import './assets/@vendor.css';
import * as he from "react";
import xe, { forwardRef as Ri, cloneElement as Gi, useState as Ye, useLayoutEffect as iu, useEffect as Ne, useRef as Ue, useImperativeHandle as Rse, createContext as lr, memo as Wt, useReducer as Jxe, isValidElement as Cd, useCallback as Cn, useMemo as cn, useContext as Hn, createElement as Pse, Component as eEe, Children as tEe, Fragment as $se, createRef as g8 } from "react";
import Kc, { createPortal as XE } from "react-dom";
import { g as Kt, c as ob, a as Mse } from "./@moment-hdGw1hqW.js";
import nEe from "yaml";
import "./assets/ic-info-filled-override.99e8094a.99e8094a.svg";
import { ReactComponent as rEe } from "./assets/ic-info-outline.29f1089c.29f1089c.svg";
import "./assets/ic-var-initial.afdaa854.afdaa854.svg";
import { Link as QE, useRouteMatch as I3, useLocation as N3, useParams as Gy, NavLink as Dse, useHistory as Yy, generatePath as Yf } from "react-router-dom";
import "./assets/ic-delete-interactive.304dd293.304dd293.svg";
import { ReactComponent as oEe } from "./assets/ic-warning.ecf7ff97.ecf7ff97.svg";
import { ReactComponent as iEe } from "./assets/ic-spray-can.955302fc.955302fc.svg";
import { ReactComponent as Ise } from "./assets/ic-tag.1613fc59.1613fc59.svg";
import { ReactComponent as sEe } from "./assets/ic-timer.b62145ec.b62145ec.svg";
import { ReactComponent as Nse } from "./assets/ic-cpu.3024be12.3024be12.svg";
import { ReactComponent as jse } from "./assets/ic-memory.c3264de1.c3264de1.svg";
import "./assets/DeployAudio.566e45df.566e45df.mp3";
import aEe, { components as Lse } from "react-select";
import { ReactComponent as lEe } from "./assets/ic-arrow-backward.d951202a.d951202a.svg";
import { ReactComponent as cEe } from "./assets/ic-docker.48906f4d.48906f4d.svg";
import { ReactComponent as Fse } from "./assets/ic-calendar.1d9c66d2.1d9c66d2.svg";
import { ReactComponent as uEe } from "./assets/ic-person.d066bc6d.d066bc6d.svg";
import { ReactComponent as Bse } from "./assets/ic-branch.8db43d66.8db43d66.svg";
import "./assets/ic-arrow-forward.a2b8ab45.a2b8ab45.svg";
import "./assets/ic-mechanical-operation.04a318d6.04a318d6.svg";
import dEe from "./assets/app-not-deployed.622dc6ba.622dc6ba.svg";
import { ReactComponent as j3 } from "./assets/ic-chevron-down.fc70d7a7.fc70d7a7.svg";
import "./assets/ic-exit-fullscreen.1ae582d1.1ae582d1.svg";
import "./assets/ic-fullscreen.b05e5087.b05e5087.svg";
import { ReactComponent as zse } from "./assets/ic-caret-down.1666c029.1666c029.svg";
import "./assets/ic-collapse-all.56740920.56740920.svg";
import "./assets/ic-expand-all.d1d223f2.d1d223f2.svg";
import "./assets/ic-arrow-out.6aea09d0.6aea09d0.svg";
import { ReactComponent as L3 } from "./assets/ic-help.39c58c34.39c58c34.svg";
import { ReactComponent as fEe } from "./assets/ic-info-filled.f870ac11.f870ac11.svg";
import "./assets/ic-stack.a6a11fe3.a6a11fe3.svg";
import { ReactComponent as hEe } from "./assets/ic-aborted.d400d0e8.d400d0e8.svg";
import { ReactComponent as pEe } from "./assets/ic-arrow-right.eda141d3.eda141d3.svg";
import { ReactComponent as qse } from "./assets/ic-environment.d241eccb.d241eccb.svg";
import { ReactComponent as mEe } from "./assets/ic-pulsate-status.2ca548fd.2ca548fd.svg";
import { ReactComponent as gEe } from "./assets/ic-close.43adc42a.43adc42a.svg";
import { ReactComponent as Use } from "./assets/ic-drag.3f71e8aa.3f71e8aa.svg";
import { ReactComponent as yEe } from "./assets/ic-lines.0a53b80a.0a53b80a.svg";
import { ReactComponent as vEe } from "./assets/ic-code-commit.161a6b3c.161a6b3c.svg";
import "./assets/ic-file-code.ed2812f3.ed2812f3.svg";
import "./assets/ic-diff-file-added.e111ba14.e111ba14.svg";
import "./assets/ic-diff-file-removed.7863a55f.7863a55f.svg";
import "./assets/ic-diff-file-updated.a8293158.a8293158.svg";
import { ReactComponent as bEe } from "./assets/ic-arrow-up-down.945ee496.945ee496.svg";
import { ReactComponent as _Ee } from "./assets/ic-sort-arrow-down.5cf54d08.5cf54d08.svg";
import { ReactComponent as wEe } from "./assets/ic-error.9d61b25b.9d61b25b.svg";
import { ReactComponent as xEe } from "./assets/ic-info-outlined.f4fa3224.f4fa3224.svg";
import "./assets/ic-expand.ab992205.ab992205.svg";
import { ReactComponent as EEe } from "./assets/ic-check.27c51fa1.27c51fa1.svg";
import "./assets/ic-check-circle-dots.296c8a3b.296c8a3b.svg";
import "./assets/ic-edit-file.aea811d8.aea811d8.svg";
import SEe from "./assets/no-artifact.fd2d84d9.fd2d84d9.webp";
import "./assets/ic-celebration.0f457baf.0f457baf.svg";
import "./assets/ic-man-on-rocket.93b070c4.93b070c4.svg";
import ib from "./assets/ic-page-not-found.3c4f114b.3c4f114b.svg";
import "./assets/ic-arrow-down.18e5e332.18e5e332.svg";
import "./assets/ic-abort.0d2773e9.0d2773e9.svg";
import "./assets/ic-check-circle.ad80d835.ad80d835.svg";
import "./assets/ic-circle.98fce2b0.98fce2b0.svg";
import "./assets/ic-commit.e3113dd9.e3113dd9.svg";
import "./assets/ic-hash.2d8669eb.2d8669eb.svg";
import "./assets/ic-message.be6dba43.be6dba43.svg";
import { ReactComponent as OEe } from "./assets/ic-pull-request.31d0c981.31d0c981.svg";
import "./assets/ic-in-progress.53ef18ae.53ef18ae.svg";
import "./assets/ic-download.c30437cd.c30437cd.svg";
import "./assets/ic-vulnerability-not-found.7d75cc30.7d75cc30.svg";
import "./assets/ic-arrows-clockwise.5990b4f7.5990b4f7.svg";
import "./assets/ic-compare.0ee3e4cf.0ee3e4cf.svg";
import { ReactComponent as CEe } from "./assets/ic-error-exclamation.c224de09.c224de09.svg";
import "./assets/ic-warning-y5.d1fb03fe.d1fb03fe.svg";
import "./assets/ic-match-case.13b7a2fa.13b7a2fa.svg";
import "./assets/ic-match-word.d92addc3.d92addc3.svg";
import { ReactComponent as kEe } from "./assets/ic-regex.e14a4ea3.e14a4ea3.svg";
import "./assets/ic-replace-all-text.a87fd342.a87fd342.svg";
import "./assets/ic-replace-text.cc5433be.cc5433be.svg";
import "./assets/ic-world.1f6a5eaf.1f6a5eaf.svg";
import "./assets/ic-clock.c21a2d14.c21a2d14.svg";
import "./assets/ic-calender-blank.963e3423.963e3423.svg";
import { ReactComponent as Hse } from "./assets/ic-cross.01e03666.01e03666.svg";
import "./assets/inject-tag.28e72db6.28e72db6.svg";
import "./assets/ic-pencil.c75a6acc.c75a6acc.svg";
import "./assets/ic-filter.8f403d6f.8f403d6f.svg";
import "./assets/ic-filter-applied.9fc48d0f.9fc48d0f.svg";
import { ReactComponent as AEe } from "./assets/ic-search.976327f1.976327f1.svg";
import { ReactComponent as TEe } from "./assets/ic-error-cross.bf21e563.bf21e563.svg";
import "./assets/ic-appstatus-cancelled.05bb3352.05bb3352.svg";
import "./assets/ic-error-medium.ea542259.ea542259.svg";
import { ReactComponent as Vse } from "./assets/ic-help-outline.9c012a0c.9c012a0c.svg";
import "./assets/empty-create.661d9355.661d9355.png";
import "./assets/ic-fullscreen-2.f138a5e8.f138a5e8.svg";
import "./assets/ic-add.cfaa779b.cfaa779b.svg";
import "./assets/ic-arrow-counter-clockwise.01cbb0e1.01cbb0e1.svg";
import "./assets/ic-minus.df865aaf.df865aaf.svg";
import "./assets/ic-enter.cab07082.cab07082.svg";
import "./assets/ic-rocket-fail.874e54ce.874e54ce.svg";
import "./assets/ic-bot.f1d4abcc.f1d4abcc.svg";
import "./assets/ic-caret-down-small.66339dda.66339dda.svg";
import "./assets/ic-shield-check.ecde083d.ecde083d.svg";
import "./assets/ic-shield-warning-outline.e6832dbc.e6832dbc.svg";
import "./assets/ic-caret-left-small.fe00c98d.fe00c98d.svg";
import "./assets/ic-scan-fallback.1e23e6fd.1e23e6fd.svg";
import { ReactComponent as REe } from "./assets/ic-success.63b86b4e.63b86b4e.svg";
import { ReactComponent as PEe } from "./assets/ic-copy.94cee0fb.94cee0fb.svg";
import { ReactComponent as $Ee } from "./assets/ic-chat-circle-dots.63f39467.63f39467.svg";
import "./assets/licenseCardBG.b507c5b0.b507c5b0.svg";
import "./assets/login-screen-ui.a33a6496.a33a6496.webp";
import "./assets/ic-book-open.7cb94ee8.7cb94ee8.svg";
import "./assets/ic-lego-block.ee4b63f1.ee4b63f1.svg";
import PD from "./assets/ic-not-authorized.cb3b5ff2.cb3b5ff2.svg";
import MEe from "./assets/ic-not-found.f5857c12.f5857c12.svg";
import DEe from "./assets/ic-loading-failure.aa68693d.aa68693d.png";
import { ReactComponent as IEe } from "./assets/ic-visibility-off.d91d3844.d91d3844.svg";
import { ReactComponent as NEe } from "./assets/ic-visibility-on.7505dd12.7505dd12.svg";
import "./assets/ic-file-text.f9563710.f9563710.svg";
import "./assets/ic-upload-arrow-animated.3db85855.3db85855.svg";
import { ReactComponent as jEe } from "./assets/ic-medium-paintbucket.45544bb9.45544bb9.svg";
import "./assets/lifebuoy.7d8fdf27.7d8fdf27.png";
import { ReactComponent as LEe } from "./assets/ic-tilde.ec1a1ea4.ec1a1ea4.svg";
import "./assets/workflow-options-modal-header.ce3c6b31.ce3c6b31.svg";
import "./assets/ic-medium-info.b59d7676.b59d7676.svg";
import "./assets/delete-medium.897114e0.897114e0.svg";
import "./assets/ic-rotate-devtron.5a8363d8.5a8363d8.svg";
import FEe from "./assets/create-backup-schedule.bbac4a86.bbac4a86.webp";
import BEe from "./assets/create-backup-snapshot.c794f612.c794f612.webp";
import { ReactComponent as zEe } from "./assets/img-celebration.8ceac2a9.8ceac2a9.svg";
import qEe from "./assets/img-code.fa00ae8e.fa00ae8e.webp";
import UEe from "./assets/img-devtron-freemium.d0657c61.d0657c61.webp";
import { ReactComponent as HEe } from "./assets/img-folder-empty.8e898c33.8e898c33.svg";
import { ReactComponent as VEe } from "./assets/img-install-freemium-saas.4388531c.4388531c.svg";
import { ReactComponent as WEe } from "./assets/img-install-via-aws-marketplace.df85f572.df85f572.svg";
import GEe from "./assets/img-man-on-rocket.ab6bef97.ab6bef97.webp";
import { ReactComponent as YEe } from "./assets/img-mechanical-operation.04a318d6.04a318d6.svg";
import { ReactComponent as KEe } from "./assets/img-no-backup-location.0e8699c5.0e8699c5.svg";
import { ReactComponent as XEe } from "./assets/img-no-restores.f26cb7db.f26cb7db.svg";
import QEe from "./assets/img-no-result.51284acb.51284acb.webp";
import { ReactComponent as ZEe } from "./assets/img-page-not-found.3c4f114b.3c4f114b.svg";
import JEe from "./assets/no-cluster-cost-enabled.038c73db.038c73db.webp";
import "./assets/ic-unordered-list.42c1cbbc.42c1cbbc.svg";
import "./assets/ic-bold.2140b7c6.2140b7c6.svg";
import "./assets/ic-checked-list.aba26c40.aba26c40.svg";
import "./assets/ic-code.1d1d4dd8.1d1d4dd8.svg";
import "./assets/ic-header.a91a9800.a91a9800.svg";
import "./assets/ic-image.2a8ed117.2a8ed117.svg";
import "./assets/ic-italic.358ca070.358ca070.svg";
import "./assets/ic-link.8453e775.8453e775.svg";
import "./assets/ic-ordered-list.879dc7c8.879dc7c8.svg";
import "./assets/ic-quote.10768489.10768489.svg";
import "./assets/ic-strikethrough.a1652ad9.a1652ad9.svg";
import { ReactComponent as eSe } from "./assets/ic-73strings.ccb245ec.ccb245ec.svg";
import { ReactComponent as tSe } from "./assets/ic-aborted.d162b12b.d162b12b.svg";
import { ReactComponent as nSe } from "./assets/ic-activity.63032a88.63032a88.svg";
import { ReactComponent as rSe } from "./assets/ic-add.4cc5a045.4cc5a045.svg";
import { ReactComponent as oSe } from "./assets/ic-ai.25e44e0c.25e44e0c.svg";
import { ReactComponent as iSe } from "./assets/ic-alibaba.518d61a4.518d61a4.svg";
import { ReactComponent as sSe } from "./assets/ic-amazon-eks.af616c23.af616c23.svg";
import { ReactComponent as aSe } from "./assets/ic-app-group.068791a2.068791a2.svg";
import { ReactComponent as lSe } from "./assets/ic-app-template.82736707.82736707.svg";
import { ReactComponent as cSe } from "./assets/ic-application.4c80bfcf.4c80bfcf.svg";
import { ReactComponent as uSe } from "./assets/ic-application-group.4b448cca.4b448cca.svg";
import { ReactComponent as dSe } from "./assets/ic-application-management.7fb9e3a0.7fb9e3a0.svg";
import { ReactComponent as fSe } from "./assets/ic-application-template.212d14f1.212d14f1.svg";
import { ReactComponent as hSe } from "./assets/ic-argocd-app.9c5eba79.9c5eba79.svg";
import { ReactComponent as pSe } from "./assets/ic-arrow-clockwise.4cb9c9ac.4cb9c9ac.svg";
import { ReactComponent as mSe } from "./assets/ic-arrow-line-down.b6a98848.b6a98848.svg";
import { ReactComponent as gSe } from "./assets/ic-arrow-right.96f4142a.96f4142a.svg";
import { ReactComponent as ySe } from "./assets/ic-arrow-square-out.c107c76c.c107c76c.svg";
import { ReactComponent as vSe } from "./assets/ic-arrows-clockwise.0f9d94ab.0f9d94ab.svg";
import { ReactComponent as bSe } from "./assets/ic-arrows-left-right.9c24874a.9c24874a.svg";
import { ReactComponent as _Se } from "./assets/ic-asterisk.d3efa9a5.d3efa9a5.svg";
import { ReactComponent as wSe } from "./assets/ic-ather.0d03ef3e.0d03ef3e.svg";
import { ReactComponent as xSe } from "./assets/ic-aws.eb2d0124.eb2d0124.svg";
import { ReactComponent as ESe } from "./assets/ic-aws-codecommit.236f850c.236f850c.svg";
import { ReactComponent as SSe } from "./assets/ic-azure.a01ce3b4.a01ce3b4.svg";
import { ReactComponent as OSe } from "./assets/ic-azure-aks.0c74ac31.0c74ac31.svg";
import { ReactComponent as CSe } from "./assets/ic-backup-and-schedule.51b7d3dd.51b7d3dd.svg";
import { ReactComponent as kSe } from "./assets/ic-backup-color.dc62e9d5.dc62e9d5.svg";
import { ReactComponent as ASe } from "./assets/ic-backup-location.ebaf1148.ebaf1148.svg";
import { ReactComponent as TSe } from "./assets/ic-backup-schedule-color.a16c34b0.a16c34b0.svg";
import { ReactComponent as RSe } from "./assets/ic-bg-backup-schedule.9ef9bc39.9ef9bc39.svg";
import { ReactComponent as PSe } from "./assets/ic-bg-backups.396e99bd.396e99bd.svg";
import { ReactComponent as $Se } from "./assets/ic-bg-build.8609d0ea.8609d0ea.svg";
import { ReactComponent as MSe } from "./assets/ic-bg-cluster.71a7ecdf.71a7ecdf.svg";
import { ReactComponent as DSe } from "./assets/ic-bg-cpu.15ec70f0.15ec70f0.svg";
import { ReactComponent as ISe } from "./assets/ic-bg-deploy.266711fe.266711fe.svg";
import { ReactComponent as NSe } from "./assets/ic-bg-environment.72d85c8c.72d85c8c.svg";
import { ReactComponent as jSe } from "./assets/ic-bg-memory.5373a125.5373a125.svg";
import { ReactComponent as LSe } from "./assets/ic-bg-pause-schedule.6edcc1d4.6edcc1d4.svg";
import { ReactComponent as FSe } from "./assets/ic-bg-production-pipelines.2951cdc0.2951cdc0.svg";
import { ReactComponent as BSe } from "./assets/ic-bg-project.84658405.84658405.svg";
import { ReactComponent as zSe } from "./assets/ic-bg-ransomware-vulnerable-cluster.1b25a5d0.1b25a5d0.svg";
import { ReactComponent as qSe } from "./assets/ic-bg-restore.4fa13869.4fa13869.svg";
import { ReactComponent as USe } from "./assets/ic-bg-scan.2249360c.2249360c.svg";
import { ReactComponent as HSe } from "./assets/ic-bg-storage-locations.894070b0.894070b0.svg";
import { ReactComponent as VSe } from "./assets/ic-bg-webhook.b455152d.b455152d.svg";
import { ReactComponent as WSe } from "./assets/ic-bharatpe.63831fdf.63831fdf.svg";
import { ReactComponent as GSe } from "./assets/ic-binoculars.c6ad42f4.c6ad42f4.svg";
import { ReactComponent as Wse } from "./assets/ic-bitbucket.ffe914a0.ffe914a0.svg";
import { ReactComponent as YSe } from "./assets/ic-book-open.9c048ee2.9c048ee2.svg";
import { ReactComponent as KSe } from "./assets/ic-bot.65f403dd.65f403dd.svg";
import { ReactComponent as XSe } from "./assets/ic-brain.1a2bb48e.1a2bb48e.svg";
import { ReactComponent as QSe } from "./assets/ic-browser.f77a9d59.f77a9d59.svg";
import { ReactComponent as ZSe } from "./assets/ic-bug.30e24a9b.30e24a9b.svg";
import { ReactComponent as JSe } from "./assets/ic-build-color.37484d39.37484d39.svg";
import { ReactComponent as eOe } from "./assets/ic-building.2405d07b.2405d07b.svg";
import { ReactComponent as tOe } from "./assets/ic-cancelled.3cd048aa.3cd048aa.svg";
import { ReactComponent as nOe } from "./assets/ic-card-stack.0de57a3a.0de57a3a.svg";
import { ReactComponent as rOe } from "./assets/ic-caret-down-small.51947d9a.51947d9a.svg";
import { ReactComponent as oOe } from "./assets/ic-caret-left.603097a8.603097a8.svg";
import { ReactComponent as iOe } from "./assets/ic-caret-right.f4dda7a7.f4dda7a7.svg";
import { ReactComponent as sOe } from "./assets/ic-cd.165ef184.165ef184.svg";
import { ReactComponent as aOe } from "./assets/ic-chart-line-up.7ab47f4e.7ab47f4e.svg";
import { ReactComponent as lOe } from "./assets/ic-chart-repo.4c12016f.4c12016f.svg";
import { ReactComponent as cOe } from "./assets/ic-chat-circle-online.cdf88c43.cdf88c43.svg";
import { ReactComponent as uOe } from "./assets/ic-check.ca1b4793.ca1b4793.svg";
import { ReactComponent as dOe } from "./assets/ic-check-all.1d8ce377.1d8ce377.svg";
import { ReactComponent as fOe } from "./assets/ic-check-circle.af18cd7e.af18cd7e.svg";
import { ReactComponent as hOe } from "./assets/ic-check-square.ba02d96e.ba02d96e.svg";
import { ReactComponent as pOe } from "./assets/ic-checks.939fbbcf.939fbbcf.svg";
import { ReactComponent as mOe } from "./assets/ic-ci-linked.b25fbb2f.b25fbb2f.svg";
import { ReactComponent as gOe } from "./assets/ic-circle-loader.9472965b.9472965b.svg";
import { ReactComponent as yOe } from "./assets/ic-circle-small.a0740b0e.a0740b0e.svg";
import { ReactComponent as vOe } from "./assets/ic-clean-brush.367a32fe.367a32fe.svg";
import { ReactComponent as bOe } from "./assets/ic-clipboard.2869fa7d.2869fa7d.svg";
import { ReactComponent as _Oe } from "./assets/ic-clock.4109c84f.4109c84f.svg";
import { ReactComponent as wOe } from "./assets/ic-clock-counterclockwise.3d7c2ef1.3d7c2ef1.svg";
import { ReactComponent as xOe } from "./assets/ic-close-large.ae3d6030.ae3d6030.svg";
import { ReactComponent as EOe } from "./assets/ic-close-small.ee9fe1c3.ee9fe1c3.svg";
import { ReactComponent as SOe } from "./assets/ic-cloud-upload.55d9c163.55d9c163.svg";
import { ReactComponent as OOe } from "./assets/ic-cloud-vms.ba70e78d.ba70e78d.svg";
import { ReactComponent as COe } from "./assets/ic-cluster.f688b9e5.f688b9e5.svg";
import { ReactComponent as kOe } from "./assets/ic-cluster-isolated.778a1ee2.778a1ee2.svg";
import { ReactComponent as AOe } from "./assets/ic-code.3af36d5c.3af36d5c.svg";
import { ReactComponent as TOe } from "./assets/ic-coins.2c15f406.2c15f406.svg";
import { ReactComponent as ROe } from "./assets/ic-coins-color-animated.fe11cdc3.fe11cdc3.svg";
import { ReactComponent as POe } from "./assets/ic-container.13005c27.13005c27.svg";
import { ReactComponent as $Oe } from "./assets/ic-container-registry.4e1e6455.4e1e6455.svg";
import { ReactComponent as MOe } from "./assets/ic-cookr.a317a655.a317a655.svg";
import { ReactComponent as DOe } from "./assets/ic-copy.c4b628de.c4b628de.svg";
import { ReactComponent as IOe } from "./assets/ic-cost-visibility.5595009f.5595009f.svg";
import { ReactComponent as NOe } from "./assets/ic-crown.24ca27fc.24ca27fc.svg";
import { ReactComponent as jOe } from "./assets/ic-cube.be637e97.be637e97.svg";
import { ReactComponent as LOe } from "./assets/ic-database-backup.b9e7c558.b9e7c558.svg";
import { ReactComponent as FOe } from "./assets/ic-delete.a6e8d3ad.a6e8d3ad.svg";
import { ReactComponent as BOe } from "./assets/ic-delete-dots.9cebdcd9.9cebdcd9.svg";
import { ReactComponent as zOe } from "./assets/ic-delete-lightning.e835c6e9.e835c6e9.svg";
import { ReactComponent as qOe } from "./assets/ic-delhivery.c4fecf0f.c4fecf0f.svg";
import { ReactComponent as UOe } from "./assets/ic-deploy-color.c7a46837.c7a46837.svg";
import { ReactComponent as HOe } from "./assets/ic-deploy-sync.9a3e3c28.9a3e3c28.svg";
import { ReactComponent as VOe } from "./assets/ic-devtron.87ead611.87ead611.svg";
import { ReactComponent as WOe } from "./assets/ic-devtron-ai.d17a01ed.d17a01ed.svg";
import { ReactComponent as GOe } from "./assets/ic-devtron-app.a8b688d3.a8b688d3.svg";
import { ReactComponent as YOe } from "./assets/ic-devtron-header-logo.e18ac7b6.e18ac7b6.svg";
import { ReactComponent as KOe } from "./assets/ic-devtron-job.a40f06cf.a40f06cf.svg";
import { ReactComponent as XOe } from "./assets/ic-devtron-text.67a413b6.67a413b6.svg";
import { ReactComponent as QOe } from "./assets/ic-diff-added.6ef6f938.6ef6f938.svg";
import { ReactComponent as ZOe } from "./assets/ic-diff-deleted.54eb24dd.54eb24dd.svg";
import { ReactComponent as JOe } from "./assets/ic-diff-updated.294b925e.294b925e.svg";
import { ReactComponent as eCe } from "./assets/ic-disconnect.bfd4ffb6.bfd4ffb6.svg";
import { ReactComponent as tCe } from "./assets/ic-discord-fill.16103b65.16103b65.svg";
import { ReactComponent as nCe } from "./assets/ic-dockerhub.03bd09a9.03bd09a9.svg";
import { ReactComponent as rCe } from "./assets/ic-download.b0685453.b0685453.svg";
import { ReactComponent as oCe } from "./assets/ic-ecr.302d6ccb.302d6ccb.svg";
import { ReactComponent as iCe } from "./assets/ic-edit.b8b75800.b8b75800.svg";
import { ReactComponent as sCe } from "./assets/ic-edit-lines.57927b07.57927b07.svg";
import { ReactComponent as aCe } from "./assets/ic-email.5c944f9a.5c944f9a.svg";
import { ReactComponent as lCe } from "./assets/ic-enter-fullscreen.ccb625cf.ccb625cf.svg";
import { ReactComponent as cCe } from "./assets/ic-enterprise-feat.259c841f.259c841f.svg";
import { ReactComponent as uCe } from "./assets/ic-enterprise-tag.345cda52.345cda52.svg";
import { ReactComponent as dCe } from "./assets/ic-env.c0634f19.c0634f19.svg";
import { ReactComponent as fCe } from "./assets/ic-environment-isolated.c80b4a45.c80b4a45.svg";
import { ReactComponent as hCe } from "./assets/ic-error.3ec5d5ef.3ec5d5ef.svg";
import { ReactComponent as pCe } from "./assets/ic-exit-fullscreen.75ef3789.75ef3789.svg";
import { ReactComponent as mCe } from "./assets/ic-expand-right-sm.dfe84ab6.dfe84ab6.svg";
import { ReactComponent as gCe } from "./assets/ic-expand-sm.e0adb3a7.e0adb3a7.svg";
import { ReactComponent as yCe } from "./assets/ic-external-link.0dd8eed7.0dd8eed7.svg";
import { ReactComponent as vCe } from "./assets/ic-failure.0220b612.0220b612.svg";
import { ReactComponent as bCe } from "./assets/ic-fast-forward.5c56ed0e.5c56ed0e.svg";
import { ReactComponent as _Ce } from "./assets/ic-file.187aaee4.187aaee4.svg";
import { ReactComponent as wCe } from "./assets/ic-file-code.96f8c5d8.96f8c5d8.svg";
import { ReactComponent as xCe } from "./assets/ic-file-download.ca57c068.ca57c068.svg";
import { ReactComponent as ECe } from "./assets/ic-file-edit.7dacd421.7dacd421.svg";
import { ReactComponent as SCe } from "./assets/ic-file-key.495ba0bb.495ba0bb.svg";
import { ReactComponent as OCe } from "./assets/ic-files.877903d3.877903d3.svg";
import { ReactComponent as CCe } from "./assets/ic-files-changed.04e6de3f.04e6de3f.svg";
import { ReactComponent as kCe } from "./assets/ic-filter.eaefc78a.eaefc78a.svg";
import { ReactComponent as ACe } from "./assets/ic-filter-applied.6541e03d.6541e03d.svg";
import { ReactComponent as TCe } from "./assets/ic-flask.962df7dd.962df7dd.svg";
import { ReactComponent as RCe } from "./assets/ic-floppy-disk.6d392bcd.6d392bcd.svg";
import { ReactComponent as PCe } from "./assets/ic-fluxcd-app.7bf7dce5.7bf7dce5.svg";
import { ReactComponent as $Ce } from "./assets/ic-folder.d5a0e01e.d5a0e01e.svg";
import { ReactComponent as MCe } from "./assets/ic-folder-color.88ee985f.88ee985f.svg";
import { ReactComponent as DCe } from "./assets/ic-folder-user.50e60be1.50e60be1.svg";
import { ReactComponent as ICe } from "./assets/ic-gavel.1799f199.1799f199.svg";
import { ReactComponent as NCe } from "./assets/ic-gear.7116a8bf.7116a8bf.svg";
import { ReactComponent as jCe } from "./assets/ic-gift.8ea07edc.8ea07edc.svg";
import { ReactComponent as LCe } from "./assets/ic-gift-animated.9ca6ccb4.9ca6ccb4.svg";
import { ReactComponent as FCe } from "./assets/ic-gift-gradient.581b1ac5.581b1ac5.svg";
import { ReactComponent as BCe } from "./assets/ic-git.bb72e063.bb72e063.svg";
import { ReactComponent as zCe } from "./assets/ic-git-branch.7be08881.7be08881.svg";
import { ReactComponent as qCe } from "./assets/ic-github.b6e9d0f3.b6e9d0f3.svg";
import { ReactComponent as UCe } from "./assets/ic-gitlab.ac331d67.ac331d67.svg";
import { ReactComponent as HCe } from "./assets/ic-global-overview.56ba9dc0.56ba9dc0.svg";
import { ReactComponent as VCe } from "./assets/ic-google.475640a4.475640a4.svg";
import { ReactComponent as WCe } from "./assets/ic-google-artifact-registry.2a167c8b.2a167c8b.svg";
import { ReactComponent as GCe } from "./assets/ic-google-cloud.3077a8dd.3077a8dd.svg";
import { ReactComponent as YCe } from "./assets/ic-google-container-registry.320c53ee.320c53ee.svg";
import { ReactComponent as KCe } from "./assets/ic-google-gke.a28779b8.a28779b8.svg";
import { ReactComponent as XCe } from "./assets/ic-grid-view.13207b99.13207b99.svg";
import { ReactComponent as QCe } from "./assets/ic-group-filter.ed1869f5.ed1869f5.svg";
import { ReactComponent as ZCe } from "./assets/ic-group-filter-applied.2cdb11e7.2cdb11e7.svg";
import { ReactComponent as JCe } from "./assets/ic-hand-pointing.f0ed4e78.f0ed4e78.svg";
import { ReactComponent as eke } from "./assets/ic-heart-green.6d3bb9cf.6d3bb9cf.svg";
import { ReactComponent as tke } from "./assets/ic-heart-red.ae773db3.ae773db3.svg";
import { ReactComponent as nke } from "./assets/ic-heart-red-animated.62caae80.62caae80.svg";
import { ReactComponent as rke } from "./assets/ic-helm.20583d75.20583d75.svg";
import { ReactComponent as oke } from "./assets/ic-helm-app.089be06f.089be06f.svg";
import { ReactComponent as ike } from "./assets/ic-help-filled.b7ae284e.b7ae284e.svg";
import { ReactComponent as ske } from "./assets/ic-help-outline.4b30e33c.4b30e33c.svg";
import { ReactComponent as ake } from "./assets/ic-hibernate.263ffcea.263ffcea.svg";
import { ReactComponent as lke } from "./assets/ic-hibernate-circle.8a400518.8a400518.svg";
import { ReactComponent as cke } from "./assets/ic-in-progress.73f9ca1e.73f9ca1e.svg";
import { ReactComponent as uke } from "./assets/ic-info-filled.763be331.763be331.svg";
import { ReactComponent as dke } from "./assets/ic-info-filled-color.7b8b860f.7b8b860f.svg";
import { ReactComponent as fke } from "./assets/ic-info-outline.d29630b4.d29630b4.svg";
import { ReactComponent as hke } from "./assets/ic-infrastructure-management.4b052d41.4b052d41.svg";
import { ReactComponent as pke } from "./assets/ic-input.57281408.57281408.svg";
import { ReactComponent as mke } from "./assets/ic-install.631b7b46.631b7b46.svg";
import { ReactComponent as gke } from "./assets/ic-job-color.bb826301.bb826301.svg";
import { ReactComponent as yke } from "./assets/ic-k3s.310882f4.310882f4.svg";
import { ReactComponent as vke } from "./assets/ic-k8s-job.c4f9ccc7.c4f9ccc7.svg";
import { ReactComponent as bke } from "./assets/ic-key.56432553.56432553.svg";
import { ReactComponent as _ke } from "./assets/ic-key-enter.1bcea42a.1bcea42a.svg";
import { ReactComponent as wke } from "./assets/ic-kind.5d844446.5d844446.svg";
import { ReactComponent as xke } from "./assets/ic-kubernetes.7e04c3d2.7e04c3d2.svg";
import { ReactComponent as Eke } from "./assets/ic-laptop.06834890.06834890.svg";
import { ReactComponent as Ske } from "./assets/ic-ldap.0c5633d9.0c5633d9.svg";
import { ReactComponent as Oke } from "./assets/ic-lego.ae684d25.ae684d25.svg";
import { ReactComponent as Cke } from "./assets/ic-lightning.f4ff5588.f4ff5588.svg";
import { ReactComponent as kke } from "./assets/ic-lightning-fill.83a792be.83a792be.svg";
import { ReactComponent as Ake } from "./assets/ic-link.8b276915.8b276915.svg";
import { ReactComponent as Tke } from "./assets/ic-linked-build-color.3833bda8.3833bda8.svg";
import { ReactComponent as Rke } from "./assets/ic-list-bullets.f055aa03.f055aa03.svg";
import { ReactComponent as Pke } from "./assets/ic-livspace.9f369ef7.9f369ef7.svg";
import { ReactComponent as $ke } from "./assets/ic-locked.dd40e181.dd40e181.svg";
import { ReactComponent as Mke } from "./assets/ic-logout.f0a8b488.f0a8b488.svg";
import { ReactComponent as Dke } from "./assets/ic-logs.84f66850.84f66850.svg";
import { ReactComponent as Ike } from "./assets/ic-magic-wand.2c29cd4e.2c29cd4e.svg";
import { ReactComponent as Nke } from "./assets/ic-magnifying-glass.b8c4da8f.b8c4da8f.svg";
import { ReactComponent as jke } from "./assets/ic-medium-delete.8386c77e.8386c77e.svg";
import { ReactComponent as Lke } from "./assets/ic-megaphone-left.ad5e7cbf.ad5e7cbf.svg";
import { ReactComponent as Fke } from "./assets/ic-megaphone-right.0f7ef63f.0f7ef63f.svg";
import { ReactComponent as Bke } from "./assets/ic-microsoft.7c7bcaeb.7c7bcaeb.svg";
import { ReactComponent as zke } from "./assets/ic-minikube.33d6538a.33d6538a.svg";
import { ReactComponent as qke } from "./assets/ic-minus.65e341f4.65e341f4.svg";
import { ReactComponent as Uke } from "./assets/ic-missing.917a1291.917a1291.svg";
import { ReactComponent as Hke } from "./assets/ic-mobile.eabc9181.eabc9181.svg";
import { ReactComponent as Vke } from "./assets/ic-monitoring.30910a3c.30910a3c.svg";
import { ReactComponent as Wke } from "./assets/ic-more-vertical.18109fc1.18109fc1.svg";
import { ReactComponent as Gke } from "./assets/ic-namespace.8a09efbb.8a09efbb.svg";
import { ReactComponent as Yke } from "./assets/ic-new.1907a03f.1907a03f.svg";
import { ReactComponent as Kke } from "./assets/ic-node-script.88af3604.88af3604.svg";
import { ReactComponent as Xke } from "./assets/ic-oidc.5e06656d.5e06656d.svg";
import { ReactComponent as Qke } from "./assets/ic-open-box.b15fcbbd.b15fcbbd.svg";
import { ReactComponent as Zke } from "./assets/ic-open-in-new.6aea09d0.6aea09d0.svg";
import { ReactComponent as Jke } from "./assets/ic-openai.030b0cc2.030b0cc2.svg";
import { ReactComponent as e2e } from "./assets/ic-openshift.3886b54f.3886b54f.svg";
import { ReactComponent as t2e } from "./assets/ic-oracle-cloud.5a8ee45d.5a8ee45d.svg";
import { ReactComponent as n2e } from "./assets/ic-otc-cloud.43b31bd8.43b31bd8.svg";
import { ReactComponent as r2e } from "./assets/ic-out-of-sync.824fb5c6.824fb5c6.svg";
import { ReactComponent as o2e } from "./assets/ic-paper-plane.bf63ba1c.bf63ba1c.svg";
import { ReactComponent as i2e } from "./assets/ic-paper-plane-color.b290f604.b290f604.svg";
import { ReactComponent as s2e } from "./assets/ic-party.cfc7e7c6.cfc7e7c6.svg";
import { ReactComponent as a2e } from "./assets/ic-path.d562ddbf.d562ddbf.svg";
import { ReactComponent as l2e } from "./assets/ic-pause.4e5c6056.4e5c6056.svg";
import { ReactComponent as c2e } from "./assets/ic-pause-circle.d9dc254f.d9dc254f.svg";
import { ReactComponent as u2e } from "./assets/ic-pencil.39510f9f.39510f9f.svg";
import { ReactComponent as d2e } from "./assets/ic-play-outline.d2551031.d2551031.svg";
import { ReactComponent as f2e } from "./assets/ic-priority-medium-fill.7bab0ff8.7bab0ff8.svg";
import { ReactComponent as h2e } from "./assets/ic-quay.d622b34f.d622b34f.svg";
import { ReactComponent as p2e } from "./assets/ic-quote.89f42bae.89f42bae.svg";
import { ReactComponent as m2e } from "./assets/ic-ratings.a1d31244.a1d31244.svg";
import { ReactComponent as g2e } from "./assets/ic-release-hub.25b9707a.25b9707a.svg";
import { ReactComponent as y2e } from "./assets/ic-resize-handle.f999b998.f999b998.svg";
import { ReactComponent as v2e } from "./assets/ic-resource-browser.4ff3e571.4ff3e571.svg";
import { ReactComponent as b2e } from "./assets/ic-resource-watcher.7cce5305.7cce5305.svg";
import { ReactComponent as _2e } from "./assets/ic-right-panel-collapse.0ecf8ceb.0ecf8ceb.svg";
import { ReactComponent as w2e } from "./assets/ic-rocket-gear.b4f582da.b4f582da.svg";
import { ReactComponent as x2e } from "./assets/ic-rocket-launch.5df99bf3.5df99bf3.svg";
import { ReactComponent as E2e } from "./assets/ic-security-fixable.168b5bf8.168b5bf8.svg";
import { ReactComponent as S2e } from "./assets/ic-security-not-fixable.be099f65.be099f65.svg";
import { ReactComponent as O2e } from "./assets/ic-security-policy.874568da.874568da.svg";
import { ReactComponent as C2e } from "./assets/ic-security-scan.3ae78d50.3ae78d50.svg";
import { ReactComponent as k2e } from "./assets/ic-security-vulnerability.c954b87a.c954b87a.svg";
import { ReactComponent as A2e } from "./assets/ic-selected.3a29e244.3a29e244.svg";
import { ReactComponent as T2e } from "./assets/ic-shapes.77fbbb93.77fbbb93.svg";
import { ReactComponent as R2e } from "./assets/ic-shield-check.c26854d2.c26854d2.svg";
import { ReactComponent as P2e } from "./assets/ic-sliders-vertical.7211dc4f.7211dc4f.svg";
import { ReactComponent as $2e } from "./assets/ic-software-release-management.dceedf80.dceedf80.svg";
import { ReactComponent as M2e } from "./assets/ic-sort-ascending.8a25e19d.8a25e19d.svg";
import { ReactComponent as D2e } from "./assets/ic-sort-descending.c5846635.c5846635.svg";
import { ReactComponent as I2e } from "./assets/ic-sortable.117b8f83.117b8f83.svg";
import { ReactComponent as N2e } from "./assets/ic-sparkle-ai-color.b67e98ce.b67e98ce.svg";
import { ReactComponent as j2e } from "./assets/ic-sparkle-color.39f6b618.39f6b618.svg";
import { ReactComponent as L2e } from "./assets/ic-speedometer.495c2d1c.495c2d1c.svg";
import { ReactComponent as F2e } from "./assets/ic-spinny.945235a0.945235a0.svg";
import { ReactComponent as B2e } from "./assets/ic-spray-can.199c0450.199c0450.svg";
import { ReactComponent as z2e } from "./assets/ic-stack.fbd3aea5.fbd3aea5.svg";
import { ReactComponent as q2e } from "./assets/ic-stamp.a3d8dea0.a3d8dea0.svg";
import { ReactComponent as U2e } from "./assets/ic-stop-fill.b6641c8b.b6641c8b.svg";
import { ReactComponent as H2e } from "./assets/ic-storage.03f282b6.03f282b6.svg";
import { ReactComponent as V2e } from "./assets/ic-strategy-blue-green.8d61b66d.8d61b66d.svg";
import { ReactComponent as W2e } from "./assets/ic-strategy-blue-green-color.baaf7071.baaf7071.svg";
import { ReactComponent as G2e } from "./assets/ic-strategy-canary.b6d42fbb.b6d42fbb.svg";
import { ReactComponent as Y2e } from "./assets/ic-strategy-canary-color.3241aea9.3241aea9.svg";
import { ReactComponent as K2e } from "./assets/ic-strategy-recreate.3aa96ce0.3aa96ce0.svg";
import { ReactComponent as X2e } from "./assets/ic-strategy-recreate-color.f62bd5ed.f62bd5ed.svg";
import { ReactComponent as Q2e } from "./assets/ic-strategy-rolling.3b901bf5.3b901bf5.svg";
import { ReactComponent as Z2e } from "./assets/ic-strategy-rolling-color.945b909a.945b909a.svg";
import { ReactComponent as J2e } from "./assets/ic-success.bcd5b258.bcd5b258.svg";
import { ReactComponent as eAe } from "./assets/ic-success-blue.7b3a2720.7b3a2720.svg";
import { ReactComponent as tAe } from "./assets/ic-sun.9fe1dd26.9fe1dd26.svg";
import { ReactComponent as nAe } from "./assets/ic-suspended.8a62c6bc.8a62c6bc.svg";
import { ReactComponent as rAe } from "./assets/ic-symbol-greater-than.8f71342d.8f71342d.svg";
import { ReactComponent as oAe } from "./assets/ic-tag.5fdc7834.5fdc7834.svg";
import { ReactComponent as iAe } from "./assets/ic-tata1mg.a631cafa.a631cafa.svg";
import { ReactComponent as sAe } from "./assets/ic-tenants.4f997b9a.4f997b9a.svg";
import { ReactComponent as aAe } from "./assets/ic-terminal.628344b9.628344b9.svg";
import { ReactComponent as lAe } from "./assets/ic-terminal-fill.4bd66669.4bd66669.svg";
import { ReactComponent as cAe } from "./assets/ic-thermometer.95af4a4b.95af4a4b.svg";
import { ReactComponent as uAe } from "./assets/ic-thumb-down.1834436f.1834436f.svg";
import { ReactComponent as dAe } from "./assets/ic-thumb-up.976f6efb.976f6efb.svg";
import { ReactComponent as fAe } from "./assets/ic-timeout-dash.d8e2d62e.d8e2d62e.svg";
import { ReactComponent as hAe } from "./assets/ic-timer.ae5f10fa.ae5f10fa.svg";
import { ReactComponent as pAe } from "./assets/ic-traffic-signal.cc68c2e5.cc68c2e5.svg";
import { ReactComponent as mAe } from "./assets/ic-travclan.86f22c7d.86f22c7d.svg";
import { ReactComponent as gAe } from "./assets/ic-trend-up.5752ef30.5752ef30.svg";
import { ReactComponent as yAe } from "./assets/ic-two-cubes.a775b635.a775b635.svg";
import { ReactComponent as vAe } from "./assets/ic-ubuntu.540c22c9.540c22c9.svg";
import { ReactComponent as bAe } from "./assets/ic-unknown.89dc351a.89dc351a.svg";
import { ReactComponent as _Ae } from "./assets/ic-upgrade-enterprise.49cbd888.49cbd888.svg";
import { ReactComponent as wAe } from "./assets/ic-user-circle.a2143a4a.a2143a4a.svg";
import { ReactComponent as xAe } from "./assets/ic-user-key.5dc44524.5dc44524.svg";
import { ReactComponent as EAe } from "./assets/ic-users.33cb397f.33cb397f.svg";
import { ReactComponent as SAe } from "./assets/ic-view-variable-toggle.93c3599f.93c3599f.svg";
import { ReactComponent as OAe } from "./assets/ic-warning.414e37e3.414e37e3.svg";
import { ReactComponent as CAe } from "./assets/ic-warning-fill.bfea8b38.bfea8b38.svg";
import { ReactComponent as kAe } from "./assets/ic-warning-stroke.fc850a4a.fc850a4a.svg";
import { ReactComponent as AAe } from "./assets/ic-webhook.ffd8ded6.ffd8ded6.svg";
import { ReactComponent as TAe } from "./assets/ic-wifi-slash.4bd4fb85.4bd4fb85.svg";
import { ReactComponent as RAe } from "./assets/ic-world-globe.c16eb8c2.c16eb8c2.svg";
import { ReactComponent as PAe } from "./assets/ic-webhook.d4431b07.d4431b07.svg";
import { ReactComponent as $Ae } from "./assets/ic-aws-codecommit.43f0dd23.43f0dd23.svg";
import { ReactComponent as MAe } from "./assets/ic-git.89f79adf.89f79adf.svg";
import { ReactComponent as DAe } from "./assets/ic-github.9d82ed09.9d82ed09.svg";
import { ReactComponent as IAe } from "./assets/ic-gitlab.de184b7f.de184b7f.svg";
import "./assets/ic-medium-clean-brush.f683d4d6.f683d4d6.svg";
import "./assets/ic-medium-pause.7449078a.7449078a.svg";
import "./assets/ic-medium-play.f7a8ddb7.f7a8ddb7.svg";
import { ReactComponent as NAe } from "./assets/ic-locked.dab69058.dab69058.svg";
var sb = { exports: {} }, hf = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var lC, y8;
function F3() {
  if (y8) return lC;
  y8 = 1;
  var t = Object.getOwnPropertySymbols, e = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(i) {
    if (i == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(i);
  }
  function o() {
    try {
      if (!Object.assign)
        return !1;
      var i = new String("abc");
      if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5")
        return !1;
      for (var s = {}, a = 0; a < 10; a++)
        s["_" + String.fromCharCode(a)] = a;
      var l = Object.getOwnPropertyNames(s).map(function(u) {
        return s[u];
      });
      if (l.join("") !== "0123456789")
        return !1;
      var c = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(u) {
        c[u] = u;
      }), Object.keys(Object.assign({}, c)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return lC = o() ? Object.assign : function(i, s) {
    for (var a, l = r(i), c, u = 1; u < arguments.length; u++) {
      a = Object(arguments[u]);
      for (var d in a)
        e.call(a, d) && (l[d] = a[d]);
      if (t) {
        c = t(a);
        for (var f = 0; f < c.length; f++)
          n.call(a, c[f]) && (l[c[f]] = a[c[f]]);
      }
    }
    return l;
  }, lC;
}
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var v8;
function jAe() {
  if (v8) return hf;
  v8 = 1, F3();
  var t = xe, e = 60103;
  if (hf.Fragment = 60107, typeof Symbol == "function" && Symbol.for) {
    var n = Symbol.for;
    e = n("react.element"), hf.Fragment = n("react.fragment");
  }
  var r = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = Object.prototype.hasOwnProperty, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(a, l, c) {
    var u, d = {}, f = null, h = null;
    c !== void 0 && (f = "" + c), l.key !== void 0 && (f = "" + l.key), l.ref !== void 0 && (h = l.ref);
    for (u in l) o.call(l, u) && !i.hasOwnProperty(u) && (d[u] = l[u]);
    if (a && a.defaultProps) for (u in l = a.defaultProps, l) d[u] === void 0 && (d[u] = l[u]);
    return { $$typeof: e, type: a, key: f, ref: h, props: d, _owner: r.current };
  }
  return hf.jsx = s, hf.jsxs = s, hf;
}
var cC = {};
/** @license React v17.0.2
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b8;
function LAe() {
  return b8 || (b8 = 1, function(t) {
    process.env.NODE_ENV !== "production" && function() {
      var e = xe, n = F3(), r = 60103, o = 60106;
      t.Fragment = 60107;
      var i = 60108, s = 60114, a = 60109, l = 60110, c = 60112, u = 60113, d = 60120, f = 60115, h = 60116, p = 60121, m = 60122, g = 60117, y = 60129, v = 60131;
      if (typeof Symbol == "function" && Symbol.for) {
        var b = Symbol.for;
        r = b("react.element"), o = b("react.portal"), t.Fragment = b("react.fragment"), i = b("react.strict_mode"), s = b("react.profiler"), a = b("react.provider"), l = b("react.context"), c = b("react.forward_ref"), u = b("react.suspense"), d = b("react.suspense_list"), f = b("react.memo"), h = b("react.lazy"), p = b("react.block"), m = b("react.server.block"), g = b("react.fundamental"), b("react.scope"), b("react.opaque.id"), y = b("react.debug_trace_mode"), b("react.offscreen"), v = b("react.legacy_hidden");
      }
      var _ = typeof Symbol == "function" && Symbol.iterator, w = "@@iterator";
      function x(J) {
        if (J === null || typeof J != "object")
          return null;
        var ie = _ && J[_] || J[w];
        return typeof ie == "function" ? ie : null;
      }
      var E = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function S(J) {
        {
          for (var ie = arguments.length, me = new Array(ie > 1 ? ie - 1 : 0), be = 1; be < ie; be++)
            me[be - 1] = arguments[be];
          C("error", J, me);
        }
      }
      function C(J, ie, me) {
        {
          var be = E.ReactDebugCurrentFrame, tt = be.getStackAddendum();
          tt !== "" && (ie += "%s", me = me.concat([tt]));
          var Ke = me.map(function(Fe) {
            return "" + Fe;
          });
          Ke.unshift("Warning: " + ie), Function.prototype.apply.call(console[J], console, Ke);
        }
      }
      var R = !1;
      function P(J) {
        return !!(typeof J == "string" || typeof J == "function" || J === t.Fragment || J === s || J === y || J === i || J === u || J === d || J === v || R || typeof J == "object" && J !== null && (J.$$typeof === h || J.$$typeof === f || J.$$typeof === a || J.$$typeof === l || J.$$typeof === c || J.$$typeof === g || J.$$typeof === p || J[0] === m));
      }
      function N(J, ie, me) {
        var be = ie.displayName || ie.name || "";
        return J.displayName || (be !== "" ? me + "(" + be + ")" : me);
      }
      function A(J) {
        return J.displayName || "Context";
      }
      function O(J) {
        if (J == null)
          return null;
        if (typeof J.tag == "number" && S("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue."), typeof J == "function")
          return J.displayName || J.name || null;
        if (typeof J == "string")
          return J;
        switch (J) {
          case t.Fragment:
            return "Fragment";
          case o:
            return "Portal";
          case s:
            return "Profiler";
          case i:
            return "StrictMode";
          case u:
            return "Suspense";
          case d:
            return "SuspenseList";
        }
        if (typeof J == "object")
          switch (J.$$typeof) {
            case l:
              var ie = J;
              return A(ie) + ".Consumer";
            case a:
              var me = J;
              return A(me._context) + ".Provider";
            case c:
              return N(J, J.render, "ForwardRef");
            case f:
              return O(J.type);
            case p:
              return O(J._render);
            case h: {
              var be = J, tt = be._payload, Ke = be._init;
              try {
                return O(Ke(tt));
              } catch {
                return null;
              }
            }
          }
        return null;
      }
      var k = 0, T, I, j, z, $, D, U;
      function q() {
      }
      q.__reactDisabledLog = !0;
      function F() {
        {
          if (k === 0) {
            T = console.log, I = console.info, j = console.warn, z = console.error, $ = console.group, D = console.groupCollapsed, U = console.groupEnd;
            var J = {
              configurable: !0,
              enumerable: !0,
              value: q,
              writable: !0
            };
            Object.defineProperties(console, {
              info: J,
              log: J,
              warn: J,
              error: J,
              group: J,
              groupCollapsed: J,
              groupEnd: J
            });
          }
          k++;
        }
      }
      function B() {
        {
          if (k--, k === 0) {
            var J = {
              configurable: !0,
              enumerable: !0,
              writable: !0
            };
            Object.defineProperties(console, {
              log: n({}, J, {
                value: T
              }),
              info: n({}, J, {
                value: I
              }),
              warn: n({}, J, {
                value: j
              }),
              error: n({}, J, {
                value: z
              }),
              group: n({}, J, {
                value: $
              }),
              groupCollapsed: n({}, J, {
                value: D
              }),
              groupEnd: n({}, J, {
                value: U
              })
            });
          }
          k < 0 && S("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
        }
      }
      var H = E.ReactCurrentDispatcher, Z;
      function W(J, ie, me) {
        {
          if (Z === void 0)
            try {
              throw Error();
            } catch (tt) {
              var be = tt.stack.trim().match(/\n( *(at )?)/);
              Z = be && be[1] || "";
            }
          return `
` + Z + J;
        }
      }
      var G = !1, ee;
      {
        var Y = typeof WeakMap == "function" ? WeakMap : Map;
        ee = new Y();
      }
      function L(J, ie) {
        if (!J || G)
          return "";
        {
          var me = ee.get(J);
          if (me !== void 0)
            return me;
        }
        var be;
        G = !0;
        var tt = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var Ke;
        Ke = H.current, H.current = null, F();
        try {
          if (ie) {
            var Fe = function() {
              throw Error();
            };
            if (Object.defineProperty(Fe.prototype, "props", {
              set: function() {
                throw Error();
              }
            }), typeof Reflect == "object" && Reflect.construct) {
              try {
                Reflect.construct(Fe, []);
              } catch (Qe) {
                be = Qe;
              }
              Reflect.construct(J, [], Fe);
            } else {
              try {
                Fe.call();
              } catch (Qe) {
                be = Qe;
              }
              J.call(Fe.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (Qe) {
              be = Qe;
            }
            J();
          }
        } catch (Qe) {
          if (Qe && be && typeof Qe.stack == "string") {
            for (var We = Qe.stack.split(`
`), Xe = be.stack.split(`
`), at = We.length - 1, bt = Xe.length - 1; at >= 1 && bt >= 0 && We[at] !== Xe[bt]; )
              bt--;
            for (; at >= 1 && bt >= 0; at--, bt--)
              if (We[at] !== Xe[bt]) {
                if (at !== 1 || bt !== 1)
                  do
                    if (at--, bt--, bt < 0 || We[at] !== Xe[bt]) {
                      var Lt = `
` + We[at].replace(" at new ", " at ");
                      return typeof J == "function" && ee.set(J, Lt), Lt;
                    }
                  while (at >= 1 && bt >= 0);
                break;
              }
          }
        } finally {
          G = !1, H.current = Ke, B(), Error.prepareStackTrace = tt;
        }
        var bn = J ? J.displayName || J.name : "", un = bn ? W(bn) : "";
        return typeof J == "function" && ee.set(J, un), un;
      }
      function V(J, ie, me) {
        return L(J, !1);
      }
      function K(J) {
        var ie = J.prototype;
        return !!(ie && ie.isReactComponent);
      }
      function ne(J, ie, me) {
        if (J == null)
          return "";
        if (typeof J == "function")
          return L(J, K(J));
        if (typeof J == "string")
          return W(J);
        switch (J) {
          case u:
            return W("Suspense");
          case d:
            return W("SuspenseList");
        }
        if (typeof J == "object")
          switch (J.$$typeof) {
            case c:
              return V(J.render);
            case f:
              return ne(J.type, ie, me);
            case p:
              return V(J._render);
            case h: {
              var be = J, tt = be._payload, Ke = be._init;
              try {
                return ne(Ke(tt), ie, me);
              } catch {
              }
            }
          }
        return "";
      }
      var ce = {}, fe = E.ReactDebugCurrentFrame;
      function ve(J) {
        if (J) {
          var ie = J._owner, me = ne(J.type, J._source, ie ? ie.type : null);
          fe.setExtraStackFrame(me);
        } else
          fe.setExtraStackFrame(null);
      }
      function _e(J, ie, me, be, tt) {
        {
          var Ke = Function.call.bind(Object.prototype.hasOwnProperty);
          for (var Fe in J)
            if (Ke(J, Fe)) {
              var We = void 0;
              try {
                if (typeof J[Fe] != "function") {
                  var Xe = Error((be || "React class") + ": " + me + " type `" + Fe + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof J[Fe] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw Xe.name = "Invariant Violation", Xe;
                }
                We = J[Fe](ie, Fe, be, me, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (at) {
                We = at;
              }
              We && !(We instanceof Error) && (ve(tt), S("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", be || "React class", me, Fe, typeof We), ve(null)), We instanceof Error && !(We.message in ce) && (ce[We.message] = !0, ve(tt), S("Failed %s type: %s", me, We.message), ve(null));
            }
        }
      }
      var Ee = E.ReactCurrentOwner, Me = Object.prototype.hasOwnProperty, Le = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      }, Ce, Je, Ie;
      Ie = {};
      function nt(J) {
        if (Me.call(J, "ref")) {
          var ie = Object.getOwnPropertyDescriptor(J, "ref").get;
          if (ie && ie.isReactWarning)
            return !1;
        }
        return J.ref !== void 0;
      }
      function ct(J) {
        if (Me.call(J, "key")) {
          var ie = Object.getOwnPropertyDescriptor(J, "key").get;
          if (ie && ie.isReactWarning)
            return !1;
        }
        return J.key !== void 0;
      }
      function mt(J, ie) {
        if (typeof J.ref == "string" && Ee.current && ie && Ee.current.stateNode !== ie) {
          var me = O(Ee.current.type);
          Ie[me] || (S('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', O(Ee.current.type), J.ref), Ie[me] = !0);
        }
      }
      function gt(J, ie) {
        {
          var me = function() {
            Ce || (Ce = !0, S("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", ie));
          };
          me.isReactWarning = !0, Object.defineProperty(J, "key", {
            get: me,
            configurable: !0
          });
        }
      }
      function Et(J, ie) {
        {
          var me = function() {
            Je || (Je = !0, S("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", ie));
          };
          me.isReactWarning = !0, Object.defineProperty(J, "ref", {
            get: me,
            configurable: !0
          });
        }
      }
      var Rt = function(J, ie, me, be, tt, Ke, Fe) {
        var We = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: r,
          // Built-in properties that belong on the element
          type: J,
          key: ie,
          ref: me,
          props: Fe,
          // Record the component responsible for creating this element.
          _owner: Ke
        };
        return We._store = {}, Object.defineProperty(We._store, "validated", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: !1
        }), Object.defineProperty(We, "_self", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: be
        }), Object.defineProperty(We, "_source", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: tt
        }), Object.freeze && (Object.freeze(We.props), Object.freeze(We)), We;
      };
      function zt(J, ie, me, be, tt) {
        {
          var Ke, Fe = {}, We = null, Xe = null;
          me !== void 0 && (We = "" + me), ct(ie) && (We = "" + ie.key), nt(ie) && (Xe = ie.ref, mt(ie, tt));
          for (Ke in ie)
            Me.call(ie, Ke) && !Le.hasOwnProperty(Ke) && (Fe[Ke] = ie[Ke]);
          if (J && J.defaultProps) {
            var at = J.defaultProps;
            for (Ke in at)
              Fe[Ke] === void 0 && (Fe[Ke] = at[Ke]);
          }
          if (We || Xe) {
            var bt = typeof J == "function" ? J.displayName || J.name || "Unknown" : J;
            We && gt(Fe, bt), Xe && Et(Fe, bt);
          }
          return Rt(J, We, Xe, tt, be, Ee.current, Fe);
        }
      }
      var At = E.ReactCurrentOwner, X = E.ReactDebugCurrentFrame;
      function ae(J) {
        if (J) {
          var ie = J._owner, me = ne(J.type, J._source, ie ? ie.type : null);
          X.setExtraStackFrame(me);
        } else
          X.setExtraStackFrame(null);
      }
      var ye;
      ye = !1;
      function De(J) {
        return typeof J == "object" && J !== null && J.$$typeof === r;
      }
      function Te() {
        {
          if (At.current) {
            var J = O(At.current.type);
            if (J)
              return `

Check the render method of \`` + J + "`.";
          }
          return "";
        }
      }
      function st(J) {
        return "";
      }
      var ft = {};
      function Ht(J) {
        {
          var ie = Te();
          if (!ie) {
            var me = typeof J == "string" ? J : J.displayName || J.name;
            me && (ie = `

Check the top-level render call using <` + me + ">.");
          }
          return ie;
        }
      }
      function nn(J, ie) {
        {
          if (!J._store || J._store.validated || J.key != null)
            return;
          J._store.validated = !0;
          var me = Ht(ie);
          if (ft[me])
            return;
          ft[me] = !0;
          var be = "";
          J && J._owner && J._owner !== At.current && (be = " It was passed a child from " + O(J._owner.type) + "."), ae(J), S('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', me, be), ae(null);
        }
      }
      function It(J, ie) {
        {
          if (typeof J != "object")
            return;
          if (Array.isArray(J))
            for (var me = 0; me < J.length; me++) {
              var be = J[me];
              De(be) && nn(be, ie);
            }
          else if (De(J))
            J._store && (J._store.validated = !0);
          else if (J) {
            var tt = x(J);
            if (typeof tt == "function" && tt !== J.entries)
              for (var Ke = tt.call(J), Fe; !(Fe = Ke.next()).done; )
                De(Fe.value) && nn(Fe.value, ie);
          }
        }
      }
      function Rn(J) {
        {
          var ie = J.type;
          if (ie == null || typeof ie == "string")
            return;
          var me;
          if (typeof ie == "function")
            me = ie.propTypes;
          else if (typeof ie == "object" && (ie.$$typeof === c || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          ie.$$typeof === f))
            me = ie.propTypes;
          else
            return;
          if (me) {
            var be = O(ie);
            _e(me, J.props, "prop", be, J);
          } else if (ie.PropTypes !== void 0 && !ye) {
            ye = !0;
            var tt = O(ie);
            S("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", tt || "Unknown");
          }
          typeof ie.getDefaultProps == "function" && !ie.getDefaultProps.isReactClassApproved && S("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
        }
      }
      function yt(J) {
        {
          for (var ie = Object.keys(J.props), me = 0; me < ie.length; me++) {
            var be = ie[me];
            if (be !== "children" && be !== "key") {
              ae(J), S("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", be), ae(null);
              break;
            }
          }
          J.ref !== null && (ae(J), S("Invalid attribute `ref` supplied to `React.Fragment`."), ae(null));
        }
      }
      function oe(J, ie, me, be, tt, Ke) {
        {
          var Fe = P(J);
          if (!Fe) {
            var We = "";
            (J === void 0 || typeof J == "object" && J !== null && Object.keys(J).length === 0) && (We += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
            var Xe = st();
            Xe ? We += Xe : We += Te();
            var at;
            J === null ? at = "null" : Array.isArray(J) ? at = "array" : J !== void 0 && J.$$typeof === r ? (at = "<" + (O(J.type) || "Unknown") + " />", We = " Did you accidentally export a JSX literal instead of a component?") : at = typeof J, S("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", at, We);
          }
          var bt = zt(J, ie, me, tt, Ke);
          if (bt == null)
            return bt;
          if (Fe) {
            var Lt = ie.children;
            if (Lt !== void 0)
              if (be)
                if (Array.isArray(Lt)) {
                  for (var bn = 0; bn < Lt.length; bn++)
                    It(Lt[bn], J);
                  Object.freeze && Object.freeze(Lt);
                } else
                  S("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
              else
                It(Lt, J);
          }
          return J === t.Fragment ? yt(bt) : Rn(bt), bt;
        }
      }
      function ge(J, ie, me) {
        return oe(J, ie, me, !0);
      }
      function pe(J, ie, me) {
        return oe(J, ie, me, !1);
      }
      var He = pe, re = ge;
      t.jsx = He, t.jsxs = re;
    }();
  }(cC)), cC;
}
var _8;
function FAe() {
  return _8 || (_8 = 1, process.env.NODE_ENV === "production" ? sb.exports = jAe() : sb.exports = LAe()), sb.exports;
}
var JDt = FAe(), Yo = "top", Yi = "bottom", Ki = "right", Ko = "left", B3 = "auto", Ky = [Yo, Yi, Ki, Ko], $h = "start", O0 = "end", BAe = "clippingParents", Gse = "viewport", Zp = "popper", zAe = "reference", w8 = /* @__PURE__ */ Ky.reduce(function(t, e) {
  return t.concat([e + "-" + $h, e + "-" + O0]);
}, []), Yse = /* @__PURE__ */ [].concat(Ky, [B3]).reduce(function(t, e) {
  return t.concat([e, e + "-" + $h, e + "-" + O0]);
}, []), qAe = "beforeRead", UAe = "read", HAe = "afterRead", VAe = "beforeMain", WAe = "main", GAe = "afterMain", YAe = "beforeWrite", KAe = "write", XAe = "afterWrite", QAe = [qAe, UAe, HAe, VAe, WAe, GAe, YAe, KAe, XAe];
function xa(t) {
  return t ? (t.nodeName || "").toLowerCase() : null;
}
function Si(t) {
  if (t == null)
    return window;
  if (t.toString() !== "[object Window]") {
    var e = t.ownerDocument;
    return e && e.defaultView || window;
  }
  return t;
}
function kd(t) {
  var e = Si(t).Element;
  return t instanceof e || t instanceof Element;
}
function Ui(t) {
  var e = Si(t).HTMLElement;
  return t instanceof e || t instanceof HTMLElement;
}
function z3(t) {
  if (typeof ShadowRoot > "u")
    return !1;
  var e = Si(t).ShadowRoot;
  return t instanceof e || t instanceof ShadowRoot;
}
function ZAe(t) {
  var e = t.state;
  Object.keys(e.elements).forEach(function(n) {
    var r = e.styles[n] || {}, o = e.attributes[n] || {}, i = e.elements[n];
    !Ui(i) || !xa(i) || (Object.assign(i.style, r), Object.keys(o).forEach(function(s) {
      var a = o[s];
      a === !1 ? i.removeAttribute(s) : i.setAttribute(s, a === !0 ? "" : a);
    }));
  });
}
function JAe(t) {
  var e = t.state, n = {
    popper: {
      position: e.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(e.elements.popper.style, n.popper), e.styles = n, e.elements.arrow && Object.assign(e.elements.arrow.style, n.arrow), function() {
    Object.keys(e.elements).forEach(function(r) {
      var o = e.elements[r], i = e.attributes[r] || {}, s = Object.keys(e.styles.hasOwnProperty(r) ? e.styles[r] : n[r]), a = s.reduce(function(l, c) {
        return l[c] = "", l;
      }, {});
      !Ui(o) || !xa(o) || (Object.assign(o.style, a), Object.keys(i).forEach(function(l) {
        o.removeAttribute(l);
      }));
    });
  };
}
const Kse = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: ZAe,
  effect: JAe,
  requires: ["computeStyles"]
};
function ma(t) {
  return t.split("-")[0];
}
var hd = Math.max, Yw = Math.min, Mh = Math.round;
function $D() {
  var t = navigator.userAgentData;
  return t != null && t.brands && Array.isArray(t.brands) ? t.brands.map(function(e) {
    return e.brand + "/" + e.version;
  }).join(" ") : navigator.userAgent;
}
function Xse() {
  return !/^((?!chrome|android).)*safari/i.test($D());
}
function Dh(t, e, n) {
  e === void 0 && (e = !1), n === void 0 && (n = !1);
  var r = t.getBoundingClientRect(), o = 1, i = 1;
  e && Ui(t) && (o = t.offsetWidth > 0 && Mh(r.width) / t.offsetWidth || 1, i = t.offsetHeight > 0 && Mh(r.height) / t.offsetHeight || 1);
  var s = kd(t) ? Si(t) : window, a = s.visualViewport, l = !Xse() && n, c = (r.left + (l && a ? a.offsetLeft : 0)) / o, u = (r.top + (l && a ? a.offsetTop : 0)) / i, d = r.width / o, f = r.height / i;
  return {
    width: d,
    height: f,
    top: u,
    right: c + d,
    bottom: u + f,
    left: c,
    x: c,
    y: u
  };
}
function q3(t) {
  var e = Dh(t), n = t.offsetWidth, r = t.offsetHeight;
  return Math.abs(e.width - n) <= 1 && (n = e.width), Math.abs(e.height - r) <= 1 && (r = e.height), {
    x: t.offsetLeft,
    y: t.offsetTop,
    width: n,
    height: r
  };
}
function Qse(t, e) {
  var n = e.getRootNode && e.getRootNode();
  if (t.contains(e))
    return !0;
  if (n && z3(n)) {
    var r = e;
    do {
      if (r && t.isSameNode(r))
        return !0;
      r = r.parentNode || r.host;
    } while (r);
  }
  return !1;
}
function $l(t) {
  return Si(t).getComputedStyle(t);
}
function eTe(t) {
  return ["table", "td", "th"].indexOf(xa(t)) >= 0;
}
function su(t) {
  return ((kd(t) ? t.ownerDocument : (
    // $FlowFixMe[prop-missing]
    t.document
  )) || window.document).documentElement;
}
function ZE(t) {
  return xa(t) === "html" ? t : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    t.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    t.parentNode || // DOM Element detected
    (z3(t) ? t.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    su(t)
  );
}
function x8(t) {
  return !Ui(t) || // https://github.com/popperjs/popper-core/issues/837
  $l(t).position === "fixed" ? null : t.offsetParent;
}
function tTe(t) {
  var e = /firefox/i.test($D()), n = /Trident/i.test($D());
  if (n && Ui(t)) {
    var r = $l(t);
    if (r.position === "fixed")
      return null;
  }
  var o = ZE(t);
  for (z3(o) && (o = o.host); Ui(o) && ["html", "body"].indexOf(xa(o)) < 0; ) {
    var i = $l(o);
    if (i.transform !== "none" || i.perspective !== "none" || i.contain === "paint" || ["transform", "perspective"].indexOf(i.willChange) !== -1 || e && i.willChange === "filter" || e && i.filter && i.filter !== "none")
      return o;
    o = o.parentNode;
  }
  return null;
}
function Xy(t) {
  for (var e = Si(t), n = x8(t); n && eTe(n) && $l(n).position === "static"; )
    n = x8(n);
  return n && (xa(n) === "html" || xa(n) === "body" && $l(n).position === "static") ? e : n || tTe(t) || e;
}
function U3(t) {
  return ["top", "bottom"].indexOf(t) >= 0 ? "x" : "y";
}
function Bg(t, e, n) {
  return hd(t, Yw(e, n));
}
function nTe(t, e, n) {
  var r = Bg(t, e, n);
  return r > n ? n : r;
}
function Zse() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function Jse(t) {
  return Object.assign({}, Zse(), t);
}
function eae(t, e) {
  return e.reduce(function(n, r) {
    return n[r] = t, n;
  }, {});
}
var rTe = function(e, n) {
  return e = typeof e == "function" ? e(Object.assign({}, n.rects, {
    placement: n.placement
  })) : e, Jse(typeof e != "number" ? e : eae(e, Ky));
};
function oTe(t) {
  var e, n = t.state, r = t.name, o = t.options, i = n.elements.arrow, s = n.modifiersData.popperOffsets, a = ma(n.placement), l = U3(a), c = [Ko, Ki].indexOf(a) >= 0, u = c ? "height" : "width";
  if (!(!i || !s)) {
    var d = rTe(o.padding, n), f = q3(i), h = l === "y" ? Yo : Ko, p = l === "y" ? Yi : Ki, m = n.rects.reference[u] + n.rects.reference[l] - s[l] - n.rects.popper[u], g = s[l] - n.rects.reference[l], y = Xy(i), v = y ? l === "y" ? y.clientHeight || 0 : y.clientWidth || 0 : 0, b = m / 2 - g / 2, _ = d[h], w = v - f[u] - d[p], x = v / 2 - f[u] / 2 + b, E = Bg(_, x, w), S = l;
    n.modifiersData[r] = (e = {}, e[S] = E, e.centerOffset = E - x, e);
  }
}
function iTe(t) {
  var e = t.state, n = t.options, r = n.element, o = r === void 0 ? "[data-popper-arrow]" : r;
  o != null && (typeof o == "string" && (o = e.elements.popper.querySelector(o), !o) || Qse(e.elements.popper, o) && (e.elements.arrow = o));
}
const sTe = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: oTe,
  effect: iTe,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function Ih(t) {
  return t.split("-")[1];
}
var aTe = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function lTe(t, e) {
  var n = t.x, r = t.y, o = e.devicePixelRatio || 1;
  return {
    x: Mh(n * o) / o || 0,
    y: Mh(r * o) / o || 0
  };
}
function E8(t) {
  var e, n = t.popper, r = t.popperRect, o = t.placement, i = t.variation, s = t.offsets, a = t.position, l = t.gpuAcceleration, c = t.adaptive, u = t.roundOffsets, d = t.isFixed, f = s.x, h = f === void 0 ? 0 : f, p = s.y, m = p === void 0 ? 0 : p, g = typeof u == "function" ? u({
    x: h,
    y: m
  }) : {
    x: h,
    y: m
  };
  h = g.x, m = g.y;
  var y = s.hasOwnProperty("x"), v = s.hasOwnProperty("y"), b = Ko, _ = Yo, w = window;
  if (c) {
    var x = Xy(n), E = "clientHeight", S = "clientWidth";
    if (x === Si(n) && (x = su(n), $l(x).position !== "static" && a === "absolute" && (E = "scrollHeight", S = "scrollWidth")), x = x, o === Yo || (o === Ko || o === Ki) && i === O0) {
      _ = Yi;
      var C = d && x === w && w.visualViewport ? w.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        x[E]
      );
      m -= C - r.height, m *= l ? 1 : -1;
    }
    if (o === Ko || (o === Yo || o === Yi) && i === O0) {
      b = Ki;
      var R = d && x === w && w.visualViewport ? w.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        x[S]
      );
      h -= R - r.width, h *= l ? 1 : -1;
    }
  }
  var P = Object.assign({
    position: a
  }, c && aTe), N = u === !0 ? lTe({
    x: h,
    y: m
  }, Si(n)) : {
    x: h,
    y: m
  };
  if (h = N.x, m = N.y, l) {
    var A;
    return Object.assign({}, P, (A = {}, A[_] = v ? "0" : "", A[b] = y ? "0" : "", A.transform = (w.devicePixelRatio || 1) <= 1 ? "translate(" + h + "px, " + m + "px)" : "translate3d(" + h + "px, " + m + "px, 0)", A));
  }
  return Object.assign({}, P, (e = {}, e[_] = v ? m + "px" : "", e[b] = y ? h + "px" : "", e.transform = "", e));
}
function cTe(t) {
  var e = t.state, n = t.options, r = n.gpuAcceleration, o = r === void 0 ? !0 : r, i = n.adaptive, s = i === void 0 ? !0 : i, a = n.roundOffsets, l = a === void 0 ? !0 : a, c = {
    placement: ma(e.placement),
    variation: Ih(e.placement),
    popper: e.elements.popper,
    popperRect: e.rects.popper,
    gpuAcceleration: o,
    isFixed: e.options.strategy === "fixed"
  };
  e.modifiersData.popperOffsets != null && (e.styles.popper = Object.assign({}, e.styles.popper, E8(Object.assign({}, c, {
    offsets: e.modifiersData.popperOffsets,
    position: e.options.strategy,
    adaptive: s,
    roundOffsets: l
  })))), e.modifiersData.arrow != null && (e.styles.arrow = Object.assign({}, e.styles.arrow, E8(Object.assign({}, c, {
    offsets: e.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: l
  })))), e.attributes.popper = Object.assign({}, e.attributes.popper, {
    "data-popper-placement": e.placement
  });
}
const uTe = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: cTe,
  data: {}
};
var ab = {
  passive: !0
};
function dTe(t) {
  var e = t.state, n = t.instance, r = t.options, o = r.scroll, i = o === void 0 ? !0 : o, s = r.resize, a = s === void 0 ? !0 : s, l = Si(e.elements.popper), c = [].concat(e.scrollParents.reference, e.scrollParents.popper);
  return i && c.forEach(function(u) {
    u.addEventListener("scroll", n.update, ab);
  }), a && l.addEventListener("resize", n.update, ab), function() {
    i && c.forEach(function(u) {
      u.removeEventListener("scroll", n.update, ab);
    }), a && l.removeEventListener("resize", n.update, ab);
  };
}
const fTe = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: dTe,
  data: {}
};
var hTe = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function j_(t) {
  return t.replace(/left|right|bottom|top/g, function(e) {
    return hTe[e];
  });
}
var pTe = {
  start: "end",
  end: "start"
};
function S8(t) {
  return t.replace(/start|end/g, function(e) {
    return pTe[e];
  });
}
function H3(t) {
  var e = Si(t), n = e.pageXOffset, r = e.pageYOffset;
  return {
    scrollLeft: n,
    scrollTop: r
  };
}
function V3(t) {
  return Dh(su(t)).left + H3(t).scrollLeft;
}
function mTe(t, e) {
  var n = Si(t), r = su(t), o = n.visualViewport, i = r.clientWidth, s = r.clientHeight, a = 0, l = 0;
  if (o) {
    i = o.width, s = o.height;
    var c = Xse();
    (c || !c && e === "fixed") && (a = o.offsetLeft, l = o.offsetTop);
  }
  return {
    width: i,
    height: s,
    x: a + V3(t),
    y: l
  };
}
function gTe(t) {
  var e, n = su(t), r = H3(t), o = (e = t.ownerDocument) == null ? void 0 : e.body, i = hd(n.scrollWidth, n.clientWidth, o ? o.scrollWidth : 0, o ? o.clientWidth : 0), s = hd(n.scrollHeight, n.clientHeight, o ? o.scrollHeight : 0, o ? o.clientHeight : 0), a = -r.scrollLeft + V3(t), l = -r.scrollTop;
  return $l(o || n).direction === "rtl" && (a += hd(n.clientWidth, o ? o.clientWidth : 0) - i), {
    width: i,
    height: s,
    x: a,
    y: l
  };
}
function W3(t) {
  var e = $l(t), n = e.overflow, r = e.overflowX, o = e.overflowY;
  return /auto|scroll|overlay|hidden/.test(n + o + r);
}
function tae(t) {
  return ["html", "body", "#document"].indexOf(xa(t)) >= 0 ? t.ownerDocument.body : Ui(t) && W3(t) ? t : tae(ZE(t));
}
function zg(t, e) {
  var n;
  e === void 0 && (e = []);
  var r = tae(t), o = r === ((n = t.ownerDocument) == null ? void 0 : n.body), i = Si(r), s = o ? [i].concat(i.visualViewport || [], W3(r) ? r : []) : r, a = e.concat(s);
  return o ? a : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    a.concat(zg(ZE(s)))
  );
}
function MD(t) {
  return Object.assign({}, t, {
    left: t.x,
    top: t.y,
    right: t.x + t.width,
    bottom: t.y + t.height
  });
}
function yTe(t, e) {
  var n = Dh(t, !1, e === "fixed");
  return n.top = n.top + t.clientTop, n.left = n.left + t.clientLeft, n.bottom = n.top + t.clientHeight, n.right = n.left + t.clientWidth, n.width = t.clientWidth, n.height = t.clientHeight, n.x = n.left, n.y = n.top, n;
}
function O8(t, e, n) {
  return e === Gse ? MD(mTe(t, n)) : kd(e) ? yTe(e, n) : MD(gTe(su(t)));
}
function vTe(t) {
  var e = zg(ZE(t)), n = ["absolute", "fixed"].indexOf($l(t).position) >= 0, r = n && Ui(t) ? Xy(t) : t;
  return kd(r) ? e.filter(function(o) {
    return kd(o) && Qse(o, r) && xa(o) !== "body";
  }) : [];
}
function bTe(t, e, n, r) {
  var o = e === "clippingParents" ? vTe(t) : [].concat(e), i = [].concat(o, [n]), s = i[0], a = i.reduce(function(l, c) {
    var u = O8(t, c, r);
    return l.top = hd(u.top, l.top), l.right = Yw(u.right, l.right), l.bottom = Yw(u.bottom, l.bottom), l.left = hd(u.left, l.left), l;
  }, O8(t, s, r));
  return a.width = a.right - a.left, a.height = a.bottom - a.top, a.x = a.left, a.y = a.top, a;
}
function nae(t) {
  var e = t.reference, n = t.element, r = t.placement, o = r ? ma(r) : null, i = r ? Ih(r) : null, s = e.x + e.width / 2 - n.width / 2, a = e.y + e.height / 2 - n.height / 2, l;
  switch (o) {
    case Yo:
      l = {
        x: s,
        y: e.y - n.height
      };
      break;
    case Yi:
      l = {
        x: s,
        y: e.y + e.height
      };
      break;
    case Ki:
      l = {
        x: e.x + e.width,
        y: a
      };
      break;
    case Ko:
      l = {
        x: e.x - n.width,
        y: a
      };
      break;
    default:
      l = {
        x: e.x,
        y: e.y
      };
  }
  var c = o ? U3(o) : null;
  if (c != null) {
    var u = c === "y" ? "height" : "width";
    switch (i) {
      case $h:
        l[c] = l[c] - (e[u] / 2 - n[u] / 2);
        break;
      case O0:
        l[c] = l[c] + (e[u] / 2 - n[u] / 2);
        break;
    }
  }
  return l;
}
function C0(t, e) {
  e === void 0 && (e = {});
  var n = e, r = n.placement, o = r === void 0 ? t.placement : r, i = n.strategy, s = i === void 0 ? t.strategy : i, a = n.boundary, l = a === void 0 ? BAe : a, c = n.rootBoundary, u = c === void 0 ? Gse : c, d = n.elementContext, f = d === void 0 ? Zp : d, h = n.altBoundary, p = h === void 0 ? !1 : h, m = n.padding, g = m === void 0 ? 0 : m, y = Jse(typeof g != "number" ? g : eae(g, Ky)), v = f === Zp ? zAe : Zp, b = t.rects.popper, _ = t.elements[p ? v : f], w = bTe(kd(_) ? _ : _.contextElement || su(t.elements.popper), l, u, s), x = Dh(t.elements.reference), E = nae({
    reference: x,
    element: b,
    strategy: "absolute",
    placement: o
  }), S = MD(Object.assign({}, b, E)), C = f === Zp ? S : x, R = {
    top: w.top - C.top + y.top,
    bottom: C.bottom - w.bottom + y.bottom,
    left: w.left - C.left + y.left,
    right: C.right - w.right + y.right
  }, P = t.modifiersData.offset;
  if (f === Zp && P) {
    var N = P[o];
    Object.keys(R).forEach(function(A) {
      var O = [Ki, Yi].indexOf(A) >= 0 ? 1 : -1, k = [Yo, Yi].indexOf(A) >= 0 ? "y" : "x";
      R[A] += N[k] * O;
    });
  }
  return R;
}
function _Te(t, e) {
  e === void 0 && (e = {});
  var n = e, r = n.placement, o = n.boundary, i = n.rootBoundary, s = n.padding, a = n.flipVariations, l = n.allowedAutoPlacements, c = l === void 0 ? Yse : l, u = Ih(r), d = u ? a ? w8 : w8.filter(function(p) {
    return Ih(p) === u;
  }) : Ky, f = d.filter(function(p) {
    return c.indexOf(p) >= 0;
  });
  f.length === 0 && (f = d);
  var h = f.reduce(function(p, m) {
    return p[m] = C0(t, {
      placement: m,
      boundary: o,
      rootBoundary: i,
      padding: s
    })[ma(m)], p;
  }, {});
  return Object.keys(h).sort(function(p, m) {
    return h[p] - h[m];
  });
}
function wTe(t) {
  if (ma(t) === B3)
    return [];
  var e = j_(t);
  return [S8(t), e, S8(e)];
}
function xTe(t) {
  var e = t.state, n = t.options, r = t.name;
  if (!e.modifiersData[r]._skip) {
    for (var o = n.mainAxis, i = o === void 0 ? !0 : o, s = n.altAxis, a = s === void 0 ? !0 : s, l = n.fallbackPlacements, c = n.padding, u = n.boundary, d = n.rootBoundary, f = n.altBoundary, h = n.flipVariations, p = h === void 0 ? !0 : h, m = n.allowedAutoPlacements, g = e.options.placement, y = ma(g), v = y === g, b = l || (v || !p ? [j_(g)] : wTe(g)), _ = [g].concat(b).reduce(function(F, B) {
      return F.concat(ma(B) === B3 ? _Te(e, {
        placement: B,
        boundary: u,
        rootBoundary: d,
        padding: c,
        flipVariations: p,
        allowedAutoPlacements: m
      }) : B);
    }, []), w = e.rects.reference, x = e.rects.popper, E = /* @__PURE__ */ new Map(), S = !0, C = _[0], R = 0; R < _.length; R++) {
      var P = _[R], N = ma(P), A = Ih(P) === $h, O = [Yo, Yi].indexOf(N) >= 0, k = O ? "width" : "height", T = C0(e, {
        placement: P,
        boundary: u,
        rootBoundary: d,
        altBoundary: f,
        padding: c
      }), I = O ? A ? Ki : Ko : A ? Yi : Yo;
      w[k] > x[k] && (I = j_(I));
      var j = j_(I), z = [];
      if (i && z.push(T[N] <= 0), a && z.push(T[I] <= 0, T[j] <= 0), z.every(function(F) {
        return F;
      })) {
        C = P, S = !1;
        break;
      }
      E.set(P, z);
    }
    if (S)
      for (var $ = p ? 3 : 1, D = function(B) {
        var H = _.find(function(Z) {
          var W = E.get(Z);
          if (W)
            return W.slice(0, B).every(function(G) {
              return G;
            });
        });
        if (H)
          return C = H, "break";
      }, U = $; U > 0; U--) {
        var q = D(U);
        if (q === "break") break;
      }
    e.placement !== C && (e.modifiersData[r]._skip = !0, e.placement = C, e.reset = !0);
  }
}
const ETe = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: xTe,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function C8(t, e, n) {
  return n === void 0 && (n = {
    x: 0,
    y: 0
  }), {
    top: t.top - e.height - n.y,
    right: t.right - e.width + n.x,
    bottom: t.bottom - e.height + n.y,
    left: t.left - e.width - n.x
  };
}
function k8(t) {
  return [Yo, Ki, Yi, Ko].some(function(e) {
    return t[e] >= 0;
  });
}
function STe(t) {
  var e = t.state, n = t.name, r = e.rects.reference, o = e.rects.popper, i = e.modifiersData.preventOverflow, s = C0(e, {
    elementContext: "reference"
  }), a = C0(e, {
    altBoundary: !0
  }), l = C8(s, r), c = C8(a, o, i), u = k8(l), d = k8(c);
  e.modifiersData[n] = {
    referenceClippingOffsets: l,
    popperEscapeOffsets: c,
    isReferenceHidden: u,
    hasPopperEscaped: d
  }, e.attributes.popper = Object.assign({}, e.attributes.popper, {
    "data-popper-reference-hidden": u,
    "data-popper-escaped": d
  });
}
const OTe = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: STe
};
function CTe(t, e, n) {
  var r = ma(t), o = [Ko, Yo].indexOf(r) >= 0 ? -1 : 1, i = typeof n == "function" ? n(Object.assign({}, e, {
    placement: t
  })) : n, s = i[0], a = i[1];
  return s = s || 0, a = (a || 0) * o, [Ko, Ki].indexOf(r) >= 0 ? {
    x: a,
    y: s
  } : {
    x: s,
    y: a
  };
}
function kTe(t) {
  var e = t.state, n = t.options, r = t.name, o = n.offset, i = o === void 0 ? [0, 0] : o, s = Yse.reduce(function(u, d) {
    return u[d] = CTe(d, e.rects, i), u;
  }, {}), a = s[e.placement], l = a.x, c = a.y;
  e.modifiersData.popperOffsets != null && (e.modifiersData.popperOffsets.x += l, e.modifiersData.popperOffsets.y += c), e.modifiersData[r] = s;
}
const ATe = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: kTe
};
function TTe(t) {
  var e = t.state, n = t.name;
  e.modifiersData[n] = nae({
    reference: e.rects.reference,
    element: e.rects.popper,
    strategy: "absolute",
    placement: e.placement
  });
}
const RTe = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: TTe,
  data: {}
};
function PTe(t) {
  return t === "x" ? "y" : "x";
}
function $Te(t) {
  var e = t.state, n = t.options, r = t.name, o = n.mainAxis, i = o === void 0 ? !0 : o, s = n.altAxis, a = s === void 0 ? !1 : s, l = n.boundary, c = n.rootBoundary, u = n.altBoundary, d = n.padding, f = n.tether, h = f === void 0 ? !0 : f, p = n.tetherOffset, m = p === void 0 ? 0 : p, g = C0(e, {
    boundary: l,
    rootBoundary: c,
    padding: d,
    altBoundary: u
  }), y = ma(e.placement), v = Ih(e.placement), b = !v, _ = U3(y), w = PTe(_), x = e.modifiersData.popperOffsets, E = e.rects.reference, S = e.rects.popper, C = typeof m == "function" ? m(Object.assign({}, e.rects, {
    placement: e.placement
  })) : m, R = typeof C == "number" ? {
    mainAxis: C,
    altAxis: C
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, C), P = e.modifiersData.offset ? e.modifiersData.offset[e.placement] : null, N = {
    x: 0,
    y: 0
  };
  if (x) {
    if (i) {
      var A, O = _ === "y" ? Yo : Ko, k = _ === "y" ? Yi : Ki, T = _ === "y" ? "height" : "width", I = x[_], j = I + g[O], z = I - g[k], $ = h ? -S[T] / 2 : 0, D = v === $h ? E[T] : S[T], U = v === $h ? -S[T] : -E[T], q = e.elements.arrow, F = h && q ? q3(q) : {
        width: 0,
        height: 0
      }, B = e.modifiersData["arrow#persistent"] ? e.modifiersData["arrow#persistent"].padding : Zse(), H = B[O], Z = B[k], W = Bg(0, E[T], F[T]), G = b ? E[T] / 2 - $ - W - H - R.mainAxis : D - W - H - R.mainAxis, ee = b ? -E[T] / 2 + $ + W + Z + R.mainAxis : U + W + Z + R.mainAxis, Y = e.elements.arrow && Xy(e.elements.arrow), L = Y ? _ === "y" ? Y.clientTop || 0 : Y.clientLeft || 0 : 0, V = (A = P?.[_]) != null ? A : 0, K = I + G - V - L, ne = I + ee - V, ce = Bg(h ? Yw(j, K) : j, I, h ? hd(z, ne) : z);
      x[_] = ce, N[_] = ce - I;
    }
    if (a) {
      var fe, ve = _ === "x" ? Yo : Ko, _e = _ === "x" ? Yi : Ki, Ee = x[w], Me = w === "y" ? "height" : "width", Le = Ee + g[ve], Ce = Ee - g[_e], Je = [Yo, Ko].indexOf(y) !== -1, Ie = (fe = P?.[w]) != null ? fe : 0, nt = Je ? Le : Ee - E[Me] - S[Me] - Ie + R.altAxis, ct = Je ? Ee + E[Me] + S[Me] - Ie - R.altAxis : Ce, mt = h && Je ? nTe(nt, Ee, ct) : Bg(h ? nt : Le, Ee, h ? ct : Ce);
      x[w] = mt, N[w] = mt - Ee;
    }
    e.modifiersData[r] = N;
  }
}
const MTe = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: $Te,
  requiresIfExists: ["offset"]
};
function DTe(t) {
  return {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  };
}
function ITe(t) {
  return t === Si(t) || !Ui(t) ? H3(t) : DTe(t);
}
function NTe(t) {
  var e = t.getBoundingClientRect(), n = Mh(e.width) / t.offsetWidth || 1, r = Mh(e.height) / t.offsetHeight || 1;
  return n !== 1 || r !== 1;
}
function jTe(t, e, n) {
  n === void 0 && (n = !1);
  var r = Ui(e), o = Ui(e) && NTe(e), i = su(e), s = Dh(t, o, n), a = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = {
    x: 0,
    y: 0
  };
  return (r || !r && !n) && ((xa(e) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  W3(i)) && (a = ITe(e)), Ui(e) ? (l = Dh(e, !0), l.x += e.clientLeft, l.y += e.clientTop) : i && (l.x = V3(i))), {
    x: s.left + a.scrollLeft - l.x,
    y: s.top + a.scrollTop - l.y,
    width: s.width,
    height: s.height
  };
}
function LTe(t) {
  var e = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set(), r = [];
  t.forEach(function(i) {
    e.set(i.name, i);
  });
  function o(i) {
    n.add(i.name);
    var s = [].concat(i.requires || [], i.requiresIfExists || []);
    s.forEach(function(a) {
      if (!n.has(a)) {
        var l = e.get(a);
        l && o(l);
      }
    }), r.push(i);
  }
  return t.forEach(function(i) {
    n.has(i.name) || o(i);
  }), r;
}
function FTe(t) {
  var e = LTe(t);
  return QAe.reduce(function(n, r) {
    return n.concat(e.filter(function(o) {
      return o.phase === r;
    }));
  }, []);
}
function BTe(t) {
  var e;
  return function() {
    return e || (e = new Promise(function(n) {
      Promise.resolve().then(function() {
        e = void 0, n(t());
      });
    })), e;
  };
}
function zTe(t) {
  var e = t.reduce(function(n, r) {
    var o = n[r.name];
    return n[r.name] = o ? Object.assign({}, o, r, {
      options: Object.assign({}, o.options, r.options),
      data: Object.assign({}, o.data, r.data)
    }) : r, n;
  }, {});
  return Object.keys(e).map(function(n) {
    return e[n];
  });
}
var A8 = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function T8() {
  for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++)
    e[n] = arguments[n];
  return !e.some(function(r) {
    return !(r && typeof r.getBoundingClientRect == "function");
  });
}
function qTe(t) {
  t === void 0 && (t = {});
  var e = t, n = e.defaultModifiers, r = n === void 0 ? [] : n, o = e.defaultOptions, i = o === void 0 ? A8 : o;
  return function(a, l, c) {
    c === void 0 && (c = i);
    var u = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, A8, i),
      modifiersData: {},
      elements: {
        reference: a,
        popper: l
      },
      attributes: {},
      styles: {}
    }, d = [], f = !1, h = {
      state: u,
      setOptions: function(y) {
        var v = typeof y == "function" ? y(u.options) : y;
        m(), u.options = Object.assign({}, i, u.options, v), u.scrollParents = {
          reference: kd(a) ? zg(a) : a.contextElement ? zg(a.contextElement) : [],
          popper: zg(l)
        };
        var b = FTe(zTe([].concat(r, u.options.modifiers)));
        return u.orderedModifiers = b.filter(function(_) {
          return _.enabled;
        }), p(), h.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!f) {
          var y = u.elements, v = y.reference, b = y.popper;
          if (T8(v, b)) {
            u.rects = {
              reference: jTe(v, Xy(b), u.options.strategy === "fixed"),
              popper: q3(b)
            }, u.reset = !1, u.placement = u.options.placement, u.orderedModifiers.forEach(function(R) {
              return u.modifiersData[R.name] = Object.assign({}, R.data);
            });
            for (var _ = 0; _ < u.orderedModifiers.length; _++) {
              if (u.reset === !0) {
                u.reset = !1, _ = -1;
                continue;
              }
              var w = u.orderedModifiers[_], x = w.fn, E = w.options, S = E === void 0 ? {} : E, C = w.name;
              typeof x == "function" && (u = x({
                state: u,
                options: S,
                name: C,
                instance: h
              }) || u);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: BTe(function() {
        return new Promise(function(g) {
          h.forceUpdate(), g(u);
        });
      }),
      destroy: function() {
        m(), f = !0;
      }
    };
    if (!T8(a, l))
      return h;
    h.setOptions(c).then(function(g) {
      !f && c.onFirstUpdate && c.onFirstUpdate(g);
    });
    function p() {
      u.orderedModifiers.forEach(function(g) {
        var y = g.name, v = g.options, b = v === void 0 ? {} : v, _ = g.effect;
        if (typeof _ == "function") {
          var w = _({
            state: u,
            name: y,
            instance: h,
            options: b
          }), x = function() {
          };
          d.push(w || x);
        }
      });
    }
    function m() {
      d.forEach(function(g) {
        return g();
      }), d = [];
    }
    return h;
  };
}
var UTe = [fTe, RTe, uTe, Kse, ATe, ETe, MTe, sTe, OTe], HTe = /* @__PURE__ */ qTe({
  defaultModifiers: UTe
}), VTe = "tippy-box", rae = "tippy-content", WTe = "tippy-backdrop", oae = "tippy-arrow", iae = "tippy-svg-arrow", Du = {
  passive: !0,
  capture: !0
}, sae = function() {
  return document.body;
};
function GTe(t, e) {
  return {}.hasOwnProperty.call(t, e);
}
function uC(t, e, n) {
  if (Array.isArray(t)) {
    var r = t[e];
    return r ?? (Array.isArray(n) ? n[e] : n);
  }
  return t;
}
function G3(t, e) {
  var n = {}.toString.call(t);
  return n.indexOf("[object") === 0 && n.indexOf(e + "]") > -1;
}
function aae(t, e) {
  return typeof t == "function" ? t.apply(void 0, e) : t;
}
function R8(t, e) {
  if (e === 0)
    return t;
  var n;
  return function(r) {
    clearTimeout(n), n = setTimeout(function() {
      t(r);
    }, e);
  };
}
function YTe(t, e) {
  var n = Object.assign({}, t);
  return e.forEach(function(r) {
    delete n[r];
  }), n;
}
function KTe(t) {
  return t.split(/\s+/).filter(Boolean);
}
function Af(t) {
  return [].concat(t);
}
function P8(t, e) {
  t.indexOf(e) === -1 && t.push(e);
}
function XTe(t) {
  return t.filter(function(e, n) {
    return t.indexOf(e) === n;
  });
}
function QTe(t) {
  return t.split("-")[0];
}
function Kw(t) {
  return [].slice.call(t);
}
function $8(t) {
  return Object.keys(t).reduce(function(e, n) {
    return t[n] !== void 0 && (e[n] = t[n]), e;
  }, {});
}
function qg() {
  return document.createElement("div");
}
function k0(t) {
  return ["Element", "Fragment"].some(function(e) {
    return G3(t, e);
  });
}
function ZTe(t) {
  return G3(t, "NodeList");
}
function JTe(t) {
  return G3(t, "MouseEvent");
}
function eRe(t) {
  return !!(t && t._tippy && t._tippy.reference === t);
}
function tRe(t) {
  return k0(t) ? [t] : ZTe(t) ? Kw(t) : Array.isArray(t) ? t : Kw(document.querySelectorAll(t));
}
function dC(t, e) {
  t.forEach(function(n) {
    n && (n.style.transitionDuration = e + "ms");
  });
}
function M8(t, e) {
  t.forEach(function(n) {
    n && n.setAttribute("data-state", e);
  });
}
function nRe(t) {
  var e, n = Af(t), r = n[0];
  return r != null && (e = r.ownerDocument) != null && e.body ? r.ownerDocument : document;
}
function rRe(t, e) {
  var n = e.clientX, r = e.clientY;
  return t.every(function(o) {
    var i = o.popperRect, s = o.popperState, a = o.props, l = a.interactiveBorder, c = QTe(s.placement), u = s.modifiersData.offset;
    if (!u)
      return !0;
    var d = c === "bottom" ? u.top.y : 0, f = c === "top" ? u.bottom.y : 0, h = c === "right" ? u.left.x : 0, p = c === "left" ? u.right.x : 0, m = i.top - r + d > l, g = r - i.bottom - f > l, y = i.left - n + h > l, v = n - i.right - p > l;
    return m || g || y || v;
  });
}
function fC(t, e, n) {
  var r = e + "EventListener";
  ["transitionend", "webkitTransitionEnd"].forEach(function(o) {
    t[r](o, n);
  });
}
function D8(t, e) {
  for (var n = e; n; ) {
    var r;
    if (t.contains(n))
      return !0;
    n = n.getRootNode == null || (r = n.getRootNode()) == null ? void 0 : r.host;
  }
  return !1;
}
var na = {
  isTouch: !1
}, I8 = 0;
function oRe() {
  na.isTouch || (na.isTouch = !0, window.performance && document.addEventListener("mousemove", lae));
}
function lae() {
  var t = performance.now();
  t - I8 < 20 && (na.isTouch = !1, document.removeEventListener("mousemove", lae)), I8 = t;
}
function iRe() {
  var t = document.activeElement;
  if (eRe(t)) {
    var e = t._tippy;
    t.blur && !e.state.isVisible && t.blur();
  }
}
function sRe() {
  document.addEventListener("touchstart", oRe, Du), window.addEventListener("blur", iRe);
}
var aRe = typeof window < "u" && typeof document < "u", lRe = aRe ? (
  // @ts-ignore
  !!window.msCrypto
) : !1;
function pf(t) {
  var e = t === "destroy" ? "n already-" : " ";
  return [t + "() was called on a" + e + "destroyed instance. This is a no-op but", "indicates a potential memory leak."].join(" ");
}
function N8(t) {
  var e = /[ \t]{2,}/g, n = /^[ \t]*/gm;
  return t.replace(e, " ").replace(n, "").trim();
}
function cRe(t) {
  return N8(`
  %ctippy.js

  %c` + N8(t) + `

  %c👷‍ This is a development-only message. It will be removed in production.
  `);
}
function cae(t) {
  return [
    cRe(t),
    // title
    "color: #00C584; font-size: 1.3em; font-weight: bold;",
    // message
    "line-height: 1.5",
    // footer
    "color: #a6a095;"
  ];
}
var A0;
process.env.NODE_ENV !== "production" && uRe();
function uRe() {
  A0 = /* @__PURE__ */ new Set();
}
function il(t, e) {
  if (t && !A0.has(e)) {
    var n;
    A0.add(e), (n = console).warn.apply(n, cae(e));
  }
}
function DD(t, e) {
  if (t && !A0.has(e)) {
    var n;
    A0.add(e), (n = console).error.apply(n, cae(e));
  }
}
function dRe(t) {
  var e = !t, n = Object.prototype.toString.call(t) === "[object Object]" && !t.addEventListener;
  DD(e, ["tippy() was passed", "`" + String(t) + "`", "as its targets (first) argument. Valid types are: String, Element,", "Element[], or NodeList."].join(" ")), DD(n, ["tippy() was passed a plain object which is not supported as an argument", "for virtual positioning. Use props.getReferenceClientRect instead."].join(" "));
}
var uae = {
  animateFill: !1,
  followCursor: !1,
  inlinePositioning: !1,
  sticky: !1
}, fRe = {
  allowHTML: !1,
  animation: "fade",
  arrow: !0,
  content: "",
  inertia: !1,
  maxWidth: 350,
  role: "tooltip",
  theme: "",
  zIndex: 9999
}, pi = Object.assign({
  appendTo: sae,
  aria: {
    content: "auto",
    expanded: "auto"
  },
  delay: 0,
  duration: [300, 250],
  getReferenceClientRect: null,
  hideOnClick: !0,
  ignoreAttributes: !1,
  interactive: !1,
  interactiveBorder: 2,
  interactiveDebounce: 0,
  moveTransition: "",
  offset: [0, 10],
  onAfterUpdate: function() {
  },
  onBeforeUpdate: function() {
  },
  onCreate: function() {
  },
  onDestroy: function() {
  },
  onHidden: function() {
  },
  onHide: function() {
  },
  onMount: function() {
  },
  onShow: function() {
  },
  onShown: function() {
  },
  onTrigger: function() {
  },
  onUntrigger: function() {
  },
  onClickOutside: function() {
  },
  placement: "top",
  plugins: [],
  popperOptions: {},
  render: null,
  showOnCreate: !1,
  touch: !0,
  trigger: "mouseenter focus",
  triggerTarget: null
}, uae, fRe), hRe = Object.keys(pi), pRe = function(e) {
  process.env.NODE_ENV !== "production" && fae(e, []);
  var n = Object.keys(e);
  n.forEach(function(r) {
    pi[r] = e[r];
  });
};
function dae(t) {
  var e = t.plugins || [], n = e.reduce(function(r, o) {
    var i = o.name, s = o.defaultValue;
    if (i) {
      var a;
      r[i] = t[i] !== void 0 ? t[i] : (a = pi[i]) != null ? a : s;
    }
    return r;
  }, {});
  return Object.assign({}, t, n);
}
function mRe(t, e) {
  var n = e ? Object.keys(dae(Object.assign({}, pi, {
    plugins: e
  }))) : hRe, r = n.reduce(function(o, i) {
    var s = (t.getAttribute("data-tippy-" + i) || "").trim();
    if (!s)
      return o;
    if (i === "content")
      o[i] = s;
    else
      try {
        o[i] = JSON.parse(s);
      } catch {
        o[i] = s;
      }
    return o;
  }, {});
  return r;
}
function j8(t, e) {
  var n = Object.assign({}, e, {
    content: aae(e.content, [t])
  }, e.ignoreAttributes ? {} : mRe(t, e.plugins));
  return n.aria = Object.assign({}, pi.aria, n.aria), n.aria = {
    expanded: n.aria.expanded === "auto" ? e.interactive : n.aria.expanded,
    content: n.aria.content === "auto" ? e.interactive ? null : "describedby" : n.aria.content
  }, n;
}
function fae(t, e) {
  t === void 0 && (t = {}), e === void 0 && (e = []);
  var n = Object.keys(t);
  n.forEach(function(r) {
    var o = YTe(pi, Object.keys(uae)), i = !GTe(o, r);
    i && (i = e.filter(function(s) {
      return s.name === r;
    }).length === 0), il(i, ["`" + r + "`", "is not a valid prop. You may have spelled it incorrectly, or if it's", "a plugin, forgot to pass it in an array as props.plugins.", `

`, `All props: https://atomiks.github.io/tippyjs/v6/all-props/
`, "Plugins: https://atomiks.github.io/tippyjs/v6/plugins/"].join(" "));
  });
}
var gRe = function() {
  return "innerHTML";
};
function ID(t, e) {
  t[gRe()] = e;
}
function L8(t) {
  var e = qg();
  return t === !0 ? e.className = oae : (e.className = iae, k0(t) ? e.appendChild(t) : ID(e, t)), e;
}
function F8(t, e) {
  k0(e.content) ? (ID(t, ""), t.appendChild(e.content)) : typeof e.content != "function" && (e.allowHTML ? ID(t, e.content) : t.textContent = e.content);
}
function ND(t) {
  var e = t.firstElementChild, n = Kw(e.children);
  return {
    box: e,
    content: n.find(function(r) {
      return r.classList.contains(rae);
    }),
    arrow: n.find(function(r) {
      return r.classList.contains(oae) || r.classList.contains(iae);
    }),
    backdrop: n.find(function(r) {
      return r.classList.contains(WTe);
    })
  };
}
function hae(t) {
  var e = qg(), n = qg();
  n.className = VTe, n.setAttribute("data-state", "hidden"), n.setAttribute("tabindex", "-1");
  var r = qg();
  r.className = rae, r.setAttribute("data-state", "hidden"), F8(r, t.props), e.appendChild(n), n.appendChild(r), o(t.props, t.props);
  function o(i, s) {
    var a = ND(e), l = a.box, c = a.content, u = a.arrow;
    s.theme ? l.setAttribute("data-theme", s.theme) : l.removeAttribute("data-theme"), typeof s.animation == "string" ? l.setAttribute("data-animation", s.animation) : l.removeAttribute("data-animation"), s.inertia ? l.setAttribute("data-inertia", "") : l.removeAttribute("data-inertia"), l.style.maxWidth = typeof s.maxWidth == "number" ? s.maxWidth + "px" : s.maxWidth, s.role ? l.setAttribute("role", s.role) : l.removeAttribute("role"), (i.content !== s.content || i.allowHTML !== s.allowHTML) && F8(c, t.props), s.arrow ? u ? i.arrow !== s.arrow && (l.removeChild(u), l.appendChild(L8(s.arrow))) : l.appendChild(L8(s.arrow)) : u && l.removeChild(u);
  }
  return {
    popper: e,
    onUpdate: o
  };
}
hae.$$tippy = !0;
var yRe = 1, lb = [], hC = [];
function vRe(t, e) {
  var n = j8(t, Object.assign({}, pi, dae($8(e)))), r, o, i, s = !1, a = !1, l = !1, c = !1, u, d, f, h = [], p = R8(K, n.interactiveDebounce), m, g = yRe++, y = null, v = XTe(n.plugins), b = {
    // Is the instance currently enabled?
    isEnabled: !0,
    // Is the tippy currently showing and not transitioning out?
    isVisible: !1,
    // Has the instance been destroyed?
    isDestroyed: !1,
    // Is the tippy currently mounted to the DOM?
    isMounted: !1,
    // Has the tippy finished transitioning in?
    isShown: !1
  }, _ = {
    // properties
    id: g,
    reference: t,
    popper: qg(),
    popperInstance: y,
    props: n,
    state: b,
    plugins: v,
    // methods
    clearDelayTimeouts: nt,
    setProps: ct,
    setContent: mt,
    show: gt,
    hide: Et,
    hideWithInteractivity: Rt,
    enable: Je,
    disable: Ie,
    unmount: zt,
    destroy: At
  };
  if (!n.render)
    return process.env.NODE_ENV !== "production" && DD(!0, "render() function has not been supplied."), _;
  var w = n.render(_), x = w.popper, E = w.onUpdate;
  x.setAttribute("data-tippy-root", ""), x.id = "tippy-" + _.id, _.popper = x, t._tippy = _, x._tippy = _;
  var S = v.map(function(X) {
    return X.fn(_);
  }), C = t.hasAttribute("aria-expanded");
  return Y(), $(), I(), j("onCreate", [_]), n.showOnCreate && Le(), x.addEventListener("mouseenter", function() {
    _.props.interactive && _.state.isVisible && _.clearDelayTimeouts();
  }), x.addEventListener("mouseleave", function() {
    _.props.interactive && _.props.trigger.indexOf("mouseenter") >= 0 && O().addEventListener("mousemove", p);
  }), _;
  function R() {
    var X = _.props.touch;
    return Array.isArray(X) ? X : [X, 0];
  }
  function P() {
    return R()[0] === "hold";
  }
  function N() {
    var X;
    return !!((X = _.props.render) != null && X.$$tippy);
  }
  function A() {
    return m || t;
  }
  function O() {
    var X = A().parentNode;
    return X ? nRe(X) : document;
  }
  function k() {
    return ND(x);
  }
  function T(X) {
    return _.state.isMounted && !_.state.isVisible || na.isTouch || u && u.type === "focus" ? 0 : uC(_.props.delay, X ? 0 : 1, pi.delay);
  }
  function I(X) {
    X === void 0 && (X = !1), x.style.pointerEvents = _.props.interactive && !X ? "" : "none", x.style.zIndex = "" + _.props.zIndex;
  }
  function j(X, ae, ye) {
    if (ye === void 0 && (ye = !0), S.forEach(function(Te) {
      Te[X] && Te[X].apply(Te, ae);
    }), ye) {
      var De;
      (De = _.props)[X].apply(De, ae);
    }
  }
  function z() {
    var X = _.props.aria;
    if (X.content) {
      var ae = "aria-" + X.content, ye = x.id, De = Af(_.props.triggerTarget || t);
      De.forEach(function(Te) {
        var st = Te.getAttribute(ae);
        if (_.state.isVisible)
          Te.setAttribute(ae, st ? st + " " + ye : ye);
        else {
          var ft = st && st.replace(ye, "").trim();
          ft ? Te.setAttribute(ae, ft) : Te.removeAttribute(ae);
        }
      });
    }
  }
  function $() {
    if (!(C || !_.props.aria.expanded)) {
      var X = Af(_.props.triggerTarget || t);
      X.forEach(function(ae) {
        _.props.interactive ? ae.setAttribute("aria-expanded", _.state.isVisible && ae === A() ? "true" : "false") : ae.removeAttribute("aria-expanded");
      });
    }
  }
  function D() {
    O().removeEventListener("mousemove", p), lb = lb.filter(function(X) {
      return X !== p;
    });
  }
  function U(X) {
    if (!(na.isTouch && (l || X.type === "mousedown"))) {
      var ae = X.composedPath && X.composedPath()[0] || X.target;
      if (!(_.props.interactive && D8(x, ae))) {
        if (Af(_.props.triggerTarget || t).some(function(ye) {
          return D8(ye, ae);
        })) {
          if (na.isTouch || _.state.isVisible && _.props.trigger.indexOf("click") >= 0)
            return;
        } else
          j("onClickOutside", [_, X]);
        _.props.hideOnClick === !0 && (_.clearDelayTimeouts(), _.hide(), a = !0, setTimeout(function() {
          a = !1;
        }), _.state.isMounted || H());
      }
    }
  }
  function q() {
    l = !0;
  }
  function F() {
    l = !1;
  }
  function B() {
    var X = O();
    X.addEventListener("mousedown", U, !0), X.addEventListener("touchend", U, Du), X.addEventListener("touchstart", F, Du), X.addEventListener("touchmove", q, Du);
  }
  function H() {
    var X = O();
    X.removeEventListener("mousedown", U, !0), X.removeEventListener("touchend", U, Du), X.removeEventListener("touchstart", F, Du), X.removeEventListener("touchmove", q, Du);
  }
  function Z(X, ae) {
    G(X, function() {
      !_.state.isVisible && x.parentNode && x.parentNode.contains(x) && ae();
    });
  }
  function W(X, ae) {
    G(X, ae);
  }
  function G(X, ae) {
    var ye = k().box;
    function De(Te) {
      Te.target === ye && (fC(ye, "remove", De), ae());
    }
    if (X === 0)
      return ae();
    fC(ye, "remove", d), fC(ye, "add", De), d = De;
  }
  function ee(X, ae, ye) {
    ye === void 0 && (ye = !1);
    var De = Af(_.props.triggerTarget || t);
    De.forEach(function(Te) {
      Te.addEventListener(X, ae, ye), h.push({
        node: Te,
        eventType: X,
        handler: ae,
        options: ye
      });
    });
  }
  function Y() {
    P() && (ee("touchstart", V, {
      passive: !0
    }), ee("touchend", ne, {
      passive: !0
    })), KTe(_.props.trigger).forEach(function(X) {
      if (X !== "manual")
        switch (ee(X, V), X) {
          case "mouseenter":
            ee("mouseleave", ne);
            break;
          case "focus":
            ee(lRe ? "focusout" : "blur", ce);
            break;
          case "focusin":
            ee("focusout", ce);
            break;
        }
    });
  }
  function L() {
    h.forEach(function(X) {
      var ae = X.node, ye = X.eventType, De = X.handler, Te = X.options;
      ae.removeEventListener(ye, De, Te);
    }), h = [];
  }
  function V(X) {
    var ae, ye = !1;
    if (!(!_.state.isEnabled || fe(X) || a)) {
      var De = ((ae = u) == null ? void 0 : ae.type) === "focus";
      u = X, m = X.currentTarget, $(), !_.state.isVisible && JTe(X) && lb.forEach(function(Te) {
        return Te(X);
      }), X.type === "click" && (_.props.trigger.indexOf("mouseenter") < 0 || s) && _.props.hideOnClick !== !1 && _.state.isVisible ? ye = !0 : Le(X), X.type === "click" && (s = !ye), ye && !De && Ce(X);
    }
  }
  function K(X) {
    var ae = X.target, ye = A().contains(ae) || x.contains(ae);
    if (!(X.type === "mousemove" && ye)) {
      var De = Me().concat(x).map(function(Te) {
        var st, ft = Te._tippy, Ht = (st = ft.popperInstance) == null ? void 0 : st.state;
        return Ht ? {
          popperRect: Te.getBoundingClientRect(),
          popperState: Ht,
          props: n
        } : null;
      }).filter(Boolean);
      rRe(De, X) && (D(), Ce(X));
    }
  }
  function ne(X) {
    var ae = fe(X) || _.props.trigger.indexOf("click") >= 0 && s;
    if (!ae) {
      if (_.props.interactive) {
        _.hideWithInteractivity(X);
        return;
      }
      Ce(X);
    }
  }
  function ce(X) {
    _.props.trigger.indexOf("focusin") < 0 && X.target !== A() || _.props.interactive && X.relatedTarget && x.contains(X.relatedTarget) || Ce(X);
  }
  function fe(X) {
    return na.isTouch ? P() !== X.type.indexOf("touch") >= 0 : !1;
  }
  function ve() {
    _e();
    var X = _.props, ae = X.popperOptions, ye = X.placement, De = X.offset, Te = X.getReferenceClientRect, st = X.moveTransition, ft = N() ? ND(x).arrow : null, Ht = Te ? {
      getBoundingClientRect: Te,
      contextElement: Te.contextElement || A()
    } : t, nn = {
      name: "$$tippy",
      enabled: !0,
      phase: "beforeWrite",
      requires: ["computeStyles"],
      fn: function(yt) {
        var oe = yt.state;
        if (N()) {
          var ge = k(), pe = ge.box;
          ["placement", "reference-hidden", "escaped"].forEach(function(He) {
            He === "placement" ? pe.setAttribute("data-placement", oe.placement) : oe.attributes.popper["data-popper-" + He] ? pe.setAttribute("data-" + He, "") : pe.removeAttribute("data-" + He);
          }), oe.attributes.popper = {};
        }
      }
    }, It = [{
      name: "offset",
      options: {
        offset: De
      }
    }, {
      name: "preventOverflow",
      options: {
        padding: {
          top: 2,
          bottom: 2,
          left: 5,
          right: 5
        }
      }
    }, {
      name: "flip",
      options: {
        padding: 5
      }
    }, {
      name: "computeStyles",
      options: {
        adaptive: !st
      }
    }, nn];
    N() && ft && It.push({
      name: "arrow",
      options: {
        element: ft,
        padding: 3
      }
    }), It.push.apply(It, ae?.modifiers || []), _.popperInstance = HTe(Ht, x, Object.assign({}, ae, {
      placement: ye,
      onFirstUpdate: f,
      modifiers: It
    }));
  }
  function _e() {
    _.popperInstance && (_.popperInstance.destroy(), _.popperInstance = null);
  }
  function Ee() {
    var X = _.props.appendTo, ae, ye = A();
    _.props.interactive && X === sae || X === "parent" ? ae = ye.parentNode : ae = aae(X, [ye]), ae.contains(x) || ae.appendChild(x), _.state.isMounted = !0, ve(), process.env.NODE_ENV !== "production" && il(_.props.interactive && X === pi.appendTo && ye.nextElementSibling !== x, ["Interactive tippy element may not be accessible via keyboard", "navigation because it is not directly after the reference element", "in the DOM source order.", `

`, "Using a wrapper <div> or <span> tag around the reference element", "solves this by creating a new parentNode context.", `

`, "Specifying `appendTo: document.body` silences this warning, but it", "assumes you are using a focus management solution to handle", "keyboard navigation.", `

`, "See: https://atomiks.github.io/tippyjs/v6/accessibility/#interactivity"].join(" "));
  }
  function Me() {
    return Kw(x.querySelectorAll("[data-tippy-root]"));
  }
  function Le(X) {
    _.clearDelayTimeouts(), X && j("onTrigger", [_, X]), B();
    var ae = T(!0), ye = R(), De = ye[0], Te = ye[1];
    na.isTouch && De === "hold" && Te && (ae = Te), ae ? r = setTimeout(function() {
      _.show();
    }, ae) : _.show();
  }
  function Ce(X) {
    if (_.clearDelayTimeouts(), j("onUntrigger", [_, X]), !_.state.isVisible) {
      H();
      return;
    }
    if (!(_.props.trigger.indexOf("mouseenter") >= 0 && _.props.trigger.indexOf("click") >= 0 && ["mouseleave", "mousemove"].indexOf(X.type) >= 0 && s)) {
      var ae = T(!1);
      ae ? o = setTimeout(function() {
        _.state.isVisible && _.hide();
      }, ae) : i = requestAnimationFrame(function() {
        _.hide();
      });
    }
  }
  function Je() {
    _.state.isEnabled = !0;
  }
  function Ie() {
    _.hide(), _.state.isEnabled = !1;
  }
  function nt() {
    clearTimeout(r), clearTimeout(o), cancelAnimationFrame(i);
  }
  function ct(X) {
    if (process.env.NODE_ENV !== "production" && il(_.state.isDestroyed, pf("setProps")), !_.state.isDestroyed) {
      j("onBeforeUpdate", [_, X]), L();
      var ae = _.props, ye = j8(t, Object.assign({}, ae, $8(X), {
        ignoreAttributes: !0
      }));
      _.props = ye, Y(), ae.interactiveDebounce !== ye.interactiveDebounce && (D(), p = R8(K, ye.interactiveDebounce)), ae.triggerTarget && !ye.triggerTarget ? Af(ae.triggerTarget).forEach(function(De) {
        De.removeAttribute("aria-expanded");
      }) : ye.triggerTarget && t.removeAttribute("aria-expanded"), $(), I(), E && E(ae, ye), _.popperInstance && (ve(), Me().forEach(function(De) {
        requestAnimationFrame(De._tippy.popperInstance.forceUpdate);
      })), j("onAfterUpdate", [_, X]);
    }
  }
  function mt(X) {
    _.setProps({
      content: X
    });
  }
  function gt() {
    process.env.NODE_ENV !== "production" && il(_.state.isDestroyed, pf("show"));
    var X = _.state.isVisible, ae = _.state.isDestroyed, ye = !_.state.isEnabled, De = na.isTouch && !_.props.touch, Te = uC(_.props.duration, 0, pi.duration);
    if (!(X || ae || ye || De) && !A().hasAttribute("disabled") && (j("onShow", [_], !1), _.props.onShow(_) !== !1)) {
      if (_.state.isVisible = !0, N() && (x.style.visibility = "visible"), I(), B(), _.state.isMounted || (x.style.transition = "none"), N()) {
        var st = k(), ft = st.box, Ht = st.content;
        dC([ft, Ht], 0);
      }
      f = function() {
        var It;
        if (!(!_.state.isVisible || c)) {
          if (c = !0, x.offsetHeight, x.style.transition = _.props.moveTransition, N() && _.props.animation) {
            var Rn = k(), yt = Rn.box, oe = Rn.content;
            dC([yt, oe], Te), M8([yt, oe], "visible");
          }
          z(), $(), P8(hC, _), (It = _.popperInstance) == null || It.forceUpdate(), j("onMount", [_]), _.props.animation && N() && W(Te, function() {
            _.state.isShown = !0, j("onShown", [_]);
          });
        }
      }, Ee();
    }
  }
  function Et() {
    process.env.NODE_ENV !== "production" && il(_.state.isDestroyed, pf("hide"));
    var X = !_.state.isVisible, ae = _.state.isDestroyed, ye = !_.state.isEnabled, De = uC(_.props.duration, 1, pi.duration);
    if (!(X || ae || ye) && (j("onHide", [_], !1), _.props.onHide(_) !== !1)) {
      if (_.state.isVisible = !1, _.state.isShown = !1, c = !1, s = !1, N() && (x.style.visibility = "hidden"), D(), H(), I(!0), N()) {
        var Te = k(), st = Te.box, ft = Te.content;
        _.props.animation && (dC([st, ft], De), M8([st, ft], "hidden"));
      }
      z(), $(), _.props.animation ? N() && Z(De, _.unmount) : _.unmount();
    }
  }
  function Rt(X) {
    process.env.NODE_ENV !== "production" && il(_.state.isDestroyed, pf("hideWithInteractivity")), O().addEventListener("mousemove", p), P8(lb, p), p(X);
  }
  function zt() {
    process.env.NODE_ENV !== "production" && il(_.state.isDestroyed, pf("unmount")), _.state.isVisible && _.hide(), _.state.isMounted && (_e(), Me().forEach(function(X) {
      X._tippy.unmount();
    }), x.parentNode && x.parentNode.removeChild(x), hC = hC.filter(function(X) {
      return X !== _;
    }), _.state.isMounted = !1, j("onHidden", [_]));
  }
  function At() {
    process.env.NODE_ENV !== "production" && il(_.state.isDestroyed, pf("destroy")), !_.state.isDestroyed && (_.clearDelayTimeouts(), _.unmount(), L(), delete t._tippy, _.state.isDestroyed = !0, j("onDestroy", [_]));
  }
}
function Qy(t, e) {
  e === void 0 && (e = {});
  var n = pi.plugins.concat(e.plugins || []);
  process.env.NODE_ENV !== "production" && (dRe(t), fae(e, n)), sRe();
  var r = Object.assign({}, e, {
    plugins: n
  }), o = tRe(t);
  if (process.env.NODE_ENV !== "production") {
    var i = k0(r.content), s = o.length > 1;
    il(i && s, ["tippy() was passed an Element as the `content` prop, but more than", "one tippy instance was created by this invocation. This means the", "content element will only be appended to the last tippy instance.", `

`, "Instead, pass the .innerHTML of the element, or use a function that", "returns a cloned version of the element instead.", `

`, `1) content: element.innerHTML
`, "2) content: () => element.cloneNode(true)"].join(" "));
  }
  var a = o.reduce(function(l, c) {
    var u = c && vRe(c, r);
    return u && l.push(u), l;
  }, []);
  return k0(t) ? a[0] : a;
}
Qy.defaultProps = pi;
Qy.setDefaultProps = pRe;
Qy.currentInput = na;
Object.assign({}, Kse, {
  effect: function(e) {
    var n = e.state, r = {
      popper: {
        position: n.options.strategy,
        left: "0",
        top: "0",
        margin: "0"
      },
      arrow: {
        position: "absolute"
      },
      reference: {}
    };
    Object.assign(n.elements.popper.style, r.popper), n.styles = r, n.elements.arrow && Object.assign(n.elements.arrow.style, r.arrow);
  }
});
Qy.setDefaultProps({
  render: hae
});
function pae(t, e) {
  if (t == null) return {};
  var n = {}, r = Object.keys(t), o, i;
  for (i = 0; i < r.length; i++)
    o = r[i], !(e.indexOf(o) >= 0) && (n[o] = t[o]);
  return n;
}
var mae = typeof window < "u" && typeof document < "u";
function jD(t, e) {
  t && (typeof t == "function" && t(e), {}.hasOwnProperty.call(t, "current") && (t.current = e));
}
function B8() {
  return mae && document.createElement("div");
}
function bRe(t) {
  var e = {
    "data-placement": t.placement
  };
  return t.referenceHidden && (e["data-reference-hidden"] = ""), t.escaped && (e["data-escaped"] = ""), e;
}
function gae(t, e) {
  if (t === e)
    return !0;
  if (typeof t == "object" && t != null && typeof e == "object" && e != null) {
    if (Object.keys(t).length !== Object.keys(e).length)
      return !1;
    for (var n in t)
      if (e.hasOwnProperty(n)) {
        if (!gae(t[n], e[n]))
          return !1;
      } else
        return !1;
    return !0;
  } else
    return !1;
}
function _Re(t) {
  var e = [];
  return t.forEach(function(n) {
    e.find(function(r) {
      return gae(n, r);
    }) || e.push(n);
  }), e;
}
function wRe(t, e) {
  var n, r;
  return Object.assign({}, e, {
    popperOptions: Object.assign({}, t.popperOptions, e.popperOptions, {
      modifiers: _Re([].concat(((n = t.popperOptions) == null ? void 0 : n.modifiers) || [], ((r = e.popperOptions) == null ? void 0 : r.modifiers) || []))
    })
  });
}
var pC = mae ? iu : Ne;
function xRe(t) {
  var e = Ue();
  return e.current || (e.current = typeof t == "function" ? t() : t), e.current;
}
function z8(t, e, n) {
  n.split(/\s+/).forEach(function(r) {
    r && t.classList[e](r);
  });
}
var ERe = {
  name: "className",
  defaultValue: "",
  fn: function(e) {
    var n = e.popper.firstElementChild, r = function() {
      var a;
      return !!((a = e.props.render) != null && a.$$tippy);
    };
    function o() {
      if (e.props.className && !r()) {
        process.env.NODE_ENV !== "production" && console.warn(["@tippyjs/react: Cannot use `className` prop in conjunction with", "`render` prop. Place the className on the element you are", "rendering."].join(" "));
        return;
      }
      z8(n, "add", e.props.className);
    }
    function i() {
      r() && z8(n, "remove", e.props.className);
    }
    return {
      onCreate: o,
      onBeforeUpdate: i,
      onAfterUpdate: o
    };
  }
};
function SRe(t) {
  function e(n) {
    var r = n.children, o = n.content, i = n.visible, s = n.singleton, a = n.render, l = n.reference, c = n.disabled, u = c === void 0 ? !1 : c, d = n.ignoreAttributes, f = d === void 0 ? !0 : d;
    n.__source, n.__self;
    var h = pae(n, ["children", "content", "visible", "singleton", "render", "reference", "disabled", "ignoreAttributes", "__source", "__self"]), p = i !== void 0, m = s !== void 0, g = Ye(!1), y = g[0], v = g[1], b = Ye({}), _ = b[0], w = b[1], x = Ye(), E = x[0], S = x[1], C = xRe(function() {
      return {
        container: B8(),
        renders: 1
      };
    }), R = Object.assign({
      ignoreAttributes: f
    }, h, {
      content: C.container
    });
    p && (process.env.NODE_ENV !== "production" && ["trigger", "hideOnClick", "showOnCreate"].forEach(function(O) {
      R[O] !== void 0 && console.warn(["@tippyjs/react: Cannot specify `" + O + "` prop in", "controlled mode (`visible` prop)"].join(" "));
    }), R.trigger = "manual", R.hideOnClick = !1), m && (u = !0);
    var P = R, N = R.plugins || [];
    a && (P = Object.assign({}, R, {
      plugins: m && s.data != null ? [].concat(N, [{
        fn: function() {
          return {
            onTrigger: function(T, I) {
              var j = s.data.children.find(function(z) {
                var $ = z.instance;
                return $.reference === I.currentTarget;
              });
              T.state.$$activeSingletonInstance = j.instance, S(j.content);
            }
          };
        }
      }]) : N,
      render: function() {
        return {
          popper: C.container
        };
      }
    }));
    var A = [l].concat(r ? [r.type] : []);
    return pC(function() {
      var O = l;
      l && l.hasOwnProperty("current") && (O = l.current);
      var k = t(O || C.ref || B8(), Object.assign({}, P, {
        plugins: [ERe].concat(R.plugins || [])
      }));
      return C.instance = k, u && k.disable(), i && k.show(), m && s.hook({
        instance: k,
        content: o,
        props: P,
        setSingletonContent: S
      }), v(!0), function() {
        k.destroy(), s?.cleanup(k);
      };
    }, A), pC(function() {
      var O;
      if (C.renders === 1) {
        C.renders++;
        return;
      }
      var k = C.instance;
      k.setProps(wRe(k.props, P)), (O = k.popperInstance) == null || O.forceUpdate(), u ? k.disable() : k.enable(), p && (i ? k.show() : k.hide()), m && s.hook({
        instance: k,
        content: o,
        props: P,
        setSingletonContent: S
      });
    }), pC(function() {
      var O;
      if (a) {
        var k = C.instance;
        k.setProps({
          popperOptions: Object.assign({}, k.props.popperOptions, {
            modifiers: [].concat((((O = k.props.popperOptions) == null ? void 0 : O.modifiers) || []).filter(function(T) {
              var I = T.name;
              return I !== "$$tippyReact";
            }), [{
              name: "$$tippyReact",
              enabled: !0,
              phase: "beforeWrite",
              requires: ["computeStyles"],
              fn: function(I) {
                var j, z = I.state, $ = (j = z.modifiersData) == null ? void 0 : j.hide;
                (_.placement !== z.placement || _.referenceHidden !== $?.isReferenceHidden || _.escaped !== $?.hasPopperEscaped) && w({
                  placement: z.placement,
                  referenceHidden: $?.isReferenceHidden,
                  escaped: $?.hasPopperEscaped
                }), z.attributes.popper = {};
              }
            }])
          })
        });
      }
    }, [_.placement, _.referenceHidden, _.escaped].concat(A)), /* @__PURE__ */ xe.createElement(xe.Fragment, null, r ? /* @__PURE__ */ Gi(r, {
      ref: function(k) {
        C.ref = k, jD(r.ref, k);
      }
    }) : null, y && /* @__PURE__ */ XE(a ? a(bRe(_), E, C.instance) : o, C.container));
  }
  return e;
}
var ORe = function(t, e) {
  return /* @__PURE__ */ Ri(function(r, o) {
    var i = r.children, s = pae(r, ["children"]);
    return (
      // If I spread them separately here, Babel adds the _extends ponyfill for
      // some reason
      /* @__PURE__ */ xe.createElement(t, Object.assign({}, e, s), i ? /* @__PURE__ */ Gi(i, {
        ref: function(l) {
          jD(o, l), jD(i.ref, l);
        }
      }) : null)
    );
  });
}, eIt = /* @__PURE__ */ ORe(/* @__PURE__ */ SRe(Qy)), L_ = { exports: {} }, CRe = L_.exports, q8;
function kRe() {
  return q8 || (q8 = 1, function(t, e) {
    (function(n, r) {
      t.exports = r();
    })(CRe, function() {
      var n = 1e3, r = 6e4, o = 36e5, i = "millisecond", s = "second", a = "minute", l = "hour", c = "day", u = "week", d = "month", f = "quarter", h = "year", p = "date", m = "Invalid Date", g = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, v = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(O) {
        var k = ["th", "st", "nd", "rd"], T = O % 100;
        return "[" + O + (k[(T - 20) % 10] || k[T] || k[0]) + "]";
      } }, b = function(O, k, T) {
        var I = String(O);
        return !I || I.length >= k ? O : "" + Array(k + 1 - I.length).join(T) + O;
      }, _ = { s: b, z: function(O) {
        var k = -O.utcOffset(), T = Math.abs(k), I = Math.floor(T / 60), j = T % 60;
        return (k <= 0 ? "+" : "-") + b(I, 2, "0") + ":" + b(j, 2, "0");
      }, m: function O(k, T) {
        if (k.date() < T.date()) return -O(T, k);
        var I = 12 * (T.year() - k.year()) + (T.month() - k.month()), j = k.clone().add(I, d), z = T - j < 0, $ = k.clone().add(I + (z ? -1 : 1), d);
        return +(-(I + (T - j) / (z ? j - $ : $ - j)) || 0);
      }, a: function(O) {
        return O < 0 ? Math.ceil(O) || 0 : Math.floor(O);
      }, p: function(O) {
        return { M: d, y: h, w: u, d: c, D: p, h: l, m: a, s, ms: i, Q: f }[O] || String(O || "").toLowerCase().replace(/s$/, "");
      }, u: function(O) {
        return O === void 0;
      } }, w = "en", x = {};
      x[w] = v;
      var E = "$isDayjsObject", S = function(O) {
        return O instanceof N || !(!O || !O[E]);
      }, C = function O(k, T, I) {
        var j;
        if (!k) return w;
        if (typeof k == "string") {
          var z = k.toLowerCase();
          x[z] && (j = z), T && (x[z] = T, j = z);
          var $ = k.split("-");
          if (!j && $.length > 1) return O($[0]);
        } else {
          var D = k.name;
          x[D] = k, j = D;
        }
        return !I && j && (w = j), j || !I && w;
      }, R = function(O, k) {
        if (S(O)) return O.clone();
        var T = typeof k == "object" ? k : {};
        return T.date = O, T.args = arguments, new N(T);
      }, P = _;
      P.l = C, P.i = S, P.w = function(O, k) {
        return R(O, { locale: k.$L, utc: k.$u, x: k.$x, $offset: k.$offset });
      };
      var N = function() {
        function O(T) {
          this.$L = C(T.locale, null, !0), this.parse(T), this.$x = this.$x || T.x || {}, this[E] = !0;
        }
        var k = O.prototype;
        return k.parse = function(T) {
          this.$d = function(I) {
            var j = I.date, z = I.utc;
            if (j === null) return /* @__PURE__ */ new Date(NaN);
            if (P.u(j)) return /* @__PURE__ */ new Date();
            if (j instanceof Date) return new Date(j);
            if (typeof j == "string" && !/Z$/i.test(j)) {
              var $ = j.match(g);
              if ($) {
                var D = $[2] - 1 || 0, U = ($[7] || "0").substring(0, 3);
                return z ? new Date(Date.UTC($[1], D, $[3] || 1, $[4] || 0, $[5] || 0, $[6] || 0, U)) : new Date($[1], D, $[3] || 1, $[4] || 0, $[5] || 0, $[6] || 0, U);
              }
            }
            return new Date(j);
          }(T), this.init();
        }, k.init = function() {
          var T = this.$d;
          this.$y = T.getFullYear(), this.$M = T.getMonth(), this.$D = T.getDate(), this.$W = T.getDay(), this.$H = T.getHours(), this.$m = T.getMinutes(), this.$s = T.getSeconds(), this.$ms = T.getMilliseconds();
        }, k.$utils = function() {
          return P;
        }, k.isValid = function() {
          return this.$d.toString() !== m;
        }, k.isSame = function(T, I) {
          var j = R(T);
          return this.startOf(I) <= j && j <= this.endOf(I);
        }, k.isAfter = function(T, I) {
          return R(T) < this.startOf(I);
        }, k.isBefore = function(T, I) {
          return this.endOf(I) < R(T);
        }, k.$g = function(T, I, j) {
          return P.u(T) ? this[I] : this.set(j, T);
        }, k.unix = function() {
          return Math.floor(this.valueOf() / 1e3);
        }, k.valueOf = function() {
          return this.$d.getTime();
        }, k.startOf = function(T, I) {
          var j = this, z = !!P.u(I) || I, $ = P.p(T), D = function(G, ee) {
            var Y = P.w(j.$u ? Date.UTC(j.$y, ee, G) : new Date(j.$y, ee, G), j);
            return z ? Y : Y.endOf(c);
          }, U = function(G, ee) {
            return P.w(j.toDate()[G].apply(j.toDate("s"), (z ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(ee)), j);
          }, q = this.$W, F = this.$M, B = this.$D, H = "set" + (this.$u ? "UTC" : "");
          switch ($) {
            case h:
              return z ? D(1, 0) : D(31, 11);
            case d:
              return z ? D(1, F) : D(0, F + 1);
            case u:
              var Z = this.$locale().weekStart || 0, W = (q < Z ? q + 7 : q) - Z;
              return D(z ? B - W : B + (6 - W), F);
            case c:
            case p:
              return U(H + "Hours", 0);
            case l:
              return U(H + "Minutes", 1);
            case a:
              return U(H + "Seconds", 2);
            case s:
              return U(H + "Milliseconds", 3);
            default:
              return this.clone();
          }
        }, k.endOf = function(T) {
          return this.startOf(T, !1);
        }, k.$set = function(T, I) {
          var j, z = P.p(T), $ = "set" + (this.$u ? "UTC" : ""), D = (j = {}, j[c] = $ + "Date", j[p] = $ + "Date", j[d] = $ + "Month", j[h] = $ + "FullYear", j[l] = $ + "Hours", j[a] = $ + "Minutes", j[s] = $ + "Seconds", j[i] = $ + "Milliseconds", j)[z], U = z === c ? this.$D + (I - this.$W) : I;
          if (z === d || z === h) {
            var q = this.clone().set(p, 1);
            q.$d[D](U), q.init(), this.$d = q.set(p, Math.min(this.$D, q.daysInMonth())).$d;
          } else D && this.$d[D](U);
          return this.init(), this;
        }, k.set = function(T, I) {
          return this.clone().$set(T, I);
        }, k.get = function(T) {
          return this[P.p(T)]();
        }, k.add = function(T, I) {
          var j, z = this;
          T = Number(T);
          var $ = P.p(I), D = function(F) {
            var B = R(z);
            return P.w(B.date(B.date() + Math.round(F * T)), z);
          };
          if ($ === d) return this.set(d, this.$M + T);
          if ($ === h) return this.set(h, this.$y + T);
          if ($ === c) return D(1);
          if ($ === u) return D(7);
          var U = (j = {}, j[a] = r, j[l] = o, j[s] = n, j)[$] || 1, q = this.$d.getTime() + T * U;
          return P.w(q, this);
        }, k.subtract = function(T, I) {
          return this.add(-1 * T, I);
        }, k.format = function(T) {
          var I = this, j = this.$locale();
          if (!this.isValid()) return j.invalidDate || m;
          var z = T || "YYYY-MM-DDTHH:mm:ssZ", $ = P.z(this), D = this.$H, U = this.$m, q = this.$M, F = j.weekdays, B = j.months, H = j.meridiem, Z = function(ee, Y, L, V) {
            return ee && (ee[Y] || ee(I, z)) || L[Y].slice(0, V);
          }, W = function(ee) {
            return P.s(D % 12 || 12, ee, "0");
          }, G = H || function(ee, Y, L) {
            var V = ee < 12 ? "AM" : "PM";
            return L ? V.toLowerCase() : V;
          };
          return z.replace(y, function(ee, Y) {
            return Y || function(L) {
              switch (L) {
                case "YY":
                  return String(I.$y).slice(-2);
                case "YYYY":
                  return P.s(I.$y, 4, "0");
                case "M":
                  return q + 1;
                case "MM":
                  return P.s(q + 1, 2, "0");
                case "MMM":
                  return Z(j.monthsShort, q, B, 3);
                case "MMMM":
                  return Z(B, q);
                case "D":
                  return I.$D;
                case "DD":
                  return P.s(I.$D, 2, "0");
                case "d":
                  return String(I.$W);
                case "dd":
                  return Z(j.weekdaysMin, I.$W, F, 2);
                case "ddd":
                  return Z(j.weekdaysShort, I.$W, F, 3);
                case "dddd":
                  return F[I.$W];
                case "H":
                  return String(D);
                case "HH":
                  return P.s(D, 2, "0");
                case "h":
                  return W(1);
                case "hh":
                  return W(2);
                case "a":
                  return G(D, U, !0);
                case "A":
                  return G(D, U, !1);
                case "m":
                  return String(U);
                case "mm":
                  return P.s(U, 2, "0");
                case "s":
                  return String(I.$s);
                case "ss":
                  return P.s(I.$s, 2, "0");
                case "SSS":
                  return P.s(I.$ms, 3, "0");
                case "Z":
                  return $;
              }
              return null;
            }(ee) || $.replace(":", "");
          });
        }, k.utcOffset = function() {
          return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, k.diff = function(T, I, j) {
          var z, $ = this, D = P.p(I), U = R(T), q = (U.utcOffset() - this.utcOffset()) * r, F = this - U, B = function() {
            return P.m($, U);
          };
          switch (D) {
            case h:
              z = B() / 12;
              break;
            case d:
              z = B();
              break;
            case f:
              z = B() / 3;
              break;
            case u:
              z = (F - q) / 6048e5;
              break;
            case c:
              z = (F - q) / 864e5;
              break;
            case l:
              z = F / o;
              break;
            case a:
              z = F / r;
              break;
            case s:
              z = F / n;
              break;
            default:
              z = F;
          }
          return j ? z : P.a(z);
        }, k.daysInMonth = function() {
          return this.endOf(d).$D;
        }, k.$locale = function() {
          return x[this.$L];
        }, k.locale = function(T, I) {
          if (!T) return this.$L;
          var j = this.clone(), z = C(T, I, !0);
          return z && (j.$L = z), j;
        }, k.clone = function() {
          return P.w(this.$d, this);
        }, k.toDate = function() {
          return new Date(this.valueOf());
        }, k.toJSON = function() {
          return this.isValid() ? this.toISOString() : null;
        }, k.toISOString = function() {
          return this.$d.toISOString();
        }, k.toString = function() {
          return this.$d.toUTCString();
        }, O;
      }(), A = N.prototype;
      return R.prototype = A, [["$ms", i], ["$s", s], ["$m", a], ["$H", l], ["$W", c], ["$M", d], ["$y", h], ["$D", p]].forEach(function(O) {
        A[O[1]] = function(k) {
          return this.$g(k, O[0], O[1]);
        };
      }), R.extend = function(O, k) {
        return O.$i || (O(k, N, R), O.$i = !0), R;
      }, R.locale = C, R.isDayjs = S, R.unix = function(O) {
        return R(1e3 * O);
      }, R.en = x[w], R.Ls = x, R.p = {}, R;
    });
  }(L_)), L_.exports;
}
var ARe = kRe();
const tIt = /* @__PURE__ */ Kt(ARe);
var F_ = { exports: {} }, TRe = F_.exports, U8;
function RRe() {
  return U8 || (U8 = 1, function(t, e) {
    (function(n, r) {
      t.exports = r();
    })(TRe, function() {
      var n = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" }, r = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|Q|YYYY|YY?|ww?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, o = /\d/, i = /\d\d/, s = /\d\d?/, a = /\d*[^-_:/,()\s\d]+/, l = {}, c = function(g) {
        return (g = +g) + (g > 68 ? 1900 : 2e3);
      }, u = function(g) {
        return function(y) {
          this[g] = +y;
        };
      }, d = [/[+-]\d\d:?(\d\d)?|Z/, function(g) {
        (this.zone || (this.zone = {})).offset = function(y) {
          if (!y || y === "Z") return 0;
          var v = y.match(/([+-]|\d\d)/g), b = 60 * v[1] + (+v[2] || 0);
          return b === 0 ? 0 : v[0] === "+" ? -b : b;
        }(g);
      }], f = function(g) {
        var y = l[g];
        return y && (y.indexOf ? y : y.s.concat(y.f));
      }, h = function(g, y) {
        var v, b = l.meridiem;
        if (b) {
          for (var _ = 1; _ <= 24; _ += 1) if (g.indexOf(b(_, 0, y)) > -1) {
            v = _ > 12;
            break;
          }
        } else v = g === (y ? "pm" : "PM");
        return v;
      }, p = { A: [a, function(g) {
        this.afternoon = h(g, !1);
      }], a: [a, function(g) {
        this.afternoon = h(g, !0);
      }], Q: [o, function(g) {
        this.month = 3 * (g - 1) + 1;
      }], S: [o, function(g) {
        this.milliseconds = 100 * +g;
      }], SS: [i, function(g) {
        this.milliseconds = 10 * +g;
      }], SSS: [/\d{3}/, function(g) {
        this.milliseconds = +g;
      }], s: [s, u("seconds")], ss: [s, u("seconds")], m: [s, u("minutes")], mm: [s, u("minutes")], H: [s, u("hours")], h: [s, u("hours")], HH: [s, u("hours")], hh: [s, u("hours")], D: [s, u("day")], DD: [i, u("day")], Do: [a, function(g) {
        var y = l.ordinal, v = g.match(/\d+/);
        if (this.day = v[0], y) for (var b = 1; b <= 31; b += 1) y(b).replace(/\[|\]/g, "") === g && (this.day = b);
      }], w: [s, u("week")], ww: [i, u("week")], M: [s, u("month")], MM: [i, u("month")], MMM: [a, function(g) {
        var y = f("months"), v = (f("monthsShort") || y.map(function(b) {
          return b.slice(0, 3);
        })).indexOf(g) + 1;
        if (v < 1) throw new Error();
        this.month = v % 12 || v;
      }], MMMM: [a, function(g) {
        var y = f("months").indexOf(g) + 1;
        if (y < 1) throw new Error();
        this.month = y % 12 || y;
      }], Y: [/[+-]?\d+/, u("year")], YY: [i, function(g) {
        this.year = c(g);
      }], YYYY: [/\d{4}/, u("year")], Z: d, ZZ: d };
      function m(g) {
        var y, v;
        y = g, v = l && l.formats;
        for (var b = (g = y.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(R, P, N) {
          var A = N && N.toUpperCase();
          return P || v[N] || n[N] || v[A].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(O, k, T) {
            return k || T.slice(1);
          });
        })).match(r), _ = b.length, w = 0; w < _; w += 1) {
          var x = b[w], E = p[x], S = E && E[0], C = E && E[1];
          b[w] = C ? { regex: S, parser: C } : x.replace(/^\[|\]$/g, "");
        }
        return function(R) {
          for (var P = {}, N = 0, A = 0; N < _; N += 1) {
            var O = b[N];
            if (typeof O == "string") A += O.length;
            else {
              var k = O.regex, T = O.parser, I = R.slice(A), j = k.exec(I)[0];
              T.call(P, j), R = R.replace(j, "");
            }
          }
          return function(z) {
            var $ = z.afternoon;
            if ($ !== void 0) {
              var D = z.hours;
              $ ? D < 12 && (z.hours += 12) : D === 12 && (z.hours = 0), delete z.afternoon;
            }
          }(P), P;
        };
      }
      return function(g, y, v) {
        v.p.customParseFormat = !0, g && g.parseTwoDigitYear && (c = g.parseTwoDigitYear);
        var b = y.prototype, _ = b.parse;
        b.parse = function(w) {
          var x = w.date, E = w.utc, S = w.args;
          this.$u = E;
          var C = S[1];
          if (typeof C == "string") {
            var R = S[2] === !0, P = S[3] === !0, N = R || P, A = S[2];
            P && (A = S[2]), l = this.$locale(), !R && A && (l = v.Ls[A]), this.$d = function(I, j, z, $) {
              try {
                if (["x", "X"].indexOf(j) > -1) return new Date((j === "X" ? 1e3 : 1) * I);
                var D = m(j)(I), U = D.year, q = D.month, F = D.day, B = D.hours, H = D.minutes, Z = D.seconds, W = D.milliseconds, G = D.zone, ee = D.week, Y = /* @__PURE__ */ new Date(), L = F || (U || q ? 1 : Y.getDate()), V = U || Y.getFullYear(), K = 0;
                U && !q || (K = q > 0 ? q - 1 : Y.getMonth());
                var ne, ce = B || 0, fe = H || 0, ve = Z || 0, _e = W || 0;
                return G ? new Date(Date.UTC(V, K, L, ce, fe, ve, _e + 60 * G.offset * 1e3)) : z ? new Date(Date.UTC(V, K, L, ce, fe, ve, _e)) : (ne = new Date(V, K, L, ce, fe, ve, _e), ee && (ne = $(ne).week(ee).toDate()), ne);
              } catch {
                return /* @__PURE__ */ new Date("");
              }
            }(x, C, E, v), this.init(), A && A !== !0 && (this.$L = this.locale(A).$L), N && x != this.format(C) && (this.$d = /* @__PURE__ */ new Date("")), l = {};
          } else if (C instanceof Array) for (var O = C.length, k = 1; k <= O; k += 1) {
            S[1] = C[k - 1];
            var T = v.apply(this, S);
            if (T.isValid()) {
              this.$d = T.$d, this.$L = T.$L, this.init();
              break;
            }
            k === O && (this.$d = /* @__PURE__ */ new Date(""));
          }
          else _.call(this, w);
        };
      };
    });
  }(F_)), F_.exports;
}
var PRe = RRe();
const nIt = /* @__PURE__ */ Kt(PRe);
var B_ = { exports: {} }, $Re = B_.exports, H8;
function MRe() {
  return H8 || (H8 = 1, function(t, e) {
    (function(n, r) {
      t.exports = r();
    })($Re, function() {
      var n, r, o = 1e3, i = 6e4, s = 36e5, a = 864e5, l = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, c = 31536e6, u = 2628e6, d = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/, f = { years: c, months: u, days: a, hours: s, minutes: i, seconds: o, milliseconds: 1, weeks: 6048e5 }, h = function(x) {
        return x instanceof _;
      }, p = function(x, E, S) {
        return new _(x, S, E.$l);
      }, m = function(x) {
        return r.p(x) + "s";
      }, g = function(x) {
        return x < 0;
      }, y = function(x) {
        return g(x) ? Math.ceil(x) : Math.floor(x);
      }, v = function(x) {
        return Math.abs(x);
      }, b = function(x, E) {
        return x ? g(x) ? { negative: !0, format: "" + v(x) + E } : { negative: !1, format: "" + x + E } : { negative: !1, format: "" };
      }, _ = function() {
        function x(S, C, R) {
          var P = this;
          if (this.$d = {}, this.$l = R, S === void 0 && (this.$ms = 0, this.parseFromMilliseconds()), C) return p(S * f[m(C)], this);
          if (typeof S == "number") return this.$ms = S, this.parseFromMilliseconds(), this;
          if (typeof S == "object") return Object.keys(S).forEach(function(O) {
            P.$d[m(O)] = S[O];
          }), this.calMilliseconds(), this;
          if (typeof S == "string") {
            var N = S.match(d);
            if (N) {
              var A = N.slice(2).map(function(O) {
                return O != null ? Number(O) : 0;
              });
              return this.$d.years = A[0], this.$d.months = A[1], this.$d.weeks = A[2], this.$d.days = A[3], this.$d.hours = A[4], this.$d.minutes = A[5], this.$d.seconds = A[6], this.calMilliseconds(), this;
            }
          }
          return this;
        }
        var E = x.prototype;
        return E.calMilliseconds = function() {
          var S = this;
          this.$ms = Object.keys(this.$d).reduce(function(C, R) {
            return C + (S.$d[R] || 0) * f[R];
          }, 0);
        }, E.parseFromMilliseconds = function() {
          var S = this.$ms;
          this.$d.years = y(S / c), S %= c, this.$d.months = y(S / u), S %= u, this.$d.days = y(S / a), S %= a, this.$d.hours = y(S / s), S %= s, this.$d.minutes = y(S / i), S %= i, this.$d.seconds = y(S / o), S %= o, this.$d.milliseconds = S;
        }, E.toISOString = function() {
          var S = b(this.$d.years, "Y"), C = b(this.$d.months, "M"), R = +this.$d.days || 0;
          this.$d.weeks && (R += 7 * this.$d.weeks);
          var P = b(R, "D"), N = b(this.$d.hours, "H"), A = b(this.$d.minutes, "M"), O = this.$d.seconds || 0;
          this.$d.milliseconds && (O += this.$d.milliseconds / 1e3, O = Math.round(1e3 * O) / 1e3);
          var k = b(O, "S"), T = S.negative || C.negative || P.negative || N.negative || A.negative || k.negative, I = N.format || A.format || k.format ? "T" : "", j = (T ? "-" : "") + "P" + S.format + C.format + P.format + I + N.format + A.format + k.format;
          return j === "P" || j === "-P" ? "P0D" : j;
        }, E.toJSON = function() {
          return this.toISOString();
        }, E.format = function(S) {
          var C = S || "YYYY-MM-DDTHH:mm:ss", R = { Y: this.$d.years, YY: r.s(this.$d.years, 2, "0"), YYYY: r.s(this.$d.years, 4, "0"), M: this.$d.months, MM: r.s(this.$d.months, 2, "0"), D: this.$d.days, DD: r.s(this.$d.days, 2, "0"), H: this.$d.hours, HH: r.s(this.$d.hours, 2, "0"), m: this.$d.minutes, mm: r.s(this.$d.minutes, 2, "0"), s: this.$d.seconds, ss: r.s(this.$d.seconds, 2, "0"), SSS: r.s(this.$d.milliseconds, 3, "0") };
          return C.replace(l, function(P, N) {
            return N || String(R[P]);
          });
        }, E.as = function(S) {
          return this.$ms / f[m(S)];
        }, E.get = function(S) {
          var C = this.$ms, R = m(S);
          return R === "milliseconds" ? C %= 1e3 : C = R === "weeks" ? y(C / f[R]) : this.$d[R], C || 0;
        }, E.add = function(S, C, R) {
          var P;
          return P = C ? S * f[m(C)] : h(S) ? S.$ms : p(S, this).$ms, p(this.$ms + P * (R ? -1 : 1), this);
        }, E.subtract = function(S, C) {
          return this.add(S, C, !0);
        }, E.locale = function(S) {
          var C = this.clone();
          return C.$l = S, C;
        }, E.clone = function() {
          return p(this.$ms, this);
        }, E.humanize = function(S) {
          return n().add(this.$ms, "ms").locale(this.$l).fromNow(!S);
        }, E.valueOf = function() {
          return this.asMilliseconds();
        }, E.milliseconds = function() {
          return this.get("milliseconds");
        }, E.asMilliseconds = function() {
          return this.as("milliseconds");
        }, E.seconds = function() {
          return this.get("seconds");
        }, E.asSeconds = function() {
          return this.as("seconds");
        }, E.minutes = function() {
          return this.get("minutes");
        }, E.asMinutes = function() {
          return this.as("minutes");
        }, E.hours = function() {
          return this.get("hours");
        }, E.asHours = function() {
          return this.as("hours");
        }, E.days = function() {
          return this.get("days");
        }, E.asDays = function() {
          return this.as("days");
        }, E.weeks = function() {
          return this.get("weeks");
        }, E.asWeeks = function() {
          return this.as("weeks");
        }, E.months = function() {
          return this.get("months");
        }, E.asMonths = function() {
          return this.as("months");
        }, E.years = function() {
          return this.get("years");
        }, E.asYears = function() {
          return this.as("years");
        }, x;
      }(), w = function(x, E, S) {
        return x.add(E.years() * S, "y").add(E.months() * S, "M").add(E.days() * S, "d").add(E.hours() * S, "h").add(E.minutes() * S, "m").add(E.seconds() * S, "s").add(E.milliseconds() * S, "ms");
      };
      return function(x, E, S) {
        n = S, r = S().$utils(), S.duration = function(P, N) {
          var A = S.locale();
          return p(P, { $l: A }, N);
        }, S.isDuration = h;
        var C = E.prototype.add, R = E.prototype.subtract;
        E.prototype.add = function(P, N) {
          return h(P) ? w(this, P, 1) : C.bind(this)(P, N);
        }, E.prototype.subtract = function(P, N) {
          return h(P) ? w(this, P, -1) : R.bind(this)(P, N);
        };
      };
    });
  }(B_)), B_.exports;
}
var DRe = MRe();
const rIt = /* @__PURE__ */ Kt(DRe);
var z_ = { exports: {} }, IRe = z_.exports, V8;
function NRe() {
  return V8 || (V8 = 1, function(t, e) {
    (function(n, r) {
      t.exports = r();
    })(IRe, function() {
      return function(n, r, o) {
        n = n || {};
        var i = r.prototype, s = { future: "in %s", past: "%s ago", s: "a few seconds", m: "a minute", mm: "%d minutes", h: "an hour", hh: "%d hours", d: "a day", dd: "%d days", M: "a month", MM: "%d months", y: "a year", yy: "%d years" };
        function a(c, u, d, f) {
          return i.fromToBase(c, u, d, f);
        }
        o.en.relativeTime = s, i.fromToBase = function(c, u, d, f, h) {
          for (var p, m, g, y = d.$locale().relativeTime || s, v = n.thresholds || [{ l: "s", r: 44, d: "second" }, { l: "m", r: 89 }, { l: "mm", r: 44, d: "minute" }, { l: "h", r: 89 }, { l: "hh", r: 21, d: "hour" }, { l: "d", r: 35 }, { l: "dd", r: 25, d: "day" }, { l: "M", r: 45 }, { l: "MM", r: 10, d: "month" }, { l: "y", r: 17 }, { l: "yy", d: "year" }], b = v.length, _ = 0; _ < b; _ += 1) {
            var w = v[_];
            w.d && (p = f ? o(c).diff(d, w.d, !0) : d.diff(c, w.d, !0));
            var x = (n.rounding || Math.round)(Math.abs(p));
            if (g = p > 0, x <= w.r || !w.r) {
              x <= 1 && _ > 0 && (w = v[_ - 1]);
              var E = y[w.l];
              h && (x = h("" + x)), m = typeof E == "string" ? E.replace("%d", x) : E(x, u, w.l, g);
              break;
            }
          }
          if (u) return m;
          var S = g ? y.future : y.past;
          return typeof S == "function" ? S(m) : S.replace("%s", m);
        }, i.to = function(c, u) {
          return a(c, u, this, !0);
        }, i.from = function(c, u) {
          return a(c, u, this);
        };
        var l = function(c) {
          return c.$u ? o.utc() : o();
        };
        i.toNow = function(c) {
          return this.to(l(this), c);
        }, i.fromNow = function(c) {
          return this.from(l(this), c);
        };
      };
    });
  }(z_)), z_.exports;
}
var jRe = NRe();
const oIt = /* @__PURE__ */ Kt(jRe);
var q_ = { exports: {} }, LRe = q_.exports, W8;
function FRe() {
  return W8 || (W8 = 1, function(t, e) {
    (function(n, r) {
      t.exports = r();
    })(LRe, function() {
      var n = { year: 0, month: 1, day: 2, hour: 3, minute: 4, second: 5 }, r = {};
      return function(o, i, s) {
        var a, l = function(f, h, p) {
          p === void 0 && (p = {});
          var m = new Date(f), g = function(y, v) {
            v === void 0 && (v = {});
            var b = v.timeZoneName || "short", _ = y + "|" + b, w = r[_];
            return w || (w = new Intl.DateTimeFormat("en-US", { hour12: !1, timeZone: y, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit", timeZoneName: b }), r[_] = w), w;
          }(h, p);
          return g.formatToParts(m);
        }, c = function(f, h) {
          for (var p = l(f, h), m = [], g = 0; g < p.length; g += 1) {
            var y = p[g], v = y.type, b = y.value, _ = n[v];
            _ >= 0 && (m[_] = parseInt(b, 10));
          }
          var w = m[3], x = w === 24 ? 0 : w, E = m[0] + "-" + m[1] + "-" + m[2] + " " + x + ":" + m[4] + ":" + m[5] + ":000", S = +f;
          return (s.utc(E).valueOf() - (S -= S % 1e3)) / 6e4;
        }, u = i.prototype;
        u.tz = function(f, h) {
          f === void 0 && (f = a);
          var p, m = this.utcOffset(), g = this.toDate(), y = g.toLocaleString("en-US", { timeZone: f }), v = Math.round((g - new Date(y)) / 1e3 / 60), b = 15 * -Math.round(g.getTimezoneOffset() / 15) - v;
          if (!Number(b)) p = this.utcOffset(0, h);
          else if (p = s(y, { locale: this.$L }).$set("millisecond", this.$ms).utcOffset(b, !0), h) {
            var _ = p.utcOffset();
            p = p.add(m - _, "minute");
          }
          return p.$x.$timezone = f, p;
        }, u.offsetName = function(f) {
          var h = this.$x.$timezone || s.tz.guess(), p = l(this.valueOf(), h, { timeZoneName: f }).find(function(m) {
            return m.type.toLowerCase() === "timezonename";
          });
          return p && p.value;
        };
        var d = u.startOf;
        u.startOf = function(f, h) {
          if (!this.$x || !this.$x.$timezone) return d.call(this, f, h);
          var p = s(this.format("YYYY-MM-DD HH:mm:ss:SSS"), { locale: this.$L });
          return d.call(p, f, h).tz(this.$x.$timezone, !0);
        }, s.tz = function(f, h, p) {
          var m = p && h, g = p || h || a, y = c(+s(), g);
          if (typeof f != "string") return s(f).tz(g);
          var v = function(x, E, S) {
            var C = x - 60 * E * 1e3, R = c(C, S);
            if (E === R) return [C, E];
            var P = c(C -= 60 * (R - E) * 1e3, S);
            return R === P ? [C, R] : [x - 60 * Math.min(R, P) * 1e3, Math.max(R, P)];
          }(s.utc(f, m).valueOf(), y, g), b = v[0], _ = v[1], w = s(b).utcOffset(_);
          return w.$x.$timezone = g, w;
        }, s.tz.guess = function() {
          return Intl.DateTimeFormat().resolvedOptions().timeZone;
        }, s.tz.setDefault = function(f) {
          a = f;
        };
      };
    });
  }(q_)), q_.exports;
}
var BRe = FRe();
const iIt = /* @__PURE__ */ Kt(BRe);
var U_ = { exports: {} }, zRe = U_.exports, G8;
function qRe() {
  return G8 || (G8 = 1, function(t, e) {
    (function(n, r) {
      t.exports = r();
    })(zRe, function() {
      var n = "minute", r = /[+-]\d\d(?::?\d\d)?/g, o = /([+-]|\d\d)/g;
      return function(i, s, a) {
        var l = s.prototype;
        a.utc = function(m) {
          var g = { date: m, utc: !0, args: arguments };
          return new s(g);
        }, l.utc = function(m) {
          var g = a(this.toDate(), { locale: this.$L, utc: !0 });
          return m ? g.add(this.utcOffset(), n) : g;
        }, l.local = function() {
          return a(this.toDate(), { locale: this.$L, utc: !1 });
        };
        var c = l.parse;
        l.parse = function(m) {
          m.utc && (this.$u = !0), this.$utils().u(m.$offset) || (this.$offset = m.$offset), c.call(this, m);
        };
        var u = l.init;
        l.init = function() {
          if (this.$u) {
            var m = this.$d;
            this.$y = m.getUTCFullYear(), this.$M = m.getUTCMonth(), this.$D = m.getUTCDate(), this.$W = m.getUTCDay(), this.$H = m.getUTCHours(), this.$m = m.getUTCMinutes(), this.$s = m.getUTCSeconds(), this.$ms = m.getUTCMilliseconds();
          } else u.call(this);
        };
        var d = l.utcOffset;
        l.utcOffset = function(m, g) {
          var y = this.$utils().u;
          if (y(m)) return this.$u ? 0 : y(this.$offset) ? d.call(this) : this.$offset;
          if (typeof m == "string" && (m = function(w) {
            w === void 0 && (w = "");
            var x = w.match(r);
            if (!x) return null;
            var E = ("" + x[0]).match(o) || ["-", 0, 0], S = E[0], C = 60 * +E[1] + +E[2];
            return C === 0 ? 0 : S === "+" ? C : -C;
          }(m), m === null)) return this;
          var v = Math.abs(m) <= 16 ? 60 * m : m, b = this;
          if (g) return b.$offset = v, b.$u = m === 0, b;
          if (m !== 0) {
            var _ = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
            (b = this.local().add(v + _, n)).$offset = v, b.$x.$localOffset = _;
          } else b = this.utc();
          return b;
        };
        var f = l.format;
        l.format = function(m) {
          var g = m || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
          return f.call(this, g);
        }, l.valueOf = function() {
          var m = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
          return this.$d.valueOf() - 6e4 * m;
        }, l.isUTC = function() {
          return !!this.$u;
        }, l.toISOString = function() {
          return this.toDate().toISOString();
        }, l.toString = function() {
          return this.toDate().toUTCString();
        };
        var h = l.toDate;
        l.toDate = function(m) {
          return m === "s" && this.$offset ? a(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : h.call(this);
        };
        var p = l.diff;
        l.diff = function(m, g, y) {
          if (m && this.$u === m.$u) return p.call(this, m, g, y);
          var v = this.local(), b = a(m).local();
          return p.call(v, b, g, y);
        };
      };
    });
  }(U_)), U_.exports;
}
var URe = qRe();
const sIt = /* @__PURE__ */ Kt(URe);
var mC = {}, gC = {}, yC = {}, Y8;
function HRe() {
  return Y8 || (Y8 = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var e = function() {
      for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
        i[s] = arguments[s];
      if (typeof window < "u") {
        var a;
        typeof window.gtag > "u" && (window.dataLayer = window.dataLayer || [], window.gtag = function() {
          window.dataLayer.push(arguments);
        }), (a = window).gtag.apply(a, i);
      }
    }, n = e;
    t.default = n;
  }(yC)), yC;
}
var vC = {}, K8;
function VRe() {
  return K8 || (K8 = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = s;
    var e = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i;
    function n(a) {
      return a.toString().trim().replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function(l, c, u) {
        return c > 0 && c + l.length !== u.length && l.search(e) > -1 && u.charAt(c - 2) !== ":" && (u.charAt(c + l.length) !== "-" || u.charAt(c - 1) === "-") && u.charAt(c - 1).search(/[^\s-]/) < 0 ? l.toLowerCase() : l.substr(1).search(/[A-Z]|\../) > -1 ? l : l.charAt(0).toUpperCase() + l.substr(1);
      });
    }
    function r(a) {
      return typeof a == "string" && a.indexOf("@") !== -1;
    }
    var o = "REDACTED (Potential Email Address)";
    function i(a) {
      return r(a) ? (console.warn("This arg looks like an email address, redacting."), o) : a;
    }
    function s() {
      var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", l = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, c = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, u = a || "";
      return l && (u = n(a)), c && (u = i(u)), u;
    }
  }(vC)), vC;
}
var X8;
function WRe() {
  return X8 || (X8 = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = t.GA4 = void 0;
    var e = a(HRe()), n = a(VRe()), r = ["eventCategory", "eventAction", "eventLabel", "eventValue", "hitType"], o = ["title", "location"], i = ["page", "hitType"], s = ["action", "category", "label", "value", "nonInteraction", "transport"];
    function a(A) {
      return A && A.__esModule ? A : { default: A };
    }
    function l(A, O) {
      if (A == null) return {};
      var k = c(A, O), T, I;
      if (Object.getOwnPropertySymbols) {
        var j = Object.getOwnPropertySymbols(A);
        for (I = 0; I < j.length; I++)
          T = j[I], !(O.indexOf(T) >= 0) && Object.prototype.propertyIsEnumerable.call(A, T) && (k[T] = A[T]);
      }
      return k;
    }
    function c(A, O) {
      if (A == null) return {};
      var k = {}, T = Object.keys(A), I, j;
      for (j = 0; j < T.length; j++)
        I = T[j], !(O.indexOf(I) >= 0) && (k[I] = A[I]);
      return k;
    }
    function u(A) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? u = function(k) {
        return typeof k;
      } : u = function(k) {
        return k && typeof Symbol == "function" && k.constructor === Symbol && k !== Symbol.prototype ? "symbol" : typeof k;
      }, u(A);
    }
    function d(A) {
      return p(A) || h(A) || b(A) || f();
    }
    function f() {
      throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    function h(A) {
      if (typeof Symbol < "u" && A[Symbol.iterator] != null || A["@@iterator"] != null) return Array.from(A);
    }
    function p(A) {
      if (Array.isArray(A)) return _(A);
    }
    function m(A, O) {
      var k = Object.keys(A);
      if (Object.getOwnPropertySymbols) {
        var T = Object.getOwnPropertySymbols(A);
        O && (T = T.filter(function(I) {
          return Object.getOwnPropertyDescriptor(A, I).enumerable;
        })), k.push.apply(k, T);
      }
      return k;
    }
    function g(A) {
      for (var O = 1; O < arguments.length; O++) {
        var k = arguments[O] != null ? arguments[O] : {};
        O % 2 ? m(Object(k), !0).forEach(function(T) {
          R(A, T, k[T]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(A, Object.getOwnPropertyDescriptors(k)) : m(Object(k)).forEach(function(T) {
          Object.defineProperty(A, T, Object.getOwnPropertyDescriptor(k, T));
        });
      }
      return A;
    }
    function y(A, O) {
      return x(A) || w(A, O) || b(A, O) || v();
    }
    function v() {
      throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    function b(A, O) {
      if (A) {
        if (typeof A == "string") return _(A, O);
        var k = Object.prototype.toString.call(A).slice(8, -1);
        if (k === "Object" && A.constructor && (k = A.constructor.name), k === "Map" || k === "Set") return Array.from(A);
        if (k === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(k)) return _(A, O);
      }
    }
    function _(A, O) {
      (O == null || O > A.length) && (O = A.length);
      for (var k = 0, T = new Array(O); k < O; k++)
        T[k] = A[k];
      return T;
    }
    function w(A, O) {
      var k = A == null ? null : typeof Symbol < "u" && A[Symbol.iterator] || A["@@iterator"];
      if (k != null) {
        var T = [], I = !0, j = !1, z, $;
        try {
          for (k = k.call(A); !(I = (z = k.next()).done) && (T.push(z.value), !(O && T.length === O)); I = !0)
            ;
        } catch (D) {
          j = !0, $ = D;
        } finally {
          try {
            !I && k.return != null && k.return();
          } finally {
            if (j) throw $;
          }
        }
        return T;
      }
    }
    function x(A) {
      if (Array.isArray(A)) return A;
    }
    function E(A, O) {
      if (!(A instanceof O))
        throw new TypeError("Cannot call a class as a function");
    }
    function S(A, O) {
      for (var k = 0; k < O.length; k++) {
        var T = O[k];
        T.enumerable = T.enumerable || !1, T.configurable = !0, "value" in T && (T.writable = !0), Object.defineProperty(A, T.key, T);
      }
    }
    function C(A, O, k) {
      return O && S(A.prototype, O), A;
    }
    function R(A, O, k) {
      return O in A ? Object.defineProperty(A, O, { value: k, enumerable: !0, configurable: !0, writable: !0 }) : A[O] = k, A;
    }
    var P = /* @__PURE__ */ function() {
      function A() {
        var O = this;
        E(this, A), R(this, "reset", function() {
          O.isInitialized = !1, O._testMode = !1, O._currentMeasurementId, O._hasLoadedGA = !1, O._isQueuing = !1, O._queueGtag = [];
        }), R(this, "_gtag", function() {
          for (var k = arguments.length, T = new Array(k), I = 0; I < k; I++)
            T[I] = arguments[I];
          O._testMode || O._isQueuing ? O._queueGtag.push(T) : e.default.apply(void 0, T);
        }), R(this, "_loadGA", function(k, T) {
          if (!(typeof window > "u" || typeof document > "u") && !O._hasLoadedGA) {
            var I = document.createElement("script");
            I.async = !0, I.src = "https://www.googletagmanager.com/gtag/js?id=".concat(k), T && I.setAttribute("nonce", T), document.body.appendChild(I), window.dataLayer = window.dataLayer || [], window.gtag = function() {
              window.dataLayer.push(arguments);
            }, O._hasLoadedGA = !0;
          }
        }), R(this, "_toGtagOptions", function(k) {
          if (k) {
            var T = {
              // Old https://developers.google.com/analytics/devguides/collection/analyticsjs/field-reference#cookieUpdate
              // New https://developers.google.com/analytics/devguides/collection/gtagjs/cookies-user-id#cookie_update
              cookieUpdate: "cookie_update",
              cookieExpires: "cookie_expires",
              cookieDomain: "cookie_domain",
              cookieFlags: "cookie_flags",
              // must be in set method?
              userId: "user_id",
              clientId: "client_id",
              anonymizeIp: "anonymize_ip",
              // https://support.google.com/analytics/answer/2853546?hl=en#zippy=%2Cin-this-article
              contentGroup1: "content_group1",
              contentGroup2: "content_group2",
              contentGroup3: "content_group3",
              contentGroup4: "content_group4",
              contentGroup5: "content_group5",
              // https://support.google.com/analytics/answer/9050852?hl=en
              allowAdFeatures: "allow_google_signals",
              allowAdPersonalizationSignals: "allow_ad_personalization_signals",
              nonInteraction: "non_interaction",
              page: "page_path",
              hitCallback: "event_callback"
            }, I = Object.entries(k).reduce(function(j, z) {
              var $ = y(z, 2), D = $[0], U = $[1];
              return T[D] ? j[T[D]] = U : j[D] = U, j;
            }, {});
            return I;
          }
        }), R(this, "initialize", function(k) {
          var T = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
          if (!k)
            throw new Error("Require GA_MEASUREMENT_ID");
          var I = typeof k == "string" ? [{
            trackingId: k
          }] : k;
          O._currentMeasurementId = I[0].trackingId;
          var j = T.gaOptions, z = T.gtagOptions, $ = T.legacyDimensionMetric, D = $ === void 0 ? !0 : $, U = T.nonce, q = T.testMode, F = q === void 0 ? !1 : q;
          if (O._testMode = F, F || O._loadGA(O._currentMeasurementId, U), O.isInitialized || (O._gtag("js", /* @__PURE__ */ new Date()), I.forEach(function(Z) {
            var W = O._appendCustomMap(g(g(g({
              // https://developers.google.com/analytics/devguides/collection/gtagjs/pages#disable_pageview_measurement
              send_page_view: !1
            }, O._toGtagOptions(g(g({}, j), Z.gaOptions))), z), Z.gtagOptions), D);
            O._gtag("config", Z.trackingId, W);
          })), O.isInitialized = !0, !F) {
            var B = d(O._queueGtag);
            for (O._queueGtag = [], O._isQueuing = !1; B.length; ) {
              var H = B.shift();
              O._gtag.apply(O, d(H)), H[0] === "get" && (O._isQueuing = !0);
            }
          }
        }), R(this, "set", function(k) {
          if (!k) {
            console.warn("`fieldsObject` is required in .set()");
            return;
          }
          if (u(k) !== "object") {
            console.warn("Expected `fieldsObject` arg to be an Object");
            return;
          }
          Object.keys(k).length === 0 && console.warn("empty `fieldsObject` given to .set()"), O._gaCommand("set", k);
        }), R(this, "_gaCommandSendEvent", function(k, T, I, j, z) {
          O._gtag("event", T, g(g({
            event_category: k,
            event_label: I,
            value: j
          }, z && {
            non_interaction: z.nonInteraction
          }), O._toGtagOptions(z)));
        }), R(this, "_gaCommandSendEventParameters", function() {
          for (var k = arguments.length, T = new Array(k), I = 0; I < k; I++)
            T[I] = arguments[I];
          if (typeof T[0] == "string")
            O._gaCommandSendEvent.apply(O, d(T.slice(1)));
          else {
            var j = T[0], z = j.eventCategory, $ = j.eventAction, D = j.eventLabel, U = j.eventValue;
            j.hitType;
            var q = l(j, r);
            O._gaCommandSendEvent(z, $, D, U, q);
          }
        }), R(this, "_gaCommandSendTiming", function(k, T, I, j) {
          O._gtag("event", "timing_complete", {
            name: T,
            value: I,
            event_category: k,
            event_label: j
          });
        }), R(this, "_gaCommandSendPageview", function(k, T) {
          if (T && Object.keys(T).length) {
            var I = O._toGtagOptions(T), j = I.title, z = I.location, $ = l(I, o);
            O._gtag("event", "page_view", g(g(g(g({}, k && {
              page_path: k
            }), j && {
              page_title: j
            }), z && {
              page_location: z
            }), $));
          } else k ? O._gtag("event", "page_view", {
            page_path: k
          }) : O._gtag("event", "page_view");
        }), R(this, "_gaCommandSendPageviewParameters", function() {
          for (var k = arguments.length, T = new Array(k), I = 0; I < k; I++)
            T[I] = arguments[I];
          if (typeof T[0] == "string")
            O._gaCommandSendPageview.apply(O, d(T.slice(1)));
          else {
            var j = T[0], z = j.page;
            j.hitType;
            var $ = l(j, i);
            O._gaCommandSendPageview(z, $);
          }
        }), R(this, "_gaCommandSend", function() {
          for (var k = arguments.length, T = new Array(k), I = 0; I < k; I++)
            T[I] = arguments[I];
          var j = typeof T[0] == "string" ? T[0] : T[0].hitType;
          switch (j) {
            case "event":
              O._gaCommandSendEventParameters.apply(O, T);
              break;
            case "pageview":
              O._gaCommandSendPageviewParameters.apply(O, T);
              break;
            case "timing":
              O._gaCommandSendTiming.apply(O, d(T.slice(1)));
              break;
            case "screenview":
            case "transaction":
            case "item":
            case "social":
            case "exception":
              console.warn("Unsupported send command: ".concat(j));
              break;
            default:
              console.warn("Send command doesn't exist: ".concat(j));
          }
        }), R(this, "_gaCommandSet", function() {
          for (var k = arguments.length, T = new Array(k), I = 0; I < k; I++)
            T[I] = arguments[I];
          typeof T[0] == "string" && (T[0] = R({}, T[0], T[1])), O._gtag("set", O._toGtagOptions(T[0]));
        }), R(this, "_gaCommand", function(k) {
          for (var T = arguments.length, I = new Array(T > 1 ? T - 1 : 0), j = 1; j < T; j++)
            I[j - 1] = arguments[j];
          switch (k) {
            case "send":
              O._gaCommandSend.apply(O, I);
              break;
            case "set":
              O._gaCommandSet.apply(O, I);
              break;
            default:
              console.warn("Command doesn't exist: ".concat(k));
          }
        }), R(this, "ga", function() {
          for (var k = arguments.length, T = new Array(k), I = 0; I < k; I++)
            T[I] = arguments[I];
          if (typeof T[0] == "string")
            O._gaCommand.apply(O, T);
          else {
            var j = T[0];
            O._gtag("get", O._currentMeasurementId, "client_id", function(z) {
              O._isQueuing = !1;
              var $ = O._queueGtag;
              for (j({
                get: function(q) {
                  return q === "clientId" ? z : q === "trackingId" ? O._currentMeasurementId : q === "apiVersion" ? "1" : void 0;
                }
              }); $.length; ) {
                var D = $.shift();
                O._gtag.apply(O, d(D));
              }
            }), O._isQueuing = !0;
          }
          return O.ga;
        }), R(this, "event", function(k, T) {
          if (typeof k == "string")
            O._gtag("event", k, O._toGtagOptions(T));
          else {
            var I = k.action, j = k.category, z = k.label, $ = k.value, D = k.nonInteraction, U = k.transport, q = l(k, s);
            if (!j || !I) {
              console.warn("args.category AND args.action are required in event()");
              return;
            }
            var F = {
              hitType: "event",
              eventCategory: (0, n.default)(j),
              eventAction: (0, n.default)(I)
            };
            z && (F.eventLabel = (0, n.default)(z)), typeof $ < "u" && (typeof $ != "number" ? console.warn("Expected `args.value` arg to be a Number.") : F.eventValue = $), typeof D < "u" && (typeof D != "boolean" ? console.warn("`args.nonInteraction` must be a boolean.") : F.nonInteraction = D), typeof U < "u" && (typeof U != "string" ? console.warn("`args.transport` must be a string.") : (["beacon", "xhr", "image"].indexOf(U) === -1 && console.warn("`args.transport` must be either one of these values: `beacon`, `xhr` or `image`"), F.transport = U)), Object.keys(q).filter(function(B) {
              return B.substr(0, 9) === "dimension";
            }).forEach(function(B) {
              F[B] = q[B];
            }), Object.keys(q).filter(function(B) {
              return B.substr(0, 6) === "metric";
            }).forEach(function(B) {
              F[B] = q[B];
            }), O._gaCommand("send", F);
          }
        }), R(this, "send", function(k) {
          O._gaCommand("send", k);
        }), R(this, "pageview", function(k, T, I) {
          var j = k?.trim();
          if (j === "") {
            console.warn("path cannot be an empty string in .pageview()");
            return;
          }
          O._gaCommand("send", "pageview", j, {
            title: I
          });
        }), this.reset();
      }
      return C(A, [{
        key: "gtag",
        value: function() {
          this._gtag.apply(this, arguments);
        }
      }, {
        key: "_appendCustomMap",
        value: function(k) {
          var T = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
          if (!T)
            return k;
          k.custom_map || (k.custom_map = {});
          for (var I = 1; I <= 200; I++)
            k.custom_map["dimension".concat(I)] || (k.custom_map["dimension".concat(I)] = "dimension".concat(I)), k.custom_map["metric".concat(I)] || (k.custom_map["metric".concat(I)] = "metric".concat(I));
          return k;
        }
        /**
         * @since v1.0.2
         * @param {string} [path="location.href"]
         * @param {string[]} [_] unsupported
         * @param {string} [title="location.pathname"]
         * @deprecated Use `.send("pageview")` instead
         */
      }, {
        key: "outboundLink",
        value: (
          /**
           * @since v1.0.6
           * @param {Object} options
           * @param {string} options.label
           * @param {function} hitCallback
           * @deprecated Use `enhanced measurement` feature in Google Analytics.
           */
          function(k, T) {
            var I = k.label;
            if (typeof T != "function") {
              console.warn("hitCallback function is required");
              return;
            }
            if (!I) {
              console.warn("args.label is required in outboundLink()");
              return;
            }
            var j = {
              hitType: "event",
              eventCategory: "Outbound",
              eventAction: "Click",
              eventLabel: (0, n.default)(I)
            }, z = !1, $ = function() {
              z = !0, T();
            }, D = setTimeout($, 250), U = function() {
              clearTimeout(D), z || T();
            };
            j.hitCallback = U, this._gaCommand("send", j);
          }
        )
      }]), A;
    }();
    t.GA4 = P;
    var N = new P();
    t.default = N;
  }(gC)), gC;
}
var Q8;
function GRe() {
  return Q8 || (Q8 = 1, function(t) {
    function e(a) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? e = function(c) {
        return typeof c;
      } : e = function(c) {
        return c && typeof Symbol == "function" && c.constructor === Symbol && c !== Symbol.prototype ? "symbol" : typeof c;
      }, e(a);
    }
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = t.ReactGAImplementation = void 0;
    var n = o(WRe());
    function r(a) {
      if (typeof WeakMap != "function") return null;
      var l = /* @__PURE__ */ new WeakMap(), c = /* @__PURE__ */ new WeakMap();
      return (r = function(d) {
        return d ? c : l;
      })(a);
    }
    function o(a, l) {
      if (a && a.__esModule)
        return a;
      if (a === null || e(a) !== "object" && typeof a != "function")
        return { default: a };
      var c = r(l);
      if (c && c.has(a))
        return c.get(a);
      var u = {}, d = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var f in a)
        if (f !== "default" && Object.prototype.hasOwnProperty.call(a, f)) {
          var h = d ? Object.getOwnPropertyDescriptor(a, f) : null;
          h && (h.get || h.set) ? Object.defineProperty(u, f, h) : u[f] = a[f];
        }
      return u.default = a, c && c.set(a, u), u;
    }
    var i = n.GA4;
    t.ReactGAImplementation = i;
    var s = n.default;
    t.default = s;
  }(mC)), mC;
}
var YRe = GRe();
const KRe = /* @__PURE__ */ Kt(YRe);
var Tf = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function bp(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function Zy(t) {
  if (Object.prototype.hasOwnProperty.call(t, "__esModule")) return t;
  var e = t.default;
  if (typeof e == "function") {
    var n = function r() {
      return this instanceof r ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    n.prototype = e.prototype;
  } else n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(t).forEach(function(r) {
    var o = Object.getOwnPropertyDescriptor(t, r);
    Object.defineProperty(n, r, o.get ? o : {
      enumerable: !0,
      get: function() {
        return t[r];
      }
    });
  }), n;
}
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
var yae;
function qe() {
  return yae.apply(null, arguments);
}
function XRe(t) {
  yae = t;
}
function Ts(t) {
  return t instanceof Array || Object.prototype.toString.call(t) === "[object Array]";
}
function pd(t) {
  return t != null && Object.prototype.toString.call(t) === "[object Object]";
}
function Zt(t, e) {
  return Object.prototype.hasOwnProperty.call(t, e);
}
function Y3(t) {
  if (Object.getOwnPropertyNames)
    return Object.getOwnPropertyNames(t).length === 0;
  var e;
  for (e in t)
    if (Zt(t, e))
      return !1;
  return !0;
}
function Fo(t) {
  return t === void 0;
}
function Ml(t) {
  return typeof t == "number" || Object.prototype.toString.call(t) === "[object Number]";
}
function Jy(t) {
  return t instanceof Date || Object.prototype.toString.call(t) === "[object Date]";
}
function vae(t, e) {
  var n = [], r, o = t.length;
  for (r = 0; r < o; ++r)
    n.push(e(t[r], r));
  return n;
}
function Tc(t, e) {
  for (var n in e)
    Zt(e, n) && (t[n] = e[n]);
  return Zt(e, "toString") && (t.toString = e.toString), Zt(e, "valueOf") && (t.valueOf = e.valueOf), t;
}
function ka(t, e, n, r) {
  return zae(t, e, n, r, !0).utc();
}
function QRe() {
  return {
    empty: !1,
    unusedTokens: [],
    unusedInput: [],
    overflow: -2,
    charsLeftOver: 0,
    nullInput: !1,
    invalidEra: null,
    invalidMonth: null,
    invalidFormat: !1,
    userInvalidated: !1,
    iso: !1,
    parsedDateParts: [],
    era: null,
    meridiem: null,
    rfc2822: !1,
    weekdayMismatch: !1
  };
}
function kt(t) {
  return t._pf == null && (t._pf = QRe()), t._pf;
}
var LD;
Array.prototype.some ? LD = Array.prototype.some : LD = function(t) {
  var e = Object(this), n = e.length >>> 0, r;
  for (r = 0; r < n; r++)
    if (r in e && t.call(this, e[r], r, e))
      return !0;
  return !1;
};
function K3(t) {
  var e = null, n = !1, r = t._d && !isNaN(t._d.getTime());
  if (r && (e = kt(t), n = LD.call(e.parsedDateParts, function(o) {
    return o != null;
  }), r = e.overflow < 0 && !e.empty && !e.invalidEra && !e.invalidMonth && !e.invalidWeekday && !e.weekdayMismatch && !e.nullInput && !e.invalidFormat && !e.userInvalidated && (!e.meridiem || e.meridiem && n), t._strict && (r = r && e.charsLeftOver === 0 && e.unusedTokens.length === 0 && e.bigHour === void 0)), Object.isFrozen == null || !Object.isFrozen(t))
    t._isValid = r;
  else
    return r;
  return t._isValid;
}
function JE(t) {
  var e = ka(NaN);
  return t != null ? Tc(kt(e), t) : kt(e).userInvalidated = !0, e;
}
var Z8 = qe.momentProperties = [], bC = !1;
function X3(t, e) {
  var n, r, o, i = Z8.length;
  if (Fo(e._isAMomentObject) || (t._isAMomentObject = e._isAMomentObject), Fo(e._i) || (t._i = e._i), Fo(e._f) || (t._f = e._f), Fo(e._l) || (t._l = e._l), Fo(e._strict) || (t._strict = e._strict), Fo(e._tzm) || (t._tzm = e._tzm), Fo(e._isUTC) || (t._isUTC = e._isUTC), Fo(e._offset) || (t._offset = e._offset), Fo(e._pf) || (t._pf = kt(e)), Fo(e._locale) || (t._locale = e._locale), i > 0)
    for (n = 0; n < i; n++)
      r = Z8[n], o = e[r], Fo(o) || (t[r] = o);
  return t;
}
function ev(t) {
  X3(this, t), this._d = new Date(t._d != null ? t._d.getTime() : NaN), this.isValid() || (this._d = /* @__PURE__ */ new Date(NaN)), bC === !1 && (bC = !0, qe.updateOffset(this), bC = !1);
}
function Rs(t) {
  return t instanceof ev || t != null && t._isAMomentObject != null;
}
function bae(t) {
  qe.suppressDeprecationWarnings === !1 && typeof console < "u" && console.warn && console.warn("Deprecation warning: " + t);
}
function os(t, e) {
  var n = !0;
  return Tc(function() {
    if (qe.deprecationHandler != null && qe.deprecationHandler(null, t), n) {
      var r = [], o, i, s, a = arguments.length;
      for (i = 0; i < a; i++) {
        if (o = "", typeof arguments[i] == "object") {
          o += `
[` + i + "] ";
          for (s in arguments[0])
            Zt(arguments[0], s) && (o += s + ": " + arguments[0][s] + ", ");
          o = o.slice(0, -2);
        } else
          o = arguments[i];
        r.push(o);
      }
      bae(
        t + `
Arguments: ` + Array.prototype.slice.call(r).join("") + `
` + new Error().stack
      ), n = !1;
    }
    return e.apply(this, arguments);
  }, e);
}
var J8 = {};
function _ae(t, e) {
  qe.deprecationHandler != null && qe.deprecationHandler(t, e), J8[t] || (bae(e), J8[t] = !0);
}
qe.suppressDeprecationWarnings = !1;
qe.deprecationHandler = null;
function Aa(t) {
  return typeof Function < "u" && t instanceof Function || Object.prototype.toString.call(t) === "[object Function]";
}
function ZRe(t) {
  var e, n;
  for (n in t)
    Zt(t, n) && (e = t[n], Aa(e) ? this[n] = e : this["_" + n] = e);
  this._config = t, this._dayOfMonthOrdinalParseLenient = new RegExp(
    (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source
  );
}
function FD(t, e) {
  var n = Tc({}, t), r;
  for (r in e)
    Zt(e, r) && (pd(t[r]) && pd(e[r]) ? (n[r] = {}, Tc(n[r], t[r]), Tc(n[r], e[r])) : e[r] != null ? n[r] = e[r] : delete n[r]);
  for (r in t)
    Zt(t, r) && !Zt(e, r) && pd(t[r]) && (n[r] = Tc({}, n[r]));
  return n;
}
function Q3(t) {
  t != null && this.set(t);
}
var BD;
Object.keys ? BD = Object.keys : BD = function(t) {
  var e, n = [];
  for (e in t)
    Zt(t, e) && n.push(e);
  return n;
};
var JRe = {
  sameDay: "[Today at] LT",
  nextDay: "[Tomorrow at] LT",
  nextWeek: "dddd [at] LT",
  lastDay: "[Yesterday at] LT",
  lastWeek: "[Last] dddd [at] LT",
  sameElse: "L"
};
function ePe(t, e, n) {
  var r = this._calendar[t] || this._calendar.sameElse;
  return Aa(r) ? r.call(e, n) : r;
}
function Ea(t, e, n) {
  var r = "" + Math.abs(t), o = e - r.length, i = t >= 0;
  return (i ? n ? "+" : "" : "-") + Math.pow(10, Math.max(0, o)).toString().substr(1) + r;
}
var Z3 = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, cb = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, _C = {}, ch = {};
function ht(t, e, n, r) {
  var o = r;
  typeof r == "string" && (o = function() {
    return this[r]();
  }), t && (ch[t] = o), e && (ch[e[0]] = function() {
    return Ea(o.apply(this, arguments), e[1], e[2]);
  }), n && (ch[n] = function() {
    return this.localeData().ordinal(
      o.apply(this, arguments),
      t
    );
  });
}
function tPe(t) {
  return t.match(/\[[\s\S]/) ? t.replace(/^\[|\]$/g, "") : t.replace(/\\/g, "");
}
function nPe(t) {
  var e = t.match(Z3), n, r;
  for (n = 0, r = e.length; n < r; n++)
    ch[e[n]] ? e[n] = ch[e[n]] : e[n] = tPe(e[n]);
  return function(o) {
    var i = "", s;
    for (s = 0; s < r; s++)
      i += Aa(e[s]) ? e[s].call(o, t) : e[s];
    return i;
  };
}
function H_(t, e) {
  return t.isValid() ? (e = wae(e, t.localeData()), _C[e] = _C[e] || nPe(e), _C[e](t)) : t.localeData().invalidDate();
}
function wae(t, e) {
  var n = 5;
  function r(o) {
    return e.longDateFormat(o) || o;
  }
  for (cb.lastIndex = 0; n >= 0 && cb.test(t); )
    t = t.replace(
      cb,
      r
    ), cb.lastIndex = 0, n -= 1;
  return t;
}
var rPe = {
  LTS: "h:mm:ss A",
  LT: "h:mm A",
  L: "MM/DD/YYYY",
  LL: "MMMM D, YYYY",
  LLL: "MMMM D, YYYY h:mm A",
  LLLL: "dddd, MMMM D, YYYY h:mm A"
};
function oPe(t) {
  var e = this._longDateFormat[t], n = this._longDateFormat[t.toUpperCase()];
  return e || !n ? e : (this._longDateFormat[t] = n.match(Z3).map(function(r) {
    return r === "MMMM" || r === "MM" || r === "DD" || r === "dddd" ? r.slice(1) : r;
  }).join(""), this._longDateFormat[t]);
}
var iPe = "Invalid date";
function sPe() {
  return this._invalidDate;
}
var aPe = "%d", lPe = /\d{1,2}/;
function cPe(t) {
  return this._ordinal.replace("%d", t);
}
var uPe = {
  future: "in %s",
  past: "%s ago",
  s: "a few seconds",
  ss: "%d seconds",
  m: "a minute",
  mm: "%d minutes",
  h: "an hour",
  hh: "%d hours",
  d: "a day",
  dd: "%d days",
  w: "a week",
  ww: "%d weeks",
  M: "a month",
  MM: "%d months",
  y: "a year",
  yy: "%d years"
};
function dPe(t, e, n, r) {
  var o = this._relativeTime[n];
  return Aa(o) ? o(t, e, n, r) : o.replace(/%d/i, t);
}
function fPe(t, e) {
  var n = this._relativeTime[t > 0 ? "future" : "past"];
  return Aa(n) ? n(e) : n.replace(/%s/i, e);
}
var eF = {
  D: "date",
  dates: "date",
  date: "date",
  d: "day",
  days: "day",
  day: "day",
  e: "weekday",
  weekdays: "weekday",
  weekday: "weekday",
  E: "isoWeekday",
  isoweekdays: "isoWeekday",
  isoweekday: "isoWeekday",
  DDD: "dayOfYear",
  dayofyears: "dayOfYear",
  dayofyear: "dayOfYear",
  h: "hour",
  hours: "hour",
  hour: "hour",
  ms: "millisecond",
  milliseconds: "millisecond",
  millisecond: "millisecond",
  m: "minute",
  minutes: "minute",
  minute: "minute",
  M: "month",
  months: "month",
  month: "month",
  Q: "quarter",
  quarters: "quarter",
  quarter: "quarter",
  s: "second",
  seconds: "second",
  second: "second",
  gg: "weekYear",
  weekyears: "weekYear",
  weekyear: "weekYear",
  GG: "isoWeekYear",
  isoweekyears: "isoWeekYear",
  isoweekyear: "isoWeekYear",
  w: "week",
  weeks: "week",
  week: "week",
  W: "isoWeek",
  isoweeks: "isoWeek",
  isoweek: "isoWeek",
  y: "year",
  years: "year",
  year: "year"
};
function is(t) {
  return typeof t == "string" ? eF[t] || eF[t.toLowerCase()] : void 0;
}
function J3(t) {
  var e = {}, n, r;
  for (r in t)
    Zt(t, r) && (n = is(r), n && (e[n] = t[r]));
  return e;
}
var hPe = {
  date: 9,
  day: 11,
  weekday: 11,
  isoWeekday: 11,
  dayOfYear: 4,
  hour: 13,
  millisecond: 16,
  minute: 14,
  month: 8,
  quarter: 7,
  second: 15,
  weekYear: 1,
  isoWeekYear: 1,
  week: 5,
  isoWeek: 5,
  year: 1
};
function pPe(t) {
  var e = [], n;
  for (n in t)
    Zt(t, n) && e.push({ unit: n, priority: hPe[n] });
  return e.sort(function(r, o) {
    return r.priority - o.priority;
  }), e;
}
var xae = /\d/, Pi = /\d\d/, Eae = /\d{3}/, e5 = /\d{4}/, eS = /[+-]?\d{6}/, Qn = /\d\d?/, Sae = /\d\d\d\d?/, Oae = /\d\d\d\d\d\d?/, tS = /\d{1,3}/, t5 = /\d{1,4}/, nS = /[+-]?\d{1,6}/, _p = /\d+/, rS = /[+-]?\d+/, mPe = /Z|[+-]\d\d:?\d\d/gi, oS = /Z|[+-]\d\d(?::?\d\d)?/gi, gPe = /[+-]?\d+(\.\d{1,3})?/, tv = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, wp = /^[1-9]\d?/, n5 = /^([1-9]\d|\d)/, Xw;
Xw = {};
function it(t, e, n) {
  Xw[t] = Aa(e) ? e : function(r, o) {
    return r && n ? n : e;
  };
}
function yPe(t, e) {
  return Zt(Xw, t) ? Xw[t](e._strict, e._locale) : new RegExp(vPe(t));
}
function vPe(t) {
  return kl(
    t.replace("\\", "").replace(
      /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
      function(e, n, r, o, i) {
        return n || r || o || i;
      }
    )
  );
}
function kl(t) {
  return t.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
}
function Fi(t) {
  return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
}
function Ft(t) {
  var e = +t, n = 0;
  return e !== 0 && isFinite(e) && (n = Fi(e)), n;
}
var zD = {};
function Mn(t, e) {
  var n, r = e, o;
  for (typeof t == "string" && (t = [t]), Ml(e) && (r = function(i, s) {
    s[e] = Ft(i);
  }), o = t.length, n = 0; n < o; n++)
    zD[t[n]] = r;
}
function nv(t, e) {
  Mn(t, function(n, r, o, i) {
    o._w = o._w || {}, e(n, o._w, o, i);
  });
}
function bPe(t, e, n) {
  e != null && Zt(zD, t) && zD[t](e, n._a, n, t);
}
function iS(t) {
  return t % 4 === 0 && t % 100 !== 0 || t % 400 === 0;
}
var fo = 0, vl = 1, aa = 2, Dr = 3, ws = 4, bl = 5, Ju = 6, _Pe = 7, wPe = 8;
ht("Y", 0, 0, function() {
  var t = this.year();
  return t <= 9999 ? Ea(t, 4) : "+" + t;
});
ht(0, ["YY", 2], 0, function() {
  return this.year() % 100;
});
ht(0, ["YYYY", 4], 0, "year");
ht(0, ["YYYYY", 5], 0, "year");
ht(0, ["YYYYYY", 6, !0], 0, "year");
it("Y", rS);
it("YY", Qn, Pi);
it("YYYY", t5, e5);
it("YYYYY", nS, eS);
it("YYYYYY", nS, eS);
Mn(["YYYYY", "YYYYYY"], fo);
Mn("YYYY", function(t, e) {
  e[fo] = t.length === 2 ? qe.parseTwoDigitYear(t) : Ft(t);
});
Mn("YY", function(t, e) {
  e[fo] = qe.parseTwoDigitYear(t);
});
Mn("Y", function(t, e) {
  e[fo] = parseInt(t, 10);
});
function Ug(t) {
  return iS(t) ? 366 : 365;
}
qe.parseTwoDigitYear = function(t) {
  return Ft(t) + (Ft(t) > 68 ? 1900 : 2e3);
};
var Cae = xp("FullYear", !0);
function xPe() {
  return iS(this.year());
}
function xp(t, e) {
  return function(n) {
    return n != null ? (kae(this, t, n), qe.updateOffset(this, e), this) : T0(this, t);
  };
}
function T0(t, e) {
  if (!t.isValid())
    return NaN;
  var n = t._d, r = t._isUTC;
  switch (e) {
    case "Milliseconds":
      return r ? n.getUTCMilliseconds() : n.getMilliseconds();
    case "Seconds":
      return r ? n.getUTCSeconds() : n.getSeconds();
    case "Minutes":
      return r ? n.getUTCMinutes() : n.getMinutes();
    case "Hours":
      return r ? n.getUTCHours() : n.getHours();
    case "Date":
      return r ? n.getUTCDate() : n.getDate();
    case "Day":
      return r ? n.getUTCDay() : n.getDay();
    case "Month":
      return r ? n.getUTCMonth() : n.getMonth();
    case "FullYear":
      return r ? n.getUTCFullYear() : n.getFullYear();
    default:
      return NaN;
  }
}
function kae(t, e, n) {
  var r, o, i, s, a;
  if (!(!t.isValid() || isNaN(n))) {
    switch (r = t._d, o = t._isUTC, e) {
      case "Milliseconds":
        return void (o ? r.setUTCMilliseconds(n) : r.setMilliseconds(n));
      case "Seconds":
        return void (o ? r.setUTCSeconds(n) : r.setSeconds(n));
      case "Minutes":
        return void (o ? r.setUTCMinutes(n) : r.setMinutes(n));
      case "Hours":
        return void (o ? r.setUTCHours(n) : r.setHours(n));
      case "Date":
        return void (o ? r.setUTCDate(n) : r.setDate(n));
      // case 'Day': // Not real
      //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
      // case 'Month': // Not used because we need to pass two variables
      //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
      case "FullYear":
        break;
      // See below ...
      default:
        return;
    }
    i = n, s = t.month(), a = t.date(), a = a === 29 && s === 1 && !iS(i) ? 28 : a, o ? r.setUTCFullYear(i, s, a) : r.setFullYear(i, s, a);
  }
}
function EPe(t) {
  return t = is(t), Aa(this[t]) ? this[t]() : this;
}
function SPe(t, e) {
  if (typeof t == "object") {
    t = J3(t);
    var n = pPe(t), r, o = n.length;
    for (r = 0; r < o; r++)
      this[n[r].unit](t[n[r].unit]);
  } else if (t = is(t), Aa(this[t]))
    return this[t](e);
  return this;
}
function OPe(t, e) {
  return (t % e + e) % e;
}
var vr;
Array.prototype.indexOf ? vr = Array.prototype.indexOf : vr = function(t) {
  var e;
  for (e = 0; e < this.length; ++e)
    if (this[e] === t)
      return e;
  return -1;
};
function r5(t, e) {
  if (isNaN(t) || isNaN(e))
    return NaN;
  var n = OPe(e, 12);
  return t += (e - n) / 12, n === 1 ? iS(t) ? 29 : 28 : 31 - n % 7 % 2;
}
ht("M", ["MM", 2], "Mo", function() {
  return this.month() + 1;
});
ht("MMM", 0, 0, function(t) {
  return this.localeData().monthsShort(this, t);
});
ht("MMMM", 0, 0, function(t) {
  return this.localeData().months(this, t);
});
it("M", Qn, wp);
it("MM", Qn, Pi);
it("MMM", function(t, e) {
  return e.monthsShortRegex(t);
});
it("MMMM", function(t, e) {
  return e.monthsRegex(t);
});
Mn(["M", "MM"], function(t, e) {
  e[vl] = Ft(t) - 1;
});
Mn(["MMM", "MMMM"], function(t, e, n, r) {
  var o = n._locale.monthsParse(t, r, n._strict);
  o != null ? e[vl] = o : kt(n).invalidMonth = t;
});
var CPe = "January_February_March_April_May_June_July_August_September_October_November_December".split(
  "_"
), Aae = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), Tae = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, kPe = tv, APe = tv;
function TPe(t, e) {
  return t ? Ts(this._months) ? this._months[t.month()] : this._months[(this._months.isFormat || Tae).test(e) ? "format" : "standalone"][t.month()] : Ts(this._months) ? this._months : this._months.standalone;
}
function RPe(t, e) {
  return t ? Ts(this._monthsShort) ? this._monthsShort[t.month()] : this._monthsShort[Tae.test(e) ? "format" : "standalone"][t.month()] : Ts(this._monthsShort) ? this._monthsShort : this._monthsShort.standalone;
}
function PPe(t, e, n) {
  var r, o, i, s = t.toLocaleLowerCase();
  if (!this._monthsParse)
    for (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = [], r = 0; r < 12; ++r)
      i = ka([2e3, r]), this._shortMonthsParse[r] = this.monthsShort(
        i,
        ""
      ).toLocaleLowerCase(), this._longMonthsParse[r] = this.months(i, "").toLocaleLowerCase();
  return n ? e === "MMM" ? (o = vr.call(this._shortMonthsParse, s), o !== -1 ? o : null) : (o = vr.call(this._longMonthsParse, s), o !== -1 ? o : null) : e === "MMM" ? (o = vr.call(this._shortMonthsParse, s), o !== -1 ? o : (o = vr.call(this._longMonthsParse, s), o !== -1 ? o : null)) : (o = vr.call(this._longMonthsParse, s), o !== -1 ? o : (o = vr.call(this._shortMonthsParse, s), o !== -1 ? o : null));
}
function $Pe(t, e, n) {
  var r, o, i;
  if (this._monthsParseExact)
    return PPe.call(this, t, e, n);
  for (this._monthsParse || (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = []), r = 0; r < 12; r++)
    if (o = ka([2e3, r]), n && !this._longMonthsParse[r] && (this._longMonthsParse[r] = new RegExp(
      "^" + this.months(o, "").replace(".", "") + "$",
      "i"
    ), this._shortMonthsParse[r] = new RegExp(
      "^" + this.monthsShort(o, "").replace(".", "") + "$",
      "i"
    )), !n && !this._monthsParse[r] && (i = "^" + this.months(o, "") + "|^" + this.monthsShort(o, ""), this._monthsParse[r] = new RegExp(i.replace(".", ""), "i")), n && e === "MMMM" && this._longMonthsParse[r].test(t) || n && e === "MMM" && this._shortMonthsParse[r].test(t) || !n && this._monthsParse[r].test(t))
      return r;
}
function Rae(t, e) {
  if (!t.isValid())
    return t;
  if (typeof e == "string") {
    if (/^\d+$/.test(e))
      e = Ft(e);
    else if (e = t.localeData().monthsParse(e), !Ml(e))
      return t;
  }
  var n = e, r = t.date();
  return r = r < 29 ? r : Math.min(r, r5(t.year(), n)), t._isUTC ? t._d.setUTCMonth(n, r) : t._d.setMonth(n, r), t;
}
function Pae(t) {
  return t != null ? (Rae(this, t), qe.updateOffset(this, !0), this) : T0(this, "Month");
}
function MPe() {
  return r5(this.year(), this.month());
}
function DPe(t) {
  return this._monthsParseExact ? (Zt(this, "_monthsRegex") || $ae.call(this), t ? this._monthsShortStrictRegex : this._monthsShortRegex) : (Zt(this, "_monthsShortRegex") || (this._monthsShortRegex = kPe), this._monthsShortStrictRegex && t ? this._monthsShortStrictRegex : this._monthsShortRegex);
}
function IPe(t) {
  return this._monthsParseExact ? (Zt(this, "_monthsRegex") || $ae.call(this), t ? this._monthsStrictRegex : this._monthsRegex) : (Zt(this, "_monthsRegex") || (this._monthsRegex = APe), this._monthsStrictRegex && t ? this._monthsStrictRegex : this._monthsRegex);
}
function $ae() {
  function t(l, c) {
    return c.length - l.length;
  }
  var e = [], n = [], r = [], o, i, s, a;
  for (o = 0; o < 12; o++)
    i = ka([2e3, o]), s = kl(this.monthsShort(i, "")), a = kl(this.months(i, "")), e.push(s), n.push(a), r.push(a), r.push(s);
  e.sort(t), n.sort(t), r.sort(t), this._monthsRegex = new RegExp("^(" + r.join("|") + ")", "i"), this._monthsShortRegex = this._monthsRegex, this._monthsStrictRegex = new RegExp(
    "^(" + n.join("|") + ")",
    "i"
  ), this._monthsShortStrictRegex = new RegExp(
    "^(" + e.join("|") + ")",
    "i"
  );
}
function NPe(t, e, n, r, o, i, s) {
  var a;
  return t < 100 && t >= 0 ? (a = new Date(t + 400, e, n, r, o, i, s), isFinite(a.getFullYear()) && a.setFullYear(t)) : a = new Date(t, e, n, r, o, i, s), a;
}
function R0(t) {
  var e, n;
  return t < 100 && t >= 0 ? (n = Array.prototype.slice.call(arguments), n[0] = t + 400, e = new Date(Date.UTC.apply(null, n)), isFinite(e.getUTCFullYear()) && e.setUTCFullYear(t)) : e = new Date(Date.UTC.apply(null, arguments)), e;
}
function Qw(t, e, n) {
  var r = 7 + e - n, o = (7 + R0(t, 0, r).getUTCDay() - e) % 7;
  return -o + r - 1;
}
function Mae(t, e, n, r, o) {
  var i = (7 + n - r) % 7, s = Qw(t, r, o), a = 1 + 7 * (e - 1) + i + s, l, c;
  return a <= 0 ? (l = t - 1, c = Ug(l) + a) : a > Ug(t) ? (l = t + 1, c = a - Ug(t)) : (l = t, c = a), {
    year: l,
    dayOfYear: c
  };
}
function P0(t, e, n) {
  var r = Qw(t.year(), e, n), o = Math.floor((t.dayOfYear() - r - 1) / 7) + 1, i, s;
  return o < 1 ? (s = t.year() - 1, i = o + Al(s, e, n)) : o > Al(t.year(), e, n) ? (i = o - Al(t.year(), e, n), s = t.year() + 1) : (s = t.year(), i = o), {
    week: i,
    year: s
  };
}
function Al(t, e, n) {
  var r = Qw(t, e, n), o = Qw(t + 1, e, n);
  return (Ug(t) - r + o) / 7;
}
ht("w", ["ww", 2], "wo", "week");
ht("W", ["WW", 2], "Wo", "isoWeek");
it("w", Qn, wp);
it("ww", Qn, Pi);
it("W", Qn, wp);
it("WW", Qn, Pi);
nv(
  ["w", "ww", "W", "WW"],
  function(t, e, n, r) {
    e[r.substr(0, 1)] = Ft(t);
  }
);
function jPe(t) {
  return P0(t, this._week.dow, this._week.doy).week;
}
var LPe = {
  dow: 0,
  // Sunday is the first day of the week.
  doy: 6
  // The week that contains Jan 6th is the first week of the year.
};
function FPe() {
  return this._week.dow;
}
function BPe() {
  return this._week.doy;
}
function zPe(t) {
  var e = this.localeData().week(this);
  return t == null ? e : this.add((t - e) * 7, "d");
}
function qPe(t) {
  var e = P0(this, 1, 4).week;
  return t == null ? e : this.add((t - e) * 7, "d");
}
ht("d", 0, "do", "day");
ht("dd", 0, 0, function(t) {
  return this.localeData().weekdaysMin(this, t);
});
ht("ddd", 0, 0, function(t) {
  return this.localeData().weekdaysShort(this, t);
});
ht("dddd", 0, 0, function(t) {
  return this.localeData().weekdays(this, t);
});
ht("e", 0, 0, "weekday");
ht("E", 0, 0, "isoWeekday");
it("d", Qn);
it("e", Qn);
it("E", Qn);
it("dd", function(t, e) {
  return e.weekdaysMinRegex(t);
});
it("ddd", function(t, e) {
  return e.weekdaysShortRegex(t);
});
it("dddd", function(t, e) {
  return e.weekdaysRegex(t);
});
nv(["dd", "ddd", "dddd"], function(t, e, n, r) {
  var o = n._locale.weekdaysParse(t, r, n._strict);
  o != null ? e.d = o : kt(n).invalidWeekday = t;
});
nv(["d", "e", "E"], function(t, e, n, r) {
  e[r] = Ft(t);
});
function UPe(t, e) {
  return typeof t != "string" ? t : isNaN(t) ? (t = e.weekdaysParse(t), typeof t == "number" ? t : null) : parseInt(t, 10);
}
function HPe(t, e) {
  return typeof t == "string" ? e.weekdaysParse(t) % 7 || 7 : isNaN(t) ? null : t;
}
function o5(t, e) {
  return t.slice(e, 7).concat(t.slice(0, e));
}
var VPe = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), Dae = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), WPe = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), GPe = tv, YPe = tv, KPe = tv;
function XPe(t, e) {
  var n = Ts(this._weekdays) ? this._weekdays : this._weekdays[t && t !== !0 && this._weekdays.isFormat.test(e) ? "format" : "standalone"];
  return t === !0 ? o5(n, this._week.dow) : t ? n[t.day()] : n;
}
function QPe(t) {
  return t === !0 ? o5(this._weekdaysShort, this._week.dow) : t ? this._weekdaysShort[t.day()] : this._weekdaysShort;
}
function ZPe(t) {
  return t === !0 ? o5(this._weekdaysMin, this._week.dow) : t ? this._weekdaysMin[t.day()] : this._weekdaysMin;
}
function JPe(t, e, n) {
  var r, o, i, s = t.toLocaleLowerCase();
  if (!this._weekdaysParse)
    for (this._weekdaysParse = [], this._shortWeekdaysParse = [], this._minWeekdaysParse = [], r = 0; r < 7; ++r)
      i = ka([2e3, 1]).day(r), this._minWeekdaysParse[r] = this.weekdaysMin(
        i,
        ""
      ).toLocaleLowerCase(), this._shortWeekdaysParse[r] = this.weekdaysShort(
        i,
        ""
      ).toLocaleLowerCase(), this._weekdaysParse[r] = this.weekdays(i, "").toLocaleLowerCase();
  return n ? e === "dddd" ? (o = vr.call(this._weekdaysParse, s), o !== -1 ? o : null) : e === "ddd" ? (o = vr.call(this._shortWeekdaysParse, s), o !== -1 ? o : null) : (o = vr.call(this._minWeekdaysParse, s), o !== -1 ? o : null) : e === "dddd" ? (o = vr.call(this._weekdaysParse, s), o !== -1 || (o = vr.call(this._shortWeekdaysParse, s), o !== -1) ? o : (o = vr.call(this._minWeekdaysParse, s), o !== -1 ? o : null)) : e === "ddd" ? (o = vr.call(this._shortWeekdaysParse, s), o !== -1 || (o = vr.call(this._weekdaysParse, s), o !== -1) ? o : (o = vr.call(this._minWeekdaysParse, s), o !== -1 ? o : null)) : (o = vr.call(this._minWeekdaysParse, s), o !== -1 || (o = vr.call(this._weekdaysParse, s), o !== -1) ? o : (o = vr.call(this._shortWeekdaysParse, s), o !== -1 ? o : null));
}
function e$e(t, e, n) {
  var r, o, i;
  if (this._weekdaysParseExact)
    return JPe.call(this, t, e, n);
  for (this._weekdaysParse || (this._weekdaysParse = [], this._minWeekdaysParse = [], this._shortWeekdaysParse = [], this._fullWeekdaysParse = []), r = 0; r < 7; r++)
    if (o = ka([2e3, 1]).day(r), n && !this._fullWeekdaysParse[r] && (this._fullWeekdaysParse[r] = new RegExp(
      "^" + this.weekdays(o, "").replace(".", "\\.?") + "$",
      "i"
    ), this._shortWeekdaysParse[r] = new RegExp(
      "^" + this.weekdaysShort(o, "").replace(".", "\\.?") + "$",
      "i"
    ), this._minWeekdaysParse[r] = new RegExp(
      "^" + this.weekdaysMin(o, "").replace(".", "\\.?") + "$",
      "i"
    )), this._weekdaysParse[r] || (i = "^" + this.weekdays(o, "") + "|^" + this.weekdaysShort(o, "") + "|^" + this.weekdaysMin(o, ""), this._weekdaysParse[r] = new RegExp(i.replace(".", ""), "i")), n && e === "dddd" && this._fullWeekdaysParse[r].test(t) || n && e === "ddd" && this._shortWeekdaysParse[r].test(t) || n && e === "dd" && this._minWeekdaysParse[r].test(t) || !n && this._weekdaysParse[r].test(t))
      return r;
}
function t$e(t) {
  if (!this.isValid())
    return t != null ? this : NaN;
  var e = T0(this, "Day");
  return t != null ? (t = UPe(t, this.localeData()), this.add(t - e, "d")) : e;
}
function n$e(t) {
  if (!this.isValid())
    return t != null ? this : NaN;
  var e = (this.day() + 7 - this.localeData()._week.dow) % 7;
  return t == null ? e : this.add(t - e, "d");
}
function r$e(t) {
  if (!this.isValid())
    return t != null ? this : NaN;
  if (t != null) {
    var e = HPe(t, this.localeData());
    return this.day(this.day() % 7 ? e : e - 7);
  } else
    return this.day() || 7;
}
function o$e(t) {
  return this._weekdaysParseExact ? (Zt(this, "_weekdaysRegex") || i5.call(this), t ? this._weekdaysStrictRegex : this._weekdaysRegex) : (Zt(this, "_weekdaysRegex") || (this._weekdaysRegex = GPe), this._weekdaysStrictRegex && t ? this._weekdaysStrictRegex : this._weekdaysRegex);
}
function i$e(t) {
  return this._weekdaysParseExact ? (Zt(this, "_weekdaysRegex") || i5.call(this), t ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex) : (Zt(this, "_weekdaysShortRegex") || (this._weekdaysShortRegex = YPe), this._weekdaysShortStrictRegex && t ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex);
}
function s$e(t) {
  return this._weekdaysParseExact ? (Zt(this, "_weekdaysRegex") || i5.call(this), t ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex) : (Zt(this, "_weekdaysMinRegex") || (this._weekdaysMinRegex = KPe), this._weekdaysMinStrictRegex && t ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex);
}
function i5() {
  function t(u, d) {
    return d.length - u.length;
  }
  var e = [], n = [], r = [], o = [], i, s, a, l, c;
  for (i = 0; i < 7; i++)
    s = ka([2e3, 1]).day(i), a = kl(this.weekdaysMin(s, "")), l = kl(this.weekdaysShort(s, "")), c = kl(this.weekdays(s, "")), e.push(a), n.push(l), r.push(c), o.push(a), o.push(l), o.push(c);
  e.sort(t), n.sort(t), r.sort(t), o.sort(t), this._weekdaysRegex = new RegExp("^(" + o.join("|") + ")", "i"), this._weekdaysShortRegex = this._weekdaysRegex, this._weekdaysMinRegex = this._weekdaysRegex, this._weekdaysStrictRegex = new RegExp(
    "^(" + r.join("|") + ")",
    "i"
  ), this._weekdaysShortStrictRegex = new RegExp(
    "^(" + n.join("|") + ")",
    "i"
  ), this._weekdaysMinStrictRegex = new RegExp(
    "^(" + e.join("|") + ")",
    "i"
  );
}
function s5() {
  return this.hours() % 12 || 12;
}
function a$e() {
  return this.hours() || 24;
}
ht("H", ["HH", 2], 0, "hour");
ht("h", ["hh", 2], 0, s5);
ht("k", ["kk", 2], 0, a$e);
ht("hmm", 0, 0, function() {
  return "" + s5.apply(this) + Ea(this.minutes(), 2);
});
ht("hmmss", 0, 0, function() {
  return "" + s5.apply(this) + Ea(this.minutes(), 2) + Ea(this.seconds(), 2);
});
ht("Hmm", 0, 0, function() {
  return "" + this.hours() + Ea(this.minutes(), 2);
});
ht("Hmmss", 0, 0, function() {
  return "" + this.hours() + Ea(this.minutes(), 2) + Ea(this.seconds(), 2);
});
function Iae(t, e) {
  ht(t, 0, 0, function() {
    return this.localeData().meridiem(
      this.hours(),
      this.minutes(),
      e
    );
  });
}
Iae("a", !0);
Iae("A", !1);
function Nae(t, e) {
  return e._meridiemParse;
}
it("a", Nae);
it("A", Nae);
it("H", Qn, n5);
it("h", Qn, wp);
it("k", Qn, wp);
it("HH", Qn, Pi);
it("hh", Qn, Pi);
it("kk", Qn, Pi);
it("hmm", Sae);
it("hmmss", Oae);
it("Hmm", Sae);
it("Hmmss", Oae);
Mn(["H", "HH"], Dr);
Mn(["k", "kk"], function(t, e, n) {
  var r = Ft(t);
  e[Dr] = r === 24 ? 0 : r;
});
Mn(["a", "A"], function(t, e, n) {
  n._isPm = n._locale.isPM(t), n._meridiem = t;
});
Mn(["h", "hh"], function(t, e, n) {
  e[Dr] = Ft(t), kt(n).bigHour = !0;
});
Mn("hmm", function(t, e, n) {
  var r = t.length - 2;
  e[Dr] = Ft(t.substr(0, r)), e[ws] = Ft(t.substr(r)), kt(n).bigHour = !0;
});
Mn("hmmss", function(t, e, n) {
  var r = t.length - 4, o = t.length - 2;
  e[Dr] = Ft(t.substr(0, r)), e[ws] = Ft(t.substr(r, 2)), e[bl] = Ft(t.substr(o)), kt(n).bigHour = !0;
});
Mn("Hmm", function(t, e, n) {
  var r = t.length - 2;
  e[Dr] = Ft(t.substr(0, r)), e[ws] = Ft(t.substr(r));
});
Mn("Hmmss", function(t, e, n) {
  var r = t.length - 4, o = t.length - 2;
  e[Dr] = Ft(t.substr(0, r)), e[ws] = Ft(t.substr(r, 2)), e[bl] = Ft(t.substr(o));
});
function l$e(t) {
  return (t + "").toLowerCase().charAt(0) === "p";
}
var c$e = /[ap]\.?m?\.?/i, u$e = xp("Hours", !0);
function d$e(t, e, n) {
  return t > 11 ? n ? "pm" : "PM" : n ? "am" : "AM";
}
var jae = {
  calendar: JRe,
  longDateFormat: rPe,
  invalidDate: iPe,
  ordinal: aPe,
  dayOfMonthOrdinalParse: lPe,
  relativeTime: uPe,
  months: CPe,
  monthsShort: Aae,
  week: LPe,
  weekdays: VPe,
  weekdaysMin: WPe,
  weekdaysShort: Dae,
  meridiemParse: c$e
}, Jn = {}, Jp = {}, $0;
function f$e(t, e) {
  var n, r = Math.min(t.length, e.length);
  for (n = 0; n < r; n += 1)
    if (t[n] !== e[n])
      return n;
  return r;
}
function tF(t) {
  return t && t.toLowerCase().replace("_", "-");
}
function h$e(t) {
  for (var e = 0, n, r, o, i; e < t.length; ) {
    for (i = tF(t[e]).split("-"), n = i.length, r = tF(t[e + 1]), r = r ? r.split("-") : null; n > 0; ) {
      if (o = sS(i.slice(0, n).join("-")), o)
        return o;
      if (r && r.length >= n && f$e(i, r) >= n - 1)
        break;
      n--;
    }
    e++;
  }
  return $0;
}
function p$e(t) {
  return !!(t && t.match("^[^/\\\\]*$"));
}
function sS(t) {
  var e = null, n;
  if (Jn[t] === void 0 && typeof module < "u" && module && module.exports && p$e(t))
    try {
      e = $0._abbr, n = require, n("./locale/" + t), Uc(e);
    } catch {
      Jn[t] = null;
    }
  return Jn[t];
}
function Uc(t, e) {
  var n;
  return t && (Fo(e) ? n = Ul(t) : n = a5(t, e), n ? $0 = n : typeof console < "u" && console.warn && console.warn(
    "Locale " + t + " not found. Did you forget to load it?"
  )), $0._abbr;
}
function a5(t, e) {
  if (e !== null) {
    var n, r = jae;
    if (e.abbr = t, Jn[t] != null)
      _ae(
        "defineLocaleOverride",
        "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."
      ), r = Jn[t]._config;
    else if (e.parentLocale != null)
      if (Jn[e.parentLocale] != null)
        r = Jn[e.parentLocale]._config;
      else if (n = sS(e.parentLocale), n != null)
        r = n._config;
      else
        return Jp[e.parentLocale] || (Jp[e.parentLocale] = []), Jp[e.parentLocale].push({
          name: t,
          config: e
        }), null;
    return Jn[t] = new Q3(FD(r, e)), Jp[t] && Jp[t].forEach(function(o) {
      a5(o.name, o.config);
    }), Uc(t), Jn[t];
  } else
    return delete Jn[t], null;
}
function m$e(t, e) {
  if (e != null) {
    var n, r, o = jae;
    Jn[t] != null && Jn[t].parentLocale != null ? Jn[t].set(FD(Jn[t]._config, e)) : (r = sS(t), r != null && (o = r._config), e = FD(o, e), r == null && (e.abbr = t), n = new Q3(e), n.parentLocale = Jn[t], Jn[t] = n), Uc(t);
  } else
    Jn[t] != null && (Jn[t].parentLocale != null ? (Jn[t] = Jn[t].parentLocale, t === Uc() && Uc(t)) : Jn[t] != null && delete Jn[t]);
  return Jn[t];
}
function Ul(t) {
  var e;
  if (t && t._locale && t._locale._abbr && (t = t._locale._abbr), !t)
    return $0;
  if (!Ts(t)) {
    if (e = sS(t), e)
      return e;
    t = [t];
  }
  return h$e(t);
}
function g$e() {
  return BD(Jn);
}
function l5(t) {
  var e, n = t._a;
  return n && kt(t).overflow === -2 && (e = n[vl] < 0 || n[vl] > 11 ? vl : n[aa] < 1 || n[aa] > r5(n[fo], n[vl]) ? aa : n[Dr] < 0 || n[Dr] > 24 || n[Dr] === 24 && (n[ws] !== 0 || n[bl] !== 0 || n[Ju] !== 0) ? Dr : n[ws] < 0 || n[ws] > 59 ? ws : n[bl] < 0 || n[bl] > 59 ? bl : n[Ju] < 0 || n[Ju] > 999 ? Ju : -1, kt(t)._overflowDayOfYear && (e < fo || e > aa) && (e = aa), kt(t)._overflowWeeks && e === -1 && (e = _Pe), kt(t)._overflowWeekday && e === -1 && (e = wPe), kt(t).overflow = e), t;
}
var y$e = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, v$e = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, b$e = /Z|[+-]\d\d(?::?\d\d)?/, ub = [
  ["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/],
  ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/],
  ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/],
  ["GGGG-[W]WW", /\d{4}-W\d\d/, !1],
  ["YYYY-DDD", /\d{4}-\d{3}/],
  ["YYYY-MM", /\d{4}-\d\d/, !1],
  ["YYYYYYMMDD", /[+-]\d{10}/],
  ["YYYYMMDD", /\d{8}/],
  ["GGGG[W]WWE", /\d{4}W\d{3}/],
  ["GGGG[W]WW", /\d{4}W\d{2}/, !1],
  ["YYYYDDD", /\d{7}/],
  ["YYYYMM", /\d{6}/, !1],
  ["YYYY", /\d{4}/, !1]
], wC = [
  ["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/],
  ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/],
  ["HH:mm:ss", /\d\d:\d\d:\d\d/],
  ["HH:mm", /\d\d:\d\d/],
  ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/],
  ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/],
  ["HHmmss", /\d\d\d\d\d\d/],
  ["HHmm", /\d\d\d\d/],
  ["HH", /\d\d/]
], _$e = /^\/?Date\((-?\d+)/i, w$e = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, x$e = {
  UT: 0,
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};
function Lae(t) {
  var e, n, r = t._i, o = y$e.exec(r) || v$e.exec(r), i, s, a, l, c = ub.length, u = wC.length;
  if (o) {
    for (kt(t).iso = !0, e = 0, n = c; e < n; e++)
      if (ub[e][1].exec(o[1])) {
        s = ub[e][0], i = ub[e][2] !== !1;
        break;
      }
    if (s == null) {
      t._isValid = !1;
      return;
    }
    if (o[3]) {
      for (e = 0, n = u; e < n; e++)
        if (wC[e][1].exec(o[3])) {
          a = (o[2] || " ") + wC[e][0];
          break;
        }
      if (a == null) {
        t._isValid = !1;
        return;
      }
    }
    if (!i && a != null) {
      t._isValid = !1;
      return;
    }
    if (o[4])
      if (b$e.exec(o[4]))
        l = "Z";
      else {
        t._isValid = !1;
        return;
      }
    t._f = s + (a || "") + (l || ""), u5(t);
  } else
    t._isValid = !1;
}
function E$e(t, e, n, r, o, i) {
  var s = [
    S$e(t),
    Aae.indexOf(e),
    parseInt(n, 10),
    parseInt(r, 10),
    parseInt(o, 10)
  ];
  return i && s.push(parseInt(i, 10)), s;
}
function S$e(t) {
  var e = parseInt(t, 10);
  return e <= 49 ? 2e3 + e : e <= 999 ? 1900 + e : e;
}
function O$e(t) {
  return t.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
}
function C$e(t, e, n) {
  if (t) {
    var r = Dae.indexOf(t), o = new Date(
      e[0],
      e[1],
      e[2]
    ).getDay();
    if (r !== o)
      return kt(n).weekdayMismatch = !0, n._isValid = !1, !1;
  }
  return !0;
}
function k$e(t, e, n) {
  if (t)
    return x$e[t];
  if (e)
    return 0;
  var r = parseInt(n, 10), o = r % 100, i = (r - o) / 100;
  return i * 60 + o;
}
function Fae(t) {
  var e = w$e.exec(O$e(t._i)), n;
  if (e) {
    if (n = E$e(
      e[4],
      e[3],
      e[2],
      e[5],
      e[6],
      e[7]
    ), !C$e(e[1], n, t))
      return;
    t._a = n, t._tzm = k$e(e[8], e[9], e[10]), t._d = R0.apply(null, t._a), t._d.setUTCMinutes(t._d.getUTCMinutes() - t._tzm), kt(t).rfc2822 = !0;
  } else
    t._isValid = !1;
}
function A$e(t) {
  var e = _$e.exec(t._i);
  if (e !== null) {
    t._d = /* @__PURE__ */ new Date(+e[1]);
    return;
  }
  if (Lae(t), t._isValid === !1)
    delete t._isValid;
  else
    return;
  if (Fae(t), t._isValid === !1)
    delete t._isValid;
  else
    return;
  t._strict ? t._isValid = !1 : qe.createFromInputFallback(t);
}
qe.createFromInputFallback = os(
  "value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.",
  function(t) {
    t._d = /* @__PURE__ */ new Date(t._i + (t._useUTC ? " UTC" : ""));
  }
);
function Rf(t, e, n) {
  return t ?? e ?? n;
}
function T$e(t) {
  var e = new Date(qe.now());
  return t._useUTC ? [
    e.getUTCFullYear(),
    e.getUTCMonth(),
    e.getUTCDate()
  ] : [e.getFullYear(), e.getMonth(), e.getDate()];
}
function c5(t) {
  var e, n, r = [], o, i, s;
  if (!t._d) {
    for (o = T$e(t), t._w && t._a[aa] == null && t._a[vl] == null && R$e(t), t._dayOfYear != null && (s = Rf(t._a[fo], o[fo]), (t._dayOfYear > Ug(s) || t._dayOfYear === 0) && (kt(t)._overflowDayOfYear = !0), n = R0(s, 0, t._dayOfYear), t._a[vl] = n.getUTCMonth(), t._a[aa] = n.getUTCDate()), e = 0; e < 3 && t._a[e] == null; ++e)
      t._a[e] = r[e] = o[e];
    for (; e < 7; e++)
      t._a[e] = r[e] = t._a[e] == null ? e === 2 ? 1 : 0 : t._a[e];
    t._a[Dr] === 24 && t._a[ws] === 0 && t._a[bl] === 0 && t._a[Ju] === 0 && (t._nextDay = !0, t._a[Dr] = 0), t._d = (t._useUTC ? R0 : NPe).apply(
      null,
      r
    ), i = t._useUTC ? t._d.getUTCDay() : t._d.getDay(), t._tzm != null && t._d.setUTCMinutes(t._d.getUTCMinutes() - t._tzm), t._nextDay && (t._a[Dr] = 24), t._w && typeof t._w.d < "u" && t._w.d !== i && (kt(t).weekdayMismatch = !0);
  }
}
function R$e(t) {
  var e, n, r, o, i, s, a, l, c;
  e = t._w, e.GG != null || e.W != null || e.E != null ? (i = 1, s = 4, n = Rf(
    e.GG,
    t._a[fo],
    P0(Xn(), 1, 4).year
  ), r = Rf(e.W, 1), o = Rf(e.E, 1), (o < 1 || o > 7) && (l = !0)) : (i = t._locale._week.dow, s = t._locale._week.doy, c = P0(Xn(), i, s), n = Rf(e.gg, t._a[fo], c.year), r = Rf(e.w, c.week), e.d != null ? (o = e.d, (o < 0 || o > 6) && (l = !0)) : e.e != null ? (o = e.e + i, (e.e < 0 || e.e > 6) && (l = !0)) : o = i), r < 1 || r > Al(n, i, s) ? kt(t)._overflowWeeks = !0 : l != null ? kt(t)._overflowWeekday = !0 : (a = Mae(n, r, o, i, s), t._a[fo] = a.year, t._dayOfYear = a.dayOfYear);
}
qe.ISO_8601 = function() {
};
qe.RFC_2822 = function() {
};
function u5(t) {
  if (t._f === qe.ISO_8601) {
    Lae(t);
    return;
  }
  if (t._f === qe.RFC_2822) {
    Fae(t);
    return;
  }
  t._a = [], kt(t).empty = !0;
  var e = "" + t._i, n, r, o, i, s, a = e.length, l = 0, c, u;
  for (o = wae(t._f, t._locale).match(Z3) || [], u = o.length, n = 0; n < u; n++)
    i = o[n], r = (e.match(yPe(i, t)) || [])[0], r && (s = e.substr(0, e.indexOf(r)), s.length > 0 && kt(t).unusedInput.push(s), e = e.slice(
      e.indexOf(r) + r.length
    ), l += r.length), ch[i] ? (r ? kt(t).empty = !1 : kt(t).unusedTokens.push(i), bPe(i, r, t)) : t._strict && !r && kt(t).unusedTokens.push(i);
  kt(t).charsLeftOver = a - l, e.length > 0 && kt(t).unusedInput.push(e), t._a[Dr] <= 12 && kt(t).bigHour === !0 && t._a[Dr] > 0 && (kt(t).bigHour = void 0), kt(t).parsedDateParts = t._a.slice(0), kt(t).meridiem = t._meridiem, t._a[Dr] = P$e(
    t._locale,
    t._a[Dr],
    t._meridiem
  ), c = kt(t).era, c !== null && (t._a[fo] = t._locale.erasConvertYear(c, t._a[fo])), c5(t), l5(t);
}
function P$e(t, e, n) {
  var r;
  return n == null ? e : t.meridiemHour != null ? t.meridiemHour(e, n) : (t.isPM != null && (r = t.isPM(n), r && e < 12 && (e += 12), !r && e === 12 && (e = 0)), e);
}
function $$e(t) {
  var e, n, r, o, i, s, a = !1, l = t._f.length;
  if (l === 0) {
    kt(t).invalidFormat = !0, t._d = /* @__PURE__ */ new Date(NaN);
    return;
  }
  for (o = 0; o < l; o++)
    i = 0, s = !1, e = X3({}, t), t._useUTC != null && (e._useUTC = t._useUTC), e._f = t._f[o], u5(e), K3(e) && (s = !0), i += kt(e).charsLeftOver, i += kt(e).unusedTokens.length * 10, kt(e).score = i, a ? i < r && (r = i, n = e) : (r == null || i < r || s) && (r = i, n = e, s && (a = !0));
  Tc(t, n || e);
}
function M$e(t) {
  if (!t._d) {
    var e = J3(t._i), n = e.day === void 0 ? e.date : e.day;
    t._a = vae(
      [e.year, e.month, n, e.hour, e.minute, e.second, e.millisecond],
      function(r) {
        return r && parseInt(r, 10);
      }
    ), c5(t);
  }
}
function D$e(t) {
  var e = new ev(l5(Bae(t)));
  return e._nextDay && (e.add(1, "d"), e._nextDay = void 0), e;
}
function Bae(t) {
  var e = t._i, n = t._f;
  return t._locale = t._locale || Ul(t._l), e === null || n === void 0 && e === "" ? JE({ nullInput: !0 }) : (typeof e == "string" && (t._i = e = t._locale.preparse(e)), Rs(e) ? new ev(l5(e)) : (Jy(e) ? t._d = e : Ts(n) ? $$e(t) : n ? u5(t) : I$e(t), K3(t) || (t._d = null), t));
}
function I$e(t) {
  var e = t._i;
  Fo(e) ? t._d = new Date(qe.now()) : Jy(e) ? t._d = new Date(e.valueOf()) : typeof e == "string" ? A$e(t) : Ts(e) ? (t._a = vae(e.slice(0), function(n) {
    return parseInt(n, 10);
  }), c5(t)) : pd(e) ? M$e(t) : Ml(e) ? t._d = new Date(e) : qe.createFromInputFallback(t);
}
function zae(t, e, n, r, o) {
  var i = {};
  return (e === !0 || e === !1) && (r = e, e = void 0), (n === !0 || n === !1) && (r = n, n = void 0), (pd(t) && Y3(t) || Ts(t) && t.length === 0) && (t = void 0), i._isAMomentObject = !0, i._useUTC = i._isUTC = o, i._l = n, i._i = t, i._f = e, i._strict = r, D$e(i);
}
function Xn(t, e, n, r) {
  return zae(t, e, n, r, !1);
}
var N$e = os(
  "moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var t = Xn.apply(null, arguments);
    return this.isValid() && t.isValid() ? t < this ? this : t : JE();
  }
), j$e = os(
  "moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var t = Xn.apply(null, arguments);
    return this.isValid() && t.isValid() ? t > this ? this : t : JE();
  }
);
function qae(t, e) {
  var n, r;
  if (e.length === 1 && Ts(e[0]) && (e = e[0]), !e.length)
    return Xn();
  for (n = e[0], r = 1; r < e.length; ++r)
    (!e[r].isValid() || e[r][t](n)) && (n = e[r]);
  return n;
}
function L$e() {
  var t = [].slice.call(arguments, 0);
  return qae("isBefore", t);
}
function F$e() {
  var t = [].slice.call(arguments, 0);
  return qae("isAfter", t);
}
var B$e = function() {
  return Date.now ? Date.now() : +/* @__PURE__ */ new Date();
}, em = [
  "year",
  "quarter",
  "month",
  "week",
  "day",
  "hour",
  "minute",
  "second",
  "millisecond"
];
function z$e(t) {
  var e, n = !1, r, o = em.length;
  for (e in t)
    if (Zt(t, e) && !(vr.call(em, e) !== -1 && (t[e] == null || !isNaN(t[e]))))
      return !1;
  for (r = 0; r < o; ++r)
    if (t[em[r]]) {
      if (n)
        return !1;
      parseFloat(t[em[r]]) !== Ft(t[em[r]]) && (n = !0);
    }
  return !0;
}
function q$e() {
  return this._isValid;
}
function U$e() {
  return Ms(NaN);
}
function aS(t) {
  var e = J3(t), n = e.year || 0, r = e.quarter || 0, o = e.month || 0, i = e.week || e.isoWeek || 0, s = e.day || 0, a = e.hour || 0, l = e.minute || 0, c = e.second || 0, u = e.millisecond || 0;
  this._isValid = z$e(e), this._milliseconds = +u + c * 1e3 + // 1000
  l * 6e4 + // 1000 * 60
  a * 1e3 * 60 * 60, this._days = +s + i * 7, this._months = +o + r * 3 + n * 12, this._data = {}, this._locale = Ul(), this._bubble();
}
function V_(t) {
  return t instanceof aS;
}
function qD(t) {
  return t < 0 ? Math.round(-1 * t) * -1 : Math.round(t);
}
function H$e(t, e, n) {
  var r = Math.min(t.length, e.length), o = Math.abs(t.length - e.length), i = 0, s;
  for (s = 0; s < r; s++)
    Ft(t[s]) !== Ft(e[s]) && i++;
  return i + o;
}
function Uae(t, e) {
  ht(t, 0, 0, function() {
    var n = this.utcOffset(), r = "+";
    return n < 0 && (n = -n, r = "-"), r + Ea(~~(n / 60), 2) + e + Ea(~~n % 60, 2);
  });
}
Uae("Z", ":");
Uae("ZZ", "");
it("Z", oS);
it("ZZ", oS);
Mn(["Z", "ZZ"], function(t, e, n) {
  n._useUTC = !0, n._tzm = d5(oS, t);
});
var V$e = /([\+\-]|\d\d)/gi;
function d5(t, e) {
  var n = (e || "").match(t), r, o, i;
  return n === null ? null : (r = n[n.length - 1] || [], o = (r + "").match(V$e) || ["-", 0, 0], i = +(o[1] * 60) + Ft(o[2]), i === 0 ? 0 : o[0] === "+" ? i : -i);
}
function f5(t, e) {
  var n, r;
  return e._isUTC ? (n = e.clone(), r = (Rs(t) || Jy(t) ? t.valueOf() : Xn(t).valueOf()) - n.valueOf(), n._d.setTime(n._d.valueOf() + r), qe.updateOffset(n, !1), n) : Xn(t).local();
}
function UD(t) {
  return -Math.round(t._d.getTimezoneOffset());
}
qe.updateOffset = function() {
};
function W$e(t, e, n) {
  var r = this._offset || 0, o;
  if (!this.isValid())
    return t != null ? this : NaN;
  if (t != null) {
    if (typeof t == "string") {
      if (t = d5(oS, t), t === null)
        return this;
    } else Math.abs(t) < 16 && !n && (t = t * 60);
    return !this._isUTC && e && (o = UD(this)), this._offset = t, this._isUTC = !0, o != null && this.add(o, "m"), r !== t && (!e || this._changeInProgress ? Wae(
      this,
      Ms(t - r, "m"),
      1,
      !1
    ) : this._changeInProgress || (this._changeInProgress = !0, qe.updateOffset(this, !0), this._changeInProgress = null)), this;
  } else
    return this._isUTC ? r : UD(this);
}
function G$e(t, e) {
  return t != null ? (typeof t != "string" && (t = -t), this.utcOffset(t, e), this) : -this.utcOffset();
}
function Y$e(t) {
  return this.utcOffset(0, t);
}
function K$e(t) {
  return this._isUTC && (this.utcOffset(0, t), this._isUTC = !1, t && this.subtract(UD(this), "m")), this;
}
function X$e() {
  if (this._tzm != null)
    this.utcOffset(this._tzm, !1, !0);
  else if (typeof this._i == "string") {
    var t = d5(mPe, this._i);
    t != null ? this.utcOffset(t) : this.utcOffset(0, !0);
  }
  return this;
}
function Q$e(t) {
  return this.isValid() ? (t = t ? Xn(t).utcOffset() : 0, (this.utcOffset() - t) % 60 === 0) : !1;
}
function Z$e() {
  return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
}
function J$e() {
  if (!Fo(this._isDSTShifted))
    return this._isDSTShifted;
  var t = {}, e;
  return X3(t, this), t = Bae(t), t._a ? (e = t._isUTC ? ka(t._a) : Xn(t._a), this._isDSTShifted = this.isValid() && H$e(t._a, e.toArray()) > 0) : this._isDSTShifted = !1, this._isDSTShifted;
}
function eMe() {
  return this.isValid() ? !this._isUTC : !1;
}
function tMe() {
  return this.isValid() ? this._isUTC : !1;
}
function Hae() {
  return this.isValid() ? this._isUTC && this._offset === 0 : !1;
}
var nMe = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, rMe = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
function Ms(t, e) {
  var n = t, r = null, o, i, s;
  return V_(t) ? n = {
    ms: t._milliseconds,
    d: t._days,
    M: t._months
  } : Ml(t) || !isNaN(+t) ? (n = {}, e ? n[e] = +t : n.milliseconds = +t) : (r = nMe.exec(t)) ? (o = r[1] === "-" ? -1 : 1, n = {
    y: 0,
    d: Ft(r[aa]) * o,
    h: Ft(r[Dr]) * o,
    m: Ft(r[ws]) * o,
    s: Ft(r[bl]) * o,
    ms: Ft(qD(r[Ju] * 1e3)) * o
    // the millisecond decimal point is included in the match
  }) : (r = rMe.exec(t)) ? (o = r[1] === "-" ? -1 : 1, n = {
    y: gu(r[2], o),
    M: gu(r[3], o),
    w: gu(r[4], o),
    d: gu(r[5], o),
    h: gu(r[6], o),
    m: gu(r[7], o),
    s: gu(r[8], o)
  }) : n == null ? n = {} : typeof n == "object" && ("from" in n || "to" in n) && (s = oMe(
    Xn(n.from),
    Xn(n.to)
  ), n = {}, n.ms = s.milliseconds, n.M = s.months), i = new aS(n), V_(t) && Zt(t, "_locale") && (i._locale = t._locale), V_(t) && Zt(t, "_isValid") && (i._isValid = t._isValid), i;
}
Ms.fn = aS.prototype;
Ms.invalid = U$e;
function gu(t, e) {
  var n = t && parseFloat(t.replace(",", "."));
  return (isNaN(n) ? 0 : n) * e;
}
function nF(t, e) {
  var n = {};
  return n.months = e.month() - t.month() + (e.year() - t.year()) * 12, t.clone().add(n.months, "M").isAfter(e) && --n.months, n.milliseconds = +e - +t.clone().add(n.months, "M"), n;
}
function oMe(t, e) {
  var n;
  return t.isValid() && e.isValid() ? (e = f5(e, t), t.isBefore(e) ? n = nF(t, e) : (n = nF(e, t), n.milliseconds = -n.milliseconds, n.months = -n.months), n) : { milliseconds: 0, months: 0 };
}
function Vae(t, e) {
  return function(n, r) {
    var o, i;
    return r !== null && !isNaN(+r) && (_ae(
      e,
      "moment()." + e + "(period, number) is deprecated. Please use moment()." + e + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."
    ), i = n, n = r, r = i), o = Ms(n, r), Wae(this, o, t), this;
  };
}
function Wae(t, e, n, r) {
  var o = e._milliseconds, i = qD(e._days), s = qD(e._months);
  t.isValid() && (r = r ?? !0, s && Rae(t, T0(t, "Month") + s * n), i && kae(t, "Date", T0(t, "Date") + i * n), o && t._d.setTime(t._d.valueOf() + o * n), r && qe.updateOffset(t, i || s));
}
var iMe = Vae(1, "add"), sMe = Vae(-1, "subtract");
function Gae(t) {
  return typeof t == "string" || t instanceof String;
}
function aMe(t) {
  return Rs(t) || Jy(t) || Gae(t) || Ml(t) || cMe(t) || lMe(t) || t === null || t === void 0;
}
function lMe(t) {
  var e = pd(t) && !Y3(t), n = !1, r = [
    "years",
    "year",
    "y",
    "months",
    "month",
    "M",
    "days",
    "day",
    "d",
    "dates",
    "date",
    "D",
    "hours",
    "hour",
    "h",
    "minutes",
    "minute",
    "m",
    "seconds",
    "second",
    "s",
    "milliseconds",
    "millisecond",
    "ms"
  ], o, i, s = r.length;
  for (o = 0; o < s; o += 1)
    i = r[o], n = n || Zt(t, i);
  return e && n;
}
function cMe(t) {
  var e = Ts(t), n = !1;
  return e && (n = t.filter(function(r) {
    return !Ml(r) && Gae(t);
  }).length === 0), e && n;
}
function uMe(t) {
  var e = pd(t) && !Y3(t), n = !1, r = [
    "sameDay",
    "nextDay",
    "lastDay",
    "nextWeek",
    "lastWeek",
    "sameElse"
  ], o, i;
  for (o = 0; o < r.length; o += 1)
    i = r[o], n = n || Zt(t, i);
  return e && n;
}
function dMe(t, e) {
  var n = t.diff(e, "days", !0);
  return n < -6 ? "sameElse" : n < -1 ? "lastWeek" : n < 0 ? "lastDay" : n < 1 ? "sameDay" : n < 2 ? "nextDay" : n < 7 ? "nextWeek" : "sameElse";
}
function fMe(t, e) {
  arguments.length === 1 && (arguments[0] ? aMe(arguments[0]) ? (t = arguments[0], e = void 0) : uMe(arguments[0]) && (e = arguments[0], t = void 0) : (t = void 0, e = void 0));
  var n = t || Xn(), r = f5(n, this).startOf("day"), o = qe.calendarFormat(this, r) || "sameElse", i = e && (Aa(e[o]) ? e[o].call(this, n) : e[o]);
  return this.format(
    i || this.localeData().calendar(o, this, Xn(n))
  );
}
function hMe() {
  return new ev(this);
}
function pMe(t, e) {
  var n = Rs(t) ? t : Xn(t);
  return this.isValid() && n.isValid() ? (e = is(e) || "millisecond", e === "millisecond" ? this.valueOf() > n.valueOf() : n.valueOf() < this.clone().startOf(e).valueOf()) : !1;
}
function mMe(t, e) {
  var n = Rs(t) ? t : Xn(t);
  return this.isValid() && n.isValid() ? (e = is(e) || "millisecond", e === "millisecond" ? this.valueOf() < n.valueOf() : this.clone().endOf(e).valueOf() < n.valueOf()) : !1;
}
function gMe(t, e, n, r) {
  var o = Rs(t) ? t : Xn(t), i = Rs(e) ? e : Xn(e);
  return this.isValid() && o.isValid() && i.isValid() ? (r = r || "()", (r[0] === "(" ? this.isAfter(o, n) : !this.isBefore(o, n)) && (r[1] === ")" ? this.isBefore(i, n) : !this.isAfter(i, n))) : !1;
}
function yMe(t, e) {
  var n = Rs(t) ? t : Xn(t), r;
  return this.isValid() && n.isValid() ? (e = is(e) || "millisecond", e === "millisecond" ? this.valueOf() === n.valueOf() : (r = n.valueOf(), this.clone().startOf(e).valueOf() <= r && r <= this.clone().endOf(e).valueOf())) : !1;
}
function vMe(t, e) {
  return this.isSame(t, e) || this.isAfter(t, e);
}
function bMe(t, e) {
  return this.isSame(t, e) || this.isBefore(t, e);
}
function _Me(t, e, n) {
  var r, o, i;
  if (!this.isValid())
    return NaN;
  if (r = f5(t, this), !r.isValid())
    return NaN;
  switch (o = (r.utcOffset() - this.utcOffset()) * 6e4, e = is(e), e) {
    case "year":
      i = W_(this, r) / 12;
      break;
    case "month":
      i = W_(this, r);
      break;
    case "quarter":
      i = W_(this, r) / 3;
      break;
    case "second":
      i = (this - r) / 1e3;
      break;
    // 1000
    case "minute":
      i = (this - r) / 6e4;
      break;
    // 1000 * 60
    case "hour":
      i = (this - r) / 36e5;
      break;
    // 1000 * 60 * 60
    case "day":
      i = (this - r - o) / 864e5;
      break;
    // 1000 * 60 * 60 * 24, negate dst
    case "week":
      i = (this - r - o) / 6048e5;
      break;
    // 1000 * 60 * 60 * 24 * 7, negate dst
    default:
      i = this - r;
  }
  return n ? i : Fi(i);
}
function W_(t, e) {
  if (t.date() < e.date())
    return -W_(e, t);
  var n = (e.year() - t.year()) * 12 + (e.month() - t.month()), r = t.clone().add(n, "months"), o, i;
  return e - r < 0 ? (o = t.clone().add(n - 1, "months"), i = (e - r) / (r - o)) : (o = t.clone().add(n + 1, "months"), i = (e - r) / (o - r)), -(n + i) || 0;
}
qe.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
qe.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
function wMe() {
  return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
}
function xMe(t) {
  if (!this.isValid())
    return null;
  var e = t !== !0, n = e ? this.clone().utc() : this;
  return n.year() < 0 || n.year() > 9999 ? H_(
    n,
    e ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ"
  ) : Aa(Date.prototype.toISOString) ? e ? this.toDate().toISOString() : new Date(this.valueOf() + this.utcOffset() * 60 * 1e3).toISOString().replace("Z", H_(n, "Z")) : H_(
    n,
    e ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ"
  );
}
function EMe() {
  if (!this.isValid())
    return "moment.invalid(/* " + this._i + " */)";
  var t = "moment", e = "", n, r, o, i;
  return this.isLocal() || (t = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone", e = "Z"), n = "[" + t + '("]', r = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY", o = "-MM-DD[T]HH:mm:ss.SSS", i = e + '[")]', this.format(n + r + o + i);
}
function SMe(t) {
  t || (t = this.isUtc() ? qe.defaultFormatUtc : qe.defaultFormat);
  var e = H_(this, t);
  return this.localeData().postformat(e);
}
function OMe(t, e) {
  return this.isValid() && (Rs(t) && t.isValid() || Xn(t).isValid()) ? Ms({ to: this, from: t }).locale(this.locale()).humanize(!e) : this.localeData().invalidDate();
}
function CMe(t) {
  return this.from(Xn(), t);
}
function kMe(t, e) {
  return this.isValid() && (Rs(t) && t.isValid() || Xn(t).isValid()) ? Ms({ from: this, to: t }).locale(this.locale()).humanize(!e) : this.localeData().invalidDate();
}
function AMe(t) {
  return this.to(Xn(), t);
}
function Yae(t) {
  var e;
  return t === void 0 ? this._locale._abbr : (e = Ul(t), e != null && (this._locale = e), this);
}
var Kae = os(
  "moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.",
  function(t) {
    return t === void 0 ? this.localeData() : this.locale(t);
  }
);
function Xae() {
  return this._locale;
}
var Zw = 1e3, uh = 60 * Zw, Jw = 60 * uh, Qae = (365 * 400 + 97) * 24 * Jw;
function dh(t, e) {
  return (t % e + e) % e;
}
function Zae(t, e, n) {
  return t < 100 && t >= 0 ? new Date(t + 400, e, n) - Qae : new Date(t, e, n).valueOf();
}
function Jae(t, e, n) {
  return t < 100 && t >= 0 ? Date.UTC(t + 400, e, n) - Qae : Date.UTC(t, e, n);
}
function TMe(t) {
  var e, n;
  if (t = is(t), t === void 0 || t === "millisecond" || !this.isValid())
    return this;
  switch (n = this._isUTC ? Jae : Zae, t) {
    case "year":
      e = n(this.year(), 0, 1);
      break;
    case "quarter":
      e = n(
        this.year(),
        this.month() - this.month() % 3,
        1
      );
      break;
    case "month":
      e = n(this.year(), this.month(), 1);
      break;
    case "week":
      e = n(
        this.year(),
        this.month(),
        this.date() - this.weekday()
      );
      break;
    case "isoWeek":
      e = n(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1)
      );
      break;
    case "day":
    case "date":
      e = n(this.year(), this.month(), this.date());
      break;
    case "hour":
      e = this._d.valueOf(), e -= dh(
        e + (this._isUTC ? 0 : this.utcOffset() * uh),
        Jw
      );
      break;
    case "minute":
      e = this._d.valueOf(), e -= dh(e, uh);
      break;
    case "second":
      e = this._d.valueOf(), e -= dh(e, Zw);
      break;
  }
  return this._d.setTime(e), qe.updateOffset(this, !0), this;
}
function RMe(t) {
  var e, n;
  if (t = is(t), t === void 0 || t === "millisecond" || !this.isValid())
    return this;
  switch (n = this._isUTC ? Jae : Zae, t) {
    case "year":
      e = n(this.year() + 1, 0, 1) - 1;
      break;
    case "quarter":
      e = n(
        this.year(),
        this.month() - this.month() % 3 + 3,
        1
      ) - 1;
      break;
    case "month":
      e = n(this.year(), this.month() + 1, 1) - 1;
      break;
    case "week":
      e = n(
        this.year(),
        this.month(),
        this.date() - this.weekday() + 7
      ) - 1;
      break;
    case "isoWeek":
      e = n(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1) + 7
      ) - 1;
      break;
    case "day":
    case "date":
      e = n(this.year(), this.month(), this.date() + 1) - 1;
      break;
    case "hour":
      e = this._d.valueOf(), e += Jw - dh(
        e + (this._isUTC ? 0 : this.utcOffset() * uh),
        Jw
      ) - 1;
      break;
    case "minute":
      e = this._d.valueOf(), e += uh - dh(e, uh) - 1;
      break;
    case "second":
      e = this._d.valueOf(), e += Zw - dh(e, Zw) - 1;
      break;
  }
  return this._d.setTime(e), qe.updateOffset(this, !0), this;
}
function PMe() {
  return this._d.valueOf() - (this._offset || 0) * 6e4;
}
function $Me() {
  return Math.floor(this.valueOf() / 1e3);
}
function MMe() {
  return new Date(this.valueOf());
}
function DMe() {
  var t = this;
  return [
    t.year(),
    t.month(),
    t.date(),
    t.hour(),
    t.minute(),
    t.second(),
    t.millisecond()
  ];
}
function IMe() {
  var t = this;
  return {
    years: t.year(),
    months: t.month(),
    date: t.date(),
    hours: t.hours(),
    minutes: t.minutes(),
    seconds: t.seconds(),
    milliseconds: t.milliseconds()
  };
}
function NMe() {
  return this.isValid() ? this.toISOString() : null;
}
function jMe() {
  return K3(this);
}
function LMe() {
  return Tc({}, kt(this));
}
function FMe() {
  return kt(this).overflow;
}
function BMe() {
  return {
    input: this._i,
    format: this._f,
    locale: this._locale,
    isUTC: this._isUTC,
    strict: this._strict
  };
}
ht("N", 0, 0, "eraAbbr");
ht("NN", 0, 0, "eraAbbr");
ht("NNN", 0, 0, "eraAbbr");
ht("NNNN", 0, 0, "eraName");
ht("NNNNN", 0, 0, "eraNarrow");
ht("y", ["y", 1], "yo", "eraYear");
ht("y", ["yy", 2], 0, "eraYear");
ht("y", ["yyy", 3], 0, "eraYear");
ht("y", ["yyyy", 4], 0, "eraYear");
it("N", h5);
it("NN", h5);
it("NNN", h5);
it("NNNN", QMe);
it("NNNNN", ZMe);
Mn(
  ["N", "NN", "NNN", "NNNN", "NNNNN"],
  function(t, e, n, r) {
    var o = n._locale.erasParse(t, r, n._strict);
    o ? kt(n).era = o : kt(n).invalidEra = t;
  }
);
it("y", _p);
it("yy", _p);
it("yyy", _p);
it("yyyy", _p);
it("yo", JMe);
Mn(["y", "yy", "yyy", "yyyy"], fo);
Mn(["yo"], function(t, e, n, r) {
  var o;
  n._locale._eraYearOrdinalRegex && (o = t.match(n._locale._eraYearOrdinalRegex)), n._locale.eraYearOrdinalParse ? e[fo] = n._locale.eraYearOrdinalParse(t, o) : e[fo] = parseInt(t, 10);
});
function zMe(t, e) {
  var n, r, o, i = this._eras || Ul("en")._eras;
  for (n = 0, r = i.length; n < r; ++n) {
    switch (typeof i[n].since) {
      case "string":
        o = qe(i[n].since).startOf("day"), i[n].since = o.valueOf();
        break;
    }
    switch (typeof i[n].until) {
      case "undefined":
        i[n].until = 1 / 0;
        break;
      case "string":
        o = qe(i[n].until).startOf("day").valueOf(), i[n].until = o.valueOf();
        break;
    }
  }
  return i;
}
function qMe(t, e, n) {
  var r, o, i = this.eras(), s, a, l;
  for (t = t.toUpperCase(), r = 0, o = i.length; r < o; ++r)
    if (s = i[r].name.toUpperCase(), a = i[r].abbr.toUpperCase(), l = i[r].narrow.toUpperCase(), n)
      switch (e) {
        case "N":
        case "NN":
        case "NNN":
          if (a === t)
            return i[r];
          break;
        case "NNNN":
          if (s === t)
            return i[r];
          break;
        case "NNNNN":
          if (l === t)
            return i[r];
          break;
      }
    else if ([s, a, l].indexOf(t) >= 0)
      return i[r];
}
function UMe(t, e) {
  var n = t.since <= t.until ? 1 : -1;
  return e === void 0 ? qe(t.since).year() : qe(t.since).year() + (e - t.offset) * n;
}
function HMe() {
  var t, e, n, r = this.localeData().eras();
  for (t = 0, e = r.length; t < e; ++t)
    if (n = this.clone().startOf("day").valueOf(), r[t].since <= n && n <= r[t].until || r[t].until <= n && n <= r[t].since)
      return r[t].name;
  return "";
}
function VMe() {
  var t, e, n, r = this.localeData().eras();
  for (t = 0, e = r.length; t < e; ++t)
    if (n = this.clone().startOf("day").valueOf(), r[t].since <= n && n <= r[t].until || r[t].until <= n && n <= r[t].since)
      return r[t].narrow;
  return "";
}
function WMe() {
  var t, e, n, r = this.localeData().eras();
  for (t = 0, e = r.length; t < e; ++t)
    if (n = this.clone().startOf("day").valueOf(), r[t].since <= n && n <= r[t].until || r[t].until <= n && n <= r[t].since)
      return r[t].abbr;
  return "";
}
function GMe() {
  var t, e, n, r, o = this.localeData().eras();
  for (t = 0, e = o.length; t < e; ++t)
    if (n = o[t].since <= o[t].until ? 1 : -1, r = this.clone().startOf("day").valueOf(), o[t].since <= r && r <= o[t].until || o[t].until <= r && r <= o[t].since)
      return (this.year() - qe(o[t].since).year()) * n + o[t].offset;
  return this.year();
}
function YMe(t) {
  return Zt(this, "_erasNameRegex") || p5.call(this), t ? this._erasNameRegex : this._erasRegex;
}
function KMe(t) {
  return Zt(this, "_erasAbbrRegex") || p5.call(this), t ? this._erasAbbrRegex : this._erasRegex;
}
function XMe(t) {
  return Zt(this, "_erasNarrowRegex") || p5.call(this), t ? this._erasNarrowRegex : this._erasRegex;
}
function h5(t, e) {
  return e.erasAbbrRegex(t);
}
function QMe(t, e) {
  return e.erasNameRegex(t);
}
function ZMe(t, e) {
  return e.erasNarrowRegex(t);
}
function JMe(t, e) {
  return e._eraYearOrdinalRegex || _p;
}
function p5() {
  var t = [], e = [], n = [], r = [], o, i, s, a, l, c = this.eras();
  for (o = 0, i = c.length; o < i; ++o)
    s = kl(c[o].name), a = kl(c[o].abbr), l = kl(c[o].narrow), e.push(s), t.push(a), n.push(l), r.push(s), r.push(a), r.push(l);
  this._erasRegex = new RegExp("^(" + r.join("|") + ")", "i"), this._erasNameRegex = new RegExp("^(" + e.join("|") + ")", "i"), this._erasAbbrRegex = new RegExp("^(" + t.join("|") + ")", "i"), this._erasNarrowRegex = new RegExp(
    "^(" + n.join("|") + ")",
    "i"
  );
}
ht(0, ["gg", 2], 0, function() {
  return this.weekYear() % 100;
});
ht(0, ["GG", 2], 0, function() {
  return this.isoWeekYear() % 100;
});
function lS(t, e) {
  ht(0, [t, t.length], 0, e);
}
lS("gggg", "weekYear");
lS("ggggg", "weekYear");
lS("GGGG", "isoWeekYear");
lS("GGGGG", "isoWeekYear");
it("G", rS);
it("g", rS);
it("GG", Qn, Pi);
it("gg", Qn, Pi);
it("GGGG", t5, e5);
it("gggg", t5, e5);
it("GGGGG", nS, eS);
it("ggggg", nS, eS);
nv(
  ["gggg", "ggggg", "GGGG", "GGGGG"],
  function(t, e, n, r) {
    e[r.substr(0, 2)] = Ft(t);
  }
);
nv(["gg", "GG"], function(t, e, n, r) {
  e[r] = qe.parseTwoDigitYear(t);
});
function eDe(t) {
  return ele.call(
    this,
    t,
    this.week(),
    this.weekday() + this.localeData()._week.dow,
    this.localeData()._week.dow,
    this.localeData()._week.doy
  );
}
function tDe(t) {
  return ele.call(
    this,
    t,
    this.isoWeek(),
    this.isoWeekday(),
    1,
    4
  );
}
function nDe() {
  return Al(this.year(), 1, 4);
}
function rDe() {
  return Al(this.isoWeekYear(), 1, 4);
}
function oDe() {
  var t = this.localeData()._week;
  return Al(this.year(), t.dow, t.doy);
}
function iDe() {
  var t = this.localeData()._week;
  return Al(this.weekYear(), t.dow, t.doy);
}
function ele(t, e, n, r, o) {
  var i;
  return t == null ? P0(this, r, o).year : (i = Al(t, r, o), e > i && (e = i), sDe.call(this, t, e, n, r, o));
}
function sDe(t, e, n, r, o) {
  var i = Mae(t, e, n, r, o), s = R0(i.year, 0, i.dayOfYear);
  return this.year(s.getUTCFullYear()), this.month(s.getUTCMonth()), this.date(s.getUTCDate()), this;
}
ht("Q", 0, "Qo", "quarter");
it("Q", xae);
Mn("Q", function(t, e) {
  e[vl] = (Ft(t) - 1) * 3;
});
function aDe(t) {
  return t == null ? Math.ceil((this.month() + 1) / 3) : this.month((t - 1) * 3 + this.month() % 3);
}
ht("D", ["DD", 2], "Do", "date");
it("D", Qn, wp);
it("DD", Qn, Pi);
it("Do", function(t, e) {
  return t ? e._dayOfMonthOrdinalParse || e._ordinalParse : e._dayOfMonthOrdinalParseLenient;
});
Mn(["D", "DD"], aa);
Mn("Do", function(t, e) {
  e[aa] = Ft(t.match(Qn)[0]);
});
var tle = xp("Date", !0);
ht("DDD", ["DDDD", 3], "DDDo", "dayOfYear");
it("DDD", tS);
it("DDDD", Eae);
Mn(["DDD", "DDDD"], function(t, e, n) {
  n._dayOfYear = Ft(t);
});
function lDe(t) {
  var e = Math.round(
    (this.clone().startOf("day") - this.clone().startOf("year")) / 864e5
  ) + 1;
  return t == null ? e : this.add(t - e, "d");
}
ht("m", ["mm", 2], 0, "minute");
it("m", Qn, n5);
it("mm", Qn, Pi);
Mn(["m", "mm"], ws);
var cDe = xp("Minutes", !1);
ht("s", ["ss", 2], 0, "second");
it("s", Qn, n5);
it("ss", Qn, Pi);
Mn(["s", "ss"], bl);
var uDe = xp("Seconds", !1);
ht("S", 0, 0, function() {
  return ~~(this.millisecond() / 100);
});
ht(0, ["SS", 2], 0, function() {
  return ~~(this.millisecond() / 10);
});
ht(0, ["SSS", 3], 0, "millisecond");
ht(0, ["SSSS", 4], 0, function() {
  return this.millisecond() * 10;
});
ht(0, ["SSSSS", 5], 0, function() {
  return this.millisecond() * 100;
});
ht(0, ["SSSSSS", 6], 0, function() {
  return this.millisecond() * 1e3;
});
ht(0, ["SSSSSSS", 7], 0, function() {
  return this.millisecond() * 1e4;
});
ht(0, ["SSSSSSSS", 8], 0, function() {
  return this.millisecond() * 1e5;
});
ht(0, ["SSSSSSSSS", 9], 0, function() {
  return this.millisecond() * 1e6;
});
it("S", tS, xae);
it("SS", tS, Pi);
it("SSS", tS, Eae);
var Rc, nle;
for (Rc = "SSSS"; Rc.length <= 9; Rc += "S")
  it(Rc, _p);
function dDe(t, e) {
  e[Ju] = Ft(("0." + t) * 1e3);
}
for (Rc = "S"; Rc.length <= 9; Rc += "S")
  Mn(Rc, dDe);
nle = xp("Milliseconds", !1);
ht("z", 0, 0, "zoneAbbr");
ht("zz", 0, 0, "zoneName");
function fDe() {
  return this._isUTC ? "UTC" : "";
}
function hDe() {
  return this._isUTC ? "Coordinated Universal Time" : "";
}
var Be = ev.prototype;
Be.add = iMe;
Be.calendar = fMe;
Be.clone = hMe;
Be.diff = _Me;
Be.endOf = RMe;
Be.format = SMe;
Be.from = OMe;
Be.fromNow = CMe;
Be.to = kMe;
Be.toNow = AMe;
Be.get = EPe;
Be.invalidAt = FMe;
Be.isAfter = pMe;
Be.isBefore = mMe;
Be.isBetween = gMe;
Be.isSame = yMe;
Be.isSameOrAfter = vMe;
Be.isSameOrBefore = bMe;
Be.isValid = jMe;
Be.lang = Kae;
Be.locale = Yae;
Be.localeData = Xae;
Be.max = j$e;
Be.min = N$e;
Be.parsingFlags = LMe;
Be.set = SPe;
Be.startOf = TMe;
Be.subtract = sMe;
Be.toArray = DMe;
Be.toObject = IMe;
Be.toDate = MMe;
Be.toISOString = xMe;
Be.inspect = EMe;
typeof Symbol < "u" && Symbol.for != null && (Be[Symbol.for("nodejs.util.inspect.custom")] = function() {
  return "Moment<" + this.format() + ">";
});
Be.toJSON = NMe;
Be.toString = wMe;
Be.unix = $Me;
Be.valueOf = PMe;
Be.creationData = BMe;
Be.eraName = HMe;
Be.eraNarrow = VMe;
Be.eraAbbr = WMe;
Be.eraYear = GMe;
Be.year = Cae;
Be.isLeapYear = xPe;
Be.weekYear = eDe;
Be.isoWeekYear = tDe;
Be.quarter = Be.quarters = aDe;
Be.month = Pae;
Be.daysInMonth = MPe;
Be.week = Be.weeks = zPe;
Be.isoWeek = Be.isoWeeks = qPe;
Be.weeksInYear = oDe;
Be.weeksInWeekYear = iDe;
Be.isoWeeksInYear = nDe;
Be.isoWeeksInISOWeekYear = rDe;
Be.date = tle;
Be.day = Be.days = t$e;
Be.weekday = n$e;
Be.isoWeekday = r$e;
Be.dayOfYear = lDe;
Be.hour = Be.hours = u$e;
Be.minute = Be.minutes = cDe;
Be.second = Be.seconds = uDe;
Be.millisecond = Be.milliseconds = nle;
Be.utcOffset = W$e;
Be.utc = Y$e;
Be.local = K$e;
Be.parseZone = X$e;
Be.hasAlignedHourOffset = Q$e;
Be.isDST = Z$e;
Be.isLocal = eMe;
Be.isUtcOffset = tMe;
Be.isUtc = Hae;
Be.isUTC = Hae;
Be.zoneAbbr = fDe;
Be.zoneName = hDe;
Be.dates = os(
  "dates accessor is deprecated. Use date instead.",
  tle
);
Be.months = os(
  "months accessor is deprecated. Use month instead",
  Pae
);
Be.years = os(
  "years accessor is deprecated. Use year instead",
  Cae
);
Be.zone = os(
  "moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/",
  G$e
);
Be.isDSTShifted = os(
  "isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information",
  J$e
);
function pDe(t) {
  return Xn(t * 1e3);
}
function mDe() {
  return Xn.apply(null, arguments).parseZone();
}
function rle(t) {
  return t;
}
var en = Q3.prototype;
en.calendar = ePe;
en.longDateFormat = oPe;
en.invalidDate = sPe;
en.ordinal = cPe;
en.preparse = rle;
en.postformat = rle;
en.relativeTime = dPe;
en.pastFuture = fPe;
en.set = ZRe;
en.eras = zMe;
en.erasParse = qMe;
en.erasConvertYear = UMe;
en.erasAbbrRegex = KMe;
en.erasNameRegex = YMe;
en.erasNarrowRegex = XMe;
en.months = TPe;
en.monthsShort = RPe;
en.monthsParse = $Pe;
en.monthsRegex = IPe;
en.monthsShortRegex = DPe;
en.week = jPe;
en.firstDayOfYear = BPe;
en.firstDayOfWeek = FPe;
en.weekdays = XPe;
en.weekdaysMin = ZPe;
en.weekdaysShort = QPe;
en.weekdaysParse = e$e;
en.weekdaysRegex = o$e;
en.weekdaysShortRegex = i$e;
en.weekdaysMinRegex = s$e;
en.isPM = l$e;
en.meridiem = d$e;
function ex(t, e, n, r) {
  var o = Ul(), i = ka().set(r, e);
  return o[n](i, t);
}
function ole(t, e, n) {
  if (Ml(t) && (e = t, t = void 0), t = t || "", e != null)
    return ex(t, e, n, "month");
  var r, o = [];
  for (r = 0; r < 12; r++)
    o[r] = ex(t, r, n, "month");
  return o;
}
function m5(t, e, n, r) {
  typeof t == "boolean" ? (Ml(e) && (n = e, e = void 0), e = e || "") : (e = t, n = e, t = !1, Ml(e) && (n = e, e = void 0), e = e || "");
  var o = Ul(), i = t ? o._week.dow : 0, s, a = [];
  if (n != null)
    return ex(e, (n + i) % 7, r, "day");
  for (s = 0; s < 7; s++)
    a[s] = ex(e, (s + i) % 7, r, "day");
  return a;
}
function gDe(t, e) {
  return ole(t, e, "months");
}
function yDe(t, e) {
  return ole(t, e, "monthsShort");
}
function vDe(t, e, n) {
  return m5(t, e, n, "weekdays");
}
function bDe(t, e, n) {
  return m5(t, e, n, "weekdaysShort");
}
function _De(t, e, n) {
  return m5(t, e, n, "weekdaysMin");
}
Uc("en", {
  eras: [
    {
      since: "0001-01-01",
      until: 1 / 0,
      offset: 1,
      name: "Anno Domini",
      narrow: "AD",
      abbr: "AD"
    },
    {
      since: "0000-12-31",
      until: -1 / 0,
      offset: 1,
      name: "Before Christ",
      narrow: "BC",
      abbr: "BC"
    }
  ],
  dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
  ordinal: function(t) {
    var e = t % 10, n = Ft(t % 100 / 10) === 1 ? "th" : e === 1 ? "st" : e === 2 ? "nd" : e === 3 ? "rd" : "th";
    return t + n;
  }
});
qe.lang = os(
  "moment.lang is deprecated. Use moment.locale instead.",
  Uc
);
qe.langData = os(
  "moment.langData is deprecated. Use moment.localeData instead.",
  Ul
);
var La = Math.abs;
function wDe() {
  var t = this._data;
  return this._milliseconds = La(this._milliseconds), this._days = La(this._days), this._months = La(this._months), t.milliseconds = La(t.milliseconds), t.seconds = La(t.seconds), t.minutes = La(t.minutes), t.hours = La(t.hours), t.months = La(t.months), t.years = La(t.years), this;
}
function ile(t, e, n, r) {
  var o = Ms(e, n);
  return t._milliseconds += r * o._milliseconds, t._days += r * o._days, t._months += r * o._months, t._bubble();
}
function xDe(t, e) {
  return ile(this, t, e, 1);
}
function EDe(t, e) {
  return ile(this, t, e, -1);
}
function rF(t) {
  return t < 0 ? Math.floor(t) : Math.ceil(t);
}
function SDe() {
  var t = this._milliseconds, e = this._days, n = this._months, r = this._data, o, i, s, a, l;
  return t >= 0 && e >= 0 && n >= 0 || t <= 0 && e <= 0 && n <= 0 || (t += rF(HD(n) + e) * 864e5, e = 0, n = 0), r.milliseconds = t % 1e3, o = Fi(t / 1e3), r.seconds = o % 60, i = Fi(o / 60), r.minutes = i % 60, s = Fi(i / 60), r.hours = s % 24, e += Fi(s / 24), l = Fi(sle(e)), n += l, e -= rF(HD(l)), a = Fi(n / 12), n %= 12, r.days = e, r.months = n, r.years = a, this;
}
function sle(t) {
  return t * 4800 / 146097;
}
function HD(t) {
  return t * 146097 / 4800;
}
function ODe(t) {
  if (!this.isValid())
    return NaN;
  var e, n, r = this._milliseconds;
  if (t = is(t), t === "month" || t === "quarter" || t === "year")
    switch (e = this._days + r / 864e5, n = this._months + sle(e), t) {
      case "month":
        return n;
      case "quarter":
        return n / 3;
      case "year":
        return n / 12;
    }
  else
    switch (e = this._days + Math.round(HD(this._months)), t) {
      case "week":
        return e / 7 + r / 6048e5;
      case "day":
        return e + r / 864e5;
      case "hour":
        return e * 24 + r / 36e5;
      case "minute":
        return e * 1440 + r / 6e4;
      case "second":
        return e * 86400 + r / 1e3;
      // Math.floor prevents floating point math errors here
      case "millisecond":
        return Math.floor(e * 864e5) + r;
      default:
        throw new Error("Unknown unit " + t);
    }
}
function Hl(t) {
  return function() {
    return this.as(t);
  };
}
var ale = Hl("ms"), CDe = Hl("s"), kDe = Hl("m"), ADe = Hl("h"), TDe = Hl("d"), RDe = Hl("w"), PDe = Hl("M"), $De = Hl("Q"), MDe = Hl("y"), DDe = ale;
function IDe() {
  return Ms(this);
}
function NDe(t) {
  return t = is(t), this.isValid() ? this[t + "s"]() : NaN;
}
function Wd(t) {
  return function() {
    return this.isValid() ? this._data[t] : NaN;
  };
}
var jDe = Wd("milliseconds"), LDe = Wd("seconds"), FDe = Wd("minutes"), BDe = Wd("hours"), zDe = Wd("days"), qDe = Wd("months"), UDe = Wd("years");
function HDe() {
  return Fi(this.days() / 7);
}
var sl = Math.round, Kf = {
  ss: 44,
  // a few seconds to seconds
  s: 45,
  // seconds to minute
  m: 45,
  // minutes to hour
  h: 22,
  // hours to day
  d: 26,
  // days to month/week
  w: null,
  // weeks to month
  M: 11
  // months to year
};
function VDe(t, e, n, r, o) {
  return o.relativeTime(e || 1, !!n, t, r);
}
function WDe(t, e, n, r) {
  var o = Ms(t).abs(), i = sl(o.as("s")), s = sl(o.as("m")), a = sl(o.as("h")), l = sl(o.as("d")), c = sl(o.as("M")), u = sl(o.as("w")), d = sl(o.as("y")), f = i <= n.ss && ["s", i] || i < n.s && ["ss", i] || s <= 1 && ["m"] || s < n.m && ["mm", s] || a <= 1 && ["h"] || a < n.h && ["hh", a] || l <= 1 && ["d"] || l < n.d && ["dd", l];
  return n.w != null && (f = f || u <= 1 && ["w"] || u < n.w && ["ww", u]), f = f || c <= 1 && ["M"] || c < n.M && ["MM", c] || d <= 1 && ["y"] || ["yy", d], f[2] = e, f[3] = +t > 0, f[4] = r, VDe.apply(null, f);
}
function GDe(t) {
  return t === void 0 ? sl : typeof t == "function" ? (sl = t, !0) : !1;
}
function YDe(t, e) {
  return Kf[t] === void 0 ? !1 : e === void 0 ? Kf[t] : (Kf[t] = e, t === "s" && (Kf.ss = e - 1), !0);
}
function KDe(t, e) {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var n = !1, r = Kf, o, i;
  return typeof t == "object" && (e = t, t = !1), typeof t == "boolean" && (n = t), typeof e == "object" && (r = Object.assign({}, Kf, e), e.s != null && e.ss == null && (r.ss = e.s - 1)), o = this.localeData(), i = WDe(this, !n, r, o), n && (i = o.pastFuture(+this, i)), o.postformat(i);
}
var xC = Math.abs;
function mf(t) {
  return (t > 0) - (t < 0) || +t;
}
function cS() {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var t = xC(this._milliseconds) / 1e3, e = xC(this._days), n = xC(this._months), r, o, i, s, a = this.asSeconds(), l, c, u, d;
  return a ? (r = Fi(t / 60), o = Fi(r / 60), t %= 60, r %= 60, i = Fi(n / 12), n %= 12, s = t ? t.toFixed(3).replace(/\.?0+$/, "") : "", l = a < 0 ? "-" : "", c = mf(this._months) !== mf(a) ? "-" : "", u = mf(this._days) !== mf(a) ? "-" : "", d = mf(this._milliseconds) !== mf(a) ? "-" : "", l + "P" + (i ? c + i + "Y" : "") + (n ? c + n + "M" : "") + (e ? u + e + "D" : "") + (o || r || t ? "T" : "") + (o ? d + o + "H" : "") + (r ? d + r + "M" : "") + (t ? d + s + "S" : "")) : "P0D";
}
var Gt = aS.prototype;
Gt.isValid = q$e;
Gt.abs = wDe;
Gt.add = xDe;
Gt.subtract = EDe;
Gt.as = ODe;
Gt.asMilliseconds = ale;
Gt.asSeconds = CDe;
Gt.asMinutes = kDe;
Gt.asHours = ADe;
Gt.asDays = TDe;
Gt.asWeeks = RDe;
Gt.asMonths = PDe;
Gt.asQuarters = $De;
Gt.asYears = MDe;
Gt.valueOf = DDe;
Gt._bubble = SDe;
Gt.clone = IDe;
Gt.get = NDe;
Gt.milliseconds = jDe;
Gt.seconds = LDe;
Gt.minutes = FDe;
Gt.hours = BDe;
Gt.days = zDe;
Gt.weeks = HDe;
Gt.months = qDe;
Gt.years = UDe;
Gt.humanize = KDe;
Gt.toISOString = cS;
Gt.toString = cS;
Gt.toJSON = cS;
Gt.locale = Yae;
Gt.localeData = Xae;
Gt.toIsoString = os(
  "toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)",
  cS
);
Gt.lang = Kae;
ht("X", 0, 0, "unix");
ht("x", 0, 0, "valueOf");
it("x", rS);
it("X", gPe);
Mn("X", function(t, e, n) {
  n._d = new Date(parseFloat(t) * 1e3);
});
Mn("x", function(t, e, n) {
  n._d = new Date(Ft(t));
});
//! moment.js
qe.version = "2.30.1";
XRe(Xn);
qe.fn = Be;
qe.min = L$e;
qe.max = F$e;
qe.now = B$e;
qe.utc = ka;
qe.unix = pDe;
qe.months = gDe;
qe.isDate = Jy;
qe.locale = Uc;
qe.invalid = JE;
qe.duration = Ms;
qe.isMoment = Rs;
qe.weekdays = vDe;
qe.parseZone = mDe;
qe.localeData = Ul;
qe.isDuration = V_;
qe.monthsShort = yDe;
qe.weekdaysMin = _De;
qe.defineLocale = a5;
qe.updateLocale = m$e;
qe.locales = g$e;
qe.weekdaysShort = bDe;
qe.normalizeUnits = is;
qe.relativeTimeRounding = GDe;
qe.relativeTimeThreshold = YDe;
qe.calendarFormat = dMe;
qe.prototype = Be;
qe.HTML5_FMT = {
  DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
  // <input type="datetime-local" />
  DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
  // <input type="datetime-local" step="1" />
  DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
  // <input type="datetime-local" step="0.001" />
  DATE: "YYYY-MM-DD",
  // <input type="date" />
  TIME: "HH:mm",
  // <input type="time" />
  TIME_SECONDS: "HH:mm:ss",
  // <input type="time" step="1" />
  TIME_MS: "HH:mm:ss.SSS",
  // <input type="time" step="0.001" />
  WEEK: "GGGG-[W]WW",
  // <input type="week" />
  MONTH: "YYYY-MM"
  // <input type="month" />
};
const XDe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: qe
}, Symbol.toStringTag, { value: "Module" })), lle = /* @__PURE__ */ Zy(XDe);
var QDe = Object.defineProperty, cle = (t) => {
  throw TypeError(t);
}, ZDe = (t, e, n) => e in t ? QDe(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n, ue = (t, e, n) => ZDe(t, typeof e != "symbol" ? e + "" : e, n), JDe = (t, e, n) => e.has(t) || cle("Cannot " + n), eIe = (t, e, n) => e.has(t) ? cle("Cannot add the same private member more than once") : e instanceof WeakSet ? e.add(t) : e.set(t, n), G_ = (t, e, n) => (JDe(t, e, "access private method"), n);
class rv {
  constructor() {
    this.listeners = /* @__PURE__ */ new Set(), this.subscribe = this.subscribe.bind(this);
  }
  subscribe(e) {
    const n = {
      listener: e
    };
    return this.listeners.add(n), this.onSubscribe(), () => {
      this.listeners.delete(n), this.onUnsubscribe();
    };
  }
  hasListeners() {
    return this.listeners.size > 0;
  }
  onSubscribe() {
  }
  onUnsubscribe() {
  }
}
const M0 = typeof window > "u" || "Deno" in window;
function ji() {
}
function tIe(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function VD(t) {
  return typeof t == "number" && t >= 0 && t !== 1 / 0;
}
function ule(t, e) {
  return Math.max(t + (e || 0) - Date.now(), 0);
}
function dg(t, e, n) {
  return uS(t) ? typeof e == "function" ? {
    ...n,
    queryKey: t,
    queryFn: e
  } : {
    ...e,
    queryKey: t
  } : t;
}
function yc(t, e, n) {
  return uS(t) ? [{
    ...e,
    queryKey: t
  }, n] : [t || {}, e];
}
function oF(t, e) {
  const {
    type: n = "all",
    exact: r,
    fetchStatus: o,
    predicate: i,
    queryKey: s,
    stale: a
  } = t;
  if (uS(s)) {
    if (r) {
      if (e.queryHash !== g5(s, e.options))
        return !1;
    } else if (!Xf(e.queryKey, s))
      return !1;
  }
  if (n !== "all") {
    const l = e.isActive();
    if (n === "active" && !l || n === "inactive" && l)
      return !1;
  }
  return !(typeof a == "boolean" && e.isStale() !== a || typeof o < "u" && o !== e.state.fetchStatus || i && !i(e));
}
function iF(t, e) {
  const {
    exact: n,
    fetching: r,
    predicate: o,
    mutationKey: i
  } = t;
  if (uS(i)) {
    if (!e.options.mutationKey)
      return !1;
    if (n) {
      if (ed(e.options.mutationKey) !== ed(i))
        return !1;
    } else if (!Xf(e.options.mutationKey, i))
      return !1;
  }
  return !(typeof r == "boolean" && e.state.status === "loading" !== r || o && !o(e));
}
function g5(t, e) {
  return (e?.queryKeyHashFn || ed)(t);
}
function ed(t) {
  return JSON.stringify(t, (e, n) => GD(n) ? Object.keys(n).sort().reduce((r, o) => (r[o] = n[o], r), {}) : n);
}
function Xf(t, e) {
  return dle(t, e);
}
function dle(t, e) {
  return t === e ? !0 : typeof t != typeof e ? !1 : t && e && typeof t == "object" && typeof e == "object" ? !Object.keys(e).some((n) => !dle(t[n], e[n])) : !1;
}
function fle(t, e) {
  if (t === e)
    return t;
  const n = sF(t) && sF(e);
  if (n || GD(t) && GD(e)) {
    const r = n ? t.length : Object.keys(t).length, o = n ? e : Object.keys(e), i = o.length, s = n ? [] : {};
    let a = 0;
    for (let l = 0; l < i; l++) {
      const c = n ? l : o[l];
      s[c] = fle(t[c], e[c]), s[c] === t[c] && a++;
    }
    return r === i && a === r ? t : s;
  }
  return e;
}
function WD(t, e) {
  if (t && !e || e && !t)
    return !1;
  for (const n in t)
    if (t[n] !== e[n])
      return !1;
  return !0;
}
function sF(t) {
  return Array.isArray(t) && t.length === Object.keys(t).length;
}
function GD(t) {
  if (!aF(t))
    return !1;
  const e = t.constructor;
  if (typeof e > "u")
    return !0;
  const n = e.prototype;
  return !(!aF(n) || !n.hasOwnProperty("isPrototypeOf"));
}
function aF(t) {
  return Object.prototype.toString.call(t) === "[object Object]";
}
function uS(t) {
  return Array.isArray(t);
}
function hle(t) {
  return new Promise((e) => {
    setTimeout(e, t);
  });
}
function lF(t) {
  hle(0).then(t);
}
function nIe() {
  if (typeof AbortController == "function")
    return new AbortController();
}
function YD(t, e, n) {
  return n.isDataEqual != null && n.isDataEqual(t, e) ? t : typeof n.structuralSharing == "function" ? n.structuralSharing(t, e) : n.structuralSharing !== !1 ? fle(t, e) : e;
}
class rIe extends rv {
  constructor() {
    super(), this.setup = (e) => {
      if (!M0 && window.addEventListener) {
        const n = () => e();
        return window.addEventListener("visibilitychange", n, !1), window.addEventListener("focus", n, !1), () => {
          window.removeEventListener("visibilitychange", n), window.removeEventListener("focus", n);
        };
      }
    };
  }
  onSubscribe() {
    this.cleanup || this.setEventListener(this.setup);
  }
  onUnsubscribe() {
    if (!this.hasListeners()) {
      var e;
      (e = this.cleanup) == null || e.call(this), this.cleanup = void 0;
    }
  }
  setEventListener(e) {
    var n;
    this.setup = e, (n = this.cleanup) == null || n.call(this), this.cleanup = e((r) => {
      typeof r == "boolean" ? this.setFocused(r) : this.onFocus();
    });
  }
  setFocused(e) {
    this.focused !== e && (this.focused = e, this.onFocus());
  }
  onFocus() {
    this.listeners.forEach(({
      listener: e
    }) => {
      e();
    });
  }
  isFocused() {
    return typeof this.focused == "boolean" ? this.focused : typeof document > "u" ? !0 : [void 0, "visible", "prerender"].includes(document.visibilityState);
  }
}
const tx = new rIe(), cF = ["online", "offline"];
class oIe extends rv {
  constructor() {
    super(), this.setup = (e) => {
      if (!M0 && window.addEventListener) {
        const n = () => e();
        return cF.forEach((r) => {
          window.addEventListener(r, n, !1);
        }), () => {
          cF.forEach((r) => {
            window.removeEventListener(r, n);
          });
        };
      }
    };
  }
  onSubscribe() {
    this.cleanup || this.setEventListener(this.setup);
  }
  onUnsubscribe() {
    if (!this.hasListeners()) {
      var e;
      (e = this.cleanup) == null || e.call(this), this.cleanup = void 0;
    }
  }
  setEventListener(e) {
    var n;
    this.setup = e, (n = this.cleanup) == null || n.call(this), this.cleanup = e((r) => {
      typeof r == "boolean" ? this.setOnline(r) : this.onOnline();
    });
  }
  setOnline(e) {
    this.online !== e && (this.online = e, this.onOnline());
  }
  onOnline() {
    this.listeners.forEach(({
      listener: e
    }) => {
      e();
    });
  }
  isOnline() {
    return typeof this.online == "boolean" ? this.online : typeof navigator > "u" || typeof navigator.onLine > "u" ? !0 : navigator.onLine;
  }
}
const Nh = new oIe();
function iIe(t) {
  return Math.min(1e3 * 2 ** t, 3e4);
}
function dS(t) {
  return (t ?? "online") === "online" ? Nh.isOnline() : !0;
}
class ple {
  constructor(e) {
    this.revert = e?.revert, this.silent = e?.silent;
  }
}
function Y_(t) {
  return t instanceof ple;
}
function mle(t) {
  let e = !1, n = 0, r = !1, o, i, s;
  const a = new Promise((g, y) => {
    i = g, s = y;
  }), l = (g) => {
    r || (h(new ple(g)), t.abort == null || t.abort());
  }, c = () => {
    e = !0;
  }, u = () => {
    e = !1;
  }, d = () => !tx.isFocused() || t.networkMode !== "always" && !Nh.isOnline(), f = (g) => {
    r || (r = !0, t.onSuccess == null || t.onSuccess(g), o?.(), i(g));
  }, h = (g) => {
    r || (r = !0, t.onError == null || t.onError(g), o?.(), s(g));
  }, p = () => new Promise((g) => {
    o = (y) => {
      const v = r || !d();
      return v && g(y), v;
    }, t.onPause == null || t.onPause();
  }).then(() => {
    o = void 0, r || t.onContinue == null || t.onContinue();
  }), m = () => {
    if (r)
      return;
    let g;
    try {
      g = t.fn();
    } catch (y) {
      g = Promise.reject(y);
    }
    Promise.resolve(g).then(f).catch((y) => {
      var v, b;
      if (r)
        return;
      const _ = (v = t.retry) != null ? v : 3, w = (b = t.retryDelay) != null ? b : iIe, x = typeof w == "function" ? w(n, y) : w, E = _ === !0 || typeof _ == "number" && n < _ || typeof _ == "function" && _(n, y);
      if (e || !E) {
        h(y);
        return;
      }
      n++, t.onFail == null || t.onFail(n, y), hle(x).then(() => {
        if (d())
          return p();
      }).then(() => {
        e ? h(y) : m();
      });
    });
  };
  return dS(t.networkMode) ? m() : p().then(m), {
    promise: a,
    cancel: l,
    continue: () => o?.() ? a : Promise.resolve(),
    cancelRetry: c,
    continueRetry: u
  };
}
const y5 = console;
function sIe() {
  let t = [], e = 0, n = (l) => {
    l();
  }, r = (l) => {
    l();
  };
  const o = (l) => {
    let c;
    e++;
    try {
      c = l();
    } finally {
      e--, e || a();
    }
    return c;
  }, i = (l) => {
    e ? t.push(l) : lF(() => {
      n(l);
    });
  }, s = (l) => (...c) => {
    i(() => {
      l(...c);
    });
  }, a = () => {
    const l = t;
    t = [], l.length && lF(() => {
      r(() => {
        l.forEach((c) => {
          n(c);
        });
      });
    });
  };
  return {
    batch: o,
    batchCalls: s,
    schedule: i,
    setNotifyFunction: (l) => {
      n = l;
    },
    setBatchNotifyFunction: (l) => {
      r = l;
    }
  };
}
const _r = sIe();
class gle {
  destroy() {
    this.clearGcTimeout();
  }
  scheduleGc() {
    this.clearGcTimeout(), VD(this.cacheTime) && (this.gcTimeout = setTimeout(() => {
      this.optionalRemove();
    }, this.cacheTime));
  }
  updateCacheTime(e) {
    this.cacheTime = Math.max(this.cacheTime || 0, e ?? (M0 ? 1 / 0 : 5 * 60 * 1e3));
  }
  clearGcTimeout() {
    this.gcTimeout && (clearTimeout(this.gcTimeout), this.gcTimeout = void 0);
  }
}
class aIe extends gle {
  constructor(e) {
    super(), this.abortSignalConsumed = !1, this.defaultOptions = e.defaultOptions, this.setOptions(e.options), this.observers = [], this.cache = e.cache, this.logger = e.logger || y5, this.queryKey = e.queryKey, this.queryHash = e.queryHash, this.initialState = e.state || lIe(this.options), this.state = this.initialState, this.scheduleGc();
  }
  get meta() {
    return this.options.meta;
  }
  setOptions(e) {
    this.options = {
      ...this.defaultOptions,
      ...e
    }, this.updateCacheTime(this.options.cacheTime);
  }
  optionalRemove() {
    !this.observers.length && this.state.fetchStatus === "idle" && this.cache.remove(this);
  }
  setData(e, n) {
    const r = YD(this.state.data, e, this.options);
    return this.dispatch({
      data: r,
      type: "success",
      dataUpdatedAt: n?.updatedAt,
      manual: n?.manual
    }), r;
  }
  setState(e, n) {
    this.dispatch({
      type: "setState",
      state: e,
      setStateOptions: n
    });
  }
  cancel(e) {
    var n;
    const r = this.promise;
    return (n = this.retryer) == null || n.cancel(e), r ? r.then(ji).catch(ji) : Promise.resolve();
  }
  destroy() {
    super.destroy(), this.cancel({
      silent: !0
    });
  }
  reset() {
    this.destroy(), this.setState(this.initialState);
  }
  isActive() {
    return this.observers.some((e) => e.options.enabled !== !1);
  }
  isDisabled() {
    return this.getObserversCount() > 0 && !this.isActive();
  }
  isStale() {
    return this.state.isInvalidated || !this.state.dataUpdatedAt || this.observers.some((e) => e.getCurrentResult().isStale);
  }
  isStaleByTime(e = 0) {
    return this.state.isInvalidated || !this.state.dataUpdatedAt || !ule(this.state.dataUpdatedAt, e);
  }
  onFocus() {
    var e;
    const n = this.observers.find((r) => r.shouldFetchOnWindowFocus());
    n && n.refetch({
      cancelRefetch: !1
    }), (e = this.retryer) == null || e.continue();
  }
  onOnline() {
    var e;
    const n = this.observers.find((r) => r.shouldFetchOnReconnect());
    n && n.refetch({
      cancelRefetch: !1
    }), (e = this.retryer) == null || e.continue();
  }
  addObserver(e) {
    this.observers.includes(e) || (this.observers.push(e), this.clearGcTimeout(), this.cache.notify({
      type: "observerAdded",
      query: this,
      observer: e
    }));
  }
  removeObserver(e) {
    this.observers.includes(e) && (this.observers = this.observers.filter((n) => n !== e), this.observers.length || (this.retryer && (this.abortSignalConsumed ? this.retryer.cancel({
      revert: !0
    }) : this.retryer.cancelRetry()), this.scheduleGc()), this.cache.notify({
      type: "observerRemoved",
      query: this,
      observer: e
    }));
  }
  getObserversCount() {
    return this.observers.length;
  }
  invalidate() {
    this.state.isInvalidated || this.dispatch({
      type: "invalidate"
    });
  }
  fetch(e, n) {
    var r, o;
    if (this.state.fetchStatus !== "idle") {
      if (this.state.dataUpdatedAt && n != null && n.cancelRefetch)
        this.cancel({
          silent: !0
        });
      else if (this.promise) {
        var i;
        return (i = this.retryer) == null || i.continueRetry(), this.promise;
      }
    }
    if (e && this.setOptions(e), !this.options.queryFn) {
      const h = this.observers.find((p) => p.options.queryFn);
      h && this.setOptions(h.options);
    }
    process.env.NODE_ENV !== "production" && (Array.isArray(this.options.queryKey) || this.logger.error("As of v4, queryKey needs to be an Array. If you are using a string like 'repoData', please change it to an Array, e.g. ['repoData']"));
    const s = nIe(), a = {
      queryKey: this.queryKey,
      pageParam: void 0,
      meta: this.meta
    }, l = (h) => {
      Object.defineProperty(h, "signal", {
        enumerable: !0,
        get: () => {
          if (s)
            return this.abortSignalConsumed = !0, s.signal;
        }
      });
    };
    l(a);
    const c = () => this.options.queryFn ? (this.abortSignalConsumed = !1, this.options.queryFn(a)) : Promise.reject("Missing queryFn for queryKey '" + this.options.queryHash + "'"), u = {
      fetchOptions: n,
      options: this.options,
      queryKey: this.queryKey,
      state: this.state,
      fetchFn: c
    };
    if (l(u), (r = this.options.behavior) == null || r.onFetch(u), this.revertState = this.state, this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((o = u.fetchOptions) == null ? void 0 : o.meta)) {
      var d;
      this.dispatch({
        type: "fetch",
        meta: (d = u.fetchOptions) == null ? void 0 : d.meta
      });
    }
    const f = (h) => {
      if (Y_(h) && h.silent || this.dispatch({
        type: "error",
        error: h
      }), !Y_(h)) {
        var p, m, g, y;
        (p = (m = this.cache.config).onError) == null || p.call(m, h, this), (g = (y = this.cache.config).onSettled) == null || g.call(y, this.state.data, h, this), process.env.NODE_ENV !== "production" && this.logger.error(h);
      }
      this.isFetchingOptimistic || this.scheduleGc(), this.isFetchingOptimistic = !1;
    };
    return this.retryer = mle({
      fn: u.fetchFn,
      abort: s?.abort.bind(s),
      onSuccess: (h) => {
        var p, m, g, y;
        if (typeof h > "u") {
          process.env.NODE_ENV !== "production" && this.logger.error("Query data cannot be undefined. Please make sure to return a value other than undefined from your query function. Affected query key: " + this.queryHash), f(new Error(this.queryHash + " data is undefined"));
          return;
        }
        this.setData(h), (p = (m = this.cache.config).onSuccess) == null || p.call(m, h, this), (g = (y = this.cache.config).onSettled) == null || g.call(y, h, this.state.error, this), this.isFetchingOptimistic || this.scheduleGc(), this.isFetchingOptimistic = !1;
      },
      onError: f,
      onFail: (h, p) => {
        this.dispatch({
          type: "failed",
          failureCount: h,
          error: p
        });
      },
      onPause: () => {
        this.dispatch({
          type: "pause"
        });
      },
      onContinue: () => {
        this.dispatch({
          type: "continue"
        });
      },
      retry: u.options.retry,
      retryDelay: u.options.retryDelay,
      networkMode: u.options.networkMode
    }), this.promise = this.retryer.promise, this.promise;
  }
  dispatch(e) {
    const n = (r) => {
      var o, i;
      switch (e.type) {
        case "failed":
          return {
            ...r,
            fetchFailureCount: e.failureCount,
            fetchFailureReason: e.error
          };
        case "pause":
          return {
            ...r,
            fetchStatus: "paused"
          };
        case "continue":
          return {
            ...r,
            fetchStatus: "fetching"
          };
        case "fetch":
          return {
            ...r,
            fetchFailureCount: 0,
            fetchFailureReason: null,
            fetchMeta: (o = e.meta) != null ? o : null,
            fetchStatus: dS(this.options.networkMode) ? "fetching" : "paused",
            ...!r.dataUpdatedAt && {
              error: null,
              status: "loading"
            }
          };
        case "success":
          return {
            ...r,
            data: e.data,
            dataUpdateCount: r.dataUpdateCount + 1,
            dataUpdatedAt: (i = e.dataUpdatedAt) != null ? i : Date.now(),
            error: null,
            isInvalidated: !1,
            status: "success",
            ...!e.manual && {
              fetchStatus: "idle",
              fetchFailureCount: 0,
              fetchFailureReason: null
            }
          };
        case "error":
          const s = e.error;
          return Y_(s) && s.revert && this.revertState ? {
            ...this.revertState,
            fetchStatus: "idle"
          } : {
            ...r,
            error: s,
            errorUpdateCount: r.errorUpdateCount + 1,
            errorUpdatedAt: Date.now(),
            fetchFailureCount: r.fetchFailureCount + 1,
            fetchFailureReason: s,
            fetchStatus: "idle",
            status: "error"
          };
        case "invalidate":
          return {
            ...r,
            isInvalidated: !0
          };
        case "setState":
          return {
            ...r,
            ...e.state
          };
      }
    };
    this.state = n(this.state), _r.batch(() => {
      this.observers.forEach((r) => {
        r.onQueryUpdate(e);
      }), this.cache.notify({
        query: this,
        type: "updated",
        action: e
      });
    });
  }
}
function lIe(t) {
  const e = typeof t.initialData == "function" ? t.initialData() : t.initialData, n = typeof e < "u", r = n ? typeof t.initialDataUpdatedAt == "function" ? t.initialDataUpdatedAt() : t.initialDataUpdatedAt : 0;
  return {
    data: e,
    dataUpdateCount: 0,
    dataUpdatedAt: n ? r ?? Date.now() : 0,
    error: null,
    errorUpdateCount: 0,
    errorUpdatedAt: 0,
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchMeta: null,
    isInvalidated: !1,
    status: n ? "success" : "loading",
    fetchStatus: "idle"
  };
}
class yle extends rv {
  constructor(e) {
    super(), this.config = e || {}, this.queries = [], this.queriesMap = {};
  }
  build(e, n, r) {
    var o;
    const i = n.queryKey, s = (o = n.queryHash) != null ? o : g5(i, n);
    let a = this.get(s);
    return a || (a = new aIe({
      cache: this,
      logger: e.getLogger(),
      queryKey: i,
      queryHash: s,
      options: e.defaultQueryOptions(n),
      state: r,
      defaultOptions: e.getQueryDefaults(i)
    }), this.add(a)), a;
  }
  add(e) {
    this.queriesMap[e.queryHash] || (this.queriesMap[e.queryHash] = e, this.queries.push(e), this.notify({
      type: "added",
      query: e
    }));
  }
  remove(e) {
    const n = this.queriesMap[e.queryHash];
    n && (e.destroy(), this.queries = this.queries.filter((r) => r !== e), n === e && delete this.queriesMap[e.queryHash], this.notify({
      type: "removed",
      query: e
    }));
  }
  clear() {
    _r.batch(() => {
      this.queries.forEach((e) => {
        this.remove(e);
      });
    });
  }
  get(e) {
    return this.queriesMap[e];
  }
  getAll() {
    return this.queries;
  }
  /**
   * @deprecated This method should be used with only one object argument.
   */
  find(e, n) {
    const [r] = yc(e, n);
    return typeof r.exact > "u" && (r.exact = !0), this.queries.find((o) => oF(r, o));
  }
  /**
   * @deprecated This method should be used with only one object argument.
   */
  findAll(e, n) {
    const [r] = yc(e, n);
    return Object.keys(r).length > 0 ? this.queries.filter((o) => oF(r, o)) : this.queries;
  }
  notify(e) {
    _r.batch(() => {
      this.listeners.forEach(({
        listener: n
      }) => {
        n(e);
      });
    });
  }
  onFocus() {
    _r.batch(() => {
      this.queries.forEach((e) => {
        e.onFocus();
      });
    });
  }
  onOnline() {
    _r.batch(() => {
      this.queries.forEach((e) => {
        e.onOnline();
      });
    });
  }
}
class cIe extends gle {
  constructor(e) {
    super(), this.defaultOptions = e.defaultOptions, this.mutationId = e.mutationId, this.mutationCache = e.mutationCache, this.logger = e.logger || y5, this.observers = [], this.state = e.state || uIe(), this.setOptions(e.options), this.scheduleGc();
  }
  setOptions(e) {
    this.options = {
      ...this.defaultOptions,
      ...e
    }, this.updateCacheTime(this.options.cacheTime);
  }
  get meta() {
    return this.options.meta;
  }
  setState(e) {
    this.dispatch({
      type: "setState",
      state: e
    });
  }
  addObserver(e) {
    this.observers.includes(e) || (this.observers.push(e), this.clearGcTimeout(), this.mutationCache.notify({
      type: "observerAdded",
      mutation: this,
      observer: e
    }));
  }
  removeObserver(e) {
    this.observers = this.observers.filter((n) => n !== e), this.scheduleGc(), this.mutationCache.notify({
      type: "observerRemoved",
      mutation: this,
      observer: e
    });
  }
  optionalRemove() {
    this.observers.length || (this.state.status === "loading" ? this.scheduleGc() : this.mutationCache.remove(this));
  }
  continue() {
    var e, n;
    return (e = (n = this.retryer) == null ? void 0 : n.continue()) != null ? e : this.execute();
  }
  async execute() {
    const e = () => {
      var E;
      return this.retryer = mle({
        fn: () => this.options.mutationFn ? this.options.mutationFn(this.state.variables) : Promise.reject("No mutationFn found"),
        onFail: (S, C) => {
          this.dispatch({
            type: "failed",
            failureCount: S,
            error: C
          });
        },
        onPause: () => {
          this.dispatch({
            type: "pause"
          });
        },
        onContinue: () => {
          this.dispatch({
            type: "continue"
          });
        },
        retry: (E = this.options.retry) != null ? E : 0,
        retryDelay: this.options.retryDelay,
        networkMode: this.options.networkMode
      }), this.retryer.promise;
    }, n = this.state.status === "loading";
    try {
      var r, o, i, s, a, l, c, u;
      if (!n) {
        var d, f, h, p;
        this.dispatch({
          type: "loading",
          variables: this.options.variables
        }), await ((d = (f = this.mutationCache.config).onMutate) == null ? void 0 : d.call(f, this.state.variables, this));
        const S = await ((h = (p = this.options).onMutate) == null ? void 0 : h.call(p, this.state.variables));
        S !== this.state.context && this.dispatch({
          type: "loading",
          context: S,
          variables: this.state.variables
        });
      }
      const E = await e();
      return await ((r = (o = this.mutationCache.config).onSuccess) == null ? void 0 : r.call(o, E, this.state.variables, this.state.context, this)), await ((i = (s = this.options).onSuccess) == null ? void 0 : i.call(s, E, this.state.variables, this.state.context)), await ((a = (l = this.mutationCache.config).onSettled) == null ? void 0 : a.call(l, E, null, this.state.variables, this.state.context, this)), await ((c = (u = this.options).onSettled) == null ? void 0 : c.call(u, E, null, this.state.variables, this.state.context)), this.dispatch({
        type: "success",
        data: E
      }), E;
    } catch (E) {
      try {
        var m, g, y, v, b, _, w, x;
        throw await ((m = (g = this.mutationCache.config).onError) == null ? void 0 : m.call(g, E, this.state.variables, this.state.context, this)), process.env.NODE_ENV !== "production" && this.logger.error(E), await ((y = (v = this.options).onError) == null ? void 0 : y.call(v, E, this.state.variables, this.state.context)), await ((b = (_ = this.mutationCache.config).onSettled) == null ? void 0 : b.call(_, void 0, E, this.state.variables, this.state.context, this)), await ((w = (x = this.options).onSettled) == null ? void 0 : w.call(x, void 0, E, this.state.variables, this.state.context)), E;
      } finally {
        this.dispatch({
          type: "error",
          error: E
        });
      }
    }
  }
  dispatch(e) {
    const n = (r) => {
      switch (e.type) {
        case "failed":
          return {
            ...r,
            failureCount: e.failureCount,
            failureReason: e.error
          };
        case "pause":
          return {
            ...r,
            isPaused: !0
          };
        case "continue":
          return {
            ...r,
            isPaused: !1
          };
        case "loading":
          return {
            ...r,
            context: e.context,
            data: void 0,
            failureCount: 0,
            failureReason: null,
            error: null,
            isPaused: !dS(this.options.networkMode),
            status: "loading",
            variables: e.variables
          };
        case "success":
          return {
            ...r,
            data: e.data,
            failureCount: 0,
            failureReason: null,
            error: null,
            status: "success",
            isPaused: !1
          };
        case "error":
          return {
            ...r,
            data: void 0,
            error: e.error,
            failureCount: r.failureCount + 1,
            failureReason: e.error,
            isPaused: !1,
            status: "error"
          };
        case "setState":
          return {
            ...r,
            ...e.state
          };
      }
    };
    this.state = n(this.state), _r.batch(() => {
      this.observers.forEach((r) => {
        r.onMutationUpdate(e);
      }), this.mutationCache.notify({
        mutation: this,
        type: "updated",
        action: e
      });
    });
  }
}
function uIe() {
  return {
    context: void 0,
    data: void 0,
    error: null,
    failureCount: 0,
    failureReason: null,
    isPaused: !1,
    status: "idle",
    variables: void 0
  };
}
class vle extends rv {
  constructor(e) {
    super(), this.config = e || {}, this.mutations = [], this.mutationId = 0;
  }
  build(e, n, r) {
    const o = new cIe({
      mutationCache: this,
      logger: e.getLogger(),
      mutationId: ++this.mutationId,
      options: e.defaultMutationOptions(n),
      state: r,
      defaultOptions: n.mutationKey ? e.getMutationDefaults(n.mutationKey) : void 0
    });
    return this.add(o), o;
  }
  add(e) {
    this.mutations.push(e), this.notify({
      type: "added",
      mutation: e
    });
  }
  remove(e) {
    this.mutations = this.mutations.filter((n) => n !== e), this.notify({
      type: "removed",
      mutation: e
    });
  }
  clear() {
    _r.batch(() => {
      this.mutations.forEach((e) => {
        this.remove(e);
      });
    });
  }
  getAll() {
    return this.mutations;
  }
  find(e) {
    return typeof e.exact > "u" && (e.exact = !0), this.mutations.find((n) => iF(e, n));
  }
  findAll(e) {
    return this.mutations.filter((n) => iF(e, n));
  }
  notify(e) {
    _r.batch(() => {
      this.listeners.forEach(({
        listener: n
      }) => {
        n(e);
      });
    });
  }
  resumePausedMutations() {
    var e;
    return this.resuming = ((e = this.resuming) != null ? e : Promise.resolve()).then(() => {
      const n = this.mutations.filter((r) => r.state.isPaused);
      return _r.batch(() => n.reduce((r, o) => r.then(() => o.continue().catch(ji)), Promise.resolve()));
    }).then(() => {
      this.resuming = void 0;
    }), this.resuming;
  }
}
function dIe() {
  return {
    onFetch: (t) => {
      t.fetchFn = () => {
        var e, n, r, o, i, s;
        const a = (e = t.fetchOptions) == null || (n = e.meta) == null ? void 0 : n.refetchPage, l = (r = t.fetchOptions) == null || (o = r.meta) == null ? void 0 : o.fetchMore, c = l?.pageParam, u = l?.direction === "forward", d = l?.direction === "backward", f = ((i = t.state.data) == null ? void 0 : i.pages) || [], h = ((s = t.state.data) == null ? void 0 : s.pageParams) || [];
        let p = h, m = !1;
        const g = (w) => {
          Object.defineProperty(w, "signal", {
            enumerable: !0,
            get: () => {
              var x;
              if ((x = t.signal) != null && x.aborted)
                m = !0;
              else {
                var E;
                (E = t.signal) == null || E.addEventListener("abort", () => {
                  m = !0;
                });
              }
              return t.signal;
            }
          });
        }, y = t.options.queryFn || (() => Promise.reject("Missing queryFn for queryKey '" + t.options.queryHash + "'")), v = (w, x, E, S) => (p = S ? [x, ...p] : [...p, x], S ? [E, ...w] : [...w, E]), b = (w, x, E, S) => {
          if (m)
            return Promise.reject("Cancelled");
          if (typeof E > "u" && !x && w.length)
            return Promise.resolve(w);
          const C = {
            queryKey: t.queryKey,
            pageParam: E,
            meta: t.options.meta
          };
          g(C);
          const R = y(C);
          return Promise.resolve(R).then((P) => v(w, E, P, S));
        };
        let _;
        if (!f.length)
          _ = b([]);
        else if (u) {
          const w = typeof c < "u", x = w ? c : uF(t.options, f);
          _ = b(f, w, x);
        } else if (d) {
          const w = typeof c < "u", x = w ? c : fIe(t.options, f);
          _ = b(f, w, x, !0);
        } else {
          p = [];
          const w = typeof t.options.getNextPageParam > "u";
          _ = !(a && f[0]) || a(f[0], 0, f) ? b([], w, h[0]) : Promise.resolve(v([], h[0], f[0]));
          for (let x = 1; x < f.length; x++)
            _ = _.then((E) => {
              if (!(a && f[x]) || a(f[x], x, f)) {
                const S = w ? h[x] : uF(t.options, E);
                return b(E, w, S);
              }
              return Promise.resolve(v(E, h[x], f[x]));
            });
        }
        return _.then((w) => ({
          pages: w,
          pageParams: p
        }));
      };
    }
  };
}
function uF(t, e) {
  return t.getNextPageParam == null ? void 0 : t.getNextPageParam(e[e.length - 1], e);
}
function fIe(t, e) {
  return t.getPreviousPageParam == null ? void 0 : t.getPreviousPageParam(e[0], e);
}
class hIe {
  constructor(e = {}) {
    this.queryCache = e.queryCache || new yle(), this.mutationCache = e.mutationCache || new vle(), this.logger = e.logger || y5, this.defaultOptions = e.defaultOptions || {}, this.queryDefaults = [], this.mutationDefaults = [], this.mountCount = 0, process.env.NODE_ENV !== "production" && e.logger && this.logger.error("Passing a custom logger has been deprecated and will be removed in the next major version.");
  }
  mount() {
    this.mountCount++, this.mountCount === 1 && (this.unsubscribeFocus = tx.subscribe(() => {
      tx.isFocused() && (this.resumePausedMutations(), this.queryCache.onFocus());
    }), this.unsubscribeOnline = Nh.subscribe(() => {
      Nh.isOnline() && (this.resumePausedMutations(), this.queryCache.onOnline());
    }));
  }
  unmount() {
    var e, n;
    this.mountCount--, this.mountCount === 0 && ((e = this.unsubscribeFocus) == null || e.call(this), this.unsubscribeFocus = void 0, (n = this.unsubscribeOnline) == null || n.call(this), this.unsubscribeOnline = void 0);
  }
  /**
   * @deprecated This method should be used with only one object argument.
   */
  isFetching(e, n) {
    const [r] = yc(e, n);
    return r.fetchStatus = "fetching", this.queryCache.findAll(r).length;
  }
  isMutating(e) {
    return this.mutationCache.findAll({
      ...e,
      fetching: !0
    }).length;
  }
  /**
   * @deprecated This method will accept only queryKey in the next major version.
   */
  getQueryData(e, n) {
    var r;
    return (r = this.queryCache.find(e, n)) == null ? void 0 : r.state.data;
  }
  /**
   * @deprecated This method should be used with only one object argument.
   */
  ensureQueryData(e, n, r) {
    const o = dg(e, n, r), i = this.getQueryData(o.queryKey);
    return i ? Promise.resolve(i) : this.fetchQuery(o);
  }
  /**
   * @deprecated This method should be used with only one object argument.
   */
  getQueriesData(e) {
    return this.getQueryCache().findAll(e).map(({
      queryKey: n,
      state: r
    }) => {
      const o = r.data;
      return [n, o];
    });
  }
  setQueryData(e, n, r) {
    const o = this.queryCache.find(e), i = o?.state.data, s = tIe(n, i);
    if (typeof s > "u")
      return;
    const a = dg(e), l = this.defaultQueryOptions(a);
    return this.queryCache.build(this, l).setData(s, {
      ...r,
      manual: !0
    });
  }
  /**
   * @deprecated This method should be used with only one object argument.
   */
  setQueriesData(e, n, r) {
    return _r.batch(() => this.getQueryCache().findAll(e).map(({
      queryKey: o
    }) => [o, this.setQueryData(o, n, r)]));
  }
  getQueryState(e, n) {
    var r;
    return (r = this.queryCache.find(e, n)) == null ? void 0 : r.state;
  }
  /**
   * @deprecated This method should be used with only one object argument.
   */
  removeQueries(e, n) {
    const [r] = yc(e, n), o = this.queryCache;
    _r.batch(() => {
      o.findAll(r).forEach((i) => {
        o.remove(i);
      });
    });
  }
  /**
   * @deprecated This method should be used with only one object argument.
   */
  resetQueries(e, n, r) {
    const [o, i] = yc(e, n, r), s = this.queryCache, a = {
      type: "active",
      ...o
    };
    return _r.batch(() => (s.findAll(o).forEach((l) => {
      l.reset();
    }), this.refetchQueries(a, i)));
  }
  /**
   * @deprecated This method should be used with only one object argument.
   */
  cancelQueries(e, n, r) {
    const [o, i = {}] = yc(e, n, r);
    typeof i.revert > "u" && (i.revert = !0);
    const s = _r.batch(() => this.queryCache.findAll(o).map((a) => a.cancel(i)));
    return Promise.all(s).then(ji).catch(ji);
  }
  /**
   * @deprecated This method should be used with only one object argument.
   */
  invalidateQueries(e, n, r) {
    const [o, i] = yc(e, n, r);
    return _r.batch(() => {
      var s, a;
      if (this.queryCache.findAll(o).forEach((c) => {
        c.invalidate();
      }), o.refetchType === "none")
        return Promise.resolve();
      const l = {
        ...o,
        type: (s = (a = o.refetchType) != null ? a : o.type) != null ? s : "active"
      };
      return this.refetchQueries(l, i);
    });
  }
  /**
   * @deprecated This method should be used with only one object argument.
   */
  refetchQueries(e, n, r) {
    const [o, i] = yc(e, n, r), s = _r.batch(() => this.queryCache.findAll(o).filter((l) => !l.isDisabled()).map((l) => {
      var c;
      return l.fetch(void 0, {
        ...i,
        cancelRefetch: (c = i?.cancelRefetch) != null ? c : !0,
        meta: {
          refetchPage: o.refetchPage
        }
      });
    }));
    let a = Promise.all(s).then(ji);
    return i != null && i.throwOnError || (a = a.catch(ji)), a;
  }
  /**
   * @deprecated This method should be used with only one object argument.
   */
  fetchQuery(e, n, r) {
    const o = dg(e, n, r), i = this.defaultQueryOptions(o);
    typeof i.retry > "u" && (i.retry = !1);
    const s = this.queryCache.build(this, i);
    return s.isStaleByTime(i.staleTime) ? s.fetch(i) : Promise.resolve(s.state.data);
  }
  /**
   * @deprecated This method should be used with only one object argument.
   */
  prefetchQuery(e, n, r) {
    return this.fetchQuery(e, n, r).then(ji).catch(ji);
  }
  /**
   * @deprecated This method should be used with only one object argument.
   */
  fetchInfiniteQuery(e, n, r) {
    const o = dg(e, n, r);
    return o.behavior = dIe(), this.fetchQuery(o);
  }
  /**
   * @deprecated This method should be used with only one object argument.
   */
  prefetchInfiniteQuery(e, n, r) {
    return this.fetchInfiniteQuery(e, n, r).then(ji).catch(ji);
  }
  resumePausedMutations() {
    return this.mutationCache.resumePausedMutations();
  }
  getQueryCache() {
    return this.queryCache;
  }
  getMutationCache() {
    return this.mutationCache;
  }
  getLogger() {
    return this.logger;
  }
  getDefaultOptions() {
    return this.defaultOptions;
  }
  setDefaultOptions(e) {
    this.defaultOptions = e;
  }
  setQueryDefaults(e, n) {
    const r = this.queryDefaults.find((o) => ed(e) === ed(o.queryKey));
    r ? r.defaultOptions = n : this.queryDefaults.push({
      queryKey: e,
      defaultOptions: n
    });
  }
  getQueryDefaults(e) {
    if (!e)
      return;
    const n = this.queryDefaults.find((r) => Xf(e, r.queryKey));
    return process.env.NODE_ENV !== "production" && this.queryDefaults.filter((r) => Xf(e, r.queryKey)).length > 1 && this.logger.error("[QueryClient] Several query defaults match with key '" + JSON.stringify(e) + "'. The first matching query defaults are used. Please check how query defaults are registered. Order does matter here. cf. https://react-query.tanstack.com/reference/QueryClient#queryclientsetquerydefaults."), n?.defaultOptions;
  }
  setMutationDefaults(e, n) {
    const r = this.mutationDefaults.find((o) => ed(e) === ed(o.mutationKey));
    r ? r.defaultOptions = n : this.mutationDefaults.push({
      mutationKey: e,
      defaultOptions: n
    });
  }
  getMutationDefaults(e) {
    if (!e)
      return;
    const n = this.mutationDefaults.find((r) => Xf(e, r.mutationKey));
    return process.env.NODE_ENV !== "production" && this.mutationDefaults.filter((r) => Xf(e, r.mutationKey)).length > 1 && this.logger.error("[QueryClient] Several mutation defaults match with key '" + JSON.stringify(e) + "'. The first matching mutation defaults are used. Please check how mutation defaults are registered. Order does matter here. cf. https://react-query.tanstack.com/reference/QueryClient#queryclientsetmutationdefaults."), n?.defaultOptions;
  }
  defaultQueryOptions(e) {
    if (e != null && e._defaulted)
      return e;
    const n = {
      ...this.defaultOptions.queries,
      ...this.getQueryDefaults(e?.queryKey),
      ...e,
      _defaulted: !0
    };
    return !n.queryHash && n.queryKey && (n.queryHash = g5(n.queryKey, n)), typeof n.refetchOnReconnect > "u" && (n.refetchOnReconnect = n.networkMode !== "always"), typeof n.useErrorBoundary > "u" && (n.useErrorBoundary = !!n.suspense), n;
  }
  defaultMutationOptions(e) {
    return e != null && e._defaulted ? e : {
      ...this.defaultOptions.mutations,
      ...this.getMutationDefaults(e?.mutationKey),
      ...e,
      _defaulted: !0
    };
  }
  clear() {
    this.queryCache.clear(), this.mutationCache.clear();
  }
}
class pIe extends rv {
  constructor(e, n) {
    super(), this.client = e, this.options = n, this.trackedProps = /* @__PURE__ */ new Set(), this.selectError = null, this.bindMethods(), this.setOptions(n);
  }
  bindMethods() {
    this.remove = this.remove.bind(this), this.refetch = this.refetch.bind(this);
  }
  onSubscribe() {
    this.listeners.size === 1 && (this.currentQuery.addObserver(this), dF(this.currentQuery, this.options) && this.executeFetch(), this.updateTimers());
  }
  onUnsubscribe() {
    this.hasListeners() || this.destroy();
  }
  shouldFetchOnReconnect() {
    return KD(this.currentQuery, this.options, this.options.refetchOnReconnect);
  }
  shouldFetchOnWindowFocus() {
    return KD(this.currentQuery, this.options, this.options.refetchOnWindowFocus);
  }
  destroy() {
    this.listeners = /* @__PURE__ */ new Set(), this.clearStaleTimeout(), this.clearRefetchInterval(), this.currentQuery.removeObserver(this);
  }
  setOptions(e, n) {
    const r = this.options, o = this.currentQuery;
    if (this.options = this.client.defaultQueryOptions(e), process.env.NODE_ENV !== "production" && typeof e?.isDataEqual < "u" && this.client.getLogger().error("The isDataEqual option has been deprecated and will be removed in the next major version. You can achieve the same functionality by passing a function as the structuralSharing option"), WD(r, this.options) || this.client.getQueryCache().notify({
      type: "observerOptionsUpdated",
      query: this.currentQuery,
      observer: this
    }), typeof this.options.enabled < "u" && typeof this.options.enabled != "boolean")
      throw new Error("Expected enabled to be a boolean");
    this.options.queryKey || (this.options.queryKey = r.queryKey), this.updateQuery();
    const i = this.hasListeners();
    i && fF(this.currentQuery, o, this.options, r) && this.executeFetch(), this.updateResult(n), i && (this.currentQuery !== o || this.options.enabled !== r.enabled || this.options.staleTime !== r.staleTime) && this.updateStaleTimeout();
    const s = this.computeRefetchInterval();
    i && (this.currentQuery !== o || this.options.enabled !== r.enabled || s !== this.currentRefetchInterval) && this.updateRefetchInterval(s);
  }
  getOptimisticResult(e) {
    const n = this.client.getQueryCache().build(this.client, e), r = this.createResult(n, e);
    return gIe(this, r, e) && (this.currentResult = r, this.currentResultOptions = this.options, this.currentResultState = this.currentQuery.state), r;
  }
  getCurrentResult() {
    return this.currentResult;
  }
  trackResult(e) {
    const n = {};
    return Object.keys(e).forEach((r) => {
      Object.defineProperty(n, r, {
        configurable: !1,
        enumerable: !0,
        get: () => (this.trackedProps.add(r), e[r])
      });
    }), n;
  }
  getCurrentQuery() {
    return this.currentQuery;
  }
  remove() {
    this.client.getQueryCache().remove(this.currentQuery);
  }
  refetch({
    refetchPage: e,
    ...n
  } = {}) {
    return this.fetch({
      ...n,
      meta: {
        refetchPage: e
      }
    });
  }
  fetchOptimistic(e) {
    const n = this.client.defaultQueryOptions(e), r = this.client.getQueryCache().build(this.client, n);
    return r.isFetchingOptimistic = !0, r.fetch().then(() => this.createResult(r, n));
  }
  fetch(e) {
    var n;
    return this.executeFetch({
      ...e,
      cancelRefetch: (n = e.cancelRefetch) != null ? n : !0
    }).then(() => (this.updateResult(), this.currentResult));
  }
  executeFetch(e) {
    this.updateQuery();
    let n = this.currentQuery.fetch(this.options, e);
    return e != null && e.throwOnError || (n = n.catch(ji)), n;
  }
  updateStaleTimeout() {
    if (this.clearStaleTimeout(), M0 || this.currentResult.isStale || !VD(this.options.staleTime))
      return;
    const e = ule(this.currentResult.dataUpdatedAt, this.options.staleTime) + 1;
    this.staleTimeoutId = setTimeout(() => {
      this.currentResult.isStale || this.updateResult();
    }, e);
  }
  computeRefetchInterval() {
    var e;
    return typeof this.options.refetchInterval == "function" ? this.options.refetchInterval(this.currentResult.data, this.currentQuery) : (e = this.options.refetchInterval) != null ? e : !1;
  }
  updateRefetchInterval(e) {
    this.clearRefetchInterval(), this.currentRefetchInterval = e, !(M0 || this.options.enabled === !1 || !VD(this.currentRefetchInterval) || this.currentRefetchInterval === 0) && (this.refetchIntervalId = setInterval(() => {
      (this.options.refetchIntervalInBackground || tx.isFocused()) && this.executeFetch();
    }, this.currentRefetchInterval));
  }
  updateTimers() {
    this.updateStaleTimeout(), this.updateRefetchInterval(this.computeRefetchInterval());
  }
  clearStaleTimeout() {
    this.staleTimeoutId && (clearTimeout(this.staleTimeoutId), this.staleTimeoutId = void 0);
  }
  clearRefetchInterval() {
    this.refetchIntervalId && (clearInterval(this.refetchIntervalId), this.refetchIntervalId = void 0);
  }
  createResult(e, n) {
    const r = this.currentQuery, o = this.options, i = this.currentResult, s = this.currentResultState, a = this.currentResultOptions, l = e !== r, c = l ? e.state : this.currentQueryInitialState, u = l ? this.currentResult : this.previousQueryResult, {
      state: d
    } = e;
    let {
      dataUpdatedAt: f,
      error: h,
      errorUpdatedAt: p,
      fetchStatus: m,
      status: g
    } = d, y = !1, v = !1, b;
    if (n._optimisticResults) {
      const E = this.hasListeners(), S = !E && dF(e, n), C = E && fF(e, r, n, o);
      (S || C) && (m = dS(e.options.networkMode) ? "fetching" : "paused", f || (g = "loading")), n._optimisticResults === "isRestoring" && (m = "idle");
    }
    if (n.keepPreviousData && !d.dataUpdatedAt && u != null && u.isSuccess && g !== "error")
      b = u.data, f = u.dataUpdatedAt, g = u.status, y = !0;
    else if (n.select && typeof d.data < "u")
      if (i && d.data === s?.data && n.select === this.selectFn)
        b = this.selectResult;
      else
        try {
          this.selectFn = n.select, b = n.select(d.data), b = YD(i?.data, b, n), this.selectResult = b, this.selectError = null;
        } catch (E) {
          process.env.NODE_ENV !== "production" && this.client.getLogger().error(E), this.selectError = E;
        }
    else
      b = d.data;
    if (typeof n.placeholderData < "u" && typeof b > "u" && g === "loading") {
      let E;
      if (i != null && i.isPlaceholderData && n.placeholderData === a?.placeholderData)
        E = i.data;
      else if (E = typeof n.placeholderData == "function" ? n.placeholderData() : n.placeholderData, n.select && typeof E < "u")
        try {
          E = n.select(E), this.selectError = null;
        } catch (S) {
          process.env.NODE_ENV !== "production" && this.client.getLogger().error(S), this.selectError = S;
        }
      typeof E < "u" && (g = "success", b = YD(i?.data, E, n), v = !0);
    }
    this.selectError && (h = this.selectError, b = this.selectResult, p = Date.now(), g = "error");
    const _ = m === "fetching", w = g === "loading", x = g === "error";
    return {
      status: g,
      fetchStatus: m,
      isLoading: w,
      isSuccess: g === "success",
      isError: x,
      isInitialLoading: w && _,
      data: b,
      dataUpdatedAt: f,
      error: h,
      errorUpdatedAt: p,
      failureCount: d.fetchFailureCount,
      failureReason: d.fetchFailureReason,
      errorUpdateCount: d.errorUpdateCount,
      isFetched: d.dataUpdateCount > 0 || d.errorUpdateCount > 0,
      isFetchedAfterMount: d.dataUpdateCount > c.dataUpdateCount || d.errorUpdateCount > c.errorUpdateCount,
      isFetching: _,
      isRefetching: _ && !w,
      isLoadingError: x && d.dataUpdatedAt === 0,
      isPaused: m === "paused",
      isPlaceholderData: v,
      isPreviousData: y,
      isRefetchError: x && d.dataUpdatedAt !== 0,
      isStale: v5(e, n),
      refetch: this.refetch,
      remove: this.remove
    };
  }
  updateResult(e) {
    const n = this.currentResult, r = this.createResult(this.currentQuery, this.options);
    if (this.currentResultState = this.currentQuery.state, this.currentResultOptions = this.options, WD(r, n))
      return;
    this.currentResult = r;
    const o = {
      cache: !0
    }, i = () => {
      if (!n)
        return !0;
      const {
        notifyOnChangeProps: s
      } = this.options, a = typeof s == "function" ? s() : s;
      if (a === "all" || !a && !this.trackedProps.size)
        return !0;
      const l = new Set(a ?? this.trackedProps);
      return this.options.useErrorBoundary && l.add("error"), Object.keys(this.currentResult).some((c) => {
        const u = c;
        return this.currentResult[u] !== n[u] && l.has(u);
      });
    };
    e?.listeners !== !1 && i() && (o.listeners = !0), this.notify({
      ...o,
      ...e
    });
  }
  updateQuery() {
    const e = this.client.getQueryCache().build(this.client, this.options);
    if (e === this.currentQuery)
      return;
    const n = this.currentQuery;
    this.currentQuery = e, this.currentQueryInitialState = e.state, this.previousQueryResult = this.currentResult, this.hasListeners() && (n?.removeObserver(this), e.addObserver(this));
  }
  onQueryUpdate(e) {
    const n = {};
    e.type === "success" ? n.onSuccess = !e.manual : e.type === "error" && !Y_(e.error) && (n.onError = !0), this.updateResult(n), this.hasListeners() && this.updateTimers();
  }
  notify(e) {
    _r.batch(() => {
      if (e.onSuccess) {
        var n, r, o, i;
        (n = (r = this.options).onSuccess) == null || n.call(r, this.currentResult.data), (o = (i = this.options).onSettled) == null || o.call(i, this.currentResult.data, null);
      } else if (e.onError) {
        var s, a, l, c;
        (s = (a = this.options).onError) == null || s.call(a, this.currentResult.error), (l = (c = this.options).onSettled) == null || l.call(c, void 0, this.currentResult.error);
      }
      e.listeners && this.listeners.forEach(({
        listener: u
      }) => {
        u(this.currentResult);
      }), e.cache && this.client.getQueryCache().notify({
        query: this.currentQuery,
        type: "observerResultsUpdated"
      });
    });
  }
}
function mIe(t, e) {
  return e.enabled !== !1 && !t.state.dataUpdatedAt && !(t.state.status === "error" && e.retryOnMount === !1);
}
function dF(t, e) {
  return mIe(t, e) || t.state.dataUpdatedAt > 0 && KD(t, e, e.refetchOnMount);
}
function KD(t, e, n) {
  if (e.enabled !== !1) {
    const r = typeof n == "function" ? n(t) : n;
    return r === "always" || r !== !1 && v5(t, e);
  }
  return !1;
}
function fF(t, e, n, r) {
  return n.enabled !== !1 && (t !== e || r.enabled === !1) && (!n.suspense || t.state.status !== "error") && v5(t, n);
}
function v5(t, e) {
  return t.isStaleByTime(e.staleTime);
}
function gIe(t, e, n) {
  return n.keepPreviousData ? !1 : n.placeholderData !== void 0 ? e.isPlaceholderData : !WD(t.getCurrentResult(), e);
}
var EC = { exports: {} }, SC = {};
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var hF;
function yIe() {
  if (hF) return SC;
  hF = 1;
  var t = xe;
  function e(d, f) {
    return d === f && (d !== 0 || 1 / d === 1 / f) || d !== d && f !== f;
  }
  var n = typeof Object.is == "function" ? Object.is : e, r = t.useState, o = t.useEffect, i = t.useLayoutEffect, s = t.useDebugValue;
  function a(d, f) {
    var h = f(), p = r({ inst: { value: h, getSnapshot: f } }), m = p[0].inst, g = p[1];
    return i(
      function() {
        m.value = h, m.getSnapshot = f, l(m) && g({ inst: m });
      },
      [d, h, f]
    ), o(
      function() {
        return l(m) && g({ inst: m }), d(function() {
          l(m) && g({ inst: m });
        });
      },
      [d]
    ), s(h), h;
  }
  function l(d) {
    var f = d.getSnapshot;
    d = d.value;
    try {
      var h = f();
      return !n(d, h);
    } catch {
      return !0;
    }
  }
  function c(d, f) {
    return f();
  }
  var u = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? c : a;
  return SC.useSyncExternalStore = t.useSyncExternalStore !== void 0 ? t.useSyncExternalStore : u, SC;
}
var pF = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var mF;
function vIe() {
  return mF || (mF = 1, process.env.NODE_ENV !== "production" && function() {
    function t(h, p) {
      return h === p && (h !== 0 || 1 / h === 1 / p) || h !== h && p !== p;
    }
    function e(h, p) {
      u || o.startTransition === void 0 || (u = !0, console.error(
        "You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."
      ));
      var m = p();
      if (!d) {
        var g = p();
        i(m, g) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), d = !0);
      }
      g = s({
        inst: { value: m, getSnapshot: p }
      });
      var y = g[0].inst, v = g[1];
      return l(
        function() {
          y.value = m, y.getSnapshot = p, n(y) && v({ inst: y });
        },
        [h, m, p]
      ), a(
        function() {
          return n(y) && v({ inst: y }), h(function() {
            n(y) && v({ inst: y });
          });
        },
        [h]
      ), c(m), m;
    }
    function n(h) {
      var p = h.getSnapshot;
      h = h.value;
      try {
        var m = p();
        return !i(h, m);
      } catch {
        return !0;
      }
    }
    function r(h, p) {
      return p();
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var o = xe, i = typeof Object.is == "function" ? Object.is : t, s = o.useState, a = o.useEffect, l = o.useLayoutEffect, c = o.useDebugValue, u = !1, d = !1, f = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? r : e;
    pF.useSyncExternalStore = o.useSyncExternalStore !== void 0 ? o.useSyncExternalStore : f, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }()), pF;
}
var gF;
function b5() {
  return gF || (gF = 1, process.env.NODE_ENV === "production" ? EC.exports = yIe() : EC.exports = vIe()), EC.exports;
}
var ble = b5();
const bIe = ble.useSyncExternalStore, yF = /* @__PURE__ */ he.createContext(void 0), _Ie = /* @__PURE__ */ he.createContext(!1);
function wIe(t, e) {
  return t || (e && typeof window < "u" ? (window.ReactQueryClientContext || (window.ReactQueryClientContext = yF), window.ReactQueryClientContext) : yF);
}
const _le = ({
  context: t
} = {}) => {
  const e = he.useContext(wIe(t, he.useContext(_Ie)));
  if (!e)
    throw new Error("No QueryClient set, use QueryClientProvider to set one");
  return e;
}, wle = /* @__PURE__ */ he.createContext(!1), xIe = () => he.useContext(wle);
wle.Provider;
function EIe() {
  let t = !1;
  return {
    clearReset: () => {
      t = !1;
    },
    reset: () => {
      t = !0;
    },
    isReset: () => t
  };
}
const SIe = /* @__PURE__ */ he.createContext(EIe()), OIe = () => he.useContext(SIe);
function CIe(t, e) {
  return typeof t == "function" ? t(...e) : !!t;
}
const kIe = (t, e) => {
  (t.suspense || t.useErrorBoundary) && (e.isReset() || (t.retryOnMount = !1));
}, AIe = (t) => {
  he.useEffect(() => {
    t.clearReset();
  }, [t]);
}, TIe = ({
  result: t,
  errorResetBoundary: e,
  useErrorBoundary: n,
  query: r
}) => t.isError && !e.isReset() && !t.isFetching && CIe(n, [t.error, r]), RIe = (t) => {
  t.suspense && typeof t.staleTime != "number" && (t.staleTime = 1e3);
}, PIe = (t, e) => t.isLoading && t.isFetching && !e, $Ie = (t, e, n) => t?.suspense && PIe(e, n), MIe = (t, e, n) => e.fetchOptimistic(t).then(({
  data: r
}) => {
  t.onSuccess == null || t.onSuccess(r), t.onSettled == null || t.onSettled(r, null);
}).catch((r) => {
  n.clearReset(), t.onError == null || t.onError(r), t.onSettled == null || t.onSettled(void 0, r);
});
function DIe(t, e) {
  const n = _le({
    context: t.context
  }), r = xIe(), o = OIe(), i = n.defaultQueryOptions(t);
  i._optimisticResults = r ? "isRestoring" : "optimistic", i.onError && (i.onError = _r.batchCalls(i.onError)), i.onSuccess && (i.onSuccess = _r.batchCalls(i.onSuccess)), i.onSettled && (i.onSettled = _r.batchCalls(i.onSettled)), RIe(i), kIe(i, o), AIe(o);
  const [s] = he.useState(() => new e(n, i)), a = s.getOptimisticResult(i);
  if (bIe(he.useCallback((l) => {
    const c = r ? () => {
    } : s.subscribe(_r.batchCalls(l));
    return s.updateResult(), c;
  }, [s, r]), () => s.getCurrentResult(), () => s.getCurrentResult()), he.useEffect(() => {
    s.setOptions(i, {
      listeners: !1
    });
  }, [i, s]), $Ie(i, a, r))
    throw MIe(i, s, o);
  if (TIe({
    result: a,
    errorResetBoundary: o,
    useErrorBoundary: i.useErrorBoundary,
    query: s.getCurrentQuery()
  }))
    throw a.error;
  return i.notifyOnChangeProps ? a : s.trackResult(a);
}
function IIe(t, e, n) {
  const r = dg(t, e, n);
  return DIe(r, pIe);
}
var OC = { exports: {} }, gf = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var CC, vF;
function ov() {
  if (vF) return CC;
  vF = 1;
  var t = Object.getOwnPropertySymbols, e = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(i) {
    if (i == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(i);
  }
  function o() {
    try {
      if (!Object.assign)
        return !1;
      var i = new String("abc");
      if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5")
        return !1;
      for (var s = {}, a = 0; a < 10; a++)
        s["_" + String.fromCharCode(a)] = a;
      var l = Object.getOwnPropertyNames(s).map(function(u) {
        return s[u];
      });
      if (l.join("") !== "0123456789")
        return !1;
      var c = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(u) {
        c[u] = u;
      }), Object.keys(Object.assign({}, c)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return CC = o() ? Object.assign : function(i, s) {
    for (var a, l = r(i), c, u = 1; u < arguments.length; u++) {
      a = Object(arguments[u]);
      for (var d in a)
        e.call(a, d) && (l[d] = a[d]);
      if (t) {
        c = t(a);
        for (var f = 0; f < c.length; f++)
          n.call(a, c[f]) && (l[c[f]] = a[c[f]]);
      }
    }
    return l;
  }, CC;
}
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var bF;
function NIe() {
  if (bF) return gf;
  bF = 1, ov();
  var t = xe, e = 60103;
  if (gf.Fragment = 60107, typeof Symbol == "function" && Symbol.for) {
    var n = Symbol.for;
    e = n("react.element"), gf.Fragment = n("react.fragment");
  }
  var r = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = Object.prototype.hasOwnProperty, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(a, l, c) {
    var u, d = {}, f = null, h = null;
    c !== void 0 && (f = "" + c), l.key !== void 0 && (f = "" + l.key), l.ref !== void 0 && (h = l.ref);
    for (u in l) o.call(l, u) && !i.hasOwnProperty(u) && (d[u] = l[u]);
    if (a && a.defaultProps) for (u in l = a.defaultProps, l) d[u] === void 0 && (d[u] = l[u]);
    return { $$typeof: e, type: a, key: f, ref: h, props: d, _owner: r.current };
  }
  return gf.jsx = s, gf.jsxs = s, gf;
}
var _F = {};
/** @license React v17.0.2
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var wF;
function jIe() {
  return wF || (wF = 1, function(t) {
    process.env.NODE_ENV !== "production" && function() {
      var e = xe, n = ov(), r = 60103, o = 60106;
      t.Fragment = 60107;
      var i = 60108, s = 60114, a = 60109, l = 60110, c = 60112, u = 60113, d = 60120, f = 60115, h = 60116, p = 60121, m = 60122, g = 60117, y = 60129, v = 60131;
      if (typeof Symbol == "function" && Symbol.for) {
        var b = Symbol.for;
        r = b("react.element"), o = b("react.portal"), t.Fragment = b("react.fragment"), i = b("react.strict_mode"), s = b("react.profiler"), a = b("react.provider"), l = b("react.context"), c = b("react.forward_ref"), u = b("react.suspense"), d = b("react.suspense_list"), f = b("react.memo"), h = b("react.lazy"), p = b("react.block"), m = b("react.server.block"), g = b("react.fundamental"), b("react.scope"), b("react.opaque.id"), y = b("react.debug_trace_mode"), b("react.offscreen"), v = b("react.legacy_hidden");
      }
      var _ = typeof Symbol == "function" && Symbol.iterator, w = "@@iterator";
      function x(re) {
        if (re === null || typeof re != "object")
          return null;
        var J = _ && re[_] || re[w];
        return typeof J == "function" ? J : null;
      }
      var E = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function S(re) {
        {
          for (var J = arguments.length, ie = new Array(J > 1 ? J - 1 : 0), me = 1; me < J; me++)
            ie[me - 1] = arguments[me];
          C("error", re, ie);
        }
      }
      function C(re, J, ie) {
        {
          var me = E.ReactDebugCurrentFrame, be = me.getStackAddendum();
          be !== "" && (J += "%s", ie = ie.concat([be]));
          var tt = ie.map(function(Ke) {
            return "" + Ke;
          });
          tt.unshift("Warning: " + J), Function.prototype.apply.call(console[re], console, tt);
        }
      }
      var R = !1;
      function P(re) {
        return !!(typeof re == "string" || typeof re == "function" || re === t.Fragment || re === s || re === y || re === i || re === u || re === d || re === v || R || typeof re == "object" && re !== null && (re.$$typeof === h || re.$$typeof === f || re.$$typeof === a || re.$$typeof === l || re.$$typeof === c || re.$$typeof === g || re.$$typeof === p || re[0] === m));
      }
      function N(re, J, ie) {
        var me = J.displayName || J.name || "";
        return re.displayName || (me !== "" ? ie + "(" + me + ")" : ie);
      }
      function A(re) {
        return re.displayName || "Context";
      }
      function O(re) {
        if (re == null)
          return null;
        if (typeof re.tag == "number" && S("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue."), typeof re == "function")
          return re.displayName || re.name || null;
        if (typeof re == "string")
          return re;
        switch (re) {
          case t.Fragment:
            return "Fragment";
          case o:
            return "Portal";
          case s:
            return "Profiler";
          case i:
            return "StrictMode";
          case u:
            return "Suspense";
          case d:
            return "SuspenseList";
        }
        if (typeof re == "object")
          switch (re.$$typeof) {
            case l:
              var J = re;
              return A(J) + ".Consumer";
            case a:
              var ie = re;
              return A(ie._context) + ".Provider";
            case c:
              return N(re, re.render, "ForwardRef");
            case f:
              return O(re.type);
            case p:
              return O(re._render);
            case h: {
              var me = re, be = me._payload, tt = me._init;
              try {
                return O(tt(be));
              } catch {
                return null;
              }
            }
          }
        return null;
      }
      var k = 0, T, I, j, z, $, D, U;
      function q() {
      }
      q.__reactDisabledLog = !0;
      function F() {
        {
          if (k === 0) {
            T = console.log, I = console.info, j = console.warn, z = console.error, $ = console.group, D = console.groupCollapsed, U = console.groupEnd;
            var re = {
              configurable: !0,
              enumerable: !0,
              value: q,
              writable: !0
            };
            Object.defineProperties(console, {
              info: re,
              log: re,
              warn: re,
              error: re,
              group: re,
              groupCollapsed: re,
              groupEnd: re
            });
          }
          k++;
        }
      }
      function B() {
        {
          if (k--, k === 0) {
            var re = {
              configurable: !0,
              enumerable: !0,
              writable: !0
            };
            Object.defineProperties(console, {
              log: n({}, re, {
                value: T
              }),
              info: n({}, re, {
                value: I
              }),
              warn: n({}, re, {
                value: j
              }),
              error: n({}, re, {
                value: z
              }),
              group: n({}, re, {
                value: $
              }),
              groupCollapsed: n({}, re, {
                value: D
              }),
              groupEnd: n({}, re, {
                value: U
              })
            });
          }
          k < 0 && S("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
        }
      }
      var H = E.ReactCurrentDispatcher, Z;
      function W(re, J, ie) {
        {
          if (Z === void 0)
            try {
              throw Error();
            } catch (be) {
              var me = be.stack.trim().match(/\n( *(at )?)/);
              Z = me && me[1] || "";
            }
          return `
` + Z + re;
        }
      }
      var G = !1, ee;
      {
        var Y = typeof WeakMap == "function" ? WeakMap : Map;
        ee = new Y();
      }
      function L(re, J) {
        if (!re || G)
          return "";
        {
          var ie = ee.get(re);
          if (ie !== void 0)
            return ie;
        }
        var me;
        G = !0;
        var be = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var tt;
        tt = H.current, H.current = null, F();
        try {
          if (J) {
            var Ke = function() {
              throw Error();
            };
            if (Object.defineProperty(Ke.prototype, "props", {
              set: function() {
                throw Error();
              }
            }), typeof Reflect == "object" && Reflect.construct) {
              try {
                Reflect.construct(Ke, []);
              } catch (un) {
                me = un;
              }
              Reflect.construct(re, [], Ke);
            } else {
              try {
                Ke.call();
              } catch (un) {
                me = un;
              }
              re.call(Ke.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (un) {
              me = un;
            }
            re();
          }
        } catch (un) {
          if (un && me && typeof un.stack == "string") {
            for (var Fe = un.stack.split(`
`), We = me.stack.split(`
`), Xe = Fe.length - 1, at = We.length - 1; Xe >= 1 && at >= 0 && Fe[Xe] !== We[at]; )
              at--;
            for (; Xe >= 1 && at >= 0; Xe--, at--)
              if (Fe[Xe] !== We[at]) {
                if (Xe !== 1 || at !== 1)
                  do
                    if (Xe--, at--, at < 0 || Fe[Xe] !== We[at]) {
                      var bt = `
` + Fe[Xe].replace(" at new ", " at ");
                      return typeof re == "function" && ee.set(re, bt), bt;
                    }
                  while (Xe >= 1 && at >= 0);
                break;
              }
          }
        } finally {
          G = !1, H.current = tt, B(), Error.prepareStackTrace = be;
        }
        var Lt = re ? re.displayName || re.name : "", bn = Lt ? W(Lt) : "";
        return typeof re == "function" && ee.set(re, bn), bn;
      }
      function V(re, J, ie) {
        return L(re, !1);
      }
      function K(re) {
        var J = re.prototype;
        return !!(J && J.isReactComponent);
      }
      function ne(re, J, ie) {
        if (re == null)
          return "";
        if (typeof re == "function")
          return L(re, K(re));
        if (typeof re == "string")
          return W(re);
        switch (re) {
          case u:
            return W("Suspense");
          case d:
            return W("SuspenseList");
        }
        if (typeof re == "object")
          switch (re.$$typeof) {
            case c:
              return V(re.render);
            case f:
              return ne(re.type, J, ie);
            case p:
              return V(re._render);
            case h: {
              var me = re, be = me._payload, tt = me._init;
              try {
                return ne(tt(be), J, ie);
              } catch {
              }
            }
          }
        return "";
      }
      var ce = {}, fe = E.ReactDebugCurrentFrame;
      function ve(re) {
        if (re) {
          var J = re._owner, ie = ne(re.type, re._source, J ? J.type : null);
          fe.setExtraStackFrame(ie);
        } else
          fe.setExtraStackFrame(null);
      }
      function _e(re, J, ie, me, be) {
        {
          var tt = Function.call.bind(Object.prototype.hasOwnProperty);
          for (var Ke in re)
            if (tt(re, Ke)) {
              var Fe = void 0;
              try {
                if (typeof re[Ke] != "function") {
                  var We = Error((me || "React class") + ": " + ie + " type `" + Ke + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof re[Ke] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw We.name = "Invariant Violation", We;
                }
                Fe = re[Ke](J, Ke, me, ie, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (Xe) {
                Fe = Xe;
              }
              Fe && !(Fe instanceof Error) && (ve(be), S("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", me || "React class", ie, Ke, typeof Fe), ve(null)), Fe instanceof Error && !(Fe.message in ce) && (ce[Fe.message] = !0, ve(be), S("Failed %s type: %s", ie, Fe.message), ve(null));
            }
        }
      }
      var Ee = E.ReactCurrentOwner, Me = Object.prototype.hasOwnProperty, Le = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      }, Ce, Je;
      function Ie(re) {
        if (Me.call(re, "ref")) {
          var J = Object.getOwnPropertyDescriptor(re, "ref").get;
          if (J && J.isReactWarning)
            return !1;
        }
        return re.ref !== void 0;
      }
      function nt(re) {
        if (Me.call(re, "key")) {
          var J = Object.getOwnPropertyDescriptor(re, "key").get;
          if (J && J.isReactWarning)
            return !1;
        }
        return re.key !== void 0;
      }
      function ct(re, J) {
        typeof re.ref == "string" && Ee.current;
      }
      function mt(re, J) {
        {
          var ie = function() {
            Ce || (Ce = !0, S("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", J));
          };
          ie.isReactWarning = !0, Object.defineProperty(re, "key", {
            get: ie,
            configurable: !0
          });
        }
      }
      function gt(re, J) {
        {
          var ie = function() {
            Je || (Je = !0, S("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", J));
          };
          ie.isReactWarning = !0, Object.defineProperty(re, "ref", {
            get: ie,
            configurable: !0
          });
        }
      }
      var Et = function(re, J, ie, me, be, tt, Ke) {
        var Fe = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: r,
          // Built-in properties that belong on the element
          type: re,
          key: J,
          ref: ie,
          props: Ke,
          // Record the component responsible for creating this element.
          _owner: tt
        };
        return Fe._store = {}, Object.defineProperty(Fe._store, "validated", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: !1
        }), Object.defineProperty(Fe, "_self", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: me
        }), Object.defineProperty(Fe, "_source", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: be
        }), Object.freeze && (Object.freeze(Fe.props), Object.freeze(Fe)), Fe;
      };
      function Rt(re, J, ie, me, be) {
        {
          var tt, Ke = {}, Fe = null, We = null;
          ie !== void 0 && (Fe = "" + ie), nt(J) && (Fe = "" + J.key), Ie(J) && (We = J.ref, ct(J));
          for (tt in J)
            Me.call(J, tt) && !Le.hasOwnProperty(tt) && (Ke[tt] = J[tt]);
          if (re && re.defaultProps) {
            var Xe = re.defaultProps;
            for (tt in Xe)
              Ke[tt] === void 0 && (Ke[tt] = Xe[tt]);
          }
          if (Fe || We) {
            var at = typeof re == "function" ? re.displayName || re.name || "Unknown" : re;
            Fe && mt(Ke, at), We && gt(Ke, at);
          }
          return Et(re, Fe, We, be, me, Ee.current, Ke);
        }
      }
      var zt = E.ReactCurrentOwner, At = E.ReactDebugCurrentFrame;
      function X(re) {
        if (re) {
          var J = re._owner, ie = ne(re.type, re._source, J ? J.type : null);
          At.setExtraStackFrame(ie);
        } else
          At.setExtraStackFrame(null);
      }
      var ae;
      ae = !1;
      function ye(re) {
        return typeof re == "object" && re !== null && re.$$typeof === r;
      }
      function De() {
        {
          if (zt.current) {
            var re = O(zt.current.type);
            if (re)
              return `

Check the render method of \`` + re + "`.";
          }
          return "";
        }
      }
      function Te(re) {
        return "";
      }
      var st = {};
      function ft(re) {
        {
          var J = De();
          if (!J) {
            var ie = typeof re == "string" ? re : re.displayName || re.name;
            ie && (J = `

Check the top-level render call using <` + ie + ">.");
          }
          return J;
        }
      }
      function Ht(re, J) {
        {
          if (!re._store || re._store.validated || re.key != null)
            return;
          re._store.validated = !0;
          var ie = ft(J);
          if (st[ie])
            return;
          st[ie] = !0;
          var me = "";
          re && re._owner && re._owner !== zt.current && (me = " It was passed a child from " + O(re._owner.type) + "."), X(re), S('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', ie, me), X(null);
        }
      }
      function nn(re, J) {
        {
          if (typeof re != "object")
            return;
          if (Array.isArray(re))
            for (var ie = 0; ie < re.length; ie++) {
              var me = re[ie];
              ye(me) && Ht(me, J);
            }
          else if (ye(re))
            re._store && (re._store.validated = !0);
          else if (re) {
            var be = x(re);
            if (typeof be == "function" && be !== re.entries)
              for (var tt = be.call(re), Ke; !(Ke = tt.next()).done; )
                ye(Ke.value) && Ht(Ke.value, J);
          }
        }
      }
      function It(re) {
        {
          var J = re.type;
          if (J == null || typeof J == "string")
            return;
          var ie;
          if (typeof J == "function")
            ie = J.propTypes;
          else if (typeof J == "object" && (J.$$typeof === c || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          J.$$typeof === f))
            ie = J.propTypes;
          else
            return;
          if (ie) {
            var me = O(J);
            _e(ie, re.props, "prop", me, re);
          } else if (J.PropTypes !== void 0 && !ae) {
            ae = !0;
            var be = O(J);
            S("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", be || "Unknown");
          }
          typeof J.getDefaultProps == "function" && !J.getDefaultProps.isReactClassApproved && S("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
        }
      }
      function Rn(re) {
        {
          for (var J = Object.keys(re.props), ie = 0; ie < J.length; ie++) {
            var me = J[ie];
            if (me !== "children" && me !== "key") {
              X(re), S("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", me), X(null);
              break;
            }
          }
          re.ref !== null && (X(re), S("Invalid attribute `ref` supplied to `React.Fragment`."), X(null));
        }
      }
      function yt(re, J, ie, me, be, tt) {
        {
          var Ke = P(re);
          if (!Ke) {
            var Fe = "";
            (re === void 0 || typeof re == "object" && re !== null && Object.keys(re).length === 0) && (Fe += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
            var We = Te();
            We ? Fe += We : Fe += De();
            var Xe;
            re === null ? Xe = "null" : Array.isArray(re) ? Xe = "array" : re !== void 0 && re.$$typeof === r ? (Xe = "<" + (O(re.type) || "Unknown") + " />", Fe = " Did you accidentally export a JSX literal instead of a component?") : Xe = typeof re, S("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Xe, Fe);
          }
          var at = Rt(re, J, ie, be, tt);
          if (at == null)
            return at;
          if (Ke) {
            var bt = J.children;
            if (bt !== void 0)
              if (me)
                if (Array.isArray(bt)) {
                  for (var Lt = 0; Lt < bt.length; Lt++)
                    nn(bt[Lt], re);
                  Object.freeze && Object.freeze(bt);
                } else
                  S("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
              else
                nn(bt, re);
          }
          return re === t.Fragment ? Rn(at) : It(at), at;
        }
      }
      function oe(re, J, ie) {
        return yt(re, J, ie, !0);
      }
      function ge(re, J, ie) {
        return yt(re, J, ie, !1);
      }
      var pe = ge, He = oe;
      t.jsx = pe, t.jsxs = He;
    }();
  }(_F)), _F;
}
var xF;
function LIe() {
  return xF || (xF = 1, process.env.NODE_ENV === "production" ? OC.exports = NIe() : OC.exports = jIe()), OC.exports;
}
var M = LIe(), Xo = "top", Xi = "bottom", Qi = "right", Qo = "left", _5 = "auto", iv = [Xo, Xi, Qi, Qo], jh = "start", D0 = "end", FIe = "clippingParents", xle = "viewport", tm = "popper", BIe = "reference", EF = /* @__PURE__ */ iv.reduce(function(t, e) {
  return t.concat([e + "-" + jh, e + "-" + D0]);
}, []), Ele = /* @__PURE__ */ [].concat(iv, [_5]).reduce(function(t, e) {
  return t.concat([e, e + "-" + jh, e + "-" + D0]);
}, []), zIe = "beforeRead", qIe = "read", UIe = "afterRead", HIe = "beforeMain", VIe = "main", WIe = "afterMain", GIe = "beforeWrite", YIe = "write", KIe = "afterWrite", XIe = [zIe, qIe, UIe, HIe, VIe, WIe, GIe, YIe, KIe];
function Sa(t) {
  return t ? (t.nodeName || "").toLowerCase() : null;
}
function Oi(t) {
  if (t == null)
    return window;
  if (t.toString() !== "[object Window]") {
    var e = t.ownerDocument;
    return e && e.defaultView || window;
  }
  return t;
}
function Ad(t) {
  var e = Oi(t).Element;
  return t instanceof e || t instanceof Element;
}
function Hi(t) {
  var e = Oi(t).HTMLElement;
  return t instanceof e || t instanceof HTMLElement;
}
function w5(t) {
  if (typeof ShadowRoot > "u")
    return !1;
  var e = Oi(t).ShadowRoot;
  return t instanceof e || t instanceof ShadowRoot;
}
function QIe(t) {
  var e = t.state;
  Object.keys(e.elements).forEach(function(n) {
    var r = e.styles[n] || {}, o = e.attributes[n] || {}, i = e.elements[n];
    !Hi(i) || !Sa(i) || (Object.assign(i.style, r), Object.keys(o).forEach(function(s) {
      var a = o[s];
      a === !1 ? i.removeAttribute(s) : i.setAttribute(s, a === !0 ? "" : a);
    }));
  });
}
function ZIe(t) {
  var e = t.state, n = {
    popper: {
      position: e.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(e.elements.popper.style, n.popper), e.styles = n, e.elements.arrow && Object.assign(e.elements.arrow.style, n.arrow), function() {
    Object.keys(e.elements).forEach(function(r) {
      var o = e.elements[r], i = e.attributes[r] || {}, s = Object.keys(e.styles.hasOwnProperty(r) ? e.styles[r] : n[r]), a = s.reduce(function(l, c) {
        return l[c] = "", l;
      }, {});
      !Hi(o) || !Sa(o) || (Object.assign(o.style, a), Object.keys(i).forEach(function(l) {
        o.removeAttribute(l);
      }));
    });
  };
}
const x5 = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: QIe,
  effect: ZIe,
  requires: ["computeStyles"]
};
function ga(t) {
  return t.split("-")[0];
}
var md = Math.max, nx = Math.min, Lh = Math.round;
function XD() {
  var t = navigator.userAgentData;
  return t != null && t.brands && Array.isArray(t.brands) ? t.brands.map(function(e) {
    return e.brand + "/" + e.version;
  }).join(" ") : navigator.userAgent;
}
function Sle() {
  return !/^((?!chrome|android).)*safari/i.test(XD());
}
function Fh(t, e, n) {
  e === void 0 && (e = !1), n === void 0 && (n = !1);
  var r = t.getBoundingClientRect(), o = 1, i = 1;
  e && Hi(t) && (o = t.offsetWidth > 0 && Lh(r.width) / t.offsetWidth || 1, i = t.offsetHeight > 0 && Lh(r.height) / t.offsetHeight || 1);
  var s = Ad(t) ? Oi(t) : window, a = s.visualViewport, l = !Sle() && n, c = (r.left + (l && a ? a.offsetLeft : 0)) / o, u = (r.top + (l && a ? a.offsetTop : 0)) / i, d = r.width / o, f = r.height / i;
  return {
    width: d,
    height: f,
    top: u,
    right: c + d,
    bottom: u + f,
    left: c,
    x: c,
    y: u
  };
}
function E5(t) {
  var e = Fh(t), n = t.offsetWidth, r = t.offsetHeight;
  return Math.abs(e.width - n) <= 1 && (n = e.width), Math.abs(e.height - r) <= 1 && (r = e.height), {
    x: t.offsetLeft,
    y: t.offsetTop,
    width: n,
    height: r
  };
}
function Ole(t, e) {
  var n = e.getRootNode && e.getRootNode();
  if (t.contains(e))
    return !0;
  if (n && w5(n)) {
    var r = e;
    do {
      if (r && t.isSameNode(r))
        return !0;
      r = r.parentNode || r.host;
    } while (r);
  }
  return !1;
}
function Dl(t) {
  return Oi(t).getComputedStyle(t);
}
function JIe(t) {
  return ["table", "td", "th"].indexOf(Sa(t)) >= 0;
}
function au(t) {
  return ((Ad(t) ? t.ownerDocument : (
    // $FlowFixMe[prop-missing]
    t.document
  )) || window.document).documentElement;
}
function fS(t) {
  return Sa(t) === "html" ? t : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    t.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    t.parentNode || // DOM Element detected
    (w5(t) ? t.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    au(t)
  );
}
function SF(t) {
  return !Hi(t) || // https://github.com/popperjs/popper-core/issues/837
  Dl(t).position === "fixed" ? null : t.offsetParent;
}
function eNe(t) {
  var e = /firefox/i.test(XD()), n = /Trident/i.test(XD());
  if (n && Hi(t)) {
    var r = Dl(t);
    if (r.position === "fixed")
      return null;
  }
  var o = fS(t);
  for (w5(o) && (o = o.host); Hi(o) && ["html", "body"].indexOf(Sa(o)) < 0; ) {
    var i = Dl(o);
    if (i.transform !== "none" || i.perspective !== "none" || i.contain === "paint" || ["transform", "perspective"].indexOf(i.willChange) !== -1 || e && i.willChange === "filter" || e && i.filter && i.filter !== "none")
      return o;
    o = o.parentNode;
  }
  return null;
}
function sv(t) {
  for (var e = Oi(t), n = SF(t); n && JIe(n) && Dl(n).position === "static"; )
    n = SF(n);
  return n && (Sa(n) === "html" || Sa(n) === "body" && Dl(n).position === "static") ? e : n || eNe(t) || e;
}
function S5(t) {
  return ["top", "bottom"].indexOf(t) >= 0 ? "x" : "y";
}
function Hg(t, e, n) {
  return md(t, nx(e, n));
}
function tNe(t, e, n) {
  var r = Hg(t, e, n);
  return r > n ? n : r;
}
function Cle() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function kle(t) {
  return Object.assign({}, Cle(), t);
}
function Ale(t, e) {
  return e.reduce(function(n, r) {
    return n[r] = t, n;
  }, {});
}
var nNe = function(t, e) {
  return t = typeof t == "function" ? t(Object.assign({}, e.rects, {
    placement: e.placement
  })) : t, kle(typeof t != "number" ? t : Ale(t, iv));
};
function rNe(t) {
  var e, n = t.state, r = t.name, o = t.options, i = n.elements.arrow, s = n.modifiersData.popperOffsets, a = ga(n.placement), l = S5(a), c = [Qo, Qi].indexOf(a) >= 0, u = c ? "height" : "width";
  if (!(!i || !s)) {
    var d = nNe(o.padding, n), f = E5(i), h = l === "y" ? Xo : Qo, p = l === "y" ? Xi : Qi, m = n.rects.reference[u] + n.rects.reference[l] - s[l] - n.rects.popper[u], g = s[l] - n.rects.reference[l], y = sv(i), v = y ? l === "y" ? y.clientHeight || 0 : y.clientWidth || 0 : 0, b = m / 2 - g / 2, _ = d[h], w = v - f[u] - d[p], x = v / 2 - f[u] / 2 + b, E = Hg(_, x, w), S = l;
    n.modifiersData[r] = (e = {}, e[S] = E, e.centerOffset = E - x, e);
  }
}
function oNe(t) {
  var e = t.state, n = t.options, r = n.element, o = r === void 0 ? "[data-popper-arrow]" : r;
  o != null && (typeof o == "string" && (o = e.elements.popper.querySelector(o), !o) || Ole(e.elements.popper, o) && (e.elements.arrow = o));
}
const iNe = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: rNe,
  effect: oNe,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function Bh(t) {
  return t.split("-")[1];
}
var sNe = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function aNe(t, e) {
  var n = t.x, r = t.y, o = e.devicePixelRatio || 1;
  return {
    x: Lh(n * o) / o || 0,
    y: Lh(r * o) / o || 0
  };
}
function OF(t) {
  var e, n = t.popper, r = t.popperRect, o = t.placement, i = t.variation, s = t.offsets, a = t.position, l = t.gpuAcceleration, c = t.adaptive, u = t.roundOffsets, d = t.isFixed, f = s.x, h = f === void 0 ? 0 : f, p = s.y, m = p === void 0 ? 0 : p, g = typeof u == "function" ? u({
    x: h,
    y: m
  }) : {
    x: h,
    y: m
  };
  h = g.x, m = g.y;
  var y = s.hasOwnProperty("x"), v = s.hasOwnProperty("y"), b = Qo, _ = Xo, w = window;
  if (c) {
    var x = sv(n), E = "clientHeight", S = "clientWidth";
    if (x === Oi(n) && (x = au(n), Dl(x).position !== "static" && a === "absolute" && (E = "scrollHeight", S = "scrollWidth")), x = x, o === Xo || (o === Qo || o === Qi) && i === D0) {
      _ = Xi;
      var C = d && x === w && w.visualViewport ? w.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        x[E]
      );
      m -= C - r.height, m *= l ? 1 : -1;
    }
    if (o === Qo || (o === Xo || o === Xi) && i === D0) {
      b = Qi;
      var R = d && x === w && w.visualViewport ? w.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        x[S]
      );
      h -= R - r.width, h *= l ? 1 : -1;
    }
  }
  var P = Object.assign({
    position: a
  }, c && sNe), N = u === !0 ? aNe({
    x: h,
    y: m
  }, Oi(n)) : {
    x: h,
    y: m
  };
  if (h = N.x, m = N.y, l) {
    var A;
    return Object.assign({}, P, (A = {}, A[_] = v ? "0" : "", A[b] = y ? "0" : "", A.transform = (w.devicePixelRatio || 1) <= 1 ? "translate(" + h + "px, " + m + "px)" : "translate3d(" + h + "px, " + m + "px, 0)", A));
  }
  return Object.assign({}, P, (e = {}, e[_] = v ? m + "px" : "", e[b] = y ? h + "px" : "", e.transform = "", e));
}
function lNe(t) {
  var e = t.state, n = t.options, r = n.gpuAcceleration, o = r === void 0 ? !0 : r, i = n.adaptive, s = i === void 0 ? !0 : i, a = n.roundOffsets, l = a === void 0 ? !0 : a, c = {
    placement: ga(e.placement),
    variation: Bh(e.placement),
    popper: e.elements.popper,
    popperRect: e.rects.popper,
    gpuAcceleration: o,
    isFixed: e.options.strategy === "fixed"
  };
  e.modifiersData.popperOffsets != null && (e.styles.popper = Object.assign({}, e.styles.popper, OF(Object.assign({}, c, {
    offsets: e.modifiersData.popperOffsets,
    position: e.options.strategy,
    adaptive: s,
    roundOffsets: l
  })))), e.modifiersData.arrow != null && (e.styles.arrow = Object.assign({}, e.styles.arrow, OF(Object.assign({}, c, {
    offsets: e.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: l
  })))), e.attributes.popper = Object.assign({}, e.attributes.popper, {
    "data-popper-placement": e.placement
  });
}
const cNe = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: lNe,
  data: {}
};
var db = {
  passive: !0
};
function uNe(t) {
  var e = t.state, n = t.instance, r = t.options, o = r.scroll, i = o === void 0 ? !0 : o, s = r.resize, a = s === void 0 ? !0 : s, l = Oi(e.elements.popper), c = [].concat(e.scrollParents.reference, e.scrollParents.popper);
  return i && c.forEach(function(u) {
    u.addEventListener("scroll", n.update, db);
  }), a && l.addEventListener("resize", n.update, db), function() {
    i && c.forEach(function(u) {
      u.removeEventListener("scroll", n.update, db);
    }), a && l.removeEventListener("resize", n.update, db);
  };
}
const dNe = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: uNe,
  data: {}
};
var fNe = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function K_(t) {
  return t.replace(/left|right|bottom|top/g, function(e) {
    return fNe[e];
  });
}
var hNe = {
  start: "end",
  end: "start"
};
function CF(t) {
  return t.replace(/start|end/g, function(e) {
    return hNe[e];
  });
}
function O5(t) {
  var e = Oi(t), n = e.pageXOffset, r = e.pageYOffset;
  return {
    scrollLeft: n,
    scrollTop: r
  };
}
function C5(t) {
  return Fh(au(t)).left + O5(t).scrollLeft;
}
function pNe(t, e) {
  var n = Oi(t), r = au(t), o = n.visualViewport, i = r.clientWidth, s = r.clientHeight, a = 0, l = 0;
  if (o) {
    i = o.width, s = o.height;
    var c = Sle();
    (c || !c && e === "fixed") && (a = o.offsetLeft, l = o.offsetTop);
  }
  return {
    width: i,
    height: s,
    x: a + C5(t),
    y: l
  };
}
function mNe(t) {
  var e, n = au(t), r = O5(t), o = (e = t.ownerDocument) == null ? void 0 : e.body, i = md(n.scrollWidth, n.clientWidth, o ? o.scrollWidth : 0, o ? o.clientWidth : 0), s = md(n.scrollHeight, n.clientHeight, o ? o.scrollHeight : 0, o ? o.clientHeight : 0), a = -r.scrollLeft + C5(t), l = -r.scrollTop;
  return Dl(o || n).direction === "rtl" && (a += md(n.clientWidth, o ? o.clientWidth : 0) - i), {
    width: i,
    height: s,
    x: a,
    y: l
  };
}
function k5(t) {
  var e = Dl(t), n = e.overflow, r = e.overflowX, o = e.overflowY;
  return /auto|scroll|overlay|hidden/.test(n + o + r);
}
function Tle(t) {
  return ["html", "body", "#document"].indexOf(Sa(t)) >= 0 ? t.ownerDocument.body : Hi(t) && k5(t) ? t : Tle(fS(t));
}
function Vg(t, e) {
  var n;
  e === void 0 && (e = []);
  var r = Tle(t), o = r === ((n = t.ownerDocument) == null ? void 0 : n.body), i = Oi(r), s = o ? [i].concat(i.visualViewport || [], k5(r) ? r : []) : r, a = e.concat(s);
  return o ? a : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    a.concat(Vg(fS(s)))
  );
}
function QD(t) {
  return Object.assign({}, t, {
    left: t.x,
    top: t.y,
    right: t.x + t.width,
    bottom: t.y + t.height
  });
}
function gNe(t, e) {
  var n = Fh(t, !1, e === "fixed");
  return n.top = n.top + t.clientTop, n.left = n.left + t.clientLeft, n.bottom = n.top + t.clientHeight, n.right = n.left + t.clientWidth, n.width = t.clientWidth, n.height = t.clientHeight, n.x = n.left, n.y = n.top, n;
}
function kF(t, e, n) {
  return e === xle ? QD(pNe(t, n)) : Ad(e) ? gNe(e, n) : QD(mNe(au(t)));
}
function yNe(t) {
  var e = Vg(fS(t)), n = ["absolute", "fixed"].indexOf(Dl(t).position) >= 0, r = n && Hi(t) ? sv(t) : t;
  return Ad(r) ? e.filter(function(o) {
    return Ad(o) && Ole(o, r) && Sa(o) !== "body";
  }) : [];
}
function vNe(t, e, n, r) {
  var o = e === "clippingParents" ? yNe(t) : [].concat(e), i = [].concat(o, [n]), s = i[0], a = i.reduce(function(l, c) {
    var u = kF(t, c, r);
    return l.top = md(u.top, l.top), l.right = nx(u.right, l.right), l.bottom = nx(u.bottom, l.bottom), l.left = md(u.left, l.left), l;
  }, kF(t, s, r));
  return a.width = a.right - a.left, a.height = a.bottom - a.top, a.x = a.left, a.y = a.top, a;
}
function Rle(t) {
  var e = t.reference, n = t.element, r = t.placement, o = r ? ga(r) : null, i = r ? Bh(r) : null, s = e.x + e.width / 2 - n.width / 2, a = e.y + e.height / 2 - n.height / 2, l;
  switch (o) {
    case Xo:
      l = {
        x: s,
        y: e.y - n.height
      };
      break;
    case Xi:
      l = {
        x: s,
        y: e.y + e.height
      };
      break;
    case Qi:
      l = {
        x: e.x + e.width,
        y: a
      };
      break;
    case Qo:
      l = {
        x: e.x - n.width,
        y: a
      };
      break;
    default:
      l = {
        x: e.x,
        y: e.y
      };
  }
  var c = o ? S5(o) : null;
  if (c != null) {
    var u = c === "y" ? "height" : "width";
    switch (i) {
      case jh:
        l[c] = l[c] - (e[u] / 2 - n[u] / 2);
        break;
      case D0:
        l[c] = l[c] + (e[u] / 2 - n[u] / 2);
        break;
    }
  }
  return l;
}
function I0(t, e) {
  e === void 0 && (e = {});
  var n = e, r = n.placement, o = r === void 0 ? t.placement : r, i = n.strategy, s = i === void 0 ? t.strategy : i, a = n.boundary, l = a === void 0 ? FIe : a, c = n.rootBoundary, u = c === void 0 ? xle : c, d = n.elementContext, f = d === void 0 ? tm : d, h = n.altBoundary, p = h === void 0 ? !1 : h, m = n.padding, g = m === void 0 ? 0 : m, y = kle(typeof g != "number" ? g : Ale(g, iv)), v = f === tm ? BIe : tm, b = t.rects.popper, _ = t.elements[p ? v : f], w = vNe(Ad(_) ? _ : _.contextElement || au(t.elements.popper), l, u, s), x = Fh(t.elements.reference), E = Rle({
    reference: x,
    element: b,
    placement: o
  }), S = QD(Object.assign({}, b, E)), C = f === tm ? S : x, R = {
    top: w.top - C.top + y.top,
    bottom: C.bottom - w.bottom + y.bottom,
    left: w.left - C.left + y.left,
    right: C.right - w.right + y.right
  }, P = t.modifiersData.offset;
  if (f === tm && P) {
    var N = P[o];
    Object.keys(R).forEach(function(A) {
      var O = [Qi, Xi].indexOf(A) >= 0 ? 1 : -1, k = [Xo, Xi].indexOf(A) >= 0 ? "y" : "x";
      R[A] += N[k] * O;
    });
  }
  return R;
}
function bNe(t, e) {
  e === void 0 && (e = {});
  var n = e, r = n.placement, o = n.boundary, i = n.rootBoundary, s = n.padding, a = n.flipVariations, l = n.allowedAutoPlacements, c = l === void 0 ? Ele : l, u = Bh(r), d = u ? a ? EF : EF.filter(function(p) {
    return Bh(p) === u;
  }) : iv, f = d.filter(function(p) {
    return c.indexOf(p) >= 0;
  });
  f.length === 0 && (f = d);
  var h = f.reduce(function(p, m) {
    return p[m] = I0(t, {
      placement: m,
      boundary: o,
      rootBoundary: i,
      padding: s
    })[ga(m)], p;
  }, {});
  return Object.keys(h).sort(function(p, m) {
    return h[p] - h[m];
  });
}
function _Ne(t) {
  if (ga(t) === _5)
    return [];
  var e = K_(t);
  return [CF(t), e, CF(e)];
}
function wNe(t) {
  var e = t.state, n = t.options, r = t.name;
  if (!e.modifiersData[r]._skip) {
    for (var o = n.mainAxis, i = o === void 0 ? !0 : o, s = n.altAxis, a = s === void 0 ? !0 : s, l = n.fallbackPlacements, c = n.padding, u = n.boundary, d = n.rootBoundary, f = n.altBoundary, h = n.flipVariations, p = h === void 0 ? !0 : h, m = n.allowedAutoPlacements, g = e.options.placement, y = ga(g), v = y === g, b = l || (v || !p ? [K_(g)] : _Ne(g)), _ = [g].concat(b).reduce(function(F, B) {
      return F.concat(ga(B) === _5 ? bNe(e, {
        placement: B,
        boundary: u,
        rootBoundary: d,
        padding: c,
        flipVariations: p,
        allowedAutoPlacements: m
      }) : B);
    }, []), w = e.rects.reference, x = e.rects.popper, E = /* @__PURE__ */ new Map(), S = !0, C = _[0], R = 0; R < _.length; R++) {
      var P = _[R], N = ga(P), A = Bh(P) === jh, O = [Xo, Xi].indexOf(N) >= 0, k = O ? "width" : "height", T = I0(e, {
        placement: P,
        boundary: u,
        rootBoundary: d,
        altBoundary: f,
        padding: c
      }), I = O ? A ? Qi : Qo : A ? Xi : Xo;
      w[k] > x[k] && (I = K_(I));
      var j = K_(I), z = [];
      if (i && z.push(T[N] <= 0), a && z.push(T[I] <= 0, T[j] <= 0), z.every(function(F) {
        return F;
      })) {
        C = P, S = !1;
        break;
      }
      E.set(P, z);
    }
    if (S)
      for (var $ = p ? 3 : 1, D = function(F) {
        var B = _.find(function(H) {
          var Z = E.get(H);
          if (Z)
            return Z.slice(0, F).every(function(W) {
              return W;
            });
        });
        if (B)
          return C = B, "break";
      }, U = $; U > 0; U--) {
        var q = D(U);
        if (q === "break") break;
      }
    e.placement !== C && (e.modifiersData[r]._skip = !0, e.placement = C, e.reset = !0);
  }
}
const xNe = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: wNe,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function AF(t, e, n) {
  return n === void 0 && (n = {
    x: 0,
    y: 0
  }), {
    top: t.top - e.height - n.y,
    right: t.right - e.width + n.x,
    bottom: t.bottom - e.height + n.y,
    left: t.left - e.width - n.x
  };
}
function TF(t) {
  return [Xo, Qi, Xi, Qo].some(function(e) {
    return t[e] >= 0;
  });
}
function ENe(t) {
  var e = t.state, n = t.name, r = e.rects.reference, o = e.rects.popper, i = e.modifiersData.preventOverflow, s = I0(e, {
    elementContext: "reference"
  }), a = I0(e, {
    altBoundary: !0
  }), l = AF(s, r), c = AF(a, o, i), u = TF(l), d = TF(c);
  e.modifiersData[n] = {
    referenceClippingOffsets: l,
    popperEscapeOffsets: c,
    isReferenceHidden: u,
    hasPopperEscaped: d
  }, e.attributes.popper = Object.assign({}, e.attributes.popper, {
    "data-popper-reference-hidden": u,
    "data-popper-escaped": d
  });
}
const SNe = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: ENe
};
function ONe(t, e, n) {
  var r = ga(t), o = [Qo, Xo].indexOf(r) >= 0 ? -1 : 1, i = typeof n == "function" ? n(Object.assign({}, e, {
    placement: t
  })) : n, s = i[0], a = i[1];
  return s = s || 0, a = (a || 0) * o, [Qo, Qi].indexOf(r) >= 0 ? {
    x: a,
    y: s
  } : {
    x: s,
    y: a
  };
}
function CNe(t) {
  var e = t.state, n = t.options, r = t.name, o = n.offset, i = o === void 0 ? [0, 0] : o, s = Ele.reduce(function(u, d) {
    return u[d] = ONe(d, e.rects, i), u;
  }, {}), a = s[e.placement], l = a.x, c = a.y;
  e.modifiersData.popperOffsets != null && (e.modifiersData.popperOffsets.x += l, e.modifiersData.popperOffsets.y += c), e.modifiersData[r] = s;
}
const kNe = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: CNe
};
function ANe(t) {
  var e = t.state, n = t.name;
  e.modifiersData[n] = Rle({
    reference: e.rects.reference,
    element: e.rects.popper,
    placement: e.placement
  });
}
const TNe = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: ANe,
  data: {}
};
function RNe(t) {
  return t === "x" ? "y" : "x";
}
function PNe(t) {
  var e = t.state, n = t.options, r = t.name, o = n.mainAxis, i = o === void 0 ? !0 : o, s = n.altAxis, a = s === void 0 ? !1 : s, l = n.boundary, c = n.rootBoundary, u = n.altBoundary, d = n.padding, f = n.tether, h = f === void 0 ? !0 : f, p = n.tetherOffset, m = p === void 0 ? 0 : p, g = I0(e, {
    boundary: l,
    rootBoundary: c,
    padding: d,
    altBoundary: u
  }), y = ga(e.placement), v = Bh(e.placement), b = !v, _ = S5(y), w = RNe(_), x = e.modifiersData.popperOffsets, E = e.rects.reference, S = e.rects.popper, C = typeof m == "function" ? m(Object.assign({}, e.rects, {
    placement: e.placement
  })) : m, R = typeof C == "number" ? {
    mainAxis: C,
    altAxis: C
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, C), P = e.modifiersData.offset ? e.modifiersData.offset[e.placement] : null, N = {
    x: 0,
    y: 0
  };
  if (x) {
    if (i) {
      var A, O = _ === "y" ? Xo : Qo, k = _ === "y" ? Xi : Qi, T = _ === "y" ? "height" : "width", I = x[_], j = I + g[O], z = I - g[k], $ = h ? -S[T] / 2 : 0, D = v === jh ? E[T] : S[T], U = v === jh ? -S[T] : -E[T], q = e.elements.arrow, F = h && q ? E5(q) : {
        width: 0,
        height: 0
      }, B = e.modifiersData["arrow#persistent"] ? e.modifiersData["arrow#persistent"].padding : Cle(), H = B[O], Z = B[k], W = Hg(0, E[T], F[T]), G = b ? E[T] / 2 - $ - W - H - R.mainAxis : D - W - H - R.mainAxis, ee = b ? -E[T] / 2 + $ + W + Z + R.mainAxis : U + W + Z + R.mainAxis, Y = e.elements.arrow && sv(e.elements.arrow), L = Y ? _ === "y" ? Y.clientTop || 0 : Y.clientLeft || 0 : 0, V = (A = P?.[_]) != null ? A : 0, K = I + G - V - L, ne = I + ee - V, ce = Hg(h ? nx(j, K) : j, I, h ? md(z, ne) : z);
      x[_] = ce, N[_] = ce - I;
    }
    if (a) {
      var fe, ve = _ === "x" ? Xo : Qo, _e = _ === "x" ? Xi : Qi, Ee = x[w], Me = w === "y" ? "height" : "width", Le = Ee + g[ve], Ce = Ee - g[_e], Je = [Xo, Qo].indexOf(y) !== -1, Ie = (fe = P?.[w]) != null ? fe : 0, nt = Je ? Le : Ee - E[Me] - S[Me] - Ie + R.altAxis, ct = Je ? Ee + E[Me] + S[Me] - Ie - R.altAxis : Ce, mt = h && Je ? tNe(nt, Ee, ct) : Hg(h ? nt : Le, Ee, h ? ct : Ce);
      x[w] = mt, N[w] = mt - Ee;
    }
    e.modifiersData[r] = N;
  }
}
const $Ne = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: PNe,
  requiresIfExists: ["offset"]
};
function MNe(t) {
  return {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  };
}
function DNe(t) {
  return t === Oi(t) || !Hi(t) ? O5(t) : MNe(t);
}
function INe(t) {
  var e = t.getBoundingClientRect(), n = Lh(e.width) / t.offsetWidth || 1, r = Lh(e.height) / t.offsetHeight || 1;
  return n !== 1 || r !== 1;
}
function NNe(t, e, n) {
  n === void 0 && (n = !1);
  var r = Hi(e), o = Hi(e) && INe(e), i = au(e), s = Fh(t, o, n), a = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = {
    x: 0,
    y: 0
  };
  return (r || !r && !n) && ((Sa(e) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  k5(i)) && (a = DNe(e)), Hi(e) ? (l = Fh(e, !0), l.x += e.clientLeft, l.y += e.clientTop) : i && (l.x = C5(i))), {
    x: s.left + a.scrollLeft - l.x,
    y: s.top + a.scrollTop - l.y,
    width: s.width,
    height: s.height
  };
}
function jNe(t) {
  var e = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set(), r = [];
  t.forEach(function(i) {
    e.set(i.name, i);
  });
  function o(i) {
    n.add(i.name);
    var s = [].concat(i.requires || [], i.requiresIfExists || []);
    s.forEach(function(a) {
      if (!n.has(a)) {
        var l = e.get(a);
        l && o(l);
      }
    }), r.push(i);
  }
  return t.forEach(function(i) {
    n.has(i.name) || o(i);
  }), r;
}
function LNe(t) {
  var e = jNe(t);
  return XIe.reduce(function(n, r) {
    return n.concat(e.filter(function(o) {
      return o.phase === r;
    }));
  }, []);
}
function FNe(t) {
  var e;
  return function() {
    return e || (e = new Promise(function(n) {
      Promise.resolve().then(function() {
        e = void 0, n(t());
      });
    })), e;
  };
}
function BNe(t) {
  var e = t.reduce(function(n, r) {
    var o = n[r.name];
    return n[r.name] = o ? Object.assign({}, o, r, {
      options: Object.assign({}, o.options, r.options),
      data: Object.assign({}, o.data, r.data)
    }) : r, n;
  }, {});
  return Object.keys(e).map(function(n) {
    return e[n];
  });
}
var RF = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function PF() {
  for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++)
    e[n] = arguments[n];
  return !e.some(function(r) {
    return !(r && typeof r.getBoundingClientRect == "function");
  });
}
function zNe(t) {
  t === void 0 && (t = {});
  var e = t, n = e.defaultModifiers, r = n === void 0 ? [] : n, o = e.defaultOptions, i = o === void 0 ? RF : o;
  return function(s, a, l) {
    l === void 0 && (l = i);
    var c = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, RF, i),
      modifiersData: {},
      elements: {
        reference: s,
        popper: a
      },
      attributes: {},
      styles: {}
    }, u = [], d = !1, f = {
      state: c,
      setOptions: function(m) {
        var g = typeof m == "function" ? m(c.options) : m;
        p(), c.options = Object.assign({}, i, c.options, g), c.scrollParents = {
          reference: Ad(s) ? Vg(s) : s.contextElement ? Vg(s.contextElement) : [],
          popper: Vg(a)
        };
        var y = LNe(BNe([].concat(r, c.options.modifiers)));
        return c.orderedModifiers = y.filter(function(v) {
          return v.enabled;
        }), h(), f.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!d) {
          var m = c.elements, g = m.reference, y = m.popper;
          if (PF(g, y)) {
            c.rects = {
              reference: NNe(g, sv(y), c.options.strategy === "fixed"),
              popper: E5(y)
            }, c.reset = !1, c.placement = c.options.placement, c.orderedModifiers.forEach(function(S) {
              return c.modifiersData[S.name] = Object.assign({}, S.data);
            });
            for (var v = 0; v < c.orderedModifiers.length; v++) {
              if (c.reset === !0) {
                c.reset = !1, v = -1;
                continue;
              }
              var b = c.orderedModifiers[v], _ = b.fn, w = b.options, x = w === void 0 ? {} : w, E = b.name;
              typeof _ == "function" && (c = _({
                state: c,
                options: x,
                name: E,
                instance: f
              }) || c);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: FNe(function() {
        return new Promise(function(m) {
          f.forceUpdate(), m(c);
        });
      }),
      destroy: function() {
        p(), d = !0;
      }
    };
    if (!PF(s, a))
      return f;
    f.setOptions(l).then(function(m) {
      !d && l.onFirstUpdate && l.onFirstUpdate(m);
    });
    function h() {
      c.orderedModifiers.forEach(function(m) {
        var g = m.name, y = m.options, v = y === void 0 ? {} : y, b = m.effect;
        if (typeof b == "function") {
          var _ = b({
            state: c,
            name: g,
            instance: f,
            options: v
          }), w = function() {
          };
          u.push(_ || w);
        }
      });
    }
    function p() {
      u.forEach(function(m) {
        return m();
      }), u = [];
    }
    return f;
  };
}
var qNe = [dNe, TNe, cNe, x5, kNe, xNe, $Ne, iNe, SNe], Ple = /* @__PURE__ */ zNe({
  defaultModifiers: qNe
}), UNe = "tippy-box", $le = "tippy-content", HNe = "tippy-backdrop", Mle = "tippy-arrow", Dle = "tippy-svg-arrow", Iu = {
  passive: !0,
  capture: !0
}, Ile = function() {
  return document.body;
};
function VNe(t, e) {
  return {}.hasOwnProperty.call(t, e);
}
function kC(t, e, n) {
  if (Array.isArray(t)) {
    var r = t[e];
    return r ?? (Array.isArray(n) ? n[e] : n);
  }
  return t;
}
function A5(t, e) {
  var n = {}.toString.call(t);
  return n.indexOf("[object") === 0 && n.indexOf(e + "]") > -1;
}
function Nle(t, e) {
  return typeof t == "function" ? t.apply(void 0, e) : t;
}
function $F(t, e) {
  if (e === 0)
    return t;
  var n;
  return function(r) {
    clearTimeout(n), n = setTimeout(function() {
      t(r);
    }, e);
  };
}
function WNe(t, e) {
  var n = Object.assign({}, t);
  return e.forEach(function(r) {
    delete n[r];
  }), n;
}
function GNe(t) {
  return t.split(/\s+/).filter(Boolean);
}
function Pf(t) {
  return [].concat(t);
}
function MF(t, e) {
  t.indexOf(e) === -1 && t.push(e);
}
function YNe(t) {
  return t.filter(function(e, n) {
    return t.indexOf(e) === n;
  });
}
function KNe(t) {
  return t.split("-")[0];
}
function rx(t) {
  return [].slice.call(t);
}
function DF(t) {
  return Object.keys(t).reduce(function(e, n) {
    return t[n] !== void 0 && (e[n] = t[n]), e;
  }, {});
}
function Wg() {
  return document.createElement("div");
}
function N0(t) {
  return ["Element", "Fragment"].some(function(e) {
    return A5(t, e);
  });
}
function XNe(t) {
  return A5(t, "NodeList");
}
function jle(t) {
  return A5(t, "MouseEvent");
}
function QNe(t) {
  return !!(t && t._tippy && t._tippy.reference === t);
}
function ZNe(t) {
  return N0(t) ? [t] : XNe(t) ? rx(t) : Array.isArray(t) ? t : rx(document.querySelectorAll(t));
}
function AC(t, e) {
  t.forEach(function(n) {
    n && (n.style.transitionDuration = e + "ms");
  });
}
function IF(t, e) {
  t.forEach(function(n) {
    n && n.setAttribute("data-state", e);
  });
}
function Lle(t) {
  var e, n = Pf(t), r = n[0];
  return r != null && (e = r.ownerDocument) != null && e.body ? r.ownerDocument : document;
}
function JNe(t, e) {
  var n = e.clientX, r = e.clientY;
  return t.every(function(o) {
    var i = o.popperRect, s = o.popperState, a = o.props, l = a.interactiveBorder, c = KNe(s.placement), u = s.modifiersData.offset;
    if (!u)
      return !0;
    var d = c === "bottom" ? u.top.y : 0, f = c === "top" ? u.bottom.y : 0, h = c === "right" ? u.left.x : 0, p = c === "left" ? u.right.x : 0, m = i.top - r + d > l, g = r - i.bottom - f > l, y = i.left - n + h > l, v = n - i.right - p > l;
    return m || g || y || v;
  });
}
function TC(t, e, n) {
  var r = e + "EventListener";
  ["transitionend", "webkitTransitionEnd"].forEach(function(o) {
    t[r](o, n);
  });
}
function NF(t, e) {
  for (var n = e; n; ) {
    var r;
    if (t.contains(n))
      return !0;
    n = n.getRootNode == null || (r = n.getRootNode()) == null ? void 0 : r.host;
  }
  return !1;
}
var ra = {
  isTouch: !1
}, jF = 0;
function eje() {
  ra.isTouch || (ra.isTouch = !0, window.performance && document.addEventListener("mousemove", Fle));
}
function Fle() {
  var t = performance.now();
  t - jF < 20 && (ra.isTouch = !1, document.removeEventListener("mousemove", Fle)), jF = t;
}
function tje() {
  var t = document.activeElement;
  if (QNe(t)) {
    var e = t._tippy;
    t.blur && !e.state.isVisible && t.blur();
  }
}
function nje() {
  document.addEventListener("touchstart", eje, Iu), window.addEventListener("blur", tje);
}
var rje = typeof window < "u" && typeof document < "u", oje = rje ? (
  // @ts-ignore
  !!window.msCrypto
) : !1;
function yf(t) {
  var e = t === "destroy" ? "n already-" : " ";
  return [t + "() was called on a" + e + "destroyed instance. This is a no-op but", "indicates a potential memory leak."].join(" ");
}
function LF(t) {
  var e = /[ \t]{2,}/g, n = /^[ \t]*/gm;
  return t.replace(e, " ").replace(n, "").trim();
}
function ije(t) {
  return LF(`
  %ctippy.js

  %c` + LF(t) + `

  %c👷‍ This is a development-only message. It will be removed in production.
  `);
}
function Ble(t) {
  return [
    ije(t),
    // title
    "color: #00C584; font-size: 1.3em; font-weight: bold;",
    // message
    "line-height: 1.5",
    // footer
    "color: #a6a095;"
  ];
}
var j0;
process.env.NODE_ENV !== "production" && sje();
function sje() {
  j0 = /* @__PURE__ */ new Set();
}
function al(t, e) {
  if (t && !j0.has(e)) {
    var n;
    j0.add(e), (n = console).warn.apply(n, Ble(e));
  }
}
function ZD(t, e) {
  if (t && !j0.has(e)) {
    var n;
    j0.add(e), (n = console).error.apply(n, Ble(e));
  }
}
function aje(t) {
  var e = !t, n = Object.prototype.toString.call(t) === "[object Object]" && !t.addEventListener;
  ZD(e, ["tippy() was passed", "`" + String(t) + "`", "as its targets (first) argument. Valid types are: String, Element,", "Element[], or NodeList."].join(" ")), ZD(n, ["tippy() was passed a plain object which is not supported as an argument", "for virtual positioning. Use props.getReferenceClientRect instead."].join(" "));
}
var zle = {
  animateFill: !1,
  followCursor: !1,
  inlinePositioning: !1,
  sticky: !1
}, lje = {
  allowHTML: !1,
  animation: "fade",
  arrow: !0,
  content: "",
  inertia: !1,
  maxWidth: 350,
  role: "tooltip",
  theme: "",
  zIndex: 9999
}, mi = Object.assign({
  appendTo: Ile,
  aria: {
    content: "auto",
    expanded: "auto"
  },
  delay: 0,
  duration: [300, 250],
  getReferenceClientRect: null,
  hideOnClick: !0,
  ignoreAttributes: !1,
  interactive: !1,
  interactiveBorder: 2,
  interactiveDebounce: 0,
  moveTransition: "",
  offset: [0, 10],
  onAfterUpdate: function() {
  },
  onBeforeUpdate: function() {
  },
  onCreate: function() {
  },
  onDestroy: function() {
  },
  onHidden: function() {
  },
  onHide: function() {
  },
  onMount: function() {
  },
  onShow: function() {
  },
  onShown: function() {
  },
  onTrigger: function() {
  },
  onUntrigger: function() {
  },
  onClickOutside: function() {
  },
  placement: "top",
  plugins: [],
  popperOptions: {},
  render: null,
  showOnCreate: !1,
  touch: !0,
  trigger: "mouseenter focus",
  triggerTarget: null
}, zle, lje), cje = Object.keys(mi), uje = function(t) {
  process.env.NODE_ENV !== "production" && Ule(t, []);
  var e = Object.keys(t);
  e.forEach(function(n) {
    mi[n] = t[n];
  });
};
function qle(t) {
  var e = t.plugins || [], n = e.reduce(function(r, o) {
    var i = o.name, s = o.defaultValue;
    if (i) {
      var a;
      r[i] = t[i] !== void 0 ? t[i] : (a = mi[i]) != null ? a : s;
    }
    return r;
  }, {});
  return Object.assign({}, t, n);
}
function dje(t, e) {
  var n = e ? Object.keys(qle(Object.assign({}, mi, {
    plugins: e
  }))) : cje, r = n.reduce(function(o, i) {
    var s = (t.getAttribute("data-tippy-" + i) || "").trim();
    if (!s)
      return o;
    if (i === "content")
      o[i] = s;
    else
      try {
        o[i] = JSON.parse(s);
      } catch {
        o[i] = s;
      }
    return o;
  }, {});
  return r;
}
function FF(t, e) {
  var n = Object.assign({}, e, {
    content: Nle(e.content, [t])
  }, e.ignoreAttributes ? {} : dje(t, e.plugins));
  return n.aria = Object.assign({}, mi.aria, n.aria), n.aria = {
    expanded: n.aria.expanded === "auto" ? e.interactive : n.aria.expanded,
    content: n.aria.content === "auto" ? e.interactive ? null : "describedby" : n.aria.content
  }, n;
}
function Ule(t, e) {
  t === void 0 && (t = {}), e === void 0 && (e = []);
  var n = Object.keys(t);
  n.forEach(function(r) {
    var o = WNe(mi, Object.keys(zle)), i = !VNe(o, r);
    i && (i = e.filter(function(s) {
      return s.name === r;
    }).length === 0), al(i, ["`" + r + "`", "is not a valid prop. You may have spelled it incorrectly, or if it's", "a plugin, forgot to pass it in an array as props.plugins.", `

`, `All props: https://atomiks.github.io/tippyjs/v6/all-props/
`, "Plugins: https://atomiks.github.io/tippyjs/v6/plugins/"].join(" "));
  });
}
var fje = function() {
  return "innerHTML";
};
function JD(t, e) {
  t[fje()] = e;
}
function BF(t) {
  var e = Wg();
  return t === !0 ? e.className = Mle : (e.className = Dle, N0(t) ? e.appendChild(t) : JD(e, t)), e;
}
function zF(t, e) {
  N0(e.content) ? (JD(t, ""), t.appendChild(e.content)) : typeof e.content != "function" && (e.allowHTML ? JD(t, e.content) : t.textContent = e.content);
}
function eI(t) {
  var e = t.firstElementChild, n = rx(e.children);
  return {
    box: e,
    content: n.find(function(r) {
      return r.classList.contains($le);
    }),
    arrow: n.find(function(r) {
      return r.classList.contains(Mle) || r.classList.contains(Dle);
    }),
    backdrop: n.find(function(r) {
      return r.classList.contains(HNe);
    })
  };
}
function Hle(t) {
  var e = Wg(), n = Wg();
  n.className = UNe, n.setAttribute("data-state", "hidden"), n.setAttribute("tabindex", "-1");
  var r = Wg();
  r.className = $le, r.setAttribute("data-state", "hidden"), zF(r, t.props), e.appendChild(n), n.appendChild(r), o(t.props, t.props);
  function o(i, s) {
    var a = eI(e), l = a.box, c = a.content, u = a.arrow;
    s.theme ? l.setAttribute("data-theme", s.theme) : l.removeAttribute("data-theme"), typeof s.animation == "string" ? l.setAttribute("data-animation", s.animation) : l.removeAttribute("data-animation"), s.inertia ? l.setAttribute("data-inertia", "") : l.removeAttribute("data-inertia"), l.style.maxWidth = typeof s.maxWidth == "number" ? s.maxWidth + "px" : s.maxWidth, s.role ? l.setAttribute("role", s.role) : l.removeAttribute("role"), (i.content !== s.content || i.allowHTML !== s.allowHTML) && zF(c, t.props), s.arrow ? u ? i.arrow !== s.arrow && (l.removeChild(u), l.appendChild(BF(s.arrow))) : l.appendChild(BF(s.arrow)) : u && l.removeChild(u);
  }
  return {
    popper: e,
    onUpdate: o
  };
}
Hle.$$tippy = !0;
var hje = 1, fb = [], RC = [];
function pje(t, e) {
  var n = FF(t, Object.assign({}, mi, qle(DF(e)))), r, o, i, s = !1, a = !1, l = !1, c = !1, u, d, f, h = [], p = $F(K, n.interactiveDebounce), m, g = hje++, y = null, v = YNe(n.plugins), b = {
    // Is the instance currently enabled?
    isEnabled: !0,
    // Is the tippy currently showing and not transitioning out?
    isVisible: !1,
    // Has the instance been destroyed?
    isDestroyed: !1,
    // Is the tippy currently mounted to the DOM?
    isMounted: !1,
    // Has the tippy finished transitioning in?
    isShown: !1
  }, _ = {
    // properties
    id: g,
    reference: t,
    popper: Wg(),
    popperInstance: y,
    props: n,
    state: b,
    plugins: v,
    // methods
    clearDelayTimeouts: nt,
    setProps: ct,
    setContent: mt,
    show: gt,
    hide: Et,
    hideWithInteractivity: Rt,
    enable: Je,
    disable: Ie,
    unmount: zt,
    destroy: At
  };
  if (!n.render)
    return process.env.NODE_ENV !== "production" && ZD(!0, "render() function has not been supplied."), _;
  var w = n.render(_), x = w.popper, E = w.onUpdate;
  x.setAttribute("data-tippy-root", ""), x.id = "tippy-" + _.id, _.popper = x, t._tippy = _, x._tippy = _;
  var S = v.map(function(X) {
    return X.fn(_);
  }), C = t.hasAttribute("aria-expanded");
  return Y(), $(), I(), j("onCreate", [_]), n.showOnCreate && Le(), x.addEventListener("mouseenter", function() {
    _.props.interactive && _.state.isVisible && _.clearDelayTimeouts();
  }), x.addEventListener("mouseleave", function() {
    _.props.interactive && _.props.trigger.indexOf("mouseenter") >= 0 && O().addEventListener("mousemove", p);
  }), _;
  function R() {
    var X = _.props.touch;
    return Array.isArray(X) ? X : [X, 0];
  }
  function P() {
    return R()[0] === "hold";
  }
  function N() {
    var X;
    return !!((X = _.props.render) != null && X.$$tippy);
  }
  function A() {
    return m || t;
  }
  function O() {
    var X = A().parentNode;
    return X ? Lle(X) : document;
  }
  function k() {
    return eI(x);
  }
  function T(X) {
    return _.state.isMounted && !_.state.isVisible || ra.isTouch || u && u.type === "focus" ? 0 : kC(_.props.delay, X ? 0 : 1, mi.delay);
  }
  function I(X) {
    X === void 0 && (X = !1), x.style.pointerEvents = _.props.interactive && !X ? "" : "none", x.style.zIndex = "" + _.props.zIndex;
  }
  function j(X, ae, ye) {
    if (ye === void 0 && (ye = !0), S.forEach(function(Te) {
      Te[X] && Te[X].apply(Te, ae);
    }), ye) {
      var De;
      (De = _.props)[X].apply(De, ae);
    }
  }
  function z() {
    var X = _.props.aria;
    if (X.content) {
      var ae = "aria-" + X.content, ye = x.id, De = Pf(_.props.triggerTarget || t);
      De.forEach(function(Te) {
        var st = Te.getAttribute(ae);
        if (_.state.isVisible)
          Te.setAttribute(ae, st ? st + " " + ye : ye);
        else {
          var ft = st && st.replace(ye, "").trim();
          ft ? Te.setAttribute(ae, ft) : Te.removeAttribute(ae);
        }
      });
    }
  }
  function $() {
    if (!(C || !_.props.aria.expanded)) {
      var X = Pf(_.props.triggerTarget || t);
      X.forEach(function(ae) {
        _.props.interactive ? ae.setAttribute("aria-expanded", _.state.isVisible && ae === A() ? "true" : "false") : ae.removeAttribute("aria-expanded");
      });
    }
  }
  function D() {
    O().removeEventListener("mousemove", p), fb = fb.filter(function(X) {
      return X !== p;
    });
  }
  function U(X) {
    if (!(ra.isTouch && (l || X.type === "mousedown"))) {
      var ae = X.composedPath && X.composedPath()[0] || X.target;
      if (!(_.props.interactive && NF(x, ae))) {
        if (Pf(_.props.triggerTarget || t).some(function(ye) {
          return NF(ye, ae);
        })) {
          if (ra.isTouch || _.state.isVisible && _.props.trigger.indexOf("click") >= 0)
            return;
        } else
          j("onClickOutside", [_, X]);
        _.props.hideOnClick === !0 && (_.clearDelayTimeouts(), _.hide(), a = !0, setTimeout(function() {
          a = !1;
        }), _.state.isMounted || H());
      }
    }
  }
  function q() {
    l = !0;
  }
  function F() {
    l = !1;
  }
  function B() {
    var X = O();
    X.addEventListener("mousedown", U, !0), X.addEventListener("touchend", U, Iu), X.addEventListener("touchstart", F, Iu), X.addEventListener("touchmove", q, Iu);
  }
  function H() {
    var X = O();
    X.removeEventListener("mousedown", U, !0), X.removeEventListener("touchend", U, Iu), X.removeEventListener("touchstart", F, Iu), X.removeEventListener("touchmove", q, Iu);
  }
  function Z(X, ae) {
    G(X, function() {
      !_.state.isVisible && x.parentNode && x.parentNode.contains(x) && ae();
    });
  }
  function W(X, ae) {
    G(X, ae);
  }
  function G(X, ae) {
    var ye = k().box;
    function De(Te) {
      Te.target === ye && (TC(ye, "remove", De), ae());
    }
    if (X === 0)
      return ae();
    TC(ye, "remove", d), TC(ye, "add", De), d = De;
  }
  function ee(X, ae, ye) {
    ye === void 0 && (ye = !1);
    var De = Pf(_.props.triggerTarget || t);
    De.forEach(function(Te) {
      Te.addEventListener(X, ae, ye), h.push({
        node: Te,
        eventType: X,
        handler: ae,
        options: ye
      });
    });
  }
  function Y() {
    P() && (ee("touchstart", V, {
      passive: !0
    }), ee("touchend", ne, {
      passive: !0
    })), GNe(_.props.trigger).forEach(function(X) {
      if (X !== "manual")
        switch (ee(X, V), X) {
          case "mouseenter":
            ee("mouseleave", ne);
            break;
          case "focus":
            ee(oje ? "focusout" : "blur", ce);
            break;
          case "focusin":
            ee("focusout", ce);
            break;
        }
    });
  }
  function L() {
    h.forEach(function(X) {
      var ae = X.node, ye = X.eventType, De = X.handler, Te = X.options;
      ae.removeEventListener(ye, De, Te);
    }), h = [];
  }
  function V(X) {
    var ae, ye = !1;
    if (!(!_.state.isEnabled || fe(X) || a)) {
      var De = ((ae = u) == null ? void 0 : ae.type) === "focus";
      u = X, m = X.currentTarget, $(), !_.state.isVisible && jle(X) && fb.forEach(function(Te) {
        return Te(X);
      }), X.type === "click" && (_.props.trigger.indexOf("mouseenter") < 0 || s) && _.props.hideOnClick !== !1 && _.state.isVisible ? ye = !0 : Le(X), X.type === "click" && (s = !ye), ye && !De && Ce(X);
    }
  }
  function K(X) {
    var ae = X.target, ye = A().contains(ae) || x.contains(ae);
    if (!(X.type === "mousemove" && ye)) {
      var De = Me().concat(x).map(function(Te) {
        var st, ft = Te._tippy, Ht = (st = ft.popperInstance) == null ? void 0 : st.state;
        return Ht ? {
          popperRect: Te.getBoundingClientRect(),
          popperState: Ht,
          props: n
        } : null;
      }).filter(Boolean);
      JNe(De, X) && (D(), Ce(X));
    }
  }
  function ne(X) {
    var ae = fe(X) || _.props.trigger.indexOf("click") >= 0 && s;
    if (!ae) {
      if (_.props.interactive) {
        _.hideWithInteractivity(X);
        return;
      }
      Ce(X);
    }
  }
  function ce(X) {
    _.props.trigger.indexOf("focusin") < 0 && X.target !== A() || _.props.interactive && X.relatedTarget && x.contains(X.relatedTarget) || Ce(X);
  }
  function fe(X) {
    return ra.isTouch ? P() !== X.type.indexOf("touch") >= 0 : !1;
  }
  function ve() {
    _e();
    var X = _.props, ae = X.popperOptions, ye = X.placement, De = X.offset, Te = X.getReferenceClientRect, st = X.moveTransition, ft = N() ? eI(x).arrow : null, Ht = Te ? {
      getBoundingClientRect: Te,
      contextElement: Te.contextElement || A()
    } : t, nn = {
      name: "$$tippy",
      enabled: !0,
      phase: "beforeWrite",
      requires: ["computeStyles"],
      fn: function(Rn) {
        var yt = Rn.state;
        if (N()) {
          var oe = k(), ge = oe.box;
          ["placement", "reference-hidden", "escaped"].forEach(function(pe) {
            pe === "placement" ? ge.setAttribute("data-placement", yt.placement) : yt.attributes.popper["data-popper-" + pe] ? ge.setAttribute("data-" + pe, "") : ge.removeAttribute("data-" + pe);
          }), yt.attributes.popper = {};
        }
      }
    }, It = [{
      name: "offset",
      options: {
        offset: De
      }
    }, {
      name: "preventOverflow",
      options: {
        padding: {
          top: 2,
          bottom: 2,
          left: 5,
          right: 5
        }
      }
    }, {
      name: "flip",
      options: {
        padding: 5
      }
    }, {
      name: "computeStyles",
      options: {
        adaptive: !st
      }
    }, nn];
    N() && ft && It.push({
      name: "arrow",
      options: {
        element: ft,
        padding: 3
      }
    }), It.push.apply(It, ae?.modifiers || []), _.popperInstance = Ple(Ht, x, Object.assign({}, ae, {
      placement: ye,
      onFirstUpdate: f,
      modifiers: It
    }));
  }
  function _e() {
    _.popperInstance && (_.popperInstance.destroy(), _.popperInstance = null);
  }
  function Ee() {
    var X = _.props.appendTo, ae, ye = A();
    _.props.interactive && X === Ile || X === "parent" ? ae = ye.parentNode : ae = Nle(X, [ye]), ae.contains(x) || ae.appendChild(x), _.state.isMounted = !0, ve(), process.env.NODE_ENV !== "production" && al(_.props.interactive && X === mi.appendTo && ye.nextElementSibling !== x, ["Interactive tippy element may not be accessible via keyboard", "navigation because it is not directly after the reference element", "in the DOM source order.", `

`, "Using a wrapper <div> or <span> tag around the reference element", "solves this by creating a new parentNode context.", `

`, "Specifying `appendTo: document.body` silences this warning, but it", "assumes you are using a focus management solution to handle", "keyboard navigation.", `

`, "See: https://atomiks.github.io/tippyjs/v6/accessibility/#interactivity"].join(" "));
  }
  function Me() {
    return rx(x.querySelectorAll("[data-tippy-root]"));
  }
  function Le(X) {
    _.clearDelayTimeouts(), X && j("onTrigger", [_, X]), B();
    var ae = T(!0), ye = R(), De = ye[0], Te = ye[1];
    ra.isTouch && De === "hold" && Te && (ae = Te), ae ? r = setTimeout(function() {
      _.show();
    }, ae) : _.show();
  }
  function Ce(X) {
    if (_.clearDelayTimeouts(), j("onUntrigger", [_, X]), !_.state.isVisible) {
      H();
      return;
    }
    if (!(_.props.trigger.indexOf("mouseenter") >= 0 && _.props.trigger.indexOf("click") >= 0 && ["mouseleave", "mousemove"].indexOf(X.type) >= 0 && s)) {
      var ae = T(!1);
      ae ? o = setTimeout(function() {
        _.state.isVisible && _.hide();
      }, ae) : i = requestAnimationFrame(function() {
        _.hide();
      });
    }
  }
  function Je() {
    _.state.isEnabled = !0;
  }
  function Ie() {
    _.hide(), _.state.isEnabled = !1;
  }
  function nt() {
    clearTimeout(r), clearTimeout(o), cancelAnimationFrame(i);
  }
  function ct(X) {
    if (process.env.NODE_ENV !== "production" && al(_.state.isDestroyed, yf("setProps")), !_.state.isDestroyed) {
      j("onBeforeUpdate", [_, X]), L();
      var ae = _.props, ye = FF(t, Object.assign({}, ae, DF(X), {
        ignoreAttributes: !0
      }));
      _.props = ye, Y(), ae.interactiveDebounce !== ye.interactiveDebounce && (D(), p = $F(K, ye.interactiveDebounce)), ae.triggerTarget && !ye.triggerTarget ? Pf(ae.triggerTarget).forEach(function(De) {
        De.removeAttribute("aria-expanded");
      }) : ye.triggerTarget && t.removeAttribute("aria-expanded"), $(), I(), E && E(ae, ye), _.popperInstance && (ve(), Me().forEach(function(De) {
        requestAnimationFrame(De._tippy.popperInstance.forceUpdate);
      })), j("onAfterUpdate", [_, X]);
    }
  }
  function mt(X) {
    _.setProps({
      content: X
    });
  }
  function gt() {
    process.env.NODE_ENV !== "production" && al(_.state.isDestroyed, yf("show"));
    var X = _.state.isVisible, ae = _.state.isDestroyed, ye = !_.state.isEnabled, De = ra.isTouch && !_.props.touch, Te = kC(_.props.duration, 0, mi.duration);
    if (!(X || ae || ye || De) && !A().hasAttribute("disabled") && (j("onShow", [_], !1), _.props.onShow(_) !== !1)) {
      if (_.state.isVisible = !0, N() && (x.style.visibility = "visible"), I(), B(), _.state.isMounted || (x.style.transition = "none"), N()) {
        var st = k(), ft = st.box, Ht = st.content;
        AC([ft, Ht], 0);
      }
      f = function() {
        var nn;
        if (!(!_.state.isVisible || c)) {
          if (c = !0, x.offsetHeight, x.style.transition = _.props.moveTransition, N() && _.props.animation) {
            var It = k(), Rn = It.box, yt = It.content;
            AC([Rn, yt], Te), IF([Rn, yt], "visible");
          }
          z(), $(), MF(RC, _), (nn = _.popperInstance) == null || nn.forceUpdate(), j("onMount", [_]), _.props.animation && N() && W(Te, function() {
            _.state.isShown = !0, j("onShown", [_]);
          });
        }
      }, Ee();
    }
  }
  function Et() {
    process.env.NODE_ENV !== "production" && al(_.state.isDestroyed, yf("hide"));
    var X = !_.state.isVisible, ae = _.state.isDestroyed, ye = !_.state.isEnabled, De = kC(_.props.duration, 1, mi.duration);
    if (!(X || ae || ye) && (j("onHide", [_], !1), _.props.onHide(_) !== !1)) {
      if (_.state.isVisible = !1, _.state.isShown = !1, c = !1, s = !1, N() && (x.style.visibility = "hidden"), D(), H(), I(!0), N()) {
        var Te = k(), st = Te.box, ft = Te.content;
        _.props.animation && (AC([st, ft], De), IF([st, ft], "hidden"));
      }
      z(), $(), _.props.animation ? N() && Z(De, _.unmount) : _.unmount();
    }
  }
  function Rt(X) {
    process.env.NODE_ENV !== "production" && al(_.state.isDestroyed, yf("hideWithInteractivity")), O().addEventListener("mousemove", p), MF(fb, p), p(X);
  }
  function zt() {
    process.env.NODE_ENV !== "production" && al(_.state.isDestroyed, yf("unmount")), _.state.isVisible && _.hide(), _.state.isMounted && (_e(), Me().forEach(function(X) {
      X._tippy.unmount();
    }), x.parentNode && x.parentNode.removeChild(x), RC = RC.filter(function(X) {
      return X !== _;
    }), _.state.isMounted = !1, j("onHidden", [_]));
  }
  function At() {
    process.env.NODE_ENV !== "production" && al(_.state.isDestroyed, yf("destroy")), !_.state.isDestroyed && (_.clearDelayTimeouts(), _.unmount(), L(), delete t._tippy, _.state.isDestroyed = !0, j("onDestroy", [_]));
  }
}
function av(t, e) {
  e === void 0 && (e = {});
  var n = mi.plugins.concat(e.plugins || []);
  process.env.NODE_ENV !== "production" && (aje(t), Ule(e, n)), nje();
  var r = Object.assign({}, e, {
    plugins: n
  }), o = ZNe(t);
  if (process.env.NODE_ENV !== "production") {
    var i = N0(r.content), s = o.length > 1;
    al(i && s, ["tippy() was passed an Element as the `content` prop, but more than", "one tippy instance was created by this invocation. This means the", "content element will only be appended to the last tippy instance.", `

`, "Instead, pass the .innerHTML of the element, or use a function that", "returns a cloned version of the element instead.", `

`, `1) content: element.innerHTML
`, "2) content: () => element.cloneNode(true)"].join(" "));
  }
  var a = o.reduce(function(l, c) {
    var u = c && pje(c, r);
    return u && l.push(u), l;
  }, []);
  return N0(t) ? a[0] : a;
}
av.defaultProps = mi;
av.setDefaultProps = uje;
av.currentInput = ra;
Object.assign({}, x5, {
  effect: function(t) {
    var e = t.state, n = {
      popper: {
        position: e.options.strategy,
        left: "0",
        top: "0",
        margin: "0"
      },
      arrow: {
        position: "absolute"
      },
      reference: {}
    };
    Object.assign(e.elements.popper.style, n.popper), e.styles = n, e.elements.arrow && Object.assign(e.elements.arrow.style, n.arrow);
  }
});
var tI = {
  clientX: 0,
  clientY: 0
}, hb = [];
function Vle(t) {
  var e = t.clientX, n = t.clientY;
  tI = {
    clientX: e,
    clientY: n
  };
}
function mje(t) {
  t.addEventListener("mousemove", Vle);
}
function gje(t) {
  t.removeEventListener("mousemove", Vle);
}
var yje = {
  name: "followCursor",
  defaultValue: !1,
  fn: function(t) {
    var e = t.reference, n = Lle(t.props.triggerTarget || e), r = !1, o = !1, i = !0, s = t.props;
    function a() {
      return t.props.followCursor === "initial" && t.state.isVisible;
    }
    function l() {
      n.addEventListener("mousemove", d);
    }
    function c() {
      n.removeEventListener("mousemove", d);
    }
    function u() {
      r = !0, t.setProps({
        getReferenceClientRect: null
      }), r = !1;
    }
    function d(p) {
      var m = p.target ? e.contains(p.target) : !0, g = t.props.followCursor, y = p.clientX, v = p.clientY, b = e.getBoundingClientRect(), _ = y - b.left, w = v - b.top;
      (m || !t.props.interactive) && t.setProps({
        // @ts-ignore - unneeded DOMRect properties
        getReferenceClientRect: function() {
          var x = e.getBoundingClientRect(), E = y, S = v;
          g === "initial" && (E = x.left + _, S = x.top + w);
          var C = g === "horizontal" ? x.top : S, R = g === "vertical" ? x.right : E, P = g === "horizontal" ? x.bottom : S, N = g === "vertical" ? x.left : E;
          return {
            width: R - N,
            height: P - C,
            top: C,
            right: R,
            bottom: P,
            left: N
          };
        }
      });
    }
    function f() {
      t.props.followCursor && (hb.push({
        instance: t,
        doc: n
      }), mje(n));
    }
    function h() {
      hb = hb.filter(function(p) {
        return p.instance !== t;
      }), hb.filter(function(p) {
        return p.doc === n;
      }).length === 0 && gje(n);
    }
    return {
      onCreate: f,
      onDestroy: h,
      onBeforeUpdate: function() {
        s = t.props;
      },
      onAfterUpdate: function(p, m) {
        var g = m.followCursor;
        r || g !== void 0 && s.followCursor !== g && (h(), g ? (f(), t.state.isMounted && !o && !a() && l()) : (c(), u()));
      },
      onMount: function() {
        t.props.followCursor && !o && (i && (d(tI), i = !1), a() || l());
      },
      onTrigger: function(p, m) {
        jle(m) && (tI = {
          clientX: m.clientX,
          clientY: m.clientY
        }), o = m.type === "focus";
      },
      onHidden: function() {
        t.props.followCursor && (u(), c(), i = !0);
      }
    };
  }
};
av.setDefaultProps({
  render: Hle
});
function Wle(t, e) {
  if (t == null) return {};
  var n = {}, r = Object.keys(t), o, i;
  for (i = 0; i < r.length; i++)
    o = r[i], !(e.indexOf(o) >= 0) && (n[o] = t[o]);
  return n;
}
var Gle = typeof window < "u" && typeof document < "u";
function nI(t, e) {
  t && (typeof t == "function" && t(e), {}.hasOwnProperty.call(t, "current") && (t.current = e));
}
function qF() {
  return Gle && document.createElement("div");
}
function vje(t) {
  var e = {
    "data-placement": t.placement
  };
  return t.referenceHidden && (e["data-reference-hidden"] = ""), t.escaped && (e["data-escaped"] = ""), e;
}
function Yle(t, e) {
  if (t === e)
    return !0;
  if (typeof t == "object" && t != null && typeof e == "object" && e != null) {
    if (Object.keys(t).length !== Object.keys(e).length)
      return !1;
    for (var n in t)
      if (e.hasOwnProperty(n)) {
        if (!Yle(t[n], e[n]))
          return !1;
      } else
        return !1;
    return !0;
  } else
    return !1;
}
function bje(t) {
  var e = [];
  return t.forEach(function(n) {
    e.find(function(r) {
      return Yle(n, r);
    }) || e.push(n);
  }), e;
}
function _je(t, e) {
  var n, r;
  return Object.assign({}, e, {
    popperOptions: Object.assign({}, t.popperOptions, e.popperOptions, {
      modifiers: bje([].concat(((n = t.popperOptions) == null ? void 0 : n.modifiers) || [], ((r = e.popperOptions) == null ? void 0 : r.modifiers) || []))
    })
  });
}
var PC = Gle ? iu : Ne;
function wje(t) {
  var e = Ue();
  return e.current || (e.current = typeof t == "function" ? t() : t), e.current;
}
function UF(t, e, n) {
  n.split(/\s+/).forEach(function(r) {
    r && t.classList[e](r);
  });
}
var xje = {
  name: "className",
  defaultValue: "",
  fn: function(t) {
    var e = t.popper.firstElementChild, n = function() {
      var i;
      return !!((i = t.props.render) != null && i.$$tippy);
    };
    function r() {
      if (t.props.className && !n()) {
        process.env.NODE_ENV !== "production" && console.warn(["@tippyjs/react: Cannot use `className` prop in conjunction with", "`render` prop. Place the className on the element you are", "rendering."].join(" "));
        return;
      }
      UF(e, "add", t.props.className);
    }
    function o() {
      n() && UF(e, "remove", t.props.className);
    }
    return {
      onCreate: r,
      onBeforeUpdate: o,
      onAfterUpdate: r
    };
  }
};
function Eje(t) {
  function e(n) {
    var r = n.children, o = n.content, i = n.visible, s = n.singleton, a = n.render, l = n.reference, c = n.disabled, u = c === void 0 ? !1 : c, d = n.ignoreAttributes, f = d === void 0 ? !0 : d;
    n.__source, n.__self;
    var h = Wle(n, ["children", "content", "visible", "singleton", "render", "reference", "disabled", "ignoreAttributes", "__source", "__self"]), p = i !== void 0, m = s !== void 0, g = Ye(!1), y = g[0], v = g[1], b = Ye({}), _ = b[0], w = b[1], x = Ye(), E = x[0], S = x[1], C = wje(function() {
      return {
        container: qF(),
        renders: 1
      };
    }), R = Object.assign({
      ignoreAttributes: f
    }, h, {
      content: C.container
    });
    p && (process.env.NODE_ENV !== "production" && ["trigger", "hideOnClick", "showOnCreate"].forEach(function(O) {
      R[O] !== void 0 && console.warn(["@tippyjs/react: Cannot specify `" + O + "` prop in", "controlled mode (`visible` prop)"].join(" "));
    }), R.trigger = "manual", R.hideOnClick = !1), m && (u = !0);
    var P = R, N = R.plugins || [];
    a && (P = Object.assign({}, R, {
      plugins: m && s.data != null ? [].concat(N, [{
        fn: function() {
          return {
            onTrigger: function(O, k) {
              var T = s.data.children.find(function(I) {
                var j = I.instance;
                return j.reference === k.currentTarget;
              });
              O.state.$$activeSingletonInstance = T.instance, S(T.content);
            }
          };
        }
      }]) : N,
      render: function() {
        return {
          popper: C.container
        };
      }
    }));
    var A = [l].concat(r ? [r.type] : []);
    return PC(function() {
      var O = l;
      l && l.hasOwnProperty("current") && (O = l.current);
      var k = t(O || C.ref || qF(), Object.assign({}, P, {
        plugins: [xje].concat(R.plugins || [])
      }));
      return C.instance = k, u && k.disable(), i && k.show(), m && s.hook({
        instance: k,
        content: o,
        props: P,
        setSingletonContent: S
      }), v(!0), function() {
        k.destroy(), s?.cleanup(k);
      };
    }, A), PC(function() {
      var O;
      if (C.renders === 1) {
        C.renders++;
        return;
      }
      var k = C.instance;
      k.setProps(_je(k.props, P)), (O = k.popperInstance) == null || O.forceUpdate(), u ? k.disable() : k.enable(), p && (i ? k.show() : k.hide()), m && s.hook({
        instance: k,
        content: o,
        props: P,
        setSingletonContent: S
      });
    }), PC(function() {
      var O;
      if (a) {
        var k = C.instance;
        k.setProps({
          popperOptions: Object.assign({}, k.props.popperOptions, {
            modifiers: [].concat((((O = k.props.popperOptions) == null ? void 0 : O.modifiers) || []).filter(function(T) {
              var I = T.name;
              return I !== "$$tippyReact";
            }), [{
              name: "$$tippyReact",
              enabled: !0,
              phase: "beforeWrite",
              requires: ["computeStyles"],
              fn: function(T) {
                var I, j = T.state, z = (I = j.modifiersData) == null ? void 0 : I.hide;
                (_.placement !== j.placement || _.referenceHidden !== z?.isReferenceHidden || _.escaped !== z?.hasPopperEscaped) && w({
                  placement: j.placement,
                  referenceHidden: z?.isReferenceHidden,
                  escaped: z?.hasPopperEscaped
                }), j.attributes.popper = {};
              }
            }])
          })
        });
      }
    }, [_.placement, _.referenceHidden, _.escaped].concat(A)), /* @__PURE__ */ xe.createElement(xe.Fragment, null, r ? /* @__PURE__ */ Gi(r, {
      ref: function(O) {
        C.ref = O, nI(r.ref, O);
      }
    }) : null, y && /* @__PURE__ */ XE(a ? a(vje(_), E, C.instance) : o, C.container));
  }
  return e;
}
var Sje = function(t, e) {
  return /* @__PURE__ */ Ri(function(n, r) {
    var o = n.children, i = Wle(n, ["children"]);
    return (
      // If I spread them separately here, Babel adds the _extends ponyfill for
      // some reason
      /* @__PURE__ */ xe.createElement(t, Object.assign({}, e, i), o ? /* @__PURE__ */ Gi(o, {
        ref: function(s) {
          nI(r, s), nI(o.ref, s);
        }
      }) : null)
    );
  });
}, hS = /* @__PURE__ */ Sje(/* @__PURE__ */ Eje(av));
class Oje {
  /**
   * @callback HookCallback
   * @this {*|Jsep} this
   * @param {Jsep} env
   * @returns: void
   */
  /**
   * Adds the given callback to the list of callbacks for the given hook.
   *
   * The callback will be invoked when the hook it is registered for is run.
   *
   * One callback function can be registered to multiple hooks and the same hook multiple times.
   *
   * @param {string|object} name The name of the hook, or an object of callbacks keyed by name
   * @param {HookCallback|boolean} callback The callback function which is given environment variables.
   * @param {?boolean} [first=false] Will add the hook to the top of the list (defaults to the bottom)
   * @public
   */
  add(e, n, r) {
    if (typeof arguments[0] != "string")
      for (let o in arguments[0])
        this.add(o, arguments[0][o], arguments[1]);
    else
      (Array.isArray(e) ? e : [e]).forEach(function(o) {
        this[o] = this[o] || [], n && this[o][r ? "unshift" : "push"](n);
      }, this);
  }
  /**
   * Runs a hook invoking all registered callbacks with the given environment variables.
   *
   * Callbacks will be invoked synchronously and in the order in which they were registered.
   *
   * @param {string} name The name of the hook.
   * @param {Object<string, any>} env The environment variables of the hook passed to all callbacks registered.
   * @public
   */
  run(e, n) {
    this[e] = this[e] || [], this[e].forEach(function(r) {
      r.call(n && n.context ? n.context : n, n);
    });
  }
}
class Cje {
  constructor(e) {
    this.jsep = e, this.registered = {};
  }
  /**
   * @callback PluginSetup
   * @this {Jsep} jsep
   * @returns: void
   */
  /**
   * Adds the given plugin(s) to the registry
   *
   * @param {object} plugins
   * @param {string} plugins.name The name of the plugin
   * @param {PluginSetup} plugins.init The init function
   * @public
   */
  register() {
    for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++)
      n[r] = arguments[r];
    n.forEach((o) => {
      if (typeof o != "object" || !o.name || !o.init)
        throw new Error("Invalid JSEP plugin format");
      this.registered[o.name] || (o.init(this.jsep), this.registered[o.name] = o);
    });
  }
}
let Vi = class ke {
  /**
   * @returns {string}
   */
  static get version() {
    return "1.4.0";
  }
  /**
   * @returns {string}
   */
  static toString() {
    return "JavaScript Expression Parser (JSEP) v" + ke.version;
  }
  // ==================== CONFIG ================================
  /**
   * @method addUnaryOp
   * @param {string} op_name The name of the unary op to add
   * @returns {Jsep}
   */
  static addUnaryOp(e) {
    return ke.max_unop_len = Math.max(e.length, ke.max_unop_len), ke.unary_ops[e] = 1, ke;
  }
  /**
   * @method jsep.addBinaryOp
   * @param {string} op_name The name of the binary op to add
   * @param {number} precedence The precedence of the binary op (can be a float). Higher number = higher precedence
   * @param {boolean} [isRightAssociative=false] whether operator is right-associative
   * @returns {Jsep}
   */
  static addBinaryOp(e, n, r) {
    return ke.max_binop_len = Math.max(e.length, ke.max_binop_len), ke.binary_ops[e] = n, r ? ke.right_associative.add(e) : ke.right_associative.delete(e), ke;
  }
  /**
   * @method addIdentifierChar
   * @param {string} char The additional character to treat as a valid part of an identifier
   * @returns {Jsep}
   */
  static addIdentifierChar(e) {
    return ke.additional_identifier_chars.add(e), ke;
  }
  /**
   * @method addLiteral
   * @param {string} literal_name The name of the literal to add
   * @param {*} literal_value The value of the literal
   * @returns {Jsep}
   */
  static addLiteral(e, n) {
    return ke.literals[e] = n, ke;
  }
  /**
   * @method removeUnaryOp
   * @param {string} op_name The name of the unary op to remove
   * @returns {Jsep}
   */
  static removeUnaryOp(e) {
    return delete ke.unary_ops[e], e.length === ke.max_unop_len && (ke.max_unop_len = ke.getMaxKeyLen(ke.unary_ops)), ke;
  }
  /**
   * @method removeAllUnaryOps
   * @returns {Jsep}
   */
  static removeAllUnaryOps() {
    return ke.unary_ops = {}, ke.max_unop_len = 0, ke;
  }
  /**
   * @method removeIdentifierChar
   * @param {string} char The additional character to stop treating as a valid part of an identifier
   * @returns {Jsep}
   */
  static removeIdentifierChar(e) {
    return ke.additional_identifier_chars.delete(e), ke;
  }
  /**
   * @method removeBinaryOp
   * @param {string} op_name The name of the binary op to remove
   * @returns {Jsep}
   */
  static removeBinaryOp(e) {
    return delete ke.binary_ops[e], e.length === ke.max_binop_len && (ke.max_binop_len = ke.getMaxKeyLen(ke.binary_ops)), ke.right_associative.delete(e), ke;
  }
  /**
   * @method removeAllBinaryOps
   * @returns {Jsep}
   */
  static removeAllBinaryOps() {
    return ke.binary_ops = {}, ke.max_binop_len = 0, ke;
  }
  /**
   * @method removeLiteral
   * @param {string} literal_name The name of the literal to remove
   * @returns {Jsep}
   */
  static removeLiteral(e) {
    return delete ke.literals[e], ke;
  }
  /**
   * @method removeAllLiterals
   * @returns {Jsep}
   */
  static removeAllLiterals() {
    return ke.literals = {}, ke;
  }
  // ==================== END CONFIG ============================
  /**
   * @returns {string}
   */
  get char() {
    return this.expr.charAt(this.index);
  }
  /**
   * @returns {number}
   */
  get code() {
    return this.expr.charCodeAt(this.index);
  }
  /**
   * @param {string} expr a string with the passed in express
   * @returns Jsep
   */
  constructor(e) {
    this.expr = e, this.index = 0;
  }
  /**
   * static top-level parser
   * @returns {jsep.Expression}
   */
  static parse(e) {
    return new ke(e).parse();
  }
  /**
   * Get the longest key length of any object
   * @param {object} obj
   * @returns {number}
   */
  static getMaxKeyLen(e) {
    return Math.max(0, ...Object.keys(e).map((n) => n.length));
  }
  /**
   * `ch` is a character code in the next three functions
   * @param {number} ch
   * @returns {boolean}
   */
  static isDecimalDigit(e) {
    return e >= 48 && e <= 57;
  }
  /**
   * Returns the precedence of a binary operator or `0` if it isn't a binary operator. Can be float.
   * @param {string} op_val
   * @returns {number}
   */
  static binaryPrecedence(e) {
    return ke.binary_ops[e] || 0;
  }
  /**
   * Looks for start of identifier
   * @param {number} ch
   * @returns {boolean}
   */
  static isIdentifierStart(e) {
    return e >= 65 && e <= 90 || // A...Z
    e >= 97 && e <= 122 || // a...z
    e >= 128 && !ke.binary_ops[String.fromCharCode(e)] || // any non-ASCII that is not an operator
    ke.additional_identifier_chars.has(String.fromCharCode(e));
  }
  /**
   * @param {number} ch
   * @returns {boolean}
   */
  static isIdentifierPart(e) {
    return ke.isIdentifierStart(e) || ke.isDecimalDigit(e);
  }
  /**
   * throw error at index of the expression
   * @param {string} message
   * @throws
   */
  throwError(e) {
    const n = new Error(e + " at character " + this.index);
    throw n.index = this.index, n.description = e, n;
  }
  /**
   * Run a given hook
   * @param {string} name
   * @param {jsep.Expression|false} [node]
   * @returns {?jsep.Expression}
   */
  runHook(e, n) {
    if (ke.hooks[e]) {
      const r = {
        context: this,
        node: n
      };
      return ke.hooks.run(e, r), r.node;
    }
    return n;
  }
  /**
   * Runs a given hook until one returns a node
   * @param {string} name
   * @returns {?jsep.Expression}
   */
  searchHook(e) {
    if (ke.hooks[e]) {
      const n = {
        context: this
      };
      return ke.hooks[e].find(function(r) {
        return r.call(n.context, n), n.node;
      }), n.node;
    }
  }
  /**
   * Push `index` up to the next non-space character
   */
  gobbleSpaces() {
    let e = this.code;
    for (; e === ke.SPACE_CODE || e === ke.TAB_CODE || e === ke.LF_CODE || e === ke.CR_CODE; )
      e = this.expr.charCodeAt(++this.index);
    this.runHook("gobble-spaces");
  }
  /**
   * Top-level method to parse all expressions and returns compound or single node
   * @returns {jsep.Expression}
   */
  parse() {
    this.runHook("before-all");
    const e = this.gobbleExpressions(), n = e.length === 1 ? e[0] : {
      type: ke.COMPOUND,
      body: e
    };
    return this.runHook("after-all", n);
  }
  /**
   * top-level parser (but can be reused within as well)
   * @param {number} [untilICode]
   * @returns {jsep.Expression[]}
   */
  gobbleExpressions(e) {
    let n = [], r, o;
    for (; this.index < this.expr.length; )
      if (r = this.code, r === ke.SEMCOL_CODE || r === ke.COMMA_CODE)
        this.index++;
      else if (o = this.gobbleExpression())
        n.push(o);
      else if (this.index < this.expr.length) {
        if (r === e)
          break;
        this.throwError('Unexpected "' + this.char + '"');
      }
    return n;
  }
  /**
   * The main parsing function.
   * @returns {?jsep.Expression}
   */
  gobbleExpression() {
    const e = this.searchHook("gobble-expression") || this.gobbleBinaryExpression();
    return this.gobbleSpaces(), this.runHook("after-expression", e);
  }
  /**
   * Search for the operation portion of the string (e.g. `+`, `===`)
   * Start by taking the longest possible binary operations (3 characters: `===`, `!==`, `>>>`)
   * and move down from 3 to 2 to 1 character until a matching binary operation is found
   * then, return that binary operation
   * @returns {string|boolean}
   */
  gobbleBinaryOp() {
    this.gobbleSpaces();
    let e = this.expr.substr(this.index, ke.max_binop_len), n = e.length;
    for (; n > 0; ) {
      if (ke.binary_ops.hasOwnProperty(e) && (!ke.isIdentifierStart(this.code) || this.index + e.length < this.expr.length && !ke.isIdentifierPart(this.expr.charCodeAt(this.index + e.length))))
        return this.index += n, e;
      e = e.substr(0, --n);
    }
    return !1;
  }
  /**
   * This function is responsible for gobbling an individual expression,
   * e.g. `1`, `1+2`, `a+(b*2)-Math.sqrt(2)`
   * @returns {?jsep.BinaryExpression}
   */
  gobbleBinaryExpression() {
    let e, n, r, o, i, s, a, l, c;
    if (s = this.gobbleToken(), !s || (n = this.gobbleBinaryOp(), !n))
      return s;
    for (i = {
      value: n,
      prec: ke.binaryPrecedence(n),
      right_a: ke.right_associative.has(n)
    }, a = this.gobbleToken(), a || this.throwError("Expected expression after " + n), o = [s, i, a]; n = this.gobbleBinaryOp(); ) {
      if (r = ke.binaryPrecedence(n), r === 0) {
        this.index -= n.length;
        break;
      }
      i = {
        value: n,
        prec: r,
        right_a: ke.right_associative.has(n)
      }, c = n;
      const u = (d) => i.right_a && d.right_a ? r > d.prec : r <= d.prec;
      for (; o.length > 2 && u(o[o.length - 2]); )
        a = o.pop(), n = o.pop().value, s = o.pop(), e = {
          type: ke.BINARY_EXP,
          operator: n,
          left: s,
          right: a
        }, o.push(e);
      e = this.gobbleToken(), e || this.throwError("Expected expression after " + c), o.push(i, e);
    }
    for (l = o.length - 1, e = o[l]; l > 1; )
      e = {
        type: ke.BINARY_EXP,
        operator: o[l - 1].value,
        left: o[l - 2],
        right: e
      }, l -= 2;
    return e;
  }
  /**
   * An individual part of a binary expression:
   * e.g. `foo.bar(baz)`, `1`, `"abc"`, `(a % 2)` (because it's in parenthesis)
   * @returns {boolean|jsep.Expression}
   */
  gobbleToken() {
    let e, n, r, o;
    if (this.gobbleSpaces(), o = this.searchHook("gobble-token"), o)
      return this.runHook("after-token", o);
    if (e = this.code, ke.isDecimalDigit(e) || e === ke.PERIOD_CODE)
      return this.gobbleNumericLiteral();
    if (e === ke.SQUOTE_CODE || e === ke.DQUOTE_CODE)
      o = this.gobbleStringLiteral();
    else if (e === ke.OBRACK_CODE)
      o = this.gobbleArray();
    else {
      for (n = this.expr.substr(this.index, ke.max_unop_len), r = n.length; r > 0; ) {
        if (ke.unary_ops.hasOwnProperty(n) && (!ke.isIdentifierStart(this.code) || this.index + n.length < this.expr.length && !ke.isIdentifierPart(this.expr.charCodeAt(this.index + n.length)))) {
          this.index += r;
          const i = this.gobbleToken();
          return i || this.throwError("missing unaryOp argument"), this.runHook("after-token", {
            type: ke.UNARY_EXP,
            operator: n,
            argument: i,
            prefix: !0
          });
        }
        n = n.substr(0, --r);
      }
      ke.isIdentifierStart(e) ? (o = this.gobbleIdentifier(), ke.literals.hasOwnProperty(o.name) ? o = {
        type: ke.LITERAL,
        value: ke.literals[o.name],
        raw: o.name
      } : o.name === ke.this_str && (o = {
        type: ke.THIS_EXP
      })) : e === ke.OPAREN_CODE && (o = this.gobbleGroup());
    }
    return o ? (o = this.gobbleTokenProperty(o), this.runHook("after-token", o)) : this.runHook("after-token", !1);
  }
  /**
   * Gobble properties of of identifiers/strings/arrays/groups.
   * e.g. `foo`, `bar.baz`, `foo['bar'].baz`
   * It also gobbles function calls:
   * e.g. `Math.acos(obj.angle)`
   * @param {jsep.Expression} node
   * @returns {jsep.Expression}
   */
  gobbleTokenProperty(e) {
    this.gobbleSpaces();
    let n = this.code;
    for (; n === ke.PERIOD_CODE || n === ke.OBRACK_CODE || n === ke.OPAREN_CODE || n === ke.QUMARK_CODE; ) {
      let r;
      if (n === ke.QUMARK_CODE) {
        if (this.expr.charCodeAt(this.index + 1) !== ke.PERIOD_CODE)
          break;
        r = !0, this.index += 2, this.gobbleSpaces(), n = this.code;
      }
      this.index++, n === ke.OBRACK_CODE ? (e = {
        type: ke.MEMBER_EXP,
        computed: !0,
        object: e,
        property: this.gobbleExpression()
      }, e.property || this.throwError('Unexpected "' + this.char + '"'), this.gobbleSpaces(), n = this.code, n !== ke.CBRACK_CODE && this.throwError("Unclosed ["), this.index++) : n === ke.OPAREN_CODE ? e = {
        type: ke.CALL_EXP,
        arguments: this.gobbleArguments(ke.CPAREN_CODE),
        callee: e
      } : (n === ke.PERIOD_CODE || r) && (r && this.index--, this.gobbleSpaces(), e = {
        type: ke.MEMBER_EXP,
        computed: !1,
        object: e,
        property: this.gobbleIdentifier()
      }), r && (e.optional = !0), this.gobbleSpaces(), n = this.code;
    }
    return e;
  }
  /**
   * Parse simple numeric literals: `12`, `3.4`, `.5`. Do this by using a string to
   * keep track of everything in the numeric literal and then calling `parseFloat` on that string
   * @returns {jsep.Literal}
   */
  gobbleNumericLiteral() {
    let e = "", n, r;
    for (; ke.isDecimalDigit(this.code); )
      e += this.expr.charAt(this.index++);
    if (this.code === ke.PERIOD_CODE)
      for (e += this.expr.charAt(this.index++); ke.isDecimalDigit(this.code); )
        e += this.expr.charAt(this.index++);
    if (n = this.char, n === "e" || n === "E") {
      for (e += this.expr.charAt(this.index++), n = this.char, (n === "+" || n === "-") && (e += this.expr.charAt(this.index++)); ke.isDecimalDigit(this.code); )
        e += this.expr.charAt(this.index++);
      ke.isDecimalDigit(this.expr.charCodeAt(this.index - 1)) || this.throwError("Expected exponent (" + e + this.char + ")");
    }
    return r = this.code, ke.isIdentifierStart(r) ? this.throwError("Variable names cannot start with a number (" + e + this.char + ")") : (r === ke.PERIOD_CODE || e.length === 1 && e.charCodeAt(0) === ke.PERIOD_CODE) && this.throwError("Unexpected period"), {
      type: ke.LITERAL,
      value: parseFloat(e),
      raw: e
    };
  }
  /**
   * Parses a string literal, staring with single or double quotes with basic support for escape codes
   * e.g. `"hello world"`, `'this is\nJSEP'`
   * @returns {jsep.Literal}
   */
  gobbleStringLiteral() {
    let e = "";
    const n = this.index, r = this.expr.charAt(this.index++);
    let o = !1;
    for (; this.index < this.expr.length; ) {
      let i = this.expr.charAt(this.index++);
      if (i === r) {
        o = !0;
        break;
      } else if (i === "\\")
        switch (i = this.expr.charAt(this.index++), i) {
          case "n":
            e += `
`;
            break;
          case "r":
            e += "\r";
            break;
          case "t":
            e += "	";
            break;
          case "b":
            e += "\b";
            break;
          case "f":
            e += "\f";
            break;
          case "v":
            e += "\v";
            break;
          default:
            e += i;
        }
      else
        e += i;
    }
    return o || this.throwError('Unclosed quote after "' + e + '"'), {
      type: ke.LITERAL,
      value: e,
      raw: this.expr.substring(n, this.index)
    };
  }
  /**
   * Gobbles only identifiers
   * e.g.: `foo`, `_value`, `$x1`
   * Also, this function checks if that identifier is a literal:
   * (e.g. `true`, `false`, `null`) or `this`
   * @returns {jsep.Identifier}
   */
  gobbleIdentifier() {
    let e = this.code, n = this.index;
    for (ke.isIdentifierStart(e) ? this.index++ : this.throwError("Unexpected " + this.char); this.index < this.expr.length && (e = this.code, ke.isIdentifierPart(e)); )
      this.index++;
    return {
      type: ke.IDENTIFIER,
      name: this.expr.slice(n, this.index)
    };
  }
  /**
   * Gobbles a list of arguments within the context of a function call
   * or array literal. This function also assumes that the opening character
   * `(` or `[` has already been gobbled, and gobbles expressions and commas
   * until the terminator character `)` or `]` is encountered.
   * e.g. `foo(bar, baz)`, `my_func()`, or `[bar, baz]`
   * @param {number} termination
   * @returns {jsep.Expression[]}
   */
  gobbleArguments(e) {
    const n = [];
    let r = !1, o = 0;
    for (; this.index < this.expr.length; ) {
      this.gobbleSpaces();
      let i = this.code;
      if (i === e) {
        r = !0, this.index++, e === ke.CPAREN_CODE && o && o >= n.length && this.throwError("Unexpected token " + String.fromCharCode(e));
        break;
      } else if (i === ke.COMMA_CODE) {
        if (this.index++, o++, o !== n.length) {
          if (e === ke.CPAREN_CODE)
            this.throwError("Unexpected token ,");
          else if (e === ke.CBRACK_CODE)
            for (let s = n.length; s < o; s++)
              n.push(null);
        }
      } else if (n.length !== o && o !== 0)
        this.throwError("Expected comma");
      else {
        const s = this.gobbleExpression();
        (!s || s.type === ke.COMPOUND) && this.throwError("Expected comma"), n.push(s);
      }
    }
    return r || this.throwError("Expected " + String.fromCharCode(e)), n;
  }
  /**
   * Responsible for parsing a group of things within parentheses `()`
   * that have no identifier in front (so not a function call)
   * This function assumes that it needs to gobble the opening parenthesis
   * and then tries to gobble everything within that parenthesis, assuming
   * that the next thing it should see is the close parenthesis. If not,
   * then the expression probably doesn't have a `)`
   * @returns {boolean|jsep.Expression}
   */
  gobbleGroup() {
    this.index++;
    let e = this.gobbleExpressions(ke.CPAREN_CODE);
    if (this.code === ke.CPAREN_CODE)
      return this.index++, e.length === 1 ? e[0] : e.length ? {
        type: ke.SEQUENCE_EXP,
        expressions: e
      } : !1;
    this.throwError("Unclosed (");
  }
  /**
   * Responsible for parsing Array literals `[1, 2, 3]`
   * This function assumes that it needs to gobble the opening bracket
   * and then tries to gobble the expressions as arguments.
   * @returns {jsep.ArrayExpression}
   */
  gobbleArray() {
    return this.index++, {
      type: ke.ARRAY_EXP,
      elements: this.gobbleArguments(ke.CBRACK_CODE)
    };
  }
};
const kje = new Oje();
Object.assign(Vi, {
  hooks: kje,
  plugins: new Cje(Vi),
  // Node Types
  // ----------
  // This is the full set of types that any JSEP node can be.
  // Store them here to save space when minified
  COMPOUND: "Compound",
  SEQUENCE_EXP: "SequenceExpression",
  IDENTIFIER: "Identifier",
  MEMBER_EXP: "MemberExpression",
  LITERAL: "Literal",
  THIS_EXP: "ThisExpression",
  CALL_EXP: "CallExpression",
  UNARY_EXP: "UnaryExpression",
  BINARY_EXP: "BinaryExpression",
  ARRAY_EXP: "ArrayExpression",
  TAB_CODE: 9,
  LF_CODE: 10,
  CR_CODE: 13,
  SPACE_CODE: 32,
  PERIOD_CODE: 46,
  // '.'
  COMMA_CODE: 44,
  // ','
  SQUOTE_CODE: 39,
  // single quote
  DQUOTE_CODE: 34,
  // double quotes
  OPAREN_CODE: 40,
  // (
  CPAREN_CODE: 41,
  // )
  OBRACK_CODE: 91,
  // [
  CBRACK_CODE: 93,
  // ]
  QUMARK_CODE: 63,
  // ?
  SEMCOL_CODE: 59,
  // ;
  COLON_CODE: 58,
  // :
  // Operations
  // ----------
  // Use a quickly-accessible map to store all of the unary operators
  // Values are set to `1` (it really doesn't matter)
  unary_ops: {
    "-": 1,
    "!": 1,
    "~": 1,
    "+": 1
  },
  // Also use a map for the binary operations but set their values to their
  // binary precedence for quick reference (higher number = higher precedence)
  // see [Order of operations](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Operator_Precedence)
  binary_ops: {
    "||": 1,
    "??": 1,
    "&&": 2,
    "|": 3,
    "^": 4,
    "&": 5,
    "==": 6,
    "!=": 6,
    "===": 6,
    "!==": 6,
    "<": 7,
    ">": 7,
    "<=": 7,
    ">=": 7,
    "<<": 8,
    ">>": 8,
    ">>>": 8,
    "+": 9,
    "-": 9,
    "*": 10,
    "/": 10,
    "%": 10,
    "**": 11
  },
  // sets specific binary_ops as right-associative
  right_associative: /* @__PURE__ */ new Set(["**"]),
  // Additional valid identifier chars, apart from a-z, A-Z and 0-9 (except on the starting char)
  additional_identifier_chars: /* @__PURE__ */ new Set(["$", "_"]),
  // Literals
  // ----------
  // Store the values to return for the various literals we may encounter
  literals: {
    true: !0,
    false: !1,
    null: null
  },
  // Except for `this`, which is special. This could be changed to something like `'self'` as well
  this_str: "this"
});
Vi.max_unop_len = Vi.getMaxKeyLen(Vi.unary_ops);
Vi.max_binop_len = Vi.getMaxKeyLen(Vi.binary_ops);
const Xc = (t) => new Vi(t).parse(), Aje = Object.getOwnPropertyNames(class {
});
Object.getOwnPropertyNames(Vi).filter((t) => !Aje.includes(t) && Xc[t] === void 0).forEach((t) => {
  Xc[t] = Vi[t];
});
Xc.Jsep = Vi;
const Tje = "ConditionalExpression";
var Rje = {
  name: "ternary",
  init(t) {
    t.hooks.add("after-expression", function(e) {
      if (e.node && this.code === t.QUMARK_CODE) {
        this.index++;
        const n = e.node, r = this.gobbleExpression();
        if (r || this.throwError("Expected expression"), this.gobbleSpaces(), this.code === t.COLON_CODE) {
          this.index++;
          const o = this.gobbleExpression();
          if (o || this.throwError("Expected expression"), e.node = {
            type: Tje,
            test: n,
            consequent: r,
            alternate: o
          }, n.operator && t.binary_ops[n.operator] <= 0.9) {
            let i = n;
            for (; i.right.operator && t.binary_ops[i.right.operator] <= 0.9; )
              i = i.right;
            e.node.test = i.right, i.right = e.node, e.node = n;
          }
        } else
          this.throwError("Expected :");
      }
    });
  }
};
Xc.plugins.register(Rje);
const HF = 47, Pje = 92;
var $je = {
  name: "regex",
  init(t) {
    t.hooks.add("gobble-token", function(e) {
      if (this.code === HF) {
        const n = ++this.index;
        let r = !1;
        for (; this.index < this.expr.length; ) {
          if (this.code === HF && !r) {
            const o = this.expr.slice(n, this.index);
            let i = "";
            for (; ++this.index < this.expr.length; ) {
              const a = this.code;
              if (a >= 97 && a <= 122 || a >= 65 && a <= 90 || a >= 48 && a <= 57)
                i += this.char;
              else
                break;
            }
            let s;
            try {
              s = new RegExp(o, i);
            } catch (a) {
              this.throwError(a.message);
            }
            return e.node = {
              type: t.LITERAL,
              value: s,
              raw: this.expr.slice(n - 1, this.index)
            }, e.node = this.gobbleTokenProperty(e.node), e.node;
          }
          this.code === t.OBRACK_CODE ? r = !0 : r && this.code === t.CBRACK_CODE && (r = !1), this.index += this.code === Pje ? 2 : 1;
        }
        this.throwError("Unclosed Regex");
      }
    });
  }
};
const $C = 43, Mje = 45, $f = {
  name: "assignment",
  assignmentOperators: /* @__PURE__ */ new Set(["=", "*=", "**=", "/=", "%=", "+=", "-=", "<<=", ">>=", ">>>=", "&=", "^=", "|=", "||=", "&&=", "??="]),
  updateOperators: [$C, Mje],
  assignmentPrecedence: 0.9,
  init(t) {
    const e = [t.IDENTIFIER, t.MEMBER_EXP];
    $f.assignmentOperators.forEach((r) => t.addBinaryOp(r, $f.assignmentPrecedence, !0)), t.hooks.add("gobble-token", function(r) {
      const o = this.code;
      $f.updateOperators.some((i) => i === o && i === this.expr.charCodeAt(this.index + 1)) && (this.index += 2, r.node = {
        type: "UpdateExpression",
        operator: o === $C ? "++" : "--",
        argument: this.gobbleTokenProperty(this.gobbleIdentifier()),
        prefix: !0
      }, (!r.node.argument || !e.includes(r.node.argument.type)) && this.throwError(`Unexpected ${r.node.operator}`));
    }), t.hooks.add("after-token", function(r) {
      if (r.node) {
        const o = this.code;
        $f.updateOperators.some((i) => i === o && i === this.expr.charCodeAt(this.index + 1)) && (e.includes(r.node.type) || this.throwError(`Unexpected ${r.node.operator}`), this.index += 2, r.node = {
          type: "UpdateExpression",
          operator: o === $C ? "++" : "--",
          argument: r.node,
          prefix: !1
        });
      }
    }), t.hooks.add("after-expression", function(r) {
      r.node && n(r.node);
    });
    function n(r) {
      $f.assignmentOperators.has(r.operator) ? (r.type = "AssignmentExpression", n(r.left), n(r.right)) : r.operator || Object.values(r).forEach((o) => {
        o && typeof o == "object" && n(o);
      });
    }
  }
};
Xc.plugins.register($je, $f);
Xc.addUnaryOp("typeof");
Xc.addLiteral("null", null);
Xc.addLiteral("undefined", void 0);
/*!
 * https://github.com/Starcounter-Jack/JSON-Patch
 * (c) 2017-2022 Joachim Wester
 * MIT licensed
 */
var Dje = /* @__PURE__ */ function() {
  var t = function(e, n) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var i in o) o.hasOwnProperty(i) && (r[i] = o[i]);
    }, t(e, n);
  };
  return function(e, n) {
    t(e, n);
    function r() {
      this.constructor = e;
    }
    e.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), Ije = Object.prototype.hasOwnProperty;
function rI(t, e) {
  return Ije.call(t, e);
}
function oI(t) {
  if (Array.isArray(t)) {
    for (var e = new Array(t.length), n = 0; n < e.length; n++)
      e[n] = "" + n;
    return e;
  }
  if (Object.keys)
    return Object.keys(t);
  var r = [];
  for (var o in t)
    rI(t, o) && r.push(o);
  return r;
}
function _i(t) {
  switch (typeof t) {
    case "object":
      return JSON.parse(JSON.stringify(t));
    //Faster than ES5 clone - http://jsperf.com/deep-cloning-of-objects/5
    case "undefined":
      return null;
    //this is how JSON.stringify behaves for array items
    default:
      return t;
  }
}
function iI(t) {
  for (var e = 0, n = t.length, r; e < n; ) {
    if (r = t.charCodeAt(e), r >= 48 && r <= 57) {
      e++;
      continue;
    }
    return !1;
  }
  return !0;
}
function Nu(t) {
  return t.indexOf("/") === -1 && t.indexOf("~") === -1 ? t : t.replace(/~/g, "~0").replace(/\//g, "~1");
}
function Kle(t) {
  return t.replace(/~1/g, "/").replace(/~0/g, "~");
}
function sI(t) {
  if (t === void 0)
    return !0;
  if (t) {
    if (Array.isArray(t)) {
      for (var e = 0, n = t.length; e < n; e++)
        if (sI(t[e]))
          return !0;
    } else if (typeof t == "object") {
      for (var r = oI(t), o = r.length, i = 0; i < o; i++)
        if (sI(t[r[i]]))
          return !0;
    }
  }
  return !1;
}
function VF(t, e) {
  var n = [t];
  for (var r in e) {
    var o = typeof e[r] == "object" ? JSON.stringify(e[r], null, 2) : e[r];
    typeof o < "u" && n.push(r + ": " + o);
  }
  return n.join(`
`);
}
var Xle = (
  /** @class */
  function(t) {
    Dje(e, t);
    function e(n, r, o, i, s) {
      var a = this.constructor, l = t.call(this, VF(n, { name: r, index: o, operation: i, tree: s })) || this;
      return l.name = r, l.index = o, l.operation = i, l.tree = s, Object.setPrototypeOf(l, a.prototype), l.message = VF(n, { name: r, index: o, operation: i, tree: s }), l;
    }
    return e;
  }(Error)
), ur = Xle, Nje = _i, Qf = {
  add: function(t, e, n) {
    return t[e] = this.value, { newDocument: n };
  },
  remove: function(t, e, n) {
    var r = t[e];
    return delete t[e], { newDocument: n, removed: r };
  },
  replace: function(t, e, n) {
    var r = t[e];
    return t[e] = this.value, { newDocument: n, removed: r };
  },
  move: function(t, e, n) {
    var r = ox(n, this.path);
    r && (r = _i(r));
    var o = gd(n, { op: "remove", path: this.from }).removed;
    return gd(n, { op: "add", path: this.path, value: o }), { newDocument: n, removed: r };
  },
  copy: function(t, e, n) {
    var r = ox(n, this.from);
    return gd(n, { op: "add", path: this.path, value: _i(r) }), { newDocument: n };
  },
  test: function(t, e, n) {
    return { newDocument: n, test: L0(t[e], this.value) };
  },
  _get: function(t, e, n) {
    return this.value = t[e], { newDocument: n };
  }
}, jje = {
  add: function(t, e, n) {
    return iI(e) ? t.splice(e, 0, this.value) : t[e] = this.value, { newDocument: n, index: e };
  },
  remove: function(t, e, n) {
    var r = t.splice(e, 1);
    return { newDocument: n, removed: r[0] };
  },
  replace: function(t, e, n) {
    var r = t[e];
    return t[e] = this.value, { newDocument: n, removed: r };
  },
  move: Qf.move,
  copy: Qf.copy,
  test: Qf.test,
  _get: Qf._get
};
function ox(t, e) {
  if (e == "")
    return t;
  var n = { op: "_get", path: e };
  return gd(t, n), n.value;
}
function gd(t, e, n, r, o, i) {
  if (n === void 0 && (n = !1), r === void 0 && (r = !0), o === void 0 && (o = !0), i === void 0 && (i = 0), n && (typeof n == "function" ? n(e, 0, t, e.path) : ix(e, 0)), e.path === "") {
    var s = { newDocument: t };
    if (e.op === "add")
      return s.newDocument = e.value, s;
    if (e.op === "replace")
      return s.newDocument = e.value, s.removed = t, s;
    if (e.op === "move" || e.op === "copy")
      return s.newDocument = ox(t, e.from), e.op === "move" && (s.removed = t), s;
    if (e.op === "test") {
      if (s.test = L0(t, e.value), s.test === !1)
        throw new ur("Test operation failed", "TEST_OPERATION_FAILED", i, e, t);
      return s.newDocument = t, s;
    } else {
      if (e.op === "remove")
        return s.removed = t, s.newDocument = null, s;
      if (e.op === "_get")
        return e.value = t, s;
      if (n)
        throw new ur("Operation `op` property is not one of operations defined in RFC-6902", "OPERATION_OP_INVALID", i, e, t);
      return s;
    }
  } else {
    r || (t = _i(t));
    var a = e.path || "", l = a.split("/"), c = t, u = 1, d = l.length, f = void 0, h = void 0, p = void 0;
    for (typeof n == "function" ? p = n : p = ix; ; ) {
      if (h = l[u], h && h.indexOf("~") != -1 && (h = Kle(h)), o && (h == "__proto__" || h == "prototype" && u > 0 && l[u - 1] == "constructor"))
        throw new TypeError("JSON-Patch: modifying `__proto__` or `constructor/prototype` prop is banned for security reasons, if this was on purpose, please set `banPrototypeModifications` flag false and pass it to this function. More info in fast-json-patch README");
      if (n && f === void 0 && (c[h] === void 0 ? f = l.slice(0, u).join("/") : u == d - 1 && (f = e.path), f !== void 0 && p(e, 0, t, f)), u++, Array.isArray(c)) {
        if (h === "-")
          h = c.length;
        else {
          if (n && !iI(h))
            throw new ur("Expected an unsigned base-10 integer value, making the new referenced value the array element with the zero-based index", "OPERATION_PATH_ILLEGAL_ARRAY_INDEX", i, e, t);
          iI(h) && (h = ~~h);
        }
        if (u >= d) {
          if (n && e.op === "add" && h > c.length)
            throw new ur("The specified index MUST NOT be greater than the number of elements in the array", "OPERATION_VALUE_OUT_OF_BOUNDS", i, e, t);
          var s = jje[e.op].call(e, c, h, t);
          if (s.test === !1)
            throw new ur("Test operation failed", "TEST_OPERATION_FAILED", i, e, t);
          return s;
        }
      } else if (u >= d) {
        var s = Qf[e.op].call(e, c, h, t);
        if (s.test === !1)
          throw new ur("Test operation failed", "TEST_OPERATION_FAILED", i, e, t);
        return s;
      }
      if (c = c[h], n && u < d && (!c || typeof c != "object"))
        throw new ur("Cannot perform operation at the desired path", "OPERATION_PATH_UNRESOLVABLE", i, e, t);
    }
  }
}
function T5(t, e, n, r, o) {
  if (r === void 0 && (r = !0), o === void 0 && (o = !0), n && !Array.isArray(e))
    throw new ur("Patch sequence must be an array", "SEQUENCE_NOT_AN_ARRAY");
  r || (t = _i(t));
  for (var i = new Array(e.length), s = 0, a = e.length; s < a; s++)
    i[s] = gd(t, e[s], n, !0, o, s), t = i[s].newDocument;
  return i.newDocument = t, i;
}
function Lje(t, e, n) {
  var r = gd(t, e);
  if (r.test === !1)
    throw new ur("Test operation failed", "TEST_OPERATION_FAILED", n, e, t);
  return r.newDocument;
}
function ix(t, e, n, r) {
  if (typeof t != "object" || t === null || Array.isArray(t))
    throw new ur("Operation is not an object", "OPERATION_NOT_AN_OBJECT", e, t, n);
  if (Qf[t.op]) {
    if (typeof t.path != "string")
      throw new ur("Operation `path` property is not a string", "OPERATION_PATH_INVALID", e, t, n);
    if (t.path.indexOf("/") !== 0 && t.path.length > 0)
      throw new ur('Operation `path` property must start with "/"', "OPERATION_PATH_INVALID", e, t, n);
    if ((t.op === "move" || t.op === "copy") && typeof t.from != "string")
      throw new ur("Operation `from` property is not present (applicable in `move` and `copy` operations)", "OPERATION_FROM_REQUIRED", e, t, n);
    if ((t.op === "add" || t.op === "replace" || t.op === "test") && t.value === void 0)
      throw new ur("Operation `value` property is not present (applicable in `add`, `replace` and `test` operations)", "OPERATION_VALUE_REQUIRED", e, t, n);
    if ((t.op === "add" || t.op === "replace" || t.op === "test") && sI(t.value))
      throw new ur("Operation `value` property is not present (applicable in `add`, `replace` and `test` operations)", "OPERATION_VALUE_CANNOT_CONTAIN_UNDEFINED", e, t, n);
    if (n) {
      if (t.op == "add") {
        var o = t.path.split("/").length, i = r.split("/").length;
        if (o !== i + 1 && o !== i)
          throw new ur("Cannot perform an `add` operation at the desired path", "OPERATION_PATH_CANNOT_ADD", e, t, n);
      } else if (t.op === "replace" || t.op === "remove" || t.op === "_get") {
        if (t.path !== r)
          throw new ur("Cannot perform the operation at a path that does not exist", "OPERATION_PATH_UNRESOLVABLE", e, t, n);
      } else if (t.op === "move" || t.op === "copy") {
        var s = { op: "_get", path: t.from, value: void 0 }, a = Qle([s], n);
        if (a && a.name === "OPERATION_PATH_UNRESOLVABLE")
          throw new ur("Cannot perform the operation from a path that does not exist", "OPERATION_FROM_UNRESOLVABLE", e, t, n);
      }
    }
  } else throw new ur("Operation `op` property is not one of operations defined in RFC-6902", "OPERATION_OP_INVALID", e, t, n);
}
function Qle(t, e, n) {
  try {
    if (!Array.isArray(t))
      throw new ur("Patch sequence must be an array", "SEQUENCE_NOT_AN_ARRAY");
    if (e)
      T5(_i(e), _i(t), n || !0);
    else {
      n = n || ix;
      for (var r = 0; r < t.length; r++)
        n(t[r], r, e, void 0);
    }
  } catch (o) {
    if (o instanceof ur)
      return o;
    throw o;
  }
}
function L0(t, e) {
  if (t === e)
    return !0;
  if (t && e && typeof t == "object" && typeof e == "object") {
    var n = Array.isArray(t), r = Array.isArray(e), o, i, s;
    if (n && r) {
      if (i = t.length, i != e.length)
        return !1;
      for (o = i; o-- !== 0; )
        if (!L0(t[o], e[o]))
          return !1;
      return !0;
    }
    if (n != r)
      return !1;
    var a = Object.keys(t);
    if (i = a.length, i !== Object.keys(e).length)
      return !1;
    for (o = i; o-- !== 0; )
      if (!e.hasOwnProperty(a[o]))
        return !1;
    for (o = i; o-- !== 0; )
      if (s = a[o], !L0(t[s], e[s]))
        return !1;
    return !0;
  }
  return t !== t && e !== e;
}
const Fje = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  JsonPatchError: ur,
  _areEquals: L0,
  applyOperation: gd,
  applyPatch: T5,
  applyReducer: Lje,
  deepClone: Nje,
  getValueByPointer: ox,
  validate: Qle,
  validator: ix
}, Symbol.toStringTag, { value: "Module" }));
/*!
 * https://github.com/Starcounter-Jack/JSON-Patch
 * (c) 2017-2021 Joachim Wester
 * MIT license
 */
var R5 = /* @__PURE__ */ new WeakMap(), Bje = (
  /** @class */
  /* @__PURE__ */ function() {
    function t(e) {
      this.observers = /* @__PURE__ */ new Map(), this.obj = e;
    }
    return t;
  }()
), zje = (
  /** @class */
  /* @__PURE__ */ function() {
    function t(e, n) {
      this.callback = e, this.observer = n;
    }
    return t;
  }()
);
function qje(t) {
  return R5.get(t);
}
function Uje(t, e) {
  return t.observers.get(e);
}
function Hje(t, e) {
  t.observers.delete(e.callback);
}
function Vje(t, e) {
  e.unobserve();
}
function Wje(t, e) {
  var n = [], r, o = qje(t);
  if (!o)
    o = new Bje(t), R5.set(t, o);
  else {
    var i = Uje(o, e);
    r = i && i.observer;
  }
  if (r)
    return r;
  if (r = {}, o.value = _i(t), e) {
    r.callback = e, r.next = null;
    var s = function() {
      aI(r);
    }, a = function() {
      clearTimeout(r.next), r.next = setTimeout(s);
    };
    typeof window < "u" && (window.addEventListener("mouseup", a), window.addEventListener("keyup", a), window.addEventListener("mousedown", a), window.addEventListener("keydown", a), window.addEventListener("change", a));
  }
  return r.patches = n, r.object = t, r.unobserve = function() {
    aI(r), clearTimeout(r.next), Hje(o, r), typeof window < "u" && (window.removeEventListener("mouseup", a), window.removeEventListener("keyup", a), window.removeEventListener("mousedown", a), window.removeEventListener("keydown", a), window.removeEventListener("change", a));
  }, o.observers.set(e, new zje(e, r)), r;
}
function aI(t, e) {
  e === void 0 && (e = !1);
  var n = R5.get(t.object);
  P5(n.value, t.object, t.patches, "", e), t.patches.length && T5(n.value, t.patches);
  var r = t.patches;
  return r.length > 0 && (t.patches = [], t.callback && t.callback(r)), r;
}
function P5(t, e, n, r, o) {
  if (e !== t) {
    typeof e.toJSON == "function" && (e = e.toJSON());
    for (var i = oI(e), s = oI(t), a = !1, l = s.length - 1; l >= 0; l--) {
      var c = s[l], u = t[c];
      if (rI(e, c) && !(e[c] === void 0 && u !== void 0 && Array.isArray(e) === !1)) {
        var d = e[c];
        typeof u == "object" && u != null && typeof d == "object" && d != null && Array.isArray(u) === Array.isArray(d) ? P5(u, d, n, r + "/" + Nu(c), o) : u !== d && (o && n.push({ op: "test", path: r + "/" + Nu(c), value: _i(u) }), n.push({ op: "replace", path: r + "/" + Nu(c), value: _i(d) }));
      } else Array.isArray(t) === Array.isArray(e) ? (o && n.push({ op: "test", path: r + "/" + Nu(c), value: _i(u) }), n.push({ op: "remove", path: r + "/" + Nu(c) }), a = !0) : (o && n.push({ op: "test", path: r, value: t }), n.push({ op: "replace", path: r, value: e }));
    }
    if (!(!a && i.length == s.length))
      for (var l = 0; l < i.length; l++) {
        var c = i[l];
        !rI(t, c) && e[c] !== void 0 && n.push({ op: "add", path: r + "/" + Nu(c), value: _i(e[c]) });
      }
  }
}
function Gje(t, e, n) {
  n === void 0 && (n = !1);
  var r = [];
  return P5(t, e, r, "", n), r;
}
const Yje = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  compare: Gje,
  generate: aI,
  observe: Wje,
  unobserve: Vje
}, Symbol.toStringTag, { value: "Module" }));
Object.assign({}, Fje, Yje, {
  JsonPatchError: Xle,
  deepClone: _i,
  escapePathComponent: Nu,
  unescapePathComponent: Kle
});
const Kje = Object.prototype.toString;
function Xje(t, e) {
  return Kje.call(t) === `[object ${e}]`;
}
function Zle(t) {
  return Xje(t, "Object");
}
function $5(t) {
  return !!(t && t.then && typeof t.then == "function");
}
function pb(t) {
  return t && t.Math == Math ? t : void 0;
}
const Os = typeof globalThis == "object" && pb(globalThis) || // eslint-disable-next-line no-restricted-globals
typeof window == "object" && pb(window) || typeof self == "object" && pb(self) || typeof global == "object" && pb(global) || /* @__PURE__ */ function() {
  return this;
}() || {};
function Jle(t, e, n) {
  const r = n || Os, o = r.__SENTRY__ = r.__SENTRY__ || {};
  return o[t] || (o[t] = e());
}
const Qje = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, Zje = "Sentry Logger ", WF = [
  "debug",
  "info",
  "warn",
  "error",
  "log",
  "assert",
  "trace"
], GF = {};
function ece(t) {
  if (!("console" in Os))
    return t();
  const e = Os.console, n = {}, r = Object.keys(GF);
  r.forEach((o) => {
    const i = GF[o];
    n[o] = e[o], e[o] = i;
  });
  try {
    return t();
  } finally {
    r.forEach((o) => {
      e[o] = n[o];
    });
  }
}
function Jje() {
  let t = !1;
  const e = {
    enable: () => {
      t = !0;
    },
    disable: () => {
      t = !1;
    },
    isEnabled: () => t
  };
  return Qje ? WF.forEach((n) => {
    e[n] = (...r) => {
      t && ece(() => {
        Os.console[n](`${Zje}[${n}]:`, ...r);
      });
    };
  }) : WF.forEach((n) => {
    e[n] = () => {
    };
  }), e;
}
const Pc = Jje();
function td(t) {
  return lI(t, /* @__PURE__ */ new Map());
}
function lI(t, e) {
  if (e3e(t)) {
    const n = e.get(t);
    if (n !== void 0)
      return n;
    const r = {};
    e.set(t, r);
    for (const o of Object.keys(t))
      typeof t[o] < "u" && (r[o] = lI(t[o], e));
    return r;
  }
  if (Array.isArray(t)) {
    const n = e.get(t);
    if (n !== void 0)
      return n;
    const r = [];
    return e.set(t, r), t.forEach((o) => {
      r.push(lI(o, e));
    }), r;
  }
  return t;
}
function e3e(t) {
  if (!Zle(t))
    return !1;
  try {
    const e = Object.getPrototypeOf(t).constructor.name;
    return !e || e === "Object";
  } catch {
    return !0;
  }
}
function ya() {
  const t = Os, e = t.crypto || t.msCrypto;
  let n = () => Math.random() * 16;
  try {
    if (e && e.randomUUID)
      return e.randomUUID().replace(/-/g, "");
    e && e.getRandomValues && (n = () => {
      const r = new Uint8Array(1);
      return e.getRandomValues(r), r[0];
    });
  } catch {
  }
  return ("10000000100040008000" + 1e11).replace(
    /[018]/g,
    (r) => (
      // eslint-disable-next-line no-bitwise
      (r ^ (n() & 15) >> r / 4).toString(16)
    )
  );
}
function t3e(t) {
  return Array.isArray(t) ? t : [t];
}
var ll;
(function(t) {
  t[t.PENDING = 0] = "PENDING";
  const e = 1;
  t[t.RESOLVED = e] = "RESOLVED";
  const n = 2;
  t[t.REJECTED = n] = "REJECTED";
})(ll || (ll = {}));
let n3e = class ju {
  constructor(e) {
    ju.prototype.__init.call(this), ju.prototype.__init2.call(this), ju.prototype.__init3.call(this), ju.prototype.__init4.call(this), this._state = ll.PENDING, this._handlers = [];
    try {
      e(this._resolve, this._reject);
    } catch (n) {
      this._reject(n);
    }
  }
  /** JSDoc */
  then(e, n) {
    return new ju((r, o) => {
      this._handlers.push([
        !1,
        (i) => {
          if (!e)
            r(i);
          else
            try {
              r(e(i));
            } catch (s) {
              o(s);
            }
        },
        (i) => {
          if (!n)
            o(i);
          else
            try {
              r(n(i));
            } catch (s) {
              o(s);
            }
        }
      ]), this._executeHandlers();
    });
  }
  /** JSDoc */
  catch(e) {
    return this.then((n) => n, e);
  }
  /** JSDoc */
  finally(e) {
    return new ju((n, r) => {
      let o, i;
      return this.then(
        (s) => {
          i = !1, o = s, e && e();
        },
        (s) => {
          i = !0, o = s, e && e();
        }
      ).then(() => {
        if (i) {
          r(o);
          return;
        }
        n(o);
      });
    });
  }
  /** JSDoc */
  __init() {
    this._resolve = (e) => {
      this._setResult(ll.RESOLVED, e);
    };
  }
  /** JSDoc */
  __init2() {
    this._reject = (e) => {
      this._setResult(ll.REJECTED, e);
    };
  }
  /** JSDoc */
  __init3() {
    this._setResult = (e, n) => {
      if (this._state === ll.PENDING) {
        if ($5(n)) {
          n.then(this._resolve, this._reject);
          return;
        }
        this._state = e, this._value = n, this._executeHandlers();
      }
    };
  }
  /** JSDoc */
  __init4() {
    this._executeHandlers = () => {
      if (this._state === ll.PENDING)
        return;
      const e = this._handlers.slice();
      this._handlers = [], e.forEach((n) => {
        n[0] || (this._state === ll.RESOLVED && n[1](this._value), this._state === ll.REJECTED && n[2](this._value), n[0] = !0);
      });
    };
  }
};
const tce = 1e3;
function M5() {
  return Date.now() / tce;
}
function r3e() {
  const { performance: t } = Os;
  if (!t || !t.now)
    return M5;
  const e = Date.now() - t.now(), n = t.timeOrigin == null ? e : t.timeOrigin;
  return () => (n + t.now()) / tce;
}
const nce = r3e();
(() => {
  const { performance: t } = Os;
  if (!t || !t.now)
    return;
  const e = 3600 * 1e3, n = t.now(), r = Date.now(), o = t.timeOrigin ? Math.abs(t.timeOrigin + n - r) : e, i = o < e, s = t.timing && t.timing.navigationStart, a = typeof s == "number" ? Math.abs(s + n - r) : e, l = a < e;
  return i || l ? o <= a ? t.timeOrigin : s : r;
})();
const X_ = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, rce = "production";
function o3e() {
  return Jle("globalEventProcessors", () => []);
}
function cI(t, e, n, r = 0) {
  return new n3e((o, i) => {
    const s = t[r];
    if (e === null || typeof s != "function")
      o(e);
    else {
      const a = s({ ...e }, n);
      X_ && s.id && a === null && Pc.log(`Event processor "${s.id}" dropped event`), $5(a) ? a.then((l) => cI(t, l, n, r + 1).then(o)).then(null, i) : cI(t, a, n, r + 1).then(o).then(null, i);
    }
  });
}
function i3e(t) {
  const e = nce(), n = {
    sid: ya(),
    init: !0,
    timestamp: e,
    started: e,
    duration: 0,
    status: "ok",
    errors: 0,
    ignoreDuration: !1,
    toJSON: () => a3e(n)
  };
  return t && pS(n, t), n;
}
function pS(t, e = {}) {
  if (e.user && (!t.ipAddress && e.user.ip_address && (t.ipAddress = e.user.ip_address), !t.did && !e.did && (t.did = e.user.id || e.user.email || e.user.username)), t.timestamp = e.timestamp || nce(), e.abnormal_mechanism && (t.abnormal_mechanism = e.abnormal_mechanism), e.ignoreDuration && (t.ignoreDuration = e.ignoreDuration), e.sid && (t.sid = e.sid.length === 32 ? e.sid : ya()), e.init !== void 0 && (t.init = e.init), !t.did && e.did && (t.did = `${e.did}`), typeof e.started == "number" && (t.started = e.started), t.ignoreDuration)
    t.duration = void 0;
  else if (typeof e.duration == "number")
    t.duration = e.duration;
  else {
    const n = t.timestamp - t.started;
    t.duration = n >= 0 ? n : 0;
  }
  e.release && (t.release = e.release), e.environment && (t.environment = e.environment), !t.ipAddress && e.ipAddress && (t.ipAddress = e.ipAddress), !t.userAgent && e.userAgent && (t.userAgent = e.userAgent), typeof e.errors == "number" && (t.errors = e.errors), e.status && (t.status = e.status);
}
function s3e(t, e) {
  let n = {};
  t.status === "ok" && (n = { status: "exited" }), pS(t, n);
}
function a3e(t) {
  return td({
    sid: `${t.sid}`,
    init: t.init,
    // Make sure that sec is converted to ms for date constructor
    started: new Date(t.started * 1e3).toISOString(),
    timestamp: new Date(t.timestamp * 1e3).toISOString(),
    status: t.status,
    errors: t.errors,
    did: typeof t.did == "number" || typeof t.did == "string" ? `${t.did}` : void 0,
    duration: t.duration,
    abnormal_mechanism: t.abnormal_mechanism,
    attrs: {
      release: t.release,
      environment: t.environment,
      ip_address: t.ipAddress,
      user_agent: t.userAgent
    }
  });
}
const l3e = 1;
function c3e(t) {
  const { spanId: e, traceId: n } = t.spanContext(), { data: r, op: o, parent_span_id: i, status: s, tags: a, origin: l } = sx(t);
  return td({
    data: r,
    op: o,
    parent_span_id: i,
    span_id: e,
    status: s,
    tags: a,
    trace_id: n,
    origin: l
  });
}
function sx(t) {
  return u3e(t) ? t.getSpanJSON() : typeof t.toJSON == "function" ? t.toJSON() : {};
}
function u3e(t) {
  return typeof t.getSpanJSON == "function";
}
function d3e(t) {
  const { traceFlags: e } = t.spanContext();
  return !!(e & l3e);
}
function f3e(t) {
  if (t)
    return h3e(t) ? { captureContext: t } : m3e(t) ? {
      captureContext: t
    } : t;
}
function h3e(t) {
  return t instanceof uI || typeof t == "function";
}
const p3e = [
  "user",
  "level",
  "extra",
  "contexts",
  "tags",
  "fingerprint",
  "requestSession",
  "propagationContext"
];
function m3e(t) {
  return Object.keys(t).some((e) => p3e.includes(e));
}
function oce(t, e) {
  return D5().captureException(t, f3e(e));
}
function g3e() {
  return D5().getClient();
}
function y3e() {
  return D5().getScope();
}
function ice(t) {
  return t.transaction;
}
function v3e(t, e, n) {
  const r = e.getOptions(), { publicKey: o } = e.getDsn() || {}, { segment: i } = n && n.getUser() || {}, s = td({
    environment: r.environment || rce,
    release: r.release,
    user_segment: i,
    public_key: o,
    trace_id: t
  });
  return e.emit && e.emit("createDsc", s), s;
}
function b3e(t) {
  const e = g3e();
  if (!e)
    return {};
  const n = v3e(sx(t).trace_id || "", e, y3e()), r = ice(t);
  if (!r)
    return n;
  const o = r && r._frozenDynamicSamplingContext;
  if (o)
    return o;
  const { sampleRate: i, source: s } = r.metadata;
  i != null && (n.sample_rate = `${i}`);
  const a = sx(r);
  return s && s !== "url" && (n.transaction = a.description), n.sampled = String(d3e(r)), e.emit && e.emit("createDsc", n), n;
}
function _3e(t, e) {
  const { fingerprint: n, span: r, breadcrumbs: o, sdkProcessingMetadata: i } = e;
  w3e(t, e), r && S3e(t, r), O3e(t, n), x3e(t, o), E3e(t, i);
}
function w3e(t, e) {
  const {
    extra: n,
    tags: r,
    user: o,
    contexts: i,
    level: s,
    // eslint-disable-next-line deprecation/deprecation
    transactionName: a
  } = e, l = td(n);
  l && Object.keys(l).length && (t.extra = { ...l, ...t.extra });
  const c = td(r);
  c && Object.keys(c).length && (t.tags = { ...c, ...t.tags });
  const u = td(o);
  u && Object.keys(u).length && (t.user = { ...u, ...t.user });
  const d = td(i);
  d && Object.keys(d).length && (t.contexts = { ...d, ...t.contexts }), s && (t.level = s), a && (t.transaction = a);
}
function x3e(t, e) {
  const n = [...t.breadcrumbs || [], ...e];
  t.breadcrumbs = n.length ? n : void 0;
}
function E3e(t, e) {
  t.sdkProcessingMetadata = {
    ...t.sdkProcessingMetadata,
    ...e
  };
}
function S3e(t, e) {
  t.contexts = { trace: c3e(e), ...t.contexts };
  const n = ice(e);
  if (n) {
    t.sdkProcessingMetadata = {
      dynamicSamplingContext: b3e(e),
      ...t.sdkProcessingMetadata
    };
    const r = sx(n).description;
    r && (t.tags = { transaction: r, ...t.tags });
  }
}
function O3e(t, e) {
  t.fingerprint = t.fingerprint ? t3e(t.fingerprint) : [], e && (t.fingerprint = t.fingerprint.concat(e)), t.fingerprint && !t.fingerprint.length && delete t.fingerprint;
}
const C3e = 100;
let uI = class Q_ {
  /** Flag if notifying is happening. */
  /** Callback for client to receive scope changes. */
  /** Callback list that will be called after {@link applyToEvent}. */
  /** Array of breadcrumbs. */
  /** User */
  /** Tags */
  /** Extra */
  /** Contexts */
  /** Attachments */
  /** Propagation Context for distributed tracing */
  /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */
  /** Fingerprint */
  /** Severity */
  // eslint-disable-next-line deprecation/deprecation
  /**
   * Transaction Name
   */
  /** Span */
  /** Session */
  /** Request Mode Session Status */
  /** The client on this scope */
  // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
  constructor() {
    this._notifyingListeners = !1, this._scopeListeners = [], this._eventProcessors = [], this._breadcrumbs = [], this._attachments = [], this._user = {}, this._tags = {}, this._extra = {}, this._contexts = {}, this._sdkProcessingMetadata = {}, this._propagationContext = YF();
  }
  /**
   * Inherit values from the parent scope.
   * @deprecated Use `scope.clone()` and `new Scope()` instead.
   */
  static clone(e) {
    return e ? e.clone() : new Q_();
  }
  /**
   * Clone this scope instance.
   */
  clone() {
    const e = new Q_();
    return e._breadcrumbs = [...this._breadcrumbs], e._tags = { ...this._tags }, e._extra = { ...this._extra }, e._contexts = { ...this._contexts }, e._user = this._user, e._level = this._level, e._span = this._span, e._session = this._session, e._transactionName = this._transactionName, e._fingerprint = this._fingerprint, e._eventProcessors = [...this._eventProcessors], e._requestSession = this._requestSession, e._attachments = [...this._attachments], e._sdkProcessingMetadata = { ...this._sdkProcessingMetadata }, e._propagationContext = { ...this._propagationContext }, e._client = this._client, e;
  }
  /** Update the client on the scope. */
  setClient(e) {
    this._client = e;
  }
  /**
   * Get the client assigned to this scope.
   *
   * It is generally recommended to use the global function `Sentry.getClient()` instead, unless you know what you are doing.
   */
  getClient() {
    return this._client;
  }
  /**
   * Add internal on change listener. Used for sub SDKs that need to store the scope.
   * @hidden
   */
  addScopeListener(e) {
    this._scopeListeners.push(e);
  }
  /**
   * @inheritDoc
   */
  addEventProcessor(e) {
    return this._eventProcessors.push(e), this;
  }
  /**
   * @inheritDoc
   */
  setUser(e) {
    return this._user = e || {
      email: void 0,
      id: void 0,
      ip_address: void 0,
      segment: void 0,
      username: void 0
    }, this._session && pS(this._session, { user: e }), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getUser() {
    return this._user;
  }
  /**
   * @inheritDoc
   */
  getRequestSession() {
    return this._requestSession;
  }
  /**
   * @inheritDoc
   */
  setRequestSession(e) {
    return this._requestSession = e, this;
  }
  /**
   * @inheritDoc
   */
  setTags(e) {
    return this._tags = {
      ...this._tags,
      ...e
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setTag(e, n) {
    return this._tags = { ...this._tags, [e]: n }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtras(e) {
    return this._extra = {
      ...this._extra,
      ...e
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtra(e, n) {
    return this._extra = { ...this._extra, [e]: n }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setFingerprint(e) {
    return this._fingerprint = e, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setLevel(e) {
    return this._level = e, this._notifyScopeListeners(), this;
  }
  /**
   * Sets the transaction name on the scope for future events.
   */
  setTransactionName(e) {
    return this._transactionName = e, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setContext(e, n) {
    return n === null ? delete this._contexts[e] : this._contexts[e] = n, this._notifyScopeListeners(), this;
  }
  /**
   * Sets the Span on the scope.
   * @param span Span
   * @deprecated Instead of setting a span on a scope, use `startSpan()`/`startSpanManual()` instead.
   */
  setSpan(e) {
    return this._span = e, this._notifyScopeListeners(), this;
  }
  /**
   * Returns the `Span` if there is one.
   * @deprecated Use `getActiveSpan()` instead.
   */
  getSpan() {
    return this._span;
  }
  /**
   * Returns the `Transaction` attached to the scope (if there is one).
   * @deprecated You should not rely on the transaction, but just use `startSpan()` APIs instead.
   */
  getTransaction() {
    const e = this._span;
    return e && e.transaction;
  }
  /**
   * @inheritDoc
   */
  setSession(e) {
    return e ? this._session = e : delete this._session, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getSession() {
    return this._session;
  }
  /**
   * @inheritDoc
   */
  update(e) {
    if (!e)
      return this;
    const n = typeof e == "function" ? e(this) : e;
    if (n instanceof Q_) {
      const r = n.getScopeData();
      this._tags = { ...this._tags, ...r.tags }, this._extra = { ...this._extra, ...r.extra }, this._contexts = { ...this._contexts, ...r.contexts }, r.user && Object.keys(r.user).length && (this._user = r.user), r.level && (this._level = r.level), r.fingerprint.length && (this._fingerprint = r.fingerprint), n.getRequestSession() && (this._requestSession = n.getRequestSession()), r.propagationContext && (this._propagationContext = r.propagationContext);
    } else if (Zle(n)) {
      const r = e;
      this._tags = { ...this._tags, ...r.tags }, this._extra = { ...this._extra, ...r.extra }, this._contexts = { ...this._contexts, ...r.contexts }, r.user && (this._user = r.user), r.level && (this._level = r.level), r.fingerprint && (this._fingerprint = r.fingerprint), r.requestSession && (this._requestSession = r.requestSession), r.propagationContext && (this._propagationContext = r.propagationContext);
    }
    return this;
  }
  /**
   * @inheritDoc
   */
  clear() {
    return this._breadcrumbs = [], this._tags = {}, this._extra = {}, this._user = {}, this._contexts = {}, this._level = void 0, this._transactionName = void 0, this._fingerprint = void 0, this._requestSession = void 0, this._span = void 0, this._session = void 0, this._notifyScopeListeners(), this._attachments = [], this._propagationContext = YF(), this;
  }
  /**
   * @inheritDoc
   */
  addBreadcrumb(e, n) {
    const r = typeof n == "number" ? n : C3e;
    if (r <= 0)
      return this;
    const o = {
      timestamp: M5(),
      ...e
    }, i = this._breadcrumbs;
    return i.push(o), this._breadcrumbs = i.length > r ? i.slice(-r) : i, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getLastBreadcrumb() {
    return this._breadcrumbs[this._breadcrumbs.length - 1];
  }
  /**
   * @inheritDoc
   */
  clearBreadcrumbs() {
    return this._breadcrumbs = [], this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  addAttachment(e) {
    return this._attachments.push(e), this;
  }
  /**
   * @inheritDoc
   * @deprecated Use `getScopeData()` instead.
   */
  getAttachments() {
    return this.getScopeData().attachments;
  }
  /**
   * @inheritDoc
   */
  clearAttachments() {
    return this._attachments = [], this;
  }
  /** @inheritDoc */
  getScopeData() {
    const {
      _breadcrumbs: e,
      _attachments: n,
      _contexts: r,
      _tags: o,
      _extra: i,
      _user: s,
      _level: a,
      _fingerprint: l,
      _eventProcessors: c,
      _propagationContext: u,
      _sdkProcessingMetadata: d,
      _transactionName: f,
      _span: h
    } = this;
    return {
      breadcrumbs: e,
      attachments: n,
      contexts: r,
      tags: o,
      extra: i,
      user: s,
      level: a,
      fingerprint: l || [],
      eventProcessors: c,
      propagationContext: u,
      sdkProcessingMetadata: d,
      transactionName: f,
      span: h
    };
  }
  /**
   * Applies data from the scope to the event and runs all event processors on it.
   *
   * @param event Event
   * @param hint Object containing additional information about the original exception, for use by the event processors.
   * @hidden
   * @deprecated Use `applyScopeDataToEvent()` directly
   */
  applyToEvent(e, n = {}, r = []) {
    _3e(e, this.getScopeData());
    const o = [
      ...r,
      // eslint-disable-next-line deprecation/deprecation
      ...o3e(),
      ...this._eventProcessors
    ];
    return cI(o, e, n);
  }
  /**
   * Add data which will be accessible during event processing but won't get sent to Sentry
   */
  setSDKProcessingMetadata(e) {
    return this._sdkProcessingMetadata = { ...this._sdkProcessingMetadata, ...e }, this;
  }
  /**
   * @inheritDoc
   */
  setPropagationContext(e) {
    return this._propagationContext = e, this;
  }
  /**
   * @inheritDoc
   */
  getPropagationContext() {
    return this._propagationContext;
  }
  /**
   * Capture an exception for this scope.
   *
   * @param exception The exception to capture.
   * @param hint Optinal additional data to attach to the Sentry event.
   * @returns the id of the captured Sentry event.
   */
  captureException(e, n) {
    const r = n && n.event_id ? n.event_id : ya();
    if (!this._client)
      return Pc.warn("No client configured on scope - will not capture exception!"), r;
    const o = new Error("Sentry syntheticException");
    return this._client.captureException(
      e,
      {
        originalException: e,
        syntheticException: o,
        ...n,
        event_id: r
      },
      this
    ), r;
  }
  /**
   * Capture a message for this scope.
   *
   * @param message The message to capture.
   * @param level An optional severity level to report the message with.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured message.
   */
  captureMessage(e, n, r) {
    const o = r && r.event_id ? r.event_id : ya();
    if (!this._client)
      return Pc.warn("No client configured on scope - will not capture message!"), o;
    const i = new Error(e);
    return this._client.captureMessage(
      e,
      n,
      {
        originalException: e,
        syntheticException: i,
        ...r,
        event_id: o
      },
      this
    ), o;
  }
  /**
   * Captures a manually created event for this scope and sends it to Sentry.
   *
   * @param exception The event to capture.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured event.
   */
  captureEvent(e, n) {
    const r = n && n.event_id ? n.event_id : ya();
    return this._client ? (this._client.captureEvent(e, { ...n, event_id: r }, this), r) : (Pc.warn("No client configured on scope - will not capture event!"), r);
  }
  /**
   * This will be called on every set call.
   */
  _notifyScopeListeners() {
    this._notifyingListeners || (this._notifyingListeners = !0, this._scopeListeners.forEach((e) => {
      e(this);
    }), this._notifyingListeners = !1);
  }
};
function YF() {
  return {
    traceId: ya(),
    spanId: ya().substring(16)
  };
}
const k3e = "7.119.2", sce = parseFloat(k3e), A3e = 100;
let ace = class {
  /** Is a {@link Layer}[] containing the client and scope */
  /** Contains the last event id of a captured event.  */
  /**
   * Creates a new instance of the hub, will push one {@link Layer} into the
   * internal stack on creation.
   *
   * @param client bound to the hub.
   * @param scope bound to the hub.
   * @param version number, higher number means higher priority.
   *
   * @deprecated Instantiation of Hub objects is deprecated and the constructor will be removed in version 8 of the SDK.
   *
   * If you are currently using the Hub for multi-client use like so:
   *
   * ```
   * // OLD
   * const hub = new Hub();
   * hub.bindClient(client);
   * makeMain(hub)
   * ```
   *
   * instead initialize the client as follows:
   *
   * ```
   * // NEW
   * Sentry.withIsolationScope(() => {
   *    Sentry.setCurrentClient(client);
   *    client.init();
   * });
   * ```
   *
   * If you are using the Hub to capture events like so:
   *
   * ```
   * // OLD
   * const client = new Client();
   * const hub = new Hub(client);
   * hub.captureException()
   * ```
   *
   * instead capture isolated events as follows:
   *
   * ```
   * // NEW
   * const client = new Client();
   * const scope = new Scope();
   * scope.setClient(client);
   * scope.captureException();
   * ```
   */
  constructor(e, n, r, o = sce) {
    this._version = o;
    let i;
    n ? i = n : (i = new uI(), i.setClient(e));
    let s;
    r ? s = r : (s = new uI(), s.setClient(e)), this._stack = [{ scope: i }], e && this.bindClient(e), this._isolationScope = s;
  }
  /**
   * Checks if this hub's version is older than the given version.
   *
   * @param version A version number to compare to.
   * @return True if the given version is newer; otherwise false.
   *
   * @deprecated This will be removed in v8.
   */
  isOlderThan(e) {
    return this._version < e;
  }
  /**
   * This binds the given client to the current scope.
   * @param client An SDK client (client) instance.
   *
   * @deprecated Use `initAndBind()` directly, or `setCurrentClient()` and/or `client.init()` instead.
   */
  bindClient(e) {
    const n = this.getStackTop();
    n.client = e, n.scope.setClient(e), e && e.setupIntegrations && e.setupIntegrations();
  }
  /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */
  pushScope() {
    const e = this.getScope().clone();
    return this.getStack().push({
      // eslint-disable-next-line deprecation/deprecation
      client: this.getClient(),
      scope: e
    }), e;
  }
  /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */
  popScope() {
    return this.getStack().length <= 1 ? !1 : !!this.getStack().pop();
  }
  /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.withScope()` instead.
   */
  withScope(e) {
    const n = this.pushScope();
    let r;
    try {
      r = e(n);
    } catch (o) {
      throw this.popScope(), o;
    }
    return $5(r) ? r.then(
      (o) => (this.popScope(), o),
      (o) => {
        throw this.popScope(), o;
      }
    ) : (this.popScope(), r);
  }
  /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.getClient()` instead.
   */
  getClient() {
    return this.getStackTop().client;
  }
  /**
   * Returns the scope of the top stack.
   *
   * @deprecated Use `Sentry.getCurrentScope()` instead.
   */
  getScope() {
    return this.getStackTop().scope;
  }
  /**
   * @deprecated Use `Sentry.getIsolationScope()` instead.
   */
  getIsolationScope() {
    return this._isolationScope;
  }
  /**
   * Returns the scope stack for domains or the process.
   * @deprecated This will be removed in v8.
   */
  getStack() {
    return this._stack;
  }
  /**
   * Returns the topmost scope layer in the order domain > local > process.
   * @deprecated This will be removed in v8.
   */
  getStackTop() {
    return this._stack[this._stack.length - 1];
  }
  /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureException()` instead.
   */
  captureException(e, n) {
    const r = this._lastEventId = n && n.event_id ? n.event_id : ya(), o = new Error("Sentry syntheticException");
    return this.getScope().captureException(e, {
      originalException: e,
      syntheticException: o,
      ...n,
      event_id: r
    }), r;
  }
  /**
   * @inheritDoc
   *
   * @deprecated Use  `Sentry.captureMessage()` instead.
   */
  captureMessage(e, n, r) {
    const o = this._lastEventId = r && r.event_id ? r.event_id : ya(), i = new Error(e);
    return this.getScope().captureMessage(e, n, {
      originalException: e,
      syntheticException: i,
      ...r,
      event_id: o
    }), o;
  }
  /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureEvent()` instead.
   */
  captureEvent(e, n) {
    const r = n && n.event_id ? n.event_id : ya();
    return e.type || (this._lastEventId = r), this.getScope().captureEvent(e, { ...n, event_id: r }), r;
  }
  /**
   * @inheritDoc
   *
   * @deprecated This will be removed in v8.
   */
  lastEventId() {
    return this._lastEventId;
  }
  /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.addBreadcrumb()` instead.
   */
  addBreadcrumb(e, n) {
    const { scope: r, client: o } = this.getStackTop();
    if (!o) return;
    const { beforeBreadcrumb: i = null, maxBreadcrumbs: s = A3e } = o.getOptions && o.getOptions() || {};
    if (s <= 0) return;
    const a = { timestamp: M5(), ...e }, l = i ? ece(() => i(a, n)) : a;
    l !== null && (o.emit && o.emit("beforeAddBreadcrumb", l, n), r.addBreadcrumb(l, s));
  }
  /**
   * @inheritDoc
   * @deprecated Use `Sentry.setUser()` instead.
   */
  setUser(e) {
    this.getScope().setUser(e), this.getIsolationScope().setUser(e);
  }
  /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTags()` instead.
   */
  setTags(e) {
    this.getScope().setTags(e), this.getIsolationScope().setTags(e);
  }
  /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtras()` instead.
   */
  setExtras(e) {
    this.getScope().setExtras(e), this.getIsolationScope().setExtras(e);
  }
  /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTag()` instead.
   */
  setTag(e, n) {
    this.getScope().setTag(e, n), this.getIsolationScope().setTag(e, n);
  }
  /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtra()` instead.
   */
  setExtra(e, n) {
    this.getScope().setExtra(e, n), this.getIsolationScope().setExtra(e, n);
  }
  /**
   * @inheritDoc
   * @deprecated Use `Sentry.setContext()` instead.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setContext(e, n) {
    this.getScope().setContext(e, n), this.getIsolationScope().setContext(e, n);
  }
  /**
   * @inheritDoc
   *
   * @deprecated Use `getScope()` directly.
   */
  configureScope(e) {
    const { scope: n, client: r } = this.getStackTop();
    r && e(n);
  }
  /**
   * @inheritDoc
   */
  // eslint-disable-next-line deprecation/deprecation
  run(e) {
    const n = KF(this);
    try {
      e(this);
    } finally {
      KF(n);
    }
  }
  /**
   * @inheritDoc
   * @deprecated Use `Sentry.getClient().getIntegrationByName()` instead.
   */
  getIntegration(e) {
    const n = this.getClient();
    if (!n) return null;
    try {
      return n.getIntegration(e);
    } catch {
      return X_ && Pc.warn(`Cannot retrieve integration ${e.id} from the current Hub`), null;
    }
  }
  /**
   * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
   *
   * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
   * new child span within the transaction or any span, call the respective `.startChild()` method.
   *
   * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
   *
   * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
   * finished child spans will be sent to Sentry.
   *
   * @param context Properties of the new `Transaction`.
   * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
   * default values). See {@link Options.tracesSampler}.
   *
   * @returns The transaction which was just started
   *
   * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
   */
  startTransaction(e, n) {
    const r = this._callExtensionMethod("startTransaction", e, n);
    return X_ && !r && (this.getClient() ? Pc.warn(`Tracing extension 'startTransaction' has not been added. Call 'addTracingExtensions' before calling 'init':
Sentry.addTracingExtensions();
Sentry.init({...});
`) : Pc.warn(
      "Tracing extension 'startTransaction' is missing. You should 'init' the SDK before calling 'startTransaction'"
    )), r;
  }
  /**
   * @inheritDoc
   * @deprecated Use `spanToTraceHeader()` instead.
   */
  traceHeaders() {
    return this._callExtensionMethod("traceHeaders");
  }
  /**
   * @inheritDoc
   *
   * @deprecated Use top level `captureSession` instead.
   */
  captureSession(e = !1) {
    if (e)
      return this.endSession();
    this._sendSessionUpdate();
  }
  /**
   * @inheritDoc
   * @deprecated Use top level `endSession` instead.
   */
  endSession() {
    const e = this.getStackTop().scope, n = e.getSession();
    n && s3e(n), this._sendSessionUpdate(), e.setSession();
  }
  /**
   * @inheritDoc
   * @deprecated Use top level `startSession` instead.
   */
  startSession(e) {
    const { scope: n, client: r } = this.getStackTop(), { release: o, environment: i = rce } = r && r.getOptions() || {}, { userAgent: s } = Os.navigator || {}, a = i3e({
      release: o,
      environment: i,
      user: n.getUser(),
      ...s && { userAgent: s },
      ...e
    }), l = n.getSession && n.getSession();
    return l && l.status === "ok" && pS(l, { status: "exited" }), this.endSession(), n.setSession(a), a;
  }
  /**
   * Returns if default PII should be sent to Sentry and propagated in ourgoing requests
   * when Tracing is used.
   *
   * @deprecated Use top-level `getClient().getOptions().sendDefaultPii` instead. This function
   * only unnecessarily increased API surface but only wrapped accessing the option.
   */
  shouldSendDefaultPii() {
    const e = this.getClient(), n = e && e.getOptions();
    return !!(n && n.sendDefaultPii);
  }
  /**
   * Sends the current Session on the scope
   */
  _sendSessionUpdate() {
    const { scope: e, client: n } = this.getStackTop(), r = e.getSession();
    r && n && n.captureSession && n.captureSession(r);
  }
  /**
   * Calls global extension method and binding current instance to the function call
   */
  // @ts-expect-error Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _callExtensionMethod(e, ...n) {
    const r = mS().__SENTRY__;
    if (r && r.extensions && typeof r.extensions[e] == "function")
      return r.extensions[e].apply(this, n);
    X_ && Pc.warn(`Extension method ${e} couldn't be found, doing nothing.`);
  }
};
function mS() {
  return Os.__SENTRY__ = Os.__SENTRY__ || {
    extensions: {},
    hub: void 0
  }, Os;
}
function KF(t) {
  const e = mS(), n = dI(e);
  return lce(e, t), n;
}
function D5() {
  const t = mS();
  if (t.__SENTRY__ && t.__SENTRY__.acs) {
    const e = t.__SENTRY__.acs.getCurrentHub();
    if (e)
      return e;
  }
  return T3e(t);
}
function T3e(t = mS()) {
  return (!R3e(t) || // eslint-disable-next-line deprecation/deprecation
  dI(t).isOlderThan(sce)) && lce(t, new ace()), dI(t);
}
function R3e(t) {
  return !!(t && t.__SENTRY__ && t.__SENTRY__.hub);
}
function dI(t) {
  return Jle("hub", () => new ace(), t);
}
function lce(t, e) {
  if (!t) return !1;
  const n = t.__SENTRY__ = t.__SENTRY__ || {};
  return n.hub = e, !0;
}
var XF = {}, QF = {}, ZF;
function P3e() {
  return ZF || (ZF = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.parse = t.FIELD_INFO = void 0;
    const e = "l", n = "w", r = "lw", o = "?", i = "#", s = "*", a = "-", l = "/", c = {
      "@yearly": "0 0 1 1 ?",
      "@monthly": "0 0 1 * ?",
      "@weekly": "0 0 ? * 0",
      "@daily": "0 0 * * ?",
      "@hourly": "0 * * * ?"
    };
    t.FIELD_INFO = {
      second: { min: 0, max: 59 },
      minute: { min: 0, max: 59 },
      hour: { min: 0, max: 23 },
      day_of_month: { min: 1, max: 31 },
      month: {
        min: 1,
        max: 12,
        alias: {
          jan: 1,
          feb: 2,
          mar: 3,
          apr: 4,
          may: 5,
          jun: 6,
          jul: 7,
          aug: 8,
          sep: 9,
          oct: 10,
          nov: 11,
          dec: 12
        }
      },
      day_of_week: {
        min: 0,
        max: 7,
        alias: {
          7: 0,
          sun: 0,
          mon: 1,
          tue: 2,
          wed: 3,
          thu: 4,
          fri: 5,
          sat: 6
        }
      },
      year: { min: 1970, max: 2099 }
    };
    const u = ["second", "minute", "hour", "day_of_month", "month", "day_of_week", "year"];
    function d(A) {
      return A && A.toString() === "true";
    }
    function f(A, O = (k) => k) {
      const k = /* @__PURE__ */ new Set(), T = [];
      return A.forEach((I) => {
        const j = O(I);
        k.has(j) || (k.add(j), T.push(I));
      }), T;
    }
    function h(A, O) {
      return f(A.split(O).map((k) => k.trim()).filter((k) => k));
    }
    function p(A, O) {
      return new Error(`Invalid cron expression [${A}]. ${O}`);
    }
    function m(A, O, k) {
      if (k = k.toLowerCase().trim(), k === s)
        return { all: !0 };
      if (k === o)
        return y(A, O, k);
      const T = h(k, ","), I = {};
      for (const j of T)
        j && (j.indexOf(l) >= 0 ? (I.steps = I.steps || [], I.steps.push(_(A, O, j))) : j.indexOf(a) >= 0 ? (I.ranges = I.ranges || [], I.ranges.push(S(A, O, j))) : j.indexOf(i) >= 0 ? (I.nthDays = I.nthDays || [], I.nthDays.push(w(A, O, j))) : j === e ? I.lastDay = g(A, O, j) : j === r ? I.lastWeekday = v(A, O, j) : O === "day_of_month" && j.indexOf(n) >= 0 ? (I.nearestWeekdays = I.nearestWeekdays || [], I.nearestWeekdays.push(x(A, O, j))) : O === "day_of_week" && j.endsWith(e) ? (I.lastDays = I.lastDays || [], I.lastDays.push(E(A, O, j))) : (I.values = I.values || [], I.values.push(b(A, O, j))));
      return I.values && (I.values = f(I.values)), I;
    }
    function g(A, O, k) {
      if (O === "day_of_week" || O === "day_of_month")
        return !0;
      throw p(A, `Invalid value for [${k}] for field [${O}]. It can be used only for [day_of_month or day_of_week] fields.`);
    }
    function y(A, O, k) {
      if (O === "day_of_week" || O === "day_of_month")
        return { omit: !0 };
      throw p(A, `Invalid Value [${k}] for field [${O}]. It can be specified only for [day_of_month or day_of_week] fields.`);
    }
    function v(A, O, k) {
      if (O === "day_of_month")
        return !0;
      throw p(A, `Invalid value for [${k}] for field [${O}]. It can be used only for [day_of_month] fields.`);
    }
    function b(A, O, k) {
      const T = C(A, O, k), I = t.FIELD_INFO[O];
      if (T < I.min)
        throw p(A, `Value [${k}] out of range for field [${O}]. It must be greater than or equals to [${I.min}].`);
      if (I.max && T > I.max)
        throw p(A, `Value [${k}] out of range for field [${O}]. It must be less than or equals to [${I.max}].`);
      return T;
    }
    function _(A, O, k) {
      const T = k.split(l);
      if (T.length != 2)
        throw p(A, `Invalid step range [${k}] for field [${O}]. Expected exactly 2 values separated by a / but got [${T.length}] values.`);
      const I = t.FIELD_INFO[O], j = T[0].indexOf(a) >= 0 ? T[0].split(a) : [T[0]], z = j[0] === s ? I.min : C(A, O, R(O, j[0])), $ = j.length > 1 ? C(A, O, R(O, j[1])) : I.max, D = C(A, O, R(O, T[1]));
      if (z < I.min)
        throw p(A, `Invalid step range [${k}] for field [${O}]. From value [${z}] out of range. It must be greater than or equals to [${I.min}]`);
      if ($ > I.max)
        throw p(A, `Invalid step range [${k}] for field [${O}]. To value [${$}] out of range. It must be less than or equals to [${I.max}]`);
      if (D > I.max)
        throw p(A, `Invalid step range [${k}] for field [${O}]. Step value [${k}] out of range. It must be less than or equals to [${I.max}]`);
      return { from: z, to: $, step: D };
    }
    function w(A, O, k) {
      if (O !== "day_of_week")
        throw p(A, `Invalid value [${k}] for field [${O}]. Nth day can be used only in [day_of_week] field.`);
      const T = k.split(i);
      if (T.length !== 2)
        throw p(A, `Invalid nth day value [${k}] for field [${O}]. It must be in [day_of_week#instance] format.`);
      const I = C(A, O, T[0]), j = C(A, void 0, T[1]);
      if (j < 1 || j > 5)
        throw p(A, `Invalid Day of Week instance value [${j}] for field [${O}]. It must be between 1 and 5.`);
      return {
        day_of_week: I,
        instance: j
      };
    }
    function x(A, O, k) {
      if (O !== "day_of_month")
        throw p(A, `Invalid value [${k}] for field [${O}]. Nearest weekday can be used only in [day_of_month] field.`);
      return C(A, O, k.split(n)[0]);
    }
    function E(A, O, k) {
      return C(A, O, k.split(e)[0]);
    }
    function S(A, O, k) {
      const T = k.split(a);
      if (T.length != 2)
        throw p(A, `Invalid range [${k}] for field [${O}]. Range should have two values separated by a - but got [${T.length}] values.`);
      const I = C(A, O, R(O, T[0]));
      let j = C(A, O, R(O, T[1]));
      if (O == "day_of_week" && j === 0 && (j = 7), I >= j)
        throw p(A, `Invalid range [${k}] for field [${O}]. From value must be less than to value.`);
      const z = t.FIELD_INFO[O];
      if (I < z.min || j > z.max)
        throw p(A, `Invalid range [${k}] for field [${O}]. From or to value is out of allowed min/max values. Allowed values are between [${z.min}-${z.max}].`);
      return { from: I, to: j };
    }
    function C(A, O, k) {
      const T = parseInt(R(O, k), 10);
      if (Number.isNaN(T))
        throw p(A, `Invalid numeric value [${k}] in field [${O}].`);
      return T;
    }
    function R(A, O) {
      if (!A)
        return O;
      const k = (t.FIELD_INFO[A].alias || {})[O];
      return k === void 0 ? O : k.toString();
    }
    function P(A, O) {
      if (!A)
        throw new Error("Cron expression cannot be blank");
      let k = A, T = O.hasSeconds;
      c[k] && (k = c[A], T = !1);
      const I = T ? 5 : 4, j = T ? 7 : 6, z = k.split(/\s+/).map((U) => U.trim()).filter((U) => U);
      if (z.length < I || z.length > j)
        throw new Error(`Invalid cron expression [${A}]. Expected [${I} to ${j}] fields but found [${z.length}] fields.`);
      T || z.unshift("0"), z.length === 5 && z.push(o), z.length === 6 && z.push(s);
      const $ = {};
      for (let U = 0; U < u.length; U++)
        $[u[U]] = z[U];
      const D = {};
      for (const U of u)
        U === "second" && !T ? D[U] = { omit: !0 } : D[U] = m(A, U, $[U]);
      return D;
    }
    function N(A, O = {}) {
      if (!A)
        throw new Error("Cron expression cannot be blank");
      return O.hasSeconds = d(O.hasSeconds), {
        pattern: A,
        expressions: h(A, "|").map((k) => P(k, O))
      };
    }
    t.parse = N;
  }(QF)), QF;
}
var JF;
function $3e() {
  return JF || (JF = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.parse = void 0;
    var e = P3e();
    Object.defineProperty(t, "parse", { enumerable: !0, get: function() {
      return e.parse;
    } });
  }(XF)), XF;
}
$3e();
var e7 = { exports: {} }, t7;
function M3e() {
  return t7 || (t7 = 1, function(t, e) {
    (function(n, r) {
      t.exports = r();
    })(globalThis, () => (
      /******/
      (() => {
        var n = {
          /***/
          949: (
            /***/
            (s, a, l) => {
              Object.defineProperty(a, "__esModule", { value: !0 }), a.CronParser = void 0;
              var c = l(515), u = function() {
                function d(f, h, p) {
                  h === void 0 && (h = !0), p === void 0 && (p = !1), this.expression = f, this.dayOfWeekStartIndexZero = h, this.monthStartIndexZero = p;
                }
                return d.prototype.parse = function() {
                  var f, h, p = (f = this.expression) !== null && f !== void 0 ? f : "";
                  if (p === "@reboot")
                    return h = ["@reboot", "", "", "", "", "", ""], h;
                  if (p.startsWith("@")) {
                    var m = this.parseSpecial(this.expression);
                    h = this.extractParts(m);
                  } else
                    h = this.extractParts(this.expression);
                  return this.normalize(h), this.validate(h), h;
                }, d.prototype.parseSpecial = function(f) {
                  var h = {
                    "@yearly": "0 0 1 1 *",
                    "@annually": "0 0 1 1 *",
                    "@monthly": "0 0 1 * *",
                    "@weekly": "0 0 * * 0",
                    "@daily": "0 0 * * *",
                    "@midnight": "0 0 * * *",
                    "@hourly": "0 * * * *",
                    "@reboot": "@reboot"
                  }, p = h[f];
                  if (!p)
                    throw new Error("Unknown special expression.");
                  return p;
                }, d.prototype.extractParts = function(f) {
                  if (!this.expression)
                    throw new Error("cron expression is empty");
                  for (var h = f.trim().split(/[ ]+/), p = 0; p < h.length; p++)
                    if (h[p].includes(",")) {
                      var m = h[p].split(",").map(function(y) {
                        return y.trim();
                      }).filter(function(y) {
                        return y !== "";
                      }).map(function(y) {
                        return isNaN(Number(y)) ? y : Number(y);
                      }).filter(function(y) {
                        return y !== null && y !== "";
                      });
                      m.length === 0 && m.push("*"), m.sort(function(y, v) {
                        return y !== null && v !== null ? y - v : 0;
                      }), h[p] = m.map(function(y) {
                        return y !== null ? y.toString() : "";
                      }).join(",");
                    }
                  if (h.length < 5)
                    throw new Error("Expression has only ".concat(h.length, " part").concat(h.length == 1 ? "" : "s", ". At least 5 parts are required."));
                  if (h.length == 5)
                    h.unshift(""), h.push("");
                  else if (h.length == 6) {
                    var g = /\d{4}$/.test(h[5]) || h[4] == "?" || h[2] == "?";
                    g ? h.unshift("") : h.push("");
                  } else if (h.length > 7)
                    throw new Error("Expression has ".concat(h.length, " parts; too many!"));
                  return h;
                }, d.prototype.normalize = function(f) {
                  var h = this;
                  if (f[3] = f[3].replace("?", "*"), f[5] = f[5].replace("?", "*"), f[2] = f[2].replace("?", "*"), f[0].indexOf("0/") == 0 && (f[0] = f[0].replace("0/", "*/")), f[1].indexOf("0/") == 0 && (f[1] = f[1].replace("0/", "*/")), f[2].indexOf("0/") == 0 && (f[2] = f[2].replace("0/", "*/")), f[3].indexOf("1/") == 0 && (f[3] = f[3].replace("1/", "*/")), f[4].indexOf("1/") == 0 && (f[4] = f[4].replace("1/", "*/")), f[6].indexOf("1/") == 0 && (f[6] = f[6].replace("1/", "*/")), f[5] = f[5].replace(/(^\d)|([^#/\s]\d)/g, function(w) {
                    var x = w.replace(/\D/, ""), E = x;
                    return h.dayOfWeekStartIndexZero ? x == "7" && (E = "0") : E = (parseInt(x) - 1).toString(), w.replace(x, E);
                  }), f[5] == "L" && (f[5] = "6"), f[3] == "?" && (f[3] = "*"), f[3].indexOf("W") > -1 && (f[3].indexOf(",") > -1 || f[3].indexOf("-") > -1))
                    throw new Error("The 'W' character can be specified only when the day-of-month is a single day, not a range or list of days.");
                  var p = {
                    SUN: 0,
                    MON: 1,
                    TUE: 2,
                    WED: 3,
                    THU: 4,
                    FRI: 5,
                    SAT: 6
                  };
                  for (var m in p)
                    f[5] = f[5].replace(new RegExp(m, "gi"), p[m].toString());
                  f[4] = f[4].replace(/(^\d{1,2})|([^#/\s]\d{1,2})/g, function(w) {
                    var x = w.replace(/\D/, ""), E = x;
                    return h.monthStartIndexZero && (E = (parseInt(x) + 1).toString()), w.replace(x, E);
                  });
                  var g = {
                    JAN: 1,
                    FEB: 2,
                    MAR: 3,
                    APR: 4,
                    MAY: 5,
                    JUN: 6,
                    JUL: 7,
                    AUG: 8,
                    SEP: 9,
                    OCT: 10,
                    NOV: 11,
                    DEC: 12
                  };
                  for (var y in g)
                    f[4] = f[4].replace(new RegExp(y, "gi"), g[y].toString());
                  f[0] == "0" && (f[0] = ""), !/\*|\-|\,|\//.test(f[2]) && (/\*|\//.test(f[1]) || /\*|\//.test(f[0])) && (f[2] += "-".concat(f[2]));
                  for (var v = 0; v < f.length; v++)
                    if (f[v].indexOf(",") != -1 && (f[v] = f[v].split(",").filter(function(w) {
                      return w !== "";
                    }).join(",") || "*"), f[v] == "*/1" && (f[v] = "*"), f[v].indexOf("/") > -1 && !/^\*|\-|\,/.test(f[v])) {
                      var b = null;
                      switch (v) {
                        case 4:
                          b = "12";
                          break;
                        case 5:
                          b = "6";
                          break;
                        case 6:
                          b = "9999";
                          break;
                        default:
                          b = null;
                          break;
                      }
                      if (b !== null) {
                        var _ = f[v].split("/");
                        f[v] = "".concat(_[0], "-").concat(b, "/").concat(_[1]);
                      }
                    }
                }, d.prototype.validate = function(f) {
                  var h = "0-9,\\-*/";
                  this.validateOnlyExpectedCharactersFound(f[0], h), this.validateOnlyExpectedCharactersFound(f[1], h), this.validateOnlyExpectedCharactersFound(f[2], h), this.validateOnlyExpectedCharactersFound(f[3], "0-9,\\-*/LW"), this.validateOnlyExpectedCharactersFound(f[4], h), this.validateOnlyExpectedCharactersFound(f[5], "0-9,\\-*/L#"), this.validateOnlyExpectedCharactersFound(f[6], h), this.validateAnyRanges(f);
                }, d.prototype.validateAnyRanges = function(f) {
                  c.default.secondRange(f[0]), c.default.minuteRange(f[1]), c.default.hourRange(f[2]), c.default.dayOfMonthRange(f[3]), c.default.monthRange(f[4], this.monthStartIndexZero), c.default.dayOfWeekRange(f[5], this.dayOfWeekStartIndexZero);
                }, d.prototype.validateOnlyExpectedCharactersFound = function(f, h) {
                  var p = f.match(new RegExp("[^".concat(h, "]+"), "gi"));
                  if (p && p.length)
                    throw new Error("Expression contains invalid values: '".concat(p.toString(), "'"));
                }, d;
              }();
              a.CronParser = u;
            }
          ),
          /***/
          333: (
            /***/
            (s, a, l) => {
              Object.defineProperty(a, "__esModule", { value: !0 }), a.ExpressionDescriptor = void 0;
              var c = l(823), u = l(949), d = function() {
                function f(h, p) {
                  if (this.expression = h, this.options = p, this.expressionParts = new Array(5), !this.options.locale && f.defaultLocale && (this.options.locale = f.defaultLocale), !f.locales[this.options.locale]) {
                    var m = Object.keys(f.locales)[0];
                    console.warn("Locale '".concat(this.options.locale, "' could not be found; falling back to '").concat(m, "'.")), this.options.locale = m;
                  }
                  this.i18n = f.locales[this.options.locale], p.use24HourTimeFormat === void 0 && (p.use24HourTimeFormat = this.i18n.use24HourTimeFormatByDefault());
                }
                return f.toString = function(h, p) {
                  var m = p === void 0 ? {} : p, g = m.throwExceptionOnParseError, y = g === void 0 ? !0 : g, v = m.verbose, b = v === void 0 ? !1 : v, _ = m.dayOfWeekStartIndexZero, w = _ === void 0 ? !0 : _, x = m.monthStartIndexZero, E = x === void 0 ? !1 : x, S = m.use24HourTimeFormat, C = m.locale, R = C === void 0 ? null : C, P = m.logicalAndDayFields, N = P === void 0 ? !1 : P, A = {
                    throwExceptionOnParseError: y,
                    verbose: b,
                    dayOfWeekStartIndexZero: w,
                    monthStartIndexZero: E,
                    use24HourTimeFormat: S,
                    locale: R,
                    logicalAndDayFields: N
                  };
                  A.tzOffset && console.warn("'tzOffset' option has been deprecated and is no longer supported.");
                  var O = new f(h, A);
                  return O.getFullDescription();
                }, f.initialize = function(h, p) {
                  p === void 0 && (p = "en"), f.specialCharacters = ["/", "-", ",", "*"], f.defaultLocale = p, h.load(f.locales);
                }, f.prototype.getFullDescription = function() {
                  var h, p, m = "";
                  try {
                    var g = new u.CronParser(this.expression, this.options.dayOfWeekStartIndexZero, this.options.monthStartIndexZero);
                    if (this.expressionParts = g.parse(), this.expressionParts[0] === "@reboot")
                      return ((p = (h = this.i18n).atReboot) === null || p === void 0 ? void 0 : p.call(h)) || "Run once, at startup";
                    var y = this.getTimeOfDayDescription(), v = this.getDayOfMonthDescription(), b = this.getMonthDescription(), _ = this.getDayOfWeekDescription(), w = this.getYearDescription();
                    m += y + v + _ + b + w, m = this.transformVerbosity(m, !!this.options.verbose), m = m.charAt(0).toLocaleUpperCase() + m.substr(1);
                  } catch (x) {
                    if (!this.options.throwExceptionOnParseError)
                      m = this.i18n.anErrorOccuredWhenGeneratingTheExpressionD();
                    else
                      throw "".concat(x);
                  }
                  return m;
                }, f.prototype.getTimeOfDayDescription = function() {
                  var h = this.expressionParts[0], p = this.expressionParts[1], m = this.expressionParts[2], g = "";
                  if (!c.StringUtilities.containsAny(p, f.specialCharacters) && !c.StringUtilities.containsAny(m, f.specialCharacters) && !c.StringUtilities.containsAny(h, f.specialCharacters))
                    g += this.i18n.atSpace() + this.formatTime(m, p, h);
                  else if (!h && p.indexOf("-") > -1 && !(p.indexOf(",") > -1) && !(p.indexOf("/") > -1) && !c.StringUtilities.containsAny(m, f.specialCharacters)) {
                    var y = p.split("-");
                    g += c.StringUtilities.format(this.i18n.everyMinuteBetweenX0AndX1(), this.formatTime(m, y[0], ""), this.formatTime(m, y[1], ""));
                  } else if (!h && m.indexOf(",") > -1 && m.indexOf("-") == -1 && m.indexOf("/") == -1 && !c.StringUtilities.containsAny(p, f.specialCharacters)) {
                    var v = m.split(",");
                    g += this.i18n.at();
                    for (var b = 0; b < v.length; b++)
                      g += " ", g += this.formatTime(v[b], p, ""), b < v.length - 2 && (g += ","), b == v.length - 2 && (g += this.i18n.spaceAnd());
                  } else {
                    var _ = this.getSecondsDescription(), w = this.getMinutesDescription(), x = this.getHoursDescription();
                    if (g += _, g && w && (g += ", "), g += w, w === x)
                      return g;
                    g && x && (g += ", "), g += x;
                  }
                  return g;
                }, f.prototype.getSecondsDescription = function() {
                  var h = this, p = this.getSegmentDescription(this.expressionParts[0], this.i18n.everySecond(), function(m) {
                    return m;
                  }, function(m) {
                    return c.StringUtilities.format(h.i18n.everyX0Seconds(m), m);
                  }, function(m) {
                    return h.i18n.secondsX0ThroughX1PastTheMinute();
                  }, function(m) {
                    return m == "0" ? "" : parseInt(m) < 20 ? h.i18n.atX0SecondsPastTheMinute(m) : h.i18n.atX0SecondsPastTheMinuteGt20() || h.i18n.atX0SecondsPastTheMinute(m);
                  });
                  return p;
                }, f.prototype.getMinutesDescription = function() {
                  var h = this, p = this.expressionParts[0], m = this.expressionParts[2], g = this.getSegmentDescription(this.expressionParts[1], this.i18n.everyMinute(), function(y) {
                    return y;
                  }, function(y) {
                    return c.StringUtilities.format(h.i18n.everyX0Minutes(y), y);
                  }, function(y) {
                    return h.i18n.minutesX0ThroughX1PastTheHour();
                  }, function(y) {
                    try {
                      return y == "0" && m.indexOf("/") == -1 && p == "" ? h.i18n.everyHour() : parseInt(y) < 20 ? h.i18n.atX0MinutesPastTheHour(y) : h.i18n.atX0MinutesPastTheHourGt20() || h.i18n.atX0MinutesPastTheHour(y);
                    } catch {
                      return h.i18n.atX0MinutesPastTheHour(y);
                    }
                  });
                  return g;
                }, f.prototype.getHoursDescription = function() {
                  var h = this, p = this.expressionParts[2], m = 0, g = [];
                  p.split("/")[0].split(",").forEach(function(b) {
                    var _ = b.split("-");
                    _.length === 2 && g.push({ value: _[1], index: m + 1 }), m += _.length;
                  });
                  var y = 0, v = this.getSegmentDescription(p, this.i18n.everyHour(), function(b) {
                    var _ = g.find(function(x) {
                      return x.value === b && x.index === y;
                    }), w = _ && h.expressionParts[1] !== "0";
                    return y++, w ? h.formatTime(b, "59", "") : h.formatTime(b, "0", "");
                  }, function(b) {
                    return c.StringUtilities.format(h.i18n.everyX0Hours(b), b);
                  }, function(b) {
                    return h.i18n.betweenX0AndX1();
                  }, function(b) {
                    return h.i18n.atX0();
                  });
                  return v;
                }, f.prototype.getDayOfWeekDescription = function() {
                  var h = this, p = this.i18n.daysOfTheWeek(), m = null;
                  return this.expressionParts[5] == "*" ? m = "" : m = this.getSegmentDescription(this.expressionParts[5], this.i18n.commaEveryDay(), function(g, y) {
                    var v = g;
                    g.indexOf("#") > -1 ? v = g.substring(0, g.indexOf("#")) : g.indexOf("L") > -1 && (v = v.replace("L", ""));
                    var b = parseInt(v), _ = h.i18n.daysOfTheWeekInCase ? h.i18n.daysOfTheWeekInCase(y)[b] : p[b];
                    if (g.indexOf("#") > -1) {
                      var w = null, x = g.substring(g.indexOf("#") + 1), E = g.substring(0, g.indexOf("#"));
                      switch (x) {
                        case "1":
                          w = h.i18n.first(E);
                          break;
                        case "2":
                          w = h.i18n.second(E);
                          break;
                        case "3":
                          w = h.i18n.third(E);
                          break;
                        case "4":
                          w = h.i18n.fourth(E);
                          break;
                        case "5":
                          w = h.i18n.fifth(E);
                          break;
                      }
                      _ = w + " " + _;
                    }
                    return _;
                  }, function(g) {
                    return parseInt(g) == 1 ? "" : c.StringUtilities.format(h.i18n.commaEveryX0DaysOfTheWeek(g), g);
                  }, function(g) {
                    var y = g.substring(0, g.indexOf("-")), v = h.expressionParts[3] != "*";
                    return v ? h.i18n.commaAndX0ThroughX1(y) : h.i18n.commaX0ThroughX1(y);
                  }, function(g) {
                    var y = null;
                    if (g.indexOf("#") > -1) {
                      var v = g.substring(g.indexOf("#") + 1), b = g.substring(0, g.indexOf("#"));
                      y = h.i18n.commaOnThe(v, b).trim() + h.i18n.spaceX0OfTheMonth();
                    } else if (g.indexOf("L") > -1)
                      y = h.i18n.commaOnTheLastX0OfTheMonth(g.replace("L", ""));
                    else {
                      var _ = h.expressionParts[3] != "*";
                      _ ? h.options.logicalAndDayFields ? y = h.i18n.commaOnlyOnX0(g) : y = h.i18n.commaAndOnX0() : y = h.i18n.commaOnlyOnX0(g);
                    }
                    return y;
                  }), m;
                }, f.prototype.getMonthDescription = function() {
                  var h = this, p = this.i18n.monthsOfTheYear(), m = this.getSegmentDescription(this.expressionParts[4], "", function(g, y) {
                    return y && h.i18n.monthsOfTheYearInCase ? h.i18n.monthsOfTheYearInCase(y)[parseInt(g) - 1] : p[parseInt(g) - 1];
                  }, function(g) {
                    return parseInt(g) == 1 ? "" : c.StringUtilities.format(h.i18n.commaEveryX0Months(g), g);
                  }, function(g) {
                    return h.i18n.commaMonthX0ThroughMonthX1() || h.i18n.commaX0ThroughX1();
                  }, function(g) {
                    return h.i18n.commaOnlyInMonthX0 ? h.i18n.commaOnlyInMonthX0() : h.i18n.commaOnlyInX0();
                  });
                  return m;
                }, f.prototype.getDayOfMonthDescription = function() {
                  var h = this, p = null, m = this.expressionParts[3];
                  switch (m) {
                    case "L":
                      p = this.i18n.commaOnTheLastDayOfTheMonth();
                      break;
                    case "WL":
                    case "LW":
                      p = this.i18n.commaOnTheLastWeekdayOfTheMonth();
                      break;
                    default:
                      var g = m.match(/(\d{1,2}W)|(W\d{1,2})/);
                      if (g) {
                        var y = parseInt(g[0].replace("W", "")), v = y == 1 ? this.i18n.firstWeekday() : c.StringUtilities.format(this.i18n.weekdayNearestDayX0(), y.toString());
                        p = c.StringUtilities.format(this.i18n.commaOnTheX0OfTheMonth(), v);
                        break;
                      } else {
                        var b = m.match(/L-(\d{1,2})/);
                        if (b) {
                          var _ = b[1];
                          p = c.StringUtilities.format(this.i18n.commaDaysBeforeTheLastDayOfTheMonth(_), _);
                          break;
                        } else {
                          if (m == "*" && this.expressionParts[5] != "*")
                            return "";
                          p = this.getSegmentDescription(m, this.i18n.commaEveryDay(), function(w) {
                            return w == "L" ? h.i18n.lastDay() : h.i18n.dayX0 ? c.StringUtilities.format(h.i18n.dayX0(), w) : w;
                          }, function(w) {
                            return w == "1" ? h.i18n.commaEveryDay() : h.i18n.commaEveryX0Days(w);
                          }, function(w) {
                            return h.i18n.commaBetweenDayX0AndX1OfTheMonth(w);
                          }, function(w) {
                            return h.i18n.commaOnDayX0OfTheMonth(w);
                          });
                        }
                        break;
                      }
                  }
                  return p;
                }, f.prototype.getYearDescription = function() {
                  var h = this, p = this.getSegmentDescription(this.expressionParts[6], "", function(m) {
                    return /^\d+$/.test(m) ? new Date(parseInt(m), 1).getFullYear().toString() : m;
                  }, function(m) {
                    return c.StringUtilities.format(h.i18n.commaEveryX0Years(m), m);
                  }, function(m) {
                    return h.i18n.commaYearX0ThroughYearX1() || h.i18n.commaX0ThroughX1();
                  }, function(m) {
                    return h.i18n.commaOnlyInYearX0 ? h.i18n.commaOnlyInYearX0() : h.i18n.commaOnlyInX0();
                  });
                  return p;
                }, f.prototype.getSegmentDescription = function(h, p, m, g, y, v) {
                  var b = null, _ = h.indexOf("/") > -1, w = h.indexOf("-") > -1, x = h.indexOf(",") > -1;
                  if (!h)
                    b = "";
                  else if (h === "*")
                    b = p;
                  else if (!_ && !w && !x)
                    b = c.StringUtilities.format(v(h), m(h));
                  else if (x) {
                    for (var E = h.split(","), S = "", C = 0; C < E.length; C++)
                      if (C > 0 && E.length > 2 && (S += ",", C < E.length - 1 && (S += " ")), C > 0 && E.length > 1 && (C == E.length - 1 || E.length == 2) && (S += "".concat(this.i18n.spaceAnd(), " ")), E[C].indexOf("/") > -1 || E[C].indexOf("-") > -1) {
                        var R = E[C].indexOf("-") > -1 && E[C].indexOf("/") == -1, P = this.getSegmentDescription(E[C], p, m, g, R ? this.i18n.commaX0ThroughX1 : y, v);
                        R && (P = P.replace(", ", "")), S += P;
                      } else _ ? S += this.getSegmentDescription(E[C], p, m, g, y, v) : S += m(E[C]);
                    _ ? b = S : b = c.StringUtilities.format(v(h), S);
                  } else if (_) {
                    var E = h.split("/");
                    if (b = c.StringUtilities.format(g(E[1]), E[1]), E[0].indexOf("-") > -1) {
                      var N = this.generateRangeSegmentDescription(E[0], y, m);
                      N.indexOf(", ") != 0 && (b += ", "), b += N;
                    } else if (E[0].indexOf("*") == -1) {
                      var A = c.StringUtilities.format(v(E[0]), m(E[0]));
                      A = A.replace(", ", ""), b += c.StringUtilities.format(this.i18n.commaStartingX0(), A);
                    }
                  } else w && (b = this.generateRangeSegmentDescription(h, y, m));
                  return b;
                }, f.prototype.generateRangeSegmentDescription = function(h, p, m) {
                  var g = "", y = h.split("-"), v = m(y[0], 1), b = m(y[1], 2), _ = p(h);
                  return g += c.StringUtilities.format(_, v, b), g;
                }, f.prototype.formatTime = function(h, p, m) {
                  var g = 0, y = 0, v = parseInt(h) + g, b = parseInt(p) + y;
                  b >= 60 ? (b -= 60, v += 1) : b < 0 && (b += 60, v -= 1), v >= 24 ? v = v - 24 : v < 0 && (v = 24 + v);
                  var _ = "", w = !1;
                  this.options.use24HourTimeFormat || (w = !!(this.i18n.setPeriodBeforeTime && this.i18n.setPeriodBeforeTime()), _ = w ? "".concat(this.getPeriod(v), " ") : " ".concat(this.getPeriod(v)), v > 12 && (v -= 12), v === 0 && (v = 12));
                  var x = "";
                  return m && (x = ":".concat(("00" + m).substring(m.length))), "".concat(w ? _ : "").concat(("00" + v.toString()).substring(v.toString().length), ":").concat(("00" + b.toString()).substring(b.toString().length)).concat(x).concat(w ? "" : _);
                }, f.prototype.transformVerbosity = function(h, p) {
                  if (!p && (h = h.replace(new RegExp(", ".concat(this.i18n.everyMinute()), "g"), ""), h = h.replace(new RegExp(", ".concat(this.i18n.everyHour()), "g"), ""), h = h.replace(new RegExp(this.i18n.commaEveryDay(), "g"), ""), h = h.replace(/\, ?$/, ""), this.i18n.conciseVerbosityReplacements))
                    for (var m = 0, g = Object.entries(this.i18n.conciseVerbosityReplacements()); m < g.length; m++) {
                      var y = g[m], v = y[0], b = y[1];
                      h = h.replace(new RegExp(v, "g"), b);
                    }
                  return h;
                }, f.prototype.getPeriod = function(h) {
                  return h >= 12 ? this.i18n.pm && this.i18n.pm() || "PM" : this.i18n.am && this.i18n.am() || "AM";
                }, f.locales = {}, f;
              }();
              a.ExpressionDescriptor = d;
            }
          ),
          /***/
          747: (
            /***/
            (s, a, l) => {
              Object.defineProperty(a, "__esModule", { value: !0 }), a.enLocaleLoader = void 0;
              var c = l(486), u = function() {
                function d() {
                }
                return d.prototype.load = function(f) {
                  f.en = new c.en();
                }, d;
              }();
              a.enLocaleLoader = u;
            }
          ),
          /***/
          486: (
            /***/
            (s, a) => {
              Object.defineProperty(a, "__esModule", { value: !0 }), a.en = void 0;
              var l = function() {
                function c() {
                }
                return c.prototype.atX0SecondsPastTheMinuteGt20 = function() {
                  return null;
                }, c.prototype.atX0MinutesPastTheHourGt20 = function() {
                  return null;
                }, c.prototype.commaMonthX0ThroughMonthX1 = function() {
                  return null;
                }, c.prototype.commaYearX0ThroughYearX1 = function() {
                  return null;
                }, c.prototype.use24HourTimeFormatByDefault = function() {
                  return !1;
                }, c.prototype.anErrorOccuredWhenGeneratingTheExpressionD = function() {
                  return "An error occurred when generating the expression description. Check the cron expression syntax.";
                }, c.prototype.everyMinute = function() {
                  return "every minute";
                }, c.prototype.everyHour = function() {
                  return "every hour";
                }, c.prototype.atSpace = function() {
                  return "At ";
                }, c.prototype.everyMinuteBetweenX0AndX1 = function() {
                  return "Every minute between %s and %s";
                }, c.prototype.at = function() {
                  return "At";
                }, c.prototype.spaceAnd = function() {
                  return " and";
                }, c.prototype.everySecond = function() {
                  return "every second";
                }, c.prototype.everyX0Seconds = function() {
                  return "every %s seconds";
                }, c.prototype.secondsX0ThroughX1PastTheMinute = function() {
                  return "seconds %s through %s past the minute";
                }, c.prototype.atX0SecondsPastTheMinute = function() {
                  return "at %s seconds past the minute";
                }, c.prototype.everyX0Minutes = function() {
                  return "every %s minutes";
                }, c.prototype.minutesX0ThroughX1PastTheHour = function() {
                  return "minutes %s through %s past the hour";
                }, c.prototype.atX0MinutesPastTheHour = function() {
                  return "at %s minutes past the hour";
                }, c.prototype.everyX0Hours = function() {
                  return "every %s hours";
                }, c.prototype.betweenX0AndX1 = function() {
                  return "between %s and %s";
                }, c.prototype.atX0 = function() {
                  return "at %s";
                }, c.prototype.commaEveryDay = function() {
                  return ", every day";
                }, c.prototype.commaEveryX0DaysOfTheWeek = function() {
                  return ", every %s days of the week";
                }, c.prototype.commaX0ThroughX1 = function() {
                  return ", %s through %s";
                }, c.prototype.commaAndX0ThroughX1 = function() {
                  return ", %s through %s";
                }, c.prototype.first = function() {
                  return "first";
                }, c.prototype.second = function() {
                  return "second";
                }, c.prototype.third = function() {
                  return "third";
                }, c.prototype.fourth = function() {
                  return "fourth";
                }, c.prototype.fifth = function() {
                  return "fifth";
                }, c.prototype.commaOnThe = function() {
                  return ", on the ";
                }, c.prototype.spaceX0OfTheMonth = function() {
                  return " %s of the month";
                }, c.prototype.lastDay = function() {
                  return "the last day";
                }, c.prototype.commaOnTheLastX0OfTheMonth = function() {
                  return ", on the last %s of the month";
                }, c.prototype.commaOnlyOnX0 = function() {
                  return ", only on %s";
                }, c.prototype.commaAndOnX0 = function() {
                  return ", and on %s";
                }, c.prototype.commaEveryX0Months = function() {
                  return ", every %s months";
                }, c.prototype.commaOnlyInX0 = function() {
                  return ", only in %s";
                }, c.prototype.commaOnTheLastDayOfTheMonth = function() {
                  return ", on the last day of the month";
                }, c.prototype.commaOnTheLastWeekdayOfTheMonth = function() {
                  return ", on the last weekday of the month";
                }, c.prototype.commaDaysBeforeTheLastDayOfTheMonth = function() {
                  return ", %s days before the last day of the month";
                }, c.prototype.firstWeekday = function() {
                  return "first weekday";
                }, c.prototype.weekdayNearestDayX0 = function() {
                  return "weekday nearest day %s";
                }, c.prototype.commaOnTheX0OfTheMonth = function() {
                  return ", on the %s of the month";
                }, c.prototype.commaEveryX0Days = function() {
                  return ", every %s days";
                }, c.prototype.commaBetweenDayX0AndX1OfTheMonth = function() {
                  return ", between day %s and %s of the month";
                }, c.prototype.commaOnDayX0OfTheMonth = function() {
                  return ", on day %s of the month";
                }, c.prototype.commaEveryHour = function() {
                  return ", every hour";
                }, c.prototype.commaEveryX0Years = function() {
                  return ", every %s years";
                }, c.prototype.commaStartingX0 = function() {
                  return ", starting %s";
                }, c.prototype.daysOfTheWeek = function() {
                  return ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
                }, c.prototype.monthsOfTheYear = function() {
                  return [
                    "January",
                    "February",
                    "March",
                    "April",
                    "May",
                    "June",
                    "July",
                    "August",
                    "September",
                    "October",
                    "November",
                    "December"
                  ];
                }, c.prototype.atReboot = function() {
                  return "Run once, at startup";
                }, c;
              }();
              a.en = l;
            }
          ),
          /***/
          515: (
            /***/
            (s, a) => {
              Object.defineProperty(a, "__esModule", { value: !0 });
              function l(u, d) {
                if (!u)
                  throw new Error(d);
              }
              var c = function() {
                function u() {
                }
                return u.secondRange = function(d) {
                  for (var f = d.split(","), h = 0; h < f.length; h++)
                    if (!isNaN(parseInt(f[h], 10))) {
                      var p = parseInt(f[h], 10);
                      l(p >= 0 && p <= 59, "seconds part must be >= 0 and <= 59");
                    }
                }, u.minuteRange = function(d) {
                  for (var f = d.split(","), h = 0; h < f.length; h++)
                    if (!isNaN(parseInt(f[h], 10))) {
                      var p = parseInt(f[h], 10);
                      l(p >= 0 && p <= 59, "minutes part must be >= 0 and <= 59");
                    }
                }, u.hourRange = function(d) {
                  for (var f = d.split(","), h = 0; h < f.length; h++)
                    if (!isNaN(parseInt(f[h], 10))) {
                      var p = parseInt(f[h], 10);
                      l(p >= 0 && p <= 23, "hours part must be >= 0 and <= 23");
                    }
                }, u.dayOfMonthRange = function(d) {
                  for (var f = d.split(","), h = 0; h < f.length; h++)
                    if (!isNaN(parseInt(f[h], 10))) {
                      var p = parseInt(f[h], 10);
                      l(p >= 1 && p <= 31, "DOM part must be >= 1 and <= 31");
                    }
                }, u.monthRange = function(d, f) {
                  for (var h = d.split(","), p = 0; p < h.length; p++)
                    if (!isNaN(parseInt(h[p], 10))) {
                      var m = parseInt(h[p], 10);
                      l(m >= 1 && m <= 12, f ? "month part must be >= 0 and <= 11" : "month part must be >= 1 and <= 12");
                    }
                }, u.dayOfWeekRange = function(d, f) {
                  for (var h = d.split(","), p = 0; p < h.length; p++)
                    if (!isNaN(parseInt(h[p], 10))) {
                      var m = parseInt(h[p], 10);
                      l(m >= 0 && m <= 6, f ? "DOW part must be >= 0 and <= 6" : "DOW part must be >= 1 and <= 7");
                    }
                }, u;
              }();
              a.default = c;
            }
          ),
          /***/
          823: (
            /***/
            (s, a) => {
              Object.defineProperty(a, "__esModule", { value: !0 }), a.StringUtilities = void 0;
              var l = function() {
                function c() {
                }
                return c.format = function(u) {
                  for (var d = [], f = 1; f < arguments.length; f++)
                    d[f - 1] = arguments[f];
                  return u.replace(/%s/g, function(h) {
                    return d.shift();
                  });
                }, c.containsAny = function(u, d) {
                  return d.some(function(f) {
                    return u.indexOf(f) > -1;
                  });
                }, c;
              }();
              a.StringUtilities = l;
            }
          )
          /******/
        }, r = {};
        function o(s) {
          var a = r[s];
          if (a !== void 0)
            return a.exports;
          var l = r[s] = {
            /******/
            // no module.id needed
            /******/
            // no module.loaded needed
            /******/
            exports: {}
            /******/
          };
          return n[s](l, l.exports, o), l.exports;
        }
        var i = {};
        return (() => {
          var s = i;
          Object.defineProperty(s, "__esModule", { value: !0 }), s.toString = void 0;
          var a = o(333), l = o(747);
          a.ExpressionDescriptor.initialize(new l.enLocaleLoader()), s.default = a.ExpressionDescriptor;
          var c = a.ExpressionDescriptor.toString;
          s.toString = c;
        })(), i;
      })()
    ));
  }(e7)), e7.exports;
}
M3e();
var fI = function(t, e) {
  return fI = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, r) {
    n.__proto__ = r;
  } || function(n, r) {
    for (var o in r) Object.prototype.hasOwnProperty.call(r, o) && (n[o] = r[o]);
  }, fI(t, e);
};
function cce(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
  fI(t, e);
  function n() {
    this.constructor = t;
  }
  t.prototype = e === null ? Object.create(e) : (n.prototype = e.prototype, new n());
}
var Ve = function() {
  return Ve = Object.assign || function(t) {
    for (var e, n = 1, r = arguments.length; n < r; n++) {
      e = arguments[n];
      for (var o in e) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
    }
    return t;
  }, Ve.apply(this, arguments);
};
function ss(t, e) {
  var n = {};
  for (var r in t) Object.prototype.hasOwnProperty.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(t); o < r.length; o++)
      e.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(t, r[o]) && (n[r[o]] = t[r[o]]);
  return n;
}
function D3e(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, n = e && t[e], r = 0;
  if (n) return n.call(t);
  if (t && typeof t.length == "number") return {
    next: function() {
      return t && r >= t.length && (t = void 0), { value: t && t[r++], done: !t };
    }
  };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function hr(t, e) {
  var n = typeof Symbol == "function" && t[Symbol.iterator];
  if (!n) return t;
  var r = n.call(t), o, i = [], s;
  try {
    for (; (e === void 0 || e-- > 0) && !(o = r.next()).done; ) i.push(o.value);
  } catch (a) {
    s = { error: a };
  } finally {
    try {
      o && !o.done && (n = r.return) && n.call(r);
    } finally {
      if (s) throw s.error;
    }
  }
  return i;
}
function Cs(t, e, n) {
  if (arguments.length === 2) for (var r = 0, o = e.length, i; r < o; r++)
    (i || !(r in e)) && (i || (i = Array.prototype.slice.call(e, 0, r)), i[r] = e[r]);
  return t.concat(i || Array.prototype.slice.call(e));
}
var lv = function() {
}, Zi = function() {
};
process.env.NODE_ENV !== "production" && (lv = function(t, e) {
  !t && typeof console < "u" && console.warn(e);
}, Zi = function(t, e) {
  if (!t)
    throw new Error(e);
});
const uce = (t, e) => (n) => Math.max(Math.min(n, e), t), Gg = (t) => t % 1 ? Number(t.toFixed(5)) : t, F0 = /(-)?([\d]*\.?[\d])+/g, hI = /(#[0-9a-f]{6}|#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))/gi, I3e = /^(#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))$/i;
function cv(t) {
  return typeof t == "string";
}
const Gd = {
  test: (t) => typeof t == "number",
  parse: parseFloat,
  transform: (t) => t
}, Yg = Object.assign(Object.assign({}, Gd), { transform: uce(0, 1) }), mb = Object.assign(Object.assign({}, Gd), { default: 1 }), uv = (t) => ({
  test: (e) => cv(e) && e.endsWith(t) && e.split(" ").length === 1,
  parse: parseFloat,
  transform: (e) => `${e}${t}`
}), hc = uv("deg"), va = uv("%"), vt = uv("px"), N3e = uv("vh"), j3e = uv("vw"), n7 = Object.assign(Object.assign({}, va), { parse: (t) => va.parse(t) / 100, transform: (t) => va.transform(t * 100) }), I5 = (t, e) => (n) => !!(cv(n) && I3e.test(n) && n.startsWith(t) || e && Object.prototype.hasOwnProperty.call(n, e)), dce = (t, e, n) => (r) => {
  if (!cv(r))
    return r;
  const [o, i, s, a] = r.match(F0);
  return {
    [t]: parseFloat(o),
    [e]: parseFloat(i),
    [n]: parseFloat(s),
    alpha: a !== void 0 ? parseFloat(a) : 1
  };
}, nd = {
  test: I5("hsl", "hue"),
  parse: dce("hue", "saturation", "lightness"),
  transform: ({ hue: t, saturation: e, lightness: n, alpha: r = 1 }) => "hsla(" + Math.round(t) + ", " + va.transform(Gg(e)) + ", " + va.transform(Gg(n)) + ", " + Gg(Yg.transform(r)) + ")"
}, L3e = uce(0, 255), MC = Object.assign(Object.assign({}, Gd), { transform: (t) => Math.round(L3e(t)) }), $c = {
  test: I5("rgb", "red"),
  parse: dce("red", "green", "blue"),
  transform: ({ red: t, green: e, blue: n, alpha: r = 1 }) => "rgba(" + MC.transform(t) + ", " + MC.transform(e) + ", " + MC.transform(n) + ", " + Gg(Yg.transform(r)) + ")"
};
function F3e(t) {
  let e = "", n = "", r = "", o = "";
  return t.length > 5 ? (e = t.substr(1, 2), n = t.substr(3, 2), r = t.substr(5, 2), o = t.substr(7, 2)) : (e = t.substr(1, 1), n = t.substr(2, 1), r = t.substr(3, 1), o = t.substr(4, 1), e += e, n += n, r += r, o += o), {
    red: parseInt(e, 16),
    green: parseInt(n, 16),
    blue: parseInt(r, 16),
    alpha: o ? parseInt(o, 16) / 255 : 1
  };
}
const pI = {
  test: I5("#"),
  parse: F3e,
  transform: $c.transform
}, Eo = {
  test: (t) => $c.test(t) || pI.test(t) || nd.test(t),
  parse: (t) => $c.test(t) ? $c.parse(t) : nd.test(t) ? nd.parse(t) : pI.parse(t),
  transform: (t) => cv(t) ? t : t.hasOwnProperty("red") ? $c.transform(t) : nd.transform(t)
}, fce = "${c}", hce = "${n}";
function B3e(t) {
  var e, n, r, o;
  return isNaN(t) && cv(t) && ((n = (e = t.match(F0)) === null || e === void 0 ? void 0 : e.length) !== null && n !== void 0 ? n : 0) + ((o = (r = t.match(hI)) === null || r === void 0 ? void 0 : r.length) !== null && o !== void 0 ? o : 0) > 0;
}
function pce(t) {
  typeof t == "number" && (t = `${t}`);
  const e = [];
  let n = 0;
  const r = t.match(hI);
  r && (n = r.length, t = t.replace(hI, fce), e.push(...r.map(Eo.parse)));
  const o = t.match(F0);
  return o && (t = t.replace(F0, hce), e.push(...o.map(Gd.parse))), { values: e, numColors: n, tokenised: t };
}
function mce(t) {
  return pce(t).values;
}
function gce(t) {
  const { values: e, numColors: n, tokenised: r } = pce(t), o = e.length;
  return (i) => {
    let s = r;
    for (let a = 0; a < o; a++)
      s = s.replace(a < n ? fce : hce, a < n ? Eo.transform(i[a]) : Gg(i[a]));
    return s;
  };
}
const z3e = (t) => typeof t == "number" ? 0 : t;
function q3e(t) {
  const e = mce(t);
  return gce(t)(e.map(z3e));
}
const Il = { test: B3e, parse: mce, createTransformer: gce, getAnimatableNone: q3e }, U3e = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function H3e(t) {
  let [e, n] = t.slice(0, -1).split("(");
  if (e === "drop-shadow")
    return t;
  const [r] = n.match(F0) || [];
  if (!r)
    return t;
  const o = n.replace(r, "");
  let i = U3e.has(e) ? 1 : 0;
  return r !== n && (i *= 100), e + "(" + i + o + ")";
}
const V3e = /([a-z-]*)\(.*?\)/g, mI = Object.assign(Object.assign({}, Il), { getAnimatableNone: (t) => {
  const e = t.match(V3e);
  return e ? e.map(H3e).join(" ") : t;
} }), ax = (t, e, n) => Math.min(Math.max(n, t), e), DC = 1e-3, W3e = 0.01, r7 = 10, G3e = 0.05, Y3e = 1;
function K3e({ duration: t = 800, bounce: e = 0.25, velocity: n = 0, mass: r = 1 }) {
  let o, i;
  lv(t <= r7 * 1e3, "Spring duration must be 10 seconds or less");
  let s = 1 - e;
  s = ax(G3e, Y3e, s), t = ax(W3e, r7, t / 1e3), s < 1 ? (o = (c) => {
    const u = c * s, d = u * t, f = u - n, h = gI(c, s), p = Math.exp(-d);
    return DC - f / h * p;
  }, i = (c) => {
    const u = c * s * t, d = u * n + n, f = Math.pow(s, 2) * Math.pow(c, 2) * t, h = Math.exp(-u), p = gI(Math.pow(c, 2), s);
    return (-o(c) + DC > 0 ? -1 : 1) * ((d - f) * h) / p;
  }) : (o = (c) => {
    const u = Math.exp(-c * t), d = (c - n) * t + 1;
    return -DC + u * d;
  }, i = (c) => {
    const u = Math.exp(-c * t), d = (n - c) * (t * t);
    return u * d;
  });
  const a = 5 / t, l = Q3e(o, i, a);
  if (t = t * 1e3, isNaN(l))
    return {
      stiffness: 100,
      damping: 10,
      duration: t
    };
  {
    const c = Math.pow(l, 2) * r;
    return {
      stiffness: c,
      damping: s * 2 * Math.sqrt(r * c),
      duration: t
    };
  }
}
const X3e = 12;
function Q3e(t, e, n) {
  let r = n;
  for (let o = 1; o < X3e; o++)
    r = r - t(r) / e(r);
  return r;
}
function gI(t, e) {
  return t * Math.sqrt(1 - e * e);
}
const Z3e = ["duration", "bounce"], J3e = ["stiffness", "damping", "mass"];
function o7(t, e) {
  return e.some((n) => t[n] !== void 0);
}
function e5e(t) {
  let e = Object.assign({ velocity: 0, stiffness: 100, damping: 10, mass: 1, isResolvedFromDuration: !1 }, t);
  if (!o7(t, J3e) && o7(t, Z3e)) {
    const n = K3e(t);
    e = Object.assign(Object.assign(Object.assign({}, e), n), { velocity: 0, mass: 1 }), e.isResolvedFromDuration = !0;
  }
  return e;
}
function N5(t) {
  var { from: e = 0, to: n = 1, restSpeed: r = 2, restDelta: o } = t, i = ss(t, ["from", "to", "restSpeed", "restDelta"]);
  const s = { done: !1, value: e };
  let { stiffness: a, damping: l, mass: c, velocity: u, duration: d, isResolvedFromDuration: f } = e5e(i), h = i7, p = i7;
  function m() {
    const g = u ? -(u / 1e3) : 0, y = n - e, v = l / (2 * Math.sqrt(a * c)), b = Math.sqrt(a / c) / 1e3;
    if (o === void 0 && (o = Math.min(Math.abs(n - e) / 100, 0.4)), v < 1) {
      const _ = gI(b, v);
      h = (w) => {
        const x = Math.exp(-v * b * w);
        return n - x * ((g + v * b * y) / _ * Math.sin(_ * w) + y * Math.cos(_ * w));
      }, p = (w) => {
        const x = Math.exp(-v * b * w);
        return v * b * x * (Math.sin(_ * w) * (g + v * b * y) / _ + y * Math.cos(_ * w)) - x * (Math.cos(_ * w) * (g + v * b * y) - _ * y * Math.sin(_ * w));
      };
    } else if (v === 1)
      h = (_) => n - Math.exp(-b * _) * (y + (g + b * y) * _);
    else {
      const _ = b * Math.sqrt(v * v - 1);
      h = (w) => {
        const x = Math.exp(-v * b * w), E = Math.min(_ * w, 300);
        return n - x * ((g + v * b * y) * Math.sinh(E) + _ * y * Math.cosh(E)) / _;
      };
    }
  }
  return m(), {
    next: (g) => {
      const y = h(g);
      if (f)
        s.done = g >= d;
      else {
        const v = p(g) * 1e3, b = Math.abs(v) <= r, _ = Math.abs(n - y) <= o;
        s.done = b && _;
      }
      return s.value = s.done ? n : y, s;
    },
    flipTarget: () => {
      u = -u, [e, n] = [n, e], m();
    }
  };
}
N5.needsInterpolation = (t, e) => typeof t == "string" || typeof e == "string";
const i7 = (t) => 0, B0 = (t, e, n) => {
  const r = e - t;
  return r === 0 ? 1 : (n - t) / r;
}, fr = (t, e, n) => -n * t + n * e + t;
function IC(t, e, n) {
  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? t + (e - t) * 6 * n : n < 1 / 2 ? e : n < 2 / 3 ? t + (e - t) * (2 / 3 - n) * 6 : t;
}
function s7({ hue: t, saturation: e, lightness: n, alpha: r }) {
  t /= 360, e /= 100, n /= 100;
  let o = 0, i = 0, s = 0;
  if (!e)
    o = i = s = n;
  else {
    const a = n < 0.5 ? n * (1 + e) : n + e - n * e, l = 2 * n - a;
    o = IC(l, a, t + 1 / 3), i = IC(l, a, t), s = IC(l, a, t - 1 / 3);
  }
  return {
    red: Math.round(o * 255),
    green: Math.round(i * 255),
    blue: Math.round(s * 255),
    alpha: r
  };
}
const t5e = (t, e, n) => {
  const r = t * t, o = e * e;
  return Math.sqrt(Math.max(0, n * (o - r) + r));
}, n5e = [pI, $c, nd], a7 = (t) => n5e.find((e) => e.test(t)), l7 = (t) => `'${t}' is not an animatable color. Use the equivalent color code instead.`, yce = (t, e) => {
  let n = a7(t), r = a7(e);
  Zi(!!n, l7(t)), Zi(!!r, l7(e));
  let o = n.parse(t), i = r.parse(e);
  n === nd && (o = s7(o), n = $c), r === nd && (i = s7(i), r = $c);
  const s = Object.assign({}, o);
  return (a) => {
    for (const l in s)
      l !== "alpha" && (s[l] = t5e(o[l], i[l], a));
    return s.alpha = fr(o.alpha, i.alpha, a), n.transform(s);
  };
}, yI = (t) => typeof t == "number", r5e = (t, e) => (n) => e(t(n)), gS = (...t) => t.reduce(r5e);
function vce(t, e) {
  return yI(t) ? (n) => fr(t, e, n) : Eo.test(t) ? yce(t, e) : _ce(t, e);
}
const bce = (t, e) => {
  const n = [...t], r = n.length, o = t.map((i, s) => vce(i, e[s]));
  return (i) => {
    for (let s = 0; s < r; s++)
      n[s] = o[s](i);
    return n;
  };
}, o5e = (t, e) => {
  const n = Object.assign(Object.assign({}, t), e), r = {};
  for (const o in n)
    t[o] !== void 0 && e[o] !== void 0 && (r[o] = vce(t[o], e[o]));
  return (o) => {
    for (const i in r)
      n[i] = r[i](o);
    return n;
  };
};
function c7(t) {
  const e = Il.parse(t), n = e.length;
  let r = 0, o = 0, i = 0;
  for (let s = 0; s < n; s++)
    r || typeof e[s] == "number" ? r++ : e[s].hue !== void 0 ? i++ : o++;
  return { parsed: e, numNumbers: r, numRGB: o, numHSL: i };
}
const _ce = (t, e) => {
  const n = Il.createTransformer(e), r = c7(t), o = c7(e);
  return r.numHSL === o.numHSL && r.numRGB === o.numRGB && r.numNumbers >= o.numNumbers ? gS(bce(r.parsed, o.parsed), n) : (lv(!0, `Complex values '${t}' and '${e}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`), (i) => `${i > 0 ? e : t}`);
}, i5e = (t, e) => (n) => fr(t, e, n);
function s5e(t) {
  if (typeof t == "number")
    return i5e;
  if (typeof t == "string")
    return Eo.test(t) ? yce : _ce;
  if (Array.isArray(t))
    return bce;
  if (typeof t == "object")
    return o5e;
}
function a5e(t, e, n) {
  const r = [], o = n || s5e(t[0]), i = t.length - 1;
  for (let s = 0; s < i; s++) {
    let a = o(t[s], t[s + 1]);
    if (e) {
      const l = Array.isArray(e) ? e[s] : e;
      a = gS(l, a);
    }
    r.push(a);
  }
  return r;
}
function l5e([t, e], [n]) {
  return (r) => n(B0(t, e, r));
}
function c5e(t, e) {
  const n = t.length, r = n - 1;
  return (o) => {
    let i = 0, s = !1;
    if (o <= t[0] ? s = !0 : o >= t[r] && (i = r - 1, s = !0), !s) {
      let l = 1;
      for (; l < n && !(t[l] > o || l === r); l++)
        ;
      i = l - 1;
    }
    const a = B0(t[i], t[i + 1], o);
    return e[i](a);
  };
}
function wce(t, e, { clamp: n = !0, ease: r, mixer: o } = {}) {
  const i = t.length;
  Zi(i === e.length, "Both input and output ranges must be the same length"), Zi(!r || !Array.isArray(r) || r.length === i - 1, "Array of easing functions must be of length `input.length - 1`, as it applies to the transitions **between** the defined values."), t[0] > t[i - 1] && (t = [].concat(t), e = [].concat(e), t.reverse(), e.reverse());
  const s = a5e(e, r, o), a = i === 2 ? l5e(t, s) : c5e(t, s);
  return n ? (l) => a(ax(t[0], t[i - 1], l)) : a;
}
const yS = (t) => (e) => 1 - t(1 - e), j5 = (t) => (e) => e <= 0.5 ? t(2 * e) / 2 : (2 - t(2 * (1 - e))) / 2, u5e = (t) => (e) => Math.pow(e, t), xce = (t) => (e) => e * e * ((t + 1) * e - t), d5e = (t) => {
  const e = xce(t);
  return (n) => (n *= 2) < 1 ? 0.5 * e(n) : 0.5 * (2 - Math.pow(2, -10 * (n - 1)));
}, Ece = 1.525, f5e = 4 / 11, h5e = 8 / 11, p5e = 9 / 10, L5 = (t) => t, F5 = u5e(2), m5e = yS(F5), Sce = j5(F5), Oce = (t) => 1 - Math.sin(Math.acos(t)), B5 = yS(Oce), g5e = j5(B5), z5 = xce(Ece), y5e = yS(z5), v5e = j5(z5), b5e = d5e(Ece), _5e = 4356 / 361, w5e = 35442 / 1805, x5e = 16061 / 1805, lx = (t) => {
  if (t === 1 || t === 0)
    return t;
  const e = t * t;
  return t < f5e ? 7.5625 * e : t < h5e ? 9.075 * e - 9.9 * t + 3.4 : t < p5e ? _5e * e - w5e * t + x5e : 10.8 * t * t - 20.52 * t + 10.72;
}, E5e = yS(lx), S5e = (t) => t < 0.5 ? 0.5 * (1 - lx(1 - t * 2)) : 0.5 * lx(t * 2 - 1) + 0.5;
function O5e(t, e) {
  return t.map(() => e || Sce).splice(0, t.length - 1);
}
function C5e(t) {
  const e = t.length;
  return t.map((n, r) => r !== 0 ? r / (e - 1) : 0);
}
function k5e(t, e) {
  return t.map((n) => n * e);
}
function Z_({ from: t = 0, to: e = 1, ease: n, offset: r, duration: o = 300 }) {
  const i = { done: !1, value: t }, s = Array.isArray(e) ? e : [t, e], a = k5e(r && r.length === s.length ? r : C5e(s), o);
  function l() {
    return wce(a, s, {
      ease: Array.isArray(n) ? n : O5e(s, n)
    });
  }
  let c = l();
  return {
    next: (u) => (i.value = c(u), i.done = u >= o, i),
    flipTarget: () => {
      s.reverse(), c = l();
    }
  };
}
function A5e({ velocity: t = 0, from: e = 0, power: n = 0.8, timeConstant: r = 350, restDelta: o = 0.5, modifyTarget: i }) {
  const s = { done: !1, value: e };
  let a = n * t;
  const l = e + a, c = i === void 0 ? l : i(l);
  return c !== l && (a = c - e), {
    next: (u) => {
      const d = -a * Math.exp(-u / r);
      return s.done = !(d > o || d < -o), s.value = s.done ? c : c + d, s;
    },
    flipTarget: () => {
    }
  };
}
const u7 = { keyframes: Z_, spring: N5, decay: A5e };
function T5e(t) {
  if (Array.isArray(t.to))
    return Z_;
  if (u7[t.type])
    return u7[t.type];
  const e = new Set(Object.keys(t));
  return e.has("ease") || e.has("duration") && !e.has("dampingRatio") ? Z_ : e.has("dampingRatio") || e.has("stiffness") || e.has("mass") || e.has("damping") || e.has("restSpeed") || e.has("restDelta") ? N5 : Z_;
}
const Cce = 1 / 60 * 1e3, R5e = typeof performance < "u" ? () => performance.now() : () => Date.now(), kce = typeof window < "u" ? (t) => window.requestAnimationFrame(t) : (t) => setTimeout(() => t(R5e()), Cce);
function P5e(t) {
  let e = [], n = [], r = 0, o = !1, i = !1;
  const s = /* @__PURE__ */ new WeakSet(), a = {
    schedule: (l, c = !1, u = !1) => {
      const d = u && o, f = d ? e : n;
      return c && s.add(l), f.indexOf(l) === -1 && (f.push(l), d && o && (r = e.length)), l;
    },
    cancel: (l) => {
      const c = n.indexOf(l);
      c !== -1 && n.splice(c, 1), s.delete(l);
    },
    process: (l) => {
      if (o) {
        i = !0;
        return;
      }
      if (o = !0, [e, n] = [n, e], n.length = 0, r = e.length, r)
        for (let c = 0; c < r; c++) {
          const u = e[c];
          u(l), s.has(u) && (a.schedule(u), t());
        }
      o = !1, i && (i = !1, a.process(l));
    }
  };
  return a;
}
const $5e = 40;
let vI = !0, z0 = !1, bI = !1;
const fh = {
  delta: 0,
  timestamp: 0
}, dv = [
  "read",
  "update",
  "preRender",
  "render",
  "postRender"
], vS = dv.reduce((t, e) => (t[e] = P5e(() => z0 = !0), t), {}), ks = dv.reduce((t, e) => {
  const n = vS[e];
  return t[e] = (r, o = !1, i = !1) => (z0 || D5e(), n.schedule(r, o, i)), t;
}, {}), zh = dv.reduce((t, e) => (t[e] = vS[e].cancel, t), {}), NC = dv.reduce((t, e) => (t[e] = () => vS[e].process(fh), t), {}), M5e = (t) => vS[t].process(fh), Ace = (t) => {
  z0 = !1, fh.delta = vI ? Cce : Math.max(Math.min(t - fh.timestamp, $5e), 1), fh.timestamp = t, bI = !0, dv.forEach(M5e), bI = !1, z0 && (vI = !1, kce(Ace));
}, D5e = () => {
  z0 = !0, vI = !0, bI || kce(Ace);
}, cx = () => fh;
function Tce(t, e, n = 0) {
  return t - e - n;
}
function I5e(t, e, n = 0, r = !0) {
  return r ? Tce(e + -t, e, n) : e - (t - e) + n;
}
function N5e(t, e, n, r) {
  return r ? t >= e + n : t <= -n;
}
const j5e = (t) => {
  const e = ({ delta: n }) => t(n);
  return {
    start: () => ks.update(e, !0),
    stop: () => zh.update(e)
  };
};
function Rce(t) {
  var e, n, { from: r, autoplay: o = !0, driver: i = j5e, elapsed: s = 0, repeat: a = 0, repeatType: l = "loop", repeatDelay: c = 0, onPlay: u, onStop: d, onComplete: f, onRepeat: h, onUpdate: p } = t, m = ss(t, ["from", "autoplay", "driver", "elapsed", "repeat", "repeatType", "repeatDelay", "onPlay", "onStop", "onComplete", "onRepeat", "onUpdate"]);
  let { to: g } = m, y, v = 0, b = m.duration, _, w = !1, x = !0, E;
  const S = T5e(m);
  !((n = (e = S).needsInterpolation) === null || n === void 0) && n.call(e, r, g) && (E = wce([0, 100], [r, g], {
    clamp: !1
  }), r = 0, g = 100);
  const C = S(Object.assign(Object.assign({}, m), { from: r, to: g }));
  function R() {
    v++, l === "reverse" ? (x = v % 2 === 0, s = I5e(s, b, c, x)) : (s = Tce(s, b, c), l === "mirror" && C.flipTarget()), w = !1, h && h();
  }
  function P() {
    y.stop(), f && f();
  }
  function N(O) {
    if (x || (O = -O), s += O, !w) {
      const k = C.next(Math.max(0, s));
      _ = k.value, E && (_ = E(_)), w = x ? k.done : s <= 0;
    }
    p?.(_), w && (v === 0 && (b ?? (b = s)), v < a ? N5e(s, b, c, x) && R() : P());
  }
  function A() {
    u?.(), y = i(N), y.start();
  }
  return o && A(), {
    stop: () => {
      d?.(), y.stop();
    }
  };
}
function Pce(t, e) {
  return e ? t * (1e3 / e) : 0;
}
function L5e({ from: t = 0, velocity: e = 0, min: n, max: r, power: o = 0.8, timeConstant: i = 750, bounceStiffness: s = 500, bounceDamping: a = 10, restDelta: l = 1, modifyTarget: c, driver: u, onUpdate: d, onComplete: f, onStop: h }) {
  let p;
  function m(b) {
    return n !== void 0 && b < n || r !== void 0 && b > r;
  }
  function g(b) {
    return n === void 0 ? r : r === void 0 || Math.abs(n - b) < Math.abs(r - b) ? n : r;
  }
  function y(b) {
    p?.stop(), p = Rce(Object.assign(Object.assign({}, b), {
      driver: u,
      onUpdate: (_) => {
        var w;
        d?.(_), (w = b.onUpdate) === null || w === void 0 || w.call(b, _);
      },
      onComplete: f,
      onStop: h
    }));
  }
  function v(b) {
    y(Object.assign({ type: "spring", stiffness: s, damping: a, restDelta: l }, b));
  }
  if (m(t))
    v({ from: t, velocity: e, to: g(t) });
  else {
    let b = o * e + t;
    typeof c < "u" && (b = c(b));
    const _ = g(b), w = _ === n ? -1 : 1;
    let x, E;
    const S = (C) => {
      x = E, E = C, e = Pce(C - x, cx().delta), (w === 1 && C > _ || w === -1 && C < _) && v({ from: C, to: _, velocity: e });
    };
    y({
      type: "decay",
      from: t,
      velocity: e,
      timeConstant: i,
      power: o,
      restDelta: l,
      modifyTarget: c,
      onUpdate: m(b) ? S : void 0
    });
  }
  return {
    stop: () => p?.stop()
  };
}
const _I = (t) => t.hasOwnProperty("x") && t.hasOwnProperty("y"), d7 = (t) => _I(t) && t.hasOwnProperty("z"), gb = (t, e) => Math.abs(t - e);
function $ce(t, e) {
  if (yI(t) && yI(e))
    return gb(t, e);
  if (_I(t) && _I(e)) {
    const n = gb(t.x, e.x), r = gb(t.y, e.y), o = d7(t) && d7(e) ? gb(t.z, e.z) : 0;
    return Math.sqrt(Math.pow(n, 2) + Math.pow(r, 2) + Math.pow(o, 2));
  }
}
const Mce = (t, e) => 1 - 3 * e + 3 * t, Dce = (t, e) => 3 * e - 6 * t, Ice = (t) => 3 * t, ux = (t, e, n) => ((Mce(e, n) * t + Dce(e, n)) * t + Ice(e)) * t, Nce = (t, e, n) => 3 * Mce(e, n) * t * t + 2 * Dce(e, n) * t + Ice(e), F5e = 1e-7, B5e = 10;
function z5e(t, e, n, r, o) {
  let i, s, a = 0;
  do
    s = e + (n - e) / 2, i = ux(s, r, o) - t, i > 0 ? n = s : e = s;
  while (Math.abs(i) > F5e && ++a < B5e);
  return s;
}
const q5e = 8, U5e = 1e-3;
function H5e(t, e, n, r) {
  for (let o = 0; o < q5e; ++o) {
    const i = Nce(e, n, r);
    if (i === 0)
      return e;
    const s = ux(e, n, r) - t;
    e -= s / i;
  }
  return e;
}
const J_ = 11, yb = 1 / (J_ - 1);
function V5e(t, e, n, r) {
  if (t === e && n === r)
    return L5;
  const o = new Float32Array(J_);
  for (let s = 0; s < J_; ++s)
    o[s] = ux(s * yb, t, n);
  function i(s) {
    let a = 0, l = 1;
    const c = J_ - 1;
    for (; l !== c && o[l] <= s; ++l)
      a += yb;
    --l;
    const u = (s - o[l]) / (o[l + 1] - o[l]), d = a + u * yb, f = Nce(d, t, n);
    return f >= U5e ? H5e(s, d, t, n) : f === 0 ? d : z5e(s, a, a + yb, t, n);
  }
  return (s) => s === 0 || s === 1 ? s : ux(i(s), e, r);
}
let W5e = (t = 21) => crypto.getRandomValues(new Uint8Array(t)).reduce((e, n) => (n &= 63, n < 36 ? e += n.toString(36) : n < 62 ? e += (n - 26).toString(36).toUpperCase() : n > 62 ? e += "-" : e += "_", e), "");
function jce(t) {
  var e, n, r = "";
  if (typeof t == "string" || typeof t == "number") r += t;
  else if (typeof t == "object") if (Array.isArray(t)) for (e = 0; e < t.length; e++) t[e] && (n = jce(t[e])) && (r && (r += " "), r += n);
  else for (e in t) t[e] && (r && (r += " "), r += e);
  return r;
}
function ca() {
  for (var t, e, n = 0, r = ""; n < arguments.length; ) (t = arguments[n++]) && (e = jce(t)) && (r && (r += " "), r += e);
  return r;
}
const G5e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  clsx: ca,
  default: ca
}, Symbol.toStringTag, { value: "Module" })), Kg = (t) => typeof t == "number" && !isNaN(t), Td = (t) => typeof t == "string", Vo = (t) => typeof t == "function", ew = (t) => Td(t) || Vo(t) ? t : null, jC = (t) => Cd(t) || Td(t) || Vo(t) || Kg(t);
function Y5e(t, e, n) {
  n === void 0 && (n = 300);
  const { scrollHeight: r, style: o } = t;
  requestAnimationFrame(() => {
    o.minHeight = "initial", o.height = r + "px", o.transition = `all ${n}ms`, requestAnimationFrame(() => {
      o.height = "0", o.padding = "0", o.margin = "0", setTimeout(e, n);
    });
  });
}
function bS(t) {
  let { enter: e, exit: n, appendPosition: r = !1, collapse: o = !0, collapseDuration: i = 300 } = t;
  return function(s) {
    let { children: a, position: l, preventExitTransition: c, done: u, nodeRef: d, isIn: f } = s;
    const h = r ? `${e}--${l}` : e, p = r ? `${n}--${l}` : n, m = Ue(0);
    return iu(() => {
      const g = d.current, y = h.split(" "), v = (b) => {
        b.target === d.current && (g.dispatchEvent(new Event("d")), g.removeEventListener("animationend", v), g.removeEventListener("animationcancel", v), m.current === 0 && b.type !== "animationcancel" && g.classList.remove(...y));
      };
      g.classList.add(...y), g.addEventListener("animationend", v), g.addEventListener("animationcancel", v);
    }, []), Ne(() => {
      const g = d.current, y = () => {
        g.removeEventListener("animationend", y), o ? Y5e(g, u, i) : u();
      };
      f || (c ? y() : (m.current = 1, g.className += ` ${p}`, g.addEventListener("animationend", y)));
    }, [f]), xe.createElement(xe.Fragment, null, a);
  };
}
function f7(t, e) {
  return t != null ? { content: t.content, containerId: t.props.containerId, id: t.props.toastId, theme: t.props.theme, type: t.props.type, data: t.props.data || {}, isLoading: t.props.isLoading, icon: t.props.icon, status: e } : {};
}
const Li = { list: /* @__PURE__ */ new Map(), emitQueue: /* @__PURE__ */ new Map(), on(t, e) {
  return this.list.has(t) || this.list.set(t, []), this.list.get(t).push(e), this;
}, off(t, e) {
  if (e) {
    const n = this.list.get(t).filter((r) => r !== e);
    return this.list.set(t, n), this;
  }
  return this.list.delete(t), this;
}, cancelEmit(t) {
  const e = this.emitQueue.get(t);
  return e && (e.forEach(clearTimeout), this.emitQueue.delete(t)), this;
}, emit(t) {
  this.list.has(t) && this.list.get(t).forEach((e) => {
    const n = setTimeout(() => {
      e(...[].slice.call(arguments, 1));
    }, 0);
    this.emitQueue.has(t) || this.emitQueue.set(t, []), this.emitQueue.get(t).push(n);
  });
} }, vb = (t) => {
  let { theme: e, type: n, ...r } = t;
  return xe.createElement("svg", { viewBox: "0 0 24 24", width: "100%", height: "100%", fill: e === "colored" ? "currentColor" : `var(--toastify-icon-color-${n})`, ...r });
}, LC = { info: function(t) {
  return xe.createElement(vb, { ...t }, xe.createElement("path", { d: "M12 0a12 12 0 1012 12A12.013 12.013 0 0012 0zm.25 5a1.5 1.5 0 11-1.5 1.5 1.5 1.5 0 011.5-1.5zm2.25 13.5h-4a1 1 0 010-2h.75a.25.25 0 00.25-.25v-4.5a.25.25 0 00-.25-.25h-.75a1 1 0 010-2h1a2 2 0 012 2v4.75a.25.25 0 00.25.25h.75a1 1 0 110 2z" }));
}, warning: function(t) {
  return xe.createElement(vb, { ...t }, xe.createElement("path", { d: "M23.32 17.191L15.438 2.184C14.728.833 13.416 0 11.996 0c-1.42 0-2.733.833-3.443 2.184L.533 17.448a4.744 4.744 0 000 4.368C1.243 23.167 2.555 24 3.975 24h16.05C22.22 24 24 22.044 24 19.632c0-.904-.251-1.746-.68-2.44zm-9.622 1.46c0 1.033-.724 1.823-1.698 1.823s-1.698-.79-1.698-1.822v-.043c0-1.028.724-1.822 1.698-1.822s1.698.79 1.698 1.822v.043zm.039-12.285l-.84 8.06c-.057.581-.408.943-.897.943-.49 0-.84-.367-.896-.942l-.84-8.065c-.057-.624.25-1.095.779-1.095h1.91c.528.005.84.476.784 1.1z" }));
}, success: function(t) {
  return xe.createElement(vb, { ...t }, xe.createElement("path", { d: "M12 0a12 12 0 1012 12A12.014 12.014 0 0012 0zm6.927 8.2l-6.845 9.289a1.011 1.011 0 01-1.43.188l-4.888-3.908a1 1 0 111.25-1.562l4.076 3.261 6.227-8.451a1 1 0 111.61 1.183z" }));
}, error: function(t) {
  return xe.createElement(vb, { ...t }, xe.createElement("path", { d: "M11.983 0a12.206 12.206 0 00-8.51 3.653A11.8 11.8 0 000 12.207 11.779 11.779 0 0011.8 24h.214A12.111 12.111 0 0024 11.791 11.766 11.766 0 0011.983 0zM10.5 16.542a1.476 1.476 0 011.449-1.53h.027a1.527 1.527 0 011.523 1.47 1.475 1.475 0 01-1.449 1.53h-.027a1.529 1.529 0 01-1.523-1.47zM11 12.5v-6a1 1 0 012 0v6a1 1 0 11-2 0z" }));
}, spinner: function() {
  return xe.createElement("div", { className: "Toastify__spinner" });
} };
function K5e(t) {
  const [, e] = Jxe((h) => h + 1, 0), [n, r] = Ye([]), o = Ue(null), i = Ue(/* @__PURE__ */ new Map()).current, s = (h) => n.indexOf(h) !== -1, a = Ue({ toastKey: 1, displayedToast: 0, count: 0, queue: [], props: t, containerId: null, isToastActive: s, getToast: (h) => i.get(h) }).current;
  function l(h) {
    let { containerId: p } = h;
    const { limit: m } = a.props;
    !m || p && a.containerId !== p || (a.count -= a.queue.length, a.queue = []);
  }
  function c(h) {
    r((p) => h == null ? [] : p.filter((m) => m !== h));
  }
  function u() {
    const { toastContent: h, toastProps: p, staleId: m } = a.queue.shift();
    f(h, p, m);
  }
  function d(h, p) {
    let { delay: m, staleId: g, ...y } = p;
    if (!jC(h) || function(N) {
      return !o.current || a.props.enableMultiContainer && N.containerId !== a.props.containerId || i.has(N.toastId) && N.updateId == null;
    }(y)) return;
    const { toastId: v, updateId: b, data: _ } = y, { props: w } = a, x = () => c(v), E = b == null;
    E && a.count++;
    const S = { ...w, style: w.toastStyle, key: a.toastKey++, ...Object.fromEntries(Object.entries(y).filter((N) => {
      let [A, O] = N;
      return O != null;
    })), toastId: v, updateId: b, data: _, closeToast: x, isIn: !1, className: ew(y.className || w.toastClassName), bodyClassName: ew(y.bodyClassName || w.bodyClassName), progressClassName: ew(y.progressClassName || w.progressClassName), autoClose: !y.isLoading && (C = y.autoClose, R = w.autoClose, C === !1 || Kg(C) && C > 0 ? C : R), deleteToast() {
      const N = f7(i.get(v), "removed");
      i.delete(v), Li.emit(4, N);
      const A = a.queue.length;
      if (a.count = v == null ? a.count - a.displayedToast : a.count - 1, a.count < 0 && (a.count = 0), A > 0) {
        const O = v == null ? a.props.limit : 1;
        if (A === 1 || O === 1) a.displayedToast++, u();
        else {
          const k = O > A ? A : O;
          a.displayedToast = k;
          for (let T = 0; T < k; T++) u();
        }
      } else e();
    } };
    var C, R;
    S.iconOut = function(N) {
      let { theme: A, type: O, isLoading: k, icon: T } = N, I = null;
      const j = { theme: A, type: O };
      return T === !1 || (Vo(T) ? I = T(j) : Cd(T) ? I = Gi(T, j) : Td(T) || Kg(T) ? I = T : k ? I = LC.spinner() : ((z) => z in LC)(O) && (I = LC[O](j))), I;
    }(S), Vo(y.onOpen) && (S.onOpen = y.onOpen), Vo(y.onClose) && (S.onClose = y.onClose), S.closeButton = w.closeButton, y.closeButton === !1 || jC(y.closeButton) ? S.closeButton = y.closeButton : y.closeButton === !0 && (S.closeButton = !jC(w.closeButton) || w.closeButton);
    let P = h;
    Cd(h) && !Td(h.type) ? P = Gi(h, { closeToast: x, toastProps: S, data: _ }) : Vo(h) && (P = h({ closeToast: x, toastProps: S, data: _ })), w.limit && w.limit > 0 && a.count > w.limit && E ? a.queue.push({ toastContent: P, toastProps: S, staleId: g }) : Kg(m) ? setTimeout(() => {
      f(P, S, g);
    }, m) : f(P, S, g);
  }
  function f(h, p, m) {
    const { toastId: g } = p;
    m && i.delete(m);
    const y = { content: h, props: p };
    i.set(g, y), r((v) => [...v, g].filter((b) => b !== m)), Li.emit(4, f7(y, y.props.updateId == null ? "added" : "updated"));
  }
  return Ne(() => (a.containerId = t.containerId, Li.cancelEmit(3).on(0, d).on(1, (h) => o.current && c(h)).on(5, l).emit(2, a), () => {
    i.clear(), Li.emit(3, a);
  }), []), Ne(() => {
    a.props = t, a.isToastActive = s, a.displayedToast = n.length;
  }), { getToastToRender: function(h) {
    const p = /* @__PURE__ */ new Map(), m = Array.from(i.values());
    return t.newestOnTop && m.reverse(), m.forEach((g) => {
      const { position: y } = g.props;
      p.has(y) || p.set(y, []), p.get(y).push(g);
    }), Array.from(p, (g) => h(g[0], g[1]));
  }, containerRef: o, isToastActive: s };
}
function h7(t) {
  return t.targetTouches && t.targetTouches.length >= 1 ? t.targetTouches[0].clientX : t.clientX;
}
function p7(t) {
  return t.targetTouches && t.targetTouches.length >= 1 ? t.targetTouches[0].clientY : t.clientY;
}
function X5e(t) {
  const [e, n] = Ye(!1), [r, o] = Ye(!1), i = Ue(null), s = Ue({ start: 0, x: 0, y: 0, delta: 0, removalDistance: 0, canCloseOnClick: !0, canDrag: !1, boundingRect: null, didMove: !1 }).current, a = Ue(t), { autoClose: l, pauseOnHover: c, closeToast: u, onClick: d, closeOnClick: f } = t;
  function h(_) {
    if (t.draggable) {
      _.nativeEvent.type === "touchstart" && _.nativeEvent.preventDefault(), s.didMove = !1, document.addEventListener("mousemove", y), document.addEventListener("mouseup", v), document.addEventListener("touchmove", y), document.addEventListener("touchend", v);
      const w = i.current;
      s.canCloseOnClick = !0, s.canDrag = !0, s.boundingRect = w.getBoundingClientRect(), w.style.transition = "", s.x = h7(_.nativeEvent), s.y = p7(_.nativeEvent), t.draggableDirection === "x" ? (s.start = s.x, s.removalDistance = w.offsetWidth * (t.draggablePercent / 100)) : (s.start = s.y, s.removalDistance = w.offsetHeight * (t.draggablePercent === 80 ? 1.5 * t.draggablePercent : t.draggablePercent / 100));
    }
  }
  function p(_) {
    if (s.boundingRect) {
      const { top: w, bottom: x, left: E, right: S } = s.boundingRect;
      _.nativeEvent.type !== "touchend" && t.pauseOnHover && s.x >= E && s.x <= S && s.y >= w && s.y <= x ? g() : m();
    }
  }
  function m() {
    n(!0);
  }
  function g() {
    n(!1);
  }
  function y(_) {
    const w = i.current;
    s.canDrag && w && (s.didMove = !0, e && g(), s.x = h7(_), s.y = p7(_), s.delta = t.draggableDirection === "x" ? s.x - s.start : s.y - s.start, s.start !== s.x && (s.canCloseOnClick = !1), w.style.transform = `translate${t.draggableDirection}(${s.delta}px)`, w.style.opacity = "" + (1 - Math.abs(s.delta / s.removalDistance)));
  }
  function v() {
    document.removeEventListener("mousemove", y), document.removeEventListener("mouseup", v), document.removeEventListener("touchmove", y), document.removeEventListener("touchend", v);
    const _ = i.current;
    if (s.canDrag && s.didMove && _) {
      if (s.canDrag = !1, Math.abs(s.delta) > s.removalDistance) return o(!0), void t.closeToast();
      _.style.transition = "transform 0.2s, opacity 0.2s", _.style.transform = `translate${t.draggableDirection}(0)`, _.style.opacity = "1";
    }
  }
  Ne(() => {
    a.current = t;
  }), Ne(() => (i.current && i.current.addEventListener("d", m, { once: !0 }), Vo(t.onOpen) && t.onOpen(Cd(t.children) && t.children.props), () => {
    const _ = a.current;
    Vo(_.onClose) && _.onClose(Cd(_.children) && _.children.props);
  }), []), Ne(() => (t.pauseOnFocusLoss && (document.hasFocus() || g(), window.addEventListener("focus", m), window.addEventListener("blur", g)), () => {
    t.pauseOnFocusLoss && (window.removeEventListener("focus", m), window.removeEventListener("blur", g));
  }), [t.pauseOnFocusLoss]);
  const b = { onMouseDown: h, onTouchStart: h, onMouseUp: p, onTouchEnd: p };
  return l && c && (b.onMouseEnter = g, b.onMouseLeave = m), f && (b.onClick = (_) => {
    d && d(_), s.canCloseOnClick && u();
  }), { playToast: m, pauseToast: g, isRunning: e, preventExitTransition: r, toastRef: i, eventHandlers: b };
}
function Lce(t) {
  let { closeToast: e, theme: n, ariaLabel: r = "close" } = t;
  return xe.createElement("button", { className: `Toastify__close-button Toastify__close-button--${n}`, type: "button", onClick: (o) => {
    o.stopPropagation(), e(o);
  }, "aria-label": r }, xe.createElement("svg", { "aria-hidden": "true", viewBox: "0 0 14 16" }, xe.createElement("path", { fillRule: "evenodd", d: "M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z" })));
}
function Q5e(t) {
  let { delay: e, isRunning: n, closeToast: r, type: o = "default", hide: i, className: s, style: a, controlledProgress: l, progress: c, rtl: u, isIn: d, theme: f } = t;
  const h = i || l && c === 0, p = { ...a, animationDuration: `${e}ms`, animationPlayState: n ? "running" : "paused", opacity: h ? 0 : 1 };
  l && (p.transform = `scaleX(${c})`);
  const m = ca("Toastify__progress-bar", l ? "Toastify__progress-bar--controlled" : "Toastify__progress-bar--animated", `Toastify__progress-bar-theme--${f}`, `Toastify__progress-bar--${o}`, { "Toastify__progress-bar--rtl": u }), g = Vo(s) ? s({ rtl: u, type: o, defaultClassName: m }) : ca(m, s);
  return xe.createElement("div", { role: "progressbar", "aria-hidden": h ? "true" : "false", "aria-label": "notification timer", className: g, style: p, [l && c >= 1 ? "onTransitionEnd" : "onAnimationEnd"]: l && c < 1 ? null : () => {
    d && r();
  } });
}
const Z5e = (t) => {
  const { isRunning: e, preventExitTransition: n, toastRef: r, eventHandlers: o } = X5e(t), { closeButton: i, children: s, autoClose: a, onClick: l, type: c, hideProgressBar: u, closeToast: d, transition: f, position: h, className: p, style: m, bodyClassName: g, bodyStyle: y, progressClassName: v, progressStyle: b, updateId: _, role: w, progress: x, rtl: E, toastId: S, deleteToast: C, isIn: R, isLoading: P, iconOut: N, closeOnClick: A, theme: O } = t, k = ca("Toastify__toast", `Toastify__toast-theme--${O}`, `Toastify__toast--${c}`, { "Toastify__toast--rtl": E }, { "Toastify__toast--close-on-click": A }), T = Vo(p) ? p({ rtl: E, position: h, type: c, defaultClassName: k }) : ca(k, p), I = !!x || !a, j = { closeToast: d, type: c, theme: O };
  let z = null;
  return i === !1 || (z = Vo(i) ? i(j) : Cd(i) ? Gi(i, j) : Lce(j)), xe.createElement(f, { isIn: R, done: C, position: h, preventExitTransition: n, nodeRef: r }, xe.createElement("div", { id: S, onClick: l, className: T, ...o, style: m, ref: r }, xe.createElement("div", { ...R && { role: w }, className: Vo(g) ? g({ type: c }) : ca("Toastify__toast-body", g), style: y }, N != null && xe.createElement("div", { className: ca("Toastify__toast-icon", { "Toastify--animate-icon Toastify__zoom-enter": !P }) }, N), xe.createElement("div", null, s)), z, xe.createElement(Q5e, { ..._ && !I ? { key: `pb-${_}` } : {}, rtl: E, theme: O, delay: a, isRunning: e, isIn: R, closeToast: d, hide: u, type: c, style: b, className: v, controlledProgress: I, progress: x || 0 })));
}, _S = function(t, e) {
  return e === void 0 && (e = !1), { enter: `Toastify--animate Toastify__${t}-enter`, exit: `Toastify--animate Toastify__${t}-exit`, appendPosition: e };
}, J5e = bS(_S("bounce", !0));
bS(_S("slide", !0));
bS(_S("zoom"));
bS(_S("flip"));
const m7 = Ri((t, e) => {
  const { getToastToRender: n, containerRef: r, isToastActive: o } = K5e(t), { className: i, style: s, rtl: a, containerId: l } = t;
  function c(u) {
    const d = ca("Toastify__toast-container", `Toastify__toast-container--${u}`, { "Toastify__toast-container--rtl": a });
    return Vo(i) ? i({ position: u, rtl: a, defaultClassName: d }) : ca(d, ew(i));
  }
  return Ne(() => {
    e && (e.current = r.current);
  }, []), xe.createElement("div", { ref: r, className: "Toastify", id: l }, n((u, d) => {
    const f = d.length ? { ...s } : { ...s, pointerEvents: "none" };
    return xe.createElement("div", { className: c(u), style: f, key: `container-${u}` }, d.map((h, p) => {
      let { content: m, props: g } = h;
      return xe.createElement(Z5e, { ...g, isIn: o(g.toastId), style: { ...g.style, "--nth": p + 1, "--len": d.length }, key: `toast-${g.key}` }, m);
    }));
  }));
});
m7.displayName = "ToastContainer", m7.defaultProps = { position: "top-right", transition: J5e, autoClose: 5e3, closeButton: Lce, pauseOnHover: !0, pauseOnFocusLoss: !0, closeOnClick: !0, draggable: !0, draggablePercent: 80, draggableDirection: "x", role: "alert", theme: "light" };
let FC, Lu = /* @__PURE__ */ new Map(), fg = [], eLe = 1;
function Fce() {
  return "" + eLe++;
}
function tLe(t) {
  return t && (Td(t.toastId) || Kg(t.toastId)) ? t.toastId : Fce();
}
function Xg(t, e) {
  return Lu.size > 0 ? Li.emit(0, t, e) : fg.push({ content: t, options: e }), e.toastId;
}
function dx(t, e) {
  return { ...e, type: e && e.type || t, toastId: tLe(e) };
}
function bb(t) {
  return (e, n) => Xg(e, dx(t, n));
}
function In(t, e) {
  return Xg(t, dx("default", e));
}
In.loading = (t, e) => Xg(t, dx("default", { isLoading: !0, autoClose: !1, closeOnClick: !1, closeButton: !1, draggable: !1, ...e })), In.promise = function(t, e, n) {
  let r, { pending: o, error: i, success: s } = e;
  o && (r = Td(o) ? In.loading(o, n) : In.loading(o.render, { ...n, ...o }));
  const a = { isLoading: null, autoClose: null, closeOnClick: null, closeButton: null, draggable: null }, l = (u, d, f) => {
    if (d == null) return void In.dismiss(r);
    const h = { type: u, ...a, ...n, data: f }, p = Td(d) ? { render: d } : d;
    return r ? In.update(r, { ...h, ...p }) : In(p.render, { ...h, ...p }), f;
  }, c = Vo(t) ? t() : t;
  return c.then((u) => l("success", s, u)).catch((u) => l("error", i, u)), c;
}, In.success = bb("success"), In.info = bb("info"), In.error = bb("error"), In.warning = bb("warning"), In.warn = In.warning, In.dark = (t, e) => Xg(t, dx("default", { theme: "dark", ...e })), In.dismiss = (t) => {
  Lu.size > 0 ? Li.emit(1, t) : fg = fg.filter((e) => t != null && e.options.toastId !== t);
}, In.clearWaitingQueue = function(t) {
  return t === void 0 && (t = {}), Li.emit(5, t);
}, In.isActive = (t) => {
  let e = !1;
  return Lu.forEach((n) => {
    n.isToastActive && n.isToastActive(t) && (e = !0);
  }), e;
}, In.update = function(t, e) {
  e === void 0 && (e = {}), setTimeout(() => {
    const n = function(r, o) {
      let { containerId: i } = o;
      const s = Lu.get(i || FC);
      return s && s.getToast(r);
    }(t, e);
    if (n) {
      const { props: r, content: o } = n, i = { delay: 100, ...r, ...e, toastId: e.toastId || t, updateId: Fce() };
      i.toastId !== t && (i.staleId = t);
      const s = i.render || o;
      delete i.render, Xg(s, i);
    }
  }, 0);
}, In.done = (t) => {
  In.update(t, { progress: 1 });
}, In.onChange = (t) => (Li.on(4, t), () => {
  Li.off(4, t);
}), In.POSITION = { TOP_LEFT: "top-left", TOP_RIGHT: "top-right", TOP_CENTER: "top-center", BOTTOM_LEFT: "bottom-left", BOTTOM_RIGHT: "bottom-right", BOTTOM_CENTER: "bottom-center" }, In.TYPE = { INFO: "info", SUCCESS: "success", WARNING: "warning", ERROR: "error", DEFAULT: "default" }, Li.on(2, (t) => {
  FC = t.containerId || t, Lu.set(FC, t), fg.forEach((e) => {
    Li.emit(0, e.content, e.options);
  }), fg = [];
}).on(3, (t) => {
  Lu.delete(t.containerId || t), Lu.size === 0 && Li.off(0).off(1).off(5);
});
function qh() {
  return qh = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (t[r] = n[r]);
    }
    return t;
  }, qh.apply(null, arguments);
}
function wI(t, e) {
  return wI = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, r) {
    return n.__proto__ = r, n;
  }, wI(t, e);
}
function nLe(t) {
  if (t.sheet)
    return t.sheet;
  for (var e = 0; e < document.styleSheets.length; e++)
    if (document.styleSheets[e].ownerNode === t)
      return document.styleSheets[e];
}
function rLe(t) {
  var e = document.createElement("style");
  return e.setAttribute("data-emotion", t.key), t.nonce !== void 0 && e.setAttribute("nonce", t.nonce), e.appendChild(document.createTextNode("")), e.setAttribute("data-s", ""), e;
}
var oLe = /* @__PURE__ */ function() {
  function t(n) {
    var r = this;
    this._insertTag = function(o) {
      var i;
      r.tags.length === 0 ? r.insertionPoint ? i = r.insertionPoint.nextSibling : r.prepend ? i = r.container.firstChild : i = r.before : i = r.tags[r.tags.length - 1].nextSibling, r.container.insertBefore(o, i), r.tags.push(o);
    }, this.isSpeedy = n.speedy === void 0 ? !0 : n.speedy, this.tags = [], this.ctr = 0, this.nonce = n.nonce, this.key = n.key, this.container = n.container, this.prepend = n.prepend, this.insertionPoint = n.insertionPoint, this.before = null;
  }
  var e = t.prototype;
  return e.hydrate = function(n) {
    n.forEach(this._insertTag);
  }, e.insert = function(n) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(rLe(this));
    var r = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var o = nLe(r);
      try {
        o.insertRule(n, o.cssRules.length);
      } catch {
      }
    } else
      r.appendChild(document.createTextNode(n));
    this.ctr++;
  }, e.flush = function() {
    this.tags.forEach(function(n) {
      var r;
      return (r = n.parentNode) == null ? void 0 : r.removeChild(n);
    }), this.tags = [], this.ctr = 0;
  }, t;
}(), no = "-ms-", fx = "-moz-", rn = "-webkit-", Bce = "comm", q5 = "rule", U5 = "decl", iLe = "@import", zce = "@keyframes", sLe = "@layer", aLe = Math.abs, wS = String.fromCharCode, lLe = Object.assign;
function cLe(t, e) {
  return Kr(t, 0) ^ 45 ? (((e << 2 ^ Kr(t, 0)) << 2 ^ Kr(t, 1)) << 2 ^ Kr(t, 2)) << 2 ^ Kr(t, 3) : 0;
}
function qce(t) {
  return t.trim();
}
function uLe(t, e) {
  return (t = e.exec(t)) ? t[0] : t;
}
function on(t, e, n) {
  return t.replace(e, n);
}
function xI(t, e) {
  return t.indexOf(e);
}
function Kr(t, e) {
  return t.charCodeAt(e) | 0;
}
function q0(t, e, n) {
  return t.slice(e, n);
}
function oa(t) {
  return t.length;
}
function H5(t) {
  return t.length;
}
function _b(t, e) {
  return e.push(t), t;
}
function dLe(t, e) {
  return t.map(e).join("");
}
var xS = 1, Uh = 1, Uce = 0, Jo = 0, Or = 0, Ep = "";
function ES(t, e, n, r, o, i, s) {
  return { value: t, root: e, parent: n, type: r, props: o, children: i, line: xS, column: Uh, length: s, return: "" };
}
function nm(t, e) {
  return lLe(ES("", null, null, "", null, null, 0), t, { length: -t.length }, e);
}
function fLe() {
  return Or;
}
function hLe() {
  return Or = Jo > 0 ? Kr(Ep, --Jo) : 0, Uh--, Or === 10 && (Uh = 1, xS--), Or;
}
function Ei() {
  return Or = Jo < Uce ? Kr(Ep, Jo++) : 0, Uh++, Or === 10 && (Uh = 1, xS++), Or;
}
function ba() {
  return Kr(Ep, Jo);
}
function tw() {
  return Jo;
}
function fv(t, e) {
  return q0(Ep, t, e);
}
function U0(t) {
  switch (t) {
    // \0 \t \n \r \s whitespace token
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    // ! + , / > @ ~ isolate token
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    // ; { } breakpoint token
    case 59:
    case 123:
    case 125:
      return 4;
    // : accompanied token
    case 58:
      return 3;
    // " ' ( [ opening delimit token
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    // ) ] closing delimit token
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function Hce(t) {
  return xS = Uh = 1, Uce = oa(Ep = t), Jo = 0, [];
}
function Vce(t) {
  return Ep = "", t;
}
function nw(t) {
  return qce(fv(Jo - 1, EI(t === 91 ? t + 2 : t === 40 ? t + 1 : t)));
}
function pLe(t) {
  for (; (Or = ba()) && Or < 33; )
    Ei();
  return U0(t) > 2 || U0(Or) > 3 ? "" : " ";
}
function mLe(t, e) {
  for (; --e && Ei() && !(Or < 48 || Or > 102 || Or > 57 && Or < 65 || Or > 70 && Or < 97); )
    ;
  return fv(t, tw() + (e < 6 && ba() == 32 && Ei() == 32));
}
function EI(t) {
  for (; Ei(); )
    switch (Or) {
      // ] ) " '
      case t:
        return Jo;
      // " '
      case 34:
      case 39:
        t !== 34 && t !== 39 && EI(Or);
        break;
      // (
      case 40:
        t === 41 && EI(t);
        break;
      // \
      case 92:
        Ei();
        break;
    }
  return Jo;
}
function gLe(t, e) {
  for (; Ei() && t + Or !== 57 && !(t + Or === 84 && ba() === 47); )
    ;
  return "/*" + fv(e, Jo - 1) + "*" + wS(t === 47 ? t : Ei());
}
function yLe(t) {
  for (; !U0(ba()); )
    Ei();
  return fv(t, Jo);
}
function vLe(t) {
  return Vce(rw("", null, null, null, [""], t = Hce(t), 0, [0], t));
}
function rw(t, e, n, r, o, i, s, a, l) {
  for (var c = 0, u = 0, d = s, f = 0, h = 0, p = 0, m = 1, g = 1, y = 1, v = 0, b = "", _ = o, w = i, x = r, E = b; g; )
    switch (p = v, v = Ei()) {
      // (
      case 40:
        if (p != 108 && Kr(E, d - 1) == 58) {
          xI(E += on(nw(v), "&", "&\f"), "&\f") != -1 && (y = -1);
          break;
        }
      // " ' [
      case 34:
      case 39:
      case 91:
        E += nw(v);
        break;
      // \t \n \r \s
      case 9:
      case 10:
      case 13:
      case 32:
        E += pLe(p);
        break;
      // \
      case 92:
        E += mLe(tw() - 1, 7);
        continue;
      // /
      case 47:
        switch (ba()) {
          case 42:
          case 47:
            _b(bLe(gLe(Ei(), tw()), e, n), l);
            break;
          default:
            E += "/";
        }
        break;
      // {
      case 123 * m:
        a[c++] = oa(E) * y;
      // } ; \0
      case 125 * m:
      case 59:
      case 0:
        switch (v) {
          // \0 }
          case 0:
          case 125:
            g = 0;
          // ;
          case 59 + u:
            y == -1 && (E = on(E, /\f/g, "")), h > 0 && oa(E) - d && _b(h > 32 ? y7(E + ";", r, n, d - 1) : y7(on(E, " ", "") + ";", r, n, d - 2), l);
            break;
          // @ ;
          case 59:
            E += ";";
          // { rule/at-rule
          default:
            if (_b(x = g7(E, e, n, c, u, o, a, b, _ = [], w = [], d), i), v === 123)
              if (u === 0)
                rw(E, e, x, x, _, i, d, a, w);
              else
                switch (f === 99 && Kr(E, 3) === 110 ? 100 : f) {
                  // d l m s
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    rw(t, x, x, r && _b(g7(t, x, x, 0, 0, o, a, b, o, _ = [], d), w), o, w, d, a, r ? _ : w);
                    break;
                  default:
                    rw(E, x, x, x, [""], w, 0, a, w);
                }
        }
        c = u = h = 0, m = y = 1, b = E = "", d = s;
        break;
      // :
      case 58:
        d = 1 + oa(E), h = p;
      default:
        if (m < 1) {
          if (v == 123)
            --m;
          else if (v == 125 && m++ == 0 && hLe() == 125)
            continue;
        }
        switch (E += wS(v), v * m) {
          // &
          case 38:
            y = u > 0 ? 1 : (E += "\f", -1);
            break;
          // ,
          case 44:
            a[c++] = (oa(E) - 1) * y, y = 1;
            break;
          // @
          case 64:
            ba() === 45 && (E += nw(Ei())), f = ba(), u = d = oa(b = E += yLe(tw())), v++;
            break;
          // -
          case 45:
            p === 45 && oa(E) == 2 && (m = 0);
        }
    }
  return i;
}
function g7(t, e, n, r, o, i, s, a, l, c, u) {
  for (var d = o - 1, f = o === 0 ? i : [""], h = H5(f), p = 0, m = 0, g = 0; p < r; ++p)
    for (var y = 0, v = q0(t, d + 1, d = aLe(m = s[p])), b = t; y < h; ++y)
      (b = qce(m > 0 ? f[y] + " " + v : on(v, /&\f/g, f[y]))) && (l[g++] = b);
  return ES(t, e, n, o === 0 ? q5 : a, l, c, u);
}
function bLe(t, e, n) {
  return ES(t, e, n, Bce, wS(fLe()), q0(t, 2, -2), 0);
}
function y7(t, e, n, r) {
  return ES(t, e, n, U5, q0(t, 0, r), q0(t, r + 1, -1), r);
}
function hh(t, e) {
  for (var n = "", r = H5(t), o = 0; o < r; o++)
    n += e(t[o], o, t, e) || "";
  return n;
}
function _Le(t, e, n, r) {
  switch (t.type) {
    case sLe:
      if (t.children.length) break;
    case iLe:
    case U5:
      return t.return = t.return || t.value;
    case Bce:
      return "";
    case zce:
      return t.return = t.value + "{" + hh(t.children, r) + "}";
    case q5:
      t.value = t.props.join(",");
  }
  return oa(n = hh(t.children, r)) ? t.return = t.value + "{" + n + "}" : "";
}
function wLe(t) {
  var e = H5(t);
  return function(n, r, o, i) {
    for (var s = "", a = 0; a < e; a++)
      s += t[a](n, r, o, i) || "";
    return s;
  };
}
function xLe(t) {
  return function(e) {
    e.root || (e = e.return) && t(e);
  };
}
var ELe = function(t, e, n) {
  for (var r = 0, o = 0; r = o, o = ba(), r === 38 && o === 12 && (e[n] = 1), !U0(o); )
    Ei();
  return fv(t, Jo);
}, SLe = function(t, e) {
  var n = -1, r = 44;
  do
    switch (U0(r)) {
      case 0:
        r === 38 && ba() === 12 && (e[n] = 1), t[n] += ELe(Jo - 1, e, n);
        break;
      case 2:
        t[n] += nw(r);
        break;
      case 4:
        if (r === 44) {
          t[++n] = ba() === 58 ? "&\f" : "", e[n] = t[n].length;
          break;
        }
      // fallthrough
      default:
        t[n] += wS(r);
    }
  while (r = Ei());
  return t;
}, OLe = function(t, e) {
  return Vce(SLe(Hce(t), e));
}, v7 = /* @__PURE__ */ new WeakMap(), CLe = function(t) {
  if (!(t.type !== "rule" || !t.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  t.length < 1)) {
    for (var e = t.value, n = t.parent, r = t.column === n.column && t.line === n.line; n.type !== "rule"; )
      if (n = n.parent, !n) return;
    if (!(t.props.length === 1 && e.charCodeAt(0) !== 58 && !v7.get(n)) && !r) {
      v7.set(t, !0);
      for (var o = [], i = OLe(e, o), s = n.props, a = 0, l = 0; a < i.length; a++)
        for (var c = 0; c < s.length; c++, l++)
          t.props[l] = o[a] ? i[a].replace(/&\f/g, s[c]) : s[c] + " " + i[a];
    }
  }
}, kLe = function(t) {
  if (t.type === "decl") {
    var e = t.value;
    e.charCodeAt(0) === 108 && // charcode for b
    e.charCodeAt(2) === 98 && (t.return = "", t.value = "");
  }
};
function Wce(t, e) {
  switch (cLe(t, e)) {
    // color-adjust
    case 5103:
      return rn + "print-" + t + t;
    // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return rn + t + t;
    // appearance, user-select, transform, hyphens, text-size-adjust
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return rn + t + fx + t + no + t + t;
    // flex, flex-direction
    case 6828:
    case 4268:
      return rn + t + no + t + t;
    // order
    case 6165:
      return rn + t + no + "flex-" + t + t;
    // align-items
    case 5187:
      return rn + t + on(t, /(\w+).+(:[^]+)/, rn + "box-$1$2" + no + "flex-$1$2") + t;
    // align-self
    case 5443:
      return rn + t + no + "flex-item-" + on(t, /flex-|-self/, "") + t;
    // align-content
    case 4675:
      return rn + t + no + "flex-line-pack" + on(t, /align-content|flex-|-self/, "") + t;
    // flex-shrink
    case 5548:
      return rn + t + no + on(t, "shrink", "negative") + t;
    // flex-basis
    case 5292:
      return rn + t + no + on(t, "basis", "preferred-size") + t;
    // flex-grow
    case 6060:
      return rn + "box-" + on(t, "-grow", "") + rn + t + no + on(t, "grow", "positive") + t;
    // transition
    case 4554:
      return rn + on(t, /([^-])(transform)/g, "$1" + rn + "$2") + t;
    // cursor
    case 6187:
      return on(on(on(t, /(zoom-|grab)/, rn + "$1"), /(image-set)/, rn + "$1"), t, "") + t;
    // background, background-image
    case 5495:
    case 3959:
      return on(t, /(image-set\([^]*)/, rn + "$1$`$1");
    // justify-content
    case 4968:
      return on(on(t, /(.+:)(flex-)?(.*)/, rn + "box-pack:$3" + no + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + rn + t + t;
    // (margin|padding)-inline-(start|end)
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return on(t, /(.+)-inline(.+)/, rn + "$1$2") + t;
    // (min|max)?(width|height|inline-size|block-size)
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (oa(t) - 1 - e > 6) switch (Kr(t, e + 1)) {
        // (m)ax-content, (m)in-content
        case 109:
          if (Kr(t, e + 4) !== 45) break;
        // (f)ill-available, (f)it-content
        case 102:
          return on(t, /(.+:)(.+)-([^]+)/, "$1" + rn + "$2-$3$1" + fx + (Kr(t, e + 3) == 108 ? "$3" : "$2-$3")) + t;
        // (s)tretch
        case 115:
          return ~xI(t, "stretch") ? Wce(on(t, "stretch", "fill-available"), e) + t : t;
      }
      break;
    // position: sticky
    case 4949:
      if (Kr(t, e + 1) !== 115) break;
    // display: (flex|inline-flex)
    case 6444:
      switch (Kr(t, oa(t) - 3 - (~xI(t, "!important") && 10))) {
        // stic(k)y
        case 107:
          return on(t, ":", ":" + rn) + t;
        // (inline-)?fl(e)x
        case 101:
          return on(t, /(.+:)([^;!]+)(;|!.+)?/, "$1" + rn + (Kr(t, 14) === 45 ? "inline-" : "") + "box$3$1" + rn + "$2$3$1" + no + "$2box$3") + t;
      }
      break;
    // writing-mode
    case 5936:
      switch (Kr(t, e + 11)) {
        // vertical-l(r)
        case 114:
          return rn + t + no + on(t, /[svh]\w+-[tblr]{2}/, "tb") + t;
        // vertical-r(l)
        case 108:
          return rn + t + no + on(t, /[svh]\w+-[tblr]{2}/, "tb-rl") + t;
        // horizontal(-)tb
        case 45:
          return rn + t + no + on(t, /[svh]\w+-[tblr]{2}/, "lr") + t;
      }
      return rn + t + no + t + t;
  }
  return t;
}
var ALe = function(t, e, n, r) {
  if (t.length > -1 && !t.return) switch (t.type) {
    case U5:
      t.return = Wce(t.value, t.length);
      break;
    case zce:
      return hh([nm(t, {
        value: on(t.value, "@", "@" + rn)
      })], r);
    case q5:
      if (t.length) return dLe(t.props, function(o) {
        switch (uLe(o, /(::plac\w+|:read-\w+)/)) {
          // :read-(only|write)
          case ":read-only":
          case ":read-write":
            return hh([nm(t, {
              props: [on(o, /:(read-\w+)/, ":" + fx + "$1")]
            })], r);
          // :placeholder
          case "::placeholder":
            return hh([nm(t, {
              props: [on(o, /:(plac\w+)/, ":" + rn + "input-$1")]
            }), nm(t, {
              props: [on(o, /:(plac\w+)/, ":" + fx + "$1")]
            }), nm(t, {
              props: [on(o, /:(plac\w+)/, no + "input-$1")]
            })], r);
        }
        return "";
      });
  }
}, TLe = [ALe], RLe = function(t) {
  var e = t.key;
  if (e === "css") {
    var n = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(n, function(p) {
      var m = p.getAttribute("data-emotion");
      m.indexOf(" ") !== -1 && (document.head.appendChild(p), p.setAttribute("data-s", ""));
    });
  }
  var r = t.stylisPlugins || TLe, o = {}, i, s = [];
  i = t.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + e + ' "]'),
    function(p) {
      for (var m = p.getAttribute("data-emotion").split(" "), g = 1; g < m.length; g++)
        o[m[g]] = !0;
      s.push(p);
    }
  );
  var a, l = [CLe, kLe];
  {
    var c, u = [_Le, xLe(function(p) {
      c.insert(p);
    })], d = wLe(l.concat(r, u)), f = function(p) {
      return hh(vLe(p), d);
    };
    a = function(p, m, g, y) {
      c = g, f(p ? p + "{" + m.styles + "}" : m.styles), y && (h.inserted[m.name] = !0);
    };
  }
  var h = {
    key: e,
    sheet: new oLe({
      key: e,
      container: i,
      nonce: t.nonce,
      speedy: t.speedy,
      prepend: t.prepend,
      insertionPoint: t.insertionPoint
    }),
    nonce: t.nonce,
    inserted: o,
    registered: {},
    insert: a
  };
  return h.sheet.hydrate(s), h;
}, BC = { exports: {} }, dn = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b7;
function PLe() {
  if (b7) return dn;
  b7 = 1;
  var t = typeof Symbol == "function" && Symbol.for, e = t ? Symbol.for("react.element") : 60103, n = t ? Symbol.for("react.portal") : 60106, r = t ? Symbol.for("react.fragment") : 60107, o = t ? Symbol.for("react.strict_mode") : 60108, i = t ? Symbol.for("react.profiler") : 60114, s = t ? Symbol.for("react.provider") : 60109, a = t ? Symbol.for("react.context") : 60110, l = t ? Symbol.for("react.async_mode") : 60111, c = t ? Symbol.for("react.concurrent_mode") : 60111, u = t ? Symbol.for("react.forward_ref") : 60112, d = t ? Symbol.for("react.suspense") : 60113, f = t ? Symbol.for("react.suspense_list") : 60120, h = t ? Symbol.for("react.memo") : 60115, p = t ? Symbol.for("react.lazy") : 60116, m = t ? Symbol.for("react.block") : 60121, g = t ? Symbol.for("react.fundamental") : 60117, y = t ? Symbol.for("react.responder") : 60118, v = t ? Symbol.for("react.scope") : 60119;
  function b(w) {
    if (typeof w == "object" && w !== null) {
      var x = w.$$typeof;
      switch (x) {
        case e:
          switch (w = w.type, w) {
            case l:
            case c:
            case r:
            case i:
            case o:
            case d:
              return w;
            default:
              switch (w = w && w.$$typeof, w) {
                case a:
                case u:
                case p:
                case h:
                case s:
                  return w;
                default:
                  return x;
              }
          }
        case n:
          return x;
      }
    }
  }
  function _(w) {
    return b(w) === c;
  }
  return dn.AsyncMode = l, dn.ConcurrentMode = c, dn.ContextConsumer = a, dn.ContextProvider = s, dn.Element = e, dn.ForwardRef = u, dn.Fragment = r, dn.Lazy = p, dn.Memo = h, dn.Portal = n, dn.Profiler = i, dn.StrictMode = o, dn.Suspense = d, dn.isAsyncMode = function(w) {
    return _(w) || b(w) === l;
  }, dn.isConcurrentMode = _, dn.isContextConsumer = function(w) {
    return b(w) === a;
  }, dn.isContextProvider = function(w) {
    return b(w) === s;
  }, dn.isElement = function(w) {
    return typeof w == "object" && w !== null && w.$$typeof === e;
  }, dn.isForwardRef = function(w) {
    return b(w) === u;
  }, dn.isFragment = function(w) {
    return b(w) === r;
  }, dn.isLazy = function(w) {
    return b(w) === p;
  }, dn.isMemo = function(w) {
    return b(w) === h;
  }, dn.isPortal = function(w) {
    return b(w) === n;
  }, dn.isProfiler = function(w) {
    return b(w) === i;
  }, dn.isStrictMode = function(w) {
    return b(w) === o;
  }, dn.isSuspense = function(w) {
    return b(w) === d;
  }, dn.isValidElementType = function(w) {
    return typeof w == "string" || typeof w == "function" || w === r || w === c || w === i || w === o || w === d || w === f || typeof w == "object" && w !== null && (w.$$typeof === p || w.$$typeof === h || w.$$typeof === s || w.$$typeof === a || w.$$typeof === u || w.$$typeof === g || w.$$typeof === y || w.$$typeof === v || w.$$typeof === m);
  }, dn.typeOf = b, dn;
}
var wn = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var _7;
function $Le() {
  return _7 || (_7 = 1, process.env.NODE_ENV !== "production" && function() {
    var t = typeof Symbol == "function" && Symbol.for, e = t ? Symbol.for("react.element") : 60103, n = t ? Symbol.for("react.portal") : 60106, r = t ? Symbol.for("react.fragment") : 60107, o = t ? Symbol.for("react.strict_mode") : 60108, i = t ? Symbol.for("react.profiler") : 60114, s = t ? Symbol.for("react.provider") : 60109, a = t ? Symbol.for("react.context") : 60110, l = t ? Symbol.for("react.async_mode") : 60111, c = t ? Symbol.for("react.concurrent_mode") : 60111, u = t ? Symbol.for("react.forward_ref") : 60112, d = t ? Symbol.for("react.suspense") : 60113, f = t ? Symbol.for("react.suspense_list") : 60120, h = t ? Symbol.for("react.memo") : 60115, p = t ? Symbol.for("react.lazy") : 60116, m = t ? Symbol.for("react.block") : 60121, g = t ? Symbol.for("react.fundamental") : 60117, y = t ? Symbol.for("react.responder") : 60118, v = t ? Symbol.for("react.scope") : 60119;
    function b(L) {
      return typeof L == "string" || typeof L == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      L === r || L === c || L === i || L === o || L === d || L === f || typeof L == "object" && L !== null && (L.$$typeof === p || L.$$typeof === h || L.$$typeof === s || L.$$typeof === a || L.$$typeof === u || L.$$typeof === g || L.$$typeof === y || L.$$typeof === v || L.$$typeof === m);
    }
    function _(L) {
      if (typeof L == "object" && L !== null) {
        var V = L.$$typeof;
        switch (V) {
          case e:
            var K = L.type;
            switch (K) {
              case l:
              case c:
              case r:
              case i:
              case o:
              case d:
                return K;
              default:
                var ne = K && K.$$typeof;
                switch (ne) {
                  case a:
                  case u:
                  case p:
                  case h:
                  case s:
                    return ne;
                  default:
                    return V;
                }
            }
          case n:
            return V;
        }
      }
    }
    var w = l, x = c, E = a, S = s, C = e, R = u, P = r, N = p, A = h, O = n, k = i, T = o, I = d, j = !1;
    function z(L) {
      return j || (j = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), $(L) || _(L) === l;
    }
    function $(L) {
      return _(L) === c;
    }
    function D(L) {
      return _(L) === a;
    }
    function U(L) {
      return _(L) === s;
    }
    function q(L) {
      return typeof L == "object" && L !== null && L.$$typeof === e;
    }
    function F(L) {
      return _(L) === u;
    }
    function B(L) {
      return _(L) === r;
    }
    function H(L) {
      return _(L) === p;
    }
    function Z(L) {
      return _(L) === h;
    }
    function W(L) {
      return _(L) === n;
    }
    function G(L) {
      return _(L) === i;
    }
    function ee(L) {
      return _(L) === o;
    }
    function Y(L) {
      return _(L) === d;
    }
    wn.AsyncMode = w, wn.ConcurrentMode = x, wn.ContextConsumer = E, wn.ContextProvider = S, wn.Element = C, wn.ForwardRef = R, wn.Fragment = P, wn.Lazy = N, wn.Memo = A, wn.Portal = O, wn.Profiler = k, wn.StrictMode = T, wn.Suspense = I, wn.isAsyncMode = z, wn.isConcurrentMode = $, wn.isContextConsumer = D, wn.isContextProvider = U, wn.isElement = q, wn.isForwardRef = F, wn.isFragment = B, wn.isLazy = H, wn.isMemo = Z, wn.isPortal = W, wn.isProfiler = G, wn.isStrictMode = ee, wn.isSuspense = Y, wn.isValidElementType = b, wn.typeOf = _;
  }()), wn;
}
var w7;
function MLe() {
  return w7 || (w7 = 1, process.env.NODE_ENV === "production" ? BC.exports = PLe() : BC.exports = $Le()), BC.exports;
}
var zC, x7;
function V5() {
  if (x7) return zC;
  x7 = 1;
  var t = MLe(), e = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
  }, n = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
  }, r = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
  }, o = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
  }, i = {};
  i[t.ForwardRef] = r, i[t.Memo] = o;
  function s(p) {
    return t.isMemo(p) ? o : i[p.$$typeof] || e;
  }
  var a = Object.defineProperty, l = Object.getOwnPropertyNames, c = Object.getOwnPropertySymbols, u = Object.getOwnPropertyDescriptor, d = Object.getPrototypeOf, f = Object.prototype;
  function h(p, m, g) {
    if (typeof m != "string") {
      if (f) {
        var y = d(m);
        y && y !== f && h(p, y, g);
      }
      var v = l(m);
      c && (v = v.concat(c(m)));
      for (var b = s(p), _ = s(m), w = 0; w < v.length; ++w) {
        var x = v[w];
        if (!n[x] && !(g && g[x]) && !(_ && _[x]) && !(b && b[x])) {
          var E = u(m, x);
          try {
            a(p, x, E);
          } catch {
          }
        }
      }
    }
    return p;
  }
  return zC = h, zC;
}
V5();
var DLe = /* @__PURE__ */ he.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ RLe({
    key: "css"
  }) : null
);
DLe.Provider;
function Gce(t, e) {
  if (t == null) return {};
  var n = {};
  for (var r in t) if ({}.hasOwnProperty.call(t, r)) {
    if (e.includes(r)) continue;
    n[r] = t[r];
  }
  return n;
}
var wb = { exports: {} }, qC = { exports: {} }, fn = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var E7;
function ILe() {
  if (E7) return fn;
  E7 = 1;
  var t = typeof Symbol == "function" && Symbol.for, e = t ? Symbol.for("react.element") : 60103, n = t ? Symbol.for("react.portal") : 60106, r = t ? Symbol.for("react.fragment") : 60107, o = t ? Symbol.for("react.strict_mode") : 60108, i = t ? Symbol.for("react.profiler") : 60114, s = t ? Symbol.for("react.provider") : 60109, a = t ? Symbol.for("react.context") : 60110, l = t ? Symbol.for("react.async_mode") : 60111, c = t ? Symbol.for("react.concurrent_mode") : 60111, u = t ? Symbol.for("react.forward_ref") : 60112, d = t ? Symbol.for("react.suspense") : 60113, f = t ? Symbol.for("react.suspense_list") : 60120, h = t ? Symbol.for("react.memo") : 60115, p = t ? Symbol.for("react.lazy") : 60116, m = t ? Symbol.for("react.block") : 60121, g = t ? Symbol.for("react.fundamental") : 60117, y = t ? Symbol.for("react.responder") : 60118, v = t ? Symbol.for("react.scope") : 60119;
  function b(w) {
    if (typeof w == "object" && w !== null) {
      var x = w.$$typeof;
      switch (x) {
        case e:
          switch (w = w.type, w) {
            case l:
            case c:
            case r:
            case i:
            case o:
            case d:
              return w;
            default:
              switch (w = w && w.$$typeof, w) {
                case a:
                case u:
                case p:
                case h:
                case s:
                  return w;
                default:
                  return x;
              }
          }
        case n:
          return x;
      }
    }
  }
  function _(w) {
    return b(w) === c;
  }
  return fn.AsyncMode = l, fn.ConcurrentMode = c, fn.ContextConsumer = a, fn.ContextProvider = s, fn.Element = e, fn.ForwardRef = u, fn.Fragment = r, fn.Lazy = p, fn.Memo = h, fn.Portal = n, fn.Profiler = i, fn.StrictMode = o, fn.Suspense = d, fn.isAsyncMode = function(w) {
    return _(w) || b(w) === l;
  }, fn.isConcurrentMode = _, fn.isContextConsumer = function(w) {
    return b(w) === a;
  }, fn.isContextProvider = function(w) {
    return b(w) === s;
  }, fn.isElement = function(w) {
    return typeof w == "object" && w !== null && w.$$typeof === e;
  }, fn.isForwardRef = function(w) {
    return b(w) === u;
  }, fn.isFragment = function(w) {
    return b(w) === r;
  }, fn.isLazy = function(w) {
    return b(w) === p;
  }, fn.isMemo = function(w) {
    return b(w) === h;
  }, fn.isPortal = function(w) {
    return b(w) === n;
  }, fn.isProfiler = function(w) {
    return b(w) === i;
  }, fn.isStrictMode = function(w) {
    return b(w) === o;
  }, fn.isSuspense = function(w) {
    return b(w) === d;
  }, fn.isValidElementType = function(w) {
    return typeof w == "string" || typeof w == "function" || w === r || w === c || w === i || w === o || w === d || w === f || typeof w == "object" && w !== null && (w.$$typeof === p || w.$$typeof === h || w.$$typeof === s || w.$$typeof === a || w.$$typeof === u || w.$$typeof === g || w.$$typeof === y || w.$$typeof === v || w.$$typeof === m);
  }, fn.typeOf = b, fn;
}
var xn = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var S7;
function NLe() {
  return S7 || (S7 = 1, process.env.NODE_ENV !== "production" && function() {
    var t = typeof Symbol == "function" && Symbol.for, e = t ? Symbol.for("react.element") : 60103, n = t ? Symbol.for("react.portal") : 60106, r = t ? Symbol.for("react.fragment") : 60107, o = t ? Symbol.for("react.strict_mode") : 60108, i = t ? Symbol.for("react.profiler") : 60114, s = t ? Symbol.for("react.provider") : 60109, a = t ? Symbol.for("react.context") : 60110, l = t ? Symbol.for("react.async_mode") : 60111, c = t ? Symbol.for("react.concurrent_mode") : 60111, u = t ? Symbol.for("react.forward_ref") : 60112, d = t ? Symbol.for("react.suspense") : 60113, f = t ? Symbol.for("react.suspense_list") : 60120, h = t ? Symbol.for("react.memo") : 60115, p = t ? Symbol.for("react.lazy") : 60116, m = t ? Symbol.for("react.block") : 60121, g = t ? Symbol.for("react.fundamental") : 60117, y = t ? Symbol.for("react.responder") : 60118, v = t ? Symbol.for("react.scope") : 60119;
    function b(L) {
      return typeof L == "string" || typeof L == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      L === r || L === c || L === i || L === o || L === d || L === f || typeof L == "object" && L !== null && (L.$$typeof === p || L.$$typeof === h || L.$$typeof === s || L.$$typeof === a || L.$$typeof === u || L.$$typeof === g || L.$$typeof === y || L.$$typeof === v || L.$$typeof === m);
    }
    function _(L) {
      if (typeof L == "object" && L !== null) {
        var V = L.$$typeof;
        switch (V) {
          case e:
            var K = L.type;
            switch (K) {
              case l:
              case c:
              case r:
              case i:
              case o:
              case d:
                return K;
              default:
                var ne = K && K.$$typeof;
                switch (ne) {
                  case a:
                  case u:
                  case p:
                  case h:
                  case s:
                    return ne;
                  default:
                    return V;
                }
            }
          case n:
            return V;
        }
      }
    }
    var w = l, x = c, E = a, S = s, C = e, R = u, P = r, N = p, A = h, O = n, k = i, T = o, I = d, j = !1;
    function z(L) {
      return j || (j = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), $(L) || _(L) === l;
    }
    function $(L) {
      return _(L) === c;
    }
    function D(L) {
      return _(L) === a;
    }
    function U(L) {
      return _(L) === s;
    }
    function q(L) {
      return typeof L == "object" && L !== null && L.$$typeof === e;
    }
    function F(L) {
      return _(L) === u;
    }
    function B(L) {
      return _(L) === r;
    }
    function H(L) {
      return _(L) === p;
    }
    function Z(L) {
      return _(L) === h;
    }
    function W(L) {
      return _(L) === n;
    }
    function G(L) {
      return _(L) === i;
    }
    function ee(L) {
      return _(L) === o;
    }
    function Y(L) {
      return _(L) === d;
    }
    xn.AsyncMode = w, xn.ConcurrentMode = x, xn.ContextConsumer = E, xn.ContextProvider = S, xn.Element = C, xn.ForwardRef = R, xn.Fragment = P, xn.Lazy = N, xn.Memo = A, xn.Portal = O, xn.Profiler = k, xn.StrictMode = T, xn.Suspense = I, xn.isAsyncMode = z, xn.isConcurrentMode = $, xn.isContextConsumer = D, xn.isContextProvider = U, xn.isElement = q, xn.isForwardRef = F, xn.isFragment = B, xn.isLazy = H, xn.isMemo = Z, xn.isPortal = W, xn.isProfiler = G, xn.isStrictMode = ee, xn.isSuspense = Y, xn.isValidElementType = b, xn.typeOf = _;
  }()), xn;
}
var O7;
function Yce() {
  return O7 || (O7 = 1, process.env.NODE_ENV === "production" ? qC.exports = ILe() : qC.exports = NLe()), qC.exports;
}
var UC, C7;
function W5() {
  if (C7) return UC;
  C7 = 1;
  var t = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return UC = t, UC;
}
var k7, A7;
function Kce() {
  return A7 || (A7 = 1, k7 = Function.call.bind(Object.prototype.hasOwnProperty)), k7;
}
var HC, T7;
function jLe() {
  if (T7) return HC;
  T7 = 1;
  var t = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var e = /* @__PURE__ */ W5(), n = {}, r = /* @__PURE__ */ Kce();
    t = function(i) {
      var s = "Warning: " + i;
      typeof console < "u" && console.error(s);
      try {
        throw new Error(s);
      } catch {
      }
    };
  }
  function o(i, s, a, l, c) {
    if (process.env.NODE_ENV !== "production") {
      for (var u in i)
        if (r(i, u)) {
          var d;
          try {
            if (typeof i[u] != "function") {
              var f = Error(
                (l || "React class") + ": " + a + " type `" + u + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[u] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw f.name = "Invariant Violation", f;
            }
            d = i[u](s, u, l, a, null, e);
          } catch (p) {
            d = p;
          }
          if (d && !(d instanceof Error) && t(
            (l || "React class") + ": type specification of " + a + " `" + u + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof d + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), d instanceof Error && !(d.message in n)) {
            n[d.message] = !0;
            var h = c ? c() : "";
            t(
              "Failed " + a + " type: " + d.message + (h ?? "")
            );
          }
        }
    }
  }
  return o.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, HC = o, HC;
}
var VC, R7;
function LLe() {
  if (R7) return VC;
  R7 = 1;
  var t = Yce(), e = ov(), n = /* @__PURE__ */ W5(), r = /* @__PURE__ */ Kce(), o = /* @__PURE__ */ jLe(), i = function() {
  };
  process.env.NODE_ENV !== "production" && (i = function(a) {
    var l = "Warning: " + a;
    typeof console < "u" && console.error(l);
    try {
      throw new Error(l);
    } catch {
    }
  });
  function s() {
    return null;
  }
  return VC = function(a, l) {
    var c = typeof Symbol == "function" && Symbol.iterator, u = "@@iterator";
    function d($) {
      var D = $ && (c && $[c] || $[u]);
      if (typeof D == "function")
        return D;
    }
    var f = "<<anonymous>>", h = {
      array: y("array"),
      bigint: y("bigint"),
      bool: y("boolean"),
      func: y("function"),
      number: y("number"),
      object: y("object"),
      string: y("string"),
      symbol: y("symbol"),
      any: v(),
      arrayOf: b,
      element: _(),
      elementType: w(),
      instanceOf: x,
      node: R(),
      objectOf: S,
      oneOf: E,
      oneOfType: C,
      shape: N,
      exact: A
    };
    function p($, D) {
      return $ === D ? $ !== 0 || 1 / $ === 1 / D : $ !== $ && D !== D;
    }
    function m($, D) {
      this.message = $, this.data = D && typeof D == "object" ? D : {}, this.stack = "";
    }
    m.prototype = Error.prototype;
    function g($) {
      if (process.env.NODE_ENV !== "production")
        var D = {}, U = 0;
      function q(B, H, Z, W, G, ee, Y) {
        if (W = W || f, ee = ee || Z, Y !== n) {
          if (l) {
            var L = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw L.name = "Invariant Violation", L;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var V = W + ":" + Z;
            !D[V] && // Avoid spamming the console because they are often not actionable except for lib authors
            U < 3 && (i(
              "You are manually calling a React.PropTypes validation function for the `" + ee + "` prop on `" + W + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), D[V] = !0, U++);
          }
        }
        return H[Z] == null ? B ? H[Z] === null ? new m("The " + G + " `" + ee + "` is marked as required " + ("in `" + W + "`, but its value is `null`.")) : new m("The " + G + " `" + ee + "` is marked as required in " + ("`" + W + "`, but its value is `undefined`.")) : null : $(H, Z, W, G, ee);
      }
      var F = q.bind(null, !1);
      return F.isRequired = q.bind(null, !0), F;
    }
    function y($) {
      function D(U, q, F, B, H, Z) {
        var W = U[q], G = T(W);
        if (G !== $) {
          var ee = I(W);
          return new m(
            "Invalid " + B + " `" + H + "` of type " + ("`" + ee + "` supplied to `" + F + "`, expected ") + ("`" + $ + "`."),
            { expectedType: $ }
          );
        }
        return null;
      }
      return g(D);
    }
    function v() {
      return g(s);
    }
    function b($) {
      function D(U, q, F, B, H) {
        if (typeof $ != "function")
          return new m("Property `" + H + "` of component `" + F + "` has invalid PropType notation inside arrayOf.");
        var Z = U[q];
        if (!Array.isArray(Z)) {
          var W = T(Z);
          return new m("Invalid " + B + " `" + H + "` of type " + ("`" + W + "` supplied to `" + F + "`, expected an array."));
        }
        for (var G = 0; G < Z.length; G++) {
          var ee = $(Z, G, F, B, H + "[" + G + "]", n);
          if (ee instanceof Error)
            return ee;
        }
        return null;
      }
      return g(D);
    }
    function _() {
      function $(D, U, q, F, B) {
        var H = D[U];
        if (!a(H)) {
          var Z = T(H);
          return new m("Invalid " + F + " `" + B + "` of type " + ("`" + Z + "` supplied to `" + q + "`, expected a single ReactElement."));
        }
        return null;
      }
      return g($);
    }
    function w() {
      function $(D, U, q, F, B) {
        var H = D[U];
        if (!t.isValidElementType(H)) {
          var Z = T(H);
          return new m("Invalid " + F + " `" + B + "` of type " + ("`" + Z + "` supplied to `" + q + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return g($);
    }
    function x($) {
      function D(U, q, F, B, H) {
        if (!(U[q] instanceof $)) {
          var Z = $.name || f, W = z(U[q]);
          return new m("Invalid " + B + " `" + H + "` of type " + ("`" + W + "` supplied to `" + F + "`, expected ") + ("instance of `" + Z + "`."));
        }
        return null;
      }
      return g(D);
    }
    function E($) {
      if (!Array.isArray($))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? i(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : i("Invalid argument supplied to oneOf, expected an array.")), s;
      function D(U, q, F, B, H) {
        for (var Z = U[q], W = 0; W < $.length; W++)
          if (p(Z, $[W]))
            return null;
        var G = JSON.stringify($, function(ee, Y) {
          var L = I(Y);
          return L === "symbol" ? String(Y) : Y;
        });
        return new m("Invalid " + B + " `" + H + "` of value `" + String(Z) + "` " + ("supplied to `" + F + "`, expected one of " + G + "."));
      }
      return g(D);
    }
    function S($) {
      function D(U, q, F, B, H) {
        if (typeof $ != "function")
          return new m("Property `" + H + "` of component `" + F + "` has invalid PropType notation inside objectOf.");
        var Z = U[q], W = T(Z);
        if (W !== "object")
          return new m("Invalid " + B + " `" + H + "` of type " + ("`" + W + "` supplied to `" + F + "`, expected an object."));
        for (var G in Z)
          if (r(Z, G)) {
            var ee = $(Z, G, F, B, H + "." + G, n);
            if (ee instanceof Error)
              return ee;
          }
        return null;
      }
      return g(D);
    }
    function C($) {
      if (!Array.isArray($))
        return process.env.NODE_ENV !== "production" && i("Invalid argument supplied to oneOfType, expected an instance of array."), s;
      for (var D = 0; D < $.length; D++) {
        var U = $[D];
        if (typeof U != "function")
          return i(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + j(U) + " at index " + D + "."
          ), s;
      }
      function q(F, B, H, Z, W) {
        for (var G = [], ee = 0; ee < $.length; ee++) {
          var Y = $[ee], L = Y(F, B, H, Z, W, n);
          if (L == null)
            return null;
          L.data && r(L.data, "expectedType") && G.push(L.data.expectedType);
        }
        var V = G.length > 0 ? ", expected one of type [" + G.join(", ") + "]" : "";
        return new m("Invalid " + Z + " `" + W + "` supplied to " + ("`" + H + "`" + V + "."));
      }
      return g(q);
    }
    function R() {
      function $(D, U, q, F, B) {
        return O(D[U]) ? null : new m("Invalid " + F + " `" + B + "` supplied to " + ("`" + q + "`, expected a ReactNode."));
      }
      return g($);
    }
    function P($, D, U, q, F) {
      return new m(
        ($ || "React class") + ": " + D + " type `" + U + "." + q + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + F + "`."
      );
    }
    function N($) {
      function D(U, q, F, B, H) {
        var Z = U[q], W = T(Z);
        if (W !== "object")
          return new m("Invalid " + B + " `" + H + "` of type `" + W + "` " + ("supplied to `" + F + "`, expected `object`."));
        for (var G in $) {
          var ee = $[G];
          if (typeof ee != "function")
            return P(F, B, H, G, I(ee));
          var Y = ee(Z, G, F, B, H + "." + G, n);
          if (Y)
            return Y;
        }
        return null;
      }
      return g(D);
    }
    function A($) {
      function D(U, q, F, B, H) {
        var Z = U[q], W = T(Z);
        if (W !== "object")
          return new m("Invalid " + B + " `" + H + "` of type `" + W + "` " + ("supplied to `" + F + "`, expected `object`."));
        var G = e({}, U[q], $);
        for (var ee in G) {
          var Y = $[ee];
          if (r($, ee) && typeof Y != "function")
            return P(F, B, H, ee, I(Y));
          if (!Y)
            return new m(
              "Invalid " + B + " `" + H + "` key `" + ee + "` supplied to `" + F + "`.\nBad object: " + JSON.stringify(U[q], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys($), null, "  ")
            );
          var L = Y(Z, ee, F, B, H + "." + ee, n);
          if (L)
            return L;
        }
        return null;
      }
      return g(D);
    }
    function O($) {
      switch (typeof $) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !$;
        case "object":
          if (Array.isArray($))
            return $.every(O);
          if ($ === null || a($))
            return !0;
          var D = d($);
          if (D) {
            var U = D.call($), q;
            if (D !== $.entries) {
              for (; !(q = U.next()).done; )
                if (!O(q.value))
                  return !1;
            } else
              for (; !(q = U.next()).done; ) {
                var F = q.value;
                if (F && !O(F[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function k($, D) {
      return $ === "symbol" ? !0 : D ? D["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && D instanceof Symbol : !1;
    }
    function T($) {
      var D = typeof $;
      return Array.isArray($) ? "array" : $ instanceof RegExp ? "object" : k(D, $) ? "symbol" : D;
    }
    function I($) {
      if (typeof $ > "u" || $ === null)
        return "" + $;
      var D = T($);
      if (D === "object") {
        if ($ instanceof Date)
          return "date";
        if ($ instanceof RegExp)
          return "regexp";
      }
      return D;
    }
    function j($) {
      var D = I($);
      switch (D) {
        case "array":
        case "object":
          return "an " + D;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + D;
        default:
          return D;
      }
    }
    function z($) {
      return !$.constructor || !$.constructor.name ? f : $.constructor.name;
    }
    return h.checkPropTypes = o, h.resetWarningCache = o.resetWarningCache, h.PropTypes = h, h;
  }, VC;
}
var WC, P7;
function FLe() {
  if (P7) return WC;
  P7 = 1;
  var t = /* @__PURE__ */ W5();
  function e() {
  }
  function n() {
  }
  return n.resetWarningCache = e, WC = function() {
    function r(s, a, l, c, u, d) {
      if (d !== t) {
        var f = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw f.name = "Invariant Violation", f;
      }
    }
    r.isRequired = r;
    function o() {
      return r;
    }
    var i = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: o,
      element: r,
      elementType: r,
      instanceOf: o,
      node: r,
      objectOf: o,
      oneOf: o,
      oneOfType: o,
      shape: o,
      exact: o,
      checkPropTypes: n,
      resetWarningCache: e
    };
    return i.PropTypes = i, i;
  }, WC;
}
var $7;
function Tr() {
  if ($7) return wb.exports;
  if ($7 = 1, process.env.NODE_ENV !== "production") {
    var t = Yce(), e = !0;
    wb.exports = /* @__PURE__ */ LLe()(t.isElement, e);
  } else
    wb.exports = /* @__PURE__ */ FLe()();
  return wb.exports;
}
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var Xce = ["input:not([inert])", "select:not([inert])", "textarea:not([inert])", "a[href]:not([inert])", "button:not([inert])", "[tabindex]:not(slot):not([inert])", "audio[controls]:not([inert])", "video[controls]:not([inert])", '[contenteditable]:not([contenteditable="false"]):not([inert])', "details>summary:first-of-type:not([inert])", "details:not([inert])"], hx = /* @__PURE__ */ Xce.join(","), Qce = typeof Element > "u", Rd = Qce ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, px = !Qce && Element.prototype.getRootNode ? function(t) {
  var e;
  return t == null || (e = t.getRootNode) === null || e === void 0 ? void 0 : e.call(t);
} : function(t) {
  return t?.ownerDocument;
}, mx = function t(e, n) {
  var r;
  n === void 0 && (n = !0);
  var o = e == null || (r = e.getAttribute) === null || r === void 0 ? void 0 : r.call(e, "inert"), i = o === "" || o === "true", s = i || n && e && t(e.parentNode);
  return s;
}, BLe = function(t) {
  var e, n = t == null || (e = t.getAttribute) === null || e === void 0 ? void 0 : e.call(t, "contenteditable");
  return n === "" || n === "true";
}, Zce = function(t, e, n) {
  if (mx(t))
    return [];
  var r = Array.prototype.slice.apply(t.querySelectorAll(hx));
  return e && Rd.call(t, hx) && r.unshift(t), r = r.filter(n), r;
}, Jce = function t(e, n, r) {
  for (var o = [], i = Array.from(e); i.length; ) {
    var s = i.shift();
    if (!mx(s, !1))
      if (s.tagName === "SLOT") {
        var a = s.assignedElements(), l = a.length ? a : s.children, c = t(l, !0, r);
        r.flatten ? o.push.apply(o, c) : o.push({
          scopeParent: s,
          candidates: c
        });
      } else {
        var u = Rd.call(s, hx);
        u && r.filter(s) && (n || !e.includes(s)) && o.push(s);
        var d = s.shadowRoot || // check for an undisclosed shadow
        typeof r.getShadowRoot == "function" && r.getShadowRoot(s), f = !mx(d, !1) && (!r.shadowRootFilter || r.shadowRootFilter(s));
        if (d && f) {
          var h = t(d === !0 ? s.children : d.children, !0, r);
          r.flatten ? o.push.apply(o, h) : o.push({
            scopeParent: s,
            candidates: h
          });
        } else
          i.unshift.apply(i, s.children);
      }
  }
  return o;
}, eue = function(t) {
  return !isNaN(parseInt(t.getAttribute("tabindex"), 10));
}, Sc = function(t) {
  if (!t)
    throw new Error("No node provided");
  return t.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(t.tagName) || BLe(t)) && !eue(t) ? 0 : t.tabIndex;
}, zLe = function(t, e) {
  var n = Sc(t);
  return n < 0 && e && !eue(t) ? 0 : n;
}, qLe = function(t, e) {
  return t.tabIndex === e.tabIndex ? t.documentOrder - e.documentOrder : t.tabIndex - e.tabIndex;
}, tue = function(t) {
  return t.tagName === "INPUT";
}, ULe = function(t) {
  return tue(t) && t.type === "hidden";
}, HLe = function(t) {
  var e = t.tagName === "DETAILS" && Array.prototype.slice.apply(t.children).some(function(n) {
    return n.tagName === "SUMMARY";
  });
  return e;
}, VLe = function(t, e) {
  for (var n = 0; n < t.length; n++)
    if (t[n].checked && t[n].form === e)
      return t[n];
}, WLe = function(t) {
  if (!t.name)
    return !0;
  var e = t.form || px(t), n = function(i) {
    return e.querySelectorAll('input[type="radio"][name="' + i + '"]');
  }, r;
  if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function")
    r = n(window.CSS.escape(t.name));
  else
    try {
      r = n(t.name);
    } catch (i) {
      return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", i.message), !1;
    }
  var o = VLe(r, t.form);
  return !o || o === t;
}, GLe = function(t) {
  return tue(t) && t.type === "radio";
}, YLe = function(t) {
  return GLe(t) && !WLe(t);
}, KLe = function(t) {
  var e, n = t && px(t), r = (e = n) === null || e === void 0 ? void 0 : e.host, o = !1;
  if (n && n !== t) {
    var i, s, a;
    for (o = !!((i = r) !== null && i !== void 0 && (s = i.ownerDocument) !== null && s !== void 0 && s.contains(r) || t != null && (a = t.ownerDocument) !== null && a !== void 0 && a.contains(t)); !o && r; ) {
      var l, c, u;
      n = px(r), r = (l = n) === null || l === void 0 ? void 0 : l.host, o = !!((c = r) !== null && c !== void 0 && (u = c.ownerDocument) !== null && u !== void 0 && u.contains(r));
    }
  }
  return o;
}, M7 = function(t) {
  var e = t.getBoundingClientRect(), n = e.width, r = e.height;
  return n === 0 && r === 0;
}, XLe = function(t, e) {
  var n = e.displayCheck, r = e.getShadowRoot;
  if (getComputedStyle(t).visibility === "hidden")
    return !0;
  var o = Rd.call(t, "details>summary:first-of-type"), i = o ? t.parentElement : t;
  if (Rd.call(i, "details:not([open]) *"))
    return !0;
  if (!n || n === "full" || n === "legacy-full") {
    if (typeof r == "function") {
      for (var s = t; t; ) {
        var a = t.parentElement, l = px(t);
        if (a && !a.shadowRoot && r(a) === !0)
          return M7(t);
        t.assignedSlot ? t = t.assignedSlot : !a && l !== t.ownerDocument ? t = l.host : t = a;
      }
      t = s;
    }
    if (KLe(t))
      return !t.getClientRects().length;
    if (n !== "legacy-full")
      return !0;
  } else if (n === "non-zero-area")
    return M7(t);
  return !1;
}, QLe = function(t) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(t.tagName))
    for (var e = t.parentElement; e; ) {
      if (e.tagName === "FIELDSET" && e.disabled) {
        for (var n = 0; n < e.children.length; n++) {
          var r = e.children.item(n);
          if (r.tagName === "LEGEND")
            return Rd.call(e, "fieldset[disabled] *") ? !0 : !r.contains(t);
        }
        return !0;
      }
      e = e.parentElement;
    }
  return !1;
}, gx = function(t, e) {
  return !(e.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
  //  because we're limited in the type of selectors we can use in JSDom (see related
  //  note related to `candidateSelectors`)
  mx(e) || ULe(e) || XLe(e, t) || // For a details element with a summary, the summary element gets the focus
  HLe(e) || QLe(e));
}, SI = function(t, e) {
  return !(YLe(e) || Sc(e) < 0 || !gx(t, e));
}, ZLe = function(t) {
  var e = parseInt(t.getAttribute("tabindex"), 10);
  return !!(isNaN(e) || e >= 0);
}, JLe = function t(e) {
  var n = [], r = [];
  return e.forEach(function(o, i) {
    var s = !!o.scopeParent, a = s ? o.scopeParent : o, l = zLe(a, s), c = s ? t(o.candidates) : a;
    l === 0 ? s ? n.push.apply(n, c) : n.push(a) : r.push({
      documentOrder: i,
      tabIndex: l,
      item: o,
      isScope: s,
      content: c
    });
  }), r.sort(qLe).reduce(function(o, i) {
    return i.isScope ? o.push.apply(o, i.content) : o.push(i.content), o;
  }, []).concat(n);
}, nue = function(t, e) {
  e = e || {};
  var n;
  return e.getShadowRoot ? n = Jce([t], e.includeContainer, {
    filter: SI.bind(null, e),
    flatten: !1,
    getShadowRoot: e.getShadowRoot,
    shadowRootFilter: ZLe
  }) : n = Zce(t, e.includeContainer, SI.bind(null, e)), JLe(n);
}, rue = function(t, e) {
  e = e || {};
  var n;
  return e.getShadowRoot ? n = Jce([t], e.includeContainer, {
    filter: gx.bind(null, e),
    flatten: !0,
    getShadowRoot: e.getShadowRoot
  }) : n = Zce(t, e.includeContainer, gx.bind(null, e)), n;
}, Fu = function(t, e) {
  if (e = e || {}, !t)
    throw new Error("No node provided");
  return Rd.call(t, hx) === !1 ? !1 : SI(e, t);
}, e4e = /* @__PURE__ */ Xce.concat("iframe").join(","), ow = function(t, e) {
  if (e = e || {}, !t)
    throw new Error("No node provided");
  return Rd.call(t, e4e) === !1 ? !1 : gx(e, t);
};
const t4e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  focusable: rue,
  getTabIndex: Sc,
  isFocusable: ow,
  isTabbable: Fu,
  tabbable: nue
}, Symbol.toStringTag, { value: "Module" }));
/*!
* focus-trap 7.6.5
* @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
*/
function OI(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, r = Array(e); n < e; n++) r[n] = t[n];
  return r;
}
function n4e(t) {
  if (Array.isArray(t)) return OI(t);
}
function r4e(t, e, n) {
  return (e = l4e(e)) in t ? Object.defineProperty(t, e, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = n, t;
}
function o4e(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null) return Array.from(t);
}
function i4e() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function D7(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(t, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function I7(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? D7(Object(n), !0).forEach(function(r) {
      r4e(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : D7(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function s4e(t) {
  return n4e(t) || o4e(t) || c4e(t) || i4e();
}
function a4e(t, e) {
  if (typeof t != "object" || !t) return t;
  var n = t[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(t, e);
    if (typeof r != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function l4e(t) {
  var e = a4e(t, "string");
  return typeof e == "symbol" ? e : e + "";
}
function c4e(t, e) {
  if (t) {
    if (typeof t == "string") return OI(t, e);
    var n = {}.toString.call(t).slice(8, -1);
    return n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set" ? Array.from(t) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? OI(t, e) : void 0;
  }
}
var N7 = {
  activateTrap: function(t, e) {
    if (t.length > 0) {
      var n = t[t.length - 1];
      n !== e && n._setPausedState(!0);
    }
    var r = t.indexOf(e);
    r === -1 || t.splice(r, 1), t.push(e);
  },
  deactivateTrap: function(t, e) {
    var n = t.indexOf(e);
    n !== -1 && t.splice(n, 1), t.length > 0 && !t[t.length - 1]._isManuallyPaused() && t[t.length - 1]._setPausedState(!1);
  }
}, u4e = function(t) {
  return t.tagName && t.tagName.toLowerCase() === "input" && typeof t.select == "function";
}, d4e = function(t) {
  return t?.key === "Escape" || t?.key === "Esc" || t?.keyCode === 27;
}, Qg = function(t) {
  return t?.key === "Tab" || t?.keyCode === 9;
}, f4e = function(t) {
  return Qg(t) && !t.shiftKey;
}, h4e = function(t) {
  return Qg(t) && t.shiftKey;
}, j7 = function(t) {
  return setTimeout(t, 0);
}, rm = function(t) {
  for (var e = arguments.length, n = new Array(e > 1 ? e - 1 : 0), r = 1; r < e; r++)
    n[r - 1] = arguments[r];
  return typeof t == "function" ? t.apply(void 0, n) : t;
}, xb = function(t) {
  return t.target.shadowRoot && typeof t.composedPath == "function" ? t.composedPath()[0] : t.target;
}, p4e = [], m4e = function(t, e) {
  var n = e?.document || document, r = e?.trapStack || p4e, o = I7({
    returnFocusOnDeactivate: !0,
    escapeDeactivates: !0,
    delayInitialFocus: !0,
    isKeyForward: f4e,
    isKeyBackward: h4e
  }, e), i = {
    // containers given to createFocusTrap()
    // @type {Array<HTMLElement>}
    containers: [],
    // list of objects identifying tabbable nodes in `containers` in the trap
    // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
    //  is active, but the trap should never get to a state where there isn't at least one group
    //  with at least one tabbable node in it (that would lead to an error condition that would
    //  result in an error being thrown)
    // @type {Array<{
    //   container: HTMLElement,
    //   tabbableNodes: Array<HTMLElement>, // empty if none
    //   focusableNodes: Array<HTMLElement>, // empty if none
    //   posTabIndexesFound: boolean,
    //   firstTabbableNode: HTMLElement|undefined,
    //   lastTabbableNode: HTMLElement|undefined,
    //   firstDomTabbableNode: HTMLElement|undefined,
    //   lastDomTabbableNode: HTMLElement|undefined,
    //   nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
    // }>}
    containerGroups: [],
    // same order/length as `containers` list
    // references to objects in `containerGroups`, but only those that actually have
    //  tabbable nodes in them
    // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
    //  the same length
    tabbableGroups: [],
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: !1,
    paused: !1,
    manuallyPaused: !1,
    // timer ID for when delayInitialFocus is true and initial focus in this trap
    //  has been delayed during activation
    delayInitialFocusTimer: void 0,
    // the most recent KeyboardEvent for the configured nav key (typically [SHIFT+]TAB), if any
    recentNavEvent: void 0
  }, s, a = function(P, N, A) {
    return P && P[N] !== void 0 ? P[N] : o[A || N];
  }, l = function(P, N) {
    var A = typeof N?.composedPath == "function" ? N.composedPath() : void 0;
    return i.containerGroups.findIndex(function(O) {
      var k = O.container, T = O.tabbableNodes;
      return k.contains(P) || A?.includes(k) || T.find(function(I) {
        return I === P;
      });
    });
  }, c = function(P) {
    var N = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, A = N.hasFallback, O = A === void 0 ? !1 : A, k = N.params, T = k === void 0 ? [] : k, I = o[P];
    if (typeof I == "function" && (I = I.apply(void 0, s4e(T))), I === !0 && (I = void 0), !I) {
      if (I === void 0 || I === !1)
        return I;
      throw new Error("`".concat(P, "` was specified but was not a node, or did not return a node"));
    }
    var j = I;
    if (typeof I == "string") {
      try {
        j = n.querySelector(I);
      } catch (z) {
        throw new Error("`".concat(P, '` appears to be an invalid selector; error="').concat(z.message, '"'));
      }
      if (!j && !O)
        throw new Error("`".concat(P, "` as selector refers to no known node"));
    }
    return j;
  }, u = function() {
    var P = c("initialFocus", {
      hasFallback: !0
    });
    if (P === !1)
      return !1;
    if (P === void 0 || P && !ow(P, o.tabbableOptions))
      if (l(n.activeElement) >= 0)
        P = n.activeElement;
      else {
        var N = i.tabbableGroups[0], A = N && N.firstTabbableNode;
        P = A || c("fallbackFocus");
      }
    else P === null && (P = c("fallbackFocus"));
    if (!P)
      throw new Error("Your focus-trap needs to have at least one focusable element");
    return P;
  }, d = function() {
    if (i.containerGroups = i.containers.map(function(P) {
      var N = nue(P, o.tabbableOptions), A = rue(P, o.tabbableOptions), O = N.length > 0 ? N[0] : void 0, k = N.length > 0 ? N[N.length - 1] : void 0, T = A.find(function(z) {
        return Fu(z);
      }), I = A.slice().reverse().find(function(z) {
        return Fu(z);
      }), j = !!N.find(function(z) {
        return Sc(z) > 0;
      });
      return {
        container: P,
        tabbableNodes: N,
        focusableNodes: A,
        /** True if at least one node with positive `tabindex` was found in this container. */
        posTabIndexesFound: j,
        /** First tabbable node in container, __tabindex__ order; `undefined` if none. */
        firstTabbableNode: O,
        /** Last tabbable node in container, __tabindex__ order; `undefined` if none. */
        lastTabbableNode: k,
        // NOTE: DOM order is NOT NECESSARILY "document position" order, but figuring that out
        //  would require more than just https://developer.mozilla.org/en-US/docs/Web/API/Node/compareDocumentPosition
        //  because that API doesn't work with Shadow DOM as well as it should (@see
        //  https://github.com/whatwg/dom/issues/320) and since this first/last is only needed, so far,
        //  to address an edge case related to positive tabindex support, this seems like a much easier,
        //  "close enough most of the time" alternative for positive tabindexes which should generally
        //  be avoided anyway...
        /** First tabbable node in container, __DOM__ order; `undefined` if none. */
        firstDomTabbableNode: T,
        /** Last tabbable node in container, __DOM__ order; `undefined` if none. */
        lastDomTabbableNode: I,
        /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */
        nextTabbableNode: function(z) {
          var $ = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, D = N.indexOf(z);
          return D < 0 ? $ ? A.slice(A.indexOf(z) + 1).find(function(U) {
            return Fu(U);
          }) : A.slice(0, A.indexOf(z)).reverse().find(function(U) {
            return Fu(U);
          }) : N[D + ($ ? 1 : -1)];
        }
      };
    }), i.tabbableGroups = i.containerGroups.filter(function(P) {
      return P.tabbableNodes.length > 0;
    }), i.tabbableGroups.length <= 0 && !c("fallbackFocus"))
      throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
    if (i.containerGroups.find(function(P) {
      return P.posTabIndexesFound;
    }) && i.containerGroups.length > 1)
      throw new Error("At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps.");
  }, f = function(P) {
    var N = P.activeElement;
    if (N)
      return N.shadowRoot && N.shadowRoot.activeElement !== null ? f(N.shadowRoot) : N;
  }, h = function(P) {
    if (P !== !1 && P !== f(document)) {
      if (!P || !P.focus) {
        h(u());
        return;
      }
      P.focus({
        preventScroll: !!o.preventScroll
      }), i.mostRecentlyFocusedNode = P, u4e(P) && P.select();
    }
  }, p = function(P) {
    var N = c("setReturnFocus", {
      params: [P]
    });
    return N || (N === !1 ? !1 : P);
  }, m = function(P) {
    var N = P.target, A = P.event, O = P.isBackward, k = O === void 0 ? !1 : O;
    N = N || xb(A), d();
    var T = null;
    if (i.tabbableGroups.length > 0) {
      var I = l(N, A), j = I >= 0 ? i.containerGroups[I] : void 0;
      if (I < 0)
        k ? T = i.tabbableGroups[i.tabbableGroups.length - 1].lastTabbableNode : T = i.tabbableGroups[0].firstTabbableNode;
      else if (k) {
        var z = i.tabbableGroups.findIndex(function(B) {
          var H = B.firstTabbableNode;
          return N === H;
        });
        if (z < 0 && (j.container === N || ow(N, o.tabbableOptions) && !Fu(N, o.tabbableOptions) && !j.nextTabbableNode(N, !1)) && (z = I), z >= 0) {
          var $ = z === 0 ? i.tabbableGroups.length - 1 : z - 1, D = i.tabbableGroups[$];
          T = Sc(N) >= 0 ? D.lastTabbableNode : D.lastDomTabbableNode;
        } else Qg(A) || (T = j.nextTabbableNode(N, !1));
      } else {
        var U = i.tabbableGroups.findIndex(function(B) {
          var H = B.lastTabbableNode;
          return N === H;
        });
        if (U < 0 && (j.container === N || ow(N, o.tabbableOptions) && !Fu(N, o.tabbableOptions) && !j.nextTabbableNode(N)) && (U = I), U >= 0) {
          var q = U === i.tabbableGroups.length - 1 ? 0 : U + 1, F = i.tabbableGroups[q];
          T = Sc(N) >= 0 ? F.firstTabbableNode : F.firstDomTabbableNode;
        } else Qg(A) || (T = j.nextTabbableNode(N));
      }
    } else
      T = c("fallbackFocus");
    return T;
  }, g = function(P) {
    var N = xb(P);
    if (!(l(N, P) >= 0)) {
      if (rm(o.clickOutsideDeactivates, P)) {
        s.deactivate({
          // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
          //  which will result in the outside click setting focus to the node
          //  that was clicked (and if not focusable, to "nothing"); by setting
          //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
          //  on activation (or the configured `setReturnFocus` node), whether the
          //  outside click was on a focusable node or not
          returnFocus: o.returnFocusOnDeactivate
        });
        return;
      }
      rm(o.allowOutsideClick, P) || P.preventDefault();
    }
  }, y = function(P) {
    var N = xb(P), A = l(N, P) >= 0;
    if (A || N instanceof Document)
      A && (i.mostRecentlyFocusedNode = N);
    else {
      P.stopImmediatePropagation();
      var O, k = !0;
      if (i.mostRecentlyFocusedNode)
        if (Sc(i.mostRecentlyFocusedNode) > 0) {
          var T = l(i.mostRecentlyFocusedNode), I = i.containerGroups[T].tabbableNodes;
          if (I.length > 0) {
            var j = I.findIndex(function(z) {
              return z === i.mostRecentlyFocusedNode;
            });
            j >= 0 && (o.isKeyForward(i.recentNavEvent) ? j + 1 < I.length && (O = I[j + 1], k = !1) : j - 1 >= 0 && (O = I[j - 1], k = !1));
          }
        } else
          i.containerGroups.some(function(z) {
            return z.tabbableNodes.some(function($) {
              return Sc($) > 0;
            });
          }) || (k = !1);
      else
        k = !1;
      k && (O = m({
        // move FROM the MRU node, not event-related node (which will be the node that is
        //  outside the trap causing the focus escape we're trying to fix)
        target: i.mostRecentlyFocusedNode,
        isBackward: o.isKeyBackward(i.recentNavEvent)
      })), h(O || i.mostRecentlyFocusedNode || u());
    }
    i.recentNavEvent = void 0;
  }, v = function(P) {
    var N = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    i.recentNavEvent = P;
    var A = m({
      event: P,
      isBackward: N
    });
    A && (Qg(P) && P.preventDefault(), h(A));
  }, b = function(P) {
    (o.isKeyForward(P) || o.isKeyBackward(P)) && v(P, o.isKeyBackward(P));
  }, _ = function(P) {
    d4e(P) && rm(o.escapeDeactivates, P) !== !1 && (P.preventDefault(), s.deactivate());
  }, w = function(P) {
    var N = xb(P);
    l(N, P) >= 0 || rm(o.clickOutsideDeactivates, P) || rm(o.allowOutsideClick, P) || (P.preventDefault(), P.stopImmediatePropagation());
  }, x = function() {
    if (i.active)
      return N7.activateTrap(r, s), i.delayInitialFocusTimer = o.delayInitialFocus ? j7(function() {
        h(u());
      }) : h(u()), n.addEventListener("focusin", y, !0), n.addEventListener("mousedown", g, {
        capture: !0,
        passive: !1
      }), n.addEventListener("touchstart", g, {
        capture: !0,
        passive: !1
      }), n.addEventListener("click", w, {
        capture: !0,
        passive: !1
      }), n.addEventListener("keydown", b, {
        capture: !0,
        passive: !1
      }), n.addEventListener("keydown", _), s;
  }, E = function() {
    if (i.active)
      return n.removeEventListener("focusin", y, !0), n.removeEventListener("mousedown", g, !0), n.removeEventListener("touchstart", g, !0), n.removeEventListener("click", w, !0), n.removeEventListener("keydown", b, !0), n.removeEventListener("keydown", _), s;
  }, S = function(P) {
    var N = P.some(function(A) {
      var O = Array.from(A.removedNodes);
      return O.some(function(k) {
        return k === i.mostRecentlyFocusedNode;
      });
    });
    N && h(u());
  }, C = typeof window < "u" && "MutationObserver" in window ? new MutationObserver(S) : void 0, R = function() {
    C && (C.disconnect(), i.active && !i.paused && i.containers.map(function(P) {
      C.observe(P, {
        subtree: !0,
        childList: !0
      });
    }));
  };
  return s = {
    get active() {
      return i.active;
    },
    get paused() {
      return i.paused;
    },
    activate: function(P) {
      if (i.active)
        return this;
      var N = a(P, "onActivate"), A = a(P, "onPostActivate"), O = a(P, "checkCanFocusTrap");
      O || d(), i.active = !0, i.paused = !1, i.nodeFocusedBeforeActivation = f(n), N?.();
      var k = function() {
        O && d(), x(), R(), A?.();
      };
      return O ? (O(i.containers.concat()).then(k, k), this) : (k(), this);
    },
    deactivate: function(P) {
      if (!i.active)
        return this;
      var N = I7({
        onDeactivate: o.onDeactivate,
        onPostDeactivate: o.onPostDeactivate,
        checkCanReturnFocus: o.checkCanReturnFocus
      }, P);
      clearTimeout(i.delayInitialFocusTimer), i.delayInitialFocusTimer = void 0, E(), i.active = !1, i.paused = !1, R(), N7.deactivateTrap(r, s);
      var A = a(N, "onDeactivate"), O = a(N, "onPostDeactivate"), k = a(N, "checkCanReturnFocus"), T = a(N, "returnFocus", "returnFocusOnDeactivate");
      A?.();
      var I = function() {
        j7(function() {
          T && h(p(i.nodeFocusedBeforeActivation)), O?.();
        });
      };
      return T && k ? (k(p(i.nodeFocusedBeforeActivation)).then(I, I), this) : (I(), this);
    },
    pause: function(P) {
      return i.active ? (i.manuallyPaused = !0, this._setPausedState(!0, P)) : this;
    },
    unpause: function(P) {
      return i.active ? (i.manuallyPaused = !1, r[r.length - 1] !== this ? this : this._setPausedState(!1, P)) : this;
    },
    updateContainerElements: function(P) {
      var N = [].concat(P).filter(Boolean);
      return i.containers = N.map(function(A) {
        return typeof A == "string" ? n.querySelector(A) : A;
      }), i.active && d(), R(), this;
    }
  }, Object.defineProperties(s, {
    _isManuallyPaused: {
      value: function() {
        return i.manuallyPaused;
      }
    },
    _setPausedState: {
      value: function(P, N) {
        if (i.paused === P)
          return this;
        if (i.paused = P, P) {
          var A = a(N, "onPause"), O = a(N, "onPostPause");
          A?.(), E(), R(), O?.();
        } else {
          var k = a(N, "onUnpause"), T = a(N, "onPostUnpause");
          k?.(), d(), x(), R(), T?.();
        }
        return this;
      }
    }
  }), s.updateContainerElements(t), s;
};
const g4e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  createFocusTrap: m4e
}, Symbol.toStringTag, { value: "Module" })), y4e = /* @__PURE__ */ Zy(g4e), v4e = /* @__PURE__ */ Zy(t4e);
var GC, L7;
function b4e() {
  if (L7) return GC;
  L7 = 1;
  function t(x) {
    "@babel/helpers - typeof";
    return t = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(E) {
      return typeof E;
    } : function(E) {
      return E && typeof Symbol == "function" && E.constructor === Symbol && E !== Symbol.prototype ? "symbol" : typeof E;
    }, t(x);
  }
  function e(x, E) {
    if (!(x instanceof E)) throw new TypeError("Cannot call a class as a function");
  }
  function n(x, E) {
    for (var S = 0; S < E.length; S++) {
      var C = E[S];
      C.enumerable = C.enumerable || !1, C.configurable = !0, "value" in C && (C.writable = !0), Object.defineProperty(x, f(C.key), C);
    }
  }
  function r(x, E, S) {
    return E && n(x.prototype, E), Object.defineProperty(x, "prototype", { writable: !1 }), x;
  }
  function o(x, E, S) {
    return E = l(E), i(x, a() ? Reflect.construct(E, S || [], l(x).constructor) : E.apply(x, S));
  }
  function i(x, E) {
    if (E && (t(E) == "object" || typeof E == "function")) return E;
    if (E !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return s(x);
  }
  function s(x) {
    if (x === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return x;
  }
  function a() {
    try {
      var x = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
    } catch {
    }
    return (a = function() {
      return !!x;
    })();
  }
  function l(x) {
    return l = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(E) {
      return E.__proto__ || Object.getPrototypeOf(E);
    }, l(x);
  }
  function c(x, E) {
    if (typeof E != "function" && E !== null) throw new TypeError("Super expression must either be null or a function");
    x.prototype = Object.create(E && E.prototype, { constructor: { value: x, writable: !0, configurable: !0 } }), Object.defineProperty(x, "prototype", { writable: !1 }), E && u(x, E);
  }
  function u(x, E) {
    return u = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(S, C) {
      return S.__proto__ = C, S;
    }, u(x, E);
  }
  function d(x, E, S) {
    return (E = f(E)) in x ? Object.defineProperty(x, E, { value: S, enumerable: !0, configurable: !0, writable: !0 }) : x[E] = S, x;
  }
  function f(x) {
    var E = h(x, "string");
    return t(E) == "symbol" ? E : E + "";
  }
  function h(x, E) {
    if (t(x) != "object" || !x) return x;
    var S = x[Symbol.toPrimitive];
    if (S !== void 0) {
      var C = S.call(x, E);
      if (t(C) != "object") return C;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return String(x);
  }
  var p = xe, m = /* @__PURE__ */ Tr(), g = y4e, y = g.createFocusTrap, v = v4e, b = v.isFocusable, _ = /* @__PURE__ */ function(x) {
    function E(S) {
      var C;
      e(this, E), C = o(this, E, [S]), d(C, "getNodeForOption", function(N) {
        var A, O = (A = this.internalOptions[N]) !== null && A !== void 0 ? A : this.originalOptions[N];
        if (typeof O == "function") {
          for (var k = arguments.length, T = new Array(k > 1 ? k - 1 : 0), I = 1; I < k; I++)
            T[I - 1] = arguments[I];
          O = O.apply(void 0, T);
        }
        if (O === !0 && (O = void 0), !O) {
          if (O === void 0 || O === !1)
            return O;
          throw new Error("`".concat(N, "` was specified but was not a node, or did not return a node"));
        }
        var j = O;
        if (typeof O == "string") {
          var z;
          if (j = (z = this.getDocument()) === null || z === void 0 ? void 0 : z.querySelector(O), !j)
            throw new Error("`".concat(N, "` as selector refers to no known node"));
        }
        return j;
      }), C.handleDeactivate = C.handleDeactivate.bind(C), C.handlePostDeactivate = C.handlePostDeactivate.bind(C), C.handleClickOutsideDeactivates = C.handleClickOutsideDeactivates.bind(C), C.internalOptions = {
        // We need to hijack the returnFocusOnDeactivate option,
        // because React can move focus into the element before we arrived at
        // this lifecycle hook (e.g. with autoFocus inputs). So the component
        // captures the previouslyFocusedElement in componentWillMount,
        // then (optionally) returns focus to it in componentWillUnmount.
        returnFocusOnDeactivate: !1,
        // the rest of these are also related to deactivation of the trap, and we
        //  need to use them and control them as well
        checkCanReturnFocus: null,
        onDeactivate: C.handleDeactivate,
        onPostDeactivate: C.handlePostDeactivate,
        // we need to special-case this setting as well so that we can know if we should
        //  NOT return focus if the trap gets auto-deactivated as the result of an
        //  outside click (otherwise, we'll always think we should return focus because
        //  of how we manage that flag internally here)
        clickOutsideDeactivates: C.handleClickOutsideDeactivates
      }, C.originalOptions = {
        // because of the above `internalOptions`, we maintain our own flag for
        //  this option, and default it to `true` because that's focus-trap's default
        returnFocusOnDeactivate: !0,
        // because of the above `internalOptions`, we keep these separate since
        //  they're part of the deactivation process which we configure (internally) to
        //  be shared between focus-trap and focus-trap-react
        onDeactivate: null,
        onPostDeactivate: null,
        checkCanReturnFocus: null,
        // the user's setting, defaulted to false since focus-trap defaults this to false
        clickOutsideDeactivates: !1
      };
      var R = S.focusTrapOptions;
      for (var P in R)
        if (Object.prototype.hasOwnProperty.call(R, P)) {
          if (P === "returnFocusOnDeactivate" || P === "onDeactivate" || P === "onPostDeactivate" || P === "checkCanReturnFocus" || P === "clickOutsideDeactivates") {
            C.originalOptions[P] = R[P];
            continue;
          }
          C.internalOptions[P] = R[P];
        }
      return C.outsideClick = null, C.focusTrapElements = S.containerElements || [], C.updatePreviousElement(), C;
    }
    return c(E, x), r(E, [{
      key: "getDocument",
      value: function() {
        return this.props.focusTrapOptions.document || (typeof document < "u" ? document : void 0);
      }
    }, {
      key: "getReturnFocusNode",
      value: function() {
        var S = this.getNodeForOption("setReturnFocus", this.previouslyFocusedElement);
        return S || (S === !1 ? !1 : this.previouslyFocusedElement);
      }
      /** Update the previously focused element with the currently focused element. */
    }, {
      key: "updatePreviousElement",
      value: function() {
        var S = this.getDocument();
        S && (this.previouslyFocusedElement = S.activeElement);
      }
    }, {
      key: "deactivateTrap",
      value: function() {
        !this.focusTrap || !this.focusTrap.active || this.focusTrap.deactivate({
          // NOTE: we never let the trap return the focus since we do that ourselves
          returnFocus: !1,
          // we'll call this in our own post deactivate handler so make sure the trap doesn't
          //  do it prematurely
          checkCanReturnFocus: null,
          // let it call the user's original deactivate handler, if any, instead of
          //  our own which calls back into this function
          onDeactivate: this.originalOptions.onDeactivate
          // NOTE: for post deactivate, don't specify anything so that it calls the
          //  onPostDeactivate handler specified on `this.internalOptions`
          //  which will always be our own `handlePostDeactivate()` handler, which
          //  will finish things off by calling the user's provided onPostDeactivate
          //  handler, if any, at the right time
          // onPostDeactivate: NOTHING
        });
      }
    }, {
      key: "handleClickOutsideDeactivates",
      value: function(S) {
        var C = typeof this.originalOptions.clickOutsideDeactivates == "function" ? this.originalOptions.clickOutsideDeactivates.call(null, S) : this.originalOptions.clickOutsideDeactivates;
        return C && (this.outsideClick = {
          target: S.target,
          allowDeactivation: C
        }), C;
      }
    }, {
      key: "handleDeactivate",
      value: function() {
        this.originalOptions.onDeactivate && this.originalOptions.onDeactivate.call(null), this.deactivateTrap();
      }
    }, {
      key: "handlePostDeactivate",
      value: function() {
        var S = this, C = function() {
          var R = S.getReturnFocusNode(), P = !!// did the consumer allow it?
          (S.originalOptions.returnFocusOnDeactivate && // can we actually focus the node?
          R !== null && R !== void 0 && R.focus && // was there an outside click that allowed deactivation?
          (!S.outsideClick || // did the consumer allow deactivation when the outside node was clicked?
          S.outsideClick.allowDeactivation && // is the outside node NOT focusable (implying that it did NOT receive focus
          //  as a result of the click-through) -- in which case do NOT restore focus
          //  to `returnFocusNode` because focus should remain on the outside node
          !b(S.outsideClick.target, S.internalOptions.tabbableOptions))), N = S.internalOptions.preventScroll, A = N === void 0 ? !1 : N;
          P && R.focus({
            preventScroll: A
          }), S.originalOptions.onPostDeactivate && S.originalOptions.onPostDeactivate.call(null), S.outsideClick = null;
        };
        this.originalOptions.checkCanReturnFocus ? this.originalOptions.checkCanReturnFocus.call(null, this.getReturnFocusNode()).then(C, C) : C();
      }
    }, {
      key: "setupFocusTrap",
      value: function() {
        if (this.focusTrap)
          this.props.active && !this.focusTrap.active && (this.focusTrap.activate(), this.props.paused && this.focusTrap.pause());
        else {
          var S = this.focusTrapElements.some(Boolean);
          S && (this.focusTrap = this.props._createFocusTrap(this.focusTrapElements, this.internalOptions), this.props.active && this.focusTrap.activate(), this.props.paused && this.focusTrap.pause());
        }
      }
    }, {
      key: "componentDidMount",
      value: function() {
        this.props.active && this.setupFocusTrap();
      }
    }, {
      key: "componentDidUpdate",
      value: function(S) {
        if (this.focusTrap) {
          S.containerElements !== this.props.containerElements && this.focusTrap.updateContainerElements(this.props.containerElements);
          var C = !S.active && this.props.active, R = S.active && !this.props.active, P = !S.paused && this.props.paused, N = S.paused && !this.props.paused;
          if (C && (this.updatePreviousElement(), this.focusTrap.activate()), R) {
            this.deactivateTrap();
            return;
          }
          P && this.focusTrap.pause(), N && this.focusTrap.unpause();
        } else
          S.containerElements !== this.props.containerElements && (this.focusTrapElements = this.props.containerElements), this.props.active && (this.updatePreviousElement(), this.setupFocusTrap());
      }
    }, {
      key: "componentWillUnmount",
      value: function() {
        this.deactivateTrap();
      }
    }, {
      key: "render",
      value: function() {
        var S = this, C = this.props.children ? p.Children.only(this.props.children) : void 0;
        if (C) {
          if (C.type && C.type === p.Fragment)
            throw new Error("A focus-trap cannot use a Fragment as its child container. Try replacing it with a <div> element.");
          var R = function(N) {
            var A = S.props.containerElements;
            C && (typeof C.ref == "function" ? C.ref(N) : C.ref && (C.ref.current = N)), S.focusTrapElements = A || [N];
          }, P = p.cloneElement(C, {
            ref: R
          });
          return P;
        }
        return null;
      }
    }]);
  }(p.Component), w = typeof Element > "u" ? Function : Element;
  return _.propTypes = {
    active: m.bool,
    paused: m.bool,
    focusTrapOptions: m.shape({
      document: m.object,
      onActivate: m.func,
      onPostActivate: m.func,
      checkCanFocusTrap: m.func,
      onPause: m.func,
      onPostPause: m.func,
      onUnpause: m.func,
      onPostUnpause: m.func,
      onDeactivate: m.func,
      onPostDeactivate: m.func,
      checkCanReturnFocus: m.func,
      initialFocus: m.oneOfType([m.instanceOf(w), m.string, m.bool, m.func]),
      fallbackFocus: m.oneOfType([
        m.instanceOf(w),
        m.string,
        // NOTE: does not support `false` as value (or return value from function)
        m.func
      ]),
      escapeDeactivates: m.oneOfType([m.bool, m.func]),
      clickOutsideDeactivates: m.oneOfType([m.bool, m.func]),
      returnFocusOnDeactivate: m.bool,
      setReturnFocus: m.oneOfType([m.instanceOf(w), m.string, m.bool, m.func]),
      allowOutsideClick: m.oneOfType([m.bool, m.func]),
      preventScroll: m.bool,
      tabbableOptions: m.shape({
        displayCheck: m.oneOf(["full", "legacy-full", "non-zero-area", "none"]),
        getShadowRoot: m.oneOfType([m.bool, m.func])
      }),
      trapStack: m.array,
      isKeyForward: m.func,
      isKeyBackward: m.func
    }),
    containerElements: m.arrayOf(m.instanceOf(w)),
    // DOM element ONLY
    children: m.oneOfType([
      m.element,
      // React element
      m.instanceOf(w)
      // DOM element
    ])
    // NOTE: _createFocusTrap is internal, for testing purposes only, so we don't
    //  specify it here. It's expected to be set to the function returned from
    //  require('focus-trap'), or one with a compatible interface.
  }, _.defaultProps = {
    active: !0,
    paused: !1,
    focusTrapOptions: {},
    _createFocusTrap: y
  }, GC = _, GC;
}
var _4e = b4e();
const w4e = /* @__PURE__ */ bp(_4e);
var om = { exports: {} }, F7 = {};
const x4e = /* @__PURE__ */ Zy(G5e);
var mr = {}, tc = {}, B7;
function SS() {
  if (B7) return tc;
  B7 = 1, Object.defineProperty(tc, "__esModule", {
    value: !0
  }), tc.dontSetMe = o, tc.findInArray = t, tc.int = r, tc.isFunction = e, tc.isNum = n;
  function t(i, s) {
    for (let a = 0, l = i.length; a < l; a++)
      if (s.apply(s, [i[a], a, i])) return i[a];
  }
  function e(i) {
    return typeof i == "function" || Object.prototype.toString.call(i) === "[object Function]";
  }
  function n(i) {
    return typeof i == "number" && !isNaN(i);
  }
  function r(i) {
    return parseInt(i, 10);
  }
  function o(i, s, a) {
    if (i[s])
      return new Error("Invalid prop ".concat(s, " passed to ").concat(a, " - do not set this, set it on the child."));
  }
  return tc;
}
var nc = {}, z7;
function E4e() {
  if (z7) return nc;
  z7 = 1, Object.defineProperty(nc, "__esModule", {
    value: !0
  }), nc.browserPrefixToKey = n, nc.browserPrefixToStyle = r, nc.default = void 0, nc.getPrefix = e;
  const t = ["Moz", "Webkit", "O", "ms"];
  function e() {
    var i;
    let s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "transform";
    if (typeof window > "u") return "";
    const a = (i = window.document) === null || i === void 0 || (i = i.documentElement) === null || i === void 0 ? void 0 : i.style;
    if (!a || s in a) return "";
    for (let l = 0; l < t.length; l++)
      if (n(s, t[l]) in a) return t[l];
    return "";
  }
  function n(i, s) {
    return s ? "".concat(s).concat(o(i)) : i;
  }
  function r(i, s) {
    return s ? "-".concat(s.toLowerCase(), "-").concat(i) : i;
  }
  function o(i) {
    let s = "", a = !0;
    for (let l = 0; l < i.length; l++)
      a ? (s += i[l].toUpperCase(), a = !1) : i[l] === "-" ? a = !0 : s += i[l];
    return s;
  }
  return nc.default = e(), nc;
}
var q7;
function G5() {
  if (q7) return mr;
  q7 = 1, Object.defineProperty(mr, "__esModule", {
    value: !0
  }), mr.addClassName = w, mr.addEvent = a, mr.addUserSelectStyles = b, mr.createCSSTransform = p, mr.createSVGTransform = m, mr.getTouch = y, mr.getTouchIdentifier = v, mr.getTranslation = g, mr.innerHeight = d, mr.innerWidth = f, mr.matchesSelector = i, mr.matchesSelectorAndParentsTo = s, mr.offsetXYFromParent = h, mr.outerHeight = c, mr.outerWidth = u, mr.removeClassName = x, mr.removeEvent = l, mr.removeUserSelectStyles = _;
  var t = SS(), e = r(E4e());
  function n(E) {
    if (typeof WeakMap != "function") return null;
    var S = /* @__PURE__ */ new WeakMap(), C = /* @__PURE__ */ new WeakMap();
    return (n = function(R) {
      return R ? C : S;
    })(E);
  }
  function r(E, S) {
    if (E && E.__esModule)
      return E;
    if (E === null || typeof E != "object" && typeof E != "function")
      return { default: E };
    var C = n(S);
    if (C && C.has(E))
      return C.get(E);
    var R = {}, P = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var N in E)
      if (N !== "default" && Object.prototype.hasOwnProperty.call(E, N)) {
        var A = P ? Object.getOwnPropertyDescriptor(E, N) : null;
        A && (A.get || A.set) ? Object.defineProperty(R, N, A) : R[N] = E[N];
      }
    return R.default = E, C && C.set(E, R), R;
  }
  let o = "";
  function i(E, S) {
    return o || (o = (0, t.findInArray)(["matches", "webkitMatchesSelector", "mozMatchesSelector", "msMatchesSelector", "oMatchesSelector"], function(C) {
      return (0, t.isFunction)(E[C]);
    })), (0, t.isFunction)(E[o]) ? E[o](S) : !1;
  }
  function s(E, S, C) {
    let R = E;
    do {
      if (i(R, S)) return !0;
      if (R === C) return !1;
      R = R.parentNode;
    } while (R);
    return !1;
  }
  function a(E, S, C, R) {
    if (!E) return;
    const P = {
      capture: !0,
      ...R
    };
    E.addEventListener ? E.addEventListener(S, C, P) : E.attachEvent ? E.attachEvent("on" + S, C) : E["on" + S] = C;
  }
  function l(E, S, C, R) {
    if (!E) return;
    const P = {
      capture: !0,
      ...R
    };
    E.removeEventListener ? E.removeEventListener(S, C, P) : E.detachEvent ? E.detachEvent("on" + S, C) : E["on" + S] = null;
  }
  function c(E) {
    let S = E.clientHeight;
    const C = E.ownerDocument.defaultView.getComputedStyle(E);
    return S += (0, t.int)(C.borderTopWidth), S += (0, t.int)(C.borderBottomWidth), S;
  }
  function u(E) {
    let S = E.clientWidth;
    const C = E.ownerDocument.defaultView.getComputedStyle(E);
    return S += (0, t.int)(C.borderLeftWidth), S += (0, t.int)(C.borderRightWidth), S;
  }
  function d(E) {
    let S = E.clientHeight;
    const C = E.ownerDocument.defaultView.getComputedStyle(E);
    return S -= (0, t.int)(C.paddingTop), S -= (0, t.int)(C.paddingBottom), S;
  }
  function f(E) {
    let S = E.clientWidth;
    const C = E.ownerDocument.defaultView.getComputedStyle(E);
    return S -= (0, t.int)(C.paddingLeft), S -= (0, t.int)(C.paddingRight), S;
  }
  function h(E, S, C) {
    const R = S === S.ownerDocument.body ? {
      left: 0,
      top: 0
    } : S.getBoundingClientRect(), P = (E.clientX + S.scrollLeft - R.left) / C, N = (E.clientY + S.scrollTop - R.top) / C;
    return {
      x: P,
      y: N
    };
  }
  function p(E, S) {
    const C = g(E, S, "px");
    return {
      [(0, e.browserPrefixToKey)("transform", e.default)]: C
    };
  }
  function m(E, S) {
    return g(E, S, "");
  }
  function g(E, S, C) {
    let {
      x: R,
      y: P
    } = E, N = "translate(".concat(R).concat(C, ",").concat(P).concat(C, ")");
    if (S) {
      const A = "".concat(typeof S.x == "string" ? S.x : S.x + C), O = "".concat(typeof S.y == "string" ? S.y : S.y + C);
      N = "translate(".concat(A, ", ").concat(O, ")") + N;
    }
    return N;
  }
  function y(E, S) {
    return E.targetTouches && (0, t.findInArray)(E.targetTouches, (C) => S === C.identifier) || E.changedTouches && (0, t.findInArray)(E.changedTouches, (C) => S === C.identifier);
  }
  function v(E) {
    if (E.targetTouches && E.targetTouches[0]) return E.targetTouches[0].identifier;
    if (E.changedTouches && E.changedTouches[0]) return E.changedTouches[0].identifier;
  }
  function b(E) {
    if (!E) return;
    let S = E.getElementById("react-draggable-style-el");
    S || (S = E.createElement("style"), S.type = "text/css", S.id = "react-draggable-style-el", S.innerHTML = `.react-draggable-transparent-selection *::-moz-selection {all: inherit;}
`, S.innerHTML += `.react-draggable-transparent-selection *::selection {all: inherit;}
`, E.getElementsByTagName("head")[0].appendChild(S)), E.body && w(E.body, "react-draggable-transparent-selection");
  }
  function _(E) {
    if (E)
      try {
        if (E.body && x(E.body, "react-draggable-transparent-selection"), E.selection)
          E.selection.empty();
        else {
          const S = (E.defaultView || window).getSelection();
          S && S.type !== "Caret" && S.removeAllRanges();
        }
      } catch {
      }
  }
  function w(E, S) {
    E.classList ? E.classList.add(S) : E.className.match(new RegExp("(?:^|\\s)".concat(S, "(?!\\S)"))) || (E.className += " ".concat(S));
  }
  function x(E, S) {
    E.classList ? E.classList.remove(S) : E.className = E.className.replace(new RegExp("(?:^|\\s)".concat(S, "(?!\\S)"), "g"), "");
  }
  return mr;
}
var Bs = {}, U7;
function oue() {
  if (U7) return Bs;
  U7 = 1, Object.defineProperty(Bs, "__esModule", {
    value: !0
  }), Bs.canDragX = o, Bs.canDragY = i, Bs.createCoreData = a, Bs.createDraggableData = l, Bs.getBoundPosition = n, Bs.getControlPosition = s, Bs.snapToGrid = r;
  var t = SS(), e = G5();
  function n(d, f, h) {
    if (!d.props.bounds) return [f, h];
    let {
      bounds: p
    } = d.props;
    p = typeof p == "string" ? p : c(p);
    const m = u(d);
    if (typeof p == "string") {
      const {
        ownerDocument: g
      } = m, y = g.defaultView;
      let v;
      if (p === "parent" ? v = m.parentNode : v = g.querySelector(p), !(v instanceof y.HTMLElement))
        throw new Error('Bounds selector "' + p + '" could not find an element.');
      const b = v, _ = y.getComputedStyle(m), w = y.getComputedStyle(b);
      p = {
        left: -m.offsetLeft + (0, t.int)(w.paddingLeft) + (0, t.int)(_.marginLeft),
        top: -m.offsetTop + (0, t.int)(w.paddingTop) + (0, t.int)(_.marginTop),
        right: (0, e.innerWidth)(b) - (0, e.outerWidth)(m) - m.offsetLeft + (0, t.int)(w.paddingRight) - (0, t.int)(_.marginRight),
        bottom: (0, e.innerHeight)(b) - (0, e.outerHeight)(m) - m.offsetTop + (0, t.int)(w.paddingBottom) - (0, t.int)(_.marginBottom)
      };
    }
    return (0, t.isNum)(p.right) && (f = Math.min(f, p.right)), (0, t.isNum)(p.bottom) && (h = Math.min(h, p.bottom)), (0, t.isNum)(p.left) && (f = Math.max(f, p.left)), (0, t.isNum)(p.top) && (h = Math.max(h, p.top)), [f, h];
  }
  function r(d, f, h) {
    const p = Math.round(f / d[0]) * d[0], m = Math.round(h / d[1]) * d[1];
    return [p, m];
  }
  function o(d) {
    return d.props.axis === "both" || d.props.axis === "x";
  }
  function i(d) {
    return d.props.axis === "both" || d.props.axis === "y";
  }
  function s(d, f, h) {
    const p = typeof f == "number" ? (0, e.getTouch)(d, f) : null;
    if (typeof f == "number" && !p) return null;
    const m = u(h), g = h.props.offsetParent || m.offsetParent || m.ownerDocument.body;
    return (0, e.offsetXYFromParent)(p || d, g, h.props.scale);
  }
  function a(d, f, h) {
    const p = !(0, t.isNum)(d.lastX), m = u(d);
    return p ? {
      node: m,
      deltaX: 0,
      deltaY: 0,
      lastX: f,
      lastY: h,
      x: f,
      y: h
    } : {
      node: m,
      deltaX: f - d.lastX,
      deltaY: h - d.lastY,
      lastX: d.lastX,
      lastY: d.lastY,
      x: f,
      y: h
    };
  }
  function l(d, f) {
    const h = d.props.scale;
    return {
      node: f.node,
      x: d.state.x + f.deltaX / h,
      y: d.state.y + f.deltaY / h,
      deltaX: f.deltaX / h,
      deltaY: f.deltaY / h,
      lastX: d.state.x,
      lastY: d.state.y
    };
  }
  function c(d) {
    return {
      left: d.left,
      top: d.top,
      right: d.right,
      bottom: d.bottom
    };
  }
  function u(d) {
    const f = d.findDOMNode();
    if (!f)
      throw new Error("<DraggableCore>: Unmounted during event!");
    return f;
  }
  return Bs;
}
var im = {}, Eb = {}, H7;
function iue() {
  if (H7) return Eb;
  H7 = 1, Object.defineProperty(Eb, "__esModule", {
    value: !0
  }), Eb.default = t;
  function t() {
  }
  return Eb;
}
var V7;
function S4e() {
  if (V7) return im;
  V7 = 1, Object.defineProperty(im, "__esModule", {
    value: !0
  }), im.default = void 0;
  var t = c(xe), e = a(/* @__PURE__ */ Tr()), n = a(Kc), r = G5(), o = oue(), i = SS(), s = a(iue());
  function a(g) {
    return g && g.__esModule ? g : { default: g };
  }
  function l(g) {
    if (typeof WeakMap != "function") return null;
    var y = /* @__PURE__ */ new WeakMap(), v = /* @__PURE__ */ new WeakMap();
    return (l = function(b) {
      return b ? v : y;
    })(g);
  }
  function c(g, y) {
    if (g && g.__esModule)
      return g;
    if (g === null || typeof g != "object" && typeof g != "function")
      return { default: g };
    var v = l(y);
    if (v && v.has(g))
      return v.get(g);
    var b = {}, _ = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var w in g)
      if (w !== "default" && Object.prototype.hasOwnProperty.call(g, w)) {
        var x = _ ? Object.getOwnPropertyDescriptor(g, w) : null;
        x && (x.get || x.set) ? Object.defineProperty(b, w, x) : b[w] = g[w];
      }
    return b.default = g, v && v.set(g, b), b;
  }
  function u(g, y, v) {
    return y = d(y), y in g ? Object.defineProperty(g, y, { value: v, enumerable: !0, configurable: !0, writable: !0 }) : g[y] = v, g;
  }
  function d(g) {
    var y = f(g, "string");
    return typeof y == "symbol" ? y : String(y);
  }
  function f(g, y) {
    if (typeof g != "object" || g === null) return g;
    var v = g[Symbol.toPrimitive];
    if (v !== void 0) {
      var b = v.call(g, y);
      if (typeof b != "object") return b;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (y === "string" ? String : Number)(g);
  }
  const h = {
    touch: {
      start: "touchstart",
      move: "touchmove",
      stop: "touchend"
    },
    mouse: {
      start: "mousedown",
      move: "mousemove",
      stop: "mouseup"
    }
  };
  let p = h.mouse, m = class extends t.Component {
    constructor() {
      super(...arguments), u(this, "dragging", !1), u(this, "lastX", NaN), u(this, "lastY", NaN), u(this, "touchIdentifier", null), u(this, "mounted", !1), u(this, "handleDragStart", (g) => {
        if (this.props.onMouseDown(g), !this.props.allowAnyClick && typeof g.button == "number" && g.button !== 0) return !1;
        const y = this.findDOMNode();
        if (!y || !y.ownerDocument || !y.ownerDocument.body)
          throw new Error("<DraggableCore> not mounted on DragStart!");
        const {
          ownerDocument: v
        } = y;
        if (this.props.disabled || !(g.target instanceof v.defaultView.Node) || this.props.handle && !(0, r.matchesSelectorAndParentsTo)(g.target, this.props.handle, y) || this.props.cancel && (0, r.matchesSelectorAndParentsTo)(g.target, this.props.cancel, y))
          return;
        g.type === "touchstart" && g.preventDefault();
        const b = (0, r.getTouchIdentifier)(g);
        this.touchIdentifier = b;
        const _ = (0, o.getControlPosition)(g, b, this);
        if (_ == null) return;
        const {
          x: w,
          y: x
        } = _, E = (0, o.createCoreData)(this, w, x);
        (0, s.default)("DraggableCore: handleDragStart: %j", E), (0, s.default)("calling", this.props.onStart), !(this.props.onStart(g, E) === !1 || this.mounted === !1) && (this.props.enableUserSelectHack && (0, r.addUserSelectStyles)(v), this.dragging = !0, this.lastX = w, this.lastY = x, (0, r.addEvent)(v, p.move, this.handleDrag), (0, r.addEvent)(v, p.stop, this.handleDragStop));
      }), u(this, "handleDrag", (g) => {
        const y = (0, o.getControlPosition)(g, this.touchIdentifier, this);
        if (y == null) return;
        let {
          x: v,
          y: b
        } = y;
        if (Array.isArray(this.props.grid)) {
          let w = v - this.lastX, x = b - this.lastY;
          if ([w, x] = (0, o.snapToGrid)(this.props.grid, w, x), !w && !x) return;
          v = this.lastX + w, b = this.lastY + x;
        }
        const _ = (0, o.createCoreData)(this, v, b);
        if ((0, s.default)("DraggableCore: handleDrag: %j", _), this.props.onDrag(g, _) === !1 || this.mounted === !1) {
          try {
            this.handleDragStop(new MouseEvent("mouseup"));
          } catch {
            const w = document.createEvent("MouseEvents");
            w.initMouseEvent("mouseup", !0, !0, window, 0, 0, 0, 0, 0, !1, !1, !1, !1, 0, null), this.handleDragStop(w);
          }
          return;
        }
        this.lastX = v, this.lastY = b;
      }), u(this, "handleDragStop", (g) => {
        if (!this.dragging) return;
        const y = (0, o.getControlPosition)(g, this.touchIdentifier, this);
        if (y == null) return;
        let {
          x: v,
          y: b
        } = y;
        if (Array.isArray(this.props.grid)) {
          let x = v - this.lastX || 0, E = b - this.lastY || 0;
          [x, E] = (0, o.snapToGrid)(this.props.grid, x, E), v = this.lastX + x, b = this.lastY + E;
        }
        const _ = (0, o.createCoreData)(this, v, b);
        if (this.props.onStop(g, _) === !1 || this.mounted === !1) return !1;
        const w = this.findDOMNode();
        w && this.props.enableUserSelectHack && (0, r.removeUserSelectStyles)(w.ownerDocument), (0, s.default)("DraggableCore: handleDragStop: %j", _), this.dragging = !1, this.lastX = NaN, this.lastY = NaN, w && ((0, s.default)("DraggableCore: Removing handlers"), (0, r.removeEvent)(w.ownerDocument, p.move, this.handleDrag), (0, r.removeEvent)(w.ownerDocument, p.stop, this.handleDragStop));
      }), u(this, "onMouseDown", (g) => (p = h.mouse, this.handleDragStart(g))), u(this, "onMouseUp", (g) => (p = h.mouse, this.handleDragStop(g))), u(this, "onTouchStart", (g) => (p = h.touch, this.handleDragStart(g))), u(this, "onTouchEnd", (g) => (p = h.touch, this.handleDragStop(g)));
    }
    componentDidMount() {
      this.mounted = !0;
      const g = this.findDOMNode();
      g && (0, r.addEvent)(g, h.touch.start, this.onTouchStart, {
        passive: !1
      });
    }
    componentWillUnmount() {
      this.mounted = !1;
      const g = this.findDOMNode();
      if (g) {
        const {
          ownerDocument: y
        } = g;
        (0, r.removeEvent)(y, h.mouse.move, this.handleDrag), (0, r.removeEvent)(y, h.touch.move, this.handleDrag), (0, r.removeEvent)(y, h.mouse.stop, this.handleDragStop), (0, r.removeEvent)(y, h.touch.stop, this.handleDragStop), (0, r.removeEvent)(g, h.touch.start, this.onTouchStart, {
          passive: !1
        }), this.props.enableUserSelectHack && (0, r.removeUserSelectStyles)(y);
      }
    }
    // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
    // the underlying DOM node ourselves. See the README for more information.
    findDOMNode() {
      var g, y;
      return (g = this.props) !== null && g !== void 0 && g.nodeRef ? (y = this.props) === null || y === void 0 || (y = y.nodeRef) === null || y === void 0 ? void 0 : y.current : n.default.findDOMNode(this);
    }
    render() {
      return /* @__PURE__ */ t.cloneElement(t.Children.only(this.props.children), {
        // Note: mouseMove handler is attached to document so it will still function
        // when the user drags quickly and leaves the bounds of the element.
        onMouseDown: this.onMouseDown,
        onMouseUp: this.onMouseUp,
        // onTouchStart is added on `componentDidMount` so they can be added with
        // {passive: false}, which allows it to cancel. See
        // https://developers.google.com/web/updates/2017/01/scrolling-intervention
        onTouchEnd: this.onTouchEnd
      });
    }
  };
  return im.default = m, u(m, "displayName", "DraggableCore"), u(m, "propTypes", {
    /**
     * `allowAnyClick` allows dragging using any mouse button.
     * By default, we only accept the left button.
     *
     * Defaults to `false`.
     */
    allowAnyClick: e.default.bool,
    children: e.default.node.isRequired,
    /**
     * `disabled`, if true, stops the <Draggable> from dragging. All handlers,
     * with the exception of `onMouseDown`, will not fire.
     */
    disabled: e.default.bool,
    /**
     * By default, we add 'user-select:none' attributes to the document body
     * to prevent ugly text selection during drag. If this is causing problems
     * for your app, set this to `false`.
     */
    enableUserSelectHack: e.default.bool,
    /**
     * `offsetParent`, if set, uses the passed DOM node to compute drag offsets
     * instead of using the parent node.
     */
    offsetParent: function(g, y) {
      if (g[y] && g[y].nodeType !== 1)
        throw new Error("Draggable's offsetParent must be a DOM Node.");
    },
    /**
     * `grid` specifies the x and y that dragging should snap to.
     */
    grid: e.default.arrayOf(e.default.number),
    /**
     * `handle` specifies a selector to be used as the handle that initiates drag.
     *
     * Example:
     *
     * ```jsx
     *   let App = React.createClass({
     *       render: function () {
     *         return (
     *            <Draggable handle=".handle">
     *              <div>
     *                  <div className="handle">Click me to drag</div>
     *                  <div>This is some other content</div>
     *              </div>
     *           </Draggable>
     *         );
     *       }
     *   });
     * ```
     */
    handle: e.default.string,
    /**
     * `cancel` specifies a selector to be used to prevent drag initialization.
     *
     * Example:
     *
     * ```jsx
     *   let App = React.createClass({
     *       render: function () {
     *           return(
     *               <Draggable cancel=".cancel">
     *                   <div>
     *                     <div className="cancel">You can't drag from here</div>
     *                     <div>Dragging here works fine</div>
     *                   </div>
     *               </Draggable>
     *           );
     *       }
     *   });
     * ```
     */
    cancel: e.default.string,
    /* If running in React Strict mode, ReactDOM.findDOMNode() is deprecated.
     * Unfortunately, in order for <Draggable> to work properly, we need raw access
     * to the underlying DOM node. If you want to avoid the warning, pass a `nodeRef`
     * as in this example:
     *
     * function MyComponent() {
     *   const nodeRef = React.useRef(null);
     *   return (
     *     <Draggable nodeRef={nodeRef}>
     *       <div ref={nodeRef}>Example Target</div>
     *     </Draggable>
     *   );
     * }
     *
     * This can be used for arbitrarily nested components, so long as the ref ends up
     * pointing to the actual child DOM node and not a custom component.
     */
    nodeRef: e.default.object,
    /**
     * Called when dragging starts.
     * If this function returns the boolean false, dragging will be canceled.
     */
    onStart: e.default.func,
    /**
     * Called while dragging.
     * If this function returns the boolean false, dragging will be canceled.
     */
    onDrag: e.default.func,
    /**
     * Called when dragging stops.
     * If this function returns the boolean false, the drag will remain active.
     */
    onStop: e.default.func,
    /**
     * A workaround option which can be passed if onMouseDown needs to be accessed,
     * since it'll always be blocked (as there is internal use of onMouseDown)
     */
    onMouseDown: e.default.func,
    /**
     * `scale`, if set, applies scaling while dragging an element
     */
    scale: e.default.number,
    /**
     * These properties should be defined on the child, not here.
     */
    className: i.dontSetMe,
    style: i.dontSetMe,
    transform: i.dontSetMe
  }), u(m, "defaultProps", {
    allowAnyClick: !1,
    // by default only accept left click
    disabled: !1,
    enableUserSelectHack: !0,
    onStart: function() {
    },
    onDrag: function() {
    },
    onStop: function() {
    },
    onMouseDown: function() {
    },
    scale: 1
  }), im;
}
var W7;
function O4e() {
  return W7 || (W7 = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "DraggableCore", {
      enumerable: !0,
      get: function() {
        return l.default;
      }
    }), t.default = void 0;
    var e = f(xe), n = u(/* @__PURE__ */ Tr()), r = u(Kc), o = u(x4e), i = G5(), s = oue(), a = SS(), l = u(S4e()), c = u(iue());
    function u(v) {
      return v && v.__esModule ? v : { default: v };
    }
    function d(v) {
      if (typeof WeakMap != "function") return null;
      var b = /* @__PURE__ */ new WeakMap(), _ = /* @__PURE__ */ new WeakMap();
      return (d = function(w) {
        return w ? _ : b;
      })(v);
    }
    function f(v, b) {
      if (v && v.__esModule)
        return v;
      if (v === null || typeof v != "object" && typeof v != "function")
        return { default: v };
      var _ = d(b);
      if (_ && _.has(v))
        return _.get(v);
      var w = {}, x = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var E in v)
        if (E !== "default" && Object.prototype.hasOwnProperty.call(v, E)) {
          var S = x ? Object.getOwnPropertyDescriptor(v, E) : null;
          S && (S.get || S.set) ? Object.defineProperty(w, E, S) : w[E] = v[E];
        }
      return w.default = v, _ && _.set(v, w), w;
    }
    function h() {
      return h = Object.assign ? Object.assign.bind() : function(v) {
        for (var b = 1; b < arguments.length; b++) {
          var _ = arguments[b];
          for (var w in _)
            Object.prototype.hasOwnProperty.call(_, w) && (v[w] = _[w]);
        }
        return v;
      }, h.apply(this, arguments);
    }
    function p(v, b, _) {
      return b = m(b), b in v ? Object.defineProperty(v, b, { value: _, enumerable: !0, configurable: !0, writable: !0 }) : v[b] = _, v;
    }
    function m(v) {
      var b = g(v, "string");
      return typeof b == "symbol" ? b : String(b);
    }
    function g(v, b) {
      if (typeof v != "object" || v === null) return v;
      var _ = v[Symbol.toPrimitive];
      if (_ !== void 0) {
        var w = _.call(v, b);
        if (typeof w != "object") return w;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (b === "string" ? String : Number)(v);
    }
    class y extends e.Component {
      // React 16.3+
      // Arity (props, state)
      static getDerivedStateFromProps(b, _) {
        let {
          position: w
        } = b, {
          prevPropsPosition: x
        } = _;
        return w && (!x || w.x !== x.x || w.y !== x.y) ? ((0, c.default)("Draggable: getDerivedStateFromProps %j", {
          position: w,
          prevPropsPosition: x
        }), {
          x: w.x,
          y: w.y,
          prevPropsPosition: {
            ...w
          }
        }) : null;
      }
      constructor(b) {
        super(b), p(this, "onDragStart", (_, w) => {
          if ((0, c.default)("Draggable: onDragStart: %j", w), this.props.onStart(_, (0, s.createDraggableData)(this, w)) === !1) return !1;
          this.setState({
            dragging: !0,
            dragged: !0
          });
        }), p(this, "onDrag", (_, w) => {
          if (!this.state.dragging) return !1;
          (0, c.default)("Draggable: onDrag: %j", w);
          const x = (0, s.createDraggableData)(this, w), E = {
            x: x.x,
            y: x.y,
            slackX: 0,
            slackY: 0
          };
          if (this.props.bounds) {
            const {
              x: S,
              y: C
            } = E;
            E.x += this.state.slackX, E.y += this.state.slackY;
            const [R, P] = (0, s.getBoundPosition)(this, E.x, E.y);
            E.x = R, E.y = P, E.slackX = this.state.slackX + (S - E.x), E.slackY = this.state.slackY + (C - E.y), x.x = E.x, x.y = E.y, x.deltaX = E.x - this.state.x, x.deltaY = E.y - this.state.y;
          }
          if (this.props.onDrag(_, x) === !1) return !1;
          this.setState(E);
        }), p(this, "onDragStop", (_, w) => {
          if (!this.state.dragging || this.props.onStop(_, (0, s.createDraggableData)(this, w)) === !1) return !1;
          (0, c.default)("Draggable: onDragStop: %j", w);
          const x = {
            dragging: !1,
            slackX: 0,
            slackY: 0
          };
          if (this.props.position) {
            const {
              x: E,
              y: S
            } = this.props.position;
            x.x = E, x.y = S;
          }
          this.setState(x);
        }), this.state = {
          // Whether or not we are currently dragging.
          dragging: !1,
          // Whether or not we have been dragged before.
          dragged: !1,
          // Current transform x and y.
          x: b.position ? b.position.x : b.defaultPosition.x,
          y: b.position ? b.position.y : b.defaultPosition.y,
          prevPropsPosition: {
            ...b.position
          },
          // Used for compensating for out-of-bounds drags
          slackX: 0,
          slackY: 0,
          // Can only determine if SVG after mounting
          isElementSVG: !1
        }, b.position && !(b.onDrag || b.onStop) && console.warn("A `position` was applied to this <Draggable>, without drag handlers. This will make this component effectively undraggable. Please attach `onDrag` or `onStop` handlers so you can adjust the `position` of this element.");
      }
      componentDidMount() {
        typeof window.SVGElement < "u" && this.findDOMNode() instanceof window.SVGElement && this.setState({
          isElementSVG: !0
        });
      }
      componentWillUnmount() {
        this.setState({
          dragging: !1
        });
      }
      // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
      // the underlying DOM node ourselves. See the README for more information.
      findDOMNode() {
        var b, _;
        return (b = (_ = this.props) === null || _ === void 0 || (_ = _.nodeRef) === null || _ === void 0 ? void 0 : _.current) !== null && b !== void 0 ? b : r.default.findDOMNode(this);
      }
      render() {
        const {
          axis: b,
          bounds: _,
          children: w,
          defaultPosition: x,
          defaultClassName: E,
          defaultClassNameDragging: S,
          defaultClassNameDragged: C,
          position: R,
          positionOffset: P,
          scale: N,
          ...A
        } = this.props;
        let O = {}, k = null;
        const T = !R || this.state.dragging, I = R || x, j = {
          // Set left if horizontal drag is enabled
          x: (0, s.canDragX)(this) && T ? this.state.x : I.x,
          // Set top if vertical drag is enabled
          y: (0, s.canDragY)(this) && T ? this.state.y : I.y
        };
        this.state.isElementSVG ? k = (0, i.createSVGTransform)(j, P) : O = (0, i.createCSSTransform)(j, P);
        const z = (0, o.default)(w.props.className || "", E, {
          [S]: this.state.dragging,
          [C]: this.state.dragged
        });
        return /* @__PURE__ */ e.createElement(l.default, h({}, A, {
          onStart: this.onDragStart,
          onDrag: this.onDrag,
          onStop: this.onDragStop
        }), /* @__PURE__ */ e.cloneElement(e.Children.only(w), {
          className: z,
          style: {
            ...w.props.style,
            ...O
          },
          transform: k
        }));
      }
    }
    t.default = y, p(y, "displayName", "Draggable"), p(y, "propTypes", {
      // Accepts all props <DraggableCore> accepts.
      ...l.default.propTypes,
      /**
       * `axis` determines which axis the draggable can move.
       *
       *  Note that all callbacks will still return data as normal. This only
       *  controls flushing to the DOM.
       *
       * 'both' allows movement horizontally and vertically.
       * 'x' limits movement to horizontal axis.
       * 'y' limits movement to vertical axis.
       * 'none' limits all movement.
       *
       * Defaults to 'both'.
       */
      axis: n.default.oneOf(["both", "x", "y", "none"]),
      /**
       * `bounds` determines the range of movement available to the element.
       * Available values are:
       *
       * 'parent' restricts movement within the Draggable's parent node.
       *
       * Alternatively, pass an object with the following properties, all of which are optional:
       *
       * {left: LEFT_BOUND, right: RIGHT_BOUND, bottom: BOTTOM_BOUND, top: TOP_BOUND}
       *
       * All values are in px.
       *
       * Example:
       *
       * ```jsx
       *   let App = React.createClass({
       *       render: function () {
       *         return (
       *            <Draggable bounds={{right: 300, bottom: 300}}>
       *              <div>Content</div>
       *           </Draggable>
       *         );
       *       }
       *   });
       * ```
       */
      bounds: n.default.oneOfType([n.default.shape({
        left: n.default.number,
        right: n.default.number,
        top: n.default.number,
        bottom: n.default.number
      }), n.default.string, n.default.oneOf([!1])]),
      defaultClassName: n.default.string,
      defaultClassNameDragging: n.default.string,
      defaultClassNameDragged: n.default.string,
      /**
       * `defaultPosition` specifies the x and y that the dragged item should start at
       *
       * Example:
       *
       * ```jsx
       *      let App = React.createClass({
       *          render: function () {
       *              return (
       *                  <Draggable defaultPosition={{x: 25, y: 25}}>
       *                      <div>I start with transformX: 25px and transformY: 25px;</div>
       *                  </Draggable>
       *              );
       *          }
       *      });
       * ```
       */
      defaultPosition: n.default.shape({
        x: n.default.number,
        y: n.default.number
      }),
      positionOffset: n.default.shape({
        x: n.default.oneOfType([n.default.number, n.default.string]),
        y: n.default.oneOfType([n.default.number, n.default.string])
      }),
      /**
       * `position`, if present, defines the current position of the element.
       *
       *  This is similar to how form elements in React work - if no `position` is supplied, the component
       *  is uncontrolled.
       *
       * Example:
       *
       * ```jsx
       *      let App = React.createClass({
       *          render: function () {
       *              return (
       *                  <Draggable position={{x: 25, y: 25}}>
       *                      <div>I start with transformX: 25px and transformY: 25px;</div>
       *                  </Draggable>
       *              );
       *          }
       *      });
       * ```
       */
      position: n.default.shape({
        x: n.default.number,
        y: n.default.number
      }),
      /**
       * These properties should be defined on the child, not here.
       */
      className: a.dontSetMe,
      style: a.dontSetMe,
      transform: a.dontSetMe
    }), p(y, "defaultProps", {
      ...l.default.defaultProps,
      axis: "both",
      bounds: !1,
      defaultClassName: "react-draggable",
      defaultClassNameDragging: "react-draggable-dragging",
      defaultClassNameDragged: "react-draggable-dragged",
      defaultPosition: {
        x: 0,
        y: 0
      },
      scale: 1
    });
  }(F7)), F7;
}
var G7;
function C4e() {
  if (G7) return om.exports;
  G7 = 1;
  const {
    default: t,
    DraggableCore: e
  } = O4e();
  return om.exports = t, om.exports.default = t, om.exports.DraggableCore = e, om.exports;
}
var k4e = C4e();
const yx = /* @__PURE__ */ bp(k4e);
let CI = [], sue = [];
(() => {
  let t = "lc,34,7n,7,7b,19,,,,2,,2,,,20,b,1c,l,g,,2t,7,2,6,2,2,,4,z,,u,r,2j,b,1m,9,9,,o,4,,9,,3,,5,17,3,3b,f,,w,1j,,,,4,8,4,,3,7,a,2,t,,1m,,,,2,4,8,,9,,a,2,q,,2,2,1l,,4,2,4,2,2,3,3,,u,2,3,,b,2,1l,,4,5,,2,4,,k,2,m,6,,,1m,,,2,,4,8,,7,3,a,2,u,,1n,,,,c,,9,,14,,3,,1l,3,5,3,,4,7,2,b,2,t,,1m,,2,,2,,3,,5,2,7,2,b,2,s,2,1l,2,,,2,4,8,,9,,a,2,t,,20,,4,,2,3,,,8,,29,,2,7,c,8,2q,,2,9,b,6,22,2,r,,,,,,1j,e,,5,,2,5,b,,10,9,,2u,4,,6,,2,2,2,p,2,4,3,g,4,d,,2,2,6,,f,,jj,3,qa,3,t,3,t,2,u,2,1s,2,,7,8,,2,b,9,,19,3,3b,2,y,,3a,3,4,2,9,,6,3,63,2,2,,1m,,,7,,,,,2,8,6,a,2,,1c,h,1r,4,1c,7,,,5,,14,9,c,2,w,4,2,2,,3,1k,,,2,3,,,3,1m,8,2,2,48,3,,d,,7,4,,6,,3,2,5i,1m,,5,ek,,5f,x,2da,3,3x,,2o,w,fe,6,2x,2,n9w,4,,a,w,2,28,2,7k,,3,,4,,p,2,5,,47,2,q,i,d,,12,8,p,b,1a,3,1c,,2,4,2,2,13,,1v,6,2,2,2,2,c,,8,,1b,,1f,,,3,2,2,5,2,,,16,2,8,,6m,,2,,4,,fn4,,kh,g,g,g,a6,2,gt,,6a,,45,5,1ae,3,,2,5,4,14,3,4,,4l,2,fx,4,ar,2,49,b,4w,,1i,f,1k,3,1d,4,2,2,1x,3,10,5,,8,1q,,c,2,1g,9,a,4,2,,2n,3,2,,,2,6,,4g,,3,8,l,2,1l,2,,,,,m,,e,7,3,5,5f,8,2,3,,,n,,29,,2,6,,,2,,,2,,2,6j,,2,4,6,2,,2,r,2,2d,8,2,,,2,2y,,,,2,6,,,2t,3,2,4,,5,77,9,,2,6t,,a,2,,,4,,40,4,2,2,4,,w,a,14,6,2,4,8,,9,6,2,3,1a,d,,2,ba,7,,6,,,2a,m,2,7,,2,,2,3e,6,3,,,2,,7,,,20,2,3,,,,9n,2,f0b,5,1n,7,t4,,1r,4,29,,f5k,2,43q,,,3,4,5,8,8,2,7,u,4,44,3,1iz,1j,4,1e,8,,e,,m,5,,f,11s,7,,h,2,7,,2,,5,79,7,c5,4,15s,7,31,7,240,5,gx7k,2o,3k,6o".split(",").map((e) => e ? parseInt(e, 36) : 1);
  for (let e = 0, n = 0; e < t.length; e++)
    (e % 2 ? sue : CI).push(n = n + t[e]);
})();
function A4e(t) {
  if (t < 768) return !1;
  for (let e = 0, n = CI.length; ; ) {
    let r = e + n >> 1;
    if (t < CI[r]) n = r;
    else if (t >= sue[r]) e = r + 1;
    else return !0;
    if (e == n) return !1;
  }
}
function Y7(t) {
  return t >= 127462 && t <= 127487;
}
const K7 = 8205;
function T4e(t, e, n = !0, r = !0) {
  return (n ? aue : R4e)(t, e, r);
}
function aue(t, e, n) {
  if (e == t.length) return e;
  e && lue(t.charCodeAt(e)) && cue(t.charCodeAt(e - 1)) && e--;
  let r = YC(t, e);
  for (e += X7(r); e < t.length; ) {
    let o = YC(t, e);
    if (r == K7 || o == K7 || n && A4e(o))
      e += X7(o), r = o;
    else if (Y7(o)) {
      let i = 0, s = e - 2;
      for (; s >= 0 && Y7(YC(t, s)); )
        i++, s -= 2;
      if (i % 2 == 0) break;
      e += 2;
    } else
      break;
  }
  return e;
}
function R4e(t, e, n) {
  for (; e > 0; ) {
    let r = aue(t, e - 2, n);
    if (r < e) return r;
    e--;
  }
  return 0;
}
function YC(t, e) {
  let n = t.charCodeAt(e);
  if (!cue(n) || e + 1 == t.length) return n;
  let r = t.charCodeAt(e + 1);
  return lue(r) ? (n - 55296 << 10) + (r - 56320) + 65536 : n;
}
function lue(t) {
  return t >= 56320 && t < 57344;
}
function cue(t) {
  return t >= 55296 && t < 56320;
}
function X7(t) {
  return t < 65536 ? 1 : 2;
}
let ln = class uue {
  /**
  Get the line description around the given position.
  */
  lineAt(e) {
    if (e < 0 || e > this.length)
      throw new RangeError(`Invalid position ${e} in document of length ${this.length}`);
    return this.lineInner(e, !1, 1, 0);
  }
  /**
  Get the description for the given (1-based) line number.
  */
  line(e) {
    if (e < 1 || e > this.lines)
      throw new RangeError(`Invalid line number ${e} in ${this.lines}-line document`);
    return this.lineInner(e, !0, 1, 0);
  }
  /**
  Replace a range of the text with the given content.
  */
  replace(e, n, r) {
    [e, n] = Hh(this, e, n);
    let o = [];
    return this.decompose(
      0,
      e,
      o,
      2
      /* Open.To */
    ), r.length && r.decompose(
      0,
      r.length,
      o,
      3
      /* Open.To */
    ), this.decompose(
      n,
      this.length,
      o,
      1
      /* Open.From */
    ), iw.from(o, this.length - (n - e) + r.length);
  }
  /**
  Append another document to this one.
  */
  append(e) {
    return this.replace(this.length, this.length, e);
  }
  /**
  Retrieve the text between the given points.
  */
  slice(e, n = this.length) {
    [e, n] = Hh(this, e, n);
    let r = [];
    return this.decompose(e, n, r, 0), iw.from(r, n - e);
  }
  /**
  Test whether this text is equal to another instance.
  */
  eq(e) {
    if (e == this)
      return !0;
    if (e.length != this.length || e.lines != this.lines)
      return !1;
    let n = this.scanIdentical(e, 1), r = this.length - this.scanIdentical(e, -1), o = new Zg(this), i = new Zg(e);
    for (let s = n, a = n; ; ) {
      if (o.next(s), i.next(s), s = 0, o.lineBreak != i.lineBreak || o.done != i.done || o.value != i.value)
        return !1;
      if (a += o.value.length, o.done || a >= r)
        return !0;
    }
  }
  /**
  Iterate over the text. When `dir` is `-1`, iteration happens
  from end to start. This will return lines and the breaks between
  them as separate strings.
  */
  iter(e = 1) {
    return new Zg(this, e);
  }
  /**
  Iterate over a range of the text. When `from` > `to`, the
  iterator will run in reverse.
  */
  iterRange(e, n = this.length) {
    return new due(this, e, n);
  }
  /**
  Return a cursor that iterates over the given range of lines,
  _without_ returning the line breaks between, and yielding empty
  strings for empty lines.
  
  When `from` and `to` are given, they should be 1-based line numbers.
  */
  iterLines(e, n) {
    let r;
    if (e == null)
      r = this.iter();
    else {
      n == null && (n = this.lines + 1);
      let o = this.line(e).from;
      r = this.iterRange(o, Math.max(o, n == this.lines + 1 ? this.length : n <= 1 ? 0 : this.line(n - 1).to));
    }
    return new fue(r);
  }
  /**
  Return the document as a string, using newline characters to
  separate lines.
  */
  toString() {
    return this.sliceString(0);
  }
  /**
  Convert the document to an array of lines (which can be
  deserialized again via [`Text.of`](https://codemirror.net/6/docs/ref/#state.Text^of)).
  */
  toJSON() {
    let e = [];
    return this.flatten(e), e;
  }
  /**
  @internal
  */
  constructor() {
  }
  /**
  Create a `Text` instance for the given array of lines.
  */
  static of(e) {
    if (e.length == 0)
      throw new RangeError("A document must have at least one line");
    return e.length == 1 && !e[0] ? uue.empty : e.length <= 32 ? new xs(e) : iw.from(xs.split(e, []));
  }
}, xs = class Gs extends ln {
  constructor(e, n = P4e(e)) {
    super(), this.text = e, this.length = n;
  }
  get lines() {
    return this.text.length;
  }
  get children() {
    return null;
  }
  lineInner(e, n, r, o) {
    for (let i = 0; ; i++) {
      let s = this.text[i], a = o + s.length;
      if ((n ? r : a) >= e)
        return new $4e(o, a, r, s);
      o = a + 1, r++;
    }
  }
  decompose(e, n, r, o) {
    let i = e <= 0 && n >= this.length ? this : new Gs(Q7(this.text, e, n), Math.min(n, this.length) - Math.max(0, e));
    if (o & 1) {
      let s = r.pop(), a = sw(i.text, s.text.slice(), 0, i.length);
      if (a.length <= 32)
        r.push(new Gs(a, s.length + i.length));
      else {
        let l = a.length >> 1;
        r.push(new Gs(a.slice(0, l)), new Gs(a.slice(l)));
      }
    } else
      r.push(i);
  }
  replace(e, n, r) {
    if (!(r instanceof Gs))
      return super.replace(e, n, r);
    [e, n] = Hh(this, e, n);
    let o = sw(this.text, sw(r.text, Q7(this.text, 0, e)), n), i = this.length + r.length - (n - e);
    return o.length <= 32 ? new Gs(o, i) : iw.from(Gs.split(o, []), i);
  }
  sliceString(e, n = this.length, r = `
`) {
    [e, n] = Hh(this, e, n);
    let o = "";
    for (let i = 0, s = 0; i <= n && s < this.text.length; s++) {
      let a = this.text[s], l = i + a.length;
      i > e && s && (o += r), e < l && n > i && (o += a.slice(Math.max(0, e - i), n - i)), i = l + 1;
    }
    return o;
  }
  flatten(e) {
    for (let n of this.text)
      e.push(n);
  }
  scanIdentical() {
    return 0;
  }
  static split(e, n) {
    let r = [], o = -1;
    for (let i of e)
      r.push(i), o += i.length + 1, r.length == 32 && (n.push(new Gs(r, o)), r = [], o = -1);
    return o > -1 && n.push(new Gs(r, o)), n;
  }
}, iw = class Mf extends ln {
  constructor(e, n) {
    super(), this.children = e, this.length = n, this.lines = 0;
    for (let r of e)
      this.lines += r.lines;
  }
  lineInner(e, n, r, o) {
    for (let i = 0; ; i++) {
      let s = this.children[i], a = o + s.length, l = r + s.lines - 1;
      if ((n ? l : a) >= e)
        return s.lineInner(e, n, r, o);
      o = a + 1, r = l + 1;
    }
  }
  decompose(e, n, r, o) {
    for (let i = 0, s = 0; s <= n && i < this.children.length; i++) {
      let a = this.children[i], l = s + a.length;
      if (e <= l && n >= s) {
        let c = o & ((s <= e ? 1 : 0) | (l >= n ? 2 : 0));
        s >= e && l <= n && !c ? r.push(a) : a.decompose(e - s, n - s, r, c);
      }
      s = l + 1;
    }
  }
  replace(e, n, r) {
    if ([e, n] = Hh(this, e, n), r.lines < this.lines)
      for (let o = 0, i = 0; o < this.children.length; o++) {
        let s = this.children[o], a = i + s.length;
        if (e >= i && n <= a) {
          let l = s.replace(e - i, n - i, r), c = this.lines - s.lines + l.lines;
          if (l.lines < c >> 4 && l.lines > c >> 6) {
            let u = this.children.slice();
            return u[o] = l, new Mf(u, this.length - (n - e) + r.length);
          }
          return super.replace(i, a, l);
        }
        i = a + 1;
      }
    return super.replace(e, n, r);
  }
  sliceString(e, n = this.length, r = `
`) {
    [e, n] = Hh(this, e, n);
    let o = "";
    for (let i = 0, s = 0; i < this.children.length && s <= n; i++) {
      let a = this.children[i], l = s + a.length;
      s > e && i && (o += r), e < l && n > s && (o += a.sliceString(e - s, n - s, r)), s = l + 1;
    }
    return o;
  }
  flatten(e) {
    for (let n of this.children)
      n.flatten(e);
  }
  scanIdentical(e, n) {
    if (!(e instanceof Mf))
      return 0;
    let r = 0, [o, i, s, a] = n > 0 ? [0, 0, this.children.length, e.children.length] : [this.children.length - 1, e.children.length - 1, -1, -1];
    for (; ; o += n, i += n) {
      if (o == s || i == a)
        return r;
      let l = this.children[o], c = e.children[i];
      if (l != c)
        return r + l.scanIdentical(c, n);
      r += l.length + 1;
    }
  }
  static from(e, n = e.reduce((r, o) => r + o.length + 1, -1)) {
    let r = 0;
    for (let h of e)
      r += h.lines;
    if (r < 32) {
      let h = [];
      for (let p of e)
        p.flatten(h);
      return new xs(h, n);
    }
    let o = Math.max(
      32,
      r >> 5
      /* Tree.BranchShift */
    ), i = o << 1, s = o >> 1, a = [], l = 0, c = -1, u = [];
    function d(h) {
      let p;
      if (h.lines > i && h instanceof Mf)
        for (let m of h.children)
          d(m);
      else h.lines > s && (l > s || !l) ? (f(), a.push(h)) : h instanceof xs && l && (p = u[u.length - 1]) instanceof xs && h.lines + p.lines <= 32 ? (l += h.lines, c += h.length + 1, u[u.length - 1] = new xs(p.text.concat(h.text), p.length + 1 + h.length)) : (l + h.lines > o && f(), l += h.lines, c += h.length + 1, u.push(h));
    }
    function f() {
      l != 0 && (a.push(u.length == 1 ? u[0] : Mf.from(u, c)), c = -1, l = u.length = 0);
    }
    for (let h of e)
      d(h);
    return f(), a.length == 1 ? a[0] : new Mf(a, n);
  }
};
ln.empty = /* @__PURE__ */ new xs([""], 0);
function P4e(t) {
  let e = -1;
  for (let n of t)
    e += n.length + 1;
  return e;
}
function sw(t, e, n = 0, r = 1e9) {
  for (let o = 0, i = 0, s = !0; i < t.length && o <= r; i++) {
    let a = t[i], l = o + a.length;
    l >= n && (l > r && (a = a.slice(0, r - o)), o < n && (a = a.slice(n - o)), s ? (e[e.length - 1] += a, s = !1) : e.push(a)), o = l + 1;
  }
  return e;
}
function Q7(t, e, n) {
  return sw(t, [""], e, n);
}
let Zg = class {
  constructor(e, n = 1) {
    this.dir = n, this.done = !1, this.lineBreak = !1, this.value = "", this.nodes = [e], this.offsets = [n > 0 ? 1 : (e instanceof xs ? e.text.length : e.children.length) << 1];
  }
  nextInner(e, n) {
    for (this.done = this.lineBreak = !1; ; ) {
      let r = this.nodes.length - 1, o = this.nodes[r], i = this.offsets[r], s = i >> 1, a = o instanceof xs ? o.text.length : o.children.length;
      if (s == (n > 0 ? a : 0)) {
        if (r == 0)
          return this.done = !0, this.value = "", this;
        n > 0 && this.offsets[r - 1]++, this.nodes.pop(), this.offsets.pop();
      } else if ((i & 1) == (n > 0 ? 0 : 1)) {
        if (this.offsets[r] += n, e == 0)
          return this.lineBreak = !0, this.value = `
`, this;
        e--;
      } else if (o instanceof xs) {
        let l = o.text[s + (n < 0 ? -1 : 0)];
        if (this.offsets[r] += n, l.length > Math.max(0, e))
          return this.value = e == 0 ? l : n > 0 ? l.slice(e) : l.slice(0, l.length - e), this;
        e -= l.length;
      } else {
        let l = o.children[s + (n < 0 ? -1 : 0)];
        e > l.length ? (e -= l.length, this.offsets[r] += n) : (n < 0 && this.offsets[r]--, this.nodes.push(l), this.offsets.push(n > 0 ? 1 : (l instanceof xs ? l.text.length : l.children.length) << 1));
      }
    }
  }
  next(e = 0) {
    return e < 0 && (this.nextInner(-e, -this.dir), e = this.value.length), this.nextInner(e, this.dir);
  }
};
class due {
  constructor(e, n, r) {
    this.value = "", this.done = !1, this.cursor = new Zg(e, n > r ? -1 : 1), this.pos = n > r ? e.length : 0, this.from = Math.min(n, r), this.to = Math.max(n, r);
  }
  nextInner(e, n) {
    if (n < 0 ? this.pos <= this.from : this.pos >= this.to)
      return this.value = "", this.done = !0, this;
    e += Math.max(0, n < 0 ? this.pos - this.to : this.from - this.pos);
    let r = n < 0 ? this.pos - this.from : this.to - this.pos;
    e > r && (e = r), r -= e;
    let { value: o } = this.cursor.next(e);
    return this.pos += (o.length + e) * n, this.value = o.length <= r ? o : n < 0 ? o.slice(o.length - r) : o.slice(0, r), this.done = !this.value, this;
  }
  next(e = 0) {
    return e < 0 ? e = Math.max(e, this.from - this.pos) : e > 0 && (e = Math.min(e, this.to - this.pos)), this.nextInner(e, this.cursor.dir);
  }
  get lineBreak() {
    return this.cursor.lineBreak && this.value != "";
  }
}
class fue {
  constructor(e) {
    this.inner = e, this.afterBreak = !0, this.value = "", this.done = !1;
  }
  next(e = 0) {
    let { done: n, lineBreak: r, value: o } = this.inner.next(e);
    return n && this.afterBreak ? (this.value = "", this.afterBreak = !1) : n ? (this.done = !0, this.value = "") : r ? this.afterBreak ? this.value = "" : (this.afterBreak = !0, this.next()) : (this.value = o, this.afterBreak = !1), this;
  }
  get lineBreak() {
    return !1;
  }
}
typeof Symbol < "u" && (ln.prototype[Symbol.iterator] = function() {
  return this.iter();
}, Zg.prototype[Symbol.iterator] = due.prototype[Symbol.iterator] = fue.prototype[Symbol.iterator] = function() {
  return this;
});
class $4e {
  /**
  @internal
  */
  constructor(e, n, r, o) {
    this.from = e, this.to = n, this.number = r, this.text = o;
  }
  /**
  The length of the line (not including any line break after it).
  */
  get length() {
    return this.to - this.from;
  }
}
function Hh(t, e, n) {
  return e = Math.max(0, Math.min(t.length, e)), [e, Math.max(e, Math.min(t.length, n))];
}
function Zr(t, e, n = !0, r = !0) {
  return T4e(t, e, n, r);
}
function M4e(t) {
  return t >= 56320 && t < 57344;
}
function D4e(t) {
  return t >= 55296 && t < 56320;
}
function zo(t, e) {
  let n = t.charCodeAt(e);
  if (!D4e(n) || e + 1 == t.length)
    return n;
  let r = t.charCodeAt(e + 1);
  return M4e(r) ? (n - 55296 << 10) + (r - 56320) + 65536 : n;
}
function Y5(t) {
  return t <= 65535 ? String.fromCharCode(t) : (t -= 65536, String.fromCharCode((t >> 10) + 55296, (t & 1023) + 56320));
}
function la(t) {
  return t < 65536 ? 1 : 2;
}
const kI = /\r\n?|\n/;
var Co = /* @__PURE__ */ function(t) {
  return t[t.Simple = 0] = "Simple", t[t.TrackDel = 1] = "TrackDel", t[t.TrackBefore = 2] = "TrackBefore", t[t.TrackAfter = 3] = "TrackAfter", t;
}(Co || (Co = {}));
let ph = class aw {
  // Sections are encoded as pairs of integers. The first is the
  // length in the current document, and the second is -1 for
  // unaffected sections, and the length of the replacement content
  // otherwise. So an insertion would be (0, n>0), a deletion (n>0,
  // 0), and a replacement two positive numbers.
  /**
  @internal
  */
  constructor(e) {
    this.sections = e;
  }
  /**
  The length of the document before the change.
  */
  get length() {
    let e = 0;
    for (let n = 0; n < this.sections.length; n += 2)
      e += this.sections[n];
    return e;
  }
  /**
  The length of the document after the change.
  */
  get newLength() {
    let e = 0;
    for (let n = 0; n < this.sections.length; n += 2) {
      let r = this.sections[n + 1];
      e += r < 0 ? this.sections[n] : r;
    }
    return e;
  }
  /**
  False when there are actual changes in this set.
  */
  get empty() {
    return this.sections.length == 0 || this.sections.length == 2 && this.sections[1] < 0;
  }
  /**
  Iterate over the unchanged parts left by these changes. `posA`
  provides the position of the range in the old document, `posB`
  the new position in the changed document.
  */
  iterGaps(e) {
    for (let n = 0, r = 0, o = 0; n < this.sections.length; ) {
      let i = this.sections[n++], s = this.sections[n++];
      s < 0 ? (e(r, o, i), o += i) : o += s, r += i;
    }
  }
  /**
  Iterate over the ranges changed by these changes. (See
  [`ChangeSet.iterChanges`](https://codemirror.net/6/docs/ref/#state.ChangeSet.iterChanges) for a
  variant that also provides you with the inserted text.)
  `fromA`/`toA` provides the extent of the change in the starting
  document, `fromB`/`toB` the extent of the replacement in the
  changed document.
  
  When `individual` is true, adjacent changes (which are kept
  separate for [position mapping](https://codemirror.net/6/docs/ref/#state.ChangeDesc.mapPos)) are
  reported separately.
  */
  iterChangedRanges(e, n = !1) {
    AI(this, e, n);
  }
  /**
  Get a description of the inverted form of these changes.
  */
  get invertedDesc() {
    let e = [];
    for (let n = 0; n < this.sections.length; ) {
      let r = this.sections[n++], o = this.sections[n++];
      o < 0 ? e.push(r, o) : e.push(o, r);
    }
    return new aw(e);
  }
  /**
  Compute the combined effect of applying another set of changes
  after this one. The length of the document after this set should
  match the length before `other`.
  */
  composeDesc(e) {
    return this.empty ? e : e.empty ? this : hue(this, e);
  }
  /**
  Map this description, which should start with the same document
  as `other`, over another set of changes, so that it can be
  applied after it. When `before` is true, map as if the changes
  in `this` happened before the ones in `other`.
  */
  mapDesc(e, n = !1) {
    return e.empty ? this : TI(this, e, n);
  }
  mapPos(e, n = -1, r = Co.Simple) {
    let o = 0, i = 0;
    for (let s = 0; s < this.sections.length; ) {
      let a = this.sections[s++], l = this.sections[s++], c = o + a;
      if (l < 0) {
        if (c > e)
          return i + (e - o);
        i += a;
      } else {
        if (r != Co.Simple && c >= e && (r == Co.TrackDel && o < e && c > e || r == Co.TrackBefore && o < e || r == Co.TrackAfter && c > e))
          return null;
        if (c > e || c == e && n < 0 && !a)
          return e == o || n < 0 ? i : i + l;
        i += l;
      }
      o = c;
    }
    if (e > o)
      throw new RangeError(`Position ${e} is out of range for changeset of length ${o}`);
    return i;
  }
  /**
  Check whether these changes touch a given range. When one of the
  changes entirely covers the range, the string `"cover"` is
  returned.
  */
  touchesRange(e, n = e) {
    for (let r = 0, o = 0; r < this.sections.length && o <= n; ) {
      let i = this.sections[r++], s = this.sections[r++], a = o + i;
      if (s >= 0 && o <= n && a >= e)
        return o < e && a > n ? "cover" : !0;
      o = a;
    }
    return !1;
  }
  /**
  @internal
  */
  toString() {
    let e = "";
    for (let n = 0; n < this.sections.length; ) {
      let r = this.sections[n++], o = this.sections[n++];
      e += (e ? " " : "") + r + (o >= 0 ? ":" + o : "");
    }
    return e;
  }
  /**
  Serialize this change desc to a JSON-representable value.
  */
  toJSON() {
    return this.sections;
  }
  /**
  Create a change desc from its JSON representation (as produced
  by [`toJSON`](https://codemirror.net/6/docs/ref/#state.ChangeDesc.toJSON).
  */
  static fromJSON(e) {
    if (!Array.isArray(e) || e.length % 2 || e.some((n) => typeof n != "number"))
      throw new RangeError("Invalid JSON representation of ChangeDesc");
    return new aw(e);
  }
  /**
  @internal
  */
  static create(e) {
    return new aw(e);
  }
}, Ps = class pc extends ph {
  constructor(e, n) {
    super(e), this.inserted = n;
  }
  /**
  Apply the changes to a document, returning the modified
  document.
  */
  apply(e) {
    if (this.length != e.length)
      throw new RangeError("Applying change set to a document with the wrong length");
    return AI(this, (n, r, o, i, s) => e = e.replace(o, o + (r - n), s), !1), e;
  }
  mapDesc(e, n = !1) {
    return TI(this, e, n, !0);
  }
  /**
  Given the document as it existed _before_ the changes, return a
  change set that represents the inverse of this set, which could
  be used to go from the document created by the changes back to
  the document as it existed before the changes.
  */
  invert(e) {
    let n = this.sections.slice(), r = [];
    for (let o = 0, i = 0; o < n.length; o += 2) {
      let s = n[o], a = n[o + 1];
      if (a >= 0) {
        n[o] = a, n[o + 1] = s;
        let l = o >> 1;
        for (; r.length < l; )
          r.push(ln.empty);
        r.push(s ? e.slice(i, i + s) : ln.empty);
      }
      i += s;
    }
    return new pc(n, r);
  }
  /**
  Combine two subsequent change sets into a single set. `other`
  must start in the document produced by `this`. If `this` goes
  `docA` → `docB` and `other` represents `docB` → `docC`, the
  returned value will represent the change `docA` → `docC`.
  */
  compose(e) {
    return this.empty ? e : e.empty ? this : hue(this, e, !0);
  }
  /**
  Given another change set starting in the same document, maps this
  change set over the other, producing a new change set that can be
  applied to the document produced by applying `other`. When
  `before` is `true`, order changes as if `this` comes before
  `other`, otherwise (the default) treat `other` as coming first.
  
  Given two changes `A` and `B`, `A.compose(B.map(A))` and
  `B.compose(A.map(B, true))` will produce the same document. This
  provides a basic form of [operational
  transformation](https://en.wikipedia.org/wiki/Operational_transformation),
  and can be used for collaborative editing.
  */
  map(e, n = !1) {
    return e.empty ? this : TI(this, e, n, !0);
  }
  /**
  Iterate over the changed ranges in the document, calling `f` for
  each, with the range in the original document (`fromA`-`toA`)
  and the range that replaces it in the new document
  (`fromB`-`toB`).
  
  When `individual` is true, adjacent changes are reported
  separately.
  */
  iterChanges(e, n = !1) {
    AI(this, e, n);
  }
  /**
  Get a [change description](https://codemirror.net/6/docs/ref/#state.ChangeDesc) for this change
  set.
  */
  get desc() {
    return ph.create(this.sections);
  }
  /**
  @internal
  */
  filter(e) {
    let n = [], r = [], o = [], i = new H0(this);
    e: for (let s = 0, a = 0; ; ) {
      let l = s == e.length ? 1e9 : e[s++];
      for (; a < l || a == l && i.len == 0; ) {
        if (i.done)
          break e;
        let u = Math.min(i.len, l - a);
        so(o, u, -1);
        let d = i.ins == -1 ? -1 : i.off == 0 ? i.ins : 0;
        so(n, u, d), d > 0 && Mc(r, n, i.text), i.forward(u), a += u;
      }
      let c = e[s++];
      for (; a < c; ) {
        if (i.done)
          break e;
        let u = Math.min(i.len, c - a);
        so(n, u, -1), so(o, u, i.ins == -1 ? -1 : i.off == 0 ? i.ins : 0), i.forward(u), a += u;
      }
    }
    return {
      changes: new pc(n, r),
      filtered: ph.create(o)
    };
  }
  /**
  Serialize this change set to a JSON-representable value.
  */
  toJSON() {
    let e = [];
    for (let n = 0; n < this.sections.length; n += 2) {
      let r = this.sections[n], o = this.sections[n + 1];
      o < 0 ? e.push(r) : o == 0 ? e.push([r]) : e.push([r].concat(this.inserted[n >> 1].toJSON()));
    }
    return e;
  }
  /**
  Create a change set for the given changes, for a document of the
  given length, using `lineSep` as line separator.
  */
  static of(e, n, r) {
    let o = [], i = [], s = 0, a = null;
    function l(u = !1) {
      if (!u && !o.length)
        return;
      s < n && so(o, n - s, -1);
      let d = new pc(o, i);
      a = a ? a.compose(d.map(a)) : d, o = [], i = [], s = 0;
    }
    function c(u) {
      if (Array.isArray(u))
        for (let d of u)
          c(d);
      else if (u instanceof pc) {
        if (u.length != n)
          throw new RangeError(`Mismatched change set length (got ${u.length}, expected ${n})`);
        l(), a = a ? a.compose(u.map(a)) : u;
      } else {
        let { from: d, to: f = d, insert: h } = u;
        if (d > f || d < 0 || f > n)
          throw new RangeError(`Invalid change range ${d} to ${f} (in doc of length ${n})`);
        let p = h ? typeof h == "string" ? ln.of(h.split(r || kI)) : h : ln.empty, m = p.length;
        if (d == f && m == 0)
          return;
        d < s && l(), d > s && so(o, d - s, -1), so(o, f - d, m), Mc(i, o, p), s = f;
      }
    }
    return c(e), l(!a), a;
  }
  /**
  Create an empty changeset of the given length.
  */
  static empty(e) {
    return new pc(e ? [e, -1] : [], []);
  }
  /**
  Create a changeset from its JSON representation (as produced by
  [`toJSON`](https://codemirror.net/6/docs/ref/#state.ChangeSet.toJSON).
  */
  static fromJSON(e) {
    if (!Array.isArray(e))
      throw new RangeError("Invalid JSON representation of ChangeSet");
    let n = [], r = [];
    for (let o = 0; o < e.length; o++) {
      let i = e[o];
      if (typeof i == "number")
        n.push(i, -1);
      else {
        if (!Array.isArray(i) || typeof i[0] != "number" || i.some((s, a) => a && typeof s != "string"))
          throw new RangeError("Invalid JSON representation of ChangeSet");
        if (i.length == 1)
          n.push(i[0], 0);
        else {
          for (; r.length < o; )
            r.push(ln.empty);
          r[o] = ln.of(i.slice(1)), n.push(i[0], r[o].length);
        }
      }
    }
    return new pc(n, r);
  }
  /**
  @internal
  */
  static createSet(e, n) {
    return new pc(e, n);
  }
};
function so(t, e, n, r = !1) {
  if (e == 0 && n <= 0)
    return;
  let o = t.length - 2;
  o >= 0 && n <= 0 && n == t[o + 1] ? t[o] += e : o >= 0 && e == 0 && t[o] == 0 ? t[o + 1] += n : r ? (t[o] += e, t[o + 1] += n) : t.push(e, n);
}
function Mc(t, e, n) {
  if (n.length == 0)
    return;
  let r = e.length - 2 >> 1;
  if (r < t.length)
    t[t.length - 1] = t[t.length - 1].append(n);
  else {
    for (; t.length < r; )
      t.push(ln.empty);
    t.push(n);
  }
}
function AI(t, e, n) {
  let r = t.inserted;
  for (let o = 0, i = 0, s = 0; s < t.sections.length; ) {
    let a = t.sections[s++], l = t.sections[s++];
    if (l < 0)
      o += a, i += a;
    else {
      let c = o, u = i, d = ln.empty;
      for (; c += a, u += l, l && r && (d = d.append(r[s - 2 >> 1])), !(n || s == t.sections.length || t.sections[s + 1] < 0); )
        a = t.sections[s++], l = t.sections[s++];
      e(o, c, i, u, d), o = c, i = u;
    }
  }
}
function TI(t, e, n, r = !1) {
  let o = [], i = r ? [] : null, s = new H0(t), a = new H0(e);
  for (let l = -1; ; ) {
    if (s.done && a.len || a.done && s.len)
      throw new Error("Mismatched change set lengths");
    if (s.ins == -1 && a.ins == -1) {
      let c = Math.min(s.len, a.len);
      so(o, c, -1), s.forward(c), a.forward(c);
    } else if (a.ins >= 0 && (s.ins < 0 || l == s.i || s.off == 0 && (a.len < s.len || a.len == s.len && !n))) {
      let c = a.len;
      for (so(o, a.ins, -1); c; ) {
        let u = Math.min(s.len, c);
        s.ins >= 0 && l < s.i && s.len <= u && (so(o, 0, s.ins), i && Mc(i, o, s.text), l = s.i), s.forward(u), c -= u;
      }
      a.next();
    } else if (s.ins >= 0) {
      let c = 0, u = s.len;
      for (; u; )
        if (a.ins == -1) {
          let d = Math.min(u, a.len);
          c += d, u -= d, a.forward(d);
        } else if (a.ins == 0 && a.len < u)
          u -= a.len, a.next();
        else
          break;
      so(o, c, l < s.i ? s.ins : 0), i && l < s.i && Mc(i, o, s.text), l = s.i, s.forward(s.len - u);
    } else {
      if (s.done && a.done)
        return i ? Ps.createSet(o, i) : ph.create(o);
      throw new Error("Mismatched change set lengths");
    }
  }
}
function hue(t, e, n = !1) {
  let r = [], o = n ? [] : null, i = new H0(t), s = new H0(e);
  for (let a = !1; ; ) {
    if (i.done && s.done)
      return o ? Ps.createSet(r, o) : ph.create(r);
    if (i.ins == 0)
      so(r, i.len, 0, a), i.next();
    else if (s.len == 0 && !s.done)
      so(r, 0, s.ins, a), o && Mc(o, r, s.text), s.next();
    else {
      if (i.done || s.done)
        throw new Error("Mismatched change set lengths");
      {
        let l = Math.min(i.len2, s.len), c = r.length;
        if (i.ins == -1) {
          let u = s.ins == -1 ? -1 : s.off ? 0 : s.ins;
          so(r, l, u, a), o && u && Mc(o, r, s.text);
        } else s.ins == -1 ? (so(r, i.off ? 0 : i.len, l, a), o && Mc(o, r, i.textBit(l))) : (so(r, i.off ? 0 : i.len, s.off ? 0 : s.ins, a), o && !s.off && Mc(o, r, s.text));
        a = (i.ins > l || s.ins >= 0 && s.len > l) && (a || r.length > c), i.forward2(l), s.forward(l);
      }
    }
  }
}
class H0 {
  constructor(e) {
    this.set = e, this.i = 0, this.next();
  }
  next() {
    let { sections: e } = this.set;
    this.i < e.length ? (this.len = e[this.i++], this.ins = e[this.i++]) : (this.len = 0, this.ins = -2), this.off = 0;
  }
  get done() {
    return this.ins == -2;
  }
  get len2() {
    return this.ins < 0 ? this.len : this.ins;
  }
  get text() {
    let { inserted: e } = this.set, n = this.i - 2 >> 1;
    return n >= e.length ? ln.empty : e[n];
  }
  textBit(e) {
    let { inserted: n } = this.set, r = this.i - 2 >> 1;
    return r >= n.length && !e ? ln.empty : n[r].slice(this.off, e == null ? void 0 : this.off + e);
  }
  forward(e) {
    e == this.len ? this.next() : (this.len -= e, this.off += e);
  }
  forward2(e) {
    this.ins == -1 ? this.forward(e) : e == this.ins ? this.next() : (this.ins -= e, this.off += e);
  }
}
class rd {
  constructor(e, n, r) {
    this.from = e, this.to = n, this.flags = r;
  }
  /**
  The anchor of the range—the side that doesn't move when you
  extend it.
  */
  get anchor() {
    return this.flags & 32 ? this.to : this.from;
  }
  /**
  The head of the range, which is moved when the range is
  [extended](https://codemirror.net/6/docs/ref/#state.SelectionRange.extend).
  */
  get head() {
    return this.flags & 32 ? this.from : this.to;
  }
  /**
  True when `anchor` and `head` are at the same position.
  */
  get empty() {
    return this.from == this.to;
  }
  /**
  If this is a cursor that is explicitly associated with the
  character on one of its sides, this returns the side. -1 means
  the character before its position, 1 the character after, and 0
  means no association.
  */
  get assoc() {
    return this.flags & 8 ? -1 : this.flags & 16 ? 1 : 0;
  }
  /**
  The bidirectional text level associated with this cursor, if
  any.
  */
  get bidiLevel() {
    let e = this.flags & 7;
    return e == 7 ? null : e;
  }
  /**
  The goal column (stored vertical offset) associated with a
  cursor. This is used to preserve the vertical position when
  [moving](https://codemirror.net/6/docs/ref/#view.EditorView.moveVertically) across
  lines of different length.
  */
  get goalColumn() {
    let e = this.flags >> 6;
    return e == 16777215 ? void 0 : e;
  }
  /**
  Map this range through a change, producing a valid range in the
  updated document.
  */
  map(e, n = -1) {
    let r, o;
    return this.empty ? r = o = e.mapPos(this.from, n) : (r = e.mapPos(this.from, 1), o = e.mapPos(this.to, -1)), r == this.from && o == this.to ? this : new rd(r, o, this.flags);
  }
  /**
  Extend this range to cover at least `from` to `to`.
  */
  extend(e, n = e) {
    if (e <= this.anchor && n >= this.anchor)
      return $e.range(e, n);
    let r = Math.abs(e - this.anchor) > Math.abs(n - this.anchor) ? e : n;
    return $e.range(this.anchor, r);
  }
  /**
  Compare this range to another range.
  */
  eq(e, n = !1) {
    return this.anchor == e.anchor && this.head == e.head && (!n || !this.empty || this.assoc == e.assoc);
  }
  /**
  Return a JSON-serializable object representing the range.
  */
  toJSON() {
    return { anchor: this.anchor, head: this.head };
  }
  /**
  Convert a JSON representation of a range to a `SelectionRange`
  instance.
  */
  static fromJSON(e) {
    if (!e || typeof e.anchor != "number" || typeof e.head != "number")
      throw new RangeError("Invalid JSON representation for SelectionRange");
    return $e.range(e.anchor, e.head);
  }
  /**
  @internal
  */
  static create(e, n, r) {
    return new rd(e, n, r);
  }
}
class $e {
  constructor(e, n) {
    this.ranges = e, this.mainIndex = n;
  }
  /**
  Map a selection through a change. Used to adjust the selection
  position for changes.
  */
  map(e, n = -1) {
    return e.empty ? this : $e.create(this.ranges.map((r) => r.map(e, n)), this.mainIndex);
  }
  /**
  Compare this selection to another selection. By default, ranges
  are compared only by position. When `includeAssoc` is true,
  cursor ranges must also have the same
  [`assoc`](https://codemirror.net/6/docs/ref/#state.SelectionRange.assoc) value.
  */
  eq(e, n = !1) {
    if (this.ranges.length != e.ranges.length || this.mainIndex != e.mainIndex)
      return !1;
    for (let r = 0; r < this.ranges.length; r++)
      if (!this.ranges[r].eq(e.ranges[r], n))
        return !1;
    return !0;
  }
  /**
  Get the primary selection range. Usually, you should make sure
  your code applies to _all_ ranges, by using methods like
  [`changeByRange`](https://codemirror.net/6/docs/ref/#state.EditorState.changeByRange).
  */
  get main() {
    return this.ranges[this.mainIndex];
  }
  /**
  Make sure the selection only has one range. Returns a selection
  holding only the main range from this selection.
  */
  asSingle() {
    return this.ranges.length == 1 ? this : new $e([this.main], 0);
  }
  /**
  Extend this selection with an extra range.
  */
  addRange(e, n = !0) {
    return $e.create([e].concat(this.ranges), n ? 0 : this.mainIndex + 1);
  }
  /**
  Replace a given range with another range, and then normalize the
  selection to merge and sort ranges if necessary.
  */
  replaceRange(e, n = this.mainIndex) {
    let r = this.ranges.slice();
    return r[n] = e, $e.create(r, this.mainIndex);
  }
  /**
  Convert this selection to an object that can be serialized to
  JSON.
  */
  toJSON() {
    return { ranges: this.ranges.map((e) => e.toJSON()), main: this.mainIndex };
  }
  /**
  Create a selection from a JSON representation.
  */
  static fromJSON(e) {
    if (!e || !Array.isArray(e.ranges) || typeof e.main != "number" || e.main >= e.ranges.length)
      throw new RangeError("Invalid JSON representation for EditorSelection");
    return new $e(e.ranges.map((n) => rd.fromJSON(n)), e.main);
  }
  /**
  Create a selection holding a single range.
  */
  static single(e, n = e) {
    return new $e([$e.range(e, n)], 0);
  }
  /**
  Sort and merge the given set of ranges, creating a valid
  selection.
  */
  static create(e, n = 0) {
    if (e.length == 0)
      throw new RangeError("A selection needs at least one range");
    for (let r = 0, o = 0; o < e.length; o++) {
      let i = e[o];
      if (i.empty ? i.from <= r : i.from < r)
        return $e.normalized(e.slice(), n);
      r = i.to;
    }
    return new $e(e, n);
  }
  /**
  Create a cursor selection range at the given position. You can
  safely ignore the optional arguments in most situations.
  */
  static cursor(e, n = 0, r, o) {
    return rd.create(e, e, (n == 0 ? 0 : n < 0 ? 8 : 16) | (r == null ? 7 : Math.min(6, r)) | (o ?? 16777215) << 6);
  }
  /**
  Create a selection range.
  */
  static range(e, n, r, o) {
    let i = (r ?? 16777215) << 6 | (o == null ? 7 : Math.min(6, o));
    return n < e ? rd.create(n, e, 48 | i) : rd.create(e, n, (n > e ? 8 : 0) | i);
  }
  /**
  @internal
  */
  static normalized(e, n = 0) {
    let r = e[n];
    e.sort((o, i) => o.from - i.from), n = e.indexOf(r);
    for (let o = 1; o < e.length; o++) {
      let i = e[o], s = e[o - 1];
      if (i.empty ? i.from <= s.to : i.from < s.to) {
        let a = s.from, l = Math.max(i.to, s.to);
        o <= n && n--, e.splice(--o, 2, i.anchor > i.head ? $e.range(l, a) : $e.range(a, l));
      }
    }
    return new $e(e, n);
  }
}
function pue(t, e) {
  for (let n of t.ranges)
    if (n.to > e)
      throw new RangeError("Selection points outside of document");
}
let K5 = 0, lt = class mue {
  constructor(e, n, r, o, i) {
    this.combine = e, this.compareInput = n, this.compare = r, this.isStatic = o, this.id = K5++, this.default = e([]), this.extensions = typeof i == "function" ? i(this) : i;
  }
  /**
  Returns a facet reader for this facet, which can be used to
  [read](https://codemirror.net/6/docs/ref/#state.EditorState.facet) it but not to define values for it.
  */
  get reader() {
    return this;
  }
  /**
  Define a new facet.
  */
  static define(e = {}) {
    return new mue(e.combine || ((n) => n), e.compareInput || ((n, r) => n === r), e.compare || (e.combine ? (n, r) => n === r : X5), !!e.static, e.enables);
  }
  /**
  Returns an extension that adds the given value to this facet.
  */
  of(e) {
    return new lw([], this, 0, e);
  }
  /**
  Create an extension that computes a value for the facet from a
  state. You must take care to declare the parts of the state that
  this value depends on, since your function is only called again
  for a new state when one of those parts changed.
  
  In cases where your value depends only on a single field, you'll
  want to use the [`from`](https://codemirror.net/6/docs/ref/#state.Facet.from) method instead.
  */
  compute(e, n) {
    if (this.isStatic)
      throw new Error("Can't compute a static facet");
    return new lw(e, this, 1, n);
  }
  /**
  Create an extension that computes zero or more values for this
  facet from a state.
  */
  computeN(e, n) {
    if (this.isStatic)
      throw new Error("Can't compute a static facet");
    return new lw(e, this, 2, n);
  }
  from(e, n) {
    return n || (n = (r) => r), this.compute([e], (r) => n(r.field(e)));
  }
};
function X5(t, e) {
  return t == e || t.length == e.length && t.every((n, r) => n === e[r]);
}
class lw {
  constructor(e, n, r, o) {
    this.dependencies = e, this.facet = n, this.type = r, this.value = o, this.id = K5++;
  }
  dynamicSlot(e) {
    var n;
    let r = this.value, o = this.facet.compareInput, i = this.id, s = e[i] >> 1, a = this.type == 2, l = !1, c = !1, u = [];
    for (let d of this.dependencies)
      d == "doc" ? l = !0 : d == "selection" ? c = !0 : (((n = e[d.id]) !== null && n !== void 0 ? n : 1) & 1) == 0 && u.push(e[d.id]);
    return {
      create(d) {
        return d.values[s] = r(d), 1;
      },
      update(d, f) {
        if (l && f.docChanged || c && (f.docChanged || f.selection) || RI(d, u)) {
          let h = r(d);
          if (a ? !Z7(h, d.values[s], o) : !o(h, d.values[s]))
            return d.values[s] = h, 1;
        }
        return 0;
      },
      reconfigure: (d, f) => {
        let h, p = f.config.address[i];
        if (p != null) {
          let m = bx(f, p);
          if (this.dependencies.every((g) => g instanceof lt ? f.facet(g) === d.facet(g) : g instanceof jr ? f.field(g, !1) == d.field(g, !1) : !0) || (a ? Z7(h = r(d), m, o) : o(h = r(d), m)))
            return d.values[s] = m, 0;
        } else
          h = r(d);
        return d.values[s] = h, 1;
      }
    };
  }
}
function Z7(t, e, n) {
  if (t.length != e.length)
    return !1;
  for (let r = 0; r < t.length; r++)
    if (!n(t[r], e[r]))
      return !1;
  return !0;
}
function RI(t, e) {
  let n = !1;
  for (let r of e)
    Jg(t, r) & 1 && (n = !0);
  return n;
}
function I4e(t, e, n) {
  let r = n.map((l) => t[l.id]), o = n.map((l) => l.type), i = r.filter((l) => !(l & 1)), s = t[e.id] >> 1;
  function a(l) {
    let c = [];
    for (let u = 0; u < r.length; u++) {
      let d = bx(l, r[u]);
      if (o[u] == 2)
        for (let f of d)
          c.push(f);
      else
        c.push(d);
    }
    return e.combine(c);
  }
  return {
    create(l) {
      for (let c of r)
        Jg(l, c);
      return l.values[s] = a(l), 1;
    },
    update(l, c) {
      if (!RI(l, i))
        return 0;
      let u = a(l);
      return e.compare(u, l.values[s]) ? 0 : (l.values[s] = u, 1);
    },
    reconfigure(l, c) {
      let u = RI(l, r), d = c.config.facets[e.id], f = c.facet(e);
      if (d && !u && X5(n, d))
        return l.values[s] = f, 0;
      let h = a(l);
      return e.compare(h, f) ? (l.values[s] = f, 0) : (l.values[s] = h, 1);
    }
  };
}
const J7 = /* @__PURE__ */ lt.define({ static: !0 });
let jr = class gue {
  constructor(e, n, r, o, i) {
    this.id = e, this.createF = n, this.updateF = r, this.compareF = o, this.spec = i, this.provides = void 0;
  }
  /**
  Define a state field.
  */
  static define(e) {
    let n = new gue(K5++, e.create, e.update, e.compare || ((r, o) => r === o), e);
    return e.provide && (n.provides = e.provide(n)), n;
  }
  create(e) {
    return (e.facet(J7).find((r) => r.field == this)?.create || this.createF)(e);
  }
  /**
  @internal
  */
  slot(e) {
    let n = e[this.id] >> 1;
    return {
      create: (r) => (r.values[n] = this.create(r), 1),
      update: (r, o) => {
        let i = r.values[n], s = this.updateF(i, o);
        return this.compareF(i, s) ? 0 : (r.values[n] = s, 1);
      },
      reconfigure: (r, o) => o.config.address[this.id] != null ? (r.values[n] = o.field(this), 0) : (r.values[n] = this.create(r), 1)
    };
  }
  /**
  Returns an extension that enables this field and overrides the
  way it is initialized. Can be useful when you need to provide a
  non-default starting value for the field.
  */
  init(e) {
    return [this, J7.of({ field: this, create: e })];
  }
  /**
  State field instances can be used as
  [`Extension`](https://codemirror.net/6/docs/ref/#state.Extension) values to enable the field in a
  given state.
  */
  get extension() {
    return this;
  }
};
const Ku = { lowest: 4, low: 3, default: 2, high: 1, highest: 0 };
function sm(t) {
  return (e) => new yue(e, t);
}
const Yd = {
  /**
  The highest precedence level, for extensions that should end up
  near the start of the precedence ordering.
  */
  highest: /* @__PURE__ */ sm(Ku.highest),
  /**
  A higher-than-default precedence, for extensions that should
  come before those with default precedence.
  */
  high: /* @__PURE__ */ sm(Ku.high),
  /**
  The default precedence, which is also used for extensions
  without an explicit precedence.
  */
  default: /* @__PURE__ */ sm(Ku.default),
  /**
  A lower-than-default precedence.
  */
  low: /* @__PURE__ */ sm(Ku.low),
  /**
  The lowest precedence level. Meant for things that should end up
  near the end of the extension order.
  */
  lowest: /* @__PURE__ */ sm(Ku.lowest)
};
class yue {
  constructor(e, n) {
    this.inner = e, this.prec = n;
  }
}
class OS {
  /**
  Create an instance of this compartment to add to your [state
  configuration](https://codemirror.net/6/docs/ref/#state.EditorStateConfig.extensions).
  */
  of(e) {
    return new PI(this, e);
  }
  /**
  Create an [effect](https://codemirror.net/6/docs/ref/#state.TransactionSpec.effects) that
  reconfigures this compartment.
  */
  reconfigure(e) {
    return OS.reconfigure.of({ compartment: this, extension: e });
  }
  /**
  Get the current content of the compartment in the state, or
  `undefined` if it isn't present.
  */
  get(e) {
    return e.config.compartments.get(this);
  }
}
class PI {
  constructor(e, n) {
    this.compartment = e, this.inner = n;
  }
}
class vx {
  constructor(e, n, r, o, i, s) {
    for (this.base = e, this.compartments = n, this.dynamicSlots = r, this.address = o, this.staticValues = i, this.facets = s, this.statusTemplate = []; this.statusTemplate.length < r.length; )
      this.statusTemplate.push(
        0
        /* SlotStatus.Unresolved */
      );
  }
  staticFacet(e) {
    let n = this.address[e.id];
    return n == null ? e.default : this.staticValues[n >> 1];
  }
  static resolve(e, n, r) {
    let o = [], i = /* @__PURE__ */ Object.create(null), s = /* @__PURE__ */ new Map();
    for (let f of N4e(e, n, s))
      f instanceof jr ? o.push(f) : (i[f.facet.id] || (i[f.facet.id] = [])).push(f);
    let a = /* @__PURE__ */ Object.create(null), l = [], c = [];
    for (let f of o)
      a[f.id] = c.length << 1, c.push((h) => f.slot(h));
    let u = r?.config.facets;
    for (let f in i) {
      let h = i[f], p = h[0].facet, m = u && u[f] || [];
      if (h.every(
        (g) => g.type == 0
        /* Provider.Static */
      ))
        if (a[p.id] = l.length << 1 | 1, X5(m, h))
          l.push(r.facet(p));
        else {
          let g = p.combine(h.map((y) => y.value));
          l.push(r && p.compare(g, r.facet(p)) ? r.facet(p) : g);
        }
      else {
        for (let g of h)
          g.type == 0 ? (a[g.id] = l.length << 1 | 1, l.push(g.value)) : (a[g.id] = c.length << 1, c.push((y) => g.dynamicSlot(y)));
        a[p.id] = c.length << 1, c.push((g) => I4e(g, p, h));
      }
    }
    let d = c.map((f) => f(a));
    return new vx(e, s, d, a, l, i);
  }
}
function N4e(t, e, n) {
  let r = [[], [], [], [], []], o = /* @__PURE__ */ new Map();
  function i(s, a) {
    let l = o.get(s);
    if (l != null) {
      if (l <= a)
        return;
      let c = r[l].indexOf(s);
      c > -1 && r[l].splice(c, 1), s instanceof PI && n.delete(s.compartment);
    }
    if (o.set(s, a), Array.isArray(s))
      for (let c of s)
        i(c, a);
    else if (s instanceof PI) {
      if (n.has(s.compartment))
        throw new RangeError("Duplicate use of compartment in extensions");
      let c = e.get(s.compartment) || s.inner;
      n.set(s.compartment, c), i(c, a);
    } else if (s instanceof yue)
      i(s.inner, s.prec);
    else if (s instanceof jr)
      r[a].push(s), s.provides && i(s.provides, a);
    else if (s instanceof lw)
      r[a].push(s), s.facet.extensions && i(s.facet.extensions, Ku.default);
    else {
      let c = s.extension;
      if (!c)
        throw new Error(`Unrecognized extension value in extension set (${s}). This sometimes happens because multiple instances of @codemirror/state are loaded, breaking instanceof checks.`);
      i(c, a);
    }
  }
  return i(t, Ku.default), r.reduce((s, a) => s.concat(a));
}
function Jg(t, e) {
  if (e & 1)
    return 2;
  let n = e >> 1, r = t.status[n];
  if (r == 4)
    throw new Error("Cyclic dependency between fields and/or facets");
  if (r & 2)
    return r;
  t.status[n] = 4;
  let o = t.computeSlot(t, t.config.dynamicSlots[n]);
  return t.status[n] = 2 | o;
}
function bx(t, e) {
  return e & 1 ? t.config.staticValues[e >> 1] : t.values[e >> 1];
}
const vue = /* @__PURE__ */ lt.define(), $I = /* @__PURE__ */ lt.define({
  combine: (t) => t.some((e) => e),
  static: !0
}), bue = /* @__PURE__ */ lt.define({
  combine: (t) => t.length ? t[0] : void 0,
  static: !0
}), _ue = /* @__PURE__ */ lt.define(), wue = /* @__PURE__ */ lt.define(), xue = /* @__PURE__ */ lt.define(), Eue = /* @__PURE__ */ lt.define({
  combine: (t) => t.length ? t[0] : !1
});
let Ta = class {
  /**
  @internal
  */
  constructor(e, n) {
    this.type = e, this.value = n;
  }
  /**
  Define a new type of annotation.
  */
  static define() {
    return new j4e();
  }
};
class j4e {
  /**
  Create an instance of this annotation.
  */
  of(e) {
    return new Ta(this, e);
  }
}
class L4e {
  /**
  @internal
  */
  constructor(e) {
    this.map = e;
  }
  /**
  Create a [state effect](https://codemirror.net/6/docs/ref/#state.StateEffect) instance of this
  type.
  */
  of(e) {
    return new xt(this, e);
  }
}
let xt = class Sue {
  /**
  @internal
  */
  constructor(e, n) {
    this.type = e, this.value = n;
  }
  /**
  Map this effect through a position mapping. Will return
  `undefined` when that ends up deleting the effect.
  */
  map(e) {
    let n = this.type.map(this.value, e);
    return n === void 0 ? void 0 : n == this.value ? this : new Sue(this.type, n);
  }
  /**
  Tells you whether this effect object is of a given
  [type](https://codemirror.net/6/docs/ref/#state.StateEffectType).
  */
  is(e) {
    return this.type == e;
  }
  /**
  Define a new effect type. The type parameter indicates the type
  of values that his effect holds. It should be a type that
  doesn't include `undefined`, since that is used in
  [mapping](https://codemirror.net/6/docs/ref/#state.StateEffect.map) to indicate that an effect is
  removed.
  */
  static define(e = {}) {
    return new L4e(e.map || ((n) => n));
  }
  /**
  Map an array of effects through a change set.
  */
  static mapEffects(e, n) {
    if (!e.length)
      return e;
    let r = [];
    for (let o of e) {
      let i = o.map(n);
      i && r.push(i);
    }
    return r;
  }
};
xt.reconfigure = /* @__PURE__ */ xt.define();
xt.appendConfig = /* @__PURE__ */ xt.define();
let Zo = class hg {
  constructor(e, n, r, o, i, s) {
    this.startState = e, this.changes = n, this.selection = r, this.effects = o, this.annotations = i, this.scrollIntoView = s, this._doc = null, this._state = null, r && pue(r, n.newLength), i.some((a) => a.type == hg.time) || (this.annotations = i.concat(hg.time.of(Date.now())));
  }
  /**
  @internal
  */
  static create(e, n, r, o, i, s) {
    return new hg(e, n, r, o, i, s);
  }
  /**
  The new document produced by the transaction. Contrary to
  [`.state`](https://codemirror.net/6/docs/ref/#state.Transaction.state)`.doc`, accessing this won't
  force the entire new state to be computed right away, so it is
  recommended that [transaction
  filters](https://codemirror.net/6/docs/ref/#state.EditorState^transactionFilter) use this getter
  when they need to look at the new document.
  */
  get newDoc() {
    return this._doc || (this._doc = this.changes.apply(this.startState.doc));
  }
  /**
  The new selection produced by the transaction. If
  [`this.selection`](https://codemirror.net/6/docs/ref/#state.Transaction.selection) is undefined,
  this will [map](https://codemirror.net/6/docs/ref/#state.EditorSelection.map) the start state's
  current selection through the changes made by the transaction.
  */
  get newSelection() {
    return this.selection || this.startState.selection.map(this.changes);
  }
  /**
  The new state created by the transaction. Computed on demand
  (but retained for subsequent access), so it is recommended not to
  access it in [transaction
  filters](https://codemirror.net/6/docs/ref/#state.EditorState^transactionFilter) when possible.
  */
  get state() {
    return this._state || this.startState.applyTransaction(this), this._state;
  }
  /**
  Get the value of the given annotation type, if any.
  */
  annotation(e) {
    for (let n of this.annotations)
      if (n.type == e)
        return n.value;
  }
  /**
  Indicates whether the transaction changed the document.
  */
  get docChanged() {
    return !this.changes.empty;
  }
  /**
  Indicates whether this transaction reconfigures the state
  (through a [configuration compartment](https://codemirror.net/6/docs/ref/#state.Compartment) or
  with a top-level configuration
  [effect](https://codemirror.net/6/docs/ref/#state.StateEffect^reconfigure).
  */
  get reconfigured() {
    return this.startState.config != this.state.config;
  }
  /**
  Returns true if the transaction has a [user
  event](https://codemirror.net/6/docs/ref/#state.Transaction^userEvent) annotation that is equal to
  or more specific than `event`. For example, if the transaction
  has `"select.pointer"` as user event, `"select"` and
  `"select.pointer"` will match it.
  */
  isUserEvent(e) {
    let n = this.annotation(hg.userEvent);
    return !!(n && (n == e || n.length > e.length && n.slice(0, e.length) == e && n[e.length] == "."));
  }
};
Zo.time = /* @__PURE__ */ Ta.define();
Zo.userEvent = /* @__PURE__ */ Ta.define();
Zo.addToHistory = /* @__PURE__ */ Ta.define();
Zo.remote = /* @__PURE__ */ Ta.define();
function F4e(t, e) {
  let n = [];
  for (let r = 0, o = 0; ; ) {
    let i, s;
    if (r < t.length && (o == e.length || e[o] >= t[r]))
      i = t[r++], s = t[r++];
    else if (o < e.length)
      i = e[o++], s = e[o++];
    else
      return n;
    !n.length || n[n.length - 1] < i ? n.push(i, s) : n[n.length - 1] < s && (n[n.length - 1] = s);
  }
}
function Oue(t, e, n) {
  var r;
  let o, i, s;
  return n ? (o = e.changes, i = Ps.empty(e.changes.length), s = t.changes.compose(e.changes)) : (o = e.changes.map(t.changes), i = t.changes.mapDesc(e.changes, !0), s = t.changes.compose(o)), {
    changes: s,
    selection: e.selection ? e.selection.map(i) : (r = t.selection) === null || r === void 0 ? void 0 : r.map(o),
    effects: xt.mapEffects(t.effects, o).concat(xt.mapEffects(e.effects, i)),
    annotations: t.annotations.length ? t.annotations.concat(e.annotations) : e.annotations,
    scrollIntoView: t.scrollIntoView || e.scrollIntoView
  };
}
function MI(t, e, n) {
  let r = e.selection, o = mh(e.annotations);
  return e.userEvent && (o = o.concat(Zo.userEvent.of(e.userEvent))), {
    changes: e.changes instanceof Ps ? e.changes : Ps.of(e.changes || [], n, t.facet(bue)),
    selection: r && (r instanceof $e ? r : $e.single(r.anchor, r.head)),
    effects: mh(e.effects),
    annotations: o,
    scrollIntoView: !!e.scrollIntoView
  };
}
function Cue(t, e, n) {
  let r = MI(t, e.length ? e[0] : {}, t.doc.length);
  e.length && e[0].filter === !1 && (n = !1);
  for (let i = 1; i < e.length; i++) {
    e[i].filter === !1 && (n = !1);
    let s = !!e[i].sequential;
    r = Oue(r, MI(t, e[i], s ? r.changes.newLength : t.doc.length), s);
  }
  let o = Zo.create(t, r.changes, r.selection, r.effects, r.annotations, r.scrollIntoView);
  return z4e(n ? B4e(o) : o);
}
function B4e(t) {
  let e = t.startState, n = !0;
  for (let o of e.facet(_ue)) {
    let i = o(t);
    if (i === !1) {
      n = !1;
      break;
    }
    Array.isArray(i) && (n = n === !0 ? i : F4e(n, i));
  }
  if (n !== !0) {
    let o, i;
    if (n === !1)
      i = t.changes.invertedDesc, o = Ps.empty(e.doc.length);
    else {
      let s = t.changes.filter(n);
      o = s.changes, i = s.filtered.mapDesc(s.changes).invertedDesc;
    }
    t = Zo.create(e, o, t.selection && t.selection.map(i), xt.mapEffects(t.effects, i), t.annotations, t.scrollIntoView);
  }
  let r = e.facet(wue);
  for (let o = r.length - 1; o >= 0; o--) {
    let i = r[o](t);
    i instanceof Zo ? t = i : Array.isArray(i) && i.length == 1 && i[0] instanceof Zo ? t = i[0] : t = Cue(e, mh(i), !1);
  }
  return t;
}
function z4e(t) {
  let e = t.startState, n = e.facet(xue), r = t;
  for (let o = n.length - 1; o >= 0; o--) {
    let i = n[o](t);
    i && Object.keys(i).length && (r = Oue(r, MI(e, i, t.changes.newLength), !0));
  }
  return r == t ? t : Zo.create(e, t.changes, t.selection, r.effects, r.annotations, r.scrollIntoView);
}
const q4e = [];
function mh(t) {
  return t == null ? q4e : Array.isArray(t) ? t : [t];
}
var rr = /* @__PURE__ */ function(t) {
  return t[t.Word = 0] = "Word", t[t.Space = 1] = "Space", t[t.Other = 2] = "Other", t;
}(rr || (rr = {}));
const U4e = /[\u00df\u0587\u0590-\u05f4\u0600-\u06ff\u3040-\u309f\u30a0-\u30ff\u3400-\u4db5\u4e00-\u9fcc\uac00-\ud7af]/;
let DI;
try {
  DI = /* @__PURE__ */ new RegExp("[\\p{Alphabetic}\\p{Number}_]", "u");
} catch {
}
function H4e(t) {
  if (DI)
    return DI.test(t);
  for (let e = 0; e < t.length; e++) {
    let n = t[e];
    if (/\w/.test(n) || n > "" && (n.toUpperCase() != n.toLowerCase() || U4e.test(n)))
      return !0;
  }
  return !1;
}
function V4e(t) {
  return (e) => {
    if (!/\S/.test(e))
      return rr.Space;
    if (H4e(e))
      return rr.Word;
    for (let n = 0; n < t.length; n++)
      if (e.indexOf(t[n]) > -1)
        return rr.Word;
    return rr.Other;
  };
}
class qt {
  constructor(e, n, r, o, i, s) {
    this.config = e, this.doc = n, this.selection = r, this.values = o, this.status = e.statusTemplate.slice(), this.computeSlot = i, s && (s._state = this);
    for (let a = 0; a < this.config.dynamicSlots.length; a++)
      Jg(this, a << 1);
    this.computeSlot = null;
  }
  field(e, n = !0) {
    let r = this.config.address[e.id];
    if (r == null) {
      if (n)
        throw new RangeError("Field is not present in this state");
      return;
    }
    return Jg(this, r), bx(this, r);
  }
  /**
  Create a [transaction](https://codemirror.net/6/docs/ref/#state.Transaction) that updates this
  state. Any number of [transaction specs](https://codemirror.net/6/docs/ref/#state.TransactionSpec)
  can be passed. Unless
  [`sequential`](https://codemirror.net/6/docs/ref/#state.TransactionSpec.sequential) is set, the
  [changes](https://codemirror.net/6/docs/ref/#state.TransactionSpec.changes) (if any) of each spec
  are assumed to start in the _current_ document (not the document
  produced by previous specs), and its
  [selection](https://codemirror.net/6/docs/ref/#state.TransactionSpec.selection) and
  [effects](https://codemirror.net/6/docs/ref/#state.TransactionSpec.effects) are assumed to refer
  to the document created by its _own_ changes. The resulting
  transaction contains the combined effect of all the different
  specs. For [selection](https://codemirror.net/6/docs/ref/#state.TransactionSpec.selection), later
  specs take precedence over earlier ones.
  */
  update(...e) {
    return Cue(this, e, !0);
  }
  /**
  @internal
  */
  applyTransaction(e) {
    let n = this.config, { base: r, compartments: o } = n;
    for (let a of e.effects)
      a.is(OS.reconfigure) ? (n && (o = /* @__PURE__ */ new Map(), n.compartments.forEach((l, c) => o.set(c, l)), n = null), o.set(a.value.compartment, a.value.extension)) : a.is(xt.reconfigure) ? (n = null, r = a.value) : a.is(xt.appendConfig) && (n = null, r = mh(r).concat(a.value));
    let i;
    n ? i = e.startState.values.slice() : (n = vx.resolve(r, o, this), i = new qt(n, this.doc, this.selection, n.dynamicSlots.map(() => null), (a, l) => l.reconfigure(a, this), null).values);
    let s = e.startState.facet($I) ? e.newSelection : e.newSelection.asSingle();
    new qt(n, e.newDoc, s, i, (a, l) => l.update(a, e), e);
  }
  /**
  Create a [transaction spec](https://codemirror.net/6/docs/ref/#state.TransactionSpec) that
  replaces every selection range with the given content.
  */
  replaceSelection(e) {
    return typeof e == "string" && (e = this.toText(e)), this.changeByRange((n) => ({
      changes: { from: n.from, to: n.to, insert: e },
      range: $e.cursor(n.from + e.length)
    }));
  }
  /**
  Create a set of changes and a new selection by running the given
  function for each range in the active selection. The function
  can return an optional set of changes (in the coordinate space
  of the start document), plus an updated range (in the coordinate
  space of the document produced by the call's own changes). This
  method will merge all the changes and ranges into a single
  changeset and selection, and return it as a [transaction
  spec](https://codemirror.net/6/docs/ref/#state.TransactionSpec), which can be passed to
  [`update`](https://codemirror.net/6/docs/ref/#state.EditorState.update).
  */
  changeByRange(e) {
    let n = this.selection, r = e(n.ranges[0]), o = this.changes(r.changes), i = [r.range], s = mh(r.effects);
    for (let a = 1; a < n.ranges.length; a++) {
      let l = e(n.ranges[a]), c = this.changes(l.changes), u = c.map(o);
      for (let f = 0; f < a; f++)
        i[f] = i[f].map(u);
      let d = o.mapDesc(c, !0);
      i.push(l.range.map(d)), o = o.compose(u), s = xt.mapEffects(s, u).concat(xt.mapEffects(mh(l.effects), d));
    }
    return {
      changes: o,
      selection: $e.create(i, n.mainIndex),
      effects: s
    };
  }
  /**
  Create a [change set](https://codemirror.net/6/docs/ref/#state.ChangeSet) from the given change
  description, taking the state's document length and line
  separator into account.
  */
  changes(e = []) {
    return e instanceof Ps ? e : Ps.of(e, this.doc.length, this.facet(qt.lineSeparator));
  }
  /**
  Using the state's [line
  separator](https://codemirror.net/6/docs/ref/#state.EditorState^lineSeparator), create a
  [`Text`](https://codemirror.net/6/docs/ref/#state.Text) instance from the given string.
  */
  toText(e) {
    return ln.of(e.split(this.facet(qt.lineSeparator) || kI));
  }
  /**
  Return the given range of the document as a string.
  */
  sliceDoc(e = 0, n = this.doc.length) {
    return this.doc.sliceString(e, n, this.lineBreak);
  }
  /**
  Get the value of a state [facet](https://codemirror.net/6/docs/ref/#state.Facet).
  */
  facet(e) {
    let n = this.config.address[e.id];
    return n == null ? e.default : (Jg(this, n), bx(this, n));
  }
  /**
  Convert this state to a JSON-serializable object. When custom
  fields should be serialized, you can pass them in as an object
  mapping property names (in the resulting object, which should
  not use `doc` or `selection`) to fields.
  */
  toJSON(e) {
    let n = {
      doc: this.sliceDoc(),
      selection: this.selection.toJSON()
    };
    if (e)
      for (let r in e) {
        let o = e[r];
        o instanceof jr && this.config.address[o.id] != null && (n[r] = o.spec.toJSON(this.field(e[r]), this));
      }
    return n;
  }
  /**
  Deserialize a state from its JSON representation. When custom
  fields should be deserialized, pass the same object you passed
  to [`toJSON`](https://codemirror.net/6/docs/ref/#state.EditorState.toJSON) when serializing as
  third argument.
  */
  static fromJSON(e, n = {}, r) {
    if (!e || typeof e.doc != "string")
      throw new RangeError("Invalid JSON representation for EditorState");
    let o = [];
    if (r) {
      for (let i in r)
        if (Object.prototype.hasOwnProperty.call(e, i)) {
          let s = r[i], a = e[i];
          o.push(s.init((l) => s.spec.fromJSON(a, l)));
        }
    }
    return qt.create({
      doc: e.doc,
      selection: $e.fromJSON(e.selection),
      extensions: n.extensions ? o.concat([n.extensions]) : o
    });
  }
  /**
  Create a new state. You'll usually only need this when
  initializing an editor—updated states are created by applying
  transactions.
  */
  static create(e = {}) {
    let n = vx.resolve(e.extensions || [], /* @__PURE__ */ new Map()), r = e.doc instanceof ln ? e.doc : ln.of((e.doc || "").split(n.staticFacet(qt.lineSeparator) || kI)), o = e.selection ? e.selection instanceof $e ? e.selection : $e.single(e.selection.anchor, e.selection.head) : $e.single(0);
    return pue(o, r.length), n.staticFacet($I) || (o = o.asSingle()), new qt(n, r, o, n.dynamicSlots.map(() => null), (i, s) => s.create(i), null);
  }
  /**
  The size (in columns) of a tab in the document, determined by
  the [`tabSize`](https://codemirror.net/6/docs/ref/#state.EditorState^tabSize) facet.
  */
  get tabSize() {
    return this.facet(qt.tabSize);
  }
  /**
  Get the proper [line-break](https://codemirror.net/6/docs/ref/#state.EditorState^lineSeparator)
  string for this state.
  */
  get lineBreak() {
    return this.facet(qt.lineSeparator) || `
`;
  }
  /**
  Returns true when the editor is
  [configured](https://codemirror.net/6/docs/ref/#state.EditorState^readOnly) to be read-only.
  */
  get readOnly() {
    return this.facet(Eue);
  }
  /**
  Look up a translation for the given phrase (via the
  [`phrases`](https://codemirror.net/6/docs/ref/#state.EditorState^phrases) facet), or return the
  original string if no translation is found.
  
  If additional arguments are passed, they will be inserted in
  place of markers like `$1` (for the first value) and `$2`, etc.
  A single `$` is equivalent to `$1`, and `$$` will produce a
  literal dollar sign.
  */
  phrase(e, ...n) {
    for (let r of this.facet(qt.phrases))
      if (Object.prototype.hasOwnProperty.call(r, e)) {
        e = r[e];
        break;
      }
    return n.length && (e = e.replace(/\$(\$|\d*)/g, (r, o) => {
      if (o == "$")
        return "$";
      let i = +(o || 1);
      return !i || i > n.length ? r : n[i - 1];
    })), e;
  }
  /**
  Find the values for a given language data field, provided by the
  the [`languageData`](https://codemirror.net/6/docs/ref/#state.EditorState^languageData) facet.
  
  Examples of language data fields are...
  
  - [`"commentTokens"`](https://codemirror.net/6/docs/ref/#commands.CommentTokens) for specifying
    comment syntax.
  - [`"autocomplete"`](https://codemirror.net/6/docs/ref/#autocomplete.autocompletion^config.override)
    for providing language-specific completion sources.
  - [`"wordChars"`](https://codemirror.net/6/docs/ref/#state.EditorState.charCategorizer) for adding
    characters that should be considered part of words in this
    language.
  - [`"closeBrackets"`](https://codemirror.net/6/docs/ref/#autocomplete.CloseBracketConfig) controls
    bracket closing behavior.
  */
  languageDataAt(e, n, r = -1) {
    let o = [];
    for (let i of this.facet(vue))
      for (let s of i(this, n, r))
        Object.prototype.hasOwnProperty.call(s, e) && o.push(s[e]);
    return o;
  }
  /**
  Return a function that can categorize strings (expected to
  represent a single [grapheme cluster](https://codemirror.net/6/docs/ref/#state.findClusterBreak))
  into one of:
  
   - Word (contains an alphanumeric character or a character
     explicitly listed in the local language's `"wordChars"`
     language data, which should be a string)
   - Space (contains only whitespace)
   - Other (anything else)
  */
  charCategorizer(e) {
    return V4e(this.languageDataAt("wordChars", e).join(""));
  }
  /**
  Find the word at the given position, meaning the range
  containing all [word](https://codemirror.net/6/docs/ref/#state.CharCategory.Word) characters
  around it. If no word characters are adjacent to the position,
  this returns null.
  */
  wordAt(e) {
    let { text: n, from: r, length: o } = this.doc.lineAt(e), i = this.charCategorizer(e), s = e - r, a = e - r;
    for (; s > 0; ) {
      let l = Zr(n, s, !1);
      if (i(n.slice(l, s)) != rr.Word)
        break;
      s = l;
    }
    for (; a < o; ) {
      let l = Zr(n, a);
      if (i(n.slice(a, l)) != rr.Word)
        break;
      a = l;
    }
    return s == a ? null : $e.range(s + r, a + r);
  }
}
qt.allowMultipleSelections = $I;
qt.tabSize = /* @__PURE__ */ lt.define({
  combine: (t) => t.length ? t[0] : 4
});
qt.lineSeparator = bue;
qt.readOnly = Eue;
qt.phrases = /* @__PURE__ */ lt.define({
  compare(t, e) {
    let n = Object.keys(t), r = Object.keys(e);
    return n.length == r.length && n.every((o) => t[o] == e[o]);
  }
});
qt.languageData = vue;
qt.changeFilter = _ue;
qt.transactionFilter = wue;
qt.transactionExtender = xue;
OS.reconfigure = /* @__PURE__ */ xt.define();
function Ra(t, e, n = {}) {
  let r = {};
  for (let o of t)
    for (let i of Object.keys(o)) {
      let s = o[i], a = r[i];
      if (a === void 0)
        r[i] = s;
      else if (!(a === s || s === void 0)) if (Object.hasOwnProperty.call(n, i))
        r[i] = n[i](a, s);
      else
        throw new Error("Config merge conflict for field " + i);
    }
  for (let o in e)
    r[o] === void 0 && (r[o] = e[o]);
  return r;
}
class Pd {
  /**
  Compare this value with another value. Used when comparing
  rangesets. The default implementation compares by identity.
  Unless you are only creating a fixed number of unique instances
  of your value type, it is a good idea to implement this
  properly.
  */
  eq(e) {
    return this == e;
  }
  /**
  Create a [range](https://codemirror.net/6/docs/ref/#state.Range) with this value.
  */
  range(e, n = e) {
    return II.create(e, n, this);
  }
}
Pd.prototype.startSide = Pd.prototype.endSide = 0;
Pd.prototype.point = !1;
Pd.prototype.mapMode = Co.TrackDel;
let II = class kue {
  constructor(e, n, r) {
    this.from = e, this.to = n, this.value = r;
  }
  /**
  @internal
  */
  static create(e, n, r) {
    return new kue(e, n, r);
  }
};
function NI(t, e) {
  return t.from - e.from || t.value.startSide - e.value.startSide;
}
let W4e = class Aue {
  constructor(e, n, r, o) {
    this.from = e, this.to = n, this.value = r, this.maxPoint = o;
  }
  get length() {
    return this.to[this.to.length - 1];
  }
  // Find the index of the given position and side. Use the ranges'
  // `from` pos when `end == false`, `to` when `end == true`.
  findIndex(e, n, r, o = 0) {
    let i = r ? this.to : this.from;
    for (let s = o, a = i.length; ; ) {
      if (s == a)
        return s;
      let l = s + a >> 1, c = i[l] - e || (r ? this.value[l].endSide : this.value[l].startSide) - n;
      if (l == s)
        return c >= 0 ? s : a;
      c >= 0 ? a = l : s = l + 1;
    }
  }
  between(e, n, r, o) {
    for (let i = this.findIndex(n, -1e9, !0), s = this.findIndex(r, 1e9, !1, i); i < s; i++)
      if (o(this.from[i] + e, this.to[i] + e, this.value[i]) === !1)
        return !1;
  }
  map(e, n) {
    let r = [], o = [], i = [], s = -1, a = -1;
    for (let l = 0; l < this.value.length; l++) {
      let c = this.value[l], u = this.from[l] + e, d = this.to[l] + e, f, h;
      if (u == d) {
        let p = n.mapPos(u, c.startSide, c.mapMode);
        if (p == null || (f = h = p, c.startSide != c.endSide && (h = n.mapPos(u, c.endSide), h < f)))
          continue;
      } else if (f = n.mapPos(u, c.startSide), h = n.mapPos(d, c.endSide), f > h || f == h && c.startSide > 0 && c.endSide <= 0)
        continue;
      (h - f || c.endSide - c.startSide) < 0 || (s < 0 && (s = f), c.point && (a = Math.max(a, h - f)), r.push(c), o.push(f - s), i.push(h - s));
    }
    return { mapped: r.length ? new Aue(o, i, r, a) : null, pos: s };
  }
}, or = class el {
  constructor(e, n, r, o) {
    this.chunkPos = e, this.chunk = n, this.nextLayer = r, this.maxPoint = o;
  }
  /**
  @internal
  */
  static create(e, n, r, o) {
    return new el(e, n, r, o);
  }
  /**
  @internal
  */
  get length() {
    let e = this.chunk.length - 1;
    return e < 0 ? 0 : Math.max(this.chunkEnd(e), this.nextLayer.length);
  }
  /**
  The number of ranges in the set.
  */
  get size() {
    if (this.isEmpty)
      return 0;
    let e = this.nextLayer.size;
    for (let n of this.chunk)
      e += n.value.length;
    return e;
  }
  /**
  @internal
  */
  chunkEnd(e) {
    return this.chunkPos[e] + this.chunk[e].length;
  }
  /**
  Update the range set, optionally adding new ranges or filtering
  out existing ones.
  
  (Note: The type parameter is just there as a kludge to work
  around TypeScript variance issues that prevented `RangeSet<X>`
  from being a subtype of `RangeSet<Y>` when `X` is a subtype of
  `Y`.)
  */
  update(e) {
    let { add: n = [], sort: r = !1, filterFrom: o = 0, filterTo: i = this.length } = e, s = e.filter;
    if (n.length == 0 && !s)
      return this;
    if (r && (n = n.slice().sort(NI)), this.isEmpty)
      return n.length ? el.of(n) : this;
    let a = new Rue(this, null, -1).goto(0), l = 0, c = [], u = new $d();
    for (; a.value || l < n.length; )
      if (l < n.length && (a.from - n[l].from || a.startSide - n[l].value.startSide) >= 0) {
        let d = n[l++];
        u.addInner(d.from, d.to, d.value) || c.push(d);
      } else a.rangeIndex == 1 && a.chunkIndex < this.chunk.length && (l == n.length || this.chunkEnd(a.chunkIndex) < n[l].from) && (!s || o > this.chunkEnd(a.chunkIndex) || i < this.chunkPos[a.chunkIndex]) && u.addChunk(this.chunkPos[a.chunkIndex], this.chunk[a.chunkIndex]) ? a.nextChunk() : ((!s || o > a.to || i < a.from || s(a.from, a.to, a.value)) && (u.addInner(a.from, a.to, a.value) || c.push(II.create(a.from, a.to, a.value))), a.next());
    return u.finishInner(this.nextLayer.isEmpty && !c.length ? el.empty : this.nextLayer.update({ add: c, filter: s, filterFrom: o, filterTo: i }));
  }
  /**
  Map this range set through a set of changes, return the new set.
  */
  map(e) {
    if (e.empty || this.isEmpty)
      return this;
    let n = [], r = [], o = -1;
    for (let s = 0; s < this.chunk.length; s++) {
      let a = this.chunkPos[s], l = this.chunk[s], c = e.touchesRange(a, a + l.length);
      if (c === !1)
        o = Math.max(o, l.maxPoint), n.push(l), r.push(e.mapPos(a));
      else if (c === !0) {
        let { mapped: u, pos: d } = l.map(a, e);
        u && (o = Math.max(o, u.maxPoint), n.push(u), r.push(d));
      }
    }
    let i = this.nextLayer.map(e);
    return n.length == 0 ? i : new el(r, n, i || el.empty, o);
  }
  /**
  Iterate over the ranges that touch the region `from` to `to`,
  calling `f` for each. There is no guarantee that the ranges will
  be reported in any specific order. When the callback returns
  `false`, iteration stops.
  */
  between(e, n, r) {
    if (!this.isEmpty) {
      for (let o = 0; o < this.chunk.length; o++) {
        let i = this.chunkPos[o], s = this.chunk[o];
        if (n >= i && e <= i + s.length && s.between(i, e - i, n - i, r) === !1)
          return;
      }
      this.nextLayer.between(e, n, r);
    }
  }
  /**
  Iterate over the ranges in this set, in order, including all
  ranges that end at or after `from`.
  */
  iter(e = 0) {
    return V0.from([this]).goto(e);
  }
  /**
  @internal
  */
  get isEmpty() {
    return this.nextLayer == this;
  }
  /**
  Iterate over the ranges in a collection of sets, in order,
  starting from `from`.
  */
  static iter(e, n = 0) {
    return V0.from(e).goto(n);
  }
  /**
  Iterate over two groups of sets, calling methods on `comparator`
  to notify it of possible differences.
  */
  static compare(e, n, r, o, i = -1) {
    let s = e.filter((d) => d.maxPoint > 0 || !d.isEmpty && d.maxPoint >= i), a = n.filter((d) => d.maxPoint > 0 || !d.isEmpty && d.maxPoint >= i), l = eB(s, a, r), c = new am(s, l, i), u = new am(a, l, i);
    r.iterGaps((d, f, h) => tB(c, d, u, f, h, o)), r.empty && r.length == 0 && tB(c, 0, u, 0, 0, o);
  }
  /**
  Compare the contents of two groups of range sets, returning true
  if they are equivalent in the given range.
  */
  static eq(e, n, r = 0, o) {
    o == null && (o = 999999999);
    let i = e.filter((u) => !u.isEmpty && n.indexOf(u) < 0), s = n.filter((u) => !u.isEmpty && e.indexOf(u) < 0);
    if (i.length != s.length)
      return !1;
    if (!i.length)
      return !0;
    let a = eB(i, s), l = new am(i, a, 0).goto(r), c = new am(s, a, 0).goto(r);
    for (; ; ) {
      if (l.to != c.to || !jI(l.active, c.active) || l.point && (!c.point || !l.point.eq(c.point)))
        return !1;
      if (l.to > o)
        return !0;
      l.next(), c.next();
    }
  }
  /**
  Iterate over a group of range sets at the same time, notifying
  the iterator about the ranges covering every given piece of
  content. Returns the open count (see
  [`SpanIterator.span`](https://codemirror.net/6/docs/ref/#state.SpanIterator.span)) at the end
  of the iteration.
  */
  static spans(e, n, r, o, i = -1) {
    let s = new am(e, null, i).goto(n), a = n, l = s.openStart;
    for (; ; ) {
      let c = Math.min(s.to, r);
      if (s.point) {
        let u = s.activeForPoint(s.to), d = s.pointFrom < n ? u.length + 1 : s.point.startSide < 0 ? u.length : Math.min(u.length, l);
        o.point(a, c, s.point, u, d, s.pointRank), l = Math.min(s.openEnd(c), u.length);
      } else c > a && (o.span(a, c, s.active, l), l = s.openEnd(c));
      if (s.to > r)
        return l + (s.point && s.to > r ? 1 : 0);
      a = s.to, s.next();
    }
  }
  /**
  Create a range set for the given range or array of ranges. By
  default, this expects the ranges to be _sorted_ (by start
  position and, if two start at the same position,
  `value.startSide`). You can pass `true` as second argument to
  cause the method to sort them.
  */
  static of(e, n = !1) {
    let r = new $d();
    for (let o of e instanceof II ? [e] : n ? G4e(e) : e)
      r.add(o.from, o.to, o.value);
    return r.finish();
  }
  /**
  Join an array of range sets into a single set.
  */
  static join(e) {
    if (!e.length)
      return el.empty;
    let n = e[e.length - 1];
    for (let r = e.length - 2; r >= 0; r--)
      for (let o = e[r]; o != el.empty; o = o.nextLayer)
        n = new el(o.chunkPos, o.chunk, n, Math.max(o.maxPoint, n.maxPoint));
    return n;
  }
};
or.empty = /* @__PURE__ */ new or([], [], null, -1);
function G4e(t) {
  if (t.length > 1)
    for (let e = t[0], n = 1; n < t.length; n++) {
      let r = t[n];
      if (NI(e, r) > 0)
        return t.slice().sort(NI);
      e = r;
    }
  return t;
}
or.empty.nextLayer = or.empty;
let $d = class Tue {
  finishChunk(e) {
    this.chunks.push(new W4e(this.from, this.to, this.value, this.maxPoint)), this.chunkPos.push(this.chunkStart), this.chunkStart = -1, this.setMaxPoint = Math.max(this.setMaxPoint, this.maxPoint), this.maxPoint = -1, e && (this.from = [], this.to = [], this.value = []);
  }
  /**
  Create an empty builder.
  */
  constructor() {
    this.chunks = [], this.chunkPos = [], this.chunkStart = -1, this.last = null, this.lastFrom = -1e9, this.lastTo = -1e9, this.from = [], this.to = [], this.value = [], this.maxPoint = -1, this.setMaxPoint = -1, this.nextLayer = null;
  }
  /**
  Add a range. Ranges should be added in sorted (by `from` and
  `value.startSide`) order.
  */
  add(e, n, r) {
    this.addInner(e, n, r) || (this.nextLayer || (this.nextLayer = new Tue())).add(e, n, r);
  }
  /**
  @internal
  */
  addInner(e, n, r) {
    let o = e - this.lastTo || r.startSide - this.last.endSide;
    if (o <= 0 && (e - this.lastFrom || r.startSide - this.last.startSide) < 0)
      throw new Error("Ranges must be added sorted by `from` position and `startSide`");
    return o < 0 ? !1 : (this.from.length == 250 && this.finishChunk(!0), this.chunkStart < 0 && (this.chunkStart = e), this.from.push(e - this.chunkStart), this.to.push(n - this.chunkStart), this.last = r, this.lastFrom = e, this.lastTo = n, this.value.push(r), r.point && (this.maxPoint = Math.max(this.maxPoint, n - e)), !0);
  }
  /**
  @internal
  */
  addChunk(e, n) {
    if ((e - this.lastTo || n.value[0].startSide - this.last.endSide) < 0)
      return !1;
    this.from.length && this.finishChunk(!0), this.setMaxPoint = Math.max(this.setMaxPoint, n.maxPoint), this.chunks.push(n), this.chunkPos.push(e);
    let r = n.value.length - 1;
    return this.last = n.value[r], this.lastFrom = n.from[r] + e, this.lastTo = n.to[r] + e, !0;
  }
  /**
  Finish the range set. Returns the new set. The builder can't be
  used anymore after this has been called.
  */
  finish() {
    return this.finishInner(or.empty);
  }
  /**
  @internal
  */
  finishInner(e) {
    if (this.from.length && this.finishChunk(!1), this.chunks.length == 0)
      return e;
    let n = or.create(this.chunkPos, this.chunks, this.nextLayer ? this.nextLayer.finishInner(e) : e, this.setMaxPoint);
    return this.from = null, n;
  }
};
function eB(t, e, n) {
  let r = /* @__PURE__ */ new Map();
  for (let i of t)
    for (let s = 0; s < i.chunk.length; s++)
      i.chunk[s].maxPoint <= 0 && r.set(i.chunk[s], i.chunkPos[s]);
  let o = /* @__PURE__ */ new Set();
  for (let i of e)
    for (let s = 0; s < i.chunk.length; s++) {
      let a = r.get(i.chunk[s]);
      a != null && (n ? n.mapPos(a) : a) == i.chunkPos[s] && !n?.touchesRange(a, a + i.chunk[s].length) && o.add(i.chunk[s]);
    }
  return o;
}
class Rue {
  constructor(e, n, r, o = 0) {
    this.layer = e, this.skip = n, this.minPoint = r, this.rank = o;
  }
  get startSide() {
    return this.value ? this.value.startSide : 0;
  }
  get endSide() {
    return this.value ? this.value.endSide : 0;
  }
  goto(e, n = -1e9) {
    return this.chunkIndex = this.rangeIndex = 0, this.gotoInner(e, n, !1), this;
  }
  gotoInner(e, n, r) {
    for (; this.chunkIndex < this.layer.chunk.length; ) {
      let o = this.layer.chunk[this.chunkIndex];
      if (!(this.skip && this.skip.has(o) || this.layer.chunkEnd(this.chunkIndex) < e || o.maxPoint < this.minPoint))
        break;
      this.chunkIndex++, r = !1;
    }
    if (this.chunkIndex < this.layer.chunk.length) {
      let o = this.layer.chunk[this.chunkIndex].findIndex(e - this.layer.chunkPos[this.chunkIndex], n, !0);
      (!r || this.rangeIndex < o) && this.setRangeIndex(o);
    }
    this.next();
  }
  forward(e, n) {
    (this.to - e || this.endSide - n) < 0 && this.gotoInner(e, n, !0);
  }
  next() {
    for (; ; )
      if (this.chunkIndex == this.layer.chunk.length) {
        this.from = this.to = 1e9, this.value = null;
        break;
      } else {
        let e = this.layer.chunkPos[this.chunkIndex], n = this.layer.chunk[this.chunkIndex], r = e + n.from[this.rangeIndex];
        if (this.from = r, this.to = e + n.to[this.rangeIndex], this.value = n.value[this.rangeIndex], this.setRangeIndex(this.rangeIndex + 1), this.minPoint < 0 || this.value.point && this.to - this.from >= this.minPoint)
          break;
      }
  }
  setRangeIndex(e) {
    if (e == this.layer.chunk[this.chunkIndex].value.length) {
      if (this.chunkIndex++, this.skip)
        for (; this.chunkIndex < this.layer.chunk.length && this.skip.has(this.layer.chunk[this.chunkIndex]); )
          this.chunkIndex++;
      this.rangeIndex = 0;
    } else
      this.rangeIndex = e;
  }
  nextChunk() {
    this.chunkIndex++, this.rangeIndex = 0, this.next();
  }
  compare(e) {
    return this.from - e.from || this.startSide - e.startSide || this.rank - e.rank || this.to - e.to || this.endSide - e.endSide;
  }
}
class V0 {
  constructor(e) {
    this.heap = e;
  }
  static from(e, n = null, r = -1) {
    let o = [];
    for (let i = 0; i < e.length; i++)
      for (let s = e[i]; !s.isEmpty; s = s.nextLayer)
        s.maxPoint >= r && o.push(new Rue(s, n, r, i));
    return o.length == 1 ? o[0] : new V0(o);
  }
  get startSide() {
    return this.value ? this.value.startSide : 0;
  }
  goto(e, n = -1e9) {
    for (let r of this.heap)
      r.goto(e, n);
    for (let r = this.heap.length >> 1; r >= 0; r--)
      KC(this.heap, r);
    return this.next(), this;
  }
  forward(e, n) {
    for (let r of this.heap)
      r.forward(e, n);
    for (let r = this.heap.length >> 1; r >= 0; r--)
      KC(this.heap, r);
    (this.to - e || this.value.endSide - n) < 0 && this.next();
  }
  next() {
    if (this.heap.length == 0)
      this.from = this.to = 1e9, this.value = null, this.rank = -1;
    else {
      let e = this.heap[0];
      this.from = e.from, this.to = e.to, this.value = e.value, this.rank = e.rank, e.value && e.next(), KC(this.heap, 0);
    }
  }
}
function KC(t, e) {
  for (let n = t[e]; ; ) {
    let r = (e << 1) + 1;
    if (r >= t.length)
      break;
    let o = t[r];
    if (r + 1 < t.length && o.compare(t[r + 1]) >= 0 && (o = t[r + 1], r++), n.compare(o) < 0)
      break;
    t[r] = n, t[e] = o, e = r;
  }
}
class am {
  constructor(e, n, r) {
    this.minPoint = r, this.active = [], this.activeTo = [], this.activeRank = [], this.minActive = -1, this.point = null, this.pointFrom = 0, this.pointRank = 0, this.to = -1e9, this.endSide = 0, this.openStart = -1, this.cursor = V0.from(e, n, r);
  }
  goto(e, n = -1e9) {
    return this.cursor.goto(e, n), this.active.length = this.activeTo.length = this.activeRank.length = 0, this.minActive = -1, this.to = e, this.endSide = n, this.openStart = -1, this.next(), this;
  }
  forward(e, n) {
    for (; this.minActive > -1 && (this.activeTo[this.minActive] - e || this.active[this.minActive].endSide - n) < 0; )
      this.removeActive(this.minActive);
    this.cursor.forward(e, n);
  }
  removeActive(e) {
    Sb(this.active, e), Sb(this.activeTo, e), Sb(this.activeRank, e), this.minActive = nB(this.active, this.activeTo);
  }
  addActive(e) {
    let n = 0, { value: r, to: o, rank: i } = this.cursor;
    for (; n < this.activeRank.length && (i - this.activeRank[n] || o - this.activeTo[n]) > 0; )
      n++;
    Ob(this.active, n, r), Ob(this.activeTo, n, o), Ob(this.activeRank, n, i), e && Ob(e, n, this.cursor.from), this.minActive = nB(this.active, this.activeTo);
  }
  // After calling this, if `this.point` != null, the next range is a
  // point. Otherwise, it's a regular range, covered by `this.active`.
  next() {
    let e = this.to, n = this.point;
    this.point = null;
    let r = this.openStart < 0 ? [] : null;
    for (; ; ) {
      let o = this.minActive;
      if (o > -1 && (this.activeTo[o] - this.cursor.from || this.active[o].endSide - this.cursor.startSide) < 0) {
        if (this.activeTo[o] > e) {
          this.to = this.activeTo[o], this.endSide = this.active[o].endSide;
          break;
        }
        this.removeActive(o), r && Sb(r, o);
      } else if (this.cursor.value)
        if (this.cursor.from > e) {
          this.to = this.cursor.from, this.endSide = this.cursor.startSide;
          break;
        } else {
          let i = this.cursor.value;
          if (!i.point)
            this.addActive(r), this.cursor.next();
          else if (n && this.cursor.to == this.to && this.cursor.from < this.cursor.to)
            this.cursor.next();
          else {
            this.point = i, this.pointFrom = this.cursor.from, this.pointRank = this.cursor.rank, this.to = this.cursor.to, this.endSide = i.endSide, this.cursor.next(), this.forward(this.to, this.endSide);
            break;
          }
        }
      else {
        this.to = this.endSide = 1e9;
        break;
      }
    }
    if (r) {
      this.openStart = 0;
      for (let o = r.length - 1; o >= 0 && r[o] < e; o--)
        this.openStart++;
    }
  }
  activeForPoint(e) {
    if (!this.active.length)
      return this.active;
    let n = [];
    for (let r = this.active.length - 1; r >= 0 && !(this.activeRank[r] < this.pointRank); r--)
      (this.activeTo[r] > e || this.activeTo[r] == e && this.active[r].endSide >= this.point.endSide) && n.push(this.active[r]);
    return n.reverse();
  }
  openEnd(e) {
    let n = 0;
    for (let r = this.activeTo.length - 1; r >= 0 && this.activeTo[r] > e; r--)
      n++;
    return n;
  }
}
function tB(t, e, n, r, o, i) {
  t.goto(e), n.goto(r);
  let s = r + o, a = r, l = r - e;
  for (; ; ) {
    let c = t.to + l - n.to, u = c || t.endSide - n.endSide, d = u < 0 ? t.to + l : n.to, f = Math.min(d, s);
    if (t.point || n.point ? t.point && n.point && (t.point == n.point || t.point.eq(n.point)) && jI(t.activeForPoint(t.to), n.activeForPoint(n.to)) || i.comparePoint(a, f, t.point, n.point) : f > a && !jI(t.active, n.active) && i.compareRange(a, f, t.active, n.active), d > s)
      break;
    (c || t.openEnd != n.openEnd) && i.boundChange && i.boundChange(d), a = d, u <= 0 && t.next(), u >= 0 && n.next();
  }
}
function jI(t, e) {
  if (t.length != e.length)
    return !1;
  for (let n = 0; n < t.length; n++)
    if (t[n] != e[n] && !t[n].eq(e[n]))
      return !1;
  return !0;
}
function Sb(t, e) {
  for (let n = e, r = t.length - 1; n < r; n++)
    t[n] = t[n + 1];
  t.pop();
}
function Ob(t, e, n) {
  for (let r = t.length - 1; r >= e; r--)
    t[r + 1] = t[r];
  t[e] = n;
}
function nB(t, e) {
  let n = -1, r = 1e9;
  for (let o = 0; o < e.length; o++)
    (e[o] - r || t[o].endSide - t[n].endSide) < 0 && (n = o, r = e[o]);
  return n;
}
function Sp(t, e, n = t.length) {
  let r = 0;
  for (let o = 0; o < n && o < t.length; )
    t.charCodeAt(o) == 9 ? (r += e - r % e, o++) : (r++, o = Zr(t, o));
  return r;
}
function LI(t, e, n, r) {
  for (let o = 0, i = 0; ; ) {
    if (i >= e)
      return o;
    if (o == t.length)
      break;
    i += t.charCodeAt(o) == 9 ? n - i % n : 1, o = Zr(t, o);
  }
  return r === !0 ? -1 : t.length;
}
const FI = "ͼ", rB = typeof Symbol > "u" ? "__" + FI : Symbol.for(FI), BI = typeof Symbol > "u" ? "__styleSet" + Math.floor(Math.random() * 1e8) : Symbol("styleSet"), oB = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : {};
let Qc = class {
  // :: (Object<Style>, ?{finish: ?(string) → string})
  // Create a style module from the given spec.
  //
  // When `finish` is given, it is called on regular (non-`@`)
  // selectors (after `&` expansion) to compute the final selector.
  constructor(e, n) {
    this.rules = [];
    let { finish: r } = n || {};
    function o(s) {
      return /^@/.test(s) ? [s] : s.split(/,\s*/);
    }
    function i(s, a, l, c) {
      let u = [], d = /^@(\w+)\b/.exec(s[0]), f = d && d[1] == "keyframes";
      if (d && a == null) return l.push(s[0] + ";");
      for (let h in a) {
        let p = a[h];
        if (/&/.test(h))
          i(
            h.split(/,\s*/).map((m) => s.map((g) => m.replace(/&/, g))).reduce((m, g) => m.concat(g)),
            p,
            l
          );
        else if (p && typeof p == "object") {
          if (!d) throw new RangeError("The value of a property (" + h + ") should be a primitive value.");
          i(o(h), p, u, f);
        } else p != null && u.push(h.replace(/_.*/, "").replace(/[A-Z]/g, (m) => "-" + m.toLowerCase()) + ": " + p + ";");
      }
      (u.length || f) && l.push((r && !d && !c ? s.map(r) : s).join(", ") + " {" + u.join(" ") + "}");
    }
    for (let s in e) i(o(s), e[s], this.rules);
  }
  // :: () → string
  // Returns a string containing the module's CSS rules.
  getRules() {
    return this.rules.join(`
`);
  }
  // :: () → string
  // Generate a new unique CSS class name.
  static newName() {
    let e = oB[rB] || 1;
    return oB[rB] = e + 1, FI + e.toString(36);
  }
  // :: (union<Document, ShadowRoot>, union<[StyleModule], StyleModule>, ?{nonce: ?string})
  //
  // Mount the given set of modules in the given DOM root, which ensures
  // that the CSS rules defined by the module are available in that
  // context.
  //
  // Rules are only added to the document once per root.
  //
  // Rule order will follow the order of the modules, so that rules from
  // modules later in the array take precedence of those from earlier
  // modules. If you call this function multiple times for the same root
  // in a way that changes the order of already mounted modules, the old
  // order will be changed.
  //
  // If a Content Security Policy nonce is provided, it is added to
  // the `<style>` tag generated by the library.
  static mount(e, n, r) {
    let o = e[BI], i = r && r.nonce;
    o ? i && o.setNonce(i) : o = new Y4e(e, i), o.mount(Array.isArray(n) ? n : [n], e);
  }
}, iB = /* @__PURE__ */ new Map();
class Y4e {
  constructor(e, n) {
    let r = e.ownerDocument || e, o = r.defaultView;
    if (!e.head && e.adoptedStyleSheets && o.CSSStyleSheet) {
      let i = iB.get(r);
      if (i) return e[BI] = i;
      this.sheet = new o.CSSStyleSheet(), iB.set(r, this);
    } else
      this.styleTag = r.createElement("style"), n && this.styleTag.setAttribute("nonce", n);
    this.modules = [], e[BI] = this;
  }
  mount(e, n) {
    let r = this.sheet, o = 0, i = 0;
    for (let s = 0; s < e.length; s++) {
      let a = e[s], l = this.modules.indexOf(a);
      if (l < i && l > -1 && (this.modules.splice(l, 1), i--, l = -1), l == -1) {
        if (this.modules.splice(i++, 0, a), r) for (let c = 0; c < a.rules.length; c++)
          r.insertRule(a.rules[c], o++);
      } else {
        for (; i < l; ) o += this.modules[i++].rules.length;
        o += a.rules.length, i++;
      }
    }
    if (r)
      n.adoptedStyleSheets.indexOf(this.sheet) < 0 && (n.adoptedStyleSheets = [this.sheet, ...n.adoptedStyleSheets]);
    else {
      let s = "";
      for (let l = 0; l < this.modules.length; l++)
        s += this.modules[l].getRules() + `
`;
      this.styleTag.textContent = s;
      let a = n.head || n;
      this.styleTag.parentNode != a && a.insertBefore(this.styleTag, a.firstChild);
    }
  }
  setNonce(e) {
    this.styleTag && this.styleTag.getAttribute("nonce") != e && this.styleTag.setAttribute("nonce", e);
  }
}
var Zc = {
  8: "Backspace",
  9: "Tab",
  10: "Enter",
  12: "NumLock",
  13: "Enter",
  16: "Shift",
  17: "Control",
  18: "Alt",
  20: "CapsLock",
  27: "Escape",
  32: " ",
  33: "PageUp",
  34: "PageDown",
  35: "End",
  36: "Home",
  37: "ArrowLeft",
  38: "ArrowUp",
  39: "ArrowRight",
  40: "ArrowDown",
  44: "PrintScreen",
  45: "Insert",
  46: "Delete",
  59: ";",
  61: "=",
  91: "Meta",
  92: "Meta",
  106: "*",
  107: "+",
  108: ",",
  109: "-",
  110: ".",
  111: "/",
  144: "NumLock",
  145: "ScrollLock",
  160: "Shift",
  161: "Shift",
  162: "Control",
  163: "Control",
  164: "Alt",
  165: "Alt",
  173: "-",
  186: ";",
  187: "=",
  188: ",",
  189: "-",
  190: ".",
  191: "/",
  192: "`",
  219: "[",
  220: "\\",
  221: "]",
  222: "'"
}, W0 = {
  48: ")",
  49: "!",
  50: "@",
  51: "#",
  52: "$",
  53: "%",
  54: "^",
  55: "&",
  56: "*",
  57: "(",
  59: ":",
  61: "+",
  173: "_",
  186: ":",
  187: "+",
  188: "<",
  189: "_",
  190: ">",
  191: "?",
  192: "~",
  219: "{",
  220: "|",
  221: "}",
  222: '"'
}, K4e = typeof navigator < "u" && /Mac/.test(navigator.platform), X4e = typeof navigator < "u" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
for (var Xr = 0; Xr < 10; Xr++) Zc[48 + Xr] = Zc[96 + Xr] = String(Xr);
for (var Xr = 1; Xr <= 24; Xr++) Zc[Xr + 111] = "F" + Xr;
for (var Xr = 65; Xr <= 90; Xr++)
  Zc[Xr] = String.fromCharCode(Xr + 32), W0[Xr] = String.fromCharCode(Xr);
for (var XC in Zc) W0.hasOwnProperty(XC) || (W0[XC] = Zc[XC]);
function Q4e(t) {
  var e = K4e && t.metaKey && t.shiftKey && !t.ctrlKey && !t.altKey || X4e && t.shiftKey && t.key && t.key.length == 1 || t.key == "Unidentified", n = !e && t.key || (t.shiftKey ? W0 : Zc)[t.keyCode] || t.key || "Unidentified";
  return n == "Esc" && (n = "Escape"), n == "Del" && (n = "Delete"), n == "Left" && (n = "ArrowLeft"), n == "Up" && (n = "ArrowUp"), n == "Right" && (n = "ArrowRight"), n == "Down" && (n = "ArrowDown"), n;
}
function G0(t) {
  let e;
  return t.nodeType == 11 ? e = t.getSelection ? t : t.ownerDocument : e = t, e.getSelection();
}
function zI(t, e) {
  return e ? t == e || t.contains(e.nodeType != 1 ? e.parentNode : e) : !1;
}
function cw(t, e) {
  if (!e.anchorNode)
    return !1;
  try {
    return zI(t, e.anchorNode);
  } catch {
    return !1;
  }
}
function Vh(t) {
  return t.nodeType == 3 ? Dd(t, 0, t.nodeValue.length).getClientRects() : t.nodeType == 1 ? t.getClientRects() : [];
}
function e0(t, e, n, r) {
  return n ? sB(t, e, n, r, -1) || sB(t, e, n, r, 1) : !1;
}
function Md(t) {
  for (var e = 0; ; e++)
    if (t = t.previousSibling, !t)
      return e;
}
function _x(t) {
  return t.nodeType == 1 && /^(DIV|P|LI|UL|OL|BLOCKQUOTE|DD|DT|H\d|SECTION|PRE)$/.test(t.nodeName);
}
function sB(t, e, n, r, o) {
  for (; ; ) {
    if (t == n && e == r)
      return !0;
    if (e == (o < 0 ? 0 : Oa(t))) {
      if (t.nodeName == "DIV")
        return !1;
      let i = t.parentNode;
      if (!i || i.nodeType != 1)
        return !1;
      e = Md(t) + (o < 0 ? 0 : 1), t = i;
    } else if (t.nodeType == 1) {
      if (t = t.childNodes[e + (o < 0 ? -1 : 0)], t.nodeType == 1 && t.contentEditable == "false")
        return !1;
      e = o < 0 ? Oa(t) : 0;
    } else
      return !1;
  }
}
function Oa(t) {
  return t.nodeType == 3 ? t.nodeValue.length : t.childNodes.length;
}
function hv(t, e) {
  let n = e ? t.left : t.right;
  return { left: n, right: n, top: t.top, bottom: t.bottom };
}
function Z4e(t) {
  let e = t.visualViewport;
  return e ? {
    left: 0,
    right: e.width,
    top: 0,
    bottom: e.height
  } : {
    left: 0,
    right: t.innerWidth,
    top: 0,
    bottom: t.innerHeight
  };
}
function Pue(t, e) {
  let n = e.width / t.offsetWidth, r = e.height / t.offsetHeight;
  return (n > 0.995 && n < 1.005 || !isFinite(n) || Math.abs(e.width - t.offsetWidth) < 1) && (n = 1), (r > 0.995 && r < 1.005 || !isFinite(r) || Math.abs(e.height - t.offsetHeight) < 1) && (r = 1), { scaleX: n, scaleY: r };
}
function J4e(t, e, n, r, o, i, s, a) {
  let l = t.ownerDocument, c = l.defaultView || window;
  for (let u = t, d = !1; u && !d; )
    if (u.nodeType == 1) {
      let f, h = u == l.body, p = 1, m = 1;
      if (h)
        f = Z4e(c);
      else {
        if (/^(fixed|sticky)$/.test(getComputedStyle(u).position) && (d = !0), u.scrollHeight <= u.clientHeight && u.scrollWidth <= u.clientWidth) {
          u = u.assignedSlot || u.parentNode;
          continue;
        }
        let v = u.getBoundingClientRect();
        ({ scaleX: p, scaleY: m } = Pue(u, v)), f = {
          left: v.left,
          right: v.left + u.clientWidth * p,
          top: v.top,
          bottom: v.top + u.clientHeight * m
        };
      }
      let g = 0, y = 0;
      if (o == "nearest")
        e.top < f.top ? (y = -(f.top - e.top + s), n > 0 && e.bottom > f.bottom + y && (y = e.bottom - f.bottom + y + s)) : e.bottom > f.bottom && (y = e.bottom - f.bottom + s, n < 0 && e.top - y < f.top && (y = -(f.top + y - e.top + s)));
      else {
        let v = e.bottom - e.top, b = f.bottom - f.top;
        y = (o == "center" && v <= b ? e.top + v / 2 - b / 2 : o == "start" || o == "center" && n < 0 ? e.top - s : e.bottom - b + s) - f.top;
      }
      if (r == "nearest" ? e.left < f.left ? (g = -(f.left - e.left + i), n > 0 && e.right > f.right + g && (g = e.right - f.right + g + i)) : e.right > f.right && (g = e.right - f.right + i, n < 0 && e.left < f.left + g && (g = -(f.left + g - e.left + i))) : g = (r == "center" ? e.left + (e.right - e.left) / 2 - (f.right - f.left) / 2 : r == "start" == a ? e.left - i : e.right - (f.right - f.left) + i) - f.left, g || y)
        if (h)
          c.scrollBy(g, y);
        else {
          let v = 0, b = 0;
          if (y) {
            let _ = u.scrollTop;
            u.scrollTop += y / m, b = (u.scrollTop - _) * m;
          }
          if (g) {
            let _ = u.scrollLeft;
            u.scrollLeft += g / p, v = (u.scrollLeft - _) * p;
          }
          e = {
            left: e.left - v,
            top: e.top - b,
            right: e.right - v,
            bottom: e.bottom - b
          }, v && Math.abs(v - g) < 1 && (r = "nearest"), b && Math.abs(b - y) < 1 && (o = "nearest");
        }
      if (h)
        break;
      u = u.assignedSlot || u.parentNode;
    } else if (u.nodeType == 11)
      u = u.host;
    else
      break;
}
function e6e(t) {
  let e = t.ownerDocument, n, r;
  for (let o = t.parentNode; o && !(o == e.body || n && r); )
    if (o.nodeType == 1)
      !r && o.scrollHeight > o.clientHeight && (r = o), !n && o.scrollWidth > o.clientWidth && (n = o), o = o.assignedSlot || o.parentNode;
    else if (o.nodeType == 11)
      o = o.host;
    else
      break;
  return { x: n, y: r };
}
class t6e {
  constructor() {
    this.anchorNode = null, this.anchorOffset = 0, this.focusNode = null, this.focusOffset = 0;
  }
  eq(e) {
    return this.anchorNode == e.anchorNode && this.anchorOffset == e.anchorOffset && this.focusNode == e.focusNode && this.focusOffset == e.focusOffset;
  }
  setRange(e) {
    let { anchorNode: n, focusNode: r } = e;
    this.set(n, Math.min(e.anchorOffset, n ? Oa(n) : 0), r, Math.min(e.focusOffset, r ? Oa(r) : 0));
  }
  set(e, n, r, o) {
    this.anchorNode = e, this.anchorOffset = n, this.focusNode = r, this.focusOffset = o;
  }
}
let vf = null;
function $ue(t) {
  if (t.setActive)
    return t.setActive();
  if (vf)
    return t.focus(vf);
  let e = [];
  for (let n = t; n && (e.push(n, n.scrollTop, n.scrollLeft), n != n.ownerDocument); n = n.parentNode)
    ;
  if (t.focus(vf == null ? {
    get preventScroll() {
      return vf = { preventScroll: !0 }, !0;
    }
  } : void 0), !vf) {
    vf = !1;
    for (let n = 0; n < e.length; ) {
      let r = e[n++], o = e[n++], i = e[n++];
      r.scrollTop != o && (r.scrollTop = o), r.scrollLeft != i && (r.scrollLeft = i);
    }
  }
}
let aB;
function Dd(t, e, n = e) {
  let r = aB || (aB = document.createRange());
  return r.setEnd(t, n), r.setStart(t, e), r;
}
function gh(t, e, n, r) {
  let o = { key: e, code: e, keyCode: n, which: n, cancelable: !0 };
  r && ({ altKey: o.altKey, ctrlKey: o.ctrlKey, shiftKey: o.shiftKey, metaKey: o.metaKey } = r);
  let i = new KeyboardEvent("keydown", o);
  i.synthetic = !0, t.dispatchEvent(i);
  let s = new KeyboardEvent("keyup", o);
  return s.synthetic = !0, t.dispatchEvent(s), i.defaultPrevented || s.defaultPrevented;
}
function n6e(t) {
  for (; t; ) {
    if (t && (t.nodeType == 9 || t.nodeType == 11 && t.host))
      return t;
    t = t.assignedSlot || t.parentNode;
  }
  return null;
}
function Mue(t) {
  for (; t.attributes.length; )
    t.removeAttributeNode(t.attributes[0]);
}
function r6e(t, e) {
  let n = e.focusNode, r = e.focusOffset;
  if (!n || e.anchorNode != n || e.anchorOffset != r)
    return !1;
  for (r = Math.min(r, Oa(n)); ; )
    if (r) {
      if (n.nodeType != 1)
        return !1;
      let o = n.childNodes[r - 1];
      o.contentEditable == "false" ? r-- : (n = o, r = Oa(n));
    } else {
      if (n == t)
        return !0;
      r = Md(n), n = n.parentNode;
    }
}
function Due(t) {
  return t.scrollTop > Math.max(1, t.scrollHeight - t.clientHeight - 4);
}
function Iue(t, e) {
  for (let n = t, r = e; ; ) {
    if (n.nodeType == 3 && r > 0)
      return { node: n, offset: r };
    if (n.nodeType == 1 && r > 0) {
      if (n.contentEditable == "false")
        return null;
      n = n.childNodes[r - 1], r = Oa(n);
    } else if (n.parentNode && !_x(n))
      r = Md(n), n = n.parentNode;
    else
      return null;
  }
}
function Nue(t, e) {
  for (let n = t, r = e; ; ) {
    if (n.nodeType == 3 && r < n.nodeValue.length)
      return { node: n, offset: r };
    if (n.nodeType == 1 && r < n.childNodes.length) {
      if (n.contentEditable == "false")
        return null;
      n = n.childNodes[r], r = 0;
    } else if (n.parentNode && !_x(n))
      r = Md(n) + 1, n = n.parentNode;
    else
      return null;
  }
}
let gi = class qI {
  constructor(e, n, r = !0) {
    this.node = e, this.offset = n, this.precise = r;
  }
  static before(e, n) {
    return new qI(e.parentNode, Md(e), n);
  }
  static after(e, n) {
    return new qI(e.parentNode, Md(e) + 1, n);
  }
};
const Q5 = [];
let tr = class UI {
  constructor() {
    this.parent = null, this.dom = null, this.flags = 2;
  }
  get overrideDOMText() {
    return null;
  }
  get posAtStart() {
    return this.parent ? this.parent.posBefore(this) : 0;
  }
  get posAtEnd() {
    return this.posAtStart + this.length;
  }
  posBefore(e) {
    let n = this.posAtStart;
    for (let r of this.children) {
      if (r == e)
        return n;
      n += r.length + r.breakAfter;
    }
    throw new RangeError("Invalid child in posBefore");
  }
  posAfter(e) {
    return this.posBefore(e) + e.length;
  }
  sync(e, n) {
    if (this.flags & 2) {
      let r = this.dom, o = null, i;
      for (let s of this.children) {
        if (s.flags & 7) {
          if (!s.dom && (i = o ? o.nextSibling : r.firstChild)) {
            let a = UI.get(i);
            (!a || !a.parent && a.canReuseDOM(s)) && s.reuseDOM(i);
          }
          s.sync(e, n), s.flags &= -8;
        }
        if (i = o ? o.nextSibling : r.firstChild, n && !n.written && n.node == r && i != s.dom && (n.written = !0), s.dom.parentNode == r)
          for (; i && i != s.dom; )
            i = lB(i);
        else
          r.insertBefore(s.dom, i);
        o = s.dom;
      }
      for (i = o ? o.nextSibling : r.firstChild, i && n && n.node == r && (n.written = !0); i; )
        i = lB(i);
    } else if (this.flags & 1)
      for (let r of this.children)
        r.flags & 7 && (r.sync(e, n), r.flags &= -8);
  }
  reuseDOM(e) {
  }
  localPosFromDOM(e, n) {
    let r;
    if (e == this.dom)
      r = this.dom.childNodes[n];
    else {
      let o = Oa(e) == 0 ? 0 : n == 0 ? -1 : 1;
      for (; ; ) {
        let i = e.parentNode;
        if (i == this.dom)
          break;
        o == 0 && i.firstChild != i.lastChild && (e == i.firstChild ? o = -1 : o = 1), e = i;
      }
      o < 0 ? r = e : r = e.nextSibling;
    }
    if (r == this.dom.firstChild)
      return 0;
    for (; r && !UI.get(r); )
      r = r.nextSibling;
    if (!r)
      return this.length;
    for (let o = 0, i = 0; ; o++) {
      let s = this.children[o];
      if (s.dom == r)
        return i;
      i += s.length + s.breakAfter;
    }
  }
  domBoundsAround(e, n, r = 0) {
    let o = -1, i = -1, s = -1, a = -1;
    for (let l = 0, c = r, u = r; l < this.children.length; l++) {
      let d = this.children[l], f = c + d.length;
      if (c < e && f > n)
        return d.domBoundsAround(e, n, c);
      if (f >= e && o == -1 && (o = l, i = c), c > n && d.dom.parentNode == this.dom) {
        s = l, a = u;
        break;
      }
      u = f, c = f + d.breakAfter;
    }
    return {
      from: i,
      to: a < 0 ? r + this.length : a,
      startDOM: (o ? this.children[o - 1].dom.nextSibling : null) || this.dom.firstChild,
      endDOM: s < this.children.length && s >= 0 ? this.children[s].dom : null
    };
  }
  markDirty(e = !1) {
    this.flags |= 2, this.markParentsDirty(e);
  }
  markParentsDirty(e) {
    for (let n = this.parent; n; n = n.parent) {
      if (e && (n.flags |= 2), n.flags & 1)
        return;
      n.flags |= 1, e = !1;
    }
  }
  setParent(e) {
    this.parent != e && (this.parent = e, this.flags & 7 && this.markParentsDirty(!0));
  }
  setDOM(e) {
    this.dom != e && (this.dom && (this.dom.cmView = null), this.dom = e, e.cmView = this);
  }
  get rootView() {
    for (let e = this; ; ) {
      let n = e.parent;
      if (!n)
        return e;
      e = n;
    }
  }
  replaceChildren(e, n, r = Q5) {
    this.markDirty();
    for (let o = e; o < n; o++) {
      let i = this.children[o];
      i.parent == this && r.indexOf(i) < 0 && i.destroy();
    }
    r.length < 250 ? this.children.splice(e, n - e, ...r) : this.children = [].concat(this.children.slice(0, e), r, this.children.slice(n));
    for (let o = 0; o < r.length; o++)
      r[o].setParent(this);
  }
  ignoreMutation(e) {
    return !1;
  }
  ignoreEvent(e) {
    return !1;
  }
  childCursor(e = this.length) {
    return new jue(this.children, e, this.children.length);
  }
  childPos(e, n = 1) {
    return this.childCursor().findPos(e, n);
  }
  toString() {
    let e = this.constructor.name.replace("View", "");
    return e + (this.children.length ? "(" + this.children.join() + ")" : this.length ? "[" + (e == "Text" ? this.text : this.length) + "]" : "") + (this.breakAfter ? "#" : "");
  }
  static get(e) {
    return e.cmView;
  }
  get isEditable() {
    return !0;
  }
  get isWidget() {
    return !1;
  }
  get isHidden() {
    return !1;
  }
  merge(e, n, r, o, i, s) {
    return !1;
  }
  become(e) {
    return !1;
  }
  canReuseDOM(e) {
    return e.constructor == this.constructor && !((this.flags | e.flags) & 8);
  }
  // When this is a zero-length view with a side, this should return a
  // number <= 0 to indicate it is before its position, or a
  // number > 0 when after its position.
  getSide() {
    return 0;
  }
  destroy() {
    for (let e of this.children)
      e.parent == this && e.destroy();
    this.parent = null;
  }
};
tr.prototype.breakAfter = 0;
function lB(t) {
  let e = t.nextSibling;
  return t.parentNode.removeChild(t), e;
}
class jue {
  constructor(e, n, r) {
    this.children = e, this.pos = n, this.i = r, this.off = 0;
  }
  findPos(e, n = 1) {
    for (; ; ) {
      if (e > this.pos || e == this.pos && (n > 0 || this.i == 0 || this.children[this.i - 1].breakAfter))
        return this.off = e - this.pos, this;
      let r = this.children[--this.i];
      this.pos -= r.length + r.breakAfter;
    }
  }
}
function Lue(t, e, n, r, o, i, s, a, l) {
  let { children: c } = t, u = c.length ? c[e] : null, d = i.length ? i[i.length - 1] : null, f = d ? d.breakAfter : s;
  if (!(e == r && u && !s && !f && i.length < 2 && u.merge(n, o, i.length ? d : null, n == 0, a, l))) {
    if (r < c.length) {
      let h = c[r];
      h && (o < h.length || h.breakAfter && d?.breakAfter) ? (e == r && (h = h.split(o), o = 0), !f && d && h.merge(0, o, d, !0, 0, l) ? i[i.length - 1] = h : ((o || h.children.length && !h.children[0].length) && h.merge(0, o, null, !1, 0, l), i.push(h))) : h?.breakAfter && (d ? d.breakAfter = 1 : s = 1), r++;
    }
    for (u && (u.breakAfter = s, n > 0 && (!s && i.length && u.merge(n, u.length, i[0], !1, a, 0) ? u.breakAfter = i.shift().breakAfter : (n < u.length || u.children.length && u.children[u.children.length - 1].length == 0) && u.merge(n, u.length, null, !1, a, 0), e++)); e < r && i.length; )
      if (c[r - 1].become(i[i.length - 1]))
        r--, i.pop(), l = i.length ? 0 : a;
      else if (c[e].become(i[0]))
        e++, i.shift(), a = i.length ? 0 : l;
      else
        break;
    !i.length && e && r < c.length && !c[e - 1].breakAfter && c[r].merge(0, 0, c[e - 1], !1, a, l) && e--, (e < r || i.length) && t.replaceChildren(e, r, i);
  }
}
function Fue(t, e, n, r, o, i) {
  let s = t.childCursor(), { i: a, off: l } = s.findPos(n, 1), { i: c, off: u } = s.findPos(e, -1), d = e - n;
  for (let f of r)
    d += f.length;
  t.length += d, Lue(t, c, u, a, l, r, 0, o, i);
}
let qo = typeof navigator < "u" ? navigator : { userAgent: "", vendor: "", platform: "" }, HI = typeof document < "u" ? document : { documentElement: { style: {} } };
const VI = /* @__PURE__ */ /Edge\/(\d+)/.exec(qo.userAgent), Bue = /* @__PURE__ */ /MSIE \d/.test(qo.userAgent), WI = /* @__PURE__ */ /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(qo.userAgent), CS = !!(Bue || WI || VI), cB = !CS && /* @__PURE__ */ /gecko\/(\d+)/i.test(qo.userAgent), QC = !CS && /* @__PURE__ */ /Chrome\/(\d+)/.exec(qo.userAgent), uB = "webkitFontSmoothing" in HI.documentElement.style, zue = !CS && /* @__PURE__ */ /Apple Computer/.test(qo.vendor), dB = zue && (/* @__PURE__ */ /Mobile\/\w+/.test(qo.userAgent) || qo.maxTouchPoints > 2);
var rt = {
  mac: dB || /* @__PURE__ */ /Mac/.test(qo.platform),
  windows: /* @__PURE__ */ /Win/.test(qo.platform),
  linux: /* @__PURE__ */ /Linux|X11/.test(qo.platform),
  ie: CS,
  ie_version: Bue ? HI.documentMode || 6 : WI ? +WI[1] : VI ? +VI[1] : 0,
  gecko: cB,
  gecko_version: cB ? +(/* @__PURE__ */ /Firefox\/(\d+)/.exec(qo.userAgent) || [0, 0])[1] : 0,
  chrome: !!QC,
  chrome_version: QC ? +QC[1] : 0,
  ios: dB,
  android: /* @__PURE__ */ /Android\b/.test(qo.userAgent),
  webkit: uB,
  safari: zue,
  webkit_version: uB ? +(/* @__PURE__ */ /\bAppleWebKit\/(\d+)/.exec(qo.userAgent) || [0, 0])[1] : 0,
  tabSize: HI.documentElement.style.tabSize != null ? "tab-size" : "-moz-tab-size"
};
const o6e = 256;
let Jc = class GI extends tr {
  constructor(e) {
    super(), this.text = e;
  }
  get length() {
    return this.text.length;
  }
  createDOM(e) {
    this.setDOM(e || document.createTextNode(this.text));
  }
  sync(e, n) {
    this.dom || this.createDOM(), this.dom.nodeValue != this.text && (n && n.node == this.dom && (n.written = !0), this.dom.nodeValue = this.text);
  }
  reuseDOM(e) {
    e.nodeType == 3 && this.createDOM(e);
  }
  merge(e, n, r) {
    return this.flags & 8 || r && (!(r instanceof GI) || this.length - (n - e) + r.length > o6e || r.flags & 8) ? !1 : (this.text = this.text.slice(0, e) + (r ? r.text : "") + this.text.slice(n), this.markDirty(), !0);
  }
  split(e) {
    let n = new GI(this.text.slice(e));
    return this.text = this.text.slice(0, e), this.markDirty(), n.flags |= this.flags & 8, n;
  }
  localPosFromDOM(e, n) {
    return e == this.dom ? n : n ? this.text.length : 0;
  }
  domAtPos(e) {
    return new gi(this.dom, e);
  }
  domBoundsAround(e, n, r) {
    return { from: r, to: r + this.length, startDOM: this.dom, endDOM: this.dom.nextSibling };
  }
  coordsAt(e, n) {
    return i6e(this.dom, e, n);
  }
}, Wh = class YI extends tr {
  constructor(e, n = [], r = 0) {
    super(), this.mark = e, this.children = n, this.length = r;
    for (let o of n)
      o.setParent(this);
  }
  setAttrs(e) {
    if (Mue(e), this.mark.class && (e.className = this.mark.class), this.mark.attrs)
      for (let n in this.mark.attrs)
        e.setAttribute(n, this.mark.attrs[n]);
    return e;
  }
  canReuseDOM(e) {
    return super.canReuseDOM(e) && !((this.flags | e.flags) & 8);
  }
  reuseDOM(e) {
    e.nodeName == this.mark.tagName.toUpperCase() && (this.setDOM(e), this.flags |= 6);
  }
  sync(e, n) {
    this.dom ? this.flags & 4 && this.setAttrs(this.dom) : this.setDOM(this.setAttrs(document.createElement(this.mark.tagName))), super.sync(e, n);
  }
  merge(e, n, r, o, i, s) {
    return r && (!(r instanceof YI && r.mark.eq(this.mark)) || e && i <= 0 || n < this.length && s <= 0) ? !1 : (Fue(this, e, n, r ? r.children.slice() : [], i - 1, s - 1), this.markDirty(), !0);
  }
  split(e) {
    let n = [], r = 0, o = -1, i = 0;
    for (let a of this.children) {
      let l = r + a.length;
      l > e && n.push(r < e ? a.split(e - r) : a), o < 0 && r >= e && (o = i), r = l, i++;
    }
    let s = this.length - e;
    return this.length = e, o > -1 && (this.children.length = o, this.markDirty()), new YI(this.mark, n, s);
  }
  domAtPos(e) {
    return que(this, e);
  }
  coordsAt(e, n) {
    return Hue(this, e, n);
  }
};
function i6e(t, e, n) {
  let r = t.nodeValue.length;
  e > r && (e = r);
  let o = e, i = e, s = 0;
  e == 0 && n < 0 || e == r && n >= 0 ? rt.chrome || rt.gecko || (e ? (o--, s = 1) : i < r && (i++, s = -1)) : n < 0 ? o-- : i < r && i++;
  let a = Dd(t, o, i).getClientRects();
  if (!a.length)
    return null;
  let l = a[(s ? s < 0 : n >= 0) ? 0 : a.length - 1];
  return rt.safari && !s && l.width == 0 && (l = Array.prototype.find.call(a, (c) => c.width) || l), s ? hv(l, s < 0) : l || null;
}
let Z5 = class pg extends tr {
  static create(e, n, r) {
    return new pg(e, n, r);
  }
  constructor(e, n, r) {
    super(), this.widget = e, this.length = n, this.side = r, this.prevWidget = null;
  }
  split(e) {
    let n = pg.create(this.widget, this.length - e, this.side);
    return this.length -= e, n;
  }
  sync(e) {
    (!this.dom || !this.widget.updateDOM(this.dom, e)) && (this.dom && this.prevWidget && this.prevWidget.destroy(this.dom), this.prevWidget = null, this.setDOM(this.widget.toDOM(e)), this.widget.editable || (this.dom.contentEditable = "false"));
  }
  getSide() {
    return this.side;
  }
  merge(e, n, r, o, i, s) {
    return r && (!(r instanceof pg) || !this.widget.compare(r.widget) || e > 0 && i <= 0 || n < this.length && s <= 0) ? !1 : (this.length = e + (r ? r.length : 0) + (this.length - n), !0);
  }
  become(e) {
    return e instanceof pg && e.side == this.side && this.widget.constructor == e.widget.constructor ? (this.widget.compare(e.widget) || this.markDirty(!0), this.dom && !this.prevWidget && (this.prevWidget = this.widget), this.widget = e.widget, this.length = e.length, !0) : !1;
  }
  ignoreMutation() {
    return !0;
  }
  ignoreEvent(e) {
    return this.widget.ignoreEvent(e);
  }
  get overrideDOMText() {
    if (this.length == 0)
      return ln.empty;
    let e = this;
    for (; e.parent; )
      e = e.parent;
    let { view: n } = e, r = n && n.state.doc, o = this.posAtStart;
    return r ? r.slice(o, o + this.length) : ln.empty;
  }
  domAtPos(e) {
    return (this.length ? e == 0 : this.side > 0) ? gi.before(this.dom) : gi.after(this.dom, e == this.length);
  }
  domBoundsAround() {
    return null;
  }
  coordsAt(e, n) {
    let r = this.widget.coordsAt(this.dom, e, n);
    if (r)
      return r;
    let o = this.dom.getClientRects(), i = null;
    if (!o.length)
      return null;
    let s = this.side ? this.side < 0 : e > 0;
    for (let a = s ? o.length - 1 : 0; i = o[a], !(e > 0 ? a == 0 : a == o.length - 1 || i.top < i.bottom); a += s ? -1 : 1)
      ;
    return hv(i, !s);
  }
  get isEditable() {
    return !1;
  }
  get isWidget() {
    return !0;
  }
  get isHidden() {
    return this.widget.isHidden;
  }
  destroy() {
    super.destroy(), this.dom && this.widget.destroy(this.dom);
  }
};
class Gh extends tr {
  constructor(e) {
    super(), this.side = e;
  }
  get length() {
    return 0;
  }
  merge() {
    return !1;
  }
  become(e) {
    return e instanceof Gh && e.side == this.side;
  }
  split() {
    return new Gh(this.side);
  }
  sync() {
    if (!this.dom) {
      let e = document.createElement("img");
      e.className = "cm-widgetBuffer", e.setAttribute("aria-hidden", "true"), this.setDOM(e);
    }
  }
  getSide() {
    return this.side;
  }
  domAtPos(e) {
    return this.side > 0 ? gi.before(this.dom) : gi.after(this.dom);
  }
  localPosFromDOM() {
    return 0;
  }
  domBoundsAround() {
    return null;
  }
  coordsAt(e) {
    return this.dom.getBoundingClientRect();
  }
  get overrideDOMText() {
    return ln.empty;
  }
  get isHidden() {
    return !0;
  }
}
Jc.prototype.children = Z5.prototype.children = Gh.prototype.children = Q5;
function que(t, e) {
  let n = t.dom, { children: r } = t, o = 0;
  for (let i = 0; o < r.length; o++) {
    let s = r[o], a = i + s.length;
    if (!(a == i && s.getSide() <= 0)) {
      if (e > i && e < a && s.dom.parentNode == n)
        return s.domAtPos(e - i);
      if (e <= i)
        break;
      i = a;
    }
  }
  for (let i = o; i > 0; i--) {
    let s = r[i - 1];
    if (s.dom.parentNode == n)
      return s.domAtPos(s.length);
  }
  for (let i = o; i < r.length; i++) {
    let s = r[i];
    if (s.dom.parentNode == n)
      return s.domAtPos(0);
  }
  return new gi(n, 0);
}
function Uue(t, e, n) {
  let r, { children: o } = t;
  n > 0 && e instanceof Wh && o.length && (r = o[o.length - 1]) instanceof Wh && r.mark.eq(e.mark) ? Uue(r, e.children[0], n - 1) : (o.push(e), e.setParent(t)), t.length += e.length;
}
function Hue(t, e, n) {
  let r = null, o = -1, i = null, s = -1;
  function a(c, u) {
    for (let d = 0, f = 0; d < c.children.length && f <= u; d++) {
      let h = c.children[d], p = f + h.length;
      p >= u && (h.children.length ? a(h, u - f) : (!i || i.isHidden && n > 0) && (p > u || f == p && h.getSide() > 0) ? (i = h, s = u - f) : (f < u || f == p && h.getSide() < 0 && !h.isHidden) && (r = h, o = u - f)), f = p;
    }
  }
  a(t, e);
  let l = (n < 0 ? r : i) || r || i;
  return l ? l.coordsAt(Math.max(0, l == r ? o : s), n) : s6e(t);
}
function s6e(t) {
  let e = t.dom.lastChild;
  if (!e)
    return t.dom.getBoundingClientRect();
  let n = Vh(e);
  return n[n.length - 1] || null;
}
function KI(t, e) {
  for (let n in t)
    n == "class" && e.class ? e.class += " " + t.class : n == "style" && e.style ? e.style += ";" + t.style : e[n] = t[n];
  return e;
}
const fB = /* @__PURE__ */ Object.create(null);
function wx(t, e, n) {
  if (t == e)
    return !0;
  t || (t = fB), e || (e = fB);
  let r = Object.keys(t), o = Object.keys(e);
  if (r.length - (n && r.indexOf(n) > -1 ? 1 : 0) != o.length - (n && o.indexOf(n) > -1 ? 1 : 0))
    return !1;
  for (let i of r)
    if (i != n && (o.indexOf(i) == -1 || t[i] !== e[i]))
      return !1;
  return !0;
}
function XI(t, e, n) {
  let r = !1;
  if (e)
    for (let o in e)
      n && o in n || (r = !0, o == "style" ? t.style.cssText = "" : t.removeAttribute(o));
  if (n)
    for (let o in n)
      e && e[o] == n[o] || (r = !0, o == "style" ? t.style.cssText = n[o] : t.setAttribute(o, n[o]));
  return r;
}
function a6e(t) {
  let e = /* @__PURE__ */ Object.create(null);
  for (let n = 0; n < t.attributes.length; n++) {
    let r = t.attributes[n];
    e[r.name] = r.value;
  }
  return e;
}
class Pa {
  /**
  Compare this instance to another instance of the same type.
  (TypeScript can't express this, but only instances of the same
  specific class will be passed to this method.) This is used to
  avoid redrawing widgets when they are replaced by a new
  decoration of the same type. The default implementation just
  returns `false`, which will cause new instances of the widget to
  always be redrawn.
  */
  eq(e) {
    return !1;
  }
  /**
  Update a DOM element created by a widget of the same type (but
  different, non-`eq` content) to reflect this widget. May return
  true to indicate that it could update, false to indicate it
  couldn't (in which case the widget will be redrawn). The default
  implementation just returns false.
  */
  updateDOM(e, n) {
    return !1;
  }
  /**
  @internal
  */
  compare(e) {
    return this == e || this.constructor == e.constructor && this.eq(e);
  }
  /**
  The estimated height this widget will have, to be used when
  estimating the height of content that hasn't been drawn. May
  return -1 to indicate you don't know. The default implementation
  returns -1.
  */
  get estimatedHeight() {
    return -1;
  }
  /**
  For inline widgets that are displayed inline (as opposed to
  `inline-block`) and introduce line breaks (through `<br>` tags
  or textual newlines), this must indicate the amount of line
  breaks they introduce. Defaults to 0.
  */
  get lineBreaks() {
    return 0;
  }
  /**
  Can be used to configure which kinds of events inside the widget
  should be ignored by the editor. The default is to ignore all
  events.
  */
  ignoreEvent(e) {
    return !0;
  }
  /**
  Override the way screen coordinates for positions at/in the
  widget are found. `pos` will be the offset into the widget, and
  `side` the side of the position that is being queried—less than
  zero for before, greater than zero for after, and zero for
  directly at that position.
  */
  coordsAt(e, n, r) {
    return null;
  }
  /**
  @internal
  */
  get isHidden() {
    return !1;
  }
  /**
  @internal
  */
  get editable() {
    return !1;
  }
  /**
  This is called when the an instance of the widget is removed
  from the editor view.
  */
  destroy(e) {
  }
}
var Ao = /* @__PURE__ */ function(t) {
  return t[t.Text = 0] = "Text", t[t.WidgetBefore = 1] = "WidgetBefore", t[t.WidgetAfter = 2] = "WidgetAfter", t[t.WidgetRange = 3] = "WidgetRange", t;
}(Ao || (Ao = {}));
let ut = class extends Pd {
  constructor(e, n, r, o) {
    super(), this.startSide = e, this.endSide = n, this.widget = r, this.spec = o;
  }
  /**
  @internal
  */
  get heightRelevant() {
    return !1;
  }
  /**
  Create a mark decoration, which influences the styling of the
  content in its range. Nested mark decorations will cause nested
  DOM elements to be created. Nesting order is determined by
  precedence of the [facet](https://codemirror.net/6/docs/ref/#view.EditorView^decorations), with
  the higher-precedence decorations creating the inner DOM nodes.
  Such elements are split on line boundaries and on the boundaries
  of lower-precedence decorations.
  */
  static mark(e) {
    return new pv(e);
  }
  /**
  Create a widget decoration, which displays a DOM element at the
  given position.
  */
  static widget(e) {
    let n = Math.max(-1e4, Math.min(1e4, e.side || 0)), r = !!e.block;
    return n += r && !e.inlineOrder ? n > 0 ? 3e8 : -4e8 : n > 0 ? 1e8 : -1e8, new Yh(e, n, n, r, e.widget || null, !1);
  }
  /**
  Create a replace decoration which replaces the given range with
  a widget, or simply hides it.
  */
  static replace(e) {
    let n = !!e.block, r, o;
    if (e.isBlockGap)
      r = -5e8, o = 4e8;
    else {
      let { start: i, end: s } = Gue(e, n);
      r = (i ? n ? -3e8 : -1 : 5e8) - 1, o = (s ? n ? 2e8 : 1 : -6e8) + 1;
    }
    return new Yh(e, r, o, n, e.widget || null, !0);
  }
  /**
  Create a line decoration, which can add DOM attributes to the
  line starting at the given position.
  */
  static line(e) {
    return new J5(e);
  }
  /**
  Build a [`DecorationSet`](https://codemirror.net/6/docs/ref/#view.DecorationSet) from the given
  decorated range or ranges. If the ranges aren't already sorted,
  pass `true` for `sort` to make the library sort them for you.
  */
  static set(e, n = !1) {
    return or.of(e, n);
  }
  /**
  @internal
  */
  hasHeight() {
    return this.widget ? this.widget.estimatedHeight > -1 : !1;
  }
};
ut.none = or.empty;
class pv extends ut {
  constructor(e) {
    let { start: n, end: r } = Gue(e);
    super(n ? -1 : 5e8, r ? 1 : -6e8, null, e), this.tagName = e.tagName || "span", this.class = e.class || "", this.attrs = e.attributes || null;
  }
  eq(e) {
    var n, r;
    return this == e || e instanceof pv && this.tagName == e.tagName && (this.class || ((n = this.attrs) === null || n === void 0 ? void 0 : n.class)) == (e.class || ((r = e.attrs) === null || r === void 0 ? void 0 : r.class)) && wx(this.attrs, e.attrs, "class");
  }
  range(e, n = e) {
    if (e >= n)
      throw new RangeError("Mark decorations may not be empty");
    return super.range(e, n);
  }
}
pv.prototype.point = !1;
let J5 = class Vue extends ut {
  constructor(e) {
    super(-2e8, -2e8, null, e);
  }
  eq(e) {
    return e instanceof Vue && this.spec.class == e.spec.class && wx(this.spec.attributes, e.spec.attributes);
  }
  range(e, n = e) {
    if (n != e)
      throw new RangeError("Line decoration ranges must be zero-length");
    return super.range(e, n);
  }
};
J5.prototype.mapMode = Co.TrackBefore;
J5.prototype.point = !0;
let Yh = class Wue extends ut {
  constructor(e, n, r, o, i, s) {
    super(n, r, i, e), this.block = o, this.isReplace = s, this.mapMode = o ? n <= 0 ? Co.TrackBefore : Co.TrackAfter : Co.TrackDel;
  }
  // Only relevant when this.block == true
  get type() {
    return this.startSide != this.endSide ? Ao.WidgetRange : this.startSide <= 0 ? Ao.WidgetBefore : Ao.WidgetAfter;
  }
  get heightRelevant() {
    return this.block || !!this.widget && (this.widget.estimatedHeight >= 5 || this.widget.lineBreaks > 0);
  }
  eq(e) {
    return e instanceof Wue && l6e(this.widget, e.widget) && this.block == e.block && this.startSide == e.startSide && this.endSide == e.endSide;
  }
  range(e, n = e) {
    if (this.isReplace && (e > n || e == n && this.startSide > 0 && this.endSide <= 0))
      throw new RangeError("Invalid range for replacement decoration");
    if (!this.isReplace && n != e)
      throw new RangeError("Widget decorations can only have zero-length ranges");
    return super.range(e, n);
  }
};
Yh.prototype.point = !0;
function Gue(t, e = !1) {
  let { inclusiveStart: n, inclusiveEnd: r } = t;
  return n == null && (n = t.inclusive), r == null && (r = t.inclusive), { start: n ?? e, end: r ?? e };
}
function l6e(t, e) {
  return t == e || !!(t && e && t.compare(e));
}
function uw(t, e, n, r = 0) {
  let o = n.length - 1;
  o >= 0 && n[o] + r >= t ? n[o] = Math.max(n[o], e) : n.push(t, e);
}
let So = class mg extends tr {
  constructor() {
    super(...arguments), this.children = [], this.length = 0, this.prevAttrs = void 0, this.attrs = null, this.breakAfter = 0;
  }
  // Consumes source
  merge(e, n, r, o, i, s) {
    if (r) {
      if (!(r instanceof mg))
        return !1;
      this.dom || r.transferDOM(this);
    }
    return o && this.setDeco(r ? r.attrs : null), Fue(this, e, n, r ? r.children.slice() : [], i, s), !0;
  }
  split(e) {
    let n = new mg();
    if (n.breakAfter = this.breakAfter, this.length == 0)
      return n;
    let { i: r, off: o } = this.childPos(e);
    o && (n.append(this.children[r].split(o), 0), this.children[r].merge(o, this.children[r].length, null, !1, 0, 0), r++);
    for (let i = r; i < this.children.length; i++)
      n.append(this.children[i], 0);
    for (; r > 0 && this.children[r - 1].length == 0; )
      this.children[--r].destroy();
    return this.children.length = r, this.markDirty(), this.length = e, n;
  }
  transferDOM(e) {
    this.dom && (this.markDirty(), e.setDOM(this.dom), e.prevAttrs = this.prevAttrs === void 0 ? this.attrs : this.prevAttrs, this.prevAttrs = void 0, this.dom = null);
  }
  setDeco(e) {
    wx(this.attrs, e) || (this.dom && (this.prevAttrs = this.attrs, this.markDirty()), this.attrs = e);
  }
  append(e, n) {
    Uue(this, e, n);
  }
  // Only called when building a line view in ContentBuilder
  addLineDeco(e) {
    let n = e.spec.attributes, r = e.spec.class;
    n && (this.attrs = KI(n, this.attrs || {})), r && (this.attrs = KI({ class: r }, this.attrs || {}));
  }
  domAtPos(e) {
    return que(this, e);
  }
  reuseDOM(e) {
    e.nodeName == "DIV" && (this.setDOM(e), this.flags |= 6);
  }
  sync(e, n) {
    var r;
    this.dom ? this.flags & 4 && (Mue(this.dom), this.dom.className = "cm-line", this.prevAttrs = this.attrs ? null : void 0) : (this.setDOM(document.createElement("div")), this.dom.className = "cm-line", this.prevAttrs = this.attrs ? null : void 0), this.prevAttrs !== void 0 && (XI(this.dom, this.prevAttrs, this.attrs), this.dom.classList.add("cm-line"), this.prevAttrs = void 0), super.sync(e, n);
    let o = this.dom.lastChild;
    for (; o && tr.get(o) instanceof Wh; )
      o = o.lastChild;
    if (!o || !this.length || o.nodeName != "BR" && ((r = tr.get(o)) === null || r === void 0 ? void 0 : r.isEditable) == !1 && (!rt.ios || !this.children.some((i) => i instanceof Jc))) {
      let i = document.createElement("BR");
      i.cmIgnore = !0, this.dom.appendChild(i);
    }
  }
  measureTextSize() {
    if (this.children.length == 0 || this.length > 20)
      return null;
    let e = 0, n;
    for (let r of this.children) {
      if (!(r instanceof Jc) || /[^ -~]/.test(r.text))
        return null;
      let o = Vh(r.dom);
      if (o.length != 1)
        return null;
      e += o[0].width, n = o[0].height;
    }
    return e ? {
      lineHeight: this.dom.getBoundingClientRect().height,
      charWidth: e / this.length,
      textHeight: n
    } : null;
  }
  coordsAt(e, n) {
    let r = Hue(this, e, n);
    if (!this.children.length && r && this.parent) {
      let { heightOracle: o } = this.parent.view.viewState, i = r.bottom - r.top;
      if (Math.abs(i - o.lineHeight) < 2 && o.textHeight < i) {
        let s = (i - o.textHeight) / 2;
        return { top: r.top + s, bottom: r.bottom - s, left: r.left, right: r.left };
      }
    }
    return r;
  }
  become(e) {
    return e instanceof mg && this.children.length == 0 && e.children.length == 0 && wx(this.attrs, e.attrs) && this.breakAfter == e.breakAfter;
  }
  covers() {
    return !0;
  }
  static find(e, n) {
    for (let r = 0, o = 0; r < e.children.length; r++) {
      let i = e.children[r], s = o + i.length;
      if (s >= n) {
        if (i instanceof mg)
          return i;
        if (s > n)
          break;
      }
      o = s + i.breakAfter;
    }
    return null;
  }
}, t0 = class dw extends tr {
  constructor(e, n, r) {
    super(), this.widget = e, this.length = n, this.deco = r, this.breakAfter = 0, this.prevWidget = null;
  }
  merge(e, n, r, o, i, s) {
    return r && (!(r instanceof dw) || !this.widget.compare(r.widget) || e > 0 && i <= 0 || n < this.length && s <= 0) ? !1 : (this.length = e + (r ? r.length : 0) + (this.length - n), !0);
  }
  domAtPos(e) {
    return e == 0 ? gi.before(this.dom) : gi.after(this.dom, e == this.length);
  }
  split(e) {
    let n = this.length - e;
    this.length = e;
    let r = new dw(this.widget, n, this.deco);
    return r.breakAfter = this.breakAfter, r;
  }
  get children() {
    return Q5;
  }
  sync(e) {
    (!this.dom || !this.widget.updateDOM(this.dom, e)) && (this.dom && this.prevWidget && this.prevWidget.destroy(this.dom), this.prevWidget = null, this.setDOM(this.widget.toDOM(e)), this.widget.editable || (this.dom.contentEditable = "false"));
  }
  get overrideDOMText() {
    return this.parent ? this.parent.view.state.doc.slice(this.posAtStart, this.posAtEnd) : ln.empty;
  }
  domBoundsAround() {
    return null;
  }
  become(e) {
    return e instanceof dw && e.widget.constructor == this.widget.constructor ? (e.widget.compare(this.widget) || this.markDirty(!0), this.dom && !this.prevWidget && (this.prevWidget = this.widget), this.widget = e.widget, this.length = e.length, this.deco = e.deco, this.breakAfter = e.breakAfter, !0) : !1;
  }
  ignoreMutation() {
    return !0;
  }
  ignoreEvent(e) {
    return this.widget.ignoreEvent(e);
  }
  get isEditable() {
    return !1;
  }
  get isWidget() {
    return !0;
  }
  coordsAt(e, n) {
    return this.widget.coordsAt(this.dom, e, n) || (this.widget instanceof QI ? null : hv(this.dom.getBoundingClientRect(), this.length ? e == 0 : n <= 0));
  }
  destroy() {
    super.destroy(), this.dom && this.widget.destroy(this.dom);
  }
  covers(e) {
    let { startSide: n, endSide: r } = this.deco;
    return n == r ? !1 : e < 0 ? n < 0 : r > 0;
  }
}, QI = class extends Pa {
  constructor(e) {
    super(), this.height = e;
  }
  toDOM() {
    let e = document.createElement("div");
    return e.className = "cm-gap", this.updateDOM(e), e;
  }
  eq(e) {
    return e.height == this.height;
  }
  updateDOM(e) {
    return e.style.height = this.height + "px", !0;
  }
  get editable() {
    return !0;
  }
  get estimatedHeight() {
    return this.height;
  }
  ignoreEvent() {
    return !1;
  }
};
class n0 {
  constructor(e, n, r, o) {
    this.doc = e, this.pos = n, this.end = r, this.disallowBlockEffectsFor = o, this.content = [], this.curLine = null, this.breakAtStart = 0, this.pendingBuffer = 0, this.bufferMarks = [], this.atCursorPos = !0, this.openStart = -1, this.openEnd = -1, this.text = "", this.textOff = 0, this.cursor = e.iter(), this.skip = n;
  }
  posCovered() {
    if (this.content.length == 0)
      return !this.breakAtStart && this.doc.lineAt(this.pos).from != this.pos;
    let e = this.content[this.content.length - 1];
    return !(e.breakAfter || e instanceof t0 && e.deco.endSide < 0);
  }
  getLine() {
    return this.curLine || (this.content.push(this.curLine = new So()), this.atCursorPos = !0), this.curLine;
  }
  flushBuffer(e = this.bufferMarks) {
    this.pendingBuffer && (this.curLine.append(Cb(new Gh(-1), e), e.length), this.pendingBuffer = 0);
  }
  addBlockWidget(e) {
    this.flushBuffer(), this.curLine = null, this.content.push(e);
  }
  finish(e) {
    this.pendingBuffer && e <= this.bufferMarks.length ? this.flushBuffer() : this.pendingBuffer = 0, !this.posCovered() && !(e && this.content.length && this.content[this.content.length - 1] instanceof t0) && this.getLine();
  }
  buildText(e, n, r) {
    for (; e > 0; ) {
      if (this.textOff == this.text.length) {
        let { value: i, lineBreak: s, done: a } = this.cursor.next(this.skip);
        if (this.skip = 0, a)
          throw new Error("Ran out of text content when drawing inline views");
        if (s) {
          this.posCovered() || this.getLine(), this.content.length ? this.content[this.content.length - 1].breakAfter = 1 : this.breakAtStart = 1, this.flushBuffer(), this.curLine = null, this.atCursorPos = !0, e--;
          continue;
        } else
          this.text = i, this.textOff = 0;
      }
      let o = Math.min(
        this.text.length - this.textOff,
        e,
        512
        /* T.Chunk */
      );
      this.flushBuffer(n.slice(n.length - r)), this.getLine().append(Cb(new Jc(this.text.slice(this.textOff, this.textOff + o)), n), r), this.atCursorPos = !0, this.textOff += o, e -= o, r = 0;
    }
  }
  span(e, n, r, o) {
    this.buildText(n - e, r, o), this.pos = n, this.openStart < 0 && (this.openStart = o);
  }
  point(e, n, r, o, i, s) {
    if (this.disallowBlockEffectsFor[s] && r instanceof Yh) {
      if (r.block)
        throw new RangeError("Block decorations may not be specified via plugins");
      if (n > this.doc.lineAt(this.pos).to)
        throw new RangeError("Decorations that replace line breaks may not be specified via plugins");
    }
    let a = n - e;
    if (r instanceof Yh)
      if (r.block)
        r.startSide > 0 && !this.posCovered() && this.getLine(), this.addBlockWidget(new t0(r.widget || Kh.block, a, r));
      else {
        let l = Z5.create(r.widget || Kh.inline, a, a ? 0 : r.startSide), c = this.atCursorPos && !l.isEditable && i <= o.length && (e < n || r.startSide > 0), u = !l.isEditable && (e < n || i > o.length || r.startSide <= 0), d = this.getLine();
        this.pendingBuffer == 2 && !c && !l.isEditable && (this.pendingBuffer = 0), this.flushBuffer(o), c && (d.append(Cb(new Gh(1), o), i), i = o.length + Math.max(0, i - o.length)), d.append(Cb(l, o), i), this.atCursorPos = u, this.pendingBuffer = u ? e < n || i > o.length ? 1 : 2 : 0, this.pendingBuffer && (this.bufferMarks = o.slice());
      }
    else this.doc.lineAt(this.pos).from == this.pos && this.getLine().addLineDeco(r);
    a && (this.textOff + a <= this.text.length ? this.textOff += a : (this.skip += a - (this.text.length - this.textOff), this.text = "", this.textOff = 0), this.pos = n), this.openStart < 0 && (this.openStart = i);
  }
  static build(e, n, r, o, i) {
    let s = new n0(e, n, r, i);
    return s.openEnd = or.spans(o, n, r, s), s.openStart < 0 && (s.openStart = s.openEnd), s.finish(s.openEnd), s;
  }
}
function Cb(t, e) {
  for (let n of e)
    t = new Wh(n, [t], t.length);
  return t;
}
class Kh extends Pa {
  constructor(e) {
    super(), this.tag = e;
  }
  eq(e) {
    return e.tag == this.tag;
  }
  toDOM() {
    return document.createElement(this.tag);
  }
  updateDOM(e) {
    return e.nodeName.toLowerCase() == this.tag;
  }
  get isHidden() {
    return !0;
  }
}
Kh.inline = /* @__PURE__ */ new Kh("span");
Kh.block = /* @__PURE__ */ new Kh("div");
var Kn = /* @__PURE__ */ function(t) {
  return t[t.LTR = 0] = "LTR", t[t.RTL = 1] = "RTL", t;
}(Kn || (Kn = {}));
const Id = Kn.LTR, eL = Kn.RTL;
function Yue(t) {
  let e = [];
  for (let n = 0; n < t.length; n++)
    e.push(1 << +t[n]);
  return e;
}
const c6e = /* @__PURE__ */ Yue("88888888888888888888888888888888888666888888787833333333337888888000000000000000000000000008888880000000000000000000000000088888888888888888888888888888888888887866668888088888663380888308888800000000000000000000000800000000000000000000000000000008"), u6e = /* @__PURE__ */ Yue("4444448826627288999999999992222222222222222222222222222222222222222222222229999999999999999999994444444444644222822222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222999999949999999229989999223333333333"), ZI = /* @__PURE__ */ Object.create(null), zs = [];
for (let t of ["()", "[]", "{}"]) {
  let e = /* @__PURE__ */ t.charCodeAt(0), n = /* @__PURE__ */ t.charCodeAt(1);
  ZI[e] = n, ZI[n] = -e;
}
function Kue(t) {
  return t <= 247 ? c6e[t] : 1424 <= t && t <= 1524 ? 2 : 1536 <= t && t <= 1785 ? u6e[t - 1536] : 1774 <= t && t <= 2220 ? 4 : 8192 <= t && t <= 8204 ? 256 : 64336 <= t && t <= 65023 ? 4 : 1;
}
const d6e = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac\ufb50-\ufdff]/;
let Dc = class {
  /**
  The direction of this span.
  */
  get dir() {
    return this.level % 2 ? eL : Id;
  }
  /**
  @internal
  */
  constructor(e, n, r) {
    this.from = e, this.to = n, this.level = r;
  }
  /**
  @internal
  */
  side(e, n) {
    return this.dir == n == e ? this.to : this.from;
  }
  /**
  @internal
  */
  forward(e, n) {
    return e == (this.dir == n);
  }
  /**
  @internal
  */
  static find(e, n, r, o) {
    let i = -1;
    for (let s = 0; s < e.length; s++) {
      let a = e[s];
      if (a.from <= n && a.to >= n) {
        if (a.level == r)
          return s;
        (i < 0 || (o != 0 ? o < 0 ? a.from < n : a.to > n : e[i].level > a.level)) && (i = s);
      }
    }
    if (i < 0)
      throw new RangeError("Index out of range");
    return i;
  }
};
function Xue(t, e) {
  if (t.length != e.length)
    return !1;
  for (let n = 0; n < t.length; n++) {
    let r = t[n], o = e[n];
    if (r.from != o.from || r.to != o.to || r.direction != o.direction || !Xue(r.inner, o.inner))
      return !1;
  }
  return !0;
}
const Nn = [];
function f6e(t, e, n, r, o) {
  for (let i = 0; i <= r.length; i++) {
    let s = i ? r[i - 1].to : e, a = i < r.length ? r[i].from : n, l = i ? 256 : o;
    for (let c = s, u = l, d = l; c < a; c++) {
      let f = Kue(t.charCodeAt(c));
      f == 512 ? f = u : f == 8 && d == 4 && (f = 16), Nn[c] = f == 4 ? 2 : f, f & 7 && (d = f), u = f;
    }
    for (let c = s, u = l, d = l; c < a; c++) {
      let f = Nn[c];
      if (f == 128)
        c < a - 1 && u == Nn[c + 1] && u & 24 ? f = Nn[c] = u : Nn[c] = 256;
      else if (f == 64) {
        let h = c + 1;
        for (; h < a && Nn[h] == 64; )
          h++;
        let p = c && u == 8 || h < n && Nn[h] == 8 ? d == 1 ? 1 : 8 : 256;
        for (let m = c; m < h; m++)
          Nn[m] = p;
        c = h - 1;
      } else f == 8 && d == 1 && (Nn[c] = 1);
      u = f, f & 7 && (d = f);
    }
  }
}
function h6e(t, e, n, r, o) {
  let i = o == 1 ? 2 : 1;
  for (let s = 0, a = 0, l = 0; s <= r.length; s++) {
    let c = s ? r[s - 1].to : e, u = s < r.length ? r[s].from : n;
    for (let d = c, f, h, p; d < u; d++)
      if (h = ZI[f = t.charCodeAt(d)])
        if (h < 0) {
          for (let m = a - 3; m >= 0; m -= 3)
            if (zs[m + 1] == -h) {
              let g = zs[m + 2], y = g & 2 ? o : g & 4 ? g & 1 ? i : o : 0;
              y && (Nn[d] = Nn[zs[m]] = y), a = m;
              break;
            }
        } else {
          if (zs.length == 189)
            break;
          zs[a++] = d, zs[a++] = f, zs[a++] = l;
        }
      else if ((p = Nn[d]) == 2 || p == 1) {
        let m = p == o;
        l = m ? 0 : 1;
        for (let g = a - 3; g >= 0; g -= 3) {
          let y = zs[g + 2];
          if (y & 2)
            break;
          if (m)
            zs[g + 2] |= 2;
          else {
            if (y & 4)
              break;
            zs[g + 2] |= 4;
          }
        }
      }
  }
}
function p6e(t, e, n, r) {
  for (let o = 0, i = r; o <= n.length; o++) {
    let s = o ? n[o - 1].to : t, a = o < n.length ? n[o].from : e;
    for (let l = s; l < a; ) {
      let c = Nn[l];
      if (c == 256) {
        let u = l + 1;
        for (; ; )
          if (u == a) {
            if (o == n.length)
              break;
            u = n[o++].to, a = o < n.length ? n[o].from : e;
          } else if (Nn[u] == 256)
            u++;
          else
            break;
        let d = i == 1, f = (u < e ? Nn[u] : r) == 1, h = d == f ? d ? 1 : 2 : r;
        for (let p = u, m = o, g = m ? n[m - 1].to : t; p > l; )
          p == g && (p = n[--m].from, g = m ? n[m - 1].to : t), Nn[--p] = h;
        l = u;
      } else
        i = c, l++;
    }
  }
}
function JI(t, e, n, r, o, i, s) {
  let a = r % 2 ? 2 : 1;
  if (r % 2 == o % 2)
    for (let l = e, c = 0; l < n; ) {
      let u = !0, d = !1;
      if (c == i.length || l < i[c].from) {
        let m = Nn[l];
        m != a && (u = !1, d = m == 16);
      }
      let f = !u && a == 1 ? [] : null, h = u ? r : r + 1, p = l;
      e: for (; ; )
        if (c < i.length && p == i[c].from) {
          if (d)
            break e;
          let m = i[c];
          if (!u)
            for (let g = m.to, y = c + 1; ; ) {
              if (g == n)
                break e;
              if (y < i.length && i[y].from == g)
                g = i[y++].to;
              else {
                if (Nn[g] == a)
                  break e;
                break;
              }
            }
          if (c++, f)
            f.push(m);
          else {
            m.from > l && s.push(new Dc(l, m.from, h));
            let g = m.direction == Id != !(h % 2);
            eN(t, g ? r + 1 : r, o, m.inner, m.from, m.to, s), l = m.to;
          }
          p = m.to;
        } else {
          if (p == n || (u ? Nn[p] != a : Nn[p] == a))
            break;
          p++;
        }
      f ? JI(t, l, p, r + 1, o, f, s) : l < p && s.push(new Dc(l, p, h)), l = p;
    }
  else
    for (let l = n, c = i.length; l > e; ) {
      let u = !0, d = !1;
      if (!c || l > i[c - 1].to) {
        let m = Nn[l - 1];
        m != a && (u = !1, d = m == 16);
      }
      let f = !u && a == 1 ? [] : null, h = u ? r : r + 1, p = l;
      e: for (; ; )
        if (c && p == i[c - 1].to) {
          if (d)
            break e;
          let m = i[--c];
          if (!u)
            for (let g = m.from, y = c; ; ) {
              if (g == e)
                break e;
              if (y && i[y - 1].to == g)
                g = i[--y].from;
              else {
                if (Nn[g - 1] == a)
                  break e;
                break;
              }
            }
          if (f)
            f.push(m);
          else {
            m.to < l && s.push(new Dc(m.to, l, h));
            let g = m.direction == Id != !(h % 2);
            eN(t, g ? r + 1 : r, o, m.inner, m.from, m.to, s), l = m.from;
          }
          p = m.from;
        } else {
          if (p == e || (u ? Nn[p - 1] != a : Nn[p - 1] == a))
            break;
          p--;
        }
      f ? JI(t, p, l, r + 1, o, f, s) : p < l && s.push(new Dc(p, l, h)), l = p;
    }
}
function eN(t, e, n, r, o, i, s) {
  let a = e % 2 ? 2 : 1;
  f6e(t, o, i, r, a), h6e(t, o, i, r, a), p6e(o, i, r, a), JI(t, o, i, e, n, r, s);
}
function m6e(t, e, n) {
  if (!t)
    return [new Dc(0, 0, e == eL ? 1 : 0)];
  if (e == Id && !n.length && !d6e.test(t))
    return Que(t.length);
  if (n.length)
    for (; t.length > Nn.length; )
      Nn[Nn.length] = 256;
  let r = [], o = e == Id ? 0 : 1;
  return eN(t, o, o, n, 0, t.length, r), r;
}
function Que(t) {
  return [new Dc(0, t, 0)];
}
let Zue = "";
function g6e(t, e, n, r, o) {
  var i;
  let s = r.head - t.from, a = Dc.find(e, s, (i = r.bidiLevel) !== null && i !== void 0 ? i : -1, r.assoc), l = e[a], c = l.side(o, n);
  if (s == c) {
    let f = a += o ? 1 : -1;
    if (f < 0 || f >= e.length)
      return null;
    l = e[a = f], s = l.side(!o, n), c = l.side(o, n);
  }
  let u = Zr(t.text, s, l.forward(o, n));
  (u < l.from || u > l.to) && (u = c), Zue = t.text.slice(Math.min(s, u), Math.max(s, u));
  let d = a == (o ? e.length - 1 : 0) ? null : e[a + (o ? 1 : -1)];
  return d && u == c && d.level + (o ? 0 : 1) < l.level ? $e.cursor(d.side(!o, n) + t.from, d.forward(o, n) ? 1 : -1, d.level) : $e.cursor(u + t.from, l.forward(o, n) ? -1 : 1, l.level);
}
function y6e(t, e, n) {
  for (let r = e; r < n; r++) {
    let o = Kue(t.charCodeAt(r));
    if (o == 1)
      return Id;
    if (o == 2 || o == 4)
      return eL;
  }
  return Id;
}
const Jue = /* @__PURE__ */ lt.define(), ede = /* @__PURE__ */ lt.define(), tde = /* @__PURE__ */ lt.define(), nde = /* @__PURE__ */ lt.define(), tN = /* @__PURE__ */ lt.define(), rde = /* @__PURE__ */ lt.define(), ode = /* @__PURE__ */ lt.define(), tL = /* @__PURE__ */ lt.define(), nL = /* @__PURE__ */ lt.define(), ide = /* @__PURE__ */ lt.define({
  combine: (t) => t.some((e) => e)
}), sde = /* @__PURE__ */ lt.define({
  combine: (t) => t.some((e) => e)
}), ade = /* @__PURE__ */ lt.define();
class yh {
  constructor(e, n = "nearest", r = "nearest", o = 5, i = 5, s = !1) {
    this.range = e, this.y = n, this.x = r, this.yMargin = o, this.xMargin = i, this.isSnapshot = s;
  }
  map(e) {
    return e.empty ? this : new yh(this.range.map(e), this.y, this.x, this.yMargin, this.xMargin, this.isSnapshot);
  }
  clip(e) {
    return this.range.to <= e.doc.length ? this : new yh($e.cursor(e.doc.length), this.y, this.x, this.yMargin, this.xMargin, this.isSnapshot);
  }
}
const kb = /* @__PURE__ */ xt.define({ map: (t, e) => t.map(e) }), lde = /* @__PURE__ */ xt.define();
function Wo(t, e, n) {
  let r = t.facet(nde);
  r.length ? r[0](e) : window.onerror ? window.onerror(String(e), n, void 0, void 0, e) : n ? console.error(n + ":", e) : console.error(e);
}
const pl = /* @__PURE__ */ lt.define({ combine: (t) => t.length ? t[0] : !0 });
let v6e = 0;
const gg = /* @__PURE__ */ lt.define();
let kr = class nN {
  constructor(e, n, r, o, i) {
    this.id = e, this.create = n, this.domEventHandlers = r, this.domEventObservers = o, this.extension = i(this);
  }
  /**
  Define a plugin from a constructor function that creates the
  plugin's value, given an editor view.
  */
  static define(e, n) {
    const { eventHandlers: r, eventObservers: o, provide: i, decorations: s } = n || {};
    return new nN(v6e++, e, r, o, (a) => {
      let l = [gg.of(a)];
      return s && l.push(Y0.of((c) => {
        let u = c.plugin(a);
        return u ? s(u) : ut.none;
      })), i && l.push(i(a)), l;
    });
  }
  /**
  Create a plugin for a class whose constructor takes a single
  editor view as argument.
  */
  static fromClass(e, n) {
    return nN.define((r) => new e(r), n);
  }
};
class ZC {
  constructor(e) {
    this.spec = e, this.mustUpdate = null, this.value = null;
  }
  update(e) {
    if (this.value) {
      if (this.mustUpdate) {
        let n = this.mustUpdate;
        if (this.mustUpdate = null, this.value.update)
          try {
            this.value.update(n);
          } catch (r) {
            if (Wo(n.state, r, "CodeMirror plugin crashed"), this.value.destroy)
              try {
                this.value.destroy();
              } catch {
              }
            this.deactivate();
          }
      }
    } else if (this.spec)
      try {
        this.value = this.spec.create(e);
      } catch (n) {
        Wo(e.state, n, "CodeMirror plugin crashed"), this.deactivate();
      }
    return this;
  }
  destroy(e) {
    var n;
    if (!((n = this.value) === null || n === void 0) && n.destroy)
      try {
        this.value.destroy();
      } catch (r) {
        Wo(e.state, r, "CodeMirror plugin crashed");
      }
  }
  deactivate() {
    this.spec = this.value = null;
  }
}
const cde = /* @__PURE__ */ lt.define(), rL = /* @__PURE__ */ lt.define(), Y0 = /* @__PURE__ */ lt.define(), ude = /* @__PURE__ */ lt.define(), oL = /* @__PURE__ */ lt.define(), dde = /* @__PURE__ */ lt.define();
function hB(t, e) {
  let n = t.state.facet(dde);
  if (!n.length)
    return n;
  let r = n.map((i) => i instanceof Function ? i(t) : i), o = [];
  return or.spans(r, e.from, e.to, {
    point() {
    },
    span(i, s, a, l) {
      let c = i - e.from, u = s - e.from, d = o;
      for (let f = a.length - 1; f >= 0; f--, l--) {
        let h = a[f].spec.bidiIsolate, p;
        if (h == null && (h = y6e(e.text, c, u)), l > 0 && d.length && (p = d[d.length - 1]).to == c && p.direction == h)
          p.to = u, d = p.inner;
        else {
          let m = { from: c, to: u, direction: h, inner: [] };
          d.push(m), d = m.inner;
        }
      }
    }
  }), o;
}
const fde = /* @__PURE__ */ lt.define();
function iL(t) {
  let e = 0, n = 0, r = 0, o = 0;
  for (let i of t.state.facet(fde)) {
    let s = i(t);
    s && (s.left != null && (e = Math.max(e, s.left)), s.right != null && (n = Math.max(n, s.right)), s.top != null && (r = Math.max(r, s.top)), s.bottom != null && (o = Math.max(o, s.bottom)));
  }
  return { left: e, right: n, top: r, bottom: o };
}
const yg = /* @__PURE__ */ lt.define();
let Hc = class fw {
  constructor(e, n, r, o) {
    this.fromA = e, this.toA = n, this.fromB = r, this.toB = o;
  }
  join(e) {
    return new fw(Math.min(this.fromA, e.fromA), Math.max(this.toA, e.toA), Math.min(this.fromB, e.fromB), Math.max(this.toB, e.toB));
  }
  addToSet(e) {
    let n = e.length, r = this;
    for (; n > 0; n--) {
      let o = e[n - 1];
      if (!(o.fromA > r.toA)) {
        if (o.toA < r.fromA)
          break;
        r = r.join(o), e.splice(n - 1, 1);
      }
    }
    return e.splice(n, 0, r), e;
  }
  static extendWithRanges(e, n) {
    if (n.length == 0)
      return e;
    let r = [];
    for (let o = 0, i = 0, s = 0, a = 0; ; o++) {
      let l = o == e.length ? null : e[o], c = s - a, u = l ? l.fromB : 1e9;
      for (; i < n.length && n[i] < u; ) {
        let d = n[i], f = n[i + 1], h = Math.max(a, d), p = Math.min(u, f);
        if (h <= p && new fw(h + c, p + c, h, p).addToSet(r), f > u)
          break;
        i += 2;
      }
      if (!l)
        return r;
      new fw(l.fromA, l.toA, l.fromB, l.toB).addToSet(r), s = l.toA, a = l.toB;
    }
  }
};
class xx {
  constructor(e, n, r) {
    this.view = e, this.state = n, this.transactions = r, this.flags = 0, this.startState = e.state, this.changes = Ps.empty(this.startState.doc.length);
    for (let i of r)
      this.changes = this.changes.compose(i.changes);
    let o = [];
    this.changes.iterChangedRanges((i, s, a, l) => o.push(new Hc(i, s, a, l))), this.changedRanges = o;
  }
  /**
  @internal
  */
  static create(e, n, r) {
    return new xx(e, n, r);
  }
  /**
  Tells you whether the [viewport](https://codemirror.net/6/docs/ref/#view.EditorView.viewport) or
  [visible ranges](https://codemirror.net/6/docs/ref/#view.EditorView.visibleRanges) changed in this
  update.
  */
  get viewportChanged() {
    return (this.flags & 4) > 0;
  }
  /**
  Returns true when
  [`viewportChanged`](https://codemirror.net/6/docs/ref/#view.ViewUpdate.viewportChanged) is true
  and the viewport change is not just the result of mapping it in
  response to document changes.
  */
  get viewportMoved() {
    return (this.flags & 8) > 0;
  }
  /**
  Indicates whether the height of a block element in the editor
  changed in this update.
  */
  get heightChanged() {
    return (this.flags & 2) > 0;
  }
  /**
  Returns true when the document was modified or the size of the
  editor, or elements within the editor, changed.
  */
  get geometryChanged() {
    return this.docChanged || (this.flags & 18) > 0;
  }
  /**
  True when this update indicates a focus change.
  */
  get focusChanged() {
    return (this.flags & 1) > 0;
  }
  /**
  Whether the document changed in this update.
  */
  get docChanged() {
    return !this.changes.empty;
  }
  /**
  Whether the selection was explicitly set in this update.
  */
  get selectionSet() {
    return this.transactions.some((e) => e.selection);
  }
  /**
  @internal
  */
  get empty() {
    return this.flags == 0 && this.transactions.length == 0;
  }
}
class pB extends tr {
  get length() {
    return this.view.state.doc.length;
  }
  constructor(e) {
    super(), this.view = e, this.decorations = [], this.dynamicDecorationMap = [!1], this.domChanged = null, this.hasComposition = null, this.markedForComposition = /* @__PURE__ */ new Set(), this.editContextFormatting = ut.none, this.lastCompositionAfterCursor = !1, this.minWidth = 0, this.minWidthFrom = 0, this.minWidthTo = 0, this.impreciseAnchor = null, this.impreciseHead = null, this.forceSelection = !1, this.lastUpdate = Date.now(), this.setDOM(e.contentDOM), this.children = [new So()], this.children[0].setParent(this), this.updateDeco(), this.updateInner([new Hc(0, 0, 0, e.state.doc.length)], 0, null);
  }
  // Update the document view to a given state.
  update(e) {
    var n;
    let r = e.changedRanges;
    this.minWidth > 0 && r.length && (r.every(({ fromA: c, toA: u }) => u < this.minWidthFrom || c > this.minWidthTo) ? (this.minWidthFrom = e.changes.mapPos(this.minWidthFrom, 1), this.minWidthTo = e.changes.mapPos(this.minWidthTo, 1)) : this.minWidth = this.minWidthFrom = this.minWidthTo = 0), this.updateEditContextFormatting(e);
    let o = -1;
    this.view.inputState.composing >= 0 && !this.view.observer.editContext && (!((n = this.domChanged) === null || n === void 0) && n.newSel ? o = this.domChanged.newSel.head : !O6e(e.changes, this.hasComposition) && !e.selectionSet && (o = e.state.selection.main.head));
    let i = o > -1 ? _6e(this.view, e.changes, o) : null;
    if (this.domChanged = null, this.hasComposition) {
      this.markedForComposition.clear();
      let { from: c, to: u } = this.hasComposition;
      r = new Hc(c, u, e.changes.mapPos(c, -1), e.changes.mapPos(u, 1)).addToSet(r.slice());
    }
    this.hasComposition = i ? { from: i.range.fromB, to: i.range.toB } : null, (rt.ie || rt.chrome) && !i && e && e.state.doc.lines != e.startState.doc.lines && (this.forceSelection = !0);
    let s = this.decorations, a = this.updateDeco(), l = E6e(s, a, e.changes);
    return r = Hc.extendWithRanges(r, l), !(this.flags & 7) && r.length == 0 ? !1 : (this.updateInner(r, e.startState.doc.length, i), e.transactions.length && (this.lastUpdate = Date.now()), !0);
  }
  // Used by update and the constructor do perform the actual DOM
  // update
  updateInner(e, n, r) {
    this.view.viewState.mustMeasureContent = !0, this.updateChildren(e, n, r);
    let { observer: o } = this.view;
    o.ignore(() => {
      this.dom.style.height = this.view.viewState.contentHeight / this.view.scaleY + "px", this.dom.style.flexBasis = this.minWidth ? this.minWidth + "px" : "";
      let s = rt.chrome || rt.ios ? { node: o.selectionRange.focusNode, written: !1 } : void 0;
      this.sync(this.view, s), this.flags &= -8, s && (s.written || o.selectionRange.focusNode != s.node) && (this.forceSelection = !0), this.dom.style.height = "";
    }), this.markedForComposition.forEach(
      (s) => s.flags &= -9
      /* ViewFlag.Composition */
    );
    let i = [];
    if (this.view.viewport.from || this.view.viewport.to < this.view.state.doc.length)
      for (let s of this.children)
        s instanceof t0 && s.widget instanceof QI && i.push(s.dom);
    o.updateGaps(i);
  }
  updateChildren(e, n, r) {
    let o = r ? r.range.addToSet(e.slice()) : e, i = this.childCursor(n);
    for (let s = o.length - 1; ; s--) {
      let a = s >= 0 ? o[s] : null;
      if (!a)
        break;
      let { fromA: l, toA: c, fromB: u, toB: d } = a, f, h, p, m;
      if (r && r.range.fromB < d && r.range.toB > u) {
        let _ = n0.build(this.view.state.doc, u, r.range.fromB, this.decorations, this.dynamicDecorationMap), w = n0.build(this.view.state.doc, r.range.toB, d, this.decorations, this.dynamicDecorationMap);
        h = _.breakAtStart, p = _.openStart, m = w.openEnd;
        let x = this.compositionView(r);
        w.breakAtStart ? x.breakAfter = 1 : w.content.length && x.merge(x.length, x.length, w.content[0], !1, w.openStart, 0) && (x.breakAfter = w.content[0].breakAfter, w.content.shift()), _.content.length && x.merge(0, 0, _.content[_.content.length - 1], !0, 0, _.openEnd) && _.content.pop(), f = _.content.concat(x).concat(w.content);
      } else
        ({ content: f, breakAtStart: h, openStart: p, openEnd: m } = n0.build(this.view.state.doc, u, d, this.decorations, this.dynamicDecorationMap));
      let { i: g, off: y } = i.findPos(c, 1), { i: v, off: b } = i.findPos(l, -1);
      Lue(this, v, b, g, y, f, h, p, m);
    }
    r && this.fixCompositionDOM(r);
  }
  updateEditContextFormatting(e) {
    this.editContextFormatting = this.editContextFormatting.map(e.changes);
    for (let n of e.transactions)
      for (let r of n.effects)
        r.is(lde) && (this.editContextFormatting = r.value);
  }
  compositionView(e) {
    let n = new Jc(e.text.nodeValue);
    n.flags |= 8;
    for (let { deco: o } of e.marks)
      n = new Wh(o, [n], n.length);
    let r = new So();
    return r.append(n, 0), r;
  }
  fixCompositionDOM(e) {
    let n = (i, s) => {
      s.flags |= 8 | (s.children.some(
        (l) => l.flags & 7
        /* ViewFlag.Dirty */
      ) ? 1 : 0), this.markedForComposition.add(s);
      let a = tr.get(i);
      a && a != s && (a.dom = null), s.setDOM(i);
    }, r = this.childPos(e.range.fromB, 1), o = this.children[r.i];
    n(e.line, o);
    for (let i = e.marks.length - 1; i >= -1; i--)
      r = o.childPos(r.off, 1), o = o.children[r.i], n(i >= 0 ? e.marks[i].node : e.text, o);
  }
  // Sync the DOM selection to this.state.selection
  updateSelection(e = !1, n = !1) {
    (e || !this.view.observer.selectionRange.focusNode) && this.view.observer.readSelectionRange();
    let r = this.view.root.activeElement, o = r == this.dom, i = !o && !(this.view.state.facet(pl) || this.dom.tabIndex > -1) && cw(this.dom, this.view.observer.selectionRange) && !(r && this.dom.contains(r));
    if (!(o || n || i))
      return;
    let s = this.forceSelection;
    this.forceSelection = !1;
    let a = this.view.state.selection.main, l = this.moveToLine(this.domAtPos(a.anchor)), c = a.empty ? l : this.moveToLine(this.domAtPos(a.head));
    if (rt.gecko && a.empty && !this.hasComposition && b6e(l)) {
      let d = document.createTextNode("");
      this.view.observer.ignore(() => l.node.insertBefore(d, l.node.childNodes[l.offset] || null)), l = c = new gi(d, 0), s = !0;
    }
    let u = this.view.observer.selectionRange;
    (s || !u.focusNode || (!e0(l.node, l.offset, u.anchorNode, u.anchorOffset) || !e0(c.node, c.offset, u.focusNode, u.focusOffset)) && !this.suppressWidgetCursorChange(u, a)) && (this.view.observer.ignore(() => {
      rt.android && rt.chrome && this.dom.contains(u.focusNode) && S6e(u.focusNode, this.dom) && (this.dom.blur(), this.dom.focus({ preventScroll: !0 }));
      let d = G0(this.view.root);
      if (d) if (a.empty) {
        if (rt.gecko) {
          let f = w6e(l.node, l.offset);
          if (f && f != 3) {
            let h = (f == 1 ? Iue : Nue)(l.node, l.offset);
            h && (l = new gi(h.node, h.offset));
          }
        }
        d.collapse(l.node, l.offset), a.bidiLevel != null && d.caretBidiLevel !== void 0 && (d.caretBidiLevel = a.bidiLevel);
      } else if (d.extend) {
        d.collapse(l.node, l.offset);
        try {
          d.extend(c.node, c.offset);
        } catch {
        }
      } else {
        let f = document.createRange();
        a.anchor > a.head && ([l, c] = [c, l]), f.setEnd(c.node, c.offset), f.setStart(l.node, l.offset), d.removeAllRanges(), d.addRange(f);
      }
      i && this.view.root.activeElement == this.dom && (this.dom.blur(), r && r.focus());
    }), this.view.observer.setSelectionRange(l, c)), this.impreciseAnchor = l.precise ? null : new gi(u.anchorNode, u.anchorOffset), this.impreciseHead = c.precise ? null : new gi(u.focusNode, u.focusOffset);
  }
  // If a zero-length widget is inserted next to the cursor during
  // composition, avoid moving it across it and disrupting the
  // composition.
  suppressWidgetCursorChange(e, n) {
    return this.hasComposition && n.empty && e0(e.focusNode, e.focusOffset, e.anchorNode, e.anchorOffset) && this.posFromDOM(e.focusNode, e.focusOffset) == n.head;
  }
  enforceCursorAssoc() {
    if (this.hasComposition)
      return;
    let { view: e } = this, n = e.state.selection.main, r = G0(e.root), { anchorNode: o, anchorOffset: i } = e.observer.selectionRange;
    if (!r || !n.empty || !n.assoc || !r.modify)
      return;
    let s = So.find(this, n.head);
    if (!s)
      return;
    let a = s.posAtStart;
    if (n.head == a || n.head == a + s.length)
      return;
    let l = this.coordsAt(n.head, -1), c = this.coordsAt(n.head, 1);
    if (!l || !c || l.bottom > c.top)
      return;
    let u = this.domAtPos(n.head + n.assoc);
    r.collapse(u.node, u.offset), r.modify("move", n.assoc < 0 ? "forward" : "backward", "lineboundary"), e.observer.readSelectionRange();
    let d = e.observer.selectionRange;
    e.docView.posFromDOM(d.anchorNode, d.anchorOffset) != n.from && r.collapse(o, i);
  }
  // If a position is in/near a block widget, move it to a nearby text
  // line, since we don't want the cursor inside a block widget.
  moveToLine(e) {
    let n = this.dom, r;
    if (e.node != n)
      return e;
    for (let o = e.offset; !r && o < n.childNodes.length; o++) {
      let i = tr.get(n.childNodes[o]);
      i instanceof So && (r = i.domAtPos(0));
    }
    for (let o = e.offset - 1; !r && o >= 0; o--) {
      let i = tr.get(n.childNodes[o]);
      i instanceof So && (r = i.domAtPos(i.length));
    }
    return r ? new gi(r.node, r.offset, !0) : e;
  }
  nearest(e) {
    for (let n = e; n; ) {
      let r = tr.get(n);
      if (r && r.rootView == this)
        return r;
      n = n.parentNode;
    }
    return null;
  }
  posFromDOM(e, n) {
    let r = this.nearest(e);
    if (!r)
      throw new RangeError("Trying to find position for a DOM position outside of the document");
    return r.localPosFromDOM(e, n) + r.posAtStart;
  }
  domAtPos(e) {
    let { i: n, off: r } = this.childCursor().findPos(e, -1);
    for (; n < this.children.length - 1; ) {
      let o = this.children[n];
      if (r < o.length || o instanceof So)
        break;
      n++, r = 0;
    }
    return this.children[n].domAtPos(r);
  }
  coordsAt(e, n) {
    let r = null, o = 0;
    for (let i = this.length, s = this.children.length - 1; s >= 0; s--) {
      let a = this.children[s], l = i - a.breakAfter, c = l - a.length;
      if (l < e)
        break;
      if (c <= e && (c < e || a.covers(-1)) && (l > e || a.covers(1)) && (!r || a instanceof So && !(r instanceof So && n >= 0)))
        r = a, o = c;
      else if (r && c == e && l == e && a instanceof t0 && Math.abs(n) < 2) {
        if (a.deco.startSide < 0)
          break;
        s && (r = null);
      }
      i = c;
    }
    return r ? r.coordsAt(e - o, n) : null;
  }
  coordsForChar(e) {
    let { i: n, off: r } = this.childPos(e, 1), o = this.children[n];
    if (!(o instanceof So))
      return null;
    for (; o.children.length; ) {
      let { i: a, off: l } = o.childPos(r, 1);
      for (; ; a++) {
        if (a == o.children.length)
          return null;
        if ((o = o.children[a]).length)
          break;
      }
      r = l;
    }
    if (!(o instanceof Jc))
      return null;
    let i = Zr(o.text, r);
    if (i == r)
      return null;
    let s = Dd(o.dom, r, i).getClientRects();
    for (let a = 0; a < s.length; a++) {
      let l = s[a];
      if (a == s.length - 1 || l.top < l.bottom && l.left < l.right)
        return l;
    }
    return null;
  }
  measureVisibleLineHeights(e) {
    let n = [], { from: r, to: o } = e, i = this.view.contentDOM.clientWidth, s = i > Math.max(this.view.scrollDOM.clientWidth, this.minWidth) + 1, a = -1, l = this.view.textDirection == Kn.LTR;
    for (let c = 0, u = 0; u < this.children.length; u++) {
      let d = this.children[u], f = c + d.length;
      if (f > o)
        break;
      if (c >= r) {
        let h = d.dom.getBoundingClientRect();
        if (n.push(h.height), s) {
          let p = d.dom.lastChild, m = p ? Vh(p) : [];
          if (m.length) {
            let g = m[m.length - 1], y = l ? g.right - h.left : h.right - g.left;
            y > a && (a = y, this.minWidth = i, this.minWidthFrom = c, this.minWidthTo = f);
          }
        }
      }
      c = f + d.breakAfter;
    }
    return n;
  }
  textDirectionAt(e) {
    let { i: n } = this.childPos(e, 1);
    return getComputedStyle(this.children[n].dom).direction == "rtl" ? Kn.RTL : Kn.LTR;
  }
  measureTextSize() {
    for (let i of this.children)
      if (i instanceof So) {
        let s = i.measureTextSize();
        if (s)
          return s;
      }
    let e = document.createElement("div"), n, r, o;
    return e.className = "cm-line", e.style.width = "99999px", e.style.position = "absolute", e.textContent = "abc def ghi jkl mno pqr stu", this.view.observer.ignore(() => {
      this.dom.appendChild(e);
      let i = Vh(e.firstChild)[0];
      n = e.getBoundingClientRect().height, r = i ? i.width / 27 : 7, o = i ? i.height : n, e.remove();
    }), { lineHeight: n, charWidth: r, textHeight: o };
  }
  childCursor(e = this.length) {
    let n = this.children.length;
    return n && (e -= this.children[--n].length), new jue(this.children, e, n);
  }
  computeBlockGapDeco() {
    let e = [], n = this.view.viewState;
    for (let r = 0, o = 0; ; o++) {
      let i = o == n.viewports.length ? null : n.viewports[o], s = i ? i.from - 1 : this.length;
      if (s > r) {
        let a = (n.lineBlockAt(s).bottom - n.lineBlockAt(r).top) / this.view.scaleY;
        e.push(ut.replace({
          widget: new QI(a),
          block: !0,
          inclusive: !0,
          isBlockGap: !0
        }).range(r, s));
      }
      if (!i)
        break;
      r = i.to + 1;
    }
    return ut.set(e);
  }
  updateDeco() {
    let e = 1, n = this.view.state.facet(Y0).map((i) => (this.dynamicDecorationMap[e++] = typeof i == "function") ? i(this.view) : i), r = !1, o = this.view.state.facet(ude).map((i, s) => {
      let a = typeof i == "function";
      return a && (r = !0), a ? i(this.view) : i;
    });
    for (o.length && (this.dynamicDecorationMap[e++] = r, n.push(or.join(o))), this.decorations = [
      this.editContextFormatting,
      ...n,
      this.computeBlockGapDeco(),
      this.view.viewState.lineGapDeco
    ]; e < this.decorations.length; )
      this.dynamicDecorationMap[e++] = !1;
    return this.decorations;
  }
  scrollIntoView(e) {
    if (e.isSnapshot) {
      let c = this.view.viewState.lineBlockAt(e.range.head);
      this.view.scrollDOM.scrollTop = c.top - e.yMargin, this.view.scrollDOM.scrollLeft = e.xMargin;
      return;
    }
    for (let c of this.view.state.facet(ade))
      try {
        if (c(this.view, e.range, e))
          return !0;
      } catch (u) {
        Wo(this.view.state, u, "scroll handler");
      }
    let { range: n } = e, r = this.coordsAt(n.head, n.empty ? n.assoc : n.head > n.anchor ? -1 : 1), o;
    if (!r)
      return;
    !n.empty && (o = this.coordsAt(n.anchor, n.anchor > n.head ? -1 : 1)) && (r = {
      left: Math.min(r.left, o.left),
      top: Math.min(r.top, o.top),
      right: Math.max(r.right, o.right),
      bottom: Math.max(r.bottom, o.bottom)
    });
    let i = iL(this.view), s = {
      left: r.left - i.left,
      top: r.top - i.top,
      right: r.right + i.right,
      bottom: r.bottom + i.bottom
    }, { offsetWidth: a, offsetHeight: l } = this.view.scrollDOM;
    J4e(this.view.scrollDOM, s, n.head < n.anchor ? -1 : 1, e.x, e.y, Math.max(Math.min(e.xMargin, a), -a), Math.max(Math.min(e.yMargin, l), -l), this.view.textDirection == Kn.LTR);
  }
}
function b6e(t) {
  return t.node.nodeType == 1 && t.node.firstChild && (t.offset == 0 || t.node.childNodes[t.offset - 1].contentEditable == "false") && (t.offset == t.node.childNodes.length || t.node.childNodes[t.offset].contentEditable == "false");
}
function hde(t, e) {
  let n = t.observer.selectionRange;
  if (!n.focusNode)
    return null;
  let r = Iue(n.focusNode, n.focusOffset), o = Nue(n.focusNode, n.focusOffset), i = r || o;
  if (o && r && o.node != r.node) {
    let a = tr.get(o.node);
    if (!a || a instanceof Jc && a.text != o.node.nodeValue)
      i = o;
    else if (t.docView.lastCompositionAfterCursor) {
      let l = tr.get(r.node);
      !l || l instanceof Jc && l.text != r.node.nodeValue || (i = o);
    }
  }
  if (t.docView.lastCompositionAfterCursor = i != r, !i)
    return null;
  let s = e - i.offset;
  return { from: s, to: s + i.node.nodeValue.length, node: i.node };
}
function _6e(t, e, n) {
  let r = hde(t, n);
  if (!r)
    return null;
  let { node: o, from: i, to: s } = r, a = o.nodeValue;
  if (/[\n\r]/.test(a) || t.state.doc.sliceString(r.from, r.to) != a)
    return null;
  let l = e.invertedDesc, c = new Hc(l.mapPos(i), l.mapPos(s), i, s), u = [];
  for (let d = o.parentNode; ; d = d.parentNode) {
    let f = tr.get(d);
    if (f instanceof Wh)
      u.push({ node: d, deco: f.mark });
    else {
      if (f instanceof So || d.nodeName == "DIV" && d.parentNode == t.contentDOM)
        return { range: c, text: o, marks: u, line: d };
      if (d != t.contentDOM)
        u.push({ node: d, deco: new pv({
          inclusive: !0,
          attributes: a6e(d),
          tagName: d.tagName.toLowerCase()
        }) });
      else
        return null;
    }
  }
}
function w6e(t, e) {
  return t.nodeType != 1 ? 0 : (e && t.childNodes[e - 1].contentEditable == "false" ? 1 : 0) | (e < t.childNodes.length && t.childNodes[e].contentEditable == "false" ? 2 : 0);
}
let x6e = class {
  constructor() {
    this.changes = [];
  }
  compareRange(t, e) {
    uw(t, e, this.changes);
  }
  comparePoint(t, e) {
    uw(t, e, this.changes);
  }
  boundChange(t) {
    uw(t, t, this.changes);
  }
};
function E6e(t, e, n) {
  let r = new x6e();
  return or.compare(t, e, n, r), r.changes;
}
function S6e(t, e) {
  for (let n = t; n && n != e; n = n.assignedSlot || n.parentNode)
    if (n.nodeType == 1 && n.contentEditable == "false")
      return !0;
  return !1;
}
function O6e(t, e) {
  let n = !1;
  return e && t.iterChangedRanges((r, o) => {
    r < e.to && o > e.from && (n = !0);
  }), n;
}
function C6e(t, e, n = 1) {
  let r = t.charCategorizer(e), o = t.doc.lineAt(e), i = e - o.from;
  if (o.length == 0)
    return $e.cursor(e);
  i == 0 ? n = 1 : i == o.length && (n = -1);
  let s = i, a = i;
  n < 0 ? s = Zr(o.text, i, !1) : a = Zr(o.text, i);
  let l = r(o.text.slice(s, a));
  for (; s > 0; ) {
    let c = Zr(o.text, s, !1);
    if (r(o.text.slice(c, s)) != l)
      break;
    s = c;
  }
  for (; a < o.length; ) {
    let c = Zr(o.text, a);
    if (r(o.text.slice(a, c)) != l)
      break;
    a = c;
  }
  return $e.range(s + o.from, a + o.from);
}
function k6e(t, e) {
  return e.left > t ? e.left - t : Math.max(0, t - e.right);
}
function A6e(t, e) {
  return e.top > t ? e.top - t : Math.max(0, t - e.bottom);
}
function JC(t, e) {
  return t.top < e.bottom - 1 && t.bottom > e.top + 1;
}
function mB(t, e) {
  return e < t.top ? { top: e, left: t.left, right: t.right, bottom: t.bottom } : t;
}
function gB(t, e) {
  return e > t.bottom ? { top: t.top, left: t.left, right: t.right, bottom: e } : t;
}
function rN(t, e, n) {
  let r, o, i, s, a = !1, l, c, u, d;
  for (let p = t.firstChild; p; p = p.nextSibling) {
    let m = Vh(p);
    for (let g = 0; g < m.length; g++) {
      let y = m[g];
      o && JC(o, y) && (y = mB(gB(y, o.bottom), o.top));
      let v = k6e(e, y), b = A6e(n, y);
      if (v == 0 && b == 0)
        return p.nodeType == 3 ? yB(p, e, n) : rN(p, e, n);
      if (!r || s > b || s == b && i > v) {
        r = p, o = y, i = v, s = b;
        let _ = b ? n < y.top ? -1 : 1 : v ? e < y.left ? -1 : 1 : 0;
        a = !_ || (_ > 0 ? g < m.length - 1 : g > 0);
      }
      v == 0 ? n > y.bottom && (!u || u.bottom < y.bottom) ? (l = p, u = y) : n < y.top && (!d || d.top > y.top) && (c = p, d = y) : u && JC(u, y) ? u = gB(u, y.bottom) : d && JC(d, y) && (d = mB(d, y.top));
    }
  }
  if (u && u.bottom >= n ? (r = l, o = u) : d && d.top <= n && (r = c, o = d), !r)
    return { node: t, offset: 0 };
  let f = Math.max(o.left, Math.min(o.right, e));
  if (r.nodeType == 3)
    return yB(r, f, n);
  if (a && r.contentEditable != "false")
    return rN(r, f, n);
  let h = Array.prototype.indexOf.call(t.childNodes, r) + (e >= (o.left + o.right) / 2 ? 1 : 0);
  return { node: t, offset: h };
}
function yB(t, e, n) {
  let r = t.nodeValue.length, o = -1, i = 1e9, s = 0;
  for (let a = 0; a < r; a++) {
    let l = Dd(t, a, a + 1).getClientRects();
    for (let c = 0; c < l.length; c++) {
      let u = l[c];
      if (u.top == u.bottom)
        continue;
      s || (s = e - u.left);
      let d = (u.top > n ? u.top - n : n - u.bottom) - 1;
      if (u.left - 1 <= e && u.right + 1 >= e && d < i) {
        let f = e >= (u.left + u.right) / 2, h = f;
        if ((rt.chrome || rt.gecko) && Dd(t, a).getBoundingClientRect().left == u.right && (h = !f), d <= 0)
          return { node: t, offset: a + (h ? 1 : 0) };
        o = a + (h ? 1 : 0), i = d;
      }
    }
  }
  return { node: t, offset: o > -1 ? o : s > 0 ? t.nodeValue.length : 0 };
}
function pde(t, e, n, r = -1) {
  var o, i;
  let s = t.contentDOM.getBoundingClientRect(), a = s.top + t.viewState.paddingTop, l, { docHeight: c } = t.viewState, { x: u, y: d } = e, f = d - a;
  if (f < 0)
    return 0;
  if (f > c)
    return t.state.doc.length;
  for (let _ = t.viewState.heightOracle.textHeight / 2, w = !1; l = t.elementAtHeight(f), l.type != Ao.Text; )
    for (; f = r > 0 ? l.bottom + _ : l.top - _, !(f >= 0 && f <= c); ) {
      if (w)
        return n ? null : 0;
      w = !0, r = -r;
    }
  d = a + f;
  let h = l.from;
  if (h < t.viewport.from)
    return t.viewport.from == 0 ? 0 : n ? null : vB(t, s, l, u, d);
  if (h > t.viewport.to)
    return t.viewport.to == t.state.doc.length ? t.state.doc.length : n ? null : vB(t, s, l, u, d);
  let p = t.dom.ownerDocument, m = t.root.elementFromPoint ? t.root : p, g = m.elementFromPoint(u, d);
  g && !t.contentDOM.contains(g) && (g = null), g || (u = Math.max(s.left + 1, Math.min(s.right - 1, u)), g = m.elementFromPoint(u, d), g && !t.contentDOM.contains(g) && (g = null));
  let y, v = -1;
  if (g && ((o = t.docView.nearest(g)) === null || o === void 0 ? void 0 : o.isEditable) != !1) {
    if (p.caretPositionFromPoint) {
      let _ = p.caretPositionFromPoint(u, d);
      _ && ({ offsetNode: y, offset: v } = _);
    } else if (p.caretRangeFromPoint) {
      let _ = p.caretRangeFromPoint(u, d);
      _ && ({ startContainer: y, startOffset: v } = _, (!t.contentDOM.contains(y) || rt.safari && T6e(y, v, u) || rt.chrome && R6e(y, v, u)) && (y = void 0));
    }
    y && (v = Math.min(Oa(y), v));
  }
  if (!y || !t.docView.dom.contains(y)) {
    let _ = So.find(t.docView, h);
    if (!_)
      return f > l.top + l.height / 2 ? l.to : l.from;
    ({ node: y, offset: v } = rN(_.dom, u, d));
  }
  let b = t.docView.nearest(y);
  if (!b)
    return null;
  if (b.isWidget && ((i = b.dom) === null || i === void 0 ? void 0 : i.nodeType) == 1) {
    let _ = b.dom.getBoundingClientRect();
    return e.y < _.top || e.y <= _.bottom && e.x <= (_.left + _.right) / 2 ? b.posAtStart : b.posAtEnd;
  } else
    return b.localPosFromDOM(y, v) + b.posAtStart;
}
function vB(t, e, n, r, o) {
  let i = Math.round((r - e.left) * t.defaultCharacterWidth);
  if (t.lineWrapping && n.height > t.defaultLineHeight * 1.5) {
    let a = t.viewState.heightOracle.textHeight, l = Math.floor((o - n.top - (t.defaultLineHeight - a) * 0.5) / a);
    i += l * t.viewState.heightOracle.lineLength;
  }
  let s = t.state.sliceDoc(n.from, n.to);
  return n.from + LI(s, i, t.state.tabSize);
}
function T6e(t, e, n) {
  let r;
  if (t.nodeType != 3 || e != (r = t.nodeValue.length))
    return !1;
  for (let o = t.nextSibling; o; o = o.nextSibling)
    if (o.nodeType != 1 || o.nodeName != "BR")
      return !1;
  return Dd(t, r - 1, r).getBoundingClientRect().left > n;
}
function R6e(t, e, n) {
  if (e != 0)
    return !1;
  for (let o = t; ; ) {
    let i = o.parentNode;
    if (!i || i.nodeType != 1 || i.firstChild != o)
      return !1;
    if (i.classList.contains("cm-line"))
      break;
    o = i;
  }
  let r = t.nodeType == 1 ? t.getBoundingClientRect() : Dd(t, 0, Math.max(t.nodeValue.length, 1)).getBoundingClientRect();
  return n - r.left > 5;
}
function oN(t, e) {
  let n = t.lineBlockAt(e);
  if (Array.isArray(n.type)) {
    for (let r of n.type)
      if (r.to > e || r.to == e && (r.to == n.to || r.type == Ao.Text))
        return r;
  }
  return n;
}
function P6e(t, e, n, r) {
  let o = oN(t, e.head), i = !r || o.type != Ao.Text || !(t.lineWrapping || o.widgetLineBreaks) ? null : t.coordsAtPos(e.assoc < 0 && e.head > o.from ? e.head - 1 : e.head);
  if (i) {
    let s = t.dom.getBoundingClientRect(), a = t.textDirectionAt(o.from), l = t.posAtCoords({
      x: n == (a == Kn.LTR) ? s.right - 1 : s.left + 1,
      y: (i.top + i.bottom) / 2
    });
    if (l != null)
      return $e.cursor(l, n ? -1 : 1);
  }
  return $e.cursor(n ? o.to : o.from, n ? -1 : 1);
}
function bB(t, e, n, r) {
  let o = t.state.doc.lineAt(e.head), i = t.bidiSpans(o), s = t.textDirectionAt(o.from);
  for (let a = e, l = null; ; ) {
    let c = g6e(o, i, s, a, n), u = Zue;
    if (!c) {
      if (o.number == (n ? t.state.doc.lines : 1))
        return a;
      u = `
`, o = t.state.doc.line(o.number + (n ? 1 : -1)), i = t.bidiSpans(o), c = t.visualLineSide(o, !n);
    }
    if (l) {
      if (!l(u))
        return a;
    } else {
      if (!r)
        return c;
      l = r(u);
    }
    a = c;
  }
}
function $6e(t, e, n) {
  let r = t.state.charCategorizer(e), o = r(n);
  return (i) => {
    let s = r(i);
    return o == rr.Space && (o = s), o == s;
  };
}
function M6e(t, e, n, r) {
  let o = e.head, i = n ? 1 : -1;
  if (o == (n ? t.state.doc.length : 0))
    return $e.cursor(o, e.assoc);
  let s = e.goalColumn, a, l = t.contentDOM.getBoundingClientRect(), c = t.coordsAtPos(o, e.assoc || -1), u = t.documentTop;
  if (c)
    s == null && (s = c.left - l.left), a = i < 0 ? c.top : c.bottom;
  else {
    let h = t.viewState.lineBlockAt(o);
    s == null && (s = Math.min(l.right - l.left, t.defaultCharacterWidth * (o - h.from))), a = (i < 0 ? h.top : h.bottom) + u;
  }
  let d = l.left + s, f = r ?? t.viewState.heightOracle.textHeight >> 1;
  for (let h = 0; ; h += 10) {
    let p = a + (f + h) * i, m = pde(t, { x: d, y: p }, !1, i);
    if (p < l.top || p > l.bottom || (i < 0 ? m < o : m > o)) {
      let g = t.docView.coordsForChar(m), y = !g || p < g.top ? -1 : 1;
      return $e.cursor(m, y, void 0, s);
    }
  }
}
function hw(t, e, n) {
  for (; ; ) {
    let r = 0;
    for (let o of t)
      o.between(e - 1, e + 1, (i, s, a) => {
        if (e > i && e < s) {
          let l = r || n || (e - i < s - e ? -1 : 1);
          e = l < 0 ? i : s, r = l;
        }
      });
    if (!r)
      return e;
  }
}
function ek(t, e, n) {
  let r = hw(t.state.facet(oL).map((o) => o(t)), n.from, e.head > n.from ? -1 : 1);
  return r == n.from ? n : $e.cursor(r, r < n.from ? 1 : -1);
}
const vg = "￿";
class D6e {
  constructor(e, n) {
    this.points = e, this.text = "", this.lineSeparator = n.facet(qt.lineSeparator);
  }
  append(e) {
    this.text += e;
  }
  lineBreak() {
    this.text += vg;
  }
  readRange(e, n) {
    if (!e)
      return this;
    let r = e.parentNode;
    for (let o = e; ; ) {
      this.findPointBefore(r, o);
      let i = this.text.length;
      this.readNode(o);
      let s = o.nextSibling;
      if (s == n)
        break;
      let a = tr.get(o), l = tr.get(s);
      (a && l ? a.breakAfter : (a ? a.breakAfter : _x(o)) || _x(s) && (o.nodeName != "BR" || o.cmIgnore) && this.text.length > i) && this.lineBreak(), o = s;
    }
    return this.findPointBefore(r, n), this;
  }
  readTextNode(e) {
    let n = e.nodeValue;
    for (let r of this.points)
      r.node == e && (r.pos = this.text.length + Math.min(r.offset, n.length));
    for (let r = 0, o = this.lineSeparator ? null : /\r\n?|\n/g; ; ) {
      let i = -1, s = 1, a;
      if (this.lineSeparator ? (i = n.indexOf(this.lineSeparator, r), s = this.lineSeparator.length) : (a = o.exec(n)) && (i = a.index, s = a[0].length), this.append(n.slice(r, i < 0 ? n.length : i)), i < 0)
        break;
      if (this.lineBreak(), s > 1)
        for (let l of this.points)
          l.node == e && l.pos > this.text.length && (l.pos -= s - 1);
      r = i + s;
    }
  }
  readNode(e) {
    if (e.cmIgnore)
      return;
    let n = tr.get(e), r = n && n.overrideDOMText;
    if (r != null) {
      this.findPointInside(e, r.length);
      for (let o = r.iter(); !o.next().done; )
        o.lineBreak ? this.lineBreak() : this.append(o.value);
    } else e.nodeType == 3 ? this.readTextNode(e) : e.nodeName == "BR" ? e.nextSibling && this.lineBreak() : e.nodeType == 1 && this.readRange(e.firstChild, null);
  }
  findPointBefore(e, n) {
    for (let r of this.points)
      r.node == e && e.childNodes[r.offset] == n && (r.pos = this.text.length);
  }
  findPointInside(e, n) {
    for (let r of this.points)
      (e.nodeType == 3 ? r.node == e : e.contains(r.node)) && (r.pos = this.text.length + (I6e(e, r.node, r.offset) ? n : 0));
  }
}
function I6e(t, e, n) {
  for (; ; ) {
    if (!e || n < Oa(e))
      return !1;
    if (e == t)
      return !0;
    n = Md(e) + 1, e = e.parentNode;
  }
}
class _B {
  constructor(e, n) {
    this.node = e, this.offset = n, this.pos = -1;
  }
}
class N6e {
  constructor(e, n, r, o) {
    this.typeOver = o, this.bounds = null, this.text = "", this.domChanged = n > -1;
    let { impreciseHead: i, impreciseAnchor: s } = e.docView;
    if (e.state.readOnly && n > -1)
      this.newSel = null;
    else if (n > -1 && (this.bounds = e.docView.domBoundsAround(n, r, 0))) {
      let a = i || s ? [] : F6e(e), l = new D6e(a, e.state);
      l.readRange(this.bounds.startDOM, this.bounds.endDOM), this.text = l.text, this.newSel = B6e(a, this.bounds.from);
    } else {
      let a = e.observer.selectionRange, l = i && i.node == a.focusNode && i.offset == a.focusOffset || !zI(e.contentDOM, a.focusNode) ? e.state.selection.main.head : e.docView.posFromDOM(a.focusNode, a.focusOffset), c = s && s.node == a.anchorNode && s.offset == a.anchorOffset || !zI(e.contentDOM, a.anchorNode) ? e.state.selection.main.anchor : e.docView.posFromDOM(a.anchorNode, a.anchorOffset), u = e.viewport;
      if ((rt.ios || rt.chrome) && e.state.selection.main.empty && l != c && (u.from > 0 || u.to < e.state.doc.length)) {
        let d = Math.min(l, c), f = Math.max(l, c), h = u.from - d, p = u.to - f;
        (h == 0 || h == 1 || d == 0) && (p == 0 || p == -1 || f == e.state.doc.length) && (l = 0, c = e.state.doc.length);
      }
      this.newSel = $e.single(c, l);
    }
  }
}
function mde(t, e) {
  let n, { newSel: r } = e, o = t.state.selection.main, i = t.inputState.lastKeyTime > Date.now() - 100 ? t.inputState.lastKeyCode : -1;
  if (e.bounds) {
    let { from: s, to: a } = e.bounds, l = o.from, c = null;
    (i === 8 || rt.android && e.text.length < a - s) && (l = o.to, c = "end");
    let u = L6e(t.state.doc.sliceString(s, a, vg), e.text, l - s, c);
    u && (rt.chrome && i == 13 && u.toB == u.from + 2 && e.text.slice(u.from, u.toB) == vg + vg && u.toB--, n = {
      from: s + u.from,
      to: s + u.toA,
      insert: ln.of(e.text.slice(u.from, u.toB).split(vg))
    });
  } else r && (!t.hasFocus && t.state.facet(pl) || r.main.eq(o)) && (r = null);
  if (!n && !r)
    return !1;
  if (!n && e.typeOver && !o.empty && r && r.main.empty ? n = { from: o.from, to: o.to, insert: t.state.doc.slice(o.from, o.to) } : (rt.mac || rt.android) && n && n.from == n.to && n.from == o.head - 1 && /^\. ?$/.test(n.insert.toString()) && t.contentDOM.getAttribute("autocorrect") == "off" ? (r && n.insert.length == 2 && (r = $e.single(r.main.anchor - 1, r.main.head - 1)), n = { from: n.from, to: n.to, insert: ln.of([n.insert.toString().replace(".", " ")]) }) : n && n.from >= o.from && n.to <= o.to && (n.from != o.from || n.to != o.to) && o.to - o.from - (n.to - n.from) <= 4 ? n = {
    from: o.from,
    to: o.to,
    insert: t.state.doc.slice(o.from, n.from).append(n.insert).append(t.state.doc.slice(n.to, o.to))
  } : rt.chrome && n && n.from == n.to && n.from == o.head && n.insert.toString() == `
 ` && t.lineWrapping && (r && (r = $e.single(r.main.anchor - 1, r.main.head - 1)), n = { from: o.from, to: o.to, insert: ln.of([" "]) }), n)
    return sL(t, n, r, i);
  if (r && !r.main.eq(o)) {
    let s = !1, a = "select";
    return t.inputState.lastSelectionTime > Date.now() - 50 && (t.inputState.lastSelectionOrigin == "select" && (s = !0), a = t.inputState.lastSelectionOrigin), t.dispatch({ selection: r, scrollIntoView: s, userEvent: a }), !0;
  } else
    return !1;
}
function sL(t, e, n, r = -1) {
  if (rt.ios && t.inputState.flushIOSKey(e))
    return !0;
  let o = t.state.selection.main;
  if (rt.android && (e.to == o.to && // GBoard will sometimes remove a space it just inserted
  // after a completion when you press enter
  (e.from == o.from || e.from == o.from - 1 && t.state.sliceDoc(e.from, o.from) == " ") && e.insert.length == 1 && e.insert.lines == 2 && gh(t.contentDOM, "Enter", 13) || (e.from == o.from - 1 && e.to == o.to && e.insert.length == 0 || r == 8 && e.insert.length < e.to - e.from && e.to > o.head) && gh(t.contentDOM, "Backspace", 8) || e.from == o.from && e.to == o.to + 1 && e.insert.length == 0 && gh(t.contentDOM, "Delete", 46)))
    return !0;
  let i = e.insert.toString();
  t.inputState.composing >= 0 && t.inputState.composing++;
  let s, a = () => s || (s = j6e(t, e, n));
  return t.state.facet(rde).some((l) => l(t, e.from, e.to, i, a)) || t.dispatch(a()), !0;
}
function j6e(t, e, n) {
  let r, o = t.state, i = o.selection.main;
  if (e.from >= i.from && e.to <= i.to && e.to - e.from >= (i.to - i.from) / 3 && (!n || n.main.empty && n.main.from == e.from + e.insert.length) && t.inputState.composing < 0) {
    let a = i.from < e.from ? o.sliceDoc(i.from, e.from) : "", l = i.to > e.to ? o.sliceDoc(e.to, i.to) : "";
    r = o.replaceSelection(t.state.toText(a + e.insert.sliceString(0, void 0, t.state.lineBreak) + l));
  } else {
    let a = o.changes(e), l = n && n.main.to <= a.newLength ? n.main : void 0;
    if (o.selection.ranges.length > 1 && t.inputState.composing >= 0 && e.to <= i.to && e.to >= i.to - 10) {
      let c = t.state.sliceDoc(e.from, e.to), u, d = n && hde(t, n.main.head);
      if (d) {
        let p = e.insert.length - (e.to - e.from);
        u = { from: d.from, to: d.to - p };
      } else
        u = t.state.doc.lineAt(i.head);
      let f = i.to - e.to, h = i.to - i.from;
      r = o.changeByRange((p) => {
        if (p.from == i.from && p.to == i.to)
          return { changes: a, range: l || p.map(a) };
        let m = p.to - f, g = m - c.length;
        if (p.to - p.from != h || t.state.sliceDoc(g, m) != c || // Unfortunately, there's no way to make multiple
        // changes in the same node work without aborting
        // composition, so cursors in the composition range are
        // ignored.
        p.to >= u.from && p.from <= u.to)
          return { range: p };
        let y = o.changes({ from: g, to: m, insert: e.insert }), v = p.to - i.to;
        return {
          changes: y,
          range: l ? $e.range(Math.max(0, l.anchor + v), Math.max(0, l.head + v)) : p.map(y)
        };
      });
    } else
      r = {
        changes: a,
        selection: l && o.selection.replaceRange(l)
      };
  }
  let s = "input.type";
  return (t.composing || t.inputState.compositionPendingChange && t.inputState.compositionEndedAt > Date.now() - 50) && (t.inputState.compositionPendingChange = !1, s += ".compose", t.inputState.compositionFirstChange && (s += ".start", t.inputState.compositionFirstChange = !1)), o.update(r, { userEvent: s, scrollIntoView: !0 });
}
function L6e(t, e, n, r) {
  let o = Math.min(t.length, e.length), i = 0;
  for (; i < o && t.charCodeAt(i) == e.charCodeAt(i); )
    i++;
  if (i == o && t.length == e.length)
    return null;
  let s = t.length, a = e.length;
  for (; s > 0 && a > 0 && t.charCodeAt(s - 1) == e.charCodeAt(a - 1); )
    s--, a--;
  if (r == "end") {
    let l = Math.max(0, i - Math.min(s, a));
    n -= s + l - i;
  }
  if (s < i && t.length < e.length) {
    let l = n <= i && n >= s ? i - n : 0;
    i -= l, a = i + (a - s), s = i;
  } else if (a < i) {
    let l = n <= i && n >= a ? i - n : 0;
    i -= l, s = i + (s - a), a = i;
  }
  return { from: i, toA: s, toB: a };
}
function F6e(t) {
  let e = [];
  if (t.root.activeElement != t.contentDOM)
    return e;
  let { anchorNode: n, anchorOffset: r, focusNode: o, focusOffset: i } = t.observer.selectionRange;
  return n && (e.push(new _B(n, r)), (o != n || i != r) && e.push(new _B(o, i))), e;
}
function B6e(t, e) {
  if (t.length == 0)
    return null;
  let n = t[0].pos, r = t.length == 2 ? t[1].pos : n;
  return n > -1 && r > -1 ? $e.single(n + e, r + e) : null;
}
class z6e {
  setSelectionOrigin(e) {
    this.lastSelectionOrigin = e, this.lastSelectionTime = Date.now();
  }
  constructor(e) {
    this.view = e, this.lastKeyCode = 0, this.lastKeyTime = 0, this.lastTouchTime = 0, this.lastFocusTime = 0, this.lastScrollTop = 0, this.lastScrollLeft = 0, this.pendingIOSKey = void 0, this.tabFocusMode = -1, this.lastSelectionOrigin = null, this.lastSelectionTime = 0, this.lastContextMenu = 0, this.scrollHandlers = [], this.handlers = /* @__PURE__ */ Object.create(null), this.composing = -1, this.compositionFirstChange = null, this.compositionEndedAt = 0, this.compositionPendingKey = !1, this.compositionPendingChange = !1, this.mouseSelection = null, this.draggedContent = null, this.handleEvent = this.handleEvent.bind(this), this.notifiedFocused = e.hasFocus, rt.safari && e.contentDOM.addEventListener("input", () => null), rt.gecko && r9e(e.contentDOM.ownerDocument);
  }
  handleEvent(e) {
    !K6e(this.view, e) || this.ignoreDuringComposition(e) || e.type == "keydown" && this.keydown(e) || this.runHandlers(e.type, e);
  }
  runHandlers(e, n) {
    let r = this.handlers[e];
    if (r) {
      for (let o of r.observers)
        o(this.view, n);
      for (let o of r.handlers) {
        if (n.defaultPrevented)
          break;
        if (o(this.view, n)) {
          n.preventDefault();
          break;
        }
      }
    }
  }
  ensureHandlers(e) {
    let n = q6e(e), r = this.handlers, o = this.view.contentDOM;
    for (let i in n)
      if (i != "scroll") {
        let s = !n[i].handlers.length, a = r[i];
        a && s != !a.handlers.length && (o.removeEventListener(i, this.handleEvent), a = null), a || o.addEventListener(i, this.handleEvent, { passive: s });
      }
    for (let i in r)
      i != "scroll" && !n[i] && o.removeEventListener(i, this.handleEvent);
    this.handlers = n;
  }
  keydown(e) {
    if (this.lastKeyCode = e.keyCode, this.lastKeyTime = Date.now(), e.keyCode == 9 && this.tabFocusMode > -1 && (!this.tabFocusMode || Date.now() <= this.tabFocusMode))
      return !0;
    if (this.tabFocusMode > 0 && e.keyCode != 27 && yde.indexOf(e.keyCode) < 0 && (this.tabFocusMode = -1), rt.android && rt.chrome && !e.synthetic && (e.keyCode == 13 || e.keyCode == 8))
      return this.view.observer.delayAndroidKey(e.key, e.keyCode), !0;
    let n;
    return rt.ios && !e.synthetic && !e.altKey && !e.metaKey && ((n = gde.find((r) => r.keyCode == e.keyCode)) && !e.ctrlKey || U6e.indexOf(e.key) > -1 && e.ctrlKey && !e.shiftKey) ? (this.pendingIOSKey = n || e, setTimeout(() => this.flushIOSKey(), 250), !0) : (e.keyCode != 229 && this.view.observer.forceFlush(), !1);
  }
  flushIOSKey(e) {
    let n = this.pendingIOSKey;
    return !n || n.key == "Enter" && e && e.from < e.to && /^\S+$/.test(e.insert.toString()) ? !1 : (this.pendingIOSKey = void 0, gh(this.view.contentDOM, n.key, n.keyCode, n instanceof KeyboardEvent ? n : void 0));
  }
  ignoreDuringComposition(e) {
    return /^key/.test(e.type) ? this.composing > 0 ? !0 : rt.safari && !rt.ios && this.compositionPendingKey && Date.now() - this.compositionEndedAt < 100 ? (this.compositionPendingKey = !1, !0) : !1 : !1;
  }
  startMouseSelection(e) {
    this.mouseSelection && this.mouseSelection.destroy(), this.mouseSelection = e;
  }
  update(e) {
    this.view.observer.update(e), this.mouseSelection && this.mouseSelection.update(e), this.draggedContent && e.docChanged && (this.draggedContent = this.draggedContent.map(e.changes)), e.transactions.length && (this.lastKeyCode = this.lastSelectionTime = 0);
  }
  destroy() {
    this.mouseSelection && this.mouseSelection.destroy();
  }
}
function wB(t, e) {
  return (n, r) => {
    try {
      return e.call(t, r, n);
    } catch (o) {
      Wo(n.state, o);
    }
  };
}
function q6e(t) {
  let e = /* @__PURE__ */ Object.create(null);
  function n(r) {
    return e[r] || (e[r] = { observers: [], handlers: [] });
  }
  for (let r of t) {
    let o = r.spec;
    if (o && o.domEventHandlers)
      for (let i in o.domEventHandlers) {
        let s = o.domEventHandlers[i];
        s && n(i).handlers.push(wB(r.value, s));
      }
    if (o && o.domEventObservers)
      for (let i in o.domEventObservers) {
        let s = o.domEventObservers[i];
        s && n(i).observers.push(wB(r.value, s));
      }
  }
  for (let r in $s)
    n(r).handlers.push($s[r]);
  for (let r in Ji)
    n(r).observers.push(Ji[r]);
  return e;
}
const gde = [
  { key: "Backspace", keyCode: 8, inputType: "deleteContentBackward" },
  { key: "Enter", keyCode: 13, inputType: "insertParagraph" },
  { key: "Enter", keyCode: 13, inputType: "insertLineBreak" },
  { key: "Delete", keyCode: 46, inputType: "deleteContentForward" }
], U6e = "dthko", yde = [16, 17, 18, 20, 91, 92, 224, 225], Ab = 6;
function Tb(t) {
  return Math.max(0, t) * 0.7 + 8;
}
function H6e(t, e) {
  return Math.max(Math.abs(t.clientX - e.clientX), Math.abs(t.clientY - e.clientY));
}
class V6e {
  constructor(e, n, r, o) {
    this.view = e, this.startEvent = n, this.style = r, this.mustSelect = o, this.scrollSpeed = { x: 0, y: 0 }, this.scrolling = -1, this.lastEvent = n, this.scrollParents = e6e(e.contentDOM), this.atoms = e.state.facet(oL).map((s) => s(e));
    let i = e.contentDOM.ownerDocument;
    i.addEventListener("mousemove", this.move = this.move.bind(this)), i.addEventListener("mouseup", this.up = this.up.bind(this)), this.extend = n.shiftKey, this.multiple = e.state.facet(qt.allowMultipleSelections) && W6e(e, n), this.dragging = Y6e(e, n) && _de(n) == 1 ? null : !1;
  }
  start(e) {
    this.dragging === !1 && this.select(e);
  }
  move(e) {
    if (e.buttons == 0)
      return this.destroy();
    if (this.dragging || this.dragging == null && H6e(this.startEvent, e) < 10)
      return;
    this.select(this.lastEvent = e);
    let n = 0, r = 0, o = 0, i = 0, s = this.view.win.innerWidth, a = this.view.win.innerHeight;
    this.scrollParents.x && ({ left: o, right: s } = this.scrollParents.x.getBoundingClientRect()), this.scrollParents.y && ({ top: i, bottom: a } = this.scrollParents.y.getBoundingClientRect());
    let l = iL(this.view);
    e.clientX - l.left <= o + Ab ? n = -Tb(o - e.clientX) : e.clientX + l.right >= s - Ab && (n = Tb(e.clientX - s)), e.clientY - l.top <= i + Ab ? r = -Tb(i - e.clientY) : e.clientY + l.bottom >= a - Ab && (r = Tb(e.clientY - a)), this.setScrollSpeed(n, r);
  }
  up(e) {
    this.dragging == null && this.select(this.lastEvent), this.dragging || e.preventDefault(), this.destroy();
  }
  destroy() {
    this.setScrollSpeed(0, 0);
    let e = this.view.contentDOM.ownerDocument;
    e.removeEventListener("mousemove", this.move), e.removeEventListener("mouseup", this.up), this.view.inputState.mouseSelection = this.view.inputState.draggedContent = null;
  }
  setScrollSpeed(e, n) {
    this.scrollSpeed = { x: e, y: n }, e || n ? this.scrolling < 0 && (this.scrolling = setInterval(() => this.scroll(), 50)) : this.scrolling > -1 && (clearInterval(this.scrolling), this.scrolling = -1);
  }
  scroll() {
    let { x: e, y: n } = this.scrollSpeed;
    e && this.scrollParents.x && (this.scrollParents.x.scrollLeft += e, e = 0), n && this.scrollParents.y && (this.scrollParents.y.scrollTop += n, n = 0), (e || n) && this.view.win.scrollBy(e, n), this.dragging === !1 && this.select(this.lastEvent);
  }
  skipAtoms(e) {
    let n = null;
    for (let r = 0; r < e.ranges.length; r++) {
      let o = e.ranges[r], i = null;
      if (o.empty) {
        let s = hw(this.atoms, o.from, 0);
        s != o.from && (i = $e.cursor(s, -1));
      } else {
        let s = hw(this.atoms, o.from, -1), a = hw(this.atoms, o.to, 1);
        (s != o.from || a != o.to) && (i = $e.range(o.from == o.anchor ? s : a, o.from == o.head ? s : a));
      }
      i && (n || (n = e.ranges.slice()), n[r] = i);
    }
    return n ? $e.create(n, e.mainIndex) : e;
  }
  select(e) {
    let { view: n } = this, r = this.skipAtoms(this.style.get(e, this.extend, this.multiple));
    (this.mustSelect || !r.eq(n.state.selection, this.dragging === !1)) && this.view.dispatch({
      selection: r,
      userEvent: "select.pointer"
    }), this.mustSelect = !1;
  }
  update(e) {
    e.transactions.some((n) => n.isUserEvent("input.type")) ? this.destroy() : this.style.update(e) && setTimeout(() => this.select(this.lastEvent), 20);
  }
}
function W6e(t, e) {
  let n = t.state.facet(Jue);
  return n.length ? n[0](e) : rt.mac ? e.metaKey : e.ctrlKey;
}
function G6e(t, e) {
  let n = t.state.facet(ede);
  return n.length ? n[0](e) : rt.mac ? !e.altKey : !e.ctrlKey;
}
function Y6e(t, e) {
  let { main: n } = t.state.selection;
  if (n.empty)
    return !1;
  let r = G0(t.root);
  if (!r || r.rangeCount == 0)
    return !0;
  let o = r.getRangeAt(0).getClientRects();
  for (let i = 0; i < o.length; i++) {
    let s = o[i];
    if (s.left <= e.clientX && s.right >= e.clientX && s.top <= e.clientY && s.bottom >= e.clientY)
      return !0;
  }
  return !1;
}
function K6e(t, e) {
  if (!e.bubbles)
    return !0;
  if (e.defaultPrevented)
    return !1;
  for (let n = e.target, r; n != t.contentDOM; n = n.parentNode)
    if (!n || n.nodeType == 11 || (r = tr.get(n)) && r.ignoreEvent(e))
      return !1;
  return !0;
}
const $s = /* @__PURE__ */ Object.create(null), Ji = /* @__PURE__ */ Object.create(null), vde = rt.ie && rt.ie_version < 15 || rt.ios && rt.webkit_version < 604;
function X6e(t) {
  let e = t.dom.parentNode;
  if (!e)
    return;
  let n = e.appendChild(document.createElement("textarea"));
  n.style.cssText = "position: fixed; left: -10000px; top: 10px", n.focus(), setTimeout(() => {
    t.focus(), n.remove(), bde(t, n.value);
  }, 50);
}
function kS(t, e, n) {
  for (let r of t.facet(e))
    n = r(n, t);
  return n;
}
function bde(t, e) {
  e = kS(t.state, tL, e);
  let { state: n } = t, r, o = 1, i = n.toText(e), s = i.lines == n.selection.ranges.length;
  if (iN != null && n.selection.ranges.every((a) => a.empty) && iN == i.toString()) {
    let a = -1;
    r = n.changeByRange((l) => {
      let c = n.doc.lineAt(l.from);
      if (c.from == a)
        return { range: l };
      a = c.from;
      let u = n.toText((s ? i.line(o++).text : e) + n.lineBreak);
      return {
        changes: { from: c.from, insert: u },
        range: $e.cursor(l.from + u.length)
      };
    });
  } else s ? r = n.changeByRange((a) => {
    let l = i.line(o++);
    return {
      changes: { from: a.from, to: a.to, insert: l.text },
      range: $e.cursor(a.from + l.length)
    };
  }) : r = n.replaceSelection(i);
  t.dispatch(r, {
    userEvent: "input.paste",
    scrollIntoView: !0
  });
}
Ji.scroll = (t) => {
  t.inputState.lastScrollTop = t.scrollDOM.scrollTop, t.inputState.lastScrollLeft = t.scrollDOM.scrollLeft;
};
$s.keydown = (t, e) => (t.inputState.setSelectionOrigin("select"), e.keyCode == 27 && t.inputState.tabFocusMode != 0 && (t.inputState.tabFocusMode = Date.now() + 2e3), !1);
Ji.touchstart = (t, e) => {
  t.inputState.lastTouchTime = Date.now(), t.inputState.setSelectionOrigin("select.pointer");
};
Ji.touchmove = (t) => {
  t.inputState.setSelectionOrigin("select.pointer");
};
$s.mousedown = (t, e) => {
  if (t.observer.flush(), t.inputState.lastTouchTime > Date.now() - 2e3)
    return !1;
  let n = null;
  for (let r of t.state.facet(tde))
    if (n = r(t, e), n)
      break;
  if (!n && e.button == 0 && (n = J6e(t, e)), n) {
    let r = !t.hasFocus;
    t.inputState.startMouseSelection(new V6e(t, e, n, r)), r && t.observer.ignore(() => {
      $ue(t.contentDOM);
      let i = t.root.activeElement;
      i && !i.contains(t.contentDOM) && i.blur();
    });
    let o = t.inputState.mouseSelection;
    if (o)
      return o.start(e), o.dragging === !1;
  }
  return !1;
};
function xB(t, e, n, r) {
  if (r == 1)
    return $e.cursor(e, n);
  if (r == 2)
    return C6e(t.state, e, n);
  {
    let o = So.find(t.docView, e), i = t.state.doc.lineAt(o ? o.posAtEnd : e), s = o ? o.posAtStart : i.from, a = o ? o.posAtEnd : i.to;
    return a < t.state.doc.length && a == i.to && a++, $e.range(s, a);
  }
}
let EB = (t, e, n) => e >= n.top && e <= n.bottom && t >= n.left && t <= n.right;
function Q6e(t, e, n, r) {
  let o = So.find(t.docView, e);
  if (!o)
    return 1;
  let i = e - o.posAtStart;
  if (i == 0)
    return 1;
  if (i == o.length)
    return -1;
  let s = o.coordsAt(i, -1);
  if (s && EB(n, r, s))
    return -1;
  let a = o.coordsAt(i, 1);
  return a && EB(n, r, a) ? 1 : s && s.bottom >= r ? -1 : 1;
}
function SB(t, e) {
  let n = t.posAtCoords({ x: e.clientX, y: e.clientY }, !1);
  return { pos: n, bias: Q6e(t, n, e.clientX, e.clientY) };
}
const Z6e = rt.ie && rt.ie_version <= 11;
let OB = null, CB = 0, kB = 0;
function _de(t) {
  if (!Z6e)
    return t.detail;
  let e = OB, n = kB;
  return OB = t, kB = Date.now(), CB = !e || n > Date.now() - 400 && Math.abs(e.clientX - t.clientX) < 2 && Math.abs(e.clientY - t.clientY) < 2 ? (CB + 1) % 3 : 1;
}
function J6e(t, e) {
  let n = SB(t, e), r = _de(e), o = t.state.selection;
  return {
    update(i) {
      i.docChanged && (n.pos = i.changes.mapPos(n.pos), o = o.map(i.changes));
    },
    get(i, s, a) {
      let l = SB(t, i), c, u = xB(t, l.pos, l.bias, r);
      if (n.pos != l.pos && !s) {
        let d = xB(t, n.pos, n.bias, r), f = Math.min(d.from, u.from), h = Math.max(d.to, u.to);
        u = f < u.from ? $e.range(f, h) : $e.range(h, f);
      }
      return s ? o.replaceRange(o.main.extend(u.from, u.to)) : a && r == 1 && o.ranges.length > 1 && (c = e9e(o, l.pos)) ? c : a ? o.addRange(u) : $e.create([u]);
    }
  };
}
function e9e(t, e) {
  for (let n = 0; n < t.ranges.length; n++) {
    let { from: r, to: o } = t.ranges[n];
    if (r <= e && o >= e)
      return $e.create(t.ranges.slice(0, n).concat(t.ranges.slice(n + 1)), t.mainIndex == n ? 0 : t.mainIndex - (t.mainIndex > n ? 1 : 0));
  }
  return null;
}
$s.dragstart = (t, e) => {
  let { selection: { main: n } } = t.state;
  if (e.target.draggable) {
    let o = t.docView.nearest(e.target);
    if (o && o.isWidget) {
      let i = o.posAtStart, s = i + o.length;
      (i >= n.to || s <= n.from) && (n = $e.range(i, s));
    }
  }
  let { inputState: r } = t;
  return r.mouseSelection && (r.mouseSelection.dragging = !0), r.draggedContent = n, e.dataTransfer && (e.dataTransfer.setData("Text", kS(t.state, nL, t.state.sliceDoc(n.from, n.to))), e.dataTransfer.effectAllowed = "copyMove"), !1;
};
$s.dragend = (t) => (t.inputState.draggedContent = null, !1);
function AB(t, e, n, r) {
  if (n = kS(t.state, tL, n), !n)
    return;
  let o = t.posAtCoords({ x: e.clientX, y: e.clientY }, !1), { draggedContent: i } = t.inputState, s = r && i && G6e(t, e) ? { from: i.from, to: i.to } : null, a = { from: o, insert: n }, l = t.state.changes(s ? [s, a] : a);
  t.focus(), t.dispatch({
    changes: l,
    selection: { anchor: l.mapPos(o, -1), head: l.mapPos(o, 1) },
    userEvent: s ? "move.drop" : "input.drop"
  }), t.inputState.draggedContent = null;
}
$s.drop = (t, e) => {
  if (!e.dataTransfer)
    return !1;
  if (t.state.readOnly)
    return !0;
  let n = e.dataTransfer.files;
  if (n && n.length) {
    let r = Array(n.length), o = 0, i = () => {
      ++o == n.length && AB(t, e, r.filter((s) => s != null).join(t.state.lineBreak), !1);
    };
    for (let s = 0; s < n.length; s++) {
      let a = new FileReader();
      a.onerror = i, a.onload = () => {
        /[\x00-\x08\x0e-\x1f]{2}/.test(a.result) || (r[s] = a.result), i();
      }, a.readAsText(n[s]);
    }
    return !0;
  } else {
    let r = e.dataTransfer.getData("Text");
    if (r)
      return AB(t, e, r, !0), !0;
  }
  return !1;
};
$s.paste = (t, e) => {
  if (t.state.readOnly)
    return !0;
  t.observer.flush();
  let n = vde ? null : e.clipboardData;
  return n ? (bde(t, n.getData("text/plain") || n.getData("text/uri-list")), !0) : (X6e(t), !1);
};
function t9e(t, e) {
  let n = t.dom.parentNode;
  if (!n)
    return;
  let r = n.appendChild(document.createElement("textarea"));
  r.style.cssText = "position: fixed; left: -10000px; top: 10px", r.value = e, r.focus(), r.selectionEnd = e.length, r.selectionStart = 0, setTimeout(() => {
    r.remove(), t.focus();
  }, 50);
}
function n9e(t) {
  let e = [], n = [], r = !1;
  for (let o of t.selection.ranges)
    o.empty || (e.push(t.sliceDoc(o.from, o.to)), n.push(o));
  if (!e.length) {
    let o = -1;
    for (let { from: i } of t.selection.ranges) {
      let s = t.doc.lineAt(i);
      s.number > o && (e.push(s.text), n.push({ from: s.from, to: Math.min(t.doc.length, s.to + 1) })), o = s.number;
    }
    r = !0;
  }
  return { text: kS(t, nL, e.join(t.lineBreak)), ranges: n, linewise: r };
}
let iN = null;
$s.copy = $s.cut = (t, e) => {
  let { text: n, ranges: r, linewise: o } = n9e(t.state);
  if (!n && !o)
    return !1;
  iN = o ? n : null, e.type == "cut" && !t.state.readOnly && t.dispatch({
    changes: r,
    scrollIntoView: !0,
    userEvent: "delete.cut"
  });
  let i = vde ? null : e.clipboardData;
  return i ? (i.clearData(), i.setData("text/plain", n), !0) : (t9e(t, n), !1);
};
const wde = /* @__PURE__ */ Ta.define();
function xde(t, e) {
  let n = [];
  for (let r of t.facet(ode)) {
    let o = r(t, e);
    o && n.push(o);
  }
  return n ? t.update({ effects: n, annotations: wde.of(!0) }) : null;
}
function Ede(t) {
  setTimeout(() => {
    let e = t.hasFocus;
    if (e != t.inputState.notifiedFocused) {
      let n = xde(t.state, e);
      n ? t.dispatch(n) : t.update([]);
    }
  }, 10);
}
Ji.focus = (t) => {
  t.inputState.lastFocusTime = Date.now(), !t.scrollDOM.scrollTop && (t.inputState.lastScrollTop || t.inputState.lastScrollLeft) && (t.scrollDOM.scrollTop = t.inputState.lastScrollTop, t.scrollDOM.scrollLeft = t.inputState.lastScrollLeft), Ede(t);
};
Ji.blur = (t) => {
  t.observer.clearSelectionRange(), Ede(t);
};
Ji.compositionstart = Ji.compositionupdate = (t) => {
  t.observer.editContext || (t.inputState.compositionFirstChange == null && (t.inputState.compositionFirstChange = !0), t.inputState.composing < 0 && (t.inputState.composing = 0));
};
Ji.compositionend = (t) => {
  t.observer.editContext || (t.inputState.composing = -1, t.inputState.compositionEndedAt = Date.now(), t.inputState.compositionPendingKey = !0, t.inputState.compositionPendingChange = t.observer.pendingRecords().length > 0, t.inputState.compositionFirstChange = null, rt.chrome && rt.android ? t.observer.flushSoon() : t.inputState.compositionPendingChange ? Promise.resolve().then(() => t.observer.flush()) : setTimeout(() => {
    t.inputState.composing < 0 && t.docView.hasComposition && t.update([]);
  }, 50));
};
Ji.contextmenu = (t) => {
  t.inputState.lastContextMenu = Date.now();
};
$s.beforeinput = (t, e) => {
  var n, r;
  if (e.inputType == "insertReplacementText" && t.observer.editContext) {
    let i = (n = e.dataTransfer) === null || n === void 0 ? void 0 : n.getData("text/plain"), s = e.getTargetRanges();
    if (i && s.length) {
      let a = s[0], l = t.posAtDOM(a.startContainer, a.startOffset), c = t.posAtDOM(a.endContainer, a.endOffset);
      return sL(t, { from: l, to: c, insert: t.state.toText(i) }, null), !0;
    }
  }
  let o;
  if (rt.chrome && rt.android && (o = gde.find((i) => i.inputType == e.inputType)) && (t.observer.delayAndroidKey(o.key, o.keyCode), o.key == "Backspace" || o.key == "Delete")) {
    let i = ((r = window.visualViewport) === null || r === void 0 ? void 0 : r.height) || 0;
    setTimeout(() => {
      var s;
      (((s = window.visualViewport) === null || s === void 0 ? void 0 : s.height) || 0) > i + 10 && t.hasFocus && (t.contentDOM.blur(), t.focus());
    }, 100);
  }
  return rt.ios && e.inputType == "deleteContentForward" && t.observer.flushSoon(), rt.safari && e.inputType == "insertText" && t.inputState.composing >= 0 && setTimeout(() => Ji.compositionend(t, e), 20), !1;
};
const TB = /* @__PURE__ */ new Set();
function r9e(t) {
  TB.has(t) || (TB.add(t), t.addEventListener("copy", () => {
  }), t.addEventListener("cut", () => {
  }));
}
const RB = ["pre-wrap", "normal", "pre-line", "break-spaces"];
let Xh = !1;
function PB() {
  Xh = !1;
}
class o9e {
  constructor(e) {
    this.lineWrapping = e, this.doc = ln.empty, this.heightSamples = {}, this.lineHeight = 14, this.charWidth = 7, this.textHeight = 14, this.lineLength = 30;
  }
  heightForGap(e, n) {
    let r = this.doc.lineAt(n).number - this.doc.lineAt(e).number + 1;
    return this.lineWrapping && (r += Math.max(0, Math.ceil((n - e - r * this.lineLength * 0.5) / this.lineLength))), this.lineHeight * r;
  }
  heightForLine(e) {
    return this.lineWrapping ? (1 + Math.max(0, Math.ceil((e - this.lineLength) / (this.lineLength - 5)))) * this.lineHeight : this.lineHeight;
  }
  setDoc(e) {
    return this.doc = e, this;
  }
  mustRefreshForWrapping(e) {
    return RB.indexOf(e) > -1 != this.lineWrapping;
  }
  mustRefreshForHeights(e) {
    let n = !1;
    for (let r = 0; r < e.length; r++) {
      let o = e[r];
      o < 0 ? r++ : this.heightSamples[Math.floor(o * 10)] || (n = !0, this.heightSamples[Math.floor(o * 10)] = !0);
    }
    return n;
  }
  refresh(e, n, r, o, i, s) {
    let a = RB.indexOf(e) > -1, l = Math.round(n) != Math.round(this.lineHeight) || this.lineWrapping != a;
    if (this.lineWrapping = a, this.lineHeight = n, this.charWidth = r, this.textHeight = o, this.lineLength = i, l) {
      this.heightSamples = {};
      for (let c = 0; c < s.length; c++) {
        let u = s[c];
        u < 0 ? c++ : this.heightSamples[Math.floor(u * 10)] = !0;
      }
    }
    return l;
  }
}
class i9e {
  constructor(e, n) {
    this.from = e, this.heights = n, this.index = 0;
  }
  get more() {
    return this.index < this.heights.length;
  }
}
let Oc = class Sde {
  /**
  @internal
  */
  constructor(e, n, r, o, i) {
    this.from = e, this.length = n, this.top = r, this.height = o, this._content = i;
  }
  /**
  The type of element this is. When querying lines, this may be
  an array of all the blocks that make up the line.
  */
  get type() {
    return typeof this._content == "number" ? Ao.Text : Array.isArray(this._content) ? this._content : this._content.type;
  }
  /**
  The end of the element as a document position.
  */
  get to() {
    return this.from + this.length;
  }
  /**
  The bottom position of the element.
  */
  get bottom() {
    return this.top + this.height;
  }
  /**
  If this is a widget block, this will return the widget
  associated with it.
  */
  get widget() {
    return this._content instanceof Yh ? this._content.widget : null;
  }
  /**
  If this is a textblock, this holds the number of line breaks
  that appear in widgets inside the block.
  */
  get widgetLineBreaks() {
    return typeof this._content == "number" ? this._content : 0;
  }
  /**
  @internal
  */
  join(e) {
    let n = (Array.isArray(this._content) ? this._content : [this]).concat(Array.isArray(e._content) ? e._content : [e]);
    return new Sde(this.from, this.length + e.length, this.top, this.height + e.height, n);
  }
};
var Yn = /* @__PURE__ */ function(t) {
  return t[t.ByPos = 0] = "ByPos", t[t.ByHeight = 1] = "ByHeight", t[t.ByPosNoHeight = 2] = "ByPosNoHeight", t;
}(Yn || (Yn = {}));
const pw = 1e-3;
let As = class mw {
  constructor(e, n, r = 2) {
    this.length = e, this.height = n, this.flags = r;
  }
  get outdated() {
    return (this.flags & 2) > 0;
  }
  set outdated(e) {
    this.flags = (e ? 2 : 0) | this.flags & -3;
  }
  setHeight(e) {
    this.height != e && (Math.abs(this.height - e) > pw && (Xh = !0), this.height = e);
  }
  // Base case is to replace a leaf node, which simply builds a tree
  // from the new nodes and returns that (HeightMapBranch and
  // HeightMapGap override this to actually use from/to)
  replace(e, n, r) {
    return mw.of(r);
  }
  // Again, these are base cases, and are overridden for branch and gap nodes.
  decomposeLeft(e, n) {
    n.push(this);
  }
  decomposeRight(e, n) {
    n.push(this);
  }
  applyChanges(e, n, r, o) {
    let i = this, s = r.doc;
    for (let a = o.length - 1; a >= 0; a--) {
      let { fromA: l, toA: c, fromB: u, toB: d } = o[a], f = i.lineAt(l, Yn.ByPosNoHeight, r.setDoc(n), 0, 0), h = f.to >= c ? f : i.lineAt(c, Yn.ByPosNoHeight, r, 0, 0);
      for (d += h.to - c, c = h.to; a > 0 && f.from <= o[a - 1].toA; )
        l = o[a - 1].fromA, u = o[a - 1].fromB, a--, l < f.from && (f = i.lineAt(l, Yn.ByPosNoHeight, r, 0, 0));
      u += f.from - l, l = f.from;
      let p = aL.build(r.setDoc(s), e, u, d);
      i = Ex(i, i.replace(l, c, p));
    }
    return i.updateHeight(r, 0);
  }
  static empty() {
    return new Zs(0, 0);
  }
  // nodes uses null values to indicate the position of line breaks.
  // There are never line breaks at the start or end of the array, or
  // two line breaks next to each other, and the array isn't allowed
  // to be empty (same restrictions as return value from the builder).
  static of(e) {
    if (e.length == 1)
      return e[0];
    let n = 0, r = e.length, o = 0, i = 0;
    for (; ; )
      if (n == r)
        if (o > i * 2) {
          let a = e[n - 1];
          a.break ? e.splice(--n, 1, a.left, null, a.right) : e.splice(--n, 1, a.left, a.right), r += 1 + a.break, o -= a.size;
        } else if (i > o * 2) {
          let a = e[r];
          a.break ? e.splice(r, 1, a.left, null, a.right) : e.splice(r, 1, a.left, a.right), r += 2 + a.break, i -= a.size;
        } else
          break;
      else if (o < i) {
        let a = e[n++];
        a && (o += a.size);
      } else {
        let a = e[--r];
        a && (i += a.size);
      }
    let s = 0;
    return e[n - 1] == null ? (s = 1, n--) : e[n] == null && (s = 1, r++), new s9e(mw.of(e.slice(0, n)), s, mw.of(e.slice(r)));
  }
};
function Ex(t, e) {
  return t == e ? t : (t.constructor != e.constructor && (Xh = !0), e);
}
As.prototype.size = 1;
class Ode extends As {
  constructor(e, n, r) {
    super(e, n), this.deco = r;
  }
  blockAt(e, n, r, o) {
    return new Oc(o, this.length, r, this.height, this.deco || 0);
  }
  lineAt(e, n, r, o, i) {
    return this.blockAt(0, r, o, i);
  }
  forEachLine(e, n, r, o, i, s) {
    e <= i + this.length && n >= i && s(this.blockAt(0, r, o, i));
  }
  updateHeight(e, n = 0, r = !1, o) {
    return o && o.from <= n && o.more && this.setHeight(o.heights[o.index++]), this.outdated = !1, this;
  }
  toString() {
    return `block(${this.length})`;
  }
}
let Zs = class sN extends Ode {
  constructor(e, n) {
    super(e, n, null), this.collapsed = 0, this.widgetHeight = 0, this.breaks = 0;
  }
  blockAt(e, n, r, o) {
    return new Oc(o, this.length, r, this.height, this.breaks);
  }
  replace(e, n, r) {
    let o = r[0];
    return r.length == 1 && (o instanceof sN || o instanceof vh && o.flags & 4) && Math.abs(this.length - o.length) < 10 ? (o instanceof vh ? o = new sN(o.length, this.height) : o.height = this.height, this.outdated || (o.outdated = !1), o) : As.of(r);
  }
  updateHeight(e, n = 0, r = !1, o) {
    return o && o.from <= n && o.more ? this.setHeight(o.heights[o.index++]) : (r || this.outdated) && this.setHeight(Math.max(this.widgetHeight, e.heightForLine(this.length - this.collapsed)) + this.breaks * e.lineHeight), this.outdated = !1, this;
  }
  toString() {
    return `line(${this.length}${this.collapsed ? -this.collapsed : ""}${this.widgetHeight ? ":" + this.widgetHeight : ""})`;
  }
}, vh = class gs extends As {
  constructor(e) {
    super(e, 0);
  }
  heightMetrics(e, n) {
    let r = e.doc.lineAt(n).number, o = e.doc.lineAt(n + this.length).number, i = o - r + 1, s, a = 0;
    if (e.lineWrapping) {
      let l = Math.min(this.height, e.lineHeight * i);
      s = l / i, this.length > i + 1 && (a = (this.height - l) / (this.length - i - 1));
    } else
      s = this.height / i;
    return { firstLine: r, lastLine: o, perLine: s, perChar: a };
  }
  blockAt(e, n, r, o) {
    let { firstLine: i, lastLine: s, perLine: a, perChar: l } = this.heightMetrics(n, o);
    if (n.lineWrapping) {
      let c = o + (e < n.lineHeight ? 0 : Math.round(Math.max(0, Math.min(1, (e - r) / this.height)) * this.length)), u = n.doc.lineAt(c), d = a + u.length * l, f = Math.max(r, e - d / 2);
      return new Oc(u.from, u.length, f, d, 0);
    } else {
      let c = Math.max(0, Math.min(s - i, Math.floor((e - r) / a))), { from: u, length: d } = n.doc.line(i + c);
      return new Oc(u, d, r + a * c, a, 0);
    }
  }
  lineAt(e, n, r, o, i) {
    if (n == Yn.ByHeight)
      return this.blockAt(e, r, o, i);
    if (n == Yn.ByPosNoHeight) {
      let { from: h, to: p } = r.doc.lineAt(e);
      return new Oc(h, p - h, 0, 0, 0);
    }
    let { firstLine: s, perLine: a, perChar: l } = this.heightMetrics(r, i), c = r.doc.lineAt(e), u = a + c.length * l, d = c.number - s, f = o + a * d + l * (c.from - i - d);
    return new Oc(c.from, c.length, Math.max(o, Math.min(f, o + this.height - u)), u, 0);
  }
  forEachLine(e, n, r, o, i, s) {
    e = Math.max(e, i), n = Math.min(n, i + this.length);
    let { firstLine: a, perLine: l, perChar: c } = this.heightMetrics(r, i);
    for (let u = e, d = o; u <= n; ) {
      let f = r.doc.lineAt(u);
      if (u == e) {
        let p = f.number - a;
        d += l * p + c * (e - i - p);
      }
      let h = l + c * f.length;
      s(new Oc(f.from, f.length, d, h, 0)), d += h, u = f.to + 1;
    }
  }
  replace(e, n, r) {
    let o = this.length - n;
    if (o > 0) {
      let i = r[r.length - 1];
      i instanceof gs ? r[r.length - 1] = new gs(i.length + o) : r.push(null, new gs(o - 1));
    }
    if (e > 0) {
      let i = r[0];
      i instanceof gs ? r[0] = new gs(e + i.length) : r.unshift(new gs(e - 1), null);
    }
    return As.of(r);
  }
  decomposeLeft(e, n) {
    n.push(new gs(e - 1), null);
  }
  decomposeRight(e, n) {
    n.push(null, new gs(this.length - e - 1));
  }
  updateHeight(e, n = 0, r = !1, o) {
    let i = n + this.length;
    if (o && o.from <= n + this.length && o.more) {
      let s = [], a = Math.max(n, o.from), l = -1;
      for (o.from > n && s.push(new gs(o.from - n - 1).updateHeight(e, n)); a <= i && o.more; ) {
        let u = e.doc.lineAt(a).length;
        s.length && s.push(null);
        let d = o.heights[o.index++];
        l == -1 ? l = d : Math.abs(d - l) >= pw && (l = -2);
        let f = new Zs(u, d);
        f.outdated = !1, s.push(f), a += u + 1;
      }
      a <= i && s.push(null, new gs(i - a).updateHeight(e, a));
      let c = As.of(s);
      return (l < 0 || Math.abs(c.height - this.height) >= pw || Math.abs(l - this.heightMetrics(e, n).perLine) >= pw) && (Xh = !0), Ex(this, c);
    } else (r || this.outdated) && (this.setHeight(e.heightForGap(n, n + this.length)), this.outdated = !1);
    return this;
  }
  toString() {
    return `gap(${this.length})`;
  }
};
class s9e extends As {
  constructor(e, n, r) {
    super(e.length + n + r.length, e.height + r.height, n | (e.outdated || r.outdated ? 2 : 0)), this.left = e, this.right = r, this.size = e.size + r.size;
  }
  get break() {
    return this.flags & 1;
  }
  blockAt(e, n, r, o) {
    let i = r + this.left.height;
    return e < i ? this.left.blockAt(e, n, r, o) : this.right.blockAt(e, n, i, o + this.left.length + this.break);
  }
  lineAt(e, n, r, o, i) {
    let s = o + this.left.height, a = i + this.left.length + this.break, l = n == Yn.ByHeight ? e < s : e < a, c = l ? this.left.lineAt(e, n, r, o, i) : this.right.lineAt(e, n, r, s, a);
    if (this.break || (l ? c.to < a : c.from > a))
      return c;
    let u = n == Yn.ByPosNoHeight ? Yn.ByPosNoHeight : Yn.ByPos;
    return l ? c.join(this.right.lineAt(a, u, r, s, a)) : this.left.lineAt(a, u, r, o, i).join(c);
  }
  forEachLine(e, n, r, o, i, s) {
    let a = o + this.left.height, l = i + this.left.length + this.break;
    if (this.break)
      e < l && this.left.forEachLine(e, n, r, o, i, s), n >= l && this.right.forEachLine(e, n, r, a, l, s);
    else {
      let c = this.lineAt(l, Yn.ByPos, r, o, i);
      e < c.from && this.left.forEachLine(e, c.from - 1, r, o, i, s), c.to >= e && c.from <= n && s(c), n > c.to && this.right.forEachLine(c.to + 1, n, r, a, l, s);
    }
  }
  replace(e, n, r) {
    let o = this.left.length + this.break;
    if (n < o)
      return this.balanced(this.left.replace(e, n, r), this.right);
    if (e > this.left.length)
      return this.balanced(this.left, this.right.replace(e - o, n - o, r));
    let i = [];
    e > 0 && this.decomposeLeft(e, i);
    let s = i.length;
    for (let a of r)
      i.push(a);
    if (e > 0 && $B(i, s - 1), n < this.length) {
      let a = i.length;
      this.decomposeRight(n, i), $B(i, a);
    }
    return As.of(i);
  }
  decomposeLeft(e, n) {
    let r = this.left.length;
    if (e <= r)
      return this.left.decomposeLeft(e, n);
    n.push(this.left), this.break && (r++, e >= r && n.push(null)), e > r && this.right.decomposeLeft(e - r, n);
  }
  decomposeRight(e, n) {
    let r = this.left.length, o = r + this.break;
    if (e >= o)
      return this.right.decomposeRight(e - o, n);
    e < r && this.left.decomposeRight(e, n), this.break && e < o && n.push(null), n.push(this.right);
  }
  balanced(e, n) {
    return e.size > 2 * n.size || n.size > 2 * e.size ? As.of(this.break ? [e, null, n] : [e, n]) : (this.left = Ex(this.left, e), this.right = Ex(this.right, n), this.setHeight(e.height + n.height), this.outdated = e.outdated || n.outdated, this.size = e.size + n.size, this.length = e.length + this.break + n.length, this);
  }
  updateHeight(e, n = 0, r = !1, o) {
    let { left: i, right: s } = this, a = n + i.length + this.break, l = null;
    return o && o.from <= n + i.length && o.more ? l = i = i.updateHeight(e, n, r, o) : i.updateHeight(e, n, r), o && o.from <= a + s.length && o.more ? l = s = s.updateHeight(e, a, r, o) : s.updateHeight(e, a, r), l ? this.balanced(i, s) : (this.height = this.left.height + this.right.height, this.outdated = !1, this);
  }
  toString() {
    return this.left + (this.break ? " " : "-") + this.right;
  }
}
function $B(t, e) {
  let n, r;
  t[e] == null && (n = t[e - 1]) instanceof vh && (r = t[e + 1]) instanceof vh && t.splice(e - 1, 3, new vh(n.length + 1 + r.length));
}
const a9e = 5;
class aL {
  constructor(e, n) {
    this.pos = e, this.oracle = n, this.nodes = [], this.lineStart = -1, this.lineEnd = -1, this.covering = null, this.writtenTo = e;
  }
  get isCovered() {
    return this.covering && this.nodes[this.nodes.length - 1] == this.covering;
  }
  span(e, n) {
    if (this.lineStart > -1) {
      let r = Math.min(n, this.lineEnd), o = this.nodes[this.nodes.length - 1];
      o instanceof Zs ? o.length += r - this.pos : (r > this.pos || !this.isCovered) && this.nodes.push(new Zs(r - this.pos, -1)), this.writtenTo = r, n > r && (this.nodes.push(null), this.writtenTo++, this.lineStart = -1);
    }
    this.pos = n;
  }
  point(e, n, r) {
    if (e < n || r.heightRelevant) {
      let o = r.widget ? r.widget.estimatedHeight : 0, i = r.widget ? r.widget.lineBreaks : 0;
      o < 0 && (o = this.oracle.lineHeight);
      let s = n - e;
      r.block ? this.addBlock(new Ode(s, o, r)) : (s || i || o >= a9e) && this.addLineDeco(o, i, s);
    } else n > e && this.span(e, n);
    this.lineEnd > -1 && this.lineEnd < this.pos && (this.lineEnd = this.oracle.doc.lineAt(this.pos).to);
  }
  enterLine() {
    if (this.lineStart > -1)
      return;
    let { from: e, to: n } = this.oracle.doc.lineAt(this.pos);
    this.lineStart = e, this.lineEnd = n, this.writtenTo < e && ((this.writtenTo < e - 1 || this.nodes[this.nodes.length - 1] == null) && this.nodes.push(this.blankContent(this.writtenTo, e - 1)), this.nodes.push(null)), this.pos > e && this.nodes.push(new Zs(this.pos - e, -1)), this.writtenTo = this.pos;
  }
  blankContent(e, n) {
    let r = new vh(n - e);
    return this.oracle.doc.lineAt(e).to == n && (r.flags |= 4), r;
  }
  ensureLine() {
    this.enterLine();
    let e = this.nodes.length ? this.nodes[this.nodes.length - 1] : null;
    if (e instanceof Zs)
      return e;
    let n = new Zs(0, -1);
    return this.nodes.push(n), n;
  }
  addBlock(e) {
    this.enterLine();
    let n = e.deco;
    n && n.startSide > 0 && !this.isCovered && this.ensureLine(), this.nodes.push(e), this.writtenTo = this.pos = this.pos + e.length, n && n.endSide > 0 && (this.covering = e);
  }
  addLineDeco(e, n, r) {
    let o = this.ensureLine();
    o.length += r, o.collapsed += r, o.widgetHeight = Math.max(o.widgetHeight, e), o.breaks += n, this.writtenTo = this.pos = this.pos + r;
  }
  finish(e) {
    let n = this.nodes.length == 0 ? null : this.nodes[this.nodes.length - 1];
    this.lineStart > -1 && !(n instanceof Zs) && !this.isCovered ? this.nodes.push(new Zs(0, -1)) : (this.writtenTo < this.pos || n == null) && this.nodes.push(this.blankContent(this.writtenTo, this.pos));
    let r = e;
    for (let o of this.nodes)
      o instanceof Zs && o.updateHeight(this.oracle, r), r += o ? o.length : 1;
    return this.nodes;
  }
  // Always called with a region that on both sides either stretches
  // to a line break or the end of the document.
  // The returned array uses null to indicate line breaks, but never
  // starts or ends in a line break, or has multiple line breaks next
  // to each other.
  static build(e, n, r, o) {
    let i = new aL(r, e);
    return or.spans(n, r, o, i, 0), i.finish(r);
  }
}
function l9e(t, e, n) {
  let r = new c9e();
  return or.compare(t, e, n, r, 0), r.changes;
}
class c9e {
  constructor() {
    this.changes = [];
  }
  compareRange() {
  }
  comparePoint(e, n, r, o) {
    (e < n || r && r.heightRelevant || o && o.heightRelevant) && uw(e, n, this.changes, 5);
  }
}
function u9e(t, e) {
  let n = t.getBoundingClientRect(), r = t.ownerDocument, o = r.defaultView || window, i = Math.max(0, n.left), s = Math.min(o.innerWidth, n.right), a = Math.max(0, n.top), l = Math.min(o.innerHeight, n.bottom);
  for (let c = t.parentNode; c && c != r.body; )
    if (c.nodeType == 1) {
      let u = c, d = window.getComputedStyle(u);
      if ((u.scrollHeight > u.clientHeight || u.scrollWidth > u.clientWidth) && d.overflow != "visible") {
        let f = u.getBoundingClientRect();
        i = Math.max(i, f.left), s = Math.min(s, f.right), a = Math.max(a, f.top), l = Math.min(c == t.parentNode ? o.innerHeight : l, f.bottom);
      }
      c = d.position == "absolute" || d.position == "fixed" ? u.offsetParent : u.parentNode;
    } else if (c.nodeType == 11)
      c = c.host;
    else
      break;
  return {
    left: i - n.left,
    right: Math.max(i, s) - n.left,
    top: a - (n.top + e),
    bottom: Math.max(a, l) - (n.top + e)
  };
}
function d9e(t) {
  let e = t.getBoundingClientRect(), n = t.ownerDocument.defaultView || window;
  return e.left < n.innerWidth && e.right > 0 && e.top < n.innerHeight && e.bottom > 0;
}
function f9e(t, e) {
  let n = t.getBoundingClientRect();
  return {
    left: 0,
    right: n.right - n.left,
    top: e,
    bottom: n.bottom - (n.top + e)
  };
}
let tk = class {
  constructor(e, n, r, o) {
    this.from = e, this.to = n, this.size = r, this.displaySize = o;
  }
  static same(e, n) {
    if (e.length != n.length)
      return !1;
    for (let r = 0; r < e.length; r++) {
      let o = e[r], i = n[r];
      if (o.from != i.from || o.to != i.to || o.size != i.size)
        return !1;
    }
    return !0;
  }
  draw(e, n) {
    return ut.replace({
      widget: new h9e(this.displaySize * (n ? e.scaleY : e.scaleX), n)
    }).range(this.from, this.to);
  }
};
class h9e extends Pa {
  constructor(e, n) {
    super(), this.size = e, this.vertical = n;
  }
  eq(e) {
    return e.size == this.size && e.vertical == this.vertical;
  }
  toDOM() {
    let e = document.createElement("div");
    return this.vertical ? e.style.height = this.size + "px" : (e.style.width = this.size + "px", e.style.height = "2px", e.style.display = "inline-block"), e;
  }
  get estimatedHeight() {
    return this.vertical ? this.size : -1;
  }
}
class MB {
  constructor(e) {
    this.state = e, this.pixelViewport = { left: 0, right: window.innerWidth, top: 0, bottom: 0 }, this.inView = !0, this.paddingTop = 0, this.paddingBottom = 0, this.contentDOMWidth = 0, this.contentDOMHeight = 0, this.editorHeight = 0, this.editorWidth = 0, this.scrollTop = 0, this.scrolledToBottom = !1, this.scaleX = 1, this.scaleY = 1, this.scrollAnchorPos = 0, this.scrollAnchorHeight = -1, this.scaler = DB, this.scrollTarget = null, this.printing = !1, this.mustMeasureContent = !0, this.defaultTextDirection = Kn.LTR, this.visibleRanges = [], this.mustEnforceCursorAssoc = !1;
    let n = e.facet(rL).some((r) => typeof r != "function" && r.class == "cm-lineWrapping");
    this.heightOracle = new o9e(n), this.stateDeco = e.facet(Y0).filter((r) => typeof r != "function"), this.heightMap = As.empty().applyChanges(this.stateDeco, ln.empty, this.heightOracle.setDoc(e.doc), [new Hc(0, 0, 0, e.doc.length)]);
    for (let r = 0; r < 2 && (this.viewport = this.getViewport(0, null), !!this.updateForViewport()); r++)
      ;
    this.updateViewportLines(), this.lineGaps = this.ensureLineGaps([]), this.lineGapDeco = ut.set(this.lineGaps.map((r) => r.draw(this, !1))), this.computeVisibleRanges();
  }
  updateForViewport() {
    let e = [this.viewport], { main: n } = this.state.selection;
    for (let r = 0; r <= 1; r++) {
      let o = r ? n.head : n.anchor;
      if (!e.some(({ from: i, to: s }) => o >= i && o <= s)) {
        let { from: i, to: s } = this.lineBlockAt(o);
        e.push(new Rb(i, s));
      }
    }
    return this.viewports = e.sort((r, o) => r.from - o.from), this.updateScaler();
  }
  updateScaler() {
    let e = this.scaler;
    return this.scaler = this.heightMap.height <= 7e6 ? DB : new lL(this.heightOracle, this.heightMap, this.viewports), e.eq(this.scaler) ? 0 : 2;
  }
  updateViewportLines() {
    this.viewportLines = [], this.heightMap.forEachLine(this.viewport.from, this.viewport.to, this.heightOracle.setDoc(this.state.doc), 0, 0, (e) => {
      this.viewportLines.push(bg(e, this.scaler));
    });
  }
  update(e, n = null) {
    this.state = e.state;
    let r = this.stateDeco;
    this.stateDeco = this.state.facet(Y0).filter((u) => typeof u != "function");
    let o = e.changedRanges, i = Hc.extendWithRanges(o, l9e(r, this.stateDeco, e ? e.changes : Ps.empty(this.state.doc.length))), s = this.heightMap.height, a = this.scrolledToBottom ? null : this.scrollAnchorAt(this.scrollTop);
    PB(), this.heightMap = this.heightMap.applyChanges(this.stateDeco, e.startState.doc, this.heightOracle.setDoc(this.state.doc), i), (this.heightMap.height != s || Xh) && (e.flags |= 2), a ? (this.scrollAnchorPos = e.changes.mapPos(a.from, -1), this.scrollAnchorHeight = a.top) : (this.scrollAnchorPos = -1, this.scrollAnchorHeight = this.heightMap.height);
    let l = i.length ? this.mapViewport(this.viewport, e.changes) : this.viewport;
    (n && (n.range.head < l.from || n.range.head > l.to) || !this.viewportIsAppropriate(l)) && (l = this.getViewport(0, n));
    let c = l.from != this.viewport.from || l.to != this.viewport.to;
    this.viewport = l, e.flags |= this.updateForViewport(), (c || !e.changes.empty || e.flags & 2) && this.updateViewportLines(), (this.lineGaps.length || this.viewport.to - this.viewport.from > 4e3) && this.updateLineGaps(this.ensureLineGaps(this.mapLineGaps(this.lineGaps, e.changes))), e.flags |= this.computeVisibleRanges(e.changes), n && (this.scrollTarget = n), !this.mustEnforceCursorAssoc && e.selectionSet && e.view.lineWrapping && e.state.selection.main.empty && e.state.selection.main.assoc && !e.state.facet(sde) && (this.mustEnforceCursorAssoc = !0);
  }
  measure(e) {
    let n = e.contentDOM, r = window.getComputedStyle(n), o = this.heightOracle, i = r.whiteSpace;
    this.defaultTextDirection = r.direction == "rtl" ? Kn.RTL : Kn.LTR;
    let s = this.heightOracle.mustRefreshForWrapping(i), a = n.getBoundingClientRect(), l = s || this.mustMeasureContent || this.contentDOMHeight != a.height;
    this.contentDOMHeight = a.height, this.mustMeasureContent = !1;
    let c = 0, u = 0;
    if (a.width && a.height) {
      let { scaleX: _, scaleY: w } = Pue(n, a);
      (_ > 5e-3 && Math.abs(this.scaleX - _) > 5e-3 || w > 5e-3 && Math.abs(this.scaleY - w) > 5e-3) && (this.scaleX = _, this.scaleY = w, c |= 16, s = l = !0);
    }
    let d = (parseInt(r.paddingTop) || 0) * this.scaleY, f = (parseInt(r.paddingBottom) || 0) * this.scaleY;
    (this.paddingTop != d || this.paddingBottom != f) && (this.paddingTop = d, this.paddingBottom = f, c |= 18), this.editorWidth != e.scrollDOM.clientWidth && (o.lineWrapping && (l = !0), this.editorWidth = e.scrollDOM.clientWidth, c |= 16);
    let h = e.scrollDOM.scrollTop * this.scaleY;
    this.scrollTop != h && (this.scrollAnchorHeight = -1, this.scrollTop = h), this.scrolledToBottom = Due(e.scrollDOM);
    let p = (this.printing ? f9e : u9e)(n, this.paddingTop), m = p.top - this.pixelViewport.top, g = p.bottom - this.pixelViewport.bottom;
    this.pixelViewport = p;
    let y = this.pixelViewport.bottom > this.pixelViewport.top && this.pixelViewport.right > this.pixelViewport.left;
    if (y != this.inView && (this.inView = y, y && (l = !0)), !this.inView && !this.scrollTarget && !d9e(e.dom))
      return 0;
    let v = a.width;
    if ((this.contentDOMWidth != v || this.editorHeight != e.scrollDOM.clientHeight) && (this.contentDOMWidth = a.width, this.editorHeight = e.scrollDOM.clientHeight, c |= 16), l) {
      let _ = e.docView.measureVisibleLineHeights(this.viewport);
      if (o.mustRefreshForHeights(_) && (s = !0), s || o.lineWrapping && Math.abs(v - this.contentDOMWidth) > o.charWidth) {
        let { lineHeight: w, charWidth: x, textHeight: E } = e.docView.measureTextSize();
        s = w > 0 && o.refresh(i, w, x, E, v / x, _), s && (e.docView.minWidth = 0, c |= 16);
      }
      m > 0 && g > 0 ? u = Math.max(m, g) : m < 0 && g < 0 && (u = Math.min(m, g)), PB();
      for (let w of this.viewports) {
        let x = w.from == this.viewport.from ? _ : e.docView.measureVisibleLineHeights(w);
        this.heightMap = (s ? As.empty().applyChanges(this.stateDeco, ln.empty, this.heightOracle, [new Hc(0, 0, 0, e.state.doc.length)]) : this.heightMap).updateHeight(o, 0, s, new i9e(w.from, x));
      }
      Xh && (c |= 2);
    }
    let b = !this.viewportIsAppropriate(this.viewport, u) || this.scrollTarget && (this.scrollTarget.range.head < this.viewport.from || this.scrollTarget.range.head > this.viewport.to);
    return b && (c & 2 && (c |= this.updateScaler()), this.viewport = this.getViewport(u, this.scrollTarget), c |= this.updateForViewport()), (c & 2 || b) && this.updateViewportLines(), (this.lineGaps.length || this.viewport.to - this.viewport.from > 4e3) && this.updateLineGaps(this.ensureLineGaps(s ? [] : this.lineGaps, e)), c |= this.computeVisibleRanges(), this.mustEnforceCursorAssoc && (this.mustEnforceCursorAssoc = !1, e.docView.enforceCursorAssoc()), c;
  }
  get visibleTop() {
    return this.scaler.fromDOM(this.pixelViewport.top);
  }
  get visibleBottom() {
    return this.scaler.fromDOM(this.pixelViewport.bottom);
  }
  getViewport(e, n) {
    let r = 0.5 - Math.max(-0.5, Math.min(0.5, e / 1e3 / 2)), o = this.heightMap, i = this.heightOracle, { visibleTop: s, visibleBottom: a } = this, l = new Rb(o.lineAt(s - r * 1e3, Yn.ByHeight, i, 0, 0).from, o.lineAt(a + (1 - r) * 1e3, Yn.ByHeight, i, 0, 0).to);
    if (n) {
      let { head: c } = n.range;
      if (c < l.from || c > l.to) {
        let u = Math.min(this.editorHeight, this.pixelViewport.bottom - this.pixelViewport.top), d = o.lineAt(c, Yn.ByPos, i, 0, 0), f;
        n.y == "center" ? f = (d.top + d.bottom) / 2 - u / 2 : n.y == "start" || n.y == "nearest" && c < l.from ? f = d.top : f = d.bottom - u, l = new Rb(o.lineAt(f - 1e3 / 2, Yn.ByHeight, i, 0, 0).from, o.lineAt(f + u + 1e3 / 2, Yn.ByHeight, i, 0, 0).to);
      }
    }
    return l;
  }
  mapViewport(e, n) {
    let r = n.mapPos(e.from, -1), o = n.mapPos(e.to, 1);
    return new Rb(this.heightMap.lineAt(r, Yn.ByPos, this.heightOracle, 0, 0).from, this.heightMap.lineAt(o, Yn.ByPos, this.heightOracle, 0, 0).to);
  }
  // Checks if a given viewport covers the visible part of the
  // document and not too much beyond that.
  viewportIsAppropriate({ from: e, to: n }, r = 0) {
    if (!this.inView)
      return !0;
    let { top: o } = this.heightMap.lineAt(e, Yn.ByPos, this.heightOracle, 0, 0), { bottom: i } = this.heightMap.lineAt(n, Yn.ByPos, this.heightOracle, 0, 0), { visibleTop: s, visibleBottom: a } = this;
    return (e == 0 || o <= s - Math.max(10, Math.min(
      -r,
      250
      /* VP.MaxCoverMargin */
    ))) && (n == this.state.doc.length || i >= a + Math.max(10, Math.min(
      r,
      250
      /* VP.MaxCoverMargin */
    ))) && o > s - 2 * 1e3 && i < a + 2 * 1e3;
  }
  mapLineGaps(e, n) {
    if (!e.length || n.empty)
      return e;
    let r = [];
    for (let o of e)
      n.touchesRange(o.from, o.to) || r.push(new tk(n.mapPos(o.from), n.mapPos(o.to), o.size, o.displaySize));
    return r;
  }
  // Computes positions in the viewport where the start or end of a
  // line should be hidden, trying to reuse existing line gaps when
  // appropriate to avoid unneccesary redraws.
  // Uses crude character-counting for the positioning and sizing,
  // since actual DOM coordinates aren't always available and
  // predictable. Relies on generous margins (see LG.Margin) to hide
  // the artifacts this might produce from the user.
  ensureLineGaps(e, n) {
    let r = this.heightOracle.lineWrapping, o = r ? 1e4 : 2e3, i = o >> 1, s = o << 1;
    if (this.defaultTextDirection != Kn.LTR && !r)
      return [];
    let a = [], l = (u, d, f, h) => {
      if (d - u < i)
        return;
      let p = this.state.selection.main, m = [p.from];
      p.empty || m.push(p.to);
      for (let y of m)
        if (y > u && y < d) {
          l(u, y - 10, f, h), l(y + 10, d, f, h);
          return;
        }
      let g = m9e(e, (y) => y.from >= f.from && y.to <= f.to && Math.abs(y.from - u) < i && Math.abs(y.to - d) < i && !m.some((v) => y.from < v && y.to > v));
      if (!g) {
        if (d < f.to && n && r && n.visibleRanges.some((b) => b.from <= d && b.to >= d)) {
          let b = n.moveToLineBoundary($e.cursor(d), !1, !0).head;
          b > u && (d = b);
        }
        let y = this.gapSize(f, u, d, h), v = r || y < 2e6 ? y : 2e6;
        g = new tk(u, d, y, v);
      }
      a.push(g);
    }, c = (u) => {
      if (u.length < s || u.type != Ao.Text)
        return;
      let d = p9e(u.from, u.to, this.stateDeco);
      if (d.total < s)
        return;
      let f = this.scrollTarget ? this.scrollTarget.range.head : null, h, p;
      if (r) {
        let m = o / this.heightOracle.lineLength * this.heightOracle.lineHeight, g, y;
        if (f != null) {
          let v = $b(d, f), b = ((this.visibleBottom - this.visibleTop) / 2 + m) / u.height;
          g = v - b, y = v + b;
        } else
          g = (this.visibleTop - u.top - m) / u.height, y = (this.visibleBottom - u.top + m) / u.height;
        h = Pb(d, g), p = Pb(d, y);
      } else {
        let m = d.total * this.heightOracle.charWidth, g = o * this.heightOracle.charWidth, y = 0;
        if (m > 2e6)
          for (let x of e)
            x.from >= u.from && x.from < u.to && x.size != x.displaySize && x.from * this.heightOracle.charWidth + y < this.pixelViewport.left && (y = x.size - x.displaySize);
        let v = this.pixelViewport.left + y, b = this.pixelViewport.right + y, _, w;
        if (f != null) {
          let x = $b(d, f), E = ((b - v) / 2 + g) / m;
          _ = x - E, w = x + E;
        } else
          _ = (v - g) / m, w = (b + g) / m;
        h = Pb(d, _), p = Pb(d, w);
      }
      h > u.from && l(u.from, h, u, d), p < u.to && l(p, u.to, u, d);
    };
    for (let u of this.viewportLines)
      Array.isArray(u.type) ? u.type.forEach(c) : c(u);
    return a;
  }
  gapSize(e, n, r, o) {
    let i = $b(o, r) - $b(o, n);
    return this.heightOracle.lineWrapping ? e.height * i : o.total * this.heightOracle.charWidth * i;
  }
  updateLineGaps(e) {
    tk.same(e, this.lineGaps) || (this.lineGaps = e, this.lineGapDeco = ut.set(e.map((n) => n.draw(this, this.heightOracle.lineWrapping))));
  }
  computeVisibleRanges(e) {
    let n = this.stateDeco;
    this.lineGaps.length && (n = n.concat(this.lineGapDeco));
    let r = [];
    or.spans(n, this.viewport.from, this.viewport.to, {
      span(i, s) {
        r.push({ from: i, to: s });
      },
      point() {
      }
    }, 20);
    let o = 0;
    if (r.length != this.visibleRanges.length)
      o = 12;
    else
      for (let i = 0; i < r.length && !(o & 8); i++) {
        let s = this.visibleRanges[i], a = r[i];
        (s.from != a.from || s.to != a.to) && (o |= 4, e && e.mapPos(s.from, -1) == a.from && e.mapPos(s.to, 1) == a.to || (o |= 8));
      }
    return this.visibleRanges = r, o;
  }
  lineBlockAt(e) {
    return e >= this.viewport.from && e <= this.viewport.to && this.viewportLines.find((n) => n.from <= e && n.to >= e) || bg(this.heightMap.lineAt(e, Yn.ByPos, this.heightOracle, 0, 0), this.scaler);
  }
  lineBlockAtHeight(e) {
    return e >= this.viewportLines[0].top && e <= this.viewportLines[this.viewportLines.length - 1].bottom && this.viewportLines.find((n) => n.top <= e && n.bottom >= e) || bg(this.heightMap.lineAt(this.scaler.fromDOM(e), Yn.ByHeight, this.heightOracle, 0, 0), this.scaler);
  }
  scrollAnchorAt(e) {
    let n = this.lineBlockAtHeight(e + 8);
    return n.from >= this.viewport.from || this.viewportLines[0].top - e > 200 ? n : this.viewportLines[0];
  }
  elementAtHeight(e) {
    return bg(this.heightMap.blockAt(this.scaler.fromDOM(e), this.heightOracle, 0, 0), this.scaler);
  }
  get docHeight() {
    return this.scaler.toDOM(this.heightMap.height);
  }
  get contentHeight() {
    return this.docHeight + this.paddingTop + this.paddingBottom;
  }
}
let Rb = class {
  constructor(t, e) {
    this.from = t, this.to = e;
  }
};
function p9e(t, e, n) {
  let r = [], o = t, i = 0;
  return or.spans(n, t, e, {
    span() {
    },
    point(s, a) {
      s > o && (r.push({ from: o, to: s }), i += s - o), o = a;
    }
  }, 20), o < e && (r.push({ from: o, to: e }), i += e - o), { total: i, ranges: r };
}
function Pb({ total: t, ranges: e }, n) {
  if (n <= 0)
    return e[0].from;
  if (n >= 1)
    return e[e.length - 1].to;
  let r = Math.floor(t * n);
  for (let o = 0; ; o++) {
    let { from: i, to: s } = e[o], a = s - i;
    if (r <= a)
      return i + r;
    r -= a;
  }
}
function $b(t, e) {
  let n = 0;
  for (let { from: r, to: o } of t.ranges) {
    if (e <= o) {
      n += e - r;
      break;
    }
    n += o - r;
  }
  return n / t.total;
}
function m9e(t, e) {
  for (let n of t)
    if (e(n))
      return n;
}
const DB = {
  toDOM(t) {
    return t;
  },
  fromDOM(t) {
    return t;
  },
  scale: 1,
  eq(t) {
    return t == this;
  }
};
class lL {
  constructor(e, n, r) {
    let o = 0, i = 0, s = 0;
    this.viewports = r.map(({ from: a, to: l }) => {
      let c = n.lineAt(a, Yn.ByPos, e, 0, 0).top, u = n.lineAt(l, Yn.ByPos, e, 0, 0).bottom;
      return o += u - c, { from: a, to: l, top: c, bottom: u, domTop: 0, domBottom: 0 };
    }), this.scale = (7e6 - o) / (n.height - o);
    for (let a of this.viewports)
      a.domTop = s + (a.top - i) * this.scale, s = a.domBottom = a.domTop + (a.bottom - a.top), i = a.bottom;
  }
  toDOM(e) {
    for (let n = 0, r = 0, o = 0; ; n++) {
      let i = n < this.viewports.length ? this.viewports[n] : null;
      if (!i || e < i.top)
        return o + (e - r) * this.scale;
      if (e <= i.bottom)
        return i.domTop + (e - i.top);
      r = i.bottom, o = i.domBottom;
    }
  }
  fromDOM(e) {
    for (let n = 0, r = 0, o = 0; ; n++) {
      let i = n < this.viewports.length ? this.viewports[n] : null;
      if (!i || e < i.domTop)
        return r + (e - o) / this.scale;
      if (e <= i.domBottom)
        return i.top + (e - i.domTop);
      r = i.bottom, o = i.domBottom;
    }
  }
  eq(e) {
    return e instanceof lL ? this.scale == e.scale && this.viewports.length == e.viewports.length && this.viewports.every((n, r) => n.from == e.viewports[r].from && n.to == e.viewports[r].to) : !1;
  }
}
function bg(t, e) {
  if (e.scale == 1)
    return t;
  let n = e.toDOM(t.top), r = e.toDOM(t.bottom);
  return new Oc(t.from, t.length, n, r - n, Array.isArray(t._content) ? t._content.map((o) => bg(o, e)) : t._content);
}
const Mb = /* @__PURE__ */ lt.define({ combine: (t) => t.join(" ") }), aN = /* @__PURE__ */ lt.define({ combine: (t) => t.indexOf(!0) > -1 }), lN = /* @__PURE__ */ Qc.newName(), Cde = /* @__PURE__ */ Qc.newName(), kde = /* @__PURE__ */ Qc.newName(), Ade = { "&light": "." + Cde, "&dark": "." + kde };
function cN(t, e, n) {
  return new Qc(e, {
    finish(r) {
      return /&/.test(r) ? r.replace(/&\w*/, (o) => {
        if (o == "&")
          return t;
        if (!n || !n[o])
          throw new RangeError(`Unsupported selector: ${o}`);
        return n[o];
      }) : t + " " + r;
    }
  });
}
const g9e = /* @__PURE__ */ cN("." + lN, {
  "&": {
    position: "relative !important",
    boxSizing: "border-box",
    "&.cm-focused": {
      // Provide a simple default outline to make sure a focused
      // editor is visually distinct. Can't leave the default behavior
      // because that will apply to the content element, which is
      // inside the scrollable container and doesn't include the
      // gutters. We also can't use an 'auto' outline, since those
      // are, for some reason, drawn behind the element content, which
      // will cause things like the active line background to cover
      // the outline (#297).
      outline: "1px dotted #212121"
    },
    display: "flex !important",
    flexDirection: "column"
  },
  ".cm-scroller": {
    display: "flex !important",
    alignItems: "flex-start !important",
    fontFamily: "monospace",
    lineHeight: 1.4,
    height: "100%",
    overflowX: "auto",
    position: "relative",
    zIndex: 0,
    overflowAnchor: "none"
  },
  ".cm-content": {
    margin: 0,
    flexGrow: 2,
    flexShrink: 0,
    display: "block",
    whiteSpace: "pre",
    wordWrap: "normal",
    // https://github.com/codemirror/dev/issues/456
    boxSizing: "border-box",
    minHeight: "100%",
    padding: "4px 0",
    outline: "none",
    "&[contenteditable=true]": {
      WebkitUserModify: "read-write-plaintext-only"
    }
  },
  ".cm-lineWrapping": {
    whiteSpace_fallback: "pre-wrap",
    // For IE
    whiteSpace: "break-spaces",
    wordBreak: "break-word",
    // For Safari, which doesn't support overflow-wrap: anywhere
    overflowWrap: "anywhere",
    flexShrink: 1
  },
  "&light .cm-content": { caretColor: "black" },
  "&dark .cm-content": { caretColor: "white" },
  ".cm-line": {
    display: "block",
    padding: "0 2px 0 6px"
  },
  ".cm-layer": {
    position: "absolute",
    left: 0,
    top: 0,
    contain: "size style",
    "& > *": {
      position: "absolute"
    }
  },
  "&light .cm-selectionBackground": {
    background: "#d9d9d9"
  },
  "&dark .cm-selectionBackground": {
    background: "#222"
  },
  "&light.cm-focused > .cm-scroller > .cm-selectionLayer .cm-selectionBackground": {
    background: "#d7d4f0"
  },
  "&dark.cm-focused > .cm-scroller > .cm-selectionLayer .cm-selectionBackground": {
    background: "#233"
  },
  ".cm-cursorLayer": {
    pointerEvents: "none"
  },
  "&.cm-focused > .cm-scroller > .cm-cursorLayer": {
    animation: "steps(1) cm-blink 1.2s infinite"
  },
  // Two animations defined so that we can switch between them to
  // restart the animation without forcing another style
  // recomputation.
  "@keyframes cm-blink": { "0%": {}, "50%": { opacity: 0 }, "100%": {} },
  "@keyframes cm-blink2": { "0%": {}, "50%": { opacity: 0 }, "100%": {} },
  ".cm-cursor, .cm-dropCursor": {
    borderLeft: "1.2px solid black",
    marginLeft: "-0.6px",
    pointerEvents: "none"
  },
  ".cm-cursor": {
    display: "none"
  },
  "&dark .cm-cursor": {
    borderLeftColor: "#ddd"
  },
  ".cm-dropCursor": {
    position: "absolute"
  },
  "&.cm-focused > .cm-scroller > .cm-cursorLayer .cm-cursor": {
    display: "block"
  },
  ".cm-iso": {
    unicodeBidi: "isolate"
  },
  ".cm-announced": {
    position: "fixed",
    top: "-10000px"
  },
  "@media print": {
    ".cm-announced": { display: "none" }
  },
  "&light .cm-activeLine": { backgroundColor: "#cceeff44" },
  "&dark .cm-activeLine": { backgroundColor: "#99eeff33" },
  "&light .cm-specialChar": { color: "red" },
  "&dark .cm-specialChar": { color: "#f78" },
  ".cm-gutters": {
    flexShrink: 0,
    display: "flex",
    height: "100%",
    boxSizing: "border-box",
    insetInlineStart: 0,
    zIndex: 200
  },
  "&light .cm-gutters": {
    backgroundColor: "#f5f5f5",
    color: "#6c6c6c",
    borderRight: "1px solid #ddd"
  },
  "&dark .cm-gutters": {
    backgroundColor: "#333338",
    color: "#ccc"
  },
  ".cm-gutter": {
    display: "flex !important",
    // Necessary -- prevents margin collapsing
    flexDirection: "column",
    flexShrink: 0,
    boxSizing: "border-box",
    minHeight: "100%",
    overflow: "hidden"
  },
  ".cm-gutterElement": {
    boxSizing: "border-box"
  },
  ".cm-lineNumbers .cm-gutterElement": {
    padding: "0 3px 0 5px",
    minWidth: "20px",
    textAlign: "right",
    whiteSpace: "nowrap"
  },
  "&light .cm-activeLineGutter": {
    backgroundColor: "#e2f2ff"
  },
  "&dark .cm-activeLineGutter": {
    backgroundColor: "#222227"
  },
  ".cm-panels": {
    boxSizing: "border-box",
    position: "sticky",
    left: 0,
    right: 0,
    zIndex: 300
  },
  "&light .cm-panels": {
    backgroundColor: "#f5f5f5",
    color: "black"
  },
  "&light .cm-panels-top": {
    borderBottom: "1px solid #ddd"
  },
  "&light .cm-panels-bottom": {
    borderTop: "1px solid #ddd"
  },
  "&dark .cm-panels": {
    backgroundColor: "#333338",
    color: "white"
  },
  ".cm-tab": {
    display: "inline-block",
    overflow: "hidden",
    verticalAlign: "bottom"
  },
  ".cm-widgetBuffer": {
    verticalAlign: "text-top",
    height: "1em",
    width: 0,
    display: "inline"
  },
  ".cm-placeholder": {
    color: "#888",
    display: "inline-block",
    verticalAlign: "top"
  },
  ".cm-highlightSpace": {
    backgroundImage: "radial-gradient(circle at 50% 55%, #aaa 20%, transparent 5%)",
    backgroundPosition: "center"
  },
  ".cm-highlightTab": {
    backgroundImage: `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="200" height="20"><path stroke="%23888" stroke-width="1" fill="none" d="M1 10H196L190 5M190 15L196 10M197 4L197 16"/></svg>')`,
    backgroundSize: "auto 100%",
    backgroundPosition: "right 90%",
    backgroundRepeat: "no-repeat"
  },
  ".cm-trailingSpace": {
    backgroundColor: "#ff332255"
  },
  ".cm-button": {
    verticalAlign: "middle",
    color: "inherit",
    fontSize: "70%",
    padding: ".2em 1em",
    borderRadius: "1px"
  },
  "&light .cm-button": {
    backgroundImage: "linear-gradient(#eff1f5, #d9d9df)",
    border: "1px solid #888",
    "&:active": {
      backgroundImage: "linear-gradient(#b4b4b4, #d0d3d6)"
    }
  },
  "&dark .cm-button": {
    backgroundImage: "linear-gradient(#393939, #111)",
    border: "1px solid #888",
    "&:active": {
      backgroundImage: "linear-gradient(#111, #333)"
    }
  },
  ".cm-textfield": {
    verticalAlign: "middle",
    color: "inherit",
    fontSize: "70%",
    border: "1px solid silver",
    padding: ".2em .5em"
  },
  "&light .cm-textfield": {
    backgroundColor: "white"
  },
  "&dark .cm-textfield": {
    border: "1px solid #555",
    backgroundColor: "inherit"
  }
}, Ade), y9e = {
  childList: !0,
  characterData: !0,
  subtree: !0,
  attributes: !0,
  characterDataOldValue: !0
}, nk = rt.ie && rt.ie_version <= 11;
class v9e {
  constructor(e) {
    this.view = e, this.active = !1, this.editContext = null, this.selectionRange = new t6e(), this.selectionChanged = !1, this.delayedFlush = -1, this.resizeTimeout = -1, this.queue = [], this.delayedAndroidKey = null, this.flushingAndroidKey = -1, this.lastChange = 0, this.scrollTargets = [], this.intersection = null, this.resizeScroll = null, this.intersecting = !1, this.gapIntersection = null, this.gaps = [], this.printQuery = null, this.parentCheck = -1, this.dom = e.contentDOM, this.observer = new MutationObserver((n) => {
      for (let r of n)
        this.queue.push(r);
      (rt.ie && rt.ie_version <= 11 || rt.ios && e.composing) && n.some((r) => r.type == "childList" && r.removedNodes.length || r.type == "characterData" && r.oldValue.length > r.target.nodeValue.length) ? this.flushSoon() : this.flush();
    }), window.EditContext && e.constructor.EDIT_CONTEXT !== !1 && // Chrome <126 doesn't support inverted selections in edit context (#1392)
    !(rt.chrome && rt.chrome_version < 126) && (this.editContext = new _9e(e), e.state.facet(pl) && (e.contentDOM.editContext = this.editContext.editContext)), nk && (this.onCharData = (n) => {
      this.queue.push({
        target: n.target,
        type: "characterData",
        oldValue: n.prevValue
      }), this.flushSoon();
    }), this.onSelectionChange = this.onSelectionChange.bind(this), this.onResize = this.onResize.bind(this), this.onPrint = this.onPrint.bind(this), this.onScroll = this.onScroll.bind(this), window.matchMedia && (this.printQuery = window.matchMedia("print")), typeof ResizeObserver == "function" && (this.resizeScroll = new ResizeObserver(() => {
      var n;
      ((n = this.view.docView) === null || n === void 0 ? void 0 : n.lastUpdate) < Date.now() - 75 && this.onResize();
    }), this.resizeScroll.observe(e.scrollDOM)), this.addWindowListeners(this.win = e.win), this.start(), typeof IntersectionObserver == "function" && (this.intersection = new IntersectionObserver((n) => {
      this.parentCheck < 0 && (this.parentCheck = setTimeout(this.listenForScroll.bind(this), 1e3)), n.length > 0 && n[n.length - 1].intersectionRatio > 0 != this.intersecting && (this.intersecting = !this.intersecting, this.intersecting != this.view.inView && this.onScrollChanged(document.createEvent("Event")));
    }, { threshold: [0, 1e-3] }), this.intersection.observe(this.dom), this.gapIntersection = new IntersectionObserver((n) => {
      n.length > 0 && n[n.length - 1].intersectionRatio > 0 && this.onScrollChanged(document.createEvent("Event"));
    }, {})), this.listenForScroll(), this.readSelectionRange();
  }
  onScrollChanged(e) {
    this.view.inputState.runHandlers("scroll", e), this.intersecting && this.view.measure();
  }
  onScroll(e) {
    this.intersecting && this.flush(!1), this.editContext && this.view.requestMeasure(this.editContext.measureReq), this.onScrollChanged(e);
  }
  onResize() {
    this.resizeTimeout < 0 && (this.resizeTimeout = setTimeout(() => {
      this.resizeTimeout = -1, this.view.requestMeasure();
    }, 50));
  }
  onPrint(e) {
    (e.type == "change" || !e.type) && !e.matches || (this.view.viewState.printing = !0, this.view.measure(), setTimeout(() => {
      this.view.viewState.printing = !1, this.view.requestMeasure();
    }, 500));
  }
  updateGaps(e) {
    if (this.gapIntersection && (e.length != this.gaps.length || this.gaps.some((n, r) => n != e[r]))) {
      this.gapIntersection.disconnect();
      for (let n of e)
        this.gapIntersection.observe(n);
      this.gaps = e;
    }
  }
  onSelectionChange(e) {
    let n = this.selectionChanged;
    if (!this.readSelectionRange() || this.delayedAndroidKey)
      return;
    let { view: r } = this, o = this.selectionRange;
    if (r.state.facet(pl) ? r.root.activeElement != this.dom : !cw(this.dom, o))
      return;
    let i = o.anchorNode && r.docView.nearest(o.anchorNode);
    if (i && i.ignoreEvent(e)) {
      n || (this.selectionChanged = !1);
      return;
    }
    (rt.ie && rt.ie_version <= 11 || rt.android && rt.chrome) && !r.state.selection.main.empty && // (Selection.isCollapsed isn't reliable on IE)
    o.focusNode && e0(o.focusNode, o.focusOffset, o.anchorNode, o.anchorOffset) ? this.flushSoon() : this.flush(!1);
  }
  readSelectionRange() {
    let { view: e } = this, n = G0(e.root);
    if (!n)
      return !1;
    let r = rt.safari && e.root.nodeType == 11 && e.root.activeElement == this.dom && b9e(this.view, n) || n;
    if (!r || this.selectionRange.eq(r))
      return !1;
    let o = cw(this.dom, r);
    return o && !this.selectionChanged && e.inputState.lastFocusTime > Date.now() - 200 && e.inputState.lastTouchTime < Date.now() - 300 && r6e(this.dom, r) ? (this.view.inputState.lastFocusTime = 0, e.docView.updateSelection(), !1) : (this.selectionRange.setRange(r), o && (this.selectionChanged = !0), !0);
  }
  setSelectionRange(e, n) {
    this.selectionRange.set(e.node, e.offset, n.node, n.offset), this.selectionChanged = !1;
  }
  clearSelectionRange() {
    this.selectionRange.set(null, 0, null, 0);
  }
  listenForScroll() {
    this.parentCheck = -1;
    let e = 0, n = null;
    for (let r = this.dom; r; )
      if (r.nodeType == 1)
        !n && e < this.scrollTargets.length && this.scrollTargets[e] == r ? e++ : n || (n = this.scrollTargets.slice(0, e)), n && n.push(r), r = r.assignedSlot || r.parentNode;
      else if (r.nodeType == 11)
        r = r.host;
      else
        break;
    if (e < this.scrollTargets.length && !n && (n = this.scrollTargets.slice(0, e)), n) {
      for (let r of this.scrollTargets)
        r.removeEventListener("scroll", this.onScroll);
      for (let r of this.scrollTargets = n)
        r.addEventListener("scroll", this.onScroll);
    }
  }
  ignore(e) {
    if (!this.active)
      return e();
    try {
      return this.stop(), e();
    } finally {
      this.start(), this.clear();
    }
  }
  start() {
    this.active || (this.observer.observe(this.dom, y9e), nk && this.dom.addEventListener("DOMCharacterDataModified", this.onCharData), this.active = !0);
  }
  stop() {
    this.active && (this.active = !1, this.observer.disconnect(), nk && this.dom.removeEventListener("DOMCharacterDataModified", this.onCharData));
  }
  // Throw away any pending changes
  clear() {
    this.processRecords(), this.queue.length = 0, this.selectionChanged = !1;
  }
  // Chrome Android, especially in combination with GBoard, not only
  // doesn't reliably fire regular key events, but also often
  // surrounds the effect of enter or backspace with a bunch of
  // composition events that, when interrupted, cause text duplication
  // or other kinds of corruption. This hack makes the editor back off
  // from handling DOM changes for a moment when such a key is
  // detected (via beforeinput or keydown), and then tries to flush
  // them or, if that has no effect, dispatches the given key.
  delayAndroidKey(e, n) {
    var r;
    if (!this.delayedAndroidKey) {
      let o = () => {
        let i = this.delayedAndroidKey;
        i && (this.clearDelayedAndroidKey(), this.view.inputState.lastKeyCode = i.keyCode, this.view.inputState.lastKeyTime = Date.now(), !this.flush() && i.force && gh(this.dom, i.key, i.keyCode));
      };
      this.flushingAndroidKey = this.view.win.requestAnimationFrame(o);
    }
    (!this.delayedAndroidKey || e == "Enter") && (this.delayedAndroidKey = {
      key: e,
      keyCode: n,
      // Only run the key handler when no changes are detected if
      // this isn't coming right after another change, in which case
      // it is probably part of a weird chain of updates, and should
      // be ignored if it returns the DOM to its previous state.
      force: this.lastChange < Date.now() - 50 || !!(!((r = this.delayedAndroidKey) === null || r === void 0) && r.force)
    });
  }
  clearDelayedAndroidKey() {
    this.win.cancelAnimationFrame(this.flushingAndroidKey), this.delayedAndroidKey = null, this.flushingAndroidKey = -1;
  }
  flushSoon() {
    this.delayedFlush < 0 && (this.delayedFlush = this.view.win.requestAnimationFrame(() => {
      this.delayedFlush = -1, this.flush();
    }));
  }
  forceFlush() {
    this.delayedFlush >= 0 && (this.view.win.cancelAnimationFrame(this.delayedFlush), this.delayedFlush = -1), this.flush();
  }
  pendingRecords() {
    for (let e of this.observer.takeRecords())
      this.queue.push(e);
    return this.queue;
  }
  processRecords() {
    let e = this.pendingRecords();
    e.length && (this.queue = []);
    let n = -1, r = -1, o = !1;
    for (let i of e) {
      let s = this.readMutation(i);
      s && (s.typeOver && (o = !0), n == -1 ? { from: n, to: r } = s : (n = Math.min(s.from, n), r = Math.max(s.to, r)));
    }
    return { from: n, to: r, typeOver: o };
  }
  readChange() {
    let { from: e, to: n, typeOver: r } = this.processRecords(), o = this.selectionChanged && cw(this.dom, this.selectionRange);
    if (e < 0 && !o)
      return null;
    e > -1 && (this.lastChange = Date.now()), this.view.inputState.lastFocusTime = 0, this.selectionChanged = !1;
    let i = new N6e(this.view, e, n, r);
    return this.view.docView.domChanged = { newSel: i.newSel ? i.newSel.main : null }, i;
  }
  // Apply pending changes, if any
  flush(e = !0) {
    if (this.delayedFlush >= 0 || this.delayedAndroidKey)
      return !1;
    e && this.readSelectionRange();
    let n = this.readChange();
    if (!n)
      return this.view.requestMeasure(), !1;
    let r = this.view.state, o = mde(this.view, n);
    return this.view.state == r && (n.domChanged || n.newSel && !n.newSel.main.eq(this.view.state.selection.main)) && this.view.update([]), o;
  }
  readMutation(e) {
    let n = this.view.docView.nearest(e.target);
    if (!n || n.ignoreMutation(e))
      return null;
    if (n.markDirty(e.type == "attributes"), e.type == "attributes" && (n.flags |= 4), e.type == "childList") {
      let r = IB(n, e.previousSibling || e.target.previousSibling, -1), o = IB(n, e.nextSibling || e.target.nextSibling, 1);
      return {
        from: r ? n.posAfter(r) : n.posAtStart,
        to: o ? n.posBefore(o) : n.posAtEnd,
        typeOver: !1
      };
    } else return e.type == "characterData" ? { from: n.posAtStart, to: n.posAtEnd, typeOver: e.target.nodeValue == e.oldValue } : null;
  }
  setWindow(e) {
    e != this.win && (this.removeWindowListeners(this.win), this.win = e, this.addWindowListeners(this.win));
  }
  addWindowListeners(e) {
    e.addEventListener("resize", this.onResize), this.printQuery ? this.printQuery.addEventListener ? this.printQuery.addEventListener("change", this.onPrint) : this.printQuery.addListener(this.onPrint) : e.addEventListener("beforeprint", this.onPrint), e.addEventListener("scroll", this.onScroll), e.document.addEventListener("selectionchange", this.onSelectionChange);
  }
  removeWindowListeners(e) {
    e.removeEventListener("scroll", this.onScroll), e.removeEventListener("resize", this.onResize), this.printQuery ? this.printQuery.removeEventListener ? this.printQuery.removeEventListener("change", this.onPrint) : this.printQuery.removeListener(this.onPrint) : e.removeEventListener("beforeprint", this.onPrint), e.document.removeEventListener("selectionchange", this.onSelectionChange);
  }
  update(e) {
    this.editContext && (this.editContext.update(e), e.startState.facet(pl) != e.state.facet(pl) && (e.view.contentDOM.editContext = e.state.facet(pl) ? this.editContext.editContext : null));
  }
  destroy() {
    var e, n, r;
    this.stop(), (e = this.intersection) === null || e === void 0 || e.disconnect(), (n = this.gapIntersection) === null || n === void 0 || n.disconnect(), (r = this.resizeScroll) === null || r === void 0 || r.disconnect();
    for (let o of this.scrollTargets)
      o.removeEventListener("scroll", this.onScroll);
    this.removeWindowListeners(this.win), clearTimeout(this.parentCheck), clearTimeout(this.resizeTimeout), this.win.cancelAnimationFrame(this.delayedFlush), this.win.cancelAnimationFrame(this.flushingAndroidKey), this.editContext && (this.view.contentDOM.editContext = null, this.editContext.destroy());
  }
}
function IB(t, e, n) {
  for (; e; ) {
    let r = tr.get(e);
    if (r && r.parent == t)
      return r;
    let o = e.parentNode;
    e = o != t.dom ? o : n > 0 ? e.nextSibling : e.previousSibling;
  }
  return null;
}
function NB(t, e) {
  let n = e.startContainer, r = e.startOffset, o = e.endContainer, i = e.endOffset, s = t.docView.domAtPos(t.state.selection.main.anchor);
  return e0(s.node, s.offset, o, i) && ([n, r, o, i] = [o, i, n, r]), { anchorNode: n, anchorOffset: r, focusNode: o, focusOffset: i };
}
function b9e(t, e) {
  if (e.getComposedRanges) {
    let o = e.getComposedRanges(t.root)[0];
    if (o)
      return NB(t, o);
  }
  let n = null;
  function r(o) {
    o.preventDefault(), o.stopImmediatePropagation(), n = o.getTargetRanges()[0];
  }
  return t.contentDOM.addEventListener("beforeinput", r, !0), t.dom.ownerDocument.execCommand("indent"), t.contentDOM.removeEventListener("beforeinput", r, !0), n ? NB(t, n) : null;
}
class _9e {
  constructor(e) {
    this.from = 0, this.to = 0, this.pendingContextChange = null, this.handlers = /* @__PURE__ */ Object.create(null), this.composing = null, this.resetRange(e.state);
    let n = this.editContext = new window.EditContext({
      text: e.state.doc.sliceString(this.from, this.to),
      selectionStart: this.toContextPos(Math.max(this.from, Math.min(this.to, e.state.selection.main.anchor))),
      selectionEnd: this.toContextPos(e.state.selection.main.head)
    });
    this.handlers.textupdate = (r) => {
      let o = e.state.selection.main, { anchor: i, head: s } = o, a = this.toEditorPos(r.updateRangeStart), l = this.toEditorPos(r.updateRangeEnd);
      e.inputState.composing >= 0 && !this.composing && (this.composing = { contextBase: r.updateRangeStart, editorBase: a, drifted: !1 });
      let c = { from: a, to: l, insert: ln.of(r.text.split(`
`)) };
      if (c.from == this.from && i < this.from ? c.from = i : c.to == this.to && i > this.to && (c.to = i), c.from == c.to && !c.insert.length) {
        let u = $e.single(this.toEditorPos(r.selectionStart), this.toEditorPos(r.selectionEnd));
        u.main.eq(o) || e.dispatch({ selection: u, userEvent: "select" });
        return;
      }
      if ((rt.mac || rt.android) && c.from == s - 1 && /^\. ?$/.test(r.text) && e.contentDOM.getAttribute("autocorrect") == "off" && (c = { from: a, to: l, insert: ln.of([r.text.replace(".", " ")]) }), this.pendingContextChange = c, !e.state.readOnly) {
        let u = this.to - this.from + (c.to - c.from + c.insert.length);
        sL(e, c, $e.single(this.toEditorPos(r.selectionStart, u), this.toEditorPos(r.selectionEnd, u)));
      }
      this.pendingContextChange && (this.revertPending(e.state), this.setSelection(e.state));
    }, this.handlers.characterboundsupdate = (r) => {
      let o = [], i = null;
      for (let s = this.toEditorPos(r.rangeStart), a = this.toEditorPos(r.rangeEnd); s < a; s++) {
        let l = e.coordsForChar(s);
        i = l && new DOMRect(l.left, l.top, l.right - l.left, l.bottom - l.top) || i || new DOMRect(), o.push(i);
      }
      n.updateCharacterBounds(r.rangeStart, o);
    }, this.handlers.textformatupdate = (r) => {
      let o = [];
      for (let i of r.getTextFormats()) {
        let s = i.underlineStyle, a = i.underlineThickness;
        if (s != "None" && a != "None") {
          let l = this.toEditorPos(i.rangeStart), c = this.toEditorPos(i.rangeEnd);
          if (l < c) {
            let u = `text-decoration: underline ${s == "Dashed" ? "dashed " : s == "Squiggle" ? "wavy " : ""}${a == "Thin" ? 1 : 2}px`;
            o.push(ut.mark({ attributes: { style: u } }).range(l, c));
          }
        }
      }
      e.dispatch({ effects: lde.of(ut.set(o)) });
    }, this.handlers.compositionstart = () => {
      e.inputState.composing < 0 && (e.inputState.composing = 0, e.inputState.compositionFirstChange = !0);
    }, this.handlers.compositionend = () => {
      if (e.inputState.composing = -1, e.inputState.compositionFirstChange = null, this.composing) {
        let { drifted: r } = this.composing;
        this.composing = null, r && this.reset(e.state);
      }
    };
    for (let r in this.handlers)
      n.addEventListener(r, this.handlers[r]);
    this.measureReq = { read: (r) => {
      this.editContext.updateControlBounds(r.contentDOM.getBoundingClientRect());
      let o = G0(r.root);
      o && o.rangeCount && this.editContext.updateSelectionBounds(o.getRangeAt(0).getBoundingClientRect());
    } };
  }
  applyEdits(e) {
    let n = 0, r = !1, o = this.pendingContextChange;
    return e.changes.iterChanges((i, s, a, l, c) => {
      if (r)
        return;
      let u = c.length - (s - i);
      if (o && s >= o.to)
        if (o.from == i && o.to == s && o.insert.eq(c)) {
          o = this.pendingContextChange = null, n += u, this.to += u;
          return;
        } else
          o = null, this.revertPending(e.state);
      if (i += n, s += n, s <= this.from)
        this.from += u, this.to += u;
      else if (i < this.to) {
        if (i < this.from || s > this.to || this.to - this.from + c.length > 3e4) {
          r = !0;
          return;
        }
        this.editContext.updateText(this.toContextPos(i), this.toContextPos(s), c.toString()), this.to += u;
      }
      n += u;
    }), o && !r && this.revertPending(e.state), !r;
  }
  update(e) {
    let n = this.pendingContextChange;
    this.composing && (this.composing.drifted || e.transactions.some((r) => !r.isUserEvent("input.type") && r.changes.touchesRange(this.from, this.to))) ? (this.composing.drifted = !0, this.composing.editorBase = e.changes.mapPos(this.composing.editorBase)) : !this.applyEdits(e) || !this.rangeIsValid(e.state) ? (this.pendingContextChange = null, this.reset(e.state)) : (e.docChanged || e.selectionSet || n) && this.setSelection(e.state), (e.geometryChanged || e.docChanged || e.selectionSet) && e.view.requestMeasure(this.measureReq);
  }
  resetRange(e) {
    let { head: n } = e.selection.main;
    this.from = Math.max(
      0,
      n - 1e4
      /* CxVp.Margin */
    ), this.to = Math.min(
      e.doc.length,
      n + 1e4
      /* CxVp.Margin */
    );
  }
  reset(e) {
    this.resetRange(e), this.editContext.updateText(0, this.editContext.text.length, e.doc.sliceString(this.from, this.to)), this.setSelection(e);
  }
  revertPending(e) {
    let n = this.pendingContextChange;
    this.pendingContextChange = null, this.editContext.updateText(this.toContextPos(n.from), this.toContextPos(n.from + n.insert.length), e.doc.sliceString(n.from, n.to));
  }
  setSelection(e) {
    let { main: n } = e.selection, r = this.toContextPos(Math.max(this.from, Math.min(this.to, n.anchor))), o = this.toContextPos(n.head);
    (this.editContext.selectionStart != r || this.editContext.selectionEnd != o) && this.editContext.updateSelection(r, o);
  }
  rangeIsValid(e) {
    let { head: n } = e.selection.main;
    return !(this.from > 0 && n - this.from < 500 || this.to < e.doc.length && this.to - n < 500 || this.to - this.from > 1e4 * 3);
  }
  toEditorPos(e, n = this.to - this.from) {
    e = Math.min(e, n);
    let r = this.composing;
    return r && r.drifted ? r.editorBase + (e - r.contextBase) : e + this.from;
  }
  toContextPos(e) {
    let n = this.composing;
    return n && n.drifted ? n.contextBase + (e - n.editorBase) : e - this.from;
  }
  destroy() {
    for (let e in this.handlers)
      this.editContext.removeEventListener(e, this.handlers[e]);
  }
}
class et {
  /**
  The current editor state.
  */
  get state() {
    return this.viewState.state;
  }
  /**
  To be able to display large documents without consuming too much
  memory or overloading the browser, CodeMirror only draws the
  code that is visible (plus a margin around it) to the DOM. This
  property tells you the extent of the current drawn viewport, in
  document positions.
  */
  get viewport() {
    return this.viewState.viewport;
  }
  /**
  When there are, for example, large collapsed ranges in the
  viewport, its size can be a lot bigger than the actual visible
  content. Thus, if you are doing something like styling the
  content in the viewport, it is preferable to only do so for
  these ranges, which are the subset of the viewport that is
  actually drawn.
  */
  get visibleRanges() {
    return this.viewState.visibleRanges;
  }
  /**
  Returns false when the editor is entirely scrolled out of view
  or otherwise hidden.
  */
  get inView() {
    return this.viewState.inView;
  }
  /**
  Indicates whether the user is currently composing text via
  [IME](https://en.wikipedia.org/wiki/Input_method), and at least
  one change has been made in the current composition.
  */
  get composing() {
    return this.inputState.composing > 0;
  }
  /**
  Indicates whether the user is currently in composing state. Note
  that on some platforms, like Android, this will be the case a
  lot, since just putting the cursor on a word starts a
  composition there.
  */
  get compositionStarted() {
    return this.inputState.composing >= 0;
  }
  /**
  The document or shadow root that the view lives in.
  */
  get root() {
    return this._root;
  }
  /**
  @internal
  */
  get win() {
    return this.dom.ownerDocument.defaultView || window;
  }
  /**
  Construct a new view. You'll want to either provide a `parent`
  option, or put `view.dom` into your document after creating a
  view, so that the user can see the editor.
  */
  constructor(e = {}) {
    var n;
    this.plugins = [], this.pluginMap = /* @__PURE__ */ new Map(), this.editorAttrs = {}, this.contentAttrs = {}, this.bidiCache = [], this.destroyed = !1, this.updateState = 2, this.measureScheduled = -1, this.measureRequests = [], this.contentDOM = document.createElement("div"), this.scrollDOM = document.createElement("div"), this.scrollDOM.tabIndex = -1, this.scrollDOM.className = "cm-scroller", this.scrollDOM.appendChild(this.contentDOM), this.announceDOM = document.createElement("div"), this.announceDOM.className = "cm-announced", this.announceDOM.setAttribute("aria-live", "polite"), this.dom = document.createElement("div"), this.dom.appendChild(this.announceDOM), this.dom.appendChild(this.scrollDOM), e.parent && e.parent.appendChild(this.dom);
    let { dispatch: r } = e;
    this.dispatchTransactions = e.dispatchTransactions || r && ((o) => o.forEach((i) => r(i, this))) || ((o) => this.update(o)), this.dispatch = this.dispatch.bind(this), this._root = e.root || n6e(e.parent) || document, this.viewState = new MB(e.state || qt.create(e)), e.scrollTo && e.scrollTo.is(kb) && (this.viewState.scrollTarget = e.scrollTo.value.clip(this.viewState.state)), this.plugins = this.state.facet(gg).map((o) => new ZC(o));
    for (let o of this.plugins)
      o.update(this);
    this.observer = new v9e(this), this.inputState = new z6e(this), this.inputState.ensureHandlers(this.plugins), this.docView = new pB(this), this.mountStyles(), this.updateAttrs(), this.updateState = 0, this.requestMeasure(), !((n = document.fonts) === null || n === void 0) && n.ready && document.fonts.ready.then(() => this.requestMeasure());
  }
  dispatch(...e) {
    let n = e.length == 1 && e[0] instanceof Zo ? e : e.length == 1 && Array.isArray(e[0]) ? e[0] : [this.state.update(...e)];
    this.dispatchTransactions(n, this);
  }
  /**
  Update the view for the given array of transactions. This will
  update the visible document and selection to match the state
  produced by the transactions, and notify view plugins of the
  change. You should usually call
  [`dispatch`](https://codemirror.net/6/docs/ref/#view.EditorView.dispatch) instead, which uses this
  as a primitive.
  */
  update(e) {
    if (this.updateState != 0)
      throw new Error("Calls to EditorView.update are not allowed while an update is in progress");
    let n = !1, r = !1, o, i = this.state;
    for (let f of e) {
      if (f.startState != i)
        throw new RangeError("Trying to update state with a transaction that doesn't start from the previous state.");
      i = f.state;
    }
    if (this.destroyed) {
      this.viewState.state = i;
      return;
    }
    let s = this.hasFocus, a = 0, l = null;
    e.some((f) => f.annotation(wde)) ? (this.inputState.notifiedFocused = s, a = 1) : s != this.inputState.notifiedFocused && (this.inputState.notifiedFocused = s, l = xde(i, s), l || (a = 1));
    let c = this.observer.delayedAndroidKey, u = null;
    if (c ? (this.observer.clearDelayedAndroidKey(), u = this.observer.readChange(), (u && !this.state.doc.eq(i.doc) || !this.state.selection.eq(i.selection)) && (u = null)) : this.observer.clear(), i.facet(qt.phrases) != this.state.facet(qt.phrases))
      return this.setState(i);
    o = xx.create(this, i, e), o.flags |= a;
    let d = this.viewState.scrollTarget;
    try {
      this.updateState = 2;
      for (let f of e) {
        if (d && (d = d.map(f.changes)), f.scrollIntoView) {
          let { main: h } = f.state.selection;
          d = new yh(h.empty ? h : $e.cursor(h.head, h.head > h.anchor ? -1 : 1));
        }
        for (let h of f.effects)
          h.is(kb) && (d = h.value.clip(this.state));
      }
      this.viewState.update(o, d), this.bidiCache = Sx.update(this.bidiCache, o.changes), o.empty || (this.updatePlugins(o), this.inputState.update(o)), n = this.docView.update(o), this.state.facet(yg) != this.styleModules && this.mountStyles(), r = this.updateAttrs(), this.showAnnouncements(e), this.docView.updateSelection(n, e.some((f) => f.isUserEvent("select.pointer")));
    } finally {
      this.updateState = 0;
    }
    if (o.startState.facet(Mb) != o.state.facet(Mb) && (this.viewState.mustMeasureContent = !0), (n || r || d || this.viewState.mustEnforceCursorAssoc || this.viewState.mustMeasureContent) && this.requestMeasure(), n && this.docViewUpdate(), !o.empty)
      for (let f of this.state.facet(tN))
        try {
          f(o);
        } catch (h) {
          Wo(this.state, h, "update listener");
        }
    (l || u) && Promise.resolve().then(() => {
      l && this.state == l.startState && this.dispatch(l), u && !mde(this, u) && c.force && gh(this.contentDOM, c.key, c.keyCode);
    });
  }
  /**
  Reset the view to the given state. (This will cause the entire
  document to be redrawn and all view plugins to be reinitialized,
  so you should probably only use it when the new state isn't
  derived from the old state. Otherwise, use
  [`dispatch`](https://codemirror.net/6/docs/ref/#view.EditorView.dispatch) instead.)
  */
  setState(e) {
    if (this.updateState != 0)
      throw new Error("Calls to EditorView.setState are not allowed while an update is in progress");
    if (this.destroyed) {
      this.viewState.state = e;
      return;
    }
    this.updateState = 2;
    let n = this.hasFocus;
    try {
      for (let r of this.plugins)
        r.destroy(this);
      this.viewState = new MB(e), this.plugins = e.facet(gg).map((r) => new ZC(r)), this.pluginMap.clear();
      for (let r of this.plugins)
        r.update(this);
      this.docView.destroy(), this.docView = new pB(this), this.inputState.ensureHandlers(this.plugins), this.mountStyles(), this.updateAttrs(), this.bidiCache = [];
    } finally {
      this.updateState = 0;
    }
    n && this.focus(), this.requestMeasure();
  }
  updatePlugins(e) {
    let n = e.startState.facet(gg), r = e.state.facet(gg);
    if (n != r) {
      let o = [];
      for (let i of r) {
        let s = n.indexOf(i);
        if (s < 0)
          o.push(new ZC(i));
        else {
          let a = this.plugins[s];
          a.mustUpdate = e, o.push(a);
        }
      }
      for (let i of this.plugins)
        i.mustUpdate != e && i.destroy(this);
      this.plugins = o, this.pluginMap.clear();
    } else
      for (let o of this.plugins)
        o.mustUpdate = e;
    for (let o = 0; o < this.plugins.length; o++)
      this.plugins[o].update(this);
    n != r && this.inputState.ensureHandlers(this.plugins);
  }
  docViewUpdate() {
    for (let e of this.plugins) {
      let n = e.value;
      if (n && n.docViewUpdate)
        try {
          n.docViewUpdate(this);
        } catch (r) {
          Wo(this.state, r, "doc view update listener");
        }
    }
  }
  /**
  @internal
  */
  measure(e = !0) {
    if (this.destroyed)
      return;
    if (this.measureScheduled > -1 && this.win.cancelAnimationFrame(this.measureScheduled), this.observer.delayedAndroidKey) {
      this.measureScheduled = -1, this.requestMeasure();
      return;
    }
    this.measureScheduled = 0, e && this.observer.forceFlush();
    let n = null, r = this.scrollDOM, o = r.scrollTop * this.scaleY, { scrollAnchorPos: i, scrollAnchorHeight: s } = this.viewState;
    Math.abs(o - this.viewState.scrollTop) > 1 && (s = -1), this.viewState.scrollAnchorHeight = -1;
    try {
      for (let a = 0; ; a++) {
        if (s < 0)
          if (Due(r))
            i = -1, s = this.viewState.heightMap.height;
          else {
            let h = this.viewState.scrollAnchorAt(o);
            i = h.from, s = h.top;
          }
        this.updateState = 1;
        let l = this.viewState.measure(this);
        if (!l && !this.measureRequests.length && this.viewState.scrollTarget == null)
          break;
        if (a > 5) {
          console.warn(this.measureRequests.length ? "Measure loop restarted more than 5 times" : "Viewport failed to stabilize");
          break;
        }
        let c = [];
        l & 4 || ([this.measureRequests, c] = [c, this.measureRequests]);
        let u = c.map((h) => {
          try {
            return h.read(this);
          } catch (p) {
            return Wo(this.state, p), jB;
          }
        }), d = xx.create(this, this.state, []), f = !1;
        d.flags |= l, n ? n.flags |= l : n = d, this.updateState = 2, d.empty || (this.updatePlugins(d), this.inputState.update(d), this.updateAttrs(), f = this.docView.update(d), f && this.docViewUpdate());
        for (let h = 0; h < c.length; h++)
          if (u[h] != jB)
            try {
              let p = c[h];
              p.write && p.write(u[h], this);
            } catch (p) {
              Wo(this.state, p);
            }
        if (f && this.docView.updateSelection(!0), !d.viewportChanged && this.measureRequests.length == 0) {
          if (this.viewState.editorHeight)
            if (this.viewState.scrollTarget) {
              this.docView.scrollIntoView(this.viewState.scrollTarget), this.viewState.scrollTarget = null, s = -1;
              continue;
            } else {
              let h = (i < 0 ? this.viewState.heightMap.height : this.viewState.lineBlockAt(i).top) - s;
              if (h > 1 || h < -1) {
                o = o + h, r.scrollTop = o / this.scaleY, s = -1;
                continue;
              }
            }
          break;
        }
      }
    } finally {
      this.updateState = 0, this.measureScheduled = -1;
    }
    if (n && !n.empty)
      for (let a of this.state.facet(tN))
        a(n);
  }
  /**
  Get the CSS classes for the currently active editor themes.
  */
  get themeClasses() {
    return lN + " " + (this.state.facet(aN) ? kde : Cde) + " " + this.state.facet(Mb);
  }
  updateAttrs() {
    let e = LB(this, cde, {
      class: "cm-editor" + (this.hasFocus ? " cm-focused " : " ") + this.themeClasses
    }), n = {
      spellcheck: "false",
      autocorrect: "off",
      autocapitalize: "off",
      writingsuggestions: "false",
      translate: "no",
      contenteditable: this.state.facet(pl) ? "true" : "false",
      class: "cm-content",
      style: `${rt.tabSize}: ${this.state.tabSize}`,
      role: "textbox",
      "aria-multiline": "true"
    };
    this.state.readOnly && (n["aria-readonly"] = "true"), LB(this, rL, n);
    let r = this.observer.ignore(() => {
      let o = XI(this.contentDOM, this.contentAttrs, n), i = XI(this.dom, this.editorAttrs, e);
      return o || i;
    });
    return this.editorAttrs = e, this.contentAttrs = n, r;
  }
  showAnnouncements(e) {
    let n = !0;
    for (let r of e)
      for (let o of r.effects)
        if (o.is(et.announce)) {
          n && (this.announceDOM.textContent = ""), n = !1;
          let i = this.announceDOM.appendChild(document.createElement("div"));
          i.textContent = o.value;
        }
  }
  mountStyles() {
    this.styleModules = this.state.facet(yg);
    let e = this.state.facet(et.cspNonce);
    Qc.mount(this.root, this.styleModules.concat(g9e).reverse(), e ? { nonce: e } : void 0);
  }
  readMeasured() {
    if (this.updateState == 2)
      throw new Error("Reading the editor layout isn't allowed during an update");
    this.updateState == 0 && this.measureScheduled > -1 && this.measure(!1);
  }
  /**
  Schedule a layout measurement, optionally providing callbacks to
  do custom DOM measuring followed by a DOM write phase. Using
  this is preferable reading DOM layout directly from, for
  example, an event handler, because it'll make sure measuring and
  drawing done by other components is synchronized, avoiding
  unnecessary DOM layout computations.
  */
  requestMeasure(e) {
    if (this.measureScheduled < 0 && (this.measureScheduled = this.win.requestAnimationFrame(() => this.measure())), e) {
      if (this.measureRequests.indexOf(e) > -1)
        return;
      if (e.key != null) {
        for (let n = 0; n < this.measureRequests.length; n++)
          if (this.measureRequests[n].key === e.key) {
            this.measureRequests[n] = e;
            return;
          }
      }
      this.measureRequests.push(e);
    }
  }
  /**
  Get the value of a specific plugin, if present. Note that
  plugins that crash can be dropped from a view, so even when you
  know you registered a given plugin, it is recommended to check
  the return value of this method.
  */
  plugin(e) {
    let n = this.pluginMap.get(e);
    return (n === void 0 || n && n.spec != e) && this.pluginMap.set(e, n = this.plugins.find((r) => r.spec == e) || null), n && n.update(this).value;
  }
  /**
  The top position of the document, in screen coordinates. This
  may be negative when the editor is scrolled down. Points
  directly to the top of the first line, not above the padding.
  */
  get documentTop() {
    return this.contentDOM.getBoundingClientRect().top + this.viewState.paddingTop;
  }
  /**
  Reports the padding above and below the document.
  */
  get documentPadding() {
    return { top: this.viewState.paddingTop, bottom: this.viewState.paddingBottom };
  }
  /**
  If the editor is transformed with CSS, this provides the scale
  along the X axis. Otherwise, it will just be 1. Note that
  transforms other than translation and scaling are not supported.
  */
  get scaleX() {
    return this.viewState.scaleX;
  }
  /**
  Provide the CSS transformed scale along the Y axis.
  */
  get scaleY() {
    return this.viewState.scaleY;
  }
  /**
  Find the text line or block widget at the given vertical
  position (which is interpreted as relative to the [top of the
  document](https://codemirror.net/6/docs/ref/#view.EditorView.documentTop)).
  */
  elementAtHeight(e) {
    return this.readMeasured(), this.viewState.elementAtHeight(e);
  }
  /**
  Find the line block (see
  [`lineBlockAt`](https://codemirror.net/6/docs/ref/#view.EditorView.lineBlockAt) at the given
  height, again interpreted relative to the [top of the
  document](https://codemirror.net/6/docs/ref/#view.EditorView.documentTop).
  */
  lineBlockAtHeight(e) {
    return this.readMeasured(), this.viewState.lineBlockAtHeight(e);
  }
  /**
  Get the extent and vertical position of all [line
  blocks](https://codemirror.net/6/docs/ref/#view.EditorView.lineBlockAt) in the viewport. Positions
  are relative to the [top of the
  document](https://codemirror.net/6/docs/ref/#view.EditorView.documentTop);
  */
  get viewportLineBlocks() {
    return this.viewState.viewportLines;
  }
  /**
  Find the line block around the given document position. A line
  block is a range delimited on both sides by either a
  non-[hidden](https://codemirror.net/6/docs/ref/#view.Decoration^replace) line break, or the
  start/end of the document. It will usually just hold a line of
  text, but may be broken into multiple textblocks by block
  widgets.
  */
  lineBlockAt(e) {
    return this.viewState.lineBlockAt(e);
  }
  /**
  The editor's total content height.
  */
  get contentHeight() {
    return this.viewState.contentHeight;
  }
  /**
  Move a cursor position by [grapheme
  cluster](https://codemirror.net/6/docs/ref/#state.findClusterBreak). `forward` determines whether
  the motion is away from the line start, or towards it. In
  bidirectional text, the line is traversed in visual order, using
  the editor's [text direction](https://codemirror.net/6/docs/ref/#view.EditorView.textDirection).
  When the start position was the last one on the line, the
  returned position will be across the line break. If there is no
  further line, the original position is returned.
  
  By default, this method moves over a single cluster. The
  optional `by` argument can be used to move across more. It will
  be called with the first cluster as argument, and should return
  a predicate that determines, for each subsequent cluster,
  whether it should also be moved over.
  */
  moveByChar(e, n, r) {
    return ek(this, e, bB(this, e, n, r));
  }
  /**
  Move a cursor position across the next group of either
  [letters](https://codemirror.net/6/docs/ref/#state.EditorState.charCategorizer) or non-letter
  non-whitespace characters.
  */
  moveByGroup(e, n) {
    return ek(this, e, bB(this, e, n, (r) => $6e(this, e.head, r)));
  }
  /**
  Get the cursor position visually at the start or end of a line.
  Note that this may differ from the _logical_ position at its
  start or end (which is simply at `line.from`/`line.to`) if text
  at the start or end goes against the line's base text direction.
  */
  visualLineSide(e, n) {
    let r = this.bidiSpans(e), o = this.textDirectionAt(e.from), i = r[n ? r.length - 1 : 0];
    return $e.cursor(i.side(n, o) + e.from, i.forward(!n, o) ? 1 : -1);
  }
  /**
  Move to the next line boundary in the given direction. If
  `includeWrap` is true, line wrapping is on, and there is a
  further wrap point on the current line, the wrap point will be
  returned. Otherwise this function will return the start or end
  of the line.
  */
  moveToLineBoundary(e, n, r = !0) {
    return P6e(this, e, n, r);
  }
  /**
  Move a cursor position vertically. When `distance` isn't given,
  it defaults to moving to the next line (including wrapped
  lines). Otherwise, `distance` should provide a positive distance
  in pixels.
  
  When `start` has a
  [`goalColumn`](https://codemirror.net/6/docs/ref/#state.SelectionRange.goalColumn), the vertical
  motion will use that as a target horizontal position. Otherwise,
  the cursor's own horizontal position is used. The returned
  cursor will have its goal column set to whichever column was
  used.
  */
  moveVertically(e, n, r) {
    return ek(this, e, M6e(this, e, n, r));
  }
  /**
  Find the DOM parent node and offset (child offset if `node` is
  an element, character offset when it is a text node) at the
  given document position.
  
  Note that for positions that aren't currently in
  `visibleRanges`, the resulting DOM position isn't necessarily
  meaningful (it may just point before or after a placeholder
  element).
  */
  domAtPos(e) {
    return this.docView.domAtPos(e);
  }
  /**
  Find the document position at the given DOM node. Can be useful
  for associating positions with DOM events. Will raise an error
  when `node` isn't part of the editor content.
  */
  posAtDOM(e, n = 0) {
    return this.docView.posFromDOM(e, n);
  }
  posAtCoords(e, n = !0) {
    return this.readMeasured(), pde(this, e, n);
  }
  /**
  Get the screen coordinates at the given document position.
  `side` determines whether the coordinates are based on the
  element before (-1) or after (1) the position (if no element is
  available on the given side, the method will transparently use
  another strategy to get reasonable coordinates).
  */
  coordsAtPos(e, n = 1) {
    this.readMeasured();
    let r = this.docView.coordsAt(e, n);
    if (!r || r.left == r.right)
      return r;
    let o = this.state.doc.lineAt(e), i = this.bidiSpans(o), s = i[Dc.find(i, e - o.from, -1, n)];
    return hv(r, s.dir == Kn.LTR == n > 0);
  }
  /**
  Return the rectangle around a given character. If `pos` does not
  point in front of a character that is in the viewport and
  rendered (i.e. not replaced, not a line break), this will return
  null. For space characters that are a line wrap point, this will
  return the position before the line break.
  */
  coordsForChar(e) {
    return this.readMeasured(), this.docView.coordsForChar(e);
  }
  /**
  The default width of a character in the editor. May not
  accurately reflect the width of all characters (given variable
  width fonts or styling of invididual ranges).
  */
  get defaultCharacterWidth() {
    return this.viewState.heightOracle.charWidth;
  }
  /**
  The default height of a line in the editor. May not be accurate
  for all lines.
  */
  get defaultLineHeight() {
    return this.viewState.heightOracle.lineHeight;
  }
  /**
  The text direction
  ([`direction`](https://developer.mozilla.org/en-US/docs/Web/CSS/direction)
  CSS property) of the editor's content element.
  */
  get textDirection() {
    return this.viewState.defaultTextDirection;
  }
  /**
  Find the text direction of the block at the given position, as
  assigned by CSS. If
  [`perLineTextDirection`](https://codemirror.net/6/docs/ref/#view.EditorView^perLineTextDirection)
  isn't enabled, or the given position is outside of the viewport,
  this will always return the same as
  [`textDirection`](https://codemirror.net/6/docs/ref/#view.EditorView.textDirection). Note that
  this may trigger a DOM layout.
  */
  textDirectionAt(e) {
    return !this.state.facet(ide) || e < this.viewport.from || e > this.viewport.to ? this.textDirection : (this.readMeasured(), this.docView.textDirectionAt(e));
  }
  /**
  Whether this editor [wraps lines](https://codemirror.net/6/docs/ref/#view.EditorView.lineWrapping)
  (as determined by the
  [`white-space`](https://developer.mozilla.org/en-US/docs/Web/CSS/white-space)
  CSS property of its content element).
  */
  get lineWrapping() {
    return this.viewState.heightOracle.lineWrapping;
  }
  /**
  Returns the bidirectional text structure of the given line
  (which should be in the current document) as an array of span
  objects. The order of these spans matches the [text
  direction](https://codemirror.net/6/docs/ref/#view.EditorView.textDirection)—if that is
  left-to-right, the leftmost spans come first, otherwise the
  rightmost spans come first.
  */
  bidiSpans(e) {
    if (e.length > w9e)
      return Que(e.length);
    let n = this.textDirectionAt(e.from), r;
    for (let i of this.bidiCache)
      if (i.from == e.from && i.dir == n && (i.fresh || Xue(i.isolates, r = hB(this, e))))
        return i.order;
    r || (r = hB(this, e));
    let o = m6e(e.text, n, r);
    return this.bidiCache.push(new Sx(e.from, e.to, n, r, !0, o)), o;
  }
  /**
  Check whether the editor has focus.
  */
  get hasFocus() {
    var e;
    return (this.dom.ownerDocument.hasFocus() || rt.safari && ((e = this.inputState) === null || e === void 0 ? void 0 : e.lastContextMenu) > Date.now() - 3e4) && this.root.activeElement == this.contentDOM;
  }
  /**
  Put focus on the editor.
  */
  focus() {
    this.observer.ignore(() => {
      $ue(this.contentDOM), this.docView.updateSelection();
    });
  }
  /**
  Update the [root](https://codemirror.net/6/docs/ref/##view.EditorViewConfig.root) in which the editor lives. This is only
  necessary when moving the editor's existing DOM to a new window or shadow root.
  */
  setRoot(e) {
    this._root != e && (this._root = e, this.observer.setWindow((e.nodeType == 9 ? e : e.ownerDocument).defaultView || window), this.mountStyles());
  }
  /**
  Clean up this editor view, removing its element from the
  document, unregistering event handlers, and notifying
  plugins. The view instance can no longer be used after
  calling this.
  */
  destroy() {
    this.root.activeElement == this.contentDOM && this.contentDOM.blur();
    for (let e of this.plugins)
      e.destroy(this);
    this.plugins = [], this.inputState.destroy(), this.docView.destroy(), this.dom.remove(), this.observer.destroy(), this.measureScheduled > -1 && this.win.cancelAnimationFrame(this.measureScheduled), this.destroyed = !0;
  }
  /**
  Returns an effect that can be
  [added](https://codemirror.net/6/docs/ref/#state.TransactionSpec.effects) to a transaction to
  cause it to scroll the given position or range into view.
  */
  static scrollIntoView(e, n = {}) {
    return kb.of(new yh(typeof e == "number" ? $e.cursor(e) : e, n.y, n.x, n.yMargin, n.xMargin));
  }
  /**
  Return an effect that resets the editor to its current (at the
  time this method was called) scroll position. Note that this
  only affects the editor's own scrollable element, not parents.
  See also
  [`EditorViewConfig.scrollTo`](https://codemirror.net/6/docs/ref/#view.EditorViewConfig.scrollTo).
  
  The effect should be used with a document identical to the one
  it was created for. Failing to do so is not an error, but may
  not scroll to the expected position. You can
  [map](https://codemirror.net/6/docs/ref/#state.StateEffect.map) the effect to account for changes.
  */
  scrollSnapshot() {
    let { scrollTop: e, scrollLeft: n } = this.scrollDOM, r = this.viewState.scrollAnchorAt(e);
    return kb.of(new yh($e.cursor(r.from), "start", "start", r.top - e, n, !0));
  }
  /**
  Enable or disable tab-focus mode, which disables key bindings
  for Tab and Shift-Tab, letting the browser's default
  focus-changing behavior go through instead. This is useful to
  prevent trapping keyboard users in your editor.
  
  Without argument, this toggles the mode. With a boolean, it
  enables (true) or disables it (false). Given a number, it
  temporarily enables the mode until that number of milliseconds
  have passed or another non-Tab key is pressed.
  */
  setTabFocusMode(e) {
    e == null ? this.inputState.tabFocusMode = this.inputState.tabFocusMode < 0 ? 0 : -1 : typeof e == "boolean" ? this.inputState.tabFocusMode = e ? 0 : -1 : this.inputState.tabFocusMode != 0 && (this.inputState.tabFocusMode = Date.now() + e);
  }
  /**
  Returns an extension that can be used to add DOM event handlers.
  The value should be an object mapping event names to handler
  functions. For any given event, such functions are ordered by
  extension precedence, and the first handler to return true will
  be assumed to have handled that event, and no other handlers or
  built-in behavior will be activated for it. These are registered
  on the [content element](https://codemirror.net/6/docs/ref/#view.EditorView.contentDOM), except
  for `scroll` handlers, which will be called any time the
  editor's [scroll element](https://codemirror.net/6/docs/ref/#view.EditorView.scrollDOM) or one of
  its parent nodes is scrolled.
  */
  static domEventHandlers(e) {
    return kr.define(() => ({}), { eventHandlers: e });
  }
  /**
  Create an extension that registers DOM event observers. Contrary
  to event [handlers](https://codemirror.net/6/docs/ref/#view.EditorView^domEventHandlers),
  observers can't be prevented from running by a higher-precedence
  handler returning true. They also don't prevent other handlers
  and observers from running when they return true, and should not
  call `preventDefault`.
  */
  static domEventObservers(e) {
    return kr.define(() => ({}), { eventObservers: e });
  }
  /**
  Create a theme extension. The first argument can be a
  [`style-mod`](https://github.com/marijnh/style-mod#documentation)
  style spec providing the styles for the theme. These will be
  prefixed with a generated class for the style.
  
  Because the selectors will be prefixed with a scope class, rule
  that directly match the editor's [wrapper
  element](https://codemirror.net/6/docs/ref/#view.EditorView.dom)—to which the scope class will be
  added—need to be explicitly differentiated by adding an `&` to
  the selector for that element—for example
  `&.cm-focused`.
  
  When `dark` is set to true, the theme will be marked as dark,
  which will cause the `&dark` rules from [base
  themes](https://codemirror.net/6/docs/ref/#view.EditorView^baseTheme) to be used (as opposed to
  `&light` when a light theme is active).
  */
  static theme(e, n) {
    let r = Qc.newName(), o = [Mb.of(r), yg.of(cN(`.${r}`, e))];
    return n && n.dark && o.push(aN.of(!0)), o;
  }
  /**
  Create an extension that adds styles to the base theme. Like
  with [`theme`](https://codemirror.net/6/docs/ref/#view.EditorView^theme), use `&` to indicate the
  place of the editor wrapper element when directly targeting
  that. You can also use `&dark` or `&light` instead to only
  target editors with a dark or light theme.
  */
  static baseTheme(e) {
    return Yd.lowest(yg.of(cN("." + lN, e, Ade)));
  }
  /**
  Retrieve an editor view instance from the view's DOM
  representation.
  */
  static findFromDOM(e) {
    var n;
    let r = e.querySelector(".cm-content");
    return ((n = (r && tr.get(r) || tr.get(e))?.rootView) === null || n === void 0 ? void 0 : n.view) || null;
  }
}
et.styleModule = yg;
et.inputHandler = rde;
et.clipboardInputFilter = tL;
et.clipboardOutputFilter = nL;
et.scrollHandler = ade;
et.focusChangeEffect = ode;
et.perLineTextDirection = ide;
et.exceptionSink = nde;
et.updateListener = tN;
et.editable = pl;
et.mouseSelectionStyle = tde;
et.dragMovesSelection = ede;
et.clickAddsSelectionRange = Jue;
et.decorations = Y0;
et.outerDecorations = ude;
et.atomicRanges = oL;
et.bidiIsolatedRanges = dde;
et.scrollMargins = fde;
et.darkTheme = aN;
et.cspNonce = /* @__PURE__ */ lt.define({ combine: (t) => t.length ? t[0] : "" });
et.contentAttributes = rL;
et.editorAttributes = cde;
et.lineWrapping = /* @__PURE__ */ et.contentAttributes.of({ class: "cm-lineWrapping" });
et.announce = /* @__PURE__ */ xt.define();
const w9e = 4096, jB = {};
class Sx {
  constructor(e, n, r, o, i, s) {
    this.from = e, this.to = n, this.dir = r, this.isolates = o, this.fresh = i, this.order = s;
  }
  static update(e, n) {
    if (n.empty && !e.some((i) => i.fresh))
      return e;
    let r = [], o = e.length ? e[e.length - 1].dir : Kn.LTR;
    for (let i = Math.max(0, e.length - 10); i < e.length; i++) {
      let s = e[i];
      s.dir == o && !n.touchesRange(s.from, s.to) && r.push(new Sx(n.mapPos(s.from, 1), n.mapPos(s.to, -1), s.dir, s.isolates, !1, s.order));
    }
    return r;
  }
}
function LB(t, e, n) {
  for (let r = t.state.facet(e), o = r.length - 1; o >= 0; o--) {
    let i = r[o], s = typeof i == "function" ? i(t) : i;
    s && KI(s, n);
  }
  return n;
}
const x9e = rt.mac ? "mac" : rt.windows ? "win" : rt.linux ? "linux" : "key";
function E9e(t, e) {
  const n = t.split(/-(?!$)/);
  let r = n[n.length - 1];
  r == "Space" && (r = " ");
  let o, i, s, a;
  for (let l = 0; l < n.length - 1; ++l) {
    const c = n[l];
    if (/^(cmd|meta|m)$/i.test(c))
      a = !0;
    else if (/^a(lt)?$/i.test(c))
      o = !0;
    else if (/^(c|ctrl|control)$/i.test(c))
      i = !0;
    else if (/^s(hift)?$/i.test(c))
      s = !0;
    else if (/^mod$/i.test(c))
      e == "mac" ? a = !0 : i = !0;
    else
      throw new Error("Unrecognized modifier name: " + c);
  }
  return o && (r = "Alt-" + r), i && (r = "Ctrl-" + r), a && (r = "Meta-" + r), s && (r = "Shift-" + r), r;
}
function Db(t, e, n) {
  return e.altKey && (t = "Alt-" + t), e.ctrlKey && (t = "Ctrl-" + t), e.metaKey && (t = "Meta-" + t), n !== !1 && e.shiftKey && (t = "Shift-" + t), t;
}
const S9e = /* @__PURE__ */ Yd.default(/* @__PURE__ */ et.domEventHandlers({
  keydown(t, e) {
    return Rde(Tde(e.state), t, e, "editor");
  }
})), AS = /* @__PURE__ */ lt.define({ enables: S9e }), FB = /* @__PURE__ */ new WeakMap();
function Tde(t) {
  let e = t.facet(AS), n = FB.get(e);
  return n || FB.set(e, n = k9e(e.reduce((r, o) => r.concat(o), []))), n;
}
function O9e(t, e, n) {
  return Rde(Tde(t.state), e, t, n);
}
let Cc = null;
const C9e = 4e3;
function k9e(t, e = x9e) {
  let n = /* @__PURE__ */ Object.create(null), r = /* @__PURE__ */ Object.create(null), o = (s, a) => {
    let l = r[s];
    if (l == null)
      r[s] = a;
    else if (l != a)
      throw new Error("Key binding " + s + " is used both as a regular binding and as a multi-stroke prefix");
  }, i = (s, a, l, c, u) => {
    var d, f;
    let h = n[s] || (n[s] = /* @__PURE__ */ Object.create(null)), p = a.split(/ (?!$)/).map((y) => E9e(y, e));
    for (let y = 1; y < p.length; y++) {
      let v = p.slice(0, y).join(" ");
      o(v, !0), h[v] || (h[v] = {
        preventDefault: !0,
        stopPropagation: !1,
        run: [(b) => {
          let _ = Cc = { view: b, prefix: v, scope: s };
          return setTimeout(() => {
            Cc == _ && (Cc = null);
          }, C9e), !0;
        }]
      });
    }
    let m = p.join(" ");
    o(m, !1);
    let g = h[m] || (h[m] = {
      preventDefault: !1,
      stopPropagation: !1,
      run: ((f = (d = h._any) === null || d === void 0 ? void 0 : d.run) === null || f === void 0 ? void 0 : f.slice()) || []
    });
    l && g.run.push(l), c && (g.preventDefault = !0), u && (g.stopPropagation = !0);
  };
  for (let s of t) {
    let a = s.scope ? s.scope.split(" ") : ["editor"];
    if (s.any)
      for (let c of a) {
        let u = n[c] || (n[c] = /* @__PURE__ */ Object.create(null));
        u._any || (u._any = { preventDefault: !1, stopPropagation: !1, run: [] });
        let { any: d } = s;
        for (let f in u)
          u[f].run.push((h) => d(h, uN));
      }
    let l = s[e] || s.key;
    if (l)
      for (let c of a)
        i(c, l, s.run, s.preventDefault, s.stopPropagation), s.shift && i(c, "Shift-" + l, s.shift, s.preventDefault, s.stopPropagation);
  }
  return n;
}
let uN = null;
function Rde(t, e, n, r) {
  uN = e;
  let o = Q4e(e), i = zo(o, 0), s = la(i) == o.length && o != " ", a = "", l = !1, c = !1, u = !1;
  Cc && Cc.view == n && Cc.scope == r && (a = Cc.prefix + " ", yde.indexOf(e.keyCode) < 0 && (c = !0, Cc = null));
  let d = /* @__PURE__ */ new Set(), f = (g) => {
    if (g) {
      for (let y of g.run)
        if (!d.has(y) && (d.add(y), y(n)))
          return g.stopPropagation && (u = !0), !0;
      g.preventDefault && (g.stopPropagation && (u = !0), c = !0);
    }
    return !1;
  }, h = t[r], p, m;
  return h && (f(h[a + Db(o, e, !s)]) ? l = !0 : s && (e.altKey || e.metaKey || e.ctrlKey) && // Ctrl-Alt may be used for AltGr on Windows
  !(rt.windows && e.ctrlKey && e.altKey) && (p = Zc[e.keyCode]) && p != o ? (f(h[a + Db(p, e, !0)]) || e.shiftKey && (m = W0[e.keyCode]) != o && m != p && f(h[a + Db(m, e, !1)])) && (l = !0) : s && e.shiftKey && f(h[a + Db(o, e, !0)]) && (l = !0), !l && f(h._any) && (l = !0)), c && (l = !0), l && u && e.stopPropagation(), uN = null, l;
}
let cL = class Pde {
  /**
  Create a marker with the given class and dimensions. If `width`
  is null, the DOM element will get no width style.
  */
  constructor(e, n, r, o, i) {
    this.className = e, this.left = n, this.top = r, this.width = o, this.height = i;
  }
  draw() {
    let e = document.createElement("div");
    return e.className = this.className, this.adjust(e), e;
  }
  update(e, n) {
    return n.className != this.className ? !1 : (this.adjust(e), !0);
  }
  adjust(e) {
    e.style.left = this.left + "px", e.style.top = this.top + "px", this.width != null && (e.style.width = this.width + "px"), e.style.height = this.height + "px";
  }
  eq(e) {
    return this.left == e.left && this.top == e.top && this.width == e.width && this.height == e.height && this.className == e.className;
  }
  /**
  Create a set of rectangles for the given selection range,
  assigning them theclass`className`. Will create a single
  rectangle for empty ranges, and a set of selection-style
  rectangles covering the range's content (in a bidi-aware
  way) for non-empty ones.
  */
  static forRange(e, n, r) {
    if (r.empty) {
      let o = e.coordsAtPos(r.head, r.assoc || 1);
      if (!o)
        return [];
      let i = $de(e);
      return [new Pde(n, o.left - i.left, o.top - i.top, null, o.bottom - o.top)];
    } else
      return A9e(e, n, r);
  }
};
function $de(t) {
  let e = t.scrollDOM.getBoundingClientRect();
  return { left: (t.textDirection == Kn.LTR ? e.left : e.right - t.scrollDOM.clientWidth * t.scaleX) - t.scrollDOM.scrollLeft * t.scaleX, top: e.top - t.scrollDOM.scrollTop * t.scaleY };
}
function BB(t, e, n, r) {
  let o = t.coordsAtPos(e, n * 2);
  if (!o)
    return r;
  let i = t.dom.getBoundingClientRect(), s = (o.top + o.bottom) / 2, a = t.posAtCoords({ x: i.left + 1, y: s }), l = t.posAtCoords({ x: i.right - 1, y: s });
  return a == null || l == null ? r : { from: Math.max(r.from, Math.min(a, l)), to: Math.min(r.to, Math.max(a, l)) };
}
function A9e(t, e, n) {
  if (n.to <= t.viewport.from || n.from >= t.viewport.to)
    return [];
  let r = Math.max(n.from, t.viewport.from), o = Math.min(n.to, t.viewport.to), i = t.textDirection == Kn.LTR, s = t.contentDOM, a = s.getBoundingClientRect(), l = $de(t), c = s.querySelector(".cm-line"), u = c && window.getComputedStyle(c), d = a.left + (u ? parseInt(u.paddingLeft) + Math.min(0, parseInt(u.textIndent)) : 0), f = a.right - (u ? parseInt(u.paddingRight) : 0), h = oN(t, r), p = oN(t, o), m = h.type == Ao.Text ? h : null, g = p.type == Ao.Text ? p : null;
  if (m && (t.lineWrapping || h.widgetLineBreaks) && (m = BB(t, r, 1, m)), g && (t.lineWrapping || p.widgetLineBreaks) && (g = BB(t, o, -1, g)), m && g && m.from == g.from && m.to == g.to)
    return v(b(n.from, n.to, m));
  {
    let w = m ? b(n.from, null, m) : _(h, !1), x = g ? b(null, n.to, g) : _(p, !0), E = [];
    return (m || h).to < (g || p).from - (m && g ? 1 : 0) || h.widgetLineBreaks > 1 && w.bottom + t.defaultLineHeight / 2 < x.top ? E.push(y(d, w.bottom, f, x.top)) : w.bottom < x.top && t.elementAtHeight((w.bottom + x.top) / 2).type == Ao.Text && (w.bottom = x.top = (w.bottom + x.top) / 2), v(w).concat(E).concat(v(x));
  }
  function y(w, x, E, S) {
    return new cL(e, w - l.left, x - l.top, E - w, S - x);
  }
  function v({ top: w, bottom: x, horizontal: E }) {
    let S = [];
    for (let C = 0; C < E.length; C += 2)
      S.push(y(E[C], w, E[C + 1], x));
    return S;
  }
  function b(w, x, E) {
    let S = 1e9, C = -1e9, R = [];
    function P(O, k, T, I, j) {
      let z = t.coordsAtPos(O, O == E.to ? -2 : 2), $ = t.coordsAtPos(T, T == E.from ? 2 : -2);
      !z || !$ || (S = Math.min(z.top, $.top, S), C = Math.max(z.bottom, $.bottom, C), j == Kn.LTR ? R.push(i && k ? d : z.left, i && I ? f : $.right) : R.push(!i && I ? d : $.left, !i && k ? f : z.right));
    }
    let N = w ?? E.from, A = x ?? E.to;
    for (let O of t.visibleRanges)
      if (O.to > N && O.from < A)
        for (let k = Math.max(O.from, N), T = Math.min(O.to, A); ; ) {
          let I = t.state.doc.lineAt(k);
          for (let j of t.bidiSpans(I)) {
            let z = j.from + I.from, $ = j.to + I.from;
            if (z >= T)
              break;
            $ > k && P(Math.max(z, k), w == null && z <= N, Math.min($, T), x == null && $ >= A, j.dir);
          }
          if (k = I.to + 1, k >= T)
            break;
        }
    return R.length == 0 && P(N, w == null, A, x == null, t.textDirection), { top: S, bottom: C, horizontal: R };
  }
  function _(w, x) {
    let E = a.top + (x ? w.top : w.bottom);
    return { top: E, bottom: E, horizontal: [] };
  }
}
function T9e(t, e) {
  return t.constructor == e.constructor && t.eq(e);
}
class R9e {
  constructor(e, n) {
    this.view = e, this.layer = n, this.drawn = [], this.scaleX = 1, this.scaleY = 1, this.measureReq = { read: this.measure.bind(this), write: this.draw.bind(this) }, this.dom = e.scrollDOM.appendChild(document.createElement("div")), this.dom.classList.add("cm-layer"), n.above && this.dom.classList.add("cm-layer-above"), n.class && this.dom.classList.add(n.class), this.scale(), this.dom.setAttribute("aria-hidden", "true"), this.setOrder(e.state), e.requestMeasure(this.measureReq), n.mount && n.mount(this.dom, e);
  }
  update(e) {
    e.startState.facet(gw) != e.state.facet(gw) && this.setOrder(e.state), (this.layer.update(e, this.dom) || e.geometryChanged) && (this.scale(), e.view.requestMeasure(this.measureReq));
  }
  docViewUpdate(e) {
    this.layer.updateOnDocViewUpdate !== !1 && e.requestMeasure(this.measureReq);
  }
  setOrder(e) {
    let n = 0, r = e.facet(gw);
    for (; n < r.length && r[n] != this.layer; )
      n++;
    this.dom.style.zIndex = String((this.layer.above ? 150 : -1) - n);
  }
  measure() {
    return this.layer.markers(this.view);
  }
  scale() {
    let { scaleX: e, scaleY: n } = this.view;
    (e != this.scaleX || n != this.scaleY) && (this.scaleX = e, this.scaleY = n, this.dom.style.transform = `scale(${1 / e}, ${1 / n})`);
  }
  draw(e) {
    if (e.length != this.drawn.length || e.some((n, r) => !T9e(n, this.drawn[r]))) {
      let n = this.dom.firstChild, r = 0;
      for (let o of e)
        o.update && n && o.constructor && this.drawn[r].constructor && o.update(n, this.drawn[r]) ? (n = n.nextSibling, r++) : this.dom.insertBefore(o.draw(), n);
      for (; n; ) {
        let o = n.nextSibling;
        n.remove(), n = o;
      }
      this.drawn = e;
    }
  }
  destroy() {
    this.layer.destroy && this.layer.destroy(this.dom, this.view), this.dom.remove();
  }
}
const gw = /* @__PURE__ */ lt.define();
function Mde(t) {
  return [
    kr.define((e) => new R9e(e, t)),
    gw.of(t)
  ];
}
const Dde = !(rt.ios && rt.webkit && rt.webkit_version < 534), K0 = /* @__PURE__ */ lt.define({
  combine(t) {
    return Ra(t, {
      cursorBlinkRate: 1200,
      drawRangeCursor: !0
    }, {
      cursorBlinkRate: (e, n) => Math.min(e, n),
      drawRangeCursor: (e, n) => e || n
    });
  }
});
function P9e(t = {}) {
  return [
    K0.of(t),
    $9e,
    M9e,
    D9e,
    sde.of(!0)
  ];
}
function Ide(t) {
  return t.startState.facet(K0) != t.state.facet(K0);
}
const $9e = /* @__PURE__ */ Mde({
  above: !0,
  markers(t) {
    let { state: e } = t, n = e.facet(K0), r = [];
    for (let o of e.selection.ranges) {
      let i = o == e.selection.main;
      if (o.empty ? !i || Dde : n.drawRangeCursor) {
        let s = i ? "cm-cursor cm-cursor-primary" : "cm-cursor cm-cursor-secondary", a = o.empty ? o : $e.cursor(o.head, o.head > o.anchor ? -1 : 1);
        for (let l of cL.forRange(t, s, a))
          r.push(l);
      }
    }
    return r;
  },
  update(t, e) {
    t.transactions.some((r) => r.selection) && (e.style.animationName = e.style.animationName == "cm-blink" ? "cm-blink2" : "cm-blink");
    let n = Ide(t);
    return n && zB(t.state, e), t.docChanged || t.selectionSet || n;
  },
  mount(t, e) {
    zB(e.state, t);
  },
  class: "cm-cursorLayer"
});
function zB(t, e) {
  e.style.animationDuration = t.facet(K0).cursorBlinkRate + "ms";
}
const M9e = /* @__PURE__ */ Mde({
  above: !1,
  markers(t) {
    return t.state.selection.ranges.map((e) => e.empty ? [] : cL.forRange(t, "cm-selectionBackground", e)).reduce((e, n) => e.concat(n));
  },
  update(t, e) {
    return t.docChanged || t.selectionSet || t.viewportChanged || Ide(t);
  },
  class: "cm-selectionLayer"
}), dN = {
  ".cm-line": {
    "& ::selection, &::selection": { backgroundColor: "transparent !important" }
  },
  ".cm-content": {
    "& :focus": {
      caretColor: "initial !important",
      "&::selection, & ::selection": {
        backgroundColor: "Highlight !important"
      }
    }
  }
};
Dde && (dN[".cm-line"].caretColor = dN[".cm-content"].caretColor = "transparent !important");
const D9e = /* @__PURE__ */ Yd.highest(/* @__PURE__ */ et.theme(dN)), Nde = /* @__PURE__ */ xt.define({
  map(t, e) {
    return t == null ? null : e.mapPos(t);
  }
}), _g = /* @__PURE__ */ jr.define({
  create() {
    return null;
  },
  update(t, e) {
    return t != null && (t = e.changes.mapPos(t)), e.effects.reduce((n, r) => r.is(Nde) ? r.value : n, t);
  }
}), I9e = /* @__PURE__ */ kr.fromClass(class {
  constructor(t) {
    this.view = t, this.cursor = null, this.measureReq = { read: this.readPos.bind(this), write: this.drawCursor.bind(this) };
  }
  update(t) {
    var e;
    let n = t.state.field(_g);
    n == null ? this.cursor != null && ((e = this.cursor) === null || e === void 0 || e.remove(), this.cursor = null) : (this.cursor || (this.cursor = this.view.scrollDOM.appendChild(document.createElement("div")), this.cursor.className = "cm-dropCursor"), (t.startState.field(_g) != n || t.docChanged || t.geometryChanged) && this.view.requestMeasure(this.measureReq));
  }
  readPos() {
    let { view: t } = this, e = t.state.field(_g), n = e != null && t.coordsAtPos(e);
    if (!n)
      return null;
    let r = t.scrollDOM.getBoundingClientRect();
    return {
      left: n.left - r.left + t.scrollDOM.scrollLeft * t.scaleX,
      top: n.top - r.top + t.scrollDOM.scrollTop * t.scaleY,
      height: n.bottom - n.top
    };
  }
  drawCursor(t) {
    if (this.cursor) {
      let { scaleX: e, scaleY: n } = this.view;
      t ? (this.cursor.style.left = t.left / e + "px", this.cursor.style.top = t.top / n + "px", this.cursor.style.height = t.height / n + "px") : this.cursor.style.left = "-100000px";
    }
  }
  destroy() {
    this.cursor && this.cursor.remove();
  }
  setDropPos(t) {
    this.view.state.field(_g) != t && this.view.dispatch({ effects: Nde.of(t) });
  }
}, {
  eventObservers: {
    dragover(t) {
      this.setDropPos(this.view.posAtCoords({ x: t.clientX, y: t.clientY }));
    },
    dragleave(t) {
      (t.target == this.view.contentDOM || !this.view.contentDOM.contains(t.relatedTarget)) && this.setDropPos(null);
    },
    dragend() {
      this.setDropPos(null);
    },
    drop() {
      this.setDropPos(null);
    }
  }
});
function N9e() {
  return [_g, I9e];
}
function qB(t, e, n, r, o) {
  e.lastIndex = 0;
  for (let i = t.iterRange(n, r), s = n, a; !i.next().done; s += i.value.length)
    if (!i.lineBreak)
      for (; a = e.exec(i.value); )
        o(s + a.index, a);
}
function j9e(t, e) {
  let n = t.visibleRanges;
  if (n.length == 1 && n[0].from == t.viewport.from && n[0].to == t.viewport.to)
    return n;
  let r = [];
  for (let { from: o, to: i } of n)
    o = Math.max(t.state.doc.lineAt(o).from, o - e), i = Math.min(t.state.doc.lineAt(i).to, i + e), r.length && r[r.length - 1].to >= o ? r[r.length - 1].to = i : r.push({ from: o, to: i });
  return r;
}
class jde {
  /**
  Create a decorator.
  */
  constructor(e) {
    const { regexp: n, decoration: r, decorate: o, boundary: i, maxLength: s = 1e3 } = e;
    if (!n.global)
      throw new RangeError("The regular expression given to MatchDecorator should have its 'g' flag set");
    if (this.regexp = n, o)
      this.addMatch = (a, l, c, u) => o(u, c, c + a[0].length, a, l);
    else if (typeof r == "function")
      this.addMatch = (a, l, c, u) => {
        let d = r(a, l, c);
        d && u(c, c + a[0].length, d);
      };
    else if (r)
      this.addMatch = (a, l, c, u) => u(c, c + a[0].length, r);
    else
      throw new RangeError("Either 'decorate' or 'decoration' should be provided to MatchDecorator");
    this.boundary = i, this.maxLength = s;
  }
  /**
  Compute the full set of decorations for matches in the given
  view's viewport. You'll want to call this when initializing your
  plugin.
  */
  createDeco(e) {
    let n = new $d(), r = n.add.bind(n);
    for (let { from: o, to: i } of j9e(e, this.maxLength))
      qB(e.state.doc, this.regexp, o, i, (s, a) => this.addMatch(a, e, s, r));
    return n.finish();
  }
  /**
  Update a set of decorations for a view update. `deco` _must_ be
  the set of decorations produced by _this_ `MatchDecorator` for
  the view state before the update.
  */
  updateDeco(e, n) {
    let r = 1e9, o = -1;
    return e.docChanged && e.changes.iterChanges((i, s, a, l) => {
      l >= e.view.viewport.from && a <= e.view.viewport.to && (r = Math.min(a, r), o = Math.max(l, o));
    }), e.viewportMoved || o - r > 1e3 ? this.createDeco(e.view) : o > -1 ? this.updateRange(e.view, n.map(e.changes), r, o) : n;
  }
  updateRange(e, n, r, o) {
    for (let i of e.visibleRanges) {
      let s = Math.max(i.from, r), a = Math.min(i.to, o);
      if (a > s) {
        let l = e.state.doc.lineAt(s), c = l.to < a ? e.state.doc.lineAt(a) : l, u = Math.max(i.from, l.from), d = Math.min(i.to, c.to);
        if (this.boundary) {
          for (; s > l.from; s--)
            if (this.boundary.test(l.text[s - 1 - l.from])) {
              u = s;
              break;
            }
          for (; a < c.to; a++)
            if (this.boundary.test(c.text[a - c.from])) {
              d = a;
              break;
            }
        }
        let f = [], h, p = (m, g, y) => f.push(y.range(m, g));
        if (l == c)
          for (this.regexp.lastIndex = u - l.from; (h = this.regexp.exec(l.text)) && h.index < d - l.from; )
            this.addMatch(h, e, h.index + l.from, p);
        else
          qB(e.state.doc, this.regexp, u, d, (m, g) => this.addMatch(g, e, m, p));
        n = n.update({ filterFrom: u, filterTo: d, filter: (m, g) => m < u || g > d, add: f });
      }
    }
    return n;
  }
}
const fN = /x/.unicode != null ? "gu" : "g", L9e = /* @__PURE__ */ new RegExp(`[\0-\b
--­؜​‎‏\u2028\u2029‭‮⁦⁧⁩\uFEFF￹-￼]`, fN), F9e = {
  0: "null",
  7: "bell",
  8: "backspace",
  10: "newline",
  11: "vertical tab",
  13: "carriage return",
  27: "escape",
  8203: "zero width space",
  8204: "zero width non-joiner",
  8205: "zero width joiner",
  8206: "left-to-right mark",
  8207: "right-to-left mark",
  8232: "line separator",
  8237: "left-to-right override",
  8238: "right-to-left override",
  8294: "left-to-right isolate",
  8295: "right-to-left isolate",
  8297: "pop directional isolate",
  8233: "paragraph separator",
  65279: "zero width no-break space",
  65532: "object replacement"
};
let rk = null;
function B9e() {
  var t;
  if (rk == null && typeof document < "u" && document.body) {
    let e = document.body.style;
    rk = ((t = e.tabSize) !== null && t !== void 0 ? t : e.MozTabSize) != null;
  }
  return rk || !1;
}
const yw = /* @__PURE__ */ lt.define({
  combine(t) {
    let e = Ra(t, {
      render: null,
      specialChars: L9e,
      addSpecialChars: null
    });
    return (e.replaceTabs = !B9e()) && (e.specialChars = new RegExp("	|" + e.specialChars.source, fN)), e.addSpecialChars && (e.specialChars = new RegExp(e.specialChars.source + "|" + e.addSpecialChars.source, fN)), e;
  }
});
function z9e(t = {}) {
  return [yw.of(t), q9e()];
}
let UB = null;
function q9e() {
  return UB || (UB = kr.fromClass(class {
    constructor(t) {
      this.view = t, this.decorations = ut.none, this.decorationCache = /* @__PURE__ */ Object.create(null), this.decorator = this.makeDecorator(t.state.facet(yw)), this.decorations = this.decorator.createDeco(t);
    }
    makeDecorator(t) {
      return new jde({
        regexp: t.specialChars,
        decoration: (e, n, r) => {
          let { doc: o } = n.state, i = zo(e[0], 0);
          if (i == 9) {
            let s = o.lineAt(r), a = n.state.tabSize, l = Sp(s.text, a, r - s.from);
            return ut.replace({
              widget: new W9e((a - l % a) * this.view.defaultCharacterWidth / this.view.scaleX)
            });
          }
          return this.decorationCache[i] || (this.decorationCache[i] = ut.replace({ widget: new V9e(t, i) }));
        },
        boundary: t.replaceTabs ? void 0 : /[^]/
      });
    }
    update(t) {
      let e = t.state.facet(yw);
      t.startState.facet(yw) != e ? (this.decorator = this.makeDecorator(e), this.decorations = this.decorator.createDeco(t.view)) : this.decorations = this.decorator.updateDeco(t, this.decorations);
    }
  }, {
    decorations: (t) => t.decorations
  }));
}
const U9e = "•";
function H9e(t) {
  return t >= 32 ? U9e : t == 10 ? "␤" : String.fromCharCode(9216 + t);
}
class V9e extends Pa {
  constructor(e, n) {
    super(), this.options = e, this.code = n;
  }
  eq(e) {
    return e.code == this.code;
  }
  toDOM(e) {
    let n = H9e(this.code), r = e.state.phrase("Control character") + " " + (F9e[this.code] || "0x" + this.code.toString(16)), o = this.options.render && this.options.render(this.code, r, n);
    if (o)
      return o;
    let i = document.createElement("span");
    return i.textContent = n, i.title = r, i.setAttribute("aria-label", r), i.className = "cm-specialChar", i;
  }
  ignoreEvent() {
    return !1;
  }
}
class W9e extends Pa {
  constructor(e) {
    super(), this.width = e;
  }
  eq(e) {
    return e.width == this.width;
  }
  toDOM() {
    let e = document.createElement("span");
    return e.textContent = "	", e.className = "cm-tab", e.style.width = this.width + "px", e;
  }
  ignoreEvent() {
    return !1;
  }
}
function G9e() {
  return K9e;
}
const Y9e = /* @__PURE__ */ ut.line({ class: "cm-activeLine" }), K9e = /* @__PURE__ */ kr.fromClass(class {
  constructor(t) {
    this.decorations = this.getDeco(t);
  }
  update(t) {
    (t.docChanged || t.selectionSet) && (this.decorations = this.getDeco(t.view));
  }
  getDeco(t) {
    let e = -1, n = [];
    for (let r of t.state.selection.ranges) {
      let o = t.lineBlockAt(r.head);
      o.from > e && (n.push(Y9e.range(o.from)), e = o.from);
    }
    return ut.set(n);
  }
}, {
  decorations: (t) => t.decorations
});
class X9e extends Pa {
  constructor(e) {
    super(), this.content = e;
  }
  toDOM(e) {
    let n = document.createElement("span");
    return n.className = "cm-placeholder", n.style.pointerEvents = "none", n.appendChild(typeof this.content == "string" ? document.createTextNode(this.content) : typeof this.content == "function" ? this.content(e) : this.content.cloneNode(!0)), typeof this.content == "string" ? n.setAttribute("aria-label", "placeholder " + this.content) : n.setAttribute("aria-hidden", "true"), n;
  }
  coordsAt(e) {
    let n = e.firstChild ? Vh(e.firstChild) : [];
    if (!n.length)
      return null;
    let r = window.getComputedStyle(e.parentNode), o = hv(n[0], r.direction != "rtl"), i = parseInt(r.lineHeight);
    return o.bottom - o.top > i * 1.5 ? { left: o.left, right: o.right, top: o.top, bottom: o.top + i } : o;
  }
  ignoreEvent() {
    return !1;
  }
}
function Q9e(t) {
  return kr.fromClass(class {
    constructor(e) {
      this.view = e, this.placeholder = t ? ut.set([ut.widget({ widget: new X9e(t), side: 1 }).range(0)]) : ut.none;
    }
    get decorations() {
      return this.view.state.doc.length ? ut.none : this.placeholder;
    }
  }, { decorations: (e) => e.decorations });
}
const hN = 2e3;
function Z9e(t, e, n) {
  let r = Math.min(e.line, n.line), o = Math.max(e.line, n.line), i = [];
  if (e.off > hN || n.off > hN || e.col < 0 || n.col < 0) {
    let s = Math.min(e.off, n.off), a = Math.max(e.off, n.off);
    for (let l = r; l <= o; l++) {
      let c = t.doc.line(l);
      c.length <= a && i.push($e.range(c.from + s, c.to + a));
    }
  } else {
    let s = Math.min(e.col, n.col), a = Math.max(e.col, n.col);
    for (let l = r; l <= o; l++) {
      let c = t.doc.line(l), u = LI(c.text, s, t.tabSize, !0);
      if (u < 0)
        i.push($e.cursor(c.to));
      else {
        let d = LI(c.text, a, t.tabSize);
        i.push($e.range(c.from + u, c.from + d));
      }
    }
  }
  return i;
}
function J9e(t, e) {
  let n = t.coordsAtPos(t.viewport.from);
  return n ? Math.round(Math.abs((n.left - e) / t.defaultCharacterWidth)) : -1;
}
function HB(t, e) {
  let n = t.posAtCoords({ x: e.clientX, y: e.clientY }, !1), r = t.state.doc.lineAt(n), o = n - r.from, i = o > hN ? -1 : o == r.length ? J9e(t, e.clientX) : Sp(r.text, t.state.tabSize, n - r.from);
  return { line: r.number, col: i, off: o };
}
function e8e(t, e) {
  let n = HB(t, e), r = t.state.selection;
  return n ? {
    update(o) {
      if (o.docChanged) {
        let i = o.changes.mapPos(o.startState.doc.line(n.line).from), s = o.state.doc.lineAt(i);
        n = { line: s.number, col: n.col, off: Math.min(n.off, s.length) }, r = r.map(o.changes);
      }
    },
    get(o, i, s) {
      let a = HB(t, o);
      if (!a)
        return r;
      let l = Z9e(t.state, n, a);
      return l.length ? s ? $e.create(l.concat(r.ranges)) : $e.create(l) : r;
    }
  } : null;
}
function t8e(t) {
  let e = (n) => n.altKey && n.button == 0;
  return et.mouseSelectionStyle.of((n, r) => e(r) ? e8e(n, r) : null);
}
const n8e = {
  Alt: [18, (t) => !!t.altKey],
  Control: [17, (t) => !!t.ctrlKey],
  Shift: [16, (t) => !!t.shiftKey],
  Meta: [91, (t) => !!t.metaKey]
}, r8e = { style: "cursor: crosshair" };
function o8e(t = {}) {
  let [e, n] = n8e[t.key || "Alt"], r = kr.fromClass(class {
    constructor(o) {
      this.view = o, this.isDown = !1;
    }
    set(o) {
      this.isDown != o && (this.isDown = o, this.view.update([]));
    }
  }, {
    eventObservers: {
      keydown(o) {
        this.set(o.keyCode == e || n(o));
      },
      keyup(o) {
        (o.keyCode == e || !n(o)) && this.set(!1);
      },
      mousemove(o) {
        this.set(n(o));
      }
    }
  });
  return [
    r,
    et.contentAttributes.of((o) => {
      var i;
      return !((i = o.plugin(r)) === null || i === void 0) && i.isDown ? r8e : null;
    })
  ];
}
const lm = "-10000px";
class Lde {
  constructor(e, n, r, o) {
    this.facet = n, this.createTooltipView = r, this.removeTooltipView = o, this.input = e.state.facet(n), this.tooltips = this.input.filter((s) => s);
    let i = null;
    this.tooltipViews = this.tooltips.map((s) => i = r(s, i));
  }
  update(e, n) {
    var r;
    let o = e.state.facet(this.facet), i = o.filter((l) => l);
    if (o === this.input) {
      for (let l of this.tooltipViews)
        l.update && l.update(e);
      return !1;
    }
    let s = [], a = n ? [] : null;
    for (let l = 0; l < i.length; l++) {
      let c = i[l], u = -1;
      if (c) {
        for (let d = 0; d < this.tooltips.length; d++) {
          let f = this.tooltips[d];
          f && f.create == c.create && (u = d);
        }
        if (u < 0)
          s[l] = this.createTooltipView(c, l ? s[l - 1] : null), a && (a[l] = !!c.above);
        else {
          let d = s[l] = this.tooltipViews[u];
          a && (a[l] = n[u]), d.update && d.update(e);
        }
      }
    }
    for (let l of this.tooltipViews)
      s.indexOf(l) < 0 && (this.removeTooltipView(l), (r = l.destroy) === null || r === void 0 || r.call(l));
    return n && (a.forEach((l, c) => n[c] = l), n.length = a.length), this.input = o, this.tooltips = i, this.tooltipViews = s, !0;
  }
}
function i8e(t) {
  let { win: e } = t;
  return { top: 0, left: 0, bottom: e.innerHeight, right: e.innerWidth };
}
const ok = /* @__PURE__ */ lt.define({
  combine: (t) => {
    var e, n, r;
    return {
      position: rt.ios ? "absolute" : ((e = t.find((o) => o.position)) === null || e === void 0 ? void 0 : e.position) || "fixed",
      parent: ((n = t.find((o) => o.parent)) === null || n === void 0 ? void 0 : n.parent) || null,
      tooltipSpace: ((r = t.find((o) => o.tooltipSpace)) === null || r === void 0 ? void 0 : r.tooltipSpace) || i8e
    };
  }
}), VB = /* @__PURE__ */ new WeakMap(), uL = /* @__PURE__ */ kr.fromClass(class {
  constructor(t) {
    this.view = t, this.above = [], this.inView = !0, this.madeAbsolute = !1, this.lastTransaction = 0, this.measureTimeout = -1;
    let e = t.state.facet(ok);
    this.position = e.position, this.parent = e.parent, this.classes = t.themeClasses, this.createContainer(), this.measureReq = { read: this.readMeasure.bind(this), write: this.writeMeasure.bind(this), key: this }, this.resizeObserver = typeof ResizeObserver == "function" ? new ResizeObserver(() => this.measureSoon()) : null, this.manager = new Lde(t, TS, (n, r) => this.createTooltip(n, r), (n) => {
      this.resizeObserver && this.resizeObserver.unobserve(n.dom), n.dom.remove();
    }), this.above = this.manager.tooltips.map((n) => !!n.above), this.intersectionObserver = typeof IntersectionObserver == "function" ? new IntersectionObserver((n) => {
      Date.now() > this.lastTransaction - 50 && n.length > 0 && n[n.length - 1].intersectionRatio < 1 && this.measureSoon();
    }, { threshold: [1] }) : null, this.observeIntersection(), t.win.addEventListener("resize", this.measureSoon = this.measureSoon.bind(this)), this.maybeMeasure();
  }
  createContainer() {
    this.parent ? (this.container = document.createElement("div"), this.container.style.position = "relative", this.container.className = this.view.themeClasses, this.parent.appendChild(this.container)) : this.container = this.view.dom;
  }
  observeIntersection() {
    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect();
      for (let t of this.manager.tooltipViews)
        this.intersectionObserver.observe(t.dom);
    }
  }
  measureSoon() {
    this.measureTimeout < 0 && (this.measureTimeout = setTimeout(() => {
      this.measureTimeout = -1, this.maybeMeasure();
    }, 50));
  }
  update(t) {
    t.transactions.length && (this.lastTransaction = Date.now());
    let e = this.manager.update(t, this.above);
    e && this.observeIntersection();
    let n = e || t.geometryChanged, r = t.state.facet(ok);
    if (r.position != this.position && !this.madeAbsolute) {
      this.position = r.position;
      for (let o of this.manager.tooltipViews)
        o.dom.style.position = this.position;
      n = !0;
    }
    if (r.parent != this.parent) {
      this.parent && this.container.remove(), this.parent = r.parent, this.createContainer();
      for (let o of this.manager.tooltipViews)
        this.container.appendChild(o.dom);
      n = !0;
    } else this.parent && this.view.themeClasses != this.classes && (this.classes = this.container.className = this.view.themeClasses);
    n && this.maybeMeasure();
  }
  createTooltip(t, e) {
    let n = t.create(this.view), r = e ? e.dom : null;
    if (n.dom.classList.add("cm-tooltip"), t.arrow && !n.dom.querySelector(".cm-tooltip > .cm-tooltip-arrow")) {
      let o = document.createElement("div");
      o.className = "cm-tooltip-arrow", n.dom.appendChild(o);
    }
    return n.dom.style.position = this.position, n.dom.style.top = lm, n.dom.style.left = "0px", this.container.insertBefore(n.dom, r), n.mount && n.mount(this.view), this.resizeObserver && this.resizeObserver.observe(n.dom), n;
  }
  destroy() {
    var t, e, n;
    this.view.win.removeEventListener("resize", this.measureSoon);
    for (let r of this.manager.tooltipViews)
      r.dom.remove(), (t = r.destroy) === null || t === void 0 || t.call(r);
    this.parent && this.container.remove(), (e = this.resizeObserver) === null || e === void 0 || e.disconnect(), (n = this.intersectionObserver) === null || n === void 0 || n.disconnect(), clearTimeout(this.measureTimeout);
  }
  readMeasure() {
    let t = 1, e = 1, n = !1;
    if (this.position == "fixed" && this.manager.tooltipViews.length) {
      let { dom: i } = this.manager.tooltipViews[0];
      if (rt.gecko)
        n = i.offsetParent != this.container.ownerDocument.body;
      else if (i.style.top == lm && i.style.left == "0px") {
        let s = i.getBoundingClientRect();
        n = Math.abs(s.top + 1e4) > 1 || Math.abs(s.left) > 1;
      }
    }
    if (n || this.position == "absolute")
      if (this.parent) {
        let i = this.parent.getBoundingClientRect();
        i.width && i.height && (t = i.width / this.parent.offsetWidth, e = i.height / this.parent.offsetHeight);
      } else
        ({ scaleX: t, scaleY: e } = this.view.viewState);
    let r = this.view.scrollDOM.getBoundingClientRect(), o = iL(this.view);
    return {
      visible: {
        left: r.left + o.left,
        top: r.top + o.top,
        right: r.right - o.right,
        bottom: r.bottom - o.bottom
      },
      parent: this.parent ? this.container.getBoundingClientRect() : this.view.dom.getBoundingClientRect(),
      pos: this.manager.tooltips.map((i, s) => {
        let a = this.manager.tooltipViews[s];
        return a.getCoords ? a.getCoords(i.pos) : this.view.coordsAtPos(i.pos);
      }),
      size: this.manager.tooltipViews.map(({ dom: i }) => i.getBoundingClientRect()),
      space: this.view.state.facet(ok).tooltipSpace(this.view),
      scaleX: t,
      scaleY: e,
      makeAbsolute: n
    };
  }
  writeMeasure(t) {
    var e;
    if (t.makeAbsolute) {
      this.madeAbsolute = !0, this.position = "absolute";
      for (let a of this.manager.tooltipViews)
        a.dom.style.position = "absolute";
    }
    let { visible: n, space: r, scaleX: o, scaleY: i } = t, s = [];
    for (let a = 0; a < this.manager.tooltips.length; a++) {
      let l = this.manager.tooltips[a], c = this.manager.tooltipViews[a], { dom: u } = c, d = t.pos[a], f = t.size[a];
      if (!d || l.clip !== !1 && (d.bottom <= Math.max(n.top, r.top) || d.top >= Math.min(n.bottom, r.bottom) || d.right < Math.max(n.left, r.left) - 0.1 || d.left > Math.min(n.right, r.right) + 0.1)) {
        u.style.top = lm;
        continue;
      }
      let h = l.arrow ? c.dom.querySelector(".cm-tooltip-arrow") : null, p = h ? 7 : 0, m = f.right - f.left, g = (e = VB.get(c)) !== null && e !== void 0 ? e : f.bottom - f.top, y = c.offset || a8e, v = this.view.textDirection == Kn.LTR, b = f.width > r.right - r.left ? v ? r.left : r.right - f.width : v ? Math.max(r.left, Math.min(d.left - (h ? 14 : 0) + y.x, r.right - m)) : Math.min(Math.max(r.left, d.left - m + (h ? 14 : 0) - y.x), r.right - m), _ = this.above[a];
      !l.strictSide && (_ ? d.top - g - p - y.y < r.top : d.bottom + g + p + y.y > r.bottom) && _ == r.bottom - d.bottom > d.top - r.top && (_ = this.above[a] = !_);
      let w = (_ ? d.top - r.top : r.bottom - d.bottom) - p;
      if (w < g && c.resize !== !1) {
        if (w < this.view.defaultLineHeight) {
          u.style.top = lm;
          continue;
        }
        VB.set(c, g), u.style.height = (g = w) / i + "px";
      } else u.style.height && (u.style.height = "");
      let x = _ ? d.top - g - p - y.y : d.bottom + p + y.y, E = b + m;
      if (c.overlap !== !0)
        for (let S of s)
          S.left < E && S.right > b && S.top < x + g && S.bottom > x && (x = _ ? S.top - g - 2 - p : S.bottom + p + 2);
      if (this.position == "absolute" ? (u.style.top = (x - t.parent.top) / i + "px", WB(u, (b - t.parent.left) / o)) : (u.style.top = x / i + "px", WB(u, b / o)), h) {
        let S = d.left + (v ? y.x : -y.x) - (b + 14 - 7);
        h.style.left = S / o + "px";
      }
      c.overlap !== !0 && s.push({ left: b, top: x, right: E, bottom: x + g }), u.classList.toggle("cm-tooltip-above", _), u.classList.toggle("cm-tooltip-below", !_), c.positioned && c.positioned(t.space);
    }
  }
  maybeMeasure() {
    if (this.manager.tooltips.length && (this.view.inView && this.view.requestMeasure(this.measureReq), this.inView != this.view.inView && (this.inView = this.view.inView, !this.inView)))
      for (let t of this.manager.tooltipViews)
        t.dom.style.top = lm;
  }
}, {
  eventObservers: {
    scroll() {
      this.maybeMeasure();
    }
  }
});
function WB(t, e) {
  let n = parseInt(t.style.left, 10);
  (isNaN(n) || Math.abs(e - n) > 1) && (t.style.left = e + "px");
}
const s8e = /* @__PURE__ */ et.baseTheme({
  ".cm-tooltip": {
    zIndex: 500,
    boxSizing: "border-box"
  },
  "&light .cm-tooltip": {
    border: "1px solid #bbb",
    backgroundColor: "#f5f5f5"
  },
  "&light .cm-tooltip-section:not(:first-child)": {
    borderTop: "1px solid #bbb"
  },
  "&dark .cm-tooltip": {
    backgroundColor: "#333338",
    color: "white"
  },
  ".cm-tooltip-arrow": {
    height: "7px",
    width: `${7 * 2}px`,
    position: "absolute",
    zIndex: -1,
    overflow: "hidden",
    "&:before, &:after": {
      content: "''",
      position: "absolute",
      width: 0,
      height: 0,
      borderLeft: "7px solid transparent",
      borderRight: "7px solid transparent"
    },
    ".cm-tooltip-above &": {
      bottom: "-7px",
      "&:before": {
        borderTop: "7px solid #bbb"
      },
      "&:after": {
        borderTop: "7px solid #f5f5f5",
        bottom: "1px"
      }
    },
    ".cm-tooltip-below &": {
      top: "-7px",
      "&:before": {
        borderBottom: "7px solid #bbb"
      },
      "&:after": {
        borderBottom: "7px solid #f5f5f5",
        top: "1px"
      }
    }
  },
  "&dark .cm-tooltip .cm-tooltip-arrow": {
    "&:before": {
      borderTopColor: "#333338",
      borderBottomColor: "#333338"
    },
    "&:after": {
      borderTopColor: "transparent",
      borderBottomColor: "transparent"
    }
  }
}), a8e = { x: 0, y: 0 }, TS = /* @__PURE__ */ lt.define({
  enables: [uL, s8e]
}), Ox = /* @__PURE__ */ lt.define({
  combine: (t) => t.reduce((e, n) => e.concat(n), [])
});
class RS {
  // Needs to be static so that host tooltip instances always match
  static create(e) {
    return new RS(e);
  }
  constructor(e) {
    this.view = e, this.mounted = !1, this.dom = document.createElement("div"), this.dom.classList.add("cm-tooltip-hover"), this.manager = new Lde(e, Ox, (n, r) => this.createHostedView(n, r), (n) => n.dom.remove());
  }
  createHostedView(e, n) {
    let r = e.create(this.view);
    return r.dom.classList.add("cm-tooltip-section"), this.dom.insertBefore(r.dom, n ? n.dom.nextSibling : this.dom.firstChild), this.mounted && r.mount && r.mount(this.view), r;
  }
  mount(e) {
    for (let n of this.manager.tooltipViews)
      n.mount && n.mount(e);
    this.mounted = !0;
  }
  positioned(e) {
    for (let n of this.manager.tooltipViews)
      n.positioned && n.positioned(e);
  }
  update(e) {
    this.manager.update(e);
  }
  destroy() {
    var e;
    for (let n of this.manager.tooltipViews)
      (e = n.destroy) === null || e === void 0 || e.call(n);
  }
  passProp(e) {
    let n;
    for (let r of this.manager.tooltipViews) {
      let o = r[e];
      if (o !== void 0) {
        if (n === void 0)
          n = o;
        else if (n !== o)
          return;
      }
    }
    return n;
  }
  get offset() {
    return this.passProp("offset");
  }
  get getCoords() {
    return this.passProp("getCoords");
  }
  get overlap() {
    return this.passProp("overlap");
  }
  get resize() {
    return this.passProp("resize");
  }
}
const l8e = /* @__PURE__ */ TS.compute([Ox], (t) => {
  let e = t.facet(Ox);
  return e.length === 0 ? null : {
    pos: Math.min(...e.map((n) => n.pos)),
    end: Math.max(...e.map((n) => {
      var r;
      return (r = n.end) !== null && r !== void 0 ? r : n.pos;
    })),
    create: RS.create,
    above: e[0].above,
    arrow: e.some((n) => n.arrow)
  };
});
class c8e {
  constructor(e, n, r, o, i) {
    this.view = e, this.source = n, this.field = r, this.setHover = o, this.hoverTime = i, this.hoverTimeout = -1, this.restartTimeout = -1, this.pending = null, this.lastMove = { x: 0, y: 0, target: e.dom, time: 0 }, this.checkHover = this.checkHover.bind(this), e.dom.addEventListener("mouseleave", this.mouseleave = this.mouseleave.bind(this)), e.dom.addEventListener("mousemove", this.mousemove = this.mousemove.bind(this));
  }
  update() {
    this.pending && (this.pending = null, clearTimeout(this.restartTimeout), this.restartTimeout = setTimeout(() => this.startHover(), 20));
  }
  get active() {
    return this.view.state.field(this.field);
  }
  checkHover() {
    if (this.hoverTimeout = -1, this.active.length)
      return;
    let e = Date.now() - this.lastMove.time;
    e < this.hoverTime ? this.hoverTimeout = setTimeout(this.checkHover, this.hoverTime - e) : this.startHover();
  }
  startHover() {
    clearTimeout(this.restartTimeout);
    let { view: e, lastMove: n } = this, r = e.docView.nearest(n.target);
    if (!r)
      return;
    let o, i = 1;
    if (r instanceof Z5)
      o = r.posAtStart;
    else {
      if (o = e.posAtCoords(n), o == null)
        return;
      let a = e.coordsAtPos(o);
      if (!a || n.y < a.top || n.y > a.bottom || n.x < a.left - e.defaultCharacterWidth || n.x > a.right + e.defaultCharacterWidth)
        return;
      let l = e.bidiSpans(e.state.doc.lineAt(o)).find((u) => u.from <= o && u.to >= o), c = l && l.dir == Kn.RTL ? -1 : 1;
      i = n.x < a.left ? -c : c;
    }
    let s = this.source(e, o, i);
    if (s?.then) {
      let a = this.pending = { pos: o };
      s.then((l) => {
        this.pending == a && (this.pending = null, l && !(Array.isArray(l) && !l.length) && e.dispatch({ effects: this.setHover.of(Array.isArray(l) ? l : [l]) }));
      }, (l) => Wo(e.state, l, "hover tooltip"));
    } else s && !(Array.isArray(s) && !s.length) && e.dispatch({ effects: this.setHover.of(Array.isArray(s) ? s : [s]) });
  }
  get tooltip() {
    let e = this.view.plugin(uL), n = e ? e.manager.tooltips.findIndex((r) => r.create == RS.create) : -1;
    return n > -1 ? e.manager.tooltipViews[n] : null;
  }
  mousemove(e) {
    var n, r;
    this.lastMove = { x: e.clientX, y: e.clientY, target: e.target, time: Date.now() }, this.hoverTimeout < 0 && (this.hoverTimeout = setTimeout(this.checkHover, this.hoverTime));
    let { active: o, tooltip: i } = this;
    if (o.length && i && !u8e(i.dom, e) || this.pending) {
      let { pos: s } = o[0] || this.pending, a = (r = (n = o[0]) === null || n === void 0 ? void 0 : n.end) !== null && r !== void 0 ? r : s;
      (s == a ? this.view.posAtCoords(this.lastMove) != s : !d8e(this.view, s, a, e.clientX, e.clientY)) && (this.view.dispatch({ effects: this.setHover.of([]) }), this.pending = null);
    }
  }
  mouseleave(e) {
    clearTimeout(this.hoverTimeout), this.hoverTimeout = -1;
    let { active: n } = this;
    if (n.length) {
      let { tooltip: r } = this;
      r && r.dom.contains(e.relatedTarget) ? this.watchTooltipLeave(r.dom) : this.view.dispatch({ effects: this.setHover.of([]) });
    }
  }
  watchTooltipLeave(e) {
    let n = (r) => {
      e.removeEventListener("mouseleave", n), this.active.length && !this.view.dom.contains(r.relatedTarget) && this.view.dispatch({ effects: this.setHover.of([]) });
    };
    e.addEventListener("mouseleave", n);
  }
  destroy() {
    clearTimeout(this.hoverTimeout), this.view.dom.removeEventListener("mouseleave", this.mouseleave), this.view.dom.removeEventListener("mousemove", this.mousemove);
  }
}
const Ib = 4;
function u8e(t, e) {
  let { left: n, right: r, top: o, bottom: i } = t.getBoundingClientRect(), s;
  if (s = t.querySelector(".cm-tooltip-arrow")) {
    let a = s.getBoundingClientRect();
    o = Math.min(a.top, o), i = Math.max(a.bottom, i);
  }
  return e.clientX >= n - Ib && e.clientX <= r + Ib && e.clientY >= o - Ib && e.clientY <= i + Ib;
}
function d8e(t, e, n, r, o, i) {
  let s = t.scrollDOM.getBoundingClientRect(), a = t.documentTop + t.documentPadding.top + t.contentHeight;
  if (s.left > r || s.right < r || s.top > o || Math.min(s.bottom, a) < o)
    return !1;
  let l = t.posAtCoords({ x: r, y: o }, !1);
  return l >= e && l <= n;
}
function f8e(t, e = {}) {
  let n = xt.define(), r = jr.define({
    create() {
      return [];
    },
    update(o, i) {
      if (o.length && (e.hideOnChange && (i.docChanged || i.selection) ? o = [] : e.hideOn && (o = o.filter((s) => !e.hideOn(i, s))), i.docChanged)) {
        let s = [];
        for (let a of o) {
          let l = i.changes.mapPos(a.pos, -1, Co.TrackDel);
          if (l != null) {
            let c = Object.assign(/* @__PURE__ */ Object.create(null), a);
            c.pos = l, c.end != null && (c.end = i.changes.mapPos(c.end)), s.push(c);
          }
        }
        o = s;
      }
      for (let s of i.effects)
        s.is(n) && (o = s.value), s.is(h8e) && (o = []);
      return o;
    },
    provide: (o) => Ox.from(o)
  });
  return {
    active: r,
    extension: [
      r,
      kr.define((o) => new c8e(
        o,
        t,
        r,
        n,
        e.hoverTime || 300
        /* Hover.Time */
      )),
      l8e
    ]
  };
}
function Fde(t, e) {
  let n = t.plugin(uL);
  if (!n)
    return null;
  let r = n.manager.tooltips.indexOf(e);
  return r < 0 ? null : n.manager.tooltipViews[r];
}
const h8e = /* @__PURE__ */ xt.define(), GB = /* @__PURE__ */ lt.define({
  combine(t) {
    let e, n;
    for (let r of t)
      e = e || r.topContainer, n = n || r.bottomContainer;
    return { topContainer: e, bottomContainer: n };
  }
});
function X0(t, e) {
  let n = t.plugin(Bde), r = n ? n.specs.indexOf(e) : -1;
  return r > -1 ? n.panels[r] : null;
}
const Bde = /* @__PURE__ */ kr.fromClass(class {
  constructor(t) {
    this.input = t.state.facet(Q0), this.specs = this.input.filter((n) => n), this.panels = this.specs.map((n) => n(t));
    let e = t.state.facet(GB);
    this.top = new Nb(t, !0, e.topContainer), this.bottom = new Nb(t, !1, e.bottomContainer), this.top.sync(this.panels.filter((n) => n.top)), this.bottom.sync(this.panels.filter((n) => !n.top));
    for (let n of this.panels)
      n.dom.classList.add("cm-panel"), n.mount && n.mount();
  }
  update(t) {
    let e = t.state.facet(GB);
    this.top.container != e.topContainer && (this.top.sync([]), this.top = new Nb(t.view, !0, e.topContainer)), this.bottom.container != e.bottomContainer && (this.bottom.sync([]), this.bottom = new Nb(t.view, !1, e.bottomContainer)), this.top.syncClasses(), this.bottom.syncClasses();
    let n = t.state.facet(Q0);
    if (n != this.input) {
      let r = n.filter((l) => l), o = [], i = [], s = [], a = [];
      for (let l of r) {
        let c = this.specs.indexOf(l), u;
        c < 0 ? (u = l(t.view), a.push(u)) : (u = this.panels[c], u.update && u.update(t)), o.push(u), (u.top ? i : s).push(u);
      }
      this.specs = r, this.panels = o, this.top.sync(i), this.bottom.sync(s);
      for (let l of a)
        l.dom.classList.add("cm-panel"), l.mount && l.mount();
    } else
      for (let r of this.panels)
        r.update && r.update(t);
  }
  destroy() {
    this.top.sync([]), this.bottom.sync([]);
  }
}, {
  provide: (t) => et.scrollMargins.of((e) => {
    let n = e.plugin(t);
    return n && { top: n.top.scrollMargin(), bottom: n.bottom.scrollMargin() };
  })
});
class Nb {
  constructor(e, n, r) {
    this.view = e, this.top = n, this.container = r, this.dom = void 0, this.classes = "", this.panels = [], this.syncClasses();
  }
  sync(e) {
    for (let n of this.panels)
      n.destroy && e.indexOf(n) < 0 && n.destroy();
    this.panels = e, this.syncDOM();
  }
  syncDOM() {
    if (this.panels.length == 0) {
      this.dom && (this.dom.remove(), this.dom = void 0);
      return;
    }
    if (!this.dom) {
      this.dom = document.createElement("div"), this.dom.className = this.top ? "cm-panels cm-panels-top" : "cm-panels cm-panels-bottom", this.dom.style[this.top ? "top" : "bottom"] = "0";
      let n = this.container || this.view.dom;
      n.insertBefore(this.dom, this.top ? n.firstChild : null);
    }
    let e = this.dom.firstChild;
    for (let n of this.panels)
      if (n.dom.parentNode == this.dom) {
        for (; e != n.dom; )
          e = YB(e);
        e = e.nextSibling;
      } else
        this.dom.insertBefore(n.dom, e);
    for (; e; )
      e = YB(e);
  }
  scrollMargin() {
    return !this.dom || this.container ? 0 : Math.max(0, this.top ? this.dom.getBoundingClientRect().bottom - Math.max(0, this.view.scrollDOM.getBoundingClientRect().top) : Math.min(innerHeight, this.view.scrollDOM.getBoundingClientRect().bottom) - this.dom.getBoundingClientRect().top);
  }
  syncClasses() {
    if (!(!this.container || this.classes == this.view.themeClasses)) {
      for (let e of this.classes.split(" "))
        e && this.container.classList.remove(e);
      for (let e of (this.classes = this.view.themeClasses).split(" "))
        e && this.container.classList.add(e);
    }
  }
}
function YB(t) {
  let e = t.nextSibling;
  return t.remove(), e;
}
const Q0 = /* @__PURE__ */ lt.define({
  enables: Bde
});
let Nl = class extends Pd {
  /**
  @internal
  */
  compare(e) {
    return this == e || this.constructor == e.constructor && this.eq(e);
  }
  /**
  Compare this marker to another marker of the same type.
  */
  eq(e) {
    return !1;
  }
  /**
  Called if the marker has a `toDOM` method and its representation
  was removed from a gutter.
  */
  destroy(e) {
  }
};
Nl.prototype.elementClass = "";
Nl.prototype.toDOM = void 0;
Nl.prototype.mapMode = Co.TrackBefore;
Nl.prototype.startSide = Nl.prototype.endSide = -1;
Nl.prototype.point = !0;
const vw = /* @__PURE__ */ lt.define(), p8e = /* @__PURE__ */ lt.define(), m8e = {
  class: "",
  renderEmptyElements: !1,
  elementStyle: "",
  markers: () => or.empty,
  lineMarker: () => null,
  widgetMarker: () => null,
  lineMarkerChange: null,
  initialSpacer: null,
  updateSpacer: null,
  domEventHandlers: {}
}, r0 = /* @__PURE__ */ lt.define();
function g8e(t) {
  return [zde(), r0.of(Object.assign(Object.assign({}, m8e), t))];
}
const KB = /* @__PURE__ */ lt.define({
  combine: (t) => t.some((e) => e)
});
function zde(t) {
  return [
    y8e
  ];
}
const y8e = /* @__PURE__ */ kr.fromClass(class {
  constructor(t) {
    this.view = t, this.prevViewport = t.viewport, this.dom = document.createElement("div"), this.dom.className = "cm-gutters", this.dom.setAttribute("aria-hidden", "true"), this.dom.style.minHeight = this.view.contentHeight / this.view.scaleY + "px", this.gutters = t.state.facet(r0).map((e) => new QB(t, e));
    for (let e of this.gutters)
      this.dom.appendChild(e.dom);
    this.fixed = !t.state.facet(KB), this.fixed && (this.dom.style.position = "sticky"), this.syncGutters(!1), t.scrollDOM.insertBefore(this.dom, t.contentDOM);
  }
  update(t) {
    if (this.updateGutters(t)) {
      let e = this.prevViewport, n = t.view.viewport, r = Math.min(e.to, n.to) - Math.max(e.from, n.from);
      this.syncGutters(r < (n.to - n.from) * 0.8);
    }
    t.geometryChanged && (this.dom.style.minHeight = this.view.contentHeight / this.view.scaleY + "px"), this.view.state.facet(KB) != !this.fixed && (this.fixed = !this.fixed, this.dom.style.position = this.fixed ? "sticky" : ""), this.prevViewport = t.view.viewport;
  }
  syncGutters(t) {
    let e = this.dom.nextSibling;
    t && this.dom.remove();
    let n = or.iter(this.view.state.facet(vw), this.view.viewport.from), r = [], o = this.gutters.map((i) => new v8e(i, this.view.viewport, -this.view.documentPadding.top));
    for (let i of this.view.viewportLineBlocks)
      if (r.length && (r = []), Array.isArray(i.type)) {
        let s = !0;
        for (let a of i.type)
          if (a.type == Ao.Text && s) {
            pN(n, r, a.from);
            for (let l of o)
              l.line(this.view, a, r);
            s = !1;
          } else if (a.widget)
            for (let l of o)
              l.widget(this.view, a);
      } else if (i.type == Ao.Text) {
        pN(n, r, i.from);
        for (let s of o)
          s.line(this.view, i, r);
      } else if (i.widget)
        for (let s of o)
          s.widget(this.view, i);
    for (let i of o)
      i.finish();
    t && this.view.scrollDOM.insertBefore(this.dom, e);
  }
  updateGutters(t) {
    let e = t.startState.facet(r0), n = t.state.facet(r0), r = t.docChanged || t.heightChanged || t.viewportChanged || !or.eq(t.startState.facet(vw), t.state.facet(vw), t.view.viewport.from, t.view.viewport.to);
    if (e == n)
      for (let o of this.gutters)
        o.update(t) && (r = !0);
    else {
      r = !0;
      let o = [];
      for (let i of n) {
        let s = e.indexOf(i);
        s < 0 ? o.push(new QB(this.view, i)) : (this.gutters[s].update(t), o.push(this.gutters[s]));
      }
      for (let i of this.gutters)
        i.dom.remove(), o.indexOf(i) < 0 && i.destroy();
      for (let i of o)
        this.dom.appendChild(i.dom);
      this.gutters = o;
    }
    return r;
  }
  destroy() {
    for (let t of this.gutters)
      t.destroy();
    this.dom.remove();
  }
}, {
  provide: (t) => et.scrollMargins.of((e) => {
    let n = e.plugin(t);
    return !n || n.gutters.length == 0 || !n.fixed ? null : e.textDirection == Kn.LTR ? { left: n.dom.offsetWidth * e.scaleX } : { right: n.dom.offsetWidth * e.scaleX };
  })
});
function XB(t) {
  return Array.isArray(t) ? t : [t];
}
function pN(t, e, n) {
  for (; t.value && t.from <= n; )
    t.from == n && e.push(t.value), t.next();
}
class v8e {
  constructor(e, n, r) {
    this.gutter = e, this.height = r, this.i = 0, this.cursor = or.iter(e.markers, n.from);
  }
  addElement(e, n, r) {
    let { gutter: o } = this, i = (n.top - this.height) / e.scaleY, s = n.height / e.scaleY;
    if (this.i == o.elements.length) {
      let a = new qde(e, s, i, r);
      o.elements.push(a), o.dom.appendChild(a.dom);
    } else
      o.elements[this.i].update(e, s, i, r);
    this.height = n.bottom, this.i++;
  }
  line(e, n, r) {
    let o = [];
    pN(this.cursor, o, n.from), r.length && (o = o.concat(r));
    let i = this.gutter.config.lineMarker(e, n, o);
    i && o.unshift(i);
    let s = this.gutter;
    o.length == 0 && !s.config.renderEmptyElements || this.addElement(e, n, o);
  }
  widget(e, n) {
    let r = this.gutter.config.widgetMarker(e, n.widget, n), o = r ? [r] : null;
    for (let i of e.state.facet(p8e)) {
      let s = i(e, n.widget, n);
      s && (o || (o = [])).push(s);
    }
    o && this.addElement(e, n, o);
  }
  finish() {
    let e = this.gutter;
    for (; e.elements.length > this.i; ) {
      let n = e.elements.pop();
      e.dom.removeChild(n.dom), n.destroy();
    }
  }
}
class QB {
  constructor(e, n) {
    this.view = e, this.config = n, this.elements = [], this.spacer = null, this.dom = document.createElement("div"), this.dom.className = "cm-gutter" + (this.config.class ? " " + this.config.class : "");
    for (let r in n.domEventHandlers)
      this.dom.addEventListener(r, (o) => {
        let i = o.target, s;
        if (i != this.dom && this.dom.contains(i)) {
          for (; i.parentNode != this.dom; )
            i = i.parentNode;
          let l = i.getBoundingClientRect();
          s = (l.top + l.bottom) / 2;
        } else
          s = o.clientY;
        let a = e.lineBlockAtHeight(s - e.documentTop);
        n.domEventHandlers[r](e, a, o) && o.preventDefault();
      });
    this.markers = XB(n.markers(e)), n.initialSpacer && (this.spacer = new qde(e, 0, 0, [n.initialSpacer(e)]), this.dom.appendChild(this.spacer.dom), this.spacer.dom.style.cssText += "visibility: hidden; pointer-events: none");
  }
  update(e) {
    let n = this.markers;
    if (this.markers = XB(this.config.markers(e.view)), this.spacer && this.config.updateSpacer) {
      let o = this.config.updateSpacer(this.spacer.markers[0], e);
      o != this.spacer.markers[0] && this.spacer.update(e.view, 0, 0, [o]);
    }
    let r = e.view.viewport;
    return !or.eq(this.markers, n, r.from, r.to) || (this.config.lineMarkerChange ? this.config.lineMarkerChange(e) : !1);
  }
  destroy() {
    for (let e of this.elements)
      e.destroy();
  }
}
class qde {
  constructor(e, n, r, o) {
    this.height = -1, this.above = 0, this.markers = [], this.dom = document.createElement("div"), this.dom.className = "cm-gutterElement", this.update(e, n, r, o);
  }
  update(e, n, r, o) {
    this.height != n && (this.height = n, this.dom.style.height = n + "px"), this.above != r && (this.dom.style.marginTop = (this.above = r) ? r + "px" : ""), b8e(this.markers, o) || this.setMarkers(e, o);
  }
  setMarkers(e, n) {
    let r = "cm-gutterElement", o = this.dom.firstChild;
    for (let i = 0, s = 0; ; ) {
      let a = s, l = i < n.length ? n[i++] : null, c = !1;
      if (l) {
        let u = l.elementClass;
        u && (r += " " + u);
        for (let d = s; d < this.markers.length; d++)
          if (this.markers[d].compare(l)) {
            a = d, c = !0;
            break;
          }
      } else
        a = this.markers.length;
      for (; s < a; ) {
        let u = this.markers[s++];
        if (u.toDOM) {
          u.destroy(o);
          let d = o.nextSibling;
          o.remove(), o = d;
        }
      }
      if (!l)
        break;
      l.toDOM && (c ? o = o.nextSibling : this.dom.insertBefore(l.toDOM(e), o)), c && s++;
    }
    this.dom.className = r, this.markers = n;
  }
  destroy() {
    this.setMarkers(null, []);
  }
}
function b8e(t, e) {
  if (t.length != e.length)
    return !1;
  for (let n = 0; n < t.length; n++)
    if (!t[n].compare(e[n]))
      return !1;
  return !0;
}
const _8e = /* @__PURE__ */ lt.define(), w8e = /* @__PURE__ */ lt.define(), Zf = /* @__PURE__ */ lt.define({
  combine(t) {
    return Ra(t, { formatNumber: String, domEventHandlers: {} }, {
      domEventHandlers(e, n) {
        let r = Object.assign({}, e);
        for (let o in n) {
          let i = r[o], s = n[o];
          r[o] = i ? (a, l, c) => i(a, l, c) || s(a, l, c) : s;
        }
        return r;
      }
    });
  }
});
let ik = class extends Nl {
  constructor(e) {
    super(), this.number = e;
  }
  eq(e) {
    return this.number == e.number;
  }
  toDOM() {
    return document.createTextNode(this.number);
  }
};
function sk(t, e) {
  return t.state.facet(Zf).formatNumber(e, t.state);
}
const x8e = /* @__PURE__ */ r0.compute([Zf], (t) => ({
  class: "cm-lineNumbers",
  renderEmptyElements: !1,
  markers(e) {
    return e.state.facet(_8e);
  },
  lineMarker(e, n, r) {
    return r.some((o) => o.toDOM) ? null : new ik(sk(e, e.state.doc.lineAt(n.from).number));
  },
  widgetMarker: (e, n, r) => {
    for (let o of e.state.facet(w8e)) {
      let i = o(e, n, r);
      if (i)
        return i;
    }
    return null;
  },
  lineMarkerChange: (e) => e.startState.facet(Zf) != e.state.facet(Zf),
  initialSpacer(e) {
    return new ik(sk(e, ZB(e.state.doc.lines)));
  },
  updateSpacer(e, n) {
    let r = sk(n.view, ZB(n.view.state.doc.lines));
    return r == e.number ? e : new ik(r);
  },
  domEventHandlers: t.facet(Zf).domEventHandlers
}));
function E8e(t = {}) {
  return [
    Zf.of(t),
    zde(),
    x8e
  ];
}
function ZB(t) {
  let e = 9;
  for (; e < t; )
    e = e * 10 + 9;
  return e;
}
const S8e = /* @__PURE__ */ new class extends Nl {
  constructor() {
    super(...arguments), this.elementClass = "cm-activeLineGutter";
  }
}(), O8e = /* @__PURE__ */ vw.compute(["selection"], (t) => {
  let e = [], n = -1;
  for (let r of t.selection.ranges) {
    let o = t.doc.lineAt(r.head).from;
    o > n && (n = o, e.push(S8e.range(o)));
  }
  return or.of(e);
});
function C8e() {
  return O8e;
}
const Ude = 1024;
let k8e = 0, ak = class {
  constructor(e, n) {
    this.from = e, this.to = n;
  }
}, Dt = class {
  /**
  Create a new node prop type.
  */
  constructor(e = {}) {
    this.id = k8e++, this.perNode = !!e.perNode, this.deserialize = e.deserialize || (() => {
      throw new Error("This node type doesn't define a deserialize function");
    });
  }
  /**
  This is meant to be used with
  [`NodeSet.extend`](#common.NodeSet.extend) or
  [`LRParser.configure`](#lr.ParserConfig.props) to compute
  prop values for each node type in the set. Takes a [match
  object](#common.NodeType^match) or function that returns undefined
  if the node type doesn't get this prop, and the prop's value if
  it does.
  */
  add(e) {
    if (this.perNode)
      throw new RangeError("Can't add per-node props to node types");
    return typeof e != "function" && (e = es.match(e)), (n) => {
      let r = e(n);
      return r === void 0 ? null : [this, r];
    };
  }
};
Dt.closedBy = new Dt({ deserialize: (t) => t.split(" ") });
Dt.openedBy = new Dt({ deserialize: (t) => t.split(" ") });
Dt.group = new Dt({ deserialize: (t) => t.split(" ") });
Dt.isolate = new Dt({ deserialize: (t) => {
  if (t && t != "rtl" && t != "ltr" && t != "auto")
    throw new RangeError("Invalid value for isolate: " + t);
  return t || "auto";
} });
Dt.contextHash = new Dt({ perNode: !0 });
Dt.lookAhead = new Dt({ perNode: !0 });
Dt.mounted = new Dt({ perNode: !0 });
class Cx {
  constructor(e, n, r) {
    this.tree = e, this.overlay = n, this.parser = r;
  }
  /**
  @internal
  */
  static get(e) {
    return e && e.props && e.props[Dt.mounted.id];
  }
}
const A8e = /* @__PURE__ */ Object.create(null);
let es = class Hde {
  /**
  @internal
  */
  constructor(e, n, r, o = 0) {
    this.name = e, this.props = n, this.id = r, this.flags = o;
  }
  /**
  Define a node type.
  */
  static define(e) {
    let n = e.props && e.props.length ? /* @__PURE__ */ Object.create(null) : A8e, r = (e.top ? 1 : 0) | (e.skipped ? 2 : 0) | (e.error ? 4 : 0) | (e.name == null ? 8 : 0), o = new Hde(e.name || "", n, e.id, r);
    if (e.props) {
      for (let i of e.props)
        if (Array.isArray(i) || (i = i(o)), i) {
          if (i[0].perNode)
            throw new RangeError("Can't store a per-node prop on a node type");
          n[i[0].id] = i[1];
        }
    }
    return o;
  }
  /**
  Retrieves a node prop for this type. Will return `undefined` if
  the prop isn't present on this node.
  */
  prop(e) {
    return this.props[e.id];
  }
  /**
  True when this is the top node of a grammar.
  */
  get isTop() {
    return (this.flags & 1) > 0;
  }
  /**
  True when this node is produced by a skip rule.
  */
  get isSkipped() {
    return (this.flags & 2) > 0;
  }
  /**
  Indicates whether this is an error node.
  */
  get isError() {
    return (this.flags & 4) > 0;
  }
  /**
  When true, this node type doesn't correspond to a user-declared
  named node, for example because it is used to cache repetition.
  */
  get isAnonymous() {
    return (this.flags & 8) > 0;
  }
  /**
  Returns true when this node's name or one of its
  [groups](#common.NodeProp^group) matches the given string.
  */
  is(e) {
    if (typeof e == "string") {
      if (this.name == e)
        return !0;
      let n = this.prop(Dt.group);
      return n ? n.indexOf(e) > -1 : !1;
    }
    return this.id == e;
  }
  /**
  Create a function from node types to arbitrary values by
  specifying an object whose property names are node or
  [group](#common.NodeProp^group) names. Often useful with
  [`NodeProp.add`](#common.NodeProp.add). You can put multiple
  names, separated by spaces, in a single property name to map
  multiple node names to a single value.
  */
  static match(e) {
    let n = /* @__PURE__ */ Object.create(null);
    for (let r in e)
      for (let o of r.split(" "))
        n[o] = e[r];
    return (r) => {
      for (let o = r.prop(Dt.group), i = -1; i < (o ? o.length : 0); i++) {
        let s = n[i < 0 ? r.name : o[i]];
        if (s)
          return s;
      }
    };
  }
};
es.none = new es(
  "",
  /* @__PURE__ */ Object.create(null),
  0,
  8
  /* NodeFlag.Anonymous */
);
class dL {
  /**
  Create a set with the given types. The `id` property of each
  type should correspond to its position within the array.
  */
  constructor(e) {
    this.types = e;
    for (let n = 0; n < e.length; n++)
      if (e[n].id != n)
        throw new RangeError("Node type ids should correspond to array positions when creating a node set");
  }
  /**
  Create a copy of this set with some node properties added. The
  arguments to this method can be created with
  [`NodeProp.add`](#common.NodeProp.add).
  */
  extend(...e) {
    let n = [];
    for (let r of this.types) {
      let o = null;
      for (let i of e) {
        let s = i(r);
        s && (o || (o = Object.assign({}, r.props)), o[s[0].id] = s[1]);
      }
      n.push(o ? new es(r.name, o, r.id, r.flags) : r);
    }
    return new dL(n);
  }
}
const jb = /* @__PURE__ */ new WeakMap(), JB = /* @__PURE__ */ new WeakMap();
var Ur;
(function(t) {
  t[t.ExcludeBuffers = 1] = "ExcludeBuffers", t[t.IncludeAnonymous = 2] = "IncludeAnonymous", t[t.IgnoreMounts = 4] = "IgnoreMounts", t[t.IgnoreOverlays = 8] = "IgnoreOverlays";
})(Ur || (Ur = {}));
let Jr = class mN {
  /**
  Construct a new tree. See also [`Tree.build`](#common.Tree^build).
  */
  constructor(e, n, r, o, i) {
    if (this.type = e, this.children = n, this.positions = r, this.length = o, this.props = null, i && i.length) {
      this.props = /* @__PURE__ */ Object.create(null);
      for (let [s, a] of i)
        this.props[typeof s == "number" ? s : s.id] = a;
    }
  }
  /**
  @internal
  */
  toString() {
    let e = Cx.get(this);
    if (e && !e.overlay)
      return e.tree.toString();
    let n = "";
    for (let r of this.children) {
      let o = r.toString();
      o && (n && (n += ","), n += o);
    }
    return this.type.name ? (/\W/.test(this.type.name) && !this.type.isError ? JSON.stringify(this.type.name) : this.type.name) + (n.length ? "(" + n + ")" : "") : n;
  }
  /**
  Get a [tree cursor](#common.TreeCursor) positioned at the top of
  the tree. Mode can be used to [control](#common.IterMode) which
  nodes the cursor visits.
  */
  cursor(e = 0) {
    return new vN(this.topNode, e);
  }
  /**
  Get a [tree cursor](#common.TreeCursor) pointing into this tree
  at the given position and side (see
  [`moveTo`](#common.TreeCursor.moveTo).
  */
  cursorAt(e, n = 0, r = 0) {
    let o = jb.get(this) || this.topNode, i = new vN(o);
    return i.moveTo(e, n), jb.set(this, i._tree), i;
  }
  /**
  Get a [syntax node](#common.SyntaxNode) object for the top of the
  tree.
  */
  get topNode() {
    return new Wi(this, 0, 0, null);
  }
  /**
  Get the [syntax node](#common.SyntaxNode) at the given position.
  If `side` is -1, this will move into nodes that end at the
  position. If 1, it'll move into nodes that start at the
  position. With 0, it'll only enter nodes that cover the position
  from both sides.
  
  Note that this will not enter
  [overlays](#common.MountedTree.overlay), and you often want
  [`resolveInner`](#common.Tree.resolveInner) instead.
  */
  resolve(e, n = 0) {
    let r = Z0(jb.get(this) || this.topNode, e, n, !1);
    return jb.set(this, r), r;
  }
  /**
  Like [`resolve`](#common.Tree.resolve), but will enter
  [overlaid](#common.MountedTree.overlay) nodes, producing a syntax node
  pointing into the innermost overlaid tree at the given position
  (with parent links going through all parent structure, including
  the host trees).
  */
  resolveInner(e, n = 0) {
    let r = Z0(JB.get(this) || this.topNode, e, n, !0);
    return JB.set(this, r), r;
  }
  /**
  In some situations, it can be useful to iterate through all
  nodes around a position, including those in overlays that don't
  directly cover the position. This method gives you an iterator
  that will produce all nodes, from small to big, around the given
  position.
  */
  resolveStack(e, n = 0) {
    return P8e(this, e, n);
  }
  /**
  Iterate over the tree and its children, calling `enter` for any
  node that touches the `from`/`to` region (if given) before
  running over such a node's children, and `leave` (if given) when
  leaving the node. When `enter` returns `false`, that node will
  not have its children iterated over (or `leave` called).
  */
  iterate(e) {
    let { enter: n, leave: r, from: o = 0, to: i = this.length } = e, s = e.mode || 0, a = (s & Ur.IncludeAnonymous) > 0;
    for (let l = this.cursor(s | Ur.IncludeAnonymous); ; ) {
      let c = !1;
      if (l.from <= i && l.to >= o && (!a && l.type.isAnonymous || n(l) !== !1)) {
        if (l.firstChild())
          continue;
        c = !0;
      }
      for (; c && r && (a || !l.type.isAnonymous) && r(l), !l.nextSibling(); ) {
        if (!l.parent())
          return;
        c = !0;
      }
    }
  }
  /**
  Get the value of the given [node prop](#common.NodeProp) for this
  node. Works with both per-node and per-type props.
  */
  prop(e) {
    return e.perNode ? this.props ? this.props[e.id] : void 0 : this.type.prop(e);
  }
  /**
  Returns the node's [per-node props](#common.NodeProp.perNode) in a
  format that can be passed to the [`Tree`](#common.Tree)
  constructor.
  */
  get propValues() {
    let e = [];
    if (this.props)
      for (let n in this.props)
        e.push([+n, this.props[n]]);
    return e;
  }
  /**
  Balance the direct children of this tree, producing a copy of
  which may have children grouped into subtrees with type
  [`NodeType.none`](#common.NodeType^none).
  */
  balance(e = {}) {
    return this.children.length <= 8 ? this : pL(es.none, this.children, this.positions, 0, this.children.length, 0, this.length, (n, r, o) => new mN(this.type, n, r, o, this.propValues), e.makeTree || ((n, r, o) => new mN(es.none, n, r, o)));
  }
  /**
  Build a tree from a postfix-ordered buffer of node information,
  or a cursor over such a buffer.
  */
  static build(e) {
    return $8e(e);
  }
};
Jr.empty = new Jr(es.none, [], [], 0);
class fL {
  constructor(e, n) {
    this.buffer = e, this.index = n;
  }
  get id() {
    return this.buffer[this.index - 4];
  }
  get start() {
    return this.buffer[this.index - 3];
  }
  get end() {
    return this.buffer[this.index - 2];
  }
  get size() {
    return this.buffer[this.index - 1];
  }
  get pos() {
    return this.index;
  }
  next() {
    this.index -= 4;
  }
  fork() {
    return new fL(this.buffer, this.index);
  }
}
let Qh = class Vde {
  /**
  Create a tree buffer.
  */
  constructor(e, n, r) {
    this.buffer = e, this.length = n, this.set = r;
  }
  /**
  @internal
  */
  get type() {
    return es.none;
  }
  /**
  @internal
  */
  toString() {
    let e = [];
    for (let n = 0; n < this.buffer.length; )
      e.push(this.childString(n)), n = this.buffer[n + 3];
    return e.join(",");
  }
  /**
  @internal
  */
  childString(e) {
    let n = this.buffer[e], r = this.buffer[e + 3], o = this.set.types[n], i = o.name;
    if (/\W/.test(i) && !o.isError && (i = JSON.stringify(i)), e += 4, r == e)
      return i;
    let s = [];
    for (; e < r; )
      s.push(this.childString(e)), e = this.buffer[e + 3];
    return i + "(" + s.join(",") + ")";
  }
  /**
  @internal
  */
  findChild(e, n, r, o, i) {
    let { buffer: s } = this, a = -1;
    for (let l = e; l != n && !(Wde(i, o, s[l + 1], s[l + 2]) && (a = l, r > 0)); l = s[l + 3])
      ;
    return a;
  }
  /**
  @internal
  */
  slice(e, n, r) {
    let o = this.buffer, i = new Uint16Array(n - e), s = 0;
    for (let a = e, l = 0; a < n; ) {
      i[l++] = o[a++], i[l++] = o[a++] - r;
      let c = i[l++] = o[a++] - r;
      i[l++] = o[a++] - e, s = Math.max(s, c);
    }
    return new Vde(i, s, this.set);
  }
};
function Wde(t, e, n, r) {
  switch (t) {
    case -2:
      return n < e;
    case -1:
      return r >= e && n < e;
    case 0:
      return n < e && r > e;
    case 1:
      return n <= e && r > e;
    case 2:
      return r > e;
    case 4:
      return !0;
  }
}
function Z0(t, e, n, r) {
  for (var o; t.from == t.to || (n < 1 ? t.from >= e : t.from > e) || (n > -1 ? t.to <= e : t.to < e); ) {
    let s = !r && t instanceof Wi && t.index < 0 ? null : t.parent;
    if (!s)
      return t;
    t = s;
  }
  let i = r ? 0 : Ur.IgnoreOverlays;
  if (r)
    for (let s = t, a = s.parent; a; s = a, a = s.parent)
      s instanceof Wi && s.index < 0 && ((o = a.enter(e, n, i)) === null || o === void 0 ? void 0 : o.from) != s.from && (t = a);
  for (; ; ) {
    let s = t.enter(e, n, i);
    if (!s)
      return t;
    t = s;
  }
}
class Gde {
  cursor(e = 0) {
    return new vN(this, e);
  }
  getChild(e, n = null, r = null) {
    let o = ez(this, e, n, r);
    return o.length ? o[0] : null;
  }
  getChildren(e, n = null, r = null) {
    return ez(this, e, n, r);
  }
  resolve(e, n = 0) {
    return Z0(this, e, n, !1);
  }
  resolveInner(e, n = 0) {
    return Z0(this, e, n, !0);
  }
  matchContext(e) {
    return gN(this.parent, e);
  }
  enterUnfinishedNodesBefore(e) {
    let n = this.childBefore(e), r = this;
    for (; n; ) {
      let o = n.lastChild;
      if (!o || o.to != n.to)
        break;
      o.type.isError && o.from == o.to ? (r = n, n = o.prevSibling) : n = o;
    }
    return r;
  }
  get node() {
    return this;
  }
  get next() {
    return this.parent;
  }
}
class Wi extends Gde {
  constructor(e, n, r, o) {
    super(), this._tree = e, this.from = n, this.index = r, this._parent = o;
  }
  get type() {
    return this._tree.type;
  }
  get name() {
    return this._tree.type.name;
  }
  get to() {
    return this.from + this._tree.length;
  }
  nextChild(e, n, r, o, i = 0) {
    for (let s = this; ; ) {
      for (let { children: a, positions: l } = s._tree, c = n > 0 ? a.length : -1; e != c; e += n) {
        let u = a[e], d = l[e] + s.from;
        if (Wde(o, r, d, d + u.length)) {
          if (u instanceof Qh) {
            if (i & Ur.ExcludeBuffers)
              continue;
            let f = u.findChild(0, u.buffer.length, n, r - d, o);
            if (f > -1)
              return new yN(new T8e(s, u, e, d), null, f);
          } else if (i & Ur.IncludeAnonymous || !u.type.isAnonymous || hL(u)) {
            let f;
            if (!(i & Ur.IgnoreMounts) && (f = Cx.get(u)) && !f.overlay)
              return new Wi(f.tree, d, e, s);
            let h = new Wi(u, d, e, s);
            return i & Ur.IncludeAnonymous || !h.type.isAnonymous ? h : h.nextChild(n < 0 ? u.children.length - 1 : 0, n, r, o);
          }
        }
      }
      if (i & Ur.IncludeAnonymous || !s.type.isAnonymous || (s.index >= 0 ? e = s.index + n : e = n < 0 ? -1 : s._parent._tree.children.length, s = s._parent, !s))
        return null;
    }
  }
  get firstChild() {
    return this.nextChild(
      0,
      1,
      0,
      4
      /* Side.DontCare */
    );
  }
  get lastChild() {
    return this.nextChild(
      this._tree.children.length - 1,
      -1,
      0,
      4
      /* Side.DontCare */
    );
  }
  childAfter(e) {
    return this.nextChild(
      0,
      1,
      e,
      2
      /* Side.After */
    );
  }
  childBefore(e) {
    return this.nextChild(
      this._tree.children.length - 1,
      -1,
      e,
      -2
      /* Side.Before */
    );
  }
  enter(e, n, r = 0) {
    let o;
    if (!(r & Ur.IgnoreOverlays) && (o = Cx.get(this._tree)) && o.overlay) {
      let i = e - this.from;
      for (let { from: s, to: a } of o.overlay)
        if ((n > 0 ? s <= i : s < i) && (n < 0 ? a >= i : a > i))
          return new Wi(o.tree, o.overlay[0].from + this.from, -1, this);
    }
    return this.nextChild(0, 1, e, n, r);
  }
  nextSignificantParent() {
    let e = this;
    for (; e.type.isAnonymous && e._parent; )
      e = e._parent;
    return e;
  }
  get parent() {
    return this._parent ? this._parent.nextSignificantParent() : null;
  }
  get nextSibling() {
    return this._parent && this.index >= 0 ? this._parent.nextChild(
      this.index + 1,
      1,
      0,
      4
      /* Side.DontCare */
    ) : null;
  }
  get prevSibling() {
    return this._parent && this.index >= 0 ? this._parent.nextChild(
      this.index - 1,
      -1,
      0,
      4
      /* Side.DontCare */
    ) : null;
  }
  get tree() {
    return this._tree;
  }
  toTree() {
    return this._tree;
  }
  /**
  @internal
  */
  toString() {
    return this._tree.toString();
  }
}
function ez(t, e, n, r) {
  let o = t.cursor(), i = [];
  if (!o.firstChild())
    return i;
  if (n != null) {
    for (let s = !1; !s; )
      if (s = o.type.is(n), !o.nextSibling())
        return i;
  }
  for (; ; ) {
    if (r != null && o.type.is(r))
      return i;
    if (o.type.is(e) && i.push(o.node), !o.nextSibling())
      return r == null ? i : [];
  }
}
function gN(t, e, n = e.length - 1) {
  for (let r = t; n >= 0; r = r.parent) {
    if (!r)
      return !1;
    if (!r.type.isAnonymous) {
      if (e[n] && e[n] != r.name)
        return !1;
      n--;
    }
  }
  return !0;
}
class T8e {
  constructor(e, n, r, o) {
    this.parent = e, this.buffer = n, this.index = r, this.start = o;
  }
}
let yN = class wg extends Gde {
  get name() {
    return this.type.name;
  }
  get from() {
    return this.context.start + this.context.buffer.buffer[this.index + 1];
  }
  get to() {
    return this.context.start + this.context.buffer.buffer[this.index + 2];
  }
  constructor(e, n, r) {
    super(), this.context = e, this._parent = n, this.index = r, this.type = e.buffer.set.types[e.buffer.buffer[r]];
  }
  child(e, n, r) {
    let { buffer: o } = this.context, i = o.findChild(this.index + 4, o.buffer[this.index + 3], e, n - this.context.start, r);
    return i < 0 ? null : new wg(this.context, this, i);
  }
  get firstChild() {
    return this.child(
      1,
      0,
      4
      /* Side.DontCare */
    );
  }
  get lastChild() {
    return this.child(
      -1,
      0,
      4
      /* Side.DontCare */
    );
  }
  childAfter(e) {
    return this.child(
      1,
      e,
      2
      /* Side.After */
    );
  }
  childBefore(e) {
    return this.child(
      -1,
      e,
      -2
      /* Side.Before */
    );
  }
  enter(e, n, r = 0) {
    if (r & Ur.ExcludeBuffers)
      return null;
    let { buffer: o } = this.context, i = o.findChild(this.index + 4, o.buffer[this.index + 3], n > 0 ? 1 : -1, e - this.context.start, n);
    return i < 0 ? null : new wg(this.context, this, i);
  }
  get parent() {
    return this._parent || this.context.parent.nextSignificantParent();
  }
  externalSibling(e) {
    return this._parent ? null : this.context.parent.nextChild(
      this.context.index + e,
      e,
      0,
      4
      /* Side.DontCare */
    );
  }
  get nextSibling() {
    let { buffer: e } = this.context, n = e.buffer[this.index + 3];
    return n < (this._parent ? e.buffer[this._parent.index + 3] : e.buffer.length) ? new wg(this.context, this._parent, n) : this.externalSibling(1);
  }
  get prevSibling() {
    let { buffer: e } = this.context, n = this._parent ? this._parent.index + 4 : 0;
    return this.index == n ? this.externalSibling(-1) : new wg(this.context, this._parent, e.findChild(
      n,
      this.index,
      -1,
      0,
      4
      /* Side.DontCare */
    ));
  }
  get tree() {
    return null;
  }
  toTree() {
    let e = [], n = [], { buffer: r } = this.context, o = this.index + 4, i = r.buffer[this.index + 3];
    if (i > o) {
      let s = r.buffer[this.index + 1];
      e.push(r.slice(o, i, s)), n.push(0);
    }
    return new Jr(this.type, e, n, this.to - this.from);
  }
  /**
  @internal
  */
  toString() {
    return this.context.buffer.childString(this.index);
  }
};
function Yde(t) {
  if (!t.length)
    return null;
  let e = 0, n = t[0];
  for (let i = 1; i < t.length; i++) {
    let s = t[i];
    (s.from > n.from || s.to < n.to) && (n = s, e = i);
  }
  let r = n instanceof Wi && n.index < 0 ? null : n.parent, o = t.slice();
  return r ? o[e] = r : o.splice(e, 1), new R8e(o, n);
}
class R8e {
  constructor(e, n) {
    this.heads = e, this.node = n;
  }
  get next() {
    return Yde(this.heads);
  }
}
function P8e(t, e, n) {
  let r = t.resolveInner(e, n), o = null;
  for (let i = r instanceof Wi ? r : r.context.parent; i; i = i.parent)
    if (i.index < 0) {
      let s = i.parent;
      (o || (o = [r])).push(s.resolve(e, n)), i = s;
    } else {
      let s = Cx.get(i.tree);
      if (s && s.overlay && s.overlay[0].from <= e && s.overlay[s.overlay.length - 1].to >= e) {
        let a = new Wi(s.tree, s.overlay[0].from + i.from, -1, i);
        (o || (o = [r])).push(Z0(a, e, n, !1));
      }
    }
  return o ? Yde(o) : r;
}
class vN {
  /**
  Shorthand for `.type.name`.
  */
  get name() {
    return this.type.name;
  }
  /**
  @internal
  */
  constructor(e, n = 0) {
    if (this.mode = n, this.buffer = null, this.stack = [], this.index = 0, this.bufferNode = null, e instanceof Wi)
      this.yieldNode(e);
    else {
      this._tree = e.context.parent, this.buffer = e.context;
      for (let r = e._parent; r; r = r._parent)
        this.stack.unshift(r.index);
      this.bufferNode = e, this.yieldBuf(e.index);
    }
  }
  yieldNode(e) {
    return e ? (this._tree = e, this.type = e.type, this.from = e.from, this.to = e.to, !0) : !1;
  }
  yieldBuf(e, n) {
    this.index = e;
    let { start: r, buffer: o } = this.buffer;
    return this.type = n || o.set.types[o.buffer[e]], this.from = r + o.buffer[e + 1], this.to = r + o.buffer[e + 2], !0;
  }
  /**
  @internal
  */
  yield(e) {
    return e ? e instanceof Wi ? (this.buffer = null, this.yieldNode(e)) : (this.buffer = e.context, this.yieldBuf(e.index, e.type)) : !1;
  }
  /**
  @internal
  */
  toString() {
    return this.buffer ? this.buffer.buffer.childString(this.index) : this._tree.toString();
  }
  /**
  @internal
  */
  enterChild(e, n, r) {
    if (!this.buffer)
      return this.yield(this._tree.nextChild(e < 0 ? this._tree._tree.children.length - 1 : 0, e, n, r, this.mode));
    let { buffer: o } = this.buffer, i = o.findChild(this.index + 4, o.buffer[this.index + 3], e, n - this.buffer.start, r);
    return i < 0 ? !1 : (this.stack.push(this.index), this.yieldBuf(i));
  }
  /**
  Move the cursor to this node's first child. When this returns
  false, the node has no child, and the cursor has not been moved.
  */
  firstChild() {
    return this.enterChild(
      1,
      0,
      4
      /* Side.DontCare */
    );
  }
  /**
  Move the cursor to this node's last child.
  */
  lastChild() {
    return this.enterChild(
      -1,
      0,
      4
      /* Side.DontCare */
    );
  }
  /**
  Move the cursor to the first child that ends after `pos`.
  */
  childAfter(e) {
    return this.enterChild(
      1,
      e,
      2
      /* Side.After */
    );
  }
  /**
  Move to the last child that starts before `pos`.
  */
  childBefore(e) {
    return this.enterChild(
      -1,
      e,
      -2
      /* Side.Before */
    );
  }
  /**
  Move the cursor to the child around `pos`. If side is -1 the
  child may end at that position, when 1 it may start there. This
  will also enter [overlaid](#common.MountedTree.overlay)
  [mounted](#common.NodeProp^mounted) trees unless `overlays` is
  set to false.
  */
  enter(e, n, r = this.mode) {
    return this.buffer ? r & Ur.ExcludeBuffers ? !1 : this.enterChild(1, e, n) : this.yield(this._tree.enter(e, n, r));
  }
  /**
  Move to the node's parent node, if this isn't the top node.
  */
  parent() {
    if (!this.buffer)
      return this.yieldNode(this.mode & Ur.IncludeAnonymous ? this._tree._parent : this._tree.parent);
    if (this.stack.length)
      return this.yieldBuf(this.stack.pop());
    let e = this.mode & Ur.IncludeAnonymous ? this.buffer.parent : this.buffer.parent.nextSignificantParent();
    return this.buffer = null, this.yieldNode(e);
  }
  /**
  @internal
  */
  sibling(e) {
    if (!this.buffer)
      return this._tree._parent ? this.yield(this._tree.index < 0 ? null : this._tree._parent.nextChild(this._tree.index + e, e, 0, 4, this.mode)) : !1;
    let { buffer: n } = this.buffer, r = this.stack.length - 1;
    if (e < 0) {
      let o = r < 0 ? 0 : this.stack[r] + 4;
      if (this.index != o)
        return this.yieldBuf(n.findChild(
          o,
          this.index,
          -1,
          0,
          4
          /* Side.DontCare */
        ));
    } else {
      let o = n.buffer[this.index + 3];
      if (o < (r < 0 ? n.buffer.length : n.buffer[this.stack[r] + 3]))
        return this.yieldBuf(o);
    }
    return r < 0 ? this.yield(this.buffer.parent.nextChild(this.buffer.index + e, e, 0, 4, this.mode)) : !1;
  }
  /**
  Move to this node's next sibling, if any.
  */
  nextSibling() {
    return this.sibling(1);
  }
  /**
  Move to this node's previous sibling, if any.
  */
  prevSibling() {
    return this.sibling(-1);
  }
  atLastNode(e) {
    let n, r, { buffer: o } = this;
    if (o) {
      if (e > 0) {
        if (this.index < o.buffer.buffer.length)
          return !1;
      } else
        for (let i = 0; i < this.index; i++)
          if (o.buffer.buffer[i + 3] < this.index)
            return !1;
      ({ index: n, parent: r } = o);
    } else
      ({ index: n, _parent: r } = this._tree);
    for (; r; { index: n, _parent: r } = r)
      if (n > -1)
        for (let i = n + e, s = e < 0 ? -1 : r._tree.children.length; i != s; i += e) {
          let a = r._tree.children[i];
          if (this.mode & Ur.IncludeAnonymous || a instanceof Qh || !a.type.isAnonymous || hL(a))
            return !1;
        }
    return !0;
  }
  move(e, n) {
    if (n && this.enterChild(
      e,
      0,
      4
      /* Side.DontCare */
    ))
      return !0;
    for (; ; ) {
      if (this.sibling(e))
        return !0;
      if (this.atLastNode(e) || !this.parent())
        return !1;
    }
  }
  /**
  Move to the next node in a
  [pre-order](https://en.wikipedia.org/wiki/Tree_traversal#Pre-order,_NLR)
  traversal, going from a node to its first child or, if the
  current node is empty or `enter` is false, its next sibling or
  the next sibling of the first parent node that has one.
  */
  next(e = !0) {
    return this.move(1, e);
  }
  /**
  Move to the next node in a last-to-first pre-order traversal. A
  node is followed by its last child or, if it has none, its
  previous sibling or the previous sibling of the first parent
  node that has one.
  */
  prev(e = !0) {
    return this.move(-1, e);
  }
  /**
  Move the cursor to the innermost node that covers `pos`. If
  `side` is -1, it will enter nodes that end at `pos`. If it is 1,
  it will enter nodes that start at `pos`.
  */
  moveTo(e, n = 0) {
    for (; (this.from == this.to || (n < 1 ? this.from >= e : this.from > e) || (n > -1 ? this.to <= e : this.to < e)) && this.parent(); )
      ;
    for (; this.enterChild(1, e, n); )
      ;
    return this;
  }
  /**
  Get a [syntax node](#common.SyntaxNode) at the cursor's current
  position.
  */
  get node() {
    if (!this.buffer)
      return this._tree;
    let e = this.bufferNode, n = null, r = 0;
    if (e && e.context == this.buffer)
      e: for (let o = this.index, i = this.stack.length; i >= 0; ) {
        for (let s = e; s; s = s._parent)
          if (s.index == o) {
            if (o == this.index)
              return s;
            n = s, r = i + 1;
            break e;
          }
        o = this.stack[--i];
      }
    for (let o = r; o < this.stack.length; o++)
      n = new yN(this.buffer, n, this.stack[o]);
    return this.bufferNode = new yN(this.buffer, n, this.index);
  }
  /**
  Get the [tree](#common.Tree) that represents the current node, if
  any. Will return null when the node is in a [tree
  buffer](#common.TreeBuffer).
  */
  get tree() {
    return this.buffer ? null : this._tree._tree;
  }
  /**
  Iterate over the current node and all its descendants, calling
  `enter` when entering a node and `leave`, if given, when leaving
  one. When `enter` returns `false`, any children of that node are
  skipped, and `leave` isn't called for it.
  */
  iterate(e, n) {
    for (let r = 0; ; ) {
      let o = !1;
      if (this.type.isAnonymous || e(this) !== !1) {
        if (this.firstChild()) {
          r++;
          continue;
        }
        this.type.isAnonymous || (o = !0);
      }
      for (; ; ) {
        if (o && n && n(this), o = this.type.isAnonymous, !r)
          return;
        if (this.nextSibling())
          break;
        this.parent(), r--, o = !0;
      }
    }
  }
  /**
  Test whether the current node matches a given context—a sequence
  of direct parent node names. Empty strings in the context array
  are treated as wildcards.
  */
  matchContext(e) {
    if (!this.buffer)
      return gN(this.node.parent, e);
    let { buffer: n } = this.buffer, { types: r } = n.set;
    for (let o = e.length - 1, i = this.stack.length - 1; o >= 0; i--) {
      if (i < 0)
        return gN(this._tree, e, o);
      let s = r[n.buffer[this.stack[i]]];
      if (!s.isAnonymous) {
        if (e[o] && e[o] != s.name)
          return !1;
        o--;
      }
    }
    return !0;
  }
}
function hL(t) {
  return t.children.some((e) => e instanceof Qh || !e.type.isAnonymous || hL(e));
}
function $8e(t) {
  var e;
  let { buffer: n, nodeSet: r, maxBufferLength: o = Ude, reused: i = [], minRepeatType: s = r.types.length } = t, a = Array.isArray(n) ? new fL(n, n.length) : n, l = r.types, c = 0, u = 0;
  function d(w, x, E, S, C, R) {
    let { id: P, start: N, end: A, size: O } = a, k = u, T = c;
    for (; O < 0; )
      if (a.next(), O == -1) {
        let D = i[P];
        E.push(D), S.push(N - w);
        return;
      } else if (O == -3) {
        c = P;
        return;
      } else if (O == -4) {
        u = P;
        return;
      } else
        throw new RangeError(`Unrecognized record size: ${O}`);
    let I = l[P], j, z, $ = N - w;
    if (A - N <= o && (z = g(a.pos - x, C))) {
      let D = new Uint16Array(z.size - z.skip), U = a.pos - z.size, q = D.length;
      for (; a.pos > U; )
        q = y(z.start, D, q);
      j = new Qh(D, A - z.start, r), $ = z.start - w;
    } else {
      let D = a.pos - O;
      a.next();
      let U = [], q = [], F = P >= s ? P : -1, B = 0, H = A;
      for (; a.pos > D; )
        F >= 0 && a.id == F && a.size >= 0 ? (a.end <= H - o && (p(U, q, N, B, a.end, H, F, k, T), B = U.length, H = a.end), a.next()) : R > 2500 ? f(N, D, U, q) : d(N, D, U, q, F, R + 1);
      if (F >= 0 && B > 0 && B < U.length && p(U, q, N, B, N, H, F, k, T), U.reverse(), q.reverse(), F > -1 && B > 0) {
        let Z = h(I, T);
        j = pL(I, U, q, 0, U.length, 0, A - N, Z, Z);
      } else
        j = m(I, U, q, A - N, k - A, T);
    }
    E.push(j), S.push($);
  }
  function f(w, x, E, S) {
    let C = [], R = 0, P = -1;
    for (; a.pos > x; ) {
      let { id: N, start: A, end: O, size: k } = a;
      if (k > 4)
        a.next();
      else {
        if (P > -1 && A < P)
          break;
        P < 0 && (P = O - o), C.push(N, A, O), R++, a.next();
      }
    }
    if (R) {
      let N = new Uint16Array(R * 4), A = C[C.length - 2];
      for (let O = C.length - 3, k = 0; O >= 0; O -= 3)
        N[k++] = C[O], N[k++] = C[O + 1] - A, N[k++] = C[O + 2] - A, N[k++] = k;
      E.push(new Qh(N, C[2] - A, r)), S.push(A - w);
    }
  }
  function h(w, x) {
    return (E, S, C) => {
      let R = 0, P = E.length - 1, N, A;
      if (P >= 0 && (N = E[P]) instanceof Jr) {
        if (!P && N.type == w && N.length == C)
          return N;
        (A = N.prop(Dt.lookAhead)) && (R = S[P] + N.length + A);
      }
      return m(w, E, S, C, R, x);
    };
  }
  function p(w, x, E, S, C, R, P, N, A) {
    let O = [], k = [];
    for (; w.length > S; )
      O.push(w.pop()), k.push(x.pop() + E - C);
    w.push(m(r.types[P], O, k, R - C, N - R, A)), x.push(C - E);
  }
  function m(w, x, E, S, C, R, P) {
    if (R) {
      let N = [Dt.contextHash, R];
      P = P ? [N].concat(P) : [N];
    }
    if (C > 25) {
      let N = [Dt.lookAhead, C];
      P = P ? [N].concat(P) : [N];
    }
    return new Jr(w, x, E, S, P);
  }
  function g(w, x) {
    let E = a.fork(), S = 0, C = 0, R = 0, P = E.end - o, N = { size: 0, start: 0, skip: 0 };
    e: for (let A = E.pos - w; E.pos > A; ) {
      let O = E.size;
      if (E.id == x && O >= 0) {
        N.size = S, N.start = C, N.skip = R, R += 4, S += 4, E.next();
        continue;
      }
      let k = E.pos - O;
      if (O < 0 || k < A || E.start < P)
        break;
      let T = E.id >= s ? 4 : 0, I = E.start;
      for (E.next(); E.pos > k; ) {
        if (E.size < 0)
          if (E.size == -3)
            T += 4;
          else
            break e;
        else E.id >= s && (T += 4);
        E.next();
      }
      C = I, S += O, R += T;
    }
    return (x < 0 || S == w) && (N.size = S, N.start = C, N.skip = R), N.size > 4 ? N : void 0;
  }
  function y(w, x, E) {
    let { id: S, start: C, end: R, size: P } = a;
    if (a.next(), P >= 0 && S < s) {
      let N = E;
      if (P > 4) {
        let A = a.pos - (P - 4);
        for (; a.pos > A; )
          E = y(w, x, E);
      }
      x[--E] = N, x[--E] = R - w, x[--E] = C - w, x[--E] = S;
    } else P == -3 ? c = S : P == -4 && (u = S);
    return E;
  }
  let v = [], b = [];
  for (; a.pos > 0; )
    d(t.start || 0, t.bufferStart || 0, v, b, -1, 0);
  let _ = (e = t.length) !== null && e !== void 0 ? e : v.length ? b[0] + v[0].length : 0;
  return new Jr(l[t.topID], v.reverse(), b.reverse(), _);
}
const tz = /* @__PURE__ */ new WeakMap();
function bw(t, e) {
  if (!t.isAnonymous || e instanceof Qh || e.type != t)
    return 1;
  let n = tz.get(e);
  if (n == null) {
    n = 1;
    for (let r of e.children) {
      if (r.type != t || !(r instanceof Jr)) {
        n = 1;
        break;
      }
      n += bw(t, r);
    }
    tz.set(e, n);
  }
  return n;
}
function pL(t, e, n, r, o, i, s, a, l) {
  let c = 0;
  for (let p = r; p < o; p++)
    c += bw(t, e[p]);
  let u = Math.ceil(
    c * 1.5 / 8
    /* Balance.BranchFactor */
  ), d = [], f = [];
  function h(p, m, g, y, v) {
    for (let b = g; b < y; ) {
      let _ = b, w = m[b], x = bw(t, p[b]);
      for (b++; b < y; b++) {
        let E = bw(t, p[b]);
        if (x + E >= u)
          break;
        x += E;
      }
      if (b == _ + 1) {
        if (x > u) {
          let E = p[_];
          h(E.children, E.positions, 0, E.children.length, m[_] + v);
          continue;
        }
        d.push(p[_]);
      } else {
        let E = m[b - 1] + p[b - 1].length - w;
        d.push(pL(t, p, m, _, b, w, E, null, l));
      }
      f.push(w + v - i);
    }
  }
  return h(e, n, r, o, 0), (a || l)(d, f, s);
}
class yd {
  /**
  Construct a tree fragment. You'll usually want to use
  [`addTree`](#common.TreeFragment^addTree) and
  [`applyChanges`](#common.TreeFragment^applyChanges) instead of
  calling this directly.
  */
  constructor(e, n, r, o, i = !1, s = !1) {
    this.from = e, this.to = n, this.tree = r, this.offset = o, this.open = (i ? 1 : 0) | (s ? 2 : 0);
  }
  /**
  Whether the start of the fragment represents the start of a
  parse, or the end of a change. (In the second case, it may not
  be safe to reuse some nodes at the start, depending on the
  parsing algorithm.)
  */
  get openStart() {
    return (this.open & 1) > 0;
  }
  /**
  Whether the end of the fragment represents the end of a
  full-document parse, or the start of a change.
  */
  get openEnd() {
    return (this.open & 2) > 0;
  }
  /**
  Create a set of fragments from a freshly parsed tree, or update
  an existing set of fragments by replacing the ones that overlap
  with a tree with content from the new tree. When `partial` is
  true, the parse is treated as incomplete, and the resulting
  fragment has [`openEnd`](#common.TreeFragment.openEnd) set to
  true.
  */
  static addTree(e, n = [], r = !1) {
    let o = [new yd(0, e.length, e, 0, !1, r)];
    for (let i of n)
      i.to > e.length && o.push(i);
    return o;
  }
  /**
  Apply a set of edits to an array of fragments, removing or
  splitting fragments as necessary to remove edited ranges, and
  adjusting offsets for fragments that moved.
  */
  static applyChanges(e, n, r = 128) {
    if (!n.length)
      return e;
    let o = [], i = 1, s = e.length ? e[0] : null;
    for (let a = 0, l = 0, c = 0; ; a++) {
      let u = a < n.length ? n[a] : null, d = u ? u.fromA : 1e9;
      if (d - l >= r)
        for (; s && s.from < d; ) {
          let f = s;
          if (l >= f.from || d <= f.to || c) {
            let h = Math.max(f.from, l) - c, p = Math.min(f.to, d) - c;
            f = h >= p ? null : new yd(h, p, f.tree, f.offset + c, a > 0, !!u);
          }
          if (f && o.push(f), s.to > d)
            break;
          s = i < e.length ? e[i++] : null;
        }
      if (!u)
        break;
      l = u.toA, c = u.toA - u.toB;
    }
    return o;
  }
}
let Kde = class {
  /**
  Start a parse, returning a [partial parse](#common.PartialParse)
  object. [`fragments`](#common.TreeFragment) can be passed in to
  make the parse incremental.
  
  By default, the entire input is parsed. You can pass `ranges`,
  which should be a sorted array of non-empty, non-overlapping
  ranges, to parse only those ranges. The tree returned in that
  case will start at `ranges[0].from`.
  */
  startParse(t, e, n) {
    return typeof t == "string" && (t = new M8e(t)), n = n ? n.length ? n.map((r) => new ak(r.from, r.to)) : [new ak(0, 0)] : [new ak(0, t.length)], this.createParse(t, e || [], n);
  }
  /**
  Run a full parse, returning the resulting tree.
  */
  parse(t, e, n) {
    let r = this.startParse(t, e, n);
    for (; ; ) {
      let o = r.advance();
      if (o)
        return o;
    }
  }
};
class M8e {
  constructor(e) {
    this.string = e;
  }
  get length() {
    return this.string.length;
  }
  chunk(e) {
    return this.string.slice(e);
  }
  get lineChunks() {
    return !1;
  }
  read(e, n) {
    return this.string.slice(e, n);
  }
}
new Dt({ perNode: !0 });
let D8e = 0, dl = class bN {
  /**
  @internal
  */
  constructor(e, n, r, o) {
    this.name = e, this.set = n, this.base = r, this.modified = o, this.id = D8e++;
  }
  toString() {
    let { name: e } = this;
    for (let n of this.modified)
      n.name && (e = `${n.name}(${e})`);
    return e;
  }
  static define(e, n) {
    let r = typeof e == "string" ? e : "?";
    if (e instanceof bN && (n = e), n?.base)
      throw new Error("Can not derive from a modified tag");
    let o = new bN(r, [], null, []);
    if (o.set.push(o), n)
      for (let i of n.set)
        o.set.push(i);
    return o;
  }
  /**
  Define a tag _modifier_, which is a function that, given a tag,
  will return a tag that is a subtag of the original. Applying the
  same modifier to a twice tag will return the same value (`m1(t1)
  == m1(t1)`) and applying multiple modifiers will, regardless or
  order, produce the same tag (`m1(m2(t1)) == m2(m1(t1))`).
  
  When multiple modifiers are applied to a given base tag, each
  smaller set of modifiers is registered as a parent, so that for
  example `m1(m2(m3(t1)))` is a subtype of `m1(m2(t1))`,
  `m1(m3(t1)`, and so on.
  */
  static defineModifier(e) {
    let n = new kx(e);
    return (r) => r.modified.indexOf(n) > -1 ? r : kx.get(r.base || r, r.modified.concat(n).sort((o, i) => o.id - i.id));
  }
}, I8e = 0;
class kx {
  constructor(e) {
    this.name = e, this.instances = [], this.id = I8e++;
  }
  static get(e, n) {
    if (!n.length)
      return e;
    let r = n[0].instances.find((a) => a.base == e && N8e(n, a.modified));
    if (r)
      return r;
    let o = [], i = new dl(e.name, o, e, n);
    for (let a of n)
      a.instances.push(i);
    let s = j8e(n);
    for (let a of e.set)
      if (!a.modified.length)
        for (let l of s)
          o.push(kx.get(a, l));
    return i;
  }
}
function N8e(t, e) {
  return t.length == e.length && t.every((n, r) => n == e[r]);
}
function j8e(t) {
  let e = [[]];
  for (let n = 0; n < t.length; n++)
    for (let r = 0, o = e.length; r < o; r++)
      e.push(e[r].concat(t[n]));
  return e.sort((n, r) => r.length - n.length);
}
function mL(t) {
  let e = /* @__PURE__ */ Object.create(null);
  for (let n in t) {
    let r = t[n];
    Array.isArray(r) || (r = [r]);
    for (let o of n.split(" "))
      if (o) {
        let i = [], s = 2, a = o;
        for (let d = 0; ; ) {
          if (a == "..." && d > 0 && d + 3 == o.length) {
            s = 1;
            break;
          }
          let f = /^"(?:[^"\\]|\\.)*?"|[^\/!]+/.exec(a);
          if (!f)
            throw new RangeError("Invalid path: " + o);
          if (i.push(f[0] == "*" ? "" : f[0][0] == '"' ? JSON.parse(f[0]) : f[0]), d += f[0].length, d == o.length)
            break;
          let h = o[d++];
          if (d == o.length && h == "!") {
            s = 0;
            break;
          }
          if (h != "/")
            throw new RangeError("Invalid path: " + o);
          a = o.slice(d);
        }
        let l = i.length - 1, c = i[l];
        if (!c)
          throw new RangeError("Invalid path: " + o);
        let u = new Ax(r, s, l > 0 ? i.slice(0, l) : null);
        e[c] = u.sort(e[c]);
      }
  }
  return Xde.add(e);
}
const Xde = new Dt();
let Ax = class {
  constructor(e, n, r, o) {
    this.tags = e, this.mode = n, this.context = r, this.next = o;
  }
  get opaque() {
    return this.mode == 0;
  }
  get inherit() {
    return this.mode == 1;
  }
  sort(e) {
    return !e || e.depth < this.depth ? (this.next = e, this) : (e.next = this.sort(e.next), e);
  }
  get depth() {
    return this.context ? this.context.length : 0;
  }
};
Ax.empty = new Ax([], 2, null);
function Qde(t, e) {
  let n = /* @__PURE__ */ Object.create(null);
  for (let i of t)
    if (!Array.isArray(i.tag))
      n[i.tag.id] = i.class;
    else
      for (let s of i.tag)
        n[s.id] = i.class;
  let { scope: r, all: o = null } = e || {};
  return {
    style: (i) => {
      let s = o;
      for (let a of i)
        for (let l of a.set) {
          let c = n[l.id];
          if (c) {
            s = s ? s + " " + c : c;
            break;
          }
        }
      return s;
    },
    scope: r
  };
}
function L8e(t, e) {
  let n = null;
  for (let r of t) {
    let o = r.style(e);
    o && (n = n ? n + " " + o : o);
  }
  return n;
}
function F8e(t, e, n, r = 0, o = t.length) {
  let i = new B8e(r, Array.isArray(e) ? e : [e], n);
  i.highlightRange(t.cursor(), r, o, "", i.highlighters), i.flush(o);
}
class B8e {
  constructor(e, n, r) {
    this.at = e, this.highlighters = n, this.span = r, this.class = "";
  }
  startSpan(e, n) {
    n != this.class && (this.flush(e), e > this.at && (this.at = e), this.class = n);
  }
  flush(e) {
    e > this.at && this.class && this.span(this.at, e, this.class);
  }
  highlightRange(e, n, r, o, i) {
    let { type: s, from: a, to: l } = e;
    if (a >= r || l <= n)
      return;
    s.isTop && (i = this.highlighters.filter((h) => !h.scope || h.scope(s)));
    let c = o, u = z8e(e) || Ax.empty, d = L8e(i, u.tags);
    if (d && (c && (c += " "), c += d, u.mode == 1 && (o += (o ? " " : "") + d)), this.startSpan(Math.max(n, a), c), u.opaque)
      return;
    let f = e.tree && e.tree.prop(Dt.mounted);
    if (f && f.overlay) {
      let h = e.node.enter(f.overlay[0].from + a, 1), p = this.highlighters.filter((g) => !g.scope || g.scope(f.tree.type)), m = e.firstChild();
      for (let g = 0, y = a; ; g++) {
        let v = g < f.overlay.length ? f.overlay[g] : null, b = v ? v.from + a : l, _ = Math.max(n, y), w = Math.min(r, b);
        if (_ < w && m)
          for (; e.from < w && (this.highlightRange(e, _, w, o, i), this.startSpan(Math.min(w, e.to), c), !(e.to >= b || !e.nextSibling())); )
            ;
        if (!v || b > r)
          break;
        y = v.to + a, y > n && (this.highlightRange(h.cursor(), Math.max(n, v.from + a), Math.min(r, y), "", p), this.startSpan(Math.min(r, y), c));
      }
      m && e.parent();
    } else if (e.firstChild()) {
      f && (o = "");
      do
        if (!(e.to <= n)) {
          if (e.from >= r)
            break;
          this.highlightRange(e, n, r, o, i), this.startSpan(Math.min(r, e.to), c);
        }
      while (e.nextSibling());
      e.parent();
    }
  }
}
function z8e(t) {
  let e = t.type.prop(Xde);
  for (; e && e.context && !t.matchContext(e.context); )
    e = e.next;
  return e || null;
}
const Ze = dl.define, Lb = Ze(), vc = Ze(), nz = Ze(vc), rz = Ze(vc), bc = Ze(), Fb = Ze(bc), lk = Ze(bc), Ys = Ze(), yu = Ze(Ys), qs = Ze(), Us = Ze(), _N = Ze(), cm = Ze(_N), Bb = Ze(), le = {
  /**
  A comment.
  */
  comment: Lb,
  /**
  A line [comment](#highlight.tags.comment).
  */
  lineComment: Ze(Lb),
  /**
  A block [comment](#highlight.tags.comment).
  */
  blockComment: Ze(Lb),
  /**
  A documentation [comment](#highlight.tags.comment).
  */
  docComment: Ze(Lb),
  /**
  Any kind of identifier.
  */
  name: vc,
  /**
  The [name](#highlight.tags.name) of a variable.
  */
  variableName: Ze(vc),
  /**
  A type [name](#highlight.tags.name).
  */
  typeName: nz,
  /**
  A tag name (subtag of [`typeName`](#highlight.tags.typeName)).
  */
  tagName: Ze(nz),
  /**
  A property or field [name](#highlight.tags.name).
  */
  propertyName: rz,
  /**
  An attribute name (subtag of [`propertyName`](#highlight.tags.propertyName)).
  */
  attributeName: Ze(rz),
  /**
  The [name](#highlight.tags.name) of a class.
  */
  className: Ze(vc),
  /**
  A label [name](#highlight.tags.name).
  */
  labelName: Ze(vc),
  /**
  A namespace [name](#highlight.tags.name).
  */
  namespace: Ze(vc),
  /**
  The [name](#highlight.tags.name) of a macro.
  */
  macroName: Ze(vc),
  /**
  A literal value.
  */
  literal: bc,
  /**
  A string [literal](#highlight.tags.literal).
  */
  string: Fb,
  /**
  A documentation [string](#highlight.tags.string).
  */
  docString: Ze(Fb),
  /**
  A character literal (subtag of [string](#highlight.tags.string)).
  */
  character: Ze(Fb),
  /**
  An attribute value (subtag of [string](#highlight.tags.string)).
  */
  attributeValue: Ze(Fb),
  /**
  A number [literal](#highlight.tags.literal).
  */
  number: lk,
  /**
  An integer [number](#highlight.tags.number) literal.
  */
  integer: Ze(lk),
  /**
  A floating-point [number](#highlight.tags.number) literal.
  */
  float: Ze(lk),
  /**
  A boolean [literal](#highlight.tags.literal).
  */
  bool: Ze(bc),
  /**
  Regular expression [literal](#highlight.tags.literal).
  */
  regexp: Ze(bc),
  /**
  An escape [literal](#highlight.tags.literal), for example a
  backslash escape in a string.
  */
  escape: Ze(bc),
  /**
  A color [literal](#highlight.tags.literal).
  */
  color: Ze(bc),
  /**
  A URL [literal](#highlight.tags.literal).
  */
  url: Ze(bc),
  /**
  A language keyword.
  */
  keyword: qs,
  /**
  The [keyword](#highlight.tags.keyword) for the self or this
  object.
  */
  self: Ze(qs),
  /**
  The [keyword](#highlight.tags.keyword) for null.
  */
  null: Ze(qs),
  /**
  A [keyword](#highlight.tags.keyword) denoting some atomic value.
  */
  atom: Ze(qs),
  /**
  A [keyword](#highlight.tags.keyword) that represents a unit.
  */
  unit: Ze(qs),
  /**
  A modifier [keyword](#highlight.tags.keyword).
  */
  modifier: Ze(qs),
  /**
  A [keyword](#highlight.tags.keyword) that acts as an operator.
  */
  operatorKeyword: Ze(qs),
  /**
  A control-flow related [keyword](#highlight.tags.keyword).
  */
  controlKeyword: Ze(qs),
  /**
  A [keyword](#highlight.tags.keyword) that defines something.
  */
  definitionKeyword: Ze(qs),
  /**
  A [keyword](#highlight.tags.keyword) related to defining or
  interfacing with modules.
  */
  moduleKeyword: Ze(qs),
  /**
  An operator.
  */
  operator: Us,
  /**
  An [operator](#highlight.tags.operator) that dereferences something.
  */
  derefOperator: Ze(Us),
  /**
  Arithmetic-related [operator](#highlight.tags.operator).
  */
  arithmeticOperator: Ze(Us),
  /**
  Logical [operator](#highlight.tags.operator).
  */
  logicOperator: Ze(Us),
  /**
  Bit [operator](#highlight.tags.operator).
  */
  bitwiseOperator: Ze(Us),
  /**
  Comparison [operator](#highlight.tags.operator).
  */
  compareOperator: Ze(Us),
  /**
  [Operator](#highlight.tags.operator) that updates its operand.
  */
  updateOperator: Ze(Us),
  /**
  [Operator](#highlight.tags.operator) that defines something.
  */
  definitionOperator: Ze(Us),
  /**
  Type-related [operator](#highlight.tags.operator).
  */
  typeOperator: Ze(Us),
  /**
  Control-flow [operator](#highlight.tags.operator).
  */
  controlOperator: Ze(Us),
  /**
  Program or markup punctuation.
  */
  punctuation: _N,
  /**
  [Punctuation](#highlight.tags.punctuation) that separates
  things.
  */
  separator: Ze(_N),
  /**
  Bracket-style [punctuation](#highlight.tags.punctuation).
  */
  bracket: cm,
  /**
  Angle [brackets](#highlight.tags.bracket) (usually `<` and `>`
  tokens).
  */
  angleBracket: Ze(cm),
  /**
  Square [brackets](#highlight.tags.bracket) (usually `[` and `]`
  tokens).
  */
  squareBracket: Ze(cm),
  /**
  Parentheses (usually `(` and `)` tokens). Subtag of
  [bracket](#highlight.tags.bracket).
  */
  paren: Ze(cm),
  /**
  Braces (usually `{` and `}` tokens). Subtag of
  [bracket](#highlight.tags.bracket).
  */
  brace: Ze(cm),
  /**
  Content, for example plain text in XML or markup documents.
  */
  content: Ys,
  /**
  [Content](#highlight.tags.content) that represents a heading.
  */
  heading: yu,
  /**
  A level 1 [heading](#highlight.tags.heading).
  */
  heading1: Ze(yu),
  /**
  A level 2 [heading](#highlight.tags.heading).
  */
  heading2: Ze(yu),
  /**
  A level 3 [heading](#highlight.tags.heading).
  */
  heading3: Ze(yu),
  /**
  A level 4 [heading](#highlight.tags.heading).
  */
  heading4: Ze(yu),
  /**
  A level 5 [heading](#highlight.tags.heading).
  */
  heading5: Ze(yu),
  /**
  A level 6 [heading](#highlight.tags.heading).
  */
  heading6: Ze(yu),
  /**
  A prose [content](#highlight.tags.content) separator (such as a horizontal rule).
  */
  contentSeparator: Ze(Ys),
  /**
  [Content](#highlight.tags.content) that represents a list.
  */
  list: Ze(Ys),
  /**
  [Content](#highlight.tags.content) that represents a quote.
  */
  quote: Ze(Ys),
  /**
  [Content](#highlight.tags.content) that is emphasized.
  */
  emphasis: Ze(Ys),
  /**
  [Content](#highlight.tags.content) that is styled strong.
  */
  strong: Ze(Ys),
  /**
  [Content](#highlight.tags.content) that is part of a link.
  */
  link: Ze(Ys),
  /**
  [Content](#highlight.tags.content) that is styled as code or
  monospace.
  */
  monospace: Ze(Ys),
  /**
  [Content](#highlight.tags.content) that has a strike-through
  style.
  */
  strikethrough: Ze(Ys),
  /**
  Inserted text in a change-tracking format.
  */
  inserted: Ze(),
  /**
  Deleted text.
  */
  deleted: Ze(),
  /**
  Changed text.
  */
  changed: Ze(),
  /**
  An invalid or unsyntactic element.
  */
  invalid: Ze(),
  /**
  Metadata or meta-instruction.
  */
  meta: Bb,
  /**
  [Metadata](#highlight.tags.meta) that applies to the entire
  document.
  */
  documentMeta: Ze(Bb),
  /**
  [Metadata](#highlight.tags.meta) that annotates or adds
  attributes to a given syntactic element.
  */
  annotation: Ze(Bb),
  /**
  Processing instruction or preprocessor directive. Subtag of
  [meta](#highlight.tags.meta).
  */
  processingInstruction: Ze(Bb),
  /**
  [Modifier](#highlight.Tag^defineModifier) that indicates that a
  given element is being defined. Expected to be used with the
  various [name](#highlight.tags.name) tags.
  */
  definition: dl.defineModifier("definition"),
  /**
  [Modifier](#highlight.Tag^defineModifier) that indicates that
  something is constant. Mostly expected to be used with
  [variable names](#highlight.tags.variableName).
  */
  constant: dl.defineModifier("constant"),
  /**
  [Modifier](#highlight.Tag^defineModifier) used to indicate that
  a [variable](#highlight.tags.variableName) or [property
  name](#highlight.tags.propertyName) is being called or defined
  as a function.
  */
  function: dl.defineModifier("function"),
  /**
  [Modifier](#highlight.Tag^defineModifier) that can be applied to
  [names](#highlight.tags.name) to indicate that they belong to
  the language's standard environment.
  */
  standard: dl.defineModifier("standard"),
  /**
  [Modifier](#highlight.Tag^defineModifier) that indicates a given
  [names](#highlight.tags.name) is local to some scope.
  */
  local: dl.defineModifier("local"),
  /**
  A generic variant [modifier](#highlight.Tag^defineModifier) that
  can be used to tag language-specific alternative variants of
  some common tag. It is recommended for themes to define special
  forms of at least the [string](#highlight.tags.string) and
  [variable name](#highlight.tags.variableName) tags, since those
  come up a lot.
  */
  special: dl.defineModifier("special")
};
for (let t in le) {
  let e = le[t];
  e instanceof dl && (e.name = t);
}
Qde([
  { tag: le.link, class: "tok-link" },
  { tag: le.heading, class: "tok-heading" },
  { tag: le.emphasis, class: "tok-emphasis" },
  { tag: le.strong, class: "tok-strong" },
  { tag: le.keyword, class: "tok-keyword" },
  { tag: le.atom, class: "tok-atom" },
  { tag: le.bool, class: "tok-bool" },
  { tag: le.url, class: "tok-url" },
  { tag: le.labelName, class: "tok-labelName" },
  { tag: le.inserted, class: "tok-inserted" },
  { tag: le.deleted, class: "tok-deleted" },
  { tag: le.literal, class: "tok-literal" },
  { tag: le.string, class: "tok-string" },
  { tag: le.number, class: "tok-number" },
  { tag: [le.regexp, le.escape, le.special(le.string)], class: "tok-string2" },
  { tag: le.variableName, class: "tok-variableName" },
  { tag: le.local(le.variableName), class: "tok-variableName tok-local" },
  { tag: le.definition(le.variableName), class: "tok-variableName tok-definition" },
  { tag: le.special(le.variableName), class: "tok-variableName2" },
  { tag: le.definition(le.propertyName), class: "tok-propertyName tok-definition" },
  { tag: le.typeName, class: "tok-typeName" },
  { tag: le.namespace, class: "tok-namespace" },
  { tag: le.className, class: "tok-className" },
  { tag: le.macroName, class: "tok-macroName" },
  { tag: le.propertyName, class: "tok-propertyName" },
  { tag: le.operator, class: "tok-operator" },
  { tag: le.comment, class: "tok-comment" },
  { tag: le.meta, class: "tok-meta" },
  { tag: le.invalid, class: "tok-invalid" },
  { tag: le.punctuation, class: "tok-punctuation" }
]);
var ck;
const xg = /* @__PURE__ */ new Dt(), q8e = /* @__PURE__ */ new Dt();
let Es = class {
  /**
  Construct a language object. If you need to invoke this
  directly, first define a data facet with
  [`defineLanguageFacet`](https://codemirror.net/6/docs/ref/#language.defineLanguageFacet), and then
  configure your parser to [attach](https://codemirror.net/6/docs/ref/#language.languageDataProp) it
  to the language's outer syntax node.
  */
  constructor(e, n, r = [], o = "") {
    this.data = e, this.name = o, qt.prototype.hasOwnProperty("tree") || Object.defineProperty(qt.prototype, "tree", { get() {
      return ho(this);
    } }), this.parser = n, this.extension = [
      eu.of(this),
      qt.languageData.of((i, s, a) => {
        let l = oz(i, s, a), c = l.type.prop(xg);
        if (!c)
          return [];
        let u = i.facet(c), d = l.type.prop(q8e);
        if (d) {
          let f = l.resolve(s - l.from, a);
          for (let h of d)
            if (h.test(f, i)) {
              let p = i.facet(h.facet);
              return h.type == "replace" ? p : p.concat(u);
            }
        }
        return u;
      })
    ].concat(r);
  }
  /**
  Query whether this language is active at the given position.
  */
  isActiveAt(e, n, r = -1) {
    return oz(e, n, r).type.prop(xg) == this.data;
  }
  /**
  Find the document regions that were parsed using this language.
  The returned regions will _include_ any nested languages rooted
  in this language, when those exist.
  */
  findRegions(e) {
    let n = e.facet(eu);
    if (n?.data == this.data)
      return [{ from: 0, to: e.doc.length }];
    if (!n || !n.allowsNesting)
      return [];
    let r = [], o = (i, s) => {
      if (i.prop(xg) == this.data) {
        r.push({ from: s, to: s + i.length });
        return;
      }
      let a = i.prop(Dt.mounted);
      if (a) {
        if (a.tree.prop(xg) == this.data) {
          if (a.overlay)
            for (let l of a.overlay)
              r.push({ from: l.from + s, to: l.to + s });
          else
            r.push({ from: s, to: s + i.length });
          return;
        } else if (a.overlay) {
          let l = r.length;
          if (o(a.tree, a.overlay[0].from + s), r.length > l)
            return;
        }
      }
      for (let l = 0; l < i.children.length; l++) {
        let c = i.children[l];
        c instanceof Jr && o(c, i.positions[l] + s);
      }
    };
    return o(ho(e), 0), r;
  }
  /**
  Indicates whether this language allows nested languages. The
  default implementation returns true.
  */
  get allowsNesting() {
    return !0;
  }
};
Es.setState = /* @__PURE__ */ xt.define();
function oz(t, e, n) {
  let r = t.facet(eu), o = ho(t).topNode;
  if (!r || r.allowsNesting)
    for (let i = o; i; i = i.enter(e, n, Ur.ExcludeBuffers))
      i.type.isTop && (o = i);
  return o;
}
function ho(t) {
  let e = t.field(Es.state, !1);
  return e ? e.tree : Jr.empty;
}
function U8e(t, e, n = 50) {
  var r;
  let o = (r = t.field(Es.state, !1)) === null || r === void 0 ? void 0 : r.context;
  if (!o)
    return null;
  let i = o.viewport;
  o.updateViewport({ from: 0, to: e });
  let s = o.isDone(e) || o.work(n, e) ? o.tree : null;
  return o.updateViewport(i), s;
}
class H8e {
  /**
  Create an input object for the given document.
  */
  constructor(e) {
    this.doc = e, this.cursorPos = 0, this.string = "", this.cursor = e.iter();
  }
  get length() {
    return this.doc.length;
  }
  syncTo(e) {
    return this.string = this.cursor.next(e - this.cursorPos).value, this.cursorPos = e + this.string.length, this.cursorPos - this.string.length;
  }
  chunk(e) {
    return this.syncTo(e), this.string;
  }
  get lineChunks() {
    return !0;
  }
  read(e, n) {
    let r = this.cursorPos - this.string.length;
    return e < r || n >= this.cursorPos ? this.doc.sliceString(e, n) : this.string.slice(e - r, n - r);
  }
}
let um = null;
class Tx {
  constructor(e, n, r = [], o, i, s, a, l) {
    this.parser = e, this.state = n, this.fragments = r, this.tree = o, this.treeLen = i, this.viewport = s, this.skipped = a, this.scheduleOn = l, this.parse = null, this.tempSkipped = [];
  }
  /**
  @internal
  */
  static create(e, n, r) {
    return new Tx(e, n, [], Jr.empty, 0, r, [], null);
  }
  startParse() {
    return this.parser.startParse(new H8e(this.state.doc), this.fragments);
  }
  /**
  @internal
  */
  work(e, n) {
    return n != null && n >= this.state.doc.length && (n = void 0), this.tree != Jr.empty && this.isDone(n ?? this.state.doc.length) ? (this.takeTree(), !0) : this.withContext(() => {
      var r;
      if (typeof e == "number") {
        let o = Date.now() + e;
        e = () => Date.now() > o;
      }
      for (this.parse || (this.parse = this.startParse()), n != null && (this.parse.stoppedAt == null || this.parse.stoppedAt > n) && n < this.state.doc.length && this.parse.stopAt(n); ; ) {
        let o = this.parse.advance();
        if (o)
          if (this.fragments = this.withoutTempSkipped(yd.addTree(o, this.fragments, this.parse.stoppedAt != null)), this.treeLen = (r = this.parse.stoppedAt) !== null && r !== void 0 ? r : this.state.doc.length, this.tree = o, this.parse = null, this.treeLen < (n ?? this.state.doc.length))
            this.parse = this.startParse();
          else
            return !0;
        if (e())
          return !1;
      }
    });
  }
  /**
  @internal
  */
  takeTree() {
    let e, n;
    this.parse && (e = this.parse.parsedPos) >= this.treeLen && ((this.parse.stoppedAt == null || this.parse.stoppedAt > e) && this.parse.stopAt(e), this.withContext(() => {
      for (; !(n = this.parse.advance()); )
        ;
    }), this.treeLen = e, this.tree = n, this.fragments = this.withoutTempSkipped(yd.addTree(this.tree, this.fragments, !0)), this.parse = null);
  }
  withContext(e) {
    let n = um;
    um = this;
    try {
      return e();
    } finally {
      um = n;
    }
  }
  withoutTempSkipped(e) {
    for (let n; n = this.tempSkipped.pop(); )
      e = iz(e, n.from, n.to);
    return e;
  }
  /**
  @internal
  */
  changes(e, n) {
    let { fragments: r, tree: o, treeLen: i, viewport: s, skipped: a } = this;
    if (this.takeTree(), !e.empty) {
      let l = [];
      if (e.iterChangedRanges((c, u, d, f) => l.push({ fromA: c, toA: u, fromB: d, toB: f })), r = yd.applyChanges(r, l), o = Jr.empty, i = 0, s = { from: e.mapPos(s.from, -1), to: e.mapPos(s.to, 1) }, this.skipped.length) {
        a = [];
        for (let c of this.skipped) {
          let u = e.mapPos(c.from, 1), d = e.mapPos(c.to, -1);
          u < d && a.push({ from: u, to: d });
        }
      }
    }
    return new Tx(this.parser, n, r, o, i, s, a, this.scheduleOn);
  }
  /**
  @internal
  */
  updateViewport(e) {
    if (this.viewport.from == e.from && this.viewport.to == e.to)
      return !1;
    this.viewport = e;
    let n = this.skipped.length;
    for (let r = 0; r < this.skipped.length; r++) {
      let { from: o, to: i } = this.skipped[r];
      o < e.to && i > e.from && (this.fragments = iz(this.fragments, o, i), this.skipped.splice(r--, 1));
    }
    return this.skipped.length >= n ? !1 : (this.reset(), !0);
  }
  /**
  @internal
  */
  reset() {
    this.parse && (this.takeTree(), this.parse = null);
  }
  /**
  Notify the parse scheduler that the given region was skipped
  because it wasn't in view, and the parse should be restarted
  when it comes into view.
  */
  skipUntilInView(e, n) {
    this.skipped.push({ from: e, to: n });
  }
  /**
  Returns a parser intended to be used as placeholder when
  asynchronously loading a nested parser. It'll skip its input and
  mark it as not-really-parsed, so that the next update will parse
  it again.
  
  When `until` is given, a reparse will be scheduled when that
  promise resolves.
  */
  static getSkippingParser(e) {
    return new class extends Kde {
      createParse(n, r, o) {
        let i = o[0].from, s = o[o.length - 1].to;
        return {
          parsedPos: i,
          advance() {
            let a = um;
            if (a) {
              for (let l of o)
                a.tempSkipped.push(l);
              e && (a.scheduleOn = a.scheduleOn ? Promise.all([a.scheduleOn, e]) : e);
            }
            return this.parsedPos = s, new Jr(es.none, [], [], s - i);
          },
          stoppedAt: null,
          stopAt() {
          }
        };
      }
    }();
  }
  /**
  @internal
  */
  isDone(e) {
    e = Math.min(e, this.state.doc.length);
    let n = this.fragments;
    return this.treeLen >= e && n.length && n[0].from == 0 && n[0].to >= e;
  }
  /**
  Get the context for the current parse, or `null` if no editor
  parse is in progress.
  */
  static get() {
    return um;
  }
}
function iz(t, e, n) {
  return yd.applyChanges(t, [{ fromA: e, toA: n, fromB: e, toB: n }]);
}
let wN = class xN {
  constructor(e) {
    this.context = e, this.tree = e.tree;
  }
  apply(e) {
    if (!e.docChanged && this.tree == this.context.tree)
      return this;
    let n = this.context.changes(e.changes, e.state), r = this.context.treeLen == e.startState.doc.length ? void 0 : Math.max(e.changes.mapPos(this.context.treeLen), n.viewport.to);
    return n.work(20, r) || n.takeTree(), new xN(n);
  }
  static init(e) {
    let n = Math.min(3e3, e.doc.length), r = Tx.create(e.facet(eu).parser, e, { from: 0, to: n });
    return r.work(20, n) || r.takeTree(), new xN(r);
  }
};
Es.state = /* @__PURE__ */ jr.define({
  create: wN.init,
  update(t, e) {
    for (let n of e.effects)
      if (n.is(Es.setState))
        return n.value;
    return e.startState.facet(eu) != e.state.facet(eu) ? wN.init(e.state) : t.apply(e);
  }
});
let Zde = (t) => {
  let e = setTimeout(
    () => t(),
    500
    /* Work.MaxPause */
  );
  return () => clearTimeout(e);
};
typeof requestIdleCallback < "u" && (Zde = (t) => {
  let e = -1, n = setTimeout(
    () => {
      e = requestIdleCallback(t, {
        timeout: 400
        /* Work.MinPause */
      });
    },
    100
    /* Work.MinPause */
  );
  return () => e < 0 ? clearTimeout(n) : cancelIdleCallback(e);
});
const uk = typeof navigator < "u" && !((ck = navigator.scheduling) === null || ck === void 0) && ck.isInputPending ? () => navigator.scheduling.isInputPending() : null, V8e = /* @__PURE__ */ kr.fromClass(class {
  constructor(t) {
    this.view = t, this.working = null, this.workScheduled = 0, this.chunkEnd = -1, this.chunkBudget = -1, this.work = this.work.bind(this), this.scheduleWork();
  }
  update(t) {
    let e = this.view.state.field(Es.state).context;
    (e.updateViewport(t.view.viewport) || this.view.viewport.to > e.treeLen) && this.scheduleWork(), (t.docChanged || t.selectionSet) && (this.view.hasFocus && (this.chunkBudget += 50), this.scheduleWork()), this.checkAsyncSchedule(e);
  }
  scheduleWork() {
    if (this.working)
      return;
    let { state: t } = this.view, e = t.field(Es.state);
    (e.tree != e.context.tree || !e.context.isDone(t.doc.length)) && (this.working = Zde(this.work));
  }
  work(t) {
    this.working = null;
    let e = Date.now();
    if (this.chunkEnd < e && (this.chunkEnd < 0 || this.view.hasFocus) && (this.chunkEnd = e + 3e4, this.chunkBudget = 3e3), this.chunkBudget <= 0)
      return;
    let { state: n, viewport: { to: r } } = this.view, o = n.field(Es.state);
    if (o.tree == o.context.tree && o.context.isDone(
      r + 1e5
      /* Work.MaxParseAhead */
    ))
      return;
    let i = Date.now() + Math.min(this.chunkBudget, 100, t && !uk ? Math.max(25, t.timeRemaining() - 5) : 1e9), s = o.context.treeLen < r && n.doc.length > r + 1e3, a = o.context.work(() => uk && uk() || Date.now() > i, r + (s ? 0 : 1e5));
    this.chunkBudget -= Date.now() - e, (a || this.chunkBudget <= 0) && (o.context.takeTree(), this.view.dispatch({ effects: Es.setState.of(new wN(o.context)) })), this.chunkBudget > 0 && !(a && !s) && this.scheduleWork(), this.checkAsyncSchedule(o.context);
  }
  checkAsyncSchedule(t) {
    t.scheduleOn && (this.workScheduled++, t.scheduleOn.then(() => this.scheduleWork()).catch((e) => Wo(this.view.state, e)).then(() => this.workScheduled--), t.scheduleOn = null);
  }
  destroy() {
    this.working && this.working();
  }
  isWorking() {
    return !!(this.working || this.workScheduled > 0);
  }
}, {
  eventHandlers: { focus() {
    this.scheduleWork();
  } }
}), eu = /* @__PURE__ */ lt.define({
  combine(t) {
    return t.length ? t[0] : null;
  },
  enables: (t) => [
    Es.state,
    V8e,
    et.contentAttributes.compute([t], (e) => {
      let n = e.facet(t);
      return n && n.name ? { "data-language": n.name } : {};
    })
  ]
}), W8e = /* @__PURE__ */ lt.define(), PS = /* @__PURE__ */ lt.define({
  combine: (t) => {
    if (!t.length)
      return "  ";
    let e = t[0];
    if (!e || /\S/.test(e) || Array.from(e).some((n) => n != e[0]))
      throw new Error("Invalid indent unit: " + JSON.stringify(t[0]));
    return e;
  }
});
function Rx(t) {
  let e = t.facet(PS);
  return e.charCodeAt(0) == 9 ? t.tabSize * e.length : e.length;
}
function J0(t, e) {
  let n = "", r = t.tabSize, o = t.facet(PS)[0];
  if (o == "	") {
    for (; e >= r; )
      n += "	", e -= r;
    o = " ";
  }
  for (let i = 0; i < e; i++)
    n += o;
  return n;
}
function gL(t, e) {
  t instanceof qt && (t = new $S(t));
  for (let r of t.state.facet(W8e)) {
    let o = r(t, e);
    if (o !== void 0)
      return o;
  }
  let n = ho(t.state);
  return n.length >= e ? Y8e(t, n, e) : null;
}
class $S {
  /**
  Create an indent context.
  */
  constructor(e, n = {}) {
    this.state = e, this.options = n, this.unit = Rx(e);
  }
  /**
  Get a description of the line at the given position, taking
  [simulated line
  breaks](https://codemirror.net/6/docs/ref/#language.IndentContext.constructor^options.simulateBreak)
  into account. If there is such a break at `pos`, the `bias`
  argument determines whether the part of the line line before or
  after the break is used.
  */
  lineAt(e, n = 1) {
    let r = this.state.doc.lineAt(e), { simulateBreak: o, simulateDoubleBreak: i } = this.options;
    return o != null && o >= r.from && o <= r.to ? i && o == e ? { text: "", from: e } : (n < 0 ? o < e : o <= e) ? { text: r.text.slice(o - r.from), from: o } : { text: r.text.slice(0, o - r.from), from: r.from } : r;
  }
  /**
  Get the text directly after `pos`, either the entire line
  or the next 100 characters, whichever is shorter.
  */
  textAfterPos(e, n = 1) {
    if (this.options.simulateDoubleBreak && e == this.options.simulateBreak)
      return "";
    let { text: r, from: o } = this.lineAt(e, n);
    return r.slice(e - o, Math.min(r.length, e + 100 - o));
  }
  /**
  Find the column for the given position.
  */
  column(e, n = 1) {
    let { text: r, from: o } = this.lineAt(e, n), i = this.countColumn(r, e - o), s = this.options.overrideIndentation ? this.options.overrideIndentation(o) : -1;
    return s > -1 && (i += s - this.countColumn(r, r.search(/\S|$/))), i;
  }
  /**
  Find the column position (taking tabs into account) of the given
  position in the given string.
  */
  countColumn(e, n = e.length) {
    return Sp(e, this.state.tabSize, n);
  }
  /**
  Find the indentation column of the line at the given point.
  */
  lineIndent(e, n = 1) {
    let { text: r, from: o } = this.lineAt(e, n), i = this.options.overrideIndentation;
    if (i) {
      let s = i(o);
      if (s > -1)
        return s;
    }
    return this.countColumn(r, r.search(/\S|$/));
  }
  /**
  Returns the [simulated line
  break](https://codemirror.net/6/docs/ref/#language.IndentContext.constructor^options.simulateBreak)
  for this context, if any.
  */
  get simulatedBreak() {
    return this.options.simulateBreak || null;
  }
}
const G8e = /* @__PURE__ */ new Dt();
function Y8e(t, e, n) {
  let r = e.resolveStack(n), o = e.resolveInner(n, -1).resolve(n, 0).enterUnfinishedNodesBefore(n);
  if (o != r.node) {
    let i = [];
    for (let s = o; s && !(s.from == r.node.from && s.type == r.node.type); s = s.parent)
      i.push(s);
    for (let s = i.length - 1; s >= 0; s--)
      r = { node: i[s], next: r };
  }
  return Jde(r, t, n);
}
function Jde(t, e, n) {
  for (let r = t; r; r = r.next) {
    let o = X8e(r.node);
    if (o)
      return o(Z8e.create(e, n, r));
  }
  return 0;
}
function K8e(t) {
  return t.pos == t.options.simulateBreak && t.options.simulateDoubleBreak;
}
function X8e(t) {
  let e = t.type.prop(G8e);
  if (e)
    return e;
  let n = t.firstChild, r;
  if (n && (r = n.type.prop(Dt.closedBy))) {
    let o = t.lastChild, i = o && r.indexOf(o.name) > -1;
    return (s) => tFe(s, !0, 1, void 0, i && !K8e(s) ? o.from : void 0);
  }
  return t.parent == null ? Q8e : null;
}
function Q8e() {
  return 0;
}
let Z8e = class efe extends $S {
  constructor(e, n, r) {
    super(e.state, e.options), this.base = e, this.pos = n, this.context = r;
  }
  /**
  The syntax tree node to which the indentation strategy
  applies.
  */
  get node() {
    return this.context.node;
  }
  /**
  @internal
  */
  static create(e, n, r) {
    return new efe(e, n, r);
  }
  /**
  Get the text directly after `this.pos`, either the entire line
  or the next 100 characters, whichever is shorter.
  */
  get textAfter() {
    return this.textAfterPos(this.pos);
  }
  /**
  Get the indentation at the reference line for `this.node`, which
  is the line on which it starts, unless there is a node that is
  _not_ a parent of this node covering the start of that line. If
  so, the line at the start of that node is tried, again skipping
  on if it is covered by another such node.
  */
  get baseIndent() {
    return this.baseIndentFor(this.node);
  }
  /**
  Get the indentation for the reference line of the given node
  (see [`baseIndent`](https://codemirror.net/6/docs/ref/#language.TreeIndentContext.baseIndent)).
  */
  baseIndentFor(e) {
    let n = this.state.doc.lineAt(e.from);
    for (; ; ) {
      let r = e.resolve(n.from);
      for (; r.parent && r.parent.from == r.from; )
        r = r.parent;
      if (J8e(r, e))
        break;
      n = this.state.doc.lineAt(r.from);
    }
    return this.lineIndent(n.from);
  }
  /**
  Continue looking for indentations in the node's parent nodes,
  and return the result of that.
  */
  continue() {
    return Jde(this.context.next, this.base, this.pos);
  }
};
function J8e(t, e) {
  for (let n = e; n; n = n.parent)
    if (t == n)
      return !0;
  return !1;
}
function eFe(t) {
  let e = t.node, n = e.childAfter(e.from), r = e.lastChild;
  if (!n)
    return null;
  let o = t.options.simulateBreak, i = t.state.doc.lineAt(n.from), s = o == null || o <= i.from ? i.to : Math.min(i.to, o);
  for (let a = n.to; ; ) {
    let l = e.childAfter(a);
    if (!l || l == r)
      return null;
    if (!l.type.isSkipped) {
      if (l.from >= s)
        return null;
      let c = /^ */.exec(i.text.slice(n.to - i.from))[0].length;
      return { from: n.from, to: n.to + c };
    }
    a = l.to;
  }
}
function tFe(t, e, n, r, o) {
  let i = t.textAfter, s = i.match(/^\s*/)[0].length, a = o == t.pos + s, l = eFe(t);
  return l ? a ? t.column(l.from) : t.column(l.to) : t.baseIndent + (a ? 0 : t.unit * n);
}
const nFe = 200;
function rFe() {
  return qt.transactionFilter.of((t) => {
    if (!t.docChanged || !t.isUserEvent("input.type") && !t.isUserEvent("input.complete"))
      return t;
    let e = t.startState.languageDataAt("indentOnInput", t.startState.selection.main.head);
    if (!e.length)
      return t;
    let n = t.newDoc, { head: r } = t.newSelection.main, o = n.lineAt(r);
    if (r > o.from + nFe)
      return t;
    let i = n.sliceString(o.from, r);
    if (!e.some((c) => c.test(i)))
      return t;
    let { state: s } = t, a = -1, l = [];
    for (let { head: c } of s.selection.ranges) {
      let u = s.doc.lineAt(c);
      if (u.from == a)
        continue;
      a = u.from;
      let d = gL(s, u.from);
      if (d == null)
        continue;
      let f = /^\s*/.exec(u.text)[0], h = J0(s, d);
      f != h && l.push({ from: u.from, to: u.from + f.length, insert: h });
    }
    return l.length ? [t, { changes: l, sequential: !0 }] : t;
  });
}
const oFe = /* @__PURE__ */ lt.define(), iFe = /* @__PURE__ */ new Dt();
function sFe(t, e, n) {
  let r = ho(t);
  if (r.length < n)
    return null;
  let o = r.resolveStack(n, 1), i = null;
  for (let s = o; s; s = s.next) {
    let a = s.node;
    if (a.to <= n || a.from > n)
      continue;
    if (i && a.from < e)
      break;
    let l = a.type.prop(iFe);
    if (l && (a.to < r.length - 50 || r.length == t.doc.length || !aFe(a))) {
      let c = l(a, t);
      c && c.from <= n && c.from >= e && c.to > n && (i = c);
    }
  }
  return i;
}
function aFe(t) {
  let e = t.lastChild;
  return e && e.to == t.to && e.type.isError;
}
function Px(t, e, n) {
  for (let r of t.facet(oFe)) {
    let o = r(t, e, n);
    if (o)
      return o;
  }
  return sFe(t, e, n);
}
function tfe(t, e) {
  let n = e.mapPos(t.from, 1), r = e.mapPos(t.to, -1);
  return n >= r ? void 0 : { from: n, to: r };
}
const MS = /* @__PURE__ */ xt.define({ map: tfe }), mv = /* @__PURE__ */ xt.define({ map: tfe });
function nfe(t) {
  let e = [];
  for (let { head: n } of t.state.selection.ranges)
    e.some((r) => r.from <= n && r.to >= n) || e.push(t.lineBlockAt(n));
  return e;
}
const Nd = /* @__PURE__ */ jr.define({
  create() {
    return ut.none;
  },
  update(t, e) {
    t = t.map(e.changes);
    for (let n of e.effects)
      if (n.is(MS) && !lFe(t, n.value.from, n.value.to)) {
        let { preparePlaceholder: r } = e.state.facet(ife), o = r ? ut.replace({ widget: new mFe(r(e.state, n.value)) }) : sz;
        t = t.update({ add: [o.range(n.value.from, n.value.to)] });
      } else n.is(mv) && (t = t.update({
        filter: (r, o) => n.value.from != r || n.value.to != o,
        filterFrom: n.value.from,
        filterTo: n.value.to
      }));
    if (e.selection) {
      let n = !1, { head: r } = e.selection.main;
      t.between(r, r, (o, i) => {
        o < r && i > r && (n = !0);
      }), n && (t = t.update({
        filterFrom: r,
        filterTo: r,
        filter: (o, i) => i <= r || o >= r
      }));
    }
    return t;
  },
  provide: (t) => et.decorations.from(t),
  toJSON(t, e) {
    let n = [];
    return t.between(0, e.doc.length, (r, o) => {
      n.push(r, o);
    }), n;
  },
  fromJSON(t) {
    if (!Array.isArray(t) || t.length % 2)
      throw new RangeError("Invalid JSON for fold state");
    let e = [];
    for (let n = 0; n < t.length; ) {
      let r = t[n++], o = t[n++];
      if (typeof r != "number" || typeof o != "number")
        throw new RangeError("Invalid JSON for fold state");
      e.push(sz.range(r, o));
    }
    return ut.set(e, !0);
  }
});
function $x(t, e, n) {
  var r;
  let o = null;
  return (r = t.field(Nd, !1)) === null || r === void 0 || r.between(e, n, (i, s) => {
    (!o || o.from > i) && (o = { from: i, to: s });
  }), o;
}
function lFe(t, e, n) {
  let r = !1;
  return t.between(e, e, (o, i) => {
    o == e && i == n && (r = !0);
  }), r;
}
function rfe(t, e) {
  return t.field(Nd, !1) ? e : e.concat(xt.appendConfig.of(sfe()));
}
const cFe = (t) => {
  for (let e of nfe(t)) {
    let n = Px(t.state, e.from, e.to);
    if (n)
      return t.dispatch({ effects: rfe(t.state, [MS.of(n), ofe(t, n)]) }), !0;
  }
  return !1;
}, uFe = (t) => {
  if (!t.state.field(Nd, !1))
    return !1;
  let e = [];
  for (let n of nfe(t)) {
    let r = $x(t.state, n.from, n.to);
    r && e.push(mv.of(r), ofe(t, r, !1));
  }
  return e.length && t.dispatch({ effects: e }), e.length > 0;
};
function ofe(t, e, n = !0) {
  let r = t.state.doc.lineAt(e.from).number, o = t.state.doc.lineAt(e.to).number;
  return et.announce.of(`${t.state.phrase(n ? "Folded lines" : "Unfolded lines")} ${r} ${t.state.phrase("to")} ${o}.`);
}
const dFe = (t) => {
  let { state: e } = t, n = [];
  for (let r = 0; r < e.doc.length; ) {
    let o = t.lineBlockAt(r), i = Px(e, o.from, o.to);
    i && n.push(MS.of(i)), r = (i ? t.lineBlockAt(i.to) : o).to + 1;
  }
  return n.length && t.dispatch({ effects: rfe(t.state, n) }), !!n.length;
}, fFe = (t) => {
  let e = t.state.field(Nd, !1);
  if (!e || !e.size)
    return !1;
  let n = [];
  return e.between(0, t.state.doc.length, (r, o) => {
    n.push(mv.of({ from: r, to: o }));
  }), t.dispatch({ effects: n }), !0;
}, hFe = [
  { key: "Ctrl-Shift-[", mac: "Cmd-Alt-[", run: cFe },
  { key: "Ctrl-Shift-]", mac: "Cmd-Alt-]", run: uFe },
  { key: "Ctrl-Alt-[", run: dFe },
  { key: "Ctrl-Alt-]", run: fFe }
], pFe = {
  placeholderDOM: null,
  preparePlaceholder: null,
  placeholderText: "…"
}, ife = /* @__PURE__ */ lt.define({
  combine(t) {
    return Ra(t, pFe);
  }
});
function sfe(t) {
  return [Nd, yFe];
}
function afe(t, e) {
  let { state: n } = t, r = n.facet(ife), o = (s) => {
    let a = t.lineBlockAt(t.posAtDOM(s.target)), l = $x(t.state, a.from, a.to);
    l && t.dispatch({ effects: mv.of(l) }), s.preventDefault();
  };
  if (r.placeholderDOM)
    return r.placeholderDOM(t, o, e);
  let i = document.createElement("span");
  return i.textContent = r.placeholderText, i.setAttribute("aria-label", n.phrase("folded code")), i.title = n.phrase("unfold"), i.className = "cm-foldPlaceholder", i.onclick = o, i;
}
const sz = /* @__PURE__ */ ut.replace({ widget: /* @__PURE__ */ new class extends Pa {
  toDOM(t) {
    return afe(t, null);
  }
}() });
class mFe extends Pa {
  constructor(e) {
    super(), this.value = e;
  }
  eq(e) {
    return this.value == e.value;
  }
  toDOM(e) {
    return afe(e, this.value);
  }
}
const gFe = {
  openText: "⌄",
  closedText: "›",
  markerDOM: null,
  domEventHandlers: {},
  foldingChanged: () => !1
};
class dk extends Nl {
  constructor(e, n) {
    super(), this.config = e, this.open = n;
  }
  eq(e) {
    return this.config == e.config && this.open == e.open;
  }
  toDOM(e) {
    if (this.config.markerDOM)
      return this.config.markerDOM(this.open);
    let n = document.createElement("span");
    return n.textContent = this.open ? this.config.openText : this.config.closedText, n.title = e.state.phrase(this.open ? "Fold line" : "Unfold line"), n;
  }
}
function lfe(t = {}) {
  let e = Object.assign(Object.assign({}, gFe), t), n = new dk(e, !0), r = new dk(e, !1), o = kr.fromClass(class {
    constructor(s) {
      this.from = s.viewport.from, this.markers = this.buildMarkers(s);
    }
    update(s) {
      (s.docChanged || s.viewportChanged || s.startState.facet(eu) != s.state.facet(eu) || s.startState.field(Nd, !1) != s.state.field(Nd, !1) || ho(s.startState) != ho(s.state) || e.foldingChanged(s)) && (this.markers = this.buildMarkers(s.view));
    }
    buildMarkers(s) {
      let a = new $d();
      for (let l of s.viewportLineBlocks) {
        let c = $x(s.state, l.from, l.to) ? r : Px(s.state, l.from, l.to) ? n : null;
        c && a.add(l.from, l.from, c);
      }
      return a.finish();
    }
  }), { domEventHandlers: i } = e;
  return [
    o,
    g8e({
      class: "cm-foldGutter",
      markers(s) {
        var a;
        return ((a = s.plugin(o)) === null || a === void 0 ? void 0 : a.markers) || or.empty;
      },
      initialSpacer() {
        return new dk(e, !1);
      },
      domEventHandlers: Object.assign(Object.assign({}, i), { click: (s, a, l) => {
        if (i.click && i.click(s, a, l))
          return !0;
        let c = $x(s.state, a.from, a.to);
        if (c)
          return s.dispatch({ effects: mv.of(c) }), !0;
        let u = Px(s.state, a.from, a.to);
        return u ? (s.dispatch({ effects: MS.of(u) }), !0) : !1;
      } })
    }),
    sfe()
  ];
}
const yFe = /* @__PURE__ */ et.baseTheme({
  ".cm-foldPlaceholder": {
    backgroundColor: "#eee",
    border: "1px solid #ddd",
    color: "#888",
    borderRadius: ".2em",
    margin: "0 1px",
    padding: "0 1px",
    cursor: "pointer"
  },
  ".cm-foldGutter span": {
    padding: "0 1px",
    cursor: "pointer"
  }
});
class Op {
  constructor(e, n) {
    this.specs = e;
    let r;
    function o(a) {
      let l = Qc.newName();
      return (r || (r = /* @__PURE__ */ Object.create(null)))["." + l] = a, l;
    }
    const i = typeof n.all == "string" ? n.all : n.all ? o(n.all) : void 0, s = n.scope;
    this.scope = s instanceof Es ? (a) => a.prop(xg) == s.data : s ? (a) => a == s : void 0, this.style = Qde(e.map((a) => ({
      tag: a.tag,
      class: a.class || o(Object.assign({}, a, { tag: null }))
    })), {
      all: i
    }).style, this.module = r ? new Qc(r) : null, this.themeType = n.themeType;
  }
  /**
  Create a highlighter style that associates the given styles to
  the given tags. The specs must be objects that hold a style tag
  or array of tags in their `tag` property, and either a single
  `class` property providing a static CSS class (for highlighter
  that rely on external styling), or a
  [`style-mod`](https://github.com/marijnh/style-mod#documentation)-style
  set of CSS properties (which define the styling for those tags).
  
  The CSS rules created for a highlighter will be emitted in the
  order of the spec's properties. That means that for elements that
  have multiple tags associated with them, styles defined further
  down in the list will have a higher CSS precedence than styles
  defined earlier.
  */
  static define(e, n) {
    return new Op(e, n || {});
  }
}
const EN = /* @__PURE__ */ lt.define(), cfe = /* @__PURE__ */ lt.define({
  combine(t) {
    return t.length ? [t[0]] : null;
  }
});
function fk(t) {
  let e = t.facet(EN);
  return e.length ? e : t.facet(cfe);
}
function yL(t, e) {
  let n = [bFe], r;
  return t instanceof Op && (t.module && n.push(et.styleModule.of(t.module)), r = t.themeType), e?.fallback ? n.push(cfe.of(t)) : r ? n.push(EN.computeN([et.darkTheme], (o) => o.facet(et.darkTheme) == (r == "dark") ? [t] : [])) : n.push(EN.of(t)), n;
}
class vFe {
  constructor(e) {
    this.markCache = /* @__PURE__ */ Object.create(null), this.tree = ho(e.state), this.decorations = this.buildDeco(e, fk(e.state)), this.decoratedTo = e.viewport.to;
  }
  update(e) {
    let n = ho(e.state), r = fk(e.state), o = r != fk(e.startState), { viewport: i } = e.view, s = e.changes.mapPos(this.decoratedTo, 1);
    n.length < i.to && !o && n.type == this.tree.type && s >= i.to ? (this.decorations = this.decorations.map(e.changes), this.decoratedTo = s) : (n != this.tree || e.viewportChanged || o) && (this.tree = n, this.decorations = this.buildDeco(e.view, r), this.decoratedTo = i.to);
  }
  buildDeco(e, n) {
    if (!n || !this.tree.length)
      return ut.none;
    let r = new $d();
    for (let { from: o, to: i } of e.visibleRanges)
      F8e(this.tree, n, (s, a, l) => {
        r.add(s, a, this.markCache[l] || (this.markCache[l] = ut.mark({ class: l })));
      }, o, i);
    return r.finish();
  }
}
const bFe = /* @__PURE__ */ Yd.high(/* @__PURE__ */ kr.fromClass(vFe, {
  decorations: (t) => t.decorations
})), _Fe = /* @__PURE__ */ Op.define([
  {
    tag: le.meta,
    color: "#404740"
  },
  {
    tag: le.link,
    textDecoration: "underline"
  },
  {
    tag: le.heading,
    textDecoration: "underline",
    fontWeight: "bold"
  },
  {
    tag: le.emphasis,
    fontStyle: "italic"
  },
  {
    tag: le.strong,
    fontWeight: "bold"
  },
  {
    tag: le.strikethrough,
    textDecoration: "line-through"
  },
  {
    tag: le.keyword,
    color: "#708"
  },
  {
    tag: [le.atom, le.bool, le.url, le.contentSeparator, le.labelName],
    color: "#219"
  },
  {
    tag: [le.literal, le.inserted],
    color: "#164"
  },
  {
    tag: [le.string, le.deleted],
    color: "#a11"
  },
  {
    tag: [le.regexp, le.escape, /* @__PURE__ */ le.special(le.string)],
    color: "#e40"
  },
  {
    tag: /* @__PURE__ */ le.definition(le.variableName),
    color: "#00f"
  },
  {
    tag: /* @__PURE__ */ le.local(le.variableName),
    color: "#30a"
  },
  {
    tag: [le.typeName, le.namespace],
    color: "#085"
  },
  {
    tag: le.className,
    color: "#167"
  },
  {
    tag: [/* @__PURE__ */ le.special(le.variableName), le.macroName],
    color: "#256"
  },
  {
    tag: /* @__PURE__ */ le.definition(le.propertyName),
    color: "#00c"
  },
  {
    tag: le.comment,
    color: "#940"
  },
  {
    tag: le.invalid,
    color: "#f00"
  }
]), wFe = /* @__PURE__ */ et.baseTheme({
  "&.cm-focused .cm-matchingBracket": { backgroundColor: "#328c8252" },
  "&.cm-focused .cm-nonmatchingBracket": { backgroundColor: "#bb555544" }
}), ufe = 1e4, dfe = "()[]{}", ffe = /* @__PURE__ */ lt.define({
  combine(t) {
    return Ra(t, {
      afterCursor: !0,
      brackets: dfe,
      maxScanDistance: ufe,
      renderMatch: SFe
    });
  }
}), xFe = /* @__PURE__ */ ut.mark({ class: "cm-matchingBracket" }), EFe = /* @__PURE__ */ ut.mark({ class: "cm-nonmatchingBracket" });
function SFe(t) {
  let e = [], n = t.matched ? xFe : EFe;
  return e.push(n.range(t.start.from, t.start.to)), t.end && e.push(n.range(t.end.from, t.end.to)), e;
}
const OFe = /* @__PURE__ */ jr.define({
  create() {
    return ut.none;
  },
  update(t, e) {
    if (!e.docChanged && !e.selection)
      return t;
    let n = [], r = e.state.facet(ffe);
    for (let o of e.state.selection.ranges) {
      if (!o.empty)
        continue;
      let i = ua(e.state, o.head, -1, r) || o.head > 0 && ua(e.state, o.head - 1, 1, r) || r.afterCursor && (ua(e.state, o.head, 1, r) || o.head < e.state.doc.length && ua(e.state, o.head + 1, -1, r));
      i && (n = n.concat(r.renderMatch(i, e.state)));
    }
    return ut.set(n, !0);
  },
  provide: (t) => et.decorations.from(t)
}), CFe = [
  OFe,
  wFe
];
function kFe(t = {}) {
  return [ffe.of(t), CFe];
}
const AFe = /* @__PURE__ */ new Dt();
function SN(t, e, n) {
  let r = t.prop(e < 0 ? Dt.openedBy : Dt.closedBy);
  if (r)
    return r;
  if (t.name.length == 1) {
    let o = n.indexOf(t.name);
    if (o > -1 && o % 2 == (e < 0 ? 1 : 0))
      return [n[o + e]];
  }
  return null;
}
function ON(t) {
  let e = t.type.prop(AFe);
  return e ? e(t.node) : t;
}
function ua(t, e, n, r = {}) {
  let o = r.maxScanDistance || ufe, i = r.brackets || dfe, s = ho(t), a = s.resolveInner(e, n);
  for (let l = a; l; l = l.parent) {
    let c = SN(l.type, n, i);
    if (c && l.from < l.to) {
      let u = ON(l);
      if (u && (n > 0 ? e >= u.from && e < u.to : e > u.from && e <= u.to))
        return TFe(t, e, n, l, u, c, i);
    }
  }
  return RFe(t, e, n, s, a.type, o, i);
}
function TFe(t, e, n, r, o, i, s) {
  let a = r.parent, l = { from: o.from, to: o.to }, c = 0, u = a?.cursor();
  if (u && (n < 0 ? u.childBefore(r.from) : u.childAfter(r.to)))
    do
      if (n < 0 ? u.to <= r.from : u.from >= r.to) {
        if (c == 0 && i.indexOf(u.type.name) > -1 && u.from < u.to) {
          let d = ON(u);
          return { start: l, end: d ? { from: d.from, to: d.to } : void 0, matched: !0 };
        } else if (SN(u.type, n, s))
          c++;
        else if (SN(u.type, -n, s)) {
          if (c == 0) {
            let d = ON(u);
            return {
              start: l,
              end: d && d.from < d.to ? { from: d.from, to: d.to } : void 0,
              matched: !1
            };
          }
          c--;
        }
      }
    while (n < 0 ? u.prevSibling() : u.nextSibling());
  return { start: l, matched: !1 };
}
function RFe(t, e, n, r, o, i, s) {
  let a = n < 0 ? t.sliceDoc(e - 1, e) : t.sliceDoc(e, e + 1), l = s.indexOf(a);
  if (l < 0 || l % 2 == 0 != n > 0)
    return null;
  let c = { from: n < 0 ? e - 1 : e, to: n > 0 ? e + 1 : e }, u = t.doc.iterRange(e, n > 0 ? t.doc.length : 0), d = 0;
  for (let f = 0; !u.next().done && f <= i; ) {
    let h = u.value;
    n < 0 && (f += h.length);
    let p = e + f * n;
    for (let m = n > 0 ? 0 : h.length - 1, g = n > 0 ? h.length : -1; m != g; m += n) {
      let y = s.indexOf(h[m]);
      if (!(y < 0 || r.resolveInner(p + m, 1).type != o))
        if (y % 2 == 0 == n > 0)
          d++;
        else {
          if (d == 1)
            return { start: c, end: { from: p + m, to: p + m + 1 }, matched: y >> 1 == l >> 1 };
          d--;
        }
    }
    n > 0 && (f += h.length);
  }
  return u.done ? { start: c, matched: !1 } : null;
}
const PFe = /* @__PURE__ */ Object.create(null), az = [es.none], lz = [], cz = /* @__PURE__ */ Object.create(null), $Fe = /* @__PURE__ */ Object.create(null);
for (let [t, e] of [
  ["variable", "variableName"],
  ["variable-2", "variableName.special"],
  ["string-2", "string.special"],
  ["def", "variableName.definition"],
  ["tag", "tagName"],
  ["attribute", "attributeName"],
  ["type", "typeName"],
  ["builtin", "variableName.standard"],
  ["qualifier", "modifier"],
  ["error", "invalid"],
  ["header", "heading"],
  ["property", "propertyName"]
])
  $Fe[t] = /* @__PURE__ */ MFe(PFe, e);
function hk(t, e) {
  lz.indexOf(t) > -1 || (lz.push(t), console.warn(e));
}
function MFe(t, e) {
  let n = [];
  for (let a of e.split(" ")) {
    let l = [];
    for (let c of a.split(".")) {
      let u = t[c] || le[c];
      u ? typeof u == "function" ? l.length ? l = l.map(u) : hk(c, `Modifier ${c} used at start of tag`) : l.length ? hk(c, `Tag ${c} used as modifier`) : l = Array.isArray(u) ? u : [u] : hk(c, `Unknown highlighting tag ${c}`);
    }
    for (let c of l)
      n.push(c);
  }
  if (!n.length)
    return 0;
  let r = e.replace(/ /g, "_"), o = r + " " + n.map((a) => a.id), i = cz[o];
  if (i)
    return i.id;
  let s = cz[o] = es.define({
    id: az.length,
    name: r,
    props: [mL({ [r]: n })]
  });
  return az.push(s), s.id;
}
Kn.RTL, Kn.LTR;
class hfe {
  /**
  Create a new completion context. (Mostly useful for testing
  completion sources—in the editor, the extension will create
  these for you.)
  */
  constructor(e, n, r, o) {
    this.state = e, this.pos = n, this.explicit = r, this.view = o, this.abortListeners = [], this.abortOnDocChange = !1;
  }
  /**
  Get the extent, content, and (if there is a token) type of the
  token before `this.pos`.
  */
  tokenBefore(e) {
    let n = ho(this.state).resolveInner(this.pos, -1);
    for (; n && e.indexOf(n.name) < 0; )
      n = n.parent;
    return n ? {
      from: n.from,
      to: this.pos,
      text: this.state.sliceDoc(n.from, this.pos),
      type: n.type
    } : null;
  }
  /**
  Get the match of the given expression directly before the
  cursor.
  */
  matchBefore(e) {
    let n = this.state.doc.lineAt(this.pos), r = Math.max(n.from, this.pos - 250), o = n.text.slice(r - n.from, this.pos - n.from), i = o.search(pfe(e, !1));
    return i < 0 ? null : { from: r + i, to: this.pos, text: o.slice(i) };
  }
  /**
  Yields true when the query has been aborted. Can be useful in
  asynchronous queries to avoid doing work that will be ignored.
  */
  get aborted() {
    return this.abortListeners == null;
  }
  /**
  Allows you to register abort handlers, which will be called when
  the query is
  [aborted](https://codemirror.net/6/docs/ref/#autocomplete.CompletionContext.aborted).
  
  By default, running queries will not be aborted for regular
  typing or backspacing, on the assumption that they are likely to
  return a result with a
  [`validFor`](https://codemirror.net/6/docs/ref/#autocomplete.CompletionResult.validFor) field that
  allows the result to be used after all. Passing `onDocChange:
  true` will cause this query to be aborted for any document
  change.
  */
  addEventListener(e, n, r) {
    e == "abort" && this.abortListeners && (this.abortListeners.push(n), r && r.onDocChange && (this.abortOnDocChange = !0));
  }
}
function uz(t) {
  let e = Object.keys(t).join(""), n = /\w/.test(e);
  return n && (e = e.replace(/\w/g, "")), `[${n ? "\\w" : ""}${e.replace(/[^\w\s]/g, "\\$&")}]`;
}
function DFe(t) {
  let e = /* @__PURE__ */ Object.create(null), n = /* @__PURE__ */ Object.create(null);
  for (let { label: o } of t) {
    e[o[0]] = !0;
    for (let i = 1; i < o.length; i++)
      n[o[i]] = !0;
  }
  let r = uz(e) + uz(n) + "*$";
  return [new RegExp("^" + r), new RegExp(r)];
}
function IFe(t) {
  let e = t.map((o) => typeof o == "string" ? { label: o } : o), [n, r] = e.every((o) => /^\w+$/.test(o.label)) ? [/\w*$/, /\w+$/] : DFe(e);
  return (o) => {
    let i = o.matchBefore(r);
    return i || o.explicit ? { from: i ? i.from : o.pos, options: e, validFor: n } : null;
  };
}
class dz {
  constructor(e, n, r, o) {
    this.completion = e, this.source = n, this.match = r, this.score = o;
  }
}
function vd(t) {
  return t.selection.main.from;
}
function pfe(t, e) {
  var n;
  let { source: r } = t, o = e && r[0] != "^", i = r[r.length - 1] != "$";
  return !o && !i ? t : new RegExp(`${o ? "^" : ""}(?:${r})${i ? "$" : ""}`, (n = t.flags) !== null && n !== void 0 ? n : t.ignoreCase ? "i" : "");
}
const mfe = /* @__PURE__ */ Ta.define();
function NFe(t, e, n, r) {
  let { main: o } = t.selection, i = n - o.from, s = r - o.from;
  return Object.assign(Object.assign({}, t.changeByRange((a) => {
    if (a != o && n != r && t.sliceDoc(a.from + i, a.from + s) != t.sliceDoc(n, r))
      return { range: a };
    let l = t.toText(e);
    return {
      changes: { from: a.from + i, to: r == o.from ? a.to : a.from + s, insert: l },
      range: $e.cursor(a.from + i + l.length)
    };
  })), { scrollIntoView: !0, userEvent: "input.complete" });
}
const fz = /* @__PURE__ */ new WeakMap();
function jFe(t) {
  if (!Array.isArray(t))
    return t;
  let e = fz.get(t);
  return e || fz.set(t, e = IFe(t)), e;
}
const Mx = /* @__PURE__ */ xt.define(), ey = /* @__PURE__ */ xt.define();
class LFe {
  constructor(e) {
    this.pattern = e, this.chars = [], this.folded = [], this.any = [], this.precise = [], this.byWord = [], this.score = 0, this.matched = [];
    for (let n = 0; n < e.length; ) {
      let r = zo(e, n), o = la(r);
      this.chars.push(r);
      let i = e.slice(n, n + o), s = i.toUpperCase();
      this.folded.push(zo(s == i ? i.toLowerCase() : s, 0)), n += o;
    }
    this.astral = e.length != this.chars.length;
  }
  ret(e, n) {
    return this.score = e, this.matched = n, this;
  }
  // Matches a given word (completion) against the pattern (input).
  // Will return a boolean indicating whether there was a match and,
  // on success, set `this.score` to the score, `this.matched` to an
  // array of `from, to` pairs indicating the matched parts of `word`.
  //
  // The score is a number that is more negative the worse the match
  // is. See `Penalty` above.
  match(e) {
    if (this.pattern.length == 0)
      return this.ret(-100, []);
    if (e.length < this.pattern.length)
      return null;
    let { chars: n, folded: r, any: o, precise: i, byWord: s } = this;
    if (n.length == 1) {
      let v = zo(e, 0), b = la(v), _ = b == e.length ? 0 : -100;
      if (v != n[0]) if (v == r[0])
        _ += -200;
      else
        return null;
      return this.ret(_, [0, b]);
    }
    let a = e.indexOf(this.pattern);
    if (a == 0)
      return this.ret(e.length == this.pattern.length ? 0 : -100, [0, this.pattern.length]);
    let l = n.length, c = 0;
    if (a < 0) {
      for (let v = 0, b = Math.min(e.length, 200); v < b && c < l; ) {
        let _ = zo(e, v);
        (_ == n[c] || _ == r[c]) && (o[c++] = v), v += la(_);
      }
      if (c < l)
        return null;
    }
    let u = 0, d = 0, f = !1, h = 0, p = -1, m = -1, g = /[a-z]/.test(e), y = !0;
    for (let v = 0, b = Math.min(e.length, 200), _ = 0; v < b && d < l; ) {
      let w = zo(e, v);
      a < 0 && (u < l && w == n[u] && (i[u++] = v), h < l && (w == n[h] || w == r[h] ? (h == 0 && (p = v), m = v + 1, h++) : h = 0));
      let x, E = w < 255 ? w >= 48 && w <= 57 || w >= 97 && w <= 122 ? 2 : w >= 65 && w <= 90 ? 1 : 0 : (x = Y5(w)) != x.toLowerCase() ? 1 : x != x.toUpperCase() ? 2 : 0;
      (!v || E == 1 && g || _ == 0 && E != 0) && (n[d] == w || r[d] == w && (f = !0) ? s[d++] = v : s.length && (y = !1)), _ = E, v += la(w);
    }
    return d == l && s[0] == 0 && y ? this.result(-100 + (f ? -200 : 0), s, e) : h == l && p == 0 ? this.ret(-200 - e.length + (m == e.length ? 0 : -100), [0, m]) : a > -1 ? this.ret(-700 - e.length, [a, a + this.pattern.length]) : h == l ? this.ret(-900 - e.length, [p, m]) : d == l ? this.result(-100 + (f ? -200 : 0) + -700 + (y ? 0 : -1100), s, e) : n.length == 2 ? null : this.result((o[0] ? -700 : 0) + -200 + -1100, o, e);
  }
  result(e, n, r) {
    let o = [], i = 0;
    for (let s of n) {
      let a = s + (this.astral ? la(zo(r, s)) : 1);
      i && o[i - 1] == s ? o[i - 1] = a : (o[i++] = s, o[i++] = a);
    }
    return this.ret(e - r.length, o);
  }
}
class FFe {
  constructor(e) {
    this.pattern = e, this.matched = [], this.score = 0, this.folded = e.toLowerCase();
  }
  match(e) {
    if (e.length < this.pattern.length)
      return null;
    let n = e.slice(0, this.pattern.length), r = n == this.pattern ? 0 : n.toLowerCase() == this.folded ? -200 : null;
    return r == null ? null : (this.matched = [0, n.length], this.score = r + (e.length == this.pattern.length ? 0 : -100), this);
  }
}
const Hr = /* @__PURE__ */ lt.define({
  combine(t) {
    return Ra(t, {
      activateOnTyping: !0,
      activateOnCompletion: () => !1,
      activateOnTypingDelay: 100,
      selectOnOpen: !0,
      override: null,
      closeOnBlur: !0,
      maxRenderedOptions: 100,
      defaultKeymap: !0,
      tooltipClass: () => "",
      optionClass: () => "",
      aboveCursor: !1,
      icons: !0,
      addToOptions: [],
      positionInfo: BFe,
      filterStrict: !1,
      compareCompletions: (e, n) => e.label.localeCompare(n.label),
      interactionDelay: 75,
      updateSyncTime: 100
    }, {
      defaultKeymap: (e, n) => e && n,
      closeOnBlur: (e, n) => e && n,
      icons: (e, n) => e && n,
      tooltipClass: (e, n) => (r) => hz(e(r), n(r)),
      optionClass: (e, n) => (r) => hz(e(r), n(r)),
      addToOptions: (e, n) => e.concat(n),
      filterStrict: (e, n) => e || n
    });
  }
});
function hz(t, e) {
  return t ? e ? t + " " + e : t : e;
}
function BFe(t, e, n, r, o, i) {
  let s = t.textDirection == Kn.RTL, a = s, l = !1, c = "top", u, d, f = e.left - o.left, h = o.right - e.right, p = r.right - r.left, m = r.bottom - r.top;
  if (a && f < Math.min(p, h) ? a = !1 : !a && h < Math.min(p, f) && (a = !0), p <= (a ? f : h))
    u = Math.max(o.top, Math.min(n.top, o.bottom - m)) - e.top, d = Math.min(400, a ? f : h);
  else {
    l = !0, d = Math.min(
      400,
      (s ? e.right : o.right - e.left) - 30
      /* Info.Margin */
    );
    let v = o.bottom - e.bottom;
    v >= m || v > e.top ? u = n.bottom - e.top : (c = "bottom", u = e.bottom - n.top);
  }
  let g = (e.bottom - e.top) / i.offsetHeight, y = (e.right - e.left) / i.offsetWidth;
  return {
    style: `${c}: ${u / g}px; max-width: ${d / y}px`,
    class: "cm-completionInfo-" + (l ? s ? "left-narrow" : "right-narrow" : a ? "left" : "right")
  };
}
function zFe(t) {
  let e = t.addToOptions.slice();
  return t.icons && e.push({
    render(n) {
      let r = document.createElement("div");
      return r.classList.add("cm-completionIcon"), n.type && r.classList.add(...n.type.split(/\s+/g).map((o) => "cm-completionIcon-" + o)), r.setAttribute("aria-hidden", "true"), r;
    },
    position: 20
  }), e.push({
    render(n, r, o, i) {
      let s = document.createElement("span");
      s.className = "cm-completionLabel";
      let a = n.displayLabel || n.label, l = 0;
      for (let c = 0; c < i.length; ) {
        let u = i[c++], d = i[c++];
        u > l && s.appendChild(document.createTextNode(a.slice(l, u)));
        let f = s.appendChild(document.createElement("span"));
        f.appendChild(document.createTextNode(a.slice(u, d))), f.className = "cm-completionMatchedText", l = d;
      }
      return l < a.length && s.appendChild(document.createTextNode(a.slice(l))), s;
    },
    position: 50
  }, {
    render(n) {
      if (!n.detail)
        return null;
      let r = document.createElement("span");
      return r.className = "cm-completionDetail", r.textContent = n.detail, r;
    },
    position: 80
  }), e.sort((n, r) => n.position - r.position).map((n) => n.render);
}
function pk(t, e, n) {
  if (t <= n)
    return { from: 0, to: t };
  if (e < 0 && (e = 0), e <= t >> 1) {
    let o = Math.floor(e / n);
    return { from: o * n, to: (o + 1) * n };
  }
  let r = Math.floor((t - e) / n);
  return { from: t - (r + 1) * n, to: t - r * n };
}
class qFe {
  constructor(e, n, r) {
    this.view = e, this.stateField = n, this.applyCompletion = r, this.info = null, this.infoDestroy = null, this.placeInfoReq = {
      read: () => this.measureInfo(),
      write: (l) => this.placeInfo(l),
      key: this
    }, this.space = null, this.currentClass = "";
    let o = e.state.field(n), { options: i, selected: s } = o.open, a = e.state.facet(Hr);
    this.optionContent = zFe(a), this.optionClass = a.optionClass, this.tooltipClass = a.tooltipClass, this.range = pk(i.length, s, a.maxRenderedOptions), this.dom = document.createElement("div"), this.dom.className = "cm-tooltip-autocomplete", this.updateTooltipClass(e.state), this.dom.addEventListener("mousedown", (l) => {
      let { options: c } = e.state.field(n).open;
      for (let u = l.target, d; u && u != this.dom; u = u.parentNode)
        if (u.nodeName == "LI" && (d = /-(\d+)$/.exec(u.id)) && +d[1] < c.length) {
          this.applyCompletion(e, c[+d[1]]), l.preventDefault();
          return;
        }
    }), this.dom.addEventListener("focusout", (l) => {
      let c = e.state.field(this.stateField, !1);
      c && c.tooltip && e.state.facet(Hr).closeOnBlur && l.relatedTarget != e.contentDOM && e.dispatch({ effects: ey.of(null) });
    }), this.showOptions(i, o.id);
  }
  mount() {
    this.updateSel();
  }
  showOptions(e, n) {
    this.list && this.list.remove(), this.list = this.dom.appendChild(this.createListBox(e, n, this.range)), this.list.addEventListener("scroll", () => {
      this.info && this.view.requestMeasure(this.placeInfoReq);
    });
  }
  update(e) {
    var n;
    let r = e.state.field(this.stateField), o = e.startState.field(this.stateField);
    if (this.updateTooltipClass(e.state), r != o) {
      let { options: i, selected: s, disabled: a } = r.open;
      (!o.open || o.open.options != i) && (this.range = pk(i.length, s, e.state.facet(Hr).maxRenderedOptions), this.showOptions(i, r.id)), this.updateSel(), a != ((n = o.open) === null || n === void 0 ? void 0 : n.disabled) && this.dom.classList.toggle("cm-tooltip-autocomplete-disabled", !!a);
    }
  }
  updateTooltipClass(e) {
    let n = this.tooltipClass(e);
    if (n != this.currentClass) {
      for (let r of this.currentClass.split(" "))
        r && this.dom.classList.remove(r);
      for (let r of n.split(" "))
        r && this.dom.classList.add(r);
      this.currentClass = n;
    }
  }
  positioned(e) {
    this.space = e, this.info && this.view.requestMeasure(this.placeInfoReq);
  }
  updateSel() {
    let e = this.view.state.field(this.stateField), n = e.open;
    if ((n.selected > -1 && n.selected < this.range.from || n.selected >= this.range.to) && (this.range = pk(n.options.length, n.selected, this.view.state.facet(Hr).maxRenderedOptions), this.showOptions(n.options, e.id)), this.updateSelectedOption(n.selected)) {
      this.destroyInfo();
      let { completion: r } = n.options[n.selected], { info: o } = r;
      if (!o)
        return;
      let i = typeof o == "string" ? document.createTextNode(o) : o(r);
      if (!i)
        return;
      "then" in i ? i.then((s) => {
        s && this.view.state.field(this.stateField, !1) == e && this.addInfoPane(s, r);
      }).catch((s) => Wo(this.view.state, s, "completion info")) : this.addInfoPane(i, r);
    }
  }
  addInfoPane(e, n) {
    this.destroyInfo();
    let r = this.info = document.createElement("div");
    if (r.className = "cm-tooltip cm-completionInfo", e.nodeType != null)
      r.appendChild(e), this.infoDestroy = null;
    else {
      let { dom: o, destroy: i } = e;
      r.appendChild(o), this.infoDestroy = i || null;
    }
    this.dom.appendChild(r), this.view.requestMeasure(this.placeInfoReq);
  }
  updateSelectedOption(e) {
    let n = null;
    for (let r = this.list.firstChild, o = this.range.from; r; r = r.nextSibling, o++)
      r.nodeName != "LI" || !r.id ? o-- : o == e ? r.hasAttribute("aria-selected") || (r.setAttribute("aria-selected", "true"), n = r) : r.hasAttribute("aria-selected") && r.removeAttribute("aria-selected");
    return n && HFe(this.list, n), n;
  }
  measureInfo() {
    let e = this.dom.querySelector("[aria-selected]");
    if (!e || !this.info)
      return null;
    let n = this.dom.getBoundingClientRect(), r = this.info.getBoundingClientRect(), o = e.getBoundingClientRect(), i = this.space;
    if (!i) {
      let s = this.dom.ownerDocument.documentElement;
      i = { left: 0, top: 0, right: s.clientWidth, bottom: s.clientHeight };
    }
    return o.top > Math.min(i.bottom, n.bottom) - 10 || o.bottom < Math.max(i.top, n.top) + 10 ? null : this.view.state.facet(Hr).positionInfo(this.view, n, o, r, i, this.dom);
  }
  placeInfo(e) {
    this.info && (e ? (e.style && (this.info.style.cssText = e.style), this.info.className = "cm-tooltip cm-completionInfo " + (e.class || "")) : this.info.style.cssText = "top: -1e6px");
  }
  createListBox(e, n, r) {
    const o = document.createElement("ul");
    o.id = n, o.setAttribute("role", "listbox"), o.setAttribute("aria-expanded", "true"), o.setAttribute("aria-label", this.view.state.phrase("Completions")), o.addEventListener("mousedown", (s) => {
      s.target == o && s.preventDefault();
    });
    let i = null;
    for (let s = r.from; s < r.to; s++) {
      let { completion: a, match: l } = e[s], { section: c } = a;
      if (c) {
        let f = typeof c == "string" ? c : c.name;
        if (f != i && (s > r.from || r.from == 0))
          if (i = f, typeof c != "string" && c.header)
            o.appendChild(c.header(c));
          else {
            let h = o.appendChild(document.createElement("completion-section"));
            h.textContent = f;
          }
      }
      const u = o.appendChild(document.createElement("li"));
      u.id = n + "-" + s, u.setAttribute("role", "option");
      let d = this.optionClass(a);
      d && (u.className = d);
      for (let f of this.optionContent) {
        let h = f(a, this.view.state, this.view, l);
        h && u.appendChild(h);
      }
    }
    return r.from && o.classList.add("cm-completionListIncompleteTop"), r.to < e.length && o.classList.add("cm-completionListIncompleteBottom"), o;
  }
  destroyInfo() {
    this.info && (this.infoDestroy && this.infoDestroy(), this.info.remove(), this.info = null);
  }
  destroy() {
    this.destroyInfo();
  }
}
function UFe(t, e) {
  return (n) => new qFe(n, t, e);
}
function HFe(t, e) {
  let n = t.getBoundingClientRect(), r = e.getBoundingClientRect(), o = n.height / t.offsetHeight;
  r.top < n.top ? t.scrollTop -= (n.top - r.top) / o : r.bottom > n.bottom && (t.scrollTop += (r.bottom - n.bottom) / o);
}
function pz(t) {
  return (t.boost || 0) * 100 + (t.apply ? 10 : 0) + (t.info ? 5 : 0) + (t.type ? 1 : 0);
}
function VFe(t, e) {
  let n = [], r = null, o = (c) => {
    n.push(c);
    let { section: u } = c.completion;
    if (u) {
      r || (r = []);
      let d = typeof u == "string" ? u : u.name;
      r.some((f) => f.name == d) || r.push(typeof u == "string" ? { name: d } : u);
    }
  }, i = e.facet(Hr);
  for (let c of t)
    if (c.hasResult()) {
      let u = c.result.getMatch;
      if (c.result.filter === !1)
        for (let d of c.result.options)
          o(new dz(d, c.source, u ? u(d) : [], 1e9 - n.length));
      else {
        let d = e.sliceDoc(c.from, c.to), f, h = i.filterStrict ? new FFe(d) : new LFe(d);
        for (let p of c.result.options)
          if (f = h.match(p.label)) {
            let m = p.displayLabel ? u ? u(p, f.matched) : [] : f.matched;
            o(new dz(p, c.source, m, f.score + (p.boost || 0)));
          }
      }
    }
  if (r) {
    let c = /* @__PURE__ */ Object.create(null), u = 0, d = (f, h) => {
      var p, m;
      return ((p = f.rank) !== null && p !== void 0 ? p : 1e9) - ((m = h.rank) !== null && m !== void 0 ? m : 1e9) || (f.name < h.name ? -1 : 1);
    };
    for (let f of r.sort(d))
      u -= 1e5, c[f.name] = u;
    for (let f of n) {
      let { section: h } = f.completion;
      h && (f.score += c[typeof h == "string" ? h : h.name]);
    }
  }
  let s = [], a = null, l = i.compareCompletions;
  for (let c of n.sort((u, d) => d.score - u.score || l(u.completion, d.completion))) {
    let u = c.completion;
    !a || a.label != u.label || a.detail != u.detail || a.type != null && u.type != null && a.type != u.type || a.apply != u.apply || a.boost != u.boost ? s.push(c) : pz(c.completion) > pz(a) && (s[s.length - 1] = c), a = c.completion;
  }
  return s;
}
class Jf {
  constructor(e, n, r, o, i, s) {
    this.options = e, this.attrs = n, this.tooltip = r, this.timestamp = o, this.selected = i, this.disabled = s;
  }
  setSelected(e, n) {
    return e == this.selected || e >= this.options.length ? this : new Jf(this.options, mz(n, e), this.tooltip, this.timestamp, e, this.disabled);
  }
  static build(e, n, r, o, i, s) {
    if (o && !s && e.some((c) => c.isPending))
      return o.setDisabled();
    let a = VFe(e, n);
    if (!a.length)
      return o && e.some((c) => c.isPending) ? o.setDisabled() : null;
    let l = n.facet(Hr).selectOnOpen ? 0 : -1;
    if (o && o.selected != l && o.selected != -1) {
      let c = o.options[o.selected].completion;
      for (let u = 0; u < a.length; u++)
        if (a[u].completion == c) {
          l = u;
          break;
        }
    }
    return new Jf(a, mz(r, l), {
      pos: e.reduce((c, u) => u.hasResult() ? Math.min(c, u.from) : c, 1e8),
      create: ZFe,
      above: i.aboveCursor
    }, o ? o.timestamp : Date.now(), l, !1);
  }
  map(e) {
    return new Jf(this.options, this.attrs, Object.assign(Object.assign({}, this.tooltip), { pos: e.mapPos(this.tooltip.pos) }), this.timestamp, this.selected, this.disabled);
  }
  setDisabled() {
    return new Jf(this.options, this.attrs, this.tooltip, this.timestamp, this.selected, !0);
  }
}
let WFe = class CN {
  constructor(e, n, r) {
    this.active = e, this.id = n, this.open = r;
  }
  static start() {
    return new CN(XFe, "cm-ac-" + Math.floor(Math.random() * 2e6).toString(36), null);
  }
  update(e) {
    let { state: n } = e, r = n.facet(Hr), o = (r.override || n.languageDataAt("autocomplete", vd(n)).map(jFe)).map((a) => (this.active.find((l) => l.source == a) || new Bi(
      a,
      this.active.some(
        (l) => l.state != 0
        /* State.Inactive */
      ) ? 1 : 0
      /* State.Inactive */
    )).update(e, r));
    o.length == this.active.length && o.every((a, l) => a == this.active[l]) && (o = this.active);
    let i = this.open, s = e.effects.some((a) => a.is(vL));
    i && e.docChanged && (i = i.map(e.changes)), e.selection || o.some((a) => a.hasResult() && e.changes.touchesRange(a.from, a.to)) || !GFe(o, this.active) || s ? i = Jf.build(o, n, this.id, i, r, s) : i && i.disabled && !o.some((a) => a.isPending) && (i = null), !i && o.every((a) => !a.isPending) && o.some((a) => a.hasResult()) && (o = o.map((a) => a.hasResult() ? new Bi(
      a.source,
      0
      /* State.Inactive */
    ) : a));
    for (let a of e.effects)
      a.is(yfe) && (i = i && i.setSelected(a.value, this.id));
    return o == this.active && i == this.open ? this : new CN(o, this.id, i);
  }
  get tooltip() {
    return this.open ? this.open.tooltip : null;
  }
  get attrs() {
    return this.open ? this.open.attrs : this.active.length ? YFe : KFe;
  }
};
function GFe(t, e) {
  if (t == e)
    return !0;
  for (let n = 0, r = 0; ; ) {
    for (; n < t.length && !t[n].hasResult(); )
      n++;
    for (; r < e.length && !e[r].hasResult(); )
      r++;
    let o = n == t.length, i = r == e.length;
    if (o || i)
      return o == i;
    if (t[n++].result != e[r++].result)
      return !1;
  }
}
const YFe = {
  "aria-autocomplete": "list"
}, KFe = {};
function mz(t, e) {
  let n = {
    "aria-autocomplete": "list",
    "aria-haspopup": "listbox",
    "aria-controls": t
  };
  return e > -1 && (n["aria-activedescendant"] = t + "-" + e), n;
}
const XFe = [];
function gfe(t, e) {
  if (t.isUserEvent("input.complete")) {
    let r = t.annotation(mfe);
    if (r && e.activateOnCompletion(r))
      return 12;
  }
  let n = t.isUserEvent("input.type");
  return n && e.activateOnTyping ? 5 : n ? 1 : t.isUserEvent("delete.backward") ? 2 : t.selection ? 8 : t.docChanged ? 16 : 0;
}
class Bi {
  constructor(e, n, r = !1) {
    this.source = e, this.state = n, this.explicit = r;
  }
  hasResult() {
    return !1;
  }
  get isPending() {
    return this.state == 1;
  }
  update(e, n) {
    let r = gfe(e, n), o = this;
    (r & 8 || r & 16 && this.touches(e)) && (o = new Bi(
      o.source,
      0
      /* State.Inactive */
    )), r & 4 && o.state == 0 && (o = new Bi(
      this.source,
      1
      /* State.Pending */
    )), o = o.updateFor(e, r);
    for (let i of e.effects)
      if (i.is(Mx))
        o = new Bi(o.source, 1, i.value);
      else if (i.is(ey))
        o = new Bi(
          o.source,
          0
          /* State.Inactive */
        );
      else if (i.is(vL))
        for (let s of i.value)
          s.source == o.source && (o = s);
    return o;
  }
  updateFor(e, n) {
    return this.map(e.changes);
  }
  map(e) {
    return this;
  }
  touches(e) {
    return e.changes.touchesRange(vd(e.state));
  }
}
class bh extends Bi {
  constructor(e, n, r, o, i, s) {
    super(e, 3, n), this.limit = r, this.result = o, this.from = i, this.to = s;
  }
  hasResult() {
    return !0;
  }
  updateFor(e, n) {
    var r;
    if (!(n & 3))
      return this.map(e.changes);
    let o = this.result;
    o.map && !e.changes.empty && (o = o.map(o, e.changes));
    let i = e.changes.mapPos(this.from), s = e.changes.mapPos(this.to, 1), a = vd(e.state);
    if (a > s || !o || n & 2 && (vd(e.startState) == this.from || a < this.limit))
      return new Bi(
        this.source,
        n & 4 ? 1 : 0
        /* State.Inactive */
      );
    let l = e.changes.mapPos(this.limit);
    return QFe(o.validFor, e.state, i, s) ? new bh(this.source, this.explicit, l, o, i, s) : o.update && (o = o.update(o, i, s, new hfe(e.state, a, !1))) ? new bh(this.source, this.explicit, l, o, o.from, (r = o.to) !== null && r !== void 0 ? r : vd(e.state)) : new Bi(this.source, 1, this.explicit);
  }
  map(e) {
    return e.empty ? this : (this.result.map ? this.result.map(this.result, e) : this.result) ? new bh(this.source, this.explicit, e.mapPos(this.limit), this.result, e.mapPos(this.from), e.mapPos(this.to, 1)) : new Bi(
      this.source,
      0
      /* State.Inactive */
    );
  }
  touches(e) {
    return e.changes.touchesRange(this.from, this.to);
  }
}
function QFe(t, e, n, r) {
  if (!t)
    return !1;
  let o = e.sliceDoc(n, r);
  return typeof t == "function" ? t(o, n, r, e) : pfe(t, !0).test(o);
}
const vL = /* @__PURE__ */ xt.define({
  map(t, e) {
    return t.map((n) => n.map(e));
  }
}), yfe = /* @__PURE__ */ xt.define(), Uo = /* @__PURE__ */ jr.define({
  create() {
    return WFe.start();
  },
  update(t, e) {
    return t.update(e);
  },
  provide: (t) => [
    TS.from(t, (e) => e.tooltip),
    et.contentAttributes.from(t, (e) => e.attrs)
  ]
});
function bL(t, e) {
  const n = e.completion.apply || e.completion.label;
  let r = t.state.field(Uo).active.find((o) => o.source == e.source);
  return r instanceof bh ? (typeof n == "string" ? t.dispatch(Object.assign(Object.assign({}, NFe(t.state, n, r.from, r.to)), { annotations: mfe.of(e.completion) })) : n(t, e.completion, r.from, r.to), !0) : !1;
}
const ZFe = /* @__PURE__ */ UFe(Uo, bL);
function zb(t, e = "option") {
  return (n) => {
    let r = n.state.field(Uo, !1);
    if (!r || !r.open || r.open.disabled || Date.now() - r.open.timestamp < n.state.facet(Hr).interactionDelay)
      return !1;
    let o = 1, i;
    e == "page" && (i = Fde(n, r.open.tooltip)) && (o = Math.max(2, Math.floor(i.dom.offsetHeight / i.dom.querySelector("li").offsetHeight) - 1));
    let { length: s } = r.open.options, a = r.open.selected > -1 ? r.open.selected + o * (t ? 1 : -1) : t ? 0 : s - 1;
    return a < 0 ? a = e == "page" ? 0 : s - 1 : a >= s && (a = e == "page" ? s - 1 : 0), n.dispatch({ effects: yfe.of(a) }), !0;
  };
}
const JFe = (t) => {
  let e = t.state.field(Uo, !1);
  return t.state.readOnly || !e || !e.open || e.open.selected < 0 || e.open.disabled || Date.now() - e.open.timestamp < t.state.facet(Hr).interactionDelay ? !1 : bL(t, e.open.options[e.open.selected]);
}, gz = (t) => t.state.field(Uo, !1) ? (t.dispatch({ effects: Mx.of(!0) }), !0) : !1, e7e = (t) => {
  let e = t.state.field(Uo, !1);
  return !e || !e.active.some(
    (n) => n.state != 0
    /* State.Inactive */
  ) ? !1 : (t.dispatch({ effects: ey.of(null) }), !0);
};
class t7e {
  constructor(e, n) {
    this.active = e, this.context = n, this.time = Date.now(), this.updates = [], this.done = void 0;
  }
}
const n7e = 50, r7e = 1e3, o7e = /* @__PURE__ */ kr.fromClass(class {
  constructor(t) {
    this.view = t, this.debounceUpdate = -1, this.running = [], this.debounceAccept = -1, this.pendingStart = !1, this.composing = 0;
    for (let e of t.state.field(Uo).active)
      e.isPending && this.startQuery(e);
  }
  update(t) {
    let e = t.state.field(Uo), n = t.state.facet(Hr);
    if (!t.selectionSet && !t.docChanged && t.startState.field(Uo) == e)
      return;
    let r = t.transactions.some((i) => {
      let s = gfe(i, n);
      return s & 8 || (i.selection || i.docChanged) && !(s & 3);
    });
    for (let i = 0; i < this.running.length; i++) {
      let s = this.running[i];
      if (r || s.context.abortOnDocChange && t.docChanged || s.updates.length + t.transactions.length > n7e && Date.now() - s.time > r7e) {
        for (let a of s.context.abortListeners)
          try {
            a();
          } catch (l) {
            Wo(this.view.state, l);
          }
        s.context.abortListeners = null, this.running.splice(i--, 1);
      } else
        s.updates.push(...t.transactions);
    }
    this.debounceUpdate > -1 && clearTimeout(this.debounceUpdate), t.transactions.some((i) => i.effects.some((s) => s.is(Mx))) && (this.pendingStart = !0);
    let o = this.pendingStart ? 50 : n.activateOnTypingDelay;
    if (this.debounceUpdate = e.active.some((i) => i.isPending && !this.running.some((s) => s.active.source == i.source)) ? setTimeout(() => this.startUpdate(), o) : -1, this.composing != 0)
      for (let i of t.transactions)
        i.isUserEvent("input.type") ? this.composing = 2 : this.composing == 2 && i.selection && (this.composing = 3);
  }
  startUpdate() {
    this.debounceUpdate = -1, this.pendingStart = !1;
    let { state: t } = this.view, e = t.field(Uo);
    for (let n of e.active)
      n.isPending && !this.running.some((r) => r.active.source == n.source) && this.startQuery(n);
    this.running.length && e.open && e.open.disabled && (this.debounceAccept = setTimeout(() => this.accept(), this.view.state.facet(Hr).updateSyncTime));
  }
  startQuery(t) {
    let { state: e } = this.view, n = vd(e), r = new hfe(e, n, t.explicit, this.view), o = new t7e(t, r);
    this.running.push(o), Promise.resolve(t.source(r)).then((i) => {
      o.context.aborted || (o.done = i || null, this.scheduleAccept());
    }, (i) => {
      this.view.dispatch({ effects: ey.of(null) }), Wo(this.view.state, i);
    });
  }
  scheduleAccept() {
    this.running.every((t) => t.done !== void 0) ? this.accept() : this.debounceAccept < 0 && (this.debounceAccept = setTimeout(() => this.accept(), this.view.state.facet(Hr).updateSyncTime));
  }
  // For each finished query in this.running, try to create a result
  // or, if appropriate, restart the query.
  accept() {
    var t;
    this.debounceAccept > -1 && clearTimeout(this.debounceAccept), this.debounceAccept = -1;
    let e = [], n = this.view.state.facet(Hr), r = this.view.state.field(Uo);
    for (let o = 0; o < this.running.length; o++) {
      let i = this.running[o];
      if (i.done === void 0)
        continue;
      if (this.running.splice(o--, 1), i.done) {
        let a = vd(i.updates.length ? i.updates[0].startState : this.view.state), l = Math.min(a, i.done.from + (i.active.explicit ? 0 : 1)), c = new bh(i.active.source, i.active.explicit, l, i.done, i.done.from, (t = i.done.to) !== null && t !== void 0 ? t : a);
        for (let u of i.updates)
          c = c.update(u, n);
        if (c.hasResult()) {
          e.push(c);
          continue;
        }
      }
      let s = r.active.find((a) => a.source == i.active.source);
      if (s && s.isPending)
        if (i.done == null) {
          let a = new Bi(
            i.active.source,
            0
            /* State.Inactive */
          );
          for (let l of i.updates)
            a = a.update(l, n);
          a.isPending || e.push(a);
        } else
          this.startQuery(s);
    }
    (e.length || r.open && r.open.disabled) && this.view.dispatch({ effects: vL.of(e) });
  }
}, {
  eventHandlers: {
    blur(t) {
      let e = this.view.state.field(Uo, !1);
      if (e && e.tooltip && this.view.state.facet(Hr).closeOnBlur) {
        let n = e.open && Fde(this.view, e.open.tooltip);
        (!n || !n.dom.contains(t.relatedTarget)) && setTimeout(() => this.view.dispatch({ effects: ey.of(null) }), 10);
      }
    },
    compositionstart() {
      this.composing = 1;
    },
    compositionend() {
      this.composing == 3 && setTimeout(() => this.view.dispatch({ effects: Mx.of(!1) }), 20), this.composing = 0;
    }
  }
}), i7e = typeof navigator == "object" && /* @__PURE__ */ /Win/.test(navigator.platform), s7e = /* @__PURE__ */ Yd.highest(/* @__PURE__ */ et.domEventHandlers({
  keydown(t, e) {
    let n = e.state.field(Uo, !1);
    if (!n || !n.open || n.open.disabled || n.open.selected < 0 || t.key.length > 1 || t.ctrlKey && !(i7e && t.altKey) || t.metaKey)
      return !1;
    let r = n.open.options[n.open.selected], o = n.active.find((s) => s.source == r.source), i = r.completion.commitCharacters || o.result.commitCharacters;
    return i && i.indexOf(t.key) > -1 && bL(e, r), !1;
  }
})), a7e = /* @__PURE__ */ et.baseTheme({
  ".cm-tooltip.cm-tooltip-autocomplete": {
    "& > ul": {
      fontFamily: "monospace",
      whiteSpace: "nowrap",
      overflow: "hidden auto",
      maxWidth_fallback: "700px",
      maxWidth: "min(700px, 95vw)",
      minWidth: "250px",
      maxHeight: "10em",
      height: "100%",
      listStyle: "none",
      margin: 0,
      padding: 0,
      "& > li, & > completion-section": {
        padding: "1px 3px",
        lineHeight: 1.2
      },
      "& > li": {
        overflowX: "hidden",
        textOverflow: "ellipsis",
        cursor: "pointer"
      },
      "& > completion-section": {
        display: "list-item",
        borderBottom: "1px solid silver",
        paddingLeft: "0.5em",
        opacity: 0.7
      }
    }
  },
  "&light .cm-tooltip-autocomplete ul li[aria-selected]": {
    background: "#17c",
    color: "white"
  },
  "&light .cm-tooltip-autocomplete-disabled ul li[aria-selected]": {
    background: "#777"
  },
  "&dark .cm-tooltip-autocomplete ul li[aria-selected]": {
    background: "#347",
    color: "white"
  },
  "&dark .cm-tooltip-autocomplete-disabled ul li[aria-selected]": {
    background: "#444"
  },
  ".cm-completionListIncompleteTop:before, .cm-completionListIncompleteBottom:after": {
    content: '"···"',
    opacity: 0.5,
    display: "block",
    textAlign: "center"
  },
  ".cm-tooltip.cm-completionInfo": {
    position: "absolute",
    padding: "3px 9px",
    width: "max-content",
    maxWidth: "400px",
    boxSizing: "border-box",
    whiteSpace: "pre-line"
  },
  ".cm-completionInfo.cm-completionInfo-left": { right: "100%" },
  ".cm-completionInfo.cm-completionInfo-right": { left: "100%" },
  ".cm-completionInfo.cm-completionInfo-left-narrow": { right: "30px" },
  ".cm-completionInfo.cm-completionInfo-right-narrow": { left: "30px" },
  "&light .cm-snippetField": { backgroundColor: "#00000022" },
  "&dark .cm-snippetField": { backgroundColor: "#ffffff22" },
  ".cm-snippetFieldPosition": {
    verticalAlign: "text-top",
    width: 0,
    height: "1.15em",
    display: "inline-block",
    margin: "0 -0.7px -.7em",
    borderLeft: "1.4px dotted #888"
  },
  ".cm-completionMatchedText": {
    textDecoration: "underline"
  },
  ".cm-completionDetail": {
    marginLeft: "0.5em",
    fontStyle: "italic"
  },
  ".cm-completionIcon": {
    fontSize: "90%",
    width: ".8em",
    display: "inline-block",
    textAlign: "center",
    paddingRight: ".6em",
    opacity: "0.6",
    boxSizing: "content-box"
  },
  ".cm-completionIcon-function, .cm-completionIcon-method": {
    "&:after": { content: "'ƒ'" }
  },
  ".cm-completionIcon-class": {
    "&:after": { content: "'○'" }
  },
  ".cm-completionIcon-interface": {
    "&:after": { content: "'◌'" }
  },
  ".cm-completionIcon-variable": {
    "&:after": { content: "'𝑥'" }
  },
  ".cm-completionIcon-constant": {
    "&:after": { content: "'𝐶'" }
  },
  ".cm-completionIcon-type": {
    "&:after": { content: "'𝑡'" }
  },
  ".cm-completionIcon-enum": {
    "&:after": { content: "'∪'" }
  },
  ".cm-completionIcon-property": {
    "&:after": { content: "'□'" }
  },
  ".cm-completionIcon-keyword": {
    "&:after": { content: "'🔑︎'" }
    // Disable emoji rendering
  },
  ".cm-completionIcon-namespace": {
    "&:after": { content: "'▢'" }
  },
  ".cm-completionIcon-text": {
    "&:after": { content: "'abc'", fontSize: "50%", verticalAlign: "middle" }
  }
}), ty = {
  brackets: ["(", "[", "{", "'", '"'],
  before: ")]}:;>",
  stringPrefixes: []
}, od = /* @__PURE__ */ xt.define({
  map(t, e) {
    return e.mapPos(t, -1, Co.TrackAfter) ?? void 0;
  }
}), _L = /* @__PURE__ */ new class extends Pd {
}();
_L.startSide = 1;
_L.endSide = -1;
const vfe = /* @__PURE__ */ jr.define({
  create() {
    return or.empty;
  },
  update(t, e) {
    if (t = t.map(e.changes), e.selection) {
      let n = e.state.doc.lineAt(e.selection.main.head);
      t = t.update({ filter: (r) => r >= n.from && r <= n.to });
    }
    for (let n of e.effects)
      n.is(od) && (t = t.update({ add: [_L.range(n.value, n.value + 1)] }));
    return t;
  }
});
function l7e() {
  return [u7e, vfe];
}
const mk = "()[]{}<>«»»«［］｛｝";
function bfe(t) {
  for (let e = 0; e < mk.length; e += 2)
    if (mk.charCodeAt(e) == t)
      return mk.charAt(e + 1);
  return Y5(t < 128 ? t : t + 1);
}
function _fe(t, e) {
  return t.languageDataAt("closeBrackets", e)[0] || ty;
}
const c7e = typeof navigator == "object" && /* @__PURE__ */ /Android\b/.test(navigator.userAgent), u7e = /* @__PURE__ */ et.inputHandler.of((t, e, n, r) => {
  if ((c7e ? t.composing : t.compositionStarted) || t.state.readOnly)
    return !1;
  let o = t.state.selection.main;
  if (r.length > 2 || r.length == 2 && la(zo(r, 0)) == 1 || e != o.from || n != o.to)
    return !1;
  let i = h7e(t.state, r);
  return i ? (t.dispatch(i), !0) : !1;
}), d7e = ({ state: t, dispatch: e }) => {
  if (t.readOnly)
    return !1;
  let n = _fe(t, t.selection.main.head).brackets || ty.brackets, r = null, o = t.changeByRange((i) => {
    if (i.empty) {
      let s = p7e(t.doc, i.head);
      for (let a of n)
        if (a == s && DS(t.doc, i.head) == bfe(zo(a, 0)))
          return {
            changes: { from: i.head - a.length, to: i.head + a.length },
            range: $e.cursor(i.head - a.length)
          };
    }
    return { range: r = i };
  });
  return r || e(t.update(o, { scrollIntoView: !0, userEvent: "delete.backward" })), !r;
}, f7e = [
  { key: "Backspace", run: d7e }
];
function h7e(t, e) {
  let n = _fe(t, t.selection.main.head), r = n.brackets || ty.brackets;
  for (let o of r) {
    let i = bfe(zo(o, 0));
    if (e == o)
      return i == o ? y7e(t, o, r.indexOf(o + o + o) > -1, n) : m7e(t, o, i, n.before || ty.before);
    if (e == i && wfe(t, t.selection.main.from))
      return g7e(t, o, i);
  }
  return null;
}
function wfe(t, e) {
  let n = !1;
  return t.field(vfe).between(0, t.doc.length, (r) => {
    r == e && (n = !0);
  }), n;
}
function DS(t, e) {
  let n = t.sliceString(e, e + 2);
  return n.slice(0, la(zo(n, 0)));
}
function p7e(t, e) {
  let n = t.sliceString(e - 2, e);
  return la(zo(n, 0)) == n.length ? n : n.slice(1);
}
function m7e(t, e, n, r) {
  let o = null, i = t.changeByRange((s) => {
    if (!s.empty)
      return {
        changes: [{ insert: e, from: s.from }, { insert: n, from: s.to }],
        effects: od.of(s.to + e.length),
        range: $e.range(s.anchor + e.length, s.head + e.length)
      };
    let a = DS(t.doc, s.head);
    return !a || /\s/.test(a) || r.indexOf(a) > -1 ? {
      changes: { insert: e + n, from: s.head },
      effects: od.of(s.head + e.length),
      range: $e.cursor(s.head + e.length)
    } : { range: o = s };
  });
  return o ? null : t.update(i, {
    scrollIntoView: !0,
    userEvent: "input.type"
  });
}
function g7e(t, e, n) {
  let r = null, o = t.changeByRange((i) => i.empty && DS(t.doc, i.head) == n ? {
    changes: { from: i.head, to: i.head + n.length, insert: n },
    range: $e.cursor(i.head + n.length)
  } : r = { range: i });
  return r ? null : t.update(o, {
    scrollIntoView: !0,
    userEvent: "input.type"
  });
}
function y7e(t, e, n, r) {
  let o = r.stringPrefixes || ty.stringPrefixes, i = null, s = t.changeByRange((a) => {
    if (!a.empty)
      return {
        changes: [{ insert: e, from: a.from }, { insert: e, from: a.to }],
        effects: od.of(a.to + e.length),
        range: $e.range(a.anchor + e.length, a.head + e.length)
      };
    let l = a.head, c = DS(t.doc, l), u;
    if (c == e) {
      if (yz(t, l))
        return {
          changes: { insert: e + e, from: l },
          effects: od.of(l + e.length),
          range: $e.cursor(l + e.length)
        };
      if (wfe(t, l)) {
        let d = n && t.sliceDoc(l, l + e.length * 3) == e + e + e ? e + e + e : e;
        return {
          changes: { from: l, to: l + d.length, insert: d },
          range: $e.cursor(l + d.length)
        };
      }
    } else {
      if (n && t.sliceDoc(l - 2 * e.length, l) == e + e && (u = vz(t, l - 2 * e.length, o)) > -1 && yz(t, u))
        return {
          changes: { insert: e + e + e + e, from: l },
          effects: od.of(l + e.length),
          range: $e.cursor(l + e.length)
        };
      if (t.charCategorizer(l)(c) != rr.Word && vz(t, l, o) > -1 && !v7e(t, l, e, o))
        return {
          changes: { insert: e + e, from: l },
          effects: od.of(l + e.length),
          range: $e.cursor(l + e.length)
        };
    }
    return { range: i = a };
  });
  return i ? null : t.update(s, {
    scrollIntoView: !0,
    userEvent: "input.type"
  });
}
function yz(t, e) {
  let n = ho(t).resolveInner(e + 1);
  return n.parent && n.from == e;
}
function v7e(t, e, n, r) {
  let o = ho(t).resolveInner(e, -1), i = r.reduce((s, a) => Math.max(s, a.length), 0);
  for (let s = 0; s < 5; s++) {
    let a = t.sliceDoc(o.from, Math.min(o.to, o.from + n.length + i)), l = a.indexOf(n);
    if (!l || l > -1 && r.indexOf(a.slice(0, l)) > -1) {
      let u = o.firstChild;
      for (; u && u.from == o.from && u.to - u.from > n.length + l; ) {
        if (t.sliceDoc(u.to - n.length, u.to) == n)
          return !1;
        u = u.firstChild;
      }
      return !0;
    }
    let c = o.to == e && o.parent;
    if (!c)
      break;
    o = c;
  }
  return !1;
}
function vz(t, e, n) {
  let r = t.charCategorizer(e);
  if (r(t.sliceDoc(e - 1, e)) != rr.Word)
    return e;
  for (let o of n) {
    let i = e - o.length;
    if (t.sliceDoc(i, e) == o && r(t.sliceDoc(i - 1, i)) != rr.Word)
      return i;
  }
  return -1;
}
function b7e(t = {}) {
  return [
    s7e,
    Uo,
    Hr.of(t),
    o7e,
    _7e,
    a7e
  ];
}
const xfe = [
  { key: "Ctrl-Space", run: gz },
  { mac: "Alt-`", run: gz },
  { key: "Escape", run: e7e },
  { key: "ArrowDown", run: /* @__PURE__ */ zb(!0) },
  { key: "ArrowUp", run: /* @__PURE__ */ zb(!1) },
  { key: "PageDown", run: /* @__PURE__ */ zb(!0, "page") },
  { key: "PageUp", run: /* @__PURE__ */ zb(!1, "page") },
  { key: "Enter", run: JFe }
], _7e = /* @__PURE__ */ Yd.highest(/* @__PURE__ */ AS.computeN([Hr], (t) => t.facet(Hr).defaultKeymap ? [xfe] : []));
function Bn() {
  var t = arguments[0];
  typeof t == "string" && (t = document.createElement(t));
  var e = 1, n = arguments[1];
  if (n && typeof n == "object" && n.nodeType == null && !Array.isArray(n)) {
    for (var r in n) if (Object.prototype.hasOwnProperty.call(n, r)) {
      var o = n[r];
      typeof o == "string" ? t.setAttribute(r, o) : o != null && (t[r] = o);
    }
    e++;
  }
  for (; e < arguments.length; e++) Efe(t, arguments[e]);
  return t;
}
function Efe(t, e) {
  if (typeof e == "string")
    t.appendChild(document.createTextNode(e));
  else if (e != null) if (e.nodeType != null)
    t.appendChild(e);
  else if (Array.isArray(e))
    for (var n = 0; n < e.length; n++) Efe(t, e[n]);
  else
    throw new RangeError("Unsupported child node: " + e);
}
class bz {
  constructor(e, n, r) {
    this.from = e, this.to = n, this.diagnostic = r;
  }
}
class Xu {
  constructor(e, n, r) {
    this.diagnostics = e, this.panel = n, this.selected = r;
  }
  static init(e, n, r) {
    let o = e, i = r.facet(ny).markerFilter;
    i && (o = i(o, r));
    let s = e.slice().sort((d, f) => d.from - f.from || d.to - f.to), a = new $d(), l = [], c = 0;
    for (let d = 0; ; ) {
      let f = d == s.length ? null : s[d];
      if (!f && !l.length)
        break;
      let h, p;
      for (l.length ? (h = c, p = l.reduce((g, y) => Math.min(g, y.to), f && f.from > h ? f.from : 1e8)) : (h = f.from, p = f.to, l.push(f), d++); d < s.length; ) {
        let g = s[d];
        if (g.from == h && (g.to > g.from || g.to == h))
          l.push(g), d++, p = Math.min(g.to, p);
        else {
          p = Math.min(g.from, p);
          break;
        }
      }
      let m = M7e(l);
      if (l.some((g) => g.from == g.to || g.from == g.to - 1 && r.doc.lineAt(g.from).to == g.from))
        a.add(h, h, ut.widget({
          widget: new T7e(m),
          diagnostics: l.slice()
        }));
      else {
        let g = l.reduce((y, v) => v.markClass ? y + " " + v.markClass : y, "");
        a.add(h, p, ut.mark({
          class: "cm-lintRange cm-lintRange-" + m + g,
          diagnostics: l.slice(),
          inclusiveEnd: l.some((y) => y.to > p)
        }));
      }
      c = p;
      for (let g = 0; g < l.length; g++)
        l[g].to <= c && l.splice(g--, 1);
    }
    let u = a.finish();
    return new Xu(u, n, Zh(u));
  }
}
function Zh(t, e = null, n = 0) {
  let r = null;
  return t.between(n, 1e9, (o, i, { spec: s }) => {
    if (!(e && s.diagnostics.indexOf(e) < 0))
      if (!r)
        r = new bz(o, i, e || s.diagnostics[0]);
      else {
        if (s.diagnostics.indexOf(r.diagnostic) < 0)
          return !1;
        r = new bz(r.from, i, r.diagnostic);
      }
  }), r;
}
function w7e(t, e) {
  let n = e.pos, r = e.end || n, o = t.state.facet(ny).hideOn(t, n, r);
  if (o != null)
    return o;
  let i = t.startState.doc.lineAt(e.pos);
  return !!(t.effects.some((s) => s.is(Sfe)) || t.changes.touchesRange(i.from, Math.max(i.to, r)));
}
function x7e(t, e) {
  return t.field(wi, !1) ? e : e.concat(xt.appendConfig.of(D7e));
}
const Sfe = /* @__PURE__ */ xt.define(), wL = /* @__PURE__ */ xt.define(), Ofe = /* @__PURE__ */ xt.define(), wi = /* @__PURE__ */ jr.define({
  create() {
    return new Xu(ut.none, null, null);
  },
  update(t, e) {
    if (e.docChanged && t.diagnostics.size) {
      let n = t.diagnostics.map(e.changes), r = null, o = t.panel;
      if (t.selected) {
        let i = e.changes.mapPos(t.selected.from, 1);
        r = Zh(n, t.selected.diagnostic, i) || Zh(n, null, i);
      }
      !n.size && o && e.state.facet(ny).autoPanel && (o = null), t = new Xu(n, o, r);
    }
    for (let n of e.effects)
      if (n.is(Sfe)) {
        let r = e.state.facet(ny).autoPanel ? n.value.length ? ry.open : null : t.panel;
        t = Xu.init(n.value, r, e.state);
      } else n.is(wL) ? t = new Xu(t.diagnostics, n.value ? ry.open : null, t.selected) : n.is(Ofe) && (t = new Xu(t.diagnostics, t.panel, n.value));
    return t;
  },
  provide: (t) => [
    Q0.from(t, (e) => e.panel),
    et.decorations.from(t, (e) => e.diagnostics)
  ]
}), E7e = /* @__PURE__ */ ut.mark({ class: "cm-lintRange cm-lintRange-active" });
function S7e(t, e, n) {
  let { diagnostics: r } = t.state.field(wi), o, i = -1, s = -1;
  r.between(e - (n < 0 ? 1 : 0), e + (n > 0 ? 1 : 0), (l, c, { spec: u }) => {
    if (e >= l && e <= c && (l == c || (e > l || n > 0) && (e < c || n < 0)))
      return o = u.diagnostics, i = l, s = c, !1;
  });
  let a = t.state.facet(ny).tooltipFilter;
  return o && a && (o = a(o, t.state)), o ? {
    pos: i,
    end: s,
    above: t.state.doc.lineAt(i).to < s,
    create() {
      return { dom: O7e(t, o) };
    }
  } : null;
}
function O7e(t, e) {
  return Bn("ul", { class: "cm-tooltip-lint" }, e.map((n) => kfe(t, n, !1)));
}
const C7e = (t) => {
  let e = t.state.field(wi, !1);
  (!e || !e.panel) && t.dispatch({ effects: x7e(t.state, [wL.of(!0)]) });
  let n = X0(t, ry.open);
  return n && n.dom.querySelector(".cm-panel-lint ul").focus(), !0;
}, _z = (t) => {
  let e = t.state.field(wi, !1);
  return !e || !e.panel ? !1 : (t.dispatch({ effects: wL.of(!1) }), !0);
}, k7e = (t) => {
  let e = t.state.field(wi, !1);
  if (!e)
    return !1;
  let n = t.state.selection.main, r = e.diagnostics.iter(n.to + 1);
  return !r.value && (r = e.diagnostics.iter(0), !r.value || r.from == n.from && r.to == n.to) ? !1 : (t.dispatch({ selection: { anchor: r.from, head: r.to }, scrollIntoView: !0 }), !0);
}, A7e = [
  { key: "Mod-Shift-m", run: C7e, preventDefault: !0 },
  { key: "F8", run: k7e }
], ny = /* @__PURE__ */ lt.define({
  combine(t) {
    return Object.assign({ sources: t.map((e) => e.source).filter((e) => e != null) }, Ra(t.map((e) => e.config), {
      delay: 750,
      markerFilter: null,
      tooltipFilter: null,
      needsRefresh: null,
      hideOn: () => null
    }, {
      needsRefresh: (e, n) => e ? n ? (r) => e(r) || n(r) : e : n
    }));
  }
});
function Cfe(t) {
  let e = [];
  if (t)
    e: for (let { name: n } of t) {
      for (let r = 0; r < n.length; r++) {
        let o = n[r];
        if (/[a-zA-Z]/.test(o) && !e.some((i) => i.toLowerCase() == o.toLowerCase())) {
          e.push(o);
          continue e;
        }
      }
      e.push("");
    }
  return e;
}
function kfe(t, e, n) {
  var r;
  let o = n ? Cfe(e.actions) : [];
  return Bn("li", { class: "cm-diagnostic cm-diagnostic-" + e.severity }, Bn("span", { class: "cm-diagnosticText" }, e.renderMessage ? e.renderMessage(t) : e.message), (r = e.actions) === null || r === void 0 ? void 0 : r.map((i, s) => {
    let a = !1, l = (f) => {
      if (f.preventDefault(), a)
        return;
      a = !0;
      let h = Zh(t.state.field(wi).diagnostics, e);
      h && i.apply(t, h.from, h.to);
    }, { name: c } = i, u = o[s] ? c.indexOf(o[s]) : -1, d = u < 0 ? c : [
      c.slice(0, u),
      Bn("u", c.slice(u, u + 1)),
      c.slice(u + 1)
    ];
    return Bn("button", {
      type: "button",
      class: "cm-diagnosticAction",
      onclick: l,
      onmousedown: l,
      "aria-label": ` Action: ${c}${u < 0 ? "" : ` (access key "${o[s]})"`}.`
    }, d);
  }), e.source && Bn("div", { class: "cm-diagnosticSource" }, e.source));
}
class T7e extends Pa {
  constructor(e) {
    super(), this.sev = e;
  }
  eq(e) {
    return e.sev == this.sev;
  }
  toDOM() {
    return Bn("span", { class: "cm-lintPoint cm-lintPoint-" + this.sev });
  }
}
class wz {
  constructor(e, n) {
    this.diagnostic = n, this.id = "item_" + Math.floor(Math.random() * 4294967295).toString(16), this.dom = kfe(e, n, !0), this.dom.id = this.id, this.dom.setAttribute("role", "option");
  }
}
class ry {
  constructor(e) {
    this.view = e, this.items = [];
    let n = (o) => {
      if (o.keyCode == 27)
        _z(this.view), this.view.focus();
      else if (o.keyCode == 38 || o.keyCode == 33)
        this.moveSelection((this.selectedIndex - 1 + this.items.length) % this.items.length);
      else if (o.keyCode == 40 || o.keyCode == 34)
        this.moveSelection((this.selectedIndex + 1) % this.items.length);
      else if (o.keyCode == 36)
        this.moveSelection(0);
      else if (o.keyCode == 35)
        this.moveSelection(this.items.length - 1);
      else if (o.keyCode == 13)
        this.view.focus();
      else if (o.keyCode >= 65 && o.keyCode <= 90 && this.selectedIndex >= 0) {
        let { diagnostic: i } = this.items[this.selectedIndex], s = Cfe(i.actions);
        for (let a = 0; a < s.length; a++)
          if (s[a].toUpperCase().charCodeAt(0) == o.keyCode) {
            let l = Zh(this.view.state.field(wi).diagnostics, i);
            l && i.actions[a].apply(e, l.from, l.to);
          }
      } else
        return;
      o.preventDefault();
    }, r = (o) => {
      for (let i = 0; i < this.items.length; i++)
        this.items[i].dom.contains(o.target) && this.moveSelection(i);
    };
    this.list = Bn("ul", {
      tabIndex: 0,
      role: "listbox",
      "aria-label": this.view.state.phrase("Diagnostics"),
      onkeydown: n,
      onclick: r
    }), this.dom = Bn("div", { class: "cm-panel-lint" }, this.list, Bn("button", {
      type: "button",
      name: "close",
      "aria-label": this.view.state.phrase("close"),
      onclick: () => _z(this.view)
    }, "×")), this.update();
  }
  get selectedIndex() {
    let e = this.view.state.field(wi).selected;
    if (!e)
      return -1;
    for (let n = 0; n < this.items.length; n++)
      if (this.items[n].diagnostic == e.diagnostic)
        return n;
    return -1;
  }
  update() {
    let { diagnostics: e, selected: n } = this.view.state.field(wi), r = 0, o = !1, i = null, s = /* @__PURE__ */ new Set();
    for (e.between(0, this.view.state.doc.length, (a, l, { spec: c }) => {
      for (let u of c.diagnostics) {
        if (s.has(u))
          continue;
        s.add(u);
        let d = -1, f;
        for (let h = r; h < this.items.length; h++)
          if (this.items[h].diagnostic == u) {
            d = h;
            break;
          }
        d < 0 ? (f = new wz(this.view, u), this.items.splice(r, 0, f), o = !0) : (f = this.items[d], d > r && (this.items.splice(r, d - r), o = !0)), n && f.diagnostic == n.diagnostic ? f.dom.hasAttribute("aria-selected") || (f.dom.setAttribute("aria-selected", "true"), i = f) : f.dom.hasAttribute("aria-selected") && f.dom.removeAttribute("aria-selected"), r++;
      }
    }); r < this.items.length && !(this.items.length == 1 && this.items[0].diagnostic.from < 0); )
      o = !0, this.items.pop();
    this.items.length == 0 && (this.items.push(new wz(this.view, {
      from: -1,
      to: -1,
      severity: "info",
      message: this.view.state.phrase("No diagnostics")
    })), o = !0), i ? (this.list.setAttribute("aria-activedescendant", i.id), this.view.requestMeasure({
      key: this,
      read: () => ({ sel: i.dom.getBoundingClientRect(), panel: this.list.getBoundingClientRect() }),
      write: ({ sel: a, panel: l }) => {
        let c = l.height / this.list.offsetHeight;
        a.top < l.top ? this.list.scrollTop -= (l.top - a.top) / c : a.bottom > l.bottom && (this.list.scrollTop += (a.bottom - l.bottom) / c);
      }
    })) : this.selectedIndex < 0 && this.list.removeAttribute("aria-activedescendant"), o && this.sync();
  }
  sync() {
    let e = this.list.firstChild;
    function n() {
      let r = e;
      e = r.nextSibling, r.remove();
    }
    for (let r of this.items)
      if (r.dom.parentNode == this.list) {
        for (; e != r.dom; )
          n();
        e = r.dom.nextSibling;
      } else
        this.list.insertBefore(r.dom, e);
    for (; e; )
      n();
  }
  moveSelection(e) {
    if (this.selectedIndex < 0)
      return;
    let n = this.view.state.field(wi), r = Zh(n.diagnostics, this.items[e].diagnostic);
    r && this.view.dispatch({
      selection: { anchor: r.from, head: r.to },
      scrollIntoView: !0,
      effects: Ofe.of(r)
    });
  }
  static open(e) {
    return new ry(e);
  }
}
function R7e(t, e = 'viewBox="0 0 40 40"') {
  return `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" ${e}>${encodeURIComponent(t)}</svg>')`;
}
function qb(t) {
  return R7e(`<path d="m0 2.5 l2 -1.5 l1 0 l2 1.5 l1 0" stroke="${t}" fill="none" stroke-width=".7"/>`, 'width="6" height="3"');
}
const P7e = /* @__PURE__ */ et.baseTheme({
  ".cm-diagnostic": {
    padding: "3px 6px 3px 8px",
    marginLeft: "-1px",
    display: "block",
    whiteSpace: "pre-wrap"
  },
  ".cm-diagnostic-error": { borderLeft: "5px solid #d11" },
  ".cm-diagnostic-warning": { borderLeft: "5px solid orange" },
  ".cm-diagnostic-info": { borderLeft: "5px solid #999" },
  ".cm-diagnostic-hint": { borderLeft: "5px solid #66d" },
  ".cm-diagnosticAction": {
    font: "inherit",
    border: "none",
    padding: "2px 4px",
    backgroundColor: "#444",
    color: "white",
    borderRadius: "3px",
    marginLeft: "8px",
    cursor: "pointer"
  },
  ".cm-diagnosticSource": {
    fontSize: "70%",
    opacity: 0.7
  },
  ".cm-lintRange": {
    backgroundPosition: "left bottom",
    backgroundRepeat: "repeat-x",
    paddingBottom: "0.7px"
  },
  ".cm-lintRange-error": { backgroundImage: /* @__PURE__ */ qb("#d11") },
  ".cm-lintRange-warning": { backgroundImage: /* @__PURE__ */ qb("orange") },
  ".cm-lintRange-info": { backgroundImage: /* @__PURE__ */ qb("#999") },
  ".cm-lintRange-hint": { backgroundImage: /* @__PURE__ */ qb("#66d") },
  ".cm-lintRange-active": { backgroundColor: "#ffdd9980" },
  ".cm-tooltip-lint": {
    padding: 0,
    margin: 0
  },
  ".cm-lintPoint": {
    position: "relative",
    "&:after": {
      content: '""',
      position: "absolute",
      bottom: 0,
      left: "-2px",
      borderLeft: "3px solid transparent",
      borderRight: "3px solid transparent",
      borderBottom: "4px solid #d11"
    }
  },
  ".cm-lintPoint-warning": {
    "&:after": { borderBottomColor: "orange" }
  },
  ".cm-lintPoint-info": {
    "&:after": { borderBottomColor: "#999" }
  },
  ".cm-lintPoint-hint": {
    "&:after": { borderBottomColor: "#66d" }
  },
  ".cm-panel.cm-panel-lint": {
    position: "relative",
    "& ul": {
      maxHeight: "100px",
      overflowY: "auto",
      "& [aria-selected]": {
        backgroundColor: "#ddd",
        "& u": { textDecoration: "underline" }
      },
      "&:focus [aria-selected]": {
        background_fallback: "#bdf",
        backgroundColor: "Highlight",
        color_fallback: "white",
        color: "HighlightText"
      },
      "& u": { textDecoration: "none" },
      padding: 0,
      margin: 0
    },
    "& [name=close]": {
      position: "absolute",
      top: "0",
      right: "2px",
      background: "inherit",
      border: "none",
      font: "inherit",
      padding: 0,
      margin: 0
    }
  }
});
function $7e(t) {
  return t == "error" ? 4 : t == "warning" ? 3 : t == "info" ? 2 : 1;
}
function M7e(t) {
  let e = "hint", n = 1;
  for (let r of t) {
    let o = $7e(r.severity);
    o > n && (n = o, e = r.severity);
  }
  return e;
}
const D7e = [
  wi,
  /* @__PURE__ */ et.decorations.compute([wi], (t) => {
    let { selected: e, panel: n } = t.field(wi);
    return !e || !n || e.from == e.to ? ut.none : ut.set([
      E7e.range(e.from, e.to)
    ]);
  }),
  /* @__PURE__ */ f8e(S7e, { hideOn: w7e }),
  P7e
], xz = typeof String.prototype.normalize == "function" ? (t) => t.normalize("NFKD") : (t) => t;
class Jh {
  /**
  Create a text cursor. The query is the search string, `from` to
  `to` provides the region to search.
  
  When `normalize` is given, it will be called, on both the query
  string and the content it is matched against, before comparing.
  You can, for example, create a case-insensitive search by
  passing `s => s.toLowerCase()`.
  
  Text is always normalized with
  [`.normalize("NFKD")`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/normalize)
  (when supported).
  */
  constructor(e, n, r = 0, o = e.length, i, s) {
    this.test = s, this.value = { from: 0, to: 0 }, this.done = !1, this.matches = [], this.buffer = "", this.bufferPos = 0, this.iter = e.iterRange(r, o), this.bufferStart = r, this.normalize = i ? (a) => i(xz(a)) : xz, this.query = this.normalize(n);
  }
  peek() {
    if (this.bufferPos == this.buffer.length) {
      if (this.bufferStart += this.buffer.length, this.iter.next(), this.iter.done)
        return -1;
      this.bufferPos = 0, this.buffer = this.iter.value;
    }
    return zo(this.buffer, this.bufferPos);
  }
  /**
  Look for the next match. Updates the iterator's
  [`value`](https://codemirror.net/6/docs/ref/#search.SearchCursor.value) and
  [`done`](https://codemirror.net/6/docs/ref/#search.SearchCursor.done) properties. Should be called
  at least once before using the cursor.
  */
  next() {
    for (; this.matches.length; )
      this.matches.pop();
    return this.nextOverlapping();
  }
  /**
  The `next` method will ignore matches that partially overlap a
  previous match. This method behaves like `next`, but includes
  such matches.
  */
  nextOverlapping() {
    for (; ; ) {
      let e = this.peek();
      if (e < 0)
        return this.done = !0, this;
      let n = Y5(e), r = this.bufferStart + this.bufferPos;
      this.bufferPos += la(e);
      let o = this.normalize(n);
      if (o.length)
        for (let i = 0, s = r; ; i++) {
          let a = o.charCodeAt(i), l = this.match(a, s, this.bufferPos + this.bufferStart);
          if (i == o.length - 1) {
            if (l)
              return this.value = l, this;
            break;
          }
          s == r && i < n.length && n.charCodeAt(i) == a && s++;
        }
    }
  }
  match(e, n, r) {
    let o = null;
    for (let i = 0; i < this.matches.length; i += 2) {
      let s = this.matches[i], a = !1;
      this.query.charCodeAt(s) == e && (s == this.query.length - 1 ? o = { from: this.matches[i + 1], to: r } : (this.matches[i]++, a = !0)), a || (this.matches.splice(i, 2), i -= 2);
    }
    return this.query.charCodeAt(0) == e && (this.query.length == 1 ? o = { from: n, to: r } : this.matches.push(1, n)), o && this.test && !this.test(o.from, o.to, this.buffer, this.bufferStart) && (o = null), o;
  }
}
typeof Symbol < "u" && (Jh.prototype[Symbol.iterator] = function() {
  return this;
});
const Afe = { from: -1, to: -1, match: /* @__PURE__ */ /.*/.exec("") }, xL = "gm" + (/x/.unicode == null ? "" : "u");
class Tfe {
  /**
  Create a cursor that will search the given range in the given
  document. `query` should be the raw pattern (as you'd pass it to
  `new RegExp`).
  */
  constructor(e, n, r, o = 0, i = e.length) {
    if (this.text = e, this.to = i, this.curLine = "", this.done = !1, this.value = Afe, /\\[sWDnr]|\n|\r|\[\^/.test(n))
      return new Rfe(e, n, r, o, i);
    this.re = new RegExp(n, xL + (r?.ignoreCase ? "i" : "")), this.test = r?.test, this.iter = e.iter();
    let s = e.lineAt(o);
    this.curLineStart = s.from, this.matchPos = Dx(e, o), this.getLine(this.curLineStart);
  }
  getLine(e) {
    this.iter.next(e), this.iter.lineBreak ? this.curLine = "" : (this.curLine = this.iter.value, this.curLineStart + this.curLine.length > this.to && (this.curLine = this.curLine.slice(0, this.to - this.curLineStart)), this.iter.next());
  }
  nextLine() {
    this.curLineStart = this.curLineStart + this.curLine.length + 1, this.curLineStart > this.to ? this.curLine = "" : this.getLine(0);
  }
  /**
  Move to the next match, if there is one.
  */
  next() {
    for (let e = this.matchPos - this.curLineStart; ; ) {
      this.re.lastIndex = e;
      let n = this.matchPos <= this.to && this.re.exec(this.curLine);
      if (n) {
        let r = this.curLineStart + n.index, o = r + n[0].length;
        if (this.matchPos = Dx(this.text, o + (r == o ? 1 : 0)), r == this.curLineStart + this.curLine.length && this.nextLine(), (r < o || r > this.value.to) && (!this.test || this.test(r, o, n)))
          return this.value = { from: r, to: o, match: n }, this;
        e = this.matchPos - this.curLineStart;
      } else if (this.curLineStart + this.curLine.length < this.to)
        this.nextLine(), e = 0;
      else
        return this.done = !0, this;
    }
  }
}
const gk = /* @__PURE__ */ new WeakMap();
let Ez = class _w {
  constructor(e, n) {
    this.from = e, this.text = n;
  }
  get to() {
    return this.from + this.text.length;
  }
  static get(e, n, r) {
    let o = gk.get(e);
    if (!o || o.from >= r || o.to <= n) {
      let a = new _w(n, e.sliceString(n, r));
      return gk.set(e, a), a;
    }
    if (o.from == n && o.to == r)
      return o;
    let { text: i, from: s } = o;
    return s > n && (i = e.sliceString(n, s) + i, s = n), o.to < r && (i += e.sliceString(o.to, r)), gk.set(e, new _w(s, i)), new _w(n, i.slice(n - s, r - s));
  }
};
class Rfe {
  constructor(e, n, r, o, i) {
    this.text = e, this.to = i, this.done = !1, this.value = Afe, this.matchPos = Dx(e, o), this.re = new RegExp(n, xL + (r?.ignoreCase ? "i" : "")), this.test = r?.test, this.flat = Ez.get(e, o, this.chunkEnd(
      o + 5e3
      /* Chunk.Base */
    ));
  }
  chunkEnd(e) {
    return e >= this.to ? this.to : this.text.lineAt(e).to;
  }
  next() {
    for (; ; ) {
      let e = this.re.lastIndex = this.matchPos - this.flat.from, n = this.re.exec(this.flat.text);
      if (n && !n[0] && n.index == e && (this.re.lastIndex = e + 1, n = this.re.exec(this.flat.text)), n) {
        let r = this.flat.from + n.index, o = r + n[0].length;
        if ((this.flat.to >= this.to || n.index + n[0].length <= this.flat.text.length - 10) && (!this.test || this.test(r, o, n)))
          return this.value = { from: r, to: o, match: n }, this.matchPos = Dx(this.text, o + (r == o ? 1 : 0)), this;
      }
      if (this.flat.to == this.to)
        return this.done = !0, this;
      this.flat = Ez.get(this.text, this.flat.from, this.chunkEnd(this.flat.from + this.flat.text.length * 2));
    }
  }
}
typeof Symbol < "u" && (Tfe.prototype[Symbol.iterator] = Rfe.prototype[Symbol.iterator] = function() {
  return this;
});
function I7e(t) {
  try {
    return new RegExp(t, xL), !0;
  } catch {
    return !1;
  }
}
function Dx(t, e) {
  if (e >= t.length)
    return e;
  let n = t.lineAt(e), r;
  for (; e < n.to && (r = n.text.charCodeAt(e - n.from)) >= 56320 && r < 57344; )
    e++;
  return e;
}
function kN(t) {
  let e = String(t.state.doc.lineAt(t.state.selection.main.head).number), n = Bn("input", { class: "cm-textfield", name: "line", value: e }), r = Bn("form", {
    class: "cm-gotoLine",
    onkeydown: (i) => {
      i.keyCode == 27 ? (i.preventDefault(), t.dispatch({ effects: Ix.of(!1) }), t.focus()) : i.keyCode == 13 && (i.preventDefault(), o());
    },
    onsubmit: (i) => {
      i.preventDefault(), o();
    }
  }, Bn("label", t.state.phrase("Go to line"), ": ", n), " ", Bn("button", { class: "cm-button", type: "submit" }, t.state.phrase("go")));
  function o() {
    let i = /^([+-])?(\d+)?(:\d+)?(%)?$/.exec(n.value);
    if (!i)
      return;
    let { state: s } = t, a = s.doc.lineAt(s.selection.main.head), [, l, c, u, d] = i, f = u ? +u.slice(1) : 0, h = c ? +c : a.number;
    if (c && d) {
      let g = h / 100;
      l && (g = g * (l == "-" ? -1 : 1) + a.number / s.doc.lines), h = Math.round(s.doc.lines * g);
    } else c && l && (h = h * (l == "-" ? -1 : 1) + a.number);
    let p = s.doc.line(Math.max(1, Math.min(s.doc.lines, h))), m = $e.cursor(p.from + Math.max(0, Math.min(f, p.length)));
    t.dispatch({
      effects: [Ix.of(!1), et.scrollIntoView(m.from, { y: "center" })],
      selection: m
    }), t.focus();
  }
  return { dom: r };
}
const Ix = /* @__PURE__ */ xt.define(), Sz = /* @__PURE__ */ jr.define({
  create() {
    return !0;
  },
  update(t, e) {
    for (let n of e.effects)
      n.is(Ix) && (t = n.value);
    return t;
  },
  provide: (t) => Q0.from(t, (e) => e ? kN : null)
}), N7e = (t) => {
  let e = X0(t, kN);
  if (!e) {
    let n = [Ix.of(!0)];
    t.state.field(Sz, !1) == null && n.push(xt.appendConfig.of([Sz, j7e])), t.dispatch({ effects: n }), e = X0(t, kN);
  }
  return e && e.dom.querySelector("input").select(), !0;
}, j7e = /* @__PURE__ */ et.baseTheme({
  ".cm-panel.cm-gotoLine": {
    padding: "2px 6px 4px",
    "& label": { fontSize: "80%" }
  }
}), L7e = {
  highlightWordAroundCursor: !1,
  minSelectionLength: 1,
  maxMatches: 100,
  wholeWords: !1
}, F7e = /* @__PURE__ */ lt.define({
  combine(t) {
    return Ra(t, L7e, {
      highlightWordAroundCursor: (e, n) => e || n,
      minSelectionLength: Math.min,
      maxMatches: Math.min
    });
  }
});
function B7e(t) {
  return [V7e, H7e];
}
const z7e = /* @__PURE__ */ ut.mark({ class: "cm-selectionMatch" }), q7e = /* @__PURE__ */ ut.mark({ class: "cm-selectionMatch cm-selectionMatch-main" });
function Oz(t, e, n, r) {
  return (n == 0 || t(e.sliceDoc(n - 1, n)) != rr.Word) && (r == e.doc.length || t(e.sliceDoc(r, r + 1)) != rr.Word);
}
function U7e(t, e, n, r) {
  return t(e.sliceDoc(n, n + 1)) == rr.Word && t(e.sliceDoc(r - 1, r)) == rr.Word;
}
const H7e = /* @__PURE__ */ kr.fromClass(class {
  constructor(t) {
    this.decorations = this.getDeco(t);
  }
  update(t) {
    (t.selectionSet || t.docChanged || t.viewportChanged) && (this.decorations = this.getDeco(t.view));
  }
  getDeco(t) {
    let e = t.state.facet(F7e), { state: n } = t, r = n.selection;
    if (r.ranges.length > 1)
      return ut.none;
    let o = r.main, i, s = null;
    if (o.empty) {
      if (!e.highlightWordAroundCursor)
        return ut.none;
      let l = n.wordAt(o.head);
      if (!l)
        return ut.none;
      s = n.charCategorizer(o.head), i = n.sliceDoc(l.from, l.to);
    } else {
      let l = o.to - o.from;
      if (l < e.minSelectionLength || l > 200)
        return ut.none;
      if (e.wholeWords) {
        if (i = n.sliceDoc(o.from, o.to), s = n.charCategorizer(o.head), !(Oz(s, n, o.from, o.to) && U7e(s, n, o.from, o.to)))
          return ut.none;
      } else if (i = n.sliceDoc(o.from, o.to), !i)
        return ut.none;
    }
    let a = [];
    for (let l of t.visibleRanges) {
      let c = new Jh(n.doc, i, l.from, l.to);
      for (; !c.next().done; ) {
        let { from: u, to: d } = c.value;
        if ((!s || Oz(s, n, u, d)) && (o.empty && u <= o.from && d >= o.to ? a.push(q7e.range(u, d)) : (u >= o.to || d <= o.from) && a.push(z7e.range(u, d)), a.length > e.maxMatches))
          return ut.none;
      }
    }
    return ut.set(a);
  }
}, {
  decorations: (t) => t.decorations
}), V7e = /* @__PURE__ */ et.baseTheme({
  ".cm-selectionMatch": { backgroundColor: "#99ff7780" },
  ".cm-searchMatch .cm-selectionMatch": { backgroundColor: "transparent" }
}), W7e = ({ state: t, dispatch: e }) => {
  let { selection: n } = t, r = $e.create(n.ranges.map((o) => t.wordAt(o.head) || $e.cursor(o.head)), n.mainIndex);
  return r.eq(n) ? !1 : (e(t.update({ selection: r })), !0);
};
function G7e(t, e) {
  let { main: n, ranges: r } = t.selection, o = t.wordAt(n.head), i = o && o.from == n.from && o.to == n.to;
  for (let s = !1, a = new Jh(t.doc, e, r[r.length - 1].to); ; )
    if (a.next(), a.done) {
      if (s)
        return null;
      a = new Jh(t.doc, e, 0, Math.max(0, r[r.length - 1].from - 1)), s = !0;
    } else {
      if (s && r.some((l) => l.from == a.value.from))
        continue;
      if (i) {
        let l = t.wordAt(a.value.from);
        if (!l || l.from != a.value.from || l.to != a.value.to)
          continue;
      }
      return a.value;
    }
}
const Y7e = ({ state: t, dispatch: e }) => {
  let { ranges: n } = t.selection;
  if (n.some((i) => i.from === i.to))
    return W7e({ state: t, dispatch: e });
  let r = t.sliceDoc(n[0].from, n[0].to);
  if (t.selection.ranges.some((i) => t.sliceDoc(i.from, i.to) != r))
    return !1;
  let o = G7e(t, r);
  return o ? (e(t.update({
    selection: t.selection.addRange($e.range(o.from, o.to), !1),
    effects: et.scrollIntoView(o.to)
  })), !0) : !1;
}, Cp = /* @__PURE__ */ lt.define({
  combine(t) {
    return Ra(t, {
      top: !1,
      caseSensitive: !1,
      literal: !1,
      regexp: !1,
      wholeWord: !1,
      createPanel: (e) => new sBe(e),
      scrollToMatch: (e) => et.scrollIntoView(e)
    });
  }
});
class Pfe {
  /**
  Create a query object.
  */
  constructor(e) {
    this.search = e.search, this.caseSensitive = !!e.caseSensitive, this.literal = !!e.literal, this.regexp = !!e.regexp, this.replace = e.replace || "", this.valid = !!this.search && (!this.regexp || I7e(this.search)), this.unquoted = this.unquote(this.search), this.wholeWord = !!e.wholeWord;
  }
  /**
  @internal
  */
  unquote(e) {
    return this.literal ? e : e.replace(/\\([nrt\\])/g, (n, r) => r == "n" ? `
` : r == "r" ? "\r" : r == "t" ? "	" : "\\");
  }
  /**
  Compare this query to another query.
  */
  eq(e) {
    return this.search == e.search && this.replace == e.replace && this.caseSensitive == e.caseSensitive && this.regexp == e.regexp && this.wholeWord == e.wholeWord;
  }
  /**
  @internal
  */
  create() {
    return this.regexp ? new Z7e(this) : new X7e(this);
  }
  /**
  Get a search cursor for this query, searching through the given
  range in the given state.
  */
  getCursor(e, n = 0, r) {
    let o = e.doc ? e : qt.create({ doc: e });
    return r == null && (r = o.doc.length), this.regexp ? If(this, o, n, r) : Df(this, o, n, r);
  }
}
class $fe {
  constructor(e) {
    this.spec = e;
  }
}
function Df(t, e, n, r) {
  return new Jh(e.doc, t.unquoted, n, r, t.caseSensitive ? void 0 : (o) => o.toLowerCase(), t.wholeWord ? K7e(e.doc, e.charCategorizer(e.selection.main.head)) : void 0);
}
function K7e(t, e) {
  return (n, r, o, i) => ((i > n || i + o.length < r) && (i = Math.max(0, n - 2), o = t.sliceString(i, Math.min(t.length, r + 2))), (e(Nx(o, n - i)) != rr.Word || e(jx(o, n - i)) != rr.Word) && (e(jx(o, r - i)) != rr.Word || e(Nx(o, r - i)) != rr.Word));
}
class X7e extends $fe {
  constructor(e) {
    super(e);
  }
  nextMatch(e, n, r) {
    let o = Df(this.spec, e, r, e.doc.length).nextOverlapping();
    if (o.done) {
      let i = Math.min(e.doc.length, n + this.spec.unquoted.length);
      o = Df(this.spec, e, 0, i).nextOverlapping();
    }
    return o.done || o.value.from == n && o.value.to == r ? null : o.value;
  }
  // Searching in reverse is, rather than implementing an inverted search
  // cursor, done by scanning chunk after chunk forward.
  prevMatchInRange(e, n, r) {
    for (let o = r; ; ) {
      let i = Math.max(n, o - 1e4 - this.spec.unquoted.length), s = Df(this.spec, e, i, o), a = null;
      for (; !s.nextOverlapping().done; )
        a = s.value;
      if (a)
        return a;
      if (i == n)
        return null;
      o -= 1e4;
    }
  }
  prevMatch(e, n, r) {
    let o = this.prevMatchInRange(e, 0, n);
    return o || (o = this.prevMatchInRange(e, Math.max(0, r - this.spec.unquoted.length), e.doc.length)), o && (o.from != n || o.to != r) ? o : null;
  }
  getReplacement(e) {
    return this.spec.unquote(this.spec.replace);
  }
  matchAll(e, n) {
    let r = Df(this.spec, e, 0, e.doc.length), o = [];
    for (; !r.next().done; ) {
      if (o.length >= n)
        return null;
      o.push(r.value);
    }
    return o;
  }
  highlight(e, n, r, o) {
    let i = Df(this.spec, e, Math.max(0, n - this.spec.unquoted.length), Math.min(r + this.spec.unquoted.length, e.doc.length));
    for (; !i.next().done; )
      o(i.value.from, i.value.to);
  }
}
function If(t, e, n, r) {
  return new Tfe(e.doc, t.search, {
    ignoreCase: !t.caseSensitive,
    test: t.wholeWord ? Q7e(e.charCategorizer(e.selection.main.head)) : void 0
  }, n, r);
}
function Nx(t, e) {
  return t.slice(Zr(t, e, !1), e);
}
function jx(t, e) {
  return t.slice(e, Zr(t, e));
}
function Q7e(t) {
  return (e, n, r) => !r[0].length || (t(Nx(r.input, r.index)) != rr.Word || t(jx(r.input, r.index)) != rr.Word) && (t(jx(r.input, r.index + r[0].length)) != rr.Word || t(Nx(r.input, r.index + r[0].length)) != rr.Word);
}
class Z7e extends $fe {
  nextMatch(e, n, r) {
    let o = If(this.spec, e, r, e.doc.length).next();
    return o.done && (o = If(this.spec, e, 0, n).next()), o.done ? null : o.value;
  }
  prevMatchInRange(e, n, r) {
    for (let o = 1; ; o++) {
      let i = Math.max(
        n,
        r - o * 1e4
        /* FindPrev.ChunkSize */
      ), s = If(this.spec, e, i, r), a = null;
      for (; !s.next().done; )
        a = s.value;
      if (a && (i == n || a.from > i + 10))
        return a;
      if (i == n)
        return null;
    }
  }
  prevMatch(e, n, r) {
    return this.prevMatchInRange(e, 0, n) || this.prevMatchInRange(e, r, e.doc.length);
  }
  getReplacement(e) {
    return this.spec.unquote(this.spec.replace).replace(/\$([$&\d+])/g, (n, r) => r == "$" ? "$" : r == "&" ? e.match[0] : r != "0" && +r < e.match.length ? e.match[r] : n);
  }
  matchAll(e, n) {
    let r = If(this.spec, e, 0, e.doc.length), o = [];
    for (; !r.next().done; ) {
      if (o.length >= n)
        return null;
      o.push(r.value);
    }
    return o;
  }
  highlight(e, n, r, o) {
    let i = If(this.spec, e, Math.max(
      0,
      n - 250
      /* RegExp.HighlightMargin */
    ), Math.min(r + 250, e.doc.length));
    for (; !i.next().done; )
      o(i.value.from, i.value.to);
  }
}
const oy = /* @__PURE__ */ xt.define(), EL = /* @__PURE__ */ xt.define(), Vc = /* @__PURE__ */ jr.define({
  create(t) {
    return new yk(AN(t).create(), null);
  },
  update(t, e) {
    for (let n of e.effects)
      n.is(oy) ? t = new yk(n.value.create(), t.panel) : n.is(EL) && (t = new yk(t.query, n.value ? SL : null));
    return t;
  },
  provide: (t) => Q0.from(t, (e) => e.panel)
});
class yk {
  constructor(e, n) {
    this.query = e, this.panel = n;
  }
}
const J7e = /* @__PURE__ */ ut.mark({ class: "cm-searchMatch" }), eBe = /* @__PURE__ */ ut.mark({ class: "cm-searchMatch cm-searchMatch-selected" }), tBe = /* @__PURE__ */ kr.fromClass(class {
  constructor(t) {
    this.view = t, this.decorations = this.highlight(t.state.field(Vc));
  }
  update(t) {
    let e = t.state.field(Vc);
    (e != t.startState.field(Vc) || t.docChanged || t.selectionSet || t.viewportChanged) && (this.decorations = this.highlight(e));
  }
  highlight({ query: t, panel: e }) {
    if (!e || !t.spec.valid)
      return ut.none;
    let { view: n } = this, r = new $d();
    for (let o = 0, i = n.visibleRanges, s = i.length; o < s; o++) {
      let { from: a, to: l } = i[o];
      for (; o < s - 1 && l > i[o + 1].from - 2 * 250; )
        l = i[++o].to;
      t.highlight(n.state, a, l, (c, u) => {
        let d = n.state.selection.ranges.some((f) => f.from == c && f.to == u);
        r.add(c, u, d ? eBe : J7e);
      });
    }
    return r.finish();
  }
}, {
  decorations: (t) => t.decorations
});
function gv(t) {
  return (e) => {
    let n = e.state.field(Vc, !1);
    return n && n.query.spec.valid ? t(e, n) : Ife(e);
  };
}
const Lx = /* @__PURE__ */ gv((t, { query: e }) => {
  let { to: n } = t.state.selection.main, r = e.nextMatch(t.state, n, n);
  if (!r)
    return !1;
  let o = $e.single(r.from, r.to), i = t.state.facet(Cp);
  return t.dispatch({
    selection: o,
    effects: [OL(t, r), i.scrollToMatch(o.main, t)],
    userEvent: "select.search"
  }), Dfe(t), !0;
}), Fx = /* @__PURE__ */ gv((t, { query: e }) => {
  let { state: n } = t, { from: r } = n.selection.main, o = e.prevMatch(n, r, r);
  if (!o)
    return !1;
  let i = $e.single(o.from, o.to), s = t.state.facet(Cp);
  return t.dispatch({
    selection: i,
    effects: [OL(t, o), s.scrollToMatch(i.main, t)],
    userEvent: "select.search"
  }), Dfe(t), !0;
}), nBe = /* @__PURE__ */ gv((t, { query: e }) => {
  let n = e.matchAll(t.state, 1e3);
  return !n || !n.length ? !1 : (t.dispatch({
    selection: $e.create(n.map((r) => $e.range(r.from, r.to))),
    userEvent: "select.search.matches"
  }), !0);
}), rBe = ({ state: t, dispatch: e }) => {
  let n = t.selection;
  if (n.ranges.length > 1 || n.main.empty)
    return !1;
  let { from: r, to: o } = n.main, i = [], s = 0;
  for (let a = new Jh(t.doc, t.sliceDoc(r, o)); !a.next().done; ) {
    if (i.length > 1e3)
      return !1;
    a.value.from == r && (s = i.length), i.push($e.range(a.value.from, a.value.to));
  }
  return e(t.update({
    selection: $e.create(i, s),
    userEvent: "select.search.matches"
  })), !0;
}, Cz = /* @__PURE__ */ gv((t, { query: e }) => {
  let { state: n } = t, { from: r, to: o } = n.selection.main;
  if (n.readOnly)
    return !1;
  let i = e.nextMatch(n, r, r);
  if (!i)
    return !1;
  let s = i, a = [], l, c, u = [];
  if (s.from == r && s.to == o && (c = n.toText(e.getReplacement(s)), a.push({ from: s.from, to: s.to, insert: c }), s = e.nextMatch(n, s.from, s.to), u.push(et.announce.of(n.phrase("replaced match on line $", n.doc.lineAt(r).number) + "."))), s) {
    let d = a.length == 0 || a[0].from >= i.to ? 0 : i.to - i.from - c.length;
    l = $e.single(s.from - d, s.to - d), u.push(OL(t, s)), u.push(n.facet(Cp).scrollToMatch(l.main, t));
  }
  return t.dispatch({
    changes: a,
    selection: l,
    effects: u,
    userEvent: "input.replace"
  }), !0;
}), oBe = /* @__PURE__ */ gv((t, { query: e }) => {
  if (t.state.readOnly)
    return !1;
  let n = e.matchAll(t.state, 1e9).map((o) => {
    let { from: i, to: s } = o;
    return { from: i, to: s, insert: e.getReplacement(o) };
  });
  if (!n.length)
    return !1;
  let r = t.state.phrase("replaced $ matches", n.length) + ".";
  return t.dispatch({
    changes: n,
    effects: et.announce.of(r),
    userEvent: "input.replace.all"
  }), !0;
});
function SL(t) {
  return t.state.facet(Cp).createPanel(t);
}
function AN(t, e) {
  var n, r, o, i, s;
  let a = t.selection.main, l = a.empty || a.to > a.from + 100 ? "" : t.sliceDoc(a.from, a.to);
  if (e && !l)
    return e;
  let c = t.facet(Cp);
  return new Pfe({
    search: ((n = e?.literal) !== null && n !== void 0 ? n : c.literal) ? l : l.replace(/\n/g, "\\n"),
    caseSensitive: (r = e?.caseSensitive) !== null && r !== void 0 ? r : c.caseSensitive,
    literal: (o = e?.literal) !== null && o !== void 0 ? o : c.literal,
    regexp: (i = e?.regexp) !== null && i !== void 0 ? i : c.regexp,
    wholeWord: (s = e?.wholeWord) !== null && s !== void 0 ? s : c.wholeWord
  });
}
function Mfe(t) {
  let e = X0(t, SL);
  return e && e.dom.querySelector("[main-field]");
}
function Dfe(t) {
  let e = Mfe(t);
  e && e == t.root.activeElement && e.select();
}
const Ife = (t) => {
  let e = t.state.field(Vc, !1);
  if (e && e.panel) {
    let n = Mfe(t);
    if (n && n != t.root.activeElement) {
      let r = AN(t.state, e.query.spec);
      r.valid && t.dispatch({ effects: oy.of(r) }), n.focus(), n.select();
    }
  } else
    t.dispatch({ effects: [
      EL.of(!0),
      e ? oy.of(AN(t.state, e.query.spec)) : xt.appendConfig.of(lBe)
    ] });
  return !0;
}, Nfe = (t) => {
  let e = t.state.field(Vc, !1);
  if (!e || !e.panel)
    return !1;
  let n = X0(t, SL);
  return n && n.dom.contains(t.root.activeElement) && t.focus(), t.dispatch({ effects: EL.of(!1) }), !0;
}, iBe = [
  { key: "Mod-f", run: Ife, scope: "editor search-panel" },
  { key: "F3", run: Lx, shift: Fx, scope: "editor search-panel", preventDefault: !0 },
  { key: "Mod-g", run: Lx, shift: Fx, scope: "editor search-panel", preventDefault: !0 },
  { key: "Escape", run: Nfe, scope: "editor search-panel" },
  { key: "Mod-Shift-l", run: rBe },
  { key: "Mod-Alt-g", run: N7e },
  { key: "Mod-d", run: Y7e, preventDefault: !0 }
];
class sBe {
  constructor(e) {
    this.view = e;
    let n = this.query = e.state.field(Vc).query.spec;
    this.commit = this.commit.bind(this), this.searchField = Bn("input", {
      value: n.search,
      placeholder: ii(e, "Find"),
      "aria-label": ii(e, "Find"),
      class: "cm-textfield",
      name: "search",
      form: "",
      "main-field": "true",
      onchange: this.commit,
      onkeyup: this.commit
    }), this.replaceField = Bn("input", {
      value: n.replace,
      placeholder: ii(e, "Replace"),
      "aria-label": ii(e, "Replace"),
      class: "cm-textfield",
      name: "replace",
      form: "",
      onchange: this.commit,
      onkeyup: this.commit
    }), this.caseField = Bn("input", {
      type: "checkbox",
      name: "case",
      form: "",
      checked: n.caseSensitive,
      onchange: this.commit
    }), this.reField = Bn("input", {
      type: "checkbox",
      name: "re",
      form: "",
      checked: n.regexp,
      onchange: this.commit
    }), this.wordField = Bn("input", {
      type: "checkbox",
      name: "word",
      form: "",
      checked: n.wholeWord,
      onchange: this.commit
    });
    function r(o, i, s) {
      return Bn("button", { class: "cm-button", name: o, onclick: i, type: "button" }, s);
    }
    this.dom = Bn("div", { onkeydown: (o) => this.keydown(o), class: "cm-search" }, [
      this.searchField,
      r("next", () => Lx(e), [ii(e, "next")]),
      r("prev", () => Fx(e), [ii(e, "previous")]),
      r("select", () => nBe(e), [ii(e, "all")]),
      Bn("label", null, [this.caseField, ii(e, "match case")]),
      Bn("label", null, [this.reField, ii(e, "regexp")]),
      Bn("label", null, [this.wordField, ii(e, "by word")]),
      ...e.state.readOnly ? [] : [
        Bn("br"),
        this.replaceField,
        r("replace", () => Cz(e), [ii(e, "replace")]),
        r("replaceAll", () => oBe(e), [ii(e, "replace all")])
      ],
      Bn("button", {
        name: "close",
        onclick: () => Nfe(e),
        "aria-label": ii(e, "close"),
        type: "button"
      }, ["×"])
    ]);
  }
  commit() {
    let e = new Pfe({
      search: this.searchField.value,
      caseSensitive: this.caseField.checked,
      regexp: this.reField.checked,
      wholeWord: this.wordField.checked,
      replace: this.replaceField.value
    });
    e.eq(this.query) || (this.query = e, this.view.dispatch({ effects: oy.of(e) }));
  }
  keydown(e) {
    O9e(this.view, e, "search-panel") ? e.preventDefault() : e.keyCode == 13 && e.target == this.searchField ? (e.preventDefault(), (e.shiftKey ? Fx : Lx)(this.view)) : e.keyCode == 13 && e.target == this.replaceField && (e.preventDefault(), Cz(this.view));
  }
  update(e) {
    for (let n of e.transactions)
      for (let r of n.effects)
        r.is(oy) && !r.value.eq(this.query) && this.setQuery(r.value);
  }
  setQuery(e) {
    this.query = e, this.searchField.value = e.search, this.replaceField.value = e.replace, this.caseField.checked = e.caseSensitive, this.reField.checked = e.regexp, this.wordField.checked = e.wholeWord;
  }
  mount() {
    this.searchField.select();
  }
  get pos() {
    return 80;
  }
  get top() {
    return this.view.state.facet(Cp).top;
  }
}
function ii(t, e) {
  return t.state.phrase(e);
}
const Ub = 30, Hb = /[\s\.,:;?!]/;
function OL(t, { from: e, to: n }) {
  let r = t.state.doc.lineAt(e), o = t.state.doc.lineAt(n).to, i = Math.max(r.from, e - Ub), s = Math.min(o, n + Ub), a = t.state.sliceDoc(i, s);
  if (i != r.from) {
    for (let l = 0; l < Ub; l++)
      if (!Hb.test(a[l + 1]) && Hb.test(a[l])) {
        a = a.slice(l);
        break;
      }
  }
  if (s != o) {
    for (let l = a.length - 1; l > a.length - Ub; l--)
      if (!Hb.test(a[l - 1]) && Hb.test(a[l])) {
        a = a.slice(0, l);
        break;
      }
  }
  return et.announce.of(`${t.state.phrase("current match")}. ${a} ${t.state.phrase("on line")} ${r.number}.`);
}
const aBe = /* @__PURE__ */ et.baseTheme({
  ".cm-panel.cm-search": {
    padding: "2px 6px 4px",
    position: "relative",
    "& [name=close]": {
      position: "absolute",
      top: "0",
      right: "4px",
      backgroundColor: "inherit",
      border: "none",
      font: "inherit",
      padding: 0,
      margin: 0
    },
    "& input, & button, & label": {
      margin: ".2em .6em .2em 0"
    },
    "& input[type=checkbox]": {
      marginRight: ".2em"
    },
    "& label": {
      fontSize: "80%",
      whiteSpace: "pre"
    }
  },
  "&light .cm-searchMatch": { backgroundColor: "#ffff0054" },
  "&dark .cm-searchMatch": { backgroundColor: "#00ffff8a" },
  "&light .cm-searchMatch-selected": { backgroundColor: "#ff6a0054" },
  "&dark .cm-searchMatch-selected": { backgroundColor: "#ff00ff8a" }
}), lBe = [
  Vc,
  /* @__PURE__ */ Yd.low(tBe),
  aBe
], cBe = (t) => {
  let { state: e } = t, n = e.doc.lineAt(e.selection.main.from), r = kL(t.state, n.from);
  return r.line ? uBe(t) : r.block ? fBe(t) : !1;
};
function CL(t, e) {
  return ({ state: n, dispatch: r }) => {
    if (n.readOnly)
      return !1;
    let o = t(e, n);
    return o ? (r(n.update(o)), !0) : !1;
  };
}
const uBe = /* @__PURE__ */ CL(
  mBe,
  0
  /* CommentOption.Toggle */
), dBe = /* @__PURE__ */ CL(
  jfe,
  0
  /* CommentOption.Toggle */
), fBe = /* @__PURE__ */ CL(
  (t, e) => jfe(t, e, pBe(e)),
  0
  /* CommentOption.Toggle */
);
function kL(t, e) {
  let n = t.languageDataAt("commentTokens", e);
  return n.length ? n[0] : {};
}
const dm = 50;
function hBe(t, { open: e, close: n }, r, o) {
  let i = t.sliceDoc(r - dm, r), s = t.sliceDoc(o, o + dm), a = /\s*$/.exec(i)[0].length, l = /^\s*/.exec(s)[0].length, c = i.length - a;
  if (i.slice(c - e.length, c) == e && s.slice(l, l + n.length) == n)
    return {
      open: { pos: r - a, margin: a && 1 },
      close: { pos: o + l, margin: l && 1 }
    };
  let u, d;
  o - r <= 2 * dm ? u = d = t.sliceDoc(r, o) : (u = t.sliceDoc(r, r + dm), d = t.sliceDoc(o - dm, o));
  let f = /^\s*/.exec(u)[0].length, h = /\s*$/.exec(d)[0].length, p = d.length - h - n.length;
  return u.slice(f, f + e.length) == e && d.slice(p, p + n.length) == n ? {
    open: {
      pos: r + f + e.length,
      margin: /\s/.test(u.charAt(f + e.length)) ? 1 : 0
    },
    close: {
      pos: o - h - n.length,
      margin: /\s/.test(d.charAt(p - 1)) ? 1 : 0
    }
  } : null;
}
function pBe(t) {
  let e = [];
  for (let n of t.selection.ranges) {
    let r = t.doc.lineAt(n.from), o = n.to <= r.to ? r : t.doc.lineAt(n.to);
    o.from > r.from && o.from == n.to && (o = n.to == r.to + 1 ? r : t.doc.lineAt(n.to - 1));
    let i = e.length - 1;
    i >= 0 && e[i].to > r.from ? e[i].to = o.to : e.push({ from: r.from + /^\s*/.exec(r.text)[0].length, to: o.to });
  }
  return e;
}
function jfe(t, e, n = e.selection.ranges) {
  let r = n.map((i) => kL(e, i.from).block);
  if (!r.every((i) => i))
    return null;
  let o = n.map((i, s) => hBe(e, r[s], i.from, i.to));
  if (t != 2 && !o.every((i) => i))
    return { changes: e.changes(n.map((i, s) => o[s] ? [] : [{ from: i.from, insert: r[s].open + " " }, { from: i.to, insert: " " + r[s].close }])) };
  if (t != 1 && o.some((i) => i)) {
    let i = [];
    for (let s = 0, a; s < o.length; s++)
      if (a = o[s]) {
        let l = r[s], { open: c, close: u } = a;
        i.push({ from: c.pos - l.open.length, to: c.pos + c.margin }, { from: u.pos - u.margin, to: u.pos + l.close.length });
      }
    return { changes: i };
  }
  return null;
}
function mBe(t, e, n = e.selection.ranges) {
  let r = [], o = -1;
  for (let { from: i, to: s } of n) {
    let a = r.length, l = 1e9, c = kL(e, i).line;
    if (c) {
      for (let u = i; u <= s; ) {
        let d = e.doc.lineAt(u);
        if (d.from > o && (i == s || s > d.from)) {
          o = d.from;
          let f = /^\s*/.exec(d.text)[0].length, h = f == d.length, p = d.text.slice(f, f + c.length) == c ? f : -1;
          f < d.text.length && f < l && (l = f), r.push({ line: d, comment: p, token: c, indent: f, empty: h, single: !1 });
        }
        u = d.to + 1;
      }
      if (l < 1e9)
        for (let u = a; u < r.length; u++)
          r[u].indent < r[u].line.text.length && (r[u].indent = l);
      r.length == a + 1 && (r[a].single = !0);
    }
  }
  if (t != 2 && r.some((i) => i.comment < 0 && (!i.empty || i.single))) {
    let i = [];
    for (let { line: a, token: l, indent: c, empty: u, single: d } of r)
      (d || !u) && i.push({ from: a.from + c, insert: l + " " });
    let s = e.changes(i);
    return { changes: s, selection: e.selection.map(s, 1) };
  } else if (t != 1 && r.some((i) => i.comment >= 0)) {
    let i = [];
    for (let { line: s, comment: a, token: l } of r)
      if (a >= 0) {
        let c = s.from + a, u = c + l.length;
        s.text[u - s.from] == " " && u++, i.push({ from: c, to: u });
      }
    return { changes: i };
  }
  return null;
}
const TN = /* @__PURE__ */ Ta.define(), gBe = /* @__PURE__ */ Ta.define(), yBe = /* @__PURE__ */ lt.define(), Lfe = /* @__PURE__ */ lt.define({
  combine(t) {
    return Ra(t, {
      minDepth: 100,
      newGroupDelay: 500,
      joinToEvent: (e, n) => n
    }, {
      minDepth: Math.max,
      newGroupDelay: Math.min,
      joinToEvent: (e, n) => (r, o) => e(r, o) || n(r, o)
    });
  }
}), Ffe = /* @__PURE__ */ jr.define({
  create() {
    return o0.empty;
  },
  update(t, e) {
    let n = e.state.facet(Lfe), r = e.annotation(TN);
    if (r) {
      let l = _l.fromTransaction(e, r.selection), c = r.side, u = c == 0 ? t.undone : t.done;
      return l ? u = Bx(u, u.length, n.minDepth, l) : u = qfe(u, e.startState.selection), new o0(c == 0 ? r.rest : u, c == 0 ? u : r.rest);
    }
    let o = e.annotation(gBe);
    if ((o == "full" || o == "before") && (t = t.isolate()), e.annotation(Zo.addToHistory) === !1)
      return e.changes.empty ? t : t.addMapping(e.changes.desc);
    let i = _l.fromTransaction(e), s = e.annotation(Zo.time), a = e.annotation(Zo.userEvent);
    return i ? t = t.addChanges(i, s, a, n, e) : e.selection && (t = t.addSelection(e.startState.selection, s, a, n.newGroupDelay)), (o == "full" || o == "after") && (t = t.isolate()), t;
  },
  toJSON(t) {
    return { done: t.done.map((e) => e.toJSON()), undone: t.undone.map((e) => e.toJSON()) };
  },
  fromJSON(t) {
    return new o0(t.done.map(_l.fromJSON), t.undone.map(_l.fromJSON));
  }
});
function vBe(t = {}) {
  return [
    Ffe,
    Lfe.of(t),
    et.domEventHandlers({
      beforeinput(e, n) {
        let r = e.inputType == "historyUndo" ? Bfe : e.inputType == "historyRedo" ? RN : null;
        return r ? (e.preventDefault(), r(n)) : !1;
      }
    })
  ];
}
function IS(t, e) {
  return function({ state: n, dispatch: r }) {
    if (!e && n.readOnly)
      return !1;
    let o = n.field(Ffe, !1);
    if (!o)
      return !1;
    let i = o.pop(t, n, e);
    return i ? (r(i), !0) : !1;
  };
}
const Bfe = /* @__PURE__ */ IS(0, !1), RN = /* @__PURE__ */ IS(1, !1), bBe = /* @__PURE__ */ IS(0, !0), _Be = /* @__PURE__ */ IS(1, !0);
let _l = class Eg {
  constructor(e, n, r, o, i) {
    this.changes = e, this.effects = n, this.mapped = r, this.startSelection = o, this.selectionsAfter = i;
  }
  setSelAfter(e) {
    return new Eg(this.changes, this.effects, this.mapped, this.startSelection, e);
  }
  toJSON() {
    var e, n, r;
    return {
      changes: (e = this.changes) === null || e === void 0 ? void 0 : e.toJSON(),
      mapped: (n = this.mapped) === null || n === void 0 ? void 0 : n.toJSON(),
      startSelection: (r = this.startSelection) === null || r === void 0 ? void 0 : r.toJSON(),
      selectionsAfter: this.selectionsAfter.map((o) => o.toJSON())
    };
  }
  static fromJSON(e) {
    return new Eg(e.changes && Ps.fromJSON(e.changes), [], e.mapped && ph.fromJSON(e.mapped), e.startSelection && $e.fromJSON(e.startSelection), e.selectionsAfter.map($e.fromJSON));
  }
  // This does not check `addToHistory` and such, it assumes the
  // transaction needs to be converted to an item. Returns null when
  // there are no changes or effects in the transaction.
  static fromTransaction(e, n) {
    let r = zi;
    for (let o of e.startState.facet(yBe)) {
      let i = o(e);
      i.length && (r = r.concat(i));
    }
    return !r.length && e.changes.empty ? null : new Eg(e.changes.invert(e.startState.doc), r, void 0, n || e.startState.selection, zi);
  }
  static selection(e) {
    return new Eg(void 0, zi, void 0, void 0, e);
  }
};
function Bx(t, e, n, r) {
  let o = e + 1 > n + 20 ? e - n - 1 : 0, i = t.slice(o, e);
  return i.push(r), i;
}
function wBe(t, e) {
  let n = [], r = !1;
  return t.iterChangedRanges((o, i) => n.push(o, i)), e.iterChangedRanges((o, i, s, a) => {
    for (let l = 0; l < n.length; ) {
      let c = n[l++], u = n[l++];
      a >= c && s <= u && (r = !0);
    }
  }), r;
}
function xBe(t, e) {
  return t.ranges.length == e.ranges.length && t.ranges.filter((n, r) => n.empty != e.ranges[r].empty).length === 0;
}
function zfe(t, e) {
  return t.length ? e.length ? t.concat(e) : t : e;
}
const zi = [], EBe = 200;
function qfe(t, e) {
  if (t.length) {
    let n = t[t.length - 1], r = n.selectionsAfter.slice(Math.max(0, n.selectionsAfter.length - EBe));
    return r.length && r[r.length - 1].eq(e) ? t : (r.push(e), Bx(t, t.length - 1, 1e9, n.setSelAfter(r)));
  } else
    return [_l.selection([e])];
}
function SBe(t) {
  let e = t[t.length - 1], n = t.slice();
  return n[t.length - 1] = e.setSelAfter(e.selectionsAfter.slice(0, e.selectionsAfter.length - 1)), n;
}
function vk(t, e) {
  if (!t.length)
    return t;
  let n = t.length, r = zi;
  for (; n; ) {
    let o = OBe(t[n - 1], e, r);
    if (o.changes && !o.changes.empty || o.effects.length) {
      let i = t.slice(0, n);
      return i[n - 1] = o, i;
    } else
      e = o.mapped, n--, r = o.selectionsAfter;
  }
  return r.length ? [_l.selection(r)] : zi;
}
function OBe(t, e, n) {
  let r = zfe(t.selectionsAfter.length ? t.selectionsAfter.map((a) => a.map(e)) : zi, n);
  if (!t.changes)
    return _l.selection(r);
  let o = t.changes.map(e), i = e.mapDesc(t.changes, !0), s = t.mapped ? t.mapped.composeDesc(i) : i;
  return new _l(o, xt.mapEffects(t.effects, e), s, t.startSelection.map(i), r);
}
const CBe = /^(input\.type|delete)($|\.)/;
let o0 = class Sg {
  constructor(e, n, r = 0, o = void 0) {
    this.done = e, this.undone = n, this.prevTime = r, this.prevUserEvent = o;
  }
  isolate() {
    return this.prevTime ? new Sg(this.done, this.undone) : this;
  }
  addChanges(e, n, r, o, i) {
    let s = this.done, a = s[s.length - 1];
    return a && a.changes && !a.changes.empty && e.changes && (!r || CBe.test(r)) && (!a.selectionsAfter.length && n - this.prevTime < o.newGroupDelay && o.joinToEvent(i, wBe(a.changes, e.changes)) || // For compose (but not compose.start) events, always join with previous event
    r == "input.type.compose") ? s = Bx(s, s.length - 1, o.minDepth, new _l(e.changes.compose(a.changes), zfe(xt.mapEffects(e.effects, a.changes), a.effects), a.mapped, a.startSelection, zi)) : s = Bx(s, s.length, o.minDepth, e), new Sg(s, zi, n, r);
  }
  addSelection(e, n, r, o) {
    let i = this.done.length ? this.done[this.done.length - 1].selectionsAfter : zi;
    return i.length > 0 && n - this.prevTime < o && r == this.prevUserEvent && r && /^select($|\.)/.test(r) && xBe(i[i.length - 1], e) ? this : new Sg(qfe(this.done, e), this.undone, n, r);
  }
  addMapping(e) {
    return new Sg(vk(this.done, e), vk(this.undone, e), this.prevTime, this.prevUserEvent);
  }
  pop(e, n, r) {
    let o = e == 0 ? this.done : this.undone;
    if (o.length == 0)
      return null;
    let i = o[o.length - 1], s = i.selectionsAfter[0] || n.selection;
    if (r && i.selectionsAfter.length)
      return n.update({
        selection: i.selectionsAfter[i.selectionsAfter.length - 1],
        annotations: TN.of({ side: e, rest: SBe(o), selection: s }),
        userEvent: e == 0 ? "select.undo" : "select.redo",
        scrollIntoView: !0
      });
    if (i.changes) {
      let a = o.length == 1 ? zi : o.slice(0, o.length - 1);
      return i.mapped && (a = vk(a, i.mapped)), n.update({
        changes: i.changes,
        selection: i.startSelection,
        effects: i.effects,
        annotations: TN.of({ side: e, rest: a, selection: s }),
        filter: !1,
        userEvent: e == 0 ? "undo" : "redo",
        scrollIntoView: !0
      });
    } else
      return null;
  }
};
o0.empty = /* @__PURE__ */ new o0(zi, zi);
const kBe = [
  { key: "Mod-z", run: Bfe, preventDefault: !0 },
  { key: "Mod-y", mac: "Mod-Shift-z", run: RN, preventDefault: !0 },
  { linux: "Ctrl-Shift-z", run: RN, preventDefault: !0 },
  { key: "Mod-u", run: bBe, preventDefault: !0 },
  { key: "Alt-u", mac: "Mod-Shift-u", run: _Be, preventDefault: !0 }
];
function kp(t, e) {
  return $e.create(t.ranges.map(e), t.mainIndex);
}
function $a(t, e) {
  return t.update({ selection: e, scrollIntoView: !0, userEvent: "select" });
}
function Ds({ state: t, dispatch: e }, n) {
  let r = kp(t.selection, n);
  return r.eq(t.selection, !0) ? !1 : (e($a(t, r)), !0);
}
function NS(t, e) {
  return $e.cursor(e ? t.to : t.from);
}
function Ufe(t, e) {
  return Ds(t, (n) => n.empty ? t.moveByChar(n, e) : NS(n, e));
}
function mo(t) {
  return t.textDirectionAt(t.state.selection.main.head) == Kn.LTR;
}
const Hfe = (t) => Ufe(t, !mo(t)), Vfe = (t) => Ufe(t, mo(t));
function Wfe(t, e) {
  return Ds(t, (n) => n.empty ? t.moveByGroup(n, e) : NS(n, e));
}
const ABe = (t) => Wfe(t, !mo(t)), TBe = (t) => Wfe(t, mo(t));
function RBe(t, e, n) {
  if (e.type.prop(n))
    return !0;
  let r = e.to - e.from;
  return r && (r > 2 || /[^\s,.;:]/.test(t.sliceDoc(e.from, e.to))) || e.firstChild;
}
function jS(t, e, n) {
  let r = ho(t).resolveInner(e.head), o = n ? Dt.closedBy : Dt.openedBy;
  for (let l = e.head; ; ) {
    let c = n ? r.childAfter(l) : r.childBefore(l);
    if (!c)
      break;
    RBe(t, c, o) ? r = c : l = n ? c.to : c.from;
  }
  let i = r.type.prop(o), s, a;
  return i && (s = n ? ua(t, r.from, 1) : ua(t, r.to, -1)) && s.matched ? a = n ? s.end.to : s.end.from : a = n ? r.to : r.from, $e.cursor(a, n ? -1 : 1);
}
const PBe = (t) => Ds(t, (e) => jS(t.state, e, !mo(t))), $Be = (t) => Ds(t, (e) => jS(t.state, e, mo(t)));
function Gfe(t, e) {
  return Ds(t, (n) => {
    if (!n.empty)
      return NS(n, e);
    let r = t.moveVertically(n, e);
    return r.head != n.head ? r : t.moveToLineBoundary(n, e);
  });
}
const Yfe = (t) => Gfe(t, !1), Kfe = (t) => Gfe(t, !0);
function Xfe(t) {
  let e = t.scrollDOM.clientHeight < t.scrollDOM.scrollHeight - 2, n = 0, r = 0, o;
  if (e) {
    for (let i of t.state.facet(et.scrollMargins)) {
      let s = i(t);
      s?.top && (n = Math.max(s?.top, n)), s?.bottom && (r = Math.max(s?.bottom, r));
    }
    o = t.scrollDOM.clientHeight - n - r;
  } else
    o = (t.dom.ownerDocument.defaultView || window).innerHeight;
  return {
    marginTop: n,
    marginBottom: r,
    selfScroll: e,
    height: Math.max(t.defaultLineHeight, o - 5)
  };
}
function Qfe(t, e) {
  let n = Xfe(t), { state: r } = t, o = kp(r.selection, (s) => s.empty ? t.moveVertically(s, e, n.height) : NS(s, e));
  if (o.eq(r.selection))
    return !1;
  let i;
  if (n.selfScroll) {
    let s = t.coordsAtPos(r.selection.main.head), a = t.scrollDOM.getBoundingClientRect(), l = a.top + n.marginTop, c = a.bottom - n.marginBottom;
    s && s.top > l && s.bottom < c && (i = et.scrollIntoView(o.main.head, { y: "start", yMargin: s.top - l }));
  }
  return t.dispatch($a(r, o), { effects: i }), !0;
}
const kz = (t) => Qfe(t, !1), PN = (t) => Qfe(t, !0);
function lu(t, e, n) {
  let r = t.lineBlockAt(e.head), o = t.moveToLineBoundary(e, n);
  if (o.head == e.head && o.head != (n ? r.to : r.from) && (o = t.moveToLineBoundary(e, n, !1)), !n && o.head == r.from && r.length) {
    let i = /^\s*/.exec(t.state.sliceDoc(r.from, Math.min(r.from + 100, r.to)))[0].length;
    i && e.head != r.from + i && (o = $e.cursor(r.from + i));
  }
  return o;
}
const MBe = (t) => Ds(t, (e) => lu(t, e, !0)), DBe = (t) => Ds(t, (e) => lu(t, e, !1)), IBe = (t) => Ds(t, (e) => lu(t, e, !mo(t))), NBe = (t) => Ds(t, (e) => lu(t, e, mo(t))), jBe = (t) => Ds(t, (e) => $e.cursor(t.lineBlockAt(e.head).from, 1)), LBe = (t) => Ds(t, (e) => $e.cursor(t.lineBlockAt(e.head).to, -1));
function FBe(t, e, n) {
  let r = !1, o = kp(t.selection, (i) => {
    let s = ua(t, i.head, -1) || ua(t, i.head, 1) || i.head > 0 && ua(t, i.head - 1, 1) || i.head < t.doc.length && ua(t, i.head + 1, -1);
    if (!s || !s.end)
      return i;
    r = !0;
    let a = s.start.from == i.head ? s.end.to : s.end.from;
    return $e.cursor(a);
  });
  return r ? (e($a(t, o)), !0) : !1;
}
const BBe = ({ state: t, dispatch: e }) => FBe(t, e);
function as(t, e) {
  let n = kp(t.state.selection, (r) => {
    let o = e(r);
    return $e.range(r.anchor, o.head, o.goalColumn, o.bidiLevel || void 0);
  });
  return n.eq(t.state.selection) ? !1 : (t.dispatch($a(t.state, n)), !0);
}
function Zfe(t, e) {
  return as(t, (n) => t.moveByChar(n, e));
}
const Jfe = (t) => Zfe(t, !mo(t)), ehe = (t) => Zfe(t, mo(t));
function the(t, e) {
  return as(t, (n) => t.moveByGroup(n, e));
}
const zBe = (t) => the(t, !mo(t)), qBe = (t) => the(t, mo(t)), UBe = (t) => as(t, (e) => jS(t.state, e, !mo(t))), HBe = (t) => as(t, (e) => jS(t.state, e, mo(t)));
function nhe(t, e) {
  return as(t, (n) => t.moveVertically(n, e));
}
const rhe = (t) => nhe(t, !1), ohe = (t) => nhe(t, !0);
function ihe(t, e) {
  return as(t, (n) => t.moveVertically(n, e, Xfe(t).height));
}
const Az = (t) => ihe(t, !1), Tz = (t) => ihe(t, !0), VBe = (t) => as(t, (e) => lu(t, e, !0)), WBe = (t) => as(t, (e) => lu(t, e, !1)), GBe = (t) => as(t, (e) => lu(t, e, !mo(t))), YBe = (t) => as(t, (e) => lu(t, e, mo(t))), KBe = (t) => as(t, (e) => $e.cursor(t.lineBlockAt(e.head).from)), XBe = (t) => as(t, (e) => $e.cursor(t.lineBlockAt(e.head).to)), Rz = ({ state: t, dispatch: e }) => (e($a(t, { anchor: 0 })), !0), Pz = ({ state: t, dispatch: e }) => (e($a(t, { anchor: t.doc.length })), !0), $z = ({ state: t, dispatch: e }) => (e($a(t, { anchor: t.selection.main.anchor, head: 0 })), !0), Mz = ({ state: t, dispatch: e }) => (e($a(t, { anchor: t.selection.main.anchor, head: t.doc.length })), !0), QBe = ({ state: t, dispatch: e }) => (e(t.update({ selection: { anchor: 0, head: t.doc.length }, userEvent: "select" })), !0), ZBe = ({ state: t, dispatch: e }) => {
  let n = LS(t).map(({ from: r, to: o }) => $e.range(r, Math.min(o + 1, t.doc.length)));
  return e(t.update({ selection: $e.create(n), userEvent: "select" })), !0;
}, JBe = ({ state: t, dispatch: e }) => {
  let n = kp(t.selection, (r) => {
    let o = ho(t), i = o.resolveStack(r.from, 1);
    if (r.empty) {
      let s = o.resolveStack(r.from, -1);
      s.node.from >= i.node.from && s.node.to <= i.node.to && (i = s);
    }
    for (let s = i; s; s = s.next) {
      let { node: a } = s;
      if ((a.from < r.from && a.to >= r.to || a.to > r.to && a.from <= r.from) && s.next)
        return $e.range(a.to, a.from);
    }
    return r;
  });
  return n.eq(t.selection) ? !1 : (e($a(t, n)), !0);
}, eze = ({ state: t, dispatch: e }) => {
  let n = t.selection, r = null;
  return n.ranges.length > 1 ? r = $e.create([n.main]) : n.main.empty || (r = $e.create([$e.cursor(n.main.head)])), r ? (e($a(t, r)), !0) : !1;
};
function yv(t, e) {
  if (t.state.readOnly)
    return !1;
  let n = "delete.selection", { state: r } = t, o = r.changeByRange((i) => {
    let { from: s, to: a } = i;
    if (s == a) {
      let l = e(i);
      l < s ? (n = "delete.backward", l = Vb(t, l, !1)) : l > s && (n = "delete.forward", l = Vb(t, l, !0)), s = Math.min(s, l), a = Math.max(a, l);
    } else
      s = Vb(t, s, !1), a = Vb(t, a, !0);
    return s == a ? { range: i } : { changes: { from: s, to: a }, range: $e.cursor(s, s < i.head ? -1 : 1) };
  });
  return o.changes.empty ? !1 : (t.dispatch(r.update(o, {
    scrollIntoView: !0,
    userEvent: n,
    effects: n == "delete.selection" ? et.announce.of(r.phrase("Selection deleted")) : void 0
  })), !0);
}
function Vb(t, e, n) {
  if (t instanceof et)
    for (let r of t.state.facet(et.atomicRanges).map((o) => o(t)))
      r.between(e, e, (o, i) => {
        o < e && i > e && (e = n ? i : o);
      });
  return e;
}
const she = (t, e, n) => yv(t, (r) => {
  let o = r.from, { state: i } = t, s = i.doc.lineAt(o), a, l;
  if (n && !e && o > s.from && o < s.from + 200 && !/[^ \t]/.test(a = s.text.slice(0, o - s.from))) {
    if (a[a.length - 1] == "	")
      return o - 1;
    let c = Sp(a, i.tabSize), u = c % Rx(i) || Rx(i);
    for (let d = 0; d < u && a[a.length - 1 - d] == " "; d++)
      o--;
    l = o;
  } else
    l = Zr(s.text, o - s.from, e, e) + s.from, l == o && s.number != (e ? i.doc.lines : 1) ? l += e ? 1 : -1 : !e && /[\ufe00-\ufe0f]/.test(s.text.slice(l - s.from, o - s.from)) && (l = Zr(s.text, l - s.from, !1, !1) + s.from);
  return l;
}), $N = (t) => she(t, !1, !0), ahe = (t) => she(t, !0, !1), lhe = (t, e) => yv(t, (n) => {
  let r = n.head, { state: o } = t, i = o.doc.lineAt(r), s = o.charCategorizer(r);
  for (let a = null; ; ) {
    if (r == (e ? i.to : i.from)) {
      r == n.head && i.number != (e ? o.doc.lines : 1) && (r += e ? 1 : -1);
      break;
    }
    let l = Zr(i.text, r - i.from, e) + i.from, c = i.text.slice(Math.min(r, l) - i.from, Math.max(r, l) - i.from), u = s(c);
    if (a != null && u != a)
      break;
    (c != " " || r != n.head) && (a = u), r = l;
  }
  return r;
}), che = (t) => lhe(t, !1), tze = (t) => lhe(t, !0), nze = (t) => yv(t, (e) => {
  let n = t.lineBlockAt(e.head).to;
  return e.head < n ? n : Math.min(t.state.doc.length, e.head + 1);
}), rze = (t) => yv(t, (e) => {
  let n = t.moveToLineBoundary(e, !1).head;
  return e.head > n ? n : Math.max(0, e.head - 1);
}), oze = (t) => yv(t, (e) => {
  let n = t.moveToLineBoundary(e, !0).head;
  return e.head < n ? n : Math.min(t.state.doc.length, e.head + 1);
}), ize = ({ state: t, dispatch: e }) => {
  if (t.readOnly)
    return !1;
  let n = t.changeByRange((r) => ({
    changes: { from: r.from, to: r.to, insert: ln.of(["", ""]) },
    range: $e.cursor(r.from)
  }));
  return e(t.update(n, { scrollIntoView: !0, userEvent: "input" })), !0;
}, sze = ({ state: t, dispatch: e }) => {
  if (t.readOnly)
    return !1;
  let n = t.changeByRange((r) => {
    if (!r.empty || r.from == 0 || r.from == t.doc.length)
      return { range: r };
    let o = r.from, i = t.doc.lineAt(o), s = o == i.from ? o - 1 : Zr(i.text, o - i.from, !1) + i.from, a = o == i.to ? o + 1 : Zr(i.text, o - i.from, !0) + i.from;
    return {
      changes: { from: s, to: a, insert: t.doc.slice(o, a).append(t.doc.slice(s, o)) },
      range: $e.cursor(a)
    };
  });
  return n.changes.empty ? !1 : (e(t.update(n, { scrollIntoView: !0, userEvent: "move.character" })), !0);
};
function LS(t) {
  let e = [], n = -1;
  for (let r of t.selection.ranges) {
    let o = t.doc.lineAt(r.from), i = t.doc.lineAt(r.to);
    if (!r.empty && r.to == i.from && (i = t.doc.lineAt(r.to - 1)), n >= o.number) {
      let s = e[e.length - 1];
      s.to = i.to, s.ranges.push(r);
    } else
      e.push({ from: o.from, to: i.to, ranges: [r] });
    n = i.number + 1;
  }
  return e;
}
function uhe(t, e, n) {
  if (t.readOnly)
    return !1;
  let r = [], o = [];
  for (let i of LS(t)) {
    if (n ? i.to == t.doc.length : i.from == 0)
      continue;
    let s = t.doc.lineAt(n ? i.to + 1 : i.from - 1), a = s.length + 1;
    if (n) {
      r.push({ from: i.to, to: s.to }, { from: i.from, insert: s.text + t.lineBreak });
      for (let l of i.ranges)
        o.push($e.range(Math.min(t.doc.length, l.anchor + a), Math.min(t.doc.length, l.head + a)));
    } else {
      r.push({ from: s.from, to: i.from }, { from: i.to, insert: t.lineBreak + s.text });
      for (let l of i.ranges)
        o.push($e.range(l.anchor - a, l.head - a));
    }
  }
  return r.length ? (e(t.update({
    changes: r,
    scrollIntoView: !0,
    selection: $e.create(o, t.selection.mainIndex),
    userEvent: "move.line"
  })), !0) : !1;
}
const aze = ({ state: t, dispatch: e }) => uhe(t, e, !1), lze = ({ state: t, dispatch: e }) => uhe(t, e, !0);
function dhe(t, e, n) {
  if (t.readOnly)
    return !1;
  let r = [];
  for (let o of LS(t))
    n ? r.push({ from: o.from, insert: t.doc.slice(o.from, o.to) + t.lineBreak }) : r.push({ from: o.to, insert: t.lineBreak + t.doc.slice(o.from, o.to) });
  return e(t.update({ changes: r, scrollIntoView: !0, userEvent: "input.copyline" })), !0;
}
const cze = ({ state: t, dispatch: e }) => dhe(t, e, !1), uze = ({ state: t, dispatch: e }) => dhe(t, e, !0), dze = (t) => {
  if (t.state.readOnly)
    return !1;
  let { state: e } = t, n = e.changes(LS(e).map(({ from: o, to: i }) => (o > 0 ? o-- : i < e.doc.length && i++, { from: o, to: i }))), r = kp(e.selection, (o) => {
    let i;
    if (t.lineWrapping) {
      let s = t.lineBlockAt(o.head), a = t.coordsAtPos(o.head, o.assoc || 1);
      a && (i = s.bottom + t.documentTop - a.bottom + t.defaultLineHeight / 2);
    }
    return t.moveVertically(o, !0, i);
  }).map(n);
  return t.dispatch({ changes: n, selection: r, scrollIntoView: !0, userEvent: "delete.line" }), !0;
};
function fze(t, e) {
  if (/\(\)|\[\]|\{\}/.test(t.sliceDoc(e - 1, e + 1)))
    return { from: e, to: e };
  let n = ho(t).resolveInner(e), r = n.childBefore(e), o = n.childAfter(e), i;
  return r && o && r.to <= e && o.from >= e && (i = r.type.prop(Dt.closedBy)) && i.indexOf(o.name) > -1 && t.doc.lineAt(r.to).from == t.doc.lineAt(o.from).from && !/\S/.test(t.sliceDoc(r.to, o.from)) ? { from: r.to, to: o.from } : null;
}
const Dz = /* @__PURE__ */ fhe(!1), hze = /* @__PURE__ */ fhe(!0);
function fhe(t) {
  return ({ state: e, dispatch: n }) => {
    if (e.readOnly)
      return !1;
    let r = e.changeByRange((o) => {
      let { from: i, to: s } = o, a = e.doc.lineAt(i), l = !t && i == s && fze(e, i);
      t && (i = s = (s <= a.to ? a : e.doc.lineAt(s)).to);
      let c = new $S(e, { simulateBreak: i, simulateDoubleBreak: !!l }), u = gL(c, i);
      for (u == null && (u = Sp(/^\s*/.exec(e.doc.lineAt(i).text)[0], e.tabSize)); s < a.to && /\s/.test(a.text[s - a.from]); )
        s++;
      l ? { from: i, to: s } = l : i > a.from && i < a.from + 100 && !/\S/.test(a.text.slice(0, i)) && (i = a.from);
      let d = ["", J0(e, u)];
      return l && d.push(J0(e, c.lineIndent(a.from, -1))), {
        changes: { from: i, to: s, insert: ln.of(d) },
        range: $e.cursor(i + 1 + d[1].length)
      };
    });
    return n(e.update(r, { scrollIntoView: !0, userEvent: "input" })), !0;
  };
}
function AL(t, e) {
  let n = -1;
  return t.changeByRange((r) => {
    let o = [];
    for (let s = r.from; s <= r.to; ) {
      let a = t.doc.lineAt(s);
      a.number > n && (r.empty || r.to > a.from) && (e(a, o, r), n = a.number), s = a.to + 1;
    }
    let i = t.changes(o);
    return {
      changes: o,
      range: $e.range(i.mapPos(r.anchor, 1), i.mapPos(r.head, 1))
    };
  });
}
const pze = ({ state: t, dispatch: e }) => {
  if (t.readOnly)
    return !1;
  let n = /* @__PURE__ */ Object.create(null), r = new $S(t, { overrideIndentation: (i) => n[i] ?? -1 }), o = AL(t, (i, s, a) => {
    let l = gL(r, i.from);
    if (l == null)
      return;
    /\S/.test(i.text) || (l = 0);
    let c = /^\s*/.exec(i.text)[0], u = J0(t, l);
    (c != u || a.from < i.from + c.length) && (n[i.from] = l, s.push({ from: i.from, to: i.from + c.length, insert: u }));
  });
  return o.changes.empty || e(t.update(o, { userEvent: "indent" })), !0;
}, hhe = ({ state: t, dispatch: e }) => t.readOnly ? !1 : (e(t.update(AL(t, (n, r) => {
  r.push({ from: n.from, insert: t.facet(PS) });
}), { userEvent: "input.indent" })), !0), phe = ({ state: t, dispatch: e }) => t.readOnly ? !1 : (e(t.update(AL(t, (n, r) => {
  let o = /^\s*/.exec(n.text)[0];
  if (!o)
    return;
  let i = Sp(o, t.tabSize), s = 0, a = J0(t, Math.max(0, i - Rx(t)));
  for (; s < o.length && s < a.length && o.charCodeAt(s) == a.charCodeAt(s); )
    s++;
  r.push({ from: n.from + s, to: n.from + o.length, insert: a.slice(s) });
}), { userEvent: "delete.dedent" })), !0), mze = (t) => (t.setTabFocusMode(), !0), gze = [
  { key: "Ctrl-b", run: Hfe, shift: Jfe, preventDefault: !0 },
  { key: "Ctrl-f", run: Vfe, shift: ehe },
  { key: "Ctrl-p", run: Yfe, shift: rhe },
  { key: "Ctrl-n", run: Kfe, shift: ohe },
  { key: "Ctrl-a", run: jBe, shift: KBe },
  { key: "Ctrl-e", run: LBe, shift: XBe },
  { key: "Ctrl-d", run: ahe },
  { key: "Ctrl-h", run: $N },
  { key: "Ctrl-k", run: nze },
  { key: "Ctrl-Alt-h", run: che },
  { key: "Ctrl-o", run: ize },
  { key: "Ctrl-t", run: sze },
  { key: "Ctrl-v", run: PN }
], yze = /* @__PURE__ */ [
  { key: "ArrowLeft", run: Hfe, shift: Jfe, preventDefault: !0 },
  { key: "Mod-ArrowLeft", mac: "Alt-ArrowLeft", run: ABe, shift: zBe, preventDefault: !0 },
  { mac: "Cmd-ArrowLeft", run: IBe, shift: GBe, preventDefault: !0 },
  { key: "ArrowRight", run: Vfe, shift: ehe, preventDefault: !0 },
  { key: "Mod-ArrowRight", mac: "Alt-ArrowRight", run: TBe, shift: qBe, preventDefault: !0 },
  { mac: "Cmd-ArrowRight", run: NBe, shift: YBe, preventDefault: !0 },
  { key: "ArrowUp", run: Yfe, shift: rhe, preventDefault: !0 },
  { mac: "Cmd-ArrowUp", run: Rz, shift: $z },
  { mac: "Ctrl-ArrowUp", run: kz, shift: Az },
  { key: "ArrowDown", run: Kfe, shift: ohe, preventDefault: !0 },
  { mac: "Cmd-ArrowDown", run: Pz, shift: Mz },
  { mac: "Ctrl-ArrowDown", run: PN, shift: Tz },
  { key: "PageUp", run: kz, shift: Az },
  { key: "PageDown", run: PN, shift: Tz },
  { key: "Home", run: DBe, shift: WBe, preventDefault: !0 },
  { key: "Mod-Home", run: Rz, shift: $z },
  { key: "End", run: MBe, shift: VBe, preventDefault: !0 },
  { key: "Mod-End", run: Pz, shift: Mz },
  { key: "Enter", run: Dz, shift: Dz },
  { key: "Mod-a", run: QBe },
  { key: "Backspace", run: $N, shift: $N },
  { key: "Delete", run: ahe },
  { key: "Mod-Backspace", mac: "Alt-Backspace", run: che },
  { key: "Mod-Delete", mac: "Alt-Delete", run: tze },
  { mac: "Mod-Backspace", run: rze },
  { mac: "Mod-Delete", run: oze }
].concat(/* @__PURE__ */ gze.map((t) => ({ mac: t.key, run: t.run, shift: t.shift }))), vze = /* @__PURE__ */ [
  { key: "Alt-ArrowLeft", mac: "Ctrl-ArrowLeft", run: PBe, shift: UBe },
  { key: "Alt-ArrowRight", mac: "Ctrl-ArrowRight", run: $Be, shift: HBe },
  { key: "Alt-ArrowUp", run: aze },
  { key: "Shift-Alt-ArrowUp", run: cze },
  { key: "Alt-ArrowDown", run: lze },
  { key: "Shift-Alt-ArrowDown", run: uze },
  { key: "Escape", run: eze },
  { key: "Mod-Enter", run: hze },
  { key: "Alt-l", mac: "Ctrl-l", run: ZBe },
  { key: "Mod-i", run: JBe, preventDefault: !0 },
  { key: "Mod-[", run: phe },
  { key: "Mod-]", run: hhe },
  { key: "Mod-Alt-\\", run: pze },
  { key: "Shift-Mod-k", run: dze },
  { key: "Shift-Mod-\\", run: BBe },
  { key: "Mod-/", run: cBe },
  { key: "Alt-A", run: dBe },
  { key: "Ctrl-m", mac: "Shift-Alt-m", run: mze }
].concat(yze), bze = { key: "Tab", run: hhe, shift: phe };
var _ze = '<svg viewBox="0 0 1024 1024" width="16" height="16" fill="currentColor"><path d="M607.934444 417.856853c-6.179746-6.1777-12.766768-11.746532-19.554358-16.910135l-0.01228 0.011256c-6.986111-6.719028-16.47216-10.857279-26.930349-10.857279-21.464871 0-38.864146 17.400299-38.864146 38.864146 0 9.497305 3.411703 18.196431 9.071609 24.947182l-0.001023 0c0.001023 0.001023 0.00307 0.00307 0.005117 0.004093 2.718925 3.242857 5.953595 6.03853 9.585309 8.251941 3.664459 3.021823 7.261381 5.997598 10.624988 9.361205l3.203972 3.204995c40.279379 40.229237 28.254507 109.539812-12.024871 149.820214L371.157763 796.383956c-40.278355 40.229237-105.761766 40.229237-146.042167 0l-3.229554-3.231601c-40.281425-40.278355-40.281425-105.809861 0-145.991002l75.93546-75.909877c9.742898-7.733125 15.997346-19.668968 15.997346-33.072233 0-23.312962-18.898419-42.211381-42.211381-42.211381-8.797363 0-16.963347 2.693342-23.725354 7.297197-0.021489-0.045025-0.044002-0.088004-0.066515-0.134053l-0.809435 0.757247c-2.989077 2.148943-5.691629 4.669346-8.025791 7.510044l-78.913281 73.841775c-74.178443 74.229608-74.178443 195.632609 0 269.758863l3.203972 3.202948c74.178443 74.127278 195.529255 74.127278 269.707698 0l171.829484-171.880649c74.076112-74.17435 80.357166-191.184297 6.282077-265.311575L607.934444 417.856853z"></path><path d="M855.61957 165.804257l-3.203972-3.203972c-74.17742-74.178443-195.528232-74.178443-269.706675 0L410.87944 334.479911c-74.178443 74.178443-78.263481 181.296089-4.085038 255.522628l3.152806 3.104711c3.368724 3.367701 6.865361 6.54302 10.434653 9.588379 2.583848 2.885723 5.618974 5.355985 8.992815 7.309476 0.025583 0.020466 0.052189 0.041956 0.077771 0.062422l0.011256-0.010233c5.377474 3.092431 11.608386 4.870938 18.257829 4.870938 20.263509 0 36.68962-16.428158 36.68962-36.68962 0-5.719258-1.309832-11.132548-3.645017-15.95846l0 0c-4.850471-10.891048-13.930267-17.521049-20.210297-23.802102l-3.15383-3.102664c-40.278355-40.278355-24.982998-98.79612 15.295358-139.074476l171.930791-171.830507c40.179095-40.280402 105.685018-40.280402 145.965419 0l3.206018 3.152806c40.279379 40.281425 40.279379 105.838513 0 146.06775l-75.686796 75.737962c-10.296507 7.628748-16.97358 19.865443-16.97358 33.662681 0 23.12365 18.745946 41.87062 41.87062 41.87062 8.048303 0 15.563464-2.275833 21.944801-6.211469 0.048095 0.081864 0.093121 0.157589 0.141216 0.240477l1.173732-1.083681c3.616364-2.421142 6.828522-5.393847 9.529027-8.792247l79.766718-73.603345C929.798013 361.334535 929.798013 239.981676 855.61957 165.804257z"></path></svg>', mhe = /\b((?:https?|ftp):\/\/[^\s/$.?#].[^\s]*)\b/gi;
class ghe extends Pa {
  constructor(e) {
    super(), this.state = void 0, this.state = e;
  }
  eq(e) {
    return this.state.url === e.state.url && this.state.at === e.state.at;
  }
  toDOM() {
    var e = document.createElement("a");
    e.href = this.state.url, e.target = "_blank", e.innerHTML = _ze, e.className = "cm-hyper-link-icon", e.rel = "nofollow";
    var n = this.state.anchor && this.state.anchor(e);
    return n || e;
  }
}
function Iz(t, e) {
  for (var n = [], r = t.state.doc.toString(), o; (o = mhe.exec(r)) !== null; ) {
    var i = o.index, s = i + o[0].length, a = ut.widget({
      widget: new ghe({
        at: s,
        url: o[0],
        anchor: e
      }),
      side: 1
    });
    n.push(a.range(s));
  }
  return ut.set(n);
}
var wze = (t, e, n, r) => new jde({
  regexp: t || mhe,
  decorate: (o, i, s, a, l) => {
    var c = a[0], u = n && typeof n == "function" ? n(c, a.input, i, s) : c;
    e && e[c] && (u = e[c]);
    var d = s, f = s, h = new ghe({
      at: d,
      url: u,
      anchor: r
    });
    o(i, s, ut.mark({
      class: "cm-hyper-link-underline"
    })), o(d, f, ut.widget({
      widget: h,
      side: 1
    }));
  }
});
function xze(t) {
  var {
    regexp: e,
    match: n,
    handle: r,
    anchor: o
  } = {};
  return kr.fromClass(class {
    constructor(i) {
      this.decorator = void 0, this.decorations = void 0, e ? (this.decorator = wze(e, n, r, o), this.decorations = this.decorator.createDeco(i)) : this.decorations = Iz(i, o);
    }
    update(i) {
      (i.docChanged || i.viewportChanged) && (e && this.decorator ? this.decorations = this.decorator.updateDeco(i, this.decorations) : this.decorations = Iz(i.view, o));
    }
  }, {
    decorations: (i) => i.decorations
  });
}
var Eze = et.baseTheme({
  ".cm-hyper-link-icon": {
    display: "inline-block",
    verticalAlign: "middle",
    marginLeft: "0.2ch"
  },
  ".cm-hyper-link-icon svg": {
    display: "block"
  },
  ".cm-hyper-link-underline": {
    textDecoration: "underline"
  }
});
xze();
var Nz = function(t) {
  t === void 0 && (t = {});
  var {
    crosshairCursor: e = !1
  } = t, n = [];
  t.closeBracketsKeymap !== !1 && (n = n.concat(f7e)), t.defaultKeymap !== !1 && (n = n.concat(vze)), t.searchKeymap !== !1 && (n = n.concat(iBe)), t.historyKeymap !== !1 && (n = n.concat(kBe)), t.foldKeymap !== !1 && (n = n.concat(hFe)), t.completionKeymap !== !1 && (n = n.concat(xfe)), t.lintKeymap !== !1 && (n = n.concat(A7e));
  var r = [];
  return t.lineNumbers !== !1 && r.push(E8e()), t.highlightActiveLineGutter !== !1 && r.push(C8e()), t.highlightSpecialChars !== !1 && r.push(z9e()), t.history !== !1 && r.push(vBe()), t.foldGutter !== !1 && r.push(lfe()), t.drawSelection !== !1 && r.push(P9e()), t.dropCursor !== !1 && r.push(N9e()), t.allowMultipleSelections !== !1 && r.push(qt.allowMultipleSelections.of(!0)), t.indentOnInput !== !1 && r.push(rFe()), t.syntaxHighlighting !== !1 && r.push(yL(_Fe, {
    fallback: !0
  })), t.bracketMatching !== !1 && r.push(kFe()), t.closeBrackets !== !1 && r.push(l7e()), t.autocompletion !== !1 && r.push(b7e()), t.rectangularSelection !== !1 && r.push(t8e()), e !== !1 && r.push(o8e()), t.highlightActiveLine !== !1 && r.push(G9e()), t.highlightSelectionMatches !== !1 && r.push(B7e()), t.tabSize && typeof t.tabSize == "number" && r.push(PS.of(" ".repeat(t.tabSize))), r.concat([AS.of(n.flat())]).filter(Boolean);
};
const Sze = "#e5c07b", jz = "#e06c75", Oze = "#56b6c2", Cze = "#ffffff", ww = "#abb2bf", MN = "#7d8799", kze = "#61afef", Aze = "#98c379", Lz = "#d19a66", Tze = "#c678dd", Rze = "#21252b", Fz = "#2c313a", Bz = "#282c34", bk = "#353a42", Pze = "#3E4451", zz = "#528bff", $ze = /* @__PURE__ */ et.theme({
  "&": {
    color: ww,
    backgroundColor: Bz
  },
  ".cm-content": {
    caretColor: zz
  },
  ".cm-cursor, .cm-dropCursor": { borderLeftColor: zz },
  "&.cm-focused > .cm-scroller > .cm-selectionLayer .cm-selectionBackground, .cm-selectionBackground, .cm-content ::selection": { backgroundColor: Pze },
  ".cm-panels": { backgroundColor: Rze, color: ww },
  ".cm-panels.cm-panels-top": { borderBottom: "2px solid black" },
  ".cm-panels.cm-panels-bottom": { borderTop: "2px solid black" },
  ".cm-searchMatch": {
    backgroundColor: "#72a1ff59",
    outline: "1px solid #457dff"
  },
  ".cm-searchMatch.cm-searchMatch-selected": {
    backgroundColor: "#6199ff2f"
  },
  ".cm-activeLine": { backgroundColor: "#6699ff0b" },
  ".cm-selectionMatch": { backgroundColor: "#aafe661a" },
  "&.cm-focused .cm-matchingBracket, &.cm-focused .cm-nonmatchingBracket": {
    backgroundColor: "#bad0f847"
  },
  ".cm-gutters": {
    backgroundColor: Bz,
    color: MN,
    border: "none"
  },
  ".cm-activeLineGutter": {
    backgroundColor: Fz
  },
  ".cm-foldPlaceholder": {
    backgroundColor: "transparent",
    border: "none",
    color: "#ddd"
  },
  ".cm-tooltip": {
    border: "none",
    backgroundColor: bk
  },
  ".cm-tooltip .cm-tooltip-arrow:before": {
    borderTopColor: "transparent",
    borderBottomColor: "transparent"
  },
  ".cm-tooltip .cm-tooltip-arrow:after": {
    borderTopColor: bk,
    borderBottomColor: bk
  },
  ".cm-tooltip-autocomplete": {
    "& > ul > li[aria-selected]": {
      backgroundColor: Fz,
      color: ww
    }
  }
}, { dark: !0 }), Mze = /* @__PURE__ */ Op.define([
  {
    tag: le.keyword,
    color: Tze
  },
  {
    tag: [le.name, le.deleted, le.character, le.propertyName, le.macroName],
    color: jz
  },
  {
    tag: [/* @__PURE__ */ le.function(le.variableName), le.labelName],
    color: kze
  },
  {
    tag: [le.color, /* @__PURE__ */ le.constant(le.name), /* @__PURE__ */ le.standard(le.name)],
    color: Lz
  },
  {
    tag: [/* @__PURE__ */ le.definition(le.name), le.separator],
    color: ww
  },
  {
    tag: [le.typeName, le.className, le.number, le.changed, le.annotation, le.modifier, le.self, le.namespace],
    color: Sze
  },
  {
    tag: [le.operator, le.operatorKeyword, le.url, le.escape, le.regexp, le.link, /* @__PURE__ */ le.special(le.string)],
    color: Oze
  },
  {
    tag: [le.meta, le.comment],
    color: MN
  },
  {
    tag: le.strong,
    fontWeight: "bold"
  },
  {
    tag: le.emphasis,
    fontStyle: "italic"
  },
  {
    tag: le.strikethrough,
    textDecoration: "line-through"
  },
  {
    tag: le.link,
    color: MN,
    textDecoration: "underline"
  },
  {
    tag: le.heading,
    fontWeight: "bold",
    color: jz
  },
  {
    tag: [le.atom, le.bool, /* @__PURE__ */ le.special(le.variableName)],
    color: Lz
  },
  {
    tag: [le.processingInstruction, le.string, le.inserted],
    color: Aze
  },
  {
    tag: le.invalid,
    color: Cze
  }
]), Dze = [$ze, /* @__PURE__ */ yL(Mze)];
var Ize = et.theme({
  "&": {
    backgroundColor: "#fff"
  }
}, {
  dark: !1
}), Nze = function(t) {
  t === void 0 && (t = {});
  var {
    indentWithTab: e = !0,
    editable: n = !0,
    readOnly: r = !1,
    theme: o = "light",
    placeholder: i = "",
    basicSetup: s = !0
  } = t, a = [];
  switch (e && a.unshift(AS.of([bze])), s && (typeof s == "boolean" ? a.unshift(Nz()) : a.unshift(Nz(s))), i && a.unshift(Q9e(i)), o) {
    case "light":
      a.push(Ize);
      break;
    case "dark":
      a.push(Dze);
      break;
    case "none":
      break;
    default:
      a.push(o);
      break;
  }
  return n === !1 && a.push(et.editable.of(!1)), r && a.push(qt.readOnly.of(!0)), [...a];
}, jze = (t) => ({
  line: t.state.doc.lineAt(t.state.selection.main.from),
  lineCount: t.state.doc.lines,
  lineBreak: t.state.lineBreak,
  length: t.state.doc.length,
  readOnly: t.state.readOnly,
  tabSize: t.state.tabSize,
  selection: t.state.selection,
  selectionAsSingle: t.state.selection.asSingle().main,
  ranges: t.state.selection.ranges,
  selectionCode: t.state.sliceDoc(t.state.selection.main.from, t.state.selection.main.to),
  selections: t.state.selection.ranges.map((e) => t.state.sliceDoc(e.from, e.to)),
  selectedText: t.state.selection.ranges.some((e) => !e.empty)
}), qz = Ta.define(), Lze = [];
function Fze(t) {
  var {
    value: e,
    selection: n,
    onChange: r,
    onStatistics: o,
    onCreateEditor: i,
    onUpdate: s,
    extensions: a = Lze,
    autoFocus: l,
    theme: c = "light",
    height: u = null,
    minHeight: d = null,
    maxHeight: f = null,
    width: h = null,
    minWidth: p = null,
    maxWidth: m = null,
    placeholder: g = "",
    editable: y = !0,
    readOnly: v = !1,
    indentWithTab: b = !0,
    basicSetup: _ = !0,
    root: w,
    initialState: x
  } = t, [E, S] = Ye(), [C, R] = Ye(), [P, N] = Ye(), A = et.theme({
    "&": {
      height: u,
      minHeight: d,
      maxHeight: f,
      width: h,
      minWidth: p,
      maxWidth: m
    },
    "& .cm-scroller": {
      height: "100% !important"
    }
  }), O = et.updateListener.of((I) => {
    if (I.docChanged && typeof r == "function" && // Fix echoing of the remote changes:
    // If transaction is market as remote we don't have to call `onChange` handler again
    !I.transactions.some(($) => $.annotation(qz))) {
      var j = I.state.doc, z = j.toString();
      r(z, I);
    }
    o && o(jze(I));
  }), k = Nze({
    theme: c,
    editable: y,
    readOnly: v,
    placeholder: g,
    indentWithTab: b,
    basicSetup: _
  }), T = [O, A, ...k];
  return s && typeof s == "function" && T.push(et.updateListener.of(s)), T = T.concat(a), Ne(() => {
    if (E && !P) {
      var I = {
        doc: e,
        selection: n,
        extensions: T
      }, j = x ? qt.fromJSON(x.json, I, x.fields) : qt.create(I);
      if (N(j), !C) {
        var z = new et({
          state: j,
          parent: E,
          root: w
        });
        R(z), i && i(z, j);
      }
    }
    return () => {
      C && (N(void 0), R(void 0));
    };
  }, [E, P]), Ne(() => S(t.container), [t.container]), Ne(() => () => {
    C && (C.destroy(), R(void 0));
  }, [C]), Ne(() => {
    l && C && C.focus();
  }, [l, C]), Ne(() => {
    C && C.dispatch({
      effects: xt.reconfigure.of(T)
    });
  }, [c, a, u, d, f, h, p, m, g, y, v, b, _, r, s]), Ne(() => {
    if (e !== void 0) {
      var I = C ? C.state.doc.toString() : "";
      C && e !== I && C.dispatch({
        changes: {
          from: 0,
          to: I.length,
          insert: e || ""
        },
        annotations: [qz.of(!0)]
      });
    }
  }, [e, C]), {
    state: P,
    setState: N,
    view: C,
    setView: R,
    container: E,
    setContainer: S
  };
}
var Bze = ["className", "value", "selection", "extensions", "onChange", "onStatistics", "onCreateEditor", "onUpdate", "autoFocus", "theme", "height", "minHeight", "maxHeight", "width", "minWidth", "maxWidth", "basicSetup", "placeholder", "indentWithTab", "editable", "readOnly", "root", "initialState"], zze = /* @__PURE__ */ Ri((t, e) => {
  var {
    className: n,
    value: r = "",
    selection: o,
    extensions: i = [],
    onChange: s,
    onStatistics: a,
    onCreateEditor: l,
    onUpdate: c,
    autoFocus: u,
    theme: d = "light",
    height: f,
    minHeight: h,
    maxHeight: p,
    width: m,
    minWidth: g,
    maxWidth: y,
    basicSetup: v,
    placeholder: b,
    indentWithTab: _,
    editable: w,
    readOnly: x,
    root: E,
    initialState: S
  } = t, C = Gce(t, Bze), R = Ue(null), {
    state: P,
    view: N,
    container: A
  } = Fze({
    container: R.current,
    root: E,
    value: r,
    autoFocus: u,
    theme: d,
    height: f,
    minHeight: h,
    maxHeight: p,
    width: m,
    minWidth: g,
    maxWidth: y,
    basicSetup: v,
    placeholder: b,
    indentWithTab: _,
    editable: w,
    readOnly: x,
    selection: o,
    onChange: s,
    onStatistics: a,
    onCreateEditor: l,
    onUpdate: c,
    extensions: i,
    initialState: S
  });
  if (Rse(e, () => ({
    editor: R.current,
    state: P,
    view: N
  }), [R, A, P, N]), typeof r != "string")
    throw new Error("value must be typeof string but got " + typeof r);
  var O = typeof d == "string" ? "cm-theme-" + d : "cm-theme";
  return /* @__PURE__ */ M.jsx("div", qh({
    ref: R,
    className: "" + O + (n ? " " + n : "")
  }, C));
});
zze.displayName = "CodeMirror";
var yhe = (t) => {
  var {
    theme: e,
    settings: n = {},
    styles: r = []
  } = t, o = {
    ".cm-gutters": {}
  }, i = {};
  n.background && (i.backgroundColor = n.background), n.backgroundImage && (i.backgroundImage = n.backgroundImage), n.foreground && (i.color = n.foreground), n.fontSize && (i.fontSize = n.fontSize), (n.background || n.foreground) && (o["&"] = i), n.fontFamily && (o["&.cm-editor .cm-scroller"] = {
    fontFamily: n.fontFamily
  }), n.gutterBackground && (o[".cm-gutters"].backgroundColor = n.gutterBackground), n.gutterForeground && (o[".cm-gutters"].color = n.gutterForeground), n.gutterBorder && (o[".cm-gutters"].borderRightColor = n.gutterBorder), n.caret && (o[".cm-content"] = {
    caretColor: n.caret
  }, o[".cm-cursor, .cm-dropCursor"] = {
    borderLeftColor: n.caret
  });
  var s = {};
  n.gutterActiveForeground && (s.color = n.gutterActiveForeground), n.lineHighlight && (o[".cm-activeLine"] = {
    backgroundColor: n.lineHighlight
  }, s.backgroundColor = n.lineHighlight), o[".cm-activeLineGutter"] = s, n.selection && (o["&.cm-focused .cm-selectionBackground, & .cm-line::selection, & .cm-selectionLayer .cm-selectionBackground, .cm-content ::selection"] = {
    background: n.selection + " !important"
  }), n.selectionMatch && (o["& .cm-selectionMatch"] = {
    backgroundColor: n.selectionMatch
  });
  var a = et.theme(o, {
    dark: e === "dark"
  }), l = Op.define(r), c = [a, yL(l)];
  return c;
}, qze = {
  background: "#fff",
  foreground: "#24292e",
  selection: "#BBDFFF",
  selectionMatch: "#BBDFFF",
  gutterBackground: "#fff",
  gutterForeground: "#6e7781"
}, Uze = [{
  tag: [le.standard(le.tagName), le.tagName],
  color: "#116329"
}, {
  tag: [le.comment, le.bracket],
  color: "#6a737d"
}, {
  tag: [le.className, le.propertyName],
  color: "#6f42c1"
}, {
  tag: [le.variableName, le.attributeName, le.number, le.operator],
  color: "#005cc5"
}, {
  tag: [le.keyword, le.typeName, le.typeOperator, le.typeName],
  color: "#d73a49"
}, {
  tag: [le.string, le.meta, le.regexp],
  color: "#032f62"
}, {
  tag: [le.name, le.quote],
  color: "#22863a"
}, {
  tag: [le.heading, le.strong],
  color: "#24292e",
  fontWeight: "bold"
}, {
  tag: [le.emphasis],
  color: "#24292e",
  fontStyle: "italic"
}, {
  tag: [le.deleted],
  color: "#b31d28",
  backgroundColor: "ffeef0"
}, {
  tag: [le.atom, le.bool, le.special(le.variableName)],
  color: "#e36209"
}, {
  tag: [le.url, le.escape, le.regexp, le.link],
  color: "#032f62"
}, {
  tag: le.link,
  textDecoration: "underline"
}, {
  tag: le.strikethrough,
  textDecoration: "line-through"
}, {
  tag: le.invalid,
  color: "#cb2431"
}], Hze = (t) => {
  var {
    theme: e = "light",
    settings: n = {},
    styles: r = []
  } = {};
  return yhe({
    theme: e,
    settings: qh({}, qze, n),
    styles: [...Uze, ...r]
  });
};
Hze();
var Vze = {
  background: "#0d1117",
  foreground: "#c9d1d9",
  caret: "#c9d1d9",
  selection: "#003d73",
  selectionMatch: "#003d73",
  lineHighlight: "#36334280"
}, Wze = [{
  tag: [le.standard(le.tagName), le.tagName],
  color: "#7ee787"
}, {
  tag: [le.comment, le.bracket],
  color: "#8b949e"
}, {
  tag: [le.className, le.propertyName],
  color: "#d2a8ff"
}, {
  tag: [le.variableName, le.attributeName, le.number, le.operator],
  color: "#79c0ff"
}, {
  tag: [le.keyword, le.typeName, le.typeOperator, le.typeName],
  color: "#ff7b72"
}, {
  tag: [le.string, le.meta, le.regexp],
  color: "#a5d6ff"
}, {
  tag: [le.name, le.quote],
  color: "#7ee787"
}, {
  tag: [le.heading, le.strong],
  color: "#d2a8ff",
  fontWeight: "bold"
}, {
  tag: [le.emphasis],
  color: "#d2a8ff",
  fontStyle: "italic"
}, {
  tag: [le.deleted],
  color: "#ffdcd7",
  backgroundColor: "ffeef0"
}, {
  tag: [le.atom, le.bool, le.special(le.variableName)],
  color: "#ffab70"
}, {
  tag: le.link,
  textDecoration: "underline"
}, {
  tag: le.strikethrough,
  textDecoration: "line-through"
}, {
  tag: le.invalid,
  color: "#f97583"
}], Gze = (t) => {
  var {
    theme: e = "dark",
    settings: n = {},
    styles: r = []
  } = {};
  return yhe({
    theme: e,
    settings: qh({}, Vze, n),
    styles: [...Wze, ...r]
  });
};
Gze();
let Yze;
try {
  Yze = /* @__PURE__ */ new RegExp("[\\p{Alphabetic}\\p{Number}]", "u");
} catch {
}
var _k = { exports: {} }, vu = {};
/** @license React v17.0.2
 * react-dom-server.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Uz;
function Kze() {
  if (Uz) return vu;
  Uz = 1;
  var t = ov(), e = xe;
  function n(oe) {
    for (var ge = "https://reactjs.org/docs/error-decoder.html?invariant=" + oe, pe = 1; pe < arguments.length; pe++) ge += "&args[]=" + encodeURIComponent(arguments[pe]);
    return "Minified React error #" + oe + "; visit " + ge + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var r = 60106, o = 60107, i = 60108, s = 60114, a = 60109, l = 60110, c = 60112, u = 60113, d = 60120, f = 60115, h = 60116, p = 60121, m = 60117, g = 60119, y = 60129, v = 60131;
  if (typeof Symbol == "function" && Symbol.for) {
    var b = Symbol.for;
    r = b("react.portal"), o = b("react.fragment"), i = b("react.strict_mode"), s = b("react.profiler"), a = b("react.provider"), l = b("react.context"), c = b("react.forward_ref"), u = b("react.suspense"), d = b("react.suspense_list"), f = b("react.memo"), h = b("react.lazy"), p = b("react.block"), m = b("react.fundamental"), g = b("react.scope"), y = b("react.debug_trace_mode"), v = b("react.legacy_hidden");
  }
  function _(oe) {
    if (oe == null) return null;
    if (typeof oe == "function") return oe.displayName || oe.name || null;
    if (typeof oe == "string") return oe;
    switch (oe) {
      case o:
        return "Fragment";
      case r:
        return "Portal";
      case s:
        return "Profiler";
      case i:
        return "StrictMode";
      case u:
        return "Suspense";
      case d:
        return "SuspenseList";
    }
    if (typeof oe == "object") switch (oe.$$typeof) {
      case l:
        return (oe.displayName || "Context") + ".Consumer";
      case a:
        return (oe._context.displayName || "Context") + ".Provider";
      case c:
        var ge = oe.render;
        return ge = ge.displayName || ge.name || "", oe.displayName || (ge !== "" ? "ForwardRef(" + ge + ")" : "ForwardRef");
      case f:
        return _(oe.type);
      case p:
        return _(oe._render);
      case h:
        ge = oe._payload, oe = oe._init;
        try {
          return _(oe(ge));
        } catch {
        }
    }
    return null;
  }
  var w = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, x = {};
  function E(oe, ge) {
    for (var pe = oe._threadCount | 0; pe <= ge; pe++) oe[pe] = oe._currentValue2, oe._threadCount = pe + 1;
  }
  function S(oe, ge, pe, He) {
    if (He && (He = oe.contextType, typeof He == "object" && He !== null)) return E(He, pe), He[pe];
    if (oe = oe.contextTypes) {
      pe = {};
      for (var re in oe) pe[re] = ge[re];
      ge = pe;
    } else ge = x;
    return ge;
  }
  for (var C = new Uint16Array(16), R = 0; 15 > R; R++) C[R] = R + 1;
  C[15] = 0;
  var P = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, N = Object.prototype.hasOwnProperty, A = {}, O = {};
  function k(oe) {
    return N.call(O, oe) ? !0 : N.call(A, oe) ? !1 : P.test(oe) ? O[oe] = !0 : (A[oe] = !0, !1);
  }
  function T(oe, ge, pe, He) {
    if (pe !== null && pe.type === 0) return !1;
    switch (typeof ge) {
      case "function":
      case "symbol":
        return !0;
      case "boolean":
        return pe !== null ? !pe.acceptsBooleans : (oe = oe.toLowerCase().slice(0, 5), oe !== "data-" && oe !== "aria-");
      default:
        return !1;
    }
  }
  function I(oe, ge, pe, He) {
    if (ge === null || typeof ge > "u" || T(oe, ge, pe)) return !0;
    if (pe !== null) switch (pe.type) {
      case 3:
        return !ge;
      case 4:
        return ge === !1;
      case 5:
        return isNaN(ge);
      case 6:
        return isNaN(ge) || 1 > ge;
    }
    return !1;
  }
  function j(oe, ge, pe, He, re, J, ie) {
    this.acceptsBooleans = ge === 2 || ge === 3 || ge === 4, this.attributeName = He, this.attributeNamespace = re, this.mustUseProperty = pe, this.propertyName = oe, this.type = ge, this.sanitizeURL = J, this.removeEmptyString = ie;
  }
  var z = {};
  "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(oe) {
    z[oe] = new j(oe, 0, !1, oe, null, !1, !1);
  }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(oe) {
    var ge = oe[0];
    z[ge] = new j(ge, 1, !1, oe[1], null, !1, !1);
  }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(oe) {
    z[oe] = new j(oe, 2, !1, oe.toLowerCase(), null, !1, !1);
  }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(oe) {
    z[oe] = new j(oe, 2, !1, oe, null, !1, !1);
  }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(oe) {
    z[oe] = new j(oe, 3, !1, oe.toLowerCase(), null, !1, !1);
  }), ["checked", "multiple", "muted", "selected"].forEach(function(oe) {
    z[oe] = new j(oe, 3, !0, oe, null, !1, !1);
  }), ["capture", "download"].forEach(function(oe) {
    z[oe] = new j(oe, 4, !1, oe, null, !1, !1);
  }), ["cols", "rows", "size", "span"].forEach(function(oe) {
    z[oe] = new j(oe, 6, !1, oe, null, !1, !1);
  }), ["rowSpan", "start"].forEach(function(oe) {
    z[oe] = new j(oe, 5, !1, oe.toLowerCase(), null, !1, !1);
  });
  var $ = /[\-:]([a-z])/g;
  function D(oe) {
    return oe[1].toUpperCase();
  }
  "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(oe) {
    var ge = oe.replace(
      $,
      D
    );
    z[ge] = new j(ge, 1, !1, oe, null, !1, !1);
  }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(oe) {
    var ge = oe.replace($, D);
    z[ge] = new j(ge, 1, !1, oe, "http://www.w3.org/1999/xlink", !1, !1);
  }), ["xml:base", "xml:lang", "xml:space"].forEach(function(oe) {
    var ge = oe.replace($, D);
    z[ge] = new j(ge, 1, !1, oe, "http://www.w3.org/XML/1998/namespace", !1, !1);
  }), ["tabIndex", "crossOrigin"].forEach(function(oe) {
    z[oe] = new j(oe, 1, !1, oe.toLowerCase(), null, !1, !1);
  }), z.xlinkHref = new j("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1), ["src", "href", "action", "formAction"].forEach(function(oe) {
    z[oe] = new j(oe, 1, !1, oe.toLowerCase(), null, !0, !0);
  });
  var U = /["'&<>]/;
  function q(oe) {
    if (typeof oe == "boolean" || typeof oe == "number") return "" + oe;
    oe = "" + oe;
    var ge = U.exec(oe);
    if (ge) {
      var pe = "", He, re = 0;
      for (He = ge.index; He < oe.length; He++) {
        switch (oe.charCodeAt(He)) {
          case 34:
            ge = "&quot;";
            break;
          case 38:
            ge = "&amp;";
            break;
          case 39:
            ge = "&#x27;";
            break;
          case 60:
            ge = "&lt;";
            break;
          case 62:
            ge = "&gt;";
            break;
          default:
            continue;
        }
        re !== He && (pe += oe.substring(re, He)), re = He + 1, pe += ge;
      }
      oe = re !== He ? pe + oe.substring(re, He) : pe;
    }
    return oe;
  }
  function F(oe, ge) {
    var pe = z.hasOwnProperty(oe) ? z[oe] : null, He;
    return (He = oe !== "style") && (He = pe !== null ? pe.type === 0 : !(!(2 < oe.length) || oe[0] !== "o" && oe[0] !== "O" || oe[1] !== "n" && oe[1] !== "N")), He || I(oe, ge, pe) ? "" : pe !== null ? (oe = pe.attributeName, He = pe.type, He === 3 || He === 4 && ge === !0 ? oe + '=""' : (pe.sanitizeURL && (ge = "" + ge), oe + '="' + (q(ge) + '"'))) : k(oe) ? oe + '="' + (q(ge) + '"') : "";
  }
  function B(oe, ge) {
    return oe === ge && (oe !== 0 || 1 / oe === 1 / ge) || oe !== oe && ge !== ge;
  }
  var H = typeof Object.is == "function" ? Object.is : B, Z = null, W = null, G = null, ee = !1, Y = !1, L = null, V = 0;
  function K() {
    if (Z === null) throw Error(n(321));
    return Z;
  }
  function ne() {
    if (0 < V) throw Error(n(312));
    return { memoizedState: null, queue: null, next: null };
  }
  function ce() {
    return G === null ? W === null ? (ee = !1, W = G = ne()) : (ee = !0, G = W) : G.next === null ? (ee = !1, G = G.next = ne()) : (ee = !0, G = G.next), G;
  }
  function fe(oe, ge, pe, He) {
    for (; Y; ) Y = !1, V += 1, G = null, pe = oe(ge, He);
    return ve(), pe;
  }
  function ve() {
    Z = null, Y = !1, W = null, V = 0, G = L = null;
  }
  function _e(oe, ge) {
    return typeof ge == "function" ? ge(oe) : ge;
  }
  function Ee(oe, ge, pe) {
    if (Z = K(), G = ce(), ee) {
      var He = G.queue;
      if (ge = He.dispatch, L !== null && (pe = L.get(He), pe !== void 0)) {
        L.delete(He), He = G.memoizedState;
        do
          He = oe(He, pe.action), pe = pe.next;
        while (pe !== null);
        return G.memoizedState = He, [He, ge];
      }
      return [G.memoizedState, ge];
    }
    return oe = oe === _e ? typeof ge == "function" ? ge() : ge : pe !== void 0 ? pe(ge) : ge, G.memoizedState = oe, oe = G.queue = { last: null, dispatch: null }, oe = oe.dispatch = Le.bind(null, Z, oe), [G.memoizedState, oe];
  }
  function Me(oe, ge) {
    if (Z = K(), G = ce(), ge = ge === void 0 ? null : ge, G !== null) {
      var pe = G.memoizedState;
      if (pe !== null && ge !== null) {
        var He = pe[1];
        e: if (He === null) He = !1;
        else {
          for (var re = 0; re < He.length && re < ge.length; re++) if (!H(ge[re], He[re])) {
            He = !1;
            break e;
          }
          He = !0;
        }
        if (He) return pe[0];
      }
    }
    return oe = oe(), G.memoizedState = [oe, ge], oe;
  }
  function Le(oe, ge, pe) {
    if (!(25 > V)) throw Error(n(301));
    if (oe === Z) if (Y = !0, oe = { action: pe, next: null }, L === null && (L = /* @__PURE__ */ new Map()), pe = L.get(ge), pe === void 0) L.set(ge, oe);
    else {
      for (ge = pe; ge.next !== null; ) ge = ge.next;
      ge.next = oe;
    }
  }
  function Ce() {
  }
  var Je = null, Ie = { readContext: function(oe) {
    var ge = Je.threadID;
    return E(oe, ge), oe[ge];
  }, useContext: function(oe) {
    K();
    var ge = Je.threadID;
    return E(oe, ge), oe[ge];
  }, useMemo: Me, useReducer: Ee, useRef: function(oe) {
    Z = K(), G = ce();
    var ge = G.memoizedState;
    return ge === null ? (oe = { current: oe }, G.memoizedState = oe) : ge;
  }, useState: function(oe) {
    return Ee(_e, oe);
  }, useLayoutEffect: function() {
  }, useCallback: function(oe, ge) {
    return Me(function() {
      return oe;
    }, ge);
  }, useImperativeHandle: Ce, useEffect: Ce, useDebugValue: Ce, useDeferredValue: function(oe) {
    return K(), oe;
  }, useTransition: function() {
    return K(), [function(oe) {
      oe();
    }, !1];
  }, useOpaqueIdentifier: function() {
    return (Je.identifierPrefix || "") + "R:" + (Je.uniqueID++).toString(36);
  }, useMutableSource: function(oe, ge) {
    return K(), ge(oe._source);
  } }, nt = { html: "http://www.w3.org/1999/xhtml" };
  function ct(oe) {
    switch (oe) {
      case "svg":
        return "http://www.w3.org/2000/svg";
      case "math":
        return "http://www.w3.org/1998/Math/MathML";
      default:
        return "http://www.w3.org/1999/xhtml";
    }
  }
  var mt = { area: !0, base: !0, br: !0, col: !0, embed: !0, hr: !0, img: !0, input: !0, keygen: !0, link: !0, meta: !0, param: !0, source: !0, track: !0, wbr: !0 }, gt = t({ menuitem: !0 }, mt), Et = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
  }, Rt = ["Webkit", "ms", "Moz", "O"];
  Object.keys(Et).forEach(function(oe) {
    Rt.forEach(function(ge) {
      ge = ge + oe.charAt(0).toUpperCase() + oe.substring(1), Et[ge] = Et[oe];
    });
  });
  var zt = /([A-Z])/g, At = /^ms-/, X = e.Children.toArray, ae = w.ReactCurrentDispatcher, ye = { listing: !0, pre: !0, textarea: !0 }, De = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, Te = {}, st = {};
  function ft(oe) {
    if (oe == null) return oe;
    var ge = "";
    return e.Children.forEach(oe, function(pe) {
      pe != null && (ge += pe);
    }), ge;
  }
  var Ht = Object.prototype.hasOwnProperty, nn = { children: null, dangerouslySetInnerHTML: null, suppressContentEditableWarning: null, suppressHydrationWarning: null };
  function It(oe, ge) {
    if (oe === void 0) throw Error(n(152, _(ge) || "Component"));
  }
  function Rn(oe, ge, pe) {
    function He(ie, me) {
      var be = me.prototype && me.prototype.isReactComponent, tt = S(me, ge, pe, be), Ke = [], Fe = !1, We = { isMounted: function() {
        return !1;
      }, enqueueForceUpdate: function() {
        if (Ke === null) return null;
      }, enqueueReplaceState: function(Qe, se) {
        Fe = !0, Ke = [se];
      }, enqueueSetState: function(Qe, se) {
        if (Ke === null) return null;
        Ke.push(se);
      } };
      if (be) {
        if (be = new me(ie.props, tt, We), typeof me.getDerivedStateFromProps == "function") {
          var Xe = me.getDerivedStateFromProps.call(null, ie.props, be.state);
          Xe != null && (be.state = t({}, be.state, Xe));
        }
      } else if (Z = {}, be = me(
        ie.props,
        tt,
        We
      ), be = fe(me, ie.props, be, tt), be == null || be.render == null) {
        oe = be, It(oe, me);
        return;
      }
      if (be.props = ie.props, be.context = tt, be.updater = We, We = be.state, We === void 0 && (be.state = We = null), typeof be.UNSAFE_componentWillMount == "function" || typeof be.componentWillMount == "function") if (typeof be.componentWillMount == "function" && typeof me.getDerivedStateFromProps != "function" && be.componentWillMount(), typeof be.UNSAFE_componentWillMount == "function" && typeof me.getDerivedStateFromProps != "function" && be.UNSAFE_componentWillMount(), Ke.length) {
        We = Ke;
        var at = Fe;
        if (Ke = null, Fe = !1, at && We.length === 1) be.state = We[0];
        else {
          Xe = at ? We[0] : be.state;
          var bt = !0;
          for (at = at ? 1 : 0; at < We.length; at++) {
            var Lt = We[at];
            Lt = typeof Lt == "function" ? Lt.call(be, Xe, ie.props, tt) : Lt, Lt != null && (bt ? (bt = !1, Xe = t({}, Xe, Lt)) : t(Xe, Lt));
          }
          be.state = Xe;
        }
      } else Ke = null;
      if (oe = be.render(), It(oe, me), typeof be.getChildContext == "function" && (ie = me.childContextTypes, typeof ie == "object")) {
        var bn = be.getChildContext();
        for (var un in bn) if (!(un in ie)) throw Error(n(108, _(me) || "Unknown", un));
      }
      bn && (ge = t({}, ge, bn));
    }
    for (; e.isValidElement(oe); ) {
      var re = oe, J = re.type;
      if (typeof J != "function") break;
      He(re, J);
    }
    return { child: oe, context: ge };
  }
  var yt = function() {
    function oe(pe, He, re) {
      e.isValidElement(pe) ? pe.type !== o ? pe = [pe] : (pe = pe.props.children, pe = e.isValidElement(pe) ? [pe] : X(pe)) : pe = X(pe), pe = { type: null, domNamespace: nt.html, children: pe, childIndex: 0, context: x, footer: "" };
      var J = C[0];
      if (J === 0) {
        var ie = C;
        J = ie.length;
        var me = 2 * J;
        if (!(65536 >= me)) throw Error(n(304));
        var be = new Uint16Array(me);
        for (be.set(ie), C = be, C[0] = J + 1, ie = J; ie < me - 1; ie++) C[ie] = ie + 1;
        C[me - 1] = 0;
      } else C[0] = C[J];
      this.threadID = J, this.stack = [pe], this.exhausted = !1, this.currentSelectValue = null, this.previousWasTextNode = !1, this.makeStaticMarkup = He, this.suspenseDepth = 0, this.contextIndex = -1, this.contextStack = [], this.contextValueStack = [], this.uniqueID = 0, this.identifierPrefix = re && re.identifierPrefix || "";
    }
    var ge = oe.prototype;
    return ge.destroy = function() {
      if (!this.exhausted) {
        this.exhausted = !0, this.clearProviders();
        var pe = this.threadID;
        C[pe] = C[0], C[0] = pe;
      }
    }, ge.pushProvider = function(pe) {
      var He = ++this.contextIndex, re = pe.type._context, J = this.threadID;
      E(re, J);
      var ie = re[J];
      this.contextStack[He] = re, this.contextValueStack[He] = ie, re[J] = pe.props.value;
    }, ge.popProvider = function() {
      var pe = this.contextIndex, He = this.contextStack[pe], re = this.contextValueStack[pe];
      this.contextStack[pe] = null, this.contextValueStack[pe] = null, this.contextIndex--, He[this.threadID] = re;
    }, ge.clearProviders = function() {
      for (var pe = this.contextIndex; 0 <= pe; pe--) this.contextStack[pe][this.threadID] = this.contextValueStack[pe];
    }, ge.read = function(pe) {
      if (this.exhausted) return null;
      var He = Je;
      Je = this;
      var re = ae.current;
      ae.current = Ie;
      try {
        for (var J = [""], ie = !1; J[0].length < pe; ) {
          if (this.stack.length === 0) {
            this.exhausted = !0;
            var me = this.threadID;
            C[me] = C[0], C[0] = me;
            break;
          }
          var be = this.stack[this.stack.length - 1];
          if (ie || be.childIndex >= be.children.length) {
            var tt = be.footer;
            if (tt !== "" && (this.previousWasTextNode = !1), this.stack.pop(), be.type === "select") this.currentSelectValue = null;
            else if (be.type != null && be.type.type != null && be.type.type.$$typeof === a) this.popProvider(be.type);
            else if (be.type === u) {
              this.suspenseDepth--;
              var Ke = J.pop();
              if (ie) {
                ie = !1;
                var Fe = be.fallbackFrame;
                if (!Fe) throw Error(n(303));
                this.stack.push(Fe), J[this.suspenseDepth] += "<!--$!-->";
                continue;
              } else J[this.suspenseDepth] += Ke;
            }
            J[this.suspenseDepth] += tt;
          } else {
            var We = be.children[be.childIndex++], Xe = "";
            try {
              Xe += this.render(We, be.context, be.domNamespace);
            } catch (at) {
              throw at != null && typeof at.then == "function" ? Error(n(294)) : at;
            } finally {
            }
            J.length <= this.suspenseDepth && J.push(""), J[this.suspenseDepth] += Xe;
          }
        }
        return J[0];
      } finally {
        ae.current = re, Je = He, ve();
      }
    }, ge.render = function(pe, He, re) {
      if (typeof pe == "string" || typeof pe == "number")
        return re = "" + pe, re === "" ? "" : this.makeStaticMarkup ? q(re) : this.previousWasTextNode ? "<!-- -->" + q(re) : (this.previousWasTextNode = !0, q(re));
      if (He = Rn(pe, He, this.threadID), pe = He.child, He = He.context, pe === null || pe === !1) return "";
      if (!e.isValidElement(pe)) {
        if (pe != null && pe.$$typeof != null)
          throw re = pe.$$typeof, Error(re === r ? n(257) : n(258, re.toString()));
        return pe = X(pe), this.stack.push({ type: null, domNamespace: re, children: pe, childIndex: 0, context: He, footer: "" }), "";
      }
      var J = pe.type;
      if (typeof J == "string") return this.renderDOM(pe, He, re);
      switch (J) {
        case v:
        case y:
        case i:
        case s:
        case d:
        case o:
          return pe = X(pe.props.children), this.stack.push({
            type: null,
            domNamespace: re,
            children: pe,
            childIndex: 0,
            context: He,
            footer: ""
          }), "";
        case u:
          throw Error(n(294));
        case g:
          throw Error(n(343));
      }
      if (typeof J == "object" && J !== null) switch (J.$$typeof) {
        case c:
          Z = {};
          var ie = J.render(pe.props, pe.ref);
          return ie = fe(J.render, pe.props, ie, pe.ref), ie = X(ie), this.stack.push({ type: null, domNamespace: re, children: ie, childIndex: 0, context: He, footer: "" }), "";
        case f:
          return pe = [e.createElement(J.type, t({ ref: pe.ref }, pe.props))], this.stack.push({ type: null, domNamespace: re, children: pe, childIndex: 0, context: He, footer: "" }), "";
        case a:
          return J = X(pe.props.children), re = { type: pe, domNamespace: re, children: J, childIndex: 0, context: He, footer: "" }, this.pushProvider(pe), this.stack.push(re), "";
        case l:
          J = pe.type, ie = pe.props;
          var me = this.threadID;
          return E(J, me), J = X(ie.children(J[me])), this.stack.push({ type: pe, domNamespace: re, children: J, childIndex: 0, context: He, footer: "" }), "";
        case m:
          throw Error(n(338));
        case h:
          return J = pe.type, ie = J._init, J = ie(J._payload), pe = [e.createElement(J, t({ ref: pe.ref }, pe.props))], this.stack.push({
            type: null,
            domNamespace: re,
            children: pe,
            childIndex: 0,
            context: He,
            footer: ""
          }), "";
      }
      throw Error(n(130, J == null ? J : typeof J, ""));
    }, ge.renderDOM = function(pe, He, re) {
      var J = pe.type.toLowerCase();
      if (!Te.hasOwnProperty(J)) {
        if (!De.test(J)) throw Error(n(65, J));
        Te[J] = !0;
      }
      var ie = pe.props;
      if (J === "input") ie = t({ type: void 0 }, ie, { defaultChecked: void 0, defaultValue: void 0, value: ie.value != null ? ie.value : ie.defaultValue, checked: ie.checked != null ? ie.checked : ie.defaultChecked });
      else if (J === "textarea") {
        var me = ie.value;
        if (me == null) {
          me = ie.defaultValue;
          var be = ie.children;
          if (be != null) {
            if (me != null) throw Error(n(92));
            if (Array.isArray(be)) {
              if (!(1 >= be.length)) throw Error(n(93));
              be = be[0];
            }
            me = "" + be;
          }
          me == null && (me = "");
        }
        ie = t({}, ie, { value: void 0, children: "" + me });
      } else if (J === "select") this.currentSelectValue = ie.value != null ? ie.value : ie.defaultValue, ie = t({}, ie, { value: void 0 });
      else if (J === "option") {
        be = this.currentSelectValue;
        var tt = ft(ie.children);
        if (be != null) {
          var Ke = ie.value != null ? ie.value + "" : tt;
          if (me = !1, Array.isArray(be)) {
            for (var Fe = 0; Fe < be.length; Fe++)
              if ("" + be[Fe] === Ke) {
                me = !0;
                break;
              }
          } else me = "" + be === Ke;
          ie = t(
            { selected: void 0, children: void 0 },
            ie,
            { selected: me, children: tt }
          );
        }
      }
      if (me = ie) {
        if (gt[J] && (me.children != null || me.dangerouslySetInnerHTML != null)) throw Error(n(137, J));
        if (me.dangerouslySetInnerHTML != null) {
          if (me.children != null) throw Error(n(60));
          if (!(typeof me.dangerouslySetInnerHTML == "object" && "__html" in me.dangerouslySetInnerHTML)) throw Error(n(61));
        }
        if (me.style != null && typeof me.style != "object") throw Error(n(62));
      }
      me = ie, be = this.makeStaticMarkup, tt = this.stack.length === 1, Ke = "<" + pe.type;
      e: if (J.indexOf("-") === -1) Fe = typeof me.is == "string";
      else switch (J) {
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          Fe = !1;
          break e;
        default:
          Fe = !0;
      }
      for (se in me) if (Ht.call(me, se)) {
        var We = me[se];
        if (We != null) {
          if (se === "style") {
            var Xe = void 0, at = "", bt = "";
            for (Xe in We) if (We.hasOwnProperty(Xe)) {
              var Lt = Xe.indexOf("--") === 0, bn = We[Xe];
              if (bn != null) {
                if (Lt) var un = Xe;
                else if (un = Xe, st.hasOwnProperty(un)) un = st[un];
                else {
                  var Qe = un.replace(zt, "-$1").toLowerCase().replace(At, "-ms-");
                  un = st[un] = Qe;
                }
                at += bt + un + ":", bt = Xe, Lt = bn == null || typeof bn == "boolean" || bn === "" ? "" : Lt || typeof bn != "number" || bn === 0 || Et.hasOwnProperty(bt) && Et[bt] ? ("" + bn).trim() : bn + "px", at += Lt, bt = ";";
              }
            }
            We = at || null;
          }
          Xe = null, Fe ? nn.hasOwnProperty(se) || (Xe = se, Xe = k(Xe) && We != null ? Xe + '="' + (q(We) + '"') : "") : Xe = F(se, We), Xe && (Ke += " " + Xe);
        }
      }
      be || tt && (Ke += ' data-reactroot=""');
      var se = Ke;
      me = "", mt.hasOwnProperty(J) ? se += "/>" : (se += ">", me = "</" + pe.type + ">");
      e: {
        if (be = ie.dangerouslySetInnerHTML, be != null) {
          if (be.__html != null) {
            be = be.__html;
            break e;
          }
        } else if (be = ie.children, typeof be == "string" || typeof be == "number") {
          be = q(be);
          break e;
        }
        be = null;
      }
      return be != null ? (ie = [], ye.hasOwnProperty(J) && be.charAt(0) === `
` && (se += `
`), se += be) : ie = X(ie.children), pe = pe.type, re = re == null || re === "http://www.w3.org/1999/xhtml" ? ct(pe) : re === "http://www.w3.org/2000/svg" && pe === "foreignObject" ? "http://www.w3.org/1999/xhtml" : re, this.stack.push({ domNamespace: re, type: J, children: ie, childIndex: 0, context: He, footer: me }), this.previousWasTextNode = !1, se;
    }, oe;
  }();
  return vu.renderToNodeStream = function() {
    throw Error(n(207));
  }, vu.renderToStaticMarkup = function(oe, ge) {
    oe = new yt(oe, !0, ge);
    try {
      return oe.read(1 / 0);
    } finally {
      oe.destroy();
    }
  }, vu.renderToStaticNodeStream = function() {
    throw Error(n(208));
  }, vu.renderToString = function(oe, ge) {
    oe = new yt(oe, !1, ge);
    try {
      return oe.read(1 / 0);
    } finally {
      oe.destroy();
    }
  }, vu.version = "17.0.2", vu;
}
var bf = {};
/** @license React v17.0.2
 * react-dom-server.browser.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Hz;
function Xze() {
  return Hz || (Hz = 1, process.env.NODE_ENV !== "production" && function() {
    var t = xe, e = ov(), n = "17.0.2", r = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function o(Q) {
      {
        for (var te = arguments.length, de = new Array(te > 1 ? te - 1 : 0), we = 1; we < te; we++)
          de[we - 1] = arguments[we];
        s("warn", Q, de);
      }
    }
    function i(Q) {
      {
        for (var te = arguments.length, de = new Array(te > 1 ? te - 1 : 0), we = 1; we < te; we++)
          de[we - 1] = arguments[we];
        s("error", Q, de);
      }
    }
    function s(Q, te, de) {
      {
        var we = r.ReactDebugCurrentFrame, Ae = we.getStackAddendum();
        Ae !== "" && (te += "%s", de = de.concat([Ae]));
        var je = de.map(function(Ge) {
          return "" + Ge;
        });
        je.unshift("Warning: " + te), Function.prototype.apply.call(console[Q], console, je);
      }
    }
    var a = 60106, l = 60107, c = 60108, u = 60114, d = 60109, f = 60110, h = 60112, p = 60113, m = 60120, g = 60115, y = 60116, v = 60121, b = 60117, _ = 60119, w = 60129, x = 60131;
    if (typeof Symbol == "function" && Symbol.for) {
      var E = Symbol.for;
      E("react.element"), a = E("react.portal"), l = E("react.fragment"), c = E("react.strict_mode"), u = E("react.profiler"), d = E("react.provider"), f = E("react.context"), h = E("react.forward_ref"), p = E("react.suspense"), m = E("react.suspense_list"), g = E("react.memo"), y = E("react.lazy"), v = E("react.block"), E("react.server.block"), b = E("react.fundamental"), _ = E("react.scope"), E("react.opaque.id"), w = E("react.debug_trace_mode"), E("react.offscreen"), x = E("react.legacy_hidden");
    }
    function S(Q, te, de) {
      var we = te.displayName || te.name || "";
      return Q.displayName || (we !== "" ? de + "(" + we + ")" : de);
    }
    function C(Q) {
      return Q.displayName || "Context";
    }
    function R(Q) {
      if (Q == null)
        return null;
      if (typeof Q.tag == "number" && i("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue."), typeof Q == "function")
        return Q.displayName || Q.name || null;
      if (typeof Q == "string")
        return Q;
      switch (Q) {
        case l:
          return "Fragment";
        case a:
          return "Portal";
        case u:
          return "Profiler";
        case c:
          return "StrictMode";
        case p:
          return "Suspense";
        case m:
          return "SuspenseList";
      }
      if (typeof Q == "object")
        switch (Q.$$typeof) {
          case f:
            var te = Q;
            return C(te) + ".Consumer";
          case d:
            var de = Q;
            return C(de._context) + ".Provider";
          case h:
            return S(Q, Q.render, "ForwardRef");
          case g:
            return R(Q.type);
          case v:
            return R(Q._render);
          case y: {
            var we = Q, Ae = we._payload, je = we._init;
            try {
              return R(je(Ae));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var P = !1, N = 0, A, O, k, T, I, j, z;
    function $() {
    }
    $.__reactDisabledLog = !0;
    function D() {
      {
        if (N === 0) {
          A = console.log, O = console.info, k = console.warn, T = console.error, I = console.group, j = console.groupCollapsed, z = console.groupEnd;
          var Q = {
            configurable: !0,
            enumerable: !0,
            value: $,
            writable: !0
          };
          Object.defineProperties(console, {
            info: Q,
            log: Q,
            warn: Q,
            error: Q,
            group: Q,
            groupCollapsed: Q,
            groupEnd: Q
          });
        }
        N++;
      }
    }
    function U() {
      {
        if (N--, N === 0) {
          var Q = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: e({}, Q, {
              value: A
            }),
            info: e({}, Q, {
              value: O
            }),
            warn: e({}, Q, {
              value: k
            }),
            error: e({}, Q, {
              value: T
            }),
            group: e({}, Q, {
              value: I
            }),
            groupCollapsed: e({}, Q, {
              value: j
            }),
            groupEnd: e({}, Q, {
              value: z
            })
          });
        }
        N < 0 && i("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var q = r.ReactCurrentDispatcher, F;
    function B(Q, te, de) {
      {
        if (F === void 0)
          try {
            throw Error();
          } catch (Ae) {
            var we = Ae.stack.trim().match(/\n( *(at )?)/);
            F = we && we[1] || "";
          }
        return `
` + F + Q;
      }
    }
    var H = !1, Z;
    {
      var W = typeof WeakMap == "function" ? WeakMap : Map;
      Z = new W();
    }
    function G(Q, te) {
      if (!Q || H)
        return "";
      {
        var de = Z.get(Q);
        if (de !== void 0)
          return de;
      }
      var we;
      H = !0;
      var Ae = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var je;
      je = q.current, q.current = null, D();
      try {
        if (te) {
          var Ge = function() {
            throw Error();
          };
          if (Object.defineProperty(Ge.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(Ge, []);
            } catch (Ln) {
              we = Ln;
            }
            Reflect.construct(Q, [], Ge);
          } else {
            try {
              Ge.call();
            } catch (Ln) {
              we = Ln;
            }
            Q.call(Ge.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Ln) {
            we = Ln;
          }
          Q();
        }
      } catch (Ln) {
        if (Ln && we && typeof Ln.stack == "string") {
          for (var Pe = Ln.stack.split(`
`), Pt = we.stack.split(`
`), Ct = Pe.length - 1, wt = Pt.length - 1; Ct >= 1 && wt >= 0 && Pe[Ct] !== Pt[wt]; )
            wt--;
          for (; Ct >= 1 && wt >= 0; Ct--, wt--)
            if (Pe[Ct] !== Pt[wt]) {
              if (Ct !== 1 || wt !== 1)
                do
                  if (Ct--, wt--, wt < 0 || Pe[Ct] !== Pt[wt]) {
                    var Pr = `
` + Pe[Ct].replace(" at new ", " at ");
                    return typeof Q == "function" && Z.set(Q, Pr), Pr;
                  }
                while (Ct >= 1 && wt >= 0);
              break;
            }
        }
      } finally {
        H = !1, q.current = je, U(), Error.prepareStackTrace = Ae;
      }
      var _n = Q ? Q.displayName || Q.name : "", _t = _n ? B(_n) : "";
      return typeof Q == "function" && Z.set(Q, _t), _t;
    }
    function ee(Q, te, de) {
      return G(Q, !1);
    }
    function Y(Q) {
      var te = Q.prototype;
      return !!(te && te.isReactComponent);
    }
    function L(Q, te, de) {
      if (Q == null)
        return "";
      if (typeof Q == "function")
        return G(Q, Y(Q));
      if (typeof Q == "string")
        return B(Q);
      switch (Q) {
        case p:
          return B("Suspense");
        case m:
          return B("SuspenseList");
      }
      if (typeof Q == "object")
        switch (Q.$$typeof) {
          case h:
            return ee(Q.render);
          case g:
            return L(Q.type, te, de);
          case v:
            return ee(Q._render);
          case y: {
            var we = Q, Ae = we._payload, je = we._init;
            try {
              return L(je(Ae), te, de);
            } catch {
            }
          }
        }
      return "";
    }
    var V = {}, K = r.ReactDebugCurrentFrame;
    function ne(Q) {
      if (Q) {
        var te = Q._owner, de = L(Q.type, Q._source, te ? te.type : null);
        K.setExtraStackFrame(de);
      } else
        K.setExtraStackFrame(null);
    }
    function ce(Q, te, de, we, Ae) {
      {
        var je = Function.call.bind(Object.prototype.hasOwnProperty);
        for (var Ge in Q)
          if (je(Q, Ge)) {
            var Pe = void 0;
            try {
              if (typeof Q[Ge] != "function") {
                var Pt = Error((we || "React class") + ": " + de + " type `" + Ge + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof Q[Ge] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Pt.name = "Invariant Violation", Pt;
              }
              Pe = Q[Ge](te, Ge, we, de, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Ct) {
              Pe = Ct;
            }
            Pe && !(Pe instanceof Error) && (ne(Ae), i("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", we, de, Ge, typeof Pe), ne(null)), Pe instanceof Error && !(Pe.message in V) && (V[Pe.message] = !0, ne(Ae), i("Failed %s type: %s", de, Pe.message), ne(null));
          }
      }
    }
    var fe;
    fe = /* @__PURE__ */ new Set();
    var ve = {};
    Object.freeze(ve);
    function _e(Q, te) {
      var de = Q.contextTypes;
      if (!de)
        return ve;
      var we = {};
      for (var Ae in de)
        we[Ae] = te[Ae];
      return we;
    }
    function Ee(Q, te, de) {
      ce(Q, te, de, "Component");
    }
    function Me(Q, te) {
      for (var de = Q._threadCount | 0; de <= te; de++)
        Q[de] = Q._currentValue2, Q._threadCount = de + 1;
    }
    function Le(Q, te, de, we) {
      if (we) {
        var Ae = Q.contextType;
        if ("contextType" in Q) {
          var je = (
            // Allow null for conditional declaration
            Ae === null || Ae !== void 0 && Ae.$$typeof === f && Ae._context === void 0
          );
          if (!je && !fe.has(Q)) {
            fe.add(Q);
            var Ge = "";
            Ae === void 0 ? Ge = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file." : typeof Ae != "object" ? Ge = " However, it is set to a " + typeof Ae + "." : Ae.$$typeof === d ? Ge = " Did you accidentally pass the Context.Provider instead?" : Ae._context !== void 0 ? Ge = " Did you accidentally pass the Context.Consumer instead?" : Ge = " However, it is set to an object with keys {" + Object.keys(Ae).join(", ") + "}.", i("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", R(Q) || "Component", Ge);
          }
        }
        if (typeof Ae == "object" && Ae !== null)
          return Me(Ae, de), Ae[de];
        {
          var Pe = _e(Q, te);
          return Q.contextTypes && Ee(Q.contextTypes, Pe, "context"), Pe;
        }
      } else {
        var Pt = _e(Q, te);
        return Q.contextTypes && Ee(Q.contextTypes, Pt, "context"), Pt;
      }
    }
    for (var Ce = new Uint16Array(16), Je = 0; Je < 15; Je++)
      Ce[Je] = Je + 1;
    Ce[15] = 0;
    function Ie() {
      var Q = Ce, te = Q.length, de = te * 2;
      if (!(de <= 65536))
        throw Error("Maximum number of concurrent React renderers exceeded. This can happen if you are not properly destroying the Readable provided by React. Ensure that you call .destroy() on it if you no longer want to read from it, and did not read to the end. If you use .pipe() this should be automatic.");
      var we = new Uint16Array(de);
      we.set(Q), Ce = we, Ce[0] = te + 1;
      for (var Ae = te; Ae < de - 1; Ae++)
        Ce[Ae] = Ae + 1;
      return Ce[de - 1] = 0, te;
    }
    function nt() {
      var Q = Ce[0];
      return Q === 0 ? Ie() : (Ce[0] = Ce[Q], Q);
    }
    function ct(Q) {
      Ce[Q] = Ce[0], Ce[0] = Q;
    }
    var mt = 0, gt = 1, Et = 2, Rt = 3, zt = 4, At = 5, X = 6, ae = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD", ye = ae + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040", De = "data-reactroot", Te = new RegExp("^[" + ae + "][" + ye + "]*$"), st = Object.prototype.hasOwnProperty, ft = {}, Ht = {};
    function nn(Q) {
      return st.call(Ht, Q) ? !0 : st.call(ft, Q) ? !1 : Te.test(Q) ? (Ht[Q] = !0, !0) : (ft[Q] = !0, i("Invalid attribute name: `%s`", Q), !1);
    }
    function It(Q, te, de) {
      return te !== null ? te.type === mt : Q.length > 2 && (Q[0] === "o" || Q[0] === "O") && (Q[1] === "n" || Q[1] === "N");
    }
    function Rn(Q, te, de, we) {
      if (de !== null && de.type === mt)
        return !1;
      switch (typeof te) {
        case "function":
        // $FlowIssue symbol is perfectly valid here
        case "symbol":
          return !0;
        case "boolean": {
          if (de !== null)
            return !de.acceptsBooleans;
          var Ae = Q.toLowerCase().slice(0, 5);
          return Ae !== "data-" && Ae !== "aria-";
        }
        default:
          return !1;
      }
    }
    function yt(Q, te, de, we) {
      if (te === null || typeof te > "u" || Rn(Q, te, de))
        return !0;
      if (de !== null)
        switch (de.type) {
          case Rt:
            return !te;
          case zt:
            return te === !1;
          case At:
            return isNaN(te);
          case X:
            return isNaN(te) || te < 1;
        }
      return !1;
    }
    function oe(Q) {
      return pe.hasOwnProperty(Q) ? pe[Q] : null;
    }
    function ge(Q, te, de, we, Ae, je, Ge) {
      this.acceptsBooleans = te === Et || te === Rt || te === zt, this.attributeName = we, this.attributeNamespace = Ae, this.mustUseProperty = de, this.propertyName = Q, this.type = te, this.sanitizeURL = je, this.removeEmptyString = Ge;
    }
    var pe = {}, He = [
      "children",
      "dangerouslySetInnerHTML",
      // TODO: This prevents the assignment of defaultValue to regular
      // elements (not just inputs). Now that ReactDOMInput assigns to the
      // defaultValue property -- do we need this?
      "defaultValue",
      "defaultChecked",
      "innerHTML",
      "suppressContentEditableWarning",
      "suppressHydrationWarning",
      "style"
    ];
    He.forEach(function(Q) {
      pe[Q] = new ge(
        Q,
        mt,
        !1,
        // mustUseProperty
        Q,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(Q) {
      var te = Q[0], de = Q[1];
      pe[te] = new ge(
        te,
        gt,
        !1,
        // mustUseProperty
        de,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(Q) {
      pe[Q] = new ge(
        Q,
        Et,
        !1,
        // mustUseProperty
        Q.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(Q) {
      pe[Q] = new ge(
        Q,
        Et,
        !1,
        // mustUseProperty
        Q,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "allowFullScreen",
      "async",
      // Note: there is a special case that prevents it from being written to the DOM
      // on the client side because the browsers are inconsistent. Instead we call focus().
      "autoFocus",
      "autoPlay",
      "controls",
      "default",
      "defer",
      "disabled",
      "disablePictureInPicture",
      "disableRemotePlayback",
      "formNoValidate",
      "hidden",
      "loop",
      "noModule",
      "noValidate",
      "open",
      "playsInline",
      "readOnly",
      "required",
      "reversed",
      "scoped",
      "seamless",
      // Microdata
      "itemScope"
    ].forEach(function(Q) {
      pe[Q] = new ge(
        Q,
        Rt,
        !1,
        // mustUseProperty
        Q.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "checked",
      // Note: `option.selected` is not updated if `select.multiple` is
      // disabled with `removeAttribute`. We have special logic for handling this.
      "multiple",
      "muted",
      "selected"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(Q) {
      pe[Q] = new ge(
        Q,
        Rt,
        !0,
        // mustUseProperty
        Q,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "capture",
      "download"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(Q) {
      pe[Q] = new ge(
        Q,
        zt,
        !1,
        // mustUseProperty
        Q,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "cols",
      "rows",
      "size",
      "span"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(Q) {
      pe[Q] = new ge(
        Q,
        X,
        !1,
        // mustUseProperty
        Q,
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), ["rowSpan", "start"].forEach(function(Q) {
      pe[Q] = new ge(
        Q,
        At,
        !1,
        // mustUseProperty
        Q.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    });
    var re = /[\-\:]([a-z])/g, J = function(Q) {
      return Q[1].toUpperCase();
    };
    [
      "accent-height",
      "alignment-baseline",
      "arabic-form",
      "baseline-shift",
      "cap-height",
      "clip-path",
      "clip-rule",
      "color-interpolation",
      "color-interpolation-filters",
      "color-profile",
      "color-rendering",
      "dominant-baseline",
      "enable-background",
      "fill-opacity",
      "fill-rule",
      "flood-color",
      "flood-opacity",
      "font-family",
      "font-size",
      "font-size-adjust",
      "font-stretch",
      "font-style",
      "font-variant",
      "font-weight",
      "glyph-name",
      "glyph-orientation-horizontal",
      "glyph-orientation-vertical",
      "horiz-adv-x",
      "horiz-origin-x",
      "image-rendering",
      "letter-spacing",
      "lighting-color",
      "marker-end",
      "marker-mid",
      "marker-start",
      "overline-position",
      "overline-thickness",
      "paint-order",
      "panose-1",
      "pointer-events",
      "rendering-intent",
      "shape-rendering",
      "stop-color",
      "stop-opacity",
      "strikethrough-position",
      "strikethrough-thickness",
      "stroke-dasharray",
      "stroke-dashoffset",
      "stroke-linecap",
      "stroke-linejoin",
      "stroke-miterlimit",
      "stroke-opacity",
      "stroke-width",
      "text-anchor",
      "text-decoration",
      "text-rendering",
      "underline-position",
      "underline-thickness",
      "unicode-bidi",
      "unicode-range",
      "units-per-em",
      "v-alphabetic",
      "v-hanging",
      "v-ideographic",
      "v-mathematical",
      "vector-effect",
      "vert-adv-y",
      "vert-origin-x",
      "vert-origin-y",
      "word-spacing",
      "writing-mode",
      "xmlns:xlink",
      "x-height"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(Q) {
      var te = Q.replace(re, J);
      pe[te] = new ge(
        te,
        gt,
        !1,
        // mustUseProperty
        Q,
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "xlink:actuate",
      "xlink:arcrole",
      "xlink:role",
      "xlink:show",
      "xlink:title",
      "xlink:type"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(Q) {
      var te = Q.replace(re, J);
      pe[te] = new ge(
        te,
        gt,
        !1,
        // mustUseProperty
        Q,
        "http://www.w3.org/1999/xlink",
        !1,
        // sanitizeURL
        !1
      );
    }), [
      "xml:base",
      "xml:lang",
      "xml:space"
      // NOTE: if you add a camelCased prop to this list,
      // you'll need to set attributeName to name.toLowerCase()
      // instead in the assignment below.
    ].forEach(function(Q) {
      var te = Q.replace(re, J);
      pe[te] = new ge(
        te,
        gt,
        !1,
        // mustUseProperty
        Q,
        "http://www.w3.org/XML/1998/namespace",
        !1,
        // sanitizeURL
        !1
      );
    }), ["tabIndex", "crossOrigin"].forEach(function(Q) {
      pe[Q] = new ge(
        Q,
        gt,
        !1,
        // mustUseProperty
        Q.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !1,
        // sanitizeURL
        !1
      );
    });
    var ie = "xlinkHref";
    pe[ie] = new ge(
      "xlinkHref",
      gt,
      !1,
      // mustUseProperty
      "xlink:href",
      "http://www.w3.org/1999/xlink",
      !0,
      // sanitizeURL
      !1
    ), ["src", "href", "action", "formAction"].forEach(function(Q) {
      pe[Q] = new ge(
        Q,
        gt,
        !1,
        // mustUseProperty
        Q.toLowerCase(),
        // attributeName
        null,
        // attributeNamespace
        !0,
        // sanitizeURL
        !0
      );
    });
    var me = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i, be = !1;
    function tt(Q) {
      !be && me.test(Q) && (be = !0, i("A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.", JSON.stringify(Q)));
    }
    var Ke = /["'&<>]/;
    function Fe(Q) {
      var te = "" + Q, de = Ke.exec(te);
      if (!de)
        return te;
      var we, Ae = "", je, Ge = 0;
      for (je = de.index; je < te.length; je++) {
        switch (te.charCodeAt(je)) {
          case 34:
            we = "&quot;";
            break;
          case 38:
            we = "&amp;";
            break;
          case 39:
            we = "&#x27;";
            break;
          case 60:
            we = "&lt;";
            break;
          case 62:
            we = "&gt;";
            break;
          default:
            continue;
        }
        Ge !== je && (Ae += te.substring(Ge, je)), Ge = je + 1, Ae += we;
      }
      return Ge !== je ? Ae + te.substring(Ge, je) : Ae;
    }
    function We(Q) {
      return typeof Q == "boolean" || typeof Q == "number" ? "" + Q : Fe(Q);
    }
    function Xe(Q) {
      return '"' + We(Q) + '"';
    }
    function at() {
      return De + '=""';
    }
    function bt(Q, te) {
      var de = oe(Q);
      if (Q !== "style" && It(Q, de) || yt(Q, te, de))
        return "";
      if (de !== null) {
        var we = de.attributeName, Ae = de.type;
        return Ae === Rt || Ae === zt && te === !0 ? we + '=""' : (de.sanitizeURL && (te = "" + te, tt(te)), we + "=" + Xe(te));
      } else if (nn(Q))
        return Q + "=" + Xe(te);
      return "";
    }
    function Lt(Q, te) {
      return !nn(Q) || te == null ? "" : Q + "=" + Xe(te);
    }
    function bn(Q, te) {
      return Q === te && (Q !== 0 || 1 / Q === 1 / te) || Q !== Q && te !== te;
    }
    var un = typeof Object.is == "function" ? Object.is : bn, Qe = null, se = null, Re = null, ot = !1, Xt = !1, Dn = null, Zn = 0, Fr = 25, sr = !1, $o;
    function Vn() {
      if (Qe === null)
        throw Error(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.`);
      return sr && i("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks"), Qe;
    }
    function of(Q, te) {
      if (te === null)
        return i("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", $o), !1;
      Q.length !== te.length && i(`The final argument passed to %s changed size between renders. The order and size of this array must remain constant.

Previous: %s
Incoming: %s`, $o, "[" + Q.join(", ") + "]", "[" + te.join(", ") + "]");
      for (var de = 0; de < te.length && de < Q.length; de++)
        if (!un(Q[de], te[de]))
          return !1;
      return !0;
    }
    function Xl() {
      if (Zn > 0)
        throw Error("Rendered more hooks than during the previous render");
      return {
        memoizedState: null,
        queue: null,
        next: null
      };
    }
    function Wp() {
      return Re === null ? se === null ? (ot = !1, se = Re = Xl()) : (ot = !0, Re = se) : Re.next === null ? (ot = !1, Re = Re.next = Xl()) : (ot = !0, Re = Re.next), Re;
    }
    function Qv(Q) {
      Qe = Q, sr = !1;
    }
    function Zv(Q, te, de, we) {
      for (; Xt; )
        Xt = !1, Zn += 1, Re = null, de = Q(te, we);
      return Jv(), de;
    }
    function Jv() {
      sr = !1, Qe = null, Xt = !1, se = null, Zn = 0, Dn = null, Re = null;
    }
    function KO(Q, te) {
      var de = af.threadID;
      return Me(Q, de), sr && i("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo()."), Q[de];
    }
    function XO(Q, te) {
      $o = "useContext", Vn();
      var de = af.threadID;
      return Me(Q, de), Q[de];
    }
    function Gp(Q, te) {
      return typeof te == "function" ? te(Q) : te;
    }
    function QO(Q) {
      return $o = "useState", eb(
        Gp,
        // useReducer has a special case to support lazy useState initializers
        Q
      );
    }
    function eb(Q, te, de) {
      if (Q !== Gp && ($o = "useReducer"), Qe = Vn(), Re = Wp(), ot) {
        var we = Re.queue, Ae = we.dispatch;
        if (Dn !== null) {
          var je = Dn.get(we);
          if (je !== void 0) {
            Dn.delete(we);
            var Ge = Re.memoizedState, Pe = je;
            do {
              var Pt = Pe.action;
              sr = !0, Ge = Q(Ge, Pt), sr = !1, Pe = Pe.next;
            } while (Pe !== null);
            return Re.memoizedState = Ge, [Ge, Ae];
          }
        }
        return [Re.memoizedState, Ae];
      } else {
        sr = !0;
        var Ct;
        Q === Gp ? Ct = typeof te == "function" ? te() : te : Ct = de !== void 0 ? de(te) : te, sr = !1, Re.memoizedState = Ct;
        var wt = Re.queue = {
          last: null,
          dispatch: null
        }, Pr = wt.dispatch = Uwe.bind(null, Qe, wt);
        return [Re.memoizedState, Pr];
      }
    }
    function sf(Q, te) {
      Qe = Vn(), Re = Wp();
      var de = te === void 0 ? null : te;
      if (Re !== null) {
        var we = Re.memoizedState;
        if (we !== null && de !== null) {
          var Ae = we[1];
          if (of(de, Ae))
            return we[0];
        }
      }
      sr = !0;
      var je = Q();
      return sr = !1, Re.memoizedState = [je, de], je;
    }
    function ZO(Q) {
      Qe = Vn(), Re = Wp();
      var te = Re.memoizedState;
      if (te === null) {
        var de = {
          current: Q
        };
        return Object.seal(de), Re.memoizedState = de, de;
      } else
        return te;
    }
    function qwe(Q, te) {
      $o = "useLayoutEffect", i("useLayoutEffect does nothing on the server, because its effect cannot be encoded into the server renderer's output format. This will lead to a mismatch between the initial, non-hydrated UI and the intended UI. To avoid this, useLayoutEffect should only be used in components that render exclusively on the client. See https://reactjs.org/link/uselayouteffect-ssr for common fixes.");
    }
    function Uwe(Q, te, de) {
      if (!(Zn < Fr))
        throw Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
      if (Q === Qe) {
        Xt = !0;
        var we = {
          action: de,
          next: null
        };
        Dn === null && (Dn = /* @__PURE__ */ new Map());
        var Ae = Dn.get(te);
        if (Ae === void 0)
          Dn.set(te, we);
        else {
          for (var je = Ae; je.next !== null; )
            je = je.next;
          je.next = we;
        }
      }
    }
    function Hwe(Q, te) {
      return sf(function() {
        return Q;
      }, te);
    }
    function Vwe(Q, te, de) {
      return Vn(), te(Q._source);
    }
    function Wwe(Q) {
      return Vn(), Q;
    }
    function Gwe() {
      Vn();
      var Q = function(te) {
        te();
      };
      return [Q, !1];
    }
    function Ywe() {
      return (af.identifierPrefix || "") + "R:" + (af.uniqueID++).toString(36);
    }
    function JO() {
    }
    var af = null;
    function P9(Q) {
      af = Q;
    }
    var Kwe = {
      readContext: KO,
      useContext: XO,
      useMemo: sf,
      useReducer: eb,
      useRef: ZO,
      useState: QO,
      useLayoutEffect: qwe,
      useCallback: Hwe,
      // useImperativeHandle is not run in the server environment
      useImperativeHandle: JO,
      // Effects are not run in the server environment.
      useEffect: JO,
      // Debugging effect
      useDebugValue: JO,
      useDeferredValue: Wwe,
      useTransition: Gwe,
      useOpaqueIdentifier: Ywe,
      // Subscriptions are not setup in a server environment.
      useMutableSource: Vwe
    }, tb = "http://www.w3.org/1999/xhtml", Xwe = "http://www.w3.org/1998/Math/MathML", $9 = "http://www.w3.org/2000/svg", eC = {
      html: tb
    };
    function M9(Q) {
      switch (Q) {
        case "svg":
          return $9;
        case "math":
          return Xwe;
        default:
          return tb;
      }
    }
    function Qwe(Q, te) {
      return Q == null || Q === tb ? M9(te) : Q === $9 && te === "foreignObject" ? tb : Q;
    }
    var Zwe = {
      button: !0,
      checkbox: !0,
      image: !0,
      hidden: !0,
      radio: !0,
      reset: !0,
      submit: !0
    };
    function tC(Q, te) {
      Zwe[te.type] || te.onChange || te.onInput || te.readOnly || te.disabled || te.value == null || i("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`."), te.onChange || te.readOnly || te.disabled || te.checked == null || i("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
    }
    var D9 = {
      area: !0,
      base: !0,
      br: !0,
      col: !0,
      embed: !0,
      hr: !0,
      img: !0,
      input: !0,
      keygen: !0,
      link: !0,
      meta: !0,
      param: !0,
      source: !0,
      track: !0,
      wbr: !0
      // NOTE: menuitem's close tag should be omitted, but that causes problems.
    }, Jwe = e({
      menuitem: !0
    }, D9), exe = "__html";
    function txe(Q, te) {
      if (te) {
        if (Jwe[Q] && !(te.children == null && te.dangerouslySetInnerHTML == null))
          throw Error(Q + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
        if (te.dangerouslySetInnerHTML != null) {
          if (te.children != null)
            throw Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
          if (!(typeof te.dangerouslySetInnerHTML == "object" && exe in te.dangerouslySetInnerHTML))
            throw Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
        }
        if (!te.suppressContentEditableWarning && te.contentEditable && te.children != null && i("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional."), !(te.style == null || typeof te.style == "object"))
          throw Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
      }
    }
    var Yp = {
      animationIterationCount: !0,
      borderImageOutset: !0,
      borderImageSlice: !0,
      borderImageWidth: !0,
      boxFlex: !0,
      boxFlexGroup: !0,
      boxOrdinalGroup: !0,
      columnCount: !0,
      columns: !0,
      flex: !0,
      flexGrow: !0,
      flexPositive: !0,
      flexShrink: !0,
      flexNegative: !0,
      flexOrder: !0,
      gridArea: !0,
      gridRow: !0,
      gridRowEnd: !0,
      gridRowSpan: !0,
      gridRowStart: !0,
      gridColumn: !0,
      gridColumnEnd: !0,
      gridColumnSpan: !0,
      gridColumnStart: !0,
      fontWeight: !0,
      lineClamp: !0,
      lineHeight: !0,
      opacity: !0,
      order: !0,
      orphans: !0,
      tabSize: !0,
      widows: !0,
      zIndex: !0,
      zoom: !0,
      // SVG-related properties
      fillOpacity: !0,
      floodOpacity: !0,
      stopOpacity: !0,
      strokeDasharray: !0,
      strokeDashoffset: !0,
      strokeMiterlimit: !0,
      strokeOpacity: !0,
      strokeWidth: !0
    };
    function nxe(Q, te) {
      return Q + te.charAt(0).toUpperCase() + te.substring(1);
    }
    var rxe = ["Webkit", "ms", "Moz", "O"];
    Object.keys(Yp).forEach(function(Q) {
      rxe.forEach(function(te) {
        Yp[nxe(te, Q)] = Yp[Q];
      });
    });
    function oxe(Q, te, de) {
      var we = te == null || typeof te == "boolean" || te === "";
      return we ? "" : !de && typeof te == "number" && te !== 0 && !(Yp.hasOwnProperty(Q) && Yp[Q]) ? te + "px" : ("" + te).trim();
    }
    var ixe = /([A-Z])/g, sxe = /^ms-/;
    function axe(Q) {
      return Q.replace(ixe, "-$1").toLowerCase().replace(sxe, "-ms-");
    }
    function nC(Q, te) {
      if (Q.indexOf("-") === -1)
        return typeof te.is == "string";
      switch (Q) {
        // These are reserved SVG and MathML elements.
        // We don't mind this list too much because we expect it to never grow.
        // The alternative is to track the namespace in a few places which is convoluted.
        // https://w3c.github.io/webcomponents/spec/custom/#custom-elements-core-concepts
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          return !1;
        default:
          return !0;
      }
    }
    var I9 = function() {
    };
    {
      var lxe = /^(?:webkit|moz|o)[A-Z]/, cxe = /^-ms-/, uxe = /-(.)/g, N9 = /;\s*$/, lf = {}, rC = {}, j9 = !1, L9 = !1, dxe = function(Q) {
        return Q.replace(uxe, function(te, de) {
          return de.toUpperCase();
        });
      }, fxe = function(Q) {
        lf.hasOwnProperty(Q) && lf[Q] || (lf[Q] = !0, i(
          "Unsupported style property %s. Did you mean %s?",
          Q,
          // As Andi Smith suggests
          // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
          // is converted to lowercase `ms`.
          dxe(Q.replace(cxe, "ms-"))
        ));
      }, hxe = function(Q) {
        lf.hasOwnProperty(Q) && lf[Q] || (lf[Q] = !0, i("Unsupported vendor-prefixed style property %s. Did you mean %s?", Q, Q.charAt(0).toUpperCase() + Q.slice(1)));
      }, pxe = function(Q, te) {
        rC.hasOwnProperty(te) && rC[te] || (rC[te] = !0, i(`Style property values shouldn't contain a semicolon. Try "%s: %s" instead.`, Q, te.replace(N9, "")));
      }, mxe = function(Q, te) {
        j9 || (j9 = !0, i("`NaN` is an invalid value for the `%s` css style property.", Q));
      }, gxe = function(Q, te) {
        L9 || (L9 = !0, i("`Infinity` is an invalid value for the `%s` css style property.", Q));
      };
      I9 = function(Q, te) {
        Q.indexOf("-") > -1 ? fxe(Q) : lxe.test(Q) ? hxe(Q) : N9.test(te) && pxe(Q, te), typeof te == "number" && (isNaN(te) ? mxe(Q, te) : isFinite(te) || gxe(Q, te));
      };
    }
    var yxe = I9, F9 = {
      "aria-current": 0,
      // state
      "aria-details": 0,
      "aria-disabled": 0,
      // state
      "aria-hidden": 0,
      // state
      "aria-invalid": 0,
      // state
      "aria-keyshortcuts": 0,
      "aria-label": 0,
      "aria-roledescription": 0,
      // Widget Attributes
      "aria-autocomplete": 0,
      "aria-checked": 0,
      "aria-expanded": 0,
      "aria-haspopup": 0,
      "aria-level": 0,
      "aria-modal": 0,
      "aria-multiline": 0,
      "aria-multiselectable": 0,
      "aria-orientation": 0,
      "aria-placeholder": 0,
      "aria-pressed": 0,
      "aria-readonly": 0,
      "aria-required": 0,
      "aria-selected": 0,
      "aria-sort": 0,
      "aria-valuemax": 0,
      "aria-valuemin": 0,
      "aria-valuenow": 0,
      "aria-valuetext": 0,
      // Live Region Attributes
      "aria-atomic": 0,
      "aria-busy": 0,
      "aria-live": 0,
      "aria-relevant": 0,
      // Drag-and-Drop Attributes
      "aria-dropeffect": 0,
      "aria-grabbed": 0,
      // Relationship Attributes
      "aria-activedescendant": 0,
      "aria-colcount": 0,
      "aria-colindex": 0,
      "aria-colspan": 0,
      "aria-controls": 0,
      "aria-describedby": 0,
      "aria-errormessage": 0,
      "aria-flowto": 0,
      "aria-labelledby": 0,
      "aria-owns": 0,
      "aria-posinset": 0,
      "aria-rowcount": 0,
      "aria-rowindex": 0,
      "aria-rowspan": 0,
      "aria-setsize": 0
    }, cf = {}, vxe = new RegExp("^(aria)-[" + ye + "]*$"), bxe = new RegExp("^(aria)[A-Z][" + ye + "]*$"), _xe = Object.prototype.hasOwnProperty;
    function wxe(Q, te) {
      {
        if (_xe.call(cf, te) && cf[te])
          return !0;
        if (bxe.test(te)) {
          var de = "aria-" + te.slice(4).toLowerCase(), we = F9.hasOwnProperty(de) ? de : null;
          if (we == null)
            return i("Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.", te), cf[te] = !0, !0;
          if (te !== we)
            return i("Invalid ARIA attribute `%s`. Did you mean `%s`?", te, we), cf[te] = !0, !0;
        }
        if (vxe.test(te)) {
          var Ae = te.toLowerCase(), je = F9.hasOwnProperty(Ae) ? Ae : null;
          if (je == null)
            return cf[te] = !0, !1;
          if (te !== je)
            return i("Unknown ARIA attribute `%s`. Did you mean `%s`?", te, je), cf[te] = !0, !0;
        }
      }
      return !0;
    }
    function xxe(Q, te) {
      {
        var de = [];
        for (var we in te) {
          var Ae = wxe(Q, we);
          Ae || de.push(we);
        }
        var je = de.map(function(Ge) {
          return "`" + Ge + "`";
        }).join(", ");
        de.length === 1 ? i("Invalid aria prop %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", je, Q) : de.length > 1 && i("Invalid aria props %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", je, Q);
      }
    }
    function Exe(Q, te) {
      nC(Q, te) || xxe(Q, te);
    }
    var B9 = !1;
    function Sxe(Q, te) {
      {
        if (Q !== "input" && Q !== "textarea" && Q !== "select")
          return;
        te != null && te.value === null && !B9 && (B9 = !0, Q === "select" && te.multiple ? i("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", Q) : i("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", Q));
      }
    }
    var z9 = {
      // HTML
      accept: "accept",
      acceptcharset: "acceptCharset",
      "accept-charset": "acceptCharset",
      accesskey: "accessKey",
      action: "action",
      allowfullscreen: "allowFullScreen",
      alt: "alt",
      as: "as",
      async: "async",
      autocapitalize: "autoCapitalize",
      autocomplete: "autoComplete",
      autocorrect: "autoCorrect",
      autofocus: "autoFocus",
      autoplay: "autoPlay",
      autosave: "autoSave",
      capture: "capture",
      cellpadding: "cellPadding",
      cellspacing: "cellSpacing",
      challenge: "challenge",
      charset: "charSet",
      checked: "checked",
      children: "children",
      cite: "cite",
      class: "className",
      classid: "classID",
      classname: "className",
      cols: "cols",
      colspan: "colSpan",
      content: "content",
      contenteditable: "contentEditable",
      contextmenu: "contextMenu",
      controls: "controls",
      controlslist: "controlsList",
      coords: "coords",
      crossorigin: "crossOrigin",
      dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
      data: "data",
      datetime: "dateTime",
      default: "default",
      defaultchecked: "defaultChecked",
      defaultvalue: "defaultValue",
      defer: "defer",
      dir: "dir",
      disabled: "disabled",
      disablepictureinpicture: "disablePictureInPicture",
      disableremoteplayback: "disableRemotePlayback",
      download: "download",
      draggable: "draggable",
      enctype: "encType",
      enterkeyhint: "enterKeyHint",
      for: "htmlFor",
      form: "form",
      formmethod: "formMethod",
      formaction: "formAction",
      formenctype: "formEncType",
      formnovalidate: "formNoValidate",
      formtarget: "formTarget",
      frameborder: "frameBorder",
      headers: "headers",
      height: "height",
      hidden: "hidden",
      high: "high",
      href: "href",
      hreflang: "hrefLang",
      htmlfor: "htmlFor",
      httpequiv: "httpEquiv",
      "http-equiv": "httpEquiv",
      icon: "icon",
      id: "id",
      innerhtml: "innerHTML",
      inputmode: "inputMode",
      integrity: "integrity",
      is: "is",
      itemid: "itemID",
      itemprop: "itemProp",
      itemref: "itemRef",
      itemscope: "itemScope",
      itemtype: "itemType",
      keyparams: "keyParams",
      keytype: "keyType",
      kind: "kind",
      label: "label",
      lang: "lang",
      list: "list",
      loop: "loop",
      low: "low",
      manifest: "manifest",
      marginwidth: "marginWidth",
      marginheight: "marginHeight",
      max: "max",
      maxlength: "maxLength",
      media: "media",
      mediagroup: "mediaGroup",
      method: "method",
      min: "min",
      minlength: "minLength",
      multiple: "multiple",
      muted: "muted",
      name: "name",
      nomodule: "noModule",
      nonce: "nonce",
      novalidate: "noValidate",
      open: "open",
      optimum: "optimum",
      pattern: "pattern",
      placeholder: "placeholder",
      playsinline: "playsInline",
      poster: "poster",
      preload: "preload",
      profile: "profile",
      radiogroup: "radioGroup",
      readonly: "readOnly",
      referrerpolicy: "referrerPolicy",
      rel: "rel",
      required: "required",
      reversed: "reversed",
      role: "role",
      rows: "rows",
      rowspan: "rowSpan",
      sandbox: "sandbox",
      scope: "scope",
      scoped: "scoped",
      scrolling: "scrolling",
      seamless: "seamless",
      selected: "selected",
      shape: "shape",
      size: "size",
      sizes: "sizes",
      span: "span",
      spellcheck: "spellCheck",
      src: "src",
      srcdoc: "srcDoc",
      srclang: "srcLang",
      srcset: "srcSet",
      start: "start",
      step: "step",
      style: "style",
      summary: "summary",
      tabindex: "tabIndex",
      target: "target",
      title: "title",
      type: "type",
      usemap: "useMap",
      value: "value",
      width: "width",
      wmode: "wmode",
      wrap: "wrap",
      // SVG
      about: "about",
      accentheight: "accentHeight",
      "accent-height": "accentHeight",
      accumulate: "accumulate",
      additive: "additive",
      alignmentbaseline: "alignmentBaseline",
      "alignment-baseline": "alignmentBaseline",
      allowreorder: "allowReorder",
      alphabetic: "alphabetic",
      amplitude: "amplitude",
      arabicform: "arabicForm",
      "arabic-form": "arabicForm",
      ascent: "ascent",
      attributename: "attributeName",
      attributetype: "attributeType",
      autoreverse: "autoReverse",
      azimuth: "azimuth",
      basefrequency: "baseFrequency",
      baselineshift: "baselineShift",
      "baseline-shift": "baselineShift",
      baseprofile: "baseProfile",
      bbox: "bbox",
      begin: "begin",
      bias: "bias",
      by: "by",
      calcmode: "calcMode",
      capheight: "capHeight",
      "cap-height": "capHeight",
      clip: "clip",
      clippath: "clipPath",
      "clip-path": "clipPath",
      clippathunits: "clipPathUnits",
      cliprule: "clipRule",
      "clip-rule": "clipRule",
      color: "color",
      colorinterpolation: "colorInterpolation",
      "color-interpolation": "colorInterpolation",
      colorinterpolationfilters: "colorInterpolationFilters",
      "color-interpolation-filters": "colorInterpolationFilters",
      colorprofile: "colorProfile",
      "color-profile": "colorProfile",
      colorrendering: "colorRendering",
      "color-rendering": "colorRendering",
      contentscripttype: "contentScriptType",
      contentstyletype: "contentStyleType",
      cursor: "cursor",
      cx: "cx",
      cy: "cy",
      d: "d",
      datatype: "datatype",
      decelerate: "decelerate",
      descent: "descent",
      diffuseconstant: "diffuseConstant",
      direction: "direction",
      display: "display",
      divisor: "divisor",
      dominantbaseline: "dominantBaseline",
      "dominant-baseline": "dominantBaseline",
      dur: "dur",
      dx: "dx",
      dy: "dy",
      edgemode: "edgeMode",
      elevation: "elevation",
      enablebackground: "enableBackground",
      "enable-background": "enableBackground",
      end: "end",
      exponent: "exponent",
      externalresourcesrequired: "externalResourcesRequired",
      fill: "fill",
      fillopacity: "fillOpacity",
      "fill-opacity": "fillOpacity",
      fillrule: "fillRule",
      "fill-rule": "fillRule",
      filter: "filter",
      filterres: "filterRes",
      filterunits: "filterUnits",
      floodopacity: "floodOpacity",
      "flood-opacity": "floodOpacity",
      floodcolor: "floodColor",
      "flood-color": "floodColor",
      focusable: "focusable",
      fontfamily: "fontFamily",
      "font-family": "fontFamily",
      fontsize: "fontSize",
      "font-size": "fontSize",
      fontsizeadjust: "fontSizeAdjust",
      "font-size-adjust": "fontSizeAdjust",
      fontstretch: "fontStretch",
      "font-stretch": "fontStretch",
      fontstyle: "fontStyle",
      "font-style": "fontStyle",
      fontvariant: "fontVariant",
      "font-variant": "fontVariant",
      fontweight: "fontWeight",
      "font-weight": "fontWeight",
      format: "format",
      from: "from",
      fx: "fx",
      fy: "fy",
      g1: "g1",
      g2: "g2",
      glyphname: "glyphName",
      "glyph-name": "glyphName",
      glyphorientationhorizontal: "glyphOrientationHorizontal",
      "glyph-orientation-horizontal": "glyphOrientationHorizontal",
      glyphorientationvertical: "glyphOrientationVertical",
      "glyph-orientation-vertical": "glyphOrientationVertical",
      glyphref: "glyphRef",
      gradienttransform: "gradientTransform",
      gradientunits: "gradientUnits",
      hanging: "hanging",
      horizadvx: "horizAdvX",
      "horiz-adv-x": "horizAdvX",
      horizoriginx: "horizOriginX",
      "horiz-origin-x": "horizOriginX",
      ideographic: "ideographic",
      imagerendering: "imageRendering",
      "image-rendering": "imageRendering",
      in2: "in2",
      in: "in",
      inlist: "inlist",
      intercept: "intercept",
      k1: "k1",
      k2: "k2",
      k3: "k3",
      k4: "k4",
      k: "k",
      kernelmatrix: "kernelMatrix",
      kernelunitlength: "kernelUnitLength",
      kerning: "kerning",
      keypoints: "keyPoints",
      keysplines: "keySplines",
      keytimes: "keyTimes",
      lengthadjust: "lengthAdjust",
      letterspacing: "letterSpacing",
      "letter-spacing": "letterSpacing",
      lightingcolor: "lightingColor",
      "lighting-color": "lightingColor",
      limitingconeangle: "limitingConeAngle",
      local: "local",
      markerend: "markerEnd",
      "marker-end": "markerEnd",
      markerheight: "markerHeight",
      markermid: "markerMid",
      "marker-mid": "markerMid",
      markerstart: "markerStart",
      "marker-start": "markerStart",
      markerunits: "markerUnits",
      markerwidth: "markerWidth",
      mask: "mask",
      maskcontentunits: "maskContentUnits",
      maskunits: "maskUnits",
      mathematical: "mathematical",
      mode: "mode",
      numoctaves: "numOctaves",
      offset: "offset",
      opacity: "opacity",
      operator: "operator",
      order: "order",
      orient: "orient",
      orientation: "orientation",
      origin: "origin",
      overflow: "overflow",
      overlineposition: "overlinePosition",
      "overline-position": "overlinePosition",
      overlinethickness: "overlineThickness",
      "overline-thickness": "overlineThickness",
      paintorder: "paintOrder",
      "paint-order": "paintOrder",
      panose1: "panose1",
      "panose-1": "panose1",
      pathlength: "pathLength",
      patterncontentunits: "patternContentUnits",
      patterntransform: "patternTransform",
      patternunits: "patternUnits",
      pointerevents: "pointerEvents",
      "pointer-events": "pointerEvents",
      points: "points",
      pointsatx: "pointsAtX",
      pointsaty: "pointsAtY",
      pointsatz: "pointsAtZ",
      prefix: "prefix",
      preservealpha: "preserveAlpha",
      preserveaspectratio: "preserveAspectRatio",
      primitiveunits: "primitiveUnits",
      property: "property",
      r: "r",
      radius: "radius",
      refx: "refX",
      refy: "refY",
      renderingintent: "renderingIntent",
      "rendering-intent": "renderingIntent",
      repeatcount: "repeatCount",
      repeatdur: "repeatDur",
      requiredextensions: "requiredExtensions",
      requiredfeatures: "requiredFeatures",
      resource: "resource",
      restart: "restart",
      result: "result",
      results: "results",
      rotate: "rotate",
      rx: "rx",
      ry: "ry",
      scale: "scale",
      security: "security",
      seed: "seed",
      shaperendering: "shapeRendering",
      "shape-rendering": "shapeRendering",
      slope: "slope",
      spacing: "spacing",
      specularconstant: "specularConstant",
      specularexponent: "specularExponent",
      speed: "speed",
      spreadmethod: "spreadMethod",
      startoffset: "startOffset",
      stddeviation: "stdDeviation",
      stemh: "stemh",
      stemv: "stemv",
      stitchtiles: "stitchTiles",
      stopcolor: "stopColor",
      "stop-color": "stopColor",
      stopopacity: "stopOpacity",
      "stop-opacity": "stopOpacity",
      strikethroughposition: "strikethroughPosition",
      "strikethrough-position": "strikethroughPosition",
      strikethroughthickness: "strikethroughThickness",
      "strikethrough-thickness": "strikethroughThickness",
      string: "string",
      stroke: "stroke",
      strokedasharray: "strokeDasharray",
      "stroke-dasharray": "strokeDasharray",
      strokedashoffset: "strokeDashoffset",
      "stroke-dashoffset": "strokeDashoffset",
      strokelinecap: "strokeLinecap",
      "stroke-linecap": "strokeLinecap",
      strokelinejoin: "strokeLinejoin",
      "stroke-linejoin": "strokeLinejoin",
      strokemiterlimit: "strokeMiterlimit",
      "stroke-miterlimit": "strokeMiterlimit",
      strokewidth: "strokeWidth",
      "stroke-width": "strokeWidth",
      strokeopacity: "strokeOpacity",
      "stroke-opacity": "strokeOpacity",
      suppresscontenteditablewarning: "suppressContentEditableWarning",
      suppresshydrationwarning: "suppressHydrationWarning",
      surfacescale: "surfaceScale",
      systemlanguage: "systemLanguage",
      tablevalues: "tableValues",
      targetx: "targetX",
      targety: "targetY",
      textanchor: "textAnchor",
      "text-anchor": "textAnchor",
      textdecoration: "textDecoration",
      "text-decoration": "textDecoration",
      textlength: "textLength",
      textrendering: "textRendering",
      "text-rendering": "textRendering",
      to: "to",
      transform: "transform",
      typeof: "typeof",
      u1: "u1",
      u2: "u2",
      underlineposition: "underlinePosition",
      "underline-position": "underlinePosition",
      underlinethickness: "underlineThickness",
      "underline-thickness": "underlineThickness",
      unicode: "unicode",
      unicodebidi: "unicodeBidi",
      "unicode-bidi": "unicodeBidi",
      unicoderange: "unicodeRange",
      "unicode-range": "unicodeRange",
      unitsperem: "unitsPerEm",
      "units-per-em": "unitsPerEm",
      unselectable: "unselectable",
      valphabetic: "vAlphabetic",
      "v-alphabetic": "vAlphabetic",
      values: "values",
      vectoreffect: "vectorEffect",
      "vector-effect": "vectorEffect",
      version: "version",
      vertadvy: "vertAdvY",
      "vert-adv-y": "vertAdvY",
      vertoriginx: "vertOriginX",
      "vert-origin-x": "vertOriginX",
      vertoriginy: "vertOriginY",
      "vert-origin-y": "vertOriginY",
      vhanging: "vHanging",
      "v-hanging": "vHanging",
      videographic: "vIdeographic",
      "v-ideographic": "vIdeographic",
      viewbox: "viewBox",
      viewtarget: "viewTarget",
      visibility: "visibility",
      vmathematical: "vMathematical",
      "v-mathematical": "vMathematical",
      vocab: "vocab",
      widths: "widths",
      wordspacing: "wordSpacing",
      "word-spacing": "wordSpacing",
      writingmode: "writingMode",
      "writing-mode": "writingMode",
      x1: "x1",
      x2: "x2",
      x: "x",
      xchannelselector: "xChannelSelector",
      xheight: "xHeight",
      "x-height": "xHeight",
      xlinkactuate: "xlinkActuate",
      "xlink:actuate": "xlinkActuate",
      xlinkarcrole: "xlinkArcrole",
      "xlink:arcrole": "xlinkArcrole",
      xlinkhref: "xlinkHref",
      "xlink:href": "xlinkHref",
      xlinkrole: "xlinkRole",
      "xlink:role": "xlinkRole",
      xlinkshow: "xlinkShow",
      "xlink:show": "xlinkShow",
      xlinktitle: "xlinkTitle",
      "xlink:title": "xlinkTitle",
      xlinktype: "xlinkType",
      "xlink:type": "xlinkType",
      xmlbase: "xmlBase",
      "xml:base": "xmlBase",
      xmllang: "xmlLang",
      "xml:lang": "xmlLang",
      xmlns: "xmlns",
      "xml:space": "xmlSpace",
      xmlnsxlink: "xmlnsXlink",
      "xmlns:xlink": "xmlnsXlink",
      xmlspace: "xmlSpace",
      y1: "y1",
      y2: "y2",
      y: "y",
      ychannelselector: "yChannelSelector",
      z: "z",
      zoomandpan: "zoomAndPan"
    }, q9 = function() {
    };
    {
      var yo = {}, Oxe = Object.prototype.hasOwnProperty, U9 = /^on./, Cxe = /^on[^A-Z]/, kxe = new RegExp("^(aria)-[" + ye + "]*$"), Axe = new RegExp("^(aria)[A-Z][" + ye + "]*$");
      q9 = function(Q, te, de, we) {
        if (Oxe.call(yo, te) && yo[te])
          return !0;
        var Ae = te.toLowerCase();
        if (Ae === "onfocusin" || Ae === "onfocusout")
          return i("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React."), yo[te] = !0, !0;
        if (we != null) {
          var je = we.registrationNameDependencies, Ge = we.possibleRegistrationNames;
          if (je.hasOwnProperty(te))
            return !0;
          var Pe = Ge.hasOwnProperty(Ae) ? Ge[Ae] : null;
          if (Pe != null)
            return i("Invalid event handler property `%s`. Did you mean `%s`?", te, Pe), yo[te] = !0, !0;
          if (U9.test(te))
            return i("Unknown event handler property `%s`. It will be ignored.", te), yo[te] = !0, !0;
        } else if (U9.test(te))
          return Cxe.test(te) && i("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", te), yo[te] = !0, !0;
        if (kxe.test(te) || Axe.test(te))
          return !0;
        if (Ae === "innerhtml")
          return i("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`."), yo[te] = !0, !0;
        if (Ae === "aria")
          return i("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead."), yo[te] = !0, !0;
        if (Ae === "is" && de !== null && de !== void 0 && typeof de != "string")
          return i("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof de), yo[te] = !0, !0;
        if (typeof de == "number" && isNaN(de))
          return i("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", te), yo[te] = !0, !0;
        var Pt = oe(te), Ct = Pt !== null && Pt.type === mt;
        if (z9.hasOwnProperty(Ae)) {
          var wt = z9[Ae];
          if (wt !== te)
            return i("Invalid DOM property `%s`. Did you mean `%s`?", te, wt), yo[te] = !0, !0;
        } else if (!Ct && te !== Ae)
          return i("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", te, Ae), yo[te] = !0, !0;
        return typeof de == "boolean" && Rn(te, de, Pt) ? (de ? i('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', de, te, te, de, te) : i('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', de, te, te, de, te, te, te), yo[te] = !0, !0) : Ct ? !0 : Rn(te, de, Pt) ? (yo[te] = !0, !1) : ((de === "false" || de === "true") && Pt !== null && Pt.type === Rt && (i("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", de, te, de === "false" ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".', te, de), yo[te] = !0), !0);
      };
    }
    var Txe = function(Q, te, de) {
      {
        var we = [];
        for (var Ae in te) {
          var je = q9(Q, Ae, te[Ae], de);
          je || we.push(Ae);
        }
        var Ge = we.map(function(Pe) {
          return "`" + Pe + "`";
        }).join(", ");
        we.length === 1 ? i("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", Ge, Q) : we.length > 1 && i("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", Ge, Q);
      }
    };
    function Rxe(Q, te, de) {
      nC(Q, te) || Txe(Q, te, de);
    }
    var Ql = t.Children.toArray, ja = [], oC = r.ReactCurrentDispatcher, nb, iC = null, H9 = function() {
      return "";
    }, V9 = function(Q) {
      return "";
    }, W9 = function(Q, te) {
    }, G9 = function(Q) {
    }, Y9 = function(Q) {
    }, K9 = function() {
    }, X9 = !1;
    nb = r.ReactDebugCurrentFrame, W9 = function(Q, te) {
      Exe(Q, te), Sxe(Q, te), Rxe(Q, te, null);
    }, V9 = function(Q) {
      return L(Q.type, Q._source, null);
    }, G9 = function(Q) {
      ja.push(Q), ja.length === 1 && (iC = nb.getCurrentStack, nb.getCurrentStack = H9);
    }, Y9 = function(Q) {
      var te = ja[ja.length - 1], de = te[te.length - 1];
      de.debugElementStack.push(Q);
    }, K9 = function() {
      ja.pop(), ja.length === 0 && (nb.getCurrentStack = iC, iC = null);
    }, H9 = function() {
      if (ja.length === 0)
        return "";
      for (var Q = ja[ja.length - 1], te = "", de = Q.length - 1; de >= 0; de--)
        for (var we = Q[de], Ae = we.debugElementStack, je = Ae.length - 1; je >= 0; je--)
          te += V9(Ae[je]);
      return te;
    };
    var Q9 = !1, Z9 = !1, J9 = !1, e8 = !1, t8 = !1, n8 = {}, r8 = {}, o8 = {}, i8 = {}, s8 = {}, a8 = {}, l8 = ["value", "defaultValue"], Pxe = {
      listing: !0,
      pre: !0,
      textarea: !0
    }, $xe = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, c8 = {};
    function Mxe(Q) {
      if (!c8.hasOwnProperty(Q)) {
        if (!$xe.test(Q))
          throw Error("Invalid tag: " + Q);
        c8[Q] = !0;
      }
    }
    var sC = {}, Dxe = function(Q) {
      if (sC.hasOwnProperty(Q))
        return sC[Q];
      var te = axe(Q);
      return sC[Q] = te, te;
    };
    function Ixe(Q) {
      var te = "", de = "";
      for (var we in Q)
        if (Q.hasOwnProperty(we)) {
          var Ae = we.indexOf("--") === 0, je = Q[we];
          Ae || yxe(we, je), je != null && (te += de + (Ae ? we : Dxe(we)) + ":", te += oxe(we, je, Ae), de = ";");
        }
      return te || null;
    }
    function u8(Q, te) {
      {
        var de = Q.constructor, we = de && R(de) || "ReactClass", Ae = we + "." + te;
        if (n8[Ae])
          return;
        i(`%s(...): Can only update a mounting component. This usually means you called %s() outside componentWillMount() on the server. This is a no-op.

Please check the code for the %s component.`, te, te, we), n8[Ae] = !0;
      }
    }
    function Nxe(Q) {
      return Q.prototype && Q.prototype.isReactComponent;
    }
    function jxe(Q) {
      var te = Q.dangerouslySetInnerHTML;
      if (te != null) {
        if (te.__html != null)
          return te.__html;
      } else {
        var de = Q.children;
        if (typeof de == "string" || typeof de == "number")
          return We(de);
      }
      return null;
    }
    function Lxe(Q) {
      if (!t.isValidElement(Q))
        return Ql(Q);
      var te = Q;
      if (te.type !== l)
        return [te];
      var de = te.props.children;
      if (!t.isValidElement(de))
        return Ql(de);
      var we = de;
      return [we];
    }
    function Fxe(Q) {
      if (Q == null)
        return Q;
      var te = "";
      return t.Children.forEach(Q, function(de) {
        de != null && (te += de, !t8 && typeof de != "string" && typeof de != "number" && (t8 = !0, i("Only strings and numbers are supported as <option> children.")));
      }), te;
    }
    var Bxe = Object.prototype.hasOwnProperty, zxe = "style", qxe = {
      children: null,
      dangerouslySetInnerHTML: null,
      suppressContentEditableWarning: null,
      suppressHydrationWarning: null
    };
    function Uxe(Q, te, de, we, Ae, je) {
      var Ge = "<" + Q, Pe = nC(te, de);
      for (var Pt in de)
        if (Bxe.call(de, Pt)) {
          var Ct = de[Pt];
          if (Ct != null) {
            Pt === zxe && (Ct = Ixe(Ct));
            var wt = null;
            Pe ? qxe.hasOwnProperty(Pt) || (wt = Lt(Pt, Ct)) : wt = bt(Pt, Ct), wt && (Ge += " " + wt);
          }
        }
      return Ae || je && (Ge += " " + at()), Ge;
    }
    function d8(Q, te) {
      if (Q === void 0)
        throw Error((R(te) || "Component") + "(...): Nothing was returned from render. This usually means a return statement is missing. Or, to render nothing, return null.");
    }
    function Hxe(Q, te, de) {
      for (; t.isValidElement(Q); ) {
        var we = Q, Ae = we.type;
        if (Y9(we), typeof Ae != "function")
          break;
        je(we, Ae);
      }
      function je(Ge, Pe) {
        var Pt = Nxe(Pe), Ct = Le(Pe, te, de, Pt), wt = [], Pr = !1, _n = {
          isMounted: function(ec) {
            return !1;
          },
          enqueueForceUpdate: function(ec) {
            if (wt === null)
              return u8(ec, "forceUpdate"), null;
          },
          enqueueReplaceState: function(ec, ff) {
            Pr = !0, wt = [ff];
          },
          enqueueSetState: function(ec, ff) {
            if (wt === null)
              return u8(ec, "setState"), null;
            wt.push(ff);
          }
        }, _t;
        if (Pt) {
          if (_t = new Pe(Ge.props, Ct, _n), typeof Pe.getDerivedStateFromProps == "function") {
            if (_t.state === null || _t.state === void 0) {
              var Ln = R(Pe) || "Unknown";
              a8[Ln] || (i("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", Ln, _t.state === null ? "null" : "undefined", Ln), a8[Ln] = !0);
            }
            var Mo = Pe.getDerivedStateFromProps.call(null, Ge.props, _t.state);
            if (Mo === void 0) {
              var ri = R(Pe) || "Unknown";
              s8[ri] || (i("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", ri), s8[ri] = !0);
            }
            Mo != null && (_t.state = e({}, _t.state, Mo));
          }
        } else {
          if (Pe.prototype && typeof Pe.prototype.render == "function") {
            var ds = R(Pe) || "Unknown";
            r8[ds] || (i("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", ds, ds), r8[ds] = !0);
          }
          var Zl = {};
          if (Qv(Zl), _t = Pe(Ge.props, Ct, _n), _t = Zv(Pe, Ge.props, _t, Ct), _t != null && _t.render != null) {
            var Do = R(Pe) || "Unknown";
            o8[Do] || (i("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", Do, Do, Do), o8[Do] = !0);
          }
          if (_t == null || _t.render == null) {
            Q = _t, d8(Q, Pe);
            return;
          }
        }
        _t.props = Ge.props, _t.context = Ct, _t.updater = _n;
        var pu = _t.state;
        if (pu === void 0 && (_t.state = pu = null), typeof _t.UNSAFE_componentWillMount == "function" || typeof _t.componentWillMount == "function") {
          if (typeof _t.componentWillMount == "function") {
            if (_t.componentWillMount.__suppressDeprecationWarning !== !0) {
              var Fs = R(Pe) || "Unknown";
              i8[Fs] || (o(
                // keep this warning in sync with ReactStrictModeWarning.js
                `componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code from componentWillMount to componentDidMount (preferred in most cases) or the constructor.

Please update the following components: %s`,
                Fs
              ), i8[Fs] = !0);
            }
            typeof Pe.getDerivedStateFromProps != "function" && _t.componentWillMount();
          }
          if (typeof _t.UNSAFE_componentWillMount == "function" && typeof Pe.getDerivedStateFromProps != "function" && _t.UNSAFE_componentWillMount(), wt.length) {
            var oi = wt, Jl = Pr;
            if (wt = null, Pr = !1, Jl && oi.length === 1)
              _t.state = oi[0];
            else {
              for (var mu = Jl ? oi[0] : _t.state, Kp = !0, fs = Jl ? 1 : 0; fs < oi.length; fs++) {
                var Xp = oi[fs], uf = typeof Xp == "function" ? Xp.call(_t, mu, Ge.props, Ct) : Xp;
                uf != null && (Kp ? (Kp = !1, mu = e({}, mu, uf)) : e(mu, uf));
              }
              _t.state = mu;
            }
          } else
            wt = null;
        }
        Q = _t.render(), Q === void 0 && _t.render._isMockFunction && (Q = null), d8(Q, Pe);
        var df;
        {
          if (typeof _t.getChildContext == "function") {
            var rb = Pe.childContextTypes;
            if (typeof rb == "object") {
              df = _t.getChildContext();
              for (var Qp in df)
                if (!(Qp in rb))
                  throw Error((R(Pe) || "Unknown") + '.getChildContext(): key "' + Qp + '" is not defined in childContextTypes.');
            } else
              i("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", R(Pe) || "Unknown");
          }
          df && (te = e({}, te, df));
        }
      }
      return {
        child: Q,
        context: te
      };
    }
    var f8 = /* @__PURE__ */ function() {
      function Q(de, we, Ae) {
        var je = Lxe(de), Ge = {
          type: null,
          // Assume all trees start in the HTML namespace (not totally true, but
          // this is what we did historically)
          domNamespace: eC.html,
          children: je,
          childIndex: 0,
          context: ve,
          footer: ""
        };
        Ge.debugElementStack = [], this.threadID = nt(), this.stack = [Ge], this.exhausted = !1, this.currentSelectValue = null, this.previousWasTextNode = !1, this.makeStaticMarkup = we, this.suspenseDepth = 0, this.contextIndex = -1, this.contextStack = [], this.contextValueStack = [], this.uniqueID = 0, this.identifierPrefix = Ae && Ae.identifierPrefix || "", this.contextProviderStack = [];
      }
      var te = Q.prototype;
      return te.destroy = function() {
        this.exhausted || (this.exhausted = !0, this.clearProviders(), ct(this.threadID));
      }, te.pushProvider = function(de) {
        var we = ++this.contextIndex, Ae = de.type._context, je = this.threadID;
        Me(Ae, je);
        var Ge = Ae[je];
        this.contextStack[we] = Ae, this.contextValueStack[we] = Ge, this.contextProviderStack[we] = de, Ae[je] = de.props.value;
      }, te.popProvider = function(de) {
        var we = this.contextIndex;
        (we < 0 || de !== this.contextProviderStack[we]) && i("Unexpected pop.");
        var Ae = this.contextStack[we], je = this.contextValueStack[we];
        this.contextStack[we] = null, this.contextValueStack[we] = null, this.contextProviderStack[we] = null, this.contextIndex--, Ae[this.threadID] = je;
      }, te.clearProviders = function() {
        for (var de = this.contextIndex; de >= 0; de--) {
          var we = this.contextStack[de], Ae = this.contextValueStack[de];
          we[this.threadID] = Ae;
        }
      }, te.read = function(de) {
        if (this.exhausted)
          return null;
        var we = af;
        P9(this);
        var Ae = oC.current;
        oC.current = Kwe;
        try {
          for (var je = [""], Ge = !1; je[0].length < de; ) {
            if (this.stack.length === 0) {
              this.exhausted = !0, ct(this.threadID);
              break;
            }
            var Pe = this.stack[this.stack.length - 1];
            if (Ge || Pe.childIndex >= Pe.children.length) {
              var Pt = Pe.footer;
              if (Pt !== "" && (this.previousWasTextNode = !1), this.stack.pop(), Pe.type === "select")
                this.currentSelectValue = null;
              else if (Pe.type != null && Pe.type.type != null && Pe.type.type.$$typeof === d) {
                var Ct = Pe.type;
                this.popProvider(Ct);
              } else if (Pe.type === p) {
                this.suspenseDepth--;
                var wt = je.pop();
                if (Ge) {
                  Ge = !1;
                  var Pr = Pe.fallbackFrame;
                  if (!Pr)
                    throw Error("ReactDOMServer did not find an internal fallback frame for Suspense. This is a bug in React. Please file an issue.");
                  this.stack.push(Pr), je[this.suspenseDepth] += "<!--$!-->";
                  continue;
                } else
                  je[this.suspenseDepth] += wt;
              }
              je[this.suspenseDepth] += Pt;
              continue;
            }
            var _n = Pe.children[Pe.childIndex++], _t = "";
            G9(this.stack), Pe.debugElementStack.length = 0;
            try {
              _t += this.render(_n, Pe.context, Pe.domNamespace);
            } catch (Ln) {
              if (Ln != null && typeof Ln.then == "function") {
                if (!P) throw Error("ReactDOMServer does not yet support Suspense.");
              } else
                throw Ln;
            } finally {
              K9();
            }
            je.length <= this.suspenseDepth && je.push(""), je[this.suspenseDepth] += _t;
          }
          return je[0];
        } finally {
          oC.current = Ae, P9(we), Jv();
        }
      }, te.render = function(de, we, Ae) {
        if (typeof de == "string" || typeof de == "number") {
          var je = "" + de;
          return je === "" ? "" : this.makeStaticMarkup ? We(je) : this.previousWasTextNode ? "<!-- -->" + We(je) : (this.previousWasTextNode = !0, We(je));
        } else {
          var Ge, Pe = Hxe(de, we, this.threadID);
          if (Ge = Pe.child, we = Pe.context, Ge === null || Ge === !1)
            return "";
          if (!t.isValidElement(Ge)) {
            if (Ge != null && Ge.$$typeof != null) {
              var Pt = Ge.$$typeof;
              throw Error(Pt === a ? "Portals are not currently supported by the server renderer. Render them conditionally so that they only appear on the client render." : "Unknown element-like object type: " + Pt.toString() + ". This is likely a bug in React. Please file an issue.");
            }
            var Ct = Ql(Ge), wt = {
              type: null,
              domNamespace: Ae,
              children: Ct,
              childIndex: 0,
              context: we,
              footer: ""
            };
            return wt.debugElementStack = [], this.stack.push(wt), "";
          }
          var Pr = Ge, _n = Pr.type;
          if (typeof _n == "string")
            return this.renderDOM(Pr, we, Ae);
          switch (_n) {
            // TODO: LegacyHidden acts the same as a fragment. This only works
            // because we currently assume that every instance of LegacyHidden is
            // accompanied by a host component wrapper. In the hidden mode, the host
            // component is given a `hidden` attribute, which ensures that the
            // initial HTML is not visible. To support the use of LegacyHidden as a
            // true fragment, without an extra DOM node, we would have to hide the
            // initial HTML in some other way.
            case x:
            case w:
            case c:
            case u:
            case m:
            case l: {
              var _t = Ql(Ge.props.children), Ln = {
                type: null,
                domNamespace: Ae,
                children: _t,
                childIndex: 0,
                context: we,
                footer: ""
              };
              return Ln.debugElementStack = [], this.stack.push(Ln), "";
            }
            case p:
              throw Error("ReactDOMServer does not yet support Suspense.");
            // eslint-disable-next-line-no-fallthrough
            case _:
              throw Error("ReactDOMServer does not yet support scope components.");
          }
          if (typeof _n == "object" && _n !== null)
            switch (_n.$$typeof) {
              case h: {
                var Mo = Ge, ri, ds = {};
                Qv(ds), ri = _n.render(Mo.props, Mo.ref), ri = Zv(_n.render, Mo.props, ri, Mo.ref), ri = Ql(ri);
                var Zl = {
                  type: null,
                  domNamespace: Ae,
                  children: ri,
                  childIndex: 0,
                  context: we,
                  footer: ""
                };
                return Zl.debugElementStack = [], this.stack.push(Zl), "";
              }
              case g: {
                var Do = Ge, pu = [t.createElement(_n.type, e({
                  ref: Do.ref
                }, Do.props))], Fs = {
                  type: null,
                  domNamespace: Ae,
                  children: pu,
                  childIndex: 0,
                  context: we,
                  footer: ""
                };
                return Fs.debugElementStack = [], this.stack.push(Fs), "";
              }
              case d: {
                var oi = Ge, Jl = oi.props, mu = Ql(Jl.children), Kp = {
                  type: oi,
                  domNamespace: Ae,
                  children: mu,
                  childIndex: 0,
                  context: we,
                  footer: ""
                };
                return Kp.debugElementStack = [], this.pushProvider(oi), this.stack.push(Kp), "";
              }
              case f: {
                var fs = Ge.type;
                fs._context === void 0 ? fs !== fs.Consumer && (X9 || (X9 = !0, i("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?"))) : fs = fs._context;
                var Xp = Ge.props, uf = this.threadID;
                Me(fs, uf);
                var df = fs[uf], rb = Ql(Xp.children(df)), Qp = {
                  type: Ge,
                  domNamespace: Ae,
                  children: rb,
                  childIndex: 0,
                  context: we,
                  footer: ""
                };
                return Qp.debugElementStack = [], this.stack.push(Qp), "";
              }
              // eslint-disable-next-line-no-fallthrough
              case b:
                throw Error("ReactDOMServer does not yet support the fundamental API.");
              // eslint-disable-next-line-no-fallthrough
              case y: {
                var ec = Ge, ff = Ge.type, Kxe = ff._payload, Xxe = ff._init, Qxe = Xxe(Kxe), Zxe = [t.createElement(Qxe, e({
                  ref: ec.ref
                }, ec.props))], h8 = {
                  type: null,
                  domNamespace: Ae,
                  children: Zxe,
                  childIndex: 0,
                  context: we,
                  footer: ""
                };
                return h8.debugElementStack = [], this.stack.push(h8), "";
              }
            }
          var aC = "";
          {
            var p8 = Pr._owner;
            (_n === void 0 || typeof _n == "object" && _n !== null && Object.keys(_n).length === 0) && (aC += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
            var m8 = p8 ? R(p8) : null;
            m8 && (aC += `

Check the render method of \`` + m8 + "`.");
          }
          throw Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: " + (_n == null ? _n : typeof _n) + "." + aC);
        }
      }, te.renderDOM = function(de, we, Ae) {
        var je = de.type.toLowerCase(), Ge = Ae;
        Ae === eC.html && (Ge = M9(je)), Ge === eC.html && je !== de.type && i("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", de.type), Mxe(je);
        var Pe = de.props;
        if (je === "input")
          tC("input", Pe), Pe.checked !== void 0 && Pe.defaultChecked !== void 0 && !Z9 && (i("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", "A component", Pe.type), Z9 = !0), Pe.value !== void 0 && Pe.defaultValue !== void 0 && !Q9 && (i("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", "A component", Pe.type), Q9 = !0), Pe = e({
            type: void 0
          }, Pe, {
            defaultChecked: void 0,
            defaultValue: void 0,
            value: Pe.value != null ? Pe.value : Pe.defaultValue,
            checked: Pe.checked != null ? Pe.checked : Pe.defaultChecked
          });
        else if (je === "textarea") {
          tC("textarea", Pe), Pe.value !== void 0 && Pe.defaultValue !== void 0 && !e8 && (i("Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://reactjs.org/link/controlled-components"), e8 = !0);
          var Pt = Pe.value;
          if (Pt == null) {
            var Ct = Pe.defaultValue, wt = Pe.children;
            if (wt != null) {
              if (i("Use the `defaultValue` or `value` props instead of setting children on <textarea>."), Ct != null)
                throw Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
              if (Array.isArray(wt)) {
                if (!(wt.length <= 1))
                  throw Error("<textarea> can only have at most one child.");
                wt = wt[0];
              }
              Ct = "" + wt;
            }
            Ct == null && (Ct = ""), Pt = Ct;
          }
          Pe = e({}, Pe, {
            value: void 0,
            children: "" + Pt
          });
        } else if (je === "select") {
          {
            tC("select", Pe);
            for (var Pr = 0; Pr < l8.length; Pr++) {
              var _n = l8[Pr];
              if (Pe[_n] != null) {
                var _t = Array.isArray(Pe[_n]);
                Pe.multiple && !_t ? i("The `%s` prop supplied to <select> must be an array if `multiple` is true.", _n) : !Pe.multiple && _t && i("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.", _n);
              }
            }
            Pe.value !== void 0 && Pe.defaultValue !== void 0 && !J9 && (i("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://reactjs.org/link/controlled-components"), J9 = !0);
          }
          this.currentSelectValue = Pe.value != null ? Pe.value : Pe.defaultValue, Pe = e({}, Pe, {
            value: void 0
          });
        } else if (je === "option") {
          var Ln = null, Mo = this.currentSelectValue, ri = Fxe(Pe.children);
          if (Mo != null) {
            var ds;
            if (Pe.value != null ? ds = Pe.value + "" : ds = ri, Ln = !1, Array.isArray(Mo)) {
              for (var Zl = 0; Zl < Mo.length; Zl++)
                if ("" + Mo[Zl] === ds) {
                  Ln = !0;
                  break;
                }
            } else
              Ln = "" + Mo === ds;
            Pe = e({
              selected: void 0,
              children: void 0
            }, Pe, {
              selected: Ln,
              children: ri
            });
          }
        }
        W9(je, Pe), txe(je, Pe);
        var Do = Uxe(de.type, je, Pe, Ge, this.makeStaticMarkup, this.stack.length === 1), pu = "";
        D9.hasOwnProperty(je) ? Do += "/>" : (Do += ">", pu = "</" + de.type + ">");
        var Fs, oi = jxe(Pe);
        oi != null ? (Fs = [], Pxe.hasOwnProperty(je) && oi.charAt(0) === `
` && (Do += `
`), Do += oi) : Fs = Ql(Pe.children);
        var Jl = {
          domNamespace: Qwe(Ae, de.type),
          type: je,
          children: Fs,
          childIndex: 0,
          context: we,
          footer: pu
        };
        return Jl.debugElementStack = [], this.stack.push(Jl), this.previousWasTextNode = !1, Do;
      }, Q;
    }();
    function Vxe(Q, te) {
      var de = new f8(Q, !1, te);
      try {
        var we = de.read(1 / 0);
        return we;
      } finally {
        de.destroy();
      }
    }
    function Wxe(Q, te) {
      var de = new f8(Q, !0, te);
      try {
        var we = de.read(1 / 0);
        return we;
      } finally {
        de.destroy();
      }
    }
    function Gxe() {
      throw Error("ReactDOMServer.renderToNodeStream(): The streaming API is not available in the browser. Use ReactDOMServer.renderToString() instead.");
    }
    function Yxe() {
      throw Error("ReactDOMServer.renderToStaticNodeStream(): The streaming API is not available in the browser. Use ReactDOMServer.renderToStaticMarkup() instead.");
    }
    bf.renderToNodeStream = Gxe, bf.renderToStaticMarkup = Wxe, bf.renderToStaticNodeStream = Yxe, bf.renderToString = Vxe, bf.version = n;
  }()), bf;
}
var Vz;
function Qze() {
  return Vz || (Vz = 1, process.env.NODE_ENV === "production" ? _k.exports = Kze() : _k.exports = Xze()), _k.exports;
}
var vhe = Qze();
let Zze = class DN {
  /**
  @internal
  */
  constructor(e, n, r, o, i, s, a, l, c, u = 0, d) {
    this.p = e, this.stack = n, this.state = r, this.reducePos = o, this.pos = i, this.score = s, this.buffer = a, this.bufferBase = l, this.curContext = c, this.lookAhead = u, this.parent = d;
  }
  /**
  @internal
  */
  toString() {
    return `[${this.stack.filter((e, n) => n % 3 == 0).concat(this.state)}]@${this.pos}${this.score ? "!" + this.score : ""}`;
  }
  // Start an empty stack
  /**
  @internal
  */
  static start(e, n, r = 0) {
    let o = e.parser.context;
    return new DN(e, [], n, r, r, 0, [], 0, o ? new Wz(o, o.start) : null, 0, null);
  }
  /**
  The stack's current [context](#lr.ContextTracker) value, if
  any. Its type will depend on the context tracker's type
  parameter, or it will be `null` if there is no context
  tracker.
  */
  get context() {
    return this.curContext ? this.curContext.context : null;
  }
  // Push a state onto the stack, tracking its start position as well
  // as the buffer base at that point.
  /**
  @internal
  */
  pushState(e, n) {
    this.stack.push(this.state, n, this.bufferBase + this.buffer.length), this.state = e;
  }
  // Apply a reduce action
  /**
  @internal
  */
  reduce(e) {
    var n;
    let r = e >> 19, o = e & 65535, { parser: i } = this.p, s = this.reducePos < this.pos - 25;
    s && this.setLookAhead(this.pos);
    let a = i.dynamicPrecedence(o);
    if (a && (this.score += a), r == 0) {
      this.pushState(i.getGoto(this.state, o, !0), this.reducePos), o < i.minRepeatTerm && this.storeNode(o, this.reducePos, this.reducePos, s ? 8 : 4, !0), this.reduceContext(o, this.reducePos);
      return;
    }
    let l = this.stack.length - (r - 1) * 3 - (e & 262144 ? 6 : 0), c = l ? this.stack[l - 2] : this.p.ranges[0].from, u = this.reducePos - c;
    u >= 2e3 && !(!((n = this.p.parser.nodeSet.types[o]) === null || n === void 0) && n.isAnonymous) && (c == this.p.lastBigReductionStart ? (this.p.bigReductionCount++, this.p.lastBigReductionSize = u) : this.p.lastBigReductionSize < u && (this.p.bigReductionCount = 1, this.p.lastBigReductionStart = c, this.p.lastBigReductionSize = u));
    let d = l ? this.stack[l - 1] : 0, f = this.bufferBase + this.buffer.length - d;
    if (o < i.minRepeatTerm || e & 131072) {
      let h = i.stateFlag(
        this.state,
        1
        /* StateFlag.Skipped */
      ) ? this.pos : this.reducePos;
      this.storeNode(o, c, h, f + 4, !0);
    }
    if (e & 262144)
      this.state = this.stack[l];
    else {
      let h = this.stack[l - 3];
      this.state = i.getGoto(h, o, !0);
    }
    for (; this.stack.length > l; )
      this.stack.pop();
    this.reduceContext(o, c);
  }
  // Shift a value into the buffer
  /**
  @internal
  */
  storeNode(e, n, r, o = 4, i = !1) {
    if (e == 0 && (!this.stack.length || this.stack[this.stack.length - 1] < this.buffer.length + this.bufferBase)) {
      let s = this, a = this.buffer.length;
      if (a == 0 && s.parent && (a = s.bufferBase - s.parent.bufferBase, s = s.parent), a > 0 && s.buffer[a - 4] == 0 && s.buffer[a - 1] > -1) {
        if (n == r)
          return;
        if (s.buffer[a - 2] >= n) {
          s.buffer[a - 2] = r;
          return;
        }
      }
    }
    if (!i || this.pos == r)
      this.buffer.push(e, n, r, o);
    else {
      let s = this.buffer.length;
      if (s > 0 && this.buffer[s - 4] != 0) {
        let a = !1;
        for (let l = s; l > 0 && this.buffer[l - 2] > r; l -= 4)
          if (this.buffer[l - 1] >= 0) {
            a = !0;
            break;
          }
        if (a)
          for (; s > 0 && this.buffer[s - 2] > r; )
            this.buffer[s] = this.buffer[s - 4], this.buffer[s + 1] = this.buffer[s - 3], this.buffer[s + 2] = this.buffer[s - 2], this.buffer[s + 3] = this.buffer[s - 1], s -= 4, o > 4 && (o -= 4);
      }
      this.buffer[s] = e, this.buffer[s + 1] = n, this.buffer[s + 2] = r, this.buffer[s + 3] = o;
    }
  }
  // Apply a shift action
  /**
  @internal
  */
  shift(e, n, r, o) {
    if (e & 131072)
      this.pushState(e & 65535, this.pos);
    else if ((e & 262144) == 0) {
      let i = e, { parser: s } = this.p;
      (o > this.pos || n <= s.maxNode) && (this.pos = o, s.stateFlag(
        i,
        1
        /* StateFlag.Skipped */
      ) || (this.reducePos = o)), this.pushState(i, r), this.shiftContext(n, r), n <= s.maxNode && this.buffer.push(n, r, o, 4);
    } else
      this.pos = o, this.shiftContext(n, r), n <= this.p.parser.maxNode && this.buffer.push(n, r, o, 4);
  }
  // Apply an action
  /**
  @internal
  */
  apply(e, n, r, o) {
    e & 65536 ? this.reduce(e) : this.shift(e, n, r, o);
  }
  // Add a prebuilt (reused) node into the buffer.
  /**
  @internal
  */
  useNode(e, n) {
    let r = this.p.reused.length - 1;
    (r < 0 || this.p.reused[r] != e) && (this.p.reused.push(e), r++);
    let o = this.pos;
    this.reducePos = this.pos = o + e.length, this.pushState(n, o), this.buffer.push(
      r,
      o,
      this.reducePos,
      -1
      /* size == -1 means this is a reused value */
    ), this.curContext && this.updateContext(this.curContext.tracker.reuse(this.curContext.context, e, this, this.p.stream.reset(this.pos - e.length)));
  }
  // Split the stack. Due to the buffer sharing and the fact
  // that `this.stack` tends to stay quite shallow, this isn't very
  // expensive.
  /**
  @internal
  */
  split() {
    let e = this, n = e.buffer.length;
    for (; n > 0 && e.buffer[n - 2] > e.reducePos; )
      n -= 4;
    let r = e.buffer.slice(n), o = e.bufferBase + n;
    for (; e && o == e.bufferBase; )
      e = e.parent;
    return new DN(this.p, this.stack.slice(), this.state, this.reducePos, this.pos, this.score, r, o, this.curContext, this.lookAhead, e);
  }
  // Try to recover from an error by 'deleting' (ignoring) one token.
  /**
  @internal
  */
  recoverByDelete(e, n) {
    let r = e <= this.p.parser.maxNode;
    r && this.storeNode(e, this.pos, n, 4), this.storeNode(0, this.pos, n, r ? 8 : 4), this.pos = this.reducePos = n, this.score -= 190;
  }
  /**
  Check if the given term would be able to be shifted (optionally
  after some reductions) on this stack. This can be useful for
  external tokenizers that want to make sure they only provide a
  given token when it applies.
  */
  canShift(e) {
    for (let n = new Jze(this); ; ) {
      let r = this.p.parser.stateSlot(
        n.state,
        4
        /* ParseState.DefaultReduce */
      ) || this.p.parser.hasAction(n.state, e);
      if (r == 0)
        return !1;
      if ((r & 65536) == 0)
        return !0;
      n.reduce(r);
    }
  }
  // Apply up to Recover.MaxNext recovery actions that conceptually
  // inserts some missing token or rule.
  /**
  @internal
  */
  recoverByInsert(e) {
    if (this.stack.length >= 300)
      return [];
    let n = this.p.parser.nextStates(this.state);
    if (n.length > 8 || this.stack.length >= 120) {
      let o = [];
      for (let i = 0, s; i < n.length; i += 2)
        (s = n[i + 1]) != this.state && this.p.parser.hasAction(s, e) && o.push(n[i], s);
      if (this.stack.length < 120)
        for (let i = 0; o.length < 8 && i < n.length; i += 2) {
          let s = n[i + 1];
          o.some((a, l) => l & 1 && a == s) || o.push(n[i], s);
        }
      n = o;
    }
    let r = [];
    for (let o = 0; o < n.length && r.length < 4; o += 2) {
      let i = n[o + 1];
      if (i == this.state)
        continue;
      let s = this.split();
      s.pushState(i, this.pos), s.storeNode(0, s.pos, s.pos, 4, !0), s.shiftContext(n[o], this.pos), s.reducePos = this.pos, s.score -= 200, r.push(s);
    }
    return r;
  }
  // Force a reduce, if possible. Return false if that can't
  // be done.
  /**
  @internal
  */
  forceReduce() {
    let { parser: e } = this.p, n = e.stateSlot(
      this.state,
      5
      /* ParseState.ForcedReduce */
    );
    if ((n & 65536) == 0)
      return !1;
    if (!e.validAction(this.state, n)) {
      let r = n >> 19, o = n & 65535, i = this.stack.length - r * 3;
      if (i < 0 || e.getGoto(this.stack[i], o, !1) < 0) {
        let s = this.findForcedReduction();
        if (s == null)
          return !1;
        n = s;
      }
      this.storeNode(0, this.pos, this.pos, 4, !0), this.score -= 100;
    }
    return this.reducePos = this.pos, this.reduce(n), !0;
  }
  /**
  Try to scan through the automaton to find some kind of reduction
  that can be applied. Used when the regular ForcedReduce field
  isn't a valid action. @internal
  */
  findForcedReduction() {
    let { parser: e } = this.p, n = [], r = (o, i) => {
      if (!n.includes(o))
        return n.push(o), e.allActions(o, (s) => {
          if (!(s & 393216)) if (s & 65536) {
            let a = (s >> 19) - i;
            if (a > 1) {
              let l = s & 65535, c = this.stack.length - a * 3;
              if (c >= 0 && e.getGoto(this.stack[c], l, !1) >= 0)
                return a << 19 | 65536 | l;
            }
          } else {
            let a = r(s, i + 1);
            if (a != null)
              return a;
          }
        });
    };
    return r(this.state, 0);
  }
  /**
  @internal
  */
  forceAll() {
    for (; !this.p.parser.stateFlag(
      this.state,
      2
      /* StateFlag.Accepting */
    ); )
      if (!this.forceReduce()) {
        this.storeNode(0, this.pos, this.pos, 4, !0);
        break;
      }
    return this;
  }
  /**
  Check whether this state has no further actions (assumed to be a direct descendant of the
  top state, since any other states must be able to continue
  somehow). @internal
  */
  get deadEnd() {
    if (this.stack.length != 3)
      return !1;
    let { parser: e } = this.p;
    return e.data[e.stateSlot(
      this.state,
      1
      /* ParseState.Actions */
    )] == 65535 && !e.stateSlot(
      this.state,
      4
      /* ParseState.DefaultReduce */
    );
  }
  /**
  Restart the stack (put it back in its start state). Only safe
  when this.stack.length == 3 (state is directly below the top
  state). @internal
  */
  restart() {
    this.storeNode(0, this.pos, this.pos, 4, !0), this.state = this.stack[0], this.stack.length = 0;
  }
  /**
  @internal
  */
  sameState(e) {
    if (this.state != e.state || this.stack.length != e.stack.length)
      return !1;
    for (let n = 0; n < this.stack.length; n += 3)
      if (this.stack[n] != e.stack[n])
        return !1;
    return !0;
  }
  /**
  Get the parser used by this stack.
  */
  get parser() {
    return this.p.parser;
  }
  /**
  Test whether a given dialect (by numeric ID, as exported from
  the terms file) is enabled.
  */
  dialectEnabled(e) {
    return this.p.parser.dialect.flags[e];
  }
  shiftContext(e, n) {
    this.curContext && this.updateContext(this.curContext.tracker.shift(this.curContext.context, e, this, this.p.stream.reset(n)));
  }
  reduceContext(e, n) {
    this.curContext && this.updateContext(this.curContext.tracker.reduce(this.curContext.context, e, this, this.p.stream.reset(n)));
  }
  /**
  @internal
  */
  emitContext() {
    let e = this.buffer.length - 1;
    (e < 0 || this.buffer[e] != -3) && this.buffer.push(this.curContext.hash, this.pos, this.pos, -3);
  }
  /**
  @internal
  */
  emitLookAhead() {
    let e = this.buffer.length - 1;
    (e < 0 || this.buffer[e] != -4) && this.buffer.push(this.lookAhead, this.pos, this.pos, -4);
  }
  updateContext(e) {
    if (e != this.curContext.context) {
      let n = new Wz(this.curContext.tracker, e);
      n.hash != this.curContext.hash && this.emitContext(), this.curContext = n;
    }
  }
  /**
  @internal
  */
  setLookAhead(e) {
    e > this.lookAhead && (this.emitLookAhead(), this.lookAhead = e);
  }
  /**
  @internal
  */
  close() {
    this.curContext && this.curContext.tracker.strict && this.emitContext(), this.lookAhead > 0 && this.emitLookAhead();
  }
};
class Wz {
  constructor(e, n) {
    this.tracker = e, this.context = n, this.hash = e.strict ? e.hash(n) : 0;
  }
}
class Jze {
  constructor(e) {
    this.start = e, this.state = e.state, this.stack = e.stack, this.base = this.stack.length;
  }
  reduce(e) {
    let n = e & 65535, r = e >> 19;
    r == 0 ? (this.stack == this.start.stack && (this.stack = this.stack.slice()), this.stack.push(this.state, 0, 0), this.base += 3) : this.base -= (r - 1) * 3;
    let o = this.start.p.parser.getGoto(this.stack[this.base - 3], n, !0);
    this.state = o;
  }
}
let eqe = class IN {
  constructor(e, n, r) {
    this.stack = e, this.pos = n, this.index = r, this.buffer = e.buffer, this.index == 0 && this.maybeNext();
  }
  static create(e, n = e.bufferBase + e.buffer.length) {
    return new IN(e, n, n - e.bufferBase);
  }
  maybeNext() {
    let e = this.stack.parent;
    e != null && (this.index = this.stack.bufferBase - e.bufferBase, this.stack = e, this.buffer = e.buffer);
  }
  get id() {
    return this.buffer[this.index - 4];
  }
  get start() {
    return this.buffer[this.index - 3];
  }
  get end() {
    return this.buffer[this.index - 2];
  }
  get size() {
    return this.buffer[this.index - 1];
  }
  next() {
    this.index -= 4, this.pos -= 4, this.index == 0 && this.maybeNext();
  }
  fork() {
    return new IN(this.stack, this.pos, this.index);
  }
};
function Wb(t, e = Uint16Array) {
  if (typeof t != "string")
    return t;
  let n = null;
  for (let r = 0, o = 0; r < t.length; ) {
    let i = 0;
    for (; ; ) {
      let s = t.charCodeAt(r++), a = !1;
      if (s == 126) {
        i = 65535;
        break;
      }
      s >= 92 && s--, s >= 34 && s--;
      let l = s - 32;
      if (l >= 46 && (l -= 46, a = !0), i += l, a)
        break;
      i *= 46;
    }
    n ? n[o++] = i : n = new e(i);
  }
  return n;
}
class xw {
  constructor() {
    this.start = -1, this.value = -1, this.end = -1, this.extended = -1, this.lookAhead = 0, this.mask = 0, this.context = 0;
  }
}
const Gz = new xw();
class tqe {
  /**
  @internal
  */
  constructor(e, n) {
    this.input = e, this.ranges = n, this.chunk = "", this.chunkOff = 0, this.chunk2 = "", this.chunk2Pos = 0, this.next = -1, this.token = Gz, this.rangeIndex = 0, this.pos = this.chunkPos = n[0].from, this.range = n[0], this.end = n[n.length - 1].to, this.readNext();
  }
  /**
  @internal
  */
  resolveOffset(e, n) {
    let r = this.range, o = this.rangeIndex, i = this.pos + e;
    for (; i < r.from; ) {
      if (!o)
        return null;
      let s = this.ranges[--o];
      i -= r.from - s.to, r = s;
    }
    for (; n < 0 ? i > r.to : i >= r.to; ) {
      if (o == this.ranges.length - 1)
        return null;
      let s = this.ranges[++o];
      i += s.from - r.to, r = s;
    }
    return i;
  }
  /**
  @internal
  */
  clipPos(e) {
    if (e >= this.range.from && e < this.range.to)
      return e;
    for (let n of this.ranges)
      if (n.to > e)
        return Math.max(e, n.from);
    return this.end;
  }
  /**
  Look at a code unit near the stream position. `.peek(0)` equals
  `.next`, `.peek(-1)` gives you the previous character, and so
  on.
  
  Note that looking around during tokenizing creates dependencies
  on potentially far-away content, which may reduce the
  effectiveness incremental parsing—when looking forward—or even
  cause invalid reparses when looking backward more than 25 code
  units, since the library does not track lookbehind.
  */
  peek(e) {
    let n = this.chunkOff + e, r, o;
    if (n >= 0 && n < this.chunk.length)
      r = this.pos + e, o = this.chunk.charCodeAt(n);
    else {
      let i = this.resolveOffset(e, 1);
      if (i == null)
        return -1;
      if (r = i, r >= this.chunk2Pos && r < this.chunk2Pos + this.chunk2.length)
        o = this.chunk2.charCodeAt(r - this.chunk2Pos);
      else {
        let s = this.rangeIndex, a = this.range;
        for (; a.to <= r; )
          a = this.ranges[++s];
        this.chunk2 = this.input.chunk(this.chunk2Pos = r), r + this.chunk2.length > a.to && (this.chunk2 = this.chunk2.slice(0, a.to - r)), o = this.chunk2.charCodeAt(0);
      }
    }
    return r >= this.token.lookAhead && (this.token.lookAhead = r + 1), o;
  }
  /**
  Accept a token. By default, the end of the token is set to the
  current stream position, but you can pass an offset (relative to
  the stream position) to change that.
  */
  acceptToken(e, n = 0) {
    let r = n ? this.resolveOffset(n, -1) : this.pos;
    if (r == null || r < this.token.start)
      throw new RangeError("Token end out of bounds");
    this.token.value = e, this.token.end = r;
  }
  /**
  Accept a token ending at a specific given position.
  */
  acceptTokenTo(e, n) {
    this.token.value = e, this.token.end = n;
  }
  getChunk() {
    if (this.pos >= this.chunk2Pos && this.pos < this.chunk2Pos + this.chunk2.length) {
      let { chunk: e, chunkPos: n } = this;
      this.chunk = this.chunk2, this.chunkPos = this.chunk2Pos, this.chunk2 = e, this.chunk2Pos = n, this.chunkOff = this.pos - this.chunkPos;
    } else {
      this.chunk2 = this.chunk, this.chunk2Pos = this.chunkPos;
      let e = this.input.chunk(this.pos), n = this.pos + e.length;
      this.chunk = n > this.range.to ? e.slice(0, this.range.to - this.pos) : e, this.chunkPos = this.pos, this.chunkOff = 0;
    }
  }
  readNext() {
    return this.chunkOff >= this.chunk.length && (this.getChunk(), this.chunkOff == this.chunk.length) ? this.next = -1 : this.next = this.chunk.charCodeAt(this.chunkOff);
  }
  /**
  Move the stream forward N (defaults to 1) code units. Returns
  the new value of [`next`](#lr.InputStream.next).
  */
  advance(e = 1) {
    for (this.chunkOff += e; this.pos + e >= this.range.to; ) {
      if (this.rangeIndex == this.ranges.length - 1)
        return this.setDone();
      e -= this.range.to - this.pos, this.range = this.ranges[++this.rangeIndex], this.pos = this.range.from;
    }
    return this.pos += e, this.pos >= this.token.lookAhead && (this.token.lookAhead = this.pos + 1), this.readNext();
  }
  setDone() {
    return this.pos = this.chunkPos = this.end, this.range = this.ranges[this.rangeIndex = this.ranges.length - 1], this.chunk = "", this.next = -1;
  }
  /**
  @internal
  */
  reset(e, n) {
    if (n ? (this.token = n, n.start = e, n.lookAhead = e + 1, n.value = n.extended = -1) : this.token = Gz, this.pos != e) {
      if (this.pos = e, e == this.end)
        return this.setDone(), this;
      for (; e < this.range.from; )
        this.range = this.ranges[--this.rangeIndex];
      for (; e >= this.range.to; )
        this.range = this.ranges[++this.rangeIndex];
      e >= this.chunkPos && e < this.chunkPos + this.chunk.length ? this.chunkOff = e - this.chunkPos : (this.chunk = "", this.chunkOff = 0), this.readNext();
    }
    return this;
  }
  /**
  @internal
  */
  read(e, n) {
    if (e >= this.chunkPos && n <= this.chunkPos + this.chunk.length)
      return this.chunk.slice(e - this.chunkPos, n - this.chunkPos);
    if (e >= this.chunk2Pos && n <= this.chunk2Pos + this.chunk2.length)
      return this.chunk2.slice(e - this.chunk2Pos, n - this.chunk2Pos);
    if (e >= this.range.from && n <= this.range.to)
      return this.input.read(e, n);
    let r = "";
    for (let o of this.ranges) {
      if (o.from >= n)
        break;
      o.to > e && (r += this.input.read(Math.max(o.from, e), Math.min(o.to, n)));
    }
    return r;
  }
}
class _h {
  constructor(e, n) {
    this.data = e, this.id = n;
  }
  token(e, n) {
    let { parser: r } = n.p;
    nqe(this.data, e, n, this.id, r.data, r.tokenPrecTable);
  }
}
_h.prototype.contextual = _h.prototype.fallback = _h.prototype.extend = !1;
_h.prototype.fallback = _h.prototype.extend = !1;
class FS {
  /**
  Create a tokenizer. The first argument is the function that,
  given an input stream, scans for the types of tokens it
  recognizes at the stream's position, and calls
  [`acceptToken`](#lr.InputStream.acceptToken) when it finds
  one.
  */
  constructor(e, n = {}) {
    this.token = e, this.contextual = !!n.contextual, this.fallback = !!n.fallback, this.extend = !!n.extend;
  }
}
function nqe(t, e, n, r, o, i) {
  let s = 0, a = 1 << r, { dialect: l } = n.p.parser;
  e: for (; (a & t[s]) != 0; ) {
    let c = t[s + 1];
    for (let h = s + 3; h < c; h += 2)
      if ((t[h + 1] & a) > 0) {
        let p = t[h];
        if (l.allows(p) && (e.token.value == -1 || e.token.value == p || rqe(p, e.token.value, o, i))) {
          e.acceptToken(p);
          break;
        }
      }
    let u = e.next, d = 0, f = t[s + 2];
    if (e.next < 0 && f > d && t[c + f * 3 - 3] == 65535) {
      s = t[c + f * 3 - 1];
      continue e;
    }
    for (; d < f; ) {
      let h = d + f >> 1, p = c + h + (h << 1), m = t[p], g = t[p + 1] || 65536;
      if (u < m)
        f = h;
      else if (u >= g)
        d = h + 1;
      else {
        s = t[p + 2], e.advance();
        continue e;
      }
    }
    break;
  }
}
function Yz(t, e, n) {
  for (let r = e, o; (o = t[r]) != 65535; r++)
    if (o == n)
      return r - e;
  return -1;
}
function rqe(t, e, n, r) {
  let o = Yz(n, r, e);
  return o < 0 || Yz(n, r, t) < o;
}
const si = typeof process < "u" && process.env && /\bparse\b/.test(process.env.LOG);
let wk = null;
function Kz(t, e, n) {
  let r = t.cursor(Ur.IncludeAnonymous);
  for (r.moveTo(e); ; )
    if (!(n < 0 ? r.childBefore(e) : r.childAfter(e)))
      for (; ; ) {
        if ((n < 0 ? r.to < e : r.from > e) && !r.type.isError)
          return n < 0 ? Math.max(0, Math.min(
            r.to - 1,
            e - 25
            /* Lookahead.Margin */
          )) : Math.min(t.length, Math.max(
            r.from + 1,
            e + 25
            /* Lookahead.Margin */
          ));
        if (n < 0 ? r.prevSibling() : r.nextSibling())
          break;
        if (!r.parent())
          return n < 0 ? 0 : t.length;
      }
}
class oqe {
  constructor(e, n) {
    this.fragments = e, this.nodeSet = n, this.i = 0, this.fragment = null, this.safeFrom = -1, this.safeTo = -1, this.trees = [], this.start = [], this.index = [], this.nextFragment();
  }
  nextFragment() {
    let e = this.fragment = this.i == this.fragments.length ? null : this.fragments[this.i++];
    if (e) {
      for (this.safeFrom = e.openStart ? Kz(e.tree, e.from + e.offset, 1) - e.offset : e.from, this.safeTo = e.openEnd ? Kz(e.tree, e.to + e.offset, -1) - e.offset : e.to; this.trees.length; )
        this.trees.pop(), this.start.pop(), this.index.pop();
      this.trees.push(e.tree), this.start.push(-e.offset), this.index.push(0), this.nextStart = this.safeFrom;
    } else
      this.nextStart = 1e9;
  }
  // `pos` must be >= any previously given `pos` for this cursor
  nodeAt(e) {
    if (e < this.nextStart)
      return null;
    for (; this.fragment && this.safeTo <= e; )
      this.nextFragment();
    if (!this.fragment)
      return null;
    for (; ; ) {
      let n = this.trees.length - 1;
      if (n < 0)
        return this.nextFragment(), null;
      let r = this.trees[n], o = this.index[n];
      if (o == r.children.length) {
        this.trees.pop(), this.start.pop(), this.index.pop();
        continue;
      }
      let i = r.children[o], s = this.start[n] + r.positions[o];
      if (s > e)
        return this.nextStart = s, null;
      if (i instanceof Jr) {
        if (s == e) {
          if (s < this.safeFrom)
            return null;
          let a = s + i.length;
          if (a <= this.safeTo) {
            let l = i.prop(Dt.lookAhead);
            if (!l || a + l < this.fragment.to)
              return i;
          }
        }
        this.index[n]++, s + i.length >= Math.max(this.safeFrom, e) && (this.trees.push(i), this.start.push(s), this.index.push(0));
      } else
        this.index[n]++, this.nextStart = s + i.length;
    }
  }
}
class iqe {
  constructor(e, n) {
    this.stream = n, this.tokens = [], this.mainToken = null, this.actions = [], this.tokens = e.tokenizers.map((r) => new xw());
  }
  getActions(e) {
    let n = 0, r = null, { parser: o } = e.p, { tokenizers: i } = o, s = o.stateSlot(
      e.state,
      3
      /* ParseState.TokenizerMask */
    ), a = e.curContext ? e.curContext.hash : 0, l = 0;
    for (let c = 0; c < i.length; c++) {
      if ((1 << c & s) == 0)
        continue;
      let u = i[c], d = this.tokens[c];
      if (!(r && !u.fallback) && ((u.contextual || d.start != e.pos || d.mask != s || d.context != a) && (this.updateCachedToken(d, u, e), d.mask = s, d.context = a), d.lookAhead > d.end + 25 && (l = Math.max(d.lookAhead, l)), d.value != 0)) {
        let f = n;
        if (d.extended > -1 && (n = this.addActions(e, d.extended, d.end, n)), n = this.addActions(e, d.value, d.end, n), !u.extend && (r = d, n > f))
          break;
      }
    }
    for (; this.actions.length > n; )
      this.actions.pop();
    return l && e.setLookAhead(l), !r && e.pos == this.stream.end && (r = new xw(), r.value = e.p.parser.eofTerm, r.start = r.end = e.pos, n = this.addActions(e, r.value, r.end, n)), this.mainToken = r, this.actions;
  }
  getMainToken(e) {
    if (this.mainToken)
      return this.mainToken;
    let n = new xw(), { pos: r, p: o } = e;
    return n.start = r, n.end = Math.min(r + 1, o.stream.end), n.value = r == o.stream.end ? o.parser.eofTerm : 0, n;
  }
  updateCachedToken(e, n, r) {
    let o = this.stream.clipPos(r.pos);
    if (n.token(this.stream.reset(o, e), r), e.value > -1) {
      let { parser: i } = r.p;
      for (let s = 0; s < i.specialized.length; s++)
        if (i.specialized[s] == e.value) {
          let a = i.specializers[s](this.stream.read(e.start, e.end), r);
          if (a >= 0 && r.p.parser.dialect.allows(a >> 1)) {
            (a & 1) == 0 ? e.value = a >> 1 : e.extended = a >> 1;
            break;
          }
        }
    } else
      e.value = 0, e.end = this.stream.clipPos(o + 1);
  }
  putAction(e, n, r, o) {
    for (let i = 0; i < o; i += 3)
      if (this.actions[i] == e)
        return o;
    return this.actions[o++] = e, this.actions[o++] = n, this.actions[o++] = r, o;
  }
  addActions(e, n, r, o) {
    let { state: i } = e, { parser: s } = e.p, { data: a } = s;
    for (let l = 0; l < 2; l++)
      for (let c = s.stateSlot(
        i,
        l ? 2 : 1
        /* ParseState.Actions */
      ); ; c += 3) {
        if (a[c] == 65535)
          if (a[c + 1] == 1)
            c = fl(a, c + 2);
          else {
            o == 0 && a[c + 1] == 2 && (o = this.putAction(fl(a, c + 2), n, r, o));
            break;
          }
        a[c] == n && (o = this.putAction(fl(a, c + 1), n, r, o));
      }
    return o;
  }
}
class sqe {
  constructor(e, n, r, o) {
    this.parser = e, this.input = n, this.ranges = o, this.recovering = 0, this.nextStackID = 9812, this.minStackPos = 0, this.reused = [], this.stoppedAt = null, this.lastBigReductionStart = -1, this.lastBigReductionSize = 0, this.bigReductionCount = 0, this.stream = new tqe(n, o), this.tokens = new iqe(e, this.stream), this.topTerm = e.top[1];
    let { from: i } = o[0];
    this.stacks = [Zze.start(this, e.top[0], i)], this.fragments = r.length && this.stream.end - i > e.bufferLength * 4 ? new oqe(r, e.nodeSet) : null;
  }
  get parsedPos() {
    return this.minStackPos;
  }
  // Move the parser forward. This will process all parse stacks at
  // `this.pos` and try to advance them to a further position. If no
  // stack for such a position is found, it'll start error-recovery.
  //
  // When the parse is finished, this will return a syntax tree. When
  // not, it returns `null`.
  advance() {
    let e = this.stacks, n = this.minStackPos, r = this.stacks = [], o, i;
    if (this.bigReductionCount > 300 && e.length == 1) {
      let [s] = e;
      for (; s.forceReduce() && s.stack.length && s.stack[s.stack.length - 2] >= this.lastBigReductionStart; )
        ;
      this.bigReductionCount = this.lastBigReductionSize = 0;
    }
    for (let s = 0; s < e.length; s++) {
      let a = e[s];
      for (; ; ) {
        if (this.tokens.mainToken = null, a.pos > n)
          r.push(a);
        else {
          if (this.advanceStack(a, r, e))
            continue;
          {
            o || (o = [], i = []), o.push(a);
            let l = this.tokens.getMainToken(a);
            i.push(l.value, l.end);
          }
        }
        break;
      }
    }
    if (!r.length) {
      let s = o && cqe(o);
      if (s)
        return si && console.log("Finish with " + this.stackID(s)), this.stackToTree(s);
      if (this.parser.strict)
        throw si && o && console.log("Stuck with token " + (this.tokens.mainToken ? this.parser.getName(this.tokens.mainToken.value) : "none")), new SyntaxError("No parse at " + n);
      this.recovering || (this.recovering = 5);
    }
    if (this.recovering && o) {
      let s = this.stoppedAt != null && o[0].pos > this.stoppedAt ? o[0] : this.runRecovery(o, i, r);
      if (s)
        return si && console.log("Force-finish " + this.stackID(s)), this.stackToTree(s.forceAll());
    }
    if (this.recovering) {
      let s = this.recovering == 1 ? 1 : this.recovering * 3;
      if (r.length > s)
        for (r.sort((a, l) => l.score - a.score); r.length > s; )
          r.pop();
      r.some((a) => a.reducePos > n) && this.recovering--;
    } else if (r.length > 1) {
      e: for (let s = 0; s < r.length - 1; s++) {
        let a = r[s];
        for (let l = s + 1; l < r.length; l++) {
          let c = r[l];
          if (a.sameState(c) || a.buffer.length > 500 && c.buffer.length > 500)
            if ((a.score - c.score || a.buffer.length - c.buffer.length) > 0)
              r.splice(l--, 1);
            else {
              r.splice(s--, 1);
              continue e;
            }
        }
      }
      r.length > 12 && r.splice(
        12,
        r.length - 12
        /* Rec.MaxStackCount */
      );
    }
    this.minStackPos = r[0].pos;
    for (let s = 1; s < r.length; s++)
      r[s].pos < this.minStackPos && (this.minStackPos = r[s].pos);
    return null;
  }
  stopAt(e) {
    if (this.stoppedAt != null && this.stoppedAt < e)
      throw new RangeError("Can't move stoppedAt forward");
    this.stoppedAt = e;
  }
  // Returns an updated version of the given stack, or null if the
  // stack can't advance normally. When `split` and `stacks` are
  // given, stacks split off by ambiguous operations will be pushed to
  // `split`, or added to `stacks` if they move `pos` forward.
  advanceStack(e, n, r) {
    let o = e.pos, { parser: i } = this, s = si ? this.stackID(e) + " -> " : "";
    if (this.stoppedAt != null && o > this.stoppedAt)
      return e.forceReduce() ? e : null;
    if (this.fragments) {
      let c = e.curContext && e.curContext.tracker.strict, u = c ? e.curContext.hash : 0;
      for (let d = this.fragments.nodeAt(o); d; ) {
        let f = this.parser.nodeSet.types[d.type.id] == d.type ? i.getGoto(e.state, d.type.id) : -1;
        if (f > -1 && d.length && (!c || (d.prop(Dt.contextHash) || 0) == u))
          return e.useNode(d, f), si && console.log(s + this.stackID(e) + ` (via reuse of ${i.getName(d.type.id)})`), !0;
        if (!(d instanceof Jr) || d.children.length == 0 || d.positions[0] > 0)
          break;
        let h = d.children[0];
        if (h instanceof Jr && d.positions[0] == 0)
          d = h;
        else
          break;
      }
    }
    let a = i.stateSlot(
      e.state,
      4
      /* ParseState.DefaultReduce */
    );
    if (a > 0)
      return e.reduce(a), si && console.log(s + this.stackID(e) + ` (via always-reduce ${i.getName(
        a & 65535
        /* Action.ValueMask */
      )})`), !0;
    if (e.stack.length >= 8400)
      for (; e.stack.length > 6e3 && e.forceReduce(); )
        ;
    let l = this.tokens.getActions(e);
    for (let c = 0; c < l.length; ) {
      let u = l[c++], d = l[c++], f = l[c++], h = c == l.length || !r, p = h ? e : e.split(), m = this.tokens.mainToken;
      if (p.apply(u, d, m ? m.start : p.pos, f), si && console.log(s + this.stackID(p) + ` (via ${(u & 65536) == 0 ? "shift" : `reduce of ${i.getName(
        u & 65535
        /* Action.ValueMask */
      )}`} for ${i.getName(d)} @ ${o}${p == e ? "" : ", split"})`), h)
        return !0;
      p.pos > o ? n.push(p) : r.push(p);
    }
    return !1;
  }
  // Advance a given stack forward as far as it will go. Returns the
  // (possibly updated) stack if it got stuck, or null if it moved
  // forward and was given to `pushStackDedup`.
  advanceFully(e, n) {
    let r = e.pos;
    for (; ; ) {
      if (!this.advanceStack(e, null, null))
        return !1;
      if (e.pos > r)
        return Xz(e, n), !0;
    }
  }
  runRecovery(e, n, r) {
    let o = null, i = !1;
    for (let s = 0; s < e.length; s++) {
      let a = e[s], l = n[s << 1], c = n[(s << 1) + 1], u = si ? this.stackID(a) + " -> " : "";
      if (a.deadEnd && (i || (i = !0, a.restart(), si && console.log(u + this.stackID(a) + " (restarted)"), this.advanceFully(a, r))))
        continue;
      let d = a.split(), f = u;
      for (let h = 0; d.forceReduce() && h < 10 && (si && console.log(f + this.stackID(d) + " (via force-reduce)"), !this.advanceFully(d, r)); h++)
        si && (f = this.stackID(d) + " -> ");
      for (let h of a.recoverByInsert(l))
        si && console.log(u + this.stackID(h) + " (via recover-insert)"), this.advanceFully(h, r);
      this.stream.end > a.pos ? (c == a.pos && (c++, l = 0), a.recoverByDelete(l, c), si && console.log(u + this.stackID(a) + ` (via recover-delete ${this.parser.getName(l)})`), Xz(a, r)) : (!o || o.score < a.score) && (o = a);
    }
    return o;
  }
  // Convert the stack's buffer to a syntax tree.
  stackToTree(e) {
    return e.close(), Jr.build({
      buffer: eqe.create(e),
      nodeSet: this.parser.nodeSet,
      topID: this.topTerm,
      maxBufferLength: this.parser.bufferLength,
      reused: this.reused,
      start: this.ranges[0].from,
      length: e.pos - this.ranges[0].from,
      minRepeatType: this.parser.minRepeatTerm
    });
  }
  stackID(e) {
    let n = (wk || (wk = /* @__PURE__ */ new WeakMap())).get(e);
    return n || wk.set(e, n = String.fromCodePoint(this.nextStackID++)), n + e;
  }
}
function Xz(t, e) {
  for (let n = 0; n < e.length; n++) {
    let r = e[n];
    if (r.pos == t.pos && r.sameState(t)) {
      e[n].score < t.score && (e[n] = t);
      return;
    }
  }
  e.push(t);
}
class aqe {
  constructor(e, n, r) {
    this.source = e, this.flags = n, this.disabled = r;
  }
  allows(e) {
    return !this.disabled || this.disabled[e] == 0;
  }
}
const xk = (t) => t;
class lqe {
  /**
  Define a context tracker.
  */
  constructor(e) {
    this.start = e.start, this.shift = e.shift || xk, this.reduce = e.reduce || xk, this.reuse = e.reuse || xk, this.hash = e.hash || (() => 0), this.strict = e.strict !== !1;
  }
}
class iy extends Kde {
  /**
  @internal
  */
  constructor(e) {
    if (super(), this.wrappers = [], e.version != 14)
      throw new RangeError(`Parser version (${e.version}) doesn't match runtime version (14)`);
    let n = e.nodeNames.split(" ");
    this.minRepeatTerm = n.length;
    for (let a = 0; a < e.repeatNodeCount; a++)
      n.push("");
    let r = Object.keys(e.topRules).map((a) => e.topRules[a][1]), o = [];
    for (let a = 0; a < n.length; a++)
      o.push([]);
    function i(a, l, c) {
      o[a].push([l, l.deserialize(String(c))]);
    }
    if (e.nodeProps)
      for (let a of e.nodeProps) {
        let l = a[0];
        typeof l == "string" && (l = Dt[l]);
        for (let c = 1; c < a.length; ) {
          let u = a[c++];
          if (u >= 0)
            i(u, l, a[c++]);
          else {
            let d = a[c + -u];
            for (let f = -u; f > 0; f--)
              i(a[c++], l, d);
            c++;
          }
        }
      }
    this.nodeSet = new dL(n.map((a, l) => es.define({
      name: l >= this.minRepeatTerm ? void 0 : a,
      id: l,
      props: o[l],
      top: r.indexOf(l) > -1,
      error: l == 0,
      skipped: e.skippedNodes && e.skippedNodes.indexOf(l) > -1
    }))), e.propSources && (this.nodeSet = this.nodeSet.extend(...e.propSources)), this.strict = !1, this.bufferLength = Ude;
    let s = Wb(e.tokenData);
    this.context = e.context, this.specializerSpecs = e.specialized || [], this.specialized = new Uint16Array(this.specializerSpecs.length);
    for (let a = 0; a < this.specializerSpecs.length; a++)
      this.specialized[a] = this.specializerSpecs[a].term;
    this.specializers = this.specializerSpecs.map(Qz), this.states = Wb(e.states, Uint32Array), this.data = Wb(e.stateData), this.goto = Wb(e.goto), this.maxTerm = e.maxTerm, this.tokenizers = e.tokenizers.map((a) => typeof a == "number" ? new _h(s, a) : a), this.topRules = e.topRules, this.dialects = e.dialects || {}, this.dynamicPrecedences = e.dynamicPrecedences || null, this.tokenPrecTable = e.tokenPrec, this.termNames = e.termNames || null, this.maxNode = this.nodeSet.types.length - 1, this.dialect = this.parseDialect(), this.top = this.topRules[Object.keys(this.topRules)[0]];
  }
  createParse(e, n, r) {
    let o = new sqe(this, e, n, r);
    for (let i of this.wrappers)
      o = i(o, e, n, r);
    return o;
  }
  /**
  Get a goto table entry @internal
  */
  getGoto(e, n, r = !1) {
    let o = this.goto;
    if (n >= o[0])
      return -1;
    for (let i = o[n + 1]; ; ) {
      let s = o[i++], a = s & 1, l = o[i++];
      if (a && r)
        return l;
      for (let c = i + (s >> 1); i < c; i++)
        if (o[i] == e)
          return l;
      if (a)
        return -1;
    }
  }
  /**
  Check if this state has an action for a given terminal @internal
  */
  hasAction(e, n) {
    let r = this.data;
    for (let o = 0; o < 2; o++)
      for (let i = this.stateSlot(
        e,
        o ? 2 : 1
        /* ParseState.Actions */
      ), s; ; i += 3) {
        if ((s = r[i]) == 65535)
          if (r[i + 1] == 1)
            s = r[i = fl(r, i + 2)];
          else {
            if (r[i + 1] == 2)
              return fl(r, i + 2);
            break;
          }
        if (s == n || s == 0)
          return fl(r, i + 1);
      }
    return 0;
  }
  /**
  @internal
  */
  stateSlot(e, n) {
    return this.states[e * 6 + n];
  }
  /**
  @internal
  */
  stateFlag(e, n) {
    return (this.stateSlot(
      e,
      0
      /* ParseState.Flags */
    ) & n) > 0;
  }
  /**
  @internal
  */
  validAction(e, n) {
    return !!this.allActions(e, (r) => r == n ? !0 : null);
  }
  /**
  @internal
  */
  allActions(e, n) {
    let r = this.stateSlot(
      e,
      4
      /* ParseState.DefaultReduce */
    ), o = r ? n(r) : void 0;
    for (let i = this.stateSlot(
      e,
      1
      /* ParseState.Actions */
    ); o == null; i += 3) {
      if (this.data[i] == 65535)
        if (this.data[i + 1] == 1)
          i = fl(this.data, i + 2);
        else
          break;
      o = n(fl(this.data, i + 1));
    }
    return o;
  }
  /**
  Get the states that can follow this one through shift actions or
  goto jumps. @internal
  */
  nextStates(e) {
    let n = [];
    for (let r = this.stateSlot(
      e,
      1
      /* ParseState.Actions */
    ); ; r += 3) {
      if (this.data[r] == 65535)
        if (this.data[r + 1] == 1)
          r = fl(this.data, r + 2);
        else
          break;
      if ((this.data[r + 2] & 1) == 0) {
        let o = this.data[r + 1];
        n.some((i, s) => s & 1 && i == o) || n.push(this.data[r], o);
      }
    }
    return n;
  }
  /**
  Configure the parser. Returns a new parser instance that has the
  given settings modified. Settings not provided in `config` are
  kept from the original parser.
  */
  configure(e) {
    let n = Object.assign(Object.create(iy.prototype), this);
    if (e.props && (n.nodeSet = this.nodeSet.extend(...e.props)), e.top) {
      let r = this.topRules[e.top];
      if (!r)
        throw new RangeError(`Invalid top rule name ${e.top}`);
      n.top = r;
    }
    return e.tokenizers && (n.tokenizers = this.tokenizers.map((r) => {
      let o = e.tokenizers.find((i) => i.from == r);
      return o ? o.to : r;
    })), e.specializers && (n.specializers = this.specializers.slice(), n.specializerSpecs = this.specializerSpecs.map((r, o) => {
      let i = e.specializers.find((a) => a.from == r.external);
      if (!i)
        return r;
      let s = Object.assign(Object.assign({}, r), { external: i.to });
      return n.specializers[o] = Qz(s), s;
    })), e.contextTracker && (n.context = e.contextTracker), e.dialect && (n.dialect = this.parseDialect(e.dialect)), e.strict != null && (n.strict = e.strict), e.wrap && (n.wrappers = n.wrappers.concat(e.wrap)), e.bufferLength != null && (n.bufferLength = e.bufferLength), n;
  }
  /**
  Tells you whether any [parse wrappers](#lr.ParserConfig.wrap)
  are registered for this parser.
  */
  hasWrappers() {
    return this.wrappers.length > 0;
  }
  /**
  Returns the name associated with a given term. This will only
  work for all terms when the parser was generated with the
  `--names` option. By default, only the names of tagged terms are
  stored.
  */
  getName(e) {
    return this.termNames ? this.termNames[e] : String(e <= this.maxNode && this.nodeSet.types[e].name || e);
  }
  /**
  The eof term id is always allocated directly after the node
  types. @internal
  */
  get eofTerm() {
    return this.maxNode + 1;
  }
  /**
  The type of top node produced by the parser.
  */
  get topNode() {
    return this.nodeSet.types[this.top[1]];
  }
  /**
  @internal
  */
  dynamicPrecedence(e) {
    let n = this.dynamicPrecedences;
    return n == null ? 0 : n[e] || 0;
  }
  /**
  @internal
  */
  parseDialect(e) {
    let n = Object.keys(this.dialects), r = n.map(() => !1);
    if (e)
      for (let i of e.split(" ")) {
        let s = n.indexOf(i);
        s >= 0 && (r[s] = !0);
      }
    let o = null;
    for (let i = 0; i < n.length; i++)
      if (!r[i])
        for (let s = this.dialects[n[i]], a; (a = this.data[s++]) != 65535; )
          (o || (o = new Uint8Array(this.maxTerm + 1)))[a] = 1;
    return new aqe(e, r, o);
  }
  /**
  Used by the output of the parser generator. Not available to
  user code. @hide
  */
  static deserialize(e) {
    return new iy(e);
  }
}
function fl(t, e) {
  return t[e] | t[e + 1] << 16;
}
function cqe(t) {
  let e = null;
  for (let n of t) {
    let r = n.p.stoppedAt;
    (n.pos == n.p.stream.end || r != null && n.pos > r) && n.p.parser.stateFlag(
      n.state,
      2
      /* StateFlag.Accepting */
    ) && (!e || e.score < n.score) && (e = n);
  }
  return e;
}
function Qz(t) {
  if (t.external) {
    let e = t.extend ? 1 : 0;
    return (n, r) => t.external(n, r) << 1 | e;
  }
  return t.get;
}
const uqe = mL({
  String: le.string,
  Number: le.number,
  "True False": le.bool,
  PropertyName: le.propertyName,
  Null: le.null,
  ", :": le.separator,
  "[ ]": le.squareBracket,
  "{ }": le.brace
});
iy.deserialize({
  version: 14,
  states: "$bOVQPOOOOQO'#Cb'#CbOnQPO'#CeOvQPO'#ClOOQO'#Cr'#CrQOQPOOOOQO'#Cg'#CgO}QPO'#CfO!SQPO'#CtOOQO,59P,59PO![QPO,59PO!aQPO'#CuOOQO,59W,59WO!iQPO,59WOVQPO,59QOqQPO'#CmO!nQPO,59`OOQO1G.k1G.kOVQPO'#CnO!vQPO,59aOOQO1G.r1G.rOOQO1G.l1G.lOOQO,59X,59XOOQO-E6k-E6kOOQO,59Y,59YOOQO-E6l-E6l",
  stateData: "#O~OeOS~OQSORSOSSOTSOWQO_ROgPO~OVXOgUO~O^[O~PVO[^O~O]_OVhX~OVaO~O]bO^iX~O^dO~O]_OVha~O]bO^ia~O",
  goto: "!kjPPPPPPkPPkqwPPPPk{!RPPP!XP!e!hXSOR^bQWQRf_TVQ_Q`WRg`QcZRicQTOQZRQe^RhbRYQR]R",
  nodeNames: "⚠ JsonText True False Null Number String } { Object Property PropertyName : , ] [ Array",
  maxTerm: 25,
  nodeProps: [
    ["isolate", -2, 6, 11, ""],
    ["openedBy", 7, "{", 14, "["],
    ["closedBy", 8, "}", 15, "]"]
  ],
  propSources: [uqe],
  skippedNodes: [0],
  repeatNodeCount: 2,
  tokenData: "(|~RaXY!WYZ!W]^!Wpq!Wrs!]|}$u}!O$z!Q!R%T!R![&c![!]&t!}#O&y#P#Q'O#Y#Z'T#b#c'r#h#i(Z#o#p(r#q#r(w~!]Oe~~!`Wpq!]qr!]rs!xs#O!]#O#P!}#P;'S!];'S;=`$o<%lO!]~!}Og~~#QXrs!]!P!Q!]#O#P!]#U#V!]#Y#Z!]#b#c!]#f#g!]#h#i!]#i#j#m~#pR!Q![#y!c!i#y#T#Z#y~#|R!Q![$V!c!i$V#T#Z$V~$YR!Q![$c!c!i$c#T#Z$c~$fR!Q![!]!c!i!]#T#Z!]~$rP;=`<%l!]~$zO]~~$}Q!Q!R%T!R![&c~%YRT~!O!P%c!g!h%w#X#Y%w~%fP!Q![%i~%nRT~!Q![%i!g!h%w#X#Y%w~%zR{|&T}!O&T!Q![&Z~&WP!Q![&Z~&`PT~!Q![&Z~&hST~!O!P%c!Q![&c!g!h%w#X#Y%w~&yO[~~'OO_~~'TO^~~'WP#T#U'Z~'^P#`#a'a~'dP#g#h'g~'jP#X#Y'm~'rOR~~'uP#i#j'x~'{P#`#a(O~(RP#`#a(U~(ZOS~~(^P#f#g(a~(dP#i#j(g~(jP#X#Y(m~(rOQ~~(wOW~~(|OV~",
  tokenizers: [0],
  topRules: { JsonText: [0, 1] },
  tokenPrec: 0
});
const Nf = 63, Zz = 64, dqe = 1, fqe = 2, bhe = 3, hqe = 4, _he = 5, pqe = 6, mqe = 7, whe = 65, gqe = 66, yqe = 8, vqe = 9, bqe = 10, _qe = 11, wqe = 12, xhe = 13, xqe = 19, Eqe = 20, Sqe = 29, Oqe = 33, Cqe = 34, kqe = 47, Aqe = 0, TL = 1, NN = 2, sy = 3, jN = 4;
class Qu {
  constructor(e, n, r) {
    this.parent = e, this.depth = n, this.type = r, this.hash = (e ? e.hash + e.hash << 8 : 0) + n + (n << 4) + r;
  }
}
Qu.top = new Qu(null, -1, Aqe);
function i0(t, e) {
  for (let n = 0, r = e - t.pos - 1; ; r--, n++) {
    let o = t.peek(r);
    if (jl(o) || o == -1) return n;
  }
}
function LN(t) {
  return t == 32 || t == 9;
}
function jl(t) {
  return t == 10 || t == 13;
}
function Ehe(t) {
  return LN(t) || jl(t);
}
function id(t) {
  return t < 0 || Ehe(t);
}
const Tqe = new lqe({
  start: Qu.top,
  reduce(t, e) {
    return t.type == sy && (e == Eqe || e == Cqe) ? t.parent : t;
  },
  shift(t, e, n, r) {
    if (e == bhe)
      return new Qu(t, i0(r, r.pos), TL);
    if (e == whe || e == _he)
      return new Qu(t, i0(r, r.pos), NN);
    if (e == Nf)
      return t.parent;
    if (e == xqe || e == Oqe)
      return new Qu(t, 0, sy);
    if (e == xhe && t.type == jN)
      return t.parent;
    if (e == kqe) {
      let o = /[1-9]/.exec(r.read(r.pos, n.pos));
      if (o) return new Qu(t, t.depth + +o[0], jN);
    }
    return t;
  },
  hash(t) {
    return t.hash;
  }
});
function ep(t, e, n = 0) {
  return t.peek(n) == e && t.peek(n + 1) == e && t.peek(n + 2) == e && id(t.peek(n + 3));
}
const Rqe = new FS((t, e) => {
  if (t.next == -1 && e.canShift(Zz))
    return t.acceptToken(Zz);
  let n = t.peek(-1);
  if ((jl(n) || n < 0) && e.context.type != sy) {
    if (ep(
      t,
      45
      /* '-' */
    ))
      if (e.canShift(Nf)) t.acceptToken(Nf);
      else return t.acceptToken(dqe, 3);
    if (ep(
      t,
      46
      /* '.' */
    ))
      if (e.canShift(Nf)) t.acceptToken(Nf);
      else return t.acceptToken(fqe, 3);
    let r = 0;
    for (; t.next == 32; )
      r++, t.advance();
    (r < e.context.depth || r == e.context.depth && e.context.type == TL && (t.next != 45 || !id(t.peek(1)))) && // Not blank
    t.next != -1 && !jl(t.next) && t.next != 35 && t.acceptToken(Nf, -r);
  }
}, { contextual: !0 }), Pqe = new FS((t, e) => {
  if (e.context.type == sy) {
    t.next == 63 && (t.advance(), id(t.next) && t.acceptToken(mqe));
    return;
  }
  if (t.next == 45)
    t.advance(), id(t.next) && t.acceptToken(e.context.type == TL && e.context.depth == i0(t, t.pos - 1) ? hqe : bhe);
  else if (t.next == 63)
    t.advance(), id(t.next) && t.acceptToken(e.context.type == NN && e.context.depth == i0(t, t.pos - 1) ? pqe : _he);
  else {
    let n = t.pos;
    for (; ; )
      if (LN(t.next)) {
        if (t.pos == n) return;
        t.advance();
      } else if (t.next == 33)
        She(t);
      else if (t.next == 38)
        FN(t);
      else if (t.next == 42) {
        FN(t);
        break;
      } else if (t.next == 39 || t.next == 34) {
        if (RL(t, !0)) break;
        return;
      } else if (t.next == 91 || t.next == 123) {
        if (!Mqe(t)) return;
        break;
      } else {
        Ohe(t, !0, !1, 0);
        break;
      }
    for (; LN(t.next); ) t.advance();
    if (t.next == 58) {
      if (t.pos == n && e.canShift(Sqe)) return;
      let r = t.peek(1);
      id(r) && t.acceptTokenTo(e.context.type == NN && e.context.depth == i0(t, n) ? gqe : whe, n);
    }
  }
}, { contextual: !0 });
function $qe(t) {
  return t > 32 && t < 127 && t != 34 && t != 37 && t != 44 && t != 60 && t != 62 && t != 92 && t != 94 && t != 96 && t != 123 && t != 124 && t != 125;
}
function Jz(t) {
  return t >= 48 && t <= 57 || t >= 97 && t <= 102 || t >= 65 && t <= 70;
}
function eq(t, e) {
  return t.next == 37 ? (t.advance(), Jz(t.next) && t.advance(), Jz(t.next) && t.advance(), !0) : $qe(t.next) || e && t.next == 44 ? (t.advance(), !0) : !1;
}
function She(t) {
  if (t.advance(), t.next == 60) {
    for (t.advance(); ; )
      if (!eq(t, !0)) {
        t.next == 62 && t.advance();
        break;
      }
  } else
    for (; eq(t, !1); )
      ;
}
function FN(t) {
  for (t.advance(); !id(t.next) && zx(t.tag) != "f"; ) t.advance();
}
function RL(t, e) {
  let n = t.next, r = !1, o = t.pos;
  for (t.advance(); ; ) {
    let i = t.next;
    if (i < 0) break;
    if (t.advance(), i == n)
      if (i == 39)
        if (t.next == 39) t.advance();
        else break;
      else
        break;
    else if (i == 92 && n == 34)
      t.next >= 0 && t.advance();
    else if (jl(i)) {
      if (e) return !1;
      r = !0;
    } else if (e && t.pos >= o + 1024)
      return !1;
  }
  return !r;
}
function Mqe(t) {
  for (let e = [], n = t.pos + 1024; ; )
    if (t.next == 91 || t.next == 123)
      e.push(t.next), t.advance();
    else if (t.next == 39 || t.next == 34) {
      if (!RL(t, !0)) return !1;
    } else if (t.next == 93 || t.next == 125) {
      if (e[e.length - 1] != t.next - 2) return !1;
      if (e.pop(), t.advance(), !e.length) return !0;
    } else {
      if (t.next < 0 || t.pos > n || jl(t.next))
        return !1;
      t.advance();
    }
}
const Dqe = "iiisiiissisfissssssssssssisssiiissssssssssssssssssssssssssfsfssissssssssssssssssssssssssssfif";
function zx(t) {
  return t < 33 ? "u" : t > 125 ? "s" : Dqe[t - 33];
}
function Ek(t, e) {
  let n = zx(t);
  return n != "u" && !(e && n == "f");
}
function Ohe(t, e, n, r) {
  if (zx(t.next) == "s" || (t.next == 63 || t.next == 58 || t.next == 45) && Ek(t.peek(1), n))
    t.advance();
  else
    return !1;
  let o = t.pos;
  for (; ; ) {
    let i = t.next, s = 0, a = r + 1;
    for (; Ehe(i); ) {
      if (jl(i)) {
        if (e) return !1;
        a = 0;
      } else
        a++;
      i = t.peek(++s);
    }
    if (!(i >= 0 && (i == 58 ? Ek(t.peek(s + 1), n) : i == 35 ? t.peek(s - 1) != 32 : Ek(i, n))) || !n && a <= r || a == 0 && !n && (ep(t, 45, s) || ep(t, 46, s)))
      break;
    if (e && zx(i) == "f") return !1;
    for (let l = s; l >= 0; l--) t.advance();
    if (e && t.pos > o + 1024) return !1;
  }
  return !0;
}
const Iqe = new FS((t, e) => {
  if (t.next == 33)
    She(t), t.acceptToken(wqe);
  else if (t.next == 38 || t.next == 42) {
    let n = t.next == 38 ? bqe : _qe;
    FN(t), t.acceptToken(n);
  } else t.next == 39 || t.next == 34 ? (RL(t, !1), t.acceptToken(vqe)) : Ohe(t, !1, e.context.type == sy, e.context.depth) && t.acceptToken(yqe);
}), Nqe = new FS((t, e) => {
  let n = e.context.type == jN ? e.context.depth : -1, r = t.pos;
  e: for (; ; ) {
    let o = 0, i = t.next;
    for (; i == 32; ) i = t.peek(++o);
    if (!o && (ep(t, 45, o) || ep(t, 46, o)) || !jl(i) && (n < 0 && (n = Math.max(e.context.depth + 1, o)), o < n))
      break;
    for (; ; ) {
      if (t.next < 0) break e;
      let s = jl(t.next);
      if (t.advance(), s) continue e;
      r = t.pos;
    }
  }
  t.acceptTokenTo(xhe, r);
}), jqe = mL({
  DirectiveName: le.keyword,
  DirectiveContent: le.attributeValue,
  "DirectiveEnd DocEnd": le.meta,
  QuotedLiteral: le.string,
  BlockLiteralHeader: le.special(le.string),
  BlockLiteralContent: le.content,
  Literal: le.content,
  "Key/Literal Key/QuotedLiteral": le.definition(le.propertyName),
  "Anchor Alias": le.labelName,
  Tag: le.typeName,
  Comment: le.lineComment,
  ": , -": le.separator,
  "?": le.punctuation,
  "[ ]": le.squareBracket,
  "{ }": le.brace
});
iy.deserialize({
  version: 14,
  states: "5lQ!ZQgOOO#PQfO'#CpO#uQfO'#DOOOQR'#Dv'#DvO$qQgO'#DRO%gQdO'#DUO%nQgO'#DUO&ROaO'#D[OOQR'#Du'#DuO&{QgO'#D^O'rQgO'#D`OOQR'#Dt'#DtO(iOqO'#DbOOQP'#Dj'#DjO(zQaO'#CmO)YQgO'#CmOOQP'#Cm'#CmQ)jQaOOQ)uQgOOQ]QgOOO*PQdO'#CrO*nQdO'#CtOOQO'#Dw'#DwO+]Q`O'#CxO+hQdO'#CwO+rQ`O'#CwOOQO'#Cv'#CvO+wQdO'#CvOOQO'#Cq'#CqO,UQ`O,59[O,^QfO,59[OOQR,59[,59[OOQO'#Cx'#CxO,eQ`O'#DPO,pQdO'#DPOOQO'#Dx'#DxO,zQdO'#DxO-XQ`O,59jO-aQfO,59jOOQR,59j,59jOOQR'#DS'#DSO-hQcO,59mO-sQgO'#DVO.TQ`O'#DVO.YQcO,59pOOQR'#DX'#DXO#|QfO'#DWO.hQcO'#DWOOQR,59v,59vO.yOWO,59vO/OOaO,59vO/WOaO,59vO/cQgO'#D_OOQR,59x,59xO0VQgO'#DaOOQR,59z,59zOOQP,59|,59|O0yOaO,59|O1ROaO,59|O1aOqO,59|OOQP-E7h-E7hO1oQgO,59XOOQP,59X,59XO2PQaO'#DeO2_QgO'#DeO2oQgO'#DkOOQP'#Dk'#DkQ)jQaOOO3PQdO'#CsOOQO,59^,59^O3kQdO'#CuOOQO,59`,59`OOQO,59c,59cO4VQdO,59cO4aQdO'#CzO4kQ`O'#CzOOQO,59b,59bOOQU,5:Q,5:QOOQR1G.v1G.vO4pQ`O1G.vOOQU-E7d-E7dO4xQdO,59kOOQO,59k,59kO5SQdO'#DQO5^Q`O'#DQOOQO,5:d,5:dOOQU,5:R,5:ROOQR1G/U1G/UO5cQ`O1G/UOOQU-E7e-E7eO5kQgO'#DhO5xQcO1G/XOOQR1G/X1G/XOOQR,59q,59qO6TQgO,59qO6eQdO'#DiO6lQgO'#DiO7PQcO1G/[OOQR1G/[1G/[OOQR,59r,59rO#|QfO,59rOOQR1G/b1G/bO7_OWO1G/bO7dOaO1G/bOOQR,59y,59yOOQR,59{,59{OOQP1G/h1G/hO7lOaO1G/hO7tOaO1G/hO8POaO1G/hOOQP1G.s1G.sO8_QgO,5:POOQP,5:P,5:POOQP,5:V,5:VOOQP-E7i-E7iOOQO,59_,59_OOQO,59a,59aOOQO1G.}1G.}OOQO,59f,59fO8oQdO,59fOOQR7+$b7+$bP,XQ`O'#DfOOQO1G/V1G/VOOQO,59l,59lO8yQdO,59lOOQR7+$p7+$pP9TQ`O'#DgOOQR'#DT'#DTOOQR,5:S,5:SOOQR-E7f-E7fOOQR7+$s7+$sOOQR1G/]1G/]O9YQgO'#DYO9jQ`O'#DYOOQR,5:T,5:TO#|QfO'#DZO9oQcO'#DZOOQR-E7g-E7gOOQR7+$v7+$vOOQR1G/^1G/^OOQR7+$|7+$|O:QOWO7+$|OOQP7+%S7+%SO:VOaO7+%SO:_OaO7+%SOOQP1G/k1G/kOOQO1G/Q1G/QOOQO1G/W1G/WOOQR,59t,59tO:jQgO,59tOOQR,59u,59uO#|QfO,59uOOQR<<Hh<<HhOOQP<<Hn<<HnO:zOaO<<HnOOQR1G/`1G/`OOQR1G/a1G/aOOQPAN>YAN>Y",
  stateData: ";S~O!fOS!gOS^OS~OP_OQbORSOTUOWROXROYYOZZO[XOcPOqQO!PVO!V[O!cTO~O`cO~P]OVkOWROXROYeOZfO[dOcPOmhOqQO~OboO~P!bOVtOWROXROYeOZfO[dOcPOmrOqQO~OpwO~P#WORSOTUOWROXROYYOZZO[XOcPOqQO!PVO!cTO~OSvP!avP!bvP~P#|OWROXROYeOZfO[dOcPOqQO~OmzO~P%OOm!OOUzP!azP!bzP!dzP~P#|O^!SO!b!QO!f!TO!g!RO~ORSOTUOWROXROcPOqQO!PVO!cTO~OY!UOP!QXQ!QX!V!QX!`!QXS!QX!a!QX!b!QXU!QXm!QX!d!QX~P&aO[!WOP!SXQ!SX!V!SX!`!SXS!SX!a!SX!b!SXU!SXm!SX!d!SX~P&aO^!ZO!W![O!b!YO!f!]O!g!YO~OP!_O!V[OQaX!`aX~OPaXQaX!VaX!`aX~P#|OP!bOQ!cO!V[O~OP_O!V[O~P#|OWROXROY!fOcPOqQObfXmfXofXpfX~OWROXRO[!hOcPOqQObhXmhXohXphX~ObeXmlXoeX~ObkXokX~P%OOm!kO~Om!lObnPonP~P%OOb!pOo!oO~Ob!pO~P!bOm!sOosXpsX~OosXpsX~P%OOm!uOotPptP~P%OOo!xOp!yO~Op!yO~P#WOS!|O!a#OO!b#OO~OUyX!ayX!byX!dyX~P#|Om#QO~OU#SO!a#UO!b#UO!d#RO~Om#WOUzX!azX!bzX!dzX~O]#XO~O!b#XO!g#YO~O^#ZO!b#XO!g#YO~OP!RXQ!RX!V!RX!`!RXS!RX!a!RX!b!RXU!RXm!RX!d!RX~P&aOP!TXQ!TX!V!TX!`!TXS!TX!a!TX!b!TXU!TXm!TX!d!TX~P&aO!b#^O!g#^O~O^#_O!b#^O!f#`O!g#^O~O^#_O!W#aO!b#^O!g#^O~OPaaQaa!Vaa!`aa~P#|OP#cO!V[OQ!XX!`!XX~OP!XXQ!XX!V!XX!`!XX~P#|OP_O!V[OQ!_X!`!_X~P#|OWROXROcPOqQObgXmgXogXpgX~OWROXROcPOqQObiXmiXoiXpiX~Obkaoka~P%OObnXonX~P%OOm#kO~Ob#lOo!oO~Oosapsa~P%OOotXptX~P%OOm#pO~Oo!xOp#qO~OSwP!awP!bwP~P#|OS!|O!a#vO!b#vO~OUya!aya!bya!dya~P#|Om#xO~P%OOm#{OU}P!a}P!b}P!d}P~P#|OU#SO!a$OO!b$OO!d#RO~O]$QO~O!b$QO!g$RO~O!b$SO!g$SO~O^$TO!b$SO!g$SO~O^$TO!b$SO!f$UO!g$SO~OP!XaQ!Xa!V!Xa!`!Xa~P#|Obnaona~P%OOotapta~P%OOo!xO~OU|X!a|X!b|X!d|X~P#|Om$ZO~Om$]OU}X!a}X!b}X!d}X~O]$^O~O!b$_O!g$_O~O^$`O!b$_O!g$_O~OU|a!a|a!b|a!d|a~P#|O!b$cO!g$cO~O",
  goto: ",]!mPPPPPPPPPPPPPPPPP!nPP!v#v#|$`#|$c$f$j$nP%VPPP!v%Y%^%a%{&O%a&R&U&X&_&b%aP&e&{&e'O'RPP']'a'g'm's'y(XPPPPPPPP(_)e*X+c,VUaObcR#e!c!{ROPQSTUXY_bcdehknrtvz!O!U!W!_!b!c!f!h!k!l!s!u!|#Q#R#S#W#c#k#p#x#{$Z$]QmPR!qnqfPQThknrtv!k!l!s!u#R#k#pR!gdR!ieTlPnTjPnSiPnSqQvQ{TQ!mkQ!trQ!vtR#y#RR!nkTsQvR!wt!RWOSUXY_bcz!O!U!W!_!b!c!|#Q#S#W#c#x#{$Z$]RySR#t!|R|TR|UQ!PUR#|#SR#z#RR#z#SyZOSU_bcz!O!_!b!c!|#Q#S#W#c#x#{$Z$]R!VXR!XYa]O^abc!a!c!eT!da!eQnPR!rnQvQR!{vQ!}yR#u!}Q#T|R#}#TW^Obc!cS!^^!aT!aa!eQ!eaR#f!eW`Obc!cQxSS}U#SQ!`_Q#PzQ#V!OQ#b!_Q#d!bQ#s!|Q#w#QQ$P#WQ$V#cQ$Y#xQ$[#{Q$a$ZR$b$]xZOSU_bcz!O!_!b!c!|#Q#S#W#c#x#{$Z$]Q!VXQ!XYQ#[!UR#]!W!QWOSUXY_bcz!O!U!W!_!b!c!|#Q#S#W#c#x#{$Z$]pfPQThknrtv!k!l!s!u#R#k#pQ!gdQ!ieQ#g!fR#h!hSgPn^pQTkrtv#RQ!jhQ#i!kQ#j!lQ#n!sQ#o!uQ$W#kR$X#pQuQR!zv",
  nodeNames: "⚠ DirectiveEnd DocEnd - - ? ? ? Literal QuotedLiteral Anchor Alias Tag BlockLiteralContent Comment Stream BOM Document ] [ FlowSequence Item Tagged Anchored Anchored Tagged FlowMapping Pair Key : Pair , } { FlowMapping Pair Pair BlockSequence Item Item BlockMapping Pair Pair Key Pair Pair BlockLiteral BlockLiteralHeader Tagged Anchored Anchored Tagged Directive DirectiveName DirectiveContent Document",
  maxTerm: 74,
  context: Tqe,
  nodeProps: [
    ["isolate", -3, 8, 9, 14, ""],
    ["openedBy", 18, "[", 32, "{"],
    ["closedBy", 19, "]", 33, "}"]
  ],
  propSources: [jqe],
  skippedNodes: [0],
  repeatNodeCount: 6,
  tokenData: "-Y~RnOX#PXY$QYZ$]Z]#P]^$]^p#Ppq$Qqs#Pst$btu#Puv$yv|#P|}&e}![#P![!]'O!]!`#P!`!a'i!a!}#P!}#O*g#O#P#P#P#Q+Q#Q#o#P#o#p+k#p#q'i#q#r,U#r;'S#P;'S;=`#z<%l?HT#P?HT?HU,o?HUO#PQ#UU!WQOY#PZp#Ppq#hq;'S#P;'S;=`#z<%lO#PQ#kTOY#PZs#Pt;'S#P;'S;=`#z<%lO#PQ#}P;=`<%l#P~$VQ!f~XY$Qpq$Q~$bO!g~~$gS^~OY$bZ;'S$b;'S;=`$s<%lO$b~$vP;=`<%l$bR%OX!WQOX%kXY#PZ]%k]^#P^p%kpq#hq;'S%k;'S;=`&_<%lO%kR%rX!WQ!VPOX%kXY#PZ]%k]^#P^p%kpq#hq;'S%k;'S;=`&_<%lO%kR&bP;=`<%l%kR&lUoP!WQOY#PZp#Ppq#hq;'S#P;'S;=`#z<%lO#PR'VUmP!WQOY#PZp#Ppq#hq;'S#P;'S;=`#z<%lO#PR'p[!PP!WQOY#PZp#Ppq#hq{#P{|(f|}#P}!O(f!O!R#P!R![)p![;'S#P;'S;=`#z<%lO#PR(mW!PP!WQOY#PZp#Ppq#hq!R#P!R![)V![;'S#P;'S;=`#z<%lO#PR)^U!PP!WQOY#PZp#Ppq#hq;'S#P;'S;=`#z<%lO#PR)wY!PP!WQOY#PZp#Ppq#hq{#P{|)V|}#P}!O)V!O;'S#P;'S;=`#z<%lO#PR*nUcP!WQOY#PZp#Ppq#hq;'S#P;'S;=`#z<%lO#PR+XUbP!WQOY#PZp#Ppq#hq;'S#P;'S;=`#z<%lO#PR+rUqP!WQOY#PZp#Ppq#hq;'S#P;'S;=`#z<%lO#PR,]UpP!WQOY#PZp#Ppq#hq;'S#P;'S;=`#z<%lO#PR,vU`P!WQOY#PZp#Ppq#hq;'S#P;'S;=`#z<%lO#P",
  tokenizers: [Rqe, Pqe, Iqe, Nqe, 0, 1],
  topRules: { Stream: [0, 15] },
  tokenPrec: 0
});
function Lqe(t) {
  Che(t, "start");
  var e = {}, n = t.languageData || {}, r = !1;
  for (var o in t) if (o != n && t.hasOwnProperty(o))
    for (var i = e[o] = [], s = t[o], a = 0; a < s.length; a++) {
      var l = s[a];
      i.push(new zqe(l, t)), (l.indent || l.dedent) && (r = !0);
    }
  return {
    name: n.name,
    startState: function() {
      return { state: "start", pending: null, indent: r ? [] : null };
    },
    copyState: function(c) {
      var u = { state: c.state, pending: c.pending, indent: c.indent && c.indent.slice(0) };
      return c.stack && (u.stack = c.stack.slice(0)), u;
    },
    token: qqe(e),
    indent: Uqe(e, n),
    languageData: n
  };
}
function Che(t, e) {
  if (!t.hasOwnProperty(e))
    throw new Error("Undefined state " + e + " in simple mode");
}
function Fqe(t, e) {
  if (!t) return /(?:)/;
  var n = "";
  return t instanceof RegExp ? (t.ignoreCase && (n = "i"), t = t.source) : t = String(t), new RegExp("^(?:" + t + ")", n);
}
function Bqe(t) {
  if (!t) return null;
  if (t.apply) return t;
  if (typeof t == "string") return t.replace(/\./g, " ");
  for (var e = [], n = 0; n < t.length; n++)
    e.push(t[n] && t[n].replace(/\./g, " "));
  return e;
}
function zqe(t, e) {
  (t.next || t.push) && Che(e, t.next || t.push), this.regex = Fqe(t.regex), this.token = Bqe(t.token), this.data = t;
}
function qqe(t) {
  return function(e, n) {
    if (n.pending) {
      var r = n.pending.shift();
      return n.pending.length == 0 && (n.pending = null), e.pos += r.text.length, r.token;
    }
    for (var o = t[n.state], i = 0; i < o.length; i++) {
      var s = o[i], a = (!s.data.sol || e.sol()) && e.match(s.regex);
      if (a) {
        s.data.next ? n.state = s.data.next : s.data.push ? ((n.stack || (n.stack = [])).push(n.state), n.state = s.data.push) : s.data.pop && n.stack && n.stack.length && (n.state = n.stack.pop()), s.data.indent && n.indent.push(e.indentation() + e.indentUnit), s.data.dedent && n.indent.pop();
        var l = s.token;
        if (l && l.apply && (l = l(a)), a.length > 2 && s.token && typeof s.token != "string") {
          n.pending = [];
          for (var c = 2; c < a.length; c++)
            a[c] && n.pending.push({ text: a[c], token: s.token[c - 1] });
          return e.backUp(a[0].length - (a[1] ? a[1].length : 0)), l[0];
        } else return l && l.join ? l[0] : l;
      }
    }
    return e.next(), null;
  };
}
function Uqe(t, e) {
  return function(n, r) {
    if (n.indent == null || e.dontIndentStates && e.doneIndentState.indexOf(n.state) > -1)
      return null;
    var o = n.indent.length - 1, i = t[n.state];
    e: for (; ; ) {
      for (var s = 0; s < i.length; s++) {
        var a = i[s];
        if (a.data.dedent && a.data.dedentIfLineStart !== !1) {
          var l = a.regex.exec(r);
          if (l && l[0]) {
            o--, (a.next || a.push) && (i = t[a.next || a.push]), r = r.slice(l[0].length);
            continue e;
          }
        }
      }
      break;
    }
    return o < 0 ? 0 : n.indent[o];
  };
}
var khe = "from", Hqe = new RegExp("^(\\s*)\\b(" + khe + ")\\b", "i"), Ahe = ["run", "cmd", "entrypoint", "shell"], Vqe = new RegExp("^(\\s*)(" + Ahe.join("|") + ")(\\s+\\[)", "i"), The = "expose", Wqe = new RegExp("^(\\s*)(" + The + ")(\\s+)", "i"), Gqe = [
  "arg",
  "from",
  "maintainer",
  "label",
  "env",
  "add",
  "copy",
  "volume",
  "user",
  "workdir",
  "onbuild",
  "stopsignal",
  "healthcheck",
  "shell"
], Yqe = [khe, The].concat(Ahe).concat(Gqe), Rhe = "(" + Yqe.join("|") + ")", Kqe = new RegExp("^(\\s*)" + Rhe + "(\\s*)(#.*)?$", "i"), Xqe = new RegExp("^(\\s*)" + Rhe + "(\\s+)", "i");
Lqe({
  start: [
    // Block comment: This is a line starting with a comment
    {
      regex: /^\s*#.*$/,
      sol: !0,
      token: "comment"
    },
    {
      regex: Hqe,
      token: [null, "keyword"],
      sol: !0,
      next: "from"
    },
    // Highlight an instruction without any arguments (for convenience)
    {
      regex: Kqe,
      token: [null, "keyword", null, "error"],
      sol: !0
    },
    {
      regex: Vqe,
      token: [null, "keyword", null],
      sol: !0,
      next: "array"
    },
    {
      regex: Wqe,
      token: [null, "keyword", null],
      sol: !0,
      next: "expose"
    },
    // Highlight an instruction followed by arguments
    {
      regex: Xqe,
      token: [null, "keyword", null],
      sol: !0,
      next: "arguments"
    },
    {
      regex: /./,
      token: null
    }
  ],
  from: [
    {
      regex: /\s*$/,
      token: null,
      next: "start"
    },
    {
      // Line comment without instruction arguments is an error
      regex: /(\s*)(#.*)$/,
      token: [null, "error"],
      next: "start"
    },
    {
      regex: /(\s*\S+\s+)(as)/i,
      token: [null, "keyword"],
      next: "start"
    },
    // Fail safe return to start
    {
      token: null,
      next: "start"
    }
  ],
  single: [
    {
      regex: /(?:[^\\']|\\.)/,
      token: "string"
    },
    {
      regex: /'/,
      token: "string",
      pop: !0
    }
  ],
  double: [
    {
      regex: /(?:[^\\"]|\\.)/,
      token: "string"
    },
    {
      regex: /"/,
      token: "string",
      pop: !0
    }
  ],
  array: [
    {
      regex: /\]/,
      token: null,
      next: "start"
    },
    {
      regex: /"(?:[^\\"]|\\.)*"?/,
      token: "string"
    }
  ],
  expose: [
    {
      regex: /\d+$/,
      token: "number",
      next: "start"
    },
    {
      regex: /[^\d]+$/,
      token: null,
      next: "start"
    },
    {
      regex: /\d+/,
      token: "number"
    },
    {
      regex: /[^\d]+/,
      token: null
    },
    // Fail safe return to start
    {
      token: null,
      next: "start"
    }
  ],
  arguments: [
    {
      regex: /^\s*#.*$/,
      sol: !0,
      token: "comment"
    },
    {
      regex: /"(?:[^\\"]|\\.)*"?$/,
      token: "string",
      next: "start"
    },
    {
      regex: /"/,
      token: "string",
      push: "double"
    },
    {
      regex: /'(?:[^\\']|\\.)*'?$/,
      token: "string",
      next: "start"
    },
    {
      regex: /'/,
      token: "string",
      push: "single"
    },
    {
      regex: /[^#"']+[\\`]$/,
      token: null
    },
    {
      regex: /[^#"']+$/,
      token: null,
      next: "start"
    },
    {
      regex: /[^#"']+/,
      token: null
    },
    // Fail safe return to start
    {
      token: null,
      next: "start"
    }
  ],
  languageData: {
    commentTokens: { line: "#" }
  }
});
var Qqe = {};
function PL(t, e) {
  for (var n = 0; n < e.length; n++)
    Qqe[e[n]] = t;
}
var Zqe = ["true", "false"], Jqe = [
  "if",
  "then",
  "do",
  "else",
  "elif",
  "while",
  "until",
  "for",
  "in",
  "esac",
  "fi",
  "fin",
  "fil",
  "done",
  "exit",
  "set",
  "unset",
  "export",
  "function"
], eUe = [
  "ab",
  "awk",
  "bash",
  "beep",
  "cat",
  "cc",
  "cd",
  "chown",
  "chmod",
  "chroot",
  "clear",
  "cp",
  "curl",
  "cut",
  "diff",
  "echo",
  "find",
  "gawk",
  "gcc",
  "get",
  "git",
  "grep",
  "hg",
  "kill",
  "killall",
  "ln",
  "ls",
  "make",
  "mkdir",
  "openssl",
  "mv",
  "nc",
  "nl",
  "node",
  "npm",
  "ping",
  "ps",
  "restart",
  "rm",
  "rmdir",
  "sed",
  "service",
  "sh",
  "shopt",
  "shred",
  "source",
  "sort",
  "sleep",
  "ssh",
  "start",
  "stop",
  "su",
  "sudo",
  "svn",
  "tee",
  "telnet",
  "top",
  "touch",
  "vi",
  "vim",
  "wall",
  "wc",
  "wget",
  "who",
  "write",
  "yes",
  "zsh"
];
PL("atom", Zqe);
PL("keyword", Jqe);
PL("builtin", eUe);
var BN = { exports: {} }, tUe = BN.exports, tq;
function nUe() {
  return tq || (tq = 1, function(t) {
    (function(e, n) {
      t.exports ? t.exports = n() : e.log = n();
    })(tUe, function() {
      var e = function() {
      }, n = "undefined", r = typeof window !== n && typeof window.navigator !== n && /Trident\/|MSIE /.test(window.navigator.userAgent), o = [
        "trace",
        "debug",
        "info",
        "warn",
        "error"
      ], i = {}, s = null;
      function a(m, g) {
        var y = m[g];
        if (typeof y.bind == "function")
          return y.bind(m);
        try {
          return Function.prototype.bind.call(y, m);
        } catch {
          return function() {
            return Function.prototype.apply.apply(y, [m, arguments]);
          };
        }
      }
      function l() {
        console.log && (console.log.apply ? console.log.apply(console, arguments) : Function.prototype.apply.apply(console.log, [console, arguments])), console.trace && console.trace();
      }
      function c(m) {
        return m === "debug" && (m = "log"), typeof console === n ? !1 : m === "trace" && r ? l : console[m] !== void 0 ? a(console, m) : console.log !== void 0 ? a(console, "log") : e;
      }
      function u() {
        for (var m = this.getLevel(), g = 0; g < o.length; g++) {
          var y = o[g];
          this[y] = g < m ? e : this.methodFactory(y, m, this.name);
        }
        if (this.log = this.debug, typeof console === n && m < this.levels.SILENT)
          return "No console available for logging";
      }
      function d(m) {
        return function() {
          typeof console !== n && (u.call(this), this[m].apply(this, arguments));
        };
      }
      function f(m, g, y) {
        return c(m) || d.apply(this, arguments);
      }
      function h(m, g) {
        var y = this, v, b, _, w = "loglevel";
        typeof m == "string" ? w += ":" + m : typeof m == "symbol" && (w = void 0);
        function x(P) {
          var N = (o[P] || "silent").toUpperCase();
          if (!(typeof window === n || !w)) {
            try {
              window.localStorage[w] = N;
              return;
            } catch {
            }
            try {
              window.document.cookie = encodeURIComponent(w) + "=" + N + ";";
            } catch {
            }
          }
        }
        function E() {
          var P;
          if (!(typeof window === n || !w)) {
            try {
              P = window.localStorage[w];
            } catch {
            }
            if (typeof P === n)
              try {
                var N = window.document.cookie, A = encodeURIComponent(w), O = N.indexOf(A + "=");
                O !== -1 && (P = /^([^;]+)/.exec(
                  N.slice(O + A.length + 1)
                )[1]);
              } catch {
              }
            return y.levels[P] === void 0 && (P = void 0), P;
          }
        }
        function S() {
          if (!(typeof window === n || !w)) {
            try {
              window.localStorage.removeItem(w);
            } catch {
            }
            try {
              window.document.cookie = encodeURIComponent(w) + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC";
            } catch {
            }
          }
        }
        function C(P) {
          var N = P;
          if (typeof N == "string" && y.levels[N.toUpperCase()] !== void 0 && (N = y.levels[N.toUpperCase()]), typeof N == "number" && N >= 0 && N <= y.levels.SILENT)
            return N;
          throw new TypeError("log.setLevel() called with invalid level: " + P);
        }
        y.name = m, y.levels = {
          TRACE: 0,
          DEBUG: 1,
          INFO: 2,
          WARN: 3,
          ERROR: 4,
          SILENT: 5
        }, y.methodFactory = g || f, y.getLevel = function() {
          return _ ?? b ?? v;
        }, y.setLevel = function(P, N) {
          return _ = C(P), N !== !1 && x(_), u.call(y);
        }, y.setDefaultLevel = function(P) {
          b = C(P), E() || y.setLevel(P, !1);
        }, y.resetLevel = function() {
          _ = null, S(), u.call(y);
        }, y.enableAll = function(P) {
          y.setLevel(y.levels.TRACE, P);
        }, y.disableAll = function(P) {
          y.setLevel(y.levels.SILENT, P);
        }, y.rebuild = function() {
          if (s !== y && (v = C(s.getLevel())), u.call(y), s === y)
            for (var P in i)
              i[P].rebuild();
        }, v = C(
          s ? s.getLevel() : "WARN"
        );
        var R = E();
        R != null && (_ = C(R)), u.call(y);
      }
      s = new h(), s.getLogger = function(m) {
        if (typeof m != "symbol" && typeof m != "string" || m === "")
          throw new TypeError("You must supply a name when creating a logger.");
        var g = i[m];
        return g || (g = i[m] = new h(
          m,
          s.methodFactory
        )), g;
      };
      var p = typeof window !== n ? window.log : void 0;
      return s.noConflict = function() {
        return typeof window !== n && window.log === s && (window.log = p), s;
      }, s.getLoggers = function() {
        return i;
      }, s.default = s, s;
    });
  }(BN)), BN.exports;
}
var rUe = nUe();
const oUe = /* @__PURE__ */ bp(rUe);
oUe.setLevel("silent");
const iUe = xt.define();
jr.define({
  create() {
  },
  update(t, e) {
    for (const n of e.effects)
      if (n.is(iUe))
        return n.value;
    return t;
  }
});
const sUe = {
  // validation errors
  AdditionalItemsError: "Array at `{{pointer}}` may not have an additional item `{{key}}`",
  AdditionalPropertiesError: "Additional property `{{property}}` on `{{pointer}}` does not match schema `{{schema}}`",
  AllOfError: "Value `{{value}}` at `{{pointer}}` does not match schema of `{{allOf}}`",
  AnyOfError: "Value `{{value}}` at `{{pointer}}` does not match any schema of `{{anyOf}}`",
  ConstError: "Expected value at `{{pointer}}` to be `{{expected}}`, but value given is `{{value}}`",
  containsAnyError: "The array at `{{pointer}}` must contain at least one item",
  ContainsArrayError: "The property at `{{pointer}}` must not be an array",
  ContainsError: "The array at `{{pointer}}` must contain an element that matches `{{schema}}`",
  EnumError: "Expected given value `{{value}}` in `{{pointer}}` to be one of `{{values}}`",
  ForbiddenPropertyError: "Property name `{{property}}` at `{{pointer}}` is not allowed",
  FormatDateError: "Value `{{value}}` at `{{pointer}}` is not a valid date",
  FormatDateTimeError: "Value `{{value}}` at `{{pointer}}` is not a valid date-time",
  FormatEmailError: "Value `{{value}}` at `{{pointer}}` is not a valid email",
  FormatHostnameError: "Value `{{value}}` at `{{pointer}}` is not a valid hostname",
  FormatIPV4Error: "Value `{{value}}` at `{{pointer}}` is not a valid IPv4 address",
  FormatIPV4LeadingZeroError: "IPv4 addresses starting with zero are invalid, since they are interpreted as octals",
  FormatIPV6Error: "Value `{{value}}` at `{{pointer}}` is not a valid IPv6 address",
  FormatIPV6LeadingZeroError: "IPv6 addresses starting with zero are invalid, since they are interpreted as octals",
  FormatJsonPointerError: "Value `{{value}}` at `{{pointer}}` is not a valid json-pointer",
  FormatRegExError: "Value `{{value}}` at `{{pointer}}` is not a valid regular expression",
  FormatTimeError: "Value `{{value}}` at `{{pointer}}` is not a valid time",
  FormatURIError: "Value `{{value}}` at `{{pointer}}` is not a valid uri",
  FormatURIReferenceError: "Value `{{value}}` at `{{pointer}}` is not a valid uri-reference",
  FormatURITemplateError: "Value `{{value}}` at `{{pointer}}` is not a valid uri-template",
  FormatURLError: "Value `{{value}}` at `{{pointer}}` is not a valid url",
  InvalidDataError: "No value may be specified in `{{pointer}}`",
  InvalidPropertyNameError: "Invalid property name `{{property}}` at `{{pointer}}`",
  MaximumError: "Value in `{{pointer}}` is `{{length}}`, but should be `{{maximum}}` at maximum",
  MaxItemsError: "Too many items in `{{pointer}}`, should be `{{maximum}}` at most, but got `{{length}}`",
  MaxLengthError: "Value `{{pointer}}` should have a maximum length of `{{maxLength}}`, but got `{{length}}`.",
  MaxPropertiesError: "Too many properties in `{{pointer}}`, should be `{{maximum}}` at most, but got `{{length}}`",
  MinimumError: "Value in `{{pointer}}` is `{{length}}`, but should be `{{minimum}}` at minimum",
  MinItemsError: "Too few items in `{{pointer}}`, should be at least `{{minItems}}`, but got `{{length}}`",
  MinItemsOneError: "At least one item is required in `{{pointer}}`",
  MinLengthError: "Value `{{pointer}}` should have a minimum length of `{{minLength}}`, but got `{{length}}`.",
  MinLengthOneError: "A value is required in `{{pointer}}`",
  MinPropertiesError: "Too few properties in `{{pointer}}`, should be at least `{{minimum}}`, but got `{{length}}`",
  MissingDependencyError: "The required propery '{{missingProperty}}' in `{{pointer}}` is missing",
  MissingOneOfPropertyError: "Value at `{{pointer}}` property: `{{property}}`",
  MultipleOfError: "Expected `{{value}}` in `{{pointer}}` to be multiple of `{{multipleOf}}`",
  MultipleOneOfError: "Value `{{value}}` should not match multiple schemas in oneOf `{{matches}}`",
  NoAdditionalPropertiesError: "Additional property `{{property}}` in `{{pointer}}` is not allowed",
  NotError: "Value `{{value}}` at pointer should not match schema `{{not}}`",
  OneOfError: "Value `{{value}}` in `{{pointer}}` does not match any given oneof schema",
  OneOfPropertyError: "Failed finding a matching oneOfProperty schema in `{{pointer}}` where `{{property}}` matches `{{value}}`",
  PatternError: "Value in `{{pointer}}` should match `{{description}}`, but received `{{received}}`",
  PatternPropertiesError: "Property `{{key}}` does not match any patterns in `{{pointer}}`. Valid patterns are: {{patterns}}",
  RequiredPropertyError: "The required property `{{key}}` is missing at `{{pointer}}`",
  SchemaWarning: "Failed retrieving a schema from '{{pointer}}' to key '{{key}}'",
  TypeError: "Expected `{{value}}` ({{received}}) in `{{pointer}}` to be of type `{{expected}}`",
  UndefinedValueError: "Value must not be undefined in `{{pointer}}`",
  UniqueItemsError: "Items in array must be unique. Value `{{value}}` in `{{pointer}}` is a duplicate of {{duplicatePointer}}.",
  UnknownPropertyError: "Could not find a valid schema for property `{{pointer}}` within object",
  ValueNotEmptyError: "A value for `{{property}}` is required at `{{pointer}}`"
}, aUe = Object.prototype.toString;
function lUe(t) {
  const e = aUe.call(t).match(/\s([^\]]+)\]/).pop().toLowerCase();
  return e === "file" ? "object" : e;
}
const cUe = "object", uUe = "array";
function dUe(t, e = {}) {
  return t.replace(/\{\{\w+\}\}/g, (n) => {
    const r = n.replace(/[{}]/g, ""), o = e[r], i = lUe(o);
    return i === cUe || i === uUe ? JSON.stringify(o) : o;
  });
}
function fUe(t, e, n = t) {
  var r;
  const o = (r = sUe[t]) !== null && r !== void 0 ? r : n;
  return dUe(o, e);
}
function hUe(t) {
  return t.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
function pUe(t, e) {
  return {
    type: "error",
    name: t,
    code: hUe(t),
    message: fUe(t, e),
    data: e
  };
}
function dt(t) {
  return pUe.bind(null, t);
}
var Sk, nq;
function mUe() {
  if (nq) return Sk;
  nq = 1;
  var t = function(y) {
    return e(y) && !n(y);
  };
  function e(y) {
    return !!y && typeof y == "object";
  }
  function n(y) {
    var v = Object.prototype.toString.call(y);
    return v === "[object RegExp]" || v === "[object Date]" || i(y);
  }
  var r = typeof Symbol == "function" && Symbol.for, o = r ? Symbol.for("react.element") : 60103;
  function i(y) {
    return y.$$typeof === o;
  }
  function s(y) {
    return Array.isArray(y) ? [] : {};
  }
  function a(y, v) {
    return v.clone !== !1 && v.isMergeableObject(y) ? m(s(y), y, v) : y;
  }
  function l(y, v, b) {
    return y.concat(v).map(function(_) {
      return a(_, b);
    });
  }
  function c(y, v) {
    if (!v.customMerge)
      return m;
    var b = v.customMerge(y);
    return typeof b == "function" ? b : m;
  }
  function u(y) {
    return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(y).filter(function(v) {
      return Object.propertyIsEnumerable.call(y, v);
    }) : [];
  }
  function d(y) {
    return Object.keys(y).concat(u(y));
  }
  function f(y, v) {
    try {
      return v in y;
    } catch {
      return !1;
    }
  }
  function h(y, v) {
    return f(y, v) && !(Object.hasOwnProperty.call(y, v) && Object.propertyIsEnumerable.call(y, v));
  }
  function p(y, v, b) {
    var _ = {};
    return b.isMergeableObject(y) && d(y).forEach(function(w) {
      _[w] = a(y[w], b);
    }), d(v).forEach(function(w) {
      h(y, w) || (f(y, w) && b.isMergeableObject(v[w]) ? _[w] = c(w, b)(y[w], v[w], b) : _[w] = a(v[w], b));
    }), _;
  }
  function m(y, v, b) {
    b = b || {}, b.arrayMerge = b.arrayMerge || l, b.isMergeableObject = b.isMergeableObject || t, b.cloneUnlessOtherwiseSpecified = a;
    var _ = Array.isArray(v), w = Array.isArray(y), x = _ === w;
    return x ? _ ? b.arrayMerge(y, v, b) : p(y, v, b) : a(v, b);
  }
  m.all = function(y, v) {
    if (!Array.isArray(y))
      throw new Error("first argument should be an array");
    return y.reduce(function(b, _) {
      return m(b, _, v);
    }, {});
  };
  var g = m;
  return Sk = g, Sk;
}
mUe();
var gUe = Function.prototype.toString, Ok = Object.create, yUe = Object.prototype.toString, vUe = (
  /** @class */
  function() {
    function t() {
      this._keys = [], this._values = [];
    }
    return t.prototype.has = function(e) {
      return !!~this._keys.indexOf(e);
    }, t.prototype.get = function(e) {
      return this._values[this._keys.indexOf(e)];
    }, t.prototype.set = function(e, n) {
      this._keys.push(e), this._values.push(n);
    }, t;
  }()
);
function bUe() {
  return new vUe();
}
function _Ue() {
  return /* @__PURE__ */ new WeakMap();
}
var wUe = typeof WeakMap < "u" ? _Ue : bUe;
function $L(t) {
  if (!t)
    return Ok(null);
  var e = t.constructor;
  if (e === Object)
    return t === Object.prototype ? {} : Ok(t);
  if (e && ~gUe.call(e).indexOf("[native code]"))
    try {
      return new e();
    } catch {
    }
  return Ok(t);
}
function xUe(t) {
  var e = "";
  return t.global && (e += "g"), t.ignoreCase && (e += "i"), t.multiline && (e += "m"), t.unicode && (e += "u"), t.sticky && (e += "y"), e;
}
function EUe(t) {
  return t.flags;
}
var SUe = /test/g.flags === "g" ? EUe : xUe;
function Phe(t) {
  var e = yUe.call(t);
  return e.substring(8, e.length - 1);
}
function OUe(t) {
  return t[Symbol.toStringTag] || Phe(t);
}
var CUe = typeof Symbol < "u" ? OUe : Phe, kUe = Object.defineProperty, AUe = Object.getOwnPropertyDescriptor, $he = Object.getOwnPropertyNames, ML = Object.getOwnPropertySymbols, Mhe = Object.prototype, Dhe = Mhe.hasOwnProperty, TUe = Mhe.propertyIsEnumerable, Ihe = typeof ML == "function";
function RUe(t) {
  return $he(t).concat(ML(t));
}
var PUe = Ihe ? RUe : $he;
function BS(t, e, n) {
  for (var r = PUe(t), o = 0, i = r.length, s = void 0, a = void 0; o < i; ++o)
    if (s = r[o], !(s === "callee" || s === "caller")) {
      if (a = AUe(t, s), !a) {
        e[s] = n.copier(t[s], n);
        continue;
      }
      !a.get && !a.set && (a.value = n.copier(a.value, n));
      try {
        kUe(e, s, a);
      } catch {
        e[s] = a.value;
      }
    }
  return e;
}
function $Ue(t, e) {
  var n = new e.Constructor();
  e.cache.set(t, n);
  for (var r = 0, o = t.length; r < o; ++r)
    n[r] = e.copier(t[r], e);
  return n;
}
function MUe(t, e) {
  var n = new e.Constructor();
  return e.cache.set(t, n), BS(t, n, e);
}
function Nhe(t, e) {
  return t.slice(0);
}
function DUe(t, e) {
  return t.slice(0, t.size, t.type);
}
function IUe(t, e) {
  return new e.Constructor(Nhe(t.buffer));
}
function NUe(t, e) {
  return new e.Constructor(t.getTime());
}
function jhe(t, e) {
  var n = new e.Constructor();
  return e.cache.set(t, n), t.forEach(function(r, o) {
    n.set(o, e.copier(r, e));
  }), n;
}
function jUe(t, e) {
  return BS(t, jhe(t, e), e);
}
function LUe(t, e) {
  var n = $L(e.prototype);
  e.cache.set(t, n);
  for (var r in t)
    Dhe.call(t, r) && (n[r] = e.copier(t[r], e));
  return n;
}
function FUe(t, e) {
  var n = $L(e.prototype);
  e.cache.set(t, n);
  for (var r in t)
    Dhe.call(t, r) && (n[r] = e.copier(t[r], e));
  for (var o = ML(t), i = 0, s = o.length, a = void 0; i < s; ++i)
    a = o[i], TUe.call(t, a) && (n[a] = e.copier(t[a], e));
  return n;
}
var BUe = Ihe ? FUe : LUe;
function zUe(t, e) {
  var n = $L(e.prototype);
  return e.cache.set(t, n), BS(t, n, e);
}
function Ck(t, e) {
  return new e.Constructor(t.valueOf());
}
function qUe(t, e) {
  var n = new e.Constructor(t.source, SUe(t));
  return n.lastIndex = t.lastIndex, n;
}
function Ew(t, e) {
  return t;
}
function Lhe(t, e) {
  var n = new e.Constructor();
  return e.cache.set(t, n), t.forEach(function(r) {
    n.add(e.copier(r, e));
  }), n;
}
function UUe(t, e) {
  return BS(t, Lhe(t, e), e);
}
var HUe = Array.isArray, DL = Object.assign, VUe = Object.getPrototypeOf || function(t) {
  return t.__proto__;
}, Fhe = {
  array: $Ue,
  arrayBuffer: Nhe,
  blob: DUe,
  dataView: IUe,
  date: NUe,
  error: Ew,
  map: jhe,
  object: BUe,
  regExp: qUe,
  set: Lhe
}, WUe = DL({}, Fhe, {
  array: MUe,
  map: jUe,
  object: zUe,
  set: UUe
});
function GUe(t) {
  return {
    Arguments: t.object,
    Array: t.array,
    ArrayBuffer: t.arrayBuffer,
    Blob: t.blob,
    Boolean: Ck,
    DataView: t.dataView,
    Date: t.date,
    Error: t.error,
    Float32Array: t.arrayBuffer,
    Float64Array: t.arrayBuffer,
    Int8Array: t.arrayBuffer,
    Int16Array: t.arrayBuffer,
    Int32Array: t.arrayBuffer,
    Map: t.map,
    Number: Ck,
    Object: t.object,
    Promise: Ew,
    RegExp: t.regExp,
    Set: t.set,
    String: Ck,
    WeakMap: Ew,
    WeakSet: Ew,
    Uint8Array: t.arrayBuffer,
    Uint8ClampedArray: t.arrayBuffer,
    Uint16Array: t.arrayBuffer,
    Uint32Array: t.arrayBuffer,
    Uint64Array: t.arrayBuffer
  };
}
function Bhe(t) {
  var e = DL({}, Fhe, t), n = GUe(e), r = n.Array, o = n.Object;
  function i(s, a) {
    if (a.prototype = a.Constructor = void 0, !s || typeof s != "object")
      return s;
    if (a.cache.has(s))
      return a.cache.get(s);
    if (a.prototype = VUe(s), a.Constructor = a.prototype && a.prototype.constructor, !a.Constructor || a.Constructor === Object)
      return o(s, a);
    if (HUe(s))
      return r(s, a);
    var l = n[CUe(s)];
    return l ? l(s, a) : typeof s.then == "function" ? s : o(s, a);
  }
  return function(s) {
    return i(s, {
      Constructor: void 0,
      cache: wUe(),
      copier: i,
      prototype: void 0
    });
  };
}
function YUe(t) {
  return Bhe(DL({}, WUe, t));
}
YUe({});
Bhe({});
var zN = { exports: {} }, KUe = zN.exports, rq;
function XUe() {
  return rq || (rq = 1, function(t, e) {
    (function(n, r) {
      t.exports = r();
    })(typeof self < "u" ? self : KUe, () => (() => {
      var n = { d: (A, O) => {
        for (var k in O) n.o(O, k) && !n.o(A, k) && Object.defineProperty(A, k, { enumerable: !0, get: O[k] });
      }, o: (A, O) => Object.prototype.hasOwnProperty.call(A, O), r: (A) => {
        typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(A, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(A, "__esModule", { value: !0 });
      } }, r = {};
      function o(A) {
        return A === "#" || A === "" || Array.isArray(A) && A.length === 0 || !1;
      }
      n.r(r), n.d(r, { default: () => N, get: () => f, isRoot: () => o, join: () => R, remove: () => w, removeUndefinedItems: () => _, set: () => y, split: () => d, splitLast: () => P });
      const i = /~1/g, s = /~0/g, a = /\/+/g, l = /(^[#/]*|\/+$)/g;
      function c(A) {
        return A.replace(i, "/").replace(s, "~");
      }
      function u(A) {
        return c(decodeURIComponent(A));
      }
      function d(A) {
        if (A == null || typeof A != "string" || o(A)) return Array.isArray(A) ? A : [];
        const O = A.indexOf("#") >= 0 ? u : c, k = (A = (A = A.replace(a, "/")).replace(l, "")).split("/");
        for (let T = 0, I = k.length; T < I; T += 1) k[T] = O(k[T]);
        return k;
      }
      function f(A, O, k = void 0) {
        if (O == null || A == null) return k;
        if (o(O)) return A;
        const T = h(A, d(O));
        return T === void 0 ? k : T;
      }
      function h(A, O) {
        const k = O.shift();
        if (A !== void 0) return k !== void 0 ? h(A[k], O) : A;
      }
      const p = /^\[.*\]$/, m = /^\[(.+)\]$/;
      function g(A, O) {
        return A === "__proto__" || A == "constructor" && O.length > 0 && O[0] == "prototype";
      }
      function y(A, O, k) {
        if (O == null) return A;
        const T = d(O);
        if (T.length === 0) return A;
        A == null && (A = p.test(T[0]) ? [] : {});
        let I, j, z = A;
        for (; T.length > 1; ) I = T.shift(), j = p.test(T[0]), g(I, T) || (z = b(z, I, j));
        return I = T.pop(), v(z, I, k), A;
      }
      function v(A, O, k) {
        let T;
        const I = O.match(m);
        O === "[]" && Array.isArray(A) ? A.push(k) : I ? (T = I.pop(), A[T] = k) : A[O] = k;
      }
      function b(A, O, k) {
        if (A[O] != null) return A[O];
        const T = k ? [] : {};
        return v(A, O, T), T;
      }
      function _(A) {
        let O = 0, k = 0;
        for (; O + k < A.length; ) A[O + k] === void 0 && (k += 1), A[O] = A[O + k], O += 1;
        return A.length = A.length - k, A;
      }
      function w(A, O, k) {
        const T = d(O), I = T.pop(), j = f(A, T);
        return j && delete j[I], Array.isArray(j) && k !== !0 && _(j), A;
      }
      const x = /\/+/g, E = /~/g, S = /\//g;
      function C(A, O) {
        if (A.length === 0) return O ? "#" : "";
        for (let k = 0, T = A.length; k < T; k += 1) A[k] = A[k].replace(E, "~0").replace(S, "~1"), O && (A[k] = encodeURIComponent(A[k]));
        return ((O ? "#/" : "/") + A.join("/")).replace(x, "/");
      }
      function R(A, ...O) {
        const k = [];
        if (Array.isArray(A)) return C(A, arguments[1] === !0);
        const T = arguments[arguments.length - 1], I = typeof T == "boolean" ? T : A && A[0] === "#";
        for (let z = 0, $ = arguments.length; z < $; z += 1) k.push.apply(k, d(arguments[z]));
        const j = [];
        for (let z = 0, $ = k.length; z < $; z += 1) if (k[z] === "..") {
          if (j.length === 0) return I ? "#" : "";
          j.pop();
        } else j.push(k[z]);
        return C(j, I);
      }
      function P(A) {
        const O = d(A);
        if (O.length === 0) return typeof A == "string" && A[0] === "#" ? ["#", O[0]] : ["", void 0];
        if (O.length === 1) return A[0] === "#" ? ["#", O[0]] : ["", O[0]];
        const k = O.pop();
        return [R(O, A[0] === "#"), k];
      }
      const N = { get: f, set: y, remove: w, join: R, split: d, splitLast: P, isRoot: o, removeUndefinedItems: _ };
      return r;
    })());
  }(zN)), zN.exports;
}
XUe();
var Gb = {}, Io = {}, fm = {}, oq;
function QUe() {
  if (oq) return fm;
  oq = 1, Object.defineProperty(fm, "__esModule", { value: !0 }), fm.TokenError = void 0;
  let t = class extends Error {
    constructor(e, n) {
      if (super(e), this.message = e, this.token = n, n && n.errors)
        n.errors.push(this);
      else
        throw this;
    }
    inspect() {
      return "SyntaxError: " + this.message;
    }
  };
  return fm.TokenError = t, fm;
}
var iq;
function ZUe() {
  if (iq) return Io;
  iq = 1, Object.defineProperty(Io, "__esModule", { value: !0 }), Io.Parser = Io.findRuleByName = Io.parseRuleName = Io.escapeRegExp = Io.readToken = void 0;
  const t = /^[A-Z0-9_]+$/, e = /(\?|\+|\*)$/, n = /^(@|&|!)/, r = "WS", o = QUe();
  function i(m, g) {
    let y = g.exec(m);
    return y && y.index == 0 ? y[0].length == 0 && g.source.length > 0 ? null : {
      type: null,
      text: y[0],
      rest: m.substr(y[0].length),
      start: 0,
      end: y[0].length - 1,
      fullText: y[0],
      errors: [],
      children: [],
      parent: null
    } : null;
  }
  Io.readToken = i;
  function s(m) {
    return m.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
  }
  Io.escapeRegExp = s;
  function a(m) {
    m.rest = "", m.children && m.children.forEach((g) => a(g));
  }
  function l(m, g) {
    m.start += g, m.end += g, m.children && m.children.forEach((y) => l(y, m.start));
  }
  function c(m, g) {
    g.errors && g.errors.length && g.errors.forEach((y) => m.push(y)), g.children && g.children.forEach((y) => c(m, y));
  }
  function u(m) {
    let g = e.exec(m), y = n.exec(m), v = g && g[0] || "", b = y && y[0] || "", _ = {
      raw: m,
      name: m.replace(e, "").replace(n, ""),
      isOptional: v == "?" || v == "*",
      allowRepetition: v == "+" || v == "*",
      atLeastOne: v == "+",
      lookupPositive: b == "&",
      lookupNegative: b == "!",
      pinned: b == "@",
      lookup: !1,
      isLiteral: !1
    };
    return _.isLiteral = _.name[0] == "'" || _.name[0] == '"', _.lookup = _.lookupNegative || _.lookupPositive, _;
  }
  Io.parseRuleName = u;
  function d(m, g) {
    let y = u(m);
    return g.cachedRules[y.name] || null;
  }
  Io.findRuleByName = d;
  function f(m, g) {
    if (m.children) {
      let y = m.children.filter((v) => v.type && g.test(v.type));
      for (let v = 0; v < y.length; v++) {
        let b = m.children.indexOf(y[v]);
        b != -1 && m.children.splice(b, 1);
      }
      m.children.forEach((v) => f(v, g));
    }
  }
  const h = ["EOF"];
  let p = class {
    constructor(m, g) {
      this.grammarRules = m, this.options = g, this.cachedRules = {}, this.debug = g ? g.debug === !0 : !1;
      let y = [], v = [];
      if (m.forEach((b) => {
        let _ = u(b.name);
        if (_.name in this.cachedRules) {
          y.push("Duplicated rule " + _.name);
          return;
        } else
          this.cachedRules[_.name] = b;
        if (!b.bnf || !b.bnf.length) {
          let w = "Missing rule content, rule: " + b.name;
          y.indexOf(w) == -1 && y.push(w);
        } else
          b.bnf.forEach((w) => {
            if (typeof w[0] == "string" && u(w[0]).name == b.name) {
              let x = "Left recursion is not allowed, rule: " + b.name;
              y.indexOf(x) == -1 && y.push(x);
            }
            w.forEach((x) => {
              if (typeof x == "string") {
                let E = u(x);
                !E.isLiteral && v.indexOf(E.name) == -1 && h.indexOf(E.name) == -1 && v.push(E.name);
              }
            });
          });
        r == b.name && (b.implicitWs = !1), b.implicitWs && v.indexOf(r) == -1 && v.push(r), b.recover && v.indexOf(b.recover) == -1 && v.push(b.recover);
      }), v.forEach((b) => {
        b in this.cachedRules || y.push("Missing rule " + b);
      }), y.length)
        throw new Error(y.join(`
`));
    }
    getAST(m, g) {
      g || (g = this.grammarRules.filter((v) => !v.fragment && v.name.indexOf("%") != 0)[0].name);
      let y = this.parse(m, g);
      if (y) {
        c(y.errors, y), l(y, 0), f(y, /^%/), (!this.options || !this.options.keepUpperRules) && f(y, t);
        let v = y.rest;
        v && new o.TokenError(`Unexpected end of input: 
` + v, y), a(y), y.rest = v;
      }
      return y;
    }
    emitSource() {
      return "CANNOT EMIT SOURCE FROM BASE Parser";
    }
    parse(m, g, y = 0) {
      let v = null, b = u(g), _, w = this.debug && /*!isLiteral &*/
      !t.test(b.name);
      w && console.log(new Array(y).join("│  ") + "Trying to get " + g + " from " + JSON.stringify(m.split(`
`)[0]));
      let x = b.name, E = d(b.name, this);
      if (b.name == "EOF") {
        if (m.length)
          return null;
        if (m.length == 0)
          return {
            type: "EOF",
            text: "",
            rest: "",
            start: 0,
            end: 0,
            fullText: "",
            errors: [],
            children: [],
            parent: null
          };
      }
      try {
        if (!E && b.isLiteral) {
          let S = b.name.trim();
          if (S.startsWith('"') ? S = JSON.parse(S) : S.startsWith("'") && (S = S.replace(/^'(.+)'$/, "$1").replace(/\\'/g, "'")), S === "")
            return {
              type: "%%EMPTY%%",
              text: "",
              rest: m,
              start: 0,
              end: 0,
              fullText: "",
              errors: [],
              children: [],
              parent: null
            };
          _ = new RegExp(s(S)), x = null;
        }
      } catch (S) {
        return S instanceof ReferenceError && console.error(S), null;
      }
      if (_) {
        let S = i(m, _);
        if (S)
          return S.type = x, S;
      } else {
        let S = E.bnf;
        S instanceof Array && S.forEach((C) => {
          if (v)
            return;
          let R = null, P = {
            type: b.name,
            text: "",
            children: [],
            end: 0,
            errors: [],
            fullText: "",
            parent: null,
            start: 0,
            rest: m
          };
          E.fragment && (P.fragment = !0);
          let N = m, A = 0, O = C.length > 0, k = !1;
          for (let T = 0; T < C.length; T++)
            if (typeof C[T] == "string") {
              let I = u(C[T]);
              O = O && I.isOptional;
              let j, z = !1;
              do {
                if (j = null, E.implicitWs && (j = this.parse(N, I.name, y + 1), !j)) {
                  let $;
                  do
                    if ($ = this.parse(N, r, y + 1), $)
                      P.text = P.text + $.text, P.end = P.text.length, $.parent = P, P.children.push($), N = N.substr($.text.length), A += $.text.length;
                    else
                      break;
                  while ($ && $.text.length);
                }
                if (j = j || this.parse(N, I.name, y + 1), I.lookupNegative) {
                  if (j)
                    return;
                  break;
                }
                if (I.lookupPositive && !j)
                  return;
                if (!j && (I.isOptional || I.atLeastOne && z))
                  break;
                if (j && E.pinned == T + 1 && (R = j, w && console.log(new Array(y + 1).join("│  ") + "└─ " + j.type + " PINNED")), j || (j = this.parseRecovery(E, N, y + 1)), !j)
                  if (R)
                    v = P, j = {
                      type: "SyntaxError",
                      text: N,
                      children: [],
                      end: N.length,
                      errors: [],
                      fullText: "",
                      parent: null,
                      start: 0,
                      rest: ""
                    }, N.length ? new o.TokenError(`Unexpected end of input. Expecting ${I.name} Got: ${N}`, j) : new o.TokenError(`Unexpected end of input. Missing ${I.name}`, j), w && console.log(new Array(y + 1).join("│  ") + "└─ " + j.type + " " + JSON.stringify(j.text));
                  else
                    return;
                if (z = !0, k = !0, j.type == "%%EMPTY%%")
                  break;
                j.start += A, j.end += A, !I.lookupPositive && j.type && (j.fragment ? j.children && j.children.forEach(($) => {
                  $.start += A, $.end += A, $.parent = P, P.children.push($);
                }) : (j.parent = P, P.children.push(j))), I.lookup && (j.lookup = !0), w && console.log(new Array(y + 1).join("│  ") + "└─ " + j.type + " " + JSON.stringify(j.text)), !I.lookup && !j.lookup && (P.text = P.text + j.text, P.end = P.text.length, N = N.substr(j.text.length), A += j.text.length), P.rest = N;
              } while (j && I.allowRepetition && N.length && !j.lookup);
            } else {
              let I = i(N, C[T]);
              if (!I)
                return;
              w && console.log(new Array(y + 1).join("│  ") + "└> " + JSON.stringify(I.text) + C[T].source), k = !0, I.start += A, I.end += A, P.text = P.text + I.text, P.end = P.text.length, N = N.substr(I.text.length), A += I.text.length, P.rest = N;
            }
          k && (v = P, w && console.log(new Array(y).join("│  ") + "├<─┴< PUSHING " + v.type + " " + JSON.stringify(v.text)));
        }), v && E.simplifyWhenOneChildren && v.children.length == 1 && (v = v.children[0]);
      }
      return v || w && console.log(g + " NOT RESOLVED FROM " + m), v;
    }
    parseRecovery(m, g, y) {
      if (m.recover && g.length) {
        let v = this.debug;
        v && console.log(new Array(y + 1).join("│  ") + "Trying to recover until token " + m.recover + " from " + JSON.stringify(g.split(`
`)[0] + g.split(`
`)[1]));
        let b = {
          type: "SyntaxError",
          text: "",
          children: [],
          end: 0,
          errors: [],
          fullText: "",
          parent: null,
          start: 0,
          rest: ""
        }, _;
        do
          if (_ = this.parse(g, m.recover, y + 1), _) {
            new o.TokenError('Unexpected input: "' + b.text + `" Expecting: ${m.name}`, b);
            break;
          } else
            b.text = b.text + g[0], b.end = b.text.length, g = g.substr(1);
        while (!_ && g.length > 0);
        if (b.text.length > 0 && _)
          return v && console.log(new Array(y + 1).join("│  ") + "Recovered text: " + JSON.stringify(b.text)), b;
      }
      return null;
    }
  };
  return Io.Parser = p, Io.default = p, Io;
}
var sq;
function JUe() {
  if (sq) return Gb;
  sq = 1, Object.defineProperty(Gb, "__esModule", { value: !0 });
  const t = ZUe();
  var e;
  return function(n) {
    n.RULES = [
      {
        name: "Grammar",
        bnf: [["RULE_S*", "%Atomic*", "EOF"]]
      },
      {
        name: "%Atomic",
        bnf: [["Production", "RULE_S*"]],
        fragment: !0
      },
      {
        name: "Production",
        bnf: [["NCName", "RULE_S*", '"::="', "RULE_WHITESPACE*", "Choice", "RULE_WHITESPACE*", "RULE_EOL+", "RULE_S*"]]
      },
      {
        name: "NCName",
        bnf: [[/[a-zA-Z][a-zA-Z_0-9]*/]]
      },
      {
        name: "Choice",
        bnf: [["SequenceOrDifference", "%_Choice_1*"]],
        fragment: !0
      },
      {
        name: "%_Choice_1",
        bnf: [["RULE_WHITESPACE*", '"|"', "RULE_WHITESPACE*", "SequenceOrDifference"]],
        fragment: !0
      },
      {
        name: "SequenceOrDifference",
        bnf: [["Item", "RULE_WHITESPACE*", "%_Item_1?"]]
      },
      {
        name: "%_Item_1",
        bnf: [["Minus", "Item"], ["Item*"]],
        fragment: !0
      },
      {
        name: "Minus",
        bnf: [['"-"']]
      },
      {
        name: "Item",
        bnf: [["RULE_WHITESPACE*", "%Primary", "PrimaryDecoration?"]],
        fragment: !0
      },
      {
        name: "PrimaryDecoration",
        bnf: [['"?"'], ['"*"'], ['"+"']]
      },
      {
        name: "DecorationName",
        bnf: [['"ebnf://"', /[^\x5D#]+/]]
      },
      {
        name: "%Primary",
        bnf: [["NCName"], ["StringLiteral"], ["CharCode"], ["CharClass"], ["SubItem"]],
        fragment: !0
      },
      {
        name: "SubItem",
        bnf: [['"("', "RULE_WHITESPACE*", "Choice", "RULE_WHITESPACE*", '")"']]
      },
      {
        name: "StringLiteral",
        bnf: [[`'"'`, /[^"]*/, `'"'`], [`"'"`, /[^']*/, `"'"`]],
        pinned: 1
      },
      {
        name: "CharCode",
        bnf: [['"#x"', /[0-9a-zA-Z]+/]]
      },
      {
        name: "CharClass",
        bnf: [["'['", "'^'?", "%RULE_CharClass_1+", '"]"']]
      },
      {
        name: "%RULE_CharClass_1",
        bnf: [["CharCodeRange"], ["CharRange"], ["CharCode"], ["RULE_Char"]],
        fragment: !0
      },
      {
        name: "RULE_Char",
        bnf: [[/\x09/], [/\x0A/], [/\x0D/], [/[\x20-\x5c]/], [/[\x5e-\uD7FF]/], [/[\uE000-\uFFFD]/]]
      },
      {
        name: "CharRange",
        bnf: [["RULE_Char", '"-"', "RULE_Char"]]
      },
      {
        name: "CharCodeRange",
        bnf: [["CharCode", '"-"', "CharCode"]]
      },
      {
        name: "RULE_WHITESPACE",
        bnf: [["%RULE_WHITESPACE_CHAR*"], ["Comment", "RULE_WHITESPACE*"]]
      },
      {
        name: "RULE_S",
        bnf: [["RULE_WHITESPACE", "RULE_S*"], ["RULE_EOL", "RULE_S*"]]
      },
      {
        name: "%RULE_WHITESPACE_CHAR",
        bnf: [[/\x09/], [/\x20/]],
        fragment: !0
      },
      {
        name: "Comment",
        bnf: [['"/*"', "%RULE_Comment_Body*", '"*/"']]
      },
      {
        name: "%RULE_Comment_Body",
        bnf: [['!"*/"', /[^*]/]],
        fragment: !0
      },
      {
        name: "RULE_EOL",
        bnf: [[/\x0D/, /\x0A/], [/\x0A/], [/\x0D/]]
      },
      {
        name: "Link",
        bnf: [["'['", "Url", "']'"]]
      },
      {
        name: "Url",
        bnf: [[/[^\x5D:/?#]/, '"://"', /[^\x5D#]+/, "%Url1?"]]
      },
      {
        name: "%Url1",
        bnf: [['"#"', "NCName"]],
        fragment: !0
      }
    ], n.defaultParser = new t.Parser(n.RULES, { debug: !1 });
    const r = /^(!|&)/, o = /(\?|\+|\*)$/, i = /^%/;
    function s(b, _) {
      if (typeof b == "string") {
        if (r.test(b))
          return "";
        if (i.test(b)) {
          let w = o.exec(b), x = w ? w[0] + " " : "";
          return a(b, _) ? c(b, _) + x : "(" + c(b, _) + ")" + x;
        }
        return b;
      } else
        return b.source.replace(/\\(?:x|u)([a-zA-Z0-9]+)/g, "#x$1").replace(/\[\\(?:x|u)([a-zA-Z0-9]+)-\\(?:x|u)([a-zA-Z0-9]+)\]/g, "[#x$1-#x$2]");
    }
    function a(b, _) {
      let w = t.findRuleByName(b, _);
      return w && w.bnf.length == 1 && w.bnf[0].length == 1 && (w.bnf[0][0] instanceof RegExp || w.bnf[0][0][0] == '"' || w.bnf[0][0][0] == "'");
    }
    function l(b, _) {
      return b.map((w) => s(w, _)).join(" ");
    }
    function c(b, _) {
      let w = t.findRuleByName(b, _);
      return w ? w.bnf.map((x) => l(x, _)).join(" | ") : "RULE_NOT_FOUND {" + b + "}";
    }
    function u(b) {
      let _ = [];
      return b.grammarRules.forEach((w) => {
        if (!/^%/.test(w.name)) {
          let x = w.recover ? " /* { recoverUntil=" + w.recover + " } */" : "";
          _.push(w.name + " ::= " + c(w.name, b) + x);
        }
      }), _.join(`
`);
    }
    n.emit = u;
    let d = 0;
    function f(b, _) {
      throw console.log("reberia restar " + _ + " a " + b), new Error("Difference not supported yet");
    }
    function h(b) {
      return new RegExp(b.replace(/#x([a-zA-Z0-9]{4})/g, "\\u$1").replace(/#x([a-zA-Z0-9]{3})/g, "\\u0$1").replace(/#x([a-zA-Z0-9]{2})/g, "\\x$1").replace(/#x([a-zA-Z0-9]{1})/g, "\\x0$1"));
    }
    function p(b, _, w) {
      let x = null, E = [];
      return _.children.forEach((S, C) => {
        S.type == "Minus" && f(x, S);
        let R = _.children[C + 1];
        R = R && R.type == "PrimaryDecoration" && R.text || "";
        let P = "";
        switch (S.type) {
          case "SubItem":
            let N = "%" + (w + d++);
            m(b, S, N), E.push(P + N + R);
            break;
          case "NCName":
          case "StringLiteral":
            E.push(P + S.text + R);
            break;
          case "CharCode":
          case "CharClass":
            if (R || P) {
              let A = {
                name: "%" + (w + d++),
                bnf: [[h(S.text)]]
              };
              b.push(A), E.push(P + A.name + R);
            } else
              E.push(h(S.text));
            break;
          case "PrimaryDecoration":
            break;
          default:
            throw new Error(" HOW SHOULD I PARSE THIS? " + S.type + " -> " + JSON.stringify(S.text));
        }
        x = S;
      }), E;
    }
    function m(b, _, w) {
      let x = _.children.filter((C) => C.type == "SequenceOrDifference").map((C) => p(b, C, w)), E = {
        name: w,
        bnf: x
      }, S = null;
      x.forEach((C) => {
        S = S || C.recover, delete C.recover;
      }), w.indexOf("%") == 0 && (E.fragment = !0), S && (E.recover = S), b.push(E);
    }
    function g(b, _ = n.defaultParser) {
      let w = _.getAST(b);
      if (!w)
        throw new Error("Could not parse " + b);
      if (w.errors && w.errors.length)
        throw w.errors[0];
      let x = [];
      return w.children.filter((E) => E.type == "Production").map((E) => {
        let S = E.children.filter((C) => C.type == "NCName")[0].text;
        m(x, E, S);
      }), x;
    }
    n.getRules = g;
    function y(b, _ = n.defaultParser) {
      return g(b.join(""), _);
    }
    n.Transform = y;
    class v extends t.Parser {
      constructor(_, w) {
        const x = w && w.debugRulesParser === !0 ? new t.Parser(n.RULES, { debug: !0 }) : n.defaultParser;
        super(g(_, x), w);
      }
      emitSource() {
        return u(this);
      }
    }
    n.Parser = v;
  }(e || (e = {})), Gb.default = e, Gb;
}
var eHe = JUe();
const tHe = /* @__PURE__ */ bp(eHe), nHe = "[^?/{}*,()#]+", rHe = `
root ::= ("#" recursion | recursion | (query | pattern) recursion* | "#" SEP? | SEP)
recursion ::= (SEP query | pattern)*

query ::= (ESC escaped ESC | property | all | any | regex) typecheck? lookahead?
property ::= ${nHe}
regex ::= "{" [^}]+ "}"
SEP ::= "/"
all ::= "**"
any ::= "*"

typecheck ::= "?:" ("value" | "boolean" | "string" | "number" | "object" | "array")
lookahead ::= "?" expression ((andExpr | orExpr) expression)*
andExpr ::= S? "&&" S?
orExpr ::= S? "||" S?

expression ::= (exprProperty | ESC escaped ESC) ((isnot | is) (exprProperty | regex | ESC escaped ESC))*
exprProperty ::= [a-zA-Z0-9-_ $]+
escaped ::= [^"]+
is ::= ":"
isnot ::= ":!"
ESC ::= '"'

pattern ::= S? "(" (SEP query | pattern (orPattern? pattern)*)* ")" quantifier? S? lookahead?
quantifier ::= "+" | "*" | [0-9]+
orPattern ::= S? "," S?

S ::= [ ]*
`;
new tHe.Parser(rHe);
var tp;
(function(t) {
  t.POINTER = "pointer", t.VALUE = "value", t.ALL = "all", t.MAP = "map";
})(tp || (tp = {}));
tp.POINTER;
tp.VALUE;
tp.ALL;
tp.MAP;
var qx;
(function(t) {
  t.REPLACE_ITEMS = "replace", t.INSERT_ITEMS = "insert";
})(qx || (qx = {}));
qx.REPLACE_ITEMS;
qx.INSERT_ITEMS;
const aq = {
  $ref: {
    type: !1
  },
  allOf: {
    type: !1,
    definitions: ["allOf/*"]
  },
  anyOf: {
    type: !1,
    definitions: ["anyOf/*"]
  },
  array: {
    type: !0,
    // ignore additionalItems:TypeDef, when items:TypeDef
    definitions: [
      "allOf/*",
      "anyOf/*",
      "oneOf/*",
      "not",
      "items",
      "items/*",
      "additionalItems"
    ],
    validationKeywords: ["minItems", "maxItems", "uniqueItems"],
    keywords: ["items", "additionalItems", "minItems", "maxItems", "uniqueItems"]
  },
  boolean: {
    type: !0
  },
  enum: {
    type: !1
  },
  integer: {
    type: !0,
    definitions: ["allOf/*", "anyOf/*", "oneOf/*", "not"],
    validationKeywords: ["minimum", "maximum", "multipleOf"]
  },
  not: {
    type: !1,
    definitions: ["not"]
  },
  number: {
    type: !0,
    definitions: ["allOf/*", "anyOf/*", "oneOf/*", "not"],
    validationKeywords: ["minimum", "maximum", "multipleOf"]
  },
  null: {
    type: !0
  },
  object: {
    type: !0,
    // patternProperties also validate properties
    // dependencies:(string, TypeDef) extend current TypeDef
    // additional Properties validate only remaining properties (after properties & pattern)
    definitions: [
      "allOf/*",
      "anyOf/*",
      "oneOf/*",
      "not",
      "properties/*",
      "additionalProperties",
      "patternProperties/*",
      "dependencies/*"
    ],
    validationKeywords: ["minProperties", "maxProperties", "required"],
    keywords: [
      "properties",
      "additionalProperties",
      "patternProperties",
      "dependencies",
      "minProperties",
      "maxProperties",
      "required"
    ]
  },
  oneOf: {
    type: !1,
    definitions: ["oneOf/*"]
  },
  string: {
    type: !0,
    definitions: ["allOf/*", "anyOf/*", "oneOf/*", "not"],
    validationKeywords: ["minLength", "maxLength", "pattern"]
  }
};
Object.keys(aq).filter((t) => aq[t].type === !1);
dt("AdditionalItemsError"), dt("AdditionalPropertiesError"), dt("AnyOfError"), dt("AllOfError"), dt("ConstError"), dt("ContainsError"), dt("ContainsArrayError"), dt("ContainsAnyError"), dt("EnumError"), dt("ForbiddenPropertyError"), dt("FormatURLError"), dt("FormatURIError"), dt("FormatURIReferenceError"), dt("FormatURITemplateError"), dt("FormatDateError"), dt("FormatDateTimeError"), dt("FormatEmailError"), dt("FormatHostnameError"), dt("FormatIPV4Error"), dt("FormatIPV4LeadingZeroError"), dt("FormatIPV6Error"), dt("FormatIPV6LeadingZeroError"), dt("FormatJsonPointerError"), dt("FormatRegExError"), dt("FormatTimeError"), dt("InvalidSchemaError"), dt("InvalidDataError"), dt("InvalidTypeError"), dt("InvalidPropertyNameError"), dt("MaximumError"), dt("MaxItemsError"), dt("MaxLengthError"), dt("MaxPropertiesError"), dt("MinimumError"), dt("MinItemsError"), dt("MinItemsOneError"), dt("MinLengthError"), dt("MinLengthOneError"), dt("MinPropertiesError"), dt("MissingDependencyError"), dt("MissingOneOfPropertyError"), dt("MultipleOfError"), dt("MultipleOneOfError"), dt("NoAdditionalPropertiesError"), dt("NotError"), dt("OneOfError"), dt("OneOfPropertyError"), dt("PatternError"), dt("PatternPropertiesError"), dt("RequiredPropertyError"), dt("SchemaWarning"), dt("TypeError"), dt("UndefinedValueError"), dt("UniqueItemsError"), dt("UnknownPropertyError"), dt("ValueNotEmptyError");
var lq = { exports: {} }, cq;
function oHe() {
  return cq || (cq = 1, function(t) {
    (function(e) {
      e.exports.is_uri = r, e.exports.is_http_uri = o, e.exports.is_https_uri = i, e.exports.is_web_uri = s, e.exports.isUri = r, e.exports.isHttpUri = o, e.exports.isHttpsUri = i, e.exports.isWebUri = s;
      var n = function(a) {
        var l = a.match(/(?:([^:\/?#]+):)?(?:\/\/([^\/?#]*))?([^?#]*)(?:\?([^#]*))?(?:#(.*))?/);
        return l;
      };
      function r(a) {
        if (a && !/[^a-z0-9\:\/\?\#\[\]\@\!\$\&\'\(\)\*\+\,\;\=\.\-\_\~\%]/i.test(a) && !/%[^0-9a-f]/i.test(a) && !/%[0-9a-f](:?[^0-9a-f]|$)/i.test(a)) {
          var l = [], c = "", u = "", d = "", f = "", h = "", p = "";
          if (l = n(a), c = l[1], u = l[2], d = l[3], f = l[4], h = l[5], !!(c && c.length && d.length >= 0)) {
            if (u && u.length) {
              if (!(d.length === 0 || /^\//.test(d))) return;
            } else if (/^\/\//.test(d)) return;
            if (/^[a-z][a-z0-9\+\-\.]*$/.test(c.toLowerCase()))
              return p += c + ":", u && u.length && (p += "//" + u), p += d, f && f.length && (p += "?" + f), h && h.length && (p += "#" + h), p;
          }
        }
      }
      function o(a, l) {
        if (r(a)) {
          var c = [], u = "", d = "", f = "", h = "", p = "", m = "", g = "";
          if (c = n(a), u = c[1], d = c[2], f = c[3], p = c[4], m = c[5], !!u) {
            if (l) {
              if (u.toLowerCase() != "https") return;
            } else if (u.toLowerCase() != "http") return;
            if (d)
              return /:(\d+)$/.test(d) && (h = d.match(/:(\d+)$/)[0], d = d.replace(/:\d+$/, "")), g += u + ":", g += "//" + d, h && (g += h), g += f, p && p.length && (g += "?" + p), m && m.length && (g += "#" + m), g;
          }
        }
      }
      function i(a) {
        return o(a, !0);
      }
      function s(a) {
        return o(a) || i(a);
      }
    })(t);
  }(lq)), lq.exports;
}
oHe();
var vo = {}, qN = { exports: {} }, iHe = qN.exports, uq;
function sHe() {
  return uq || (uq = 1, function(t) {
    (function(e, n) {
      t.exports ? t.exports = n() : e.nearley = n();
    })(iHe, function() {
      function e(c, u, d) {
        return this.id = ++e.highestId, this.name = c, this.symbols = u, this.postprocess = d, this;
      }
      e.highestId = 0, e.prototype.toString = function(c) {
        var u = typeof c > "u" ? this.symbols.map(l).join(" ") : this.symbols.slice(0, c).map(l).join(" ") + " ● " + this.symbols.slice(c).map(l).join(" ");
        return this.name + " → " + u;
      };
      function n(c, u, d, f) {
        this.rule = c, this.dot = u, this.reference = d, this.data = [], this.wantedBy = f, this.isComplete = this.dot === c.symbols.length;
      }
      n.prototype.toString = function() {
        return "{" + this.rule.toString(this.dot) + "}, from: " + (this.reference || 0);
      }, n.prototype.nextState = function(c) {
        var u = new n(this.rule, this.dot + 1, this.reference, this.wantedBy);
        return u.left = this, u.right = c, u.isComplete && (u.data = u.build(), u.right = void 0), u;
      }, n.prototype.build = function() {
        var c = [], u = this;
        do
          c.push(u.right.data), u = u.left;
        while (u.left);
        return c.reverse(), c;
      }, n.prototype.finish = function() {
        this.rule.postprocess && (this.data = this.rule.postprocess(this.data, this.reference, s.fail));
      };
      function r(c, u) {
        this.grammar = c, this.index = u, this.states = [], this.wants = {}, this.scannable = [], this.completed = {};
      }
      r.prototype.process = function(c) {
        for (var u = this.states, d = this.wants, f = this.completed, h = 0; h < u.length; h++) {
          var p = u[h];
          if (p.isComplete) {
            if (p.finish(), p.data !== s.fail) {
              for (var m = p.wantedBy, g = m.length; g--; ) {
                var y = m[g];
                this.complete(y, p);
              }
              if (p.reference === this.index) {
                var v = p.rule.name;
                (this.completed[v] = this.completed[v] || []).push(p);
              }
            }
          } else {
            var v = p.rule.symbols[p.dot];
            if (typeof v != "string") {
              this.scannable.push(p);
              continue;
            }
            if (d[v]) {
              if (d[v].push(p), f.hasOwnProperty(v))
                for (var b = f[v], g = 0; g < b.length; g++) {
                  var _ = b[g];
                  this.complete(p, _);
                }
            } else
              d[v] = [p], this.predict(v);
          }
        }
      }, r.prototype.predict = function(c) {
        for (var u = this.grammar.byName[c] || [], d = 0; d < u.length; d++) {
          var f = u[d], h = this.wants[c], p = new n(f, 0, this.index, h);
          this.states.push(p);
        }
      }, r.prototype.complete = function(c, u) {
        var d = c.nextState(u);
        this.states.push(d);
      };
      function o(c, u) {
        this.rules = c, this.start = u || this.rules[0].name;
        var d = this.byName = {};
        this.rules.forEach(function(f) {
          d.hasOwnProperty(f.name) || (d[f.name] = []), d[f.name].push(f);
        });
      }
      o.fromCompiled = function(f, u) {
        var d = f.Lexer;
        f.ParserStart && (u = f.ParserStart, f = f.ParserRules);
        var f = f.map(function(p) {
          return new e(p.name, p.symbols, p.postprocess);
        }), h = new o(f, u);
        return h.lexer = d, h;
      };
      function i() {
        this.reset("");
      }
      i.prototype.reset = function(c, u) {
        this.buffer = c, this.index = 0, this.line = u ? u.line : 1, this.lastLineBreak = u ? -u.col : 0;
      }, i.prototype.next = function() {
        if (this.index < this.buffer.length) {
          var c = this.buffer[this.index++];
          return c === `
` && (this.line += 1, this.lastLineBreak = this.index), { value: c };
        }
      }, i.prototype.save = function() {
        return {
          line: this.line,
          col: this.index - this.lastLineBreak
        };
      }, i.prototype.formatError = function(c, u) {
        var d = this.buffer;
        if (typeof d == "string") {
          var f = d.split(`
`).slice(
            Math.max(0, this.line - 5),
            this.line
          ), h = d.indexOf(`
`, this.index);
          h === -1 && (h = d.length);
          var p = this.index - this.lastLineBreak, m = String(this.line).length;
          return u += " at line " + this.line + " col " + p + `:

`, u += f.map(function(y, v) {
            return g(this.line - f.length + v + 1, m) + " " + y;
          }, this).join(`
`), u += `
` + g("", m + p) + `^
`, u;
        } else
          return u + " at index " + (this.index - 1);
        function g(y, v) {
          var b = String(y);
          return Array(v - b.length + 1).join(" ") + b;
        }
      };
      function s(c, u, f) {
        if (c instanceof o)
          var h = c, f = u;
        else
          var h = o.fromCompiled(c, u);
        this.grammar = h, this.options = {
          keepHistory: !1,
          lexer: h.lexer || new i()
        };
        for (var p in f || {})
          this.options[p] = f[p];
        this.lexer = this.options.lexer, this.lexerState = void 0;
        var m = new r(h, 0);
        this.table = [m], m.wants[h.start] = [], m.predict(h.start), m.process(), this.current = 0;
      }
      s.fail = {}, s.prototype.feed = function(c) {
        var u = this.lexer;
        u.reset(c, this.lexerState);
        for (var d; ; ) {
          try {
            if (d = u.next(), !d)
              break;
          } catch (E) {
            var m = new r(this.grammar, this.current + 1);
            this.table.push(m);
            var f = new Error(this.reportLexerError(E));
            throw f.offset = this.current, f.token = E.token, f;
          }
          var h = this.table[this.current];
          this.options.keepHistory || delete this.table[this.current - 1];
          var p = this.current + 1, m = new r(this.grammar, p);
          this.table.push(m);
          for (var g = d.text !== void 0 ? d.text : d.value, y = u.constructor === i ? d.value : d, v = h.scannable, b = v.length; b--; ) {
            var _ = v[b], w = _.rule.symbols[_.dot];
            if (w.test ? w.test(y) : w.type ? w.type === d.type : w.literal === g) {
              var x = _.nextState({ data: y, token: d, isToken: !0, reference: p - 1 });
              m.states.push(x);
            }
          }
          if (m.process(), m.states.length === 0) {
            var f = new Error(this.reportError(d));
            throw f.offset = this.current, f.token = d, f;
          }
          this.options.keepHistory && (h.lexerState = u.save()), this.current++;
        }
        return h && (this.lexerState = u.save()), this.results = this.finish(), this;
      }, s.prototype.reportLexerError = function(c) {
        var u, d, f = c.token;
        return f ? (u = "input " + JSON.stringify(f.text[0]) + " (lexer error)", d = this.lexer.formatError(f, "Syntax error")) : (u = "input (lexer error)", d = c.message), this.reportErrorCommon(d, u);
      }, s.prototype.reportError = function(c) {
        var u = (c.type ? c.type + " token: " : "") + JSON.stringify(c.value !== void 0 ? c.value : c), d = this.lexer.formatError(c, "Syntax error");
        return this.reportErrorCommon(d, u);
      }, s.prototype.reportErrorCommon = function(c, u) {
        var d = [];
        d.push(c);
        var f = this.table.length - 2, h = this.table[f], p = h.states.filter(function(g) {
          var y = g.rule.symbols[g.dot];
          return y && typeof y != "string";
        });
        if (p.length === 0)
          d.push("Unexpected " + u + `. I did not expect any more input. Here is the state of my parse table:
`), this.displayStateStack(h.states, d);
        else {
          d.push("Unexpected " + u + `. Instead, I was expecting to see one of the following:
`);
          var m = p.map(function(g) {
            return this.buildFirstStateStack(g, []) || [g];
          }, this);
          m.forEach(function(g) {
            var y = g[0], v = y.rule.symbols[y.dot], b = this.getSymbolDisplay(v);
            d.push("A " + b + " based on:"), this.displayStateStack(g, d);
          }, this);
        }
        return d.push(""), d.join(`
`);
      }, s.prototype.displayStateStack = function(c, u) {
        for (var d, f = 0, h = 0; h < c.length; h++) {
          var p = c[h], m = p.rule.toString(p.dot);
          m === d ? f++ : (f > 0 && u.push("    ^ " + f + " more lines identical to this"), f = 0, u.push("    " + m)), d = m;
        }
      }, s.prototype.getSymbolDisplay = function(c) {
        return a(c);
      }, s.prototype.buildFirstStateStack = function(c, u) {
        if (u.indexOf(c) !== -1)
          return null;
        if (c.wantedBy.length === 0)
          return [c];
        var d = c.wantedBy[0], f = [c].concat(u), h = this.buildFirstStateStack(d, f);
        return h === null ? null : [c].concat(h);
      }, s.prototype.save = function() {
        var c = this.table[this.current];
        return c.lexerState = this.lexerState, c;
      }, s.prototype.restore = function(c) {
        var u = c.index;
        this.current = u, this.table[u] = c, this.table.splice(u + 1), this.lexerState = c.lexerState, this.results = this.finish();
      }, s.prototype.rewind = function(c) {
        if (!this.options.keepHistory)
          throw new Error("set option `keepHistory` to enable rewinding");
        this.restore(this.table[c]);
      }, s.prototype.finish = function() {
        var c = [], u = this.grammar.start, d = this.table[this.table.length - 1];
        return d.states.forEach(function(f) {
          f.rule.name === u && f.dot === f.rule.symbols.length && f.reference === 0 && f.data !== s.fail && c.push(f);
        }), c.map(function(f) {
          return f.data;
        });
      };
      function a(c) {
        var u = typeof c;
        if (u === "string")
          return c;
        if (u === "object") {
          if (c.literal)
            return JSON.stringify(c.literal);
          if (c instanceof RegExp)
            return "character matching " + c;
          if (c.type)
            return c.type + " token";
          if (c.test)
            return "token matching " + String(c.test);
          throw new Error("Unknown symbol type: " + c);
        }
      }
      function l(c) {
        var u = typeof c;
        if (u === "string")
          return c;
        if (u === "object") {
          if (c.literal)
            return JSON.stringify(c.literal);
          if (c instanceof RegExp)
            return c.toString();
          if (c.type)
            return "%" + c.type;
          if (c.test)
            return "<" + String(c.test) + ">";
          throw new Error("Unknown symbol type: " + c);
        }
      }
      return {
        Parser: s,
        Grammar: o,
        Rule: e
      };
    });
  }(qN)), qN.exports;
}
var Yb = {}, dq;
function aHe() {
  if (dq) return Yb;
  dq = 1, Object.defineProperty(Yb, "__esModule", { value: !0 });
  function t(o) {
    return o[0];
  }
  const e = (o) => [].concat(...o.map((i) => Array.isArray(i) ? e(i) : i));
  function n(o) {
    return o ? Array.isArray(o) ? e(o).join("") : o : "";
  }
  const r = {
    Lexer: void 0,
    ParserRules: [
      { name: "Reverse_path", symbols: ["Path"] },
      { name: "Reverse_path$string$1", symbols: [{ literal: "<" }, { literal: ">" }], postprocess: (o) => o.join("") },
      { name: "Reverse_path", symbols: ["Reverse_path$string$1"] },
      { name: "Forward_path$subexpression$1$subexpression$1", symbols: [{ literal: "<" }, /[pP]/, /[oO]/, /[sS]/, /[tT]/, /[mM]/, /[aA]/, /[sS]/, /[tT]/, /[eE]/, /[rR]/, { literal: "@" }], postprocess: function(o) {
        return o.join("");
      } },
      { name: "Forward_path$subexpression$1", symbols: ["Forward_path$subexpression$1$subexpression$1", "Domain", { literal: ">" }] },
      { name: "Forward_path", symbols: ["Forward_path$subexpression$1"] },
      { name: "Forward_path$subexpression$2", symbols: [{ literal: "<" }, /[pP]/, /[oO]/, /[sS]/, /[tT]/, /[mM]/, /[aA]/, /[sS]/, /[tT]/, /[eE]/, /[rR]/, { literal: ">" }], postprocess: function(o) {
        return o.join("");
      } },
      { name: "Forward_path", symbols: ["Forward_path$subexpression$2"] },
      { name: "Forward_path", symbols: ["Path"] },
      { name: "Path$ebnf$1$subexpression$1", symbols: ["A_d_l", { literal: ":" }] },
      { name: "Path$ebnf$1", symbols: ["Path$ebnf$1$subexpression$1"], postprocess: t },
      { name: "Path$ebnf$1", symbols: [], postprocess: () => null },
      { name: "Path", symbols: [{ literal: "<" }, "Path$ebnf$1", "Mailbox", { literal: ">" }] },
      { name: "A_d_l$ebnf$1", symbols: [] },
      { name: "A_d_l$ebnf$1$subexpression$1", symbols: [{ literal: "," }, "At_domain"] },
      { name: "A_d_l$ebnf$1", symbols: ["A_d_l$ebnf$1", "A_d_l$ebnf$1$subexpression$1"], postprocess: (o) => o[0].concat([o[1]]) },
      { name: "A_d_l", symbols: ["At_domain", "A_d_l$ebnf$1"] },
      { name: "At_domain", symbols: [{ literal: "@" }, "Domain"] },
      { name: "Domain$ebnf$1", symbols: [] },
      { name: "Domain$ebnf$1$subexpression$1", symbols: [{ literal: "." }, "sub_domain"] },
      { name: "Domain$ebnf$1", symbols: ["Domain$ebnf$1", "Domain$ebnf$1$subexpression$1"], postprocess: (o) => o[0].concat([o[1]]) },
      { name: "Domain", symbols: ["sub_domain", "Domain$ebnf$1"] },
      { name: "sub_domain", symbols: ["U_label"] },
      { name: "Let_dig", symbols: ["ALPHA_DIGIT"], postprocess: t },
      { name: "Ldh_str$ebnf$1", symbols: [] },
      { name: "Ldh_str$ebnf$1", symbols: ["Ldh_str$ebnf$1", "ALPHA_DIG_DASH"], postprocess: (o) => o[0].concat([o[1]]) },
      { name: "Ldh_str", symbols: ["Ldh_str$ebnf$1", "Let_dig"] },
      { name: "U_Let_dig", symbols: ["ALPHA_DIGIT_U"], postprocess: t },
      { name: "U_Ldh_str$ebnf$1", symbols: [] },
      { name: "U_Ldh_str$ebnf$1", symbols: ["U_Ldh_str$ebnf$1", "ALPHA_DIG_DASH_U"], postprocess: (o) => o[0].concat([o[1]]) },
      { name: "U_Ldh_str", symbols: ["U_Ldh_str$ebnf$1", "U_Let_dig"] },
      { name: "U_label$ebnf$1$subexpression$1", symbols: ["U_Ldh_str"] },
      { name: "U_label$ebnf$1", symbols: ["U_label$ebnf$1$subexpression$1"], postprocess: t },
      { name: "U_label$ebnf$1", symbols: [], postprocess: () => null },
      { name: "U_label", symbols: ["U_Let_dig", "U_label$ebnf$1"] },
      { name: "address_literal$subexpression$1", symbols: ["IPv4_address_literal"] },
      { name: "address_literal$subexpression$1", symbols: ["IPv6_address_literal"] },
      { name: "address_literal$subexpression$1", symbols: ["General_address_literal"] },
      { name: "address_literal", symbols: [{ literal: "[" }, "address_literal$subexpression$1", { literal: "]" }] },
      {
        name: "non_local_part",
        symbols: ["Domain"],
        postprocess: function(o) {
          return { DomainName: n(o[0]) };
        }
      },
      {
        name: "non_local_part",
        symbols: ["address_literal"],
        postprocess: function(o) {
          return { AddressLiteral: n(o[0]) };
        }
      },
      {
        name: "Mailbox",
        symbols: ["Local_part", { literal: "@" }, "non_local_part"],
        postprocess: function(o) {
          return { localPart: n(o[0]), domainPart: n(o[2]) };
        }
      },
      {
        name: "Local_part",
        symbols: ["Dot_string"],
        postprocess: function(o) {
          return { DotString: n(o[0]) };
        }
      },
      {
        name: "Local_part",
        symbols: ["Quoted_string"],
        postprocess: function(o) {
          return { QuotedString: n(o[0]) };
        }
      },
      { name: "Dot_string$ebnf$1", symbols: [] },
      { name: "Dot_string$ebnf$1$subexpression$1", symbols: [{ literal: "." }, "Atom"] },
      { name: "Dot_string$ebnf$1", symbols: ["Dot_string$ebnf$1", "Dot_string$ebnf$1$subexpression$1"], postprocess: (o) => o[0].concat([o[1]]) },
      { name: "Dot_string", symbols: ["Atom", "Dot_string$ebnf$1"] },
      { name: "Atom$ebnf$1", symbols: [/[0-9A-Za-z!#$%&'*+\-/=?^_`{|}~\u0080-\uFFFF/]/] },
      { name: "Atom$ebnf$1", symbols: ["Atom$ebnf$1", /[0-9A-Za-z!#$%&'*+\-/=?^_`{|}~\u0080-\uFFFF/]/], postprocess: (o) => o[0].concat([o[1]]) },
      { name: "Atom", symbols: ["Atom$ebnf$1"] },
      { name: "Quoted_string$ebnf$1", symbols: [] },
      { name: "Quoted_string$ebnf$1", symbols: ["Quoted_string$ebnf$1", "QcontentSMTP"], postprocess: (o) => o[0].concat([o[1]]) },
      { name: "Quoted_string", symbols: ["DQUOTE", "Quoted_string$ebnf$1", "DQUOTE"] },
      { name: "QcontentSMTP", symbols: ["qtextSMTP"] },
      { name: "QcontentSMTP", symbols: ["quoted_pairSMTP"] },
      { name: "quoted_pairSMTP", symbols: [{ literal: "\\" }, /[\x20-\x7e]/] },
      { name: "qtextSMTP", symbols: [/[\x20-\x21\x23-\x5b\x5d-\x7e\u0080-\uFFFF]/], postprocess: t },
      { name: "IPv4_address_literal$macrocall$2", symbols: [{ literal: "." }, "Snum"] },
      { name: "IPv4_address_literal$macrocall$1", symbols: ["IPv4_address_literal$macrocall$2", "IPv4_address_literal$macrocall$2", "IPv4_address_literal$macrocall$2"] },
      { name: "IPv4_address_literal", symbols: ["Snum", "IPv4_address_literal$macrocall$1"] },
      { name: "IPv6_address_literal$subexpression$1", symbols: [/[iI]/, /[pP]/, /[vV]/, { literal: "6" }, { literal: ":" }], postprocess: function(o) {
        return o.join("");
      } },
      { name: "IPv6_address_literal", symbols: ["IPv6_address_literal$subexpression$1", "IPv6_addr"] },
      { name: "General_address_literal$ebnf$1", symbols: ["dcontent"] },
      { name: "General_address_literal$ebnf$1", symbols: ["General_address_literal$ebnf$1", "dcontent"], postprocess: (o) => o[0].concat([o[1]]) },
      { name: "General_address_literal", symbols: ["Standardized_tag", { literal: ":" }, "General_address_literal$ebnf$1"] },
      { name: "Standardized_tag", symbols: ["Ldh_str"] },
      { name: "dcontent", symbols: [/[\x21-\x5a\x5e-\x7e]/], postprocess: t },
      { name: "Snum", symbols: ["DIGIT"] },
      { name: "Snum$subexpression$1", symbols: [/[1-9]/, "DIGIT"] },
      { name: "Snum", symbols: ["Snum$subexpression$1"] },
      { name: "Snum$subexpression$2", symbols: [{ literal: "1" }, "DIGIT", "DIGIT"] },
      { name: "Snum", symbols: ["Snum$subexpression$2"] },
      { name: "Snum$subexpression$3", symbols: [{ literal: "2" }, /[0-4]/, "DIGIT"] },
      { name: "Snum", symbols: ["Snum$subexpression$3"] },
      { name: "Snum$subexpression$4", symbols: [{ literal: "2" }, { literal: "5" }, /[0-5]/] },
      { name: "Snum", symbols: ["Snum$subexpression$4"] },
      { name: "IPv6_addr", symbols: ["IPv6_full"] },
      { name: "IPv6_addr", symbols: ["IPv6_comp"] },
      { name: "IPv6_addr", symbols: ["IPv6v4_full"] },
      { name: "IPv6_addr", symbols: ["IPv6v4_comp"] },
      { name: "IPv6_hex", symbols: ["HEXDIG"] },
      { name: "IPv6_hex$subexpression$1", symbols: ["HEXDIG", "HEXDIG"] },
      { name: "IPv6_hex", symbols: ["IPv6_hex$subexpression$1"] },
      { name: "IPv6_hex$subexpression$2", symbols: ["HEXDIG", "HEXDIG", "HEXDIG"] },
      { name: "IPv6_hex", symbols: ["IPv6_hex$subexpression$2"] },
      { name: "IPv6_hex$subexpression$3", symbols: ["HEXDIG", "HEXDIG", "HEXDIG", "HEXDIG"] },
      { name: "IPv6_hex", symbols: ["IPv6_hex$subexpression$3"] },
      { name: "IPv6_full$macrocall$2", symbols: [{ literal: ":" }, "IPv6_hex"] },
      { name: "IPv6_full$macrocall$1", symbols: ["IPv6_full$macrocall$2", "IPv6_full$macrocall$2", "IPv6_full$macrocall$2", "IPv6_full$macrocall$2", "IPv6_full$macrocall$2", "IPv6_full$macrocall$2", "IPv6_full$macrocall$2"] },
      { name: "IPv6_full", symbols: ["IPv6_hex", "IPv6_full$macrocall$1"] },
      { name: "IPv6_comp$ebnf$1$subexpression$1$macrocall$2", symbols: [{ literal: ":" }, "IPv6_hex"] },
      { name: "IPv6_comp$ebnf$1$subexpression$1$macrocall$1", symbols: ["IPv6_comp$ebnf$1$subexpression$1$macrocall$2", "IPv6_comp$ebnf$1$subexpression$1$macrocall$2", "IPv6_comp$ebnf$1$subexpression$1$macrocall$2", "IPv6_comp$ebnf$1$subexpression$1$macrocall$2", "IPv6_comp$ebnf$1$subexpression$1$macrocall$2"] },
      { name: "IPv6_comp$ebnf$1$subexpression$1", symbols: ["IPv6_hex", "IPv6_comp$ebnf$1$subexpression$1$macrocall$1"] },
      { name: "IPv6_comp$ebnf$1", symbols: ["IPv6_comp$ebnf$1$subexpression$1"], postprocess: t },
      { name: "IPv6_comp$ebnf$1", symbols: [], postprocess: () => null },
      { name: "IPv6_comp$string$1", symbols: [{ literal: ":" }, { literal: ":" }], postprocess: (o) => o.join("") },
      { name: "IPv6_comp$ebnf$2$subexpression$1$macrocall$2", symbols: [{ literal: ":" }, "IPv6_hex"] },
      { name: "IPv6_comp$ebnf$2$subexpression$1$macrocall$1", symbols: ["IPv6_comp$ebnf$2$subexpression$1$macrocall$2", "IPv6_comp$ebnf$2$subexpression$1$macrocall$2", "IPv6_comp$ebnf$2$subexpression$1$macrocall$2", "IPv6_comp$ebnf$2$subexpression$1$macrocall$2", "IPv6_comp$ebnf$2$subexpression$1$macrocall$2"] },
      { name: "IPv6_comp$ebnf$2$subexpression$1", symbols: ["IPv6_hex", "IPv6_comp$ebnf$2$subexpression$1$macrocall$1"] },
      { name: "IPv6_comp$ebnf$2", symbols: ["IPv6_comp$ebnf$2$subexpression$1"], postprocess: t },
      { name: "IPv6_comp$ebnf$2", symbols: [], postprocess: () => null },
      { name: "IPv6_comp", symbols: ["IPv6_comp$ebnf$1", "IPv6_comp$string$1", "IPv6_comp$ebnf$2"] },
      { name: "IPv6v4_full$macrocall$2", symbols: [{ literal: ":" }, "IPv6_hex"] },
      { name: "IPv6v4_full$macrocall$1", symbols: ["IPv6v4_full$macrocall$2", "IPv6v4_full$macrocall$2", "IPv6v4_full$macrocall$2", "IPv6v4_full$macrocall$2", "IPv6v4_full$macrocall$2"] },
      { name: "IPv6v4_full", symbols: ["IPv6_hex", "IPv6v4_full$macrocall$1", { literal: ":" }, "IPv4_address_literal"] },
      { name: "IPv6v4_comp$ebnf$1$subexpression$1$macrocall$2", symbols: [{ literal: ":" }, "IPv6_hex"] },
      { name: "IPv6v4_comp$ebnf$1$subexpression$1$macrocall$1", symbols: ["IPv6v4_comp$ebnf$1$subexpression$1$macrocall$2", "IPv6v4_comp$ebnf$1$subexpression$1$macrocall$2", "IPv6v4_comp$ebnf$1$subexpression$1$macrocall$2"] },
      { name: "IPv6v4_comp$ebnf$1$subexpression$1", symbols: ["IPv6_hex", "IPv6v4_comp$ebnf$1$subexpression$1$macrocall$1"] },
      { name: "IPv6v4_comp$ebnf$1", symbols: ["IPv6v4_comp$ebnf$1$subexpression$1"], postprocess: t },
      { name: "IPv6v4_comp$ebnf$1", symbols: [], postprocess: () => null },
      { name: "IPv6v4_comp$string$1", symbols: [{ literal: ":" }, { literal: ":" }], postprocess: (o) => o.join("") },
      { name: "IPv6v4_comp$ebnf$2$subexpression$1$macrocall$2", symbols: [{ literal: ":" }, "IPv6_hex"] },
      { name: "IPv6v4_comp$ebnf$2$subexpression$1$macrocall$1", symbols: ["IPv6v4_comp$ebnf$2$subexpression$1$macrocall$2", "IPv6v4_comp$ebnf$2$subexpression$1$macrocall$2", "IPv6v4_comp$ebnf$2$subexpression$1$macrocall$2"] },
      { name: "IPv6v4_comp$ebnf$2$subexpression$1", symbols: ["IPv6_hex", "IPv6v4_comp$ebnf$2$subexpression$1$macrocall$1", { literal: ":" }] },
      { name: "IPv6v4_comp$ebnf$2", symbols: ["IPv6v4_comp$ebnf$2$subexpression$1"], postprocess: t },
      { name: "IPv6v4_comp$ebnf$2", symbols: [], postprocess: () => null },
      { name: "IPv6v4_comp", symbols: ["IPv6v4_comp$ebnf$1", "IPv6v4_comp$string$1", "IPv6v4_comp$ebnf$2", "IPv4_address_literal"] },
      { name: "DIGIT", symbols: [/[0-9]/], postprocess: t },
      { name: "ALPHA_DIGIT_U", symbols: [/[0-9A-Za-z\u0080-\uFFFF]/], postprocess: t },
      { name: "ALPHA_DIGIT", symbols: [/[0-9A-Za-z]/], postprocess: t },
      { name: "ALPHA_DIG_DASH", symbols: [/[-0-9A-Za-z]/], postprocess: t },
      { name: "ALPHA_DIG_DASH_U", symbols: [/[-0-9A-Za-z\u0080-\uFFFF]/], postprocess: t },
      { name: "HEXDIG", symbols: [/[0-9A-Fa-f]/], postprocess: t },
      { name: "DQUOTE", symbols: [{ literal: '"' }], postprocess: t }
    ],
    ParserStart: "Reverse_path"
  };
  return Yb.default = r, Yb;
}
var fq;
function lHe() {
  if (fq) return vo;
  fq = 1;
  var t = vo && vo.__importDefault || function(c) {
    return c && c.__esModule ? c : { default: c };
  };
  Object.defineProperty(vo, "__esModule", { value: !0 }), vo.canonicalize = vo.canonicalize_quoted_string = vo.normalize = vo.normalize_dot_string = vo.parse = void 0;
  const e = sHe(), n = t(aHe());
  n.default.ParserStart = "Mailbox";
  const r = e.Grammar.fromCompiled(n.default);
  function o(c) {
    const u = new e.Parser(r);
    if (u.feed(c), u.results.length !== 1)
      throw new Error("address parsing failed: ambiguous grammar");
    return u.results[0];
  }
  vo.parse = o;
  function i(c) {
    return function() {
      const u = c.indexOf("+");
      return u === -1 ? c : c.substr(0, u);
    }().replace(/\./g, "").toLowerCase();
  }
  vo.normalize_dot_string = i;
  function s(c) {
    var u, d;
    const f = o(c), h = (u = f.domainPart.AddressLiteral) !== null && u !== void 0 ? u : f.domainPart.DomainName.toLowerCase();
    return `${(d = f.localPart.QuotedString) !== null && d !== void 0 ? d : i(f.localPart.DotString)}@${h}`;
  }
  vo.normalize = s;
  function a(c) {
    return `"${c.substr(1).substr(0, c.length - 2).replace(/(?:\\(.))/g, "$1").replace(/(?:(["\\]))/g, "\\$1")}"`;
  }
  vo.canonicalize_quoted_string = a;
  function l(c) {
    var u;
    const d = o(c), f = (u = d.domainPart.AddressLiteral) !== null && u !== void 0 ? u : d.domainPart.DomainName.toLowerCase();
    return `${d.localPart.QuotedString ? a(d.localPart.QuotedString) : d.localPart.DotString}@${f}`;
  }
  return vo.canonicalize = l, vo;
}
lHe();
const hq = {};
function cHe(t) {
  let e = hq[t];
  if (e)
    return e;
  e = hq[t] = [];
  for (let n = 0; n < 128; n++) {
    const r = String.fromCharCode(n);
    e.push(r);
  }
  for (let n = 0; n < t.length; n++) {
    const r = t.charCodeAt(n);
    e[r] = "%" + ("0" + r.toString(16).toUpperCase()).slice(-2);
  }
  return e;
}
function np(t, e) {
  typeof e != "string" && (e = np.defaultChars);
  const n = cHe(e);
  return t.replace(/(%[a-f0-9]{2})+/gi, function(r) {
    let o = "";
    for (let i = 0, s = r.length; i < s; i += 3) {
      const a = parseInt(r.slice(i + 1, i + 3), 16);
      if (a < 128) {
        o += n[a];
        continue;
      }
      if ((a & 224) === 192 && i + 3 < s) {
        const l = parseInt(r.slice(i + 4, i + 6), 16);
        if ((l & 192) === 128) {
          const c = a << 6 & 1984 | l & 63;
          c < 128 ? o += "��" : o += String.fromCharCode(c), i += 3;
          continue;
        }
      }
      if ((a & 240) === 224 && i + 6 < s) {
        const l = parseInt(r.slice(i + 4, i + 6), 16), c = parseInt(r.slice(i + 7, i + 9), 16);
        if ((l & 192) === 128 && (c & 192) === 128) {
          const u = a << 12 & 61440 | l << 6 & 4032 | c & 63;
          u < 2048 || u >= 55296 && u <= 57343 ? o += "���" : o += String.fromCharCode(u), i += 6;
          continue;
        }
      }
      if ((a & 248) === 240 && i + 9 < s) {
        const l = parseInt(r.slice(i + 4, i + 6), 16), c = parseInt(r.slice(i + 7, i + 9), 16), u = parseInt(r.slice(i + 10, i + 12), 16);
        if ((l & 192) === 128 && (c & 192) === 128 && (u & 192) === 128) {
          let d = a << 18 & 1835008 | l << 12 & 258048 | c << 6 & 4032 | u & 63;
          d < 65536 || d > 1114111 ? o += "����" : (d -= 65536, o += String.fromCharCode(55296 + (d >> 10), 56320 + (d & 1023))), i += 9;
          continue;
        }
      }
      o += "�";
    }
    return o;
  });
}
np.defaultChars = ";/?:@&=+$,#";
np.componentChars = "";
const pq = {};
function uHe(t) {
  let e = pq[t];
  if (e)
    return e;
  e = pq[t] = [];
  for (let n = 0; n < 128; n++) {
    const r = String.fromCharCode(n);
    /^[0-9a-z]$/i.test(r) ? e.push(r) : e.push("%" + ("0" + n.toString(16).toUpperCase()).slice(-2));
  }
  for (let n = 0; n < t.length; n++)
    e[t.charCodeAt(n)] = t[n];
  return e;
}
function vv(t, e, n) {
  typeof e != "string" && (n = e, e = vv.defaultChars), typeof n > "u" && (n = !0);
  const r = uHe(e);
  let o = "";
  for (let i = 0, s = t.length; i < s; i++) {
    const a = t.charCodeAt(i);
    if (n && a === 37 && i + 2 < s && /^[0-9a-f]{2}$/i.test(t.slice(i + 1, i + 3))) {
      o += t.slice(i, i + 3), i += 2;
      continue;
    }
    if (a < 128) {
      o += r[a];
      continue;
    }
    if (a >= 55296 && a <= 57343) {
      if (a >= 55296 && a <= 56319 && i + 1 < s) {
        const l = t.charCodeAt(i + 1);
        if (l >= 56320 && l <= 57343) {
          o += encodeURIComponent(t[i] + t[i + 1]), i++;
          continue;
        }
      }
      o += "%EF%BF%BD";
      continue;
    }
    o += encodeURIComponent(t[i]);
  }
  return o;
}
vv.defaultChars = ";/?:@&=+$,-_.!~*'()#";
vv.componentChars = "-_.!~*'()";
function IL(t) {
  let e = "";
  return e += t.protocol || "", e += t.slashes ? "//" : "", e += t.auth ? t.auth + "@" : "", t.hostname && t.hostname.indexOf(":") !== -1 ? e += "[" + t.hostname + "]" : e += t.hostname || "", e += t.port ? ":" + t.port : "", e += t.pathname || "", e += t.search || "", e += t.hash || "", e;
}
function Ux() {
  this.protocol = null, this.slashes = null, this.auth = null, this.port = null, this.hostname = null, this.hash = null, this.search = null, this.pathname = null;
}
const dHe = /^([a-z0-9.+-]+:)/i, fHe = /:[0-9]*$/, hHe = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/, pHe = ["<", ">", '"', "`", " ", "\r", `
`, "	"], mHe = ["{", "}", "|", "\\", "^", "`"].concat(pHe), gHe = ["'"].concat(mHe), mq = ["%", "/", "?", ";", "#"].concat(gHe), gq = ["/", "?", "#"], yHe = 255, yq = /^[+a-z0-9A-Z_-]{0,63}$/, vHe = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, vq = {
  javascript: !0,
  "javascript:": !0
}, bq = {
  http: !0,
  https: !0,
  ftp: !0,
  gopher: !0,
  file: !0,
  "http:": !0,
  "https:": !0,
  "ftp:": !0,
  "gopher:": !0,
  "file:": !0
};
function NL(t, e) {
  if (t && t instanceof Ux) return t;
  const n = new Ux();
  return n.parse(t, e), n;
}
Ux.prototype.parse = function(t, e) {
  let n, r, o, i = t;
  if (i = i.trim(), !e && t.split("#").length === 1) {
    const c = hHe.exec(i);
    if (c)
      return this.pathname = c[1], c[2] && (this.search = c[2]), this;
  }
  let s = dHe.exec(i);
  if (s && (s = s[0], n = s.toLowerCase(), this.protocol = s, i = i.substr(s.length)), (e || s || i.match(/^\/\/[^@\/]+@[^@\/]+/)) && (o = i.substr(0, 2) === "//", o && !(s && vq[s]) && (i = i.substr(2), this.slashes = !0)), !vq[s] && (o || s && !bq[s])) {
    let c = -1;
    for (let p = 0; p < gq.length; p++)
      r = i.indexOf(gq[p]), r !== -1 && (c === -1 || r < c) && (c = r);
    let u, d;
    c === -1 ? d = i.lastIndexOf("@") : d = i.lastIndexOf("@", c), d !== -1 && (u = i.slice(0, d), i = i.slice(d + 1), this.auth = u), c = -1;
    for (let p = 0; p < mq.length; p++)
      r = i.indexOf(mq[p]), r !== -1 && (c === -1 || r < c) && (c = r);
    c === -1 && (c = i.length), i[c - 1] === ":" && c--;
    const f = i.slice(0, c);
    i = i.slice(c), this.parseHost(f), this.hostname = this.hostname || "";
    const h = this.hostname[0] === "[" && this.hostname[this.hostname.length - 1] === "]";
    if (!h) {
      const p = this.hostname.split(/\./);
      for (let m = 0, g = p.length; m < g; m++) {
        const y = p[m];
        if (y && !y.match(yq)) {
          let v = "";
          for (let b = 0, _ = y.length; b < _; b++)
            y.charCodeAt(b) > 127 ? v += "x" : v += y[b];
          if (!v.match(yq)) {
            const b = p.slice(0, m), _ = p.slice(m + 1), w = y.match(vHe);
            w && (b.push(w[1]), _.unshift(w[2])), _.length && (i = _.join(".") + i), this.hostname = b.join(".");
            break;
          }
        }
      }
    }
    this.hostname.length > yHe && (this.hostname = ""), h && (this.hostname = this.hostname.substr(1, this.hostname.length - 2));
  }
  const a = i.indexOf("#");
  a !== -1 && (this.hash = i.substr(a), i = i.slice(0, a));
  const l = i.indexOf("?");
  return l !== -1 && (this.search = i.substr(l), i = i.slice(0, l)), i && (this.pathname = i), bq[n] && this.hostname && !this.pathname && (this.pathname = ""), this;
};
Ux.prototype.parseHost = function(t) {
  let e = fHe.exec(t);
  e && (e = e[0], e !== ":" && (this.port = e.substr(1)), t = t.substr(0, t.length - e.length)), t && (this.hostname = t);
};
const bHe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  decode: np,
  encode: vv,
  format: IL,
  parse: NL
}, Symbol.toStringTag, { value: "Module" })), zhe = /[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/, qhe = /[\0-\x1F\x7F-\x9F]/, _He = /[\xAD\u0600-\u0605\u061C\u06DD\u070F\u0890\u0891\u08E2\u180E\u200B-\u200F\u202A-\u202E\u2060-\u2064\u2066-\u206F\uFEFF\uFFF9-\uFFFB]|\uD804[\uDCBD\uDCCD]|\uD80D[\uDC30-\uDC3F]|\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|\uDB40[\uDC01\uDC20-\uDC7F]/, jL = /[!-#%-\*,-\/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061D-\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1B7D\u1B7E\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u2E52-\u2E5D\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDEAD\uDF55-\uDF59\uDF86-\uDF89]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5A\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDEB9\uDF3C-\uDF3E]|\uD806[\uDC3B\uDD44-\uDD46\uDDE2\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2\uDF00-\uDF09]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8\uDF43-\uDF4F\uDFFF]|\uD809[\uDC70-\uDC74]|\uD80B[\uDFF1\uDFF2]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD81B[\uDE97-\uDE9A\uDFE2]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/, Uhe = /[\$\+<->\^`\|~\xA2-\xA6\xA8\xA9\xAC\xAE-\xB1\xB4\xB8\xD7\xF7\u02C2-\u02C5\u02D2-\u02DF\u02E5-\u02EB\u02ED\u02EF-\u02FF\u0375\u0384\u0385\u03F6\u0482\u058D-\u058F\u0606-\u0608\u060B\u060E\u060F\u06DE\u06E9\u06FD\u06FE\u07F6\u07FE\u07FF\u0888\u09F2\u09F3\u09FA\u09FB\u0AF1\u0B70\u0BF3-\u0BFA\u0C7F\u0D4F\u0D79\u0E3F\u0F01-\u0F03\u0F13\u0F15-\u0F17\u0F1A-\u0F1F\u0F34\u0F36\u0F38\u0FBE-\u0FC5\u0FC7-\u0FCC\u0FCE\u0FCF\u0FD5-\u0FD8\u109E\u109F\u1390-\u1399\u166D\u17DB\u1940\u19DE-\u19FF\u1B61-\u1B6A\u1B74-\u1B7C\u1FBD\u1FBF-\u1FC1\u1FCD-\u1FCF\u1FDD-\u1FDF\u1FED-\u1FEF\u1FFD\u1FFE\u2044\u2052\u207A-\u207C\u208A-\u208C\u20A0-\u20C0\u2100\u2101\u2103-\u2106\u2108\u2109\u2114\u2116-\u2118\u211E-\u2123\u2125\u2127\u2129\u212E\u213A\u213B\u2140-\u2144\u214A-\u214D\u214F\u218A\u218B\u2190-\u2307\u230C-\u2328\u232B-\u2426\u2440-\u244A\u249C-\u24E9\u2500-\u2767\u2794-\u27C4\u27C7-\u27E5\u27F0-\u2982\u2999-\u29D7\u29DC-\u29FB\u29FE-\u2B73\u2B76-\u2B95\u2B97-\u2BFF\u2CE5-\u2CEA\u2E50\u2E51\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u2FF0-\u2FFF\u3004\u3012\u3013\u3020\u3036\u3037\u303E\u303F\u309B\u309C\u3190\u3191\u3196-\u319F\u31C0-\u31E3\u31EF\u3200-\u321E\u322A-\u3247\u3250\u3260-\u327F\u328A-\u32B0\u32C0-\u33FF\u4DC0-\u4DFF\uA490-\uA4C6\uA700-\uA716\uA720\uA721\uA789\uA78A\uA828-\uA82B\uA836-\uA839\uAA77-\uAA79\uAB5B\uAB6A\uAB6B\uFB29\uFBB2-\uFBC2\uFD40-\uFD4F\uFDCF\uFDFC-\uFDFF\uFE62\uFE64-\uFE66\uFE69\uFF04\uFF0B\uFF1C-\uFF1E\uFF3E\uFF40\uFF5C\uFF5E\uFFE0-\uFFE6\uFFE8-\uFFEE\uFFFC\uFFFD]|\uD800[\uDD37-\uDD3F\uDD79-\uDD89\uDD8C-\uDD8E\uDD90-\uDD9C\uDDA0\uDDD0-\uDDFC]|\uD802[\uDC77\uDC78\uDEC8]|\uD805\uDF3F|\uD807[\uDFD5-\uDFF1]|\uD81A[\uDF3C-\uDF3F\uDF45]|\uD82F\uDC9C|\uD833[\uDF50-\uDFC3]|\uD834[\uDC00-\uDCF5\uDD00-\uDD26\uDD29-\uDD64\uDD6A-\uDD6C\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDDEA\uDE00-\uDE41\uDE45\uDF00-\uDF56]|\uD835[\uDEC1\uDEDB\uDEFB\uDF15\uDF35\uDF4F\uDF6F\uDF89\uDFA9\uDFC3]|\uD836[\uDC00-\uDDFF\uDE37-\uDE3A\uDE6D-\uDE74\uDE76-\uDE83\uDE85\uDE86]|\uD838[\uDD4F\uDEFF]|\uD83B[\uDCAC\uDCB0\uDD2E\uDEF0\uDEF1]|\uD83C[\uDC00-\uDC2B\uDC30-\uDC93\uDCA0-\uDCAE\uDCB1-\uDCBF\uDCC1-\uDCCF\uDCD1-\uDCF5\uDD0D-\uDDAD\uDDE6-\uDE02\uDE10-\uDE3B\uDE40-\uDE48\uDE50\uDE51\uDE60-\uDE65\uDF00-\uDFFF]|\uD83D[\uDC00-\uDED7\uDEDC-\uDEEC\uDEF0-\uDEFC\uDF00-\uDF76\uDF7B-\uDFD9\uDFE0-\uDFEB\uDFF0]|\uD83E[\uDC00-\uDC0B\uDC10-\uDC47\uDC50-\uDC59\uDC60-\uDC87\uDC90-\uDCAD\uDCB0\uDCB1\uDD00-\uDE53\uDE60-\uDE6D\uDE70-\uDE7C\uDE80-\uDE88\uDE90-\uDEBD\uDEBF-\uDEC5\uDECE-\uDEDB\uDEE0-\uDEE8\uDEF0-\uDEF8\uDF00-\uDF92\uDF94-\uDFCA]/, Hhe = /[ \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]/, wHe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Any: zhe,
  Cc: qhe,
  Cf: _He,
  P: jL,
  S: Uhe,
  Z: Hhe
}, Symbol.toStringTag, { value: "Module" })), xHe = new Uint16Array(
  // prettier-ignore
  'ᵁ<Õıʊҝջאٵ۞ޢߖࠏ੊ઑඡ๭༉༦჊ረዡᐕᒝᓃᓟᔥ\0\0\0\0\0\0ᕫᛍᦍᰒᷝ὾⁠↰⊍⏀⏻⑂⠤⤒ⴈ⹈⿎〖㊺㘹㞬㣾㨨㩱㫠㬮ࠀEMabcfglmnoprstu\\bfms¦³¹ÈÏlig耻Æ䃆P耻&䀦cute耻Á䃁reve;䄂Āiyx}rc耻Â䃂;䐐r;쀀𝔄rave耻À䃀pha;䎑acr;䄀d;橓Āgp¡on;䄄f;쀀𝔸plyFunction;恡ing耻Å䃅Ācs¾Ãr;쀀𝒜ign;扔ilde耻Ã䃃ml耻Ä䃄ЀaceforsuåûþėĜĢħĪĀcrêòkslash;或Ŷöø;櫧ed;挆y;䐑ƀcrtąċĔause;戵noullis;愬a;䎒r;쀀𝔅pf;쀀𝔹eve;䋘còēmpeq;扎܀HOacdefhilorsuōőŖƀƞƢƵƷƺǜȕɳɸɾcy;䐧PY耻©䂩ƀcpyŝŢźute;䄆Ā;iŧŨ拒talDifferentialD;慅leys;愭ȀaeioƉƎƔƘron;䄌dil耻Ç䃇rc;䄈nint;戰ot;䄊ĀdnƧƭilla;䂸terDot;䂷òſi;䎧rcleȀDMPTǇǋǑǖot;抙inus;抖lus;投imes;抗oĀcsǢǸkwiseContourIntegral;戲eCurlyĀDQȃȏoubleQuote;思uote;怙ȀlnpuȞȨɇɕonĀ;eȥȦ户;橴ƀgitȯȶȺruent;扡nt;戯ourIntegral;戮ĀfrɌɎ;愂oduct;成nterClockwiseContourIntegral;戳oss;樯cr;쀀𝒞pĀ;Cʄʅ拓ap;才րDJSZacefiosʠʬʰʴʸˋ˗ˡ˦̳ҍĀ;oŹʥtrahd;椑cy;䐂cy;䐅cy;䐏ƀgrsʿ˄ˇger;怡r;憡hv;櫤Āayː˕ron;䄎;䐔lĀ;t˝˞戇a;䎔r;쀀𝔇Āaf˫̧Ācm˰̢riticalȀADGT̖̜̀̆cute;䂴oŴ̋̍;䋙bleAcute;䋝rave;䁠ilde;䋜ond;拄ferentialD;慆Ѱ̽\0\0\0͔͂\0Ѕf;쀀𝔻ƀ;DE͈͉͍䂨ot;惜qual;扐blèCDLRUVͣͲ΂ϏϢϸontourIntegraìȹoɴ͹\0\0ͻ»͉nArrow;懓Āeo·ΤftƀARTΐΖΡrrow;懐ightArrow;懔eåˊngĀLRΫτeftĀARγιrrow;柸ightArrow;柺ightArrow;柹ightĀATϘϞrrow;懒ee;抨pɁϩ\0\0ϯrrow;懑ownArrow;懕erticalBar;戥ǹABLRTaВЪаўѿͼrrowƀ;BUНОТ憓ar;椓pArrow;懵reve;䌑eft˒к\0ц\0ѐightVector;楐eeVector;楞ectorĀ;Bљњ憽ar;楖ightǔѧ\0ѱeeVector;楟ectorĀ;BѺѻ懁ar;楗eeĀ;A҆҇护rrow;憧ĀctҒҗr;쀀𝒟rok;䄐ࠀNTacdfglmopqstuxҽӀӄӋӞӢӧӮӵԡԯԶՒ՝ՠեG;䅊H耻Ð䃐cute耻É䃉ƀaiyӒӗӜron;䄚rc耻Ê䃊;䐭ot;䄖r;쀀𝔈rave耻È䃈ement;戈ĀapӺӾcr;䄒tyɓԆ\0\0ԒmallSquare;旻erySmallSquare;斫ĀgpԦԪon;䄘f;쀀𝔼silon;䎕uĀaiԼՉlĀ;TՂՃ橵ilde;扂librium;懌Āci՗՚r;愰m;橳a;䎗ml耻Ë䃋Āipժկsts;戃onentialE;慇ʀcfiosօֈ֍ֲ׌y;䐤r;쀀𝔉lledɓ֗\0\0֣mallSquare;旼erySmallSquare;斪Ͱֺ\0ֿ\0\0ׄf;쀀𝔽All;戀riertrf;愱cò׋؀JTabcdfgorstר׬ׯ׺؀ؒؖ؛؝أ٬ٲcy;䐃耻>䀾mmaĀ;d׷׸䎓;䏜reve;䄞ƀeiy؇،ؐdil;䄢rc;䄜;䐓ot;䄠r;쀀𝔊;拙pf;쀀𝔾eater̀EFGLSTصلَٖٛ٦qualĀ;Lؾؿ扥ess;招ullEqual;执reater;檢ess;扷lantEqual;橾ilde;扳cr;쀀𝒢;扫ЀAacfiosuڅڋږڛڞڪھۊRDcy;䐪Āctڐڔek;䋇;䁞irc;䄤r;愌lbertSpace;愋ǰگ\0ڲf;愍izontalLine;攀Āctۃۅòکrok;䄦mpńېۘownHumðįqual;扏܀EJOacdfgmnostuۺ۾܃܇܎ܚܞܡܨ݄ݸދޏޕcy;䐕lig;䄲cy;䐁cute耻Í䃍Āiyܓܘrc耻Î䃎;䐘ot;䄰r;愑rave耻Ì䃌ƀ;apܠܯܿĀcgܴܷr;䄪inaryI;慈lieóϝǴ݉\0ݢĀ;eݍݎ戬Āgrݓݘral;戫section;拂isibleĀCTݬݲomma;恣imes;恢ƀgptݿރވon;䄮f;쀀𝕀a;䎙cr;愐ilde;䄨ǫޚ\0ޞcy;䐆l耻Ï䃏ʀcfosuެ޷޼߂ߐĀiyޱ޵rc;䄴;䐙r;쀀𝔍pf;쀀𝕁ǣ߇\0ߌr;쀀𝒥rcy;䐈kcy;䐄΀HJacfosߤߨ߽߬߱ࠂࠈcy;䐥cy;䐌ppa;䎚Āey߶߻dil;䄶;䐚r;쀀𝔎pf;쀀𝕂cr;쀀𝒦րJTaceflmostࠥࠩࠬࡐࡣ঳সে্਷ੇcy;䐉耻<䀼ʀcmnpr࠷࠼ࡁࡄࡍute;䄹bda;䎛g;柪lacetrf;愒r;憞ƀaeyࡗ࡜ࡡron;䄽dil;䄻;䐛Āfsࡨ॰tԀACDFRTUVarࡾࢩࢱࣦ࣠ࣼयज़ΐ४Ānrࢃ࢏gleBracket;柨rowƀ;BR࢙࢚࢞憐ar;懤ightArrow;懆eiling;挈oǵࢷ\0ࣃbleBracket;柦nǔࣈ\0࣒eeVector;楡ectorĀ;Bࣛࣜ懃ar;楙loor;挊ightĀAV࣯ࣵrrow;憔ector;楎Āerँगeƀ;AVउऊऐ抣rrow;憤ector;楚iangleƀ;BEतथऩ抲ar;槏qual;抴pƀDTVषूौownVector;楑eeVector;楠ectorĀ;Bॖॗ憿ar;楘ectorĀ;B॥०憼ar;楒ightáΜs̀EFGLSTॾঋকঝঢভqualGreater;拚ullEqual;扦reater;扶ess;檡lantEqual;橽ilde;扲r;쀀𝔏Ā;eঽা拘ftarrow;懚idot;䄿ƀnpw৔ਖਛgȀLRlr৞৷ਂਐeftĀAR০৬rrow;柵ightArrow;柷ightArrow;柶eftĀarγਊightáοightáϊf;쀀𝕃erĀLRਢਬeftArrow;憙ightArrow;憘ƀchtਾੀੂòࡌ;憰rok;䅁;扪Ѐacefiosuਗ਼੝੠੷੼અઋ઎p;椅y;䐜Ādl੥੯iumSpace;恟lintrf;愳r;쀀𝔐nusPlus;戓pf;쀀𝕄cò੶;䎜ҀJacefostuણધભીଔଙඑ඗ඞcy;䐊cute;䅃ƀaey઴હાron;䅇dil;䅅;䐝ƀgswે૰଎ativeƀMTV૓૟૨ediumSpace;怋hiĀcn૦૘ë૙eryThiî૙tedĀGL૸ଆreaterGreateòٳessLesóੈLine;䀊r;쀀𝔑ȀBnptଢନଷ଺reak;恠BreakingSpace;䂠f;愕ڀ;CDEGHLNPRSTV୕ୖ୪୼஡௫ఄ౞಄ದ೘ൡඅ櫬Āou୛୤ngruent;扢pCap;扭oubleVerticalBar;戦ƀlqxஃஊ஛ement;戉ualĀ;Tஒஓ扠ilde;쀀≂̸ists;戄reater΀;EFGLSTஶஷ஽௉௓௘௥扯qual;扱ullEqual;쀀≧̸reater;쀀≫̸ess;批lantEqual;쀀⩾̸ilde;扵umpń௲௽ownHump;쀀≎̸qual;쀀≏̸eĀfsఊధtTriangleƀ;BEచఛడ拪ar;쀀⧏̸qual;括s̀;EGLSTవశ఼ౄోౘ扮qual;扰reater;扸ess;쀀≪̸lantEqual;쀀⩽̸ilde;扴estedĀGL౨౹reaterGreater;쀀⪢̸essLess;쀀⪡̸recedesƀ;ESಒಓಛ技qual;쀀⪯̸lantEqual;拠ĀeiಫಹverseElement;戌ghtTriangleƀ;BEೋೌ೒拫ar;쀀⧐̸qual;拭ĀquೝഌuareSuĀbp೨೹setĀ;E೰ೳ쀀⊏̸qual;拢ersetĀ;Eഃആ쀀⊐̸qual;拣ƀbcpഓതൎsetĀ;Eഛഞ쀀⊂⃒qual;抈ceedsȀ;ESTലള഻െ抁qual;쀀⪰̸lantEqual;拡ilde;쀀≿̸ersetĀ;E൘൛쀀⊃⃒qual;抉ildeȀ;EFT൮൯൵ൿ扁qual;扄ullEqual;扇ilde;扉erticalBar;戤cr;쀀𝒩ilde耻Ñ䃑;䎝܀Eacdfgmoprstuvලෂ෉෕ෛ෠෧෼ขภยา฿ไlig;䅒cute耻Ó䃓Āiy෎ීrc耻Ô䃔;䐞blac;䅐r;쀀𝔒rave耻Ò䃒ƀaei෮ෲ෶cr;䅌ga;䎩cron;䎟pf;쀀𝕆enCurlyĀDQฎบoubleQuote;怜uote;怘;橔Āclวฬr;쀀𝒪ash耻Ø䃘iŬื฼de耻Õ䃕es;樷ml耻Ö䃖erĀBP๋๠Āar๐๓r;怾acĀek๚๜;揞et;掴arenthesis;揜Ҁacfhilors๿ງຊຏຒດຝະ໼rtialD;戂y;䐟r;쀀𝔓i;䎦;䎠usMinus;䂱Āipຢອncareplanåڝf;愙Ȁ;eio຺ູ໠໤檻cedesȀ;EST່້໏໚扺qual;檯lantEqual;扼ilde;找me;怳Ādp໩໮uct;戏ortionĀ;aȥ໹l;戝Āci༁༆r;쀀𝒫;䎨ȀUfos༑༖༛༟OT耻"䀢r;쀀𝔔pf;愚cr;쀀𝒬؀BEacefhiorsu༾གྷཇའཱིྦྷྪྭ႖ႩႴႾarr;椐G耻®䂮ƀcnrཎནབute;䅔g;柫rĀ;tཛྷཝ憠l;椖ƀaeyཧཬཱron;䅘dil;䅖;䐠Ā;vླྀཹ愜erseĀEUྂྙĀlq྇ྎement;戋uilibrium;懋pEquilibrium;楯r»ཹo;䎡ghtЀACDFTUVa࿁࿫࿳ဢဨၛႇϘĀnr࿆࿒gleBracket;柩rowƀ;BL࿜࿝࿡憒ar;懥eftArrow;懄eiling;按oǵ࿹\0စbleBracket;柧nǔည\0နeeVector;楝ectorĀ;Bဝသ懂ar;楕loor;挋Āerိ၃eƀ;AVဵံြ抢rrow;憦ector;楛iangleƀ;BEၐၑၕ抳ar;槐qual;抵pƀDTVၣၮၸownVector;楏eeVector;楜ectorĀ;Bႂႃ憾ar;楔ectorĀ;B႑႒懀ar;楓Āpuႛ႞f;愝ndImplies;楰ightarrow;懛ĀchႹႼr;愛;憱leDelayed;槴ڀHOacfhimoqstuფჱჷჽᄙᄞᅑᅖᅡᅧᆵᆻᆿĀCcჩხHcy;䐩y;䐨FTcy;䐬cute;䅚ʀ;aeiyᄈᄉᄎᄓᄗ檼ron;䅠dil;䅞rc;䅜;䐡r;쀀𝔖ortȀDLRUᄪᄴᄾᅉownArrow»ОeftArrow»࢚ightArrow»࿝pArrow;憑gma;䎣allCircle;战pf;쀀𝕊ɲᅭ\0\0ᅰt;戚areȀ;ISUᅻᅼᆉᆯ斡ntersection;抓uĀbpᆏᆞsetĀ;Eᆗᆘ抏qual;抑ersetĀ;Eᆨᆩ抐qual;抒nion;抔cr;쀀𝒮ar;拆ȀbcmpᇈᇛሉላĀ;sᇍᇎ拐etĀ;Eᇍᇕqual;抆ĀchᇠህeedsȀ;ESTᇭᇮᇴᇿ扻qual;檰lantEqual;扽ilde;承Tháྌ;我ƀ;esሒሓሣ拑rsetĀ;Eሜም抃qual;抇et»ሓրHRSacfhiorsሾቄ቉ቕ቞ቱቶኟዂወዑORN耻Þ䃞ADE;愢ĀHc቎ቒcy;䐋y;䐦Ābuቚቜ;䀉;䎤ƀaeyብቪቯron;䅤dil;䅢;䐢r;쀀𝔗Āeiቻ኉ǲኀ\0ኇefore;戴a;䎘Ācn኎ኘkSpace;쀀  Space;怉ldeȀ;EFTካኬኲኼ戼qual;扃ullEqual;扅ilde;扈pf;쀀𝕋ipleDot;惛Āctዖዛr;쀀𝒯rok;䅦ૡዷጎጚጦ\0ጬጱ\0\0\0\0\0ጸጽ፷ᎅ\0᏿ᐄᐊᐐĀcrዻጁute耻Ú䃚rĀ;oጇገ憟cir;楉rǣጓ\0጖y;䐎ve;䅬Āiyጞጣrc耻Û䃛;䐣blac;䅰r;쀀𝔘rave耻Ù䃙acr;䅪Ādiፁ፩erĀBPፈ፝Āarፍፐr;䁟acĀekፗፙ;揟et;掵arenthesis;揝onĀ;P፰፱拃lus;抎Āgp፻፿on;䅲f;쀀𝕌ЀADETadps᎕ᎮᎸᏄϨᏒᏗᏳrrowƀ;BDᅐᎠᎤar;椒ownArrow;懅ownArrow;憕quilibrium;楮eeĀ;AᏋᏌ报rrow;憥ownáϳerĀLRᏞᏨeftArrow;憖ightArrow;憗iĀ;lᏹᏺ䏒on;䎥ing;䅮cr;쀀𝒰ilde;䅨ml耻Ü䃜ҀDbcdefosvᐧᐬᐰᐳᐾᒅᒊᒐᒖash;披ar;櫫y;䐒ashĀ;lᐻᐼ抩;櫦Āerᑃᑅ;拁ƀbtyᑌᑐᑺar;怖Ā;iᑏᑕcalȀBLSTᑡᑥᑪᑴar;戣ine;䁼eparator;杘ilde;所ThinSpace;怊r;쀀𝔙pf;쀀𝕍cr;쀀𝒱dash;抪ʀcefosᒧᒬᒱᒶᒼirc;䅴dge;拀r;쀀𝔚pf;쀀𝕎cr;쀀𝒲Ȁfiosᓋᓐᓒᓘr;쀀𝔛;䎞pf;쀀𝕏cr;쀀𝒳ҀAIUacfosuᓱᓵᓹᓽᔄᔏᔔᔚᔠcy;䐯cy;䐇cy;䐮cute耻Ý䃝Āiyᔉᔍrc;䅶;䐫r;쀀𝔜pf;쀀𝕐cr;쀀𝒴ml;䅸ЀHacdefosᔵᔹᔿᕋᕏᕝᕠᕤcy;䐖cute;䅹Āayᕄᕉron;䅽;䐗ot;䅻ǲᕔ\0ᕛoWidtè૙a;䎖r;愨pf;愤cr;쀀𝒵௡ᖃᖊᖐ\0ᖰᖶᖿ\0\0\0\0ᗆᗛᗫᙟ᙭\0ᚕ᚛ᚲᚹ\0ᚾcute耻á䃡reve;䄃̀;Ediuyᖜᖝᖡᖣᖨᖭ戾;쀀∾̳;房rc耻â䃢te肻´̆;䐰lig耻æ䃦Ā;r²ᖺ;쀀𝔞rave耻à䃠ĀepᗊᗖĀfpᗏᗔsym;愵èᗓha;䎱ĀapᗟcĀclᗤᗧr;䄁g;樿ɤᗰ\0\0ᘊʀ;adsvᗺᗻᗿᘁᘇ戧nd;橕;橜lope;橘;橚΀;elmrszᘘᘙᘛᘞᘿᙏᙙ戠;榤e»ᘙsdĀ;aᘥᘦ戡ѡᘰᘲᘴᘶᘸᘺᘼᘾ;榨;榩;榪;榫;榬;榭;榮;榯tĀ;vᙅᙆ戟bĀ;dᙌᙍ抾;榝Āptᙔᙗh;戢»¹arr;捼Āgpᙣᙧon;䄅f;쀀𝕒΀;Eaeiop዁ᙻᙽᚂᚄᚇᚊ;橰cir;橯;扊d;手s;䀧roxĀ;e዁ᚒñᚃing耻å䃥ƀctyᚡᚦᚨr;쀀𝒶;䀪mpĀ;e዁ᚯñʈilde耻ã䃣ml耻ä䃤Āciᛂᛈoninôɲnt;樑ࠀNabcdefiklnoprsu᛭ᛱᜰ᜼ᝃᝈ᝸᝽០៦ᠹᡐᜍ᤽᥈ᥰot;櫭Ācrᛶ᜞kȀcepsᜀᜅᜍᜓong;扌psilon;䏶rime;怵imĀ;e᜚᜛戽q;拍Ŷᜢᜦee;抽edĀ;gᜬᜭ挅e»ᜭrkĀ;t፜᜷brk;掶Āoyᜁᝁ;䐱quo;怞ʀcmprtᝓ᝛ᝡᝤᝨausĀ;eĊĉptyv;榰séᜌnoõēƀahwᝯ᝱ᝳ;䎲;愶een;扬r;쀀𝔟g΀costuvwឍឝឳេ៕៛៞ƀaiuបពរðݠrc;旯p»፱ƀdptឤឨឭot;樀lus;樁imes;樂ɱឹ\0\0ើcup;樆ar;昅riangleĀdu៍្own;施p;斳plus;樄eåᑄåᒭarow;植ƀako៭ᠦᠵĀcn៲ᠣkƀlst៺֫᠂ozenge;槫riangleȀ;dlr᠒᠓᠘᠝斴own;斾eft;旂ight;斸k;搣Ʊᠫ\0ᠳƲᠯ\0ᠱ;斒;斑4;斓ck;斈ĀeoᠾᡍĀ;qᡃᡆ쀀=⃥uiv;쀀≡⃥t;挐Ȁptwxᡙᡞᡧᡬf;쀀𝕓Ā;tᏋᡣom»Ꮜtie;拈؀DHUVbdhmptuvᢅᢖᢪᢻᣗᣛᣬ᣿ᤅᤊᤐᤡȀLRlrᢎᢐᢒᢔ;敗;敔;敖;敓ʀ;DUduᢡᢢᢤᢦᢨ敐;敦;敩;敤;敧ȀLRlrᢳᢵᢷᢹ;敝;敚;敜;教΀;HLRhlrᣊᣋᣍᣏᣑᣓᣕ救;敬;散;敠;敫;敢;敟ox;槉ȀLRlrᣤᣦᣨᣪ;敕;敒;攐;攌ʀ;DUduڽ᣷᣹᣻᣽;敥;敨;攬;攴inus;抟lus;択imes;抠ȀLRlrᤙᤛᤝ᤟;敛;敘;攘;攔΀;HLRhlrᤰᤱᤳᤵᤷ᤻᤹攂;敪;敡;敞;攼;攤;攜Āevģ᥂bar耻¦䂦Ȁceioᥑᥖᥚᥠr;쀀𝒷mi;恏mĀ;e᜚᜜lƀ;bhᥨᥩᥫ䁜;槅sub;柈Ŭᥴ᥾lĀ;e᥹᥺怢t»᥺pƀ;Eeįᦅᦇ;檮Ā;qۜۛೡᦧ\0᧨ᨑᨕᨲ\0ᨷᩐ\0\0᪴\0\0᫁\0\0ᬡᬮ᭍᭒\0᯽\0ᰌƀcpr᦭ᦲ᧝ute;䄇̀;abcdsᦿᧀᧄ᧊᧕᧙戩nd;橄rcup;橉Āau᧏᧒p;橋p;橇ot;橀;쀀∩︀Āeo᧢᧥t;恁îړȀaeiu᧰᧻ᨁᨅǰ᧵\0᧸s;橍on;䄍dil耻ç䃧rc;䄉psĀ;sᨌᨍ橌m;橐ot;䄋ƀdmnᨛᨠᨦil肻¸ƭptyv;榲t脀¢;eᨭᨮ䂢räƲr;쀀𝔠ƀceiᨽᩀᩍy;䑇ckĀ;mᩇᩈ朓ark»ᩈ;䏇r΀;Ecefms᩟᩠ᩢᩫ᪤᪪᪮旋;槃ƀ;elᩩᩪᩭ䋆q;扗eɡᩴ\0\0᪈rrowĀlr᩼᪁eft;憺ight;憻ʀRSacd᪒᪔᪖᪚᪟»ཇ;擈st;抛irc;抚ash;抝nint;樐id;櫯cir;槂ubsĀ;u᪻᪼晣it»᪼ˬ᫇᫔᫺\0ᬊonĀ;eᫍᫎ䀺Ā;qÇÆɭ᫙\0\0᫢aĀ;t᫞᫟䀬;䁀ƀ;fl᫨᫩᫫戁îᅠeĀmx᫱᫶ent»᫩eóɍǧ᫾\0ᬇĀ;dኻᬂot;橭nôɆƀfryᬐᬔᬗ;쀀𝕔oäɔ脀©;sŕᬝr;愗Āaoᬥᬩrr;憵ss;朗Ācuᬲᬷr;쀀𝒸Ābpᬼ᭄Ā;eᭁᭂ櫏;櫑Ā;eᭉᭊ櫐;櫒dot;拯΀delprvw᭠᭬᭷ᮂᮬᯔ᯹arrĀlr᭨᭪;椸;椵ɰ᭲\0\0᭵r;拞c;拟arrĀ;p᭿ᮀ憶;椽̀;bcdosᮏᮐᮖᮡᮥᮨ截rcap;橈Āauᮛᮞp;橆p;橊ot;抍r;橅;쀀∪︀Ȁalrv᮵ᮿᯞᯣrrĀ;mᮼᮽ憷;椼yƀevwᯇᯔᯘqɰᯎ\0\0ᯒreã᭳uã᭵ee;拎edge;拏en耻¤䂤earrowĀlrᯮ᯳eft»ᮀight»ᮽeäᯝĀciᰁᰇoninôǷnt;戱lcty;挭ঀAHabcdefhijlorstuwz᰸᰻᰿ᱝᱩᱵᲊᲞᲬᲷ᳻᳿ᴍᵻᶑᶫᶻ᷆᷍rò΁ar;楥Ȁglrs᱈ᱍ᱒᱔ger;怠eth;愸òᄳhĀ;vᱚᱛ怐»ऊūᱡᱧarow;椏aã̕Āayᱮᱳron;䄏;䐴ƀ;ao̲ᱼᲄĀgrʿᲁr;懊tseq;橷ƀglmᲑᲔᲘ耻°䂰ta;䎴ptyv;榱ĀirᲣᲨsht;楿;쀀𝔡arĀlrᲳᲵ»ࣜ»သʀaegsv᳂͸᳖᳜᳠mƀ;oș᳊᳔ndĀ;ș᳑uit;晦amma;䏝in;拲ƀ;io᳧᳨᳸䃷de脀÷;o᳧ᳰntimes;拇nø᳷cy;䑒cɯᴆ\0\0ᴊrn;挞op;挍ʀlptuwᴘᴝᴢᵉᵕlar;䀤f;쀀𝕕ʀ;emps̋ᴭᴷᴽᵂqĀ;d͒ᴳot;扑inus;戸lus;戔quare;抡blebarwedgåúnƀadhᄮᵝᵧownarrowóᲃarpoonĀlrᵲᵶefôᲴighôᲶŢᵿᶅkaro÷གɯᶊ\0\0ᶎrn;挟op;挌ƀcotᶘᶣᶦĀryᶝᶡ;쀀𝒹;䑕l;槶rok;䄑Ādrᶰᶴot;拱iĀ;fᶺ᠖斿Āah᷀᷃ròЩaòྦangle;榦Āci᷒ᷕy;䑟grarr;柿ऀDacdefglmnopqrstuxḁḉḙḸոḼṉṡṾấắẽỡἪἷὄ὎὚ĀDoḆᴴoôᲉĀcsḎḔute耻é䃩ter;橮ȀaioyḢḧḱḶron;䄛rĀ;cḭḮ扖耻ê䃪lon;払;䑍ot;䄗ĀDrṁṅot;扒;쀀𝔢ƀ;rsṐṑṗ檚ave耻è䃨Ā;dṜṝ檖ot;檘Ȁ;ilsṪṫṲṴ檙nters;揧;愓Ā;dṹṺ檕ot;檗ƀapsẅẉẗcr;䄓tyƀ;svẒẓẕ戅et»ẓpĀ1;ẝẤĳạả;怄;怅怃ĀgsẪẬ;䅋p;怂ĀgpẴẸon;䄙f;쀀𝕖ƀalsỄỎỒrĀ;sỊị拕l;槣us;橱iƀ;lvỚớở䎵on»ớ;䏵ȀcsuvỪỳἋἣĀioữḱrc»Ḯɩỹ\0\0ỻíՈantĀglἂἆtr»ṝess»Ṻƀaeiἒ἖Ἒls;䀽st;扟vĀ;DȵἠD;橸parsl;槥ĀDaἯἳot;打rr;楱ƀcdiἾὁỸr;愯oô͒ĀahὉὋ;䎷耻ð䃰Āmrὓὗl耻ë䃫o;悬ƀcipὡὤὧl;䀡sôծĀeoὬὴctatioîՙnentialåչৡᾒ\0ᾞ\0ᾡᾧ\0\0ῆῌ\0ΐ\0ῦῪ \0 ⁚llingdotseñṄy;䑄male;晀ƀilrᾭᾳ῁lig;耀ﬃɩᾹ\0\0᾽g;耀ﬀig;耀ﬄ;쀀𝔣lig;耀ﬁlig;쀀fjƀaltῙ῜ῡt;晭ig;耀ﬂns;斱of;䆒ǰ΅\0ῳf;쀀𝕗ĀakֿῷĀ;vῼ´拔;櫙artint;樍Āao‌⁕Ācs‑⁒α‚‰‸⁅⁈\0⁐β•‥‧‪‬\0‮耻½䂽;慓耻¼䂼;慕;慙;慛Ƴ‴\0‶;慔;慖ʴ‾⁁\0\0⁃耻¾䂾;慗;慜5;慘ƶ⁌\0⁎;慚;慝8;慞l;恄wn;挢cr;쀀𝒻ࢀEabcdefgijlnorstv₂₉₟₥₰₴⃰⃵⃺⃿℃ℒℸ̗ℾ⅒↞Ā;lٍ₇;檌ƀcmpₐₕ₝ute;䇵maĀ;dₜ᳚䎳;檆reve;䄟Āiy₪₮rc;䄝;䐳ot;䄡Ȁ;lqsؾق₽⃉ƀ;qsؾٌ⃄lanô٥Ȁ;cdl٥⃒⃥⃕c;檩otĀ;o⃜⃝檀Ā;l⃢⃣檂;檄Ā;e⃪⃭쀀⋛︀s;檔r;쀀𝔤Ā;gٳ؛mel;愷cy;䑓Ȁ;Eajٚℌℎℐ;檒;檥;檤ȀEaesℛℝ℩ℴ;扩pĀ;p℣ℤ檊rox»ℤĀ;q℮ℯ檈Ā;q℮ℛim;拧pf;쀀𝕘Āci⅃ⅆr;愊mƀ;el٫ⅎ⅐;檎;檐茀>;cdlqr׮ⅠⅪⅮⅳⅹĀciⅥⅧ;檧r;橺ot;拗Par;榕uest;橼ʀadelsↄⅪ←ٖ↛ǰ↉\0↎proø₞r;楸qĀlqؿ↖lesó₈ií٫Āen↣↭rtneqq;쀀≩︀Å↪ԀAabcefkosy⇄⇇⇱⇵⇺∘∝∯≨≽ròΠȀilmr⇐⇔⇗⇛rsðᒄf»․ilôکĀdr⇠⇤cy;䑊ƀ;cwࣴ⇫⇯ir;楈;憭ar;意irc;䄥ƀalr∁∎∓rtsĀ;u∉∊晥it»∊lip;怦con;抹r;쀀𝔥sĀew∣∩arow;椥arow;椦ʀamopr∺∾≃≞≣rr;懿tht;戻kĀlr≉≓eftarrow;憩ightarrow;憪f;쀀𝕙bar;怕ƀclt≯≴≸r;쀀𝒽asè⇴rok;䄧Ābp⊂⊇ull;恃hen»ᱛૡ⊣\0⊪\0⊸⋅⋎\0⋕⋳\0\0⋸⌢⍧⍢⍿\0⎆⎪⎴cute耻í䃭ƀ;iyݱ⊰⊵rc耻î䃮;䐸Ācx⊼⊿y;䐵cl耻¡䂡ĀfrΟ⋉;쀀𝔦rave耻ì䃬Ȁ;inoܾ⋝⋩⋮Āin⋢⋦nt;樌t;戭fin;槜ta;愩lig;䄳ƀaop⋾⌚⌝ƀcgt⌅⌈⌗r;䄫ƀelpܟ⌏⌓inåގarôܠh;䄱f;抷ed;䆵ʀ;cfotӴ⌬⌱⌽⍁are;愅inĀ;t⌸⌹戞ie;槝doô⌙ʀ;celpݗ⍌⍐⍛⍡al;抺Āgr⍕⍙eróᕣã⍍arhk;樗rod;樼Ȁcgpt⍯⍲⍶⍻y;䑑on;䄯f;쀀𝕚a;䎹uest耻¿䂿Āci⎊⎏r;쀀𝒾nʀ;EdsvӴ⎛⎝⎡ӳ;拹ot;拵Ā;v⎦⎧拴;拳Ā;iݷ⎮lde;䄩ǫ⎸\0⎼cy;䑖l耻ï䃯̀cfmosu⏌⏗⏜⏡⏧⏵Āiy⏑⏕rc;䄵;䐹r;쀀𝔧ath;䈷pf;쀀𝕛ǣ⏬\0⏱r;쀀𝒿rcy;䑘kcy;䑔Ѐacfghjos␋␖␢␧␭␱␵␻ppaĀ;v␓␔䎺;䏰Āey␛␠dil;䄷;䐺r;쀀𝔨reen;䄸cy;䑅cy;䑜pf;쀀𝕜cr;쀀𝓀஀ABEHabcdefghjlmnoprstuv⑰⒁⒆⒍⒑┎┽╚▀♎♞♥♹♽⚚⚲⛘❝❨➋⟀⠁⠒ƀart⑷⑺⑼rò৆òΕail;椛arr;椎Ā;gঔ⒋;檋ar;楢ॣ⒥\0⒪\0⒱\0\0\0\0\0⒵Ⓔ\0ⓆⓈⓍ\0⓹ute;䄺mptyv;榴raîࡌbda;䎻gƀ;dlࢎⓁⓃ;榑åࢎ;檅uo耻«䂫rЀ;bfhlpst࢙ⓞⓦⓩ⓫⓮⓱⓵Ā;f࢝ⓣs;椟s;椝ë≒p;憫l;椹im;楳l;憢ƀ;ae⓿─┄檫il;椙Ā;s┉┊檭;쀀⪭︀ƀabr┕┙┝rr;椌rk;杲Āak┢┬cĀek┨┪;䁻;䁛Āes┱┳;榋lĀdu┹┻;榏;榍Ȁaeuy╆╋╖╘ron;䄾Ādi═╔il;䄼ìࢰâ┩;䐻Ȁcqrs╣╦╭╽a;椶uoĀ;rนᝆĀdu╲╷har;楧shar;楋h;憲ʀ;fgqs▋▌উ◳◿扤tʀahlrt▘▤▷◂◨rrowĀ;t࢙□aé⓶arpoonĀdu▯▴own»њp»०eftarrows;懇ightƀahs◍◖◞rrowĀ;sࣴࢧarpoonó྘quigarro÷⇰hreetimes;拋ƀ;qs▋ও◺lanôবʀ;cdgsব☊☍☝☨c;檨otĀ;o☔☕橿Ā;r☚☛檁;檃Ā;e☢☥쀀⋚︀s;檓ʀadegs☳☹☽♉♋pproøⓆot;拖qĀgq♃♅ôউgtò⒌ôছiíলƀilr♕࣡♚sht;楼;쀀𝔩Ā;Eজ♣;檑š♩♶rĀdu▲♮Ā;l॥♳;楪lk;斄cy;䑙ʀ;achtੈ⚈⚋⚑⚖rò◁orneòᴈard;楫ri;旺Āio⚟⚤dot;䅀ustĀ;a⚬⚭掰che»⚭ȀEaes⚻⚽⛉⛔;扨pĀ;p⛃⛄檉rox»⛄Ā;q⛎⛏檇Ā;q⛎⚻im;拦Ѐabnoptwz⛩⛴⛷✚✯❁❇❐Ānr⛮⛱g;柬r;懽rëࣁgƀlmr⛿✍✔eftĀar০✇ightá৲apsto;柼ightá৽parrowĀlr✥✩efô⓭ight;憬ƀafl✶✹✽r;榅;쀀𝕝us;樭imes;樴š❋❏st;戗áፎƀ;ef❗❘᠀旊nge»❘arĀ;l❤❥䀨t;榓ʀachmt❳❶❼➅➇ròࢨorneòᶌarĀ;d྘➃;業;怎ri;抿̀achiqt➘➝ੀ➢➮➻quo;怹r;쀀𝓁mƀ;egল➪➬;檍;檏Ābu┪➳oĀ;rฟ➹;怚rok;䅂萀<;cdhilqrࠫ⟒☹⟜⟠⟥⟪⟰Āci⟗⟙;檦r;橹reå◲mes;拉arr;楶uest;橻ĀPi⟵⟹ar;榖ƀ;ef⠀भ᠛旃rĀdu⠇⠍shar;楊har;楦Āen⠗⠡rtneqq;쀀≨︀Å⠞܀Dacdefhilnopsu⡀⡅⢂⢎⢓⢠⢥⢨⣚⣢⣤ઃ⣳⤂Dot;戺Ȁclpr⡎⡒⡣⡽r耻¯䂯Āet⡗⡙;時Ā;e⡞⡟朠se»⡟Ā;sျ⡨toȀ;dluျ⡳⡷⡻owîҌefôएðᏑker;斮Āoy⢇⢌mma;権;䐼ash;怔asuredangle»ᘦr;쀀𝔪o;愧ƀcdn⢯⢴⣉ro耻µ䂵Ȁ;acdᑤ⢽⣀⣄sôᚧir;櫰ot肻·Ƶusƀ;bd⣒ᤃ⣓戒Ā;uᴼ⣘;横ţ⣞⣡p;櫛ò−ðઁĀdp⣩⣮els;抧f;쀀𝕞Āct⣸⣽r;쀀𝓂pos»ᖝƀ;lm⤉⤊⤍䎼timap;抸ఀGLRVabcdefghijlmoprstuvw⥂⥓⥾⦉⦘⧚⧩⨕⨚⩘⩝⪃⪕⪤⪨⬄⬇⭄⭿⮮ⰴⱧⱼ⳩Āgt⥇⥋;쀀⋙̸Ā;v⥐௏쀀≫⃒ƀelt⥚⥲⥶ftĀar⥡⥧rrow;懍ightarrow;懎;쀀⋘̸Ā;v⥻ే쀀≪⃒ightarrow;懏ĀDd⦎⦓ash;抯ash;抮ʀbcnpt⦣⦧⦬⦱⧌la»˞ute;䅄g;쀀∠⃒ʀ;Eiop඄⦼⧀⧅⧈;쀀⩰̸d;쀀≋̸s;䅉roø඄urĀ;a⧓⧔普lĀ;s⧓ସǳ⧟\0⧣p肻 ଷmpĀ;e௹ఀʀaeouy⧴⧾⨃⨐⨓ǰ⧹\0⧻;橃on;䅈dil;䅆ngĀ;dൾ⨊ot;쀀⩭̸p;橂;䐽ash;怓΀;Aadqsxஒ⨩⨭⨻⩁⩅⩐rr;懗rĀhr⨳⨶k;椤Ā;oᏲᏰot;쀀≐̸uiöୣĀei⩊⩎ar;椨í஘istĀ;s஠டr;쀀𝔫ȀEest௅⩦⩹⩼ƀ;qs஼⩭௡ƀ;qs஼௅⩴lanô௢ií௪Ā;rஶ⪁»ஷƀAap⪊⪍⪑rò⥱rr;憮ar;櫲ƀ;svྍ⪜ྌĀ;d⪡⪢拼;拺cy;䑚΀AEadest⪷⪺⪾⫂⫅⫶⫹rò⥦;쀀≦̸rr;憚r;急Ȁ;fqs఻⫎⫣⫯tĀar⫔⫙rro÷⫁ightarro÷⪐ƀ;qs఻⪺⫪lanôౕĀ;sౕ⫴»శiíౝĀ;rవ⫾iĀ;eచథiäඐĀpt⬌⬑f;쀀𝕟膀¬;in⬙⬚⬶䂬nȀ;Edvஉ⬤⬨⬮;쀀⋹̸ot;쀀⋵̸ǡஉ⬳⬵;拷;拶iĀ;vಸ⬼ǡಸ⭁⭃;拾;拽ƀaor⭋⭣⭩rȀ;ast୻⭕⭚⭟lleì୻l;쀀⫽⃥;쀀∂̸lint;樔ƀ;ceಒ⭰⭳uåಥĀ;cಘ⭸Ā;eಒ⭽ñಘȀAait⮈⮋⮝⮧rò⦈rrƀ;cw⮔⮕⮙憛;쀀⤳̸;쀀↝̸ghtarrow»⮕riĀ;eೋೖ΀chimpqu⮽⯍⯙⬄୸⯤⯯Ȁ;cerല⯆ഷ⯉uå൅;쀀𝓃ortɭ⬅\0\0⯖ará⭖mĀ;e൮⯟Ā;q൴൳suĀbp⯫⯭å೸åഋƀbcp⯶ⰑⰙȀ;Ees⯿ⰀഢⰄ抄;쀀⫅̸etĀ;eഛⰋqĀ;qണⰀcĀ;eലⰗñസȀ;EesⰢⰣൟⰧ抅;쀀⫆̸etĀ;e൘ⰮqĀ;qൠⰣȀgilrⰽⰿⱅⱇìௗlde耻ñ䃱çృiangleĀlrⱒⱜeftĀ;eచⱚñదightĀ;eೋⱥñ೗Ā;mⱬⱭ䎽ƀ;esⱴⱵⱹ䀣ro;愖p;怇ҀDHadgilrsⲏⲔⲙⲞⲣⲰⲶⳓⳣash;抭arr;椄p;쀀≍⃒ash;抬ĀetⲨⲬ;쀀≥⃒;쀀>⃒nfin;槞ƀAetⲽⳁⳅrr;椂;쀀≤⃒Ā;rⳊⳍ쀀<⃒ie;쀀⊴⃒ĀAtⳘⳜrr;椃rie;쀀⊵⃒im;쀀∼⃒ƀAan⳰⳴ⴂrr;懖rĀhr⳺⳽k;椣Ā;oᏧᏥear;椧ቓ᪕\0\0\0\0\0\0\0\0\0\0\0\0\0ⴭ\0ⴸⵈⵠⵥ⵲ⶄᬇ\0\0ⶍⶫ\0ⷈⷎ\0ⷜ⸙⸫⸾⹃Ācsⴱ᪗ute耻ó䃳ĀiyⴼⵅrĀ;c᪞ⵂ耻ô䃴;䐾ʀabios᪠ⵒⵗǈⵚlac;䅑v;樸old;榼lig;䅓Ācr⵩⵭ir;榿;쀀𝔬ͯ⵹\0\0⵼\0ⶂn;䋛ave耻ò䃲;槁Ābmⶈ෴ar;榵Ȁacitⶕ⶘ⶥⶨrò᪀Āir⶝ⶠr;榾oss;榻nå๒;槀ƀaeiⶱⶵⶹcr;䅍ga;䏉ƀcdnⷀⷅǍron;䎿;榶pf;쀀𝕠ƀaelⷔ⷗ǒr;榷rp;榹΀;adiosvⷪⷫⷮ⸈⸍⸐⸖戨rò᪆Ȁ;efmⷷⷸ⸂⸅橝rĀ;oⷾⷿ愴f»ⷿ耻ª䂪耻º䂺gof;抶r;橖lope;橗;橛ƀclo⸟⸡⸧ò⸁ash耻ø䃸l;折iŬⸯ⸴de耻õ䃵esĀ;aǛ⸺s;樶ml耻ö䃶bar;挽ૡ⹞\0⹽\0⺀⺝\0⺢⺹\0\0⻋ຜ\0⼓\0\0⼫⾼\0⿈rȀ;astЃ⹧⹲຅脀¶;l⹭⹮䂶leìЃɩ⹸\0\0⹻m;櫳;櫽y;䐿rʀcimpt⺋⺏⺓ᡥ⺗nt;䀥od;䀮il;怰enk;怱r;쀀𝔭ƀimo⺨⺰⺴Ā;v⺭⺮䏆;䏕maô੶ne;明ƀ;tv⺿⻀⻈䏀chfork»´;䏖Āau⻏⻟nĀck⻕⻝kĀ;h⇴⻛;愎ö⇴sҀ;abcdemst⻳⻴ᤈ⻹⻽⼄⼆⼊⼎䀫cir;樣ir;樢Āouᵀ⼂;樥;橲n肻±ຝim;樦wo;樧ƀipu⼙⼠⼥ntint;樕f;쀀𝕡nd耻£䂣Ԁ;Eaceinosu່⼿⽁⽄⽇⾁⾉⾒⽾⾶;檳p;檷uå໙Ā;c໎⽌̀;acens່⽙⽟⽦⽨⽾pproø⽃urlyeñ໙ñ໎ƀaes⽯⽶⽺pprox;檹qq;檵im;拨iíໟmeĀ;s⾈ຮ怲ƀEas⽸⾐⽺ð⽵ƀdfp໬⾙⾯ƀals⾠⾥⾪lar;挮ine;挒urf;挓Ā;t໻⾴ï໻rel;抰Āci⿀⿅r;쀀𝓅;䏈ncsp;怈̀fiopsu⿚⋢⿟⿥⿫⿱r;쀀𝔮pf;쀀𝕢rime;恗cr;쀀𝓆ƀaeo⿸〉〓tĀei⿾々rnionóڰnt;樖stĀ;e【】䀿ñἙô༔઀ABHabcdefhilmnoprstux぀けさすムㄎㄫㅇㅢㅲㆎ㈆㈕㈤㈩㉘㉮㉲㊐㊰㊷ƀartぇおがròႳòϝail;検aròᱥar;楤΀cdenqrtとふへみわゔヌĀeuねぱ;쀀∽̱te;䅕iãᅮmptyv;榳gȀ;del࿑らるろ;榒;榥å࿑uo耻»䂻rր;abcfhlpstw࿜ガクシスゼゾダッデナp;極Ā;f࿠ゴs;椠;椳s;椞ë≝ð✮l;楅im;楴l;憣;憝Āaiパフil;椚oĀ;nホボ戶aló༞ƀabrョリヮrò៥rk;杳ĀakンヽcĀekヹ・;䁽;䁝Āes㄂㄄;榌lĀduㄊㄌ;榎;榐Ȁaeuyㄗㄜㄧㄩron;䅙Ādiㄡㄥil;䅗ì࿲âヺ;䑀Ȁclqsㄴㄷㄽㅄa;椷dhar;楩uoĀ;rȎȍh;憳ƀacgㅎㅟངlȀ;ipsླྀㅘㅛႜnåႻarôྩt;断ƀilrㅩဣㅮsht;楽;쀀𝔯ĀaoㅷㆆrĀduㅽㅿ»ѻĀ;l႑ㆄ;楬Ā;vㆋㆌ䏁;䏱ƀgns㆕ㇹㇼht̀ahlrstㆤㆰ㇂㇘㇤㇮rrowĀ;t࿜ㆭaéトarpoonĀduㆻㆿowîㅾp»႒eftĀah㇊㇐rrowó࿪arpoonóՑightarrows;應quigarro÷ニhreetimes;拌g;䋚ingdotseñἲƀahm㈍㈐㈓rò࿪aòՑ;怏oustĀ;a㈞㈟掱che»㈟mid;櫮Ȁabpt㈲㈽㉀㉒Ānr㈷㈺g;柭r;懾rëဃƀafl㉇㉊㉎r;榆;쀀𝕣us;樮imes;樵Āap㉝㉧rĀ;g㉣㉤䀩t;榔olint;樒arò㇣Ȁachq㉻㊀Ⴜ㊅quo;怺r;쀀𝓇Ābu・㊊oĀ;rȔȓƀhir㊗㊛㊠reåㇸmes;拊iȀ;efl㊪ၙᠡ㊫方tri;槎luhar;楨;愞ൡ㋕㋛㋟㌬㌸㍱\0㍺㎤\0\0㏬㏰\0㐨㑈㑚㒭㒱㓊㓱\0㘖\0\0㘳cute;䅛quï➺Ԁ;Eaceinpsyᇭ㋳㋵㋿㌂㌋㌏㌟㌦㌩;檴ǰ㋺\0㋼;檸on;䅡uåᇾĀ;dᇳ㌇il;䅟rc;䅝ƀEas㌖㌘㌛;檶p;檺im;择olint;樓iíሄ;䑁otƀ;be㌴ᵇ㌵担;橦΀Aacmstx㍆㍊㍗㍛㍞㍣㍭rr;懘rĀhr㍐㍒ë∨Ā;oਸ਼਴t耻§䂧i;䀻war;椩mĀin㍩ðnuóñt;朶rĀ;o㍶⁕쀀𝔰Ȁacoy㎂㎆㎑㎠rp;景Āhy㎋㎏cy;䑉;䑈rtɭ㎙\0\0㎜iäᑤaraì⹯耻­䂭Āgm㎨㎴maƀ;fv㎱㎲㎲䏃;䏂Ѐ;deglnprካ㏅㏉㏎㏖㏞㏡㏦ot;橪Ā;q኱ኰĀ;E㏓㏔檞;檠Ā;E㏛㏜檝;檟e;扆lus;樤arr;楲aròᄽȀaeit㏸㐈㐏㐗Āls㏽㐄lsetmé㍪hp;樳parsl;槤Ādlᑣ㐔e;挣Ā;e㐜㐝檪Ā;s㐢㐣檬;쀀⪬︀ƀflp㐮㐳㑂tcy;䑌Ā;b㐸㐹䀯Ā;a㐾㐿槄r;挿f;쀀𝕤aĀdr㑍ЂesĀ;u㑔㑕晠it»㑕ƀcsu㑠㑹㒟Āau㑥㑯pĀ;sᆈ㑫;쀀⊓︀pĀ;sᆴ㑵;쀀⊔︀uĀbp㑿㒏ƀ;esᆗᆜ㒆etĀ;eᆗ㒍ñᆝƀ;esᆨᆭ㒖etĀ;eᆨ㒝ñᆮƀ;afᅻ㒦ְrť㒫ֱ»ᅼaròᅈȀcemt㒹㒾㓂㓅r;쀀𝓈tmîñiì㐕aræᆾĀar㓎㓕rĀ;f㓔ឿ昆Āan㓚㓭ightĀep㓣㓪psiloîỠhé⺯s»⡒ʀbcmnp㓻㕞ሉ㖋㖎Ҁ;Edemnprs㔎㔏㔑㔕㔞㔣㔬㔱㔶抂;櫅ot;檽Ā;dᇚ㔚ot;櫃ult;櫁ĀEe㔨㔪;櫋;把lus;檿arr;楹ƀeiu㔽㕒㕕tƀ;en㔎㕅㕋qĀ;qᇚ㔏eqĀ;q㔫㔨m;櫇Ābp㕚㕜;櫕;櫓c̀;acensᇭ㕬㕲㕹㕻㌦pproø㋺urlyeñᇾñᇳƀaes㖂㖈㌛pproø㌚qñ㌗g;晪ڀ123;Edehlmnps㖩㖬㖯ሜ㖲㖴㗀㗉㗕㗚㗟㗨㗭耻¹䂹耻²䂲耻³䂳;櫆Āos㖹㖼t;檾ub;櫘Ā;dሢ㗅ot;櫄sĀou㗏㗒l;柉b;櫗arr;楻ult;櫂ĀEe㗤㗦;櫌;抋lus;櫀ƀeiu㗴㘉㘌tƀ;enሜ㗼㘂qĀ;qሢ㖲eqĀ;q㗧㗤m;櫈Ābp㘑㘓;櫔;櫖ƀAan㘜㘠㘭rr;懙rĀhr㘦㘨ë∮Ā;oਫ਩war;椪lig耻ß䃟௡㙑㙝㙠ዎ㙳㙹\0㙾㛂\0\0\0\0\0㛛㜃\0㜉㝬\0\0\0㞇ɲ㙖\0\0㙛get;挖;䏄rë๟ƀaey㙦㙫㙰ron;䅥dil;䅣;䑂lrec;挕r;쀀𝔱Ȁeiko㚆㚝㚵㚼ǲ㚋\0㚑eĀ4fኄኁaƀ;sv㚘㚙㚛䎸ym;䏑Ācn㚢㚲kĀas㚨㚮pproø዁im»ኬsðኞĀas㚺㚮ð዁rn耻þ䃾Ǭ̟㛆⋧es膀×;bd㛏㛐㛘䃗Ā;aᤏ㛕r;樱;樰ƀeps㛡㛣㜀á⩍Ȁ;bcf҆㛬㛰㛴ot;挶ir;櫱Ā;o㛹㛼쀀𝕥rk;櫚á㍢rime;怴ƀaip㜏㜒㝤dåቈ΀adempst㜡㝍㝀㝑㝗㝜㝟ngleʀ;dlqr㜰㜱㜶㝀㝂斵own»ᶻeftĀ;e⠀㜾ñम;扜ightĀ;e㊪㝋ñၚot;旬inus;樺lus;樹b;槍ime;樻ezium;揢ƀcht㝲㝽㞁Āry㝷㝻;쀀𝓉;䑆cy;䑛rok;䅧Āio㞋㞎xô᝷headĀlr㞗㞠eftarro÷ࡏightarrow»ཝऀAHabcdfghlmoprstuw㟐㟓㟗㟤㟰㟼㠎㠜㠣㠴㡑㡝㡫㢩㣌㣒㣪㣶ròϭar;楣Ācr㟜㟢ute耻ú䃺òᅐrǣ㟪\0㟭y;䑞ve;䅭Āiy㟵㟺rc耻û䃻;䑃ƀabh㠃㠆㠋ròᎭlac;䅱aòᏃĀir㠓㠘sht;楾;쀀𝔲rave耻ù䃹š㠧㠱rĀlr㠬㠮»ॗ»ႃlk;斀Āct㠹㡍ɯ㠿\0\0㡊rnĀ;e㡅㡆挜r»㡆op;挏ri;旸Āal㡖㡚cr;䅫肻¨͉Āgp㡢㡦on;䅳f;쀀𝕦̀adhlsuᅋ㡸㡽፲㢑㢠ownáᎳarpoonĀlr㢈㢌efô㠭ighô㠯iƀ;hl㢙㢚㢜䏅»ᏺon»㢚parrows;懈ƀcit㢰㣄㣈ɯ㢶\0\0㣁rnĀ;e㢼㢽挝r»㢽op;挎ng;䅯ri;旹cr;쀀𝓊ƀdir㣙㣝㣢ot;拰lde;䅩iĀ;f㜰㣨»᠓Āam㣯㣲rò㢨l耻ü䃼angle;榧ހABDacdeflnoprsz㤜㤟㤩㤭㦵㦸㦽㧟㧤㧨㧳㧹㧽㨁㨠ròϷarĀ;v㤦㤧櫨;櫩asèϡĀnr㤲㤷grt;榜΀eknprst㓣㥆㥋㥒㥝㥤㦖appá␕othinçẖƀhir㓫⻈㥙opô⾵Ā;hᎷ㥢ïㆍĀiu㥩㥭gmá㎳Ābp㥲㦄setneqĀ;q㥽㦀쀀⊊︀;쀀⫋︀setneqĀ;q㦏㦒쀀⊋︀;쀀⫌︀Āhr㦛㦟etá㚜iangleĀlr㦪㦯eft»थight»ၑy;䐲ash»ံƀelr㧄㧒㧗ƀ;beⷪ㧋㧏ar;抻q;扚lip;拮Ābt㧜ᑨaòᑩr;쀀𝔳tré㦮suĀbp㧯㧱»ജ»൙pf;쀀𝕧roð໻tré㦴Ācu㨆㨋r;쀀𝓋Ābp㨐㨘nĀEe㦀㨖»㥾nĀEe㦒㨞»㦐igzag;榚΀cefoprs㨶㨻㩖㩛㩔㩡㩪irc;䅵Ādi㩀㩑Ābg㩅㩉ar;機eĀ;qᗺ㩏;扙erp;愘r;쀀𝔴pf;쀀𝕨Ā;eᑹ㩦atèᑹcr;쀀𝓌ૣណ㪇\0㪋\0㪐㪛\0\0㪝㪨㪫㪯\0\0㫃㫎\0㫘ៜ៟tré៑r;쀀𝔵ĀAa㪔㪗ròσrò৶;䎾ĀAa㪡㪤ròθrò৫að✓is;拻ƀdptឤ㪵㪾Āfl㪺ឩ;쀀𝕩imåឲĀAa㫇㫊ròώròਁĀcq㫒ីr;쀀𝓍Āpt៖㫜ré។Ѐacefiosu㫰㫽㬈㬌㬑㬕㬛㬡cĀuy㫶㫻te耻ý䃽;䑏Āiy㬂㬆rc;䅷;䑋n耻¥䂥r;쀀𝔶cy;䑗pf;쀀𝕪cr;쀀𝓎Ācm㬦㬩y;䑎l耻ÿ䃿Ԁacdefhiosw㭂㭈㭔㭘㭤㭩㭭㭴㭺㮀cute;䅺Āay㭍㭒ron;䅾;䐷ot;䅼Āet㭝㭡træᕟa;䎶r;쀀𝔷cy;䐶grarr;懝pf;쀀𝕫cr;쀀𝓏Ājn㮅㮇;怍j;怌'.split("").map((t) => t.charCodeAt(0))
), EHe = new Uint16Array(
  // prettier-ignore
  "Ȁaglq	\x1Bɭ\0\0p;䀦os;䀧t;䀾t;䀼uot;䀢".split("").map((t) => t.charCodeAt(0))
);
var kk;
const SHe = /* @__PURE__ */ new Map([
  [0, 65533],
  // C1 Unicode control character reference replacements
  [128, 8364],
  [130, 8218],
  [131, 402],
  [132, 8222],
  [133, 8230],
  [134, 8224],
  [135, 8225],
  [136, 710],
  [137, 8240],
  [138, 352],
  [139, 8249],
  [140, 338],
  [142, 381],
  [145, 8216],
  [146, 8217],
  [147, 8220],
  [148, 8221],
  [149, 8226],
  [150, 8211],
  [151, 8212],
  [152, 732],
  [153, 8482],
  [154, 353],
  [155, 8250],
  [156, 339],
  [158, 382],
  [159, 376]
]), OHe = (
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, node/no-unsupported-features/es-builtins
  (kk = String.fromCodePoint) !== null && kk !== void 0 ? kk : function(t) {
    let e = "";
    return t > 65535 && (t -= 65536, e += String.fromCharCode(t >>> 10 & 1023 | 55296), t = 56320 | t & 1023), e += String.fromCharCode(t), e;
  }
);
function CHe(t) {
  var e;
  return t >= 55296 && t <= 57343 || t > 1114111 ? 65533 : (e = SHe.get(t)) !== null && e !== void 0 ? e : t;
}
var Vr;
(function(t) {
  t[t.NUM = 35] = "NUM", t[t.SEMI = 59] = "SEMI", t[t.EQUALS = 61] = "EQUALS", t[t.ZERO = 48] = "ZERO", t[t.NINE = 57] = "NINE", t[t.LOWER_A = 97] = "LOWER_A", t[t.LOWER_F = 102] = "LOWER_F", t[t.LOWER_X = 120] = "LOWER_X", t[t.LOWER_Z = 122] = "LOWER_Z", t[t.UPPER_A = 65] = "UPPER_A", t[t.UPPER_F = 70] = "UPPER_F", t[t.UPPER_Z = 90] = "UPPER_Z";
})(Vr || (Vr = {}));
const kHe = 32;
var Ic;
(function(t) {
  t[t.VALUE_LENGTH = 49152] = "VALUE_LENGTH", t[t.BRANCH_LENGTH = 16256] = "BRANCH_LENGTH", t[t.JUMP_TABLE = 127] = "JUMP_TABLE";
})(Ic || (Ic = {}));
function UN(t) {
  return t >= Vr.ZERO && t <= Vr.NINE;
}
function AHe(t) {
  return t >= Vr.UPPER_A && t <= Vr.UPPER_F || t >= Vr.LOWER_A && t <= Vr.LOWER_F;
}
function THe(t) {
  return t >= Vr.UPPER_A && t <= Vr.UPPER_Z || t >= Vr.LOWER_A && t <= Vr.LOWER_Z || UN(t);
}
function RHe(t) {
  return t === Vr.EQUALS || THe(t);
}
var zr;
(function(t) {
  t[t.EntityStart = 0] = "EntityStart", t[t.NumericStart = 1] = "NumericStart", t[t.NumericDecimal = 2] = "NumericDecimal", t[t.NumericHex = 3] = "NumericHex", t[t.NamedEntity = 4] = "NamedEntity";
})(zr || (zr = {}));
var kc;
(function(t) {
  t[t.Legacy = 0] = "Legacy", t[t.Strict = 1] = "Strict", t[t.Attribute = 2] = "Attribute";
})(kc || (kc = {}));
class PHe {
  constructor(e, n, r) {
    this.decodeTree = e, this.emitCodePoint = n, this.errors = r, this.state = zr.EntityStart, this.consumed = 1, this.result = 0, this.treeIndex = 0, this.excess = 1, this.decodeMode = kc.Strict;
  }
  /** Resets the instance to make it reusable. */
  startEntity(e) {
    this.decodeMode = e, this.state = zr.EntityStart, this.result = 0, this.treeIndex = 0, this.excess = 1, this.consumed = 1;
  }
  /**
   * Write an entity to the decoder. This can be called multiple times with partial entities.
   * If the entity is incomplete, the decoder will return -1.
   *
   * Mirrors the implementation of `getDecoder`, but with the ability to stop decoding if the
   * entity is incomplete, and resume when the next string is written.
   *
   * @param string The string containing the entity (or a continuation of the entity).
   * @param offset The offset at which the entity begins. Should be 0 if this is not the first call.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  write(e, n) {
    switch (this.state) {
      case zr.EntityStart:
        return e.charCodeAt(n) === Vr.NUM ? (this.state = zr.NumericStart, this.consumed += 1, this.stateNumericStart(e, n + 1)) : (this.state = zr.NamedEntity, this.stateNamedEntity(e, n));
      case zr.NumericStart:
        return this.stateNumericStart(e, n);
      case zr.NumericDecimal:
        return this.stateNumericDecimal(e, n);
      case zr.NumericHex:
        return this.stateNumericHex(e, n);
      case zr.NamedEntity:
        return this.stateNamedEntity(e, n);
    }
  }
  /**
   * Switches between the numeric decimal and hexadecimal states.
   *
   * Equivalent to the `Numeric character reference state` in the HTML spec.
   *
   * @param str The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericStart(e, n) {
    return n >= e.length ? -1 : (e.charCodeAt(n) | kHe) === Vr.LOWER_X ? (this.state = zr.NumericHex, this.consumed += 1, this.stateNumericHex(e, n + 1)) : (this.state = zr.NumericDecimal, this.stateNumericDecimal(e, n));
  }
  addToNumericResult(e, n, r, o) {
    if (n !== r) {
      const i = r - n;
      this.result = this.result * Math.pow(o, i) + parseInt(e.substr(n, i), o), this.consumed += i;
    }
  }
  /**
   * Parses a hexadecimal numeric entity.
   *
   * Equivalent to the `Hexademical character reference state` in the HTML spec.
   *
   * @param str The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericHex(e, n) {
    const r = n;
    for (; n < e.length; ) {
      const o = e.charCodeAt(n);
      if (UN(o) || AHe(o))
        n += 1;
      else
        return this.addToNumericResult(e, r, n, 16), this.emitNumericEntity(o, 3);
    }
    return this.addToNumericResult(e, r, n, 16), -1;
  }
  /**
   * Parses a decimal numeric entity.
   *
   * Equivalent to the `Decimal character reference state` in the HTML spec.
   *
   * @param str The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNumericDecimal(e, n) {
    const r = n;
    for (; n < e.length; ) {
      const o = e.charCodeAt(n);
      if (UN(o))
        n += 1;
      else
        return this.addToNumericResult(e, r, n, 10), this.emitNumericEntity(o, 2);
    }
    return this.addToNumericResult(e, r, n, 10), -1;
  }
  /**
   * Validate and emit a numeric entity.
   *
   * Implements the logic from the `Hexademical character reference start
   * state` and `Numeric character reference end state` in the HTML spec.
   *
   * @param lastCp The last code point of the entity. Used to see if the
   *               entity was terminated with a semicolon.
   * @param expectedLength The minimum number of characters that should be
   *                       consumed. Used to validate that at least one digit
   *                       was consumed.
   * @returns The number of characters that were consumed.
   */
  emitNumericEntity(e, n) {
    var r;
    if (this.consumed <= n)
      return (r = this.errors) === null || r === void 0 || r.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
    if (e === Vr.SEMI)
      this.consumed += 1;
    else if (this.decodeMode === kc.Strict)
      return 0;
    return this.emitCodePoint(CHe(this.result), this.consumed), this.errors && (e !== Vr.SEMI && this.errors.missingSemicolonAfterCharacterReference(), this.errors.validateNumericCharacterReference(this.result)), this.consumed;
  }
  /**
   * Parses a named entity.
   *
   * Equivalent to the `Named character reference state` in the HTML spec.
   *
   * @param str The string containing the entity (or a continuation of the entity).
   * @param offset The current offset.
   * @returns The number of characters that were consumed, or -1 if the entity is incomplete.
   */
  stateNamedEntity(e, n) {
    const { decodeTree: r } = this;
    let o = r[this.treeIndex], i = (o & Ic.VALUE_LENGTH) >> 14;
    for (; n < e.length; n++, this.excess++) {
      const s = e.charCodeAt(n);
      if (this.treeIndex = $He(r, o, this.treeIndex + Math.max(1, i), s), this.treeIndex < 0)
        return this.result === 0 || // If we are parsing an attribute
        this.decodeMode === kc.Attribute && // We shouldn't have consumed any characters after the entity,
        (i === 0 || // And there should be no invalid characters.
        RHe(s)) ? 0 : this.emitNotTerminatedNamedEntity();
      if (o = r[this.treeIndex], i = (o & Ic.VALUE_LENGTH) >> 14, i !== 0) {
        if (s === Vr.SEMI)
          return this.emitNamedEntityData(this.treeIndex, i, this.consumed + this.excess);
        this.decodeMode !== kc.Strict && (this.result = this.treeIndex, this.consumed += this.excess, this.excess = 0);
      }
    }
    return -1;
  }
  /**
   * Emit a named entity that was not terminated with a semicolon.
   *
   * @returns The number of characters consumed.
   */
  emitNotTerminatedNamedEntity() {
    var e;
    const { result: n, decodeTree: r } = this, o = (r[n] & Ic.VALUE_LENGTH) >> 14;
    return this.emitNamedEntityData(n, o, this.consumed), (e = this.errors) === null || e === void 0 || e.missingSemicolonAfterCharacterReference(), this.consumed;
  }
  /**
   * Emit a named entity.
   *
   * @param result The index of the entity in the decode tree.
   * @param valueLength The number of bytes in the entity.
   * @param consumed The number of characters consumed.
   *
   * @returns The number of characters consumed.
   */
  emitNamedEntityData(e, n, r) {
    const { decodeTree: o } = this;
    return this.emitCodePoint(n === 1 ? o[e] & ~Ic.VALUE_LENGTH : o[e + 1], r), n === 3 && this.emitCodePoint(o[e + 2], r), r;
  }
  /**
   * Signal to the parser that the end of the input was reached.
   *
   * Remaining data will be emitted and relevant errors will be produced.
   *
   * @returns The number of characters consumed.
   */
  end() {
    var e;
    switch (this.state) {
      case zr.NamedEntity:
        return this.result !== 0 && (this.decodeMode !== kc.Attribute || this.result === this.treeIndex) ? this.emitNotTerminatedNamedEntity() : 0;
      // Otherwise, emit a numeric entity if we have one.
      case zr.NumericDecimal:
        return this.emitNumericEntity(0, 2);
      case zr.NumericHex:
        return this.emitNumericEntity(0, 3);
      case zr.NumericStart:
        return (e = this.errors) === null || e === void 0 || e.absenceOfDigitsInNumericCharacterReference(this.consumed), 0;
      case zr.EntityStart:
        return 0;
    }
  }
}
function Vhe(t) {
  let e = "";
  const n = new PHe(t, (r) => e += OHe(r));
  return function(r, o) {
    let i = 0, s = 0;
    for (; (s = r.indexOf("&", s)) >= 0; ) {
      e += r.slice(i, s), n.startEntity(o);
      const l = n.write(
        r,
        // Skip the "&"
        s + 1
      );
      if (l < 0) {
        i = s + n.end();
        break;
      }
      i = s + l, s = l === 0 ? i + 1 : i;
    }
    const a = e + r.slice(i);
    return e = "", a;
  };
}
function $He(t, e, n, r) {
  const o = (e & Ic.BRANCH_LENGTH) >> 7, i = e & Ic.JUMP_TABLE;
  if (o === 0)
    return i !== 0 && r === i ? n : -1;
  if (i) {
    const l = r - i;
    return l < 0 || l >= o ? -1 : t[n + l] - 1;
  }
  let s = n, a = s + o - 1;
  for (; s <= a; ) {
    const l = s + a >>> 1, c = t[l];
    if (c < r)
      s = l + 1;
    else if (c > r)
      a = l - 1;
    else
      return t[l + o];
  }
  return -1;
}
const MHe = Vhe(xHe);
Vhe(EHe);
function Whe(t, e = kc.Legacy) {
  return MHe(t, e);
}
function DHe(t) {
  return Object.prototype.toString.call(t);
}
function LL(t) {
  return DHe(t) === "[object String]";
}
const IHe = Object.prototype.hasOwnProperty;
function NHe(t, e) {
  return IHe.call(t, e);
}
function zS(t) {
  return Array.prototype.slice.call(arguments, 1).forEach(function(e) {
    if (e) {
      if (typeof e != "object")
        throw new TypeError(e + "must be object");
      Object.keys(e).forEach(function(n) {
        t[n] = e[n];
      });
    }
  }), t;
}
function Ghe(t, e, n) {
  return [].concat(t.slice(0, e), n, t.slice(e + 1));
}
function FL(t) {
  return !(t >= 55296 && t <= 57343 || t >= 64976 && t <= 65007 || (t & 65535) === 65535 || (t & 65535) === 65534 || t >= 0 && t <= 8 || t === 11 || t >= 14 && t <= 31 || t >= 127 && t <= 159 || t > 1114111);
}
function Hx(t) {
  if (t > 65535) {
    t -= 65536;
    const e = 55296 + (t >> 10), n = 56320 + (t & 1023);
    return String.fromCharCode(e, n);
  }
  return String.fromCharCode(t);
}
const Yhe = /\\([!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~])/g, jHe = /&([a-z#][a-z0-9]{1,31});/gi, LHe = new RegExp(Yhe.source + "|" + jHe.source, "gi"), FHe = /^#((?:x[a-f0-9]{1,8}|[0-9]{1,8}))$/i;
function BHe(t, e) {
  if (e.charCodeAt(0) === 35 && FHe.test(e)) {
    const r = e[1].toLowerCase() === "x" ? parseInt(e.slice(2), 16) : parseInt(e.slice(1), 10);
    return FL(r) ? Hx(r) : t;
  }
  const n = Whe(t);
  return n !== t ? n : t;
}
function zHe(t) {
  return t.indexOf("\\") < 0 ? t : t.replace(Yhe, "$1");
}
function rp(t) {
  return t.indexOf("\\") < 0 && t.indexOf("&") < 0 ? t : t.replace(LHe, function(e, n, r) {
    return n || BHe(e, r);
  });
}
const qHe = /[&<>"]/, UHe = /[&<>"]/g, HHe = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;"
};
function VHe(t) {
  return HHe[t];
}
function tu(t) {
  return qHe.test(t) ? t.replace(UHe, VHe) : t;
}
const WHe = /[.?*+^$[\]\\(){}|-]/g;
function GHe(t) {
  return t.replace(WHe, "\\$&");
}
function Un(t) {
  switch (t) {
    case 9:
    case 32:
      return !0;
  }
  return !1;
}
function ay(t) {
  if (t >= 8192 && t <= 8202)
    return !0;
  switch (t) {
    case 9:
    // \t
    case 10:
    // \n
    case 11:
    // \v
    case 12:
    // \f
    case 13:
    // \r
    case 32:
    case 160:
    case 5760:
    case 8239:
    case 8287:
    case 12288:
      return !0;
  }
  return !1;
}
function ly(t) {
  return jL.test(t) || Uhe.test(t);
}
function cy(t) {
  switch (t) {
    case 33:
    case 34:
    case 35:
    case 36:
    case 37:
    case 38:
    case 39:
    case 40:
    case 41:
    case 42:
    case 43:
    case 44:
    case 45:
    case 46:
    case 47:
    case 58:
    case 59:
    case 60:
    case 61:
    case 62:
    case 63:
    case 64:
    case 91:
    case 92:
    case 93:
    case 94:
    case 95:
    case 96:
    case 123:
    case 124:
    case 125:
    case 126:
      return !0;
    default:
      return !1;
  }
}
function qS(t) {
  return t = t.trim().replace(/\s+/g, " "), "ẞ".toLowerCase() === "Ṿ" && (t = t.replace(/ẞ/g, "ß")), t.toLowerCase().toUpperCase();
}
const YHe = { mdurl: bHe, ucmicro: wHe }, KHe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  arrayReplaceAt: Ghe,
  assign: zS,
  escapeHtml: tu,
  escapeRE: GHe,
  fromCodePoint: Hx,
  has: NHe,
  isMdAsciiPunct: cy,
  isPunctChar: ly,
  isSpace: Un,
  isString: LL,
  isValidEntityCode: FL,
  isWhiteSpace: ay,
  lib: YHe,
  normalizeReference: qS,
  unescapeAll: rp,
  unescapeMd: zHe
}, Symbol.toStringTag, { value: "Module" }));
function XHe(t, e, n) {
  let r, o, i, s;
  const a = t.posMax, l = t.pos;
  for (t.pos = e + 1, r = 1; t.pos < a; ) {
    if (i = t.src.charCodeAt(t.pos), i === 93 && (r--, r === 0)) {
      o = !0;
      break;
    }
    if (s = t.pos, t.md.inline.skipToken(t), i === 91) {
      if (s === t.pos - 1)
        r++;
      else if (n)
        return t.pos = l, -1;
    }
  }
  let c = -1;
  return o && (c = t.pos), t.pos = l, c;
}
function QHe(t, e, n) {
  let r, o = e;
  const i = {
    ok: !1,
    pos: 0,
    str: ""
  };
  if (t.charCodeAt(o) === 60) {
    for (o++; o < n; ) {
      if (r = t.charCodeAt(o), r === 10 || r === 60)
        return i;
      if (r === 62)
        return i.pos = o + 1, i.str = rp(t.slice(e + 1, o)), i.ok = !0, i;
      if (r === 92 && o + 1 < n) {
        o += 2;
        continue;
      }
      o++;
    }
    return i;
  }
  let s = 0;
  for (; o < n && (r = t.charCodeAt(o), !(r === 32 || r < 32 || r === 127)); ) {
    if (r === 92 && o + 1 < n) {
      if (t.charCodeAt(o + 1) === 32)
        break;
      o += 2;
      continue;
    }
    if (r === 40 && (s++, s > 32))
      return i;
    if (r === 41) {
      if (s === 0)
        break;
      s--;
    }
    o++;
  }
  return e === o || s !== 0 || (i.str = rp(t.slice(e, o)), i.pos = o, i.ok = !0), i;
}
function ZHe(t, e, n, r) {
  let o, i = e;
  const s = {
    // if `true`, this is a valid link title
    ok: !1,
    // if `true`, this link can be continued on the next line
    can_continue: !1,
    // if `ok`, it's the position of the first character after the closing marker
    pos: 0,
    // if `ok`, it's the unescaped title
    str: "",
    // expected closing marker character code
    marker: 0
  };
  if (r)
    s.str = r.str, s.marker = r.marker;
  else {
    if (i >= n)
      return s;
    let a = t.charCodeAt(i);
    if (a !== 34 && a !== 39 && a !== 40)
      return s;
    e++, i++, a === 40 && (a = 41), s.marker = a;
  }
  for (; i < n; ) {
    if (o = t.charCodeAt(i), o === s.marker)
      return s.pos = i + 1, s.str += rp(t.slice(e, i)), s.ok = !0, s;
    if (o === 40 && s.marker === 41)
      return s;
    o === 92 && i + 1 < n && i++, i++;
  }
  return s.can_continue = !0, s.str += rp(t.slice(e, i)), s;
}
const JHe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  parseLinkDestination: QHe,
  parseLinkLabel: XHe,
  parseLinkTitle: ZHe
}, Symbol.toStringTag, { value: "Module" })), Ma = {};
Ma.code_inline = function(t, e, n, r, o) {
  const i = t[e];
  return "<code" + o.renderAttrs(i) + ">" + tu(i.content) + "</code>";
};
Ma.code_block = function(t, e, n, r, o) {
  const i = t[e];
  return "<pre" + o.renderAttrs(i) + "><code>" + tu(t[e].content) + `</code></pre>
`;
};
Ma.fence = function(t, e, n, r, o) {
  const i = t[e], s = i.info ? rp(i.info).trim() : "";
  let a = "", l = "";
  if (s) {
    const u = s.split(/(\s+)/g);
    a = u[0], l = u.slice(2).join("");
  }
  let c;
  if (n.highlight ? c = n.highlight(i.content, a, l) || tu(i.content) : c = tu(i.content), c.indexOf("<pre") === 0)
    return c + `
`;
  if (s) {
    const u = i.attrIndex("class"), d = i.attrs ? i.attrs.slice() : [];
    u < 0 ? d.push(["class", n.langPrefix + a]) : (d[u] = d[u].slice(), d[u][1] += " " + n.langPrefix + a);
    const f = {
      attrs: d
    };
    return `<pre><code${o.renderAttrs(f)}>${c}</code></pre>
`;
  }
  return `<pre><code${o.renderAttrs(i)}>${c}</code></pre>
`;
};
Ma.image = function(t, e, n, r, o) {
  const i = t[e];
  return i.attrs[i.attrIndex("alt")][1] = o.renderInlineAsText(i.children, n, r), o.renderToken(t, e, n);
};
Ma.hardbreak = function(t, e, n) {
  return n.xhtmlOut ? `<br />
` : `<br>
`;
};
Ma.softbreak = function(t, e, n) {
  return n.breaks ? n.xhtmlOut ? `<br />
` : `<br>
` : `
`;
};
Ma.text = function(t, e) {
  return tu(t[e].content);
};
Ma.html_block = function(t, e) {
  return t[e].content;
};
Ma.html_inline = function(t, e) {
  return t[e].content;
};
function Ap() {
  this.rules = zS({}, Ma);
}
Ap.prototype.renderAttrs = function(t) {
  let e, n, r;
  if (!t.attrs)
    return "";
  for (r = "", e = 0, n = t.attrs.length; e < n; e++)
    r += " " + tu(t.attrs[e][0]) + '="' + tu(t.attrs[e][1]) + '"';
  return r;
};
Ap.prototype.renderToken = function(t, e, n) {
  const r = t[e];
  let o = "";
  if (r.hidden)
    return "";
  r.block && r.nesting !== -1 && e && t[e - 1].hidden && (o += `
`), o += (r.nesting === -1 ? "</" : "<") + r.tag, o += this.renderAttrs(r), r.nesting === 0 && n.xhtmlOut && (o += " /");
  let i = !1;
  if (r.block && (i = !0, r.nesting === 1 && e + 1 < t.length)) {
    const s = t[e + 1];
    (s.type === "inline" || s.hidden || s.nesting === -1 && s.tag === r.tag) && (i = !1);
  }
  return o += i ? `>
` : ">", o;
};
Ap.prototype.renderInline = function(t, e, n) {
  let r = "";
  const o = this.rules;
  for (let i = 0, s = t.length; i < s; i++) {
    const a = t[i].type;
    typeof o[a] < "u" ? r += o[a](t, i, e, n, this) : r += this.renderToken(t, i, e);
  }
  return r;
};
Ap.prototype.renderInlineAsText = function(t, e, n) {
  let r = "";
  for (let o = 0, i = t.length; o < i; o++)
    switch (t[o].type) {
      case "text":
        r += t[o].content;
        break;
      case "image":
        r += this.renderInlineAsText(t[o].children, e, n);
        break;
      case "html_inline":
      case "html_block":
        r += t[o].content;
        break;
      case "softbreak":
      case "hardbreak":
        r += `
`;
        break;
    }
  return r;
};
Ap.prototype.render = function(t, e, n) {
  let r = "";
  const o = this.rules;
  for (let i = 0, s = t.length; i < s; i++) {
    const a = t[i].type;
    a === "inline" ? r += this.renderInline(t[i].children, e, n) : typeof o[a] < "u" ? r += o[a](t, i, e, n, this) : r += this.renderToken(t, i, e, n);
  }
  return r;
};
function ei() {
  this.__rules__ = [], this.__cache__ = null;
}
ei.prototype.__find__ = function(t) {
  for (let e = 0; e < this.__rules__.length; e++)
    if (this.__rules__[e].name === t)
      return e;
  return -1;
};
ei.prototype.__compile__ = function() {
  const t = this, e = [""];
  t.__rules__.forEach(function(n) {
    n.enabled && n.alt.forEach(function(r) {
      e.indexOf(r) < 0 && e.push(r);
    });
  }), t.__cache__ = {}, e.forEach(function(n) {
    t.__cache__[n] = [], t.__rules__.forEach(function(r) {
      r.enabled && (n && r.alt.indexOf(n) < 0 || t.__cache__[n].push(r.fn));
    });
  });
};
ei.prototype.at = function(t, e, n) {
  const r = this.__find__(t), o = n || {};
  if (r === -1)
    throw new Error("Parser rule not found: " + t);
  this.__rules__[r].fn = e, this.__rules__[r].alt = o.alt || [], this.__cache__ = null;
};
ei.prototype.before = function(t, e, n, r) {
  const o = this.__find__(t), i = r || {};
  if (o === -1)
    throw new Error("Parser rule not found: " + t);
  this.__rules__.splice(o, 0, {
    name: e,
    enabled: !0,
    fn: n,
    alt: i.alt || []
  }), this.__cache__ = null;
};
ei.prototype.after = function(t, e, n, r) {
  const o = this.__find__(t), i = r || {};
  if (o === -1)
    throw new Error("Parser rule not found: " + t);
  this.__rules__.splice(o + 1, 0, {
    name: e,
    enabled: !0,
    fn: n,
    alt: i.alt || []
  }), this.__cache__ = null;
};
ei.prototype.push = function(t, e, n) {
  const r = n || {};
  this.__rules__.push({
    name: t,
    enabled: !0,
    fn: e,
    alt: r.alt || []
  }), this.__cache__ = null;
};
ei.prototype.enable = function(t, e) {
  Array.isArray(t) || (t = [t]);
  const n = [];
  return t.forEach(function(r) {
    const o = this.__find__(r);
    if (o < 0) {
      if (e)
        return;
      throw new Error("Rules manager: invalid rule name " + r);
    }
    this.__rules__[o].enabled = !0, n.push(r);
  }, this), this.__cache__ = null, n;
};
ei.prototype.enableOnly = function(t, e) {
  Array.isArray(t) || (t = [t]), this.__rules__.forEach(function(n) {
    n.enabled = !1;
  }), this.enable(t, e);
};
ei.prototype.disable = function(t, e) {
  Array.isArray(t) || (t = [t]);
  const n = [];
  return t.forEach(function(r) {
    const o = this.__find__(r);
    if (o < 0) {
      if (e)
        return;
      throw new Error("Rules manager: invalid rule name " + r);
    }
    this.__rules__[o].enabled = !1, n.push(r);
  }, this), this.__cache__ = null, n;
};
ei.prototype.getRules = function(t) {
  return this.__cache__ === null && this.__compile__(), this.__cache__[t] || [];
};
function Is(t, e, n) {
  this.type = t, this.tag = e, this.attrs = null, this.map = null, this.nesting = n, this.level = 0, this.children = null, this.content = "", this.markup = "", this.info = "", this.meta = null, this.block = !1, this.hidden = !1;
}
Is.prototype.attrIndex = function(t) {
  if (!this.attrs)
    return -1;
  const e = this.attrs;
  for (let n = 0, r = e.length; n < r; n++)
    if (e[n][0] === t)
      return n;
  return -1;
};
Is.prototype.attrPush = function(t) {
  this.attrs ? this.attrs.push(t) : this.attrs = [t];
};
Is.prototype.attrSet = function(t, e) {
  const n = this.attrIndex(t), r = [t, e];
  n < 0 ? this.attrPush(r) : this.attrs[n] = r;
};
Is.prototype.attrGet = function(t) {
  const e = this.attrIndex(t);
  let n = null;
  return e >= 0 && (n = this.attrs[e][1]), n;
};
Is.prototype.attrJoin = function(t, e) {
  const n = this.attrIndex(t);
  n < 0 ? this.attrPush([t, e]) : this.attrs[n][1] = this.attrs[n][1] + " " + e;
};
function Khe(t, e, n) {
  this.src = t, this.env = n, this.tokens = [], this.inlineMode = !1, this.md = e;
}
Khe.prototype.Token = Is;
const eVe = /\r\n?|\n/g, tVe = /\0/g;
function nVe(t) {
  let e;
  e = t.src.replace(eVe, `
`), e = e.replace(tVe, "�"), t.src = e;
}
function rVe(t) {
  let e;
  t.inlineMode ? (e = new t.Token("inline", "", 0), e.content = t.src, e.map = [0, 1], e.children = [], t.tokens.push(e)) : t.md.block.parse(t.src, t.md, t.env, t.tokens);
}
function oVe(t) {
  const e = t.tokens;
  for (let n = 0, r = e.length; n < r; n++) {
    const o = e[n];
    o.type === "inline" && t.md.inline.parse(o.content, t.md, t.env, o.children);
  }
}
function iVe(t) {
  return /^<a[>\s]/i.test(t);
}
function sVe(t) {
  return /^<\/a\s*>/i.test(t);
}
function aVe(t) {
  const e = t.tokens;
  if (t.md.options.linkify)
    for (let n = 0, r = e.length; n < r; n++) {
      if (e[n].type !== "inline" || !t.md.linkify.pretest(e[n].content))
        continue;
      let o = e[n].children, i = 0;
      for (let s = o.length - 1; s >= 0; s--) {
        const a = o[s];
        if (a.type === "link_close") {
          for (s--; o[s].level !== a.level && o[s].type !== "link_open"; )
            s--;
          continue;
        }
        if (a.type === "html_inline" && (iVe(a.content) && i > 0 && i--, sVe(a.content) && i++), !(i > 0) && a.type === "text" && t.md.linkify.test(a.content)) {
          const l = a.content;
          let c = t.md.linkify.match(l);
          const u = [];
          let d = a.level, f = 0;
          c.length > 0 && c[0].index === 0 && s > 0 && o[s - 1].type === "text_special" && (c = c.slice(1));
          for (let h = 0; h < c.length; h++) {
            const p = c[h].url, m = t.md.normalizeLink(p);
            if (!t.md.validateLink(m))
              continue;
            let g = c[h].text;
            c[h].schema ? c[h].schema === "mailto:" && !/^mailto:/i.test(g) ? g = t.md.normalizeLinkText("mailto:" + g).replace(/^mailto:/, "") : g = t.md.normalizeLinkText(g) : g = t.md.normalizeLinkText("http://" + g).replace(/^http:\/\//, "");
            const y = c[h].index;
            if (y > f) {
              const w = new t.Token("text", "", 0);
              w.content = l.slice(f, y), w.level = d, u.push(w);
            }
            const v = new t.Token("link_open", "a", 1);
            v.attrs = [["href", m]], v.level = d++, v.markup = "linkify", v.info = "auto", u.push(v);
            const b = new t.Token("text", "", 0);
            b.content = g, b.level = d, u.push(b);
            const _ = new t.Token("link_close", "a", -1);
            _.level = --d, _.markup = "linkify", _.info = "auto", u.push(_), f = c[h].lastIndex;
          }
          if (f < l.length) {
            const h = new t.Token("text", "", 0);
            h.content = l.slice(f), h.level = d, u.push(h);
          }
          e[n].children = o = Ghe(o, s, u);
        }
      }
    }
}
const Xhe = /\+-|\.\.|\?\?\?\?|!!!!|,,|--/, lVe = /\((c|tm|r)\)/i, cVe = /\((c|tm|r)\)/ig, uVe = {
  c: "©",
  r: "®",
  tm: "™"
};
function dVe(t, e) {
  return uVe[e.toLowerCase()];
}
function fVe(t) {
  let e = 0;
  for (let n = t.length - 1; n >= 0; n--) {
    const r = t[n];
    r.type === "text" && !e && (r.content = r.content.replace(cVe, dVe)), r.type === "link_open" && r.info === "auto" && e--, r.type === "link_close" && r.info === "auto" && e++;
  }
}
function hVe(t) {
  let e = 0;
  for (let n = t.length - 1; n >= 0; n--) {
    const r = t[n];
    r.type === "text" && !e && Xhe.test(r.content) && (r.content = r.content.replace(/\+-/g, "±").replace(/\.{2,}/g, "…").replace(/([?!])…/g, "$1..").replace(/([?!]){4,}/g, "$1$1$1").replace(/,{2,}/g, ",").replace(/(^|[^-])---(?=[^-]|$)/mg, "$1—").replace(/(^|\s)--(?=\s|$)/mg, "$1–").replace(/(^|[^-\s])--(?=[^-\s]|$)/mg, "$1–")), r.type === "link_open" && r.info === "auto" && e--, r.type === "link_close" && r.info === "auto" && e++;
  }
}
function pVe(t) {
  let e;
  if (t.md.options.typographer)
    for (e = t.tokens.length - 1; e >= 0; e--)
      t.tokens[e].type === "inline" && (lVe.test(t.tokens[e].content) && fVe(t.tokens[e].children), Xhe.test(t.tokens[e].content) && hVe(t.tokens[e].children));
}
const mVe = /['"]/, _q = /['"]/g, wq = "’";
function Kb(t, e, n) {
  return t.slice(0, e) + n + t.slice(e + 1);
}
function gVe(t, e) {
  let n;
  const r = [];
  for (let o = 0; o < t.length; o++) {
    const i = t[o], s = t[o].level;
    for (n = r.length - 1; n >= 0 && !(r[n].level <= s); n--)
      ;
    if (r.length = n + 1, i.type !== "text")
      continue;
    let a = i.content, l = 0, c = a.length;
    e:
      for (; l < c; ) {
        _q.lastIndex = l;
        const u = _q.exec(a);
        if (!u)
          break;
        let d = !0, f = !0;
        l = u.index + 1;
        const h = u[0] === "'";
        let p = 32;
        if (u.index - 1 >= 0)
          p = a.charCodeAt(u.index - 1);
        else
          for (n = o - 1; n >= 0 && !(t[n].type === "softbreak" || t[n].type === "hardbreak"); n--)
            if (t[n].content) {
              p = t[n].content.charCodeAt(t[n].content.length - 1);
              break;
            }
        let m = 32;
        if (l < c)
          m = a.charCodeAt(l);
        else
          for (n = o + 1; n < t.length && !(t[n].type === "softbreak" || t[n].type === "hardbreak"); n++)
            if (t[n].content) {
              m = t[n].content.charCodeAt(0);
              break;
            }
        const g = cy(p) || ly(String.fromCharCode(p)), y = cy(m) || ly(String.fromCharCode(m)), v = ay(p), b = ay(m);
        if (b ? d = !1 : y && (v || g || (d = !1)), v ? f = !1 : g && (b || y || (f = !1)), m === 34 && u[0] === '"' && p >= 48 && p <= 57 && (f = d = !1), d && f && (d = g, f = y), !d && !f) {
          h && (i.content = Kb(i.content, u.index, wq));
          continue;
        }
        if (f)
          for (n = r.length - 1; n >= 0; n--) {
            let _ = r[n];
            if (r[n].level < s)
              break;
            if (_.single === h && r[n].level === s) {
              _ = r[n];
              let w, x;
              h ? (w = e.md.options.quotes[2], x = e.md.options.quotes[3]) : (w = e.md.options.quotes[0], x = e.md.options.quotes[1]), i.content = Kb(i.content, u.index, x), t[_.token].content = Kb(
                t[_.token].content,
                _.pos,
                w
              ), l += x.length - 1, _.token === o && (l += w.length - 1), a = i.content, c = a.length, r.length = n;
              continue e;
            }
          }
        d ? r.push({
          token: o,
          pos: u.index,
          single: h,
          level: s
        }) : f && h && (i.content = Kb(i.content, u.index, wq));
      }
  }
}
function yVe(t) {
  if (t.md.options.typographer)
    for (let e = t.tokens.length - 1; e >= 0; e--)
      t.tokens[e].type !== "inline" || !mVe.test(t.tokens[e].content) || gVe(t.tokens[e].children, t);
}
function vVe(t) {
  let e, n;
  const r = t.tokens, o = r.length;
  for (let i = 0; i < o; i++) {
    if (r[i].type !== "inline") continue;
    const s = r[i].children, a = s.length;
    for (e = 0; e < a; e++)
      s[e].type === "text_special" && (s[e].type = "text");
    for (e = n = 0; e < a; e++)
      s[e].type === "text" && e + 1 < a && s[e + 1].type === "text" ? s[e + 1].content = s[e].content + s[e + 1].content : (e !== n && (s[n] = s[e]), n++);
    e !== n && (s.length = n);
  }
}
const Ak = [
  ["normalize", nVe],
  ["block", rVe],
  ["inline", oVe],
  ["linkify", aVe],
  ["replacements", pVe],
  ["smartquotes", yVe],
  // `text_join` finds `text_special` tokens (for escape sequences)
  // and joins them with the rest of the text
  ["text_join", vVe]
];
function BL() {
  this.ruler = new ei();
  for (let t = 0; t < Ak.length; t++)
    this.ruler.push(Ak[t][0], Ak[t][1]);
}
BL.prototype.process = function(t) {
  const e = this.ruler.getRules("");
  for (let n = 0, r = e.length; n < r; n++)
    e[n](t);
};
BL.prototype.State = Khe;
function Da(t, e, n, r) {
  this.src = t, this.md = e, this.env = n, this.tokens = r, this.bMarks = [], this.eMarks = [], this.tShift = [], this.sCount = [], this.bsCount = [], this.blkIndent = 0, this.line = 0, this.lineMax = 0, this.tight = !1, this.ddIndent = -1, this.listIndent = -1, this.parentType = "root", this.level = 0;
  const o = this.src;
  for (let i = 0, s = 0, a = 0, l = 0, c = o.length, u = !1; s < c; s++) {
    const d = o.charCodeAt(s);
    if (!u)
      if (Un(d)) {
        a++, d === 9 ? l += 4 - l % 4 : l++;
        continue;
      } else
        u = !0;
    (d === 10 || s === c - 1) && (d !== 10 && s++, this.bMarks.push(i), this.eMarks.push(s), this.tShift.push(a), this.sCount.push(l), this.bsCount.push(0), u = !1, a = 0, l = 0, i = s + 1);
  }
  this.bMarks.push(o.length), this.eMarks.push(o.length), this.tShift.push(0), this.sCount.push(0), this.bsCount.push(0), this.lineMax = this.bMarks.length - 1;
}
Da.prototype.push = function(t, e, n) {
  const r = new Is(t, e, n);
  return r.block = !0, n < 0 && this.level--, r.level = this.level, n > 0 && this.level++, this.tokens.push(r), r;
};
Da.prototype.isEmpty = function(t) {
  return this.bMarks[t] + this.tShift[t] >= this.eMarks[t];
};
Da.prototype.skipEmptyLines = function(t) {
  for (let e = this.lineMax; t < e && !(this.bMarks[t] + this.tShift[t] < this.eMarks[t]); t++)
    ;
  return t;
};
Da.prototype.skipSpaces = function(t) {
  for (let e = this.src.length; t < e; t++) {
    const n = this.src.charCodeAt(t);
    if (!Un(n))
      break;
  }
  return t;
};
Da.prototype.skipSpacesBack = function(t, e) {
  if (t <= e)
    return t;
  for (; t > e; )
    if (!Un(this.src.charCodeAt(--t)))
      return t + 1;
  return t;
};
Da.prototype.skipChars = function(t, e) {
  for (let n = this.src.length; t < n && this.src.charCodeAt(t) === e; t++)
    ;
  return t;
};
Da.prototype.skipCharsBack = function(t, e, n) {
  if (t <= n)
    return t;
  for (; t > n; )
    if (e !== this.src.charCodeAt(--t))
      return t + 1;
  return t;
};
Da.prototype.getLines = function(t, e, n, r) {
  if (t >= e)
    return "";
  const o = new Array(e - t);
  for (let i = 0, s = t; s < e; s++, i++) {
    let a = 0;
    const l = this.bMarks[s];
    let c = l, u;
    for (s + 1 < e || r ? u = this.eMarks[s] + 1 : u = this.eMarks[s]; c < u && a < n; ) {
      const d = this.src.charCodeAt(c);
      if (Un(d))
        d === 9 ? a += 4 - (a + this.bsCount[s]) % 4 : a++;
      else if (c - l < this.tShift[s])
        a++;
      else
        break;
      c++;
    }
    a > n ? o[i] = new Array(a - n + 1).join(" ") + this.src.slice(c, u) : o[i] = this.src.slice(c, u);
  }
  return o.join("");
};
Da.prototype.Token = Is;
const bVe = 65536;
function Tk(t, e) {
  const n = t.bMarks[e] + t.tShift[e], r = t.eMarks[e];
  return t.src.slice(n, r);
}
function xq(t) {
  const e = [], n = t.length;
  let r = 0, o = t.charCodeAt(r), i = !1, s = 0, a = "";
  for (; r < n; )
    o === 124 && (i ? (a += t.substring(s, r - 1), s = r) : (e.push(a + t.substring(s, r)), a = "", s = r + 1)), i = o === 92, r++, o = t.charCodeAt(r);
  return e.push(a + t.substring(s)), e;
}
function _Ve(t, e, n, r) {
  if (e + 2 > n)
    return !1;
  let o = e + 1;
  if (t.sCount[o] < t.blkIndent || t.sCount[o] - t.blkIndent >= 4)
    return !1;
  let i = t.bMarks[o] + t.tShift[o];
  if (i >= t.eMarks[o])
    return !1;
  const s = t.src.charCodeAt(i++);
  if (s !== 124 && s !== 45 && s !== 58 || i >= t.eMarks[o])
    return !1;
  const a = t.src.charCodeAt(i++);
  if (a !== 124 && a !== 45 && a !== 58 && !Un(a) || s === 45 && Un(a))
    return !1;
  for (; i < t.eMarks[o]; ) {
    const _ = t.src.charCodeAt(i);
    if (_ !== 124 && _ !== 45 && _ !== 58 && !Un(_))
      return !1;
    i++;
  }
  let l = Tk(t, e + 1), c = l.split("|");
  const u = [];
  for (let _ = 0; _ < c.length; _++) {
    const w = c[_].trim();
    if (!w) {
      if (_ === 0 || _ === c.length - 1)
        continue;
      return !1;
    }
    if (!/^:?-+:?$/.test(w))
      return !1;
    w.charCodeAt(w.length - 1) === 58 ? u.push(w.charCodeAt(0) === 58 ? "center" : "right") : w.charCodeAt(0) === 58 ? u.push("left") : u.push("");
  }
  if (l = Tk(t, e).trim(), l.indexOf("|") === -1 || t.sCount[e] - t.blkIndent >= 4)
    return !1;
  c = xq(l), c.length && c[0] === "" && c.shift(), c.length && c[c.length - 1] === "" && c.pop();
  const d = c.length;
  if (d === 0 || d !== u.length)
    return !1;
  if (r)
    return !0;
  const f = t.parentType;
  t.parentType = "table";
  const h = t.md.block.ruler.getRules("blockquote"), p = t.push("table_open", "table", 1), m = [e, 0];
  p.map = m;
  const g = t.push("thead_open", "thead", 1);
  g.map = [e, e + 1];
  const y = t.push("tr_open", "tr", 1);
  y.map = [e, e + 1];
  for (let _ = 0; _ < c.length; _++) {
    const w = t.push("th_open", "th", 1);
    u[_] && (w.attrs = [["style", "text-align:" + u[_]]]);
    const x = t.push("inline", "", 0);
    x.content = c[_].trim(), x.children = [], t.push("th_close", "th", -1);
  }
  t.push("tr_close", "tr", -1), t.push("thead_close", "thead", -1);
  let v, b = 0;
  for (o = e + 2; o < n && !(t.sCount[o] < t.blkIndent); o++) {
    let _ = !1;
    for (let x = 0, E = h.length; x < E; x++)
      if (h[x](t, o, n, !0)) {
        _ = !0;
        break;
      }
    if (_ || (l = Tk(t, o).trim(), !l) || t.sCount[o] - t.blkIndent >= 4 || (c = xq(l), c.length && c[0] === "" && c.shift(), c.length && c[c.length - 1] === "" && c.pop(), b += d - c.length, b > bVe))
      break;
    if (o === e + 2) {
      const x = t.push("tbody_open", "tbody", 1);
      x.map = v = [e + 2, 0];
    }
    const w = t.push("tr_open", "tr", 1);
    w.map = [o, o + 1];
    for (let x = 0; x < d; x++) {
      const E = t.push("td_open", "td", 1);
      u[x] && (E.attrs = [["style", "text-align:" + u[x]]]);
      const S = t.push("inline", "", 0);
      S.content = c[x] ? c[x].trim() : "", S.children = [], t.push("td_close", "td", -1);
    }
    t.push("tr_close", "tr", -1);
  }
  return v && (t.push("tbody_close", "tbody", -1), v[1] = o), t.push("table_close", "table", -1), m[1] = o, t.parentType = f, t.line = o, !0;
}
function wVe(t, e, n) {
  if (t.sCount[e] - t.blkIndent < 4)
    return !1;
  let r = e + 1, o = r;
  for (; r < n; ) {
    if (t.isEmpty(r)) {
      r++;
      continue;
    }
    if (t.sCount[r] - t.blkIndent >= 4) {
      r++, o = r;
      continue;
    }
    break;
  }
  t.line = o;
  const i = t.push("code_block", "code", 0);
  return i.content = t.getLines(e, o, 4 + t.blkIndent, !1) + `
`, i.map = [e, t.line], !0;
}
function xVe(t, e, n, r) {
  let o = t.bMarks[e] + t.tShift[e], i = t.eMarks[e];
  if (t.sCount[e] - t.blkIndent >= 4 || o + 3 > i)
    return !1;
  const s = t.src.charCodeAt(o);
  if (s !== 126 && s !== 96)
    return !1;
  let a = o;
  o = t.skipChars(o, s);
  let l = o - a;
  if (l < 3)
    return !1;
  const c = t.src.slice(a, o), u = t.src.slice(o, i);
  if (s === 96 && u.indexOf(String.fromCharCode(s)) >= 0)
    return !1;
  if (r)
    return !0;
  let d = e, f = !1;
  for (; d++, !(d >= n || (o = a = t.bMarks[d] + t.tShift[d], i = t.eMarks[d], o < i && t.sCount[d] < t.blkIndent)); )
    if (t.src.charCodeAt(o) === s && !(t.sCount[d] - t.blkIndent >= 4) && (o = t.skipChars(o, s), !(o - a < l) && (o = t.skipSpaces(o), !(o < i)))) {
      f = !0;
      break;
    }
  l = t.sCount[e], t.line = d + (f ? 1 : 0);
  const h = t.push("fence", "code", 0);
  return h.info = u, h.content = t.getLines(e + 1, d, l, !0), h.markup = c, h.map = [e, t.line], !0;
}
function EVe(t, e, n, r) {
  let o = t.bMarks[e] + t.tShift[e], i = t.eMarks[e];
  const s = t.lineMax;
  if (t.sCount[e] - t.blkIndent >= 4 || t.src.charCodeAt(o) !== 62)
    return !1;
  if (r)
    return !0;
  const a = [], l = [], c = [], u = [], d = t.md.block.ruler.getRules("blockquote"), f = t.parentType;
  t.parentType = "blockquote";
  let h = !1, p;
  for (p = e; p < n; p++) {
    const b = t.sCount[p] < t.blkIndent;
    if (o = t.bMarks[p] + t.tShift[p], i = t.eMarks[p], o >= i)
      break;
    if (t.src.charCodeAt(o++) === 62 && !b) {
      let w = t.sCount[p] + 1, x, E;
      t.src.charCodeAt(o) === 32 ? (o++, w++, E = !1, x = !0) : t.src.charCodeAt(o) === 9 ? (x = !0, (t.bsCount[p] + w) % 4 === 3 ? (o++, w++, E = !1) : E = !0) : x = !1;
      let S = w;
      for (a.push(t.bMarks[p]), t.bMarks[p] = o; o < i; ) {
        const C = t.src.charCodeAt(o);
        if (Un(C))
          C === 9 ? S += 4 - (S + t.bsCount[p] + (E ? 1 : 0)) % 4 : S++;
        else
          break;
        o++;
      }
      h = o >= i, l.push(t.bsCount[p]), t.bsCount[p] = t.sCount[p] + 1 + (x ? 1 : 0), c.push(t.sCount[p]), t.sCount[p] = S - w, u.push(t.tShift[p]), t.tShift[p] = o - t.bMarks[p];
      continue;
    }
    if (h)
      break;
    let _ = !1;
    for (let w = 0, x = d.length; w < x; w++)
      if (d[w](t, p, n, !0)) {
        _ = !0;
        break;
      }
    if (_) {
      t.lineMax = p, t.blkIndent !== 0 && (a.push(t.bMarks[p]), l.push(t.bsCount[p]), u.push(t.tShift[p]), c.push(t.sCount[p]), t.sCount[p] -= t.blkIndent);
      break;
    }
    a.push(t.bMarks[p]), l.push(t.bsCount[p]), u.push(t.tShift[p]), c.push(t.sCount[p]), t.sCount[p] = -1;
  }
  const m = t.blkIndent;
  t.blkIndent = 0;
  const g = t.push("blockquote_open", "blockquote", 1);
  g.markup = ">";
  const y = [e, 0];
  g.map = y, t.md.block.tokenize(t, e, p);
  const v = t.push("blockquote_close", "blockquote", -1);
  v.markup = ">", t.lineMax = s, t.parentType = f, y[1] = t.line;
  for (let b = 0; b < u.length; b++)
    t.bMarks[b + e] = a[b], t.tShift[b + e] = u[b], t.sCount[b + e] = c[b], t.bsCount[b + e] = l[b];
  return t.blkIndent = m, !0;
}
function SVe(t, e, n, r) {
  const o = t.eMarks[e];
  if (t.sCount[e] - t.blkIndent >= 4)
    return !1;
  let i = t.bMarks[e] + t.tShift[e];
  const s = t.src.charCodeAt(i++);
  if (s !== 42 && s !== 45 && s !== 95)
    return !1;
  let a = 1;
  for (; i < o; ) {
    const c = t.src.charCodeAt(i++);
    if (c !== s && !Un(c))
      return !1;
    c === s && a++;
  }
  if (a < 3)
    return !1;
  if (r)
    return !0;
  t.line = e + 1;
  const l = t.push("hr", "hr", 0);
  return l.map = [e, t.line], l.markup = Array(a + 1).join(String.fromCharCode(s)), !0;
}
function Eq(t, e) {
  const n = t.eMarks[e];
  let r = t.bMarks[e] + t.tShift[e];
  const o = t.src.charCodeAt(r++);
  if (o !== 42 && o !== 45 && o !== 43)
    return -1;
  if (r < n) {
    const i = t.src.charCodeAt(r);
    if (!Un(i))
      return -1;
  }
  return r;
}
function Sq(t, e) {
  const n = t.bMarks[e] + t.tShift[e], r = t.eMarks[e];
  let o = n;
  if (o + 1 >= r)
    return -1;
  let i = t.src.charCodeAt(o++);
  if (i < 48 || i > 57)
    return -1;
  for (; ; ) {
    if (o >= r)
      return -1;
    if (i = t.src.charCodeAt(o++), i >= 48 && i <= 57) {
      if (o - n >= 10)
        return -1;
      continue;
    }
    if (i === 41 || i === 46)
      break;
    return -1;
  }
  return o < r && (i = t.src.charCodeAt(o), !Un(i)) ? -1 : o;
}
function OVe(t, e) {
  const n = t.level + 2;
  for (let r = e + 2, o = t.tokens.length - 2; r < o; r++)
    t.tokens[r].level === n && t.tokens[r].type === "paragraph_open" && (t.tokens[r + 2].hidden = !0, t.tokens[r].hidden = !0, r += 2);
}
function CVe(t, e, n, r) {
  let o, i, s, a, l = e, c = !0;
  if (t.sCount[l] - t.blkIndent >= 4 || t.listIndent >= 0 && t.sCount[l] - t.listIndent >= 4 && t.sCount[l] < t.blkIndent)
    return !1;
  let u = !1;
  r && t.parentType === "paragraph" && t.sCount[l] >= t.blkIndent && (u = !0);
  let d, f, h;
  if ((h = Sq(t, l)) >= 0) {
    if (d = !0, s = t.bMarks[l] + t.tShift[l], f = Number(t.src.slice(s, h - 1)), u && f !== 1) return !1;
  } else if ((h = Eq(t, l)) >= 0)
    d = !1;
  else
    return !1;
  if (u && t.skipSpaces(h) >= t.eMarks[l])
    return !1;
  if (r)
    return !0;
  const p = t.src.charCodeAt(h - 1), m = t.tokens.length;
  d ? (a = t.push("ordered_list_open", "ol", 1), f !== 1 && (a.attrs = [["start", f]])) : a = t.push("bullet_list_open", "ul", 1);
  const g = [l, 0];
  a.map = g, a.markup = String.fromCharCode(p);
  let y = !1;
  const v = t.md.block.ruler.getRules("list"), b = t.parentType;
  for (t.parentType = "list"; l < n; ) {
    i = h, o = t.eMarks[l];
    const _ = t.sCount[l] + h - (t.bMarks[l] + t.tShift[l]);
    let w = _;
    for (; i < o; ) {
      const k = t.src.charCodeAt(i);
      if (k === 9)
        w += 4 - (w + t.bsCount[l]) % 4;
      else if (k === 32)
        w++;
      else
        break;
      i++;
    }
    const x = i;
    let E;
    x >= o ? E = 1 : E = w - _, E > 4 && (E = 1);
    const S = _ + E;
    a = t.push("list_item_open", "li", 1), a.markup = String.fromCharCode(p);
    const C = [l, 0];
    a.map = C, d && (a.info = t.src.slice(s, h - 1));
    const R = t.tight, P = t.tShift[l], N = t.sCount[l], A = t.listIndent;
    if (t.listIndent = t.blkIndent, t.blkIndent = S, t.tight = !0, t.tShift[l] = x - t.bMarks[l], t.sCount[l] = w, x >= o && t.isEmpty(l + 1) ? t.line = Math.min(t.line + 2, n) : t.md.block.tokenize(t, l, n, !0), (!t.tight || y) && (c = !1), y = t.line - l > 1 && t.isEmpty(t.line - 1), t.blkIndent = t.listIndent, t.listIndent = A, t.tShift[l] = P, t.sCount[l] = N, t.tight = R, a = t.push("list_item_close", "li", -1), a.markup = String.fromCharCode(p), l = t.line, C[1] = l, l >= n || t.sCount[l] < t.blkIndent || t.sCount[l] - t.blkIndent >= 4)
      break;
    let O = !1;
    for (let k = 0, T = v.length; k < T; k++)
      if (v[k](t, l, n, !0)) {
        O = !0;
        break;
      }
    if (O)
      break;
    if (d) {
      if (h = Sq(t, l), h < 0)
        break;
      s = t.bMarks[l] + t.tShift[l];
    } else if (h = Eq(t, l), h < 0)
      break;
    if (p !== t.src.charCodeAt(h - 1))
      break;
  }
  return d ? a = t.push("ordered_list_close", "ol", -1) : a = t.push("bullet_list_close", "ul", -1), a.markup = String.fromCharCode(p), g[1] = l, t.line = l, t.parentType = b, c && OVe(t, m), !0;
}
function kVe(t, e, n, r) {
  let o = t.bMarks[e] + t.tShift[e], i = t.eMarks[e], s = e + 1;
  if (t.sCount[e] - t.blkIndent >= 4 || t.src.charCodeAt(o) !== 91)
    return !1;
  function a(v) {
    const b = t.lineMax;
    if (v >= b || t.isEmpty(v))
      return null;
    let _ = !1;
    if (t.sCount[v] - t.blkIndent > 3 && (_ = !0), t.sCount[v] < 0 && (_ = !0), !_) {
      const E = t.md.block.ruler.getRules("reference"), S = t.parentType;
      t.parentType = "reference";
      let C = !1;
      for (let R = 0, P = E.length; R < P; R++)
        if (E[R](t, v, b, !0)) {
          C = !0;
          break;
        }
      if (t.parentType = S, C)
        return null;
    }
    const w = t.bMarks[v] + t.tShift[v], x = t.eMarks[v];
    return t.src.slice(w, x + 1);
  }
  let l = t.src.slice(o, i + 1);
  i = l.length;
  let c = -1;
  for (o = 1; o < i; o++) {
    const v = l.charCodeAt(o);
    if (v === 91)
      return !1;
    if (v === 93) {
      c = o;
      break;
    } else if (v === 10) {
      const b = a(s);
      b !== null && (l += b, i = l.length, s++);
    } else if (v === 92 && (o++, o < i && l.charCodeAt(o) === 10)) {
      const b = a(s);
      b !== null && (l += b, i = l.length, s++);
    }
  }
  if (c < 0 || l.charCodeAt(c + 1) !== 58)
    return !1;
  for (o = c + 2; o < i; o++) {
    const v = l.charCodeAt(o);
    if (v === 10) {
      const b = a(s);
      b !== null && (l += b, i = l.length, s++);
    } else if (!Un(v)) break;
  }
  const u = t.md.helpers.parseLinkDestination(l, o, i);
  if (!u.ok)
    return !1;
  const d = t.md.normalizeLink(u.str);
  if (!t.md.validateLink(d))
    return !1;
  o = u.pos;
  const f = o, h = s, p = o;
  for (; o < i; o++) {
    const v = l.charCodeAt(o);
    if (v === 10) {
      const b = a(s);
      b !== null && (l += b, i = l.length, s++);
    } else if (!Un(v)) break;
  }
  let m = t.md.helpers.parseLinkTitle(l, o, i);
  for (; m.can_continue; ) {
    const v = a(s);
    if (v === null) break;
    l += v, o = i, i = l.length, s++, m = t.md.helpers.parseLinkTitle(l, o, i, m);
  }
  let g;
  for (o < i && p !== o && m.ok ? (g = m.str, o = m.pos) : (g = "", o = f, s = h); o < i; ) {
    const v = l.charCodeAt(o);
    if (!Un(v))
      break;
    o++;
  }
  if (o < i && l.charCodeAt(o) !== 10 && g)
    for (g = "", o = f, s = h; o < i; ) {
      const v = l.charCodeAt(o);
      if (!Un(v))
        break;
      o++;
    }
  if (o < i && l.charCodeAt(o) !== 10)
    return !1;
  const y = qS(l.slice(1, c));
  return y ? (r || (typeof t.env.references > "u" && (t.env.references = {}), typeof t.env.references[y] > "u" && (t.env.references[y] = { title: g, href: d }), t.line = s), !0) : !1;
}
const AVe = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], TVe = "[a-zA-Z_:][a-zA-Z0-9:._-]*", RVe = "[^\"'=<>`\\x00-\\x20]+", PVe = "'[^']*'", $Ve = '"[^"]*"', MVe = "(?:" + RVe + "|" + PVe + "|" + $Ve + ")", DVe = "(?:\\s+" + TVe + "(?:\\s*=\\s*" + MVe + ")?)", Qhe = "<[A-Za-z][A-Za-z0-9\\-]*" + DVe + "*\\s*\\/?>", Zhe = "<\\/[A-Za-z][A-Za-z0-9\\-]*\\s*>", IVe = "<!---?>|<!--(?:[^-]|-[^-]|--[^>])*-->", NVe = "<[?][\\s\\S]*?[?]>", jVe = "<![A-Za-z][^>]*>", LVe = "<!\\[CDATA\\[[\\s\\S]*?\\]\\]>", FVe = new RegExp("^(?:" + Qhe + "|" + Zhe + "|" + IVe + "|" + NVe + "|" + jVe + "|" + LVe + ")"), BVe = new RegExp("^(?:" + Qhe + "|" + Zhe + ")"), _f = [
  [/^<(script|pre|style|textarea)(?=(\s|>|$))/i, /<\/(script|pre|style|textarea)>/i, !0],
  [/^<!--/, /-->/, !0],
  [/^<\?/, /\?>/, !0],
  [/^<![A-Z]/, />/, !0],
  [/^<!\[CDATA\[/, /\]\]>/, !0],
  [new RegExp("^</?(" + AVe.join("|") + ")(?=(\\s|/?>|$))", "i"), /^$/, !0],
  [new RegExp(BVe.source + "\\s*$"), /^$/, !1]
];
function zVe(t, e, n, r) {
  let o = t.bMarks[e] + t.tShift[e], i = t.eMarks[e];
  if (t.sCount[e] - t.blkIndent >= 4 || !t.md.options.html || t.src.charCodeAt(o) !== 60)
    return !1;
  let s = t.src.slice(o, i), a = 0;
  for (; a < _f.length && !_f[a][0].test(s); a++)
    ;
  if (a === _f.length)
    return !1;
  if (r)
    return _f[a][2];
  let l = e + 1;
  if (!_f[a][1].test(s)) {
    for (; l < n && !(t.sCount[l] < t.blkIndent); l++)
      if (o = t.bMarks[l] + t.tShift[l], i = t.eMarks[l], s = t.src.slice(o, i), _f[a][1].test(s)) {
        s.length !== 0 && l++;
        break;
      }
  }
  t.line = l;
  const c = t.push("html_block", "", 0);
  return c.map = [e, l], c.content = t.getLines(e, l, t.blkIndent, !0), !0;
}
function qVe(t, e, n, r) {
  let o = t.bMarks[e] + t.tShift[e], i = t.eMarks[e];
  if (t.sCount[e] - t.blkIndent >= 4)
    return !1;
  let s = t.src.charCodeAt(o);
  if (s !== 35 || o >= i)
    return !1;
  let a = 1;
  for (s = t.src.charCodeAt(++o); s === 35 && o < i && a <= 6; )
    a++, s = t.src.charCodeAt(++o);
  if (a > 6 || o < i && !Un(s))
    return !1;
  if (r)
    return !0;
  i = t.skipSpacesBack(i, o);
  const l = t.skipCharsBack(i, 35, o);
  l > o && Un(t.src.charCodeAt(l - 1)) && (i = l), t.line = e + 1;
  const c = t.push("heading_open", "h" + String(a), 1);
  c.markup = "########".slice(0, a), c.map = [e, t.line];
  const u = t.push("inline", "", 0);
  u.content = t.src.slice(o, i).trim(), u.map = [e, t.line], u.children = [];
  const d = t.push("heading_close", "h" + String(a), -1);
  return d.markup = "########".slice(0, a), !0;
}
function UVe(t, e, n) {
  const r = t.md.block.ruler.getRules("paragraph");
  if (t.sCount[e] - t.blkIndent >= 4)
    return !1;
  const o = t.parentType;
  t.parentType = "paragraph";
  let i = 0, s, a = e + 1;
  for (; a < n && !t.isEmpty(a); a++) {
    if (t.sCount[a] - t.blkIndent > 3)
      continue;
    if (t.sCount[a] >= t.blkIndent) {
      let h = t.bMarks[a] + t.tShift[a];
      const p = t.eMarks[a];
      if (h < p && (s = t.src.charCodeAt(h), (s === 45 || s === 61) && (h = t.skipChars(h, s), h = t.skipSpaces(h), h >= p))) {
        i = s === 61 ? 1 : 2;
        break;
      }
    }
    if (t.sCount[a] < 0)
      continue;
    let f = !1;
    for (let h = 0, p = r.length; h < p; h++)
      if (r[h](t, a, n, !0)) {
        f = !0;
        break;
      }
    if (f)
      break;
  }
  if (!i)
    return !1;
  const l = t.getLines(e, a, t.blkIndent, !1).trim();
  t.line = a + 1;
  const c = t.push("heading_open", "h" + String(i), 1);
  c.markup = String.fromCharCode(s), c.map = [e, t.line];
  const u = t.push("inline", "", 0);
  u.content = l, u.map = [e, t.line - 1], u.children = [];
  const d = t.push("heading_close", "h" + String(i), -1);
  return d.markup = String.fromCharCode(s), t.parentType = o, !0;
}
function HVe(t, e, n) {
  const r = t.md.block.ruler.getRules("paragraph"), o = t.parentType;
  let i = e + 1;
  for (t.parentType = "paragraph"; i < n && !t.isEmpty(i); i++) {
    if (t.sCount[i] - t.blkIndent > 3 || t.sCount[i] < 0)
      continue;
    let c = !1;
    for (let u = 0, d = r.length; u < d; u++)
      if (r[u](t, i, n, !0)) {
        c = !0;
        break;
      }
    if (c)
      break;
  }
  const s = t.getLines(e, i, t.blkIndent, !1).trim();
  t.line = i;
  const a = t.push("paragraph_open", "p", 1);
  a.map = [e, t.line];
  const l = t.push("inline", "", 0);
  return l.content = s, l.map = [e, t.line], l.children = [], t.push("paragraph_close", "p", -1), t.parentType = o, !0;
}
const Xb = [
  // First 2 params - rule name & source. Secondary array - list of rules,
  // which can be terminated by this one.
  ["table", _Ve, ["paragraph", "reference"]],
  ["code", wVe],
  ["fence", xVe, ["paragraph", "reference", "blockquote", "list"]],
  ["blockquote", EVe, ["paragraph", "reference", "blockquote", "list"]],
  ["hr", SVe, ["paragraph", "reference", "blockquote", "list"]],
  ["list", CVe, ["paragraph", "reference", "blockquote"]],
  ["reference", kVe],
  ["html_block", zVe, ["paragraph", "reference", "blockquote"]],
  ["heading", qVe, ["paragraph", "reference", "blockquote"]],
  ["lheading", UVe],
  ["paragraph", HVe]
];
function US() {
  this.ruler = new ei();
  for (let t = 0; t < Xb.length; t++)
    this.ruler.push(Xb[t][0], Xb[t][1], { alt: (Xb[t][2] || []).slice() });
}
US.prototype.tokenize = function(t, e, n) {
  const r = this.ruler.getRules(""), o = r.length, i = t.md.options.maxNesting;
  let s = e, a = !1;
  for (; s < n && (t.line = s = t.skipEmptyLines(s), !(s >= n || t.sCount[s] < t.blkIndent)); ) {
    if (t.level >= i) {
      t.line = n;
      break;
    }
    const l = t.line;
    let c = !1;
    for (let u = 0; u < o; u++)
      if (c = r[u](t, s, n, !1), c) {
        if (l >= t.line)
          throw new Error("block rule didn't increment state.line");
        break;
      }
    if (!c) throw new Error("none of the block rules matched");
    t.tight = !a, t.isEmpty(t.line - 1) && (a = !0), s = t.line, s < n && t.isEmpty(s) && (a = !0, s++, t.line = s);
  }
};
US.prototype.parse = function(t, e, n, r) {
  if (!t)
    return;
  const o = new this.State(t, e, n, r);
  this.tokenize(o, o.line, o.lineMax);
};
US.prototype.State = Da;
function bv(t, e, n, r) {
  this.src = t, this.env = n, this.md = e, this.tokens = r, this.tokens_meta = Array(r.length), this.pos = 0, this.posMax = this.src.length, this.level = 0, this.pending = "", this.pendingLevel = 0, this.cache = {}, this.delimiters = [], this._prev_delimiters = [], this.backticks = {}, this.backticksScanned = !1, this.linkLevel = 0;
}
bv.prototype.pushPending = function() {
  const t = new Is("text", "", 0);
  return t.content = this.pending, t.level = this.pendingLevel, this.tokens.push(t), this.pending = "", t;
};
bv.prototype.push = function(t, e, n) {
  this.pending && this.pushPending();
  const r = new Is(t, e, n);
  let o = null;
  return n < 0 && (this.level--, this.delimiters = this._prev_delimiters.pop()), r.level = this.level, n > 0 && (this.level++, this._prev_delimiters.push(this.delimiters), this.delimiters = [], o = { delimiters: this.delimiters }), this.pendingLevel = this.level, this.tokens.push(r), this.tokens_meta.push(o), r;
};
bv.prototype.scanDelims = function(t, e) {
  const n = this.posMax, r = this.src.charCodeAt(t), o = t > 0 ? this.src.charCodeAt(t - 1) : 32;
  let i = t;
  for (; i < n && this.src.charCodeAt(i) === r; )
    i++;
  const s = i - t, a = i < n ? this.src.charCodeAt(i) : 32, l = cy(o) || ly(String.fromCharCode(o)), c = cy(a) || ly(String.fromCharCode(a)), u = ay(o), d = ay(a), f = !d && (!c || u || l), h = !u && (!l || d || c);
  return { can_open: f && (e || !h || l), can_close: h && (e || !f || c), length: s };
};
bv.prototype.Token = Is;
function VVe(t) {
  switch (t) {
    case 10:
    case 33:
    case 35:
    case 36:
    case 37:
    case 38:
    case 42:
    case 43:
    case 45:
    case 58:
    case 60:
    case 61:
    case 62:
    case 64:
    case 91:
    case 92:
    case 93:
    case 94:
    case 95:
    case 96:
    case 123:
    case 125:
    case 126:
      return !0;
    default:
      return !1;
  }
}
function WVe(t, e) {
  let n = t.pos;
  for (; n < t.posMax && !VVe(t.src.charCodeAt(n)); )
    n++;
  return n === t.pos ? !1 : (e || (t.pending += t.src.slice(t.pos, n)), t.pos = n, !0);
}
const GVe = /(?:^|[^a-z0-9.+-])([a-z][a-z0-9.+-]*)$/i;
function YVe(t, e) {
  if (!t.md.options.linkify || t.linkLevel > 0) return !1;
  const n = t.pos, r = t.posMax;
  if (n + 3 > r || t.src.charCodeAt(n) !== 58 || t.src.charCodeAt(n + 1) !== 47 || t.src.charCodeAt(n + 2) !== 47) return !1;
  const o = t.pending.match(GVe);
  if (!o) return !1;
  const i = o[1], s = t.md.linkify.matchAtStart(t.src.slice(n - i.length));
  if (!s) return !1;
  let a = s.url;
  if (a.length <= i.length) return !1;
  a = a.replace(/\*+$/, "");
  const l = t.md.normalizeLink(a);
  if (!t.md.validateLink(l)) return !1;
  if (!e) {
    t.pending = t.pending.slice(0, -i.length);
    const c = t.push("link_open", "a", 1);
    c.attrs = [["href", l]], c.markup = "linkify", c.info = "auto";
    const u = t.push("text", "", 0);
    u.content = t.md.normalizeLinkText(a);
    const d = t.push("link_close", "a", -1);
    d.markup = "linkify", d.info = "auto";
  }
  return t.pos += a.length - i.length, !0;
}
function KVe(t, e) {
  let n = t.pos;
  if (t.src.charCodeAt(n) !== 10)
    return !1;
  const r = t.pending.length - 1, o = t.posMax;
  if (!e)
    if (r >= 0 && t.pending.charCodeAt(r) === 32)
      if (r >= 1 && t.pending.charCodeAt(r - 1) === 32) {
        let i = r - 1;
        for (; i >= 1 && t.pending.charCodeAt(i - 1) === 32; ) i--;
        t.pending = t.pending.slice(0, i), t.push("hardbreak", "br", 0);
      } else
        t.pending = t.pending.slice(0, -1), t.push("softbreak", "br", 0);
    else
      t.push("softbreak", "br", 0);
  for (n++; n < o && Un(t.src.charCodeAt(n)); )
    n++;
  return t.pos = n, !0;
}
const zL = [];
for (let t = 0; t < 256; t++)
  zL.push(0);
"\\!\"#$%&'()*+,./:;<=>?@[]^_`{|}~-".split("").forEach(function(t) {
  zL[t.charCodeAt(0)] = 1;
});
function XVe(t, e) {
  let n = t.pos;
  const r = t.posMax;
  if (t.src.charCodeAt(n) !== 92 || (n++, n >= r)) return !1;
  let o = t.src.charCodeAt(n);
  if (o === 10) {
    for (e || t.push("hardbreak", "br", 0), n++; n < r && (o = t.src.charCodeAt(n), !!Un(o)); )
      n++;
    return t.pos = n, !0;
  }
  let i = t.src[n];
  if (o >= 55296 && o <= 56319 && n + 1 < r) {
    const a = t.src.charCodeAt(n + 1);
    a >= 56320 && a <= 57343 && (i += t.src[n + 1], n++);
  }
  const s = "\\" + i;
  if (!e) {
    const a = t.push("text_special", "", 0);
    o < 256 && zL[o] !== 0 ? a.content = i : a.content = s, a.markup = s, a.info = "escape";
  }
  return t.pos = n + 1, !0;
}
function QVe(t, e) {
  let n = t.pos;
  if (t.src.charCodeAt(n) !== 96)
    return !1;
  const r = n;
  n++;
  const o = t.posMax;
  for (; n < o && t.src.charCodeAt(n) === 96; )
    n++;
  const i = t.src.slice(r, n), s = i.length;
  if (t.backticksScanned && (t.backticks[s] || 0) <= r)
    return e || (t.pending += i), t.pos += s, !0;
  let a = n, l;
  for (; (l = t.src.indexOf("`", a)) !== -1; ) {
    for (a = l + 1; a < o && t.src.charCodeAt(a) === 96; )
      a++;
    const c = a - l;
    if (c === s) {
      if (!e) {
        const u = t.push("code_inline", "code", 0);
        u.markup = i, u.content = t.src.slice(n, l).replace(/\n/g, " ").replace(/^ (.+) $/, "$1");
      }
      return t.pos = a, !0;
    }
    t.backticks[c] = l;
  }
  return t.backticksScanned = !0, e || (t.pending += i), t.pos += s, !0;
}
function ZVe(t, e) {
  const n = t.pos, r = t.src.charCodeAt(n);
  if (e || r !== 126)
    return !1;
  const o = t.scanDelims(t.pos, !0);
  let i = o.length;
  const s = String.fromCharCode(r);
  if (i < 2)
    return !1;
  let a;
  i % 2 && (a = t.push("text", "", 0), a.content = s, i--);
  for (let l = 0; l < i; l += 2)
    a = t.push("text", "", 0), a.content = s + s, t.delimiters.push({
      marker: r,
      length: 0,
      // disable "rule of 3" length checks meant for emphasis
      token: t.tokens.length - 1,
      end: -1,
      open: o.can_open,
      close: o.can_close
    });
  return t.pos += o.length, !0;
}
function Oq(t, e) {
  let n;
  const r = [], o = e.length;
  for (let i = 0; i < o; i++) {
    const s = e[i];
    if (s.marker !== 126 || s.end === -1)
      continue;
    const a = e[s.end];
    n = t.tokens[s.token], n.type = "s_open", n.tag = "s", n.nesting = 1, n.markup = "~~", n.content = "", n = t.tokens[a.token], n.type = "s_close", n.tag = "s", n.nesting = -1, n.markup = "~~", n.content = "", t.tokens[a.token - 1].type === "text" && t.tokens[a.token - 1].content === "~" && r.push(a.token - 1);
  }
  for (; r.length; ) {
    const i = r.pop();
    let s = i + 1;
    for (; s < t.tokens.length && t.tokens[s].type === "s_close"; )
      s++;
    s--, i !== s && (n = t.tokens[s], t.tokens[s] = t.tokens[i], t.tokens[i] = n);
  }
}
function JVe(t) {
  const e = t.tokens_meta, n = t.tokens_meta.length;
  Oq(t, t.delimiters);
  for (let r = 0; r < n; r++)
    e[r] && e[r].delimiters && Oq(t, e[r].delimiters);
}
const Jhe = {
  tokenize: ZVe,
  postProcess: JVe
};
function eWe(t, e) {
  const n = t.pos, r = t.src.charCodeAt(n);
  if (e || r !== 95 && r !== 42)
    return !1;
  const o = t.scanDelims(t.pos, r === 42);
  for (let i = 0; i < o.length; i++) {
    const s = t.push("text", "", 0);
    s.content = String.fromCharCode(r), t.delimiters.push({
      // Char code of the starting marker (number).
      //
      marker: r,
      // Total length of these series of delimiters.
      //
      length: o.length,
      // A position of the token this delimiter corresponds to.
      //
      token: t.tokens.length - 1,
      // If this delimiter is matched as a valid opener, `end` will be
      // equal to its position, otherwise it's `-1`.
      //
      end: -1,
      // Boolean flags that determine if this delimiter could open or close
      // an emphasis.
      //
      open: o.can_open,
      close: o.can_close
    });
  }
  return t.pos += o.length, !0;
}
function Cq(t, e) {
  const n = e.length;
  for (let r = n - 1; r >= 0; r--) {
    const o = e[r];
    if (o.marker !== 95 && o.marker !== 42 || o.end === -1)
      continue;
    const i = e[o.end], s = r > 0 && e[r - 1].end === o.end + 1 && // check that first two markers match and adjacent
    e[r - 1].marker === o.marker && e[r - 1].token === o.token - 1 && // check that last two markers are adjacent (we can safely assume they match)
    e[o.end + 1].token === i.token + 1, a = String.fromCharCode(o.marker), l = t.tokens[o.token];
    l.type = s ? "strong_open" : "em_open", l.tag = s ? "strong" : "em", l.nesting = 1, l.markup = s ? a + a : a, l.content = "";
    const c = t.tokens[i.token];
    c.type = s ? "strong_close" : "em_close", c.tag = s ? "strong" : "em", c.nesting = -1, c.markup = s ? a + a : a, c.content = "", s && (t.tokens[e[r - 1].token].content = "", t.tokens[e[o.end + 1].token].content = "", r--);
  }
}
function tWe(t) {
  const e = t.tokens_meta, n = t.tokens_meta.length;
  Cq(t, t.delimiters);
  for (let r = 0; r < n; r++)
    e[r] && e[r].delimiters && Cq(t, e[r].delimiters);
}
const epe = {
  tokenize: eWe,
  postProcess: tWe
};
function nWe(t, e) {
  let n, r, o, i, s = "", a = "", l = t.pos, c = !0;
  if (t.src.charCodeAt(t.pos) !== 91)
    return !1;
  const u = t.pos, d = t.posMax, f = t.pos + 1, h = t.md.helpers.parseLinkLabel(t, t.pos, !0);
  if (h < 0)
    return !1;
  let p = h + 1;
  if (p < d && t.src.charCodeAt(p) === 40) {
    for (c = !1, p++; p < d && (n = t.src.charCodeAt(p), !(!Un(n) && n !== 10)); p++)
      ;
    if (p >= d)
      return !1;
    if (l = p, o = t.md.helpers.parseLinkDestination(t.src, p, t.posMax), o.ok) {
      for (s = t.md.normalizeLink(o.str), t.md.validateLink(s) ? p = o.pos : s = "", l = p; p < d && (n = t.src.charCodeAt(p), !(!Un(n) && n !== 10)); p++)
        ;
      if (o = t.md.helpers.parseLinkTitle(t.src, p, t.posMax), p < d && l !== p && o.ok)
        for (a = o.str, p = o.pos; p < d && (n = t.src.charCodeAt(p), !(!Un(n) && n !== 10)); p++)
          ;
    }
    (p >= d || t.src.charCodeAt(p) !== 41) && (c = !0), p++;
  }
  if (c) {
    if (typeof t.env.references > "u")
      return !1;
    if (p < d && t.src.charCodeAt(p) === 91 ? (l = p + 1, p = t.md.helpers.parseLinkLabel(t, p), p >= 0 ? r = t.src.slice(l, p++) : p = h + 1) : p = h + 1, r || (r = t.src.slice(f, h)), i = t.env.references[qS(r)], !i)
      return t.pos = u, !1;
    s = i.href, a = i.title;
  }
  if (!e) {
    t.pos = f, t.posMax = h;
    const m = t.push("link_open", "a", 1), g = [["href", s]];
    m.attrs = g, a && g.push(["title", a]), t.linkLevel++, t.md.inline.tokenize(t), t.linkLevel--, t.push("link_close", "a", -1);
  }
  return t.pos = p, t.posMax = d, !0;
}
function rWe(t, e) {
  let n, r, o, i, s, a, l, c, u = "";
  const d = t.pos, f = t.posMax;
  if (t.src.charCodeAt(t.pos) !== 33 || t.src.charCodeAt(t.pos + 1) !== 91)
    return !1;
  const h = t.pos + 2, p = t.md.helpers.parseLinkLabel(t, t.pos + 1, !1);
  if (p < 0)
    return !1;
  if (i = p + 1, i < f && t.src.charCodeAt(i) === 40) {
    for (i++; i < f && (n = t.src.charCodeAt(i), !(!Un(n) && n !== 10)); i++)
      ;
    if (i >= f)
      return !1;
    for (c = i, a = t.md.helpers.parseLinkDestination(t.src, i, t.posMax), a.ok && (u = t.md.normalizeLink(a.str), t.md.validateLink(u) ? i = a.pos : u = ""), c = i; i < f && (n = t.src.charCodeAt(i), !(!Un(n) && n !== 10)); i++)
      ;
    if (a = t.md.helpers.parseLinkTitle(t.src, i, t.posMax), i < f && c !== i && a.ok)
      for (l = a.str, i = a.pos; i < f && (n = t.src.charCodeAt(i), !(!Un(n) && n !== 10)); i++)
        ;
    else
      l = "";
    if (i >= f || t.src.charCodeAt(i) !== 41)
      return t.pos = d, !1;
    i++;
  } else {
    if (typeof t.env.references > "u")
      return !1;
    if (i < f && t.src.charCodeAt(i) === 91 ? (c = i + 1, i = t.md.helpers.parseLinkLabel(t, i), i >= 0 ? o = t.src.slice(c, i++) : i = p + 1) : i = p + 1, o || (o = t.src.slice(h, p)), s = t.env.references[qS(o)], !s)
      return t.pos = d, !1;
    u = s.href, l = s.title;
  }
  if (!e) {
    r = t.src.slice(h, p);
    const m = [];
    t.md.inline.parse(
      r,
      t.md,
      t.env,
      m
    );
    const g = t.push("image", "img", 0), y = [["src", u], ["alt", ""]];
    g.attrs = y, g.children = m, g.content = r, l && y.push(["title", l]);
  }
  return t.pos = i, t.posMax = f, !0;
}
const oWe = /^([a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*)$/, iWe = /^([a-zA-Z][a-zA-Z0-9+.-]{1,31}):([^<>\x00-\x20]*)$/;
function sWe(t, e) {
  let n = t.pos;
  if (t.src.charCodeAt(n) !== 60)
    return !1;
  const r = t.pos, o = t.posMax;
  for (; ; ) {
    if (++n >= o) return !1;
    const s = t.src.charCodeAt(n);
    if (s === 60) return !1;
    if (s === 62) break;
  }
  const i = t.src.slice(r + 1, n);
  if (iWe.test(i)) {
    const s = t.md.normalizeLink(i);
    if (!t.md.validateLink(s))
      return !1;
    if (!e) {
      const a = t.push("link_open", "a", 1);
      a.attrs = [["href", s]], a.markup = "autolink", a.info = "auto";
      const l = t.push("text", "", 0);
      l.content = t.md.normalizeLinkText(i);
      const c = t.push("link_close", "a", -1);
      c.markup = "autolink", c.info = "auto";
    }
    return t.pos += i.length + 2, !0;
  }
  if (oWe.test(i)) {
    const s = t.md.normalizeLink("mailto:" + i);
    if (!t.md.validateLink(s))
      return !1;
    if (!e) {
      const a = t.push("link_open", "a", 1);
      a.attrs = [["href", s]], a.markup = "autolink", a.info = "auto";
      const l = t.push("text", "", 0);
      l.content = t.md.normalizeLinkText(i);
      const c = t.push("link_close", "a", -1);
      c.markup = "autolink", c.info = "auto";
    }
    return t.pos += i.length + 2, !0;
  }
  return !1;
}
function aWe(t) {
  return /^<a[>\s]/i.test(t);
}
function lWe(t) {
  return /^<\/a\s*>/i.test(t);
}
function cWe(t) {
  const e = t | 32;
  return e >= 97 && e <= 122;
}
function uWe(t, e) {
  if (!t.md.options.html)
    return !1;
  const n = t.posMax, r = t.pos;
  if (t.src.charCodeAt(r) !== 60 || r + 2 >= n)
    return !1;
  const o = t.src.charCodeAt(r + 1);
  if (o !== 33 && o !== 63 && o !== 47 && !cWe(o))
    return !1;
  const i = t.src.slice(r).match(FVe);
  if (!i)
    return !1;
  if (!e) {
    const s = t.push("html_inline", "", 0);
    s.content = i[0], aWe(s.content) && t.linkLevel++, lWe(s.content) && t.linkLevel--;
  }
  return t.pos += i[0].length, !0;
}
const dWe = /^&#((?:x[a-f0-9]{1,6}|[0-9]{1,7}));/i, fWe = /^&([a-z][a-z0-9]{1,31});/i;
function hWe(t, e) {
  const n = t.pos, r = t.posMax;
  if (t.src.charCodeAt(n) !== 38 || n + 1 >= r) return !1;
  if (t.src.charCodeAt(n + 1) === 35) {
    const o = t.src.slice(n).match(dWe);
    if (o) {
      if (!e) {
        const i = o[1][0].toLowerCase() === "x" ? parseInt(o[1].slice(1), 16) : parseInt(o[1], 10), s = t.push("text_special", "", 0);
        s.content = FL(i) ? Hx(i) : Hx(65533), s.markup = o[0], s.info = "entity";
      }
      return t.pos += o[0].length, !0;
    }
  } else {
    const o = t.src.slice(n).match(fWe);
    if (o) {
      const i = Whe(o[0]);
      if (i !== o[0]) {
        if (!e) {
          const s = t.push("text_special", "", 0);
          s.content = i, s.markup = o[0], s.info = "entity";
        }
        return t.pos += o[0].length, !0;
      }
    }
  }
  return !1;
}
function kq(t) {
  const e = {}, n = t.length;
  if (!n) return;
  let r = 0, o = -2;
  const i = [];
  for (let s = 0; s < n; s++) {
    const a = t[s];
    if (i.push(0), (t[r].marker !== a.marker || o !== a.token - 1) && (r = s), o = a.token, a.length = a.length || 0, !a.close) continue;
    e.hasOwnProperty(a.marker) || (e[a.marker] = [-1, -1, -1, -1, -1, -1]);
    const l = e[a.marker][(a.open ? 3 : 0) + a.length % 3];
    let c = r - i[r] - 1, u = c;
    for (; c > l; c -= i[c] + 1) {
      const d = t[c];
      if (d.marker === a.marker && d.open && d.end < 0) {
        let f = !1;
        if ((d.close || a.open) && (d.length + a.length) % 3 === 0 && (d.length % 3 !== 0 || a.length % 3 !== 0) && (f = !0), !f) {
          const h = c > 0 && !t[c - 1].open ? i[c - 1] + 1 : 0;
          i[s] = s - c + h, i[c] = h, a.open = !1, d.end = s, d.close = !1, u = -1, o = -2;
          break;
        }
      }
    }
    u !== -1 && (e[a.marker][(a.open ? 3 : 0) + (a.length || 0) % 3] = u);
  }
}
function pWe(t) {
  const e = t.tokens_meta, n = t.tokens_meta.length;
  kq(t.delimiters);
  for (let r = 0; r < n; r++)
    e[r] && e[r].delimiters && kq(e[r].delimiters);
}
function mWe(t) {
  let e, n, r = 0;
  const o = t.tokens, i = t.tokens.length;
  for (e = n = 0; e < i; e++)
    o[e].nesting < 0 && r--, o[e].level = r, o[e].nesting > 0 && r++, o[e].type === "text" && e + 1 < i && o[e + 1].type === "text" ? o[e + 1].content = o[e].content + o[e + 1].content : (e !== n && (o[n] = o[e]), n++);
  e !== n && (o.length = n);
}
const Rk = [
  ["text", WVe],
  ["linkify", YVe],
  ["newline", KVe],
  ["escape", XVe],
  ["backticks", QVe],
  ["strikethrough", Jhe.tokenize],
  ["emphasis", epe.tokenize],
  ["link", nWe],
  ["image", rWe],
  ["autolink", sWe],
  ["html_inline", uWe],
  ["entity", hWe]
], Pk = [
  ["balance_pairs", pWe],
  ["strikethrough", Jhe.postProcess],
  ["emphasis", epe.postProcess],
  // rules for pairs separate '**' into its own text tokens, which may be left unused,
  // rule below merges unused segments back with the rest of the text
  ["fragments_join", mWe]
];
function _v() {
  this.ruler = new ei();
  for (let t = 0; t < Rk.length; t++)
    this.ruler.push(Rk[t][0], Rk[t][1]);
  this.ruler2 = new ei();
  for (let t = 0; t < Pk.length; t++)
    this.ruler2.push(Pk[t][0], Pk[t][1]);
}
_v.prototype.skipToken = function(t) {
  const e = t.pos, n = this.ruler.getRules(""), r = n.length, o = t.md.options.maxNesting, i = t.cache;
  if (typeof i[e] < "u") {
    t.pos = i[e];
    return;
  }
  let s = !1;
  if (t.level < o) {
    for (let a = 0; a < r; a++)
      if (t.level++, s = n[a](t, !0), t.level--, s) {
        if (e >= t.pos)
          throw new Error("inline rule didn't increment state.pos");
        break;
      }
  } else
    t.pos = t.posMax;
  s || t.pos++, i[e] = t.pos;
};
_v.prototype.tokenize = function(t) {
  const e = this.ruler.getRules(""), n = e.length, r = t.posMax, o = t.md.options.maxNesting;
  for (; t.pos < r; ) {
    const i = t.pos;
    let s = !1;
    if (t.level < o) {
      for (let a = 0; a < n; a++)
        if (s = e[a](t, !1), s) {
          if (i >= t.pos)
            throw new Error("inline rule didn't increment state.pos");
          break;
        }
    }
    if (s) {
      if (t.pos >= r)
        break;
      continue;
    }
    t.pending += t.src[t.pos++];
  }
  t.pending && t.pushPending();
};
_v.prototype.parse = function(t, e, n, r) {
  const o = new this.State(t, e, n, r);
  this.tokenize(o);
  const i = this.ruler2.getRules(""), s = i.length;
  for (let a = 0; a < s; a++)
    i[a](o);
};
_v.prototype.State = bv;
function gWe(t) {
  const e = {};
  t = t || {}, e.src_Any = zhe.source, e.src_Cc = qhe.source, e.src_Z = Hhe.source, e.src_P = jL.source, e.src_ZPCc = [e.src_Z, e.src_P, e.src_Cc].join("|"), e.src_ZCc = [e.src_Z, e.src_Cc].join("|");
  const n = "[><｜]";
  return e.src_pseudo_letter = "(?:(?!" + n + "|" + e.src_ZPCc + ")" + e.src_Any + ")", e.src_ip4 = "(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)", e.src_auth = "(?:(?:(?!" + e.src_ZCc + "|[@/\\[\\]()]).)+@)?", e.src_port = "(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?", e.src_host_terminator = "(?=$|" + n + "|" + e.src_ZPCc + ")(?!" + (t["---"] ? "-(?!--)|" : "-|") + "_|:\\d|\\.-|\\.(?!$|" + e.src_ZPCc + "))", e.src_path = "(?:[/?#](?:(?!" + e.src_ZCc + "|" + n + `|[()[\\]{}.,"'?!\\-;]).|\\[(?:(?!` + e.src_ZCc + "|\\]).)*\\]|\\((?:(?!" + e.src_ZCc + "|[)]).)*\\)|\\{(?:(?!" + e.src_ZCc + '|[}]).)*\\}|\\"(?:(?!' + e.src_ZCc + `|["]).)+\\"|\\'(?:(?!` + e.src_ZCc + "|[']).)+\\'|\\'(?=" + e.src_pseudo_letter + "|[-])|\\.{2,}[a-zA-Z0-9%/&]|\\.(?!" + e.src_ZCc + "|[.]|$)|" + (t["---"] ? "\\-(?!--(?:[^-]|$))(?:-*)|" : "\\-+|") + // allow `,,,` in paths
  ",(?!" + e.src_ZCc + "|$)|;(?!" + e.src_ZCc + "|$)|\\!+(?!" + e.src_ZCc + "|[!]|$)|\\?(?!" + e.src_ZCc + "|[?]|$))+|\\/)?", e.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*', e.src_xn = "xn--[a-z0-9\\-]{1,59}", e.src_domain_root = // Allow letters & digits (http://test1)
  "(?:" + e.src_xn + "|" + e.src_pseudo_letter + "{1,63})", e.src_domain = "(?:" + e.src_xn + "|(?:" + e.src_pseudo_letter + ")|(?:" + e.src_pseudo_letter + "(?:-|" + e.src_pseudo_letter + "){0,61}" + e.src_pseudo_letter + "))", e.src_host = "(?:(?:(?:(?:" + e.src_domain + ")\\.)*" + e.src_domain + "))", e.tpl_host_fuzzy = "(?:" + e.src_ip4 + "|(?:(?:(?:" + e.src_domain + ")\\.)+(?:%TLDS%)))", e.tpl_host_no_ip_fuzzy = "(?:(?:(?:" + e.src_domain + ")\\.)+(?:%TLDS%))", e.src_host_strict = e.src_host + e.src_host_terminator, e.tpl_host_fuzzy_strict = e.tpl_host_fuzzy + e.src_host_terminator, e.src_host_port_strict = e.src_host + e.src_port + e.src_host_terminator, e.tpl_host_port_fuzzy_strict = e.tpl_host_fuzzy + e.src_port + e.src_host_terminator, e.tpl_host_port_no_ip_fuzzy_strict = e.tpl_host_no_ip_fuzzy + e.src_port + e.src_host_terminator, e.tpl_host_fuzzy_test = "localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:" + e.src_ZPCc + "|>|$))", e.tpl_email_fuzzy = "(^|" + n + '|"|\\(|' + e.src_ZCc + ")(" + e.src_email_name + "@" + e.tpl_host_fuzzy_strict + ")", e.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
  // but can start with > (markdown blockquote)
  "(^|(?![.:/\\-_@])(?:[$+<=>^`|｜]|" + e.src_ZPCc + "))((?![$+<=>^`|｜])" + e.tpl_host_port_fuzzy_strict + e.src_path + ")", e.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
  // but can start with > (markdown blockquote)
  "(^|(?![.:/\\-_@])(?:[$+<=>^`|｜]|" + e.src_ZPCc + "))((?![$+<=>^`|｜])" + e.tpl_host_port_no_ip_fuzzy_strict + e.src_path + ")", e;
}
function HN(t) {
  return Array.prototype.slice.call(arguments, 1).forEach(function(e) {
    e && Object.keys(e).forEach(function(n) {
      t[n] = e[n];
    });
  }), t;
}
function HS(t) {
  return Object.prototype.toString.call(t);
}
function yWe(t) {
  return HS(t) === "[object String]";
}
function vWe(t) {
  return HS(t) === "[object Object]";
}
function bWe(t) {
  return HS(t) === "[object RegExp]";
}
function Aq(t) {
  return HS(t) === "[object Function]";
}
function _We(t) {
  return t.replace(/[.?*+^$[\]\\(){}|-]/g, "\\$&");
}
const tpe = {
  fuzzyLink: !0,
  fuzzyEmail: !0,
  fuzzyIP: !1
};
function wWe(t) {
  return Object.keys(t || {}).reduce(function(e, n) {
    return e || tpe.hasOwnProperty(n);
  }, !1);
}
const xWe = {
  "http:": {
    validate: function(t, e, n) {
      const r = t.slice(e);
      return n.re.http || (n.re.http = new RegExp(
        "^\\/\\/" + n.re.src_auth + n.re.src_host_port_strict + n.re.src_path,
        "i"
      )), n.re.http.test(r) ? r.match(n.re.http)[0].length : 0;
    }
  },
  "https:": "http:",
  "ftp:": "http:",
  "//": {
    validate: function(t, e, n) {
      const r = t.slice(e);
      return n.re.no_http || (n.re.no_http = new RegExp(
        "^" + n.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
        // with code comments
        "(?:localhost|(?:(?:" + n.re.src_domain + ")\\.)+" + n.re.src_domain_root + ")" + n.re.src_port + n.re.src_host_terminator + n.re.src_path,
        "i"
      )), n.re.no_http.test(r) ? e >= 3 && t[e - 3] === ":" || e >= 3 && t[e - 3] === "/" ? 0 : r.match(n.re.no_http)[0].length : 0;
    }
  },
  "mailto:": {
    validate: function(t, e, n) {
      const r = t.slice(e);
      return n.re.mailto || (n.re.mailto = new RegExp(
        "^" + n.re.src_email_name + "@" + n.re.src_host_strict,
        "i"
      )), n.re.mailto.test(r) ? r.match(n.re.mailto)[0].length : 0;
    }
  }
}, EWe = "a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]", SWe = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф".split("|");
function OWe(t) {
  t.__index__ = -1, t.__text_cache__ = "";
}
function CWe(t) {
  return function(e, n) {
    const r = e.slice(n);
    return t.test(r) ? r.match(t)[0].length : 0;
  };
}
function Tq() {
  return function(t, e) {
    e.normalize(t);
  };
}
function Vx(t) {
  const e = t.re = gWe(t.__opts__), n = t.__tlds__.slice();
  t.onCompile(), t.__tlds_replaced__ || n.push(EWe), n.push(e.src_xn), e.src_tlds = n.join("|");
  function r(a) {
    return a.replace("%TLDS%", e.src_tlds);
  }
  e.email_fuzzy = RegExp(r(e.tpl_email_fuzzy), "i"), e.link_fuzzy = RegExp(r(e.tpl_link_fuzzy), "i"), e.link_no_ip_fuzzy = RegExp(r(e.tpl_link_no_ip_fuzzy), "i"), e.host_fuzzy_test = RegExp(r(e.tpl_host_fuzzy_test), "i");
  const o = [];
  t.__compiled__ = {};
  function i(a, l) {
    throw new Error('(LinkifyIt) Invalid schema "' + a + '": ' + l);
  }
  Object.keys(t.__schemas__).forEach(function(a) {
    const l = t.__schemas__[a];
    if (l === null)
      return;
    const c = { validate: null, link: null };
    if (t.__compiled__[a] = c, vWe(l)) {
      bWe(l.validate) ? c.validate = CWe(l.validate) : Aq(l.validate) ? c.validate = l.validate : i(a, l), Aq(l.normalize) ? c.normalize = l.normalize : l.normalize ? i(a, l) : c.normalize = Tq();
      return;
    }
    if (yWe(l)) {
      o.push(a);
      return;
    }
    i(a, l);
  }), o.forEach(function(a) {
    t.__compiled__[t.__schemas__[a]] && (t.__compiled__[a].validate = t.__compiled__[t.__schemas__[a]].validate, t.__compiled__[a].normalize = t.__compiled__[t.__schemas__[a]].normalize);
  }), t.__compiled__[""] = { validate: null, normalize: Tq() };
  const s = Object.keys(t.__compiled__).filter(function(a) {
    return a.length > 0 && t.__compiled__[a];
  }).map(_We).join("|");
  t.re.schema_test = RegExp("(^|(?!_)(?:[><｜]|" + e.src_ZPCc + "))(" + s + ")", "i"), t.re.schema_search = RegExp("(^|(?!_)(?:[><｜]|" + e.src_ZPCc + "))(" + s + ")", "ig"), t.re.schema_at_start = RegExp("^" + t.re.schema_search.source, "i"), t.re.pretest = RegExp(
    "(" + t.re.schema_test.source + ")|(" + t.re.host_fuzzy_test.source + ")|@",
    "i"
  ), OWe(t);
}
function kWe(t, e) {
  const n = t.__index__, r = t.__last_index__, o = t.__text_cache__.slice(n, r);
  this.schema = t.__schema__.toLowerCase(), this.index = n + e, this.lastIndex = r + e, this.raw = o, this.text = o, this.url = o;
}
function VN(t, e) {
  const n = new kWe(t, e);
  return t.__compiled__[n.schema].normalize(n, t), n;
}
function Ci(t, e) {
  if (!(this instanceof Ci))
    return new Ci(t, e);
  e || wWe(t) && (e = t, t = {}), this.__opts__ = HN({}, tpe, e), this.__index__ = -1, this.__last_index__ = -1, this.__schema__ = "", this.__text_cache__ = "", this.__schemas__ = HN({}, xWe, t), this.__compiled__ = {}, this.__tlds__ = SWe, this.__tlds_replaced__ = !1, this.re = {}, Vx(this);
}
Ci.prototype.add = function(t, e) {
  return this.__schemas__[t] = e, Vx(this), this;
};
Ci.prototype.set = function(t) {
  return this.__opts__ = HN(this.__opts__, t), this;
};
Ci.prototype.test = function(t) {
  if (this.__text_cache__ = t, this.__index__ = -1, !t.length)
    return !1;
  let e, n, r, o, i, s, a, l, c;
  if (this.re.schema_test.test(t)) {
    for (a = this.re.schema_search, a.lastIndex = 0; (e = a.exec(t)) !== null; )
      if (o = this.testSchemaAt(t, e[2], a.lastIndex), o) {
        this.__schema__ = e[2], this.__index__ = e.index + e[1].length, this.__last_index__ = e.index + e[0].length + o;
        break;
      }
  }
  return this.__opts__.fuzzyLink && this.__compiled__["http:"] && (l = t.search(this.re.host_fuzzy_test), l >= 0 && (this.__index__ < 0 || l < this.__index__) && (n = t.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null && (i = n.index + n[1].length, (this.__index__ < 0 || i < this.__index__) && (this.__schema__ = "", this.__index__ = i, this.__last_index__ = n.index + n[0].length))), this.__opts__.fuzzyEmail && this.__compiled__["mailto:"] && (c = t.indexOf("@"), c >= 0 && (r = t.match(this.re.email_fuzzy)) !== null && (i = r.index + r[1].length, s = r.index + r[0].length, (this.__index__ < 0 || i < this.__index__ || i === this.__index__ && s > this.__last_index__) && (this.__schema__ = "mailto:", this.__index__ = i, this.__last_index__ = s))), this.__index__ >= 0;
};
Ci.prototype.pretest = function(t) {
  return this.re.pretest.test(t);
};
Ci.prototype.testSchemaAt = function(t, e, n) {
  return this.__compiled__[e.toLowerCase()] ? this.__compiled__[e.toLowerCase()].validate(t, n, this) : 0;
};
Ci.prototype.match = function(t) {
  const e = [];
  let n = 0;
  this.__index__ >= 0 && this.__text_cache__ === t && (e.push(VN(this, n)), n = this.__last_index__);
  let r = n ? t.slice(n) : t;
  for (; this.test(r); )
    e.push(VN(this, n)), r = r.slice(this.__last_index__), n += this.__last_index__;
  return e.length ? e : null;
};
Ci.prototype.matchAtStart = function(t) {
  if (this.__text_cache__ = t, this.__index__ = -1, !t.length) return null;
  const e = this.re.schema_at_start.exec(t);
  if (!e) return null;
  const n = this.testSchemaAt(t, e[2], e[0].length);
  return n ? (this.__schema__ = e[2], this.__index__ = e.index + e[1].length, this.__last_index__ = e.index + e[0].length + n, VN(this, 0)) : null;
};
Ci.prototype.tlds = function(t, e) {
  return t = Array.isArray(t) ? t : [t], e ? (this.__tlds__ = this.__tlds__.concat(t).sort().filter(function(n, r, o) {
    return n !== o[r - 1];
  }).reverse(), Vx(this), this) : (this.__tlds__ = t.slice(), this.__tlds_replaced__ = !0, Vx(this), this);
};
Ci.prototype.normalize = function(t) {
  t.schema || (t.url = "http://" + t.url), t.schema === "mailto:" && !/^mailto:/i.test(t.url) && (t.url = "mailto:" + t.url);
};
Ci.prototype.onCompile = function() {
};
const wh = 2147483647, da = 36, qL = 1, uy = 26, AWe = 38, TWe = 700, npe = 72, rpe = 128, ope = "-", RWe = /^xn--/, PWe = /[^\0-\x7F]/, $We = /[\x2E\u3002\uFF0E\uFF61]/g, MWe = {
  overflow: "Overflow: input needs wider integers to process",
  "not-basic": "Illegal input >= 0x80 (not a basic code point)",
  "invalid-input": "Invalid input"
}, $k = da - qL, fa = Math.floor, Mk = String.fromCharCode;
function _c(t) {
  throw new RangeError(MWe[t]);
}
function DWe(t, e) {
  const n = [];
  let r = t.length;
  for (; r--; )
    n[r] = e(t[r]);
  return n;
}
function ipe(t, e) {
  const n = t.split("@");
  let r = "";
  n.length > 1 && (r = n[0] + "@", t = n[1]), t = t.replace($We, ".");
  const o = t.split("."), i = DWe(o, e).join(".");
  return r + i;
}
function spe(t) {
  const e = [];
  let n = 0;
  const r = t.length;
  for (; n < r; ) {
    const o = t.charCodeAt(n++);
    if (o >= 55296 && o <= 56319 && n < r) {
      const i = t.charCodeAt(n++);
      (i & 64512) == 56320 ? e.push(((o & 1023) << 10) + (i & 1023) + 65536) : (e.push(o), n--);
    } else
      e.push(o);
  }
  return e;
}
const IWe = (t) => String.fromCodePoint(...t), NWe = function(t) {
  return t >= 48 && t < 58 ? 26 + (t - 48) : t >= 65 && t < 91 ? t - 65 : t >= 97 && t < 123 ? t - 97 : da;
}, Rq = function(t, e) {
  return t + 22 + 75 * (t < 26) - ((e != 0) << 5);
}, ape = function(t, e, n) {
  let r = 0;
  for (t = n ? fa(t / TWe) : t >> 1, t += fa(t / e); t > $k * uy >> 1; r += da)
    t = fa(t / $k);
  return fa(r + ($k + 1) * t / (t + AWe));
}, lpe = function(t) {
  const e = [], n = t.length;
  let r = 0, o = rpe, i = npe, s = t.lastIndexOf(ope);
  s < 0 && (s = 0);
  for (let a = 0; a < s; ++a)
    t.charCodeAt(a) >= 128 && _c("not-basic"), e.push(t.charCodeAt(a));
  for (let a = s > 0 ? s + 1 : 0; a < n; ) {
    const l = r;
    for (let u = 1, d = da; ; d += da) {
      a >= n && _c("invalid-input");
      const f = NWe(t.charCodeAt(a++));
      f >= da && _c("invalid-input"), f > fa((wh - r) / u) && _c("overflow"), r += f * u;
      const h = d <= i ? qL : d >= i + uy ? uy : d - i;
      if (f < h)
        break;
      const p = da - h;
      u > fa(wh / p) && _c("overflow"), u *= p;
    }
    const c = e.length + 1;
    i = ape(r - l, c, l == 0), fa(r / c) > wh - o && _c("overflow"), o += fa(r / c), r %= c, e.splice(r++, 0, o);
  }
  return String.fromCodePoint(...e);
}, cpe = function(t) {
  const e = [];
  t = spe(t);
  const n = t.length;
  let r = rpe, o = 0, i = npe;
  for (const l of t)
    l < 128 && e.push(Mk(l));
  const s = e.length;
  let a = s;
  for (s && e.push(ope); a < n; ) {
    let l = wh;
    for (const u of t)
      u >= r && u < l && (l = u);
    const c = a + 1;
    l - r > fa((wh - o) / c) && _c("overflow"), o += (l - r) * c, r = l;
    for (const u of t)
      if (u < r && ++o > wh && _c("overflow"), u === r) {
        let d = o;
        for (let f = da; ; f += da) {
          const h = f <= i ? qL : f >= i + uy ? uy : f - i;
          if (d < h)
            break;
          const p = d - h, m = da - h;
          e.push(
            Mk(Rq(h + p % m, 0))
          ), d = fa(p / m);
        }
        e.push(Mk(Rq(d, 0))), i = ape(o, c, a === s), o = 0, ++a;
      }
    ++o, ++r;
  }
  return e.join("");
}, jWe = function(t) {
  return ipe(t, function(e) {
    return RWe.test(e) ? lpe(e.slice(4).toLowerCase()) : e;
  });
}, LWe = function(t) {
  return ipe(t, function(e) {
    return PWe.test(e) ? "xn--" + cpe(e) : e;
  });
}, upe = {
  /**
   * A string representing the current Punycode.js version number.
   * @memberOf punycode
   * @type String
   */
  version: "2.3.1",
  /**
   * An object of methods to convert from JavaScript's internal character
   * representation (UCS-2) to Unicode code points, and back.
   * @see <https://mathiasbynens.be/notes/javascript-encoding>
   * @memberOf punycode
   * @type Object
   */
  ucs2: {
    decode: spe,
    encode: IWe
  },
  decode: lpe,
  encode: cpe,
  toASCII: LWe,
  toUnicode: jWe
}, FWe = {
  options: {
    // Enable HTML tags in source
    html: !1,
    // Use '/' to close single tags (<br />)
    xhtmlOut: !1,
    // Convert '\n' in paragraphs into <br>
    breaks: !1,
    // CSS language prefix for fenced blocks
    langPrefix: "language-",
    // autoconvert URL-like texts to links
    linkify: !1,
    // Enable some language-neutral replacements + quotes beautification
    typographer: !1,
    // Double + single quotes replacement pairs, when typographer enabled,
    // and smartquotes on. Could be either a String or an Array.
    //
    // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
    // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
    quotes: "“”‘’",
    /* “”‘’ */
    // Highlighter function. Should return escaped HTML,
    // or '' if the source string is not changed and should be escaped externaly.
    // If result starts with <pre... internal wrapper is skipped.
    //
    // function (/*str, lang*/) { return ''; }
    //
    highlight: null,
    // Internal protection, recursion limit
    maxNesting: 100
  },
  components: {
    core: {},
    block: {},
    inline: {}
  }
}, BWe = {
  options: {
    // Enable HTML tags in source
    html: !1,
    // Use '/' to close single tags (<br />)
    xhtmlOut: !1,
    // Convert '\n' in paragraphs into <br>
    breaks: !1,
    // CSS language prefix for fenced blocks
    langPrefix: "language-",
    // autoconvert URL-like texts to links
    linkify: !1,
    // Enable some language-neutral replacements + quotes beautification
    typographer: !1,
    // Double + single quotes replacement pairs, when typographer enabled,
    // and smartquotes on. Could be either a String or an Array.
    //
    // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
    // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
    quotes: "“”‘’",
    /* “”‘’ */
    // Highlighter function. Should return escaped HTML,
    // or '' if the source string is not changed and should be escaped externaly.
    // If result starts with <pre... internal wrapper is skipped.
    //
    // function (/*str, lang*/) { return ''; }
    //
    highlight: null,
    // Internal protection, recursion limit
    maxNesting: 20
  },
  components: {
    core: {
      rules: [
        "normalize",
        "block",
        "inline",
        "text_join"
      ]
    },
    block: {
      rules: [
        "paragraph"
      ]
    },
    inline: {
      rules: [
        "text"
      ],
      rules2: [
        "balance_pairs",
        "fragments_join"
      ]
    }
  }
}, zWe = {
  options: {
    // Enable HTML tags in source
    html: !0,
    // Use '/' to close single tags (<br />)
    xhtmlOut: !0,
    // Convert '\n' in paragraphs into <br>
    breaks: !1,
    // CSS language prefix for fenced blocks
    langPrefix: "language-",
    // autoconvert URL-like texts to links
    linkify: !1,
    // Enable some language-neutral replacements + quotes beautification
    typographer: !1,
    // Double + single quotes replacement pairs, when typographer enabled,
    // and smartquotes on. Could be either a String or an Array.
    //
    // For example, you can use '«»„“' for Russian, '„“‚‘' for German,
    // and ['«\xA0', '\xA0»', '‹\xA0', '\xA0›'] for French (including nbsp).
    quotes: "“”‘’",
    /* “”‘’ */
    // Highlighter function. Should return escaped HTML,
    // or '' if the source string is not changed and should be escaped externaly.
    // If result starts with <pre... internal wrapper is skipped.
    //
    // function (/*str, lang*/) { return ''; }
    //
    highlight: null,
    // Internal protection, recursion limit
    maxNesting: 20
  },
  components: {
    core: {
      rules: [
        "normalize",
        "block",
        "inline",
        "text_join"
      ]
    },
    block: {
      rules: [
        "blockquote",
        "code",
        "fence",
        "heading",
        "hr",
        "html_block",
        "lheading",
        "list",
        "reference",
        "paragraph"
      ]
    },
    inline: {
      rules: [
        "autolink",
        "backticks",
        "emphasis",
        "entity",
        "escape",
        "html_inline",
        "image",
        "link",
        "newline",
        "text"
      ],
      rules2: [
        "balance_pairs",
        "emphasis",
        "fragments_join"
      ]
    }
  }
}, qWe = {
  default: FWe,
  zero: BWe,
  commonmark: zWe
}, UWe = /^(vbscript|javascript|file|data):/, HWe = /^data:image\/(gif|png|jpeg|webp);/;
function VWe(t) {
  const e = t.trim().toLowerCase();
  return UWe.test(e) ? HWe.test(e) : !0;
}
const dpe = ["http:", "https:", "mailto:"];
function WWe(t) {
  const e = NL(t, !0);
  if (e.hostname && (!e.protocol || dpe.indexOf(e.protocol) >= 0))
    try {
      e.hostname = upe.toASCII(e.hostname);
    } catch {
    }
  return vv(IL(e));
}
function GWe(t) {
  const e = NL(t, !0);
  if (e.hostname && (!e.protocol || dpe.indexOf(e.protocol) >= 0))
    try {
      e.hostname = upe.toUnicode(e.hostname);
    } catch {
    }
  return np(IL(e), np.defaultChars + "%");
}
function ts(t, e) {
  if (!(this instanceof ts))
    return new ts(t, e);
  e || LL(t) || (e = t || {}, t = "default"), this.inline = new _v(), this.block = new US(), this.core = new BL(), this.renderer = new Ap(), this.linkify = new Ci(), this.validateLink = VWe, this.normalizeLink = WWe, this.normalizeLinkText = GWe, this.utils = KHe, this.helpers = zS({}, JHe), this.options = {}, this.configure(t), e && this.set(e);
}
ts.prototype.set = function(t) {
  return zS(this.options, t), this;
};
ts.prototype.configure = function(t) {
  const e = this;
  if (LL(t)) {
    const n = t;
    if (t = qWe[n], !t)
      throw new Error('Wrong `markdown-it` preset "' + n + '", check name');
  }
  if (!t)
    throw new Error("Wrong `markdown-it` preset, can't be empty");
  return t.options && e.set(t.options), t.components && Object.keys(t.components).forEach(function(n) {
    t.components[n].rules && e[n].ruler.enableOnly(t.components[n].rules), t.components[n].rules2 && e[n].ruler2.enableOnly(t.components[n].rules2);
  }), this;
};
ts.prototype.enable = function(t, e) {
  let n = [];
  Array.isArray(t) || (t = [t]), ["core", "block", "inline"].forEach(function(o) {
    n = n.concat(this[o].ruler.enable(t, !0));
  }, this), n = n.concat(this.inline.ruler2.enable(t, !0));
  const r = t.filter(function(o) {
    return n.indexOf(o) < 0;
  });
  if (r.length && !e)
    throw new Error("MarkdownIt. Failed to enable unknown rule(s): " + r);
  return this;
};
ts.prototype.disable = function(t, e) {
  let n = [];
  Array.isArray(t) || (t = [t]), ["core", "block", "inline"].forEach(function(o) {
    n = n.concat(this[o].ruler.disable(t, !0));
  }, this), n = n.concat(this.inline.ruler2.disable(t, !0));
  const r = t.filter(function(o) {
    return n.indexOf(o) < 0;
  });
  if (r.length && !e)
    throw new Error("MarkdownIt. Failed to disable unknown rule(s): " + r);
  return this;
};
ts.prototype.use = function(t) {
  const e = [this].concat(Array.prototype.slice.call(arguments, 1));
  return t.apply(t, e), this;
};
ts.prototype.parse = function(t, e) {
  if (typeof t != "string")
    throw new Error("Input data should be a String");
  const n = new this.core.State(t, this, e);
  return this.core.process(n), n.tokens;
};
ts.prototype.render = function(t, e) {
  return e = e || {}, this.renderer.render(this.parse(t, e), this.options, e);
};
ts.prototype.parseInline = function(t, e) {
  const n = new this.core.State(t, this, e);
  return n.inlineMode = !0, this.core.process(n), n.tokens;
};
ts.prototype.renderInline = function(t, e) {
  return e = e || {}, this.renderer.render(this.parseInline(t, e), this.options, e);
};
function YWe(t, e, n) {
  const {
    parseMetaString: r,
    trimEndingNewline: o = !0,
    defaultLanguage: i = "text",
    fallbackLanguage: s
  } = n, a = e.getLoadedLanguages();
  t.options.highlight = (l, c = "text", u) => {
    c === "" && (c = i), s && !a.includes(c) && (c = s);
    const d = r?.(u, l, c) || {}, f = {
      ...n,
      lang: c,
      meta: {
        ...n.meta,
        ...d,
        __raw: u
      }
    }, h = [];
    return h.push({
      name: "@shikijs/markdown-it:block-class",
      code(p) {
        p.properties.class = `language-${c}`;
      }
    }), o && l.endsWith(`
`) && (l = l.slice(0, -1)), e.codeToHtml(
      l,
      {
        ...f,
        transformers: [
          ...h,
          ...f.transformers || []
        ]
      }
    );
  };
}
function KWe(t, e) {
  return function(n) {
    YWe(n, t, e);
  };
}
let bd = class extends Error {
  constructor(t) {
    super(t), this.name = "ShikiError";
  }
}, UL = class extends Error {
  constructor(t) {
    super(t), this.name = "ShikiError";
  }
};
function XWe() {
  return 2147483648;
}
function QWe() {
  return typeof performance < "u" ? performance.now() : Date.now();
}
const ZWe = (t, e) => t + (e - t % e) % e;
async function JWe(t) {
  let e, n;
  const r = {};
  function o(h) {
    n = h, r.HEAPU8 = new Uint8Array(h), r.HEAPU32 = new Uint32Array(h);
  }
  function i(h, p, m) {
    r.HEAPU8.copyWithin(h, p, p + m);
  }
  function s(h) {
    try {
      return e.grow(h - n.byteLength + 65535 >>> 16), o(e.buffer), 1;
    } catch {
    }
  }
  function a(h) {
    const p = r.HEAPU8.length;
    h = h >>> 0;
    const m = XWe();
    if (h > m)
      return !1;
    for (let g = 1; g <= 4; g *= 2) {
      let y = p * (1 + 0.2 / g);
      y = Math.min(y, h + 100663296);
      const v = Math.min(m, ZWe(Math.max(h, y), 65536));
      if (s(v))
        return !0;
    }
    return !1;
  }
  const l = typeof TextDecoder < "u" ? new TextDecoder("utf8") : void 0;
  function c(h, p, m = 1024) {
    const g = p + m;
    let y = p;
    for (; h[y] && !(y >= g); )
      ++y;
    if (y - p > 16 && h.buffer && l)
      return l.decode(h.subarray(p, y));
    let v = "";
    for (; p < y; ) {
      let b = h[p++];
      if (!(b & 128)) {
        v += String.fromCharCode(b);
        continue;
      }
      const _ = h[p++] & 63;
      if ((b & 224) === 192) {
        v += String.fromCharCode((b & 31) << 6 | _);
        continue;
      }
      const w = h[p++] & 63;
      if ((b & 240) === 224 ? b = (b & 15) << 12 | _ << 6 | w : b = (b & 7) << 18 | _ << 12 | w << 6 | h[p++] & 63, b < 65536)
        v += String.fromCharCode(b);
      else {
        const x = b - 65536;
        v += String.fromCharCode(55296 | x >> 10, 56320 | x & 1023);
      }
    }
    return v;
  }
  function u(h, p) {
    return h ? c(r.HEAPU8, h, p) : "";
  }
  const d = {
    emscripten_get_now: QWe,
    emscripten_memcpy_big: i,
    emscripten_resize_heap: a,
    fd_write: () => 0
  };
  async function f() {
    const h = await t({
      env: d,
      wasi_snapshot_preview1: d
    });
    e = h.memory, o(e.buffer), Object.assign(r, h), r.UTF8ToString = u;
  }
  return await f(), r;
}
var eGe = Object.defineProperty, tGe = (t, e, n) => e in t ? eGe(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n, $r = (t, e, n) => (tGe(t, typeof e != "symbol" ? e + "" : e, n), n);
let qr = null;
function nGe(t) {
  throw new UL(t.UTF8ToString(t.getLastOnigError()));
}
class VS {
  constructor(e) {
    $r(this, "utf16Length"), $r(this, "utf8Length"), $r(this, "utf16Value"), $r(this, "utf8Value"), $r(this, "utf16OffsetToUtf8"), $r(this, "utf8OffsetToUtf16");
    const n = e.length, r = VS._utf8ByteLength(e), o = r !== n, i = o ? new Uint32Array(n + 1) : null;
    o && (i[n] = r);
    const s = o ? new Uint32Array(r + 1) : null;
    o && (s[r] = n);
    const a = new Uint8Array(r);
    let l = 0;
    for (let c = 0; c < n; c++) {
      const u = e.charCodeAt(c);
      let d = u, f = !1;
      if (u >= 55296 && u <= 56319 && c + 1 < n) {
        const h = e.charCodeAt(c + 1);
        h >= 56320 && h <= 57343 && (d = (u - 55296 << 10) + 65536 | h - 56320, f = !0);
      }
      o && (i[c] = l, f && (i[c + 1] = l), d <= 127 ? s[l + 0] = c : d <= 2047 ? (s[l + 0] = c, s[l + 1] = c) : d <= 65535 ? (s[l + 0] = c, s[l + 1] = c, s[l + 2] = c) : (s[l + 0] = c, s[l + 1] = c, s[l + 2] = c, s[l + 3] = c)), d <= 127 ? a[l++] = d : d <= 2047 ? (a[l++] = 192 | (d & 1984) >>> 6, a[l++] = 128 | (d & 63) >>> 0) : d <= 65535 ? (a[l++] = 224 | (d & 61440) >>> 12, a[l++] = 128 | (d & 4032) >>> 6, a[l++] = 128 | (d & 63) >>> 0) : (a[l++] = 240 | (d & 1835008) >>> 18, a[l++] = 128 | (d & 258048) >>> 12, a[l++] = 128 | (d & 4032) >>> 6, a[l++] = 128 | (d & 63) >>> 0), f && c++;
    }
    this.utf16Length = n, this.utf8Length = r, this.utf16Value = e, this.utf8Value = a, this.utf16OffsetToUtf8 = i, this.utf8OffsetToUtf16 = s;
  }
  static _utf8ByteLength(e) {
    let n = 0;
    for (let r = 0, o = e.length; r < o; r++) {
      const i = e.charCodeAt(r);
      let s = i, a = !1;
      if (i >= 55296 && i <= 56319 && r + 1 < o) {
        const l = e.charCodeAt(r + 1);
        l >= 56320 && l <= 57343 && (s = (i - 55296 << 10) + 65536 | l - 56320, a = !0);
      }
      s <= 127 ? n += 1 : s <= 2047 ? n += 2 : s <= 65535 ? n += 3 : n += 4, a && r++;
    }
    return n;
  }
  createString(e) {
    const n = e.omalloc(this.utf8Length);
    return e.HEAPU8.set(this.utf8Value, n), n;
  }
}
const Ks = class {
  constructor(e) {
    if ($r(this, "id", ++Ks.LAST_ID), $r(this, "_onigBinding"), $r(this, "content"), $r(this, "utf16Length"), $r(this, "utf8Length"), $r(this, "utf16OffsetToUtf8"), $r(this, "utf8OffsetToUtf16"), $r(this, "ptr"), !qr)
      throw new UL("Must invoke loadWasm first.");
    this._onigBinding = qr, this.content = e;
    const n = new VS(e);
    this.utf16Length = n.utf16Length, this.utf8Length = n.utf8Length, this.utf16OffsetToUtf8 = n.utf16OffsetToUtf8, this.utf8OffsetToUtf16 = n.utf8OffsetToUtf16, this.utf8Length < 1e4 && !Ks._sharedPtrInUse ? (Ks._sharedPtr || (Ks._sharedPtr = qr.omalloc(1e4)), Ks._sharedPtrInUse = !0, qr.HEAPU8.set(n.utf8Value, Ks._sharedPtr), this.ptr = Ks._sharedPtr) : this.ptr = n.createString(qr);
  }
  convertUtf8OffsetToUtf16(e) {
    return this.utf8OffsetToUtf16 ? e < 0 ? 0 : e > this.utf8Length ? this.utf16Length : this.utf8OffsetToUtf16[e] : e;
  }
  convertUtf16OffsetToUtf8(e) {
    return this.utf16OffsetToUtf8 ? e < 0 ? 0 : e > this.utf16Length ? this.utf8Length : this.utf16OffsetToUtf8[e] : e;
  }
  dispose() {
    this.ptr === Ks._sharedPtr ? Ks._sharedPtrInUse = !1 : this._onigBinding.ofree(this.ptr);
  }
};
let wv = Ks;
$r(wv, "LAST_ID", 0);
$r(wv, "_sharedPtr", 0);
$r(wv, "_sharedPtrInUse", !1);
class rGe {
  constructor(e) {
    if ($r(this, "_onigBinding"), $r(this, "_ptr"), !qr)
      throw new UL("Must invoke loadWasm first.");
    const n = [], r = [];
    for (let a = 0, l = e.length; a < l; a++) {
      const c = new VS(e[a]);
      n[a] = c.createString(qr), r[a] = c.utf8Length;
    }
    const o = qr.omalloc(4 * e.length);
    qr.HEAPU32.set(n, o / 4);
    const i = qr.omalloc(4 * e.length);
    qr.HEAPU32.set(r, i / 4);
    const s = qr.createOnigScanner(o, i, e.length);
    for (let a = 0, l = e.length; a < l; a++)
      qr.ofree(n[a]);
    qr.ofree(i), qr.ofree(o), s === 0 && nGe(qr), this._onigBinding = qr, this._ptr = s;
  }
  dispose() {
    this._onigBinding.freeOnigScanner(this._ptr);
  }
  findNextMatchSync(e, n, r) {
    let o = 0;
    if (typeof r == "number" && (o = r), typeof e == "string") {
      e = new wv(e);
      const i = this._findNextMatchSync(e, n, !1, o);
      return e.dispose(), i;
    }
    return this._findNextMatchSync(e, n, !1, o);
  }
  _findNextMatchSync(e, n, r, o) {
    const i = this._onigBinding, s = i.findNextOnigScannerMatch(this._ptr, e.id, e.ptr, e.utf8Length, e.convertUtf16OffsetToUtf8(n), o);
    if (s === 0)
      return null;
    const a = i.HEAPU32;
    let l = s / 4;
    const c = a[l++], u = a[l++], d = [];
    for (let f = 0; f < u; f++) {
      const h = e.convertUtf8OffsetToUtf16(a[l++]), p = e.convertUtf8OffsetToUtf16(a[l++]);
      d[f] = {
        start: h,
        end: p,
        length: p - h
      };
    }
    return {
      index: c,
      captureIndices: d
    };
  }
}
function oGe(t) {
  return typeof t.instantiator == "function";
}
function iGe(t) {
  return typeof t.default == "function";
}
function sGe(t) {
  return typeof t.data < "u";
}
function aGe(t) {
  return typeof Response < "u" && t instanceof Response;
}
function lGe(t) {
  return typeof ArrayBuffer < "u" && (t instanceof ArrayBuffer || ArrayBuffer.isView(t)) || typeof Buffer < "u" && Buffer.isBuffer?.(t) || typeof SharedArrayBuffer < "u" && t instanceof SharedArrayBuffer || typeof Uint32Array < "u" && t instanceof Uint32Array;
}
let Qb;
function cGe(t) {
  if (Qb)
    return Qb;
  async function e() {
    qr = await JWe(async (n) => {
      let r = t;
      return r = await r, typeof r == "function" && (r = await r(n)), typeof r == "function" && (r = await r(n)), oGe(r) ? r = await r.instantiator(n) : iGe(r) ? r = await r.default(n) : (sGe(r) && (r = r.data), aGe(r) ? typeof WebAssembly.instantiateStreaming == "function" ? r = await uGe(r)(n) : r = await dGe(r)(n) : lGe(r) ? r = await Dk(r)(n) : r instanceof WebAssembly.Module ? r = await Dk(r)(n) : "default" in r && r.default instanceof WebAssembly.Module && (r = await Dk(r.default)(n))), "instance" in r && (r = r.instance), "exports" in r && (r = r.exports), r;
    });
  }
  return Qb = e(), Qb;
}
function Dk(t) {
  return (e) => WebAssembly.instantiate(t, e);
}
function uGe(t) {
  return (e) => WebAssembly.instantiateStreaming(t, e);
}
function dGe(t) {
  return async (e) => {
    const n = await t.arrayBuffer();
    return WebAssembly.instantiate(n, e);
  };
}
let fGe;
function hGe() {
  return fGe;
}
async function pGe(t) {
  return t && await cGe(t), {
    createScanner(e) {
      return new rGe(e.map((n) => typeof n == "string" ? n : n.source));
    },
    createString(e) {
      return new wv(e);
    }
  };
}
function mGe(t) {
  return HL(t);
}
function HL(t) {
  return Array.isArray(t) ? gGe(t) : t instanceof RegExp ? t : typeof t == "object" ? yGe(t) : t;
}
function gGe(t) {
  let e = [];
  for (let n = 0, r = t.length; n < r; n++)
    e[n] = HL(t[n]);
  return e;
}
function yGe(t) {
  let e = {};
  for (let n in t)
    e[n] = HL(t[n]);
  return e;
}
function fpe(t, ...e) {
  return e.forEach((n) => {
    for (let r in n)
      t[r] = n[r];
  }), t;
}
function hpe(t) {
  const e = ~t.lastIndexOf("/") || ~t.lastIndexOf("\\");
  return e === 0 ? t : ~e === t.length - 1 ? hpe(t.substring(0, t.length - 1)) : t.substr(~e + 1);
}
var Ik = /\$(\d+)|\${(\d+):\/(downcase|upcase)}/g, Zb = class {
  static hasCaptures(t) {
    return t === null ? !1 : (Ik.lastIndex = 0, Ik.test(t));
  }
  static replaceCaptures(t, e, n) {
    return t.replace(Ik, (r, o, i, s) => {
      let a = n[parseInt(o || i, 10)];
      if (a) {
        let l = e.substring(a.start, a.end);
        for (; l[0] === "."; )
          l = l.substring(1);
        switch (s) {
          case "downcase":
            return l.toLowerCase();
          case "upcase":
            return l.toUpperCase();
          default:
            return l;
        }
      } else
        return r;
    });
  }
};
function ppe(t, e) {
  return t < e ? -1 : t > e ? 1 : 0;
}
function mpe(t, e) {
  if (t === null && e === null)
    return 0;
  if (!t)
    return -1;
  if (!e)
    return 1;
  let n = t.length, r = e.length;
  if (n === r) {
    for (let o = 0; o < n; o++) {
      let i = ppe(t[o], e[o]);
      if (i !== 0)
        return i;
    }
    return 0;
  }
  return n - r;
}
function Pq(t) {
  return !!(/^#[0-9a-f]{6}$/i.test(t) || /^#[0-9a-f]{8}$/i.test(t) || /^#[0-9a-f]{3}$/i.test(t) || /^#[0-9a-f]{4}$/i.test(t));
}
function gpe(t) {
  return t.replace(/[\-\\\{\}\*\+\?\|\^\$\.\,\[\]\(\)\#\s]/g, "\\$&");
}
var ype = class {
  constructor(t) {
    ue(this, "cache", /* @__PURE__ */ new Map()), this.fn = t;
  }
  get(t) {
    if (this.cache.has(t))
      return this.cache.get(t);
    const e = this.fn(t);
    return this.cache.set(t, e), e;
  }
}, Wx = class {
  constructor(t, e, n) {
    ue(this, "_cachedMatchRoot", new ype(
      (r) => this._root.match(r)
    )), this._colorMap = t, this._defaults = e, this._root = n;
  }
  static createFromRawTheme(t, e) {
    return this.createFromParsedTheme(_Ge(t), e);
  }
  static createFromParsedTheme(t, e) {
    return xGe(t, e);
  }
  getColorMap() {
    return this._colorMap.getColorMap();
  }
  getDefaults() {
    return this._defaults;
  }
  match(t) {
    if (t === null)
      return this._defaults;
    const e = t.scopeName, n = this._cachedMatchRoot.get(e).find(
      (r) => vGe(t.parent, r.parentScopes)
    );
    return n ? new vpe(
      n.fontStyle,
      n.foreground,
      n.background
    ) : null;
  }
}, Nk = class Sw {
  constructor(e, n) {
    this.parent = e, this.scopeName = n;
  }
  static push(e, n) {
    for (const r of n)
      e = new Sw(e, r);
    return e;
  }
  static from(...e) {
    let n = null;
    for (let r = 0; r < e.length; r++)
      n = new Sw(n, e[r]);
    return n;
  }
  push(e) {
    return new Sw(this, e);
  }
  getSegments() {
    let e = this;
    const n = [];
    for (; e; )
      n.push(e.scopeName), e = e.parent;
    return n.reverse(), n;
  }
  toString() {
    return this.getSegments().join(" ");
  }
  extends(e) {
    return this === e ? !0 : this.parent === null ? !1 : this.parent.extends(e);
  }
  getExtensionIfDefined(e) {
    const n = [];
    let r = this;
    for (; r && r !== e; )
      n.push(r.scopeName), r = r.parent;
    return r === e ? n.reverse() : void 0;
  }
};
function vGe(t, e) {
  if (e.length === 0)
    return !0;
  for (let n = 0; n < e.length; n++) {
    let r = e[n], o = !1;
    if (r === ">") {
      if (n === e.length - 1)
        return !1;
      r = e[++n], o = !0;
    }
    for (; t && !bGe(t.scopeName, r); ) {
      if (o)
        return !1;
      t = t.parent;
    }
    if (!t)
      return !1;
    t = t.parent;
  }
  return !0;
}
function bGe(t, e) {
  return e === t || t.startsWith(e) && t[e.length] === ".";
}
var vpe = class {
  constructor(t, e, n) {
    this.fontStyle = t, this.foregroundId = e, this.backgroundId = n;
  }
};
function _Ge(t) {
  if (!t)
    return [];
  if (!t.settings || !Array.isArray(t.settings))
    return [];
  let e = t.settings, n = [], r = 0;
  for (let o = 0, i = e.length; o < i; o++) {
    let s = e[o];
    if (!s.settings)
      continue;
    let a;
    if (typeof s.scope == "string") {
      let d = s.scope;
      d = d.replace(/^[,]+/, ""), d = d.replace(/[,]+$/, ""), a = d.split(",");
    } else Array.isArray(s.scope) ? a = s.scope : a = [""];
    let l = -1;
    if (typeof s.settings.fontStyle == "string") {
      l = 0;
      let d = s.settings.fontStyle.split(" ");
      for (let f = 0, h = d.length; f < h; f++)
        switch (d[f]) {
          case "italic":
            l = l | 1;
            break;
          case "bold":
            l = l | 2;
            break;
          case "underline":
            l = l | 4;
            break;
          case "strikethrough":
            l = l | 8;
            break;
        }
    }
    let c = null;
    typeof s.settings.foreground == "string" && Pq(s.settings.foreground) && (c = s.settings.foreground);
    let u = null;
    typeof s.settings.background == "string" && Pq(s.settings.background) && (u = s.settings.background);
    for (let d = 0, f = a.length; d < f; d++) {
      let h = a[d].trim().split(" "), p = h[h.length - 1], m = null;
      h.length > 1 && (m = h.slice(0, h.length - 1), m.reverse()), n[r++] = new wGe(
        p,
        m,
        o,
        l,
        c,
        u
      );
    }
  }
  return n;
}
var wGe = class {
  constructor(t, e, n, r, o, i) {
    this.scope = t, this.parentScopes = e, this.index = n, this.fontStyle = r, this.foreground = o, this.background = i;
  }
}, wl = /* @__PURE__ */ ((t) => (t[t.NotSet = -1] = "NotSet", t[t.None = 0] = "None", t[t.Italic = 1] = "Italic", t[t.Bold = 2] = "Bold", t[t.Underline = 4] = "Underline", t[t.Strikethrough = 8] = "Strikethrough", t))(wl || {});
function xGe(t, e) {
  t.sort((l, c) => {
    let u = ppe(l.scope, c.scope);
    return u !== 0 || (u = mpe(l.parentScopes, c.parentScopes), u !== 0) ? u : l.index - c.index;
  });
  let n = 0, r = "#000000", o = "#ffffff";
  for (; t.length >= 1 && t[0].scope === ""; ) {
    let l = t.shift();
    l.fontStyle !== -1 && (n = l.fontStyle), l.foreground !== null && (r = l.foreground), l.background !== null && (o = l.background);
  }
  let i = new EGe(e), s = new vpe(n, i.getId(r), i.getId(o)), a = new OGe(new WN(0, null, -1, 0, 0), []);
  for (let l = 0, c = t.length; l < c; l++) {
    let u = t[l];
    a.insert(0, u.scope, u.parentScopes, u.fontStyle, i.getId(u.foreground), i.getId(u.background));
  }
  return new Wx(i, s, a);
}
var EGe = class {
  constructor(t) {
    if (ue(this, "_isFrozen"), ue(this, "_lastColorId"), ue(this, "_id2color"), ue(this, "_color2id"), this._lastColorId = 0, this._id2color = [], this._color2id = /* @__PURE__ */ Object.create(null), Array.isArray(t)) {
      this._isFrozen = !0;
      for (let e = 0, n = t.length; e < n; e++)
        this._color2id[t[e]] = e, this._id2color[e] = t[e];
    } else
      this._isFrozen = !1;
  }
  getId(t) {
    if (t === null)
      return 0;
    t = t.toUpperCase();
    let e = this._color2id[t];
    if (e)
      return e;
    if (this._isFrozen)
      throw new Error(`Missing color in color map - ${t}`);
    return e = ++this._lastColorId, this._color2id[t] = e, this._id2color[e] = t, e;
  }
  getColorMap() {
    return this._id2color.slice(0);
  }
}, SGe = Object.freeze([]), WN = class bpe {
  constructor(e, n, r, o, i) {
    ue(this, "scopeDepth"), ue(this, "parentScopes"), ue(this, "fontStyle"), ue(this, "foreground"), ue(this, "background"), this.scopeDepth = e, this.parentScopes = n || SGe, this.fontStyle = r, this.foreground = o, this.background = i;
  }
  clone() {
    return new bpe(this.scopeDepth, this.parentScopes, this.fontStyle, this.foreground, this.background);
  }
  static cloneArr(e) {
    let n = [];
    for (let r = 0, o = e.length; r < o; r++)
      n[r] = e[r].clone();
    return n;
  }
  acceptOverwrite(e, n, r, o) {
    this.scopeDepth > e ? console.log("how did this happen?") : this.scopeDepth = e, n !== -1 && (this.fontStyle = n), r !== 0 && (this.foreground = r), o !== 0 && (this.background = o);
  }
}, OGe = class GN {
  constructor(e, n = [], r = {}) {
    ue(this, "_rulesWithParentScopes"), this._mainRule = e, this._children = r, this._rulesWithParentScopes = n;
  }
  static _cmpBySpecificity(e, n) {
    if (e.scopeDepth !== n.scopeDepth)
      return n.scopeDepth - e.scopeDepth;
    let r = 0, o = 0;
    for (; e.parentScopes[r] === ">" && r++, n.parentScopes[o] === ">" && o++, !(r >= e.parentScopes.length || o >= n.parentScopes.length); ) {
      const i = n.parentScopes[o].length - e.parentScopes[r].length;
      if (i !== 0)
        return i;
      r++, o++;
    }
    return n.parentScopes.length - e.parentScopes.length;
  }
  match(e) {
    if (e !== "") {
      let r = e.indexOf("."), o, i;
      if (r === -1 ? (o = e, i = "") : (o = e.substring(0, r), i = e.substring(r + 1)), this._children.hasOwnProperty(o))
        return this._children[o].match(i);
    }
    const n = this._rulesWithParentScopes.concat(this._mainRule);
    return n.sort(GN._cmpBySpecificity), n;
  }
  insert(e, n, r, o, i, s) {
    if (n === "") {
      this._doInsertHere(e, r, o, i, s);
      return;
    }
    let a = n.indexOf("."), l, c;
    a === -1 ? (l = n, c = "") : (l = n.substring(0, a), c = n.substring(a + 1));
    let u;
    this._children.hasOwnProperty(l) ? u = this._children[l] : (u = new GN(this._mainRule.clone(), WN.cloneArr(this._rulesWithParentScopes)), this._children[l] = u), u.insert(e + 1, c, r, o, i, s);
  }
  _doInsertHere(e, n, r, o, i) {
    if (n === null) {
      this._mainRule.acceptOverwrite(e, r, o, i);
      return;
    }
    for (let s = 0, a = this._rulesWithParentScopes.length; s < a; s++) {
      let l = this._rulesWithParentScopes[s];
      if (mpe(l.parentScopes, n) === 0) {
        l.acceptOverwrite(e, r, o, i);
        return;
      }
    }
    r === -1 && (r = this._mainRule.fontStyle), o === 0 && (o = this._mainRule.foreground), i === 0 && (i = this._mainRule.background), this._rulesWithParentScopes.push(new WN(e, n, r, o, i));
  }
}, op = class Ni {
  static toBinaryStr(e) {
    return e.toString(2).padStart(32, "0");
  }
  static print(e) {
    const n = Ni.getLanguageId(e), r = Ni.getTokenType(e), o = Ni.getFontStyle(e), i = Ni.getForeground(e), s = Ni.getBackground(e);
    console.log({
      languageId: n,
      tokenType: r,
      fontStyle: o,
      foreground: i,
      background: s
    });
  }
  static getLanguageId(e) {
    return (e & 255) >>> 0;
  }
  static getTokenType(e) {
    return (e & 768) >>> 8;
  }
  static containsBalancedBrackets(e) {
    return (e & 1024) !== 0;
  }
  static getFontStyle(e) {
    return (e & 30720) >>> 11;
  }
  static getForeground(e) {
    return (e & 16744448) >>> 15;
  }
  static getBackground(e) {
    return (e & 4278190080) >>> 24;
  }
  /**
   * Updates the fields in `metadata`.
   * A value of `0`, `NotSet` or `null` indicates that the corresponding field should be left as is.
   */
  static set(e, n, r, o, i, s, a) {
    let l = Ni.getLanguageId(e), c = Ni.getTokenType(e), u = Ni.containsBalancedBrackets(e) ? 1 : 0, d = Ni.getFontStyle(e), f = Ni.getForeground(e), h = Ni.getBackground(e);
    return n !== 0 && (l = n), r !== 8 && (c = r), o !== null && (u = o ? 1 : 0), i !== -1 && (d = i), s !== 0 && (f = s), a !== 0 && (h = a), (l << 0 | c << 8 | u << 10 | d << 11 | f << 15 | h << 24) >>> 0;
  }
};
function Gx(t, e) {
  const n = [], r = CGe(t);
  let o = r.next();
  for (; o !== null; ) {
    let l = 0;
    if (o.length === 2 && o.charAt(1) === ":") {
      switch (o.charAt(0)) {
        case "R":
          l = 1;
          break;
        case "L":
          l = -1;
          break;
        default:
          console.log(`Unknown priority ${o} in scope selector`);
      }
      o = r.next();
    }
    let c = s();
    if (n.push({ matcher: c, priority: l }), o !== ",")
      break;
    o = r.next();
  }
  return n;
  function i() {
    if (o === "-") {
      o = r.next();
      const l = i();
      return (c) => !!l && !l(c);
    }
    if (o === "(") {
      o = r.next();
      const l = a();
      return o === ")" && (o = r.next()), l;
    }
    if ($q(o)) {
      const l = [];
      do
        l.push(o), o = r.next();
      while ($q(o));
      return (c) => e(l, c);
    }
    return null;
  }
  function s() {
    const l = [];
    let c = i();
    for (; c; )
      l.push(c), c = i();
    return (u) => l.every((d) => d(u));
  }
  function a() {
    const l = [];
    let c = s();
    for (; c && (l.push(c), o === "|" || o === ","); ) {
      do
        o = r.next();
      while (o === "|" || o === ",");
      c = s();
    }
    return (u) => l.some((d) => d(u));
  }
}
function $q(t) {
  return !!t && !!t.match(/[\w\.:]+/);
}
function CGe(t) {
  let e = /([LR]:|[\w\.:][\w\.:\-]*|[\,\|\-\(\)])/g, n = e.exec(t);
  return {
    next: () => {
      if (!n)
        return null;
      const r = n[0];
      return n = e.exec(t), r;
    }
  };
}
function _pe(t) {
  typeof t.dispose == "function" && t.dispose();
}
var dy = class {
  constructor(t) {
    this.scopeName = t;
  }
  toKey() {
    return this.scopeName;
  }
}, kGe = class {
  constructor(t, e) {
    this.scopeName = t, this.ruleName = e;
  }
  toKey() {
    return `${this.scopeName}#${this.ruleName}`;
  }
}, AGe = class {
  constructor() {
    ue(this, "_references", []), ue(this, "_seenReferenceKeys", /* @__PURE__ */ new Set()), ue(this, "visitedRule", /* @__PURE__ */ new Set());
  }
  get references() {
    return this._references;
  }
  add(t) {
    const e = t.toKey();
    this._seenReferenceKeys.has(e) || (this._seenReferenceKeys.add(e), this._references.push(t));
  }
}, TGe = class {
  constructor(t, e) {
    ue(this, "seenFullScopeRequests", /* @__PURE__ */ new Set()), ue(this, "seenPartialScopeRequests", /* @__PURE__ */ new Set()), ue(this, "Q"), this.repo = t, this.initialScopeName = e, this.seenFullScopeRequests.add(this.initialScopeName), this.Q = [new dy(this.initialScopeName)];
  }
  processQueue() {
    const t = this.Q;
    this.Q = [];
    const e = new AGe();
    for (const n of t)
      RGe(n, this.initialScopeName, this.repo, e);
    for (const n of e.references)
      if (n instanceof dy) {
        if (this.seenFullScopeRequests.has(n.scopeName))
          continue;
        this.seenFullScopeRequests.add(n.scopeName), this.Q.push(n);
      } else {
        if (this.seenFullScopeRequests.has(n.scopeName) || this.seenPartialScopeRequests.has(n.toKey()))
          continue;
        this.seenPartialScopeRequests.add(n.toKey()), this.Q.push(n);
      }
  }
};
function RGe(t, e, n, r) {
  const o = n.lookup(t.scopeName);
  if (!o) {
    if (t.scopeName === e)
      throw new Error(`No grammar provided for <${e}>`);
    return;
  }
  const i = n.lookup(e);
  t instanceof dy ? Ow({ baseGrammar: i, selfGrammar: o }, r) : YN(
    t.ruleName,
    { baseGrammar: i, selfGrammar: o, repository: o.repository },
    r
  );
  const s = n.injections(t.scopeName);
  if (s)
    for (const a of s)
      r.add(new dy(a));
}
function YN(t, e, n) {
  if (e.repository && e.repository[t]) {
    const r = e.repository[t];
    Yx([r], e, n);
  }
}
function Ow(t, e) {
  t.selfGrammar.patterns && Array.isArray(t.selfGrammar.patterns) && Yx(
    t.selfGrammar.patterns,
    { ...t, repository: t.selfGrammar.repository },
    e
  ), t.selfGrammar.injections && Yx(
    Object.values(t.selfGrammar.injections),
    { ...t, repository: t.selfGrammar.repository },
    e
  );
}
function Yx(t, e, n) {
  for (const r of t) {
    if (n.visitedRule.has(r))
      continue;
    n.visitedRule.add(r);
    const o = r.repository ? fpe({}, e.repository, r.repository) : e.repository;
    Array.isArray(r.patterns) && Yx(r.patterns, { ...e, repository: o }, n);
    const i = r.include;
    if (!i)
      continue;
    const s = wpe(i);
    switch (s.kind) {
      case 0:
        Ow({ ...e, selfGrammar: e.baseGrammar }, n);
        break;
      case 1:
        Ow(e, n);
        break;
      case 2:
        YN(s.ruleName, { ...e, repository: o }, n);
        break;
      case 3:
      case 4:
        const a = s.scopeName === e.selfGrammar.scopeName ? e.selfGrammar : s.scopeName === e.baseGrammar.scopeName ? e.baseGrammar : void 0;
        if (a) {
          const l = { baseGrammar: e.baseGrammar, selfGrammar: a, repository: o };
          s.kind === 4 ? YN(s.ruleName, l, n) : Ow(l, n);
        } else
          s.kind === 4 ? n.add(new kGe(s.scopeName, s.ruleName)) : n.add(new dy(s.scopeName));
        break;
    }
  }
}
var PGe = class {
  constructor() {
    ue(this, "kind", 0);
  }
}, $Ge = class {
  constructor() {
    ue(this, "kind", 1);
  }
}, MGe = class {
  constructor(t) {
    ue(this, "kind", 2), this.ruleName = t;
  }
}, DGe = class {
  constructor(t) {
    ue(this, "kind", 3), this.scopeName = t;
  }
}, IGe = class {
  constructor(t, e) {
    ue(this, "kind", 4), this.scopeName = t, this.ruleName = e;
  }
};
function wpe(t) {
  if (t === "$base")
    return new PGe();
  if (t === "$self")
    return new $Ge();
  const e = t.indexOf("#");
  if (e === -1)
    return new DGe(t);
  if (e === 0)
    return new MGe(t.substring(1));
  {
    const n = t.substring(0, e), r = t.substring(e + 1);
    return new IGe(n, r);
  }
}
var NGe = /\\(\d+)/, Mq = /\\(\d+)/g, jGe = -1, xpe = -2, xv = class {
  constructor(e, n, r, o) {
    ue(this, "$location"), ue(this, "id"), ue(this, "_nameIsCapturing"), ue(this, "_name"), ue(this, "_contentNameIsCapturing"), ue(this, "_contentName"), this.$location = e, this.id = n, this._name = r || null, this._nameIsCapturing = Zb.hasCaptures(this._name), this._contentName = o || null, this._contentNameIsCapturing = Zb.hasCaptures(this._contentName);
  }
  get debugName() {
    const e = this.$location ? `${hpe(this.$location.filename)}:${this.$location.line}` : "unknown";
    return `${this.constructor.name}#${this.id} @ ${e}`;
  }
  getName(e, n) {
    return !this._nameIsCapturing || this._name === null || e === null || n === null ? this._name : Zb.replaceCaptures(this._name, e, n);
  }
  getContentName(e, n) {
    return !this._contentNameIsCapturing || this._contentName === null ? this._contentName : Zb.replaceCaptures(this._contentName, e, n);
  }
}, LGe = class extends xv {
  constructor(t, e, n, r, o) {
    super(t, e, n, r), ue(this, "retokenizeCapturedWithRuleId"), this.retokenizeCapturedWithRuleId = o;
  }
  dispose() {
  }
  collectPatterns(t, e) {
    throw new Error("Not supported!");
  }
  compile(t, e) {
    throw new Error("Not supported!");
  }
  compileAG(t, e, n, r) {
    throw new Error("Not supported!");
  }
}, FGe = class extends xv {
  constructor(t, e, n, r, o) {
    super(t, e, n, null), ue(this, "_match"), ue(this, "captures"), ue(this, "_cachedCompiledPatterns"), this._match = new fy(r, this.id), this.captures = o, this._cachedCompiledPatterns = null;
  }
  dispose() {
    this._cachedCompiledPatterns && (this._cachedCompiledPatterns.dispose(), this._cachedCompiledPatterns = null);
  }
  get debugMatchRegExp() {
    return `${this._match.source}`;
  }
  collectPatterns(t, e) {
    e.push(this._match);
  }
  compile(t, e) {
    return this._getCachedCompiledPatterns(t).compile(t);
  }
  compileAG(t, e, n, r) {
    return this._getCachedCompiledPatterns(t).compileAG(t, n, r);
  }
  _getCachedCompiledPatterns(t) {
    return this._cachedCompiledPatterns || (this._cachedCompiledPatterns = new hy(), this.collectPatterns(t, this._cachedCompiledPatterns)), this._cachedCompiledPatterns;
  }
}, Dq = class extends xv {
  constructor(t, e, n, r, o) {
    super(t, e, n, r), ue(this, "hasMissingPatterns"), ue(this, "patterns"), ue(this, "_cachedCompiledPatterns"), this.patterns = o.patterns, this.hasMissingPatterns = o.hasMissingPatterns, this._cachedCompiledPatterns = null;
  }
  dispose() {
    this._cachedCompiledPatterns && (this._cachedCompiledPatterns.dispose(), this._cachedCompiledPatterns = null);
  }
  collectPatterns(t, e) {
    for (const n of this.patterns)
      t.getRule(n).collectPatterns(t, e);
  }
  compile(t, e) {
    return this._getCachedCompiledPatterns(t).compile(t);
  }
  compileAG(t, e, n, r) {
    return this._getCachedCompiledPatterns(t).compileAG(t, n, r);
  }
  _getCachedCompiledPatterns(t) {
    return this._cachedCompiledPatterns || (this._cachedCompiledPatterns = new hy(), this.collectPatterns(t, this._cachedCompiledPatterns)), this._cachedCompiledPatterns;
  }
}, KN = class extends xv {
  constructor(t, e, n, r, o, i, s, a, l, c) {
    super(t, e, n, r), ue(this, "_begin"), ue(this, "beginCaptures"), ue(this, "_end"), ue(this, "endHasBackReferences"), ue(this, "endCaptures"), ue(this, "applyEndPatternLast"), ue(this, "hasMissingPatterns"), ue(this, "patterns"), ue(this, "_cachedCompiledPatterns"), this._begin = new fy(o, this.id), this.beginCaptures = i, this._end = new fy(s || "￿", -1), this.endHasBackReferences = this._end.hasBackReferences, this.endCaptures = a, this.applyEndPatternLast = l || !1, this.patterns = c.patterns, this.hasMissingPatterns = c.hasMissingPatterns, this._cachedCompiledPatterns = null;
  }
  dispose() {
    this._cachedCompiledPatterns && (this._cachedCompiledPatterns.dispose(), this._cachedCompiledPatterns = null);
  }
  get debugBeginRegExp() {
    return `${this._begin.source}`;
  }
  get debugEndRegExp() {
    return `${this._end.source}`;
  }
  getEndWithResolvedBackReferences(t, e) {
    return this._end.resolveBackReferences(t, e);
  }
  collectPatterns(t, e) {
    e.push(this._begin);
  }
  compile(t, e) {
    return this._getCachedCompiledPatterns(t, e).compile(t);
  }
  compileAG(t, e, n, r) {
    return this._getCachedCompiledPatterns(t, e).compileAG(t, n, r);
  }
  _getCachedCompiledPatterns(t, e) {
    if (!this._cachedCompiledPatterns) {
      this._cachedCompiledPatterns = new hy();
      for (const n of this.patterns)
        t.getRule(n).collectPatterns(t, this._cachedCompiledPatterns);
      this.applyEndPatternLast ? this._cachedCompiledPatterns.push(this._end.hasBackReferences ? this._end.clone() : this._end) : this._cachedCompiledPatterns.unshift(this._end.hasBackReferences ? this._end.clone() : this._end);
    }
    return this._end.hasBackReferences && (this.applyEndPatternLast ? this._cachedCompiledPatterns.setSource(this._cachedCompiledPatterns.length() - 1, e) : this._cachedCompiledPatterns.setSource(0, e)), this._cachedCompiledPatterns;
  }
}, Kx = class extends xv {
  constructor(e, n, r, o, i, s, a, l, c) {
    super(e, n, r, o), ue(this, "_begin"), ue(this, "beginCaptures"), ue(this, "whileCaptures"), ue(this, "_while"), ue(this, "whileHasBackReferences"), ue(this, "hasMissingPatterns"), ue(this, "patterns"), ue(this, "_cachedCompiledPatterns"), ue(this, "_cachedCompiledWhilePatterns"), this._begin = new fy(i, this.id), this.beginCaptures = s, this.whileCaptures = l, this._while = new fy(a, xpe), this.whileHasBackReferences = this._while.hasBackReferences, this.patterns = c.patterns, this.hasMissingPatterns = c.hasMissingPatterns, this._cachedCompiledPatterns = null, this._cachedCompiledWhilePatterns = null;
  }
  dispose() {
    this._cachedCompiledPatterns && (this._cachedCompiledPatterns.dispose(), this._cachedCompiledPatterns = null), this._cachedCompiledWhilePatterns && (this._cachedCompiledWhilePatterns.dispose(), this._cachedCompiledWhilePatterns = null);
  }
  get debugBeginRegExp() {
    return `${this._begin.source}`;
  }
  get debugWhileRegExp() {
    return `${this._while.source}`;
  }
  getWhileWithResolvedBackReferences(e, n) {
    return this._while.resolveBackReferences(e, n);
  }
  collectPatterns(e, n) {
    n.push(this._begin);
  }
  compile(e, n) {
    return this._getCachedCompiledPatterns(e).compile(e);
  }
  compileAG(e, n, r, o) {
    return this._getCachedCompiledPatterns(e).compileAG(e, r, o);
  }
  _getCachedCompiledPatterns(e) {
    if (!this._cachedCompiledPatterns) {
      this._cachedCompiledPatterns = new hy();
      for (const n of this.patterns)
        e.getRule(n).collectPatterns(e, this._cachedCompiledPatterns);
    }
    return this._cachedCompiledPatterns;
  }
  compileWhile(e, n) {
    return this._getCachedCompiledWhilePatterns(e, n).compile(e);
  }
  compileWhileAG(e, n, r, o) {
    return this._getCachedCompiledWhilePatterns(e, n).compileAG(e, r, o);
  }
  _getCachedCompiledWhilePatterns(e, n) {
    return this._cachedCompiledWhilePatterns || (this._cachedCompiledWhilePatterns = new hy(), this._cachedCompiledWhilePatterns.push(this._while.hasBackReferences ? this._while.clone() : this._while)), this._while.hasBackReferences && this._cachedCompiledWhilePatterns.setSource(0, n || "￿"), this._cachedCompiledWhilePatterns;
  }
}, Epe = class ro {
  static createCaptureRule(e, n, r, o, i) {
    return e.registerRule((s) => new LGe(n, s, r, o, i));
  }
  static getCompiledRuleId(e, n, r) {
    return e.id || n.registerRule((o) => {
      if (e.id = o, e.match)
        return new FGe(
          e.$vscodeTextmateLocation,
          e.id,
          e.name,
          e.match,
          ro._compileCaptures(e.captures, n, r)
        );
      if (typeof e.begin > "u") {
        e.repository && (r = fpe({}, r, e.repository));
        let i = e.patterns;
        return typeof i > "u" && e.include && (i = [{ include: e.include }]), new Dq(
          e.$vscodeTextmateLocation,
          e.id,
          e.name,
          e.contentName,
          ro._compilePatterns(i, n, r)
        );
      }
      return e.while ? new Kx(
        e.$vscodeTextmateLocation,
        e.id,
        e.name,
        e.contentName,
        e.begin,
        ro._compileCaptures(e.beginCaptures || e.captures, n, r),
        e.while,
        ro._compileCaptures(e.whileCaptures || e.captures, n, r),
        ro._compilePatterns(e.patterns, n, r)
      ) : new KN(
        e.$vscodeTextmateLocation,
        e.id,
        e.name,
        e.contentName,
        e.begin,
        ro._compileCaptures(e.beginCaptures || e.captures, n, r),
        e.end,
        ro._compileCaptures(e.endCaptures || e.captures, n, r),
        e.applyEndPatternLast,
        ro._compilePatterns(e.patterns, n, r)
      );
    }), e.id;
  }
  static _compileCaptures(e, n, r) {
    let o = [];
    if (e) {
      let i = 0;
      for (const s in e) {
        if (s === "$vscodeTextmateLocation")
          continue;
        const a = parseInt(s, 10);
        a > i && (i = a);
      }
      for (let s = 0; s <= i; s++)
        o[s] = null;
      for (const s in e) {
        if (s === "$vscodeTextmateLocation")
          continue;
        const a = parseInt(s, 10);
        let l = 0;
        e[s].patterns && (l = ro.getCompiledRuleId(e[s], n, r)), o[a] = ro.createCaptureRule(n, e[s].$vscodeTextmateLocation, e[s].name, e[s].contentName, l);
      }
    }
    return o;
  }
  static _compilePatterns(e, n, r) {
    let o = [];
    if (e)
      for (let i = 0, s = e.length; i < s; i++) {
        const a = e[i];
        let l = -1;
        if (a.include) {
          const c = wpe(a.include);
          switch (c.kind) {
            case 0:
            case 1:
              l = ro.getCompiledRuleId(r[a.include], n, r);
              break;
            case 2:
              let u = r[c.ruleName];
              u && (l = ro.getCompiledRuleId(u, n, r));
              break;
            case 3:
            case 4:
              const d = c.scopeName, f = c.kind === 4 ? c.ruleName : null, h = n.getExternalGrammar(d, r);
              if (h)
                if (f) {
                  let p = h.repository[f];
                  p && (l = ro.getCompiledRuleId(p, n, h.repository));
                } else
                  l = ro.getCompiledRuleId(h.repository.$self, n, h.repository);
              break;
          }
        } else
          l = ro.getCompiledRuleId(a, n, r);
        if (l !== -1) {
          const c = n.getRule(l);
          let u = !1;
          if ((c instanceof Dq || c instanceof KN || c instanceof Kx) && c.hasMissingPatterns && c.patterns.length === 0 && (u = !0), u)
            continue;
          o.push(l);
        }
      }
    return {
      patterns: o,
      hasMissingPatterns: (e ? e.length : 0) !== o.length
    };
  }
}, fy = class Spe {
  constructor(e, n) {
    if (ue(this, "source"), ue(this, "ruleId"), ue(this, "hasAnchor"), ue(this, "hasBackReferences"), ue(this, "_anchorCache"), e && typeof e == "string") {
      const r = e.length;
      let o = 0, i = [], s = !1;
      for (let a = 0; a < r; a++)
        if (e.charAt(a) === "\\" && a + 1 < r) {
          const l = e.charAt(a + 1);
          l === "z" ? (i.push(e.substring(o, a)), i.push("$(?!\\n)(?<!\\n)"), o = a + 2) : (l === "A" || l === "G") && (s = !0), a++;
        }
      this.hasAnchor = s, o === 0 ? this.source = e : (i.push(e.substring(o, r)), this.source = i.join(""));
    } else
      this.hasAnchor = !1, this.source = e;
    this.hasAnchor ? this._anchorCache = this._buildAnchorCache() : this._anchorCache = null, this.ruleId = n, typeof this.source == "string" ? this.hasBackReferences = NGe.test(this.source) : this.hasBackReferences = !1;
  }
  clone() {
    return new Spe(this.source, this.ruleId);
  }
  setSource(e) {
    this.source !== e && (this.source = e, this.hasAnchor && (this._anchorCache = this._buildAnchorCache()));
  }
  resolveBackReferences(e, n) {
    if (typeof this.source != "string")
      throw new Error("This method should only be called if the source is a string");
    let r = n.map((o) => e.substring(o.start, o.end));
    return Mq.lastIndex = 0, this.source.replace(Mq, (o, i) => gpe(r[parseInt(i, 10)] || ""));
  }
  _buildAnchorCache() {
    if (typeof this.source != "string")
      throw new Error("This method should only be called if the source is a string");
    let e = [], n = [], r = [], o = [], i, s, a, l;
    for (i = 0, s = this.source.length; i < s; i++)
      a = this.source.charAt(i), e[i] = a, n[i] = a, r[i] = a, o[i] = a, a === "\\" && i + 1 < s && (l = this.source.charAt(i + 1), l === "A" ? (e[i + 1] = "￿", n[i + 1] = "￿", r[i + 1] = "A", o[i + 1] = "A") : l === "G" ? (e[i + 1] = "￿", n[i + 1] = "G", r[i + 1] = "￿", o[i + 1] = "G") : (e[i + 1] = l, n[i + 1] = l, r[i + 1] = l, o[i + 1] = l), i++);
    return {
      A0_G0: e.join(""),
      A0_G1: n.join(""),
      A1_G0: r.join(""),
      A1_G1: o.join("")
    };
  }
  resolveAnchors(e, n) {
    return !this.hasAnchor || !this._anchorCache || typeof this.source != "string" ? this.source : e ? n ? this._anchorCache.A1_G1 : this._anchorCache.A1_G0 : n ? this._anchorCache.A0_G1 : this._anchorCache.A0_G0;
  }
}, hy = class {
  constructor() {
    ue(this, "_items"), ue(this, "_hasAnchors"), ue(this, "_cached"), ue(this, "_anchorCache"), this._items = [], this._hasAnchors = !1, this._cached = null, this._anchorCache = {
      A0_G0: null,
      A0_G1: null,
      A1_G0: null,
      A1_G1: null
    };
  }
  dispose() {
    this._disposeCaches();
  }
  _disposeCaches() {
    this._cached && (this._cached.dispose(), this._cached = null), this._anchorCache.A0_G0 && (this._anchorCache.A0_G0.dispose(), this._anchorCache.A0_G0 = null), this._anchorCache.A0_G1 && (this._anchorCache.A0_G1.dispose(), this._anchorCache.A0_G1 = null), this._anchorCache.A1_G0 && (this._anchorCache.A1_G0.dispose(), this._anchorCache.A1_G0 = null), this._anchorCache.A1_G1 && (this._anchorCache.A1_G1.dispose(), this._anchorCache.A1_G1 = null);
  }
  push(t) {
    this._items.push(t), this._hasAnchors = this._hasAnchors || t.hasAnchor;
  }
  unshift(t) {
    this._items.unshift(t), this._hasAnchors = this._hasAnchors || t.hasAnchor;
  }
  length() {
    return this._items.length;
  }
  setSource(t, e) {
    this._items[t].source !== e && (this._disposeCaches(), this._items[t].setSource(e));
  }
  compile(t) {
    if (!this._cached) {
      let e = this._items.map((n) => n.source);
      this._cached = new Iq(t, e, this._items.map((n) => n.ruleId));
    }
    return this._cached;
  }
  compileAG(t, e, n) {
    return this._hasAnchors ? e ? n ? (this._anchorCache.A1_G1 || (this._anchorCache.A1_G1 = this._resolveAnchors(t, e, n)), this._anchorCache.A1_G1) : (this._anchorCache.A1_G0 || (this._anchorCache.A1_G0 = this._resolveAnchors(t, e, n)), this._anchorCache.A1_G0) : n ? (this._anchorCache.A0_G1 || (this._anchorCache.A0_G1 = this._resolveAnchors(t, e, n)), this._anchorCache.A0_G1) : (this._anchorCache.A0_G0 || (this._anchorCache.A0_G0 = this._resolveAnchors(t, e, n)), this._anchorCache.A0_G0) : this.compile(t);
  }
  _resolveAnchors(t, e, n) {
    let r = this._items.map((o) => o.resolveAnchors(e, n));
    return new Iq(t, r, this._items.map((o) => o.ruleId));
  }
}, Iq = class {
  constructor(t, e, n) {
    ue(this, "scanner"), this.regExps = e, this.rules = n, this.scanner = t.createOnigScanner(e);
  }
  dispose() {
    typeof this.scanner.dispose == "function" && this.scanner.dispose();
  }
  toString() {
    const t = [];
    for (let e = 0, n = this.rules.length; e < n; e++)
      t.push("   - " + this.rules[e] + ": " + this.regExps[e]);
    return t.join(`
`);
  }
  findNextMatchSync(t, e, n) {
    const r = this.scanner.findNextMatchSync(t, e, n);
    return r ? {
      ruleId: this.rules[r.index],
      captureIndices: r.captureIndices
    } : null;
  }
}, jk = class {
  constructor(t, e) {
    this.languageId = t, this.tokenType = e;
  }
}, wf, BGe = (wf = class {
  constructor(t, e) {
    ue(this, "_defaultAttributes"), ue(this, "_embeddedLanguagesMatcher"), ue(this, "_getBasicScopeAttributes", new ype((n) => {
      const r = this._scopeToLanguage(n), o = this._toStandardTokenType(n);
      return new jk(r, o);
    })), this._defaultAttributes = new jk(
      t,
      8
      /* NotSet */
    ), this._embeddedLanguagesMatcher = new zGe(Object.entries(e || {}));
  }
  getDefaultAttributes() {
    return this._defaultAttributes;
  }
  getBasicScopeAttributes(t) {
    return t === null ? wf._NULL_SCOPE_METADATA : this._getBasicScopeAttributes.get(t);
  }
  /**
   * Given a produced TM scope, return the language that token describes or null if unknown.
   * e.g. source.html => html, source.css.embedded.html => css, punctuation.definition.tag.html => null
   */
  _scopeToLanguage(t) {
    return this._embeddedLanguagesMatcher.match(t) || 0;
  }
  _toStandardTokenType(t) {
    const e = t.match(wf.STANDARD_TOKEN_TYPE_REGEXP);
    if (!e)
      return 8;
    switch (e[1]) {
      case "comment":
        return 1;
      case "string":
        return 2;
      case "regex":
        return 3;
      case "meta.embedded":
        return 0;
    }
    throw new Error("Unexpected match for standard token type!");
  }
}, ue(wf, "_NULL_SCOPE_METADATA", new jk(0, 0)), ue(wf, "STANDARD_TOKEN_TYPE_REGEXP", /\b(comment|string|regex|meta\.embedded)\b/), wf), zGe = class {
  constructor(t) {
    if (ue(this, "values"), ue(this, "scopesRegExp"), t.length === 0)
      this.values = null, this.scopesRegExp = null;
    else {
      this.values = new Map(t);
      const e = t.map(
        ([n, r]) => gpe(n)
      );
      e.sort(), e.reverse(), this.scopesRegExp = new RegExp(
        `^((${e.join(")|(")}))($|\\.)`,
        ""
      );
    }
  }
  match(t) {
    if (!this.scopesRegExp)
      return;
    const e = t.match(this.scopesRegExp);
    if (e)
      return this.values.get(e[1]);
  }
};
typeof process < "u" && process.env.VSCODE_TEXTMATE_DEBUG;
var Nq = class {
  constructor(t, e) {
    this.stack = t, this.stoppedEarly = e;
  }
};
function Ope(t, e, n, r, o, i, s, a) {
  const l = e.content.length;
  let c = !1, u = -1;
  if (s) {
    const h = qGe(
      t,
      e,
      n,
      r,
      o,
      i
    );
    o = h.stack, r = h.linePos, n = h.isFirstLine, u = h.anchorPosition;
  }
  const d = Date.now();
  for (; !c; ) {
    if (a !== 0 && Date.now() - d > a)
      return new Nq(o, !0);
    f();
  }
  return new Nq(o, !1);
  function f() {
    const h = UGe(
      t,
      e,
      n,
      r,
      o,
      u
    );
    if (!h) {
      i.produce(o, l), c = !0;
      return;
    }
    const p = h.captureIndices, m = h.matchedRuleId, g = p && p.length > 0 ? p[0].end > r : !1;
    if (m === jGe) {
      const y = o.getRule(t);
      i.produce(o, p[0].start), o = o.withContentNameScopesList(o.nameScopesList), Og(
        t,
        e,
        n,
        o,
        i,
        y.endCaptures,
        p
      ), i.produce(o, p[0].end);
      const v = o;
      if (o = o.parent, u = v.getAnchorPos(), !g && v.getEnterPos() === r) {
        o = v, i.produce(o, l), c = !0;
        return;
      }
    } else {
      const y = t.getRule(m);
      i.produce(o, p[0].start);
      const v = o, b = y.getName(e.content, p), _ = o.contentNameScopesList.pushAttributed(
        b,
        t
      );
      if (o = o.push(
        m,
        r,
        u,
        p[0].end === l,
        null,
        _,
        _
      ), y instanceof KN) {
        const w = y;
        Og(
          t,
          e,
          n,
          o,
          i,
          w.beginCaptures,
          p
        ), i.produce(o, p[0].end), u = p[0].end;
        const x = w.getContentName(
          e.content,
          p
        ), E = _.pushAttributed(
          x,
          t
        );
        if (o = o.withContentNameScopesList(E), w.endHasBackReferences && (o = o.withEndRule(
          w.getEndWithResolvedBackReferences(
            e.content,
            p
          )
        )), !g && v.hasSameRuleAs(o)) {
          o = o.pop(), i.produce(o, l), c = !0;
          return;
        }
      } else if (y instanceof Kx) {
        const w = y;
        Og(
          t,
          e,
          n,
          o,
          i,
          w.beginCaptures,
          p
        ), i.produce(o, p[0].end), u = p[0].end;
        const x = w.getContentName(
          e.content,
          p
        ), E = _.pushAttributed(
          x,
          t
        );
        if (o = o.withContentNameScopesList(E), w.whileHasBackReferences && (o = o.withEndRule(
          w.getWhileWithResolvedBackReferences(
            e.content,
            p
          )
        )), !g && v.hasSameRuleAs(o)) {
          o = o.pop(), i.produce(o, l), c = !0;
          return;
        }
      } else if (Og(
        t,
        e,
        n,
        o,
        i,
        y.captures,
        p
      ), i.produce(o, p[0].end), o = o.pop(), !g) {
        o = o.safePop(), i.produce(o, l), c = !0;
        return;
      }
    }
    p[0].end > r && (r = p[0].end, n = !1);
  }
}
function qGe(t, e, n, r, o, i) {
  let s = o.beginRuleCapturedEOL ? 0 : -1;
  const a = [];
  for (let l = o; l; l = l.pop()) {
    const c = l.getRule(t);
    c instanceof Kx && a.push({
      rule: c,
      stack: l
    });
  }
  for (let l = a.pop(); l; l = a.pop()) {
    const { ruleScanner: c, findOptions: u } = WGe(l.rule, t, l.stack.endRule, n, r === s), d = c.findNextMatchSync(e, r, u);
    if (d) {
      if (d.ruleId !== xpe) {
        o = l.stack.pop();
        break;
      }
      d.captureIndices && d.captureIndices.length && (i.produce(l.stack, d.captureIndices[0].start), Og(t, e, n, l.stack, i, l.rule.whileCaptures, d.captureIndices), i.produce(l.stack, d.captureIndices[0].end), s = d.captureIndices[0].end, d.captureIndices[0].end > r && (r = d.captureIndices[0].end, n = !1));
    } else {
      o = l.stack.pop();
      break;
    }
  }
  return { stack: o, linePos: r, anchorPosition: s, isFirstLine: n };
}
function UGe(t, e, n, r, o, i) {
  const s = HGe(t, e, n, r, o, i), a = t.getInjections();
  if (a.length === 0)
    return s;
  const l = VGe(a, t, e, n, r, o, i);
  if (!l)
    return s;
  if (!s)
    return l;
  const c = s.captureIndices[0].start, u = l.captureIndices[0].start;
  return u < c || l.priorityMatch && u === c ? l : s;
}
function HGe(t, e, n, r, o, i) {
  const s = o.getRule(t), { ruleScanner: a, findOptions: l } = Cpe(s, t, o.endRule, n, r === i), c = a.findNextMatchSync(e, r, l);
  return c ? {
    captureIndices: c.captureIndices,
    matchedRuleId: c.ruleId
  } : null;
}
function VGe(t, e, n, r, o, i, s) {
  let a = Number.MAX_VALUE, l = null, c, u = 0;
  const d = i.contentNameScopesList.getScopeNames();
  for (let f = 0, h = t.length; f < h; f++) {
    const p = t[f];
    if (!p.matcher(d))
      continue;
    const m = e.getRule(p.ruleId), { ruleScanner: g, findOptions: y } = Cpe(m, e, null, r, o === s), v = g.findNextMatchSync(n, o, y);
    if (!v)
      continue;
    const b = v.captureIndices[0].start;
    if (!(b >= a) && (a = b, l = v.captureIndices, c = v.ruleId, u = p.priority, a === o))
      break;
  }
  return l ? {
    priorityMatch: u === -1,
    captureIndices: l,
    matchedRuleId: c
  } : null;
}
function Cpe(t, e, n, r, o) {
  return {
    ruleScanner: t.compileAG(e, n, r, o),
    findOptions: 0
    /* None */
  };
}
function WGe(t, e, n, r, o) {
  return {
    ruleScanner: t.compileWhileAG(e, n, r, o),
    findOptions: 0
    /* None */
  };
}
function Og(t, e, n, r, o, i, s) {
  if (i.length === 0)
    return;
  const a = e.content, l = Math.min(i.length, s.length), c = [], u = s[0].end;
  for (let d = 0; d < l; d++) {
    const f = i[d];
    if (f === null)
      continue;
    const h = s[d];
    if (h.length === 0)
      continue;
    if (h.start > u)
      break;
    for (; c.length > 0 && c[c.length - 1].endPos <= h.start; )
      o.produceFromScopes(c[c.length - 1].scopes, c[c.length - 1].endPos), c.pop();
    if (c.length > 0 ? o.produceFromScopes(c[c.length - 1].scopes, h.start) : o.produce(r, h.start), f.retokenizeCapturedWithRuleId) {
      const m = f.getName(a, s), g = r.contentNameScopesList.pushAttributed(m, t), y = f.getContentName(a, s), v = g.pushAttributed(y, t), b = r.push(f.retokenizeCapturedWithRuleId, h.start, -1, !1, null, g, v), _ = t.createOnigString(a.substring(0, h.end));
      Ope(
        t,
        _,
        n && h.start === 0,
        h.start,
        b,
        o,
        !1,
        /* no time limit */
        0
      ), _pe(_);
      continue;
    }
    const p = f.getName(a, s);
    if (p !== null) {
      const m = (c.length > 0 ? c[c.length - 1].scopes : r.contentNameScopesList).pushAttributed(p, t);
      c.push(new GGe(m, h.end));
    }
  }
  for (; c.length > 0; )
    o.produceFromScopes(c[c.length - 1].scopes, c[c.length - 1].endPos), c.pop();
}
var GGe = class {
  constructor(t, e) {
    ue(this, "scopes"), ue(this, "endPos"), this.scopes = t, this.endPos = e;
  }
};
function YGe(t, e, n, r, o, i, s, a) {
  return new XGe(
    t,
    e,
    n,
    r,
    o,
    i,
    s,
    a
  );
}
function jq(t, e, n, r, o) {
  const i = Gx(e, Xx), s = Epe.getCompiledRuleId(n, r, o.repository);
  for (const a of i)
    t.push({
      debugSelector: e,
      matcher: a.matcher,
      ruleId: s,
      grammar: o,
      priority: a.priority
    });
}
function Xx(t, e) {
  if (e.length < t.length)
    return !1;
  let n = 0;
  return t.every((r) => {
    for (let o = n; o < e.length; o++)
      if (KGe(e[o], r))
        return n = o + 1, !0;
    return !1;
  });
}
function KGe(t, e) {
  if (!t)
    return !1;
  if (t === e)
    return !0;
  const n = e.length;
  return t.length > n && t.substr(0, n) === e && t[n] === ".";
}
var XGe = class {
  constructor(t, e, n, r, o, i, s, a) {
    if (ue(this, "_rootId"), ue(this, "_lastRuleId"), ue(this, "_ruleId2desc"), ue(this, "_includedGrammars"), ue(this, "_grammarRepository"), ue(this, "_grammar"), ue(this, "_injections"), ue(this, "_basicScopeAttributesProvider"), ue(this, "_tokenTypeMatchers"), this._rootScopeName = t, this.balancedBracketSelectors = i, this._onigLib = a, this._basicScopeAttributesProvider = new BGe(
      n,
      r
    ), this._rootId = -1, this._lastRuleId = 0, this._ruleId2desc = [null], this._includedGrammars = {}, this._grammarRepository = s, this._grammar = Lq(e, null), this._injections = null, this._tokenTypeMatchers = [], o)
      for (const l of Object.keys(o)) {
        const c = Gx(l, Xx);
        for (const u of c)
          this._tokenTypeMatchers.push({
            matcher: u.matcher,
            type: o[l]
          });
      }
  }
  get themeProvider() {
    return this._grammarRepository;
  }
  dispose() {
    for (const t of this._ruleId2desc)
      t && t.dispose();
  }
  createOnigScanner(t) {
    return this._onigLib.createOnigScanner(t);
  }
  createOnigString(t) {
    return this._onigLib.createOnigString(t);
  }
  getMetadataForScope(t) {
    return this._basicScopeAttributesProvider.getBasicScopeAttributes(t);
  }
  _collectInjections() {
    const t = {
      lookup: (o) => o === this._rootScopeName ? this._grammar : this.getExternalGrammar(o),
      injections: (o) => this._grammarRepository.injections(o)
    }, e = [], n = this._rootScopeName, r = t.lookup(n);
    if (r) {
      const o = r.injections;
      if (o)
        for (let s in o)
          jq(
            e,
            s,
            o[s],
            this,
            r
          );
      const i = this._grammarRepository.injections(n);
      i && i.forEach((s) => {
        const a = this.getExternalGrammar(s);
        if (a) {
          const l = a.injectionSelector;
          l && jq(
            e,
            l,
            a,
            this,
            a
          );
        }
      });
    }
    return e.sort((o, i) => o.priority - i.priority), e;
  }
  getInjections() {
    return this._injections === null && (this._injections = this._collectInjections()), this._injections;
  }
  registerRule(t) {
    const e = ++this._lastRuleId, n = t(e);
    return this._ruleId2desc[e] = n, n;
  }
  getRule(t) {
    return this._ruleId2desc[t];
  }
  getExternalGrammar(t, e) {
    if (this._includedGrammars[t])
      return this._includedGrammars[t];
    if (this._grammarRepository) {
      const n = this._grammarRepository.lookup(t);
      if (n)
        return this._includedGrammars[t] = Lq(
          n,
          e && e.$base
        ), this._includedGrammars[t];
    }
  }
  tokenizeLine(t, e, n = 0) {
    const r = this._tokenize(t, e, !1, n);
    return {
      tokens: r.lineTokens.getResult(r.ruleStack, r.lineLength),
      ruleStack: r.ruleStack,
      stoppedEarly: r.stoppedEarly
    };
  }
  tokenizeLine2(t, e, n = 0) {
    const r = this._tokenize(t, e, !0, n);
    return {
      tokens: r.lineTokens.getBinaryResult(r.ruleStack, r.lineLength),
      ruleStack: r.ruleStack,
      stoppedEarly: r.stoppedEarly
    };
  }
  _tokenize(t, e, n, r) {
    this._rootId === -1 && (this._rootId = Epe.getCompiledRuleId(
      this._grammar.repository.$self,
      this,
      this._grammar.repository
    ), this.getInjections());
    let o;
    if (!e || e === XN.NULL) {
      o = !0;
      const c = this._basicScopeAttributesProvider.getDefaultAttributes(), u = this.themeProvider.getDefaults(), d = op.set(
        0,
        c.languageId,
        c.tokenType,
        null,
        u.fontStyle,
        u.foregroundId,
        u.backgroundId
      ), f = this.getRule(this._rootId).getName(
        null,
        null
      );
      let h;
      f ? h = s0.createRootAndLookUpScopeName(
        f,
        d,
        this
      ) : h = s0.createRoot(
        "unknown",
        d
      ), e = new XN(
        null,
        this._rootId,
        -1,
        -1,
        !1,
        null,
        h,
        h
      );
    } else
      o = !1, e.reset();
    t = t + `
`;
    const i = this.createOnigString(t), s = i.content.length, a = new ZGe(
      n,
      t,
      this._tokenTypeMatchers,
      this.balancedBracketSelectors
    ), l = Ope(
      this,
      i,
      o,
      0,
      e,
      a,
      !0,
      r
    );
    return _pe(i), {
      lineLength: s,
      lineTokens: a,
      ruleStack: l.stack,
      stoppedEarly: l.stoppedEarly
    };
  }
};
function Lq(t, e) {
  return t = mGe(t), t.repository = t.repository || {}, t.repository.$self = {
    $vscodeTextmateLocation: t.$vscodeTextmateLocation,
    patterns: t.patterns,
    name: t.scopeName
  }, t.repository.$base = e || t.repository.$self, t;
}
var s0 = class Xs {
  /**
   * Invariant:
   * ```
   * if (parent && !scopePath.extends(parent.scopePath)) {
   * 	throw new Error();
   * }
   * ```
   */
  constructor(e, n, r) {
    this.parent = e, this.scopePath = n, this.tokenAttributes = r;
  }
  static fromExtension(e, n) {
    let r = e, o = e?.scopePath ?? null;
    for (const i of n)
      o = Nk.push(o, i.scopeNames), r = new Xs(r, o, i.encodedTokenAttributes);
    return r;
  }
  static createRoot(e, n) {
    return new Xs(null, new Nk(null, e), n);
  }
  static createRootAndLookUpScopeName(e, n, r) {
    const o = r.getMetadataForScope(e), i = new Nk(null, e), s = r.themeProvider.themeMatch(i), a = Xs.mergeAttributes(
      n,
      o,
      s
    );
    return new Xs(null, i, a);
  }
  get scopeName() {
    return this.scopePath.scopeName;
  }
  toString() {
    return this.getScopeNames().join(" ");
  }
  equals(e) {
    return Xs.equals(this, e);
  }
  static equals(e, n) {
    do {
      if (e === n || !e && !n)
        return !0;
      if (!e || !n || e.scopeName !== n.scopeName || e.tokenAttributes !== n.tokenAttributes)
        return !1;
      e = e.parent, n = n.parent;
    } while (!0);
  }
  static mergeAttributes(e, n, r) {
    let o = -1, i = 0, s = 0;
    return r !== null && (o = r.fontStyle, i = r.foregroundId, s = r.backgroundId), op.set(
      e,
      n.languageId,
      n.tokenType,
      null,
      o,
      i,
      s
    );
  }
  pushAttributed(e, n) {
    if (e === null)
      return this;
    if (e.indexOf(" ") === -1)
      return Xs._pushAttributed(this, e, n);
    const r = e.split(/ /g);
    let o = this;
    for (const i of r)
      o = Xs._pushAttributed(o, i, n);
    return o;
  }
  static _pushAttributed(e, n, r) {
    const o = r.getMetadataForScope(n), i = e.scopePath.push(n), s = r.themeProvider.themeMatch(i), a = Xs.mergeAttributes(
      e.tokenAttributes,
      o,
      s
    );
    return new Xs(e, i, a);
  }
  getScopeNames() {
    return this.scopePath.getSegments();
  }
  getExtensionIfDefined(e) {
    const n = [];
    let r = this;
    for (; r && r !== e; )
      n.push({
        encodedTokenAttributes: r.tokenAttributes,
        scopeNames: r.scopePath.getExtensionIfDefined(r.parent?.scopePath ?? null)
      }), r = r.parent;
    return r === e ? n.reverse() : void 0;
  }
}, Fa, XN = (Fa = class {
  /**
   * Invariant:
   * ```
   * if (contentNameScopesList !== nameScopesList && contentNameScopesList?.parent !== nameScopesList) {
   * 	throw new Error();
   * }
   * if (this.parent && !nameScopesList.extends(this.parent.contentNameScopesList)) {
   * 	throw new Error();
   * }
   * ```
   */
  constructor(t, e, n, r, o, i, s, a) {
    ue(this, "_stackElementBrand"), ue(this, "_enterPos"), ue(this, "_anchorPos"), ue(this, "depth"), this.parent = t, this.ruleId = e, this.beginRuleCapturedEOL = o, this.endRule = i, this.nameScopesList = s, this.contentNameScopesList = a, this.depth = this.parent ? this.parent.depth + 1 : 1, this._enterPos = n, this._anchorPos = r;
  }
  equals(t) {
    return t === null ? !1 : Fa._equals(this, t);
  }
  static _equals(t, e) {
    return t === e ? !0 : this._structuralEquals(t, e) ? s0.equals(t.contentNameScopesList, e.contentNameScopesList) : !1;
  }
  /**
   * A structural equals check. Does not take into account `scopes`.
   */
  static _structuralEquals(t, e) {
    do {
      if (t === e || !t && !e)
        return !0;
      if (!t || !e || t.depth !== e.depth || t.ruleId !== e.ruleId || t.endRule !== e.endRule)
        return !1;
      t = t.parent, e = e.parent;
    } while (!0);
  }
  clone() {
    return this;
  }
  static _reset(t) {
    for (; t; )
      t._enterPos = -1, t._anchorPos = -1, t = t.parent;
  }
  reset() {
    Fa._reset(this);
  }
  pop() {
    return this.parent;
  }
  safePop() {
    return this.parent ? this.parent : this;
  }
  push(t, e, n, r, o, i, s) {
    return new Fa(
      this,
      t,
      e,
      n,
      r,
      o,
      i,
      s
    );
  }
  getEnterPos() {
    return this._enterPos;
  }
  getAnchorPos() {
    return this._anchorPos;
  }
  getRule(t) {
    return t.getRule(this.ruleId);
  }
  toString() {
    const t = [];
    return this._writeString(t, 0), "[" + t.join(",") + "]";
  }
  _writeString(t, e) {
    return this.parent && (e = this.parent._writeString(t, e)), t[e++] = `(${this.ruleId}, ${this.nameScopesList?.toString()}, ${this.contentNameScopesList?.toString()})`, e;
  }
  withContentNameScopesList(t) {
    return this.contentNameScopesList === t ? this : this.parent.push(
      this.ruleId,
      this._enterPos,
      this._anchorPos,
      this.beginRuleCapturedEOL,
      this.endRule,
      this.nameScopesList,
      t
    );
  }
  withEndRule(t) {
    return this.endRule === t ? this : new Fa(
      this.parent,
      this.ruleId,
      this._enterPos,
      this._anchorPos,
      this.beginRuleCapturedEOL,
      t,
      this.nameScopesList,
      this.contentNameScopesList
    );
  }
  // Used to warn of endless loops
  hasSameRuleAs(t) {
    let e = this;
    for (; e && e._enterPos === t._enterPos; ) {
      if (e.ruleId === t.ruleId)
        return !0;
      e = e.parent;
    }
    return !1;
  }
  toStateStackFrame() {
    return {
      ruleId: this.ruleId,
      beginRuleCapturedEOL: this.beginRuleCapturedEOL,
      endRule: this.endRule,
      nameScopesList: this.nameScopesList?.getExtensionIfDefined(this.parent?.nameScopesList ?? null) ?? [],
      contentNameScopesList: this.contentNameScopesList?.getExtensionIfDefined(this.nameScopesList) ?? []
    };
  }
  static pushFrame(t, e) {
    const n = s0.fromExtension(t?.nameScopesList ?? null, e.nameScopesList);
    return new Fa(
      t,
      e.ruleId,
      e.enterPos ?? -1,
      e.anchorPos ?? -1,
      e.beginRuleCapturedEOL,
      e.endRule,
      n,
      s0.fromExtension(n, e.contentNameScopesList)
    );
  }
}, // TODO remove me
ue(Fa, "NULL", new Fa(
  null,
  0,
  0,
  0,
  !1,
  null,
  null,
  null
)), Fa), QGe = class {
  constructor(t, e) {
    ue(this, "balancedBracketScopes"), ue(this, "unbalancedBracketScopes"), ue(this, "allowAny", !1), this.balancedBracketScopes = t.flatMap(
      (n) => n === "*" ? (this.allowAny = !0, []) : Gx(n, Xx).map((r) => r.matcher)
    ), this.unbalancedBracketScopes = e.flatMap(
      (n) => Gx(n, Xx).map((r) => r.matcher)
    );
  }
  get matchesAlways() {
    return this.allowAny && this.unbalancedBracketScopes.length === 0;
  }
  get matchesNever() {
    return this.balancedBracketScopes.length === 0 && !this.allowAny;
  }
  match(t) {
    for (const e of this.unbalancedBracketScopes)
      if (e(t))
        return !1;
    for (const e of this.balancedBracketScopes)
      if (e(t))
        return !0;
    return this.allowAny;
  }
}, ZGe = class {
  constructor(t, e, n, r) {
    ue(this, "_emitBinaryTokens"), ue(this, "_lineText"), ue(this, "_tokens"), ue(this, "_binaryTokens"), ue(this, "_lastTokenEndIndex"), ue(this, "_tokenTypeOverrides"), this.balancedBracketSelectors = r, this._emitBinaryTokens = t, this._tokenTypeOverrides = n, this._lineText = null, this._tokens = [], this._binaryTokens = [], this._lastTokenEndIndex = 0;
  }
  produce(t, e) {
    this.produceFromScopes(t.contentNameScopesList, e);
  }
  produceFromScopes(t, e) {
    if (this._lastTokenEndIndex >= e)
      return;
    if (this._emitBinaryTokens) {
      let r = t?.tokenAttributes ?? 0, o = !1;
      if (this.balancedBracketSelectors?.matchesAlways && (o = !0), this._tokenTypeOverrides.length > 0 || this.balancedBracketSelectors && !this.balancedBracketSelectors.matchesAlways && !this.balancedBracketSelectors.matchesNever) {
        const i = t?.getScopeNames() ?? [];
        for (const s of this._tokenTypeOverrides)
          s.matcher(i) && (r = op.set(
            r,
            0,
            s.type,
            null,
            -1,
            0,
            0
          ));
        this.balancedBracketSelectors && (o = this.balancedBracketSelectors.match(i));
      }
      if (o && (r = op.set(
        r,
        0,
        8,
        o,
        -1,
        0,
        0
      )), this._binaryTokens.length > 0 && this._binaryTokens[this._binaryTokens.length - 1] === r) {
        this._lastTokenEndIndex = e;
        return;
      }
      this._binaryTokens.push(this._lastTokenEndIndex), this._binaryTokens.push(r), this._lastTokenEndIndex = e;
      return;
    }
    const n = t?.getScopeNames() ?? [];
    this._tokens.push({
      startIndex: this._lastTokenEndIndex,
      endIndex: e,
      // value: lineText.substring(lastTokenEndIndex, endIndex),
      scopes: n
    }), this._lastTokenEndIndex = e;
  }
  getResult(t, e) {
    return this._tokens.length > 0 && this._tokens[this._tokens.length - 1].startIndex === e - 1 && this._tokens.pop(), this._tokens.length === 0 && (this._lastTokenEndIndex = -1, this.produce(t, e), this._tokens[this._tokens.length - 1].startIndex = 0), this._tokens;
  }
  getBinaryResult(t, e) {
    this._binaryTokens.length > 0 && this._binaryTokens[this._binaryTokens.length - 2] === e - 1 && (this._binaryTokens.pop(), this._binaryTokens.pop()), this._binaryTokens.length === 0 && (this._lastTokenEndIndex = -1, this.produce(t, e), this._binaryTokens[this._binaryTokens.length - 2] = 0);
    const n = new Uint32Array(this._binaryTokens.length);
    for (let r = 0, o = this._binaryTokens.length; r < o; r++)
      n[r] = this._binaryTokens[r];
    return n;
  }
}, JGe = class {
  constructor(t, e) {
    ue(this, "_grammars", /* @__PURE__ */ new Map()), ue(this, "_rawGrammars", /* @__PURE__ */ new Map()), ue(this, "_injectionGrammars", /* @__PURE__ */ new Map()), ue(this, "_theme"), this._onigLib = e, this._theme = t;
  }
  dispose() {
    for (const t of this._grammars.values())
      t.dispose();
  }
  setTheme(t) {
    this._theme = t;
  }
  getColorMap() {
    return this._theme.getColorMap();
  }
  /**
   * Add `grammar` to registry and return a list of referenced scope names
   */
  addGrammar(t, e) {
    this._rawGrammars.set(t.scopeName, t), e && this._injectionGrammars.set(t.scopeName, e);
  }
  /**
   * Lookup a raw grammar.
   */
  lookup(t) {
    return this._rawGrammars.get(t);
  }
  /**
   * Returns the injections for the given grammar
   */
  injections(t) {
    return this._injectionGrammars.get(t);
  }
  /**
   * Get the default theme settings
   */
  getDefaults() {
    return this._theme.getDefaults();
  }
  /**
   * Match a scope in the theme.
   */
  themeMatch(t) {
    return this._theme.match(t);
  }
  /**
   * Lookup a grammar.
   */
  grammarForScopeName(t, e, n, r, o) {
    if (!this._grammars.has(t)) {
      let i = this._rawGrammars.get(t);
      if (!i)
        return null;
      this._grammars.set(t, YGe(
        t,
        i,
        e,
        n,
        r,
        o,
        this,
        this._onigLib
      ));
    }
    return this._grammars.get(t);
  }
}, eYe = class {
  constructor(t) {
    ue(this, "_options"), ue(this, "_syncRegistry"), ue(this, "_ensureGrammarCache"), this._options = t, this._syncRegistry = new JGe(
      Wx.createFromRawTheme(t.theme, t.colorMap),
      t.onigLib
    ), this._ensureGrammarCache = /* @__PURE__ */ new Map();
  }
  dispose() {
    this._syncRegistry.dispose();
  }
  /**
   * Change the theme. Once called, no previous `ruleStack` should be used anymore.
   */
  setTheme(t, e) {
    this._syncRegistry.setTheme(Wx.createFromRawTheme(t, e));
  }
  /**
   * Returns a lookup array for color ids.
   */
  getColorMap() {
    return this._syncRegistry.getColorMap();
  }
  /**
   * Load the grammar for `scopeName` and all referenced included grammars asynchronously.
   * Please do not use language id 0.
   */
  loadGrammarWithEmbeddedLanguages(t, e, n) {
    return this.loadGrammarWithConfiguration(t, e, { embeddedLanguages: n });
  }
  /**
   * Load the grammar for `scopeName` and all referenced included grammars asynchronously.
   * Please do not use language id 0.
   */
  loadGrammarWithConfiguration(t, e, n) {
    return this._loadGrammar(
      t,
      e,
      n.embeddedLanguages,
      n.tokenTypes,
      new QGe(
        n.balancedBracketSelectors || [],
        n.unbalancedBracketSelectors || []
      )
    );
  }
  /**
   * Load the grammar for `scopeName` and all referenced included grammars asynchronously.
   */
  loadGrammar(t) {
    return this._loadGrammar(t, 0, null, null, null);
  }
  _loadGrammar(t, e, n, r, o) {
    const i = new TGe(this._syncRegistry, t);
    for (; i.Q.length > 0; )
      i.Q.map((s) => this._loadSingleGrammar(s.scopeName)), i.processQueue();
    return this._grammarForScopeName(
      t,
      e,
      n,
      r,
      o
    );
  }
  _loadSingleGrammar(t) {
    this._ensureGrammarCache.has(t) || (this._doLoadSingleGrammar(t), this._ensureGrammarCache.set(t, !0));
  }
  _doLoadSingleGrammar(t) {
    const e = this._options.loadGrammar(t);
    if (e) {
      const n = typeof this._options.getInjections == "function" ? this._options.getInjections(t) : void 0;
      this._syncRegistry.addGrammar(e, n);
    }
  }
  /**
   * Adds a rawGrammar.
   */
  addGrammar(t, e = [], n = 0, r = null) {
    return this._syncRegistry.addGrammar(t, e), this._grammarForScopeName(t.scopeName, n, r);
  }
  /**
   * Get the grammar for `scopeName`. The grammar must first be created via `loadGrammar` or `addGrammar`.
   */
  _grammarForScopeName(t, e = 0, n = null, r = null, o = null) {
    return this._syncRegistry.grammarForScopeName(
      t,
      e,
      n,
      r,
      o
    );
  }
}, QN = XN.NULL;
const tYe = [
  "area",
  "base",
  "basefont",
  "bgsound",
  "br",
  "col",
  "command",
  "embed",
  "frame",
  "hr",
  "image",
  "img",
  "input",
  "keygen",
  "link",
  "meta",
  "param",
  "source",
  "track",
  "wbr"
];
class Ev {
  /**
   * @constructor
   * @param {Properties} property
   * @param {Normal} normal
   * @param {string} [space]
   */
  constructor(e, n, r) {
    this.property = e, this.normal = n, r && (this.space = r);
  }
}
Ev.prototype.property = {};
Ev.prototype.normal = {};
Ev.prototype.space = null;
function kpe(t, e) {
  const n = {}, r = {};
  let o = -1;
  for (; ++o < t.length; )
    Object.assign(n, t[o].property), Object.assign(r, t[o].normal);
  return new Ev(n, r, e);
}
function ZN(t) {
  return t.toLowerCase();
}
let ls = class {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   */
  constructor(e, n) {
    this.property = e, this.attribute = n;
  }
};
ls.prototype.space = null;
ls.prototype.boolean = !1;
ls.prototype.booleanish = !1;
ls.prototype.overloadedBoolean = !1;
ls.prototype.number = !1;
ls.prototype.commaSeparated = !1;
ls.prototype.spaceSeparated = !1;
ls.prototype.commaOrSpaceSeparated = !1;
ls.prototype.mustUseProperty = !1;
ls.prototype.defined = !1;
let nYe = 0;
const St = Kd(), Er = Kd(), Ape = Kd(), ze = Kd(), Fn = Kd(), xh = Kd(), ci = Kd();
function Kd() {
  return 2 ** ++nYe;
}
const JN = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean: St,
  booleanish: Er,
  commaOrSpaceSeparated: ci,
  commaSeparated: xh,
  number: ze,
  overloadedBoolean: Ape,
  spaceSeparated: Fn
}, Symbol.toStringTag, { value: "Module" })), Lk = Object.keys(JN);
class VL extends ls {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number|null} [mask]
   * @param {string} [space]
   */
  constructor(e, n, r, o) {
    let i = -1;
    if (super(e, n), Fq(this, "space", o), typeof r == "number")
      for (; ++i < Lk.length; ) {
        const s = Lk[i];
        Fq(this, Lk[i], (r & JN[s]) === JN[s]);
      }
  }
}
VL.prototype.defined = !0;
function Fq(t, e, n) {
  n && (t[e] = n);
}
const rYe = {}.hasOwnProperty;
function Tp(t) {
  const e = {}, n = {};
  let r;
  for (r in t.properties)
    if (rYe.call(t.properties, r)) {
      const o = t.properties[r], i = new VL(
        r,
        t.transform(t.attributes || {}, r),
        o,
        t.space
      );
      t.mustUseProperty && t.mustUseProperty.includes(r) && (i.mustUseProperty = !0), e[r] = i, n[ZN(r)] = r, n[ZN(i.attribute)] = r;
    }
  return new Ev(e, n, t.space);
}
const Tpe = Tp({
  space: "xlink",
  transform(t, e) {
    return "xlink:" + e.slice(5).toLowerCase();
  },
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  }
}), Rpe = Tp({
  space: "xml",
  transform(t, e) {
    return "xml:" + e.slice(3).toLowerCase();
  },
  properties: { xmlLang: null, xmlBase: null, xmlSpace: null }
});
function Ppe(t, e) {
  return e in t ? t[e] : e;
}
function $pe(t, e) {
  return Ppe(t, e.toLowerCase());
}
const Mpe = Tp({
  space: "xmlns",
  attributes: { xmlnsxlink: "xmlns:xlink" },
  transform: $pe,
  properties: { xmlns: null, xmlnsXLink: null }
}), Dpe = Tp({
  transform(t, e) {
    return e === "role" ? e : "aria-" + e.slice(4).toLowerCase();
  },
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: Er,
    ariaAutoComplete: null,
    ariaBusy: Er,
    ariaChecked: Er,
    ariaColCount: ze,
    ariaColIndex: ze,
    ariaColSpan: ze,
    ariaControls: Fn,
    ariaCurrent: null,
    ariaDescribedBy: Fn,
    ariaDetails: null,
    ariaDisabled: Er,
    ariaDropEffect: Fn,
    ariaErrorMessage: null,
    ariaExpanded: Er,
    ariaFlowTo: Fn,
    ariaGrabbed: Er,
    ariaHasPopup: null,
    ariaHidden: Er,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: Fn,
    ariaLevel: ze,
    ariaLive: null,
    ariaModal: Er,
    ariaMultiLine: Er,
    ariaMultiSelectable: Er,
    ariaOrientation: null,
    ariaOwns: Fn,
    ariaPlaceholder: null,
    ariaPosInSet: ze,
    ariaPressed: Er,
    ariaReadOnly: Er,
    ariaRelevant: null,
    ariaRequired: Er,
    ariaRoleDescription: Fn,
    ariaRowCount: ze,
    ariaRowIndex: ze,
    ariaRowSpan: ze,
    ariaSelected: Er,
    ariaSetSize: ze,
    ariaSort: null,
    ariaValueMax: ze,
    ariaValueMin: ze,
    ariaValueNow: ze,
    ariaValueText: null,
    role: null
  }
}), oYe = Tp({
  space: "html",
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  transform: $pe,
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: xh,
    acceptCharset: Fn,
    accessKey: Fn,
    action: null,
    allow: null,
    allowFullScreen: St,
    allowPaymentRequest: St,
    allowUserMedia: St,
    alt: null,
    as: null,
    async: St,
    autoCapitalize: null,
    autoComplete: Fn,
    autoFocus: St,
    autoPlay: St,
    blocking: Fn,
    capture: null,
    charSet: null,
    checked: St,
    cite: null,
    className: Fn,
    cols: ze,
    colSpan: null,
    content: null,
    contentEditable: Er,
    controls: St,
    controlsList: Fn,
    coords: ze | xh,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: St,
    defer: St,
    dir: null,
    dirName: null,
    disabled: St,
    download: Ape,
    draggable: Er,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: St,
    formTarget: null,
    headers: Fn,
    height: ze,
    hidden: St,
    high: ze,
    href: null,
    hrefLang: null,
    htmlFor: Fn,
    httpEquiv: Fn,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: St,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: St,
    itemId: null,
    itemProp: Fn,
    itemRef: Fn,
    itemScope: St,
    itemType: Fn,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: St,
    low: ze,
    manifest: null,
    max: null,
    maxLength: ze,
    media: null,
    method: null,
    min: null,
    minLength: ze,
    multiple: St,
    muted: St,
    name: null,
    nonce: null,
    noModule: St,
    noValidate: St,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: St,
    optimum: ze,
    pattern: null,
    ping: Fn,
    placeholder: null,
    playsInline: St,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: St,
    referrerPolicy: null,
    rel: Fn,
    required: St,
    reversed: St,
    rows: ze,
    rowSpan: ze,
    sandbox: Fn,
    scope: null,
    scoped: St,
    seamless: St,
    selected: St,
    shadowRootClonable: St,
    shadowRootDelegatesFocus: St,
    shadowRootMode: null,
    shape: null,
    size: ze,
    sizes: null,
    slot: null,
    span: ze,
    spellCheck: Er,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: ze,
    step: null,
    style: null,
    tabIndex: ze,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: St,
    useMap: null,
    value: Er,
    width: ze,
    wrap: null,
    writingSuggestions: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: Fn,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: ze,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: ze,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: St,
    // Lists. Use CSS to reduce space between items instead
    declare: St,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: ze,
    // `<img>` and `<object>`
    leftMargin: ze,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: ze,
    // `<body>`
    marginWidth: ze,
    // `<body>`
    noResize: St,
    // `<frame>`
    noHref: St,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: St,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: St,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: ze,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: Er,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: ze,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: ze,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: St,
    disableRemotePlayback: St,
    prefix: null,
    property: null,
    results: ze,
    security: null,
    unselectable: null
  }
}), iYe = Tp({
  space: "svg",
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    transformOrigin: "transform-origin",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  transform: Ppe,
  properties: {
    about: ci,
    accentHeight: ze,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: ze,
    amplitude: ze,
    arabicForm: null,
    ascent: ze,
    attributeName: null,
    attributeType: null,
    azimuth: ze,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: ze,
    by: null,
    calcMode: null,
    capHeight: ze,
    className: Fn,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: ze,
    diffuseConstant: ze,
    direction: null,
    display: null,
    dur: null,
    divisor: ze,
    dominantBaseline: null,
    download: St,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: ze,
    enableBackground: null,
    end: null,
    event: null,
    exponent: ze,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: ze,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: xh,
    g2: xh,
    glyphName: xh,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: ze,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: ze,
    horizOriginX: ze,
    horizOriginY: ze,
    id: null,
    ideographic: ze,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: ze,
    k: ze,
    k1: ze,
    k2: ze,
    k3: ze,
    k4: ze,
    kernelMatrix: ci,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: ze,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: ze,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: ze,
    overlineThickness: ze,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: ze,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: Fn,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: ze,
    pointsAtY: ze,
    pointsAtZ: ze,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: ci,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: ci,
    rev: ci,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: ci,
    requiredFeatures: ci,
    requiredFonts: ci,
    requiredFormats: ci,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: ze,
    specularExponent: ze,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: ze,
    strikethroughThickness: ze,
    string: null,
    stroke: null,
    strokeDashArray: ci,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: ze,
    strokeOpacity: ze,
    strokeWidth: null,
    style: null,
    surfaceScale: ze,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: ci,
    tabIndex: ze,
    tableValues: null,
    target: null,
    targetX: ze,
    targetY: ze,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: ci,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: ze,
    underlineThickness: ze,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: ze,
    values: null,
    vAlphabetic: ze,
    vMathematical: ze,
    vectorEffect: null,
    vHanging: ze,
    vIdeographic: ze,
    version: null,
    vertAdvY: ze,
    vertOriginX: ze,
    vertOriginY: ze,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: ze,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  }
}), sYe = /^data[-\w.:]+$/i, Bq = /-[a-z]/g, aYe = /[A-Z]/g;
function lYe(t, e) {
  const n = ZN(e);
  let r = e, o = ls;
  if (n in t.normal)
    return t.property[t.normal[n]];
  if (n.length > 4 && n.slice(0, 4) === "data" && sYe.test(e)) {
    if (e.charAt(4) === "-") {
      const i = e.slice(5).replace(Bq, uYe);
      r = "data" + i.charAt(0).toUpperCase() + i.slice(1);
    } else {
      const i = e.slice(4);
      if (!Bq.test(i)) {
        let s = i.replace(aYe, cYe);
        s.charAt(0) !== "-" && (s = "-" + s), e = "data" + s;
      }
    }
    o = VL;
  }
  return new o(r, e);
}
function cYe(t) {
  return "-" + t.toLowerCase();
}
function uYe(t) {
  return t.charAt(1).toUpperCase();
}
const dYe = kpe([Rpe, Tpe, Mpe, Dpe, oYe], "html"), Ipe = kpe([Rpe, Tpe, Mpe, Dpe, iYe], "svg"), zq = {}.hasOwnProperty;
function fYe(t, e) {
  const n = e || {};
  function r(o, ...i) {
    let s = r.invalid;
    const a = r.handlers;
    if (o && zq.call(o, t)) {
      const l = String(o[t]);
      s = zq.call(a, l) ? a[l] : r.unknown;
    }
    if (s)
      return s.call(this, o, ...i);
  }
  return r.handlers = n.handlers || {}, r.invalid = n.invalid, r.unknown = n.unknown, r;
}
const hYe = /["&'<>`]/g, pYe = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g, mYe = (
  // eslint-disable-next-line no-control-regex, unicorn/no-hex-escape
  /[\x01-\t\v\f\x0E-\x1F\x7F\x81\x8D\x8F\x90\x9D\xA0-\uFFFF]/g
), gYe = /[|\\{}()[\]^$+*?.]/g, qq = /* @__PURE__ */ new WeakMap();
function yYe(t, e) {
  if (t = t.replace(
    e.subset ? vYe(e.subset) : hYe,
    r
  ), e.subset || e.escapeOnly)
    return t;
  return t.replace(pYe, n).replace(mYe, r);
  function n(o, i, s) {
    return e.format(
      (o.charCodeAt(0) - 55296) * 1024 + o.charCodeAt(1) - 56320 + 65536,
      s.charCodeAt(i + 2),
      e
    );
  }
  function r(o, i, s) {
    return e.format(
      o.charCodeAt(0),
      s.charCodeAt(i + 1),
      e
    );
  }
}
function vYe(t) {
  let e = qq.get(t);
  return e || (e = bYe(t), qq.set(t, e)), e;
}
function bYe(t) {
  const e = [];
  let n = -1;
  for (; ++n < t.length; )
    e.push(t[n].replace(gYe, "\\$&"));
  return new RegExp("(?:" + e.join("|") + ")", "g");
}
const _Ye = /[\dA-Fa-f]/;
function wYe(t, e, n) {
  const r = "&#x" + t.toString(16).toUpperCase();
  return n && e && !_Ye.test(String.fromCharCode(e)) ? r : r + ";";
}
const xYe = /\d/;
function EYe(t, e, n) {
  const r = "&#" + String(t);
  return n && e && !xYe.test(String.fromCharCode(e)) ? r : r + ";";
}
const SYe = [
  "AElig",
  "AMP",
  "Aacute",
  "Acirc",
  "Agrave",
  "Aring",
  "Atilde",
  "Auml",
  "COPY",
  "Ccedil",
  "ETH",
  "Eacute",
  "Ecirc",
  "Egrave",
  "Euml",
  "GT",
  "Iacute",
  "Icirc",
  "Igrave",
  "Iuml",
  "LT",
  "Ntilde",
  "Oacute",
  "Ocirc",
  "Ograve",
  "Oslash",
  "Otilde",
  "Ouml",
  "QUOT",
  "REG",
  "THORN",
  "Uacute",
  "Ucirc",
  "Ugrave",
  "Uuml",
  "Yacute",
  "aacute",
  "acirc",
  "acute",
  "aelig",
  "agrave",
  "amp",
  "aring",
  "atilde",
  "auml",
  "brvbar",
  "ccedil",
  "cedil",
  "cent",
  "copy",
  "curren",
  "deg",
  "divide",
  "eacute",
  "ecirc",
  "egrave",
  "eth",
  "euml",
  "frac12",
  "frac14",
  "frac34",
  "gt",
  "iacute",
  "icirc",
  "iexcl",
  "igrave",
  "iquest",
  "iuml",
  "laquo",
  "lt",
  "macr",
  "micro",
  "middot",
  "nbsp",
  "not",
  "ntilde",
  "oacute",
  "ocirc",
  "ograve",
  "ordf",
  "ordm",
  "oslash",
  "otilde",
  "ouml",
  "para",
  "plusmn",
  "pound",
  "quot",
  "raquo",
  "reg",
  "sect",
  "shy",
  "sup1",
  "sup2",
  "sup3",
  "szlig",
  "thorn",
  "times",
  "uacute",
  "ucirc",
  "ugrave",
  "uml",
  "uuml",
  "yacute",
  "yen",
  "yuml"
], Fk = {
  nbsp: " ",
  iexcl: "¡",
  cent: "¢",
  pound: "£",
  curren: "¤",
  yen: "¥",
  brvbar: "¦",
  sect: "§",
  uml: "¨",
  copy: "©",
  ordf: "ª",
  laquo: "«",
  not: "¬",
  shy: "­",
  reg: "®",
  macr: "¯",
  deg: "°",
  plusmn: "±",
  sup2: "²",
  sup3: "³",
  acute: "´",
  micro: "µ",
  para: "¶",
  middot: "·",
  cedil: "¸",
  sup1: "¹",
  ordm: "º",
  raquo: "»",
  frac14: "¼",
  frac12: "½",
  frac34: "¾",
  iquest: "¿",
  Agrave: "À",
  Aacute: "Á",
  Acirc: "Â",
  Atilde: "Ã",
  Auml: "Ä",
  Aring: "Å",
  AElig: "Æ",
  Ccedil: "Ç",
  Egrave: "È",
  Eacute: "É",
  Ecirc: "Ê",
  Euml: "Ë",
  Igrave: "Ì",
  Iacute: "Í",
  Icirc: "Î",
  Iuml: "Ï",
  ETH: "Ð",
  Ntilde: "Ñ",
  Ograve: "Ò",
  Oacute: "Ó",
  Ocirc: "Ô",
  Otilde: "Õ",
  Ouml: "Ö",
  times: "×",
  Oslash: "Ø",
  Ugrave: "Ù",
  Uacute: "Ú",
  Ucirc: "Û",
  Uuml: "Ü",
  Yacute: "Ý",
  THORN: "Þ",
  szlig: "ß",
  agrave: "à",
  aacute: "á",
  acirc: "â",
  atilde: "ã",
  auml: "ä",
  aring: "å",
  aelig: "æ",
  ccedil: "ç",
  egrave: "è",
  eacute: "é",
  ecirc: "ê",
  euml: "ë",
  igrave: "ì",
  iacute: "í",
  icirc: "î",
  iuml: "ï",
  eth: "ð",
  ntilde: "ñ",
  ograve: "ò",
  oacute: "ó",
  ocirc: "ô",
  otilde: "õ",
  ouml: "ö",
  divide: "÷",
  oslash: "ø",
  ugrave: "ù",
  uacute: "ú",
  ucirc: "û",
  uuml: "ü",
  yacute: "ý",
  thorn: "þ",
  yuml: "ÿ",
  fnof: "ƒ",
  Alpha: "Α",
  Beta: "Β",
  Gamma: "Γ",
  Delta: "Δ",
  Epsilon: "Ε",
  Zeta: "Ζ",
  Eta: "Η",
  Theta: "Θ",
  Iota: "Ι",
  Kappa: "Κ",
  Lambda: "Λ",
  Mu: "Μ",
  Nu: "Ν",
  Xi: "Ξ",
  Omicron: "Ο",
  Pi: "Π",
  Rho: "Ρ",
  Sigma: "Σ",
  Tau: "Τ",
  Upsilon: "Υ",
  Phi: "Φ",
  Chi: "Χ",
  Psi: "Ψ",
  Omega: "Ω",
  alpha: "α",
  beta: "β",
  gamma: "γ",
  delta: "δ",
  epsilon: "ε",
  zeta: "ζ",
  eta: "η",
  theta: "θ",
  iota: "ι",
  kappa: "κ",
  lambda: "λ",
  mu: "μ",
  nu: "ν",
  xi: "ξ",
  omicron: "ο",
  pi: "π",
  rho: "ρ",
  sigmaf: "ς",
  sigma: "σ",
  tau: "τ",
  upsilon: "υ",
  phi: "φ",
  chi: "χ",
  psi: "ψ",
  omega: "ω",
  thetasym: "ϑ",
  upsih: "ϒ",
  piv: "ϖ",
  bull: "•",
  hellip: "…",
  prime: "′",
  Prime: "″",
  oline: "‾",
  frasl: "⁄",
  weierp: "℘",
  image: "ℑ",
  real: "ℜ",
  trade: "™",
  alefsym: "ℵ",
  larr: "←",
  uarr: "↑",
  rarr: "→",
  darr: "↓",
  harr: "↔",
  crarr: "↵",
  lArr: "⇐",
  uArr: "⇑",
  rArr: "⇒",
  dArr: "⇓",
  hArr: "⇔",
  forall: "∀",
  part: "∂",
  exist: "∃",
  empty: "∅",
  nabla: "∇",
  isin: "∈",
  notin: "∉",
  ni: "∋",
  prod: "∏",
  sum: "∑",
  minus: "−",
  lowast: "∗",
  radic: "√",
  prop: "∝",
  infin: "∞",
  ang: "∠",
  and: "∧",
  or: "∨",
  cap: "∩",
  cup: "∪",
  int: "∫",
  there4: "∴",
  sim: "∼",
  cong: "≅",
  asymp: "≈",
  ne: "≠",
  equiv: "≡",
  le: "≤",
  ge: "≥",
  sub: "⊂",
  sup: "⊃",
  nsub: "⊄",
  sube: "⊆",
  supe: "⊇",
  oplus: "⊕",
  otimes: "⊗",
  perp: "⊥",
  sdot: "⋅",
  lceil: "⌈",
  rceil: "⌉",
  lfloor: "⌊",
  rfloor: "⌋",
  lang: "〈",
  rang: "〉",
  loz: "◊",
  spades: "♠",
  clubs: "♣",
  hearts: "♥",
  diams: "♦",
  quot: '"',
  amp: "&",
  lt: "<",
  gt: ">",
  OElig: "Œ",
  oelig: "œ",
  Scaron: "Š",
  scaron: "š",
  Yuml: "Ÿ",
  circ: "ˆ",
  tilde: "˜",
  ensp: " ",
  emsp: " ",
  thinsp: " ",
  zwnj: "‌",
  zwj: "‍",
  lrm: "‎",
  rlm: "‏",
  ndash: "–",
  mdash: "—",
  lsquo: "‘",
  rsquo: "’",
  sbquo: "‚",
  ldquo: "“",
  rdquo: "”",
  bdquo: "„",
  dagger: "†",
  Dagger: "‡",
  permil: "‰",
  lsaquo: "‹",
  rsaquo: "›",
  euro: "€"
}, OYe = [
  "cent",
  "copy",
  "divide",
  "gt",
  "lt",
  "not",
  "para",
  "times"
], Npe = {}.hasOwnProperty, ej = {};
let Jb;
for (Jb in Fk)
  Npe.call(Fk, Jb) && (ej[Fk[Jb]] = Jb);
const CYe = /[^\dA-Za-z]/;
function kYe(t, e, n, r) {
  const o = String.fromCharCode(t);
  if (Npe.call(ej, o)) {
    const i = ej[o], s = "&" + i;
    return n && SYe.includes(i) && !OYe.includes(i) && (!r || e && e !== 61 && CYe.test(String.fromCharCode(e))) ? s : s + ";";
  }
  return "";
}
function AYe(t, e, n) {
  let r = wYe(t, e, n.omitOptionalSemicolons), o;
  if ((n.useNamedReferences || n.useShortestReferences) && (o = kYe(
    t,
    e,
    n.omitOptionalSemicolons,
    n.attribute
  )), (n.useShortestReferences || !o) && n.useShortestReferences) {
    const i = EYe(t, e, n.omitOptionalSemicolons);
    i.length < r.length && (r = i);
  }
  return o && (!n.useShortestReferences || o.length < r.length) ? o : r;
}
function Eh(t, e) {
  return yYe(t, Object.assign({ format: AYe }, e));
}
const TYe = /^>|^->|<!--|-->|--!>|<!-$/g, RYe = [">"], PYe = ["<", ">"];
function $Ye(t, e, n, r) {
  return r.settings.bogusComments ? "<?" + Eh(
    t.value,
    Object.assign({}, r.settings.characterReferences, {
      subset: RYe
    })
  ) + ">" : "<!--" + t.value.replace(TYe, o) + "-->";
  function o(i) {
    return Eh(
      i,
      Object.assign({}, r.settings.characterReferences, {
        subset: PYe
      })
    );
  }
}
function MYe(t, e, n, r) {
  return "<!" + (r.settings.upperDoctype ? "DOCTYPE" : "doctype") + (r.settings.tightDoctype ? "" : " ") + "html>";
}
function Uq(t, e) {
  const n = String(t);
  if (typeof e != "string")
    throw new TypeError("Expected character");
  let r = 0, o = n.indexOf(e);
  for (; o !== -1; )
    r++, o = n.indexOf(e, o + e.length);
  return r;
}
function DYe(t, e) {
  const n = e || {};
  return (t[t.length - 1] === "" ? [...t, ""] : t).join(
    (n.padRight ? " " : "") + "," + (n.padLeft === !1 ? "" : " ")
  ).trim();
}
function IYe(t) {
  return t.join(" ").trim();
}
const NYe = /[ \t\n\f\r]/g;
function WL(t) {
  return typeof t == "object" ? t.type === "text" ? Hq(t.value) : !1 : Hq(t);
}
function Hq(t) {
  return t.replace(NYe, "") === "";
}
const Lr = Lpe(1), jpe = Lpe(-1), jYe = [];
function Lpe(t) {
  return e;
  function e(n, r, o) {
    const i = n ? n.children : jYe;
    let s = (r || 0) + t, a = i[s];
    if (!o)
      for (; a && WL(a); )
        s += t, a = i[s];
    return a;
  }
}
const LYe = {}.hasOwnProperty;
function Fpe(t) {
  return e;
  function e(n, r, o) {
    return LYe.call(t, n.tagName) && t[n.tagName](n, r, o);
  }
}
const GL = Fpe({
  body: BYe,
  caption: Bk,
  colgroup: Bk,
  dd: HYe,
  dt: UYe,
  head: Bk,
  html: FYe,
  li: qYe,
  optgroup: VYe,
  option: WYe,
  p: zYe,
  rp: Vq,
  rt: Vq,
  tbody: YYe,
  td: Wq,
  tfoot: KYe,
  th: Wq,
  thead: GYe,
  tr: XYe
});
function Bk(t, e, n) {
  const r = Lr(n, e, !0);
  return !r || r.type !== "comment" && !(r.type === "text" && WL(r.value.charAt(0)));
}
function FYe(t, e, n) {
  const r = Lr(n, e);
  return !r || r.type !== "comment";
}
function BYe(t, e, n) {
  const r = Lr(n, e);
  return !r || r.type !== "comment";
}
function zYe(t, e, n) {
  const r = Lr(n, e);
  return r ? r.type === "element" && (r.tagName === "address" || r.tagName === "article" || r.tagName === "aside" || r.tagName === "blockquote" || r.tagName === "details" || r.tagName === "div" || r.tagName === "dl" || r.tagName === "fieldset" || r.tagName === "figcaption" || r.tagName === "figure" || r.tagName === "footer" || r.tagName === "form" || r.tagName === "h1" || r.tagName === "h2" || r.tagName === "h3" || r.tagName === "h4" || r.tagName === "h5" || r.tagName === "h6" || r.tagName === "header" || r.tagName === "hgroup" || r.tagName === "hr" || r.tagName === "main" || r.tagName === "menu" || r.tagName === "nav" || r.tagName === "ol" || r.tagName === "p" || r.tagName === "pre" || r.tagName === "section" || r.tagName === "table" || r.tagName === "ul") : !n || // Confusing parent.
  !(n.type === "element" && (n.tagName === "a" || n.tagName === "audio" || n.tagName === "del" || n.tagName === "ins" || n.tagName === "map" || n.tagName === "noscript" || n.tagName === "video"));
}
function qYe(t, e, n) {
  const r = Lr(n, e);
  return !r || r.type === "element" && r.tagName === "li";
}
function UYe(t, e, n) {
  const r = Lr(n, e);
  return !!(r && r.type === "element" && (r.tagName === "dt" || r.tagName === "dd"));
}
function HYe(t, e, n) {
  const r = Lr(n, e);
  return !r || r.type === "element" && (r.tagName === "dt" || r.tagName === "dd");
}
function Vq(t, e, n) {
  const r = Lr(n, e);
  return !r || r.type === "element" && (r.tagName === "rp" || r.tagName === "rt");
}
function VYe(t, e, n) {
  const r = Lr(n, e);
  return !r || r.type === "element" && r.tagName === "optgroup";
}
function WYe(t, e, n) {
  const r = Lr(n, e);
  return !r || r.type === "element" && (r.tagName === "option" || r.tagName === "optgroup");
}
function GYe(t, e, n) {
  const r = Lr(n, e);
  return !!(r && r.type === "element" && (r.tagName === "tbody" || r.tagName === "tfoot"));
}
function YYe(t, e, n) {
  const r = Lr(n, e);
  return !r || r.type === "element" && (r.tagName === "tbody" || r.tagName === "tfoot");
}
function KYe(t, e, n) {
  return !Lr(n, e);
}
function XYe(t, e, n) {
  const r = Lr(n, e);
  return !r || r.type === "element" && r.tagName === "tr";
}
function Wq(t, e, n) {
  const r = Lr(n, e);
  return !r || r.type === "element" && (r.tagName === "td" || r.tagName === "th");
}
const QYe = Fpe({
  body: eKe,
  colgroup: tKe,
  head: JYe,
  html: ZYe,
  tbody: nKe
});
function ZYe(t) {
  const e = Lr(t, -1);
  return !e || e.type !== "comment";
}
function JYe(t) {
  const e = /* @__PURE__ */ new Set();
  for (const r of t.children)
    if (r.type === "element" && (r.tagName === "base" || r.tagName === "title")) {
      if (e.has(r.tagName)) return !1;
      e.add(r.tagName);
    }
  const n = t.children[0];
  return !n || n.type === "element";
}
function eKe(t) {
  const e = Lr(t, -1, !0);
  return !e || e.type !== "comment" && !(e.type === "text" && WL(e.value.charAt(0))) && !(e.type === "element" && (e.tagName === "meta" || e.tagName === "link" || e.tagName === "script" || e.tagName === "style" || e.tagName === "template"));
}
function tKe(t, e, n) {
  const r = jpe(n, e), o = Lr(t, -1, !0);
  return n && r && r.type === "element" && r.tagName === "colgroup" && GL(r, n.children.indexOf(r), n) ? !1 : !!(o && o.type === "element" && o.tagName === "col");
}
function nKe(t, e, n) {
  const r = jpe(n, e), o = Lr(t, -1);
  return n && r && r.type === "element" && (r.tagName === "thead" || r.tagName === "tbody") && GL(r, n.children.indexOf(r), n) ? !1 : !!(o && o.type === "element" && o.tagName === "tr");
}
const e1 = {
  // See: <https://html.spec.whatwg.org/#attribute-name-state>.
  name: [
    [`	
\f\r &/=>`.split(""), `	
\f\r "&'/=>\``.split("")],
    [`\0	
\f\r "&'/<=>`.split(""), `\0	
\f\r "&'/<=>\``.split("")]
  ],
  // See: <https://html.spec.whatwg.org/#attribute-value-(unquoted)-state>.
  unquoted: [
    [`	
\f\r &>`.split(""), `\0	
\f\r "&'<=>\``.split("")],
    [`\0	
\f\r "&'<=>\``.split(""), `\0	
\f\r "&'<=>\``.split("")]
  ],
  // See: <https://html.spec.whatwg.org/#attribute-value-(single-quoted)-state>.
  single: [
    ["&'".split(""), "\"&'`".split("")],
    ["\0&'".split(""), "\0\"&'`".split("")]
  ],
  // See: <https://html.spec.whatwg.org/#attribute-value-(double-quoted)-state>.
  double: [
    ['"&'.split(""), "\"&'`".split("")],
    ['\0"&'.split(""), "\0\"&'`".split("")]
  ]
};
function rKe(t, e, n, r) {
  const o = r.schema, i = o.space === "svg" ? !1 : r.settings.omitOptionalTags;
  let s = o.space === "svg" ? r.settings.closeEmptyElements : r.settings.voids.includes(t.tagName.toLowerCase());
  const a = [];
  let l;
  o.space === "html" && t.tagName === "svg" && (r.schema = Ipe);
  const c = oKe(r, t.properties), u = r.all(
    o.space === "html" && t.tagName === "template" ? t.content : t
  );
  return r.schema = o, u && (s = !1), (c || !i || !QYe(t, e, n)) && (a.push("<", t.tagName, c ? " " + c : ""), s && (o.space === "svg" || r.settings.closeSelfClosing) && (l = c.charAt(c.length - 1), (!r.settings.tightSelfClosing || l === "/" || l && l !== '"' && l !== "'") && a.push(" "), a.push("/")), a.push(">")), a.push(u), !s && (!i || !GL(t, e, n)) && a.push("</" + t.tagName + ">"), a.join("");
}
function oKe(t, e) {
  const n = [];
  let r = -1, o;
  if (e) {
    for (o in e)
      if (e[o] !== null && e[o] !== void 0) {
        const i = iKe(t, o, e[o]);
        i && n.push(i);
      }
  }
  for (; ++r < n.length; ) {
    const i = t.settings.tightAttributes ? n[r].charAt(n[r].length - 1) : void 0;
    r !== n.length - 1 && i !== '"' && i !== "'" && (n[r] += " ");
  }
  return n.join("");
}
function iKe(t, e, n) {
  const r = lYe(t.schema, e), o = t.settings.allowParseErrors && t.schema.space === "html" ? 0 : 1, i = t.settings.allowDangerousCharacters ? 0 : 1;
  let s = t.quote, a;
  if (r.overloadedBoolean && (n === r.attribute || n === "") ? n = !0 : (r.boolean || r.overloadedBoolean) && (typeof n != "string" || n === r.attribute || n === "") && (n = !!n), n == null || n === !1 || typeof n == "number" && Number.isNaN(n))
    return "";
  const l = Eh(
    r.attribute,
    Object.assign({}, t.settings.characterReferences, {
      // Always encode without parse errors in non-HTML.
      subset: e1.name[o][i]
    })
  );
  return n === !0 || (n = Array.isArray(n) ? (r.commaSeparated ? DYe : IYe)(n, {
    padLeft: !t.settings.tightCommaSeparatedLists
  }) : String(n), t.settings.collapseEmptyAttributes && !n) ? l : (t.settings.preferUnquoted && (a = Eh(
    n,
    Object.assign({}, t.settings.characterReferences, {
      attribute: !0,
      subset: e1.unquoted[o][i]
    })
  )), a !== n && (t.settings.quoteSmart && Uq(n, s) > Uq(n, t.alternative) && (s = t.alternative), a = s + Eh(
    n,
    Object.assign({}, t.settings.characterReferences, {
      // Always encode without parse errors in non-HTML.
      subset: (s === "'" ? e1.single : e1.double)[o][i],
      attribute: !0
    })
  ) + s), l + (a && "=" + a));
}
const sKe = ["<", "&"];
function Bpe(t, e, n, r) {
  return n && n.type === "element" && (n.tagName === "script" || n.tagName === "style") ? t.value : Eh(
    t.value,
    Object.assign({}, r.settings.characterReferences, {
      subset: sKe
    })
  );
}
function aKe(t, e, n, r) {
  return r.settings.allowDangerousHtml ? t.value : Bpe(t, e, n, r);
}
function lKe(t, e, n, r) {
  return r.all(t);
}
const cKe = fYe("type", {
  invalid: uKe,
  unknown: dKe,
  handlers: { comment: $Ye, doctype: MYe, element: rKe, raw: aKe, root: lKe, text: Bpe }
});
function uKe(t) {
  throw new Error("Expected node, not `" + t + "`");
}
function dKe(t) {
  const e = (
    /** @type {Nodes} */
    t
  );
  throw new Error("Cannot compile unknown node `" + e.type + "`");
}
const fKe = {}, hKe = {}, pKe = [];
function mKe(t, e) {
  const n = fKe, r = n.quote || '"', o = r === '"' ? "'" : '"';
  if (r !== '"' && r !== "'")
    throw new Error("Invalid quote `" + r + "`, expected `'` or `\"`");
  return {
    one: gKe,
    all: yKe,
    settings: {
      omitOptionalTags: n.omitOptionalTags || !1,
      allowParseErrors: n.allowParseErrors || !1,
      allowDangerousCharacters: n.allowDangerousCharacters || !1,
      quoteSmart: n.quoteSmart || !1,
      preferUnquoted: n.preferUnquoted || !1,
      tightAttributes: n.tightAttributes || !1,
      upperDoctype: n.upperDoctype || !1,
      tightDoctype: n.tightDoctype || !1,
      bogusComments: n.bogusComments || !1,
      tightCommaSeparatedLists: n.tightCommaSeparatedLists || !1,
      tightSelfClosing: n.tightSelfClosing || !1,
      collapseEmptyAttributes: n.collapseEmptyAttributes || !1,
      allowDangerousHtml: n.allowDangerousHtml || !1,
      voids: n.voids || tYe,
      characterReferences: n.characterReferences || hKe,
      closeSelfClosing: n.closeSelfClosing || !1,
      closeEmptyElements: n.closeEmptyElements || !1
    },
    schema: n.space === "svg" ? Ipe : dYe,
    quote: r,
    alternative: o
  }.one(
    Array.isArray(t) ? { type: "root", children: t } : t,
    void 0,
    void 0
  );
}
function gKe(t, e, n) {
  return cKe(t, e, n, this);
}
function yKe(t) {
  const e = [], n = t && t.children || pKe;
  let r = -1;
  for (; ++r < n.length; )
    e[r] = this.one(n[r], r, t);
  return e.join("");
}
function vKe(t) {
  return Array.isArray(t) ? t : [t];
}
function WS(t, e = !1) {
  const n = t.split(/(\r?\n)/g);
  let r = 0;
  const o = [];
  for (let i = 0; i < n.length; i += 2) {
    const s = e ? n[i] + (n[i + 1] || "") : n[i];
    o.push([s, r]), r += n[i].length, r += n[i + 1]?.length || 0;
  }
  return o;
}
function YL(t) {
  return !t || ["plaintext", "txt", "text", "plain"].includes(t);
}
function bKe(t) {
  return t === "ansi" || YL(t);
}
function KL(t) {
  return t === "none";
}
function _Ke(t) {
  return KL(t);
}
function zpe(t, e) {
  if (!e)
    return t;
  t.properties ||= {}, t.properties.class ||= [], typeof t.properties.class == "string" && (t.properties.class = t.properties.class.split(/\s+/g)), Array.isArray(t.properties.class) || (t.properties.class = []);
  const n = Array.isArray(e) ? e : e.split(/\s+/g);
  for (const r of n)
    r && !t.properties.class.includes(r) && t.properties.class.push(r);
  return t;
}
function wKe(t, e) {
  let n = 0;
  const r = [];
  for (const o of e)
    o > n && r.push({
      ...t,
      content: t.content.slice(n, o),
      offset: t.offset + n
    }), n = o;
  return n < t.content.length && r.push({
    ...t,
    content: t.content.slice(n),
    offset: t.offset + n
  }), r;
}
function xKe(t, e) {
  const n = Array.from(e instanceof Set ? e : new Set(e)).sort((r, o) => r - o);
  return n.length ? t.map((r) => r.flatMap((o) => {
    const i = n.filter((s) => o.offset < s && s < o.offset + o.content.length).map((s) => s - o.offset).sort((s, a) => s - a);
    return i.length ? wKe(o, i) : o;
  })) : t;
}
async function qpe(t) {
  return Promise.resolve(typeof t == "function" ? t() : t).then((e) => e.default || e);
}
function Qx(t, e) {
  const n = typeof t == "string" ? {} : { ...t.colorReplacements }, r = typeof t == "string" ? t : t.name;
  for (const [o, i] of Object.entries(e?.colorReplacements || {}))
    typeof i == "string" ? n[o] = i : o === r && Object.assign(n, i);
  return n;
}
function sd(t, e) {
  return t && (e?.[t?.toLowerCase()] || t);
}
function Upe(t) {
  const e = {};
  return t.color && (e.color = t.color), t.bgColor && (e["background-color"] = t.bgColor), t.fontStyle && (t.fontStyle & wl.Italic && (e["font-style"] = "italic"), t.fontStyle & wl.Bold && (e["font-weight"] = "bold"), t.fontStyle & wl.Underline && (e["text-decoration"] = "underline")), e;
}
function EKe(t) {
  return typeof t == "string" ? t : Object.entries(t).map(([e, n]) => `${e}:${n}`).join(";");
}
function SKe(t) {
  const e = WS(t, !0).map(([o]) => o);
  function n(o) {
    if (o === t.length)
      return {
        line: e.length - 1,
        character: e[e.length - 1].length
      };
    let i = o, s = 0;
    for (const a of e) {
      if (i < a.length)
        break;
      i -= a.length, s++;
    }
    return { line: s, character: i };
  }
  function r(o, i) {
    let s = 0;
    for (let a = 0; a < o; a++)
      s += e[a].length;
    return s += i, s;
  }
  return {
    lines: e,
    indexToPos: n,
    posToIndex: r
  };
}
let Oo = class extends Error {
  constructor(e) {
    super(e), this.name = "ShikiError";
  }
};
const Hpe = /* @__PURE__ */ new WeakMap();
function GS(t, e) {
  Hpe.set(t, e);
}
function py(t) {
  return Hpe.get(t);
}
class Rp {
  constructor(...e) {
    if (ue(this, "_stacks", {}), ue(this, "lang"), e.length === 2) {
      const [n, r] = e;
      this.lang = r, this._stacks = n;
    } else {
      const [n, r, o] = e;
      this.lang = r, this._stacks = { [o]: n };
    }
  }
  get themes() {
    return Object.keys(this._stacks);
  }
  get theme() {
    return this.themes[0];
  }
  get _stack() {
    return this._stacks[this.theme];
  }
  /**
   * Static method to create a initial grammar state.
   */
  static initial(e, n) {
    return new Rp(
      Object.fromEntries(vKe(n).map((r) => [r, QN])),
      e
    );
  }
  /**
   * Get the internal stack object.
   * @internal
   */
  getInternalStack(e = this.theme) {
    return this._stacks[e];
  }
  /**
   * @deprecated use `getScopes` instead
   */
  get scopes() {
    return Gq(this._stacks[this.theme]);
  }
  getScopes(e = this.theme) {
    return Gq(this._stacks[e]);
  }
  toJSON() {
    return {
      lang: this.lang,
      theme: this.theme,
      themes: this.themes,
      scopes: this.scopes
    };
  }
}
function Gq(t) {
  const e = [], n = /* @__PURE__ */ new Set();
  function r(o) {
    if (n.has(o))
      return;
    n.add(o);
    const i = o?.nameScopesList?.scopeName;
    i && e.push(i), o.parent && r(o.parent);
  }
  return r(t), e;
}
function OKe(t, e) {
  if (!(t instanceof Rp))
    throw new Oo("Invalid grammar state");
  return t.getInternalStack(e);
}
function CKe() {
  const t = /* @__PURE__ */ new WeakMap();
  function e(n) {
    if (!t.has(n.meta)) {
      let r = function(s) {
        if (typeof s == "number") {
          if (s < 0 || s > n.source.length)
            throw new Oo(`Invalid decoration offset: ${s}. Code length: ${n.source.length}`);
          return {
            ...o.indexToPos(s),
            offset: s
          };
        } else {
          const a = o.lines[s.line];
          if (a === void 0)
            throw new Oo(`Invalid decoration position ${JSON.stringify(s)}. Lines length: ${o.lines.length}`);
          if (s.character < 0 || s.character > a.length)
            throw new Oo(`Invalid decoration position ${JSON.stringify(s)}. Line ${s.line} length: ${a.length}`);
          return {
            ...s,
            offset: o.posToIndex(s.line, s.character)
          };
        }
      };
      const o = SKe(n.source), i = (n.options.decorations || []).map((s) => ({
        ...s,
        start: r(s.start),
        end: r(s.end)
      }));
      kKe(i), t.set(n.meta, {
        decorations: i,
        converter: o,
        source: n.source
      });
    }
    return t.get(n.meta);
  }
  return {
    name: "shiki:decorations",
    tokens(n) {
      if (!this.options.decorations?.length)
        return;
      const r = e(this).decorations.flatMap((o) => [o.start.offset, o.end.offset]);
      return xKe(n, r);
    },
    code(n) {
      if (!this.options.decorations?.length)
        return;
      const r = e(this), o = Array.from(n.children).filter((u) => u.type === "element" && u.tagName === "span");
      if (o.length !== r.converter.lines.length)
        throw new Oo(`Number of lines in code element (${o.length}) does not match the number of lines in the source (${r.converter.lines.length}). Failed to apply decorations.`);
      function i(u, d, f, h) {
        const p = o[u];
        let m = "", g = -1, y = -1;
        if (d === 0 && (g = 0), f === 0 && (y = 0), f === Number.POSITIVE_INFINITY && (y = p.children.length), g === -1 || y === -1)
          for (let b = 0; b < p.children.length; b++)
            m += Vpe(p.children[b]), g === -1 && m.length === d && (g = b + 1), y === -1 && m.length === f && (y = b + 1);
        if (g === -1)
          throw new Oo(`Failed to find start index for decoration ${JSON.stringify(h.start)}`);
        if (y === -1)
          throw new Oo(`Failed to find end index for decoration ${JSON.stringify(h.end)}`);
        const v = p.children.slice(g, y);
        if (!h.alwaysWrap && v.length === p.children.length)
          a(p, h, "line");
        else if (!h.alwaysWrap && v.length === 1 && v[0].type === "element")
          a(v[0], h, "token");
        else {
          const b = {
            type: "element",
            tagName: "span",
            properties: {},
            children: v
          };
          a(b, h, "wrapper"), p.children.splice(g, v.length, b);
        }
      }
      function s(u, d) {
        o[u] = a(o[u], d, "line");
      }
      function a(u, d, f) {
        const h = d.properties || {}, p = d.transform || ((m) => m);
        return u.tagName = d.tagName || "span", u.properties = {
          ...u.properties,
          ...h,
          class: u.properties.class
        }, d.properties?.class && zpe(u, d.properties.class), u = p(u, f) || u, u;
      }
      const l = [], c = r.decorations.sort((u, d) => d.start.offset - u.start.offset);
      for (const u of c) {
        const { start: d, end: f } = u;
        if (d.line === f.line)
          i(d.line, d.character, f.character, u);
        else if (d.line < f.line) {
          i(d.line, d.character, Number.POSITIVE_INFINITY, u);
          for (let h = d.line + 1; h < f.line; h++)
            l.unshift(() => s(h, u));
          i(f.line, 0, f.character, u);
        }
      }
      l.forEach((u) => u());
    }
  };
}
function kKe(t) {
  for (let e = 0; e < t.length; e++) {
    const n = t[e];
    if (n.start.offset > n.end.offset)
      throw new Oo(`Invalid decoration range: ${JSON.stringify(n.start)} - ${JSON.stringify(n.end)}`);
    for (let r = e + 1; r < t.length; r++) {
      const o = t[r], i = n.start.offset < o.start.offset && o.start.offset < n.end.offset, s = n.start.offset < o.end.offset && o.end.offset < n.end.offset, a = o.start.offset < n.start.offset && n.start.offset < o.end.offset, l = o.start.offset < n.end.offset && n.end.offset < o.end.offset;
      if (i || s || a || l) {
        if (s && s || a && l)
          continue;
        throw new Oo(`Decorations ${JSON.stringify(n.start)} and ${JSON.stringify(o.start)} intersect.`);
      }
    }
  }
}
function Vpe(t) {
  return t.type === "text" ? t.value : t.type === "element" ? t.children.map(Vpe).join("") : "";
}
const AKe = [
  /* @__PURE__ */ CKe()
];
function Zx(t) {
  return [
    ...t.transformers || [],
    ...AKe
  ];
}
var ad = [
  "black",
  "red",
  "green",
  "yellow",
  "blue",
  "magenta",
  "cyan",
  "white",
  "brightBlack",
  "brightRed",
  "brightGreen",
  "brightYellow",
  "brightBlue",
  "brightMagenta",
  "brightCyan",
  "brightWhite"
], zk = {
  1: "bold",
  2: "dim",
  3: "italic",
  4: "underline",
  7: "reverse",
  9: "strikethrough"
};
function TKe(t, e) {
  const n = t.indexOf("\x1B[", e);
  if (n !== -1) {
    const r = t.indexOf("m", n);
    return {
      sequence: t.substring(n + 2, r).split(";"),
      startPosition: n,
      position: r + 1
    };
  }
  return {
    position: t.length
  };
}
function Yq(t, e) {
  let n = 1;
  const r = t[e + n++];
  let o;
  if (r === "2") {
    const i = [
      t[e + n++],
      t[e + n++],
      t[e + n]
    ].map((s) => Number.parseInt(s));
    i.length === 3 && !i.some((s) => Number.isNaN(s)) && (o = {
      type: "rgb",
      rgb: i
    });
  } else if (r === "5") {
    const i = Number.parseInt(t[e + n]);
    Number.isNaN(i) || (o = { type: "table", index: Number(i) });
  }
  return [n, o];
}
function RKe(t) {
  const e = [];
  for (let n = 0; n < t.length; n++) {
    const r = t[n], o = Number.parseInt(r);
    if (!Number.isNaN(o))
      if (o === 0)
        e.push({ type: "resetAll" });
      else if (o <= 9)
        zk[o] && e.push({
          type: "setDecoration",
          value: zk[o]
        });
      else if (o <= 29) {
        const i = zk[o - 20];
        i && e.push({
          type: "resetDecoration",
          value: i
        });
      } else if (o <= 37)
        e.push({
          type: "setForegroundColor",
          value: { type: "named", name: ad[o - 30] }
        });
      else if (o === 38) {
        const [i, s] = Yq(t, n);
        s && e.push({
          type: "setForegroundColor",
          value: s
        }), n += i;
      } else if (o === 39)
        e.push({
          type: "resetForegroundColor"
        });
      else if (o <= 47)
        e.push({
          type: "setBackgroundColor",
          value: { type: "named", name: ad[o - 40] }
        });
      else if (o === 48) {
        const [i, s] = Yq(t, n);
        s && e.push({
          type: "setBackgroundColor",
          value: s
        }), n += i;
      } else o === 49 ? e.push({
        type: "resetBackgroundColor"
      }) : o >= 90 && o <= 97 ? e.push({
        type: "setForegroundColor",
        value: { type: "named", name: ad[o - 90 + 8] }
      }) : o >= 100 && o <= 107 && e.push({
        type: "setBackgroundColor",
        value: { type: "named", name: ad[o - 100 + 8] }
      });
  }
  return e;
}
function PKe() {
  let t = null, e = null, n = /* @__PURE__ */ new Set();
  return {
    parse(r) {
      const o = [];
      let i = 0;
      do {
        const s = TKe(r, i), a = s.sequence ? r.substring(i, s.startPosition) : r.substring(i);
        if (a.length > 0 && o.push({
          value: a,
          foreground: t,
          background: e,
          decorations: new Set(n)
        }), s.sequence) {
          const l = RKe(s.sequence);
          for (const c of l)
            c.type === "resetAll" ? (t = null, e = null, n.clear()) : c.type === "resetForegroundColor" ? t = null : c.type === "resetBackgroundColor" ? e = null : c.type === "resetDecoration" && n.delete(c.value);
          for (const c of l)
            c.type === "setForegroundColor" ? t = c.value : c.type === "setBackgroundColor" ? e = c.value : c.type === "setDecoration" && n.add(c.value);
        }
        i = s.position;
      } while (i < r.length);
      return o;
    }
  };
}
var $Ke = {
  black: "#000000",
  red: "#bb0000",
  green: "#00bb00",
  yellow: "#bbbb00",
  blue: "#0000bb",
  magenta: "#ff00ff",
  cyan: "#00bbbb",
  white: "#eeeeee",
  brightBlack: "#555555",
  brightRed: "#ff5555",
  brightGreen: "#00ff00",
  brightYellow: "#ffff55",
  brightBlue: "#5555ff",
  brightMagenta: "#ff55ff",
  brightCyan: "#55ffff",
  brightWhite: "#ffffff"
};
function MKe(t = $Ke) {
  function e(a) {
    return t[a];
  }
  function n(a) {
    return `#${a.map((l) => Math.max(0, Math.min(l, 255)).toString(16).padStart(2, "0")).join("")}`;
  }
  let r;
  function o() {
    if (r)
      return r;
    r = [];
    for (let c = 0; c < ad.length; c++)
      r.push(e(ad[c]));
    let a = [0, 95, 135, 175, 215, 255];
    for (let c = 0; c < 6; c++)
      for (let u = 0; u < 6; u++)
        for (let d = 0; d < 6; d++)
          r.push(n([a[c], a[u], a[d]]));
    let l = 8;
    for (let c = 0; c < 24; c++, l += 10)
      r.push(n([l, l, l]));
    return r;
  }
  function i(a) {
    return o()[a];
  }
  function s(a) {
    switch (a.type) {
      case "named":
        return e(a.name);
      case "rgb":
        return n(a.rgb);
      case "table":
        return i(a.index);
    }
  }
  return {
    value: s
  };
}
function DKe(t, e, n) {
  const r = Qx(t, n), o = WS(e), i = MKe(
    Object.fromEntries(
      ad.map((a) => [
        a,
        t.colors?.[`terminal.ansi${a[0].toUpperCase()}${a.substring(1)}`]
      ])
    )
  ), s = PKe();
  return o.map(
    (a) => s.parse(a[0]).map((l) => {
      let c, u;
      l.decorations.has("reverse") ? (c = l.background ? i.value(l.background) : t.bg, u = l.foreground ? i.value(l.foreground) : t.fg) : (c = l.foreground ? i.value(l.foreground) : t.fg, u = l.background ? i.value(l.background) : void 0), c = sd(c, r), u = sd(u, r), l.decorations.has("dim") && (c = IKe(c));
      let d = wl.None;
      return l.decorations.has("bold") && (d |= wl.Bold), l.decorations.has("italic") && (d |= wl.Italic), l.decorations.has("underline") && (d |= wl.Underline), {
        content: l.value,
        offset: a[1],
        // TODO: more accurate offset? might need to fork ansi-sequence-parser
        color: c,
        bgColor: u,
        fontStyle: d
      };
    })
  );
}
function IKe(t) {
  const e = t.match(/#([0-9a-f]{3})([0-9a-f]{3})?([0-9a-f]{2})?/);
  if (e)
    if (e[3]) {
      const r = Math.round(Number.parseInt(e[3], 16) / 2).toString(16).padStart(2, "0");
      return `#${e[1]}${e[2]}${r}`;
    } else return e[2] ? `#${e[1]}${e[2]}80` : `#${Array.from(e[1]).map((r) => `${r}${r}`).join("")}80`;
  const n = t.match(/var\((--[\w-]+-ansi-[\w-]+)\)/);
  return n ? `var(${n[1]}-dim)` : t;
}
function XL(t, e, n = {}) {
  const {
    lang: r = "text",
    theme: o = t.getLoadedThemes()[0]
  } = n;
  if (YL(r) || KL(o))
    return WS(e).map((l) => [{ content: l[0], offset: l[1] }]);
  const { theme: i, colorMap: s } = t.setTheme(o);
  if (r === "ansi")
    return DKe(i, e, n);
  const a = t.getLanguage(r);
  if (n.grammarState) {
    if (n.grammarState.lang !== a.name)
      throw new bd(`Grammar state language "${n.grammarState.lang}" does not match highlight language "${a.name}"`);
    if (!n.grammarState.themes.includes(i.name))
      throw new bd(`Grammar state themes "${n.grammarState.themes}" do not contain highlight theme "${i.name}"`);
  }
  return jKe(e, a, i, s, n);
}
function NKe(...t) {
  if (t.length === 2)
    return py(t[1]);
  const [e, n, r = {}] = t, {
    lang: o = "text",
    theme: i = e.getLoadedThemes()[0]
  } = r;
  if (YL(o) || KL(i))
    throw new bd("Plain language does not have grammar state");
  if (o === "ansi")
    throw new bd("ANSI language does not have grammar state");
  const { theme: s, colorMap: a } = e.setTheme(i), l = e.getLanguage(o);
  return new Rp(
    Jx(n, l, s, a, r).stateStack,
    l.name,
    s.name
  );
}
function jKe(t, e, n, r, o) {
  const i = Jx(t, e, n, r, o), s = new Rp(
    Jx(t, e, n, r, o).stateStack,
    e.name,
    n.name
  );
  return GS(i.tokens, s), i.tokens;
}
function Jx(t, e, n, r, o) {
  const i = Qx(n, o), {
    tokenizeMaxLineLength: s = 0,
    tokenizeTimeLimit: a = 500
  } = o, l = WS(t);
  let c = o.grammarState ? OKe(o.grammarState, n.name) ?? QN : o.grammarContextCode != null ? Jx(
    o.grammarContextCode,
    e,
    n,
    r,
    {
      ...o,
      grammarState: void 0,
      grammarContextCode: void 0
    }
  ).stateStack : QN, u = [];
  const d = [];
  for (let f = 0, h = l.length; f < h; f++) {
    const [p, m] = l[f];
    if (p === "") {
      u = [], d.push([]);
      continue;
    }
    if (s > 0 && p.length >= s) {
      u = [], d.push([{
        content: p,
        offset: m,
        color: "",
        fontStyle: 0
      }]);
      continue;
    }
    let g, y, v;
    o.includeExplanation && (g = e.tokenizeLine(p, c), y = g.tokens, v = 0);
    const b = e.tokenizeLine2(p, c, a), _ = b.tokens.length / 2;
    for (let w = 0; w < _; w++) {
      const x = b.tokens[2 * w], E = w + 1 < _ ? b.tokens[2 * w + 2] : p.length;
      if (x === E)
        continue;
      const S = b.tokens[2 * w + 1], C = sd(
        r[op.getForeground(S)],
        i
      ), R = op.getFontStyle(S), P = {
        content: p.substring(x, E),
        offset: m + x,
        color: C,
        fontStyle: R
      };
      if (o.includeExplanation) {
        const N = [];
        if (o.includeExplanation !== "scopeName")
          for (const O of n.settings) {
            let k;
            switch (typeof O.scope) {
              case "string":
                k = O.scope.split(/,/).map((T) => T.trim());
                break;
              case "object":
                k = O.scope;
                break;
              default:
                continue;
            }
            N.push({
              settings: O,
              selectors: k.map((T) => T.split(/ /))
            });
          }
        P.explanation = [];
        let A = 0;
        for (; x + A < E; ) {
          const O = y[v], k = p.substring(
            O.startIndex,
            O.endIndex
          );
          A += k.length, P.explanation.push({
            content: k,
            scopes: o.includeExplanation === "scopeName" ? LKe(
              O.scopes
            ) : FKe(
              N,
              O.scopes
            )
          }), v += 1;
        }
      }
      u.push(P);
    }
    d.push(u), u = [], c = b.ruleStack;
  }
  return {
    tokens: d,
    stateStack: c
  };
}
function LKe(t) {
  return t.map((e) => ({ scopeName: e }));
}
function FKe(t, e) {
  const n = [];
  for (let r = 0, o = e.length; r < o; r++) {
    const i = e[r];
    n[r] = {
      scopeName: i,
      themeMatches: zKe(t, i, e.slice(0, r))
    };
  }
  return n;
}
function Kq(t, e) {
  return t === e || e.substring(0, t.length) === t && e[t.length] === ".";
}
function BKe(t, e, n) {
  if (!Kq(t[t.length - 1], e))
    return !1;
  let r = t.length - 2, o = n.length - 1;
  for (; r >= 0 && o >= 0; )
    Kq(t[r], n[o]) && (r -= 1), o -= 1;
  return r === -1;
}
function zKe(t, e, n) {
  const r = [];
  for (const { selectors: o, settings: i } of t)
    for (const s of o)
      if (BKe(s, e, n)) {
        r.push(i);
        break;
      }
  return r;
}
function Wpe(t, e, n) {
  const r = Object.entries(n.themes).filter((l) => l[1]).map((l) => ({ color: l[0], theme: l[1] })), o = r.map((l) => {
    const c = XL(t, e, {
      ...n,
      theme: l.theme
    }), u = py(c), d = typeof l.theme == "string" ? l.theme : l.theme.name;
    return {
      tokens: c,
      state: u,
      theme: d
    };
  }), i = qKe(
    ...o.map((l) => l.tokens)
  ), s = i[0].map(
    (l, c) => l.map((u, d) => {
      const f = {
        content: u.content,
        variants: {},
        offset: u.offset
      };
      return "includeExplanation" in n && n.includeExplanation && (f.explanation = u.explanation), i.forEach((h, p) => {
        const {
          content: m,
          explanation: g,
          offset: y,
          ...v
        } = h[c][d];
        f.variants[r[p].color] = v;
      }), f;
    })
  ), a = o[0].state ? new Rp(
    Object.fromEntries(o.map((l) => [l.theme, l.state?.getInternalStack(l.theme)])),
    o[0].state.lang
  ) : void 0;
  return a && GS(s, a), s;
}
function qKe(...t) {
  const e = t.map(() => []), n = t.length;
  for (let r = 0; r < t[0].length; r++) {
    const o = t.map((l) => l[r]), i = e.map(() => []);
    e.forEach((l, c) => l.push(i[c]));
    const s = o.map(() => 0), a = o.map((l) => l[0]);
    for (; a.every((l) => l); ) {
      const l = Math.min(...a.map((c) => c.content.length));
      for (let c = 0; c < n; c++) {
        const u = a[c];
        u.content.length === l ? (i[c].push(u), s[c] += 1, a[c] = o[c][s[c]]) : (i[c].push({
          ...u,
          content: u.content.slice(0, l)
        }), a[c] = {
          ...u,
          content: u.content.slice(l),
          offset: u.offset + l
        });
      }
    }
  }
  return e;
}
function eE(t, e, n) {
  let r, o, i, s, a, l;
  if ("themes" in n) {
    const {
      defaultColor: c = "light",
      cssVariablePrefix: u = "--shiki-"
    } = n, d = Object.entries(n.themes).filter((g) => g[1]).map((g) => ({ color: g[0], theme: g[1] })).sort((g, y) => g.color === c ? -1 : y.color === c ? 1 : 0);
    if (d.length === 0)
      throw new bd("`themes` option must not be empty");
    const f = Wpe(
      t,
      e,
      n
    );
    if (l = py(f), c && !d.find((g) => g.color === c))
      throw new bd(`\`themes\` option must contain the defaultColor key \`${c}\``);
    const h = d.map((g) => t.getTheme(g.theme)), p = d.map((g) => g.color);
    i = f.map((g) => g.map((y) => UKe(y, p, u, c))), l && GS(i, l);
    const m = d.map((g) => Qx(g.theme, n));
    o = d.map((g, y) => (y === 0 && c ? "" : `${u + g.color}:`) + (sd(h[y].fg, m[y]) || "inherit")).join(";"), r = d.map((g, y) => (y === 0 && c ? "" : `${u + g.color}-bg:`) + (sd(h[y].bg, m[y]) || "inherit")).join(";"), s = `shiki-themes ${h.map((g) => g.name).join(" ")}`, a = c ? void 0 : [o, r].join(";");
  } else if ("theme" in n) {
    const c = Qx(n.theme, n);
    i = XL(
      t,
      e,
      n
    );
    const u = t.getTheme(n.theme);
    r = sd(u.bg, c), o = sd(u.fg, c), s = u.name, l = py(i);
  } else
    throw new bd("Invalid options, either `theme` or `themes` must be provided");
  return {
    tokens: i,
    fg: o,
    bg: r,
    themeName: s,
    rootStyle: a,
    grammarState: l
  };
}
function UKe(t, e, n, r) {
  const o = {
    content: t.content,
    explanation: t.explanation,
    offset: t.offset
  }, i = e.map((l) => Upe(t.variants[l])), s = new Set(i.flatMap((l) => Object.keys(l))), a = {};
  return i.forEach((l, c) => {
    for (const u of s) {
      const d = l[u] || "inherit";
      if (c === 0 && r)
        a[u] = d;
      else {
        const f = u === "color" ? "" : u === "background-color" ? "-bg" : `-${u}`, h = n + e[c] + (u === "color" ? "" : f);
        a[h] = d;
      }
    }
  }), o.htmlStyle = a, o;
}
function tE(t, e, n, r = {
  meta: {},
  options: n,
  codeToHast: (o, i) => tE(t, o, i),
  codeToTokens: (o, i) => eE(t, o, i)
}) {
  let o = e;
  for (const h of Zx(n))
    o = h.preprocess?.call(r, o, n) || o;
  let {
    tokens: i,
    fg: s,
    bg: a,
    themeName: l,
    rootStyle: c,
    grammarState: u
  } = eE(t, o, n);
  const {
    mergeWhitespaces: d = !0
  } = n;
  d === !0 ? i = VKe(i) : d === "never" && (i = WKe(i));
  const f = {
    ...r,
    get source() {
      return o;
    }
  };
  for (const h of Zx(n))
    i = h.tokens?.call(f, i) || i;
  return HKe(
    i,
    {
      ...n,
      fg: s,
      bg: a,
      themeName: l,
      rootStyle: c
    },
    f,
    u
  );
}
function HKe(t, e, n, r = py(t)) {
  const o = Zx(e), i = [], s = {
    type: "root",
    children: []
  }, {
    structure: a = "classic",
    tabindex: l = "0"
  } = e;
  let c = {
    type: "element",
    tagName: "pre",
    properties: {
      class: `shiki ${e.themeName || ""}`,
      style: e.rootStyle || `background-color:${e.bg};color:${e.fg}`,
      ...l !== !1 && l != null ? {
        tabindex: l.toString()
      } : {},
      ...Object.fromEntries(
        Array.from(
          Object.entries(e.meta || {})
        ).filter(([p]) => !p.startsWith("_"))
      )
    },
    children: []
  }, u = {
    type: "element",
    tagName: "code",
    properties: {},
    children: i
  };
  const d = [], f = {
    ...n,
    structure: a,
    addClassToHast: zpe,
    get source() {
      return n.source;
    },
    get tokens() {
      return t;
    },
    get options() {
      return e;
    },
    get root() {
      return s;
    },
    get pre() {
      return c;
    },
    get code() {
      return u;
    },
    get lines() {
      return d;
    }
  };
  if (t.forEach((p, m) => {
    m && (a === "inline" ? s.children.push({ type: "element", tagName: "br", properties: {}, children: [] }) : a === "classic" && i.push({ type: "text", value: `
` }));
    let g = {
      type: "element",
      tagName: "span",
      properties: { class: "line" },
      children: []
    }, y = 0;
    for (const v of p) {
      let b = {
        type: "element",
        tagName: "span",
        properties: {
          ...v.htmlAttrs
        },
        children: [{ type: "text", value: v.content }]
      };
      v.htmlStyle;
      const _ = EKe(v.htmlStyle || Upe(v));
      _ && (b.properties.style = _);
      for (const w of o)
        b = w?.span?.call(f, b, m + 1, y, g, v) || b;
      a === "inline" ? s.children.push(b) : a === "classic" && g.children.push(b), y += v.content.length;
    }
    if (a === "classic") {
      for (const v of o)
        g = v?.line?.call(f, g, m + 1) || g;
      d.push(g), i.push(g);
    }
  }), a === "classic") {
    for (const p of o)
      u = p?.code?.call(f, u) || u;
    c.children.push(u);
    for (const p of o)
      c = p?.pre?.call(f, c) || c;
    s.children.push(c);
  }
  let h = s;
  for (const p of o)
    h = p?.root?.call(f, h) || h;
  return r && GS(h, r), h;
}
function VKe(t) {
  return t.map((e) => {
    const n = [];
    let r = "", o = 0;
    return e.forEach((i, s) => {
      const a = !(i.fontStyle && i.fontStyle & wl.Underline);
      a && i.content.match(/^\s+$/) && e[s + 1] ? (o || (o = i.offset), r += i.content) : r ? (a ? n.push({
        ...i,
        offset: o,
        content: r + i.content
      }) : n.push(
        {
          content: r,
          offset: o
        },
        i
      ), o = 0, r = "") : n.push(i);
    }), n;
  });
}
function WKe(t) {
  return t.map((e) => e.flatMap((n) => {
    if (n.content.match(/^\s+$/))
      return n;
    const r = n.content.match(/^(\s*)(.*?)(\s*)$/);
    if (!r)
      return n;
    const [, o, i, s] = r;
    if (!o && !s)
      return n;
    const a = [{
      ...n,
      offset: n.offset + o.length,
      content: i
    }];
    return o && a.unshift({
      content: o,
      offset: n.offset
    }), s && a.push({
      content: s,
      offset: n.offset + o.length + i.length
    }), a;
  }));
}
function GKe(t, e, n) {
  const r = {
    meta: {},
    options: n,
    codeToHast: (i, s) => tE(t, i, s),
    codeToTokens: (i, s) => eE(t, i, s)
  };
  let o = mKe(tE(t, e, n, r));
  for (const i of Zx(n))
    o = i.postprocess?.call(r, o, n) || o;
  return o;
}
const Xq = { light: "#333333", dark: "#bbbbbb" }, Qq = { light: "#fffffe", dark: "#1e1e1e" }, Zq = "__shiki_resolved";
function QL(t) {
  if (t?.[Zq])
    return t;
  const e = {
    ...t
  };
  e.tokenColors && !e.settings && (e.settings = e.tokenColors, delete e.tokenColors), e.type ||= "dark", e.colorReplacements = { ...e.colorReplacements }, e.settings ||= [];
  let { bg: n, fg: r } = e;
  if (!n || !r) {
    const a = e.settings ? e.settings.find((l) => !l.name && !l.scope) : void 0;
    a?.settings?.foreground && (r = a.settings.foreground), a?.settings?.background && (n = a.settings.background), !r && e?.colors?.["editor.foreground"] && (r = e.colors["editor.foreground"]), !n && e?.colors?.["editor.background"] && (n = e.colors["editor.background"]), r || (r = e.type === "light" ? Xq.light : Xq.dark), n || (n = e.type === "light" ? Qq.light : Qq.dark), e.fg = r, e.bg = n;
  }
  e.settings[0] && e.settings[0].settings && !e.settings[0].scope || e.settings.unshift({
    settings: {
      foreground: e.fg,
      background: e.bg
    }
  });
  let o = 0;
  const i = /* @__PURE__ */ new Map();
  function s(a) {
    if (i.has(a))
      return i.get(a);
    o += 1;
    const l = `#${o.toString(16).padStart(8, "0").toLowerCase()}`;
    return e.colorReplacements?.[`#${l}`] ? s(a) : (i.set(a, l), l);
  }
  e.settings = e.settings.map((a) => {
    const l = a.settings?.foreground && !a.settings.foreground.startsWith("#"), c = a.settings?.background && !a.settings.background.startsWith("#");
    if (!l && !c)
      return a;
    const u = {
      ...a,
      settings: {
        ...a.settings
      }
    };
    if (l) {
      const d = s(a.settings.foreground);
      e.colorReplacements[d] = a.settings.foreground, u.settings.foreground = d;
    }
    if (c) {
      const d = s(a.settings.background);
      e.colorReplacements[d] = a.settings.background, u.settings.background = d;
    }
    return u;
  });
  for (const a of Object.keys(e.colors || {}))
    if ((a === "editor.foreground" || a === "editor.background" || a.startsWith("terminal.ansi")) && !e.colors[a]?.startsWith("#")) {
      const l = s(e.colors[a]);
      e.colorReplacements[l] = e.colors[a], e.colors[a] = l;
    }
  return Object.defineProperty(e, Zq, {
    enumerable: !1,
    writable: !1,
    value: !0
  }), e;
}
async function Gpe(t) {
  return Array.from(new Set((await Promise.all(
    t.filter((e) => !bKe(e)).map(async (e) => await qpe(e).then((n) => Array.isArray(n) ? n : [n]))
  )).flat()));
}
async function Ype(t) {
  return (await Promise.all(
    t.map(
      async (e) => _Ke(e) ? null : QL(await qpe(e))
    )
  )).filter((e) => !!e);
}
let YKe = class extends eYe {
  constructor(t, e, n, r = {}) {
    super(t), ue(this, "_resolvedThemes", /* @__PURE__ */ new Map()), ue(this, "_resolvedGrammars", /* @__PURE__ */ new Map()), ue(this, "_langMap", /* @__PURE__ */ new Map()), ue(this, "_langGraph", /* @__PURE__ */ new Map()), ue(this, "_textmateThemeCache", /* @__PURE__ */ new WeakMap()), ue(this, "_loadedThemesCache", null), ue(this, "_loadedLanguagesCache", null), this._resolver = t, this._themes = e, this._langs = n, this._alias = r, this._themes.map((o) => this.loadTheme(o)), this.loadLanguages(this._langs);
  }
  getTheme(t) {
    return typeof t == "string" ? this._resolvedThemes.get(t) : this.loadTheme(t);
  }
  loadTheme(t) {
    const e = QL(t);
    return e.name && (this._resolvedThemes.set(e.name, e), this._loadedThemesCache = null), e;
  }
  getLoadedThemes() {
    return this._loadedThemesCache || (this._loadedThemesCache = [...this._resolvedThemes.keys()]), this._loadedThemesCache;
  }
  // Override and re-implement this method to cache the textmate themes as `TextMateTheme.createFromRawTheme`
  // is expensive. Themes can switch often especially for dual-theme support.
  //
  // The parent class also accepts `colorMap` as the second parameter, but since we don't use that,
  // we omit here so it's easier to cache the themes.
  setTheme(t) {
    let e = this._textmateThemeCache.get(t);
    e || (e = Wx.createFromRawTheme(t), this._textmateThemeCache.set(t, e)), this._syncRegistry.setTheme(e);
  }
  getGrammar(t) {
    if (this._alias[t]) {
      const e = /* @__PURE__ */ new Set([t]);
      for (; this._alias[t]; ) {
        if (t = this._alias[t], e.has(t))
          throw new Oo(`Circular alias \`${Array.from(e).join(" -> ")} -> ${t}\``);
        e.add(t);
      }
    }
    return this._resolvedGrammars.get(t);
  }
  loadLanguage(t) {
    if (this.getGrammar(t.name))
      return;
    const e = new Set(
      [...this._langMap.values()].filter((o) => o.embeddedLangsLazy?.includes(t.name))
    );
    this._resolver.addLanguage(t);
    const n = {
      balancedBracketSelectors: t.balancedBracketSelectors || ["*"],
      unbalancedBracketSelectors: t.unbalancedBracketSelectors || []
    };
    this._syncRegistry._rawGrammars.set(t.scopeName, t);
    const r = this.loadGrammarWithConfiguration(t.scopeName, 1, n);
    if (r.name = t.name, this._resolvedGrammars.set(t.name, r), t.aliases && t.aliases.forEach((o) => {
      this._alias[o] = t.name;
    }), this._loadedLanguagesCache = null, e.size)
      for (const o of e)
        this._resolvedGrammars.delete(o.name), this._loadedLanguagesCache = null, this._syncRegistry?._injectionGrammars?.delete(o.scopeName), this._syncRegistry?._grammars?.delete(o.scopeName), this.loadLanguage(this._langMap.get(o.name));
  }
  dispose() {
    super.dispose(), this._resolvedThemes.clear(), this._resolvedGrammars.clear(), this._langMap.clear(), this._langGraph.clear(), this._loadedThemesCache = null;
  }
  loadLanguages(t) {
    for (const r of t)
      this.resolveEmbeddedLanguages(r);
    const e = Array.from(this._langGraph.entries()), n = e.filter(([r, o]) => !o);
    if (n.length) {
      const r = e.filter(([o, i]) => i && i.embeddedLangs?.some((s) => n.map(([a]) => a).includes(s))).filter((o) => !n.includes(o));
      throw new Oo(`Missing languages ${n.map(([o]) => `\`${o}\``).join(", ")}, required by ${r.map(([o]) => `\`${o}\``).join(", ")}`);
    }
    for (const [r, o] of e)
      this._resolver.addLanguage(o);
    for (const [r, o] of e)
      this.loadLanguage(o);
  }
  getLoadedLanguages() {
    return this._loadedLanguagesCache || (this._loadedLanguagesCache = [
      .../* @__PURE__ */ new Set([...this._resolvedGrammars.keys(), ...Object.keys(this._alias)])
    ]), this._loadedLanguagesCache;
  }
  resolveEmbeddedLanguages(t) {
    if (this._langMap.set(t.name, t), this._langGraph.set(t.name, t), t.embeddedLangs)
      for (const e of t.embeddedLangs)
        this._langGraph.set(e, this._langMap.get(e));
  }
};
class KKe {
  constructor(e, n) {
    ue(this, "_langs", /* @__PURE__ */ new Map()), ue(this, "_scopeToLang", /* @__PURE__ */ new Map()), ue(this, "_injections", /* @__PURE__ */ new Map()), ue(this, "_onigLib"), this._onigLib = {
      createOnigScanner: (r) => e.createScanner(r),
      createOnigString: (r) => e.createString(r)
    }, n.forEach((r) => this.addLanguage(r));
  }
  get onigLib() {
    return this._onigLib;
  }
  getLangRegistration(e) {
    return this._langs.get(e);
  }
  loadGrammar(e) {
    return this._scopeToLang.get(e);
  }
  addLanguage(e) {
    this._langs.set(e.name, e), e.aliases && e.aliases.forEach((n) => {
      this._langs.set(n, e);
    }), this._scopeToLang.set(e.scopeName, e), e.injectTo && e.injectTo.forEach((n) => {
      this._injections.get(n) || this._injections.set(n, []), this._injections.get(n).push(e.scopeName);
    });
  }
  getInjections(e) {
    const n = e.split(".");
    let r = [];
    for (let o = 1; o <= n.length; o++) {
      const i = n.slice(0, o).join(".");
      r = [...r, ...this._injections.get(i) || []];
    }
    return r;
  }
}
let hm = 0;
function XKe(t) {
  hm += 1, t.warnings !== !1 && hm >= 10 && hm % 10 === 0 && console.warn(`[Shiki] ${hm} instances have been created. Shiki is supposed to be used as a singleton, consider refactoring your code to cache your highlighter instance; Or call \`highlighter.dispose()\` to release unused instances.`);
  let e = !1;
  if (!t.engine)
    throw new Oo("`engine` option is required for synchronous mode");
  const n = (t.langs || []).flat(1), r = (t.themes || []).flat(1).map(QL), o = new KKe(t.engine, n), i = new YKe(o, r, n, t.langAlias);
  let s;
  function a(v) {
    g();
    const b = i.getGrammar(typeof v == "string" ? v : v.name);
    if (!b)
      throw new Oo(`Language \`${v}\` not found, you may need to load it first`);
    return b;
  }
  function l(v) {
    if (v === "none")
      return { bg: "", fg: "", name: "none", settings: [], type: "dark" };
    g();
    const b = i.getTheme(v);
    if (!b)
      throw new Oo(`Theme \`${v}\` not found, you may need to load it first`);
    return b;
  }
  function c(v) {
    g();
    const b = l(v);
    s !== v && (i.setTheme(b), s = v);
    const _ = i.getColorMap();
    return {
      theme: b,
      colorMap: _
    };
  }
  function u() {
    return g(), i.getLoadedThemes();
  }
  function d() {
    return g(), i.getLoadedLanguages();
  }
  function f(...v) {
    g(), i.loadLanguages(v.flat(1));
  }
  async function h(...v) {
    return f(await Gpe(v));
  }
  function p(...v) {
    g();
    for (const b of v.flat(1))
      i.loadTheme(b);
  }
  async function m(...v) {
    return g(), p(await Ype(v));
  }
  function g() {
    if (e)
      throw new Oo("Shiki instance has been disposed");
  }
  function y() {
    e || (e = !0, i.dispose(), hm -= 1);
  }
  return {
    setTheme: c,
    getTheme: l,
    getLanguage: a,
    getLoadedThemes: u,
    getLoadedLanguages: d,
    loadLanguage: h,
    loadLanguageSync: f,
    loadTheme: m,
    loadThemeSync: p,
    dispose: y,
    [Symbol.dispose]: y
  };
}
async function QKe(t = {}) {
  t.loadWasm;
  const [
    e,
    n,
    r
  ] = await Promise.all([
    Ype(t.themes || []),
    Gpe(t.langs || []),
    t.engine || pGe(t.loadWasm || hGe())
  ]);
  return XKe({
    ...t,
    themes: e,
    langs: n,
    engine: r
  });
}
async function ZKe(t = {}) {
  const e = await QKe(t);
  return {
    getLastGrammarState: (...n) => NKe(e, ...n),
    codeToTokensBase: (n, r) => XL(e, n, r),
    codeToTokensWithThemes: (n, r) => Wpe(e, n, r),
    codeToTokens: (n, r) => eE(e, n, r),
    codeToHast: (n, r) => tE(e, n, r),
    codeToHtml: (n, r) => GKe(e, n, r),
    ...e,
    getInternalContext: () => e
  };
}
const JKe = ts({
  linkify: !0,
  typographer: !0
});
(async () => {
  const t = await ZKe({
    themes: [
      Promise.resolve().then(() => tpt),
      Promise.resolve().then(() => rpt)
    ],
    langs: [Promise.resolve().then(() => spt)]
  });
  JKe.use(KWe(t, {
    themes: {
      light: "vitesse-light",
      dark: "vitesse-dark"
    }
  }));
})();
var Jq = {}, eU;
function eXe() {
  return eU || (eU = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.parse = void 0;
    function e(b) {
      if (b !== void 0) {
        if (b === null)
          return null;
        if (b === "")
          return "";
        b = b.replace(/\\+$/, (_) => _.length % 2 === 0 ? _ : _.slice(0, -1));
        try {
          return JSON.parse(b);
        } catch (_) {
          const [w, x] = b.trimLeft()[0] === ":" ? n(b, _) : n(b, _, h);
          return e.lastParseReminding = x, e.onExtraToken && x.length > 0 && e.onExtraToken(b, w, x), w;
        }
      }
    }
    t.parse = e, function(b) {
      b.onExtraToken = (_, w, x) => {
        console.error("parsed json with extra tokens:", {
          text: _,
          data: w,
          reminding: x
        });
      };
    }(e = t.parse || (t.parse = {}));
    function n(b, _, w) {
      const x = o[b[0]] || w;
      if (!x)
        throw console.error(`no parser registered for ${JSON.stringify(b[0])}:`, { s: b }), _;
      return x(b, _);
    }
    function r(b, _, w) {
      return b[0] === '"' ? u(b) : b[0] === "'" ? f(b) : h(b, _, w);
    }
    const o = {};
    function i(b) {
      return b.trimLeft();
    }
    o[" "] = s, o["\r"] = s, o[`
`] = s, o["	"] = s;
    function s(b, _) {
      return b = i(b), n(b, _);
    }
    o["["] = a;
    function a(b, _) {
      b = b.substr(1);
      const w = [];
      for (b = i(b); b.length > 0; ) {
        if (b[0] === "]") {
          b = b.substr(1);
          break;
        }
        const x = n(b, _, (E, S) => h(E, S, [",", "]"]));
        w.push(x[0]), b = x[1], b = i(b), b[0] === "," && (b = b.substring(1), b = i(b));
      }
      return [w, b];
    }
    for (const b of "0123456789.-".slice())
      o[b] = l;
    function l(b) {
      for (let _ = 0; _ < b.length; _++) {
        const w = b[_];
        if (o[w] === l)
          continue;
        const x = b.substring(0, _);
        return b = b.substring(_), [c(x), b];
      }
      return [c(b), ""];
    }
    function c(b) {
      if (b === "-")
        return -0;
      const _ = +b;
      return Number.isNaN(_) ? b : _;
    }
    o['"'] = u;
    function u(b) {
      for (let _ = 1; _ < b.length; _++) {
        const w = b[_];
        if (w === "\\") {
          _++;
          continue;
        }
        if (w === '"') {
          const x = d(b.substring(0, _ + 1));
          return b = b.substring(_ + 1), [JSON.parse(x), b];
        }
      }
      return [JSON.parse(d(b) + '"'), ""];
    }
    function d(b) {
      return b.replace(/\n/g, "\\n").replace(/\t/g, "\\t").replace(/\r/g, "\\r");
    }
    o["'"] = f;
    function f(b) {
      for (let _ = 1; _ < b.length; _++) {
        const w = b[_];
        if (w === "\\") {
          _++;
          continue;
        }
        if (w === "'") {
          const x = d(b.substring(0, _ + 1));
          return b = b.substring(_ + 1), [JSON.parse('"' + x.slice(1, -1) + '"'), b];
        }
      }
      return [JSON.parse('"' + d(b.slice(1)) + '"'), ""];
    }
    function h(b, _, w = [" "]) {
      const x = Math.min(...w.map((C) => {
        const R = b.indexOf(C);
        return R === -1 ? b.length : R;
      })), E = b.substring(0, x).trim(), S = b.substring(x);
      return [E, S];
    }
    o["{"] = p;
    function p(b, _) {
      b = b.substr(1);
      const w = {};
      for (b = i(b); b.length > 0; ) {
        if (b[0] === "}") {
          b = b.substr(1);
          break;
        }
        const x = r(b, _, [":", "}"]), E = x[0];
        if (b = x[1], b = i(b), b[0] !== ":") {
          w[E] = void 0;
          break;
        }
        if (b = b.substr(1), b = i(b), b.length === 0) {
          w[E] = void 0;
          break;
        }
        const S = n(b, _);
        w[E] = S[0], b = S[1], b = i(b), b[0] === "," && (b = b.substr(1), b = i(b));
      }
      return [w, b];
    }
    o.t = m;
    function m(b, _) {
      return v(b, "true", !0, _);
    }
    o.f = g;
    function g(b, _) {
      return v(b, "false", !1, _);
    }
    o.n = y;
    function y(b, _) {
      return v(b, "null", null, _);
    }
    function v(b, _, w, x) {
      for (let E = _.length; E >= 1; E--)
        if (b.startsWith(_.slice(0, E)))
          return [w, b.slice(E)];
      {
        const E = JSON.stringify(b.slice(0, _.length));
        throw console.error(`unknown token starting with ${E}:`, { s: b }), x;
      }
    }
  }(Jq)), Jq;
}
eXe();
var qk = {}, tU;
function tXe() {
  return tU || (tU = 1, function(t) {
    (function(e, n) {
      if (typeof t.nodeName != "string")
        n(t);
      else {
        var r = {};
        n(r), e.AnsiUp = r.default;
      }
    })(qk, function(e) {
      var n = this && this.__makeTemplateObject || function(a, l) {
        return Object.defineProperty ? Object.defineProperty(a, "raw", { value: l }) : a.raw = l, a;
      }, r;
      (function(a) {
        a[a.EOS = 0] = "EOS", a[a.Text = 1] = "Text", a[a.Incomplete = 2] = "Incomplete", a[a.ESC = 3] = "ESC", a[a.Unknown = 4] = "Unknown", a[a.SGR = 5] = "SGR", a[a.OSCURL = 6] = "OSCURL";
      })(r || (r = {}));
      var o = function() {
        function a() {
          this.VERSION = "5.2.1", this.setup_palettes(), this._use_classes = !1, this.bold = !1, this.italic = !1, this.underline = !1, this.fg = this.bg = null, this._buffer = "", this._url_whitelist = { http: 1, https: 1 }, this._escape_html = !0;
        }
        return Object.defineProperty(a.prototype, "use_classes", {
          get: function() {
            return this._use_classes;
          },
          set: function(l) {
            this._use_classes = l;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(a.prototype, "url_whitelist", {
          get: function() {
            return this._url_whitelist;
          },
          set: function(l) {
            this._url_whitelist = l;
          },
          enumerable: !1,
          configurable: !0
        }), Object.defineProperty(a.prototype, "escape_html", {
          get: function() {
            return this._escape_html;
          },
          set: function(l) {
            this._escape_html = l;
          },
          enumerable: !1,
          configurable: !0
        }), a.prototype.setup_palettes = function() {
          var l = this;
          this.ansi_colors = [
            [
              { rgb: [0, 0, 0], class_name: "ansi-black" },
              { rgb: [187, 0, 0], class_name: "ansi-red" },
              { rgb: [0, 187, 0], class_name: "ansi-green" },
              { rgb: [187, 187, 0], class_name: "ansi-yellow" },
              { rgb: [0, 0, 187], class_name: "ansi-blue" },
              { rgb: [187, 0, 187], class_name: "ansi-magenta" },
              { rgb: [0, 187, 187], class_name: "ansi-cyan" },
              { rgb: [255, 255, 255], class_name: "ansi-white" }
            ],
            [
              { rgb: [85, 85, 85], class_name: "ansi-bright-black" },
              { rgb: [255, 85, 85], class_name: "ansi-bright-red" },
              { rgb: [0, 255, 0], class_name: "ansi-bright-green" },
              { rgb: [255, 255, 85], class_name: "ansi-bright-yellow" },
              { rgb: [85, 85, 255], class_name: "ansi-bright-blue" },
              { rgb: [255, 85, 255], class_name: "ansi-bright-magenta" },
              { rgb: [85, 255, 255], class_name: "ansi-bright-cyan" },
              { rgb: [255, 255, 255], class_name: "ansi-bright-white" }
            ]
          ], this.palette_256 = [], this.ansi_colors.forEach(function(y) {
            y.forEach(function(v) {
              l.palette_256.push(v);
            });
          });
          for (var c = [0, 95, 135, 175, 215, 255], u = 0; u < 6; ++u)
            for (var d = 0; d < 6; ++d)
              for (var f = 0; f < 6; ++f) {
                var h = { rgb: [c[u], c[d], c[f]], class_name: "truecolor" };
                this.palette_256.push(h);
              }
          for (var p = 8, m = 0; m < 24; ++m, p += 10) {
            var g = { rgb: [p, p, p], class_name: "truecolor" };
            this.palette_256.push(g);
          }
        }, a.prototype.escape_txt_for_html = function(l) {
          return this._escape_html ? l.replace(/[&<>"']/gm, function(c) {
            if (c === "&")
              return "&amp;";
            if (c === "<")
              return "&lt;";
            if (c === ">")
              return "&gt;";
            if (c === '"')
              return "&quot;";
            if (c === "'")
              return "&#x27;";
          }) : l;
        }, a.prototype.append_buffer = function(l) {
          var c = this._buffer + l;
          this._buffer = c;
        }, a.prototype.get_next_packet = function() {
          var l = {
            kind: r.EOS,
            text: "",
            url: ""
          }, c = this._buffer.length;
          if (c == 0)
            return l;
          var u = this._buffer.indexOf("\x1B");
          if (u == -1)
            return l.kind = r.Text, l.text = this._buffer, this._buffer = "", l;
          if (u > 0)
            return l.kind = r.Text, l.text = this._buffer.slice(0, u), this._buffer = this._buffer.slice(u), l;
          if (u == 0) {
            if (c < 3)
              return l.kind = r.Incomplete, l;
            var d = this._buffer.charAt(1);
            if (d != "[" && d != "]" && d != "(")
              return l.kind = r.ESC, l.text = this._buffer.slice(0, 1), this._buffer = this._buffer.slice(1), l;
            if (d == "[") {
              this._csi_regex || (this._csi_regex = i(n([`
                        ^                           # beginning of line
                                                    #
                                                    # First attempt
                        (?:                         # legal sequence
                          \x1B[                      # CSI
                          ([<-?]?)              # private-mode char
                          ([d;]*)                    # any digits or semicolons
                          ([ -/]?               # an intermediate modifier
                          [@-~])                # the command
                        )
                        |                           # alternate (second attempt)
                        (?:                         # illegal sequence
                          \x1B[                      # CSI
                          [ -~]*                # anything legal
                          ([\0-:])              # anything illegal
                        )
                    `], [`
                        ^                           # beginning of line
                                                    #
                                                    # First attempt
                        (?:                         # legal sequence
                          \\x1b\\[                      # CSI
                          ([\\x3c-\\x3f]?)              # private-mode char
                          ([\\d;]*)                    # any digits or semicolons
                          ([\\x20-\\x2f]?               # an intermediate modifier
                          [\\x40-\\x7e])                # the command
                        )
                        |                           # alternate (second attempt)
                        (?:                         # illegal sequence
                          \\x1b\\[                      # CSI
                          [\\x20-\\x7e]*                # anything legal
                          ([\\x00-\\x1f:])              # anything illegal
                        )
                    `])));
              var f = this._buffer.match(this._csi_regex);
              if (f === null)
                return l.kind = r.Incomplete, l;
              if (f[4])
                return l.kind = r.ESC, l.text = this._buffer.slice(0, 1), this._buffer = this._buffer.slice(1), l;
              f[1] != "" || f[3] != "m" ? l.kind = r.Unknown : l.kind = r.SGR, l.text = f[2];
              var h = f[0].length;
              return this._buffer = this._buffer.slice(h), l;
            } else if (d == "]") {
              if (c < 4)
                return l.kind = r.Incomplete, l;
              if (this._buffer.charAt(2) != "8" || this._buffer.charAt(3) != ";")
                return l.kind = r.ESC, l.text = this._buffer.slice(0, 1), this._buffer = this._buffer.slice(1), l;
              this._osc_st || (this._osc_st = s(n([`
                        (?:                         # legal sequence
                          (\x1B\\)                    # ESC                           |                           # alternate
                          (\x07)                      # BEL (what xterm did)
                        )
                        |                           # alternate (second attempt)
                        (                           # illegal sequence
                          [\0-]                 # anything illegal
                          |                           # alternate
                          [\b-]                 # anything illegal
                          |                           # alternate
                          [-]                 # anything illegal
                        )
                    `], [`
                        (?:                         # legal sequence
                          (\\x1b\\\\)                    # ESC \\
                          |                           # alternate
                          (\\x07)                      # BEL (what xterm did)
                        )
                        |                           # alternate (second attempt)
                        (                           # illegal sequence
                          [\\x00-\\x06]                 # anything illegal
                          |                           # alternate
                          [\\x08-\\x1a]                 # anything illegal
                          |                           # alternate
                          [\\x1c-\\x1f]                 # anything illegal
                        )
                    `]))), this._osc_st.lastIndex = 0;
              {
                var p = this._osc_st.exec(this._buffer);
                if (p === null)
                  return l.kind = r.Incomplete, l;
                if (p[3])
                  return l.kind = r.ESC, l.text = this._buffer.slice(0, 1), this._buffer = this._buffer.slice(1), l;
              }
              {
                var m = this._osc_st.exec(this._buffer);
                if (m === null)
                  return l.kind = r.Incomplete, l;
                if (m[3])
                  return l.kind = r.ESC, l.text = this._buffer.slice(0, 1), this._buffer = this._buffer.slice(1), l;
              }
              this._osc_regex || (this._osc_regex = i(n([`
                        ^                           # beginning of line
                                                    #
                        \x1B]8;                    # OSC Hyperlink
                        [ -:<-~]*       # params (excluding ;)
                        ;                           # end of params
                        ([!-~]{0,512})        # URL capture
                        (?:                         # ST
                          (?:\x1B\\)                  # ESC                           |                           # alternate
                          (?:\x07)                    # BEL (what xterm did)
                        )
                        ([ -~]+)              # TEXT capture
                        \x1B]8;;                   # OSC Hyperlink End
                        (?:                         # ST
                          (?:\x1B\\)                  # ESC                           |                           # alternate
                          (?:\x07)                    # BEL (what xterm did)
                        )
                    `], [`
                        ^                           # beginning of line
                                                    #
                        \\x1b\\]8;                    # OSC Hyperlink
                        [\\x20-\\x3a\\x3c-\\x7e]*       # params (excluding ;)
                        ;                           # end of params
                        ([\\x21-\\x7e]{0,512})        # URL capture
                        (?:                         # ST
                          (?:\\x1b\\\\)                  # ESC \\
                          |                           # alternate
                          (?:\\x07)                    # BEL (what xterm did)
                        )
                        ([\\x20-\\x7e]+)              # TEXT capture
                        \\x1b\\]8;;                   # OSC Hyperlink End
                        (?:                         # ST
                          (?:\\x1b\\\\)                  # ESC \\
                          |                           # alternate
                          (?:\\x07)                    # BEL (what xterm did)
                        )
                    `])));
              var f = this._buffer.match(this._osc_regex);
              if (f === null)
                return l.kind = r.ESC, l.text = this._buffer.slice(0, 1), this._buffer = this._buffer.slice(1), l;
              l.kind = r.OSCURL, l.url = f[1], l.text = f[2];
              var h = f[0].length;
              return this._buffer = this._buffer.slice(h), l;
            } else if (d == "(")
              return l.kind = r.Unknown, this._buffer = this._buffer.slice(3), l;
          }
        }, a.prototype.ansi_to_html = function(l) {
          this.append_buffer(l);
          for (var c = []; ; ) {
            var u = this.get_next_packet();
            if (u.kind == r.EOS || u.kind == r.Incomplete)
              break;
            u.kind == r.ESC || u.kind == r.Unknown || (u.kind == r.Text ? c.push(this.transform_to_html(this.with_state(u))) : u.kind == r.SGR ? this.process_ansi(u) : u.kind == r.OSCURL && c.push(this.process_hyperlink(u)));
          }
          return c.join("");
        }, a.prototype.with_state = function(l) {
          return { bold: this.bold, italic: this.italic, underline: this.underline, fg: this.fg, bg: this.bg, text: l.text };
        }, a.prototype.process_ansi = function(l) {
          for (var c = l.text.split(";"); c.length > 0; ) {
            var u = c.shift(), d = parseInt(u, 10);
            if (isNaN(d) || d === 0)
              this.fg = this.bg = null, this.bold = !1, this.italic = !1, this.underline = !1;
            else if (d === 1)
              this.bold = !0;
            else if (d === 3)
              this.italic = !0;
            else if (d === 4)
              this.underline = !0;
            else if (d === 22)
              this.bold = !1;
            else if (d === 23)
              this.italic = !1;
            else if (d === 24)
              this.underline = !1;
            else if (d === 39)
              this.fg = null;
            else if (d === 49)
              this.bg = null;
            else if (d >= 30 && d < 38)
              this.fg = this.ansi_colors[0][d - 30];
            else if (d >= 40 && d < 48)
              this.bg = this.ansi_colors[0][d - 40];
            else if (d >= 90 && d < 98)
              this.fg = this.ansi_colors[1][d - 90];
            else if (d >= 100 && d < 108)
              this.bg = this.ansi_colors[1][d - 100];
            else if ((d === 38 || d === 48) && c.length > 0) {
              var f = d === 38, h = c.shift();
              if (h === "5" && c.length > 0) {
                var p = parseInt(c.shift(), 10);
                p >= 0 && p <= 255 && (f ? this.fg = this.palette_256[p] : this.bg = this.palette_256[p]);
              }
              if (h === "2" && c.length > 2) {
                var m = parseInt(c.shift(), 10), g = parseInt(c.shift(), 10), y = parseInt(c.shift(), 10);
                if (m >= 0 && m <= 255 && g >= 0 && g <= 255 && y >= 0 && y <= 255) {
                  var v = { rgb: [m, g, y], class_name: "truecolor" };
                  f ? this.fg = v : this.bg = v;
                }
              }
            }
          }
        }, a.prototype.transform_to_html = function(l) {
          var c = l.text;
          if (c.length === 0 || (c = this.escape_txt_for_html(c), !l.bold && !l.italic && !l.underline && l.fg === null && l.bg === null))
            return c;
          var u = [], d = [], f = l.fg, h = l.bg;
          l.bold && u.push("font-weight:bold"), l.italic && u.push("font-style:italic"), l.underline && u.push("text-decoration:underline"), this._use_classes ? (f && (f.class_name !== "truecolor" ? d.push(f.class_name + "-fg") : u.push("color:rgb(" + f.rgb.join(",") + ")")), h && (h.class_name !== "truecolor" ? d.push(h.class_name + "-bg") : u.push("background-color:rgb(" + h.rgb.join(",") + ")"))) : (f && u.push("color:rgb(" + f.rgb.join(",") + ")"), h && u.push("background-color:rgb(" + h.rgb + ")"));
          var p = "", m = "";
          return d.length && (p = ' class="' + d.join(" ") + '"'), u.length && (m = ' style="' + u.join(";") + '"'), "<span" + m + p + ">" + c + "</span>";
        }, a.prototype.process_hyperlink = function(l) {
          var c = l.url.split(":");
          if (c.length < 1 || !this._url_whitelist[c[0]])
            return "";
          var u = '<a href="' + this.escape_txt_for_html(l.url) + '">' + this.escape_txt_for_html(l.text) + "</a>";
          return u;
        }, a;
      }();
      function i(a) {
        var l = a.raw[0], c = /^\s+|\s+\n|\s*#[\s\S]*?\n|\n/gm, u = l.replace(c, "");
        return new RegExp(u);
      }
      function s(a) {
        var l = a.raw[0], c = /^\s+|\s+\n|\s*#[\s\S]*?\n|\n/gm, u = l.replace(c, "");
        return new RegExp(u, "g");
      }
      Object.defineProperty(e, "__esModule", { value: !0 }), e.default = o;
    });
  }(qk)), qk;
}
tXe();
var nXe = "tippy-content", rXe = "tippy-backdrop", oXe = "tippy-arrow", iXe = "tippy-svg-arrow", Bu = {
  passive: !0,
  capture: !0
}, Kpe = function() {
  return document.body;
};
function sXe(t, e) {
  return {}.hasOwnProperty.call(t, e);
}
function Uk(t, e, n) {
  if (Array.isArray(t)) {
    var r = t[e];
    return r ?? (Array.isArray(n) ? n[e] : n);
  }
  return t;
}
function ZL(t, e) {
  var n = {}.toString.call(t);
  return n.indexOf("[object") === 0 && n.indexOf(e + "]") > -1;
}
function Xpe(t, e) {
  return typeof t == "function" ? t.apply(void 0, e) : t;
}
function nU(t, e) {
  if (e === 0)
    return t;
  var n;
  return function(r) {
    clearTimeout(n), n = setTimeout(function() {
      t(r);
    }, e);
  };
}
function aXe(t, e) {
  var n = Object.assign({}, t);
  return e.forEach(function(r) {
    delete n[r];
  }), n;
}
function lXe(t) {
  return t.split(/\s+/).filter(Boolean);
}
function jf(t) {
  return [].concat(t);
}
function rU(t, e) {
  t.indexOf(e) === -1 && t.push(e);
}
function cXe(t) {
  return t.filter(function(e, n) {
    return t.indexOf(e) === n;
  });
}
function uXe(t) {
  return t.split("-")[0];
}
function nE(t) {
  return [].slice.call(t);
}
function oU(t) {
  return Object.keys(t).reduce(function(e, n) {
    return t[n] !== void 0 && (e[n] = t[n]), e;
  }, {});
}
function dXe() {
  return document.createElement("div");
}
function tj(t) {
  return ["Element", "Fragment"].some(function(e) {
    return ZL(t, e);
  });
}
function fXe(t) {
  return ZL(t, "NodeList");
}
function hXe(t) {
  return ZL(t, "MouseEvent");
}
function pXe(t) {
  return !!(t && t._tippy && t._tippy.reference === t);
}
function mXe(t) {
  return tj(t) ? [t] : fXe(t) ? nE(t) : Array.isArray(t) ? t : nE(document.querySelectorAll(t));
}
function Hk(t, e) {
  t.forEach(function(n) {
    n && (n.style.transitionDuration = e + "ms");
  });
}
function iU(t, e) {
  t.forEach(function(n) {
    n && n.setAttribute("data-state", e);
  });
}
function gXe(t) {
  var e, n = jf(t), r = n[0];
  return r != null && (e = r.ownerDocument) != null && e.body ? r.ownerDocument : document;
}
function yXe(t, e) {
  var n = e.clientX, r = e.clientY;
  return t.every(function(o) {
    var i = o.popperRect, s = o.popperState, a = o.props, l = a.interactiveBorder, c = uXe(s.placement), u = s.modifiersData.offset;
    if (!u)
      return !0;
    var d = c === "bottom" ? u.top.y : 0, f = c === "top" ? u.bottom.y : 0, h = c === "right" ? u.left.x : 0, p = c === "left" ? u.right.x : 0, m = i.top - r + d > l, g = r - i.bottom - f > l, y = i.left - n + h > l, v = n - i.right - p > l;
    return m || g || y || v;
  });
}
function Vk(t, e, n) {
  var r = e + "EventListener";
  ["transitionend", "webkitTransitionEnd"].forEach(function(o) {
    t[r](o, n);
  });
}
function sU(t, e) {
  for (var n = e; n; ) {
    var r;
    if (t.contains(n))
      return !0;
    n = n.getRootNode == null || (r = n.getRootNode()) == null ? void 0 : r.host;
  }
  return !1;
}
var ia = {
  isTouch: !1
}, aU = 0;
function vXe() {
  ia.isTouch || (ia.isTouch = !0, window.performance && document.addEventListener("mousemove", Qpe));
}
function Qpe() {
  var t = performance.now();
  t - aU < 20 && (ia.isTouch = !1, document.removeEventListener("mousemove", Qpe)), aU = t;
}
function bXe() {
  var t = document.activeElement;
  if (pXe(t)) {
    var e = t._tippy;
    t.blur && !e.state.isVisible && t.blur();
  }
}
function _Xe() {
  document.addEventListener("touchstart", vXe, Bu), window.addEventListener("blur", bXe);
}
var wXe = typeof window < "u" && typeof document < "u", xXe = wXe ? (
  // @ts-ignore
  !!window.msCrypto
) : !1;
function xf(t) {
  var e = t === "destroy" ? "n already-" : " ";
  return [t + "() was called on a" + e + "destroyed instance. This is a no-op but", "indicates a potential memory leak."].join(" ");
}
function lU(t) {
  var e = /[ \t]{2,}/g, n = /^[ \t]*/gm;
  return t.replace(e, " ").replace(n, "").trim();
}
function EXe(t) {
  return lU(`
  %ctippy.js

  %c` + lU(t) + `

  %c👷‍ This is a development-only message. It will be removed in production.
  `);
}
function Zpe(t) {
  return [
    EXe(t),
    // title
    "color: #00C584; font-size: 1.3em; font-weight: bold;",
    // message
    "line-height: 1.5",
    // footer
    "color: #a6a095;"
  ];
}
var my;
process.env.NODE_ENV !== "production" && SXe();
function SXe() {
  my = /* @__PURE__ */ new Set();
}
function cl(t, e) {
  if (t && !my.has(e)) {
    var n;
    my.add(e), (n = console).warn.apply(n, Zpe(e));
  }
}
function nj(t, e) {
  if (t && !my.has(e)) {
    var n;
    my.add(e), (n = console).error.apply(n, Zpe(e));
  }
}
function OXe(t) {
  var e = !t, n = Object.prototype.toString.call(t) === "[object Object]" && !t.addEventListener;
  nj(e, ["tippy() was passed", "`" + String(t) + "`", "as its targets (first) argument. Valid types are: String, Element,", "Element[], or NodeList."].join(" ")), nj(n, ["tippy() was passed a plain object which is not supported as an argument", "for virtual positioning. Use props.getReferenceClientRect instead."].join(" "));
}
var Jpe = {
  animateFill: !1,
  followCursor: !1,
  inlinePositioning: !1,
  sticky: !1
}, CXe = {
  allowHTML: !1,
  animation: "fade",
  arrow: !0,
  content: "",
  inertia: !1,
  maxWidth: 350,
  role: "tooltip",
  theme: "",
  zIndex: 9999
}, yi = Object.assign({
  appendTo: Kpe,
  aria: {
    content: "auto",
    expanded: "auto"
  },
  delay: 0,
  duration: [300, 250],
  getReferenceClientRect: null,
  hideOnClick: !0,
  ignoreAttributes: !1,
  interactive: !1,
  interactiveBorder: 2,
  interactiveDebounce: 0,
  moveTransition: "",
  offset: [0, 10],
  onAfterUpdate: function() {
  },
  onBeforeUpdate: function() {
  },
  onCreate: function() {
  },
  onDestroy: function() {
  },
  onHidden: function() {
  },
  onHide: function() {
  },
  onMount: function() {
  },
  onShow: function() {
  },
  onShown: function() {
  },
  onTrigger: function() {
  },
  onUntrigger: function() {
  },
  onClickOutside: function() {
  },
  placement: "top",
  plugins: [],
  popperOptions: {},
  render: null,
  showOnCreate: !1,
  touch: !0,
  trigger: "mouseenter focus",
  triggerTarget: null
}, Jpe, CXe), kXe = Object.keys(yi), AXe = function(t) {
  process.env.NODE_ENV !== "production" && tme(t, []);
  var e = Object.keys(t);
  e.forEach(function(n) {
    yi[n] = t[n];
  });
};
function eme(t) {
  var e = t.plugins || [], n = e.reduce(function(r, o) {
    var i = o.name, s = o.defaultValue;
    if (i) {
      var a;
      r[i] = t[i] !== void 0 ? t[i] : (a = yi[i]) != null ? a : s;
    }
    return r;
  }, {});
  return Object.assign({}, t, n);
}
function TXe(t, e) {
  var n = e ? Object.keys(eme(Object.assign({}, yi, {
    plugins: e
  }))) : kXe, r = n.reduce(function(o, i) {
    var s = (t.getAttribute("data-tippy-" + i) || "").trim();
    if (!s)
      return o;
    if (i === "content")
      o[i] = s;
    else
      try {
        o[i] = JSON.parse(s);
      } catch {
        o[i] = s;
      }
    return o;
  }, {});
  return r;
}
function cU(t, e) {
  var n = Object.assign({}, e, {
    content: Xpe(e.content, [t])
  }, e.ignoreAttributes ? {} : TXe(t, e.plugins));
  return n.aria = Object.assign({}, yi.aria, n.aria), n.aria = {
    expanded: n.aria.expanded === "auto" ? e.interactive : n.aria.expanded,
    content: n.aria.content === "auto" ? e.interactive ? null : "describedby" : n.aria.content
  }, n;
}
function tme(t, e) {
  t === void 0 && (t = {}), e === void 0 && (e = []);
  var n = Object.keys(t);
  n.forEach(function(r) {
    var o = aXe(yi, Object.keys(Jpe)), i = !sXe(o, r);
    i && (i = e.filter(function(s) {
      return s.name === r;
    }).length === 0), cl(i, ["`" + r + "`", "is not a valid prop. You may have spelled it incorrectly, or if it's", "a plugin, forgot to pass it in an array as props.plugins.", `

`, `All props: https://atomiks.github.io/tippyjs/v6/all-props/
`, "Plugins: https://atomiks.github.io/tippyjs/v6/plugins/"].join(" "));
  });
}
function uU(t) {
  var e = t.firstElementChild, n = nE(e.children);
  return {
    box: e,
    content: n.find(function(r) {
      return r.classList.contains(nXe);
    }),
    arrow: n.find(function(r) {
      return r.classList.contains(oXe) || r.classList.contains(iXe);
    }),
    backdrop: n.find(function(r) {
      return r.classList.contains(rXe);
    })
  };
}
var RXe = 1, t1 = [], Wk = [];
function PXe(t, e) {
  var n = cU(t, Object.assign({}, yi, eme(oU(e)))), r, o, i, s = !1, a = !1, l = !1, c = !1, u, d, f, h = [], p = nU(K, n.interactiveDebounce), m, g = RXe++, y = null, v = cXe(n.plugins), b = {
    // Is the instance currently enabled?
    isEnabled: !0,
    // Is the tippy currently showing and not transitioning out?
    isVisible: !1,
    // Has the instance been destroyed?
    isDestroyed: !1,
    // Is the tippy currently mounted to the DOM?
    isMounted: !1,
    // Has the tippy finished transitioning in?
    isShown: !1
  }, _ = {
    // properties
    id: g,
    reference: t,
    popper: dXe(),
    popperInstance: y,
    props: n,
    state: b,
    plugins: v,
    // methods
    clearDelayTimeouts: nt,
    setProps: ct,
    setContent: mt,
    show: gt,
    hide: Et,
    hideWithInteractivity: Rt,
    enable: Je,
    disable: Ie,
    unmount: zt,
    destroy: At
  };
  if (!n.render)
    return process.env.NODE_ENV !== "production" && nj(!0, "render() function has not been supplied."), _;
  var w = n.render(_), x = w.popper, E = w.onUpdate;
  x.setAttribute("data-tippy-root", ""), x.id = "tippy-" + _.id, _.popper = x, t._tippy = _, x._tippy = _;
  var S = v.map(function(X) {
    return X.fn(_);
  }), C = t.hasAttribute("aria-expanded");
  return Y(), $(), I(), j("onCreate", [_]), n.showOnCreate && Le(), x.addEventListener("mouseenter", function() {
    _.props.interactive && _.state.isVisible && _.clearDelayTimeouts();
  }), x.addEventListener("mouseleave", function() {
    _.props.interactive && _.props.trigger.indexOf("mouseenter") >= 0 && O().addEventListener("mousemove", p);
  }), _;
  function R() {
    var X = _.props.touch;
    return Array.isArray(X) ? X : [X, 0];
  }
  function P() {
    return R()[0] === "hold";
  }
  function N() {
    var X;
    return !!((X = _.props.render) != null && X.$$tippy);
  }
  function A() {
    return m || t;
  }
  function O() {
    var X = A().parentNode;
    return X ? gXe(X) : document;
  }
  function k() {
    return uU(x);
  }
  function T(X) {
    return _.state.isMounted && !_.state.isVisible || ia.isTouch || u && u.type === "focus" ? 0 : Uk(_.props.delay, X ? 0 : 1, yi.delay);
  }
  function I(X) {
    X === void 0 && (X = !1), x.style.pointerEvents = _.props.interactive && !X ? "" : "none", x.style.zIndex = "" + _.props.zIndex;
  }
  function j(X, ae, ye) {
    if (ye === void 0 && (ye = !0), S.forEach(function(Te) {
      Te[X] && Te[X].apply(Te, ae);
    }), ye) {
      var De;
      (De = _.props)[X].apply(De, ae);
    }
  }
  function z() {
    var X = _.props.aria;
    if (X.content) {
      var ae = "aria-" + X.content, ye = x.id, De = jf(_.props.triggerTarget || t);
      De.forEach(function(Te) {
        var st = Te.getAttribute(ae);
        if (_.state.isVisible)
          Te.setAttribute(ae, st ? st + " " + ye : ye);
        else {
          var ft = st && st.replace(ye, "").trim();
          ft ? Te.setAttribute(ae, ft) : Te.removeAttribute(ae);
        }
      });
    }
  }
  function $() {
    if (!(C || !_.props.aria.expanded)) {
      var X = jf(_.props.triggerTarget || t);
      X.forEach(function(ae) {
        _.props.interactive ? ae.setAttribute("aria-expanded", _.state.isVisible && ae === A() ? "true" : "false") : ae.removeAttribute("aria-expanded");
      });
    }
  }
  function D() {
    O().removeEventListener("mousemove", p), t1 = t1.filter(function(X) {
      return X !== p;
    });
  }
  function U(X) {
    if (!(ia.isTouch && (l || X.type === "mousedown"))) {
      var ae = X.composedPath && X.composedPath()[0] || X.target;
      if (!(_.props.interactive && sU(x, ae))) {
        if (jf(_.props.triggerTarget || t).some(function(ye) {
          return sU(ye, ae);
        })) {
          if (ia.isTouch || _.state.isVisible && _.props.trigger.indexOf("click") >= 0)
            return;
        } else
          j("onClickOutside", [_, X]);
        _.props.hideOnClick === !0 && (_.clearDelayTimeouts(), _.hide(), a = !0, setTimeout(function() {
          a = !1;
        }), _.state.isMounted || H());
      }
    }
  }
  function q() {
    l = !0;
  }
  function F() {
    l = !1;
  }
  function B() {
    var X = O();
    X.addEventListener("mousedown", U, !0), X.addEventListener("touchend", U, Bu), X.addEventListener("touchstart", F, Bu), X.addEventListener("touchmove", q, Bu);
  }
  function H() {
    var X = O();
    X.removeEventListener("mousedown", U, !0), X.removeEventListener("touchend", U, Bu), X.removeEventListener("touchstart", F, Bu), X.removeEventListener("touchmove", q, Bu);
  }
  function Z(X, ae) {
    G(X, function() {
      !_.state.isVisible && x.parentNode && x.parentNode.contains(x) && ae();
    });
  }
  function W(X, ae) {
    G(X, ae);
  }
  function G(X, ae) {
    var ye = k().box;
    function De(Te) {
      Te.target === ye && (Vk(ye, "remove", De), ae());
    }
    if (X === 0)
      return ae();
    Vk(ye, "remove", d), Vk(ye, "add", De), d = De;
  }
  function ee(X, ae, ye) {
    ye === void 0 && (ye = !1);
    var De = jf(_.props.triggerTarget || t);
    De.forEach(function(Te) {
      Te.addEventListener(X, ae, ye), h.push({
        node: Te,
        eventType: X,
        handler: ae,
        options: ye
      });
    });
  }
  function Y() {
    P() && (ee("touchstart", V, {
      passive: !0
    }), ee("touchend", ne, {
      passive: !0
    })), lXe(_.props.trigger).forEach(function(X) {
      if (X !== "manual")
        switch (ee(X, V), X) {
          case "mouseenter":
            ee("mouseleave", ne);
            break;
          case "focus":
            ee(xXe ? "focusout" : "blur", ce);
            break;
          case "focusin":
            ee("focusout", ce);
            break;
        }
    });
  }
  function L() {
    h.forEach(function(X) {
      var ae = X.node, ye = X.eventType, De = X.handler, Te = X.options;
      ae.removeEventListener(ye, De, Te);
    }), h = [];
  }
  function V(X) {
    var ae, ye = !1;
    if (!(!_.state.isEnabled || fe(X) || a)) {
      var De = ((ae = u) == null ? void 0 : ae.type) === "focus";
      u = X, m = X.currentTarget, $(), !_.state.isVisible && hXe(X) && t1.forEach(function(Te) {
        return Te(X);
      }), X.type === "click" && (_.props.trigger.indexOf("mouseenter") < 0 || s) && _.props.hideOnClick !== !1 && _.state.isVisible ? ye = !0 : Le(X), X.type === "click" && (s = !ye), ye && !De && Ce(X);
    }
  }
  function K(X) {
    var ae = X.target, ye = A().contains(ae) || x.contains(ae);
    if (!(X.type === "mousemove" && ye)) {
      var De = Me().concat(x).map(function(Te) {
        var st, ft = Te._tippy, Ht = (st = ft.popperInstance) == null ? void 0 : st.state;
        return Ht ? {
          popperRect: Te.getBoundingClientRect(),
          popperState: Ht,
          props: n
        } : null;
      }).filter(Boolean);
      yXe(De, X) && (D(), Ce(X));
    }
  }
  function ne(X) {
    var ae = fe(X) || _.props.trigger.indexOf("click") >= 0 && s;
    if (!ae) {
      if (_.props.interactive) {
        _.hideWithInteractivity(X);
        return;
      }
      Ce(X);
    }
  }
  function ce(X) {
    _.props.trigger.indexOf("focusin") < 0 && X.target !== A() || _.props.interactive && X.relatedTarget && x.contains(X.relatedTarget) || Ce(X);
  }
  function fe(X) {
    return ia.isTouch ? P() !== X.type.indexOf("touch") >= 0 : !1;
  }
  function ve() {
    _e();
    var X = _.props, ae = X.popperOptions, ye = X.placement, De = X.offset, Te = X.getReferenceClientRect, st = X.moveTransition, ft = N() ? uU(x).arrow : null, Ht = Te ? {
      getBoundingClientRect: Te,
      contextElement: Te.contextElement || A()
    } : t, nn = {
      name: "$$tippy",
      enabled: !0,
      phase: "beforeWrite",
      requires: ["computeStyles"],
      fn: function(Rn) {
        var yt = Rn.state;
        if (N()) {
          var oe = k(), ge = oe.box;
          ["placement", "reference-hidden", "escaped"].forEach(function(pe) {
            pe === "placement" ? ge.setAttribute("data-placement", yt.placement) : yt.attributes.popper["data-popper-" + pe] ? ge.setAttribute("data-" + pe, "") : ge.removeAttribute("data-" + pe);
          }), yt.attributes.popper = {};
        }
      }
    }, It = [{
      name: "offset",
      options: {
        offset: De
      }
    }, {
      name: "preventOverflow",
      options: {
        padding: {
          top: 2,
          bottom: 2,
          left: 5,
          right: 5
        }
      }
    }, {
      name: "flip",
      options: {
        padding: 5
      }
    }, {
      name: "computeStyles",
      options: {
        adaptive: !st
      }
    }, nn];
    N() && ft && It.push({
      name: "arrow",
      options: {
        element: ft,
        padding: 3
      }
    }), It.push.apply(It, ae?.modifiers || []), _.popperInstance = Ple(Ht, x, Object.assign({}, ae, {
      placement: ye,
      onFirstUpdate: f,
      modifiers: It
    }));
  }
  function _e() {
    _.popperInstance && (_.popperInstance.destroy(), _.popperInstance = null);
  }
  function Ee() {
    var X = _.props.appendTo, ae, ye = A();
    _.props.interactive && X === Kpe || X === "parent" ? ae = ye.parentNode : ae = Xpe(X, [ye]), ae.contains(x) || ae.appendChild(x), _.state.isMounted = !0, ve(), process.env.NODE_ENV !== "production" && cl(_.props.interactive && X === yi.appendTo && ye.nextElementSibling !== x, ["Interactive tippy element may not be accessible via keyboard", "navigation because it is not directly after the reference element", "in the DOM source order.", `

`, "Using a wrapper <div> or <span> tag around the reference element", "solves this by creating a new parentNode context.", `

`, "Specifying `appendTo: document.body` silences this warning, but it", "assumes you are using a focus management solution to handle", "keyboard navigation.", `

`, "See: https://atomiks.github.io/tippyjs/v6/accessibility/#interactivity"].join(" "));
  }
  function Me() {
    return nE(x.querySelectorAll("[data-tippy-root]"));
  }
  function Le(X) {
    _.clearDelayTimeouts(), X && j("onTrigger", [_, X]), B();
    var ae = T(!0), ye = R(), De = ye[0], Te = ye[1];
    ia.isTouch && De === "hold" && Te && (ae = Te), ae ? r = setTimeout(function() {
      _.show();
    }, ae) : _.show();
  }
  function Ce(X) {
    if (_.clearDelayTimeouts(), j("onUntrigger", [_, X]), !_.state.isVisible) {
      H();
      return;
    }
    if (!(_.props.trigger.indexOf("mouseenter") >= 0 && _.props.trigger.indexOf("click") >= 0 && ["mouseleave", "mousemove"].indexOf(X.type) >= 0 && s)) {
      var ae = T(!1);
      ae ? o = setTimeout(function() {
        _.state.isVisible && _.hide();
      }, ae) : i = requestAnimationFrame(function() {
        _.hide();
      });
    }
  }
  function Je() {
    _.state.isEnabled = !0;
  }
  function Ie() {
    _.hide(), _.state.isEnabled = !1;
  }
  function nt() {
    clearTimeout(r), clearTimeout(o), cancelAnimationFrame(i);
  }
  function ct(X) {
    if (process.env.NODE_ENV !== "production" && cl(_.state.isDestroyed, xf("setProps")), !_.state.isDestroyed) {
      j("onBeforeUpdate", [_, X]), L();
      var ae = _.props, ye = cU(t, Object.assign({}, ae, oU(X), {
        ignoreAttributes: !0
      }));
      _.props = ye, Y(), ae.interactiveDebounce !== ye.interactiveDebounce && (D(), p = nU(K, ye.interactiveDebounce)), ae.triggerTarget && !ye.triggerTarget ? jf(ae.triggerTarget).forEach(function(De) {
        De.removeAttribute("aria-expanded");
      }) : ye.triggerTarget && t.removeAttribute("aria-expanded"), $(), I(), E && E(ae, ye), _.popperInstance && (ve(), Me().forEach(function(De) {
        requestAnimationFrame(De._tippy.popperInstance.forceUpdate);
      })), j("onAfterUpdate", [_, X]);
    }
  }
  function mt(X) {
    _.setProps({
      content: X
    });
  }
  function gt() {
    process.env.NODE_ENV !== "production" && cl(_.state.isDestroyed, xf("show"));
    var X = _.state.isVisible, ae = _.state.isDestroyed, ye = !_.state.isEnabled, De = ia.isTouch && !_.props.touch, Te = Uk(_.props.duration, 0, yi.duration);
    if (!(X || ae || ye || De) && !A().hasAttribute("disabled") && (j("onShow", [_], !1), _.props.onShow(_) !== !1)) {
      if (_.state.isVisible = !0, N() && (x.style.visibility = "visible"), I(), B(), _.state.isMounted || (x.style.transition = "none"), N()) {
        var st = k(), ft = st.box, Ht = st.content;
        Hk([ft, Ht], 0);
      }
      f = function() {
        var nn;
        if (!(!_.state.isVisible || c)) {
          if (c = !0, x.offsetHeight, x.style.transition = _.props.moveTransition, N() && _.props.animation) {
            var It = k(), Rn = It.box, yt = It.content;
            Hk([Rn, yt], Te), iU([Rn, yt], "visible");
          }
          z(), $(), rU(Wk, _), (nn = _.popperInstance) == null || nn.forceUpdate(), j("onMount", [_]), _.props.animation && N() && W(Te, function() {
            _.state.isShown = !0, j("onShown", [_]);
          });
        }
      }, Ee();
    }
  }
  function Et() {
    process.env.NODE_ENV !== "production" && cl(_.state.isDestroyed, xf("hide"));
    var X = !_.state.isVisible, ae = _.state.isDestroyed, ye = !_.state.isEnabled, De = Uk(_.props.duration, 1, yi.duration);
    if (!(X || ae || ye) && (j("onHide", [_], !1), _.props.onHide(_) !== !1)) {
      if (_.state.isVisible = !1, _.state.isShown = !1, c = !1, s = !1, N() && (x.style.visibility = "hidden"), D(), H(), I(!0), N()) {
        var Te = k(), st = Te.box, ft = Te.content;
        _.props.animation && (Hk([st, ft], De), iU([st, ft], "hidden"));
      }
      z(), $(), _.props.animation ? N() && Z(De, _.unmount) : _.unmount();
    }
  }
  function Rt(X) {
    process.env.NODE_ENV !== "production" && cl(_.state.isDestroyed, xf("hideWithInteractivity")), O().addEventListener("mousemove", p), rU(t1, p), p(X);
  }
  function zt() {
    process.env.NODE_ENV !== "production" && cl(_.state.isDestroyed, xf("unmount")), _.state.isVisible && _.hide(), _.state.isMounted && (_e(), Me().forEach(function(X) {
      X._tippy.unmount();
    }), x.parentNode && x.parentNode.removeChild(x), Wk = Wk.filter(function(X) {
      return X !== _;
    }), _.state.isMounted = !1, j("onHidden", [_]));
  }
  function At() {
    process.env.NODE_ENV !== "production" && cl(_.state.isDestroyed, xf("destroy")), !_.state.isDestroyed && (_.clearDelayTimeouts(), _.unmount(), L(), delete t._tippy, _.state.isDestroyed = !0, j("onDestroy", [_]));
  }
}
function Sv(t, e) {
  e === void 0 && (e = {});
  var n = yi.plugins.concat(e.plugins || []);
  process.env.NODE_ENV !== "production" && (OXe(t), tme(e, n)), _Xe();
  var r = Object.assign({}, e, {
    plugins: n
  }), o = mXe(t);
  if (process.env.NODE_ENV !== "production") {
    var i = tj(r.content), s = o.length > 1;
    cl(i && s, ["tippy() was passed an Element as the `content` prop, but more than", "one tippy instance was created by this invocation. This means the", "content element will only be appended to the last tippy instance.", `

`, "Instead, pass the .innerHTML of the element, or use a function that", "returns a cloned version of the element instead.", `

`, `1) content: element.innerHTML
`, "2) content: () => element.cloneNode(true)"].join(" "));
  }
  var a = o.reduce(function(l, c) {
    var u = c && PXe(c, r);
    return u && l.push(u), l;
  }, []);
  return tj(t) ? a[0] : a;
}
Sv.defaultProps = yi;
Sv.setDefaultProps = AXe;
Sv.currentInput = ia;
Object.assign({}, x5, {
  effect: function(t) {
    var e = t.state, n = {
      popper: {
        position: e.options.strategy,
        left: "0",
        top: "0",
        margin: "0"
      },
      arrow: {
        position: "absolute"
      },
      reference: {}
    };
    Object.assign(e.elements.popper.style, n.popper), e.styles = n, e.elements.arrow && Object.assign(e.elements.arrow.style, n.arrow);
  }
});
Sv.setDefaultProps({
  animation: !1
});
function nme(t, e) {
  if (t == null) return {};
  var n = {}, r = Object.keys(t), o, i;
  for (i = 0; i < r.length; i++)
    o = r[i], !(e.indexOf(o) >= 0) && (n[o] = t[o]);
  return n;
}
var rme = typeof window < "u" && typeof document < "u";
function rj(t, e) {
  t && (typeof t == "function" && t(e), {}.hasOwnProperty.call(t, "current") && (t.current = e));
}
function dU() {
  return rme && document.createElement("div");
}
function $Xe(t) {
  var e = {
    "data-placement": t.placement
  };
  return t.referenceHidden && (e["data-reference-hidden"] = ""), t.escaped && (e["data-escaped"] = ""), e;
}
function ome(t, e) {
  if (t === e)
    return !0;
  if (typeof t == "object" && t != null && typeof e == "object" && e != null) {
    if (Object.keys(t).length !== Object.keys(e).length)
      return !1;
    for (var n in t)
      if (e.hasOwnProperty(n)) {
        if (!ome(t[n], e[n]))
          return !1;
      } else
        return !1;
    return !0;
  } else
    return !1;
}
function MXe(t) {
  var e = [];
  return t.forEach(function(n) {
    e.find(function(r) {
      return ome(n, r);
    }) || e.push(n);
  }), e;
}
function DXe(t, e) {
  var n, r;
  return Object.assign({}, e, {
    popperOptions: Object.assign({}, t.popperOptions, e.popperOptions, {
      modifiers: MXe([].concat(((n = t.popperOptions) == null ? void 0 : n.modifiers) || [], ((r = e.popperOptions) == null ? void 0 : r.modifiers) || []))
    })
  });
}
var Gk = rme ? iu : Ne;
function IXe(t) {
  var e = Ue();
  return e.current || (e.current = typeof t == "function" ? t() : t), e.current;
}
function fU(t, e, n) {
  n.split(/\s+/).forEach(function(r) {
    r && t.classList[e](r);
  });
}
var NXe = {
  name: "className",
  defaultValue: "",
  fn: function(t) {
    var e = t.popper.firstElementChild, n = function() {
      var i;
      return !!((i = t.props.render) != null && i.$$tippy);
    };
    function r() {
      if (t.props.className && !n()) {
        process.env.NODE_ENV !== "production" && console.warn(["@tippyjs/react: Cannot use `className` prop in conjunction with", "`render` prop. Place the className on the element you are", "rendering."].join(" "));
        return;
      }
      fU(e, "add", t.props.className);
    }
    function o() {
      n() && fU(e, "remove", t.props.className);
    }
    return {
      onCreate: r,
      onBeforeUpdate: o,
      onAfterUpdate: r
    };
  }
};
function jXe(t) {
  function e(n) {
    var r = n.children, o = n.content, i = n.visible, s = n.singleton, a = n.render, l = n.reference, c = n.disabled, u = c === void 0 ? !1 : c, d = n.ignoreAttributes, f = d === void 0 ? !0 : d;
    n.__source, n.__self;
    var h = nme(n, ["children", "content", "visible", "singleton", "render", "reference", "disabled", "ignoreAttributes", "__source", "__self"]), p = i !== void 0, m = s !== void 0, g = Ye(!1), y = g[0], v = g[1], b = Ye({}), _ = b[0], w = b[1], x = Ye(), E = x[0], S = x[1], C = IXe(function() {
      return {
        container: dU(),
        renders: 1
      };
    }), R = Object.assign({
      ignoreAttributes: f
    }, h, {
      content: C.container
    });
    p && (process.env.NODE_ENV !== "production" && ["trigger", "hideOnClick", "showOnCreate"].forEach(function(O) {
      R[O] !== void 0 && console.warn(["@tippyjs/react: Cannot specify `" + O + "` prop in", "controlled mode (`visible` prop)"].join(" "));
    }), R.trigger = "manual", R.hideOnClick = !1), m && (u = !0);
    var P = R, N = R.plugins || [];
    a && (P = Object.assign({}, R, {
      plugins: m && s.data != null ? [].concat(N, [{
        fn: function() {
          return {
            onTrigger: function(O, k) {
              var T = s.data.children.find(function(I) {
                var j = I.instance;
                return j.reference === k.currentTarget;
              });
              O.state.$$activeSingletonInstance = T.instance, S(T.content);
            }
          };
        }
      }]) : N,
      render: function() {
        return {
          popper: C.container
        };
      }
    }));
    var A = [l].concat(r ? [r.type] : []);
    return Gk(function() {
      var O = l;
      l && l.hasOwnProperty("current") && (O = l.current);
      var k = t(O || C.ref || dU(), Object.assign({}, P, {
        plugins: [NXe].concat(R.plugins || [])
      }));
      return C.instance = k, u && k.disable(), i && k.show(), m && s.hook({
        instance: k,
        content: o,
        props: P,
        setSingletonContent: S
      }), v(!0), function() {
        k.destroy(), s?.cleanup(k);
      };
    }, A), Gk(function() {
      var O;
      if (C.renders === 1) {
        C.renders++;
        return;
      }
      var k = C.instance;
      k.setProps(DXe(k.props, P)), (O = k.popperInstance) == null || O.forceUpdate(), u ? k.disable() : k.enable(), p && (i ? k.show() : k.hide()), m && s.hook({
        instance: k,
        content: o,
        props: P,
        setSingletonContent: S
      });
    }), Gk(function() {
      var O;
      if (a) {
        var k = C.instance;
        k.setProps({
          popperOptions: Object.assign({}, k.props.popperOptions, {
            modifiers: [].concat((((O = k.props.popperOptions) == null ? void 0 : O.modifiers) || []).filter(function(T) {
              var I = T.name;
              return I !== "$$tippyReact";
            }), [{
              name: "$$tippyReact",
              enabled: !0,
              phase: "beforeWrite",
              requires: ["computeStyles"],
              fn: function(T) {
                var I, j = T.state, z = (I = j.modifiersData) == null ? void 0 : I.hide;
                (_.placement !== j.placement || _.referenceHidden !== z?.isReferenceHidden || _.escaped !== z?.hasPopperEscaped) && w({
                  placement: j.placement,
                  referenceHidden: z?.isReferenceHidden,
                  escaped: z?.hasPopperEscaped
                }), j.attributes.popper = {};
              }
            }])
          })
        });
      }
    }, [_.placement, _.referenceHidden, _.escaped].concat(A)), /* @__PURE__ */ xe.createElement(xe.Fragment, null, r ? /* @__PURE__ */ Gi(r, {
      ref: function(O) {
        C.ref = O, rj(r.ref, O);
      }
    }) : null, y && /* @__PURE__ */ XE(a ? a($Xe(_), E, C.instance) : o, C.container));
  }
  return e;
}
var LXe = function(t, e) {
  return /* @__PURE__ */ Ri(function(n, r) {
    var o = n.children, i = nme(n, ["children"]);
    return (
      // If I spread them separately here, Babel adds the _extends ponyfill for
      // some reason
      /* @__PURE__ */ xe.createElement(t, Object.assign({}, e, i), o ? /* @__PURE__ */ Gi(o, {
        ref: function(s) {
          rj(r, s), rj(o.ref, s);
        }
      }) : null)
    );
  });
}, FXe = /* @__PURE__ */ LXe(/* @__PURE__ */ jXe(Sv), {
  render: function() {
    return "";
  }
}), rc = {}, Br = {}, No = {}, JL = {};
(function t(e, n, r, o) {
  var i = !!(e.Worker && e.Blob && e.Promise && e.OffscreenCanvas && e.OffscreenCanvasRenderingContext2D && e.HTMLCanvasElement && e.HTMLCanvasElement.prototype.transferControlToOffscreen && e.URL && e.URL.createObjectURL), s = typeof Path2D == "function" && typeof DOMMatrix == "function", a = function() {
    if (!e.OffscreenCanvas)
      return !1;
    var $ = new OffscreenCanvas(1, 1), D = $.getContext("2d");
    D.fillRect(0, 0, 1, 1);
    var U = $.transferToImageBitmap();
    try {
      D.createPattern(U, "no-repeat");
    } catch {
      return !1;
    }
    return !0;
  }();
  function l() {
  }
  function c($) {
    var D = n.exports.Promise, U = D !== void 0 ? D : e.Promise;
    return typeof U == "function" ? new U($) : ($(l, l), null);
  }
  var u = /* @__PURE__ */ function($, D) {
    return {
      transform: function(U) {
        if ($)
          return U;
        if (D.has(U))
          return D.get(U);
        var q = new OffscreenCanvas(U.width, U.height), F = q.getContext("2d");
        return F.drawImage(U, 0, 0), D.set(U, q), q;
      },
      clear: function() {
        D.clear();
      }
    };
  }(a, /* @__PURE__ */ new Map()), d = function() {
    var $ = Math.floor(16.666666666666668), D, U, q = {}, F = 0;
    return typeof requestAnimationFrame == "function" && typeof cancelAnimationFrame == "function" ? (D = function(B) {
      var H = Math.random();
      return q[H] = requestAnimationFrame(function Z(W) {
        F === W || F + $ - 1 < W ? (F = W, delete q[H], B()) : q[H] = requestAnimationFrame(Z);
      }), H;
    }, U = function(B) {
      q[B] && cancelAnimationFrame(q[B]);
    }) : (D = function(B) {
      return setTimeout(B, $);
    }, U = function(B) {
      return clearTimeout(B);
    }), { frame: D, cancel: U };
  }(), f = /* @__PURE__ */ function() {
    var $, D, U = {};
    function q(F) {
      function B(H, Z) {
        F.postMessage({ options: H || {}, callback: Z });
      }
      F.init = function(H) {
        var Z = H.transferControlToOffscreen();
        F.postMessage({ canvas: Z }, [Z]);
      }, F.fire = function(H, Z, W) {
        if (D)
          return B(H, null), D;
        var G = Math.random().toString(36).slice(2);
        return D = c(function(ee) {
          function Y(L) {
            L.data.callback === G && (delete U[G], F.removeEventListener("message", Y), D = null, u.clear(), W(), ee());
          }
          F.addEventListener("message", Y), B(H, G), U[G] = Y.bind(null, { data: { callback: G } });
        }), D;
      }, F.reset = function() {
        F.postMessage({ reset: !0 });
        for (var H in U)
          U[H](), delete U[H];
      };
    }
    return function() {
      if ($)
        return $;
      if (!r && i) {
        var F = [
          "var CONFETTI, SIZE = {}, module = {};",
          "(" + t.toString() + ")(this, module, true, SIZE);",
          "onmessage = function(msg) {",
          "  if (msg.data.options) {",
          "    CONFETTI(msg.data.options).then(function () {",
          "      if (msg.data.callback) {",
          "        postMessage({ callback: msg.data.callback });",
          "      }",
          "    });",
          "  } else if (msg.data.reset) {",
          "    CONFETTI && CONFETTI.reset();",
          "  } else if (msg.data.resize) {",
          "    SIZE.width = msg.data.resize.width;",
          "    SIZE.height = msg.data.resize.height;",
          "  } else if (msg.data.canvas) {",
          "    SIZE.width = msg.data.canvas.width;",
          "    SIZE.height = msg.data.canvas.height;",
          "    CONFETTI = module.exports.create(msg.data.canvas);",
          "  }",
          "}"
        ].join(`
`);
        try {
          $ = new Worker(URL.createObjectURL(new Blob([F])));
        } catch (B) {
          return typeof console !== void 0 && typeof console.warn == "function" && console.warn("🎊 Could not load worker", B), null;
        }
        q($);
      }
      return $;
    };
  }(), h = {
    particleCount: 50,
    angle: 90,
    spread: 45,
    startVelocity: 45,
    decay: 0.9,
    gravity: 1,
    drift: 0,
    ticks: 200,
    x: 0.5,
    y: 0.5,
    shapes: ["square", "circle"],
    zIndex: 100,
    colors: [
      "#26ccff",
      "#a25afd",
      "#ff5e7e",
      "#88ff5a",
      "#fcff42",
      "#ffa62d",
      "#ff36ff"
    ],
    // probably should be true, but back-compat
    disableForReducedMotion: !1,
    scalar: 1
  };
  function p($, D) {
    return D ? D($) : $;
  }
  function m($) {
    return $ != null;
  }
  function g($, D, U) {
    return p(
      $ && m($[D]) ? $[D] : h[D],
      U
    );
  }
  function y($) {
    return $ < 0 ? 0 : Math.floor($);
  }
  function v($, D) {
    return Math.floor(Math.random() * (D - $)) + $;
  }
  function b($) {
    return parseInt($, 16);
  }
  function _($) {
    return $.map(w);
  }
  function w($) {
    var D = String($).replace(/[^0-9a-f]/gi, "");
    return D.length < 6 && (D = D[0] + D[0] + D[1] + D[1] + D[2] + D[2]), {
      r: b(D.substring(0, 2)),
      g: b(D.substring(2, 4)),
      b: b(D.substring(4, 6))
    };
  }
  function x($) {
    var D = g($, "origin", Object);
    return D.x = g(D, "x", Number), D.y = g(D, "y", Number), D;
  }
  function E($) {
    $.width = document.documentElement.clientWidth, $.height = document.documentElement.clientHeight;
  }
  function S($) {
    var D = $.getBoundingClientRect();
    $.width = D.width, $.height = D.height;
  }
  function C($) {
    var D = document.createElement("canvas");
    return D.style.position = "fixed", D.style.top = "0px", D.style.left = "0px", D.style.pointerEvents = "none", D.style.zIndex = $, D;
  }
  function R($, D, U, q, F, B, H, Z, W) {
    $.save(), $.translate(D, U), $.rotate(B), $.scale(q, F), $.arc(0, 0, 1, H, Z, W), $.restore();
  }
  function P($) {
    var D = $.angle * (Math.PI / 180), U = $.spread * (Math.PI / 180);
    return {
      x: $.x,
      y: $.y,
      wobble: Math.random() * 10,
      wobbleSpeed: Math.min(0.11, Math.random() * 0.1 + 0.05),
      velocity: $.startVelocity * 0.5 + Math.random() * $.startVelocity,
      angle2D: -D + (0.5 * U - Math.random() * U),
      tiltAngle: (Math.random() * (0.75 - 0.25) + 0.25) * Math.PI,
      color: $.color,
      shape: $.shape,
      tick: 0,
      totalTicks: $.ticks,
      decay: $.decay,
      drift: $.drift,
      random: Math.random() + 2,
      tiltSin: 0,
      tiltCos: 0,
      wobbleX: 0,
      wobbleY: 0,
      gravity: $.gravity * 3,
      ovalScalar: 0.6,
      scalar: $.scalar,
      flat: $.flat
    };
  }
  function N($, D) {
    D.x += Math.cos(D.angle2D) * D.velocity + D.drift, D.y += Math.sin(D.angle2D) * D.velocity + D.gravity, D.velocity *= D.decay, D.flat ? (D.wobble = 0, D.wobbleX = D.x + 10 * D.scalar, D.wobbleY = D.y + 10 * D.scalar, D.tiltSin = 0, D.tiltCos = 0, D.random = 1) : (D.wobble += D.wobbleSpeed, D.wobbleX = D.x + 10 * D.scalar * Math.cos(D.wobble), D.wobbleY = D.y + 10 * D.scalar * Math.sin(D.wobble), D.tiltAngle += 0.1, D.tiltSin = Math.sin(D.tiltAngle), D.tiltCos = Math.cos(D.tiltAngle), D.random = Math.random() + 2);
    var U = D.tick++ / D.totalTicks, q = D.x + D.random * D.tiltCos, F = D.y + D.random * D.tiltSin, B = D.wobbleX + D.random * D.tiltCos, H = D.wobbleY + D.random * D.tiltSin;
    if ($.fillStyle = "rgba(" + D.color.r + ", " + D.color.g + ", " + D.color.b + ", " + (1 - U) + ")", $.beginPath(), s && D.shape.type === "path" && typeof D.shape.path == "string" && Array.isArray(D.shape.matrix))
      $.fill(I(
        D.shape.path,
        D.shape.matrix,
        D.x,
        D.y,
        Math.abs(B - q) * 0.1,
        Math.abs(H - F) * 0.1,
        Math.PI / 10 * D.wobble
      ));
    else if (D.shape.type === "bitmap") {
      var Z = Math.PI / 10 * D.wobble, W = Math.abs(B - q) * 0.1, G = Math.abs(H - F) * 0.1, ee = D.shape.bitmap.width * D.scalar, Y = D.shape.bitmap.height * D.scalar, L = new DOMMatrix([
        Math.cos(Z) * W,
        Math.sin(Z) * W,
        -Math.sin(Z) * G,
        Math.cos(Z) * G,
        D.x,
        D.y
      ]);
      L.multiplySelf(new DOMMatrix(D.shape.matrix));
      var V = $.createPattern(u.transform(D.shape.bitmap), "no-repeat");
      V.setTransform(L), $.globalAlpha = 1 - U, $.fillStyle = V, $.fillRect(
        D.x - ee / 2,
        D.y - Y / 2,
        ee,
        Y
      ), $.globalAlpha = 1;
    } else if (D.shape === "circle")
      $.ellipse ? $.ellipse(D.x, D.y, Math.abs(B - q) * D.ovalScalar, Math.abs(H - F) * D.ovalScalar, Math.PI / 10 * D.wobble, 0, 2 * Math.PI) : R($, D.x, D.y, Math.abs(B - q) * D.ovalScalar, Math.abs(H - F) * D.ovalScalar, Math.PI / 10 * D.wobble, 0, 2 * Math.PI);
    else if (D.shape === "star")
      for (var K = Math.PI / 2 * 3, ne = 4 * D.scalar, ce = 8 * D.scalar, fe = D.x, ve = D.y, _e = 5, Ee = Math.PI / _e; _e--; )
        fe = D.x + Math.cos(K) * ce, ve = D.y + Math.sin(K) * ce, $.lineTo(fe, ve), K += Ee, fe = D.x + Math.cos(K) * ne, ve = D.y + Math.sin(K) * ne, $.lineTo(fe, ve), K += Ee;
    else
      $.moveTo(Math.floor(D.x), Math.floor(D.y)), $.lineTo(Math.floor(D.wobbleX), Math.floor(F)), $.lineTo(Math.floor(B), Math.floor(H)), $.lineTo(Math.floor(q), Math.floor(D.wobbleY));
    return $.closePath(), $.fill(), D.tick < D.totalTicks;
  }
  function A($, D, U, q, F) {
    var B = D.slice(), H = $.getContext("2d"), Z, W, G = c(function(ee) {
      function Y() {
        Z = W = null, H.clearRect(0, 0, q.width, q.height), u.clear(), F(), ee();
      }
      function L() {
        r && !(q.width === o.width && q.height === o.height) && (q.width = $.width = o.width, q.height = $.height = o.height), !q.width && !q.height && (U($), q.width = $.width, q.height = $.height), H.clearRect(0, 0, q.width, q.height), B = B.filter(function(V) {
          return N(H, V);
        }), B.length ? Z = d.frame(L) : Y();
      }
      Z = d.frame(L), W = Y;
    });
    return {
      addFettis: function(ee) {
        return B = B.concat(ee), G;
      },
      canvas: $,
      promise: G,
      reset: function() {
        Z && d.cancel(Z), W && W();
      }
    };
  }
  function O($, D) {
    var U = !$, q = !!g(D || {}, "resize"), F = !1, B = g(D, "disableForReducedMotion", Boolean), H = i && !!g(D || {}, "useWorker"), Z = H ? f() : null, W = U ? E : S, G = $ && Z ? !!$.__confetti_initialized : !1, ee = typeof matchMedia == "function" && matchMedia("(prefers-reduced-motion)").matches, Y;
    function L(K, ne, ce) {
      for (var fe = g(K, "particleCount", y), ve = g(K, "angle", Number), _e = g(K, "spread", Number), Ee = g(K, "startVelocity", Number), Me = g(K, "decay", Number), Le = g(K, "gravity", Number), Ce = g(K, "drift", Number), Je = g(K, "colors", _), Ie = g(K, "ticks", Number), nt = g(K, "shapes"), ct = g(K, "scalar"), mt = !!g(K, "flat"), gt = x(K), Et = fe, Rt = [], zt = $.width * gt.x, At = $.height * gt.y; Et--; )
        Rt.push(
          P({
            x: zt,
            y: At,
            angle: ve,
            spread: _e,
            startVelocity: Ee,
            color: Je[Et % Je.length],
            shape: nt[v(0, nt.length)],
            ticks: Ie,
            decay: Me,
            gravity: Le,
            drift: Ce,
            scalar: ct,
            flat: mt
          })
        );
      return Y ? Y.addFettis(Rt) : (Y = A($, Rt, W, ne, ce), Y.promise);
    }
    function V(K) {
      var ne = B || g(K, "disableForReducedMotion", Boolean), ce = g(K, "zIndex", Number);
      if (ne && ee)
        return c(function(Ee) {
          Ee();
        });
      U && Y ? $ = Y.canvas : U && !$ && ($ = C(ce), document.body.appendChild($)), q && !G && W($);
      var fe = {
        width: $.width,
        height: $.height
      };
      Z && !G && Z.init($), G = !0, Z && ($.__confetti_initialized = !0);
      function ve() {
        if (Z) {
          var Ee = {
            getBoundingClientRect: function() {
              if (!U)
                return $.getBoundingClientRect();
            }
          };
          W(Ee), Z.postMessage({
            resize: {
              width: Ee.width,
              height: Ee.height
            }
          });
          return;
        }
        fe.width = fe.height = null;
      }
      function _e() {
        Y = null, q && (F = !1, e.removeEventListener("resize", ve)), U && $ && (document.body.contains($) && document.body.removeChild($), $ = null, G = !1);
      }
      return q && !F && (F = !0, e.addEventListener("resize", ve, !1)), Z ? Z.fire(K, fe, _e) : L(K, fe, _e);
    }
    return V.reset = function() {
      Z && Z.reset(), Y && Y.reset();
    }, V;
  }
  var k;
  function T() {
    return k || (k = O(null, { useWorker: !0, resize: !0 })), k;
  }
  function I($, D, U, q, F, B, H) {
    var Z = new Path2D($), W = new Path2D();
    W.addPath(Z, new DOMMatrix(D));
    var G = new Path2D();
    return G.addPath(W, new DOMMatrix([
      Math.cos(H) * F,
      Math.sin(H) * F,
      -Math.sin(H) * B,
      Math.cos(H) * B,
      U,
      q
    ])), G;
  }
  function j($) {
    if (!s)
      throw new Error("path confetti are not supported in this browser");
    var D, U;
    typeof $ == "string" ? D = $ : (D = $.path, U = $.matrix);
    var q = new Path2D(D), F = document.createElement("canvas"), B = F.getContext("2d");
    if (!U) {
      for (var H = 1e3, Z = H, W = H, G = 0, ee = 0, Y, L, V = 0; V < H; V += 2)
        for (var K = 0; K < H; K += 2)
          B.isPointInPath(q, V, K, "nonzero") && (Z = Math.min(Z, V), W = Math.min(W, K), G = Math.max(G, V), ee = Math.max(ee, K));
      Y = G - Z, L = ee - W;
      var ne = 10, ce = Math.min(ne / Y, ne / L);
      U = [
        ce,
        0,
        0,
        ce,
        -Math.round(Y / 2 + Z) * ce,
        -Math.round(L / 2 + W) * ce
      ];
    }
    return {
      type: "path",
      path: D,
      matrix: U
    };
  }
  function z($) {
    var D, U = 1, q = "#000000", F = '"Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji", "EmojiOne Color", "Android Emoji", "Twemoji Mozilla", "system emoji", sans-serif';
    typeof $ == "string" ? D = $ : (D = $.text, U = "scalar" in $ ? $.scalar : U, F = "fontFamily" in $ ? $.fontFamily : F, q = "color" in $ ? $.color : q);
    var B = 10 * U, H = "" + B + "px " + F, Z = new OffscreenCanvas(B, B), W = Z.getContext("2d");
    W.font = H;
    var G = W.measureText(D), ee = Math.ceil(G.actualBoundingBoxRight + G.actualBoundingBoxLeft), Y = Math.ceil(G.actualBoundingBoxAscent + G.actualBoundingBoxDescent), L = 2, V = G.actualBoundingBoxLeft + L, K = G.actualBoundingBoxAscent + L;
    ee += L + L, Y += L + L, Z = new OffscreenCanvas(ee, Y), W = Z.getContext("2d"), W.font = H, W.fillStyle = q, W.fillText(D, V, K);
    var ne = 1 / U;
    return {
      type: "bitmap",
      // TODO these probably need to be transfered for workers
      bitmap: Z.transferToImageBitmap(),
      matrix: [ne, 0, 0, ne, -ee * ne / 2, -Y * ne / 2]
    };
  }
  n.exports = function() {
    return T().apply(this, arguments);
  }, n.exports.reset = function() {
    T().reset();
  }, n.exports.create = O, n.exports.shapeFromPath = j, n.exports.shapeFromText = z;
})(/* @__PURE__ */ function() {
  return typeof window < "u" ? window : typeof self < "u" ? self : this || {};
}(), JL, !1);
const BXe = JL.exports;
var zXe = JL.exports.create;
const qXe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  create: zXe,
  default: BXe
}, Symbol.toStringTag, { value: "Module" })), UXe = /* @__PURE__ */ Zy(qXe);
var hU;
function HXe() {
  if (hU) return No;
  hU = 1;
  var t = No && No.__assign || function() {
    return t = Object.assign || function(d) {
      for (var f, h = 1, p = arguments.length; h < p; h++) {
        f = arguments[h];
        for (var m in f) Object.prototype.hasOwnProperty.call(f, m) && (d[m] = f[m]);
      }
      return d;
    }, t.apply(this, arguments);
  }, e = No && No.__createBinding || (Object.create ? function(d, f, h, p) {
    p === void 0 && (p = h);
    var m = Object.getOwnPropertyDescriptor(f, h);
    (!m || ("get" in m ? !f.__esModule : m.writable || m.configurable)) && (m = { enumerable: !0, get: function() {
      return f[h];
    } }), Object.defineProperty(d, p, m);
  } : function(d, f, h, p) {
    p === void 0 && (p = h), d[p] = f[h];
  }), n = No && No.__setModuleDefault || (Object.create ? function(d, f) {
    Object.defineProperty(d, "default", { enumerable: !0, value: f });
  } : function(d, f) {
    d.default = f;
  }), r = No && No.__importStar || function(d) {
    if (d && d.__esModule) return d;
    var f = {};
    if (d != null) for (var h in d) h !== "default" && Object.prototype.hasOwnProperty.call(d, h) && e(f, d, h);
    return n(f, d), f;
  }, o = No && No.__importDefault || function(d) {
    return d && d.__esModule ? d : { default: d };
  };
  Object.defineProperty(No, "__esModule", { value: !0 });
  var i = r(xe), s = o(UXe), a = {
    resize: !0,
    useWorker: !1
  }, l = {
    position: "fixed",
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    top: 0,
    left: 0
  };
  function c(d, f) {
    return !d && !f ? l : d;
  }
  function u(d) {
    var f = d.style, h = d.className, p = d.width, m = d.height, g = d.globalOptions, y = d.onInit, v = (0, i.useRef)(null), b = (0, i.useRef)(null);
    return (0, i.useEffect)(function() {
      if (v.current)
        return b.current = s.default.create(v.current, t(t({}, a), g)), y?.({ confetti: b.current }), function() {
          var _;
          (_ = b.current) === null || _ === void 0 || _.reset();
        };
    }, []), i.default.createElement("canvas", { ref: v, style: c(f, h), className: h, width: p, height: m });
  }
  return No.default = u, No;
}
var pU;
function VXe() {
  if (pU) return Br;
  pU = 1;
  var t = Br && Br.__assign || function() {
    return t = Object.assign || function(d) {
      for (var f, h = 1, p = arguments.length; h < p; h++) {
        f = arguments[h];
        for (var m in f) Object.prototype.hasOwnProperty.call(f, m) && (d[m] = f[m]);
      }
      return d;
    }, t.apply(this, arguments);
  }, e = Br && Br.__createBinding || (Object.create ? function(d, f, h, p) {
    p === void 0 && (p = h);
    var m = Object.getOwnPropertyDescriptor(f, h);
    (!m || ("get" in m ? !f.__esModule : m.writable || m.configurable)) && (m = { enumerable: !0, get: function() {
      return f[h];
    } }), Object.defineProperty(d, p, m);
  } : function(d, f, h, p) {
    p === void 0 && (p = h), d[p] = f[h];
  }), n = Br && Br.__setModuleDefault || (Object.create ? function(d, f) {
    Object.defineProperty(d, "default", { enumerable: !0, value: f });
  } : function(d, f) {
    d.default = f;
  }), r = Br && Br.__importStar || function(d) {
    if (d && d.__esModule) return d;
    var f = {};
    if (d != null) for (var h in d) h !== "default" && Object.prototype.hasOwnProperty.call(d, h) && e(f, d, h);
    return n(f, d), f;
  }, o = Br && Br.__rest || function(d, f) {
    var h = {};
    for (var p in d) Object.prototype.hasOwnProperty.call(d, p) && f.indexOf(p) < 0 && (h[p] = d[p]);
    if (d != null && typeof Object.getOwnPropertySymbols == "function")
      for (var m = 0, p = Object.getOwnPropertySymbols(d); m < p.length; m++)
        f.indexOf(p[m]) < 0 && Object.prototype.propertyIsEnumerable.call(d, p[m]) && (h[p[m]] = d[p[m]]);
    return h;
  }, i = Br && Br.__read || function(d, f) {
    var h = typeof Symbol == "function" && d[Symbol.iterator];
    if (!h) return d;
    var p = h.call(d), m, g = [], y;
    try {
      for (; (f === void 0 || f-- > 0) && !(m = p.next()).done; ) g.push(m.value);
    } catch (v) {
      y = { error: v };
    } finally {
      try {
        m && !m.done && (h = p.return) && h.call(p);
      } finally {
        if (y) throw y.error;
      }
    }
    return g;
  }, s = Br && Br.__importDefault || function(d) {
    return d && d.__esModule ? d : { default: d };
  };
  Object.defineProperty(Br, "__esModule", { value: !0 });
  var a = r(xe), l = s(HXe()), c = function(d) {
    return d;
  };
  function u(d) {
    var f = d.decorateOptions, h = f === void 0 ? c : f, p = d.Conductor, m = d.autorun, g = d.onInit, y = o(d, ["decorateOptions", "Conductor", "autorun", "onInit"]), v = i((0, a.useState)(), 2), b = v[0], _ = v[1], w = (0, a.useCallback)(function(x) {
      var E = x.confetti;
      _(function() {
        return E;
      });
    }, []);
    return (0, a.useEffect)(function() {
      if (b) {
        var x = new p({
          confetti: b,
          decorateOptions: h
        });
        return m && x.run(m), g?.({ confetti: b, conductor: x }), x.stop;
      }
    }, [b]), a.default.createElement(l.default, t({ onInit: w }, y));
  }
  return Br.default = u, Br;
}
var Mi = {}, n1 = {}, mU;
function WXe() {
  if (mU) return n1;
  mU = 1, Object.defineProperty(n1, "__esModule", { value: !0 });
  var t = /* @__PURE__ */ function() {
    function e(n) {
      var r = n.confetti, o = n.decorateOptions, i = this;
      this.interval = null, this.shoot = function() {
        return i.tickAnimation();
      }, this.run = function(s) {
        var a = s.speed, l = s.delay, c = l === void 0 ? 0 : l, u = s.duration;
        i.interval || setTimeout(function() {
          i.shoot(), i.interval = setInterval(i.shoot, 1e3 / Math.min(a, 1e3)), u && setTimeout(i.pause, u);
        }, c);
      }, this.pause = function() {
        clearInterval(i.interval), i.interval = null;
      }, this.stop = function() {
        i.pause(), i.confetti.reset();
      }, this.confetti = r, this.decorateOptions = o;
    }
    return e;
  }();
  return n1.default = t, n1;
}
var gU;
function GXe() {
  if (gU) return Mi;
  gU = 1;
  var t = Mi && Mi.__extends || /* @__PURE__ */ function() {
    var s = function(a, l) {
      return s = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(c, u) {
        c.__proto__ = u;
      } || function(c, u) {
        for (var d in u) Object.prototype.hasOwnProperty.call(u, d) && (c[d] = u[d]);
      }, s(a, l);
    };
    return function(a, l) {
      if (typeof l != "function" && l !== null)
        throw new TypeError("Class extends value " + String(l) + " is not a constructor or null");
      s(a, l);
      function c() {
        this.constructor = a;
      }
      a.prototype = l === null ? Object.create(l) : (c.prototype = l.prototype, new c());
    };
  }(), e = Mi && Mi.__read || function(s, a) {
    var l = typeof Symbol == "function" && s[Symbol.iterator];
    if (!l) return s;
    var c = l.call(s), u, d = [], f;
    try {
      for (; (a === void 0 || a-- > 0) && !(u = c.next()).done; ) d.push(u.value);
    } catch (h) {
      f = { error: h };
    } finally {
      try {
        u && !u.done && (l = c.return) && l.call(c);
      } finally {
        if (f) throw f.error;
      }
    }
    return d;
  }, n = Mi && Mi.__spreadArray || function(s, a, l) {
    if (l || arguments.length === 2) for (var c = 0, u = a.length, d; c < u; c++)
      (d || !(c in a)) && (d || (d = Array.prototype.slice.call(a, 0, c)), d[c] = a[c]);
    return s.concat(d || Array.prototype.slice.call(a));
  }, r = Mi && Mi.__importDefault || function(s) {
    return s && s.__esModule ? s : { default: s };
  };
  Object.defineProperty(Mi, "__esModule", { value: !0 });
  var o = r(WXe()), i = function(s) {
    t(a, s);
    function a() {
      var l = s.apply(this, n([], e(arguments), !1)) || this;
      return l.tickAnimation = function() {
        l.confetti(l.decorateOptions({
          particleCount: 3,
          angle: 60,
          spread: 55,
          origin: { x: 0 },
          colors: ["#bb0000", "#ffffff"]
        })), l.confetti(l.decorateOptions({
          particleCount: 3,
          angle: 120,
          spread: 55,
          origin: { x: 1 },
          colors: ["#bb0000", "#ffffff"]
        }));
      }, l;
    }
    return a;
  }(o.default);
  return Mi.default = i, Mi;
}
var yU;
function YXe() {
  if (yU) return rc;
  yU = 1;
  var t = rc && rc.__assign || function() {
    return t = Object.assign || function(s) {
      for (var a, l = 1, c = arguments.length; l < c; l++) {
        a = arguments[l];
        for (var u in a) Object.prototype.hasOwnProperty.call(a, u) && (s[u] = a[u]);
      }
      return s;
    }, t.apply(this, arguments);
  }, e = rc && rc.__importDefault || function(s) {
    return s && s.__esModule ? s : { default: s };
  };
  Object.defineProperty(rc, "__esModule", { value: !0 });
  var n = e(xe), r = e(VXe()), o = e(GXe());
  function i(s) {
    return n.default.createElement(r.default, t({ Conductor: o.default }, s));
  }
  return rc.default = i, rc;
}
YXe();
var oj = { exports: {} }, KXe = oj.exports, vU;
function XXe() {
  return vU || (vU = 1, function(t, e) {
    (function(n, r) {
      t.exports = r();
    })(KXe, function() {
      var n = 1e3, r = 6e4, o = 36e5, i = "millisecond", s = "second", a = "minute", l = "hour", c = "day", u = "week", d = "month", f = "quarter", h = "year", p = "date", m = "Invalid Date", g = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, v = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(O) {
        var k = ["th", "st", "nd", "rd"], T = O % 100;
        return "[" + O + (k[(T - 20) % 10] || k[T] || k[0]) + "]";
      } }, b = function(O, k, T) {
        var I = String(O);
        return !I || I.length >= k ? O : "" + Array(k + 1 - I.length).join(T) + O;
      }, _ = { s: b, z: function(O) {
        var k = -O.utcOffset(), T = Math.abs(k), I = Math.floor(T / 60), j = T % 60;
        return (k <= 0 ? "+" : "-") + b(I, 2, "0") + ":" + b(j, 2, "0");
      }, m: function O(k, T) {
        if (k.date() < T.date()) return -O(T, k);
        var I = 12 * (T.year() - k.year()) + (T.month() - k.month()), j = k.clone().add(I, d), z = T - j < 0, $ = k.clone().add(I + (z ? -1 : 1), d);
        return +(-(I + (T - j) / (z ? j - $ : $ - j)) || 0);
      }, a: function(O) {
        return O < 0 ? Math.ceil(O) || 0 : Math.floor(O);
      }, p: function(O) {
        return { M: d, y: h, w: u, d: c, D: p, h: l, m: a, s, ms: i, Q: f }[O] || String(O || "").toLowerCase().replace(/s$/, "");
      }, u: function(O) {
        return O === void 0;
      } }, w = "en", x = {};
      x[w] = v;
      var E = "$isDayjsObject", S = function(O) {
        return O instanceof N || !(!O || !O[E]);
      }, C = function O(k, T, I) {
        var j;
        if (!k) return w;
        if (typeof k == "string") {
          var z = k.toLowerCase();
          x[z] && (j = z), T && (x[z] = T, j = z);
          var $ = k.split("-");
          if (!j && $.length > 1) return O($[0]);
        } else {
          var D = k.name;
          x[D] = k, j = D;
        }
        return !I && j && (w = j), j || !I && w;
      }, R = function(O, k) {
        if (S(O)) return O.clone();
        var T = typeof k == "object" ? k : {};
        return T.date = O, T.args = arguments, new N(T);
      }, P = _;
      P.l = C, P.i = S, P.w = function(O, k) {
        return R(O, { locale: k.$L, utc: k.$u, x: k.$x, $offset: k.$offset });
      };
      var N = function() {
        function O(T) {
          this.$L = C(T.locale, null, !0), this.parse(T), this.$x = this.$x || T.x || {}, this[E] = !0;
        }
        var k = O.prototype;
        return k.parse = function(T) {
          this.$d = function(I) {
            var j = I.date, z = I.utc;
            if (j === null) return /* @__PURE__ */ new Date(NaN);
            if (P.u(j)) return /* @__PURE__ */ new Date();
            if (j instanceof Date) return new Date(j);
            if (typeof j == "string" && !/Z$/i.test(j)) {
              var $ = j.match(g);
              if ($) {
                var D = $[2] - 1 || 0, U = ($[7] || "0").substring(0, 3);
                return z ? new Date(Date.UTC($[1], D, $[3] || 1, $[4] || 0, $[5] || 0, $[6] || 0, U)) : new Date($[1], D, $[3] || 1, $[4] || 0, $[5] || 0, $[6] || 0, U);
              }
            }
            return new Date(j);
          }(T), this.init();
        }, k.init = function() {
          var T = this.$d;
          this.$y = T.getFullYear(), this.$M = T.getMonth(), this.$D = T.getDate(), this.$W = T.getDay(), this.$H = T.getHours(), this.$m = T.getMinutes(), this.$s = T.getSeconds(), this.$ms = T.getMilliseconds();
        }, k.$utils = function() {
          return P;
        }, k.isValid = function() {
          return this.$d.toString() !== m;
        }, k.isSame = function(T, I) {
          var j = R(T);
          return this.startOf(I) <= j && j <= this.endOf(I);
        }, k.isAfter = function(T, I) {
          return R(T) < this.startOf(I);
        }, k.isBefore = function(T, I) {
          return this.endOf(I) < R(T);
        }, k.$g = function(T, I, j) {
          return P.u(T) ? this[I] : this.set(j, T);
        }, k.unix = function() {
          return Math.floor(this.valueOf() / 1e3);
        }, k.valueOf = function() {
          return this.$d.getTime();
        }, k.startOf = function(T, I) {
          var j = this, z = !!P.u(I) || I, $ = P.p(T), D = function(G, ee) {
            var Y = P.w(j.$u ? Date.UTC(j.$y, ee, G) : new Date(j.$y, ee, G), j);
            return z ? Y : Y.endOf(c);
          }, U = function(G, ee) {
            return P.w(j.toDate()[G].apply(j.toDate("s"), (z ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(ee)), j);
          }, q = this.$W, F = this.$M, B = this.$D, H = "set" + (this.$u ? "UTC" : "");
          switch ($) {
            case h:
              return z ? D(1, 0) : D(31, 11);
            case d:
              return z ? D(1, F) : D(0, F + 1);
            case u:
              var Z = this.$locale().weekStart || 0, W = (q < Z ? q + 7 : q) - Z;
              return D(z ? B - W : B + (6 - W), F);
            case c:
            case p:
              return U(H + "Hours", 0);
            case l:
              return U(H + "Minutes", 1);
            case a:
              return U(H + "Seconds", 2);
            case s:
              return U(H + "Milliseconds", 3);
            default:
              return this.clone();
          }
        }, k.endOf = function(T) {
          return this.startOf(T, !1);
        }, k.$set = function(T, I) {
          var j, z = P.p(T), $ = "set" + (this.$u ? "UTC" : ""), D = (j = {}, j[c] = $ + "Date", j[p] = $ + "Date", j[d] = $ + "Month", j[h] = $ + "FullYear", j[l] = $ + "Hours", j[a] = $ + "Minutes", j[s] = $ + "Seconds", j[i] = $ + "Milliseconds", j)[z], U = z === c ? this.$D + (I - this.$W) : I;
          if (z === d || z === h) {
            var q = this.clone().set(p, 1);
            q.$d[D](U), q.init(), this.$d = q.set(p, Math.min(this.$D, q.daysInMonth())).$d;
          } else D && this.$d[D](U);
          return this.init(), this;
        }, k.set = function(T, I) {
          return this.clone().$set(T, I);
        }, k.get = function(T) {
          return this[P.p(T)]();
        }, k.add = function(T, I) {
          var j, z = this;
          T = Number(T);
          var $ = P.p(I), D = function(F) {
            var B = R(z);
            return P.w(B.date(B.date() + Math.round(F * T)), z);
          };
          if ($ === d) return this.set(d, this.$M + T);
          if ($ === h) return this.set(h, this.$y + T);
          if ($ === c) return D(1);
          if ($ === u) return D(7);
          var U = (j = {}, j[a] = r, j[l] = o, j[s] = n, j)[$] || 1, q = this.$d.getTime() + T * U;
          return P.w(q, this);
        }, k.subtract = function(T, I) {
          return this.add(-1 * T, I);
        }, k.format = function(T) {
          var I = this, j = this.$locale();
          if (!this.isValid()) return j.invalidDate || m;
          var z = T || "YYYY-MM-DDTHH:mm:ssZ", $ = P.z(this), D = this.$H, U = this.$m, q = this.$M, F = j.weekdays, B = j.months, H = j.meridiem, Z = function(ee, Y, L, V) {
            return ee && (ee[Y] || ee(I, z)) || L[Y].slice(0, V);
          }, W = function(ee) {
            return P.s(D % 12 || 12, ee, "0");
          }, G = H || function(ee, Y, L) {
            var V = ee < 12 ? "AM" : "PM";
            return L ? V.toLowerCase() : V;
          };
          return z.replace(y, function(ee, Y) {
            return Y || function(L) {
              switch (L) {
                case "YY":
                  return String(I.$y).slice(-2);
                case "YYYY":
                  return P.s(I.$y, 4, "0");
                case "M":
                  return q + 1;
                case "MM":
                  return P.s(q + 1, 2, "0");
                case "MMM":
                  return Z(j.monthsShort, q, B, 3);
                case "MMMM":
                  return Z(B, q);
                case "D":
                  return I.$D;
                case "DD":
                  return P.s(I.$D, 2, "0");
                case "d":
                  return String(I.$W);
                case "dd":
                  return Z(j.weekdaysMin, I.$W, F, 2);
                case "ddd":
                  return Z(j.weekdaysShort, I.$W, F, 3);
                case "dddd":
                  return F[I.$W];
                case "H":
                  return String(D);
                case "HH":
                  return P.s(D, 2, "0");
                case "h":
                  return W(1);
                case "hh":
                  return W(2);
                case "a":
                  return G(D, U, !0);
                case "A":
                  return G(D, U, !1);
                case "m":
                  return String(U);
                case "mm":
                  return P.s(U, 2, "0");
                case "s":
                  return String(I.$s);
                case "ss":
                  return P.s(I.$s, 2, "0");
                case "SSS":
                  return P.s(I.$ms, 3, "0");
                case "Z":
                  return $;
              }
              return null;
            }(ee) || $.replace(":", "");
          });
        }, k.utcOffset = function() {
          return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, k.diff = function(T, I, j) {
          var z, $ = this, D = P.p(I), U = R(T), q = (U.utcOffset() - this.utcOffset()) * r, F = this - U, B = function() {
            return P.m($, U);
          };
          switch (D) {
            case h:
              z = B() / 12;
              break;
            case d:
              z = B();
              break;
            case f:
              z = B() / 3;
              break;
            case u:
              z = (F - q) / 6048e5;
              break;
            case c:
              z = (F - q) / 864e5;
              break;
            case l:
              z = F / o;
              break;
            case a:
              z = F / r;
              break;
            case s:
              z = F / n;
              break;
            default:
              z = F;
          }
          return j ? z : P.a(z);
        }, k.daysInMonth = function() {
          return this.endOf(d).$D;
        }, k.$locale = function() {
          return x[this.$L];
        }, k.locale = function(T, I) {
          if (!T) return this.$L;
          var j = this.clone(), z = C(T, I, !0);
          return z && (j.$L = z), j;
        }, k.clone = function() {
          return P.w(this.$d, this);
        }, k.toDate = function() {
          return new Date(this.valueOf());
        }, k.toJSON = function() {
          return this.isValid() ? this.toISOString() : null;
        }, k.toISOString = function() {
          return this.$d.toISOString();
        }, k.toString = function() {
          return this.$d.toUTCString();
        }, O;
      }(), A = N.prototype;
      return R.prototype = A, [["$ms", i], ["$s", s], ["$m", a], ["$H", l], ["$W", c], ["$M", d], ["$y", h], ["$D", p]].forEach(function(O) {
        A[O[1]] = function(k) {
          return this.$g(k, O[0], O[1]);
        };
      }), R.extend = function(O, k) {
        return O.$i || (O(k, N, R), O.$i = !0), R;
      }, R.locale = C, R.isDayjs = S, R.unix = function(O) {
        return R(1e3 * O);
      }, R.en = x[w], R.Ls = x, R.p = {}, R;
    });
  }(oj)), oj.exports;
}
XXe();
/*!
 * @kurkle/color v0.3.4
 * https://github.com/kurkle/color#readme
 * (c) 2024 Jukka Kurkela
 * Released under the MIT License
 */
function Ov(t) {
  return t + 0.5 | 0;
}
const Nc = (t, e, n) => Math.max(Math.min(t, n), e);
function Cg(t) {
  return Nc(Ov(t * 2.55), 0, 255);
}
function Wc(t) {
  return Nc(Ov(t * 255), 0, 255);
}
function hl(t) {
  return Nc(Ov(t / 2.55) / 100, 0, 1);
}
function bU(t) {
  return Nc(Ov(t * 100), 0, 100);
}
const Di = { 0: 0, 1: 1, 2: 2, 3: 3, 4: 4, 5: 5, 6: 6, 7: 7, 8: 8, 9: 9, A: 10, B: 11, C: 12, D: 13, E: 14, F: 15, a: 10, b: 11, c: 12, d: 13, e: 14, f: 15 }, ij = [..."0123456789ABCDEF"], QXe = (t) => ij[t & 15], ZXe = (t) => ij[(t & 240) >> 4] + ij[t & 15], r1 = (t) => (t & 240) >> 4 === (t & 15), JXe = (t) => r1(t.r) && r1(t.g) && r1(t.b) && r1(t.a);
function eQe(t) {
  var e = t.length, n;
  return t[0] === "#" && (e === 4 || e === 5 ? n = {
    r: 255 & Di[t[1]] * 17,
    g: 255 & Di[t[2]] * 17,
    b: 255 & Di[t[3]] * 17,
    a: e === 5 ? Di[t[4]] * 17 : 255
  } : (e === 7 || e === 9) && (n = {
    r: Di[t[1]] << 4 | Di[t[2]],
    g: Di[t[3]] << 4 | Di[t[4]],
    b: Di[t[5]] << 4 | Di[t[6]],
    a: e === 9 ? Di[t[7]] << 4 | Di[t[8]] : 255
  })), n;
}
const tQe = (t, e) => t < 255 ? e(t) : "";
function nQe(t) {
  var e = JXe(t) ? QXe : ZXe;
  return t ? "#" + e(t.r) + e(t.g) + e(t.b) + tQe(t.a, e) : void 0;
}
const rQe = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
function ime(t, e, n) {
  const r = e * Math.min(n, 1 - n), o = (i, s = (i + t / 30) % 12) => n - r * Math.max(Math.min(s - 3, 9 - s, 1), -1);
  return [o(0), o(8), o(4)];
}
function oQe(t, e, n) {
  const r = (o, i = (o + t / 60) % 6) => n - n * e * Math.max(Math.min(i, 4 - i, 1), 0);
  return [r(5), r(3), r(1)];
}
function iQe(t, e, n) {
  const r = ime(t, 1, 0.5);
  let o;
  for (e + n > 1 && (o = 1 / (e + n), e *= o, n *= o), o = 0; o < 3; o++)
    r[o] *= 1 - e - n, r[o] += e;
  return r;
}
function sQe(t, e, n, r, o) {
  return t === o ? (e - n) / r + (e < n ? 6 : 0) : e === o ? (n - t) / r + 2 : (t - e) / r + 4;
}
function e4(t) {
  const e = t.r / 255, n = t.g / 255, r = t.b / 255, o = Math.max(e, n, r), i = Math.min(e, n, r), s = (o + i) / 2;
  let a, l, c;
  return o !== i && (c = o - i, l = s > 0.5 ? c / (2 - o - i) : c / (o + i), a = sQe(e, n, r, c, o), a = a * 60 + 0.5), [a | 0, l || 0, s];
}
function t4(t, e, n, r) {
  return (Array.isArray(e) ? t(e[0], e[1], e[2]) : t(e, n, r)).map(Wc);
}
function n4(t, e, n) {
  return t4(ime, t, e, n);
}
function aQe(t, e, n) {
  return t4(iQe, t, e, n);
}
function lQe(t, e, n) {
  return t4(oQe, t, e, n);
}
function sme(t) {
  return (t % 360 + 360) % 360;
}
function cQe(t) {
  const e = rQe.exec(t);
  let n = 255, r;
  if (!e)
    return;
  e[5] !== r && (n = e[6] ? Cg(+e[5]) : Wc(+e[5]));
  const o = sme(+e[2]), i = +e[3] / 100, s = +e[4] / 100;
  return e[1] === "hwb" ? r = aQe(o, i, s) : e[1] === "hsv" ? r = lQe(o, i, s) : r = n4(o, i, s), {
    r: r[0],
    g: r[1],
    b: r[2],
    a: n
  };
}
function uQe(t, e) {
  var n = e4(t);
  n[0] = sme(n[0] + e), n = n4(n), t.r = n[0], t.g = n[1], t.b = n[2];
}
function dQe(t) {
  if (!t)
    return;
  const e = e4(t), n = e[0], r = bU(e[1]), o = bU(e[2]);
  return t.a < 255 ? `hsla(${n}, ${r}%, ${o}%, ${hl(t.a)})` : `hsl(${n}, ${r}%, ${o}%)`;
}
const _U = {
  x: "dark",
  Z: "light",
  Y: "re",
  X: "blu",
  W: "gr",
  V: "medium",
  U: "slate",
  A: "ee",
  T: "ol",
  S: "or",
  B: "ra",
  C: "lateg",
  D: "ights",
  R: "in",
  Q: "turquois",
  E: "hi",
  P: "ro",
  O: "al",
  N: "le",
  M: "de",
  L: "yello",
  F: "en",
  K: "ch",
  G: "arks",
  H: "ea",
  I: "ightg",
  J: "wh"
}, wU = {
  OiceXe: "f0f8ff",
  antiquewEte: "faebd7",
  aqua: "ffff",
  aquamarRe: "7fffd4",
  azuY: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "0",
  blanKedOmond: "ffebcd",
  Xe: "ff",
  XeviTet: "8a2be2",
  bPwn: "a52a2a",
  burlywood: "deb887",
  caMtXe: "5f9ea0",
  KartYuse: "7fff00",
  KocTate: "d2691e",
  cSO: "ff7f50",
  cSnflowerXe: "6495ed",
  cSnsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "ffff",
  xXe: "8b",
  xcyan: "8b8b",
  xgTMnPd: "b8860b",
  xWay: "a9a9a9",
  xgYF: "6400",
  xgYy: "a9a9a9",
  xkhaki: "bdb76b",
  xmagFta: "8b008b",
  xTivegYF: "556b2f",
  xSange: "ff8c00",
  xScEd: "9932cc",
  xYd: "8b0000",
  xsOmon: "e9967a",
  xsHgYF: "8fbc8f",
  xUXe: "483d8b",
  xUWay: "2f4f4f",
  xUgYy: "2f4f4f",
  xQe: "ced1",
  xviTet: "9400d3",
  dAppRk: "ff1493",
  dApskyXe: "bfff",
  dimWay: "696969",
  dimgYy: "696969",
  dodgerXe: "1e90ff",
  fiYbrick: "b22222",
  flSOwEte: "fffaf0",
  foYstWAn: "228b22",
  fuKsia: "ff00ff",
  gaRsbSo: "dcdcdc",
  ghostwEte: "f8f8ff",
  gTd: "ffd700",
  gTMnPd: "daa520",
  Way: "808080",
  gYF: "8000",
  gYFLw: "adff2f",
  gYy: "808080",
  honeyMw: "f0fff0",
  hotpRk: "ff69b4",
  RdianYd: "cd5c5c",
  Rdigo: "4b0082",
  ivSy: "fffff0",
  khaki: "f0e68c",
  lavFMr: "e6e6fa",
  lavFMrXsh: "fff0f5",
  lawngYF: "7cfc00",
  NmoncEffon: "fffacd",
  ZXe: "add8e6",
  ZcSO: "f08080",
  Zcyan: "e0ffff",
  ZgTMnPdLw: "fafad2",
  ZWay: "d3d3d3",
  ZgYF: "90ee90",
  ZgYy: "d3d3d3",
  ZpRk: "ffb6c1",
  ZsOmon: "ffa07a",
  ZsHgYF: "20b2aa",
  ZskyXe: "87cefa",
  ZUWay: "778899",
  ZUgYy: "778899",
  ZstAlXe: "b0c4de",
  ZLw: "ffffe0",
  lime: "ff00",
  limegYF: "32cd32",
  lRF: "faf0e6",
  magFta: "ff00ff",
  maPon: "800000",
  VaquamarRe: "66cdaa",
  VXe: "cd",
  VScEd: "ba55d3",
  VpurpN: "9370db",
  VsHgYF: "3cb371",
  VUXe: "7b68ee",
  VsprRggYF: "fa9a",
  VQe: "48d1cc",
  VviTetYd: "c71585",
  midnightXe: "191970",
  mRtcYam: "f5fffa",
  mistyPse: "ffe4e1",
  moccasR: "ffe4b5",
  navajowEte: "ffdead",
  navy: "80",
  Tdlace: "fdf5e6",
  Tive: "808000",
  TivedBb: "6b8e23",
  Sange: "ffa500",
  SangeYd: "ff4500",
  ScEd: "da70d6",
  pOegTMnPd: "eee8aa",
  pOegYF: "98fb98",
  pOeQe: "afeeee",
  pOeviTetYd: "db7093",
  papayawEp: "ffefd5",
  pHKpuff: "ffdab9",
  peru: "cd853f",
  pRk: "ffc0cb",
  plum: "dda0dd",
  powMrXe: "b0e0e6",
  purpN: "800080",
  YbeccapurpN: "663399",
  Yd: "ff0000",
  Psybrown: "bc8f8f",
  PyOXe: "4169e1",
  saddNbPwn: "8b4513",
  sOmon: "fa8072",
  sandybPwn: "f4a460",
  sHgYF: "2e8b57",
  sHshell: "fff5ee",
  siFna: "a0522d",
  silver: "c0c0c0",
  skyXe: "87ceeb",
  UXe: "6a5acd",
  UWay: "708090",
  UgYy: "708090",
  snow: "fffafa",
  sprRggYF: "ff7f",
  stAlXe: "4682b4",
  tan: "d2b48c",
  teO: "8080",
  tEstN: "d8bfd8",
  tomato: "ff6347",
  Qe: "40e0d0",
  viTet: "ee82ee",
  JHt: "f5deb3",
  wEte: "ffffff",
  wEtesmoke: "f5f5f5",
  Lw: "ffff00",
  LwgYF: "9acd32"
};
function fQe() {
  const t = {}, e = Object.keys(wU), n = Object.keys(_U);
  let r, o, i, s, a;
  for (r = 0; r < e.length; r++) {
    for (s = a = e[r], o = 0; o < n.length; o++)
      i = n[o], a = a.replace(i, _U[i]);
    i = parseInt(wU[s], 16), t[a] = [i >> 16 & 255, i >> 8 & 255, i & 255];
  }
  return t;
}
let o1;
function hQe(t) {
  o1 || (o1 = fQe(), o1.transparent = [0, 0, 0, 0]);
  const e = o1[t.toLowerCase()];
  return e && {
    r: e[0],
    g: e[1],
    b: e[2],
    a: e.length === 4 ? e[3] : 255
  };
}
const pQe = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;
function mQe(t) {
  const e = pQe.exec(t);
  let n = 255, r, o, i;
  if (e) {
    if (e[7] !== r) {
      const s = +e[7];
      n = e[8] ? Cg(s) : Nc(s * 255, 0, 255);
    }
    return r = +e[1], o = +e[3], i = +e[5], r = 255 & (e[2] ? Cg(r) : Nc(r, 0, 255)), o = 255 & (e[4] ? Cg(o) : Nc(o, 0, 255)), i = 255 & (e[6] ? Cg(i) : Nc(i, 0, 255)), {
      r,
      g: o,
      b: i,
      a: n
    };
  }
}
function gQe(t) {
  return t && (t.a < 255 ? `rgba(${t.r}, ${t.g}, ${t.b}, ${hl(t.a)})` : `rgb(${t.r}, ${t.g}, ${t.b})`);
}
const Yk = (t) => t <= 31308e-7 ? t * 12.92 : Math.pow(t, 1 / 2.4) * 1.055 - 0.055, Ef = (t) => t <= 0.04045 ? t / 12.92 : Math.pow((t + 0.055) / 1.055, 2.4);
function yQe(t, e, n) {
  const r = Ef(hl(t.r)), o = Ef(hl(t.g)), i = Ef(hl(t.b));
  return {
    r: Wc(Yk(r + n * (Ef(hl(e.r)) - r))),
    g: Wc(Yk(o + n * (Ef(hl(e.g)) - o))),
    b: Wc(Yk(i + n * (Ef(hl(e.b)) - i))),
    a: t.a + n * (e.a - t.a)
  };
}
function i1(t, e, n) {
  if (t) {
    let r = e4(t);
    r[e] = Math.max(0, Math.min(r[e] + r[e] * n, e === 0 ? 360 : 1)), r = n4(r), t.r = r[0], t.g = r[1], t.b = r[2];
  }
}
function ame(t, e) {
  return t && Object.assign(e || {}, t);
}
function xU(t) {
  var e = { r: 0, g: 0, b: 0, a: 255 };
  return Array.isArray(t) ? t.length >= 3 && (e = { r: t[0], g: t[1], b: t[2], a: 255 }, t.length > 3 && (e.a = Wc(t[3]))) : (e = ame(t, { r: 0, g: 0, b: 0, a: 1 }), e.a = Wc(e.a)), e;
}
function vQe(t) {
  return t.charAt(0) === "r" ? mQe(t) : cQe(t);
}
let lme = class sj {
  constructor(e) {
    if (e instanceof sj)
      return e;
    const n = typeof e;
    let r;
    n === "object" ? r = xU(e) : n === "string" && (r = eQe(e) || hQe(e) || vQe(e)), this._rgb = r, this._valid = !!r;
  }
  get valid() {
    return this._valid;
  }
  get rgb() {
    var e = ame(this._rgb);
    return e && (e.a = hl(e.a)), e;
  }
  set rgb(e) {
    this._rgb = xU(e);
  }
  rgbString() {
    return this._valid ? gQe(this._rgb) : void 0;
  }
  hexString() {
    return this._valid ? nQe(this._rgb) : void 0;
  }
  hslString() {
    return this._valid ? dQe(this._rgb) : void 0;
  }
  mix(e, n) {
    if (e) {
      const r = this.rgb, o = e.rgb;
      let i;
      const s = n === i ? 0.5 : n, a = 2 * s - 1, l = r.a - o.a, c = ((a * l === -1 ? a : (a + l) / (1 + a * l)) + 1) / 2;
      i = 1 - c, r.r = 255 & c * r.r + i * o.r + 0.5, r.g = 255 & c * r.g + i * o.g + 0.5, r.b = 255 & c * r.b + i * o.b + 0.5, r.a = s * r.a + (1 - s) * o.a, this.rgb = r;
    }
    return this;
  }
  interpolate(e, n) {
    return e && (this._rgb = yQe(this._rgb, e._rgb, n)), this;
  }
  clone() {
    return new sj(this.rgb);
  }
  alpha(e) {
    return this._rgb.a = Wc(e), this;
  }
  clearer(e) {
    const n = this._rgb;
    return n.a *= 1 - e, this;
  }
  greyscale() {
    const e = this._rgb, n = Ov(e.r * 0.3 + e.g * 0.59 + e.b * 0.11);
    return e.r = e.g = e.b = n, this;
  }
  opaquer(e) {
    const n = this._rgb;
    return n.a *= 1 + e, this;
  }
  negate() {
    const e = this._rgb;
    return e.r = 255 - e.r, e.g = 255 - e.g, e.b = 255 - e.b, this;
  }
  lighten(e) {
    return i1(this._rgb, 2, e), this;
  }
  darken(e) {
    return i1(this._rgb, 2, -e), this;
  }
  saturate(e) {
    return i1(this._rgb, 1, e), this;
  }
  desaturate(e) {
    return i1(this._rgb, 1, -e), this;
  }
  rotate(e) {
    return uQe(this._rgb, e), this;
  }
};
/*!
 * Chart.js v4.5.0
 * https://www.chartjs.org
 * (c) 2025 Chart.js Contributors
 * Released under the MIT License
 */
function Ba() {
}
const bQe = /* @__PURE__ */ (() => {
  let t = 0;
  return () => t++;
})();
function vn(t) {
  return t == null;
}
function Cr(t) {
  if (Array.isArray && Array.isArray(t))
    return !0;
  const e = Object.prototype.toString.call(t);
  return e.slice(0, 7) === "[object" && e.slice(-6) === "Array]";
}
function Bt(t) {
  return t !== null && Object.prototype.toString.call(t) === "[object Object]";
}
function po(t) {
  return (typeof t == "number" || t instanceof Number) && isFinite(+t);
}
function Hs(t, e) {
  return po(t) ? t : e;
}
function Tt(t, e) {
  return typeof t > "u" ? e : t;
}
const _Qe = (t, e) => typeof t == "string" && t.endsWith("%") ? parseFloat(t) / 100 : +t / e, cme = (t, e) => typeof t == "string" && t.endsWith("%") ? parseFloat(t) / 100 * e : +t;
function Wn(t, e, n) {
  if (t && typeof t.call == "function")
    return t.apply(n, e);
}
function On(t, e, n, r) {
  let o, i, s;
  if (Cr(t))
    for (i = t.length, o = 0; o < i; o++)
      e.call(n, t[o], o);
  else if (Bt(t))
    for (s = Object.keys(t), i = s.length, o = 0; o < i; o++)
      e.call(n, t[s[o]], s[o]);
}
function rE(t, e) {
  let n, r, o, i;
  if (!t || !e || t.length !== e.length)
    return !1;
  for (n = 0, r = t.length; n < r; ++n)
    if (o = t[n], i = e[n], o.datasetIndex !== i.datasetIndex || o.index !== i.index)
      return !1;
  return !0;
}
function oE(t) {
  if (Cr(t))
    return t.map(oE);
  if (Bt(t)) {
    const e = /* @__PURE__ */ Object.create(null), n = Object.keys(t), r = n.length;
    let o = 0;
    for (; o < r; ++o)
      e[n[o]] = oE(t[n[o]]);
    return e;
  }
  return t;
}
function ume(t) {
  return [
    "__proto__",
    "prototype",
    "constructor"
  ].indexOf(t) === -1;
}
function wQe(t, e, n, r) {
  if (!ume(t))
    return;
  const o = e[t], i = n[t];
  Bt(o) && Bt(i) ? gy(o, i, r) : e[t] = oE(i);
}
function gy(t, e, n) {
  const r = Cr(e) ? e : [
    e
  ], o = r.length;
  if (!Bt(t))
    return t;
  n = n || {};
  const i = n.merger || wQe;
  let s;
  for (let a = 0; a < o; ++a) {
    if (s = r[a], !Bt(s))
      continue;
    const l = Object.keys(s);
    for (let c = 0, u = l.length; c < u; ++c)
      i(l[c], t, s, n);
  }
  return t;
}
function a0(t, e) {
  return gy(t, e, {
    merger: xQe
  });
}
function xQe(t, e, n) {
  if (!ume(t))
    return;
  const r = e[t], o = n[t];
  Bt(r) && Bt(o) ? a0(r, o) : Object.prototype.hasOwnProperty.call(e, t) || (e[t] = oE(o));
}
const EU = {
  // Chart.helpers.core resolveObjectKey should resolve empty key to root object
  "": (t) => t,
  // default resolvers
  x: (t) => t.x,
  y: (t) => t.y
};
function EQe(t) {
  const e = t.split("."), n = [];
  let r = "";
  for (const o of e)
    r += o, r.endsWith("\\") ? r = r.slice(0, -1) + "." : (n.push(r), r = "");
  return n;
}
function SQe(t) {
  const e = EQe(t);
  return (n) => {
    for (const r of e) {
      if (r === "")
        break;
      n = n && n[r];
    }
    return n;
  };
}
function jd(t, e) {
  return (EU[e] || (EU[e] = SQe(e)))(t);
}
function r4(t) {
  return t.charAt(0).toUpperCase() + t.slice(1);
}
const yy = (t) => typeof t < "u", nu = (t) => typeof t == "function", SU = (t, e) => {
  if (t.size !== e.size)
    return !1;
  for (const n of t)
    if (!e.has(n))
      return !1;
  return !0;
};
function OQe(t) {
  return t.type === "mouseup" || t.type === "click" || t.type === "contextmenu";
}
const An = Math.PI, ar = 2 * An, CQe = ar + An, iE = Number.POSITIVE_INFINITY, kQe = An / 180, Ir = An / 2, bu = An / 4, OU = An * 2 / 3, dme = Math.log10, _a = Math.sign;
function l0(t, e, n) {
  return Math.abs(t - e) < n;
}
function CU(t) {
  const e = Math.round(t);
  t = l0(t, e, t / 1e3) ? e : t;
  const n = Math.pow(10, Math.floor(dme(t))), r = t / n;
  return (r <= 1 ? 1 : r <= 2 ? 2 : r <= 5 ? 5 : 10) * n;
}
function AQe(t) {
  const e = [], n = Math.sqrt(t);
  let r;
  for (r = 1; r < n; r++)
    t % r === 0 && (e.push(r), e.push(t / r));
  return n === (n | 0) && e.push(n), e.sort((o, i) => o - i).pop(), e;
}
function TQe(t) {
  return typeof t == "symbol" || typeof t == "object" && t !== null && !(Symbol.toPrimitive in t || "toString" in t || "valueOf" in t);
}
function vy(t) {
  return !TQe(t) && !isNaN(parseFloat(t)) && isFinite(t);
}
function RQe(t, e) {
  const n = Math.round(t);
  return n - e <= t && n + e >= t;
}
function PQe(t, e, n) {
  let r, o, i;
  for (r = 0, o = t.length; r < o; r++)
    i = t[r][n], isNaN(i) || (e.min = Math.min(e.min, i), e.max = Math.max(e.max, i));
}
function xl(t) {
  return t * (An / 180);
}
function $Qe(t) {
  return t * (180 / An);
}
function kU(t) {
  if (!po(t))
    return;
  let e = 1, n = 0;
  for (; Math.round(t * e) / e !== t; )
    e *= 10, n++;
  return n;
}
function fme(t, e) {
  const n = e.x - t.x, r = e.y - t.y, o = Math.sqrt(n * n + r * r);
  let i = Math.atan2(r, n);
  return i < -0.5 * An && (i += ar), {
    angle: i,
    distance: o
  };
}
function aj(t, e) {
  return Math.sqrt(Math.pow(e.x - t.x, 2) + Math.pow(e.y - t.y, 2));
}
function MQe(t, e) {
  return (t - e + CQe) % ar - An;
}
function di(t) {
  return (t % ar + ar) % ar;
}
function by(t, e, n, r) {
  const o = di(t), i = di(e), s = di(n), a = di(i - o), l = di(s - o), c = di(o - i), u = di(o - s);
  return o === i || o === s || r && i === s || a > l && c < u;
}
function co(t, e, n) {
  return Math.max(e, Math.min(n, t));
}
function DQe(t) {
  return co(t, -32768, 32767);
}
function El(t, e, n, r = 1e-6) {
  return t >= Math.min(e, n) - r && t <= Math.max(e, n) + r;
}
function o4(t, e, n) {
  n = n || ((s) => t[s] < e);
  let r = t.length - 1, o = 0, i;
  for (; r - o > 1; )
    i = o + r >> 1, n(i) ? o = i : r = i;
  return {
    lo: o,
    hi: r
  };
}
const ld = (t, e, n, r) => o4(t, n, r ? (o) => {
  const i = t[o][e];
  return i < n || i === n && t[o + 1][e] === n;
} : (o) => t[o][e] < n), IQe = (t, e, n) => o4(t, n, (r) => t[r][e] >= n);
function NQe(t, e, n) {
  let r = 0, o = t.length;
  for (; r < o && t[r] < e; )
    r++;
  for (; o > r && t[o - 1] > n; )
    o--;
  return r > 0 || o < t.length ? t.slice(r, o) : t;
}
const hme = [
  "push",
  "pop",
  "shift",
  "splice",
  "unshift"
];
function jQe(t, e) {
  if (t._chartjs) {
    t._chartjs.listeners.push(e);
    return;
  }
  Object.defineProperty(t, "_chartjs", {
    configurable: !0,
    enumerable: !1,
    value: {
      listeners: [
        e
      ]
    }
  }), hme.forEach((n) => {
    const r = "_onData" + r4(n), o = t[n];
    Object.defineProperty(t, n, {
      configurable: !0,
      enumerable: !1,
      value(...i) {
        const s = o.apply(this, i);
        return t._chartjs.listeners.forEach((a) => {
          typeof a[r] == "function" && a[r](...i);
        }), s;
      }
    });
  });
}
function AU(t, e) {
  const n = t._chartjs;
  if (!n)
    return;
  const r = n.listeners, o = r.indexOf(e);
  o !== -1 && r.splice(o, 1), !(r.length > 0) && (hme.forEach((i) => {
    delete t[i];
  }), delete t._chartjs);
}
function pme(t) {
  const e = new Set(t);
  return e.size === t.length ? t : Array.from(e);
}
const mme = function() {
  return typeof window > "u" ? function(t) {
    return t();
  } : window.requestAnimationFrame;
}();
function gme(t, e) {
  let n = [], r = !1;
  return function(...o) {
    n = o, r || (r = !0, mme.call(window, () => {
      r = !1, t.apply(e, n);
    }));
  };
}
function LQe(t, e) {
  let n;
  return function(...r) {
    return e ? (clearTimeout(n), n = setTimeout(t, e, r)) : t.apply(this, r), e;
  };
}
const i4 = (t) => t === "start" ? "left" : t === "end" ? "right" : "center", io = (t, e, n) => t === "start" ? e : t === "end" ? n : (e + n) / 2, FQe = (t, e, n, r) => t === (r ? "left" : "right") ? n : t === "center" ? (e + n) / 2 : e;
function BQe(t, e, n) {
  const r = e.length;
  let o = 0, i = r;
  if (t._sorted) {
    const { iScale: s, vScale: a, _parsed: l } = t, c = t.dataset && t.dataset.options ? t.dataset.options.spanGaps : null, u = s.axis, { min: d, max: f, minDefined: h, maxDefined: p } = s.getUserBounds();
    if (h) {
      if (o = Math.min(
        // @ts-expect-error Need to type _parsed
        ld(l, u, d).lo,
        // @ts-expect-error Need to fix types on _lookupByKey
        n ? r : ld(e, u, s.getPixelForValue(d)).lo
      ), c) {
        const m = l.slice(0, o + 1).reverse().findIndex((g) => !vn(g[a.axis]));
        o -= Math.max(0, m);
      }
      o = co(o, 0, r - 1);
    }
    if (p) {
      let m = Math.max(
        // @ts-expect-error Need to type _parsed
        ld(l, s.axis, f, !0).hi + 1,
        // @ts-expect-error Need to fix types on _lookupByKey
        n ? 0 : ld(e, u, s.getPixelForValue(f), !0).hi + 1
      );
      if (c) {
        const g = l.slice(m - 1).findIndex((y) => !vn(y[a.axis]));
        m += Math.max(0, g);
      }
      i = co(m, o, r) - o;
    } else
      i = r - o;
  }
  return {
    start: o,
    count: i
  };
}
function zQe(t) {
  const { xScale: e, yScale: n, _scaleRanges: r } = t, o = {
    xmin: e.min,
    xmax: e.max,
    ymin: n.min,
    ymax: n.max
  };
  if (!r)
    return t._scaleRanges = o, !0;
  const i = r.xmin !== e.min || r.xmax !== e.max || r.ymin !== n.min || r.ymax !== n.max;
  return Object.assign(r, o), i;
}
const s1 = (t) => t === 0 || t === 1, TU = (t, e, n) => -(Math.pow(2, 10 * (t -= 1)) * Math.sin((t - e) * ar / n)), RU = (t, e, n) => Math.pow(2, -10 * t) * Math.sin((t - e) * ar / n) + 1, c0 = {
  linear: (t) => t,
  easeInQuad: (t) => t * t,
  easeOutQuad: (t) => -t * (t - 2),
  easeInOutQuad: (t) => (t /= 0.5) < 1 ? 0.5 * t * t : -0.5 * (--t * (t - 2) - 1),
  easeInCubic: (t) => t * t * t,
  easeOutCubic: (t) => (t -= 1) * t * t + 1,
  easeInOutCubic: (t) => (t /= 0.5) < 1 ? 0.5 * t * t * t : 0.5 * ((t -= 2) * t * t + 2),
  easeInQuart: (t) => t * t * t * t,
  easeOutQuart: (t) => -((t -= 1) * t * t * t - 1),
  easeInOutQuart: (t) => (t /= 0.5) < 1 ? 0.5 * t * t * t * t : -0.5 * ((t -= 2) * t * t * t - 2),
  easeInQuint: (t) => t * t * t * t * t,
  easeOutQuint: (t) => (t -= 1) * t * t * t * t + 1,
  easeInOutQuint: (t) => (t /= 0.5) < 1 ? 0.5 * t * t * t * t * t : 0.5 * ((t -= 2) * t * t * t * t + 2),
  easeInSine: (t) => -Math.cos(t * Ir) + 1,
  easeOutSine: (t) => Math.sin(t * Ir),
  easeInOutSine: (t) => -0.5 * (Math.cos(An * t) - 1),
  easeInExpo: (t) => t === 0 ? 0 : Math.pow(2, 10 * (t - 1)),
  easeOutExpo: (t) => t === 1 ? 1 : -Math.pow(2, -10 * t) + 1,
  easeInOutExpo: (t) => s1(t) ? t : t < 0.5 ? 0.5 * Math.pow(2, 10 * (t * 2 - 1)) : 0.5 * (-Math.pow(2, -10 * (t * 2 - 1)) + 2),
  easeInCirc: (t) => t >= 1 ? t : -(Math.sqrt(1 - t * t) - 1),
  easeOutCirc: (t) => Math.sqrt(1 - (t -= 1) * t),
  easeInOutCirc: (t) => (t /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - t * t) - 1) : 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1),
  easeInElastic: (t) => s1(t) ? t : TU(t, 0.075, 0.3),
  easeOutElastic: (t) => s1(t) ? t : RU(t, 0.075, 0.3),
  easeInOutElastic(t) {
    return s1(t) ? t : t < 0.5 ? 0.5 * TU(t * 2, 0.1125, 0.45) : 0.5 + 0.5 * RU(t * 2 - 1, 0.1125, 0.45);
  },
  easeInBack(t) {
    return t * t * ((1.70158 + 1) * t - 1.70158);
  },
  easeOutBack(t) {
    return (t -= 1) * t * ((1.70158 + 1) * t + 1.70158) + 1;
  },
  easeInOutBack(t) {
    let e = 1.70158;
    return (t /= 0.5) < 1 ? 0.5 * (t * t * (((e *= 1.525) + 1) * t - e)) : 0.5 * ((t -= 2) * t * (((e *= 1.525) + 1) * t + e) + 2);
  },
  easeInBounce: (t) => 1 - c0.easeOutBounce(1 - t),
  easeOutBounce(t) {
    return t < 1 / 2.75 ? 7.5625 * t * t : t < 2 / 2.75 ? 7.5625 * (t -= 1.5 / 2.75) * t + 0.75 : t < 2.5 / 2.75 ? 7.5625 * (t -= 2.25 / 2.75) * t + 0.9375 : 7.5625 * (t -= 2.625 / 2.75) * t + 0.984375;
  },
  easeInOutBounce: (t) => t < 0.5 ? c0.easeInBounce(t * 2) * 0.5 : c0.easeOutBounce(t * 2 - 1) * 0.5 + 0.5
};
function s4(t) {
  if (t && typeof t == "object") {
    const e = t.toString();
    return e === "[object CanvasPattern]" || e === "[object CanvasGradient]";
  }
  return !1;
}
function PU(t) {
  return s4(t) ? t : new lme(t);
}
function Kk(t) {
  return s4(t) ? t : new lme(t).saturate(0.5).darken(0.1).hexString();
}
const qQe = [
  "x",
  "y",
  "borderWidth",
  "radius",
  "tension"
], UQe = [
  "color",
  "borderColor",
  "backgroundColor"
];
function HQe(t) {
  t.set("animation", {
    delay: void 0,
    duration: 1e3,
    easing: "easeOutQuart",
    fn: void 0,
    from: void 0,
    loop: void 0,
    to: void 0,
    type: void 0
  }), t.describe("animation", {
    _fallback: !1,
    _indexable: !1,
    _scriptable: (e) => e !== "onProgress" && e !== "onComplete" && e !== "fn"
  }), t.set("animations", {
    colors: {
      type: "color",
      properties: UQe
    },
    numbers: {
      type: "number",
      properties: qQe
    }
  }), t.describe("animations", {
    _fallback: "animation"
  }), t.set("transitions", {
    active: {
      animation: {
        duration: 400
      }
    },
    resize: {
      animation: {
        duration: 0
      }
    },
    show: {
      animations: {
        colors: {
          from: "transparent"
        },
        visible: {
          type: "boolean",
          duration: 0
        }
      }
    },
    hide: {
      animations: {
        colors: {
          to: "transparent"
        },
        visible: {
          type: "boolean",
          easing: "linear",
          fn: (e) => e | 0
        }
      }
    }
  });
}
function VQe(t) {
  t.set("layout", {
    autoPadding: !0,
    padding: {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    }
  });
}
const $U = /* @__PURE__ */ new Map();
function WQe(t, e) {
  e = e || {};
  const n = t + JSON.stringify(e);
  let r = $U.get(n);
  return r || (r = new Intl.NumberFormat(t, e), $U.set(n, r)), r;
}
function a4(t, e, n) {
  return WQe(e, n).format(t);
}
const GQe = {
  values(t) {
    return Cr(t) ? t : "" + t;
  },
  numeric(t, e, n) {
    if (t === 0)
      return "0";
    const r = this.chart.options.locale;
    let o, i = t;
    if (n.length > 1) {
      const c = Math.max(Math.abs(n[0].value), Math.abs(n[n.length - 1].value));
      (c < 1e-4 || c > 1e15) && (o = "scientific"), i = YQe(t, n);
    }
    const s = dme(Math.abs(i)), a = isNaN(s) ? 1 : Math.max(Math.min(-1 * Math.floor(s), 20), 0), l = {
      notation: o,
      minimumFractionDigits: a,
      maximumFractionDigits: a
    };
    return Object.assign(l, this.options.ticks.format), a4(t, r, l);
  }
};
function YQe(t, e) {
  let n = e.length > 3 ? e[2].value - e[1].value : e[1].value - e[0].value;
  return Math.abs(n) >= 1 && t !== Math.floor(t) && (n = t - Math.floor(t)), n;
}
var yme = {
  formatters: GQe
};
function KQe(t) {
  t.set("scale", {
    display: !0,
    offset: !1,
    reverse: !1,
    beginAtZero: !1,
    bounds: "ticks",
    clip: !0,
    grace: 0,
    grid: {
      display: !0,
      lineWidth: 1,
      drawOnChartArea: !0,
      drawTicks: !0,
      tickLength: 8,
      tickWidth: (e, n) => n.lineWidth,
      tickColor: (e, n) => n.color,
      offset: !1
    },
    border: {
      display: !0,
      dash: [],
      dashOffset: 0,
      width: 1
    },
    title: {
      display: !1,
      text: "",
      padding: {
        top: 4,
        bottom: 4
      }
    },
    ticks: {
      minRotation: 0,
      maxRotation: 50,
      mirror: !1,
      textStrokeWidth: 0,
      textStrokeColor: "",
      padding: 3,
      display: !0,
      autoSkip: !0,
      autoSkipPadding: 3,
      labelOffset: 0,
      callback: yme.formatters.values,
      minor: {},
      major: {},
      align: "center",
      crossAlign: "near",
      showLabelBackdrop: !1,
      backdropColor: "rgba(255, 255, 255, 0.75)",
      backdropPadding: 2
    }
  }), t.route("scale.ticks", "color", "", "color"), t.route("scale.grid", "color", "", "borderColor"), t.route("scale.border", "color", "", "borderColor"), t.route("scale.title", "color", "", "color"), t.describe("scale", {
    _fallback: !1,
    _scriptable: (e) => !e.startsWith("before") && !e.startsWith("after") && e !== "callback" && e !== "parser",
    _indexable: (e) => e !== "borderDash" && e !== "tickBorderDash" && e !== "dash"
  }), t.describe("scales", {
    _fallback: "scale"
  }), t.describe("scale.ticks", {
    _scriptable: (e) => e !== "backdropPadding" && e !== "callback",
    _indexable: (e) => e !== "backdropPadding"
  });
}
const Ld = /* @__PURE__ */ Object.create(null), lj = /* @__PURE__ */ Object.create(null);
function u0(t, e) {
  if (!e)
    return t;
  const n = e.split(".");
  for (let r = 0, o = n.length; r < o; ++r) {
    const i = n[r];
    t = t[i] || (t[i] = /* @__PURE__ */ Object.create(null));
  }
  return t;
}
function Xk(t, e, n) {
  return typeof e == "string" ? gy(u0(t, e), n) : gy(u0(t, ""), e);
}
class XQe {
  constructor(e, n) {
    this.animation = void 0, this.backgroundColor = "rgba(0,0,0,0.1)", this.borderColor = "rgba(0,0,0,0.1)", this.color = "#666", this.datasets = {}, this.devicePixelRatio = (r) => r.chart.platform.getDevicePixelRatio(), this.elements = {}, this.events = [
      "mousemove",
      "mouseout",
      "click",
      "touchstart",
      "touchmove"
    ], this.font = {
      family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
      size: 12,
      style: "normal",
      lineHeight: 1.2,
      weight: null
    }, this.hover = {}, this.hoverBackgroundColor = (r, o) => Kk(o.backgroundColor), this.hoverBorderColor = (r, o) => Kk(o.borderColor), this.hoverColor = (r, o) => Kk(o.color), this.indexAxis = "x", this.interaction = {
      mode: "nearest",
      intersect: !0,
      includeInvisible: !1
    }, this.maintainAspectRatio = !0, this.onHover = null, this.onClick = null, this.parsing = !0, this.plugins = {}, this.responsive = !0, this.scale = void 0, this.scales = {}, this.showLine = !0, this.drawActiveElementsOnTop = !0, this.describe(e), this.apply(n);
  }
  set(e, n) {
    return Xk(this, e, n);
  }
  get(e) {
    return u0(this, e);
  }
  describe(e, n) {
    return Xk(lj, e, n);
  }
  override(e, n) {
    return Xk(Ld, e, n);
  }
  route(e, n, r, o) {
    const i = u0(this, e), s = u0(this, r), a = "_" + n;
    Object.defineProperties(i, {
      [a]: {
        value: i[n],
        writable: !0
      },
      [n]: {
        enumerable: !0,
        get() {
          const l = this[a], c = s[o];
          return Bt(l) ? Object.assign({}, c, l) : Tt(l, c);
        },
        set(l) {
          this[a] = l;
        }
      }
    });
  }
  apply(e) {
    e.forEach((n) => n(this));
  }
}
var wr = /* @__PURE__ */ new XQe({
  _scriptable: (t) => !t.startsWith("on"),
  _indexable: (t) => t !== "events",
  hover: {
    _fallback: "interaction"
  },
  interaction: {
    _scriptable: !1,
    _indexable: !1
  }
}, [
  HQe,
  VQe,
  KQe
]);
function QQe(t) {
  return !t || vn(t.size) || vn(t.family) ? null : (t.style ? t.style + " " : "") + (t.weight ? t.weight + " " : "") + t.size + "px " + t.family;
}
function MU(t, e, n, r, o) {
  let i = e[o];
  return i || (i = e[o] = t.measureText(o).width, n.push(o)), i > r && (r = i), r;
}
function _u(t, e, n) {
  const r = t.currentDevicePixelRatio, o = n !== 0 ? Math.max(n / 2, 0.5) : 0;
  return Math.round((e - o) * r) / r + o;
}
function DU(t, e) {
  !e && !t || (e = e || t.getContext("2d"), e.save(), e.resetTransform(), e.clearRect(0, 0, t.width, t.height), e.restore());
}
function cj(t, e, n, r) {
  vme(t, e, n, r, null);
}
function vme(t, e, n, r, o) {
  let i, s, a, l, c, u, d, f;
  const h = e.pointStyle, p = e.rotation, m = e.radius;
  let g = (p || 0) * kQe;
  if (h && typeof h == "object" && (i = h.toString(), i === "[object HTMLImageElement]" || i === "[object HTMLCanvasElement]")) {
    t.save(), t.translate(n, r), t.rotate(g), t.drawImage(h, -h.width / 2, -h.height / 2, h.width, h.height), t.restore();
    return;
  }
  if (!(isNaN(m) || m <= 0)) {
    switch (t.beginPath(), h) {
      // Default includes circle
      default:
        o ? t.ellipse(n, r, o / 2, m, 0, 0, ar) : t.arc(n, r, m, 0, ar), t.closePath();
        break;
      case "triangle":
        u = o ? o / 2 : m, t.moveTo(n + Math.sin(g) * u, r - Math.cos(g) * m), g += OU, t.lineTo(n + Math.sin(g) * u, r - Math.cos(g) * m), g += OU, t.lineTo(n + Math.sin(g) * u, r - Math.cos(g) * m), t.closePath();
        break;
      case "rectRounded":
        c = m * 0.516, l = m - c, s = Math.cos(g + bu) * l, d = Math.cos(g + bu) * (o ? o / 2 - c : l), a = Math.sin(g + bu) * l, f = Math.sin(g + bu) * (o ? o / 2 - c : l), t.arc(n - d, r - a, c, g - An, g - Ir), t.arc(n + f, r - s, c, g - Ir, g), t.arc(n + d, r + a, c, g, g + Ir), t.arc(n - f, r + s, c, g + Ir, g + An), t.closePath();
        break;
      case "rect":
        if (!p) {
          l = Math.SQRT1_2 * m, u = o ? o / 2 : l, t.rect(n - u, r - l, 2 * u, 2 * l);
          break;
        }
        g += bu;
      /* falls through */
      case "rectRot":
        d = Math.cos(g) * (o ? o / 2 : m), s = Math.cos(g) * m, a = Math.sin(g) * m, f = Math.sin(g) * (o ? o / 2 : m), t.moveTo(n - d, r - a), t.lineTo(n + f, r - s), t.lineTo(n + d, r + a), t.lineTo(n - f, r + s), t.closePath();
        break;
      case "crossRot":
        g += bu;
      /* falls through */
      case "cross":
        d = Math.cos(g) * (o ? o / 2 : m), s = Math.cos(g) * m, a = Math.sin(g) * m, f = Math.sin(g) * (o ? o / 2 : m), t.moveTo(n - d, r - a), t.lineTo(n + d, r + a), t.moveTo(n + f, r - s), t.lineTo(n - f, r + s);
        break;
      case "star":
        d = Math.cos(g) * (o ? o / 2 : m), s = Math.cos(g) * m, a = Math.sin(g) * m, f = Math.sin(g) * (o ? o / 2 : m), t.moveTo(n - d, r - a), t.lineTo(n + d, r + a), t.moveTo(n + f, r - s), t.lineTo(n - f, r + s), g += bu, d = Math.cos(g) * (o ? o / 2 : m), s = Math.cos(g) * m, a = Math.sin(g) * m, f = Math.sin(g) * (o ? o / 2 : m), t.moveTo(n - d, r - a), t.lineTo(n + d, r + a), t.moveTo(n + f, r - s), t.lineTo(n - f, r + s);
        break;
      case "line":
        s = o ? o / 2 : Math.cos(g) * m, a = Math.sin(g) * m, t.moveTo(n - s, r - a), t.lineTo(n + s, r + a);
        break;
      case "dash":
        t.moveTo(n, r), t.lineTo(n + Math.cos(g) * (o ? o / 2 : m), r + Math.sin(g) * m);
        break;
      case !1:
        t.closePath();
        break;
    }
    t.fill(), e.borderWidth > 0 && t.stroke();
  }
}
function _y(t, e, n) {
  return n = n || 0.5, !e || t && t.x > e.left - n && t.x < e.right + n && t.y > e.top - n && t.y < e.bottom + n;
}
function YS(t, e) {
  t.save(), t.beginPath(), t.rect(e.left, e.top, e.right - e.left, e.bottom - e.top), t.clip();
}
function KS(t) {
  t.restore();
}
function ZQe(t, e, n, r, o) {
  if (!e)
    return t.lineTo(n.x, n.y);
  if (o === "middle") {
    const i = (e.x + n.x) / 2;
    t.lineTo(i, e.y), t.lineTo(i, n.y);
  } else o === "after" != !!r ? t.lineTo(e.x, n.y) : t.lineTo(n.x, e.y);
  t.lineTo(n.x, n.y);
}
function JQe(t, e, n, r) {
  if (!e)
    return t.lineTo(n.x, n.y);
  t.bezierCurveTo(r ? e.cp1x : e.cp2x, r ? e.cp1y : e.cp2y, r ? n.cp2x : n.cp1x, r ? n.cp2y : n.cp1y, n.x, n.y);
}
function eZe(t, e) {
  e.translation && t.translate(e.translation[0], e.translation[1]), vn(e.rotation) || t.rotate(e.rotation), e.color && (t.fillStyle = e.color), e.textAlign && (t.textAlign = e.textAlign), e.textBaseline && (t.textBaseline = e.textBaseline);
}
function tZe(t, e, n, r, o) {
  if (o.strikethrough || o.underline) {
    const i = t.measureText(r), s = e - i.actualBoundingBoxLeft, a = e + i.actualBoundingBoxRight, l = n - i.actualBoundingBoxAscent, c = n + i.actualBoundingBoxDescent, u = o.strikethrough ? (l + c) / 2 : c;
    t.strokeStyle = t.fillStyle, t.beginPath(), t.lineWidth = o.decorationWidth || 2, t.moveTo(s, u), t.lineTo(a, u), t.stroke();
  }
}
function nZe(t, e) {
  const n = t.fillStyle;
  t.fillStyle = e.color, t.fillRect(e.left, e.top, e.width, e.height), t.fillStyle = n;
}
function wy(t, e, n, r, o, i = {}) {
  const s = Cr(e) ? e : [
    e
  ], a = i.strokeWidth > 0 && i.strokeColor !== "";
  let l, c;
  for (t.save(), t.font = o.string, eZe(t, i), l = 0; l < s.length; ++l)
    c = s[l], i.backdrop && nZe(t, i.backdrop), a && (i.strokeColor && (t.strokeStyle = i.strokeColor), vn(i.strokeWidth) || (t.lineWidth = i.strokeWidth), t.strokeText(c, n, r, i.maxWidth)), t.fillText(c, n, r, i.maxWidth), tZe(t, n, r, c, i), r += Number(o.lineHeight);
  t.restore();
}
function sE(t, e) {
  const { x: n, y: r, w: o, h: i, radius: s } = e;
  t.arc(n + s.topLeft, r + s.topLeft, s.topLeft, 1.5 * An, An, !0), t.lineTo(n, r + i - s.bottomLeft), t.arc(n + s.bottomLeft, r + i - s.bottomLeft, s.bottomLeft, An, Ir, !0), t.lineTo(n + o - s.bottomRight, r + i), t.arc(n + o - s.bottomRight, r + i - s.bottomRight, s.bottomRight, Ir, 0, !0), t.lineTo(n + o, r + s.topRight), t.arc(n + o - s.topRight, r + s.topRight, s.topRight, 0, -Ir, !0), t.lineTo(n + s.topLeft, r);
}
const rZe = /^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/, oZe = /^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/;
function iZe(t, e) {
  const n = ("" + t).match(rZe);
  if (!n || n[1] === "normal")
    return e * 1.2;
  switch (t = +n[2], n[3]) {
    case "px":
      return t;
    case "%":
      t /= 100;
      break;
  }
  return e * t;
}
const sZe = (t) => +t || 0;
function l4(t, e) {
  const n = {}, r = Bt(e), o = r ? Object.keys(e) : e, i = Bt(t) ? r ? (s) => Tt(t[s], t[e[s]]) : (s) => t[s] : () => t;
  for (const s of o)
    n[s] = sZe(i(s));
  return n;
}
function bme(t) {
  return l4(t, {
    top: "y",
    right: "x",
    bottom: "y",
    left: "x"
  });
}
function Sh(t) {
  return l4(t, [
    "topLeft",
    "topRight",
    "bottomLeft",
    "bottomRight"
  ]);
}
function ns(t) {
  const e = bme(t);
  return e.width = e.left + e.right, e.height = e.top + e.bottom, e;
}
function uo(t, e) {
  t = t || {}, e = e || wr.font;
  let n = Tt(t.size, e.size);
  typeof n == "string" && (n = parseInt(n, 10));
  let r = Tt(t.style, e.style);
  r && !("" + r).match(oZe) && (console.warn('Invalid font style specified: "' + r + '"'), r = void 0);
  const o = {
    family: Tt(t.family, e.family),
    lineHeight: iZe(Tt(t.lineHeight, e.lineHeight), n),
    size: n,
    style: r,
    weight: Tt(t.weight, e.weight),
    string: ""
  };
  return o.string = QQe(o), o;
}
function a1(t, e, n, r) {
  let o, i, s;
  for (o = 0, i = t.length; o < i; ++o)
    if (s = t[o], s !== void 0 && s !== void 0)
      return s;
}
function aZe(t, e, n) {
  const { min: r, max: o } = t, i = cme(e, (o - r) / 2), s = (a, l) => n && a === 0 ? 0 : a + l;
  return {
    min: s(r, -Math.abs(i)),
    max: s(o, i)
  };
}
function Xd(t, e) {
  return Object.assign(Object.create(t), e);
}
function c4(t, e = [
  ""
], n, r, o = () => t[0]) {
  const i = n || t;
  typeof r > "u" && (r = Eme("_fallback", t));
  const s = {
    [Symbol.toStringTag]: "Object",
    _cacheable: !0,
    _scopes: t,
    _rootScopes: i,
    _fallback: r,
    _getTarget: o,
    override: (a) => c4([
      a,
      ...t
    ], e, i, r)
  };
  return new Proxy(s, {
    /**
    * A trap for the delete operator.
    */
    deleteProperty(a, l) {
      return delete a[l], delete a._keys, delete t[0][l], !0;
    },
    /**
    * A trap for getting property values.
    */
    get(a, l) {
      return wme(a, l, () => mZe(l, e, t, a));
    },
    /**
    * A trap for Object.getOwnPropertyDescriptor.
    * Also used by Object.hasOwnProperty.
    */
    getOwnPropertyDescriptor(a, l) {
      return Reflect.getOwnPropertyDescriptor(a._scopes[0], l);
    },
    /**
    * A trap for Object.getPrototypeOf.
    */
    getPrototypeOf() {
      return Reflect.getPrototypeOf(t[0]);
    },
    /**
    * A trap for the in operator.
    */
    has(a, l) {
      return NU(a).includes(l);
    },
    /**
    * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
    */
    ownKeys(a) {
      return NU(a);
    },
    /**
    * A trap for setting property values.
    */
    set(a, l, c) {
      const u = a._storage || (a._storage = o());
      return a[l] = u[l] = c, delete a._keys, !0;
    }
  });
}
function ip(t, e, n, r) {
  const o = {
    _cacheable: !1,
    _proxy: t,
    _context: e,
    _subProxy: n,
    _stack: /* @__PURE__ */ new Set(),
    _descriptors: _me(t, r),
    setContext: (i) => ip(t, i, n, r),
    override: (i) => ip(t.override(i), e, n, r)
  };
  return new Proxy(o, {
    /**
    * A trap for the delete operator.
    */
    deleteProperty(i, s) {
      return delete i[s], delete t[s], !0;
    },
    /**
    * A trap for getting property values.
    */
    get(i, s, a) {
      return wme(i, s, () => cZe(i, s, a));
    },
    /**
    * A trap for Object.getOwnPropertyDescriptor.
    * Also used by Object.hasOwnProperty.
    */
    getOwnPropertyDescriptor(i, s) {
      return i._descriptors.allKeys ? Reflect.has(t, s) ? {
        enumerable: !0,
        configurable: !0
      } : void 0 : Reflect.getOwnPropertyDescriptor(t, s);
    },
    /**
    * A trap for Object.getPrototypeOf.
    */
    getPrototypeOf() {
      return Reflect.getPrototypeOf(t);
    },
    /**
    * A trap for the in operator.
    */
    has(i, s) {
      return Reflect.has(t, s);
    },
    /**
    * A trap for Object.getOwnPropertyNames and Object.getOwnPropertySymbols.
    */
    ownKeys() {
      return Reflect.ownKeys(t);
    },
    /**
    * A trap for setting property values.
    */
    set(i, s, a) {
      return t[s] = a, delete i[s], !0;
    }
  });
}
function _me(t, e = {
  scriptable: !0,
  indexable: !0
}) {
  const { _scriptable: n = e.scriptable, _indexable: r = e.indexable, _allKeys: o = e.allKeys } = t;
  return {
    allKeys: o,
    scriptable: n,
    indexable: r,
    isScriptable: nu(n) ? n : () => n,
    isIndexable: nu(r) ? r : () => r
  };
}
const lZe = (t, e) => t ? t + r4(e) : e, u4 = (t, e) => Bt(e) && t !== "adapters" && (Object.getPrototypeOf(e) === null || e.constructor === Object);
function wme(t, e, n) {
  if (Object.prototype.hasOwnProperty.call(t, e) || e === "constructor")
    return t[e];
  const r = n();
  return t[e] = r, r;
}
function cZe(t, e, n) {
  const { _proxy: r, _context: o, _subProxy: i, _descriptors: s } = t;
  let a = r[e];
  return nu(a) && s.isScriptable(e) && (a = uZe(e, a, t, n)), Cr(a) && a.length && (a = dZe(e, a, t, s.isIndexable)), u4(e, a) && (a = ip(a, o, i && i[e], s)), a;
}
function uZe(t, e, n, r) {
  const { _proxy: o, _context: i, _subProxy: s, _stack: a } = n;
  if (a.has(t))
    throw new Error("Recursion detected: " + Array.from(a).join("->") + "->" + t);
  a.add(t);
  let l = e(i, s || r);
  return a.delete(t), u4(t, l) && (l = d4(o._scopes, o, t, l)), l;
}
function dZe(t, e, n, r) {
  const { _proxy: o, _context: i, _subProxy: s, _descriptors: a } = n;
  if (typeof i.index < "u" && r(t))
    return e[i.index % e.length];
  if (Bt(e[0])) {
    const l = e, c = o._scopes.filter((u) => u !== l);
    e = [];
    for (const u of l) {
      const d = d4(c, o, t, u);
      e.push(ip(d, i, s && s[t], a));
    }
  }
  return e;
}
function xme(t, e, n) {
  return nu(t) ? t(e, n) : t;
}
const fZe = (t, e) => t === !0 ? e : typeof t == "string" ? jd(e, t) : void 0;
function hZe(t, e, n, r, o) {
  for (const i of e) {
    const s = fZe(n, i);
    if (s) {
      t.add(s);
      const a = xme(s._fallback, n, o);
      if (typeof a < "u" && a !== n && a !== r)
        return a;
    } else if (s === !1 && typeof r < "u" && n !== r)
      return null;
  }
  return !1;
}
function d4(t, e, n, r) {
  const o = e._rootScopes, i = xme(e._fallback, n, r), s = [
    ...t,
    ...o
  ], a = /* @__PURE__ */ new Set();
  a.add(r);
  let l = IU(a, s, n, i || n, r);
  return l === null || typeof i < "u" && i !== n && (l = IU(a, s, i, l, r), l === null) ? !1 : c4(Array.from(a), [
    ""
  ], o, i, () => pZe(e, n, r));
}
function IU(t, e, n, r, o) {
  for (; n; )
    n = hZe(t, e, n, r, o);
  return n;
}
function pZe(t, e, n) {
  const r = t._getTarget();
  e in r || (r[e] = {});
  const o = r[e];
  return Cr(o) && Bt(n) ? n : o || {};
}
function mZe(t, e, n, r) {
  let o;
  for (const i of e)
    if (o = Eme(lZe(i, t), n), typeof o < "u")
      return u4(t, o) ? d4(n, r, t, o) : o;
}
function Eme(t, e) {
  for (const n of e) {
    if (!n)
      continue;
    const r = n[t];
    if (typeof r < "u")
      return r;
  }
}
function NU(t) {
  let e = t._keys;
  return e || (e = t._keys = gZe(t._scopes)), e;
}
function gZe(t) {
  const e = /* @__PURE__ */ new Set();
  for (const n of t)
    for (const r of Object.keys(n).filter((o) => !o.startsWith("_")))
      e.add(r);
  return Array.from(e);
}
const yZe = Number.EPSILON || 1e-14, sp = (t, e) => e < t.length && !t[e].skip && t[e], Sme = (t) => t === "x" ? "y" : "x";
function vZe(t, e, n, r) {
  const o = t.skip ? e : t, i = e, s = n.skip ? e : n, a = aj(i, o), l = aj(s, i);
  let c = a / (a + l), u = l / (a + l);
  c = isNaN(c) ? 0 : c, u = isNaN(u) ? 0 : u;
  const d = r * c, f = r * u;
  return {
    previous: {
      x: i.x - d * (s.x - o.x),
      y: i.y - d * (s.y - o.y)
    },
    next: {
      x: i.x + f * (s.x - o.x),
      y: i.y + f * (s.y - o.y)
    }
  };
}
function bZe(t, e, n) {
  const r = t.length;
  let o, i, s, a, l, c = sp(t, 0);
  for (let u = 0; u < r - 1; ++u)
    if (l = c, c = sp(t, u + 1), !(!l || !c)) {
      if (l0(e[u], 0, yZe)) {
        n[u] = n[u + 1] = 0;
        continue;
      }
      o = n[u] / e[u], i = n[u + 1] / e[u], a = Math.pow(o, 2) + Math.pow(i, 2), !(a <= 9) && (s = 3 / Math.sqrt(a), n[u] = o * s * e[u], n[u + 1] = i * s * e[u]);
    }
}
function _Ze(t, e, n = "x") {
  const r = Sme(n), o = t.length;
  let i, s, a, l = sp(t, 0);
  for (let c = 0; c < o; ++c) {
    if (s = a, a = l, l = sp(t, c + 1), !a)
      continue;
    const u = a[n], d = a[r];
    s && (i = (u - s[n]) / 3, a[`cp1${n}`] = u - i, a[`cp1${r}`] = d - i * e[c]), l && (i = (l[n] - u) / 3, a[`cp2${n}`] = u + i, a[`cp2${r}`] = d + i * e[c]);
  }
}
function wZe(t, e = "x") {
  const n = Sme(e), r = t.length, o = Array(r).fill(0), i = Array(r);
  let s, a, l, c = sp(t, 0);
  for (s = 0; s < r; ++s)
    if (a = l, l = c, c = sp(t, s + 1), !!l) {
      if (c) {
        const u = c[e] - l[e];
        o[s] = u !== 0 ? (c[n] - l[n]) / u : 0;
      }
      i[s] = a ? c ? _a(o[s - 1]) !== _a(o[s]) ? 0 : (o[s - 1] + o[s]) / 2 : o[s - 1] : o[s];
    }
  bZe(t, o, i), _Ze(t, i, e);
}
function l1(t, e, n) {
  return Math.max(Math.min(t, n), e);
}
function xZe(t, e) {
  let n, r, o, i, s, a = _y(t[0], e);
  for (n = 0, r = t.length; n < r; ++n)
    s = i, i = a, a = n < r - 1 && _y(t[n + 1], e), i && (o = t[n], s && (o.cp1x = l1(o.cp1x, e.left, e.right), o.cp1y = l1(o.cp1y, e.top, e.bottom)), a && (o.cp2x = l1(o.cp2x, e.left, e.right), o.cp2y = l1(o.cp2y, e.top, e.bottom)));
}
function EZe(t, e, n, r, o) {
  let i, s, a, l;
  if (e.spanGaps && (t = t.filter((c) => !c.skip)), e.cubicInterpolationMode === "monotone")
    wZe(t, o);
  else {
    let c = r ? t[t.length - 1] : t[0];
    for (i = 0, s = t.length; i < s; ++i)
      a = t[i], l = vZe(c, a, t[Math.min(i + 1, s - (r ? 0 : 1)) % s], e.tension), a.cp1x = l.previous.x, a.cp1y = l.previous.y, a.cp2x = l.next.x, a.cp2y = l.next.y, c = a;
  }
  e.capBezierPoints && xZe(t, n);
}
function f4() {
  return typeof window < "u" && typeof document < "u";
}
function h4(t) {
  let e = t.parentNode;
  return e && e.toString() === "[object ShadowRoot]" && (e = e.host), e;
}
function aE(t, e, n) {
  let r;
  return typeof t == "string" ? (r = parseInt(t, 10), t.indexOf("%") !== -1 && (r = r / 100 * e.parentNode[n])) : r = t, r;
}
const XS = (t) => t.ownerDocument.defaultView.getComputedStyle(t, null);
function SZe(t, e) {
  return XS(t).getPropertyValue(e);
}
const OZe = [
  "top",
  "right",
  "bottom",
  "left"
];
function _d(t, e, n) {
  const r = {};
  n = n ? "-" + n : "";
  for (let o = 0; o < 4; o++) {
    const i = OZe[o];
    r[i] = parseFloat(t[e + "-" + i + n]) || 0;
  }
  return r.width = r.left + r.right, r.height = r.top + r.bottom, r;
}
const CZe = (t, e, n) => (t > 0 || e > 0) && (!n || !n.shadowRoot);
function kZe(t, e) {
  const n = t.touches, r = n && n.length ? n[0] : t, { offsetX: o, offsetY: i } = r;
  let s = !1, a, l;
  if (CZe(o, i, t.target))
    a = o, l = i;
  else {
    const c = e.getBoundingClientRect();
    a = r.clientX - c.left, l = r.clientY - c.top, s = !0;
  }
  return {
    x: a,
    y: l,
    box: s
  };
}
function zu(t, e) {
  if ("native" in t)
    return t;
  const { canvas: n, currentDevicePixelRatio: r } = e, o = XS(n), i = o.boxSizing === "border-box", s = _d(o, "padding"), a = _d(o, "border", "width"), { x: l, y: c, box: u } = kZe(t, n), d = s.left + (u && a.left), f = s.top + (u && a.top);
  let { width: h, height: p } = e;
  return i && (h -= s.width + a.width, p -= s.height + a.height), {
    x: Math.round((l - d) / h * n.width / r),
    y: Math.round((c - f) / p * n.height / r)
  };
}
function AZe(t, e, n) {
  let r, o;
  if (e === void 0 || n === void 0) {
    const i = t && h4(t);
    if (!i)
      e = t.clientWidth, n = t.clientHeight;
    else {
      const s = i.getBoundingClientRect(), a = XS(i), l = _d(a, "border", "width"), c = _d(a, "padding");
      e = s.width - c.width - l.width, n = s.height - c.height - l.height, r = aE(a.maxWidth, i, "clientWidth"), o = aE(a.maxHeight, i, "clientHeight");
    }
  }
  return {
    width: e,
    height: n,
    maxWidth: r || iE,
    maxHeight: o || iE
  };
}
const c1 = (t) => Math.round(t * 10) / 10;
function TZe(t, e, n, r) {
  const o = XS(t), i = _d(o, "margin"), s = aE(o.maxWidth, t, "clientWidth") || iE, a = aE(o.maxHeight, t, "clientHeight") || iE, l = AZe(t, e, n);
  let { width: c, height: u } = l;
  if (o.boxSizing === "content-box") {
    const d = _d(o, "border", "width"), f = _d(o, "padding");
    c -= f.width + d.width, u -= f.height + d.height;
  }
  return c = Math.max(0, c - i.width), u = Math.max(0, r ? c / r : u - i.height), c = c1(Math.min(c, s, l.maxWidth)), u = c1(Math.min(u, a, l.maxHeight)), c && !u && (u = c1(c / 2)), (e !== void 0 || n !== void 0) && r && l.height && u > l.height && (u = l.height, c = c1(Math.floor(u * r))), {
    width: c,
    height: u
  };
}
function jU(t, e, n) {
  const r = e || 1, o = Math.floor(t.height * r), i = Math.floor(t.width * r);
  t.height = Math.floor(t.height), t.width = Math.floor(t.width);
  const s = t.canvas;
  return s.style && (n || !s.style.height && !s.style.width) && (s.style.height = `${t.height}px`, s.style.width = `${t.width}px`), t.currentDevicePixelRatio !== r || s.height !== o || s.width !== i ? (t.currentDevicePixelRatio = r, s.height = o, s.width = i, t.ctx.setTransform(r, 0, 0, r, 0, 0), !0) : !1;
}
const RZe = function() {
  let t = !1;
  try {
    const e = {
      get passive() {
        return t = !0, !1;
      }
    };
    f4() && (window.addEventListener("test", null, e), window.removeEventListener("test", null, e));
  } catch {
  }
  return t;
}();
function LU(t, e) {
  const n = SZe(t, e), r = n && n.match(/^(\d+)(\.\d+)?px$/);
  return r ? +r[1] : void 0;
}
function qu(t, e, n, r) {
  return {
    x: t.x + n * (e.x - t.x),
    y: t.y + n * (e.y - t.y)
  };
}
function PZe(t, e, n, r) {
  return {
    x: t.x + n * (e.x - t.x),
    y: r === "middle" ? n < 0.5 ? t.y : e.y : r === "after" ? n < 1 ? t.y : e.y : n > 0 ? e.y : t.y
  };
}
function $Ze(t, e, n, r) {
  const o = {
    x: t.cp2x,
    y: t.cp2y
  }, i = {
    x: e.cp1x,
    y: e.cp1y
  }, s = qu(t, o, n), a = qu(o, i, n), l = qu(i, e, n), c = qu(s, a, n), u = qu(a, l, n);
  return qu(c, u, n);
}
const MZe = function(t, e) {
  return {
    x(n) {
      return t + t + e - n;
    },
    setWidth(n) {
      e = n;
    },
    textAlign(n) {
      return n === "center" ? n : n === "right" ? "left" : "right";
    },
    xPlus(n, r) {
      return n - r;
    },
    leftForLtr(n, r) {
      return n - r;
    }
  };
}, DZe = function() {
  return {
    x(t) {
      return t;
    },
    setWidth(t) {
    },
    textAlign(t) {
      return t;
    },
    xPlus(t, e) {
      return t + e;
    },
    leftForLtr(t, e) {
      return t;
    }
  };
};
function Oh(t, e, n) {
  return t ? MZe(e, n) : DZe();
}
function Ome(t, e) {
  let n, r;
  (e === "ltr" || e === "rtl") && (n = t.canvas.style, r = [
    n.getPropertyValue("direction"),
    n.getPropertyPriority("direction")
  ], n.setProperty("direction", e, "important"), t.prevTextDirection = r);
}
function Cme(t, e) {
  e !== void 0 && (delete t.prevTextDirection, t.canvas.style.setProperty("direction", e[0], e[1]));
}
function kme(t) {
  return t === "angle" ? {
    between: by,
    compare: MQe,
    normalize: di
  } : {
    between: El,
    compare: (e, n) => e - n,
    normalize: (e) => e
  };
}
function FU({ start: t, end: e, count: n, loop: r, style: o }) {
  return {
    start: t % n,
    end: e % n,
    loop: r && (e - t + 1) % n === 0,
    style: o
  };
}
function IZe(t, e, n) {
  const { property: r, start: o, end: i } = n, { between: s, normalize: a } = kme(r), l = e.length;
  let { start: c, end: u, loop: d } = t, f, h;
  if (d) {
    for (c += l, u += l, f = 0, h = l; f < h && s(a(e[c % l][r]), o, i); ++f)
      c--, u--;
    c %= l, u %= l;
  }
  return u < c && (u += l), {
    start: c,
    end: u,
    loop: d,
    style: t.style
  };
}
function Ame(t, e, n) {
  if (!n)
    return [
      t
    ];
  const { property: r, start: o, end: i } = n, s = e.length, { compare: a, between: l, normalize: c } = kme(r), { start: u, end: d, loop: f, style: h } = IZe(t, e, n), p = [];
  let m = !1, g = null, y, v, b;
  const _ = () => l(o, b, y) && a(o, b) !== 0, w = () => a(i, y) === 0 || l(i, b, y), x = () => m || _(), E = () => !m || w();
  for (let S = u, C = u; S <= d; ++S)
    v = e[S % s], !v.skip && (y = c(v[r]), y !== b && (m = l(y, o, i), g === null && x() && (g = a(y, o) === 0 ? S : C), g !== null && E() && (p.push(FU({
      start: g,
      end: S,
      loop: f,
      count: s,
      style: h
    })), g = null), C = S, b = y));
  return g !== null && p.push(FU({
    start: g,
    end: d,
    loop: f,
    count: s,
    style: h
  })), p;
}
function Tme(t, e) {
  const n = [], r = t.segments;
  for (let o = 0; o < r.length; o++) {
    const i = Ame(r[o], t.points, e);
    i.length && n.push(...i);
  }
  return n;
}
function NZe(t, e, n, r) {
  let o = 0, i = e - 1;
  if (n && !r)
    for (; o < e && !t[o].skip; )
      o++;
  for (; o < e && t[o].skip; )
    o++;
  for (o %= e, n && (i += o); i > o && t[i % e].skip; )
    i--;
  return i %= e, {
    start: o,
    end: i
  };
}
function jZe(t, e, n, r) {
  const o = t.length, i = [];
  let s = e, a = t[e], l;
  for (l = e + 1; l <= n; ++l) {
    const c = t[l % o];
    c.skip || c.stop ? a.skip || (r = !1, i.push({
      start: e % o,
      end: (l - 1) % o,
      loop: r
    }), e = s = c.stop ? l : null) : (s = l, a.skip && (e = l)), a = c;
  }
  return s !== null && i.push({
    start: e % o,
    end: s % o,
    loop: r
  }), i;
}
function LZe(t, e) {
  const n = t.points, r = t.options.spanGaps, o = n.length;
  if (!o)
    return [];
  const i = !!t._loop, { start: s, end: a } = NZe(n, o, i, r);
  if (r === !0)
    return BU(t, [
      {
        start: s,
        end: a,
        loop: i
      }
    ], n, e);
  const l = a < s ? a + o : a, c = !!t._fullLoop && s === 0 && a === o - 1;
  return BU(t, jZe(n, s, l, c), n, e);
}
function BU(t, e, n, r) {
  return !r || !r.setContext || !n ? e : FZe(t, e, n, r);
}
function FZe(t, e, n, r) {
  const o = t._chart.getContext(), i = zU(t.options), { _datasetIndex: s, options: { spanGaps: a } } = t, l = n.length, c = [];
  let u = i, d = e[0].start, f = d;
  function h(p, m, g, y) {
    const v = a ? -1 : 1;
    if (p !== m) {
      for (p += l; n[p % l].skip; )
        p -= v;
      for (; n[m % l].skip; )
        m += v;
      p % l !== m % l && (c.push({
        start: p % l,
        end: m % l,
        loop: g,
        style: y
      }), u = y, d = m % l);
    }
  }
  for (const p of e) {
    d = a ? d : p.start;
    let m = n[d % l], g;
    for (f = d + 1; f <= p.end; f++) {
      const y = n[f % l];
      g = zU(r.setContext(Xd(o, {
        type: "segment",
        p0: m,
        p1: y,
        p0DataIndex: (f - 1) % l,
        p1DataIndex: f % l,
        datasetIndex: s
      }))), BZe(g, u) && h(d, f - 1, p.loop, u), m = y, u = g;
    }
    d < f - 1 && h(d, f - 1, p.loop, u);
  }
  return c;
}
function zU(t) {
  return {
    backgroundColor: t.backgroundColor,
    borderCapStyle: t.borderCapStyle,
    borderDash: t.borderDash,
    borderDashOffset: t.borderDashOffset,
    borderJoinStyle: t.borderJoinStyle,
    borderWidth: t.borderWidth,
    borderColor: t.borderColor
  };
}
function BZe(t, e) {
  if (!e)
    return !1;
  const n = [], r = function(o, i) {
    return s4(i) ? (n.includes(i) || n.push(i), n.indexOf(i)) : i;
  };
  return JSON.stringify(t, r) !== JSON.stringify(e, r);
}
function u1(t, e, n) {
  return t.options.clip ? t[n] : e[n];
}
function zZe(t, e) {
  const { xScale: n, yScale: r } = t;
  return n && r ? {
    left: u1(n, e, "left"),
    right: u1(n, e, "right"),
    top: u1(r, e, "top"),
    bottom: u1(r, e, "bottom")
  } : e;
}
function Rme(t, e) {
  const n = e._clip;
  if (n.disabled)
    return !1;
  const r = zZe(e, t.chartArea);
  return {
    left: n.left === !1 ? 0 : r.left - (n.left === !0 ? 0 : n.left),
    right: n.right === !1 ? t.width : r.right + (n.right === !0 ? 0 : n.right),
    top: n.top === !1 ? 0 : r.top - (n.top === !0 ? 0 : n.top),
    bottom: n.bottom === !1 ? t.height : r.bottom + (n.bottom === !0 ? 0 : n.bottom)
  };
}
/*!
 * Chart.js v4.5.0
 * https://www.chartjs.org
 * (c) 2025 Chart.js Contributors
 * Released under the MIT License
 */
class qZe {
  constructor() {
    this._request = null, this._charts = /* @__PURE__ */ new Map(), this._running = !1, this._lastDate = void 0;
  }
  _notify(e, n, r, o) {
    const i = n.listeners[o], s = n.duration;
    i.forEach((a) => a({
      chart: e,
      initial: n.initial,
      numSteps: s,
      currentStep: Math.min(r - n.start, s)
    }));
  }
  _refresh() {
    this._request || (this._running = !0, this._request = mme.call(window, () => {
      this._update(), this._request = null, this._running && this._refresh();
    }));
  }
  _update(e = Date.now()) {
    let n = 0;
    this._charts.forEach((r, o) => {
      if (!r.running || !r.items.length)
        return;
      const i = r.items;
      let s = i.length - 1, a = !1, l;
      for (; s >= 0; --s)
        l = i[s], l._active ? (l._total > r.duration && (r.duration = l._total), l.tick(e), a = !0) : (i[s] = i[i.length - 1], i.pop());
      a && (o.draw(), this._notify(o, r, e, "progress")), i.length || (r.running = !1, this._notify(o, r, e, "complete"), r.initial = !1), n += i.length;
    }), this._lastDate = e, n === 0 && (this._running = !1);
  }
  _getAnims(e) {
    const n = this._charts;
    let r = n.get(e);
    return r || (r = {
      running: !1,
      initial: !0,
      items: [],
      listeners: {
        complete: [],
        progress: []
      }
    }, n.set(e, r)), r;
  }
  listen(e, n, r) {
    this._getAnims(e).listeners[n].push(r);
  }
  add(e, n) {
    !n || !n.length || this._getAnims(e).items.push(...n);
  }
  has(e) {
    return this._getAnims(e).items.length > 0;
  }
  start(e) {
    const n = this._charts.get(e);
    n && (n.running = !0, n.start = Date.now(), n.duration = n.items.reduce((r, o) => Math.max(r, o._duration), 0), this._refresh());
  }
  running(e) {
    if (!this._running)
      return !1;
    const n = this._charts.get(e);
    return !(!n || !n.running || !n.items.length);
  }
  stop(e) {
    const n = this._charts.get(e);
    if (!n || !n.items.length)
      return;
    const r = n.items;
    let o = r.length - 1;
    for (; o >= 0; --o)
      r[o].cancel();
    n.items = [], this._notify(e, n, Date.now(), "complete");
  }
  remove(e) {
    return this._charts.delete(e);
  }
}
var tl = /* @__PURE__ */ new qZe();
const qU = "transparent", UZe = {
  boolean(t, e, n) {
    return n > 0.5 ? e : t;
  },
  color(t, e, n) {
    const r = PU(t || qU), o = r.valid && PU(e || qU);
    return o && o.valid ? o.mix(r, n).hexString() : e;
  },
  number(t, e, n) {
    return t + (e - t) * n;
  }
};
class HZe {
  constructor(e, n, r, o) {
    const i = n[r];
    o = a1([
      e.to,
      o,
      i,
      e.from
    ]);
    const s = a1([
      e.from,
      i,
      o
    ]);
    this._active = !0, this._fn = e.fn || UZe[e.type || typeof s], this._easing = c0[e.easing] || c0.linear, this._start = Math.floor(Date.now() + (e.delay || 0)), this._duration = this._total = Math.floor(e.duration), this._loop = !!e.loop, this._target = n, this._prop = r, this._from = s, this._to = o, this._promises = void 0;
  }
  active() {
    return this._active;
  }
  update(e, n, r) {
    if (this._active) {
      this._notify(!1);
      const o = this._target[this._prop], i = r - this._start, s = this._duration - i;
      this._start = r, this._duration = Math.floor(Math.max(s, e.duration)), this._total += i, this._loop = !!e.loop, this._to = a1([
        e.to,
        n,
        o,
        e.from
      ]), this._from = a1([
        e.from,
        o,
        n
      ]);
    }
  }
  cancel() {
    this._active && (this.tick(Date.now()), this._active = !1, this._notify(!1));
  }
  tick(e) {
    const n = e - this._start, r = this._duration, o = this._prop, i = this._from, s = this._loop, a = this._to;
    let l;
    if (this._active = i !== a && (s || n < r), !this._active) {
      this._target[o] = a, this._notify(!0);
      return;
    }
    if (n < 0) {
      this._target[o] = i;
      return;
    }
    l = n / r % 2, l = s && l > 1 ? 2 - l : l, l = this._easing(Math.min(1, Math.max(0, l))), this._target[o] = this._fn(i, a, l);
  }
  wait() {
    const e = this._promises || (this._promises = []);
    return new Promise((n, r) => {
      e.push({
        res: n,
        rej: r
      });
    });
  }
  _notify(e) {
    const n = e ? "res" : "rej", r = this._promises || [];
    for (let o = 0; o < r.length; o++)
      r[o][n]();
  }
}
class Pme {
  constructor(e, n) {
    this._chart = e, this._properties = /* @__PURE__ */ new Map(), this.configure(n);
  }
  configure(e) {
    if (!Bt(e))
      return;
    const n = Object.keys(wr.animation), r = this._properties;
    Object.getOwnPropertyNames(e).forEach((o) => {
      const i = e[o];
      if (!Bt(i))
        return;
      const s = {};
      for (const a of n)
        s[a] = i[a];
      (Cr(i.properties) && i.properties || [
        o
      ]).forEach((a) => {
        (a === o || !r.has(a)) && r.set(a, s);
      });
    });
  }
  _animateOptions(e, n) {
    const r = n.options, o = WZe(e, r);
    if (!o)
      return [];
    const i = this._createAnimations(o, r);
    return r.$shared && VZe(e.options.$animations, r).then(() => {
      e.options = r;
    }, () => {
    }), i;
  }
  _createAnimations(e, n) {
    const r = this._properties, o = [], i = e.$animations || (e.$animations = {}), s = Object.keys(n), a = Date.now();
    let l;
    for (l = s.length - 1; l >= 0; --l) {
      const c = s[l];
      if (c.charAt(0) === "$")
        continue;
      if (c === "options") {
        o.push(...this._animateOptions(e, n));
        continue;
      }
      const u = n[c];
      let d = i[c];
      const f = r.get(c);
      if (d)
        if (f && d.active()) {
          d.update(f, u, a);
          continue;
        } else
          d.cancel();
      if (!f || !f.duration) {
        e[c] = u;
        continue;
      }
      i[c] = d = new HZe(f, e, c, u), o.push(d);
    }
    return o;
  }
  update(e, n) {
    if (this._properties.size === 0) {
      Object.assign(e, n);
      return;
    }
    const r = this._createAnimations(e, n);
    if (r.length)
      return tl.add(this._chart, r), !0;
  }
}
function VZe(t, e) {
  const n = [], r = Object.keys(e);
  for (let o = 0; o < r.length; o++) {
    const i = t[r[o]];
    i && i.active() && n.push(i.wait());
  }
  return Promise.all(n);
}
function WZe(t, e) {
  if (!e)
    return;
  let n = t.options;
  if (!n) {
    t.options = e;
    return;
  }
  return n.$shared && (t.options = n = Object.assign({}, n, {
    $shared: !1,
    $animations: {}
  })), n;
}
function UU(t, e) {
  const n = t && t.options || {}, r = n.reverse, o = n.min === void 0 ? e : 0, i = n.max === void 0 ? e : 0;
  return {
    start: r ? i : o,
    end: r ? o : i
  };
}
function GZe(t, e, n) {
  if (n === !1)
    return !1;
  const r = UU(t, n), o = UU(e, n);
  return {
    top: o.end,
    right: r.end,
    bottom: o.start,
    left: r.start
  };
}
function YZe(t) {
  let e, n, r, o;
  return Bt(t) ? (e = t.top, n = t.right, r = t.bottom, o = t.left) : e = n = r = o = t, {
    top: e,
    right: n,
    bottom: r,
    left: o,
    disabled: t === !1
  };
}
function $me(t, e) {
  const n = [], r = t._getSortedDatasetMetas(e);
  let o, i;
  for (o = 0, i = r.length; o < i; ++o)
    n.push(r[o].index);
  return n;
}
function HU(t, e, n, r = {}) {
  const o = t.keys, i = r.mode === "single";
  let s, a, l, c;
  if (e === null)
    return;
  let u = !1;
  for (s = 0, a = o.length; s < a; ++s) {
    if (l = +o[s], l === n) {
      if (u = !0, r.all)
        continue;
      break;
    }
    c = t.values[l], po(c) && (i || e === 0 || _a(e) === _a(c)) && (e += c);
  }
  return !u && !r.all ? 0 : e;
}
function KZe(t, e) {
  const { iScale: n, vScale: r } = e, o = n.axis === "x" ? "x" : "y", i = r.axis === "x" ? "x" : "y", s = Object.keys(t), a = new Array(s.length);
  let l, c, u;
  for (l = 0, c = s.length; l < c; ++l)
    u = s[l], a[l] = {
      [o]: u,
      [i]: t[u]
    };
  return a;
}
function Qk(t, e) {
  const n = t && t.options.stacked;
  return n || n === void 0 && e.stack !== void 0;
}
function XZe(t, e, n) {
  return `${t.id}.${e.id}.${n.stack || n.type}`;
}
function QZe(t) {
  const { min: e, max: n, minDefined: r, maxDefined: o } = t.getUserBounds();
  return {
    min: r ? e : Number.NEGATIVE_INFINITY,
    max: o ? n : Number.POSITIVE_INFINITY
  };
}
function ZZe(t, e, n) {
  const r = t[e] || (t[e] = {});
  return r[n] || (r[n] = {});
}
function VU(t, e, n, r) {
  for (const o of e.getMatchingVisibleMetas(r).reverse()) {
    const i = t[o.index];
    if (n && i > 0 || !n && i < 0)
      return o.index;
  }
  return null;
}
function WU(t, e) {
  const { chart: n, _cachedMeta: r } = t, o = n._stacks || (n._stacks = {}), { iScale: i, vScale: s, index: a } = r, l = i.axis, c = s.axis, u = XZe(i, s, r), d = e.length;
  let f;
  for (let h = 0; h < d; ++h) {
    const p = e[h], { [l]: m, [c]: g } = p, y = p._stacks || (p._stacks = {});
    f = y[c] = ZZe(o, u, m), f[a] = g, f._top = VU(f, s, !0, r.type), f._bottom = VU(f, s, !1, r.type);
    const v = f._visualValues || (f._visualValues = {});
    v[a] = g;
  }
}
function Zk(t, e) {
  const n = t.scales;
  return Object.keys(n).filter((r) => n[r].axis === e).shift();
}
function JZe(t, e) {
  return Xd(t, {
    active: !1,
    dataset: void 0,
    datasetIndex: e,
    index: e,
    mode: "default",
    type: "dataset"
  });
}
function eJe(t, e, n) {
  return Xd(t, {
    active: !1,
    dataIndex: e,
    parsed: void 0,
    raw: void 0,
    element: n,
    index: e,
    mode: "default",
    type: "data"
  });
}
function pm(t, e) {
  const n = t.controller.index, r = t.vScale && t.vScale.axis;
  if (r) {
    e = e || t._parsed;
    for (const o of e) {
      const i = o._stacks;
      if (!i || i[r] === void 0 || i[r][n] === void 0)
        return;
      delete i[r][n], i[r]._visualValues !== void 0 && i[r]._visualValues[n] !== void 0 && delete i[r]._visualValues[n];
    }
  }
}
const Jk = (t) => t === "reset" || t === "none", GU = (t, e) => e ? t : Object.assign({}, t), tJe = (t, e, n) => t && !e.hidden && e._stacked && {
  keys: $me(n, !0),
  values: null
};
class wd {
  constructor(e, n) {
    this.chart = e, this._ctx = e.ctx, this.index = n, this._cachedDataOpts = {}, this._cachedMeta = this.getMeta(), this._type = this._cachedMeta.type, this.options = void 0, this._parsing = !1, this._data = void 0, this._objectData = void 0, this._sharedOptions = void 0, this._drawStart = void 0, this._drawCount = void 0, this.enableOptionSharing = !1, this.supportsDecimation = !1, this.$context = void 0, this._syncList = [], this.datasetElementType = new.target.datasetElementType, this.dataElementType = new.target.dataElementType, this.initialize();
  }
  initialize() {
    const e = this._cachedMeta;
    this.configure(), this.linkScales(), e._stacked = Qk(e.vScale, e), this.addElements(), this.options.fill && !this.chart.isPluginEnabled("filler") && console.warn("Tried to use the 'fill' option without the 'Filler' plugin enabled. Please import and register the 'Filler' plugin and make sure it is not disabled in the options");
  }
  updateIndex(e) {
    this.index !== e && pm(this._cachedMeta), this.index = e;
  }
  linkScales() {
    const e = this.chart, n = this._cachedMeta, r = this.getDataset(), o = (d, f, h, p) => d === "x" ? f : d === "r" ? p : h, i = n.xAxisID = Tt(r.xAxisID, Zk(e, "x")), s = n.yAxisID = Tt(r.yAxisID, Zk(e, "y")), a = n.rAxisID = Tt(r.rAxisID, Zk(e, "r")), l = n.indexAxis, c = n.iAxisID = o(l, i, s, a), u = n.vAxisID = o(l, s, i, a);
    n.xScale = this.getScaleForId(i), n.yScale = this.getScaleForId(s), n.rScale = this.getScaleForId(a), n.iScale = this.getScaleForId(c), n.vScale = this.getScaleForId(u);
  }
  getDataset() {
    return this.chart.data.datasets[this.index];
  }
  getMeta() {
    return this.chart.getDatasetMeta(this.index);
  }
  getScaleForId(e) {
    return this.chart.scales[e];
  }
  _getOtherScale(e) {
    const n = this._cachedMeta;
    return e === n.iScale ? n.vScale : n.iScale;
  }
  reset() {
    this._update("reset");
  }
  _destroy() {
    const e = this._cachedMeta;
    this._data && AU(this._data, this), e._stacked && pm(e);
  }
  _dataCheck() {
    const e = this.getDataset(), n = e.data || (e.data = []), r = this._data;
    if (Bt(n)) {
      const o = this._cachedMeta;
      this._data = KZe(n, o);
    } else if (r !== n) {
      if (r) {
        AU(r, this);
        const o = this._cachedMeta;
        pm(o), o._parsed = [];
      }
      n && Object.isExtensible(n) && jQe(n, this), this._syncList = [], this._data = n;
    }
  }
  addElements() {
    const e = this._cachedMeta;
    this._dataCheck(), this.datasetElementType && (e.dataset = new this.datasetElementType());
  }
  buildOrUpdateElements(e) {
    const n = this._cachedMeta, r = this.getDataset();
    let o = !1;
    this._dataCheck();
    const i = n._stacked;
    n._stacked = Qk(n.vScale, n), n.stack !== r.stack && (o = !0, pm(n), n.stack = r.stack), this._resyncElements(e), (o || i !== n._stacked) && (WU(this, n._parsed), n._stacked = Qk(n.vScale, n));
  }
  configure() {
    const e = this.chart.config, n = e.datasetScopeKeys(this._type), r = e.getOptionScopes(this.getDataset(), n, !0);
    this.options = e.createResolver(r, this.getContext()), this._parsing = this.options.parsing, this._cachedDataOpts = {};
  }
  parse(e, n) {
    const { _cachedMeta: r, _data: o } = this, { iScale: i, _stacked: s } = r, a = i.axis;
    let l = e === 0 && n === o.length ? !0 : r._sorted, c = e > 0 && r._parsed[e - 1], u, d, f;
    if (this._parsing === !1)
      r._parsed = o, r._sorted = !0, f = o;
    else {
      Cr(o[e]) ? f = this.parseArrayData(r, o, e, n) : Bt(o[e]) ? f = this.parseObjectData(r, o, e, n) : f = this.parsePrimitiveData(r, o, e, n);
      const h = () => d[a] === null || c && d[a] < c[a];
      for (u = 0; u < n; ++u)
        r._parsed[u + e] = d = f[u], l && (h() && (l = !1), c = d);
      r._sorted = l;
    }
    s && WU(this, f);
  }
  parsePrimitiveData(e, n, r, o) {
    const { iScale: i, vScale: s } = e, a = i.axis, l = s.axis, c = i.getLabels(), u = i === s, d = new Array(o);
    let f, h, p;
    for (f = 0, h = o; f < h; ++f)
      p = f + r, d[f] = {
        [a]: u || i.parse(c[p], p),
        [l]: s.parse(n[p], p)
      };
    return d;
  }
  parseArrayData(e, n, r, o) {
    const { xScale: i, yScale: s } = e, a = new Array(o);
    let l, c, u, d;
    for (l = 0, c = o; l < c; ++l)
      u = l + r, d = n[u], a[l] = {
        x: i.parse(d[0], u),
        y: s.parse(d[1], u)
      };
    return a;
  }
  parseObjectData(e, n, r, o) {
    const { xScale: i, yScale: s } = e, { xAxisKey: a = "x", yAxisKey: l = "y" } = this._parsing, c = new Array(o);
    let u, d, f, h;
    for (u = 0, d = o; u < d; ++u)
      f = u + r, h = n[f], c[u] = {
        x: i.parse(jd(h, a), f),
        y: s.parse(jd(h, l), f)
      };
    return c;
  }
  getParsed(e) {
    return this._cachedMeta._parsed[e];
  }
  getDataElement(e) {
    return this._cachedMeta.data[e];
  }
  applyStack(e, n, r) {
    const o = this.chart, i = this._cachedMeta, s = n[e.axis], a = {
      keys: $me(o, !0),
      values: n._stacks[e.axis]._visualValues
    };
    return HU(a, s, i.index, {
      mode: r
    });
  }
  updateRangeFromParsed(e, n, r, o) {
    const i = r[n.axis];
    let s = i === null ? NaN : i;
    const a = o && r._stacks[n.axis];
    o && a && (o.values = a, s = HU(o, i, this._cachedMeta.index)), e.min = Math.min(e.min, s), e.max = Math.max(e.max, s);
  }
  getMinMax(e, n) {
    const r = this._cachedMeta, o = r._parsed, i = r._sorted && e === r.iScale, s = o.length, a = this._getOtherScale(e), l = tJe(n, r, this.chart), c = {
      min: Number.POSITIVE_INFINITY,
      max: Number.NEGATIVE_INFINITY
    }, { min: u, max: d } = QZe(a);
    let f, h;
    function p() {
      h = o[f];
      const m = h[a.axis];
      return !po(h[e.axis]) || u > m || d < m;
    }
    for (f = 0; f < s && !(!p() && (this.updateRangeFromParsed(c, e, h, l), i)); ++f)
      ;
    if (i) {
      for (f = s - 1; f >= 0; --f)
        if (!p()) {
          this.updateRangeFromParsed(c, e, h, l);
          break;
        }
    }
    return c;
  }
  getAllParsedValues(e) {
    const n = this._cachedMeta._parsed, r = [];
    let o, i, s;
    for (o = 0, i = n.length; o < i; ++o)
      s = n[o][e.axis], po(s) && r.push(s);
    return r;
  }
  getMaxOverflow() {
    return !1;
  }
  getLabelAndValue(e) {
    const n = this._cachedMeta, r = n.iScale, o = n.vScale, i = this.getParsed(e);
    return {
      label: r ? "" + r.getLabelForValue(i[r.axis]) : "",
      value: o ? "" + o.getLabelForValue(i[o.axis]) : ""
    };
  }
  _update(e) {
    const n = this._cachedMeta;
    this.update(e || "default"), n._clip = YZe(Tt(this.options.clip, GZe(n.xScale, n.yScale, this.getMaxOverflow())));
  }
  update(e) {
  }
  draw() {
    const e = this._ctx, n = this.chart, r = this._cachedMeta, o = r.data || [], i = n.chartArea, s = [], a = this._drawStart || 0, l = this._drawCount || o.length - a, c = this.options.drawActiveElementsOnTop;
    let u;
    for (r.dataset && r.dataset.draw(e, i, a, l), u = a; u < a + l; ++u) {
      const d = o[u];
      d.hidden || (d.active && c ? s.push(d) : d.draw(e, i));
    }
    for (u = 0; u < s.length; ++u)
      s[u].draw(e, i);
  }
  getStyle(e, n) {
    const r = n ? "active" : "default";
    return e === void 0 && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(r) : this.resolveDataElementOptions(e || 0, r);
  }
  getContext(e, n, r) {
    const o = this.getDataset();
    let i;
    if (e >= 0 && e < this._cachedMeta.data.length) {
      const s = this._cachedMeta.data[e];
      i = s.$context || (s.$context = eJe(this.getContext(), e, s)), i.parsed = this.getParsed(e), i.raw = o.data[e], i.index = i.dataIndex = e;
    } else
      i = this.$context || (this.$context = JZe(this.chart.getContext(), this.index)), i.dataset = o, i.index = i.datasetIndex = this.index;
    return i.active = !!n, i.mode = r, i;
  }
  resolveDatasetElementOptions(e) {
    return this._resolveElementOptions(this.datasetElementType.id, e);
  }
  resolveDataElementOptions(e, n) {
    return this._resolveElementOptions(this.dataElementType.id, n, e);
  }
  _resolveElementOptions(e, n = "default", r) {
    const o = n === "active", i = this._cachedDataOpts, s = e + "-" + n, a = i[s], l = this.enableOptionSharing && yy(r);
    if (a)
      return GU(a, l);
    const c = this.chart.config, u = c.datasetElementScopeKeys(this._type, e), d = o ? [
      `${e}Hover`,
      "hover",
      e,
      ""
    ] : [
      e,
      ""
    ], f = c.getOptionScopes(this.getDataset(), u), h = Object.keys(wr.elements[e]), p = () => this.getContext(r, o, n), m = c.resolveNamedOptions(f, h, p, d);
    return m.$shared && (m.$shared = l, i[s] = Object.freeze(GU(m, l))), m;
  }
  _resolveAnimations(e, n, r) {
    const o = this.chart, i = this._cachedDataOpts, s = `animation-${n}`, a = i[s];
    if (a)
      return a;
    let l;
    if (o.options.animation !== !1) {
      const u = this.chart.config, d = u.datasetAnimationScopeKeys(this._type, n), f = u.getOptionScopes(this.getDataset(), d);
      l = u.createResolver(f, this.getContext(e, r, n));
    }
    const c = new Pme(o, l && l.animations);
    return l && l._cacheable && (i[s] = Object.freeze(c)), c;
  }
  getSharedOptions(e) {
    if (e.$shared)
      return this._sharedOptions || (this._sharedOptions = Object.assign({}, e));
  }
  includeOptions(e, n) {
    return !n || Jk(e) || this.chart._animationsDisabled;
  }
  _getSharedOptions(e, n) {
    const r = this.resolveDataElementOptions(e, n), o = this._sharedOptions, i = this.getSharedOptions(r), s = this.includeOptions(n, i) || i !== o;
    return this.updateSharedOptions(i, n, r), {
      sharedOptions: i,
      includeOptions: s
    };
  }
  updateElement(e, n, r, o) {
    Jk(o) ? Object.assign(e, r) : this._resolveAnimations(n, o).update(e, r);
  }
  updateSharedOptions(e, n, r) {
    e && !Jk(n) && this._resolveAnimations(void 0, n).update(e, r);
  }
  _setStyle(e, n, r, o) {
    e.active = o;
    const i = this.getStyle(n, o);
    this._resolveAnimations(n, r, o).update(e, {
      options: !o && this.getSharedOptions(i) || i
    });
  }
  removeHoverStyle(e, n, r) {
    this._setStyle(e, r, "active", !1);
  }
  setHoverStyle(e, n, r) {
    this._setStyle(e, r, "active", !0);
  }
  _removeDatasetHoverStyle() {
    const e = this._cachedMeta.dataset;
    e && this._setStyle(e, void 0, "active", !1);
  }
  _setDatasetHoverStyle() {
    const e = this._cachedMeta.dataset;
    e && this._setStyle(e, void 0, "active", !0);
  }
  _resyncElements(e) {
    const n = this._data, r = this._cachedMeta.data;
    for (const [a, l, c] of this._syncList)
      this[a](l, c);
    this._syncList = [];
    const o = r.length, i = n.length, s = Math.min(i, o);
    s && this.parse(0, s), i > o ? this._insertElements(o, i - o, e) : i < o && this._removeElements(i, o - i);
  }
  _insertElements(e, n, r = !0) {
    const o = this._cachedMeta, i = o.data, s = e + n;
    let a;
    const l = (c) => {
      for (c.length += n, a = c.length - 1; a >= s; a--)
        c[a] = c[a - n];
    };
    for (l(i), a = e; a < s; ++a)
      i[a] = new this.dataElementType();
    this._parsing && l(o._parsed), this.parse(e, n), r && this.updateElements(i, e, n, "reset");
  }
  updateElements(e, n, r, o) {
  }
  _removeElements(e, n) {
    const r = this._cachedMeta;
    if (this._parsing) {
      const o = r._parsed.splice(e, n);
      r._stacked && pm(r, o);
    }
    r.data.splice(e, n);
  }
  _sync(e) {
    if (this._parsing)
      this._syncList.push(e);
    else {
      const [n, r, o] = e;
      this[n](r, o);
    }
    this.chart._dataChanges.push([
      this.index,
      ...e
    ]);
  }
  _onDataPush() {
    const e = arguments.length;
    this._sync([
      "_insertElements",
      this.getDataset().data.length - e,
      e
    ]);
  }
  _onDataPop() {
    this._sync([
      "_removeElements",
      this._cachedMeta.data.length - 1,
      1
    ]);
  }
  _onDataShift() {
    this._sync([
      "_removeElements",
      0,
      1
    ]);
  }
  _onDataSplice(e, n) {
    n && this._sync([
      "_removeElements",
      e,
      n
    ]);
    const r = arguments.length - 2;
    r && this._sync([
      "_insertElements",
      e,
      r
    ]);
  }
  _onDataUnshift() {
    this._sync([
      "_insertElements",
      0,
      arguments.length
    ]);
  }
}
ue(wd, "defaults", {}), ue(wd, "datasetElementType", null), ue(wd, "dataElementType", null);
function nJe(t, e) {
  if (!t._cache.$bar) {
    const n = t.getMatchingVisibleMetas(e);
    let r = [];
    for (let o = 0, i = n.length; o < i; o++)
      r = r.concat(n[o].controller.getAllParsedValues(t));
    t._cache.$bar = pme(r.sort((o, i) => o - i));
  }
  return t._cache.$bar;
}
function rJe(t) {
  const e = t.iScale, n = nJe(e, t.type);
  let r = e._length, o, i, s, a;
  const l = () => {
    s === 32767 || s === -32768 || (yy(a) && (r = Math.min(r, Math.abs(s - a) || r)), a = s);
  };
  for (o = 0, i = n.length; o < i; ++o)
    s = e.getPixelForValue(n[o]), l();
  for (a = void 0, o = 0, i = e.ticks.length; o < i; ++o)
    s = e.getPixelForTick(o), l();
  return r;
}
function oJe(t, e, n, r) {
  const o = n.barThickness;
  let i, s;
  return vn(o) ? (i = e.min * n.categoryPercentage, s = n.barPercentage) : (i = o * r, s = 1), {
    chunk: i / r,
    ratio: s,
    start: e.pixels[t] - i / 2
  };
}
function iJe(t, e, n, r) {
  const o = e.pixels, i = o[t];
  let s = t > 0 ? o[t - 1] : null, a = t < o.length - 1 ? o[t + 1] : null;
  const l = n.categoryPercentage;
  s === null && (s = i - (a === null ? e.end - e.start : a - i)), a === null && (a = i + i - s);
  const c = i - (i - Math.min(s, a)) / 2 * l;
  return {
    chunk: Math.abs(a - s) / 2 * l / r,
    ratio: n.barPercentage,
    start: c
  };
}
function sJe(t, e, n, r) {
  const o = n.parse(t[0], r), i = n.parse(t[1], r), s = Math.min(o, i), a = Math.max(o, i);
  let l = s, c = a;
  Math.abs(s) > Math.abs(a) && (l = a, c = s), e[n.axis] = c, e._custom = {
    barStart: l,
    barEnd: c,
    start: o,
    end: i,
    min: s,
    max: a
  };
}
function Mme(t, e, n, r) {
  return Cr(t) ? sJe(t, e, n, r) : e[n.axis] = n.parse(t, r), e;
}
function YU(t, e, n, r) {
  const o = t.iScale, i = t.vScale, s = o.getLabels(), a = o === i, l = [];
  let c, u, d, f;
  for (c = n, u = n + r; c < u; ++c)
    f = e[c], d = {}, d[o.axis] = a || o.parse(s[c], c), l.push(Mme(f, d, i, c));
  return l;
}
function e2(t) {
  return t && t.barStart !== void 0 && t.barEnd !== void 0;
}
function aJe(t, e, n) {
  return t !== 0 ? _a(t) : (e.isHorizontal() ? 1 : -1) * (e.min >= n ? 1 : -1);
}
function lJe(t) {
  let e, n, r, o, i;
  return t.horizontal ? (e = t.base > t.x, n = "left", r = "right") : (e = t.base < t.y, n = "bottom", r = "top"), e ? (o = "end", i = "start") : (o = "start", i = "end"), {
    start: n,
    end: r,
    reverse: e,
    top: o,
    bottom: i
  };
}
function cJe(t, e, n, r) {
  let o = e.borderSkipped;
  const i = {};
  if (!o) {
    t.borderSkipped = i;
    return;
  }
  if (o === !0) {
    t.borderSkipped = {
      top: !0,
      right: !0,
      bottom: !0,
      left: !0
    };
    return;
  }
  const { start: s, end: a, reverse: l, top: c, bottom: u } = lJe(t);
  o === "middle" && n && (t.enableBorderRadius = !0, (n._top || 0) === r ? o = c : (n._bottom || 0) === r ? o = u : (i[KU(u, s, a, l)] = !0, o = c)), i[KU(o, s, a, l)] = !0, t.borderSkipped = i;
}
function KU(t, e, n, r) {
  return r ? (t = uJe(t, e, n), t = XU(t, n, e)) : t = XU(t, e, n), t;
}
function uJe(t, e, n) {
  return t === e ? n : t === n ? e : t;
}
function XU(t, e, n) {
  return t === "start" ? e : t === "end" ? n : t;
}
function dJe(t, { inflateAmount: e }, n) {
  t.inflateAmount = e === "auto" ? n === 1 ? 0.33 : 0 : e;
}
class Cw extends wd {
  parsePrimitiveData(e, n, r, o) {
    return YU(e, n, r, o);
  }
  parseArrayData(e, n, r, o) {
    return YU(e, n, r, o);
  }
  parseObjectData(e, n, r, o) {
    const { iScale: i, vScale: s } = e, { xAxisKey: a = "x", yAxisKey: l = "y" } = this._parsing, c = i.axis === "x" ? a : l, u = s.axis === "x" ? a : l, d = [];
    let f, h, p, m;
    for (f = r, h = r + o; f < h; ++f)
      m = n[f], p = {}, p[i.axis] = i.parse(jd(m, c), f), d.push(Mme(jd(m, u), p, s, f));
    return d;
  }
  updateRangeFromParsed(e, n, r, o) {
    super.updateRangeFromParsed(e, n, r, o);
    const i = r._custom;
    i && n === this._cachedMeta.vScale && (e.min = Math.min(e.min, i.min), e.max = Math.max(e.max, i.max));
  }
  getMaxOverflow() {
    return 0;
  }
  getLabelAndValue(e) {
    const n = this._cachedMeta, { iScale: r, vScale: o } = n, i = this.getParsed(e), s = i._custom, a = e2(s) ? "[" + s.start + ", " + s.end + "]" : "" + o.getLabelForValue(i[o.axis]);
    return {
      label: "" + r.getLabelForValue(i[r.axis]),
      value: a
    };
  }
  initialize() {
    this.enableOptionSharing = !0, super.initialize();
    const e = this._cachedMeta;
    e.stack = this.getDataset().stack;
  }
  update(e) {
    const n = this._cachedMeta;
    this.updateElements(n.data, 0, n.data.length, e);
  }
  updateElements(e, n, r, o) {
    const i = o === "reset", { index: s, _cachedMeta: { vScale: a } } = this, l = a.getBasePixel(), c = a.isHorizontal(), u = this._getRuler(), { sharedOptions: d, includeOptions: f } = this._getSharedOptions(n, o);
    for (let h = n; h < n + r; h++) {
      const p = this.getParsed(h), m = i || vn(p[a.axis]) ? {
        base: l,
        head: l
      } : this._calculateBarValuePixels(h), g = this._calculateBarIndexPixels(h, u), y = (p._stacks || {})[a.axis], v = {
        horizontal: c,
        base: m.base,
        enableBorderRadius: !y || e2(p._custom) || s === y._top || s === y._bottom,
        x: c ? m.head : g.center,
        y: c ? g.center : m.head,
        height: c ? g.size : Math.abs(m.size),
        width: c ? Math.abs(m.size) : g.size
      };
      f && (v.options = d || this.resolveDataElementOptions(h, e[h].active ? "active" : o));
      const b = v.options || e[h].options;
      cJe(v, b, y, s), dJe(v, b, u.ratio), this.updateElement(e[h], h, v, o);
    }
  }
  _getStacks(e, n) {
    const { iScale: r } = this._cachedMeta, o = r.getMatchingVisibleMetas(this._type).filter((u) => u.controller.options.grouped), i = r.options.stacked, s = [], a = this._cachedMeta.controller.getParsed(n), l = a && a[r.axis], c = (u) => {
      const d = u._parsed.find((h) => h[r.axis] === l), f = d && d[u.vScale.axis];
      if (vn(f) || isNaN(f))
        return !0;
    };
    for (const u of o)
      if (!(n !== void 0 && c(u)) && ((i === !1 || s.indexOf(u.stack) === -1 || i === void 0 && u.stack === void 0) && s.push(u.stack), u.index === e))
        break;
    return s.length || s.push(void 0), s;
  }
  _getStackCount(e) {
    return this._getStacks(void 0, e).length;
  }
  _getAxisCount() {
    return this._getAxis().length;
  }
  getFirstScaleIdForIndexAxis() {
    const e = this.chart.scales, n = this.chart.options.indexAxis;
    return Object.keys(e).filter((r) => e[r].axis === n).shift();
  }
  _getAxis() {
    const e = {}, n = this.getFirstScaleIdForIndexAxis();
    for (const r of this.chart.data.datasets)
      e[Tt(this.chart.options.indexAxis === "x" ? r.xAxisID : r.yAxisID, n)] = !0;
    return Object.keys(e);
  }
  _getStackIndex(e, n, r) {
    const o = this._getStacks(e, r), i = n !== void 0 ? o.indexOf(n) : -1;
    return i === -1 ? o.length - 1 : i;
  }
  _getRuler() {
    const e = this.options, n = this._cachedMeta, r = n.iScale, o = [];
    let i, s;
    for (i = 0, s = n.data.length; i < s; ++i)
      o.push(r.getPixelForValue(this.getParsed(i)[r.axis], i));
    const a = e.barThickness;
    return {
      min: a || rJe(n),
      pixels: o,
      start: r._startPixel,
      end: r._endPixel,
      stackCount: this._getStackCount(),
      scale: r,
      grouped: e.grouped,
      ratio: a ? 1 : e.categoryPercentage * e.barPercentage
    };
  }
  _calculateBarValuePixels(e) {
    const { _cachedMeta: { vScale: n, _stacked: r, index: o }, options: { base: i, minBarLength: s } } = this, a = i || 0, l = this.getParsed(e), c = l._custom, u = e2(c);
    let d = l[n.axis], f = 0, h = r ? this.applyStack(n, l, r) : d, p, m;
    h !== d && (f = h - d, h = d), u && (d = c.barStart, h = c.barEnd - c.barStart, d !== 0 && _a(d) !== _a(c.barEnd) && (f = 0), f += d);
    const g = !vn(i) && !u ? i : f;
    let y = n.getPixelForValue(g);
    if (this.chart.getDataVisibility(e) ? p = n.getPixelForValue(f + h) : p = y, m = p - y, Math.abs(m) < s) {
      m = aJe(m, n, a) * s, d === a && (y -= m / 2);
      const v = n.getPixelForDecimal(0), b = n.getPixelForDecimal(1), _ = Math.min(v, b), w = Math.max(v, b);
      y = Math.max(Math.min(y, w), _), p = y + m, r && !u && (l._stacks[n.axis]._visualValues[o] = n.getValueForPixel(p) - n.getValueForPixel(y));
    }
    if (y === n.getPixelForValue(a)) {
      const v = _a(m) * n.getLineWidthForValue(a) / 2;
      y += v, m -= v;
    }
    return {
      size: m,
      base: y,
      head: p,
      center: p + m / 2
    };
  }
  _calculateBarIndexPixels(e, n) {
    const r = n.scale, o = this.options, i = o.skipNull, s = Tt(o.maxBarThickness, 1 / 0);
    let a, l;
    const c = this._getAxisCount();
    if (n.grouped) {
      const u = i ? this._getStackCount(e) : n.stackCount, d = o.barThickness === "flex" ? iJe(e, n, o, u * c) : oJe(e, n, o, u * c), f = this.chart.options.indexAxis === "x" ? this.getDataset().xAxisID : this.getDataset().yAxisID, h = this._getAxis().indexOf(Tt(f, this.getFirstScaleIdForIndexAxis())), p = this._getStackIndex(this.index, this._cachedMeta.stack, i ? e : void 0) + h;
      a = d.start + d.chunk * p + d.chunk / 2, l = Math.min(s, d.chunk * d.ratio);
    } else
      a = r.getPixelForValue(this.getParsed(e)[r.axis], e), l = Math.min(s, n.min * n.ratio);
    return {
      base: a - l / 2,
      head: a + l / 2,
      center: a,
      size: l
    };
  }
  draw() {
    const e = this._cachedMeta, n = e.vScale, r = e.data, o = r.length;
    let i = 0;
    for (; i < o; ++i)
      this.getParsed(i)[n.axis] !== null && !r[i].hidden && r[i].draw(this._ctx);
  }
}
ue(Cw, "id", "bar"), ue(Cw, "defaults", {
  datasetElementType: !1,
  dataElementType: "bar",
  categoryPercentage: 0.8,
  barPercentage: 0.9,
  grouped: !0,
  animations: {
    numbers: {
      type: "number",
      properties: [
        "x",
        "y",
        "base",
        "width",
        "height"
      ]
    }
  }
}), ue(Cw, "overrides", {
  scales: {
    _index_: {
      type: "category",
      offset: !0,
      grid: {
        offset: !0
      }
    },
    _value_: {
      type: "linear",
      beginAtZero: !0
    }
  }
});
function fJe(t, e, n) {
  let r = 1, o = 1, i = 0, s = 0;
  if (e < ar) {
    const a = t, l = a + e, c = Math.cos(a), u = Math.sin(a), d = Math.cos(l), f = Math.sin(l), h = (b, _, w) => by(b, a, l, !0) ? 1 : Math.max(_, _ * n, w, w * n), p = (b, _, w) => by(b, a, l, !0) ? -1 : Math.min(_, _ * n, w, w * n), m = h(0, c, d), g = h(Ir, u, f), y = p(An, c, d), v = p(An + Ir, u, f);
    r = (m - y) / 2, o = (g - v) / 2, i = -(m + y) / 2, s = -(g + v) / 2;
  }
  return {
    ratioX: r,
    ratioY: o,
    offsetX: i,
    offsetY: s
  };
}
class kg extends wd {
  constructor(e, n) {
    super(e, n), this.enableOptionSharing = !0, this.innerRadius = void 0, this.outerRadius = void 0, this.offsetX = void 0, this.offsetY = void 0;
  }
  linkScales() {
  }
  parse(e, n) {
    const r = this.getDataset().data, o = this._cachedMeta;
    if (this._parsing === !1)
      o._parsed = r;
    else {
      let i = (l) => +r[l];
      if (Bt(r[e])) {
        const { key: l = "value" } = this._parsing;
        i = (c) => +jd(r[c], l);
      }
      let s, a;
      for (s = e, a = e + n; s < a; ++s)
        o._parsed[s] = i(s);
    }
  }
  _getRotation() {
    return xl(this.options.rotation - 90);
  }
  _getCircumference() {
    return xl(this.options.circumference);
  }
  _getRotationExtents() {
    let e = ar, n = -ar;
    for (let r = 0; r < this.chart.data.datasets.length; ++r)
      if (this.chart.isDatasetVisible(r) && this.chart.getDatasetMeta(r).type === this._type) {
        const o = this.chart.getDatasetMeta(r).controller, i = o._getRotation(), s = o._getCircumference();
        e = Math.min(e, i), n = Math.max(n, i + s);
      }
    return {
      rotation: e,
      circumference: n - e
    };
  }
  update(e) {
    const n = this.chart, { chartArea: r } = n, o = this._cachedMeta, i = o.data, s = this.getMaxBorderWidth() + this.getMaxOffset(i) + this.options.spacing, a = Math.max((Math.min(r.width, r.height) - s) / 2, 0), l = Math.min(_Qe(this.options.cutout, a), 1), c = this._getRingWeight(this.index), { circumference: u, rotation: d } = this._getRotationExtents(), { ratioX: f, ratioY: h, offsetX: p, offsetY: m } = fJe(d, u, l), g = (r.width - s) / f, y = (r.height - s) / h, v = Math.max(Math.min(g, y) / 2, 0), b = cme(this.options.radius, v), _ = Math.max(b * l, 0), w = (b - _) / this._getVisibleDatasetWeightTotal();
    this.offsetX = p * b, this.offsetY = m * b, o.total = this.calculateTotal(), this.outerRadius = b - w * this._getRingWeightOffset(this.index), this.innerRadius = Math.max(this.outerRadius - w * c, 0), this.updateElements(i, 0, i.length, e);
  }
  _circumference(e, n) {
    const r = this.options, o = this._cachedMeta, i = this._getCircumference();
    return n && r.animation.animateRotate || !this.chart.getDataVisibility(e) || o._parsed[e] === null || o.data[e].hidden ? 0 : this.calculateCircumference(o._parsed[e] * i / ar);
  }
  updateElements(e, n, r, o) {
    const i = o === "reset", s = this.chart, a = s.chartArea, l = s.options.animation, c = (a.left + a.right) / 2, u = (a.top + a.bottom) / 2, d = i && l.animateScale, f = d ? 0 : this.innerRadius, h = d ? 0 : this.outerRadius, { sharedOptions: p, includeOptions: m } = this._getSharedOptions(n, o);
    let g = this._getRotation(), y;
    for (y = 0; y < n; ++y)
      g += this._circumference(y, i);
    for (y = n; y < n + r; ++y) {
      const v = this._circumference(y, i), b = e[y], _ = {
        x: c + this.offsetX,
        y: u + this.offsetY,
        startAngle: g,
        endAngle: g + v,
        circumference: v,
        outerRadius: h,
        innerRadius: f
      };
      m && (_.options = p || this.resolveDataElementOptions(y, b.active ? "active" : o)), g += v, this.updateElement(b, y, _, o);
    }
  }
  calculateTotal() {
    const e = this._cachedMeta, n = e.data;
    let r = 0, o;
    for (o = 0; o < n.length; o++) {
      const i = e._parsed[o];
      i !== null && !isNaN(i) && this.chart.getDataVisibility(o) && !n[o].hidden && (r += Math.abs(i));
    }
    return r;
  }
  calculateCircumference(e) {
    const n = this._cachedMeta.total;
    return n > 0 && !isNaN(e) ? ar * (Math.abs(e) / n) : 0;
  }
  getLabelAndValue(e) {
    const n = this._cachedMeta, r = this.chart, o = r.data.labels || [], i = a4(n._parsed[e], r.options.locale);
    return {
      label: o[e] || "",
      value: i
    };
  }
  getMaxBorderWidth(e) {
    let n = 0;
    const r = this.chart;
    let o, i, s, a, l;
    if (!e) {
      for (o = 0, i = r.data.datasets.length; o < i; ++o)
        if (r.isDatasetVisible(o)) {
          s = r.getDatasetMeta(o), e = s.data, a = s.controller;
          break;
        }
    }
    if (!e)
      return 0;
    for (o = 0, i = e.length; o < i; ++o)
      l = a.resolveDataElementOptions(o), l.borderAlign !== "inner" && (n = Math.max(n, l.borderWidth || 0, l.hoverBorderWidth || 0));
    return n;
  }
  getMaxOffset(e) {
    let n = 0;
    for (let r = 0, o = e.length; r < o; ++r) {
      const i = this.resolveDataElementOptions(r);
      n = Math.max(n, i.offset || 0, i.hoverOffset || 0);
    }
    return n;
  }
  _getRingWeightOffset(e) {
    let n = 0;
    for (let r = 0; r < e; ++r)
      this.chart.isDatasetVisible(r) && (n += this._getRingWeight(r));
    return n;
  }
  _getRingWeight(e) {
    return Math.max(Tt(this.chart.data.datasets[e].weight, 1), 0);
  }
  _getVisibleDatasetWeightTotal() {
    return this._getRingWeightOffset(this.chart.data.datasets.length) || 1;
  }
}
ue(kg, "id", "doughnut"), ue(kg, "defaults", {
  datasetElementType: !1,
  dataElementType: "arc",
  animation: {
    animateRotate: !0,
    animateScale: !1
  },
  animations: {
    numbers: {
      type: "number",
      properties: [
        "circumference",
        "endAngle",
        "innerRadius",
        "outerRadius",
        "startAngle",
        "x",
        "y",
        "offset",
        "borderWidth",
        "spacing"
      ]
    }
  },
  cutout: "50%",
  rotation: 0,
  circumference: 360,
  radius: "100%",
  spacing: 0,
  indexAxis: "r"
}), ue(kg, "descriptors", {
  _scriptable: (t) => t !== "spacing",
  _indexable: (t) => t !== "spacing" && !t.startsWith("borderDash") && !t.startsWith("hoverBorderDash")
}), ue(kg, "overrides", {
  aspectRatio: 1,
  plugins: {
    legend: {
      labels: {
        generateLabels(t) {
          const e = t.data;
          if (e.labels.length && e.datasets.length) {
            const { labels: { pointStyle: n, color: r } } = t.legend.options;
            return e.labels.map((o, i) => {
              const s = t.getDatasetMeta(0).controller.getStyle(i);
              return {
                text: o,
                fillStyle: s.backgroundColor,
                strokeStyle: s.borderColor,
                fontColor: r,
                lineWidth: s.borderWidth,
                pointStyle: n,
                hidden: !t.getDataVisibility(i),
                index: i
              };
            });
          }
          return [];
        }
      },
      onClick(t, e, n) {
        n.chart.toggleDataVisibility(e.index), n.chart.update();
      }
    }
  }
});
class kw extends wd {
  initialize() {
    this.enableOptionSharing = !0, this.supportsDecimation = !0, super.initialize();
  }
  update(e) {
    const n = this._cachedMeta, { dataset: r, data: o = [], _dataset: i } = n, s = this.chart._animationsDisabled;
    let { start: a, count: l } = BQe(n, o, s);
    this._drawStart = a, this._drawCount = l, zQe(n) && (a = 0, l = o.length), r._chart = this.chart, r._datasetIndex = this.index, r._decimated = !!i._decimated, r.points = o;
    const c = this.resolveDatasetElementOptions(e);
    this.options.showLine || (c.borderWidth = 0), c.segment = this.options.segment, this.updateElement(r, void 0, {
      animated: !s,
      options: c
    }, e), this.updateElements(o, a, l, e);
  }
  updateElements(e, n, r, o) {
    const i = o === "reset", { iScale: s, vScale: a, _stacked: l, _dataset: c } = this._cachedMeta, { sharedOptions: u, includeOptions: d } = this._getSharedOptions(n, o), f = s.axis, h = a.axis, { spanGaps: p, segment: m } = this.options, g = vy(p) ? p : Number.POSITIVE_INFINITY, y = this.chart._animationsDisabled || i || o === "none", v = n + r, b = e.length;
    let _ = n > 0 && this.getParsed(n - 1);
    for (let w = 0; w < b; ++w) {
      const x = e[w], E = y ? x : {};
      if (w < n || w >= v) {
        E.skip = !0;
        continue;
      }
      const S = this.getParsed(w), C = vn(S[h]), R = E[f] = s.getPixelForValue(S[f], w), P = E[h] = i || C ? a.getBasePixel() : a.getPixelForValue(l ? this.applyStack(a, S, l) : S[h], w);
      E.skip = isNaN(R) || isNaN(P) || C, E.stop = w > 0 && Math.abs(S[f] - _[f]) > g, m && (E.parsed = S, E.raw = c.data[w]), d && (E.options = u || this.resolveDataElementOptions(w, x.active ? "active" : o)), y || this.updateElement(x, w, E, o), _ = S;
    }
  }
  getMaxOverflow() {
    const e = this._cachedMeta, n = e.dataset, r = n.options && n.options.borderWidth || 0, o = e.data || [];
    if (!o.length)
      return r;
    const i = o[0].size(this.resolveDataElementOptions(0)), s = o[o.length - 1].size(this.resolveDataElementOptions(o.length - 1));
    return Math.max(r, i, s) / 2;
  }
  draw() {
    const e = this._cachedMeta;
    e.dataset.updateControlPoints(this.chart.chartArea, e.iScale.axis), super.draw();
  }
}
ue(kw, "id", "line"), ue(kw, "defaults", {
  datasetElementType: "line",
  dataElementType: "point",
  showLine: !0,
  spanGaps: !1
}), ue(kw, "overrides", {
  scales: {
    _index_: {
      type: "category"
    },
    _value_: {
      type: "linear"
    }
  }
});
function wu() {
  throw new Error("This method is not implemented: Check that a complete date adapter is provided.");
}
class p4 {
  constructor(e) {
    ue(this, "options"), this.options = e || {};
  }
  /**
  * Override default date adapter methods.
  * Accepts type parameter to define options type.
  * @example
  * Chart._adapters._date.override<{myAdapterOption: string}>({
  *   init() {
  *     console.log(this.options.myAdapterOption);
  *   }
  * })
  */
  static override(e) {
    Object.assign(p4.prototype, e);
  }
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  init() {
  }
  formats() {
    return wu();
  }
  parse() {
    return wu();
  }
  format() {
    return wu();
  }
  add() {
    return wu();
  }
  diff() {
    return wu();
  }
  startOf() {
    return wu();
  }
  endOf() {
    return wu();
  }
}
var hJe = {
  _date: p4
};
function pJe(t, e, n, r) {
  const { controller: o, data: i, _sorted: s } = t, a = o._cachedMeta.iScale, l = t.dataset && t.dataset.options ? t.dataset.options.spanGaps : null;
  if (a && e === a.axis && e !== "r" && s && i.length) {
    const c = a._reversePixels ? IQe : ld;
    if (r) {
      if (o._sharedOptions) {
        const u = i[0], d = typeof u.getRange == "function" && u.getRange(e);
        if (d) {
          const f = c(i, e, n - d), h = c(i, e, n + d);
          return {
            lo: f.lo,
            hi: h.hi
          };
        }
      }
    } else {
      const u = c(i, e, n);
      if (l) {
        const { vScale: d } = o._cachedMeta, { _parsed: f } = t, h = f.slice(0, u.lo + 1).reverse().findIndex((m) => !vn(m[d.axis]));
        u.lo -= Math.max(0, h);
        const p = f.slice(u.hi).findIndex((m) => !vn(m[d.axis]));
        u.hi += Math.max(0, p);
      }
      return u;
    }
  }
  return {
    lo: 0,
    hi: i.length - 1
  };
}
function QS(t, e, n, r, o) {
  const i = t.getSortedVisibleDatasetMetas(), s = n[e];
  for (let a = 0, l = i.length; a < l; ++a) {
    const { index: c, data: u } = i[a], { lo: d, hi: f } = pJe(i[a], e, s, o);
    for (let h = d; h <= f; ++h) {
      const p = u[h];
      p.skip || r(p, c, h);
    }
  }
}
function mJe(t) {
  const e = t.indexOf("x") !== -1, n = t.indexOf("y") !== -1;
  return function(r, o) {
    const i = e ? Math.abs(r.x - o.x) : 0, s = n ? Math.abs(r.y - o.y) : 0;
    return Math.sqrt(Math.pow(i, 2) + Math.pow(s, 2));
  };
}
function t2(t, e, n, r, o) {
  const i = [];
  return !o && !t.isPointInArea(e) || QS(t, n, e, function(s, a, l) {
    !o && !_y(s, t.chartArea, 0) || s.inRange(e.x, e.y, r) && i.push({
      element: s,
      datasetIndex: a,
      index: l
    });
  }, !0), i;
}
function gJe(t, e, n, r) {
  let o = [];
  function i(s, a, l) {
    const { startAngle: c, endAngle: u } = s.getProps([
      "startAngle",
      "endAngle"
    ], r), { angle: d } = fme(s, {
      x: e.x,
      y: e.y
    });
    by(d, c, u) && o.push({
      element: s,
      datasetIndex: a,
      index: l
    });
  }
  return QS(t, n, e, i), o;
}
function yJe(t, e, n, r, o, i) {
  let s = [];
  const a = mJe(n);
  let l = Number.POSITIVE_INFINITY;
  function c(u, d, f) {
    const h = u.inRange(e.x, e.y, o);
    if (r && !h)
      return;
    const p = u.getCenterPoint(o);
    if (!(i || t.isPointInArea(p)) && !h)
      return;
    const m = a(e, p);
    m < l ? (s = [
      {
        element: u,
        datasetIndex: d,
        index: f
      }
    ], l = m) : m === l && s.push({
      element: u,
      datasetIndex: d,
      index: f
    });
  }
  return QS(t, n, e, c), s;
}
function n2(t, e, n, r, o, i) {
  return !i && !t.isPointInArea(e) ? [] : n === "r" && !r ? gJe(t, e, n, o) : yJe(t, e, n, r, o, i);
}
function QU(t, e, n, r, o) {
  const i = [], s = n === "x" ? "inXRange" : "inYRange";
  let a = !1;
  return QS(t, n, e, (l, c, u) => {
    l[s] && l[s](e[n], o) && (i.push({
      element: l,
      datasetIndex: c,
      index: u
    }), a = a || l.inRange(e.x, e.y, o));
  }), r && !a ? [] : i;
}
var vJe = {
  modes: {
    index(t, e, n, r) {
      const o = zu(e, t), i = n.axis || "x", s = n.includeInvisible || !1, a = n.intersect ? t2(t, o, i, r, s) : n2(t, o, i, !1, r, s), l = [];
      return a.length ? (t.getSortedVisibleDatasetMetas().forEach((c) => {
        const u = a[0].index, d = c.data[u];
        d && !d.skip && l.push({
          element: d,
          datasetIndex: c.index,
          index: u
        });
      }), l) : [];
    },
    dataset(t, e, n, r) {
      const o = zu(e, t), i = n.axis || "xy", s = n.includeInvisible || !1;
      let a = n.intersect ? t2(t, o, i, r, s) : n2(t, o, i, !1, r, s);
      if (a.length > 0) {
        const l = a[0].datasetIndex, c = t.getDatasetMeta(l).data;
        a = [];
        for (let u = 0; u < c.length; ++u)
          a.push({
            element: c[u],
            datasetIndex: l,
            index: u
          });
      }
      return a;
    },
    point(t, e, n, r) {
      const o = zu(e, t), i = n.axis || "xy", s = n.includeInvisible || !1;
      return t2(t, o, i, r, s);
    },
    nearest(t, e, n, r) {
      const o = zu(e, t), i = n.axis || "xy", s = n.includeInvisible || !1;
      return n2(t, o, i, n.intersect, r, s);
    },
    x(t, e, n, r) {
      const o = zu(e, t);
      return QU(t, o, "x", n.intersect, r);
    },
    y(t, e, n, r) {
      const o = zu(e, t);
      return QU(t, o, "y", n.intersect, r);
    }
  }
};
const Dme = [
  "left",
  "top",
  "right",
  "bottom"
];
function mm(t, e) {
  return t.filter((n) => n.pos === e);
}
function ZU(t, e) {
  return t.filter((n) => Dme.indexOf(n.pos) === -1 && n.box.axis === e);
}
function gm(t, e) {
  return t.sort((n, r) => {
    const o = e ? r : n, i = e ? n : r;
    return o.weight === i.weight ? o.index - i.index : o.weight - i.weight;
  });
}
function bJe(t) {
  const e = [];
  let n, r, o, i, s, a;
  for (n = 0, r = (t || []).length; n < r; ++n)
    o = t[n], { position: i, options: { stack: s, stackWeight: a = 1 } } = o, e.push({
      index: n,
      box: o,
      pos: i,
      horizontal: o.isHorizontal(),
      weight: o.weight,
      stack: s && i + s,
      stackWeight: a
    });
  return e;
}
function _Je(t) {
  const e = {};
  for (const n of t) {
    const { stack: r, pos: o, stackWeight: i } = n;
    if (!r || !Dme.includes(o))
      continue;
    const s = e[r] || (e[r] = {
      count: 0,
      placed: 0,
      weight: 0,
      size: 0
    });
    s.count++, s.weight += i;
  }
  return e;
}
function wJe(t, e) {
  const n = _Je(t), { vBoxMaxWidth: r, hBoxMaxHeight: o } = e;
  let i, s, a;
  for (i = 0, s = t.length; i < s; ++i) {
    a = t[i];
    const { fullSize: l } = a.box, c = n[a.stack], u = c && a.stackWeight / c.weight;
    a.horizontal ? (a.width = u ? u * r : l && e.availableWidth, a.height = o) : (a.width = r, a.height = u ? u * o : l && e.availableHeight);
  }
  return n;
}
function xJe(t) {
  const e = bJe(t), n = gm(e.filter((c) => c.box.fullSize), !0), r = gm(mm(e, "left"), !0), o = gm(mm(e, "right")), i = gm(mm(e, "top"), !0), s = gm(mm(e, "bottom")), a = ZU(e, "x"), l = ZU(e, "y");
  return {
    fullSize: n,
    leftAndTop: r.concat(i),
    rightAndBottom: o.concat(l).concat(s).concat(a),
    chartArea: mm(e, "chartArea"),
    vertical: r.concat(o).concat(l),
    horizontal: i.concat(s).concat(a)
  };
}
function JU(t, e, n, r) {
  return Math.max(t[n], e[n]) + Math.max(t[r], e[r]);
}
function Ime(t, e) {
  t.top = Math.max(t.top, e.top), t.left = Math.max(t.left, e.left), t.bottom = Math.max(t.bottom, e.bottom), t.right = Math.max(t.right, e.right);
}
function EJe(t, e, n, r) {
  const { pos: o, box: i } = n, s = t.maxPadding;
  if (!Bt(o)) {
    n.size && (t[o] -= n.size);
    const d = r[n.stack] || {
      size: 0,
      count: 1
    };
    d.size = Math.max(d.size, n.horizontal ? i.height : i.width), n.size = d.size / d.count, t[o] += n.size;
  }
  i.getPadding && Ime(s, i.getPadding());
  const a = Math.max(0, e.outerWidth - JU(s, t, "left", "right")), l = Math.max(0, e.outerHeight - JU(s, t, "top", "bottom")), c = a !== t.w, u = l !== t.h;
  return t.w = a, t.h = l, n.horizontal ? {
    same: c,
    other: u
  } : {
    same: u,
    other: c
  };
}
function SJe(t) {
  const e = t.maxPadding;
  function n(r) {
    const o = Math.max(e[r] - t[r], 0);
    return t[r] += o, o;
  }
  t.y += n("top"), t.x += n("left"), n("right"), n("bottom");
}
function OJe(t, e) {
  const n = e.maxPadding;
  function r(o) {
    const i = {
      left: 0,
      top: 0,
      right: 0,
      bottom: 0
    };
    return o.forEach((s) => {
      i[s] = Math.max(e[s], n[s]);
    }), i;
  }
  return r(t ? [
    "left",
    "right"
  ] : [
    "top",
    "bottom"
  ]);
}
function Ag(t, e, n, r) {
  const o = [];
  let i, s, a, l, c, u;
  for (i = 0, s = t.length, c = 0; i < s; ++i) {
    a = t[i], l = a.box, l.update(a.width || e.w, a.height || e.h, OJe(a.horizontal, e));
    const { same: d, other: f } = EJe(e, n, a, r);
    c |= d && o.length, u = u || f, l.fullSize || o.push(a);
  }
  return c && Ag(o, e, n, r) || u;
}
function d1(t, e, n, r, o) {
  t.top = n, t.left = e, t.right = e + r, t.bottom = n + o, t.width = r, t.height = o;
}
function eH(t, e, n, r) {
  const o = n.padding;
  let { x: i, y: s } = e;
  for (const a of t) {
    const l = a.box, c = r[a.stack] || {
      placed: 0,
      weight: 1
    }, u = a.stackWeight / c.weight || 1;
    if (a.horizontal) {
      const d = e.w * u, f = c.size || l.height;
      yy(c.start) && (s = c.start), l.fullSize ? d1(l, o.left, s, n.outerWidth - o.right - o.left, f) : d1(l, e.left + c.placed, s, d, f), c.start = s, c.placed += d, s = l.bottom;
    } else {
      const d = e.h * u, f = c.size || l.width;
      yy(c.start) && (i = c.start), l.fullSize ? d1(l, i, o.top, f, n.outerHeight - o.bottom - o.top) : d1(l, i, e.top + c.placed, f, d), c.start = i, c.placed += d, i = l.right;
    }
  }
  e.x = i, e.y = s;
}
var qi = {
  addBox(t, e) {
    t.boxes || (t.boxes = []), e.fullSize = e.fullSize || !1, e.position = e.position || "top", e.weight = e.weight || 0, e._layers = e._layers || function() {
      return [
        {
          z: 0,
          draw(n) {
            e.draw(n);
          }
        }
      ];
    }, t.boxes.push(e);
  },
  removeBox(t, e) {
    const n = t.boxes ? t.boxes.indexOf(e) : -1;
    n !== -1 && t.boxes.splice(n, 1);
  },
  configure(t, e, n) {
    e.fullSize = n.fullSize, e.position = n.position, e.weight = n.weight;
  },
  update(t, e, n, r) {
    if (!t)
      return;
    const o = ns(t.options.layout.padding), i = Math.max(e - o.width, 0), s = Math.max(n - o.height, 0), a = xJe(t.boxes), l = a.vertical, c = a.horizontal;
    On(t.boxes, (m) => {
      typeof m.beforeLayout == "function" && m.beforeLayout();
    });
    const u = l.reduce((m, g) => g.box.options && g.box.options.display === !1 ? m : m + 1, 0) || 1, d = Object.freeze({
      outerWidth: e,
      outerHeight: n,
      padding: o,
      availableWidth: i,
      availableHeight: s,
      vBoxMaxWidth: i / 2 / u,
      hBoxMaxHeight: s / 2
    }), f = Object.assign({}, o);
    Ime(f, ns(r));
    const h = Object.assign({
      maxPadding: f,
      w: i,
      h: s,
      x: o.left,
      y: o.top
    }, o), p = wJe(l.concat(c), d);
    Ag(a.fullSize, h, d, p), Ag(l, h, d, p), Ag(c, h, d, p) && Ag(l, h, d, p), SJe(h), eH(a.leftAndTop, h, d, p), h.x += h.w, h.y += h.h, eH(a.rightAndBottom, h, d, p), t.chartArea = {
      left: h.left,
      top: h.top,
      right: h.left + h.w,
      bottom: h.top + h.h,
      height: h.h,
      width: h.w
    }, On(a.chartArea, (m) => {
      const g = m.box;
      Object.assign(g, t.chartArea), g.update(h.w, h.h, {
        left: 0,
        top: 0,
        right: 0,
        bottom: 0
      });
    });
  }
};
class Nme {
  acquireContext(e, n) {
  }
  releaseContext(e) {
    return !1;
  }
  addEventListener(e, n, r) {
  }
  removeEventListener(e, n, r) {
  }
  getDevicePixelRatio() {
    return 1;
  }
  getMaximumSize(e, n, r, o) {
    return n = Math.max(0, n || e.width), r = r || e.height, {
      width: n,
      height: Math.max(0, o ? Math.floor(n / o) : r)
    };
  }
  isAttached(e) {
    return !0;
  }
  updateConfig(e) {
  }
}
class CJe extends Nme {
  acquireContext(e) {
    return e && e.getContext && e.getContext("2d") || null;
  }
  updateConfig(e) {
    e.options.animation = !1;
  }
}
const Aw = "$chartjs", kJe = {
  touchstart: "mousedown",
  touchmove: "mousemove",
  touchend: "mouseup",
  pointerenter: "mouseenter",
  pointerdown: "mousedown",
  pointermove: "mousemove",
  pointerup: "mouseup",
  pointerleave: "mouseout",
  pointerout: "mouseout"
}, tH = (t) => t === null || t === "";
function AJe(t, e) {
  const n = t.style, r = t.getAttribute("height"), o = t.getAttribute("width");
  if (t[Aw] = {
    initial: {
      height: r,
      width: o,
      style: {
        display: n.display,
        height: n.height,
        width: n.width
      }
    }
  }, n.display = n.display || "block", n.boxSizing = n.boxSizing || "border-box", tH(o)) {
    const i = LU(t, "width");
    i !== void 0 && (t.width = i);
  }
  if (tH(r))
    if (t.style.height === "")
      t.height = t.width / (e || 2);
    else {
      const i = LU(t, "height");
      i !== void 0 && (t.height = i);
    }
  return t;
}
const jme = RZe ? {
  passive: !0
} : !1;
function TJe(t, e, n) {
  t && t.addEventListener(e, n, jme);
}
function RJe(t, e, n) {
  t && t.canvas && t.canvas.removeEventListener(e, n, jme);
}
function PJe(t, e) {
  const n = kJe[t.type] || t.type, { x: r, y: o } = zu(t, e);
  return {
    type: n,
    chart: e,
    native: t,
    x: r !== void 0 ? r : null,
    y: o !== void 0 ? o : null
  };
}
function lE(t, e) {
  for (const n of t)
    if (n === e || n.contains(e))
      return !0;
}
function $Je(t, e, n) {
  const r = t.canvas, o = new MutationObserver((i) => {
    let s = !1;
    for (const a of i)
      s = s || lE(a.addedNodes, r), s = s && !lE(a.removedNodes, r);
    s && n();
  });
  return o.observe(document, {
    childList: !0,
    subtree: !0
  }), o;
}
function MJe(t, e, n) {
  const r = t.canvas, o = new MutationObserver((i) => {
    let s = !1;
    for (const a of i)
      s = s || lE(a.removedNodes, r), s = s && !lE(a.addedNodes, r);
    s && n();
  });
  return o.observe(document, {
    childList: !0,
    subtree: !0
  }), o;
}
const xy = /* @__PURE__ */ new Map();
let nH = 0;
function Lme() {
  const t = window.devicePixelRatio;
  t !== nH && (nH = t, xy.forEach((e, n) => {
    n.currentDevicePixelRatio !== t && e();
  }));
}
function DJe(t, e) {
  xy.size || window.addEventListener("resize", Lme), xy.set(t, e);
}
function IJe(t) {
  xy.delete(t), xy.size || window.removeEventListener("resize", Lme);
}
function NJe(t, e, n) {
  const r = t.canvas, o = r && h4(r);
  if (!o)
    return;
  const i = gme((a, l) => {
    const c = o.clientWidth;
    n(a, l), c < o.clientWidth && n();
  }, window), s = new ResizeObserver((a) => {
    const l = a[0], c = l.contentRect.width, u = l.contentRect.height;
    c === 0 && u === 0 || i(c, u);
  });
  return s.observe(o), DJe(t, i), s;
}
function r2(t, e, n) {
  n && n.disconnect(), e === "resize" && IJe(t);
}
function jJe(t, e, n) {
  const r = t.canvas, o = gme((i) => {
    t.ctx !== null && n(PJe(i, t));
  }, t);
  return TJe(r, e, o), o;
}
class LJe extends Nme {
  acquireContext(e, n) {
    const r = e && e.getContext && e.getContext("2d");
    return r && r.canvas === e ? (AJe(e, n), r) : null;
  }
  releaseContext(e) {
    const n = e.canvas;
    if (!n[Aw])
      return !1;
    const r = n[Aw].initial;
    [
      "height",
      "width"
    ].forEach((i) => {
      const s = r[i];
      vn(s) ? n.removeAttribute(i) : n.setAttribute(i, s);
    });
    const o = r.style || {};
    return Object.keys(o).forEach((i) => {
      n.style[i] = o[i];
    }), n.width = n.width, delete n[Aw], !0;
  }
  addEventListener(e, n, r) {
    this.removeEventListener(e, n);
    const o = e.$proxies || (e.$proxies = {}), i = {
      attach: $Je,
      detach: MJe,
      resize: NJe
    }[n] || jJe;
    o[n] = i(e, n, r);
  }
  removeEventListener(e, n) {
    const r = e.$proxies || (e.$proxies = {}), o = r[n];
    o && (({
      attach: r2,
      detach: r2,
      resize: r2
    }[n] || RJe)(e, n, o), r[n] = void 0);
  }
  getDevicePixelRatio() {
    return window.devicePixelRatio;
  }
  getMaximumSize(e, n, r, o) {
    return TZe(e, n, r, o);
  }
  isAttached(e) {
    const n = e && h4(e);
    return !!(n && n.isConnected);
  }
}
function FJe(t) {
  return !f4() || typeof OffscreenCanvas < "u" && t instanceof OffscreenCanvas ? CJe : LJe;
}
var f1;
let Vl = (f1 = class {
  constructor() {
    ue(this, "x"), ue(this, "y"), ue(this, "active", !1), ue(this, "options"), ue(this, "$animations");
  }
  tooltipPosition(t) {
    const { x: e, y: n } = this.getProps([
      "x",
      "y"
    ], t);
    return {
      x: e,
      y: n
    };
  }
  hasValue() {
    return vy(this.x) && vy(this.y);
  }
  getProps(t, e) {
    const n = this.$animations;
    if (!e || !n)
      return this;
    const r = {};
    return t.forEach((o) => {
      r[o] = n[o] && n[o].active() ? n[o]._to : this[o];
    }), r;
  }
}, ue(f1, "defaults", {}), ue(f1, "defaultRoutes"), f1);
function BJe(t, e) {
  const n = t.options.ticks, r = zJe(t), o = Math.min(n.maxTicksLimit || r, r), i = n.major.enabled ? UJe(e) : [], s = i.length, a = i[0], l = i[s - 1], c = [];
  if (s > o)
    return HJe(e, c, i, s / o), c;
  const u = qJe(i, e, o);
  if (s > 0) {
    let d, f;
    const h = s > 1 ? Math.round((l - a) / (s - 1)) : null;
    for (h1(e, c, u, vn(h) ? 0 : a - h, a), d = 0, f = s - 1; d < f; d++)
      h1(e, c, u, i[d], i[d + 1]);
    return h1(e, c, u, l, vn(h) ? e.length : l + h), c;
  }
  return h1(e, c, u), c;
}
function zJe(t) {
  const e = t.options.offset, n = t._tickSize(), r = t._length / n + (e ? 0 : 1), o = t._maxLength / n;
  return Math.floor(Math.min(r, o));
}
function qJe(t, e, n) {
  const r = VJe(t), o = e.length / n;
  if (!r)
    return Math.max(o, 1);
  const i = AQe(r);
  for (let s = 0, a = i.length - 1; s < a; s++) {
    const l = i[s];
    if (l > o)
      return l;
  }
  return Math.max(o, 1);
}
function UJe(t) {
  const e = [];
  let n, r;
  for (n = 0, r = t.length; n < r; n++)
    t[n].major && e.push(n);
  return e;
}
function HJe(t, e, n, r) {
  let o = 0, i = n[0], s;
  for (r = Math.ceil(r), s = 0; s < t.length; s++)
    s === i && (e.push(t[s]), o++, i = n[o * r]);
}
function h1(t, e, n, r, o) {
  const i = Tt(r, 0), s = Math.min(Tt(o, t.length), t.length);
  let a = 0, l, c, u;
  for (n = Math.ceil(n), o && (l = o - r, n = l / Math.floor(l / n)), u = i; u < 0; )
    a++, u = Math.round(i + a * n);
  for (c = Math.max(i, 0); c < s; c++)
    c === u && (e.push(t[c]), a++, u = Math.round(i + a * n));
}
function VJe(t) {
  const e = t.length;
  let n, r;
  if (e < 2)
    return !1;
  for (r = t[0], n = 1; n < e; ++n)
    if (t[n] - t[n - 1] !== r)
      return !1;
  return r;
}
const WJe = (t) => t === "left" ? "right" : t === "right" ? "left" : t, rH = (t, e, n) => e === "top" || e === "left" ? t[e] + n : t[e] - n, oH = (t, e) => Math.min(e || t, t);
function iH(t, e) {
  const n = [], r = t.length / e, o = t.length;
  let i = 0;
  for (; i < o; i += r)
    n.push(t[Math.floor(i)]);
  return n;
}
function GJe(t, e, n) {
  const r = t.ticks.length, o = Math.min(e, r - 1), i = t._startPixel, s = t._endPixel, a = 1e-6;
  let l = t.getPixelForTick(o), c;
  if (!(n && (r === 1 ? c = Math.max(l - i, s - l) : e === 0 ? c = (t.getPixelForTick(1) - l) / 2 : c = (l - t.getPixelForTick(o - 1)) / 2, l += o < e ? c : -c, l < i - a || l > s + a)))
    return l;
}
function YJe(t, e) {
  On(t, (n) => {
    const r = n.gc, o = r.length / 2;
    let i;
    if (o > e) {
      for (i = 0; i < o; ++i)
        delete n.data[r[i]];
      r.splice(0, o);
    }
  });
}
function ym(t) {
  return t.drawTicks ? t.tickLength : 0;
}
function sH(t, e) {
  if (!t.display)
    return 0;
  const n = uo(t.font, e), r = ns(t.padding);
  return (Cr(t.text) ? t.text.length : 1) * n.lineHeight + r.height;
}
function KJe(t, e) {
  return Xd(t, {
    scale: e,
    type: "scale"
  });
}
function XJe(t, e, n) {
  return Xd(t, {
    tick: n,
    index: e,
    type: "tick"
  });
}
function QJe(t, e, n) {
  let r = i4(t);
  return (n && e !== "right" || !n && e === "right") && (r = WJe(r)), r;
}
function ZJe(t, e, n, r) {
  const { top: o, left: i, bottom: s, right: a, chart: l } = t, { chartArea: c, scales: u } = l;
  let d = 0, f, h, p;
  const m = s - o, g = a - i;
  if (t.isHorizontal()) {
    if (h = io(r, i, a), Bt(n)) {
      const y = Object.keys(n)[0], v = n[y];
      p = u[y].getPixelForValue(v) + m - e;
    } else n === "center" ? p = (c.bottom + c.top) / 2 + m - e : p = rH(t, n, e);
    f = a - i;
  } else {
    if (Bt(n)) {
      const y = Object.keys(n)[0], v = n[y];
      h = u[y].getPixelForValue(v) - g + e;
    } else n === "center" ? h = (c.left + c.right) / 2 - g + e : h = rH(t, n, e);
    p = io(r, s, o), d = n === "left" ? -Ir : Ir;
  }
  return {
    titleX: h,
    titleY: p,
    maxWidth: f,
    rotation: d
  };
}
class Pp extends Vl {
  constructor(e) {
    super(), this.id = e.id, this.type = e.type, this.options = void 0, this.ctx = e.ctx, this.chart = e.chart, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.width = void 0, this.height = void 0, this._margins = {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, this.maxWidth = void 0, this.maxHeight = void 0, this.paddingTop = void 0, this.paddingBottom = void 0, this.paddingLeft = void 0, this.paddingRight = void 0, this.axis = void 0, this.labelRotation = void 0, this.min = void 0, this.max = void 0, this._range = void 0, this.ticks = [], this._gridLineItems = null, this._labelItems = null, this._labelSizes = null, this._length = 0, this._maxLength = 0, this._longestTextCache = {}, this._startPixel = void 0, this._endPixel = void 0, this._reversePixels = !1, this._userMax = void 0, this._userMin = void 0, this._suggestedMax = void 0, this._suggestedMin = void 0, this._ticksLength = 0, this._borderValue = 0, this._cache = {}, this._dataLimitsCached = !1, this.$context = void 0;
  }
  init(e) {
    this.options = e.setContext(this.getContext()), this.axis = e.axis, this._userMin = this.parse(e.min), this._userMax = this.parse(e.max), this._suggestedMin = this.parse(e.suggestedMin), this._suggestedMax = this.parse(e.suggestedMax);
  }
  parse(e, n) {
    return e;
  }
  getUserBounds() {
    let { _userMin: e, _userMax: n, _suggestedMin: r, _suggestedMax: o } = this;
    return e = Hs(e, Number.POSITIVE_INFINITY), n = Hs(n, Number.NEGATIVE_INFINITY), r = Hs(r, Number.POSITIVE_INFINITY), o = Hs(o, Number.NEGATIVE_INFINITY), {
      min: Hs(e, r),
      max: Hs(n, o),
      minDefined: po(e),
      maxDefined: po(n)
    };
  }
  getMinMax(e) {
    let { min: n, max: r, minDefined: o, maxDefined: i } = this.getUserBounds(), s;
    if (o && i)
      return {
        min: n,
        max: r
      };
    const a = this.getMatchingVisibleMetas();
    for (let l = 0, c = a.length; l < c; ++l)
      s = a[l].controller.getMinMax(this, e), o || (n = Math.min(n, s.min)), i || (r = Math.max(r, s.max));
    return n = i && n > r ? r : n, r = o && n > r ? n : r, {
      min: Hs(n, Hs(r, n)),
      max: Hs(r, Hs(n, r))
    };
  }
  getPadding() {
    return {
      left: this.paddingLeft || 0,
      top: this.paddingTop || 0,
      right: this.paddingRight || 0,
      bottom: this.paddingBottom || 0
    };
  }
  getTicks() {
    return this.ticks;
  }
  getLabels() {
    const e = this.chart.data;
    return this.options.labels || (this.isHorizontal() ? e.xLabels : e.yLabels) || e.labels || [];
  }
  getLabelItems(e = this.chart.chartArea) {
    return this._labelItems || (this._labelItems = this._computeLabelItems(e));
  }
  beforeLayout() {
    this._cache = {}, this._dataLimitsCached = !1;
  }
  beforeUpdate() {
    Wn(this.options.beforeUpdate, [
      this
    ]);
  }
  update(e, n, r) {
    const { beginAtZero: o, grace: i, ticks: s } = this.options, a = s.sampleSize;
    this.beforeUpdate(), this.maxWidth = e, this.maxHeight = n, this._margins = r = Object.assign({
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, r), this.ticks = null, this._labelSizes = null, this._gridLineItems = null, this._labelItems = null, this.beforeSetDimensions(), this.setDimensions(), this.afterSetDimensions(), this._maxLength = this.isHorizontal() ? this.width + r.left + r.right : this.height + r.top + r.bottom, this._dataLimitsCached || (this.beforeDataLimits(), this.determineDataLimits(), this.afterDataLimits(), this._range = aZe(this, i, o), this._dataLimitsCached = !0), this.beforeBuildTicks(), this.ticks = this.buildTicks() || [], this.afterBuildTicks();
    const l = a < this.ticks.length;
    this._convertTicksToLabels(l ? iH(this.ticks, a) : this.ticks), this.configure(), this.beforeCalculateLabelRotation(), this.calculateLabelRotation(), this.afterCalculateLabelRotation(), s.display && (s.autoSkip || s.source === "auto") && (this.ticks = BJe(this, this.ticks), this._labelSizes = null, this.afterAutoSkip()), l && this._convertTicksToLabels(this.ticks), this.beforeFit(), this.fit(), this.afterFit(), this.afterUpdate();
  }
  configure() {
    let e = this.options.reverse, n, r;
    this.isHorizontal() ? (n = this.left, r = this.right) : (n = this.top, r = this.bottom, e = !e), this._startPixel = n, this._endPixel = r, this._reversePixels = e, this._length = r - n, this._alignToPixels = this.options.alignToPixels;
  }
  afterUpdate() {
    Wn(this.options.afterUpdate, [
      this
    ]);
  }
  beforeSetDimensions() {
    Wn(this.options.beforeSetDimensions, [
      this
    ]);
  }
  setDimensions() {
    this.isHorizontal() ? (this.width = this.maxWidth, this.left = 0, this.right = this.width) : (this.height = this.maxHeight, this.top = 0, this.bottom = this.height), this.paddingLeft = 0, this.paddingTop = 0, this.paddingRight = 0, this.paddingBottom = 0;
  }
  afterSetDimensions() {
    Wn(this.options.afterSetDimensions, [
      this
    ]);
  }
  _callHooks(e) {
    this.chart.notifyPlugins(e, this.getContext()), Wn(this.options[e], [
      this
    ]);
  }
  beforeDataLimits() {
    this._callHooks("beforeDataLimits");
  }
  determineDataLimits() {
  }
  afterDataLimits() {
    this._callHooks("afterDataLimits");
  }
  beforeBuildTicks() {
    this._callHooks("beforeBuildTicks");
  }
  buildTicks() {
    return [];
  }
  afterBuildTicks() {
    this._callHooks("afterBuildTicks");
  }
  beforeTickToLabelConversion() {
    Wn(this.options.beforeTickToLabelConversion, [
      this
    ]);
  }
  generateTickLabels(e) {
    const n = this.options.ticks;
    let r, o, i;
    for (r = 0, o = e.length; r < o; r++)
      i = e[r], i.label = Wn(n.callback, [
        i.value,
        r,
        e
      ], this);
  }
  afterTickToLabelConversion() {
    Wn(this.options.afterTickToLabelConversion, [
      this
    ]);
  }
  beforeCalculateLabelRotation() {
    Wn(this.options.beforeCalculateLabelRotation, [
      this
    ]);
  }
  calculateLabelRotation() {
    const e = this.options, n = e.ticks, r = oH(this.ticks.length, e.ticks.maxTicksLimit), o = n.minRotation || 0, i = n.maxRotation;
    let s = o, a, l, c;
    if (!this._isVisible() || !n.display || o >= i || r <= 1 || !this.isHorizontal()) {
      this.labelRotation = o;
      return;
    }
    const u = this._getLabelSizes(), d = u.widest.width, f = u.highest.height, h = co(this.chart.width - d, 0, this.maxWidth);
    a = e.offset ? this.maxWidth / r : h / (r - 1), d + 6 > a && (a = h / (r - (e.offset ? 0.5 : 1)), l = this.maxHeight - ym(e.grid) - n.padding - sH(e.title, this.chart.options.font), c = Math.sqrt(d * d + f * f), s = $Qe(Math.min(Math.asin(co((u.highest.height + 6) / a, -1, 1)), Math.asin(co(l / c, -1, 1)) - Math.asin(co(f / c, -1, 1)))), s = Math.max(o, Math.min(i, s))), this.labelRotation = s;
  }
  afterCalculateLabelRotation() {
    Wn(this.options.afterCalculateLabelRotation, [
      this
    ]);
  }
  afterAutoSkip() {
  }
  beforeFit() {
    Wn(this.options.beforeFit, [
      this
    ]);
  }
  fit() {
    const e = {
      width: 0,
      height: 0
    }, { chart: n, options: { ticks: r, title: o, grid: i } } = this, s = this._isVisible(), a = this.isHorizontal();
    if (s) {
      const l = sH(o, n.options.font);
      if (a ? (e.width = this.maxWidth, e.height = ym(i) + l) : (e.height = this.maxHeight, e.width = ym(i) + l), r.display && this.ticks.length) {
        const { first: c, last: u, widest: d, highest: f } = this._getLabelSizes(), h = r.padding * 2, p = xl(this.labelRotation), m = Math.cos(p), g = Math.sin(p);
        if (a) {
          const y = r.mirror ? 0 : g * d.width + m * f.height;
          e.height = Math.min(this.maxHeight, e.height + y + h);
        } else {
          const y = r.mirror ? 0 : m * d.width + g * f.height;
          e.width = Math.min(this.maxWidth, e.width + y + h);
        }
        this._calculatePadding(c, u, g, m);
      }
    }
    this._handleMargins(), a ? (this.width = this._length = n.width - this._margins.left - this._margins.right, this.height = e.height) : (this.width = e.width, this.height = this._length = n.height - this._margins.top - this._margins.bottom);
  }
  _calculatePadding(e, n, r, o) {
    const { ticks: { align: i, padding: s }, position: a } = this.options, l = this.labelRotation !== 0, c = a !== "top" && this.axis === "x";
    if (this.isHorizontal()) {
      const u = this.getPixelForTick(0) - this.left, d = this.right - this.getPixelForTick(this.ticks.length - 1);
      let f = 0, h = 0;
      l ? c ? (f = o * e.width, h = r * n.height) : (f = r * e.height, h = o * n.width) : i === "start" ? h = n.width : i === "end" ? f = e.width : i !== "inner" && (f = e.width / 2, h = n.width / 2), this.paddingLeft = Math.max((f - u + s) * this.width / (this.width - u), 0), this.paddingRight = Math.max((h - d + s) * this.width / (this.width - d), 0);
    } else {
      let u = n.height / 2, d = e.height / 2;
      i === "start" ? (u = 0, d = e.height) : i === "end" && (u = n.height, d = 0), this.paddingTop = u + s, this.paddingBottom = d + s;
    }
  }
  _handleMargins() {
    this._margins && (this._margins.left = Math.max(this.paddingLeft, this._margins.left), this._margins.top = Math.max(this.paddingTop, this._margins.top), this._margins.right = Math.max(this.paddingRight, this._margins.right), this._margins.bottom = Math.max(this.paddingBottom, this._margins.bottom));
  }
  afterFit() {
    Wn(this.options.afterFit, [
      this
    ]);
  }
  isHorizontal() {
    const { axis: e, position: n } = this.options;
    return n === "top" || n === "bottom" || e === "x";
  }
  isFullSize() {
    return this.options.fullSize;
  }
  _convertTicksToLabels(e) {
    this.beforeTickToLabelConversion(), this.generateTickLabels(e);
    let n, r;
    for (n = 0, r = e.length; n < r; n++)
      vn(e[n].label) && (e.splice(n, 1), r--, n--);
    this.afterTickToLabelConversion();
  }
  _getLabelSizes() {
    let e = this._labelSizes;
    if (!e) {
      const n = this.options.ticks.sampleSize;
      let r = this.ticks;
      n < r.length && (r = iH(r, n)), this._labelSizes = e = this._computeLabelSizes(r, r.length, this.options.ticks.maxTicksLimit);
    }
    return e;
  }
  _computeLabelSizes(e, n, r) {
    const { ctx: o, _longestTextCache: i } = this, s = [], a = [], l = Math.floor(n / oH(n, r));
    let c = 0, u = 0, d, f, h, p, m, g, y, v, b, _, w;
    for (d = 0; d < n; d += l) {
      if (p = e[d].label, m = this._resolveTickFontOptions(d), o.font = g = m.string, y = i[g] = i[g] || {
        data: {},
        gc: []
      }, v = m.lineHeight, b = _ = 0, !vn(p) && !Cr(p))
        b = MU(o, y.data, y.gc, b, p), _ = v;
      else if (Cr(p))
        for (f = 0, h = p.length; f < h; ++f)
          w = p[f], !vn(w) && !Cr(w) && (b = MU(o, y.data, y.gc, b, w), _ += v);
      s.push(b), a.push(_), c = Math.max(b, c), u = Math.max(_, u);
    }
    YJe(i, n);
    const x = s.indexOf(c), E = a.indexOf(u), S = (C) => ({
      width: s[C] || 0,
      height: a[C] || 0
    });
    return {
      first: S(0),
      last: S(n - 1),
      widest: S(x),
      highest: S(E),
      widths: s,
      heights: a
    };
  }
  getLabelForValue(e) {
    return e;
  }
  getPixelForValue(e, n) {
    return NaN;
  }
  getValueForPixel(e) {
  }
  getPixelForTick(e) {
    const n = this.ticks;
    return e < 0 || e > n.length - 1 ? null : this.getPixelForValue(n[e].value);
  }
  getPixelForDecimal(e) {
    this._reversePixels && (e = 1 - e);
    const n = this._startPixel + e * this._length;
    return DQe(this._alignToPixels ? _u(this.chart, n, 0) : n);
  }
  getDecimalForPixel(e) {
    const n = (e - this._startPixel) / this._length;
    return this._reversePixels ? 1 - n : n;
  }
  getBasePixel() {
    return this.getPixelForValue(this.getBaseValue());
  }
  getBaseValue() {
    const { min: e, max: n } = this;
    return e < 0 && n < 0 ? n : e > 0 && n > 0 ? e : 0;
  }
  getContext(e) {
    const n = this.ticks || [];
    if (e >= 0 && e < n.length) {
      const r = n[e];
      return r.$context || (r.$context = XJe(this.getContext(), e, r));
    }
    return this.$context || (this.$context = KJe(this.chart.getContext(), this));
  }
  _tickSize() {
    const e = this.options.ticks, n = xl(this.labelRotation), r = Math.abs(Math.cos(n)), o = Math.abs(Math.sin(n)), i = this._getLabelSizes(), s = e.autoSkipPadding || 0, a = i ? i.widest.width + s : 0, l = i ? i.highest.height + s : 0;
    return this.isHorizontal() ? l * r > a * o ? a / r : l / o : l * o < a * r ? l / r : a / o;
  }
  _isVisible() {
    const e = this.options.display;
    return e !== "auto" ? !!e : this.getMatchingVisibleMetas().length > 0;
  }
  _computeGridLineItems(e) {
    const n = this.axis, r = this.chart, o = this.options, { grid: i, position: s, border: a } = o, l = i.offset, c = this.isHorizontal(), u = this.ticks.length + (l ? 1 : 0), d = ym(i), f = [], h = a.setContext(this.getContext()), p = h.display ? h.width : 0, m = p / 2, g = function(k) {
      return _u(r, k, p);
    };
    let y, v, b, _, w, x, E, S, C, R, P, N;
    if (s === "top")
      y = g(this.bottom), x = this.bottom - d, S = y - m, R = g(e.top) + m, N = e.bottom;
    else if (s === "bottom")
      y = g(this.top), R = e.top, N = g(e.bottom) - m, x = y + m, S = this.top + d;
    else if (s === "left")
      y = g(this.right), w = this.right - d, E = y - m, C = g(e.left) + m, P = e.right;
    else if (s === "right")
      y = g(this.left), C = e.left, P = g(e.right) - m, w = y + m, E = this.left + d;
    else if (n === "x") {
      if (s === "center")
        y = g((e.top + e.bottom) / 2 + 0.5);
      else if (Bt(s)) {
        const k = Object.keys(s)[0], T = s[k];
        y = g(this.chart.scales[k].getPixelForValue(T));
      }
      R = e.top, N = e.bottom, x = y + m, S = x + d;
    } else if (n === "y") {
      if (s === "center")
        y = g((e.left + e.right) / 2);
      else if (Bt(s)) {
        const k = Object.keys(s)[0], T = s[k];
        y = g(this.chart.scales[k].getPixelForValue(T));
      }
      w = y - m, E = w - d, C = e.left, P = e.right;
    }
    const A = Tt(o.ticks.maxTicksLimit, u), O = Math.max(1, Math.ceil(u / A));
    for (v = 0; v < u; v += O) {
      const k = this.getContext(v), T = i.setContext(k), I = a.setContext(k), j = T.lineWidth, z = T.color, $ = I.dash || [], D = I.dashOffset, U = T.tickWidth, q = T.tickColor, F = T.tickBorderDash || [], B = T.tickBorderDashOffset;
      b = GJe(this, v, l), b !== void 0 && (_ = _u(r, b, j), c ? w = E = C = P = _ : x = S = R = N = _, f.push({
        tx1: w,
        ty1: x,
        tx2: E,
        ty2: S,
        x1: C,
        y1: R,
        x2: P,
        y2: N,
        width: j,
        color: z,
        borderDash: $,
        borderDashOffset: D,
        tickWidth: U,
        tickColor: q,
        tickBorderDash: F,
        tickBorderDashOffset: B
      }));
    }
    return this._ticksLength = u, this._borderValue = y, f;
  }
  _computeLabelItems(e) {
    const n = this.axis, r = this.options, { position: o, ticks: i } = r, s = this.isHorizontal(), a = this.ticks, { align: l, crossAlign: c, padding: u, mirror: d } = i, f = ym(r.grid), h = f + u, p = d ? -u : h, m = -xl(this.labelRotation), g = [];
    let y, v, b, _, w, x, E, S, C, R, P, N, A = "middle";
    if (o === "top")
      x = this.bottom - p, E = this._getXAxisLabelAlignment();
    else if (o === "bottom")
      x = this.top + p, E = this._getXAxisLabelAlignment();
    else if (o === "left") {
      const k = this._getYAxisLabelAlignment(f);
      E = k.textAlign, w = k.x;
    } else if (o === "right") {
      const k = this._getYAxisLabelAlignment(f);
      E = k.textAlign, w = k.x;
    } else if (n === "x") {
      if (o === "center")
        x = (e.top + e.bottom) / 2 + h;
      else if (Bt(o)) {
        const k = Object.keys(o)[0], T = o[k];
        x = this.chart.scales[k].getPixelForValue(T) + h;
      }
      E = this._getXAxisLabelAlignment();
    } else if (n === "y") {
      if (o === "center")
        w = (e.left + e.right) / 2 - h;
      else if (Bt(o)) {
        const k = Object.keys(o)[0], T = o[k];
        w = this.chart.scales[k].getPixelForValue(T);
      }
      E = this._getYAxisLabelAlignment(f).textAlign;
    }
    n === "y" && (l === "start" ? A = "top" : l === "end" && (A = "bottom"));
    const O = this._getLabelSizes();
    for (y = 0, v = a.length; y < v; ++y) {
      b = a[y], _ = b.label;
      const k = i.setContext(this.getContext(y));
      S = this.getPixelForTick(y) + i.labelOffset, C = this._resolveTickFontOptions(y), R = C.lineHeight, P = Cr(_) ? _.length : 1;
      const T = P / 2, I = k.color, j = k.textStrokeColor, z = k.textStrokeWidth;
      let $ = E;
      s ? (w = S, E === "inner" && (y === v - 1 ? $ = this.options.reverse ? "left" : "right" : y === 0 ? $ = this.options.reverse ? "right" : "left" : $ = "center"), o === "top" ? c === "near" || m !== 0 ? N = -P * R + R / 2 : c === "center" ? N = -O.highest.height / 2 - T * R + R : N = -O.highest.height + R / 2 : c === "near" || m !== 0 ? N = R / 2 : c === "center" ? N = O.highest.height / 2 - T * R : N = O.highest.height - P * R, d && (N *= -1), m !== 0 && !k.showLabelBackdrop && (w += R / 2 * Math.sin(m))) : (x = S, N = (1 - P) * R / 2);
      let D;
      if (k.showLabelBackdrop) {
        const U = ns(k.backdropPadding), q = O.heights[y], F = O.widths[y];
        let B = N - U.top, H = 0 - U.left;
        switch (A) {
          case "middle":
            B -= q / 2;
            break;
          case "bottom":
            B -= q;
            break;
        }
        switch (E) {
          case "center":
            H -= F / 2;
            break;
          case "right":
            H -= F;
            break;
          case "inner":
            y === v - 1 ? H -= F : y > 0 && (H -= F / 2);
            break;
        }
        D = {
          left: H,
          top: B,
          width: F + U.width,
          height: q + U.height,
          color: k.backdropColor
        };
      }
      g.push({
        label: _,
        font: C,
        textOffset: N,
        options: {
          rotation: m,
          color: I,
          strokeColor: j,
          strokeWidth: z,
          textAlign: $,
          textBaseline: A,
          translation: [
            w,
            x
          ],
          backdrop: D
        }
      });
    }
    return g;
  }
  _getXAxisLabelAlignment() {
    const { position: e, ticks: n } = this.options;
    if (-xl(this.labelRotation))
      return e === "top" ? "left" : "right";
    let r = "center";
    return n.align === "start" ? r = "left" : n.align === "end" ? r = "right" : n.align === "inner" && (r = "inner"), r;
  }
  _getYAxisLabelAlignment(e) {
    const { position: n, ticks: { crossAlign: r, mirror: o, padding: i } } = this.options, s = this._getLabelSizes(), a = e + i, l = s.widest.width;
    let c, u;
    return n === "left" ? o ? (u = this.right + i, r === "near" ? c = "left" : r === "center" ? (c = "center", u += l / 2) : (c = "right", u += l)) : (u = this.right - a, r === "near" ? c = "right" : r === "center" ? (c = "center", u -= l / 2) : (c = "left", u = this.left)) : n === "right" ? o ? (u = this.left + i, r === "near" ? c = "right" : r === "center" ? (c = "center", u -= l / 2) : (c = "left", u -= l)) : (u = this.left + a, r === "near" ? c = "left" : r === "center" ? (c = "center", u += l / 2) : (c = "right", u = this.right)) : c = "right", {
      textAlign: c,
      x: u
    };
  }
  _computeLabelArea() {
    if (this.options.ticks.mirror)
      return;
    const e = this.chart, n = this.options.position;
    if (n === "left" || n === "right")
      return {
        top: 0,
        left: this.left,
        bottom: e.height,
        right: this.right
      };
    if (n === "top" || n === "bottom")
      return {
        top: this.top,
        left: 0,
        bottom: this.bottom,
        right: e.width
      };
  }
  drawBackground() {
    const { ctx: e, options: { backgroundColor: n }, left: r, top: o, width: i, height: s } = this;
    n && (e.save(), e.fillStyle = n, e.fillRect(r, o, i, s), e.restore());
  }
  getLineWidthForValue(e) {
    const n = this.options.grid;
    if (!this._isVisible() || !n.display)
      return 0;
    const r = this.ticks.findIndex((o) => o.value === e);
    return r >= 0 ? n.setContext(this.getContext(r)).lineWidth : 0;
  }
  drawGrid(e) {
    const n = this.options.grid, r = this.ctx, o = this._gridLineItems || (this._gridLineItems = this._computeGridLineItems(e));
    let i, s;
    const a = (l, c, u) => {
      !u.width || !u.color || (r.save(), r.lineWidth = u.width, r.strokeStyle = u.color, r.setLineDash(u.borderDash || []), r.lineDashOffset = u.borderDashOffset, r.beginPath(), r.moveTo(l.x, l.y), r.lineTo(c.x, c.y), r.stroke(), r.restore());
    };
    if (n.display)
      for (i = 0, s = o.length; i < s; ++i) {
        const l = o[i];
        n.drawOnChartArea && a({
          x: l.x1,
          y: l.y1
        }, {
          x: l.x2,
          y: l.y2
        }, l), n.drawTicks && a({
          x: l.tx1,
          y: l.ty1
        }, {
          x: l.tx2,
          y: l.ty2
        }, {
          color: l.tickColor,
          width: l.tickWidth,
          borderDash: l.tickBorderDash,
          borderDashOffset: l.tickBorderDashOffset
        });
      }
  }
  drawBorder() {
    const { chart: e, ctx: n, options: { border: r, grid: o } } = this, i = r.setContext(this.getContext()), s = r.display ? i.width : 0;
    if (!s)
      return;
    const a = o.setContext(this.getContext(0)).lineWidth, l = this._borderValue;
    let c, u, d, f;
    this.isHorizontal() ? (c = _u(e, this.left, s) - s / 2, u = _u(e, this.right, a) + a / 2, d = f = l) : (d = _u(e, this.top, s) - s / 2, f = _u(e, this.bottom, a) + a / 2, c = u = l), n.save(), n.lineWidth = i.width, n.strokeStyle = i.color, n.beginPath(), n.moveTo(c, d), n.lineTo(u, f), n.stroke(), n.restore();
  }
  drawLabels(e) {
    if (!this.options.ticks.display)
      return;
    const n = this.ctx, r = this._computeLabelArea();
    r && YS(n, r);
    const o = this.getLabelItems(e);
    for (const i of o) {
      const s = i.options, a = i.font, l = i.label, c = i.textOffset;
      wy(n, l, 0, c, a, s);
    }
    r && KS(n);
  }
  drawTitle() {
    const { ctx: e, options: { position: n, title: r, reverse: o } } = this;
    if (!r.display)
      return;
    const i = uo(r.font), s = ns(r.padding), a = r.align;
    let l = i.lineHeight / 2;
    n === "bottom" || n === "center" || Bt(n) ? (l += s.bottom, Cr(r.text) && (l += i.lineHeight * (r.text.length - 1))) : l += s.top;
    const { titleX: c, titleY: u, maxWidth: d, rotation: f } = ZJe(this, l, n, a);
    wy(e, r.text, 0, 0, i, {
      color: r.color,
      maxWidth: d,
      rotation: f,
      textAlign: QJe(a, n, o),
      textBaseline: "middle",
      translation: [
        c,
        u
      ]
    });
  }
  draw(e) {
    this._isVisible() && (this.drawBackground(), this.drawGrid(e), this.drawBorder(), this.drawTitle(), this.drawLabels(e));
  }
  _layers() {
    const e = this.options, n = e.ticks && e.ticks.z || 0, r = Tt(e.grid && e.grid.z, -1), o = Tt(e.border && e.border.z, 0);
    return !this._isVisible() || this.draw !== Pp.prototype.draw ? [
      {
        z: n,
        draw: (i) => {
          this.draw(i);
        }
      }
    ] : [
      {
        z: r,
        draw: (i) => {
          this.drawBackground(), this.drawGrid(i), this.drawTitle();
        }
      },
      {
        z: o,
        draw: () => {
          this.drawBorder();
        }
      },
      {
        z: n,
        draw: (i) => {
          this.drawLabels(i);
        }
      }
    ];
  }
  getMatchingVisibleMetas(e) {
    const n = this.chart.getSortedVisibleDatasetMetas(), r = this.axis + "AxisID", o = [];
    let i, s;
    for (i = 0, s = n.length; i < s; ++i) {
      const a = n[i];
      a[r] === this.id && (!e || a.type === e) && o.push(a);
    }
    return o;
  }
  _resolveTickFontOptions(e) {
    const n = this.options.ticks.setContext(this.getContext(e));
    return uo(n.font);
  }
  _maxDigits() {
    const e = this._resolveTickFontOptions(0).lineHeight;
    return (this.isHorizontal() ? this.width : this.height) / e;
  }
}
class p1 {
  constructor(e, n, r) {
    this.type = e, this.scope = n, this.override = r, this.items = /* @__PURE__ */ Object.create(null);
  }
  isForType(e) {
    return Object.prototype.isPrototypeOf.call(this.type.prototype, e.prototype);
  }
  register(e) {
    const n = Object.getPrototypeOf(e);
    let r;
    tet(n) && (r = this.register(n));
    const o = this.items, i = e.id, s = this.scope + "." + i;
    if (!i)
      throw new Error("class does not have id: " + e);
    return i in o || (o[i] = e, JJe(e, s, r), this.override && wr.override(e.id, e.overrides)), s;
  }
  get(e) {
    return this.items[e];
  }
  unregister(e) {
    const n = this.items, r = e.id, o = this.scope;
    r in n && delete n[r], o && r in wr[o] && (delete wr[o][r], this.override && delete Ld[r]);
  }
}
function JJe(t, e, n) {
  const r = gy(/* @__PURE__ */ Object.create(null), [
    n ? wr.get(n) : {},
    wr.get(e),
    t.defaults
  ]);
  wr.set(e, r), t.defaultRoutes && eet(e, t.defaultRoutes), t.descriptors && wr.describe(e, t.descriptors);
}
function eet(t, e) {
  Object.keys(e).forEach((n) => {
    const r = n.split("."), o = r.pop(), i = [
      t
    ].concat(r).join("."), s = e[n].split("."), a = s.pop(), l = s.join(".");
    wr.route(i, o, l, a);
  });
}
function tet(t) {
  return "id" in t && "defaults" in t;
}
let net = class {
  constructor() {
    this.controllers = new p1(wd, "datasets", !0), this.elements = new p1(Vl, "elements"), this.plugins = new p1(Object, "plugins"), this.scales = new p1(Pp, "scales"), this._typedRegistries = [
      this.controllers,
      this.scales,
      this.elements
    ];
  }
  add(...t) {
    this._each("register", t);
  }
  remove(...t) {
    this._each("unregister", t);
  }
  addControllers(...t) {
    this._each("register", t, this.controllers);
  }
  addElements(...t) {
    this._each("register", t, this.elements);
  }
  addPlugins(...t) {
    this._each("register", t, this.plugins);
  }
  addScales(...t) {
    this._each("register", t, this.scales);
  }
  getController(t) {
    return this._get(t, this.controllers, "controller");
  }
  getElement(t) {
    return this._get(t, this.elements, "element");
  }
  getPlugin(t) {
    return this._get(t, this.plugins, "plugin");
  }
  getScale(t) {
    return this._get(t, this.scales, "scale");
  }
  removeControllers(...t) {
    this._each("unregister", t, this.controllers);
  }
  removeElements(...t) {
    this._each("unregister", t, this.elements);
  }
  removePlugins(...t) {
    this._each("unregister", t, this.plugins);
  }
  removeScales(...t) {
    this._each("unregister", t, this.scales);
  }
  _each(t, e, n) {
    [
      ...e
    ].forEach((r) => {
      const o = n || this._getRegistryForType(r);
      n || o.isForType(r) || o === this.plugins && r.id ? this._exec(t, o, r) : On(r, (i) => {
        const s = n || this._getRegistryForType(i);
        this._exec(t, s, i);
      });
    });
  }
  _exec(t, e, n) {
    const r = r4(t);
    Wn(n["before" + r], [], n), e[t](n), Wn(n["after" + r], [], n);
  }
  _getRegistryForType(t) {
    for (let e = 0; e < this._typedRegistries.length; e++) {
      const n = this._typedRegistries[e];
      if (n.isForType(t))
        return n;
    }
    return this.plugins;
  }
  _get(t, e, n) {
    const r = e.get(t);
    if (r === void 0)
      throw new Error('"' + t + '" is not a registered ' + n + ".");
    return r;
  }
};
var ea = /* @__PURE__ */ new net();
class ret {
  constructor() {
    this._init = [];
  }
  notify(e, n, r, o) {
    n === "beforeInit" && (this._init = this._createDescriptors(e, !0), this._notify(this._init, e, "install"));
    const i = o ? this._descriptors(e).filter(o) : this._descriptors(e), s = this._notify(i, e, n, r);
    return n === "afterDestroy" && (this._notify(i, e, "stop"), this._notify(this._init, e, "uninstall")), s;
  }
  _notify(e, n, r, o) {
    o = o || {};
    for (const i of e) {
      const s = i.plugin, a = s[r], l = [
        n,
        o,
        i.options
      ];
      if (Wn(a, l, s) === !1 && o.cancelable)
        return !1;
    }
    return !0;
  }
  invalidate() {
    vn(this._cache) || (this._oldCache = this._cache, this._cache = void 0);
  }
  _descriptors(e) {
    if (this._cache)
      return this._cache;
    const n = this._cache = this._createDescriptors(e);
    return this._notifyStateChanges(e), n;
  }
  _createDescriptors(e, n) {
    const r = e && e.config, o = Tt(r.options && r.options.plugins, {}), i = oet(r);
    return o === !1 && !n ? [] : set(e, i, o, n);
  }
  _notifyStateChanges(e) {
    const n = this._oldCache || [], r = this._cache, o = (i, s) => i.filter((a) => !s.some((l) => a.plugin.id === l.plugin.id));
    this._notify(o(n, r), e, "stop"), this._notify(o(r, n), e, "start");
  }
}
function oet(t) {
  const e = {}, n = [], r = Object.keys(ea.plugins.items);
  for (let i = 0; i < r.length; i++)
    n.push(ea.getPlugin(r[i]));
  const o = t.plugins || [];
  for (let i = 0; i < o.length; i++) {
    const s = o[i];
    n.indexOf(s) === -1 && (n.push(s), e[s.id] = !0);
  }
  return {
    plugins: n,
    localIds: e
  };
}
function iet(t, e) {
  return !e && t === !1 ? null : t === !0 ? {} : t;
}
function set(t, { plugins: e, localIds: n }, r, o) {
  const i = [], s = t.getContext();
  for (const a of e) {
    const l = a.id, c = iet(r[l], o);
    c !== null && i.push({
      plugin: a,
      options: aet(t.config, {
        plugin: a,
        local: n[l]
      }, c, s)
    });
  }
  return i;
}
function aet(t, { plugin: e, local: n }, r, o) {
  const i = t.pluginScopeKeys(e), s = t.getOptionScopes(r, i);
  return n && e.defaults && s.push(e.defaults), t.createResolver(s, o, [
    ""
  ], {
    scriptable: !1,
    indexable: !1,
    allKeys: !0
  });
}
function uj(t, e) {
  const n = wr.datasets[t] || {};
  return ((e.datasets || {})[t] || {}).indexAxis || e.indexAxis || n.indexAxis || "x";
}
function cet(t, e) {
  let n = t;
  return t === "_index_" ? n = e : t === "_value_" && (n = e === "x" ? "y" : "x"), n;
}
function uet(t, e) {
  return t === e ? "_index_" : "_value_";
}
function aH(t) {
  if (t === "x" || t === "y" || t === "r")
    return t;
}
function det(t) {
  if (t === "top" || t === "bottom")
    return "x";
  if (t === "left" || t === "right")
    return "y";
}
function dj(t, ...e) {
  if (aH(t))
    return t;
  for (const n of e) {
    const r = n.axis || det(n.position) || t.length > 1 && aH(t[0].toLowerCase());
    if (r)
      return r;
  }
  throw new Error(`Cannot determine type of '${t}' axis. Please provide 'axis' or 'position' option.`);
}
function lH(t, e, n) {
  if (n[e + "AxisID"] === t)
    return {
      axis: e
    };
}
function fet(t, e) {
  if (e.data && e.data.datasets) {
    const n = e.data.datasets.filter((r) => r.xAxisID === t || r.yAxisID === t);
    if (n.length)
      return lH(t, "x", n[0]) || lH(t, "y", n[0]);
  }
  return {};
}
function het(t, e) {
  const n = Ld[t.type] || {
    scales: {}
  }, r = e.scales || {}, o = uj(t.type, e), i = /* @__PURE__ */ Object.create(null);
  return Object.keys(r).forEach((s) => {
    const a = r[s];
    if (!Bt(a))
      return console.error(`Invalid scale configuration for scale: ${s}`);
    if (a._proxy)
      return console.warn(`Ignoring resolver passed as options for scale: ${s}`);
    const l = dj(s, a, fet(s, t), wr.scales[a.type]), c = uet(l, o), u = n.scales || {};
    i[s] = a0(/* @__PURE__ */ Object.create(null), [
      {
        axis: l
      },
      a,
      u[l],
      u[c]
    ]);
  }), t.data.datasets.forEach((s) => {
    const a = s.type || t.type, l = s.indexAxis || uj(a, e), c = (Ld[a] || {}).scales || {};
    Object.keys(c).forEach((u) => {
      const d = cet(u, l), f = s[d + "AxisID"] || d;
      i[f] = i[f] || /* @__PURE__ */ Object.create(null), a0(i[f], [
        {
          axis: d
        },
        r[f],
        c[u]
      ]);
    });
  }), Object.keys(i).forEach((s) => {
    const a = i[s];
    a0(a, [
      wr.scales[a.type],
      wr.scale
    ]);
  }), i;
}
function Fme(t) {
  const e = t.options || (t.options = {});
  e.plugins = Tt(e.plugins, {}), e.scales = het(t, e);
}
function Bme(t) {
  return t = t || {}, t.datasets = t.datasets || [], t.labels = t.labels || [], t;
}
function pet(t) {
  return t = t || {}, t.data = Bme(t.data), Fme(t), t;
}
const cH = /* @__PURE__ */ new Map(), zme = /* @__PURE__ */ new Set();
function m1(t, e) {
  let n = cH.get(t);
  return n || (n = e(), cH.set(t, n), zme.add(n)), n;
}
const vm = (t, e, n) => {
  const r = jd(e, n);
  r !== void 0 && t.add(r);
};
class met {
  constructor(e) {
    this._config = pet(e), this._scopeCache = /* @__PURE__ */ new Map(), this._resolverCache = /* @__PURE__ */ new Map();
  }
  get platform() {
    return this._config.platform;
  }
  get type() {
    return this._config.type;
  }
  set type(e) {
    this._config.type = e;
  }
  get data() {
    return this._config.data;
  }
  set data(e) {
    this._config.data = Bme(e);
  }
  get options() {
    return this._config.options;
  }
  set options(e) {
    this._config.options = e;
  }
  get plugins() {
    return this._config.plugins;
  }
  update() {
    const e = this._config;
    this.clearCache(), Fme(e);
  }
  clearCache() {
    this._scopeCache.clear(), this._resolverCache.clear();
  }
  datasetScopeKeys(e) {
    return m1(e, () => [
      [
        `datasets.${e}`,
        ""
      ]
    ]);
  }
  datasetAnimationScopeKeys(e, n) {
    return m1(`${e}.transition.${n}`, () => [
      [
        `datasets.${e}.transitions.${n}`,
        `transitions.${n}`
      ],
      [
        `datasets.${e}`,
        ""
      ]
    ]);
  }
  datasetElementScopeKeys(e, n) {
    return m1(`${e}-${n}`, () => [
      [
        `datasets.${e}.elements.${n}`,
        `datasets.${e}`,
        `elements.${n}`,
        ""
      ]
    ]);
  }
  pluginScopeKeys(e) {
    const n = e.id, r = this.type;
    return m1(`${r}-plugin-${n}`, () => [
      [
        `plugins.${n}`,
        ...e.additionalOptionScopes || []
      ]
    ]);
  }
  _cachedScopes(e, n) {
    const r = this._scopeCache;
    let o = r.get(e);
    return (!o || n) && (o = /* @__PURE__ */ new Map(), r.set(e, o)), o;
  }
  getOptionScopes(e, n, r) {
    const { options: o, type: i } = this, s = this._cachedScopes(e, r), a = s.get(n);
    if (a)
      return a;
    const l = /* @__PURE__ */ new Set();
    n.forEach((u) => {
      e && (l.add(e), u.forEach((d) => vm(l, e, d))), u.forEach((d) => vm(l, o, d)), u.forEach((d) => vm(l, Ld[i] || {}, d)), u.forEach((d) => vm(l, wr, d)), u.forEach((d) => vm(l, lj, d));
    });
    const c = Array.from(l);
    return c.length === 0 && c.push(/* @__PURE__ */ Object.create(null)), zme.has(n) && s.set(n, c), c;
  }
  chartOptionScopes() {
    const { options: e, type: n } = this;
    return [
      e,
      Ld[n] || {},
      wr.datasets[n] || {},
      {
        type: n
      },
      wr,
      lj
    ];
  }
  resolveNamedOptions(e, n, r, o = [
    ""
  ]) {
    const i = {
      $shared: !0
    }, { resolver: s, subPrefixes: a } = uH(this._resolverCache, e, o);
    let l = s;
    if (yet(s, n)) {
      i.$shared = !1, r = nu(r) ? r() : r;
      const c = this.createResolver(e, r, a);
      l = ip(s, r, c);
    }
    for (const c of n)
      i[c] = l[c];
    return i;
  }
  createResolver(e, n, r = [
    ""
  ], o) {
    const { resolver: i } = uH(this._resolverCache, e, r);
    return Bt(n) ? ip(i, n, void 0, o) : i;
  }
}
function uH(t, e, n) {
  let r = t.get(e);
  r || (r = /* @__PURE__ */ new Map(), t.set(e, r));
  const o = n.join();
  let i = r.get(o);
  return i || (i = {
    resolver: c4(e, n),
    subPrefixes: n.filter((s) => !s.toLowerCase().includes("hover"))
  }, r.set(o, i)), i;
}
const get = (t) => Bt(t) && Object.getOwnPropertyNames(t).some((e) => nu(t[e]));
function yet(t, e) {
  const { isScriptable: n, isIndexable: r } = _me(t);
  for (const o of e) {
    const i = n(o), s = r(o), a = (s || i) && t[o];
    if (i && (nu(a) || get(a)) || s && Cr(a))
      return !0;
  }
  return !1;
}
var vet = "4.5.0";
const bet = [
  "top",
  "bottom",
  "left",
  "right",
  "chartArea"
];
function dH(t, e) {
  return t === "top" || t === "bottom" || bet.indexOf(t) === -1 && e === "x";
}
function fH(t, e) {
  return function(n, r) {
    return n[t] === r[t] ? n[e] - r[e] : n[t] - r[t];
  };
}
function hH(t) {
  const e = t.chart, n = e.options.animation;
  e.notifyPlugins("afterRender"), Wn(n && n.onComplete, [
    t
  ], e);
}
function _et(t) {
  const e = t.chart, n = e.options.animation;
  Wn(n && n.onProgress, [
    t
  ], e);
}
function qme(t) {
  return f4() && typeof t == "string" ? t = document.getElementById(t) : t && t.length && (t = t[0]), t && t.canvas && (t = t.canvas), t;
}
const cE = {}, Ume = (t) => {
  const e = qme(t);
  return Object.values(cE).filter((n) => n.canvas === e).pop();
};
function wet(t, e, n) {
  const r = Object.keys(t);
  for (const o of r) {
    const i = +o;
    if (i >= e) {
      const s = t[o];
      delete t[o], (n > 0 || i > e) && (t[i + n] = s);
    }
  }
}
function xet(t, e, n, r) {
  return !n || t.type === "mouseout" ? null : r ? e : t;
}
let wc = class {
  static register(...e) {
    ea.add(...e), pH();
  }
  static unregister(...e) {
    ea.remove(...e), pH();
  }
  constructor(e, n) {
    const r = this.config = new met(n), o = qme(e), i = Ume(o);
    if (i)
      throw new Error("Canvas is already in use. Chart with ID '" + i.id + "' must be destroyed before the canvas with ID '" + i.canvas.id + "' can be reused.");
    const s = r.createResolver(r.chartOptionScopes(), this.getContext());
    this.platform = new (r.platform || FJe(o))(), this.platform.updateConfig(r);
    const a = this.platform.acquireContext(o, s.aspectRatio), l = a && a.canvas, c = l && l.height, u = l && l.width;
    if (this.id = bQe(), this.ctx = a, this.canvas = l, this.width = u, this.height = c, this._options = s, this._aspectRatio = this.aspectRatio, this._layers = [], this._metasets = [], this._stacks = void 0, this.boxes = [], this.currentDevicePixelRatio = void 0, this.chartArea = void 0, this._active = [], this._lastEvent = void 0, this._listeners = {}, this._responsiveListeners = void 0, this._sortedMetasets = [], this.scales = {}, this._plugins = new ret(), this.$proxies = {}, this._hiddenIndices = {}, this.attached = !1, this._animationsDisabled = void 0, this.$context = void 0, this._doResize = LQe((d) => this.update(d), s.resizeDelay || 0), this._dataChanges = [], cE[this.id] = this, !a || !l) {
      console.error("Failed to create chart: can't acquire context from the given item");
      return;
    }
    tl.listen(this, "complete", hH), tl.listen(this, "progress", _et), this._initialize(), this.attached && this.update();
  }
  get aspectRatio() {
    const { options: { aspectRatio: e, maintainAspectRatio: n }, width: r, height: o, _aspectRatio: i } = this;
    return vn(e) ? n && i ? i : o ? r / o : null : e;
  }
  get data() {
    return this.config.data;
  }
  set data(e) {
    this.config.data = e;
  }
  get options() {
    return this._options;
  }
  set options(e) {
    this.config.options = e;
  }
  get registry() {
    return ea;
  }
  _initialize() {
    return this.notifyPlugins("beforeInit"), this.options.responsive ? this.resize() : jU(this, this.options.devicePixelRatio), this.bindEvents(), this.notifyPlugins("afterInit"), this;
  }
  clear() {
    return DU(this.canvas, this.ctx), this;
  }
  stop() {
    return tl.stop(this), this;
  }
  resize(e, n) {
    tl.running(this) ? this._resizeBeforeDraw = {
      width: e,
      height: n
    } : this._resize(e, n);
  }
  _resize(e, n) {
    const r = this.options, o = this.canvas, i = r.maintainAspectRatio && this.aspectRatio, s = this.platform.getMaximumSize(o, e, n, i), a = r.devicePixelRatio || this.platform.getDevicePixelRatio(), l = this.width ? "resize" : "attach";
    this.width = s.width, this.height = s.height, this._aspectRatio = this.aspectRatio, jU(this, a, !0) && (this.notifyPlugins("resize", {
      size: s
    }), Wn(r.onResize, [
      this,
      s
    ], this), this.attached && this._doResize(l) && this.render());
  }
  ensureScalesHaveIDs() {
    const e = this.options.scales || {};
    On(e, (n, r) => {
      n.id = r;
    });
  }
  buildOrUpdateScales() {
    const e = this.options, n = e.scales, r = this.scales, o = Object.keys(r).reduce((s, a) => (s[a] = !1, s), {});
    let i = [];
    n && (i = i.concat(Object.keys(n).map((s) => {
      const a = n[s], l = dj(s, a), c = l === "r", u = l === "x";
      return {
        options: a,
        dposition: c ? "chartArea" : u ? "bottom" : "left",
        dtype: c ? "radialLinear" : u ? "category" : "linear"
      };
    }))), On(i, (s) => {
      const a = s.options, l = a.id, c = dj(l, a), u = Tt(a.type, s.dtype);
      (a.position === void 0 || dH(a.position, c) !== dH(s.dposition)) && (a.position = s.dposition), o[l] = !0;
      let d = null;
      if (l in r && r[l].type === u)
        d = r[l];
      else {
        const f = ea.getScale(u);
        d = new f({
          id: l,
          type: u,
          ctx: this.ctx,
          chart: this
        }), r[d.id] = d;
      }
      d.init(a, e);
    }), On(o, (s, a) => {
      s || delete r[a];
    }), On(r, (s) => {
      qi.configure(this, s, s.options), qi.addBox(this, s);
    });
  }
  _updateMetasets() {
    const e = this._metasets, n = this.data.datasets.length, r = e.length;
    if (e.sort((o, i) => o.index - i.index), r > n) {
      for (let o = n; o < r; ++o)
        this._destroyDatasetMeta(o);
      e.splice(n, r - n);
    }
    this._sortedMetasets = e.slice(0).sort(fH("order", "index"));
  }
  _removeUnreferencedMetasets() {
    const { _metasets: e, data: { datasets: n } } = this;
    e.length > n.length && delete this._stacks, e.forEach((r, o) => {
      n.filter((i) => i === r._dataset).length === 0 && this._destroyDatasetMeta(o);
    });
  }
  buildOrUpdateControllers() {
    const e = [], n = this.data.datasets;
    let r, o;
    for (this._removeUnreferencedMetasets(), r = 0, o = n.length; r < o; r++) {
      const i = n[r];
      let s = this.getDatasetMeta(r);
      const a = i.type || this.config.type;
      if (s.type && s.type !== a && (this._destroyDatasetMeta(r), s = this.getDatasetMeta(r)), s.type = a, s.indexAxis = i.indexAxis || uj(a, this.options), s.order = i.order || 0, s.index = r, s.label = "" + i.label, s.visible = this.isDatasetVisible(r), s.controller)
        s.controller.updateIndex(r), s.controller.linkScales();
      else {
        const l = ea.getController(a), { datasetElementType: c, dataElementType: u } = wr.datasets[a];
        Object.assign(l, {
          dataElementType: ea.getElement(u),
          datasetElementType: c && ea.getElement(c)
        }), s.controller = new l(this, r), e.push(s.controller);
      }
    }
    return this._updateMetasets(), e;
  }
  _resetElements() {
    On(this.data.datasets, (e, n) => {
      this.getDatasetMeta(n).controller.reset();
    }, this);
  }
  reset() {
    this._resetElements(), this.notifyPlugins("reset");
  }
  update(e) {
    const n = this.config;
    n.update();
    const r = this._options = n.createResolver(n.chartOptionScopes(), this.getContext()), o = this._animationsDisabled = !r.animation;
    if (this._updateScales(), this._checkEventBindings(), this._updateHiddenIndices(), this._plugins.invalidate(), this.notifyPlugins("beforeUpdate", {
      mode: e,
      cancelable: !0
    }) === !1)
      return;
    const i = this.buildOrUpdateControllers();
    this.notifyPlugins("beforeElementsUpdate");
    let s = 0;
    for (let c = 0, u = this.data.datasets.length; c < u; c++) {
      const { controller: d } = this.getDatasetMeta(c), f = !o && i.indexOf(d) === -1;
      d.buildOrUpdateElements(f), s = Math.max(+d.getMaxOverflow(), s);
    }
    s = this._minPadding = r.layout.autoPadding ? s : 0, this._updateLayout(s), o || On(i, (c) => {
      c.reset();
    }), this._updateDatasets(e), this.notifyPlugins("afterUpdate", {
      mode: e
    }), this._layers.sort(fH("z", "_idx"));
    const { _active: a, _lastEvent: l } = this;
    l ? this._eventHandler(l, !0) : a.length && this._updateHoverStyles(a, a, !0), this.render();
  }
  _updateScales() {
    On(this.scales, (e) => {
      qi.removeBox(this, e);
    }), this.ensureScalesHaveIDs(), this.buildOrUpdateScales();
  }
  _checkEventBindings() {
    const e = this.options, n = new Set(Object.keys(this._listeners)), r = new Set(e.events);
    (!SU(n, r) || !!this._responsiveListeners !== e.responsive) && (this.unbindEvents(), this.bindEvents());
  }
  _updateHiddenIndices() {
    const { _hiddenIndices: e } = this, n = this._getUniformDataChanges() || [];
    for (const { method: r, start: o, count: i } of n) {
      const s = r === "_removeElements" ? -i : i;
      wet(e, o, s);
    }
  }
  _getUniformDataChanges() {
    const e = this._dataChanges;
    if (!e || !e.length)
      return;
    this._dataChanges = [];
    const n = this.data.datasets.length, r = (i) => new Set(e.filter((s) => s[0] === i).map((s, a) => a + "," + s.splice(1).join(","))), o = r(0);
    for (let i = 1; i < n; i++)
      if (!SU(o, r(i)))
        return;
    return Array.from(o).map((i) => i.split(",")).map((i) => ({
      method: i[1],
      start: +i[2],
      count: +i[3]
    }));
  }
  _updateLayout(e) {
    if (this.notifyPlugins("beforeLayout", {
      cancelable: !0
    }) === !1)
      return;
    qi.update(this, this.width, this.height, e);
    const n = this.chartArea, r = n.width <= 0 || n.height <= 0;
    this._layers = [], On(this.boxes, (o) => {
      r && o.position === "chartArea" || (o.configure && o.configure(), this._layers.push(...o._layers()));
    }, this), this._layers.forEach((o, i) => {
      o._idx = i;
    }), this.notifyPlugins("afterLayout");
  }
  _updateDatasets(e) {
    if (this.notifyPlugins("beforeDatasetsUpdate", {
      mode: e,
      cancelable: !0
    }) !== !1) {
      for (let n = 0, r = this.data.datasets.length; n < r; ++n)
        this.getDatasetMeta(n).controller.configure();
      for (let n = 0, r = this.data.datasets.length; n < r; ++n)
        this._updateDataset(n, nu(e) ? e({
          datasetIndex: n
        }) : e);
      this.notifyPlugins("afterDatasetsUpdate", {
        mode: e
      });
    }
  }
  _updateDataset(e, n) {
    const r = this.getDatasetMeta(e), o = {
      meta: r,
      index: e,
      mode: n,
      cancelable: !0
    };
    this.notifyPlugins("beforeDatasetUpdate", o) !== !1 && (r.controller._update(n), o.cancelable = !1, this.notifyPlugins("afterDatasetUpdate", o));
  }
  render() {
    this.notifyPlugins("beforeRender", {
      cancelable: !0
    }) !== !1 && (tl.has(this) ? this.attached && !tl.running(this) && tl.start(this) : (this.draw(), hH({
      chart: this
    })));
  }
  draw() {
    let e;
    if (this._resizeBeforeDraw) {
      const { width: r, height: o } = this._resizeBeforeDraw;
      this._resizeBeforeDraw = null, this._resize(r, o);
    }
    if (this.clear(), this.width <= 0 || this.height <= 0 || this.notifyPlugins("beforeDraw", {
      cancelable: !0
    }) === !1)
      return;
    const n = this._layers;
    for (e = 0; e < n.length && n[e].z <= 0; ++e)
      n[e].draw(this.chartArea);
    for (this._drawDatasets(); e < n.length; ++e)
      n[e].draw(this.chartArea);
    this.notifyPlugins("afterDraw");
  }
  _getSortedDatasetMetas(e) {
    const n = this._sortedMetasets, r = [];
    let o, i;
    for (o = 0, i = n.length; o < i; ++o) {
      const s = n[o];
      (!e || s.visible) && r.push(s);
    }
    return r;
  }
  getSortedVisibleDatasetMetas() {
    return this._getSortedDatasetMetas(!0);
  }
  _drawDatasets() {
    if (this.notifyPlugins("beforeDatasetsDraw", {
      cancelable: !0
    }) === !1)
      return;
    const e = this.getSortedVisibleDatasetMetas();
    for (let n = e.length - 1; n >= 0; --n)
      this._drawDataset(e[n]);
    this.notifyPlugins("afterDatasetsDraw");
  }
  _drawDataset(e) {
    const n = this.ctx, r = {
      meta: e,
      index: e.index,
      cancelable: !0
    }, o = Rme(this, e);
    this.notifyPlugins("beforeDatasetDraw", r) !== !1 && (o && YS(n, o), e.controller.draw(), o && KS(n), r.cancelable = !1, this.notifyPlugins("afterDatasetDraw", r));
  }
  isPointInArea(e) {
    return _y(e, this.chartArea, this._minPadding);
  }
  getElementsAtEventForMode(e, n, r, o) {
    const i = vJe.modes[n];
    return typeof i == "function" ? i(this, e, r, o) : [];
  }
  getDatasetMeta(e) {
    const n = this.data.datasets[e], r = this._metasets;
    let o = r.filter((i) => i && i._dataset === n).pop();
    return o || (o = {
      type: null,
      data: [],
      dataset: null,
      controller: null,
      hidden: null,
      xAxisID: null,
      yAxisID: null,
      order: n && n.order || 0,
      index: e,
      _dataset: n,
      _parsed: [],
      _sorted: !1
    }, r.push(o)), o;
  }
  getContext() {
    return this.$context || (this.$context = Xd(null, {
      chart: this,
      type: "chart"
    }));
  }
  getVisibleDatasetCount() {
    return this.getSortedVisibleDatasetMetas().length;
  }
  isDatasetVisible(e) {
    const n = this.data.datasets[e];
    if (!n)
      return !1;
    const r = this.getDatasetMeta(e);
    return typeof r.hidden == "boolean" ? !r.hidden : !n.hidden;
  }
  setDatasetVisibility(e, n) {
    const r = this.getDatasetMeta(e);
    r.hidden = !n;
  }
  toggleDataVisibility(e) {
    this._hiddenIndices[e] = !this._hiddenIndices[e];
  }
  getDataVisibility(e) {
    return !this._hiddenIndices[e];
  }
  _updateVisibility(e, n, r) {
    const o = r ? "show" : "hide", i = this.getDatasetMeta(e), s = i.controller._resolveAnimations(void 0, o);
    yy(n) ? (i.data[n].hidden = !r, this.update()) : (this.setDatasetVisibility(e, r), s.update(i, {
      visible: r
    }), this.update((a) => a.datasetIndex === e ? o : void 0));
  }
  hide(e, n) {
    this._updateVisibility(e, n, !1);
  }
  show(e, n) {
    this._updateVisibility(e, n, !0);
  }
  _destroyDatasetMeta(e) {
    const n = this._metasets[e];
    n && n.controller && n.controller._destroy(), delete this._metasets[e];
  }
  _stop() {
    let e, n;
    for (this.stop(), tl.remove(this), e = 0, n = this.data.datasets.length; e < n; ++e)
      this._destroyDatasetMeta(e);
  }
  destroy() {
    this.notifyPlugins("beforeDestroy");
    const { canvas: e, ctx: n } = this;
    this._stop(), this.config.clearCache(), e && (this.unbindEvents(), DU(e, n), this.platform.releaseContext(n), this.canvas = null, this.ctx = null), delete cE[this.id], this.notifyPlugins("afterDestroy");
  }
  toBase64Image(...e) {
    return this.canvas.toDataURL(...e);
  }
  bindEvents() {
    this.bindUserEvents(), this.options.responsive ? this.bindResponsiveEvents() : this.attached = !0;
  }
  bindUserEvents() {
    const e = this._listeners, n = this.platform, r = (i, s) => {
      n.addEventListener(this, i, s), e[i] = s;
    }, o = (i, s, a) => {
      i.offsetX = s, i.offsetY = a, this._eventHandler(i);
    };
    On(this.options.events, (i) => r(i, o));
  }
  bindResponsiveEvents() {
    this._responsiveListeners || (this._responsiveListeners = {});
    const e = this._responsiveListeners, n = this.platform, r = (l, c) => {
      n.addEventListener(this, l, c), e[l] = c;
    }, o = (l, c) => {
      e[l] && (n.removeEventListener(this, l, c), delete e[l]);
    }, i = (l, c) => {
      this.canvas && this.resize(l, c);
    };
    let s;
    const a = () => {
      o("attach", a), this.attached = !0, this.resize(), r("resize", i), r("detach", s);
    };
    s = () => {
      this.attached = !1, o("resize", i), this._stop(), this._resize(0, 0), r("attach", a);
    }, n.isAttached(this.canvas) ? a() : s();
  }
  unbindEvents() {
    On(this._listeners, (e, n) => {
      this.platform.removeEventListener(this, n, e);
    }), this._listeners = {}, On(this._responsiveListeners, (e, n) => {
      this.platform.removeEventListener(this, n, e);
    }), this._responsiveListeners = void 0;
  }
  updateHoverStyle(e, n, r) {
    const o = r ? "set" : "remove";
    let i, s, a, l;
    for (n === "dataset" && (i = this.getDatasetMeta(e[0].datasetIndex), i.controller["_" + o + "DatasetHoverStyle"]()), a = 0, l = e.length; a < l; ++a) {
      s = e[a];
      const c = s && this.getDatasetMeta(s.datasetIndex).controller;
      c && c[o + "HoverStyle"](s.element, s.datasetIndex, s.index);
    }
  }
  getActiveElements() {
    return this._active || [];
  }
  setActiveElements(e) {
    const n = this._active || [], r = e.map(({ datasetIndex: o, index: i }) => {
      const s = this.getDatasetMeta(o);
      if (!s)
        throw new Error("No dataset found at index " + o);
      return {
        datasetIndex: o,
        element: s.data[i],
        index: i
      };
    });
    !rE(r, n) && (this._active = r, this._lastEvent = null, this._updateHoverStyles(r, n));
  }
  notifyPlugins(e, n, r) {
    return this._plugins.notify(this, e, n, r);
  }
  isPluginEnabled(e) {
    return this._plugins._cache.filter((n) => n.plugin.id === e).length === 1;
  }
  _updateHoverStyles(e, n, r) {
    const o = this.options.hover, i = (l, c) => l.filter((u) => !c.some((d) => u.datasetIndex === d.datasetIndex && u.index === d.index)), s = i(n, e), a = r ? e : i(e, n);
    s.length && this.updateHoverStyle(s, o.mode, !1), a.length && o.mode && this.updateHoverStyle(a, o.mode, !0);
  }
  _eventHandler(e, n) {
    const r = {
      event: e,
      replay: n,
      cancelable: !0,
      inChartArea: this.isPointInArea(e)
    }, o = (s) => (s.options.events || this.options.events).includes(e.native.type);
    if (this.notifyPlugins("beforeEvent", r, o) === !1)
      return;
    const i = this._handleEvent(e, n, r.inChartArea);
    return r.cancelable = !1, this.notifyPlugins("afterEvent", r, o), (i || r.changed) && this.render(), this;
  }
  _handleEvent(e, n, r) {
    const { _active: o = [], options: i } = this, s = n, a = this._getActiveElements(e, o, r, s), l = OQe(e), c = xet(e, this._lastEvent, r, l);
    r && (this._lastEvent = null, Wn(i.onHover, [
      e,
      a,
      this
    ], this), l && Wn(i.onClick, [
      e,
      a,
      this
    ], this));
    const u = !rE(a, o);
    return (u || n) && (this._active = a, this._updateHoverStyles(a, o, n)), this._lastEvent = c, u;
  }
  _getActiveElements(e, n, r, o) {
    if (e.type === "mouseout")
      return [];
    if (!r)
      return n;
    const i = this.options.hover;
    return this.getElementsAtEventForMode(e, i.mode, i, o);
  }
};
ue(wc, "defaults", wr), ue(wc, "instances", cE), ue(wc, "overrides", Ld), ue(wc, "registry", ea), ue(wc, "version", vet), ue(wc, "getChart", Ume);
function pH() {
  return On(wc.instances, (t) => t._plugins.invalidate());
}
function Eet(t, e, n) {
  const { startAngle: r, x: o, y: i, outerRadius: s, innerRadius: a, options: l } = e, { borderWidth: c, borderJoinStyle: u } = l, d = Math.min(c / s, di(r - n));
  if (t.beginPath(), t.arc(o, i, s - c / 2, r + d / 2, n - d / 2), a > 0) {
    const f = Math.min(c / a, di(r - n));
    t.arc(o, i, a + c / 2, n - f / 2, r + f / 2, !0);
  } else {
    const f = Math.min(c / 2, s * di(r - n));
    if (u === "round")
      t.arc(o, i, f, n - An / 2, r + An / 2, !0);
    else if (u === "bevel") {
      const h = 2 * f * f, p = -h * Math.cos(n + An / 2) + o, m = -h * Math.sin(n + An / 2) + i, g = h * Math.cos(r + An / 2) + o, y = h * Math.sin(r + An / 2) + i;
      t.lineTo(p, m), t.lineTo(g, y);
    }
  }
  t.closePath(), t.moveTo(0, 0), t.rect(0, 0, t.canvas.width, t.canvas.height), t.clip("evenodd");
}
function Oet(t, e, n) {
  const { startAngle: r, pixelMargin: o, x: i, y: s, outerRadius: a, innerRadius: l } = e;
  let c = o / a;
  t.beginPath(), t.arc(i, s, a, r - c, n + c), l > o ? (c = o / l, t.arc(i, s, l, n + c, r - c, !0)) : t.arc(i, s, o, n + Ir, r - Ir), t.closePath(), t.clip();
}
function Cet(t) {
  return l4(t, [
    "outerStart",
    "outerEnd",
    "innerStart",
    "innerEnd"
  ]);
}
function ket(t, e, n, r) {
  const o = Cet(t.options.borderRadius), i = (n - e) / 2, s = Math.min(i, r * e / 2), a = (l) => {
    const c = (n - Math.min(i, l)) * r / 2;
    return co(l, 0, Math.min(i, c));
  };
  return {
    outerStart: a(o.outerStart),
    outerEnd: a(o.outerEnd),
    innerStart: co(o.innerStart, 0, s),
    innerEnd: co(o.innerEnd, 0, s)
  };
}
function Sf(t, e, n, r) {
  return {
    x: n + t * Math.cos(e),
    y: r + t * Math.sin(e)
  };
}
function uE(t, e, n, r, o, i) {
  const { x: s, y: a, startAngle: l, pixelMargin: c, innerRadius: u } = e, d = Math.max(e.outerRadius + r + n - c, 0), f = u > 0 ? u + r + n + c : 0;
  let h = 0;
  const p = o - l;
  if (r) {
    const k = u > 0 ? u - r : 0, T = d > 0 ? d - r : 0, I = (k + T) / 2, j = I !== 0 ? p * I / (I + r) : p;
    h = (p - j) / 2;
  }
  const m = Math.max(1e-3, p * d - n / An) / d, g = (p - m) / 2, y = l + g + h, v = o - g - h, { outerStart: b, outerEnd: _, innerStart: w, innerEnd: x } = ket(e, f, d, v - y), E = d - b, S = d - _, C = y + b / E, R = v - _ / S, P = f + w, N = f + x, A = y + w / P, O = v - x / N;
  if (t.beginPath(), i) {
    const k = (C + R) / 2;
    if (t.arc(s, a, d, C, k), t.arc(s, a, d, k, R), _ > 0) {
      const z = Sf(S, R, s, a);
      t.arc(z.x, z.y, _, R, v + Ir);
    }
    const T = Sf(N, v, s, a);
    if (t.lineTo(T.x, T.y), x > 0) {
      const z = Sf(N, O, s, a);
      t.arc(z.x, z.y, x, v + Ir, O + Math.PI);
    }
    const I = (v - x / f + (y + w / f)) / 2;
    if (t.arc(s, a, f, v - x / f, I, !0), t.arc(s, a, f, I, y + w / f, !0), w > 0) {
      const z = Sf(P, A, s, a);
      t.arc(z.x, z.y, w, A + Math.PI, y - Ir);
    }
    const j = Sf(E, y, s, a);
    if (t.lineTo(j.x, j.y), b > 0) {
      const z = Sf(E, C, s, a);
      t.arc(z.x, z.y, b, y - Ir, C);
    }
  } else {
    t.moveTo(s, a);
    const k = Math.cos(C) * d + s, T = Math.sin(C) * d + a;
    t.lineTo(k, T);
    const I = Math.cos(R) * d + s, j = Math.sin(R) * d + a;
    t.lineTo(I, j);
  }
  t.closePath();
}
function Aet(t, e, n, r, o) {
  const { fullCircles: i, startAngle: s, circumference: a } = e;
  let l = e.endAngle;
  if (i) {
    uE(t, e, n, r, l, o);
    for (let c = 0; c < i; ++c)
      t.fill();
    isNaN(a) || (l = s + (a % ar || ar));
  }
  return uE(t, e, n, r, l, o), t.fill(), l;
}
function Tet(t, e, n, r, o) {
  const { fullCircles: i, startAngle: s, circumference: a, options: l } = e, { borderWidth: c, borderJoinStyle: u, borderDash: d, borderDashOffset: f, borderRadius: h } = l, p = l.borderAlign === "inner";
  if (!c)
    return;
  t.setLineDash(d || []), t.lineDashOffset = f, p ? (t.lineWidth = c * 2, t.lineJoin = u || "round") : (t.lineWidth = c, t.lineJoin = u || "bevel");
  let m = e.endAngle;
  if (i) {
    uE(t, e, n, r, m, o);
    for (let g = 0; g < i; ++g)
      t.stroke();
    isNaN(a) || (m = s + (a % ar || ar));
  }
  p && Oet(t, e, m), l.selfJoin && m - s >= An && h === 0 && u !== "miter" && Eet(t, e, m), i || (uE(t, e, n, r, m, o), t.stroke());
}
class Tg extends Vl {
  constructor(e) {
    super(), ue(this, "circumference"), ue(this, "endAngle"), ue(this, "fullCircles"), ue(this, "innerRadius"), ue(this, "outerRadius"), ue(this, "pixelMargin"), ue(this, "startAngle"), this.options = void 0, this.circumference = void 0, this.startAngle = void 0, this.endAngle = void 0, this.innerRadius = void 0, this.outerRadius = void 0, this.pixelMargin = 0, this.fullCircles = 0, e && Object.assign(this, e);
  }
  inRange(e, n, r) {
    const o = this.getProps([
      "x",
      "y"
    ], r), { angle: i, distance: s } = fme(o, {
      x: e,
      y: n
    }), { startAngle: a, endAngle: l, innerRadius: c, outerRadius: u, circumference: d } = this.getProps([
      "startAngle",
      "endAngle",
      "innerRadius",
      "outerRadius",
      "circumference"
    ], r), f = (this.options.spacing + this.options.borderWidth) / 2, h = Tt(d, l - a), p = by(i, a, l) && a !== l, m = h >= ar || p, g = El(s, c + f, u + f);
    return m && g;
  }
  getCenterPoint(e) {
    const { x: n, y: r, startAngle: o, endAngle: i, innerRadius: s, outerRadius: a } = this.getProps([
      "x",
      "y",
      "startAngle",
      "endAngle",
      "innerRadius",
      "outerRadius"
    ], e), { offset: l, spacing: c } = this.options, u = (o + i) / 2, d = (s + a + c + l) / 2;
    return {
      x: n + Math.cos(u) * d,
      y: r + Math.sin(u) * d
    };
  }
  tooltipPosition(e) {
    return this.getCenterPoint(e);
  }
  draw(e) {
    const { options: n, circumference: r } = this, o = (n.offset || 0) / 4, i = (n.spacing || 0) / 2, s = n.circular;
    if (this.pixelMargin = n.borderAlign === "inner" ? 0.33 : 0, this.fullCircles = r > ar ? Math.floor(r / ar) : 0, r === 0 || this.innerRadius < 0 || this.outerRadius < 0)
      return;
    e.save();
    const a = (this.startAngle + this.endAngle) / 2;
    e.translate(Math.cos(a) * o, Math.sin(a) * o);
    const l = 1 - Math.sin(Math.min(An, r || 0)), c = o * l;
    e.fillStyle = n.backgroundColor, e.strokeStyle = n.borderColor, Aet(e, this, c, i, s), Tet(e, this, c, i, s), e.restore();
  }
}
ue(Tg, "id", "arc"), ue(Tg, "defaults", {
  borderAlign: "center",
  borderColor: "#fff",
  borderDash: [],
  borderDashOffset: 0,
  borderJoinStyle: void 0,
  borderRadius: 0,
  borderWidth: 2,
  offset: 0,
  spacing: 0,
  angle: void 0,
  circular: !0,
  selfJoin: !1
}), ue(Tg, "defaultRoutes", {
  backgroundColor: "backgroundColor"
}), ue(Tg, "descriptors", {
  _scriptable: !0,
  _indexable: (t) => t !== "borderDash"
});
function Hme(t, e, n = e) {
  t.lineCap = Tt(n.borderCapStyle, e.borderCapStyle), t.setLineDash(Tt(n.borderDash, e.borderDash)), t.lineDashOffset = Tt(n.borderDashOffset, e.borderDashOffset), t.lineJoin = Tt(n.borderJoinStyle, e.borderJoinStyle), t.lineWidth = Tt(n.borderWidth, e.borderWidth), t.strokeStyle = Tt(n.borderColor, e.borderColor);
}
function Ret(t, e, n) {
  t.lineTo(n.x, n.y);
}
function Pet(t) {
  return t.stepped ? ZQe : t.tension || t.cubicInterpolationMode === "monotone" ? JQe : Ret;
}
function Vme(t, e, n = {}) {
  const r = t.length, { start: o = 0, end: i = r - 1 } = n, { start: s, end: a } = e, l = Math.max(o, s), c = Math.min(i, a), u = o < s && i < s || o > a && i > a;
  return {
    count: r,
    start: l,
    loop: e.loop,
    ilen: c < l && !u ? r + c - l : c - l
  };
}
function $et(t, e, n, r) {
  const { points: o, options: i } = e, { count: s, start: a, loop: l, ilen: c } = Vme(o, n, r), u = Pet(i);
  let { move: d = !0, reverse: f } = r || {}, h, p, m;
  for (h = 0; h <= c; ++h)
    p = o[(a + (f ? c - h : h)) % s], !p.skip && (d ? (t.moveTo(p.x, p.y), d = !1) : u(t, m, p, f, i.stepped), m = p);
  return l && (p = o[(a + (f ? c : 0)) % s], u(t, m, p, f, i.stepped)), !!l;
}
function Met(t, e, n, r) {
  const o = e.points, { count: i, start: s, ilen: a } = Vme(o, n, r), { move: l = !0, reverse: c } = r || {};
  let u = 0, d = 0, f, h, p, m, g, y;
  const v = (_) => (s + (c ? a - _ : _)) % i, b = () => {
    m !== g && (t.lineTo(u, g), t.lineTo(u, m), t.lineTo(u, y));
  };
  for (l && (h = o[v(0)], t.moveTo(h.x, h.y)), f = 0; f <= a; ++f) {
    if (h = o[v(f)], h.skip)
      continue;
    const _ = h.x, w = h.y, x = _ | 0;
    x === p ? (w < m ? m = w : w > g && (g = w), u = (d * u + _) / ++d) : (b(), t.lineTo(_, w), p = x, d = 0, m = g = w), y = w;
  }
  b();
}
function fj(t) {
  const e = t.options, n = e.borderDash && e.borderDash.length;
  return !t._decimated && !t._loop && !e.tension && e.cubicInterpolationMode !== "monotone" && !e.stepped && !n ? Met : $et;
}
function Det(t) {
  return t.stepped ? PZe : t.tension || t.cubicInterpolationMode === "monotone" ? $Ze : qu;
}
function Iet(t, e, n, r) {
  let o = e._path;
  o || (o = e._path = new Path2D(), e.path(o, n, r) && o.closePath()), Hme(t, e.options), t.stroke(o);
}
function Net(t, e, n, r) {
  const { segments: o, options: i } = e, s = fj(e);
  for (const a of o)
    Hme(t, i, a.style), t.beginPath(), s(t, e, a, {
      start: n,
      end: n + r - 1
    }) && t.closePath(), t.stroke();
}
const jet = typeof Path2D == "function";
function Let(t, e, n, r) {
  jet && !e.options.segment ? Iet(t, e, n, r) : Net(t, e, n, r);
}
class jc extends Vl {
  constructor(e) {
    super(), this.animated = !0, this.options = void 0, this._chart = void 0, this._loop = void 0, this._fullLoop = void 0, this._path = void 0, this._points = void 0, this._segments = void 0, this._decimated = !1, this._pointsUpdated = !1, this._datasetIndex = void 0, e && Object.assign(this, e);
  }
  updateControlPoints(e, n) {
    const r = this.options;
    if ((r.tension || r.cubicInterpolationMode === "monotone") && !r.stepped && !this._pointsUpdated) {
      const o = r.spanGaps ? this._loop : this._fullLoop;
      EZe(this._points, r, e, o, n), this._pointsUpdated = !0;
    }
  }
  set points(e) {
    this._points = e, delete this._segments, delete this._path, this._pointsUpdated = !1;
  }
  get points() {
    return this._points;
  }
  get segments() {
    return this._segments || (this._segments = LZe(this, this.options.segment));
  }
  first() {
    const e = this.segments, n = this.points;
    return e.length && n[e[0].start];
  }
  last() {
    const e = this.segments, n = this.points, r = e.length;
    return r && n[e[r - 1].end];
  }
  interpolate(e, n) {
    const r = this.options, o = e[n], i = this.points, s = Tme(this, {
      property: n,
      start: o,
      end: o
    });
    if (!s.length)
      return;
    const a = [], l = Det(r);
    let c, u;
    for (c = 0, u = s.length; c < u; ++c) {
      const { start: d, end: f } = s[c], h = i[d], p = i[f];
      if (h === p) {
        a.push(h);
        continue;
      }
      const m = Math.abs((o - h[n]) / (p[n] - h[n])), g = l(h, p, m, r.stepped);
      g[n] = e[n], a.push(g);
    }
    return a.length === 1 ? a[0] : a;
  }
  pathSegment(e, n, r) {
    return fj(this)(e, this, n, r);
  }
  path(e, n, r) {
    const o = this.segments, i = fj(this);
    let s = this._loop;
    n = n || 0, r = r || this.points.length - n;
    for (const a of o)
      s &= i(e, this, a, {
        start: n,
        end: n + r - 1
      });
    return !!s;
  }
  draw(e, n, r, o) {
    const i = this.options || {};
    (this.points || []).length && i.borderWidth && (e.save(), Let(e, this, r, o), e.restore()), this.animated && (this._pointsUpdated = !1, this._path = void 0);
  }
}
ue(jc, "id", "line"), ue(jc, "defaults", {
  borderCapStyle: "butt",
  borderDash: [],
  borderDashOffset: 0,
  borderJoinStyle: "miter",
  borderWidth: 3,
  capBezierPoints: !0,
  cubicInterpolationMode: "default",
  fill: !1,
  spanGaps: !1,
  stepped: !1,
  tension: 0
}), ue(jc, "defaultRoutes", {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
}), ue(jc, "descriptors", {
  _scriptable: !0,
  _indexable: (t) => t !== "borderDash" && t !== "fill"
});
function mH(t, e, n, r) {
  const o = t.options, { [n]: i } = t.getProps([
    n
  ], r);
  return Math.abs(e - i) < o.radius + o.hitRadius;
}
class Tw extends Vl {
  constructor(e) {
    super(), ue(this, "parsed"), ue(this, "skip"), ue(this, "stop"), this.options = void 0, this.parsed = void 0, this.skip = void 0, this.stop = void 0, e && Object.assign(this, e);
  }
  inRange(e, n, r) {
    const o = this.options, { x: i, y: s } = this.getProps([
      "x",
      "y"
    ], r);
    return Math.pow(e - i, 2) + Math.pow(n - s, 2) < Math.pow(o.hitRadius + o.radius, 2);
  }
  inXRange(e, n) {
    return mH(this, e, "x", n);
  }
  inYRange(e, n) {
    return mH(this, e, "y", n);
  }
  getCenterPoint(e) {
    const { x: n, y: r } = this.getProps([
      "x",
      "y"
    ], e);
    return {
      x: n,
      y: r
    };
  }
  size(e) {
    e = e || this.options || {};
    let n = e.radius || 0;
    n = Math.max(n, n && e.hoverRadius || 0);
    const r = n && e.borderWidth || 0;
    return (n + r) * 2;
  }
  draw(e, n) {
    const r = this.options;
    this.skip || r.radius < 0.1 || !_y(this, n, this.size(r) / 2) || (e.strokeStyle = r.borderColor, e.lineWidth = r.borderWidth, e.fillStyle = r.backgroundColor, cj(e, r, this.x, this.y));
  }
  getRange() {
    const e = this.options || {};
    return e.radius + e.hitRadius;
  }
}
ue(Tw, "id", "point"), /**
* @type {any}
*/
ue(Tw, "defaults", {
  borderWidth: 1,
  hitRadius: 1,
  hoverBorderWidth: 1,
  hoverRadius: 4,
  pointStyle: "circle",
  radius: 3,
  rotation: 0
}), /**
* @type {any}
*/
ue(Tw, "defaultRoutes", {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
});
function Wme(t, e) {
  const { x: n, y: r, base: o, width: i, height: s } = t.getProps([
    "x",
    "y",
    "base",
    "width",
    "height"
  ], e);
  let a, l, c, u, d;
  return t.horizontal ? (d = s / 2, a = Math.min(n, o), l = Math.max(n, o), c = r - d, u = r + d) : (d = i / 2, a = n - d, l = n + d, c = Math.min(r, o), u = Math.max(r, o)), {
    left: a,
    top: c,
    right: l,
    bottom: u
  };
}
function Lc(t, e, n, r) {
  return t ? 0 : co(e, n, r);
}
function Fet(t, e, n) {
  const r = t.options.borderWidth, o = t.borderSkipped, i = bme(r);
  return {
    t: Lc(o.top, i.top, 0, n),
    r: Lc(o.right, i.right, 0, e),
    b: Lc(o.bottom, i.bottom, 0, n),
    l: Lc(o.left, i.left, 0, e)
  };
}
function Bet(t, e, n) {
  const { enableBorderRadius: r } = t.getProps([
    "enableBorderRadius"
  ]), o = t.options.borderRadius, i = Sh(o), s = Math.min(e, n), a = t.borderSkipped, l = r || Bt(o);
  return {
    topLeft: Lc(!l || a.top || a.left, i.topLeft, 0, s),
    topRight: Lc(!l || a.top || a.right, i.topRight, 0, s),
    bottomLeft: Lc(!l || a.bottom || a.left, i.bottomLeft, 0, s),
    bottomRight: Lc(!l || a.bottom || a.right, i.bottomRight, 0, s)
  };
}
function zet(t) {
  const e = Wme(t), n = e.right - e.left, r = e.bottom - e.top, o = Fet(t, n / 2, r / 2), i = Bet(t, n / 2, r / 2);
  return {
    outer: {
      x: e.left,
      y: e.top,
      w: n,
      h: r,
      radius: i
    },
    inner: {
      x: e.left + o.l,
      y: e.top + o.t,
      w: n - o.l - o.r,
      h: r - o.t - o.b,
      radius: {
        topLeft: Math.max(0, i.topLeft - Math.max(o.t, o.l)),
        topRight: Math.max(0, i.topRight - Math.max(o.t, o.r)),
        bottomLeft: Math.max(0, i.bottomLeft - Math.max(o.b, o.l)),
        bottomRight: Math.max(0, i.bottomRight - Math.max(o.b, o.r))
      }
    }
  };
}
function o2(t, e, n, r) {
  const o = e === null, i = n === null, s = t && !(o && i) && Wme(t, r);
  return s && (o || El(e, s.left, s.right)) && (i || El(n, s.top, s.bottom));
}
function qet(t) {
  return t.topLeft || t.topRight || t.bottomLeft || t.bottomRight;
}
function Uet(t, e) {
  t.rect(e.x, e.y, e.w, e.h);
}
function i2(t, e, n = {}) {
  const r = t.x !== n.x ? -e : 0, o = t.y !== n.y ? -e : 0, i = (t.x + t.w !== n.x + n.w ? e : 0) - r, s = (t.y + t.h !== n.y + n.h ? e : 0) - o;
  return {
    x: t.x + r,
    y: t.y + o,
    w: t.w + i,
    h: t.h + s,
    radius: t.radius
  };
}
class Rw extends Vl {
  constructor(e) {
    super(), this.options = void 0, this.horizontal = void 0, this.base = void 0, this.width = void 0, this.height = void 0, this.inflateAmount = void 0, e && Object.assign(this, e);
  }
  draw(e) {
    const { inflateAmount: n, options: { borderColor: r, backgroundColor: o } } = this, { inner: i, outer: s } = zet(this), a = qet(s.radius) ? sE : Uet;
    e.save(), (s.w !== i.w || s.h !== i.h) && (e.beginPath(), a(e, i2(s, n, i)), e.clip(), a(e, i2(i, -n, s)), e.fillStyle = r, e.fill("evenodd")), e.beginPath(), a(e, i2(i, n)), e.fillStyle = o, e.fill(), e.restore();
  }
  inRange(e, n, r) {
    return o2(this, e, n, r);
  }
  inXRange(e, n) {
    return o2(this, e, null, n);
  }
  inYRange(e, n) {
    return o2(this, null, e, n);
  }
  getCenterPoint(e) {
    const { x: n, y: r, base: o, horizontal: i } = this.getProps([
      "x",
      "y",
      "base",
      "horizontal"
    ], e);
    return {
      x: i ? (n + o) / 2 : n,
      y: i ? r : (r + o) / 2
    };
  }
  getRange(e) {
    return e === "x" ? this.width / 2 : this.height / 2;
  }
}
ue(Rw, "id", "bar"), ue(Rw, "defaults", {
  borderSkipped: "start",
  borderWidth: 0,
  borderRadius: 0,
  inflateAmount: "auto",
  pointStyle: void 0
}), ue(Rw, "defaultRoutes", {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
});
function Het(t, e, n) {
  const r = t.segments, o = t.points, i = e.points, s = [];
  for (const a of r) {
    let { start: l, end: c } = a;
    c = ZS(l, c, o);
    const u = hj(n, o[l], o[c], a.loop);
    if (!e.segments) {
      s.push({
        source: a,
        target: u,
        start: o[l],
        end: o[c]
      });
      continue;
    }
    const d = Tme(e, u);
    for (const f of d) {
      const h = hj(n, i[f.start], i[f.end], f.loop), p = Ame(a, o, h);
      for (const m of p)
        s.push({
          source: m,
          target: f,
          start: {
            [n]: gH(u, h, "start", Math.max)
          },
          end: {
            [n]: gH(u, h, "end", Math.min)
          }
        });
    }
  }
  return s;
}
function hj(t, e, n, r) {
  if (r)
    return;
  let o = e[t], i = n[t];
  return t === "angle" && (o = di(o), i = di(i)), {
    property: t,
    start: o,
    end: i
  };
}
function Vet(t, e) {
  const { x: n = null, y: r = null } = t || {}, o = e.points, i = [];
  return e.segments.forEach(({ start: s, end: a }) => {
    a = ZS(s, a, o);
    const l = o[s], c = o[a];
    r !== null ? (i.push({
      x: l.x,
      y: r
    }), i.push({
      x: c.x,
      y: r
    })) : n !== null && (i.push({
      x: n,
      y: l.y
    }), i.push({
      x: n,
      y: c.y
    }));
  }), i;
}
function ZS(t, e, n) {
  for (; e > t; e--) {
    const r = n[e];
    if (!isNaN(r.x) && !isNaN(r.y))
      break;
  }
  return e;
}
function gH(t, e, n, r) {
  return t && e ? r(t[n], e[n]) : t ? t[n] : e ? e[n] : 0;
}
function Gme(t, e) {
  let n = [], r = !1;
  return Cr(t) ? (r = !0, n = t) : n = Vet(t, e), n.length ? new jc({
    points: n,
    options: {
      tension: 0
    },
    _loop: r,
    _fullLoop: r
  }) : null;
}
function yH(t) {
  return t && t.fill !== !1;
}
function Wet(t, e, n) {
  let r = t[e].fill;
  const o = [
    e
  ];
  let i;
  if (!n)
    return r;
  for (; r !== !1 && o.indexOf(r) === -1; ) {
    if (!po(r))
      return r;
    if (i = t[r], !i)
      return !1;
    if (i.visible)
      return r;
    o.push(r), r = i.fill;
  }
  return !1;
}
function Get(t, e, n) {
  const r = Qet(t);
  if (Bt(r))
    return isNaN(r.value) ? !1 : r;
  let o = parseFloat(r);
  return po(o) && Math.floor(o) === o ? Yet(r[0], e, o, n) : [
    "origin",
    "start",
    "end",
    "stack",
    "shape"
  ].indexOf(r) >= 0 && r;
}
function Yet(t, e, n, r) {
  return (t === "-" || t === "+") && (n = e + n), n === e || n < 0 || n >= r ? !1 : n;
}
function Ket(t, e) {
  let n = null;
  return t === "start" ? n = e.bottom : t === "end" ? n = e.top : Bt(t) ? n = e.getPixelForValue(t.value) : e.getBasePixel && (n = e.getBasePixel()), n;
}
function Xet(t, e, n) {
  let r;
  return t === "start" ? r = n : t === "end" ? r = e.options.reverse ? e.min : e.max : Bt(t) ? r = t.value : r = e.getBaseValue(), r;
}
function Qet(t) {
  const e = t.options, n = e.fill;
  let r = Tt(n && n.target, n);
  return r === void 0 && (r = !!e.backgroundColor), r === !1 || r === null ? !1 : r === !0 ? "origin" : r;
}
function Zet(t) {
  const { scale: e, index: n, line: r } = t, o = [], i = r.segments, s = r.points, a = Jet(e, n);
  a.push(Gme({
    x: null,
    y: e.bottom
  }, r));
  for (let l = 0; l < i.length; l++) {
    const c = i[l];
    for (let u = c.start; u <= c.end; u++)
      ett(o, s[u], a);
  }
  return new jc({
    points: o,
    options: {}
  });
}
function Jet(t, e) {
  const n = [], r = t.getMatchingVisibleMetas("line");
  for (let o = 0; o < r.length; o++) {
    const i = r[o];
    if (i.index === e)
      break;
    i.hidden || n.unshift(i.dataset);
  }
  return n;
}
function ett(t, e, n) {
  const r = [];
  for (let o = 0; o < n.length; o++) {
    const i = n[o], { first: s, last: a, point: l } = ttt(i, e, "x");
    if (!(!l || s && a)) {
      if (s)
        r.unshift(l);
      else if (t.push(l), !a)
        break;
    }
  }
  t.push(...r);
}
function ttt(t, e, n) {
  const r = t.interpolate(e, n);
  if (!r)
    return {};
  const o = r[n], i = t.segments, s = t.points;
  let a = !1, l = !1;
  for (let c = 0; c < i.length; c++) {
    const u = i[c], d = s[u.start][n], f = s[u.end][n];
    if (El(o, d, f)) {
      a = o === d, l = o === f;
      break;
    }
  }
  return {
    first: a,
    last: l,
    point: r
  };
}
class Yme {
  constructor(e) {
    this.x = e.x, this.y = e.y, this.radius = e.radius;
  }
  pathSegment(e, n, r) {
    const { x: o, y: i, radius: s } = this;
    return n = n || {
      start: 0,
      end: ar
    }, e.arc(o, i, s, n.end, n.start, !0), !r.bounds;
  }
  interpolate(e) {
    const { x: n, y: r, radius: o } = this, i = e.angle;
    return {
      x: n + Math.cos(i) * o,
      y: r + Math.sin(i) * o,
      angle: i
    };
  }
}
function ntt(t) {
  const { chart: e, fill: n, line: r } = t;
  if (po(n))
    return rtt(e, n);
  if (n === "stack")
    return Zet(t);
  if (n === "shape")
    return !0;
  const o = ott(t);
  return o instanceof Yme ? o : Gme(o, r);
}
function rtt(t, e) {
  const n = t.getDatasetMeta(e);
  return n && t.isDatasetVisible(e) ? n.dataset : null;
}
function ott(t) {
  return (t.scale || {}).getPointPositionForValue ? stt(t) : itt(t);
}
function itt(t) {
  const { scale: e = {}, fill: n } = t, r = Ket(n, e);
  if (po(r)) {
    const o = e.isHorizontal();
    return {
      x: o ? r : null,
      y: o ? null : r
    };
  }
  return null;
}
function stt(t) {
  const { scale: e, fill: n } = t, r = e.options, o = e.getLabels().length, i = r.reverse ? e.max : e.min, s = Xet(n, e, i), a = [];
  if (r.grid.circular) {
    const l = e.getPointPositionForValue(0, i);
    return new Yme({
      x: l.x,
      y: l.y,
      radius: e.getDistanceFromCenterForValue(s)
    });
  }
  for (let l = 0; l < o; ++l)
    a.push(e.getPointPositionForValue(l, s));
  return a;
}
function s2(t, e, n) {
  const r = ntt(e), { chart: o, index: i, line: s, scale: a, axis: l } = e, c = s.options, u = c.fill, d = c.backgroundColor, { above: f = d, below: h = d } = u || {}, p = o.getDatasetMeta(i), m = Rme(o, p);
  r && s.points.length && (YS(t, n), att(t, {
    line: s,
    target: r,
    above: f,
    below: h,
    area: n,
    scale: a,
    axis: l,
    clip: m
  }), KS(t));
}
function att(t, e) {
  const { line: n, target: r, above: o, below: i, area: s, scale: a, clip: l } = e, c = n._loop ? "angle" : e.axis;
  t.save();
  let u = i;
  i !== o && (c === "x" ? (vH(t, r, s.top), a2(t, {
    line: n,
    target: r,
    color: o,
    scale: a,
    property: c,
    clip: l
  }), t.restore(), t.save(), vH(t, r, s.bottom)) : c === "y" && (bH(t, r, s.left), a2(t, {
    line: n,
    target: r,
    color: i,
    scale: a,
    property: c,
    clip: l
  }), t.restore(), t.save(), bH(t, r, s.right), u = o)), a2(t, {
    line: n,
    target: r,
    color: u,
    scale: a,
    property: c,
    clip: l
  }), t.restore();
}
function vH(t, e, n) {
  const { segments: r, points: o } = e;
  let i = !0, s = !1;
  t.beginPath();
  for (const a of r) {
    const { start: l, end: c } = a, u = o[l], d = o[ZS(l, c, o)];
    i ? (t.moveTo(u.x, u.y), i = !1) : (t.lineTo(u.x, n), t.lineTo(u.x, u.y)), s = !!e.pathSegment(t, a, {
      move: s
    }), s ? t.closePath() : t.lineTo(d.x, n);
  }
  t.lineTo(e.first().x, n), t.closePath(), t.clip();
}
function bH(t, e, n) {
  const { segments: r, points: o } = e;
  let i = !0, s = !1;
  t.beginPath();
  for (const a of r) {
    const { start: l, end: c } = a, u = o[l], d = o[ZS(l, c, o)];
    i ? (t.moveTo(u.x, u.y), i = !1) : (t.lineTo(n, u.y), t.lineTo(u.x, u.y)), s = !!e.pathSegment(t, a, {
      move: s
    }), s ? t.closePath() : t.lineTo(n, d.y);
  }
  t.lineTo(n, e.first().y), t.closePath(), t.clip();
}
function a2(t, e) {
  const { line: n, target: r, property: o, color: i, scale: s, clip: a } = e, l = Het(n, r, o);
  for (const { source: c, target: u, start: d, end: f } of l) {
    const { style: { backgroundColor: h = i } = {} } = c, p = r !== !0;
    t.save(), t.fillStyle = h, ltt(t, s, a, p && hj(o, d, f)), t.beginPath();
    const m = !!n.pathSegment(t, c);
    let g;
    if (p) {
      m ? t.closePath() : _H(t, r, f, o);
      const y = !!r.pathSegment(t, u, {
        move: m,
        reverse: !0
      });
      g = m && y, g || _H(t, r, d, o);
    }
    t.closePath(), t.fill(g ? "evenodd" : "nonzero"), t.restore();
  }
}
function ltt(t, e, n, r) {
  const o = e.chart.chartArea, { property: i, start: s, end: a } = r || {};
  if (i === "x" || i === "y") {
    let l, c, u, d;
    i === "x" ? (l = s, c = o.top, u = a, d = o.bottom) : (l = o.left, c = s, u = o.right, d = a), t.beginPath(), n && (l = Math.max(l, n.left), u = Math.min(u, n.right), c = Math.max(c, n.top), d = Math.min(d, n.bottom)), t.rect(l, c, u - l, d - c), t.clip();
  }
}
function _H(t, e, n, r) {
  const o = e.interpolate(n, r);
  o && t.lineTo(o.x, o.y);
}
var ctt = {
  id: "filler",
  afterDatasetsUpdate(t, e, n) {
    const r = (t.data.datasets || []).length, o = [];
    let i, s, a, l;
    for (s = 0; s < r; ++s)
      i = t.getDatasetMeta(s), a = i.dataset, l = null, a && a.options && a instanceof jc && (l = {
        visible: t.isDatasetVisible(s),
        index: s,
        fill: Get(a, s, r),
        chart: t,
        axis: i.controller.options.indexAxis,
        scale: i.vScale,
        line: a
      }), i.$filler = l, o.push(l);
    for (s = 0; s < r; ++s)
      l = o[s], !(!l || l.fill === !1) && (l.fill = Wet(o, s, n.propagate));
  },
  beforeDraw(t, e, n) {
    const r = n.drawTime === "beforeDraw", o = t.getSortedVisibleDatasetMetas(), i = t.chartArea;
    for (let s = o.length - 1; s >= 0; --s) {
      const a = o[s].$filler;
      a && (a.line.updateControlPoints(i, a.axis), r && a.fill && s2(t.ctx, a, i));
    }
  },
  beforeDatasetsDraw(t, e, n) {
    if (n.drawTime !== "beforeDatasetsDraw")
      return;
    const r = t.getSortedVisibleDatasetMetas();
    for (let o = r.length - 1; o >= 0; --o) {
      const i = r[o].$filler;
      yH(i) && s2(t.ctx, i, t.chartArea);
    }
  },
  beforeDatasetDraw(t, e, n) {
    const r = e.meta.$filler;
    !yH(r) || n.drawTime !== "beforeDatasetDraw" || s2(t.ctx, r, t.chartArea);
  },
  defaults: {
    propagate: !0,
    drawTime: "beforeDatasetDraw"
  }
};
const wH = (t, e) => {
  let { boxHeight: n = e, boxWidth: r = e } = t;
  return t.usePointStyle && (n = Math.min(n, e), r = t.pointStyleWidth || Math.min(r, e)), {
    boxWidth: r,
    boxHeight: n,
    itemHeight: Math.max(e, n)
  };
}, utt = (t, e) => t !== null && e !== null && t.datasetIndex === e.datasetIndex && t.index === e.index;
class xH extends Vl {
  constructor(e) {
    super(), this._added = !1, this.legendHitBoxes = [], this._hoveredItem = null, this.doughnutMode = !1, this.chart = e.chart, this.options = e.options, this.ctx = e.ctx, this.legendItems = void 0, this.columnSizes = void 0, this.lineWidths = void 0, this.maxHeight = void 0, this.maxWidth = void 0, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.height = void 0, this.width = void 0, this._margins = void 0, this.position = void 0, this.weight = void 0, this.fullSize = void 0;
  }
  update(e, n, r) {
    this.maxWidth = e, this.maxHeight = n, this._margins = r, this.setDimensions(), this.buildLabels(), this.fit();
  }
  setDimensions() {
    this.isHorizontal() ? (this.width = this.maxWidth, this.left = this._margins.left, this.right = this.width) : (this.height = this.maxHeight, this.top = this._margins.top, this.bottom = this.height);
  }
  buildLabels() {
    const e = this.options.labels || {};
    let n = Wn(e.generateLabels, [
      this.chart
    ], this) || [];
    e.filter && (n = n.filter((r) => e.filter(r, this.chart.data))), e.sort && (n = n.sort((r, o) => e.sort(r, o, this.chart.data))), this.options.reverse && n.reverse(), this.legendItems = n;
  }
  fit() {
    const { options: e, ctx: n } = this;
    if (!e.display) {
      this.width = this.height = 0;
      return;
    }
    const r = e.labels, o = uo(r.font), i = o.size, s = this._computeTitleHeight(), { boxWidth: a, itemHeight: l } = wH(r, i);
    let c, u;
    n.font = o.string, this.isHorizontal() ? (c = this.maxWidth, u = this._fitRows(s, i, a, l) + 10) : (u = this.maxHeight, c = this._fitCols(s, o, a, l) + 10), this.width = Math.min(c, e.maxWidth || this.maxWidth), this.height = Math.min(u, e.maxHeight || this.maxHeight);
  }
  _fitRows(e, n, r, o) {
    const { ctx: i, maxWidth: s, options: { labels: { padding: a } } } = this, l = this.legendHitBoxes = [], c = this.lineWidths = [
      0
    ], u = o + a;
    let d = e;
    i.textAlign = "left", i.textBaseline = "middle";
    let f = -1, h = -u;
    return this.legendItems.forEach((p, m) => {
      const g = r + n / 2 + i.measureText(p.text).width;
      (m === 0 || c[c.length - 1] + g + 2 * a > s) && (d += u, c[c.length - (m > 0 ? 0 : 1)] = 0, h += u, f++), l[m] = {
        left: 0,
        top: h,
        row: f,
        width: g,
        height: o
      }, c[c.length - 1] += g + a;
    }), d;
  }
  _fitCols(e, n, r, o) {
    const { ctx: i, maxHeight: s, options: { labels: { padding: a } } } = this, l = this.legendHitBoxes = [], c = this.columnSizes = [], u = s - e;
    let d = a, f = 0, h = 0, p = 0, m = 0;
    return this.legendItems.forEach((g, y) => {
      const { itemWidth: v, itemHeight: b } = dtt(r, n, i, g, o);
      y > 0 && h + b + 2 * a > u && (d += f + a, c.push({
        width: f,
        height: h
      }), p += f + a, m++, f = h = 0), l[y] = {
        left: p,
        top: h,
        col: m,
        width: v,
        height: b
      }, f = Math.max(f, v), h += b + a;
    }), d += f, c.push({
      width: f,
      height: h
    }), d;
  }
  adjustHitBoxes() {
    if (!this.options.display)
      return;
    const e = this._computeTitleHeight(), { legendHitBoxes: n, options: { align: r, labels: { padding: o }, rtl: i } } = this, s = Oh(i, this.left, this.width);
    if (this.isHorizontal()) {
      let a = 0, l = io(r, this.left + o, this.right - this.lineWidths[a]);
      for (const c of n)
        a !== c.row && (a = c.row, l = io(r, this.left + o, this.right - this.lineWidths[a])), c.top += this.top + e + o, c.left = s.leftForLtr(s.x(l), c.width), l += c.width + o;
    } else {
      let a = 0, l = io(r, this.top + e + o, this.bottom - this.columnSizes[a].height);
      for (const c of n)
        c.col !== a && (a = c.col, l = io(r, this.top + e + o, this.bottom - this.columnSizes[a].height)), c.top = l, c.left += this.left + o, c.left = s.leftForLtr(s.x(c.left), c.width), l += c.height + o;
    }
  }
  isHorizontal() {
    return this.options.position === "top" || this.options.position === "bottom";
  }
  draw() {
    if (this.options.display) {
      const e = this.ctx;
      YS(e, this), this._draw(), KS(e);
    }
  }
  _draw() {
    const { options: e, columnSizes: n, lineWidths: r, ctx: o } = this, { align: i, labels: s } = e, a = wr.color, l = Oh(e.rtl, this.left, this.width), c = uo(s.font), { padding: u } = s, d = c.size, f = d / 2;
    let h;
    this.drawTitle(), o.textAlign = l.textAlign("left"), o.textBaseline = "middle", o.lineWidth = 0.5, o.font = c.string;
    const { boxWidth: p, boxHeight: m, itemHeight: g } = wH(s, d), y = function(x, E, S) {
      if (isNaN(p) || p <= 0 || isNaN(m) || m < 0)
        return;
      o.save();
      const C = Tt(S.lineWidth, 1);
      if (o.fillStyle = Tt(S.fillStyle, a), o.lineCap = Tt(S.lineCap, "butt"), o.lineDashOffset = Tt(S.lineDashOffset, 0), o.lineJoin = Tt(S.lineJoin, "miter"), o.lineWidth = C, o.strokeStyle = Tt(S.strokeStyle, a), o.setLineDash(Tt(S.lineDash, [])), s.usePointStyle) {
        const R = {
          radius: m * Math.SQRT2 / 2,
          pointStyle: S.pointStyle,
          rotation: S.rotation,
          borderWidth: C
        }, P = l.xPlus(x, p / 2), N = E + f;
        vme(o, R, P, N, s.pointStyleWidth && p);
      } else {
        const R = E + Math.max((d - m) / 2, 0), P = l.leftForLtr(x, p), N = Sh(S.borderRadius);
        o.beginPath(), Object.values(N).some((A) => A !== 0) ? sE(o, {
          x: P,
          y: R,
          w: p,
          h: m,
          radius: N
        }) : o.rect(P, R, p, m), o.fill(), C !== 0 && o.stroke();
      }
      o.restore();
    }, v = function(x, E, S) {
      wy(o, S.text, x, E + g / 2, c, {
        strikethrough: S.hidden,
        textAlign: l.textAlign(S.textAlign)
      });
    }, b = this.isHorizontal(), _ = this._computeTitleHeight();
    b ? h = {
      x: io(i, this.left + u, this.right - r[0]),
      y: this.top + u + _,
      line: 0
    } : h = {
      x: this.left + u,
      y: io(i, this.top + _ + u, this.bottom - n[0].height),
      line: 0
    }, Ome(this.ctx, e.textDirection);
    const w = g + u;
    this.legendItems.forEach((x, E) => {
      o.strokeStyle = x.fontColor, o.fillStyle = x.fontColor;
      const S = o.measureText(x.text).width, C = l.textAlign(x.textAlign || (x.textAlign = s.textAlign)), R = p + f + S;
      let P = h.x, N = h.y;
      l.setWidth(this.width), b ? E > 0 && P + R + u > this.right && (N = h.y += w, h.line++, P = h.x = io(i, this.left + u, this.right - r[h.line])) : E > 0 && N + w > this.bottom && (P = h.x = P + n[h.line].width + u, h.line++, N = h.y = io(i, this.top + _ + u, this.bottom - n[h.line].height));
      const A = l.x(P);
      if (y(A, N, x), P = FQe(C, P + p + f, b ? P + R : this.right, e.rtl), v(l.x(P), N, x), b)
        h.x += R + u;
      else if (typeof x.text != "string") {
        const O = c.lineHeight;
        h.y += Kme(x, O) + u;
      } else
        h.y += w;
    }), Cme(this.ctx, e.textDirection);
  }
  drawTitle() {
    const e = this.options, n = e.title, r = uo(n.font), o = ns(n.padding);
    if (!n.display)
      return;
    const i = Oh(e.rtl, this.left, this.width), s = this.ctx, a = n.position, l = r.size / 2, c = o.top + l;
    let u, d = this.left, f = this.width;
    if (this.isHorizontal())
      f = Math.max(...this.lineWidths), u = this.top + c, d = io(e.align, d, this.right - f);
    else {
      const p = this.columnSizes.reduce((m, g) => Math.max(m, g.height), 0);
      u = c + io(e.align, this.top, this.bottom - p - e.labels.padding - this._computeTitleHeight());
    }
    const h = io(a, d, d + f);
    s.textAlign = i.textAlign(i4(a)), s.textBaseline = "middle", s.strokeStyle = n.color, s.fillStyle = n.color, s.font = r.string, wy(s, n.text, h, u, r);
  }
  _computeTitleHeight() {
    const e = this.options.title, n = uo(e.font), r = ns(e.padding);
    return e.display ? n.lineHeight + r.height : 0;
  }
  _getLegendItemAt(e, n) {
    let r, o, i;
    if (El(e, this.left, this.right) && El(n, this.top, this.bottom)) {
      for (i = this.legendHitBoxes, r = 0; r < i.length; ++r)
        if (o = i[r], El(e, o.left, o.left + o.width) && El(n, o.top, o.top + o.height))
          return this.legendItems[r];
    }
    return null;
  }
  handleEvent(e) {
    const n = this.options;
    if (!ptt(e.type, n))
      return;
    const r = this._getLegendItemAt(e.x, e.y);
    if (e.type === "mousemove" || e.type === "mouseout") {
      const o = this._hoveredItem, i = utt(o, r);
      o && !i && Wn(n.onLeave, [
        e,
        o,
        this
      ], this), this._hoveredItem = r, r && !i && Wn(n.onHover, [
        e,
        r,
        this
      ], this);
    } else r && Wn(n.onClick, [
      e,
      r,
      this
    ], this);
  }
}
function dtt(t, e, n, r, o) {
  const i = ftt(r, t, e, n), s = htt(o, r, e.lineHeight);
  return {
    itemWidth: i,
    itemHeight: s
  };
}
function ftt(t, e, n, r) {
  let o = t.text;
  return o && typeof o != "string" && (o = o.reduce((i, s) => i.length > s.length ? i : s)), e + n.size / 2 + r.measureText(o).width;
}
function htt(t, e, n) {
  let r = t;
  return typeof e.text != "string" && (r = Kme(e, n)), r;
}
function Kme(t, e) {
  const n = t.text ? t.text.length : 0;
  return e * n;
}
function ptt(t, e) {
  return !!((t === "mousemove" || t === "mouseout") && (e.onHover || e.onLeave) || e.onClick && (t === "click" || t === "mouseup"));
}
var mtt = {
  id: "legend",
  _element: xH,
  start(t, e, n) {
    const r = t.legend = new xH({
      ctx: t.ctx,
      options: n,
      chart: t
    });
    qi.configure(t, r, n), qi.addBox(t, r);
  },
  stop(t) {
    qi.removeBox(t, t.legend), delete t.legend;
  },
  beforeUpdate(t, e, n) {
    const r = t.legend;
    qi.configure(t, r, n), r.options = n;
  },
  afterUpdate(t) {
    const e = t.legend;
    e.buildLabels(), e.adjustHitBoxes();
  },
  afterEvent(t, e) {
    e.replay || t.legend.handleEvent(e.event);
  },
  defaults: {
    display: !0,
    position: "top",
    align: "center",
    fullSize: !0,
    reverse: !1,
    weight: 1e3,
    onClick(t, e, n) {
      const r = e.datasetIndex, o = n.chart;
      o.isDatasetVisible(r) ? (o.hide(r), e.hidden = !0) : (o.show(r), e.hidden = !1);
    },
    onHover: null,
    onLeave: null,
    labels: {
      color: (t) => t.chart.options.color,
      boxWidth: 40,
      padding: 10,
      generateLabels(t) {
        const e = t.data.datasets, { labels: { usePointStyle: n, pointStyle: r, textAlign: o, color: i, useBorderRadius: s, borderRadius: a } } = t.legend.options;
        return t._getSortedDatasetMetas().map((l) => {
          const c = l.controller.getStyle(n ? 0 : void 0), u = ns(c.borderWidth);
          return {
            text: e[l.index].label,
            fillStyle: c.backgroundColor,
            fontColor: i,
            hidden: !l.visible,
            lineCap: c.borderCapStyle,
            lineDash: c.borderDash,
            lineDashOffset: c.borderDashOffset,
            lineJoin: c.borderJoinStyle,
            lineWidth: (u.width + u.height) / 4,
            strokeStyle: c.borderColor,
            pointStyle: r || c.pointStyle,
            rotation: c.rotation,
            textAlign: o || c.textAlign,
            borderRadius: s && (a || c.borderRadius),
            datasetIndex: l.index
          };
        }, this);
      }
    },
    title: {
      color: (t) => t.chart.options.color,
      display: !1,
      position: "center",
      text: ""
    }
  },
  descriptors: {
    _scriptable: (t) => !t.startsWith("on"),
    labels: {
      _scriptable: (t) => ![
        "generateLabels",
        "filter",
        "sort"
      ].includes(t)
    }
  }
};
class Xme extends Vl {
  constructor(e) {
    super(), this.chart = e.chart, this.options = e.options, this.ctx = e.ctx, this._padding = void 0, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.width = void 0, this.height = void 0, this.position = void 0, this.weight = void 0, this.fullSize = void 0;
  }
  update(e, n) {
    const r = this.options;
    if (this.left = 0, this.top = 0, !r.display) {
      this.width = this.height = this.right = this.bottom = 0;
      return;
    }
    this.width = this.right = e, this.height = this.bottom = n;
    const o = Cr(r.text) ? r.text.length : 1;
    this._padding = ns(r.padding);
    const i = o * uo(r.font).lineHeight + this._padding.height;
    this.isHorizontal() ? this.height = i : this.width = i;
  }
  isHorizontal() {
    const e = this.options.position;
    return e === "top" || e === "bottom";
  }
  _drawArgs(e) {
    const { top: n, left: r, bottom: o, right: i, options: s } = this, a = s.align;
    let l = 0, c, u, d;
    return this.isHorizontal() ? (u = io(a, r, i), d = n + e, c = i - r) : (s.position === "left" ? (u = r + e, d = io(a, o, n), l = An * -0.5) : (u = i - e, d = io(a, n, o), l = An * 0.5), c = o - n), {
      titleX: u,
      titleY: d,
      maxWidth: c,
      rotation: l
    };
  }
  draw() {
    const e = this.ctx, n = this.options;
    if (!n.display)
      return;
    const r = uo(n.font), o = r.lineHeight / 2 + this._padding.top, { titleX: i, titleY: s, maxWidth: a, rotation: l } = this._drawArgs(o);
    wy(e, n.text, 0, 0, r, {
      color: n.color,
      maxWidth: a,
      rotation: l,
      textAlign: i4(n.align),
      textBaseline: "middle",
      translation: [
        i,
        s
      ]
    });
  }
}
function gtt(t, e) {
  const n = new Xme({
    ctx: t.ctx,
    options: e,
    chart: t
  });
  qi.configure(t, n, e), qi.addBox(t, n), t.titleBlock = n;
}
var ytt = {
  id: "title",
  _element: Xme,
  start(t, e, n) {
    gtt(t, n);
  },
  stop(t) {
    const e = t.titleBlock;
    qi.removeBox(t, e), delete t.titleBlock;
  },
  beforeUpdate(t, e, n) {
    const r = t.titleBlock;
    qi.configure(t, r, n), r.options = n;
  },
  defaults: {
    align: "center",
    display: !1,
    font: {
      weight: "bold"
    },
    fullSize: !0,
    padding: 10,
    position: "top",
    text: "",
    weight: 2e3
  },
  defaultRoutes: {
    color: "color"
  },
  descriptors: {
    _scriptable: !0,
    _indexable: !1
  }
};
const d0 = {
  average(t) {
    if (!t.length)
      return !1;
    let e, n, r = /* @__PURE__ */ new Set(), o = 0, i = 0;
    for (e = 0, n = t.length; e < n; ++e) {
      const s = t[e].element;
      if (s && s.hasValue()) {
        const a = s.tooltipPosition();
        r.add(a.x), o += a.y, ++i;
      }
    }
    return i === 0 || r.size === 0 ? !1 : {
      x: [
        ...r
      ].reduce((s, a) => s + a) / r.size,
      y: o / i
    };
  },
  nearest(t, e) {
    if (!t.length)
      return !1;
    let n = e.x, r = e.y, o = Number.POSITIVE_INFINITY, i, s, a;
    for (i = 0, s = t.length; i < s; ++i) {
      const l = t[i].element;
      if (l && l.hasValue()) {
        const c = l.getCenterPoint(), u = aj(e, c);
        u < o && (o = u, a = l);
      }
    }
    if (a) {
      const l = a.tooltipPosition();
      n = l.x, r = l.y;
    }
    return {
      x: n,
      y: r
    };
  }
};
function Qs(t, e) {
  return e && (Cr(e) ? Array.prototype.push.apply(t, e) : t.push(e)), t;
}
function nl(t) {
  return (typeof t == "string" || t instanceof String) && t.indexOf(`
`) > -1 ? t.split(`
`) : t;
}
function vtt(t, e) {
  const { element: n, datasetIndex: r, index: o } = e, i = t.getDatasetMeta(r).controller, { label: s, value: a } = i.getLabelAndValue(o);
  return {
    chart: t,
    label: s,
    parsed: i.getParsed(o),
    raw: t.data.datasets[r].data[o],
    formattedValue: a,
    dataset: i.getDataset(),
    dataIndex: o,
    datasetIndex: r,
    element: n
  };
}
function EH(t, e) {
  const n = t.chart.ctx, { body: r, footer: o, title: i } = t, { boxWidth: s, boxHeight: a } = e, l = uo(e.bodyFont), c = uo(e.titleFont), u = uo(e.footerFont), d = i.length, f = o.length, h = r.length, p = ns(e.padding);
  let m = p.height, g = 0, y = r.reduce((_, w) => _ + w.before.length + w.lines.length + w.after.length, 0);
  if (y += t.beforeBody.length + t.afterBody.length, d && (m += d * c.lineHeight + (d - 1) * e.titleSpacing + e.titleMarginBottom), y) {
    const _ = e.displayColors ? Math.max(a, l.lineHeight) : l.lineHeight;
    m += h * _ + (y - h) * l.lineHeight + (y - 1) * e.bodySpacing;
  }
  f && (m += e.footerMarginTop + f * u.lineHeight + (f - 1) * e.footerSpacing);
  let v = 0;
  const b = function(_) {
    g = Math.max(g, n.measureText(_).width + v);
  };
  return n.save(), n.font = c.string, On(t.title, b), n.font = l.string, On(t.beforeBody.concat(t.afterBody), b), v = e.displayColors ? s + 2 + e.boxPadding : 0, On(r, (_) => {
    On(_.before, b), On(_.lines, b), On(_.after, b);
  }), v = 0, n.font = u.string, On(t.footer, b), n.restore(), g += p.width, {
    width: g,
    height: m
  };
}
function btt(t, e) {
  const { y: n, height: r } = e;
  return n < r / 2 ? "top" : n > t.height - r / 2 ? "bottom" : "center";
}
function _tt(t, e, n, r) {
  const { x: o, width: i } = r, s = n.caretSize + n.caretPadding;
  if (t === "left" && o + i + s > e.width || t === "right" && o - i - s < 0)
    return !0;
}
function wtt(t, e, n, r) {
  const { x: o, width: i } = n, { width: s, chartArea: { left: a, right: l } } = t;
  let c = "center";
  return r === "center" ? c = o <= (a + l) / 2 ? "left" : "right" : o <= i / 2 ? c = "left" : o >= s - i / 2 && (c = "right"), _tt(c, t, e, n) && (c = "center"), c;
}
function SH(t, e, n) {
  const r = n.yAlign || e.yAlign || btt(t, n);
  return {
    xAlign: n.xAlign || e.xAlign || wtt(t, e, n, r),
    yAlign: r
  };
}
function xtt(t, e) {
  let { x: n, width: r } = t;
  return e === "right" ? n -= r : e === "center" && (n -= r / 2), n;
}
function Ett(t, e, n) {
  let { y: r, height: o } = t;
  return e === "top" ? r += n : e === "bottom" ? r -= o + n : r -= o / 2, r;
}
function OH(t, e, n, r) {
  const { caretSize: o, caretPadding: i, cornerRadius: s } = t, { xAlign: a, yAlign: l } = n, c = o + i, { topLeft: u, topRight: d, bottomLeft: f, bottomRight: h } = Sh(s);
  let p = xtt(e, a);
  const m = Ett(e, l, c);
  return l === "center" ? a === "left" ? p += c : a === "right" && (p -= c) : a === "left" ? p -= Math.max(u, f) + o : a === "right" && (p += Math.max(d, h) + o), {
    x: co(p, 0, r.width - e.width),
    y: co(m, 0, r.height - e.height)
  };
}
function g1(t, e, n) {
  const r = ns(n.padding);
  return e === "center" ? t.x + t.width / 2 : e === "right" ? t.x + t.width - r.right : t.x + r.left;
}
function CH(t) {
  return Qs([], nl(t));
}
function Stt(t, e, n) {
  return Xd(t, {
    tooltip: e,
    tooltipItems: n,
    type: "tooltip"
  });
}
function kH(t, e) {
  const n = e && e.dataset && e.dataset.tooltip && e.dataset.tooltip.callbacks;
  return n ? t.override(n) : t;
}
const Qme = {
  beforeTitle: Ba,
  title(t) {
    if (t.length > 0) {
      const e = t[0], n = e.chart.data.labels, r = n ? n.length : 0;
      if (this && this.options && this.options.mode === "dataset")
        return e.dataset.label || "";
      if (e.label)
        return e.label;
      if (r > 0 && e.dataIndex < r)
        return n[e.dataIndex];
    }
    return "";
  },
  afterTitle: Ba,
  beforeBody: Ba,
  beforeLabel: Ba,
  label(t) {
    if (this && this.options && this.options.mode === "dataset")
      return t.label + ": " + t.formattedValue || t.formattedValue;
    let e = t.dataset.label || "";
    e && (e += ": ");
    const n = t.formattedValue;
    return vn(n) || (e += n), e;
  },
  labelColor(t) {
    const e = t.chart.getDatasetMeta(t.datasetIndex).controller.getStyle(t.dataIndex);
    return {
      borderColor: e.borderColor,
      backgroundColor: e.backgroundColor,
      borderWidth: e.borderWidth,
      borderDash: e.borderDash,
      borderDashOffset: e.borderDashOffset,
      borderRadius: 0
    };
  },
  labelTextColor() {
    return this.options.bodyColor;
  },
  labelPointStyle(t) {
    const e = t.chart.getDatasetMeta(t.datasetIndex).controller.getStyle(t.dataIndex);
    return {
      pointStyle: e.pointStyle,
      rotation: e.rotation
    };
  },
  afterLabel: Ba,
  afterBody: Ba,
  beforeFooter: Ba,
  footer: Ba,
  afterFooter: Ba
};
function jo(t, e, n, r) {
  const o = t[e].call(n, r);
  return typeof o > "u" ? Qme[e].call(n, r) : o;
}
class pj extends Vl {
  constructor(e) {
    super(), this.opacity = 0, this._active = [], this._eventPosition = void 0, this._size = void 0, this._cachedAnimations = void 0, this._tooltipItems = [], this.$animations = void 0, this.$context = void 0, this.chart = e.chart, this.options = e.options, this.dataPoints = void 0, this.title = void 0, this.beforeBody = void 0, this.body = void 0, this.afterBody = void 0, this.footer = void 0, this.xAlign = void 0, this.yAlign = void 0, this.x = void 0, this.y = void 0, this.height = void 0, this.width = void 0, this.caretX = void 0, this.caretY = void 0, this.labelColors = void 0, this.labelPointStyles = void 0, this.labelTextColors = void 0;
  }
  initialize(e) {
    this.options = e, this._cachedAnimations = void 0, this.$context = void 0;
  }
  _resolveAnimations() {
    const e = this._cachedAnimations;
    if (e)
      return e;
    const n = this.chart, r = this.options.setContext(this.getContext()), o = r.enabled && n.options.animation && r.animations, i = new Pme(this.chart, o);
    return o._cacheable && (this._cachedAnimations = Object.freeze(i)), i;
  }
  getContext() {
    return this.$context || (this.$context = Stt(this.chart.getContext(), this, this._tooltipItems));
  }
  getTitle(e, n) {
    const { callbacks: r } = n, o = jo(r, "beforeTitle", this, e), i = jo(r, "title", this, e), s = jo(r, "afterTitle", this, e);
    let a = [];
    return a = Qs(a, nl(o)), a = Qs(a, nl(i)), a = Qs(a, nl(s)), a;
  }
  getBeforeBody(e, n) {
    return CH(jo(n.callbacks, "beforeBody", this, e));
  }
  getBody(e, n) {
    const { callbacks: r } = n, o = [];
    return On(e, (i) => {
      const s = {
        before: [],
        lines: [],
        after: []
      }, a = kH(r, i);
      Qs(s.before, nl(jo(a, "beforeLabel", this, i))), Qs(s.lines, jo(a, "label", this, i)), Qs(s.after, nl(jo(a, "afterLabel", this, i))), o.push(s);
    }), o;
  }
  getAfterBody(e, n) {
    return CH(jo(n.callbacks, "afterBody", this, e));
  }
  getFooter(e, n) {
    const { callbacks: r } = n, o = jo(r, "beforeFooter", this, e), i = jo(r, "footer", this, e), s = jo(r, "afterFooter", this, e);
    let a = [];
    return a = Qs(a, nl(o)), a = Qs(a, nl(i)), a = Qs(a, nl(s)), a;
  }
  _createItems(e) {
    const n = this._active, r = this.chart.data, o = [], i = [], s = [];
    let a = [], l, c;
    for (l = 0, c = n.length; l < c; ++l)
      a.push(vtt(this.chart, n[l]));
    return e.filter && (a = a.filter((u, d, f) => e.filter(u, d, f, r))), e.itemSort && (a = a.sort((u, d) => e.itemSort(u, d, r))), On(a, (u) => {
      const d = kH(e.callbacks, u);
      o.push(jo(d, "labelColor", this, u)), i.push(jo(d, "labelPointStyle", this, u)), s.push(jo(d, "labelTextColor", this, u));
    }), this.labelColors = o, this.labelPointStyles = i, this.labelTextColors = s, this.dataPoints = a, a;
  }
  update(e, n) {
    const r = this.options.setContext(this.getContext()), o = this._active;
    let i, s = [];
    if (!o.length)
      this.opacity !== 0 && (i = {
        opacity: 0
      });
    else {
      const a = d0[r.position].call(this, o, this._eventPosition);
      s = this._createItems(r), this.title = this.getTitle(s, r), this.beforeBody = this.getBeforeBody(s, r), this.body = this.getBody(s, r), this.afterBody = this.getAfterBody(s, r), this.footer = this.getFooter(s, r);
      const l = this._size = EH(this, r), c = Object.assign({}, a, l), u = SH(this.chart, r, c), d = OH(r, c, u, this.chart);
      this.xAlign = u.xAlign, this.yAlign = u.yAlign, i = {
        opacity: 1,
        x: d.x,
        y: d.y,
        width: l.width,
        height: l.height,
        caretX: a.x,
        caretY: a.y
      };
    }
    this._tooltipItems = s, this.$context = void 0, i && this._resolveAnimations().update(this, i), e && r.external && r.external.call(this, {
      chart: this.chart,
      tooltip: this,
      replay: n
    });
  }
  drawCaret(e, n, r, o) {
    const i = this.getCaretPosition(e, r, o);
    n.lineTo(i.x1, i.y1), n.lineTo(i.x2, i.y2), n.lineTo(i.x3, i.y3);
  }
  getCaretPosition(e, n, r) {
    const { xAlign: o, yAlign: i } = this, { caretSize: s, cornerRadius: a } = r, { topLeft: l, topRight: c, bottomLeft: u, bottomRight: d } = Sh(a), { x: f, y: h } = e, { width: p, height: m } = n;
    let g, y, v, b, _, w;
    return i === "center" ? (_ = h + m / 2, o === "left" ? (g = f, y = g - s, b = _ + s, w = _ - s) : (g = f + p, y = g + s, b = _ - s, w = _ + s), v = g) : (o === "left" ? y = f + Math.max(l, u) + s : o === "right" ? y = f + p - Math.max(c, d) - s : y = this.caretX, i === "top" ? (b = h, _ = b - s, g = y - s, v = y + s) : (b = h + m, _ = b + s, g = y + s, v = y - s), w = b), {
      x1: g,
      x2: y,
      x3: v,
      y1: b,
      y2: _,
      y3: w
    };
  }
  drawTitle(e, n, r) {
    const o = this.title, i = o.length;
    let s, a, l;
    if (i) {
      const c = Oh(r.rtl, this.x, this.width);
      for (e.x = g1(this, r.titleAlign, r), n.textAlign = c.textAlign(r.titleAlign), n.textBaseline = "middle", s = uo(r.titleFont), a = r.titleSpacing, n.fillStyle = r.titleColor, n.font = s.string, l = 0; l < i; ++l)
        n.fillText(o[l], c.x(e.x), e.y + s.lineHeight / 2), e.y += s.lineHeight + a, l + 1 === i && (e.y += r.titleMarginBottom - a);
    }
  }
  _drawColorBox(e, n, r, o, i) {
    const s = this.labelColors[r], a = this.labelPointStyles[r], { boxHeight: l, boxWidth: c } = i, u = uo(i.bodyFont), d = g1(this, "left", i), f = o.x(d), h = l < u.lineHeight ? (u.lineHeight - l) / 2 : 0, p = n.y + h;
    if (i.usePointStyle) {
      const m = {
        radius: Math.min(c, l) / 2,
        pointStyle: a.pointStyle,
        rotation: a.rotation,
        borderWidth: 1
      }, g = o.leftForLtr(f, c) + c / 2, y = p + l / 2;
      e.strokeStyle = i.multiKeyBackground, e.fillStyle = i.multiKeyBackground, cj(e, m, g, y), e.strokeStyle = s.borderColor, e.fillStyle = s.backgroundColor, cj(e, m, g, y);
    } else {
      e.lineWidth = Bt(s.borderWidth) ? Math.max(...Object.values(s.borderWidth)) : s.borderWidth || 1, e.strokeStyle = s.borderColor, e.setLineDash(s.borderDash || []), e.lineDashOffset = s.borderDashOffset || 0;
      const m = o.leftForLtr(f, c), g = o.leftForLtr(o.xPlus(f, 1), c - 2), y = Sh(s.borderRadius);
      Object.values(y).some((v) => v !== 0) ? (e.beginPath(), e.fillStyle = i.multiKeyBackground, sE(e, {
        x: m,
        y: p,
        w: c,
        h: l,
        radius: y
      }), e.fill(), e.stroke(), e.fillStyle = s.backgroundColor, e.beginPath(), sE(e, {
        x: g,
        y: p + 1,
        w: c - 2,
        h: l - 2,
        radius: y
      }), e.fill()) : (e.fillStyle = i.multiKeyBackground, e.fillRect(m, p, c, l), e.strokeRect(m, p, c, l), e.fillStyle = s.backgroundColor, e.fillRect(g, p + 1, c - 2, l - 2));
    }
    e.fillStyle = this.labelTextColors[r];
  }
  drawBody(e, n, r) {
    const { body: o } = this, { bodySpacing: i, bodyAlign: s, displayColors: a, boxHeight: l, boxWidth: c, boxPadding: u } = r, d = uo(r.bodyFont);
    let f = d.lineHeight, h = 0;
    const p = Oh(r.rtl, this.x, this.width), m = function(S) {
      n.fillText(S, p.x(e.x + h), e.y + f / 2), e.y += f + i;
    }, g = p.textAlign(s);
    let y, v, b, _, w, x, E;
    for (n.textAlign = s, n.textBaseline = "middle", n.font = d.string, e.x = g1(this, g, r), n.fillStyle = r.bodyColor, On(this.beforeBody, m), h = a && g !== "right" ? s === "center" ? c / 2 + u : c + 2 + u : 0, _ = 0, x = o.length; _ < x; ++_) {
      for (y = o[_], v = this.labelTextColors[_], n.fillStyle = v, On(y.before, m), b = y.lines, a && b.length && (this._drawColorBox(n, e, _, p, r), f = Math.max(d.lineHeight, l)), w = 0, E = b.length; w < E; ++w)
        m(b[w]), f = d.lineHeight;
      On(y.after, m);
    }
    h = 0, f = d.lineHeight, On(this.afterBody, m), e.y -= i;
  }
  drawFooter(e, n, r) {
    const o = this.footer, i = o.length;
    let s, a;
    if (i) {
      const l = Oh(r.rtl, this.x, this.width);
      for (e.x = g1(this, r.footerAlign, r), e.y += r.footerMarginTop, n.textAlign = l.textAlign(r.footerAlign), n.textBaseline = "middle", s = uo(r.footerFont), n.fillStyle = r.footerColor, n.font = s.string, a = 0; a < i; ++a)
        n.fillText(o[a], l.x(e.x), e.y + s.lineHeight / 2), e.y += s.lineHeight + r.footerSpacing;
    }
  }
  drawBackground(e, n, r, o) {
    const { xAlign: i, yAlign: s } = this, { x: a, y: l } = e, { width: c, height: u } = r, { topLeft: d, topRight: f, bottomLeft: h, bottomRight: p } = Sh(o.cornerRadius);
    n.fillStyle = o.backgroundColor, n.strokeStyle = o.borderColor, n.lineWidth = o.borderWidth, n.beginPath(), n.moveTo(a + d, l), s === "top" && this.drawCaret(e, n, r, o), n.lineTo(a + c - f, l), n.quadraticCurveTo(a + c, l, a + c, l + f), s === "center" && i === "right" && this.drawCaret(e, n, r, o), n.lineTo(a + c, l + u - p), n.quadraticCurveTo(a + c, l + u, a + c - p, l + u), s === "bottom" && this.drawCaret(e, n, r, o), n.lineTo(a + h, l + u), n.quadraticCurveTo(a, l + u, a, l + u - h), s === "center" && i === "left" && this.drawCaret(e, n, r, o), n.lineTo(a, l + d), n.quadraticCurveTo(a, l, a + d, l), n.closePath(), n.fill(), o.borderWidth > 0 && n.stroke();
  }
  _updateAnimationTarget(e) {
    const n = this.chart, r = this.$animations, o = r && r.x, i = r && r.y;
    if (o || i) {
      const s = d0[e.position].call(this, this._active, this._eventPosition);
      if (!s)
        return;
      const a = this._size = EH(this, e), l = Object.assign({}, s, this._size), c = SH(n, e, l), u = OH(e, l, c, n);
      (o._to !== u.x || i._to !== u.y) && (this.xAlign = c.xAlign, this.yAlign = c.yAlign, this.width = a.width, this.height = a.height, this.caretX = s.x, this.caretY = s.y, this._resolveAnimations().update(this, u));
    }
  }
  _willRender() {
    return !!this.opacity;
  }
  draw(e) {
    const n = this.options.setContext(this.getContext());
    let r = this.opacity;
    if (!r)
      return;
    this._updateAnimationTarget(n);
    const o = {
      width: this.width,
      height: this.height
    }, i = {
      x: this.x,
      y: this.y
    };
    r = Math.abs(r) < 1e-3 ? 0 : r;
    const s = ns(n.padding), a = this.title.length || this.beforeBody.length || this.body.length || this.afterBody.length || this.footer.length;
    n.enabled && a && (e.save(), e.globalAlpha = r, this.drawBackground(i, e, o, n), Ome(e, n.textDirection), i.y += s.top, this.drawTitle(i, e, n), this.drawBody(i, e, n), this.drawFooter(i, e, n), Cme(e, n.textDirection), e.restore());
  }
  getActiveElements() {
    return this._active || [];
  }
  setActiveElements(e, n) {
    const r = this._active, o = e.map(({ datasetIndex: a, index: l }) => {
      const c = this.chart.getDatasetMeta(a);
      if (!c)
        throw new Error("Cannot find a dataset at index " + a);
      return {
        datasetIndex: a,
        element: c.data[l],
        index: l
      };
    }), i = !rE(r, o), s = this._positionChanged(o, n);
    (i || s) && (this._active = o, this._eventPosition = n, this._ignoreReplayEvents = !0, this.update(!0));
  }
  handleEvent(e, n, r = !0) {
    if (n && this._ignoreReplayEvents)
      return !1;
    this._ignoreReplayEvents = !1;
    const o = this.options, i = this._active || [], s = this._getActiveElements(e, i, n, r), a = this._positionChanged(s, e), l = n || !rE(s, i) || a;
    return l && (this._active = s, (o.enabled || o.external) && (this._eventPosition = {
      x: e.x,
      y: e.y
    }, this.update(!0, n))), l;
  }
  _getActiveElements(e, n, r, o) {
    const i = this.options;
    if (e.type === "mouseout")
      return [];
    if (!o)
      return n.filter((a) => this.chart.data.datasets[a.datasetIndex] && this.chart.getDatasetMeta(a.datasetIndex).controller.getParsed(a.index) !== void 0);
    const s = this.chart.getElementsAtEventForMode(e, i.mode, i, r);
    return i.reverse && s.reverse(), s;
  }
  _positionChanged(e, n) {
    const { caretX: r, caretY: o, options: i } = this, s = d0[i.position].call(this, e, n);
    return s !== !1 && (r !== s.x || o !== s.y);
  }
}
ue(pj, "positioners", d0);
var Zme = {
  id: "tooltip",
  _element: pj,
  positioners: d0,
  afterInit(t, e, n) {
    n && (t.tooltip = new pj({
      chart: t,
      options: n
    }));
  },
  beforeUpdate(t, e, n) {
    t.tooltip && t.tooltip.initialize(n);
  },
  reset(t, e, n) {
    t.tooltip && t.tooltip.initialize(n);
  },
  afterDraw(t) {
    const e = t.tooltip;
    if (e && e._willRender()) {
      const n = {
        tooltip: e
      };
      if (t.notifyPlugins("beforeTooltipDraw", {
        ...n,
        cancelable: !0
      }) === !1)
        return;
      e.draw(t.ctx), t.notifyPlugins("afterTooltipDraw", n);
    }
  },
  afterEvent(t, e) {
    if (t.tooltip) {
      const n = e.replay;
      t.tooltip.handleEvent(e.event, n, e.inChartArea) && (e.changed = !0);
    }
  },
  defaults: {
    enabled: !0,
    external: null,
    position: "average",
    backgroundColor: "rgba(0,0,0,0.8)",
    titleColor: "#fff",
    titleFont: {
      weight: "bold"
    },
    titleSpacing: 2,
    titleMarginBottom: 6,
    titleAlign: "left",
    bodyColor: "#fff",
    bodySpacing: 2,
    bodyFont: {},
    bodyAlign: "left",
    footerColor: "#fff",
    footerSpacing: 2,
    footerMarginTop: 6,
    footerFont: {
      weight: "bold"
    },
    footerAlign: "left",
    padding: 6,
    caretPadding: 2,
    caretSize: 5,
    cornerRadius: 6,
    boxHeight: (t, e) => e.bodyFont.size,
    boxWidth: (t, e) => e.bodyFont.size,
    multiKeyBackground: "#fff",
    displayColors: !0,
    boxPadding: 0,
    borderColor: "rgba(0,0,0,0)",
    borderWidth: 0,
    animation: {
      duration: 400,
      easing: "easeOutQuart"
    },
    animations: {
      numbers: {
        type: "number",
        properties: [
          "x",
          "y",
          "width",
          "height",
          "caretX",
          "caretY"
        ]
      },
      opacity: {
        easing: "linear",
        duration: 200
      }
    },
    callbacks: Qme
  },
  defaultRoutes: {
    bodyFont: "font",
    footerFont: "font",
    titleFont: "font"
  },
  descriptors: {
    _scriptable: (t) => t !== "filter" && t !== "itemSort" && t !== "external",
    _indexable: !1,
    callbacks: {
      _scriptable: !1,
      _indexable: !1
    },
    animation: {
      _fallback: !1
    },
    animations: {
      _fallback: "animation"
    }
  },
  additionalOptionScopes: [
    "interaction"
  ]
};
const Ott = (t, e, n, r) => (typeof e == "string" ? (n = t.push(e) - 1, r.unshift({
  index: n,
  label: e
})) : isNaN(e) && (n = null), n);
function Ctt(t, e, n, r) {
  const o = t.indexOf(e);
  if (o === -1)
    return Ott(t, e, n, r);
  const i = t.lastIndexOf(e);
  return o !== i ? n : o;
}
const ktt = (t, e) => t === null ? null : co(Math.round(t), 0, e);
function Jme(t) {
  const e = this.getLabels();
  return t >= 0 && t < e.length ? e[t] : t;
}
class mj extends Pp {
  constructor(e) {
    super(e), this._startValue = void 0, this._valueRange = 0, this._addedLabels = [];
  }
  init(e) {
    const n = this._addedLabels;
    if (n.length) {
      const r = this.getLabels();
      for (const { index: o, label: i } of n)
        r[o] === i && r.splice(o, 1);
      this._addedLabels = [];
    }
    super.init(e);
  }
  parse(e, n) {
    if (vn(e))
      return null;
    const r = this.getLabels();
    return n = isFinite(n) && r[n] === e ? n : Ctt(r, e, Tt(n, e), this._addedLabels), ktt(n, r.length - 1);
  }
  determineDataLimits() {
    const { minDefined: e, maxDefined: n } = this.getUserBounds();
    let { min: r, max: o } = this.getMinMax(!0);
    this.options.bounds === "ticks" && (e || (r = 0), n || (o = this.getLabels().length - 1)), this.min = r, this.max = o;
  }
  buildTicks() {
    const e = this.min, n = this.max, r = this.options.offset, o = [];
    let i = this.getLabels();
    i = e === 0 && n === i.length - 1 ? i : i.slice(e, n + 1), this._valueRange = Math.max(i.length - (r ? 0 : 1), 1), this._startValue = this.min - (r ? 0.5 : 0);
    for (let s = e; s <= n; s++)
      o.push({
        value: s
      });
    return o;
  }
  getLabelForValue(e) {
    return Jme.call(this, e);
  }
  configure() {
    super.configure(), this.isHorizontal() || (this._reversePixels = !this._reversePixels);
  }
  getPixelForValue(e) {
    return typeof e != "number" && (e = this.parse(e)), e === null ? NaN : this.getPixelForDecimal((e - this._startValue) / this._valueRange);
  }
  getPixelForTick(e) {
    const n = this.ticks;
    return e < 0 || e > n.length - 1 ? null : this.getPixelForValue(n[e].value);
  }
  getValueForPixel(e) {
    return Math.round(this._startValue + this.getDecimalForPixel(e) * this._valueRange);
  }
  getBasePixel() {
    return this.bottom;
  }
}
ue(mj, "id", "category"), ue(mj, "defaults", {
  ticks: {
    callback: Jme
  }
});
function Att(t, e) {
  const n = [], { bounds: r, step: o, min: i, max: s, precision: a, count: l, maxTicks: c, maxDigits: u, includeBounds: d } = t, f = o || 1, h = c - 1, { min: p, max: m } = e, g = !vn(i), y = !vn(s), v = !vn(l), b = (m - p) / (u + 1);
  let _ = CU((m - p) / h / f) * f, w, x, E, S;
  if (_ < 1e-14 && !g && !y)
    return [
      {
        value: p
      },
      {
        value: m
      }
    ];
  S = Math.ceil(m / _) - Math.floor(p / _), S > h && (_ = CU(S * _ / h / f) * f), vn(a) || (w = Math.pow(10, a), _ = Math.ceil(_ * w) / w), r === "ticks" ? (x = Math.floor(p / _) * _, E = Math.ceil(m / _) * _) : (x = p, E = m), g && y && o && RQe((s - i) / o, _ / 1e3) ? (S = Math.round(Math.min((s - i) / _, c)), _ = (s - i) / S, x = i, E = s) : v ? (x = g ? i : x, E = y ? s : E, S = l - 1, _ = (E - x) / S) : (S = (E - x) / _, l0(S, Math.round(S), _ / 1e3) ? S = Math.round(S) : S = Math.ceil(S));
  const C = Math.max(kU(_), kU(x));
  w = Math.pow(10, vn(a) ? C : a), x = Math.round(x * w) / w, E = Math.round(E * w) / w;
  let R = 0;
  for (g && (d && x !== i ? (n.push({
    value: i
  }), x < i && R++, l0(Math.round((x + R * _) * w) / w, i, AH(i, b, t)) && R++) : x < i && R++); R < S; ++R) {
    const P = Math.round((x + R * _) * w) / w;
    if (y && P > s)
      break;
    n.push({
      value: P
    });
  }
  return y && d && E !== s ? n.length && l0(n[n.length - 1].value, s, AH(s, b, t)) ? n[n.length - 1].value = s : n.push({
    value: s
  }) : (!y || E === s) && n.push({
    value: E
  }), n;
}
function AH(t, e, { horizontal: n, minRotation: r }) {
  const o = xl(r), i = (n ? Math.sin(o) : Math.cos(o)) || 1e-3, s = 0.75 * e * ("" + t).length;
  return Math.min(e / i, s);
}
class Ttt extends Pp {
  constructor(e) {
    super(e), this.start = void 0, this.end = void 0, this._startValue = void 0, this._endValue = void 0, this._valueRange = 0;
  }
  parse(e, n) {
    return vn(e) || (typeof e == "number" || e instanceof Number) && !isFinite(+e) ? null : +e;
  }
  handleTickRangeOptions() {
    const { beginAtZero: e } = this.options, { minDefined: n, maxDefined: r } = this.getUserBounds();
    let { min: o, max: i } = this;
    const s = (l) => o = n ? o : l, a = (l) => i = r ? i : l;
    if (e) {
      const l = _a(o), c = _a(i);
      l < 0 && c < 0 ? a(0) : l > 0 && c > 0 && s(0);
    }
    if (o === i) {
      let l = i === 0 ? 1 : Math.abs(i * 0.05);
      a(i + l), e || s(o - l);
    }
    this.min = o, this.max = i;
  }
  getTickLimit() {
    const e = this.options.ticks;
    let { maxTicksLimit: n, stepSize: r } = e, o;
    return r ? (o = Math.ceil(this.max / r) - Math.floor(this.min / r) + 1, o > 1e3 && (console.warn(`scales.${this.id}.ticks.stepSize: ${r} would result generating up to ${o} ticks. Limiting to 1000.`), o = 1e3)) : (o = this.computeTickLimit(), n = n || 11), n && (o = Math.min(n, o)), o;
  }
  computeTickLimit() {
    return Number.POSITIVE_INFINITY;
  }
  buildTicks() {
    const e = this.options, n = e.ticks;
    let r = this.getTickLimit();
    r = Math.max(2, r);
    const o = {
      maxTicks: r,
      bounds: e.bounds,
      min: e.min,
      max: e.max,
      precision: n.precision,
      step: n.stepSize,
      count: n.count,
      maxDigits: this._maxDigits(),
      horizontal: this.isHorizontal(),
      minRotation: n.minRotation || 0,
      includeBounds: n.includeBounds !== !1
    }, i = this._range || this, s = Att(o, i);
    return e.bounds === "ticks" && PQe(s, this, "value"), e.reverse ? (s.reverse(), this.start = this.max, this.end = this.min) : (this.start = this.min, this.end = this.max), s;
  }
  configure() {
    const e = this.ticks;
    let n = this.min, r = this.max;
    if (super.configure(), this.options.offset && e.length) {
      const o = (r - n) / Math.max(e.length - 1, 1) / 2;
      n -= o, r += o;
    }
    this._startValue = n, this._endValue = r, this._valueRange = r - n;
  }
  getLabelForValue(e) {
    return a4(e, this.chart.options.locale, this.options.ticks.format);
  }
}
class gj extends Ttt {
  determineDataLimits() {
    const { min: e, max: n } = this.getMinMax(!0);
    this.min = po(e) ? e : 0, this.max = po(n) ? n : 1, this.handleTickRangeOptions();
  }
  computeTickLimit() {
    const e = this.isHorizontal(), n = e ? this.width : this.height, r = xl(this.options.ticks.minRotation), o = (e ? Math.sin(r) : Math.cos(r)) || 1e-3, i = this._resolveTickFontOptions(0);
    return Math.ceil(n / Math.min(40, i.lineHeight / o));
  }
  getPixelForValue(e) {
    return e === null ? NaN : this.getPixelForDecimal((e - this._startValue) / this._valueRange);
  }
  getValueForPixel(e) {
    return this._startValue + this.getDecimalForPixel(e) * this._valueRange;
  }
}
ue(gj, "id", "linear"), ue(gj, "defaults", {
  ticks: {
    callback: yme.formatters.numeric
  }
});
const JS = {
  millisecond: {
    common: !0,
    size: 1,
    steps: 1e3
  },
  second: {
    common: !0,
    size: 1e3,
    steps: 60
  },
  minute: {
    common: !0,
    size: 6e4,
    steps: 60
  },
  hour: {
    common: !0,
    size: 36e5,
    steps: 24
  },
  day: {
    common: !0,
    size: 864e5,
    steps: 30
  },
  week: {
    common: !1,
    size: 6048e5,
    steps: 4
  },
  month: {
    common: !0,
    size: 2628e6,
    steps: 12
  },
  quarter: {
    common: !1,
    size: 7884e6,
    steps: 4
  },
  year: {
    common: !0,
    size: 3154e7
  }
}, Ho = /* @__PURE__ */ Object.keys(JS);
function TH(t, e) {
  return t - e;
}
function RH(t, e) {
  if (vn(e))
    return null;
  const n = t._adapter, { parser: r, round: o, isoWeekday: i } = t._parseOpts;
  let s = e;
  return typeof r == "function" && (s = r(s)), po(s) || (s = typeof r == "string" ? n.parse(s, r) : n.parse(s)), s === null ? null : (o && (s = o === "week" && (vy(i) || i === !0) ? n.startOf(s, "isoWeek", i) : n.startOf(s, o)), +s);
}
function PH(t, e, n, r) {
  const o = Ho.length;
  for (let i = Ho.indexOf(t); i < o - 1; ++i) {
    const s = JS[Ho[i]], a = s.steps ? s.steps : Number.MAX_SAFE_INTEGER;
    if (s.common && Math.ceil((n - e) / (a * s.size)) <= r)
      return Ho[i];
  }
  return Ho[o - 1];
}
function Rtt(t, e, n, r, o) {
  for (let i = Ho.length - 1; i >= Ho.indexOf(n); i--) {
    const s = Ho[i];
    if (JS[s].common && t._adapter.diff(o, r, s) >= e - 1)
      return s;
  }
  return Ho[n ? Ho.indexOf(n) : 0];
}
function Ptt(t) {
  for (let e = Ho.indexOf(t) + 1, n = Ho.length; e < n; ++e)
    if (JS[Ho[e]].common)
      return Ho[e];
}
function $H(t, e, n) {
  if (!n)
    t[e] = !0;
  else if (n.length) {
    const { lo: r, hi: o } = o4(n, e), i = n[r] >= e ? n[r] : n[o];
    t[i] = !0;
  }
}
function $tt(t, e, n, r) {
  const o = t._adapter, i = +o.startOf(e[0].value, r), s = e[e.length - 1].value;
  let a, l;
  for (a = i; a <= s; a = +o.add(a, 1, r))
    l = n[a], l >= 0 && (e[l].major = !0);
  return e;
}
function MH(t, e, n) {
  const r = [], o = {}, i = e.length;
  let s, a;
  for (s = 0; s < i; ++s)
    a = e[s], o[a] = s, r.push({
      value: a,
      major: !1
    });
  return i === 0 || !n ? r : $tt(t, r, o, n);
}
class Ey extends Pp {
  constructor(e) {
    super(e), this._cache = {
      data: [],
      labels: [],
      all: []
    }, this._unit = "day", this._majorUnit = void 0, this._offsets = {}, this._normalized = !1, this._parseOpts = void 0;
  }
  init(e, n = {}) {
    const r = e.time || (e.time = {}), o = this._adapter = new hJe._date(e.adapters.date);
    o.init(n), a0(r.displayFormats, o.formats()), this._parseOpts = {
      parser: r.parser,
      round: r.round,
      isoWeekday: r.isoWeekday
    }, super.init(e), this._normalized = n.normalized;
  }
  parse(e, n) {
    return e === void 0 ? null : RH(this, e);
  }
  beforeLayout() {
    super.beforeLayout(), this._cache = {
      data: [],
      labels: [],
      all: []
    };
  }
  determineDataLimits() {
    const e = this.options, n = this._adapter, r = e.time.unit || "day";
    let { min: o, max: i, minDefined: s, maxDefined: a } = this.getUserBounds();
    function l(c) {
      !s && !isNaN(c.min) && (o = Math.min(o, c.min)), !a && !isNaN(c.max) && (i = Math.max(i, c.max));
    }
    (!s || !a) && (l(this._getLabelBounds()), (e.bounds !== "ticks" || e.ticks.source !== "labels") && l(this.getMinMax(!1))), o = po(o) && !isNaN(o) ? o : +n.startOf(Date.now(), r), i = po(i) && !isNaN(i) ? i : +n.endOf(Date.now(), r) + 1, this.min = Math.min(o, i - 1), this.max = Math.max(o + 1, i);
  }
  _getLabelBounds() {
    const e = this.getLabelTimestamps();
    let n = Number.POSITIVE_INFINITY, r = Number.NEGATIVE_INFINITY;
    return e.length && (n = e[0], r = e[e.length - 1]), {
      min: n,
      max: r
    };
  }
  buildTicks() {
    const e = this.options, n = e.time, r = e.ticks, o = r.source === "labels" ? this.getLabelTimestamps() : this._generate();
    e.bounds === "ticks" && o.length && (this.min = this._userMin || o[0], this.max = this._userMax || o[o.length - 1]);
    const i = this.min, s = this.max, a = NQe(o, i, s);
    return this._unit = n.unit || (r.autoSkip ? PH(n.minUnit, this.min, this.max, this._getLabelCapacity(i)) : Rtt(this, a.length, n.minUnit, this.min, this.max)), this._majorUnit = !r.major.enabled || this._unit === "year" ? void 0 : Ptt(this._unit), this.initOffsets(o), e.reverse && a.reverse(), MH(this, a, this._majorUnit);
  }
  afterAutoSkip() {
    this.options.offsetAfterAutoskip && this.initOffsets(this.ticks.map((e) => +e.value));
  }
  initOffsets(e = []) {
    let n = 0, r = 0, o, i;
    this.options.offset && e.length && (o = this.getDecimalForValue(e[0]), e.length === 1 ? n = 1 - o : n = (this.getDecimalForValue(e[1]) - o) / 2, i = this.getDecimalForValue(e[e.length - 1]), e.length === 1 ? r = i : r = (i - this.getDecimalForValue(e[e.length - 2])) / 2);
    const s = e.length < 3 ? 0.5 : 0.25;
    n = co(n, 0, s), r = co(r, 0, s), this._offsets = {
      start: n,
      end: r,
      factor: 1 / (n + 1 + r)
    };
  }
  _generate() {
    const e = this._adapter, n = this.min, r = this.max, o = this.options, i = o.time, s = i.unit || PH(i.minUnit, n, r, this._getLabelCapacity(n)), a = Tt(o.ticks.stepSize, 1), l = s === "week" ? i.isoWeekday : !1, c = vy(l) || l === !0, u = {};
    let d = n, f, h;
    if (c && (d = +e.startOf(d, "isoWeek", l)), d = +e.startOf(d, c ? "day" : s), e.diff(r, n, s) > 1e5 * a)
      throw new Error(n + " and " + r + " are too far apart with stepSize of " + a + " " + s);
    const p = o.ticks.source === "data" && this.getDataTimestamps();
    for (f = d, h = 0; f < r; f = +e.add(f, a, s), h++)
      $H(u, f, p);
    return (f === r || o.bounds === "ticks" || h === 1) && $H(u, f, p), Object.keys(u).sort(TH).map((m) => +m);
  }
  getLabelForValue(e) {
    const n = this._adapter, r = this.options.time;
    return r.tooltipFormat ? n.format(e, r.tooltipFormat) : n.format(e, r.displayFormats.datetime);
  }
  format(e, n) {
    const r = this.options.time.displayFormats, o = this._unit, i = n || r[o];
    return this._adapter.format(e, i);
  }
  _tickFormatFunction(e, n, r, o) {
    const i = this.options, s = i.ticks.callback;
    if (s)
      return Wn(s, [
        e,
        n,
        r
      ], this);
    const a = i.time.displayFormats, l = this._unit, c = this._majorUnit, u = l && a[l], d = c && a[c], f = r[n], h = c && d && f && f.major;
    return this._adapter.format(e, o || (h ? d : u));
  }
  generateTickLabels(e) {
    let n, r, o;
    for (n = 0, r = e.length; n < r; ++n)
      o = e[n], o.label = this._tickFormatFunction(o.value, n, e);
  }
  getDecimalForValue(e) {
    return e === null ? NaN : (e - this.min) / (this.max - this.min);
  }
  getPixelForValue(e) {
    const n = this._offsets, r = this.getDecimalForValue(e);
    return this.getPixelForDecimal((n.start + r) * n.factor);
  }
  getValueForPixel(e) {
    const n = this._offsets, r = this.getDecimalForPixel(e) / n.factor - n.end;
    return this.min + r * (this.max - this.min);
  }
  _getLabelSize(e) {
    const n = this.options.ticks, r = this.ctx.measureText(e).width, o = xl(this.isHorizontal() ? n.maxRotation : n.minRotation), i = Math.cos(o), s = Math.sin(o), a = this._resolveTickFontOptions(0).size;
    return {
      w: r * i + a * s,
      h: r * s + a * i
    };
  }
  _getLabelCapacity(e) {
    const n = this.options.time, r = n.displayFormats, o = r[n.unit] || r.millisecond, i = this._tickFormatFunction(e, 0, MH(this, [
      e
    ], this._majorUnit), o), s = this._getLabelSize(i), a = Math.floor(this.isHorizontal() ? this.width / s.w : this.height / s.h) - 1;
    return a > 0 ? a : 1;
  }
  getDataTimestamps() {
    let e = this._cache.data || [], n, r;
    if (e.length)
      return e;
    const o = this.getMatchingVisibleMetas();
    if (this._normalized && o.length)
      return this._cache.data = o[0].controller.getAllParsedValues(this);
    for (n = 0, r = o.length; n < r; ++n)
      e = e.concat(o[n].controller.getAllParsedValues(this));
    return this._cache.data = this.normalize(e);
  }
  getLabelTimestamps() {
    const e = this._cache.labels || [];
    let n, r;
    if (e.length)
      return e;
    const o = this.getLabels();
    for (n = 0, r = o.length; n < r; ++n)
      e.push(RH(this, o[n]));
    return this._cache.labels = this._normalized ? e : this.normalize(e);
  }
  normalize(e) {
    return pme(e.sort(TH));
  }
}
ue(Ey, "id", "time"), ue(Ey, "defaults", {
  bounds: "data",
  adapters: {},
  time: {
    parser: !1,
    unit: !1,
    round: !1,
    isoWeekday: !1,
    minUnit: "millisecond",
    displayFormats: {}
  },
  ticks: {
    source: "auto",
    callback: !1,
    major: {
      enabled: !1
    }
  }
});
function y1(t, e, n) {
  let r = 0, o = t.length - 1, i, s, a, l;
  n ? (e >= t[r].pos && e <= t[o].pos && ({ lo: r, hi: o } = ld(t, "pos", e)), { pos: i, time: a } = t[r], { pos: s, time: l } = t[o]) : (e >= t[r].time && e <= t[o].time && ({ lo: r, hi: o } = ld(t, "time", e)), { time: i, pos: a } = t[r], { time: s, pos: l } = t[o]);
  const c = s - i;
  return c ? a + (l - a) * (e - i) / c : a;
}
class DH extends Ey {
  constructor(e) {
    super(e), this._table = [], this._minPos = void 0, this._tableRange = void 0;
  }
  initOffsets() {
    const e = this._getTimestampsForTable(), n = this._table = this.buildLookupTable(e);
    this._minPos = y1(n, this.min), this._tableRange = y1(n, this.max) - this._minPos, super.initOffsets(e);
  }
  buildLookupTable(e) {
    const { min: n, max: r } = this, o = [], i = [];
    let s, a, l, c, u;
    for (s = 0, a = e.length; s < a; ++s)
      c = e[s], c >= n && c <= r && o.push(c);
    if (o.length < 2)
      return [
        {
          time: n,
          pos: 0
        },
        {
          time: r,
          pos: 1
        }
      ];
    for (s = 0, a = o.length; s < a; ++s)
      u = o[s + 1], l = o[s - 1], c = o[s], Math.round((u + l) / 2) !== c && i.push({
        time: c,
        pos: s / (a - 1)
      });
    return i;
  }
  _generate() {
    const e = this.min, n = this.max;
    let r = super.getDataTimestamps();
    return (!r.includes(e) || !r.length) && r.splice(0, 0, e), (!r.includes(n) || r.length === 1) && r.push(n), r.sort((o, i) => o - i);
  }
  _getTimestampsForTable() {
    let e = this._cache.all || [];
    if (e.length)
      return e;
    const n = this.getDataTimestamps(), r = this.getLabelTimestamps();
    return n.length && r.length ? e = this.normalize(n.concat(r)) : e = n.length ? n : r, e = this._cache.all = e, e;
  }
  getDecimalForValue(e) {
    return (y1(this._table, e) - this._minPos) / this._tableRange;
  }
  getValueForPixel(e) {
    const n = this._offsets, r = this.getDecimalForPixel(e) / n.factor - n.end;
    return y1(this._table, r * this._tableRange + this._minPos, !0);
  }
}
ue(DH, "id", "timeseries"), ue(DH, "defaults", Ey.defaults);
var $p = [["Afghanistan", "af", "93"], ["Albania", "al", "355"], ["Algeria", "dz", "213"], ["Andorra", "ad", "376"], ["Angola", "ao", "244"], ["Antigua and Barbuda", "ag", "1268"], ["Argentina", "ar", "54", "(..) ........", 0], ["Armenia", "am", "374", ".. ......"], ["Aruba", "aw", "297"], ["Australia", "au", "61", { default: ". .... ....", "/^4/": "... ... ...", "/^5(?!50)/": "... ... ...", "/^1(3|8)00/": ".... ... ...", "/^13/": ".. .. ..", "/^180/": "... ...." }, 0, []], ["Austria", "at", "43"], ["Azerbaijan", "az", "994", "(..) ... .. .."], ["Bahamas", "bs", "1242"], ["Bahrain", "bh", "973"], ["Bangladesh", "bd", "880"], ["Barbados", "bb", "1246"], ["Belarus", "by", "375", "(..) ... .. .."], ["Belgium", "be", "32", "... .. .. .."], ["Belize", "bz", "501"], ["Benin", "bj", "229"], ["Bhutan", "bt", "975"], ["Bolivia", "bo", "591"], ["Bosnia and Herzegovina", "ba", "387"], ["Botswana", "bw", "267"], ["Brazil", "br", "55", "(..) .....-...."], ["British Indian Ocean Territory", "io", "246"], ["Brunei", "bn", "673"], ["Bulgaria", "bg", "359"], ["Burkina Faso", "bf", "226"], ["Burundi", "bi", "257"], ["Cambodia", "kh", "855"], ["Cameroon", "cm", "237"], ["Canada", "ca", "1", "(...) ...-....", 1, ["204", "226", "236", "249", "250", "289", "306", "343", "365", "387", "403", "416", "418", "431", "437", "438", "450", "506", "514", "519", "548", "579", "581", "587", "604", "613", "639", "647", "672", "705", "709", "742", "778", "780", "782", "807", "819", "825", "867", "873", "902", "905"]], ["Cape Verde", "cv", "238"], ["Caribbean Netherlands", "bq", "599", "", 1], ["Cayman Islands", "ky", "1", "... ... ....", 4, ["345"]], ["Central African Republic", "cf", "236"], ["Chad", "td", "235"], ["Chile", "cl", "56"], ["China", "cn", "86", "... .... ...."], ["Colombia", "co", "57", "... ... ...."], ["Comoros", "km", "269"], ["Congo", "cd", "243"], ["Congo", "cg", "242"], ["Costa Rica", "cr", "506", "....-...."], ["Côte d'Ivoire", "ci", "225", ".. .. .. .. .."], ["Croatia", "hr", "385"], ["Cuba", "cu", "53"], ["Curaçao", "cw", "599", "", 0], ["Cyprus", "cy", "357", ".. ......"], ["Czech Republic", "cz", "420", "... ... ..."], ["Denmark", "dk", "45", ".. .. .. .."], ["Djibouti", "dj", "253", ".. .. ...."], ["Dominica", "dm", "1767"], ["Dominican Republic", "do", "1", "(...) ...-....", 2, ["809", "829", "849"]], ["Ecuador", "ec", "593"], ["Egypt", "eg", "20"], ["El Salvador", "sv", "503", "....-...."], ["Equatorial Guinea", "gq", "240"], ["Eritrea", "er", "291"], ["Estonia", "ee", "372", ".... ......"], ["Ethiopia", "et", "251", ".. ... ...."], ["Fiji", "fj", "679"], ["Finland", "fi", "358", ".. ... .. .."], ["France", "fr", "33", ". .. .. .. .."], ["French Guiana", "gf", "594"], ["French Polynesia", "pf", "689"], ["Gabon", "ga", "241"], ["Gambia", "gm", "220"], ["Georgia", "ge", "995"], ["Germany", "de", "49", "... ........."], ["Ghana", "gh", "233"], ["Greece", "gr", "30"], ["Greenland", "gl", "299", ".. .. .."], ["Grenada", "gd", "1473"], ["Guadeloupe", "gp", "590", "", 0], ["Guam", "gu", "1671"], ["Guatemala", "gt", "502", "....-...."], ["Guinea", "gn", "224"], ["Guinea-Bissau", "gw", "245"], ["Guyana", "gy", "592"], ["Haiti", "ht", "509", "....-...."], ["Honduras", "hn", "504"], ["Hong Kong", "hk", "852", ".... ...."], ["Hungary", "hu", "36"], ["Iceland", "is", "354", "... ...."], ["India", "in", "91", ".....-....."], ["Indonesia", "id", "62"], ["Iran", "ir", "98", "... ... ...."], ["Iraq", "iq", "964"], ["Ireland", "ie", "353", ".. ......."], ["Israel", "il", "972", "... ... ...."], ["Italy", "it", "39", "... .......", 0], ["Jamaica", "jm", "1876"], ["Japan", "jp", "81", ".. .... ...."], ["Jordan", "jo", "962"], ["Kazakhstan", "kz", "7", "... ...-..-..", 0], ["Kenya", "ke", "254"], ["Kiribati", "ki", "686"], ["Kosovo", "xk", "383"], ["Kuwait", "kw", "965"], ["Kyrgyzstan", "kg", "996", "... ... ..."], ["Laos", "la", "856"], ["Latvia", "lv", "371", ".. ... ..."], ["Lebanon", "lb", "961"], ["Lesotho", "ls", "266"], ["Liberia", "lr", "231"], ["Libya", "ly", "218"], ["Liechtenstein", "li", "423"], ["Lithuania", "lt", "370"], ["Luxembourg", "lu", "352"], ["Macau", "mo", "853"], ["Macedonia", "mk", "389"], ["Madagascar", "mg", "261"], ["Malawi", "mw", "265"], ["Malaysia", "my", "60", "..-....-...."], ["Maldives", "mv", "960"], ["Mali", "ml", "223"], ["Malta", "mt", "356"], ["Marshall Islands", "mh", "692"], ["Martinique", "mq", "596"], ["Mauritania", "mr", "222"], ["Mauritius", "mu", "230"], ["Mayotte", "yt", "262", "", 1, ["269", "639"]], ["Mexico", "mx", "52", "... ... ....", 0], ["Micronesia", "fm", "691"], ["Moldova", "md", "373", "(..) ..-..-.."], ["Monaco", "mc", "377"], ["Mongolia", "mn", "976"], ["Montenegro", "me", "382"], ["Morocco", "ma", "212"], ["Mozambique", "mz", "258"], ["Myanmar", "mm", "95"], ["Namibia", "na", "264"], ["Nauru", "nr", "674"], ["Nepal", "np", "977"], ["Netherlands", "nl", "31", { "/^06/": "(.). .........", "/^6/": ". .........", "/^0(10|13|14|15|20|23|24|26|30|33|35|36|38|40|43|44|45|46|50|53|55|58|70|71|72|73|74|75|76|77|78|79|82|84|85|87|88|91)/": "(.).. ........", "/^(10|13|14|15|20|23|24|26|30|33|35|36|38|40|43|44|45|46|50|53|55|58|70|71|72|73|74|75|76|77|78|79|82|84|85|87|88|91)/": ".. ........", "/^0/": "(.)... .......", default: "... ......." }], ["New Caledonia", "nc", "687"], ["New Zealand", "nz", "64", "...-...-...."], ["Nicaragua", "ni", "505"], ["Niger", "ne", "227"], ["Nigeria", "ng", "234"], ["North Korea", "kp", "850"], ["Norway", "no", "47", "... .. ..."], ["Oman", "om", "968"], ["Pakistan", "pk", "92", "...-......."], ["Palau", "pw", "680"], ["Palestine", "ps", "970"], ["Panama", "pa", "507"], ["Papua New Guinea", "pg", "675"], ["Paraguay", "py", "595"], ["Peru", "pe", "51"], ["Philippines", "ph", "63", "... ... ...."], ["Poland", "pl", "48", "...-...-..."], ["Portugal", "pt", "351"], ["Puerto Rico", "pr", "1", "(...) ...-....", 3, ["787", "939"]], ["Qatar", "qa", "974"], ["Réunion", "re", "262", "", 0], ["Romania", "ro", "40"], ["Russia", "ru", "7", "(...) ...-..-..", 1], ["Rwanda", "rw", "250"], ["Saint Kitts and Nevis", "kn", "1869"], ["Saint Lucia", "lc", "1758"], ["Saint Vincent and the Grenadines", "vc", "1784"], ["Samoa", "ws", "685"], ["San Marino", "sm", "378"], ["São Tomé and Príncipe", "st", "239"], ["Saudi Arabia", "sa", "966"], ["Senegal", "sn", "221"], ["Serbia", "rs", "381"], ["Seychelles", "sc", "248"], ["Sierra Leone", "sl", "232"], ["Singapore", "sg", "65", "....-...."], ["Slovakia", "sk", "421"], ["Slovenia", "si", "386"], ["Solomon Islands", "sb", "677"], ["Somalia", "so", "252"], ["South Africa", "za", "27"], ["South Korea", "kr", "82", "... .... ...."], ["South Sudan", "ss", "211"], ["Spain", "es", "34", "... ... ..."], ["Sri Lanka", "lk", "94"], ["Sudan", "sd", "249"], ["Suriname", "sr", "597"], ["Swaziland", "sz", "268"], ["Sweden", "se", "46", "... ... ..."], ["Switzerland", "ch", "41", ".. ... .. .."], ["Syria", "sy", "963"], ["Taiwan", "tw", "886"], ["Tajikistan", "tj", "992"], ["Tanzania", "tz", "255"], ["Thailand", "th", "66"], ["Timor-Leste", "tl", "670"], ["Togo", "tg", "228"], ["Tonga", "to", "676"], ["Trinidad and Tobago", "tt", "1868"], ["Tunisia", "tn", "216"], ["Turkey", "tr", "90", "... ... .. .."], ["Turkmenistan", "tm", "993"], ["Tuvalu", "tv", "688"], ["Uganda", "ug", "256"], ["Ukraine", "ua", "380", "(..) ... .. .."], ["United Arab Emirates", "ae", "971"], ["United Kingdom", "gb", "44", ".... ......"], ["United States", "us", "1", "(...) ...-....", 0], ["Uruguay", "uy", "598"], ["Uzbekistan", "uz", "998", ".. ... .. .."], ["Vanuatu", "vu", "678"], ["Vatican City", "va", "39", ".. .... ....", 1], ["Venezuela", "ve", "58"], ["Vietnam", "vn", "84"], ["Yemen", "ye", "967"], ["Zambia", "zm", "260"], ["Zimbabwe", "zw", "263"]], Mtt = "react-international-phone-", ege = (...t) => t.filter((e) => !!e).join(" ").trim(), Dtt = (...t) => ege(...t).split(" ").map((e) => `${Mtt}${e}`).join(" "), ao = ({ addPrefix: t, rawClassNames: e }) => ege(Dtt(...t), ...e), Itt = ({ value: t, mask: e, maskSymbol: n, offset: r = 0, trimNonMaskCharsLeftover: o = !1 }) => {
  if (t.length < r) return t;
  let i = t.slice(0, r), s = t.slice(r), a = i, l = 0;
  for (let c of e.split("")) {
    if (l >= s.length) {
      if (!o && c !== n) {
        a += c;
        continue;
      }
      break;
    }
    c === n ? (a += s[l], l += 1) : a += c;
  }
  return a;
}, Lf = (t) => t ? /^\d+$/.test(t) : !1, eO = (t) => t.replace(/\D/g, ""), Ntt = (t, e) => {
  let n = t.style.display;
  n !== "block" && (t.style.display = "block");
  let r = t.getBoundingClientRect(), o = e.getBoundingClientRect(), i = o.top - r.top, s = r.bottom - o.bottom;
  i >= 0 && s >= 0 || (Math.abs(i) < Math.abs(s) ? t.scrollTop += i : t.scrollTop -= s), t.style.display = n;
}, jtt = () => typeof window > "u" ? !1 : window.navigator.userAgent.toLowerCase().includes("macintosh"), Ltt = (t, e) => {
  let n = e.disableDialCodeAndPrefix ? !1 : e.forceDialCode, r = e.disableDialCodeAndPrefix ? !1 : e.insertDialCodeOnEmpty, o = t, i = (c) => e.trimNonDigitsEnd ? c.trim() : c;
  if (!o) return r && !o.length || n ? i(`${e.prefix}${e.dialCode}${e.charAfterDialCode}`) : i(o);
  if (o = eO(o), o === e.dialCode && !e.disableDialCodeAndPrefix) return i(`${e.prefix}${e.dialCode}${e.charAfterDialCode}`);
  if (e.dialCode.startsWith(o) && !e.disableDialCodeAndPrefix) return i(n ? `${e.prefix}${e.dialCode}${e.charAfterDialCode}` : `${e.prefix}${o}`);
  if (!o.startsWith(e.dialCode) && !e.disableDialCodeAndPrefix) {
    if (n) return i(`${e.prefix}${e.dialCode}${e.charAfterDialCode}`);
    if (o.length < e.dialCode.length) return i(`${e.prefix}${o}`);
  }
  let s = () => {
    let c = e.dialCode.length, u = o.slice(0, c), d = o.slice(c);
    return { phoneLeftSide: u, phoneRightSide: d };
  }, { phoneLeftSide: a, phoneRightSide: l } = s();
  return a = `${e.prefix}${a}${e.charAfterDialCode}`, l = Itt({ value: l, mask: e.mask, maskSymbol: e.maskChar, trimNonMaskCharsLeftover: e.trimNonDigitsEnd || e.disableDialCodeAndPrefix && l.length === 0 }), e.disableDialCodeAndPrefix && (a = ""), i(`${a}${l}`);
}, Ftt = ({ phoneBeforeInput: t, phoneAfterInput: e, phoneAfterFormatted: n, cursorPositionAfterInput: r, leftOffset: o = 0, deletion: i }) => {
  if (r < o) return o;
  if (!t) return n.length;
  let s = null;
  for (let u = r - 1; u >= 0; u -= 1) if (Lf(e[u])) {
    s = u;
    break;
  }
  if (s === null) {
    for (let u = 0; u < e.length; u += 1) if (Lf(n[u])) return u;
    return e.length;
  }
  let a = 0;
  for (let u = 0; u < s; u += 1) Lf(e[u]) && (a += 1);
  let l = 0, c = 0;
  for (let u = 0; u < n.length && (l += 1, Lf(n[u]) && (c += 1), !(c >= a + 1)); u += 1) ;
  if (i !== "backward") for (; !Lf(n[l]) && l < n.length; ) l += 1;
  return l;
}, Pw = ({ phone: t, prefix: e }) => t ? `${e}${eO(t)}` : "";
function yj({ value: t, country: e, insertDialCodeOnEmpty: n, trimNonDigitsEnd: r, countries: o, prefix: i, charAfterDialCode: s, forceDialCode: a, disableDialCodeAndPrefix: l, defaultMask: c, countryGuessingEnabled: u, disableFormatting: d }) {
  let f = t;
  l && (f = f.startsWith(`${i}`) ? f : `${i}${e.dialCode}${f}`);
  let h = u ? Ktt({ phone: f, countries: o, currentCountryIso2: e?.iso2 }) : void 0, p = h?.country ?? e, m = Ltt(f, { prefix: i, mask: Gtt({ phone: f, country: p, defaultMask: c, disableFormatting: d }), maskChar: tge, dialCode: p.dialCode, trimNonDigitsEnd: r, charAfterDialCode: s, forceDialCode: a, insertDialCodeOnEmpty: n, disableDialCodeAndPrefix: l }), g = u && !h?.fullDialCodeMatch ? e : p;
  return { phone: Pw({ phone: l ? `${g.dialCode}${m}` : m, prefix: i }), inputValue: m, country: g };
}
var Btt = (t) => {
  if (t?.toLocaleLowerCase().includes("delete") ?? !1) return t?.toLocaleLowerCase().includes("forward") ? "forward" : "backward";
}, ztt = (t, { country: e, insertDialCodeOnEmpty: n, phoneBeforeInput: r, prefix: o, charAfterDialCode: i, forceDialCode: s, disableDialCodeAndPrefix: a, countryGuessingEnabled: l, defaultMask: c, disableFormatting: u, countries: d }) => {
  let f = t.nativeEvent, h = f.inputType, p = Btt(h), m = !!h?.startsWith("insertFrom"), g = h === "insertText", y = f?.data || void 0, v = t.target.value, b = t.target.selectionStart ?? 0;
  if (h?.includes("history")) return { inputValue: r, phone: Pw({ phone: r, prefix: o }), cursorPosition: r.length, country: e };
  if (g && !Lf(y) && v !== o) return { inputValue: r, phone: Pw({ phone: a ? `${e.dialCode}${r}` : r, prefix: o }), cursorPosition: b - (y?.length ?? 0), country: e };
  if (s && !v.startsWith(`${o}${e.dialCode}`) && !m) {
    let S = v ? r : `${o}${e.dialCode}${i}`;
    return { inputValue: S, phone: Pw({ phone: S, prefix: o }), cursorPosition: o.length + e.dialCode.length + i.length, country: e };
  }
  let { phone: _, inputValue: w, country: x } = yj({ value: v, country: e, trimNonDigitsEnd: p === "backward", insertDialCodeOnEmpty: n, countryGuessingEnabled: l, countries: d, prefix: o, charAfterDialCode: i, forceDialCode: s, disableDialCodeAndPrefix: a, disableFormatting: u, defaultMask: c }), E = Ftt({ cursorPositionAfterInput: b, phoneBeforeInput: r, phoneAfterInput: v, phoneAfterFormatted: w, leftOffset: s ? o.length + e.dialCode.length + i.length : 0, deletion: p });
  return { phone: _, inputValue: w, cursorPosition: E, country: x };
}, qtt = (t, e) => {
  let n = Object.keys(t), r = Object.keys(e);
  if (n.length !== r.length) return !1;
  for (let o of n) if (t[o] !== e[o]) return !1;
  return !0;
}, Utt = () => {
  let t = Ue(), e = Ue(Date.now());
  return { check: () => {
    let n = Date.now(), r = t.current ? n - e.current : void 0;
    return t.current = e.current, e.current = n, r;
  } };
}, Htt = { size: 20, overrideLastItemDebounceMS: -1 };
function Vtt(t, e) {
  let { size: n, overrideLastItemDebounceMS: r, onChange: o } = { ...Htt, ...e }, [i, s] = Ye(t), [a, l] = Ye([i]), [c, u] = Ye(0), d = Utt();
  return [i, (f, h) => {
    if (typeof f == "object" && typeof i == "object" && qtt(f, i) || f === i) return;
    let p = r > 0, m = d.check(), g = p && m !== void 0 ? m > r : !0;
    if (h?.overrideLastItem !== void 0 ? h.overrideLastItem : !g) l((y) => [...y.slice(0, c), f]);
    else {
      let y = a.length >= n;
      l((v) => [...v.slice(y ? 1 : 0, c + 1), f]), y || u((v) => v + 1);
    }
    s(f), o?.(f);
  }, () => {
    if (c <= 0) return { success: !1 };
    let f = a[c - 1];
    return s(f), u((h) => h - 1), o?.(f), { success: !0, value: f };
  }, () => {
    if (c + 1 >= a.length) return { success: !1 };
    let f = a[c + 1];
    return s(f), u((h) => h + 1), o?.(f), { success: !0, value: f };
  }];
}
var tge = ".", Ii = { defaultCountry: "us", value: "", prefix: "+", defaultMask: "............", charAfterDialCode: " ", historySaveDebounceMS: 200, disableCountryGuess: !1, disableDialCodePrefill: !1, forceDialCode: !1, disableDialCodeAndPrefix: !1, disableFormatting: !1, countries: $p }, Wtt = ({ defaultCountry: t = Ii.defaultCountry, value: e = Ii.value, countries: n = Ii.countries, prefix: r = Ii.prefix, defaultMask: o = Ii.defaultMask, charAfterDialCode: i = Ii.charAfterDialCode, historySaveDebounceMS: s = Ii.historySaveDebounceMS, disableCountryGuess: a = Ii.disableCountryGuess, disableDialCodePrefill: l = Ii.disableDialCodePrefill, forceDialCode: c = Ii.forceDialCode, disableDialCodeAndPrefix: u = Ii.disableDialCodeAndPrefix, disableFormatting: d = Ii.disableFormatting, onChange: f, inputRef: h }) => {
  let p = { countries: n, prefix: r, charAfterDialCode: i, forceDialCode: u ? !1 : c, disableDialCodeAndPrefix: u, defaultMask: o, countryGuessingEnabled: !a, disableFormatting: d }, m = Ue(null), g = h || m, y = (O) => {
    Promise.resolve().then(() => {
      typeof window > "u" || g.current !== document?.activeElement || g.current?.setSelectionRange(O, O);
    });
  }, [{ phone: v, inputValue: b, country: _ }, w, x, E] = Vtt(() => {
    let O = eh({ value: t, field: "iso2", countries: n });
    O || console.error(`[react-international-phone]: can not find a country with "${t}" iso2 code`);
    let k = O || eh({ value: "us", field: "iso2", countries: n }), { phone: T, inputValue: I, country: j } = yj({ value: e, country: k, insertDialCodeOnEmpty: !l, ...p });
    return y(I.length), { phone: T, inputValue: I, country: j.iso2 };
  }, { overrideLastItemDebounceMS: s, onChange: ({ inputValue: O, phone: k, country: T }) => {
    if (!f) return;
    let I = S(T);
    f({ phone: k, inputValue: O, country: I });
  } }), S = Cn((O) => eh({ value: O, field: "iso2", countries: n }), [n]), C = cn(() => S(_), [_, S]);
  Ne(() => {
    let O = g.current;
    if (!O) return;
    let k = (T) => {
      if (!T.key) return;
      let I = T.ctrlKey, j = T.metaKey, z = T.shiftKey;
      if (T.key.toLowerCase() === "z") {
        if (jtt()) {
          if (!j) return;
        } else if (!I) return;
        z ? E() : x();
      }
    };
    return O.addEventListener("keydown", k), () => {
      O.removeEventListener("keydown", k);
    };
  }, [g, x, E]);
  let R = (O) => {
    O.preventDefault();
    let { phone: k, inputValue: T, country: I, cursorPosition: j } = ztt(O, { country: C, phoneBeforeInput: b, insertDialCodeOnEmpty: !1, ...p });
    return w({ inputValue: T, phone: k, country: I.iso2 }), y(j), e;
  }, P = (O, k = { focusOnInput: !1 }) => {
    let T = eh({ value: O, field: "iso2", countries: n });
    if (!T) {
      console.error(`[react-international-phone]: can not find a country with "${O}" iso2 code`);
      return;
    }
    let I = u ? "" : `${r}${T.dialCode}${i}`;
    w({ inputValue: I, phone: `${r}${T.dialCode}`, country: T.iso2 }), k.focusOnInput && Promise.resolve().then(() => {
      g.current?.focus();
    });
  }, [N, A] = Ye(!1);
  return Ne(() => {
    if (!N) {
      A(!0), e !== v && f?.({ inputValue: b, phone: v, country: C });
      return;
    }
    if (e === v) return;
    let { phone: O, inputValue: k, country: T } = yj({ value: e, country: C, insertDialCodeOnEmpty: !l, ...p });
    w({ phone: O, inputValue: k, country: T.iso2 });
  }, [e]), { phone: v, inputValue: b, country: C, setCountry: P, handlePhoneValueChange: R, inputRef: g };
}, Gtt = ({ phone: t, country: e, defaultMask: n = "............", disableFormatting: r = !1 }) => {
  let o = e.format, i = (a) => r ? a.replace(new RegExp(`[^${tge}]`, "g"), "") : a;
  if (!o) return i(n);
  if (typeof o == "string") return i(o);
  if (!o.default) return console.error(`[react-international-phone]: default mask for ${e.iso2} is not provided`), i(n);
  let s = Object.keys(o).find((a) => {
    if (a === "default") return !1;
    if (!(a.charAt(0) === "/" && a.charAt(a.length - 1) === "/")) return console.error(`[react-international-phone]: format regex "${a}" for ${e.iso2} is not valid`), !1;
    let l = new RegExp(a.substring(1, a.length - 1)), c = t.replace(e.dialCode, "");
    return l.test(eO(c));
  });
  return i(s ? o[s] : o.default);
}, ta = (t) => {
  let [e, n, r, o, i, s] = t;
  return { name: e, iso2: n, dialCode: r, format: o, priority: i, areaCodes: s };
}, Ytt = (t) => `Field "${t}" is not supported`, eh = ({ field: t, value: e, countries: n = $p }) => {
  if (["priority"].includes(t)) throw new Error(Ytt(t));
  let r = n.find((o) => {
    let i = ta(o);
    return e === i[t];
  });
  if (r) return ta(r);
}, Ktt = ({ phone: t, countries: e = $p, currentCountryIso2: n }) => {
  let r = { country: void 0, fullDialCodeMatch: !1 };
  if (!t) return r;
  let o = eO(t);
  if (!o) return r;
  let i = r, s = ({ country: a, fullDialCodeMatch: l }) => {
    let c = a.dialCode === i.country?.dialCode, u = (a.priority ?? 0) < (i.country?.priority ?? 0);
    (!c || u) && (i = { country: a, fullDialCodeMatch: l });
  };
  for (let a of e) {
    let l = ta(a), { dialCode: c, areaCodes: u } = l;
    if (o.startsWith(c)) {
      let d = i.country ? Number(c) >= Number(i.country.dialCode) : !0;
      if (u) {
        let f = o.substring(c.length);
        for (let h of u) if (f.startsWith(h)) return { country: l, fullDialCodeMatch: !0 };
      }
      (d || c === o || !i.fullDialCodeMatch) && s({ country: l, fullDialCodeMatch: !0 });
    }
    i.fullDialCodeMatch || o.length < c.length && c.startsWith(o) && (!i.country || Number(c) <= Number(i.country.dialCode)) && s({ country: l, fullDialCodeMatch: !1 });
  }
  if (n) {
    let a = eh({ value: n, field: "iso2", countries: e });
    if (!a) return i;
    let l = a ? ((c) => {
      if (!c?.areaCodes) return !1;
      let u = o.substring(c.dialCode.length);
      return c.areaCodes.some((d) => d.startsWith(u));
    })(a) : !1;
    i && i.country?.dialCode === a.dialCode && i.country !== a && i.fullDialCodeMatch && (!a.areaCodes || l) && (i = { country: a, fullDialCodeMatch: !0 });
  }
  return i;
}, Xtt = (t, e) => {
  let n = parseInt(t, 16);
  return Number(n + e).toString(16);
}, Qtt = "abcdefghijklmnopqrstuvwxyz", Ztt = "1f1e6", IH = Qtt.split("").reduce((t, e, n) => ({ ...t, [e]: Xtt(Ztt, n) }), {}), Jtt = (t) => [IH[t[0]], IH[t[1]]].join("-"), nge = ({ iso2: t, size: e, src: n, protocol: r = "https", disableLazyLoading: o, className: i, style: s, ...a }) => {
  if (!t) return xe.createElement("img", { className: ao({ addPrefix: ["flag-emoji"], rawClassNames: [i] }), width: e, height: e, ...a });
  let l = () => {
    if (n) return n;
    let c = Jtt(t);
    return `${r}://cdnjs.cloudflare.com/ajax/libs/twemoji/14.0.2/svg/${c}.svg`;
  };
  return xe.createElement("img", { className: ao({ addPrefix: ["flag-emoji"], rawClassNames: [i] }), src: l(), width: e, height: e, draggable: !1, "data-country": t, loading: o ? void 0 : "lazy", style: { width: e, height: e, ...s }, alt: "", ...a });
}, ent = 1e3, tnt = ({ show: t, dialCodePrefix: e = "+", selectedCountry: n, countries: r = $p, preferredCountries: o = [], flags: i, onSelect: s, onClose: a, ...l }) => {
  let c = Ue(null), u = Ue(), d = cn(() => {
    if (!o || !o.length) return r;
    let x = [], E = [...r];
    for (let S of o) {
      let C = E.findIndex((R) => ta(R).iso2 === S);
      if (C !== -1) {
        let R = E.splice(C, 1)[0];
        x.push(R);
      }
    }
    return x.concat(E);
  }, [r, o]), f = Ue({ updatedAt: void 0, value: "" }), h = (x) => {
    let E = f.current.updatedAt && (/* @__PURE__ */ new Date()).getTime() - f.current.updatedAt.getTime() > ent;
    f.current = { value: E ? x : `${f.current.value}${x}`, updatedAt: /* @__PURE__ */ new Date() };
    let S = d.findIndex((C) => ta(C).name.toLowerCase().startsWith(f.current.value));
    S !== -1 && g(S);
  }, p = Cn((x) => d.findIndex((E) => ta(E).iso2 === x), [d]), [m, g] = Ye(p(n)), y = () => {
    u.current !== n && g(p(n));
  }, v = Cn((x) => {
    g(p(x.iso2)), s?.(x);
  }, [s, p]), b = (x) => {
    let E = d.length - 1, S = (C) => x === "prev" ? C - 1 : x === "next" ? C + 1 : x === "last" ? E : 0;
    g((C) => {
      let R = S(C);
      return R < 0 ? 0 : R > E ? E : R;
    });
  }, _ = (x) => {
    if (x.stopPropagation(), x.key === "Enter") {
      x.preventDefault();
      let E = ta(d[m]);
      v(E);
      return;
    }
    if (x.key === "Escape") {
      a?.();
      return;
    }
    if (x.key === "ArrowUp") {
      x.preventDefault(), b("prev");
      return;
    }
    if (x.key === "ArrowDown") {
      x.preventDefault(), b("next");
      return;
    }
    if (x.key === "PageUp") {
      x.preventDefault(), b("first");
      return;
    }
    if (x.key === "PageDown") {
      x.preventDefault(), b("last");
      return;
    }
    x.key === " " && x.preventDefault(), x.key.length === 1 && !x.altKey && !x.ctrlKey && !x.metaKey && h(x.key.toLocaleLowerCase());
  }, w = Cn(() => {
    if (!c.current || m === void 0) return;
    let x = ta(d[m]).iso2;
    if (x === u.current) return;
    let E = c.current.querySelector(`[data-country="${x}"]`);
    E && (Ntt(c.current, E), u.current = x);
  }, [m, d]);
  return Ne(() => {
    w();
  }, [m, w]), Ne(() => {
    c.current && (t ? c.current.focus() : y());
  }, [t]), Ne(() => {
    y();
  }, [n]), xe.createElement("ul", { ref: c, role: "listbox", className: ao({ addPrefix: ["country-selector-dropdown"], rawClassNames: [l.className] }), style: { display: t ? "block" : "none", ...l.style }, onKeyDown: _, onBlur: a, tabIndex: -1, "aria-activedescendant": `react-international-phone__${ta(d[m]).iso2}-option` }, d.map((x, E) => {
    let S = ta(x), C = S.iso2 === n, R = E === m, P = o.includes(S.iso2), N = E === o.length - 1, A = i?.find((O) => O.iso2 === S.iso2);
    return xe.createElement(xe.Fragment, { key: S.iso2 }, xe.createElement("li", { "data-country": S.iso2, role: "option", "aria-selected": C, "aria-label": `${S.name} ${e}${S.dialCode}`, id: `react-international-phone__${S.iso2}-option`, className: ao({ addPrefix: ["country-selector-dropdown__list-item", P && "country-selector-dropdown__list-item--preferred", C && "country-selector-dropdown__list-item--selected", R && "country-selector-dropdown__list-item--focused"], rawClassNames: [l.listItemClassName] }), onClick: () => v(S), style: l.listItemStyle, title: S.name }, xe.createElement(nge, { iso2: S.iso2, src: A?.src, className: ao({ addPrefix: ["country-selector-dropdown__list-item-flag-emoji"], rawClassNames: [l.listItemFlagClassName] }), style: l.listItemFlagStyle }), xe.createElement("span", { className: ao({ addPrefix: ["country-selector-dropdown__list-item-country-name"], rawClassNames: [l.listItemCountryNameClassName] }), style: l.listItemCountryNameStyle }, S.name), xe.createElement("span", { className: ao({ addPrefix: ["country-selector-dropdown__list-item-dial-code"], rawClassNames: [l.listItemDialCodeClassName] }), style: l.listItemDialCodeStyle }, e, S.dialCode)), N ? xe.createElement("hr", { className: ao({ addPrefix: ["country-selector-dropdown__preferred-list-divider"], rawClassNames: [l.preferredListDividerClassName] }), style: l.preferredListDividerStyle }) : null);
  }));
}, nnt = ({ selectedCountry: t, onSelect: e, disabled: n, hideDropdown: r, countries: o = $p, preferredCountries: i = [], flags: s, renderButtonWrapper: a, ...l }) => {
  let [c, u] = Ye(!1), d = cn(() => {
    if (t) return eh({ value: t, field: "iso2", countries: o });
  }, [o, t]), f = Ue(null), h = (m) => {
    m.key && ["ArrowUp", "ArrowDown"].includes(m.key) && (m.preventDefault(), u(!0));
  }, p = () => {
    let m = { title: d?.name, onClick: () => u((y) => !y), onMouseDown: (y) => y.preventDefault(), onKeyDown: h, disabled: r || n, role: "combobox", "aria-label": "Country selector", "aria-haspopup": "listbox", "aria-expanded": c }, g = xe.createElement("div", { className: ao({ addPrefix: ["country-selector-button__button-content"], rawClassNames: [l.buttonContentWrapperClassName] }), style: l.buttonContentWrapperStyle }, xe.createElement(nge, { iso2: t, src: s?.find((y) => y.iso2 === t)?.src, className: ao({ addPrefix: ["country-selector-button__flag-emoji", n && "country-selector-button__flag-emoji--disabled"], rawClassNames: [l.flagClassName] }), style: { visibility: t ? "visible" : "hidden", ...l.flagStyle } }), !r && xe.createElement("div", { className: ao({ addPrefix: ["country-selector-button__dropdown-arrow", n && "country-selector-button__dropdown-arrow--disabled", c && "country-selector-button__dropdown-arrow--active"], rawClassNames: [l.dropdownArrowClassName] }), style: l.dropdownArrowStyle }));
    return a ? a({ children: g, rootProps: m }) : xe.createElement("button", { ...m, type: "button", className: ao({ addPrefix: ["country-selector-button", c && "country-selector-button--active", n && "country-selector-button--disabled", r && "country-selector-button--hide-dropdown"], rawClassNames: [l.buttonClassName] }), "data-country": t, style: l.buttonStyle }, g);
  };
  return xe.createElement("div", { className: ao({ addPrefix: ["country-selector"], rawClassNames: [l.className] }), style: l.style, ref: f }, p(), xe.createElement(tnt, { show: c, countries: o, preferredCountries: i, flags: s, onSelect: (m) => {
    u(!1), e?.(m);
  }, selectedCountry: t, onClose: () => {
    u(!1);
  }, ...l.dropdownStyleProps }));
}, rnt = ({ dialCode: t, prefix: e, disabled: n, style: r, className: o }) => xe.createElement("div", { className: ao({ addPrefix: ["dial-code-preview", n && "dial-code-preview--disabled"], rawClassNames: [o] }), style: r }, `${e}${t}`);
Ri(({ value: t, onChange: e, countries: n = $p, preferredCountries: r = [], hideDropdown: o, showDisabledDialCodeAndPrefix: i, disableFocusAfterCountrySelect: s, flags: a, style: l, className: c, inputStyle: u, inputClassName: d, countrySelectorStyleProps: f, dialCodePreviewStyleProps: h, inputProps: p, placeholder: m, disabled: g, name: y, onFocus: v, onBlur: b, required: _, autoFocus: w, ...x }, E) => {
  let { phone: S, inputValue: C, inputRef: R, country: P, setCountry: N, handlePhoneValueChange: A } = Wtt({ value: t, countries: n, ...x, onChange: (k) => {
    e?.(k.phone, { country: k.country, inputValue: k.inputValue });
  } }), O = x.disableDialCodeAndPrefix && i && P?.dialCode;
  return Rse(E, () => R.current ? Object.assign(R.current, { setCountry: N, state: { phone: S, inputValue: C, country: P } }) : null, [R, N, S, C, P]), xe.createElement("div", { ref: E, className: ao({ addPrefix: ["input-container"], rawClassNames: [c] }), style: l }, xe.createElement(nnt, { onSelect: (k) => N(k.iso2, { focusOnInput: !s }), flags: a, selectedCountry: P.iso2, countries: n, preferredCountries: r, disabled: g, hideDropdown: o, ...f }), O && xe.createElement(rnt, { dialCode: P.dialCode, prefix: x.prefix ?? "+", disabled: g, ...h }), xe.createElement("input", { onChange: A, value: C, type: "tel", ref: R, className: ao({ addPrefix: ["input", g && "input--disabled"], rawClassNames: [d] }), placeholder: m, disabled: g, style: u, name: y, onFocus: v, onBlur: b, autoFocus: w, required: _, ...p }));
});
var NH = { exports: {} }, jH;
function m4() {
  return jH || (jH = 1, function(t) {
    function e(n) {
      return n && n.__esModule ? n : {
        default: n
      };
    }
    t.exports = e, t.exports.__esModule = !0, t.exports.default = t.exports;
  }(NH)), NH.exports;
}
var l2 = { exports: {} }, c2, LH;
function rge() {
  if (LH) return c2;
  LH = 1;
  var t = Object.prototype.toString;
  return c2 = function(e) {
    var n = t.call(e), r = n === "[object Arguments]";
    return r || (r = n !== "[object Array]" && e !== null && typeof e == "object" && typeof e.length == "number" && e.length >= 0 && t.call(e.callee) === "[object Function]"), r;
  }, c2;
}
var u2, FH;
function ont() {
  if (FH) return u2;
  FH = 1;
  var t;
  if (!Object.keys) {
    var e = Object.prototype.hasOwnProperty, n = Object.prototype.toString, r = rge(), o = Object.prototype.propertyIsEnumerable, i = !o.call({ toString: null }, "toString"), s = o.call(function() {
    }, "prototype"), a = [
      "toString",
      "toLocaleString",
      "valueOf",
      "hasOwnProperty",
      "isPrototypeOf",
      "propertyIsEnumerable",
      "constructor"
    ], l = function(f) {
      var h = f.constructor;
      return h && h.prototype === f;
    }, c = {
      $applicationCache: !0,
      $console: !0,
      $external: !0,
      $frame: !0,
      $frameElement: !0,
      $frames: !0,
      $innerHeight: !0,
      $innerWidth: !0,
      $onmozfullscreenchange: !0,
      $onmozfullscreenerror: !0,
      $outerHeight: !0,
      $outerWidth: !0,
      $pageXOffset: !0,
      $pageYOffset: !0,
      $parent: !0,
      $scrollLeft: !0,
      $scrollTop: !0,
      $scrollX: !0,
      $scrollY: !0,
      $self: !0,
      $webkitIndexedDB: !0,
      $webkitStorageInfo: !0,
      $window: !0
    }, u = function() {
      if (typeof window > "u")
        return !1;
      for (var f in window)
        try {
          if (!c["$" + f] && e.call(window, f) && window[f] !== null && typeof window[f] == "object")
            try {
              l(window[f]);
            } catch {
              return !0;
            }
        } catch {
          return !0;
        }
      return !1;
    }(), d = function(f) {
      if (typeof window > "u" || !u)
        return l(f);
      try {
        return l(f);
      } catch {
        return !1;
      }
    };
    t = function(f) {
      var h = f !== null && typeof f == "object", p = n.call(f) === "[object Function]", m = r(f), g = h && n.call(f) === "[object String]", y = [];
      if (!h && !p && !m)
        throw new TypeError("Object.keys called on a non-object");
      var v = s && p;
      if (g && f.length > 0 && !e.call(f, 0))
        for (var b = 0; b < f.length; ++b)
          y.push(String(b));
      if (m && f.length > 0)
        for (var _ = 0; _ < f.length; ++_)
          y.push(String(_));
      else
        for (var w in f)
          !(v && w === "prototype") && e.call(f, w) && y.push(String(w));
      if (i)
        for (var x = d(f), E = 0; E < a.length; ++E)
          !(x && a[E] === "constructor") && e.call(f, a[E]) && y.push(a[E]);
      return y;
    };
  }
  return u2 = t, u2;
}
var d2, BH;
function g4() {
  if (BH) return d2;
  BH = 1;
  var t = Array.prototype.slice, e = rge(), n = Object.keys, r = n ? function(i) {
    return n(i);
  } : ont(), o = Object.keys;
  return r.shim = function() {
    if (Object.keys) {
      var i = function() {
        var s = Object.keys(arguments);
        return s && s.length === arguments.length;
      }(1, 2);
      i || (Object.keys = function(s) {
        return e(s) ? o(t.call(s)) : o(s);
      });
    } else
      Object.keys = r;
    return Object.keys || r;
  }, d2 = r, d2;
}
var f2, zH;
function Cv() {
  if (zH) return f2;
  zH = 1;
  var t = Object.defineProperty || !1;
  if (t)
    try {
      t({}, "a", { value: 1 });
    } catch {
      t = !1;
    }
  return f2 = t, f2;
}
var qH, UH;
function oge() {
  return UH || (UH = 1, qH = SyntaxError), qH;
}
var HH, VH;
function go() {
  return VH || (VH = 1, HH = TypeError), HH;
}
var WH, GH;
function int() {
  return GH || (GH = 1, WH = Object.getOwnPropertyDescriptor), WH;
}
var h2, YH;
function kv() {
  if (YH) return h2;
  YH = 1;
  var t = /* @__PURE__ */ int();
  if (t)
    try {
      t([], "length");
    } catch {
      t = null;
    }
  return h2 = t, h2;
}
var p2, KH;
function ige() {
  if (KH) return p2;
  KH = 1;
  var t = /* @__PURE__ */ Cv(), e = /* @__PURE__ */ oge(), n = /* @__PURE__ */ go(), r = /* @__PURE__ */ kv();
  return p2 = function(o, i, s) {
    if (!o || typeof o != "object" && typeof o != "function")
      throw new n("`obj` must be an object or a function`");
    if (typeof i != "string" && typeof i != "symbol")
      throw new n("`property` must be a string or a symbol`");
    if (arguments.length > 3 && typeof arguments[3] != "boolean" && arguments[3] !== null)
      throw new n("`nonEnumerable`, if provided, must be a boolean or null");
    if (arguments.length > 4 && typeof arguments[4] != "boolean" && arguments[4] !== null)
      throw new n("`nonWritable`, if provided, must be a boolean or null");
    if (arguments.length > 5 && typeof arguments[5] != "boolean" && arguments[5] !== null)
      throw new n("`nonConfigurable`, if provided, must be a boolean or null");
    if (arguments.length > 6 && typeof arguments[6] != "boolean")
      throw new n("`loose`, if provided, must be a boolean");
    var a = arguments.length > 3 ? arguments[3] : null, l = arguments.length > 4 ? arguments[4] : null, c = arguments.length > 5 ? arguments[5] : null, u = arguments.length > 6 ? arguments[6] : !1, d = !!r && r(o, i);
    if (t)
      t(o, i, {
        configurable: c === null && d ? d.configurable : !c,
        enumerable: a === null && d ? d.enumerable : !a,
        value: s,
        writable: l === null && d ? d.writable : !l
      });
    else if (u || !a && !l && !c)
      o[i] = s;
    else
      throw new e("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
  }, p2;
}
var m2, XH;
function y4() {
  if (XH) return m2;
  XH = 1;
  var t = /* @__PURE__ */ Cv(), e = function() {
    return !!t;
  };
  return e.hasArrayLengthDefineBug = function() {
    if (!t)
      return null;
    try {
      return t([], "length", { value: 1 }).length !== 1;
    } catch {
      return !0;
    }
  }, m2 = e, m2;
}
var g2, QH;
function to() {
  if (QH) return g2;
  QH = 1;
  var t = g4(), e = typeof Symbol == "function" && typeof Symbol("foo") == "symbol", n = Object.prototype.toString, r = Array.prototype.concat, o = /* @__PURE__ */ ige(), i = function(c) {
    return typeof c == "function" && n.call(c) === "[object Function]";
  }, s = /* @__PURE__ */ y4()(), a = function(c, u, d, f) {
    if (u in c) {
      if (f === !0) {
        if (c[u] === d)
          return;
      } else if (!i(f) || !f())
        return;
    }
    s ? o(c, u, d, !0) : o(c, u, d);
  }, l = function(c, u) {
    var d = arguments.length > 2 ? arguments[2] : {}, f = t(u);
    e && (f = r.call(f, Object.getOwnPropertySymbols(u)));
    for (var h = 0; h < f.length; h += 1)
      a(c, f[h], u[f[h]], d[f[h]]);
  };
  return l.supportsDescriptors = !!s, g2 = l, g2;
}
var ZH = { exports: {} }, JH, eV;
function sge() {
  return eV || (eV = 1, JH = Object), JH;
}
var tV, nV;
function snt() {
  return nV || (nV = 1, tV = Error), tV;
}
var rV, oV;
function ant() {
  return oV || (oV = 1, rV = EvalError), rV;
}
var iV, sV;
function lnt() {
  return sV || (sV = 1, iV = RangeError), iV;
}
var aV, lV;
function cnt() {
  return lV || (lV = 1, aV = ReferenceError), aV;
}
var cV, uV;
function unt() {
  return uV || (uV = 1, cV = URIError), cV;
}
var dV, fV;
function dnt() {
  return fV || (fV = 1, dV = Math.abs), dV;
}
var hV, pV;
function fnt() {
  return pV || (pV = 1, hV = Math.floor), hV;
}
var mV, gV;
function hnt() {
  return gV || (gV = 1, mV = Math.max), mV;
}
var yV, vV;
function pnt() {
  return vV || (vV = 1, yV = Math.min), yV;
}
var bV, _V;
function mnt() {
  return _V || (_V = 1, bV = Math.pow), bV;
}
var wV, xV;
function v4() {
  return xV || (xV = 1, wV = function() {
    if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
      return !1;
    if (typeof Symbol.iterator == "symbol")
      return !0;
    var t = {}, e = Symbol("test"), n = Object(e);
    if (typeof e == "string" || Object.prototype.toString.call(e) !== "[object Symbol]" || Object.prototype.toString.call(n) !== "[object Symbol]")
      return !1;
    var r = 42;
    t[e] = r;
    for (var o in t)
      return !1;
    if (typeof Object.keys == "function" && Object.keys(t).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(t).length !== 0)
      return !1;
    var i = Object.getOwnPropertySymbols(t);
    if (i.length !== 1 || i[0] !== e || !Object.prototype.propertyIsEnumerable.call(t, e))
      return !1;
    if (typeof Object.getOwnPropertyDescriptor == "function") {
      var s = (
        /** @type {PropertyDescriptor} */
        Object.getOwnPropertyDescriptor(t, e)
      );
      if (s.value !== r || s.enumerable !== !0)
        return !1;
    }
    return !0;
  }), wV;
}
var y2, EV;
function age() {
  if (EV) return y2;
  EV = 1;
  var t = typeof Symbol < "u" && Symbol, e = v4();
  return y2 = function() {
    return typeof t != "function" || typeof Symbol != "function" || typeof t("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : e();
  }, y2;
}
var v2, SV;
function gnt() {
  if (SV) return v2;
  SV = 1;
  var t = "Function.prototype.bind called on incompatible ", e = Object.prototype.toString, n = Math.max, r = "[object Function]", o = function(a, l) {
    for (var c = [], u = 0; u < a.length; u += 1)
      c[u] = a[u];
    for (var d = 0; d < l.length; d += 1)
      c[d + a.length] = l[d];
    return c;
  }, i = function(a, l) {
    for (var c = [], u = l, d = 0; u < a.length; u += 1, d += 1)
      c[d] = a[u];
    return c;
  }, s = function(a, l) {
    for (var c = "", u = 0; u < a.length; u += 1)
      c += a[u], u + 1 < a.length && (c += l);
    return c;
  };
  return v2 = function(a) {
    var l = this;
    if (typeof l != "function" || e.apply(l) !== r)
      throw new TypeError(t + l);
    for (var c = i(arguments, 1), u, d = function() {
      if (this instanceof u) {
        var g = l.apply(
          this,
          o(c, arguments)
        );
        return Object(g) === g ? g : this;
      }
      return l.apply(
        a,
        o(c, arguments)
      );
    }, f = n(0, l.length - c.length), h = [], p = 0; p < f; p++)
      h[p] = "$" + p;
    if (u = Function("binder", "return function (" + s(h, ",") + "){ return binder.apply(this,arguments); }")(d), l.prototype) {
      var m = function() {
      };
      m.prototype = l.prototype, u.prototype = new m(), m.prototype = null;
    }
    return u;
  }, v2;
}
var b2, OV;
function Av() {
  if (OV) return b2;
  OV = 1;
  var t = gnt();
  return b2 = Function.prototype.bind || t, b2;
}
var CV, kV;
function b4() {
  return kV || (kV = 1, CV = Function.prototype.call), CV;
}
var AV, TV;
function _4() {
  return TV || (TV = 1, AV = Function.prototype.apply), AV;
}
var RV, PV;
function ynt() {
  return PV || (PV = 1, RV = typeof Reflect < "u" && Reflect && Reflect.apply), RV;
}
var _2, $V;
function lge() {
  if ($V) return _2;
  $V = 1;
  var t = Av(), e = _4(), n = b4(), r = ynt();
  return _2 = r || t.call(n, e), _2;
}
var w2, MV;
function cge() {
  if (MV) return w2;
  MV = 1;
  var t = Av(), e = /* @__PURE__ */ go(), n = b4(), r = lge();
  return w2 = function(o) {
    if (o.length < 1 || typeof o[0] != "function")
      throw new e("a function is required");
    return r(t, n, o);
  }, w2;
}
var x2, DV;
function vnt() {
  if (DV) return x2;
  DV = 1;
  var t = cge(), e = /* @__PURE__ */ kv(), n;
  try {
    n = /** @type {{ __proto__?: typeof Array.prototype }} */
    [].__proto__ === Array.prototype;
  } catch (s) {
    if (!s || typeof s != "object" || !("code" in s) || s.code !== "ERR_PROTO_ACCESS")
      throw s;
  }
  var r = !!n && e && e(
    Object.prototype,
    /** @type {keyof typeof Object.prototype} */
    "__proto__"
  ), o = Object, i = o.getPrototypeOf;
  return x2 = r && typeof r.get == "function" ? t([r.get]) : typeof i == "function" ? (
    /** @type {import('./get')} */
    function(s) {
      return i(s == null ? s : o(s));
    }
  ) : !1, x2;
}
var E2, IV;
function cu() {
  if (IV) return E2;
  IV = 1;
  var t = Function.prototype.call, e = Object.prototype.hasOwnProperty, n = Av();
  return E2 = n.call(t, e), E2;
}
var S2, NV;
function uu() {
  if (NV) return S2;
  NV = 1;
  var t, e = /* @__PURE__ */ sge(), n = /* @__PURE__ */ snt(), r = /* @__PURE__ */ ant(), o = /* @__PURE__ */ lnt(), i = /* @__PURE__ */ cnt(), s = /* @__PURE__ */ oge(), a = /* @__PURE__ */ go(), l = /* @__PURE__ */ unt(), c = /* @__PURE__ */ dnt(), u = /* @__PURE__ */ fnt(), d = /* @__PURE__ */ hnt(), f = /* @__PURE__ */ pnt(), h = /* @__PURE__ */ mnt(), p = Function, m = function(H) {
    try {
      return p('"use strict"; return (' + H + ").constructor;")();
    } catch {
    }
  }, g = /* @__PURE__ */ kv(), y = /* @__PURE__ */ Cv(), v = function() {
    throw new a();
  }, b = g ? function() {
    try {
      return arguments.callee, v;
    } catch {
      try {
        return g(arguments, "callee").get;
      } catch {
        return v;
      }
    }
  }() : v, _ = age()(), w = /* @__PURE__ */ vnt(), x = typeof Reflect == "function" && Reflect.getPrototypeOf || e.getPrototypeOf || w, E = _4(), S = b4(), C = {}, R = typeof Uint8Array > "u" || !x ? t : x(Uint8Array), P = {
    __proto__: null,
    "%AggregateError%": typeof AggregateError > "u" ? t : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer > "u" ? t : ArrayBuffer,
    "%ArrayIteratorPrototype%": _ && x ? x([][Symbol.iterator]()) : t,
    "%AsyncFromSyncIteratorPrototype%": t,
    "%AsyncFunction%": C,
    "%AsyncGenerator%": C,
    "%AsyncGeneratorFunction%": C,
    "%AsyncIteratorPrototype%": C,
    "%Atomics%": typeof Atomics > "u" ? t : Atomics,
    "%BigInt%": typeof BigInt > "u" ? t : BigInt,
    "%BigInt64Array%": typeof BigInt64Array > "u" ? t : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array > "u" ? t : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView > "u" ? t : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": n,
    "%eval%": eval,
    // eslint-disable-line no-eval
    "%EvalError%": r,
    "%Float32Array%": typeof Float32Array > "u" ? t : Float32Array,
    "%Float64Array%": typeof Float64Array > "u" ? t : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? t : FinalizationRegistry,
    "%Function%": p,
    "%GeneratorFunction%": C,
    "%Int8Array%": typeof Int8Array > "u" ? t : Int8Array,
    "%Int16Array%": typeof Int16Array > "u" ? t : Int16Array,
    "%Int32Array%": typeof Int32Array > "u" ? t : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": _ && x ? x(x([][Symbol.iterator]())) : t,
    "%JSON%": typeof JSON == "object" ? JSON : t,
    "%Map%": typeof Map > "u" ? t : Map,
    "%MapIteratorPrototype%": typeof Map > "u" || !_ || !x ? t : x((/* @__PURE__ */ new Map())[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": e,
    "%Object.getOwnPropertyDescriptor%": g,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise > "u" ? t : Promise,
    "%Proxy%": typeof Proxy > "u" ? t : Proxy,
    "%RangeError%": o,
    "%ReferenceError%": i,
    "%Reflect%": typeof Reflect > "u" ? t : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set > "u" ? t : Set,
    "%SetIteratorPrototype%": typeof Set > "u" || !_ || !x ? t : x((/* @__PURE__ */ new Set())[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? t : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": _ && x ? x(""[Symbol.iterator]()) : t,
    "%Symbol%": _ ? Symbol : t,
    "%SyntaxError%": s,
    "%ThrowTypeError%": b,
    "%TypedArray%": R,
    "%TypeError%": a,
    "%Uint8Array%": typeof Uint8Array > "u" ? t : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? t : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array > "u" ? t : Uint16Array,
    "%Uint32Array%": typeof Uint32Array > "u" ? t : Uint32Array,
    "%URIError%": l,
    "%WeakMap%": typeof WeakMap > "u" ? t : WeakMap,
    "%WeakRef%": typeof WeakRef > "u" ? t : WeakRef,
    "%WeakSet%": typeof WeakSet > "u" ? t : WeakSet,
    "%Function.prototype.call%": S,
    "%Function.prototype.apply%": E,
    "%Object.defineProperty%": y,
    "%Math.abs%": c,
    "%Math.floor%": u,
    "%Math.max%": d,
    "%Math.min%": f,
    "%Math.pow%": h
  };
  if (x)
    try {
      null.error;
    } catch (H) {
      var N = x(x(H));
      P["%Error.prototype%"] = N;
    }
  var A = function H(Z) {
    var W;
    if (Z === "%AsyncFunction%")
      W = m("async function () {}");
    else if (Z === "%GeneratorFunction%")
      W = m("function* () {}");
    else if (Z === "%AsyncGeneratorFunction%")
      W = m("async function* () {}");
    else if (Z === "%AsyncGenerator%") {
      var G = H("%AsyncGeneratorFunction%");
      G && (W = G.prototype);
    } else if (Z === "%AsyncIteratorPrototype%") {
      var ee = H("%AsyncGenerator%");
      ee && x && (W = x(ee.prototype));
    }
    return P[Z] = W, W;
  }, O = {
    __proto__: null,
    "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
    "%ArrayPrototype%": ["Array", "prototype"],
    "%ArrayProto_entries%": ["Array", "prototype", "entries"],
    "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
    "%ArrayProto_keys%": ["Array", "prototype", "keys"],
    "%ArrayProto_values%": ["Array", "prototype", "values"],
    "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
    "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
    "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
    "%BooleanPrototype%": ["Boolean", "prototype"],
    "%DataViewPrototype%": ["DataView", "prototype"],
    "%DatePrototype%": ["Date", "prototype"],
    "%ErrorPrototype%": ["Error", "prototype"],
    "%EvalErrorPrototype%": ["EvalError", "prototype"],
    "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
    "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
    "%FunctionPrototype%": ["Function", "prototype"],
    "%Generator%": ["GeneratorFunction", "prototype"],
    "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
    "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
    "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
    "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
    "%JSONParse%": ["JSON", "parse"],
    "%JSONStringify%": ["JSON", "stringify"],
    "%MapPrototype%": ["Map", "prototype"],
    "%NumberPrototype%": ["Number", "prototype"],
    "%ObjectPrototype%": ["Object", "prototype"],
    "%ObjProto_toString%": ["Object", "prototype", "toString"],
    "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
    "%PromisePrototype%": ["Promise", "prototype"],
    "%PromiseProto_then%": ["Promise", "prototype", "then"],
    "%Promise_all%": ["Promise", "all"],
    "%Promise_reject%": ["Promise", "reject"],
    "%Promise_resolve%": ["Promise", "resolve"],
    "%RangeErrorPrototype%": ["RangeError", "prototype"],
    "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
    "%RegExpPrototype%": ["RegExp", "prototype"],
    "%SetPrototype%": ["Set", "prototype"],
    "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
    "%StringPrototype%": ["String", "prototype"],
    "%SymbolPrototype%": ["Symbol", "prototype"],
    "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
    "%TypedArrayPrototype%": ["TypedArray", "prototype"],
    "%TypeErrorPrototype%": ["TypeError", "prototype"],
    "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
    "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
    "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
    "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
    "%URIErrorPrototype%": ["URIError", "prototype"],
    "%WeakMapPrototype%": ["WeakMap", "prototype"],
    "%WeakSetPrototype%": ["WeakSet", "prototype"]
  }, k = Av(), T = /* @__PURE__ */ cu(), I = k.call(S, Array.prototype.concat), j = k.call(E, Array.prototype.splice), z = k.call(S, String.prototype.replace), $ = k.call(S, String.prototype.slice), D = k.call(S, RegExp.prototype.exec), U = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, q = /\\(\\)?/g, F = function(H) {
    var Z = $(H, 0, 1), W = $(H, -1);
    if (Z === "%" && W !== "%")
      throw new s("invalid intrinsic syntax, expected closing `%`");
    if (W === "%" && Z !== "%")
      throw new s("invalid intrinsic syntax, expected opening `%`");
    var G = [];
    return z(H, U, function(ee, Y, L, V) {
      G[G.length] = L ? z(V, q, "$1") : Y || ee;
    }), G;
  }, B = function(H, Z) {
    var W = H, G;
    if (T(O, W) && (G = O[W], W = "%" + G[0] + "%"), T(P, W)) {
      var ee = P[W];
      if (ee === C && (ee = A(W)), typeof ee > "u" && !Z)
        throw new a("intrinsic " + H + " exists, but is not available. Please file an issue!");
      return {
        alias: G,
        name: W,
        value: ee
      };
    }
    throw new s("intrinsic " + H + " does not exist!");
  };
  return S2 = function(H, Z) {
    if (typeof H != "string" || H.length === 0)
      throw new a("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof Z != "boolean")
      throw new a('"allowMissing" argument must be a boolean');
    if (D(/^%?[^%]*%?$/, H) === null)
      throw new s("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var W = F(H), G = W.length > 0 ? W[0] : "", ee = B("%" + G + "%", Z), Y = ee.name, L = ee.value, V = !1, K = ee.alias;
    K && (G = K[0], j(W, I([0, 1], K)));
    for (var ne = 1, ce = !0; ne < W.length; ne += 1) {
      var fe = W[ne], ve = $(fe, 0, 1), _e = $(fe, -1);
      if ((ve === '"' || ve === "'" || ve === "`" || _e === '"' || _e === "'" || _e === "`") && ve !== _e)
        throw new s("property names with quotes must have matching quotes");
      if ((fe === "constructor" || !ce) && (V = !0), G += "." + fe, Y = "%" + G + "%", T(P, Y))
        L = P[Y];
      else if (L != null) {
        if (!(fe in L)) {
          if (!Z)
            throw new a("base intrinsic for " + H + " exists, but the property is not available.");
          return;
        }
        if (g && ne + 1 >= W.length) {
          var Ee = g(L, fe);
          ce = !!Ee, ce && "get" in Ee && !("originalValue" in Ee.get) ? L = Ee.get : L = L[fe];
        } else
          ce = T(L, fe), L = L[fe];
        ce && !V && (P[Y] = L);
      }
    }
    return L;
  }, S2;
}
var O2, jV;
function bnt() {
  if (jV) return O2;
  jV = 1;
  var t = /* @__PURE__ */ uu(), e = /* @__PURE__ */ ige(), n = /* @__PURE__ */ y4()(), r = /* @__PURE__ */ kv(), o = /* @__PURE__ */ go(), i = t("%Math.floor%");
  return O2 = function(s, a) {
    if (typeof s != "function")
      throw new o("`fn` is not a function");
    if (typeof a != "number" || a < 0 || a > 4294967295 || i(a) !== a)
      throw new o("`length` must be a positive 32-bit integer");
    var l = arguments.length > 2 && !!arguments[2], c = !0, u = !0;
    if ("length" in s && r) {
      var d = r(s, "length");
      d && !d.configurable && (c = !1), d && !d.writable && (u = !1);
    }
    return (c || u || !l) && (n ? e(
      /** @type {Parameters<define>[0]} */
      s,
      "length",
      a,
      !0,
      !0
    ) : e(
      /** @type {Parameters<define>[0]} */
      s,
      "length",
      a
    )), s;
  }, O2;
}
var C2, LV;
function _nt() {
  if (LV) return C2;
  LV = 1;
  var t = Av(), e = _4(), n = lge();
  return C2 = function() {
    return n(t, e, arguments);
  }, C2;
}
var FV;
function Wl() {
  return FV || (FV = 1, function(t) {
    var e = /* @__PURE__ */ bnt(), n = /* @__PURE__ */ Cv(), r = cge(), o = _nt();
    t.exports = function(i) {
      var s = r(arguments), a = i.length - (arguments.length - 1);
      return e(
        s,
        1 + (a > 0 ? a : 0),
        !0
      );
    }, n ? n(t.exports, "apply", { value: o }) : t.exports.apply = o;
  }(ZH)), ZH.exports;
}
var k2, BV;
function uge() {
  if (BV) return k2;
  BV = 1;
  var t = function(e) {
    return e !== e;
  };
  return k2 = function(e, n) {
    return e === 0 && n === 0 ? 1 / e === 1 / n : !!(e === n || t(e) && t(n));
  }, k2;
}
var A2, zV;
function dge() {
  if (zV) return A2;
  zV = 1;
  var t = uge();
  return A2 = function() {
    return typeof Object.is == "function" ? Object.is : t;
  }, A2;
}
var T2, qV;
function wnt() {
  if (qV) return T2;
  qV = 1;
  var t = dge(), e = to();
  return T2 = function() {
    var n = t();
    return e(Object, { is: n }, {
      is: function() {
        return Object.is !== n;
      }
    }), n;
  }, T2;
}
var R2, UV;
function w4() {
  if (UV) return R2;
  UV = 1;
  var t = to(), e = Wl(), n = uge(), r = dge(), o = wnt(), i = e(r(), Object);
  return t(i, {
    getPolyfill: r,
    implementation: n,
    shim: o
  }), R2 = i, R2;
}
var HV;
function xnt() {
  return HV || (HV = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = s;
    var n = o(w4()), r = o(/* @__PURE__ */ cu());
    function o(a) {
      return a && a.__esModule ? a : { default: a };
    }
    function i(a) {
      "@babel/helpers - typeof";
      return i = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(l) {
        return typeof l;
      } : function(l) {
        return l && typeof Symbol == "function" && l.constructor === Symbol && l !== Symbol.prototype ? "symbol" : typeof l;
      }, i(a);
    }
    function s(a, l) {
      if ((0, n.default)(a, l))
        return !0;
      if (!a || !l || i(a) !== "object" || i(l) !== "object")
        return !1;
      var c = Object.keys(a), u = Object.keys(l);
      if (c.length !== u.length)
        return !1;
      c.sort(), u.sort();
      for (var d = 0; d < c.length; d += 1)
        if (!(0, r.default)(l, c[d]) || !(0, n.default)(a[c[d]], l[c[d]]))
          return !1;
      return !0;
    }
    t.exports = e.default;
  }(l2, l2.exports)), l2.exports;
}
var VV = { exports: {} }, WV;
function Ent() {
  return WV || (WV = 1, function(t) {
    function e() {
      return t.exports = e = Object.assign ? Object.assign.bind() : function(n) {
        for (var r = 1; r < arguments.length; r++) {
          var o = arguments[r];
          for (var i in o) ({}).hasOwnProperty.call(o, i) && (n[i] = o[i]);
        }
        return n;
      }, t.exports.__esModule = !0, t.exports.default = t.exports, e.apply(null, arguments);
    }
    t.exports = e, t.exports.__esModule = !0, t.exports.default = t.exports;
  }(VV)), VV.exports;
}
var GV = { exports: {} }, YV = { exports: {} }, KV;
function Snt() {
  return KV || (KV = 1, function(t) {
    function e(n, r) {
      return t.exports = e = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(o, i) {
        return o.__proto__ = i, o;
      }, t.exports.__esModule = !0, t.exports.default = t.exports, e(n, r);
    }
    t.exports = e, t.exports.__esModule = !0, t.exports.default = t.exports;
  }(YV)), YV.exports;
}
var XV;
function Ont() {
  return XV || (XV = 1, function(t) {
    var e = Snt();
    function n(r, o) {
      r.prototype = Object.create(o.prototype), r.prototype.constructor = r, e(r, o);
    }
    t.exports = n, t.exports.__esModule = !0, t.exports.default = t.exports;
  }(GV)), GV.exports;
}
var QV = { exports: {} }, ZV = { exports: {} }, JV = { exports: {} }, eW;
function x4() {
  return eW || (eW = 1, function(t) {
    function e(n) {
      "@babel/helpers - typeof";
      return t.exports = e = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
        return typeof r;
      } : function(r) {
        return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
      }, t.exports.__esModule = !0, t.exports.default = t.exports, e(n);
    }
    t.exports = e, t.exports.__esModule = !0, t.exports.default = t.exports;
  }(JV)), JV.exports;
}
var tW = { exports: {} }, nW;
function Cnt() {
  return nW || (nW = 1, function(t) {
    var e = x4().default;
    function n(r, o) {
      if (e(r) != "object" || !r) return r;
      var i = r[Symbol.toPrimitive];
      if (i !== void 0) {
        var s = i.call(r, o || "default");
        if (e(s) != "object") return s;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (o === "string" ? String : Number)(r);
    }
    t.exports = n, t.exports.__esModule = !0, t.exports.default = t.exports;
  }(tW)), tW.exports;
}
var rW;
function knt() {
  return rW || (rW = 1, function(t) {
    var e = x4().default, n = Cnt();
    function r(o) {
      var i = n(o, "string");
      return e(i) == "symbol" ? i : i + "";
    }
    t.exports = r, t.exports.__esModule = !0, t.exports.default = t.exports;
  }(ZV)), ZV.exports;
}
var oW;
function Ant() {
  return oW || (oW = 1, function(t) {
    var e = knt();
    function n(r, o, i) {
      return (o = e(o)) in r ? Object.defineProperty(r, o, {
        value: i,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : r[o] = i, r;
    }
    t.exports = n, t.exports.__esModule = !0, t.exports.default = t.exports;
  }(QV)), QV.exports;
}
var P2, iW;
function Tnt() {
  if (iW) return P2;
  iW = 1;
  var t = lle;
  function e(n) {
    return typeof t.isMoment == "function" && !t.isMoment(n) ? !1 : typeof n.isValid == "function" ? n.isValid() : !isNaN(n);
  }
  return P2 = {
    isValidMoment: e
  }, P2;
}
var $2, sW;
function Rnt() {
  if (sW) return $2;
  sW = 1;
  var t = {
    invalidPredicate: "`predicate` must be a function",
    invalidPropValidator: "`propValidator` must be a function",
    requiredCore: "is marked as required",
    invalidTypeCore: "Invalid input type",
    predicateFailureCore: "Failed to succeed with predicate",
    anonymousMessage: "<<anonymous>>",
    baseInvalidMessage: "Invalid "
  };
  function e(s) {
    if (typeof s != "function")
      throw new Error(t.invalidPropValidator);
    var a = s.bind(null, !1, null);
    return a.isRequired = s.bind(null, !0, null), a.withPredicate = function(l) {
      if (typeof l != "function")
        throw new Error(t.invalidPredicate);
      var c = s.bind(null, !1, l);
      return c.isRequired = s.bind(null, !0, l), c;
    }, a;
  }
  function n(s, a, l) {
    return new Error(
      "The prop `" + s + "` " + t.requiredCore + " in `" + a + "`, but its value is `" + l + "`."
    );
  }
  var r = -1;
  function o(s, a, l, c) {
    var u = typeof c > "u", d = c === null;
    if (s) {
      if (u)
        return n(l, a, "undefined");
      if (d)
        return n(l, a, "null");
    }
    return u || d ? null : r;
  }
  function i(s, a, l, c) {
    function u(d, f, h, p, m, g, y) {
      var v = h[p], b = typeof v;
      m = m || t.anonymousMessage, y = y || p;
      var _ = o(
        d,
        m,
        y,
        v
      );
      if (_ !== r)
        return _;
      if (a && !a(v))
        return new Error(
          t.invalidTypeCore + ": `" + p + "` of type `" + b + "` supplied to `" + m + "`, expected `" + s + "`."
        );
      if (!l(v))
        return new Error(
          t.baseInvalidMessage + g + " `" + p + "` of type `" + b + "` supplied to `" + m + "`, expected `" + c + "`."
        );
      if (f && !f(v)) {
        var w = f.name || t.anonymousMessage;
        return new Error(
          t.baseInvalidMessage + g + " `" + p + "` of type `" + b + "` supplied to `" + m + "`. " + t.predicateFailureCore + " `" + w + "`."
        );
      }
      return null;
    }
    return e(u);
  }
  return $2 = {
    constructPropValidatorVariations: e,
    createMomentChecker: i,
    messages: t
  }, $2;
}
var M2, aW;
function Pnt() {
  if (aW) return M2;
  aW = 1;
  var t = lle, e = Tnt(), n = Rnt();
  return M2 = {
    momentObj: n.createMomentChecker(
      "object",
      function(r) {
        return typeof r == "object";
      },
      function(r) {
        return e.isValidMoment(r);
      },
      "Moment"
    ),
    momentString: n.createMomentChecker(
      "string",
      function(r) {
        return typeof r == "string";
      },
      function(r) {
        return e.isValidMoment(t(r));
      },
      "Moment"
    ),
    momentDurationObj: n.createMomentChecker(
      "object",
      function(r) {
        return typeof r == "object";
      },
      function(r) {
        return t.isDuration(r);
      },
      "Duration"
    )
  }, M2;
}
var D2, lW;
function $nt() {
  if (lW) return D2;
  lW = 1;
  function t() {
    return null;
  }
  t.isRequired = t;
  function e() {
    return t;
  }
  return D2 = {
    and: e,
    between: e,
    booleanSome: e,
    childrenHavePropXorChildren: e,
    childrenOf: e,
    childrenOfType: e,
    childrenSequenceOf: e,
    componentWithName: e,
    disallowedIf: e,
    elementType: e,
    empty: e,
    explicitNull: e,
    forbidExtraProps: Object,
    integer: e,
    keysOf: e,
    mutuallyExclusiveProps: e,
    mutuallyExclusiveTrueProps: e,
    nChildren: e,
    nonNegativeInteger: t,
    nonNegativeNumber: e,
    numericString: e,
    object: e,
    or: e,
    predicate: e,
    range: e,
    ref: e,
    requiredBy: e,
    restrictedProp: e,
    sequenceOf: e,
    shape: e,
    stringEndsWith: e,
    stringStartsWith: e,
    uniqueArray: e,
    uniqueArrayOf: e,
    valuesOf: e,
    withShape: e
  }, D2;
}
var I2, cW;
function $i() {
  if (cW) return I2;
  cW = 1;
  var t = /* @__PURE__ */ uu(), e = Wl(), n = e(t("String.prototype.indexOf"));
  return I2 = function(r, o) {
    var i = t(r, !!o);
    return typeof i == "function" && n(r, ".prototype.") > -1 ? e(i) : i;
  }, I2;
}
var N2, uW;
function fge() {
  if (uW) return N2;
  uW = 1;
  var t = g4(), e = v4()(), n = $i(), r = Object, o = n("Array.prototype.push"), i = n("Object.prototype.propertyIsEnumerable"), s = e ? Object.getOwnPropertySymbols : null;
  return N2 = function(a, l) {
    if (a == null)
      throw new TypeError("target must be an object");
    var c = r(a);
    if (arguments.length === 1)
      return c;
    for (var u = 1; u < arguments.length; ++u) {
      var d = r(arguments[u]), f = t(d), h = e && (Object.getOwnPropertySymbols || s);
      if (h)
        for (var p = h(d), m = 0; m < p.length; ++m) {
          var g = p[m];
          i(d, g) && o(f, g);
        }
      for (var y = 0; y < f.length; ++y) {
        var v = f[y];
        if (i(d, v)) {
          var b = d[v];
          c[v] = b;
        }
      }
    }
    return c;
  }, N2;
}
var j2, dW;
function hge() {
  if (dW) return j2;
  dW = 1;
  var t = fge(), e = function() {
    if (!Object.assign)
      return !1;
    for (var r = "abcdefghijklmnopqrst", o = r.split(""), i = {}, s = 0; s < o.length; ++s)
      i[o[s]] = o[s];
    var a = Object.assign({}, i), l = "";
    for (var c in a)
      l += c;
    return r !== l;
  }, n = function() {
    if (!Object.assign || !Object.preventExtensions)
      return !1;
    var r = Object.preventExtensions({ 1: 2 });
    try {
      Object.assign(r, "xy");
    } catch {
      return r[1] === "y";
    }
    return !1;
  };
  return j2 = function() {
    return !Object.assign || e() || n() ? t : Object.assign;
  }, j2;
}
var L2, fW;
function Mnt() {
  if (fW) return L2;
  fW = 1;
  var t = to(), e = hge();
  return L2 = function() {
    var n = e();
    return t(
      Object,
      { assign: n },
      { assign: function() {
        return Object.assign !== n;
      } }
    ), n;
  }, L2;
}
var F2, hW;
function pge() {
  if (hW) return F2;
  hW = 1;
  var t = to(), e = Wl(), n = fge(), r = hge(), o = Mnt(), i = e.apply(r()), s = function(a, l) {
    return i(Object, arguments);
  };
  return t(s, {
    getPolyfill: r,
    implementation: n,
    shim: o
  }), F2 = s, F2;
}
var B2, pW;
function Dnt() {
  if (pW) return B2;
  pW = 1;
  var t = /* @__PURE__ */ uu(), e = Wl(), n = $i(), r = t("%Reflect.ownKeys%", !0), o = e.apply(t("%Array.prototype.push%")), i = n("Symbol.prototype.valueOf", !0), s = t("%Object.getOwnPropertyNames%", !0), a = i ? t("%Object.getOwnPropertySymbols%") : null, l = g4();
  return B2 = r || function(c) {
    var u = (s || l)(c);
    return a && o(u, a(c)), u;
  }, B2;
}
var z2, mW;
function mge() {
  if (mW) return z2;
  mW = 1;
  var t = /* @__PURE__ */ Dnt();
  return z2 = function(e) {
    return t(e);
  }, z2;
}
var q2, gW;
function gge() {
  if (gW) return q2;
  gW = 1;
  var t = mge();
  return q2 = function() {
    return typeof Reflect == "object" && typeof Reflect.ownKeys == "function" ? Reflect.ownKeys : t;
  }, q2;
}
var U2, yW;
function Int() {
  if (yW) return U2;
  yW = 1;
  var t = /* @__PURE__ */ uu(), e = t("%Array%"), n = !e.isArray && $i()("Object.prototype.toString");
  return U2 = e.isArray || function(r) {
    return n(r) === "[object Array]";
  }, U2;
}
var H2, vW;
function Nnt() {
  if (vW) return H2;
  vW = 1;
  var t = /* @__PURE__ */ y4(), e = /* @__PURE__ */ Cv(), n = t.hasArrayLengthDefineBug(), r = n && /* @__PURE__ */ Int(), o = $i(), i = o("Object.prototype.propertyIsEnumerable");
  return H2 = function(s, a, l, c, u, d) {
    if (!e) {
      if (!s(d) || !d["[[Configurable]]"] || !d["[[Writable]]"] || u in c && i(c, u) !== !!d["[[Enumerable]]"])
        return !1;
      var f = d["[[Value]]"];
      return c[u] = f, a(c[u], f);
    }
    return n && u === "length" && "[[Value]]" in d && r(c) && c.length !== d["[[Value]]"] ? (c.length = d["[[Value]]"], c.length === d["[[Value]]"]) : (e(c, u, l(d)), !0);
  }, H2;
}
var V2, bW;
function yge() {
  if (bW) return V2;
  bW = 1;
  var t = /* @__PURE__ */ go(), e = /* @__PURE__ */ cu(), n = {
    __proto__: null,
    "[[Configurable]]": !0,
    "[[Enumerable]]": !0,
    "[[Get]]": !0,
    "[[Set]]": !0,
    "[[Value]]": !0,
    "[[Writable]]": !0
  };
  return V2 = function(r) {
    if (!r || typeof r != "object")
      return !1;
    for (var o in r)
      if (e(r, o) && !n[o])
        return !1;
    var i = e(r, "[[Value]]") || e(r, "[[Writable]]"), s = e(r, "[[Get]]") || e(r, "[[Set]]");
    if (i && s)
      throw new t("Property Descriptors may not be both accessor and data descriptors");
    return !0;
  }, V2;
}
var _W, wW;
function jnt() {
  return wW || (wW = 1, _W = function(t) {
    if (typeof t > "u")
      return t;
    var e = {};
    return "[[Value]]" in t && (e.value = t["[[Value]]"]), "[[Writable]]" in t && (e.writable = !!t["[[Writable]]"]), "[[Get]]" in t && (e.get = t["[[Get]]"]), "[[Set]]" in t && (e.set = t["[[Set]]"]), "[[Enumerable]]" in t && (e.enumerable = !!t["[[Enumerable]]"]), "[[Configurable]]" in t && (e.configurable = !!t["[[Configurable]]"]), e;
  }), _W;
}
var W2, xW;
function Lnt() {
  if (xW) return W2;
  xW = 1;
  var t = /* @__PURE__ */ go(), e = /* @__PURE__ */ yge(), n = /* @__PURE__ */ jnt();
  return W2 = function(r) {
    if (typeof r < "u" && !e(r))
      throw new t("Assertion failed: `Desc` must be a Property Descriptor");
    return n(r);
  }, W2;
}
var G2, EW;
function Fnt() {
  if (EW) return G2;
  EW = 1;
  var t = /* @__PURE__ */ go(), e = /* @__PURE__ */ cu(), n = /* @__PURE__ */ yge();
  return G2 = function(r) {
    if (typeof r > "u")
      return !1;
    if (!n(r))
      throw new t("Assertion failed: `Desc` must be a Property Descriptor");
    return !(!e(r, "[[Value]]") && !e(r, "[[Writable]]"));
  }, G2;
}
var SW, OW;
function vge() {
  return OW || (OW = 1, SW = function(t) {
    return typeof t == "string" || typeof t == "symbol";
  }), SW;
}
var CW, kW;
function E4() {
  return kW || (kW = 1, CW = Number.isNaN || function(t) {
    return t !== t;
  }), CW;
}
var Y2, AW;
function Bnt() {
  if (AW) return Y2;
  AW = 1;
  var t = /* @__PURE__ */ E4();
  return Y2 = function(e, n) {
    return e === n ? e === 0 ? 1 / e === 1 / n : !0 : t(e) && t(n);
  }, Y2;
}
var TW, RW;
function znt() {
  return RW || (RW = 1, TW = function(t) {
    if (t === null)
      return "Null";
    if (typeof t > "u")
      return "Undefined";
    if (typeof t == "function" || typeof t == "object")
      return "Object";
    if (typeof t == "number")
      return "Number";
    if (typeof t == "boolean")
      return "Boolean";
    if (typeof t == "string")
      return "String";
  }), TW;
}
var K2, PW;
function bge() {
  if (PW) return K2;
  PW = 1;
  var t = /* @__PURE__ */ znt();
  return K2 = function(e) {
    return typeof e == "symbol" ? "Symbol" : typeof e == "bigint" ? "BigInt" : t(e);
  }, K2;
}
var X2, $W;
function qnt() {
  if ($W) return X2;
  $W = 1;
  var t = /* @__PURE__ */ go(), e = /* @__PURE__ */ Nnt(), n = /* @__PURE__ */ Lnt(), r = /* @__PURE__ */ Fnt(), o = /* @__PURE__ */ vge(), i = /* @__PURE__ */ Bnt(), s = /* @__PURE__ */ bge();
  return X2 = function(a, l, c) {
    if (s(a) !== "Object")
      throw new t("Assertion failed: Type(O) is not Object");
    if (!o(l))
      throw new t("Assertion failed: IsPropertyKey(P) is not true");
    var u = {
      "[[Configurable]]": !0,
      "[[Enumerable]]": !1,
      "[[Value]]": c,
      "[[Writable]]": !0
    };
    return e(
      r,
      i,
      n,
      a,
      l,
      u
    );
  }, X2;
}
var Q2, MW;
function S4() {
  if (MW) return Q2;
  MW = 1;
  var t = v4();
  return Q2 = function() {
    return t() && !!Symbol.toStringTag;
  }, Q2;
}
var Z2, DW;
function Unt() {
  if (DW) return Z2;
  DW = 1;
  var t = /* @__PURE__ */ uu(), e = t("%Object.defineProperty%", !0), n = S4()(), r = /* @__PURE__ */ cu(), o = n ? Symbol.toStringTag : null;
  return Z2 = function(i, s) {
    var a = arguments.length > 2 && arguments[2] && arguments[2].force;
    o && (a || !r(i, o)) && (e ? e(i, o, {
      configurable: !0,
      enumerable: !1,
      value: s,
      writable: !1
    }) : i[o] = s);
  }, Z2;
}
var v1 = { exports: {} }, IW;
function _ge() {
  return IW || (IW = 1, typeof self < "u" ? v1.exports = self : typeof window < "u" ? v1.exports = window : v1.exports = Function("return this")()), v1.exports;
}
var J2, NW;
function wge() {
  if (NW) return J2;
  NW = 1;
  var t = _ge();
  return J2 = function() {
    return typeof Tf != "object" || !Tf || Tf.Math !== Math || Tf.Array !== Array ? t : Tf;
  }, J2;
}
var eA, jW;
function Hnt() {
  if (jW) return eA;
  jW = 1;
  var t = to(), e = /* @__PURE__ */ kv(), n = wge();
  return eA = function() {
    var r = n();
    if (t.supportsDescriptors) {
      var o = e(r, "globalThis");
      (!o || o.configurable && (o.enumerable || !o.writable || globalThis !== r)) && Object.defineProperty(r, "globalThis", {
        configurable: !0,
        enumerable: !1,
        value: r,
        writable: !0
      });
    } else (typeof globalThis != "object" || globalThis !== r) && (r.globalThis = r);
    return r;
  }, eA;
}
var tA, LW;
function Vnt() {
  if (LW) return tA;
  LW = 1;
  var t = to(), e = _ge(), n = wge(), r = Hnt(), o = n(), i = function() {
    return o;
  };
  return t(i, {
    getPolyfill: n,
    implementation: e,
    shim: r
  }), tA = i, tA;
}
var nA, FW;
function Wnt() {
  if (FW) return nA;
  FW = 1;
  var t = /* @__PURE__ */ qnt(), e = /* @__PURE__ */ Unt(), n = Vnt()(), r = gge();
  return nA = function() {
    if (typeof Reflect > "u") {
      var o = {};
      e(o, "Reflect"), t(n, "Reflect", o);
    }
    var i = r();
    return i !== Reflect.ownKeys && t(Reflect, "ownKeys", i), i;
  }, nA;
}
var rA, BW;
function Gnt() {
  if (BW) return rA;
  BW = 1;
  var t = to(), e = Wl(), n = mge(), r = gge(), o = Wnt(), i = e(r(), null);
  return t(i, {
    getPolyfill: r,
    implementation: n,
    shim: o
  }), rA = i, rA;
}
var oA, zW;
function Ynt() {
  if (zW) return oA;
  zW = 1;
  var t = {}.toString;
  return oA = Array.isArray || function(e) {
    return t.call(e) == "[object Array]";
  }, oA;
}
var iA, qW;
function xge() {
  if (qW) return iA;
  qW = 1;
  var t = Ynt();
  return iA = function(e) {
    return e && typeof e == "object" && !t(e);
  }, iA;
}
var sA, UW;
function Knt() {
  if (UW) return sA;
  UW = 1;
  var t = pge(), e = /* @__PURE__ */ cu(), n = Gnt(), r = /* @__PURE__ */ go(), o = /* @__PURE__ */ xge(), i = "​", s = "prop-types-exact: " + i, a = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for(s) : (
    /* istanbul ignore next */
    s
  ), l = $i(), c = l("Object.prototype.propertyIsEnumerable");
  function u(f) {
    return f[s] = a, f;
  }
  function d(f) {
    return f && f[s] === a;
  }
  return sA = function(f) {
    if (!o(f))
      throw new r("given propTypes must be an object");
    if (e(f, s) && !d(f[s]))
      throw new r("Against all odds, you created a propType for a prop that uses both the zero-width space and our custom string - which, sadly, conflicts with `prop-types-exact`");
    var h = {};
    return h[s] = u(function(p, m, g) {
      var y = n(p).filter(function(v) {
        return !e(f, v) && c(p, v);
      });
      return y.length > 0 ? new r(g + ": unknown props found: " + y.join(", ")) : null;
    }), t({}, f, h);
  }, sA;
}
var HW = {}, VW = {}, WW;
function tn() {
  return WW || (WW = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = r;
    var e = n(pge());
    function n(o) {
      return o && o.__esModule ? o : { default: o };
    }
    function r(o, i) {
      var s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
      return (0, e.default)(o.bind(), {
        typeName: i,
        typeChecker: s,
        isRequired: (0, e.default)(o.isRequired.bind(), {
          typeName: i,
          typeChecker: s,
          typeRequired: !0
        })
      });
    }
  }(VW)), VW;
}
var GW;
function Qd() {
  return GW || (GW = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = r;
    var e = n(tn());
    function n(o) {
      return o && o.__esModule ? o : { default: o };
    }
    function r(o) {
      var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "and";
      if (!Array.isArray(o))
        throw new TypeError("and: 2 or more validators are required");
      if (o.length <= 1)
        throw new RangeError("and: 2 or more validators are required");
      var s = function() {
        for (var a = arguments.length, l = new Array(a), c = 0; c < a; c++)
          l[c] = arguments[c];
        var u = null;
        return o.some(function(d) {
          return u = d.apply(void 0, l), u != null;
        }), u ?? null;
      };
      return s.isRequired = function() {
        for (var a = arguments.length, l = new Array(a), c = 0; c < a; c++)
          l[c] = arguments[c];
        var u = null;
        return o.some(function(d) {
          return u = d.isRequired.apply(d, l), u != null;
        }), u ?? null;
      }, (0, e.default)(s, i, o);
    }
  }(HW)), HW;
}
var YW = {}, aA, KW;
function Mp() {
  if (KW) return aA;
  KW = 1;
  var t = /* @__PURE__ */ go();
  return aA = function(e) {
    if (e == null)
      throw new t(arguments.length > 0 && arguments[1] || "Cannot call method on " + e);
    return e;
  }, aA;
}
var lA, XW;
function Ege() {
  if (XW) return lA;
  XW = 1;
  var t = /* @__PURE__ */ Mp(), e = $i(), n = e("Object.prototype.propertyIsEnumerable"), r = e("Array.prototype.push");
  return lA = function(o) {
    var i = t(o), s = [];
    for (var a in i)
      n(i, a) && r(s, [a, i[a]]);
    return s;
  }, lA;
}
var cA, QW;
function Sge() {
  if (QW) return cA;
  QW = 1;
  var t = Ege();
  return cA = function() {
    return typeof Object.entries == "function" ? Object.entries : t;
  }, cA;
}
var uA, ZW;
function Xnt() {
  if (ZW) return uA;
  ZW = 1;
  var t = Sge(), e = to();
  return uA = function() {
    var n = t();
    return e(Object, { entries: n }, {
      entries: function() {
        return Object.entries !== n;
      }
    }), n;
  }, uA;
}
var dA, JW;
function Qnt() {
  if (JW) return dA;
  JW = 1;
  var t = to(), e = Wl(), n = Ege(), r = Sge(), o = Xnt(), i = e(r(), Object);
  return t(i, {
    getPolyfill: r,
    implementation: n,
    shim: o
  }), dA = i, dA;
}
var eG = {}, tG = {}, nG;
function O4() {
  return nG || (nG = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var e = n(/* @__PURE__ */ xge());
    function n(o) {
      return o && o.__esModule ? o : { default: o };
    }
    var r = e.default;
    t.default = r;
  }(tG)), tG;
}
var rG;
function C4() {
  return rG || (rG = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = o;
    var e = r(O4()), n = r(tn());
    function r(i) {
      return i && i.__esModule ? i : { default: i };
    }
    function o(i) {
      if (!(0, e.default)(i))
        throw new TypeError("shape must be a normal object");
      function s(a, l, c, u) {
        var d = a[l];
        if (d == null)
          return null;
        for (var f = arguments.length, h = new Array(f > 4 ? f - 4 : 0), p = 4; p < f; p++)
          h[p - 4] = arguments[p];
        for (var m in i) {
          var g = i[m];
          if (g) {
            var y = g.apply(void 0, [d, m, c, u].concat(h));
            if (y)
              return y;
          }
        }
        return null;
      }
      return s.isRequired = function(a, l, c) {
        var u = a[l];
        if (u == null)
          return new TypeError("".concat(c, ": ").concat(l, " is required."));
        for (var d = arguments.length, f = new Array(d > 3 ? d - 3 : 0), h = 3; h < d; h++)
          f[h - 3] = arguments[h];
        return s.apply(void 0, [a, l, c].concat(f));
      }, (0, n.default)(s, "shape", i);
    }
  }(eG)), eG;
}
var oG = {}, iG = {}, sG;
function Oge() {
  return sG || (sG = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = n;
    function e(r) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? e = function(o) {
        return typeof o;
      } : e = function(o) {
        return o && typeof Symbol == "function" && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
      }, e(r);
    }
    function n(r) {
      return !r || e(r) !== "object" && typeof r != "function";
    }
  }(iG)), iG;
}
var aG;
function Cge() {
  return aG || (aG = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = o;
    var e = r(Oge()), n = r(tn());
    function r(i) {
      return i && i.__esModule ? i : { default: i };
    }
    function o(i) {
      if (typeof i != "function")
        throw new TypeError("objectOf: propType must be a function");
      var s = function(a, l, c, u, d) {
        for (var f = arguments.length, h = new Array(f > 5 ? f - 5 : 0), p = 5; p < f; p++)
          h[p - 5] = arguments[p];
        var m = a[l];
        if (m == null || (0, e.default)(m))
          return null;
        var g;
        return Object.keys(m).some(function(y) {
          return g = i.apply(void 0, [m, y, c, u, "".concat(d, ".").concat(y)].concat(h)), g;
        }), g || null;
      };
      return s.isRequired = function(a, l, c) {
        var u = a[l];
        if (u == null)
          return new TypeError("".concat(c, ": ").concat(l, " is required."));
        for (var d = arguments.length, f = new Array(d > 3 ? d - 3 : 0), h = 3; h < d; h++)
          f[h - 3] = arguments[h];
        return s.apply(void 0, [a, l, c].concat(f));
      }, (0, n.default)(s, "valuesOf", i);
    }
  }(oG)), oG;
}
var lG;
function k4() {
  return lG || (lG = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = N;
    var e = i(Qnt()), n = i(C4()), r = i(Cge()), o = i(tn());
    function i(A) {
      return A && A.__esModule ? A : { default: A };
    }
    function s(A) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? s = function(O) {
        return typeof O;
      } : s = function(O) {
        return O && typeof Symbol == "function" && O.constructor === Symbol && O !== Symbol.prototype ? "symbol" : typeof O;
      }, s(A);
    }
    function a(A, O) {
      var k = Object.keys(A);
      if (Object.getOwnPropertySymbols) {
        var T = Object.getOwnPropertySymbols(A);
        O && (T = T.filter(function(I) {
          return Object.getOwnPropertyDescriptor(A, I).enumerable;
        })), k.push.apply(k, T);
      }
      return k;
    }
    function l(A) {
      for (var O = 1; O < arguments.length; O++) {
        var k = arguments[O] != null ? arguments[O] : {};
        O % 2 ? a(Object(k), !0).forEach(function(T) {
          c(A, T, k[T]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(A, Object.getOwnPropertyDescriptors(k)) : a(Object(k)).forEach(function(T) {
          Object.defineProperty(A, T, Object.getOwnPropertyDescriptor(k, T));
        });
      }
      return A;
    }
    function c(A, O, k) {
      return O in A ? Object.defineProperty(A, O, { value: k, enumerable: !0, configurable: !0, writable: !0 }) : A[O] = k, A;
    }
    function u(A, O) {
      return m(A) || p(A, O) || f(A, O) || d();
    }
    function d() {
      throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    function f(A, O) {
      if (A) {
        if (typeof A == "string") return h(A, O);
        var k = Object.prototype.toString.call(A).slice(8, -1);
        if (k === "Object" && A.constructor && (k = A.constructor.name), k === "Map" || k === "Set") return Array.from(A);
        if (k === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(k)) return h(A, O);
      }
    }
    function h(A, O) {
      (O == null || O > A.length) && (O = A.length);
      for (var k = 0, T = new Array(O); k < O; k++)
        T[k] = A[k];
      return T;
    }
    function p(A, O) {
      if (!(typeof Symbol > "u" || !(Symbol.iterator in Object(A)))) {
        var k = [], T = !0, I = !1, j = void 0;
        try {
          for (var z = A[Symbol.iterator](), $; !(T = ($ = z.next()).done) && (k.push($.value), !(O && k.length === O)); T = !0)
            ;
        } catch (D) {
          I = !0, j = D;
        } finally {
          try {
            !T && z.return != null && z.return();
          } finally {
            if (I) throw j;
          }
        }
        return k;
      }
    }
    function m(A) {
      if (Array.isArray(A)) return A;
    }
    function g(A, O, k) {
      var T = A[O];
      return typeof T == "number" && !isNaN(T) ? null : new TypeError("".concat(k, ": ").concat(O, " must be a non-NaN number."));
    }
    function y(A, O) {
      var k = A[O];
      return typeof k == "function" || typeof k == "number" && !isNaN(k) ? null : new TypeError("".concat(O, ": a function, or a non-NaN number is required"));
    }
    function v(A, O) {
      var k = O.gt, T = O.gte;
      return typeof k == "number" ? A > k : typeof T == "number" ? A >= T : !0;
    }
    function b(A, O) {
      var k = O.lt, T = O.lte;
      return typeof k == "number" ? A < k : typeof T == "number" ? A <= T : !0;
    }
    function _(A) {
      var O = A.gt, k = A.gte;
      return typeof O == "number" ? "greater than ".concat(O) : typeof k == "number" ? "greater than or equal to ".concat(k) : "";
    }
    function w(A) {
      var O = A.lt, k = A.lte;
      return typeof O == "number" ? "less than ".concat(O) : typeof k == "number" ? "less than or equal to ".concat(k) : "";
    }
    function x(A, O, k) {
      var T = [_(k), w(k)].filter(Boolean).join(" and ");
      return "".concat(A, ": ").concat(O, " must be ").concat(T);
    }
    function E(A) {
      return (0, e.default)(A).reduce(function(O, k) {
        var T = u(k, 2), I = T[0], j = T[1], z = typeof j == "number" ? function() {
          return j;
        } : j;
        return l(l({}, O), {}, c({}, I, z));
      }, {});
    }
    function S(A, O) {
      return (0, e.default)(A).reduce(function(k, T) {
        var I = u(T, 2), j = I[0], z = I[1], $ = z(O);
        return l(l({}, k), {}, c({}, j, $));
      }, {});
    }
    var C = [(0, n.default)({
      lt: y,
      gt: y
    }).isRequired, (0, n.default)({
      lte: y,
      gt: y
    }).isRequired, (0, n.default)({
      lt: y,
      gte: y
    }).isRequired, (0, n.default)({
      lte: y,
      gte: y
    }).isRequired, (0, n.default)({
      lt: y
    }).isRequired, (0, n.default)({
      lte: y
    }).isRequired, (0, n.default)({
      gt: y
    }).isRequired, (0, n.default)({
      gte: y
    }).isRequired];
    function R(A, O) {
      return C.every(function(k) {
        return !!k(A, O);
      });
    }
    var P = (0, r.default)(g).isRequired;
    function N(A) {
      var O = R({
        options: A
      }, "options");
      if (O)
        throw new TypeError("between: only one of the pairs of `lt`/`lte`, and `gt`/`gte`, may be supplied, and at least one pair must be provided.");
      var k = E(A), T = function(I, j, z) {
        var $ = I[j];
        if ($ == null)
          return null;
        if (typeof $ != "number")
          return new RangeError("".concat(z, ": ").concat(j, ' must be a number, got "').concat(s($), '"'));
        for (var D = S(k, I), U = arguments.length, q = new Array(U > 3 ? U - 3 : 0), F = 3; F < U; F++)
          q[F - 3] = arguments[F];
        var B = P.apply(void 0, [c({}, j, D), j, z].concat(q));
        return B || (!v($, D) || !b($, D) ? new RangeError(x(z, j, D)) : null);
      };
      return T.isRequired = function(I, j, z) {
        var $ = I[j];
        if (typeof $ != "number")
          return new RangeError("".concat(z, ": ").concat(j, ' must be a number, got "').concat(s($), '"'));
        for (var D = S(k, I), U = arguments.length, q = new Array(U > 3 ? U - 3 : 0), F = 3; F < U; F++)
          q[F - 3] = arguments[F];
        var B = P.apply(void 0, [c({}, j, D), j, z].concat(q));
        return B || (!v($, D) || !b($, D) ? new RangeError(x(z, j, D)) : null);
      }, (0, o.default)(T, "between", A);
    }
  }(YW)), YW;
}
var cG = {}, uG;
function Znt() {
  return uG || (uG = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = o;
    var e = /* @__PURE__ */ Tr(), n = r(tn());
    function r(i) {
      return i && i.__esModule ? i : { default: i };
    }
    function o() {
      for (var i = arguments.length, s = new Array(i), a = 0; a < i; a++)
        s[a] = arguments[a];
      if (s.length < 1)
        throw new TypeError("at least one prop (one of which must be `true`) is required");
      if (!s.every(function(u) {
        return typeof u == "string";
      }))
        throw new TypeError("all booleanSome props must be strings");
      var l = s.join(", or "), c = function(u, d, f) {
        var h = function(v, b) {
          return v + (u[b] === !1 ? 1 : 0);
        }, p = s.reduce(h, 0);
        if (p === s.length)
          return new Error("A ".concat(f, " must have at least one of these boolean props be `true`: ").concat(l));
        for (var m = arguments.length, g = new Array(m > 3 ? m - 3 : 0), y = 3; y < m; y++)
          g[y - 3] = arguments[y];
        return e.bool.apply(void 0, [u, d, f].concat(g));
      };
      return c.isRequired = function(u, d, f) {
        var h = function(v, b) {
          return v + (u[b] === !1 ? 1 : 0);
        }, p = s.reduce(h, 0);
        if (p === s.length)
          return new Error("A ".concat(f, " must have at least one of these boolean props be `true`: ").concat(l));
        for (var m = arguments.length, g = new Array(m > 3 ? m - 3 : 0), y = 3; y < m; y++)
          g[y - 3] = arguments[y];
        return e.bool.isRequired.apply(e.bool, [u, d, f].concat(g));
      }, (0, n.default)(c, "booleanSome: ".concat(l), s);
    }
  }(cG)), cG;
}
var dG = {}, fG;
function Jnt() {
  return fG || (fG = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = i;
    var e = r(xe), n = r(tn());
    function r(s) {
      return s && s.__esModule ? s : { default: s };
    }
    function o(s) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? o = function(a) {
        return typeof a;
      } : o = function(a) {
        return a && typeof Symbol == "function" && a.constructor === Symbol && a !== Symbol.prototype ? "symbol" : typeof a;
      }, o(s);
    }
    function i(s) {
      if (typeof s != "string" && o(s) !== "symbol")
        throw new TypeError("invalid prop: must be string or symbol");
      var a = function(l, c, u) {
        var d = l.children, f = 0, h = 0, p = 0;
        return e.default.Children.forEach(d, function(m) {
          m && (f += 1, m.props[s] && (h += 1), e.default.Children.count(m.props.children) && (p += 1));
        }), h === f && p === 0 || h === 0 && p === f || h === 0 && p === 0 ? null : new TypeError("`".concat(u, "` requires children to all have prop “").concat(s, "”, all have children, or all have neither."));
      };
      return a.isRequired = a, (0, n.default)(a, "childrenHavePropXorChildrenWithProp:".concat(s), s);
    }
  }(dG)), dG;
}
var hG = {}, pG = {}, mG;
function A4() {
  return mG || (mG = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = r;
    var e = n(xe);
    function n(o) {
      return o && o.__esModule ? o : { default: o };
    }
    function r(o) {
      return e.default.Children.toArray(o).filter(function(i) {
        return i === 0 || i;
      });
    }
  }(pG)), pG;
}
var gG;
function ert() {
  return gG || (gG = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = l;
    var e = r(A4()), n = r(tn());
    function r(c) {
      return c && c.__esModule ? c : { default: c };
    }
    function o(c, u) {
      var d = Object.keys(c);
      if (Object.getOwnPropertySymbols) {
        var f = Object.getOwnPropertySymbols(c);
        u && (f = f.filter(function(h) {
          return Object.getOwnPropertyDescriptor(c, h).enumerable;
        })), d.push.apply(d, f);
      }
      return d;
    }
    function i(c) {
      for (var u = 1; u < arguments.length; u++) {
        var d = arguments[u] != null ? arguments[u] : {};
        u % 2 ? o(Object(d), !0).forEach(function(f) {
          s(c, f, d[f]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(c, Object.getOwnPropertyDescriptors(d)) : o(Object(d)).forEach(function(f) {
          Object.defineProperty(c, f, Object.getOwnPropertyDescriptor(d, f));
        });
      }
      return c;
    }
    function s(c, u, d) {
      return u in c ? Object.defineProperty(c, u, { value: d, enumerable: !0, configurable: !0, writable: !0 }) : c[u] = d, c;
    }
    function a(c, u, d) {
      for (var f = arguments.length, h = new Array(f > 3 ? f - 3 : 0), p = 3; p < f; p++)
        h[p - 3] = arguments[p];
      var m;
      return u.some(function(g) {
        return m = c.apply(void 0, [i(i({}, d), {}, {
          children: g
        }), "children"].concat(h)), m;
      }), m || null;
    }
    function l(c) {
      function u(d, f, h) {
        if (f !== "children")
          return new TypeError("".concat(h, ' is using the childrenOf validator on non-children prop "').concat(f, '"'));
        var p = d[f];
        if (p == null)
          return null;
        var m = (0, e.default)(p);
        if (m.length === 0)
          return null;
        for (var g = arguments.length, y = new Array(g > 3 ? g - 3 : 0), v = 3; v < g; v++)
          y[v - 3] = arguments[v];
        return a.apply(void 0, [c, m, d, h].concat(y));
      }
      return u.isRequired = function(d, f, h) {
        if (f !== "children")
          return new TypeError("".concat(h, ' is using the childrenOf validator on non-children prop "').concat(f, '"'));
        var p = (0, e.default)(d[f]);
        if (p.length === 0)
          return new TypeError("`".concat(h, "` requires at least one node of type ").concat(c.typeName || c.name));
        for (var m = arguments.length, g = new Array(m > 3 ? m - 3 : 0), y = 3; y < m; y++)
          g[y - 3] = arguments[y];
        return a.apply(void 0, [c, p, d, h].concat(g));
      }, (0, n.default)(u, "childrenOf", c);
    }
  }(hG)), hG;
}
var yG = {}, fA, vG;
function trt() {
  if (vG) return fA;
  vG = 1;
  var t = /* @__PURE__ */ sge(), e = /* @__PURE__ */ Mp();
  return fA = function(n) {
    return e(n), t(n);
  }, fA;
}
var bG, _G;
function nrt() {
  return _G || (_G = 1, bG = Number.MAX_SAFE_INTEGER || 9007199254740991), bG;
}
var wG, xG;
function rrt() {
  return xG || (xG = 1, wG = function(t) {
    return t === null || typeof t != "function" && typeof t != "object";
  }), wG;
}
var EG, SG;
function ort() {
  return SG || (SG = 1, EG = function(t) {
    return t === null || typeof t != "function" && typeof t != "object";
  }), EG;
}
var hA, OG;
function T4() {
  if (OG) return hA;
  OG = 1;
  var t = Function.prototype.toString, e = typeof Reflect == "object" && Reflect !== null && Reflect.apply, n, r;
  if (typeof e == "function" && typeof Object.defineProperty == "function")
    try {
      n = Object.defineProperty({}, "length", {
        get: function() {
          throw r;
        }
      }), r = {}, e(function() {
        throw 42;
      }, null, n);
    } catch (v) {
      v !== r && (e = null);
    }
  else
    e = null;
  var o = /^\s*class\b/, i = function(v) {
    try {
      var b = t.call(v);
      return o.test(b);
    } catch {
      return !1;
    }
  }, s = function(v) {
    try {
      return i(v) ? !1 : (t.call(v), !0);
    } catch {
      return !1;
    }
  }, a = Object.prototype.toString, l = "[object Object]", c = "[object Function]", u = "[object GeneratorFunction]", d = "[object HTMLAllCollection]", f = "[object HTML document.all class]", h = "[object HTMLCollection]", p = typeof Symbol == "function" && !!Symbol.toStringTag, m = !(0 in [,]), g = function() {
    return !1;
  };
  if (typeof document == "object") {
    var y = document.all;
    a.call(y) === a.call(document.all) && (g = function(v) {
      if ((m || !v) && (typeof v > "u" || typeof v == "object"))
        try {
          var b = a.call(v);
          return (b === d || b === f || b === h || b === l) && v("") == null;
        } catch {
        }
      return !1;
    });
  }
  return hA = e ? function(v) {
    if (g(v))
      return !0;
    if (!v || typeof v != "function" && typeof v != "object")
      return !1;
    try {
      e(v, null, n);
    } catch (b) {
      if (b !== r)
        return !1;
    }
    return !i(v) && s(v);
  } : function(v) {
    if (g(v))
      return !0;
    if (!v || typeof v != "function" && typeof v != "object")
      return !1;
    if (p)
      return s(v);
    if (i(v))
      return !1;
    var b = a.call(v);
    return b !== c && b !== u && !/^\[object HTML/.test(b) ? !1 : s(v);
  }, hA;
}
var pA, CG;
function irt() {
  if (CG) return pA;
  CG = 1;
  var t = Date.prototype.getDay, e = function(i) {
    try {
      return t.call(i), !0;
    } catch {
      return !1;
    }
  }, n = Object.prototype.toString, r = "[object Date]", o = S4()();
  return pA = function(i) {
    return typeof i != "object" || i === null ? !1 : o ? e(i) : n.call(i) === r;
  }, pA;
}
var b1 = { exports: {} }, kG;
function srt() {
  if (kG) return b1.exports;
  kG = 1;
  var t = Object.prototype.toString, e = age()();
  if (e) {
    var n = Symbol.prototype.toString, r = /^Symbol\(.*\)$/, o = function(i) {
      return typeof i.valueOf() != "symbol" ? !1 : r.test(n.call(i));
    };
    b1.exports = function(i) {
      if (typeof i == "symbol")
        return !0;
      if (t.call(i) !== "[object Symbol]")
        return !1;
      try {
        return o(i);
      } catch {
        return !1;
      }
    };
  } else
    b1.exports = function(i) {
      return !1;
    };
  return b1.exports;
}
var mA, AG;
function art() {
  if (AG) return mA;
  AG = 1;
  var t = typeof Symbol == "function" && typeof Symbol.iterator == "symbol", e = ort(), n = T4(), r = irt(), o = srt(), i = function(a, l) {
    if (typeof a > "u" || a === null)
      throw new TypeError("Cannot call method on " + a);
    if (typeof l != "string" || l !== "number" && l !== "string")
      throw new TypeError('hint must be "string" or "number"');
    var c = l === "string" ? ["toString", "valueOf"] : ["valueOf", "toString"], u, d, f;
    for (f = 0; f < c.length; ++f)
      if (u = a[c[f]], n(u) && (d = u.call(a), e(d)))
        return d;
    throw new TypeError("No default value");
  }, s = function(a, l) {
    var c = a[l];
    if (c !== null && typeof c < "u") {
      if (!n(c))
        throw new TypeError(c + " returned for property " + l + " of object " + a + " is not a function");
      return c;
    }
  };
  return mA = function(a) {
    if (e(a))
      return a;
    var l = "default";
    arguments.length > 1 && (arguments[1] === String ? l = "string" : arguments[1] === Number && (l = "number"));
    var c;
    if (t && (Symbol.toPrimitive ? c = s(a, Symbol.toPrimitive) : o(a) && (c = Symbol.prototype.valueOf)), typeof c < "u") {
      var u = c.call(a, l);
      if (e(u))
        return u;
      throw new TypeError("unable to convert exotic object to primitive");
    }
    return l === "default" && (r(a) || o(a)) && (l = "string"), i(a, l === "default" ? "number" : l);
  }, mA;
}
var gA, TG;
function lrt() {
  if (TG) return gA;
  TG = 1;
  var t = art();
  return gA = function(e) {
    return arguments.length > 1 ? t(e, arguments[1]) : t(e);
  }, gA;
}
var yA, RG;
function kge() {
  if (RG) return yA;
  RG = 1;
  var t = $i(), e = S4()(), n, r, o, i;
  if (e) {
    n = t("Object.prototype.hasOwnProperty"), r = t("RegExp.prototype.exec"), o = {};
    var s = function() {
      throw o;
    };
    i = {
      toString: s,
      valueOf: s
    }, typeof Symbol.toPrimitive == "symbol" && (i[Symbol.toPrimitive] = s);
  }
  var a = t("Object.prototype.toString"), l = Object.getOwnPropertyDescriptor, c = "[object RegExp]";
  return yA = e ? function(u) {
    if (!u || typeof u != "object")
      return !1;
    var d = l(u, "lastIndex"), f = d && n(d, "value");
    if (!f)
      return !1;
    try {
      r(u, i);
    } catch (h) {
      return h === o;
    }
  } : function(u) {
    return !u || typeof u != "object" && typeof u != "function" ? !1 : a(u) === c;
  }, yA;
}
var vA, PG;
function crt() {
  if (PG) return vA;
  PG = 1;
  var t = $i(), e = kge(), n = t("RegExp.prototype.exec"), r = /* @__PURE__ */ go();
  return vA = function(o) {
    if (!e(o))
      throw new r("`regex` must be a RegExp");
    return function(i) {
      return n(o, i) !== null;
    };
  }, vA;
}
var bA, $G;
function urt() {
  if ($G) return bA;
  $G = 1;
  var t = /* @__PURE__ */ uu(), e = t("%String%"), n = /* @__PURE__ */ go();
  return bA = function(r) {
    if (typeof r == "symbol")
      throw new n("Cannot convert a Symbol value to a string");
    return e(r);
  }, bA;
}
var _A, MG;
function Age() {
  if (MG) return _A;
  MG = 1;
  var t = /* @__PURE__ */ Mp(), e = /* @__PURE__ */ urt(), n = $i(), r = n("String.prototype.replace"), o = /^\s$/.test("᠎"), i = o ? /^[\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]+/ : /^[\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]+/, s = o ? /[\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]+$/ : /[\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]+$/;
  return _A = function() {
    var a = e(t(this));
    return r(r(a, i, ""), s, "");
  }, _A;
}
var wA, DG;
function Tge() {
  if (DG) return wA;
  DG = 1;
  var t = Age(), e = "​", n = "᠎";
  return wA = function() {
    return String.prototype.trim && e.trim() === e && n.trim() === n && ("_" + n).trim() === "_" + n && (n + "_").trim() === n + "_" ? String.prototype.trim : t;
  }, wA;
}
var xA, IG;
function drt() {
  if (IG) return xA;
  IG = 1;
  var t = to(), e = Tge();
  return xA = function() {
    var n = e();
    return t(String.prototype, { trim: n }, {
      trim: function() {
        return String.prototype.trim !== n;
      }
    }), n;
  }, xA;
}
var EA, NG;
function frt() {
  if (NG) return EA;
  NG = 1;
  var t = Wl(), e = to(), n = /* @__PURE__ */ Mp(), r = Age(), o = Tge(), i = drt(), s = t(o()), a = function(l) {
    return n(l), s(l);
  };
  return e(a, {
    getPolyfill: o,
    implementation: r,
    shim: i
  }), EA = a, EA;
}
var SA, jG;
function hrt() {
  if (jG) return SA;
  jG = 1;
  var t = /* @__PURE__ */ uu(), e = t("%Number%"), n = t("%RegExp%"), r = /* @__PURE__ */ go(), o = t("%parseInt%"), i = $i(), s = /* @__PURE__ */ crt(), a = i("String.prototype.slice"), l = s(/^0b[01]+$/i), c = s(/^0o[0-7]+$/i), u = s(/^[-+]0x[0-9a-f]+$/i), d = ["", "​", "￾"].join(""), f = new n("[" + d + "]", "g"), h = s(f), p = frt();
  return SA = function m(g) {
    if (typeof g != "string")
      throw new r("Assertion failed: `argument` is not a String");
    if (l(g))
      return e(o(a(g, 2), 2));
    if (c(g))
      return e(o(a(g, 2), 8));
    if (h(g) || u(g))
      return NaN;
    var y = p(g);
    return y !== g ? m(y) : e(g);
  }, SA;
}
var OA, LG;
function prt() {
  if (LG) return OA;
  LG = 1;
  var t = /* @__PURE__ */ uu(), e = /* @__PURE__ */ go(), n = t("%Number%"), r = /* @__PURE__ */ rrt(), o = /* @__PURE__ */ lrt(), i = /* @__PURE__ */ hrt();
  return OA = function(s) {
    var a = r(s) ? s : o(s, n);
    if (typeof a == "symbol")
      throw new e("Cannot convert a Symbol value to a number");
    if (typeof a == "bigint")
      throw new e("Conversion from 'BigInt' to 'number' is not allowed.");
    return typeof a == "string" ? i(a) : n(a);
  }, OA;
}
var CA, FG;
function mrt() {
  if (FG) return CA;
  FG = 1;
  var t = Math.floor;
  return CA = function(e) {
    return typeof e == "bigint" ? e : t(e);
  }, CA;
}
var kA, BG;
function grt() {
  if (BG) return kA;
  BG = 1;
  var t = /* @__PURE__ */ mrt(), e = /* @__PURE__ */ go();
  return kA = function(n) {
    if (typeof n != "number" && typeof n != "bigint")
      throw new e("argument must be a Number or a BigInt");
    var r = n < 0 ? -t(-n) : t(n);
    return r === 0 ? 0 : r;
  }, kA;
}
var AA, zG;
function yrt() {
  if (zG) return AA;
  zG = 1;
  var t = /* @__PURE__ */ E4();
  return AA = function(e) {
    return (typeof e == "number" || typeof e == "bigint") && !t(e) && e !== 1 / 0 && e !== -1 / 0;
  }, AA;
}
var TA, qG;
function vrt() {
  if (qG) return TA;
  qG = 1;
  var t = /* @__PURE__ */ prt(), e = /* @__PURE__ */ grt(), n = /* @__PURE__ */ E4(), r = /* @__PURE__ */ yrt();
  return TA = function(o) {
    var i = t(o);
    return n(i) || i === 0 ? 0 : r(i) ? e(i) : i;
  }, TA;
}
var RA, UG;
function brt() {
  if (UG) return RA;
  UG = 1;
  var t = /* @__PURE__ */ nrt(), e = /* @__PURE__ */ vrt();
  return RA = function(n) {
    var r = e(n);
    return r <= 0 ? 0 : r > t ? t : r;
  }, RA;
}
var HG, VG;
function _rt() {
  return VG || (VG = 1, HG = T4()), HG;
}
var PA, WG;
function Rge() {
  if (WG) return PA;
  WG = 1;
  var t = /* @__PURE__ */ trt(), e = /* @__PURE__ */ brt(), n = /* @__PURE__ */ _rt();
  return PA = function(r) {
    var o = t(this), i = e(o.length);
    if (!n(r))
      throw new TypeError("Array#find: predicate must be a function");
    if (i !== 0) {
      var s;
      arguments.length > 0 && (s = arguments[1]);
      for (var a = 0, l; a < i; a++)
        if (l = o[a], r.apply(s, [l, a, o]))
          return l;
    }
  }, PA;
}
var GG, YG;
function Pge() {
  return YG || (YG = 1, GG = function() {
    var t = Array.prototype.find && [, 1].find(function() {
      return !0;
    }) !== 1;
    return t ? Array.prototype.find : Rge();
  }), GG;
}
var $A, KG;
function wrt() {
  if (KG) return $A;
  KG = 1;
  var t = /* @__PURE__ */ cu(), e = typeof Symbol == "function" && typeof Symbol.unscopables == "symbol", n = e && Array.prototype[Symbol.unscopables], r = TypeError;
  return $A = function(o) {
    if (typeof o != "string" || !o)
      throw new r("method must be a non-empty string");
    if (!t(Array.prototype, o))
      throw new r("method must be on Array.prototype");
    e && (n[o] = !0);
  }, $A;
}
var MA, XG;
function xrt() {
  if (XG) return MA;
  XG = 1;
  var t = to(), e = wrt(), n = Pge();
  return MA = function() {
    var r = n();
    return t(
      Array.prototype,
      { find: r },
      {
        find: function() {
          return Array.prototype.find !== r;
        }
      }
    ), e("find"), r;
  }, MA;
}
var DA, QG;
function $ge() {
  if (QG) return DA;
  QG = 1;
  var t = to(), e = $i(), n = /* @__PURE__ */ Mp(), r = Rge(), o = Pge(), i = xrt(), s = e("Array.prototype.slice"), a = o(), l = function(c, u) {
    n(c);
    var d = s(arguments, 1);
    return a.apply(c, d);
  };
  return t(l, {
    getPolyfill: o,
    implementation: r,
    shim: i
  }), DA = l, DA;
}
var ZG = {}, JG, eY;
function Ert() {
  return eY || (eY = 1, JG = T4()), JG;
}
var IA, tY;
function Srt() {
  if (tY) return IA;
  tY = 1;
  var t = /* @__PURE__ */ go(), e = /* @__PURE__ */ cu(), n = /* @__PURE__ */ vge(), r = /* @__PURE__ */ bge();
  return IA = function(o, i) {
    if (r(o) !== "Object")
      throw new t("Assertion failed: `O` must be an Object");
    if (!n(i))
      throw new t("Assertion failed: `P` must be a Property Key");
    return e(o, i);
  }, IA;
}
var NA, nY;
function Mge() {
  if (nY) return NA;
  nY = 1;
  var t = function() {
    return typeof function() {
    }.name == "string";
  }, e = Object.getOwnPropertyDescriptor;
  if (e)
    try {
      e([], "length");
    } catch {
      e = null;
    }
  t.functionsHaveConfigurableNames = function() {
    if (!t() || !e)
      return !1;
    var r = e(function() {
    }, "name");
    return !!r && !!r.configurable;
  };
  var n = Function.prototype.bind;
  return t.boundFunctionsHaveNames = function() {
    return t() && typeof n == "function" && function() {
    }.bind().name !== "";
  }, NA = t, NA;
}
var jA, rY;
function Dge() {
  if (rY) return jA;
  rY = 1;
  var t = /* @__PURE__ */ Ert(), e = /* @__PURE__ */ Srt(), n = Mge()(), r = $i(), o = r("Function.prototype.toString"), i = r("String.prototype.match"), s = r("Object.prototype.toString"), a = /^class /, l = function(g) {
    if (t(g) || typeof g != "function")
      return !1;
    try {
      var y = i(o(g), a);
      return !!y;
    } catch {
    }
    return !1;
  }, c = /\s*function\s+([^(\s]*)\s*/, u = !(0 in [,]), d = "[object Object]", f = "[object HTMLAllCollection]", h = Function.prototype, p = function() {
    return !1;
  };
  if (typeof document == "object") {
    var m = document.all;
    s(m) === s(document.all) && (p = function(g) {
      if ((u || !g) && (typeof g > "u" || typeof g == "object"))
        try {
          var y = s(g);
          return (y === f || y === d) && g("") == null;
        } catch {
        }
      return !1;
    });
  }
  return jA = function() {
    if (p(this) || !l(this) && !t(this))
      throw new TypeError("Function.prototype.name sham getter called on non-function");
    if (n && e(this, "name"))
      return this.name;
    if (this === h)
      return "";
    var g = o(this), y = i(g, c), v = y && y[1];
    return v;
  }, jA;
}
var LA, oY;
function Ige() {
  if (oY) return LA;
  oY = 1;
  var t = Dge();
  return LA = function() {
    return t;
  }, LA;
}
var FA, iY;
function Ort() {
  if (iY) return FA;
  iY = 1;
  var t = to().supportsDescriptors, e = Mge()(), n = Ige(), r = Object.defineProperty, o = TypeError;
  return FA = function() {
    var i = n();
    if (e)
      return i;
    if (!t)
      throw new o("Shimming Function.prototype.name support requires ES5 property descriptor support.");
    var s = Function.prototype;
    return r(s, "name", {
      configurable: !0,
      enumerable: !1,
      get: function() {
        var a = i.call(this);
        return this !== s && r(this, "name", {
          configurable: !0,
          enumerable: !1,
          value: a,
          writable: !1
        }), a;
      }
    }), i;
  }, FA;
}
var BA, sY;
function Crt() {
  if (sY) return BA;
  sY = 1;
  var t = to(), e = Wl(), n = Dge(), r = Ige(), o = Ort(), i = e(n);
  return t(i, {
    getPolyfill: r,
    implementation: n,
    shim: o
  }), BA = i, BA;
}
var zA = { exports: {} }, hn = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var aY;
function krt() {
  if (aY) return hn;
  aY = 1;
  var t = typeof Symbol == "function" && Symbol.for, e = t ? Symbol.for("react.element") : 60103, n = t ? Symbol.for("react.portal") : 60106, r = t ? Symbol.for("react.fragment") : 60107, o = t ? Symbol.for("react.strict_mode") : 60108, i = t ? Symbol.for("react.profiler") : 60114, s = t ? Symbol.for("react.provider") : 60109, a = t ? Symbol.for("react.context") : 60110, l = t ? Symbol.for("react.async_mode") : 60111, c = t ? Symbol.for("react.concurrent_mode") : 60111, u = t ? Symbol.for("react.forward_ref") : 60112, d = t ? Symbol.for("react.suspense") : 60113, f = t ? Symbol.for("react.suspense_list") : 60120, h = t ? Symbol.for("react.memo") : 60115, p = t ? Symbol.for("react.lazy") : 60116, m = t ? Symbol.for("react.block") : 60121, g = t ? Symbol.for("react.fundamental") : 60117, y = t ? Symbol.for("react.responder") : 60118, v = t ? Symbol.for("react.scope") : 60119;
  function b(w) {
    if (typeof w == "object" && w !== null) {
      var x = w.$$typeof;
      switch (x) {
        case e:
          switch (w = w.type, w) {
            case l:
            case c:
            case r:
            case i:
            case o:
            case d:
              return w;
            default:
              switch (w = w && w.$$typeof, w) {
                case a:
                case u:
                case p:
                case h:
                case s:
                  return w;
                default:
                  return x;
              }
          }
        case n:
          return x;
      }
    }
  }
  function _(w) {
    return b(w) === c;
  }
  return hn.AsyncMode = l, hn.ConcurrentMode = c, hn.ContextConsumer = a, hn.ContextProvider = s, hn.Element = e, hn.ForwardRef = u, hn.Fragment = r, hn.Lazy = p, hn.Memo = h, hn.Portal = n, hn.Profiler = i, hn.StrictMode = o, hn.Suspense = d, hn.isAsyncMode = function(w) {
    return _(w) || b(w) === l;
  }, hn.isConcurrentMode = _, hn.isContextConsumer = function(w) {
    return b(w) === a;
  }, hn.isContextProvider = function(w) {
    return b(w) === s;
  }, hn.isElement = function(w) {
    return typeof w == "object" && w !== null && w.$$typeof === e;
  }, hn.isForwardRef = function(w) {
    return b(w) === u;
  }, hn.isFragment = function(w) {
    return b(w) === r;
  }, hn.isLazy = function(w) {
    return b(w) === p;
  }, hn.isMemo = function(w) {
    return b(w) === h;
  }, hn.isPortal = function(w) {
    return b(w) === n;
  }, hn.isProfiler = function(w) {
    return b(w) === i;
  }, hn.isStrictMode = function(w) {
    return b(w) === o;
  }, hn.isSuspense = function(w) {
    return b(w) === d;
  }, hn.isValidElementType = function(w) {
    return typeof w == "string" || typeof w == "function" || w === r || w === c || w === i || w === o || w === d || w === f || typeof w == "object" && w !== null && (w.$$typeof === p || w.$$typeof === h || w.$$typeof === s || w.$$typeof === a || w.$$typeof === u || w.$$typeof === g || w.$$typeof === y || w.$$typeof === v || w.$$typeof === m);
  }, hn.typeOf = b, hn;
}
var En = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var lY;
function Art() {
  return lY || (lY = 1, process.env.NODE_ENV !== "production" && function() {
    var t = typeof Symbol == "function" && Symbol.for, e = t ? Symbol.for("react.element") : 60103, n = t ? Symbol.for("react.portal") : 60106, r = t ? Symbol.for("react.fragment") : 60107, o = t ? Symbol.for("react.strict_mode") : 60108, i = t ? Symbol.for("react.profiler") : 60114, s = t ? Symbol.for("react.provider") : 60109, a = t ? Symbol.for("react.context") : 60110, l = t ? Symbol.for("react.async_mode") : 60111, c = t ? Symbol.for("react.concurrent_mode") : 60111, u = t ? Symbol.for("react.forward_ref") : 60112, d = t ? Symbol.for("react.suspense") : 60113, f = t ? Symbol.for("react.suspense_list") : 60120, h = t ? Symbol.for("react.memo") : 60115, p = t ? Symbol.for("react.lazy") : 60116, m = t ? Symbol.for("react.block") : 60121, g = t ? Symbol.for("react.fundamental") : 60117, y = t ? Symbol.for("react.responder") : 60118, v = t ? Symbol.for("react.scope") : 60119;
    function b(L) {
      return typeof L == "string" || typeof L == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      L === r || L === c || L === i || L === o || L === d || L === f || typeof L == "object" && L !== null && (L.$$typeof === p || L.$$typeof === h || L.$$typeof === s || L.$$typeof === a || L.$$typeof === u || L.$$typeof === g || L.$$typeof === y || L.$$typeof === v || L.$$typeof === m);
    }
    function _(L) {
      if (typeof L == "object" && L !== null) {
        var V = L.$$typeof;
        switch (V) {
          case e:
            var K = L.type;
            switch (K) {
              case l:
              case c:
              case r:
              case i:
              case o:
              case d:
                return K;
              default:
                var ne = K && K.$$typeof;
                switch (ne) {
                  case a:
                  case u:
                  case p:
                  case h:
                  case s:
                    return ne;
                  default:
                    return V;
                }
            }
          case n:
            return V;
        }
      }
    }
    var w = l, x = c, E = a, S = s, C = e, R = u, P = r, N = p, A = h, O = n, k = i, T = o, I = d, j = !1;
    function z(L) {
      return j || (j = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), $(L) || _(L) === l;
    }
    function $(L) {
      return _(L) === c;
    }
    function D(L) {
      return _(L) === a;
    }
    function U(L) {
      return _(L) === s;
    }
    function q(L) {
      return typeof L == "object" && L !== null && L.$$typeof === e;
    }
    function F(L) {
      return _(L) === u;
    }
    function B(L) {
      return _(L) === r;
    }
    function H(L) {
      return _(L) === p;
    }
    function Z(L) {
      return _(L) === h;
    }
    function W(L) {
      return _(L) === n;
    }
    function G(L) {
      return _(L) === i;
    }
    function ee(L) {
      return _(L) === o;
    }
    function Y(L) {
      return _(L) === d;
    }
    En.AsyncMode = w, En.ConcurrentMode = x, En.ContextConsumer = E, En.ContextProvider = S, En.Element = C, En.ForwardRef = R, En.Fragment = P, En.Lazy = N, En.Memo = A, En.Portal = O, En.Profiler = k, En.StrictMode = T, En.Suspense = I, En.isAsyncMode = z, En.isConcurrentMode = $, En.isContextConsumer = D, En.isContextProvider = U, En.isElement = q, En.isForwardRef = F, En.isFragment = B, En.isLazy = H, En.isMemo = Z, En.isPortal = W, En.isProfiler = G, En.isStrictMode = ee, En.isSuspense = Y, En.isValidElementType = b, En.typeOf = _;
  }()), En;
}
var cY;
function Nge() {
  return cY || (cY = 1, process.env.NODE_ENV === "production" ? zA.exports = krt() : zA.exports = Art()), zA.exports;
}
var uY;
function Tv() {
  return uY || (uY = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = o;
    var e = r(Crt()), n = Nge();
    function r(i) {
      return i && i.__esModule ? i : { default: i };
    }
    function o(i) {
      return typeof i == "string" ? i : typeof i == "function" ? i.displayName || (0, e.default)(i) : (0, n.isForwardRef)({
        type: i,
        $$typeof: n.Element
      }) ? i.displayName : (0, n.isMemo)(i) ? o(i.type) : null;
    }
  }(ZG)), ZG;
}
var dY;
function Trt() {
  return dY || (dY = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var e = i($ge()), n = i(Tv()), r = i(A4()), o = i(tn());
    function i(u) {
      return u && u.__esModule ? u : { default: u };
    }
    function s(u, d, f) {
      if (!d.every(function(p) {
        return p && (0, e.default)(u, function(m) {
          return m === "*" || p.type === m;
        });
      })) {
        var h = u.map(n.default).join(", or ");
        return new TypeError("`".concat(f, "` only accepts children of type ").concat(h));
      }
      return null;
    }
    function a(u, d, f) {
      if (d.length === 0) {
        var h = u.map(n.default).join(", or ");
        return new TypeError("`".concat(f, "` requires at least one node of type ").concat(h));
      }
      return null;
    }
    function l() {
      for (var u = arguments.length, d = new Array(u), f = 0; f < u; f++)
        d[f] = arguments[f];
      if (d.length < 1)
        throw new TypeError("childrenOfType: at least 1 type is required");
      function h(p, m, g) {
        return s(d, (0, r.default)(p[m]), g);
      }
      return h.isRequired = function(p, m, g) {
        var y = (0, r.default)(p[m]);
        return a(d, y, g) || s(d, y, g);
      }, (0, o.default)(h, "childrenOfType", d);
    }
    var c = l;
    t.default = c;
  }(yG)), yG;
}
var fY = {}, hY = {}, pY = {}, mY = {}, gY = {}, yY;
function jge() {
  return yY || (yY = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var e = Math.floor, n = isFinite, r = Number.isInteger || /* istanbul ignore next */
    function(o) {
      return typeof o == "number" && n(o) && e(o) === o;
    };
    t.default = r;
  }(gY)), gY;
}
var vY;
function R4() {
  return vY || (vY = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var e = r(jge()), n = r(tn());
    function r(a) {
      return a && a.__esModule ? a : { default: a };
    }
    function o(a, l, c) {
      var u = a[l];
      return u == null || !(0, e.default)(u) ? new RangeError("".concat(l, " in ").concat(c, " must be an integer")) : null;
    }
    var i = function(a, l) {
      var c = a[l];
      if (c == null)
        return null;
      for (var u = arguments.length, d = new Array(u > 2 ? u - 2 : 0), f = 2; f < u; f++)
        d[f - 2] = arguments[f];
      return o.apply(void 0, [a, l].concat(d));
    };
    i.isRequired = o;
    var s = function() {
      return (0, n.default)(i, "integer");
    };
    t.default = s;
  }(mY)), mY;
}
var bY = {}, _Y;
function Lge() {
  return _Y || (_Y = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var e = r(w4()), n = r(tn());
    function r(l) {
      return l && l.__esModule ? l : { default: l };
    }
    function o(l) {
      return typeof l == "number" && isFinite(l) && l >= 0 && !(0, e.default)(l, -0);
    }
    function i(l, c, u) {
      var d = l[c];
      return d == null || o(d) ? null : new RangeError("".concat(c, " in ").concat(u, " must be a non-negative number"));
    }
    function s(l, c, u) {
      var d = l[c];
      return o(d) ? null : new RangeError("".concat(c, " in ").concat(u, " must be a non-negative number"));
    }
    i.isRequired = s;
    var a = function() {
      return (0, n.default)(i, "nonNegativeNumber");
    };
    t.default = a;
  }(bY)), bY;
}
var wY;
function Fge() {
  return wY || (wY = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var e = o(Qd()), n = o(R4()), r = o(Lge());
    function o(s) {
      return s && s.__esModule ? s : { default: s };
    }
    var i = (0, e.default)([(0, n.default)(), (0, r.default)()], "nonNegativeInteger");
    t.default = i;
  }(pY)), pY;
}
var xY = {}, EY = {}, SY;
function Bge() {
  return SY || (SY = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = o;
    var e = n(xe);
    function n(i) {
      return i && i.__esModule ? i : { default: i };
    }
    function r(i) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? r = function(s) {
        return typeof s;
      } : r = function(s) {
        return s && typeof Symbol == "function" && s.constructor === Symbol && s !== Symbol.prototype ? "symbol" : typeof s;
      }, r(i);
    }
    function o(i) {
      return i === null ? "null" : Array.isArray(i) ? "array" : r(i) !== "object" ? r(i) : /* @__PURE__ */ e.default.isValidElement(i) ? i.type : i;
    }
  }(EY)), EY;
}
var OY;
function zge() {
  return OY || (OY = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var e = o(O4()), n = o(Bge()), r = o(tn());
    function o(l) {
      return l && l.__esModule ? l : { default: l };
    }
    var i = {
      prop: "prop",
      context: "context",
      childContext: "child context"
    };
    function s(l, c, u, d, f) {
      var h = l[c];
      if (h == null || (0, e.default)(h))
        return null;
      var p = i[d] || d;
      return new TypeError("Invalid ".concat(p, " `").concat(f, "` of type `").concat((0, n.default)(h), "` supplied to `").concat(u, "`, expected `object`."));
    }
    s.isRequired = function(l, c, u, d, f) {
      var h = l[c];
      if (h == null) {
        var p = i[d] || d;
        return new TypeError("The ".concat(p, " `").concat(f, "` is marked as required in `").concat(u, "`, but its value is `").concat(h, "`."));
      }
      for (var m = arguments.length, g = new Array(m > 5 ? m - 5 : 0), y = 5; y < m; y++)
        g[y - 5] = arguments[y];
      return s.apply(void 0, [l, c, u, d, f].concat(g));
    };
    var a = function() {
      return (0, r.default)(s, "object");
    };
    t.default = a;
  }(xY)), xY;
}
var CY = {}, kY;
function P4() {
  return kY || (kY = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = o;
    var e = r(Qd()), n = r(C4());
    function r(i) {
      return i && i.__esModule ? i : { default: i };
    }
    function o(i, s) {
      if (typeof i != "function")
        throw new TypeError("type must be a valid PropType");
      var a = (0, n.default)(s);
      return (0, e.default)([i, a], "withShape");
    }
  }(CY)), CY;
}
var AY;
function qge() {
  return AY || (AY = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = w;
    var e = /* @__PURE__ */ Tr(), n = c(Qd()), r = c(k4()), o = c(Fge()), i = c(zge()), s = c(P4()), a = c(Bge()), l = c(tn());
    function c(x) {
      return x && x.__esModule ? x : { default: x };
    }
    function u(x, E) {
      var S = Object.keys(x);
      if (Object.getOwnPropertySymbols) {
        var C = Object.getOwnPropertySymbols(x);
        E && (C = C.filter(function(R) {
          return Object.getOwnPropertyDescriptor(x, R).enumerable;
        })), S.push.apply(S, C);
      }
      return S;
    }
    function d(x) {
      for (var E = 1; E < arguments.length; E++) {
        var S = arguments[E] != null ? arguments[E] : {};
        E % 2 ? u(Object(S), !0).forEach(function(C) {
          f(x, C, S[C]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(x, Object.getOwnPropertyDescriptors(S)) : u(Object(S)).forEach(function(C) {
          Object.defineProperty(x, C, Object.getOwnPropertyDescriptor(S, C));
        });
      }
      return x;
    }
    function f(x, E, S) {
      return E in x ? Object.defineProperty(x, E, { value: S, enumerable: !0, configurable: !0, writable: !0 }) : x[E] = S, x;
    }
    var h = o.default, p = (0, n.default)([o.default, (0, r.default)({
      gte: 1
    })]);
    function m(x, E) {
      return typeof E != "number" || typeof x != "number" || x <= E ? null : new RangeError("min must be less than or equal to max");
    }
    var g = {
      validator: function(x, E) {
        var S = x[E];
        return typeof S != "function" ? new TypeError('"validator" must be a propType validator function') : null;
      },
      min: function(x, E) {
        return h(x, E) || m(x.min, x.max);
      },
      max: function(x, E) {
        return p(x, E) || m(x.min, x.max);
      }
    };
    function y(x) {
      var E = x.min, S = x.max, C, R;
      return typeof E != "number" && typeof S != "number" ? (C = 1, R = 1) : (C = typeof E == "number" ? E : 1, R = typeof S == "number" ? S : 1 / 0), {
        minimum: C,
        maximum: R
      };
    }
    function v(x) {
      var E = [], S;
      return x.reduce(function(C, R) {
        var P = (0, a.default)(R);
        return !S || P === S ? E.push(R) : (C.push(E), E = [R]), S = P, C;
      }, []).concat(E.length > 0 ? [E] : []);
    }
    function b(x, E, S, C) {
      for (var R = E[S], P = v(R), N = arguments.length, A = new Array(N > 4 ? N - 4 : 0), O = 4; O < N; O++)
        A[O - 4] = arguments[O];
      for (var k = 0; k < x.length; k += 1) {
        var T = x[k], I = T.validator, j = T.min, z = T.max, $ = y({
          min: j,
          max: z
        }), D = $.minimum, U = $.maximum;
        if (!(P.length === 0 && D === 0)) {
          var q = (0, e.arrayOf)(I).isRequired, F = P.shift(), B = q.apply(void 0, [d(d({}, E), {}, f({}, S, F)), S, C].concat(A));
          if (B) {
            if (D === 0) {
              P.unshift(F);
              continue;
            }
            return B;
          }
          if (F.length < D)
            return new RangeError("".concat(C, ": specifier index ").concat(k, " requires a minimum of ").concat(j, " items, but only has ").concat(F.length, "."));
          if (F.length > U)
            return new RangeError("".concat(C, ": specifier index ").concat(k, " requires a maximum of ").concat(z, " items, but has ").concat(F.length, "."));
        }
      }
      return P.length > 0 ? new TypeError("".concat(C, ": after all ").concat(x.length, " specifiers matched, ").concat(P.length, " types of items were remaining.")) : null;
    }
    var _ = (0, s.default)((0, i.default)(), g).isRequired;
    function w() {
      for (var x = arguments.length, E = new Array(x), S = 0; S < x; S++)
        E[S] = arguments[S];
      if (E.length === 0)
        throw new RangeError("sequenceOf: at least one specifier is required");
      var C = E.map(function(P, N) {
        return _({
          specifier: P
        }, "specifier", "sequenceOf specifier", "suequenceOf specifier, index ".concat(N), "specifier, index ".concat(N));
      });
      if (C.some(Boolean))
        throw new TypeError(`
      sequenceOf: all specifiers must match the appropriate shape.

      Errors:
        `.concat(C.map(function(P, N) {
          return " - Argument index ".concat(N, ": ").concat(P.message);
        }).join(`,
        `), `
    `));
      var R = function(P, N) {
        var A = P[N];
        if (A == null)
          return null;
        for (var O = arguments.length, k = new Array(O > 2 ? O - 2 : 0), T = 2; T < O; T++)
          k[T - 2] = arguments[T];
        var I = e.array.apply(void 0, [P, N].concat(k));
        return I || b.apply(void 0, [E, P, N].concat(k));
      };
      return R.isRequired = function(P, N, A) {
        for (var O = arguments.length, k = new Array(O > 3 ? O - 3 : 0), T = 3; T < O; T++)
          k[T - 3] = arguments[T];
        var I = e.array.isRequired.apply(e.array, [P, N, A].concat(k));
        return I || b.apply(void 0, [E, P, N, A].concat(k));
      }, (0, l.default)(R, "sequenceOf", E);
    }
  }(hY)), hY;
}
var TY;
function Rrt() {
  return TY || (TY = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = l;
    var e = o(qge()), n = o(A4()), r = o(tn());
    function o(c) {
      return c && c.__esModule ? c : { default: c };
    }
    function i(c, u) {
      var d = Object.keys(c);
      if (Object.getOwnPropertySymbols) {
        var f = Object.getOwnPropertySymbols(c);
        u && (f = f.filter(function(h) {
          return Object.getOwnPropertyDescriptor(c, h).enumerable;
        })), d.push.apply(d, f);
      }
      return d;
    }
    function s(c) {
      for (var u = 1; u < arguments.length; u++) {
        var d = arguments[u] != null ? arguments[u] : {};
        u % 2 ? i(Object(d), !0).forEach(function(f) {
          a(c, f, d[f]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(c, Object.getOwnPropertyDescriptors(d)) : i(Object(d)).forEach(function(f) {
          Object.defineProperty(c, f, Object.getOwnPropertyDescriptor(d, f));
        });
      }
      return c;
    }
    function a(c, u, d) {
      return u in c ? Object.defineProperty(c, u, { value: d, enumerable: !0, configurable: !0, writable: !0 }) : c[u] = d, c;
    }
    function l() {
      for (var c = arguments.length, u = new Array(c), d = 0; d < c; d++)
        u[d] = arguments[d];
      var f = e.default.apply(void 0, u), h = function(p, m, g) {
        if (m !== "children")
          return new TypeError("".concat(g, ' is using the childrenSequenceOf validator on non-children prop "').concat(m, '"'));
        var y = p[m], v = (0, n.default)(y);
        if (v.length === 0)
          return null;
        for (var b = arguments.length, _ = new Array(b > 3 ? b - 3 : 0), w = 3; w < b; w++)
          _[w - 3] = arguments[w];
        return f.apply(void 0, [s(s({}, p), {}, {
          children: v
        }), m, g].concat(_));
      };
      return h.isRequired = function(p, m, g) {
        if (m !== "children")
          return new TypeError("".concat(g, ' is using the childrenSequenceOf validator on non-children prop "').concat(m, '"'));
        var y = p[m], v = (0, n.default)(y);
        if (v.length === 0)
          return new TypeError("".concat(g, ": renderable children are required."));
        for (var b = arguments.length, _ = new Array(b > 3 ? b - 3 : 0), w = 3; w < b; w++)
          _[w - 3] = arguments[w];
        return f.isRequired.apply(f, [s(s({}, p), {}, {
          children: v
        }), m, g].concat(_));
      }, (0, r.default)(h, "childrenSequenceOf", u);
    }
  }(fY)), fY;
}
var RY = {}, PY;
function Prt() {
  return PY || (PY = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = c;
    var e = s(xe), n = s(kge()), r = s($ge()), o = s(Tv()), i = s(tn());
    function s(u) {
      return u && u.__esModule ? u : { default: u };
    }
    function a(u, d) {
      for (var f = u; /\([^()]*\)/g.test(f); ) {
        var h = f, p = void 0;
        do
          p = h, h = p.replace(/\([^()]*\)/g, "");
        while (p !== h);
        if (d.indexOf(h) === -1)
          return f;
        f = f.replace(RegExp("^".concat(h, "\\(|\\)$"), "g"), "");
      }
      return f;
    }
    function l(u, d, f, h, p) {
      for (var m = arguments.length, g = new Array(m > 5 ? m - 5 : 0), y = 5; y < m; y++)
        g[y - 5] = arguments[y];
      if (Array.isArray(f))
        return (0, r.default)(f.map(function(w) {
          return l.apply(void 0, [u, d, w, h, p].concat(g));
        }), Boolean) || null;
      if (!/* @__PURE__ */ e.default.isValidElement(f))
        return new TypeError("".concat(p, ".").concat(h, " is not a valid React element"));
      var v = f.type, b = (0, o.default)(v), _ = d.length > 0 ? a(b, d) : b;
      return (0, n.default)(u) && !u.test(_) ? new TypeError("`".concat(p, ".").concat(h, "` only accepts components matching the regular expression ").concat(u)) : !(0, n.default)(u) && _ !== u ? new TypeError("`".concat(p, ".").concat(h, "` only accepts components named ").concat(u, ", got ").concat(_)) : null;
    }
    function c(u) {
      var d = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      if (typeof u != "string" && !(0, n.default)(u))
        throw new TypeError("name must be a string or a regex");
      var f = Object.keys(d);
      if (f.length > 1 || f.length === 1 && f[0] !== "stripHOCs")
        throw new TypeError("The only options supported are: “stripHOCs”, got: “".concat(f.join("”, “"), "”"));
      var h = d.stripHOCs, p = h === void 0 ? [] : h, m = p.every(function(y) {
        return typeof y != "string" || /[()]/g.test(y) ? !1 : /^(?:[a-z][a-zA-Z0-9]+|[A-Z][a-z][a-zA-Z0-9]+)$/.test(y);
      });
      if (!m)
        throw new TypeError("every provided HOC name must be a string with no parens, and in camelCase");
      function g(y, v, b) {
        var _ = y[v];
        if (y[v] == null)
          return null;
        for (var w = arguments.length, x = new Array(w > 3 ? w - 3 : 0), E = 3; E < w; E++)
          x[E - 3] = arguments[E];
        return l.apply(void 0, [u, p, _, v, b].concat(x));
      }
      return g.isRequired = function(y, v, b) {
        var _ = y[v];
        if (_ == null)
          return new TypeError("`".concat(b, ".").concat(v, "` requires at least one component named ").concat(u));
        for (var w = arguments.length, x = new Array(w > 3 ? w - 3 : 0), E = 3; E < w; E++)
          x[E - 3] = arguments[E];
        return l.apply(void 0, [u, p, _, v, b].concat(x));
      }, (0, i.default)(g, "componentWithName:".concat(u), u);
    }
  }(RY)), RY;
}
var $Y = {}, MY;
function $rt() {
  return MY || (MY = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = r;
    var e = n(tn());
    function n(o) {
      return o && o.__esModule ? o : { default: o };
    }
    function r(o, i, s) {
      if (typeof o != "function" || typeof o.isRequired != "function")
        throw new TypeError("a propType validator is required; propType validators must also provide `.isRequired`");
      if (typeof i != "string")
        throw new TypeError("other prop name must be a string");
      if (typeof s != "function")
        throw new TypeError("other prop type validator is required");
      function a(c, u, d) {
        for (var f = arguments.length, h = new Array(f > 3 ? f - 3 : 0), p = 3; p < f; p++)
          h[p - 3] = arguments[p];
        var m = o.isRequired.apply(o, [c, u, d].concat(h));
        if (m)
          return m;
        if (c[i] == null)
          return null;
        var g = s.apply(void 0, [c, i, d].concat(h));
        return g ? null : new Error("prop “".concat(u, "” is disallowed when “").concat(i, "” matches the provided validator"));
      }
      var l = function(c, u) {
        if (c[u] == null)
          return null;
        for (var d = arguments.length, f = new Array(d > 2 ? d - 2 : 0), h = 2; h < d; h++)
          f[h - 2] = arguments[h];
        return a.apply(void 0, [c, u].concat(f));
      };
      return l.isRequired = a, (0, e.default)(l, "disallowedIf", {
        propType: o,
        otherPropName: i,
        otherPropType: s
      });
    }
  }($Y)), $Y;
}
var DY = {}, IY;
function Mrt() {
  return IY || (IY = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = u;
    var e = /* @__PURE__ */ Tr(), n = Nge(), r = s(Qd()), o = s(Tv()), i = s(tn());
    function s(d) {
      return d && d.__esModule ? d : { default: d };
    }
    function a(d) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? a = function(f) {
        return typeof f;
      } : a = function(f) {
        return f && typeof Symbol == "function" && f.constructor === Symbol && f !== Symbol.prototype ? "symbol" : typeof f;
      }, a(d);
    }
    function l(d) {
      if (typeof d == "string")
        return d;
      var f = (0, o.default)(d);
      return f || "Anonymous Component";
    }
    function c(d, f, h, p) {
      var m = f[h].type;
      return m === d ? null : new TypeError("".concat(p, ".").concat(h, " must be a React element of type ").concat(l(d)));
    }
    function u(d) {
      if (d === "*")
        return (0, i.default)(e.element, "elementType(*)", d);
      if (!(0, n.isValidElementType)(d))
        throw new TypeError('Type must be a React Component, an HTML element tag name, or "*". Got an '.concat(a(d)));
      function f(m, g, y) {
        if (m[g] == null)
          return null;
        for (var v = arguments.length, b = new Array(v > 3 ? v - 3 : 0), _ = 3; _ < v; _++)
          b[_ - 3] = arguments[_];
        return c.apply(void 0, [d, m, g, y].concat(b));
      }
      f.isRequired = f;
      var h = l(d), p = "elementType(".concat(h, ")");
      return (0, i.default)((0, r.default)([e.element, f], p), p, d);
    }
  }(DY)), DY;
}
var NY = {}, jY = {}, LY;
function Uge() {
  return LY || (LY = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = d;
    var e = /* @__PURE__ */ Tr(), n = r(tn());
    function r(f) {
      return f && f.__esModule ? f : { default: f };
    }
    function o(f) {
      return l(f) || a(f) || s(f) || i();
    }
    function i() {
      throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    function s(f, h) {
      if (f) {
        if (typeof f == "string") return c(f, h);
        var p = Object.prototype.toString.call(f).slice(8, -1);
        if (p === "Object" && f.constructor && (p = f.constructor.name), p === "Map" || p === "Set") return Array.from(f);
        if (p === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(p)) return c(f, h);
      }
    }
    function a(f) {
      if (typeof Symbol < "u" && Symbol.iterator in Object(f)) return Array.from(f);
    }
    function l(f) {
      if (Array.isArray(f)) return c(f);
    }
    function c(f, h) {
      (h == null || h > f.length) && (h = f.length);
      for (var p = 0, m = new Array(h); p < h; p++)
        m[p] = f[p];
      return m;
    }
    function u(f) {
      var h = function(p, m, g) {
        for (var y = arguments.length, v = new Array(y > 3 ? y - 3 : 0), b = 3; b < y; b++)
          v[b - 3] = arguments[b];
        var _ = p[m];
        if (typeof _ > "u")
          return null;
        var w = f.map(function(x) {
          return x.apply(void 0, [p, m, g].concat(v));
        }).filter(Boolean);
        return w.length < f.length ? null : new TypeError("".concat(g, ": invalid value supplied to ").concat(m, "."));
      };
      return h.isRequired = function(p, m, g) {
        for (var y = arguments.length, v = new Array(y > 3 ? y - 3 : 0), b = 3; b < y; b++)
          v[b - 3] = arguments[b];
        var _ = p[m];
        if (typeof _ > "u")
          return new TypeError("".concat(g, ": missing value for required ").concat(m, "."));
        var w = f.map(function(x) {
          return x.apply(void 0, [p, m, g].concat(v));
        }).filter(Boolean);
        return w.length === f.length ? new TypeError("".concat(g, ": invalid value ").concat(w, " supplied to required ").concat(m, ".")) : null;
      }, (0, n.default)(h, "oneOfType", f);
    }
    function d(f) {
      var h = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "or";
      if (!Array.isArray(f))
        throw new TypeError("or: 2 or more validators are required");
      if (f.length <= 1)
        throw new RangeError("or: 2 or more validators are required");
      var p = u([(0, e.arrayOf)(u(f))].concat(o(f)));
      return (0, n.default)(p, h, f);
    }
  }(jY)), jY;
}
var FY = {}, BY;
function Hge() {
  return BY || (BY = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var e = n(tn());
    function n(s) {
      return s && s.__esModule ? s : { default: s };
    }
    function r(s) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? r = function(a) {
        return typeof a;
      } : r = function(a) {
        return a && typeof Symbol == "function" && a.constructor === Symbol && a !== Symbol.prototype ? "symbol" : typeof a;
      }, r(s);
    }
    function o(s, a, l) {
      return s[a] == null ? null : new TypeError("".concat(l, ": prop “").concat(a, "” must be null or undefined; received ").concat(r(s[a])));
    }
    o.isRequired = function(s, a, l) {
      return s[a] === null ? null : new TypeError("".concat(l, ": prop “").concat(a, "” must be null; received ").concat(r(s[a])));
    };
    var i = function() {
      return (0, e.default)(o, "explicitNull");
    };
    t.default = i;
  }(FY)), FY;
}
var zY;
function Drt() {
  return zY || (zY = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var e = /* @__PURE__ */ Tr(), n = s(Uge()), r = s(Hge()), o = s(P4()), i = s(tn());
    function s(u) {
      return u && u.__esModule ? u : { default: u };
    }
    var a, l = (0, n.default)([
      r.default,
      // null/undefined
      (0, e.oneOf)([!1, "", NaN]),
      (0, o.default)(e.array, {
        length: (0, e.oneOf)([0]).isRequired
      }).isRequired,
      function() {
        return a.apply(void 0, arguments);
      }
    ]);
    a = (0, e.arrayOf)(l).isRequired;
    var c = function() {
      return (0, i.default)(l, "empty");
    };
    t.default = c;
  }(NY)), NY;
}
var qY = {}, UY;
function Irt() {
  return UY || (UY = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = i;
    var e = r(Oge()), n = r(tn());
    function r(s) {
      return s && s.__esModule ? s : { default: s };
    }
    function o(s, a, l) {
      return a in s ? Object.defineProperty(s, a, { value: l, enumerable: !0, configurable: !0, writable: !0 }) : s[a] = l, s;
    }
    function i(s) {
      var a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "keysOf";
      if (typeof s != "function")
        throw new TypeError("argument to keysOf must be a valid PropType function");
      var l = function(c, u, d, f, h) {
        for (var p = arguments.length, m = new Array(p > 5 ? p - 5 : 0), g = 5; g < p; g++)
          m[g - 5] = arguments[g];
        var y = c[u];
        if (y == null || (0, e.default)(y))
          return null;
        var v = null;
        return Object.keys(y).some(function(b) {
          return v = s.apply(void 0, [o({}, b, b), b, d, f, "(".concat(h, ").").concat(b)].concat(m)), v != null;
        }), v || null;
      };
      return l.isRequired = function(c, u, d) {
        var f = c[u];
        if (f == null)
          return new TypeError("".concat(d, ": ").concat(u, " is required, but value is ").concat(f));
        for (var h = arguments.length, p = new Array(h > 3 ? h - 3 : 0), m = 3; m < h; m++)
          p[m - 3] = arguments[m];
        return l.apply(void 0, [c, u, d].concat(p));
      }, (0, n.default)(l, a, s);
    }
  }(qY)), qY;
}
var HY = {}, VY;
function Nrt() {
  return VY || (VY = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = s;
    var e = n(tn());
    function n(a) {
      return a && a.__esModule ? a : { default: a };
    }
    function r(a, l) {
      var c = Object.keys(a);
      if (Object.getOwnPropertySymbols) {
        var u = Object.getOwnPropertySymbols(a);
        l && (u = u.filter(function(d) {
          return Object.getOwnPropertyDescriptor(a, d).enumerable;
        })), c.push.apply(c, u);
      }
      return c;
    }
    function o(a) {
      for (var l = 1; l < arguments.length; l++) {
        var c = arguments[l] != null ? arguments[l] : {};
        l % 2 ? r(Object(c), !0).forEach(function(u) {
          i(a, u, c[u]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(c)) : r(Object(c)).forEach(function(u) {
          Object.defineProperty(a, u, Object.getOwnPropertyDescriptor(c, u));
        });
      }
      return a;
    }
    function i(a, l, c) {
      return l in a ? Object.defineProperty(a, l, { value: c, enumerable: !0, configurable: !0, writable: !0 }) : a[l] = c, a;
    }
    function s(a) {
      if (typeof a != "function")
        throw new TypeError("a propType is required");
      for (var l = arguments.length, c = new Array(l > 1 ? l - 1 : 0), u = 1; u < l; u++)
        c[u - 1] = arguments[u];
      if (c.length < 1)
        throw new TypeError("at least one prop that is mutually exclusive with this propType is required");
      var d = c.join(", or "), f = c.reduce(function(m, g) {
        return o(o({}, m), {}, i({}, g, !0));
      }, {}), h = function(m, g) {
        return m + (f[g] ? 1 : 0);
      }, p = function(m, g, y) {
        var v = Object.keys(m).filter(function(x) {
          return m[x] != null;
        }).reduce(h, 0);
        if (v > 1)
          return new Error("A ".concat(y, " cannot have more than one of these props: ").concat(d));
        for (var b = arguments.length, _ = new Array(b > 3 ? b - 3 : 0), w = 3; w < b; w++)
          _[w - 3] = arguments[w];
        return a.apply(void 0, [m, g, y].concat(_));
      };
      return p.isRequired = function(m, g, y) {
        var v = Object.keys(m).filter(function(x) {
          return x === g || m[x] != null;
        }).reduce(h, 0);
        if (v > 1)
          return new Error("A ".concat(y, " cannot have more than one of these props: ").concat(d));
        for (var b = arguments.length, _ = new Array(b > 3 ? b - 3 : 0), w = 3; w < b; w++)
          _[w - 3] = arguments[w];
        return a.apply(void 0, [m, g, y].concat(_));
      }, (0, e.default)(p, "mutuallyExclusiveProps:".concat(d), c);
    }
  }(HY)), HY;
}
var WY = {}, GY;
function jrt() {
  return GY || (GY = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = o;
    var e = /* @__PURE__ */ Tr(), n = r(tn());
    function r(i) {
      return i && i.__esModule ? i : { default: i };
    }
    function o() {
      for (var i = arguments.length, s = new Array(i), a = 0; a < i; a++)
        s[a] = arguments[a];
      if (s.length < 1)
        throw new TypeError("at least one prop that is mutually exclusive is required");
      if (!s.every(function(u) {
        return typeof u == "string";
      }))
        throw new TypeError("all exclusive true props must be strings");
      var l = s.join(", or "), c = function(u, d, f) {
        var h = function(v, b) {
          return v + (u[b] ? 1 : 0);
        }, p = s.reduce(h, 0);
        if (p > 1)
          return new Error("A ".concat(f, " cannot have more than one of these boolean props be true: ").concat(l));
        for (var m = arguments.length, g = new Array(m > 3 ? m - 3 : 0), y = 3; y < m; y++)
          g[y - 3] = arguments[y];
        return e.bool.apply(void 0, [u, d, f].concat(g));
      };
      return c.isRequired = function(u, d, f) {
        var h = function(v, b) {
          return v + (u[b] ? 1 : 0);
        }, p = s.reduce(h, 0);
        if (p > 1)
          return new Error("A ".concat(f, " cannot have more than one of these boolean props be true: ").concat(l));
        for (var m = arguments.length, g = new Array(m > 3 ? m - 3 : 0), y = 3; y < m; y++)
          g[y - 3] = arguments[y];
        return e.bool.isRequired.apply(e.bool, [u, d, f].concat(g));
      }, (0, n.default)(c, "mutuallyExclusiveTrueProps: ".concat(l), s);
    }
  }(WY)), WY;
}
var YY = {}, KY;
function Lrt() {
  return KY || (KY = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = i;
    var e = o(xe), n = /* @__PURE__ */ Tr(), r = o(tn());
    function o(s) {
      return s && s.__esModule ? s : { default: s };
    }
    function i(s) {
      var a = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : n.node;
      if (typeof s != "number" || isNaN(s) || s < 0)
        throw new TypeError("a non-negative number is required");
      var l = function(c, u, d) {
        if (u !== "children")
          return new TypeError("".concat(d, " is using the nChildren validator on a non-children prop"));
        var f = c.children, h = e.default.Children.count(f);
        if (h !== s)
          return new RangeError("".concat(d, " expects to receive ").concat(s, " children, but received ").concat(h, " children."));
        for (var p = arguments.length, m = new Array(p > 3 ? p - 3 : 0), g = 3; g < p; g++)
          m[g - 3] = arguments[g];
        return a.apply(void 0, [c, u, d].concat(m));
      };
      return l.isRequired = l, (0, r.default)(l, "nChildren:".concat(s), s);
    }
  }(YY)), YY;
}
var XY = {}, QY;
function Frt() {
  return QY || (QY = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var e = /* @__PURE__ */ Tr(), n = r(tn());
    function r(a) {
      return a && a.__esModule ? a : { default: a };
    }
    var o = /^[-+]?(?:[1-9][0-9]*(?:\.[0-9]+)?|0|0\.[0-9]+)$/, i = function(a, l, c) {
      if (a[l] == null)
        return null;
      for (var u = arguments.length, d = new Array(u > 3 ? u - 3 : 0), f = 3; f < u; f++)
        d[f - 3] = arguments[f];
      var h = e.string.apply(void 0, [a, l, c].concat(d));
      if (h)
        return h;
      var p = a[l], m = o.test(p);
      return m ? null : new TypeError("".concat(c, ': prop "').concat(l, '" (value "').concat(p, `") must be a numeric string:
    - starting with an optional + or -
    - that does not have a leading zero
    - with an optional decimal part (that contains only one decimal point, if present)
    - that otherwise only contains digits (0-9)
    - not +-NaN, or +-Infinity
  `));
    };
    i.isRequired = function(a, l, c) {
      if (a[l] == null)
        return new TypeError("".concat(c, ": ").concat(l, " is required"));
      for (var u = arguments.length, d = new Array(u > 3 ? u - 3 : 0), f = 3; f < u; f++)
        d[f - 3] = arguments[f];
      return i.apply(void 0, [a, l, c].concat(d));
    };
    var s = function() {
      return (0, n.default)(i, "numericString");
    };
    t.default = s;
  }(XY)), XY;
}
var ZY = {}, JY;
function Brt() {
  return JY || (JY = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = r;
    var e = n(tn());
    function n(o) {
      return o && o.__esModule ? o : { default: o };
    }
    function r(o) {
      var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
      if (typeof o != "function")
        throw new TypeError("`fn` must be a function");
      if (typeof i != "string")
        throw new TypeError("`message`, if provided, must be a string");
      function s(l, c, u) {
        var d = o(l[c]);
        return d ? null : new TypeError("`".concat(u, "` requires that `").concat(c, "` pass a predicate function").concat(i ? ": ".concat(i) : "", "."));
      }
      function a(l, c) {
        if (l[c] == null)
          return null;
        for (var u = arguments.length, d = new Array(u > 2 ? u - 2 : 0), f = 2; f < u; f++)
          d[f - 2] = arguments[f];
        return s.apply(void 0, [l, c].concat(d));
      }
      return a.isRequired = s, (0, e.default)(a, "predicate", o);
    }
  }(ZY)), ZY;
}
var eK = {}, tK;
function zrt() {
  return tK || (tK = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = c;
    var e = s(Qd()), n = s(k4()), r = s(R4()), o = s(jge()), i = s(tn());
    function s(u) {
      return u && u.__esModule ? u : { default: u };
    }
    var a = Number.MAX_SAFE_INTEGER || /* istanbul ignore next */
    Math.pow(2, 53) - 1;
    function l(u) {
      return (0, o.default)(u) && Math.abs(u) < a;
    }
    function c(u, d) {
      if (!l(u) || !l(d))
        throw new RangeError('"range" requires two integers: '.concat(u, " and ").concat(d, " given"));
      if (u === d)
        throw new RangeError("min and max must not be the same");
      return (0, i.default)((0, e.default)([(0, r.default)(), (0, n.default)({
        gte: u,
        lt: d
      })], "range"), "range", {
        min: u,
        max: d
      });
    }
  }(eK)), eK;
}
var nK = {}, rK;
function Vge() {
  return rK || (rK = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var e = xe, n = o(O4()), r = o(tn());
    function o(d) {
      return d && d.__esModule ? d : { default: d };
    }
    var i = Object.prototype.isPrototypeOf;
    function s(d) {
      if (!(0, n.default)(d))
        return !1;
      var f = Object.keys(d);
      return f.length === 1 && f[0] === "current";
    }
    function a(d) {
      return typeof d == "function" && !i.call(e.Component, d) && (!e.PureComponent || !i.call(e.PureComponent, d));
    }
    function l(d, f, h) {
      var p = d[f];
      return a(p) || s(p) ? null : new TypeError("".concat(f, " in ").concat(h, " must be a ref"));
    }
    function c(d, f, h) {
      var p = d[f];
      if (p == null)
        return null;
      for (var m = arguments.length, g = new Array(m > 3 ? m - 3 : 0), y = 3; y < m; y++)
        g[y - 3] = arguments[y];
      return l.apply(void 0, [d, f, h].concat(g));
    }
    c.isRequired = l;
    var u = function() {
      return (0, r.default)(c, "ref");
    };
    t.default = u;
  }(nK)), nK;
}
var oK = {}, iK;
function qrt() {
  return iK || (iK = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = o;
    var e = r(w4()), n = r(tn());
    function r(i) {
      return i && i.__esModule ? i : { default: i };
    }
    function o(i, s) {
      var a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
      function l(c, u, d) {
        if (c[i]) {
          var f = c[u];
          if ((0, e.default)(f, a) || typeof f > "u")
            return new TypeError("".concat(d, ": when ").concat(i, " is true, prop “").concat(u, "” must be present."));
        }
        for (var h = arguments.length, p = new Array(h > 3 ? h - 3 : 0), m = 3; m < h; m++)
          p[m - 3] = arguments[m];
        return s.apply(void 0, [c, u, d].concat(p));
      }
      return l.isRequired = function(c, u, d) {
        var f = c[u];
        if ((0, e.default)(f, a))
          return new TypeError("".concat(d, ": prop “").concat(u, "” must be present."));
        for (var h = arguments.length, p = new Array(h > 3 ? h - 3 : 0), m = 3; m < h; m++)
          p[m - 3] = arguments[m];
        return s.isRequired.apply(s, [c, u, d].concat(p));
      }, (0, n.default)(l, "requiredBy “".concat(i, "”"), [i, a]);
    }
  }(oK)), oK;
}
var sK = {}, aK;
function Urt() {
  return aK || (aK = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var e = n(tn());
    function n(i) {
      return i && i.__esModule ? i : { default: i };
    }
    function r(i) {
      function s(a, l, c, u) {
        if (a[l] == null)
          return null;
        if (i && typeof i == "function") {
          for (var d = arguments.length, f = new Array(d > 4 ? d - 4 : 0), h = 4; h < d; h++)
            f[h - 4] = arguments[h];
          return new TypeError(i.apply(void 0, [a, l, c, u].concat(f)));
        }
        return new TypeError("The ".concat(l, " ").concat(u, " on ").concat(c, " is not allowed."));
      }
      return s.isRequired = s, s;
    }
    var o = function() {
      var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
      return (0, e.default)(r(i), "restrictedProp");
    };
    t.default = o;
  }(sK)), sK;
}
var lK = {}, cK;
function Hrt() {
  return cK || (cK = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = o;
    var e = /* @__PURE__ */ Tr(), n = r(tn());
    function r(i) {
      return i && i.__esModule ? i : { default: i };
    }
    function o(i) {
      if (typeof i != "string" || i.length === 0)
        throw new TypeError("a non-empty string is required");
      var s = function(a, l, c) {
        var u = a[l];
        if (u == null)
          return null;
        for (var d = arguments.length, f = new Array(d > 3 ? d - 3 : 0), h = 3; h < d; h++)
          f[h - 3] = arguments[h];
        var p = e.string.apply(void 0, [a, l, c].concat(f));
        return p || (!u.endsWith(i) || u.length <= i.length ? new TypeError("".concat(c, ": ").concat(l, ' does not end with "').concat(i, '"')) : null);
      };
      return s.isRequired = function() {
        var a = e.string.isRequired.apply(e.string, arguments);
        return a || s.apply(void 0, arguments);
      }, (0, n.default)(s, "stringEndsWith: ".concat(i));
    }
  }(lK)), lK;
}
var uK = {}, dK;
function Vrt() {
  return dK || (dK = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = o;
    var e = /* @__PURE__ */ Tr(), n = r(tn());
    function r(i) {
      return i && i.__esModule ? i : { default: i };
    }
    function o(i) {
      if (typeof i != "string" || i.length === 0)
        throw new TypeError("a non-empty string is required");
      var s = function(a, l, c) {
        var u = a[l];
        if (u == null)
          return null;
        for (var d = arguments.length, f = new Array(d > 3 ? d - 3 : 0), h = 3; h < d; h++)
          f[h - 3] = arguments[h];
        var p = e.string.apply(void 0, [a, l, c].concat(f));
        return p || (!u.startsWith(i) || u.length <= i.length ? new TypeError("".concat(c, ": ").concat(l, ' does not start with "').concat(i, '"')) : null);
      };
      return s.isRequired = function() {
        var a = e.string.isRequired.apply(e.string, arguments);
        return a || s.apply(void 0, arguments);
      }, (0, n.default)(s, "stringStartsWith: ".concat(i));
    }
  }(uK)), uK;
}
var fK = {}, hK;
function Wge() {
  return hK || (hK = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var e = /* @__PURE__ */ Tr(), n = r(tn());
    function r(u) {
      return u && u.__esModule ? u : { default: u };
    }
    function o(u) {
      return new Set(u).size;
    }
    function i(u) {
      var d = [];
      return u.forEach(function(f) {
        d.indexOf(f) === -1 && d.push(f);
      }), d.length;
    }
    var s = typeof Set == "function" ? o : (
      /* istanbul ignore next */
      i
    );
    function a(u, d, f) {
      for (var h = arguments.length, p = new Array(h > 3 ? h - 3 : 0), m = 3; m < h; m++)
        p[m - 3] = arguments[m];
      var g = e.array.isRequired.apply(e.array, [u, d, f].concat(p));
      if (g != null)
        return g;
      var y = u[d], v = s(y);
      return v !== y.length ? new RangeError("".concat(f, ": values must be unique. ").concat(y.length - v, " duplicate values found.")) : null;
    }
    function l(u, d) {
      var f = u[d];
      if (f == null)
        return null;
      for (var h = arguments.length, p = new Array(h > 2 ? h - 2 : 0), m = 2; m < h; m++)
        p[m - 2] = arguments[m];
      return a.apply(void 0, [u, d].concat(p));
    }
    l.isRequired = a;
    var c = function() {
      return (0, n.default)(l, "uniqueArray");
    };
    t.default = c;
  }(fK)), fK;
}
var pK = {}, mK;
function Wrt() {
  return mK || (mK = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = c;
    var e = /* @__PURE__ */ Tr(), n = o(Qd()), r = o(Wge());
    function o(u) {
      return u && u.__esModule ? u : { default: u };
    }
    function i(u, d) {
      var f = Object.keys(u);
      if (Object.getOwnPropertySymbols) {
        var h = Object.getOwnPropertySymbols(u);
        d && (h = h.filter(function(p) {
          return Object.getOwnPropertyDescriptor(u, p).enumerable;
        })), f.push.apply(f, h);
      }
      return f;
    }
    function s(u) {
      for (var d = 1; d < arguments.length; d++) {
        var f = arguments[d] != null ? arguments[d] : {};
        d % 2 ? i(Object(f), !0).forEach(function(h) {
          a(u, h, f[h]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(u, Object.getOwnPropertyDescriptors(f)) : i(Object(f)).forEach(function(h) {
          Object.defineProperty(u, h, Object.getOwnPropertyDescriptor(f, h));
        });
      }
      return u;
    }
    function a(u, d, f) {
      return d in u ? Object.defineProperty(u, d, { value: f, enumerable: !0, configurable: !0, writable: !0 }) : u[d] = f, u;
    }
    var l = (0, r.default)();
    function c(u) {
      if (typeof u != "function")
        throw new TypeError("type must be a validator function");
      for (var d = null, f = "uniqueArrayOfType", h = arguments.length, p = new Array(h > 1 ? h - 1 : 0), m = 1; m < h; m++)
        p[m - 1] = arguments[m];
      if (p.length === 1)
        if (typeof p[0] == "function")
          d = p[0];
        else if (typeof p[0] == "string")
          f = p[0];
        else
          throw new TypeError("single input must either be string or function");
      else if (p.length === 2)
        if (typeof p[0] == "function" && typeof p[1] == "string")
          d = p[0], f = p[1];
        else
          throw new TypeError("multiple inputs must be in [function, string] order");
      else if (p.length > 2)
        throw new TypeError("only [], [name], [mapper], and [mapper, name] are valid inputs");
      function g(_, w) {
        var x = _[w];
        if (x == null)
          return null;
        for (var E = x.map(d), S = arguments.length, C = new Array(S > 2 ? S - 2 : 0), R = 2; R < S; R++)
          C[R - 2] = arguments[R];
        return l.apply(void 0, [s(s({}, _), {}, a({}, w, E)), w].concat(C));
      }
      g.isRequired = function(_, w) {
        for (var x = _[w], E = arguments.length, S = new Array(E > 2 ? E - 2 : 0), C = 2; C < E; C++)
          S[C - 2] = arguments[C];
        return x == null ? e.array.isRequired.apply(e.array, [_, w].concat(S)) : g.apply(void 0, [_, w].concat(S));
      };
      var y = (0, e.arrayOf)(u), v = d ? g : l, b = (0, n.default)([y, v], f);
      return b.isRequired = (0, n.default)([v.isRequired, y.isRequired], "".concat(f, ".isRequired")), b;
    }
  }(pK)), pK;
}
var qA, gK;
function Grt() {
  if (gK) return qA;
  gK = 1;
  var t = $(/* @__PURE__ */ Knt()), e = $(Qd()), n = $(k4()), r = $(Znt()), o = $(Jnt()), i = $(ert()), s = $(Trt()), a = $(Rrt()), l = $(Prt()), c = $($rt()), u = $(Mrt()), d = $(Drt()), f = $(Hge()), h = $(R4()), p = $(Irt()), m = $(Nrt()), g = $(jrt()), y = $(Lrt()), v = $(Fge()), b = $(Lge()), _ = $(Frt()), w = $(zge()), x = $(Uge()), E = $(Brt()), S = $(zrt()), C = $(Vge()), R = $(qrt()), P = $(Urt()), N = $(qge()), A = $(C4()), O = $(Hrt()), k = $(Vrt()), T = $(Wge()), I = $(Wrt()), j = $(Cge()), z = $(P4());
  function $(D) {
    return D && D.__esModule ? D : { default: D };
  }
  return qA = {
    and: e.default,
    between: n.default,
    booleanSome: r.default,
    childrenHavePropXorChildren: o.default,
    childrenOf: i.default,
    childrenOfType: s.default,
    childrenSequenceOf: a.default,
    componentWithName: l.default,
    disallowedIf: c.default,
    elementType: u.default,
    empty: d.default,
    explicitNull: f.default,
    forbidExtraProps: t.default,
    integer: h.default,
    keysOf: p.default,
    mutuallyExclusiveProps: m.default,
    mutuallyExclusiveTrueProps: g.default,
    nChildren: y.default,
    nonNegativeInteger: v.default,
    nonNegativeNumber: b.default,
    numericString: _.default,
    object: w.default,
    or: x.default,
    predicate: E.default,
    range: S.default,
    ref: C.default,
    requiredBy: R.default,
    restrictedProp: P.default,
    sequenceOf: N.default,
    shape: A.default,
    stringEndsWith: O.default,
    stringStartsWith: k.default,
    uniqueArray: T.default,
    uniqueArrayOf: I.default,
    valuesOf: j.default,
    withShape: z.default
  }, qA;
}
var yK, vK;
function Yrt() {
  return vK || (vK = 1, yK = process.env.NODE_ENV === "production" ? $nt() : Grt()), yK;
}
var bK = {}, _K = { exports: {} }, wK;
function Krt() {
  return wK || (wK = 1, function(t) {
    var e = x4().default;
    function n(o) {
      if (typeof WeakMap != "function") return null;
      var i = /* @__PURE__ */ new WeakMap(), s = /* @__PURE__ */ new WeakMap();
      return (n = function(a) {
        return a ? s : i;
      })(o);
    }
    function r(o, i) {
      if (!i && o && o.__esModule) return o;
      if (o === null || e(o) != "object" && typeof o != "function") return {
        default: o
      };
      var s = n(i);
      if (s && s.has(o)) return s.get(o);
      var a = {
        __proto__: null
      }, l = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var c in o) if (c !== "default" && {}.hasOwnProperty.call(o, c)) {
        var u = l ? Object.getOwnPropertyDescriptor(o, c) : null;
        u && (u.get || u.set) ? Object.defineProperty(a, c, u) : a[c] = o[c];
      }
      return a.default = o, s && s.set(o, a), a;
    }
    t.exports = r, t.exports.__esModule = !0, t.exports.default = t.exports;
  }(_K)), _K.exports;
}
var xK = { exports: {} }, EK = { exports: {} }, SK;
function Xrt() {
  return SK || (SK = 1, function(t) {
    function e(n, r) {
      if (n == null) return {};
      var o = {};
      for (var i in n) if ({}.hasOwnProperty.call(n, i)) {
        if (r.includes(i)) continue;
        o[i] = n[i];
      }
      return o;
    }
    t.exports = e, t.exports.__esModule = !0, t.exports.default = t.exports;
  }(EK)), EK.exports;
}
var OK;
function Qrt() {
  return OK || (OK = 1, function(t) {
    var e = Xrt();
    function n(r, o) {
      if (r == null) return {};
      var i, s, a = e(r, o);
      if (Object.getOwnPropertySymbols) {
        var l = Object.getOwnPropertySymbols(r);
        for (s = 0; s < l.length; s++) i = l[s], o.includes(i) || {}.propertyIsEnumerable.call(r, i) && (a[i] = r[i]);
      }
      return a;
    }
    t.exports = n, t.exports.__esModule = !0, t.exports.default = t.exports;
  }(xK)), xK.exports;
}
var CK = {}, kK;
function Zrt() {
  return kK || (kK = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = void 0;
    var e = {}, n = function() {
      return e;
    }, r = n;
    t.default = r;
  }(CK)), CK;
}
var AK = {}, TK;
function Jrt() {
  return TK || (TK = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.perfStart = e, t.perfEnd = n, t.default = r;
    function e(o) {
      typeof performance < "u" && performance.mark !== void 0 && typeof performance.clearMarks == "function" && o && (performance.clearMarks(o), performance.mark(o));
    }
    function n(o, i, s) {
      typeof performance < "u" && performance.mark !== void 0 && typeof performance.clearMarks == "function" && (performance.clearMarks(i), performance.mark(i), performance.measure(s, o, i), performance.clearMarks(s));
    }
    function r(o) {
      var i = "react-with-styles.".concat(o, ".start"), s = "react-with-styles.".concat(o, ".end"), a = "👩‍🎨 [".concat(o, "]");
      return function(l) {
        return function() {
          process.env.NODE_ENV !== "production" && e(i);
          var c = l.apply(void 0, arguments);
          return process.env.NODE_ENV !== "production" && n(i, s, a), c;
        };
      };
    }
  }(AK)), AK;
}
var RK = {}, PK = {}, UA, $K;
function eot() {
  if ($K) return UA;
  $K = 1;
  var t = function(f) {
    return e(f) && !n(f);
  };
  function e(f) {
    return !!f && typeof f == "object";
  }
  function n(f) {
    var h = Object.prototype.toString.call(f);
    return h === "[object RegExp]" || h === "[object Date]" || i(f);
  }
  var r = typeof Symbol == "function" && Symbol.for, o = r ? Symbol.for("react.element") : 60103;
  function i(f) {
    return f.$$typeof === o;
  }
  function s(f) {
    return Array.isArray(f) ? [] : {};
  }
  function a(f, h) {
    var p = h && h.clone === !0;
    return p && t(f) ? u(s(f), f, h) : f;
  }
  function l(f, h, p) {
    var m = f.slice();
    return h.forEach(function(g, y) {
      typeof m[y] > "u" ? m[y] = a(g, p) : t(g) ? m[y] = u(f[y], g, p) : f.indexOf(g) === -1 && m.push(a(g, p));
    }), m;
  }
  function c(f, h, p) {
    var m = {};
    return t(f) && Object.keys(f).forEach(function(g) {
      m[g] = a(f[g], p);
    }), Object.keys(h).forEach(function(g) {
      !t(h[g]) || !f[g] ? m[g] = a(h[g], p) : m[g] = u(f[g], h[g], p);
    }), m;
  }
  function u(f, h, p) {
    var m = Array.isArray(h), g = Array.isArray(f), y = p || { arrayMerge: l }, v = m === g;
    if (v)
      if (m) {
        var b = y.arrayMerge || l;
        return b(f, h, p);
      } else
        return c(f, h, p);
    else return a(h, p);
  }
  u.all = function(f, h) {
    if (!Array.isArray(f) || f.length < 2)
      throw new Error("first argument should be an array with at least two elements");
    return f.reduce(function(p, m) {
      return u(p, m, h);
    });
  };
  var d = u;
  return UA = d, UA;
}
var _1 = {}, MK;
function Gge() {
  return MK || (MK = 1, Object.defineProperty(_1, "__esModule", {
    value: !0
  }), _1.CHANNEL = "__direction__", _1.DIRECTIONS = {
    LTR: "ltr",
    RTL: "rtl"
  }), _1;
}
var DK = {}, IK;
function tot() {
  return IK || (IK = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var e = /* @__PURE__ */ Tr(), n = r(e);
    function r(o) {
      return o && o.__esModule ? o : { default: o };
    }
    t.default = n.default.shape({
      getState: n.default.func,
      setState: n.default.func,
      subscribe: n.default.func
    });
  }(DK)), DK;
}
var NK = {}, HA, jK;
function Yge() {
  if (jK) return HA;
  jK = 1;
  var t = /* @__PURE__ */ Mp(), e = $i(), n = e("Object.prototype.propertyIsEnumerable"), r = e("Array.prototype.push");
  return HA = function(o) {
    var i = t(o), s = [];
    for (var a in i)
      n(i, a) && r(s, i[a]);
    return s;
  }, HA;
}
var VA, LK;
function Kge() {
  if (LK) return VA;
  LK = 1;
  var t = Yge();
  return VA = function() {
    return typeof Object.values == "function" ? Object.values : t;
  }, VA;
}
var WA, FK;
function not() {
  if (FK) return WA;
  FK = 1;
  var t = Kge(), e = to();
  return WA = function() {
    var n = t();
    return e(Object, { values: n }, {
      values: function() {
        return Object.values !== n;
      }
    }), n;
  }, WA;
}
var GA, BK;
function rot() {
  if (BK) return GA;
  BK = 1;
  var t = to(), e = Wl(), n = Yge(), r = Kge(), o = not(), i = e(r(), Object);
  return t(i, {
    getPolyfill: r,
    implementation: n,
    shim: o
  }), GA = i, GA;
}
var zK;
function oot() {
  return zK || (zK = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var e = rot(), n = s(e), r = /* @__PURE__ */ Tr(), o = s(r), i = Gge();
    function s(a) {
      return a && a.__esModule ? a : { default: a };
    }
    t.default = o.default.oneOf((0, n.default)(i.DIRECTIONS));
  }(NK)), NK;
}
var qK;
function iot() {
  return qK || (qK = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.withDirectionPropTypes = t.DIRECTIONS = void 0;
    var e = Object.assign || function(S) {
      for (var C = 1; C < arguments.length; C++) {
        var R = arguments[C];
        for (var P in R)
          Object.prototype.hasOwnProperty.call(R, P) && (S[P] = R[P]);
      }
      return S;
    }, n = /* @__PURE__ */ function() {
      function S(C, R) {
        for (var P = 0; P < R.length; P++) {
          var N = R[P];
          N.enumerable = N.enumerable || !1, N.configurable = !0, "value" in N && (N.writable = !0), Object.defineProperty(C, N.key, N);
        }
      }
      return function(C, R, P) {
        return R && S(C.prototype, R), P && S(C, P), C;
      };
    }();
    t.default = E;
    var r = xe, o = g(r), i = V5(), s = g(i), a = eot(), l = g(a), c = Tv(), u = g(c), d = Gge(), f = tot(), h = g(f), p = oot(), m = g(p);
    function g(S) {
      return S && S.__esModule ? S : { default: S };
    }
    function y(S, C) {
      if (!(S instanceof C))
        throw new TypeError("Cannot call a class as a function");
    }
    function v(S, C) {
      if (!S)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return C && (typeof C == "object" || typeof C == "function") ? C : S;
    }
    function b(S, C) {
      if (typeof C != "function" && C !== null)
        throw new TypeError("Super expression must either be null or a function, not " + typeof C);
      S.prototype = Object.create(C && C.prototype, { constructor: { value: S, enumerable: !1, writable: !0, configurable: !0 } }), C && (Object.setPrototypeOf ? Object.setPrototypeOf(S, C) : S.__proto__ = C);
    }
    function _(S, C, R) {
      return C in S ? Object.defineProperty(S, C, { value: R, enumerable: !0, configurable: !0, writable: !0 }) : S[C] = R, S;
    }
    var w = _({}, d.CHANNEL, h.default);
    t.DIRECTIONS = d.DIRECTIONS;
    var x = d.DIRECTIONS.LTR;
    t.withDirectionPropTypes = {
      direction: m.default.isRequired
    };
    function E(S) {
      var C = function(P) {
        b(N, P);
        function N(A, O) {
          y(this, N);
          var k = v(this, (N.__proto__ || Object.getPrototypeOf(N)).call(this, A, O));
          return k.state = {
            direction: O[d.CHANNEL] ? O[d.CHANNEL].getState() : x
          }, k;
        }
        return n(N, [{
          key: "componentDidMount",
          value: /* @__PURE__ */ function() {
            function A() {
              var O = this;
              this.context[d.CHANNEL] && (this.channelUnsubscribe = this.context[d.CHANNEL].subscribe(function(k) {
                O.setState({ direction: k });
              }));
            }
            return A;
          }()
        }, {
          key: "componentWillUnmount",
          value: /* @__PURE__ */ function() {
            function A() {
              this.channelUnsubscribe && this.channelUnsubscribe();
            }
            return A;
          }()
        }, {
          key: "render",
          value: /* @__PURE__ */ function() {
            function A() {
              var O = this.state.direction;
              return o.default.createElement(S, e({}, this.props, {
                direction: O
              }));
            }
            return A;
          }()
        }]), N;
      }(o.default.Component), R = (0, u.default)(S) || "Component";
      return C.WrappedComponent = S, C.contextTypes = w, C.displayName = "withDirection(" + String(R) + ")", S.propTypes && (C.propTypes = (0, l.default)({}, S.propTypes), delete C.propTypes.direction), S.defaultProps && (C.defaultProps = (0, l.default)({}, S.defaultProps)), (0, s.default)(C, S);
    }
  }(PK)), PK;
}
var UK;
function sot() {
  return UK || (UK = 1, function(t) {
    var e = m4();
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "DIRECTIONS", {
      enumerable: !0,
      get: function() {
        return o.DIRECTIONS;
      }
    }), t.default = void 0;
    var n = xe, r = e(/* @__PURE__ */ Tr()), o = iot();
    function i(l) {
      return n.createContext ? /* @__PURE__ */ (0, n.createContext)(l) : {
        Provider: function() {
          throw new ReferenceError("WithStylesContext requires React 16.3 or later");
        },
        Consumer: function() {
          throw new ReferenceError("WithStylesContext requires React 16.3 or later");
        }
      };
    }
    var s = i({
      stylesInterface: null,
      stylesTheme: null,
      direction: null
    });
    s.Provider.propTypes = {
      stylesInterface: r.default.object,
      // eslint-disable-line react/forbid-prop-types
      stylesTheme: r.default.object,
      // eslint-disable-line react/forbid-prop-types
      direction: r.default.oneOf([o.DIRECTIONS.LTR, o.DIRECTIONS.RTL])
    };
    var a = s;
    t.default = a;
  }(RK)), RK;
}
var HK = {}, VK;
function aot() {
  return VK || (VK = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t._getInterface = g, t._getTheme = d, t.default = void 0;
    var e, n, r = "react-with-styles.resolve.start", o = "react-with-styles.resolve.end", i = "👩‍🎨 [resolve]";
    function s(v) {
      n = v;
    }
    function a(v) {
      e = v;
    }
    function l(v, b) {
      var _ = b(v(n));
      return function() {
        return _;
      };
    }
    function c(v) {
      return l(v, e.createLTR || e.create);
    }
    function u(v) {
      return l(v, e.createRTL || e.create);
    }
    function d() {
      return n;
    }
    function f() {
      process.env.NODE_ENV !== "production" && typeof performance < "u" && performance.mark !== void 0 && typeof performance.clearMarks == "function" && (performance.clearMarks(r), performance.mark(r));
      for (var v = arguments.length, b = new Array(v), _ = 0; _ < v; _++)
        b[_] = arguments[_];
      var w = e.resolve(b);
      return process.env.NODE_ENV !== "production" && typeof performance < "u" && performance.mark !== void 0 && typeof performance.clearMarks == "function" && (performance.clearMarks(o), performance.mark(o), performance.measure(i, r, o), performance.clearMarks(i)), w;
    }
    function h() {
      for (var v = arguments.length, b = new Array(v), _ = 0; _ < v; _++)
        b[_] = arguments[_];
      return e.resolveLTR ? e.resolveLTR(b) : f(b);
    }
    function p() {
      for (var v = arguments.length, b = new Array(v), _ = 0; _ < v; _++)
        b[_] = arguments[_];
      return e.resolveRTL ? e.resolveRTL(b) : f(b);
    }
    function m() {
      e.flush && e.flush();
    }
    function g() {
      return e;
    }
    var y = {
      registerTheme: s,
      registerInterface: a,
      create: c,
      createLTR: c,
      createRTL: u,
      get: d,
      resolve: h,
      resolveLTR: h,
      resolveRTL: p,
      flush: m
    };
    t.default = y;
  }(HK)), HK;
}
var WK = {}, GK;
function lot() {
  return GK || (GK = 1, function(t) {
    var e = m4();
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.default = t.withStylesPropTypes = void 0;
    var n = e(/* @__PURE__ */ Tr()), r = {
      styles: n.default.object.isRequired,
      theme: n.default.object.isRequired,
      css: n.default.func.isRequired
    };
    t.withStylesPropTypes = r;
    var o = r;
    t.default = o;
  }(WK)), WK;
}
var YK;
function cot() {
  return YK || (YK = 1, function(t) {
    var e = Krt(), n = m4();
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), t.withStyles = v, Object.defineProperty(t, "withStylesPropTypes", {
      enumerable: !0,
      get: function() {
        return m.withStylesPropTypes;
      }
    }), t.css = t.default = void 0;
    var r = n(Ent()), o = n(Ant()), i = n(Qrt()), s = n(Ont()), a = n(xe), l = n(V5()), c = n(Tv()), u = n(Vge()), d = n(Zrt()), f = n(Jrt()), h = e(sot()), p = e(aot()), m = lot();
    function g(w, x) {
      var E = Object.keys(w);
      if (Object.getOwnPropertySymbols) {
        var S = Object.getOwnPropertySymbols(w);
        x && (S = S.filter(function(C) {
          return Object.getOwnPropertyDescriptor(w, C).enumerable;
        })), E.push.apply(E, S);
      }
      return E;
    }
    function y(w) {
      for (var x = 1; x < arguments.length; x++) {
        var E = arguments[x] != null ? arguments[x] : {};
        x % 2 ? g(Object(E), !0).forEach(function(S) {
          (0, o.default)(w, S, E[S]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(w, Object.getOwnPropertyDescriptors(E)) : g(Object(E)).forEach(function(S) {
          Object.defineProperty(w, S, Object.getOwnPropertyDescriptor(E, S));
        });
      }
      return w;
    }
    function v() {
      var w = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : d.default, x = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, E = x.stylesPropName, S = E === void 0 ? "styles" : E, C = x.themePropName, R = C === void 0 ? "theme" : C, P = x.cssPropName, N = P === void 0 ? "css" : P, A = x.flushBefore, O = A === void 0 ? !1 : A, k = x.pureComponent, T = k === void 0 ? !1 : k;
      w = w || d.default;
      var I = T ? a.default.PureComponent : a.default.Component, j = typeof WeakMap > "u" ? /* @__PURE__ */ new Map() : /* @__PURE__ */ new WeakMap();
      function z(B) {
        var H = j.get(B), Z = H || w(B) || {};
        return j.set(B, Z), Z;
      }
      var $ = typeof WeakMap > "u" ? /* @__PURE__ */ new Map() : /* @__PURE__ */ new WeakMap();
      function D(B, H, Z) {
        var W = $.get(B);
        if (!W)
          return null;
        var G = W.get(H);
        return G ? G[Z] : null;
      }
      function U(B, H, Z, W) {
        var G = $.get(B);
        G || (G = typeof WeakMap > "u" ? /* @__PURE__ */ new Map() : /* @__PURE__ */ new WeakMap(), $.set(B, G));
        var ee = G.get(H);
        ee || (ee = {
          ltr: {},
          rtl: {}
        }, G.set(H, ee)), ee[Z] = W;
      }
      function q(B, H) {
        var Z = B === h.DIRECTIONS.RTL ? "RTL" : "LTR", W = H["create".concat(Z)] || H.create, G = W;
        return process.env.NODE_ENV !== "production" && (W = (0, f.default)("create")(W)), {
          create: W,
          original: G
        };
      }
      function F(B, H) {
        var Z = B === h.DIRECTIONS.RTL ? "RTL" : "LTR", W = H["resolve".concat(Z)] || H.resolve, G = W;
        return process.env.NODE_ENV !== "production" && (W = (0, f.default)("resolve")(W)), {
          resolve: W,
          original: G
        };
      }
      return function(B) {
        var H = (0, c.default)(B), Z = /* @__PURE__ */ function(G) {
          (0, s.default)(ee, G);
          function ee() {
            return G.apply(this, arguments) || this;
          }
          var Y = ee.prototype;
          return Y.getCurrentInterface = function() {
            return this.context && this.context.stylesInterface || (0, p._getInterface)();
          }, Y.getCurrentTheme = function() {
            return this.context && this.context.stylesTheme || (0, p._getTheme)();
          }, Y.getCurrentDirection = function() {
            return this.context && this.context.direction || h.DIRECTIONS.LTR;
          }, Y.getProps = function() {
            var L = this.getCurrentInterface(), V = this.getCurrentTheme(), K = this.getCurrentDirection(), ne = D(V, ee, K), ce = !ne || !ne.stylesInterface || L && ne.stylesInterface !== L, fe = !ne || ne.theme !== V;
            if (!ce && !fe)
              return ne.props;
            var ve = ce && q(K, L) || ne.create, _e = ce && F(K, L) || ne.resolve, Ee = ve.create, Me = _e.resolve, Le = !ne || !ne.create || ve.original !== ne.create.original, Ce = !ne || !ne.resolve || _e.original !== ne.resolve.original, Je = Ce && function() {
              for (var mt = arguments.length, gt = new Array(mt), Et = 0; Et < mt; Et++)
                gt[Et] = arguments[Et];
              return Me(gt);
            } || ne.props.css, Ie = z(V), nt = (Le || Ie !== ne.stylesFnResult) && Ee(Ie) || ne.props.styles, ct = {
              css: Je,
              styles: nt,
              theme: V
            };
            return U(V, ee, K, {
              stylesInterface: L,
              theme: V,
              create: ve,
              resolve: _e,
              stylesFnResult: Ie,
              props: ct
            }), ct;
          }, Y.flush = function() {
            var L = this.getCurrentInterface();
            L && L.flush && L.flush();
          }, Y.render = function() {
            var L, V = this.getProps(), K = V.theme, ne = V.styles, ce = V.css;
            O && this.flush();
            var fe = this.props, ve = fe.forwardedRef, _e = (0, i.default)(fe, ["forwardedRef"]);
            return /* @__PURE__ */ a.default.createElement(
              B,
              (0, r.default)({
                ref: typeof a.default.forwardRef > "u" ? void 0 : ve
              }, typeof a.default.forwardRef > "u" ? this.props : _e, (L = {}, (0, o.default)(L, R, K), (0, o.default)(L, S, ne), (0, o.default)(L, N, ce), L))
            );
          }, ee;
        }(I);
        typeof a.default.forwardRef < "u" && (Z.propTypes = {
          forwardedRef: (0, u.default)()
        });
        var W = typeof a.default.forwardRef > "u" ? Z : /* @__PURE__ */ a.default.forwardRef(function(G, ee) {
          return /* @__PURE__ */ a.default.createElement(Z, (0, r.default)({}, G, {
            forwardedRef: ee
          }));
        });
        return B.propTypes && (W.propTypes = y({}, B.propTypes), delete W.propTypes[S], delete W.propTypes[R], delete W.propTypes[N]), B.defaultProps && (W.defaultProps = y({}, B.defaultProps)), Z.contextType = h.default, W.WrappedComponent = B, W.displayName = "withStyles(".concat(H, ")"), (0, l.default)(W, B);
      };
    }
    var b = v;
    t.default = b;
    var _ = p.default.resolveLTR;
    t.css = _;
  }(bK)), bK;
}
var bm = { exports: {} }, Ff = { exports: {} }, uot = Ff.exports, KK;
function dot() {
  return KK || (KK = 1, function() {
    var t, e, n, r, o, i;
    typeof performance < "u" && performance !== null && performance.now ? Ff.exports = function() {
      return performance.now();
    } : typeof process < "u" && process !== null && process.hrtime ? (Ff.exports = function() {
      return (t() - o) / 1e6;
    }, e = process.hrtime, t = function() {
      var s;
      return s = e(), s[0] * 1e9 + s[1];
    }, r = t(), i = process.uptime() * 1e9, o = r - i) : Date.now ? (Ff.exports = function() {
      return Date.now() - n;
    }, n = Date.now()) : (Ff.exports = function() {
      return (/* @__PURE__ */ new Date()).getTime() - n;
    }, n = (/* @__PURE__ */ new Date()).getTime());
  }.call(uot)), Ff.exports;
}
var XK;
function fot() {
  if (XK) return bm.exports;
  XK = 1;
  for (var t = dot(), e = typeof window > "u" ? Tf : window, n = ["moz", "webkit"], r = "AnimationFrame", o = e["request" + r], i = e["cancel" + r] || e["cancelRequest" + r], s = 0; !o && s < n.length; s++)
    o = e[n[s] + "Request" + r], i = e[n[s] + "Cancel" + r] || e[n[s] + "CancelRequest" + r];
  if (!o || !i) {
    var a = 0, l = 0, c = [], u = 1e3 / 60;
    o = function(d) {
      if (c.length === 0) {
        var f = t(), h = Math.max(0, u - (f - a));
        a = h + f, setTimeout(function() {
          var p = c.slice(0);
          c.length = 0;
          for (var m = 0; m < p.length; m++)
            if (!p[m].cancelled)
              try {
                p[m].callback(a);
              } catch (g) {
                setTimeout(function() {
                  throw g;
                }, 0);
              }
        }, Math.round(h));
      }
      return c.push({
        handle: ++l,
        callback: d,
        cancelled: !1
      }), l;
    }, i = function(d) {
      for (var f = 0; f < c.length; f++)
        c[f].handle === d && (c[f].cancelled = !0);
    };
  }
  return bm.exports = function(d) {
    return o.call(e, d);
  }, bm.exports.cancel = function() {
    i.apply(e, arguments);
  }, bm.exports.polyfill = function(d) {
    d || (d = e), d.requestAnimationFrame = o, d.cancelAnimationFrame = i;
  }, bm.exports;
}
var ui = /* @__PURE__ */ Tr();
const br = /* @__PURE__ */ bp(ui);
var hot = !!(typeof window < "u" && window.document && window.document.createElement), pot = /* @__PURE__ */ function() {
  function t(e, n) {
    for (var r = 0; r < n.length; r++) {
      var o = n[r];
      o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
    }
  }
  return function(e, n, r) {
    return n && t(e.prototype, n), r && t(e, r), e;
  };
}();
function mot(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function got(t, e) {
  if (!t)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e && (typeof e == "object" || typeof e == "function") ? e : t;
}
function yot(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof e);
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
}
var Xge = function(t) {
  yot(e, t);
  function e() {
    return mot(this, e), got(this, (e.__proto__ || Object.getPrototypeOf(e)).apply(this, arguments));
  }
  return pot(e, [{
    key: "componentWillUnmount",
    value: function() {
      this.defaultNode && document.body.removeChild(this.defaultNode), this.defaultNode = null;
    }
  }, {
    key: "render",
    value: function() {
      return hot ? (!this.props.node && !this.defaultNode && (this.defaultNode = document.createElement("div"), document.body.appendChild(this.defaultNode)), Kc.createPortal(this.props.children, this.props.node || this.defaultNode)) : null;
    }
  }]), e;
}(xe.Component);
Xge.propTypes = {
  children: br.node.isRequired,
  node: br.any
};
var vot = /* @__PURE__ */ function() {
  function t(e, n) {
    for (var r = 0; r < n.length; r++) {
      var o = n[r];
      o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
    }
  }
  return function(e, n, r) {
    return n && t(e.prototype, n), r && t(e, r), e;
  };
}();
function bot(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function _ot(t, e) {
  if (!t)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e && (typeof e == "object" || typeof e == "function") ? e : t;
}
function wot(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof e);
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
}
var Qge = function(t) {
  wot(e, t);
  function e() {
    return bot(this, e), _ot(this, (e.__proto__ || Object.getPrototypeOf(e)).apply(this, arguments));
  }
  return vot(e, [{
    key: "componentDidMount",
    value: function() {
      this.renderPortal();
    }
  }, {
    key: "componentDidUpdate",
    value: function(n) {
      this.renderPortal();
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      Kc.unmountComponentAtNode(this.defaultNode || this.props.node), this.defaultNode && document.body.removeChild(this.defaultNode), this.defaultNode = null, this.portal = null;
    }
  }, {
    key: "renderPortal",
    value: function(n) {
      !this.props.node && !this.defaultNode && (this.defaultNode = document.createElement("div"), document.body.appendChild(this.defaultNode));
      var r = this.props.children;
      typeof this.props.children.type == "function" && (r = xe.cloneElement(this.props.children)), this.portal = Kc.unstable_renderSubtreeIntoContainer(this, r, this.props.node || this.defaultNode);
    }
  }, {
    key: "render",
    value: function() {
      return null;
    }
  }]), e;
}(xe.Component);
Qge.propTypes = {
  children: br.node.isRequired,
  node: br.any
};
var vj = void 0;
Kc.createPortal ? vj = Xge : vj = Qge;
var xot = /* @__PURE__ */ function() {
  function t(e, n) {
    for (var r = 0; r < n.length; r++) {
      var o = n[r];
      o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
    }
  }
  return function(e, n, r) {
    return n && t(e.prototype, n), r && t(e, r), e;
  };
}();
function Eot(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Sot(t, e) {
  if (!t)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e && (typeof e == "object" || typeof e == "function") ? e : t;
}
function Oot(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof e);
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
}
var Cot = {
  ESCAPE: 27
}, Zge = function(t) {
  Oot(e, t);
  function e(n) {
    Eot(this, e);
    var r = Sot(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, n));
    return r.portalNode = null, r.state = { active: !!n.defaultOpen }, r.openPortal = r.openPortal.bind(r), r.closePortal = r.closePortal.bind(r), r.wrapWithPortal = r.wrapWithPortal.bind(r), r.handleOutsideMouseClick = r.handleOutsideMouseClick.bind(r), r.handleKeydown = r.handleKeydown.bind(r), r;
  }
  return xot(e, [{
    key: "componentDidMount",
    value: function() {
      this.props.closeOnEsc && document.addEventListener("keydown", this.handleKeydown), this.props.closeOnOutsideClick && document.addEventListener("click", this.handleOutsideMouseClick);
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.props.closeOnEsc && document.removeEventListener("keydown", this.handleKeydown), this.props.closeOnOutsideClick && document.removeEventListener("click", this.handleOutsideMouseClick);
    }
  }, {
    key: "openPortal",
    value: function(n) {
      this.state.active || (n && n.nativeEvent && n.nativeEvent.stopImmediatePropagation(), this.setState({ active: !0 }, this.props.onOpen));
    }
  }, {
    key: "closePortal",
    value: function() {
      this.state.active && this.setState({ active: !1 }, this.props.onClose);
    }
  }, {
    key: "wrapWithPortal",
    value: function(n) {
      var r = this;
      return this.state.active ? xe.createElement(
        vj,
        {
          node: this.props.node,
          key: "react-portal",
          ref: function(o) {
            return r.portalNode = o;
          }
        },
        n
      ) : null;
    }
  }, {
    key: "handleOutsideMouseClick",
    value: function(n) {
      if (this.state.active) {
        var r = this.portalNode && (this.portalNode.props.node || this.portalNode.defaultNode);
        !r || r.contains(n.target) || n.button && n.button !== 0 || this.closePortal();
      }
    }
  }, {
    key: "handleKeydown",
    value: function(n) {
      n.keyCode === Cot.ESCAPE && this.state.active && this.closePortal();
    }
  }, {
    key: "render",
    value: function() {
      return this.props.children({
        openPortal: this.openPortal,
        closePortal: this.closePortal,
        portal: this.wrapWithPortal,
        isOpen: this.state.active
      });
    }
  }]), e;
}(xe.Component);
Zge.propTypes = {
  children: br.func.isRequired,
  defaultOpen: br.bool,
  node: br.any,
  closeOnEsc: br.bool,
  closeOnOutsideClick: br.bool,
  onOpen: br.func,
  onClose: br.func
};
Zge.defaultProps = {
  onOpen: function() {
  },
  onClose: function() {
  }
};
function kot(t, e) {
  t.prototype = Object.create(e.prototype), t.prototype.constructor = t, wI(t, e);
}
xnt();
Pnt();
Yrt();
cot();
fot();
const Aot = () => /^((?!chrome|android).)*safari/i.test(navigator.userAgent), Jge = (t) => Array.isArray(t) && t.every(
  (e) => typeof e == "object" && !(e instanceof Array)
), Tot = (t) => Array.isArray(t) && t.every(
  (e) => Array.isArray(e)
), Rot = (t) => Array.from(
  t.map((e) => Object.keys(e)).reduce((e, n) => /* @__PURE__ */ new Set([...e, ...n]), [])
), Pot = (t, e) => {
  e = e || Rot(t);
  let n = e, r = e;
  Jge(e) && (n = e.map((i) => i.label), r = e.map((i) => i.key));
  const o = t.map((i) => r.map((s) => $ot(s, i)));
  return [n, ...o];
}, $ot = (t, e) => {
  const n = t.replace(/\[([^\]]+)]/g, ".$1").split(".").reduce(function(r, o, i, s) {
    const a = r[o];
    if (a == null)
      s.splice(1);
    else
      return a;
  }, e);
  return n === void 0 ? t in e ? e[t] : "" : n;
}, Mot = (t) => typeof t > "u" || t === null ? "" : t, e0e = (t, e = ",", n = '"') => t.filter((r) => r).map(
  (r) => r.map((o) => Mot(o)).map((o) => `${n}${o}${n}`).join(e)
).join(`
`), Dot = (t, e, n, r) => e0e(e ? [e, ...t] : t, n, r), Iot = (t, e, n, r) => e0e(Pot(t, e), n, r), Not = (t, e, n, r) => e ? `${e.join(n)}
${t}` : t.replace(/"/g, '""'), t0e = (t, e, n, r) => {
  if (Jge(t)) return Iot(t, e, n, r);
  if (Tot(t)) return Dot(t, e, n, r);
  if (typeof t == "string") return Not(t, e, n);
  throw new TypeError('Data should be a "String", "Array of arrays" OR "Array of objects" ');
}, n0e = (t, e, n, r, o) => {
  const i = t0e(t, n, r, o), s = Aot() ? "application/csv" : "text/csv", a = new Blob([e ? "\uFEFF" : "", i], { type: s }), l = `data:${s};charset=utf-8,${e ? "\uFEFF" : ""}${i}`, c = window.URL || window.webkitURL;
  return typeof c.createObjectURL > "u" ? l : c.createObjectURL(a);
}, r0e = {
  data: ui.oneOfType([ui.string, ui.array, ui.func]).isRequired,
  headers: ui.array,
  target: ui.string,
  separator: ui.string,
  filename: ui.string,
  uFEFF: ui.bool,
  onClick: ui.func,
  asyncOnClick: ui.bool,
  enclosingCharacter: ui.string
}, o0e = {
  separator: ",",
  filename: "generatedBy_react-csv.csv",
  uFEFF: !0,
  asyncOnClick: !1,
  enclosingCharacter: '"'
}, jot = {
  target: "_blank"
};
class QK extends xe.Component {
  constructor(e) {
    super(e), this.state = {};
  }
  buildURI() {
    return n0e(...arguments);
  }
  componentDidMount() {
    const { data: e, headers: n, separator: r, enclosingCharacter: o, uFEFF: i, target: s, specs: a, replace: l } = this.props;
    this.state.page = window.open(
      this.buildURI(e, i, n, r, o),
      s,
      a,
      l
    );
  }
  getWindow() {
    return this.state.page;
  }
  render() {
    return null;
  }
}
ue(QK, "defaultProps", Object.assign(
  o0e,
  jot
)), ue(QK, "propTypes", r0e);
var w1;
w1 = class extends xe.Component {
  constructor(t) {
    super(t), this.buildURI = this.buildURI.bind(this);
  }
  buildURI() {
    return n0e(...arguments);
  }
  /**
   * In IE11 this method will trigger the file download
   */
  handleLegacy(t, e = !1) {
    if (window.navigator.msSaveOrOpenBlob) {
      t.preventDefault();
      const {
        data: n,
        headers: r,
        separator: o,
        filename: i,
        enclosingCharacter: s,
        uFEFF: a
      } = this.props, l = e && typeof n == "function" ? n() : n;
      let c = new Blob([a ? "\uFEFF" : "", t0e(l, r, o, s)]);
      return window.navigator.msSaveBlob(c, i), !1;
    }
  }
  handleAsyncClick(t) {
    const e = (n) => {
      if (n === !1) {
        t.preventDefault();
        return;
      }
      this.handleLegacy(t, !0);
    };
    this.props.onClick(t, e);
  }
  handleSyncClick(t) {
    if (this.props.onClick(t) === !1) {
      t.preventDefault();
      return;
    }
    this.handleLegacy(t);
  }
  handleClick() {
    return (t) => {
      if (typeof this.props.onClick == "function")
        return this.props.asyncOnClick ? this.handleAsyncClick(t) : this.handleSyncClick(t);
      this.handleLegacy(t);
    };
  }
  render() {
    const {
      data: t,
      headers: e,
      separator: n,
      filename: r,
      uFEFF: o,
      children: i,
      onClick: s,
      asyncOnClick: a,
      enclosingCharacter: l,
      ...c
    } = this.props, u = typeof window > "u" ? "" : this.buildURI(t, o, e, n, l);
    return /* @__PURE__ */ M.jsx(
      "a",
      {
        download: r,
        ...c,
        ref: (d) => this.link = d,
        target: "_self",
        href: u,
        onClick: this.handleClick(),
        children: i
      }
    );
  }
}, ue(w1, "defaultProps", o0e), ue(w1, "propTypes", r0e);
function Rr(t) {
  if (typeof t == "string" || typeof t == "number") return "" + t;
  let e = "";
  if (Array.isArray(t))
    for (let n = 0, r; n < t.length; n++)
      (r = Rr(t[n])) !== "" && (e += (e && " ") + r);
  else
    for (let n in t)
      t[n] && (e += (e && " ") + n);
  return e;
}
var Lot = { value: () => {
} };
function tO() {
  for (var t = 0, e = arguments.length, n = {}, r; t < e; ++t) {
    if (!(r = arguments[t] + "") || r in n || /[\s.]/.test(r)) throw new Error("illegal type: " + r);
    n[r] = [];
  }
  return new $w(n);
}
function $w(t) {
  this._ = t;
}
function Fot(t, e) {
  return t.trim().split(/^|\s+/).map(function(n) {
    var r = "", o = n.indexOf(".");
    if (o >= 0 && (r = n.slice(o + 1), n = n.slice(0, o)), n && !e.hasOwnProperty(n)) throw new Error("unknown type: " + n);
    return { type: n, name: r };
  });
}
$w.prototype = tO.prototype = {
  constructor: $w,
  on: function(t, e) {
    var n = this._, r = Fot(t + "", n), o, i = -1, s = r.length;
    if (arguments.length < 2) {
      for (; ++i < s; ) if ((o = (t = r[i]).type) && (o = Bot(n[o], t.name))) return o;
      return;
    }
    if (e != null && typeof e != "function") throw new Error("invalid callback: " + e);
    for (; ++i < s; )
      if (o = (t = r[i]).type) n[o] = ZK(n[o], t.name, e);
      else if (e == null) for (o in n) n[o] = ZK(n[o], t.name, null);
    return this;
  },
  copy: function() {
    var t = {}, e = this._;
    for (var n in e) t[n] = e[n].slice();
    return new $w(t);
  },
  call: function(t, e) {
    if ((o = arguments.length - 2) > 0) for (var n = new Array(o), r = 0, o, i; r < o; ++r) n[r] = arguments[r + 2];
    if (!this._.hasOwnProperty(t)) throw new Error("unknown type: " + t);
    for (i = this._[t], r = 0, o = i.length; r < o; ++r) i[r].value.apply(e, n);
  },
  apply: function(t, e, n) {
    if (!this._.hasOwnProperty(t)) throw new Error("unknown type: " + t);
    for (var r = this._[t], o = 0, i = r.length; o < i; ++o) r[o].value.apply(e, n);
  }
};
function Bot(t, e) {
  for (var n = 0, r = t.length, o; n < r; ++n)
    if ((o = t[n]).name === e)
      return o.value;
}
function ZK(t, e, n) {
  for (var r = 0, o = t.length; r < o; ++r)
    if (t[r].name === e) {
      t[r] = Lot, t = t.slice(0, r).concat(t.slice(r + 1));
      break;
    }
  return n != null && t.push({ name: e, value: n }), t;
}
var bj = "http://www.w3.org/1999/xhtml";
const JK = {
  svg: "http://www.w3.org/2000/svg",
  xhtml: bj,
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace",
  xmlns: "http://www.w3.org/2000/xmlns/"
};
function nO(t) {
  var e = t += "", n = e.indexOf(":");
  return n >= 0 && (e = t.slice(0, n)) !== "xmlns" && (t = t.slice(n + 1)), JK.hasOwnProperty(e) ? { space: JK[e], local: t } : t;
}
function zot(t) {
  return function() {
    var e = this.ownerDocument, n = this.namespaceURI;
    return n === bj && e.documentElement.namespaceURI === bj ? e.createElement(t) : e.createElementNS(n, t);
  };
}
function qot(t) {
  return function() {
    return this.ownerDocument.createElementNS(t.space, t.local);
  };
}
function i0e(t) {
  var e = nO(t);
  return (e.local ? qot : zot)(e);
}
function Uot() {
}
function $4(t) {
  return t == null ? Uot : function() {
    return this.querySelector(t);
  };
}
function Hot(t) {
  typeof t != "function" && (t = $4(t));
  for (var e = this._groups, n = e.length, r = new Array(n), o = 0; o < n; ++o)
    for (var i = e[o], s = i.length, a = r[o] = new Array(s), l, c, u = 0; u < s; ++u)
      (l = i[u]) && (c = t.call(l, l.__data__, u, i)) && ("__data__" in l && (c.__data__ = l.__data__), a[u] = c);
  return new ki(r, this._parents);
}
function Vot(t) {
  return t == null ? [] : Array.isArray(t) ? t : Array.from(t);
}
function Wot() {
  return [];
}
function s0e(t) {
  return t == null ? Wot : function() {
    return this.querySelectorAll(t);
  };
}
function Got(t) {
  return function() {
    return Vot(t.apply(this, arguments));
  };
}
function Yot(t) {
  typeof t == "function" ? t = Got(t) : t = s0e(t);
  for (var e = this._groups, n = e.length, r = [], o = [], i = 0; i < n; ++i)
    for (var s = e[i], a = s.length, l, c = 0; c < a; ++c)
      (l = s[c]) && (r.push(t.call(l, l.__data__, c, s)), o.push(l));
  return new ki(r, o);
}
function a0e(t) {
  return function() {
    return this.matches(t);
  };
}
function l0e(t) {
  return function(e) {
    return e.matches(t);
  };
}
var Kot = Array.prototype.find;
function Xot(t) {
  return function() {
    return Kot.call(this.children, t);
  };
}
function Qot() {
  return this.firstElementChild;
}
function Zot(t) {
  return this.select(t == null ? Qot : Xot(typeof t == "function" ? t : l0e(t)));
}
var Jot = Array.prototype.filter;
function eit() {
  return Array.from(this.children);
}
function tit(t) {
  return function() {
    return Jot.call(this.children, t);
  };
}
function nit(t) {
  return this.selectAll(t == null ? eit : tit(typeof t == "function" ? t : l0e(t)));
}
function rit(t) {
  typeof t != "function" && (t = a0e(t));
  for (var e = this._groups, n = e.length, r = new Array(n), o = 0; o < n; ++o)
    for (var i = e[o], s = i.length, a = r[o] = [], l, c = 0; c < s; ++c)
      (l = i[c]) && t.call(l, l.__data__, c, i) && a.push(l);
  return new ki(r, this._parents);
}
function c0e(t) {
  return new Array(t.length);
}
function oit() {
  return new ki(this._enter || this._groups.map(c0e), this._parents);
}
function dE(t, e) {
  this.ownerDocument = t.ownerDocument, this.namespaceURI = t.namespaceURI, this._next = null, this._parent = t, this.__data__ = e;
}
dE.prototype = {
  constructor: dE,
  appendChild: function(t) {
    return this._parent.insertBefore(t, this._next);
  },
  insertBefore: function(t, e) {
    return this._parent.insertBefore(t, e);
  },
  querySelector: function(t) {
    return this._parent.querySelector(t);
  },
  querySelectorAll: function(t) {
    return this._parent.querySelectorAll(t);
  }
};
function iit(t) {
  return function() {
    return t;
  };
}
function sit(t, e, n, r, o, i) {
  for (var s = 0, a, l = e.length, c = i.length; s < c; ++s)
    (a = e[s]) ? (a.__data__ = i[s], r[s] = a) : n[s] = new dE(t, i[s]);
  for (; s < l; ++s)
    (a = e[s]) && (o[s] = a);
}
function ait(t, e, n, r, o, i, s) {
  var a, l, c = /* @__PURE__ */ new Map(), u = e.length, d = i.length, f = new Array(u), h;
  for (a = 0; a < u; ++a)
    (l = e[a]) && (f[a] = h = s.call(l, l.__data__, a, e) + "", c.has(h) ? o[a] = l : c.set(h, l));
  for (a = 0; a < d; ++a)
    h = s.call(t, i[a], a, i) + "", (l = c.get(h)) ? (r[a] = l, l.__data__ = i[a], c.delete(h)) : n[a] = new dE(t, i[a]);
  for (a = 0; a < u; ++a)
    (l = e[a]) && c.get(f[a]) === l && (o[a] = l);
}
function lit(t) {
  return t.__data__;
}
function cit(t, e) {
  if (!arguments.length) return Array.from(this, lit);
  var n = e ? ait : sit, r = this._parents, o = this._groups;
  typeof t != "function" && (t = iit(t));
  for (var i = o.length, s = new Array(i), a = new Array(i), l = new Array(i), c = 0; c < i; ++c) {
    var u = r[c], d = o[c], f = d.length, h = uit(t.call(u, u && u.__data__, c, r)), p = h.length, m = a[c] = new Array(p), g = s[c] = new Array(p), y = l[c] = new Array(f);
    n(u, d, m, g, y, h, e);
    for (var v = 0, b = 0, _, w; v < p; ++v)
      if (_ = m[v]) {
        for (v >= b && (b = v + 1); !(w = g[b]) && ++b < p; ) ;
        _._next = w || null;
      }
  }
  return s = new ki(s, r), s._enter = a, s._exit = l, s;
}
function uit(t) {
  return typeof t == "object" && "length" in t ? t : Array.from(t);
}
function dit() {
  return new ki(this._exit || this._groups.map(c0e), this._parents);
}
function fit(t, e, n) {
  var r = this.enter(), o = this, i = this.exit();
  return typeof t == "function" ? (r = t(r), r && (r = r.selection())) : r = r.append(t + ""), e != null && (o = e(o), o && (o = o.selection())), n == null ? i.remove() : n(i), r && o ? r.merge(o).order() : o;
}
function hit(t) {
  for (var e = t.selection ? t.selection() : t, n = this._groups, r = e._groups, o = n.length, i = r.length, s = Math.min(o, i), a = new Array(o), l = 0; l < s; ++l)
    for (var c = n[l], u = r[l], d = c.length, f = a[l] = new Array(d), h, p = 0; p < d; ++p)
      (h = c[p] || u[p]) && (f[p] = h);
  for (; l < o; ++l)
    a[l] = n[l];
  return new ki(a, this._parents);
}
function pit() {
  for (var t = this._groups, e = -1, n = t.length; ++e < n; )
    for (var r = t[e], o = r.length - 1, i = r[o], s; --o >= 0; )
      (s = r[o]) && (i && s.compareDocumentPosition(i) ^ 4 && i.parentNode.insertBefore(s, i), i = s);
  return this;
}
function mit(t) {
  t || (t = git);
  function e(d, f) {
    return d && f ? t(d.__data__, f.__data__) : !d - !f;
  }
  for (var n = this._groups, r = n.length, o = new Array(r), i = 0; i < r; ++i) {
    for (var s = n[i], a = s.length, l = o[i] = new Array(a), c, u = 0; u < a; ++u)
      (c = s[u]) && (l[u] = c);
    l.sort(e);
  }
  return new ki(o, this._parents).order();
}
function git(t, e) {
  return t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
}
function yit() {
  var t = arguments[0];
  return arguments[0] = this, t.apply(null, arguments), this;
}
function vit() {
  return Array.from(this);
}
function bit() {
  for (var t = this._groups, e = 0, n = t.length; e < n; ++e)
    for (var r = t[e], o = 0, i = r.length; o < i; ++o) {
      var s = r[o];
      if (s) return s;
    }
  return null;
}
function _it() {
  let t = 0;
  for (const e of this) ++t;
  return t;
}
function wit() {
  return !this.node();
}
function xit(t) {
  for (var e = this._groups, n = 0, r = e.length; n < r; ++n)
    for (var o = e[n], i = 0, s = o.length, a; i < s; ++i)
      (a = o[i]) && t.call(a, a.__data__, i, o);
  return this;
}
function Eit(t) {
  return function() {
    this.removeAttribute(t);
  };
}
function Sit(t) {
  return function() {
    this.removeAttributeNS(t.space, t.local);
  };
}
function Oit(t, e) {
  return function() {
    this.setAttribute(t, e);
  };
}
function Cit(t, e) {
  return function() {
    this.setAttributeNS(t.space, t.local, e);
  };
}
function kit(t, e) {
  return function() {
    var n = e.apply(this, arguments);
    n == null ? this.removeAttribute(t) : this.setAttribute(t, n);
  };
}
function Ait(t, e) {
  return function() {
    var n = e.apply(this, arguments);
    n == null ? this.removeAttributeNS(t.space, t.local) : this.setAttributeNS(t.space, t.local, n);
  };
}
function Tit(t, e) {
  var n = nO(t);
  if (arguments.length < 2) {
    var r = this.node();
    return n.local ? r.getAttributeNS(n.space, n.local) : r.getAttribute(n);
  }
  return this.each((e == null ? n.local ? Sit : Eit : typeof e == "function" ? n.local ? Ait : kit : n.local ? Cit : Oit)(n, e));
}
function u0e(t) {
  return t.ownerDocument && t.ownerDocument.defaultView || t.document && t || t.defaultView;
}
function Rit(t) {
  return function() {
    this.style.removeProperty(t);
  };
}
function Pit(t, e, n) {
  return function() {
    this.style.setProperty(t, e, n);
  };
}
function $it(t, e, n) {
  return function() {
    var r = e.apply(this, arguments);
    r == null ? this.style.removeProperty(t) : this.style.setProperty(t, r, n);
  };
}
function Mit(t, e, n) {
  return arguments.length > 1 ? this.each((e == null ? Rit : typeof e == "function" ? $it : Pit)(t, e, n ?? "")) : ap(this.node(), t);
}
function ap(t, e) {
  return t.style.getPropertyValue(e) || u0e(t).getComputedStyle(t, null).getPropertyValue(e);
}
function Dit(t) {
  return function() {
    delete this[t];
  };
}
function Iit(t, e) {
  return function() {
    this[t] = e;
  };
}
function Nit(t, e) {
  return function() {
    var n = e.apply(this, arguments);
    n == null ? delete this[t] : this[t] = n;
  };
}
function jit(t, e) {
  return arguments.length > 1 ? this.each((e == null ? Dit : typeof e == "function" ? Nit : Iit)(t, e)) : this.node()[t];
}
function d0e(t) {
  return t.trim().split(/^|\s+/);
}
function M4(t) {
  return t.classList || new f0e(t);
}
function f0e(t) {
  this._node = t, this._names = d0e(t.getAttribute("class") || "");
}
f0e.prototype = {
  add: function(t) {
    var e = this._names.indexOf(t);
    e < 0 && (this._names.push(t), this._node.setAttribute("class", this._names.join(" ")));
  },
  remove: function(t) {
    var e = this._names.indexOf(t);
    e >= 0 && (this._names.splice(e, 1), this._node.setAttribute("class", this._names.join(" ")));
  },
  contains: function(t) {
    return this._names.indexOf(t) >= 0;
  }
};
function h0e(t, e) {
  for (var n = M4(t), r = -1, o = e.length; ++r < o; ) n.add(e[r]);
}
function p0e(t, e) {
  for (var n = M4(t), r = -1, o = e.length; ++r < o; ) n.remove(e[r]);
}
function Lit(t) {
  return function() {
    h0e(this, t);
  };
}
function Fit(t) {
  return function() {
    p0e(this, t);
  };
}
function Bit(t, e) {
  return function() {
    (e.apply(this, arguments) ? h0e : p0e)(this, t);
  };
}
function zit(t, e) {
  var n = d0e(t + "");
  if (arguments.length < 2) {
    for (var r = M4(this.node()), o = -1, i = n.length; ++o < i; ) if (!r.contains(n[o])) return !1;
    return !0;
  }
  return this.each((typeof e == "function" ? Bit : e ? Lit : Fit)(n, e));
}
function qit() {
  this.textContent = "";
}
function Uit(t) {
  return function() {
    this.textContent = t;
  };
}
function Hit(t) {
  return function() {
    var e = t.apply(this, arguments);
    this.textContent = e ?? "";
  };
}
function Vit(t) {
  return arguments.length ? this.each(t == null ? qit : (typeof t == "function" ? Hit : Uit)(t)) : this.node().textContent;
}
function Wit() {
  this.innerHTML = "";
}
function Git(t) {
  return function() {
    this.innerHTML = t;
  };
}
function Yit(t) {
  return function() {
    var e = t.apply(this, arguments);
    this.innerHTML = e ?? "";
  };
}
function Kit(t) {
  return arguments.length ? this.each(t == null ? Wit : (typeof t == "function" ? Yit : Git)(t)) : this.node().innerHTML;
}
function Xit() {
  this.nextSibling && this.parentNode.appendChild(this);
}
function Qit() {
  return this.each(Xit);
}
function Zit() {
  this.previousSibling && this.parentNode.insertBefore(this, this.parentNode.firstChild);
}
function Jit() {
  return this.each(Zit);
}
function est(t) {
  var e = typeof t == "function" ? t : i0e(t);
  return this.select(function() {
    return this.appendChild(e.apply(this, arguments));
  });
}
function tst() {
  return null;
}
function nst(t, e) {
  var n = typeof t == "function" ? t : i0e(t), r = e == null ? tst : typeof e == "function" ? e : $4(e);
  return this.select(function() {
    return this.insertBefore(n.apply(this, arguments), r.apply(this, arguments) || null);
  });
}
function rst() {
  var t = this.parentNode;
  t && t.removeChild(this);
}
function ost() {
  return this.each(rst);
}
function ist() {
  var t = this.cloneNode(!1), e = this.parentNode;
  return e ? e.insertBefore(t, this.nextSibling) : t;
}
function sst() {
  var t = this.cloneNode(!0), e = this.parentNode;
  return e ? e.insertBefore(t, this.nextSibling) : t;
}
function ast(t) {
  return this.select(t ? sst : ist);
}
function lst(t) {
  return arguments.length ? this.property("__data__", t) : this.node().__data__;
}
function cst(t) {
  return function(e) {
    t.call(this, e, this.__data__);
  };
}
function ust(t) {
  return t.trim().split(/^|\s+/).map(function(e) {
    var n = "", r = e.indexOf(".");
    return r >= 0 && (n = e.slice(r + 1), e = e.slice(0, r)), { type: e, name: n };
  });
}
function dst(t) {
  return function() {
    var e = this.__on;
    if (e) {
      for (var n = 0, r = -1, o = e.length, i; n < o; ++n)
        i = e[n], (!t.type || i.type === t.type) && i.name === t.name ? this.removeEventListener(i.type, i.listener, i.options) : e[++r] = i;
      ++r ? e.length = r : delete this.__on;
    }
  };
}
function fst(t, e, n) {
  return function() {
    var r = this.__on, o, i = cst(e);
    if (r) {
      for (var s = 0, a = r.length; s < a; ++s)
        if ((o = r[s]).type === t.type && o.name === t.name) {
          this.removeEventListener(o.type, o.listener, o.options), this.addEventListener(o.type, o.listener = i, o.options = n), o.value = e;
          return;
        }
    }
    this.addEventListener(t.type, i, n), o = { type: t.type, name: t.name, value: e, listener: i, options: n }, r ? r.push(o) : this.__on = [o];
  };
}
function hst(t, e, n) {
  var r = ust(t + ""), o, i = r.length, s;
  if (arguments.length < 2) {
    var a = this.node().__on;
    if (a) {
      for (var l = 0, c = a.length, u; l < c; ++l)
        for (o = 0, u = a[l]; o < i; ++o)
          if ((s = r[o]).type === u.type && s.name === u.name)
            return u.value;
    }
    return;
  }
  for (a = e ? fst : dst, o = 0; o < i; ++o) this.each(a(r[o], e, n));
  return this;
}
function m0e(t, e, n) {
  var r = u0e(t), o = r.CustomEvent;
  typeof o == "function" ? o = new o(e, n) : (o = r.document.createEvent("Event"), n ? (o.initEvent(e, n.bubbles, n.cancelable), o.detail = n.detail) : o.initEvent(e, !1, !1)), t.dispatchEvent(o);
}
function pst(t, e) {
  return function() {
    return m0e(this, t, e);
  };
}
function mst(t, e) {
  return function() {
    return m0e(this, t, e.apply(this, arguments));
  };
}
function gst(t, e) {
  return this.each((typeof e == "function" ? mst : pst)(t, e));
}
function* yst() {
  for (var t = this._groups, e = 0, n = t.length; e < n; ++e)
    for (var r = t[e], o = 0, i = r.length, s; o < i; ++o)
      (s = r[o]) && (yield s);
}
var g0e = [null];
function ki(t, e) {
  this._groups = t, this._parents = e;
}
function Rv() {
  return new ki([[document.documentElement]], g0e);
}
function vst() {
  return this;
}
ki.prototype = Rv.prototype = {
  constructor: ki,
  select: Hot,
  selectAll: Yot,
  selectChild: Zot,
  selectChildren: nit,
  filter: rit,
  data: cit,
  enter: oit,
  exit: dit,
  join: fit,
  merge: hit,
  selection: vst,
  order: pit,
  sort: mit,
  call: yit,
  nodes: vit,
  node: bit,
  size: _it,
  empty: wit,
  each: xit,
  attr: Tit,
  style: Mit,
  property: jit,
  classed: zit,
  text: Vit,
  html: Kit,
  raise: Qit,
  lower: Jit,
  append: est,
  insert: nst,
  remove: ost,
  clone: ast,
  datum: lst,
  on: hst,
  dispatch: gst,
  [Symbol.iterator]: yst
};
function vi(t) {
  return typeof t == "string" ? new ki([[document.querySelector(t)]], [document.documentElement]) : new ki([[t]], g0e);
}
function bst(t) {
  let e;
  for (; e = t.sourceEvent; ) t = e;
  return t;
}
function vs(t, e) {
  if (t = bst(t), e === void 0 && (e = t.currentTarget), e) {
    var n = e.ownerSVGElement || e;
    if (n.createSVGPoint) {
      var r = n.createSVGPoint();
      return r.x = t.clientX, r.y = t.clientY, r = r.matrixTransform(e.getScreenCTM().inverse()), [r.x, r.y];
    }
    if (e.getBoundingClientRect) {
      var o = e.getBoundingClientRect();
      return [t.clientX - o.left - e.clientLeft, t.clientY - o.top - e.clientTop];
    }
  }
  return [t.pageX, t.pageY];
}
const _st = { passive: !1 }, Sy = { capture: !0, passive: !1 };
function YA(t) {
  t.stopImmediatePropagation();
}
function Ch(t) {
  t.preventDefault(), t.stopImmediatePropagation();
}
function y0e(t) {
  var e = t.document.documentElement, n = vi(t).on("dragstart.drag", Ch, Sy);
  "onselectstart" in e ? n.on("selectstart.drag", Ch, Sy) : (e.__noselect = e.style.MozUserSelect, e.style.MozUserSelect = "none");
}
function v0e(t, e) {
  var n = t.document.documentElement, r = vi(t).on("dragstart.drag", null);
  e && (r.on("click.drag", Ch, Sy), setTimeout(function() {
    r.on("click.drag", null);
  }, 0)), "onselectstart" in n ? r.on("selectstart.drag", null) : (n.style.MozUserSelect = n.__noselect, delete n.__noselect);
}
const x1 = (t) => () => t;
function _j(t, {
  sourceEvent: e,
  subject: n,
  target: r,
  identifier: o,
  active: i,
  x: s,
  y: a,
  dx: l,
  dy: c,
  dispatch: u
}) {
  Object.defineProperties(this, {
    type: { value: t, enumerable: !0, configurable: !0 },
    sourceEvent: { value: e, enumerable: !0, configurable: !0 },
    subject: { value: n, enumerable: !0, configurable: !0 },
    target: { value: r, enumerable: !0, configurable: !0 },
    identifier: { value: o, enumerable: !0, configurable: !0 },
    active: { value: i, enumerable: !0, configurable: !0 },
    x: { value: s, enumerable: !0, configurable: !0 },
    y: { value: a, enumerable: !0, configurable: !0 },
    dx: { value: l, enumerable: !0, configurable: !0 },
    dy: { value: c, enumerable: !0, configurable: !0 },
    _: { value: u }
  });
}
_j.prototype.on = function() {
  var t = this._.on.apply(this._, arguments);
  return t === this._ ? this : t;
};
function wst(t) {
  return !t.ctrlKey && !t.button;
}
function xst() {
  return this.parentNode;
}
function Est(t, e) {
  return e ?? { x: t.x, y: t.y };
}
function Sst() {
  return navigator.maxTouchPoints || "ontouchstart" in this;
}
function b0e() {
  var t = wst, e = xst, n = Est, r = Sst, o = {}, i = tO("start", "drag", "end"), s = 0, a, l, c, u, d = 0;
  function f(_) {
    _.on("mousedown.drag", h).filter(r).on("touchstart.drag", g).on("touchmove.drag", y, _st).on("touchend.drag touchcancel.drag", v).style("touch-action", "none").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
  }
  function h(_, w) {
    if (!(u || !t.call(this, _, w))) {
      var x = b(this, e.call(this, _, w), _, w, "mouse");
      x && (vi(_.view).on("mousemove.drag", p, Sy).on("mouseup.drag", m, Sy), y0e(_.view), YA(_), c = !1, a = _.clientX, l = _.clientY, x("start", _));
    }
  }
  function p(_) {
    if (Ch(_), !c) {
      var w = _.clientX - a, x = _.clientY - l;
      c = w * w + x * x > d;
    }
    o.mouse("drag", _);
  }
  function m(_) {
    vi(_.view).on("mousemove.drag mouseup.drag", null), v0e(_.view, c), Ch(_), o.mouse("end", _);
  }
  function g(_, w) {
    if (t.call(this, _, w)) {
      var x = _.changedTouches, E = e.call(this, _, w), S = x.length, C, R;
      for (C = 0; C < S; ++C)
        (R = b(this, E, _, w, x[C].identifier, x[C])) && (YA(_), R("start", _, x[C]));
    }
  }
  function y(_) {
    var w = _.changedTouches, x = w.length, E, S;
    for (E = 0; E < x; ++E)
      (S = o[w[E].identifier]) && (Ch(_), S("drag", _, w[E]));
  }
  function v(_) {
    var w = _.changedTouches, x = w.length, E, S;
    for (u && clearTimeout(u), u = setTimeout(function() {
      u = null;
    }, 500), E = 0; E < x; ++E)
      (S = o[w[E].identifier]) && (YA(_), S("end", _, w[E]));
  }
  function b(_, w, x, E, S, C) {
    var R = i.copy(), P = vs(C || x, w), N, A, O;
    if ((O = n.call(_, new _j("beforestart", {
      sourceEvent: x,
      target: f,
      identifier: S,
      active: s,
      x: P[0],
      y: P[1],
      dx: 0,
      dy: 0,
      dispatch: R
    }), E)) != null)
      return N = O.x - P[0] || 0, A = O.y - P[1] || 0, function k(T, I, j) {
        var z = P, $;
        switch (T) {
          case "start":
            o[S] = k, $ = s++;
            break;
          case "end":
            delete o[S], --s;
          // falls through
          case "drag":
            P = vs(j || I, w), $ = s;
            break;
        }
        R.call(
          T,
          _,
          new _j(T, {
            sourceEvent: I,
            subject: O,
            target: f,
            identifier: S,
            active: $,
            x: P[0] + N,
            y: P[1] + A,
            dx: P[0] - z[0],
            dy: P[1] - z[1],
            dispatch: R
          }),
          E
        );
      };
  }
  return f.filter = function(_) {
    return arguments.length ? (t = typeof _ == "function" ? _ : x1(!!_), f) : t;
  }, f.container = function(_) {
    return arguments.length ? (e = typeof _ == "function" ? _ : x1(_), f) : e;
  }, f.subject = function(_) {
    return arguments.length ? (n = typeof _ == "function" ? _ : x1(_), f) : n;
  }, f.touchable = function(_) {
    return arguments.length ? (r = typeof _ == "function" ? _ : x1(!!_), f) : r;
  }, f.on = function() {
    var _ = i.on.apply(i, arguments);
    return _ === i ? f : _;
  }, f.clickDistance = function(_) {
    return arguments.length ? (d = (_ = +_) * _, f) : Math.sqrt(d);
  }, f;
}
function D4(t, e, n) {
  t.prototype = e.prototype = n, n.constructor = t;
}
function _0e(t, e) {
  var n = Object.create(t.prototype);
  for (var r in e) n[r] = e[r];
  return n;
}
function Pv() {
}
var Oy = 0.7, fE = 1 / Oy, kh = "\\s*([+-]?\\d+)\\s*", Cy = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", wa = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", Ost = /^#([0-9a-f]{3,8})$/, Cst = new RegExp(`^rgb\\(${kh},${kh},${kh}\\)$`), kst = new RegExp(`^rgb\\(${wa},${wa},${wa}\\)$`), Ast = new RegExp(`^rgba\\(${kh},${kh},${kh},${Cy}\\)$`), Tst = new RegExp(`^rgba\\(${wa},${wa},${wa},${Cy}\\)$`), Rst = new RegExp(`^hsl\\(${Cy},${wa},${wa}\\)$`), Pst = new RegExp(`^hsla\\(${Cy},${wa},${wa},${Cy}\\)$`), eX = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
D4(Pv, ky, {
  copy(t) {
    return Object.assign(new this.constructor(), this, t);
  },
  displayable() {
    return this.rgb().displayable();
  },
  hex: tX,
  // Deprecated! Use color.formatHex.
  formatHex: tX,
  formatHex8: $st,
  formatHsl: Mst,
  formatRgb: nX,
  toString: nX
});
function tX() {
  return this.rgb().formatHex();
}
function $st() {
  return this.rgb().formatHex8();
}
function Mst() {
  return w0e(this).formatHsl();
}
function nX() {
  return this.rgb().formatRgb();
}
function ky(t) {
  var e, n;
  return t = (t + "").trim().toLowerCase(), (e = Ost.exec(t)) ? (n = e[1].length, e = parseInt(e[1], 16), n === 6 ? rX(e) : n === 3 ? new Go(e >> 8 & 15 | e >> 4 & 240, e >> 4 & 15 | e & 240, (e & 15) << 4 | e & 15, 1) : n === 8 ? E1(e >> 24 & 255, e >> 16 & 255, e >> 8 & 255, (e & 255) / 255) : n === 4 ? E1(e >> 12 & 15 | e >> 8 & 240, e >> 8 & 15 | e >> 4 & 240, e >> 4 & 15 | e & 240, ((e & 15) << 4 | e & 15) / 255) : null) : (e = Cst.exec(t)) ? new Go(e[1], e[2], e[3], 1) : (e = kst.exec(t)) ? new Go(e[1] * 255 / 100, e[2] * 255 / 100, e[3] * 255 / 100, 1) : (e = Ast.exec(t)) ? E1(e[1], e[2], e[3], e[4]) : (e = Tst.exec(t)) ? E1(e[1] * 255 / 100, e[2] * 255 / 100, e[3] * 255 / 100, e[4]) : (e = Rst.exec(t)) ? sX(e[1], e[2] / 100, e[3] / 100, 1) : (e = Pst.exec(t)) ? sX(e[1], e[2] / 100, e[3] / 100, e[4]) : eX.hasOwnProperty(t) ? rX(eX[t]) : t === "transparent" ? new Go(NaN, NaN, NaN, 0) : null;
}
function rX(t) {
  return new Go(t >> 16 & 255, t >> 8 & 255, t & 255, 1);
}
function E1(t, e, n, r) {
  return r <= 0 && (t = e = n = NaN), new Go(t, e, n, r);
}
function Dst(t) {
  return t instanceof Pv || (t = ky(t)), t ? (t = t.rgb(), new Go(t.r, t.g, t.b, t.opacity)) : new Go();
}
function wj(t, e, n, r) {
  return arguments.length === 1 ? Dst(t) : new Go(t, e, n, r ?? 1);
}
function Go(t, e, n, r) {
  this.r = +t, this.g = +e, this.b = +n, this.opacity = +r;
}
D4(Go, wj, _0e(Pv, {
  brighter(t) {
    return t = t == null ? fE : Math.pow(fE, t), new Go(this.r * t, this.g * t, this.b * t, this.opacity);
  },
  darker(t) {
    return t = t == null ? Oy : Math.pow(Oy, t), new Go(this.r * t, this.g * t, this.b * t, this.opacity);
  },
  rgb() {
    return this;
  },
  clamp() {
    return new Go(xd(this.r), xd(this.g), xd(this.b), hE(this.opacity));
  },
  displayable() {
    return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
  },
  hex: oX,
  // Deprecated! Use color.formatHex.
  formatHex: oX,
  formatHex8: Ist,
  formatRgb: iX,
  toString: iX
}));
function oX() {
  return `#${cd(this.r)}${cd(this.g)}${cd(this.b)}`;
}
function Ist() {
  return `#${cd(this.r)}${cd(this.g)}${cd(this.b)}${cd((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function iX() {
  const t = hE(this.opacity);
  return `${t === 1 ? "rgb(" : "rgba("}${xd(this.r)}, ${xd(this.g)}, ${xd(this.b)}${t === 1 ? ")" : `, ${t})`}`;
}
function hE(t) {
  return isNaN(t) ? 1 : Math.max(0, Math.min(1, t));
}
function xd(t) {
  return Math.max(0, Math.min(255, Math.round(t) || 0));
}
function cd(t) {
  return t = xd(t), (t < 16 ? "0" : "") + t.toString(16);
}
function sX(t, e, n, r) {
  return r <= 0 ? t = e = n = NaN : n <= 0 || n >= 1 ? t = e = NaN : e <= 0 && (t = NaN), new _s(t, e, n, r);
}
function w0e(t) {
  if (t instanceof _s) return new _s(t.h, t.s, t.l, t.opacity);
  if (t instanceof Pv || (t = ky(t)), !t) return new _s();
  if (t instanceof _s) return t;
  t = t.rgb();
  var e = t.r / 255, n = t.g / 255, r = t.b / 255, o = Math.min(e, n, r), i = Math.max(e, n, r), s = NaN, a = i - o, l = (i + o) / 2;
  return a ? (e === i ? s = (n - r) / a + (n < r) * 6 : n === i ? s = (r - e) / a + 2 : s = (e - n) / a + 4, a /= l < 0.5 ? i + o : 2 - i - o, s *= 60) : a = l > 0 && l < 1 ? 0 : s, new _s(s, a, l, t.opacity);
}
function Nst(t, e, n, r) {
  return arguments.length === 1 ? w0e(t) : new _s(t, e, n, r ?? 1);
}
function _s(t, e, n, r) {
  this.h = +t, this.s = +e, this.l = +n, this.opacity = +r;
}
D4(_s, Nst, _0e(Pv, {
  brighter(t) {
    return t = t == null ? fE : Math.pow(fE, t), new _s(this.h, this.s, this.l * t, this.opacity);
  },
  darker(t) {
    return t = t == null ? Oy : Math.pow(Oy, t), new _s(this.h, this.s, this.l * t, this.opacity);
  },
  rgb() {
    var t = this.h % 360 + (this.h < 0) * 360, e = isNaN(t) || isNaN(this.s) ? 0 : this.s, n = this.l, r = n + (n < 0.5 ? n : 1 - n) * e, o = 2 * n - r;
    return new Go(
      KA(t >= 240 ? t - 240 : t + 120, o, r),
      KA(t, o, r),
      KA(t < 120 ? t + 240 : t - 120, o, r),
      this.opacity
    );
  },
  clamp() {
    return new _s(aX(this.h), S1(this.s), S1(this.l), hE(this.opacity));
  },
  displayable() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  },
  formatHsl() {
    const t = hE(this.opacity);
    return `${t === 1 ? "hsl(" : "hsla("}${aX(this.h)}, ${S1(this.s) * 100}%, ${S1(this.l) * 100}%${t === 1 ? ")" : `, ${t})`}`;
  }
}));
function aX(t) {
  return t = (t || 0) % 360, t < 0 ? t + 360 : t;
}
function S1(t) {
  return Math.max(0, Math.min(1, t || 0));
}
function KA(t, e, n) {
  return (t < 60 ? e + (n - e) * t / 60 : t < 180 ? n : t < 240 ? e + (n - e) * (240 - t) / 60 : e) * 255;
}
const x0e = (t) => () => t;
function jst(t, e) {
  return function(n) {
    return t + n * e;
  };
}
function Lst(t, e, n) {
  return t = Math.pow(t, n), e = Math.pow(e, n) - t, n = 1 / n, function(r) {
    return Math.pow(t + r * e, n);
  };
}
function Fst(t) {
  return (t = +t) == 1 ? E0e : function(e, n) {
    return n - e ? Lst(e, n, t) : x0e(isNaN(e) ? n : e);
  };
}
function E0e(t, e) {
  var n = e - t;
  return n ? jst(t, n) : x0e(isNaN(t) ? e : t);
}
const lX = function t(e) {
  var n = Fst(e);
  function r(o, i) {
    var s = n((o = wj(o)).r, (i = wj(i)).r), a = n(o.g, i.g), l = n(o.b, i.b), c = E0e(o.opacity, i.opacity);
    return function(u) {
      return o.r = s(u), o.g = a(u), o.b = l(u), o.opacity = c(u), o + "";
    };
  }
  return r.gamma = t, r;
}(1);
function xc(t, e) {
  return t = +t, e = +e, function(n) {
    return t * (1 - n) + e * n;
  };
}
var xj = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, XA = new RegExp(xj.source, "g");
function Bst(t) {
  return function() {
    return t;
  };
}
function zst(t) {
  return function(e) {
    return t(e) + "";
  };
}
function qst(t, e) {
  var n = xj.lastIndex = XA.lastIndex = 0, r, o, i, s = -1, a = [], l = [];
  for (t = t + "", e = e + ""; (r = xj.exec(t)) && (o = XA.exec(e)); )
    (i = o.index) > n && (i = e.slice(n, i), a[s] ? a[s] += i : a[++s] = i), (r = r[0]) === (o = o[0]) ? a[s] ? a[s] += o : a[++s] = o : (a[++s] = null, l.push({ i: s, x: xc(r, o) })), n = XA.lastIndex;
  return n < e.length && (i = e.slice(n), a[s] ? a[s] += i : a[++s] = i), a.length < 2 ? l[0] ? zst(l[0].x) : Bst(e) : (e = l.length, function(c) {
    for (var u = 0, d; u < e; ++u) a[(d = l[u]).i] = d.x(c);
    return a.join("");
  });
}
var cX = 180 / Math.PI, S0e = {
  translateX: 0,
  translateY: 0,
  rotate: 0,
  skewX: 0,
  scaleX: 1,
  scaleY: 1
};
function O0e(t, e, n, r, o, i) {
  var s, a, l;
  return (s = Math.sqrt(t * t + e * e)) && (t /= s, e /= s), (l = t * n + e * r) && (n -= t * l, r -= e * l), (a = Math.sqrt(n * n + r * r)) && (n /= a, r /= a, l /= a), t * r < e * n && (t = -t, e = -e, l = -l, s = -s), {
    translateX: o,
    translateY: i,
    rotate: Math.atan2(e, t) * cX,
    skewX: Math.atan(l) * cX,
    scaleX: s,
    scaleY: a
  };
}
var O1;
function Ust(t) {
  const e = new (typeof DOMMatrix == "function" ? DOMMatrix : WebKitCSSMatrix)(t + "");
  return e.isIdentity ? S0e : O0e(e.a, e.b, e.c, e.d, e.e, e.f);
}
function Hst(t) {
  return t == null || (O1 || (O1 = document.createElementNS("http://www.w3.org/2000/svg", "g")), O1.setAttribute("transform", t), !(t = O1.transform.baseVal.consolidate())) ? S0e : (t = t.matrix, O0e(t.a, t.b, t.c, t.d, t.e, t.f));
}
function C0e(t, e, n, r) {
  function o(c) {
    return c.length ? c.pop() + " " : "";
  }
  function i(c, u, d, f, h, p) {
    if (c !== d || u !== f) {
      var m = h.push("translate(", null, e, null, n);
      p.push({ i: m - 4, x: xc(c, d) }, { i: m - 2, x: xc(u, f) });
    } else (d || f) && h.push("translate(" + d + e + f + n);
  }
  function s(c, u, d, f) {
    c !== u ? (c - u > 180 ? u += 360 : u - c > 180 && (c += 360), f.push({ i: d.push(o(d) + "rotate(", null, r) - 2, x: xc(c, u) })) : u && d.push(o(d) + "rotate(" + u + r);
  }
  function a(c, u, d, f) {
    c !== u ? f.push({ i: d.push(o(d) + "skewX(", null, r) - 2, x: xc(c, u) }) : u && d.push(o(d) + "skewX(" + u + r);
  }
  function l(c, u, d, f, h, p) {
    if (c !== d || u !== f) {
      var m = h.push(o(h) + "scale(", null, ",", null, ")");
      p.push({ i: m - 4, x: xc(c, d) }, { i: m - 2, x: xc(u, f) });
    } else (d !== 1 || f !== 1) && h.push(o(h) + "scale(" + d + "," + f + ")");
  }
  return function(c, u) {
    var d = [], f = [];
    return c = t(c), u = t(u), i(c.translateX, c.translateY, u.translateX, u.translateY, d, f), s(c.rotate, u.rotate, d, f), a(c.skewX, u.skewX, d, f), l(c.scaleX, c.scaleY, u.scaleX, u.scaleY, d, f), c = u = null, function(h) {
      for (var p = -1, m = f.length, g; ++p < m; ) d[(g = f[p]).i] = g.x(h);
      return d.join("");
    };
  };
}
var Vst = C0e(Ust, "px, ", "px)", "deg)"), Wst = C0e(Hst, ", ", ")", ")"), Gst = 1e-12;
function uX(t) {
  return ((t = Math.exp(t)) + 1 / t) / 2;
}
function Yst(t) {
  return ((t = Math.exp(t)) - 1 / t) / 2;
}
function Kst(t) {
  return ((t = Math.exp(2 * t)) - 1) / (t + 1);
}
const Xst = function t(e, n, r) {
  function o(i, s) {
    var a = i[0], l = i[1], c = i[2], u = s[0], d = s[1], f = s[2], h = u - a, p = d - l, m = h * h + p * p, g, y;
    if (m < Gst)
      y = Math.log(f / c) / e, g = function(E) {
        return [
          a + E * h,
          l + E * p,
          c * Math.exp(e * E * y)
        ];
      };
    else {
      var v = Math.sqrt(m), b = (f * f - c * c + r * m) / (2 * c * n * v), _ = (f * f - c * c - r * m) / (2 * f * n * v), w = Math.log(Math.sqrt(b * b + 1) - b), x = Math.log(Math.sqrt(_ * _ + 1) - _);
      y = (x - w) / e, g = function(E) {
        var S = E * y, C = uX(w), R = c / (n * v) * (C * Kst(e * S + w) - Yst(w));
        return [
          a + R * h,
          l + R * p,
          c * C / uX(e * S + w)
        ];
      };
    }
    return g.duration = y * 1e3 * e / Math.SQRT2, g;
  }
  return o.rho = function(i) {
    var s = Math.max(1e-3, +i), a = s * s, l = a * a;
    return t(s, a, l);
  }, o;
}(Math.SQRT2, 2, 4);
var lp = 0, Rg = 0, _m = 0, k0e = 1e3, pE, Pg, mE = 0, Fd = 0, rO = 0, Ay = typeof performance == "object" && performance.now ? performance : Date, A0e = typeof window == "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(t) {
  setTimeout(t, 17);
};
function I4() {
  return Fd || (A0e(Qst), Fd = Ay.now() + rO);
}
function Qst() {
  Fd = 0;
}
function gE() {
  this._call = this._time = this._next = null;
}
gE.prototype = T0e.prototype = {
  constructor: gE,
  restart: function(t, e, n) {
    if (typeof t != "function") throw new TypeError("callback is not a function");
    n = (n == null ? I4() : +n) + (e == null ? 0 : +e), !this._next && Pg !== this && (Pg ? Pg._next = this : pE = this, Pg = this), this._call = t, this._time = n, Ej();
  },
  stop: function() {
    this._call && (this._call = null, this._time = 1 / 0, Ej());
  }
};
function T0e(t, e, n) {
  var r = new gE();
  return r.restart(t, e, n), r;
}
function Zst() {
  I4(), ++lp;
  for (var t = pE, e; t; )
    (e = Fd - t._time) >= 0 && t._call.call(void 0, e), t = t._next;
  --lp;
}
function dX() {
  Fd = (mE = Ay.now()) + rO, lp = Rg = 0;
  try {
    Zst();
  } finally {
    lp = 0, eat(), Fd = 0;
  }
}
function Jst() {
  var t = Ay.now(), e = t - mE;
  e > k0e && (rO -= e, mE = t);
}
function eat() {
  for (var t, e = pE, n, r = 1 / 0; e; )
    e._call ? (r > e._time && (r = e._time), t = e, e = e._next) : (n = e._next, e._next = null, e = t ? t._next = n : pE = n);
  Pg = t, Ej(r);
}
function Ej(t) {
  if (!lp) {
    Rg && (Rg = clearTimeout(Rg));
    var e = t - Fd;
    e > 24 ? (t < 1 / 0 && (Rg = setTimeout(dX, t - Ay.now() - rO)), _m && (_m = clearInterval(_m))) : (_m || (mE = Ay.now(), _m = setInterval(Jst, k0e)), lp = 1, A0e(dX));
  }
}
function fX(t, e, n) {
  var r = new gE();
  return e = e == null ? 0 : +e, r.restart((o) => {
    r.stop(), t(o + e);
  }, e, n), r;
}
var tat = tO("start", "end", "cancel", "interrupt"), nat = [], R0e = 0, hX = 1, Sj = 2, Mw = 3, pX = 4, Oj = 5, Dw = 6;
function oO(t, e, n, r, o, i) {
  var s = t.__transition;
  if (!s) t.__transition = {};
  else if (n in s) return;
  rat(t, n, {
    name: e,
    index: r,
    // For context during callback.
    group: o,
    // For context during callback.
    on: tat,
    tween: nat,
    time: i.time,
    delay: i.delay,
    duration: i.duration,
    ease: i.ease,
    timer: null,
    state: R0e
  });
}
function N4(t, e) {
  var n = Ns(t, e);
  if (n.state > R0e) throw new Error("too late; already scheduled");
  return n;
}
function Ia(t, e) {
  var n = Ns(t, e);
  if (n.state > Mw) throw new Error("too late; already running");
  return n;
}
function Ns(t, e) {
  var n = t.__transition;
  if (!n || !(n = n[e])) throw new Error("transition not found");
  return n;
}
function rat(t, e, n) {
  var r = t.__transition, o;
  r[e] = n, n.timer = T0e(i, 0, n.time);
  function i(c) {
    n.state = hX, n.timer.restart(s, n.delay, n.time), n.delay <= c && s(c - n.delay);
  }
  function s(c) {
    var u, d, f, h;
    if (n.state !== hX) return l();
    for (u in r)
      if (h = r[u], h.name === n.name) {
        if (h.state === Mw) return fX(s);
        h.state === pX ? (h.state = Dw, h.timer.stop(), h.on.call("interrupt", t, t.__data__, h.index, h.group), delete r[u]) : +u < e && (h.state = Dw, h.timer.stop(), h.on.call("cancel", t, t.__data__, h.index, h.group), delete r[u]);
      }
    if (fX(function() {
      n.state === Mw && (n.state = pX, n.timer.restart(a, n.delay, n.time), a(c));
    }), n.state = Sj, n.on.call("start", t, t.__data__, n.index, n.group), n.state === Sj) {
      for (n.state = Mw, o = new Array(f = n.tween.length), u = 0, d = -1; u < f; ++u)
        (h = n.tween[u].value.call(t, t.__data__, n.index, n.group)) && (o[++d] = h);
      o.length = d + 1;
    }
  }
  function a(c) {
    for (var u = c < n.duration ? n.ease.call(null, c / n.duration) : (n.timer.restart(l), n.state = Oj, 1), d = -1, f = o.length; ++d < f; )
      o[d].call(t, u);
    n.state === Oj && (n.on.call("end", t, t.__data__, n.index, n.group), l());
  }
  function l() {
    n.state = Dw, n.timer.stop(), delete r[e];
    for (var c in r) return;
    delete t.__transition;
  }
}
function Iw(t, e) {
  var n = t.__transition, r, o, i = !0, s;
  if (n) {
    e = e == null ? null : e + "";
    for (s in n) {
      if ((r = n[s]).name !== e) {
        i = !1;
        continue;
      }
      o = r.state > Sj && r.state < Oj, r.state = Dw, r.timer.stop(), r.on.call(o ? "interrupt" : "cancel", t, t.__data__, r.index, r.group), delete n[s];
    }
    i && delete t.__transition;
  }
}
function oat(t) {
  return this.each(function() {
    Iw(this, t);
  });
}
function iat(t, e) {
  var n, r;
  return function() {
    var o = Ia(this, t), i = o.tween;
    if (i !== n) {
      r = n = i;
      for (var s = 0, a = r.length; s < a; ++s)
        if (r[s].name === e) {
          r = r.slice(), r.splice(s, 1);
          break;
        }
    }
    o.tween = r;
  };
}
function sat(t, e, n) {
  var r, o;
  if (typeof n != "function") throw new Error();
  return function() {
    var i = Ia(this, t), s = i.tween;
    if (s !== r) {
      o = (r = s).slice();
      for (var a = { name: e, value: n }, l = 0, c = o.length; l < c; ++l)
        if (o[l].name === e) {
          o[l] = a;
          break;
        }
      l === c && o.push(a);
    }
    i.tween = o;
  };
}
function aat(t, e) {
  var n = this._id;
  if (t += "", arguments.length < 2) {
    for (var r = Ns(this.node(), n).tween, o = 0, i = r.length, s; o < i; ++o)
      if ((s = r[o]).name === t)
        return s.value;
    return null;
  }
  return this.each((e == null ? iat : sat)(n, t, e));
}
function j4(t, e, n) {
  var r = t._id;
  return t.each(function() {
    var o = Ia(this, r);
    (o.value || (o.value = {}))[e] = n.apply(this, arguments);
  }), function(o) {
    return Ns(o, r).value[e];
  };
}
function P0e(t, e) {
  var n;
  return (typeof e == "number" ? xc : e instanceof ky ? lX : (n = ky(e)) ? (e = n, lX) : qst)(t, e);
}
function lat(t) {
  return function() {
    this.removeAttribute(t);
  };
}
function cat(t) {
  return function() {
    this.removeAttributeNS(t.space, t.local);
  };
}
function uat(t, e, n) {
  var r, o = n + "", i;
  return function() {
    var s = this.getAttribute(t);
    return s === o ? null : s === r ? i : i = e(r = s, n);
  };
}
function dat(t, e, n) {
  var r, o = n + "", i;
  return function() {
    var s = this.getAttributeNS(t.space, t.local);
    return s === o ? null : s === r ? i : i = e(r = s, n);
  };
}
function fat(t, e, n) {
  var r, o, i;
  return function() {
    var s, a = n(this), l;
    return a == null ? void this.removeAttribute(t) : (s = this.getAttribute(t), l = a + "", s === l ? null : s === r && l === o ? i : (o = l, i = e(r = s, a)));
  };
}
function hat(t, e, n) {
  var r, o, i;
  return function() {
    var s, a = n(this), l;
    return a == null ? void this.removeAttributeNS(t.space, t.local) : (s = this.getAttributeNS(t.space, t.local), l = a + "", s === l ? null : s === r && l === o ? i : (o = l, i = e(r = s, a)));
  };
}
function pat(t, e) {
  var n = nO(t), r = n === "transform" ? Wst : P0e;
  return this.attrTween(t, typeof e == "function" ? (n.local ? hat : fat)(n, r, j4(this, "attr." + t, e)) : e == null ? (n.local ? cat : lat)(n) : (n.local ? dat : uat)(n, r, e));
}
function mat(t, e) {
  return function(n) {
    this.setAttribute(t, e.call(this, n));
  };
}
function gat(t, e) {
  return function(n) {
    this.setAttributeNS(t.space, t.local, e.call(this, n));
  };
}
function yat(t, e) {
  var n, r;
  function o() {
    var i = e.apply(this, arguments);
    return i !== r && (n = (r = i) && gat(t, i)), n;
  }
  return o._value = e, o;
}
function vat(t, e) {
  var n, r;
  function o() {
    var i = e.apply(this, arguments);
    return i !== r && (n = (r = i) && mat(t, i)), n;
  }
  return o._value = e, o;
}
function bat(t, e) {
  var n = "attr." + t;
  if (arguments.length < 2) return (n = this.tween(n)) && n._value;
  if (e == null) return this.tween(n, null);
  if (typeof e != "function") throw new Error();
  var r = nO(t);
  return this.tween(n, (r.local ? yat : vat)(r, e));
}
function _at(t, e) {
  return function() {
    N4(this, t).delay = +e.apply(this, arguments);
  };
}
function wat(t, e) {
  return e = +e, function() {
    N4(this, t).delay = e;
  };
}
function xat(t) {
  var e = this._id;
  return arguments.length ? this.each((typeof t == "function" ? _at : wat)(e, t)) : Ns(this.node(), e).delay;
}
function Eat(t, e) {
  return function() {
    Ia(this, t).duration = +e.apply(this, arguments);
  };
}
function Sat(t, e) {
  return e = +e, function() {
    Ia(this, t).duration = e;
  };
}
function Oat(t) {
  var e = this._id;
  return arguments.length ? this.each((typeof t == "function" ? Eat : Sat)(e, t)) : Ns(this.node(), e).duration;
}
function Cat(t, e) {
  if (typeof e != "function") throw new Error();
  return function() {
    Ia(this, t).ease = e;
  };
}
function kat(t) {
  var e = this._id;
  return arguments.length ? this.each(Cat(e, t)) : Ns(this.node(), e).ease;
}
function Aat(t, e) {
  return function() {
    var n = e.apply(this, arguments);
    if (typeof n != "function") throw new Error();
    Ia(this, t).ease = n;
  };
}
function Tat(t) {
  if (typeof t != "function") throw new Error();
  return this.each(Aat(this._id, t));
}
function Rat(t) {
  typeof t != "function" && (t = a0e(t));
  for (var e = this._groups, n = e.length, r = new Array(n), o = 0; o < n; ++o)
    for (var i = e[o], s = i.length, a = r[o] = [], l, c = 0; c < s; ++c)
      (l = i[c]) && t.call(l, l.__data__, c, i) && a.push(l);
  return new Ll(r, this._parents, this._name, this._id);
}
function Pat(t) {
  if (t._id !== this._id) throw new Error();
  for (var e = this._groups, n = t._groups, r = e.length, o = n.length, i = Math.min(r, o), s = new Array(r), a = 0; a < i; ++a)
    for (var l = e[a], c = n[a], u = l.length, d = s[a] = new Array(u), f, h = 0; h < u; ++h)
      (f = l[h] || c[h]) && (d[h] = f);
  for (; a < r; ++a)
    s[a] = e[a];
  return new Ll(s, this._parents, this._name, this._id);
}
function $at(t) {
  return (t + "").trim().split(/^|\s+/).every(function(e) {
    var n = e.indexOf(".");
    return n >= 0 && (e = e.slice(0, n)), !e || e === "start";
  });
}
function Mat(t, e, n) {
  var r, o, i = $at(e) ? N4 : Ia;
  return function() {
    var s = i(this, t), a = s.on;
    a !== r && (o = (r = a).copy()).on(e, n), s.on = o;
  };
}
function Dat(t, e) {
  var n = this._id;
  return arguments.length < 2 ? Ns(this.node(), n).on.on(t) : this.each(Mat(n, t, e));
}
function Iat(t) {
  return function() {
    var e = this.parentNode;
    for (var n in this.__transition) if (+n !== t) return;
    e && e.removeChild(this);
  };
}
function Nat() {
  return this.on("end.remove", Iat(this._id));
}
function jat(t) {
  var e = this._name, n = this._id;
  typeof t != "function" && (t = $4(t));
  for (var r = this._groups, o = r.length, i = new Array(o), s = 0; s < o; ++s)
    for (var a = r[s], l = a.length, c = i[s] = new Array(l), u, d, f = 0; f < l; ++f)
      (u = a[f]) && (d = t.call(u, u.__data__, f, a)) && ("__data__" in u && (d.__data__ = u.__data__), c[f] = d, oO(c[f], e, n, f, c, Ns(u, n)));
  return new Ll(i, this._parents, e, n);
}
function Lat(t) {
  var e = this._name, n = this._id;
  typeof t != "function" && (t = s0e(t));
  for (var r = this._groups, o = r.length, i = [], s = [], a = 0; a < o; ++a)
    for (var l = r[a], c = l.length, u, d = 0; d < c; ++d)
      if (u = l[d]) {
        for (var f = t.call(u, u.__data__, d, l), h, p = Ns(u, n), m = 0, g = f.length; m < g; ++m)
          (h = f[m]) && oO(h, e, n, m, f, p);
        i.push(f), s.push(u);
      }
  return new Ll(i, s, e, n);
}
var Fat = Rv.prototype.constructor;
function Bat() {
  return new Fat(this._groups, this._parents);
}
function zat(t, e) {
  var n, r, o;
  return function() {
    var i = ap(this, t), s = (this.style.removeProperty(t), ap(this, t));
    return i === s ? null : i === n && s === r ? o : o = e(n = i, r = s);
  };
}
function $0e(t) {
  return function() {
    this.style.removeProperty(t);
  };
}
function qat(t, e, n) {
  var r, o = n + "", i;
  return function() {
    var s = ap(this, t);
    return s === o ? null : s === r ? i : i = e(r = s, n);
  };
}
function Uat(t, e, n) {
  var r, o, i;
  return function() {
    var s = ap(this, t), a = n(this), l = a + "";
    return a == null && (l = a = (this.style.removeProperty(t), ap(this, t))), s === l ? null : s === r && l === o ? i : (o = l, i = e(r = s, a));
  };
}
function Hat(t, e) {
  var n, r, o, i = "style." + e, s = "end." + i, a;
  return function() {
    var l = Ia(this, t), c = l.on, u = l.value[i] == null ? a || (a = $0e(e)) : void 0;
    (c !== n || o !== u) && (r = (n = c).copy()).on(s, o = u), l.on = r;
  };
}
function Vat(t, e, n) {
  var r = (t += "") == "transform" ? Vst : P0e;
  return e == null ? this.styleTween(t, zat(t, r)).on("end.style." + t, $0e(t)) : typeof e == "function" ? this.styleTween(t, Uat(t, r, j4(this, "style." + t, e))).each(Hat(this._id, t)) : this.styleTween(t, qat(t, r, e), n).on("end.style." + t, null);
}
function Wat(t, e, n) {
  return function(r) {
    this.style.setProperty(t, e.call(this, r), n);
  };
}
function Gat(t, e, n) {
  var r, o;
  function i() {
    var s = e.apply(this, arguments);
    return s !== o && (r = (o = s) && Wat(t, s, n)), r;
  }
  return i._value = e, i;
}
function Yat(t, e, n) {
  var r = "style." + (t += "");
  if (arguments.length < 2) return (r = this.tween(r)) && r._value;
  if (e == null) return this.tween(r, null);
  if (typeof e != "function") throw new Error();
  return this.tween(r, Gat(t, e, n ?? ""));
}
function Kat(t) {
  return function() {
    this.textContent = t;
  };
}
function Xat(t) {
  return function() {
    var e = t(this);
    this.textContent = e ?? "";
  };
}
function Qat(t) {
  return this.tween("text", typeof t == "function" ? Xat(j4(this, "text", t)) : Kat(t == null ? "" : t + ""));
}
function Zat(t) {
  return function(e) {
    this.textContent = t.call(this, e);
  };
}
function Jat(t) {
  var e, n;
  function r() {
    var o = t.apply(this, arguments);
    return o !== n && (e = (n = o) && Zat(o)), e;
  }
  return r._value = t, r;
}
function elt(t) {
  var e = "text";
  if (arguments.length < 1) return (e = this.tween(e)) && e._value;
  if (t == null) return this.tween(e, null);
  if (typeof t != "function") throw new Error();
  return this.tween(e, Jat(t));
}
function tlt() {
  for (var t = this._name, e = this._id, n = M0e(), r = this._groups, o = r.length, i = 0; i < o; ++i)
    for (var s = r[i], a = s.length, l, c = 0; c < a; ++c)
      if (l = s[c]) {
        var u = Ns(l, e);
        oO(l, t, n, c, s, {
          time: u.time + u.delay + u.duration,
          delay: 0,
          duration: u.duration,
          ease: u.ease
        });
      }
  return new Ll(r, this._parents, t, n);
}
function nlt() {
  var t, e, n = this, r = n._id, o = n.size();
  return new Promise(function(i, s) {
    var a = { value: s }, l = { value: function() {
      --o === 0 && i();
    } };
    n.each(function() {
      var c = Ia(this, r), u = c.on;
      u !== t && (e = (t = u).copy(), e._.cancel.push(a), e._.interrupt.push(a), e._.end.push(l)), c.on = e;
    }), o === 0 && i();
  });
}
var rlt = 0;
function Ll(t, e, n, r) {
  this._groups = t, this._parents = e, this._name = n, this._id = r;
}
function M0e() {
  return ++rlt;
}
var za = Rv.prototype;
Ll.prototype = {
  constructor: Ll,
  select: jat,
  selectAll: Lat,
  selectChild: za.selectChild,
  selectChildren: za.selectChildren,
  filter: Rat,
  merge: Pat,
  selection: Bat,
  transition: tlt,
  call: za.call,
  nodes: za.nodes,
  node: za.node,
  size: za.size,
  empty: za.empty,
  each: za.each,
  on: Dat,
  attr: pat,
  attrTween: bat,
  style: Vat,
  styleTween: Yat,
  text: Qat,
  textTween: elt,
  remove: Nat,
  tween: aat,
  delay: xat,
  duration: Oat,
  ease: kat,
  easeVarying: Tat,
  end: nlt,
  [Symbol.iterator]: za[Symbol.iterator]
};
function olt(t) {
  return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}
var ilt = {
  time: null,
  // Set on use.
  delay: 0,
  duration: 250,
  ease: olt
};
function slt(t, e) {
  for (var n; !(n = t.__transition) || !(n = n[e]); )
    if (!(t = t.parentNode))
      throw new Error(`transition ${e} not found`);
  return n;
}
function alt(t) {
  var e, n;
  t instanceof Ll ? (e = t._id, t = t._name) : (e = M0e(), (n = ilt).time = I4(), t = t == null ? null : t + "");
  for (var r = this._groups, o = r.length, i = 0; i < o; ++i)
    for (var s = r[i], a = s.length, l, c = 0; c < a; ++c)
      (l = s[c]) && oO(l, t, e, c, s, n || slt(l, e));
  return new Ll(r, this._parents, t, e);
}
Rv.prototype.interrupt = oat;
Rv.prototype.transition = alt;
const C1 = (t) => () => t;
function llt(t, {
  sourceEvent: e,
  target: n,
  transform: r,
  dispatch: o
}) {
  Object.defineProperties(this, {
    type: { value: t, enumerable: !0, configurable: !0 },
    sourceEvent: { value: e, enumerable: !0, configurable: !0 },
    target: { value: n, enumerable: !0, configurable: !0 },
    transform: { value: r, enumerable: !0, configurable: !0 },
    _: { value: o }
  });
}
function Sl(t, e, n) {
  this.k = t, this.x = e, this.y = n;
}
Sl.prototype = {
  constructor: Sl,
  scale: function(t) {
    return t === 1 ? this : new Sl(this.k * t, this.x, this.y);
  },
  translate: function(t, e) {
    return t === 0 & e === 0 ? this : new Sl(this.k, this.x + this.k * t, this.y + this.k * e);
  },
  apply: function(t) {
    return [t[0] * this.k + this.x, t[1] * this.k + this.y];
  },
  applyX: function(t) {
    return t * this.k + this.x;
  },
  applyY: function(t) {
    return t * this.k + this.y;
  },
  invert: function(t) {
    return [(t[0] - this.x) / this.k, (t[1] - this.y) / this.k];
  },
  invertX: function(t) {
    return (t - this.x) / this.k;
  },
  invertY: function(t) {
    return (t - this.y) / this.k;
  },
  rescaleX: function(t) {
    return t.copy().domain(t.range().map(this.invertX, this).map(t.invert, t));
  },
  rescaleY: function(t) {
    return t.copy().domain(t.range().map(this.invertY, this).map(t.invert, t));
  },
  toString: function() {
    return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
  }
};
var iO = new Sl(1, 0, 0);
D0e.prototype = Sl.prototype;
function D0e(t) {
  for (; !t.__zoom; ) if (!(t = t.parentNode)) return iO;
  return t.__zoom;
}
function QA(t) {
  t.stopImmediatePropagation();
}
function wm(t) {
  t.preventDefault(), t.stopImmediatePropagation();
}
function clt(t) {
  return (!t.ctrlKey || t.type === "wheel") && !t.button;
}
function ult() {
  var t = this;
  return t instanceof SVGElement ? (t = t.ownerSVGElement || t, t.hasAttribute("viewBox") ? (t = t.viewBox.baseVal, [[t.x, t.y], [t.x + t.width, t.y + t.height]]) : [[0, 0], [t.width.baseVal.value, t.height.baseVal.value]]) : [[0, 0], [t.clientWidth, t.clientHeight]];
}
function mX() {
  return this.__zoom || iO;
}
function dlt(t) {
  return -t.deltaY * (t.deltaMode === 1 ? 0.05 : t.deltaMode ? 1 : 2e-3) * (t.ctrlKey ? 10 : 1);
}
function flt() {
  return navigator.maxTouchPoints || "ontouchstart" in this;
}
function hlt(t, e, n) {
  var r = t.invertX(e[0][0]) - n[0][0], o = t.invertX(e[1][0]) - n[1][0], i = t.invertY(e[0][1]) - n[0][1], s = t.invertY(e[1][1]) - n[1][1];
  return t.translate(
    o > r ? (r + o) / 2 : Math.min(0, r) || Math.max(0, o),
    s > i ? (i + s) / 2 : Math.min(0, i) || Math.max(0, s)
  );
}
function I0e() {
  var t = clt, e = ult, n = hlt, r = dlt, o = flt, i = [0, 1 / 0], s = [[-1 / 0, -1 / 0], [1 / 0, 1 / 0]], a = 250, l = Xst, c = tO("start", "zoom", "end"), u, d, f, h = 500, p = 150, m = 0, g = 10;
  function y(O) {
    O.property("__zoom", mX).on("wheel.zoom", S, { passive: !1 }).on("mousedown.zoom", C).on("dblclick.zoom", R).filter(o).on("touchstart.zoom", P).on("touchmove.zoom", N).on("touchend.zoom touchcancel.zoom", A).style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
  }
  y.transform = function(O, k, T, I) {
    var j = O.selection ? O.selection() : O;
    j.property("__zoom", mX), O !== j ? w(O, k, T, I) : j.interrupt().each(function() {
      x(this, arguments).event(I).start().zoom(null, typeof k == "function" ? k.apply(this, arguments) : k).end();
    });
  }, y.scaleBy = function(O, k, T, I) {
    y.scaleTo(O, function() {
      var j = this.__zoom.k, z = typeof k == "function" ? k.apply(this, arguments) : k;
      return j * z;
    }, T, I);
  }, y.scaleTo = function(O, k, T, I) {
    y.transform(O, function() {
      var j = e.apply(this, arguments), z = this.__zoom, $ = T == null ? _(j) : typeof T == "function" ? T.apply(this, arguments) : T, D = z.invert($), U = typeof k == "function" ? k.apply(this, arguments) : k;
      return n(b(v(z, U), $, D), j, s);
    }, T, I);
  }, y.translateBy = function(O, k, T, I) {
    y.transform(O, function() {
      return n(this.__zoom.translate(
        typeof k == "function" ? k.apply(this, arguments) : k,
        typeof T == "function" ? T.apply(this, arguments) : T
      ), e.apply(this, arguments), s);
    }, null, I);
  }, y.translateTo = function(O, k, T, I, j) {
    y.transform(O, function() {
      var z = e.apply(this, arguments), $ = this.__zoom, D = I == null ? _(z) : typeof I == "function" ? I.apply(this, arguments) : I;
      return n(iO.translate(D[0], D[1]).scale($.k).translate(
        typeof k == "function" ? -k.apply(this, arguments) : -k,
        typeof T == "function" ? -T.apply(this, arguments) : -T
      ), z, s);
    }, I, j);
  };
  function v(O, k) {
    return k = Math.max(i[0], Math.min(i[1], k)), k === O.k ? O : new Sl(k, O.x, O.y);
  }
  function b(O, k, T) {
    var I = k[0] - T[0] * O.k, j = k[1] - T[1] * O.k;
    return I === O.x && j === O.y ? O : new Sl(O.k, I, j);
  }
  function _(O) {
    return [(+O[0][0] + +O[1][0]) / 2, (+O[0][1] + +O[1][1]) / 2];
  }
  function w(O, k, T, I) {
    O.on("start.zoom", function() {
      x(this, arguments).event(I).start();
    }).on("interrupt.zoom end.zoom", function() {
      x(this, arguments).event(I).end();
    }).tween("zoom", function() {
      var j = this, z = arguments, $ = x(j, z).event(I), D = e.apply(j, z), U = T == null ? _(D) : typeof T == "function" ? T.apply(j, z) : T, q = Math.max(D[1][0] - D[0][0], D[1][1] - D[0][1]), F = j.__zoom, B = typeof k == "function" ? k.apply(j, z) : k, H = l(F.invert(U).concat(q / F.k), B.invert(U).concat(q / B.k));
      return function(Z) {
        if (Z === 1) Z = B;
        else {
          var W = H(Z), G = q / W[2];
          Z = new Sl(G, U[0] - W[0] * G, U[1] - W[1] * G);
        }
        $.zoom(null, Z);
      };
    });
  }
  function x(O, k, T) {
    return !T && O.__zooming || new E(O, k);
  }
  function E(O, k) {
    this.that = O, this.args = k, this.active = 0, this.sourceEvent = null, this.extent = e.apply(O, k), this.taps = 0;
  }
  E.prototype = {
    event: function(O) {
      return O && (this.sourceEvent = O), this;
    },
    start: function() {
      return ++this.active === 1 && (this.that.__zooming = this, this.emit("start")), this;
    },
    zoom: function(O, k) {
      return this.mouse && O !== "mouse" && (this.mouse[1] = k.invert(this.mouse[0])), this.touch0 && O !== "touch" && (this.touch0[1] = k.invert(this.touch0[0])), this.touch1 && O !== "touch" && (this.touch1[1] = k.invert(this.touch1[0])), this.that.__zoom = k, this.emit("zoom"), this;
    },
    end: function() {
      return --this.active === 0 && (delete this.that.__zooming, this.emit("end")), this;
    },
    emit: function(O) {
      var k = vi(this.that).datum();
      c.call(
        O,
        this.that,
        new llt(O, {
          sourceEvent: this.sourceEvent,
          target: y,
          transform: this.that.__zoom,
          dispatch: c
        }),
        k
      );
    }
  };
  function S(O, ...k) {
    if (!t.apply(this, arguments)) return;
    var T = x(this, k).event(O), I = this.__zoom, j = Math.max(i[0], Math.min(i[1], I.k * Math.pow(2, r.apply(this, arguments)))), z = vs(O);
    if (T.wheel)
      (T.mouse[0][0] !== z[0] || T.mouse[0][1] !== z[1]) && (T.mouse[1] = I.invert(T.mouse[0] = z)), clearTimeout(T.wheel);
    else {
      if (I.k === j) return;
      T.mouse = [z, I.invert(z)], Iw(this), T.start();
    }
    wm(O), T.wheel = setTimeout($, p), T.zoom("mouse", n(b(v(I, j), T.mouse[0], T.mouse[1]), T.extent, s));
    function $() {
      T.wheel = null, T.end();
    }
  }
  function C(O, ...k) {
    if (f || !t.apply(this, arguments)) return;
    var T = O.currentTarget, I = x(this, k, !0).event(O), j = vi(O.view).on("mousemove.zoom", U, !0).on("mouseup.zoom", q, !0), z = vs(O, T), $ = O.clientX, D = O.clientY;
    y0e(O.view), QA(O), I.mouse = [z, this.__zoom.invert(z)], Iw(this), I.start();
    function U(F) {
      if (wm(F), !I.moved) {
        var B = F.clientX - $, H = F.clientY - D;
        I.moved = B * B + H * H > m;
      }
      I.event(F).zoom("mouse", n(b(I.that.__zoom, I.mouse[0] = vs(F, T), I.mouse[1]), I.extent, s));
    }
    function q(F) {
      j.on("mousemove.zoom mouseup.zoom", null), v0e(F.view, I.moved), wm(F), I.event(F).end();
    }
  }
  function R(O, ...k) {
    if (t.apply(this, arguments)) {
      var T = this.__zoom, I = vs(O.changedTouches ? O.changedTouches[0] : O, this), j = T.invert(I), z = T.k * (O.shiftKey ? 0.5 : 2), $ = n(b(v(T, z), I, j), e.apply(this, k), s);
      wm(O), a > 0 ? vi(this).transition().duration(a).call(w, $, I, O) : vi(this).call(y.transform, $, I, O);
    }
  }
  function P(O, ...k) {
    if (t.apply(this, arguments)) {
      var T = O.touches, I = T.length, j = x(this, k, O.changedTouches.length === I).event(O), z, $, D, U;
      for (QA(O), $ = 0; $ < I; ++$)
        D = T[$], U = vs(D, this), U = [U, this.__zoom.invert(U), D.identifier], j.touch0 ? !j.touch1 && j.touch0[2] !== U[2] && (j.touch1 = U, j.taps = 0) : (j.touch0 = U, z = !0, j.taps = 1 + !!u);
      u && (u = clearTimeout(u)), z && (j.taps < 2 && (d = U[0], u = setTimeout(function() {
        u = null;
      }, h)), Iw(this), j.start());
    }
  }
  function N(O, ...k) {
    if (this.__zooming) {
      var T = x(this, k).event(O), I = O.changedTouches, j = I.length, z, $, D, U;
      for (wm(O), z = 0; z < j; ++z)
        $ = I[z], D = vs($, this), T.touch0 && T.touch0[2] === $.identifier ? T.touch0[0] = D : T.touch1 && T.touch1[2] === $.identifier && (T.touch1[0] = D);
      if ($ = T.that.__zoom, T.touch1) {
        var q = T.touch0[0], F = T.touch0[1], B = T.touch1[0], H = T.touch1[1], Z = (Z = B[0] - q[0]) * Z + (Z = B[1] - q[1]) * Z, W = (W = H[0] - F[0]) * W + (W = H[1] - F[1]) * W;
        $ = v($, Math.sqrt(Z / W)), D = [(q[0] + B[0]) / 2, (q[1] + B[1]) / 2], U = [(F[0] + H[0]) / 2, (F[1] + H[1]) / 2];
      } else if (T.touch0) D = T.touch0[0], U = T.touch0[1];
      else return;
      T.zoom("touch", n(b($, D, U), T.extent, s));
    }
  }
  function A(O, ...k) {
    if (this.__zooming) {
      var T = x(this, k).event(O), I = O.changedTouches, j = I.length, z, $;
      for (QA(O), f && clearTimeout(f), f = setTimeout(function() {
        f = null;
      }, h), z = 0; z < j; ++z)
        $ = I[z], T.touch0 && T.touch0[2] === $.identifier ? delete T.touch0 : T.touch1 && T.touch1[2] === $.identifier && delete T.touch1;
      if (T.touch1 && !T.touch0 && (T.touch0 = T.touch1, delete T.touch1), T.touch0) T.touch0[1] = this.__zoom.invert(T.touch0[0]);
      else if (T.end(), T.taps === 2 && ($ = vs($, this), Math.hypot(d[0] - $[0], d[1] - $[1]) < g)) {
        var D = vi(this).on("dblclick.zoom");
        D && D.apply(this, arguments);
      }
    }
  }
  return y.wheelDelta = function(O) {
    return arguments.length ? (r = typeof O == "function" ? O : C1(+O), y) : r;
  }, y.filter = function(O) {
    return arguments.length ? (t = typeof O == "function" ? O : C1(!!O), y) : t;
  }, y.touchable = function(O) {
    return arguments.length ? (o = typeof O == "function" ? O : C1(!!O), y) : o;
  }, y.extent = function(O) {
    return arguments.length ? (e = typeof O == "function" ? O : C1([[+O[0][0], +O[0][1]], [+O[1][0], +O[1][1]]]), y) : e;
  }, y.scaleExtent = function(O) {
    return arguments.length ? (i[0] = +O[0], i[1] = +O[1], y) : [i[0], i[1]];
  }, y.translateExtent = function(O) {
    return arguments.length ? (s[0][0] = +O[0][0], s[1][0] = +O[1][0], s[0][1] = +O[0][1], s[1][1] = +O[1][1], y) : [[s[0][0], s[0][1]], [s[1][0], s[1][1]]];
  }, y.constrain = function(O) {
    return arguments.length ? (n = O, y) : n;
  }, y.duration = function(O) {
    return arguments.length ? (a = +O, y) : a;
  }, y.interpolate = function(O) {
    return arguments.length ? (l = O, y) : l;
  }, y.on = function() {
    var O = c.on.apply(c, arguments);
    return O === c ? y : O;
  }, y.clickDistance = function(O) {
    return arguments.length ? (m = (O = +O) * O, y) : Math.sqrt(m);
  }, y.tapDistance = function(O) {
    return arguments.length ? (g = +O, y) : g;
  }, y;
}
const cs = {
  error001: () => "[React Flow]: Seems like you have not used zustand provider as an ancestor. Help: https://reactflow.dev/error#001",
  error002: () => "It looks like you've created a new nodeTypes or edgeTypes object. If this wasn't on purpose please define the nodeTypes/edgeTypes outside of the component or memoize them.",
  error003: (t) => `Node type "${t}" not found. Using fallback type "default".`,
  error004: () => "The React Flow parent container needs a width and a height to render the graph.",
  error005: () => "Only child nodes can use a parent extent.",
  error006: () => "Can't create edge. An edge needs a source and a target.",
  error007: (t) => `The old edge with id=${t} does not exist.`,
  error009: (t) => `Marker type "${t}" doesn't exist.`,
  error008: (t, { id: e, sourceHandle: n, targetHandle: r }) => `Couldn't create edge for ${t} handle id: "${t === "source" ? n : r}", edge id: ${e}.`,
  error010: () => "Handle: No node id found. Make sure to only use a Handle inside a custom Node.",
  error011: (t) => `Edge type "${t}" not found. Using fallback type "default".`,
  error012: (t) => `Node with id "${t}" does not exist, it may have been removed. This can happen when a node is deleted before the "onNodeClick" handler is called.`,
  error013: (t = "react") => `It seems that you haven't loaded the styles. Please import '@xyflow/${t}/dist/style.css' or base.css to make sure everything is working properly.`,
  error014: () => "useNodeConnections: No node ID found. Call useNodeConnections inside a custom Node or provide a node ID."
}, Ty = [
  [Number.NEGATIVE_INFINITY, Number.NEGATIVE_INFINITY],
  [Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY]
], N0e = ["Enter", " ", "Escape"];
var cp;
(function(t) {
  t.Strict = "strict", t.Loose = "loose";
})(cp || (cp = {}));
var Ed;
(function(t) {
  t.Free = "free", t.Vertical = "vertical", t.Horizontal = "horizontal";
})(Ed || (Ed = {}));
var Ry;
(function(t) {
  t.Partial = "partial", t.Full = "full";
})(Ry || (Ry = {}));
const j0e = {
  inProgress: !1,
  isValid: null,
  from: null,
  fromHandle: null,
  fromPosition: null,
  fromNode: null,
  to: null,
  toHandle: null,
  toPosition: null,
  toNode: null
};
var Ac;
(function(t) {
  t.Bezier = "default", t.Straight = "straight", t.Step = "step", t.SmoothStep = "smoothstep", t.SimpleBezier = "simplebezier";
})(Ac || (Ac = {}));
var yE;
(function(t) {
  t.Arrow = "arrow", t.ArrowClosed = "arrowclosed";
})(yE || (yE = {}));
var pt;
(function(t) {
  t.Left = "left", t.Top = "top", t.Right = "right", t.Bottom = "bottom";
})(pt || (pt = {}));
const gX = {
  [pt.Left]: pt.Right,
  [pt.Right]: pt.Left,
  [pt.Top]: pt.Bottom,
  [pt.Bottom]: pt.Top
};
function L0e(t) {
  return t === null ? null : t ? "valid" : "invalid";
}
const F0e = (t) => "id" in t && "source" in t && "target" in t, plt = (t) => "id" in t && "position" in t && !("source" in t) && !("target" in t), L4 = (t) => "id" in t && "internals" in t && !("source" in t) && !("target" in t), $v = (t, e = [0, 0]) => {
  const { width: n, height: r } = Gl(t), o = t.origin ?? e, i = n * o[0], s = r * o[1];
  return {
    x: t.position.x - i,
    y: t.position.y - s
  };
}, mlt = (t, e = { nodeOrigin: [0, 0], nodeLookup: void 0 }) => {
  if (process.env.NODE_ENV === "development" && !e.nodeLookup && console.warn("Please use `getNodesBounds` from `useReactFlow`/`useSvelteFlow` hook to ensure correct values for sub flows. If not possible, you have to provide a nodeLookup to support sub flows."), t.length === 0)
    return { x: 0, y: 0, width: 0, height: 0 };
  const n = t.reduce((r, o) => {
    const i = typeof o == "string";
    let s = !e.nodeLookup && !i ? o : void 0;
    e.nodeLookup && (s = i ? e.nodeLookup.get(o) : L4(o) ? o : e.nodeLookup.get(o.id));
    const a = s ? vE(s, e.nodeOrigin) : { x: 0, y: 0, x2: 0, y2: 0 };
    return sO(r, a);
  }, { x: 1 / 0, y: 1 / 0, x2: -1 / 0, y2: -1 / 0 });
  return aO(n);
}, Mv = (t, e = {}) => {
  if (t.size === 0)
    return { x: 0, y: 0, width: 0, height: 0 };
  let n = { x: 1 / 0, y: 1 / 0, x2: -1 / 0, y2: -1 / 0 };
  return t.forEach((r) => {
    if (e.filter === void 0 || e.filter(r)) {
      const o = vE(r);
      n = sO(n, o);
    }
  }), aO(n);
}, B0e = (t, e, [n, r, o] = [0, 0, 1], i = !1, s = !1) => {
  const a = {
    ...Dv(e, [n, r, o]),
    width: e.width / o,
    height: e.height / o
  }, l = [];
  for (const c of t.values()) {
    const { measured: u, selectable: d = !0, hidden: f = !1 } = c;
    if (s && !d || f)
      continue;
    const h = u.width ?? c.width ?? c.initialWidth ?? null, p = u.height ?? c.height ?? c.initialHeight ?? null, m = Py(a, dp(c)), g = (h ?? 0) * (p ?? 0), y = i && m > 0;
    (!c.internals.handleBounds || y || m >= g || c.dragging) && l.push(c);
  }
  return l;
}, glt = (t, e) => {
  const n = /* @__PURE__ */ new Set();
  return t.forEach((r) => {
    n.add(r.id);
  }), e.filter((r) => n.has(r.source) || n.has(r.target));
};
function Cj(t, e) {
  const n = /* @__PURE__ */ new Map(), r = e?.nodes ? new Set(e.nodes.map((o) => o.id)) : null;
  return t.forEach((o) => {
    o.measured.width && o.measured.height && (e?.includeHiddenNodes || !o.hidden) && (!r || r.has(o.id)) && n.set(o.id, o);
  }), n;
}
async function kj({ nodes: t, width: e, height: n, panZoom: r, minZoom: o, maxZoom: i }, s) {
  if (t.size === 0)
    return Promise.resolve(!1);
  const a = Mv(t), l = F4(a, e, n, s?.minZoom ?? o, s?.maxZoom ?? i, s?.padding ?? 0.1);
  return await r.setViewport(l, { duration: s?.duration }), Promise.resolve(!0);
}
function z0e({ nodeId: t, nextPosition: e, nodeLookup: n, nodeOrigin: r = [0, 0], nodeExtent: o, onError: i }) {
  const s = n.get(t), a = s.parentId ? n.get(s.parentId) : void 0, { x: l, y: c } = a ? a.internals.positionAbsolute : { x: 0, y: 0 }, u = s.origin ?? r;
  let d = o;
  if (s.extent === "parent" && !s.expandParent)
    if (!a)
      i?.("005", cs.error005());
    else {
      const h = a.measured.width, p = a.measured.height;
      h && p && (d = [
        [l, c],
        [l + h, c + p]
      ]);
    }
  else a && fp(s.extent) && (d = [
    [s.extent[0][0] + l, s.extent[0][1] + c],
    [s.extent[1][0] + l, s.extent[1][1] + c]
  ]);
  const f = fp(d) ? Bd(e, d, s.measured) : e;
  return {
    position: {
      x: f.x - l + s.measured.width * u[0],
      y: f.y - c + s.measured.height * u[1]
    },
    positionAbsolute: f
  };
}
async function ylt({ nodesToRemove: t = [], edgesToRemove: e = [], nodes: n, edges: r, onBeforeDelete: o }) {
  const i = new Set(t.map((d) => d.id)), s = [];
  for (const d of n) {
    if (d.deletable === !1)
      continue;
    const f = i.has(d.id), h = !f && d.parentId && s.find((p) => p.id === d.parentId);
    (f || h) && s.push(d);
  }
  const a = new Set(e.map((d) => d.id)), l = r.filter((d) => d.deletable !== !1), c = glt(s, l);
  for (const d of l)
    a.has(d.id) && !c.find((f) => f.id === d.id) && c.push(d);
  if (!o)
    return {
      edges: c,
      nodes: s
    };
  const u = await o({
    nodes: s,
    edges: c
  });
  return typeof u == "boolean" ? u ? { edges: c, nodes: s } : { edges: [], nodes: [] } : u;
}
const up = (t, e = 0, n = 1) => Math.min(Math.max(t, e), n), Bd = (t = { x: 0, y: 0 }, e, n) => ({
  x: up(t.x, e[0][0], e[1][0] - (n?.width ?? 0)),
  y: up(t.y, e[0][1], e[1][1] - (n?.height ?? 0))
});
function q0e(t, e, n) {
  const { width: r, height: o } = Gl(n), { x: i, y: s } = n.internals.positionAbsolute;
  return Bd(t, [
    [i, s],
    [i + r, s + o]
  ], e);
}
const yX = (t, e, n) => t < e ? up(Math.abs(t - e), 1, e) / e : t > n ? -up(Math.abs(t - n), 1, e) / e : 0, U0e = (t, e, n = 15, r = 40) => {
  const o = yX(t.x, r, e.width - r) * n, i = yX(t.y, r, e.height - r) * n;
  return [o, i];
}, sO = (t, e) => ({
  x: Math.min(t.x, e.x),
  y: Math.min(t.y, e.y),
  x2: Math.max(t.x2, e.x2),
  y2: Math.max(t.y2, e.y2)
}), Aj = ({ x: t, y: e, width: n, height: r }) => ({
  x: t,
  y: e,
  x2: t + n,
  y2: e + r
}), aO = ({ x: t, y: e, x2: n, y2: r }) => ({
  x: t,
  y: e,
  width: n - t,
  height: r - e
}), dp = (t, e = [0, 0]) => {
  const { x: n, y: r } = L4(t) ? t.internals.positionAbsolute : $v(t, e);
  return {
    x: n,
    y: r,
    width: t.measured?.width ?? t.width ?? t.initialWidth ?? 0,
    height: t.measured?.height ?? t.height ?? t.initialHeight ?? 0
  };
}, vE = (t, e = [0, 0]) => {
  const { x: n, y: r } = L4(t) ? t.internals.positionAbsolute : $v(t, e);
  return {
    x: n,
    y: r,
    x2: n + (t.measured?.width ?? t.width ?? t.initialWidth ?? 0),
    y2: r + (t.measured?.height ?? t.height ?? t.initialHeight ?? 0)
  };
}, H0e = (t, e) => aO(sO(Aj(t), Aj(e))), Py = (t, e) => {
  const n = Math.max(0, Math.min(t.x + t.width, e.x + e.width) - Math.max(t.x, e.x)), r = Math.max(0, Math.min(t.y + t.height, e.y + e.height) - Math.max(t.y, e.y));
  return Math.ceil(n * r);
}, vX = (t) => Ss(t.width) && Ss(t.height) && Ss(t.x) && Ss(t.y), Ss = (t) => !isNaN(t) && isFinite(t), V0e = (t, e) => {
  process.env.NODE_ENV === "development" && console.warn(`[React Flow]: ${e} Help: https://reactflow.dev/error#${t}`);
}, lO = (t, e = [1, 1]) => ({
  x: e[0] * Math.round(t.x / e[0]),
  y: e[1] * Math.round(t.y / e[1])
}), Dv = ({ x: t, y: e }, [n, r, o], i = !1, s = [1, 1]) => {
  const a = {
    x: (t - n) / o,
    y: (e - r) / o
  };
  return i ? lO(a, s) : a;
}, W0e = ({ x: t, y: e }, [n, r, o]) => ({
  x: t * o + n,
  y: e * o + r
}), F4 = (t, e, n, r, o, i) => {
  const s = e / (t.width * (1 + i)), a = n / (t.height * (1 + i)), l = Math.min(s, a), c = up(l, r, o), u = t.x + t.width / 2, d = t.y + t.height / 2, f = e / 2 - u * c, h = n / 2 - d * c;
  return { x: f, y: h, zoom: c };
}, bE = () => typeof navigator < "u" && navigator?.userAgent?.indexOf("Mac") >= 0;
function fp(t) {
  return t !== void 0 && t !== "parent";
}
function Gl(t) {
  return {
    width: t.measured?.width ?? t.width ?? t.initialWidth ?? 0,
    height: t.measured?.height ?? t.height ?? t.initialHeight ?? 0
  };
}
function G0e(t) {
  return (t.measured?.width ?? t.width ?? t.initialWidth) !== void 0 && (t.measured?.height ?? t.height ?? t.initialHeight) !== void 0;
}
function Y0e(t, e = { width: 0, height: 0 }, n, r, o) {
  const i = { ...t }, s = r.get(n);
  if (s) {
    const a = s.origin || o;
    i.x += s.internals.positionAbsolute.x - (e.width ?? 0) * a[0], i.y += s.internals.positionAbsolute.y - (e.height ?? 0) * a[1];
  }
  return i;
}
function bX(t, e) {
  if (t.size !== e.size)
    return !1;
  for (const n of t)
    if (!e.has(n))
      return !1;
  return !0;
}
function f0(t, { snapGrid: e = [0, 0], snapToGrid: n = !1, transform: r, containerBounds: o }) {
  const { x: i, y: s } = Tl(t), a = Dv({ x: i - (o?.left ?? 0), y: s - (o?.top ?? 0) }, r), { x: l, y: c } = n ? lO(a, e) : a;
  return {
    xSnapped: l,
    ySnapped: c,
    ...a
  };
}
const cO = (t) => ({
  width: t.offsetWidth,
  height: t.offsetHeight
}), K0e = (t) => t?.getRootNode?.() || window?.document, vlt = ["INPUT", "SELECT", "TEXTAREA"];
function Tj(t) {
  const e = t.composedPath?.()?.[0] || t.target;
  return e?.nodeType !== 1 ? !1 : vlt.includes(e.nodeName) || e.hasAttribute("contenteditable") || !!e.closest(".nokey");
}
const X0e = (t) => "clientX" in t, Tl = (t, e) => {
  const n = X0e(t), r = n ? t.clientX : t.touches?.[0].clientX, o = n ? t.clientY : t.touches?.[0].clientY;
  return {
    x: r - (e?.left ?? 0),
    y: o - (e?.top ?? 0)
  };
}, _X = (t, e, n, r, o) => {
  const i = e.querySelectorAll(`.${t}`);
  return !i || !i.length ? null : Array.from(i).map((s) => {
    const a = s.getBoundingClientRect();
    return {
      id: s.getAttribute("data-handleid"),
      type: t,
      nodeId: o,
      position: s.getAttribute("data-handlepos"),
      x: (a.left - n.left) / r,
      y: (a.top - n.top) / r,
      ...cO(s)
    };
  });
};
function Q0e({ sourceX: t, sourceY: e, targetX: n, targetY: r, sourceControlX: o, sourceControlY: i, targetControlX: s, targetControlY: a }) {
  const l = t * 0.125 + o * 0.375 + s * 0.375 + n * 0.125, c = e * 0.125 + i * 0.375 + a * 0.375 + r * 0.125, u = Math.abs(l - t), d = Math.abs(c - e);
  return [l, c, u, d];
}
function k1(t, e) {
  return t >= 0 ? 0.5 * t : e * 25 * Math.sqrt(-t);
}
function wX({ pos: t, x1: e, y1: n, x2: r, y2: o, c: i }) {
  switch (t) {
    case pt.Left:
      return [e - k1(e - r, i), n];
    case pt.Right:
      return [e + k1(r - e, i), n];
    case pt.Top:
      return [e, n - k1(n - o, i)];
    case pt.Bottom:
      return [e, n + k1(o - n, i)];
  }
}
function Z0e({ sourceX: t, sourceY: e, sourcePosition: n = pt.Bottom, targetX: r, targetY: o, targetPosition: i = pt.Top, curvature: s = 0.25 }) {
  const [a, l] = wX({
    pos: n,
    x1: t,
    y1: e,
    x2: r,
    y2: o,
    c: s
  }), [c, u] = wX({
    pos: i,
    x1: r,
    y1: o,
    x2: t,
    y2: e,
    c: s
  }), [d, f, h, p] = Q0e({
    sourceX: t,
    sourceY: e,
    targetX: r,
    targetY: o,
    sourceControlX: a,
    sourceControlY: l,
    targetControlX: c,
    targetControlY: u
  });
  return [
    `M${t},${e} C${a},${l} ${c},${u} ${r},${o}`,
    d,
    f,
    h,
    p
  ];
}
function J0e({ sourceX: t, sourceY: e, targetX: n, targetY: r }) {
  const o = Math.abs(n - t) / 2, i = n < t ? n + o : n - o, s = Math.abs(r - e) / 2, a = r < e ? r + s : r - s;
  return [i, a, o, s];
}
function blt({ sourceNode: t, targetNode: e, selected: n = !1, zIndex: r = 0, elevateOnSelect: o = !1 }) {
  if (!o)
    return r;
  const i = n || e.selected || t.selected, s = Math.max(t.internals.z || 0, e.internals.z || 0, 1e3);
  return r + (i ? s : 0);
}
function _lt({ sourceNode: t, targetNode: e, width: n, height: r, transform: o }) {
  const i = sO(vE(t), vE(e));
  i.x === i.x2 && (i.x2 += 1), i.y === i.y2 && (i.y2 += 1);
  const s = {
    x: -o[0] / o[2],
    y: -o[1] / o[2],
    width: n / o[2],
    height: r / o[2]
  };
  return Py(s, aO(i)) > 0;
}
const wlt = ({ source: t, sourceHandle: e, target: n, targetHandle: r }) => `xy-edge__${t}${e || ""}-${n}${r || ""}`, xlt = (t, e) => e.some((n) => n.source === t.source && n.target === t.target && (n.sourceHandle === t.sourceHandle || !n.sourceHandle && !t.sourceHandle) && (n.targetHandle === t.targetHandle || !n.targetHandle && !t.targetHandle)), Elt = (t, e) => {
  if (!t.source || !t.target)
    return V0e("006", cs.error006()), e;
  let n;
  return F0e(t) ? n = { ...t } : n = {
    ...t,
    id: wlt(t)
  }, xlt(n, e) ? e : (n.sourceHandle === null && delete n.sourceHandle, n.targetHandle === null && delete n.targetHandle, e.concat(n));
};
function eye({ sourceX: t, sourceY: e, targetX: n, targetY: r }) {
  const [o, i, s, a] = J0e({
    sourceX: t,
    sourceY: e,
    targetX: n,
    targetY: r
  });
  return [`M ${t},${e}L ${n},${r}`, o, i, s, a];
}
const xX = {
  [pt.Left]: { x: -1, y: 0 },
  [pt.Right]: { x: 1, y: 0 },
  [pt.Top]: { x: 0, y: -1 },
  [pt.Bottom]: { x: 0, y: 1 }
}, Slt = ({ source: t, sourcePosition: e = pt.Bottom, target: n }) => e === pt.Left || e === pt.Right ? t.x < n.x ? { x: 1, y: 0 } : { x: -1, y: 0 } : t.y < n.y ? { x: 0, y: 1 } : { x: 0, y: -1 }, EX = (t, e) => Math.sqrt(Math.pow(e.x - t.x, 2) + Math.pow(e.y - t.y, 2));
function Olt({ source: t, sourcePosition: e = pt.Bottom, target: n, targetPosition: r = pt.Top, center: o, offset: i }) {
  const s = xX[e], a = xX[r], l = { x: t.x + s.x * i, y: t.y + s.y * i }, c = { x: n.x + a.x * i, y: n.y + a.y * i }, u = Slt({
    source: l,
    sourcePosition: e,
    target: c
  }), d = u.x !== 0 ? "x" : "y", f = u[d];
  let h = [], p, m;
  const g = { x: 0, y: 0 }, y = { x: 0, y: 0 }, [v, b, _, w] = J0e({
    sourceX: t.x,
    sourceY: t.y,
    targetX: n.x,
    targetY: n.y
  });
  if (s[d] * a[d] === -1) {
    p = o.x ?? v, m = o.y ?? b;
    const x = [
      { x: p, y: l.y },
      { x: p, y: c.y }
    ], E = [
      { x: l.x, y: m },
      { x: c.x, y: m }
    ];
    s[d] === f ? h = d === "x" ? x : E : h = d === "x" ? E : x;
  } else {
    const x = [{ x: l.x, y: c.y }], E = [{ x: c.x, y: l.y }];
    if (d === "x" ? h = s.x === f ? E : x : h = s.y === f ? x : E, e === r) {
      const N = Math.abs(t[d] - n[d]);
      if (N <= i) {
        const A = Math.min(i - 1, i - N);
        s[d] === f ? g[d] = (l[d] > t[d] ? -1 : 1) * A : y[d] = (c[d] > n[d] ? -1 : 1) * A;
      }
    }
    if (e !== r) {
      const N = d === "x" ? "y" : "x", A = s[d] === a[N], O = l[N] > c[N], k = l[N] < c[N];
      (s[d] === 1 && (!A && O || A && k) || s[d] !== 1 && (!A && k || A && O)) && (h = d === "x" ? x : E);
    }
    const S = { x: l.x + g.x, y: l.y + g.y }, C = { x: c.x + y.x, y: c.y + y.y }, R = Math.max(Math.abs(S.x - h[0].x), Math.abs(C.x - h[0].x)), P = Math.max(Math.abs(S.y - h[0].y), Math.abs(C.y - h[0].y));
    R >= P ? (p = (S.x + C.x) / 2, m = h[0].y) : (p = h[0].x, m = (S.y + C.y) / 2);
  }
  return [[
    t,
    { x: l.x + g.x, y: l.y + g.y },
    ...h,
    { x: c.x + y.x, y: c.y + y.y },
    n
  ], p, m, _, w];
}
function Clt(t, e, n, r) {
  const o = Math.min(EX(t, e) / 2, EX(e, n) / 2, r), { x: i, y: s } = e;
  if (t.x === i && i === n.x || t.y === s && s === n.y)
    return `L${i} ${s}`;
  if (t.y === s) {
    const c = t.x < n.x ? -1 : 1, u = t.y < n.y ? 1 : -1;
    return `L ${i + o * c},${s}Q ${i},${s} ${i},${s + o * u}`;
  }
  const a = t.x < n.x ? 1 : -1, l = t.y < n.y ? -1 : 1;
  return `L ${i},${s + o * l}Q ${i},${s} ${i + o * a},${s}`;
}
function Rj({ sourceX: t, sourceY: e, sourcePosition: n = pt.Bottom, targetX: r, targetY: o, targetPosition: i = pt.Top, borderRadius: s = 5, centerX: a, centerY: l, offset: c = 20 }) {
  const [u, d, f, h, p] = Olt({
    source: { x: t, y: e },
    sourcePosition: n,
    target: { x: r, y: o },
    targetPosition: i,
    center: { x: a, y: l },
    offset: c
  });
  return [u.reduce((m, g, y) => {
    let v = "";
    return y > 0 && y < u.length - 1 ? v = Clt(u[y - 1], g, u[y + 1], s) : v = `${y === 0 ? "M" : "L"}${g.x} ${g.y}`, m += v, m;
  }, ""), d, f, h, p];
}
function SX(t) {
  return t && !!(t.internals.handleBounds || t.handles?.length) && !!(t.measured.width || t.width || t.initialWidth);
}
function klt(t) {
  const { sourceNode: e, targetNode: n } = t;
  if (!SX(e) || !SX(n))
    return null;
  const r = e.internals.handleBounds || OX(e.handles), o = n.internals.handleBounds || OX(n.handles), i = CX(r?.source ?? [], t.sourceHandle), s = CX(
    // when connection type is loose we can define all handles as sources and connect source -> source
    t.connectionMode === cp.Strict ? o?.target ?? [] : (o?.target ?? []).concat(o?.source ?? []),
    t.targetHandle
  );
  if (!i || !s)
    return t.onError?.("008", cs.error008(i ? "target" : "source", {
      id: t.id,
      sourceHandle: t.sourceHandle,
      targetHandle: t.targetHandle
    })), null;
  const a = i?.position || pt.Bottom, l = s?.position || pt.Top, c = $y(e, i, a), u = $y(n, s, l);
  return {
    sourceX: c.x,
    sourceY: c.y,
    targetX: u.x,
    targetY: u.y,
    sourcePosition: a,
    targetPosition: l
  };
}
function OX(t) {
  if (!t)
    return null;
  const e = [], n = [];
  for (const r of t)
    r.width = r.width ?? 1, r.height = r.height ?? 1, r.type === "source" ? e.push(r) : r.type === "target" && n.push(r);
  return {
    source: e,
    target: n
  };
}
function $y(t, e, n = pt.Left, r = !1) {
  const o = (e?.x ?? 0) + t.internals.positionAbsolute.x, i = (e?.y ?? 0) + t.internals.positionAbsolute.y, { width: s, height: a } = e ?? Gl(t);
  if (r)
    return { x: o + s / 2, y: i + a / 2 };
  switch (e?.position ?? n) {
    case pt.Top:
      return { x: o + s / 2, y: i };
    case pt.Right:
      return { x: o + s, y: i + a / 2 };
    case pt.Bottom:
      return { x: o + s / 2, y: i + a };
    case pt.Left:
      return { x: o, y: i + a / 2 };
  }
}
function CX(t, e) {
  return t && (e ? t.find((n) => n.id === e) : t[0]) || null;
}
function Pj(t, e) {
  return t ? typeof t == "string" ? t : `${e ? `${e}__` : ""}${Object.keys(t).sort().map((n) => `${n}=${t[n]}`).join("&")}` : "";
}
function Alt(t, { id: e, defaultColor: n, defaultMarkerStart: r, defaultMarkerEnd: o }) {
  const i = /* @__PURE__ */ new Set();
  return t.reduce((s, a) => ([a.markerStart || r, a.markerEnd || o].forEach((l) => {
    if (l && typeof l == "object") {
      const c = Pj(l, e);
      i.has(c) || (s.push({ id: c, color: l.color || n, ...l }), i.add(c));
    }
  }), s), []).sort((s, a) => s.id.localeCompare(a.id));
}
const B4 = {
  nodeOrigin: [0, 0],
  nodeExtent: Ty,
  elevateNodesOnSelect: !0,
  defaults: {}
}, Tlt = {
  ...B4,
  checkEquality: !0
};
function z4(t, e) {
  const n = { ...t };
  for (const r in e)
    e[r] !== void 0 && (n[r] = e[r]);
  return n;
}
function Rlt(t, e, n) {
  const r = z4(B4, n);
  for (const o of t.values())
    if (o.parentId)
      q4(o, t, e, r);
    else {
      const i = $v(o, r.nodeOrigin), s = fp(o.extent) ? o.extent : r.nodeExtent, a = Bd(i, s, Gl(o));
      o.internals.positionAbsolute = a;
    }
}
function $j(t, e, n, r) {
  const o = z4(Tlt, r), i = new Map(e), s = o?.elevateNodesOnSelect ? 1e3 : 0;
  e.clear(), n.clear();
  for (const a of t) {
    let l = i.get(a.id);
    if (o.checkEquality && a === l?.internals.userNode)
      e.set(a.id, l);
    else {
      const c = $v(a, o.nodeOrigin), u = fp(a.extent) ? a.extent : o.nodeExtent, d = Bd(c, u, Gl(a));
      l = {
        ...o.defaults,
        ...a,
        measured: {
          width: a.measured?.width,
          height: a.measured?.height
        },
        internals: {
          positionAbsolute: d,
          // if user re-initializes the node or removes `measured` for whatever reason, we reset the handleBounds so that the node gets re-measured
          handleBounds: a.measured ? l?.internals.handleBounds : void 0,
          z: tye(a, s),
          userNode: a
        }
      }, e.set(a.id, l);
    }
    a.parentId && q4(l, e, n, r);
  }
}
function Plt(t, e) {
  if (!t.parentId)
    return;
  const n = e.get(t.parentId);
  n ? n.set(t.id, t) : e.set(t.parentId, /* @__PURE__ */ new Map([[t.id, t]]));
}
function q4(t, e, n, r) {
  const { elevateNodesOnSelect: o, nodeOrigin: i, nodeExtent: s } = z4(B4, r), a = t.parentId, l = e.get(a);
  if (!l) {
    console.warn(`Parent node ${a} not found. Please make sure that parent nodes are in front of their child nodes in the nodes array.`);
    return;
  }
  Plt(t, n);
  const c = o ? 1e3 : 0, { x: u, y: d, z: f } = $lt(t, l, i, s, c), { positionAbsolute: h } = t.internals, p = u !== h.x || d !== h.y;
  (p || f !== t.internals.z) && e.set(t.id, {
    ...t,
    internals: {
      ...t.internals,
      positionAbsolute: p ? { x: u, y: d } : h,
      z: f
    }
  });
}
function tye(t, e) {
  return (Ss(t.zIndex) ? t.zIndex : 0) + (t.selected ? e : 0);
}
function $lt(t, e, n, r, o) {
  const { x: i, y: s } = e.internals.positionAbsolute, a = Gl(t), l = $v(t, n), c = fp(t.extent) ? Bd(l, t.extent, a) : l;
  let u = Bd({ x: i + c.x, y: s + c.y }, r, a);
  t.extent === "parent" && (u = q0e(u, a, e));
  const d = tye(t, o), f = e.internals.z ?? 0;
  return {
    x: u.x,
    y: u.y,
    z: f > d ? f : d
  };
}
function U4(t, e, n, r = [0, 0]) {
  const o = [], i = /* @__PURE__ */ new Map();
  for (const s of t) {
    const a = e.get(s.parentId);
    if (!a)
      continue;
    const l = i.get(s.parentId)?.expandedRect ?? dp(a), c = H0e(l, s.rect);
    i.set(s.parentId, { expandedRect: c, parent: a });
  }
  return i.size > 0 && i.forEach(({ expandedRect: s, parent: a }, l) => {
    const c = a.internals.positionAbsolute, u = Gl(a), d = a.origin ?? r, f = s.x < c.x ? Math.round(Math.abs(c.x - s.x)) : 0, h = s.y < c.y ? Math.round(Math.abs(c.y - s.y)) : 0, p = Math.max(u.width, Math.round(s.width)), m = Math.max(u.height, Math.round(s.height)), g = (p - u.width) * d[0], y = (m - u.height) * d[1];
    (f > 0 || h > 0 || g || y) && (o.push({
      id: l,
      type: "position",
      position: {
        x: a.position.x - f + g,
        y: a.position.y - h + y
      }
    }), n.get(l)?.forEach((v) => {
      t.some((b) => b.id === v.id) || o.push({
        id: v.id,
        type: "position",
        position: {
          x: v.position.x + f,
          y: v.position.y + h
        }
      });
    })), (u.width < s.width || u.height < s.height || f || h) && o.push({
      id: l,
      type: "dimensions",
      setAttributes: !0,
      dimensions: {
        width: p + (f ? d[0] * f - g : 0),
        height: m + (h ? d[1] * h - y : 0)
      }
    });
  }), o;
}
function Mlt(t, e, n, r, o, i) {
  const s = r?.querySelector(".xyflow__viewport");
  let a = !1;
  if (!s)
    return { changes: [], updatedInternals: a };
  const l = [], c = window.getComputedStyle(s), { m22: u } = new window.DOMMatrixReadOnly(c.transform), d = [];
  for (const f of t.values()) {
    const h = e.get(f.id);
    if (!h)
      continue;
    if (h.hidden) {
      e.set(h.id, {
        ...h,
        internals: {
          ...h.internals,
          handleBounds: void 0
        }
      }), a = !0;
      continue;
    }
    const p = cO(f.nodeElement), m = h.measured.width !== p.width || h.measured.height !== p.height;
    if (p.width && p.height && (m || !h.internals.handleBounds || f.force)) {
      const g = f.nodeElement.getBoundingClientRect(), y = fp(h.extent) ? h.extent : i;
      let { positionAbsolute: v } = h.internals;
      h.parentId && h.extent === "parent" ? v = q0e(v, p, e.get(h.parentId)) : y && (v = Bd(v, y, p));
      const b = {
        ...h,
        measured: p,
        internals: {
          ...h.internals,
          positionAbsolute: v,
          handleBounds: {
            source: _X("source", f.nodeElement, g, u, h.id),
            target: _X("target", f.nodeElement, g, u, h.id)
          }
        }
      };
      e.set(h.id, b), h.parentId && q4(b, e, n, { nodeOrigin: o }), a = !0, m && (l.push({
        id: h.id,
        type: "dimensions",
        dimensions: p
      }), h.expandParent && h.parentId && d.push({
        id: h.id,
        parentId: h.parentId,
        rect: dp(b, o)
      }));
    }
  }
  if (d.length > 0) {
    const f = U4(d, e, n, o);
    l.push(...f);
  }
  return { changes: l, updatedInternals: a };
}
async function Dlt({ delta: t, panZoom: e, transform: n, translateExtent: r, width: o, height: i }) {
  if (!e || !t.x && !t.y)
    return Promise.resolve(!1);
  const s = await e.setViewportConstrained({
    x: n[0] + t.x,
    y: n[1] + t.y,
    zoom: n[2]
  }, [
    [0, 0],
    [o, i]
  ], r), a = !!s && (s.x !== n[0] || s.y !== n[1] || s.k !== n[2]);
  return Promise.resolve(a);
}
function kX(t, e, n, r, o, i) {
  let s = o;
  const a = r.get(s) || /* @__PURE__ */ new Map();
  r.set(s, a.set(n, e)), s = `${o}-${t}`;
  const l = r.get(s) || /* @__PURE__ */ new Map();
  if (r.set(s, l.set(n, e)), i) {
    s = `${o}-${t}-${i}`;
    const c = r.get(s) || /* @__PURE__ */ new Map();
    r.set(s, c.set(n, e));
  }
}
function nye(t, e, n) {
  t.clear(), e.clear();
  for (const r of n) {
    const { source: o, target: i, sourceHandle: s = null, targetHandle: a = null } = r, l = { edgeId: r.id, source: o, target: i, sourceHandle: s, targetHandle: a }, c = `${o}-${s}--${i}-${a}`, u = `${i}-${a}--${o}-${s}`;
    kX("source", l, u, t, o, s), kX("target", l, c, t, i, a), e.set(r.id, r);
  }
}
function rye(t, e) {
  if (!t.parentId)
    return !1;
  const n = e.get(t.parentId);
  return n ? n.selected ? !0 : rye(n, e) : !1;
}
function AX(t, e, n) {
  let r = t;
  do {
    if (r?.matches?.(e))
      return !0;
    if (r === n)
      return !1;
    r = r?.parentElement;
  } while (r);
  return !1;
}
function Ilt(t, e, n, r) {
  const o = /* @__PURE__ */ new Map();
  for (const [i, s] of t)
    if ((s.selected || s.id === r) && (!s.parentId || !rye(s, t)) && (s.draggable || e && typeof s.draggable > "u")) {
      const a = t.get(i);
      a && o.set(i, {
        id: i,
        position: a.position || { x: 0, y: 0 },
        distance: {
          x: n.x - a.internals.positionAbsolute.x,
          y: n.y - a.internals.positionAbsolute.y
        },
        extent: a.extent,
        parentId: a.parentId,
        origin: a.origin,
        expandParent: a.expandParent,
        internals: {
          positionAbsolute: a.internals.positionAbsolute || { x: 0, y: 0 }
        },
        measured: {
          width: a.measured.width ?? 0,
          height: a.measured.height ?? 0
        }
      });
    }
  return o;
}
function ZA({ nodeId: t, dragItems: e, nodeLookup: n, dragging: r = !0 }) {
  const o = [];
  for (const [s, a] of e) {
    const l = n.get(s)?.internals.userNode;
    l && o.push({
      ...l,
      position: a.position,
      dragging: r
    });
  }
  if (!t)
    return [o[0], o];
  const i = n.get(t)?.internals.userNode;
  return [
    i ? {
      ...i,
      position: e.get(t)?.position || i.position,
      dragging: r
    } : o[0],
    o
  ];
}
function Nlt({ onNodeMouseDown: t, getStoreItems: e, onDragStart: n, onDrag: r, onDragStop: o }) {
  let i = { x: null, y: null }, s = 0, a = /* @__PURE__ */ new Map(), l = !1, c = { x: 0, y: 0 }, u = null, d = !1, f = null, h = !1;
  function p({ noDragClassName: g, handleSelector: y, domNode: v, isSelectable: b, nodeId: _, nodeClickDistance: w = 0 }) {
    f = vi(v);
    function x({ x: R, y: P }, N) {
      const { nodeLookup: A, nodeExtent: O, snapGrid: k, snapToGrid: T, nodeOrigin: I, onNodeDrag: j, onSelectionDrag: z, onError: $, updateNodePositions: D } = e();
      i = { x: R, y: P };
      let U = !1, q = { x: 0, y: 0, x2: 0, y2: 0 };
      if (a.size > 1 && O) {
        const F = Mv(a);
        q = Aj(F);
      }
      for (const [F, B] of a) {
        if (!A.has(F))
          continue;
        let H = { x: R - B.distance.x, y: P - B.distance.y };
        T && (H = lO(H, k));
        let Z = [
          [O[0][0], O[0][1]],
          [O[1][0], O[1][1]]
        ];
        if (a.size > 1 && O && !B.extent) {
          const { positionAbsolute: ee } = B.internals, Y = ee.x - q.x + O[0][0], L = ee.x + B.measured.width - q.x2 + O[1][0], V = ee.y - q.y + O[0][1], K = ee.y + B.measured.height - q.y2 + O[1][1];
          Z = [
            [Y, V],
            [L, K]
          ];
        }
        const { position: W, positionAbsolute: G } = z0e({
          nodeId: F,
          nextPosition: H,
          nodeLookup: A,
          nodeExtent: Z,
          nodeOrigin: I,
          onError: $
        });
        U = U || B.position.x !== W.x || B.position.y !== W.y, B.position = W, B.internals.positionAbsolute = G;
      }
      if (U && (D(a, !0), N && (r || j || !_ && z))) {
        const [F, B] = ZA({
          nodeId: _,
          dragItems: a,
          nodeLookup: A
        });
        r?.(N, a, F, B), j?.(N, F, B), _ || z?.(N, B);
      }
    }
    async function E() {
      if (!u)
        return;
      const { transform: R, panBy: P, autoPanSpeed: N } = e(), [A, O] = U0e(c, u, N);
      (A !== 0 || O !== 0) && (i.x = (i.x ?? 0) - A / R[2], i.y = (i.y ?? 0) - O / R[2], await P({ x: A, y: O }) && x(i, null)), s = requestAnimationFrame(E);
    }
    function S(R) {
      const { nodeLookup: P, multiSelectionActive: N, nodesDraggable: A, transform: O, snapGrid: k, snapToGrid: T, selectNodesOnDrag: I, onNodeDragStart: j, onSelectionDragStart: z, unselectNodesAndEdges: $ } = e();
      d = !0, (!I || !b) && !N && _ && (P.get(_)?.selected || $()), b && I && _ && t?.(_);
      const D = f0(R.sourceEvent, { transform: O, snapGrid: k, snapToGrid: T, containerBounds: u });
      if (i = D, a = Ilt(P, A, D, _), a.size > 0 && (n || j || !_ && z)) {
        const [U, q] = ZA({
          nodeId: _,
          dragItems: a,
          nodeLookup: P
        });
        n?.(R.sourceEvent, a, U, q), j?.(R.sourceEvent, U, q), _ || z?.(R.sourceEvent, q);
      }
    }
    const C = b0e().clickDistance(w).on("start", (R) => {
      const { domNode: P, nodeDragThreshold: N, transform: A, snapGrid: O, snapToGrid: k } = e();
      u = P?.getBoundingClientRect() || null, h = !1, N === 0 && S(R), i = f0(R.sourceEvent, { transform: A, snapGrid: O, snapToGrid: k, containerBounds: u }), c = Tl(R.sourceEvent, u);
    }).on("drag", (R) => {
      const { autoPanOnNodeDrag: P, transform: N, snapGrid: A, snapToGrid: O, nodeDragThreshold: k, nodeLookup: T } = e(), I = f0(R.sourceEvent, { transform: N, snapGrid: A, snapToGrid: O, containerBounds: u });
      if ((R.sourceEvent.type === "touchmove" && R.sourceEvent.touches.length > 1 || // if user deletes a node while dragging, we need to abort the drag to prevent errors
      _ && !T.has(_)) && (h = !0), !h) {
        if (!l && P && d && (l = !0, E()), !d) {
          const j = I.xSnapped - (i.x ?? 0), z = I.ySnapped - (i.y ?? 0);
          Math.sqrt(j * j + z * z) > k && S(R);
        }
        (i.x !== I.xSnapped || i.y !== I.ySnapped) && a && d && (c = Tl(R.sourceEvent, u), x(I, R.sourceEvent));
      }
    }).on("end", (R) => {
      if (!(!d || h) && (l = !1, d = !1, cancelAnimationFrame(s), a.size > 0)) {
        const { nodeLookup: P, updateNodePositions: N, onNodeDragStop: A, onSelectionDragStop: O } = e();
        if (N(a, !1), o || A || !_ && O) {
          const [k, T] = ZA({
            nodeId: _,
            dragItems: a,
            nodeLookup: P,
            dragging: !1
          });
          o?.(R.sourceEvent, a, k, T), A?.(R.sourceEvent, k, T), _ || O?.(R.sourceEvent, T);
        }
      }
    }).filter((R) => {
      const P = R.target;
      return !R.button && (!g || !AX(P, `.${g}`, v)) && (!y || AX(P, y, v));
    });
    f.call(C);
  }
  function m() {
    f?.on(".drag", null);
  }
  return {
    update: p,
    destroy: m
  };
}
function jlt(t, e, n) {
  const r = [], o = {
    x: t.x - n,
    y: t.y - n,
    width: n * 2,
    height: n * 2
  };
  for (const i of e.values())
    Py(o, dp(i)) > 0 && r.push(i);
  return r;
}
const Llt = 250;
function Flt(t, e, n, r) {
  let o = [], i = 1 / 0;
  const s = jlt(t, n, e + Llt);
  for (const a of s) {
    const l = [...a.internals.handleBounds?.source ?? [], ...a.internals.handleBounds?.target ?? []];
    for (const c of l) {
      if (r.nodeId === c.nodeId && r.type === c.type && r.id === c.id)
        continue;
      const { x: u, y: d } = $y(a, c, c.position, !0), f = Math.sqrt(Math.pow(u - t.x, 2) + Math.pow(d - t.y, 2));
      f > e || (f < i ? (o = [{ ...c, x: u, y: d }], i = f) : f === i && o.push({ ...c, x: u, y: d }));
    }
  }
  if (!o.length)
    return null;
  if (o.length > 1) {
    const a = r.type === "source" ? "target" : "source";
    return o.find((l) => l.type === a) ?? o[0];
  }
  return o[0];
}
function oye(t, e, n, r, o, i = !1) {
  const s = r.get(t);
  if (!s)
    return null;
  const a = o === "strict" ? s.internals.handleBounds?.[e] : [...s.internals.handleBounds?.source ?? [], ...s.internals.handleBounds?.target ?? []], l = (n ? a?.find((c) => c.id === n) : a?.[0]) ?? null;
  return l && i ? { ...l, ...$y(s, l, l.position, !0) } : l;
}
function iye(t, e) {
  return t || (e?.classList.contains("target") ? "target" : e?.classList.contains("source") ? "source" : null);
}
function Blt(t, e) {
  let n = null;
  return e ? n = !0 : t && !e && (n = !1), n;
}
const sye = () => !0;
function zlt(t, { connectionMode: e, connectionRadius: n, handleId: r, nodeId: o, edgeUpdaterType: i, isTarget: s, domNode: a, nodeLookup: l, lib: c, autoPanOnConnect: u, flowId: d, panBy: f, cancelConnection: h, onConnectStart: p, onConnect: m, onConnectEnd: g, isValidConnection: y = sye, onReconnectEnd: v, updateConnection: b, getTransform: _, getFromHandle: w, autoPanSpeed: x }) {
  const E = K0e(t.target);
  let S = 0, C;
  const { x: R, y: P } = Tl(t), N = E?.elementFromPoint(R, P), A = iye(i, N), O = a?.getBoundingClientRect();
  if (!O || !A)
    return;
  const k = oye(o, A, r, l, e);
  if (!k)
    return;
  let T = Tl(t, O), I = !1, j = null, z = !1, $ = null;
  function D() {
    if (!u || !O)
      return;
    const [W, G] = U0e(T, O, x);
    f({ x: W, y: G }), S = requestAnimationFrame(D);
  }
  const U = {
    ...k,
    nodeId: o,
    type: A,
    position: k.position
  }, q = l.get(o), F = {
    inProgress: !0,
    isValid: null,
    from: $y(q, U, pt.Left, !0),
    fromHandle: U,
    fromPosition: U.position,
    fromNode: q,
    to: T,
    toHandle: null,
    toPosition: gX[U.position],
    toNode: null
  };
  b(F);
  let B = F;
  p?.(t, { nodeId: o, handleId: r, handleType: A });
  function H(W) {
    if (!w() || !U) {
      Z(W);
      return;
    }
    const G = _();
    T = Tl(W, O), C = Flt(Dv(T, G, !1, [1, 1]), n, l, U), I || (D(), I = !0);
    const ee = aye(W, {
      handle: C,
      connectionMode: e,
      fromNodeId: o,
      fromHandleId: r,
      fromType: s ? "target" : "source",
      isValidConnection: y,
      doc: E,
      lib: c,
      flowId: d,
      nodeLookup: l
    });
    $ = ee.handleDomNode, j = ee.connection, z = Blt(!!C, ee.isValid);
    const Y = {
      // from stays the same
      ...B,
      isValid: z,
      to: C && z ? W0e({ x: C.x, y: C.y }, G) : T,
      toHandle: ee.toHandle,
      toPosition: z && ee.toHandle ? ee.toHandle.position : gX[U.position],
      toNode: ee.toHandle ? l.get(ee.toHandle.nodeId) : null
    };
    z && C && B.toHandle && Y.toHandle && B.toHandle.type === Y.toHandle.type && B.toHandle.nodeId === Y.toHandle.nodeId && B.toHandle.id === Y.toHandle.id && B.to.x === Y.to.x && B.to.y === Y.to.y || (b(Y), B = Y);
  }
  function Z(W) {
    (C || $) && j && z && m?.(j);
    const { inProgress: G, ...ee } = B, Y = {
      ...ee,
      toPosition: B.toHandle ? B.toPosition : null
    };
    g?.(W, Y), i && v?.(W, Y), h(), cancelAnimationFrame(S), I = !1, z = !1, j = null, $ = null, E.removeEventListener("mousemove", H), E.removeEventListener("mouseup", Z), E.removeEventListener("touchmove", H), E.removeEventListener("touchend", Z);
  }
  E.addEventListener("mousemove", H), E.addEventListener("mouseup", Z), E.addEventListener("touchmove", H), E.addEventListener("touchend", Z);
}
function aye(t, { handle: e, connectionMode: n, fromNodeId: r, fromHandleId: o, fromType: i, doc: s, lib: a, flowId: l, isValidConnection: c = sye, nodeLookup: u }) {
  const d = i === "target", f = e ? s.querySelector(`.${a}-flow__handle[data-id="${l}-${e?.nodeId}-${e?.id}-${e?.type}"]`) : null, { x: h, y: p } = Tl(t), m = s.elementFromPoint(h, p), g = m?.classList.contains(`${a}-flow__handle`) ? m : f, y = {
    handleDomNode: g,
    isValid: !1,
    connection: null,
    toHandle: null
  };
  if (g) {
    const v = iye(void 0, g), b = g.getAttribute("data-nodeid"), _ = g.getAttribute("data-handleid"), w = g.classList.contains("connectable"), x = g.classList.contains("connectableend");
    if (!b || !v)
      return y;
    const E = {
      source: d ? b : r,
      sourceHandle: d ? _ : o,
      target: d ? r : b,
      targetHandle: d ? o : _
    };
    y.connection = E;
    const S = w && x && (n === cp.Strict ? d && v === "source" || !d && v === "target" : b !== r || _ !== o);
    y.isValid = S && c(E), y.toHandle = oye(b, v, _, u, n, !1);
  }
  return y;
}
const Mj = {
  onPointerDown: zlt,
  isValid: aye
};
function qlt({ domNode: t, panZoom: e, getTransform: n, getViewScale: r }) {
  const o = vi(t);
  function i({ translateExtent: a, width: l, height: c, zoomStep: u = 10, pannable: d = !0, zoomable: f = !0, inversePan: h = !1 }) {
    const p = (b) => {
      const _ = n();
      if (b.sourceEvent.type !== "wheel" || !e)
        return;
      const w = -b.sourceEvent.deltaY * (b.sourceEvent.deltaMode === 1 ? 0.05 : b.sourceEvent.deltaMode ? 1 : 2e-3) * u, x = _[2] * Math.pow(2, w);
      e.scaleTo(x);
    };
    let m = [0, 0];
    const g = (b) => {
      (b.sourceEvent.type === "mousedown" || b.sourceEvent.type === "touchstart") && (m = [
        b.sourceEvent.clientX ?? b.sourceEvent.touches[0].clientX,
        b.sourceEvent.clientY ?? b.sourceEvent.touches[0].clientY
      ]);
    }, y = (b) => {
      const _ = n();
      if (b.sourceEvent.type !== "mousemove" && b.sourceEvent.type !== "touchmove" || !e)
        return;
      const w = [
        b.sourceEvent.clientX ?? b.sourceEvent.touches[0].clientX,
        b.sourceEvent.clientY ?? b.sourceEvent.touches[0].clientY
      ], x = [w[0] - m[0], w[1] - m[1]];
      m = w;
      const E = r() * Math.max(_[2], Math.log(_[2])) * (h ? -1 : 1), S = {
        x: _[0] - x[0] * E,
        y: _[1] - x[1] * E
      }, C = [
        [0, 0],
        [l, c]
      ];
      e.setViewportConstrained({
        x: S.x,
        y: S.y,
        zoom: _[2]
      }, C, a);
    }, v = I0e().on("start", g).on("zoom", d ? y : null).on("zoom.wheel", f ? p : null);
    o.call(v, {});
  }
  function s() {
    o.on("zoom", null);
  }
  return {
    update: i,
    destroy: s,
    pointer: vs
  };
}
const Ult = (t, e) => t.x !== e.x || t.y !== e.y || t.zoom !== e.k, uO = (t) => ({
  x: t.x,
  y: t.y,
  zoom: t.k
}), JA = ({ x: t, y: e, zoom: n }) => iO.translate(t, e).scale(n), th = (t, e) => t.target.closest(`.${e}`), lye = (t, e) => e === 2 && Array.isArray(t) && t.includes(2), eT = (t, e = 0, n = () => {
}) => {
  const r = typeof e == "number" && e > 0;
  return r || n(), r ? t.transition().duration(e).on("end", n) : t;
}, cye = (t) => {
  const e = t.ctrlKey && bE() ? 10 : 1;
  return -t.deltaY * (t.deltaMode === 1 ? 0.05 : t.deltaMode ? 1 : 2e-3) * e;
};
function Hlt({ zoomPanValues: t, noWheelClassName: e, d3Selection: n, d3Zoom: r, panOnScrollMode: o, panOnScrollSpeed: i, zoomOnPinch: s, onPanZoomStart: a, onPanZoom: l, onPanZoomEnd: c }) {
  return (u) => {
    if (th(u, e))
      return !1;
    u.preventDefault(), u.stopImmediatePropagation();
    const d = n.property("__zoom").k || 1;
    if (u.ctrlKey && s) {
      const g = vs(u), y = cye(u), v = d * Math.pow(2, y);
      r.scaleTo(n, v, g, u);
      return;
    }
    const f = u.deltaMode === 1 ? 20 : 1;
    let h = o === Ed.Vertical ? 0 : u.deltaX * f, p = o === Ed.Horizontal ? 0 : u.deltaY * f;
    !bE() && u.shiftKey && o !== Ed.Vertical && (h = u.deltaY * f, p = 0), r.translateBy(
      n,
      -(h / d) * i,
      -(p / d) * i,
      // @ts-ignore
      { internal: !0 }
    );
    const m = uO(n.property("__zoom"));
    clearTimeout(t.panScrollTimeout), t.isPanScrolling || (t.isPanScrolling = !0, a?.(u, m)), t.isPanScrolling && (l?.(u, m), t.panScrollTimeout = setTimeout(() => {
      c?.(u, m), t.isPanScrolling = !1;
    }, 150));
  };
}
function Vlt({ noWheelClassName: t, preventScrolling: e, d3ZoomHandler: n }) {
  return function(r, o) {
    if (!e && r.type === "wheel" && !r.ctrlKey || th(r, t))
      return null;
    r.preventDefault(), n.call(this, r, o);
  };
}
function Wlt({ zoomPanValues: t, onDraggingChange: e, onPanZoomStart: n }) {
  return (r) => {
    if (r.sourceEvent?.internal)
      return;
    const o = uO(r.transform);
    t.mouseButton = r.sourceEvent?.button || 0, t.isZoomingOrPanning = !0, t.prevViewport = o, r.sourceEvent?.type === "mousedown" && e(!0), n && n?.(r.sourceEvent, o);
  };
}
function Glt({ zoomPanValues: t, panOnDrag: e, onPaneContextMenu: n, onTransformChange: r, onPanZoom: o }) {
  return (i) => {
    t.usedRightMouseButton = !!(n && lye(e, t.mouseButton ?? 0)), i.sourceEvent?.sync || r([i.transform.x, i.transform.y, i.transform.k]), o && !i.sourceEvent?.internal && o?.(i.sourceEvent, uO(i.transform));
  };
}
function Ylt({ zoomPanValues: t, panOnDrag: e, panOnScroll: n, onDraggingChange: r, onPanZoomEnd: o, onPaneContextMenu: i }) {
  return (s) => {
    if (!s.sourceEvent?.internal && (t.isZoomingOrPanning = !1, i && lye(e, t.mouseButton ?? 0) && !t.usedRightMouseButton && s.sourceEvent && i(s.sourceEvent), t.usedRightMouseButton = !1, r(!1), o && Ult(t.prevViewport, s.transform))) {
      const a = uO(s.transform);
      t.prevViewport = a, clearTimeout(t.timerId), t.timerId = setTimeout(
        () => {
          o?.(s.sourceEvent, a);
        },
        // we need a setTimeout for panOnScroll to supress multiple end events fired during scroll
        n ? 150 : 0
      );
    }
  };
}
function Klt({ zoomActivationKeyPressed: t, zoomOnScroll: e, zoomOnPinch: n, panOnDrag: r, panOnScroll: o, zoomOnDoubleClick: i, userSelectionActive: s, noWheelClassName: a, noPanClassName: l, lib: c }) {
  return (u) => {
    const d = t || e, f = n && u.ctrlKey;
    if (u.button === 1 && u.type === "mousedown" && (th(u, `${c}-flow__node`) || th(u, `${c}-flow__edge`)))
      return !0;
    if (!r && !d && !o && !i && !n || s || th(u, a) && u.type === "wheel" || th(u, l) && (u.type !== "wheel" || o && u.type === "wheel" && !t) || !n && u.ctrlKey && u.type === "wheel")
      return !1;
    if (!n && u.type === "touchstart" && u.touches?.length > 1)
      return u.preventDefault(), !1;
    if (!d && !o && !f && u.type === "wheel" || !r && (u.type === "mousedown" || u.type === "touchstart") || Array.isArray(r) && !r.includes(u.button) && u.type === "mousedown")
      return !1;
    const h = Array.isArray(r) && r.includes(u.button) || !u.button || u.button <= 1;
    return (!u.ctrlKey || u.type === "wheel") && h;
  };
}
function Xlt({ domNode: t, minZoom: e, maxZoom: n, paneClickDistance: r, translateExtent: o, viewport: i, onPanZoom: s, onPanZoomStart: a, onPanZoomEnd: l, onDraggingChange: c }) {
  const u = {
    isZoomingOrPanning: !1,
    usedRightMouseButton: !1,
    prevViewport: { x: 0, y: 0, zoom: 0 },
    mouseButton: 0,
    timerId: void 0,
    panScrollTimeout: void 0,
    isPanScrolling: !1
  }, d = t.getBoundingClientRect(), f = I0e().clickDistance(!Ss(r) || r < 0 ? 0 : r).scaleExtent([e, n]).translateExtent(o), h = vi(t).call(f);
  b({
    x: i.x,
    y: i.y,
    zoom: up(i.zoom, e, n)
  }, [
    [0, 0],
    [d.width, d.height]
  ], o);
  const p = h.on("wheel.zoom"), m = h.on("dblclick.zoom");
  f.wheelDelta(cye);
  function g(N, A) {
    return h ? new Promise((O) => {
      f?.transform(eT(h, A?.duration, () => O(!0)), N);
    }) : Promise.resolve(!1);
  }
  function y({ noWheelClassName: N, noPanClassName: A, onPaneContextMenu: O, userSelectionActive: k, panOnScroll: T, panOnDrag: I, panOnScrollMode: j, panOnScrollSpeed: z, preventScrolling: $, zoomOnPinch: D, zoomOnScroll: U, zoomOnDoubleClick: q, zoomActivationKeyPressed: F, lib: B, onTransformChange: H }) {
    k && !u.isZoomingOrPanning && v();
    const Z = T && !F && !k ? Hlt({
      zoomPanValues: u,
      noWheelClassName: N,
      d3Selection: h,
      d3Zoom: f,
      panOnScrollMode: j,
      panOnScrollSpeed: z,
      zoomOnPinch: D,
      onPanZoomStart: a,
      onPanZoom: s,
      onPanZoomEnd: l
    }) : Vlt({
      noWheelClassName: N,
      preventScrolling: $,
      d3ZoomHandler: p
    });
    if (h.on("wheel.zoom", Z, { passive: !1 }), !k) {
      const G = Wlt({
        zoomPanValues: u,
        onDraggingChange: c,
        onPanZoomStart: a
      });
      f.on("start", G);
      const ee = Glt({
        zoomPanValues: u,
        panOnDrag: I,
        onPaneContextMenu: !!O,
        onPanZoom: s,
        onTransformChange: H
      });
      f.on("zoom", ee);
      const Y = Ylt({
        zoomPanValues: u,
        panOnDrag: I,
        panOnScroll: T,
        onPaneContextMenu: O,
        onPanZoomEnd: l,
        onDraggingChange: c
      });
      f.on("end", Y);
    }
    const W = Klt({
      zoomActivationKeyPressed: F,
      panOnDrag: I,
      zoomOnScroll: U,
      panOnScroll: T,
      zoomOnDoubleClick: q,
      zoomOnPinch: D,
      userSelectionActive: k,
      noPanClassName: A,
      noWheelClassName: N,
      lib: B
    });
    f.filter(W), q ? h.on("dblclick.zoom", m) : h.on("dblclick.zoom", null);
  }
  function v() {
    f.on("zoom", null);
  }
  async function b(N, A, O) {
    const k = JA(N), T = f?.constrain()(k, A, O);
    return T && await g(T), new Promise((I) => I(T));
  }
  async function _(N, A) {
    const O = JA(N);
    return await g(O, A), new Promise((k) => k(O));
  }
  function w(N) {
    if (h) {
      const A = JA(N), O = h.property("__zoom");
      (O.k !== N.zoom || O.x !== N.x || O.y !== N.y) && f?.transform(h, A, null, { sync: !0 });
    }
  }
  function x() {
    const N = h ? D0e(h.node()) : { x: 0, y: 0, k: 1 };
    return { x: N.x, y: N.y, zoom: N.k };
  }
  function E(N, A) {
    return h ? new Promise((O) => {
      f?.scaleTo(eT(h, A?.duration, () => O(!0)), N);
    }) : Promise.resolve(!1);
  }
  function S(N, A) {
    return h ? new Promise((O) => {
      f?.scaleBy(eT(h, A?.duration, () => O(!0)), N);
    }) : Promise.resolve(!1);
  }
  function C(N) {
    f?.scaleExtent(N);
  }
  function R(N) {
    f?.translateExtent(N);
  }
  function P(N) {
    const A = !Ss(N) || N < 0 ? 0 : N;
    f?.clickDistance(A);
  }
  return {
    update: y,
    destroy: v,
    setViewport: _,
    setViewportConstrained: b,
    getViewport: x,
    scaleTo: E,
    scaleBy: S,
    setScaleExtent: C,
    setTranslateExtent: R,
    syncViewport: w,
    setClickDistance: P
  };
}
var h0;
(function(t) {
  t.Line = "line", t.Handle = "handle";
})(h0 || (h0 = {}));
function Qlt({ width: t, prevWidth: e, height: n, prevHeight: r, affectsX: o, affectsY: i }) {
  const s = t - e, a = n - r, l = [s > 0 ? 1 : s < 0 ? -1 : 0, a > 0 ? 1 : a < 0 ? -1 : 0];
  return s && o && (l[0] = l[0] * -1), a && i && (l[1] = l[1] * -1), l;
}
function Zlt(t) {
  const e = t.includes("right") || t.includes("left"), n = t.includes("bottom") || t.includes("top"), r = t.includes("left"), o = t.includes("top");
  return {
    isHorizontal: e,
    isVertical: n,
    affectsX: r,
    affectsY: o
  };
}
function oc(t, e) {
  return Math.max(0, e - t);
}
function ic(t, e) {
  return Math.max(0, t - e);
}
function A1(t, e, n) {
  return Math.max(0, e - t, t - n);
}
function TX(t, e) {
  return t ? !e : e;
}
function Jlt(t, e, n, r, o, i, s, a) {
  let { affectsX: l, affectsY: c } = e;
  const { isHorizontal: u, isVertical: d } = e, f = u && d, { xSnapped: h, ySnapped: p } = n, { minWidth: m, maxWidth: g, minHeight: y, maxHeight: v } = r, { x: b, y: _, width: w, height: x, aspectRatio: E } = t;
  let S = Math.floor(u ? h - t.pointerX : 0), C = Math.floor(d ? p - t.pointerY : 0);
  const R = w + (l ? -S : S), P = x + (c ? -C : C), N = -i[0] * w, A = -i[1] * x;
  let O = A1(R, m, g), k = A1(P, y, v);
  if (s) {
    let j = 0, z = 0;
    l && S < 0 ? j = oc(b + S + N, s[0][0]) : !l && S > 0 && (j = ic(b + R + N, s[1][0])), c && C < 0 ? z = oc(_ + C + A, s[0][1]) : !c && C > 0 && (z = ic(_ + P + A, s[1][1])), O = Math.max(O, j), k = Math.max(k, z);
  }
  if (a) {
    let j = 0, z = 0;
    l && S > 0 ? j = ic(b + S, a[0][0]) : !l && S < 0 && (j = oc(b + R, a[1][0])), c && C > 0 ? z = ic(_ + C, a[0][1]) : !c && C < 0 && (z = oc(_ + P, a[1][1])), O = Math.max(O, j), k = Math.max(k, z);
  }
  if (o) {
    if (u) {
      const j = A1(R / E, y, v) * E;
      if (O = Math.max(O, j), s) {
        let z = 0;
        !l && !c || l && !c && f ? z = ic(_ + A + R / E, s[1][1]) * E : z = oc(_ + A + (l ? S : -S) / E, s[0][1]) * E, O = Math.max(O, z);
      }
      if (a) {
        let z = 0;
        !l && !c || l && !c && f ? z = oc(_ + R / E, a[1][1]) * E : z = ic(_ + (l ? S : -S) / E, a[0][1]) * E, O = Math.max(O, z);
      }
    }
    if (d) {
      const j = A1(P * E, m, g) / E;
      if (k = Math.max(k, j), s) {
        let z = 0;
        !l && !c || c && !l && f ? z = ic(b + P * E + N, s[1][0]) / E : z = oc(b + (c ? C : -C) * E + N, s[0][0]) / E, k = Math.max(k, z);
      }
      if (a) {
        let z = 0;
        !l && !c || c && !l && f ? z = oc(b + P * E, a[1][0]) / E : z = ic(b + (c ? C : -C) * E, a[0][0]) / E, k = Math.max(k, z);
      }
    }
  }
  C = C + (C < 0 ? k : -k), S = S + (S < 0 ? O : -O), o && (f ? R > P * E ? C = (TX(l, c) ? -S : S) / E : S = (TX(l, c) ? -C : C) * E : u ? (C = S / E, c = l) : (S = C * E, l = c));
  const T = l ? b + S : b, I = c ? _ + C : _;
  return {
    width: w + (l ? -S : S),
    height: x + (c ? -C : C),
    x: i[0] * S * (l ? -1 : 1) + T,
    y: i[1] * C * (c ? -1 : 1) + I
  };
}
const uye = { width: 0, height: 0, x: 0, y: 0 }, ect = {
  ...uye,
  pointerX: 0,
  pointerY: 0,
  aspectRatio: 1
};
function tct(t) {
  return [
    [0, 0],
    [t.measured.width, t.measured.height]
  ];
}
function nct(t, e, n) {
  const r = e.position.x + t.position.x, o = e.position.y + t.position.y, i = t.measured.width ?? 0, s = t.measured.height ?? 0, a = n[0] * i, l = n[1] * s;
  return [
    [r - a, o - l],
    [r + i - a, o + s - l]
  ];
}
function rct({ domNode: t, nodeId: e, getStoreItems: n, onChange: r, onEnd: o }) {
  const i = vi(t);
  function s({ controlPosition: l, boundaries: c, keepAspectRatio: u, onResizeStart: d, onResize: f, onResizeEnd: h, shouldResize: p }) {
    let m = { ...uye }, g = { ...ect };
    const y = Zlt(l);
    let v, b = null, _ = [], w, x, E;
    const S = b0e().on("start", (C) => {
      const { nodeLookup: R, transform: P, snapGrid: N, snapToGrid: A, nodeOrigin: O, paneDomNode: k } = n();
      if (v = R.get(e), !v)
        return;
      b = k?.getBoundingClientRect() ?? null;
      const { xSnapped: T, ySnapped: I } = f0(C.sourceEvent, {
        transform: P,
        snapGrid: N,
        snapToGrid: A,
        containerBounds: b
      });
      m = {
        width: v.measured.width ?? 0,
        height: v.measured.height ?? 0,
        x: v.position.x ?? 0,
        y: v.position.y ?? 0
      }, g = {
        ...m,
        pointerX: T,
        pointerY: I,
        aspectRatio: m.width / m.height
      }, w = void 0, v.parentId && (v.extent === "parent" || v.expandParent) && (w = R.get(v.parentId), x = w && v.extent === "parent" ? tct(w) : void 0), _ = [], E = void 0;
      for (const [j, z] of R)
        if (z.parentId === e && (_.push({
          id: j,
          position: { ...z.position },
          extent: z.extent
        }), z.extent === "parent" || z.expandParent)) {
          const $ = nct(z, v, z.origin ?? O);
          E ? E = [
            [Math.min($[0][0], E[0][0]), Math.min($[0][1], E[0][1])],
            [Math.max($[1][0], E[1][0]), Math.max($[1][1], E[1][1])]
          ] : E = $;
        }
      d?.(C, { ...m });
    }).on("drag", (C) => {
      const { transform: R, snapGrid: P, snapToGrid: N, nodeOrigin: A } = n(), O = f0(C.sourceEvent, {
        transform: R,
        snapGrid: P,
        snapToGrid: N,
        containerBounds: b
      }), k = [];
      if (!v)
        return;
      const { x: T, y: I, width: j, height: z } = m, $ = {}, D = v.origin ?? A, { width: U, height: q, x: F, y: B } = Jlt(g, y, O, c, u, D, x, E), H = U !== j, Z = q !== z, W = F !== T && H, G = B !== I && Z;
      if (!W && !G && !H && !Z)
        return;
      if ((W || G || D[0] === 1 || D[1] === 1) && ($.x = W ? F : m.x, $.y = G ? B : m.y, m.x = $.x, m.y = $.y, _.length > 0)) {
        const L = F - T, V = B - I;
        for (const K of _)
          K.position = {
            x: K.position.x - L + D[0] * (U - j),
            y: K.position.y - V + D[1] * (q - z)
          }, k.push(K);
      }
      if ((H || Z) && ($.width = H ? U : m.width, $.height = Z ? q : m.height, m.width = $.width, m.height = $.height), w && v.expandParent) {
        const L = D[0] * ($.width ?? 0);
        $.x && $.x < L && (m.x = L, g.x = g.x - ($.x - L));
        const V = D[1] * ($.height ?? 0);
        $.y && $.y < V && (m.y = V, g.y = g.y - ($.y - V));
      }
      const ee = Qlt({
        width: m.width,
        prevWidth: j,
        height: m.height,
        prevHeight: z,
        affectsX: y.affectsX,
        affectsY: y.affectsY
      }), Y = { ...m, direction: ee };
      p?.(C, Y) !== !1 && (f?.(C, Y), r($, k));
    }).on("end", (C) => {
      h?.(C, { ...m }), o?.();
    });
    i.call(S);
  }
  function a() {
    i.on(".drag", null);
  }
  return {
    update: s,
    destroy: a
  };
}
var tT = { exports: {} }, nT = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var RX;
function oct() {
  if (RX) return nT;
  RX = 1;
  var t = xe, e = b5();
  function n(c, u) {
    return c === u && (c !== 0 || 1 / c === 1 / u) || c !== c && u !== u;
  }
  var r = typeof Object.is == "function" ? Object.is : n, o = e.useSyncExternalStore, i = t.useRef, s = t.useEffect, a = t.useMemo, l = t.useDebugValue;
  return nT.useSyncExternalStoreWithSelector = function(c, u, d, f, h) {
    var p = i(null);
    if (p.current === null) {
      var m = { hasValue: !1, value: null };
      p.current = m;
    } else m = p.current;
    p = a(
      function() {
        function y(x) {
          if (!v) {
            if (v = !0, b = x, x = f(x), h !== void 0 && m.hasValue) {
              var E = m.value;
              if (h(E, x))
                return _ = E;
            }
            return _ = x;
          }
          if (E = _, r(b, x)) return E;
          var S = f(x);
          return h !== void 0 && h(E, S) ? (b = x, E) : (b = x, _ = S);
        }
        var v = !1, b, _, w = d === void 0 ? null : d;
        return [
          function() {
            return y(u());
          },
          w === null ? void 0 : function() {
            return y(w());
          }
        ];
      },
      [u, d, f, h]
    );
    var g = o(c, p[0], p[1]);
    return s(
      function() {
        m.hasValue = !0, m.value = g;
      },
      [g]
    ), l(g), g;
  }, nT;
}
var PX = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var $X;
function ict() {
  return $X || ($X = 1, process.env.NODE_ENV !== "production" && function() {
    function t(c, u) {
      return c === u && (c !== 0 || 1 / c === 1 / u) || c !== c && u !== u;
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var e = xe, n = b5(), r = typeof Object.is == "function" ? Object.is : t, o = n.useSyncExternalStore, i = e.useRef, s = e.useEffect, a = e.useMemo, l = e.useDebugValue;
    PX.useSyncExternalStoreWithSelector = function(c, u, d, f, h) {
      var p = i(null);
      if (p.current === null) {
        var m = { hasValue: !1, value: null };
        p.current = m;
      } else m = p.current;
      p = a(
        function() {
          function y(x) {
            if (!v) {
              if (v = !0, b = x, x = f(x), h !== void 0 && m.hasValue) {
                var E = m.value;
                if (h(E, x))
                  return _ = E;
              }
              return _ = x;
            }
            if (E = _, r(b, x))
              return E;
            var S = f(x);
            return h !== void 0 && h(E, S) ? (b = x, E) : (b = x, _ = S);
          }
          var v = !1, b, _, w = d === void 0 ? null : d;
          return [
            function() {
              return y(u());
            },
            w === null ? void 0 : function() {
              return y(w());
            }
          ];
        },
        [u, d, f, h]
      );
      var g = o(c, p[0], p[1]);
      return s(
        function() {
          m.hasValue = !0, m.value = g;
        },
        [g]
      ), l(g), g;
    }, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }()), PX;
}
var MX;
function sct() {
  return MX || (MX = 1, process.env.NODE_ENV === "production" ? tT.exports = oct() : tT.exports = ict()), tT.exports;
}
var act = sct();
const lct = /* @__PURE__ */ bp(act), cct = {}, DX = (t) => {
  let e;
  const n = /* @__PURE__ */ new Set(), r = (a, l) => {
    const c = typeof a == "function" ? a(e) : a;
    if (!Object.is(c, e)) {
      const u = e;
      e = l ?? (typeof c != "object" || c === null) ? c : Object.assign({}, e, c), n.forEach((d) => d(e, u));
    }
  }, o = () => e, i = { setState: r, getState: o, getInitialState: () => s, subscribe: (a) => (n.add(a), () => n.delete(a)), destroy: () => {
    (cct ? "production" : void 0) !== "production" && console.warn(
      "[DEPRECATED] The `destroy` method will be unsupported in a future version. Instead use unsubscribe function returned by subscribe. Everything will be garbage-collected if store is garbage-collected."
    ), n.clear();
  } }, s = e = t(r, o, i);
  return i;
}, uct = (t) => t ? DX(t) : DX, { useDebugValue: dct } = xe, { useSyncExternalStoreWithSelector: fct } = lct, hct = (t) => t;
function dye(t, e = hct, n) {
  const r = fct(
    t.subscribe,
    t.getState,
    t.getServerState || t.getInitialState,
    e,
    n
  );
  return dct(r), r;
}
const IX = (t, e) => {
  const n = uct(t), r = (o, i = e) => dye(n, o, i);
  return Object.assign(r, n), r;
}, pct = (t, e) => t ? IX(t, e) : IX;
function pr(t, e) {
  if (Object.is(t, e))
    return !0;
  if (typeof t != "object" || t === null || typeof e != "object" || e === null)
    return !1;
  if (t instanceof Map && e instanceof Map) {
    if (t.size !== e.size) return !1;
    for (const [r, o] of t)
      if (!Object.is(o, e.get(r)))
        return !1;
    return !0;
  }
  if (t instanceof Set && e instanceof Set) {
    if (t.size !== e.size) return !1;
    for (const r of t)
      if (!e.has(r))
        return !1;
    return !0;
  }
  const n = Object.keys(t);
  if (n.length !== Object.keys(e).length)
    return !1;
  for (const r of n)
    if (!Object.prototype.hasOwnProperty.call(e, r) || !Object.is(t[r], e[r]))
      return !1;
  return !0;
}
const dO = lr(null), mct = dO.Provider, fye = cs.error001();
function Yt(t, e) {
  const n = Hn(dO);
  if (n === null)
    throw new Error(fye);
  return dye(n, t, e);
}
function ir() {
  const t = Hn(dO);
  if (t === null)
    throw new Error(fye);
  return cn(() => ({
    getState: t.getState,
    setState: t.setState,
    subscribe: t.subscribe
  }), [t]);
}
const NX = { display: "none" }, gct = {
  position: "absolute",
  width: 1,
  height: 1,
  margin: -1,
  border: 0,
  padding: 0,
  overflow: "hidden",
  clip: "rect(0px, 0px, 0px, 0px)",
  clipPath: "inset(100%)"
}, hye = "react-flow__node-desc", pye = "react-flow__edge-desc", yct = "react-flow__aria-live", vct = (t) => t.ariaLiveMessage;
function bct({ rfId: t }) {
  const e = Yt(vct);
  return M.jsx("div", { id: `${yct}-${t}`, "aria-live": "assertive", "aria-atomic": "true", style: gct, children: e });
}
function _ct({ rfId: t, disableKeyboardA11y: e }) {
  return M.jsxs(M.Fragment, { children: [M.jsxs("div", { id: `${hye}-${t}`, style: NX, children: ["Press enter or space to select a node.", !e && "You can then use the arrow keys to move the node around.", " Press delete to remove it and escape to cancel.", " "] }), M.jsx("div", { id: `${pye}-${t}`, style: NX, children: "Press enter or space to select an edge. You can then press delete to remove it or escape to cancel." }), !e && M.jsx(bct, { rfId: t })] });
}
const wct = (t) => t.userSelectionActive ? "none" : "all", H4 = Ri(({ position: t = "top-left", children: e, className: n, style: r, ...o }, i) => {
  const s = Yt(wct), a = `${t}`.split("-");
  return M.jsx("div", { className: Rr(["react-flow__panel", n, ...a]), style: { ...r, pointerEvents: s }, ref: i, ...o, children: e });
});
function xct({ proOptions: t, position: e = "bottom-right" }) {
  return t?.hideAttribution ? null : M.jsx(H4, { position: e, className: "react-flow__attribution", "data-message": "Please only hide this attribution when you are subscribed to React Flow Pro: https://pro.reactflow.dev", children: M.jsx("a", { href: "https://reactflow.dev", target: "_blank", rel: "noopener noreferrer", "aria-label": "React Flow attribution", children: "React Flow" }) });
}
const Ect = (t) => {
  const e = [], n = [];
  for (const [, r] of t.nodeLookup)
    r.selected && e.push(r.internals.userNode);
  for (const [, r] of t.edgeLookup)
    r.selected && n.push(r);
  return { selectedNodes: e, selectedEdges: n };
}, T1 = (t) => t.id;
function Sct(t, e) {
  return pr(t.selectedNodes.map(T1), e.selectedNodes.map(T1)) && pr(t.selectedEdges.map(T1), e.selectedEdges.map(T1));
}
function Oct({ onSelectionChange: t }) {
  const e = ir(), { selectedNodes: n, selectedEdges: r } = Yt(Ect, Sct);
  return Ne(() => {
    const o = { nodes: n, edges: r };
    t?.(o), e.getState().onSelectionChangeHandlers.forEach((i) => i(o));
  }, [n, r, t]), null;
}
const Cct = (t) => !!t.onSelectionChangeHandlers;
function kct({ onSelectionChange: t }) {
  const e = Yt(Cct);
  return t || e ? M.jsx(Oct, { onSelectionChange: t }) : null;
}
const mye = [0, 0], Act = { x: 0, y: 0, zoom: 1 }, Tct = [
  "nodes",
  "edges",
  "defaultNodes",
  "defaultEdges",
  "onConnect",
  "onConnectStart",
  "onConnectEnd",
  "onClickConnectStart",
  "onClickConnectEnd",
  "nodesDraggable",
  "nodesConnectable",
  "nodesFocusable",
  "edgesFocusable",
  "edgesReconnectable",
  "elevateNodesOnSelect",
  "elevateEdgesOnSelect",
  "minZoom",
  "maxZoom",
  "nodeExtent",
  "onNodesChange",
  "onEdgesChange",
  "elementsSelectable",
  "connectionMode",
  "snapGrid",
  "snapToGrid",
  "translateExtent",
  "connectOnClick",
  "defaultEdgeOptions",
  "fitView",
  "fitViewOptions",
  "onNodesDelete",
  "onEdgesDelete",
  "onDelete",
  "onNodeDrag",
  "onNodeDragStart",
  "onNodeDragStop",
  "onSelectionDrag",
  "onSelectionDragStart",
  "onSelectionDragStop",
  "onMoveStart",
  "onMove",
  "onMoveEnd",
  "noPanClassName",
  "nodeOrigin",
  "autoPanOnConnect",
  "autoPanOnNodeDrag",
  "onError",
  "connectionRadius",
  "isValidConnection",
  "selectNodesOnDrag",
  "nodeDragThreshold",
  "onBeforeDelete",
  "debug",
  "autoPanSpeed",
  "paneClickDistance"
], jX = [...Tct, "rfId"], Rct = (t) => ({
  setNodes: t.setNodes,
  setEdges: t.setEdges,
  setMinZoom: t.setMinZoom,
  setMaxZoom: t.setMaxZoom,
  setTranslateExtent: t.setTranslateExtent,
  setNodeExtent: t.setNodeExtent,
  reset: t.reset,
  setDefaultNodesAndEdges: t.setDefaultNodesAndEdges,
  setPaneClickDistance: t.setPaneClickDistance
}), LX = {
  // these are values that are also passed directly to other components
  // than the StoreUpdater. We can reduce the number of setStore calls
  // by setting the same values here as prev fields.
  translateExtent: Ty,
  nodeOrigin: mye,
  minZoom: 0.5,
  maxZoom: 2,
  elementsSelectable: !0,
  noPanClassName: "nopan",
  rfId: "1",
  paneClickDistance: 0
};
function Pct(t) {
  const { setNodes: e, setEdges: n, setMinZoom: r, setMaxZoom: o, setTranslateExtent: i, setNodeExtent: s, reset: a, setDefaultNodesAndEdges: l, setPaneClickDistance: c } = Yt(Rct, pr), u = ir();
  Ne(() => (l(t.defaultNodes, t.defaultEdges), () => {
    d.current = LX, a();
  }), []);
  const d = Ue(LX);
  return Ne(
    () => {
      for (const f of jX) {
        const h = t[f], p = d.current[f];
        h !== p && (typeof t[f] > "u" || (f === "nodes" ? e(h) : f === "edges" ? n(h) : f === "minZoom" ? r(h) : f === "maxZoom" ? o(h) : f === "translateExtent" ? i(h) : f === "nodeExtent" ? s(h) : f === "paneClickDistance" ? c(h) : f === "fitView" ? u.setState({ fitViewOnInit: h }) : f === "fitViewOptions" ? u.setState({ fitViewOnInitOptions: h }) : u.setState({ [f]: h })));
      }
      d.current = t;
    },
    // Only re-run the effect if one of the fields we track changes
    jX.map((f) => t[f])
  ), null;
}
function FX() {
  return typeof window > "u" || !window.matchMedia ? null : window.matchMedia("(prefers-color-scheme: dark)");
}
function $ct(t) {
  const [e, n] = Ye(t === "system" ? null : t);
  return Ne(() => {
    if (t !== "system") {
      n(t);
      return;
    }
    const r = FX(), o = () => n(r?.matches ? "dark" : "light");
    return o(), r?.addEventListener("change", o), () => {
      r?.removeEventListener("change", o);
    };
  }, [t]), e !== null ? e : FX()?.matches ? "dark" : "light";
}
const BX = typeof document < "u" ? document : null;
function My(t = null, e = { target: BX, actInsideInputWithModifier: !0 }) {
  const [n, r] = Ye(!1), o = Ue(!1), i = Ue(/* @__PURE__ */ new Set([])), [s, a] = cn(() => {
    if (t !== null) {
      const l = (Array.isArray(t) ? t : [t]).filter((u) => typeof u == "string").map((u) => u.replace("+", `
`).replace(`

`, `
+`).split(`
`)), c = l.reduce((u, d) => u.concat(...d), []);
      return [l, c];
    }
    return [[], []];
  }, [t]);
  return Ne(() => {
    const l = e?.target || BX;
    if (t !== null) {
      const c = (f) => {
        if (o.current = f.ctrlKey || f.metaKey || f.shiftKey, (!o.current || o.current && !e.actInsideInputWithModifier) && Tj(f))
          return !1;
        const h = qX(f.code, a);
        i.current.add(f[h]), zX(s, i.current, !1) && (f.preventDefault(), r(!0));
      }, u = (f) => {
        if ((!o.current || o.current && !e.actInsideInputWithModifier) && Tj(f))
          return !1;
        const h = qX(f.code, a);
        zX(s, i.current, !0) ? (r(!1), i.current.clear()) : i.current.delete(f[h]), f.key === "Meta" && i.current.clear(), o.current = !1;
      }, d = () => {
        i.current.clear(), r(!1);
      };
      return l?.addEventListener("keydown", c), l?.addEventListener("keyup", u), window.addEventListener("blur", d), window.addEventListener("contextmenu", d), () => {
        l?.removeEventListener("keydown", c), l?.removeEventListener("keyup", u), window.removeEventListener("blur", d), window.removeEventListener("contextmenu", d);
      };
    }
  }, [t, r]), n;
}
function zX(t, e, n) {
  return t.filter((r) => n || r.length === e.size).some((r) => r.every((o) => e.has(o)));
}
function qX(t, e) {
  return e.includes(t) ? "code" : "key";
}
const Mct = () => {
  const t = ir();
  return cn(() => ({
    zoomIn: (e) => {
      const { panZoom: n } = t.getState();
      return n ? n.scaleBy(1.2, { duration: e?.duration }) : Promise.resolve(!1);
    },
    zoomOut: (e) => {
      const { panZoom: n } = t.getState();
      return n ? n.scaleBy(1 / 1.2, { duration: e?.duration }) : Promise.resolve(!1);
    },
    zoomTo: (e, n) => {
      const { panZoom: r } = t.getState();
      return r ? r.scaleTo(e, { duration: n?.duration }) : Promise.resolve(!1);
    },
    getZoom: () => t.getState().transform[2],
    setViewport: async (e, n) => {
      const { transform: [r, o, i], panZoom: s } = t.getState();
      return s ? (await s.setViewport({
        x: e.x ?? r,
        y: e.y ?? o,
        zoom: e.zoom ?? i
      }, { duration: n?.duration }), Promise.resolve(!0)) : Promise.resolve(!1);
    },
    getViewport: () => {
      const [e, n, r] = t.getState().transform;
      return { x: e, y: n, zoom: r };
    },
    fitView: (e) => {
      const { nodeLookup: n, minZoom: r, maxZoom: o, panZoom: i, domNode: s } = t.getState();
      if (!i || !s)
        return Promise.resolve(!1);
      const a = Cj(n, e), { width: l, height: c } = cO(s);
      return kj({
        nodes: a,
        width: l,
        height: c,
        minZoom: r,
        maxZoom: o,
        panZoom: i
      }, e);
    },
    setCenter: async (e, n, r) => {
      const { width: o, height: i, maxZoom: s, panZoom: a } = t.getState(), l = typeof r?.zoom < "u" ? r.zoom : s, c = o / 2 - e * l, u = i / 2 - n * l;
      return a ? (await a.setViewport({
        x: c,
        y: u,
        zoom: l
      }, { duration: r?.duration }), Promise.resolve(!0)) : Promise.resolve(!1);
    },
    fitBounds: async (e, n) => {
      const { width: r, height: o, minZoom: i, maxZoom: s, panZoom: a } = t.getState(), l = F4(e, r, o, i, s, n?.padding ?? 0.1);
      return a ? (await a.setViewport(l, { duration: n?.duration }), Promise.resolve(!0)) : Promise.resolve(!1);
    },
    screenToFlowPosition: (e, n = { snapToGrid: !0 }) => {
      const { transform: r, snapGrid: o, domNode: i } = t.getState();
      if (!i)
        return e;
      const { x: s, y: a } = i.getBoundingClientRect(), l = {
        x: e.x - s,
        y: e.y - a
      };
      return Dv(l, r, n.snapToGrid, o);
    },
    flowToScreenPosition: (e) => {
      const { transform: n, domNode: r } = t.getState();
      if (!r)
        return e;
      const { x: o, y: i } = r.getBoundingClientRect(), s = W0e(e, n);
      return {
        x: s.x + o,
        y: s.y + i
      };
    }
  }), []);
};
function gye(t, e) {
  const n = [], r = /* @__PURE__ */ new Map(), o = [];
  for (const i of t)
    if (i.type === "add") {
      o.push(i);
      continue;
    } else if (i.type === "remove" || i.type === "replace")
      r.set(i.id, [i]);
    else {
      const s = r.get(i.id);
      s ? s.push(i) : r.set(i.id, [i]);
    }
  for (const i of e) {
    const s = r.get(i.id);
    if (!s) {
      n.push(i);
      continue;
    }
    if (s[0].type === "remove")
      continue;
    if (s[0].type === "replace") {
      n.push({ ...s[0].item });
      continue;
    }
    const a = { ...i };
    for (const l of s)
      Dct(l, a);
    n.push(a);
  }
  return o.length && o.forEach((i) => {
    i.index !== void 0 ? n.splice(i.index, 0, { ...i.item }) : n.push({ ...i.item });
  }), n;
}
function Dct(t, e) {
  switch (t.type) {
    case "select": {
      e.selected = t.selected;
      break;
    }
    case "position": {
      typeof t.position < "u" && (e.position = t.position), typeof t.dragging < "u" && (e.dragging = t.dragging);
      break;
    }
    case "dimensions": {
      typeof t.dimensions < "u" && (e.measured ??= {}, e.measured.width = t.dimensions.width, e.measured.height = t.dimensions.height, t.setAttributes && (e.width = t.dimensions.width, e.height = t.dimensions.height)), typeof t.resizing == "boolean" && (e.resizing = t.resizing);
      break;
    }
  }
}
function Ict(t, e) {
  return gye(t, e);
}
function Nct(t, e) {
  return gye(t, e);
}
function Uu(t, e) {
  return {
    id: t,
    type: "select",
    selected: e
  };
}
function nh(t, e = /* @__PURE__ */ new Set(), n = !1) {
  const r = [];
  for (const [o, i] of t) {
    const s = e.has(o);
    !(i.selected === void 0 && !s) && i.selected !== s && (n && (i.selected = s), r.push(Uu(i.id, s)));
  }
  return r;
}
function UX({ items: t = [], lookup: e }) {
  const n = [], r = new Map(t.map((o) => [o.id, o]));
  for (const [o, i] of t.entries()) {
    const s = e.get(i.id), a = s?.internals?.userNode ?? s;
    a !== void 0 && a !== i && n.push({ id: i.id, item: i, type: "replace" }), a === void 0 && n.push({ item: i, type: "add", index: o });
  }
  for (const [o] of e)
    r.get(o) === void 0 && n.push({ id: o, type: "remove" });
  return n;
}
function HX(t) {
  return {
    id: t.id,
    type: "remove"
  };
}
const VX = (t) => plt(t), jct = (t) => F0e(t);
function yye(t) {
  return Ri(t);
}
const Lct = typeof window < "u" ? iu : Ne;
function WX(t) {
  const [e, n] = Ye(BigInt(0)), [r] = Ye(() => Fct(() => n((o) => o + BigInt(1))));
  return Lct(() => {
    const o = r.get();
    o.length && (t(o), r.reset());
  }, [e]), r;
}
function Fct(t) {
  let e = [];
  return {
    get: () => e,
    reset: () => {
      e = [];
    },
    push: (n) => {
      e.push(n), t();
    }
  };
}
const vye = lr(null);
function Bct({ children: t }) {
  const e = ir(), n = Cn((a) => {
    const { nodes: l = [], setNodes: c, hasDefaultNodes: u, onNodesChange: d, nodeLookup: f } = e.getState();
    let h = l;
    for (const p of a)
      h = typeof p == "function" ? p(h) : p;
    u ? c(h) : d && d(UX({
      items: h,
      lookup: f
    }));
  }, []), r = WX(n), o = Cn((a) => {
    const { edges: l = [], setEdges: c, hasDefaultEdges: u, onEdgesChange: d, edgeLookup: f } = e.getState();
    let h = l;
    for (const p of a)
      h = typeof p == "function" ? p(h) : p;
    u ? c(h) : d && d(UX({
      items: h,
      lookup: f
    }));
  }, []), i = WX(o), s = cn(() => ({ nodeQueue: r, edgeQueue: i }), []);
  return M.jsx(vye.Provider, { value: s, children: t });
}
function zct() {
  const t = Hn(vye);
  if (!t)
    throw new Error("useBatchContext must be used within a BatchProvider");
  return t;
}
const qct = (t) => !!t.panZoom;
function V4() {
  const t = Mct(), e = ir(), n = zct(), r = Yt(qct), o = cn(() => {
    const i = (d) => e.getState().nodeLookup.get(d), s = (d) => {
      n.nodeQueue.push(d);
    }, a = (d) => {
      n.edgeQueue.push(d);
    }, l = (d) => {
      const { nodeLookup: f, nodeOrigin: h } = e.getState(), p = VX(d) ? d : f.get(d.id), m = p.parentId ? Y0e(p.position, p.measured, p.parentId, f, h) : p.position, g = {
        ...p,
        position: m,
        width: p.measured?.width ?? p.width,
        height: p.measured?.height ?? p.height
      };
      return dp(g);
    }, c = (d, f, h = { replace: !1 }) => {
      s((p) => p.map((m) => {
        if (m.id === d) {
          const g = typeof f == "function" ? f(m) : f;
          return h.replace && VX(g) ? g : { ...m, ...g };
        }
        return m;
      }));
    }, u = (d, f, h = { replace: !1 }) => {
      a((p) => p.map((m) => {
        if (m.id === d) {
          const g = typeof f == "function" ? f(m) : f;
          return h.replace && jct(g) ? g : { ...m, ...g };
        }
        return m;
      }));
    };
    return {
      getNodes: () => e.getState().nodes.map((d) => ({ ...d })),
      getNode: (d) => i(d)?.internals.userNode,
      getInternalNode: i,
      getEdges: () => {
        const { edges: d = [] } = e.getState();
        return d.map((f) => ({ ...f }));
      },
      getEdge: (d) => e.getState().edgeLookup.get(d),
      setNodes: s,
      setEdges: a,
      addNodes: (d) => {
        const f = Array.isArray(d) ? d : [d];
        n.nodeQueue.push((h) => [...h, ...f]);
      },
      addEdges: (d) => {
        const f = Array.isArray(d) ? d : [d];
        n.edgeQueue.push((h) => [...h, ...f]);
      },
      toObject: () => {
        const { nodes: d = [], edges: f = [], transform: h } = e.getState(), [p, m, g] = h;
        return {
          nodes: d.map((y) => ({ ...y })),
          edges: f.map((y) => ({ ...y })),
          viewport: {
            x: p,
            y: m,
            zoom: g
          }
        };
      },
      deleteElements: async ({ nodes: d = [], edges: f = [] }) => {
        const { nodes: h, edges: p, onNodesDelete: m, onEdgesDelete: g, triggerNodeChanges: y, triggerEdgeChanges: v, onDelete: b, onBeforeDelete: _ } = e.getState(), { nodes: w, edges: x } = await ylt({
          nodesToRemove: d,
          edgesToRemove: f,
          nodes: h,
          edges: p,
          onBeforeDelete: _
        }), E = x.length > 0, S = w.length > 0;
        if (E) {
          const C = x.map(HX);
          g?.(x), v(C);
        }
        if (S) {
          const C = w.map(HX);
          m?.(w), y(C);
        }
        return (S || E) && b?.({ nodes: w, edges: x }), { deletedNodes: w, deletedEdges: x };
      },
      getIntersectingNodes: (d, f = !0, h) => {
        const p = vX(d), m = p ? d : l(d), g = h !== void 0;
        return m ? (h || e.getState().nodes).filter((y) => {
          const v = e.getState().nodeLookup.get(y.id);
          if (v && !p && (y.id === d.id || !v.internals.positionAbsolute))
            return !1;
          const b = dp(g ? y : v), _ = Py(b, m);
          return f && _ > 0 || _ >= m.width * m.height;
        }) : [];
      },
      isNodeIntersecting: (d, f, h = !0) => {
        const p = vX(d) ? d : l(d);
        if (!p)
          return !1;
        const m = Py(p, f);
        return h && m > 0 || m >= p.width * p.height;
      },
      updateNode: c,
      updateNodeData: (d, f, h = { replace: !1 }) => {
        c(d, (p) => {
          const m = typeof f == "function" ? f(p) : f;
          return h.replace ? { ...p, data: m } : { ...p, data: { ...p.data, ...m } };
        }, h);
      },
      updateEdge: u,
      updateEdgeData: (d, f, h = { replace: !1 }) => {
        u(d, (p) => {
          const m = typeof f == "function" ? f(p) : f;
          return h.replace ? { ...p, data: m } : { ...p, data: { ...p.data, ...m } };
        }, h);
      },
      getNodesBounds: (d) => {
        const { nodeLookup: f, nodeOrigin: h } = e.getState();
        return mlt(d, { nodeLookup: f, nodeOrigin: h });
      },
      getHandleConnections: ({ type: d, id: f, nodeId: h }) => Array.from(e.getState().connectionLookup.get(`${h}-${d}${f ? `-${f}` : ""}`)?.values() ?? []),
      getNodeConnections: ({ type: d, handleId: f, nodeId: h }) => Array.from(e.getState().connectionLookup.get(`${h}${d ? f ? `-${d}-${f}` : `-${d}` : ""}`)?.values() ?? [])
    };
  }, []);
  return cn(() => ({
    ...o,
    ...t,
    viewportInitialized: r
  }), [r]);
}
const GX = (t) => t.selected, Uct = { actInsideInputWithModifier: !1 }, Hct = typeof window < "u" ? window : void 0;
function Vct({ deleteKeyCode: t, multiSelectionKeyCode: e }) {
  const n = ir(), { deleteElements: r } = V4(), o = My(t, Uct), i = My(e, { target: Hct });
  Ne(() => {
    if (o) {
      const { edges: s, nodes: a } = n.getState();
      r({ nodes: a.filter(GX), edges: s.filter(GX) }), n.setState({ nodesSelectionActive: !1 });
    }
  }, [o]), Ne(() => {
    n.setState({ multiSelectionActive: i });
  }, [i]);
}
function Wct(t) {
  const e = ir();
  Ne(() => {
    const n = () => {
      if (!t.current)
        return !1;
      const r = cO(t.current);
      (r.height === 0 || r.width === 0) && e.getState().onError?.("004", cs.error004()), e.setState({ width: r.width || 500, height: r.height || 500 });
    };
    if (t.current) {
      n(), window.addEventListener("resize", n);
      const r = new ResizeObserver(() => n());
      return r.observe(t.current), () => {
        window.removeEventListener("resize", n), r && t.current && r.unobserve(t.current);
      };
    }
  }, []);
}
const fO = {
  position: "absolute",
  width: "100%",
  height: "100%",
  top: 0,
  left: 0
}, Gct = (t) => ({
  userSelectionActive: t.userSelectionActive,
  lib: t.lib
});
function Yct({ onPaneContextMenu: t, zoomOnScroll: e = !0, zoomOnPinch: n = !0, panOnScroll: r = !1, panOnScrollSpeed: o = 0.5, panOnScrollMode: i = Ed.Free, zoomOnDoubleClick: s = !0, panOnDrag: a = !0, defaultViewport: l, translateExtent: c, minZoom: u, maxZoom: d, zoomActivationKeyCode: f, preventScrolling: h = !0, children: p, noWheelClassName: m, noPanClassName: g, onViewportChange: y, isControlledViewport: v, paneClickDistance: b }) {
  const _ = ir(), w = Ue(null), { userSelectionActive: x, lib: E } = Yt(Gct, pr), S = My(f), C = Ue();
  Wct(w);
  const R = Cn((P) => {
    y?.({ x: P[0], y: P[1], zoom: P[2] }), v || _.setState({ transform: P });
  }, [y, v]);
  return Ne(() => {
    if (w.current) {
      C.current = Xlt({
        domNode: w.current,
        minZoom: u,
        maxZoom: d,
        translateExtent: c,
        viewport: l,
        paneClickDistance: b,
        onDraggingChange: (O) => _.setState({ paneDragging: O }),
        onPanZoomStart: (O, k) => {
          const { onViewportChangeStart: T, onMoveStart: I } = _.getState();
          I?.(O, k), T?.(k);
        },
        onPanZoom: (O, k) => {
          const { onViewportChange: T, onMove: I } = _.getState();
          I?.(O, k), T?.(k);
        },
        onPanZoomEnd: (O, k) => {
          const { onViewportChangeEnd: T, onMoveEnd: I } = _.getState();
          I?.(O, k), T?.(k);
        }
      });
      const { x: P, y: N, zoom: A } = C.current.getViewport();
      return _.setState({
        panZoom: C.current,
        transform: [P, N, A],
        domNode: w.current.closest(".react-flow")
      }), () => {
        C.current?.destroy();
      };
    }
  }, []), Ne(() => {
    C.current?.update({
      onPaneContextMenu: t,
      zoomOnScroll: e,
      zoomOnPinch: n,
      panOnScroll: r,
      panOnScrollSpeed: o,
      panOnScrollMode: i,
      zoomOnDoubleClick: s,
      panOnDrag: a,
      zoomActivationKeyPressed: S,
      preventScrolling: h,
      noPanClassName: g,
      userSelectionActive: x,
      noWheelClassName: m,
      lib: E,
      onTransformChange: R
    });
  }, [
    t,
    e,
    n,
    r,
    o,
    i,
    s,
    a,
    S,
    h,
    g,
    x,
    m,
    E,
    R
  ]), M.jsx("div", { className: "react-flow__renderer", ref: w, style: fO, children: p });
}
const Kct = (t) => ({
  userSelectionActive: t.userSelectionActive,
  userSelectionRect: t.userSelectionRect
});
function Xct() {
  const { userSelectionActive: t, userSelectionRect: e } = Yt(Kct, pr);
  return t && e ? M.jsx("div", { className: "react-flow__selection react-flow__container", style: {
    width: e.width,
    height: e.height,
    transform: `translate(${e.x}px, ${e.y}px)`
  } }) : null;
}
const rT = (t, e) => (n) => {
  n.target === e.current && t?.(n);
}, Qct = (t) => ({
  userSelectionActive: t.userSelectionActive,
  elementsSelectable: t.elementsSelectable,
  dragging: t.paneDragging
});
function Zct({ isSelecting: t, selectionKeyPressed: e, selectionMode: n = Ry.Full, panOnDrag: r, selectionOnDrag: o, onSelectionStart: i, onSelectionEnd: s, onPaneClick: a, onPaneContextMenu: l, onPaneScroll: c, onPaneMouseEnter: u, onPaneMouseMove: d, onPaneMouseLeave: f, children: h }) {
  const p = ir(), { userSelectionActive: m, elementsSelectable: g, dragging: y } = Yt(Qct, pr), v = g && (t || m), b = Ue(null), _ = Ue(), w = Ue(/* @__PURE__ */ new Set()), x = Ue(/* @__PURE__ */ new Set()), E = Ue(!1), S = Ue(!1), C = (T) => {
    if (E.current) {
      E.current = !1;
      return;
    }
    a?.(T), p.getState().resetSelectedElements(), p.setState({ nodesSelectionActive: !1 });
  }, R = (T) => {
    if (Array.isArray(r) && r?.includes(2)) {
      T.preventDefault();
      return;
    }
    l?.(T);
  }, P = c ? (T) => c(T) : void 0, N = (T) => {
    const { resetSelectedElements: I, domNode: j } = p.getState();
    if (_.current = j?.getBoundingClientRect(), !g || !t || T.button !== 0 || T.target !== b.current || !_.current)
      return;
    T.target?.setPointerCapture?.(T.pointerId), S.current = !0, E.current = !1;
    const { x: z, y: $ } = Tl(T.nativeEvent, _.current);
    I(), p.setState({
      userSelectionRect: {
        width: 0,
        height: 0,
        startX: z,
        startY: $,
        x: z,
        y: $
      }
    }), i?.(T);
  }, A = (T) => {
    const { userSelectionRect: I, transform: j, nodeLookup: z, edgeLookup: $, connectionLookup: D, triggerNodeChanges: U, triggerEdgeChanges: q, defaultEdgeOptions: F } = p.getState();
    if (!_.current || !I)
      return;
    E.current = !0;
    const { x: B, y: H } = Tl(T.nativeEvent, _.current), { startX: Z, startY: W } = I, G = {
      startX: Z,
      startY: W,
      x: B < Z ? B : Z,
      y: H < W ? H : W,
      width: Math.abs(B - Z),
      height: Math.abs(H - W)
    }, ee = w.current, Y = x.current;
    w.current = new Set(B0e(z, G, j, n === Ry.Partial, !0).map((V) => V.id)), x.current = /* @__PURE__ */ new Set();
    const L = F?.selectable ?? !0;
    for (const V of w.current) {
      const K = D.get(V);
      if (K)
        for (const { edgeId: ne } of K.values()) {
          const ce = $.get(ne);
          ce && (ce.selectable ?? L) && x.current.add(ne);
        }
    }
    if (!bX(ee, w.current)) {
      const V = nh(z, w.current, !0);
      U(V);
    }
    if (!bX(Y, x.current)) {
      const V = nh($, x.current);
      q(V);
    }
    p.setState({
      userSelectionRect: G,
      userSelectionActive: !0,
      nodesSelectionActive: !1
    });
  }, O = (T) => {
    if (T.button !== 0 || !S.current)
      return;
    T.target?.releasePointerCapture?.(T.pointerId);
    const { userSelectionRect: I } = p.getState();
    !m && I && T.target === b.current && C?.(T), p.setState({
      userSelectionActive: !1,
      userSelectionRect: null,
      nodesSelectionActive: w.current.size > 0
    }), s?.(T), (e || o) && (E.current = !1), S.current = !1;
  }, k = r === !0 || Array.isArray(r) && r.includes(0);
  return M.jsxs("div", { className: Rr(["react-flow__pane", { draggable: k, dragging: y, selection: t }]), onClick: v ? void 0 : rT(C, b), onContextMenu: rT(R, b), onWheel: rT(P, b), onPointerEnter: v ? void 0 : u, onPointerDown: v ? N : d, onPointerMove: v ? A : d, onPointerUp: v ? O : void 0, onPointerLeave: f, ref: b, style: fO, children: [h, M.jsx(Xct, {})] });
}
function Dj({ id: t, store: e, unselect: n = !1, nodeRef: r }) {
  const { addSelectedNodes: o, unselectNodesAndEdges: i, multiSelectionActive: s, nodeLookup: a, onError: l } = e.getState(), c = a.get(t);
  if (!c) {
    l?.("012", cs.error012(t));
    return;
  }
  e.setState({ nodesSelectionActive: !1 }), c.selected ? (n || c.selected && s) && (i({ nodes: [c], edges: [] }), requestAnimationFrame(() => r?.current?.blur())) : o([t]);
}
function bye({ nodeRef: t, disabled: e = !1, noDragClassName: n, handleSelector: r, nodeId: o, isSelectable: i, nodeClickDistance: s }) {
  const a = ir(), [l, c] = Ye(!1), u = Ue();
  return Ne(() => {
    u.current = Nlt({
      getStoreItems: () => a.getState(),
      onNodeMouseDown: (d) => {
        Dj({
          id: d,
          store: a,
          nodeRef: t
        });
      },
      onDragStart: () => {
        c(!0);
      },
      onDragStop: () => {
        c(!1);
      }
    });
  }, []), Ne(() => {
    if (e)
      u.current?.destroy();
    else if (t.current)
      return u.current?.update({
        noDragClassName: n,
        handleSelector: r,
        domNode: t.current,
        isSelectable: i,
        nodeId: o,
        nodeClickDistance: s
      }), () => {
        u.current?.destroy();
      };
  }, [n, r, e, i, t, o]), l;
}
const Jct = (t) => (e) => e.selected && (e.draggable || t && typeof e.draggable > "u");
function _ye() {
  const t = ir();
  return Cn((e) => {
    const { nodeExtent: n, snapToGrid: r, snapGrid: o, nodesDraggable: i, onError: s, updateNodePositions: a, nodeLookup: l, nodeOrigin: c } = t.getState(), u = /* @__PURE__ */ new Map(), d = Jct(i), f = r ? o[0] : 5, h = r ? o[1] : 5, p = e.direction.x * f * e.factor, m = e.direction.y * h * e.factor;
    for (const [, g] of l) {
      if (!d(g))
        continue;
      let y = {
        x: g.internals.positionAbsolute.x + p,
        y: g.internals.positionAbsolute.y + m
      };
      r && (y = lO(y, o));
      const { position: v, positionAbsolute: b } = z0e({
        nodeId: g.id,
        nextPosition: y,
        nodeLookup: l,
        nodeExtent: n,
        nodeOrigin: c,
        onError: s
      });
      g.position = v, g.internals.positionAbsolute = b, u.set(g.id, g);
    }
    a(u);
  }, []);
}
const W4 = lr(null), eut = W4.Provider;
W4.Consumer;
const wye = () => Hn(W4), tut = (t) => ({
  connectOnClick: t.connectOnClick,
  noPanClassName: t.noPanClassName,
  rfId: t.rfId
}), nut = (t, e, n) => (r) => {
  const { connectionClickStartHandle: o, connectionMode: i, connection: s } = r, { fromHandle: a, toHandle: l, isValid: c } = s, u = l?.nodeId === t && l?.id === e && l?.type === n;
  return {
    connectingFrom: a?.nodeId === t && a?.id === e && a?.type === n,
    connectingTo: u,
    clickConnecting: o?.nodeId === t && o?.id === e && o?.type === n,
    isPossibleEndHandle: i === cp.Strict ? a?.type !== n : t !== a?.nodeId || e !== a?.id,
    connectionInProcess: !!a,
    valid: u && c
  };
};
function rut({ type: t = "source", position: e = pt.Top, isValidConnection: n, isConnectable: r = !0, isConnectableStart: o = !0, isConnectableEnd: i = !0, id: s, onConnect: a, children: l, className: c, onMouseDown: u, onTouchStart: d, ...f }, h) {
  const p = s || null, m = t === "target", g = ir(), y = wye(), { connectOnClick: v, noPanClassName: b, rfId: _ } = Yt(tut, pr), { connectingFrom: w, connectingTo: x, clickConnecting: E, isPossibleEndHandle: S, connectionInProcess: C, valid: R } = Yt(nut(y, p, t), pr);
  y || g.getState().onError?.("010", cs.error010());
  const P = (O) => {
    const { defaultEdgeOptions: k, onConnect: T, hasDefaultEdges: I } = g.getState(), j = {
      ...k,
      ...O
    };
    if (I) {
      const { edges: z, setEdges: $ } = g.getState();
      $(Elt(j, z));
    }
    T?.(j), a?.(j);
  }, N = (O) => {
    if (!y)
      return;
    const k = X0e(O.nativeEvent);
    if (o && (k && O.button === 0 || !k)) {
      const T = g.getState();
      Mj.onPointerDown(O.nativeEvent, {
        autoPanOnConnect: T.autoPanOnConnect,
        connectionMode: T.connectionMode,
        connectionRadius: T.connectionRadius,
        domNode: T.domNode,
        nodeLookup: T.nodeLookup,
        lib: T.lib,
        isTarget: m,
        handleId: p,
        nodeId: y,
        flowId: T.rfId,
        panBy: T.panBy,
        cancelConnection: T.cancelConnection,
        onConnectStart: T.onConnectStart,
        onConnectEnd: T.onConnectEnd,
        updateConnection: T.updateConnection,
        onConnect: P,
        isValidConnection: n || T.isValidConnection,
        getTransform: () => g.getState().transform,
        getFromHandle: () => g.getState().connection.fromHandle,
        autoPanSpeed: T.autoPanSpeed
      });
    }
    k ? u?.(O) : d?.(O);
  }, A = (O) => {
    const { onClickConnectStart: k, onClickConnectEnd: T, connectionClickStartHandle: I, connectionMode: j, isValidConnection: z, lib: $, rfId: D, nodeLookup: U, connection: q } = g.getState();
    if (!y || !I && !o)
      return;
    if (!I) {
      k?.(O.nativeEvent, { nodeId: y, handleId: p, handleType: t }), g.setState({ connectionClickStartHandle: { nodeId: y, type: t, id: p } });
      return;
    }
    const F = K0e(O.target), B = n || z, { connection: H, isValid: Z } = Mj.isValid(O.nativeEvent, {
      handle: {
        nodeId: y,
        id: p,
        type: t
      },
      connectionMode: j,
      fromNodeId: I.nodeId,
      fromHandleId: I.id || null,
      fromType: I.type,
      isValidConnection: B,
      flowId: D,
      doc: F,
      lib: $,
      nodeLookup: U
    });
    Z && H && P(H);
    const W = structuredClone(q);
    delete W.inProgress, W.toPosition = W.toHandle ? W.toHandle.position : null, T?.(O, W), g.setState({ connectionClickStartHandle: null });
  };
  return M.jsx("div", { "data-handleid": p, "data-nodeid": y, "data-handlepos": e, "data-id": `${_}-${y}-${p}-${t}`, className: Rr([
    "react-flow__handle",
    `react-flow__handle-${e}`,
    "nodrag",
    b,
    c,
    {
      source: !m,
      target: m,
      connectable: r,
      connectablestart: o,
      connectableend: i,
      clickconnecting: E,
      connectingfrom: w,
      connectingto: x,
      valid: R,
      // shows where you can start a connection from
      // and where you can end it while connecting
      connectionindicator: r && (!C || S) && (C ? i : o)
    }
  ]), onMouseDown: N, onTouchStart: N, onClick: v ? A : void 0, ref: h, ...f, children: l });
}
const _E = Wt(yye(rut));
function out({ data: t, isConnectable: e, sourcePosition: n = pt.Bottom }) {
  return M.jsxs(M.Fragment, { children: [t?.label, M.jsx(_E, { type: "source", position: n, isConnectable: e })] });
}
function iut({ data: t, isConnectable: e, targetPosition: n = pt.Top, sourcePosition: r = pt.Bottom }) {
  return M.jsxs(M.Fragment, { children: [M.jsx(_E, { type: "target", position: n, isConnectable: e }), t?.label, M.jsx(_E, { type: "source", position: r, isConnectable: e })] });
}
function sut() {
  return null;
}
function aut({ data: t, isConnectable: e, targetPosition: n = pt.Top }) {
  return M.jsxs(M.Fragment, { children: [M.jsx(_E, { type: "target", position: n, isConnectable: e }), t?.label] });
}
const wE = {
  ArrowUp: { x: 0, y: -1 },
  ArrowDown: { x: 0, y: 1 },
  ArrowLeft: { x: -1, y: 0 },
  ArrowRight: { x: 1, y: 0 }
}, YX = {
  input: out,
  default: iut,
  output: aut,
  group: sut
};
function lut(t) {
  return t.internals.handleBounds === void 0 ? {
    width: t.width ?? t.initialWidth ?? t.style?.width,
    height: t.height ?? t.initialHeight ?? t.style?.height
  } : {
    width: t.width ?? t.style?.width,
    height: t.height ?? t.style?.height
  };
}
const cut = (t) => {
  const { width: e, height: n, x: r, y: o } = Mv(t.nodeLookup, {
    filter: (i) => !!i.selected
  });
  return {
    width: Ss(e) ? e : null,
    height: Ss(n) ? n : null,
    userSelectionActive: t.userSelectionActive,
    transformString: `translate(${t.transform[0]}px,${t.transform[1]}px) scale(${t.transform[2]}) translate(${r}px,${o}px)`
  };
};
function uut({ onSelectionContextMenu: t, noPanClassName: e, disableKeyboardA11y: n }) {
  const r = ir(), { width: o, height: i, transformString: s, userSelectionActive: a } = Yt(cut, pr), l = _ye(), c = Ue(null);
  if (Ne(() => {
    n || c.current?.focus({
      preventScroll: !0
    });
  }, [n]), bye({
    nodeRef: c
  }), a || !o || !i)
    return null;
  const u = t ? (f) => {
    const h = r.getState().nodes.filter((p) => p.selected);
    t(f, h);
  } : void 0, d = (f) => {
    Object.prototype.hasOwnProperty.call(wE, f.key) && (f.preventDefault(), l({
      direction: wE[f.key],
      factor: f.shiftKey ? 4 : 1
    }));
  };
  return M.jsx("div", { className: Rr(["react-flow__nodesselection", "react-flow__container", e]), style: {
    transform: s
  }, children: M.jsx("div", { ref: c, className: "react-flow__nodesselection-rect", onContextMenu: u, tabIndex: n ? void 0 : -1, onKeyDown: n ? void 0 : d, style: {
    width: o,
    height: i
  } }) });
}
const KX = typeof window < "u" ? window : void 0, dut = (t) => ({ nodesSelectionActive: t.nodesSelectionActive, userSelectionActive: t.userSelectionActive });
function xye({ children: t, onPaneClick: e, onPaneMouseEnter: n, onPaneMouseMove: r, onPaneMouseLeave: o, onPaneContextMenu: i, onPaneScroll: s, paneClickDistance: a, deleteKeyCode: l, selectionKeyCode: c, selectionOnDrag: u, selectionMode: d, onSelectionStart: f, onSelectionEnd: h, multiSelectionKeyCode: p, panActivationKeyCode: m, zoomActivationKeyCode: g, elementsSelectable: y, zoomOnScroll: v, zoomOnPinch: b, panOnScroll: _, panOnScrollSpeed: w, panOnScrollMode: x, zoomOnDoubleClick: E, panOnDrag: S, defaultViewport: C, translateExtent: R, minZoom: P, maxZoom: N, preventScrolling: A, onSelectionContextMenu: O, noWheelClassName: k, noPanClassName: T, disableKeyboardA11y: I, onViewportChange: j, isControlledViewport: z }) {
  const { nodesSelectionActive: $, userSelectionActive: D } = Yt(dut), U = My(c, { target: KX }), q = My(m, { target: KX }), F = q || S, B = q || _, H = u && F !== !0, Z = U || D || H;
  return Vct({ deleteKeyCode: l, multiSelectionKeyCode: p }), M.jsx(Yct, { onPaneContextMenu: i, elementsSelectable: y, zoomOnScroll: v, zoomOnPinch: b, panOnScroll: B, panOnScrollSpeed: w, panOnScrollMode: x, zoomOnDoubleClick: E, panOnDrag: !U && F, defaultViewport: C, translateExtent: R, minZoom: P, maxZoom: N, zoomActivationKeyCode: g, preventScrolling: A, noWheelClassName: k, noPanClassName: T, onViewportChange: j, isControlledViewport: z, paneClickDistance: a, children: M.jsxs(Zct, { onSelectionStart: f, onSelectionEnd: h, onPaneClick: e, onPaneMouseEnter: n, onPaneMouseMove: r, onPaneMouseLeave: o, onPaneContextMenu: i, onPaneScroll: s, panOnDrag: F, isSelecting: !!Z, selectionMode: d, selectionKeyPressed: U, selectionOnDrag: H, children: [t, $ && M.jsx(uut, { onSelectionContextMenu: O, noPanClassName: T, disableKeyboardA11y: I })] }) });
}
xye.displayName = "FlowRenderer";
const fut = Wt(xye), hut = (t) => (e) => t ? B0e(e.nodeLookup, { x: 0, y: 0, width: e.width, height: e.height }, e.transform, !0).map((n) => n.id) : Array.from(e.nodeLookup.keys());
function put(t) {
  return Yt(Cn(hut(t), [t]), pr);
}
const mut = (t) => t.updateNodeInternals;
function gut() {
  const t = Yt(mut), [e] = Ye(() => typeof ResizeObserver > "u" ? null : new ResizeObserver((n) => {
    const r = /* @__PURE__ */ new Map();
    n.forEach((o) => {
      const i = o.target.getAttribute("data-id");
      r.set(i, {
        id: i,
        nodeElement: o.target,
        force: !0
      });
    }), t(r);
  }));
  return Ne(() => () => {
    e?.disconnect();
  }, [e]), e;
}
function yut({ node: t, nodeType: e, hasDimensions: n, resizeObserver: r }) {
  const o = ir(), i = Ue(null), s = Ue(null), a = Ue(t.sourcePosition), l = Ue(t.targetPosition), c = Ue(e), u = n && !!t.internals.handleBounds;
  return Ne(() => {
    i.current && !t.hidden && (!u || s.current !== i.current) && (s.current && r?.unobserve(s.current), r?.observe(i.current), s.current = i.current);
  }, [u, t.hidden]), Ne(() => () => {
    s.current && (r?.unobserve(s.current), s.current = null);
  }, []), Ne(() => {
    if (i.current) {
      const d = c.current !== e, f = a.current !== t.sourcePosition, h = l.current !== t.targetPosition;
      (d || f || h) && (c.current = e, a.current = t.sourcePosition, l.current = t.targetPosition, o.getState().updateNodeInternals(/* @__PURE__ */ new Map([[t.id, { id: t.id, nodeElement: i.current, force: !0 }]])));
    }
  }, [t.id, e, t.sourcePosition, t.targetPosition]), i;
}
function vut({ id: t, onClick: e, onMouseEnter: n, onMouseMove: r, onMouseLeave: o, onContextMenu: i, onDoubleClick: s, nodesDraggable: a, elementsSelectable: l, nodesConnectable: c, nodesFocusable: u, resizeObserver: d, noDragClassName: f, noPanClassName: h, disableKeyboardA11y: p, rfId: m, nodeTypes: g, nodeExtent: y, nodeClickDistance: v, onError: b }) {
  const { node: _, internals: w, isParent: x } = Yt((W) => {
    const G = W.nodeLookup.get(t), ee = W.parentLookup.has(t);
    return {
      node: G,
      internals: G.internals,
      isParent: ee
    };
  }, pr);
  let E = _.type || "default", S = g?.[E] || YX[E];
  S === void 0 && (b?.("003", cs.error003(E)), E = "default", S = YX.default);
  const C = !!(_.draggable || a && typeof _.draggable > "u"), R = !!(_.selectable || l && typeof _.selectable > "u"), P = !!(_.connectable || c && typeof _.connectable > "u"), N = !!(_.focusable || u && typeof _.focusable > "u"), A = ir(), O = G0e(_), k = yut({ node: _, nodeType: E, hasDimensions: O, resizeObserver: d }), T = bye({
    nodeRef: k,
    disabled: _.hidden || !C,
    noDragClassName: f,
    handleSelector: _.dragHandle,
    nodeId: t,
    isSelectable: R,
    nodeClickDistance: v
  }), I = _ye();
  if (_.hidden)
    return null;
  const j = Gl(_), z = lut(_), $ = R || C || e || n || r || o, D = n ? (W) => n(W, { ...w.userNode }) : void 0, U = r ? (W) => r(W, { ...w.userNode }) : void 0, q = o ? (W) => o(W, { ...w.userNode }) : void 0, F = i ? (W) => i(W, { ...w.userNode }) : void 0, B = s ? (W) => s(W, { ...w.userNode }) : void 0, H = (W) => {
    const { selectNodesOnDrag: G, nodeDragThreshold: ee } = A.getState();
    R && (!G || !C || ee > 0) && Dj({
      id: t,
      store: A,
      nodeRef: k
    }), e && e(W, { ...w.userNode });
  }, Z = (W) => {
    if (!(Tj(W.nativeEvent) || p))
      if (N0e.includes(W.key) && R) {
        const G = W.key === "Escape";
        Dj({
          id: t,
          store: A,
          unselect: G,
          nodeRef: k
        });
      } else C && _.selected && Object.prototype.hasOwnProperty.call(wE, W.key) && (W.preventDefault(), A.setState({
        ariaLiveMessage: `Moved selected node ${W.key.replace("Arrow", "").toLowerCase()}. New position, x: ${~~w.positionAbsolute.x}, y: ${~~w.positionAbsolute.y}`
      }), I({
        direction: wE[W.key],
        factor: W.shiftKey ? 4 : 1
      }));
  };
  return M.jsx("div", { className: Rr([
    "react-flow__node",
    `react-flow__node-${E}`,
    {
      // this is overwritable by passing `nopan` as a class name
      [h]: C
    },
    _.className,
    {
      selected: _.selected,
      selectable: R,
      parent: x,
      draggable: C,
      dragging: T
    }
  ]), ref: k, style: {
    zIndex: w.z,
    transform: `translate(${w.positionAbsolute.x}px,${w.positionAbsolute.y}px)`,
    pointerEvents: $ ? "all" : "none",
    visibility: O ? "visible" : "hidden",
    ..._.style,
    ...z
  }, "data-id": t, "data-testid": `rf__node-${t}`, onMouseEnter: D, onMouseMove: U, onMouseLeave: q, onContextMenu: F, onClick: H, onDoubleClick: B, onKeyDown: N ? Z : void 0, tabIndex: N ? 0 : void 0, role: N ? "button" : void 0, "aria-describedby": p ? void 0 : `${hye}-${m}`, "aria-label": _.ariaLabel, children: M.jsx(eut, { value: t, children: M.jsx(S, { id: t, data: _.data, type: E, positionAbsoluteX: w.positionAbsolute.x, positionAbsoluteY: w.positionAbsolute.y, selected: _.selected ?? !1, selectable: R, draggable: C, deletable: _.deletable ?? !0, isConnectable: P, sourcePosition: _.sourcePosition, targetPosition: _.targetPosition, dragging: T, dragHandle: _.dragHandle, zIndex: w.z, parentId: _.parentId, ...j }) }) });
}
const but = (t) => ({
  nodesDraggable: t.nodesDraggable,
  nodesConnectable: t.nodesConnectable,
  nodesFocusable: t.nodesFocusable,
  elementsSelectable: t.elementsSelectable,
  onError: t.onError
});
function Eye(t) {
  const { nodesDraggable: e, nodesConnectable: n, nodesFocusable: r, elementsSelectable: o, onError: i } = Yt(but, pr), s = put(t.onlyRenderVisibleElements), a = gut();
  return M.jsx("div", { className: "react-flow__nodes", style: fO, children: s.map((l) => (
    // The split of responsibilities between NodeRenderer and
    // NodeComponentWrapper may appear weird. However, it’s designed to
    // minimize the cost of updates when individual nodes change.
    //
    // For example, when you’re dragging a single node, that node gets
    // updated multiple times per second. If `NodeRenderer` were to update
    // every time, it would have to re-run the `nodes.map()` loop every
    // time. This gets pricey with hundreds of nodes, especially if every
    // loop cycle does more than just rendering a JSX element!
    //
    // As a result of this choice, we took the following implementation
    // decisions:
    // - NodeRenderer subscribes *only* to node IDs – and therefore
    //   rerender *only* when visible nodes are added or removed.
    // - NodeRenderer performs all operations the result of which can be
    //   shared between nodes (such as creating the `ResizeObserver`
    //   instance, or subscribing to `selector`). This means extra prop
    //   drilling into `NodeComponentWrapper`, but it means we need to run
    //   these operations only once – instead of once per node.
    // - Any operations that you’d normally write inside `nodes.map` are
    //   moved into `NodeComponentWrapper`. This ensures they are
    //   memorized – so if `NodeRenderer` *has* to rerender, it only
    //   needs to regenerate the list of nodes, nothing else.
    M.jsx(vut, { id: l, nodeTypes: t.nodeTypes, nodeExtent: t.nodeExtent, onClick: t.onNodeClick, onMouseEnter: t.onNodeMouseEnter, onMouseMove: t.onNodeMouseMove, onMouseLeave: t.onNodeMouseLeave, onContextMenu: t.onNodeContextMenu, onDoubleClick: t.onNodeDoubleClick, noDragClassName: t.noDragClassName, noPanClassName: t.noPanClassName, rfId: t.rfId, disableKeyboardA11y: t.disableKeyboardA11y, resizeObserver: a, nodesDraggable: e, nodesConnectable: n, nodesFocusable: r, elementsSelectable: o, nodeClickDistance: t.nodeClickDistance, onError: i }, l)
  )) });
}
Eye.displayName = "NodeRenderer";
const _ut = Wt(Eye);
function wut(t) {
  return Yt(Cn((e) => {
    if (!t)
      return e.edges.map((r) => r.id);
    const n = [];
    if (e.width && e.height)
      for (const r of e.edges) {
        const o = e.nodeLookup.get(r.source), i = e.nodeLookup.get(r.target);
        o && i && _lt({
          sourceNode: o,
          targetNode: i,
          width: e.width,
          height: e.height,
          transform: e.transform
        }) && n.push(r.id);
      }
    return n;
  }, [t]), pr);
}
const xut = ({ color: t = "none", strokeWidth: e = 1 }) => M.jsx("polyline", { style: {
  stroke: t,
  strokeWidth: e
}, strokeLinecap: "round", strokeLinejoin: "round", fill: "none", points: "-5,-4 0,0 -5,4" }), Eut = ({ color: t = "none", strokeWidth: e = 1 }) => M.jsx("polyline", { style: {
  stroke: t,
  fill: t,
  strokeWidth: e
}, strokeLinecap: "round", strokeLinejoin: "round", points: "-5,-4 0,0 -5,4 -5,-4" }), XX = {
  [yE.Arrow]: xut,
  [yE.ArrowClosed]: Eut
};
function Sut(t) {
  const e = ir();
  return cn(() => Object.prototype.hasOwnProperty.call(XX, t) ? XX[t] : (e.getState().onError?.("009", cs.error009(t)), null), [t]);
}
const Out = ({ id: t, type: e, color: n, width: r = 12.5, height: o = 12.5, markerUnits: i = "strokeWidth", strokeWidth: s, orient: a = "auto-start-reverse" }) => {
  const l = Sut(e);
  return l ? M.jsx("marker", { className: "react-flow__arrowhead", id: t, markerWidth: `${r}`, markerHeight: `${o}`, viewBox: "-10 -10 20 20", markerUnits: i, orient: a, refX: "0", refY: "0", children: M.jsx(l, { color: n, strokeWidth: s }) }) : null;
}, Sye = ({ defaultColor: t, rfId: e }) => {
  const n = Yt((i) => i.edges), r = Yt((i) => i.defaultEdgeOptions), o = cn(() => Alt(n, {
    id: e,
    defaultColor: t,
    defaultMarkerStart: r?.markerStart,
    defaultMarkerEnd: r?.markerEnd
  }), [n, r, e, t]);
  return o.length ? M.jsx("svg", { className: "react-flow__marker", children: M.jsx("defs", { children: o.map((i) => M.jsx(Out, { id: i.id, type: i.type, color: i.color, width: i.width, height: i.height, markerUnits: i.markerUnits, strokeWidth: i.strokeWidth, orient: i.orient }, i.id)) }) }) : null;
};
Sye.displayName = "MarkerDefinitions";
var Cut = Wt(Sye);
function Oye({ x: t, y: e, label: n, labelStyle: r = {}, labelShowBg: o = !0, labelBgStyle: i = {}, labelBgPadding: s = [2, 4], labelBgBorderRadius: a = 2, children: l, className: c, ...u }) {
  const [d, f] = Ye({ x: 1, y: 0, width: 0, height: 0 }), h = Rr(["react-flow__edge-textwrapper", c]), p = Ue(null);
  return Ne(() => {
    if (p.current) {
      const m = p.current.getBBox();
      f({
        x: m.x,
        y: m.y,
        width: m.width,
        height: m.height
      });
    }
  }, [n]), typeof n > "u" || !n ? null : M.jsxs("g", { transform: `translate(${t - d.width / 2} ${e - d.height / 2})`, className: h, visibility: d.width ? "visible" : "hidden", ...u, children: [o && M.jsx("rect", { width: d.width + 2 * s[0], x: -s[0], y: -s[1], height: d.height + 2 * s[1], className: "react-flow__edge-textbg", style: i, rx: a, ry: a }), M.jsx("text", { className: "react-flow__edge-text", y: d.height / 2, dy: "0.3em", ref: p, style: r, children: n }), l] });
}
Oye.displayName = "EdgeText";
const kut = Wt(Oye);
function hO({ path: t, labelX: e, labelY: n, label: r, labelStyle: o, labelShowBg: i, labelBgStyle: s, labelBgPadding: a, labelBgBorderRadius: l, interactionWidth: c = 20, ...u }) {
  return M.jsxs(M.Fragment, { children: [M.jsx("path", { ...u, d: t, fill: "none", className: Rr(["react-flow__edge-path", u.className]) }), c && M.jsx("path", { d: t, fill: "none", strokeOpacity: 0, strokeWidth: c, className: "react-flow__edge-interaction" }), r && Ss(e) && Ss(n) ? M.jsx(kut, { x: e, y: n, label: r, labelStyle: o, labelShowBg: i, labelBgStyle: s, labelBgPadding: a, labelBgBorderRadius: l }) : null] });
}
function QX({ pos: t, x1: e, y1: n, x2: r, y2: o }) {
  return t === pt.Left || t === pt.Right ? [0.5 * (e + r), n] : [e, 0.5 * (n + o)];
}
function Cye({ sourceX: t, sourceY: e, sourcePosition: n = pt.Bottom, targetX: r, targetY: o, targetPosition: i = pt.Top }) {
  const [s, a] = QX({
    pos: n,
    x1: t,
    y1: e,
    x2: r,
    y2: o
  }), [l, c] = QX({
    pos: i,
    x1: r,
    y1: o,
    x2: t,
    y2: e
  }), [u, d, f, h] = Q0e({
    sourceX: t,
    sourceY: e,
    targetX: r,
    targetY: o,
    sourceControlX: s,
    sourceControlY: a,
    targetControlX: l,
    targetControlY: c
  });
  return [
    `M${t},${e} C${s},${a} ${l},${c} ${r},${o}`,
    u,
    d,
    f,
    h
  ];
}
function kye(t) {
  return Wt(({ id: e, sourceX: n, sourceY: r, targetX: o, targetY: i, sourcePosition: s = pt.Bottom, targetPosition: a = pt.Top, label: l, labelStyle: c, labelShowBg: u, labelBgStyle: d, labelBgPadding: f, labelBgBorderRadius: h, style: p, markerEnd: m, markerStart: g, interactionWidth: y }) => {
    const [v, b, _] = Cye({
      sourceX: n,
      sourceY: r,
      sourcePosition: s,
      targetX: o,
      targetY: i,
      targetPosition: a
    }), w = t.isInternal ? void 0 : e;
    return M.jsx(hO, { id: w, path: v, labelX: b, labelY: _, label: l, labelStyle: c, labelShowBg: u, labelBgStyle: d, labelBgPadding: f, labelBgBorderRadius: h, style: p, markerEnd: m, markerStart: g, interactionWidth: y });
  });
}
const Aut = kye({ isInternal: !1 }), Aye = kye({ isInternal: !0 });
Aut.displayName = "SimpleBezierEdge";
Aye.displayName = "SimpleBezierEdgeInternal";
function Tye(t) {
  return Wt(({ id: e, sourceX: n, sourceY: r, targetX: o, targetY: i, label: s, labelStyle: a, labelShowBg: l, labelBgStyle: c, labelBgPadding: u, labelBgBorderRadius: d, style: f, sourcePosition: h = pt.Bottom, targetPosition: p = pt.Top, markerEnd: m, markerStart: g, pathOptions: y, interactionWidth: v }) => {
    const [b, _, w] = Rj({
      sourceX: n,
      sourceY: r,
      sourcePosition: h,
      targetX: o,
      targetY: i,
      targetPosition: p,
      borderRadius: y?.borderRadius,
      offset: y?.offset
    }), x = t.isInternal ? void 0 : e;
    return M.jsx(hO, { id: x, path: b, labelX: _, labelY: w, label: s, labelStyle: a, labelShowBg: l, labelBgStyle: c, labelBgPadding: u, labelBgBorderRadius: d, style: f, markerEnd: m, markerStart: g, interactionWidth: v });
  });
}
const Rye = Tye({ isInternal: !1 }), Pye = Tye({ isInternal: !0 });
Rye.displayName = "SmoothStepEdge";
Pye.displayName = "SmoothStepEdgeInternal";
function $ye(t) {
  return Wt(({ id: e, ...n }) => {
    const r = t.isInternal ? void 0 : e;
    return M.jsx(Rye, { ...n, id: r, pathOptions: cn(() => ({ borderRadius: 0, offset: n.pathOptions?.offset }), [n.pathOptions?.offset]) });
  });
}
const Tut = $ye({ isInternal: !1 }), Mye = $ye({ isInternal: !0 });
Tut.displayName = "StepEdge";
Mye.displayName = "StepEdgeInternal";
function Dye(t) {
  return Wt(({ id: e, sourceX: n, sourceY: r, targetX: o, targetY: i, label: s, labelStyle: a, labelShowBg: l, labelBgStyle: c, labelBgPadding: u, labelBgBorderRadius: d, style: f, markerEnd: h, markerStart: p, interactionWidth: m }) => {
    const [g, y, v] = eye({ sourceX: n, sourceY: r, targetX: o, targetY: i }), b = t.isInternal ? void 0 : e;
    return M.jsx(hO, { id: b, path: g, labelX: y, labelY: v, label: s, labelStyle: a, labelShowBg: l, labelBgStyle: c, labelBgPadding: u, labelBgBorderRadius: d, style: f, markerEnd: h, markerStart: p, interactionWidth: m });
  });
}
const Rut = Dye({ isInternal: !1 }), Iye = Dye({ isInternal: !0 });
Rut.displayName = "StraightEdge";
Iye.displayName = "StraightEdgeInternal";
function Nye(t) {
  return Wt(({ id: e, sourceX: n, sourceY: r, targetX: o, targetY: i, sourcePosition: s = pt.Bottom, targetPosition: a = pt.Top, label: l, labelStyle: c, labelShowBg: u, labelBgStyle: d, labelBgPadding: f, labelBgBorderRadius: h, style: p, markerEnd: m, markerStart: g, pathOptions: y, interactionWidth: v }) => {
    const [b, _, w] = Z0e({
      sourceX: n,
      sourceY: r,
      sourcePosition: s,
      targetX: o,
      targetY: i,
      targetPosition: a,
      curvature: y?.curvature
    }), x = t.isInternal ? void 0 : e;
    return M.jsx(hO, { id: x, path: b, labelX: _, labelY: w, label: l, labelStyle: c, labelShowBg: u, labelBgStyle: d, labelBgPadding: f, labelBgBorderRadius: h, style: p, markerEnd: m, markerStart: g, interactionWidth: v });
  });
}
const Put = Nye({ isInternal: !1 }), jye = Nye({ isInternal: !0 });
Put.displayName = "BezierEdge";
jye.displayName = "BezierEdgeInternal";
const ZX = {
  default: jye,
  straight: Iye,
  step: Mye,
  smoothstep: Pye,
  simplebezier: Aye
}, JX = {
  sourceX: null,
  sourceY: null,
  targetX: null,
  targetY: null,
  sourcePosition: null,
  targetPosition: null
}, $ut = (t, e, n) => n === pt.Left ? t - e : n === pt.Right ? t + e : t, Mut = (t, e, n) => n === pt.Top ? t - e : n === pt.Bottom ? t + e : t, eQ = "react-flow__edgeupdater";
function tQ({ position: t, centerX: e, centerY: n, radius: r = 10, onMouseDown: o, onMouseEnter: i, onMouseOut: s, type: a }) {
  return M.jsx("circle", { onMouseDown: o, onMouseEnter: i, onMouseOut: s, className: Rr([eQ, `${eQ}-${a}`]), cx: $ut(e, r, t), cy: Mut(n, r, t), r, stroke: "transparent", fill: "transparent" });
}
function Dut({ isReconnectable: t, reconnectRadius: e, edge: n, sourceX: r, sourceY: o, targetX: i, targetY: s, sourcePosition: a, targetPosition: l, onReconnect: c, onReconnectStart: u, onReconnectEnd: d, setReconnecting: f, setUpdateHover: h }) {
  const p = ir(), m = (_, w) => {
    if (_.button !== 0)
      return;
    const { autoPanOnConnect: x, domNode: E, isValidConnection: S, connectionMode: C, connectionRadius: R, lib: P, onConnectStart: N, onConnectEnd: A, cancelConnection: O, nodeLookup: k, rfId: T, panBy: I, updateConnection: j } = p.getState(), z = w.type === "target";
    f(!0), u?.(_, n, w.type);
    const $ = (U, q) => {
      f(!1), d?.(U, n, w.type, q);
    }, D = (U) => c?.(n, U);
    Mj.onPointerDown(_.nativeEvent, {
      autoPanOnConnect: x,
      connectionMode: C,
      connectionRadius: R,
      domNode: E,
      handleId: w.id,
      nodeId: w.nodeId,
      nodeLookup: k,
      isTarget: z,
      edgeUpdaterType: w.type,
      lib: P,
      flowId: T,
      cancelConnection: O,
      panBy: I,
      isValidConnection: S,
      onConnect: D,
      onConnectStart: N,
      onConnectEnd: A,
      onReconnectEnd: $,
      updateConnection: j,
      getTransform: () => p.getState().transform,
      getFromHandle: () => p.getState().connection.fromHandle
    });
  }, g = (_) => m(_, { nodeId: n.target, id: n.targetHandle ?? null, type: "target" }), y = (_) => m(_, { nodeId: n.source, id: n.sourceHandle ?? null, type: "source" }), v = () => h(!0), b = () => h(!1);
  return M.jsxs(M.Fragment, { children: [(t === !0 || t === "source") && M.jsx(tQ, { position: a, centerX: r, centerY: o, radius: e, onMouseDown: g, onMouseEnter: v, onMouseOut: b, type: "source" }), (t === !0 || t === "target") && M.jsx(tQ, { position: l, centerX: i, centerY: s, radius: e, onMouseDown: y, onMouseEnter: v, onMouseOut: b, type: "target" })] });
}
function Iut({ id: t, edgesFocusable: e, edgesReconnectable: n, elementsSelectable: r, onClick: o, onDoubleClick: i, onContextMenu: s, onMouseEnter: a, onMouseMove: l, onMouseLeave: c, reconnectRadius: u, onReconnect: d, onReconnectStart: f, onReconnectEnd: h, rfId: p, edgeTypes: m, noPanClassName: g, onError: y, disableKeyboardA11y: v }) {
  let b = Yt((L) => L.edgeLookup.get(t));
  const _ = Yt((L) => L.defaultEdgeOptions);
  b = _ ? { ..._, ...b } : b;
  let w = b.type || "default", x = m?.[w] || ZX[w];
  x === void 0 && (y?.("011", cs.error011(w)), w = "default", x = ZX.default);
  const E = !!(b.focusable || e && typeof b.focusable > "u"), S = typeof d < "u" && (b.reconnectable || n && typeof b.reconnectable > "u"), C = !!(b.selectable || r && typeof b.selectable > "u"), R = Ue(null), [P, N] = Ye(!1), [A, O] = Ye(!1), k = ir(), { zIndex: T, sourceX: I, sourceY: j, targetX: z, targetY: $, sourcePosition: D, targetPosition: U } = Yt(Cn((L) => {
    const V = L.nodeLookup.get(b.source), K = L.nodeLookup.get(b.target);
    if (!V || !K)
      return {
        zIndex: b.zIndex,
        ...JX
      };
    const ne = klt({
      id: t,
      sourceNode: V,
      targetNode: K,
      sourceHandle: b.sourceHandle || null,
      targetHandle: b.targetHandle || null,
      connectionMode: L.connectionMode,
      onError: y
    });
    return {
      zIndex: blt({
        selected: b.selected,
        zIndex: b.zIndex,
        sourceNode: V,
        targetNode: K,
        elevateOnSelect: L.elevateEdgesOnSelect
      }),
      ...ne || JX
    };
  }, [b.source, b.target, b.sourceHandle, b.targetHandle, b.selected, b.zIndex]), pr), q = cn(() => b.markerStart ? `url('#${Pj(b.markerStart, p)}')` : void 0, [b.markerStart, p]), F = cn(() => b.markerEnd ? `url('#${Pj(b.markerEnd, p)}')` : void 0, [b.markerEnd, p]);
  if (b.hidden || I === null || j === null || z === null || $ === null)
    return null;
  const B = (L) => {
    const { addSelectedEdges: V, unselectNodesAndEdges: K, multiSelectionActive: ne } = k.getState();
    C && (k.setState({ nodesSelectionActive: !1 }), b.selected && ne ? (K({ nodes: [], edges: [b] }), R.current?.blur()) : V([t])), o && o(L, b);
  }, H = i ? (L) => {
    i(L, { ...b });
  } : void 0, Z = s ? (L) => {
    s(L, { ...b });
  } : void 0, W = a ? (L) => {
    a(L, { ...b });
  } : void 0, G = l ? (L) => {
    l(L, { ...b });
  } : void 0, ee = c ? (L) => {
    c(L, { ...b });
  } : void 0, Y = (L) => {
    if (!v && N0e.includes(L.key) && C) {
      const { unselectNodesAndEdges: V, addSelectedEdges: K } = k.getState();
      L.key === "Escape" ? (R.current?.blur(), V({ edges: [b] })) : K([t]);
    }
  };
  return M.jsx("svg", { style: { zIndex: T }, children: M.jsxs("g", { className: Rr([
    "react-flow__edge",
    `react-flow__edge-${w}`,
    b.className,
    g,
    {
      selected: b.selected,
      animated: b.animated,
      inactive: !C && !o,
      updating: P,
      selectable: C
    }
  ]), onClick: B, onDoubleClick: H, onContextMenu: Z, onMouseEnter: W, onMouseMove: G, onMouseLeave: ee, onKeyDown: E ? Y : void 0, tabIndex: E ? 0 : void 0, role: E ? "button" : "img", "data-id": t, "data-testid": `rf__edge-${t}`, "aria-label": b.ariaLabel === null ? void 0 : b.ariaLabel || `Edge from ${b.source} to ${b.target}`, "aria-describedby": E ? `${pye}-${p}` : void 0, ref: R, children: [!A && M.jsx(x, { id: t, source: b.source, target: b.target, type: b.type, selected: b.selected, animated: b.animated, selectable: C, deletable: b.deletable ?? !0, label: b.label, labelStyle: b.labelStyle, labelShowBg: b.labelShowBg, labelBgStyle: b.labelBgStyle, labelBgPadding: b.labelBgPadding, labelBgBorderRadius: b.labelBgBorderRadius, sourceX: I, sourceY: j, targetX: z, targetY: $, sourcePosition: D, targetPosition: U, data: b.data, style: b.style, sourceHandleId: b.sourceHandle, targetHandleId: b.targetHandle, markerStart: q, markerEnd: F, pathOptions: "pathOptions" in b ? b.pathOptions : void 0, interactionWidth: b.interactionWidth }), S && M.jsx(Dut, { edge: b, isReconnectable: S, reconnectRadius: u, onReconnect: d, onReconnectStart: f, onReconnectEnd: h, sourceX: I, sourceY: j, targetX: z, targetY: $, sourcePosition: D, targetPosition: U, setUpdateHover: N, setReconnecting: O })] }) });
}
const Nut = (t) => ({
  edgesFocusable: t.edgesFocusable,
  edgesReconnectable: t.edgesReconnectable,
  elementsSelectable: t.elementsSelectable,
  connectionMode: t.connectionMode,
  onError: t.onError
});
function Lye({ defaultMarkerColor: t, onlyRenderVisibleElements: e, rfId: n, edgeTypes: r, noPanClassName: o, onReconnect: i, onEdgeContextMenu: s, onEdgeMouseEnter: a, onEdgeMouseMove: l, onEdgeMouseLeave: c, onEdgeClick: u, reconnectRadius: d, onEdgeDoubleClick: f, onReconnectStart: h, onReconnectEnd: p, disableKeyboardA11y: m }) {
  const { edgesFocusable: g, edgesReconnectable: y, elementsSelectable: v, onError: b } = Yt(Nut, pr), _ = wut(e);
  return M.jsxs("div", { className: "react-flow__edges", children: [M.jsx(Cut, { defaultColor: t, rfId: n }), _.map((w) => M.jsx(Iut, { id: w, edgesFocusable: g, edgesReconnectable: y, elementsSelectable: v, noPanClassName: o, onReconnect: i, onContextMenu: s, onMouseEnter: a, onMouseMove: l, onMouseLeave: c, onClick: u, reconnectRadius: d, onDoubleClick: f, onReconnectStart: h, onReconnectEnd: p, rfId: n, onError: b, edgeTypes: r, disableKeyboardA11y: m }, w))] });
}
Lye.displayName = "EdgeRenderer";
const jut = Wt(Lye), Lut = (t) => `translate(${t.transform[0]}px,${t.transform[1]}px) scale(${t.transform[2]})`;
function Fut({ children: t }) {
  const e = Yt(Lut);
  return M.jsx("div", { className: "react-flow__viewport xyflow__viewport react-flow__container", style: { transform: e }, children: t });
}
function But(t) {
  const e = V4(), n = Ue(!1);
  Ne(() => {
    !n.current && e.viewportInitialized && t && (setTimeout(() => t(e), 1), n.current = !0);
  }, [t, e.viewportInitialized]);
}
const zut = (t) => t.panZoom?.syncViewport;
function qut(t) {
  const e = Yt(zut), n = ir();
  return Ne(() => {
    t && (e?.(t), n.setState({ transform: [t.x, t.y, t.zoom] }));
  }, [t, e]), null;
}
function Uut(t) {
  return t.connection.inProgress ? { ...t.connection, to: Dv(t.connection.to, t.transform) } : { ...t.connection };
}
function Hut(t) {
  return Uut;
}
function Vut(t) {
  const e = Hut();
  return Yt(e, pr);
}
const Wut = (t) => ({
  nodesConnectable: t.nodesConnectable,
  isValid: t.connection.isValid,
  inProgress: t.connection.inProgress,
  width: t.width,
  height: t.height
});
function Gut({ containerStyle: t, style: e, type: n, component: r }) {
  const { nodesConnectable: o, width: i, height: s, isValid: a, inProgress: l } = Yt(Wut, pr);
  return i && o && l ? M.jsx("svg", { style: t, width: i, height: s, className: "react-flow__connectionline react-flow__container", children: M.jsx("g", { className: Rr(["react-flow__connection", L0e(a)]), children: M.jsx(Fye, { style: e, type: n, CustomComponent: r, isValid: a }) }) }) : null;
}
const Fye = ({ style: t, type: e = Ac.Bezier, CustomComponent: n, isValid: r }) => {
  const { inProgress: o, from: i, fromNode: s, fromHandle: a, fromPosition: l, to: c, toNode: u, toHandle: d, toPosition: f } = Vut();
  if (!o)
    return;
  if (n)
    return M.jsx(n, { connectionLineType: e, connectionLineStyle: t, fromNode: s, fromHandle: a, fromX: i.x, fromY: i.y, toX: c.x, toY: c.y, fromPosition: l, toPosition: f, connectionStatus: L0e(r), toNode: u, toHandle: d });
  let h = "";
  const p = {
    sourceX: i.x,
    sourceY: i.y,
    sourcePosition: l,
    targetX: c.x,
    targetY: c.y,
    targetPosition: f
  };
  switch (e) {
    case Ac.Bezier:
      [h] = Z0e(p);
      break;
    case Ac.SimpleBezier:
      [h] = Cye(p);
      break;
    case Ac.Step:
      [h] = Rj({
        ...p,
        borderRadius: 0
      });
      break;
    case Ac.SmoothStep:
      [h] = Rj(p);
      break;
    default:
      [h] = eye(p);
  }
  return M.jsx("path", { d: h, fill: "none", className: "react-flow__connection-path", style: t });
};
Fye.displayName = "ConnectionLine";
const Yut = {};
function nQ(t = Yut) {
  const e = Ue(t), n = ir();
  Ne(() => {
    if (process.env.NODE_ENV === "development") {
      const r = /* @__PURE__ */ new Set([...Object.keys(e.current), ...Object.keys(t)]);
      for (const o of r)
        if (e.current[o] !== t[o]) {
          n.getState().onError?.("002", cs.error002());
          break;
        }
      e.current = t;
    }
  }, [t]);
}
function Kut() {
  const t = ir(), e = Ue(!1);
  Ne(() => {
    if (process.env.NODE_ENV === "development" && !e.current) {
      const n = document.querySelector(".react-flow__pane");
      n && window.getComputedStyle(n).zIndex !== "1" && t.getState().onError?.("013", cs.error013("react")), e.current = !0;
    }
  }, []);
}
function Bye({ nodeTypes: t, edgeTypes: e, onInit: n, onNodeClick: r, onEdgeClick: o, onNodeDoubleClick: i, onEdgeDoubleClick: s, onNodeMouseEnter: a, onNodeMouseMove: l, onNodeMouseLeave: c, onNodeContextMenu: u, onSelectionContextMenu: d, onSelectionStart: f, onSelectionEnd: h, connectionLineType: p, connectionLineStyle: m, connectionLineComponent: g, connectionLineContainerStyle: y, selectionKeyCode: v, selectionOnDrag: b, selectionMode: _, multiSelectionKeyCode: w, panActivationKeyCode: x, zoomActivationKeyCode: E, deleteKeyCode: S, onlyRenderVisibleElements: C, elementsSelectable: R, defaultViewport: P, translateExtent: N, minZoom: A, maxZoom: O, preventScrolling: k, defaultMarkerColor: T, zoomOnScroll: I, zoomOnPinch: j, panOnScroll: z, panOnScrollSpeed: $, panOnScrollMode: D, zoomOnDoubleClick: U, panOnDrag: q, onPaneClick: F, onPaneMouseEnter: B, onPaneMouseMove: H, onPaneMouseLeave: Z, onPaneScroll: W, onPaneContextMenu: G, paneClickDistance: ee, nodeClickDistance: Y, onEdgeContextMenu: L, onEdgeMouseEnter: V, onEdgeMouseMove: K, onEdgeMouseLeave: ne, reconnectRadius: ce, onReconnect: fe, onReconnectStart: ve, onReconnectEnd: _e, noDragClassName: Ee, noWheelClassName: Me, noPanClassName: Le, disableKeyboardA11y: Ce, nodeExtent: Je, rfId: Ie, viewport: nt, onViewportChange: ct }) {
  return nQ(t), nQ(e), Kut(), But(n), qut(nt), M.jsx(fut, { onPaneClick: F, onPaneMouseEnter: B, onPaneMouseMove: H, onPaneMouseLeave: Z, onPaneContextMenu: G, onPaneScroll: W, paneClickDistance: ee, deleteKeyCode: S, selectionKeyCode: v, selectionOnDrag: b, selectionMode: _, onSelectionStart: f, onSelectionEnd: h, multiSelectionKeyCode: w, panActivationKeyCode: x, zoomActivationKeyCode: E, elementsSelectable: R, zoomOnScroll: I, zoomOnPinch: j, zoomOnDoubleClick: U, panOnScroll: z, panOnScrollSpeed: $, panOnScrollMode: D, panOnDrag: q, defaultViewport: P, translateExtent: N, minZoom: A, maxZoom: O, onSelectionContextMenu: d, preventScrolling: k, noDragClassName: Ee, noWheelClassName: Me, noPanClassName: Le, disableKeyboardA11y: Ce, onViewportChange: ct, isControlledViewport: !!nt, children: M.jsxs(Fut, { children: [M.jsx(jut, { edgeTypes: e, onEdgeClick: o, onEdgeDoubleClick: s, onReconnect: fe, onReconnectStart: ve, onReconnectEnd: _e, onlyRenderVisibleElements: C, onEdgeContextMenu: L, onEdgeMouseEnter: V, onEdgeMouseMove: K, onEdgeMouseLeave: ne, reconnectRadius: ce, defaultMarkerColor: T, noPanClassName: Le, disableKeyboardA11y: Ce, rfId: Ie }), M.jsx(Gut, { style: m, type: p, component: g, containerStyle: y }), M.jsx("div", { className: "react-flow__edgelabel-renderer" }), M.jsx(_ut, { nodeTypes: t, onNodeClick: r, onNodeDoubleClick: i, onNodeMouseEnter: a, onNodeMouseMove: l, onNodeMouseLeave: c, onNodeContextMenu: u, nodeClickDistance: Y, onlyRenderVisibleElements: C, noPanClassName: Le, noDragClassName: Ee, disableKeyboardA11y: Ce, nodeExtent: Je, rfId: Ie }), M.jsx("div", { className: "react-flow__viewport-portal" })] }) });
}
Bye.displayName = "GraphView";
const Xut = Wt(Bye), rQ = ({ nodes: t, edges: e, defaultNodes: n, defaultEdges: r, width: o, height: i, fitView: s, nodeOrigin: a, nodeExtent: l } = {}) => {
  const c = /* @__PURE__ */ new Map(), u = /* @__PURE__ */ new Map(), d = /* @__PURE__ */ new Map(), f = /* @__PURE__ */ new Map(), h = r ?? e ?? [], p = n ?? t ?? [], m = a ?? [0, 0], g = l ?? Ty;
  nye(d, f, h), $j(p, c, u, {
    nodeOrigin: m,
    nodeExtent: g,
    elevateNodesOnSelect: !1
  });
  let y = [0, 0, 1];
  if (s && o && i) {
    const v = Mv(c, {
      filter: (x) => !!((x.width || x.initialWidth) && (x.height || x.initialHeight))
    }), { x: b, y: _, zoom: w } = F4(v, o, i, 0.5, 2, 0.1);
    y = [b, _, w];
  }
  return {
    rfId: "1",
    width: 0,
    height: 0,
    transform: y,
    nodes: p,
    nodeLookup: c,
    parentLookup: u,
    edges: h,
    edgeLookup: f,
    connectionLookup: d,
    onNodesChange: null,
    onEdgesChange: null,
    hasDefaultNodes: n !== void 0,
    hasDefaultEdges: r !== void 0,
    panZoom: null,
    minZoom: 0.5,
    maxZoom: 2,
    translateExtent: Ty,
    nodeExtent: g,
    nodesSelectionActive: !1,
    userSelectionActive: !1,
    userSelectionRect: null,
    connectionMode: cp.Strict,
    domNode: null,
    paneDragging: !1,
    noPanClassName: "nopan",
    nodeOrigin: m,
    nodeDragThreshold: 1,
    snapGrid: [15, 15],
    snapToGrid: !1,
    nodesDraggable: !0,
    nodesConnectable: !0,
    nodesFocusable: !0,
    edgesFocusable: !0,
    edgesReconnectable: !0,
    elementsSelectable: !0,
    elevateNodesOnSelect: !0,
    elevateEdgesOnSelect: !1,
    fitViewOnInit: !1,
    fitViewDone: !1,
    fitViewOnInitOptions: void 0,
    selectNodesOnDrag: !0,
    multiSelectionActive: !1,
    connection: { ...j0e },
    connectionClickStartHandle: null,
    connectOnClick: !0,
    ariaLiveMessage: "",
    autoPanOnConnect: !0,
    autoPanOnNodeDrag: !0,
    autoPanSpeed: 15,
    connectionRadius: 20,
    onError: V0e,
    isValidConnection: void 0,
    onSelectionChangeHandlers: [],
    lib: "react",
    debug: !1
  };
}, Qut = ({ nodes: t, edges: e, defaultNodes: n, defaultEdges: r, width: o, height: i, fitView: s, nodeOrigin: a, nodeExtent: l }) => pct((c, u) => ({
  ...rQ({ nodes: t, edges: e, width: o, height: i, fitView: s, nodeOrigin: a, nodeExtent: l, defaultNodes: n, defaultEdges: r }),
  setNodes: (d) => {
    const { nodeLookup: f, parentLookup: h, nodeOrigin: p, elevateNodesOnSelect: m } = u();
    $j(d, f, h, {
      nodeOrigin: p,
      nodeExtent: l,
      elevateNodesOnSelect: m,
      checkEquality: !0
    }), c({ nodes: d });
  },
  setEdges: (d) => {
    const { connectionLookup: f, edgeLookup: h } = u();
    nye(f, h, d), c({ edges: d });
  },
  setDefaultNodesAndEdges: (d, f) => {
    if (d) {
      const { setNodes: h } = u();
      h(d), c({ hasDefaultNodes: !0 });
    }
    if (f) {
      const { setEdges: h } = u();
      h(f), c({ hasDefaultEdges: !0 });
    }
  },
  // Every node gets registerd at a ResizeObserver. Whenever a node
  // changes its dimensions, this function is called to measure the
  // new dimensions and update the nodes.
  updateNodeInternals: (d, f = { triggerFitView: !0 }) => {
    const { triggerNodeChanges: h, nodeLookup: p, parentLookup: m, fitViewOnInit: g, fitViewDone: y, fitViewOnInitOptions: v, domNode: b, nodeOrigin: _, nodeExtent: w, debug: x, fitViewSync: E } = u(), { changes: S, updatedInternals: C } = Mlt(d, p, m, b, _, w);
    if (C) {
      if (Rlt(p, m, { nodeOrigin: _, nodeExtent: w }), f.triggerFitView) {
        let R = y;
        !y && g && (R = E({
          ...v,
          nodes: v?.nodes
        })), c({ fitViewDone: R });
      } else
        c({});
      S?.length > 0 && (x && console.log("React Flow: trigger node changes", S), h?.(S));
    }
  },
  updateNodePositions: (d, f = !1) => {
    const h = [], p = [];
    for (const [m, g] of d) {
      const y = !!(g?.expandParent && g?.parentId && g?.position), v = {
        id: m,
        type: "position",
        position: y ? {
          x: Math.max(0, g.position.x),
          y: Math.max(0, g.position.y)
        } : g.position,
        dragging: f
      };
      y && h.push({
        id: m,
        parentId: g.parentId,
        rect: {
          ...g.internals.positionAbsolute,
          width: g.measured.width,
          height: g.measured.height
        }
      }), p.push(v);
    }
    if (h.length > 0) {
      const { nodeLookup: m, parentLookup: g, nodeOrigin: y } = u(), v = U4(h, m, g, y);
      p.push(...v);
    }
    u().triggerNodeChanges(p);
  },
  triggerNodeChanges: (d) => {
    const { onNodesChange: f, setNodes: h, nodes: p, hasDefaultNodes: m, debug: g } = u();
    if (d?.length) {
      if (m) {
        const y = Ict(d, p);
        h(y);
      }
      g && console.log("React Flow: trigger node changes", d), f?.(d);
    }
  },
  triggerEdgeChanges: (d) => {
    const { onEdgesChange: f, setEdges: h, edges: p, hasDefaultEdges: m, debug: g } = u();
    if (d?.length) {
      if (m) {
        const y = Nct(d, p);
        h(y);
      }
      g && console.log("React Flow: trigger edge changes", d), f?.(d);
    }
  },
  addSelectedNodes: (d) => {
    const { multiSelectionActive: f, edgeLookup: h, nodeLookup: p, triggerNodeChanges: m, triggerEdgeChanges: g } = u();
    if (f) {
      const y = d.map((v) => Uu(v, !0));
      m(y);
      return;
    }
    m(nh(p, /* @__PURE__ */ new Set([...d]), !0)), g(nh(h));
  },
  addSelectedEdges: (d) => {
    const { multiSelectionActive: f, edgeLookup: h, nodeLookup: p, triggerNodeChanges: m, triggerEdgeChanges: g } = u();
    if (f) {
      const y = d.map((v) => Uu(v, !0));
      g(y);
      return;
    }
    g(nh(h, /* @__PURE__ */ new Set([...d]))), m(nh(p, /* @__PURE__ */ new Set(), !0));
  },
  unselectNodesAndEdges: ({ nodes: d, edges: f } = {}) => {
    const { edges: h, nodes: p, nodeLookup: m, triggerNodeChanges: g, triggerEdgeChanges: y } = u(), v = d || p, b = f || h, _ = v.map((x) => {
      const E = m.get(x.id);
      return E && (E.selected = !1), Uu(x.id, !1);
    }), w = b.map((x) => Uu(x.id, !1));
    g(_), y(w);
  },
  setMinZoom: (d) => {
    const { panZoom: f, maxZoom: h } = u();
    f?.setScaleExtent([d, h]), c({ minZoom: d });
  },
  setMaxZoom: (d) => {
    const { panZoom: f, minZoom: h } = u();
    f?.setScaleExtent([h, d]), c({ maxZoom: d });
  },
  setTranslateExtent: (d) => {
    u().panZoom?.setTranslateExtent(d), c({ translateExtent: d });
  },
  setPaneClickDistance: (d) => {
    u().panZoom?.setClickDistance(d);
  },
  resetSelectedElements: () => {
    const { edges: d, nodes: f, triggerNodeChanges: h, triggerEdgeChanges: p } = u(), m = f.reduce((y, v) => v.selected ? [...y, Uu(v.id, !1)] : y, []), g = d.reduce((y, v) => v.selected ? [...y, Uu(v.id, !1)] : y, []);
    h(m), p(g);
  },
  setNodeExtent: (d) => {
    const { nodes: f, nodeLookup: h, parentLookup: p, nodeOrigin: m, elevateNodesOnSelect: g, nodeExtent: y } = u();
    d[0][0] === y[0][0] && d[0][1] === y[0][1] && d[1][0] === y[1][0] && d[1][1] === y[1][1] || ($j(f, h, p, {
      nodeOrigin: m,
      nodeExtent: d,
      elevateNodesOnSelect: g,
      checkEquality: !1
    }), c({ nodeExtent: d }));
  },
  panBy: (d) => {
    const { transform: f, width: h, height: p, panZoom: m, translateExtent: g } = u();
    return Dlt({ delta: d, panZoom: m, transform: f, translateExtent: g, width: h, height: p });
  },
  fitView: (d) => {
    const { panZoom: f, width: h, height: p, minZoom: m, maxZoom: g, nodeLookup: y } = u();
    if (!f)
      return Promise.resolve(!1);
    const v = Cj(y, d);
    return kj({
      nodes: v,
      width: h,
      height: p,
      panZoom: f,
      minZoom: m,
      maxZoom: g
    }, d);
  },
  // we can't call an asnychronous function in updateNodeInternals
  // for that we created this sync version of fitView
  fitViewSync: (d) => {
    const { panZoom: f, width: h, height: p, minZoom: m, maxZoom: g, nodeLookup: y } = u();
    if (!f)
      return !1;
    const v = Cj(y, d);
    return kj({
      nodes: v,
      width: h,
      height: p,
      panZoom: f,
      minZoom: m,
      maxZoom: g
    }, d), v.size > 0;
  },
  cancelConnection: () => {
    c({
      connection: { ...j0e }
    });
  },
  updateConnection: (d) => {
    c({ connection: d });
  },
  reset: () => c({ ...rQ() })
}), Object.is);
function Zut({ initialNodes: t, initialEdges: e, defaultNodes: n, defaultEdges: r, initialWidth: o, initialHeight: i, fitView: s, nodeOrigin: a, nodeExtent: l, children: c }) {
  const [u] = Ye(() => Qut({
    nodes: t,
    edges: e,
    defaultNodes: n,
    defaultEdges: r,
    width: o,
    height: i,
    fitView: s,
    nodeOrigin: a,
    nodeExtent: l
  }));
  return M.jsx(mct, { value: u, children: M.jsx(Bct, { children: c }) });
}
function Jut({ children: t, nodes: e, edges: n, defaultNodes: r, defaultEdges: o, width: i, height: s, fitView: a, nodeOrigin: l, nodeExtent: c }) {
  return Hn(dO) ? M.jsx(M.Fragment, { children: t }) : M.jsx(Zut, { initialNodes: e, initialEdges: n, defaultNodes: r, defaultEdges: o, initialWidth: i, initialHeight: s, fitView: a, nodeOrigin: l, nodeExtent: c, children: t });
}
const edt = {
  width: "100%",
  height: "100%",
  overflow: "hidden",
  position: "relative",
  zIndex: 0
};
function tdt({ nodes: t, edges: e, defaultNodes: n, defaultEdges: r, className: o, nodeTypes: i, edgeTypes: s, onNodeClick: a, onEdgeClick: l, onInit: c, onMove: u, onMoveStart: d, onMoveEnd: f, onConnect: h, onConnectStart: p, onConnectEnd: m, onClickConnectStart: g, onClickConnectEnd: y, onNodeMouseEnter: v, onNodeMouseMove: b, onNodeMouseLeave: _, onNodeContextMenu: w, onNodeDoubleClick: x, onNodeDragStart: E, onNodeDrag: S, onNodeDragStop: C, onNodesDelete: R, onEdgesDelete: P, onDelete: N, onSelectionChange: A, onSelectionDragStart: O, onSelectionDrag: k, onSelectionDragStop: T, onSelectionContextMenu: I, onSelectionStart: j, onSelectionEnd: z, onBeforeDelete: $, connectionMode: D, connectionLineType: U = Ac.Bezier, connectionLineStyle: q, connectionLineComponent: F, connectionLineContainerStyle: B, deleteKeyCode: H = "Backspace", selectionKeyCode: Z = "Shift", selectionOnDrag: W = !1, selectionMode: G = Ry.Full, panActivationKeyCode: ee = "Space", multiSelectionKeyCode: Y = bE() ? "Meta" : "Control", zoomActivationKeyCode: L = bE() ? "Meta" : "Control", snapToGrid: V, snapGrid: K, onlyRenderVisibleElements: ne = !1, selectNodesOnDrag: ce, nodesDraggable: fe, nodesConnectable: ve, nodesFocusable: _e, nodeOrigin: Ee = mye, edgesFocusable: Me, edgesReconnectable: Le, elementsSelectable: Ce = !0, defaultViewport: Je = Act, minZoom: Ie = 0.5, maxZoom: nt = 2, translateExtent: ct = Ty, preventScrolling: mt = !0, nodeExtent: gt, defaultMarkerColor: Et = "#b1b1b7", zoomOnScroll: Rt = !0, zoomOnPinch: zt = !0, panOnScroll: At = !1, panOnScrollSpeed: X = 0.5, panOnScrollMode: ae = Ed.Free, zoomOnDoubleClick: ye = !0, panOnDrag: De = !0, onPaneClick: Te, onPaneMouseEnter: st, onPaneMouseMove: ft, onPaneMouseLeave: Ht, onPaneScroll: nn, onPaneContextMenu: It, paneClickDistance: Rn = 0, nodeClickDistance: yt = 0, children: oe, onReconnect: ge, onReconnectStart: pe, onReconnectEnd: He, onEdgeContextMenu: re, onEdgeDoubleClick: J, onEdgeMouseEnter: ie, onEdgeMouseMove: me, onEdgeMouseLeave: be, reconnectRadius: tt = 10, onNodesChange: Ke, onEdgesChange: Fe, noDragClassName: We = "nodrag", noWheelClassName: Xe = "nowheel", noPanClassName: at = "nopan", fitView: bt, fitViewOptions: Lt, connectOnClick: bn, attributionPosition: un, proOptions: Qe, defaultEdgeOptions: se, elevateNodesOnSelect: Re, elevateEdgesOnSelect: ot, disableKeyboardA11y: Xt = !1, autoPanOnConnect: Dn, autoPanOnNodeDrag: Zn, autoPanSpeed: Fr, connectionRadius: sr, isValidConnection: $o, onError: Vn, style: of, id: Xl, nodeDragThreshold: Wp, viewport: Qv, onViewportChange: Zv, width: Jv, height: KO, colorMode: XO = "light", debug: Gp, ...QO }, eb) {
  const sf = Xl || "1", ZO = $ct(XO);
  return M.jsx("div", { "data-testid": "rf__wrapper", ...QO, style: { ...of, ...edt }, ref: eb, className: Rr(["react-flow", o, ZO]), id: Xl, children: M.jsxs(Jut, { nodes: t, edges: e, width: Jv, height: KO, fitView: bt, nodeOrigin: Ee, nodeExtent: gt, children: [M.jsx(Xut, { onInit: c, onNodeClick: a, onEdgeClick: l, onNodeMouseEnter: v, onNodeMouseMove: b, onNodeMouseLeave: _, onNodeContextMenu: w, onNodeDoubleClick: x, nodeTypes: i, edgeTypes: s, connectionLineType: U, connectionLineStyle: q, connectionLineComponent: F, connectionLineContainerStyle: B, selectionKeyCode: Z, selectionOnDrag: W, selectionMode: G, deleteKeyCode: H, multiSelectionKeyCode: Y, panActivationKeyCode: ee, zoomActivationKeyCode: L, onlyRenderVisibleElements: ne, defaultViewport: Je, translateExtent: ct, minZoom: Ie, maxZoom: nt, preventScrolling: mt, zoomOnScroll: Rt, zoomOnPinch: zt, zoomOnDoubleClick: ye, panOnScroll: At, panOnScrollSpeed: X, panOnScrollMode: ae, panOnDrag: De, onPaneClick: Te, onPaneMouseEnter: st, onPaneMouseMove: ft, onPaneMouseLeave: Ht, onPaneScroll: nn, onPaneContextMenu: It, paneClickDistance: Rn, nodeClickDistance: yt, onSelectionContextMenu: I, onSelectionStart: j, onSelectionEnd: z, onReconnect: ge, onReconnectStart: pe, onReconnectEnd: He, onEdgeContextMenu: re, onEdgeDoubleClick: J, onEdgeMouseEnter: ie, onEdgeMouseMove: me, onEdgeMouseLeave: be, reconnectRadius: tt, defaultMarkerColor: Et, noDragClassName: We, noWheelClassName: Xe, noPanClassName: at, rfId: sf, disableKeyboardA11y: Xt, nodeExtent: gt, viewport: Qv, onViewportChange: Zv }), M.jsx(Pct, { nodes: t, edges: e, defaultNodes: n, defaultEdges: r, onConnect: h, onConnectStart: p, onConnectEnd: m, onClickConnectStart: g, onClickConnectEnd: y, nodesDraggable: fe, nodesConnectable: ve, nodesFocusable: _e, edgesFocusable: Me, edgesReconnectable: Le, elementsSelectable: Ce, elevateNodesOnSelect: Re, elevateEdgesOnSelect: ot, minZoom: Ie, maxZoom: nt, nodeExtent: gt, onNodesChange: Ke, onEdgesChange: Fe, snapToGrid: V, snapGrid: K, connectionMode: D, translateExtent: ct, connectOnClick: bn, defaultEdgeOptions: se, fitView: bt, fitViewOptions: Lt, onNodesDelete: R, onEdgesDelete: P, onDelete: N, onNodeDragStart: E, onNodeDrag: S, onNodeDragStop: C, onSelectionDrag: k, onSelectionDragStart: O, onSelectionDragStop: T, onMove: u, onMoveStart: d, onMoveEnd: f, noPanClassName: at, nodeOrigin: Ee, rfId: sf, autoPanOnConnect: Dn, autoPanOnNodeDrag: Zn, autoPanSpeed: Fr, onError: Vn, connectionRadius: sr, isValidConnection: $o, selectNodesOnDrag: ce, nodeDragThreshold: Wp, onBeforeDelete: $, paneClickDistance: Rn, debug: Gp }), M.jsx(kct, { onSelectionChange: A }), oe, M.jsx(xct, { proOptions: Qe, position: un }), M.jsx(_ct, { rfId: sf, disableKeyboardA11y: Xt })] }) });
}
yye(tdt);
function ndt({ dimensions: t, lineWidth: e, variant: n, className: r }) {
  return M.jsx("path", { strokeWidth: e, d: `M${t[0] / 2} 0 V${t[1]} M0 ${t[1] / 2} H${t[0]}`, className: Rr(["react-flow__background-pattern", n, r]) });
}
function rdt({ radius: t, className: e }) {
  return M.jsx("circle", { cx: t, cy: t, r: t, className: Rr(["react-flow__background-pattern", "dots", e]) });
}
var Gc;
(function(t) {
  t.Lines = "lines", t.Dots = "dots", t.Cross = "cross";
})(Gc || (Gc = {}));
const odt = {
  [Gc.Dots]: 1,
  [Gc.Lines]: 1,
  [Gc.Cross]: 6
}, idt = (t) => ({ transform: t.transform, patternId: `pattern-${t.rfId}` });
function zye({
  id: t,
  variant: e = Gc.Dots,
  // only used for dots and cross
  gap: n = 20,
  // only used for lines and cross
  size: r,
  lineWidth: o = 1,
  offset: i = 0,
  color: s,
  bgColor: a,
  style: l,
  className: c,
  patternClassName: u
}) {
  const d = Ue(null), { transform: f, patternId: h } = Yt(idt, pr), p = r || odt[e], m = e === Gc.Dots, g = e === Gc.Cross, y = Array.isArray(n) ? n : [n, n], v = [y[0] * f[2] || 1, y[1] * f[2] || 1], b = p * f[2], _ = Array.isArray(i) ? i : [i, i], w = g ? [b, b] : v, x = [
    _[0] * f[2] || 1 + w[0] / 2,
    _[1] * f[2] || 1 + w[1] / 2
  ], E = `${h}${t || ""}`;
  return M.jsxs("svg", { className: Rr(["react-flow__background", c]), style: {
    ...l,
    ...fO,
    "--xy-background-color-props": a,
    "--xy-background-pattern-color-props": s
  }, ref: d, "data-testid": "rf__background", children: [M.jsx("pattern", { id: E, x: f[0] % v[0], y: f[1] % v[1], width: v[0], height: v[1], patternUnits: "userSpaceOnUse", patternTransform: `translate(-${x[0]},-${x[1]})`, children: m ? M.jsx(rdt, { radius: b / 2, className: u }) : M.jsx(ndt, { dimensions: w, lineWidth: o, variant: e, className: u }) }), M.jsx("rect", { x: "0", y: "0", width: "100%", height: "100%", fill: `url(#${E})` })] });
}
zye.displayName = "Background";
Wt(zye);
function sdt() {
  return M.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32", children: M.jsx("path", { d: "M32 18.133H18.133V32h-4.266V18.133H0v-4.266h13.867V0h4.266v13.867H32z" }) });
}
function adt() {
  return M.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 5", children: M.jsx("path", { d: "M0 0h32v4.2H0z" }) });
}
function ldt() {
  return M.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 30", children: M.jsx("path", { d: "M3.692 4.63c0-.53.4-.938.939-.938h5.215V0H4.708C2.13 0 0 2.054 0 4.63v5.216h3.692V4.631zM27.354 0h-5.2v3.692h5.17c.53 0 .984.4.984.939v5.215H32V4.631A4.624 4.624 0 0027.354 0zm.954 24.83c0 .532-.4.94-.939.94h-5.215v3.768h5.215c2.577 0 4.631-2.13 4.631-4.707v-5.139h-3.692v5.139zm-23.677.94c-.531 0-.939-.4-.939-.94v-5.138H0v5.139c0 2.577 2.13 4.707 4.708 4.707h5.138V25.77H4.631z" }) });
}
function cdt() {
  return M.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 25 32", children: M.jsx("path", { d: "M21.333 10.667H19.81V7.619C19.81 3.429 16.38 0 12.19 0 8 0 4.571 3.429 4.571 7.619v3.048H3.048A3.056 3.056 0 000 13.714v15.238A3.056 3.056 0 003.048 32h18.285a3.056 3.056 0 003.048-3.048V13.714a3.056 3.056 0 00-3.048-3.047zM12.19 24.533a3.056 3.056 0 01-3.047-3.047 3.056 3.056 0 013.047-3.048 3.056 3.056 0 013.048 3.048 3.056 3.056 0 01-3.048 3.047zm4.724-13.866H7.467V7.619c0-2.59 2.133-4.724 4.723-4.724 2.591 0 4.724 2.133 4.724 4.724v3.048z" }) });
}
function udt() {
  return M.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 25 32", children: M.jsx("path", { d: "M21.333 10.667H19.81V7.619C19.81 3.429 16.38 0 12.19 0c-4.114 1.828-1.37 2.133.305 2.438 1.676.305 4.42 2.59 4.42 5.181v3.048H3.047A3.056 3.056 0 000 13.714v15.238A3.056 3.056 0 003.048 32h18.285a3.056 3.056 0 003.048-3.048V13.714a3.056 3.056 0 00-3.048-3.047zM12.19 24.533a3.056 3.056 0 01-3.047-3.047 3.056 3.056 0 013.047-3.048 3.056 3.056 0 013.048 3.048 3.056 3.056 0 01-3.048 3.047z" }) });
}
function R1({ children: t, className: e, ...n }) {
  return M.jsx("button", { type: "button", className: Rr(["react-flow__controls-button", e]), ...n, children: t });
}
const ddt = (t) => ({
  isInteractive: t.nodesDraggable || t.nodesConnectable || t.elementsSelectable,
  minZoomReached: t.transform[2] <= t.minZoom,
  maxZoomReached: t.transform[2] >= t.maxZoom
});
function qye({ style: t, showZoom: e = !0, showFitView: n = !0, showInteractive: r = !0, fitViewOptions: o, onZoomIn: i, onZoomOut: s, onFitView: a, onInteractiveChange: l, className: c, children: u, position: d = "bottom-left", orientation: f = "vertical", "aria-label": h = "React Flow controls" }) {
  const p = ir(), { isInteractive: m, minZoomReached: g, maxZoomReached: y } = Yt(ddt, pr), { zoomIn: v, zoomOut: b, fitView: _ } = V4(), w = () => {
    v(), i?.();
  }, x = () => {
    b(), s?.();
  }, E = () => {
    _(o), a?.();
  }, S = () => {
    p.setState({
      nodesDraggable: !m,
      nodesConnectable: !m,
      elementsSelectable: !m
    }), l?.(!m);
  }, C = f === "horizontal" ? "horizontal" : "vertical";
  return M.jsxs(H4, { className: Rr(["react-flow__controls", C, c]), position: d, style: t, "data-testid": "rf__controls", "aria-label": h, children: [e && M.jsxs(M.Fragment, { children: [M.jsx(R1, { onClick: w, className: "react-flow__controls-zoomin", title: "zoom in", "aria-label": "zoom in", disabled: y, children: M.jsx(sdt, {}) }), M.jsx(R1, { onClick: x, className: "react-flow__controls-zoomout", title: "zoom out", "aria-label": "zoom out", disabled: g, children: M.jsx(adt, {}) })] }), n && M.jsx(R1, { className: "react-flow__controls-fitview", onClick: E, title: "fit view", "aria-label": "fit view", children: M.jsx(ldt, {}) }), r && M.jsx(R1, { className: "react-flow__controls-interactive", onClick: S, title: "toggle interactivity", "aria-label": "toggle interactivity", children: m ? M.jsx(udt, {}) : M.jsx(cdt, {}) }), u] });
}
qye.displayName = "Controls";
Wt(qye);
function fdt({ id: t, x: e, y: n, width: r, height: o, style: i, color: s, strokeColor: a, strokeWidth: l, className: c, borderRadius: u, shapeRendering: d, selected: f, onClick: h }) {
  const { background: p, backgroundColor: m } = i || {}, g = s || p || m;
  return M.jsx("rect", { className: Rr(["react-flow__minimap-node", { selected: f }, c]), x: e, y: n, rx: u, ry: u, width: r, height: o, style: {
    fill: g,
    stroke: a,
    strokeWidth: l
  }, shapeRendering: d, onClick: h ? (y) => h(y, t) : void 0 });
}
const hdt = Wt(fdt), pdt = (t) => t.nodes.map((e) => e.id), oT = (t) => t instanceof Function ? t : () => t;
function mdt({
  nodeStrokeColor: t,
  nodeColor: e,
  nodeClassName: n = "",
  nodeBorderRadius: r = 5,
  nodeStrokeWidth: o,
  // We need to rename the prop to be `CapitalCase` so that JSX will render it as
  // a component properly.
  nodeComponent: i = hdt,
  onClick: s
}) {
  const a = Yt(pdt, pr), l = oT(e), c = oT(t), u = oT(n), d = typeof window > "u" || window.chrome ? "crispEdges" : "geometricPrecision";
  return M.jsx(M.Fragment, { children: a.map((f) => (
    // The split of responsibilities between MiniMapNodes and
    // NodeComponentWrapper may appear weird. However, it’s designed to
    // minimize the cost of updates when individual nodes change.
    //
    // For more details, see a similar commit in `NodeRenderer/index.tsx`.
    M.jsx(ydt, { id: f, nodeColorFunc: l, nodeStrokeColorFunc: c, nodeClassNameFunc: u, nodeBorderRadius: r, nodeStrokeWidth: o, NodeComponent: i, onClick: s, shapeRendering: d }, f)
  )) });
}
function gdt({ id: t, nodeColorFunc: e, nodeStrokeColorFunc: n, nodeClassNameFunc: r, nodeBorderRadius: o, nodeStrokeWidth: i, shapeRendering: s, NodeComponent: a, onClick: l }) {
  const { node: c, x: u, y: d, width: f, height: h } = Yt((p) => {
    const m = p.nodeLookup.get(t), { x: g, y } = m.internals.positionAbsolute, { width: v, height: b } = Gl(m);
    return {
      node: m,
      x: g,
      y,
      width: v,
      height: b
    };
  }, pr);
  return !c || c.hidden || !G0e(c) ? null : M.jsx(a, { x: u, y: d, width: f, height: h, style: c.style, selected: !!c.selected, className: r(c), color: e(c), borderRadius: o, strokeColor: n(c), strokeWidth: i, shapeRendering: s, onClick: l, id: c.id });
}
const ydt = Wt(gdt);
var vdt = Wt(mdt);
const bdt = 200, _dt = 150, wdt = (t) => {
  const e = {
    x: -t.transform[0] / t.transform[2],
    y: -t.transform[1] / t.transform[2],
    width: t.width / t.transform[2],
    height: t.height / t.transform[2]
  };
  return {
    viewBB: e,
    boundingRect: t.nodeLookup.size > 0 ? H0e(Mv(t.nodeLookup), e) : e,
    rfId: t.rfId,
    panZoom: t.panZoom,
    translateExtent: t.translateExtent,
    flowWidth: t.width,
    flowHeight: t.height
  };
}, xdt = "react-flow__minimap-desc";
function Uye({
  style: t,
  className: e,
  nodeStrokeColor: n,
  nodeColor: r,
  nodeClassName: o = "",
  nodeBorderRadius: i = 5,
  nodeStrokeWidth: s,
  // We need to rename the prop to be `CapitalCase` so that JSX will render it as
  // a component properly.
  nodeComponent: a,
  bgColor: l,
  maskColor: c,
  maskStrokeColor: u,
  maskStrokeWidth: d,
  position: f = "bottom-right",
  onClick: h,
  onNodeClick: p,
  pannable: m = !1,
  zoomable: g = !1,
  ariaLabel: y = "React Flow mini map",
  inversePan: v,
  zoomStep: b = 10,
  offsetScale: _ = 5
}) {
  const w = ir(), x = Ue(null), { boundingRect: E, viewBB: S, rfId: C, panZoom: R, translateExtent: P, flowWidth: N, flowHeight: A } = Yt(wdt, pr), O = t?.width ?? bdt, k = t?.height ?? _dt, T = E.width / O, I = E.height / k, j = Math.max(T, I), z = j * O, $ = j * k, D = _ * j, U = E.x - (z - E.width) / 2 - D, q = E.y - ($ - E.height) / 2 - D, F = z + D * 2, B = $ + D * 2, H = `${xdt}-${C}`, Z = Ue(0), W = Ue();
  Z.current = j, Ne(() => {
    if (x.current && R)
      return W.current = qlt({
        domNode: x.current,
        panZoom: R,
        getTransform: () => w.getState().transform,
        getViewScale: () => Z.current
      }), () => {
        W.current?.destroy();
      };
  }, [R]), Ne(() => {
    W.current?.update({
      translateExtent: P,
      width: N,
      height: A,
      inversePan: v,
      pannable: m,
      zoomStep: b,
      zoomable: g
    });
  }, [m, g, v, b, P, N, A]);
  const G = h ? (Y) => {
    const [L, V] = W.current?.pointer(Y) || [0, 0];
    h(Y, { x: L, y: V });
  } : void 0, ee = p ? Cn((Y, L) => {
    const V = w.getState().nodeLookup.get(L);
    p(Y, V);
  }, []) : void 0;
  return M.jsx(H4, { position: f, style: {
    ...t,
    "--xy-minimap-background-color-props": typeof l == "string" ? l : void 0,
    "--xy-minimap-mask-background-color-props": typeof c == "string" ? c : void 0,
    "--xy-minimap-mask-stroke-color-props": typeof u == "string" ? u : void 0,
    "--xy-minimap-mask-stroke-width-props": typeof d == "number" ? d * j : void 0,
    "--xy-minimap-node-background-color-props": typeof r == "string" ? r : void 0,
    "--xy-minimap-node-stroke-color-props": typeof n == "string" ? n : void 0,
    "--xy-minimap-node-stroke-width-props": typeof s == "string" ? s : void 0
  }, className: Rr(["react-flow__minimap", e]), "data-testid": "rf__minimap", children: M.jsxs("svg", { width: O, height: k, viewBox: `${U} ${q} ${F} ${B}`, className: "react-flow__minimap-svg", role: "img", "aria-labelledby": H, ref: x, onClick: G, children: [y && M.jsx("title", { id: H, children: y }), M.jsx(vdt, { onClick: ee, nodeColor: r, nodeStrokeColor: n, nodeBorderRadius: i, nodeClassName: o, nodeStrokeWidth: s, nodeComponent: a }), M.jsx("path", { className: "react-flow__minimap-mask", d: `M${U - D},${q - D}h${F + D * 2}v${B + D * 2}h${-F - D * 2}z
        M${S.x},${S.y}h${S.width}v${S.height}h${-S.width}z`, fillRule: "evenodd", pointerEvents: "none" })] }) });
}
Uye.displayName = "MiniMap";
Wt(Uye);
function Edt({ nodeId: t, position: e, variant: n = h0.Handle, className: r, style: o = {}, children: i, color: s, minWidth: a = 10, minHeight: l = 10, maxWidth: c = Number.MAX_VALUE, maxHeight: u = Number.MAX_VALUE, keepAspectRatio: d = !1, shouldResize: f, onResizeStart: h, onResize: p, onResizeEnd: m }) {
  const g = wye(), y = typeof t == "string" ? t : g, v = ir(), b = Ue(null), _ = n === h0.Line ? "right" : "bottom-right", w = e ?? _, x = Ue(null);
  Ne(() => {
    if (!(!b.current || !y))
      return x.current || (x.current = rct({
        domNode: b.current,
        nodeId: y,
        getStoreItems: () => {
          const { nodeLookup: R, transform: P, snapGrid: N, snapToGrid: A, nodeOrigin: O, domNode: k } = v.getState();
          return {
            nodeLookup: R,
            transform: P,
            snapGrid: N,
            snapToGrid: A,
            nodeOrigin: O,
            paneDomNode: k
          };
        },
        onChange: (R, P) => {
          const { triggerNodeChanges: N, nodeLookup: A, parentLookup: O, nodeOrigin: k } = v.getState(), T = [], I = { x: R.x, y: R.y }, j = A.get(y);
          if (j && j.expandParent && j.parentId) {
            const z = j.origin ?? k, $ = R.width ?? j.measured.width, D = R.height ?? j.measured.height, U = {
              id: j.id,
              parentId: j.parentId,
              rect: {
                width: $,
                height: D,
                ...Y0e({
                  x: R.x ?? j.position.x,
                  y: R.y ?? j.position.y
                }, { width: $, height: D }, j.parentId, A, z)
              }
            }, q = U4([U], A, O, k);
            T.push(...q), I.x = R.x ? Math.max(z[0] * $, R.x) : void 0, I.y = R.y ? Math.max(z[1] * D, R.y) : void 0;
          }
          if (I.x !== void 0 && I.y !== void 0) {
            const z = {
              id: y,
              type: "position",
              position: { ...I }
            };
            T.push(z);
          }
          if (R.width !== void 0 && R.height !== void 0) {
            const z = {
              id: y,
              type: "dimensions",
              resizing: !0,
              setAttributes: !0,
              dimensions: {
                width: R.width,
                height: R.height
              }
            };
            T.push(z);
          }
          for (const z of P) {
            const $ = {
              ...z,
              type: "position"
            };
            T.push($);
          }
          N(T);
        },
        onEnd: () => {
          const R = {
            id: y,
            type: "dimensions",
            resizing: !1
          };
          v.getState().triggerNodeChanges([R]);
        }
      })), x.current.update({
        controlPosition: w,
        boundaries: {
          minWidth: a,
          minHeight: l,
          maxWidth: c,
          maxHeight: u
        },
        keepAspectRatio: d,
        onResizeStart: h,
        onResize: p,
        onResizeEnd: m,
        shouldResize: f
      }), () => {
        x.current?.destroy();
      };
  }, [
    w,
    a,
    l,
    c,
    u,
    d,
    h,
    p,
    m,
    f
  ]);
  const E = w.split("-"), S = n === h0.Line ? "borderColor" : "backgroundColor", C = s ? { ...o, [S]: s } : o;
  return M.jsx("div", { className: Rr(["react-flow__resize-control", "nodrag", ...E, n, r]), ref: b, style: C, children: i });
}
Wt(Edt);
var Sdt = Object.defineProperty, xE = Object.getOwnPropertySymbols, Hye = Object.prototype.hasOwnProperty, Vye = Object.prototype.propertyIsEnumerable, oQ = (t, e, n) => e in t ? Sdt(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n, Ij = (t, e) => {
  for (var n in e || (e = {}))
    Hye.call(e, n) && oQ(t, n, e[n]);
  if (xE)
    for (var n of xE(e))
      Vye.call(e, n) && oQ(t, n, e[n]);
  return t;
}, Nj = (t, e) => {
  var n = {};
  for (var r in t)
    Hye.call(t, r) && e.indexOf(r) < 0 && (n[r] = t[r]);
  if (t != null && xE)
    for (var r of xE(t))
      e.indexOf(r) < 0 && Vye.call(t, r) && (n[r] = t[r]);
  return n;
};
/**
 * @license QR Code generator library (TypeScript)
 * Copyright (c) Project Nayuki.
 * SPDX-License-Identifier: MIT
 */
var zd;
((t) => {
  const e = class jt {
    /*-- Constructor (low level) and fields --*/
    // Creates a new QR Code with the given version number,
    // error correction level, data codeword bytes, and mask number.
    // This is a low-level API that most users should not use directly.
    // A mid-level API is the encodeSegments() function.
    constructor(l, c, u, d) {
      if (this.version = l, this.errorCorrectionLevel = c, this.modules = [], this.isFunction = [], l < jt.MIN_VERSION || l > jt.MAX_VERSION)
        throw new RangeError("Version value out of range");
      if (d < -1 || d > 7)
        throw new RangeError("Mask value out of range");
      this.size = l * 4 + 17;
      let f = [];
      for (let p = 0; p < this.size; p++)
        f.push(!1);
      for (let p = 0; p < this.size; p++)
        this.modules.push(f.slice()), this.isFunction.push(f.slice());
      this.drawFunctionPatterns();
      const h = this.addEccAndInterleave(u);
      if (this.drawCodewords(h), d == -1) {
        let p = 1e9;
        for (let m = 0; m < 8; m++) {
          this.applyMask(m), this.drawFormatBits(m);
          const g = this.getPenaltyScore();
          g < p && (d = m, p = g), this.applyMask(m);
        }
      }
      o(0 <= d && d <= 7), this.mask = d, this.applyMask(d), this.drawFormatBits(d), this.isFunction = [];
    }
    /*-- Static factory functions (high level) --*/
    // Returns a QR Code representing the given Unicode text string at the given error correction level.
    // As a conservative upper bound, this function is guaranteed to succeed for strings that have 738 or fewer
    // Unicode code points (not UTF-16 code units) if the low error correction level is used. The smallest possible
    // QR Code version is automatically chosen for the output. The ECC level of the result may be higher than the
    // ecl argument if it can be done without increasing the version.
    static encodeText(l, c) {
      const u = t.QrSegment.makeSegments(l);
      return jt.encodeSegments(u, c);
    }
    // Returns a QR Code representing the given binary data at the given error correction level.
    // This function always encodes using the binary segment mode, not any text mode. The maximum number of
    // bytes allowed is 2953. The smallest possible QR Code version is automatically chosen for the output.
    // The ECC level of the result may be higher than the ecl argument if it can be done without increasing the version.
    static encodeBinary(l, c) {
      const u = t.QrSegment.makeBytes(l);
      return jt.encodeSegments([u], c);
    }
    /*-- Static factory functions (mid level) --*/
    // Returns a QR Code representing the given segments with the given encoding parameters.
    // The smallest possible QR Code version within the given range is automatically
    // chosen for the output. Iff boostEcl is true, then the ECC level of the result
    // may be higher than the ecl argument if it can be done without increasing the
    // version. The mask number is either between 0 to 7 (inclusive) to force that
    // mask, or -1 to automatically choose an appropriate mask (which may be slow).
    // This function allows the user to create a custom sequence of segments that switches
    // between modes (such as alphanumeric and byte) to encode text in less space.
    // This is a mid-level API; the high-level API is encodeText() and encodeBinary().
    static encodeSegments(l, c, u = 1, d = 40, f = -1, h = !0) {
      if (!(jt.MIN_VERSION <= u && u <= d && d <= jt.MAX_VERSION) || f < -1 || f > 7)
        throw new RangeError("Invalid value");
      let p, m;
      for (p = u; ; p++) {
        const b = jt.getNumDataCodewords(p, c) * 8, _ = s.getTotalBits(l, p);
        if (_ <= b) {
          m = _;
          break;
        }
        if (p >= d)
          throw new RangeError("Data too long");
      }
      for (const b of [jt.Ecc.MEDIUM, jt.Ecc.QUARTILE, jt.Ecc.HIGH])
        h && m <= jt.getNumDataCodewords(p, b) * 8 && (c = b);
      let g = [];
      for (const b of l) {
        n(b.mode.modeBits, 4, g), n(b.numChars, b.mode.numCharCountBits(p), g);
        for (const _ of b.getData())
          g.push(_);
      }
      o(g.length == m);
      const y = jt.getNumDataCodewords(p, c) * 8;
      o(g.length <= y), n(0, Math.min(4, y - g.length), g), n(0, (8 - g.length % 8) % 8, g), o(g.length % 8 == 0);
      for (let b = 236; g.length < y; b ^= 253)
        n(b, 8, g);
      let v = [];
      for (; v.length * 8 < g.length; )
        v.push(0);
      return g.forEach((b, _) => v[_ >>> 3] |= b << 7 - (_ & 7)), new jt(p, c, v, f);
    }
    /*-- Accessor methods --*/
    // Returns the color of the module (pixel) at the given coordinates, which is false
    // for light or true for dark. The top left corner has the coordinates (x=0, y=0).
    // If the given coordinates are out of bounds, then false (light) is returned.
    getModule(l, c) {
      return 0 <= l && l < this.size && 0 <= c && c < this.size && this.modules[c][l];
    }
    // Modified to expose modules for easy access
    getModules() {
      return this.modules;
    }
    /*-- Private helper methods for constructor: Drawing function modules --*/
    // Reads this object's version field, and draws and marks all function modules.
    drawFunctionPatterns() {
      for (let u = 0; u < this.size; u++)
        this.setFunctionModule(6, u, u % 2 == 0), this.setFunctionModule(u, 6, u % 2 == 0);
      this.drawFinderPattern(3, 3), this.drawFinderPattern(this.size - 4, 3), this.drawFinderPattern(3, this.size - 4);
      const l = this.getAlignmentPatternPositions(), c = l.length;
      for (let u = 0; u < c; u++)
        for (let d = 0; d < c; d++)
          u == 0 && d == 0 || u == 0 && d == c - 1 || u == c - 1 && d == 0 || this.drawAlignmentPattern(l[u], l[d]);
      this.drawFormatBits(0), this.drawVersion();
    }
    // Draws two copies of the format bits (with its own error correction code)
    // based on the given mask and this object's error correction level field.
    drawFormatBits(l) {
      const c = this.errorCorrectionLevel.formatBits << 3 | l;
      let u = c;
      for (let f = 0; f < 10; f++)
        u = u << 1 ^ (u >>> 9) * 1335;
      const d = (c << 10 | u) ^ 21522;
      o(d >>> 15 == 0);
      for (let f = 0; f <= 5; f++)
        this.setFunctionModule(8, f, r(d, f));
      this.setFunctionModule(8, 7, r(d, 6)), this.setFunctionModule(8, 8, r(d, 7)), this.setFunctionModule(7, 8, r(d, 8));
      for (let f = 9; f < 15; f++)
        this.setFunctionModule(14 - f, 8, r(d, f));
      for (let f = 0; f < 8; f++)
        this.setFunctionModule(this.size - 1 - f, 8, r(d, f));
      for (let f = 8; f < 15; f++)
        this.setFunctionModule(8, this.size - 15 + f, r(d, f));
      this.setFunctionModule(8, this.size - 8, !0);
    }
    // Draws two copies of the version bits (with its own error correction code),
    // based on this object's version field, iff 7 <= version <= 40.
    drawVersion() {
      if (this.version < 7)
        return;
      let l = this.version;
      for (let u = 0; u < 12; u++)
        l = l << 1 ^ (l >>> 11) * 7973;
      const c = this.version << 12 | l;
      o(c >>> 18 == 0);
      for (let u = 0; u < 18; u++) {
        const d = r(c, u), f = this.size - 11 + u % 3, h = Math.floor(u / 3);
        this.setFunctionModule(f, h, d), this.setFunctionModule(h, f, d);
      }
    }
    // Draws a 9*9 finder pattern including the border separator,
    // with the center module at (x, y). Modules can be out of bounds.
    drawFinderPattern(l, c) {
      for (let u = -4; u <= 4; u++)
        for (let d = -4; d <= 4; d++) {
          const f = Math.max(Math.abs(d), Math.abs(u)), h = l + d, p = c + u;
          0 <= h && h < this.size && 0 <= p && p < this.size && this.setFunctionModule(h, p, f != 2 && f != 4);
        }
    }
    // Draws a 5*5 alignment pattern, with the center module
    // at (x, y). All modules must be in bounds.
    drawAlignmentPattern(l, c) {
      for (let u = -2; u <= 2; u++)
        for (let d = -2; d <= 2; d++)
          this.setFunctionModule(l + d, c + u, Math.max(Math.abs(d), Math.abs(u)) != 1);
    }
    // Sets the color of a module and marks it as a function module.
    // Only used by the constructor. Coordinates must be in bounds.
    setFunctionModule(l, c, u) {
      this.modules[c][l] = u, this.isFunction[c][l] = !0;
    }
    /*-- Private helper methods for constructor: Codewords and masking --*/
    // Returns a new byte string representing the given data with the appropriate error correction
    // codewords appended to it, based on this object's version and error correction level.
    addEccAndInterleave(l) {
      const c = this.version, u = this.errorCorrectionLevel;
      if (l.length != jt.getNumDataCodewords(c, u))
        throw new RangeError("Invalid argument");
      const d = jt.NUM_ERROR_CORRECTION_BLOCKS[u.ordinal][c], f = jt.ECC_CODEWORDS_PER_BLOCK[u.ordinal][c], h = Math.floor(jt.getNumRawDataModules(c) / 8), p = d - h % d, m = Math.floor(h / d);
      let g = [];
      const y = jt.reedSolomonComputeDivisor(f);
      for (let b = 0, _ = 0; b < d; b++) {
        let w = l.slice(_, _ + m - f + (b < p ? 0 : 1));
        _ += w.length;
        const x = jt.reedSolomonComputeRemainder(w, y);
        b < p && w.push(0), g.push(w.concat(x));
      }
      let v = [];
      for (let b = 0; b < g[0].length; b++)
        g.forEach((_, w) => {
          (b != m - f || w >= p) && v.push(_[b]);
        });
      return o(v.length == h), v;
    }
    // Draws the given sequence of 8-bit codewords (data and error correction) onto the entire
    // data area of this QR Code. Function modules need to be marked off before this is called.
    drawCodewords(l) {
      if (l.length != Math.floor(jt.getNumRawDataModules(this.version) / 8))
        throw new RangeError("Invalid argument");
      let c = 0;
      for (let u = this.size - 1; u >= 1; u -= 2) {
        u == 6 && (u = 5);
        for (let d = 0; d < this.size; d++)
          for (let f = 0; f < 2; f++) {
            const h = u - f, p = (u + 1 & 2) == 0 ? this.size - 1 - d : d;
            !this.isFunction[p][h] && c < l.length * 8 && (this.modules[p][h] = r(l[c >>> 3], 7 - (c & 7)), c++);
          }
      }
      o(c == l.length * 8);
    }
    // XORs the codeword modules in this QR Code with the given mask pattern.
    // The function modules must be marked and the codeword bits must be drawn
    // before masking. Due to the arithmetic of XOR, calling applyMask() with
    // the same mask value a second time will undo the mask. A final well-formed
    // QR Code needs exactly one (not zero, two, etc.) mask applied.
    applyMask(l) {
      if (l < 0 || l > 7)
        throw new RangeError("Mask value out of range");
      for (let c = 0; c < this.size; c++)
        for (let u = 0; u < this.size; u++) {
          let d;
          switch (l) {
            case 0:
              d = (u + c) % 2 == 0;
              break;
            case 1:
              d = c % 2 == 0;
              break;
            case 2:
              d = u % 3 == 0;
              break;
            case 3:
              d = (u + c) % 3 == 0;
              break;
            case 4:
              d = (Math.floor(u / 3) + Math.floor(c / 2)) % 2 == 0;
              break;
            case 5:
              d = u * c % 2 + u * c % 3 == 0;
              break;
            case 6:
              d = (u * c % 2 + u * c % 3) % 2 == 0;
              break;
            case 7:
              d = ((u + c) % 2 + u * c % 3) % 2 == 0;
              break;
            default:
              throw new Error("Unreachable");
          }
          !this.isFunction[c][u] && d && (this.modules[c][u] = !this.modules[c][u]);
        }
    }
    // Calculates and returns the penalty score based on state of this QR Code's current modules.
    // This is used by the automatic mask choice algorithm to find the mask pattern that yields the lowest score.
    getPenaltyScore() {
      let l = 0;
      for (let f = 0; f < this.size; f++) {
        let h = !1, p = 0, m = [0, 0, 0, 0, 0, 0, 0];
        for (let g = 0; g < this.size; g++)
          this.modules[f][g] == h ? (p++, p == 5 ? l += jt.PENALTY_N1 : p > 5 && l++) : (this.finderPenaltyAddHistory(p, m), h || (l += this.finderPenaltyCountPatterns(m) * jt.PENALTY_N3), h = this.modules[f][g], p = 1);
        l += this.finderPenaltyTerminateAndCount(h, p, m) * jt.PENALTY_N3;
      }
      for (let f = 0; f < this.size; f++) {
        let h = !1, p = 0, m = [0, 0, 0, 0, 0, 0, 0];
        for (let g = 0; g < this.size; g++)
          this.modules[g][f] == h ? (p++, p == 5 ? l += jt.PENALTY_N1 : p > 5 && l++) : (this.finderPenaltyAddHistory(p, m), h || (l += this.finderPenaltyCountPatterns(m) * jt.PENALTY_N3), h = this.modules[g][f], p = 1);
        l += this.finderPenaltyTerminateAndCount(h, p, m) * jt.PENALTY_N3;
      }
      for (let f = 0; f < this.size - 1; f++)
        for (let h = 0; h < this.size - 1; h++) {
          const p = this.modules[f][h];
          p == this.modules[f][h + 1] && p == this.modules[f + 1][h] && p == this.modules[f + 1][h + 1] && (l += jt.PENALTY_N2);
        }
      let c = 0;
      for (const f of this.modules)
        c = f.reduce((h, p) => h + (p ? 1 : 0), c);
      const u = this.size * this.size, d = Math.ceil(Math.abs(c * 20 - u * 10) / u) - 1;
      return o(0 <= d && d <= 9), l += d * jt.PENALTY_N4, o(0 <= l && l <= 2568888), l;
    }
    /*-- Private helper functions --*/
    // Returns an ascending list of positions of alignment patterns for this version number.
    // Each position is in the range [0,177), and are used on both the x and y axes.
    // This could be implemented as lookup table of 40 variable-length lists of integers.
    getAlignmentPatternPositions() {
      if (this.version == 1)
        return [];
      {
        const l = Math.floor(this.version / 7) + 2, c = this.version == 32 ? 26 : Math.ceil((this.version * 4 + 4) / (l * 2 - 2)) * 2;
        let u = [6];
        for (let d = this.size - 7; u.length < l; d -= c)
          u.splice(1, 0, d);
        return u;
      }
    }
    // Returns the number of data bits that can be stored in a QR Code of the given version number, after
    // all function modules are excluded. This includes remainder bits, so it might not be a multiple of 8.
    // The result is in the range [208, 29648]. This could be implemented as a 40-entry lookup table.
    static getNumRawDataModules(l) {
      if (l < jt.MIN_VERSION || l > jt.MAX_VERSION)
        throw new RangeError("Version number out of range");
      let c = (16 * l + 128) * l + 64;
      if (l >= 2) {
        const u = Math.floor(l / 7) + 2;
        c -= (25 * u - 10) * u - 55, l >= 7 && (c -= 36);
      }
      return o(208 <= c && c <= 29648), c;
    }
    // Returns the number of 8-bit data (i.e. not error correction) codewords contained in any
    // QR Code of the given version number and error correction level, with remainder bits discarded.
    // This stateless pure function could be implemented as a (40*4)-cell lookup table.
    static getNumDataCodewords(l, c) {
      return Math.floor(jt.getNumRawDataModules(l) / 8) - jt.ECC_CODEWORDS_PER_BLOCK[c.ordinal][l] * jt.NUM_ERROR_CORRECTION_BLOCKS[c.ordinal][l];
    }
    // Returns a Reed-Solomon ECC generator polynomial for the given degree. This could be
    // implemented as a lookup table over all possible parameter values, instead of as an algorithm.
    static reedSolomonComputeDivisor(l) {
      if (l < 1 || l > 255)
        throw new RangeError("Degree out of range");
      let c = [];
      for (let d = 0; d < l - 1; d++)
        c.push(0);
      c.push(1);
      let u = 1;
      for (let d = 0; d < l; d++) {
        for (let f = 0; f < c.length; f++)
          c[f] = jt.reedSolomonMultiply(c[f], u), f + 1 < c.length && (c[f] ^= c[f + 1]);
        u = jt.reedSolomonMultiply(u, 2);
      }
      return c;
    }
    // Returns the Reed-Solomon error correction codeword for the given data and divisor polynomials.
    static reedSolomonComputeRemainder(l, c) {
      let u = c.map((d) => 0);
      for (const d of l) {
        const f = d ^ u.shift();
        u.push(0), c.forEach((h, p) => u[p] ^= jt.reedSolomonMultiply(h, f));
      }
      return u;
    }
    // Returns the product of the two given field elements modulo GF(2^8/0x11D). The arguments and result
    // are unsigned 8-bit integers. This could be implemented as a lookup table of 256*256 entries of uint8.
    static reedSolomonMultiply(l, c) {
      if (l >>> 8 || c >>> 8)
        throw new RangeError("Byte out of range");
      let u = 0;
      for (let d = 7; d >= 0; d--)
        u = u << 1 ^ (u >>> 7) * 285, u ^= (c >>> d & 1) * l;
      return o(u >>> 8 == 0), u;
    }
    // Can only be called immediately after a light run is added, and
    // returns either 0, 1, or 2. A helper function for getPenaltyScore().
    finderPenaltyCountPatterns(l) {
      const c = l[1];
      o(c <= this.size * 3);
      const u = c > 0 && l[2] == c && l[3] == c * 3 && l[4] == c && l[5] == c;
      return (u && l[0] >= c * 4 && l[6] >= c ? 1 : 0) + (u && l[6] >= c * 4 && l[0] >= c ? 1 : 0);
    }
    // Must be called at the end of a line (row or column) of modules. A helper function for getPenaltyScore().
    finderPenaltyTerminateAndCount(l, c, u) {
      return l && (this.finderPenaltyAddHistory(c, u), c = 0), c += this.size, this.finderPenaltyAddHistory(c, u), this.finderPenaltyCountPatterns(u);
    }
    // Pushes the given value to the front and drops the last value. A helper function for getPenaltyScore().
    finderPenaltyAddHistory(l, c) {
      c[0] == 0 && (l += this.size), c.pop(), c.unshift(l);
    }
  };
  e.MIN_VERSION = 1, e.MAX_VERSION = 40, e.PENALTY_N1 = 3, e.PENALTY_N2 = 3, e.PENALTY_N3 = 40, e.PENALTY_N4 = 10, e.ECC_CODEWORDS_PER_BLOCK = [
    // Version: (note that index 0 is for padding, and is set to an illegal value)
    //0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40    Error correction level
    [-1, 7, 10, 15, 20, 26, 18, 20, 24, 30, 18, 20, 24, 26, 30, 22, 24, 28, 30, 28, 28, 28, 28, 30, 30, 26, 28, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30],
    // Low
    [-1, 10, 16, 26, 18, 24, 16, 18, 22, 22, 26, 30, 22, 22, 24, 24, 28, 28, 26, 26, 26, 26, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28],
    // Medium
    [-1, 13, 22, 18, 26, 18, 24, 18, 22, 20, 24, 28, 26, 24, 20, 30, 24, 28, 28, 26, 30, 28, 30, 30, 30, 30, 28, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30],
    // Quartile
    [-1, 17, 28, 22, 16, 22, 28, 26, 26, 24, 28, 24, 28, 22, 24, 24, 30, 28, 28, 26, 28, 30, 24, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30]
    // High
  ], e.NUM_ERROR_CORRECTION_BLOCKS = [
    // Version: (note that index 0 is for padding, and is set to an illegal value)
    //0, 1, 2, 3, 4, 5, 6, 7, 8, 9,10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40    Error correction level
    [-1, 1, 1, 1, 1, 1, 2, 2, 2, 2, 4, 4, 4, 4, 4, 6, 6, 6, 6, 7, 8, 8, 9, 9, 10, 12, 12, 12, 13, 14, 15, 16, 17, 18, 19, 19, 20, 21, 22, 24, 25],
    // Low
    [-1, 1, 1, 1, 2, 2, 4, 4, 4, 5, 5, 5, 8, 9, 9, 10, 10, 11, 13, 14, 16, 17, 17, 18, 20, 21, 23, 25, 26, 28, 29, 31, 33, 35, 37, 38, 40, 43, 45, 47, 49],
    // Medium
    [-1, 1, 1, 2, 2, 4, 4, 6, 6, 8, 8, 8, 10, 12, 16, 12, 17, 16, 18, 21, 20, 23, 23, 25, 27, 29, 34, 34, 35, 38, 40, 43, 45, 48, 51, 53, 56, 59, 62, 65, 68],
    // Quartile
    [-1, 1, 1, 2, 4, 4, 4, 5, 6, 8, 8, 11, 11, 16, 16, 18, 16, 19, 21, 25, 25, 25, 34, 30, 32, 35, 37, 40, 42, 45, 48, 51, 54, 57, 60, 63, 66, 70, 74, 77, 81]
    // High
  ], t.QrCode = e;
  function n(a, l, c) {
    if (l < 0 || l > 31 || a >>> l)
      throw new RangeError("Value out of range");
    for (let u = l - 1; u >= 0; u--)
      c.push(a >>> u & 1);
  }
  function r(a, l) {
    return (a >>> l & 1) != 0;
  }
  function o(a) {
    if (!a)
      throw new Error("Assertion error");
  }
  const i = class cr {
    /*-- Constructor (low level) and fields --*/
    // Creates a new QR Code segment with the given attributes and data.
    // The character count (numChars) must agree with the mode and the bit buffer length,
    // but the constraint isn't checked. The given bit buffer is cloned and stored.
    constructor(l, c, u) {
      if (this.mode = l, this.numChars = c, this.bitData = u, c < 0)
        throw new RangeError("Invalid argument");
      this.bitData = u.slice();
    }
    /*-- Static factory functions (mid level) --*/
    // Returns a segment representing the given binary data encoded in
    // byte mode. All input byte arrays are acceptable. Any text string
    // can be converted to UTF-8 bytes and encoded as a byte mode segment.
    static makeBytes(l) {
      let c = [];
      for (const u of l)
        n(u, 8, c);
      return new cr(cr.Mode.BYTE, l.length, c);
    }
    // Returns a segment representing the given string of decimal digits encoded in numeric mode.
    static makeNumeric(l) {
      if (!cr.isNumeric(l))
        throw new RangeError("String contains non-numeric characters");
      let c = [];
      for (let u = 0; u < l.length; ) {
        const d = Math.min(l.length - u, 3);
        n(parseInt(l.substring(u, u + d), 10), d * 3 + 1, c), u += d;
      }
      return new cr(cr.Mode.NUMERIC, l.length, c);
    }
    // Returns a segment representing the given text string encoded in alphanumeric mode.
    // The characters allowed are: 0 to 9, A to Z (uppercase only), space,
    // dollar, percent, asterisk, plus, hyphen, period, slash, colon.
    static makeAlphanumeric(l) {
      if (!cr.isAlphanumeric(l))
        throw new RangeError("String contains unencodable characters in alphanumeric mode");
      let c = [], u;
      for (u = 0; u + 2 <= l.length; u += 2) {
        let d = cr.ALPHANUMERIC_CHARSET.indexOf(l.charAt(u)) * 45;
        d += cr.ALPHANUMERIC_CHARSET.indexOf(l.charAt(u + 1)), n(d, 11, c);
      }
      return u < l.length && n(cr.ALPHANUMERIC_CHARSET.indexOf(l.charAt(u)), 6, c), new cr(cr.Mode.ALPHANUMERIC, l.length, c);
    }
    // Returns a new mutable list of zero or more segments to represent the given Unicode text string.
    // The result may use various segment modes and switch modes to optimize the length of the bit stream.
    static makeSegments(l) {
      return l == "" ? [] : cr.isNumeric(l) ? [cr.makeNumeric(l)] : cr.isAlphanumeric(l) ? [cr.makeAlphanumeric(l)] : [cr.makeBytes(cr.toUtf8ByteArray(l))];
    }
    // Returns a segment representing an Extended Channel Interpretation
    // (ECI) designator with the given assignment value.
    static makeEci(l) {
      let c = [];
      if (l < 0)
        throw new RangeError("ECI assignment value out of range");
      if (l < 128)
        n(l, 8, c);
      else if (l < 16384)
        n(2, 2, c), n(l, 14, c);
      else if (l < 1e6)
        n(6, 3, c), n(l, 21, c);
      else
        throw new RangeError("ECI assignment value out of range");
      return new cr(cr.Mode.ECI, 0, c);
    }
    // Tests whether the given string can be encoded as a segment in numeric mode.
    // A string is encodable iff each character is in the range 0 to 9.
    static isNumeric(l) {
      return cr.NUMERIC_REGEX.test(l);
    }
    // Tests whether the given string can be encoded as a segment in alphanumeric mode.
    // A string is encodable iff each character is in the following set: 0 to 9, A to Z
    // (uppercase only), space, dollar, percent, asterisk, plus, hyphen, period, slash, colon.
    static isAlphanumeric(l) {
      return cr.ALPHANUMERIC_REGEX.test(l);
    }
    /*-- Methods --*/
    // Returns a new copy of the data bits of this segment.
    getData() {
      return this.bitData.slice();
    }
    // (Package-private) Calculates and returns the number of bits needed to encode the given segments at
    // the given version. The result is infinity if a segment has too many characters to fit its length field.
    static getTotalBits(l, c) {
      let u = 0;
      for (const d of l) {
        const f = d.mode.numCharCountBits(c);
        if (d.numChars >= 1 << f)
          return 1 / 0;
        u += 4 + f + d.bitData.length;
      }
      return u;
    }
    // Returns a new array of bytes representing the given string encoded in UTF-8.
    static toUtf8ByteArray(l) {
      l = encodeURI(l);
      let c = [];
      for (let u = 0; u < l.length; u++)
        l.charAt(u) != "%" ? c.push(l.charCodeAt(u)) : (c.push(parseInt(l.substring(u + 1, u + 3), 16)), u += 2);
      return c;
    }
  };
  i.NUMERIC_REGEX = /^[0-9]*$/, i.ALPHANUMERIC_REGEX = /^[A-Z0-9 $%*+.\/:-]*$/, i.ALPHANUMERIC_CHARSET = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ $%*+-./:";
  let s = i;
  t.QrSegment = i;
})(zd || (zd = {}));
((t) => {
  ((e) => {
    const n = class {
      // The QR Code can tolerate about 30% erroneous codewords
      /*-- Constructor and fields --*/
      constructor(r, o) {
        this.ordinal = r, this.formatBits = o;
      }
    };
    n.LOW = new n(0, 1), n.MEDIUM = new n(1, 0), n.QUARTILE = new n(2, 3), n.HIGH = new n(3, 2), e.Ecc = n;
  })(t.QrCode || (t.QrCode = {}));
})(zd || (zd = {}));
((t) => {
  ((e) => {
    const n = class {
      /*-- Constructor and fields --*/
      constructor(r, o) {
        this.modeBits = r, this.numBitsCharCount = o;
      }
      /*-- Method --*/
      // (Package-private) Returns the bit width of the character count field for a segment in
      // this mode in a QR Code at the given version number. The result is in the range [0, 16].
      numCharCountBits(r) {
        return this.numBitsCharCount[Math.floor((r + 7) / 17)];
      }
    };
    n.NUMERIC = new n(1, [10, 12, 14]), n.ALPHANUMERIC = new n(2, [9, 11, 13]), n.BYTE = new n(4, [8, 16, 16]), n.KANJI = new n(8, [8, 10, 12]), n.ECI = new n(7, [0, 0, 0]), e.Mode = n;
  })(t.QrSegment || (t.QrSegment = {}));
})(zd || (zd = {}));
var rh = zd;
/**
 * @license qrcode.react
 * Copyright (c) Paul O'Shannessy
 * SPDX-License-Identifier: ISC
 */
var Odt = {
  L: rh.QrCode.Ecc.LOW,
  M: rh.QrCode.Ecc.MEDIUM,
  Q: rh.QrCode.Ecc.QUARTILE,
  H: rh.QrCode.Ecc.HIGH
}, Wye = 128, Gye = "L", Yye = "#FFFFFF", Kye = "#000000", Xye = !1, Qye = 1, Cdt = 4, kdt = 0, Adt = 0.1;
function Zye(t, e = 0) {
  const n = [];
  return t.forEach(function(r, o) {
    let i = null;
    r.forEach(function(s, a) {
      if (!s && i !== null) {
        n.push(
          `M${i + e} ${o + e}h${a - i}v1H${i + e}z`
        ), i = null;
        return;
      }
      if (a === r.length - 1) {
        if (!s)
          return;
        i === null ? n.push(`M${a + e},${o + e} h1v1H${a + e}z`) : n.push(
          `M${i + e},${o + e} h${a + 1 - i}v1H${i + e}z`
        );
        return;
      }
      s && i === null && (i = a);
    });
  }), n.join("");
}
function Jye(t, e) {
  return t.slice().map((n, r) => r < e.y || r >= e.y + e.h ? n : n.map((o, i) => i < e.x || i >= e.x + e.w ? o : !1));
}
function Tdt(t, e, n, r) {
  if (r == null)
    return null;
  const o = t.length + n * 2, i = Math.floor(e * Adt), s = o / e, a = (r.width || i) * s, l = (r.height || i) * s, c = r.x == null ? t.length / 2 - a / 2 : r.x * s, u = r.y == null ? t.length / 2 - l / 2 : r.y * s, d = r.opacity == null ? 1 : r.opacity;
  let f = null;
  if (r.excavate) {
    let p = Math.floor(c), m = Math.floor(u), g = Math.ceil(a + c - p), y = Math.ceil(l + u - m);
    f = { x: p, y: m, w: g, h: y };
  }
  const h = r.crossOrigin;
  return { x: c, y: u, h: l, w: a, excavation: f, opacity: d, crossOrigin: h };
}
function Rdt(t, e) {
  return e != null ? Math.max(Math.floor(e), 0) : t ? Cdt : kdt;
}
function eve({
  value: t,
  level: e,
  minVersion: n,
  includeMargin: r,
  marginSize: o,
  imageSettings: i,
  size: s,
  boostLevel: a
}) {
  let l = xe.useMemo(() => {
    const h = (Array.isArray(t) ? t : [t]).reduce((p, m) => (p.push(...rh.QrSegment.makeSegments(m)), p), []);
    return rh.QrCode.encodeSegments(
      h,
      Odt[e],
      n,
      void 0,
      void 0,
      a
    );
  }, [t, e, n, a]);
  const { cells: c, margin: u, numCells: d, calculatedImageSettings: f } = xe.useMemo(() => {
    let h = l.getModules();
    const p = Rdt(r, o), m = h.length + p * 2, g = Tdt(
      h,
      s,
      p,
      i
    );
    return {
      cells: h,
      margin: p,
      numCells: m,
      calculatedImageSettings: g
    };
  }, [l, s, i, r, o]);
  return {
    qrcode: l,
    margin: u,
    cells: c,
    numCells: d,
    calculatedImageSettings: f
  };
}
var Pdt = function() {
  try {
    new Path2D().addPath(new Path2D());
  } catch {
    return !1;
  }
  return !0;
}(), $dt = xe.forwardRef(
  function(t, e) {
    const n = t, {
      value: r,
      size: o = Wye,
      level: i = Gye,
      bgColor: s = Yye,
      fgColor: a = Kye,
      includeMargin: l = Xye,
      minVersion: c = Qye,
      boostLevel: u,
      marginSize: d,
      imageSettings: f
    } = n, h = Nj(n, [
      "value",
      "size",
      "level",
      "bgColor",
      "fgColor",
      "includeMargin",
      "minVersion",
      "boostLevel",
      "marginSize",
      "imageSettings"
    ]), { style: p } = h, m = Nj(h, ["style"]), g = f?.src, y = xe.useRef(null), v = xe.useRef(null), b = xe.useCallback(
      (N) => {
        y.current = N, typeof e == "function" ? e(N) : e && (e.current = N);
      },
      [e]
    ), [_, w] = xe.useState(!1), { margin: x, cells: E, numCells: S, calculatedImageSettings: C } = eve({
      value: r,
      level: i,
      minVersion: c,
      boostLevel: u,
      includeMargin: l,
      marginSize: d,
      imageSettings: f,
      size: o
    });
    xe.useEffect(() => {
      if (y.current != null) {
        const N = y.current, A = N.getContext("2d");
        if (!A)
          return;
        let O = E;
        const k = v.current, T = C != null && k !== null && k.complete && k.naturalHeight !== 0 && k.naturalWidth !== 0;
        T && C.excavation != null && (O = Jye(
          E,
          C.excavation
        ));
        const I = window.devicePixelRatio || 1;
        N.height = N.width = o * I;
        const j = o / S * I;
        A.scale(j, j), A.fillStyle = s, A.fillRect(0, 0, S, S), A.fillStyle = a, Pdt ? A.fill(new Path2D(Zye(O, x))) : E.forEach(function(z, $) {
          z.forEach(function(D, U) {
            D && A.fillRect(U + x, $ + x, 1, 1);
          });
        }), C && (A.globalAlpha = C.opacity), T && A.drawImage(
          k,
          C.x + x,
          C.y + x,
          C.w,
          C.h
        );
      }
    }), xe.useEffect(() => {
      w(!1);
    }, [g]);
    const R = Ij({ height: o, width: o }, p);
    let P = null;
    return g != null && (P = /* @__PURE__ */ xe.createElement(
      "img",
      {
        src: g,
        key: g,
        style: { display: "none" },
        onLoad: () => {
          w(!0);
        },
        ref: v,
        crossOrigin: C?.crossOrigin
      }
    )), /* @__PURE__ */ xe.createElement(xe.Fragment, null, /* @__PURE__ */ xe.createElement(
      "canvas",
      Ij({
        style: R,
        height: o,
        width: o,
        ref: b,
        role: "img"
      }, m)
    ), P);
  }
);
$dt.displayName = "QRCodeCanvas";
var Mdt = xe.forwardRef(
  function(t, e) {
    const n = t, {
      value: r,
      size: o = Wye,
      level: i = Gye,
      bgColor: s = Yye,
      fgColor: a = Kye,
      includeMargin: l = Xye,
      minVersion: c = Qye,
      boostLevel: u,
      title: d,
      marginSize: f,
      imageSettings: h
    } = n, p = Nj(n, [
      "value",
      "size",
      "level",
      "bgColor",
      "fgColor",
      "includeMargin",
      "minVersion",
      "boostLevel",
      "title",
      "marginSize",
      "imageSettings"
    ]), { margin: m, cells: g, numCells: y, calculatedImageSettings: v } = eve({
      value: r,
      level: i,
      minVersion: c,
      boostLevel: u,
      includeMargin: l,
      marginSize: f,
      imageSettings: h,
      size: o
    });
    let b = g, _ = null;
    h != null && v != null && (v.excavation != null && (b = Jye(
      g,
      v.excavation
    )), _ = /* @__PURE__ */ xe.createElement(
      "image",
      {
        href: h.src,
        height: v.h,
        width: v.w,
        x: v.x + m,
        y: v.y + m,
        preserveAspectRatio: "none",
        opacity: v.opacity,
        crossOrigin: v.crossOrigin
      }
    ));
    const w = Zye(b, m);
    return /* @__PURE__ */ xe.createElement(
      "svg",
      Ij({
        height: o,
        width: o,
        viewBox: `0 0 ${y} ${y}`,
        ref: e,
        role: "img"
      }, p),
      !!d && /* @__PURE__ */ xe.createElement("title", null, d),
      /* @__PURE__ */ xe.createElement(
        "path",
        {
          fill: s,
          d: `M0,0 h${y}v${y}H0z`,
          shapeRendering: "crispEdges"
        }
      ),
      /* @__PURE__ */ xe.createElement("path", { fill: a, d: w, shapeRendering: "crispEdges" }),
      _
    );
  }
);
Mdt.displayName = "QRCodeSVG";
var tve = function() {
  if (typeof Map < "u")
    return Map;
  function t(e, n) {
    var r = -1;
    return e.some(function(o, i) {
      return o[0] === n ? (r = i, !0) : !1;
    }), r;
  }
  return (
    /** @class */
    function() {
      function e() {
        this.__entries__ = [];
      }
      return Object.defineProperty(e.prototype, "size", {
        /**
         * @returns {boolean}
         */
        get: function() {
          return this.__entries__.length;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.get = function(n) {
        var r = t(this.__entries__, n), o = this.__entries__[r];
        return o && o[1];
      }, e.prototype.set = function(n, r) {
        var o = t(this.__entries__, n);
        ~o ? this.__entries__[o][1] = r : this.__entries__.push([n, r]);
      }, e.prototype.delete = function(n) {
        var r = this.__entries__, o = t(r, n);
        ~o && r.splice(o, 1);
      }, e.prototype.has = function(n) {
        return !!~t(this.__entries__, n);
      }, e.prototype.clear = function() {
        this.__entries__.splice(0);
      }, e.prototype.forEach = function(n, r) {
        r === void 0 && (r = null);
        for (var o = 0, i = this.__entries__; o < i.length; o++) {
          var s = i[o];
          n.call(r, s[1], s[0]);
        }
      }, e;
    }()
  );
}(), jj = typeof window < "u" && typeof document < "u" && window.document === document, EE = function() {
  return typeof global < "u" && global.Math === Math ? global : typeof self < "u" && self.Math === Math ? self : typeof window < "u" && window.Math === Math ? window : Function("return this")();
}(), Ddt = function() {
  return typeof requestAnimationFrame == "function" ? requestAnimationFrame.bind(EE) : function(t) {
    return setTimeout(function() {
      return t(Date.now());
    }, 1e3 / 60);
  };
}(), Idt = 2;
function Ndt(t, e) {
  var n = !1, r = !1, o = 0;
  function i() {
    n && (n = !1, t()), r && a();
  }
  function s() {
    Ddt(i);
  }
  function a() {
    var l = Date.now();
    if (n) {
      if (l - o < Idt)
        return;
      r = !0;
    } else
      n = !0, r = !1, setTimeout(s, e);
    o = l;
  }
  return a;
}
var jdt = 20, Ldt = ["top", "right", "bottom", "left", "width", "height", "size", "weight"], Fdt = typeof MutationObserver < "u", Bdt = (
  /** @class */
  function() {
    function t() {
      this.connected_ = !1, this.mutationEventsAdded_ = !1, this.mutationsObserver_ = null, this.observers_ = [], this.onTransitionEnd_ = this.onTransitionEnd_.bind(this), this.refresh = Ndt(this.refresh.bind(this), jdt);
    }
    return t.prototype.addObserver = function(e) {
      ~this.observers_.indexOf(e) || this.observers_.push(e), this.connected_ || this.connect_();
    }, t.prototype.removeObserver = function(e) {
      var n = this.observers_, r = n.indexOf(e);
      ~r && n.splice(r, 1), !n.length && this.connected_ && this.disconnect_();
    }, t.prototype.refresh = function() {
      var e = this.updateObservers_();
      e && this.refresh();
    }, t.prototype.updateObservers_ = function() {
      var e = this.observers_.filter(function(n) {
        return n.gatherActive(), n.hasActive();
      });
      return e.forEach(function(n) {
        return n.broadcastActive();
      }), e.length > 0;
    }, t.prototype.connect_ = function() {
      !jj || this.connected_ || (document.addEventListener("transitionend", this.onTransitionEnd_), window.addEventListener("resize", this.refresh), Fdt ? (this.mutationsObserver_ = new MutationObserver(this.refresh), this.mutationsObserver_.observe(document, {
        attributes: !0,
        childList: !0,
        characterData: !0,
        subtree: !0
      })) : (document.addEventListener("DOMSubtreeModified", this.refresh), this.mutationEventsAdded_ = !0), this.connected_ = !0);
    }, t.prototype.disconnect_ = function() {
      !jj || !this.connected_ || (document.removeEventListener("transitionend", this.onTransitionEnd_), window.removeEventListener("resize", this.refresh), this.mutationsObserver_ && this.mutationsObserver_.disconnect(), this.mutationEventsAdded_ && document.removeEventListener("DOMSubtreeModified", this.refresh), this.mutationsObserver_ = null, this.mutationEventsAdded_ = !1, this.connected_ = !1);
    }, t.prototype.onTransitionEnd_ = function(e) {
      var n = e.propertyName, r = n === void 0 ? "" : n, o = Ldt.some(function(i) {
        return !!~r.indexOf(i);
      });
      o && this.refresh();
    }, t.getInstance = function() {
      return this.instance_ || (this.instance_ = new t()), this.instance_;
    }, t.instance_ = null, t;
  }()
), nve = function(t, e) {
  for (var n = 0, r = Object.keys(e); n < r.length; n++) {
    var o = r[n];
    Object.defineProperty(t, o, {
      value: e[o],
      enumerable: !1,
      writable: !1,
      configurable: !0
    });
  }
  return t;
}, hp = function(t) {
  var e = t && t.ownerDocument && t.ownerDocument.defaultView;
  return e || EE;
}, rve = pO(0, 0, 0, 0);
function SE(t) {
  return parseFloat(t) || 0;
}
function iQ(t) {
  for (var e = [], n = 1; n < arguments.length; n++)
    e[n - 1] = arguments[n];
  return e.reduce(function(r, o) {
    var i = t["border-" + o + "-width"];
    return r + SE(i);
  }, 0);
}
function zdt(t) {
  for (var e = ["top", "right", "bottom", "left"], n = {}, r = 0, o = e; r < o.length; r++) {
    var i = o[r], s = t["padding-" + i];
    n[i] = SE(s);
  }
  return n;
}
function qdt(t) {
  var e = t.getBBox();
  return pO(0, 0, e.width, e.height);
}
function Udt(t) {
  var e = t.clientWidth, n = t.clientHeight;
  if (!e && !n)
    return rve;
  var r = hp(t).getComputedStyle(t), o = zdt(r), i = o.left + o.right, s = o.top + o.bottom, a = SE(r.width), l = SE(r.height);
  if (r.boxSizing === "border-box" && (Math.round(a + i) !== e && (a -= iQ(r, "left", "right") + i), Math.round(l + s) !== n && (l -= iQ(r, "top", "bottom") + s)), !Vdt(t)) {
    var c = Math.round(a + i) - e, u = Math.round(l + s) - n;
    Math.abs(c) !== 1 && (a -= c), Math.abs(u) !== 1 && (l -= u);
  }
  return pO(o.left, o.top, a, l);
}
var Hdt = /* @__PURE__ */ function() {
  return typeof SVGGraphicsElement < "u" ? function(t) {
    return t instanceof hp(t).SVGGraphicsElement;
  } : function(t) {
    return t instanceof hp(t).SVGElement && typeof t.getBBox == "function";
  };
}();
function Vdt(t) {
  return t === hp(t).document.documentElement;
}
function Wdt(t) {
  return jj ? Hdt(t) ? qdt(t) : Udt(t) : rve;
}
function Gdt(t) {
  var e = t.x, n = t.y, r = t.width, o = t.height, i = typeof DOMRectReadOnly < "u" ? DOMRectReadOnly : Object, s = Object.create(i.prototype);
  return nve(s, {
    x: e,
    y: n,
    width: r,
    height: o,
    top: n,
    right: e + r,
    bottom: o + n,
    left: e
  }), s;
}
function pO(t, e, n, r) {
  return { x: t, y: e, width: n, height: r };
}
var Ydt = (
  /** @class */
  function() {
    function t(e) {
      this.broadcastWidth = 0, this.broadcastHeight = 0, this.contentRect_ = pO(0, 0, 0, 0), this.target = e;
    }
    return t.prototype.isActive = function() {
      var e = Wdt(this.target);
      return this.contentRect_ = e, e.width !== this.broadcastWidth || e.height !== this.broadcastHeight;
    }, t.prototype.broadcastRect = function() {
      var e = this.contentRect_;
      return this.broadcastWidth = e.width, this.broadcastHeight = e.height, e;
    }, t;
  }()
), Kdt = (
  /** @class */
  /* @__PURE__ */ function() {
    function t(e, n) {
      var r = Gdt(n);
      nve(this, { target: e, contentRect: r });
    }
    return t;
  }()
), Xdt = (
  /** @class */
  function() {
    function t(e, n, r) {
      if (this.activeObservations_ = [], this.observations_ = new tve(), typeof e != "function")
        throw new TypeError("The callback provided as parameter 1 is not a function.");
      this.callback_ = e, this.controller_ = n, this.callbackCtx_ = r;
    }
    return t.prototype.observe = function(e) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element > "u" || !(Element instanceof Object))) {
        if (!(e instanceof hp(e).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var n = this.observations_;
        n.has(e) || (n.set(e, new Ydt(e)), this.controller_.addObserver(this), this.controller_.refresh());
      }
    }, t.prototype.unobserve = function(e) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element > "u" || !(Element instanceof Object))) {
        if (!(e instanceof hp(e).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var n = this.observations_;
        n.has(e) && (n.delete(e), n.size || this.controller_.removeObserver(this));
      }
    }, t.prototype.disconnect = function() {
      this.clearActive(), this.observations_.clear(), this.controller_.removeObserver(this);
    }, t.prototype.gatherActive = function() {
      var e = this;
      this.clearActive(), this.observations_.forEach(function(n) {
        n.isActive() && e.activeObservations_.push(n);
      });
    }, t.prototype.broadcastActive = function() {
      if (this.hasActive()) {
        var e = this.callbackCtx_, n = this.activeObservations_.map(function(r) {
          return new Kdt(r.target, r.broadcastRect());
        });
        this.callback_.call(e, n, e), this.clearActive();
      }
    }, t.prototype.clearActive = function() {
      this.activeObservations_.splice(0);
    }, t.prototype.hasActive = function() {
      return this.activeObservations_.length > 0;
    }, t;
  }()
), ove = typeof WeakMap < "u" ? /* @__PURE__ */ new WeakMap() : new tve(), ive = (
  /** @class */
  /* @__PURE__ */ function() {
    function t(e) {
      if (!(this instanceof t))
        throw new TypeError("Cannot call a class as a function.");
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      var n = Bdt.getInstance(), r = new Xdt(e, n, this);
      ove.set(this, r);
    }
    return t;
  }()
);
[
  "observe",
  "unobserve",
  "disconnect"
].forEach(function(t) {
  ive.prototype[t] = function() {
    var e;
    return (e = ove.get(this))[t].apply(e, arguments);
  };
});
var Qdt = function() {
  return typeof EE.ResizeObserver < "u" ? EE.ResizeObserver : ive;
}(), Zdt = ["client", "offset", "scroll", "bounds", "margin"];
function sQ(t) {
  var e = [];
  return Zdt.forEach(function(n) {
    t[n] && e.push(n);
  }), e;
}
function aQ(t, e) {
  var n = {};
  if (e.indexOf("client") > -1 && (n.client = {
    top: t.clientTop,
    left: t.clientLeft,
    width: t.clientWidth,
    height: t.clientHeight
  }), e.indexOf("offset") > -1 && (n.offset = {
    top: t.offsetTop,
    left: t.offsetLeft,
    width: t.offsetWidth,
    height: t.offsetHeight
  }), e.indexOf("scroll") > -1 && (n.scroll = {
    top: t.scrollTop,
    left: t.scrollLeft,
    width: t.scrollWidth,
    height: t.scrollHeight
  }), e.indexOf("bounds") > -1) {
    var r = t.getBoundingClientRect();
    n.bounds = {
      top: r.top,
      right: r.right,
      bottom: r.bottom,
      left: r.left,
      width: r.width,
      height: r.height
    };
  }
  if (e.indexOf("margin") > -1) {
    var o = getComputedStyle(t);
    n.margin = {
      top: o ? parseInt(o.marginTop) : 0,
      right: o ? parseInt(o.marginRight) : 0,
      bottom: o ? parseInt(o.marginBottom) : 0,
      left: o ? parseInt(o.marginLeft) : 0
    };
  }
  return n;
}
function Jdt(t) {
  var e = t && t.ownerDocument && t.ownerDocument.defaultView;
  return e || window;
}
function eft(t) {
  return function(e) {
    var n, r;
    return r = n = /* @__PURE__ */ function(o) {
      kot(i, o);
      function i() {
        for (var a, l = arguments.length, c = new Array(l), u = 0; u < l; u++)
          c[u] = arguments[u];
        return a = o.call.apply(o, [this].concat(c)) || this, a.state = {
          contentRect: {
            entry: {},
            client: {},
            offset: {},
            scroll: {},
            bounds: {},
            margin: {}
          }
        }, a._animationFrameID = null, a._resizeObserver = null, a._node = null, a._window = null, a.measure = function(d) {
          var f = aQ(a._node, sQ(a.props));
          d && (f.entry = d[0].contentRect), a._animationFrameID = a._window.requestAnimationFrame(function() {
            a._resizeObserver !== null && (a.setState({
              contentRect: f
            }), typeof a.props.onResize == "function" && a.props.onResize(f));
          });
        }, a._handleRef = function(d) {
          a._resizeObserver !== null && a._node !== null && a._resizeObserver.unobserve(a._node), a._node = d, a._window = Jdt(a._node);
          var f = a.props.innerRef;
          f && (typeof f == "function" ? f(a._node) : f.current = a._node), a._resizeObserver !== null && a._node !== null && a._resizeObserver.observe(a._node);
        }, a;
      }
      var s = i.prototype;
      return s.componentDidMount = function() {
        this._resizeObserver = this._window !== null && this._window.ResizeObserver ? new this._window.ResizeObserver(this.measure) : new Qdt(this.measure), this._node !== null && (this._resizeObserver.observe(this._node), typeof this.props.onResize == "function" && this.props.onResize(aQ(this._node, sQ(this.props))));
      }, s.componentWillUnmount = function() {
        this._window !== null && this._window.cancelAnimationFrame(this._animationFrameID), this._resizeObserver !== null && (this._resizeObserver.disconnect(), this._resizeObserver = null);
      }, s.render = function() {
        var a = this.props;
        a.innerRef, a.onResize;
        var l = Gce(a, ["innerRef", "onResize"]);
        return Pse(e, qh({}, l, {
          measureRef: this._handleRef,
          measure: this.measure,
          contentRect: this.state.contentRect
        }));
      }, i;
    }(eEe), n.propTypes = {
      client: br.bool,
      offset: br.bool,
      scroll: br.bool,
      bounds: br.bool,
      margin: br.bool,
      innerRef: br.oneOfType([br.object, br.func]),
      onResize: br.func
    }, r;
  };
}
var sve = eft()(function(t) {
  var e = t.measure, n = t.measureRef, r = t.contentRect, o = t.children;
  return o({
    measure: e,
    measureRef: n,
    contentRect: r
  });
});
sve.displayName = "Measure";
sve.propTypes.children = br.func;
function Fl() {
  return Fl = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
    }
    return t;
  }, Fl.apply(this, arguments);
}
/**
   * match-sorter-utils
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
const ave = {
  À: "A",
  Á: "A",
  Â: "A",
  Ã: "A",
  Ä: "A",
  Å: "A",
  Ấ: "A",
  Ắ: "A",
  Ẳ: "A",
  Ẵ: "A",
  Ặ: "A",
  Æ: "AE",
  Ầ: "A",
  Ằ: "A",
  Ȃ: "A",
  Ç: "C",
  Ḉ: "C",
  È: "E",
  É: "E",
  Ê: "E",
  Ë: "E",
  Ế: "E",
  Ḗ: "E",
  Ề: "E",
  Ḕ: "E",
  Ḝ: "E",
  Ȇ: "E",
  Ì: "I",
  Í: "I",
  Î: "I",
  Ï: "I",
  Ḯ: "I",
  Ȋ: "I",
  Ð: "D",
  Ñ: "N",
  Ò: "O",
  Ó: "O",
  Ô: "O",
  Õ: "O",
  Ö: "O",
  Ø: "O",
  Ố: "O",
  Ṍ: "O",
  Ṓ: "O",
  Ȏ: "O",
  Ù: "U",
  Ú: "U",
  Û: "U",
  Ü: "U",
  Ý: "Y",
  à: "a",
  á: "a",
  â: "a",
  ã: "a",
  ä: "a",
  å: "a",
  ấ: "a",
  ắ: "a",
  ẳ: "a",
  ẵ: "a",
  ặ: "a",
  æ: "ae",
  ầ: "a",
  ằ: "a",
  ȃ: "a",
  ç: "c",
  ḉ: "c",
  è: "e",
  é: "e",
  ê: "e",
  ë: "e",
  ế: "e",
  ḗ: "e",
  ề: "e",
  ḕ: "e",
  ḝ: "e",
  ȇ: "e",
  ì: "i",
  í: "i",
  î: "i",
  ï: "i",
  ḯ: "i",
  ȋ: "i",
  ð: "d",
  ñ: "n",
  ò: "o",
  ó: "o",
  ô: "o",
  õ: "o",
  ö: "o",
  ø: "o",
  ố: "o",
  ṍ: "o",
  ṓ: "o",
  ȏ: "o",
  ù: "u",
  ú: "u",
  û: "u",
  ü: "u",
  ý: "y",
  ÿ: "y",
  Ā: "A",
  ā: "a",
  Ă: "A",
  ă: "a",
  Ą: "A",
  ą: "a",
  Ć: "C",
  ć: "c",
  Ĉ: "C",
  ĉ: "c",
  Ċ: "C",
  ċ: "c",
  Č: "C",
  č: "c",
  C̆: "C",
  c̆: "c",
  Ď: "D",
  ď: "d",
  Đ: "D",
  đ: "d",
  Ē: "E",
  ē: "e",
  Ĕ: "E",
  ĕ: "e",
  Ė: "E",
  ė: "e",
  Ę: "E",
  ę: "e",
  Ě: "E",
  ě: "e",
  Ĝ: "G",
  Ǵ: "G",
  ĝ: "g",
  ǵ: "g",
  Ğ: "G",
  ğ: "g",
  Ġ: "G",
  ġ: "g",
  Ģ: "G",
  ģ: "g",
  Ĥ: "H",
  ĥ: "h",
  Ħ: "H",
  ħ: "h",
  Ḫ: "H",
  ḫ: "h",
  Ĩ: "I",
  ĩ: "i",
  Ī: "I",
  ī: "i",
  Ĭ: "I",
  ĭ: "i",
  Į: "I",
  į: "i",
  İ: "I",
  ı: "i",
  Ĳ: "IJ",
  ĳ: "ij",
  Ĵ: "J",
  ĵ: "j",
  Ķ: "K",
  ķ: "k",
  Ḱ: "K",
  ḱ: "k",
  K̆: "K",
  k̆: "k",
  Ĺ: "L",
  ĺ: "l",
  Ļ: "L",
  ļ: "l",
  Ľ: "L",
  ľ: "l",
  Ŀ: "L",
  ŀ: "l",
  Ł: "l",
  ł: "l",
  Ḿ: "M",
  ḿ: "m",
  M̆: "M",
  m̆: "m",
  Ń: "N",
  ń: "n",
  Ņ: "N",
  ņ: "n",
  Ň: "N",
  ň: "n",
  ŉ: "n",
  N̆: "N",
  n̆: "n",
  Ō: "O",
  ō: "o",
  Ŏ: "O",
  ŏ: "o",
  Ő: "O",
  ő: "o",
  Œ: "OE",
  œ: "oe",
  P̆: "P",
  p̆: "p",
  Ŕ: "R",
  ŕ: "r",
  Ŗ: "R",
  ŗ: "r",
  Ř: "R",
  ř: "r",
  R̆: "R",
  r̆: "r",
  Ȓ: "R",
  ȓ: "r",
  Ś: "S",
  ś: "s",
  Ŝ: "S",
  ŝ: "s",
  Ş: "S",
  Ș: "S",
  ș: "s",
  ş: "s",
  Š: "S",
  š: "s",
  Ţ: "T",
  ţ: "t",
  ț: "t",
  Ț: "T",
  Ť: "T",
  ť: "t",
  Ŧ: "T",
  ŧ: "t",
  T̆: "T",
  t̆: "t",
  Ũ: "U",
  ũ: "u",
  Ū: "U",
  ū: "u",
  Ŭ: "U",
  ŭ: "u",
  Ů: "U",
  ů: "u",
  Ű: "U",
  ű: "u",
  Ų: "U",
  ų: "u",
  Ȗ: "U",
  ȗ: "u",
  V̆: "V",
  v̆: "v",
  Ŵ: "W",
  ŵ: "w",
  Ẃ: "W",
  ẃ: "w",
  X̆: "X",
  x̆: "x",
  Ŷ: "Y",
  ŷ: "y",
  Ÿ: "Y",
  Y̆: "Y",
  y̆: "y",
  Ź: "Z",
  ź: "z",
  Ż: "Z",
  ż: "z",
  Ž: "Z",
  ž: "z",
  ſ: "s",
  ƒ: "f",
  Ơ: "O",
  ơ: "o",
  Ư: "U",
  ư: "u",
  Ǎ: "A",
  ǎ: "a",
  Ǐ: "I",
  ǐ: "i",
  Ǒ: "O",
  ǒ: "o",
  Ǔ: "U",
  ǔ: "u",
  Ǖ: "U",
  ǖ: "u",
  Ǘ: "U",
  ǘ: "u",
  Ǚ: "U",
  ǚ: "u",
  Ǜ: "U",
  ǜ: "u",
  Ứ: "U",
  ứ: "u",
  Ṹ: "U",
  ṹ: "u",
  Ǻ: "A",
  ǻ: "a",
  Ǽ: "AE",
  ǽ: "ae",
  Ǿ: "O",
  ǿ: "o",
  Þ: "TH",
  þ: "th",
  Ṕ: "P",
  ṕ: "p",
  Ṥ: "S",
  ṥ: "s",
  X́: "X",
  x́: "x",
  Ѓ: "Г",
  ѓ: "г",
  Ќ: "К",
  ќ: "к",
  A̋: "A",
  a̋: "a",
  E̋: "E",
  e̋: "e",
  I̋: "I",
  i̋: "i",
  Ǹ: "N",
  ǹ: "n",
  Ồ: "O",
  ồ: "o",
  Ṑ: "O",
  ṑ: "o",
  Ừ: "U",
  ừ: "u",
  Ẁ: "W",
  ẁ: "w",
  Ỳ: "Y",
  ỳ: "y",
  Ȁ: "A",
  ȁ: "a",
  Ȅ: "E",
  ȅ: "e",
  Ȉ: "I",
  ȉ: "i",
  Ȍ: "O",
  ȍ: "o",
  Ȑ: "R",
  ȑ: "r",
  Ȕ: "U",
  ȕ: "u",
  B̌: "B",
  b̌: "b",
  Č̣: "C",
  č̣: "c",
  Ê̌: "E",
  ê̌: "e",
  F̌: "F",
  f̌: "f",
  Ǧ: "G",
  ǧ: "g",
  Ȟ: "H",
  ȟ: "h",
  J̌: "J",
  ǰ: "j",
  Ǩ: "K",
  ǩ: "k",
  M̌: "M",
  m̌: "m",
  P̌: "P",
  p̌: "p",
  Q̌: "Q",
  q̌: "q",
  Ř̩: "R",
  ř̩: "r",
  Ṧ: "S",
  ṧ: "s",
  V̌: "V",
  v̌: "v",
  W̌: "W",
  w̌: "w",
  X̌: "X",
  x̌: "x",
  Y̌: "Y",
  y̌: "y",
  A̧: "A",
  a̧: "a",
  B̧: "B",
  b̧: "b",
  Ḑ: "D",
  ḑ: "d",
  Ȩ: "E",
  ȩ: "e",
  Ɛ̧: "E",
  ɛ̧: "e",
  Ḩ: "H",
  ḩ: "h",
  I̧: "I",
  i̧: "i",
  Ɨ̧: "I",
  ɨ̧: "i",
  M̧: "M",
  m̧: "m",
  O̧: "O",
  o̧: "o",
  Q̧: "Q",
  q̧: "q",
  U̧: "U",
  u̧: "u",
  X̧: "X",
  x̧: "x",
  Z̧: "Z",
  z̧: "z"
}, tft = Object.keys(ave).join("|"), nft = new RegExp(tft, "g");
function rft(t) {
  return t.replace(nft, (e) => ave[e]);
}
/**
 * @name match-sorter
 * @license MIT license.
 * @copyright (c) 2099 Kent C. Dodds
 * @author Kent C. Dodds <me@kentcdodds.com> (https://kentcdodds.com)
 */
const Bo = {
  CASE_SENSITIVE_EQUAL: 7,
  EQUAL: 6,
  STARTS_WITH: 5,
  WORD_STARTS_WITH: 4,
  CONTAINS: 3,
  ACRONYM: 2,
  MATCHES: 1,
  NO_MATCH: 0
};
function oft(t, e, n) {
  var r;
  if (n = n || {}, n.threshold = (r = n.threshold) != null ? r : Bo.MATCHES, !n.accessors) {
    const s = lQ(t, e, n);
    return {
      // ends up being duplicate of 'item' in matches but consistent
      rankedValue: t,
      rank: s,
      accessorIndex: -1,
      accessorThreshold: n.threshold,
      passed: s >= n.threshold
    };
  }
  const o = lft(t, n.accessors), i = {
    rankedValue: t,
    rank: Bo.NO_MATCH,
    accessorIndex: -1,
    accessorThreshold: n.threshold,
    passed: !1
  };
  for (let s = 0; s < o.length; s++) {
    const a = o[s];
    let l = lQ(a.itemValue, e, n);
    const {
      minRanking: c,
      maxRanking: u,
      threshold: d = n.threshold
    } = a.attributes;
    l < c && l >= Bo.MATCHES ? l = c : l > u && (l = u), l = Math.min(l, u), l >= d && l > i.rank && (i.rank = l, i.passed = !0, i.accessorIndex = s, i.accessorThreshold = d, i.rankedValue = a.itemValue);
  }
  return i;
}
function lQ(t, e, n) {
  return t = cQ(t, n), e = cQ(e, n), e.length > t.length ? Bo.NO_MATCH : t === e ? Bo.CASE_SENSITIVE_EQUAL : (t = t.toLowerCase(), e = e.toLowerCase(), t === e ? Bo.EQUAL : t.startsWith(e) ? Bo.STARTS_WITH : t.includes(` ${e}`) ? Bo.WORD_STARTS_WITH : t.includes(e) ? Bo.CONTAINS : e.length === 1 ? Bo.NO_MATCH : ift(t).includes(e) ? Bo.ACRONYM : sft(t, e));
}
function ift(t) {
  let e = "";
  return t.split(" ").forEach((n) => {
    n.split("-").forEach((r) => {
      e += r.substr(0, 1);
    });
  }), e;
}
function sft(t, e) {
  let n = 0, r = 0;
  function o(l, c, u) {
    for (let d = u, f = c.length; d < f; d++)
      if (c[d] === l)
        return n += 1, d + 1;
    return -1;
  }
  function i(l) {
    const c = 1 / l, u = n / e.length;
    return Bo.MATCHES + u * c;
  }
  const s = o(e[0], t, 0);
  if (s < 0)
    return Bo.NO_MATCH;
  r = s;
  for (let l = 1, c = e.length; l < c; l++) {
    const u = e[l];
    if (r = o(u, t, r), !(r > -1))
      return Bo.NO_MATCH;
  }
  const a = r - s;
  return i(a);
}
function cQ(t, e) {
  let {
    keepDiacritics: n
  } = e;
  return t = `${t}`, n || (t = rft(t)), t;
}
function aft(t, e) {
  let n = e;
  typeof e == "object" && (n = e.accessor);
  const r = n(t);
  return r == null ? [] : Array.isArray(r) ? r : [String(r)];
}
function lft(t, e) {
  const n = [];
  for (let r = 0, o = e.length; r < o; r++) {
    const i = e[r], s = cft(i), a = aft(t, i);
    for (let l = 0, c = a.length; l < c; l++)
      n.push({
        itemValue: a[l],
        attributes: s
      });
  }
  return n;
}
const uQ = {
  maxRanking: 1 / 0,
  minRanking: -1 / 0
};
function cft(t) {
  return typeof t == "function" ? uQ : {
    ...uQ,
    ...t
  };
}
const uft = (t) => {
  try {
    const e = localStorage.getItem(t);
    return typeof e == "string" ? JSON.parse(e) : void 0;
  } catch {
    return;
  }
};
function Fc(t, e) {
  const [n, r] = he.useState();
  he.useEffect(() => {
    const i = uft(t);
    r(typeof i > "u" || i === null ? typeof e == "function" ? e() : e : i);
  }, [e, t]);
  const o = he.useCallback((i) => {
    r((s) => {
      let a = i;
      typeof i == "function" && (a = i(s));
      try {
        localStorage.setItem(t, JSON.stringify(a));
      } catch {
      }
      return a;
    });
  }, [t]);
  return [n, o];
}
var dft = (
  /** @class */
  function() {
    function t() {
      this.keyToValue = /* @__PURE__ */ new Map(), this.valueToKey = /* @__PURE__ */ new Map();
    }
    return t.prototype.set = function(e, n) {
      this.keyToValue.set(e, n), this.valueToKey.set(n, e);
    }, t.prototype.getByKey = function(e) {
      return this.keyToValue.get(e);
    }, t.prototype.getByValue = function(e) {
      return this.valueToKey.get(e);
    }, t.prototype.clear = function() {
      this.keyToValue.clear(), this.valueToKey.clear();
    }, t;
  }()
), lve = (
  /** @class */
  function() {
    function t(e) {
      this.generateIdentifier = e, this.kv = new dft();
    }
    return t.prototype.register = function(e, n) {
      this.kv.getByValue(e) || (n || (n = this.generateIdentifier(e)), this.kv.set(n, e));
    }, t.prototype.clear = function() {
      this.kv.clear();
    }, t.prototype.getIdentifier = function(e) {
      return this.kv.getByValue(e);
    }, t.prototype.getValue = function(e) {
      return this.kv.getByKey(e);
    }, t;
  }()
), fft = /* @__PURE__ */ function() {
  var t = function(e, n) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var i in o) Object.prototype.hasOwnProperty.call(o, i) && (r[i] = o[i]);
    }, t(e, n);
  };
  return function(e, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    t(e, n);
    function r() {
      this.constructor = e;
    }
    e.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), hft = (
  /** @class */
  function(t) {
    fft(e, t);
    function e() {
      var n = t.call(this, function(r) {
        return r.name;
      }) || this;
      return n.classToAllowedProps = /* @__PURE__ */ new Map(), n;
    }
    return e.prototype.register = function(n, r) {
      typeof r == "object" ? (r.allowProps && this.classToAllowedProps.set(n, r.allowProps), t.prototype.register.call(this, n, r.identifier)) : t.prototype.register.call(this, n, r);
    }, e.prototype.getAllowedProps = function(n) {
      return this.classToAllowedProps.get(n);
    }, e;
  }(lve)
), pft = function(t, e) {
  var n = typeof Symbol == "function" && t[Symbol.iterator];
  if (!n) return t;
  var r = n.call(t), o, i = [], s;
  try {
    for (; (e === void 0 || e-- > 0) && !(o = r.next()).done; ) i.push(o.value);
  } catch (a) {
    s = { error: a };
  } finally {
    try {
      o && !o.done && (n = r.return) && n.call(r);
    } finally {
      if (s) throw s.error;
    }
  }
  return i;
};
function mft(t) {
  if ("values" in Object)
    return Object.values(t);
  var e = [];
  for (var n in t)
    t.hasOwnProperty(n) && e.push(t[n]);
  return e;
}
function gft(t, e) {
  var n = mft(t);
  if ("find" in n)
    return n.find(e);
  for (var r = n, o = 0; o < r.length; o++) {
    var i = r[o];
    if (e(i))
      return i;
  }
}
function pp(t, e) {
  Object.entries(t).forEach(function(n) {
    var r = pft(n, 2), o = r[0], i = r[1];
    return e(i, o);
  });
}
function Nw(t, e) {
  return t.indexOf(e) !== -1;
}
function dQ(t, e) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    if (e(r))
      return r;
  }
}
var yft = (
  /** @class */
  function() {
    function t() {
      this.transfomers = {};
    }
    return t.prototype.register = function(e) {
      this.transfomers[e.name] = e;
    }, t.prototype.findApplicable = function(e) {
      return gft(this.transfomers, function(n) {
        return n.isApplicable(e);
      });
    }, t.prototype.findByName = function(e) {
      return this.transfomers[e];
    }, t;
  }()
), vft = function(t) {
  return Object.prototype.toString.call(t).slice(8, -1);
}, cve = function(t) {
  return typeof t > "u";
}, bft = function(t) {
  return t === null;
}, Dy = function(t) {
  return typeof t != "object" || t === null || t === Object.prototype ? !1 : Object.getPrototypeOf(t) === null ? !0 : Object.getPrototypeOf(t) === Object.prototype;
}, Lj = function(t) {
  return Dy(t) && Object.keys(t).length === 0;
}, ru = function(t) {
  return Array.isArray(t);
}, _ft = function(t) {
  return typeof t == "string";
}, wft = function(t) {
  return typeof t == "number" && !isNaN(t);
}, xft = function(t) {
  return typeof t == "boolean";
}, Eft = function(t) {
  return t instanceof RegExp;
}, Iy = function(t) {
  return t instanceof Map;
}, Ny = function(t) {
  return t instanceof Set;
}, uve = function(t) {
  return vft(t) === "Symbol";
}, Sft = function(t) {
  return t instanceof Date && !isNaN(t.valueOf());
}, Oft = function(t) {
  return t instanceof Error;
}, fQ = function(t) {
  return typeof t == "number" && isNaN(t);
}, Cft = function(t) {
  return xft(t) || bft(t) || cve(t) || wft(t) || _ft(t) || uve(t);
}, kft = function(t) {
  return typeof t == "bigint";
}, Aft = function(t) {
  return t === 1 / 0 || t === -1 / 0;
}, Tft = function(t) {
  return ArrayBuffer.isView(t) && !(t instanceof DataView);
}, Rft = function(t) {
  return t instanceof URL;
}, dve = function(t) {
  return t.replace(/\./g, "\\.");
}, iT = function(t) {
  return t.map(String).map(dve).join(".");
}, p0 = function(t) {
  for (var e = [], n = "", r = 0; r < t.length; r++) {
    var o = t.charAt(r), i = o === "\\" && t.charAt(r + 1) === ".";
    if (i) {
      n += ".", r++;
      continue;
    }
    var s = o === ".";
    if (s) {
      e.push(n), n = "";
      continue;
    }
    n += o;
  }
  var a = n;
  return e.push(a), e;
}, Fj = function() {
  return Fj = Object.assign || function(t) {
    for (var e, n = 1, r = arguments.length; n < r; n++) {
      e = arguments[n];
      for (var o in e) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
    }
    return t;
  }, Fj.apply(this, arguments);
}, Bj = function(t, e) {
  var n = typeof Symbol == "function" && t[Symbol.iterator];
  if (!n) return t;
  var r = n.call(t), o, i = [], s;
  try {
    for (; (e === void 0 || e-- > 0) && !(o = r.next()).done; ) i.push(o.value);
  } catch (a) {
    s = { error: a };
  } finally {
    try {
      o && !o.done && (n = r.return) && n.call(r);
    } finally {
      if (s) throw s.error;
    }
  }
  return i;
}, zj = function(t, e) {
  for (var n = 0, r = e.length, o = t.length; n < r; n++, o++)
    t[o] = e[n];
  return t;
};
function Vs(t, e, n, r) {
  return {
    isApplicable: t,
    annotation: e,
    transform: n,
    untransform: r
  };
}
var fve = [
  Vs(cve, "undefined", function() {
    return null;
  }, function() {
  }),
  Vs(kft, "bigint", function(t) {
    return t.toString();
  }, function(t) {
    return typeof BigInt < "u" ? BigInt(t) : (console.error("Please add a BigInt polyfill."), t);
  }),
  Vs(Sft, "Date", function(t) {
    return t.toISOString();
  }, function(t) {
    return new Date(t);
  }),
  Vs(Oft, "Error", function(t, e) {
    var n = {
      name: t.name,
      message: t.message
    };
    return e.allowedErrorProps.forEach(function(r) {
      n[r] = t[r];
    }), n;
  }, function(t, e) {
    var n = new Error(t.message);
    return n.name = t.name, n.stack = t.stack, e.allowedErrorProps.forEach(function(r) {
      n[r] = t[r];
    }), n;
  }),
  Vs(Eft, "regexp", function(t) {
    return "" + t;
  }, function(t) {
    var e = t.slice(1, t.lastIndexOf("/")), n = t.slice(t.lastIndexOf("/") + 1);
    return new RegExp(e, n);
  }),
  Vs(
    Ny,
    "set",
    // (sets only exist in es6+)
    // eslint-disable-next-line es5/no-es6-methods
    function(t) {
      return zj([], Bj(t.values()));
    },
    function(t) {
      return new Set(t);
    }
  ),
  Vs(Iy, "map", function(t) {
    return zj([], Bj(t.entries()));
  }, function(t) {
    return new Map(t);
  }),
  Vs(function(t) {
    return fQ(t) || Aft(t);
  }, "number", function(t) {
    return fQ(t) ? "NaN" : t > 0 ? "Infinity" : "-Infinity";
  }, Number),
  Vs(function(t) {
    return t === 0 && 1 / t === -1 / 0;
  }, "number", function() {
    return "-0";
  }, Number),
  Vs(Rft, "URL", function(t) {
    return t.toString();
  }, function(t) {
    return new URL(t);
  })
];
function mO(t, e, n, r) {
  return {
    isApplicable: t,
    annotation: e,
    transform: n,
    untransform: r
  };
}
var hve = mO(function(t, e) {
  if (uve(t)) {
    var n = !!e.symbolRegistry.getIdentifier(t);
    return n;
  }
  return !1;
}, function(t, e) {
  var n = e.symbolRegistry.getIdentifier(t);
  return ["symbol", n];
}, function(t) {
  return t.description;
}, function(t, e, n) {
  var r = n.symbolRegistry.getValue(e[1]);
  if (!r)
    throw new Error("Trying to deserialize unknown symbol");
  return r;
}), Pft = [
  Int8Array,
  Uint8Array,
  Int16Array,
  Uint16Array,
  Int32Array,
  Uint32Array,
  Float32Array,
  Float64Array,
  Uint8ClampedArray
].reduce(function(t, e) {
  return t[e.name] = e, t;
}, {}), pve = mO(Tft, function(t) {
  return ["typed-array", t.constructor.name];
}, function(t) {
  return zj([], Bj(t));
}, function(t, e) {
  var n = Pft[e[1]];
  if (!n)
    throw new Error("Trying to deserialize unknown typed array");
  return new n(t);
});
function mve(t, e) {
  if (t?.constructor) {
    var n = !!e.classRegistry.getIdentifier(t.constructor);
    return n;
  }
  return !1;
}
var gve = mO(mve, function(t, e) {
  var n = e.classRegistry.getIdentifier(t.constructor);
  return ["class", n];
}, function(t, e) {
  var n = e.classRegistry.getAllowedProps(t.constructor);
  if (!n)
    return Fj({}, t);
  var r = {};
  return n.forEach(function(o) {
    r[o] = t[o];
  }), r;
}, function(t, e, n) {
  var r = n.classRegistry.getValue(e[1]);
  if (!r)
    throw new Error("Trying to deserialize unknown class - check https://github.com/blitz-js/superjson/issues/116#issuecomment-773996564");
  return Object.assign(Object.create(r.prototype), t);
}), yve = mO(function(t, e) {
  return !!e.customTransformerRegistry.findApplicable(t);
}, function(t, e) {
  var n = e.customTransformerRegistry.findApplicable(t);
  return ["custom", n.name];
}, function(t, e) {
  var n = e.customTransformerRegistry.findApplicable(t);
  return n.serialize(t);
}, function(t, e, n) {
  var r = n.customTransformerRegistry.findByName(e[1]);
  if (!r)
    throw new Error("Trying to deserialize unknown custom value");
  return r.deserialize(t);
}), $ft = [gve, hve, yve, pve], hQ = function(t, e) {
  var n = dQ($ft, function(o) {
    return o.isApplicable(t, e);
  });
  if (n)
    return {
      value: n.transform(t, e),
      type: n.annotation(t, e)
    };
  var r = dQ(fve, function(o) {
    return o.isApplicable(t, e);
  });
  if (r)
    return {
      value: r.transform(t, e),
      type: r.annotation
    };
}, vve = {};
fve.forEach(function(t) {
  vve[t.annotation] = t;
});
var Mft = function(t, e, n) {
  if (ru(e))
    switch (e[0]) {
      case "symbol":
        return hve.untransform(t, e, n);
      case "class":
        return gve.untransform(t, e, n);
      case "custom":
        return yve.untransform(t, e, n);
      case "typed-array":
        return pve.untransform(t, e, n);
      default:
        throw new Error("Unknown transformation: " + e);
    }
  else {
    var r = vve[e];
    if (!r)
      throw new Error("Unknown transformation: " + e);
    return r.untransform(t, n);
  }
}, oh = function(t, e) {
  for (var n = t.keys(); e > 0; )
    n.next(), e--;
  return n.next().value;
};
function bve(t) {
  if (Nw(t, "__proto__"))
    throw new Error("__proto__ is not allowed as a property");
  if (Nw(t, "prototype"))
    throw new Error("prototype is not allowed as a property");
  if (Nw(t, "constructor"))
    throw new Error("constructor is not allowed as a property");
}
var Dft = function(t, e) {
  bve(e);
  for (var n = 0; n < e.length; n++) {
    var r = e[n];
    if (Ny(t))
      t = oh(t, +r);
    else if (Iy(t)) {
      var o = +r, i = +e[++n] == 0 ? "key" : "value", s = oh(t, o);
      switch (i) {
        case "key":
          t = s;
          break;
        case "value":
          t = t.get(s);
          break;
      }
    } else
      t = t[r];
  }
  return t;
}, qj = function(t, e, n) {
  if (bve(e), e.length === 0)
    return n(t);
  for (var r = t, o = 0; o < e.length - 1; o++) {
    var i = e[o];
    if (ru(r)) {
      var s = +i;
      r = r[s];
    } else if (Dy(r))
      r = r[i];
    else if (Ny(r)) {
      var a = +i;
      r = oh(r, a);
    } else if (Iy(r)) {
      var l = o === e.length - 2;
      if (l)
        break;
      var a = +i, c = +e[++o] == 0 ? "key" : "value", u = oh(r, a);
      switch (c) {
        case "key":
          r = u;
          break;
        case "value":
          r = r.get(u);
          break;
      }
    }
  }
  var d = e[e.length - 1];
  if (ru(r) ? r[+d] = n(r[+d]) : Dy(r) && (r[d] = n(r[d])), Ny(r)) {
    var f = oh(r, +d), h = n(f);
    f !== h && (r.delete(f), r.add(h));
  }
  if (Iy(r)) {
    var a = +e[e.length - 2], p = oh(r, a), c = +d == 0 ? "key" : "value";
    switch (c) {
      case "key": {
        var m = n(p);
        r.set(m, r.get(p)), m !== p && r.delete(p);
        break;
      }
      case "value": {
        r.set(p, n(r.get(p)));
        break;
      }
    }
  }
  return t;
}, ml = function(t, e) {
  var n = typeof Symbol == "function" && t[Symbol.iterator];
  if (!n) return t;
  var r = n.call(t), o, i = [], s;
  try {
    for (; (e === void 0 || e-- > 0) && !(o = r.next()).done; ) i.push(o.value);
  } catch (a) {
    s = { error: a };
  } finally {
    try {
      o && !o.done && (n = r.return) && n.call(r);
    } finally {
      if (s) throw s.error;
    }
  }
  return i;
}, Bc = function(t, e) {
  for (var n = 0, r = e.length, o = t.length; n < r; n++, o++)
    t[o] = e[n];
  return t;
};
function Uj(t, e, n) {
  if (n === void 0 && (n = []), !!t) {
    if (!ru(t)) {
      pp(t, function(s, a) {
        return Uj(s, e, Bc(Bc([], ml(n)), ml(p0(a))));
      });
      return;
    }
    var r = ml(t, 2), o = r[0], i = r[1];
    i && pp(i, function(s, a) {
      Uj(s, e, Bc(Bc([], ml(n)), ml(p0(a))));
    }), e(o, n);
  }
}
function Ift(t, e, n) {
  return Uj(e, function(r, o) {
    t = qj(t, o, function(i) {
      return Mft(i, r, n);
    });
  }), t;
}
function Nft(t, e) {
  function n(s, a) {
    var l = Dft(t, p0(a));
    s.map(p0).forEach(function(c) {
      t = qj(t, c, function() {
        return l;
      });
    });
  }
  if (ru(e)) {
    var r = ml(e, 2), o = r[0], i = r[1];
    o.forEach(function(s) {
      t = qj(t, p0(s), function() {
        return t;
      });
    }), i && pp(i, n);
  } else
    pp(e, n);
  return t;
}
var jft = function(t, e) {
  return Dy(t) || ru(t) || Iy(t) || Ny(t) || mve(t, e);
};
function Lft(t, e, n) {
  var r = n.get(t);
  r ? r.push(e) : n.set(t, [e]);
}
function Fft(t, e) {
  var n = {}, r = void 0;
  return t.forEach(function(o) {
    if (!(o.length <= 1)) {
      e || (o = o.map(function(l) {
        return l.map(String);
      }).sort(function(l, c) {
        return l.length - c.length;
      }));
      var i = ml(o), s = i[0], a = i.slice(1);
      s.length === 0 ? r = a.map(iT) : n[iT(s)] = a.map(iT);
    }
  }), r ? Lj(n) ? [r] : [r, n] : Lj(n) ? void 0 : n;
}
var _ve = function(t, e, n, r, o, i, s) {
  var a;
  o === void 0 && (o = []), i === void 0 && (i = []), s === void 0 && (s = /* @__PURE__ */ new Map());
  var l = Cft(t);
  if (!l) {
    Lft(t, o, e);
    var c = s.get(t);
    if (c)
      return r ? {
        transformedValue: null
      } : c;
  }
  if (!jft(t, n)) {
    var u = hQ(t, n), d = u ? {
      transformedValue: u.value,
      annotations: [u.type]
    } : {
      transformedValue: t
    };
    return l || s.set(t, d), d;
  }
  if (Nw(i, t))
    return {
      transformedValue: null
    };
  var f = hQ(t, n), h = (a = f?.value) !== null && a !== void 0 ? a : t, p = ru(h) ? [] : {}, m = {};
  pp(h, function(y, v) {
    var b = _ve(y, e, n, r, Bc(Bc([], ml(o)), [v]), Bc(Bc([], ml(i)), [t]), s);
    p[v] = b.transformedValue, ru(b.annotations) ? m[v] = b.annotations : Dy(b.annotations) && pp(b.annotations, function(_, w) {
      m[dve(v) + "." + w] = _;
    });
  });
  var g = Lj(m) ? {
    transformedValue: p,
    annotations: f ? [f.type] : void 0
  } : {
    transformedValue: p,
    annotations: f ? [f.type, m] : m
  };
  return l || s.set(t, g), g;
};
function wve(t) {
  return Object.prototype.toString.call(t).slice(8, -1);
}
function pQ(t) {
  return wve(t) === "Array";
}
function Bft(t) {
  if (wve(t) !== "Object")
    return !1;
  const e = Object.getPrototypeOf(t);
  return !!e && e.constructor === Object && e === Object.prototype;
}
function zft(t, e, n, r, o) {
  const i = {}.propertyIsEnumerable.call(r, e) ? "enumerable" : "nonenumerable";
  i === "enumerable" && (t[e] = n), o && i === "nonenumerable" && Object.defineProperty(t, e, {
    value: n,
    enumerable: !1,
    writable: !0,
    configurable: !0
  });
}
function Hj(t, e = {}) {
  if (pQ(t))
    return t.map((o) => Hj(o, e));
  if (!Bft(t))
    return t;
  const n = Object.getOwnPropertyNames(t), r = Object.getOwnPropertySymbols(t);
  return [...n, ...r].reduce((o, i) => {
    if (pQ(e.props) && !e.props.includes(i))
      return o;
    const s = t[i], a = Hj(s, e);
    return zft(o, i, a, t, e.nonenumerable), o;
  }, {});
}
var Zu = function() {
  return Zu = Object.assign || function(t) {
    for (var e, n = 1, r = arguments.length; n < r; n++) {
      e = arguments[n];
      for (var o in e) Object.prototype.hasOwnProperty.call(e, o) && (t[o] = e[o]);
    }
    return t;
  }, Zu.apply(this, arguments);
}, qft = function(t, e) {
  var n = typeof Symbol == "function" && t[Symbol.iterator];
  if (!n) return t;
  var r = n.call(t), o, i = [], s;
  try {
    for (; (e === void 0 || e-- > 0) && !(o = r.next()).done; ) i.push(o.value);
  } catch (a) {
    s = { error: a };
  } finally {
    try {
      o && !o.done && (n = r.return) && n.call(r);
    } finally {
      if (s) throw s.error;
    }
  }
  return i;
}, Uft = function(t, e) {
  for (var n = 0, r = e.length, o = t.length; n < r; n++, o++)
    t[o] = e[n];
  return t;
}, xve = (
  /** @class */
  function() {
    function t(e) {
      var n = e === void 0 ? {} : e, r = n.dedupe, o = r === void 0 ? !1 : r;
      this.classRegistry = new hft(), this.symbolRegistry = new lve(function(i) {
        var s;
        return (s = i.description) !== null && s !== void 0 ? s : "";
      }), this.customTransformerRegistry = new yft(), this.allowedErrorProps = [], this.dedupe = o;
    }
    return t.prototype.serialize = function(e) {
      var n = /* @__PURE__ */ new Map(), r = _ve(e, n, this, this.dedupe), o = {
        json: r.transformedValue
      };
      r.annotations && (o.meta = Zu(Zu({}, o.meta), { values: r.annotations }));
      var i = Fft(n, this.dedupe);
      return i && (o.meta = Zu(Zu({}, o.meta), { referentialEqualities: i })), o;
    }, t.prototype.deserialize = function(e) {
      var n = e.json, r = e.meta, o = Hj(n);
      return r?.values && (o = Ift(o, r.values, this)), r?.referentialEqualities && (o = Nft(o, r.referentialEqualities)), o;
    }, t.prototype.stringify = function(e) {
      return JSON.stringify(this.serialize(e));
    }, t.prototype.parse = function(e) {
      return this.deserialize(JSON.parse(e));
    }, t.prototype.registerClass = function(e, n) {
      this.classRegistry.register(e, n);
    }, t.prototype.registerSymbol = function(e, n) {
      this.symbolRegistry.register(e, n);
    }, t.prototype.registerCustom = function(e, n) {
      this.customTransformerRegistry.register(Zu({ name: n }, e));
    }, t.prototype.allowErrorProps = function() {
      for (var e, n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      (e = this.allowedErrorProps).push.apply(e, Uft([], qft(n)));
    }, t.defaultInstance = new t(), t.serialize = t.defaultInstance.serialize.bind(t.defaultInstance), t.deserialize = t.defaultInstance.deserialize.bind(t.defaultInstance), t.stringify = t.defaultInstance.stringify.bind(t.defaultInstance), t.parse = t.defaultInstance.parse.bind(t.defaultInstance), t.registerClass = t.defaultInstance.registerClass.bind(t.defaultInstance), t.registerSymbol = t.defaultInstance.registerSymbol.bind(t.defaultInstance), t.registerCustom = t.defaultInstance.registerCustom.bind(t.defaultInstance), t.allowErrorProps = t.defaultInstance.allowErrorProps.bind(t.defaultInstance), t;
  }()
);
const Qt = {
  background: "#0b1521",
  backgroundAlt: "#132337",
  foreground: "white",
  gray: "#3f4e60",
  grayAlt: "#222e3e",
  inputBackgroundColor: "#fff",
  inputTextColor: "#000",
  success: "#00ab52",
  danger: "#ff0085",
  active: "#006bff",
  paused: "#8c49eb",
  warning: "#ffb200"
}, Eve = /* @__PURE__ */ he.createContext(Qt);
function Sve({
  theme: t,
  ...e
}) {
  return /* @__PURE__ */ he.createElement(Eve.Provider, Fl({
    value: t
  }, e));
}
function Hft() {
  return he.useContext(Eve);
}
function Vft(t) {
  const [e, n] = he.useState(() => {
    if (typeof window < "u")
      return window.matchMedia(t).matches;
  });
  return he.useEffect(() => {
    if (typeof window < "u") {
      const r = window.matchMedia(t), o = ({
        matches: i
      }) => n(i);
      return r.addListener(o), () => {
        r.removeListener(o);
      };
    }
  }, [e, t, n]), e;
}
function Ove({
  queryState: t,
  observerCount: e,
  isStale: n,
  theme: r
}) {
  return t.fetchStatus === "fetching" ? r.active : e ? t.fetchStatus === "paused" ? r.paused : n ? r.warning : r.success : r.gray;
}
function Bf(t) {
  return t.state.fetchStatus === "fetching" ? "fetching" : t.getObserversCount() ? t.state.fetchStatus === "paused" ? "paused" : t.isStale() ? "stale" : "fresh" : "inactive";
}
function Po(t, e, n = {}) {
  return /* @__PURE__ */ he.forwardRef(({
    style: r,
    ...o
  }, i) => {
    const s = Hft(), a = Object.entries(n).reduce((l, [c, u]) => Vft(c) ? {
      ...l,
      ...typeof u == "function" ? u(o, s) : u
    } : l, {});
    return /* @__PURE__ */ he.createElement(t, {
      ...o,
      style: {
        ...typeof e == "function" ? e(o, s) : e,
        ...r,
        ...a
      },
      ref: i
    });
  });
}
function Wft() {
  const t = he.useRef(!1), e = he.useCallback(() => t.current, []);
  return he.useEffect(() => (t.current = !0, () => {
    t.current = !1;
  }), []), e;
}
const Cve = (t, e = !1) => {
  const {
    json: n
  } = xve.serialize(t);
  return JSON.stringify(n, null, e ? 2 : void 0);
}, P1 = (t) => t.state.fetchStatus !== "idle" ? 0 : t.getObserversCount() ? t.isStale() ? 2 : 1 : 3, Gft = (t, e) => t.queryHash.localeCompare(e.queryHash), kve = (t, e) => t.state.dataUpdatedAt < e.state.dataUpdatedAt ? 1 : -1, Yft = (t, e) => P1(t) === P1(e) ? kve(t, e) : P1(t) > P1(e) ? 1 : -1, sT = {
  "Status > Last Updated": Yft,
  "Query Hash": Gft,
  "Last Updated": kve
}, Vj = 70, jy = 500, Kft = {
  top: "bottom",
  bottom: "top",
  left: "right",
  right: "left"
};
function OE(t) {
  return ["left", "right"].includes(t);
}
function Ave(t) {
  return Kft[t];
}
function G4(t, e) {
  return "" + t + (e.charAt(0).toUpperCase() + e.slice(1));
}
function Xft({
  position: t = "bottom",
  height: e,
  width: n,
  devtoolsTheme: r,
  isOpen: o,
  isResizing: i,
  panelStyle: s
}) {
  const a = Ave(t), l = G4("border", a), c = OE(t);
  return {
    ...s,
    direction: "ltr",
    position: "fixed",
    [t]: 0,
    [l]: "1px solid " + r.gray,
    transformOrigin: a,
    boxShadow: "0 0 20px rgba(0,0,0,.3)",
    zIndex: 99999,
    // visibility will be toggled after transitions, but set initial state here
    visibility: o ? "visible" : "hidden",
    ...i ? {
      transition: "none"
    } : {
      transition: "all .2s ease"
    },
    ...o ? {
      opacity: 1,
      pointerEvents: "all",
      transform: c ? "translateX(0) scale(1)" : "translateY(0) scale(1)"
    } : {
      opacity: 0,
      pointerEvents: "none",
      transform: c ? "translateX(15px) scale(1.02)" : "translateY(15px) scale(1.02)"
    },
    ...c ? {
      top: 0,
      height: "100vh",
      maxWidth: "90%",
      width: typeof n == "number" && n >= Vj ? n : jy
    } : {
      left: 0,
      width: "100%",
      maxHeight: "90%",
      height: typeof e == "number" && e >= Vj ? e : jy
    }
  };
}
function Qft(t = "bottom") {
  const e = OE(t), n = Ave(t), r = G4("margin", n);
  return {
    position: "absolute",
    cursor: e ? "col-resize" : "row-resize",
    zIndex: 1e5,
    [n]: 0,
    [r]: "-4px",
    ...e ? {
      top: 0,
      height: "100%",
      width: "4px"
    } : {
      width: "100%",
      height: "4px"
    }
  };
}
const Zft = Po("div", (t, e) => ({
  fontSize: "clamp(12px, 1.5vw, 14px)",
  fontFamily: "sans-serif",
  display: "flex",
  backgroundColor: e.background,
  color: e.foreground
}), {
  "(max-width: 700px)": {
    flexDirection: "column"
  },
  "(max-width: 600px)": {
    fontSize: ".9em"
    // flexDirection: 'column',
  }
}), Jft = Po("div", () => ({
  flex: "1 1 500px",
  display: "flex",
  flexDirection: "column",
  overflow: "auto",
  height: "100%"
}), {
  "(max-width: 700px)": (t, e) => ({
    borderTop: "2px solid " + e.gray
  })
}), sa = Po("button", (t, e) => ({
  appearance: "none",
  fontSize: ".9em",
  fontWeight: "bold",
  background: e.gray,
  border: "0",
  borderRadius: ".3em",
  color: "white",
  padding: ".5em",
  opacity: t.disabled ? ".5" : void 0,
  cursor: "pointer"
})), eht = Po("span", {
  display: "flex",
  flexWrap: "wrap",
  gap: "0.5em",
  fontSize: "0.9em"
}), xm = Po("span", {
  display: "inline-flex",
  alignItems: "center",
  padding: ".2em .4em",
  fontWeight: "bold",
  textShadow: "0 0 10px black",
  borderRadius: ".2em"
}), gl = Po("code", {
  fontSize: ".9em",
  color: "inherit",
  background: "inherit"
}), tht = Po("input", (t, e) => ({
  backgroundColor: e.inputBackgroundColor,
  border: 0,
  borderRadius: ".2em",
  color: e.inputTextColor,
  fontSize: ".9em",
  lineHeight: "1.3",
  padding: ".3em .4em"
})), Wj = Po("select", (t, e) => ({
  display: "inline-block",
  fontSize: ".9em",
  fontFamily: "sans-serif",
  fontWeight: "normal",
  lineHeight: "1.3",
  padding: ".3em 1.5em .3em .5em",
  height: "auto",
  border: 0,
  borderRadius: ".2em",
  appearance: "none",
  WebkitAppearance: "none",
  backgroundColor: e.inputBackgroundColor,
  backgroundImage: `url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='100' height='100' fill='%23444444'><polygon points='0,25 100,25 50,75'/></svg>")`,
  backgroundRepeat: "no-repeat",
  backgroundPosition: "right .55em center",
  backgroundSize: ".65em auto, 100%",
  color: e.inputTextColor
}), {
  "(max-width: 500px)": {
    display: "none"
  }
});
function Gj({
  text: t
}) {
  return /* @__PURE__ */ he.createElement("span", {
    style: {
      position: "absolute",
      width: "0.1px",
      height: "0.1px",
      overflow: "hidden"
    }
  }, t);
}
const mQ = Po("div", {
  fontFamily: "Menlo, monospace",
  fontSize: "1em",
  lineHeight: "1.7",
  outline: "none",
  wordBreak: "break-word"
}), nht = Po("span", {
  color: "white"
}), rht = Po("button", {
  cursor: "pointer",
  color: "white"
}), oht = Po("button", {
  cursor: "pointer",
  color: "inherit",
  font: "inherit",
  outline: "inherit",
  background: "transparent",
  border: "none",
  padding: 0
}), iht = ({
  value: t
}) => {
  const [e, n] = he.useState("NoCopy");
  return /* @__PURE__ */ he.createElement("button", {
    onClick: e === "NoCopy" ? () => {
      navigator.clipboard.writeText(xve.stringify(t)).then(() => {
        n("SuccessCopy"), setTimeout(() => {
          n("NoCopy");
        }, 1500);
      }, (r) => {
        console.error("Failed to copy: ", r), n("ErrorCopy"), setTimeout(() => {
          n("NoCopy");
        }, 1500);
      });
    } : void 0,
    style: {
      cursor: "pointer",
      color: "inherit",
      font: "inherit",
      outline: "inherit",
      background: "transparent",
      border: "none",
      padding: 0
    }
  }, e === "NoCopy" ? /* @__PURE__ */ he.createElement(lht, null) : e === "SuccessCopy" ? /* @__PURE__ */ he.createElement(uht, null) : /* @__PURE__ */ he.createElement(cht, null));
}, sht = Po("span", (t, e) => ({
  color: e.danger
})), aT = Po("div", {
  marginLeft: ".1em",
  paddingLeft: "1em",
  borderLeft: "2px solid rgba(0,0,0,.15)"
}), aht = Po("span", {
  color: "grey",
  fontSize: ".7em"
}), gQ = ({
  expanded: t,
  style: e = {}
}) => /* @__PURE__ */ he.createElement("span", {
  style: {
    display: "inline-block",
    transition: "all .1s ease",
    transform: "rotate(" + (t ? 90 : 0) + "deg) " + (e.transform || ""),
    ...e
  }
}, "▶"), lht = () => /* @__PURE__ */ he.createElement("span", {
  "aria-label": "Copy object to clipboard",
  title: "Copy object to clipboard",
  style: {
    paddingLeft: "1em"
  }
}, /* @__PURE__ */ he.createElement("svg", {
  height: "12",
  viewBox: "0 0 16 12",
  width: "10"
}, /* @__PURE__ */ he.createElement("path", {
  fill: "currentColor",
  d: "M0 6.75C0 5.784.784 5 1.75 5h1.5a.75.75 0 010 1.5h-1.5a.25.25 0 00-.25.25v7.5c0 .138.112.25.25.25h7.5a.25.25 0 00.25-.25v-1.5a.75.75 0 011.5 0v1.5A1.75 1.75 0 019.25 16h-7.5A1.75 1.75 0 010 14.25v-7.5z"
}), /* @__PURE__ */ he.createElement("path", {
  fill: "currentColor",
  d: "M5 1.75C5 .784 5.784 0 6.75 0h7.5C15.216 0 16 .784 16 1.75v7.5A1.75 1.75 0 0114.25 11h-7.5A1.75 1.75 0 015 9.25v-7.5zm1.75-.25a.25.25 0 00-.25.25v7.5c0 .138.112.25.25.25h7.5a.25.25 0 00.25-.25v-7.5a.25.25 0 00-.25-.25h-7.5z"
}))), cht = () => /* @__PURE__ */ he.createElement("span", {
  "aria-label": "Failed copying to clipboard",
  title: "Failed copying to clipboard",
  style: {
    paddingLeft: "1em",
    display: "flex",
    alignItems: "center"
  }
}, /* @__PURE__ */ he.createElement("svg", {
  height: "12",
  viewBox: "0 0 16 12",
  width: "10",
  display: "block"
}, /* @__PURE__ */ he.createElement("path", {
  fill: "red",
  d: "M3.72 3.72a.75.75 0 011.06 0L8 6.94l3.22-3.22a.75.75 0 111.06 1.06L9.06 8l3.22 3.22a.75.75 0 11-1.06 1.06L8 9.06l-3.22 3.22a.75.75 0 01-1.06-1.06L6.94 8 3.72 4.78a.75.75 0 010-1.06z"
})), /* @__PURE__ */ he.createElement("span", {
  style: {
    color: "red",
    fontSize: "12px",
    paddingLeft: "4px",
    position: "relative",
    top: "2px"
  }
}, "See console")), uht = () => /* @__PURE__ */ he.createElement("span", {
  "aria-label": "Object copied to clipboard",
  title: "Object copied to clipboard",
  style: {
    paddingLeft: "1em",
    display: "inline-block",
    verticalAlign: "middle"
  }
}, /* @__PURE__ */ he.createElement("svg", {
  height: "16",
  viewBox: "0 0 16 16",
  width: "16",
  display: "block"
}, /* @__PURE__ */ he.createElement("path", {
  fill: "green",
  d: "M13.78 4.22a.75.75 0 010 1.06l-7.25 7.25a.75.75 0 01-1.06 0L2.22 9.28a.75.75 0 011.06-1.06L6 10.94l6.72-6.72a.75.75 0 011.06 0z"
})));
function dht(t, e) {
  if (e < 1) return [];
  let n = 0;
  const r = [];
  for (; n < t.length; )
    r.push(t.slice(n, n + e)), n = n + e;
  return r;
}
const fht = ({
  handleEntry: t,
  label: e,
  value: n,
  subEntries: r = [],
  subEntryPages: o = [],
  type: i,
  expanded: s = !1,
  copyable: a = !1,
  toggleExpanded: l,
  pageSize: c
}) => {
  const [u, d] = he.useState([]);
  return /* @__PURE__ */ he.createElement(mQ, {
    key: e
  }, o.length ? /* @__PURE__ */ he.createElement(he.Fragment, null, /* @__PURE__ */ he.createElement(oht, {
    onClick: () => l()
  }, /* @__PURE__ */ he.createElement(gQ, {
    expanded: s
  }), " ", e, " ", /* @__PURE__ */ he.createElement(aht, null, String(i).toLowerCase() === "iterable" ? "(Iterable) " : "", r.length, " ", r.length > 1 ? "items" : "item")), a ? /* @__PURE__ */ he.createElement(iht, {
    value: n
  }) : null, s ? o.length === 1 ? /* @__PURE__ */ he.createElement(aT, null, r.map(t)) : /* @__PURE__ */ he.createElement(aT, null, o.map((f, h) => /* @__PURE__ */ he.createElement("div", {
    key: h
  }, /* @__PURE__ */ he.createElement(mQ, null, /* @__PURE__ */ he.createElement(rht, {
    onClick: () => d((p) => p.includes(h) ? p.filter((m) => m !== h) : [...p, h])
  }, /* @__PURE__ */ he.createElement(gQ, {
    expanded: s
  }), " [", h * c, " ...", " ", h * c + c - 1, "]"), u.includes(h) ? /* @__PURE__ */ he.createElement(aT, null, f.map(t)) : null)))) : null) : /* @__PURE__ */ he.createElement(he.Fragment, null, /* @__PURE__ */ he.createElement(nht, null, e, ":"), " ", /* @__PURE__ */ he.createElement(sht, null, Cve(n))));
};
function hht(t) {
  return Symbol.iterator in t;
}
function Yj({
  value: t,
  defaultExpanded: e,
  renderer: n = fht,
  pageSize: r = 100,
  copyable: o = !1,
  ...i
}) {
  const [s, a] = he.useState(!!e), l = he.useCallback(() => a((h) => !h), []);
  let c = typeof t, u = [];
  const d = (h) => {
    const p = e === !0 ? {
      [h.label]: !0
    } : e?.[h.label];
    return {
      ...h,
      defaultExpanded: p
    };
  };
  Array.isArray(t) ? (c = "array", u = t.map((h, p) => d({
    label: p.toString(),
    value: h
  }))) : t !== null && typeof t == "object" && hht(t) && typeof t[Symbol.iterator] == "function" ? (c = "Iterable", u = Array.from(t, (h, p) => d({
    label: p.toString(),
    value: h
  }))) : typeof t == "object" && t !== null && (c = "object", u = Object.entries(t).map(([h, p]) => d({
    label: h,
    value: p
  })));
  const f = dht(u, r);
  return n({
    handleEntry: (h) => /* @__PURE__ */ he.createElement(Yj, Fl({
      key: h.label,
      value: t,
      renderer: n,
      copyable: o
    }, i, h)),
    type: c,
    subEntries: u,
    subEntryPages: f,
    value: t,
    expanded: s,
    copyable: o,
    toggleExpanded: l,
    pageSize: r,
    ...i
  });
}
function Tve(t) {
  return /* @__PURE__ */ he.createElement("svg", Fl({
    width: "40px",
    height: "40px",
    viewBox: "0 0 190 190",
    version: "1.1"
  }, t), /* @__PURE__ */ he.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /* @__PURE__ */ he.createElement("g", {
    transform: "translate(-33.000000, 0.000000)"
  }, /* @__PURE__ */ he.createElement("path", {
    d: "M72.7239712,61.3436237 C69.631224,46.362877 68.9675112,34.8727722 70.9666331,26.5293551 C72.1555965,21.5671678 74.3293088,17.5190846 77.6346064,14.5984631 C81.1241394,11.5150478 85.5360327,10.0020122 90.493257,10.0020122 C98.6712013,10.0020122 107.26826,13.7273214 116.455725,20.8044264 C120.20312,23.6910458 124.092437,27.170411 128.131651,31.2444746 C128.45314,30.8310265 128.816542,30.4410453 129.22143,30.0806152 C140.64098,19.9149716 150.255245,13.5989272 158.478408,11.1636507 C163.367899,9.715636 167.958526,9.57768202 172.138936,10.983031 C176.551631,12.4664684 180.06766,15.5329489 182.548314,19.8281091 C186.642288,26.9166735 187.721918,36.2310983 186.195595,47.7320243 C185.573451,52.4199112 184.50985,57.5263831 183.007094,63.0593153 C183.574045,63.1277086 184.142416,63.2532808 184.705041,63.4395297 C199.193932,68.2358678 209.453582,73.3937462 215.665021,79.2882839 C219.360669,82.7953831 221.773972,86.6998434 222.646365,91.0218204 C223.567176,95.5836746 222.669313,100.159332 220.191548,104.451297 C216.105211,111.529614 208.591643,117.11221 197.887587,121.534031 C193.589552,123.309539 188.726579,124.917559 183.293259,126.363748 C183.541176,126.92292 183.733521,127.516759 183.862138,128.139758 C186.954886,143.120505 187.618598,154.61061 185.619477,162.954027 C184.430513,167.916214 182.256801,171.964297 178.951503,174.884919 C175.46197,177.968334 171.050077,179.48137 166.092853,179.48137 C157.914908,179.48137 149.31785,175.756061 140.130385,168.678956 C136.343104,165.761613 132.410866,162.238839 128.325434,158.108619 C127.905075,158.765474 127.388968,159.376011 126.77857,159.919385 C115.35902,170.085028 105.744755,176.401073 97.5215915,178.836349 C92.6321009,180.284364 88.0414736,180.422318 83.8610636,179.016969 C79.4483686,177.533532 75.9323404,174.467051 73.4516862,170.171891 C69.3577116,163.083327 68.2780823,153.768902 69.8044053,142.267976 C70.449038,137.410634 71.56762,132.103898 73.1575891,126.339009 C72.5361041,126.276104 71.9120754,126.144816 71.2949591,125.940529 C56.8060684,121.144191 46.5464184,115.986312 40.3349789,110.091775 C36.6393312,106.584675 34.2260275,102.680215 33.3536352,98.3582381 C32.4328237,93.7963839 33.3306866,89.2207269 35.8084524,84.9287618 C39.8947886,77.8504443 47.4083565,72.2678481 58.1124133,67.8460273 C62.5385143,66.0176154 67.5637208,64.366822 73.1939394,62.8874674 C72.9933393,62.3969171 72.8349374,61.8811235 72.7239712,61.3436237 Z",
    fill: "#002C4B",
    fillRule: "nonzero",
    transform: "translate(128.000000, 95.000000) scale(-1, 1) translate(-128.000000, -95.000000) "
  }), /* @__PURE__ */ he.createElement("path", {
    d: "M113.396882,64 L142.608177,64 C144.399254,64 146.053521,64.958025 146.944933,66.5115174 L161.577138,92.0115174 C162.461464,93.5526583 162.461464,95.4473417 161.577138,96.9884826 L146.944933,122.488483 C146.053521,124.041975 144.399254,125 142.608177,125 L113.396882,125 C111.605806,125 109.951539,124.041975 109.060126,122.488483 L94.4279211,96.9884826 C93.543596,95.4473417 93.543596,93.5526583 94.4279211,92.0115174 L109.060126,66.5115174 C109.951539,64.958025 111.605806,64 113.396882,64 Z M138.987827,70.2765273 C140.779849,70.2765273 142.434839,71.2355558 143.325899,72.7903404 L154.343038,92.0138131 C155.225607,93.5537825 155.225607,95.4462175 154.343038,96.9861869 L143.325899,116.20966 C142.434839,117.764444 140.779849,118.723473 138.987827,118.723473 L117.017233,118.723473 C115.225211,118.723473 113.570221,117.764444 112.67916,116.20966 L101.662022,96.9861869 C100.779452,95.4462175 100.779452,93.5537825 101.662022,92.0138131 L112.67916,72.7903404 C113.570221,71.2355558 115.225211,70.2765273 117.017233,70.2765273 L138.987827,70.2765273 Z M135.080648,77.1414791 L120.924411,77.1414791 C119.134228,77.1414791 117.480644,78.0985567 116.5889,79.6508285 L116.5889,79.6508285 L109.489217,92.0093494 C108.603232,93.5515958 108.603232,95.4484042 109.489217,96.9906506 L109.489217,96.9906506 L116.5889,109.349172 C117.480644,110.901443 119.134228,111.858521 120.924411,111.858521 L120.924411,111.858521 L135.080648,111.858521 C136.870831,111.858521 138.524416,110.901443 139.41616,109.349172 L139.41616,109.349172 L146.515843,96.9906506 C147.401828,95.4484042 147.401828,93.5515958 146.515843,92.0093494 L146.515843,92.0093494 L139.41616,79.6508285 C138.524416,78.0985567 136.870831,77.1414791 135.080648,77.1414791 L135.080648,77.1414791 Z M131.319186,83.7122186 C133.108028,83.7122186 134.760587,84.6678753 135.652827,86.2183156 L138.983552,92.0060969 C139.87203,93.5500005 139.87203,95.4499995 138.983552,96.9939031 L135.652827,102.781684 C134.760587,104.332125 133.108028,105.287781 131.319186,105.287781 L124.685874,105.287781 C122.897032,105.287781 121.244473,104.332125 120.352233,102.781684 L117.021508,96.9939031 C116.13303,95.4499995 116.13303,93.5500005 117.021508,92.0060969 L120.352233,86.2183156 C121.244473,84.6678753 122.897032,83.7122186 124.685874,83.7122186 L131.319186,83.7122186 Z M128.003794,90.1848875 C126.459294,90.1848875 125.034382,91.0072828 124.263005,92.3424437 C123.491732,93.6774232 123.491732,95.3225768 124.263005,96.6575563 C125.034382,97.9927172 126.459294,98.8151125 128.001266,98.8151125 L128.001266,98.8151125 C129.545766,98.8151125 130.970678,97.9927172 131.742055,96.6575563 C132.513327,95.3225768 132.513327,93.6774232 131.742055,92.3424437 C130.970678,91.0072828 129.545766,90.1848875 128.003794,90.1848875 L128.003794,90.1848875 Z M93,94.5009646 L100.767764,94.5009646",
    fill: "#FFD94C"
  }), /* @__PURE__ */ he.createElement("path", {
    d: "M87.8601729,108.357758 C89.1715224,107.608286 90.8360246,108.074601 91.5779424,109.399303 L91.5779424,109.399303 L92.0525843,110.24352 C95.8563392,116.982993 99.8190116,123.380176 103.940602,129.435068 C108.807881,136.585427 114.28184,143.82411 120.362479,151.151115 C121.316878,152.30114 121.184944,154.011176 120.065686,154.997937 L120.065686,154.997937 L119.454208,155.534625 C99.3465389,173.103314 86.2778188,176.612552 80.2480482,166.062341 C74.3500652,155.742717 76.4844915,136.982888 86.6513274,109.782853 C86.876818,109.179582 87.3045861,108.675291 87.8601729,108.357758 Z M173.534177,129.041504 C174.986131,128.785177 176.375496,129.742138 176.65963,131.194242 L176.65963,131.194242 L176.812815,131.986376 C181.782365,157.995459 178.283348,171 166.315764,171 C154.609745,171 139.708724,159.909007 121.612702,137.727022 C121.211349,137.235047 120.994572,136.617371 121,135.981509 C121.013158,134.480686 122.235785,133.274651 123.730918,133.287756 L123.730918,133.287756 L124.684654,133.294531 C132.305698,133.335994 139.714387,133.071591 146.910723,132.501323 C155.409039,131.82788 164.283523,130.674607 173.534177,129.041504 Z M180.408726,73.8119663 C180.932139,72.4026903 182.508386,71.6634537 183.954581,72.149012 L183.954581,72.149012 L184.742552,72.4154854 C210.583763,81.217922 220.402356,90.8916805 214.198332,101.436761 C208.129904,111.751366 190.484347,119.260339 161.26166,123.963678 C160.613529,124.067994 159.948643,123.945969 159.382735,123.618843 C158.047025,122.846729 157.602046,121.158214 158.388848,119.847438 L158.388848,119.847438 L158.889328,119.0105 C162.877183,112.31633 166.481358,105.654262 169.701854,99.0242957 C173.50501,91.1948179 177.073967,82.7907081 180.408726,73.8119663 Z M94.7383398,66.0363218 C95.3864708,65.9320063 96.0513565,66.0540315 96.6172646,66.3811573 C97.9529754,67.153271 98.3979538,68.8417862 97.6111517,70.1525615 L97.6111517,70.1525615 L97.1106718,70.9895001 C93.1228168,77.6836699 89.5186416,84.3457379 86.2981462,90.9757043 C82.49499,98.8051821 78.9260328,107.209292 75.5912744,116.188034 C75.0678608,117.59731 73.4916142,118.336546 72.045419,117.850988 L72.045419,117.850988 L71.2574475,117.584515 C45.4162372,108.782078 35.597644,99.1083195 41.8016679,88.5632391 C47.8700957,78.2486335 65.515653,70.7396611 94.7383398,66.0363218 Z M136.545792,34.4653746 C156.653461,16.8966864 169.722181,13.3874478 175.751952,23.9376587 C181.649935,34.2572826 179.515508,53.0171122 169.348673,80.2171474 C169.123182,80.8204179 168.695414,81.324709 168.139827,81.6422422 C166.828478,82.3917144 165.163975,81.9253986 164.422058,80.6006966 L164.422058,80.6006966 L163.947416,79.7564798 C160.143661,73.0170065 156.180988,66.6198239 152.059398,60.564932 C147.192119,53.4145727 141.71816,46.1758903 135.637521,38.8488847 C134.683122,37.6988602 134.815056,35.9888243 135.934314,35.0020629 L135.934314,35.0020629 Z M90.6842361,18 C102.390255,18 117.291276,29.0909926 135.387298,51.2729777 C135.788651,51.7649527 136.005428,52.3826288 136,53.0184911 C135.986842,54.5193144 134.764215,55.7253489 133.269082,55.7122445 L133.269082,55.7122445 L132.315346,55.7054689 C124.694302,55.6640063 117.285613,55.9284091 110.089277,56.4986773 C101.590961,57.17212 92.7164767,58.325393 83.4658235,59.9584962 C82.0138691,60.2148231 80.6245044,59.2578618 80.3403697,57.805758 L80.3403697,57.805758 L80.1871846,57.0136235 C75.2176347,31.0045412 78.7166519,18 90.6842361,18 Z",
    fill: "#FF4154"
  }))));
}
function pht({
  initialIsOpen: t,
  panelProps: e = {},
  closeButtonProps: n = {},
  toggleButtonProps: r = {},
  position: o = "bottom-left",
  containerElement: i = "aside",
  context: s,
  styleNonce: a,
  panelPosition: l = "bottom",
  errorTypes: c = []
}) {
  const u = he.useRef(null), d = he.useRef(null), [f, h] = Fc("reactQueryDevtoolsOpen", t), [p, m] = Fc("reactQueryDevtoolsHeight", jy), [g, y] = Fc("reactQueryDevtoolsWidth", jy), [v = "bottom", b] = Fc("reactQueryDevtoolsPanelPosition", l), [_, w] = he.useState(!1), [x, E] = he.useState(!1), S = Wft(), C = (T, I) => {
    if (!T || I.button !== 0) return;
    const j = OE(v);
    E(!0);
    const {
      height: z,
      width: $
    } = T.getBoundingClientRect(), D = I.clientX, U = I.clientY;
    let q = 0;
    const F = (H) => {
      H.preventDefault(), j ? (q = $ + (v === "right" ? D - H.clientX : H.clientX - D), y(q)) : (q = z + (v === "bottom" ? U - H.clientY : H.clientY - U), m(q)), q < Vj ? h(!1) : h(!0);
    }, B = () => {
      x && E(!1), document.removeEventListener("mousemove", F, !1), document.removeEventListener("mouseUp", B, !1);
    };
    document.addEventListener("mousemove", F, !1), document.addEventListener("mouseup", B, !1);
  };
  he.useEffect(() => {
    w(f ?? !1);
  }, [f, _, w]), he.useEffect(() => {
    const T = d.current;
    if (T) {
      const I = () => {
        _ && (T.style.visibility = "visible");
      }, j = () => {
        _ || (T.style.visibility = "hidden");
      };
      return T.addEventListener("transitionstart", I), T.addEventListener("transitionend", j), () => {
        T.removeEventListener("transitionstart", I), T.removeEventListener("transitionend", j);
      };
    }
  }, [_]), he.useEffect(() => {
    var T;
    if (_ && (T = u.current) != null && T.parentElement) {
      const {
        parentElement: I
      } = u.current, j = G4("padding", v), z = OE(v), $ = (({
        padding: U,
        paddingTop: q,
        paddingBottom: F,
        paddingLeft: B,
        paddingRight: H
      }) => ({
        padding: U,
        paddingTop: q,
        paddingBottom: F,
        paddingLeft: B,
        paddingRight: H
      }))(I.style), D = () => {
        I.style.padding = "0px", I.style.paddingTop = "0px", I.style.paddingBottom = "0px", I.style.paddingLeft = "0px", I.style.paddingRight = "0px", I.style[j] = (z ? g : p) + "px";
      };
      if (D(), typeof window < "u")
        return window.addEventListener("resize", D), () => {
          window.removeEventListener("resize", D), Object.entries($).forEach(([U, q]) => {
            I.style[U] = q;
          });
        };
    }
  }, [_, v, p, g]);
  const {
    style: R = {},
    ...P
  } = e, {
    style: N = {},
    onClick: A,
    ...O
  } = r, k = Xft({
    position: v,
    devtoolsTheme: Qt,
    isOpen: _,
    height: p,
    width: g,
    isResizing: x,
    panelStyle: R
  });
  return S() ? /* @__PURE__ */ he.createElement(i, {
    ref: u,
    className: "ReactQueryDevtools",
    "aria-label": "React Query Devtools"
  }, /* @__PURE__ */ he.createElement(Sve, {
    theme: Qt
  }, /* @__PURE__ */ he.createElement(mht, Fl({
    ref: d,
    context: s,
    styleNonce: a,
    position: v,
    onPositionChange: b,
    showCloseButton: !0,
    closeButtonProps: n
  }, P, {
    style: k,
    isOpen: _,
    setIsOpen: h,
    onDragStart: (T) => C(d.current, T),
    errorTypes: c
  }))), _ ? null : /* @__PURE__ */ he.createElement("button", Fl({
    type: "button"
  }, O, {
    "aria-label": "Open React Query Devtools",
    "aria-controls": "ReactQueryDevtoolsPanel",
    "aria-haspopup": "true",
    "aria-expanded": "false",
    onClick: (T) => {
      h(!0), A?.(T);
    },
    style: {
      background: "none",
      border: 0,
      padding: 0,
      position: "fixed",
      zIndex: 99999,
      display: "inline-flex",
      fontSize: "1.5em",
      margin: ".5em",
      cursor: "pointer",
      width: "fit-content",
      ...o === "top-right" ? {
        top: "0",
        right: "0"
      } : o === "top-left" ? {
        top: "0",
        left: "0"
      } : o === "bottom-right" ? {
        bottom: "0",
        right: "0"
      } : {
        bottom: "0",
        left: "0"
      },
      ...N
    }
  }), /* @__PURE__ */ he.createElement(Tve, {
    "aria-hidden": !0
  }), /* @__PURE__ */ he.createElement(Gj, {
    text: "Open React Query Devtools"
  }))) : null;
}
const ko = (t, e, n = !1) => ble.useSyncExternalStore(he.useCallback((r) => n ? () => {
} : t.subscribe(_r.batchCalls(r)), [t, n]), e, e), mht = /* @__PURE__ */ he.forwardRef(function(t, e) {
  const {
    isOpen: n = !0,
    styleNonce: r,
    setIsOpen: o,
    context: i,
    onDragStart: s,
    onPositionChange: a,
    showCloseButton: l,
    position: c,
    closeButtonProps: u = {},
    errorTypes: d = [],
    ...f
  } = t, {
    onClick: h,
    ...p
  } = u, m = _le({
    context: i
  }), g = m.getQueryCache(), [y, v] = Fc("reactQueryDevtoolsSortFn", Object.keys(sT)[0]), [b, _] = Fc("reactQueryDevtoolsFilter", ""), [w, x] = Fc("reactQueryDevtoolsBaseSort", 1), E = he.useMemo(() => sT[y], [y]), S = ko(g, () => g.getAll().length, !n), [C, R] = Fc("reactQueryDevtoolsActiveQueryHash", ""), P = he.useMemo(() => {
    const O = g.getAll();
    if (S === 0)
      return [];
    const k = b ? O.filter((T) => oft(T.queryHash, b).passed) : [...O];
    return E ? k.sort((T, I) => E(T, I) * w) : k;
  }, [w, E, b, S, g]), [N, A] = he.useState(!1);
  return /* @__PURE__ */ he.createElement(Sve, {
    theme: Qt
  }, /* @__PURE__ */ he.createElement(Zft, Fl({
    ref: e,
    className: "ReactQueryDevtoolsPanel",
    "aria-label": "React Query Devtools Panel",
    id: "ReactQueryDevtoolsPanel"
  }, f, {
    style: {
      height: jy,
      position: "relative",
      ...f.style
    }
  }), /* @__PURE__ */ he.createElement("style", {
    nonce: r,
    dangerouslySetInnerHTML: {
      __html: `
            .ReactQueryDevtoolsPanel * {
              scrollbar-color: ` + Qt.backgroundAlt + " " + Qt.gray + `;
            }

            .ReactQueryDevtoolsPanel *::-webkit-scrollbar, .ReactQueryDevtoolsPanel scrollbar {
              width: 1em;
              height: 1em;
            }

            .ReactQueryDevtoolsPanel *::-webkit-scrollbar-track, .ReactQueryDevtoolsPanel scrollbar-track {
              background: ` + Qt.backgroundAlt + `;
            }

            .ReactQueryDevtoolsPanel *::-webkit-scrollbar-thumb, .ReactQueryDevtoolsPanel scrollbar-thumb {
              background: ` + Qt.gray + `;
              border-radius: .5em;
              border: 3px solid ` + Qt.backgroundAlt + `;
            }
          `
    }
  }), /* @__PURE__ */ he.createElement("div", {
    style: Qft(c),
    onMouseDown: s
  }), n && /* @__PURE__ */ he.createElement("div", {
    style: {
      flex: "1 1 500px",
      minHeight: "40%",
      maxHeight: "100%",
      overflow: "auto",
      borderRight: "1px solid " + Qt.grayAlt,
      display: "flex",
      flexDirection: "column"
    }
  }, /* @__PURE__ */ he.createElement("div", {
    style: {
      padding: ".5em",
      background: Qt.backgroundAlt,
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center"
    }
  }, /* @__PURE__ */ he.createElement("button", {
    type: "button",
    "aria-label": "Close React Query Devtools",
    "aria-controls": "ReactQueryDevtoolsPanel",
    "aria-haspopup": "true",
    "aria-expanded": "true",
    onClick: () => o(!1),
    style: {
      display: "inline-flex",
      background: "none",
      border: 0,
      padding: 0,
      marginRight: ".5em",
      cursor: "pointer"
    }
  }, /* @__PURE__ */ he.createElement(Tve, {
    "aria-hidden": !0
  }), /* @__PURE__ */ he.createElement(Gj, {
    text: "Close React Query Devtools"
  })), /* @__PURE__ */ he.createElement("div", {
    style: {
      display: "flex",
      flexDirection: "column"
    }
  }, /* @__PURE__ */ he.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: ".5em"
    }
  }, /* @__PURE__ */ he.createElement(yht, {
    queryCache: g
  }), c && a ? /* @__PURE__ */ he.createElement(Wj, {
    "aria-label": "Panel position",
    value: c,
    style: {
      marginInlineStart: ".5em"
    },
    onChange: (O) => a(O.target.value)
  }, /* @__PURE__ */ he.createElement("option", {
    value: "left"
  }, "Left"), /* @__PURE__ */ he.createElement("option", {
    value: "right"
  }, "Right"), /* @__PURE__ */ he.createElement("option", {
    value: "top"
  }, "Top"), /* @__PURE__ */ he.createElement("option", {
    value: "bottom"
  }, "Bottom")) : null), /* @__PURE__ */ he.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      flexWrap: "wrap",
      gap: "0.5em"
    }
  }, /* @__PURE__ */ he.createElement(tht, {
    placeholder: "Filter",
    "aria-label": "Filter by queryhash",
    value: b ?? "",
    onChange: (O) => _(O.target.value),
    onKeyDown: (O) => {
      O.key === "Escape" && _("");
    },
    style: {
      flex: "1",
      width: "100%"
    }
  }), /* @__PURE__ */ he.createElement(Wj, {
    "aria-label": "Sort queries",
    value: y,
    onChange: (O) => v(O.target.value),
    style: {
      flex: "1",
      minWidth: 75,
      marginRight: ".5em"
    }
  }, Object.keys(sT).map((O) => /* @__PURE__ */ he.createElement("option", {
    key: O,
    value: O
  }, "Sort by ", O))), /* @__PURE__ */ he.createElement(sa, {
    type: "button",
    onClick: () => x((O) => O * -1),
    style: {
      padding: ".3em .4em",
      marginRight: ".5em"
    }
  }, w === 1 ? "⬆ Asc" : "⬇ Desc"), /* @__PURE__ */ he.createElement(sa, {
    title: "Clear cache",
    "aria-label": "Clear cache",
    type: "button",
    onClick: () => g.clear(),
    style: {
      padding: ".3em .4em",
      marginRight: ".5em"
    }
  }, "Clear"), /* @__PURE__ */ he.createElement(sa, {
    type: "button",
    onClick: () => {
      N ? (Nh.setOnline(void 0), A(!1), window.dispatchEvent(new Event("online"))) : (Nh.setOnline(!1), A(!0));
    },
    "aria-label": N ? "Restore offline mock" : "Mock offline behavior",
    title: N ? "Restore offline mock" : "Mock offline behavior",
    style: {
      padding: "0",
      height: "2em"
    }
  }, /* @__PURE__ */ he.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "2em",
    height: "2em",
    viewBox: "0 0 24 24",
    stroke: N ? Qt.danger : "currentColor",
    fill: "none"
  }, N ? /* @__PURE__ */ he.createElement(he.Fragment, null, /* @__PURE__ */ he.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /* @__PURE__ */ he.createElement("line", {
    x1: "12",
    y1: "18",
    x2: "12.01",
    y2: "18"
  }), /* @__PURE__ */ he.createElement("path", {
    d: "M9.172 15.172a4 4 0 0 1 5.656 0"
  }), /* @__PURE__ */ he.createElement("path", {
    d: "M6.343 12.343a7.963 7.963 0 0 1 3.864 -2.14m4.163 .155a7.965 7.965 0 0 1 3.287 2"
  }), /* @__PURE__ */ he.createElement("path", {
    d: "M3.515 9.515a12 12 0 0 1 3.544 -2.455m3.101 -.92a12 12 0 0 1 10.325 3.374"
  }), /* @__PURE__ */ he.createElement("line", {
    x1: "3",
    y1: "3",
    x2: "21",
    y2: "21"
  })) : /* @__PURE__ */ he.createElement(he.Fragment, null, /* @__PURE__ */ he.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /* @__PURE__ */ he.createElement("line", {
    x1: "12",
    y1: "18",
    x2: "12.01",
    y2: "18"
  }), /* @__PURE__ */ he.createElement("path", {
    d: "M9.172 15.172a4 4 0 0 1 5.656 0"
  }), /* @__PURE__ */ he.createElement("path", {
    d: "M6.343 12.343a8 8 0 0 1 11.314 0"
  }), /* @__PURE__ */ he.createElement("path", {
    d: "M3.515 9.515c4.686 -4.687 12.284 -4.687 17 0"
  }))), /* @__PURE__ */ he.createElement(Gj, {
    text: N ? "Restore offline mock" : "Mock offline behavior"
  }))))), /* @__PURE__ */ he.createElement("div", {
    style: {
      overflowY: "auto",
      flex: "1"
    }
  }, P.map((O) => /* @__PURE__ */ he.createElement(Rve, {
    queryKey: O.queryKey,
    activeQueryHash: C,
    setActiveQueryHash: R,
    key: O.queryHash,
    queryCache: g
  })))), C && n ? /* @__PURE__ */ he.createElement(ght, {
    activeQueryHash: C,
    queryCache: g,
    queryClient: m,
    errorTypes: d
  }) : null, l ? /* @__PURE__ */ he.createElement(sa, Fl({
    type: "button",
    "aria-controls": "ReactQueryDevtoolsPanel",
    "aria-haspopup": "true",
    "aria-expanded": "true"
  }, p, {
    style: {
      position: "absolute",
      zIndex: 99999,
      margin: ".5em",
      bottom: 0,
      left: 0,
      ...p.style
    },
    onClick: (O) => {
      o(!1), h?.(O);
    }
  }), "Close") : null));
}), ght = ({
  queryCache: t,
  activeQueryHash: e,
  queryClient: n,
  errorTypes: r
}) => {
  var o, i;
  const s = ko(t, () => t.getAll().find((p) => p.queryHash === e)), a = ko(t, () => {
    var p;
    return (p = t.getAll().find((m) => m.queryHash === e)) == null ? void 0 : p.state;
  }), l = (o = ko(t, () => {
    var p;
    return (p = t.getAll().find((m) => m.queryHash === e)) == null ? void 0 : p.isStale();
  })) != null ? o : !1, c = (i = ko(t, () => {
    var p;
    return (p = t.getAll().find((m) => m.queryHash === e)) == null ? void 0 : p.getObserversCount();
  })) != null ? i : 0, u = () => {
    s?.fetch()?.catch(vht);
  }, d = cn(() => {
    if (s && a != null && a.error)
      return r.find((m) => {
        var g;
        return m.initializer(s).toString() === ((g = a.error) == null ? void 0 : g.toString());
      })?.name;
  }, [s, a?.error, r]);
  if (!s || !a)
    return null;
  const f = (p) => {
    var m;
    const g = (m = p?.initializer(s)) != null ? m : new Error("Unknown error from devtools"), y = s.options;
    s.setState({
      status: "error",
      error: g,
      fetchMeta: {
        ...s.state.fetchMeta,
        __previousQueryOptions: y
      }
    });
  }, h = () => {
    s.fetch(s.state.fetchMeta.__previousQueryOptions, {
      // Make sure this fetch will cancel the previous one
      cancelRefetch: !0
    });
  };
  return /* @__PURE__ */ he.createElement(Jft, null, /* @__PURE__ */ he.createElement("div", {
    style: {
      padding: ".5em",
      background: Qt.backgroundAlt,
      position: "sticky",
      top: 0,
      zIndex: 1
    }
  }, "Query Details"), /* @__PURE__ */ he.createElement("div", {
    style: {
      padding: ".5em"
    }
  }, /* @__PURE__ */ he.createElement("div", {
    style: {
      marginBottom: ".5em",
      display: "flex",
      alignItems: "flex-start",
      justifyContent: "space-between"
    }
  }, /* @__PURE__ */ he.createElement(gl, {
    style: {
      lineHeight: "1.8em"
    }
  }, /* @__PURE__ */ he.createElement("pre", {
    style: {
      margin: 0,
      padding: 0,
      overflow: "auto"
    }
  }, Cve(s.queryKey, !0))), /* @__PURE__ */ he.createElement("span", {
    style: {
      padding: "0.3em .6em",
      borderRadius: "0.4em",
      fontWeight: "bold",
      textShadow: "0 2px 10px black",
      background: Ove({
        queryState: a,
        isStale: l,
        observerCount: c,
        theme: Qt
      }),
      flexShrink: 0
    }
  }, Bf(s))), /* @__PURE__ */ he.createElement("div", {
    style: {
      marginBottom: ".5em",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between"
    }
  }, "Observers: ", /* @__PURE__ */ he.createElement(gl, null, c)), /* @__PURE__ */ he.createElement("div", {
    style: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between"
    }
  }, "Last Updated:", " ", /* @__PURE__ */ he.createElement(gl, null, new Date(a.dataUpdatedAt).toLocaleTimeString()))), /* @__PURE__ */ he.createElement("div", {
    style: {
      background: Qt.backgroundAlt,
      padding: ".5em",
      position: "sticky",
      top: 0,
      zIndex: 1
    }
  }, "Actions"), /* @__PURE__ */ he.createElement("div", {
    style: {
      padding: "0.5em",
      display: "flex",
      flexWrap: "wrap",
      gap: "0.5em",
      alignItems: "flex-end"
    }
  }, /* @__PURE__ */ he.createElement(sa, {
    type: "button",
    onClick: u,
    disabled: a.fetchStatus === "fetching",
    style: {
      background: Qt.active
    }
  }, "Refetch"), " ", /* @__PURE__ */ he.createElement(sa, {
    type: "button",
    onClick: () => n.invalidateQueries(s),
    style: {
      background: Qt.warning,
      color: Qt.inputTextColor
    }
  }, "Invalidate"), " ", /* @__PURE__ */ he.createElement(sa, {
    type: "button",
    onClick: () => n.resetQueries(s),
    style: {
      background: Qt.gray
    }
  }, "Reset"), " ", /* @__PURE__ */ he.createElement(sa, {
    type: "button",
    onClick: () => n.removeQueries(s),
    style: {
      background: Qt.danger
    }
  }, "Remove"), " ", /* @__PURE__ */ he.createElement(sa, {
    type: "button",
    onClick: () => {
      var p;
      if (!(s.state.fetchStatus === "fetching" && typeof ((p = s.state.fetchMeta) == null ? void 0 : p.__previousQueryOptions) > "u"))
        if (s.state.data === void 0)
          h();
        else {
          const m = s.options;
          s.fetch({
            ...m,
            queryFn: () => new Promise(() => {
            }),
            cacheTime: -1
          }), s.setState({
            data: void 0,
            status: "loading",
            fetchMeta: {
              ...s.state.fetchMeta,
              __previousQueryOptions: m
            }
          });
        }
    },
    style: {
      background: Qt.paused
    }
  }, s.state.status === "loading" ? "Restore" : "Trigger", " ", "loading"), " ", r.length === 0 || s.state.status === "error" ? /* @__PURE__ */ he.createElement(sa, {
    type: "button",
    onClick: () => {
      s.state.error ? n.resetQueries(s) : f();
    },
    style: {
      background: Qt.danger
    }
  }, s.state.status === "error" ? "Restore" : "Trigger", " error") : /* @__PURE__ */ he.createElement("label", null, "Trigger error:", /* @__PURE__ */ he.createElement(Wj, {
    value: d ?? "",
    style: {
      marginInlineStart: ".5em"
    },
    onChange: (p) => {
      const m = r.find((g) => g.name === p.target.value);
      f(m);
    }
  }, /* @__PURE__ */ he.createElement("option", {
    key: "",
    value: ""
  }), r.map((p) => /* @__PURE__ */ he.createElement("option", {
    key: p.name,
    value: p.name
  }, p.name))))), /* @__PURE__ */ he.createElement("div", {
    style: {
      background: Qt.backgroundAlt,
      padding: ".5em",
      position: "sticky",
      top: 0,
      zIndex: 1
    }
  }, "Data Explorer"), /* @__PURE__ */ he.createElement("div", {
    style: {
      padding: ".5em"
    }
  }, /* @__PURE__ */ he.createElement(Yj, {
    label: "Data",
    value: a.data,
    defaultExpanded: {},
    copyable: !0
  })), /* @__PURE__ */ he.createElement("div", {
    style: {
      background: Qt.backgroundAlt,
      padding: ".5em",
      position: "sticky",
      top: 0,
      zIndex: 1
    }
  }, "Query Explorer"), /* @__PURE__ */ he.createElement("div", {
    style: {
      padding: ".5em"
    }
  }, /* @__PURE__ */ he.createElement(Yj, {
    label: "Query",
    value: s,
    defaultExpanded: {
      queryKey: !0
    }
  })));
}, yht = ({
  queryCache: t
}) => {
  const e = ko(t, () => t.getAll().filter((s) => Bf(s) === "fresh").length), n = ko(t, () => t.getAll().filter((s) => Bf(s) === "fetching").length), r = ko(t, () => t.getAll().filter((s) => Bf(s) === "paused").length), o = ko(t, () => t.getAll().filter((s) => Bf(s) === "stale").length), i = ko(t, () => t.getAll().filter((s) => Bf(s) === "inactive").length);
  return /* @__PURE__ */ he.createElement(eht, null, /* @__PURE__ */ he.createElement(xm, {
    style: {
      background: Qt.success,
      opacity: e ? 1 : 0.3
    }
  }, "fresh ", /* @__PURE__ */ he.createElement(gl, null, "(", e, ")")), " ", /* @__PURE__ */ he.createElement(xm, {
    style: {
      background: Qt.active,
      opacity: n ? 1 : 0.3
    }
  }, "fetching ", /* @__PURE__ */ he.createElement(gl, null, "(", n, ")")), " ", /* @__PURE__ */ he.createElement(xm, {
    style: {
      background: Qt.paused,
      opacity: r ? 1 : 0.3
    }
  }, "paused ", /* @__PURE__ */ he.createElement(gl, null, "(", r, ")")), " ", /* @__PURE__ */ he.createElement(xm, {
    style: {
      background: Qt.warning,
      color: "black",
      textShadow: "0",
      opacity: o ? 1 : 0.3
    }
  }, "stale ", /* @__PURE__ */ he.createElement(gl, null, "(", o, ")")), " ", /* @__PURE__ */ he.createElement(xm, {
    style: {
      background: Qt.gray,
      opacity: i ? 1 : 0.3
    }
  }, "inactive ", /* @__PURE__ */ he.createElement(gl, null, "(", i, ")")));
}, Rve = /* @__PURE__ */ he.memo(({
  queryKey: t,
  setActiveQueryHash: e,
  activeQueryHash: n,
  queryCache: r
}) => {
  var o, i, s, a;
  const l = (o = ko(r, () => {
    var h;
    return (h = r.find(t)) == null ? void 0 : h.queryHash;
  })) != null ? o : "", c = ko(r, () => {
    var h;
    return (h = r.find(t)) == null ? void 0 : h.state;
  }), u = (i = ko(r, () => {
    var h;
    return (h = r.find(t)) == null ? void 0 : h.isStale();
  })) != null ? i : !1, d = (s = ko(r, () => {
    var h;
    return (h = r.find(t)) == null ? void 0 : h.isDisabled();
  })) != null ? s : !1, f = (a = ko(r, () => {
    var h;
    return (h = r.find(t)) == null ? void 0 : h.getObserversCount();
  })) != null ? a : 0;
  return c ? /* @__PURE__ */ he.createElement("div", {
    role: "button",
    "aria-label": "Open query details for " + l,
    onClick: () => e(n === l ? "" : l),
    style: {
      display: "flex",
      borderBottom: "solid 1px " + Qt.grayAlt,
      cursor: "pointer",
      background: l === n ? "rgba(255,255,255,.1)" : void 0
    }
  }, /* @__PURE__ */ he.createElement("div", {
    style: {
      flex: "0 0 auto",
      width: "2em",
      height: "2em",
      background: Ove({
        queryState: c,
        isStale: u,
        observerCount: f,
        theme: Qt
      }),
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontWeight: "bold",
      textShadow: u ? "0" : "0 0 10px black",
      color: u ? "black" : "white"
    }
  }, f), d ? /* @__PURE__ */ he.createElement("div", {
    style: {
      flex: "0 0 auto",
      height: "2em",
      background: Qt.gray,
      display: "flex",
      alignItems: "center",
      fontWeight: "bold",
      padding: "0 0.5em"
    }
  }, "disabled") : null, /* @__PURE__ */ he.createElement(gl, {
    style: {
      padding: ".5em"
    }
  }, "" + l)) : null;
});
Rve.displayName = "QueryRow";
function vht() {
}
process.env.NODE_ENV;
process.env.NODE_ENV;
function Y4() {
  return {
    async: !1,
    breaks: !1,
    extensions: null,
    gfm: !0,
    hooks: null,
    pedantic: !1,
    renderer: null,
    silent: !1,
    tokenizer: null,
    walkTokens: null
  };
}
let Zd = Y4();
function Pve(t) {
  Zd = t;
}
const $ve = /[&<>"']/, bht = new RegExp($ve.source, "g"), Mve = /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/, _ht = new RegExp(Mve.source, "g"), wht = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;"
}, yQ = (t) => wht[t];
function fi(t, e) {
  if (e) {
    if ($ve.test(t))
      return t.replace(bht, yQ);
  } else if (Mve.test(t))
    return t.replace(_ht, yQ);
  return t;
}
const xht = /&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/ig;
function Eht(t) {
  return t.replace(xht, (e, n) => (n = n.toLowerCase(), n === "colon" ? ":" : n.charAt(0) === "#" ? n.charAt(1) === "x" ? String.fromCharCode(parseInt(n.substring(2), 16)) : String.fromCharCode(+n.substring(1)) : ""));
}
const Sht = /(^|[^\[])\^/g;
function $n(t, e) {
  let n = typeof t == "string" ? t : t.source;
  e = e || "";
  const r = {
    replace: (o, i) => {
      let s = typeof i == "string" ? i : i.source;
      return s = s.replace(Sht, "$1"), n = n.replace(o, s), r;
    },
    getRegex: () => new RegExp(n, e)
  };
  return r;
}
function vQ(t) {
  try {
    t = encodeURI(t).replace(/%25/g, "%");
  } catch {
    return null;
  }
  return t;
}
const m0 = { exec: () => null };
function bQ(t, e) {
  const n = t.replace(/\|/g, (i, s, a) => {
    let l = !1, c = s;
    for (; --c >= 0 && a[c] === "\\"; )
      l = !l;
    return l ? "|" : " |";
  }), r = n.split(/ \|/);
  let o = 0;
  if (r[0].trim() || r.shift(), r.length > 0 && !r[r.length - 1].trim() && r.pop(), e)
    if (r.length > e)
      r.splice(e);
    else
      for (; r.length < e; )
        r.push("");
  for (; o < r.length; o++)
    r[o] = r[o].trim().replace(/\\\|/g, "|");
  return r;
}
function Em(t, e, n) {
  const r = t.length;
  if (r === 0)
    return "";
  let o = 0;
  for (; o < r && t.charAt(r - o - 1) === e; )
    o++;
  return t.slice(0, r - o);
}
function Oht(t, e) {
  if (t.indexOf(e[1]) === -1)
    return -1;
  let n = 0;
  for (let r = 0; r < t.length; r++)
    if (t[r] === "\\")
      r++;
    else if (t[r] === e[0])
      n++;
    else if (t[r] === e[1] && (n--, n < 0))
      return r;
  return -1;
}
function _Q(t, e, n, r) {
  const o = e.href, i = e.title ? fi(e.title) : null, s = t[1].replace(/\\([\[\]])/g, "$1");
  if (t[0].charAt(0) !== "!") {
    r.state.inLink = !0;
    const a = {
      type: "link",
      raw: n,
      href: o,
      title: i,
      text: s,
      tokens: r.inlineTokens(s)
    };
    return r.state.inLink = !1, a;
  }
  return {
    type: "image",
    raw: n,
    href: o,
    title: i,
    text: fi(s)
  };
}
function Cht(t, e) {
  const n = t.match(/^(\s+)(?:```)/);
  if (n === null)
    return e;
  const r = n[1];
  return e.split(`
`).map((o) => {
    const i = o.match(/^\s+/);
    if (i === null)
      return o;
    const [s] = i;
    return s.length >= r.length ? o.slice(r.length) : o;
  }).join(`
`);
}
class CE {
  // set by the lexer
  constructor(e) {
    ue(this, "options"), ue(this, "rules"), ue(this, "lexer"), this.options = e || Zd;
  }
  space(e) {
    const n = this.rules.block.newline.exec(e);
    if (n && n[0].length > 0)
      return {
        type: "space",
        raw: n[0]
      };
  }
  code(e) {
    const n = this.rules.block.code.exec(e);
    if (n) {
      const r = n[0].replace(/^ {1,4}/gm, "");
      return {
        type: "code",
        raw: n[0],
        codeBlockStyle: "indented",
        text: this.options.pedantic ? r : Em(r, `
`)
      };
    }
  }
  fences(e) {
    const n = this.rules.block.fences.exec(e);
    if (n) {
      const r = n[0], o = Cht(r, n[3] || "");
      return {
        type: "code",
        raw: r,
        lang: n[2] ? n[2].trim().replace(this.rules.inline.anyPunctuation, "$1") : n[2],
        text: o
      };
    }
  }
  heading(e) {
    const n = this.rules.block.heading.exec(e);
    if (n) {
      let r = n[2].trim();
      if (/#$/.test(r)) {
        const o = Em(r, "#");
        (this.options.pedantic || !o || / $/.test(o)) && (r = o.trim());
      }
      return {
        type: "heading",
        raw: n[0],
        depth: n[1].length,
        text: r,
        tokens: this.lexer.inline(r)
      };
    }
  }
  hr(e) {
    const n = this.rules.block.hr.exec(e);
    if (n)
      return {
        type: "hr",
        raw: Em(n[0], `
`)
      };
  }
  blockquote(e) {
    const n = this.rules.block.blockquote.exec(e);
    if (n) {
      let r = Em(n[0], `
`).split(`
`), o = "", i = "";
      const s = [];
      for (; r.length > 0; ) {
        let a = !1;
        const l = [];
        let c;
        for (c = 0; c < r.length; c++)
          if (/^ {0,3}>/.test(r[c]))
            l.push(r[c]), a = !0;
          else if (!a)
            l.push(r[c]);
          else
            break;
        r = r.slice(c);
        const u = l.join(`
`), d = u.replace(/\n {0,3}((?:=+|-+) *)(?=\n|$)/g, `
    $1`).replace(/^ {0,3}>[ \t]?/gm, "");
        o = o ? `${o}
${u}` : u, i = i ? `${i}
${d}` : d;
        const f = this.lexer.state.top;
        if (this.lexer.state.top = !0, this.lexer.blockTokens(d, s, !0), this.lexer.state.top = f, r.length === 0)
          break;
        const h = s[s.length - 1];
        if (h?.type === "code")
          break;
        if (h?.type === "blockquote") {
          const p = h, m = p.raw + `
` + r.join(`
`), g = this.blockquote(m);
          s[s.length - 1] = g, o = o.substring(0, o.length - p.raw.length) + g.raw, i = i.substring(0, i.length - p.text.length) + g.text;
          break;
        } else if (h?.type === "list") {
          const p = h, m = p.raw + `
` + r.join(`
`), g = this.list(m);
          s[s.length - 1] = g, o = o.substring(0, o.length - h.raw.length) + g.raw, i = i.substring(0, i.length - p.raw.length) + g.raw, r = m.substring(s[s.length - 1].raw.length).split(`
`);
          continue;
        }
      }
      return {
        type: "blockquote",
        raw: o,
        tokens: s,
        text: i
      };
    }
  }
  list(e) {
    let n = this.rules.block.list.exec(e);
    if (n) {
      let r = n[1].trim();
      const o = r.length > 1, i = {
        type: "list",
        raw: "",
        ordered: o,
        start: o ? +r.slice(0, -1) : "",
        loose: !1,
        items: []
      };
      r = o ? `\\d{1,9}\\${r.slice(-1)}` : `\\${r}`, this.options.pedantic && (r = o ? r : "[*+-]");
      const s = new RegExp(`^( {0,3}${r})((?:[	 ][^\\n]*)?(?:\\n|$))`);
      let a = !1;
      for (; e; ) {
        let l = !1, c = "", u = "";
        if (!(n = s.exec(e)) || this.rules.block.hr.test(e))
          break;
        c = n[0], e = e.substring(c.length);
        let d = n[2].split(`
`, 1)[0].replace(/^\t+/, (y) => " ".repeat(3 * y.length)), f = e.split(`
`, 1)[0], h = !d.trim(), p = 0;
        if (this.options.pedantic ? (p = 2, u = d.trimStart()) : h ? p = n[1].length + 1 : (p = n[2].search(/[^ ]/), p = p > 4 ? 1 : p, u = d.slice(p), p += n[1].length), h && /^ *$/.test(f) && (c += f + `
`, e = e.substring(f.length + 1), l = !0), !l) {
          const y = new RegExp(`^ {0,${Math.min(3, p - 1)}}(?:[*+-]|\\d{1,9}[.)])((?:[ 	][^\\n]*)?(?:\\n|$))`), v = new RegExp(`^ {0,${Math.min(3, p - 1)}}((?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$)`), b = new RegExp(`^ {0,${Math.min(3, p - 1)}}(?:\`\`\`|~~~)`), _ = new RegExp(`^ {0,${Math.min(3, p - 1)}}#`);
          for (; e; ) {
            const w = e.split(`
`, 1)[0];
            if (f = w, this.options.pedantic && (f = f.replace(/^ {1,4}(?=( {4})*[^ ])/g, "  ")), b.test(f) || _.test(f) || y.test(f) || v.test(e))
              break;
            if (f.search(/[^ ]/) >= p || !f.trim())
              u += `
` + f.slice(p);
            else {
              if (h || d.search(/[^ ]/) >= 4 || b.test(d) || _.test(d) || v.test(d))
                break;
              u += `
` + f;
            }
            !h && !f.trim() && (h = !0), c += w + `
`, e = e.substring(w.length + 1), d = f.slice(p);
          }
        }
        i.loose || (a ? i.loose = !0 : /\n *\n *$/.test(c) && (a = !0));
        let m = null, g;
        this.options.gfm && (m = /^\[[ xX]\] /.exec(u), m && (g = m[0] !== "[ ] ", u = u.replace(/^\[[ xX]\] +/, ""))), i.items.push({
          type: "list_item",
          raw: c,
          task: !!m,
          checked: g,
          loose: !1,
          text: u,
          tokens: []
        }), i.raw += c;
      }
      i.items[i.items.length - 1].raw = i.items[i.items.length - 1].raw.trimEnd(), i.items[i.items.length - 1].text = i.items[i.items.length - 1].text.trimEnd(), i.raw = i.raw.trimEnd();
      for (let l = 0; l < i.items.length; l++)
        if (this.lexer.state.top = !1, i.items[l].tokens = this.lexer.blockTokens(i.items[l].text, []), !i.loose) {
          const c = i.items[l].tokens.filter((d) => d.type === "space"), u = c.length > 0 && c.some((d) => /\n.*\n/.test(d.raw));
          i.loose = u;
        }
      if (i.loose)
        for (let l = 0; l < i.items.length; l++)
          i.items[l].loose = !0;
      return i;
    }
  }
  html(e) {
    const n = this.rules.block.html.exec(e);
    if (n)
      return {
        type: "html",
        block: !0,
        raw: n[0],
        pre: n[1] === "pre" || n[1] === "script" || n[1] === "style",
        text: n[0]
      };
  }
  def(e) {
    const n = this.rules.block.def.exec(e);
    if (n) {
      const r = n[1].toLowerCase().replace(/\s+/g, " "), o = n[2] ? n[2].replace(/^<(.*)>$/, "$1").replace(this.rules.inline.anyPunctuation, "$1") : "", i = n[3] ? n[3].substring(1, n[3].length - 1).replace(this.rules.inline.anyPunctuation, "$1") : n[3];
      return {
        type: "def",
        tag: r,
        raw: n[0],
        href: o,
        title: i
      };
    }
  }
  table(e) {
    const n = this.rules.block.table.exec(e);
    if (!n || !/[:|]/.test(n[2]))
      return;
    const r = bQ(n[1]), o = n[2].replace(/^\||\| *$/g, "").split("|"), i = n[3] && n[3].trim() ? n[3].replace(/\n[ \t]*$/, "").split(`
`) : [], s = {
      type: "table",
      raw: n[0],
      header: [],
      align: [],
      rows: []
    };
    if (r.length === o.length) {
      for (const a of o)
        /^ *-+: *$/.test(a) ? s.align.push("right") : /^ *:-+: *$/.test(a) ? s.align.push("center") : /^ *:-+ *$/.test(a) ? s.align.push("left") : s.align.push(null);
      for (let a = 0; a < r.length; a++)
        s.header.push({
          text: r[a],
          tokens: this.lexer.inline(r[a]),
          header: !0,
          align: s.align[a]
        });
      for (const a of i)
        s.rows.push(bQ(a, s.header.length).map((l, c) => ({
          text: l,
          tokens: this.lexer.inline(l),
          header: !1,
          align: s.align[c]
        })));
      return s;
    }
  }
  lheading(e) {
    const n = this.rules.block.lheading.exec(e);
    if (n)
      return {
        type: "heading",
        raw: n[0],
        depth: n[2].charAt(0) === "=" ? 1 : 2,
        text: n[1],
        tokens: this.lexer.inline(n[1])
      };
  }
  paragraph(e) {
    const n = this.rules.block.paragraph.exec(e);
    if (n) {
      const r = n[1].charAt(n[1].length - 1) === `
` ? n[1].slice(0, -1) : n[1];
      return {
        type: "paragraph",
        raw: n[0],
        text: r,
        tokens: this.lexer.inline(r)
      };
    }
  }
  text(e) {
    const n = this.rules.block.text.exec(e);
    if (n)
      return {
        type: "text",
        raw: n[0],
        text: n[0],
        tokens: this.lexer.inline(n[0])
      };
  }
  escape(e) {
    const n = this.rules.inline.escape.exec(e);
    if (n)
      return {
        type: "escape",
        raw: n[0],
        text: fi(n[1])
      };
  }
  tag(e) {
    const n = this.rules.inline.tag.exec(e);
    if (n)
      return !this.lexer.state.inLink && /^<a /i.test(n[0]) ? this.lexer.state.inLink = !0 : this.lexer.state.inLink && /^<\/a>/i.test(n[0]) && (this.lexer.state.inLink = !1), !this.lexer.state.inRawBlock && /^<(pre|code|kbd|script)(\s|>)/i.test(n[0]) ? this.lexer.state.inRawBlock = !0 : this.lexer.state.inRawBlock && /^<\/(pre|code|kbd|script)(\s|>)/i.test(n[0]) && (this.lexer.state.inRawBlock = !1), {
        type: "html",
        raw: n[0],
        inLink: this.lexer.state.inLink,
        inRawBlock: this.lexer.state.inRawBlock,
        block: !1,
        text: n[0]
      };
  }
  link(e) {
    const n = this.rules.inline.link.exec(e);
    if (n) {
      const r = n[2].trim();
      if (!this.options.pedantic && /^</.test(r)) {
        if (!/>$/.test(r))
          return;
        const s = Em(r.slice(0, -1), "\\");
        if ((r.length - s.length) % 2 === 0)
          return;
      } else {
        const s = Oht(n[2], "()");
        if (s > -1) {
          const a = (n[0].indexOf("!") === 0 ? 5 : 4) + n[1].length + s;
          n[2] = n[2].substring(0, s), n[0] = n[0].substring(0, a).trim(), n[3] = "";
        }
      }
      let o = n[2], i = "";
      if (this.options.pedantic) {
        const s = /^([^'"]*[^\s])\s+(['"])(.*)\2/.exec(o);
        s && (o = s[1], i = s[3]);
      } else
        i = n[3] ? n[3].slice(1, -1) : "";
      return o = o.trim(), /^</.test(o) && (this.options.pedantic && !/>$/.test(r) ? o = o.slice(1) : o = o.slice(1, -1)), _Q(n, {
        href: o && o.replace(this.rules.inline.anyPunctuation, "$1"),
        title: i && i.replace(this.rules.inline.anyPunctuation, "$1")
      }, n[0], this.lexer);
    }
  }
  reflink(e, n) {
    let r;
    if ((r = this.rules.inline.reflink.exec(e)) || (r = this.rules.inline.nolink.exec(e))) {
      const o = (r[2] || r[1]).replace(/\s+/g, " "), i = n[o.toLowerCase()];
      if (!i) {
        const s = r[0].charAt(0);
        return {
          type: "text",
          raw: s,
          text: s
        };
      }
      return _Q(r, i, r[0], this.lexer);
    }
  }
  emStrong(e, n, r = "") {
    let o = this.rules.inline.emStrongLDelim.exec(e);
    if (!(!o || o[3] && r.match(/[\p{L}\p{N}]/u)) && (!(o[1] || o[2]) || !r || this.rules.inline.punctuation.exec(r))) {
      const i = [...o[0]].length - 1;
      let s, a, l = i, c = 0;
      const u = o[0][0] === "*" ? this.rules.inline.emStrongRDelimAst : this.rules.inline.emStrongRDelimUnd;
      for (u.lastIndex = 0, n = n.slice(-1 * e.length + i); (o = u.exec(n)) != null; ) {
        if (s = o[1] || o[2] || o[3] || o[4] || o[5] || o[6], !s)
          continue;
        if (a = [...s].length, o[3] || o[4]) {
          l += a;
          continue;
        } else if ((o[5] || o[6]) && i % 3 && !((i + a) % 3)) {
          c += a;
          continue;
        }
        if (l -= a, l > 0)
          continue;
        a = Math.min(a, a + l + c);
        const d = [...o[0]][0].length, f = e.slice(0, i + o.index + d + a);
        if (Math.min(i, a) % 2) {
          const p = f.slice(1, -1);
          return {
            type: "em",
            raw: f,
            text: p,
            tokens: this.lexer.inlineTokens(p)
          };
        }
        const h = f.slice(2, -2);
        return {
          type: "strong",
          raw: f,
          text: h,
          tokens: this.lexer.inlineTokens(h)
        };
      }
    }
  }
  codespan(e) {
    const n = this.rules.inline.code.exec(e);
    if (n) {
      let r = n[2].replace(/\n/g, " ");
      const o = /[^ ]/.test(r), i = /^ /.test(r) && / $/.test(r);
      return o && i && (r = r.substring(1, r.length - 1)), r = fi(r, !0), {
        type: "codespan",
        raw: n[0],
        text: r
      };
    }
  }
  br(e) {
    const n = this.rules.inline.br.exec(e);
    if (n)
      return {
        type: "br",
        raw: n[0]
      };
  }
  del(e) {
    const n = this.rules.inline.del.exec(e);
    if (n)
      return {
        type: "del",
        raw: n[0],
        text: n[2],
        tokens: this.lexer.inlineTokens(n[2])
      };
  }
  autolink(e) {
    const n = this.rules.inline.autolink.exec(e);
    if (n) {
      let r, o;
      return n[2] === "@" ? (r = fi(n[1]), o = "mailto:" + r) : (r = fi(n[1]), o = r), {
        type: "link",
        raw: n[0],
        text: r,
        href: o,
        tokens: [
          {
            type: "text",
            raw: r,
            text: r
          }
        ]
      };
    }
  }
  url(e) {
    let n;
    if (n = this.rules.inline.url.exec(e)) {
      let r, o;
      if (n[2] === "@")
        r = fi(n[0]), o = "mailto:" + r;
      else {
        let i;
        do
          i = n[0], n[0] = this.rules.inline._backpedal.exec(n[0])?.[0] ?? "";
        while (i !== n[0]);
        r = fi(n[0]), n[1] === "www." ? o = "http://" + n[0] : o = n[0];
      }
      return {
        type: "link",
        raw: n[0],
        text: r,
        href: o,
        tokens: [
          {
            type: "text",
            raw: r,
            text: r
          }
        ]
      };
    }
  }
  inlineText(e) {
    const n = this.rules.inline.text.exec(e);
    if (n) {
      let r;
      return this.lexer.state.inRawBlock ? r = n[0] : r = fi(n[0]), {
        type: "text",
        raw: n[0],
        text: r
      };
    }
  }
}
const kht = /^(?: *(?:\n|$))+/, Aht = /^( {4}[^\n]+(?:\n(?: *(?:\n|$))*)?)+/, Tht = /^ {0,3}(`{3,}(?=[^`\n]*(?:\n|$))|~{3,})([^\n]*)(?:\n|$)(?:|([\s\S]*?)(?:\n|$))(?: {0,3}\1[~`]* *(?=\n|$)|$)/, Iv = /^ {0,3}((?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/, Rht = /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/, Dve = /(?:[*+-]|\d{1,9}[.)])/, Ive = $n(/^(?!bull |blockCode|fences|blockquote|heading|html)((?:.|\n(?!\s*?\n|bull |blockCode|fences|blockquote|heading|html))+?)\n {0,3}(=+|-+) *(?:\n+|$)/).replace(/bull/g, Dve).replace(/blockCode/g, / {4}/).replace(/fences/g, / {0,3}(?:`{3,}|~{3,})/).replace(/blockquote/g, / {0,3}>/).replace(/heading/g, / {0,3}#{1,6}/).replace(/html/g, / {0,3}<[^\n>]+>\n/).getRegex(), K4 = /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table| +\n)[^\n]+)*)/, Pht = /^[^\n]+/, X4 = /(?!\s*\])(?:\\.|[^\[\]\\])+/, $ht = $n(/^ {0,3}\[(label)\]: *(?:\n *)?([^<\s][^\s]*|<.*?>)(?:(?: +(?:\n *)?| *\n *)(title))? *(?:\n+|$)/).replace("label", X4).replace("title", /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/).getRegex(), Mht = $n(/^( {0,3}bull)([ \t][^\n]+?)?(?:\n|$)/).replace(/bull/g, Dve).getRegex(), gO = "address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option|p|param|search|section|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul", Q4 = /<!--(?:-?>|[\s\S]*?(?:-->|$))/, Dht = $n("^ {0,3}(?:<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)|comment[^\\n]*(\\n+|$)|<\\?[\\s\\S]*?(?:\\?>\\n*|$)|<![A-Z][\\s\\S]*?(?:>\\n*|$)|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n *)+\\n|$)|<(?!script|pre|style|textarea)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$)|</(?!script|pre|style|textarea)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$))", "i").replace("comment", Q4).replace("tag", gO).replace("attribute", / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex(), Nve = $n(K4).replace("hr", Iv).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "").replace("|table", "").replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", gO).getRegex(), Iht = $n(/^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/).replace("paragraph", Nve).getRegex(), Z4 = {
  blockquote: Iht,
  code: Aht,
  def: $ht,
  fences: Tht,
  heading: Rht,
  hr: Iv,
  html: Dht,
  lheading: Ive,
  list: Mht,
  newline: kht,
  paragraph: Nve,
  table: m0,
  text: Pht
}, wQ = $n("^ *([^\\n ].*)\\n {0,3}((?:\\| *)?:?-+:? *(?:\\| *:?-+:? *)*(?:\\| *)?)(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)").replace("hr", Iv).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("blockquote", " {0,3}>").replace("code", " {4}[^\\n]").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", gO).getRegex(), Nht = {
  ...Z4,
  table: wQ,
  paragraph: $n(K4).replace("hr", Iv).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "").replace("table", wQ).replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n").replace("list", " {0,3}(?:[*+-]|1[.)]) ").replace("html", "</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)").replace("tag", gO).getRegex()
}, jht = {
  ...Z4,
  html: $n(`^ *(?:comment *(?:\\n|\\s*$)|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)|<tag(?:"[^"]*"|'[^']*'|\\s[^'"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))`).replace("comment", Q4).replace(/tag/g, "(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b").getRegex(),
  def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
  heading: /^(#{1,6})(.*)(?:\n+|$)/,
  fences: m0,
  // fences not supported
  lheading: /^(.+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
  paragraph: $n(K4).replace("hr", Iv).replace("heading", ` *#{1,6} *[^
]`).replace("lheading", Ive).replace("|table", "").replace("blockquote", " {0,3}>").replace("|fences", "").replace("|list", "").replace("|html", "").replace("|tag", "").getRegex()
}, jve = /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/, Lht = /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/, Lve = /^( {2,}|\\)\n(?!\s*$)/, Fht = /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/, Nv = "\\p{P}\\p{S}", Bht = $n(/^((?![*_])[\spunctuation])/, "u").replace(/punctuation/g, Nv).getRegex(), zht = /\[[^[\]]*?\]\([^\(\)]*?\)|`[^`]*?`|<[^<>]*?>/g, qht = $n(/^(?:\*+(?:((?!\*)[punct])|[^\s*]))|^_+(?:((?!_)[punct])|([^\s_]))/, "u").replace(/punct/g, Nv).getRegex(), Uht = $n("^[^_*]*?__[^_*]*?\\*[^_*]*?(?=__)|[^*]+(?=[^*])|(?!\\*)[punct](\\*+)(?=[\\s]|$)|[^punct\\s](\\*+)(?!\\*)(?=[punct\\s]|$)|(?!\\*)[punct\\s](\\*+)(?=[^punct\\s])|[\\s](\\*+)(?!\\*)(?=[punct])|(?!\\*)[punct](\\*+)(?!\\*)(?=[punct])|[^punct\\s](\\*+)(?=[^punct\\s])", "gu").replace(/punct/g, Nv).getRegex(), Hht = $n("^[^_*]*?\\*\\*[^_*]*?_[^_*]*?(?=\\*\\*)|[^_]+(?=[^_])|(?!_)[punct](_+)(?=[\\s]|$)|[^punct\\s](_+)(?!_)(?=[punct\\s]|$)|(?!_)[punct\\s](_+)(?=[^punct\\s])|[\\s](_+)(?!_)(?=[punct])|(?!_)[punct](_+)(?!_)(?=[punct])", "gu").replace(/punct/g, Nv).getRegex(), Vht = $n(/\\([punct])/, "gu").replace(/punct/g, Nv).getRegex(), Wht = $n(/^<(scheme:[^\s\x00-\x1f<>]*|email)>/).replace("scheme", /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/).replace("email", /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/).getRegex(), Ght = $n(Q4).replace("(?:-->|$)", "-->").getRegex(), Yht = $n("^comment|^</[a-zA-Z][\\w:-]*\\s*>|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>|^<\\?[\\s\\S]*?\\?>|^<![a-zA-Z]+\\s[\\s\\S]*?>|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>").replace("comment", Ght).replace("attribute", /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/).getRegex(), kE = /(?:\[(?:\\.|[^\[\]\\])*\]|\\.|`[^`]*`|[^\[\]\\`])*?/, Kht = $n(/^!?\[(label)\]\(\s*(href)(?:\s+(title))?\s*\)/).replace("label", kE).replace("href", /<(?:\\.|[^\n<>\\])+>|[^\s\x00-\x1f]*/).replace("title", /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/).getRegex(), Fve = $n(/^!?\[(label)\]\[(ref)\]/).replace("label", kE).replace("ref", X4).getRegex(), Bve = $n(/^!?\[(ref)\](?:\[\])?/).replace("ref", X4).getRegex(), Xht = $n("reflink|nolink(?!\\()", "g").replace("reflink", Fve).replace("nolink", Bve).getRegex(), J4 = {
  _backpedal: m0,
  // only used for GFM url
  anyPunctuation: Vht,
  autolink: Wht,
  blockSkip: zht,
  br: Lve,
  code: Lht,
  del: m0,
  emStrongLDelim: qht,
  emStrongRDelimAst: Uht,
  emStrongRDelimUnd: Hht,
  escape: jve,
  link: Kht,
  nolink: Bve,
  punctuation: Bht,
  reflink: Fve,
  reflinkSearch: Xht,
  tag: Yht,
  text: Fht,
  url: m0
}, Qht = {
  ...J4,
  link: $n(/^!?\[(label)\]\((.*?)\)/).replace("label", kE).getRegex(),
  reflink: $n(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace("label", kE).getRegex()
}, Kj = {
  ...J4,
  escape: $n(jve).replace("])", "~|])").getRegex(),
  url: $n(/^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/, "i").replace("email", /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/).getRegex(),
  _backpedal: /(?:[^?!.,:;*_'"~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_'"~)]+(?!$))+/,
  del: /^(~~?)(?=[^\s~])([\s\S]*?[^\s~])\1(?=[^~]|$)/,
  text: /^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|https?:\/\/|ftp:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/
}, Zht = {
  ...Kj,
  br: $n(Lve).replace("{2,}", "*").getRegex(),
  text: $n(Kj.text).replace("\\b_", "\\b_| {2,}\\n").replace(/\{2,\}/g, "*").getRegex()
}, $1 = {
  normal: Z4,
  gfm: Nht,
  pedantic: jht
}, Sm = {
  normal: J4,
  gfm: Kj,
  breaks: Zht,
  pedantic: Qht
};
let ud = class Xj {
  constructor(e) {
    ue(this, "tokens"), ue(this, "options"), ue(this, "state"), ue(this, "tokenizer"), ue(this, "inlineQueue"), this.tokens = [], this.tokens.links = /* @__PURE__ */ Object.create(null), this.options = e || Zd, this.options.tokenizer = this.options.tokenizer || new CE(), this.tokenizer = this.options.tokenizer, this.tokenizer.options = this.options, this.tokenizer.lexer = this, this.inlineQueue = [], this.state = {
      inLink: !1,
      inRawBlock: !1,
      top: !0
    };
    const n = {
      block: $1.normal,
      inline: Sm.normal
    };
    this.options.pedantic ? (n.block = $1.pedantic, n.inline = Sm.pedantic) : this.options.gfm && (n.block = $1.gfm, this.options.breaks ? n.inline = Sm.breaks : n.inline = Sm.gfm), this.tokenizer.rules = n;
  }
  /**
   * Expose Rules
   */
  static get rules() {
    return {
      block: $1,
      inline: Sm
    };
  }
  /**
   * Static Lex Method
   */
  static lex(e, n) {
    return new Xj(n).lex(e);
  }
  /**
   * Static Lex Inline Method
   */
  static lexInline(e, n) {
    return new Xj(n).inlineTokens(e);
  }
  /**
   * Preprocessing
   */
  lex(e) {
    e = e.replace(/\r\n|\r/g, `
`), this.blockTokens(e, this.tokens);
    for (let n = 0; n < this.inlineQueue.length; n++) {
      const r = this.inlineQueue[n];
      this.inlineTokens(r.src, r.tokens);
    }
    return this.inlineQueue = [], this.tokens;
  }
  blockTokens(e, n = [], r = !1) {
    this.options.pedantic ? e = e.replace(/\t/g, "    ").replace(/^ +$/gm, "") : e = e.replace(/^( *)(\t+)/gm, (a, l, c) => l + "    ".repeat(c.length));
    let o, i, s;
    for (; e; )
      if (!(this.options.extensions && this.options.extensions.block && this.options.extensions.block.some((a) => (o = a.call({ lexer: this }, e, n)) ? (e = e.substring(o.raw.length), n.push(o), !0) : !1))) {
        if (o = this.tokenizer.space(e)) {
          e = e.substring(o.raw.length), o.raw.length === 1 && n.length > 0 ? n[n.length - 1].raw += `
` : n.push(o);
          continue;
        }
        if (o = this.tokenizer.code(e)) {
          e = e.substring(o.raw.length), i = n[n.length - 1], i && (i.type === "paragraph" || i.type === "text") ? (i.raw += `
` + o.raw, i.text += `
` + o.text, this.inlineQueue[this.inlineQueue.length - 1].src = i.text) : n.push(o);
          continue;
        }
        if (o = this.tokenizer.fences(e)) {
          e = e.substring(o.raw.length), n.push(o);
          continue;
        }
        if (o = this.tokenizer.heading(e)) {
          e = e.substring(o.raw.length), n.push(o);
          continue;
        }
        if (o = this.tokenizer.hr(e)) {
          e = e.substring(o.raw.length), n.push(o);
          continue;
        }
        if (o = this.tokenizer.blockquote(e)) {
          e = e.substring(o.raw.length), n.push(o);
          continue;
        }
        if (o = this.tokenizer.list(e)) {
          e = e.substring(o.raw.length), n.push(o);
          continue;
        }
        if (o = this.tokenizer.html(e)) {
          e = e.substring(o.raw.length), n.push(o);
          continue;
        }
        if (o = this.tokenizer.def(e)) {
          e = e.substring(o.raw.length), i = n[n.length - 1], i && (i.type === "paragraph" || i.type === "text") ? (i.raw += `
` + o.raw, i.text += `
` + o.raw, this.inlineQueue[this.inlineQueue.length - 1].src = i.text) : this.tokens.links[o.tag] || (this.tokens.links[o.tag] = {
            href: o.href,
            title: o.title
          });
          continue;
        }
        if (o = this.tokenizer.table(e)) {
          e = e.substring(o.raw.length), n.push(o);
          continue;
        }
        if (o = this.tokenizer.lheading(e)) {
          e = e.substring(o.raw.length), n.push(o);
          continue;
        }
        if (s = e, this.options.extensions && this.options.extensions.startBlock) {
          let a = 1 / 0;
          const l = e.slice(1);
          let c;
          this.options.extensions.startBlock.forEach((u) => {
            c = u.call({ lexer: this }, l), typeof c == "number" && c >= 0 && (a = Math.min(a, c));
          }), a < 1 / 0 && a >= 0 && (s = e.substring(0, a + 1));
        }
        if (this.state.top && (o = this.tokenizer.paragraph(s))) {
          i = n[n.length - 1], r && i?.type === "paragraph" ? (i.raw += `
` + o.raw, i.text += `
` + o.text, this.inlineQueue.pop(), this.inlineQueue[this.inlineQueue.length - 1].src = i.text) : n.push(o), r = s.length !== e.length, e = e.substring(o.raw.length);
          continue;
        }
        if (o = this.tokenizer.text(e)) {
          e = e.substring(o.raw.length), i = n[n.length - 1], i && i.type === "text" ? (i.raw += `
` + o.raw, i.text += `
` + o.text, this.inlineQueue.pop(), this.inlineQueue[this.inlineQueue.length - 1].src = i.text) : n.push(o);
          continue;
        }
        if (e) {
          const a = "Infinite loop on byte: " + e.charCodeAt(0);
          if (this.options.silent) {
            console.error(a);
            break;
          } else
            throw new Error(a);
        }
      }
    return this.state.top = !0, n;
  }
  inline(e, n = []) {
    return this.inlineQueue.push({ src: e, tokens: n }), n;
  }
  /**
   * Lexing/Compiling
   */
  inlineTokens(e, n = []) {
    let r, o, i, s = e, a, l, c;
    if (this.tokens.links) {
      const u = Object.keys(this.tokens.links);
      if (u.length > 0)
        for (; (a = this.tokenizer.rules.inline.reflinkSearch.exec(s)) != null; )
          u.includes(a[0].slice(a[0].lastIndexOf("[") + 1, -1)) && (s = s.slice(0, a.index) + "[" + "a".repeat(a[0].length - 2) + "]" + s.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex));
    }
    for (; (a = this.tokenizer.rules.inline.blockSkip.exec(s)) != null; )
      s = s.slice(0, a.index) + "[" + "a".repeat(a[0].length - 2) + "]" + s.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
    for (; (a = this.tokenizer.rules.inline.anyPunctuation.exec(s)) != null; )
      s = s.slice(0, a.index) + "++" + s.slice(this.tokenizer.rules.inline.anyPunctuation.lastIndex);
    for (; e; )
      if (l || (c = ""), l = !1, !(this.options.extensions && this.options.extensions.inline && this.options.extensions.inline.some((u) => (r = u.call({ lexer: this }, e, n)) ? (e = e.substring(r.raw.length), n.push(r), !0) : !1))) {
        if (r = this.tokenizer.escape(e)) {
          e = e.substring(r.raw.length), n.push(r);
          continue;
        }
        if (r = this.tokenizer.tag(e)) {
          e = e.substring(r.raw.length), o = n[n.length - 1], o && r.type === "text" && o.type === "text" ? (o.raw += r.raw, o.text += r.text) : n.push(r);
          continue;
        }
        if (r = this.tokenizer.link(e)) {
          e = e.substring(r.raw.length), n.push(r);
          continue;
        }
        if (r = this.tokenizer.reflink(e, this.tokens.links)) {
          e = e.substring(r.raw.length), o = n[n.length - 1], o && r.type === "text" && o.type === "text" ? (o.raw += r.raw, o.text += r.text) : n.push(r);
          continue;
        }
        if (r = this.tokenizer.emStrong(e, s, c)) {
          e = e.substring(r.raw.length), n.push(r);
          continue;
        }
        if (r = this.tokenizer.codespan(e)) {
          e = e.substring(r.raw.length), n.push(r);
          continue;
        }
        if (r = this.tokenizer.br(e)) {
          e = e.substring(r.raw.length), n.push(r);
          continue;
        }
        if (r = this.tokenizer.del(e)) {
          e = e.substring(r.raw.length), n.push(r);
          continue;
        }
        if (r = this.tokenizer.autolink(e)) {
          e = e.substring(r.raw.length), n.push(r);
          continue;
        }
        if (!this.state.inLink && (r = this.tokenizer.url(e))) {
          e = e.substring(r.raw.length), n.push(r);
          continue;
        }
        if (i = e, this.options.extensions && this.options.extensions.startInline) {
          let u = 1 / 0;
          const d = e.slice(1);
          let f;
          this.options.extensions.startInline.forEach((h) => {
            f = h.call({ lexer: this }, d), typeof f == "number" && f >= 0 && (u = Math.min(u, f));
          }), u < 1 / 0 && u >= 0 && (i = e.substring(0, u + 1));
        }
        if (r = this.tokenizer.inlineText(i)) {
          e = e.substring(r.raw.length), r.raw.slice(-1) !== "_" && (c = r.raw.slice(-1)), l = !0, o = n[n.length - 1], o && o.type === "text" ? (o.raw += r.raw, o.text += r.text) : n.push(r);
          continue;
        }
        if (e) {
          const u = "Infinite loop on byte: " + e.charCodeAt(0);
          if (this.options.silent) {
            console.error(u);
            break;
          } else
            throw new Error(u);
        }
      }
    return n;
  }
};
class AE {
  // set by the parser
  constructor(e) {
    ue(this, "options"), ue(this, "parser"), this.options = e || Zd;
  }
  space(e) {
    return "";
  }
  code({ text: e, lang: n, escaped: r }) {
    const o = (n || "").match(/^\S*/)?.[0], i = e.replace(/\n$/, "") + `
`;
    return o ? '<pre><code class="language-' + fi(o) + '">' + (r ? i : fi(i, !0)) + `</code></pre>
` : "<pre><code>" + (r ? i : fi(i, !0)) + `</code></pre>
`;
  }
  blockquote({ tokens: e }) {
    return `<blockquote>
${this.parser.parse(e)}</blockquote>
`;
  }
  html({ text: e }) {
    return e;
  }
  heading({ tokens: e, depth: n }) {
    return `<h${n}>${this.parser.parseInline(e)}</h${n}>
`;
  }
  hr(e) {
    return `<hr>
`;
  }
  list(e) {
    const n = e.ordered, r = e.start;
    let o = "";
    for (let a = 0; a < e.items.length; a++) {
      const l = e.items[a];
      o += this.listitem(l);
    }
    const i = n ? "ol" : "ul", s = n && r !== 1 ? ' start="' + r + '"' : "";
    return "<" + i + s + `>
` + o + "</" + i + `>
`;
  }
  listitem(e) {
    let n = "";
    if (e.task) {
      const r = this.checkbox({ checked: !!e.checked });
      e.loose ? e.tokens.length > 0 && e.tokens[0].type === "paragraph" ? (e.tokens[0].text = r + " " + e.tokens[0].text, e.tokens[0].tokens && e.tokens[0].tokens.length > 0 && e.tokens[0].tokens[0].type === "text" && (e.tokens[0].tokens[0].text = r + " " + e.tokens[0].tokens[0].text)) : e.tokens.unshift({
        type: "text",
        raw: r + " ",
        text: r + " "
      }) : n += r + " ";
    }
    return n += this.parser.parse(e.tokens, !!e.loose), `<li>${n}</li>
`;
  }
  checkbox({ checked: e }) {
    return "<input " + (e ? 'checked="" ' : "") + 'disabled="" type="checkbox">';
  }
  paragraph({ tokens: e }) {
    return `<p>${this.parser.parseInline(e)}</p>
`;
  }
  table(e) {
    let n = "", r = "";
    for (let i = 0; i < e.header.length; i++)
      r += this.tablecell(e.header[i]);
    n += this.tablerow({ text: r });
    let o = "";
    for (let i = 0; i < e.rows.length; i++) {
      const s = e.rows[i];
      r = "";
      for (let a = 0; a < s.length; a++)
        r += this.tablecell(s[a]);
      o += this.tablerow({ text: r });
    }
    return o && (o = `<tbody>${o}</tbody>`), `<table>
<thead>
` + n + `</thead>
` + o + `</table>
`;
  }
  tablerow({ text: e }) {
    return `<tr>
${e}</tr>
`;
  }
  tablecell(e) {
    const n = this.parser.parseInline(e.tokens), r = e.header ? "th" : "td";
    return (e.align ? `<${r} align="${e.align}">` : `<${r}>`) + n + `</${r}>
`;
  }
  /**
   * span level renderer
   */
  strong({ tokens: e }) {
    return `<strong>${this.parser.parseInline(e)}</strong>`;
  }
  em({ tokens: e }) {
    return `<em>${this.parser.parseInline(e)}</em>`;
  }
  codespan({ text: e }) {
    return `<code>${e}</code>`;
  }
  br(e) {
    return "<br>";
  }
  del({ tokens: e }) {
    return `<del>${this.parser.parseInline(e)}</del>`;
  }
  link({ href: e, title: n, tokens: r }) {
    const o = this.parser.parseInline(r), i = vQ(e);
    if (i === null)
      return o;
    e = i;
    let s = '<a href="' + e + '"';
    return n && (s += ' title="' + n + '"'), s += ">" + o + "</a>", s;
  }
  image({ href: e, title: n, text: r }) {
    const o = vQ(e);
    if (o === null)
      return r;
    e = o;
    let i = `<img src="${e}" alt="${r}"`;
    return n && (i += ` title="${n}"`), i += ">", i;
  }
  text(e) {
    return "tokens" in e && e.tokens ? this.parser.parseInline(e.tokens) : e.text;
  }
}
class e6 {
  // no need for block level renderers
  strong({ text: e }) {
    return e;
  }
  em({ text: e }) {
    return e;
  }
  codespan({ text: e }) {
    return e;
  }
  del({ text: e }) {
    return e;
  }
  html({ text: e }) {
    return e;
  }
  text({ text: e }) {
    return e;
  }
  link({ text: e }) {
    return "" + e;
  }
  image({ text: e }) {
    return "" + e;
  }
  br() {
    return "";
  }
}
let dd = class Qj {
  constructor(e) {
    ue(this, "options"), ue(this, "renderer"), ue(this, "textRenderer"), this.options = e || Zd, this.options.renderer = this.options.renderer || new AE(), this.renderer = this.options.renderer, this.renderer.options = this.options, this.renderer.parser = this, this.textRenderer = new e6();
  }
  /**
   * Static Parse Method
   */
  static parse(e, n) {
    return new Qj(n).parse(e);
  }
  /**
   * Static Parse Inline Method
   */
  static parseInline(e, n) {
    return new Qj(n).parseInline(e);
  }
  /**
   * Parse Loop
   */
  parse(e, n = !0) {
    let r = "";
    for (let o = 0; o < e.length; o++) {
      const i = e[o];
      if (this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[i.type]) {
        const a = i, l = this.options.extensions.renderers[a.type].call({ parser: this }, a);
        if (l !== !1 || !["space", "hr", "heading", "code", "table", "blockquote", "list", "html", "paragraph", "text"].includes(a.type)) {
          r += l || "";
          continue;
        }
      }
      const s = i;
      switch (s.type) {
        case "space": {
          r += this.renderer.space(s);
          continue;
        }
        case "hr": {
          r += this.renderer.hr(s);
          continue;
        }
        case "heading": {
          r += this.renderer.heading(s);
          continue;
        }
        case "code": {
          r += this.renderer.code(s);
          continue;
        }
        case "table": {
          r += this.renderer.table(s);
          continue;
        }
        case "blockquote": {
          r += this.renderer.blockquote(s);
          continue;
        }
        case "list": {
          r += this.renderer.list(s);
          continue;
        }
        case "html": {
          r += this.renderer.html(s);
          continue;
        }
        case "paragraph": {
          r += this.renderer.paragraph(s);
          continue;
        }
        case "text": {
          let a = s, l = this.renderer.text(a);
          for (; o + 1 < e.length && e[o + 1].type === "text"; )
            a = e[++o], l += `
` + this.renderer.text(a);
          n ? r += this.renderer.paragraph({
            type: "paragraph",
            raw: l,
            text: l,
            tokens: [{ type: "text", raw: l, text: l }]
          }) : r += l;
          continue;
        }
        default: {
          const a = 'Token with "' + s.type + '" type was not found.';
          if (this.options.silent)
            return console.error(a), "";
          throw new Error(a);
        }
      }
    }
    return r;
  }
  /**
   * Parse Inline Tokens
   */
  parseInline(e, n) {
    n = n || this.renderer;
    let r = "";
    for (let o = 0; o < e.length; o++) {
      const i = e[o];
      if (this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[i.type]) {
        const a = this.options.extensions.renderers[i.type].call({ parser: this }, i);
        if (a !== !1 || !["escape", "html", "link", "image", "strong", "em", "codespan", "br", "del", "text"].includes(i.type)) {
          r += a || "";
          continue;
        }
      }
      const s = i;
      switch (s.type) {
        case "escape": {
          r += n.text(s);
          break;
        }
        case "html": {
          r += n.html(s);
          break;
        }
        case "link": {
          r += n.link(s);
          break;
        }
        case "image": {
          r += n.image(s);
          break;
        }
        case "strong": {
          r += n.strong(s);
          break;
        }
        case "em": {
          r += n.em(s);
          break;
        }
        case "codespan": {
          r += n.codespan(s);
          break;
        }
        case "br": {
          r += n.br(s);
          break;
        }
        case "del": {
          r += n.del(s);
          break;
        }
        case "text": {
          r += n.text(s);
          break;
        }
        default: {
          const a = 'Token with "' + s.type + '" type was not found.';
          if (this.options.silent)
            return console.error(a), "";
          throw new Error(a);
        }
      }
    }
    return r;
  }
};
class g0 {
  constructor(e) {
    ue(this, "options"), this.options = e || Zd;
  }
  /**
   * Process markdown before marked
   */
  preprocess(e) {
    return e;
  }
  /**
   * Process HTML after marked is finished
   */
  postprocess(e) {
    return e;
  }
  /**
   * Process all tokens before walk tokens
   */
  processAllTokens(e) {
    return e;
  }
}
ue(g0, "passThroughHooks", /* @__PURE__ */ new Set([
  "preprocess",
  "postprocess",
  "processAllTokens"
]));
var ih, zve, Zj, xQ;
class Jht {
  constructor(...e) {
    eIe(this, ih), ue(this, "defaults", Y4()), ue(this, "options", this.setOptions), ue(this, "parse", G_(this, ih, Zj).call(this, ud.lex, dd.parse)), ue(this, "parseInline", G_(this, ih, Zj).call(this, ud.lexInline, dd.parseInline)), ue(this, "Parser", dd), ue(this, "Renderer", AE), ue(this, "TextRenderer", e6), ue(this, "Lexer", ud), ue(this, "Tokenizer", CE), ue(this, "Hooks", g0), this.use(...e);
  }
  /**
   * Run callback for every token
   */
  walkTokens(e, n) {
    let r = [];
    for (const o of e)
      switch (r = r.concat(n.call(this, o)), o.type) {
        case "table": {
          const i = o;
          for (const s of i.header)
            r = r.concat(this.walkTokens(s.tokens, n));
          for (const s of i.rows)
            for (const a of s)
              r = r.concat(this.walkTokens(a.tokens, n));
          break;
        }
        case "list": {
          const i = o;
          r = r.concat(this.walkTokens(i.items, n));
          break;
        }
        default: {
          const i = o;
          this.defaults.extensions?.childTokens?.[i.type] ? this.defaults.extensions.childTokens[i.type].forEach((s) => {
            const a = i[s].flat(1 / 0);
            r = r.concat(this.walkTokens(a, n));
          }) : i.tokens && (r = r.concat(this.walkTokens(i.tokens, n)));
        }
      }
    return r;
  }
  use(...e) {
    const n = this.defaults.extensions || { renderers: {}, childTokens: {} };
    return e.forEach((r) => {
      const o = { ...r };
      if (o.async = this.defaults.async || o.async || !1, r.extensions && (r.extensions.forEach((i) => {
        if (!i.name)
          throw new Error("extension name required");
        if ("renderer" in i) {
          const s = n.renderers[i.name];
          s ? n.renderers[i.name] = function(...a) {
            let l = i.renderer.apply(this, a);
            return l === !1 && (l = s.apply(this, a)), l;
          } : n.renderers[i.name] = i.renderer;
        }
        if ("tokenizer" in i) {
          if (!i.level || i.level !== "block" && i.level !== "inline")
            throw new Error("extension level must be 'block' or 'inline'");
          const s = n[i.level];
          s ? s.unshift(i.tokenizer) : n[i.level] = [i.tokenizer], i.start && (i.level === "block" ? n.startBlock ? n.startBlock.push(i.start) : n.startBlock = [i.start] : i.level === "inline" && (n.startInline ? n.startInline.push(i.start) : n.startInline = [i.start]));
        }
        "childTokens" in i && i.childTokens && (n.childTokens[i.name] = i.childTokens);
      }), o.extensions = n), r.renderer) {
        const i = this.defaults.renderer || new AE(this.defaults);
        for (const s in r.renderer) {
          if (!(s in i))
            throw new Error(`renderer '${s}' does not exist`);
          if (["options", "parser"].includes(s))
            continue;
          const a = s;
          let l = r.renderer[a];
          r.useNewRenderer || (l = G_(this, ih, zve).call(this, l, a, i));
          const c = i[a];
          i[a] = (...u) => {
            let d = l.apply(i, u);
            return d === !1 && (d = c.apply(i, u)), d || "";
          };
        }
        o.renderer = i;
      }
      if (r.tokenizer) {
        const i = this.defaults.tokenizer || new CE(this.defaults);
        for (const s in r.tokenizer) {
          if (!(s in i))
            throw new Error(`tokenizer '${s}' does not exist`);
          if (["options", "rules", "lexer"].includes(s))
            continue;
          const a = s, l = r.tokenizer[a], c = i[a];
          i[a] = (...u) => {
            let d = l.apply(i, u);
            return d === !1 && (d = c.apply(i, u)), d;
          };
        }
        o.tokenizer = i;
      }
      if (r.hooks) {
        const i = this.defaults.hooks || new g0();
        for (const s in r.hooks) {
          if (!(s in i))
            throw new Error(`hook '${s}' does not exist`);
          if (s === "options")
            continue;
          const a = s, l = r.hooks[a], c = i[a];
          g0.passThroughHooks.has(s) ? i[a] = (u) => {
            if (this.defaults.async)
              return Promise.resolve(l.call(i, u)).then((f) => c.call(i, f));
            const d = l.call(i, u);
            return c.call(i, d);
          } : i[a] = (...u) => {
            let d = l.apply(i, u);
            return d === !1 && (d = c.apply(i, u)), d;
          };
        }
        o.hooks = i;
      }
      if (r.walkTokens) {
        const i = this.defaults.walkTokens, s = r.walkTokens;
        o.walkTokens = function(a) {
          let l = [];
          return l.push(s.call(this, a)), i && (l = l.concat(i.call(this, a))), l;
        };
      }
      this.defaults = { ...this.defaults, ...o };
    }), this;
  }
  setOptions(e) {
    return this.defaults = { ...this.defaults, ...e }, this;
  }
  lexer(e, n) {
    return ud.lex(e, n ?? this.defaults);
  }
  parser(e, n) {
    return dd.parse(e, n ?? this.defaults);
  }
}
ih = /* @__PURE__ */ new WeakSet(), // TODO: Remove this in next major release
zve = function(t, e, n) {
  switch (e) {
    case "heading":
      return function(r) {
        return !r.type || r.type !== e ? t.apply(this, arguments) : t.call(this, n.parser.parseInline(r.tokens), r.depth, Eht(n.parser.parseInline(r.tokens, n.parser.textRenderer)));
      };
    case "code":
      return function(r) {
        return !r.type || r.type !== e ? t.apply(this, arguments) : t.call(this, r.text, r.lang, !!r.escaped);
      };
    case "table":
      return function(r) {
        if (!r.type || r.type !== e)
          return t.apply(this, arguments);
        let o = "", i = "";
        for (let a = 0; a < r.header.length; a++)
          i += this.tablecell({
            text: r.header[a].text,
            tokens: r.header[a].tokens,
            header: !0,
            align: r.align[a]
          });
        o += this.tablerow({ text: i });
        let s = "";
        for (let a = 0; a < r.rows.length; a++) {
          const l = r.rows[a];
          i = "";
          for (let c = 0; c < l.length; c++)
            i += this.tablecell({
              text: l[c].text,
              tokens: l[c].tokens,
              header: !1,
              align: r.align[c]
            });
          s += this.tablerow({ text: i });
        }
        return t.call(this, o, s);
      };
    case "blockquote":
      return function(r) {
        if (!r.type || r.type !== e)
          return t.apply(this, arguments);
        const o = this.parser.parse(r.tokens);
        return t.call(this, o);
      };
    case "list":
      return function(r) {
        if (!r.type || r.type !== e)
          return t.apply(this, arguments);
        const o = r.ordered, i = r.start, s = r.loose;
        let a = "";
        for (let l = 0; l < r.items.length; l++) {
          const c = r.items[l], u = c.checked, d = c.task;
          let f = "";
          if (c.task) {
            const h = this.checkbox({ checked: !!u });
            s ? c.tokens.length > 0 && c.tokens[0].type === "paragraph" ? (c.tokens[0].text = h + " " + c.tokens[0].text, c.tokens[0].tokens && c.tokens[0].tokens.length > 0 && c.tokens[0].tokens[0].type === "text" && (c.tokens[0].tokens[0].text = h + " " + c.tokens[0].tokens[0].text)) : c.tokens.unshift({
              type: "text",
              text: h + " "
            }) : f += h + " ";
          }
          f += this.parser.parse(c.tokens, s), a += this.listitem({
            type: "list_item",
            raw: f,
            text: f,
            task: d,
            checked: !!u,
            loose: s,
            tokens: c.tokens
          });
        }
        return t.call(this, a, o, i);
      };
    case "html":
      return function(r) {
        return !r.type || r.type !== e ? t.apply(this, arguments) : t.call(this, r.text, r.block);
      };
    case "paragraph":
      return function(r) {
        return !r.type || r.type !== e ? t.apply(this, arguments) : t.call(this, this.parser.parseInline(r.tokens));
      };
    case "escape":
      return function(r) {
        return !r.type || r.type !== e ? t.apply(this, arguments) : t.call(this, r.text);
      };
    case "link":
      return function(r) {
        return !r.type || r.type !== e ? t.apply(this, arguments) : t.call(this, r.href, r.title, this.parser.parseInline(r.tokens));
      };
    case "image":
      return function(r) {
        return !r.type || r.type !== e ? t.apply(this, arguments) : t.call(this, r.href, r.title, r.text);
      };
    case "strong":
      return function(r) {
        return !r.type || r.type !== e ? t.apply(this, arguments) : t.call(this, this.parser.parseInline(r.tokens));
      };
    case "em":
      return function(r) {
        return !r.type || r.type !== e ? t.apply(this, arguments) : t.call(this, this.parser.parseInline(r.tokens));
      };
    case "codespan":
      return function(r) {
        return !r.type || r.type !== e ? t.apply(this, arguments) : t.call(this, r.text);
      };
    case "del":
      return function(r) {
        return !r.type || r.type !== e ? t.apply(this, arguments) : t.call(this, this.parser.parseInline(r.tokens));
      };
    case "text":
      return function(r) {
        return !r.type || r.type !== e ? t.apply(this, arguments) : t.call(this, r.text);
      };
  }
  return t;
}, Zj = function(t, e) {
  return (n, r) => {
    const o = { ...r }, i = { ...this.defaults, ...o };
    this.defaults.async === !0 && o.async === !1 && (i.silent || console.warn("marked(): The async option was set to true by an extension. The async: false option sent to parse will be ignored."), i.async = !0);
    const s = G_(this, ih, xQ).call(this, !!i.silent, !!i.async);
    if (typeof n > "u" || n === null)
      return s(new Error("marked(): input parameter is undefined or null"));
    if (typeof n != "string")
      return s(new Error("marked(): input parameter is of type " + Object.prototype.toString.call(n) + ", string expected"));
    if (i.hooks && (i.hooks.options = i), i.async)
      return Promise.resolve(i.hooks ? i.hooks.preprocess(n) : n).then((a) => t(a, i)).then((a) => i.hooks ? i.hooks.processAllTokens(a) : a).then((a) => i.walkTokens ? Promise.all(this.walkTokens(a, i.walkTokens)).then(() => a) : a).then((a) => e(a, i)).then((a) => i.hooks ? i.hooks.postprocess(a) : a).catch(s);
    try {
      i.hooks && (n = i.hooks.preprocess(n));
      let a = t(n, i);
      i.hooks && (a = i.hooks.processAllTokens(a)), i.walkTokens && this.walkTokens(a, i.walkTokens);
      let l = e(a, i);
      return i.hooks && (l = i.hooks.postprocess(l)), l;
    } catch (a) {
      return s(a);
    }
  };
}, xQ = function(t, e) {
  return (n) => {
    if (n.message += `
Please report this to https://github.com/markedjs/marked.`, t) {
      const r = "<p>An error occurred:</p><pre>" + fi(n.message + "", !0) + "</pre>";
      return e ? Promise.resolve(r) : r;
    }
    if (e)
      return Promise.reject(n);
    throw n;
  };
};
const qd = new Jht();
function Tn(t, e) {
  return qd.parse(t, e);
}
Tn.options = Tn.setOptions = function(t) {
  return qd.setOptions(t), Tn.defaults = qd.defaults, Pve(Tn.defaults), Tn;
};
Tn.getDefaults = Y4;
Tn.defaults = Zd;
Tn.use = function(...t) {
  return qd.use(...t), Tn.defaults = qd.defaults, Pve(Tn.defaults), Tn;
};
Tn.walkTokens = function(t, e) {
  return qd.walkTokens(t, e);
};
Tn.parseInline = qd.parseInline;
Tn.Parser = dd;
Tn.parser = dd.parse;
Tn.Renderer = AE;
Tn.TextRenderer = e6;
Tn.Lexer = ud;
Tn.lexer = ud.lex;
Tn.Tokenizer = CE;
Tn.Hooks = g0;
Tn.parse = Tn;
Tn.options;
Tn.setOptions;
Tn.use;
Tn.walkTokens;
Tn.parseInline;
dd.parse;
ud.lex;
const ept = Object.freeze(JSON.parse('{"colors":{"activityBar.activeBorder":"#1c6b48","activityBar.background":"#ffffff","activityBar.border":"#f0f0f0","activityBar.foreground":"#393a34","activityBar.inactiveForeground":"#393a3450","activityBarBadge.background":"#4e4f47","activityBarBadge.foreground":"#ffffff","badge.background":"#393a3490","badge.foreground":"#ffffff","breadcrumb.activeSelectionForeground":"#22222218","breadcrumb.background":"#f7f7f7","breadcrumb.focusForeground":"#393a34","breadcrumb.foreground":"#6a737d","breadcrumbPicker.background":"#ffffff","button.background":"#1c6b48","button.foreground":"#ffffff","button.hoverBackground":"#1c6b48","checkbox.background":"#f7f7f7","checkbox.border":"#d1d5da","debugToolBar.background":"#ffffff","descriptionForeground":"#393a3490","diffEditor.insertedTextBackground":"#1c6b4830","diffEditor.removedTextBackground":"#ab595940","dropdown.background":"#ffffff","dropdown.border":"#f0f0f0","dropdown.foreground":"#393a34","dropdown.listBackground":"#f7f7f7","editor.background":"#ffffff","editor.findMatchBackground":"#e6cc7744","editor.findMatchHighlightBackground":"#e6cc7766","editor.focusedStackFrameHighlightBackground":"#fff5b1","editor.foldBackground":"#22222210","editor.foreground":"#393a34","editor.inactiveSelectionBackground":"#22222210","editor.lineHighlightBackground":"#f7f7f7","editor.selectionBackground":"#22222218","editor.selectionHighlightBackground":"#22222210","editor.stackFrameHighlightBackground":"#fffbdd","editor.wordHighlightBackground":"#1c6b4805","editor.wordHighlightStrongBackground":"#1c6b4810","editorBracketHighlight.foreground1":"#2993a3","editorBracketHighlight.foreground2":"#1e754f","editorBracketHighlight.foreground3":"#a65e2b","editorBracketHighlight.foreground4":"#a13865","editorBracketHighlight.foreground5":"#bda437","editorBracketHighlight.foreground6":"#296aa3","editorBracketMatch.background":"#1c6b4820","editorError.foreground":"#ab5959","editorGroup.border":"#f0f0f0","editorGroupHeader.tabsBackground":"#ffffff","editorGroupHeader.tabsBorder":"#f0f0f0","editorGutter.addedBackground":"#1e754f","editorGutter.commentRangeForeground":"#393a3450","editorGutter.deletedBackground":"#ab5959","editorGutter.foldingControlForeground":"#393a3490","editorGutter.modifiedBackground":"#296aa3","editorHint.foreground":"#1e754f","editorIndentGuide.activeBackground":"#00000030","editorIndentGuide.background":"#00000015","editorInfo.foreground":"#296aa3","editorInlayHint.background":"#f7f7f7","editorInlayHint.foreground":"#999999","editorLineNumber.activeForeground":"#4e4f47","editorLineNumber.foreground":"#393a3450","editorOverviewRuler.border":"#fff","editorStickyScroll.background":"#f7f7f7","editorStickyScrollHover.background":"#f7f7f7","editorWarning.foreground":"#a65e2b","editorWhitespace.foreground":"#00000015","editorWidget.background":"#ffffff","errorForeground":"#ab5959","focusBorder":"#00000000","foreground":"#393a34","gitDecoration.addedResourceForeground":"#1e754f","gitDecoration.conflictingResourceForeground":"#a65e2b","gitDecoration.deletedResourceForeground":"#ab5959","gitDecoration.ignoredResourceForeground":"#393a3450","gitDecoration.modifiedResourceForeground":"#296aa3","gitDecoration.submoduleResourceForeground":"#393a3490","gitDecoration.untrackedResourceForeground":"#2993a3","input.background":"#f7f7f7","input.border":"#f0f0f0","input.foreground":"#393a34","input.placeholderForeground":"#393a3490","inputOption.activeBackground":"#393a3450","list.activeSelectionBackground":"#f7f7f7","list.activeSelectionForeground":"#393a34","list.focusBackground":"#f7f7f7","list.highlightForeground":"#1c6b48","list.hoverBackground":"#f7f7f7","list.hoverForeground":"#393a34","list.inactiveFocusBackground":"#ffffff","list.inactiveSelectionBackground":"#f7f7f7","list.inactiveSelectionForeground":"#393a34","menu.separatorBackground":"#f0f0f0","notificationCenterHeader.background":"#ffffff","notificationCenterHeader.foreground":"#6a737d","notifications.background":"#ffffff","notifications.border":"#f0f0f0","notifications.foreground":"#393a34","notificationsErrorIcon.foreground":"#ab5959","notificationsInfoIcon.foreground":"#296aa3","notificationsWarningIcon.foreground":"#a65e2b","panel.background":"#ffffff","panel.border":"#f0f0f0","panelInput.border":"#e1e4e8","panelTitle.activeBorder":"#1c6b48","panelTitle.activeForeground":"#393a34","panelTitle.inactiveForeground":"#6a737d","peekViewEditor.background":"#ffffff","peekViewResult.background":"#ffffff","pickerGroup.border":"#f0f0f0","pickerGroup.foreground":"#393a34","problemsErrorIcon.foreground":"#ab5959","problemsInfoIcon.foreground":"#296aa3","problemsWarningIcon.foreground":"#a65e2b","progressBar.background":"#1c6b48","quickInput.background":"#ffffff","quickInput.foreground":"#393a34","quickInputList.focusBackground":"#f7f7f7","scrollbar.shadow":"#6a737d33","scrollbarSlider.activeBackground":"#393a3450","scrollbarSlider.background":"#393a3410","scrollbarSlider.hoverBackground":"#393a3450","settings.headerForeground":"#393a34","settings.modifiedItemIndicator":"#1c6b48","sideBar.background":"#ffffff","sideBar.border":"#f0f0f0","sideBar.foreground":"#4e4f47","sideBarSectionHeader.background":"#ffffff","sideBarSectionHeader.border":"#f0f0f0","sideBarSectionHeader.foreground":"#393a34","sideBarTitle.foreground":"#393a34","statusBar.background":"#ffffff","statusBar.border":"#f0f0f0","statusBar.debuggingBackground":"#f7f7f7","statusBar.debuggingForeground":"#4e4f47","statusBar.foreground":"#4e4f47","statusBar.noFolderBackground":"#ffffff","statusBarItem.prominentBackground":"#f7f7f7","tab.activeBackground":"#ffffff","tab.activeBorder":"#f0f0f0","tab.activeBorderTop":"#393a3490","tab.activeForeground":"#393a34","tab.border":"#f0f0f0","tab.hoverBackground":"#f7f7f7","tab.inactiveBackground":"#ffffff","tab.inactiveForeground":"#6a737d","tab.unfocusedActiveBorder":"#f0f0f0","tab.unfocusedActiveBorderTop":"#f0f0f0","tab.unfocusedHoverBackground":"#ffffff","terminal.ansiBlack":"#121212","terminal.ansiBlue":"#296aa3","terminal.ansiBrightBlack":"#aaaaaa","terminal.ansiBrightBlue":"#296aa3","terminal.ansiBrightCyan":"#2993a3","terminal.ansiBrightGreen":"#1e754f","terminal.ansiBrightMagenta":"#a13865","terminal.ansiBrightRed":"#ab5959","terminal.ansiBrightWhite":"#dddddd","terminal.ansiBrightYellow":"#bda437","terminal.ansiCyan":"#2993a3","terminal.ansiGreen":"#1e754f","terminal.ansiMagenta":"#a13865","terminal.ansiRed":"#ab5959","terminal.ansiWhite":"#dbd7ca","terminal.ansiYellow":"#bda437","terminal.foreground":"#393a34","terminal.selectionBackground":"#22222218","textBlockQuote.background":"#ffffff","textBlockQuote.border":"#f0f0f0","textCodeBlock.background":"#ffffff","textLink.activeForeground":"#1c6b48","textLink.foreground":"#1c6b48","textPreformat.foreground":"#586069","textSeparator.foreground":"#d1d5da","titleBar.activeBackground":"#ffffff","titleBar.activeForeground":"#4e4f47","titleBar.border":"#f7f7f7","titleBar.inactiveBackground":"#ffffff","titleBar.inactiveForeground":"#6a737d","tree.indentGuidesStroke":"#e1e4e8","welcomePage.buttonBackground":"#f6f8fa","welcomePage.buttonHoverBackground":"#e1e4e8"},"displayName":"Vitesse Light","name":"vitesse-light","semanticHighlighting":true,"semanticTokenColors":{"class":"#5a6aa6","interface":"#2e808f","namespace":"#b05a78","property":"#998418","type":"#2e808f"},"tokenColors":[{"scope":["comment","punctuation.definition.comment","string.comment"],"settings":{"foreground":"#a0ada0"}},{"scope":["delimiter.bracket","delimiter","invalid.illegal.character-not-allowed-here.html","keyword.operator.rest","keyword.operator.spread","keyword.operator.type.annotation","keyword.operator.relational","keyword.operator.assignment","keyword.operator.type","meta.brace","meta.tag.block.any.html","meta.tag.inline.any.html","meta.tag.structure.input.void.html","meta.type.annotation","meta.embedded.block.github-actions-expression","storage.type.function.arrow","meta.objectliteral.ts","punctuation","punctuation.definition.string.begin.html.vue","punctuation.definition.string.end.html.vue"],"settings":{"foreground":"#999999"}},{"scope":["constant","entity.name.constant","variable.language","meta.definition.variable"],"settings":{"foreground":"#a65e2b"}},{"scope":["entity","entity.name"],"settings":{"foreground":"#59873a"}},{"scope":"variable.parameter.function","settings":{"foreground":"#393a34"}},{"scope":["entity.name.tag","tag.html"],"settings":{"foreground":"#1e754f"}},{"scope":"entity.name.function","settings":{"foreground":"#59873a"}},{"scope":["keyword","storage.type.class.jsdoc","punctuation.definition.template-expression"],"settings":{"foreground":"#1e754f"}},{"scope":["storage","storage.type","support.type.builtin","constant.language.undefined","constant.language.null","constant.language.import-export-all.ts"],"settings":{"foreground":"#ab5959"}},{"scope":["text.html.derivative","storage.modifier.package","storage.modifier.import","storage.type.java"],"settings":{"foreground":"#393a34"}},{"scope":["string","string punctuation.section.embedded source","attribute.value"],"settings":{"foreground":"#b56959"}},{"scope":["punctuation.definition.string"],"settings":{"foreground":"#b5695977"}},{"scope":["punctuation.support.type.property-name"],"settings":{"foreground":"#99841877"}},{"scope":"support","settings":{"foreground":"#998418"}},{"scope":["property","meta.property-name","meta.object-literal.key","entity.name.tag.yaml","attribute.name"],"settings":{"foreground":"#998418"}},{"scope":["entity.other.attribute-name","invalid.deprecated.entity.other.attribute-name.html"],"settings":{"foreground":"#b07d48"}},{"scope":["variable","identifier"],"settings":{"foreground":"#b07d48"}},{"scope":["support.type.primitive","entity.name.type"],"settings":{"foreground":"#2e8f82"}},{"scope":"namespace","settings":{"foreground":"#b05a78"}},{"scope":["keyword.operator","keyword.operator.assignment.compound","meta.var.expr.ts"],"settings":{"foreground":"#ab5959"}},{"scope":"invalid.broken","settings":{"fontStyle":"italic","foreground":"#b31d28"}},{"scope":"invalid.deprecated","settings":{"fontStyle":"italic","foreground":"#b31d28"}},{"scope":"invalid.illegal","settings":{"fontStyle":"italic","foreground":"#b31d28"}},{"scope":"invalid.unimplemented","settings":{"fontStyle":"italic","foreground":"#b31d28"}},{"scope":"carriage-return","settings":{"background":"#d73a49","content":"^M","fontStyle":"italic underline","foreground":"#fafbfc"}},{"scope":"message.error","settings":{"foreground":"#b31d28"}},{"scope":"string variable","settings":{"foreground":"#b56959"}},{"scope":["source.regexp","string.regexp"],"settings":{"foreground":"#ab5e3f"}},{"scope":["string.regexp.character-class","string.regexp constant.character.escape","string.regexp source.ruby.embedded","string.regexp string.regexp.arbitrary-repitition"],"settings":{"foreground":"#b56959"}},{"scope":"string.regexp constant.character.escape","settings":{"foreground":"#bda437"}},{"scope":["support.constant"],"settings":{"foreground":"#a65e2b"}},{"scope":["keyword.operator.quantifier.regexp","constant.numeric","number"],"settings":{"foreground":"#2f798a"}},{"scope":["keyword.other.unit"],"settings":{"foreground":"#ab5959"}},{"scope":["constant.language.boolean","constant.language"],"settings":{"foreground":"#1e754f"}},{"scope":"meta.module-reference","settings":{"foreground":"#1c6b48"}},{"scope":"punctuation.definition.list.begin.markdown","settings":{"foreground":"#a65e2b"}},{"scope":["markup.heading","markup.heading entity.name"],"settings":{"fontStyle":"bold","foreground":"#1c6b48"}},{"scope":"markup.quote","settings":{"foreground":"#2e808f"}},{"scope":"markup.italic","settings":{"fontStyle":"italic","foreground":"#393a34"}},{"scope":"markup.bold","settings":{"fontStyle":"bold","foreground":"#393a34"}},{"scope":"markup.raw","settings":{"foreground":"#1c6b48"}},{"scope":["markup.deleted","meta.diff.header.from-file","punctuation.definition.deleted"],"settings":{"background":"#ffeef0","foreground":"#b31d28"}},{"scope":["markup.inserted","meta.diff.header.to-file","punctuation.definition.inserted"],"settings":{"background":"#f0fff4","foreground":"#22863a"}},{"scope":["markup.changed","punctuation.definition.changed"],"settings":{"background":"#ffebda","foreground":"#e36209"}},{"scope":["markup.ignored","markup.untracked"],"settings":{"background":"#005cc5","foreground":"#f6f8fa"}},{"scope":"meta.diff.range","settings":{"fontStyle":"bold","foreground":"#6f42c1"}},{"scope":"meta.diff.header","settings":{"foreground":"#005cc5"}},{"scope":"meta.separator","settings":{"fontStyle":"bold","foreground":"#005cc5"}},{"scope":"meta.output","settings":{"foreground":"#005cc5"}},{"scope":["brackethighlighter.tag","brackethighlighter.curly","brackethighlighter.round","brackethighlighter.square","brackethighlighter.angle","brackethighlighter.quote"],"settings":{"foreground":"#586069"}},{"scope":"brackethighlighter.unmatched","settings":{"foreground":"#b31d28"}},{"scope":["constant.other.reference.link","string.other.link","punctuation.definition.string.begin.markdown","punctuation.definition.string.end.markdown"],"settings":{"foreground":"#b56959"}},{"scope":["markup.underline.link.markdown","markup.underline.link.image.markdown"],"settings":{"fontStyle":"underline","foreground":"#393a3490"}},{"scope":["type.identifier","constant.other.character-class.regexp"],"settings":{"foreground":"#5a6aa6"}},{"scope":["entity.other.attribute-name.html.vue"],"settings":{"foreground":"#59873a"}},{"scope":["invalid.illegal.unrecognized-tag.html"],"settings":{"fontStyle":"normal"}}],"type":"light"}')), tpt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ept
}, Symbol.toStringTag, { value: "Module" })), npt = Object.freeze(JSON.parse('{"colors":{"activityBar.activeBorder":"#4d9375","activityBar.background":"#121212","activityBar.border":"#191919","activityBar.foreground":"#dbd7caee","activityBar.inactiveForeground":"#dedcd550","activityBarBadge.background":"#bfbaaa","activityBarBadge.foreground":"#121212","badge.background":"#dedcd590","badge.foreground":"#121212","breadcrumb.activeSelectionForeground":"#eeeeee18","breadcrumb.background":"#181818","breadcrumb.focusForeground":"#dbd7caee","breadcrumb.foreground":"#959da5","breadcrumbPicker.background":"#121212","button.background":"#4d9375","button.foreground":"#121212","button.hoverBackground":"#4d9375","checkbox.background":"#181818","checkbox.border":"#2f363d","debugToolBar.background":"#121212","descriptionForeground":"#dedcd590","diffEditor.insertedTextBackground":"#4d937550","diffEditor.removedTextBackground":"#ab595950","dropdown.background":"#121212","dropdown.border":"#191919","dropdown.foreground":"#dbd7caee","dropdown.listBackground":"#181818","editor.background":"#121212","editor.findMatchBackground":"#e6cc7722","editor.findMatchHighlightBackground":"#e6cc7744","editor.focusedStackFrameHighlightBackground":"#b808","editor.foldBackground":"#eeeeee10","editor.foreground":"#dbd7caee","editor.inactiveSelectionBackground":"#eeeeee10","editor.lineHighlightBackground":"#181818","editor.selectionBackground":"#eeeeee18","editor.selectionHighlightBackground":"#eeeeee10","editor.stackFrameHighlightBackground":"#a707","editor.wordHighlightBackground":"#1c6b4805","editor.wordHighlightStrongBackground":"#1c6b4810","editorBracketHighlight.foreground1":"#5eaab5","editorBracketHighlight.foreground2":"#4d9375","editorBracketHighlight.foreground3":"#d4976c","editorBracketHighlight.foreground4":"#d9739f","editorBracketHighlight.foreground5":"#e6cc77","editorBracketHighlight.foreground6":"#6394bf","editorBracketMatch.background":"#4d937520","editorError.foreground":"#cb7676","editorGroup.border":"#191919","editorGroupHeader.tabsBackground":"#121212","editorGroupHeader.tabsBorder":"#191919","editorGutter.addedBackground":"#4d9375","editorGutter.commentRangeForeground":"#dedcd550","editorGutter.deletedBackground":"#cb7676","editorGutter.foldingControlForeground":"#dedcd590","editorGutter.modifiedBackground":"#6394bf","editorHint.foreground":"#4d9375","editorIndentGuide.activeBackground":"#ffffff30","editorIndentGuide.background":"#ffffff15","editorInfo.foreground":"#6394bf","editorInlayHint.background":"#181818","editorInlayHint.foreground":"#666666","editorLineNumber.activeForeground":"#bfbaaa","editorLineNumber.foreground":"#dedcd550","editorOverviewRuler.border":"#111","editorStickyScroll.background":"#181818","editorStickyScrollHover.background":"#181818","editorWarning.foreground":"#d4976c","editorWhitespace.foreground":"#ffffff15","editorWidget.background":"#121212","errorForeground":"#cb7676","focusBorder":"#00000000","foreground":"#dbd7caee","gitDecoration.addedResourceForeground":"#4d9375","gitDecoration.conflictingResourceForeground":"#d4976c","gitDecoration.deletedResourceForeground":"#cb7676","gitDecoration.ignoredResourceForeground":"#dedcd550","gitDecoration.modifiedResourceForeground":"#6394bf","gitDecoration.submoduleResourceForeground":"#dedcd590","gitDecoration.untrackedResourceForeground":"#5eaab5","input.background":"#181818","input.border":"#191919","input.foreground":"#dbd7caee","input.placeholderForeground":"#dedcd590","inputOption.activeBackground":"#dedcd550","list.activeSelectionBackground":"#181818","list.activeSelectionForeground":"#dbd7caee","list.focusBackground":"#181818","list.highlightForeground":"#4d9375","list.hoverBackground":"#181818","list.hoverForeground":"#dbd7caee","list.inactiveFocusBackground":"#121212","list.inactiveSelectionBackground":"#181818","list.inactiveSelectionForeground":"#dbd7caee","menu.separatorBackground":"#191919","notificationCenterHeader.background":"#121212","notificationCenterHeader.foreground":"#959da5","notifications.background":"#121212","notifications.border":"#191919","notifications.foreground":"#dbd7caee","notificationsErrorIcon.foreground":"#cb7676","notificationsInfoIcon.foreground":"#6394bf","notificationsWarningIcon.foreground":"#d4976c","panel.background":"#121212","panel.border":"#191919","panelInput.border":"#2f363d","panelTitle.activeBorder":"#4d9375","panelTitle.activeForeground":"#dbd7caee","panelTitle.inactiveForeground":"#959da5","peekViewEditor.background":"#121212","peekViewEditor.matchHighlightBackground":"#ffd33d33","peekViewResult.background":"#121212","peekViewResult.matchHighlightBackground":"#ffd33d33","pickerGroup.border":"#191919","pickerGroup.foreground":"#dbd7caee","problemsErrorIcon.foreground":"#cb7676","problemsInfoIcon.foreground":"#6394bf","problemsWarningIcon.foreground":"#d4976c","progressBar.background":"#4d9375","quickInput.background":"#121212","quickInput.foreground":"#dbd7caee","quickInputList.focusBackground":"#181818","scrollbar.shadow":"#0000","scrollbarSlider.activeBackground":"#dedcd550","scrollbarSlider.background":"#dedcd510","scrollbarSlider.hoverBackground":"#dedcd550","settings.headerForeground":"#dbd7caee","settings.modifiedItemIndicator":"#4d9375","sideBar.background":"#121212","sideBar.border":"#191919","sideBar.foreground":"#bfbaaa","sideBarSectionHeader.background":"#121212","sideBarSectionHeader.border":"#191919","sideBarSectionHeader.foreground":"#dbd7caee","sideBarTitle.foreground":"#dbd7caee","statusBar.background":"#121212","statusBar.border":"#191919","statusBar.debuggingBackground":"#181818","statusBar.debuggingForeground":"#bfbaaa","statusBar.foreground":"#bfbaaa","statusBar.noFolderBackground":"#121212","statusBarItem.prominentBackground":"#181818","tab.activeBackground":"#121212","tab.activeBorder":"#191919","tab.activeBorderTop":"#dedcd590","tab.activeForeground":"#dbd7caee","tab.border":"#191919","tab.hoverBackground":"#181818","tab.inactiveBackground":"#121212","tab.inactiveForeground":"#959da5","tab.unfocusedActiveBorder":"#191919","tab.unfocusedActiveBorderTop":"#191919","tab.unfocusedHoverBackground":"#121212","terminal.ansiBlack":"#393a34","terminal.ansiBlue":"#6394bf","terminal.ansiBrightBlack":"#777777","terminal.ansiBrightBlue":"#6394bf","terminal.ansiBrightCyan":"#5eaab5","terminal.ansiBrightGreen":"#4d9375","terminal.ansiBrightMagenta":"#d9739f","terminal.ansiBrightRed":"#cb7676","terminal.ansiBrightWhite":"#ffffff","terminal.ansiBrightYellow":"#e6cc77","terminal.ansiCyan":"#5eaab5","terminal.ansiGreen":"#4d9375","terminal.ansiMagenta":"#d9739f","terminal.ansiRed":"#cb7676","terminal.ansiWhite":"#dbd7ca","terminal.ansiYellow":"#e6cc77","terminal.foreground":"#dbd7caee","terminal.selectionBackground":"#eeeeee18","textBlockQuote.background":"#121212","textBlockQuote.border":"#191919","textCodeBlock.background":"#121212","textLink.activeForeground":"#4d9375","textLink.foreground":"#4d9375","textPreformat.foreground":"#d1d5da","textSeparator.foreground":"#586069","titleBar.activeBackground":"#121212","titleBar.activeForeground":"#bfbaaa","titleBar.border":"#181818","titleBar.inactiveBackground":"#121212","titleBar.inactiveForeground":"#959da5","tree.indentGuidesStroke":"#2f363d","welcomePage.buttonBackground":"#2f363d","welcomePage.buttonHoverBackground":"#444d56"},"displayName":"Vitesse Dark","name":"vitesse-dark","semanticHighlighting":true,"semanticTokenColors":{"class":"#6872ab","interface":"#5d99a9","namespace":"#db889a","property":"#b8a965","type":"#5d99a9"},"tokenColors":[{"scope":["comment","punctuation.definition.comment","string.comment"],"settings":{"foreground":"#758575dd"}},{"scope":["delimiter.bracket","delimiter","invalid.illegal.character-not-allowed-here.html","keyword.operator.rest","keyword.operator.spread","keyword.operator.type.annotation","keyword.operator.relational","keyword.operator.assignment","keyword.operator.type","meta.brace","meta.tag.block.any.html","meta.tag.inline.any.html","meta.tag.structure.input.void.html","meta.type.annotation","meta.embedded.block.github-actions-expression","storage.type.function.arrow","meta.objectliteral.ts","punctuation","punctuation.definition.string.begin.html.vue","punctuation.definition.string.end.html.vue"],"settings":{"foreground":"#666666"}},{"scope":["constant","entity.name.constant","variable.language","meta.definition.variable"],"settings":{"foreground":"#c99076"}},{"scope":["entity","entity.name"],"settings":{"foreground":"#80a665"}},{"scope":"variable.parameter.function","settings":{"foreground":"#dbd7caee"}},{"scope":["entity.name.tag","tag.html"],"settings":{"foreground":"#4d9375"}},{"scope":"entity.name.function","settings":{"foreground":"#80a665"}},{"scope":["keyword","storage.type.class.jsdoc","punctuation.definition.template-expression"],"settings":{"foreground":"#4d9375"}},{"scope":["storage","storage.type","support.type.builtin","constant.language.undefined","constant.language.null","constant.language.import-export-all.ts"],"settings":{"foreground":"#cb7676"}},{"scope":["text.html.derivative","storage.modifier.package","storage.modifier.import","storage.type.java"],"settings":{"foreground":"#dbd7caee"}},{"scope":["string","string punctuation.section.embedded source","attribute.value"],"settings":{"foreground":"#c98a7d"}},{"scope":["punctuation.definition.string"],"settings":{"foreground":"#c98a7d77"}},{"scope":["punctuation.support.type.property-name"],"settings":{"foreground":"#b8a96577"}},{"scope":"support","settings":{"foreground":"#b8a965"}},{"scope":["property","meta.property-name","meta.object-literal.key","entity.name.tag.yaml","attribute.name"],"settings":{"foreground":"#b8a965"}},{"scope":["entity.other.attribute-name","invalid.deprecated.entity.other.attribute-name.html"],"settings":{"foreground":"#bd976a"}},{"scope":["variable","identifier"],"settings":{"foreground":"#bd976a"}},{"scope":["support.type.primitive","entity.name.type"],"settings":{"foreground":"#5DA994"}},{"scope":"namespace","settings":{"foreground":"#db889a"}},{"scope":["keyword.operator","keyword.operator.assignment.compound","meta.var.expr.ts"],"settings":{"foreground":"#cb7676"}},{"scope":"invalid.broken","settings":{"fontStyle":"italic","foreground":"#fdaeb7"}},{"scope":"invalid.deprecated","settings":{"fontStyle":"italic","foreground":"#fdaeb7"}},{"scope":"invalid.illegal","settings":{"fontStyle":"italic","foreground":"#fdaeb7"}},{"scope":"invalid.unimplemented","settings":{"fontStyle":"italic","foreground":"#fdaeb7"}},{"scope":"carriage-return","settings":{"background":"#f97583","content":"^M","fontStyle":"italic underline","foreground":"#24292e"}},{"scope":"message.error","settings":{"foreground":"#fdaeb7"}},{"scope":"string variable","settings":{"foreground":"#c98a7d"}},{"scope":["source.regexp","string.regexp"],"settings":{"foreground":"#c4704f"}},{"scope":["string.regexp.character-class","string.regexp constant.character.escape","string.regexp source.ruby.embedded","string.regexp string.regexp.arbitrary-repitition"],"settings":{"foreground":"#c98a7d"}},{"scope":"string.regexp constant.character.escape","settings":{"foreground":"#e6cc77"}},{"scope":["support.constant"],"settings":{"foreground":"#c99076"}},{"scope":["keyword.operator.quantifier.regexp","constant.numeric","number"],"settings":{"foreground":"#4C9A91"}},{"scope":["keyword.other.unit"],"settings":{"foreground":"#cb7676"}},{"scope":["constant.language.boolean","constant.language"],"settings":{"foreground":"#4d9375"}},{"scope":"meta.module-reference","settings":{"foreground":"#4d9375"}},{"scope":"punctuation.definition.list.begin.markdown","settings":{"foreground":"#d4976c"}},{"scope":["markup.heading","markup.heading entity.name"],"settings":{"fontStyle":"bold","foreground":"#4d9375"}},{"scope":"markup.quote","settings":{"foreground":"#5d99a9"}},{"scope":"markup.italic","settings":{"fontStyle":"italic","foreground":"#dbd7caee"}},{"scope":"markup.bold","settings":{"fontStyle":"bold","foreground":"#dbd7caee"}},{"scope":"markup.raw","settings":{"foreground":"#4d9375"}},{"scope":["markup.deleted","meta.diff.header.from-file","punctuation.definition.deleted"],"settings":{"background":"#86181d","foreground":"#fdaeb7"}},{"scope":["markup.inserted","meta.diff.header.to-file","punctuation.definition.inserted"],"settings":{"background":"#144620","foreground":"#85e89d"}},{"scope":["markup.changed","punctuation.definition.changed"],"settings":{"background":"#c24e00","foreground":"#ffab70"}},{"scope":["markup.ignored","markup.untracked"],"settings":{"background":"#79b8ff","foreground":"#2f363d"}},{"scope":"meta.diff.range","settings":{"fontStyle":"bold","foreground":"#b392f0"}},{"scope":"meta.diff.header","settings":{"foreground":"#79b8ff"}},{"scope":"meta.separator","settings":{"fontStyle":"bold","foreground":"#79b8ff"}},{"scope":"meta.output","settings":{"foreground":"#79b8ff"}},{"scope":["brackethighlighter.tag","brackethighlighter.curly","brackethighlighter.round","brackethighlighter.square","brackethighlighter.angle","brackethighlighter.quote"],"settings":{"foreground":"#d1d5da"}},{"scope":"brackethighlighter.unmatched","settings":{"foreground":"#fdaeb7"}},{"scope":["constant.other.reference.link","string.other.link","punctuation.definition.string.begin.markdown","punctuation.definition.string.end.markdown"],"settings":{"foreground":"#c98a7d"}},{"scope":["markup.underline.link.markdown","markup.underline.link.image.markdown"],"settings":{"fontStyle":"underline","foreground":"#dedcd590"}},{"scope":["type.identifier","constant.other.character-class.regexp"],"settings":{"foreground":"#6872ab"}},{"scope":["entity.other.attribute-name.html.vue"],"settings":{"foreground":"#80a665"}},{"scope":["invalid.illegal.unrecognized-tag.html"],"settings":{"fontStyle":"normal"}}],"type":"dark"}')), rpt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: npt
}, Symbol.toStringTag, { value: "Module" })), opt = Object.freeze(JSON.parse(`{"displayName":"JavaScript","name":"javascript","patterns":[{"include":"#directives"},{"include":"#statements"},{"include":"#shebang"}],"repository":{"access-modifier":{"match":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(abstract|declare|override|public|protected|private|readonly|static)(?![_$[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))","name":"storage.modifier.js"},"after-operator-block-as-object-literal":{"begin":"(?<!\\\\+\\\\+|--)(?<=[:=(,\\\\[?+!>]|^await|[^\\\\._$[:alnum:]]await|^return|[^\\\\._$[:alnum:]]return|^yield|[^\\\\._$[:alnum:]]yield|^throw|[^\\\\._$[:alnum:]]throw|^in|[^\\\\._$[:alnum:]]in|^of|[^\\\\._$[:alnum:]]of|^typeof|[^\\\\._$[:alnum:]]typeof|&&|\\\\|\\\\||\\\\*)\\\\s*(\\\\{)","beginCaptures":{"1":{"name":"punctuation.definition.block.js"}},"end":"\\\\}","endCaptures":{"0":{"name":"punctuation.definition.block.js"}},"name":"meta.objectliteral.js","patterns":[{"include":"#object-member"}]},"array-binding-pattern":{"begin":"(?:(\\\\.\\\\.\\\\.)\\\\s*)?(\\\\[)","beginCaptures":{"1":{"name":"keyword.operator.rest.js"},"2":{"name":"punctuation.definition.binding-pattern.array.js"}},"end":"\\\\]","endCaptures":{"0":{"name":"punctuation.definition.binding-pattern.array.js"}},"patterns":[{"include":"#binding-element"},{"include":"#punctuation-comma"}]},"array-binding-pattern-const":{"begin":"(?:(\\\\.\\\\.\\\\.)\\\\s*)?(\\\\[)","beginCaptures":{"1":{"name":"keyword.operator.rest.js"},"2":{"name":"punctuation.definition.binding-pattern.array.js"}},"end":"\\\\]","endCaptures":{"0":{"name":"punctuation.definition.binding-pattern.array.js"}},"patterns":[{"include":"#binding-element-const"},{"include":"#punctuation-comma"}]},"array-literal":{"begin":"\\\\s*(\\\\[)","beginCaptures":{"1":{"name":"meta.brace.square.js"}},"end":"\\\\]","endCaptures":{"0":{"name":"meta.brace.square.js"}},"name":"meta.array.literal.js","patterns":[{"include":"#expression"},{"include":"#punctuation-comma"}]},"arrow-function":{"patterns":[{"captures":{"1":{"name":"storage.modifier.async.js"},"2":{"name":"variable.parameter.js"}},"match":"(?:(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(\\\\basync)\\\\s+)?([_$[:alpha:]][_$[:alnum:]]*)\\\\s*(?==>)","name":"meta.arrow.js"},{"begin":"(?:(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(\\\\basync))?((?<![})!\\\\]])\\\\s*(?=((<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<]|\\\\<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<]|\\\\<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<])*\\\\>)*\\\\>)*>\\\\s*)?[(]\\\\s*(\\\\/\\\\*([^\\\\*]|(\\\\*[^\\\\/]))*\\\\*\\\\/\\\\s*)*(([)]\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[_$[:alpha:]][_$[:alnum:]]*\\\\s*:)))|([<]\\\\s*[_$[:alpha:]][_$[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<]|\\\\<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<]|\\\\<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<])*\\\\>)*\\\\>)*>\\\\s*)?\\\\(\\\\s*(\\\\/\\\\*([^\\\\*]|(\\\\*[^\\\\/]))*\\\\*\\\\/\\\\s*)*(([_$[:alpha:]]|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\])|(\\\\.\\\\.\\\\.\\\\s*[_$[:alpha:]]))([^()\\\\'\\\\\\"\\\\\`]|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\'([^\\\\'\\\\\\\\]|\\\\\\\\.)*\\\\')|(\\\\\\"([^\\\\\\"\\\\\\\\]|\\\\\\\\.)*\\\\\\")|(\\\\\`([^\\\\\`\\\\\\\\]|\\\\\\\\.)*\\\\\`))*)?\\\\)(\\\\s*:\\\\s*([^<>\\\\(\\\\)\\\\{\\\\}]|\\\\<([^<>]|\\\\<([^<>]|\\\\<[^<>]+\\\\>)+\\\\>)+\\\\>|\\\\([^\\\\(\\\\)]+\\\\)|\\\\{[^\\\\{\\\\}]+\\\\})+)?\\\\s*=>)))","beginCaptures":{"1":{"name":"storage.modifier.async.js"}},"end":"(?==>|\\\\{|(^\\\\s*(export|function|class|interface|let|var|(?:\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[_$[:alpha:]])\\\\b)|(?:\\\\bawait\\\\s+(?:\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[_$[:alpha:]])\\\\b)\\\\b)|const|import|enum|namespace|module|type|abstract|declare)\\\\s+))","name":"meta.arrow.js","patterns":[{"include":"#comment"},{"include":"#type-parameters"},{"include":"#function-parameters"},{"include":"#arrow-return-type"},{"include":"#possibly-arrow-return-type"}]},{"begin":"=>","beginCaptures":{"0":{"name":"storage.type.function.arrow.js"}},"end":"((?<=\\\\}|\\\\S)(?<!=>)|((?!\\\\{)(?=\\\\S)))(?!\\\\/[\\\\/\\\\*])","name":"meta.arrow.js","patterns":[{"include":"#single-line-comment-consuming-line-ending"},{"include":"#decl-block"},{"include":"#expression"}]}]},"arrow-return-type":{"begin":"(?<=\\\\))\\\\s*(:)","beginCaptures":{"1":{"name":"keyword.operator.type.annotation.js"}},"end":"(?==>|\\\\{|(^\\\\s*(export|function|class|interface|let|var|(?:\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[_$[:alpha:]])\\\\b)|(?:\\\\bawait\\\\s+(?:\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[_$[:alpha:]])\\\\b)\\\\b)|const|import|enum|namespace|module|type|abstract|declare)\\\\s+))","name":"meta.return.type.arrow.js","patterns":[{"include":"#arrow-return-type-body"}]},"arrow-return-type-body":{"patterns":[{"begin":"(?<=[:])(?=\\\\s*\\\\{)","end":"(?<=\\\\})","patterns":[{"include":"#type-object"}]},{"include":"#type-predicate-operator"},{"include":"#type"}]},"async-modifier":{"match":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(async)(?![_$[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))","name":"storage.modifier.async.js"},"binding-element":{"patterns":[{"include":"#comment"},{"include":"#string"},{"include":"#numeric-literal"},{"include":"#regex"},{"include":"#object-binding-pattern"},{"include":"#array-binding-pattern"},{"include":"#destructuring-variable-rest"},{"include":"#variable-initializer"}]},"binding-element-const":{"patterns":[{"include":"#comment"},{"include":"#string"},{"include":"#numeric-literal"},{"include":"#regex"},{"include":"#object-binding-pattern-const"},{"include":"#array-binding-pattern-const"},{"include":"#destructuring-variable-rest-const"},{"include":"#variable-initializer"}]},"boolean-literal":{"patterns":[{"match":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))true(?![_$[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))","name":"constant.language.boolean.true.js"},{"match":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))false(?![_$[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))","name":"constant.language.boolean.false.js"}]},"brackets":{"patterns":[{"begin":"{","end":"}|(?=\\\\*/)","patterns":[{"include":"#brackets"}]},{"begin":"\\\\[","end":"\\\\]|(?=\\\\*/)","patterns":[{"include":"#brackets"}]}]},"cast":{"patterns":[{"include":"#jsx"}]},"class-declaration":{"begin":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(\\\\bexport)\\\\s+)?(?:(\\\\bdeclare)\\\\s+)?\\\\b(?:(abstract)\\\\s+)?\\\\b(class)\\\\b(?=\\\\s+|/[/*])","beginCaptures":{"1":{"name":"keyword.control.export.js"},"2":{"name":"storage.modifier.js"},"3":{"name":"storage.modifier.js"},"4":{"name":"storage.type.class.js"}},"end":"(?<=\\\\})","name":"meta.class.js","patterns":[{"include":"#class-declaration-or-expression-patterns"}]},"class-declaration-or-expression-patterns":{"patterns":[{"include":"#comment"},{"include":"#class-or-interface-heritage"},{"captures":{"0":{"name":"entity.name.type.class.js"}},"match":"[_$[:alpha:]][_$[:alnum:]]*"},{"include":"#type-parameters"},{"include":"#class-or-interface-body"}]},"class-expression":{"begin":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(abstract)\\\\s+)?(class)\\\\b(?=\\\\s+|[<{]|\\\\/[\\\\/*])","beginCaptures":{"1":{"name":"storage.modifier.js"},"2":{"name":"storage.type.class.js"}},"end":"(?<=\\\\})","name":"meta.class.js","patterns":[{"include":"#class-declaration-or-expression-patterns"}]},"class-or-interface-body":{"begin":"\\\\{","beginCaptures":{"0":{"name":"punctuation.definition.block.js"}},"end":"\\\\}","endCaptures":{"0":{"name":"punctuation.definition.block.js"}},"patterns":[{"include":"#comment"},{"include":"#decorator"},{"begin":"(?<=:)\\\\s*","end":"(?=\\\\s|[;),}\\\\]:\\\\-\\\\+]|;|^\\\\s*$|(?:^\\\\s*(?:abstract|async|(?:\\\\bawait\\\\s+(?:\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[_$[:alpha:]])\\\\b)\\\\b)|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|(?:\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[_$[:alpha:]])\\\\b)|var|while)\\\\b))","patterns":[{"include":"#expression"}]},{"include":"#method-declaration"},{"include":"#indexer-declaration"},{"include":"#field-declaration"},{"include":"#string"},{"include":"#type-annotation"},{"include":"#variable-initializer"},{"include":"#access-modifier"},{"include":"#property-accessor"},{"include":"#async-modifier"},{"include":"#after-operator-block-as-object-literal"},{"include":"#decl-block"},{"include":"#expression"},{"include":"#punctuation-comma"},{"include":"#punctuation-semicolon"}]},"class-or-interface-heritage":{"begin":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(extends|implements)\\\\b)(?![_$[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))","beginCaptures":{"1":{"name":"storage.modifier.js"}},"end":"(?=\\\\{)","patterns":[{"include":"#comment"},{"include":"#class-or-interface-heritage"},{"include":"#type-parameters"},{"include":"#expressionWithoutIdentifiers"},{"captures":{"1":{"name":"entity.name.type.module.js"},"2":{"name":"punctuation.accessor.js"},"3":{"name":"punctuation.accessor.optional.js"}},"match":"([_$[:alpha:]][_$[:alnum:]]*)\\\\s*(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*[[:digit:]])))(?=\\\\s*[_$[:alpha:]][_$[:alnum:]]*(\\\\s*\\\\??\\\\.\\\\s*[_$[:alpha:]][_$[:alnum:]]*)*\\\\s*)"},{"captures":{"1":{"name":"entity.other.inherited-class.js"}},"match":"([_$[:alpha:]][_$[:alnum:]]*)"},{"include":"#expressionPunctuations"}]},"comment":{"patterns":[{"begin":"/\\\\*\\\\*(?!/)","beginCaptures":{"0":{"name":"punctuation.definition.comment.js"}},"end":"\\\\*/","endCaptures":{"0":{"name":"punctuation.definition.comment.js"}},"name":"comment.block.documentation.js","patterns":[{"include":"#docblock"}]},{"begin":"(/\\\\*)(?:\\\\s*((@)internal)(?=\\\\s|(\\\\*/)))?","beginCaptures":{"1":{"name":"punctuation.definition.comment.js"},"2":{"name":"storage.type.internaldeclaration.js"},"3":{"name":"punctuation.decorator.internaldeclaration.js"}},"end":"\\\\*/","endCaptures":{"0":{"name":"punctuation.definition.comment.js"}},"name":"comment.block.js"},{"begin":"(^[ \\\\t]+)?((//)(?:\\\\s*((@)internal)(?=\\\\s|$))?)","beginCaptures":{"1":{"name":"punctuation.whitespace.comment.leading.js"},"2":{"name":"comment.line.double-slash.js"},"3":{"name":"punctuation.definition.comment.js"},"4":{"name":"storage.type.internaldeclaration.js"},"5":{"name":"punctuation.decorator.internaldeclaration.js"}},"contentName":"comment.line.double-slash.js","end":"(?=$)"}]},"control-statement":{"patterns":[{"include":"#switch-statement"},{"include":"#for-loop"},{"match":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(catch|finally|throw|try)(?![_$[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))","name":"keyword.control.trycatch.js"},{"captures":{"1":{"name":"keyword.control.loop.js"},"2":{"name":"entity.name.label.js"}},"match":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(break|continue|goto)\\\\s+([_$[:alpha:]][_$[:alnum:]]*)(?![_$[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))"},{"match":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(break|continue|do|goto|while)(?![_$[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))","name":"keyword.control.loop.js"},{"begin":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(return)(?![_$[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))","beginCaptures":{"0":{"name":"keyword.control.flow.js"}},"end":"(?=[;}]|$|;|^\\\\s*$|(?:^\\\\s*(?:abstract|async|(?:\\\\bawait\\\\s+(?:\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[_$[:alpha:]])\\\\b)\\\\b)|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|(?:\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[_$[:alpha:]])\\\\b)|var|while)\\\\b))","patterns":[{"include":"#expression"}]},{"match":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(case|default|switch)(?![_$[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))","name":"keyword.control.switch.js"},{"include":"#if-statement"},{"match":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(else|if)(?![_$[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))","name":"keyword.control.conditional.js"},{"match":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(with)(?![_$[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))","name":"keyword.control.with.js"},{"match":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(package)(?![_$[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))","name":"keyword.control.js"},{"match":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(debugger)(?![_$[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))","name":"keyword.other.debugger.js"}]},"decl-block":{"begin":"\\\\{","beginCaptures":{"0":{"name":"punctuation.definition.block.js"}},"end":"\\\\}","endCaptures":{"0":{"name":"punctuation.definition.block.js"}},"name":"meta.block.js","patterns":[{"include":"#statements"}]},"declaration":{"patterns":[{"include":"#decorator"},{"include":"#var-expr"},{"include":"#function-declaration"},{"include":"#class-declaration"},{"include":"#interface-declaration"},{"include":"#enum-declaration"},{"include":"#namespace-declaration"},{"include":"#type-alias-declaration"},{"include":"#import-equals-declaration"},{"include":"#import-declaration"},{"include":"#export-declaration"},{"match":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(declare|export)(?![_$[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))","name":"storage.modifier.js"}]},"decorator":{"begin":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))\\\\@","beginCaptures":{"0":{"name":"punctuation.decorator.js"}},"end":"(?=\\\\s)","name":"meta.decorator.js","patterns":[{"include":"#expression"}]},"destructuring-const":{"patterns":[{"begin":"(?<!=|:|^of|[^\\\\._$[:alnum:]]of|^in|[^\\\\._$[:alnum:]]in)\\\\s*(?=\\\\{)","end":"(?=$|^|[;,=}]|((?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+))","name":"meta.object-binding-pattern-variable.js","patterns":[{"include":"#object-binding-pattern-const"},{"include":"#type-annotation"},{"include":"#comment"}]},{"begin":"(?<!=|:|^of|[^\\\\._$[:alnum:]]of|^in|[^\\\\._$[:alnum:]]in)\\\\s*(?=\\\\[)","end":"(?=$|^|[;,=}]|((?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+))","name":"meta.array-binding-pattern-variable.js","patterns":[{"include":"#array-binding-pattern-const"},{"include":"#type-annotation"},{"include":"#comment"}]}]},"destructuring-parameter":{"patterns":[{"begin":"(?<!=|:)\\\\s*(?:(\\\\.\\\\.\\\\.)\\\\s*)?(\\\\{)","beginCaptures":{"1":{"name":"keyword.operator.rest.js"},"2":{"name":"punctuation.definition.binding-pattern.object.js"}},"end":"\\\\}","endCaptures":{"0":{"name":"punctuation.definition.binding-pattern.object.js"}},"name":"meta.parameter.object-binding-pattern.js","patterns":[{"include":"#parameter-object-binding-element"}]},{"begin":"(?<!=|:)\\\\s*(?:(\\\\.\\\\.\\\\.)\\\\s*)?(\\\\[)","beginCaptures":{"1":{"name":"keyword.operator.rest.js"},"2":{"name":"punctuation.definition.binding-pattern.array.js"}},"end":"\\\\]","endCaptures":{"0":{"name":"punctuation.definition.binding-pattern.array.js"}},"name":"meta.paramter.array-binding-pattern.js","patterns":[{"include":"#parameter-binding-element"},{"include":"#punctuation-comma"}]}]},"destructuring-parameter-rest":{"captures":{"1":{"name":"keyword.operator.rest.js"},"2":{"name":"variable.parameter.js"}},"match":"(?:(\\\\.\\\\.\\\\.)\\\\s*)?([_$[:alpha:]][_$[:alnum:]]*)"},"destructuring-variable":{"patterns":[{"begin":"(?<!=|:|^of|[^\\\\._$[:alnum:]]of|^in|[^\\\\._$[:alnum:]]in)\\\\s*(?=\\\\{)","end":"(?=$|^|[;,=}]|((?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+))","name":"meta.object-binding-pattern-variable.js","patterns":[{"include":"#object-binding-pattern"},{"include":"#type-annotation"},{"include":"#comment"}]},{"begin":"(?<!=|:|^of|[^\\\\._$[:alnum:]]of|^in|[^\\\\._$[:alnum:]]in)\\\\s*(?=\\\\[)","end":"(?=$|^|[;,=}]|((?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+))","name":"meta.array-binding-pattern-variable.js","patterns":[{"include":"#array-binding-pattern"},{"include":"#type-annotation"},{"include":"#comment"}]}]},"destructuring-variable-rest":{"captures":{"1":{"name":"keyword.operator.rest.js"},"2":{"name":"meta.definition.variable.js variable.other.readwrite.js"}},"match":"(?:(\\\\.\\\\.\\\\.)\\\\s*)?([_$[:alpha:]][_$[:alnum:]]*)"},"destructuring-variable-rest-const":{"captures":{"1":{"name":"keyword.operator.rest.js"},"2":{"name":"meta.definition.variable.js variable.other.constant.js"}},"match":"(?:(\\\\.\\\\.\\\\.)\\\\s*)?([_$[:alpha:]][_$[:alnum:]]*)"},"directives":{"begin":"^(///)\\\\s*(?=<(reference|amd-dependency|amd-module)(\\\\s+(path|types|no-default-lib|lib|name|resolution-mode)\\\\s*=\\\\s*((\\\\'([^\\\\'\\\\\\\\]|\\\\\\\\.)*\\\\')|(\\\\\\"([^\\\\\\"\\\\\\\\]|\\\\\\\\.)*\\\\\\")|(\\\\\`([^\\\\\`\\\\\\\\]|\\\\\\\\.)*\\\\\`)))+\\\\s*/>\\\\s*$)","beginCaptures":{"1":{"name":"punctuation.definition.comment.js"}},"end":"(?=$)","name":"comment.line.triple-slash.directive.js","patterns":[{"begin":"(<)(reference|amd-dependency|amd-module)","beginCaptures":{"1":{"name":"punctuation.definition.tag.directive.js"},"2":{"name":"entity.name.tag.directive.js"}},"end":"/>","endCaptures":{"0":{"name":"punctuation.definition.tag.directive.js"}},"name":"meta.tag.js","patterns":[{"match":"path|types|no-default-lib|lib|name|resolution-mode","name":"entity.other.attribute-name.directive.js"},{"match":"=","name":"keyword.operator.assignment.js"},{"include":"#string"}]}]},"docblock":{"patterns":[{"captures":{"1":{"name":"storage.type.class.jsdoc"},"2":{"name":"punctuation.definition.block.tag.jsdoc"},"3":{"name":"constant.language.access-type.jsdoc"}},"match":"((@)(?:access|api))\\\\s+(private|protected|public)\\\\b"},{"captures":{"1":{"name":"storage.type.class.jsdoc"},"2":{"name":"punctuation.definition.block.tag.jsdoc"},"3":{"name":"entity.name.type.instance.jsdoc"},"4":{"name":"punctuation.definition.bracket.angle.begin.jsdoc"},"5":{"name":"constant.other.email.link.underline.jsdoc"},"6":{"name":"punctuation.definition.bracket.angle.end.jsdoc"}},"match":"((@)author)\\\\s+([^@\\\\s<>*/](?:[^@<>*/]|\\\\*[^/])*)(?:\\\\s*(<)([^>\\\\s]+)(>))?"},{"captures":{"1":{"name":"storage.type.class.jsdoc"},"2":{"name":"punctuation.definition.block.tag.jsdoc"},"3":{"name":"entity.name.type.instance.jsdoc"},"4":{"name":"keyword.operator.control.jsdoc"},"5":{"name":"entity.name.type.instance.jsdoc"}},"match":"((@)borrows)\\\\s+((?:[^@\\\\s*/]|\\\\*[^/])+)\\\\s+(as)\\\\s+((?:[^@\\\\s*/]|\\\\*[^/])+)"},{"begin":"((@)example)\\\\s+","beginCaptures":{"1":{"name":"storage.type.class.jsdoc"},"2":{"name":"punctuation.definition.block.tag.jsdoc"}},"end":"(?=@|\\\\*/)","name":"meta.example.jsdoc","patterns":[{"match":"^\\\\s\\\\*\\\\s+"},{"begin":"\\\\G(<)caption(>)","beginCaptures":{"0":{"name":"entity.name.tag.inline.jsdoc"},"1":{"name":"punctuation.definition.bracket.angle.begin.jsdoc"},"2":{"name":"punctuation.definition.bracket.angle.end.jsdoc"}},"contentName":"constant.other.description.jsdoc","end":"(</)caption(>)|(?=\\\\*/)","endCaptures":{"0":{"name":"entity.name.tag.inline.jsdoc"},"1":{"name":"punctuation.definition.bracket.angle.begin.jsdoc"},"2":{"name":"punctuation.definition.bracket.angle.end.jsdoc"}}},{"captures":{"0":{"name":"source.embedded.js"}},"match":"[^\\\\s@*](?:[^*]|\\\\*[^/])*"}]},{"captures":{"1":{"name":"storage.type.class.jsdoc"},"2":{"name":"punctuation.definition.block.tag.jsdoc"},"3":{"name":"constant.language.symbol-type.jsdoc"}},"match":"((@)kind)\\\\s+(class|constant|event|external|file|function|member|mixin|module|namespace|typedef)\\\\b"},{"captures":{"1":{"name":"storage.type.class.jsdoc"},"2":{"name":"punctuation.definition.block.tag.jsdoc"},"3":{"name":"variable.other.link.underline.jsdoc"},"4":{"name":"entity.name.type.instance.jsdoc"}},"match":"((@)see)\\\\s+(?:((?=https?://)(?:[^\\\\s*]|\\\\*[^/])+)|((?!https?://|(?:\\\\[[^\\\\[\\\\]]*\\\\])?{@(?:link|linkcode|linkplain|tutorial)\\\\b)(?:[^@\\\\s*/]|\\\\*[^/])+))"},{"captures":{"1":{"name":"storage.type.class.jsdoc"},"2":{"name":"punctuation.definition.block.tag.jsdoc"},"3":{"name":"variable.other.jsdoc"}},"match":"((@)template)\\\\s+([A-Za-z_$][\\\\w$.\\\\[\\\\]]*(?:\\\\s*,\\\\s*[A-Za-z_$][\\\\w$.\\\\[\\\\]]*)*)"},{"begin":"((@)template)\\\\s+(?={)","beginCaptures":{"1":{"name":"storage.type.class.jsdoc"},"2":{"name":"punctuation.definition.block.tag.jsdoc"}},"end":"(?=\\\\s|\\\\*/|[^{}\\\\[\\\\]A-Za-z_$])","patterns":[{"include":"#jsdoctype"},{"match":"([A-Za-z_$][\\\\w$.\\\\[\\\\]]*)","name":"variable.other.jsdoc"}]},{"captures":{"1":{"name":"storage.type.class.jsdoc"},"2":{"name":"punctuation.definition.block.tag.jsdoc"},"3":{"name":"variable.other.jsdoc"}},"match":"((@)(?:arg|argument|const|constant|member|namespace|param|var))\\\\s+([A-Za-z_$][\\\\w$.\\\\[\\\\]]*)"},{"begin":"((@)typedef)\\\\s+(?={)","beginCaptures":{"1":{"name":"storage.type.class.jsdoc"},"2":{"name":"punctuation.definition.block.tag.jsdoc"}},"end":"(?=\\\\s|\\\\*/|[^{}\\\\[\\\\]A-Za-z_$])","patterns":[{"include":"#jsdoctype"},{"match":"(?:[^@\\\\s*/]|\\\\*[^/])+","name":"entity.name.type.instance.jsdoc"}]},{"begin":"((@)(?:arg|argument|const|constant|member|namespace|param|prop|property|var))\\\\s+(?={)","beginCaptures":{"1":{"name":"storage.type.class.jsdoc"},"2":{"name":"punctuation.definition.block.tag.jsdoc"}},"end":"(?=\\\\s|\\\\*/|[^{}\\\\[\\\\]A-Za-z_$])","patterns":[{"include":"#jsdoctype"},{"match":"([A-Za-z_$][\\\\w$.\\\\[\\\\]]*)","name":"variable.other.jsdoc"},{"captures":{"1":{"name":"punctuation.definition.optional-value.begin.bracket.square.jsdoc"},"2":{"name":"keyword.operator.assignment.jsdoc"},"3":{"name":"source.embedded.js"},"4":{"name":"punctuation.definition.optional-value.end.bracket.square.jsdoc"},"5":{"name":"invalid.illegal.syntax.jsdoc"}},"match":"(\\\\[)\\\\s*[\\\\w$]+(?:(?:\\\\[\\\\])?\\\\.[\\\\w$]+)*(?:\\\\s*(=)\\\\s*((?>\\"(?:(?:\\\\*(?!/))|(?:\\\\\\\\(?!\\"))|[^*\\\\\\\\])*?\\"|'(?:(?:\\\\*(?!/))|(?:\\\\\\\\(?!'))|[^*\\\\\\\\])*?'|\\\\[(?:(?:\\\\*(?!/))|[^*])*?\\\\]|(?:(?:\\\\*(?!/))|\\\\s(?!\\\\s*\\\\])|\\\\[.*?(?:\\\\]|(?=\\\\*/))|[^*\\\\s\\\\[\\\\]])*)*))?\\\\s*(?:(\\\\])((?:[^*\\\\s]|\\\\*[^\\\\s/])+)?|(?=\\\\*/))","name":"variable.other.jsdoc"}]},{"begin":"((@)(?:define|enum|exception|export|extends|lends|implements|modifies|namespace|private|protected|returns?|satisfies|suppress|this|throws|type|yields?))\\\\s+(?={)","beginCaptures":{"1":{"name":"storage.type.class.jsdoc"},"2":{"name":"punctuation.definition.block.tag.jsdoc"}},"end":"(?=\\\\s|\\\\*/|[^{}\\\\[\\\\]A-Za-z_$])","patterns":[{"include":"#jsdoctype"}]},{"captures":{"1":{"name":"storage.type.class.jsdoc"},"2":{"name":"punctuation.definition.block.tag.jsdoc"},"3":{"name":"entity.name.type.instance.jsdoc"}},"match":"((@)(?:alias|augments|callback|constructs|emits|event|fires|exports?|extends|external|function|func|host|lends|listens|interface|memberof!?|method|module|mixes|mixin|name|requires|see|this|typedef|uses))\\\\s+((?:[^{}@\\\\s*]|\\\\*[^/])+)"},{"begin":"((@)(?:default(?:value)?|license|version))\\\\s+(([''\\"]))","beginCaptures":{"1":{"name":"storage.type.class.jsdoc"},"2":{"name":"punctuation.definition.block.tag.jsdoc"},"3":{"name":"variable.other.jsdoc"},"4":{"name":"punctuation.definition.string.begin.jsdoc"}},"contentName":"variable.other.jsdoc","end":"(\\\\3)|(?=$|\\\\*/)","endCaptures":{"0":{"name":"variable.other.jsdoc"},"1":{"name":"punctuation.definition.string.end.jsdoc"}}},{"captures":{"1":{"name":"storage.type.class.jsdoc"},"2":{"name":"punctuation.definition.block.tag.jsdoc"},"3":{"name":"variable.other.jsdoc"}},"match":"((@)(?:default(?:value)?|license|tutorial|variation|version))\\\\s+([^\\\\s*]+)"},{"captures":{"1":{"name":"punctuation.definition.block.tag.jsdoc"}},"match":"(@)(?:abstract|access|alias|api|arg|argument|async|attribute|augments|author|beta|borrows|bubbles|callback|chainable|class|classdesc|code|config|const|constant|constructor|constructs|copyright|default|defaultvalue|define|deprecated|desc|description|dict|emits|enum|event|example|exception|exports?|extends|extension(?:_?for)?|external|externs|file|fileoverview|final|fires|for|func|function|generator|global|hideconstructor|host|ignore|implements|implicitCast|inherit[Dd]oc|inner|instance|interface|internal|kind|lends|license|listens|main|member|memberof!?|method|mixes|mixins?|modifies|module|name|namespace|noalias|nocollapse|nocompile|nosideeffects|override|overview|package|param|polymer(?:Behavior)?|preserve|private|prop|property|protected|public|read[Oo]nly|record|require[ds]|returns?|see|since|static|struct|submodule|summary|suppress|template|this|throws|todo|tutorial|type|typedef|unrestricted|uses|var|variation|version|virtual|writeOnce|yields?)\\\\b","name":"storage.type.class.jsdoc"},{"include":"#inline-tags"},{"captures":{"1":{"name":"storage.type.class.jsdoc"},"2":{"name":"punctuation.definition.block.tag.jsdoc"}},"match":"((@)(?:[_$[:alpha:]][_$[:alnum:]]*))(?=\\\\s+)"}]},"enum-declaration":{"begin":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(\\\\bexport)\\\\s+)?(?:(\\\\bdeclare)\\\\s+)?(?:\\\\b(const)\\\\s+)?\\\\b(enum)\\\\s+([_$[:alpha:]][_$[:alnum:]]*)","beginCaptures":{"1":{"name":"keyword.control.export.js"},"2":{"name":"storage.modifier.js"},"3":{"name":"storage.modifier.js"},"4":{"name":"storage.type.enum.js"},"5":{"name":"entity.name.type.enum.js"}},"end":"(?<=\\\\})","name":"meta.enum.declaration.js","patterns":[{"include":"#comment"},{"begin":"\\\\{","beginCaptures":{"0":{"name":"punctuation.definition.block.js"}},"end":"\\\\}","endCaptures":{"0":{"name":"punctuation.definition.block.js"}},"patterns":[{"include":"#comment"},{"begin":"([_$[:alpha:]][_$[:alnum:]]*)","beginCaptures":{"0":{"name":"variable.other.enummember.js"}},"end":"(?=,|\\\\}|$)","patterns":[{"include":"#comment"},{"include":"#variable-initializer"}]},{"begin":"(?=((\\\\'([^\\\\'\\\\\\\\]|\\\\\\\\.)*\\\\')|(\\\\\\"([^\\\\\\"\\\\\\\\]|\\\\\\\\.)*\\\\\\")|(\\\\\`([^\\\\\`\\\\\\\\]|\\\\\\\\.)*\\\\\`)|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])+\\\\])))","end":"(?=,|\\\\}|$)","patterns":[{"include":"#string"},{"include":"#array-literal"},{"include":"#comment"},{"include":"#variable-initializer"}]},{"include":"#punctuation-comma"}]}]},"export-declaration":{"patterns":[{"captures":{"1":{"name":"keyword.control.export.js"},"2":{"name":"keyword.control.as.js"},"3":{"name":"storage.type.namespace.js"},"4":{"name":"entity.name.type.module.js"}},"match":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(export)\\\\s+(as)\\\\s+(namespace)\\\\s+([_$[:alpha:]][_$[:alnum:]]*)"},{"begin":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(export)(?:\\\\s+(type))?(?:(?:\\\\s*(=))|(?:\\\\s+(default)(?=\\\\s+)))","beginCaptures":{"1":{"name":"keyword.control.export.js"},"2":{"name":"keyword.control.type.js"},"3":{"name":"keyword.operator.assignment.js"},"4":{"name":"keyword.control.default.js"}},"end":"(?=$|;|^\\\\s*$|(?:^\\\\s*(?:abstract|async|(?:\\\\bawait\\\\s+(?:\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[_$[:alpha:]])\\\\b)\\\\b)|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|(?:\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[_$[:alpha:]])\\\\b)|var|while)\\\\b))","name":"meta.export.default.js","patterns":[{"include":"#interface-declaration"},{"include":"#expression"}]},{"begin":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(export)(?:\\\\s+(type))?\\\\b(?!(\\\\$)|(\\\\s*:))((?=\\\\s*[\\\\{*])|((?=\\\\s*[_$[:alpha:]][_$[:alnum:]]*(\\\\s|,))(?!\\\\s*(?:abstract|async|(?:\\\\bawait\\\\s+(?:\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[_$[:alpha:]])\\\\b)\\\\b)|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|(?:\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[_$[:alpha:]])\\\\b)|var|while)\\\\b)))","beginCaptures":{"1":{"name":"keyword.control.export.js"},"2":{"name":"keyword.control.type.js"}},"end":"(?=$|;|^\\\\s*$|(?:^\\\\s*(?:abstract|async|(?:\\\\bawait\\\\s+(?:\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[_$[:alpha:]])\\\\b)\\\\b)|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|(?:\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[_$[:alpha:]])\\\\b)|var|while)\\\\b))","name":"meta.export.js","patterns":[{"include":"#import-export-declaration"}]}]},"expression":{"patterns":[{"include":"#expressionWithoutIdentifiers"},{"include":"#identifiers"},{"include":"#expressionPunctuations"}]},"expression-inside-possibly-arrow-parens":{"patterns":[{"include":"#expressionWithoutIdentifiers"},{"include":"#comment"},{"include":"#string"},{"include":"#decorator"},{"include":"#destructuring-parameter"},{"captures":{"1":{"name":"storage.modifier.js"}},"match":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(override|public|protected|private|readonly)\\\\s+(?=(override|public|protected|private|readonly)\\\\s+)"},{"captures":{"1":{"name":"storage.modifier.js"},"2":{"name":"keyword.operator.rest.js"},"3":{"name":"entity.name.function.js variable.language.this.js"},"4":{"name":"entity.name.function.js"},"5":{"name":"keyword.operator.optional.js"}},"match":"(?:(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(override|public|private|protected|readonly)\\\\s+)?(?:(\\\\.\\\\.\\\\.)\\\\s*)?(?<!=|:)(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(this)|([_$[:alpha:]][_$[:alnum:]]*))(?![_$[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\\\\s*(\\\\??)(?=\\\\s*(=\\\\s*(((async\\\\s+)?((function\\\\s*[(<*])|(function\\\\s+)|([_$[:alpha:]][_$[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*$)|([\\\\(]\\\\s*((([\\\\{\\\\[]\\\\s*)?$)|((\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})\\\\s*((:\\\\s*\\\\{?$)|((\\\\s*([^<>\\\\(\\\\)\\\\{\\\\}]|\\\\<([^<>]|\\\\<([^<>]|\\\\<[^<>]+\\\\>)+\\\\>)+\\\\>|\\\\([^\\\\(\\\\)]+\\\\)|\\\\{[^\\\\{\\\\}]+\\\\})+\\\\s*)?=\\\\s*)))|((\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\])\\\\s*((:\\\\s*\\\\[?$)|((\\\\s*([^<>\\\\(\\\\)\\\\{\\\\}]|\\\\<([^<>]|\\\\<([^<>]|\\\\<[^<>]+\\\\>)+\\\\>)+\\\\>|\\\\([^\\\\(\\\\)]+\\\\)|\\\\{[^\\\\{\\\\}]+\\\\})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<]|\\\\<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<]|\\\\<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<])*\\\\>)*\\\\>)*>\\\\s*)?[(]\\\\s*(\\\\/\\\\*([^\\\\*]|(\\\\*[^\\\\/]))*\\\\*\\\\/\\\\s*)*(([)]\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[_$[:alpha:]][_$[:alnum:]]*\\\\s*:)))|([<]\\\\s*[_$[:alpha:]][_$[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<]|\\\\<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<]|\\\\<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<])*\\\\>)*\\\\>)*>\\\\s*)?\\\\(\\\\s*(\\\\/\\\\*([^\\\\*]|(\\\\*[^\\\\/]))*\\\\*\\\\/\\\\s*)*(([_$[:alpha:]]|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\])|(\\\\.\\\\.\\\\.\\\\s*[_$[:alpha:]]))([^()\\\\'\\\\\\"\\\\\`]|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\'([^\\\\'\\\\\\\\]|\\\\\\\\.)*\\\\')|(\\\\\\"([^\\\\\\"\\\\\\\\]|\\\\\\\\.)*\\\\\\")|(\\\\\`([^\\\\\`\\\\\\\\]|\\\\\\\\.)*\\\\\`))*)?\\\\)(\\\\s*:\\\\s*([^<>\\\\(\\\\)\\\\{\\\\}]|\\\\<([^<>]|\\\\<([^<>]|\\\\<[^<>]+\\\\>)+\\\\>)+\\\\>|\\\\([^\\\\(\\\\)]+\\\\)|\\\\{[^\\\\{\\\\}]+\\\\})+)?\\\\s*=>)))))|(:\\\\s*((<)|([(]\\\\s*(([)])|(\\\\.\\\\.\\\\.)|([_$[:alnum:]]+\\\\s*(([:,?=])|([)]\\\\s*=>)))))))|(:\\\\s*(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))Function(?![_$[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|(:\\\\s*((<\\\\s*$)|([\\\\(]\\\\s*((([\\\\{\\\\[]\\\\s*)?$)|((\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})\\\\s*((:\\\\s*\\\\{?$)|((\\\\s*([^<>\\\\(\\\\)\\\\{\\\\}]|\\\\<([^<>]|\\\\<([^<>]|\\\\<[^<>]+\\\\>)+\\\\>)+\\\\>|\\\\([^\\\\(\\\\)]+\\\\)|\\\\{[^\\\\{\\\\}]+\\\\})+\\\\s*)?=\\\\s*)))|((\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\])\\\\s*((:\\\\s*\\\\[?$)|((\\\\s*([^<>\\\\(\\\\)\\\\{\\\\}]|\\\\<([^<>]|\\\\<([^<>]|\\\\<[^<>]+\\\\>)+\\\\>)+\\\\>|\\\\([^\\\\(\\\\)]+\\\\)|\\\\{[^\\\\{\\\\}]+\\\\})+\\\\s*)?=\\\\s*)))))))|(:\\\\s*(=>|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(<[^<>]*>)|[^<>(),=])+=\\\\s*(((async\\\\s+)?((function\\\\s*[(<*])|(function\\\\s+)|([_$[:alpha:]][_$[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*$)|([\\\\(]\\\\s*((([\\\\{\\\\[]\\\\s*)?$)|((\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})\\\\s*((:\\\\s*\\\\{?$)|((\\\\s*([^<>\\\\(\\\\)\\\\{\\\\}]|\\\\<([^<>]|\\\\<([^<>]|\\\\<[^<>]+\\\\>)+\\\\>)+\\\\>|\\\\([^\\\\(\\\\)]+\\\\)|\\\\{[^\\\\{\\\\}]+\\\\})+\\\\s*)?=\\\\s*)))|((\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\])\\\\s*((:\\\\s*\\\\[?$)|((\\\\s*([^<>\\\\(\\\\)\\\\{\\\\}]|\\\\<([^<>]|\\\\<([^<>]|\\\\<[^<>]+\\\\>)+\\\\>)+\\\\>|\\\\([^\\\\(\\\\)]+\\\\)|\\\\{[^\\\\{\\\\}]+\\\\})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<]|\\\\<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<]|\\\\<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<])*\\\\>)*\\\\>)*>\\\\s*)?[(]\\\\s*(\\\\/\\\\*([^\\\\*]|(\\\\*[^\\\\/]))*\\\\*\\\\/\\\\s*)*(([)]\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[_$[:alpha:]][_$[:alnum:]]*\\\\s*:)))|([<]\\\\s*[_$[:alpha:]][_$[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<]|\\\\<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<]|\\\\<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<])*\\\\>)*\\\\>)*>\\\\s*)?\\\\(\\\\s*(\\\\/\\\\*([^\\\\*]|(\\\\*[^\\\\/]))*\\\\*\\\\/\\\\s*)*(([_$[:alpha:]]|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\])|(\\\\.\\\\.\\\\.\\\\s*[_$[:alpha:]]))([^()\\\\'\\\\\\"\\\\\`]|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\'([^\\\\'\\\\\\\\]|\\\\\\\\.)*\\\\')|(\\\\\\"([^\\\\\\"\\\\\\\\]|\\\\\\\\.)*\\\\\\")|(\\\\\`([^\\\\\`\\\\\\\\]|\\\\\\\\.)*\\\\\`))*)?\\\\)(\\\\s*:\\\\s*([^<>\\\\(\\\\)\\\\{\\\\}]|\\\\<([^<>]|\\\\<([^<>]|\\\\<[^<>]+\\\\>)+\\\\>)+\\\\>|\\\\([^\\\\(\\\\)]+\\\\)|\\\\{[^\\\\{\\\\}]+\\\\})+)?\\\\s*=>))))))"},{"captures":{"1":{"name":"storage.modifier.js"},"2":{"name":"keyword.operator.rest.js"},"3":{"name":"variable.parameter.js variable.language.this.js"},"4":{"name":"variable.parameter.js"},"5":{"name":"keyword.operator.optional.js"}},"match":"(?:(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(override|public|private|protected|readonly)\\\\s+)?(?:(\\\\.\\\\.\\\\.)\\\\s*)?(?<!=|:)(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(this)|([_$[:alpha:]][_$[:alnum:]]*))(?![_$[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\\\\s*(\\\\??)(?=\\\\s*[:,]|$)"},{"include":"#type-annotation"},{"include":"#variable-initializer"},{"match":",","name":"punctuation.separator.parameter.js"},{"include":"#identifiers"},{"include":"#expressionPunctuations"}]},"expression-operators":{"patterns":[{"match":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(await)(?![_$[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))","name":"keyword.control.flow.js"},{"begin":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(yield)(?![_$[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))(?=\\\\s*\\\\/\\\\*([^\\\\*]|(\\\\*[^\\\\/]))*\\\\*\\\\/\\\\s*\\\\*)","beginCaptures":{"1":{"name":"keyword.control.flow.js"}},"end":"\\\\*","endCaptures":{"0":{"name":"keyword.generator.asterisk.js"}},"patterns":[{"include":"#comment"}]},{"captures":{"1":{"name":"keyword.control.flow.js"},"2":{"name":"keyword.generator.asterisk.js"}},"match":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(yield)(?![_$[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))(?:\\\\s*(\\\\*))?"},{"match":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))delete(?![_$[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))","name":"keyword.operator.expression.delete.js"},{"match":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))in(?![_$[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))(?!\\\\()","name":"keyword.operator.expression.in.js"},{"match":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))of(?![_$[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))(?!\\\\()","name":"keyword.operator.expression.of.js"},{"match":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))instanceof(?![_$[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))","name":"keyword.operator.expression.instanceof.js"},{"match":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))new(?![_$[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))","name":"keyword.operator.new.js"},{"include":"#typeof-operator"},{"match":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))void(?![_$[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))","name":"keyword.operator.expression.void.js"},{"captures":{"1":{"name":"keyword.control.as.js"},"2":{"name":"storage.modifier.js"}},"match":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(as)\\\\s+(const)(?=\\\\s*($|[;,:})\\\\]]))"},{"begin":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(as)|(satisfies))\\\\s+","beginCaptures":{"1":{"name":"keyword.control.as.js"},"2":{"name":"keyword.control.satisfies.js"}},"end":"(?=^|[;),}\\\\]:?\\\\-\\\\+\\\\>]|\\\\|\\\\||\\\\&\\\\&|\\\\!\\\\=\\\\=|$|((?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(as|satisfies)\\\\s+)|(\\\\s+\\\\<))","patterns":[{"include":"#type"}]},{"match":"\\\\.\\\\.\\\\.","name":"keyword.operator.spread.js"},{"match":"\\\\*=|(?<!\\\\()/=|%=|\\\\+=|\\\\-=","name":"keyword.operator.assignment.compound.js"},{"match":"\\\\&=|\\\\^=|<<=|>>=|>>>=|\\\\|=","name":"keyword.operator.assignment.compound.bitwise.js"},{"match":"<<|>>>|>>","name":"keyword.operator.bitwise.shift.js"},{"match":"===|!==|==|!=","name":"keyword.operator.comparison.js"},{"match":"<=|>=|<>|<|>","name":"keyword.operator.relational.js"},{"captures":{"1":{"name":"keyword.operator.logical.js"},"2":{"name":"keyword.operator.assignment.compound.js"},"3":{"name":"keyword.operator.arithmetic.js"}},"match":"(?<=[_$[:alnum:]])(\\\\!)\\\\s*(?:(/=)|(?:(/)(?![/*])))"},{"match":"\\\\!|&&|\\\\|\\\\||\\\\?\\\\?","name":"keyword.operator.logical.js"},{"match":"\\\\&|~|\\\\^|\\\\|","name":"keyword.operator.bitwise.js"},{"match":"\\\\=","name":"keyword.operator.assignment.js"},{"match":"--","name":"keyword.operator.decrement.js"},{"match":"\\\\+\\\\+","name":"keyword.operator.increment.js"},{"match":"%|\\\\*|/|-|\\\\+","name":"keyword.operator.arithmetic.js"},{"begin":"(?<=[_$[:alnum:])\\\\]])\\\\s*(?=(\\\\/\\\\*([^\\\\*]|(\\\\*[^\\\\/]))*\\\\*\\\\/\\\\s*)+(?:(/=)|(?:(/)(?![/*]))))","end":"(?:(/=)|(?:(/)(?!\\\\*([^\\\\*]|(\\\\*[^\\\\/]))*\\\\*\\\\/)))","endCaptures":{"1":{"name":"keyword.operator.assignment.compound.js"},"2":{"name":"keyword.operator.arithmetic.js"}},"patterns":[{"include":"#comment"}]},{"captures":{"1":{"name":"keyword.operator.assignment.compound.js"},"2":{"name":"keyword.operator.arithmetic.js"}},"match":"(?<=[_$[:alnum:])\\\\]])\\\\s*(?:(/=)|(?:(/)(?![/*])))"}]},"expressionPunctuations":{"patterns":[{"include":"#punctuation-comma"},{"include":"#punctuation-accessor"}]},"expressionWithoutIdentifiers":{"patterns":[{"include":"#jsx"},{"include":"#string"},{"include":"#regex"},{"include":"#comment"},{"include":"#function-expression"},{"include":"#class-expression"},{"include":"#arrow-function"},{"include":"#paren-expression-possibly-arrow"},{"include":"#cast"},{"include":"#ternary-expression"},{"include":"#new-expr"},{"include":"#instanceof-expr"},{"include":"#object-literal"},{"include":"#expression-operators"},{"include":"#function-call"},{"include":"#literal"},{"include":"#support-objects"},{"include":"#paren-expression"}]},"field-declaration":{"begin":"(?<!\\\\()(?:(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(readonly)\\\\s+)?(?=\\\\s*((\\\\b(?<!\\\\$)0(?:x|X)[0-9a-fA-F][0-9a-fA-F_]*(n)?\\\\b(?!\\\\$))|(\\\\b(?<!\\\\$)0(?:b|B)[01][01_]*(n)?\\\\b(?!\\\\$))|(\\\\b(?<!\\\\$)0(?:o|O)?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[eE][+-]?[0-9][0-9_]*(n)?\\\\b)|(?:\\\\b[0-9][0-9_]*(\\\\.)[eE][+-]?[0-9][0-9_]*(n)?\\\\b)|(?:\\\\B(\\\\.)[0-9][0-9_]*[eE][+-]?[0-9][0-9_]*(n)?\\\\b)|(?:\\\\b[0-9][0-9_]*[eE][+-]?[0-9][0-9_]*(n)?\\\\b)|(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b)|(?:\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B)|(?:\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b)|(?:\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.)))(?!\\\\$))|(\\\\#?[_$[:alpha:]][_$[:alnum:]]*)|(\\\\'([^\\\\'\\\\\\\\]|\\\\\\\\.)*\\\\')|(\\\\\\"([^\\\\\\"\\\\\\\\]|\\\\\\\\.)*\\\\\\")|(\\\\\`([^\\\\\`\\\\\\\\]|\\\\\\\\.)*\\\\\`)|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])+\\\\]))\\\\s*(?:(?:(\\\\?)|(\\\\!))\\\\s*)?(=|:|;|,|\\\\}|$))","beginCaptures":{"1":{"name":"storage.modifier.js"}},"end":"(?=\\\\}|;|,|$|(^(?!\\\\s*((\\\\b(?<!\\\\$)0(?:x|X)[0-9a-fA-F][0-9a-fA-F_]*(n)?\\\\b(?!\\\\$))|(\\\\b(?<!\\\\$)0(?:b|B)[01][01_]*(n)?\\\\b(?!\\\\$))|(\\\\b(?<!\\\\$)0(?:o|O)?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[eE][+-]?[0-9][0-9_]*(n)?\\\\b)|(?:\\\\b[0-9][0-9_]*(\\\\.)[eE][+-]?[0-9][0-9_]*(n)?\\\\b)|(?:\\\\B(\\\\.)[0-9][0-9_]*[eE][+-]?[0-9][0-9_]*(n)?\\\\b)|(?:\\\\b[0-9][0-9_]*[eE][+-]?[0-9][0-9_]*(n)?\\\\b)|(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b)|(?:\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B)|(?:\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b)|(?:\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.)))(?!\\\\$))|(\\\\#?[_$[:alpha:]][_$[:alnum:]]*)|(\\\\'([^\\\\'\\\\\\\\]|\\\\\\\\.)*\\\\')|(\\\\\\"([^\\\\\\"\\\\\\\\]|\\\\\\\\.)*\\\\\\")|(\\\\\`([^\\\\\`\\\\\\\\]|\\\\\\\\.)*\\\\\`)|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])+\\\\]))\\\\s*(?:(?:(\\\\?)|(\\\\!))\\\\s*)?(=|:|;|,|$))))|(?<=\\\\})","name":"meta.field.declaration.js","patterns":[{"include":"#variable-initializer"},{"include":"#type-annotation"},{"include":"#string"},{"include":"#array-literal"},{"include":"#numeric-literal"},{"include":"#comment"},{"captures":{"1":{"name":"meta.definition.property.js entity.name.function.js"},"2":{"name":"keyword.operator.optional.js"},"3":{"name":"keyword.operator.definiteassignment.js"}},"match":"(\\\\#?[_$[:alpha:]][_$[:alnum:]]*)(?:(\\\\?)|(\\\\!))?(?=\\\\s*\\\\s*(=\\\\s*(((async\\\\s+)?((function\\\\s*[(<*])|(function\\\\s+)|([_$[:alpha:]][_$[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*$)|([\\\\(]\\\\s*((([\\\\{\\\\[]\\\\s*)?$)|((\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})\\\\s*((:\\\\s*\\\\{?$)|((\\\\s*([^<>\\\\(\\\\)\\\\{\\\\}]|\\\\<([^<>]|\\\\<([^<>]|\\\\<[^<>]+\\\\>)+\\\\>)+\\\\>|\\\\([^\\\\(\\\\)]+\\\\)|\\\\{[^\\\\{\\\\}]+\\\\})+\\\\s*)?=\\\\s*)))|((\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\])\\\\s*((:\\\\s*\\\\[?$)|((\\\\s*([^<>\\\\(\\\\)\\\\{\\\\}]|\\\\<([^<>]|\\\\<([^<>]|\\\\<[^<>]+\\\\>)+\\\\>)+\\\\>|\\\\([^\\\\(\\\\)]+\\\\)|\\\\{[^\\\\{\\\\}]+\\\\})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<]|\\\\<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<]|\\\\<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<])*\\\\>)*\\\\>)*>\\\\s*)?[(]\\\\s*(\\\\/\\\\*([^\\\\*]|(\\\\*[^\\\\/]))*\\\\*\\\\/\\\\s*)*(([)]\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[_$[:alpha:]][_$[:alnum:]]*\\\\s*:)))|([<]\\\\s*[_$[:alpha:]][_$[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<]|\\\\<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<]|\\\\<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<])*\\\\>)*\\\\>)*>\\\\s*)?\\\\(\\\\s*(\\\\/\\\\*([^\\\\*]|(\\\\*[^\\\\/]))*\\\\*\\\\/\\\\s*)*(([_$[:alpha:]]|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\])|(\\\\.\\\\.\\\\.\\\\s*[_$[:alpha:]]))([^()\\\\'\\\\\\"\\\\\`]|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\'([^\\\\'\\\\\\\\]|\\\\\\\\.)*\\\\')|(\\\\\\"([^\\\\\\"\\\\\\\\]|\\\\\\\\.)*\\\\\\")|(\\\\\`([^\\\\\`\\\\\\\\]|\\\\\\\\.)*\\\\\`))*)?\\\\)(\\\\s*:\\\\s*([^<>\\\\(\\\\)\\\\{\\\\}]|\\\\<([^<>]|\\\\<([^<>]|\\\\<[^<>]+\\\\>)+\\\\>)+\\\\>|\\\\([^\\\\(\\\\)]+\\\\)|\\\\{[^\\\\{\\\\}]+\\\\})+)?\\\\s*=>)))))|(:\\\\s*((<)|([(]\\\\s*(([)])|(\\\\.\\\\.\\\\.)|([_$[:alnum:]]+\\\\s*(([:,?=])|([)]\\\\s*=>)))))))|(:\\\\s*(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))Function(?![_$[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|(:\\\\s*((<\\\\s*$)|([\\\\(]\\\\s*((([\\\\{\\\\[]\\\\s*)?$)|((\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})\\\\s*((:\\\\s*\\\\{?$)|((\\\\s*([^<>\\\\(\\\\)\\\\{\\\\}]|\\\\<([^<>]|\\\\<([^<>]|\\\\<[^<>]+\\\\>)+\\\\>)+\\\\>|\\\\([^\\\\(\\\\)]+\\\\)|\\\\{[^\\\\{\\\\}]+\\\\})+\\\\s*)?=\\\\s*)))|((\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\])\\\\s*((:\\\\s*\\\\[?$)|((\\\\s*([^<>\\\\(\\\\)\\\\{\\\\}]|\\\\<([^<>]|\\\\<([^<>]|\\\\<[^<>]+\\\\>)+\\\\>)+\\\\>|\\\\([^\\\\(\\\\)]+\\\\)|\\\\{[^\\\\{\\\\}]+\\\\})+\\\\s*)?=\\\\s*)))))))|(:\\\\s*(=>|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(<[^<>]*>)|[^<>(),=])+=\\\\s*(((async\\\\s+)?((function\\\\s*[(<*])|(function\\\\s+)|([_$[:alpha:]][_$[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*$)|([\\\\(]\\\\s*((([\\\\{\\\\[]\\\\s*)?$)|((\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})\\\\s*((:\\\\s*\\\\{?$)|((\\\\s*([^<>\\\\(\\\\)\\\\{\\\\}]|\\\\<([^<>]|\\\\<([^<>]|\\\\<[^<>]+\\\\>)+\\\\>)+\\\\>|\\\\([^\\\\(\\\\)]+\\\\)|\\\\{[^\\\\{\\\\}]+\\\\})+\\\\s*)?=\\\\s*)))|((\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\])\\\\s*((:\\\\s*\\\\[?$)|((\\\\s*([^<>\\\\(\\\\)\\\\{\\\\}]|\\\\<([^<>]|\\\\<([^<>]|\\\\<[^<>]+\\\\>)+\\\\>)+\\\\>|\\\\([^\\\\(\\\\)]+\\\\)|\\\\{[^\\\\{\\\\}]+\\\\})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<]|\\\\<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<]|\\\\<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<])*\\\\>)*\\\\>)*>\\\\s*)?[(]\\\\s*(\\\\/\\\\*([^\\\\*]|(\\\\*[^\\\\/]))*\\\\*\\\\/\\\\s*)*(([)]\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[_$[:alpha:]][_$[:alnum:]]*\\\\s*:)))|([<]\\\\s*[_$[:alpha:]][_$[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<]|\\\\<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<]|\\\\<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<])*\\\\>)*\\\\>)*>\\\\s*)?\\\\(\\\\s*(\\\\/\\\\*([^\\\\*]|(\\\\*[^\\\\/]))*\\\\*\\\\/\\\\s*)*(([_$[:alpha:]]|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\])|(\\\\.\\\\.\\\\.\\\\s*[_$[:alpha:]]))([^()\\\\'\\\\\\"\\\\\`]|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\'([^\\\\'\\\\\\\\]|\\\\\\\\.)*\\\\')|(\\\\\\"([^\\\\\\"\\\\\\\\]|\\\\\\\\.)*\\\\\\")|(\\\\\`([^\\\\\`\\\\\\\\]|\\\\\\\\.)*\\\\\`))*)?\\\\)(\\\\s*:\\\\s*([^<>\\\\(\\\\)\\\\{\\\\}]|\\\\<([^<>]|\\\\<([^<>]|\\\\<[^<>]+\\\\>)+\\\\>)+\\\\>|\\\\([^\\\\(\\\\)]+\\\\)|\\\\{[^\\\\{\\\\}]+\\\\})+)?\\\\s*=>))))))"},{"match":"\\\\#?[_$[:alpha:]][_$[:alnum:]]*","name":"meta.definition.property.js variable.object.property.js"},{"match":"\\\\?","name":"keyword.operator.optional.js"},{"match":"\\\\!","name":"keyword.operator.definiteassignment.js"}]},"for-loop":{"begin":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))for(?=((\\\\s+|(\\\\s*\\\\/\\\\*([^\\\\*]|(\\\\*[^\\\\/]))*\\\\*\\\\/\\\\s*))await)?\\\\s*(\\\\/\\\\*([^\\\\*]|(\\\\*[^\\\\/]))*\\\\*\\\\/\\\\s*)?(\\\\())","beginCaptures":{"0":{"name":"keyword.control.loop.js"}},"end":"(?<=\\\\))","patterns":[{"include":"#comment"},{"match":"await","name":"keyword.control.loop.js"},{"begin":"\\\\(","beginCaptures":{"0":{"name":"meta.brace.round.js"}},"end":"\\\\)","endCaptures":{"0":{"name":"meta.brace.round.js"}},"patterns":[{"include":"#var-expr"},{"include":"#expression"},{"include":"#punctuation-semicolon"}]}]},"function-body":{"patterns":[{"include":"#comment"},{"include":"#type-parameters"},{"include":"#function-parameters"},{"include":"#return-type"},{"include":"#type-function-return-type"},{"include":"#decl-block"},{"match":"\\\\*","name":"keyword.generator.asterisk.js"}]},"function-call":{"patterns":[{"begin":"(?=(((([_$[:alpha:]][_$[:alnum:]]*)(\\\\s*\\\\??\\\\.\\\\s*(\\\\#?[_$[:alpha:]][_$[:alnum:]]*))*)|(\\\\??\\\\.\\\\s*\\\\#?[_$[:alpha:]][_$[:alnum:]]*))|(?<=[\\\\)]))\\\\s*(?:(\\\\?\\\\.\\\\s*)|(\\\\!))?((<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([_$[:alpha:]][_$[:alnum:]]*|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\])|(\\\\'([^\\\\'\\\\\\\\]|\\\\\\\\.)*\\\\')|(\\\\\\"([^\\\\\\"\\\\\\\\]|\\\\\\\\.)*\\\\\\")|(\\\\\`([^\\\\\`\\\\\\\\]|\\\\\\\\.)*\\\\\`))(?=\\\\s*([\\\\<\\\\>\\\\,\\\\.\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^<>\\\\(]|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(?<==)\\\\>|\\\\<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([_$[:alpha:]][_$[:alnum:]]*|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\])|(\\\\'([^\\\\'\\\\\\\\]|\\\\\\\\.)*\\\\')|(\\\\\\"([^\\\\\\"\\\\\\\\]|\\\\\\\\.)*\\\\\\")|(\\\\\`([^\\\\\`\\\\\\\\]|\\\\\\\\.)*\\\\\`))(?=\\\\s*([\\\\<\\\\>\\\\,\\\\.\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))(([^<>\\\\(]|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(?<==)\\\\>|\\\\<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([_$[:alpha:]][_$[:alnum:]]*|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\])|(\\\\'([^\\\\'\\\\\\\\]|\\\\\\\\.)*\\\\')|(\\\\\\"([^\\\\\\"\\\\\\\\]|\\\\\\\\.)*\\\\\\")|(\\\\\`([^\\\\\`\\\\\\\\]|\\\\\\\\.)*\\\\\`))(?=\\\\s*([\\\\<\\\\>\\\\,\\\\.\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^<>\\\\(]|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(?<==)\\\\>)*(?<!=)\\\\>))*(?<!=)\\\\>)*(?<!=)>\\\\s*)?\\\\())","end":"(?<=\\\\))(?!(((([_$[:alpha:]][_$[:alnum:]]*)(\\\\s*\\\\??\\\\.\\\\s*(\\\\#?[_$[:alpha:]][_$[:alnum:]]*))*)|(\\\\??\\\\.\\\\s*\\\\#?[_$[:alpha:]][_$[:alnum:]]*))|(?<=[\\\\)]))\\\\s*(?:(\\\\?\\\\.\\\\s*)|(\\\\!))?((<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([_$[:alpha:]][_$[:alnum:]]*|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\])|(\\\\'([^\\\\'\\\\\\\\]|\\\\\\\\.)*\\\\')|(\\\\\\"([^\\\\\\"\\\\\\\\]|\\\\\\\\.)*\\\\\\")|(\\\\\`([^\\\\\`\\\\\\\\]|\\\\\\\\.)*\\\\\`))(?=\\\\s*([\\\\<\\\\>\\\\,\\\\.\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^<>\\\\(]|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(?<==)\\\\>|\\\\<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([_$[:alpha:]][_$[:alnum:]]*|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\])|(\\\\'([^\\\\'\\\\\\\\]|\\\\\\\\.)*\\\\')|(\\\\\\"([^\\\\\\"\\\\\\\\]|\\\\\\\\.)*\\\\\\")|(\\\\\`([^\\\\\`\\\\\\\\]|\\\\\\\\.)*\\\\\`))(?=\\\\s*([\\\\<\\\\>\\\\,\\\\.\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))(([^<>\\\\(]|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(?<==)\\\\>|\\\\<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([_$[:alpha:]][_$[:alnum:]]*|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\])|(\\\\'([^\\\\'\\\\\\\\]|\\\\\\\\.)*\\\\')|(\\\\\\"([^\\\\\\"\\\\\\\\]|\\\\\\\\.)*\\\\\\")|(\\\\\`([^\\\\\`\\\\\\\\]|\\\\\\\\.)*\\\\\`))(?=\\\\s*([\\\\<\\\\>\\\\,\\\\.\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^<>\\\\(]|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(?<==)\\\\>)*(?<!=)\\\\>))*(?<!=)\\\\>)*(?<!=)>\\\\s*)?\\\\())","patterns":[{"begin":"(?=(([_$[:alpha:]][_$[:alnum:]]*)(\\\\s*\\\\??\\\\.\\\\s*(\\\\#?[_$[:alpha:]][_$[:alnum:]]*))*)|(\\\\??\\\\.\\\\s*\\\\#?[_$[:alpha:]][_$[:alnum:]]*))","end":"(?=\\\\s*(?:(\\\\?\\\\.\\\\s*)|(\\\\!))?((<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([_$[:alpha:]][_$[:alnum:]]*|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\])|(\\\\'([^\\\\'\\\\\\\\]|\\\\\\\\.)*\\\\')|(\\\\\\"([^\\\\\\"\\\\\\\\]|\\\\\\\\.)*\\\\\\")|(\\\\\`([^\\\\\`\\\\\\\\]|\\\\\\\\.)*\\\\\`))(?=\\\\s*([\\\\<\\\\>\\\\,\\\\.\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^<>\\\\(]|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(?<==)\\\\>|\\\\<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([_$[:alpha:]][_$[:alnum:]]*|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\])|(\\\\'([^\\\\'\\\\\\\\]|\\\\\\\\.)*\\\\')|(\\\\\\"([^\\\\\\"\\\\\\\\]|\\\\\\\\.)*\\\\\\")|(\\\\\`([^\\\\\`\\\\\\\\]|\\\\\\\\.)*\\\\\`))(?=\\\\s*([\\\\<\\\\>\\\\,\\\\.\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))(([^<>\\\\(]|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(?<==)\\\\>|\\\\<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([_$[:alpha:]][_$[:alnum:]]*|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\])|(\\\\'([^\\\\'\\\\\\\\]|\\\\\\\\.)*\\\\')|(\\\\\\"([^\\\\\\"\\\\\\\\]|\\\\\\\\.)*\\\\\\")|(\\\\\`([^\\\\\`\\\\\\\\]|\\\\\\\\.)*\\\\\`))(?=\\\\s*([\\\\<\\\\>\\\\,\\\\.\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^<>\\\\(]|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(?<==)\\\\>)*(?<!=)\\\\>))*(?<!=)\\\\>)*(?<!=)>\\\\s*)?\\\\())","name":"meta.function-call.js","patterns":[{"include":"#function-call-target"}]},{"include":"#comment"},{"include":"#function-call-optionals"},{"include":"#type-arguments"},{"include":"#paren-expression"}]},{"begin":"(?=(((([_$[:alpha:]][_$[:alnum:]]*)(\\\\s*\\\\??\\\\.\\\\s*(\\\\#?[_$[:alpha:]][_$[:alnum:]]*))*)|(\\\\??\\\\.\\\\s*\\\\#?[_$[:alpha:]][_$[:alnum:]]*))|(?<=[\\\\)]))(<\\\\s*[\\\\{\\\\[\\\\(]\\\\s*$))","end":"(?<=\\\\>)(?!(((([_$[:alpha:]][_$[:alnum:]]*)(\\\\s*\\\\??\\\\.\\\\s*(\\\\#?[_$[:alpha:]][_$[:alnum:]]*))*)|(\\\\??\\\\.\\\\s*\\\\#?[_$[:alpha:]][_$[:alnum:]]*))|(?<=[\\\\)]))(<\\\\s*[\\\\{\\\\[\\\\(]\\\\s*$))","patterns":[{"begin":"(?=(([_$[:alpha:]][_$[:alnum:]]*)(\\\\s*\\\\??\\\\.\\\\s*(\\\\#?[_$[:alpha:]][_$[:alnum:]]*))*)|(\\\\??\\\\.\\\\s*\\\\#?[_$[:alpha:]][_$[:alnum:]]*))","end":"(?=(<\\\\s*[\\\\{\\\\[\\\\(]\\\\s*$))","name":"meta.function-call.js","patterns":[{"include":"#function-call-target"}]},{"include":"#comment"},{"include":"#function-call-optionals"},{"include":"#type-arguments"}]}]},"function-call-optionals":{"patterns":[{"match":"\\\\?\\\\.","name":"meta.function-call.js punctuation.accessor.optional.js"},{"match":"\\\\!","name":"meta.function-call.js keyword.operator.definiteassignment.js"}]},"function-call-target":{"patterns":[{"include":"#support-function-call-identifiers"},{"match":"(\\\\#?[_$[:alpha:]][_$[:alnum:]]*)","name":"entity.name.function.js"}]},"function-declaration":{"begin":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(\\\\bexport)\\\\s+)?(?:(\\\\bdeclare)\\\\s+)?(?:(async)\\\\s+)?(function\\\\b)(?:\\\\s*(\\\\*))?(?:(?:\\\\s+|(?<=\\\\*))([_$[:alpha:]][_$[:alnum:]]*))?\\\\s*","beginCaptures":{"1":{"name":"keyword.control.export.js"},"2":{"name":"storage.modifier.js"},"3":{"name":"storage.modifier.async.js"},"4":{"name":"storage.type.function.js"},"5":{"name":"keyword.generator.asterisk.js"},"6":{"name":"meta.definition.function.js entity.name.function.js"}},"end":"(?=;|^\\\\s*$|(?:^\\\\s*(?:abstract|async|(?:\\\\bawait\\\\s+(?:\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[_$[:alpha:]])\\\\b)\\\\b)|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|(?:\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[_$[:alpha:]])\\\\b)|var|while)\\\\b))|(?<=\\\\})","name":"meta.function.js","patterns":[{"include":"#function-name"},{"include":"#function-body"}]},"function-expression":{"begin":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(async)\\\\s+)?(function\\\\b)(?:\\\\s*(\\\\*))?(?:(?:\\\\s+|(?<=\\\\*))([_$[:alpha:]][_$[:alnum:]]*))?\\\\s*","beginCaptures":{"1":{"name":"storage.modifier.async.js"},"2":{"name":"storage.type.function.js"},"3":{"name":"keyword.generator.asterisk.js"},"4":{"name":"meta.definition.function.js entity.name.function.js"}},"end":"(?=;)|(?<=\\\\})","name":"meta.function.expression.js","patterns":[{"include":"#function-name"},{"include":"#single-line-comment-consuming-line-ending"},{"include":"#function-body"}]},"function-name":{"match":"[_$[:alpha:]][_$[:alnum:]]*","name":"meta.definition.function.js entity.name.function.js"},"function-parameters":{"begin":"\\\\(","beginCaptures":{"0":{"name":"punctuation.definition.parameters.begin.js"}},"end":"\\\\)","endCaptures":{"0":{"name":"punctuation.definition.parameters.end.js"}},"name":"meta.parameters.js","patterns":[{"include":"#function-parameters-body"}]},"function-parameters-body":{"patterns":[{"include":"#comment"},{"include":"#string"},{"include":"#decorator"},{"include":"#destructuring-parameter"},{"include":"#parameter-name"},{"include":"#parameter-type-annotation"},{"include":"#variable-initializer"},{"match":",","name":"punctuation.separator.parameter.js"}]},"identifiers":{"patterns":[{"include":"#object-identifiers"},{"captures":{"1":{"name":"punctuation.accessor.js"},"2":{"name":"punctuation.accessor.optional.js"},"3":{"name":"entity.name.function.js"}},"match":"(?:(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*[[:digit:]])))\\\\s*)?([_$[:alpha:]][_$[:alnum:]]*)(?=\\\\s*=\\\\s*(((async\\\\s+)?((function\\\\s*[(<*])|(function\\\\s+)|([_$[:alpha:]][_$[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*$)|([\\\\(]\\\\s*((([\\\\{\\\\[]\\\\s*)?$)|((\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})\\\\s*((:\\\\s*\\\\{?$)|((\\\\s*([^<>\\\\(\\\\)\\\\{\\\\}]|\\\\<([^<>]|\\\\<([^<>]|\\\\<[^<>]+\\\\>)+\\\\>)+\\\\>|\\\\([^\\\\(\\\\)]+\\\\)|\\\\{[^\\\\{\\\\}]+\\\\})+\\\\s*)?=\\\\s*)))|((\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\])\\\\s*((:\\\\s*\\\\[?$)|((\\\\s*([^<>\\\\(\\\\)\\\\{\\\\}]|\\\\<([^<>]|\\\\<([^<>]|\\\\<[^<>]+\\\\>)+\\\\>)+\\\\>|\\\\([^\\\\(\\\\)]+\\\\)|\\\\{[^\\\\{\\\\}]+\\\\})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<]|\\\\<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<]|\\\\<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<])*\\\\>)*\\\\>)*>\\\\s*)?[(]\\\\s*(\\\\/\\\\*([^\\\\*]|(\\\\*[^\\\\/]))*\\\\*\\\\/\\\\s*)*(([)]\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[_$[:alpha:]][_$[:alnum:]]*\\\\s*:)))|([<]\\\\s*[_$[:alpha:]][_$[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<]|\\\\<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<]|\\\\<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<])*\\\\>)*\\\\>)*>\\\\s*)?\\\\(\\\\s*(\\\\/\\\\*([^\\\\*]|(\\\\*[^\\\\/]))*\\\\*\\\\/\\\\s*)*(([_$[:alpha:]]|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\])|(\\\\.\\\\.\\\\.\\\\s*[_$[:alpha:]]))([^()\\\\'\\\\\\"\\\\\`]|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\'([^\\\\'\\\\\\\\]|\\\\\\\\.)*\\\\')|(\\\\\\"([^\\\\\\"\\\\\\\\]|\\\\\\\\.)*\\\\\\")|(\\\\\`([^\\\\\`\\\\\\\\]|\\\\\\\\.)*\\\\\`))*)?\\\\)(\\\\s*:\\\\s*([^<>\\\\(\\\\)\\\\{\\\\}]|\\\\<([^<>]|\\\\<([^<>]|\\\\<[^<>]+\\\\>)+\\\\>)+\\\\>|\\\\([^\\\\(\\\\)]+\\\\)|\\\\{[^\\\\{\\\\}]+\\\\})+)?\\\\s*=>)))))"},{"captures":{"1":{"name":"punctuation.accessor.js"},"2":{"name":"punctuation.accessor.optional.js"},"3":{"name":"variable.other.constant.property.js"}},"match":"(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*[[:digit:]])))\\\\s*(\\\\#?[[:upper:]][_$[:digit:][:upper:]]*)(?![_$[:alnum:]])"},{"captures":{"1":{"name":"punctuation.accessor.js"},"2":{"name":"punctuation.accessor.optional.js"},"3":{"name":"variable.other.property.js"}},"match":"(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*[[:digit:]])))\\\\s*(\\\\#?[_$[:alpha:]][_$[:alnum:]]*)"},{"match":"([[:upper:]][_$[:digit:][:upper:]]*)(?![_$[:alnum:]])","name":"variable.other.constant.js"},{"match":"[_$[:alpha:]][_$[:alnum:]]*","name":"variable.other.readwrite.js"}]},"if-statement":{"patterns":[{"begin":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?=\\\\bif\\\\s*(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))\\\\s*(?!\\\\{))","end":"(?=;|$|\\\\})","patterns":[{"include":"#comment"},{"begin":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(if)\\\\s*(\\\\()","beginCaptures":{"1":{"name":"keyword.control.conditional.js"},"2":{"name":"meta.brace.round.js"}},"end":"\\\\)","endCaptures":{"0":{"name":"meta.brace.round.js"}},"patterns":[{"include":"#expression"}]},{"begin":"(?<=\\\\))\\\\s*\\\\/(?![\\\\/*])(?=(?:[^\\\\/\\\\\\\\\\\\[]|\\\\\\\\.|\\\\[([^\\\\]\\\\\\\\]|\\\\\\\\.)*\\\\])+\\\\/([dgimsuvy]+|(?![\\\\/\\\\*])|(?=\\\\/\\\\*))(?!\\\\s*[a-zA-Z0-9_$]))","beginCaptures":{"0":{"name":"punctuation.definition.string.begin.js"}},"end":"(/)([dgimsuvy]*)","endCaptures":{"1":{"name":"punctuation.definition.string.end.js"},"2":{"name":"keyword.other.js"}},"name":"string.regexp.js","patterns":[{"include":"#regexp"}]},{"include":"#statements"}]}]},"import-declaration":{"begin":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(\\\\bexport)\\\\s+)?(?:(\\\\bdeclare)\\\\s+)?\\\\b(import)(?:\\\\s+(type)(?!\\\\s+from))?(?!\\\\s*[:\\\\(])(?![_$[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))","beginCaptures":{"1":{"name":"keyword.control.export.js"},"2":{"name":"storage.modifier.js"},"3":{"name":"keyword.control.import.js"},"4":{"name":"keyword.control.type.js"}},"end":"(?<!^import|[^\\\\._$[:alnum:]]import)(?=;|$|^)","name":"meta.import.js","patterns":[{"include":"#single-line-comment-consuming-line-ending"},{"include":"#comment"},{"include":"#string"},{"begin":"(?<=^import|[^\\\\._$[:alnum:]]import)(?!\\\\s*[\\"'])","end":"\\\\bfrom\\\\b","endCaptures":{"0":{"name":"keyword.control.from.js"}},"patterns":[{"include":"#import-export-declaration"}]},{"include":"#import-export-declaration"}]},"import-equals-declaration":{"patterns":[{"begin":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(\\\\bexport)\\\\s+)?(?:(\\\\bdeclare)\\\\s+)?\\\\b(import)(?:\\\\s+(type))?\\\\s+([_$[:alpha:]][_$[:alnum:]]*)\\\\s*(=)\\\\s*(require)\\\\s*(\\\\()","beginCaptures":{"1":{"name":"keyword.control.export.js"},"2":{"name":"storage.modifier.js"},"3":{"name":"keyword.control.import.js"},"4":{"name":"keyword.control.type.js"},"5":{"name":"variable.other.readwrite.alias.js"},"6":{"name":"keyword.operator.assignment.js"},"7":{"name":"keyword.control.require.js"},"8":{"name":"meta.brace.round.js"}},"end":"\\\\)","endCaptures":{"0":{"name":"meta.brace.round.js"}},"name":"meta.import-equals.external.js","patterns":[{"include":"#comment"},{"include":"#string"}]},{"begin":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(\\\\bexport)\\\\s+)?(?:(\\\\bdeclare)\\\\s+)?\\\\b(import)(?:\\\\s+(type))?\\\\s+([_$[:alpha:]][_$[:alnum:]]*)\\\\s*(=)\\\\s*(?!require\\\\b)","beginCaptures":{"1":{"name":"keyword.control.export.js"},"2":{"name":"storage.modifier.js"},"3":{"name":"keyword.control.import.js"},"4":{"name":"keyword.control.type.js"},"5":{"name":"variable.other.readwrite.alias.js"},"6":{"name":"keyword.operator.assignment.js"}},"end":"(?=;|$|^)","name":"meta.import-equals.internal.js","patterns":[{"include":"#single-line-comment-consuming-line-ending"},{"include":"#comment"},{"captures":{"1":{"name":"entity.name.type.module.js"},"2":{"name":"punctuation.accessor.js"},"3":{"name":"punctuation.accessor.optional.js"}},"match":"([_$[:alpha:]][_$[:alnum:]]*)\\\\s*(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*[[:digit:]])))"},{"match":"([_$[:alpha:]][_$[:alnum:]]*)","name":"variable.other.readwrite.js"}]}]},"import-export-assert-clause":{"begin":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(with)|(assert))\\\\s*(\\\\{)","beginCaptures":{"1":{"name":"keyword.control.with.js"},"2":{"name":"keyword.control.assert.js"},"3":{"name":"punctuation.definition.block.js"}},"end":"\\\\}","endCaptures":{"0":{"name":"punctuation.definition.block.js"}},"patterns":[{"include":"#comment"},{"include":"#string"},{"match":"(?:[_$[:alpha:]][_$[:alnum:]]*)\\\\s*(?=(\\\\/\\\\*([^\\\\*]|(\\\\*[^\\\\/]))*\\\\*\\\\/\\\\s*)*:)","name":"meta.object-literal.key.js"},{"match":":","name":"punctuation.separator.key-value.js"}]},"import-export-block":{"begin":"\\\\{","beginCaptures":{"0":{"name":"punctuation.definition.block.js"}},"end":"\\\\}","endCaptures":{"0":{"name":"punctuation.definition.block.js"}},"name":"meta.block.js","patterns":[{"include":"#import-export-clause"}]},"import-export-clause":{"patterns":[{"include":"#comment"},{"captures":{"1":{"name":"keyword.control.type.js"},"2":{"name":"keyword.control.default.js"},"3":{"name":"constant.language.import-export-all.js"},"4":{"name":"variable.other.readwrite.js"},"5":{"name":"string.quoted.alias.js"},"12":{"name":"keyword.control.as.js"},"13":{"name":"keyword.control.default.js"},"14":{"name":"variable.other.readwrite.alias.js"},"15":{"name":"string.quoted.alias.js"}},"match":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(?:(\\\\btype)\\\\s+)?(?:(\\\\bdefault)|(\\\\*)|(\\\\b[_$[:alpha:]][_$[:alnum:]]*)|((\\\\'([^\\\\'\\\\\\\\]|\\\\\\\\.)*\\\\')|(\\\\\\"([^\\\\\\"\\\\\\\\]|\\\\\\\\.)*\\\\\\")|(\\\\\`([^\\\\\`\\\\\\\\]|\\\\\\\\.)*\\\\\`))))\\\\s+(as)\\\\s+(?:(default(?![_$[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|([_$[:alpha:]][_$[:alnum:]]*)|((\\\\'([^\\\\'\\\\\\\\]|\\\\\\\\.)*\\\\')|(\\\\\\"([^\\\\\\"\\\\\\\\]|\\\\\\\\.)*\\\\\\")|(\\\\\`([^\\\\\`\\\\\\\\]|\\\\\\\\.)*\\\\\`)))"},{"include":"#punctuation-comma"},{"match":"\\\\*","name":"constant.language.import-export-all.js"},{"match":"\\\\b(default)\\\\b","name":"keyword.control.default.js"},{"captures":{"1":{"name":"keyword.control.type.js"},"2":{"name":"variable.other.readwrite.alias.js"},"3":{"name":"string.quoted.alias.js"}},"match":"(?:(\\\\btype)\\\\s+)?(?:([_$[:alpha:]][_$[:alnum:]]*)|((\\\\'([^\\\\'\\\\\\\\]|\\\\\\\\.)*\\\\')|(\\\\\\"([^\\\\\\"\\\\\\\\]|\\\\\\\\.)*\\\\\\")|(\\\\\`([^\\\\\`\\\\\\\\]|\\\\\\\\.)*\\\\\`)))"}]},"import-export-declaration":{"patterns":[{"include":"#comment"},{"include":"#string"},{"include":"#import-export-block"},{"match":"\\\\bfrom\\\\b","name":"keyword.control.from.js"},{"include":"#import-export-assert-clause"},{"include":"#import-export-clause"}]},"indexer-declaration":{"begin":"(?:(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(readonly)\\\\s*)?\\\\s*(\\\\[)\\\\s*([_$[:alpha:]][_$[:alnum:]]*)\\\\s*(?=:)","beginCaptures":{"1":{"name":"storage.modifier.js"},"2":{"name":"meta.brace.square.js"},"3":{"name":"variable.parameter.js"}},"end":"(\\\\])\\\\s*(\\\\?\\\\s*)?|$","endCaptures":{"1":{"name":"meta.brace.square.js"},"2":{"name":"keyword.operator.optional.js"}},"name":"meta.indexer.declaration.js","patterns":[{"include":"#type-annotation"}]},"indexer-mapped-type-declaration":{"begin":"(?:(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))([+-])?(readonly)\\\\s*)?\\\\s*(\\\\[)\\\\s*([_$[:alpha:]][_$[:alnum:]]*)\\\\s+(in)\\\\s+","beginCaptures":{"1":{"name":"keyword.operator.type.modifier.js"},"2":{"name":"storage.modifier.js"},"3":{"name":"meta.brace.square.js"},"4":{"name":"entity.name.type.js"},"5":{"name":"keyword.operator.expression.in.js"}},"end":"(\\\\])([+-])?\\\\s*(\\\\?\\\\s*)?|$","endCaptures":{"1":{"name":"meta.brace.square.js"},"2":{"name":"keyword.operator.type.modifier.js"},"3":{"name":"keyword.operator.optional.js"}},"name":"meta.indexer.mappedtype.declaration.js","patterns":[{"captures":{"1":{"name":"keyword.control.as.js"}},"match":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(as)\\\\s+"},{"include":"#type"}]},"inline-tags":{"patterns":[{"captures":{"1":{"name":"punctuation.definition.bracket.square.begin.jsdoc"},"2":{"name":"punctuation.definition.bracket.square.end.jsdoc"}},"match":"(\\\\[)[^\\\\]]+(\\\\])(?={@(?:link|linkcode|linkplain|tutorial))","name":"constant.other.description.jsdoc"},{"begin":"({)((@)(?:link(?:code|plain)?|tutorial))\\\\s*","beginCaptures":{"1":{"name":"punctuation.definition.bracket.curly.begin.jsdoc"},"2":{"name":"storage.type.class.jsdoc"},"3":{"name":"punctuation.definition.inline.tag.jsdoc"}},"end":"}|(?=\\\\*/)","endCaptures":{"0":{"name":"punctuation.definition.bracket.curly.end.jsdoc"}},"name":"entity.name.type.instance.jsdoc","patterns":[{"captures":{"1":{"name":"variable.other.link.underline.jsdoc"},"2":{"name":"punctuation.separator.pipe.jsdoc"}},"match":"\\\\G((?=https?://)(?:[^|}\\\\s*]|\\\\*[/])+)(\\\\|)?"},{"captures":{"1":{"name":"variable.other.description.jsdoc"},"2":{"name":"punctuation.separator.pipe.jsdoc"}},"match":"\\\\G((?:[^{}@\\\\s|*]|\\\\*[^/])+)(\\\\|)?"}]}]},"instanceof-expr":{"begin":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(instanceof)(?![_$[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))","beginCaptures":{"1":{"name":"keyword.operator.expression.instanceof.js"}},"end":"(?<=\\\\))|(?=[;),}\\\\]:?\\\\-\\\\+\\\\>]|\\\\|\\\\||\\\\&\\\\&|\\\\!\\\\=\\\\=|$|(===|!==|==|!=)|(([\\\\&\\\\~\\\\^\\\\|]\\\\s*)?[_$[:alpha:]][_$[:alnum:]]*\\\\s+instanceof(?![_$[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|((?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))function((\\\\s+[_$[:alpha:]][_$[:alnum:]]*)|(\\\\s*[\\\\(]))))","patterns":[{"include":"#type"}]},"interface-declaration":{"begin":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(\\\\bexport)\\\\s+)?(?:(\\\\bdeclare)\\\\s+)?\\\\b(?:(abstract)\\\\s+)?\\\\b(interface)\\\\b(?=\\\\s+|/[/*])","beginCaptures":{"1":{"name":"keyword.control.export.js"},"2":{"name":"storage.modifier.js"},"3":{"name":"storage.modifier.js"},"4":{"name":"storage.type.interface.js"}},"end":"(?<=\\\\})","name":"meta.interface.js","patterns":[{"include":"#comment"},{"include":"#class-or-interface-heritage"},{"captures":{"0":{"name":"entity.name.type.interface.js"}},"match":"[_$[:alpha:]][_$[:alnum:]]*"},{"include":"#type-parameters"},{"include":"#class-or-interface-body"}]},"jsdoctype":{"patterns":[{"begin":"\\\\G({)","beginCaptures":{"0":{"name":"entity.name.type.instance.jsdoc"},"1":{"name":"punctuation.definition.bracket.curly.begin.jsdoc"}},"contentName":"entity.name.type.instance.jsdoc","end":"((}))\\\\s*|(?=\\\\*/)","endCaptures":{"1":{"name":"entity.name.type.instance.jsdoc"},"2":{"name":"punctuation.definition.bracket.curly.end.jsdoc"}},"patterns":[{"include":"#brackets"}]}]},"jsx":{"patterns":[{"include":"#jsx-tag-without-attributes-in-expression"},{"include":"#jsx-tag-in-expression"}]},"jsx-children":{"patterns":[{"include":"#jsx-tag-without-attributes"},{"include":"#jsx-tag"},{"include":"#jsx-evaluated-code"},{"include":"#jsx-entities"}]},"jsx-entities":{"patterns":[{"captures":{"1":{"name":"punctuation.definition.entity.js"},"3":{"name":"punctuation.definition.entity.js"}},"match":"(&)([a-zA-Z0-9]+|#[0-9]+|#x[0-9a-fA-F]+)(;)","name":"constant.character.entity.js"}]},"jsx-evaluated-code":{"begin":"\\\\{","beginCaptures":{"0":{"name":"punctuation.section.embedded.begin.js"}},"contentName":"meta.embedded.expression.js","end":"\\\\}","endCaptures":{"0":{"name":"punctuation.section.embedded.end.js"}},"patterns":[{"include":"#expression"}]},"jsx-string-double-quoted":{"begin":"\\"","beginCaptures":{"0":{"name":"punctuation.definition.string.begin.js"}},"end":"\\"","endCaptures":{"0":{"name":"punctuation.definition.string.end.js"}},"name":"string.quoted.double.js","patterns":[{"include":"#jsx-entities"}]},"jsx-string-single-quoted":{"begin":"'","beginCaptures":{"0":{"name":"punctuation.definition.string.begin.js"}},"end":"'","endCaptures":{"0":{"name":"punctuation.definition.string.end.js"}},"name":"string.quoted.single.js","patterns":[{"include":"#jsx-entities"}]},"jsx-tag":{"begin":"(?=(<)\\\\s*(?:([_$[:alpha:]][-_$[:alnum:].]*)(?<!\\\\.|-)(:))?((?:[a-z][a-z0-9]*|([_$[:alpha:]][-_$[:alnum:].]*))(?<!\\\\.|-))(?=((<\\\\s*)|(\\\\s+))(?!\\\\?)|\\\\/?>))","end":"(/>)|(?:(</)\\\\s*(?:([_$[:alpha:]][-_$[:alnum:].]*)(?<!\\\\.|-)(:))?((?:[a-z][a-z0-9]*|([_$[:alpha:]][-_$[:alnum:].]*))(?<!\\\\.|-))?\\\\s*(>))","endCaptures":{"1":{"name":"punctuation.definition.tag.end.js"},"2":{"name":"punctuation.definition.tag.begin.js"},"3":{"name":"entity.name.tag.namespace.js"},"4":{"name":"punctuation.separator.namespace.js"},"5":{"name":"entity.name.tag.js"},"6":{"name":"support.class.component.js"},"7":{"name":"punctuation.definition.tag.end.js"}},"name":"meta.tag.js","patterns":[{"begin":"(<)\\\\s*(?:([_$[:alpha:]][-_$[:alnum:].]*)(?<!\\\\.|-)(:))?((?:[a-z][a-z0-9]*|([_$[:alpha:]][-_$[:alnum:].]*))(?<!\\\\.|-))(?=((<\\\\s*)|(\\\\s+))(?!\\\\?)|\\\\/?>)","beginCaptures":{"1":{"name":"punctuation.definition.tag.begin.js"},"2":{"name":"entity.name.tag.namespace.js"},"3":{"name":"punctuation.separator.namespace.js"},"4":{"name":"entity.name.tag.js"},"5":{"name":"support.class.component.js"}},"end":"(?=[/]?>)","patterns":[{"include":"#comment"},{"include":"#type-arguments"},{"include":"#jsx-tag-attributes"}]},{"begin":"(>)","beginCaptures":{"1":{"name":"punctuation.definition.tag.end.js"}},"contentName":"meta.jsx.children.js","end":"(?=</)","patterns":[{"include":"#jsx-children"}]}]},"jsx-tag-attribute-assignment":{"match":"=(?=\\\\s*(?:'|\\"|{|/\\\\*|//|\\\\n))","name":"keyword.operator.assignment.js"},"jsx-tag-attribute-name":{"captures":{"1":{"name":"entity.other.attribute-name.namespace.js"},"2":{"name":"punctuation.separator.namespace.js"},"3":{"name":"entity.other.attribute-name.js"}},"match":"\\\\s*(?:([_$[:alpha:]][-_$[:alnum:].]*)(:))?([_$[:alpha:]][-_$[:alnum:]]*)(?=\\\\s|=|/?>|/\\\\*|//)"},"jsx-tag-attributes":{"begin":"\\\\s+","end":"(?=[/]?>)","name":"meta.tag.attributes.js","patterns":[{"include":"#comment"},{"include":"#jsx-tag-attribute-name"},{"include":"#jsx-tag-attribute-assignment"},{"include":"#jsx-string-double-quoted"},{"include":"#jsx-string-single-quoted"},{"include":"#jsx-evaluated-code"},{"include":"#jsx-tag-attributes-illegal"}]},"jsx-tag-attributes-illegal":{"match":"\\\\S+","name":"invalid.illegal.attribute.js"},"jsx-tag-in-expression":{"begin":"(?<!\\\\+\\\\+|--)(?<=[({\\\\[,?=>:*]|&&|\\\\|\\\\||\\\\?|\\\\*\\\\/|^await|[^\\\\._$[:alnum:]]await|^return|[^\\\\._$[:alnum:]]return|^default|[^\\\\._$[:alnum:]]default|^yield|[^\\\\._$[:alnum:]]yield|^)\\\\s*(?!<\\\\s*[_$[:alpha:]][_$[:alnum:]]*((\\\\s+extends\\\\s+[^=>])|,))(?=(<)\\\\s*(?:([_$[:alpha:]][-_$[:alnum:].]*)(?<!\\\\.|-)(:))?((?:[a-z][a-z0-9]*|([_$[:alpha:]][-_$[:alnum:].]*))(?<!\\\\.|-))(?=((<\\\\s*)|(\\\\s+))(?!\\\\?)|\\\\/?>))","end":"(?!(<)\\\\s*(?:([_$[:alpha:]][-_$[:alnum:].]*)(?<!\\\\.|-)(:))?((?:[a-z][a-z0-9]*|([_$[:alpha:]][-_$[:alnum:].]*))(?<!\\\\.|-))(?=((<\\\\s*)|(\\\\s+))(?!\\\\?)|\\\\/?>))","patterns":[{"include":"#jsx-tag"}]},"jsx-tag-without-attributes":{"begin":"(<)\\\\s*(?:([_$[:alpha:]][-_$[:alnum:].]*)(?<!\\\\.|-)(:))?((?:[a-z][a-z0-9]*|([_$[:alpha:]][-_$[:alnum:].]*))(?<!\\\\.|-))?\\\\s*(>)","beginCaptures":{"1":{"name":"punctuation.definition.tag.begin.js"},"2":{"name":"entity.name.tag.namespace.js"},"3":{"name":"punctuation.separator.namespace.js"},"4":{"name":"entity.name.tag.js"},"5":{"name":"support.class.component.js"},"6":{"name":"punctuation.definition.tag.end.js"}},"contentName":"meta.jsx.children.js","end":"(</)\\\\s*(?:([_$[:alpha:]][-_$[:alnum:].]*)(?<!\\\\.|-)(:))?((?:[a-z][a-z0-9]*|([_$[:alpha:]][-_$[:alnum:].]*))(?<!\\\\.|-))?\\\\s*(>)","endCaptures":{"1":{"name":"punctuation.definition.tag.begin.js"},"2":{"name":"entity.name.tag.namespace.js"},"3":{"name":"punctuation.separator.namespace.js"},"4":{"name":"entity.name.tag.js"},"5":{"name":"support.class.component.js"},"6":{"name":"punctuation.definition.tag.end.js"}},"name":"meta.tag.without-attributes.js","patterns":[{"include":"#jsx-children"}]},"jsx-tag-without-attributes-in-expression":{"begin":"(?<!\\\\+\\\\+|--)(?<=[({\\\\[,?=>:*]|&&|\\\\|\\\\||\\\\?|\\\\*\\\\/|^await|[^\\\\._$[:alnum:]]await|^return|[^\\\\._$[:alnum:]]return|^default|[^\\\\._$[:alnum:]]default|^yield|[^\\\\._$[:alnum:]]yield|^)\\\\s*(?=(<)\\\\s*(?:([_$[:alpha:]][-_$[:alnum:].]*)(?<!\\\\.|-)(:))?((?:[a-z][a-z0-9]*|([_$[:alpha:]][-_$[:alnum:].]*))(?<!\\\\.|-))?\\\\s*(>))","end":"(?!(<)\\\\s*(?:([_$[:alpha:]][-_$[:alnum:].]*)(?<!\\\\.|-)(:))?((?:[a-z][a-z0-9]*|([_$[:alpha:]][-_$[:alnum:].]*))(?<!\\\\.|-))?\\\\s*(>))","patterns":[{"include":"#jsx-tag-without-attributes"}]},"label":{"patterns":[{"begin":"([_$[:alpha:]][_$[:alnum:]]*)\\\\s*(:)(?=\\\\s*\\\\{)","beginCaptures":{"1":{"name":"entity.name.label.js"},"2":{"name":"punctuation.separator.label.js"}},"end":"(?<=\\\\})","patterns":[{"include":"#decl-block"}]},{"captures":{"1":{"name":"entity.name.label.js"},"2":{"name":"punctuation.separator.label.js"}},"match":"([_$[:alpha:]][_$[:alnum:]]*)\\\\s*(:)"}]},"literal":{"patterns":[{"include":"#numeric-literal"},{"include":"#boolean-literal"},{"include":"#null-literal"},{"include":"#undefined-literal"},{"include":"#numericConstant-literal"},{"include":"#array-literal"},{"include":"#this-literal"},{"include":"#super-literal"}]},"method-declaration":{"patterns":[{"begin":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(override)\\\\s+)?(?:\\\\b(public|private|protected)\\\\s+)?(?:\\\\b(abstract)\\\\s+)?(?:\\\\b(async)\\\\s+)?\\\\s*\\\\b(constructor)\\\\b(?!:)(?![_$[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))","beginCaptures":{"1":{"name":"storage.modifier.js"},"2":{"name":"storage.modifier.js"},"3":{"name":"storage.modifier.js"},"4":{"name":"storage.modifier.async.js"},"5":{"name":"storage.type.js"}},"end":"(?=\\\\}|;|,|$)|(?<=\\\\})","name":"meta.method.declaration.js","patterns":[{"include":"#method-declaration-name"},{"include":"#function-body"}]},{"begin":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(override)\\\\s+)?(?:\\\\b(public|private|protected)\\\\s+)?(?:\\\\b(abstract)\\\\s+)?(?:\\\\b(async)\\\\s+)?(?:(?:\\\\s*\\\\b(new)\\\\b(?!:)(?![_$[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|(?:(\\\\*)\\\\s*)?)(?=\\\\s*((<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<]|\\\\<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<]|\\\\<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<])*\\\\>)*\\\\>)*>\\\\s*))?[\\\\(])","beginCaptures":{"1":{"name":"storage.modifier.js"},"2":{"name":"storage.modifier.js"},"3":{"name":"storage.modifier.js"},"4":{"name":"storage.modifier.async.js"},"5":{"name":"keyword.operator.new.js"},"6":{"name":"keyword.generator.asterisk.js"}},"end":"(?=\\\\}|;|,|$)|(?<=\\\\})","name":"meta.method.declaration.js","patterns":[{"include":"#method-declaration-name"},{"include":"#function-body"}]},{"begin":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(override)\\\\s+)?(?:\\\\b(public|private|protected)\\\\s+)?(?:\\\\b(abstract)\\\\s+)?(?:\\\\b(async)\\\\s+)?(?:\\\\b(get|set)\\\\s+)?(?:(\\\\*)\\\\s*)?(?=\\\\s*(((\\\\b(?<!\\\\$)0(?:x|X)[0-9a-fA-F][0-9a-fA-F_]*(n)?\\\\b(?!\\\\$))|(\\\\b(?<!\\\\$)0(?:b|B)[01][01_]*(n)?\\\\b(?!\\\\$))|(\\\\b(?<!\\\\$)0(?:o|O)?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[eE][+-]?[0-9][0-9_]*(n)?\\\\b)|(?:\\\\b[0-9][0-9_]*(\\\\.)[eE][+-]?[0-9][0-9_]*(n)?\\\\b)|(?:\\\\B(\\\\.)[0-9][0-9_]*[eE][+-]?[0-9][0-9_]*(n)?\\\\b)|(?:\\\\b[0-9][0-9_]*[eE][+-]?[0-9][0-9_]*(n)?\\\\b)|(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b)|(?:\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B)|(?:\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b)|(?:\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.)))(?!\\\\$))|([_$[:alpha:]][_$[:alnum:]]*)|(\\\\'([^\\\\'\\\\\\\\]|\\\\\\\\.)*\\\\')|(\\\\\\"([^\\\\\\"\\\\\\\\]|\\\\\\\\.)*\\\\\\")|(\\\\\`([^\\\\\`\\\\\\\\]|\\\\\\\\.)*\\\\\`)|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])+\\\\]))\\\\s*(\\\\??))\\\\s*((<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<]|\\\\<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<]|\\\\<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<])*\\\\>)*\\\\>)*>\\\\s*))?[\\\\(])","beginCaptures":{"1":{"name":"storage.modifier.js"},"2":{"name":"storage.modifier.js"},"3":{"name":"storage.modifier.js"},"4":{"name":"storage.modifier.async.js"},"5":{"name":"storage.type.property.js"},"6":{"name":"keyword.generator.asterisk.js"}},"end":"(?=\\\\}|;|,|$)|(?<=\\\\})","name":"meta.method.declaration.js","patterns":[{"include":"#method-declaration-name"},{"include":"#function-body"}]}]},"method-declaration-name":{"begin":"(?=((\\\\b(?<!\\\\$)0(?:x|X)[0-9a-fA-F][0-9a-fA-F_]*(n)?\\\\b(?!\\\\$))|(\\\\b(?<!\\\\$)0(?:b|B)[01][01_]*(n)?\\\\b(?!\\\\$))|(\\\\b(?<!\\\\$)0(?:o|O)?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[eE][+-]?[0-9][0-9_]*(n)?\\\\b)|(?:\\\\b[0-9][0-9_]*(\\\\.)[eE][+-]?[0-9][0-9_]*(n)?\\\\b)|(?:\\\\B(\\\\.)[0-9][0-9_]*[eE][+-]?[0-9][0-9_]*(n)?\\\\b)|(?:\\\\b[0-9][0-9_]*[eE][+-]?[0-9][0-9_]*(n)?\\\\b)|(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b)|(?:\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B)|(?:\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b)|(?:\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.)))(?!\\\\$))|([_$[:alpha:]][_$[:alnum:]]*)|(\\\\'([^\\\\'\\\\\\\\]|\\\\\\\\.)*\\\\')|(\\\\\\"([^\\\\\\"\\\\\\\\]|\\\\\\\\.)*\\\\\\")|(\\\\\`([^\\\\\`\\\\\\\\]|\\\\\\\\.)*\\\\\`)|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])+\\\\]))\\\\s*(\\\\??)\\\\s*[\\\\(\\\\<])","end":"(?=\\\\(|\\\\<)","patterns":[{"include":"#string"},{"include":"#array-literal"},{"include":"#numeric-literal"},{"match":"[_$[:alpha:]][_$[:alnum:]]*","name":"meta.definition.method.js entity.name.function.js"},{"match":"\\\\?","name":"keyword.operator.optional.js"}]},"namespace-declaration":{"begin":"(?:(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(\\\\bexport)\\\\s+)?(?:(\\\\bdeclare)\\\\s+)?\\\\b(namespace|module)\\\\s+(?=[_$[:alpha:]\\"'\`]))","beginCaptures":{"1":{"name":"keyword.control.export.js"},"2":{"name":"storage.modifier.js"},"3":{"name":"storage.type.namespace.js"}},"end":"(?<=\\\\})|(?=;|^\\\\s*$|(?:^\\\\s*(?:abstract|async|(?:\\\\bawait\\\\s+(?:\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[_$[:alpha:]])\\\\b)\\\\b)|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|(?:\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[_$[:alpha:]])\\\\b)|var|while)\\\\b))","name":"meta.namespace.declaration.js","patterns":[{"include":"#comment"},{"include":"#string"},{"match":"([_$[:alpha:]][_$[:alnum:]]*)","name":"entity.name.type.module.js"},{"include":"#punctuation-accessor"},{"include":"#decl-block"}]},"new-expr":{"begin":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(new)(?![_$[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))","beginCaptures":{"1":{"name":"keyword.operator.new.js"}},"end":"(?<=\\\\))|(?=[;),}\\\\]:?\\\\-\\\\+\\\\>]|\\\\|\\\\||\\\\&\\\\&|\\\\!\\\\=\\\\=|$|((?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))new(?![_$[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|((?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))function((\\\\s+[_$[:alpha:]][_$[:alnum:]]*)|(\\\\s*[\\\\(]))))","name":"new.expr.js","patterns":[{"include":"#expression"}]},"null-literal":{"match":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))null(?![_$[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))","name":"constant.language.null.js"},"numeric-literal":{"patterns":[{"captures":{"1":{"name":"storage.type.numeric.bigint.js"}},"match":"\\\\b(?<!\\\\$)0(?:x|X)[0-9a-fA-F][0-9a-fA-F_]*(n)?\\\\b(?!\\\\$)","name":"constant.numeric.hex.js"},{"captures":{"1":{"name":"storage.type.numeric.bigint.js"}},"match":"\\\\b(?<!\\\\$)0(?:b|B)[01][01_]*(n)?\\\\b(?!\\\\$)","name":"constant.numeric.binary.js"},{"captures":{"1":{"name":"storage.type.numeric.bigint.js"}},"match":"\\\\b(?<!\\\\$)0(?:o|O)?[0-7][0-7_]*(n)?\\\\b(?!\\\\$)","name":"constant.numeric.octal.js"},{"captures":{"0":{"name":"constant.numeric.decimal.js"},"1":{"name":"meta.delimiter.decimal.period.js"},"2":{"name":"storage.type.numeric.bigint.js"},"3":{"name":"meta.delimiter.decimal.period.js"},"4":{"name":"storage.type.numeric.bigint.js"},"5":{"name":"meta.delimiter.decimal.period.js"},"6":{"name":"storage.type.numeric.bigint.js"},"7":{"name":"storage.type.numeric.bigint.js"},"8":{"name":"meta.delimiter.decimal.period.js"},"9":{"name":"storage.type.numeric.bigint.js"},"10":{"name":"meta.delimiter.decimal.period.js"},"11":{"name":"storage.type.numeric.bigint.js"},"12":{"name":"meta.delimiter.decimal.period.js"},"13":{"name":"storage.type.numeric.bigint.js"},"14":{"name":"storage.type.numeric.bigint.js"}},"match":"(?<!\\\\$)(?:(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[eE][+-]?[0-9][0-9_]*(n)?\\\\b)|(?:\\\\b[0-9][0-9_]*(\\\\.)[eE][+-]?[0-9][0-9_]*(n)?\\\\b)|(?:\\\\B(\\\\.)[0-9][0-9_]*[eE][+-]?[0-9][0-9_]*(n)?\\\\b)|(?:\\\\b[0-9][0-9_]*[eE][+-]?[0-9][0-9_]*(n)?\\\\b)|(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b)|(?:\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B)|(?:\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b)|(?:\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.)))(?!\\\\$)"}]},"numericConstant-literal":{"patterns":[{"match":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))NaN(?![_$[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))","name":"constant.language.nan.js"},{"match":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))Infinity(?![_$[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))","name":"constant.language.infinity.js"}]},"object-binding-element":{"patterns":[{"include":"#comment"},{"begin":"(?=((\\\\b(?<!\\\\$)0(?:x|X)[0-9a-fA-F][0-9a-fA-F_]*(n)?\\\\b(?!\\\\$))|(\\\\b(?<!\\\\$)0(?:b|B)[01][01_]*(n)?\\\\b(?!\\\\$))|(\\\\b(?<!\\\\$)0(?:o|O)?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[eE][+-]?[0-9][0-9_]*(n)?\\\\b)|(?:\\\\b[0-9][0-9_]*(\\\\.)[eE][+-]?[0-9][0-9_]*(n)?\\\\b)|(?:\\\\B(\\\\.)[0-9][0-9_]*[eE][+-]?[0-9][0-9_]*(n)?\\\\b)|(?:\\\\b[0-9][0-9_]*[eE][+-]?[0-9][0-9_]*(n)?\\\\b)|(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b)|(?:\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B)|(?:\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b)|(?:\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.)))(?!\\\\$))|([_$[:alpha:]][_$[:alnum:]]*)|(\\\\'([^\\\\'\\\\\\\\]|\\\\\\\\.)*\\\\')|(\\\\\\"([^\\\\\\"\\\\\\\\]|\\\\\\\\.)*\\\\\\")|(\\\\\`([^\\\\\`\\\\\\\\]|\\\\\\\\.)*\\\\\`)|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])+\\\\]))\\\\s*(:))","end":"(?=,|\\\\})","patterns":[{"include":"#object-binding-element-propertyName"},{"include":"#binding-element"}]},{"include":"#object-binding-pattern"},{"include":"#destructuring-variable-rest"},{"include":"#variable-initializer"},{"include":"#punctuation-comma"}]},"object-binding-element-const":{"patterns":[{"include":"#comment"},{"begin":"(?=((\\\\b(?<!\\\\$)0(?:x|X)[0-9a-fA-F][0-9a-fA-F_]*(n)?\\\\b(?!\\\\$))|(\\\\b(?<!\\\\$)0(?:b|B)[01][01_]*(n)?\\\\b(?!\\\\$))|(\\\\b(?<!\\\\$)0(?:o|O)?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[eE][+-]?[0-9][0-9_]*(n)?\\\\b)|(?:\\\\b[0-9][0-9_]*(\\\\.)[eE][+-]?[0-9][0-9_]*(n)?\\\\b)|(?:\\\\B(\\\\.)[0-9][0-9_]*[eE][+-]?[0-9][0-9_]*(n)?\\\\b)|(?:\\\\b[0-9][0-9_]*[eE][+-]?[0-9][0-9_]*(n)?\\\\b)|(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b)|(?:\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B)|(?:\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b)|(?:\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.)))(?!\\\\$))|([_$[:alpha:]][_$[:alnum:]]*)|(\\\\'([^\\\\'\\\\\\\\]|\\\\\\\\.)*\\\\')|(\\\\\\"([^\\\\\\"\\\\\\\\]|\\\\\\\\.)*\\\\\\")|(\\\\\`([^\\\\\`\\\\\\\\]|\\\\\\\\.)*\\\\\`)|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])+\\\\]))\\\\s*(:))","end":"(?=,|\\\\})","patterns":[{"include":"#object-binding-element-propertyName"},{"include":"#binding-element-const"}]},{"include":"#object-binding-pattern-const"},{"include":"#destructuring-variable-rest-const"},{"include":"#variable-initializer"},{"include":"#punctuation-comma"}]},"object-binding-element-propertyName":{"begin":"(?=((\\\\b(?<!\\\\$)0(?:x|X)[0-9a-fA-F][0-9a-fA-F_]*(n)?\\\\b(?!\\\\$))|(\\\\b(?<!\\\\$)0(?:b|B)[01][01_]*(n)?\\\\b(?!\\\\$))|(\\\\b(?<!\\\\$)0(?:o|O)?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[eE][+-]?[0-9][0-9_]*(n)?\\\\b)|(?:\\\\b[0-9][0-9_]*(\\\\.)[eE][+-]?[0-9][0-9_]*(n)?\\\\b)|(?:\\\\B(\\\\.)[0-9][0-9_]*[eE][+-]?[0-9][0-9_]*(n)?\\\\b)|(?:\\\\b[0-9][0-9_]*[eE][+-]?[0-9][0-9_]*(n)?\\\\b)|(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b)|(?:\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B)|(?:\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b)|(?:\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.)))(?!\\\\$))|([_$[:alpha:]][_$[:alnum:]]*)|(\\\\'([^\\\\'\\\\\\\\]|\\\\\\\\.)*\\\\')|(\\\\\\"([^\\\\\\"\\\\\\\\]|\\\\\\\\.)*\\\\\\")|(\\\\\`([^\\\\\`\\\\\\\\]|\\\\\\\\.)*\\\\\`)|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])+\\\\]))\\\\s*(:))","end":"(:)","endCaptures":{"0":{"name":"punctuation.destructuring.js"}},"patterns":[{"include":"#string"},{"include":"#array-literal"},{"include":"#numeric-literal"},{"match":"([_$[:alpha:]][_$[:alnum:]]*)","name":"variable.object.property.js"}]},"object-binding-pattern":{"begin":"(?:(\\\\.\\\\.\\\\.)\\\\s*)?(\\\\{)","beginCaptures":{"1":{"name":"keyword.operator.rest.js"},"2":{"name":"punctuation.definition.binding-pattern.object.js"}},"end":"\\\\}","endCaptures":{"0":{"name":"punctuation.definition.binding-pattern.object.js"}},"patterns":[{"include":"#object-binding-element"}]},"object-binding-pattern-const":{"begin":"(?:(\\\\.\\\\.\\\\.)\\\\s*)?(\\\\{)","beginCaptures":{"1":{"name":"keyword.operator.rest.js"},"2":{"name":"punctuation.definition.binding-pattern.object.js"}},"end":"\\\\}","endCaptures":{"0":{"name":"punctuation.definition.binding-pattern.object.js"}},"patterns":[{"include":"#object-binding-element-const"}]},"object-identifiers":{"patterns":[{"match":"([_$[:alpha:]][_$[:alnum:]]*)(?=\\\\s*\\\\??\\\\.\\\\s*prototype\\\\b(?!\\\\$))","name":"support.class.js"},{"captures":{"1":{"name":"punctuation.accessor.js"},"2":{"name":"punctuation.accessor.optional.js"},"3":{"name":"variable.other.constant.object.property.js"},"4":{"name":"variable.other.object.property.js"}},"match":"(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*[[:digit:]])))\\\\s*(?:(\\\\#?[[:upper:]][_$[:digit:][:upper:]]*)|(\\\\#?[_$[:alpha:]][_$[:alnum:]]*))(?=\\\\s*\\\\??\\\\.\\\\s*\\\\#?[_$[:alpha:]][_$[:alnum:]]*)"},{"captures":{"1":{"name":"variable.other.constant.object.js"},"2":{"name":"variable.other.object.js"}},"match":"(?:([[:upper:]][_$[:digit:][:upper:]]*)|([_$[:alpha:]][_$[:alnum:]]*))(?=\\\\s*\\\\??\\\\.\\\\s*\\\\#?[_$[:alpha:]][_$[:alnum:]]*)"}]},"object-literal":{"begin":"\\\\{","beginCaptures":{"0":{"name":"punctuation.definition.block.js"}},"end":"\\\\}","endCaptures":{"0":{"name":"punctuation.definition.block.js"}},"name":"meta.objectliteral.js","patterns":[{"include":"#object-member"}]},"object-literal-method-declaration":{"begin":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(async)\\\\s+)?(?:\\\\b(get|set)\\\\s+)?(?:(\\\\*)\\\\s*)?(?=\\\\s*(((\\\\b(?<!\\\\$)0(?:x|X)[0-9a-fA-F][0-9a-fA-F_]*(n)?\\\\b(?!\\\\$))|(\\\\b(?<!\\\\$)0(?:b|B)[01][01_]*(n)?\\\\b(?!\\\\$))|(\\\\b(?<!\\\\$)0(?:o|O)?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[eE][+-]?[0-9][0-9_]*(n)?\\\\b)|(?:\\\\b[0-9][0-9_]*(\\\\.)[eE][+-]?[0-9][0-9_]*(n)?\\\\b)|(?:\\\\B(\\\\.)[0-9][0-9_]*[eE][+-]?[0-9][0-9_]*(n)?\\\\b)|(?:\\\\b[0-9][0-9_]*[eE][+-]?[0-9][0-9_]*(n)?\\\\b)|(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b)|(?:\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B)|(?:\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b)|(?:\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.)))(?!\\\\$))|([_$[:alpha:]][_$[:alnum:]]*)|(\\\\'([^\\\\'\\\\\\\\]|\\\\\\\\.)*\\\\')|(\\\\\\"([^\\\\\\"\\\\\\\\]|\\\\\\\\.)*\\\\\\")|(\\\\\`([^\\\\\`\\\\\\\\]|\\\\\\\\.)*\\\\\`)|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])+\\\\]))\\\\s*(\\\\??))\\\\s*((<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<]|\\\\<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<]|\\\\<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<])*\\\\>)*\\\\>)*>\\\\s*))?[\\\\(])","beginCaptures":{"1":{"name":"storage.modifier.async.js"},"2":{"name":"storage.type.property.js"},"3":{"name":"keyword.generator.asterisk.js"}},"end":"(?=\\\\}|;|,)|(?<=\\\\})","name":"meta.method.declaration.js","patterns":[{"include":"#method-declaration-name"},{"include":"#function-body"},{"begin":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:\\\\b(async)\\\\s+)?(?:\\\\b(get|set)\\\\s+)?(?:(\\\\*)\\\\s*)?(?=\\\\s*(((\\\\b(?<!\\\\$)0(?:x|X)[0-9a-fA-F][0-9a-fA-F_]*(n)?\\\\b(?!\\\\$))|(\\\\b(?<!\\\\$)0(?:b|B)[01][01_]*(n)?\\\\b(?!\\\\$))|(\\\\b(?<!\\\\$)0(?:o|O)?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[eE][+-]?[0-9][0-9_]*(n)?\\\\b)|(?:\\\\b[0-9][0-9_]*(\\\\.)[eE][+-]?[0-9][0-9_]*(n)?\\\\b)|(?:\\\\B(\\\\.)[0-9][0-9_]*[eE][+-]?[0-9][0-9_]*(n)?\\\\b)|(?:\\\\b[0-9][0-9_]*[eE][+-]?[0-9][0-9_]*(n)?\\\\b)|(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b)|(?:\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B)|(?:\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b)|(?:\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.)))(?!\\\\$))|([_$[:alpha:]][_$[:alnum:]]*)|(\\\\'([^\\\\'\\\\\\\\]|\\\\\\\\.)*\\\\')|(\\\\\\"([^\\\\\\"\\\\\\\\]|\\\\\\\\.)*\\\\\\")|(\\\\\`([^\\\\\`\\\\\\\\]|\\\\\\\\.)*\\\\\`)|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])+\\\\]))\\\\s*(\\\\??))\\\\s*((<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<]|\\\\<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<]|\\\\<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<])*\\\\>)*\\\\>)*>\\\\s*))?[\\\\(])","beginCaptures":{"1":{"name":"storage.modifier.async.js"},"2":{"name":"storage.type.property.js"},"3":{"name":"keyword.generator.asterisk.js"}},"end":"(?=\\\\(|\\\\<)","patterns":[{"include":"#method-declaration-name"}]}]},"object-member":{"patterns":[{"include":"#comment"},{"include":"#object-literal-method-declaration"},{"begin":"(?=\\\\[)","end":"(?=:)|((?<=[\\\\]])(?=\\\\s*[\\\\(\\\\<]))","name":"meta.object.member.js meta.object-literal.key.js","patterns":[{"include":"#comment"},{"include":"#array-literal"}]},{"begin":"(?=[\\\\'\\\\\\"\\\\\`])","end":"(?=:)|((?<=[\\\\'\\\\\\"\\\\\`])(?=((\\\\s*[\\\\(\\\\<,}])|(\\\\s+(as|satisifies)\\\\s+))))","name":"meta.object.member.js meta.object-literal.key.js","patterns":[{"include":"#comment"},{"include":"#string"}]},{"begin":"(?=(\\\\b(?<!\\\\$)0(?:x|X)[0-9a-fA-F][0-9a-fA-F_]*(n)?\\\\b(?!\\\\$))|(\\\\b(?<!\\\\$)0(?:b|B)[01][01_]*(n)?\\\\b(?!\\\\$))|(\\\\b(?<!\\\\$)0(?:o|O)?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[eE][+-]?[0-9][0-9_]*(n)?\\\\b)|(?:\\\\b[0-9][0-9_]*(\\\\.)[eE][+-]?[0-9][0-9_]*(n)?\\\\b)|(?:\\\\B(\\\\.)[0-9][0-9_]*[eE][+-]?[0-9][0-9_]*(n)?\\\\b)|(?:\\\\b[0-9][0-9_]*[eE][+-]?[0-9][0-9_]*(n)?\\\\b)|(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b)|(?:\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B)|(?:\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b)|(?:\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.)))(?!\\\\$)))","end":"(?=:)|(?=\\\\s*([\\\\(\\\\<,}])|(\\\\s+as|satisifies\\\\s+))","name":"meta.object.member.js meta.object-literal.key.js","patterns":[{"include":"#comment"},{"include":"#numeric-literal"}]},{"begin":"(?<=[\\\\]\\\\'\\\\\\"\\\\\`])(?=\\\\s*[\\\\(\\\\<])","end":"(?=\\\\}|;|,)|(?<=\\\\})","name":"meta.method.declaration.js","patterns":[{"include":"#function-body"}]},{"captures":{"0":{"name":"meta.object-literal.key.js"},"1":{"name":"constant.numeric.decimal.js"}},"match":"(?![_$[:alpha:]])([[:digit:]]+)\\\\s*(?=(\\\\/\\\\*([^\\\\*]|(\\\\*[^\\\\/]))*\\\\*\\\\/\\\\s*)*:)","name":"meta.object.member.js"},{"captures":{"0":{"name":"meta.object-literal.key.js"},"1":{"name":"entity.name.function.js"}},"match":"(?:([_$[:alpha:]][_$[:alnum:]]*)\\\\s*(?=(\\\\/\\\\*([^\\\\*]|(\\\\*[^\\\\/]))*\\\\*\\\\/\\\\s*)*:(\\\\s*\\\\/\\\\*([^\\\\*]|(\\\\*[^\\\\/]))*\\\\*\\\\/)*\\\\s*(((async\\\\s+)?((function\\\\s*[(<*])|(function\\\\s+)|([_$[:alpha:]][_$[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*$)|([\\\\(]\\\\s*((([\\\\{\\\\[]\\\\s*)?$)|((\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})\\\\s*((:\\\\s*\\\\{?$)|((\\\\s*([^<>\\\\(\\\\)\\\\{\\\\}]|\\\\<([^<>]|\\\\<([^<>]|\\\\<[^<>]+\\\\>)+\\\\>)+\\\\>|\\\\([^\\\\(\\\\)]+\\\\)|\\\\{[^\\\\{\\\\}]+\\\\})+\\\\s*)?=\\\\s*)))|((\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\])\\\\s*((:\\\\s*\\\\[?$)|((\\\\s*([^<>\\\\(\\\\)\\\\{\\\\}]|\\\\<([^<>]|\\\\<([^<>]|\\\\<[^<>]+\\\\>)+\\\\>)+\\\\>|\\\\([^\\\\(\\\\)]+\\\\)|\\\\{[^\\\\{\\\\}]+\\\\})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<]|\\\\<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<]|\\\\<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<])*\\\\>)*\\\\>)*>\\\\s*)?[(]\\\\s*(\\\\/\\\\*([^\\\\*]|(\\\\*[^\\\\/]))*\\\\*\\\\/\\\\s*)*(([)]\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[_$[:alpha:]][_$[:alnum:]]*\\\\s*:)))|([<]\\\\s*[_$[:alpha:]][_$[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<]|\\\\<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<]|\\\\<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<])*\\\\>)*\\\\>)*>\\\\s*)?\\\\(\\\\s*(\\\\/\\\\*([^\\\\*]|(\\\\*[^\\\\/]))*\\\\*\\\\/\\\\s*)*(([_$[:alpha:]]|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\])|(\\\\.\\\\.\\\\.\\\\s*[_$[:alpha:]]))([^()\\\\'\\\\\\"\\\\\`]|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\'([^\\\\'\\\\\\\\]|\\\\\\\\.)*\\\\')|(\\\\\\"([^\\\\\\"\\\\\\\\]|\\\\\\\\.)*\\\\\\")|(\\\\\`([^\\\\\`\\\\\\\\]|\\\\\\\\.)*\\\\\`))*)?\\\\)(\\\\s*:\\\\s*([^<>\\\\(\\\\)\\\\{\\\\}]|\\\\<([^<>]|\\\\<([^<>]|\\\\<[^<>]+\\\\>)+\\\\>)+\\\\>|\\\\([^\\\\(\\\\)]+\\\\)|\\\\{[^\\\\{\\\\}]+\\\\})+)?\\\\s*=>))))))","name":"meta.object.member.js"},{"captures":{"0":{"name":"meta.object-literal.key.js"}},"match":"(?:[_$[:alpha:]][_$[:alnum:]]*)\\\\s*(?=(\\\\/\\\\*([^\\\\*]|(\\\\*[^\\\\/]))*\\\\*\\\\/\\\\s*)*:)","name":"meta.object.member.js"},{"begin":"\\\\.\\\\.\\\\.","beginCaptures":{"0":{"name":"keyword.operator.spread.js"}},"end":"(?=,|\\\\})","name":"meta.object.member.js","patterns":[{"include":"#expression"}]},{"captures":{"1":{"name":"variable.other.readwrite.js"}},"match":"([_$[:alpha:]][_$[:alnum:]]*)\\\\s*(?=,|\\\\}|$|\\\\/\\\\/|\\\\/\\\\*)","name":"meta.object.member.js"},{"captures":{"1":{"name":"keyword.control.as.js"},"2":{"name":"storage.modifier.js"}},"match":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(as)\\\\s+(const)(?=\\\\s*([,}]|$))","name":"meta.object.member.js"},{"begin":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(as)|(satisfies))\\\\s+","beginCaptures":{"1":{"name":"keyword.control.as.js"},"2":{"name":"keyword.control.satisfies.js"}},"end":"(?=[;),}\\\\]:?\\\\-\\\\+\\\\>]|\\\\|\\\\||\\\\&\\\\&|\\\\!\\\\=\\\\=|$|^|((?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(as|satisifies)\\\\s+))","name":"meta.object.member.js","patterns":[{"include":"#type"}]},{"begin":"(?=[_$[:alpha:]][_$[:alnum:]]*\\\\s*=)","end":"(?=,|\\\\}|$|\\\\/\\\\/|\\\\/\\\\*)","name":"meta.object.member.js","patterns":[{"include":"#expression"}]},{"begin":":","beginCaptures":{"0":{"name":"meta.object-literal.key.js punctuation.separator.key-value.js"}},"end":"(?=,|\\\\})","name":"meta.object.member.js","patterns":[{"begin":"(?<=:)\\\\s*(async)?(?=\\\\s*(<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<]|\\\\<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<]|\\\\<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<])*\\\\>)*\\\\>)*>\\\\s*)\\\\(\\\\s*((([\\\\{\\\\[]\\\\s*)?$)|((\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})\\\\s*((:\\\\s*\\\\{?$)|((\\\\s*([^<>\\\\(\\\\)\\\\{\\\\}]|\\\\<([^<>]|\\\\<([^<>]|\\\\<[^<>]+\\\\>)+\\\\>)+\\\\>|\\\\([^\\\\(\\\\)]+\\\\)|\\\\{[^\\\\{\\\\}]+\\\\})+\\\\s*)?=\\\\s*)))|((\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\])\\\\s*((:\\\\s*\\\\[?$)|((\\\\s*([^<>\\\\(\\\\)\\\\{\\\\}]|\\\\<([^<>]|\\\\<([^<>]|\\\\<[^<>]+\\\\>)+\\\\>)+\\\\>|\\\\([^\\\\(\\\\)]+\\\\)|\\\\{[^\\\\{\\\\}]+\\\\})+\\\\s*)?=\\\\s*)))))","beginCaptures":{"1":{"name":"storage.modifier.async.js"}},"end":"(?<=\\\\))","patterns":[{"include":"#type-parameters"},{"begin":"\\\\(","beginCaptures":{"0":{"name":"meta.brace.round.js"}},"end":"\\\\)","endCaptures":{"0":{"name":"meta.brace.round.js"}},"patterns":[{"include":"#expression-inside-possibly-arrow-parens"}]}]},{"begin":"(?<=:)\\\\s*(async)?\\\\s*(\\\\()(?=\\\\s*((([\\\\{\\\\[]\\\\s*)?$)|((\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})\\\\s*((:\\\\s*\\\\{?$)|((\\\\s*([^<>\\\\(\\\\)\\\\{\\\\}]|\\\\<([^<>]|\\\\<([^<>]|\\\\<[^<>]+\\\\>)+\\\\>)+\\\\>|\\\\([^\\\\(\\\\)]+\\\\)|\\\\{[^\\\\{\\\\}]+\\\\})+\\\\s*)?=\\\\s*)))|((\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\])\\\\s*((:\\\\s*\\\\[?$)|((\\\\s*([^<>\\\\(\\\\)\\\\{\\\\}]|\\\\<([^<>]|\\\\<([^<>]|\\\\<[^<>]+\\\\>)+\\\\>)+\\\\>|\\\\([^\\\\(\\\\)]+\\\\)|\\\\{[^\\\\{\\\\}]+\\\\})+\\\\s*)?=\\\\s*)))))","beginCaptures":{"1":{"name":"storage.modifier.async.js"},"2":{"name":"meta.brace.round.js"}},"end":"\\\\)","endCaptures":{"0":{"name":"meta.brace.round.js"}},"patterns":[{"include":"#expression-inside-possibly-arrow-parens"}]},{"begin":"(?<=:)\\\\s*(async)?\\\\s*(?=\\\\<\\\\s*$)","beginCaptures":{"1":{"name":"storage.modifier.async.js"}},"end":"(?<=\\\\>)","patterns":[{"include":"#type-parameters"}]},{"begin":"(?<=\\\\>)\\\\s*(\\\\()(?=\\\\s*((([\\\\{\\\\[]\\\\s*)?$)|((\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})\\\\s*((:\\\\s*\\\\{?$)|((\\\\s*([^<>\\\\(\\\\)\\\\{\\\\}]|\\\\<([^<>]|\\\\<([^<>]|\\\\<[^<>]+\\\\>)+\\\\>)+\\\\>|\\\\([^\\\\(\\\\)]+\\\\)|\\\\{[^\\\\{\\\\}]+\\\\})+\\\\s*)?=\\\\s*)))|((\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\])\\\\s*((:\\\\s*\\\\[?$)|((\\\\s*([^<>\\\\(\\\\)\\\\{\\\\}]|\\\\<([^<>]|\\\\<([^<>]|\\\\<[^<>]+\\\\>)+\\\\>)+\\\\>|\\\\([^\\\\(\\\\)]+\\\\)|\\\\{[^\\\\{\\\\}]+\\\\})+\\\\s*)?=\\\\s*)))))","beginCaptures":{"1":{"name":"meta.brace.round.js"}},"end":"\\\\)","endCaptures":{"0":{"name":"meta.brace.round.js"}},"patterns":[{"include":"#expression-inside-possibly-arrow-parens"}]},{"include":"#possibly-arrow-return-type"},{"include":"#expression"}]},{"include":"#punctuation-comma"},{"include":"#decl-block"}]},"parameter-array-binding-pattern":{"begin":"(?:(\\\\.\\\\.\\\\.)\\\\s*)?(\\\\[)","beginCaptures":{"1":{"name":"keyword.operator.rest.js"},"2":{"name":"punctuation.definition.binding-pattern.array.js"}},"end":"\\\\]","endCaptures":{"0":{"name":"punctuation.definition.binding-pattern.array.js"}},"patterns":[{"include":"#parameter-binding-element"},{"include":"#punctuation-comma"}]},"parameter-binding-element":{"patterns":[{"include":"#comment"},{"include":"#string"},{"include":"#numeric-literal"},{"include":"#regex"},{"include":"#parameter-object-binding-pattern"},{"include":"#parameter-array-binding-pattern"},{"include":"#destructuring-parameter-rest"},{"include":"#variable-initializer"}]},"parameter-name":{"patterns":[{"captures":{"1":{"name":"storage.modifier.js"}},"match":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(override|public|protected|private|readonly)\\\\s+(?=(override|public|protected|private|readonly)\\\\s+)"},{"captures":{"1":{"name":"storage.modifier.js"},"2":{"name":"keyword.operator.rest.js"},"3":{"name":"entity.name.function.js variable.language.this.js"},"4":{"name":"entity.name.function.js"},"5":{"name":"keyword.operator.optional.js"}},"match":"(?:(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(override|public|private|protected|readonly)\\\\s+)?(?:(\\\\.\\\\.\\\\.)\\\\s*)?(?<!=|:)(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(this)|([_$[:alpha:]][_$[:alnum:]]*))(?![_$[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\\\\s*(\\\\??)(?=\\\\s*(=\\\\s*(((async\\\\s+)?((function\\\\s*[(<*])|(function\\\\s+)|([_$[:alpha:]][_$[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*$)|([\\\\(]\\\\s*((([\\\\{\\\\[]\\\\s*)?$)|((\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})\\\\s*((:\\\\s*\\\\{?$)|((\\\\s*([^<>\\\\(\\\\)\\\\{\\\\}]|\\\\<([^<>]|\\\\<([^<>]|\\\\<[^<>]+\\\\>)+\\\\>)+\\\\>|\\\\([^\\\\(\\\\)]+\\\\)|\\\\{[^\\\\{\\\\}]+\\\\})+\\\\s*)?=\\\\s*)))|((\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\])\\\\s*((:\\\\s*\\\\[?$)|((\\\\s*([^<>\\\\(\\\\)\\\\{\\\\}]|\\\\<([^<>]|\\\\<([^<>]|\\\\<[^<>]+\\\\>)+\\\\>)+\\\\>|\\\\([^\\\\(\\\\)]+\\\\)|\\\\{[^\\\\{\\\\}]+\\\\})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<]|\\\\<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<]|\\\\<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<])*\\\\>)*\\\\>)*>\\\\s*)?[(]\\\\s*(\\\\/\\\\*([^\\\\*]|(\\\\*[^\\\\/]))*\\\\*\\\\/\\\\s*)*(([)]\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[_$[:alpha:]][_$[:alnum:]]*\\\\s*:)))|([<]\\\\s*[_$[:alpha:]][_$[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<]|\\\\<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<]|\\\\<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<])*\\\\>)*\\\\>)*>\\\\s*)?\\\\(\\\\s*(\\\\/\\\\*([^\\\\*]|(\\\\*[^\\\\/]))*\\\\*\\\\/\\\\s*)*(([_$[:alpha:]]|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\])|(\\\\.\\\\.\\\\.\\\\s*[_$[:alpha:]]))([^()\\\\'\\\\\\"\\\\\`]|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\'([^\\\\'\\\\\\\\]|\\\\\\\\.)*\\\\')|(\\\\\\"([^\\\\\\"\\\\\\\\]|\\\\\\\\.)*\\\\\\")|(\\\\\`([^\\\\\`\\\\\\\\]|\\\\\\\\.)*\\\\\`))*)?\\\\)(\\\\s*:\\\\s*([^<>\\\\(\\\\)\\\\{\\\\}]|\\\\<([^<>]|\\\\<([^<>]|\\\\<[^<>]+\\\\>)+\\\\>)+\\\\>|\\\\([^\\\\(\\\\)]+\\\\)|\\\\{[^\\\\{\\\\}]+\\\\})+)?\\\\s*=>)))))|(:\\\\s*((<)|([(]\\\\s*(([)])|(\\\\.\\\\.\\\\.)|([_$[:alnum:]]+\\\\s*(([:,?=])|([)]\\\\s*=>)))))))|(:\\\\s*(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))Function(?![_$[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|(:\\\\s*((<\\\\s*$)|([\\\\(]\\\\s*((([\\\\{\\\\[]\\\\s*)?$)|((\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})\\\\s*((:\\\\s*\\\\{?$)|((\\\\s*([^<>\\\\(\\\\)\\\\{\\\\}]|\\\\<([^<>]|\\\\<([^<>]|\\\\<[^<>]+\\\\>)+\\\\>)+\\\\>|\\\\([^\\\\(\\\\)]+\\\\)|\\\\{[^\\\\{\\\\}]+\\\\})+\\\\s*)?=\\\\s*)))|((\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\])\\\\s*((:\\\\s*\\\\[?$)|((\\\\s*([^<>\\\\(\\\\)\\\\{\\\\}]|\\\\<([^<>]|\\\\<([^<>]|\\\\<[^<>]+\\\\>)+\\\\>)+\\\\>|\\\\([^\\\\(\\\\)]+\\\\)|\\\\{[^\\\\{\\\\}]+\\\\})+\\\\s*)?=\\\\s*)))))))|(:\\\\s*(=>|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(<[^<>]*>)|[^<>(),=])+=\\\\s*(((async\\\\s+)?((function\\\\s*[(<*])|(function\\\\s+)|([_$[:alpha:]][_$[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*$)|([\\\\(]\\\\s*((([\\\\{\\\\[]\\\\s*)?$)|((\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})\\\\s*((:\\\\s*\\\\{?$)|((\\\\s*([^<>\\\\(\\\\)\\\\{\\\\}]|\\\\<([^<>]|\\\\<([^<>]|\\\\<[^<>]+\\\\>)+\\\\>)+\\\\>|\\\\([^\\\\(\\\\)]+\\\\)|\\\\{[^\\\\{\\\\}]+\\\\})+\\\\s*)?=\\\\s*)))|((\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\])\\\\s*((:\\\\s*\\\\[?$)|((\\\\s*([^<>\\\\(\\\\)\\\\{\\\\}]|\\\\<([^<>]|\\\\<([^<>]|\\\\<[^<>]+\\\\>)+\\\\>)+\\\\>|\\\\([^\\\\(\\\\)]+\\\\)|\\\\{[^\\\\{\\\\}]+\\\\})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<]|\\\\<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<]|\\\\<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<])*\\\\>)*\\\\>)*>\\\\s*)?[(]\\\\s*(\\\\/\\\\*([^\\\\*]|(\\\\*[^\\\\/]))*\\\\*\\\\/\\\\s*)*(([)]\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[_$[:alpha:]][_$[:alnum:]]*\\\\s*:)))|([<]\\\\s*[_$[:alpha:]][_$[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<]|\\\\<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<]|\\\\<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<])*\\\\>)*\\\\>)*>\\\\s*)?\\\\(\\\\s*(\\\\/\\\\*([^\\\\*]|(\\\\*[^\\\\/]))*\\\\*\\\\/\\\\s*)*(([_$[:alpha:]]|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\])|(\\\\.\\\\.\\\\.\\\\s*[_$[:alpha:]]))([^()\\\\'\\\\\\"\\\\\`]|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\'([^\\\\'\\\\\\\\]|\\\\\\\\.)*\\\\')|(\\\\\\"([^\\\\\\"\\\\\\\\]|\\\\\\\\.)*\\\\\\")|(\\\\\`([^\\\\\`\\\\\\\\]|\\\\\\\\.)*\\\\\`))*)?\\\\)(\\\\s*:\\\\s*([^<>\\\\(\\\\)\\\\{\\\\}]|\\\\<([^<>]|\\\\<([^<>]|\\\\<[^<>]+\\\\>)+\\\\>)+\\\\>|\\\\([^\\\\(\\\\)]+\\\\)|\\\\{[^\\\\{\\\\}]+\\\\})+)?\\\\s*=>))))))"},{"captures":{"1":{"name":"storage.modifier.js"},"2":{"name":"keyword.operator.rest.js"},"3":{"name":"variable.parameter.js variable.language.this.js"},"4":{"name":"variable.parameter.js"},"5":{"name":"keyword.operator.optional.js"}},"match":"(?:(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(override|public|private|protected|readonly)\\\\s+)?(?:(\\\\.\\\\.\\\\.)\\\\s*)?(?<!=|:)(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(this)|([_$[:alpha:]][_$[:alnum:]]*))(?![_$[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\\\\s*(\\\\??)"}]},"parameter-object-binding-element":{"patterns":[{"include":"#comment"},{"begin":"(?=((\\\\b(?<!\\\\$)0(?:x|X)[0-9a-fA-F][0-9a-fA-F_]*(n)?\\\\b(?!\\\\$))|(\\\\b(?<!\\\\$)0(?:b|B)[01][01_]*(n)?\\\\b(?!\\\\$))|(\\\\b(?<!\\\\$)0(?:o|O)?[0-7][0-7_]*(n)?\\\\b(?!\\\\$))|((?<!\\\\$)(?:(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*[eE][+-]?[0-9][0-9_]*(n)?\\\\b)|(?:\\\\b[0-9][0-9_]*(\\\\.)[eE][+-]?[0-9][0-9_]*(n)?\\\\b)|(?:\\\\B(\\\\.)[0-9][0-9_]*[eE][+-]?[0-9][0-9_]*(n)?\\\\b)|(?:\\\\b[0-9][0-9_]*[eE][+-]?[0-9][0-9_]*(n)?\\\\b)|(?:\\\\b[0-9][0-9_]*(\\\\.)[0-9][0-9_]*(n)?\\\\b)|(?:\\\\b[0-9][0-9_]*(\\\\.)(n)?\\\\B)|(?:\\\\B(\\\\.)[0-9][0-9_]*(n)?\\\\b)|(?:\\\\b[0-9][0-9_]*(n)?\\\\b(?!\\\\.)))(?!\\\\$))|([_$[:alpha:]][_$[:alnum:]]*)|(\\\\'([^\\\\'\\\\\\\\]|\\\\\\\\.)*\\\\')|(\\\\\\"([^\\\\\\"\\\\\\\\]|\\\\\\\\.)*\\\\\\")|(\\\\\`([^\\\\\`\\\\\\\\]|\\\\\\\\.)*\\\\\`)|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])+\\\\]))\\\\s*(:))","end":"(?=,|\\\\})","patterns":[{"include":"#object-binding-element-propertyName"},{"include":"#parameter-binding-element"},{"include":"#paren-expression"}]},{"include":"#parameter-object-binding-pattern"},{"include":"#destructuring-parameter-rest"},{"include":"#variable-initializer"},{"include":"#punctuation-comma"}]},"parameter-object-binding-pattern":{"begin":"(?:(\\\\.\\\\.\\\\.)\\\\s*)?(\\\\{)","beginCaptures":{"1":{"name":"keyword.operator.rest.js"},"2":{"name":"punctuation.definition.binding-pattern.object.js"}},"end":"\\\\}","endCaptures":{"0":{"name":"punctuation.definition.binding-pattern.object.js"}},"patterns":[{"include":"#parameter-object-binding-element"}]},"parameter-type-annotation":{"patterns":[{"begin":"(:)","beginCaptures":{"1":{"name":"keyword.operator.type.annotation.js"}},"end":"(?=[,)])|(?==[^>])","name":"meta.type.annotation.js","patterns":[{"include":"#type"}]}]},"paren-expression":{"begin":"\\\\(","beginCaptures":{"0":{"name":"meta.brace.round.js"}},"end":"\\\\)","endCaptures":{"0":{"name":"meta.brace.round.js"}},"patterns":[{"include":"#expression"}]},"paren-expression-possibly-arrow":{"patterns":[{"begin":"(?<=[(=,])\\\\s*(async)?(?=\\\\s*((<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<]|\\\\<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<]|\\\\<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<])*\\\\>)*\\\\>)*>\\\\s*))?\\\\(\\\\s*((([\\\\{\\\\[]\\\\s*)?$)|((\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})\\\\s*((:\\\\s*\\\\{?$)|((\\\\s*([^<>\\\\(\\\\)\\\\{\\\\}]|\\\\<([^<>]|\\\\<([^<>]|\\\\<[^<>]+\\\\>)+\\\\>)+\\\\>|\\\\([^\\\\(\\\\)]+\\\\)|\\\\{[^\\\\{\\\\}]+\\\\})+\\\\s*)?=\\\\s*)))|((\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\])\\\\s*((:\\\\s*\\\\[?$)|((\\\\s*([^<>\\\\(\\\\)\\\\{\\\\}]|\\\\<([^<>]|\\\\<([^<>]|\\\\<[^<>]+\\\\>)+\\\\>)+\\\\>|\\\\([^\\\\(\\\\)]+\\\\)|\\\\{[^\\\\{\\\\}]+\\\\})+\\\\s*)?=\\\\s*)))))","beginCaptures":{"1":{"name":"storage.modifier.async.js"}},"end":"(?<=\\\\))","patterns":[{"include":"#paren-expression-possibly-arrow-with-typeparameters"}]},{"begin":"(?<=[(=,]|=>|^return|[^\\\\._$[:alnum:]]return)\\\\s*(async)?(?=\\\\s*((((<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<]|\\\\<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<]|\\\\<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<])*\\\\>)*\\\\>)*>\\\\s*))?\\\\()|(<)|((<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<]|\\\\<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<]|\\\\<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<])*\\\\>)*\\\\>)*>\\\\s*)))\\\\s*$)","beginCaptures":{"1":{"name":"storage.modifier.async.js"}},"end":"(?<=\\\\))","patterns":[{"include":"#paren-expression-possibly-arrow-with-typeparameters"}]},{"include":"#possibly-arrow-return-type"}]},"paren-expression-possibly-arrow-with-typeparameters":{"patterns":[{"include":"#type-parameters"},{"begin":"\\\\(","beginCaptures":{"0":{"name":"meta.brace.round.js"}},"end":"\\\\)","endCaptures":{"0":{"name":"meta.brace.round.js"}},"patterns":[{"include":"#expression-inside-possibly-arrow-parens"}]}]},"possibly-arrow-return-type":{"begin":"(?<=\\\\)|^)\\\\s*(:)(?=\\\\s*([^<>\\\\(\\\\)\\\\{\\\\}]|\\\\<([^<>]|\\\\<([^<>]|\\\\<[^<>]+\\\\>)+\\\\>)+\\\\>|\\\\([^\\\\(\\\\)]+\\\\)|\\\\{[^\\\\{\\\\}]+\\\\})+\\\\s*=>)","beginCaptures":{"1":{"name":"meta.arrow.js meta.return.type.arrow.js keyword.operator.type.annotation.js"}},"contentName":"meta.arrow.js meta.return.type.arrow.js","end":"(?==>|\\\\{|(^\\\\s*(export|function|class|interface|let|var|(?:\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[_$[:alpha:]])\\\\b)|(?:\\\\bawait\\\\s+(?:\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[_$[:alpha:]])\\\\b)\\\\b)|const|import|enum|namespace|module|type|abstract|declare)\\\\s+))","patterns":[{"include":"#arrow-return-type-body"}]},"property-accessor":{"match":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(accessor|get|set)(?![_$[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))","name":"storage.type.property.js"},"punctuation-accessor":{"captures":{"1":{"name":"punctuation.accessor.js"},"2":{"name":"punctuation.accessor.optional.js"}},"match":"(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*[[:digit:]])))"},"punctuation-comma":{"match":",","name":"punctuation.separator.comma.js"},"punctuation-semicolon":{"match":";","name":"punctuation.terminator.statement.js"},"qstring-double":{"begin":"\\"","beginCaptures":{"0":{"name":"punctuation.definition.string.begin.js"}},"end":"(\\")|((?:[^\\\\\\\\\\\\n])$)","endCaptures":{"1":{"name":"punctuation.definition.string.end.js"},"2":{"name":"invalid.illegal.newline.js"}},"name":"string.quoted.double.js","patterns":[{"include":"#string-character-escape"}]},"qstring-single":{"begin":"'","beginCaptures":{"0":{"name":"punctuation.definition.string.begin.js"}},"end":"(\\\\')|((?:[^\\\\\\\\\\\\n])$)","endCaptures":{"1":{"name":"punctuation.definition.string.end.js"},"2":{"name":"invalid.illegal.newline.js"}},"name":"string.quoted.single.js","patterns":[{"include":"#string-character-escape"}]},"regex":{"patterns":[{"begin":"(?<!\\\\+\\\\+|--|})(?<=[=(:,\\\\[?+!]|^return|[^\\\\._$[:alnum:]]return|^case|[^\\\\._$[:alnum:]]case|=>|&&|\\\\|\\\\||\\\\*\\\\/)\\\\s*(\\\\/)(?![\\\\/*])(?=(?:[^\\\\/\\\\\\\\\\\\[\\\\()]|\\\\\\\\.|\\\\[([^\\\\]\\\\\\\\]|\\\\\\\\.)+\\\\]|\\\\(([^\\\\)\\\\\\\\]|\\\\\\\\.)+\\\\))+\\\\/([dgimsuvy]+|(?![\\\\/\\\\*])|(?=\\\\/\\\\*))(?!\\\\s*[a-zA-Z0-9_$]))","beginCaptures":{"1":{"name":"punctuation.definition.string.begin.js"}},"end":"(/)([dgimsuvy]*)","endCaptures":{"1":{"name":"punctuation.definition.string.end.js"},"2":{"name":"keyword.other.js"}},"name":"string.regexp.js","patterns":[{"include":"#regexp"}]},{"begin":"((?<![_$[:alnum:])\\\\]]|\\\\+\\\\+|--|}|\\\\*\\\\/)|((?<=^return|[^\\\\._$[:alnum:]]return|^case|[^\\\\._$[:alnum:]]case))\\\\s*)\\\\/(?![\\\\/*])(?=(?:[^\\\\/\\\\\\\\\\\\[]|\\\\\\\\.|\\\\[([^\\\\]\\\\\\\\]|\\\\\\\\.)*\\\\])+\\\\/([dgimsuvy]+|(?![\\\\/\\\\*])|(?=\\\\/\\\\*))(?!\\\\s*[a-zA-Z0-9_$]))","beginCaptures":{"0":{"name":"punctuation.definition.string.begin.js"}},"end":"(/)([dgimsuvy]*)","endCaptures":{"1":{"name":"punctuation.definition.string.end.js"},"2":{"name":"keyword.other.js"}},"name":"string.regexp.js","patterns":[{"include":"#regexp"}]}]},"regex-character-class":{"patterns":[{"match":"\\\\\\\\[wWsSdDtrnvf]|\\\\.","name":"constant.other.character-class.regexp"},{"match":"\\\\\\\\([0-7]{3}|x[0-9A-Fa-f]{2}|u[0-9A-Fa-f]{4})","name":"constant.character.numeric.regexp"},{"match":"\\\\\\\\c[A-Z]","name":"constant.character.control.regexp"},{"match":"\\\\\\\\.","name":"constant.character.escape.backslash.regexp"}]},"regexp":{"patterns":[{"match":"\\\\\\\\[bB]|\\\\^|\\\\$","name":"keyword.control.anchor.regexp"},{"captures":{"0":{"name":"keyword.other.back-reference.regexp"},"1":{"name":"variable.other.regexp"}},"match":"\\\\\\\\[1-9]\\\\d*|\\\\\\\\k<([a-zA-Z_$][\\\\w$]*)>"},{"match":"[?+*]|\\\\{(\\\\d+,\\\\d+|\\\\d+,|,\\\\d+|\\\\d+)\\\\}\\\\??","name":"keyword.operator.quantifier.regexp"},{"match":"\\\\|","name":"keyword.operator.or.regexp"},{"begin":"(\\\\()((\\\\?=)|(\\\\?!)|(\\\\?<=)|(\\\\?<!))","beginCaptures":{"1":{"name":"punctuation.definition.group.regexp"},"2":{"name":"punctuation.definition.group.assertion.regexp"},"3":{"name":"meta.assertion.look-ahead.regexp"},"4":{"name":"meta.assertion.negative-look-ahead.regexp"},"5":{"name":"meta.assertion.look-behind.regexp"},"6":{"name":"meta.assertion.negative-look-behind.regexp"}},"end":"(\\\\))","endCaptures":{"1":{"name":"punctuation.definition.group.regexp"}},"name":"meta.group.assertion.regexp","patterns":[{"include":"#regexp"}]},{"begin":"\\\\((?:(\\\\?:)|(?:\\\\?<([a-zA-Z_$][\\\\w$]*)>))?","beginCaptures":{"0":{"name":"punctuation.definition.group.regexp"},"1":{"name":"punctuation.definition.group.no-capture.regexp"},"2":{"name":"variable.other.regexp"}},"end":"\\\\)","endCaptures":{"0":{"name":"punctuation.definition.group.regexp"}},"name":"meta.group.regexp","patterns":[{"include":"#regexp"}]},{"begin":"(\\\\[)(\\\\^)?","beginCaptures":{"1":{"name":"punctuation.definition.character-class.regexp"},"2":{"name":"keyword.operator.negation.regexp"}},"end":"(\\\\])","endCaptures":{"1":{"name":"punctuation.definition.character-class.regexp"}},"name":"constant.other.character-class.set.regexp","patterns":[{"captures":{"1":{"name":"constant.character.numeric.regexp"},"2":{"name":"constant.character.control.regexp"},"3":{"name":"constant.character.escape.backslash.regexp"},"4":{"name":"constant.character.numeric.regexp"},"5":{"name":"constant.character.control.regexp"},"6":{"name":"constant.character.escape.backslash.regexp"}},"match":"(?:.|(\\\\\\\\(?:[0-7]{3}|x[0-9A-Fa-f]{2}|u[0-9A-Fa-f]{4}))|(\\\\\\\\c[A-Z])|(\\\\\\\\.))\\\\-(?:[^\\\\]\\\\\\\\]|(\\\\\\\\(?:[0-7]{3}|x[0-9A-Fa-f]{2}|u[0-9A-Fa-f]{4}))|(\\\\\\\\c[A-Z])|(\\\\\\\\.))","name":"constant.other.character-class.range.regexp"},{"include":"#regex-character-class"}]},{"include":"#regex-character-class"}]},"return-type":{"patterns":[{"begin":"(?<=\\\\))\\\\s*(:)(?=\\\\s*\\\\S)","beginCaptures":{"1":{"name":"keyword.operator.type.annotation.js"}},"end":"(?<![:|&])(?=$|^|[{};,]|//)","name":"meta.return.type.js","patterns":[{"include":"#return-type-core"}]},{"begin":"(?<=\\\\))\\\\s*(:)","beginCaptures":{"1":{"name":"keyword.operator.type.annotation.js"}},"end":"(?<![:|&])((?=[{};,]|//|^\\\\s*$)|((?<=\\\\S)(?=\\\\s*$)))","name":"meta.return.type.js","patterns":[{"include":"#return-type-core"}]}]},"return-type-core":{"patterns":[{"include":"#comment"},{"begin":"(?<=[:|&])(?=\\\\s*\\\\{)","end":"(?<=\\\\})","patterns":[{"include":"#type-object"}]},{"include":"#type-predicate-operator"},{"include":"#type"}]},"shebang":{"captures":{"1":{"name":"punctuation.definition.comment.js"}},"match":"\\\\A(#!).*(?=$)","name":"comment.line.shebang.js"},"single-line-comment-consuming-line-ending":{"begin":"(^[ \\\\t]+)?((//)(?:\\\\s*((@)internal)(?=\\\\s|$))?)","beginCaptures":{"1":{"name":"punctuation.whitespace.comment.leading.js"},"2":{"name":"comment.line.double-slash.js"},"3":{"name":"punctuation.definition.comment.js"},"4":{"name":"storage.type.internaldeclaration.js"},"5":{"name":"punctuation.decorator.internaldeclaration.js"}},"contentName":"comment.line.double-slash.js","end":"(?=^)"},"statements":{"patterns":[{"include":"#declaration"},{"include":"#control-statement"},{"include":"#after-operator-block-as-object-literal"},{"include":"#decl-block"},{"include":"#label"},{"include":"#expression"},{"include":"#punctuation-semicolon"},{"include":"#string"},{"include":"#comment"}]},"string":{"patterns":[{"include":"#qstring-single"},{"include":"#qstring-double"},{"include":"#template"}]},"string-character-escape":{"match":"\\\\\\\\(x[0-9A-Fa-f]{2}|u[0-9A-Fa-f]{4}|u\\\\{[0-9A-Fa-f]+\\\\}|[0-2][0-7]{0,2}|3[0-6][0-7]?|37[0-7]?|[4-7][0-7]?|.|$)","name":"constant.character.escape.js"},"super-literal":{"match":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))super\\\\b(?!\\\\$)","name":"variable.language.super.js"},"support-function-call-identifiers":{"patterns":[{"include":"#literal"},{"include":"#support-objects"},{"include":"#object-identifiers"},{"include":"#punctuation-accessor"},{"match":"(?:(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))import(?=\\\\s*[\\\\(]\\\\s*[\\\\\\"\\\\'\\\\\`]))","name":"keyword.operator.expression.import.js"}]},"support-objects":{"patterns":[{"match":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(arguments)\\\\b(?!\\\\$)","name":"variable.language.arguments.js"},{"match":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(Promise)\\\\b(?!\\\\$)","name":"support.class.promise.js"},{"captures":{"1":{"name":"keyword.control.import.js"},"2":{"name":"punctuation.accessor.js"},"3":{"name":"punctuation.accessor.optional.js"},"4":{"name":"support.variable.property.importmeta.js"}},"match":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(import)\\\\s*(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*[[:digit:]])))\\\\s*(meta)\\\\b(?!\\\\$)"},{"captures":{"1":{"name":"keyword.operator.new.js"},"2":{"name":"punctuation.accessor.js"},"3":{"name":"punctuation.accessor.optional.js"},"4":{"name":"support.variable.property.target.js"}},"match":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(new)\\\\s*(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*[[:digit:]])))\\\\s*(target)\\\\b(?!\\\\$)"},{"captures":{"1":{"name":"punctuation.accessor.js"},"2":{"name":"punctuation.accessor.optional.js"},"3":{"name":"support.variable.property.js"},"4":{"name":"support.constant.js"}},"match":"(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*[[:digit:]])))\\\\s*(?:(?:(constructor|length|prototype|__proto__)\\\\b(?!\\\\$|\\\\s*(<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<]|\\\\<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<]|\\\\<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<])*\\\\>)*\\\\>)*>\\\\s*)?\\\\())|(?:(EPSILON|MAX_SAFE_INTEGER|MAX_VALUE|MIN_SAFE_INTEGER|MIN_VALUE|NEGATIVE_INFINITY|POSITIVE_INFINITY)\\\\b(?!\\\\$)))"},{"captures":{"1":{"name":"support.type.object.module.js"},"2":{"name":"support.type.object.module.js"},"3":{"name":"punctuation.accessor.js"},"4":{"name":"punctuation.accessor.optional.js"},"5":{"name":"support.type.object.module.js"}},"match":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(exports)|(module)(?:(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*[[:digit:]])))(exports|id|filename|loaded|parent|children))?)\\\\b(?!\\\\$)"}]},"switch-statement":{"begin":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?=\\\\bswitch\\\\s*\\\\()","end":"\\\\}","endCaptures":{"0":{"name":"punctuation.definition.block.js"}},"name":"switch-statement.expr.js","patterns":[{"include":"#comment"},{"begin":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(switch)\\\\s*(\\\\()","beginCaptures":{"1":{"name":"keyword.control.switch.js"},"2":{"name":"meta.brace.round.js"}},"end":"\\\\)","endCaptures":{"0":{"name":"meta.brace.round.js"}},"name":"switch-expression.expr.js","patterns":[{"include":"#expression"}]},{"begin":"\\\\{","beginCaptures":{"0":{"name":"punctuation.definition.block.js"}},"end":"(?=\\\\})","name":"switch-block.expr.js","patterns":[{"begin":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(case|default(?=:))(?![_$[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))","beginCaptures":{"1":{"name":"keyword.control.switch.js"}},"end":"(?=:)","name":"case-clause.expr.js","patterns":[{"include":"#expression"}]},{"begin":"(:)\\\\s*(\\\\{)","beginCaptures":{"1":{"name":"case-clause.expr.js punctuation.definition.section.case-statement.js"},"2":{"name":"meta.block.js punctuation.definition.block.js"}},"contentName":"meta.block.js","end":"\\\\}","endCaptures":{"0":{"name":"meta.block.js punctuation.definition.block.js"}},"patterns":[{"include":"#statements"}]},{"captures":{"0":{"name":"case-clause.expr.js punctuation.definition.section.case-statement.js"}},"match":"(:)"},{"include":"#statements"}]}]},"template":{"patterns":[{"include":"#template-call"},{"begin":"([_$[:alpha:]][_$[:alnum:]]*)?(\`)","beginCaptures":{"1":{"name":"entity.name.function.tagged-template.js"},"2":{"name":"string.template.js punctuation.definition.string.template.begin.js"}},"contentName":"string.template.js","end":"\`","endCaptures":{"0":{"name":"string.template.js punctuation.definition.string.template.end.js"}},"patterns":[{"include":"#template-substitution-element"},{"include":"#string-character-escape"}]}]},"template-call":{"patterns":[{"begin":"(?=(([_$[:alpha:]][_$[:alnum:]]*\\\\s*\\\\??\\\\.\\\\s*)*|(\\\\??\\\\.\\\\s*)?)([_$[:alpha:]][_$[:alnum:]]*)(<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([_$[:alpha:]][_$[:alnum:]]*|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\])|(\\\\'([^\\\\'\\\\\\\\]|\\\\\\\\.)*\\\\')|(\\\\\\"([^\\\\\\"\\\\\\\\]|\\\\\\\\.)*\\\\\\")|(\\\\\`([^\\\\\`\\\\\\\\]|\\\\\\\\.)*\\\\\`))(?=\\\\s*([\\\\<\\\\>\\\\,\\\\.\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^<>\\\\(]|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(?<==)\\\\>|\\\\<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([_$[:alpha:]][_$[:alnum:]]*|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\])|(\\\\'([^\\\\'\\\\\\\\]|\\\\\\\\.)*\\\\')|(\\\\\\"([^\\\\\\"\\\\\\\\]|\\\\\\\\.)*\\\\\\")|(\\\\\`([^\\\\\`\\\\\\\\]|\\\\\\\\.)*\\\\\`))(?=\\\\s*([\\\\<\\\\>\\\\,\\\\.\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))(([^<>\\\\(]|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(?<==)\\\\>|\\\\<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([_$[:alpha:]][_$[:alnum:]]*|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\])|(\\\\'([^\\\\'\\\\\\\\]|\\\\\\\\.)*\\\\')|(\\\\\\"([^\\\\\\"\\\\\\\\]|\\\\\\\\.)*\\\\\\")|(\\\\\`([^\\\\\`\\\\\\\\]|\\\\\\\\.)*\\\\\`))(?=\\\\s*([\\\\<\\\\>\\\\,\\\\.\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^<>\\\\(]|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(?<==)\\\\>)*(?<!=)\\\\>))*(?<!=)\\\\>)*(?<!=)>\\\\s*)?\`)","end":"(?=\`)","patterns":[{"begin":"(?=(([_$[:alpha:]][_$[:alnum:]]*\\\\s*\\\\??\\\\.\\\\s*)*|(\\\\??\\\\.\\\\s*)?)([_$[:alpha:]][_$[:alnum:]]*))","end":"(?=(<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([_$[:alpha:]][_$[:alnum:]]*|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\])|(\\\\'([^\\\\'\\\\\\\\]|\\\\\\\\.)*\\\\')|(\\\\\\"([^\\\\\\"\\\\\\\\]|\\\\\\\\.)*\\\\\\")|(\\\\\`([^\\\\\`\\\\\\\\]|\\\\\\\\.)*\\\\\`))(?=\\\\s*([\\\\<\\\\>\\\\,\\\\.\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^<>\\\\(]|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(?<==)\\\\>|\\\\<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([_$[:alpha:]][_$[:alnum:]]*|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\])|(\\\\'([^\\\\'\\\\\\\\]|\\\\\\\\.)*\\\\')|(\\\\\\"([^\\\\\\"\\\\\\\\]|\\\\\\\\.)*\\\\\\")|(\\\\\`([^\\\\\`\\\\\\\\]|\\\\\\\\.)*\\\\\`))(?=\\\\s*([\\\\<\\\\>\\\\,\\\\.\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))(([^<>\\\\(]|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(?<==)\\\\>|\\\\<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([_$[:alpha:]][_$[:alnum:]]*|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\])|(\\\\'([^\\\\'\\\\\\\\]|\\\\\\\\.)*\\\\')|(\\\\\\"([^\\\\\\"\\\\\\\\]|\\\\\\\\.)*\\\\\\")|(\\\\\`([^\\\\\`\\\\\\\\]|\\\\\\\\.)*\\\\\`))(?=\\\\s*([\\\\<\\\\>\\\\,\\\\.\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^<>\\\\(]|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(?<==)\\\\>)*(?<!=)\\\\>))*(?<!=)\\\\>)*(?<!=)>\\\\s*)?\`)","patterns":[{"include":"#support-function-call-identifiers"},{"match":"([_$[:alpha:]][_$[:alnum:]]*)","name":"entity.name.function.tagged-template.js"}]},{"include":"#type-arguments"}]},{"begin":"([_$[:alpha:]][_$[:alnum:]]*)?\\\\s*(?=(<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([_$[:alpha:]][_$[:alnum:]]*|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\])|(\\\\'([^\\\\'\\\\\\\\]|\\\\\\\\.)*\\\\')|(\\\\\\"([^\\\\\\"\\\\\\\\]|\\\\\\\\.)*\\\\\\")|(\\\\\`([^\\\\\`\\\\\\\\]|\\\\\\\\.)*\\\\\`))(?=\\\\s*([\\\\<\\\\>\\\\,\\\\.\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^<>\\\\(]|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(?<==)\\\\>|\\\\<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([_$[:alpha:]][_$[:alnum:]]*|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\])|(\\\\'([^\\\\'\\\\\\\\]|\\\\\\\\.)*\\\\')|(\\\\\\"([^\\\\\\"\\\\\\\\]|\\\\\\\\.)*\\\\\\")|(\\\\\`([^\\\\\`\\\\\\\\]|\\\\\\\\.)*\\\\\`))(?=\\\\s*([\\\\<\\\\>\\\\,\\\\.\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))(([^<>\\\\(]|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(?<==)\\\\>|\\\\<\\\\s*(((keyof|infer|typeof|readonly)\\\\s+)|(([_$[:alpha:]][_$[:alnum:]]*|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\])|(\\\\'([^\\\\'\\\\\\\\]|\\\\\\\\.)*\\\\')|(\\\\\\"([^\\\\\\"\\\\\\\\]|\\\\\\\\.)*\\\\\\")|(\\\\\`([^\\\\\`\\\\\\\\]|\\\\\\\\.)*\\\\\`))(?=\\\\s*([\\\\<\\\\>\\\\,\\\\.\\\\[]|=>|&(?!&)|\\\\|(?!\\\\|)))))([^<>\\\\(]|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(?<==)\\\\>)*(?<!=)\\\\>))*(?<!=)\\\\>)*(?<!=)>\\\\s*)\`)","beginCaptures":{"1":{"name":"entity.name.function.tagged-template.js"}},"end":"(?=\`)","patterns":[{"include":"#type-arguments"}]}]},"template-substitution-element":{"begin":"\\\\$\\\\{","beginCaptures":{"0":{"name":"punctuation.definition.template-expression.begin.js"}},"contentName":"meta.embedded.line.js","end":"\\\\}","endCaptures":{"0":{"name":"punctuation.definition.template-expression.end.js"}},"name":"meta.template.expression.js","patterns":[{"include":"#expression"}]},"template-type":{"patterns":[{"include":"#template-call"},{"begin":"([_$[:alpha:]][_$[:alnum:]]*)?(\`)","beginCaptures":{"1":{"name":"entity.name.function.tagged-template.js"},"2":{"name":"string.template.js punctuation.definition.string.template.begin.js"}},"contentName":"string.template.js","end":"\`","endCaptures":{"0":{"name":"string.template.js punctuation.definition.string.template.end.js"}},"patterns":[{"include":"#template-type-substitution-element"},{"include":"#string-character-escape"}]}]},"template-type-substitution-element":{"begin":"\\\\$\\\\{","beginCaptures":{"0":{"name":"punctuation.definition.template-expression.begin.js"}},"contentName":"meta.embedded.line.js","end":"\\\\}","endCaptures":{"0":{"name":"punctuation.definition.template-expression.end.js"}},"name":"meta.template.expression.js","patterns":[{"include":"#type"}]},"ternary-expression":{"begin":"(?!\\\\?\\\\.\\\\s*[^[:digit:]])(\\\\?)(?!\\\\?)","beginCaptures":{"1":{"name":"keyword.operator.ternary.js"}},"end":"\\\\s*(:)","endCaptures":{"1":{"name":"keyword.operator.ternary.js"}},"patterns":[{"include":"#expression"}]},"this-literal":{"match":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))this\\\\b(?!\\\\$)","name":"variable.language.this.js"},"type":{"patterns":[{"include":"#comment"},{"include":"#type-string"},{"include":"#numeric-literal"},{"include":"#type-primitive"},{"include":"#type-builtin-literals"},{"include":"#type-parameters"},{"include":"#type-tuple"},{"include":"#type-object"},{"include":"#type-operators"},{"include":"#type-conditional"},{"include":"#type-fn-type-parameters"},{"include":"#type-paren-or-function-parameters"},{"include":"#type-function-return-type"},{"captures":{"1":{"name":"storage.modifier.js"}},"match":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(readonly)(?![_$[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\\\\s*"},{"include":"#type-name"}]},"type-alias-declaration":{"begin":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(\\\\bexport)\\\\s+)?(?:(\\\\bdeclare)\\\\s+)?\\\\b(type)\\\\b\\\\s+([_$[:alpha:]][_$[:alnum:]]*)\\\\s*","beginCaptures":{"1":{"name":"keyword.control.export.js"},"2":{"name":"storage.modifier.js"},"3":{"name":"storage.type.type.js"},"4":{"name":"entity.name.type.alias.js"}},"end":"(?=\\\\}|;|^\\\\s*$|(?:^\\\\s*(?:abstract|async|(?:\\\\bawait\\\\s+(?:\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[_$[:alpha:]])\\\\b)\\\\b)|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|(?:\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[_$[:alpha:]])\\\\b)|var|while)\\\\b))","name":"meta.type.declaration.js","patterns":[{"include":"#comment"},{"include":"#type-parameters"},{"begin":"(=)\\\\s*(intrinsic)(?![_$[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))","beginCaptures":{"1":{"name":"keyword.operator.assignment.js"},"2":{"name":"keyword.control.intrinsic.js"}},"end":"(?=\\\\}|;|^\\\\s*$|(?:^\\\\s*(?:abstract|async|(?:\\\\bawait\\\\s+(?:\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[_$[:alpha:]])\\\\b)\\\\b)|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|(?:\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[_$[:alpha:]])\\\\b)|var|while)\\\\b))","patterns":[{"include":"#type"}]},{"begin":"(=)\\\\s*","beginCaptures":{"1":{"name":"keyword.operator.assignment.js"}},"end":"(?=\\\\}|;|^\\\\s*$|(?:^\\\\s*(?:abstract|async|(?:\\\\bawait\\\\s+(?:\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[_$[:alpha:]])\\\\b)\\\\b)|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|(?:\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[_$[:alpha:]])\\\\b)|var|while)\\\\b))","patterns":[{"include":"#type"}]}]},"type-annotation":{"patterns":[{"begin":"(:)(?=\\\\s*\\\\S)","beginCaptures":{"1":{"name":"keyword.operator.type.annotation.js"}},"end":"(?<![:|&])(?!\\\\s*[|&]\\\\s+)((?=^|[,);\\\\}\\\\]]|//)|(?==[^>])|((?<=[\\\\}>\\\\]\\\\)]|[_$[:alpha:]])\\\\s*(?=\\\\{)))","name":"meta.type.annotation.js","patterns":[{"include":"#type"}]},{"begin":"(:)","beginCaptures":{"1":{"name":"keyword.operator.type.annotation.js"}},"end":"(?<![:|&])((?=[,);\\\\}\\\\]]|\\\\/\\\\/)|(?==[^>])|(?=^\\\\s*$)|((?<=[\\\\}>\\\\]\\\\)]|[_$[:alpha:]])\\\\s*(?=\\\\{)))","name":"meta.type.annotation.js","patterns":[{"include":"#type"}]}]},"type-arguments":{"begin":"\\\\<","beginCaptures":{"0":{"name":"punctuation.definition.typeparameters.begin.js"}},"end":"\\\\>","endCaptures":{"0":{"name":"punctuation.definition.typeparameters.end.js"}},"name":"meta.type.parameters.js","patterns":[{"include":"#type-arguments-body"}]},"type-arguments-body":{"patterns":[{"captures":{"0":{"name":"keyword.operator.type.js"}},"match":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(_)(?![_$[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))"},{"include":"#type"},{"include":"#punctuation-comma"}]},"type-builtin-literals":{"match":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(this|true|false|undefined|null|object)(?![_$[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))","name":"support.type.builtin.js"},"type-conditional":{"patterns":[{"begin":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(extends)\\\\s+","beginCaptures":{"1":{"name":"storage.modifier.js"}},"end":"(?<=:)","patterns":[{"begin":"\\\\?","beginCaptures":{"0":{"name":"keyword.operator.ternary.js"}},"end":":","endCaptures":{"0":{"name":"keyword.operator.ternary.js"}},"patterns":[{"include":"#type"}]},{"include":"#type"}]}]},"type-fn-type-parameters":{"patterns":[{"begin":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(abstract)\\\\s+)?(new)\\\\b(?=\\\\s*\\\\<)","beginCaptures":{"1":{"name":"meta.type.constructor.js storage.modifier.js"},"2":{"name":"meta.type.constructor.js keyword.control.new.js"}},"end":"(?<=>)","patterns":[{"include":"#comment"},{"include":"#type-parameters"}]},{"begin":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(abstract)\\\\s+)?(new)\\\\b\\\\s*(?=\\\\()","beginCaptures":{"1":{"name":"storage.modifier.js"},"2":{"name":"keyword.control.new.js"}},"end":"(?<=\\\\))","name":"meta.type.constructor.js","patterns":[{"include":"#function-parameters"}]},{"begin":"((?=[(]\\\\s*(([)])|(\\\\.\\\\.\\\\.)|([_$[:alnum:]]+\\\\s*(([:,?=])|([)]\\\\s*=>))))))","end":"(?<=\\\\))","name":"meta.type.function.js","patterns":[{"include":"#function-parameters"}]}]},"type-function-return-type":{"patterns":[{"begin":"(=>)(?=\\\\s*\\\\S)","beginCaptures":{"1":{"name":"storage.type.function.arrow.js"}},"end":"(?<!=>)(?<![|&])(?=[,\\\\]\\\\)\\\\{\\\\}=;>:\\\\?]|//|$)","name":"meta.type.function.return.js","patterns":[{"include":"#type-function-return-type-core"}]},{"begin":"=>","beginCaptures":{"0":{"name":"storage.type.function.arrow.js"}},"end":"(?<!=>)(?<![|&])((?=[,\\\\]\\\\)\\\\{\\\\}=;:\\\\?>]|//|^\\\\s*$)|((?<=\\\\S)(?=\\\\s*$)))","name":"meta.type.function.return.js","patterns":[{"include":"#type-function-return-type-core"}]}]},"type-function-return-type-core":{"patterns":[{"include":"#comment"},{"begin":"(?<==>)(?=\\\\s*\\\\{)","end":"(?<=\\\\})","patterns":[{"include":"#type-object"}]},{"include":"#type-predicate-operator"},{"include":"#type"}]},"type-infer":{"patterns":[{"captures":{"1":{"name":"keyword.operator.expression.infer.js"},"2":{"name":"entity.name.type.js"},"3":{"name":"keyword.operator.expression.extends.js"}},"match":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(infer)\\\\s+([_$[:alpha:]][_$[:alnum:]]*)(?![_$[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))(?:\\\\s+(extends)(?![_$[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))?","name":"meta.type.infer.js"}]},"type-name":{"patterns":[{"begin":"([_$[:alpha:]][_$[:alnum:]]*)\\\\s*(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*[[:digit:]])))\\\\s*(<)","captures":{"1":{"name":"entity.name.type.module.js"},"2":{"name":"punctuation.accessor.js"},"3":{"name":"punctuation.accessor.optional.js"},"4":{"name":"meta.type.parameters.js punctuation.definition.typeparameters.begin.js"}},"contentName":"meta.type.parameters.js","end":"(>)","endCaptures":{"1":{"name":"meta.type.parameters.js punctuation.definition.typeparameters.end.js"}},"patterns":[{"include":"#type-arguments-body"}]},{"begin":"([_$[:alpha:]][_$[:alnum:]]*)\\\\s*(<)","beginCaptures":{"1":{"name":"entity.name.type.js"},"2":{"name":"meta.type.parameters.js punctuation.definition.typeparameters.begin.js"}},"contentName":"meta.type.parameters.js","end":"(>)","endCaptures":{"1":{"name":"meta.type.parameters.js punctuation.definition.typeparameters.end.js"}},"patterns":[{"include":"#type-arguments-body"}]},{"captures":{"1":{"name":"entity.name.type.module.js"},"2":{"name":"punctuation.accessor.js"},"3":{"name":"punctuation.accessor.optional.js"}},"match":"([_$[:alpha:]][_$[:alnum:]]*)\\\\s*(?:(\\\\.)|(\\\\?\\\\.(?!\\\\s*[[:digit:]])))"},{"match":"[_$[:alpha:]][_$[:alnum:]]*","name":"entity.name.type.js"}]},"type-object":{"begin":"\\\\{","beginCaptures":{"0":{"name":"punctuation.definition.block.js"}},"end":"\\\\}","endCaptures":{"0":{"name":"punctuation.definition.block.js"}},"name":"meta.object.type.js","patterns":[{"include":"#comment"},{"include":"#method-declaration"},{"include":"#indexer-declaration"},{"include":"#indexer-mapped-type-declaration"},{"include":"#field-declaration"},{"include":"#type-annotation"},{"begin":"\\\\.\\\\.\\\\.","beginCaptures":{"0":{"name":"keyword.operator.spread.js"}},"end":"(?=\\\\}|;|,|$)|(?<=\\\\})","patterns":[{"include":"#type"}]},{"include":"#punctuation-comma"},{"include":"#punctuation-semicolon"},{"include":"#type"}]},"type-operators":{"patterns":[{"include":"#typeof-operator"},{"include":"#type-infer"},{"begin":"([&|])(?=\\\\s*\\\\{)","beginCaptures":{"0":{"name":"keyword.operator.type.js"}},"end":"(?<=\\\\})","patterns":[{"include":"#type-object"}]},{"begin":"[&|]","beginCaptures":{"0":{"name":"keyword.operator.type.js"}},"end":"(?=\\\\S)"},{"match":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))keyof(?![_$[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))","name":"keyword.operator.expression.keyof.js"},{"match":"(\\\\?|\\\\:)","name":"keyword.operator.ternary.js"},{"match":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))import(?=\\\\s*\\\\()","name":"keyword.operator.expression.import.js"}]},"type-parameters":{"begin":"(<)","beginCaptures":{"1":{"name":"punctuation.definition.typeparameters.begin.js"}},"end":"(>)","endCaptures":{"1":{"name":"punctuation.definition.typeparameters.end.js"}},"name":"meta.type.parameters.js","patterns":[{"include":"#comment"},{"match":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(extends|in|out|const)(?![_$[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))","name":"storage.modifier.js"},{"include":"#type"},{"include":"#punctuation-comma"},{"match":"(=)(?!>)","name":"keyword.operator.assignment.js"}]},"type-paren-or-function-parameters":{"begin":"\\\\(","beginCaptures":{"0":{"name":"meta.brace.round.js"}},"end":"\\\\)","endCaptures":{"0":{"name":"meta.brace.round.js"}},"name":"meta.type.paren.cover.js","patterns":[{"captures":{"1":{"name":"storage.modifier.js"},"2":{"name":"keyword.operator.rest.js"},"3":{"name":"entity.name.function.js variable.language.this.js"},"4":{"name":"entity.name.function.js"},"5":{"name":"keyword.operator.optional.js"}},"match":"(?:(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(public|private|protected|readonly)\\\\s+)?(?:(\\\\.\\\\.\\\\.)\\\\s*)?(?<!=|:)(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(this)|([_$[:alpha:]][_$[:alnum:]]*))\\\\s*(\\\\??)(?=\\\\s*(:\\\\s*((<)|([(]\\\\s*(([)])|(\\\\.\\\\.\\\\.)|([_$[:alnum:]]+\\\\s*(([:,?=])|([)]\\\\s*=>)))))))|(:\\\\s*(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))Function(?![_$[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|(:\\\\s*((<\\\\s*$)|([\\\\(]\\\\s*((([\\\\{\\\\[]\\\\s*)?$)|((\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})\\\\s*((:\\\\s*\\\\{?$)|((\\\\s*([^<>\\\\(\\\\)\\\\{\\\\}]|\\\\<([^<>]|\\\\<([^<>]|\\\\<[^<>]+\\\\>)+\\\\>)+\\\\>|\\\\([^\\\\(\\\\)]+\\\\)|\\\\{[^\\\\{\\\\}]+\\\\})+\\\\s*)?=\\\\s*)))|((\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\])\\\\s*((:\\\\s*\\\\[?$)|((\\\\s*([^<>\\\\(\\\\)\\\\{\\\\}]|\\\\<([^<>]|\\\\<([^<>]|\\\\<[^<>]+\\\\>)+\\\\>)+\\\\>|\\\\([^\\\\(\\\\)]+\\\\)|\\\\{[^\\\\{\\\\}]+\\\\})+\\\\s*)?=\\\\s*))))))))"},{"captures":{"1":{"name":"storage.modifier.js"},"2":{"name":"keyword.operator.rest.js"},"3":{"name":"variable.parameter.js variable.language.this.js"},"4":{"name":"variable.parameter.js"},"5":{"name":"keyword.operator.optional.js"}},"match":"(?:(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(public|private|protected|readonly)\\\\s+)?(?:(\\\\.\\\\.\\\\.)\\\\s*)?(?<!=|:)(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(this)|([_$[:alpha:]][_$[:alnum:]]*))\\\\s*(\\\\??)(?=:)"},{"include":"#type-annotation"},{"match":",","name":"punctuation.separator.parameter.js"},{"include":"#type"}]},"type-predicate-operator":{"patterns":[{"captures":{"1":{"name":"keyword.operator.type.asserts.js"},"2":{"name":"variable.parameter.js variable.language.this.js"},"3":{"name":"variable.parameter.js"},"4":{"name":"keyword.operator.expression.is.js"}},"match":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(asserts)\\\\s+)?(?!asserts)(?:(this)|([_$[:alpha:]][_$[:alnum:]]*))\\\\s(is)(?![_$[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))"},{"captures":{"1":{"name":"keyword.operator.type.asserts.js"},"2":{"name":"variable.parameter.js variable.language.this.js"},"3":{"name":"variable.parameter.js"}},"match":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(asserts)\\\\s+(?!is)(?:(this)|([_$[:alpha:]][_$[:alnum:]]*))(?![_$[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))"},{"match":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))asserts(?![_$[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))","name":"keyword.operator.type.asserts.js"},{"match":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))is(?![_$[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))","name":"keyword.operator.expression.is.js"}]},"type-primitive":{"match":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(string|number|bigint|boolean|symbol|any|void|never|unknown)(?![_$[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))","name":"support.type.primitive.js"},"type-string":{"patterns":[{"include":"#qstring-single"},{"include":"#qstring-double"},{"include":"#template-type"}]},"type-tuple":{"begin":"\\\\[","beginCaptures":{"0":{"name":"meta.brace.square.js"}},"end":"\\\\]","endCaptures":{"0":{"name":"meta.brace.square.js"}},"name":"meta.type.tuple.js","patterns":[{"match":"\\\\.\\\\.\\\\.","name":"keyword.operator.rest.js"},{"captures":{"1":{"name":"entity.name.label.js"},"2":{"name":"keyword.operator.optional.js"},"3":{"name":"punctuation.separator.label.js"}},"match":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))([_$[:alpha:]][_$[:alnum:]]*)\\\\s*(\\\\?)?\\\\s*(:)"},{"include":"#type"},{"include":"#punctuation-comma"}]},"typeof-operator":{"begin":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))typeof(?![_$[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))","beginCaptures":{"0":{"name":"keyword.operator.expression.typeof.js"}},"end":"(?=[,);}\\\\]=>:&|{\\\\?]|(extends\\\\s+)|$|;|^\\\\s*$|(?:^\\\\s*(?:abstract|async|(?:\\\\bawait\\\\s+(?:\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[_$[:alpha:]])\\\\b)\\\\b)|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|(?:\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[_$[:alpha:]])\\\\b)|var|while)\\\\b))","patterns":[{"include":"#type-arguments"},{"include":"#expression"}]},"undefined-literal":{"match":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))undefined(?![_$[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))","name":"constant.language.undefined.js"},"var-expr":{"patterns":[{"begin":"(?=(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(\\\\bexport)\\\\s+)?(?:(\\\\bdeclare)\\\\s+)?\\\\b(var|let)(?![_$[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))","end":"(?!(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(\\\\bexport)\\\\s+)?(?:(\\\\bdeclare)\\\\s+)?\\\\b(var|let)(?![_$[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))((?=^|;|}|((?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|;|^\\\\s*$|(?:^\\\\s*(?:abstract|async|(?:\\\\bawait\\\\s+(?:\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[_$[:alpha:]])\\\\b)\\\\b)|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|(?:\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[_$[:alpha:]])\\\\b)|var|while)\\\\b))|((?<!^let|[^\\\\._$[:alnum:]]let|^var|[^\\\\._$[:alnum:]]var)(?=\\\\s*$)))","name":"meta.var.expr.js","patterns":[{"begin":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(\\\\bexport)\\\\s+)?(?:(\\\\bdeclare)\\\\s+)?\\\\b(var|let)(?![_$[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\\\\s*","beginCaptures":{"1":{"name":"keyword.control.export.js"},"2":{"name":"storage.modifier.js"},"3":{"name":"storage.type.js"}},"end":"(?=\\\\S)"},{"include":"#destructuring-variable"},{"include":"#var-single-variable"},{"include":"#variable-initializer"},{"include":"#comment"},{"begin":"(,)\\\\s*(?=$|\\\\/\\\\/)","beginCaptures":{"1":{"name":"punctuation.separator.comma.js"}},"end":"(?<!,)(((?==|;|}|((?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|^\\\\s*$))|((?<=\\\\S)(?=\\\\s*$)))","patterns":[{"include":"#single-line-comment-consuming-line-ending"},{"include":"#comment"},{"include":"#destructuring-variable"},{"include":"#var-single-variable"},{"include":"#punctuation-comma"}]},{"include":"#punctuation-comma"}]},{"begin":"(?=(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(\\\\bexport)\\\\s+)?(?:(\\\\bdeclare)\\\\s+)?\\\\b(const(?!\\\\s+enum\\\\b))(?![_$[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))","beginCaptures":{"1":{"name":"keyword.control.export.js"},"2":{"name":"storage.modifier.js"},"3":{"name":"storage.type.js"}},"end":"(?!(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(\\\\bexport)\\\\s+)?(?:(\\\\bdeclare)\\\\s+)?\\\\b(const(?!\\\\s+enum\\\\b))(?![_$[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))((?=^|;|}|((?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|;|^\\\\s*$|(?:^\\\\s*(?:abstract|async|(?:\\\\bawait\\\\s+(?:\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[_$[:alpha:]])\\\\b)\\\\b)|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|(?:\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[_$[:alpha:]])\\\\b)|var|while)\\\\b))|((?<!^const|[^\\\\._$[:alnum:]]const)(?=\\\\s*$)))","name":"meta.var.expr.js","patterns":[{"begin":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(\\\\bexport)\\\\s+)?(?:(\\\\bdeclare)\\\\s+)?\\\\b(const(?!\\\\s+enum\\\\b))(?![_$[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\\\\s*","beginCaptures":{"1":{"name":"keyword.control.export.js"},"2":{"name":"storage.modifier.js"},"3":{"name":"storage.type.js"}},"end":"(?=\\\\S)"},{"include":"#destructuring-const"},{"include":"#var-single-const"},{"include":"#variable-initializer"},{"include":"#comment"},{"begin":"(,)\\\\s*(?=$|\\\\/\\\\/)","beginCaptures":{"1":{"name":"punctuation.separator.comma.js"}},"end":"(?<!,)(((?==|;|}|((?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|^\\\\s*$))|((?<=\\\\S)(?=\\\\s*$)))","patterns":[{"include":"#single-line-comment-consuming-line-ending"},{"include":"#comment"},{"include":"#destructuring-const"},{"include":"#var-single-const"},{"include":"#punctuation-comma"}]},{"include":"#punctuation-comma"}]},{"begin":"(?=(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(\\\\bexport)\\\\s+)?(?:(\\\\bdeclare)\\\\s+)?\\\\b((?:\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[_$[:alpha:]])\\\\b)|(?:\\\\bawait\\\\s+(?:\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[_$[:alpha:]])\\\\b)\\\\b))(?![_$[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))","beginCaptures":{"1":{"name":"keyword.control.export.js"},"2":{"name":"storage.modifier.js"},"3":{"name":"storage.type.js"}},"end":"(?!(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(\\\\bexport)\\\\s+)?(?:(\\\\bdeclare)\\\\s+)?\\\\b((?:\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[_$[:alpha:]])\\\\b)|(?:\\\\bawait\\\\s+(?:\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[_$[:alpha:]])\\\\b)\\\\b))(?![_$[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))((?=;|}|((?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|;|^\\\\s*$|(?:^\\\\s*(?:abstract|async|(?:\\\\bawait\\\\s+(?:\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[_$[:alpha:]])\\\\b)\\\\b)|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|(?:\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[_$[:alpha:]])\\\\b)|var|while)\\\\b))|((?<!^using|[^\\\\._$[:alnum:]]using|^await\\\\s+using|[^\\\\._$[:alnum:]]await\\\\s+using)(?=\\\\s*$)))","name":"meta.var.expr.js","patterns":[{"begin":"(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(?:(\\\\bexport)\\\\s+)?(?:(\\\\bdeclare)\\\\s+)?\\\\b((?:\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[_$[:alpha:]])\\\\b)|(?:\\\\bawait\\\\s+(?:\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[_$[:alpha:]])\\\\b)\\\\b))(?![_$[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.))\\\\s*","beginCaptures":{"1":{"name":"keyword.control.export.js"},"2":{"name":"storage.modifier.js"},"3":{"name":"storage.type.js"}},"end":"(?=\\\\S)"},{"include":"#var-single-const"},{"include":"#variable-initializer"},{"include":"#comment"},{"begin":"(,)\\\\s*((?!\\\\S)|(?=\\\\/\\\\/))","beginCaptures":{"1":{"name":"punctuation.separator.comma.js"}},"end":"(?<!,)(((?==|;|}|((?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|^\\\\s*$))|((?<=\\\\S)(?=\\\\s*$)))","patterns":[{"include":"#single-line-comment-consuming-line-ending"},{"include":"#comment"},{"include":"#var-single-const"},{"include":"#punctuation-comma"}]},{"include":"#punctuation-comma"}]}]},"var-single-const":{"patterns":[{"begin":"([_$[:alpha:]][_$[:alnum:]]*)(?=\\\\s*(=\\\\s*(((async\\\\s+)?((function\\\\s*[(<*])|(function\\\\s+)|([_$[:alpha:]][_$[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*$)|([\\\\(]\\\\s*((([\\\\{\\\\[]\\\\s*)?$)|((\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})\\\\s*((:\\\\s*\\\\{?$)|((\\\\s*([^<>\\\\(\\\\)\\\\{\\\\}]|\\\\<([^<>]|\\\\<([^<>]|\\\\<[^<>]+\\\\>)+\\\\>)+\\\\>|\\\\([^\\\\(\\\\)]+\\\\)|\\\\{[^\\\\{\\\\}]+\\\\})+\\\\s*)?=\\\\s*)))|((\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\])\\\\s*((:\\\\s*\\\\[?$)|((\\\\s*([^<>\\\\(\\\\)\\\\{\\\\}]|\\\\<([^<>]|\\\\<([^<>]|\\\\<[^<>]+\\\\>)+\\\\>)+\\\\>|\\\\([^\\\\(\\\\)]+\\\\)|\\\\{[^\\\\{\\\\}]+\\\\})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<]|\\\\<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<]|\\\\<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<])*\\\\>)*\\\\>)*>\\\\s*)?[(]\\\\s*(\\\\/\\\\*([^\\\\*]|(\\\\*[^\\\\/]))*\\\\*\\\\/\\\\s*)*(([)]\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[_$[:alpha:]][_$[:alnum:]]*\\\\s*:)))|([<]\\\\s*[_$[:alpha:]][_$[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<]|\\\\<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<]|\\\\<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<])*\\\\>)*\\\\>)*>\\\\s*)?\\\\(\\\\s*(\\\\/\\\\*([^\\\\*]|(\\\\*[^\\\\/]))*\\\\*\\\\/\\\\s*)*(([_$[:alpha:]]|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\])|(\\\\.\\\\.\\\\.\\\\s*[_$[:alpha:]]))([^()\\\\'\\\\\\"\\\\\`]|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\'([^\\\\'\\\\\\\\]|\\\\\\\\.)*\\\\')|(\\\\\\"([^\\\\\\"\\\\\\\\]|\\\\\\\\.)*\\\\\\")|(\\\\\`([^\\\\\`\\\\\\\\]|\\\\\\\\.)*\\\\\`))*)?\\\\)(\\\\s*:\\\\s*([^<>\\\\(\\\\)\\\\{\\\\}]|\\\\<([^<>]|\\\\<([^<>]|\\\\<[^<>]+\\\\>)+\\\\>)+\\\\>|\\\\([^\\\\(\\\\)]+\\\\)|\\\\{[^\\\\{\\\\}]+\\\\})+)?\\\\s*=>)))))|(:\\\\s*((<)|([(]\\\\s*(([)])|(\\\\.\\\\.\\\\.)|([_$[:alnum:]]+\\\\s*(([:,?=])|([)]\\\\s*=>)))))))|(:\\\\s*(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))Function(?![_$[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|(:\\\\s*((<\\\\s*$)|([\\\\(]\\\\s*((([\\\\{\\\\[]\\\\s*)?$)|((\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})\\\\s*((:\\\\s*\\\\{?$)|((\\\\s*([^<>\\\\(\\\\)\\\\{\\\\}]|\\\\<([^<>]|\\\\<([^<>]|\\\\<[^<>]+\\\\>)+\\\\>)+\\\\>|\\\\([^\\\\(\\\\)]+\\\\)|\\\\{[^\\\\{\\\\}]+\\\\})+\\\\s*)?=\\\\s*)))|((\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\])\\\\s*((:\\\\s*\\\\[?$)|((\\\\s*([^<>\\\\(\\\\)\\\\{\\\\}]|\\\\<([^<>]|\\\\<([^<>]|\\\\<[^<>]+\\\\>)+\\\\>)+\\\\>|\\\\([^\\\\(\\\\)]+\\\\)|\\\\{[^\\\\{\\\\}]+\\\\})+\\\\s*)?=\\\\s*)))))))|(:\\\\s*(=>|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(<[^<>]*>)|[^<>(),=])+=\\\\s*(((async\\\\s+)?((function\\\\s*[(<*])|(function\\\\s+)|([_$[:alpha:]][_$[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*$)|([\\\\(]\\\\s*((([\\\\{\\\\[]\\\\s*)?$)|((\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})\\\\s*((:\\\\s*\\\\{?$)|((\\\\s*([^<>\\\\(\\\\)\\\\{\\\\}]|\\\\<([^<>]|\\\\<([^<>]|\\\\<[^<>]+\\\\>)+\\\\>)+\\\\>|\\\\([^\\\\(\\\\)]+\\\\)|\\\\{[^\\\\{\\\\}]+\\\\})+\\\\s*)?=\\\\s*)))|((\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\])\\\\s*((:\\\\s*\\\\[?$)|((\\\\s*([^<>\\\\(\\\\)\\\\{\\\\}]|\\\\<([^<>]|\\\\<([^<>]|\\\\<[^<>]+\\\\>)+\\\\>)+\\\\>|\\\\([^\\\\(\\\\)]+\\\\)|\\\\{[^\\\\{\\\\}]+\\\\})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<]|\\\\<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<]|\\\\<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<])*\\\\>)*\\\\>)*>\\\\s*)?[(]\\\\s*(\\\\/\\\\*([^\\\\*]|(\\\\*[^\\\\/]))*\\\\*\\\\/\\\\s*)*(([)]\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[_$[:alpha:]][_$[:alnum:]]*\\\\s*:)))|([<]\\\\s*[_$[:alpha:]][_$[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<]|\\\\<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<]|\\\\<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<])*\\\\>)*\\\\>)*>\\\\s*)?\\\\(\\\\s*(\\\\/\\\\*([^\\\\*]|(\\\\*[^\\\\/]))*\\\\*\\\\/\\\\s*)*(([_$[:alpha:]]|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\])|(\\\\.\\\\.\\\\.\\\\s*[_$[:alpha:]]))([^()\\\\'\\\\\\"\\\\\`]|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\'([^\\\\'\\\\\\\\]|\\\\\\\\.)*\\\\')|(\\\\\\"([^\\\\\\"\\\\\\\\]|\\\\\\\\.)*\\\\\\")|(\\\\\`([^\\\\\`\\\\\\\\]|\\\\\\\\.)*\\\\\`))*)?\\\\)(\\\\s*:\\\\s*([^<>\\\\(\\\\)\\\\{\\\\}]|\\\\<([^<>]|\\\\<([^<>]|\\\\<[^<>]+\\\\>)+\\\\>)+\\\\>|\\\\([^\\\\(\\\\)]+\\\\)|\\\\{[^\\\\{\\\\}]+\\\\})+)?\\\\s*=>))))))","beginCaptures":{"1":{"name":"meta.definition.variable.js variable.other.constant.js entity.name.function.js"}},"end":"(?=$|^|[;,=}]|((?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|(;|^\\\\s*$|(?:^\\\\s*(?:abstract|async|(?:\\\\bawait\\\\s+(?:\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[_$[:alpha:]])\\\\b)\\\\b)|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|(?:\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[_$[:alpha:]])\\\\b)|var|while)\\\\b)))","name":"meta.var-single-variable.expr.js","patterns":[{"include":"#var-single-variable-type-annotation"}]},{"begin":"([_$[:alpha:]][_$[:alnum:]]*)","beginCaptures":{"1":{"name":"meta.definition.variable.js variable.other.constant.js"}},"end":"(?=$|^|[;,=}]|((?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|(;|^\\\\s*$|(?:^\\\\s*(?:abstract|async|(?:\\\\bawait\\\\s+(?:\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[_$[:alpha:]])\\\\b)\\\\b)|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|(?:\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[_$[:alpha:]])\\\\b)|var|while)\\\\b)))","name":"meta.var-single-variable.expr.js","patterns":[{"include":"#var-single-variable-type-annotation"}]}]},"var-single-variable":{"patterns":[{"begin":"([_$[:alpha:]][_$[:alnum:]]*)(\\\\!)?(?=\\\\s*(=\\\\s*(((async\\\\s+)?((function\\\\s*[(<*])|(function\\\\s+)|([_$[:alpha:]][_$[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*$)|([\\\\(]\\\\s*((([\\\\{\\\\[]\\\\s*)?$)|((\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})\\\\s*((:\\\\s*\\\\{?$)|((\\\\s*([^<>\\\\(\\\\)\\\\{\\\\}]|\\\\<([^<>]|\\\\<([^<>]|\\\\<[^<>]+\\\\>)+\\\\>)+\\\\>|\\\\([^\\\\(\\\\)]+\\\\)|\\\\{[^\\\\{\\\\}]+\\\\})+\\\\s*)?=\\\\s*)))|((\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\])\\\\s*((:\\\\s*\\\\[?$)|((\\\\s*([^<>\\\\(\\\\)\\\\{\\\\}]|\\\\<([^<>]|\\\\<([^<>]|\\\\<[^<>]+\\\\>)+\\\\>)+\\\\>|\\\\([^\\\\(\\\\)]+\\\\)|\\\\{[^\\\\{\\\\}]+\\\\})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<]|\\\\<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<]|\\\\<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<])*\\\\>)*\\\\>)*>\\\\s*)?[(]\\\\s*(\\\\/\\\\*([^\\\\*]|(\\\\*[^\\\\/]))*\\\\*\\\\/\\\\s*)*(([)]\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[_$[:alpha:]][_$[:alnum:]]*\\\\s*:)))|([<]\\\\s*[_$[:alpha:]][_$[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<]|\\\\<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<]|\\\\<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<])*\\\\>)*\\\\>)*>\\\\s*)?\\\\(\\\\s*(\\\\/\\\\*([^\\\\*]|(\\\\*[^\\\\/]))*\\\\*\\\\/\\\\s*)*(([_$[:alpha:]]|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\])|(\\\\.\\\\.\\\\.\\\\s*[_$[:alpha:]]))([^()\\\\'\\\\\\"\\\\\`]|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\'([^\\\\'\\\\\\\\]|\\\\\\\\.)*\\\\')|(\\\\\\"([^\\\\\\"\\\\\\\\]|\\\\\\\\.)*\\\\\\")|(\\\\\`([^\\\\\`\\\\\\\\]|\\\\\\\\.)*\\\\\`))*)?\\\\)(\\\\s*:\\\\s*([^<>\\\\(\\\\)\\\\{\\\\}]|\\\\<([^<>]|\\\\<([^<>]|\\\\<[^<>]+\\\\>)+\\\\>)+\\\\>|\\\\([^\\\\(\\\\)]+\\\\)|\\\\{[^\\\\{\\\\}]+\\\\})+)?\\\\s*=>)))))|(:\\\\s*((<)|([(]\\\\s*(([)])|(\\\\.\\\\.\\\\.)|([_$[:alnum:]]+\\\\s*(([:,?=])|([)]\\\\s*=>)))))))|(:\\\\s*(?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))Function(?![_$[:alnum:]])(?:(?=\\\\.\\\\.\\\\.)|(?!\\\\.)))|(:\\\\s*((<\\\\s*$)|([\\\\(]\\\\s*((([\\\\{\\\\[]\\\\s*)?$)|((\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})\\\\s*((:\\\\s*\\\\{?$)|((\\\\s*([^<>\\\\(\\\\)\\\\{\\\\}]|\\\\<([^<>]|\\\\<([^<>]|\\\\<[^<>]+\\\\>)+\\\\>)+\\\\>|\\\\([^\\\\(\\\\)]+\\\\)|\\\\{[^\\\\{\\\\}]+\\\\})+\\\\s*)?=\\\\s*)))|((\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\])\\\\s*((:\\\\s*\\\\[?$)|((\\\\s*([^<>\\\\(\\\\)\\\\{\\\\}]|\\\\<([^<>]|\\\\<([^<>]|\\\\<[^<>]+\\\\>)+\\\\>)+\\\\>|\\\\([^\\\\(\\\\)]+\\\\)|\\\\{[^\\\\{\\\\}]+\\\\})+\\\\s*)?=\\\\s*)))))))|(:\\\\s*(=>|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(<[^<>]*>)|[^<>(),=])+=\\\\s*(((async\\\\s+)?((function\\\\s*[(<*])|(function\\\\s+)|([_$[:alpha:]][_$[:alnum:]]*\\\\s*=>)))|((async\\\\s*)?(((<\\\\s*$)|([\\\\(]\\\\s*((([\\\\{\\\\[]\\\\s*)?$)|((\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})\\\\s*((:\\\\s*\\\\{?$)|((\\\\s*([^<>\\\\(\\\\)\\\\{\\\\}]|\\\\<([^<>]|\\\\<([^<>]|\\\\<[^<>]+\\\\>)+\\\\>)+\\\\>|\\\\([^\\\\(\\\\)]+\\\\)|\\\\{[^\\\\{\\\\}]+\\\\})+\\\\s*)?=\\\\s*)))|((\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\])\\\\s*((:\\\\s*\\\\[?$)|((\\\\s*([^<>\\\\(\\\\)\\\\{\\\\}]|\\\\<([^<>]|\\\\<([^<>]|\\\\<[^<>]+\\\\>)+\\\\>)+\\\\>|\\\\([^\\\\(\\\\)]+\\\\)|\\\\{[^\\\\{\\\\}]+\\\\})+\\\\s*)?=\\\\s*))))))|((<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<]|\\\\<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<]|\\\\<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<])*\\\\>)*\\\\>)*>\\\\s*)?[(]\\\\s*(\\\\/\\\\*([^\\\\*]|(\\\\*[^\\\\/]))*\\\\*\\\\/\\\\s*)*(([)]\\\\s*:)|((\\\\.\\\\.\\\\.\\\\s*)?[_$[:alpha:]][_$[:alnum:]]*\\\\s*:)))|([<]\\\\s*[_$[:alpha:]][_$[:alnum:]]*\\\\s+extends\\\\s*[^=>])|((<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<]|\\\\<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<]|\\\\<\\\\s*(((const\\\\s+)?[_$[:alpha:]])|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\]))([^=<>]|=[^<])*\\\\>)*\\\\>)*>\\\\s*)?\\\\(\\\\s*(\\\\/\\\\*([^\\\\*]|(\\\\*[^\\\\/]))*\\\\*\\\\/\\\\s*)*(([_$[:alpha:]]|(\\\\{([^\\\\{\\\\}]|(\\\\{([^\\\\{\\\\}]|\\\\{[^\\\\{\\\\}]*\\\\})*\\\\}))*\\\\})|(\\\\[([^\\\\[\\\\]]|(\\\\[([^\\\\[\\\\]]|\\\\[[^\\\\[\\\\]]*\\\\])*\\\\]))*\\\\])|(\\\\.\\\\.\\\\.\\\\s*[_$[:alpha:]]))([^()\\\\'\\\\\\"\\\\\`]|(\\\\(([^\\\\(\\\\)]|(\\\\(([^\\\\(\\\\)]|\\\\([^\\\\(\\\\)]*\\\\))*\\\\)))*\\\\))|(\\\\'([^\\\\'\\\\\\\\]|\\\\\\\\.)*\\\\')|(\\\\\\"([^\\\\\\"\\\\\\\\]|\\\\\\\\.)*\\\\\\")|(\\\\\`([^\\\\\`\\\\\\\\]|\\\\\\\\.)*\\\\\`))*)?\\\\)(\\\\s*:\\\\s*([^<>\\\\(\\\\)\\\\{\\\\}]|\\\\<([^<>]|\\\\<([^<>]|\\\\<[^<>]+\\\\>)+\\\\>)+\\\\>|\\\\([^\\\\(\\\\)]+\\\\)|\\\\{[^\\\\{\\\\}]+\\\\})+)?\\\\s*=>))))))","beginCaptures":{"1":{"name":"meta.definition.variable.js entity.name.function.js"},"2":{"name":"keyword.operator.definiteassignment.js"}},"end":"(?=$|^|[;,=}]|((?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|(;|^\\\\s*$|(?:^\\\\s*(?:abstract|async|(?:\\\\bawait\\\\s+(?:\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[_$[:alpha:]])\\\\b)\\\\b)|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|(?:\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[_$[:alpha:]])\\\\b)|var|while)\\\\b)))","name":"meta.var-single-variable.expr.js","patterns":[{"include":"#var-single-variable-type-annotation"}]},{"begin":"([[:upper:]][_$[:digit:][:upper:]]*)(?![_$[:alnum:]])(\\\\!)?","beginCaptures":{"1":{"name":"meta.definition.variable.js variable.other.constant.js"},"2":{"name":"keyword.operator.definiteassignment.js"}},"end":"(?=$|^|[;,=}]|((?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|(;|^\\\\s*$|(?:^\\\\s*(?:abstract|async|(?:\\\\bawait\\\\s+(?:\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[_$[:alpha:]])\\\\b)\\\\b)|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|(?:\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[_$[:alpha:]])\\\\b)|var|while)\\\\b)))","name":"meta.var-single-variable.expr.js","patterns":[{"include":"#var-single-variable-type-annotation"}]},{"begin":"([_$[:alpha:]][_$[:alnum:]]*)(\\\\!)?","beginCaptures":{"1":{"name":"meta.definition.variable.js variable.other.readwrite.js"},"2":{"name":"keyword.operator.definiteassignment.js"}},"end":"(?=$|^|[;,=}]|((?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+)|(;|^\\\\s*$|(?:^\\\\s*(?:abstract|async|(?:\\\\bawait\\\\s+(?:\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[_$[:alpha:]])\\\\b)\\\\b)|break|case|catch|class|const|continue|declare|do|else|enum|export|finally|function|for|goto|if|import|interface|let|module|namespace|switch|return|throw|try|type|(?:\\\\busing(?=\\\\s+(?!in\\\\b|of\\\\b(?!\\\\s*(?:of\\\\b|=)))[_$[:alpha:]])\\\\b)|var|while)\\\\b)))","name":"meta.var-single-variable.expr.js","patterns":[{"include":"#var-single-variable-type-annotation"}]}]},"var-single-variable-type-annotation":{"patterns":[{"include":"#type-annotation"},{"include":"#string"},{"include":"#comment"}]},"variable-initializer":{"patterns":[{"begin":"(?<!=|!)(=)(?!=)(?=\\\\s*\\\\S)(?!\\\\s*.*=>\\\\s*$)","beginCaptures":{"1":{"name":"keyword.operator.assignment.js"}},"end":"(?=$|^|[,);}\\\\]]|((?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+))","patterns":[{"include":"#expression"}]},{"begin":"(?<!=|!)(=)(?!=)","beginCaptures":{"1":{"name":"keyword.operator.assignment.js"}},"end":"(?=[,);}\\\\]]|((?<![_$[:alnum:]])(?:(?<=\\\\.\\\\.\\\\.)|(?<!\\\\.))(of|in)\\\\s+))|(?=^\\\\s*$)|(?<![\\\\|\\\\&\\\\+\\\\-\\\\*\\\\/])(?<=\\\\S)(?<!=)(?=\\\\s*$)","patterns":[{"include":"#expression"}]}]}},"scopeName":"source.js","aliases":["js"]}`)), ipt = [
  opt
], spt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ipt
}, Symbol.toStringTag, { value: "Module" }));
var EQ = "production", t6 = typeof process > "u" || process.env === void 0 ? EQ : process.env.NODE_ENV || EQ, qa = function(t) {
  return {
    isEnabled: function(e) {
      return t.some(function(n) {
        return !!e[n];
      });
    }
  };
}, Ly = {
  measureLayout: qa(["layout", "layoutId", "drag"]),
  animation: qa([
    "animate",
    "exit",
    "variants",
    "whileHover",
    "whileTap",
    "whileFocus",
    "whileDrag",
    "whileInView"
  ]),
  exit: qa(["exit"]),
  drag: qa(["drag", "dragControls"]),
  focus: qa(["whileFocus"]),
  hover: qa(["whileHover", "onHoverStart", "onHoverEnd"]),
  tap: qa(["whileTap", "onTap", "onTapStart", "onTapCancel"]),
  pan: qa([
    "onPan",
    "onPanStart",
    "onPanSessionStart",
    "onPanEnd"
  ]),
  inView: qa([
    "whileInView",
    "onViewportEnter",
    "onViewportLeave"
  ])
};
function apt(t) {
  for (var e in t)
    t[e] !== null && (e === "projectionNodeConstructor" ? Ly.projectionNodeConstructor = t[e] : Ly[e].Component = t[e]);
}
var qve = lr({ strict: !1 }), Uve = Object.keys(Ly), lpt = Uve.length;
function cpt(t, e, n) {
  var r = [], o = Hn(qve);
  if (!e)
    return null;
  t6 !== "production" && n && o.strict && Zi(!1, "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.");
  for (var i = 0; i < lpt; i++) {
    var s = Uve[i], a = Ly[s], l = a.isEnabled, c = a.Component;
    l(t) && c && r.push(he.createElement(c, Ve({ key: s }, t, { visualElement: e })));
  }
  return r;
}
var n6 = lr({
  transformPagePoint: function(t) {
    return t;
  },
  isStatic: !1,
  reducedMotion: "never"
}), yO = lr({});
function upt() {
  return Hn(yO).visualElement;
}
var jv = lr(null), Dp = typeof document < "u", TE = Dp ? iu : Ne, Jj = { current: null }, Hve = !1;
function dpt() {
  if (Hve = !0, !!Dp)
    if (window.matchMedia) {
      var t = window.matchMedia("(prefers-reduced-motion)"), e = function() {
        return Jj.current = t.matches;
      };
      t.addListener(e), e();
    } else
      Jj.current = !1;
}
function fpt() {
  !Hve && dpt();
  var t = hr(Ye(Jj.current), 1), e = t[0];
  return e;
}
function hpt() {
  var t = fpt(), e = Hn(n6).reducedMotion;
  return e === "never" ? !1 : e === "always" ? !0 : t;
}
function ppt(t, e, n, r) {
  var o = Hn(qve), i = upt(), s = Hn(jv), a = hpt(), l = Ue(void 0);
  r || (r = o.renderer), !l.current && r && (l.current = r(t, {
    visualState: e,
    parent: i,
    props: n,
    presenceId: s?.id,
    blockInitialAnimation: s?.initial === !1,
    shouldReduceMotion: a
  }));
  var c = l.current;
  return TE(function() {
    c?.syncRender();
  }), Ne(function() {
    var u;
    (u = c?.animationState) === null || u === void 0 || u.animateChanges();
  }), TE(function() {
    return function() {
      return c?.notifyUnmount();
    };
  }, []), c;
}
function sh(t) {
  return typeof t == "object" && Object.prototype.hasOwnProperty.call(t, "current");
}
function mpt(t, e, n) {
  return Cn(
    function(r) {
      var o;
      r && ((o = t.mount) === null || o === void 0 || o.call(t, r)), e && (r ? e.mount(r) : e.unmount()), n && (typeof n == "function" ? n(r) : sh(n) && (n.current = r));
    },
    /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */
    [e]
  );
}
function Vve(t) {
  return Array.isArray(t);
}
function bs(t) {
  return typeof t == "string" || Vve(t);
}
function gpt(t) {
  var e = {};
  return t.forEachValue(function(n, r) {
    return e[r] = n.get();
  }), e;
}
function ypt(t) {
  var e = {};
  return t.forEachValue(function(n, r) {
    return e[r] = n.getVelocity();
  }), e;
}
function Wve(t, e, n, r, o) {
  var i;
  return r === void 0 && (r = {}), o === void 0 && (o = {}), typeof e == "function" && (e = e(n ?? t.custom, r, o)), typeof e == "string" && (e = (i = t.variants) === null || i === void 0 ? void 0 : i[e]), typeof e == "function" && (e = e(n ?? t.custom, r, o)), e;
}
function vO(t, e, n) {
  var r = t.getProps();
  return Wve(r, e, n ?? r.custom, gpt(t), ypt(t));
}
function bO(t) {
  var e;
  return typeof ((e = t.animate) === null || e === void 0 ? void 0 : e.start) == "function" || bs(t.initial) || bs(t.animate) || bs(t.whileHover) || bs(t.whileDrag) || bs(t.whileTap) || bs(t.whileFocus) || bs(t.exit);
}
function Gve(t) {
  return !!(bO(t) || t.variants);
}
function vpt(t, e) {
  if (bO(t)) {
    var n = t.initial, r = t.animate;
    return {
      initial: n === !1 || bs(n) ? n : void 0,
      animate: bs(r) ? r : void 0
    };
  }
  return t.inherit !== !1 ? e : {};
}
function bpt(t) {
  var e = vpt(t, Hn(yO)), n = e.initial, r = e.animate;
  return cn(function() {
    return { initial: n, animate: r };
  }, [SQ(n), SQ(r)]);
}
function SQ(t) {
  return Array.isArray(t) ? t.join(" ") : t;
}
function Lv(t) {
  var e = Ue(null);
  return e.current === null && (e.current = t()), e.current;
}
var y0 = {
  /**
   * Global flag as to whether the tree has animated since the last time
   * we resized the window
   */
  hasAnimatedSinceResize: !0,
  /**
   * We set this to true once, on the first update. Any nodes added to the tree beyond that
   * update will be given a `data-projection-id` attribute.
   */
  hasEverUpdated: !1
}, _pt = 1;
function wpt() {
  return Lv(function() {
    if (y0.hasEverUpdated)
      return _pt++;
  });
}
var r6 = lr({}), Yve = lr({});
function xpt(t, e, n, r) {
  var o, i = e.layoutId, s = e.layout, a = e.drag, l = e.dragConstraints, c = e.layoutScroll, u = Hn(Yve);
  !r || !n || n?.projection || (n.projection = new r(t, n.getLatestValues(), (o = n.parent) === null || o === void 0 ? void 0 : o.projection), n.projection.setOptions({
    layoutId: i,
    layout: s,
    alwaysMeasureLayout: !!a || l && sh(l),
    visualElement: n,
    scheduleRender: function() {
      return n.scheduleRender();
    },
    /**
     * TODO: Update options in an effect. This could be tricky as it'll be too late
     * to update by the time layout animations run.
     * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
     * ensuring it gets called if there's no potential layout animations.
     *
     */
    animationType: typeof s == "string" ? s : "both",
    initialPromotionConfig: u,
    layoutScroll: c
  }));
}
var Ept = (
  /** @class */
  function(t) {
    cce(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.prototype.getSnapshotBeforeUpdate = function() {
      return this.updateProps(), null;
    }, e.prototype.componentDidUpdate = function() {
    }, e.prototype.updateProps = function() {
      var n = this.props, r = n.visualElement, o = n.props;
      r && r.setProps(o);
    }, e.prototype.render = function() {
      return this.props.children;
    }, e;
  }(xe.Component)
);
function Spt(t) {
  var e = t.preloadedFeatures, n = t.createVisualElement, r = t.projectionNodeConstructor, o = t.useRender, i = t.useVisualState, s = t.Component;
  e && apt(e);
  function a(l, c) {
    var u = Opt(l);
    l = Ve(Ve({}, l), { layoutId: u });
    var d = Hn(n6), f = null, h = bpt(l), p = d.isStatic ? void 0 : wpt(), m = i(l, d.isStatic);
    return !d.isStatic && Dp && (h.visualElement = ppt(s, m, Ve(Ve({}, d), l), n), xpt(p, l, h.visualElement, r || Ly.projectionNodeConstructor), f = cpt(l, h.visualElement, e)), he.createElement(
      Ept,
      { visualElement: h.visualElement, props: Ve(Ve({}, d), l) },
      f,
      he.createElement(yO.Provider, { value: h }, o(s, l, p, mpt(m, h.visualElement, c), m, d.isStatic, h.visualElement))
    );
  }
  return Ri(a);
}
function Opt(t) {
  var e, n = t.layoutId, r = (e = Hn(r6)) === null || e === void 0 ? void 0 : e.id;
  return r && n !== void 0 ? r + "-" + n : n;
}
function Cpt(t) {
  function e(r, o) {
    return o === void 0 && (o = {}), Spt(t(r, o));
  }
  if (typeof Proxy > "u")
    return e;
  var n = /* @__PURE__ */ new Map();
  return new Proxy(e, {
    /**
     * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
     * The prop name is passed through as `key` and we can use that to generate a `motion`
     * DOM component with that name.
     */
    get: function(r, o) {
      return n.has(o) || n.set(o, e(o)), n.get(o);
    }
  });
}
var kpt = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "svg",
  "switch",
  "symbol",
  "text",
  "tspan",
  "use",
  "view"
];
function o6(t) {
  return (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof t != "string" || /**
    * If it contains a dash, the element is a custom HTML webcomponent.
    */
    t.includes("-") ? !1 : (
      /**
       * If it's in our list of lowercase SVG tags, it's an SVG component
       */
      !!(kpt.indexOf(t) > -1 || /**
      * If it contains a capital letter, it's an SVG component
      */
      /[A-Z]/.test(t))
    )
  );
}
var RE = {};
function Apt(t) {
  Object.assign(RE, t);
}
var e3 = ["", "X", "Y", "Z"], Tpt = ["translate", "scale", "rotate", "skew"], Fy = ["transformPerspective", "x", "y", "z"];
Tpt.forEach(function(t) {
  return e3.forEach(function(e) {
    return Fy.push(t + e);
  });
});
function Rpt(t, e) {
  return Fy.indexOf(t) - Fy.indexOf(e);
}
var Ppt = new Set(Fy);
function Fv(t) {
  return Ppt.has(t);
}
var $pt = /* @__PURE__ */ new Set(["originX", "originY", "originZ"]);
function Kve(t) {
  return $pt.has(t);
}
function Xve(t, e) {
  var n = e.layout, r = e.layoutId;
  return Fv(t) || Kve(t) || (n || r !== void 0) && (!!RE[t] || t === "opacity");
}
var Bl = function(t) {
  return !!(t !== null && typeof t == "object" && t.getVelocity);
}, Mpt = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
};
function Dpt(t, e, n, r) {
  var o = t.transform, i = t.transformKeys, s = e.enableHardwareAcceleration, a = s === void 0 ? !0 : s, l = e.allowTransformNone, c = l === void 0 ? !0 : l, u = "";
  i.sort(Rpt);
  for (var d = !1, f = i.length, h = 0; h < f; h++) {
    var p = i[h];
    u += "".concat(Mpt[p] || p, "(").concat(o[p], ") "), p === "z" && (d = !0);
  }
  return !d && a ? u += "translateZ(0)" : u = u.trim(), r ? u = r(o, n ? "" : u) : c && n && (u = "none"), u;
}
function Ipt(t) {
  var e = t.originX, n = e === void 0 ? "50%" : e, r = t.originY, o = r === void 0 ? "50%" : r, i = t.originZ, s = i === void 0 ? 0 : i;
  return "".concat(n, " ").concat(o, " ").concat(s);
}
function Qve(t) {
  return t.startsWith("--");
}
var Npt = function(t, e) {
  return e && typeof t == "number" ? e.transform(t) : t;
}, OQ = Ve(Ve({}, Gd), { transform: Math.round }), Zve = {
  // Border props
  borderWidth: vt,
  borderTopWidth: vt,
  borderRightWidth: vt,
  borderBottomWidth: vt,
  borderLeftWidth: vt,
  borderRadius: vt,
  radius: vt,
  borderTopLeftRadius: vt,
  borderTopRightRadius: vt,
  borderBottomRightRadius: vt,
  borderBottomLeftRadius: vt,
  // Positioning props
  width: vt,
  maxWidth: vt,
  height: vt,
  maxHeight: vt,
  size: vt,
  top: vt,
  right: vt,
  bottom: vt,
  left: vt,
  // Spacing props
  padding: vt,
  paddingTop: vt,
  paddingRight: vt,
  paddingBottom: vt,
  paddingLeft: vt,
  margin: vt,
  marginTop: vt,
  marginRight: vt,
  marginBottom: vt,
  marginLeft: vt,
  // Transform props
  rotate: hc,
  rotateX: hc,
  rotateY: hc,
  rotateZ: hc,
  scale: mb,
  scaleX: mb,
  scaleY: mb,
  scaleZ: mb,
  skew: hc,
  skewX: hc,
  skewY: hc,
  distance: vt,
  translateX: vt,
  translateY: vt,
  translateZ: vt,
  x: vt,
  y: vt,
  z: vt,
  perspective: vt,
  transformPerspective: vt,
  opacity: Yg,
  originX: n7,
  originY: n7,
  originZ: vt,
  // Misc
  zIndex: OQ,
  // SVG
  fillOpacity: Yg,
  strokeOpacity: Yg,
  numOctaves: OQ
};
function i6(t, e, n, r) {
  var o, i = t.style, s = t.vars, a = t.transform, l = t.transformKeys, c = t.transformOrigin;
  l.length = 0;
  var u = !1, d = !1, f = !0;
  for (var h in e) {
    var p = e[h];
    if (Qve(h)) {
      s[h] = p;
      continue;
    }
    var m = Zve[h], g = Npt(p, m);
    if (Fv(h)) {
      if (u = !0, a[h] = g, l.push(h), !f)
        continue;
      p !== ((o = m.default) !== null && o !== void 0 ? o : 0) && (f = !1);
    } else Kve(h) ? (c[h] = g, d = !0) : i[h] = g;
  }
  u ? i.transform = Dpt(t, n, f, r) : r ? i.transform = r({}, "") : !e.transform && i.transform && (i.transform = "none"), d && (i.transformOrigin = Ipt(c));
}
var s6 = function() {
  return {
    style: {},
    transform: {},
    transformKeys: [],
    transformOrigin: {},
    vars: {}
  };
};
function Jve(t, e, n) {
  for (var r in e)
    !Bl(e[r]) && !Xve(r, n) && (t[r] = e[r]);
}
function jpt(t, e, n) {
  var r = t.transformTemplate;
  return cn(function() {
    var o = s6();
    i6(o, e, { enableHardwareAcceleration: !n }, r);
    var i = o.vars, s = o.style;
    return Ve(Ve({}, i), s);
  }, [e]);
}
function Lpt(t, e, n) {
  var r = t.style || {}, o = {};
  return Jve(o, r, t), Object.assign(o, jpt(t, e, n)), t.transformValues && (o = t.transformValues(o)), o;
}
function Fpt(t, e, n) {
  var r = {}, o = Lpt(t, e, n);
  return t.drag && t.dragListener !== !1 && (r.draggable = !1, o.userSelect = o.WebkitUserSelect = o.WebkitTouchCallout = "none", o.touchAction = t.drag === !0 ? "none" : "pan-".concat(t.drag === "x" ? "y" : "x")), r.style = o, r;
}
var Bpt = /* @__PURE__ */ new Set([
  "initial",
  "animate",
  "exit",
  "style",
  "variants",
  "transition",
  "transformTemplate",
  "transformValues",
  "custom",
  "inherit",
  "layout",
  "layoutId",
  "layoutDependency",
  "onLayoutAnimationStart",
  "onLayoutAnimationComplete",
  "onLayoutMeasure",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "drag",
  "dragControls",
  "dragListener",
  "dragConstraints",
  "dragDirectionLock",
  "dragSnapToOrigin",
  "_dragX",
  "_dragY",
  "dragElastic",
  "dragMomentum",
  "dragPropagation",
  "dragTransition",
  "whileDrag",
  "onPan",
  "onPanStart",
  "onPanEnd",
  "onPanSessionStart",
  "onTap",
  "onTapStart",
  "onTapCancel",
  "onHoverStart",
  "onHoverEnd",
  "whileFocus",
  "whileTap",
  "whileHover",
  "whileInView",
  "onViewportEnter",
  "onViewportLeave",
  "viewport",
  "layoutScroll"
]);
function PE(t) {
  return Bpt.has(t);
}
var ebe = function(t) {
  return !PE(t);
};
function zpt(t) {
  t && (ebe = function(e) {
    return e.startsWith("on") ? !PE(e) : t(e);
  });
}
try {
  zpt(require("@emotion/is-prop-valid").default);
} catch {
}
function qpt(t, e, n) {
  var r = {};
  for (var o in t)
    (ebe(o) || n === !0 && PE(o) || !e && !PE(o) || // If trying to use native HTML drag events, forward drag listeners
    t.draggable && o.startsWith("onDrag")) && (r[o] = t[o]);
  return r;
}
function CQ(t, e, n) {
  return typeof t == "string" ? t : vt.transform(e + n * t);
}
function Upt(t, e, n) {
  var r = CQ(e, t.x, t.width), o = CQ(n, t.y, t.height);
  return "".concat(r, " ").concat(o);
}
var Hpt = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function Vpt(t, e, n, r, o) {
  n === void 0 && (n = 1), r === void 0 && (r = 0), t.pathLength = 1;
  var i = Hpt;
  t[i.offset] = vt.transform(-r);
  var s = vt.transform(e), a = vt.transform(n);
  t[i.array] = "".concat(s, " ").concat(a);
}
function a6(t, e, n, r) {
  var o = e.attrX, i = e.attrY, s = e.originX, a = e.originY, l = e.pathLength, c = e.pathSpacing, u = c === void 0 ? 1 : c, d = e.pathOffset, f = d === void 0 ? 0 : d, h = ss(e, ["attrX", "attrY", "originX", "originY", "pathLength", "pathSpacing", "pathOffset"]);
  i6(t, h, n, r), t.attrs = t.style, t.style = {};
  var p = t.attrs, m = t.style, g = t.dimensions;
  p.transform && (g && (m.transform = p.transform), delete p.transform), g && (s !== void 0 || a !== void 0 || m.transform) && (m.transformOrigin = Upt(g, s !== void 0 ? s : 0.5, a !== void 0 ? a : 0.5)), o !== void 0 && (p.x = o), i !== void 0 && (p.y = i), l !== void 0 && Vpt(p, l, u, f);
}
var tbe = function() {
  return Ve(Ve({}, s6()), { attrs: {} });
};
function Wpt(t, e) {
  var n = cn(function() {
    var o = tbe();
    return a6(o, e, { enableHardwareAcceleration: !1 }, t.transformTemplate), Ve(Ve({}, o.attrs), { style: Ve({}, o.style) });
  }, [e]);
  if (t.style) {
    var r = {};
    Jve(r, t.style, t), n.style = Ve(Ve({}, r), n.style);
  }
  return n;
}
function Gpt(t) {
  t === void 0 && (t = !1);
  var e = function(n, r, o, i, s, a) {
    var l = s.latestValues, c = o6(n) ? Wpt : Fpt, u = c(r, l, a), d = qpt(r, typeof n == "string", t), f = Ve(Ve(Ve({}, d), u), { ref: i });
    return o && (f["data-projection-id"] = o), Pse(n, f);
  };
  return e;
}
var Ypt = /([a-z])([A-Z])/g, Kpt = "$1-$2", nbe = function(t) {
  return t.replace(Ypt, Kpt).toLowerCase();
};
function rbe(t, e, n, r) {
  var o = e.style, i = e.vars;
  Object.assign(t.style, o, r && r.getProjectionStyles(n));
  for (var s in i)
    t.style.setProperty(s, i[s]);
}
var obe = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform",
  "pathLength"
]);
function ibe(t, e, n, r) {
  rbe(t, e, void 0, r);
  for (var o in e.attrs)
    t.setAttribute(obe.has(o) ? o : nbe(o), e.attrs[o]);
}
function l6(t) {
  var e = t.style, n = {};
  for (var r in e)
    (Bl(e[r]) || Xve(r, t)) && (n[r] = e[r]);
  return n;
}
function sbe(t) {
  var e = l6(t);
  for (var n in t)
    if (Bl(t[n])) {
      var r = n === "x" || n === "y" ? "attr" + n.toUpperCase() : n;
      e[r] = t[n];
    }
  return e;
}
function c6(t) {
  return typeof t == "object" && typeof t.start == "function";
}
var By = function(t) {
  return Array.isArray(t);
}, Xpt = function(t) {
  return !!(t && typeof t == "object" && t.mix && t.toValue);
}, abe = function(t) {
  return By(t) ? t[t.length - 1] || 0 : t;
};
function jw(t) {
  var e = Bl(t) ? t.get() : t;
  return Xpt(e) ? e.toValue() : e;
}
function kQ(t, e, n, r) {
  var o = t.scrapeMotionValuesFromProps, i = t.createRenderState, s = t.onMount, a = {
    latestValues: Qpt(e, n, r, o),
    renderState: i()
  };
  return s && (a.mount = function(l) {
    return s(e, l, a);
  }), a;
}
var lbe = function(t) {
  return function(e, n) {
    var r = Hn(yO), o = Hn(jv);
    return n ? kQ(t, e, r, o) : Lv(function() {
      return kQ(t, e, r, o);
    });
  };
};
function Qpt(t, e, n, r) {
  var o = {}, i = n?.initial === !1, s = r(t);
  for (var a in s)
    o[a] = jw(s[a]);
  var l = t.initial, c = t.animate, u = bO(t), d = Gve(t);
  e && d && !u && t.inherit !== !1 && (l ?? (l = e.initial), c ?? (c = e.animate));
  var f = i || l === !1, h = f ? c : l;
  if (h && typeof h != "boolean" && !c6(h)) {
    var p = Array.isArray(h) ? h : [h];
    p.forEach(function(m) {
      var g = Wve(t, m);
      if (g) {
        var y = g.transitionEnd;
        g.transition;
        var v = ss(g, ["transitionEnd", "transition"]);
        for (var b in v) {
          var _ = v[b];
          if (Array.isArray(_)) {
            var w = f ? _.length - 1 : 0;
            _ = _[w];
          }
          _ !== null && (o[b] = _);
        }
        for (var b in y)
          o[b] = y[b];
      }
    });
  }
  return o;
}
var Zpt = {
  useVisualState: lbe({
    scrapeMotionValuesFromProps: sbe,
    createRenderState: tbe,
    onMount: function(t, e, n) {
      var r = n.renderState, o = n.latestValues;
      try {
        r.dimensions = typeof e.getBBox == "function" ? e.getBBox() : e.getBoundingClientRect();
      } catch {
        r.dimensions = {
          x: 0,
          y: 0,
          width: 0,
          height: 0
        };
      }
      a6(r, o, { enableHardwareAcceleration: !1 }, t.transformTemplate), ibe(e, r);
    }
  })
}, Jpt = {
  useVisualState: lbe({
    scrapeMotionValuesFromProps: l6,
    createRenderState: s6
  })
};
function emt(t, e, n, r, o) {
  var i = e.forwardMotionProps, s = i === void 0 ? !1 : i, a = o6(t) ? Zpt : Jpt;
  return Ve(Ve({}, a), { preloadedFeatures: n, useRender: Gpt(s), createVisualElement: r, projectionNodeConstructor: o, Component: t });
}
var qn;
(function(t) {
  t.Animate = "animate", t.Hover = "whileHover", t.Tap = "whileTap", t.Drag = "whileDrag", t.Focus = "whileFocus", t.InView = "whileInView", t.Exit = "exit";
})(qn || (qn = {}));
function _O(t, e, n, r) {
  return r === void 0 && (r = { passive: !0 }), t.addEventListener(e, n, r), function() {
    return t.removeEventListener(e, n);
  };
}
function t3(t, e, n, r) {
  Ne(function() {
    var o = t.current;
    if (n && o)
      return _O(o, e, n, r);
  }, [t, e, n, r]);
}
function tmt(t) {
  var e = t.whileFocus, n = t.visualElement, r = function() {
    var i;
    (i = n.animationState) === null || i === void 0 || i.setActive(qn.Focus, !0);
  }, o = function() {
    var i;
    (i = n.animationState) === null || i === void 0 || i.setActive(qn.Focus, !1);
  };
  t3(n, "focus", e ? r : void 0), t3(n, "blur", e ? o : void 0);
}
function cbe(t) {
  return typeof PointerEvent < "u" && t instanceof PointerEvent ? t.pointerType === "mouse" : t instanceof MouseEvent;
}
function ube(t) {
  var e = !!t.touches;
  return e;
}
function nmt(t) {
  return function(e) {
    var n = e instanceof MouseEvent, r = !n || n && e.button === 0;
    r && t(e);
  };
}
var rmt = { pageX: 0, pageY: 0 };
function omt(t, e) {
  e === void 0 && (e = "page");
  var n = t.touches[0] || t.changedTouches[0], r = n || rmt;
  return {
    x: r[e + "X"],
    y: r[e + "Y"]
  };
}
function imt(t, e) {
  return e === void 0 && (e = "page"), {
    x: t[e + "X"],
    y: t[e + "Y"]
  };
}
function u6(t, e) {
  return e === void 0 && (e = "page"), {
    point: ube(t) ? omt(t, e) : imt(t, e)
  };
}
var dbe = function(t, e) {
  e === void 0 && (e = !1);
  var n = function(r) {
    return t(r, u6(r));
  };
  return e ? nmt(n) : n;
}, smt = function() {
  return Dp && window.onpointerdown === null;
}, amt = function() {
  return Dp && window.ontouchstart === null;
}, lmt = function() {
  return Dp && window.onmousedown === null;
}, cmt = {
  pointerdown: "mousedown",
  pointermove: "mousemove",
  pointerup: "mouseup",
  pointercancel: "mousecancel",
  pointerover: "mouseover",
  pointerout: "mouseout",
  pointerenter: "mouseenter",
  pointerleave: "mouseleave"
}, umt = {
  pointerdown: "touchstart",
  pointermove: "touchmove",
  pointerup: "touchend",
  pointercancel: "touchcancel"
};
function fbe(t) {
  return smt() ? t : amt() ? umt[t] : lmt() ? cmt[t] : t;
}
function Ah(t, e, n, r) {
  return _O(t, fbe(e), dbe(n, e === "pointerdown"), r);
}
function $E(t, e, n, r) {
  return t3(t, fbe(e), n && dbe(n, e === "pointerdown"), r);
}
function hbe(t) {
  var e = null;
  return function() {
    var n = function() {
      e = null;
    };
    return e === null ? (e = t, n) : !1;
  };
}
var AQ = hbe("dragHorizontal"), TQ = hbe("dragVertical");
function pbe(t) {
  var e = !1;
  if (t === "y")
    e = TQ();
  else if (t === "x")
    e = AQ();
  else {
    var n = AQ(), r = TQ();
    n && r ? e = function() {
      n(), r();
    } : (n && n(), r && r());
  }
  return e;
}
function mbe() {
  var t = pbe(!0);
  return t ? (t(), !1) : !0;
}
function RQ(t, e, n) {
  return function(r, o) {
    var i;
    !cbe(r) || mbe() || ((i = t.animationState) === null || i === void 0 || i.setActive(qn.Hover, e), n?.(r, o));
  };
}
function dmt(t) {
  var e = t.onHoverStart, n = t.onHoverEnd, r = t.whileHover, o = t.visualElement;
  $E(o, "pointerenter", e || r ? RQ(o, !0, e) : void 0, { passive: !e }), $E(o, "pointerleave", n || r ? RQ(o, !1, n) : void 0, { passive: !n });
}
var gbe = function(t, e) {
  return e ? t === e ? !0 : gbe(t, e.parentElement) : !1;
};
function d6(t) {
  return Ne(function() {
    return function() {
      return t();
    };
  }, []);
}
function fmt(t) {
  var e = t.onTap, n = t.onTapStart, r = t.onTapCancel, o = t.whileTap, i = t.visualElement, s = e || n || r || o, a = Ue(!1), l = Ue(null), c = {
    passive: !(n || e || r || p)
  };
  function u() {
    var m;
    (m = l.current) === null || m === void 0 || m.call(l), l.current = null;
  }
  function d() {
    var m;
    return u(), a.current = !1, (m = i.animationState) === null || m === void 0 || m.setActive(qn.Tap, !1), !mbe();
  }
  function f(m, g) {
    d() && (gbe(i.getInstance(), m.target) ? e?.(m, g) : r?.(m, g));
  }
  function h(m, g) {
    d() && r?.(m, g);
  }
  function p(m, g) {
    var y;
    u(), !a.current && (a.current = !0, l.current = gS(Ah(window, "pointerup", f, c), Ah(window, "pointercancel", h, c)), (y = i.animationState) === null || y === void 0 || y.setActive(qn.Tap, !0), n?.(m, g));
  }
  $E(i, "pointerdown", s ? p : void 0, c), d6(u);
}
var PQ = /* @__PURE__ */ new Set();
function ybe(t, e, n) {
  t || PQ.has(e) || (console.warn(e), PQ.add(e));
}
var n3 = /* @__PURE__ */ new WeakMap(), lT = /* @__PURE__ */ new WeakMap(), hmt = function(t) {
  var e;
  (e = n3.get(t.target)) === null || e === void 0 || e(t);
}, pmt = function(t) {
  t.forEach(hmt);
};
function mmt(t) {
  var e = t.root, n = ss(t, ["root"]), r = e || document;
  lT.has(r) || lT.set(r, {});
  var o = lT.get(r), i = JSON.stringify(n);
  return o[i] || (o[i] = new IntersectionObserver(pmt, Ve({ root: e }, n))), o[i];
}
function gmt(t, e, n) {
  var r = mmt(e);
  return n3.set(t, n), r.observe(t), function() {
    n3.delete(t), r.unobserve(t);
  };
}
function ymt(t) {
  var e = t.visualElement, n = t.whileInView, r = t.onViewportEnter, o = t.onViewportLeave, i = t.viewport, s = i === void 0 ? {} : i, a = Ue({
    hasEnteredView: !1,
    isInView: !1
  }), l = !!(n || r || o);
  s.once && a.current.hasEnteredView && (l = !1);
  var c = typeof IntersectionObserver > "u" ? _mt : bmt;
  c(l, a.current, e, s);
}
var vmt = {
  some: 0,
  all: 1
};
function bmt(t, e, n, r) {
  var o = r.root, i = r.margin, s = r.amount, a = s === void 0 ? "some" : s, l = r.once;
  Ne(function() {
    if (t) {
      var c = {
        root: o?.current,
        rootMargin: i,
        threshold: typeof a == "number" ? a : vmt[a]
      }, u = function(d) {
        var f, h = d.isIntersecting;
        if (e.isInView !== h && (e.isInView = h, !(l && !h && e.hasEnteredView))) {
          h && (e.hasEnteredView = !0), (f = n.animationState) === null || f === void 0 || f.setActive(qn.InView, h);
          var p = n.getProps(), m = h ? p.onViewportEnter : p.onViewportLeave;
          m?.(d);
        }
      };
      return gmt(n.getInstance(), c, u);
    }
  }, [t, o, i, a]);
}
function _mt(t, e, n, r) {
  var o = r.fallback, i = o === void 0 ? !0 : o;
  Ne(function() {
    !t || !i || (t6 !== "production" && ybe(!1, "IntersectionObserver not available on this device. whileInView animations will trigger on mount."), requestAnimationFrame(function() {
      var s;
      e.hasEnteredView = !0;
      var a = n.getProps().onViewportEnter;
      a?.(null), (s = n.animationState) === null || s === void 0 || s.setActive(qn.InView, !0);
    }));
  }, [t]);
}
var zc = function(t) {
  return function(e) {
    return t(e), null;
  };
}, wmt = {
  inView: zc(ymt),
  tap: zc(fmt),
  focus: zc(tmt),
  hover: zc(dmt)
}, xmt = 0, Emt = function() {
  return xmt++;
}, vbe = function() {
  return Lv(Emt);
};
function bbe() {
  var t = Hn(jv);
  if (t === null)
    return [!0, null];
  var e = t.isPresent, n = t.onExitComplete, r = t.register, o = vbe();
  Ne(function() {
    return r(o);
  }, []);
  var i = function() {
    return n?.(o);
  };
  return !e && n ? [!1, i] : [!0];
}
function _be(t, e) {
  if (!Array.isArray(e))
    return !1;
  var n = e.length;
  if (n !== t.length)
    return !1;
  for (var r = 0; r < n; r++)
    if (e[r] !== t[r])
      return !1;
  return !0;
}
var ME = function(t) {
  return t * 1e3;
}, $Q = {
  linear: L5,
  easeIn: F5,
  easeInOut: Sce,
  easeOut: m5e,
  circIn: Oce,
  circInOut: g5e,
  circOut: B5,
  backIn: z5,
  backInOut: v5e,
  backOut: y5e,
  anticipate: b5e,
  bounceIn: E5e,
  bounceInOut: S5e,
  bounceOut: lx
}, MQ = function(t) {
  if (Array.isArray(t)) {
    Zi(t.length === 4, "Cubic bezier arrays must contain four numerical values.");
    var e = hr(t, 4), n = e[0], r = e[1], o = e[2], i = e[3];
    return V5e(n, r, o, i);
  } else if (typeof t == "string")
    return Zi($Q[t] !== void 0, "Invalid easing type '".concat(t, "'")), $Q[t];
  return t;
}, Smt = function(t) {
  return Array.isArray(t) && typeof t[0] != "number";
}, DQ = function(t, e) {
  return t === "zIndex" ? !1 : !!(typeof e == "number" || Array.isArray(e) || typeof e == "string" && // It's animatable if we have a string
  Il.test(e) && // And it contains numbers and/or colors
  !e.startsWith("url("));
}, xu = function() {
  return {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10
  };
}, M1 = function(t) {
  return {
    type: "spring",
    stiffness: 550,
    damping: t === 0 ? 2 * Math.sqrt(550) : 30,
    restSpeed: 10
  };
}, cT = function() {
  return {
    type: "keyframes",
    ease: "linear",
    duration: 0.3
  };
}, Omt = function(t) {
  return {
    type: "keyframes",
    duration: 0.8,
    values: t
  };
}, IQ = {
  x: xu,
  y: xu,
  z: xu,
  rotate: xu,
  rotateX: xu,
  rotateY: xu,
  rotateZ: xu,
  scaleX: M1,
  scaleY: M1,
  scale: M1,
  opacity: cT,
  backgroundColor: cT,
  color: cT,
  default: M1
}, Cmt = function(t, e) {
  var n;
  return By(e) ? n = Omt : n = IQ[t] || IQ.default, Ve({ to: e }, n(e));
}, kmt = Ve(Ve({}, Zve), {
  // Color props
  color: Eo,
  backgroundColor: Eo,
  outlineColor: Eo,
  fill: Eo,
  stroke: Eo,
  // Border props
  borderColor: Eo,
  borderTopColor: Eo,
  borderRightColor: Eo,
  borderBottomColor: Eo,
  borderLeftColor: Eo,
  filter: mI,
  WebkitFilter: mI
}), f6 = function(t) {
  return kmt[t];
};
function h6(t, e) {
  var n, r = f6(t);
  return r !== mI && (r = Il), (n = r.getAnimatableNone) === null || n === void 0 ? void 0 : n.call(r, e);
}
function Amt(t) {
  t.when, t.delay, t.delayChildren, t.staggerChildren, t.staggerDirection, t.repeat, t.repeatType, t.repeatDelay, t.from;
  var e = ss(t, ["when", "delay", "delayChildren", "staggerChildren", "staggerDirection", "repeat", "repeatType", "repeatDelay", "from"]);
  return !!Object.keys(e).length;
}
var NQ = !1;
function Tmt(t) {
  var e = t.ease, n = t.times, r = t.yoyo, o = t.flip, i = t.loop, s = ss(t, ["ease", "times", "yoyo", "flip", "loop"]), a = Ve({}, s);
  return n && (a.offset = n), s.duration && (a.duration = ME(s.duration)), s.repeatDelay && (a.repeatDelay = ME(s.repeatDelay)), e && (a.ease = Smt(e) ? e.map(MQ) : MQ(e)), s.type === "tween" && (a.type = "keyframes"), (r || i || o) && (lv(!NQ, "yoyo, loop and flip have been removed from the API. Replace with repeat and repeatType options."), NQ = !0, r ? a.repeatType = "reverse" : i ? a.repeatType = "loop" : o && (a.repeatType = "mirror"), a.repeat = i || r || o || s.repeat), s.type !== "spring" && (a.type = "keyframes"), a;
}
function Rmt(t, e) {
  var n, r, o = p6(t, e) || {};
  return (r = (n = o.delay) !== null && n !== void 0 ? n : t.delay) !== null && r !== void 0 ? r : 0;
}
function Pmt(t) {
  return Array.isArray(t.to) && t.to[0] === null && (t.to = Cs([], hr(t.to), !1), t.to[0] = t.from), t;
}
function $mt(t, e, n) {
  var r;
  return Array.isArray(e.to) && ((r = t.duration) !== null && r !== void 0 || (t.duration = 0.8)), Pmt(e), Amt(t) || (t = Ve(Ve({}, t), Cmt(n, e.to))), Ve(Ve({}, e), Tmt(t));
}
function Mmt(t, e, n, r, o) {
  var i, s = p6(r, t), a = (i = s.from) !== null && i !== void 0 ? i : e.get(), l = DQ(t, n);
  a === "none" && l && typeof n == "string" ? a = h6(t, n) : jQ(a) && typeof n == "string" ? a = LQ(n) : !Array.isArray(n) && jQ(n) && typeof a == "string" && (n = LQ(a));
  var c = DQ(t, a);
  lv(c === l, "You are trying to animate ".concat(t, ' from "').concat(a, '" to "').concat(n, '". ').concat(a, " is not an animatable value - to enable this animation set ").concat(a, " to a value animatable to ").concat(n, " via the `style` property."));
  function u() {
    var f = {
      from: a,
      to: n,
      velocity: e.getVelocity(),
      onComplete: o,
      onUpdate: function(h) {
        return e.set(h);
      }
    };
    return s.type === "inertia" || s.type === "decay" ? L5e(Ve(Ve({}, f), s)) : Rce(Ve(Ve({}, $mt(s, f, t)), { onUpdate: function(h) {
      var p;
      f.onUpdate(h), (p = s.onUpdate) === null || p === void 0 || p.call(s, h);
    }, onComplete: function() {
      var h;
      f.onComplete(), (h = s.onComplete) === null || h === void 0 || h.call(s);
    } }));
  }
  function d() {
    var f, h, p = abe(n);
    return e.set(p), o(), (f = s?.onUpdate) === null || f === void 0 || f.call(s, p), (h = s?.onComplete) === null || h === void 0 || h.call(s), { stop: function() {
    } };
  }
  return !c || !l || s.type === !1 ? d : u;
}
function jQ(t) {
  return t === 0 || typeof t == "string" && parseFloat(t) === 0 && t.indexOf(" ") === -1;
}
function LQ(t) {
  return typeof t == "number" ? 0 : h6("", t);
}
function p6(t, e) {
  return t[e] || t.default || t;
}
function m6(t, e, n, r) {
  return r === void 0 && (r = {}), e.start(function(o) {
    var i, s, a = Mmt(t, e, n, r, o), l = Rmt(r, t), c = function() {
      return s = a();
    };
    return l ? i = window.setTimeout(c, ME(l)) : c(), function() {
      clearTimeout(i), s?.stop();
    };
  });
}
var Dmt = function(t) {
  return /^\-?\d*\.?\d+$/.test(t);
}, Imt = function(t) {
  return /^0[^.\s]+$/.test(t);
};
function g6(t, e) {
  t.indexOf(e) === -1 && t.push(e);
}
function y6(t, e) {
  var n = t.indexOf(e);
  n > -1 && t.splice(n, 1);
}
var v0 = (
  /** @class */
  function() {
    function t() {
      this.subscriptions = [];
    }
    return t.prototype.add = function(e) {
      var n = this;
      return g6(this.subscriptions, e), function() {
        return y6(n.subscriptions, e);
      };
    }, t.prototype.notify = function(e, n, r) {
      var o = this.subscriptions.length;
      if (o)
        if (o === 1)
          this.subscriptions[0](e, n, r);
        else
          for (var i = 0; i < o; i++) {
            var s = this.subscriptions[i];
            s && s(e, n, r);
          }
    }, t.prototype.getSize = function() {
      return this.subscriptions.length;
    }, t.prototype.clear = function() {
      this.subscriptions.length = 0;
    }, t;
  }()
), Nmt = function(t) {
  return !isNaN(parseFloat(t));
}, jmt = (
  /** @class */
  function() {
    function t(e) {
      var n = this;
      this.version = "6.5.1", this.timeDelta = 0, this.lastUpdated = 0, this.updateSubscribers = new v0(), this.velocityUpdateSubscribers = new v0(), this.renderSubscribers = new v0(), this.canTrackVelocity = !1, this.updateAndNotify = function(r, o) {
        o === void 0 && (o = !0), n.prev = n.current, n.current = r;
        var i = cx(), s = i.delta, a = i.timestamp;
        n.lastUpdated !== a && (n.timeDelta = s, n.lastUpdated = a, ks.postRender(n.scheduleVelocityCheck)), n.prev !== n.current && n.updateSubscribers.notify(n.current), n.velocityUpdateSubscribers.getSize() && n.velocityUpdateSubscribers.notify(n.getVelocity()), o && n.renderSubscribers.notify(n.current);
      }, this.scheduleVelocityCheck = function() {
        return ks.postRender(n.velocityCheck);
      }, this.velocityCheck = function(r) {
        var o = r.timestamp;
        o !== n.lastUpdated && (n.prev = n.current, n.velocityUpdateSubscribers.notify(n.getVelocity()));
      }, this.hasAnimated = !1, this.prev = this.current = e, this.canTrackVelocity = Nmt(this.current);
    }
    return t.prototype.onChange = function(e) {
      return this.updateSubscribers.add(e);
    }, t.prototype.clearListeners = function() {
      this.updateSubscribers.clear();
    }, t.prototype.onRenderRequest = function(e) {
      return e(this.get()), this.renderSubscribers.add(e);
    }, t.prototype.attach = function(e) {
      this.passiveEffect = e;
    }, t.prototype.set = function(e, n) {
      n === void 0 && (n = !0), !n || !this.passiveEffect ? this.updateAndNotify(e, n) : this.passiveEffect(e, this.updateAndNotify);
    }, t.prototype.get = function() {
      return this.current;
    }, t.prototype.getPrevious = function() {
      return this.prev;
    }, t.prototype.getVelocity = function() {
      return this.canTrackVelocity ? (
        // These casts could be avoided if parseFloat would be typed better
        Pce(parseFloat(this.current) - parseFloat(this.prev), this.timeDelta)
      ) : 0;
    }, t.prototype.start = function(e) {
      var n = this;
      return this.stop(), new Promise(function(r) {
        n.hasAnimated = !0, n.stopAnimation = e(r);
      }).then(function() {
        return n.clearAnimation();
      });
    }, t.prototype.stop = function() {
      this.stopAnimation && this.stopAnimation(), this.clearAnimation();
    }, t.prototype.isAnimating = function() {
      return !!this.stopAnimation;
    }, t.prototype.clearAnimation = function() {
      this.stopAnimation = null;
    }, t.prototype.destroy = function() {
      this.updateSubscribers.clear(), this.renderSubscribers.clear(), this.stop();
    }, t;
  }()
);
function mp(t) {
  return new jmt(t);
}
var wbe = function(t) {
  return function(e) {
    return e.test(t);
  };
}, Lmt = {
  test: function(t) {
    return t === "auto";
  },
  parse: function(t) {
    return t;
  }
}, xbe = [Gd, vt, va, hc, j3e, N3e, Lmt], Om = function(t) {
  return xbe.find(wbe(t));
}, Fmt = Cs(Cs([], hr(xbe), !1), [Eo, Il], !1), Bmt = function(t) {
  return Fmt.find(wbe(t));
};
function zmt(t, e, n) {
  t.hasValue(e) ? t.getValue(e).set(n) : t.addValue(e, mp(n));
}
function qmt(t, e) {
  var n = vO(t, e), r = n ? t.makeTargetAnimatable(n, !1) : {}, o = r.transitionEnd, i = o === void 0 ? {} : o;
  r.transition;
  var s = ss(r, ["transitionEnd", "transition"]);
  s = Ve(Ve({}, s), i);
  for (var a in s) {
    var l = abe(s[a]);
    zmt(t, a, l);
  }
}
function Umt(t, e, n) {
  var r, o, i, s, a = Object.keys(e).filter(function(h) {
    return !t.hasValue(h);
  }), l = a.length;
  if (l)
    for (var c = 0; c < l; c++) {
      var u = a[c], d = e[u], f = null;
      Array.isArray(d) && (f = d[0]), f === null && (f = (o = (r = n[u]) !== null && r !== void 0 ? r : t.readValue(u)) !== null && o !== void 0 ? o : e[u]), f != null && (typeof f == "string" && (Dmt(f) || Imt(f)) ? f = parseFloat(f) : !Bmt(f) && Il.test(d) && (f = h6(u, d)), t.addValue(u, mp(f)), (i = (s = n)[u]) !== null && i !== void 0 || (s[u] = f), t.setBaseTarget(u, f));
    }
}
function Hmt(t, e) {
  if (e) {
    var n = e[t] || e.default || e;
    return n.from;
  }
}
function Vmt(t, e, n) {
  var r, o, i = {};
  for (var s in t)
    i[s] = (r = Hmt(s, e)) !== null && r !== void 0 ? r : (o = n.getValue(s)) === null || o === void 0 ? void 0 : o.get();
  return i;
}
function Wmt(t, e, n) {
  n === void 0 && (n = {}), t.notifyAnimationStart(e);
  var r;
  if (Array.isArray(e)) {
    var o = e.map(function(s) {
      return r3(t, s, n);
    });
    r = Promise.all(o);
  } else if (typeof e == "string")
    r = r3(t, e, n);
  else {
    var i = typeof e == "function" ? vO(t, e, n.custom) : e;
    r = Ebe(t, i, n);
  }
  return r.then(function() {
    return t.notifyAnimationComplete(e);
  });
}
function r3(t, e, n) {
  var r;
  n === void 0 && (n = {});
  var o = vO(t, e, n.custom), i = (o || {}).transition, s = i === void 0 ? t.getDefaultTransition() || {} : i;
  n.transitionOverride && (s = n.transitionOverride);
  var a = o ? function() {
    return Ebe(t, o, n);
  } : function() {
    return Promise.resolve();
  }, l = !((r = t.variantChildren) === null || r === void 0) && r.size ? function(h) {
    h === void 0 && (h = 0);
    var p = s.delayChildren, m = p === void 0 ? 0 : p, g = s.staggerChildren, y = s.staggerDirection;
    return Gmt(t, e, m + h, g, y, n);
  } : function() {
    return Promise.resolve();
  }, c = s.when;
  if (c) {
    var u = hr(c === "beforeChildren" ? [a, l] : [l, a], 2), d = u[0], f = u[1];
    return d().then(f);
  } else
    return Promise.all([a(), l(n.delay)]);
}
function Ebe(t, e, n) {
  var r, o = n === void 0 ? {} : n, i = o.delay, s = i === void 0 ? 0 : i, a = o.transitionOverride, l = o.type, c = t.makeTargetAnimatable(e), u = c.transition, d = u === void 0 ? t.getDefaultTransition() : u, f = c.transitionEnd, h = ss(c, ["transition", "transitionEnd"]);
  a && (d = a);
  var p = [], m = l && ((r = t.animationState) === null || r === void 0 ? void 0 : r.getState()[l]);
  for (var g in h) {
    var y = t.getValue(g), v = h[g];
    if (!(!y || v === void 0 || m && Kmt(m, g))) {
      var b = Ve({ delay: s }, d);
      t.shouldReduceMotion && Fv(g) && (b = Ve(Ve({}, b), { type: !1, delay: 0 }));
      var _ = m6(g, y, v, b);
      p.push(_);
    }
  }
  return Promise.all(p).then(function() {
    f && qmt(t, f);
  });
}
function Gmt(t, e, n, r, o, i) {
  n === void 0 && (n = 0), r === void 0 && (r = 0), o === void 0 && (o = 1);
  var s = [], a = (t.variantChildren.size - 1) * r, l = o === 1 ? function(c) {
    return c === void 0 && (c = 0), c * r;
  } : function(c) {
    return c === void 0 && (c = 0), a - c * r;
  };
  return Array.from(t.variantChildren).sort(Ymt).forEach(function(c, u) {
    s.push(r3(c, e, Ve(Ve({}, i), { delay: n + l(u) })).then(function() {
      return c.notifyAnimationComplete(e);
    }));
  }), Promise.all(s);
}
function Ymt(t, e) {
  return t.sortNodePosition(e);
}
function Kmt(t, e) {
  var n = t.protectedKeys, r = t.needsAnimating, o = n.hasOwnProperty(e) && r[e] !== !0;
  return r[e] = !1, o;
}
var v6 = [
  qn.Animate,
  qn.InView,
  qn.Focus,
  qn.Hover,
  qn.Tap,
  qn.Drag,
  qn.Exit
], Xmt = Cs([], hr(v6), !1).reverse(), Qmt = v6.length;
function Zmt(t) {
  return function(e) {
    return Promise.all(e.map(function(n) {
      var r = n.animation, o = n.options;
      return Wmt(t, r, o);
    }));
  };
}
function Jmt(t) {
  var e = Zmt(t), n = tgt(), r = {}, o = !0, i = function(u, d) {
    var f = vO(t, d);
    if (f) {
      f.transition;
      var h = f.transitionEnd, p = ss(f, ["transition", "transitionEnd"]);
      u = Ve(Ve(Ve({}, u), p), h);
    }
    return u;
  };
  function s(u) {
    return r[u] !== void 0;
  }
  function a(u) {
    e = u(t);
  }
  function l(u, d) {
    for (var f, h = t.getProps(), p = t.getVariantContext(!0) || {}, m = [], g = /* @__PURE__ */ new Set(), y = {}, v = 1 / 0, b = function(E) {
      var S = Xmt[E], C = n[S], R = (f = h[S]) !== null && f !== void 0 ? f : p[S], P = bs(R), N = S === d ? C.isActive : null;
      N === !1 && (v = E);
      var A = R === p[S] && R !== h[S] && P;
      if (A && o && t.manuallyAnimateOnMount && (A = !1), C.protectedKeys = Ve({}, y), // If it isn't active and hasn't *just* been set as inactive
      !C.isActive && N === null || // If we didn't and don't have any defined prop for this animation type
      !R && !C.prevProp || // Or if the prop doesn't define an animation
      c6(R) || typeof R == "boolean")
        return "continue";
      var O = egt(C.prevProp, R), k = O || // If we're making this variant active, we want to always make it active
      S === d && C.isActive && !A && P || // If we removed a higher-priority variant (i is in reverse order)
      E > v && P, T = Array.isArray(R) ? R : [R], I = T.reduce(i, {});
      N === !1 && (I = {});
      var j = C.prevResolvedValues, z = j === void 0 ? {} : j, $ = Ve(Ve({}, z), I), D = function(B) {
        k = !0, g.delete(B), C.needsAnimating[B] = !0;
      };
      for (var U in $) {
        var q = I[U], F = z[U];
        y.hasOwnProperty(U) || (q !== F ? By(q) && By(F) ? !_be(q, F) || O ? D(U) : C.protectedKeys[U] = !0 : q !== void 0 ? D(U) : g.add(U) : q !== void 0 && g.has(U) ? D(U) : C.protectedKeys[U] = !0);
      }
      C.prevProp = R, C.prevResolvedValues = I, C.isActive && (y = Ve(Ve({}, y), I)), o && t.blockInitialAnimation && (k = !1), k && !A && m.push.apply(m, Cs([], hr(T.map(function(B) {
        return {
          animation: B,
          options: Ve({ type: S }, u)
        };
      })), !1));
    }, _ = 0; _ < Qmt; _++)
      b(_);
    if (r = Ve({}, y), g.size) {
      var w = {};
      g.forEach(function(E) {
        var S = t.getBaseTarget(E);
        S !== void 0 && (w[E] = S);
      }), m.push({ animation: w });
    }
    var x = !!m.length;
    return o && h.initial === !1 && !t.manuallyAnimateOnMount && (x = !1), o = !1, x ? e(m) : Promise.resolve();
  }
  function c(u, d, f) {
    var h;
    if (n[u].isActive === d)
      return Promise.resolve();
    (h = t.variantChildren) === null || h === void 0 || h.forEach(function(g) {
      var y;
      return (y = g.animationState) === null || y === void 0 ? void 0 : y.setActive(u, d);
    }), n[u].isActive = d;
    var p = l(f, u);
    for (var m in n)
      n[m].protectedKeys = {};
    return p;
  }
  return {
    isAnimated: s,
    animateChanges: l,
    setActive: c,
    setAnimateFunction: a,
    getState: function() {
      return n;
    }
  };
}
function egt(t, e) {
  return typeof e == "string" ? e !== t : Vve(e) ? !_be(e, t) : !1;
}
function Eu(t) {
  return t === void 0 && (t = !1), {
    isActive: t,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function tgt() {
  var t;
  return t = {}, t[qn.Animate] = Eu(!0), t[qn.InView] = Eu(), t[qn.Hover] = Eu(), t[qn.Tap] = Eu(), t[qn.Drag] = Eu(), t[qn.Focus] = Eu(), t[qn.Exit] = Eu(), t;
}
var ngt = {
  animation: zc(function(t) {
    var e = t.visualElement, n = t.animate;
    e.animationState || (e.animationState = Jmt(e)), c6(n) && Ne(function() {
      return n.subscribe(e);
    }, [n]);
  }),
  exit: zc(function(t) {
    var e = t.custom, n = t.visualElement, r = hr(bbe(), 2), o = r[0], i = r[1], s = Hn(jv);
    Ne(function() {
      var a, l;
      n.isPresent = o;
      var c = (a = n.animationState) === null || a === void 0 ? void 0 : a.setActive(qn.Exit, !o, { custom: (l = s?.custom) !== null && l !== void 0 ? l : e });
      !o && c?.then(i);
    }, [o]);
  })
}, Sbe = (
  /** @class */
  function() {
    function t(e, n, r) {
      var o = this, i = r === void 0 ? {} : r, s = i.transformPagePoint;
      if (this.startEvent = null, this.lastMoveEvent = null, this.lastMoveEventInfo = null, this.handlers = {}, this.updatePoint = function() {
        if (o.lastMoveEvent && o.lastMoveEventInfo) {
          var f = dT(o.lastMoveEventInfo, o.history), h = o.startEvent !== null, p = $ce(f.offset, { x: 0, y: 0 }) >= 3;
          if (!(!h && !p)) {
            var m = f.point, g = cx().timestamp;
            o.history.push(Ve(Ve({}, m), { timestamp: g }));
            var y = o.handlers, v = y.onStart, b = y.onMove;
            h || (v && v(o.lastMoveEvent, f), o.startEvent = o.lastMoveEvent), b && b(o.lastMoveEvent, f);
          }
        }
      }, this.handlePointerMove = function(f, h) {
        if (o.lastMoveEvent = f, o.lastMoveEventInfo = uT(h, o.transformPagePoint), cbe(f) && f.buttons === 0) {
          o.handlePointerUp(f, h);
          return;
        }
        ks.update(o.updatePoint, !0);
      }, this.handlePointerUp = function(f, h) {
        o.end();
        var p = o.handlers, m = p.onEnd, g = p.onSessionEnd, y = dT(uT(h, o.transformPagePoint), o.history);
        o.startEvent && m && m(f, y), g && g(f, y);
      }, !(ube(e) && e.touches.length > 1)) {
        this.handlers = n, this.transformPagePoint = s;
        var a = u6(e), l = uT(a, this.transformPagePoint), c = l.point, u = cx().timestamp;
        this.history = [Ve(Ve({}, c), { timestamp: u })];
        var d = n.onSessionStart;
        d && d(e, dT(l, this.history)), this.removeListeners = gS(Ah(window, "pointermove", this.handlePointerMove), Ah(window, "pointerup", this.handlePointerUp), Ah(window, "pointercancel", this.handlePointerUp));
      }
    }
    return t.prototype.updateHandlers = function(e) {
      this.handlers = e;
    }, t.prototype.end = function() {
      this.removeListeners && this.removeListeners(), zh.update(this.updatePoint);
    }, t;
  }()
);
function uT(t, e) {
  return e ? { point: e(t.point) } : t;
}
function FQ(t, e) {
  return { x: t.x - e.x, y: t.y - e.y };
}
function dT(t, e) {
  var n = t.point;
  return {
    point: n,
    delta: FQ(n, Obe(e)),
    offset: FQ(n, rgt(e)),
    velocity: ogt(e, 0.1)
  };
}
function rgt(t) {
  return t[0];
}
function Obe(t) {
  return t[t.length - 1];
}
function ogt(t, e) {
  if (t.length < 2)
    return { x: 0, y: 0 };
  for (var n = t.length - 1, r = null, o = Obe(t); n >= 0 && (r = t[n], !(o.timestamp - r.timestamp > ME(e))); )
    n--;
  if (!r)
    return { x: 0, y: 0 };
  var i = (o.timestamp - r.timestamp) / 1e3;
  if (i === 0)
    return { x: 0, y: 0 };
  var s = {
    x: (o.x - r.x) / i,
    y: (o.y - r.y) / i
  };
  return s.x === 1 / 0 && (s.x = 0), s.y === 1 / 0 && (s.y = 0), s;
}
function zl(t) {
  return t.max - t.min;
}
function BQ(t, e, n) {
  return e === void 0 && (e = 0), n === void 0 && (n = 0.01), $ce(t, e) < n;
}
function zQ(t, e, n, r) {
  r === void 0 && (r = 0.5), t.origin = r, t.originPoint = fr(e.min, e.max, t.origin), t.scale = zl(n) / zl(e), (BQ(t.scale, 1, 1e-4) || isNaN(t.scale)) && (t.scale = 1), t.translate = fr(n.min, n.max, t.origin) - t.originPoint, (BQ(t.translate) || isNaN(t.translate)) && (t.translate = 0);
}
function b0(t, e, n, r) {
  zQ(t.x, e.x, n.x, r?.originX), zQ(t.y, e.y, n.y, r?.originY);
}
function qQ(t, e, n) {
  t.min = n.min + e.min, t.max = t.min + zl(e);
}
function igt(t, e, n) {
  qQ(t.x, e.x, n.x), qQ(t.y, e.y, n.y);
}
function UQ(t, e, n) {
  t.min = e.min - n.min, t.max = t.min + zl(e);
}
function _0(t, e, n) {
  UQ(t.x, e.x, n.x), UQ(t.y, e.y, n.y);
}
function sgt(t, e, n) {
  var r = e.min, o = e.max;
  return r !== void 0 && t < r ? t = n ? fr(r, t, n.min) : Math.max(t, r) : o !== void 0 && t > o && (t = n ? fr(o, t, n.max) : Math.min(t, o)), t;
}
function HQ(t, e, n) {
  return {
    min: e !== void 0 ? t.min + e : void 0,
    max: n !== void 0 ? t.max + n - (t.max - t.min) : void 0
  };
}
function agt(t, e) {
  var n = e.top, r = e.left, o = e.bottom, i = e.right;
  return {
    x: HQ(t.x, r, i),
    y: HQ(t.y, n, o)
  };
}
function VQ(t, e) {
  var n, r = e.min - t.min, o = e.max - t.max;
  return e.max - e.min < t.max - t.min && (n = hr([o, r], 2), r = n[0], o = n[1]), { min: r, max: o };
}
function lgt(t, e) {
  return {
    x: VQ(t.x, e.x),
    y: VQ(t.y, e.y)
  };
}
function cgt(t, e) {
  var n = 0.5, r = zl(t), o = zl(e);
  return o > r ? n = B0(e.min, e.max - r, t.min) : r > o && (n = B0(t.min, t.max - o, e.min)), ax(0, 1, n);
}
function ugt(t, e) {
  var n = {};
  return e.min !== void 0 && (n.min = e.min - t.min), e.max !== void 0 && (n.max = e.max - t.min), n;
}
var o3 = 0.35;
function dgt(t) {
  return t === void 0 && (t = o3), t === !1 ? t = 0 : t === !0 && (t = o3), {
    x: WQ(t, "left", "right"),
    y: WQ(t, "top", "bottom")
  };
}
function WQ(t, e, n) {
  return {
    min: GQ(t, e),
    max: GQ(t, n)
  };
}
function GQ(t, e) {
  var n;
  return typeof t == "number" ? t : (n = t[e]) !== null && n !== void 0 ? n : 0;
}
var YQ = function() {
  return {
    translate: 0,
    scale: 1,
    origin: 0,
    originPoint: 0
  };
}, w0 = function() {
  return {
    x: YQ(),
    y: YQ()
  };
}, KQ = function() {
  return { min: 0, max: 0 };
}, oo = function() {
  return {
    x: KQ(),
    y: KQ()
  };
};
function Js(t) {
  return [t("x"), t("y")];
}
function Cbe(t) {
  var e = t.top, n = t.left, r = t.right, o = t.bottom;
  return {
    x: { min: n, max: r },
    y: { min: e, max: o }
  };
}
function fgt(t) {
  var e = t.x, n = t.y;
  return { top: n.min, right: e.max, bottom: n.max, left: e.min };
}
function hgt(t, e) {
  if (!e)
    return t;
  var n = e({ x: t.left, y: t.top }), r = e({ x: t.right, y: t.bottom });
  return {
    top: n.y,
    left: n.x,
    bottom: r.y,
    right: r.x
  };
}
function fT(t) {
  return t === void 0 || t === 1;
}
function kbe(t) {
  var e = t.scale, n = t.scaleX, r = t.scaleY;
  return !fT(e) || !fT(n) || !fT(r);
}
function mc(t) {
  return kbe(t) || XQ(t.x) || XQ(t.y) || t.z || t.rotate || t.rotateX || t.rotateY;
}
function XQ(t) {
  return t && t !== "0%";
}
function DE(t, e, n) {
  var r = t - n, o = e * r;
  return n + o;
}
function QQ(t, e, n, r, o) {
  return o !== void 0 && (t = DE(t, o, r)), DE(t, n, r) + e;
}
function i3(t, e, n, r, o) {
  e === void 0 && (e = 0), n === void 0 && (n = 1), t.min = QQ(t.min, e, n, r, o), t.max = QQ(t.max, e, n, r, o);
}
function Abe(t, e) {
  var n = e.x, r = e.y;
  i3(t.x, n.translate, n.scale, n.originPoint), i3(t.y, r.translate, r.scale, r.originPoint);
}
function pgt(t, e, n, r) {
  var o, i;
  r === void 0 && (r = !1);
  var s = n.length;
  if (s) {
    e.x = e.y = 1;
    for (var a, l, c = 0; c < s; c++)
      a = n[c], l = a.projectionDelta, ((i = (o = a.instance) === null || o === void 0 ? void 0 : o.style) === null || i === void 0 ? void 0 : i.display) !== "contents" && (r && a.options.layoutScroll && a.scroll && a !== a.root && ah(t, { x: -a.scroll.x, y: -a.scroll.y }), l && (e.x *= l.x.scale, e.y *= l.y.scale, Abe(t, l)), r && mc(a.latestValues) && ah(t, a.latestValues));
  }
}
function Ec(t, e) {
  t.min = t.min + e, t.max = t.max + e;
}
function ZQ(t, e, n) {
  var r = hr(n, 3), o = r[0], i = r[1], s = r[2], a = e[s] !== void 0 ? e[s] : 0.5, l = fr(t.min, t.max, a);
  i3(t, e[o], e[i], l, e.scale);
}
var mgt = ["x", "scaleX", "originX"], ggt = ["y", "scaleY", "originY"];
function ah(t, e) {
  ZQ(t.x, e, mgt), ZQ(t.y, e, ggt);
}
function Tbe(t, e) {
  return Cbe(hgt(t.getBoundingClientRect(), e));
}
function ygt(t, e, n) {
  var r = Tbe(t, n), o = e.scroll;
  return o && (Ec(r.x, o.x), Ec(r.y, o.y)), r;
}
var vgt = /* @__PURE__ */ new WeakMap(), bgt = (
  /** @class */
  function() {
    function t(e) {
      this.openGlobalLock = null, this.isDragging = !1, this.currentDirection = null, this.originPoint = { x: 0, y: 0 }, this.constraints = !1, this.hasMutatedConstraints = !1, this.elastic = oo(), this.visualElement = e;
    }
    return t.prototype.start = function(e, n) {
      var r = this, o = n === void 0 ? {} : n, i = o.snapToCursor, s = i === void 0 ? !1 : i;
      if (this.visualElement.isPresent !== !1) {
        var a = function(d) {
          r.stopAnimation(), s && r.snapToCursor(u6(d, "page").point);
        }, l = function(d, f) {
          var h, p = r.getProps(), m = p.drag, g = p.dragPropagation, y = p.onDragStart;
          m && !g && (r.openGlobalLock && r.openGlobalLock(), r.openGlobalLock = pbe(m), !r.openGlobalLock) || (r.isDragging = !0, r.currentDirection = null, r.resolveConstraints(), r.visualElement.projection && (r.visualElement.projection.isAnimationBlocked = !0, r.visualElement.projection.target = void 0), Js(function(v) {
            var b, _, w = r.getAxisMotionValue(v).get() || 0;
            if (va.test(w)) {
              var x = (_ = (b = r.visualElement.projection) === null || b === void 0 ? void 0 : b.layout) === null || _ === void 0 ? void 0 : _.actual[v];
              if (x) {
                var E = zl(x);
                w = E * (parseFloat(w) / 100);
              }
            }
            r.originPoint[v] = w;
          }), y?.(d, f), (h = r.visualElement.animationState) === null || h === void 0 || h.setActive(qn.Drag, !0));
        }, c = function(d, f) {
          var h = r.getProps(), p = h.dragPropagation, m = h.dragDirectionLock, g = h.onDirectionLock, y = h.onDrag;
          if (!(!p && !r.openGlobalLock)) {
            var v = f.offset;
            if (m && r.currentDirection === null) {
              r.currentDirection = _gt(v), r.currentDirection !== null && g?.(r.currentDirection);
              return;
            }
            r.updateAxis("x", f.point, v), r.updateAxis("y", f.point, v), r.visualElement.syncRender(), y?.(d, f);
          }
        }, u = function(d, f) {
          return r.stop(d, f);
        };
        this.panSession = new Sbe(e, {
          onSessionStart: a,
          onStart: l,
          onMove: c,
          onSessionEnd: u
        }, { transformPagePoint: this.visualElement.getTransformPagePoint() });
      }
    }, t.prototype.stop = function(e, n) {
      var r = this.isDragging;
      if (this.cancel(), !!r) {
        var o = n.velocity;
        this.startAnimation(o);
        var i = this.getProps().onDragEnd;
        i?.(e, n);
      }
    }, t.prototype.cancel = function() {
      var e, n;
      this.isDragging = !1, this.visualElement.projection && (this.visualElement.projection.isAnimationBlocked = !1), (e = this.panSession) === null || e === void 0 || e.end(), this.panSession = void 0;
      var r = this.getProps().dragPropagation;
      !r && this.openGlobalLock && (this.openGlobalLock(), this.openGlobalLock = null), (n = this.visualElement.animationState) === null || n === void 0 || n.setActive(qn.Drag, !1);
    }, t.prototype.updateAxis = function(e, n, r) {
      var o = this.getProps().drag;
      if (!(!r || !D1(e, o, this.currentDirection))) {
        var i = this.getAxisMotionValue(e), s = this.originPoint[e] + r[e];
        this.constraints && this.constraints[e] && (s = sgt(s, this.constraints[e], this.elastic[e])), i.set(s);
      }
    }, t.prototype.resolveConstraints = function() {
      var e = this, n = this.getProps(), r = n.dragConstraints, o = n.dragElastic, i = (this.visualElement.projection || {}).layout, s = this.constraints;
      r && sh(r) ? this.constraints || (this.constraints = this.resolveRefConstraints()) : r && i ? this.constraints = agt(i.actual, r) : this.constraints = !1, this.elastic = dgt(o), s !== this.constraints && i && this.constraints && !this.hasMutatedConstraints && Js(function(a) {
        e.getAxisMotionValue(a) && (e.constraints[a] = ugt(i.actual[a], e.constraints[a]));
      });
    }, t.prototype.resolveRefConstraints = function() {
      var e = this.getProps(), n = e.dragConstraints, r = e.onMeasureDragConstraints;
      if (!n || !sh(n))
        return !1;
      var o = n.current;
      Zi(o !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
      var i = this.visualElement.projection;
      if (!i || !i.layout)
        return !1;
      var s = ygt(o, i.root, this.visualElement.getTransformPagePoint()), a = lgt(i.layout.actual, s);
      if (r) {
        var l = r(fgt(a));
        this.hasMutatedConstraints = !!l, l && (a = Cbe(l));
      }
      return a;
    }, t.prototype.startAnimation = function(e) {
      var n = this, r = this.getProps(), o = r.drag, i = r.dragMomentum, s = r.dragElastic, a = r.dragTransition, l = r.dragSnapToOrigin, c = r.onDragTransitionEnd, u = this.constraints || {}, d = Js(function(f) {
        var h;
        if (D1(f, o, n.currentDirection)) {
          var p = (h = u?.[f]) !== null && h !== void 0 ? h : {};
          l && (p = { min: 0, max: 0 });
          var m = s ? 200 : 1e6, g = s ? 40 : 1e7, y = Ve(Ve({ type: "inertia", velocity: i ? e[f] : 0, bounceStiffness: m, bounceDamping: g, timeConstant: 750, restDelta: 1, restSpeed: 10 }, a), p);
          return n.startAxisValueAnimation(f, y);
        }
      });
      return Promise.all(d).then(c);
    }, t.prototype.startAxisValueAnimation = function(e, n) {
      var r = this.getAxisMotionValue(e);
      return m6(e, r, 0, n);
    }, t.prototype.stopAnimation = function() {
      var e = this;
      Js(function(n) {
        return e.getAxisMotionValue(n).stop();
      });
    }, t.prototype.getAxisMotionValue = function(e) {
      var n, r, o = "_drag" + e.toUpperCase(), i = this.visualElement.getProps()[o];
      return i || this.visualElement.getValue(e, (r = (n = this.visualElement.getProps().initial) === null || n === void 0 ? void 0 : n[e]) !== null && r !== void 0 ? r : 0);
    }, t.prototype.snapToCursor = function(e) {
      var n = this;
      Js(function(r) {
        var o = n.getProps().drag;
        if (D1(r, o, n.currentDirection)) {
          var i = n.visualElement.projection, s = n.getAxisMotionValue(r);
          if (i && i.layout) {
            var a = i.layout.actual[r], l = a.min, c = a.max;
            s.set(e[r] - fr(l, c, 0.5));
          }
        }
      });
    }, t.prototype.scalePositionWithinConstraints = function() {
      var e = this, n, r = this.getProps(), o = r.drag, i = r.dragConstraints, s = this.visualElement.projection;
      if (!(!sh(i) || !s || !this.constraints)) {
        this.stopAnimation();
        var a = { x: 0, y: 0 };
        Js(function(c) {
          var u = e.getAxisMotionValue(c);
          if (u) {
            var d = u.get();
            a[c] = cgt({ min: d, max: d }, e.constraints[c]);
          }
        });
        var l = this.visualElement.getProps().transformTemplate;
        this.visualElement.getInstance().style.transform = l ? l({}, "") : "none", (n = s.root) === null || n === void 0 || n.updateScroll(), s.updateLayout(), this.resolveConstraints(), Js(function(c) {
          if (D1(c, o, null)) {
            var u = e.getAxisMotionValue(c), d = e.constraints[c], f = d.min, h = d.max;
            u.set(fr(f, h, a[c]));
          }
        });
      }
    }, t.prototype.addListeners = function() {
      var e = this, n;
      vgt.set(this.visualElement, this);
      var r = this.visualElement.getInstance(), o = Ah(r, "pointerdown", function(c) {
        var u = e.getProps(), d = u.drag, f = u.dragListener, h = f === void 0 ? !0 : f;
        d && h && e.start(c);
      }), i = function() {
        var c = e.getProps().dragConstraints;
        sh(c) && (e.constraints = e.resolveRefConstraints());
      }, s = this.visualElement.projection, a = s.addEventListener("measure", i);
      s && !s.layout && ((n = s.root) === null || n === void 0 || n.updateScroll(), s.updateLayout()), i();
      var l = _O(window, "resize", function() {
        return e.scalePositionWithinConstraints();
      });
      return s.addEventListener("didUpdate", function(c) {
        var u = c.delta, d = c.hasLayoutChanged;
        e.isDragging && d && (Js(function(f) {
          var h = e.getAxisMotionValue(f);
          h && (e.originPoint[f] += u[f].translate, h.set(h.get() + u[f].translate));
        }), e.visualElement.syncRender());
      }), function() {
        l(), o(), a();
      };
    }, t.prototype.getProps = function() {
      var e = this.visualElement.getProps(), n = e.drag, r = n === void 0 ? !1 : n, o = e.dragDirectionLock, i = o === void 0 ? !1 : o, s = e.dragPropagation, a = s === void 0 ? !1 : s, l = e.dragConstraints, c = l === void 0 ? !1 : l, u = e.dragElastic, d = u === void 0 ? o3 : u, f = e.dragMomentum, h = f === void 0 ? !0 : f;
      return Ve(Ve({}, e), { drag: r, dragDirectionLock: i, dragPropagation: a, dragConstraints: c, dragElastic: d, dragMomentum: h });
    }, t;
  }()
);
function D1(t, e, n) {
  return (e === !0 || e === t) && (n === null || n === t);
}
function _gt(t, e) {
  e === void 0 && (e = 10);
  var n = null;
  return Math.abs(t.y) > e ? n = "y" : Math.abs(t.x) > e && (n = "x"), n;
}
function wgt(t) {
  var e = t.dragControls, n = t.visualElement, r = Lv(function() {
    return new bgt(n);
  });
  Ne(function() {
    return e && e.subscribe(r);
  }, [r, e]), Ne(function() {
    return r.addListeners();
  }, [r]);
}
function xgt(t) {
  var e = t.onPan, n = t.onPanStart, r = t.onPanEnd, o = t.onPanSessionStart, i = t.visualElement, s = e || n || r || o, a = Ue(null), l = Hn(n6).transformPagePoint, c = {
    onSessionStart: o,
    onStart: n,
    onMove: e,
    onEnd: function(d, f) {
      a.current = null, r && r(d, f);
    }
  };
  Ne(function() {
    a.current !== null && a.current.updateHandlers(c);
  });
  function u(d) {
    a.current = new Sbe(d, c, {
      transformPagePoint: l
    });
  }
  $E(i, "pointerdown", s && u), d6(function() {
    return a.current && a.current.end();
  });
}
var Egt = {
  pan: zc(xgt),
  drag: zc(wgt)
}, I1 = [
  "LayoutMeasure",
  "BeforeLayoutMeasure",
  "LayoutUpdate",
  "ViewportBoxUpdate",
  "Update",
  "Render",
  "AnimationComplete",
  "LayoutAnimationComplete",
  "AnimationStart",
  "LayoutAnimationStart",
  "SetAxisTarget",
  "Unmount"
];
function Sgt() {
  var t = I1.map(function() {
    return new v0();
  }), e = {}, n = {
    clearAllListeners: function() {
      return t.forEach(function(r) {
        return r.clear();
      });
    },
    updatePropListeners: function(r) {
      I1.forEach(function(o) {
        var i, s = "on" + o, a = r[s];
        (i = e[o]) === null || i === void 0 || i.call(e), a && (e[o] = n[s](a));
      });
    }
  };
  return t.forEach(function(r, o) {
    n["on" + I1[o]] = function(i) {
      return r.add(i);
    }, n["notify" + I1[o]] = function() {
      for (var i = [], s = 0; s < arguments.length; s++)
        i[s] = arguments[s];
      return r.notify.apply(r, Cs([], hr(i), !1));
    };
  }), n;
}
function Ogt(t, e, n) {
  var r;
  for (var o in e) {
    var i = e[o], s = n[o];
    if (Bl(i))
      t.addValue(o, i), process.env.NODE_ENV === "development" && ybe(i.version === "6.5.1", "Attempting to mix Framer Motion versions ".concat(i.version, " with 6.5.1 may not work as expected."));
    else if (Bl(s))
      t.addValue(o, mp(i));
    else if (s !== i)
      if (t.hasValue(o)) {
        var a = t.getValue(o);
        !a.hasAnimated && a.set(i);
      } else
        t.addValue(o, mp((r = t.getStaticValue(o)) !== null && r !== void 0 ? r : i));
  }
  for (var o in n)
    e[o] === void 0 && t.removeValue(o);
  return e;
}
var Rbe = function(t) {
  var e = t.treeType, n = e === void 0 ? "" : e, r = t.build, o = t.getBaseTarget, i = t.makeTargetAnimatable, s = t.measureViewportBox, a = t.render, l = t.readValueFromInstance, c = t.removeValueFromRenderState, u = t.sortNodePosition, d = t.scrapeMotionValuesFromProps;
  return function(f, h) {
    var p = f.parent, m = f.props, g = f.presenceId, y = f.blockInitialAnimation, v = f.visualState, b = f.shouldReduceMotion;
    h === void 0 && (h = {});
    var _ = !1, w = v.latestValues, x = v.renderState, E, S = Sgt(), C = /* @__PURE__ */ new Map(), R = /* @__PURE__ */ new Map(), P = {}, N = Ve({}, w), A;
    function O() {
      !E || !_ || (k(), a(E, x, m.style, q.projection));
    }
    function k() {
      r(q, x, w, h, m);
    }
    function T() {
      S.notifyUpdate(w);
    }
    function I(F, B) {
      var H = B.onChange(function(W) {
        w[F] = W, m.onUpdate && ks.update(T, !1, !0);
      }), Z = B.onRenderRequest(q.scheduleRender);
      R.set(F, function() {
        H(), Z();
      });
    }
    var j = d(m);
    for (var z in j) {
      var $ = j[z];
      w[z] !== void 0 && Bl($) && $.set(w[z], !1);
    }
    var D = bO(m), U = Gve(m), q = Ve(Ve({
      treeType: n,
      /**
       * This is a mirror of the internal instance prop, which keeps
       * VisualElement type-compatible with React's RefObject.
       */
      current: null,
      /**
       * The depth of this visual element within the visual element tree.
       */
      depth: p ? p.depth + 1 : 0,
      parent: p,
      children: /* @__PURE__ */ new Set(),
      /**
       *
       */
      presenceId: g,
      shouldReduceMotion: b,
      /**
       * If this component is part of the variant tree, it should track
       * any children that are also part of the tree. This is essentially
       * a shadow tree to simplify logic around how to stagger over children.
       */
      variantChildren: U ? /* @__PURE__ */ new Set() : void 0,
      /**
       * Whether this instance is visible. This can be changed imperatively
       * by the projection tree, is analogous to CSS's visibility in that
       * hidden elements should take up layout, and needs enacting by the configured
       * render function.
       */
      isVisible: void 0,
      /**
       * Normally, if a component is controlled by a parent's variants, it can
       * rely on that ancestor to trigger animations further down the tree.
       * However, if a component is created after its parent is mounted, the parent
       * won't trigger that mount animation so the child needs to.
       *
       * TODO: This might be better replaced with a method isParentMounted
       */
      manuallyAnimateOnMount: !!p?.isMounted(),
      /**
       * This can be set by AnimatePresence to force components that mount
       * at the same time as it to mount as if they have initial={false} set.
       */
      blockInitialAnimation: y,
      /**
       * Determine whether this component has mounted yet. This is mostly used
       * by variant children to determine whether they need to trigger their
       * own animations on mount.
       */
      isMounted: function() {
        return !!E;
      },
      mount: function(F) {
        _ = !0, E = q.current = F, q.projection && q.projection.mount(F), U && p && !D && (A = p?.addVariantChild(q)), C.forEach(function(B, H) {
          return I(H, B);
        }), p?.children.add(q), q.setProps(m);
      },
      /**
       *
       */
      unmount: function() {
        var F;
        (F = q.projection) === null || F === void 0 || F.unmount(), zh.update(T), zh.render(O), R.forEach(function(B) {
          return B();
        }), A?.(), p?.children.delete(q), S.clearAllListeners(), E = void 0, _ = !1;
      },
      /**
       * Add a child visual element to our set of children.
       */
      addVariantChild: function(F) {
        var B, H = q.getClosestVariantNode();
        if (H)
          return (B = H.variantChildren) === null || B === void 0 || B.add(F), function() {
            return H.variantChildren.delete(F);
          };
      },
      sortNodePosition: function(F) {
        return !u || n !== F.treeType ? 0 : u(q.getInstance(), F.getInstance());
      },
      /**
       * Returns the closest variant node in the tree starting from
       * this visual element.
       */
      getClosestVariantNode: function() {
        return U ? q : p?.getClosestVariantNode();
      },
      /**
       * Expose the latest layoutId prop.
       */
      getLayoutId: function() {
        return m.layoutId;
      },
      /**
       * Returns the current instance.
       */
      getInstance: function() {
        return E;
      },
      /**
       * Get/set the latest static values.
       */
      getStaticValue: function(F) {
        return w[F];
      },
      setStaticValue: function(F, B) {
        return w[F] = B;
      },
      /**
       * Returns the latest motion value state. Currently only used to take
       * a snapshot of the visual element - perhaps this can return the whole
       * visual state
       */
      getLatestValues: function() {
        return w;
      },
      /**
       * Set the visiblity of the visual element. If it's changed, schedule
       * a render to reflect these changes.
       */
      setVisibility: function(F) {
        q.isVisible !== F && (q.isVisible = F, q.scheduleRender());
      },
      /**
       * Make a target animatable by Popmotion. For instance, if we're
       * trying to animate width from 100px to 100vw we need to measure 100vw
       * in pixels to determine what we really need to animate to. This is also
       * pluggable to support Framer's custom value types like Color,
       * and CSS variables.
       */
      makeTargetAnimatable: function(F, B) {
        return B === void 0 && (B = !0), i(q, F, m, B);
      },
      /**
       * Measure the current viewport box with or without transforms.
       * Only measures axis-aligned boxes, rotate and skew must be manually
       * removed with a re-render to work.
       */
      measureViewportBox: function() {
        return s(E, m);
      },
      // Motion values ========================
      /**
       * Add a motion value and bind it to this visual element.
       */
      addValue: function(F, B) {
        q.hasValue(F) && q.removeValue(F), C.set(F, B), w[F] = B.get(), I(F, B);
      },
      /**
       * Remove a motion value and unbind any active subscriptions.
       */
      removeValue: function(F) {
        var B;
        C.delete(F), (B = R.get(F)) === null || B === void 0 || B(), R.delete(F), delete w[F], c(F, x);
      },
      /**
       * Check whether we have a motion value for this key
       */
      hasValue: function(F) {
        return C.has(F);
      },
      /**
       * Get a motion value for this key. If called with a default
       * value, we'll create one if none exists.
       */
      getValue: function(F, B) {
        var H = C.get(F);
        return H === void 0 && B !== void 0 && (H = mp(B), q.addValue(F, H)), H;
      },
      /**
       * Iterate over our motion values.
       */
      forEachValue: function(F) {
        return C.forEach(F);
      },
      /**
       * If we're trying to animate to a previously unencountered value,
       * we need to check for it in our state and as a last resort read it
       * directly from the instance (which might have performance implications).
       */
      readValue: function(F) {
        var B;
        return (B = w[F]) !== null && B !== void 0 ? B : l(E, F, h);
      },
      /**
       * Set the base target to later animate back to. This is currently
       * only hydrated on creation and when we first read a value.
       */
      setBaseTarget: function(F, B) {
        N[F] = B;
      },
      /**
       * Find the base target for a value thats been removed from all animation
       * props.
       */
      getBaseTarget: function(F) {
        if (o) {
          var B = o(m, F);
          if (B !== void 0 && !Bl(B))
            return B;
        }
        return N[F];
      }
    }, S), {
      /**
       * Build the renderer state based on the latest visual state.
       */
      build: function() {
        return k(), x;
      },
      /**
       * Schedule a render on the next animation frame.
       */
      scheduleRender: function() {
        ks.render(O, !1, !0);
      },
      /**
       * Synchronously fire render. It's prefered that we batch renders but
       * in many circumstances, like layout measurement, we need to run this
       * synchronously. However in those instances other measures should be taken
       * to batch reads/writes.
       */
      syncRender: O,
      /**
       * Update the provided props. Ensure any newly-added motion values are
       * added to our map, old ones removed, and listeners updated.
       */
      setProps: function(F) {
        (F.transformTemplate || m.transformTemplate) && q.scheduleRender(), m = F, S.updatePropListeners(F), P = Ogt(q, d(m), P);
      },
      getProps: function() {
        return m;
      },
      // Variants ==============================
      /**
       * Returns the variant definition with a given name.
       */
      getVariant: function(F) {
        var B;
        return (B = m.variants) === null || B === void 0 ? void 0 : B[F];
      },
      /**
       * Returns the defined default transition on this component.
       */
      getDefaultTransition: function() {
        return m.transition;
      },
      getTransformPagePoint: function() {
        return m.transformPagePoint;
      },
      /**
       * Used by child variant nodes to get the closest ancestor variant props.
       */
      getVariantContext: function(F) {
        if (F === void 0 && (F = !1), F)
          return p?.getVariantContext();
        if (!D) {
          var B = p?.getVariantContext() || {};
          return m.initial !== void 0 && (B.initial = m.initial), B;
        }
        for (var H = {}, Z = 0; Z < Cgt; Z++) {
          var W = Pbe[Z], G = m[W];
          (bs(G) || G === !1) && (H[W] = G);
        }
        return H;
      }
    });
    return q;
  };
}, Pbe = Cs(["initial"], hr(v6), !1), Cgt = Pbe.length;
function s3(t) {
  return typeof t == "string" && t.startsWith("var(--");
}
var $be = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
function kgt(t) {
  var e = $be.exec(t);
  if (!e)
    return [,];
  var n = hr(e, 3), r = n[1], o = n[2];
  return [r, o];
}
var Agt = 4;
function a3(t, e, n) {
  n === void 0 && (n = 1), Zi(n <= Agt, 'Max CSS variable fallback depth detected in property "'.concat(t, '". This may indicate a circular fallback dependency.'));
  var r = hr(kgt(t), 2), o = r[0], i = r[1];
  if (o) {
    var s = window.getComputedStyle(e).getPropertyValue(o);
    return s ? s.trim() : s3(i) ? a3(i, e, n + 1) : i;
  }
}
function Tgt(t, e, n) {
  var r, o = ss(e, []), i = t.getInstance();
  if (!(i instanceof Element))
    return { target: o, transitionEnd: n };
  n && (n = Ve({}, n)), t.forEachValue(function(c) {
    var u = c.get();
    if (s3(u)) {
      var d = a3(u, i);
      d && c.set(d);
    }
  });
  for (var s in o) {
    var a = o[s];
    if (s3(a)) {
      var l = a3(a, i);
      l && (o[s] = l, n && ((r = n[s]) !== null && r !== void 0 || (n[s] = a)));
    }
  }
  return { target: o, transitionEnd: n };
}
var Rgt = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  "x",
  "y"
]), Mbe = function(t) {
  return Rgt.has(t);
}, Pgt = function(t) {
  return Object.keys(t).some(Mbe);
}, Dbe = function(t, e) {
  t.set(e, !1), t.set(e);
}, N1 = function(t) {
  return t === Gd || t === vt;
}, JQ;
(function(t) {
  t.width = "width", t.height = "height", t.left = "left", t.right = "right", t.top = "top", t.bottom = "bottom";
})(JQ || (JQ = {}));
var eZ = function(t, e) {
  return parseFloat(t.split(", ")[e]);
}, tZ = function(t, e) {
  return function(n, r) {
    var o = r.transform;
    if (o === "none" || !o)
      return 0;
    var i = o.match(/^matrix3d\((.+)\)$/);
    if (i)
      return eZ(i[1], e);
    var s = o.match(/^matrix\((.+)\)$/);
    return s ? eZ(s[1], t) : 0;
  };
}, $gt = /* @__PURE__ */ new Set(["x", "y", "z"]), Mgt = Fy.filter(function(t) {
  return !$gt.has(t);
});
function Dgt(t) {
  var e = [];
  return Mgt.forEach(function(n) {
    var r = t.getValue(n);
    r !== void 0 && (e.push([n, r.get()]), r.set(n.startsWith("scale") ? 1 : 0));
  }), e.length && t.syncRender(), e;
}
var nZ = {
  // Dimensions
  width: function(t, e) {
    var n = t.x, r = e.paddingLeft, o = r === void 0 ? "0" : r, i = e.paddingRight, s = i === void 0 ? "0" : i;
    return n.max - n.min - parseFloat(o) - parseFloat(s);
  },
  height: function(t, e) {
    var n = t.y, r = e.paddingTop, o = r === void 0 ? "0" : r, i = e.paddingBottom, s = i === void 0 ? "0" : i;
    return n.max - n.min - parseFloat(o) - parseFloat(s);
  },
  top: function(t, e) {
    var n = e.top;
    return parseFloat(n);
  },
  left: function(t, e) {
    var n = e.left;
    return parseFloat(n);
  },
  bottom: function(t, e) {
    var n = t.y, r = e.top;
    return parseFloat(r) + (n.max - n.min);
  },
  right: function(t, e) {
    var n = t.x, r = e.left;
    return parseFloat(r) + (n.max - n.min);
  },
  // Transform
  x: tZ(4, 13),
  y: tZ(5, 14)
}, Igt = function(t, e, n) {
  var r = e.measureViewportBox(), o = e.getInstance(), i = getComputedStyle(o), s = i.display, a = {};
  s === "none" && e.setStaticValue("display", t.display || "block"), n.forEach(function(c) {
    a[c] = nZ[c](r, i);
  }), e.syncRender();
  var l = e.measureViewportBox();
  return n.forEach(function(c) {
    var u = e.getValue(c);
    Dbe(u, a[c]), t[c] = nZ[c](l, i);
  }), t;
}, Ngt = function(t, e, n, r) {
  n === void 0 && (n = {}), r === void 0 && (r = {}), e = Ve({}, e), r = Ve({}, r);
  var o = Object.keys(e).filter(Mbe), i = [], s = !1, a = [];
  if (o.forEach(function(u) {
    var d = t.getValue(u);
    if (t.hasValue(u)) {
      var f = n[u], h = Om(f), p = e[u], m;
      if (By(p)) {
        var g = p.length, y = p[0] === null ? 1 : 0;
        f = p[y], h = Om(f);
        for (var v = y; v < g; v++)
          m ? Zi(Om(p[v]) === m, "All keyframes must be of the same type") : (m = Om(p[v]), Zi(m === h || N1(h) && N1(m), "Keyframes must be of the same dimension as the current value"));
      } else
        m = Om(p);
      if (h !== m)
        if (N1(h) && N1(m)) {
          var b = d.get();
          typeof b == "string" && d.set(parseFloat(b)), typeof p == "string" ? e[u] = parseFloat(p) : Array.isArray(p) && m === vt && (e[u] = p.map(parseFloat));
        } else h?.transform && m?.transform && (f === 0 || p === 0) ? f === 0 ? d.set(m.transform(f)) : e[u] = h.transform(p) : (s || (i = Dgt(t), s = !0), a.push(u), r[u] = r[u] !== void 0 ? r[u] : e[u], Dbe(d, p));
    }
  }), a.length) {
    var l = a.indexOf("height") >= 0 ? window.pageYOffset : null, c = Igt(e, t, a);
    return i.length && i.forEach(function(u) {
      var d = hr(u, 2), f = d[0], h = d[1];
      t.getValue(f).set(h);
    }), t.syncRender(), l !== null && window.scrollTo({ top: l }), { target: c, transitionEnd: r };
  } else
    return { target: e, transitionEnd: r };
};
function jgt(t, e, n, r) {
  return Pgt(e) ? Ngt(t, e, n, r) : { target: e, transitionEnd: r };
}
var Lgt = function(t, e, n, r) {
  var o = Tgt(t, e, r);
  return e = o.target, r = o.transitionEnd, jgt(t, e, n, r);
};
function Fgt(t) {
  return window.getComputedStyle(t);
}
var Ibe = {
  treeType: "dom",
  readValueFromInstance: function(t, e) {
    if (Fv(e)) {
      var n = f6(e);
      return n && n.default || 0;
    } else {
      var r = Fgt(t);
      return (Qve(e) ? r.getPropertyValue(e) : r[e]) || 0;
    }
  },
  sortNodePosition: function(t, e) {
    return t.compareDocumentPosition(e) & 2 ? 1 : -1;
  },
  getBaseTarget: function(t, e) {
    var n;
    return (n = t.style) === null || n === void 0 ? void 0 : n[e];
  },
  measureViewportBox: function(t, e) {
    var n = e.transformPagePoint;
    return Tbe(t, n);
  },
  /**
   * Reset the transform on the current Element. This is called as part
   * of a batched process across the entire layout tree. To remove this write
   * cycle it'd be interesting to see if it's possible to "undo" all the current
   * layout transforms up the tree in the same way this.getBoundingBoxWithoutTransforms
   * works
   */
  resetTransform: function(t, e, n) {
    var r = n.transformTemplate;
    e.style.transform = r ? r({}, "") : "none", t.scheduleRender();
  },
  restoreTransform: function(t, e) {
    t.style.transform = e.style.transform;
  },
  removeValueFromRenderState: function(t, e) {
    var n = e.vars, r = e.style;
    delete n[t], delete r[t];
  },
  /**
   * Ensure that HTML and Framer-specific value types like `px`->`%` and `Color`
   * can be animated by Motion.
   */
  makeTargetAnimatable: function(t, e, n, r) {
    var o = n.transformValues;
    r === void 0 && (r = !0);
    var i = e.transition, s = e.transitionEnd, a = ss(e, ["transition", "transitionEnd"]), l = Vmt(a, i || {}, t);
    if (o && (s && (s = o(s)), a && (a = o(a)), l && (l = o(l))), r) {
      Umt(t, a, l);
      var c = Lgt(t, a, l, s);
      s = c.transitionEnd, a = c.target;
    }
    return Ve({ transition: i, transitionEnd: s }, a);
  },
  scrapeMotionValuesFromProps: l6,
  build: function(t, e, n, r, o) {
    t.isVisible !== void 0 && (e.style.visibility = t.isVisible ? "visible" : "hidden"), i6(e, n, r, o.transformTemplate);
  },
  render: rbe
}, Bgt = Rbe(Ibe), zgt = Rbe(Ve(Ve({}, Ibe), { getBaseTarget: function(t, e) {
  return t[e];
}, readValueFromInstance: function(t, e) {
  var n;
  return Fv(e) ? ((n = f6(e)) === null || n === void 0 ? void 0 : n.default) || 0 : (e = obe.has(e) ? e : nbe(e), t.getAttribute(e));
}, scrapeMotionValuesFromProps: sbe, build: function(t, e, n, r, o) {
  a6(e, n, r, o.transformTemplate);
}, render: ibe })), qgt = function(t, e) {
  return o6(t) ? zgt(e, { enableHardwareAcceleration: !1 }) : Bgt(e, { enableHardwareAcceleration: !0 });
};
function rZ(t, e) {
  return e.max === e.min ? 0 : t / (e.max - e.min) * 100;
}
var Cm = {
  correct: function(t, e) {
    if (!e.target)
      return t;
    if (typeof t == "string")
      if (vt.test(t))
        t = parseFloat(t);
      else
        return t;
    var n = rZ(t, e.target.x), r = rZ(t, e.target.y);
    return "".concat(n, "% ").concat(r, "%");
  }
}, oZ = "_$css", Ugt = {
  correct: function(t, e) {
    var n = e.treeScale, r = e.projectionDelta, o = t, i = t.includes("var("), s = [];
    i && (t = t.replace($be, function(m) {
      return s.push(m), oZ;
    }));
    var a = Il.parse(t);
    if (a.length > 5)
      return o;
    var l = Il.createTransformer(t), c = typeof a[0] != "number" ? 1 : 0, u = r.x.scale * n.x, d = r.y.scale * n.y;
    a[0 + c] /= u, a[1 + c] /= d;
    var f = fr(u, d, 0.5);
    typeof a[2 + c] == "number" && (a[2 + c] /= f), typeof a[3 + c] == "number" && (a[3 + c] /= f);
    var h = l(a);
    if (i) {
      var p = 0;
      h = h.replace(oZ, function() {
        var m = s[p];
        return p++, m;
      });
    }
    return h;
  }
}, Hgt = (
  /** @class */
  function(t) {
    cce(e, t);
    function e() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return e.prototype.componentDidMount = function() {
      var n = this, r = this.props, o = r.visualElement, i = r.layoutGroup, s = r.switchLayoutGroup, a = r.layoutId, l = o.projection;
      Apt(Wgt), l && (i?.group && i.group.add(l), s?.register && a && s.register(l), l.root.didUpdate(), l.addEventListener("animationComplete", function() {
        n.safeToRemove();
      }), l.setOptions(Ve(Ve({}, l.options), { onExitComplete: function() {
        return n.safeToRemove();
      } }))), y0.hasEverUpdated = !0;
    }, e.prototype.getSnapshotBeforeUpdate = function(n) {
      var r = this, o = this.props, i = o.layoutDependency, s = o.visualElement, a = o.drag, l = o.isPresent, c = s.projection;
      return c && (c.isPresent = l, a || n.layoutDependency !== i || i === void 0 ? c.willUpdate() : this.safeToRemove(), n.isPresent !== l && (l ? c.promote() : c.relegate() || ks.postRender(function() {
        var u;
        !((u = c.getStack()) === null || u === void 0) && u.members.length || r.safeToRemove();
      }))), null;
    }, e.prototype.componentDidUpdate = function() {
      var n = this.props.visualElement.projection;
      n && (n.root.didUpdate(), !n.currentAnimation && n.isLead() && this.safeToRemove());
    }, e.prototype.componentWillUnmount = function() {
      var n = this.props, r = n.visualElement, o = n.layoutGroup, i = n.switchLayoutGroup, s = r.projection;
      s && (s.scheduleCheckAfterUnmount(), o?.group && o.group.remove(s), i?.deregister && i.deregister(s));
    }, e.prototype.safeToRemove = function() {
      var n = this.props.safeToRemove;
      n?.();
    }, e.prototype.render = function() {
      return null;
    }, e;
  }(xe.Component)
);
function Vgt(t) {
  var e = hr(bbe(), 2), n = e[0], r = e[1], o = Hn(r6);
  return xe.createElement(Hgt, Ve({}, t, { layoutGroup: o, switchLayoutGroup: Hn(Yve), isPresent: n, safeToRemove: r }));
}
var Wgt = {
  borderRadius: Ve(Ve({}, Cm), { applyTo: [
    "borderTopLeftRadius",
    "borderTopRightRadius",
    "borderBottomLeftRadius",
    "borderBottomRightRadius"
  ] }),
  borderTopLeftRadius: Cm,
  borderTopRightRadius: Cm,
  borderBottomLeftRadius: Cm,
  borderBottomRightRadius: Cm,
  boxShadow: Ugt
}, Ggt = {
  measureLayout: Vgt
};
function Ygt(t, e, n) {
  n === void 0 && (n = {});
  var r = Bl(t) ? t : mp(t);
  return m6("", r, e, n), {
    stop: function() {
      return r.stop();
    },
    isAnimating: function() {
      return r.isAnimating();
    }
  };
}
var Nbe = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"], Kgt = Nbe.length, iZ = function(t) {
  return typeof t == "string" ? parseFloat(t) : t;
}, sZ = function(t) {
  return typeof t == "number" || vt.test(t);
};
function Xgt(t, e, n, r, o, i) {
  var s, a, l, c;
  o ? (t.opacity = fr(
    0,
    // (follow?.opacity as number) ?? 0,
    // TODO Reinstate this if only child
    (s = n.opacity) !== null && s !== void 0 ? s : 1,
    Qgt(r)
  ), t.opacityExit = fr((a = e.opacity) !== null && a !== void 0 ? a : 1, 0, Zgt(r))) : i && (t.opacity = fr((l = e.opacity) !== null && l !== void 0 ? l : 1, (c = n.opacity) !== null && c !== void 0 ? c : 1, r));
  for (var u = 0; u < Kgt; u++) {
    var d = "border".concat(Nbe[u], "Radius"), f = aZ(e, d), h = aZ(n, d);
    if (!(f === void 0 && h === void 0)) {
      f || (f = 0), h || (h = 0);
      var p = f === 0 || h === 0 || sZ(f) === sZ(h);
      p ? (t[d] = Math.max(fr(iZ(f), iZ(h), r), 0), (va.test(h) || va.test(f)) && (t[d] += "%")) : t[d] = h;
    }
  }
  (e.rotate || n.rotate) && (t.rotate = fr(e.rotate || 0, n.rotate || 0, r));
}
function aZ(t, e) {
  var n;
  return (n = t[e]) !== null && n !== void 0 ? n : t.borderRadius;
}
var Qgt = jbe(0, 0.5, B5), Zgt = jbe(0.5, 0.95, L5);
function jbe(t, e, n) {
  return function(r) {
    return r < t ? 0 : r > e ? 1 : n(B0(t, e, r));
  };
}
function lZ(t, e) {
  t.min = e.min, t.max = e.max;
}
function hs(t, e) {
  lZ(t.x, e.x), lZ(t.y, e.y);
}
function cZ(t, e, n, r, o) {
  return t -= e, t = DE(t, 1 / n, r), o !== void 0 && (t = DE(t, 1 / o, r)), t;
}
function Jgt(t, e, n, r, o, i, s) {
  if (e === void 0 && (e = 0), n === void 0 && (n = 1), r === void 0 && (r = 0.5), i === void 0 && (i = t), s === void 0 && (s = t), va.test(e)) {
    e = parseFloat(e);
    var a = fr(s.min, s.max, e / 100);
    e = a - s.min;
  }
  if (typeof e == "number") {
    var l = fr(i.min, i.max, r);
    t === i && (l -= e), t.min = cZ(t.min, e, n, l, o), t.max = cZ(t.max, e, n, l, o);
  }
}
function uZ(t, e, n, r, o) {
  var i = hr(n, 3), s = i[0], a = i[1], l = i[2];
  Jgt(t, e[s], e[a], e[l], e.scale, r, o);
}
var e0t = ["x", "scaleX", "originX"], t0t = ["y", "scaleY", "originY"];
function dZ(t, e, n, r) {
  uZ(t.x, e, e0t, n?.x, r?.x), uZ(t.y, e, t0t, n?.y, r?.y);
}
function fZ(t) {
  return t.translate === 0 && t.scale === 1;
}
function Lbe(t) {
  return fZ(t.x) && fZ(t.y);
}
function Fbe(t, e) {
  return t.x.min === e.x.min && t.x.max === e.x.max && t.y.min === e.y.min && t.y.max === e.y.max;
}
var n0t = (
  /** @class */
  function() {
    function t() {
      this.members = [];
    }
    return t.prototype.add = function(e) {
      g6(this.members, e), e.scheduleRender();
    }, t.prototype.remove = function(e) {
      if (y6(this.members, e), e === this.prevLead && (this.prevLead = void 0), e === this.lead) {
        var n = this.members[this.members.length - 1];
        n && this.promote(n);
      }
    }, t.prototype.relegate = function(e) {
      var n = this.members.findIndex(function(s) {
        return e === s;
      });
      if (n === 0)
        return !1;
      for (var r, o = n; o >= 0; o--) {
        var i = this.members[o];
        if (i.isPresent !== !1) {
          r = i;
          break;
        }
      }
      return r ? (this.promote(r), !0) : !1;
    }, t.prototype.promote = function(e, n) {
      var r, o = this.lead;
      if (e !== o && (this.prevLead = o, this.lead = e, e.show(), o)) {
        o.instance && o.scheduleRender(), e.scheduleRender(), e.resumeFrom = o, n && (e.resumeFrom.preserveOpacity = !0), o.snapshot && (e.snapshot = o.snapshot, e.snapshot.latestValues = o.animationValues || o.latestValues, e.snapshot.isShared = !0), !((r = e.root) === null || r === void 0) && r.isUpdating && (e.isLayoutDirty = !0);
        var i = e.options.crossfade;
        i === !1 && o.hide();
      }
    }, t.prototype.exitAnimationComplete = function() {
      this.members.forEach(function(e) {
        var n, r, o, i, s;
        (r = (n = e.options).onExitComplete) === null || r === void 0 || r.call(n), (s = (o = e.resumingFrom) === null || o === void 0 ? void 0 : (i = o.options).onExitComplete) === null || s === void 0 || s.call(i);
      });
    }, t.prototype.scheduleRender = function() {
      this.members.forEach(function(e) {
        e.instance && e.scheduleRender(!1);
      });
    }, t.prototype.removeLeadSnapshot = function() {
      this.lead && this.lead.snapshot && (this.lead.snapshot = void 0);
    }, t;
  }()
), r0t = "translate3d(0px, 0px, 0) scale(1, 1) scale(1, 1)";
function hZ(t, e, n) {
  var r = t.x.translate / e.x, o = t.y.translate / e.y, i = "translate3d(".concat(r, "px, ").concat(o, "px, 0) ");
  if (i += "scale(".concat(1 / e.x, ", ").concat(1 / e.y, ") "), n) {
    var s = n.rotate, a = n.rotateX, l = n.rotateY;
    s && (i += "rotate(".concat(s, "deg) ")), a && (i += "rotateX(".concat(a, "deg) ")), l && (i += "rotateY(".concat(l, "deg) "));
  }
  var c = t.x.scale * e.x, u = t.y.scale * e.y;
  return i += "scale(".concat(c, ", ").concat(u, ")"), i === r0t ? "none" : i;
}
var o0t = function(t, e) {
  return t.depth - e.depth;
}, i0t = (
  /** @class */
  function() {
    function t() {
      this.children = [], this.isDirty = !1;
    }
    return t.prototype.add = function(e) {
      g6(this.children, e), this.isDirty = !0;
    }, t.prototype.remove = function(e) {
      y6(this.children, e), this.isDirty = !0;
    }, t.prototype.forEach = function(e) {
      this.isDirty && this.children.sort(o0t), this.isDirty = !1, this.children.forEach(e);
    }, t;
  }()
), pZ = 1e3;
function Bbe(t) {
  var e = t.attachResizeListener, n = t.defaultParent, r = t.measureScroll, o = t.checkIsScrollRoot, i = t.resetTransform;
  return (
    /** @class */
    function() {
      function s(a, l, c) {
        var u = this;
        l === void 0 && (l = {}), c === void 0 && (c = n?.()), this.children = /* @__PURE__ */ new Set(), this.options = {}, this.isTreeAnimating = !1, this.isAnimationBlocked = !1, this.isLayoutDirty = !1, this.updateManuallyBlocked = !1, this.updateBlockedByResize = !1, this.isUpdating = !1, this.isSVG = !1, this.needsReset = !1, this.shouldResetTransform = !1, this.treeScale = { x: 1, y: 1 }, this.eventHandlers = /* @__PURE__ */ new Map(), this.potentialNodes = /* @__PURE__ */ new Map(), this.checkUpdateFailed = function() {
          u.isUpdating && (u.isUpdating = !1, u.clearAllSnapshots());
        }, this.updateProjection = function() {
          u.nodes.forEach(d0t), u.nodes.forEach(f0t);
        }, this.hasProjected = !1, this.isVisible = !0, this.animationProgress = 0, this.sharedNodes = /* @__PURE__ */ new Map(), this.id = a, this.latestValues = l, this.root = c ? c.root || c : this, this.path = c ? Cs(Cs([], hr(c.path), !1), [c], !1) : [], this.parent = c, this.depth = c ? c.depth + 1 : 0, a && this.root.registerPotentialNode(a, this);
        for (var d = 0; d < this.path.length; d++)
          this.path[d].shouldResetTransform = !0;
        this.root === this && (this.nodes = new i0t());
      }
      return s.prototype.addEventListener = function(a, l) {
        return this.eventHandlers.has(a) || this.eventHandlers.set(a, new v0()), this.eventHandlers.get(a).add(l);
      }, s.prototype.notifyListeners = function(a) {
        for (var l = [], c = 1; c < arguments.length; c++)
          l[c - 1] = arguments[c];
        var u = this.eventHandlers.get(a);
        u?.notify.apply(u, Cs([], hr(l), !1));
      }, s.prototype.hasListeners = function(a) {
        return this.eventHandlers.has(a);
      }, s.prototype.registerPotentialNode = function(a, l) {
        this.potentialNodes.set(a, l);
      }, s.prototype.mount = function(a, l) {
        var c = this, u;
        if (l === void 0 && (l = !1), !this.instance) {
          this.isSVG = a instanceof SVGElement && a.tagName !== "svg", this.instance = a;
          var d = this.options, f = d.layoutId, h = d.layout, p = d.visualElement;
          if (p && !p.getInstance() && p.mount(a), this.root.nodes.add(this), (u = this.parent) === null || u === void 0 || u.children.add(this), this.id && this.root.potentialNodes.delete(this.id), l && (h || f) && (this.isLayoutDirty = !0), e) {
            var m, g = function() {
              return c.root.updateBlockedByResize = !1;
            };
            e(a, function() {
              c.root.updateBlockedByResize = !0, clearTimeout(m), m = window.setTimeout(g, 250), y0.hasAnimatedSinceResize && (y0.hasAnimatedSinceResize = !1, c.nodes.forEach(u0t));
            });
          }
          f && this.root.registerSharedNode(f, this), this.options.animate !== !1 && p && (f || h) && this.addEventListener("didUpdate", function(y) {
            var v, b, _, w, x, E = y.delta, S = y.hasLayoutChanged, C = y.hasRelativeTargetChanged, R = y.layout;
            if (c.isTreeAnimationBlocked()) {
              c.target = void 0, c.relativeTarget = void 0;
              return;
            }
            var P = (b = (v = c.options.transition) !== null && v !== void 0 ? v : p.getDefaultTransition()) !== null && b !== void 0 ? b : y0t, N = p.getProps(), A = N.onLayoutAnimationStart, O = N.onLayoutAnimationComplete, k = !c.targetLayout || !Fbe(c.targetLayout, R) || C, T = !S && C;
            if (!((_ = c.resumeFrom) === null || _ === void 0) && _.instance || T || S && (k || !c.currentAnimation)) {
              c.resumeFrom && (c.resumingFrom = c.resumeFrom, c.resumingFrom.resumingFrom = void 0), c.setAnimationOrigin(E, T);
              var I = Ve(Ve({}, p6(P, "layout")), { onPlay: A, onComplete: O });
              p.shouldReduceMotion && (I.delay = 0, I.type = !1), c.startAnimation(I);
            } else
              !S && c.animationProgress === 0 && c.finishAnimation(), c.isLead() && ((x = (w = c.options).onExitComplete) === null || x === void 0 || x.call(w));
            c.targetLayout = R;
          });
        }
      }, s.prototype.unmount = function() {
        var a, l;
        this.options.layoutId && this.willUpdate(), this.root.nodes.remove(this), (a = this.getStack()) === null || a === void 0 || a.remove(this), (l = this.parent) === null || l === void 0 || l.children.delete(this), this.instance = void 0, zh.preRender(this.updateProjection);
      }, s.prototype.blockUpdate = function() {
        this.updateManuallyBlocked = !0;
      }, s.prototype.unblockUpdate = function() {
        this.updateManuallyBlocked = !1;
      }, s.prototype.isUpdateBlocked = function() {
        return this.updateManuallyBlocked || this.updateBlockedByResize;
      }, s.prototype.isTreeAnimationBlocked = function() {
        var a;
        return this.isAnimationBlocked || ((a = this.parent) === null || a === void 0 ? void 0 : a.isTreeAnimationBlocked()) || !1;
      }, s.prototype.startUpdate = function() {
        var a;
        this.isUpdateBlocked() || (this.isUpdating = !0, (a = this.nodes) === null || a === void 0 || a.forEach(h0t));
      }, s.prototype.willUpdate = function(a) {
        var l, c, u;
        if (a === void 0 && (a = !0), this.root.isUpdateBlocked()) {
          (c = (l = this.options).onExitComplete) === null || c === void 0 || c.call(l);
          return;
        }
        if (!this.root.isUpdating && this.root.startUpdate(), !this.isLayoutDirty) {
          this.isLayoutDirty = !0;
          for (var d = 0; d < this.path.length; d++) {
            var f = this.path[d];
            f.shouldResetTransform = !0, f.updateScroll();
          }
          var h = this.options, p = h.layoutId, m = h.layout;
          if (!(p === void 0 && !m)) {
            var g = (u = this.options.visualElement) === null || u === void 0 ? void 0 : u.getProps().transformTemplate;
            this.prevTransformTemplateValue = g?.(this.latestValues, ""), this.updateSnapshot(), a && this.notifyListeners("willUpdate");
          }
        }
      }, s.prototype.didUpdate = function() {
        var a = this.isUpdateBlocked();
        if (a) {
          this.unblockUpdate(), this.clearAllSnapshots(), this.nodes.forEach(mZ);
          return;
        }
        this.isUpdating && (this.isUpdating = !1, this.potentialNodes.size && (this.potentialNodes.forEach(v0t), this.potentialNodes.clear()), this.nodes.forEach(c0t), this.nodes.forEach(s0t), this.nodes.forEach(a0t), this.clearAllSnapshots(), NC.update(), NC.preRender(), NC.render());
      }, s.prototype.clearAllSnapshots = function() {
        this.nodes.forEach(l0t), this.sharedNodes.forEach(p0t);
      }, s.prototype.scheduleUpdateProjection = function() {
        ks.preRender(this.updateProjection, !1, !0);
      }, s.prototype.scheduleCheckAfterUnmount = function() {
        var a = this;
        ks.postRender(function() {
          a.isLayoutDirty ? a.root.didUpdate() : a.root.checkUpdateFailed();
        });
      }, s.prototype.updateSnapshot = function() {
        if (!(this.snapshot || !this.instance)) {
          var a = this.measure(), l = this.removeTransform(this.removeElementScroll(a));
          bZ(l), this.snapshot = {
            measured: a,
            layout: l,
            latestValues: {}
          };
        }
      }, s.prototype.updateLayout = function() {
        var a;
        if (this.instance && (this.updateScroll(), !(!(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty))) {
          if (this.resumeFrom && !this.resumeFrom.instance)
            for (var l = 0; l < this.path.length; l++) {
              var c = this.path[l];
              c.updateScroll();
            }
          var u = this.measure();
          bZ(u);
          var d = this.layout;
          this.layout = {
            measured: u,
            actual: this.removeElementScroll(u)
          }, this.layoutCorrected = oo(), this.isLayoutDirty = !1, this.projectionDelta = void 0, this.notifyListeners("measure", this.layout.actual), (a = this.options.visualElement) === null || a === void 0 || a.notifyLayoutMeasure(this.layout.actual, d?.actual);
        }
      }, s.prototype.updateScroll = function() {
        this.options.layoutScroll && this.instance && (this.isScrollRoot = o(this.instance), this.scroll = r(this.instance));
      }, s.prototype.resetTransform = function() {
        var a;
        if (i) {
          var l = this.isLayoutDirty || this.shouldResetTransform, c = this.projectionDelta && !Lbe(this.projectionDelta), u = (a = this.options.visualElement) === null || a === void 0 ? void 0 : a.getProps().transformTemplate, d = u?.(this.latestValues, ""), f = d !== this.prevTransformTemplateValue;
          l && (c || mc(this.latestValues) || f) && (i(this.instance, d), this.shouldResetTransform = !1, this.scheduleRender());
        }
      }, s.prototype.measure = function() {
        var a = this.options.visualElement;
        if (!a)
          return oo();
        var l = a.measureViewportBox(), c = this.root.scroll;
        return c && (Ec(l.x, c.x), Ec(l.y, c.y)), l;
      }, s.prototype.removeElementScroll = function(a) {
        var l = oo();
        hs(l, a);
        for (var c = 0; c < this.path.length; c++) {
          var u = this.path[c], d = u.scroll, f = u.options, h = u.isScrollRoot;
          if (u !== this.root && d && f.layoutScroll) {
            if (h) {
              hs(l, a);
              var p = this.root.scroll;
              p && (Ec(l.x, -p.x), Ec(l.y, -p.y));
            }
            Ec(l.x, d.x), Ec(l.y, d.y);
          }
        }
        return l;
      }, s.prototype.applyTransform = function(a, l) {
        l === void 0 && (l = !1);
        var c = oo();
        hs(c, a);
        for (var u = 0; u < this.path.length; u++) {
          var d = this.path[u];
          !l && d.options.layoutScroll && d.scroll && d !== d.root && ah(c, {
            x: -d.scroll.x,
            y: -d.scroll.y
          }), mc(d.latestValues) && ah(c, d.latestValues);
        }
        return mc(this.latestValues) && ah(c, this.latestValues), c;
      }, s.prototype.removeTransform = function(a) {
        var l, c = oo();
        hs(c, a);
        for (var u = 0; u < this.path.length; u++) {
          var d = this.path[u];
          if (d.instance && mc(d.latestValues)) {
            kbe(d.latestValues) && d.updateSnapshot();
            var f = oo(), h = d.measure();
            hs(f, h), dZ(c, d.latestValues, (l = d.snapshot) === null || l === void 0 ? void 0 : l.layout, f);
          }
        }
        return mc(this.latestValues) && dZ(c, this.latestValues), c;
      }, s.prototype.setTargetDelta = function(a) {
        this.targetDelta = a, this.root.scheduleUpdateProjection();
      }, s.prototype.setOptions = function(a) {
        var l;
        this.options = Ve(Ve(Ve({}, this.options), a), { crossfade: (l = a.crossfade) !== null && l !== void 0 ? l : !0 });
      }, s.prototype.clearMeasurements = function() {
        this.scroll = void 0, this.layout = void 0, this.snapshot = void 0, this.prevTransformTemplateValue = void 0, this.targetDelta = void 0, this.target = void 0, this.isLayoutDirty = !1;
      }, s.prototype.resolveTargetDelta = function() {
        var a, l = this.options, c = l.layout, u = l.layoutId;
        !this.layout || !(c || u) || (!this.targetDelta && !this.relativeTarget && (this.relativeParent = this.getClosestProjectingParent(), this.relativeParent && this.relativeParent.layout && (this.relativeTarget = oo(), this.relativeTargetOrigin = oo(), _0(this.relativeTargetOrigin, this.layout.actual, this.relativeParent.layout.actual), hs(this.relativeTarget, this.relativeTargetOrigin))), !(!this.relativeTarget && !this.targetDelta) && (this.target || (this.target = oo(), this.targetWithTransforms = oo()), this.relativeTarget && this.relativeTargetOrigin && !((a = this.relativeParent) === null || a === void 0) && a.target ? igt(this.target, this.relativeTarget, this.relativeParent.target) : this.targetDelta ? (this.resumingFrom ? this.target = this.applyTransform(this.layout.actual) : hs(this.target, this.layout.actual), Abe(this.target, this.targetDelta)) : hs(this.target, this.layout.actual), this.attemptToResolveRelativeTarget && (this.attemptToResolveRelativeTarget = !1, this.relativeParent = this.getClosestProjectingParent(), this.relativeParent && !!this.relativeParent.resumingFrom == !!this.resumingFrom && !this.relativeParent.options.layoutScroll && this.relativeParent.target && (this.relativeTarget = oo(), this.relativeTargetOrigin = oo(), _0(this.relativeTargetOrigin, this.target, this.relativeParent.target), hs(this.relativeTarget, this.relativeTargetOrigin)))));
      }, s.prototype.getClosestProjectingParent = function() {
        if (!(!this.parent || mc(this.parent.latestValues)))
          return (this.parent.relativeTarget || this.parent.targetDelta) && this.parent.layout ? this.parent : this.parent.getClosestProjectingParent();
      }, s.prototype.calcProjection = function() {
        var a, l = this.options, c = l.layout, u = l.layoutId;
        if (this.isTreeAnimating = !!(!((a = this.parent) === null || a === void 0) && a.isTreeAnimating || this.currentAnimation || this.pendingAnimation), this.isTreeAnimating || (this.targetDelta = this.relativeTarget = void 0), !(!this.layout || !(c || u))) {
          var d = this.getLead();
          hs(this.layoutCorrected, this.layout.actual), pgt(this.layoutCorrected, this.treeScale, this.path, !!this.resumingFrom || this !== d);
          var f = d.target;
          if (f) {
            this.projectionDelta || (this.projectionDelta = w0(), this.projectionDeltaWithTransform = w0());
            var h = this.treeScale.x, p = this.treeScale.y, m = this.projectionTransform;
            b0(this.projectionDelta, this.layoutCorrected, f, this.latestValues), this.projectionTransform = hZ(this.projectionDelta, this.treeScale), (this.projectionTransform !== m || this.treeScale.x !== h || this.treeScale.y !== p) && (this.hasProjected = !0, this.scheduleRender(), this.notifyListeners("projectionUpdate", f));
          }
        }
      }, s.prototype.hide = function() {
        this.isVisible = !1;
      }, s.prototype.show = function() {
        this.isVisible = !0;
      }, s.prototype.scheduleRender = function(a) {
        var l, c, u;
        a === void 0 && (a = !0), (c = (l = this.options).scheduleRender) === null || c === void 0 || c.call(l), a && ((u = this.getStack()) === null || u === void 0 || u.scheduleRender()), this.resumingFrom && !this.resumingFrom.instance && (this.resumingFrom = void 0);
      }, s.prototype.setAnimationOrigin = function(a, l) {
        var c = this, u;
        l === void 0 && (l = !1);
        var d = this.snapshot, f = d?.latestValues || {}, h = Ve({}, this.latestValues), p = w0();
        this.relativeTarget = this.relativeTargetOrigin = void 0, this.attemptToResolveRelativeTarget = !l;
        var m = oo(), g = d?.isShared, y = (((u = this.getStack()) === null || u === void 0 ? void 0 : u.members.length) || 0) <= 1, v = !!(g && !y && this.options.crossfade === !0 && !this.path.some(g0t));
        this.animationProgress = 0, this.mixTargetDelta = function(b) {
          var _, w = b / 1e3;
          gZ(p.x, a.x, w), gZ(p.y, a.y, w), c.setTargetDelta(p), c.relativeTarget && c.relativeTargetOrigin && c.layout && !((_ = c.relativeParent) === null || _ === void 0) && _.layout && (_0(m, c.layout.actual, c.relativeParent.layout.actual), m0t(c.relativeTarget, c.relativeTargetOrigin, m, w)), g && (c.animationValues = h, Xgt(h, f, c.latestValues, w, v, y)), c.root.scheduleUpdateProjection(), c.scheduleRender(), c.animationProgress = w;
        }, this.mixTargetDelta(0);
      }, s.prototype.startAnimation = function(a) {
        var l = this, c, u;
        this.notifyListeners("animationStart"), (c = this.currentAnimation) === null || c === void 0 || c.stop(), this.resumingFrom && ((u = this.resumingFrom.currentAnimation) === null || u === void 0 || u.stop()), this.pendingAnimation && (zh.update(this.pendingAnimation), this.pendingAnimation = void 0), this.pendingAnimation = ks.update(function() {
          y0.hasAnimatedSinceResize = !0, l.currentAnimation = Ygt(0, pZ, Ve(Ve({}, a), { onUpdate: function(d) {
            var f;
            l.mixTargetDelta(d), (f = a.onUpdate) === null || f === void 0 || f.call(a, d);
          }, onComplete: function() {
            var d;
            (d = a.onComplete) === null || d === void 0 || d.call(a), l.completeAnimation();
          } })), l.resumingFrom && (l.resumingFrom.currentAnimation = l.currentAnimation), l.pendingAnimation = void 0;
        });
      }, s.prototype.completeAnimation = function() {
        var a;
        this.resumingFrom && (this.resumingFrom.currentAnimation = void 0, this.resumingFrom.preserveOpacity = void 0), (a = this.getStack()) === null || a === void 0 || a.exitAnimationComplete(), this.resumingFrom = this.currentAnimation = this.animationValues = void 0, this.notifyListeners("animationComplete");
      }, s.prototype.finishAnimation = function() {
        var a;
        this.currentAnimation && ((a = this.mixTargetDelta) === null || a === void 0 || a.call(this, pZ), this.currentAnimation.stop()), this.completeAnimation();
      }, s.prototype.applyTransformsToTarget = function() {
        var a = this.getLead(), l = a.targetWithTransforms, c = a.target, u = a.layout, d = a.latestValues;
        !l || !c || !u || (hs(l, c), ah(l, d), b0(this.projectionDeltaWithTransform, this.layoutCorrected, l, d));
      }, s.prototype.registerSharedNode = function(a, l) {
        var c, u, d;
        this.sharedNodes.has(a) || this.sharedNodes.set(a, new n0t());
        var f = this.sharedNodes.get(a);
        f.add(l), l.promote({
          transition: (c = l.options.initialPromotionConfig) === null || c === void 0 ? void 0 : c.transition,
          preserveFollowOpacity: (d = (u = l.options.initialPromotionConfig) === null || u === void 0 ? void 0 : u.shouldPreserveFollowOpacity) === null || d === void 0 ? void 0 : d.call(u, l)
        });
      }, s.prototype.isLead = function() {
        var a = this.getStack();
        return a ? a.lead === this : !0;
      }, s.prototype.getLead = function() {
        var a, l = this.options.layoutId;
        return l ? ((a = this.getStack()) === null || a === void 0 ? void 0 : a.lead) || this : this;
      }, s.prototype.getPrevLead = function() {
        var a, l = this.options.layoutId;
        return l ? (a = this.getStack()) === null || a === void 0 ? void 0 : a.prevLead : void 0;
      }, s.prototype.getStack = function() {
        var a = this.options.layoutId;
        if (a)
          return this.root.sharedNodes.get(a);
      }, s.prototype.promote = function(a) {
        var l = a === void 0 ? {} : a, c = l.needsReset, u = l.transition, d = l.preserveFollowOpacity, f = this.getStack();
        f && f.promote(this, d), c && (this.projectionDelta = void 0, this.needsReset = !0), u && this.setOptions({ transition: u });
      }, s.prototype.relegate = function() {
        var a = this.getStack();
        return a ? a.relegate(this) : !1;
      }, s.prototype.resetRotation = function() {
        var a = this.options.visualElement;
        if (a) {
          for (var l = !1, c = {}, u = 0; u < e3.length; u++) {
            var d = e3[u], f = "rotate" + d;
            a.getStaticValue(f) && (l = !0, c[f] = a.getStaticValue(f), a.setStaticValue(f, 0));
          }
          if (l) {
            a?.syncRender();
            for (var f in c)
              a.setStaticValue(f, c[f]);
            a.scheduleRender();
          }
        }
      }, s.prototype.getProjectionStyles = function(a) {
        var l, c, u, d, f, h;
        a === void 0 && (a = {});
        var p = {};
        if (!this.instance || this.isSVG)
          return p;
        if (this.isVisible)
          p.visibility = "";
        else
          return { visibility: "hidden" };
        var m = (l = this.options.visualElement) === null || l === void 0 ? void 0 : l.getProps().transformTemplate;
        if (this.needsReset)
          return this.needsReset = !1, p.opacity = "", p.pointerEvents = jw(a.pointerEvents) || "", p.transform = m ? m(this.latestValues, "") : "none", p;
        var g = this.getLead();
        if (!this.projectionDelta || !this.layout || !g.target) {
          var y = {};
          return this.options.layoutId && (y.opacity = (c = this.latestValues.opacity) !== null && c !== void 0 ? c : 1, y.pointerEvents = jw(a.pointerEvents) || ""), this.hasProjected && !mc(this.latestValues) && (y.transform = m ? m({}, "") : "none", this.hasProjected = !1), y;
        }
        var v = g.animationValues || g.latestValues;
        this.applyTransformsToTarget(), p.transform = hZ(this.projectionDeltaWithTransform, this.treeScale, v), m && (p.transform = m(v, p.transform));
        var b = this.projectionDelta, _ = b.x, w = b.y;
        p.transformOrigin = "".concat(_.origin * 100, "% ").concat(w.origin * 100, "% 0"), g.animationValues ? p.opacity = g === this ? (d = (u = v.opacity) !== null && u !== void 0 ? u : this.latestValues.opacity) !== null && d !== void 0 ? d : 1 : this.preserveOpacity ? this.latestValues.opacity : v.opacityExit : p.opacity = g === this ? (f = v.opacity) !== null && f !== void 0 ? f : "" : (h = v.opacityExit) !== null && h !== void 0 ? h : 0;
        for (var x in RE)
          if (v[x] !== void 0) {
            var E = RE[x], S = E.correct, C = E.applyTo, R = S(v[x], g);
            if (C)
              for (var P = C.length, N = 0; N < P; N++)
                p[C[N]] = R;
            else
              p[x] = R;
          }
        return this.options.layoutId && (p.pointerEvents = g === this ? jw(a.pointerEvents) || "" : "none"), p;
      }, s.prototype.clearSnapshot = function() {
        this.resumeFrom = this.snapshot = void 0;
      }, s.prototype.resetTree = function() {
        this.root.nodes.forEach(function(a) {
          var l;
          return (l = a.currentAnimation) === null || l === void 0 ? void 0 : l.stop();
        }), this.root.nodes.forEach(mZ), this.root.sharedNodes.clear();
      }, s;
    }()
  );
}
function s0t(t) {
  t.updateLayout();
}
function a0t(t) {
  var e, n, r, o, i = (n = (e = t.resumeFrom) === null || e === void 0 ? void 0 : e.snapshot) !== null && n !== void 0 ? n : t.snapshot;
  if (t.isLead() && t.layout && i && t.hasListeners("didUpdate")) {
    var s = t.layout, a = s.actual, l = s.measured;
    t.options.animationType === "size" ? Js(function(v) {
      var b = i.isShared ? i.measured[v] : i.layout[v], _ = zl(b);
      b.min = a[v].min, b.max = b.min + _;
    }) : t.options.animationType === "position" && Js(function(v) {
      var b = i.isShared ? i.measured[v] : i.layout[v], _ = zl(a[v]);
      b.max = b.min + _;
    });
    var c = w0();
    b0(c, a, i.layout);
    var u = w0();
    i.isShared ? b0(u, t.applyTransform(l, !0), i.measured) : b0(u, a, i.layout);
    var d = !Lbe(c), f = !1;
    if (!t.resumeFrom && (t.relativeParent = t.getClosestProjectingParent(), t.relativeParent && !t.relativeParent.resumeFrom)) {
      var h = t.relativeParent, p = h.snapshot, m = h.layout;
      if (p && m) {
        var g = oo();
        _0(g, i.layout, p.layout);
        var y = oo();
        _0(y, a, m.actual), Fbe(g, y) || (f = !0);
      }
    }
    t.notifyListeners("didUpdate", {
      layout: a,
      snapshot: i,
      delta: u,
      layoutDelta: c,
      hasLayoutChanged: d,
      hasRelativeTargetChanged: f
    });
  } else t.isLead() && ((o = (r = t.options).onExitComplete) === null || o === void 0 || o.call(r));
  t.options.transition = void 0;
}
function l0t(t) {
  t.clearSnapshot();
}
function mZ(t) {
  t.clearMeasurements();
}
function c0t(t) {
  var e = t.options.visualElement;
  e?.getProps().onBeforeLayoutMeasure && e.notifyBeforeLayoutMeasure(), t.resetTransform();
}
function u0t(t) {
  t.finishAnimation(), t.targetDelta = t.relativeTarget = t.target = void 0;
}
function d0t(t) {
  t.resolveTargetDelta();
}
function f0t(t) {
  t.calcProjection();
}
function h0t(t) {
  t.resetRotation();
}
function p0t(t) {
  t.removeLeadSnapshot();
}
function gZ(t, e, n) {
  t.translate = fr(e.translate, 0, n), t.scale = fr(e.scale, 1, n), t.origin = e.origin, t.originPoint = e.originPoint;
}
function yZ(t, e, n, r) {
  t.min = fr(e.min, n.min, r), t.max = fr(e.max, n.max, r);
}
function m0t(t, e, n, r) {
  yZ(t.x, e.x, n.x, r), yZ(t.y, e.y, n.y, r);
}
function g0t(t) {
  return t.animationValues && t.animationValues.opacityExit !== void 0;
}
var y0t = {
  duration: 0.45,
  ease: [0.4, 0, 0.1, 1]
};
function v0t(t, e) {
  for (var n = t.root, r = t.path.length - 1; r >= 0; r--)
    if (t.path[r].instance) {
      n = t.path[r];
      break;
    }
  var o = n && n !== t.root ? n.instance : document, i = o.querySelector('[data-projection-id="'.concat(e, '"]'));
  i && t.mount(i, !0);
}
function vZ(t) {
  t.min = Math.round(t.min), t.max = Math.round(t.max);
}
function bZ(t) {
  vZ(t.x), vZ(t.y);
}
var b0t = Bbe({
  attachResizeListener: function(t, e) {
    return _O(t, "resize", e);
  },
  measureScroll: function() {
    return {
      x: document.documentElement.scrollLeft || document.body.scrollLeft,
      y: document.documentElement.scrollTop || document.body.scrollTop
    };
  },
  checkIsScrollRoot: function() {
    return !0;
  }
}), hT = {
  current: void 0
}, _0t = Bbe({
  measureScroll: function(t) {
    return {
      x: t.scrollLeft,
      y: t.scrollTop
    };
  },
  defaultParent: function() {
    if (!hT.current) {
      var t = new b0t(0, {});
      t.mount(window), t.setOptions({ layoutScroll: !0 }), hT.current = t;
    }
    return hT.current;
  },
  resetTransform: function(t, e) {
    t.style.transform = e ?? "none";
  },
  checkIsScrollRoot: function(t) {
    return window.getComputedStyle(t).position === "fixed";
  }
}), w0t = Ve(Ve(Ve(Ve({}, ngt), wmt), Egt), Ggt), IE = /* @__PURE__ */ Cpt(function(t, e) {
  return emt(t, e, w0t, qgt, _0t);
});
function zbe() {
  var t = Ue(!1);
  return TE(function() {
    return t.current = !0, function() {
      t.current = !1;
    };
  }, []), t;
}
function x0t() {
  var t = zbe(), e = hr(Ye(0), 2), n = e[0], r = e[1], o = Cn(function() {
    t.current && r(n + 1);
  }, [n]), i = Cn(function() {
    return ks.postRender(o);
  }, [o]);
  return [i, n];
}
var pT = function(t) {
  var e = t.children, n = t.initial, r = t.isPresent, o = t.onExitComplete, i = t.custom, s = t.presenceAffectsLayout, a = Lv(E0t), l = vbe(), c = cn(
    function() {
      return {
        id: l,
        initial: n,
        isPresent: r,
        custom: i,
        onExitComplete: function(u) {
          var d, f;
          a.set(u, !0);
          try {
            for (var h = D3e(a.values()), p = h.next(); !p.done; p = h.next()) {
              var m = p.value;
              if (!m)
                return;
            }
          } catch (g) {
            d = { error: g };
          } finally {
            try {
              p && !p.done && (f = h.return) && f.call(h);
            } finally {
              if (d) throw d.error;
            }
          }
          o?.();
        },
        register: function(u) {
          return a.set(u, !1), function() {
            return a.delete(u);
          };
        }
      };
    },
    /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */
    s ? void 0 : [r]
  );
  return cn(function() {
    a.forEach(function(u, d) {
      return a.set(d, !1);
    });
  }, [r]), he.useEffect(function() {
    !r && !a.size && o?.();
  }, [r]), he.createElement(jv.Provider, { value: c }, e);
};
function E0t() {
  return /* @__PURE__ */ new Map();
}
var zf = function(t) {
  return t.key || "";
};
function S0t(t, e) {
  t.forEach(function(n) {
    var r = zf(n);
    e.set(r, n);
  });
}
function O0t(t) {
  var e = [];
  return tEe.forEach(t, function(n) {
    Cd(n) && e.push(n);
  }), e;
}
var C0t = function(t) {
  var e = t.children, n = t.custom, r = t.initial, o = r === void 0 ? !0 : r, i = t.onExitComplete, s = t.exitBeforeEnter, a = t.presenceAffectsLayout, l = a === void 0 ? !0 : a, c = hr(x0t(), 1), u = c[0], d = Hn(r6).forceRender;
  d && (u = d);
  var f = zbe(), h = O0t(e), p = h, m = /* @__PURE__ */ new Set(), g = Ue(p), y = Ue(/* @__PURE__ */ new Map()).current, v = Ue(!0);
  if (TE(function() {
    v.current = !1, S0t(h, y), g.current = p;
  }), d6(function() {
    v.current = !0, y.clear(), m.clear();
  }), v.current)
    return he.createElement(he.Fragment, null, p.map(function(S) {
      return he.createElement(pT, { key: zf(S), isPresent: !0, initial: o ? void 0 : !1, presenceAffectsLayout: l }, S);
    }));
  p = Cs([], hr(p), !1);
  for (var b = g.current.map(zf), _ = h.map(zf), w = b.length, x = 0; x < w; x++) {
    var E = b[x];
    _.indexOf(E) === -1 && m.add(E);
  }
  return s && m.size && (p = []), m.forEach(function(S) {
    if (_.indexOf(S) === -1) {
      var C = y.get(S);
      if (C) {
        var R = b.indexOf(S), P = function() {
          y.delete(S), m.delete(S);
          var N = g.current.findIndex(function(A) {
            return A.key === S;
          });
          if (g.current.splice(N, 1), !m.size) {
            if (g.current = h, f.current === !1)
              return;
            u(), i && i();
          }
        };
        p.splice(R, 0, he.createElement(pT, { key: zf(C), isPresent: !1, onExitComplete: P, custom: n, presenceAffectsLayout: l }, C));
      }
    }
  }), p = p.map(function(S) {
    var C = S.key;
    return m.has(C) ? S : he.createElement(pT, { key: zf(S), isPresent: !0, presenceAffectsLayout: l }, S);
  }), t6 !== "production" && s && p.length > 1 && console.warn("You're attempting to animate multiple children within AnimatePresence, but its exitBeforeEnter prop is set to true. This will lead to odd visual behaviour."), he.createElement(he.Fragment, null, m.size ? p : p.map(function(S) {
    return Gi(S);
  }));
}, l3 = function(t, e) {
  return l3 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, r) {
    n.__proto__ = r;
  } || function(n, r) {
    for (var o in r) Object.prototype.hasOwnProperty.call(r, o) && (n[o] = r[o]);
  }, l3(t, e);
};
function Bv(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
  l3(t, e);
  function n() {
    this.constructor = t;
  }
  t.prototype = e === null ? Object.create(e) : (n.prototype = e.prototype, new n());
}
function c3(t) {
  var e = typeof Symbol == "function" && Symbol.iterator, n = e && t[e], r = 0;
  if (n) return n.call(t);
  if (t && typeof t.length == "number") return {
    next: function() {
      return t && r >= t.length && (t = void 0), { value: t && t[r++], done: !t };
    }
  };
  throw new TypeError(e ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function u3(t, e) {
  var n = typeof Symbol == "function" && t[Symbol.iterator];
  if (!n) return t;
  var r = n.call(t), o, i = [], s;
  try {
    for (; (e === void 0 || e-- > 0) && !(o = r.next()).done; ) i.push(o.value);
  } catch (a) {
    s = { error: a };
  } finally {
    try {
      o && !o.done && (n = r.return) && n.call(r);
    } finally {
      if (s) throw s.error;
    }
  }
  return i;
}
function d3(t, e, n) {
  if (n || arguments.length === 2) for (var r = 0, o = e.length, i; r < o; r++)
    (i || !(r in e)) && (i || (i = Array.prototype.slice.call(e, 0, r)), i[r] = e[r]);
  return t.concat(i || Array.prototype.slice.call(e));
}
function Rl(t) {
  return typeof t == "function";
}
function qbe(t) {
  var e = function(r) {
    Error.call(r), r.stack = new Error().stack;
  }, n = t(e);
  return n.prototype = Object.create(Error.prototype), n.prototype.constructor = n, n;
}
var mT = qbe(function(t) {
  return function(n) {
    t(this), this.message = n ? n.length + ` errors occurred during unsubscription:
` + n.map(function(r, o) {
      return o + 1 + ") " + r.toString();
    }).join(`
  `) : "", this.name = "UnsubscriptionError", this.errors = n;
  };
});
function f3(t, e) {
  if (t) {
    var n = t.indexOf(e);
    0 <= n && t.splice(n, 1);
  }
}
var wO = function() {
  function t(e) {
    this.initialTeardown = e, this.closed = !1, this._parentage = null, this._finalizers = null;
  }
  return t.prototype.unsubscribe = function() {
    var e, n, r, o, i;
    if (!this.closed) {
      this.closed = !0;
      var s = this._parentage;
      if (s)
        if (this._parentage = null, Array.isArray(s))
          try {
            for (var a = c3(s), l = a.next(); !l.done; l = a.next()) {
              var c = l.value;
              c.remove(this);
            }
          } catch (m) {
            e = { error: m };
          } finally {
            try {
              l && !l.done && (n = a.return) && n.call(a);
            } finally {
              if (e) throw e.error;
            }
          }
        else
          s.remove(this);
      var u = this.initialTeardown;
      if (Rl(u))
        try {
          u();
        } catch (m) {
          i = m instanceof mT ? m.errors : [m];
        }
      var d = this._finalizers;
      if (d) {
        this._finalizers = null;
        try {
          for (var f = c3(d), h = f.next(); !h.done; h = f.next()) {
            var p = h.value;
            try {
              _Z(p);
            } catch (m) {
              i = i ?? [], m instanceof mT ? i = d3(d3([], u3(i)), u3(m.errors)) : i.push(m);
            }
          }
        } catch (m) {
          r = { error: m };
        } finally {
          try {
            h && !h.done && (o = f.return) && o.call(f);
          } finally {
            if (r) throw r.error;
          }
        }
      }
      if (i)
        throw new mT(i);
    }
  }, t.prototype.add = function(e) {
    var n;
    if (e && e !== this)
      if (this.closed)
        _Z(e);
      else {
        if (e instanceof t) {
          if (e.closed || e._hasParent(this))
            return;
          e._addParent(this);
        }
        (this._finalizers = (n = this._finalizers) !== null && n !== void 0 ? n : []).push(e);
      }
  }, t.prototype._hasParent = function(e) {
    var n = this._parentage;
    return n === e || Array.isArray(n) && n.includes(e);
  }, t.prototype._addParent = function(e) {
    var n = this._parentage;
    this._parentage = Array.isArray(n) ? (n.push(e), n) : n ? [n, e] : e;
  }, t.prototype._removeParent = function(e) {
    var n = this._parentage;
    n === e ? this._parentage = null : Array.isArray(n) && f3(n, e);
  }, t.prototype.remove = function(e) {
    var n = this._finalizers;
    n && f3(n, e), e instanceof t && e._removeParent(this);
  }, t.EMPTY = function() {
    var e = new t();
    return e.closed = !0, e;
  }(), t;
}(), Ube = wO.EMPTY;
function Hbe(t) {
  return t instanceof wO || t && "closed" in t && Rl(t.remove) && Rl(t.add) && Rl(t.unsubscribe);
}
function _Z(t) {
  Rl(t) ? t() : t.unsubscribe();
}
var Vbe = {
  onUnhandledError: null,
  onStoppedNotification: null,
  Promise: void 0,
  useDeprecatedSynchronousErrorHandling: !1,
  useDeprecatedNextContext: !1
}, k0t = {
  setTimeout: function(t, e) {
    for (var n = [], r = 2; r < arguments.length; r++)
      n[r - 2] = arguments[r];
    return setTimeout.apply(void 0, d3([t, e], u3(n)));
  },
  clearTimeout: function(t) {
    return clearTimeout(t);
  },
  delegate: void 0
};
function A0t(t) {
  k0t.setTimeout(function() {
    throw t;
  });
}
function wZ() {
}
function Lw(t) {
  t();
}
var Wbe = function(t) {
  Bv(e, t);
  function e(n) {
    var r = t.call(this) || this;
    return r.isStopped = !1, n ? (r.destination = n, Hbe(n) && n.add(r)) : r.destination = $0t, r;
  }
  return e.create = function(n, r, o) {
    return new h3(n, r, o);
  }, e.prototype.next = function(n) {
    this.isStopped || this._next(n);
  }, e.prototype.error = function(n) {
    this.isStopped || (this.isStopped = !0, this._error(n));
  }, e.prototype.complete = function() {
    this.isStopped || (this.isStopped = !0, this._complete());
  }, e.prototype.unsubscribe = function() {
    this.closed || (this.isStopped = !0, t.prototype.unsubscribe.call(this), this.destination = null);
  }, e.prototype._next = function(n) {
    this.destination.next(n);
  }, e.prototype._error = function(n) {
    try {
      this.destination.error(n);
    } finally {
      this.unsubscribe();
    }
  }, e.prototype._complete = function() {
    try {
      this.destination.complete();
    } finally {
      this.unsubscribe();
    }
  }, e;
}(wO), T0t = Function.prototype.bind;
function gT(t, e) {
  return T0t.call(t, e);
}
var R0t = function() {
  function t(e) {
    this.partialObserver = e;
  }
  return t.prototype.next = function(e) {
    var n = this.partialObserver;
    if (n.next)
      try {
        n.next(e);
      } catch (r) {
        j1(r);
      }
  }, t.prototype.error = function(e) {
    var n = this.partialObserver;
    if (n.error)
      try {
        n.error(e);
      } catch (r) {
        j1(r);
      }
    else
      j1(e);
  }, t.prototype.complete = function() {
    var e = this.partialObserver;
    if (e.complete)
      try {
        e.complete();
      } catch (n) {
        j1(n);
      }
  }, t;
}(), h3 = function(t) {
  Bv(e, t);
  function e(n, r, o) {
    var i = t.call(this) || this, s;
    if (Rl(n) || !n)
      s = {
        next: n ?? void 0,
        error: r ?? void 0,
        complete: o ?? void 0
      };
    else {
      var a;
      i && Vbe.useDeprecatedNextContext ? (a = Object.create(n), a.unsubscribe = function() {
        return i.unsubscribe();
      }, s = {
        next: n.next && gT(n.next, a),
        error: n.error && gT(n.error, a),
        complete: n.complete && gT(n.complete, a)
      }) : s = n;
    }
    return i.destination = new R0t(s), i;
  }
  return e;
}(Wbe);
function j1(t) {
  A0t(t);
}
function P0t(t) {
  throw t;
}
var $0t = {
  closed: !0,
  next: wZ,
  error: P0t,
  complete: wZ
}, M0t = function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
}();
function D0t(t) {
  return t;
}
function I0t(t) {
  return t.length === 0 ? D0t : t.length === 1 ? t[0] : function(n) {
    return t.reduce(function(r, o) {
      return o(r);
    }, n);
  };
}
var xZ = function() {
  function t(e) {
    e && (this._subscribe = e);
  }
  return t.prototype.lift = function(e) {
    var n = new t();
    return n.source = this, n.operator = e, n;
  }, t.prototype.subscribe = function(e, n, r) {
    var o = this, i = j0t(e) ? e : new h3(e, n, r);
    return Lw(function() {
      var s = o, a = s.operator, l = s.source;
      i.add(a ? a.call(i, l) : l ? o._subscribe(i) : o._trySubscribe(i));
    }), i;
  }, t.prototype._trySubscribe = function(e) {
    try {
      return this._subscribe(e);
    } catch (n) {
      e.error(n);
    }
  }, t.prototype.forEach = function(e, n) {
    var r = this;
    return n = EZ(n), new n(function(o, i) {
      var s = new h3({
        next: function(a) {
          try {
            e(a);
          } catch (l) {
            i(l), s.unsubscribe();
          }
        },
        error: i,
        complete: o
      });
      r.subscribe(s);
    });
  }, t.prototype._subscribe = function(e) {
    var n;
    return (n = this.source) === null || n === void 0 ? void 0 : n.subscribe(e);
  }, t.prototype[M0t] = function() {
    return this;
  }, t.prototype.pipe = function() {
    for (var e = [], n = 0; n < arguments.length; n++)
      e[n] = arguments[n];
    return I0t(e)(this);
  }, t.prototype.toPromise = function(e) {
    var n = this;
    return e = EZ(e), new e(function(r, o) {
      var i;
      n.subscribe(function(s) {
        return i = s;
      }, function(s) {
        return o(s);
      }, function() {
        return r(i);
      });
    });
  }, t.create = function(e) {
    return new t(e);
  }, t;
}();
function EZ(t) {
  var e;
  return (e = t ?? Vbe.Promise) !== null && e !== void 0 ? e : Promise;
}
function N0t(t) {
  return t && Rl(t.next) && Rl(t.error) && Rl(t.complete);
}
function j0t(t) {
  return t && t instanceof Wbe || N0t(t) && Hbe(t);
}
var L0t = qbe(function(t) {
  return function() {
    t(this), this.name = "ObjectUnsubscribedError", this.message = "object unsubscribed";
  };
}), Gbe = function(t) {
  Bv(e, t);
  function e() {
    var n = t.call(this) || this;
    return n.closed = !1, n.currentObservers = null, n.observers = [], n.isStopped = !1, n.hasError = !1, n.thrownError = null, n;
  }
  return e.prototype.lift = function(n) {
    var r = new SZ(this, this);
    return r.operator = n, r;
  }, e.prototype._throwIfClosed = function() {
    if (this.closed)
      throw new L0t();
  }, e.prototype.next = function(n) {
    var r = this;
    Lw(function() {
      var o, i;
      if (r._throwIfClosed(), !r.isStopped) {
        r.currentObservers || (r.currentObservers = Array.from(r.observers));
        try {
          for (var s = c3(r.currentObservers), a = s.next(); !a.done; a = s.next()) {
            var l = a.value;
            l.next(n);
          }
        } catch (c) {
          o = { error: c };
        } finally {
          try {
            a && !a.done && (i = s.return) && i.call(s);
          } finally {
            if (o) throw o.error;
          }
        }
      }
    });
  }, e.prototype.error = function(n) {
    var r = this;
    Lw(function() {
      if (r._throwIfClosed(), !r.isStopped) {
        r.hasError = r.isStopped = !0, r.thrownError = n;
        for (var o = r.observers; o.length; )
          o.shift().error(n);
      }
    });
  }, e.prototype.complete = function() {
    var n = this;
    Lw(function() {
      if (n._throwIfClosed(), !n.isStopped) {
        n.isStopped = !0;
        for (var r = n.observers; r.length; )
          r.shift().complete();
      }
    });
  }, e.prototype.unsubscribe = function() {
    this.isStopped = this.closed = !0, this.observers = this.currentObservers = null;
  }, Object.defineProperty(e.prototype, "observed", {
    get: function() {
      var n;
      return ((n = this.observers) === null || n === void 0 ? void 0 : n.length) > 0;
    },
    enumerable: !1,
    configurable: !0
  }), e.prototype._trySubscribe = function(n) {
    return this._throwIfClosed(), t.prototype._trySubscribe.call(this, n);
  }, e.prototype._subscribe = function(n) {
    return this._throwIfClosed(), this._checkFinalizedStatuses(n), this._innerSubscribe(n);
  }, e.prototype._innerSubscribe = function(n) {
    var r = this, o = this, i = o.hasError, s = o.isStopped, a = o.observers;
    return i || s ? Ube : (this.currentObservers = null, a.push(n), new wO(function() {
      r.currentObservers = null, f3(a, n);
    }));
  }, e.prototype._checkFinalizedStatuses = function(n) {
    var r = this, o = r.hasError, i = r.thrownError, s = r.isStopped;
    o ? n.error(i) : s && n.complete();
  }, e.prototype.asObservable = function() {
    var n = new xZ();
    return n.source = this, n;
  }, e.create = function(n, r) {
    return new SZ(n, r);
  }, e;
}(xZ), SZ = function(t) {
  Bv(e, t);
  function e(n, r) {
    var o = t.call(this) || this;
    return o.destination = n, o.source = r, o;
  }
  return e.prototype.next = function(n) {
    var r, o;
    (o = (r = this.destination) === null || r === void 0 ? void 0 : r.next) === null || o === void 0 || o.call(r, n);
  }, e.prototype.error = function(n) {
    var r, o;
    (o = (r = this.destination) === null || r === void 0 ? void 0 : r.error) === null || o === void 0 || o.call(r, n);
  }, e.prototype.complete = function() {
    var n, r;
    (r = (n = this.destination) === null || n === void 0 ? void 0 : n.complete) === null || r === void 0 || r.call(n);
  }, e.prototype._subscribe = function(n) {
    var r, o;
    return (o = (r = this.source) === null || r === void 0 ? void 0 : r.subscribe(n)) !== null && o !== void 0 ? o : Ube;
  }, e;
}(Gbe), xO = function(t) {
  Bv(e, t);
  function e(n) {
    var r = t.call(this) || this;
    return r._value = n, r;
  }
  return Object.defineProperty(e.prototype, "value", {
    get: function() {
      return this.getValue();
    },
    enumerable: !1,
    configurable: !0
  }), e.prototype._subscribe = function(n) {
    var r = t.prototype._subscribe.call(this, n);
    return !r.closed && n.next(this._value), r;
  }, e.prototype.getValue = function() {
    var n = this, r = n.hasError, o = n.thrownError, i = n._value;
    if (r)
      throw o;
    return this._throwIfClosed(), i;
  }, e.prototype.next = function(n) {
    t.prototype.next.call(this, this._value = n);
  }, e;
}(Gbe);
/*! @license DOMPurify 3.2.4 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.2.4/LICENSE */
const {
  entries: Ybe,
  setPrototypeOf: OZ,
  isFrozen: F0t,
  getPrototypeOf: B0t,
  getOwnPropertyDescriptor: z0t
} = Object;
let {
  freeze: To,
  seal: rs,
  create: Kbe
} = Object, {
  apply: p3,
  construct: m3
} = typeof Reflect < "u" && Reflect;
To || (To = function(e) {
  return e;
});
rs || (rs = function(e) {
  return e;
});
p3 || (p3 = function(e, n, r) {
  return e.apply(n, r);
});
m3 || (m3 = function(e, n) {
  return new e(...n);
});
const L1 = Ro(Array.prototype.forEach), q0t = Ro(Array.prototype.lastIndexOf), CZ = Ro(Array.prototype.pop), km = Ro(Array.prototype.push), U0t = Ro(Array.prototype.splice), Fw = Ro(String.prototype.toLowerCase), yT = Ro(String.prototype.toString), kZ = Ro(String.prototype.match), Am = Ro(String.prototype.replace), H0t = Ro(String.prototype.indexOf), V0t = Ro(String.prototype.trim), ys = Ro(Object.prototype.hasOwnProperty), bo = Ro(RegExp.prototype.test), Tm = W0t(TypeError);
function Ro(t) {
  return function(e) {
    for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++)
      r[o - 1] = arguments[o];
    return p3(t, e, r);
  };
}
function W0t(t) {
  return function() {
    for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++)
      n[r] = arguments[r];
    return m3(t, n);
  };
}
function Nt(t, e) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Fw;
  OZ && OZ(t, null);
  let r = e.length;
  for (; r--; ) {
    let o = e[r];
    if (typeof o == "string") {
      const i = n(o);
      i !== o && (F0t(e) || (e[r] = i), o = i);
    }
    t[o] = !0;
  }
  return t;
}
function G0t(t) {
  for (let e = 0; e < t.length; e++)
    ys(t, e) || (t[e] = null);
  return t;
}
function Hu(t) {
  const e = Kbe(null);
  for (const [n, r] of Ybe(t))
    ys(t, n) && (Array.isArray(r) ? e[n] = G0t(r) : r && typeof r == "object" && r.constructor === Object ? e[n] = Hu(r) : e[n] = r);
  return e;
}
function Rm(t, e) {
  for (; t !== null; ) {
    const r = z0t(t, e);
    if (r) {
      if (r.get)
        return Ro(r.get);
      if (typeof r.value == "function")
        return Ro(r.value);
    }
    t = B0t(t);
  }
  function n() {
    return null;
  }
  return n;
}
const AZ = To(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "section", "select", "shadow", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), vT = To(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), bT = To(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), Y0t = To(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), _T = To(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), K0t = To(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), TZ = To(["#text"]), RZ = To(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns", "slot"]), wT = To(["accent-height", "accumulate", "additive", "alignment-baseline", "amplitude", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "exponent", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "intercept", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "slope", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "tablevalues", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), PZ = To(["accent", "accentunder", "align", "bevelled", "close", "columnsalign", "columnlines", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lspace", "lquote", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), F1 = To(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), X0t = rs(/\{\{[\w\W]*|[\w\W]*\}\}/gm), Q0t = rs(/<%[\w\W]*|[\w\W]*%>/gm), Z0t = rs(/\$\{[\w\W]*/gm), J0t = rs(/^data-[\-\w.\u00B7-\uFFFF]+$/), eyt = rs(/^aria-[\-\w]+$/), Xbe = rs(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
), tyt = rs(/^(?:\w+script|data):/i), nyt = rs(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
), Qbe = rs(/^html$/i), ryt = rs(/^[a-z][.\w]*(-[.\w]+)+$/i);
var $Z = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ARIA_ATTR: eyt,
  ATTR_WHITESPACE: nyt,
  CUSTOM_ELEMENT: ryt,
  DATA_ATTR: J0t,
  DOCTYPE_NAME: Qbe,
  ERB_EXPR: Q0t,
  IS_ALLOWED_URI: Xbe,
  IS_SCRIPT_OR_DATA: tyt,
  MUSTACHE_EXPR: X0t,
  TMPLIT_EXPR: Z0t
});
const Pm = {
  element: 1,
  attribute: 2,
  text: 3,
  cdataSection: 4,
  entityReference: 5,
  // Deprecated
  entityNode: 6,
  // Deprecated
  progressingInstruction: 7,
  comment: 8,
  document: 9,
  documentType: 10,
  documentFragment: 11,
  notation: 12
  // Deprecated
}, oyt = function() {
  return typeof window > "u" ? null : window;
}, iyt = function(e, n) {
  if (typeof e != "object" || typeof e.createPolicy != "function")
    return null;
  let r = null;
  const o = "data-tt-policy-suffix";
  n && n.hasAttribute(o) && (r = n.getAttribute(o));
  const i = "dompurify" + (r ? "#" + r : "");
  try {
    return e.createPolicy(i, {
      createHTML(s) {
        return s;
      },
      createScriptURL(s) {
        return s;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + i + " could not be created."), null;
  }
}, MZ = function() {
  return {
    afterSanitizeAttributes: [],
    afterSanitizeElements: [],
    afterSanitizeShadowDOM: [],
    beforeSanitizeAttributes: [],
    beforeSanitizeElements: [],
    beforeSanitizeShadowDOM: [],
    uponSanitizeAttribute: [],
    uponSanitizeElement: [],
    uponSanitizeShadowNode: []
  };
};
function Zbe() {
  let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : oyt();
  const e = (Qe) => Zbe(Qe);
  if (e.version = "3.2.4", e.removed = [], !t || !t.document || t.document.nodeType !== Pm.document || !t.Element)
    return e.isSupported = !1, e;
  let {
    document: n
  } = t;
  const r = n, o = r.currentScript, {
    DocumentFragment: i,
    HTMLTemplateElement: s,
    Node: a,
    Element: l,
    NodeFilter: c,
    NamedNodeMap: u = t.NamedNodeMap || t.MozNamedAttrMap,
    HTMLFormElement: d,
    DOMParser: f,
    trustedTypes: h
  } = t, p = l.prototype, m = Rm(p, "cloneNode"), g = Rm(p, "remove"), y = Rm(p, "nextSibling"), v = Rm(p, "childNodes"), b = Rm(p, "parentNode");
  if (typeof s == "function") {
    const Qe = n.createElement("template");
    Qe.content && Qe.content.ownerDocument && (n = Qe.content.ownerDocument);
  }
  let _, w = "";
  const {
    implementation: x,
    createNodeIterator: E,
    createDocumentFragment: S,
    getElementsByTagName: C
  } = n, {
    importNode: R
  } = r;
  let P = MZ();
  e.isSupported = typeof Ybe == "function" && typeof b == "function" && x && x.createHTMLDocument !== void 0;
  const {
    MUSTACHE_EXPR: N,
    ERB_EXPR: A,
    TMPLIT_EXPR: O,
    DATA_ATTR: k,
    ARIA_ATTR: T,
    IS_SCRIPT_OR_DATA: I,
    ATTR_WHITESPACE: j,
    CUSTOM_ELEMENT: z
  } = $Z;
  let {
    IS_ALLOWED_URI: $
  } = $Z, D = null;
  const U = Nt({}, [...AZ, ...vT, ...bT, ..._T, ...TZ]);
  let q = null;
  const F = Nt({}, [...RZ, ...wT, ...PZ, ...F1]);
  let B = Object.seal(Kbe(null, {
    tagNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: !1
    }
  })), H = null, Z = null, W = !0, G = !0, ee = !1, Y = !0, L = !1, V = !0, K = !1, ne = !1, ce = !1, fe = !1, ve = !1, _e = !1, Ee = !0, Me = !1;
  const Le = "user-content-";
  let Ce = !0, Je = !1, Ie = {}, nt = null;
  const ct = Nt({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]);
  let mt = null;
  const gt = Nt({}, ["audio", "video", "img", "source", "image", "track"]);
  let Et = null;
  const Rt = Nt({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), zt = "http://www.w3.org/1998/Math/MathML", At = "http://www.w3.org/2000/svg", X = "http://www.w3.org/1999/xhtml";
  let ae = X, ye = !1, De = null;
  const Te = Nt({}, [zt, At, X], yT);
  let st = Nt({}, ["mi", "mo", "mn", "ms", "mtext"]), ft = Nt({}, ["annotation-xml"]);
  const Ht = Nt({}, ["title", "style", "font", "a", "script"]);
  let nn = null;
  const It = ["application/xhtml+xml", "text/html"], Rn = "text/html";
  let yt = null, oe = null;
  const ge = n.createElement("form"), pe = function(se) {
    return se instanceof RegExp || se instanceof Function;
  }, He = function() {
    let se = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!(oe && oe === se)) {
      if ((!se || typeof se != "object") && (se = {}), se = Hu(se), nn = // eslint-disable-next-line unicorn/prefer-includes
      It.indexOf(se.PARSER_MEDIA_TYPE) === -1 ? Rn : se.PARSER_MEDIA_TYPE, yt = nn === "application/xhtml+xml" ? yT : Fw, D = ys(se, "ALLOWED_TAGS") ? Nt({}, se.ALLOWED_TAGS, yt) : U, q = ys(se, "ALLOWED_ATTR") ? Nt({}, se.ALLOWED_ATTR, yt) : F, De = ys(se, "ALLOWED_NAMESPACES") ? Nt({}, se.ALLOWED_NAMESPACES, yT) : Te, Et = ys(se, "ADD_URI_SAFE_ATTR") ? Nt(Hu(Rt), se.ADD_URI_SAFE_ATTR, yt) : Rt, mt = ys(se, "ADD_DATA_URI_TAGS") ? Nt(Hu(gt), se.ADD_DATA_URI_TAGS, yt) : gt, nt = ys(se, "FORBID_CONTENTS") ? Nt({}, se.FORBID_CONTENTS, yt) : ct, H = ys(se, "FORBID_TAGS") ? Nt({}, se.FORBID_TAGS, yt) : {}, Z = ys(se, "FORBID_ATTR") ? Nt({}, se.FORBID_ATTR, yt) : {}, Ie = ys(se, "USE_PROFILES") ? se.USE_PROFILES : !1, W = se.ALLOW_ARIA_ATTR !== !1, G = se.ALLOW_DATA_ATTR !== !1, ee = se.ALLOW_UNKNOWN_PROTOCOLS || !1, Y = se.ALLOW_SELF_CLOSE_IN_ATTR !== !1, L = se.SAFE_FOR_TEMPLATES || !1, V = se.SAFE_FOR_XML !== !1, K = se.WHOLE_DOCUMENT || !1, fe = se.RETURN_DOM || !1, ve = se.RETURN_DOM_FRAGMENT || !1, _e = se.RETURN_TRUSTED_TYPE || !1, ce = se.FORCE_BODY || !1, Ee = se.SANITIZE_DOM !== !1, Me = se.SANITIZE_NAMED_PROPS || !1, Ce = se.KEEP_CONTENT !== !1, Je = se.IN_PLACE || !1, $ = se.ALLOWED_URI_REGEXP || Xbe, ae = se.NAMESPACE || X, st = se.MATHML_TEXT_INTEGRATION_POINTS || st, ft = se.HTML_INTEGRATION_POINTS || ft, B = se.CUSTOM_ELEMENT_HANDLING || {}, se.CUSTOM_ELEMENT_HANDLING && pe(se.CUSTOM_ELEMENT_HANDLING.tagNameCheck) && (B.tagNameCheck = se.CUSTOM_ELEMENT_HANDLING.tagNameCheck), se.CUSTOM_ELEMENT_HANDLING && pe(se.CUSTOM_ELEMENT_HANDLING.attributeNameCheck) && (B.attributeNameCheck = se.CUSTOM_ELEMENT_HANDLING.attributeNameCheck), se.CUSTOM_ELEMENT_HANDLING && typeof se.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements == "boolean" && (B.allowCustomizedBuiltInElements = se.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements), L && (G = !1), ve && (fe = !0), Ie && (D = Nt({}, TZ), q = [], Ie.html === !0 && (Nt(D, AZ), Nt(q, RZ)), Ie.svg === !0 && (Nt(D, vT), Nt(q, wT), Nt(q, F1)), Ie.svgFilters === !0 && (Nt(D, bT), Nt(q, wT), Nt(q, F1)), Ie.mathMl === !0 && (Nt(D, _T), Nt(q, PZ), Nt(q, F1))), se.ADD_TAGS && (D === U && (D = Hu(D)), Nt(D, se.ADD_TAGS, yt)), se.ADD_ATTR && (q === F && (q = Hu(q)), Nt(q, se.ADD_ATTR, yt)), se.ADD_URI_SAFE_ATTR && Nt(Et, se.ADD_URI_SAFE_ATTR, yt), se.FORBID_CONTENTS && (nt === ct && (nt = Hu(nt)), Nt(nt, se.FORBID_CONTENTS, yt)), Ce && (D["#text"] = !0), K && Nt(D, ["html", "head", "body"]), D.table && (Nt(D, ["tbody"]), delete H.tbody), se.TRUSTED_TYPES_POLICY) {
        if (typeof se.TRUSTED_TYPES_POLICY.createHTML != "function")
          throw Tm('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
        if (typeof se.TRUSTED_TYPES_POLICY.createScriptURL != "function")
          throw Tm('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
        _ = se.TRUSTED_TYPES_POLICY, w = _.createHTML("");
      } else
        _ === void 0 && (_ = iyt(h, o)), _ !== null && typeof w == "string" && (w = _.createHTML(""));
      To && To(se), oe = se;
    }
  }, re = Nt({}, [...vT, ...bT, ...Y0t]), J = Nt({}, [..._T, ...K0t]), ie = function(se) {
    let Re = b(se);
    (!Re || !Re.tagName) && (Re = {
      namespaceURI: ae,
      tagName: "template"
    });
    const ot = Fw(se.tagName), Xt = Fw(Re.tagName);
    return De[se.namespaceURI] ? se.namespaceURI === At ? Re.namespaceURI === X ? ot === "svg" : Re.namespaceURI === zt ? ot === "svg" && (Xt === "annotation-xml" || st[Xt]) : !!re[ot] : se.namespaceURI === zt ? Re.namespaceURI === X ? ot === "math" : Re.namespaceURI === At ? ot === "math" && ft[Xt] : !!J[ot] : se.namespaceURI === X ? Re.namespaceURI === At && !ft[Xt] || Re.namespaceURI === zt && !st[Xt] ? !1 : !J[ot] && (Ht[ot] || !re[ot]) : !!(nn === "application/xhtml+xml" && De[se.namespaceURI]) : !1;
  }, me = function(se) {
    km(e.removed, {
      element: se
    });
    try {
      b(se).removeChild(se);
    } catch {
      g(se);
    }
  }, be = function(se, Re) {
    try {
      km(e.removed, {
        attribute: Re.getAttributeNode(se),
        from: Re
      });
    } catch {
      km(e.removed, {
        attribute: null,
        from: Re
      });
    }
    if (Re.removeAttribute(se), se === "is")
      if (fe || ve)
        try {
          me(Re);
        } catch {
        }
      else
        try {
          Re.setAttribute(se, "");
        } catch {
        }
  }, tt = function(se) {
    let Re = null, ot = null;
    if (ce)
      se = "<remove></remove>" + se;
    else {
      const Zn = kZ(se, /^[\r\n\t ]+/);
      ot = Zn && Zn[0];
    }
    nn === "application/xhtml+xml" && ae === X && (se = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + se + "</body></html>");
    const Xt = _ ? _.createHTML(se) : se;
    if (ae === X)
      try {
        Re = new f().parseFromString(Xt, nn);
      } catch {
      }
    if (!Re || !Re.documentElement) {
      Re = x.createDocument(ae, "template", null);
      try {
        Re.documentElement.innerHTML = ye ? w : Xt;
      } catch {
      }
    }
    const Dn = Re.body || Re.documentElement;
    return se && ot && Dn.insertBefore(n.createTextNode(ot), Dn.childNodes[0] || null), ae === X ? C.call(Re, K ? "html" : "body")[0] : K ? Re.documentElement : Dn;
  }, Ke = function(se) {
    return E.call(
      se.ownerDocument || se,
      se,
      // eslint-disable-next-line no-bitwise
      c.SHOW_ELEMENT | c.SHOW_COMMENT | c.SHOW_TEXT | c.SHOW_PROCESSING_INSTRUCTION | c.SHOW_CDATA_SECTION,
      null
    );
  }, Fe = function(se) {
    return se instanceof d && (typeof se.nodeName != "string" || typeof se.textContent != "string" || typeof se.removeChild != "function" || !(se.attributes instanceof u) || typeof se.removeAttribute != "function" || typeof se.setAttribute != "function" || typeof se.namespaceURI != "string" || typeof se.insertBefore != "function" || typeof se.hasChildNodes != "function");
  }, We = function(se) {
    return typeof a == "function" && se instanceof a;
  };
  function Xe(Qe, se, Re) {
    L1(Qe, (ot) => {
      ot.call(e, se, Re, oe);
    });
  }
  const at = function(se) {
    let Re = null;
    if (Xe(P.beforeSanitizeElements, se, null), Fe(se))
      return me(se), !0;
    const ot = yt(se.nodeName);
    if (Xe(P.uponSanitizeElement, se, {
      tagName: ot,
      allowedTags: D
    }), se.hasChildNodes() && !We(se.firstElementChild) && bo(/<[/\w]/g, se.innerHTML) && bo(/<[/\w]/g, se.textContent) || se.nodeType === Pm.progressingInstruction || V && se.nodeType === Pm.comment && bo(/<[/\w]/g, se.data))
      return me(se), !0;
    if (!D[ot] || H[ot]) {
      if (!H[ot] && Lt(ot) && (B.tagNameCheck instanceof RegExp && bo(B.tagNameCheck, ot) || B.tagNameCheck instanceof Function && B.tagNameCheck(ot)))
        return !1;
      if (Ce && !nt[ot]) {
        const Xt = b(se) || se.parentNode, Dn = v(se) || se.childNodes;
        if (Dn && Xt) {
          const Zn = Dn.length;
          for (let Fr = Zn - 1; Fr >= 0; --Fr) {
            const sr = m(Dn[Fr], !0);
            sr.__removalCount = (se.__removalCount || 0) + 1, Xt.insertBefore(sr, y(se));
          }
        }
      }
      return me(se), !0;
    }
    return se instanceof l && !ie(se) || (ot === "noscript" || ot === "noembed" || ot === "noframes") && bo(/<\/no(script|embed|frames)/i, se.innerHTML) ? (me(se), !0) : (L && se.nodeType === Pm.text && (Re = se.textContent, L1([N, A, O], (Xt) => {
      Re = Am(Re, Xt, " ");
    }), se.textContent !== Re && (km(e.removed, {
      element: se.cloneNode()
    }), se.textContent = Re)), Xe(P.afterSanitizeElements, se, null), !1);
  }, bt = function(se, Re, ot) {
    if (Ee && (Re === "id" || Re === "name") && (ot in n || ot in ge))
      return !1;
    if (!(G && !Z[Re] && bo(k, Re))) {
      if (!(W && bo(T, Re))) {
        if (!q[Re] || Z[Re]) {
          if (
            // First condition does a very basic check if a) it's basically a valid custom element tagname AND
            // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
            !(Lt(se) && (B.tagNameCheck instanceof RegExp && bo(B.tagNameCheck, se) || B.tagNameCheck instanceof Function && B.tagNameCheck(se)) && (B.attributeNameCheck instanceof RegExp && bo(B.attributeNameCheck, Re) || B.attributeNameCheck instanceof Function && B.attributeNameCheck(Re)) || // Alternative, second condition checks if it's an `is`-attribute, AND
            // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            Re === "is" && B.allowCustomizedBuiltInElements && (B.tagNameCheck instanceof RegExp && bo(B.tagNameCheck, ot) || B.tagNameCheck instanceof Function && B.tagNameCheck(ot)))
          ) return !1;
        } else if (!Et[Re]) {
          if (!bo($, Am(ot, j, ""))) {
            if (!((Re === "src" || Re === "xlink:href" || Re === "href") && se !== "script" && H0t(ot, "data:") === 0 && mt[se])) {
              if (!(ee && !bo(I, Am(ot, j, "")))) {
                if (ot)
                  return !1;
              }
            }
          }
        }
      }
    }
    return !0;
  }, Lt = function(se) {
    return se !== "annotation-xml" && kZ(se, z);
  }, bn = function(se) {
    Xe(P.beforeSanitizeAttributes, se, null);
    const {
      attributes: Re
    } = se;
    if (!Re || Fe(se))
      return;
    const ot = {
      attrName: "",
      attrValue: "",
      keepAttr: !0,
      allowedAttributes: q,
      forceKeepAttr: void 0
    };
    let Xt = Re.length;
    for (; Xt--; ) {
      const Dn = Re[Xt], {
        name: Zn,
        namespaceURI: Fr,
        value: sr
      } = Dn, $o = yt(Zn);
      let Vn = Zn === "value" ? sr : V0t(sr);
      if (ot.attrName = $o, ot.attrValue = Vn, ot.keepAttr = !0, ot.forceKeepAttr = void 0, Xe(P.uponSanitizeAttribute, se, ot), Vn = ot.attrValue, Me && ($o === "id" || $o === "name") && (be(Zn, se), Vn = Le + Vn), V && bo(/((--!?|])>)|<\/(style|title)/i, Vn)) {
        be(Zn, se);
        continue;
      }
      if (ot.forceKeepAttr || (be(Zn, se), !ot.keepAttr))
        continue;
      if (!Y && bo(/\/>/i, Vn)) {
        be(Zn, se);
        continue;
      }
      L && L1([N, A, O], (Xl) => {
        Vn = Am(Vn, Xl, " ");
      });
      const of = yt(se.nodeName);
      if (bt(of, $o, Vn)) {
        if (_ && typeof h == "object" && typeof h.getAttributeType == "function" && !Fr)
          switch (h.getAttributeType(of, $o)) {
            case "TrustedHTML": {
              Vn = _.createHTML(Vn);
              break;
            }
            case "TrustedScriptURL": {
              Vn = _.createScriptURL(Vn);
              break;
            }
          }
        try {
          Fr ? se.setAttributeNS(Fr, Zn, Vn) : se.setAttribute(Zn, Vn), Fe(se) ? me(se) : CZ(e.removed);
        } catch {
        }
      }
    }
    Xe(P.afterSanitizeAttributes, se, null);
  }, un = function Qe(se) {
    let Re = null;
    const ot = Ke(se);
    for (Xe(P.beforeSanitizeShadowDOM, se, null); Re = ot.nextNode(); )
      Xe(P.uponSanitizeShadowNode, Re, null), at(Re), bn(Re), Re.content instanceof i && Qe(Re.content);
    Xe(P.afterSanitizeShadowDOM, se, null);
  };
  return e.sanitize = function(Qe) {
    let se = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, Re = null, ot = null, Xt = null, Dn = null;
    if (ye = !Qe, ye && (Qe = "<!-->"), typeof Qe != "string" && !We(Qe))
      if (typeof Qe.toString == "function") {
        if (Qe = Qe.toString(), typeof Qe != "string")
          throw Tm("dirty is not a string, aborting");
      } else
        throw Tm("toString is not a function");
    if (!e.isSupported)
      return Qe;
    if (ne || He(se), e.removed = [], typeof Qe == "string" && (Je = !1), Je) {
      if (Qe.nodeName) {
        const sr = yt(Qe.nodeName);
        if (!D[sr] || H[sr])
          throw Tm("root node is forbidden and cannot be sanitized in-place");
      }
    } else if (Qe instanceof a)
      Re = tt("<!---->"), ot = Re.ownerDocument.importNode(Qe, !0), ot.nodeType === Pm.element && ot.nodeName === "BODY" || ot.nodeName === "HTML" ? Re = ot : Re.appendChild(ot);
    else {
      if (!fe && !L && !K && // eslint-disable-next-line unicorn/prefer-includes
      Qe.indexOf("<") === -1)
        return _ && _e ? _.createHTML(Qe) : Qe;
      if (Re = tt(Qe), !Re)
        return fe ? null : _e ? w : "";
    }
    Re && ce && me(Re.firstChild);
    const Zn = Ke(Je ? Qe : Re);
    for (; Xt = Zn.nextNode(); )
      at(Xt), bn(Xt), Xt.content instanceof i && un(Xt.content);
    if (Je)
      return Qe;
    if (fe) {
      if (ve)
        for (Dn = S.call(Re.ownerDocument); Re.firstChild; )
          Dn.appendChild(Re.firstChild);
      else
        Dn = Re;
      return (q.shadowroot || q.shadowrootmode) && (Dn = R.call(r, Dn, !0)), Dn;
    }
    let Fr = K ? Re.outerHTML : Re.innerHTML;
    return K && D["!doctype"] && Re.ownerDocument && Re.ownerDocument.doctype && Re.ownerDocument.doctype.name && bo(Qbe, Re.ownerDocument.doctype.name) && (Fr = "<!DOCTYPE " + Re.ownerDocument.doctype.name + `>
` + Fr), L && L1([N, A, O], (sr) => {
      Fr = Am(Fr, sr, " ");
    }), _ && _e ? _.createHTML(Fr) : Fr;
  }, e.setConfig = function() {
    let Qe = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    He(Qe), ne = !0;
  }, e.clearConfig = function() {
    oe = null, ne = !1;
  }, e.isValidAttribute = function(Qe, se, Re) {
    oe || He({});
    const ot = yt(Qe), Xt = yt(se);
    return bt(ot, Xt, Re);
  }, e.addHook = function(Qe, se) {
    typeof se == "function" && km(P[Qe], se);
  }, e.removeHook = function(Qe, se) {
    if (se !== void 0) {
      const Re = q0t(P[Qe], se);
      return Re === -1 ? void 0 : U0t(P[Qe], Re, 1)[0];
    }
    return CZ(P[Qe]);
  }, e.removeHooks = function(Qe) {
    P[Qe] = [];
  }, e.removeAllHooks = function() {
    P = MZ();
  }, e;
}
var DZ = Zbe();
function xr(t) {
  return typeof File < "u" && t instanceof File || typeof Date < "u" && t instanceof Date ? !1 : typeof t == "object" && t !== null && !Array.isArray(t);
}
const Jbe = "__additional_property", syt = "additionalProperties", b6 = "allOf", NE = "anyOf", ayt = "const", lyt = "default", e1e = "dependencies", Ol = "__errors", B1 = "$id", cyt = "if", uyt = "items", dyt = "_$junk_option_schema_id$_", x0 = "oneOf", ha = "properties", fyt = "required", Ca = "$ref", hyt = "__rjsf_additionalProperties", t1e = "__rjsf_rootSchema", pyt = "ui:widget", myt = "ui:options";
function IZ(t = {}, e = {}) {
  return Object.keys(t).filter((n) => n.indexOf("ui:") === 0).reduce((n, r) => {
    const o = t[r];
    return r === pyt && xr(o) ? (console.error("Setting options via ui:widget object is no longer supported, use ui:options instead"), n) : r === myt && xr(o) ? { ...n, ...o } : { ...n, [r.substring(3)]: o };
  }, { ...e });
}
var xT, NZ;
function n1e() {
  if (NZ) return xT;
  NZ = 1;
  var t = typeof ob == "object" && ob && ob.Object === Object && ob;
  return xT = t, xT;
}
var ET, jZ;
function Na() {
  if (jZ) return ET;
  jZ = 1;
  var t = n1e(), e = typeof self == "object" && self && self.Object === Object && self, n = t || e || Function("return this")();
  return ET = n, ET;
}
var ST, LZ;
function Ip() {
  if (LZ) return ST;
  LZ = 1;
  var t = Na(), e = t.Symbol;
  return ST = e, ST;
}
var OT, FZ;
function gyt() {
  if (FZ) return OT;
  FZ = 1;
  var t = Ip(), e = Object.prototype, n = e.hasOwnProperty, r = e.toString, o = t ? t.toStringTag : void 0;
  function i(s) {
    var a = n.call(s, o), l = s[o];
    try {
      s[o] = void 0;
      var c = !0;
    } catch {
    }
    var u = r.call(s);
    return c && (a ? s[o] = l : delete s[o]), u;
  }
  return OT = i, OT;
}
var CT, BZ;
function yyt() {
  if (BZ) return CT;
  BZ = 1;
  var t = Object.prototype, e = t.toString;
  function n(r) {
    return e.call(r);
  }
  return CT = n, CT;
}
var kT, zZ;
function Yl() {
  if (zZ) return kT;
  zZ = 1;
  var t = Ip(), e = gyt(), n = yyt(), r = "[object Null]", o = "[object Undefined]", i = t ? t.toStringTag : void 0;
  function s(a) {
    return a == null ? a === void 0 ? o : r : i && i in Object(a) ? e(a) : n(a);
  }
  return kT = s, kT;
}
var AT, qZ;
function r1e() {
  if (qZ) return AT;
  qZ = 1;
  function t(e, n) {
    return function(r) {
      return e(n(r));
    };
  }
  return AT = t, AT;
}
var TT, UZ;
function EO() {
  if (UZ) return TT;
  UZ = 1;
  var t = r1e(), e = t(Object.getPrototypeOf, Object);
  return TT = e, TT;
}
var RT, HZ;
function us() {
  if (HZ) return RT;
  HZ = 1;
  function t(e) {
    return e != null && typeof e == "object";
  }
  return RT = t, RT;
}
var PT, VZ;
function Np() {
  if (VZ) return PT;
  VZ = 1;
  var t = Yl(), e = EO(), n = us(), r = "[object Object]", o = Function.prototype, i = Object.prototype, s = o.toString, a = i.hasOwnProperty, l = s.call(Object);
  function c(u) {
    if (!n(u) || t(u) != r)
      return !1;
    var d = e(u);
    if (d === null)
      return !0;
    var f = a.call(d, "constructor") && d.constructor;
    return typeof f == "function" && f instanceof f && s.call(f) == l;
  }
  return PT = c, PT;
}
var vyt = Np();
const _6 = /* @__PURE__ */ Kt(vyt);
function g3(t) {
  const e = {
    // We store the list of errors for this node in a property named __errors
    // to avoid name collision with a possible sub schema field named
    // 'errors' (see `utils.toErrorSchema`).
    [Ol]: [],
    addError(n) {
      this[Ol].push(n);
    }
  };
  if (Array.isArray(t))
    return t.reduce((n, r, o) => ({ ...n, [o]: g3(r) }), e);
  if (_6(t)) {
    const n = t;
    return Object.keys(n).reduce((r, o) => ({ ...r, [o]: g3(n[o]) }), e);
  }
  return e;
}
var $T, WZ;
function byt() {
  if (WZ) return $T;
  WZ = 1;
  function t() {
    this.__data__ = [], this.size = 0;
  }
  return $T = t, $T;
}
var MT, GZ;
function jp() {
  if (GZ) return MT;
  GZ = 1;
  function t(e, n) {
    return e === n || e !== e && n !== n;
  }
  return MT = t, MT;
}
var DT, YZ;
function SO() {
  if (YZ) return DT;
  YZ = 1;
  var t = jp();
  function e(n, r) {
    for (var o = n.length; o--; )
      if (t(n[o][0], r))
        return o;
    return -1;
  }
  return DT = e, DT;
}
var IT, KZ;
function _yt() {
  if (KZ) return IT;
  KZ = 1;
  var t = SO(), e = Array.prototype, n = e.splice;
  function r(o) {
    var i = this.__data__, s = t(i, o);
    if (s < 0)
      return !1;
    var a = i.length - 1;
    return s == a ? i.pop() : n.call(i, s, 1), --this.size, !0;
  }
  return IT = r, IT;
}
var NT, XZ;
function wyt() {
  if (XZ) return NT;
  XZ = 1;
  var t = SO();
  function e(n) {
    var r = this.__data__, o = t(r, n);
    return o < 0 ? void 0 : r[o][1];
  }
  return NT = e, NT;
}
var jT, QZ;
function xyt() {
  if (QZ) return jT;
  QZ = 1;
  var t = SO();
  function e(n) {
    return t(this.__data__, n) > -1;
  }
  return jT = e, jT;
}
var LT, ZZ;
function Eyt() {
  if (ZZ) return LT;
  ZZ = 1;
  var t = SO();
  function e(n, r) {
    var o = this.__data__, i = t(o, n);
    return i < 0 ? (++this.size, o.push([n, r])) : o[i][1] = r, this;
  }
  return LT = e, LT;
}
var FT, JZ;
function OO() {
  if (JZ) return FT;
  JZ = 1;
  var t = byt(), e = _yt(), n = wyt(), r = xyt(), o = Eyt();
  function i(s) {
    var a = -1, l = s == null ? 0 : s.length;
    for (this.clear(); ++a < l; ) {
      var c = s[a];
      this.set(c[0], c[1]);
    }
  }
  return i.prototype.clear = t, i.prototype.delete = e, i.prototype.get = n, i.prototype.has = r, i.prototype.set = o, FT = i, FT;
}
var BT, eJ;
function Syt() {
  if (eJ) return BT;
  eJ = 1;
  var t = OO();
  function e() {
    this.__data__ = new t(), this.size = 0;
  }
  return BT = e, BT;
}
var zT, tJ;
function Oyt() {
  if (tJ) return zT;
  tJ = 1;
  function t(e) {
    var n = this.__data__, r = n.delete(e);
    return this.size = n.size, r;
  }
  return zT = t, zT;
}
var qT, nJ;
function Cyt() {
  if (nJ) return qT;
  nJ = 1;
  function t(e) {
    return this.__data__.get(e);
  }
  return qT = t, qT;
}
var UT, rJ;
function kyt() {
  if (rJ) return UT;
  rJ = 1;
  function t(e) {
    return this.__data__.has(e);
  }
  return UT = t, UT;
}
var HT, oJ;
function ni() {
  if (oJ) return HT;
  oJ = 1;
  function t(e) {
    var n = typeof e;
    return e != null && (n == "object" || n == "function");
  }
  return HT = t, HT;
}
var VT, iJ;
function CO() {
  if (iJ) return VT;
  iJ = 1;
  var t = Yl(), e = ni(), n = "[object AsyncFunction]", r = "[object Function]", o = "[object GeneratorFunction]", i = "[object Proxy]";
  function s(a) {
    if (!e(a))
      return !1;
    var l = t(a);
    return l == r || l == o || l == n || l == i;
  }
  return VT = s, VT;
}
var WT, sJ;
function Ayt() {
  if (sJ) return WT;
  sJ = 1;
  var t = Na(), e = t["__core-js_shared__"];
  return WT = e, WT;
}
var GT, aJ;
function Tyt() {
  if (aJ) return GT;
  aJ = 1;
  var t = Ayt(), e = function() {
    var r = /[^.]+$/.exec(t && t.keys && t.keys.IE_PROTO || "");
    return r ? "Symbol(src)_1." + r : "";
  }();
  function n(r) {
    return !!e && e in r;
  }
  return GT = n, GT;
}
var YT, lJ;
function o1e() {
  if (lJ) return YT;
  lJ = 1;
  var t = Function.prototype, e = t.toString;
  function n(r) {
    if (r != null) {
      try {
        return e.call(r);
      } catch {
      }
      try {
        return r + "";
      } catch {
      }
    }
    return "";
  }
  return YT = n, YT;
}
var KT, cJ;
function Ryt() {
  if (cJ) return KT;
  cJ = 1;
  var t = CO(), e = Tyt(), n = ni(), r = o1e(), o = /[\\^$.*+?()[\]{}|]/g, i = /^\[object .+?Constructor\]$/, s = Function.prototype, a = Object.prototype, l = s.toString, c = a.hasOwnProperty, u = RegExp(
    "^" + l.call(c).replace(o, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function d(f) {
    if (!n(f) || e(f))
      return !1;
    var h = t(f) ? u : i;
    return h.test(r(f));
  }
  return KT = d, KT;
}
var XT, uJ;
function Pyt() {
  if (uJ) return XT;
  uJ = 1;
  function t(e, n) {
    return e?.[n];
  }
  return XT = t, XT;
}
var QT, dJ;
function Jd() {
  if (dJ) return QT;
  dJ = 1;
  var t = Ryt(), e = Pyt();
  function n(r, o) {
    var i = e(r, o);
    return t(i) ? i : void 0;
  }
  return QT = n, QT;
}
var ZT, fJ;
function w6() {
  if (fJ) return ZT;
  fJ = 1;
  var t = Jd(), e = Na(), n = t(e, "Map");
  return ZT = n, ZT;
}
var JT, hJ;
function kO() {
  if (hJ) return JT;
  hJ = 1;
  var t = Jd(), e = t(Object, "create");
  return JT = e, JT;
}
var eR, pJ;
function $yt() {
  if (pJ) return eR;
  pJ = 1;
  var t = kO();
  function e() {
    this.__data__ = t ? t(null) : {}, this.size = 0;
  }
  return eR = e, eR;
}
var tR, mJ;
function Myt() {
  if (mJ) return tR;
  mJ = 1;
  function t(e) {
    var n = this.has(e) && delete this.__data__[e];
    return this.size -= n ? 1 : 0, n;
  }
  return tR = t, tR;
}
var nR, gJ;
function Dyt() {
  if (gJ) return nR;
  gJ = 1;
  var t = kO(), e = "__lodash_hash_undefined__", n = Object.prototype, r = n.hasOwnProperty;
  function o(i) {
    var s = this.__data__;
    if (t) {
      var a = s[i];
      return a === e ? void 0 : a;
    }
    return r.call(s, i) ? s[i] : void 0;
  }
  return nR = o, nR;
}
var rR, yJ;
function Iyt() {
  if (yJ) return rR;
  yJ = 1;
  var t = kO(), e = Object.prototype, n = e.hasOwnProperty;
  function r(o) {
    var i = this.__data__;
    return t ? i[o] !== void 0 : n.call(i, o);
  }
  return rR = r, rR;
}
var oR, vJ;
function Nyt() {
  if (vJ) return oR;
  vJ = 1;
  var t = kO(), e = "__lodash_hash_undefined__";
  function n(r, o) {
    var i = this.__data__;
    return this.size += this.has(r) ? 0 : 1, i[r] = t && o === void 0 ? e : o, this;
  }
  return oR = n, oR;
}
var iR, bJ;
function jyt() {
  if (bJ) return iR;
  bJ = 1;
  var t = $yt(), e = Myt(), n = Dyt(), r = Iyt(), o = Nyt();
  function i(s) {
    var a = -1, l = s == null ? 0 : s.length;
    for (this.clear(); ++a < l; ) {
      var c = s[a];
      this.set(c[0], c[1]);
    }
  }
  return i.prototype.clear = t, i.prototype.delete = e, i.prototype.get = n, i.prototype.has = r, i.prototype.set = o, iR = i, iR;
}
var sR, _J;
function Lyt() {
  if (_J) return sR;
  _J = 1;
  var t = jyt(), e = OO(), n = w6();
  function r() {
    this.size = 0, this.__data__ = {
      hash: new t(),
      map: new (n || e)(),
      string: new t()
    };
  }
  return sR = r, sR;
}
var aR, wJ;
function Fyt() {
  if (wJ) return aR;
  wJ = 1;
  function t(e) {
    var n = typeof e;
    return n == "string" || n == "number" || n == "symbol" || n == "boolean" ? e !== "__proto__" : e === null;
  }
  return aR = t, aR;
}
var lR, xJ;
function AO() {
  if (xJ) return lR;
  xJ = 1;
  var t = Fyt();
  function e(n, r) {
    var o = n.__data__;
    return t(r) ? o[typeof r == "string" ? "string" : "hash"] : o.map;
  }
  return lR = e, lR;
}
var cR, EJ;
function Byt() {
  if (EJ) return cR;
  EJ = 1;
  var t = AO();
  function e(n) {
    var r = t(this, n).delete(n);
    return this.size -= r ? 1 : 0, r;
  }
  return cR = e, cR;
}
var uR, SJ;
function zyt() {
  if (SJ) return uR;
  SJ = 1;
  var t = AO();
  function e(n) {
    return t(this, n).get(n);
  }
  return uR = e, uR;
}
var dR, OJ;
function qyt() {
  if (OJ) return dR;
  OJ = 1;
  var t = AO();
  function e(n) {
    return t(this, n).has(n);
  }
  return dR = e, dR;
}
var fR, CJ;
function Uyt() {
  if (CJ) return fR;
  CJ = 1;
  var t = AO();
  function e(n, r) {
    var o = t(this, n), i = o.size;
    return o.set(n, r), this.size += o.size == i ? 0 : 1, this;
  }
  return fR = e, fR;
}
var hR, kJ;
function x6() {
  if (kJ) return hR;
  kJ = 1;
  var t = Lyt(), e = Byt(), n = zyt(), r = qyt(), o = Uyt();
  function i(s) {
    var a = -1, l = s == null ? 0 : s.length;
    for (this.clear(); ++a < l; ) {
      var c = s[a];
      this.set(c[0], c[1]);
    }
  }
  return i.prototype.clear = t, i.prototype.delete = e, i.prototype.get = n, i.prototype.has = r, i.prototype.set = o, hR = i, hR;
}
var pR, AJ;
function Hyt() {
  if (AJ) return pR;
  AJ = 1;
  var t = OO(), e = w6(), n = x6(), r = 200;
  function o(i, s) {
    var a = this.__data__;
    if (a instanceof t) {
      var l = a.__data__;
      if (!e || l.length < r - 1)
        return l.push([i, s]), this.size = ++a.size, this;
      a = this.__data__ = new n(l);
    }
    return a.set(i, s), this.size = a.size, this;
  }
  return pR = o, pR;
}
var mR, TJ;
function TO() {
  if (TJ) return mR;
  TJ = 1;
  var t = OO(), e = Syt(), n = Oyt(), r = Cyt(), o = kyt(), i = Hyt();
  function s(a) {
    var l = this.__data__ = new t(a);
    this.size = l.size;
  }
  return s.prototype.clear = e, s.prototype.delete = n, s.prototype.get = r, s.prototype.has = o, s.prototype.set = i, mR = s, mR;
}
var gR, RJ;
function Vyt() {
  if (RJ) return gR;
  RJ = 1;
  var t = "__lodash_hash_undefined__";
  function e(n) {
    return this.__data__.set(n, t), this;
  }
  return gR = e, gR;
}
var yR, PJ;
function Wyt() {
  if (PJ) return yR;
  PJ = 1;
  function t(e) {
    return this.__data__.has(e);
  }
  return yR = t, yR;
}
var vR, $J;
function RO() {
  if ($J) return vR;
  $J = 1;
  var t = x6(), e = Vyt(), n = Wyt();
  function r(o) {
    var i = -1, s = o == null ? 0 : o.length;
    for (this.__data__ = new t(); ++i < s; )
      this.add(o[i]);
  }
  return r.prototype.add = r.prototype.push = e, r.prototype.has = n, vR = r, vR;
}
var bR, MJ;
function Gyt() {
  if (MJ) return bR;
  MJ = 1;
  function t(e, n) {
    for (var r = -1, o = e == null ? 0 : e.length; ++r < o; )
      if (n(e[r], r, e))
        return !0;
    return !1;
  }
  return bR = t, bR;
}
var _R, DJ;
function PO() {
  if (DJ) return _R;
  DJ = 1;
  function t(e, n) {
    return e.has(n);
  }
  return _R = t, _R;
}
var wR, IJ;
function i1e() {
  if (IJ) return wR;
  IJ = 1;
  var t = RO(), e = Gyt(), n = PO(), r = 1, o = 2;
  function i(s, a, l, c, u, d) {
    var f = l & r, h = s.length, p = a.length;
    if (h != p && !(f && p > h))
      return !1;
    var m = d.get(s), g = d.get(a);
    if (m && g)
      return m == a && g == s;
    var y = -1, v = !0, b = l & o ? new t() : void 0;
    for (d.set(s, a), d.set(a, s); ++y < h; ) {
      var _ = s[y], w = a[y];
      if (c)
        var x = f ? c(w, _, y, a, s, d) : c(_, w, y, s, a, d);
      if (x !== void 0) {
        if (x)
          continue;
        v = !1;
        break;
      }
      if (b) {
        if (!e(a, function(E, S) {
          if (!n(b, S) && (_ === E || u(_, E, l, c, d)))
            return b.push(S);
        })) {
          v = !1;
          break;
        }
      } else if (!(_ === w || u(_, w, l, c, d))) {
        v = !1;
        break;
      }
    }
    return d.delete(s), d.delete(a), v;
  }
  return wR = i, wR;
}
var xR, NJ;
function s1e() {
  if (NJ) return xR;
  NJ = 1;
  var t = Na(), e = t.Uint8Array;
  return xR = e, xR;
}
var ER, jJ;
function Yyt() {
  if (jJ) return ER;
  jJ = 1;
  function t(e) {
    var n = -1, r = Array(e.size);
    return e.forEach(function(o, i) {
      r[++n] = [i, o];
    }), r;
  }
  return ER = t, ER;
}
var SR, LJ;
function E6() {
  if (LJ) return SR;
  LJ = 1;
  function t(e) {
    var n = -1, r = Array(e.size);
    return e.forEach(function(o) {
      r[++n] = o;
    }), r;
  }
  return SR = t, SR;
}
var OR, FJ;
function Kyt() {
  if (FJ) return OR;
  FJ = 1;
  var t = Ip(), e = s1e(), n = jp(), r = i1e(), o = Yyt(), i = E6(), s = 1, a = 2, l = "[object Boolean]", c = "[object Date]", u = "[object Error]", d = "[object Map]", f = "[object Number]", h = "[object RegExp]", p = "[object Set]", m = "[object String]", g = "[object Symbol]", y = "[object ArrayBuffer]", v = "[object DataView]", b = t ? t.prototype : void 0, _ = b ? b.valueOf : void 0;
  function w(x, E, S, C, R, P, N) {
    switch (S) {
      case v:
        if (x.byteLength != E.byteLength || x.byteOffset != E.byteOffset)
          return !1;
        x = x.buffer, E = E.buffer;
      case y:
        return !(x.byteLength != E.byteLength || !P(new e(x), new e(E)));
      case l:
      case c:
      case f:
        return n(+x, +E);
      case u:
        return x.name == E.name && x.message == E.message;
      case h:
      case m:
        return x == E + "";
      case d:
        var A = o;
      case p:
        var O = C & s;
        if (A || (A = i), x.size != E.size && !O)
          return !1;
        var k = N.get(x);
        if (k)
          return k == E;
        C |= a, N.set(x, E);
        var T = r(A(x), A(E), C, R, P, N);
        return N.delete(x), T;
      case g:
        if (_)
          return _.call(x) == _.call(E);
    }
    return !1;
  }
  return OR = w, OR;
}
var CR, BJ;
function S6() {
  if (BJ) return CR;
  BJ = 1;
  function t(e, n) {
    for (var r = -1, o = n.length, i = e.length; ++r < o; )
      e[i + r] = n[r];
    return e;
  }
  return CR = t, CR;
}
var kR, zJ;
function Wr() {
  if (zJ) return kR;
  zJ = 1;
  var t = Array.isArray;
  return kR = t, kR;
}
var AR, qJ;
function a1e() {
  if (qJ) return AR;
  qJ = 1;
  var t = S6(), e = Wr();
  function n(r, o, i) {
    var s = o(r);
    return e(r) ? s : t(s, i(r));
  }
  return AR = n, AR;
}
var TR, UJ;
function Xyt() {
  if (UJ) return TR;
  UJ = 1;
  function t(e, n) {
    for (var r = -1, o = e == null ? 0 : e.length, i = 0, s = []; ++r < o; ) {
      var a = e[r];
      n(a, r, e) && (s[i++] = a);
    }
    return s;
  }
  return TR = t, TR;
}
var RR, HJ;
function l1e() {
  if (HJ) return RR;
  HJ = 1;
  function t() {
    return [];
  }
  return RR = t, RR;
}
var PR, VJ;
function O6() {
  if (VJ) return PR;
  VJ = 1;
  var t = Xyt(), e = l1e(), n = Object.prototype, r = n.propertyIsEnumerable, o = Object.getOwnPropertySymbols, i = o ? function(s) {
    return s == null ? [] : (s = Object(s), t(o(s), function(a) {
      return r.call(s, a);
    }));
  } : e;
  return PR = i, PR;
}
var $R, WJ;
function c1e() {
  if (WJ) return $R;
  WJ = 1;
  function t(e, n) {
    for (var r = -1, o = Array(e); ++r < e; )
      o[r] = n(r);
    return o;
  }
  return $R = t, $R;
}
var MR, GJ;
function Qyt() {
  if (GJ) return MR;
  GJ = 1;
  var t = Yl(), e = us(), n = "[object Arguments]";
  function r(o) {
    return e(o) && t(o) == n;
  }
  return MR = r, MR;
}
var DR, YJ;
function zv() {
  if (YJ) return DR;
  YJ = 1;
  var t = Qyt(), e = us(), n = Object.prototype, r = n.hasOwnProperty, o = n.propertyIsEnumerable, i = t(/* @__PURE__ */ function() {
    return arguments;
  }()) ? t : function(s) {
    return e(s) && r.call(s, "callee") && !o.call(s, "callee");
  };
  return DR = i, DR;
}
var $g = { exports: {} }, IR, KJ;
function Zyt() {
  if (KJ) return IR;
  KJ = 1;
  function t() {
    return !1;
  }
  return IR = t, IR;
}
$g.exports;
var XJ;
function Lp() {
  return XJ || (XJ = 1, function(t, e) {
    var n = Na(), r = Zyt(), o = e && !e.nodeType && e, i = o && !0 && t && !t.nodeType && t, s = i && i.exports === o, a = s ? n.Buffer : void 0, l = a ? a.isBuffer : void 0, c = l || r;
    t.exports = c;
  }($g, $g.exports)), $g.exports;
}
var NR, QJ;
function $O() {
  if (QJ) return NR;
  QJ = 1;
  var t = 9007199254740991, e = /^(?:0|[1-9]\d*)$/;
  function n(r, o) {
    var i = typeof r;
    return o = o ?? t, !!o && (i == "number" || i != "symbol" && e.test(r)) && r > -1 && r % 1 == 0 && r < o;
  }
  return NR = n, NR;
}
var jR, ZJ;
function C6() {
  if (ZJ) return jR;
  ZJ = 1;
  var t = 9007199254740991;
  function e(n) {
    return typeof n == "number" && n > -1 && n % 1 == 0 && n <= t;
  }
  return jR = e, jR;
}
var LR, JJ;
function Jyt() {
  if (JJ) return LR;
  JJ = 1;
  var t = Yl(), e = C6(), n = us(), r = "[object Arguments]", o = "[object Array]", i = "[object Boolean]", s = "[object Date]", a = "[object Error]", l = "[object Function]", c = "[object Map]", u = "[object Number]", d = "[object Object]", f = "[object RegExp]", h = "[object Set]", p = "[object String]", m = "[object WeakMap]", g = "[object ArrayBuffer]", y = "[object DataView]", v = "[object Float32Array]", b = "[object Float64Array]", _ = "[object Int8Array]", w = "[object Int16Array]", x = "[object Int32Array]", E = "[object Uint8Array]", S = "[object Uint8ClampedArray]", C = "[object Uint16Array]", R = "[object Uint32Array]", P = {};
  P[v] = P[b] = P[_] = P[w] = P[x] = P[E] = P[S] = P[C] = P[R] = !0, P[r] = P[o] = P[g] = P[i] = P[y] = P[s] = P[a] = P[l] = P[c] = P[u] = P[d] = P[f] = P[h] = P[p] = P[m] = !1;
  function N(A) {
    return n(A) && e(A.length) && !!P[t(A)];
  }
  return LR = N, LR;
}
var FR, eee;
function ef() {
  if (eee) return FR;
  eee = 1;
  function t(e) {
    return function(n) {
      return e(n);
    };
  }
  return FR = t, FR;
}
var Mg = { exports: {} };
Mg.exports;
var tee;
function k6() {
  return tee || (tee = 1, function(t, e) {
    var n = n1e(), r = e && !e.nodeType && e, o = r && !0 && t && !t.nodeType && t, i = o && o.exports === r, s = i && n.process, a = function() {
      try {
        var l = o && o.require && o.require("util").types;
        return l || s && s.binding && s.binding("util");
      } catch {
      }
    }();
    t.exports = a;
  }(Mg, Mg.exports)), Mg.exports;
}
var BR, nee;
function qv() {
  if (nee) return BR;
  nee = 1;
  var t = Jyt(), e = ef(), n = k6(), r = n && n.isTypedArray, o = r ? e(r) : t;
  return BR = o, BR;
}
var zR, ree;
function u1e() {
  if (ree) return zR;
  ree = 1;
  var t = c1e(), e = zv(), n = Wr(), r = Lp(), o = $O(), i = qv(), s = Object.prototype, a = s.hasOwnProperty;
  function l(c, u) {
    var d = n(c), f = !d && e(c), h = !d && !f && r(c), p = !d && !f && !h && i(c), m = d || f || h || p, g = m ? t(c.length, String) : [], y = g.length;
    for (var v in c)
      (u || a.call(c, v)) && !(m && // Safari 9 has enumerable `arguments.length` in strict mode.
      (v == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      h && (v == "offset" || v == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      p && (v == "buffer" || v == "byteLength" || v == "byteOffset") || // Skip index properties.
      o(v, y))) && g.push(v);
    return g;
  }
  return zR = l, zR;
}
var qR, oee;
function MO() {
  if (oee) return qR;
  oee = 1;
  var t = Object.prototype;
  function e(n) {
    var r = n && n.constructor, o = typeof r == "function" && r.prototype || t;
    return n === o;
  }
  return qR = e, qR;
}
var UR, iee;
function evt() {
  if (iee) return UR;
  iee = 1;
  var t = r1e(), e = t(Object.keys, Object);
  return UR = e, UR;
}
var HR, see;
function d1e() {
  if (see) return HR;
  see = 1;
  var t = MO(), e = evt(), n = Object.prototype, r = n.hasOwnProperty;
  function o(i) {
    if (!t(i))
      return e(i);
    var s = [];
    for (var a in Object(i))
      r.call(i, a) && a != "constructor" && s.push(a);
    return s;
  }
  return HR = o, HR;
}
var VR, aee;
function tf() {
  if (aee) return VR;
  aee = 1;
  var t = CO(), e = C6();
  function n(r) {
    return r != null && e(r.length) && !t(r);
  }
  return VR = n, VR;
}
var WR, lee;
function Uv() {
  if (lee) return WR;
  lee = 1;
  var t = u1e(), e = d1e(), n = tf();
  function r(o) {
    return n(o) ? t(o) : e(o);
  }
  return WR = r, WR;
}
var GR, cee;
function f1e() {
  if (cee) return GR;
  cee = 1;
  var t = a1e(), e = O6(), n = Uv();
  function r(o) {
    return t(o, n, e);
  }
  return GR = r, GR;
}
var YR, uee;
function tvt() {
  if (uee) return YR;
  uee = 1;
  var t = f1e(), e = 1, n = Object.prototype, r = n.hasOwnProperty;
  function o(i, s, a, l, c, u) {
    var d = a & e, f = t(i), h = f.length, p = t(s), m = p.length;
    if (h != m && !d)
      return !1;
    for (var g = h; g--; ) {
      var y = f[g];
      if (!(d ? y in s : r.call(s, y)))
        return !1;
    }
    var v = u.get(i), b = u.get(s);
    if (v && b)
      return v == s && b == i;
    var _ = !0;
    u.set(i, s), u.set(s, i);
    for (var w = d; ++g < h; ) {
      y = f[g];
      var x = i[y], E = s[y];
      if (l)
        var S = d ? l(E, x, y, s, i, u) : l(x, E, y, i, s, u);
      if (!(S === void 0 ? x === E || c(x, E, a, l, u) : S)) {
        _ = !1;
        break;
      }
      w || (w = y == "constructor");
    }
    if (_ && !w) {
      var C = i.constructor, R = s.constructor;
      C != R && "constructor" in i && "constructor" in s && !(typeof C == "function" && C instanceof C && typeof R == "function" && R instanceof R) && (_ = !1);
    }
    return u.delete(i), u.delete(s), _;
  }
  return YR = o, YR;
}
var KR, dee;
function nvt() {
  if (dee) return KR;
  dee = 1;
  var t = Jd(), e = Na(), n = t(e, "DataView");
  return KR = n, KR;
}
var XR, fee;
function rvt() {
  if (fee) return XR;
  fee = 1;
  var t = Jd(), e = Na(), n = t(e, "Promise");
  return XR = n, XR;
}
var QR, hee;
function h1e() {
  if (hee) return QR;
  hee = 1;
  var t = Jd(), e = Na(), n = t(e, "Set");
  return QR = n, QR;
}
var ZR, pee;
function ovt() {
  if (pee) return ZR;
  pee = 1;
  var t = Jd(), e = Na(), n = t(e, "WeakMap");
  return ZR = n, ZR;
}
var JR, mee;
function Hv() {
  if (mee) return JR;
  mee = 1;
  var t = nvt(), e = w6(), n = rvt(), r = h1e(), o = ovt(), i = Yl(), s = o1e(), a = "[object Map]", l = "[object Object]", c = "[object Promise]", u = "[object Set]", d = "[object WeakMap]", f = "[object DataView]", h = s(t), p = s(e), m = s(n), g = s(r), y = s(o), v = i;
  return (t && v(new t(new ArrayBuffer(1))) != f || e && v(new e()) != a || n && v(n.resolve()) != c || r && v(new r()) != u || o && v(new o()) != d) && (v = function(b) {
    var _ = i(b), w = _ == l ? b.constructor : void 0, x = w ? s(w) : "";
    if (x)
      switch (x) {
        case h:
          return f;
        case p:
          return a;
        case m:
          return c;
        case g:
          return u;
        case y:
          return d;
      }
    return _;
  }), JR = v, JR;
}
var eP, gee;
function ivt() {
  if (gee) return eP;
  gee = 1;
  var t = TO(), e = i1e(), n = Kyt(), r = tvt(), o = Hv(), i = Wr(), s = Lp(), a = qv(), l = 1, c = "[object Arguments]", u = "[object Array]", d = "[object Object]", f = Object.prototype, h = f.hasOwnProperty;
  function p(m, g, y, v, b, _) {
    var w = i(m), x = i(g), E = w ? u : o(m), S = x ? u : o(g);
    E = E == c ? d : E, S = S == c ? d : S;
    var C = E == d, R = S == d, P = E == S;
    if (P && s(m)) {
      if (!s(g))
        return !1;
      w = !0, C = !1;
    }
    if (P && !C)
      return _ || (_ = new t()), w || a(m) ? e(m, g, y, v, b, _) : n(m, g, E, y, v, b, _);
    if (!(y & l)) {
      var N = C && h.call(m, "__wrapped__"), A = R && h.call(g, "__wrapped__");
      if (N || A) {
        var O = N ? m.value() : m, k = A ? g.value() : g;
        return _ || (_ = new t()), b(O, k, y, v, _);
      }
    }
    return P ? (_ || (_ = new t()), r(m, g, y, v, b, _)) : !1;
  }
  return eP = p, eP;
}
var tP, yee;
function DO() {
  if (yee) return tP;
  yee = 1;
  var t = ivt(), e = us();
  function n(r, o, i, s, a) {
    return r === o ? !0 : r == null || o == null || !e(r) && !e(o) ? r !== r && o !== o : t(r, o, i, s, n, a);
  }
  return tP = n, tP;
}
var nP, vee;
function svt() {
  if (vee) return nP;
  vee = 1;
  var t = DO();
  function e(n, r, o) {
    o = typeof o == "function" ? o : void 0;
    var i = o ? o(n, r) : void 0;
    return i === void 0 ? t(n, r, void 0, o) : !!i;
  }
  return nP = e, nP;
}
var avt = svt();
const lvt = /* @__PURE__ */ Kt(avt);
function p1e(t, e) {
  return lvt(t, e, (n, r) => {
    if (typeof n == "function" && typeof r == "function")
      return !0;
  });
}
var rP, bee;
function Fp() {
  if (bee) return rP;
  bee = 1;
  var t = Yl(), e = us(), n = "[object Symbol]";
  function r(o) {
    return typeof o == "symbol" || e(o) && t(o) == n;
  }
  return rP = r, rP;
}
var oP, _ee;
function A6() {
  if (_ee) return oP;
  _ee = 1;
  var t = Wr(), e = Fp(), n = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, r = /^\w*$/;
  function o(i, s) {
    if (t(i))
      return !1;
    var a = typeof i;
    return a == "number" || a == "symbol" || a == "boolean" || i == null || e(i) ? !0 : r.test(i) || !n.test(i) || s != null && i in Object(s);
  }
  return oP = o, oP;
}
var iP, wee;
function cvt() {
  if (wee) return iP;
  wee = 1;
  var t = x6(), e = "Expected a function";
  function n(r, o) {
    if (typeof r != "function" || o != null && typeof o != "function")
      throw new TypeError(e);
    var i = function() {
      var s = arguments, a = o ? o.apply(this, s) : s[0], l = i.cache;
      if (l.has(a))
        return l.get(a);
      var c = r.apply(this, s);
      return i.cache = l.set(a, c) || l, c;
    };
    return i.cache = new (n.Cache || t)(), i;
  }
  return n.Cache = t, iP = n, iP;
}
var sP, xee;
function uvt() {
  if (xee) return sP;
  xee = 1;
  var t = cvt(), e = 500;
  function n(r) {
    var o = t(r, function(s) {
      return i.size === e && i.clear(), s;
    }), i = o.cache;
    return o;
  }
  return sP = n, sP;
}
var aP, Eee;
function m1e() {
  if (Eee) return aP;
  Eee = 1;
  var t = uvt(), e = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, n = /\\(\\)?/g, r = t(function(o) {
    var i = [];
    return o.charCodeAt(0) === 46 && i.push(""), o.replace(e, function(s, a, l, c) {
      i.push(l ? c.replace(n, "$1") : a || s);
    }), i;
  });
  return aP = r, aP;
}
var lP, See;
function Kl() {
  if (See) return lP;
  See = 1;
  function t(e, n) {
    for (var r = -1, o = e == null ? 0 : e.length, i = Array(o); ++r < o; )
      i[r] = n(e[r], r, e);
    return i;
  }
  return lP = t, lP;
}
var cP, Oee;
function dvt() {
  if (Oee) return cP;
  Oee = 1;
  var t = Ip(), e = Kl(), n = Wr(), r = Fp(), o = 1 / 0, i = t ? t.prototype : void 0, s = i ? i.toString : void 0;
  function a(l) {
    if (typeof l == "string")
      return l;
    if (n(l))
      return e(l, a) + "";
    if (r(l))
      return s ? s.call(l) : "";
    var c = l + "";
    return c == "0" && 1 / l == -o ? "-0" : c;
  }
  return cP = a, cP;
}
var uP, Cee;
function g1e() {
  if (Cee) return uP;
  Cee = 1;
  var t = dvt();
  function e(n) {
    return n == null ? "" : t(n);
  }
  return uP = e, uP;
}
var dP, kee;
function Vv() {
  if (kee) return dP;
  kee = 1;
  var t = Wr(), e = A6(), n = m1e(), r = g1e();
  function o(i, s) {
    return t(i) ? i : e(i, s) ? [i] : n(r(i));
  }
  return dP = o, dP;
}
var fP, Aee;
function nf() {
  if (Aee) return fP;
  Aee = 1;
  var t = Fp(), e = 1 / 0;
  function n(r) {
    if (typeof r == "string" || t(r))
      return r;
    var o = r + "";
    return o == "0" && 1 / r == -e ? "-0" : o;
  }
  return fP = n, fP;
}
var hP, Tee;
function IO() {
  if (Tee) return hP;
  Tee = 1;
  var t = Vv(), e = nf();
  function n(r, o) {
    o = t(o, r);
    for (var i = 0, s = o.length; r != null && i < s; )
      r = r[e(o[i++])];
    return i && i == s ? r : void 0;
  }
  return hP = n, hP;
}
var pP, Ree;
function y1e() {
  if (Ree) return pP;
  Ree = 1;
  var t = IO();
  function e(n, r, o) {
    var i = n == null ? void 0 : t(n, r);
    return i === void 0 ? o : i;
  }
  return pP = e, pP;
}
var fvt = y1e();
const nr = /* @__PURE__ */ Kt(fvt);
var mP, Pee;
function hvt() {
  if (Pee) return mP;
  Pee = 1;
  var t = d1e(), e = Hv(), n = zv(), r = Wr(), o = tf(), i = Lp(), s = MO(), a = qv(), l = "[object Map]", c = "[object Set]", u = Object.prototype, d = u.hasOwnProperty;
  function f(h) {
    if (h == null)
      return !0;
    if (o(h) && (r(h) || typeof h == "string" || typeof h.splice == "function" || i(h) || a(h) || n(h)))
      return !h.length;
    var p = e(h);
    if (p == l || p == c)
      return !h.size;
    if (s(h))
      return !t(h).length;
    for (var m in h)
      if (d.call(h, m))
        return !1;
    return !0;
  }
  return mP = f, mP;
}
var pvt = hvt();
const zy = /* @__PURE__ */ Kt(pvt);
var $m = {}, $ee;
function mvt() {
  if ($ee) return $m;
  $ee = 1;
  var t = /~/, e = /~[01]/g;
  function n(c) {
    switch (c) {
      case "~1":
        return "/";
      case "~0":
        return "~";
    }
    throw new Error("Invalid tilde escape: " + c);
  }
  function r(c) {
    return t.test(c) ? c.replace(e, n) : c;
  }
  function o(c, u, d) {
    for (var f, h, p = 1, m = u.length; p < m; ) {
      if (u[p] === "constructor" || u[p] === "prototype" || u[p] === "__proto__") return c;
      if (f = r(u[p++]), h = m > p, typeof c[f] > "u" && (Array.isArray(c) && f === "-" && (f = c.length), h && (u[p] !== "" && u[p] < 1 / 0 || u[p] === "-" ? c[f] = [] : c[f] = {})), !h) break;
      c = c[f];
    }
    var g = c[f];
    return d === void 0 ? delete c[f] : c[f] = d, g;
  }
  function i(c) {
    if (typeof c == "string") {
      if (c = c.split("/"), c[0] === "") return c;
      throw new Error("Invalid JSON pointer.");
    } else if (Array.isArray(c)) {
      for (const u of c)
        if (typeof u != "string" && typeof u != "number")
          throw new Error("Invalid JSON pointer. Must be of type string or number.");
      return c;
    }
    throw new Error("Invalid JSON pointer.");
  }
  function s(c, u) {
    if (typeof c != "object") throw new Error("Invalid input object.");
    u = i(u);
    var d = u.length;
    if (d === 1) return c;
    for (var f = 1; f < d; ) {
      if (c = c[r(u[f++])], d === f) return c;
      if (typeof c != "object" || c === null) return;
    }
  }
  function a(c, u, d) {
    if (typeof c != "object") throw new Error("Invalid input object.");
    if (u = i(u), u.length === 0) throw new Error("Invalid JSON pointer for set.");
    return o(c, u, d);
  }
  function l(c) {
    var u = i(c);
    return {
      get: function(d) {
        return s(d, u);
      },
      set: function(d, f) {
        return a(d, u, f);
      }
    };
  }
  return $m.get = s, $m.set = a, $m.compile = l, $m;
}
var gvt = mvt();
const yvt = /* @__PURE__ */ Kt(gvt);
var gP, Mee;
function T6() {
  if (Mee) return gP;
  Mee = 1;
  function t(e, n) {
    for (var r = -1, o = e == null ? 0 : e.length; ++r < o && n(e[r], r, e) !== !1; )
      ;
    return e;
  }
  return gP = t, gP;
}
var yP, Dee;
function v1e() {
  if (Dee) return yP;
  Dee = 1;
  var t = Jd(), e = function() {
    try {
      var n = t(Object, "defineProperty");
      return n({}, "", {}), n;
    } catch {
    }
  }();
  return yP = e, yP;
}
var vP, Iee;
function R6() {
  if (Iee) return vP;
  Iee = 1;
  var t = v1e();
  function e(n, r, o) {
    r == "__proto__" && t ? t(n, r, {
      configurable: !0,
      enumerable: !0,
      value: o,
      writable: !0
    }) : n[r] = o;
  }
  return vP = e, vP;
}
var bP, Nee;
function P6() {
  if (Nee) return bP;
  Nee = 1;
  var t = R6(), e = jp(), n = Object.prototype, r = n.hasOwnProperty;
  function o(i, s, a) {
    var l = i[s];
    (!(r.call(i, s) && e(l, a)) || a === void 0 && !(s in i)) && t(i, s, a);
  }
  return bP = o, bP;
}
var _P, jee;
function Bp() {
  if (jee) return _P;
  jee = 1;
  var t = P6(), e = R6();
  function n(r, o, i, s) {
    var a = !i;
    i || (i = {});
    for (var l = -1, c = o.length; ++l < c; ) {
      var u = o[l], d = s ? s(i[u], r[u], u, i, r) : void 0;
      d === void 0 && (d = r[u]), a ? e(i, u, d) : t(i, u, d);
    }
    return i;
  }
  return _P = n, _P;
}
var wP, Lee;
function vvt() {
  if (Lee) return wP;
  Lee = 1;
  var t = Bp(), e = Uv();
  function n(r, o) {
    return r && t(o, e(o), r);
  }
  return wP = n, wP;
}
var xP, Fee;
function bvt() {
  if (Fee) return xP;
  Fee = 1;
  function t(e) {
    var n = [];
    if (e != null)
      for (var r in Object(e))
        n.push(r);
    return n;
  }
  return xP = t, xP;
}
var EP, Bee;
function _vt() {
  if (Bee) return EP;
  Bee = 1;
  var t = ni(), e = MO(), n = bvt(), r = Object.prototype, o = r.hasOwnProperty;
  function i(s) {
    if (!t(s))
      return n(s);
    var a = e(s), l = [];
    for (var c in s)
      c == "constructor" && (a || !o.call(s, c)) || l.push(c);
    return l;
  }
  return EP = i, EP;
}
var SP, zee;
function zp() {
  if (zee) return SP;
  zee = 1;
  var t = u1e(), e = _vt(), n = tf();
  function r(o) {
    return n(o) ? t(o, !0) : e(o);
  }
  return SP = r, SP;
}
var OP, qee;
function wvt() {
  if (qee) return OP;
  qee = 1;
  var t = Bp(), e = zp();
  function n(r, o) {
    return r && t(o, e(o), r);
  }
  return OP = n, OP;
}
var Dg = { exports: {} };
Dg.exports;
var Uee;
function b1e() {
  return Uee || (Uee = 1, function(t, e) {
    var n = Na(), r = e && !e.nodeType && e, o = r && !0 && t && !t.nodeType && t, i = o && o.exports === r, s = i ? n.Buffer : void 0, a = s ? s.allocUnsafe : void 0;
    function l(c, u) {
      if (u)
        return c.slice();
      var d = c.length, f = a ? a(d) : new c.constructor(d);
      return c.copy(f), f;
    }
    t.exports = l;
  }(Dg, Dg.exports)), Dg.exports;
}
var CP, Hee;
function NO() {
  if (Hee) return CP;
  Hee = 1;
  function t(e, n) {
    var r = -1, o = e.length;
    for (n || (n = Array(o)); ++r < o; )
      n[r] = e[r];
    return n;
  }
  return CP = t, CP;
}
var kP, Vee;
function xvt() {
  if (Vee) return kP;
  Vee = 1;
  var t = Bp(), e = O6();
  function n(r, o) {
    return t(r, e(r), o);
  }
  return kP = n, kP;
}
var AP, Wee;
function _1e() {
  if (Wee) return AP;
  Wee = 1;
  var t = S6(), e = EO(), n = O6(), r = l1e(), o = Object.getOwnPropertySymbols, i = o ? function(s) {
    for (var a = []; s; )
      t(a, n(s)), s = e(s);
    return a;
  } : r;
  return AP = i, AP;
}
var TP, Gee;
function Evt() {
  if (Gee) return TP;
  Gee = 1;
  var t = Bp(), e = _1e();
  function n(r, o) {
    return t(r, e(r), o);
  }
  return TP = n, TP;
}
var RP, Yee;
function w1e() {
  if (Yee) return RP;
  Yee = 1;
  var t = a1e(), e = _1e(), n = zp();
  function r(o) {
    return t(o, n, e);
  }
  return RP = r, RP;
}
var PP, Kee;
function Svt() {
  if (Kee) return PP;
  Kee = 1;
  var t = Object.prototype, e = t.hasOwnProperty;
  function n(r) {
    var o = r.length, i = new r.constructor(o);
    return o && typeof r[0] == "string" && e.call(r, "index") && (i.index = r.index, i.input = r.input), i;
  }
  return PP = n, PP;
}
var $P, Xee;
function $6() {
  if (Xee) return $P;
  Xee = 1;
  var t = s1e();
  function e(n) {
    var r = new n.constructor(n.byteLength);
    return new t(r).set(new t(n)), r;
  }
  return $P = e, $P;
}
var MP, Qee;
function Ovt() {
  if (Qee) return MP;
  Qee = 1;
  var t = $6();
  function e(n, r) {
    var o = r ? t(n.buffer) : n.buffer;
    return new n.constructor(o, n.byteOffset, n.byteLength);
  }
  return MP = e, MP;
}
var DP, Zee;
function Cvt() {
  if (Zee) return DP;
  Zee = 1;
  var t = /\w*$/;
  function e(n) {
    var r = new n.constructor(n.source, t.exec(n));
    return r.lastIndex = n.lastIndex, r;
  }
  return DP = e, DP;
}
var IP, Jee;
function kvt() {
  if (Jee) return IP;
  Jee = 1;
  var t = Ip(), e = t ? t.prototype : void 0, n = e ? e.valueOf : void 0;
  function r(o) {
    return n ? Object(n.call(o)) : {};
  }
  return IP = r, IP;
}
var NP, ete;
function x1e() {
  if (ete) return NP;
  ete = 1;
  var t = $6();
  function e(n, r) {
    var o = r ? t(n.buffer) : n.buffer;
    return new n.constructor(o, n.byteOffset, n.length);
  }
  return NP = e, NP;
}
var jP, tte;
function Avt() {
  if (tte) return jP;
  tte = 1;
  var t = $6(), e = Ovt(), n = Cvt(), r = kvt(), o = x1e(), i = "[object Boolean]", s = "[object Date]", a = "[object Map]", l = "[object Number]", c = "[object RegExp]", u = "[object Set]", d = "[object String]", f = "[object Symbol]", h = "[object ArrayBuffer]", p = "[object DataView]", m = "[object Float32Array]", g = "[object Float64Array]", y = "[object Int8Array]", v = "[object Int16Array]", b = "[object Int32Array]", _ = "[object Uint8Array]", w = "[object Uint8ClampedArray]", x = "[object Uint16Array]", E = "[object Uint32Array]";
  function S(C, R, P) {
    var N = C.constructor;
    switch (R) {
      case h:
        return t(C);
      case i:
      case s:
        return new N(+C);
      case p:
        return e(C, P);
      case m:
      case g:
      case y:
      case v:
      case b:
      case _:
      case w:
      case x:
      case E:
        return o(C, P);
      case a:
        return new N();
      case l:
      case d:
        return new N(C);
      case c:
        return n(C);
      case u:
        return new N();
      case f:
        return r(C);
    }
  }
  return jP = S, jP;
}
var LP, nte;
function E1e() {
  if (nte) return LP;
  nte = 1;
  var t = ni(), e = Object.create, n = /* @__PURE__ */ function() {
    function r() {
    }
    return function(o) {
      if (!t(o))
        return {};
      if (e)
        return e(o);
      r.prototype = o;
      var i = new r();
      return r.prototype = void 0, i;
    };
  }();
  return LP = n, LP;
}
var FP, rte;
function S1e() {
  if (rte) return FP;
  rte = 1;
  var t = E1e(), e = EO(), n = MO();
  function r(o) {
    return typeof o.constructor == "function" && !n(o) ? t(e(o)) : {};
  }
  return FP = r, FP;
}
var BP, ote;
function Tvt() {
  if (ote) return BP;
  ote = 1;
  var t = Hv(), e = us(), n = "[object Map]";
  function r(o) {
    return e(o) && t(o) == n;
  }
  return BP = r, BP;
}
var zP, ite;
function Rvt() {
  if (ite) return zP;
  ite = 1;
  var t = Tvt(), e = ef(), n = k6(), r = n && n.isMap, o = r ? e(r) : t;
  return zP = o, zP;
}
var qP, ste;
function Pvt() {
  if (ste) return qP;
  ste = 1;
  var t = Hv(), e = us(), n = "[object Set]";
  function r(o) {
    return e(o) && t(o) == n;
  }
  return qP = r, qP;
}
var UP, ate;
function $vt() {
  if (ate) return UP;
  ate = 1;
  var t = Pvt(), e = ef(), n = k6(), r = n && n.isSet, o = r ? e(r) : t;
  return UP = o, UP;
}
var HP, lte;
function O1e() {
  if (lte) return HP;
  lte = 1;
  var t = TO(), e = T6(), n = P6(), r = vvt(), o = wvt(), i = b1e(), s = NO(), a = xvt(), l = Evt(), c = f1e(), u = w1e(), d = Hv(), f = Svt(), h = Avt(), p = S1e(), m = Wr(), g = Lp(), y = Rvt(), v = ni(), b = $vt(), _ = Uv(), w = zp(), x = 1, E = 2, S = 4, C = "[object Arguments]", R = "[object Array]", P = "[object Boolean]", N = "[object Date]", A = "[object Error]", O = "[object Function]", k = "[object GeneratorFunction]", T = "[object Map]", I = "[object Number]", j = "[object Object]", z = "[object RegExp]", $ = "[object Set]", D = "[object String]", U = "[object Symbol]", q = "[object WeakMap]", F = "[object ArrayBuffer]", B = "[object DataView]", H = "[object Float32Array]", Z = "[object Float64Array]", W = "[object Int8Array]", G = "[object Int16Array]", ee = "[object Int32Array]", Y = "[object Uint8Array]", L = "[object Uint8ClampedArray]", V = "[object Uint16Array]", K = "[object Uint32Array]", ne = {};
  ne[C] = ne[R] = ne[F] = ne[B] = ne[P] = ne[N] = ne[H] = ne[Z] = ne[W] = ne[G] = ne[ee] = ne[T] = ne[I] = ne[j] = ne[z] = ne[$] = ne[D] = ne[U] = ne[Y] = ne[L] = ne[V] = ne[K] = !0, ne[A] = ne[O] = ne[q] = !1;
  function ce(fe, ve, _e, Ee, Me, Le) {
    var Ce, Je = ve & x, Ie = ve & E, nt = ve & S;
    if (_e && (Ce = Me ? _e(fe, Ee, Me, Le) : _e(fe)), Ce !== void 0)
      return Ce;
    if (!v(fe))
      return fe;
    var ct = m(fe);
    if (ct) {
      if (Ce = f(fe), !Je)
        return s(fe, Ce);
    } else {
      var mt = d(fe), gt = mt == O || mt == k;
      if (g(fe))
        return i(fe, Je);
      if (mt == j || mt == C || gt && !Me) {
        if (Ce = Ie || gt ? {} : p(fe), !Je)
          return Ie ? l(fe, o(Ce, fe)) : a(fe, r(Ce, fe));
      } else {
        if (!ne[mt])
          return Me ? fe : {};
        Ce = h(fe, mt, Je);
      }
    }
    Le || (Le = new t());
    var Et = Le.get(fe);
    if (Et)
      return Et;
    Le.set(fe, Ce), b(fe) ? fe.forEach(function(At) {
      Ce.add(ce(At, ve, _e, At, fe, Le));
    }) : y(fe) && fe.forEach(function(At, X) {
      Ce.set(X, ce(At, ve, _e, X, fe, Le));
    });
    var Rt = nt ? Ie ? u : c : Ie ? w : _, zt = ct ? void 0 : Rt(fe);
    return e(zt || fe, function(At, X) {
      zt && (X = At, At = fe[X]), n(Ce, X, ce(At, ve, _e, X, fe, Le));
    }), Ce;
  }
  return HP = ce, HP;
}
var VP, cte;
function C1e() {
  if (cte) return VP;
  cte = 1;
  function t(e) {
    var n = e == null ? 0 : e.length;
    return n ? e[n - 1] : void 0;
  }
  return VP = t, VP;
}
var WP, ute;
function Mvt() {
  if (ute) return WP;
  ute = 1;
  function t(e, n, r) {
    var o = -1, i = e.length;
    n < 0 && (n = -n > i ? 0 : i + n), r = r > i ? i : r, r < 0 && (r += i), i = n > r ? 0 : r - n >>> 0, n >>>= 0;
    for (var s = Array(i); ++o < i; )
      s[o] = e[o + n];
    return s;
  }
  return WP = t, WP;
}
var GP, dte;
function Dvt() {
  if (dte) return GP;
  dte = 1;
  var t = IO(), e = Mvt();
  function n(r, o) {
    return o.length < 2 ? r : t(r, e(o, 0, -1));
  }
  return GP = n, GP;
}
var YP, fte;
function Ivt() {
  if (fte) return YP;
  fte = 1;
  var t = Vv(), e = C1e(), n = Dvt(), r = nf();
  function o(i, s) {
    return s = t(s, i), i = n(i, s), i == null || delete i[r(e(s))];
  }
  return YP = o, YP;
}
var KP, hte;
function Nvt() {
  if (hte) return KP;
  hte = 1;
  var t = Np();
  function e(n) {
    return t(n) ? void 0 : n;
  }
  return KP = e, KP;
}
var XP, pte;
function jvt() {
  if (pte) return XP;
  pte = 1;
  var t = Ip(), e = zv(), n = Wr(), r = t ? t.isConcatSpreadable : void 0;
  function o(i) {
    return n(i) || e(i) || !!(r && i && i[r]);
  }
  return XP = o, XP;
}
var QP, mte;
function jO() {
  if (mte) return QP;
  mte = 1;
  var t = S6(), e = jvt();
  function n(r, o, i, s, a) {
    var l = -1, c = r.length;
    for (i || (i = e), a || (a = []); ++l < c; ) {
      var u = r[l];
      o > 0 && i(u) ? o > 1 ? n(u, o - 1, i, s, a) : t(a, u) : s || (a[a.length] = u);
    }
    return a;
  }
  return QP = n, QP;
}
var ZP, gte;
function M6() {
  if (gte) return ZP;
  gte = 1;
  var t = jO();
  function e(n) {
    var r = n == null ? 0 : n.length;
    return r ? t(n, 1) : [];
  }
  return ZP = e, ZP;
}
var JP, yte;
function k1e() {
  if (yte) return JP;
  yte = 1;
  function t(e, n, r) {
    switch (r.length) {
      case 0:
        return e.call(n);
      case 1:
        return e.call(n, r[0]);
      case 2:
        return e.call(n, r[0], r[1]);
      case 3:
        return e.call(n, r[0], r[1], r[2]);
    }
    return e.apply(n, r);
  }
  return JP = t, JP;
}
var e$, vte;
function A1e() {
  if (vte) return e$;
  vte = 1;
  var t = k1e(), e = Math.max;
  function n(r, o, i) {
    return o = e(o === void 0 ? r.length - 1 : o, 0), function() {
      for (var s = arguments, a = -1, l = e(s.length - o, 0), c = Array(l); ++a < l; )
        c[a] = s[o + a];
      a = -1;
      for (var u = Array(o + 1); ++a < o; )
        u[a] = s[a];
      return u[o] = i(c), t(r, this, u);
    };
  }
  return e$ = n, e$;
}
var t$, bte;
function Lvt() {
  if (bte) return t$;
  bte = 1;
  function t(e) {
    return function() {
      return e;
    };
  }
  return t$ = t, t$;
}
var n$, _te;
function Wv() {
  if (_te) return n$;
  _te = 1;
  function t(e) {
    return e;
  }
  return n$ = t, n$;
}
var r$, wte;
function Fvt() {
  if (wte) return r$;
  wte = 1;
  var t = Lvt(), e = v1e(), n = Wv(), r = e ? function(o, i) {
    return e(o, "toString", {
      configurable: !0,
      enumerable: !1,
      value: t(i),
      writable: !0
    });
  } : n;
  return r$ = r, r$;
}
var o$, xte;
function Bvt() {
  if (xte) return o$;
  xte = 1;
  var t = 800, e = 16, n = Date.now;
  function r(o) {
    var i = 0, s = 0;
    return function() {
      var a = n(), l = e - (a - s);
      if (s = a, l > 0) {
        if (++i >= t)
          return arguments[0];
      } else
        i = 0;
      return o.apply(void 0, arguments);
    };
  }
  return o$ = r, o$;
}
var i$, Ete;
function T1e() {
  if (Ete) return i$;
  Ete = 1;
  var t = Fvt(), e = Bvt(), n = e(t);
  return i$ = n, i$;
}
var s$, Ste;
function zvt() {
  if (Ste) return s$;
  Ste = 1;
  var t = M6(), e = A1e(), n = T1e();
  function r(o) {
    return n(e(o, void 0, t), o + "");
  }
  return s$ = r, s$;
}
var a$, Ote;
function qvt() {
  if (Ote) return a$;
  Ote = 1;
  var t = Kl(), e = O1e(), n = Ivt(), r = Vv(), o = Bp(), i = Nvt(), s = zvt(), a = w1e(), l = 1, c = 2, u = 4, d = s(function(f, h) {
    var p = {};
    if (f == null)
      return p;
    var m = !1;
    h = t(h, function(y) {
      return y = r(y, f), m || (m = y.length > 1), y;
    }), o(f, a(f), p), m && (p = e(p, l | c | u, i));
    for (var g = h.length; g--; )
      n(p, h[g]);
    return p;
  });
  return a$ = d, a$;
}
var Uvt = qvt();
const Hvt = /* @__PURE__ */ Kt(Uvt);
function D6(t, e) {
  const n = e[t];
  return [Hvt(e, [t]), n];
}
function R1e(t, e = {}, n = []) {
  const r = t || "";
  let o;
  if (r.startsWith("#"))
    o = decodeURIComponent(r.substring(1));
  else
    throw new Error(`Could not find a definition for ${t}.`);
  const i = yvt.get(e, o);
  if (i === void 0)
    throw new Error(`Could not find a definition for ${t}.`);
  const s = i[Ca];
  if (s) {
    if (n.includes(s)) {
      if (n.length === 1)
        throw new Error(`Definition for ${t} is a circular reference`);
      const [u, ...d] = n, f = [...d, r, u].join(" -> ");
      throw new Error(`Definition for ${u} contains a circular reference through ${f}`);
    }
    const [a, l] = D6(Ca, i), c = R1e(l, e, [...n, r]);
    return Object.keys(a).length > 0 ? { ...a, ...c } : c;
  }
  return i;
}
function P1e(t, e = {}) {
  return R1e(t, e, []);
}
var l$, Cte;
function Vvt() {
  if (Cte) return l$;
  Cte = 1;
  var t = Object.prototype, e = t.hasOwnProperty;
  function n(r, o) {
    return r != null && e.call(r, o);
  }
  return l$ = n, l$;
}
var c$, kte;
function $1e() {
  if (kte) return c$;
  kte = 1;
  var t = Vv(), e = zv(), n = Wr(), r = $O(), o = C6(), i = nf();
  function s(a, l, c) {
    l = t(l, a);
    for (var u = -1, d = l.length, f = !1; ++u < d; ) {
      var h = i(l[u]);
      if (!(f = a != null && c(a, h)))
        break;
      a = a[h];
    }
    return f || ++u != d ? f : (d = a == null ? 0 : a.length, !!d && o(d) && r(h, d) && (n(a) || e(a)));
  }
  return c$ = s, c$;
}
var u$, Ate;
function Wvt() {
  if (Ate) return u$;
  Ate = 1;
  var t = Vvt(), e = $1e();
  function n(r, o) {
    return r != null && e(r, o, t);
  }
  return u$ = n, u$;
}
var Gvt = Wvt();
const Ig = /* @__PURE__ */ Kt(Gvt);
var d$, Tte;
function Yvt() {
  if (Tte) return d$;
  Tte = 1;
  var t = Yl(), e = us(), n = "[object Number]";
  function r(o) {
    return typeof o == "number" || e(o) && t(o) == n;
  }
  return d$ = r, d$;
}
var Kvt = Yvt();
const M1e = /* @__PURE__ */ Kt(Kvt);
var Xvt = ni();
const I6 = /* @__PURE__ */ Kt(Xvt);
var f$, Rte;
function Qvt() {
  if (Rte) return f$;
  Rte = 1;
  var t = Yl(), e = Wr(), n = us(), r = "[object String]";
  function o(i) {
    return typeof i == "string" || !e(i) && n(i) && t(i) == r;
  }
  return f$ = o, f$;
}
var Zvt = Qvt();
const D1e = /* @__PURE__ */ Kt(Zvt);
var h$, Pte;
function Jvt() {
  if (Pte) return h$;
  Pte = 1;
  function t(e, n, r, o) {
    var i = -1, s = e == null ? 0 : e.length;
    for (o && s && (r = e[++i]); ++i < s; )
      r = n(r, e[i], i, e);
    return r;
  }
  return h$ = t, h$;
}
var p$, $te;
function ebt() {
  if ($te) return p$;
  $te = 1;
  function t(e) {
    return function(n, r, o) {
      for (var i = -1, s = Object(n), a = o(n), l = a.length; l--; ) {
        var c = a[e ? l : ++i];
        if (r(s[c], c, s) === !1)
          break;
      }
      return n;
    };
  }
  return p$ = t, p$;
}
var m$, Mte;
function I1e() {
  if (Mte) return m$;
  Mte = 1;
  var t = ebt(), e = t();
  return m$ = e, m$;
}
var g$, Dte;
function N1e() {
  if (Dte) return g$;
  Dte = 1;
  var t = I1e(), e = Uv();
  function n(r, o) {
    return r && t(r, o, e);
  }
  return g$ = n, g$;
}
var y$, Ite;
function tbt() {
  if (Ite) return y$;
  Ite = 1;
  var t = tf();
  function e(n, r) {
    return function(o, i) {
      if (o == null)
        return o;
      if (!t(o))
        return n(o, i);
      for (var s = o.length, a = r ? s : -1, l = Object(o); (r ? a-- : ++a < s) && i(l[a], a, l) !== !1; )
        ;
      return o;
    };
  }
  return y$ = e, y$;
}
var v$, Nte;
function N6() {
  if (Nte) return v$;
  Nte = 1;
  var t = N1e(), e = tbt(), n = e(t);
  return v$ = n, v$;
}
var b$, jte;
function nbt() {
  if (jte) return b$;
  jte = 1;
  var t = TO(), e = DO(), n = 1, r = 2;
  function o(i, s, a, l) {
    var c = a.length, u = c, d = !l;
    if (i == null)
      return !u;
    for (i = Object(i); c--; ) {
      var f = a[c];
      if (d && f[2] ? f[1] !== i[f[0]] : !(f[0] in i))
        return !1;
    }
    for (; ++c < u; ) {
      f = a[c];
      var h = f[0], p = i[h], m = f[1];
      if (d && f[2]) {
        if (p === void 0 && !(h in i))
          return !1;
      } else {
        var g = new t();
        if (l)
          var y = l(p, m, h, i, s, g);
        if (!(y === void 0 ? e(m, p, n | r, l, g) : y))
          return !1;
      }
    }
    return !0;
  }
  return b$ = o, b$;
}
var _$, Lte;
function j1e() {
  if (Lte) return _$;
  Lte = 1;
  var t = ni();
  function e(n) {
    return n === n && !t(n);
  }
  return _$ = e, _$;
}
var w$, Fte;
function rbt() {
  if (Fte) return w$;
  Fte = 1;
  var t = j1e(), e = Uv();
  function n(r) {
    for (var o = e(r), i = o.length; i--; ) {
      var s = o[i], a = r[s];
      o[i] = [s, a, t(a)];
    }
    return o;
  }
  return w$ = n, w$;
}
var x$, Bte;
function L1e() {
  if (Bte) return x$;
  Bte = 1;
  function t(e, n) {
    return function(r) {
      return r == null ? !1 : r[e] === n && (n !== void 0 || e in Object(r));
    };
  }
  return x$ = t, x$;
}
var E$, zte;
function obt() {
  if (zte) return E$;
  zte = 1;
  var t = nbt(), e = rbt(), n = L1e();
  function r(o) {
    var i = e(o);
    return i.length == 1 && i[0][2] ? n(i[0][0], i[0][1]) : function(s) {
      return s === o || t(s, o, i);
    };
  }
  return E$ = r, E$;
}
var S$, qte;
function ibt() {
  if (qte) return S$;
  qte = 1;
  function t(e, n) {
    return e != null && n in Object(e);
  }
  return S$ = t, S$;
}
var O$, Ute;
function sbt() {
  if (Ute) return O$;
  Ute = 1;
  var t = ibt(), e = $1e();
  function n(r, o) {
    return r != null && e(r, o, t);
  }
  return O$ = n, O$;
}
var C$, Hte;
function abt() {
  if (Hte) return C$;
  Hte = 1;
  var t = DO(), e = y1e(), n = sbt(), r = A6(), o = j1e(), i = L1e(), s = nf(), a = 1, l = 2;
  function c(u, d) {
    return r(u) && o(d) ? i(s(u), d) : function(f) {
      var h = e(f, u);
      return h === void 0 && h === d ? n(f, u) : t(d, h, a | l);
    };
  }
  return C$ = c, C$;
}
var k$, Vte;
function lbt() {
  if (Vte) return k$;
  Vte = 1;
  function t(e) {
    return function(n) {
      return n?.[e];
    };
  }
  return k$ = t, k$;
}
var A$, Wte;
function cbt() {
  if (Wte) return A$;
  Wte = 1;
  var t = IO();
  function e(n) {
    return function(r) {
      return t(r, n);
    };
  }
  return A$ = e, A$;
}
var T$, Gte;
function ubt() {
  if (Gte) return T$;
  Gte = 1;
  var t = lbt(), e = cbt(), n = A6(), r = nf();
  function o(i) {
    return n(i) ? t(r(i)) : e(i);
  }
  return T$ = o, T$;
}
var R$, Yte;
function j6() {
  if (Yte) return R$;
  Yte = 1;
  var t = obt(), e = abt(), n = Wv(), r = Wr(), o = ubt();
  function i(s) {
    return typeof s == "function" ? s : s == null ? n : typeof s == "object" ? r(s) ? e(s[0], s[1]) : t(s) : o(s);
  }
  return R$ = i, R$;
}
var P$, Kte;
function dbt() {
  if (Kte) return P$;
  Kte = 1;
  function t(e, n, r, o, i) {
    return i(e, function(s, a, l) {
      r = o ? (o = !1, s) : n(r, s, a, l);
    }), r;
  }
  return P$ = t, P$;
}
var $$, Xte;
function fbt() {
  if (Xte) return $$;
  Xte = 1;
  var t = Jvt(), e = N6(), n = j6(), r = dbt(), o = Wr();
  function i(s, a, l) {
    var c = o(s) ? t : r, u = arguments.length < 3;
    return c(s, n(a, 4), l, u, e);
  }
  return $$ = i, $$;
}
var hbt = fbt();
const pbt = /* @__PURE__ */ Kt(hbt);
var M$, Qte;
function F1e() {
  if (Qte) return M$;
  Qte = 1;
  var t = Wv();
  function e(n) {
    return typeof n == "function" ? n : t;
  }
  return M$ = e, M$;
}
var D$, Zte;
function mbt() {
  if (Zte) return D$;
  Zte = 1;
  var t = /\s/;
  function e(n) {
    for (var r = n.length; r-- && t.test(n.charAt(r)); )
      ;
    return r;
  }
  return D$ = e, D$;
}
var I$, Jte;
function gbt() {
  if (Jte) return I$;
  Jte = 1;
  var t = mbt(), e = /^\s+/;
  function n(r) {
    return r && r.slice(0, t(r) + 1).replace(e, "");
  }
  return I$ = n, I$;
}
var N$, ene;
function ybt() {
  if (ene) return N$;
  ene = 1;
  var t = gbt(), e = ni(), n = Fp(), r = NaN, o = /^[-+]0x[0-9a-f]+$/i, i = /^0b[01]+$/i, s = /^0o[0-7]+$/i, a = parseInt;
  function l(c) {
    if (typeof c == "number")
      return c;
    if (n(c))
      return r;
    if (e(c)) {
      var u = typeof c.valueOf == "function" ? c.valueOf() : c;
      c = e(u) ? u + "" : u;
    }
    if (typeof c != "string")
      return c === 0 ? c : +c;
    c = t(c);
    var d = i.test(c);
    return d || s.test(c) ? a(c.slice(2), d ? 2 : 8) : o.test(c) ? r : +c;
  }
  return N$ = l, N$;
}
var j$, tne;
function vbt() {
  if (tne) return j$;
  tne = 1;
  var t = ybt(), e = 1 / 0, n = 17976931348623157e292;
  function r(o) {
    if (!o)
      return o === 0 ? o : 0;
    if (o = t(o), o === e || o === -e) {
      var i = o < 0 ? -1 : 1;
      return i * n;
    }
    return o === o ? o : 0;
  }
  return j$ = r, j$;
}
var L$, nne;
function bbt() {
  if (nne) return L$;
  nne = 1;
  var t = vbt();
  function e(n) {
    var r = t(n), o = r % 1;
    return r === r ? o ? r - o : r : 0;
  }
  return L$ = e, L$;
}
var F$, rne;
function _bt() {
  if (rne) return F$;
  rne = 1;
  var t = c1e(), e = F1e(), n = bbt(), r = 9007199254740991, o = 4294967295, i = Math.min;
  function s(a, l) {
    if (a = n(a), a < 1 || a > r)
      return [];
    var c = o, u = i(a, o);
    l = e(l), a -= o;
    for (var d = t(u, l); ++c < a; )
      l(c);
    return d;
  }
  return F$ = s, F$;
}
var wbt = _bt();
const B1e = /* @__PURE__ */ Kt(wbt);
function z1e(t, e, n) {
  var r;
  if (t && n) {
    const o = nr(t, n);
    if (o === void 0)
      return;
    for (let i = 0; i < e.length; i++) {
      const s = e[i], a = nr(s, [ha, n], {});
      if (!(a.type === "object" || a.type === "array") && (a.const === o || !((r = a.enum) === null || r === void 0) && r.includes(o)))
        return i;
    }
  }
}
function xbt(t, e, n, r, o) {
  if (e === void 0)
    return 0;
  const i = z1e(e, n, o);
  if (M1e(i))
    return i;
  for (let s = 0; s < n.length; s++) {
    const a = n[s];
    if (o && Ig(a, [ha, o])) {
      const l = nr(e, o), c = nr(a, [ha, o], {});
      if (t.isValid(c, l, r))
        return s;
    } else if (a[ha]) {
      const l = {
        anyOf: Object.keys(a[ha]).map((u) => ({
          required: [u]
        }))
      };
      let c;
      if (a.anyOf) {
        const { ...u } = a;
        u.allOf ? u.allOf = u.allOf.slice() : u.allOf = [], u.allOf.push(l), c = u;
      } else
        c = Object.assign({}, a, l);
      if (delete c.required, t.isValid(c, e, r))
        return s;
    } else if (t.isValid(a, e, r))
      return s;
  }
  return 0;
}
function q1e(t, e, n, r, o) {
  return xbt(t, e, n, r, o);
}
var B$, one;
function L6() {
  if (one) return B$;
  one = 1;
  var t = DO();
  function e(n, r) {
    return t(n, r);
  }
  return B$ = e, B$;
}
var Ebt = L6();
const Sbt = /* @__PURE__ */ Kt(Ebt);
var z$, ine;
function U1e() {
  if (ine) return z$;
  ine = 1;
  var t = P6(), e = Vv(), n = $O(), r = ni(), o = nf();
  function i(s, a, l, c) {
    if (!r(s))
      return s;
    a = e(a, s);
    for (var u = -1, d = a.length, f = d - 1, h = s; h != null && ++u < d; ) {
      var p = o(a[u]), m = l;
      if (p === "__proto__" || p === "constructor" || p === "prototype")
        return s;
      if (u != f) {
        var g = h[p];
        m = c ? c(g, p, h) : void 0, m === void 0 && (m = r(g) ? g : n(a[u + 1]) ? [] : {});
      }
      t(h, p, m), h = h[p];
    }
    return s;
  }
  return z$ = i, z$;
}
var q$, sne;
function Obt() {
  if (sne) return q$;
  sne = 1;
  var t = U1e();
  function e(n, r, o) {
    return n == null ? n : t(n, r, o);
  }
  return q$ = e, q$;
}
var Cbt = Obt();
const y3 = /* @__PURE__ */ Kt(Cbt);
var U$, ane;
function kbt() {
  if (ane) return U$;
  ane = 1;
  var t = T6(), e = E1e(), n = N1e(), r = j6(), o = EO(), i = Wr(), s = Lp(), a = CO(), l = ni(), c = qv();
  function u(d, f, h) {
    var p = i(d), m = p || s(d) || c(d);
    if (f = r(f, 4), h == null) {
      var g = d && d.constructor;
      m ? h = p ? new g() : [] : l(d) ? h = a(g) ? e(o(d)) : {} : h = {};
    }
    return (m ? t : n)(d, function(y, v, b) {
      return f(h, y, v, b);
    }), h;
  }
  return U$ = u, U$;
}
var Abt = kbt();
const Tbt = /* @__PURE__ */ Kt(Abt);
var H$, lne;
function H1e() {
  if (lne) return H$;
  lne = 1;
  var t = R6(), e = jp();
  function n(r, o, i) {
    (i !== void 0 && !e(r[o], i) || i === void 0 && !(o in r)) && t(r, o, i);
  }
  return H$ = n, H$;
}
var V$, cne;
function LO() {
  if (cne) return V$;
  cne = 1;
  var t = tf(), e = us();
  function n(r) {
    return e(r) && t(r);
  }
  return V$ = n, V$;
}
var W$, une;
function V1e() {
  if (une) return W$;
  une = 1;
  function t(e, n) {
    if (!(n === "constructor" && typeof e[n] == "function") && n != "__proto__")
      return e[n];
  }
  return W$ = t, W$;
}
var G$, dne;
function Rbt() {
  if (dne) return G$;
  dne = 1;
  var t = Bp(), e = zp();
  function n(r) {
    return t(r, e(r));
  }
  return G$ = n, G$;
}
var Y$, fne;
function Pbt() {
  if (fne) return Y$;
  fne = 1;
  var t = H1e(), e = b1e(), n = x1e(), r = NO(), o = S1e(), i = zv(), s = Wr(), a = LO(), l = Lp(), c = CO(), u = ni(), d = Np(), f = qv(), h = V1e(), p = Rbt();
  function m(g, y, v, b, _, w, x) {
    var E = h(g, v), S = h(y, v), C = x.get(S);
    if (C) {
      t(g, v, C);
      return;
    }
    var R = w ? w(E, S, v + "", g, y, x) : void 0, P = R === void 0;
    if (P) {
      var N = s(S), A = !N && l(S), O = !N && !A && f(S);
      R = S, N || A || O ? s(E) ? R = E : a(E) ? R = r(E) : A ? (P = !1, R = e(S, !0)) : O ? (P = !1, R = n(S, !0)) : R = [] : d(S) || i(S) ? (R = E, i(E) ? R = p(E) : (!u(E) || c(E)) && (R = o(S))) : P = !1;
    }
    P && (x.set(S, R), _(R, S, b, w, x), x.delete(S)), t(g, v, R);
  }
  return Y$ = m, Y$;
}
var K$, hne;
function F6() {
  if (hne) return K$;
  hne = 1;
  var t = TO(), e = H1e(), n = I1e(), r = Pbt(), o = ni(), i = zp(), s = V1e();
  function a(l, c, u, d, f) {
    l !== c && n(c, function(h, p) {
      if (f || (f = new t()), o(h))
        r(l, c, p, u, a, d, f);
      else {
        var m = d ? d(s(l, p), h, p + "", l, c, f) : void 0;
        m === void 0 && (m = h), e(l, p, m);
      }
    }, i);
  }
  return K$ = a, K$;
}
var X$, pne;
function du() {
  if (pne) return X$;
  pne = 1;
  var t = Wv(), e = A1e(), n = T1e();
  function r(o, i) {
    return n(e(o, i, t), o + "");
  }
  return X$ = r, X$;
}
var Q$, mne;
function B6() {
  if (mne) return Q$;
  mne = 1;
  var t = jp(), e = tf(), n = $O(), r = ni();
  function o(i, s, a) {
    if (!r(a))
      return !1;
    var l = typeof s;
    return (l == "number" ? e(a) && n(s, a.length) : l == "string" && s in a) ? t(a[s], i) : !1;
  }
  return Q$ = o, Q$;
}
var Z$, gne;
function W1e() {
  if (gne) return Z$;
  gne = 1;
  var t = du(), e = B6();
  function n(r) {
    return t(function(o, i) {
      var s = -1, a = i.length, l = a > 1 ? i[a - 1] : void 0, c = a > 2 ? i[2] : void 0;
      for (l = r.length > 3 && typeof l == "function" ? (a--, l) : void 0, c && e(i[0], i[1], c) && (l = a < 3 ? void 0 : l, a = 1), o = Object(o); ++s < a; ) {
        var u = i[s];
        u && r(o, u, s, l);
      }
      return o;
    });
  }
  return Z$ = n, Z$;
}
var J$, yne;
function $bt() {
  if (yne) return J$;
  yne = 1;
  var t = F6(), e = W1e(), n = e(function(r, o, i) {
    t(r, o, i);
  });
  return J$ = n, J$;
}
var Mbt = $bt();
const Dbt = /* @__PURE__ */ Kt(Mbt);
var eM, vne;
function z6() {
  if (vne) return eM;
  vne = 1;
  var t = jO(), e = 1 / 0;
  function n(r) {
    var o = r == null ? 0 : r.length;
    return o ? t(r, e) : [];
  }
  return eM = n, eM;
}
var Ibt = z6();
const Nbt = /* @__PURE__ */ Kt(Ibt);
var tM, bne;
function jbt() {
  if (bne) return tM;
  bne = 1;
  function t(e, n, r, o) {
    for (var i = e.length, s = r + (o ? 1 : -1); o ? s-- : ++s < i; )
      if (n(e[s], s, e))
        return s;
    return -1;
  }
  return tM = t, tM;
}
var nM, _ne;
function Lbt() {
  if (_ne) return nM;
  _ne = 1;
  function t(e) {
    return e !== e;
  }
  return nM = t, nM;
}
var rM, wne;
function Fbt() {
  if (wne) return rM;
  wne = 1;
  function t(e, n, r) {
    for (var o = r - 1, i = e.length; ++o < i; )
      if (e[o] === n)
        return o;
    return -1;
  }
  return rM = t, rM;
}
var oM, xne;
function G1e() {
  if (xne) return oM;
  xne = 1;
  var t = jbt(), e = Lbt(), n = Fbt();
  function r(o, i, s) {
    return i === i ? n(o, i, s) : t(o, e, s);
  }
  return oM = r, oM;
}
var iM, Ene;
function q6() {
  if (Ene) return iM;
  Ene = 1;
  var t = G1e();
  function e(n, r) {
    var o = n == null ? 0 : n.length;
    return !!o && t(n, r, 0) > -1;
  }
  return iM = e, iM;
}
var sM, Sne;
function U6() {
  if (Sne) return sM;
  Sne = 1;
  function t(e, n, r) {
    for (var o = -1, i = e == null ? 0 : e.length; ++o < i; )
      if (r(n, e[o]))
        return !0;
    return !1;
  }
  return sM = t, sM;
}
var aM, One;
function Bbt() {
  if (One) return aM;
  One = 1;
  function t() {
  }
  return aM = t, aM;
}
var lM, Cne;
function zbt() {
  if (Cne) return lM;
  Cne = 1;
  var t = h1e(), e = Bbt(), n = E6(), r = 1 / 0, o = t && 1 / n(new t([, -0]))[1] == r ? function(i) {
    return new t(i);
  } : e;
  return lM = o, lM;
}
var cM, kne;
function H6() {
  if (kne) return cM;
  kne = 1;
  var t = RO(), e = q6(), n = U6(), r = PO(), o = zbt(), i = E6(), s = 200;
  function a(l, c, u) {
    var d = -1, f = e, h = l.length, p = !0, m = [], g = m;
    if (u)
      p = !1, f = n;
    else if (h >= s) {
      var y = c ? null : o(l);
      if (y)
        return i(y);
      p = !1, f = r, g = new t();
    } else
      g = c ? [] : m;
    e:
      for (; ++d < h; ) {
        var v = l[d], b = c ? c(v) : v;
        if (v = u || v !== 0 ? v : 0, p && b === b) {
          for (var _ = g.length; _--; )
            if (g[_] === b)
              continue e;
          c && g.push(b), m.push(v);
        } else f(g, b, u) || (g !== m && g.push(b), m.push(v));
      }
    return m;
  }
  return cM = a, cM;
}
var uM, Ane;
function FO() {
  if (Ane) return uM;
  Ane = 1;
  var t = H6();
  function e(n) {
    return n && n.length ? t(n) : [];
  }
  return uM = e, uM;
}
var qbt = FO();
const Ubt = /* @__PURE__ */ Kt(qbt);
var dM, Tne;
function Y1e() {
  if (Tne) return dM;
  Tne = 1;
  var t = O1e(), e = 1, n = 4;
  function r(o) {
    return t(o, e | n);
  }
  return dM = r, dM;
}
var fM, Rne;
function Hbt() {
  if (Rne) return fM;
  Rne = 1;
  var t = N6(), e = tf();
  function n(r, o) {
    var i = -1, s = e(r) ? Array(r.length) : [];
    return t(r, function(a, l, c) {
      s[++i] = o(a, l, c);
    }), s;
  }
  return fM = n, fM;
}
var hM, Pne;
function Vbt() {
  if (Pne) return hM;
  Pne = 1;
  function t(e, n) {
    var r = e.length;
    for (e.sort(n); r--; )
      e[r] = e[r].value;
    return e;
  }
  return hM = t, hM;
}
var pM, $ne;
function Wbt() {
  if ($ne) return pM;
  $ne = 1;
  var t = Fp();
  function e(n, r) {
    if (n !== r) {
      var o = n !== void 0, i = n === null, s = n === n, a = t(n), l = r !== void 0, c = r === null, u = r === r, d = t(r);
      if (!c && !d && !a && n > r || a && l && u && !c && !d || i && l && u || !o && u || !s)
        return 1;
      if (!i && !a && !d && n < r || d && o && s && !i && !a || c && o && s || !l && s || !u)
        return -1;
    }
    return 0;
  }
  return pM = e, pM;
}
var mM, Mne;
function Gbt() {
  if (Mne) return mM;
  Mne = 1;
  var t = Wbt();
  function e(n, r, o) {
    for (var i = -1, s = n.criteria, a = r.criteria, l = s.length, c = o.length; ++i < l; ) {
      var u = t(s[i], a[i]);
      if (u) {
        if (i >= c)
          return u;
        var d = o[i];
        return u * (d == "desc" ? -1 : 1);
      }
    }
    return n.index - r.index;
  }
  return mM = e, mM;
}
var gM, Dne;
function Ybt() {
  if (Dne) return gM;
  Dne = 1;
  var t = Kl(), e = IO(), n = j6(), r = Hbt(), o = Vbt(), i = ef(), s = Gbt(), a = Wv(), l = Wr();
  function c(u, d, f) {
    d.length ? d = t(d, function(m) {
      return l(m) ? function(g) {
        return e(g, m.length === 1 ? m[0] : m);
      } : m;
    }) : d = [a];
    var h = -1;
    d = t(d, i(n));
    var p = r(u, function(m, g, y) {
      var v = t(d, function(b) {
        return b(m);
      });
      return { criteria: v, index: ++h, value: m };
    });
    return o(p, function(m, g) {
      return s(m, g, f);
    });
  }
  return gM = c, gM;
}
var yM, Ine;
function K1e() {
  if (Ine) return yM;
  Ine = 1;
  var t = jO(), e = Ybt(), n = du(), r = B6(), o = n(function(i, s) {
    if (i == null)
      return [];
    var a = s.length;
    return a > 1 && r(i, s[0], s[1]) ? s = [] : a > 2 && r(s[0], s[1], s[2]) && (s = [s[0]]), e(i, t(s, 1), []);
  });
  return yM = o, yM;
}
var vM, Nne;
function V6() {
  if (Nne) return vM;
  Nne = 1;
  var t = H6();
  function e(n, r) {
    return r = typeof r == "function" ? r : void 0, n && n.length ? t(n, void 0, r) : [];
  }
  return vM = e, vM;
}
var bM, jne;
function Kbt() {
  if (jne) return bM;
  jne = 1;
  var t = du(), e = jp(), n = B6(), r = zp(), o = Object.prototype, i = o.hasOwnProperty, s = t(function(a, l) {
    a = Object(a);
    var c = -1, u = l.length, d = u > 2 ? l[2] : void 0;
    for (d && n(l[0], l[1], d) && (u = 1); ++c < u; )
      for (var f = l[c], h = r(f), p = -1, m = h.length; ++p < m; ) {
        var g = h[p], y = a[g];
        (y === void 0 || e(y, o[g]) && !i.call(a, g)) && (a[g] = f[g]);
      }
    return a;
  });
  return bM = s, bM;
}
var _M, Lne;
function X1e() {
  if (Lne) return _M;
  Lne = 1;
  var t = RO(), e = q6(), n = U6(), r = Kl(), o = ef(), i = PO(), s = Math.min;
  function a(l, c, u) {
    for (var d = u ? n : e, f = l[0].length, h = l.length, p = h, m = Array(h), g = 1 / 0, y = []; p--; ) {
      var v = l[p];
      p && c && (v = r(v, o(c))), g = s(v.length, g), m[p] = !u && (c || f >= 120 && v.length >= 120) ? new t(p && v) : void 0;
    }
    v = l[0];
    var b = -1, _ = m[0];
    e:
      for (; ++b < f && y.length < g; ) {
        var w = v[b], x = c ? c(w) : w;
        if (w = u || w !== 0 ? w : 0, !(_ ? i(_, x) : d(y, x, u))) {
          for (p = h; --p; ) {
            var E = m[p];
            if (!(E ? i(E, x) : d(l[p], x, u)))
              continue e;
          }
          _ && _.push(x), y.push(w);
        }
      }
    return y;
  }
  return _M = a, _M;
}
var wM, Fne;
function Q1e() {
  if (Fne) return wM;
  Fne = 1;
  var t = LO();
  function e(n) {
    return t(n) ? n : [];
  }
  return wM = e, wM;
}
var xM, Bne;
function Z1e() {
  if (Bne) return xM;
  Bne = 1;
  var t = Kl(), e = X1e(), n = du(), r = Q1e(), o = C1e(), i = n(function(s) {
    var a = o(s), l = t(s, r);
    return a = typeof a == "function" ? a : void 0, a && l.pop(), l.length && l[0] === s[0] ? e(l, void 0, a) : [];
  });
  return xM = i, xM;
}
var EM, zne;
function Xbt() {
  if (zne) return EM;
  zne = 1;
  var t = Yl(), e = us(), n = "[object Boolean]";
  function r(o) {
    return o === !0 || o === !1 || e(o) && t(o) == n;
  }
  return EM = r, EM;
}
var SM, qne;
function W6() {
  if (qne) return SM;
  qne = 1;
  var t = L6(), e = K1e(), n = FO(), r = V6(), o = Kbt(), i = Z1e(), s = Np(), a = Xbt(), l = (A) => Array.isArray(A) ? A : [A], c = (A) => A === void 0, u = (A) => s(A) || Array.isArray(A) ? Object.keys(A) : [], d = (A, O) => A.hasOwnProperty(O), f = (A) => e(n(A)), h = (A) => c(A) || Array.isArray(A) && A.length === 0, p = (A, O, k, T) => O && d(O, k) && A && d(A, k) && T(A[k], O[k]), m = (A, O) => c(A) && O === 0 || c(O) && A === 0 || t(A, O), g = (A, O) => c(A) && O === !1 || c(O) && A === !1 || t(A, O), y = (A) => c(A) || t(A, {}) || A === !0, v = (A) => c(A) || t(A, {}), b = (A) => c(A) || s(A) || A === !0 || A === !1;
  function _(A, O) {
    return h(A) && h(O) ? !0 : t(f(A), f(O));
  }
  function w(A, O) {
    return A = l(A), O = l(O), t(f(A), f(O));
  }
  function x(A, O, k, T) {
    var I = n(u(A).concat(u(O)));
    return v(A) && v(O) ? !0 : v(A) && u(O).length || v(O) && u(A).length ? !1 : I.every(function(j) {
      var z = A[j], $ = O[j];
      return Array.isArray(z) && Array.isArray($) ? t(f(A), f(O)) : Array.isArray(z) && !Array.isArray($) || Array.isArray($) && !Array.isArray(z) ? !1 : p(A, O, j, T);
    });
  }
  function E(A, O, k, T) {
    return s(A) && s(O) ? T(A, O) : Array.isArray(A) && Array.isArray(O) ? x(A, O, k, T) : t(A, O);
  }
  function S(A, O, k, T) {
    var I = r(A, T), j = r(O, T), z = i(I, j, T);
    return z.length === Math.max(I.length, j.length);
  }
  var C = {
    title: t,
    uniqueItems: g,
    minLength: m,
    minItems: m,
    minProperties: m,
    required: _,
    enum: _,
    type: w,
    items: E,
    anyOf: S,
    allOf: S,
    oneOf: S,
    properties: x,
    patternProperties: x,
    dependencies: x
  }, R = [
    "properties",
    "patternProperties",
    "dependencies",
    "uniqueItems",
    "minLength",
    "minItems",
    "minProperties",
    "required"
  ], P = ["additionalProperties", "additionalItems", "contains", "propertyNames", "not"];
  function N(A, O, k) {
    if (k = o(k, {
      ignore: []
    }), y(A) && y(O))
      return !0;
    if (!b(A) || !b(O))
      throw new Error("Either of the values are not a JSON schema.");
    if (A === O)
      return !0;
    if (a(A) && a(O))
      return A === O;
    if (A === void 0 && O === !1 || O === void 0 && A === !1 || c(A) && !c(O) || !c(A) && c(O))
      return !1;
    var T = n(Object.keys(A).concat(Object.keys(O)));
    if (k.ignore.length && (T = T.filter((j) => k.ignore.indexOf(j) === -1)), !T.length)
      return !0;
    function I(j, z) {
      return N(j, z, k);
    }
    return T.every(function(j) {
      var z = A[j], $ = O[j];
      if (P.indexOf(j) !== -1)
        return N(z, $, k);
      var D = C[j];
      if (D || (D = t), t(z, $))
        return !0;
      if (R.indexOf(j) === -1 && (!d(A, j) && d(O, j) || d(A, j) && !d(O, j)))
        return z === $;
      var U = D(z, $, j, I);
      if (!a(U))
        throw new Error("Comparer must return true or false");
      return U;
    });
  }
  return SM = N, SM;
}
var OM, Une;
function G6() {
  if (Une) return OM;
  Une = 1;
  function t(e) {
    return Object.prototype.toString.call(e) === "[object Array]";
  }
  return OM = Array.isArray || t, OM;
}
var CM, Hne;
function Qbt() {
  if (Hne) return CM;
  Hne = 1;
  function t(e) {
    return (typeof e == "number" || Object.prototype.toString.call(e) === "[object Number]") && e.valueOf() === e.valueOf();
  }
  return CM = t, CM;
}
var kM, Vne;
function Zbt() {
  if (Vne) return kM;
  Vne = 1;
  var t = Qbt();
  function e(n) {
    return t(n) && n % 1 === 0;
  }
  return kM = e, kM;
}
var AM, Wne;
function J1e() {
  if (Wne) return AM;
  Wne = 1;
  var t = G6(), e = Zbt();
  function n(r) {
    var o;
    if (!t(r) || (o = r.length, !o))
      return !1;
    for (var i = 0; i < o; i++)
      if (!e(r[i]))
        return !1;
    return !0;
  }
  return AM = n, AM;
}
var TM, Gne;
function e_e() {
  if (Gne) return TM;
  Gne = 1;
  function t(e) {
    return typeof e == "function";
  }
  return TM = t, TM;
}
var RM, Yne;
function Jbt() {
  if (Yne) return RM;
  Yne = 1;
  var t = G6(), e = J1e(), n = e_e(), r = Math.pow(2, 31) - 1;
  function o(a, l) {
    var c = 1, u;
    if (a === 0)
      return l;
    if (l === 0)
      return a;
    for (; a % 2 === 0 && l % 2 === 0; )
      a = a / 2, l = l / 2, c = c * 2;
    for (; a % 2 === 0; )
      a = a / 2;
    for (; l; ) {
      for (; l % 2 === 0; )
        l = l / 2;
      a > l && (u = l, l = a, a = u), l = l - a;
    }
    return c * a;
  }
  function i(a, l) {
    var c = 0, u;
    if (a === 0)
      return l;
    if (l === 0)
      return a;
    for (; (a & 1) === 0 && (l & 1) === 0; )
      a >>>= 1, l >>>= 1, c++;
    for (; (a & 1) === 0; )
      a >>>= 1;
    for (; l; ) {
      for (; (l & 1) === 0; )
        l >>>= 1;
      a > l && (u = l, l = a, a = u), l = l - a;
    }
    return a << c;
  }
  function s() {
    var a = arguments.length, l, c, u, d, f, h, p;
    for (l = new Array(a), p = 0; p < a; p++)
      l[p] = arguments[p];
    if (e(l)) {
      if (a === 2)
        return f = l[0], h = l[1], f < 0 && (f = -f), h < 0 && (h = -h), f <= r && h <= r ? i(f, h) : o(f, h);
      u = l;
    } else if (t(l[0]))
      if (a > 1) {
        if (u = l[0], c = l[1], !n(c))
          throw new TypeError("gcd()::invalid input argument. Accessor must be a function. Value: `" + c + "`.");
      } else
        u = l[0];
    else throw new TypeError("gcd()::invalid input argument. Must provide an array of integers. Value: `" + l[0] + "`.");
    if (d = u.length, d < 2)
      return null;
    if (c) {
      for (f = new Array(d), p = 0; p < d; p++)
        f[p] = c(u[p], p);
      u = f;
    }
    if (a < 3 && !e(u))
      throw new TypeError("gcd()::invalid input argument. Accessed array values must be integers. Value: `" + u + "`.");
    for (p = 0; p < d; p++)
      f = u[p], f < 0 && (u[p] = -f);
    for (f = u[0], p = 1; p < d; p++)
      h = u[p], h <= r && f <= r ? f = i(f, h) : f = o(f, h);
    return f;
  }
  return RM = s, RM;
}
var PM, Kne;
function e1t() {
  if (Kne) return PM;
  Kne = 1;
  var t = Jbt(), e = G6(), n = J1e(), r = e_e();
  function o() {
    var i = arguments.length, s, a, l, c, u, d, f;
    for (s = new Array(i), f = 0; f < i; f++)
      s[f] = arguments[f];
    if (n(s)) {
      if (i === 2)
        return u = s[0], d = s[1], u < 0 && (u = -u), d < 0 && (d = -d), u === 0 || d === 0 ? 0 : u / t(u, d) * d;
      l = s;
    } else if (e(s[0]))
      if (i > 1) {
        if (l = s[0], a = s[1], !r(a))
          throw new TypeError("lcm()::invalid input argument. Accessor must be a function. Value: `" + a + "`.");
      } else
        l = s[0];
    else throw new TypeError("lcm()::invalid input argument. Must provide an array of integers. Value: `" + s[0] + "`.");
    if (c = l.length, c < 2)
      return null;
    if (a) {
      for (u = new Array(c), f = 0; f < c; f++)
        u[f] = a(l[f], f);
      l = u;
    }
    if (i < 3 && !n(l))
      throw new TypeError("lcm()::invalid input argument. Accessed array values must be integers. Value: `" + l + "`.");
    for (f = 0; f < c; f++)
      u = l[f], u < 0 && (l[f] = -u);
    for (u = l[0], f = 1; f < c; f++) {
      if (d = l[f], u === 0 || d === 0)
        return 0;
      u = u / t(u, d) * d;
    }
    return u;
  }
  return PM = o, PM;
}
var $M, Xne;
function t1t() {
  if (Xne) return $M;
  Xne = 1;
  var t = F6(), e = ni();
  function n(r, o, i, s, a, l) {
    return e(r) && e(o) && (l.set(o, r), t(r, o, void 0, n, l), l.delete(o)), r;
  }
  return $M = n, $M;
}
var MM, Qne;
function n1t() {
  if (Qne) return MM;
  Qne = 1;
  var t = F6(), e = W1e(), n = e(function(r, o, i, s) {
    t(r, o, i, s);
  });
  return MM = n, MM;
}
var DM, Zne;
function r1t() {
  if (Zne) return DM;
  Zne = 1;
  var t = k1e(), e = du(), n = t1t(), r = n1t(), o = e(function(i) {
    return i.push(void 0, n), t(r, void 0, i);
  });
  return DM = o, DM;
}
var IM, Jne;
function o1t() {
  if (Jne) return IM;
  Jne = 1;
  var t = Kl(), e = X1e(), n = du(), r = Q1e(), o = n(function(i) {
    var s = t(i, r);
    return s.length && s[0] === i[0] ? e(s) : [];
  });
  return IM = o, IM;
}
var NM, ere;
function i1t() {
  if (ere) return NM;
  ere = 1;
  function t(e, n, r, o) {
    for (var i = r - 1, s = e.length; ++i < s; )
      if (o(e[i], n))
        return i;
    return -1;
  }
  return NM = t, NM;
}
var jM, tre;
function s1t() {
  if (tre) return jM;
  tre = 1;
  var t = Kl(), e = G1e(), n = i1t(), r = ef(), o = NO(), i = Array.prototype, s = i.splice;
  function a(l, c, u, d) {
    var f = d ? n : e, h = -1, p = c.length, m = l;
    for (l === c && (c = o(c)), u && (m = t(l, r(u))); ++h < p; )
      for (var g = 0, y = c[h], v = u ? u(y) : y; (g = f(m, v, g, d)) > -1; )
        m !== l && s.call(m, g, 1), s.call(l, g, 1);
    return l;
  }
  return jM = a, jM;
}
var LM, nre;
function a1t() {
  if (nre) return LM;
  nre = 1;
  var t = s1t();
  function e(n, r) {
    return n && n.length && r && r.length ? t(n, r) : n;
  }
  return LM = e, LM;
}
var FM, rre;
function Y6() {
  if (rre) return FM;
  rre = 1;
  var t = T6(), e = N6(), n = F1e(), r = Wr();
  function o(i, s) {
    var a = r(i) ? t : e;
    return a(i, n(s));
  }
  return FM = o, FM;
}
var BM, ore;
function l1t() {
  if (ore) return BM;
  ore = 1;
  var t = RO(), e = q6(), n = U6(), r = Kl(), o = ef(), i = PO(), s = 200;
  function a(l, c, u, d) {
    var f = -1, h = e, p = !0, m = l.length, g = [], y = c.length;
    if (!m)
      return g;
    u && (c = r(c, o(u))), d ? (h = n, p = !1) : c.length >= s && (h = i, p = !1, c = new t(c));
    e:
      for (; ++f < m; ) {
        var v = l[f], b = u == null ? v : u(v);
        if (v = d || v !== 0 ? v : 0, p && b === b) {
          for (var _ = y; _--; )
            if (c[_] === b)
              continue e;
          g.push(v);
        } else h(c, b, d) || g.push(v);
      }
    return g;
  }
  return BM = a, BM;
}
var zM, ire;
function c1t() {
  if (ire) return zM;
  ire = 1;
  var t = l1t(), e = du(), n = LO(), r = e(function(o, i) {
    return n(o) ? t(o, i) : [];
  });
  return zM = r, zM;
}
var qM, sre;
function t_e() {
  if (sre) return qM;
  sre = 1;
  const t = M6(), e = z6(), n = Np(), r = FO(), o = V6(), i = c1t();
  function s(m) {
    for (const g in m)
      c(m, g) && h(m[g]) && delete m[g];
    return m;
  }
  const a = (m) => r(e(m.map(u))), l = (m, g) => m.map((y) => y && y[g]), c = (m, g) => Object.prototype.hasOwnProperty.call(m, g), u = (m) => n(m) || Array.isArray(m) ? Object.keys(m) : [], d = (m) => m !== void 0, f = (m) => n(m) || m === !0 || m === !1, h = (m) => !u(m).length && m !== !1 && m !== !0;
  return qM = {
    allUniqueKeys: a,
    deleteUndefinedProps: s,
    getValues: l,
    has: c,
    isEmptySchema: h,
    isSchema: f,
    keys: u,
    notUndefined: d,
    uniqWith: o,
    withoutArr: (m, ...g) => i.apply(null, [m].concat(t(g)))
  }, qM;
}
var UM, are;
function u1t() {
  if (are) return UM;
  are = 1;
  const t = W6(), e = Y6(), {
    allUniqueKeys: n,
    deleteUndefinedProps: r,
    getValues: o,
    keys: i,
    notUndefined: s,
    uniqWith: a,
    withoutArr: l
  } = t_e();
  function c(d) {
    e(d, function(f, h) {
      f === !1 && delete d[h];
    });
  }
  function u(d, f) {
    return n(d).reduce(function(p, m) {
      const g = o(d, m), y = a(g.filter(s), t);
      return p[m] = f(y, m), p;
    }, {});
  }
  return UM = {
    keywords: ["properties", "patternProperties", "additionalProperties"],
    resolver(d, f, h, p) {
      p.ignoreAdditionalProperties || (d.forEach(function(g) {
        const y = d.filter((w) => w !== g), v = i(g.properties), _ = i(g.patternProperties).map((w) => new RegExp(w));
        y.forEach(function(w) {
          const x = i(w.properties), E = x.filter((C) => _.some((R) => R.test(C)));
          l(x, v, E).forEach(function(C) {
            w.properties[C] = h.properties([
              w.properties[C],
              g.additionalProperties
            ], C);
          });
        });
      }), d.forEach(function(g) {
        const y = d.filter((b) => b !== g), v = i(g.patternProperties);
        g.additionalProperties === !1 && y.forEach(function(b) {
          const _ = i(b.patternProperties);
          l(_, v).forEach((x) => delete b.patternProperties[x]);
        });
      }));
      const m = {
        additionalProperties: h.additionalProperties(d.map((g) => g.additionalProperties)),
        patternProperties: u(d.map((g) => g.patternProperties), h.patternProperties),
        properties: u(d.map((g) => g.properties), h.properties)
      };
      return m.additionalProperties === !1 && c(m.properties), r(m);
    }
  }, UM;
}
var HM, lre;
function d1t() {
  if (lre) return HM;
  lre = 1;
  const t = W6(), e = Y6(), {
    allUniqueKeys: n,
    deleteUndefinedProps: r,
    has: o,
    isSchema: i,
    notUndefined: s,
    uniqWith: a
  } = t_e();
  function l(f) {
    e(f, function(h, p) {
      h === !1 && f.splice(p, 1);
    });
  }
  function c(f, h) {
    return f.map(function(p) {
      if (p)
        if (Array.isArray(p.items)) {
          const m = p.items[h];
          if (i(m))
            return m;
          if (o(p, "additionalItems"))
            return p.additionalItems;
        } else
          return p.items;
    });
  }
  function u(f) {
    return f.map(function(h) {
      if (h)
        return Array.isArray(h.items) ? h.additionalItems : h.items;
    });
  }
  function d(f, h, p) {
    return n(p).reduce(function(g, y) {
      const v = c(f, y), b = a(v.filter(s), t);
      return g[y] = h(b, y), g;
    }, []);
  }
  return HM = {
    keywords: ["items", "additionalItems"],
    resolver(f, h, p) {
      const m = f.map((b) => b.items), g = m.filter(s), y = {};
      g.every(i) ? y.items = p.items(m) : y.items = d(f, p.items, m);
      let v;
      return g.every(Array.isArray) ? v = f.map((b) => b.additionalItems) : g.some(Array.isArray) && (v = u(f)), v && (y.additionalItems = p.additionalItems(v)), y.additionalItems === !1 && Array.isArray(y.items) && l(y.items), r(y);
    }
  }, HM;
}
var VM, cre;
function f1t() {
  if (cre) return VM;
  cre = 1;
  const t = Y1e(), e = W6(), n = e1t(), r = r1t(), o = M6(), i = z6(), s = o1t(), a = Z1e(), l = L6(), c = Np(), u = a1t(), d = K1e(), f = FO(), h = V6(), p = u1t(), m = d1t(), g = (G, ee) => G.indexOf(ee) !== -1, y = (G) => c(G) || G === !0 || G === !1, v = (G) => G === !1, b = (G) => G === !0, _ = (G, ee, Y) => Y(G), w = (G) => d(f(i(G))), x = (G) => G !== void 0, E = (G) => f(i(G.map(j))), S = (G) => G[0], C = (G) => w(G), R = (G) => Math.max.apply(Math, G), P = (G) => Math.min.apply(Math, G), N = (G) => G.some(b), A = (G) => h(o(G), l);
  function O(G) {
    return function(ee, Y) {
      return e({
        [G]: ee
      }, { [G]: Y });
    };
  }
  function k(G) {
    let { allOf: ee = [], ...Y } = G;
    return Y = c(G) ? Y : G, [Y, ...ee.map(k)];
  }
  function T(G, ee) {
    return G.map((Y) => Y && Y[ee]);
  }
  function I(G, ee) {
    return G.map(function(Y, L) {
      try {
        return ee(Y, L);
      } catch {
        return;
      }
    }).filter(x);
  }
  function j(G) {
    return c(G) || Array.isArray(G) ? Object.keys(G) : [];
  }
  function z(G, ee) {
    if (ee = ee || [], !G.length)
      return ee;
    const Y = G.slice(0).shift(), L = G.slice(1);
    return ee.length ? z(L, o(ee.map((V) => Y.map((K) => [K].concat(V))))) : z(L, Y.map((V) => V));
  }
  function $(G, ee) {
    let Y;
    try {
      Y = G.map(function(L) {
        return JSON.stringify(L, null, 2);
      }).join(`
`);
    } catch {
      Y = G.join(", ");
    }
    throw new Error('Could not resolve values for path:"' + ee.join(".") + `". They are probably incompatible. Values: 
` + Y);
  }
  function D(G, ee, Y, L, V, K) {
    if (G.length) {
      const ne = V.complexResolvers[ee];
      if (!ne || !ne.resolver)
        throw new Error("No resolver found for " + ee);
      const ce = Y.map((Ee) => G.reduce((Me, Le) => (Ee[Le] !== void 0 && (Me[Le] = Ee[Le]), Me), {})), fe = h(ce, e), ve = ne.keywords.reduce((Ee, Me) => ({
        ...Ee,
        [Me]: (Le, Ce = []) => L(Le, null, K.concat(Me, Ce))
      }), {}), _e = ne.resolver(fe, K.concat(ee), ve, V);
      return c(_e) || $(fe, K.concat(ee)), _e;
    }
  }
  function U(G) {
    return { required: G };
  }
  const q = ["properties", "patternProperties", "definitions", "dependencies"], F = ["anyOf", "oneOf"], B = [
    "additionalProperties",
    "additionalItems",
    "contains",
    "propertyNames",
    "not",
    "items"
  ], H = {
    type(G) {
      if (G.some(Array.isArray)) {
        const ee = G.map(function(L) {
          return Array.isArray(L) ? L : [L];
        }), Y = s.apply(null, ee);
        if (Y.length === 1)
          return Y[0];
        if (Y.length > 1)
          return f(Y);
      }
    },
    dependencies(G, ee, Y) {
      return E(G).reduce(function(V, K) {
        const ne = T(G, K);
        let ce = h(ne.filter(x), l);
        const fe = ce.filter(Array.isArray);
        if (fe.length) {
          if (fe.length === ce.length)
            V[K] = w(ce);
          else {
            const ve = ce.filter(y), _e = fe.map(U);
            V[K] = Y(ve.concat(_e), K);
          }
          return V;
        }
        return ce = h(ce, e), V[K] = Y(ce, K), V;
      }, {});
    },
    oneOf(G, ee, Y) {
      const L = z(t(G)), V = I(L, Y), K = h(V, e);
      if (K.length)
        return K;
    },
    not(G) {
      return { anyOf: G };
    },
    pattern(G) {
      return G.map((ee) => "(?=" + ee + ")").join("");
    },
    multipleOf(G) {
      let ee = G.slice(0), Y = 1;
      for (; ee.some((L) => !Number.isInteger(L)); )
        ee = ee.map((L) => L * 10), Y = Y * 10;
      return n(ee) / Y;
    },
    enum(G) {
      const ee = a.apply(null, G.concat(l));
      if (ee.length)
        return d(ee);
    }
  };
  H.$id = S, H.$ref = S, H.$schema = S, H.additionalItems = _, H.additionalProperties = _, H.anyOf = H.oneOf, H.contains = _, H.default = S, H.definitions = H.dependencies, H.description = S, H.examples = A, H.exclusiveMaximum = P, H.exclusiveMinimum = R, H.items = m, H.maximum = P, H.maxItems = P, H.maxLength = P, H.maxProperties = P, H.minimum = R, H.minItems = R, H.minLength = R, H.minProperties = R, H.properties = p, H.propertyNames = _, H.required = C, H.title = S, H.uniqueItems = N;
  const Z = {
    properties: p,
    items: m
  };
  function W(G, ee, Y) {
    ee = r(ee, {
      ignoreAdditionalProperties: !1,
      resolvers: H,
      complexResolvers: Z,
      deep: !0
    });
    const L = Object.entries(ee.complexResolvers);
    function V(ce, fe, ve) {
      ce = t(ce.filter(x)), ve = ve || [];
      const _e = c(fe) ? fe : {};
      if (!ce.length)
        return;
      if (ce.some(v))
        return !1;
      if (ce.every(b))
        return !0;
      ce = ce.filter(c);
      const Ee = E(ce);
      if (ee.deep && g(Ee, "allOf"))
        return W({
          allOf: ce
        }, ee);
      const Me = L.map(([Le, Ce]) => Ee.filter((Je) => Ce.keywords.includes(Je)));
      return Me.forEach((Le) => u(Ee, Le)), Ee.forEach(function(Le) {
        const Ce = T(ce, Le), Je = h(Ce.filter(x), O(Le));
        if (Je.length === 1 && g(F, Le))
          _e[Le] = Je[0].map((Ie) => V([Ie], Ie));
        else if (Je.length === 1 && !g(q, Le) && !g(B, Le))
          _e[Le] = Je[0];
        else {
          const Ie = ee.resolvers[Le] || ee.resolvers.defaultResolver;
          if (!Ie) throw new Error("No resolver found for key " + Le + ". You can provide a resolver for this keyword in the options, or provide a default resolver.");
          const nt = (ct, mt = []) => V(ct, null, ve.concat(Le, mt));
          _e[Le] = Ie(Je, ve.concat(Le), nt, ee), _e[Le] === void 0 ? $(Je, ve.concat(Le)) : _e[Le] === void 0 && delete _e[Le];
        }
      }), L.reduce((Le, [Ce, Je], Ie) => ({
        ...Le,
        ...D(Me[Ie], Ce, ce, V, ee, ve)
      }), _e);
    }
    const K = i(k(G));
    return V(K);
  }
  return W.options = {
    resolvers: H
  }, VM = W, VM;
}
var h1t = f1t();
const p1t = /* @__PURE__ */ Kt(h1t);
function jE(t) {
  let e;
  const n = nr(t, "discriminator.propertyName", void 0);
  return D1e(n) ? e = n : n !== void 0 && console.warn(`Expecting discriminator to be a string, got "${typeof n}" instead`), e;
}
function qy(t) {
  return Array.isArray(t) ? "array" : typeof t == "string" ? "string" : t == null ? "null" : typeof t == "boolean" ? "boolean" : isNaN(t) ? typeof t == "object" ? "object" : "string" : "number";
}
var WM, ure;
function m1t() {
  if (ure) return WM;
  ure = 1;
  var t = jO(), e = du(), n = H6(), r = LO(), o = e(function(i) {
    return n(t(i, 1, r, !0));
  });
  return WM = o, WM;
}
var g1t = m1t();
const y1t = /* @__PURE__ */ Kt(g1t);
function v3(t) {
  let { type: e } = t;
  return !e && t.const ? qy(t.const) : !e && t.enum ? "string" : !e && (t.properties || t.additionalProperties) ? "object" : (Array.isArray(e) && (e.length === 2 && e.includes("null") ? e = e.find((n) => n !== "null") : e = e[0]), e);
}
function ou(t, e) {
  const n = Object.assign({}, t);
  return Object.keys(e).reduce((r, o) => {
    const i = t ? t[o] : {}, s = e[o];
    return t && o in t && xr(s) ? r[o] = ou(i, s) : t && e && (v3(t) === "object" || v3(e) === "object") && o === fyt && Array.isArray(i) && Array.isArray(s) ? r[o] = y1t(i, s) : r[o] = s, r;
  }, n);
}
function Gv(t, e, n = {}, r) {
  return pa(t, e, n, r)[0];
}
function v1t(t, e, n, r, o, i) {
  const { if: s, then: a, else: l, ...c } = e, u = t.isValid(s, i || {}, n);
  let d = [c], f = [];
  if (r)
    a && typeof a != "boolean" && (f = f.concat(pa(t, a, n, i, r, o))), l && typeof l != "boolean" && (f = f.concat(pa(t, l, n, i, r, o)));
  else {
    const h = u ? a : l;
    h && typeof h != "boolean" && (f = f.concat(pa(t, h, n, i, r, o)));
  }
  return f.length && (d = f.map((h) => ou(c, h))), d.flatMap((h) => pa(t, h, n, i, r, o));
}
function n_e(t) {
  return t.reduce(
    (n, r) => r.length > 1 ? r.flatMap((o) => B1e(n.length, (i) => [...n[i]].concat(o))) : (n.forEach((o) => o.push(r[0])), n),
    [[]]
    // Start with an empty list
  );
}
function b1t(t, e, n, r, o, i) {
  const s = r_e(t, e, n, r, o, i);
  if (s.length > 1 || s[0] !== e)
    return s;
  if (e1e in e)
    return o_e(t, e, n, r, o, i).flatMap((l) => pa(t, l, n, i, r, o));
  if (b6 in e && Array.isArray(e.allOf)) {
    const a = e.allOf.map((c) => pa(t, c, n, i, r, o));
    return n_e(a).map((c) => ({ ...e, allOf: c }));
  }
  return [e];
}
function r_e(t, e, n, r, o, i) {
  const s = Uy(e, n, o);
  return s !== e ? pa(t, s, n, i, r, o) : [e];
}
function Uy(t, e, n) {
  if (!xr(t))
    return t;
  let r = t;
  if (Ca in r) {
    const { $ref: o, ...i } = r;
    if (n.includes(o))
      return r;
    n.push(o), r = { ...P1e(o, e), ...i };
  }
  if (ha in r) {
    const o = [], i = Tbt(r[ha], (s, a, l) => {
      const c = [...n];
      s[l] = Uy(a, e, c), o.push(c);
    }, {});
    Dbt(n, Ubt(Nbt(o))), r = { ...r, [ha]: i };
  }
  return uyt in r && !Array.isArray(r.items) && typeof r.items != "boolean" && (r = {
    ...r,
    items: Uy(r.items, e, n)
  }), Sbt(t, r) ? t : r;
}
function _1t(t, e, n, r) {
  const o = {
    ...e,
    properties: { ...e.properties }
  }, i = r && xr(r) ? r : {};
  return Object.keys(i).forEach((s) => {
    if (s in o.properties)
      return;
    let a = {};
    typeof o.additionalProperties != "boolean" ? Ca in o.additionalProperties ? a = Gv(t, { $ref: nr(o.additionalProperties, [Ca]) }, n, i) : "type" in o.additionalProperties ? a = { ...o.additionalProperties } : NE in o.additionalProperties || x0 in o.additionalProperties ? a = {
      type: "object",
      ...o.additionalProperties
    } : a = { type: qy(nr(i, [s])) } : a = { type: qy(nr(i, [s])) }, o.properties[s] = a, y3(o.properties, [s, Jbe], !0);
  }), o;
}
function pa(t, e, n, r, o = !1, i = []) {
  return xr(e) ? b1t(t, e, n, o, i, r).flatMap((a) => {
    var l;
    let c = a;
    if (cyt in c)
      return v1t(t, c, n, o, i, r);
    if (b6 in c) {
      if (o) {
        const { allOf: d, ...f } = c;
        return [...d, f];
      }
      try {
        const d = [], f = [];
        (l = c.allOf) === null || l === void 0 || l.forEach((h) => {
          typeof h == "object" && h.contains ? d.push(h) : f.push(h);
        }), d.length && (c = { ...c, allOf: f }), c = p1t(c, {
          deep: !1
        }), d.length && (c.allOf = d);
      } catch (d) {
        console.warn(`could not merge subschemas in allOf:
`, d);
        const { allOf: f, ...h } = c;
        return h;
      }
    }
    return syt in c && c.additionalProperties !== !1 ? _1t(t, c, n, r) : c;
  }) : [{}];
}
function w1t(t, e, n, r, o) {
  let i;
  const { oneOf: s, anyOf: a, ...l } = e;
  if (Array.isArray(s) ? i = s : Array.isArray(a) && (i = a), i) {
    const c = o === void 0 && r ? {} : o, u = jE(e);
    i = i.map((f) => Uy(f, n, []));
    const d = q1e(t, c, i, n, u);
    if (r)
      return i.map((f) => ou(l, f));
    e = ou(l, i[d]);
  }
  return [e];
}
function o_e(t, e, n, r, o, i) {
  const { dependencies: s, ...a } = e;
  return w1t(t, a, n, r, i).flatMap((c) => i_e(t, s, c, n, r, o, i));
}
function i_e(t, e, n, r, o, i, s) {
  let a = [n];
  for (const l in e) {
    if (!o && nr(s, [l]) === void 0 || n.properties && !(l in n.properties))
      continue;
    const [c, u] = D6(l, e);
    return Array.isArray(u) ? a[0] = x1t(n, u) : xr(u) && (a = E1t(t, n, r, l, u, o, i, s)), a.flatMap((d) => i_e(t, c, d, r, o, i, s));
  }
  return a;
}
function x1t(t, e) {
  if (!e)
    return t;
  const n = Array.isArray(t.required) ? Array.from(/* @__PURE__ */ new Set([...t.required, ...e])) : e;
  return { ...t, required: n };
}
function E1t(t, e, n, r, o, i, s, a) {
  return pa(t, o, n, a, i, s).flatMap((c) => {
    const { oneOf: u, ...d } = c;
    if (e = ou(e, d), u === void 0)
      return e;
    const f = u.map((p) => typeof p == "boolean" || !(Ca in p) ? [p] : r_e(t, p, n, i, s, a));
    return n_e(f).flatMap((p) => S1t(t, e, n, r, p, i, s, a));
  });
}
function S1t(t, e, n, r, o, i, s, a) {
  const l = o.filter((c) => {
    if (typeof c == "boolean" || !c || !c.properties)
      return !1;
    const { [r]: u } = c.properties;
    if (u) {
      const d = {
        type: "object",
        properties: {
          [r]: u
        }
      };
      return t.isValid(d, a, n) || i;
    }
    return !1;
  });
  return !i && l.length !== 1 ? (console.warn("ignoring oneOf in dependencies because there isn't exactly one subschema that is valid"), [e]) : l.flatMap((c) => {
    const u = c, [d] = D6(r, u.properties), f = { ...u, properties: d };
    return pa(t, f, n, a, i, s).map((p) => ou(e, p));
  });
}
const O1t = {
  type: "object",
  $id: dyt,
  properties: {
    __not_really_there__: {
      type: "number"
    }
  }
};
function b3(t, e, n, r = {}) {
  let o = 0;
  return n && (I6(n.properties) ? o += pbt(n.properties, (i, s, a) => {
    const l = nr(r, a);
    if (typeof s == "boolean")
      return i;
    if (Ig(s, Ca)) {
      const c = Gv(t, s, e, l);
      return i + b3(t, e, c, l || {});
    }
    if ((Ig(s, x0) || Ig(s, NE)) && l) {
      const c = Ig(s, x0) ? x0 : NE, u = jE(s);
      return i + _3(t, e, l, nr(s, c), -1, u);
    }
    if (s.type === "object")
      return i + b3(t, e, s, l || {});
    if (s.type === qy(l)) {
      let c = i + 1;
      return s.default ? c += l === s.default ? 1 : -1 : s.const && (c += l === s.const ? 1 : -1), c;
    }
    return i;
  }, 0) : D1e(n.type) && n.type === qy(r) && (o += 1)), o;
}
function _3(t, e, n, r, o = -1, i) {
  const s = r.map((d) => Uy(d, e, [])), a = z1e(n, r, i);
  if (M1e(a))
    return a;
  const l = s.reduce((d, f, h) => (q1e(t, n, [O1t, f], e, i) === 1 && d.push(h), d), []);
  if (l.length === 1)
    return l[0];
  l.length || B1e(s.length, (d) => l.push(d));
  const c = /* @__PURE__ */ new Set(), { bestIndex: u } = l.reduce((d, f) => {
    const { bestScore: h } = d, p = s[f], m = b3(t, e, p, n);
    return c.add(m), m > h ? { bestIndex: f, bestScore: m } : d;
  }, { bestIndex: o, bestScore: 0 });
  return c.size === 1 && o >= 0 ? o : u;
}
function C1t(t) {
  return Array.isArray(t.items) && t.items.length > 0 && t.items.every((e) => xr(e));
}
function LE(t, e, n = !1) {
  if (Array.isArray(e)) {
    const r = Array.isArray(t) ? t : [], o = e.map((i, s) => r[s] ? LE(r[s], i, n) : i);
    return n && o.length < r.length && o.push(...r.slice(o.length)), o;
  }
  if (xr(e)) {
    const r = Object.assign({}, t);
    return Object.keys(e).reduce((o, i) => (o[i] = LE(t ? nr(t, i) : {}, nr(e, i), n), o), r);
  }
  return e;
}
function K6(t, e, n = !1) {
  return Object.keys(e).reduce((r, o) => {
    const i = t ? t[o] : {}, s = e[o];
    if (t && o in t && xr(s))
      r[o] = K6(i, s, n);
    else if (n && Array.isArray(i) && Array.isArray(s)) {
      let a = s;
      n === "preventDuplicates" && (a = s.reduce((l, c) => (i.includes(c) || l.push(c), l), [])), r[o] = i.concat(a);
    } else
      r[o] = s;
    return r;
  }, Object.assign({}, t));
}
function k1t(t) {
  return Array.isArray(t.enum) && t.enum.length === 1 || ayt in t;
}
function A1t(t, e, n = {}) {
  const r = Gv(t, e, n, void 0), o = r.oneOf || r.anyOf;
  return Array.isArray(r.enum) ? !0 : Array.isArray(o) ? o.every((i) => typeof i != "boolean" && k1t(i)) : !1;
}
function T1t(t, e, n) {
  return !e.uniqueItems || !e.items || typeof e.items == "boolean" ? !1 : A1t(t, e.items, n);
}
var gp;
(function(t) {
  t[t.Ignore = 0] = "Ignore", t[t.Invert = 1] = "Invert", t[t.Fallback = 2] = "Fallback";
})(gp || (gp = {}));
function GM(t, e = gp.Ignore, n = -1) {
  if (n >= 0) {
    if (Array.isArray(t.items) && n < t.items.length) {
      const r = t.items[n];
      if (typeof r != "boolean")
        return r;
    }
  } else if (t.items && !Array.isArray(t.items) && typeof t.items != "boolean")
    return t.items;
  return e !== gp.Ignore && xr(t.additionalItems) ? t.additionalItems : {};
}
function dre(t, e, n, r, o, i = [], s = {}) {
  const { emptyObjectFields: a = "populateAllDefaults" } = s;
  if (r)
    t[e] = n;
  else if (a !== "skipDefaults")
    if (xr(n)) {
      const l = o === void 0 ? i.includes(e) : o;
      a === "skipEmptyDefaults" ? zy(n) || (t[e] = n) : (!zy(n) || i.includes(e)) && (l || a !== "populateRequiredDefaults") && (t[e] = n);
    } else // Store computedDefault if it's a defined primitive (e.g., true) and satisfies certain conditions
    // Condition 1: computedDefault is not undefined
    // Condition 2: If emptyObjectFields is 'populateAllDefaults' or 'skipEmptyDefaults) or if the key is a required field
    n !== void 0 && (a === "populateAllDefaults" || a === "skipEmptyDefaults" || i.includes(e)) && (t[e] = n);
}
function Yc(t, e, n = {}) {
  const { parentDefaults: r, rawFormData: o, rootSchema: i = {}, includeUndefinedValues: s = !1, _recurseList: a = [], experimental_defaultFormStateBehavior: l = void 0, required: c } = n, u = xr(o) ? o : {}, d = xr(e) ? e : {};
  let f = r, h = null, p = a;
  if (xr(f) && xr(d.default))
    f = K6(f, d.default);
  else if (lyt in d)
    f = d.default;
  else if (Ca in d) {
    const g = d[Ca];
    a.includes(g) || (p = a.concat(g), h = P1e(g, i));
  } else if (e1e in d) {
    const g = {
      ...u,
      ...fre(t, d, n, f)
    };
    h = o_e(t, d, i, !1, [], g)[0];
  } else if (C1t(d))
    f = d.items.map((g, y) => Yc(t, g, {
      rootSchema: i,
      includeUndefinedValues: s,
      _recurseList: a,
      experimental_defaultFormStateBehavior: l,
      parentDefaults: Array.isArray(r) ? r[y] : void 0,
      rawFormData: u,
      required: c
    }));
  else if (x0 in d) {
    const { oneOf: g, ...y } = d;
    if (g.length === 0)
      return;
    const v = jE(d);
    h = g[_3(t, i, zy(u) ? void 0 : u, g, 0, v)], h = ou(y, h);
  } else if (NE in d) {
    const { anyOf: g, ...y } = d;
    if (g.length === 0)
      return;
    const v = jE(d);
    h = g[_3(t, i, zy(u) ? void 0 : u, g, 0, v)], h = ou(y, h);
  }
  if (h)
    return Yc(t, h, {
      rootSchema: i,
      includeUndefinedValues: s,
      _recurseList: p,
      experimental_defaultFormStateBehavior: l,
      parentDefaults: f,
      rawFormData: u,
      required: c
    });
  f === void 0 && (f = d.default);
  const m = fre(t, d, n, f);
  return m ?? f;
}
function R1t(t, e, { rawFormData: n, rootSchema: r = {}, includeUndefinedValues: o = !1, _recurseList: i = [], experimental_defaultFormStateBehavior: s = void 0, required: a } = {}, l) {
  {
    const c = xr(n) ? n : {}, u = e, d = s?.allOf === "populateDefaults" && b6 in u ? Gv(t, u, r, c) : u, f = Object.keys(d.properties || {}).reduce((h, p) => {
      var m;
      const g = Yc(t, nr(d, [ha, p]), {
        rootSchema: r,
        _recurseList: i,
        experimental_defaultFormStateBehavior: s,
        includeUndefinedValues: o === !0,
        parentDefaults: nr(l, [p]),
        rawFormData: nr(c, [p]),
        required: (m = d.required) === null || m === void 0 ? void 0 : m.includes(p)
      });
      return dre(h, p, g, o, a, d.required, s), h;
    }, {});
    if (d.additionalProperties) {
      const h = xr(d.additionalProperties) ? d.additionalProperties : {}, p = /* @__PURE__ */ new Set();
      xr(l) && Object.keys(l).filter((g) => !d.properties || !d.properties[g]).forEach((g) => p.add(g));
      const m = [];
      Object.keys(c).filter((g) => !d.properties || !d.properties[g]).forEach((g) => {
        p.add(g), m.push(g);
      }), p.forEach((g) => {
        var y;
        const v = Yc(t, h, {
          rootSchema: r,
          _recurseList: i,
          experimental_defaultFormStateBehavior: s,
          includeUndefinedValues: o === !0,
          parentDefaults: nr(l, [g]),
          rawFormData: nr(c, [g]),
          required: (y = d.required) === null || y === void 0 ? void 0 : y.includes(g)
        });
        dre(f, g, v, o, a, m);
      });
    }
    return f;
  }
}
function P1t(t, e, { rawFormData: n, rootSchema: r = {}, _recurseList: o = [], experimental_defaultFormStateBehavior: i = void 0, required: s } = {}, a) {
  var l, c, u, d;
  const f = e, h = ((l = i?.arrayMinItems) === null || l === void 0 ? void 0 : l.populate) === "never", p = ((c = i?.arrayMinItems) === null || c === void 0 ? void 0 : c.populate) === "requiredOnly", m = i?.emptyObjectFields === "skipEmptyDefaults", g = (d = (u = i?.arrayMinItems) === null || u === void 0 ? void 0 : u.computeSkipPopulate) !== null && d !== void 0 ? d : () => !1, y = m ? void 0 : [];
  if (Array.isArray(a) && (a = a.map((E, S) => {
    const C = GM(f, gp.Fallback, S);
    return Yc(t, C, {
      rootSchema: r,
      _recurseList: o,
      experimental_defaultFormStateBehavior: i,
      parentDefaults: E,
      required: s
    });
  })), Array.isArray(n)) {
    const E = GM(f);
    h ? a = n : a = n.map((S, C) => Yc(t, E, {
      rootSchema: r,
      _recurseList: o,
      experimental_defaultFormStateBehavior: i,
      rawFormData: S,
      parentDefaults: nr(a, [C]),
      required: s
    }));
  }
  if (h)
    return a ?? y;
  if (p && !s)
    return a || void 0;
  const v = Array.isArray(a) ? a.length : 0;
  if (!f.minItems || T1t(t, f, r) || g(t, f, r) || f.minItems <= v)
    return a || y;
  const b = a || [], _ = GM(f, gp.Invert), w = _.default, x = new Array(f.minItems - v).fill(Yc(t, _, {
    parentDefaults: w,
    rootSchema: r,
    _recurseList: o,
    experimental_defaultFormStateBehavior: i,
    required: s
  }));
  return b.concat(x);
}
function fre(t, e, n = {}, r) {
  switch (v3(e)) {
    // We need to recurse for object schema inner default values.
    case "object":
      return R1t(t, e, n, r);
    case "array":
      return P1t(t, e, n, r);
  }
}
function $1t(t, e, n, r, o = !1, i) {
  if (!xr(e))
    throw new Error("Invalid schema: " + e);
  const s = Gv(t, e, r, n), a = Yc(t, s, {
    rootSchema: r,
    includeUndefinedValues: o,
    experimental_defaultFormStateBehavior: i,
    rawFormData: n
  });
  if (n == null || typeof n == "number" && isNaN(n))
    return a;
  const { mergeExtraDefaults: l } = {};
  return xr(n) || Array.isArray(n) ? LE(a, n, l) : n;
}
var M1t = Y1e();
const D1t = /* @__PURE__ */ Kt(M1t);
var YM, hre;
function I1t() {
  if (hre) return YM;
  hre = 1;
  var t = U1e();
  function e(n, r, o, i) {
    return i = typeof i == "function" ? i : void 0, n == null ? n : t(n, r, o, i);
  }
  return YM = e, YM;
}
var N1t = I1t();
const j1t = /* @__PURE__ */ Kt(N1t);
class L1t {
  /** Construct an `ErrorSchemaBuilder` with an optional initial set of errors in an `ErrorSchema`.
   *
   * @param [initialSchema] - The optional set of initial errors, that will be cloned into the class
   */
  constructor(e) {
    this.errorSchema = {}, this.resetAllErrors(e);
  }
  /** Returns the `ErrorSchema` that has been updated by the methods of the `ErrorSchemaBuilder`
   */
  get ErrorSchema() {
    return this.errorSchema;
  }
  /** Will get an existing `ErrorSchema` at the specified `pathOfError` or create and return one.
   *
   * @param [pathOfError] - The optional path into the `ErrorSchema` at which to add the error(s)
   * @returns - The error block for the given `pathOfError` or the root if not provided
   * @private
   */
  getOrCreateErrorBlock(e) {
    let r = Array.isArray(e) && e.length > 0 || typeof e == "string" ? nr(this.errorSchema, e) : this.errorSchema;
    return !r && e && (r = {}, j1t(this.errorSchema, e, r, Object)), r;
  }
  /** Resets all errors in the `ErrorSchemaBuilder` back to the `initialSchema` if provided, otherwise an empty set.
   *
   * @param [initialSchema] - The optional set of initial errors, that will be cloned into the class
   * @returns - The `ErrorSchemaBuilder` object for chaining purposes
   */
  resetAllErrors(e) {
    return this.errorSchema = e ? D1t(e) : {}, this;
  }
  /** Adds the `errorOrList` to the list of errors in the `ErrorSchema` at either the root level or the location within
   * the schema described by the `pathOfError`. For more information about how to specify the path see the
   * [eslint lodash plugin docs](https://github.com/wix/eslint-plugin-lodash/blob/master/docs/rules/path-style.md).
   *
   * @param errorOrList - The error or list of errors to add into the `ErrorSchema`
   * @param [pathOfError] - The optional path into the `ErrorSchema` at which to add the error(s)
   * @returns - The `ErrorSchemaBuilder` object for chaining purposes
   */
  addErrors(e, n) {
    const r = this.getOrCreateErrorBlock(n);
    let o = nr(r, Ol);
    return Array.isArray(o) || (o = [], r[Ol] = o), Array.isArray(e) ? o.push(...e) : o.push(e), this;
  }
  /** Sets/replaces the `errorOrList` as the error(s) in the `ErrorSchema` at either the root level or the location
   * within the schema described by the `pathOfError`. For more information about how to specify the path see the
   * [eslint lodash plugin docs](https://github.com/wix/eslint-plugin-lodash/blob/master/docs/rules/path-style.md).
   *
   * @param errorOrList - The error or list of errors to set into the `ErrorSchema`
   * @param [pathOfError] - The optional path into the `ErrorSchema` at which to set the error(s)
   * @returns - The `ErrorSchemaBuilder` object for chaining purposes
   */
  setErrors(e, n) {
    const r = this.getOrCreateErrorBlock(n), o = Array.isArray(e) ? [...e] : [e];
    return y3(r, Ol, o), this;
  }
  /** Clears the error(s) in the `ErrorSchema` at either the root level or the location within the schema described by
   * the `pathOfError`. For more information about how to specify the path see the
   * [eslint lodash plugin docs](https://github.com/wix/eslint-plugin-lodash/blob/master/docs/rules/path-style.md).
   *
   * @param [pathOfError] - The optional path into the `ErrorSchema` at which to clear the error(s)
   * @returns - The `ErrorSchemaBuilder` object for chaining purposes
   */
  clearErrors(e) {
    const n = this.getOrCreateErrorBlock(e);
    return y3(n, Ol, []), this;
  }
}
var z1 = { exports: {} }, pn = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var pre;
function F1t() {
  if (pre) return pn;
  pre = 1;
  var t = Symbol.for("react.element"), e = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), s = Symbol.for("react.context"), a = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), h = Symbol.for("react.offscreen"), p;
  p = Symbol.for("react.module.reference");
  function m(g) {
    if (typeof g == "object" && g !== null) {
      var y = g.$$typeof;
      switch (y) {
        case t:
          switch (g = g.type, g) {
            case n:
            case o:
            case r:
            case c:
            case u:
              return g;
            default:
              switch (g = g && g.$$typeof, g) {
                case a:
                case s:
                case l:
                case f:
                case d:
                case i:
                  return g;
                default:
                  return y;
              }
          }
        case e:
          return y;
      }
    }
  }
  return pn.ContextConsumer = s, pn.ContextProvider = i, pn.Element = t, pn.ForwardRef = l, pn.Fragment = n, pn.Lazy = f, pn.Memo = d, pn.Portal = e, pn.Profiler = o, pn.StrictMode = r, pn.Suspense = c, pn.SuspenseList = u, pn.isAsyncMode = function() {
    return !1;
  }, pn.isConcurrentMode = function() {
    return !1;
  }, pn.isContextConsumer = function(g) {
    return m(g) === s;
  }, pn.isContextProvider = function(g) {
    return m(g) === i;
  }, pn.isElement = function(g) {
    return typeof g == "object" && g !== null && g.$$typeof === t;
  }, pn.isForwardRef = function(g) {
    return m(g) === l;
  }, pn.isFragment = function(g) {
    return m(g) === n;
  }, pn.isLazy = function(g) {
    return m(g) === f;
  }, pn.isMemo = function(g) {
    return m(g) === d;
  }, pn.isPortal = function(g) {
    return m(g) === e;
  }, pn.isProfiler = function(g) {
    return m(g) === o;
  }, pn.isStrictMode = function(g) {
    return m(g) === r;
  }, pn.isSuspense = function(g) {
    return m(g) === c;
  }, pn.isSuspenseList = function(g) {
    return m(g) === u;
  }, pn.isValidElementType = function(g) {
    return typeof g == "string" || typeof g == "function" || g === n || g === o || g === r || g === c || g === u || g === h || typeof g == "object" && g !== null && (g.$$typeof === f || g.$$typeof === d || g.$$typeof === i || g.$$typeof === s || g.$$typeof === l || g.$$typeof === p || g.getModuleId !== void 0);
  }, pn.typeOf = m, pn;
}
var mn = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var mre;
function B1t() {
  return mre || (mre = 1, process.env.NODE_ENV !== "production" && function() {
    var t = Symbol.for("react.element"), e = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), s = Symbol.for("react.context"), a = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), h = Symbol.for("react.offscreen"), p = !1, m = !1, g = !1, y = !1, v = !1, b;
    b = Symbol.for("react.module.reference");
    function _(K) {
      return !!(typeof K == "string" || typeof K == "function" || K === n || K === o || v || K === r || K === c || K === u || y || K === h || p || m || g || typeof K == "object" && K !== null && (K.$$typeof === f || K.$$typeof === d || K.$$typeof === i || K.$$typeof === s || K.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      K.$$typeof === b || K.getModuleId !== void 0));
    }
    function w(K) {
      if (typeof K == "object" && K !== null) {
        var ne = K.$$typeof;
        switch (ne) {
          case t:
            var ce = K.type;
            switch (ce) {
              case n:
              case o:
              case r:
              case c:
              case u:
                return ce;
              default:
                var fe = ce && ce.$$typeof;
                switch (fe) {
                  case a:
                  case s:
                  case l:
                  case f:
                  case d:
                  case i:
                    return fe;
                  default:
                    return ne;
                }
            }
          case e:
            return ne;
        }
      }
    }
    var x = s, E = i, S = t, C = l, R = n, P = f, N = d, A = e, O = o, k = r, T = c, I = u, j = !1, z = !1;
    function $(K) {
      return j || (j = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function D(K) {
      return z || (z = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function U(K) {
      return w(K) === s;
    }
    function q(K) {
      return w(K) === i;
    }
    function F(K) {
      return typeof K == "object" && K !== null && K.$$typeof === t;
    }
    function B(K) {
      return w(K) === l;
    }
    function H(K) {
      return w(K) === n;
    }
    function Z(K) {
      return w(K) === f;
    }
    function W(K) {
      return w(K) === d;
    }
    function G(K) {
      return w(K) === e;
    }
    function ee(K) {
      return w(K) === o;
    }
    function Y(K) {
      return w(K) === r;
    }
    function L(K) {
      return w(K) === c;
    }
    function V(K) {
      return w(K) === u;
    }
    mn.ContextConsumer = x, mn.ContextProvider = E, mn.Element = S, mn.ForwardRef = C, mn.Fragment = R, mn.Lazy = P, mn.Memo = N, mn.Portal = A, mn.Profiler = O, mn.StrictMode = k, mn.Suspense = T, mn.SuspenseList = I, mn.isAsyncMode = $, mn.isConcurrentMode = D, mn.isContextConsumer = U, mn.isContextProvider = q, mn.isElement = F, mn.isForwardRef = B, mn.isFragment = H, mn.isLazy = Z, mn.isMemo = W, mn.isPortal = G, mn.isProfiler = ee, mn.isStrictMode = Y, mn.isSuspense = L, mn.isSuspenseList = V, mn.isValidElementType = _, mn.typeOf = w;
  }()), mn;
}
var gre;
function z1t() {
  return gre || (gre = 1, process.env.NODE_ENV === "production" ? z1.exports = F1t() : z1.exports = B1t()), z1.exports;
}
z1t();
function q1t(t) {
  let e = 0;
  for (let n = 0; n < t.length; n += 1) {
    const r = t.charCodeAt(n);
    e = (e << 5) - e + r, e = e & e;
  }
  return e.toString(16);
}
function U1t(t) {
  const e = /* @__PURE__ */ new Set();
  return JSON.stringify(t, (n, r) => (e.add(n), r)), q1t(JSON.stringify(t, Array.from(e).sort()));
}
function X6(t, e = []) {
  if (!t)
    return [];
  let n = [];
  return Ol in t && (n = n.concat(t[Ol].map((r) => {
    const o = `.${e.join(".")}`;
    return {
      property: o,
      message: r,
      stack: `${o} ${r}`
    };
  }))), Object.keys(t).reduce((r, o) => {
    if (o !== Ol) {
      const i = t[o];
      _6(i) && (r = r.concat(X6(i, [...e, o])));
    }
    return r;
  }, n);
}
var KM, yre;
function H1t() {
  if (yre) return KM;
  yre = 1;
  var t = Kl(), e = NO(), n = Wr(), r = Fp(), o = m1e(), i = nf(), s = g1e();
  function a(l) {
    return n(l) ? t(l, i) : r(l) ? [l] : e(o(s(l)));
  }
  return KM = a, KM;
}
var V1t = H1t();
const W1t = /* @__PURE__ */ Kt(V1t);
function G1t(t) {
  const e = new L1t();
  return t.length && t.forEach((n) => {
    const { property: r, message: o } = n, i = r === "." ? [] : W1t(r);
    i.length > 0 && i[0] === "" && i.splice(0, 1), o && e.addErrors(o, i);
  }), e.ErrorSchema;
}
function s_e(t) {
  return Object.keys(t).reduce((e, n) => {
    if (n === "addError")
      return e;
    {
      const r = t[n];
      return _6(r) ? {
        ...e,
        [n]: s_e(r)
      } : { ...e, [n]: r };
    }
  }, {});
}
function Y1t(t, e) {
  if (!e)
    return t;
  const { errors: n, errorSchema: r } = t;
  let o = X6(e), i = e;
  return zy(r) || (i = K6(r, e, !0), o = [...n].concat(o)), { errorSchema: i, errors: o };
}
function K1t(t) {
  for (const e in t) {
    const n = t, r = n[e];
    e === Ca && typeof r == "string" && r.startsWith("#") ? n[e] = t1e + r : n[e] = Q6(r);
  }
  return t;
}
function X1t(t) {
  for (let e = 0; e < t.length; e++)
    t[e] = Q6(t[e]);
  return t;
}
function Q6(t) {
  return Array.isArray(t) ? X1t([...t]) : I6(t) ? K1t({ ...t }) : t;
}
var vre;
(function(t) {
  t.ArrayItemTitle = "Item", t.MissingItems = "Missing items definition", t.YesLabel = "Yes", t.NoLabel = "No", t.CloseLabel = "Close", t.ErrorsLabel = "Errors", t.NewStringDefault = "New Value", t.AddButton = "Add", t.AddItemButton = "Add Item", t.CopyButton = "Copy", t.MoveDownButton = "Move down", t.MoveUpButton = "Move up", t.RemoveButton = "Remove", t.NowLabel = "Now", t.ClearLabel = "Clear", t.AriaDateLabel = "Select a date", t.PreviewLabel = "Preview", t.DecrementAriaLabel = "Decrease value by 1", t.IncrementAriaLabel = "Increase value by 1", t.UnknownFieldType = "Unknown field type %1", t.OptionPrefix = "Option %1", t.TitleOptionPrefix = "%1 option %2", t.KeyLabel = "%1 Key", t.InvalidObjectField = 'Invalid "%1" object field configuration: _%2_.', t.UnsupportedField = "Unsupported field schema.", t.UnsupportedFieldWithId = "Unsupported field schema for field `%1`.", t.UnsupportedFieldWithReason = "Unsupported field schema: _%1_.", t.UnsupportedFieldWithIdAndReason = "Unsupported field schema for field `%1`: _%2_.", t.FilesInfo = "**%1** (%2, %3 bytes)";
})(vre || (vre = {}));
Y6();
var q1 = { exports: {} }, XM = {}, Ua = {}, Su = {}, QM = {}, ZM = {}, JM = {}, bre;
function FE() {
  return bre || (bre = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.regexpCode = t.getEsmExportName = t.getProperty = t.safeStringify = t.stringify = t.strConcat = t.addCodeArg = t.str = t._ = t.nil = t._Code = t.Name = t.IDENTIFIER = t._CodeOrName = void 0;
    class e {
    }
    t._CodeOrName = e, t.IDENTIFIER = /^[a-z$_][a-z$_0-9]*$/i;
    class n extends e {
      constructor(v) {
        if (super(), !t.IDENTIFIER.test(v))
          throw new Error("CodeGen: name must be a valid identifier");
        this.str = v;
      }
      toString() {
        return this.str;
      }
      emptyStr() {
        return !1;
      }
      get names() {
        return { [this.str]: 1 };
      }
    }
    t.Name = n;
    class r extends e {
      constructor(v) {
        super(), this._items = typeof v == "string" ? [v] : v;
      }
      toString() {
        return this.str;
      }
      emptyStr() {
        if (this._items.length > 1)
          return !1;
        const v = this._items[0];
        return v === "" || v === '""';
      }
      get str() {
        var v;
        return (v = this._str) !== null && v !== void 0 ? v : this._str = this._items.reduce((b, _) => `${b}${_}`, "");
      }
      get names() {
        var v;
        return (v = this._names) !== null && v !== void 0 ? v : this._names = this._items.reduce((b, _) => (_ instanceof n && (b[_.str] = (b[_.str] || 0) + 1), b), {});
      }
    }
    t._Code = r, t.nil = new r("");
    function o(y, ...v) {
      const b = [y[0]];
      let _ = 0;
      for (; _ < v.length; )
        a(b, v[_]), b.push(y[++_]);
      return new r(b);
    }
    t._ = o;
    const i = new r("+");
    function s(y, ...v) {
      const b = [h(y[0])];
      let _ = 0;
      for (; _ < v.length; )
        b.push(i), a(b, v[_]), b.push(i, h(y[++_]));
      return l(b), new r(b);
    }
    t.str = s;
    function a(y, v) {
      v instanceof r ? y.push(...v._items) : v instanceof n ? y.push(v) : y.push(d(v));
    }
    t.addCodeArg = a;
    function l(y) {
      let v = 1;
      for (; v < y.length - 1; ) {
        if (y[v] === i) {
          const b = c(y[v - 1], y[v + 1]);
          if (b !== void 0) {
            y.splice(v - 1, 3, b);
            continue;
          }
          y[v++] = "+";
        }
        v++;
      }
    }
    function c(y, v) {
      if (v === '""')
        return y;
      if (y === '""')
        return v;
      if (typeof y == "string")
        return v instanceof n || y[y.length - 1] !== '"' ? void 0 : typeof v != "string" ? `${y.slice(0, -1)}${v}"` : v[0] === '"' ? y.slice(0, -1) + v.slice(1) : void 0;
      if (typeof v == "string" && v[0] === '"' && !(y instanceof n))
        return `"${y}${v.slice(1)}`;
    }
    function u(y, v) {
      return v.emptyStr() ? y : y.emptyStr() ? v : s`${y}${v}`;
    }
    t.strConcat = u;
    function d(y) {
      return typeof y == "number" || typeof y == "boolean" || y === null ? y : h(Array.isArray(y) ? y.join(",") : y);
    }
    function f(y) {
      return new r(h(y));
    }
    t.stringify = f;
    function h(y) {
      return JSON.stringify(y).replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029");
    }
    t.safeStringify = h;
    function p(y) {
      return typeof y == "string" && t.IDENTIFIER.test(y) ? new r(`.${y}`) : o`[${y}]`;
    }
    t.getProperty = p;
    function m(y) {
      if (typeof y == "string" && t.IDENTIFIER.test(y))
        return new r(`${y}`);
      throw new Error(`CodeGen: invalid export name: ${y}, use explicit $id name mapping`);
    }
    t.getEsmExportName = m;
    function g(y) {
      return new r(y.toString());
    }
    t.regexpCode = g;
  }(JM)), JM;
}
var eD = {}, _re;
function wre() {
  return _re || (_re = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.ValueScope = t.ValueScopeName = t.Scope = t.varKinds = t.UsedValueState = void 0;
    const e = FE();
    class n extends Error {
      constructor(c) {
        super(`CodeGen: "code" for ${c} not defined`), this.value = c.value;
      }
    }
    var r;
    (function(l) {
      l[l.Started = 0] = "Started", l[l.Completed = 1] = "Completed";
    })(r || (t.UsedValueState = r = {})), t.varKinds = {
      const: new e.Name("const"),
      let: new e.Name("let"),
      var: new e.Name("var")
    };
    class o {
      constructor({ prefixes: c, parent: u } = {}) {
        this._names = {}, this._prefixes = c, this._parent = u;
      }
      toName(c) {
        return c instanceof e.Name ? c : this.name(c);
      }
      name(c) {
        return new e.Name(this._newName(c));
      }
      _newName(c) {
        const u = this._names[c] || this._nameGroup(c);
        return `${c}${u.index++}`;
      }
      _nameGroup(c) {
        var u, d;
        if (!((d = (u = this._parent) === null || u === void 0 ? void 0 : u._prefixes) === null || d === void 0) && d.has(c) || this._prefixes && !this._prefixes.has(c))
          throw new Error(`CodeGen: prefix "${c}" is not allowed in this scope`);
        return this._names[c] = { prefix: c, index: 0 };
      }
    }
    t.Scope = o;
    class i extends e.Name {
      constructor(c, u) {
        super(u), this.prefix = c;
      }
      setValue(c, { property: u, itemIndex: d }) {
        this.value = c, this.scopePath = (0, e._)`.${new e.Name(u)}[${d}]`;
      }
    }
    t.ValueScopeName = i;
    const s = (0, e._)`\n`;
    class a extends o {
      constructor(c) {
        super(c), this._values = {}, this._scope = c.scope, this.opts = { ...c, _n: c.lines ? s : e.nil };
      }
      get() {
        return this._scope;
      }
      name(c) {
        return new i(c, this._newName(c));
      }
      value(c, u) {
        var d;
        if (u.ref === void 0)
          throw new Error("CodeGen: ref must be passed in value");
        const f = this.toName(c), { prefix: h } = f, p = (d = u.key) !== null && d !== void 0 ? d : u.ref;
        let m = this._values[h];
        if (m) {
          const v = m.get(p);
          if (v)
            return v;
        } else
          m = this._values[h] = /* @__PURE__ */ new Map();
        m.set(p, f);
        const g = this._scope[h] || (this._scope[h] = []), y = g.length;
        return g[y] = u.ref, f.setValue(u, { property: h, itemIndex: y }), f;
      }
      getValue(c, u) {
        const d = this._values[c];
        if (d)
          return d.get(u);
      }
      scopeRefs(c, u = this._values) {
        return this._reduceValues(u, (d) => {
          if (d.scopePath === void 0)
            throw new Error(`CodeGen: name "${d}" has no value`);
          return (0, e._)`${c}${d.scopePath}`;
        });
      }
      scopeCode(c = this._values, u, d) {
        return this._reduceValues(c, (f) => {
          if (f.value === void 0)
            throw new Error(`CodeGen: name "${f}" has no value`);
          return f.value.code;
        }, u, d);
      }
      _reduceValues(c, u, d = {}, f) {
        let h = e.nil;
        for (const p in c) {
          const m = c[p];
          if (!m)
            continue;
          const g = d[p] = d[p] || /* @__PURE__ */ new Map();
          m.forEach((y) => {
            if (g.has(y))
              return;
            g.set(y, r.Started);
            let v = u(y);
            if (v) {
              const b = this.opts.es5 ? t.varKinds.var : t.varKinds.const;
              h = (0, e._)`${h}${b} ${y} = ${v};${this.opts._n}`;
            } else if (v = f?.(y))
              h = (0, e._)`${h}${v}${this.opts._n}`;
            else
              throw new n(y);
            g.set(y, r.Completed);
          });
        }
        return h;
      }
    }
    t.ValueScope = a;
  }(eD)), eD;
}
var xre;
function Mt() {
  return xre || (xre = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.or = t.and = t.not = t.CodeGen = t.operators = t.varKinds = t.ValueScopeName = t.ValueScope = t.Scope = t.Name = t.regexpCode = t.stringify = t.getProperty = t.nil = t.strConcat = t.str = t._ = void 0;
    const e = FE(), n = wre();
    var r = FE();
    Object.defineProperty(t, "_", { enumerable: !0, get: function() {
      return r._;
    } }), Object.defineProperty(t, "str", { enumerable: !0, get: function() {
      return r.str;
    } }), Object.defineProperty(t, "strConcat", { enumerable: !0, get: function() {
      return r.strConcat;
    } }), Object.defineProperty(t, "nil", { enumerable: !0, get: function() {
      return r.nil;
    } }), Object.defineProperty(t, "getProperty", { enumerable: !0, get: function() {
      return r.getProperty;
    } }), Object.defineProperty(t, "stringify", { enumerable: !0, get: function() {
      return r.stringify;
    } }), Object.defineProperty(t, "regexpCode", { enumerable: !0, get: function() {
      return r.regexpCode;
    } }), Object.defineProperty(t, "Name", { enumerable: !0, get: function() {
      return r.Name;
    } });
    var o = wre();
    Object.defineProperty(t, "Scope", { enumerable: !0, get: function() {
      return o.Scope;
    } }), Object.defineProperty(t, "ValueScope", { enumerable: !0, get: function() {
      return o.ValueScope;
    } }), Object.defineProperty(t, "ValueScopeName", { enumerable: !0, get: function() {
      return o.ValueScopeName;
    } }), Object.defineProperty(t, "varKinds", { enumerable: !0, get: function() {
      return o.varKinds;
    } }), t.operators = {
      GT: new e._Code(">"),
      GTE: new e._Code(">="),
      LT: new e._Code("<"),
      LTE: new e._Code("<="),
      EQ: new e._Code("==="),
      NEQ: new e._Code("!=="),
      NOT: new e._Code("!"),
      OR: new e._Code("||"),
      AND: new e._Code("&&"),
      ADD: new e._Code("+")
    };
    class i {
      optimizeNodes() {
        return this;
      }
      optimizeNames(F, B) {
        return this;
      }
    }
    class s extends i {
      constructor(F, B, H) {
        super(), this.varKind = F, this.name = B, this.rhs = H;
      }
      render({ es5: F, _n: B }) {
        const H = F ? n.varKinds.var : this.varKind, Z = this.rhs === void 0 ? "" : ` = ${this.rhs}`;
        return `${H} ${this.name}${Z};` + B;
      }
      optimizeNames(F, B) {
        if (F[this.name.str])
          return this.rhs && (this.rhs = O(this.rhs, F, B)), this;
      }
      get names() {
        return this.rhs instanceof e._CodeOrName ? this.rhs.names : {};
      }
    }
    class a extends i {
      constructor(F, B, H) {
        super(), this.lhs = F, this.rhs = B, this.sideEffects = H;
      }
      render({ _n: F }) {
        return `${this.lhs} = ${this.rhs};` + F;
      }
      optimizeNames(F, B) {
        if (!(this.lhs instanceof e.Name && !F[this.lhs.str] && !this.sideEffects))
          return this.rhs = O(this.rhs, F, B), this;
      }
      get names() {
        const F = this.lhs instanceof e.Name ? {} : { ...this.lhs.names };
        return A(F, this.rhs);
      }
    }
    class l extends a {
      constructor(F, B, H, Z) {
        super(F, H, Z), this.op = B;
      }
      render({ _n: F }) {
        return `${this.lhs} ${this.op}= ${this.rhs};` + F;
      }
    }
    class c extends i {
      constructor(F) {
        super(), this.label = F, this.names = {};
      }
      render({ _n: F }) {
        return `${this.label}:` + F;
      }
    }
    class u extends i {
      constructor(F) {
        super(), this.label = F, this.names = {};
      }
      render({ _n: F }) {
        return `break${this.label ? ` ${this.label}` : ""};` + F;
      }
    }
    class d extends i {
      constructor(F) {
        super(), this.error = F;
      }
      render({ _n: F }) {
        return `throw ${this.error};` + F;
      }
      get names() {
        return this.error.names;
      }
    }
    class f extends i {
      constructor(F) {
        super(), this.code = F;
      }
      render({ _n: F }) {
        return `${this.code};` + F;
      }
      optimizeNodes() {
        return `${this.code}` ? this : void 0;
      }
      optimizeNames(F, B) {
        return this.code = O(this.code, F, B), this;
      }
      get names() {
        return this.code instanceof e._CodeOrName ? this.code.names : {};
      }
    }
    class h extends i {
      constructor(F = []) {
        super(), this.nodes = F;
      }
      render(F) {
        return this.nodes.reduce((B, H) => B + H.render(F), "");
      }
      optimizeNodes() {
        const { nodes: F } = this;
        let B = F.length;
        for (; B--; ) {
          const H = F[B].optimizeNodes();
          Array.isArray(H) ? F.splice(B, 1, ...H) : H ? F[B] = H : F.splice(B, 1);
        }
        return F.length > 0 ? this : void 0;
      }
      optimizeNames(F, B) {
        const { nodes: H } = this;
        let Z = H.length;
        for (; Z--; ) {
          const W = H[Z];
          W.optimizeNames(F, B) || (k(F, W.names), H.splice(Z, 1));
        }
        return H.length > 0 ? this : void 0;
      }
      get names() {
        return this.nodes.reduce((F, B) => N(F, B.names), {});
      }
    }
    class p extends h {
      render(F) {
        return "{" + F._n + super.render(F) + "}" + F._n;
      }
    }
    class m extends h {
    }
    class g extends p {
    }
    g.kind = "else";
    class y extends p {
      constructor(F, B) {
        super(B), this.condition = F;
      }
      render(F) {
        let B = `if(${this.condition})` + super.render(F);
        return this.else && (B += "else " + this.else.render(F)), B;
      }
      optimizeNodes() {
        super.optimizeNodes();
        const F = this.condition;
        if (F === !0)
          return this.nodes;
        let B = this.else;
        if (B) {
          const H = B.optimizeNodes();
          B = this.else = Array.isArray(H) ? new g(H) : H;
        }
        if (B)
          return F === !1 ? B instanceof y ? B : B.nodes : this.nodes.length ? this : new y(T(F), B instanceof y ? [B] : B.nodes);
        if (!(F === !1 || !this.nodes.length))
          return this;
      }
      optimizeNames(F, B) {
        var H;
        if (this.else = (H = this.else) === null || H === void 0 ? void 0 : H.optimizeNames(F, B), !!(super.optimizeNames(F, B) || this.else))
          return this.condition = O(this.condition, F, B), this;
      }
      get names() {
        const F = super.names;
        return A(F, this.condition), this.else && N(F, this.else.names), F;
      }
    }
    y.kind = "if";
    class v extends p {
    }
    v.kind = "for";
    class b extends v {
      constructor(F) {
        super(), this.iteration = F;
      }
      render(F) {
        return `for(${this.iteration})` + super.render(F);
      }
      optimizeNames(F, B) {
        if (super.optimizeNames(F, B))
          return this.iteration = O(this.iteration, F, B), this;
      }
      get names() {
        return N(super.names, this.iteration.names);
      }
    }
    class _ extends v {
      constructor(F, B, H, Z) {
        super(), this.varKind = F, this.name = B, this.from = H, this.to = Z;
      }
      render(F) {
        const B = F.es5 ? n.varKinds.var : this.varKind, { name: H, from: Z, to: W } = this;
        return `for(${B} ${H}=${Z}; ${H}<${W}; ${H}++)` + super.render(F);
      }
      get names() {
        const F = A(super.names, this.from);
        return A(F, this.to);
      }
    }
    class w extends v {
      constructor(F, B, H, Z) {
        super(), this.loop = F, this.varKind = B, this.name = H, this.iterable = Z;
      }
      render(F) {
        return `for(${this.varKind} ${this.name} ${this.loop} ${this.iterable})` + super.render(F);
      }
      optimizeNames(F, B) {
        if (super.optimizeNames(F, B))
          return this.iterable = O(this.iterable, F, B), this;
      }
      get names() {
        return N(super.names, this.iterable.names);
      }
    }
    class x extends p {
      constructor(F, B, H) {
        super(), this.name = F, this.args = B, this.async = H;
      }
      render(F) {
        return `${this.async ? "async " : ""}function ${this.name}(${this.args})` + super.render(F);
      }
    }
    x.kind = "func";
    class E extends h {
      render(F) {
        return "return " + super.render(F);
      }
    }
    E.kind = "return";
    class S extends p {
      render(F) {
        let B = "try" + super.render(F);
        return this.catch && (B += this.catch.render(F)), this.finally && (B += this.finally.render(F)), B;
      }
      optimizeNodes() {
        var F, B;
        return super.optimizeNodes(), (F = this.catch) === null || F === void 0 || F.optimizeNodes(), (B = this.finally) === null || B === void 0 || B.optimizeNodes(), this;
      }
      optimizeNames(F, B) {
        var H, Z;
        return super.optimizeNames(F, B), (H = this.catch) === null || H === void 0 || H.optimizeNames(F, B), (Z = this.finally) === null || Z === void 0 || Z.optimizeNames(F, B), this;
      }
      get names() {
        const F = super.names;
        return this.catch && N(F, this.catch.names), this.finally && N(F, this.finally.names), F;
      }
    }
    class C extends p {
      constructor(F) {
        super(), this.error = F;
      }
      render(F) {
        return `catch(${this.error})` + super.render(F);
      }
    }
    C.kind = "catch";
    class R extends p {
      render(F) {
        return "finally" + super.render(F);
      }
    }
    R.kind = "finally";
    class P {
      constructor(F, B = {}) {
        this._values = {}, this._blockStarts = [], this._constants = {}, this.opts = { ...B, _n: B.lines ? `
` : "" }, this._extScope = F, this._scope = new n.Scope({ parent: F }), this._nodes = [new m()];
      }
      toString() {
        return this._root.render(this.opts);
      }
      // returns unique name in the internal scope
      name(F) {
        return this._scope.name(F);
      }
      // reserves unique name in the external scope
      scopeName(F) {
        return this._extScope.name(F);
      }
      // reserves unique name in the external scope and assigns value to it
      scopeValue(F, B) {
        const H = this._extScope.value(F, B);
        return (this._values[H.prefix] || (this._values[H.prefix] = /* @__PURE__ */ new Set())).add(H), H;
      }
      getScopeValue(F, B) {
        return this._extScope.getValue(F, B);
      }
      // return code that assigns values in the external scope to the names that are used internally
      // (same names that were returned by gen.scopeName or gen.scopeValue)
      scopeRefs(F) {
        return this._extScope.scopeRefs(F, this._values);
      }
      scopeCode() {
        return this._extScope.scopeCode(this._values);
      }
      _def(F, B, H, Z) {
        const W = this._scope.toName(B);
        return H !== void 0 && Z && (this._constants[W.str] = H), this._leafNode(new s(F, W, H)), W;
      }
      // `const` declaration (`var` in es5 mode)
      const(F, B, H) {
        return this._def(n.varKinds.const, F, B, H);
      }
      // `let` declaration with optional assignment (`var` in es5 mode)
      let(F, B, H) {
        return this._def(n.varKinds.let, F, B, H);
      }
      // `var` declaration with optional assignment
      var(F, B, H) {
        return this._def(n.varKinds.var, F, B, H);
      }
      // assignment code
      assign(F, B, H) {
        return this._leafNode(new a(F, B, H));
      }
      // `+=` code
      add(F, B) {
        return this._leafNode(new l(F, t.operators.ADD, B));
      }
      // appends passed SafeExpr to code or executes Block
      code(F) {
        return typeof F == "function" ? F() : F !== e.nil && this._leafNode(new f(F)), this;
      }
      // returns code for object literal for the passed argument list of key-value pairs
      object(...F) {
        const B = ["{"];
        for (const [H, Z] of F)
          B.length > 1 && B.push(","), B.push(H), (H !== Z || this.opts.es5) && (B.push(":"), (0, e.addCodeArg)(B, Z));
        return B.push("}"), new e._Code(B);
      }
      // `if` clause (or statement if `thenBody` and, optionally, `elseBody` are passed)
      if(F, B, H) {
        if (this._blockNode(new y(F)), B && H)
          this.code(B).else().code(H).endIf();
        else if (B)
          this.code(B).endIf();
        else if (H)
          throw new Error('CodeGen: "else" body without "then" body');
        return this;
      }
      // `else if` clause - invalid without `if` or after `else` clauses
      elseIf(F) {
        return this._elseNode(new y(F));
      }
      // `else` clause - only valid after `if` or `else if` clauses
      else() {
        return this._elseNode(new g());
      }
      // end `if` statement (needed if gen.if was used only with condition)
      endIf() {
        return this._endBlockNode(y, g);
      }
      _for(F, B) {
        return this._blockNode(F), B && this.code(B).endFor(), this;
      }
      // a generic `for` clause (or statement if `forBody` is passed)
      for(F, B) {
        return this._for(new b(F), B);
      }
      // `for` statement for a range of values
      forRange(F, B, H, Z, W = this.opts.es5 ? n.varKinds.var : n.varKinds.let) {
        const G = this._scope.toName(F);
        return this._for(new _(W, G, B, H), () => Z(G));
      }
      // `for-of` statement (in es5 mode replace with a normal for loop)
      forOf(F, B, H, Z = n.varKinds.const) {
        const W = this._scope.toName(F);
        if (this.opts.es5) {
          const G = B instanceof e.Name ? B : this.var("_arr", B);
          return this.forRange("_i", 0, (0, e._)`${G}.length`, (ee) => {
            this.var(W, (0, e._)`${G}[${ee}]`), H(W);
          });
        }
        return this._for(new w("of", Z, W, B), () => H(W));
      }
      // `for-in` statement.
      // With option `ownProperties` replaced with a `for-of` loop for object keys
      forIn(F, B, H, Z = this.opts.es5 ? n.varKinds.var : n.varKinds.const) {
        if (this.opts.ownProperties)
          return this.forOf(F, (0, e._)`Object.keys(${B})`, H);
        const W = this._scope.toName(F);
        return this._for(new w("in", Z, W, B), () => H(W));
      }
      // end `for` loop
      endFor() {
        return this._endBlockNode(v);
      }
      // `label` statement
      label(F) {
        return this._leafNode(new c(F));
      }
      // `break` statement
      break(F) {
        return this._leafNode(new u(F));
      }
      // `return` statement
      return(F) {
        const B = new E();
        if (this._blockNode(B), this.code(F), B.nodes.length !== 1)
          throw new Error('CodeGen: "return" should have one node');
        return this._endBlockNode(E);
      }
      // `try` statement
      try(F, B, H) {
        if (!B && !H)
          throw new Error('CodeGen: "try" without "catch" and "finally"');
        const Z = new S();
        if (this._blockNode(Z), this.code(F), B) {
          const W = this.name("e");
          this._currNode = Z.catch = new C(W), B(W);
        }
        return H && (this._currNode = Z.finally = new R(), this.code(H)), this._endBlockNode(C, R);
      }
      // `throw` statement
      throw(F) {
        return this._leafNode(new d(F));
      }
      // start self-balancing block
      block(F, B) {
        return this._blockStarts.push(this._nodes.length), F && this.code(F).endBlock(B), this;
      }
      // end the current self-balancing block
      endBlock(F) {
        const B = this._blockStarts.pop();
        if (B === void 0)
          throw new Error("CodeGen: not in self-balancing block");
        const H = this._nodes.length - B;
        if (H < 0 || F !== void 0 && H !== F)
          throw new Error(`CodeGen: wrong number of nodes: ${H} vs ${F} expected`);
        return this._nodes.length = B, this;
      }
      // `function` heading (or definition if funcBody is passed)
      func(F, B = e.nil, H, Z) {
        return this._blockNode(new x(F, B, H)), Z && this.code(Z).endFunc(), this;
      }
      // end function definition
      endFunc() {
        return this._endBlockNode(x);
      }
      optimize(F = 1) {
        for (; F-- > 0; )
          this._root.optimizeNodes(), this._root.optimizeNames(this._root.names, this._constants);
      }
      _leafNode(F) {
        return this._currNode.nodes.push(F), this;
      }
      _blockNode(F) {
        this._currNode.nodes.push(F), this._nodes.push(F);
      }
      _endBlockNode(F, B) {
        const H = this._currNode;
        if (H instanceof F || B && H instanceof B)
          return this._nodes.pop(), this;
        throw new Error(`CodeGen: not in block "${B ? `${F.kind}/${B.kind}` : F.kind}"`);
      }
      _elseNode(F) {
        const B = this._currNode;
        if (!(B instanceof y))
          throw new Error('CodeGen: "else" without "if"');
        return this._currNode = B.else = F, this;
      }
      get _root() {
        return this._nodes[0];
      }
      get _currNode() {
        const F = this._nodes;
        return F[F.length - 1];
      }
      set _currNode(F) {
        const B = this._nodes;
        B[B.length - 1] = F;
      }
    }
    t.CodeGen = P;
    function N(q, F) {
      for (const B in F)
        q[B] = (q[B] || 0) + (F[B] || 0);
      return q;
    }
    function A(q, F) {
      return F instanceof e._CodeOrName ? N(q, F.names) : q;
    }
    function O(q, F, B) {
      if (q instanceof e.Name)
        return H(q);
      if (!Z(q))
        return q;
      return new e._Code(q._items.reduce((W, G) => (G instanceof e.Name && (G = H(G)), G instanceof e._Code ? W.push(...G._items) : W.push(G), W), []));
      function H(W) {
        const G = B[W.str];
        return G === void 0 || F[W.str] !== 1 ? W : (delete F[W.str], G);
      }
      function Z(W) {
        return W instanceof e._Code && W._items.some((G) => G instanceof e.Name && F[G.str] === 1 && B[G.str] !== void 0);
      }
    }
    function k(q, F) {
      for (const B in F)
        q[B] = (q[B] || 0) - (F[B] || 0);
    }
    function T(q) {
      return typeof q == "boolean" || typeof q == "number" || q === null ? !q : (0, e._)`!${U(q)}`;
    }
    t.not = T;
    const I = D(t.operators.AND);
    function j(...q) {
      return q.reduce(I);
    }
    t.and = j;
    const z = D(t.operators.OR);
    function $(...q) {
      return q.reduce(z);
    }
    t.or = $;
    function D(q) {
      return (F, B) => F === e.nil ? B : B === e.nil ? F : (0, e._)`${U(F)} ${q} ${U(B)}`;
    }
    function U(q) {
      return q instanceof e.Name ? q : (0, e._)`(${q})`;
    }
  }(ZM)), ZM;
}
var $t = {}, Ere;
function Jt() {
  if (Ere) return $t;
  Ere = 1, Object.defineProperty($t, "__esModule", { value: !0 }), $t.checkStrictMode = $t.getErrorPath = $t.Type = $t.useFunc = $t.setEvaluated = $t.evaluatedPropsToName = $t.mergeEvaluated = $t.eachItem = $t.unescapeJsonPointer = $t.escapeJsonPointer = $t.escapeFragment = $t.unescapeFragment = $t.schemaRefOrVal = $t.schemaHasRulesButRef = $t.schemaHasRules = $t.checkUnknownRules = $t.alwaysValidSchema = $t.toHash = void 0;
  const t = Mt(), e = FE();
  function n(w) {
    const x = {};
    for (const E of w)
      x[E] = !0;
    return x;
  }
  $t.toHash = n;
  function r(w, x) {
    return typeof x == "boolean" ? x : Object.keys(x).length === 0 ? !0 : (o(w, x), !i(x, w.self.RULES.all));
  }
  $t.alwaysValidSchema = r;
  function o(w, x = w.schema) {
    const { opts: E, self: S } = w;
    if (!E.strictSchema || typeof x == "boolean")
      return;
    const C = S.RULES.keywords;
    for (const R in x)
      C[R] || _(w, `unknown keyword: "${R}"`);
  }
  $t.checkUnknownRules = o;
  function i(w, x) {
    if (typeof w == "boolean")
      return !w;
    for (const E in w)
      if (x[E])
        return !0;
    return !1;
  }
  $t.schemaHasRules = i;
  function s(w, x) {
    if (typeof w == "boolean")
      return !w;
    for (const E in w)
      if (E !== "$ref" && x.all[E])
        return !0;
    return !1;
  }
  $t.schemaHasRulesButRef = s;
  function a({ topSchemaRef: w, schemaPath: x }, E, S, C) {
    if (!C) {
      if (typeof E == "number" || typeof E == "boolean")
        return E;
      if (typeof E == "string")
        return (0, t._)`${E}`;
    }
    return (0, t._)`${w}${x}${(0, t.getProperty)(S)}`;
  }
  $t.schemaRefOrVal = a;
  function l(w) {
    return d(decodeURIComponent(w));
  }
  $t.unescapeFragment = l;
  function c(w) {
    return encodeURIComponent(u(w));
  }
  $t.escapeFragment = c;
  function u(w) {
    return typeof w == "number" ? `${w}` : w.replace(/~/g, "~0").replace(/\//g, "~1");
  }
  $t.escapeJsonPointer = u;
  function d(w) {
    return w.replace(/~1/g, "/").replace(/~0/g, "~");
  }
  $t.unescapeJsonPointer = d;
  function f(w, x) {
    if (Array.isArray(w))
      for (const E of w)
        x(E);
    else
      x(w);
  }
  $t.eachItem = f;
  function h({ mergeNames: w, mergeToName: x, mergeValues: E, resultToName: S }) {
    return (C, R, P, N) => {
      const A = P === void 0 ? R : P instanceof t.Name ? (R instanceof t.Name ? w(C, R, P) : x(C, R, P), P) : R instanceof t.Name ? (x(C, P, R), R) : E(R, P);
      return N === t.Name && !(A instanceof t.Name) ? S(C, A) : A;
    };
  }
  $t.mergeEvaluated = {
    props: h({
      mergeNames: (w, x, E) => w.if((0, t._)`${E} !== true && ${x} !== undefined`, () => {
        w.if((0, t._)`${x} === true`, () => w.assign(E, !0), () => w.assign(E, (0, t._)`${E} || {}`).code((0, t._)`Object.assign(${E}, ${x})`));
      }),
      mergeToName: (w, x, E) => w.if((0, t._)`${E} !== true`, () => {
        x === !0 ? w.assign(E, !0) : (w.assign(E, (0, t._)`${E} || {}`), m(w, E, x));
      }),
      mergeValues: (w, x) => w === !0 ? !0 : { ...w, ...x },
      resultToName: p
    }),
    items: h({
      mergeNames: (w, x, E) => w.if((0, t._)`${E} !== true && ${x} !== undefined`, () => w.assign(E, (0, t._)`${x} === true ? true : ${E} > ${x} ? ${E} : ${x}`)),
      mergeToName: (w, x, E) => w.if((0, t._)`${E} !== true`, () => w.assign(E, x === !0 ? !0 : (0, t._)`${E} > ${x} ? ${E} : ${x}`)),
      mergeValues: (w, x) => w === !0 ? !0 : Math.max(w, x),
      resultToName: (w, x) => w.var("items", x)
    })
  };
  function p(w, x) {
    if (x === !0)
      return w.var("props", !0);
    const E = w.var("props", (0, t._)`{}`);
    return x !== void 0 && m(w, E, x), E;
  }
  $t.evaluatedPropsToName = p;
  function m(w, x, E) {
    Object.keys(E).forEach((S) => w.assign((0, t._)`${x}${(0, t.getProperty)(S)}`, !0));
  }
  $t.setEvaluated = m;
  const g = {};
  function y(w, x) {
    return w.scopeValue("func", {
      ref: x,
      code: g[x.code] || (g[x.code] = new e._Code(x.code))
    });
  }
  $t.useFunc = y;
  var v;
  (function(w) {
    w[w.Num = 0] = "Num", w[w.Str = 1] = "Str";
  })(v || ($t.Type = v = {}));
  function b(w, x, E) {
    if (w instanceof t.Name) {
      const S = x === v.Num;
      return E ? S ? (0, t._)`"[" + ${w} + "]"` : (0, t._)`"['" + ${w} + "']"` : S ? (0, t._)`"/" + ${w}` : (0, t._)`"/" + ${w}.replace(/~/g, "~0").replace(/\\//g, "~1")`;
    }
    return E ? (0, t.getProperty)(w).toString() : "/" + u(w);
  }
  $t.getErrorPath = b;
  function _(w, x, E = w.opts.strictSchema) {
    if (E) {
      if (x = `strict mode: ${x}`, E === !0)
        throw new Error(x);
      w.self.logger.warn(x);
    }
  }
  return $t.checkStrictMode = _, $t;
}
var U1 = {}, Sre;
function fu() {
  if (Sre) return U1;
  Sre = 1, Object.defineProperty(U1, "__esModule", { value: !0 });
  const t = Mt(), e = {
    // validation function arguments
    data: new t.Name("data"),
    // data passed to validation function
    // args passed from referencing schema
    valCxt: new t.Name("valCxt"),
    // validation/data context - should not be used directly, it is destructured to the names below
    instancePath: new t.Name("instancePath"),
    parentData: new t.Name("parentData"),
    parentDataProperty: new t.Name("parentDataProperty"),
    rootData: new t.Name("rootData"),
    // root data - same as the data passed to the first/top validation function
    dynamicAnchors: new t.Name("dynamicAnchors"),
    // used to support recursiveRef and dynamicRef
    // function scoped variables
    vErrors: new t.Name("vErrors"),
    // null or array of validation errors
    errors: new t.Name("errors"),
    // counter of validation errors
    this: new t.Name("this"),
    // "globals"
    self: new t.Name("self"),
    scope: new t.Name("scope"),
    // JTD serialize/parse name for JSON string and position
    json: new t.Name("json"),
    jsonPos: new t.Name("jsonPos"),
    jsonLen: new t.Name("jsonLen"),
    jsonPart: new t.Name("jsonPart")
  };
  return U1.default = e, U1;
}
var Ore;
function BO() {
  return Ore || (Ore = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.extendErrors = t.resetErrorsCount = t.reportExtraError = t.reportError = t.keyword$DataError = t.keywordError = void 0;
    const e = Mt(), n = Jt(), r = fu();
    t.keywordError = {
      message: ({ keyword: g }) => (0, e.str)`must pass "${g}" keyword validation`
    }, t.keyword$DataError = {
      message: ({ keyword: g, schemaType: y }) => y ? (0, e.str)`"${g}" keyword must be ${y} ($data)` : (0, e.str)`"${g}" keyword is invalid ($data)`
    };
    function o(g, y = t.keywordError, v, b) {
      const { it: _ } = g, { gen: w, compositeRule: x, allErrors: E } = _, S = d(g, y, v);
      b ?? (x || E) ? l(w, S) : c(_, (0, e._)`[${S}]`);
    }
    t.reportError = o;
    function i(g, y = t.keywordError, v) {
      const { it: b } = g, { gen: _, compositeRule: w, allErrors: x } = b, E = d(g, y, v);
      l(_, E), w || x || c(b, r.default.vErrors);
    }
    t.reportExtraError = i;
    function s(g, y) {
      g.assign(r.default.errors, y), g.if((0, e._)`${r.default.vErrors} !== null`, () => g.if(y, () => g.assign((0, e._)`${r.default.vErrors}.length`, y), () => g.assign(r.default.vErrors, null)));
    }
    t.resetErrorsCount = s;
    function a({ gen: g, keyword: y, schemaValue: v, data: b, errsCount: _, it: w }) {
      if (_ === void 0)
        throw new Error("ajv implementation error");
      const x = g.name("err");
      g.forRange("i", _, r.default.errors, (E) => {
        g.const(x, (0, e._)`${r.default.vErrors}[${E}]`), g.if((0, e._)`${x}.instancePath === undefined`, () => g.assign((0, e._)`${x}.instancePath`, (0, e.strConcat)(r.default.instancePath, w.errorPath))), g.assign((0, e._)`${x}.schemaPath`, (0, e.str)`${w.errSchemaPath}/${y}`), w.opts.verbose && (g.assign((0, e._)`${x}.schema`, v), g.assign((0, e._)`${x}.data`, b));
      });
    }
    t.extendErrors = a;
    function l(g, y) {
      const v = g.const("err", y);
      g.if((0, e._)`${r.default.vErrors} === null`, () => g.assign(r.default.vErrors, (0, e._)`[${v}]`), (0, e._)`${r.default.vErrors}.push(${v})`), g.code((0, e._)`${r.default.errors}++`);
    }
    function c(g, y) {
      const { gen: v, validateName: b, schemaEnv: _ } = g;
      _.$async ? v.throw((0, e._)`new ${g.ValidationError}(${y})`) : (v.assign((0, e._)`${b}.errors`, y), v.return(!1));
    }
    const u = {
      keyword: new e.Name("keyword"),
      schemaPath: new e.Name("schemaPath"),
      // also used in JTD errors
      params: new e.Name("params"),
      propertyName: new e.Name("propertyName"),
      message: new e.Name("message"),
      schema: new e.Name("schema"),
      parentSchema: new e.Name("parentSchema")
    };
    function d(g, y, v) {
      const { createErrors: b } = g.it;
      return b === !1 ? (0, e._)`{}` : f(g, y, v);
    }
    function f(g, y, v = {}) {
      const { gen: b, it: _ } = g, w = [
        h(_, v),
        p(g, v)
      ];
      return m(g, y, w), b.object(...w);
    }
    function h({ errorPath: g }, { instancePath: y }) {
      const v = y ? (0, e.str)`${g}${(0, n.getErrorPath)(y, n.Type.Str)}` : g;
      return [r.default.instancePath, (0, e.strConcat)(r.default.instancePath, v)];
    }
    function p({ keyword: g, it: { errSchemaPath: y } }, { schemaPath: v, parentSchema: b }) {
      let _ = b ? y : (0, e.str)`${y}/${g}`;
      return v && (_ = (0, e.str)`${_}${(0, n.getErrorPath)(v, n.Type.Str)}`), [u.schemaPath, _];
    }
    function m(g, { params: y, message: v }, b) {
      const { keyword: _, data: w, schemaValue: x, it: E } = g, { opts: S, propertyName: C, topSchemaRef: R, schemaPath: P } = E;
      b.push([u.keyword, _], [u.params, typeof y == "function" ? y(g) : y || (0, e._)`{}`]), S.messages && b.push([u.message, typeof v == "function" ? v(g) : v]), S.verbose && b.push([u.schema, x], [u.parentSchema, (0, e._)`${R}${P}`], [r.default.data, w]), C && b.push([u.propertyName, C]);
    }
  }(QM)), QM;
}
var Cre;
function Q1t() {
  if (Cre) return Su;
  Cre = 1, Object.defineProperty(Su, "__esModule", { value: !0 }), Su.boolOrEmptySchema = Su.topBoolOrEmptySchema = void 0;
  const t = BO(), e = Mt(), n = fu(), r = {
    message: "boolean schema is false"
  };
  function o(a) {
    const { gen: l, schema: c, validateName: u } = a;
    c === !1 ? s(a, !1) : typeof c == "object" && c.$async === !0 ? l.return(n.default.data) : (l.assign((0, e._)`${u}.errors`, null), l.return(!0));
  }
  Su.topBoolOrEmptySchema = o;
  function i(a, l) {
    const { gen: c, schema: u } = a;
    u === !1 ? (c.var(l, !1), s(a)) : c.var(l, !0);
  }
  Su.boolOrEmptySchema = i;
  function s(a, l) {
    const { gen: c, data: u } = a, d = {
      gen: c,
      keyword: "false schema",
      data: u,
      schema: !1,
      schemaCode: !1,
      schemaValue: !1,
      params: {},
      it: a
    };
    (0, t.reportError)(d, r, void 0, l);
  }
  return Su;
}
var Gr = {}, Ou = {}, kre;
function a_e() {
  if (kre) return Ou;
  kre = 1, Object.defineProperty(Ou, "__esModule", { value: !0 }), Ou.getRules = Ou.isJSONType = void 0;
  const t = ["string", "number", "integer", "boolean", "null", "object", "array"], e = new Set(t);
  function n(o) {
    return typeof o == "string" && e.has(o);
  }
  Ou.isJSONType = n;
  function r() {
    const o = {
      number: { type: "number", rules: [] },
      string: { type: "string", rules: [] },
      array: { type: "array", rules: [] },
      object: { type: "object", rules: [] }
    };
    return {
      types: { ...o, integer: !0, boolean: !0, null: !0 },
      rules: [{ rules: [] }, o.number, o.string, o.array, o.object],
      post: { rules: [] },
      all: {},
      keywords: {}
    };
  }
  return Ou.getRules = r, Ou;
}
var Ha = {}, Are;
function l_e() {
  if (Are) return Ha;
  Are = 1, Object.defineProperty(Ha, "__esModule", { value: !0 }), Ha.shouldUseRule = Ha.shouldUseGroup = Ha.schemaHasRulesForType = void 0;
  function t({ schema: r, self: o }, i) {
    const s = o.RULES.types[i];
    return s && s !== !0 && e(r, s);
  }
  Ha.schemaHasRulesForType = t;
  function e(r, o) {
    return o.rules.some((i) => n(r, i));
  }
  Ha.shouldUseGroup = e;
  function n(r, o) {
    var i;
    return r[o.keyword] !== void 0 || ((i = o.definition.implements) === null || i === void 0 ? void 0 : i.some((s) => r[s] !== void 0));
  }
  return Ha.shouldUseRule = n, Ha;
}
var Tre;
function BE() {
  if (Tre) return Gr;
  Tre = 1, Object.defineProperty(Gr, "__esModule", { value: !0 }), Gr.reportTypeError = Gr.checkDataTypes = Gr.checkDataType = Gr.coerceAndCheckDataType = Gr.getJSONTypes = Gr.getSchemaTypes = Gr.DataType = void 0;
  const t = a_e(), e = l_e(), n = BO(), r = Mt(), o = Jt();
  var i;
  (function(v) {
    v[v.Correct = 0] = "Correct", v[v.Wrong = 1] = "Wrong";
  })(i || (Gr.DataType = i = {}));
  function s(v) {
    const b = a(v.type);
    if (b.includes("null")) {
      if (v.nullable === !1)
        throw new Error("type: null contradicts nullable: false");
    } else {
      if (!b.length && v.nullable !== void 0)
        throw new Error('"nullable" cannot be used without "type"');
      v.nullable === !0 && b.push("null");
    }
    return b;
  }
  Gr.getSchemaTypes = s;
  function a(v) {
    const b = Array.isArray(v) ? v : v ? [v] : [];
    if (b.every(t.isJSONType))
      return b;
    throw new Error("type must be JSONType or JSONType[]: " + b.join(","));
  }
  Gr.getJSONTypes = a;
  function l(v, b) {
    const { gen: _, data: w, opts: x } = v, E = u(b, x.coerceTypes), S = b.length > 0 && !(E.length === 0 && b.length === 1 && (0, e.schemaHasRulesForType)(v, b[0]));
    if (S) {
      const C = p(b, w, x.strictNumbers, i.Wrong);
      _.if(C, () => {
        E.length ? d(v, b, E) : g(v);
      });
    }
    return S;
  }
  Gr.coerceAndCheckDataType = l;
  const c = /* @__PURE__ */ new Set(["string", "number", "integer", "boolean", "null"]);
  function u(v, b) {
    return b ? v.filter((_) => c.has(_) || b === "array" && _ === "array") : [];
  }
  function d(v, b, _) {
    const { gen: w, data: x, opts: E } = v, S = w.let("dataType", (0, r._)`typeof ${x}`), C = w.let("coerced", (0, r._)`undefined`);
    E.coerceTypes === "array" && w.if((0, r._)`${S} == 'object' && Array.isArray(${x}) && ${x}.length == 1`, () => w.assign(x, (0, r._)`${x}[0]`).assign(S, (0, r._)`typeof ${x}`).if(p(b, x, E.strictNumbers), () => w.assign(C, x))), w.if((0, r._)`${C} !== undefined`);
    for (const P of _)
      (c.has(P) || P === "array" && E.coerceTypes === "array") && R(P);
    w.else(), g(v), w.endIf(), w.if((0, r._)`${C} !== undefined`, () => {
      w.assign(x, C), f(v, C);
    });
    function R(P) {
      switch (P) {
        case "string":
          w.elseIf((0, r._)`${S} == "number" || ${S} == "boolean"`).assign(C, (0, r._)`"" + ${x}`).elseIf((0, r._)`${x} === null`).assign(C, (0, r._)`""`);
          return;
        case "number":
          w.elseIf((0, r._)`${S} == "boolean" || ${x} === null
              || (${S} == "string" && ${x} && ${x} == +${x})`).assign(C, (0, r._)`+${x}`);
          return;
        case "integer":
          w.elseIf((0, r._)`${S} === "boolean" || ${x} === null
              || (${S} === "string" && ${x} && ${x} == +${x} && !(${x} % 1))`).assign(C, (0, r._)`+${x}`);
          return;
        case "boolean":
          w.elseIf((0, r._)`${x} === "false" || ${x} === 0 || ${x} === null`).assign(C, !1).elseIf((0, r._)`${x} === "true" || ${x} === 1`).assign(C, !0);
          return;
        case "null":
          w.elseIf((0, r._)`${x} === "" || ${x} === 0 || ${x} === false`), w.assign(C, null);
          return;
        case "array":
          w.elseIf((0, r._)`${S} === "string" || ${S} === "number"
              || ${S} === "boolean" || ${x} === null`).assign(C, (0, r._)`[${x}]`);
      }
    }
  }
  function f({ gen: v, parentData: b, parentDataProperty: _ }, w) {
    v.if((0, r._)`${b} !== undefined`, () => v.assign((0, r._)`${b}[${_}]`, w));
  }
  function h(v, b, _, w = i.Correct) {
    const x = w === i.Correct ? r.operators.EQ : r.operators.NEQ;
    let E;
    switch (v) {
      case "null":
        return (0, r._)`${b} ${x} null`;
      case "array":
        E = (0, r._)`Array.isArray(${b})`;
        break;
      case "object":
        E = (0, r._)`${b} && typeof ${b} == "object" && !Array.isArray(${b})`;
        break;
      case "integer":
        E = S((0, r._)`!(${b} % 1) && !isNaN(${b})`);
        break;
      case "number":
        E = S();
        break;
      default:
        return (0, r._)`typeof ${b} ${x} ${v}`;
    }
    return w === i.Correct ? E : (0, r.not)(E);
    function S(C = r.nil) {
      return (0, r.and)((0, r._)`typeof ${b} == "number"`, C, _ ? (0, r._)`isFinite(${b})` : r.nil);
    }
  }
  Gr.checkDataType = h;
  function p(v, b, _, w) {
    if (v.length === 1)
      return h(v[0], b, _, w);
    let x;
    const E = (0, o.toHash)(v);
    if (E.array && E.object) {
      const S = (0, r._)`typeof ${b} != "object"`;
      x = E.null ? S : (0, r._)`!${b} || ${S}`, delete E.null, delete E.array, delete E.object;
    } else
      x = r.nil;
    E.number && delete E.integer;
    for (const S in E)
      x = (0, r.and)(x, h(S, b, _, w));
    return x;
  }
  Gr.checkDataTypes = p;
  const m = {
    message: ({ schema: v }) => `must be ${v}`,
    params: ({ schema: v, schemaValue: b }) => typeof v == "string" ? (0, r._)`{type: ${v}}` : (0, r._)`{type: ${b}}`
  };
  function g(v) {
    const b = y(v);
    (0, n.reportError)(b, m);
  }
  Gr.reportTypeError = g;
  function y(v) {
    const { gen: b, data: _, schema: w } = v, x = (0, o.schemaRefOrVal)(v, w, "type");
    return {
      gen: b,
      keyword: "type",
      data: _,
      schema: w.type,
      schemaCode: x,
      schemaValue: x,
      parentSchema: w,
      params: {},
      it: v
    };
  }
  return Gr;
}
var Mm = {}, Rre;
function Z1t() {
  if (Rre) return Mm;
  Rre = 1, Object.defineProperty(Mm, "__esModule", { value: !0 }), Mm.assignDefaults = void 0;
  const t = Mt(), e = Jt();
  function n(o, i) {
    const { properties: s, items: a } = o.schema;
    if (i === "object" && s)
      for (const l in s)
        r(o, l, s[l].default);
    else i === "array" && Array.isArray(a) && a.forEach((l, c) => r(o, c, l.default));
  }
  Mm.assignDefaults = n;
  function r(o, i, s) {
    const { gen: a, compositeRule: l, data: c, opts: u } = o;
    if (s === void 0)
      return;
    const d = (0, t._)`${c}${(0, t.getProperty)(i)}`;
    if (l) {
      (0, e.checkStrictMode)(o, `default is ignored for: ${d}`);
      return;
    }
    let f = (0, t._)`${d} === undefined`;
    u.useDefaults === "empty" && (f = (0, t._)`${f} || ${d} === null || ${d} === ""`), a.if(f, (0, t._)`${d} = ${(0, t.stringify)(s)}`);
  }
  return Mm;
}
var ps = {}, Sn = {}, Pre;
function js() {
  if (Pre) return Sn;
  Pre = 1, Object.defineProperty(Sn, "__esModule", { value: !0 }), Sn.validateUnion = Sn.validateArray = Sn.usePattern = Sn.callValidateCode = Sn.schemaProperties = Sn.allSchemaProperties = Sn.noPropertyInData = Sn.propertyInData = Sn.isOwnProperty = Sn.hasPropFunc = Sn.reportMissingProp = Sn.checkMissingProp = Sn.checkReportMissingProp = void 0;
  const t = Mt(), e = Jt(), n = fu(), r = Jt();
  function o(v, b) {
    const { gen: _, data: w, it: x } = v;
    _.if(u(_, w, b, x.opts.ownProperties), () => {
      v.setParams({ missingProperty: (0, t._)`${b}` }, !0), v.error();
    });
  }
  Sn.checkReportMissingProp = o;
  function i({ gen: v, data: b, it: { opts: _ } }, w, x) {
    return (0, t.or)(...w.map((E) => (0, t.and)(u(v, b, E, _.ownProperties), (0, t._)`${x} = ${E}`)));
  }
  Sn.checkMissingProp = i;
  function s(v, b) {
    v.setParams({ missingProperty: b }, !0), v.error();
  }
  Sn.reportMissingProp = s;
  function a(v) {
    return v.scopeValue("func", {
      // eslint-disable-next-line @typescript-eslint/unbound-method
      ref: Object.prototype.hasOwnProperty,
      code: (0, t._)`Object.prototype.hasOwnProperty`
    });
  }
  Sn.hasPropFunc = a;
  function l(v, b, _) {
    return (0, t._)`${a(v)}.call(${b}, ${_})`;
  }
  Sn.isOwnProperty = l;
  function c(v, b, _, w) {
    const x = (0, t._)`${b}${(0, t.getProperty)(_)} !== undefined`;
    return w ? (0, t._)`${x} && ${l(v, b, _)}` : x;
  }
  Sn.propertyInData = c;
  function u(v, b, _, w) {
    const x = (0, t._)`${b}${(0, t.getProperty)(_)} === undefined`;
    return w ? (0, t.or)(x, (0, t.not)(l(v, b, _))) : x;
  }
  Sn.noPropertyInData = u;
  function d(v) {
    return v ? Object.keys(v).filter((b) => b !== "__proto__") : [];
  }
  Sn.allSchemaProperties = d;
  function f(v, b) {
    return d(b).filter((_) => !(0, e.alwaysValidSchema)(v, b[_]));
  }
  Sn.schemaProperties = f;
  function h({ schemaCode: v, data: b, it: { gen: _, topSchemaRef: w, schemaPath: x, errorPath: E }, it: S }, C, R, P) {
    const N = P ? (0, t._)`${v}, ${b}, ${w}${x}` : b, A = [
      [n.default.instancePath, (0, t.strConcat)(n.default.instancePath, E)],
      [n.default.parentData, S.parentData],
      [n.default.parentDataProperty, S.parentDataProperty],
      [n.default.rootData, n.default.rootData]
    ];
    S.opts.dynamicRef && A.push([n.default.dynamicAnchors, n.default.dynamicAnchors]);
    const O = (0, t._)`${N}, ${_.object(...A)}`;
    return R !== t.nil ? (0, t._)`${C}.call(${R}, ${O})` : (0, t._)`${C}(${O})`;
  }
  Sn.callValidateCode = h;
  const p = (0, t._)`new RegExp`;
  function m({ gen: v, it: { opts: b } }, _) {
    const w = b.unicodeRegExp ? "u" : "", { regExp: x } = b.code, E = x(_, w);
    return v.scopeValue("pattern", {
      key: E.toString(),
      ref: E,
      code: (0, t._)`${x.code === "new RegExp" ? p : (0, r.useFunc)(v, x)}(${_}, ${w})`
    });
  }
  Sn.usePattern = m;
  function g(v) {
    const { gen: b, data: _, keyword: w, it: x } = v, E = b.name("valid");
    if (x.allErrors) {
      const C = b.let("valid", !0);
      return S(() => b.assign(C, !1)), C;
    }
    return b.var(E, !0), S(() => b.break()), E;
    function S(C) {
      const R = b.const("len", (0, t._)`${_}.length`);
      b.forRange("i", 0, R, (P) => {
        v.subschema({
          keyword: w,
          dataProp: P,
          dataPropType: e.Type.Num
        }, E), b.if((0, t.not)(E), C);
      });
    }
  }
  Sn.validateArray = g;
  function y(v) {
    const { gen: b, schema: _, keyword: w, it: x } = v;
    if (!Array.isArray(_))
      throw new Error("ajv implementation error");
    if (_.some((R) => (0, e.alwaysValidSchema)(x, R)) && !x.opts.unevaluated)
      return;
    const S = b.let("valid", !1), C = b.name("_valid");
    b.block(() => _.forEach((R, P) => {
      const N = v.subschema({
        keyword: w,
        schemaProp: P,
        compositeRule: !0
      }, C);
      b.assign(S, (0, t._)`${S} || ${C}`), v.mergeValidEvaluated(N, C) || b.if((0, t.not)(S));
    })), v.result(S, () => v.reset(), () => v.error(!0));
  }
  return Sn.validateUnion = y, Sn;
}
var $re;
function J1t() {
  if ($re) return ps;
  $re = 1, Object.defineProperty(ps, "__esModule", { value: !0 }), ps.validateKeywordUsage = ps.validSchemaType = ps.funcKeywordCode = ps.macroKeywordCode = void 0;
  const t = Mt(), e = fu(), n = js(), r = BO();
  function o(f, h) {
    const { gen: p, keyword: m, schema: g, parentSchema: y, it: v } = f, b = h.macro.call(v.self, g, y, v), _ = c(p, m, b);
    v.opts.validateSchema !== !1 && v.self.validateSchema(b, !0);
    const w = p.name("valid");
    f.subschema({
      schema: b,
      schemaPath: t.nil,
      errSchemaPath: `${v.errSchemaPath}/${m}`,
      topSchemaRef: _,
      compositeRule: !0
    }, w), f.pass(w, () => f.error(!0));
  }
  ps.macroKeywordCode = o;
  function i(f, h) {
    var p;
    const { gen: m, keyword: g, schema: y, parentSchema: v, $data: b, it: _ } = f;
    l(_, h);
    const w = !b && h.compile ? h.compile.call(_.self, y, v, _) : h.validate, x = c(m, g, w), E = m.let("valid");
    f.block$data(E, S), f.ok((p = h.valid) !== null && p !== void 0 ? p : E);
    function S() {
      if (h.errors === !1)
        P(), h.modifying && s(f), N(() => f.error());
      else {
        const A = h.async ? C() : R();
        h.modifying && s(f), N(() => a(f, A));
      }
    }
    function C() {
      const A = m.let("ruleErrs", null);
      return m.try(() => P((0, t._)`await `), (O) => m.assign(E, !1).if((0, t._)`${O} instanceof ${_.ValidationError}`, () => m.assign(A, (0, t._)`${O}.errors`), () => m.throw(O))), A;
    }
    function R() {
      const A = (0, t._)`${x}.errors`;
      return m.assign(A, null), P(t.nil), A;
    }
    function P(A = h.async ? (0, t._)`await ` : t.nil) {
      const O = _.opts.passContext ? e.default.this : e.default.self, k = !("compile" in h && !b || h.schema === !1);
      m.assign(E, (0, t._)`${A}${(0, n.callValidateCode)(f, x, O, k)}`, h.modifying);
    }
    function N(A) {
      var O;
      m.if((0, t.not)((O = h.valid) !== null && O !== void 0 ? O : E), A);
    }
  }
  ps.funcKeywordCode = i;
  function s(f) {
    const { gen: h, data: p, it: m } = f;
    h.if(m.parentData, () => h.assign(p, (0, t._)`${m.parentData}[${m.parentDataProperty}]`));
  }
  function a(f, h) {
    const { gen: p } = f;
    p.if((0, t._)`Array.isArray(${h})`, () => {
      p.assign(e.default.vErrors, (0, t._)`${e.default.vErrors} === null ? ${h} : ${e.default.vErrors}.concat(${h})`).assign(e.default.errors, (0, t._)`${e.default.vErrors}.length`), (0, r.extendErrors)(f);
    }, () => f.error());
  }
  function l({ schemaEnv: f }, h) {
    if (h.async && !f.$async)
      throw new Error("async keyword in sync schema");
  }
  function c(f, h, p) {
    if (p === void 0)
      throw new Error(`keyword "${h}" failed to compile`);
    return f.scopeValue("keyword", typeof p == "function" ? { ref: p } : { ref: p, code: (0, t.stringify)(p) });
  }
  function u(f, h, p = !1) {
    return !h.length || h.some((m) => m === "array" ? Array.isArray(f) : m === "object" ? f && typeof f == "object" && !Array.isArray(f) : typeof f == m || p && typeof f > "u");
  }
  ps.validSchemaType = u;
  function d({ schema: f, opts: h, self: p, errSchemaPath: m }, g, y) {
    if (Array.isArray(g.keyword) ? !g.keyword.includes(y) : g.keyword !== y)
      throw new Error("ajv implementation error");
    const v = g.dependencies;
    if (v?.some((b) => !Object.prototype.hasOwnProperty.call(f, b)))
      throw new Error(`parent schema must have dependencies of ${y}: ${v.join(",")}`);
    if (g.validateSchema && !g.validateSchema(f[y])) {
      const _ = `keyword "${y}" value is invalid at path "${m}": ` + p.errorsText(g.validateSchema.errors);
      if (h.validateSchema === "log")
        p.logger.error(_);
      else
        throw new Error(_);
    }
  }
  return ps.validateKeywordUsage = d, ps;
}
var Va = {}, Mre;
function e_t() {
  if (Mre) return Va;
  Mre = 1, Object.defineProperty(Va, "__esModule", { value: !0 }), Va.extendSubschemaMode = Va.extendSubschemaData = Va.getSubschema = void 0;
  const t = Mt(), e = Jt();
  function n(i, { keyword: s, schemaProp: a, schema: l, schemaPath: c, errSchemaPath: u, topSchemaRef: d }) {
    if (s !== void 0 && l !== void 0)
      throw new Error('both "keyword" and "schema" passed, only one allowed');
    if (s !== void 0) {
      const f = i.schema[s];
      return a === void 0 ? {
        schema: f,
        schemaPath: (0, t._)`${i.schemaPath}${(0, t.getProperty)(s)}`,
        errSchemaPath: `${i.errSchemaPath}/${s}`
      } : {
        schema: f[a],
        schemaPath: (0, t._)`${i.schemaPath}${(0, t.getProperty)(s)}${(0, t.getProperty)(a)}`,
        errSchemaPath: `${i.errSchemaPath}/${s}/${(0, e.escapeFragment)(a)}`
      };
    }
    if (l !== void 0) {
      if (c === void 0 || u === void 0 || d === void 0)
        throw new Error('"schemaPath", "errSchemaPath" and "topSchemaRef" are required with "schema"');
      return {
        schema: l,
        schemaPath: c,
        topSchemaRef: d,
        errSchemaPath: u
      };
    }
    throw new Error('either "keyword" or "schema" must be passed');
  }
  Va.getSubschema = n;
  function r(i, s, { dataProp: a, dataPropType: l, data: c, dataTypes: u, propertyName: d }) {
    if (c !== void 0 && a !== void 0)
      throw new Error('both "data" and "dataProp" passed, only one allowed');
    const { gen: f } = s;
    if (a !== void 0) {
      const { errorPath: p, dataPathArr: m, opts: g } = s, y = f.let("data", (0, t._)`${s.data}${(0, t.getProperty)(a)}`, !0);
      h(y), i.errorPath = (0, t.str)`${p}${(0, e.getErrorPath)(a, l, g.jsPropertySyntax)}`, i.parentDataProperty = (0, t._)`${a}`, i.dataPathArr = [...m, i.parentDataProperty];
    }
    if (c !== void 0) {
      const p = c instanceof t.Name ? c : f.let("data", c, !0);
      h(p), d !== void 0 && (i.propertyName = d);
    }
    u && (i.dataTypes = u);
    function h(p) {
      i.data = p, i.dataLevel = s.dataLevel + 1, i.dataTypes = [], s.definedProperties = /* @__PURE__ */ new Set(), i.parentData = s.data, i.dataNames = [...s.dataNames, p];
    }
  }
  Va.extendSubschemaData = r;
  function o(i, { jtdDiscriminator: s, jtdMetadata: a, compositeRule: l, createErrors: c, allErrors: u }) {
    l !== void 0 && (i.compositeRule = l), c !== void 0 && (i.createErrors = c), u !== void 0 && (i.allErrors = u), i.jtdDiscriminator = s, i.jtdMetadata = a;
  }
  return Va.extendSubschemaMode = o, Va;
}
var _o = {}, tD, Dre;
function c_e() {
  return Dre || (Dre = 1, tD = function t(e, n) {
    if (e === n) return !0;
    if (e && n && typeof e == "object" && typeof n == "object") {
      if (e.constructor !== n.constructor) return !1;
      var r, o, i;
      if (Array.isArray(e)) {
        if (r = e.length, r != n.length) return !1;
        for (o = r; o-- !== 0; )
          if (!t(e[o], n[o])) return !1;
        return !0;
      }
      if (e.constructor === RegExp) return e.source === n.source && e.flags === n.flags;
      if (e.valueOf !== Object.prototype.valueOf) return e.valueOf() === n.valueOf();
      if (e.toString !== Object.prototype.toString) return e.toString() === n.toString();
      if (i = Object.keys(e), r = i.length, r !== Object.keys(n).length) return !1;
      for (o = r; o-- !== 0; )
        if (!Object.prototype.hasOwnProperty.call(n, i[o])) return !1;
      for (o = r; o-- !== 0; ) {
        var s = i[o];
        if (!t(e[s], n[s])) return !1;
      }
      return !0;
    }
    return e !== e && n !== n;
  }), tD;
}
var nD = { exports: {} }, Ire;
function t_t() {
  if (Ire) return nD.exports;
  Ire = 1;
  var t = nD.exports = function(r, o, i) {
    typeof o == "function" && (i = o, o = {}), i = o.cb || i;
    var s = typeof i == "function" ? i : i.pre || function() {
    }, a = i.post || function() {
    };
    e(o, s, a, r, "", r);
  };
  t.keywords = {
    additionalItems: !0,
    items: !0,
    contains: !0,
    additionalProperties: !0,
    propertyNames: !0,
    not: !0,
    if: !0,
    then: !0,
    else: !0
  }, t.arrayKeywords = {
    items: !0,
    allOf: !0,
    anyOf: !0,
    oneOf: !0
  }, t.propsKeywords = {
    $defs: !0,
    definitions: !0,
    properties: !0,
    patternProperties: !0,
    dependencies: !0
  }, t.skipKeywords = {
    default: !0,
    enum: !0,
    const: !0,
    required: !0,
    maximum: !0,
    minimum: !0,
    exclusiveMaximum: !0,
    exclusiveMinimum: !0,
    multipleOf: !0,
    maxLength: !0,
    minLength: !0,
    pattern: !0,
    format: !0,
    maxItems: !0,
    minItems: !0,
    uniqueItems: !0,
    maxProperties: !0,
    minProperties: !0
  };
  function e(r, o, i, s, a, l, c, u, d, f) {
    if (s && typeof s == "object" && !Array.isArray(s)) {
      o(s, a, l, c, u, d, f);
      for (var h in s) {
        var p = s[h];
        if (Array.isArray(p)) {
          if (h in t.arrayKeywords)
            for (var m = 0; m < p.length; m++)
              e(r, o, i, p[m], a + "/" + h + "/" + m, l, a, h, s, m);
        } else if (h in t.propsKeywords) {
          if (p && typeof p == "object")
            for (var g in p)
              e(r, o, i, p[g], a + "/" + h + "/" + n(g), l, a, h, s, g);
        } else (h in t.keywords || r.allKeys && !(h in t.skipKeywords)) && e(r, o, i, p, a + "/" + h, l, a, h, s);
      }
      i(s, a, l, c, u, d, f);
    }
  }
  function n(r) {
    return r.replace(/~/g, "~0").replace(/\//g, "~1");
  }
  return nD.exports;
}
var Nre;
function zO() {
  if (Nre) return _o;
  Nre = 1, Object.defineProperty(_o, "__esModule", { value: !0 }), _o.getSchemaRefs = _o.resolveUrl = _o.normalizeId = _o._getFullPath = _o.getFullPath = _o.inlineRef = void 0;
  const t = Jt(), e = c_e(), n = t_t(), r = /* @__PURE__ */ new Set([
    "type",
    "format",
    "pattern",
    "maxLength",
    "minLength",
    "maxProperties",
    "minProperties",
    "maxItems",
    "minItems",
    "maximum",
    "minimum",
    "uniqueItems",
    "multipleOf",
    "required",
    "enum",
    "const"
  ]);
  function o(m, g = !0) {
    return typeof m == "boolean" ? !0 : g === !0 ? !s(m) : g ? a(m) <= g : !1;
  }
  _o.inlineRef = o;
  const i = /* @__PURE__ */ new Set([
    "$ref",
    "$recursiveRef",
    "$recursiveAnchor",
    "$dynamicRef",
    "$dynamicAnchor"
  ]);
  function s(m) {
    for (const g in m) {
      if (i.has(g))
        return !0;
      const y = m[g];
      if (Array.isArray(y) && y.some(s) || typeof y == "object" && s(y))
        return !0;
    }
    return !1;
  }
  function a(m) {
    let g = 0;
    for (const y in m) {
      if (y === "$ref")
        return 1 / 0;
      if (g++, !r.has(y) && (typeof m[y] == "object" && (0, t.eachItem)(m[y], (v) => g += a(v)), g === 1 / 0))
        return 1 / 0;
    }
    return g;
  }
  function l(m, g = "", y) {
    y !== !1 && (g = d(g));
    const v = m.parse(g);
    return c(m, v);
  }
  _o.getFullPath = l;
  function c(m, g) {
    return m.serialize(g).split("#")[0] + "#";
  }
  _o._getFullPath = c;
  const u = /#\/?$/;
  function d(m) {
    return m ? m.replace(u, "") : "";
  }
  _o.normalizeId = d;
  function f(m, g, y) {
    return y = d(y), m.resolve(g, y);
  }
  _o.resolveUrl = f;
  const h = /^[a-z_][-a-z0-9._]*$/i;
  function p(m, g) {
    if (typeof m == "boolean")
      return {};
    const { schemaId: y, uriResolver: v } = this.opts, b = d(m[y] || g), _ = { "": b }, w = l(v, b, !1), x = {}, E = /* @__PURE__ */ new Set();
    return n(m, { allKeys: !0 }, (R, P, N, A) => {
      if (A === void 0)
        return;
      const O = w + P;
      let k = _[A];
      typeof R[y] == "string" && (k = T.call(this, R[y])), I.call(this, R.$anchor), I.call(this, R.$dynamicAnchor), _[P] = k;
      function T(j) {
        const z = this.opts.uriResolver.resolve;
        if (j = d(k ? z(k, j) : j), E.has(j))
          throw C(j);
        E.add(j);
        let $ = this.refs[j];
        return typeof $ == "string" && ($ = this.refs[$]), typeof $ == "object" ? S(R, $.schema, j) : j !== d(O) && (j[0] === "#" ? (S(R, x[j], j), x[j] = R) : this.refs[j] = O), j;
      }
      function I(j) {
        if (typeof j == "string") {
          if (!h.test(j))
            throw new Error(`invalid anchor "${j}"`);
          T.call(this, `#${j}`);
        }
      }
    }), x;
    function S(R, P, N) {
      if (P !== void 0 && !e(R, P))
        throw C(N);
    }
    function C(R) {
      return new Error(`reference "${R}" resolves to more than one schema`);
    }
  }
  return _o.getSchemaRefs = p, _o;
}
var jre;
function qO() {
  if (jre) return Ua;
  jre = 1, Object.defineProperty(Ua, "__esModule", { value: !0 }), Ua.getData = Ua.KeywordCxt = Ua.validateFunctionCode = void 0;
  const t = Q1t(), e = BE(), n = l_e(), r = BE(), o = Z1t(), i = J1t(), s = e_t(), a = Mt(), l = fu(), c = zO(), u = Jt(), d = BO();
  function f(Y) {
    if (w(Y) && (E(Y), _(Y))) {
      g(Y);
      return;
    }
    h(Y, () => (0, t.topBoolOrEmptySchema)(Y));
  }
  Ua.validateFunctionCode = f;
  function h({ gen: Y, validateName: L, schema: V, schemaEnv: K, opts: ne }, ce) {
    ne.code.es5 ? Y.func(L, (0, a._)`${l.default.data}, ${l.default.valCxt}`, K.$async, () => {
      Y.code((0, a._)`"use strict"; ${v(V, ne)}`), m(Y, ne), Y.code(ce);
    }) : Y.func(L, (0, a._)`${l.default.data}, ${p(ne)}`, K.$async, () => Y.code(v(V, ne)).code(ce));
  }
  function p(Y) {
    return (0, a._)`{${l.default.instancePath}="", ${l.default.parentData}, ${l.default.parentDataProperty}, ${l.default.rootData}=${l.default.data}${Y.dynamicRef ? (0, a._)`, ${l.default.dynamicAnchors}={}` : a.nil}}={}`;
  }
  function m(Y, L) {
    Y.if(l.default.valCxt, () => {
      Y.var(l.default.instancePath, (0, a._)`${l.default.valCxt}.${l.default.instancePath}`), Y.var(l.default.parentData, (0, a._)`${l.default.valCxt}.${l.default.parentData}`), Y.var(l.default.parentDataProperty, (0, a._)`${l.default.valCxt}.${l.default.parentDataProperty}`), Y.var(l.default.rootData, (0, a._)`${l.default.valCxt}.${l.default.rootData}`), L.dynamicRef && Y.var(l.default.dynamicAnchors, (0, a._)`${l.default.valCxt}.${l.default.dynamicAnchors}`);
    }, () => {
      Y.var(l.default.instancePath, (0, a._)`""`), Y.var(l.default.parentData, (0, a._)`undefined`), Y.var(l.default.parentDataProperty, (0, a._)`undefined`), Y.var(l.default.rootData, l.default.data), L.dynamicRef && Y.var(l.default.dynamicAnchors, (0, a._)`{}`);
    });
  }
  function g(Y) {
    const { schema: L, opts: V, gen: K } = Y;
    h(Y, () => {
      V.$comment && L.$comment && A(Y), R(Y), K.let(l.default.vErrors, null), K.let(l.default.errors, 0), V.unevaluated && y(Y), S(Y), O(Y);
    });
  }
  function y(Y) {
    const { gen: L, validateName: V } = Y;
    Y.evaluated = L.const("evaluated", (0, a._)`${V}.evaluated`), L.if((0, a._)`${Y.evaluated}.dynamicProps`, () => L.assign((0, a._)`${Y.evaluated}.props`, (0, a._)`undefined`)), L.if((0, a._)`${Y.evaluated}.dynamicItems`, () => L.assign((0, a._)`${Y.evaluated}.items`, (0, a._)`undefined`));
  }
  function v(Y, L) {
    const V = typeof Y == "object" && Y[L.schemaId];
    return V && (L.code.source || L.code.process) ? (0, a._)`/*# sourceURL=${V} */` : a.nil;
  }
  function b(Y, L) {
    if (w(Y) && (E(Y), _(Y))) {
      x(Y, L);
      return;
    }
    (0, t.boolOrEmptySchema)(Y, L);
  }
  function _({ schema: Y, self: L }) {
    if (typeof Y == "boolean")
      return !Y;
    for (const V in Y)
      if (L.RULES.all[V])
        return !0;
    return !1;
  }
  function w(Y) {
    return typeof Y.schema != "boolean";
  }
  function x(Y, L) {
    const { schema: V, gen: K, opts: ne } = Y;
    ne.$comment && V.$comment && A(Y), P(Y), N(Y);
    const ce = K.const("_errs", l.default.errors);
    S(Y, ce), K.var(L, (0, a._)`${ce} === ${l.default.errors}`);
  }
  function E(Y) {
    (0, u.checkUnknownRules)(Y), C(Y);
  }
  function S(Y, L) {
    if (Y.opts.jtd)
      return T(Y, [], !1, L);
    const V = (0, e.getSchemaTypes)(Y.schema), K = (0, e.coerceAndCheckDataType)(Y, V);
    T(Y, V, !K, L);
  }
  function C(Y) {
    const { schema: L, errSchemaPath: V, opts: K, self: ne } = Y;
    L.$ref && K.ignoreKeywordsWithRef && (0, u.schemaHasRulesButRef)(L, ne.RULES) && ne.logger.warn(`$ref: keywords ignored in schema at path "${V}"`);
  }
  function R(Y) {
    const { schema: L, opts: V } = Y;
    L.default !== void 0 && V.useDefaults && V.strictSchema && (0, u.checkStrictMode)(Y, "default is ignored in the schema root");
  }
  function P(Y) {
    const L = Y.schema[Y.opts.schemaId];
    L && (Y.baseId = (0, c.resolveUrl)(Y.opts.uriResolver, Y.baseId, L));
  }
  function N(Y) {
    if (Y.schema.$async && !Y.schemaEnv.$async)
      throw new Error("async schema in sync schema");
  }
  function A({ gen: Y, schemaEnv: L, schema: V, errSchemaPath: K, opts: ne }) {
    const ce = V.$comment;
    if (ne.$comment === !0)
      Y.code((0, a._)`${l.default.self}.logger.log(${ce})`);
    else if (typeof ne.$comment == "function") {
      const fe = (0, a.str)`${K}/$comment`, ve = Y.scopeValue("root", { ref: L.root });
      Y.code((0, a._)`${l.default.self}.opts.$comment(${ce}, ${fe}, ${ve}.schema)`);
    }
  }
  function O(Y) {
    const { gen: L, schemaEnv: V, validateName: K, ValidationError: ne, opts: ce } = Y;
    V.$async ? L.if((0, a._)`${l.default.errors} === 0`, () => L.return(l.default.data), () => L.throw((0, a._)`new ${ne}(${l.default.vErrors})`)) : (L.assign((0, a._)`${K}.errors`, l.default.vErrors), ce.unevaluated && k(Y), L.return((0, a._)`${l.default.errors} === 0`));
  }
  function k({ gen: Y, evaluated: L, props: V, items: K }) {
    V instanceof a.Name && Y.assign((0, a._)`${L}.props`, V), K instanceof a.Name && Y.assign((0, a._)`${L}.items`, K);
  }
  function T(Y, L, V, K) {
    const { gen: ne, schema: ce, data: fe, allErrors: ve, opts: _e, self: Ee } = Y, { RULES: Me } = Ee;
    if (ce.$ref && (_e.ignoreKeywordsWithRef || !(0, u.schemaHasRulesButRef)(ce, Me))) {
      ne.block(() => Z(Y, "$ref", Me.all.$ref.definition));
      return;
    }
    _e.jtd || j(Y, L), ne.block(() => {
      for (const Ce of Me.rules)
        Le(Ce);
      Le(Me.post);
    });
    function Le(Ce) {
      (0, n.shouldUseGroup)(ce, Ce) && (Ce.type ? (ne.if((0, r.checkDataType)(Ce.type, fe, _e.strictNumbers)), I(Y, Ce), L.length === 1 && L[0] === Ce.type && V && (ne.else(), (0, r.reportTypeError)(Y)), ne.endIf()) : I(Y, Ce), ve || ne.if((0, a._)`${l.default.errors} === ${K || 0}`));
    }
  }
  function I(Y, L) {
    const { gen: V, schema: K, opts: { useDefaults: ne } } = Y;
    ne && (0, o.assignDefaults)(Y, L.type), V.block(() => {
      for (const ce of L.rules)
        (0, n.shouldUseRule)(K, ce) && Z(Y, ce.keyword, ce.definition, L.type);
    });
  }
  function j(Y, L) {
    Y.schemaEnv.meta || !Y.opts.strictTypes || (z(Y, L), Y.opts.allowUnionTypes || $(Y, L), D(Y, Y.dataTypes));
  }
  function z(Y, L) {
    if (L.length) {
      if (!Y.dataTypes.length) {
        Y.dataTypes = L;
        return;
      }
      L.forEach((V) => {
        q(Y.dataTypes, V) || B(Y, `type "${V}" not allowed by context "${Y.dataTypes.join(",")}"`);
      }), F(Y, L);
    }
  }
  function $(Y, L) {
    L.length > 1 && !(L.length === 2 && L.includes("null")) && B(Y, "use allowUnionTypes to allow union type keyword");
  }
  function D(Y, L) {
    const V = Y.self.RULES.all;
    for (const K in V) {
      const ne = V[K];
      if (typeof ne == "object" && (0, n.shouldUseRule)(Y.schema, ne)) {
        const { type: ce } = ne.definition;
        ce.length && !ce.some((fe) => U(L, fe)) && B(Y, `missing type "${ce.join(",")}" for keyword "${K}"`);
      }
    }
  }
  function U(Y, L) {
    return Y.includes(L) || L === "number" && Y.includes("integer");
  }
  function q(Y, L) {
    return Y.includes(L) || L === "integer" && Y.includes("number");
  }
  function F(Y, L) {
    const V = [];
    for (const K of Y.dataTypes)
      q(L, K) ? V.push(K) : L.includes("integer") && K === "number" && V.push("integer");
    Y.dataTypes = V;
  }
  function B(Y, L) {
    const V = Y.schemaEnv.baseId + Y.errSchemaPath;
    L += ` at "${V}" (strictTypes)`, (0, u.checkStrictMode)(Y, L, Y.opts.strictTypes);
  }
  class H {
    constructor(L, V, K) {
      if ((0, i.validateKeywordUsage)(L, V, K), this.gen = L.gen, this.allErrors = L.allErrors, this.keyword = K, this.data = L.data, this.schema = L.schema[K], this.$data = V.$data && L.opts.$data && this.schema && this.schema.$data, this.schemaValue = (0, u.schemaRefOrVal)(L, this.schema, K, this.$data), this.schemaType = V.schemaType, this.parentSchema = L.schema, this.params = {}, this.it = L, this.def = V, this.$data)
        this.schemaCode = L.gen.const("vSchema", ee(this.$data, L));
      else if (this.schemaCode = this.schemaValue, !(0, i.validSchemaType)(this.schema, V.schemaType, V.allowUndefined))
        throw new Error(`${K} value must be ${JSON.stringify(V.schemaType)}`);
      ("code" in V ? V.trackErrors : V.errors !== !1) && (this.errsCount = L.gen.const("_errs", l.default.errors));
    }
    result(L, V, K) {
      this.failResult((0, a.not)(L), V, K);
    }
    failResult(L, V, K) {
      this.gen.if(L), K ? K() : this.error(), V ? (this.gen.else(), V(), this.allErrors && this.gen.endIf()) : this.allErrors ? this.gen.endIf() : this.gen.else();
    }
    pass(L, V) {
      this.failResult((0, a.not)(L), void 0, V);
    }
    fail(L) {
      if (L === void 0) {
        this.error(), this.allErrors || this.gen.if(!1);
        return;
      }
      this.gen.if(L), this.error(), this.allErrors ? this.gen.endIf() : this.gen.else();
    }
    fail$data(L) {
      if (!this.$data)
        return this.fail(L);
      const { schemaCode: V } = this;
      this.fail((0, a._)`${V} !== undefined && (${(0, a.or)(this.invalid$data(), L)})`);
    }
    error(L, V, K) {
      if (V) {
        this.setParams(V), this._error(L, K), this.setParams({});
        return;
      }
      this._error(L, K);
    }
    _error(L, V) {
      (L ? d.reportExtraError : d.reportError)(this, this.def.error, V);
    }
    $dataError() {
      (0, d.reportError)(this, this.def.$dataError || d.keyword$DataError);
    }
    reset() {
      if (this.errsCount === void 0)
        throw new Error('add "trackErrors" to keyword definition');
      (0, d.resetErrorsCount)(this.gen, this.errsCount);
    }
    ok(L) {
      this.allErrors || this.gen.if(L);
    }
    setParams(L, V) {
      V ? Object.assign(this.params, L) : this.params = L;
    }
    block$data(L, V, K = a.nil) {
      this.gen.block(() => {
        this.check$data(L, K), V();
      });
    }
    check$data(L = a.nil, V = a.nil) {
      if (!this.$data)
        return;
      const { gen: K, schemaCode: ne, schemaType: ce, def: fe } = this;
      K.if((0, a.or)((0, a._)`${ne} === undefined`, V)), L !== a.nil && K.assign(L, !0), (ce.length || fe.validateSchema) && (K.elseIf(this.invalid$data()), this.$dataError(), L !== a.nil && K.assign(L, !1)), K.else();
    }
    invalid$data() {
      const { gen: L, schemaCode: V, schemaType: K, def: ne, it: ce } = this;
      return (0, a.or)(fe(), ve());
      function fe() {
        if (K.length) {
          if (!(V instanceof a.Name))
            throw new Error("ajv implementation error");
          const _e = Array.isArray(K) ? K : [K];
          return (0, a._)`${(0, r.checkDataTypes)(_e, V, ce.opts.strictNumbers, r.DataType.Wrong)}`;
        }
        return a.nil;
      }
      function ve() {
        if (ne.validateSchema) {
          const _e = L.scopeValue("validate$data", { ref: ne.validateSchema });
          return (0, a._)`!${_e}(${V})`;
        }
        return a.nil;
      }
    }
    subschema(L, V) {
      const K = (0, s.getSubschema)(this.it, L);
      (0, s.extendSubschemaData)(K, this.it, L), (0, s.extendSubschemaMode)(K, L);
      const ne = { ...this.it, ...K, items: void 0, props: void 0 };
      return b(ne, V), ne;
    }
    mergeEvaluated(L, V) {
      const { it: K, gen: ne } = this;
      K.opts.unevaluated && (K.props !== !0 && L.props !== void 0 && (K.props = u.mergeEvaluated.props(ne, L.props, K.props, V)), K.items !== !0 && L.items !== void 0 && (K.items = u.mergeEvaluated.items(ne, L.items, K.items, V)));
    }
    mergeValidEvaluated(L, V) {
      const { it: K, gen: ne } = this;
      if (K.opts.unevaluated && (K.props !== !0 || K.items !== !0))
        return ne.if(V, () => this.mergeEvaluated(L, a.Name)), !0;
    }
  }
  Ua.KeywordCxt = H;
  function Z(Y, L, V, K) {
    const ne = new H(Y, V, L);
    "code" in V ? V.code(ne, K) : ne.$data && V.validate ? (0, i.funcKeywordCode)(ne, V) : "macro" in V ? (0, i.macroKeywordCode)(ne, V) : (V.compile || V.validate) && (0, i.funcKeywordCode)(ne, V);
  }
  const W = /^\/(?:[^~]|~0|~1)*$/, G = /^([0-9]+)(#|\/(?:[^~]|~0|~1)*)?$/;
  function ee(Y, { dataLevel: L, dataNames: V, dataPathArr: K }) {
    let ne, ce;
    if (Y === "")
      return l.default.rootData;
    if (Y[0] === "/") {
      if (!W.test(Y))
        throw new Error(`Invalid JSON-pointer: ${Y}`);
      ne = Y, ce = l.default.rootData;
    } else {
      const Ee = G.exec(Y);
      if (!Ee)
        throw new Error(`Invalid JSON-pointer: ${Y}`);
      const Me = +Ee[1];
      if (ne = Ee[2], ne === "#") {
        if (Me >= L)
          throw new Error(_e("property/index", Me));
        return K[L - Me];
      }
      if (Me > L)
        throw new Error(_e("data", Me));
      if (ce = V[L - Me], !ne)
        return ce;
    }
    let fe = ce;
    const ve = ne.split("/");
    for (const Ee of ve)
      Ee && (ce = (0, a._)`${ce}${(0, a.getProperty)((0, u.unescapeJsonPointer)(Ee))}`, fe = (0, a._)`${fe} && ${ce}`);
    return fe;
    function _e(Ee, Me) {
      return `Cannot access ${Ee} ${Me} levels up, current level is ${L}`;
    }
  }
  return Ua.getData = ee, Ua;
}
var H1 = {}, Lre;
function Z6() {
  if (Lre) return H1;
  Lre = 1, Object.defineProperty(H1, "__esModule", { value: !0 });
  class t extends Error {
    constructor(n) {
      super("validation failed"), this.errors = n, this.ajv = this.validation = !0;
    }
  }
  return H1.default = t, H1;
}
var V1 = {}, Fre;
function UO() {
  if (Fre) return V1;
  Fre = 1, Object.defineProperty(V1, "__esModule", { value: !0 });
  const t = zO();
  class e extends Error {
    constructor(r, o, i, s) {
      super(s || `can't resolve reference ${i} from id ${o}`), this.missingRef = (0, t.resolveUrl)(r, o, i), this.missingSchema = (0, t.normalizeId)((0, t.getFullPath)(r, this.missingRef));
    }
  }
  return V1.default = e, V1;
}
var ai = {}, Bre;
function J6() {
  if (Bre) return ai;
  Bre = 1, Object.defineProperty(ai, "__esModule", { value: !0 }), ai.resolveSchema = ai.getCompilingSchema = ai.resolveRef = ai.compileSchema = ai.SchemaEnv = void 0;
  const t = Mt(), e = Z6(), n = fu(), r = zO(), o = Jt(), i = qO();
  class s {
    constructor(y) {
      var v;
      this.refs = {}, this.dynamicAnchors = {};
      let b;
      typeof y.schema == "object" && (b = y.schema), this.schema = y.schema, this.schemaId = y.schemaId, this.root = y.root || this, this.baseId = (v = y.baseId) !== null && v !== void 0 ? v : (0, r.normalizeId)(b?.[y.schemaId || "$id"]), this.schemaPath = y.schemaPath, this.localRefs = y.localRefs, this.meta = y.meta, this.$async = b?.$async, this.refs = {};
    }
  }
  ai.SchemaEnv = s;
  function a(g) {
    const y = u.call(this, g);
    if (y)
      return y;
    const v = (0, r.getFullPath)(this.opts.uriResolver, g.root.baseId), { es5: b, lines: _ } = this.opts.code, { ownProperties: w } = this.opts, x = new t.CodeGen(this.scope, { es5: b, lines: _, ownProperties: w });
    let E;
    g.$async && (E = x.scopeValue("Error", {
      ref: e.default,
      code: (0, t._)`require("ajv/dist/runtime/validation_error").default`
    }));
    const S = x.scopeName("validate");
    g.validateName = S;
    const C = {
      gen: x,
      allErrors: this.opts.allErrors,
      data: n.default.data,
      parentData: n.default.parentData,
      parentDataProperty: n.default.parentDataProperty,
      dataNames: [n.default.data],
      dataPathArr: [t.nil],
      // TODO can its length be used as dataLevel if nil is removed?
      dataLevel: 0,
      dataTypes: [],
      definedProperties: /* @__PURE__ */ new Set(),
      topSchemaRef: x.scopeValue("schema", this.opts.code.source === !0 ? { ref: g.schema, code: (0, t.stringify)(g.schema) } : { ref: g.schema }),
      validateName: S,
      ValidationError: E,
      schema: g.schema,
      schemaEnv: g,
      rootId: v,
      baseId: g.baseId || v,
      schemaPath: t.nil,
      errSchemaPath: g.schemaPath || (this.opts.jtd ? "" : "#"),
      errorPath: (0, t._)`""`,
      opts: this.opts,
      self: this
    };
    let R;
    try {
      this._compilations.add(g), (0, i.validateFunctionCode)(C), x.optimize(this.opts.code.optimize);
      const P = x.toString();
      R = `${x.scopeRefs(n.default.scope)}return ${P}`, this.opts.code.process && (R = this.opts.code.process(R, g));
      const A = new Function(`${n.default.self}`, `${n.default.scope}`, R)(this, this.scope.get());
      if (this.scope.value(S, { ref: A }), A.errors = null, A.schema = g.schema, A.schemaEnv = g, g.$async && (A.$async = !0), this.opts.code.source === !0 && (A.source = { validateName: S, validateCode: P, scopeValues: x._values }), this.opts.unevaluated) {
        const { props: O, items: k } = C;
        A.evaluated = {
          props: O instanceof t.Name ? void 0 : O,
          items: k instanceof t.Name ? void 0 : k,
          dynamicProps: O instanceof t.Name,
          dynamicItems: k instanceof t.Name
        }, A.source && (A.source.evaluated = (0, t.stringify)(A.evaluated));
      }
      return g.validate = A, g;
    } catch (P) {
      throw delete g.validate, delete g.validateName, R && this.logger.error("Error compiling schema, function code:", R), P;
    } finally {
      this._compilations.delete(g);
    }
  }
  ai.compileSchema = a;
  function l(g, y, v) {
    var b;
    v = (0, r.resolveUrl)(this.opts.uriResolver, y, v);
    const _ = g.refs[v];
    if (_)
      return _;
    let w = f.call(this, g, v);
    if (w === void 0) {
      const x = (b = g.localRefs) === null || b === void 0 ? void 0 : b[v], { schemaId: E } = this.opts;
      x && (w = new s({ schema: x, schemaId: E, root: g, baseId: y }));
    }
    if (w !== void 0)
      return g.refs[v] = c.call(this, w);
  }
  ai.resolveRef = l;
  function c(g) {
    return (0, r.inlineRef)(g.schema, this.opts.inlineRefs) ? g.schema : g.validate ? g : a.call(this, g);
  }
  function u(g) {
    for (const y of this._compilations)
      if (d(y, g))
        return y;
  }
  ai.getCompilingSchema = u;
  function d(g, y) {
    return g.schema === y.schema && g.root === y.root && g.baseId === y.baseId;
  }
  function f(g, y) {
    let v;
    for (; typeof (v = this.refs[y]) == "string"; )
      y = v;
    return v || this.schemas[y] || h.call(this, g, y);
  }
  function h(g, y) {
    const v = this.opts.uriResolver.parse(y), b = (0, r._getFullPath)(this.opts.uriResolver, v);
    let _ = (0, r.getFullPath)(this.opts.uriResolver, g.baseId, void 0);
    if (Object.keys(g.schema).length > 0 && b === _)
      return m.call(this, v, g);
    const w = (0, r.normalizeId)(b), x = this.refs[w] || this.schemas[w];
    if (typeof x == "string") {
      const E = h.call(this, g, x);
      return typeof E?.schema != "object" ? void 0 : m.call(this, v, E);
    }
    if (typeof x?.schema == "object") {
      if (x.validate || a.call(this, x), w === (0, r.normalizeId)(y)) {
        const { schema: E } = x, { schemaId: S } = this.opts, C = E[S];
        return C && (_ = (0, r.resolveUrl)(this.opts.uriResolver, _, C)), new s({ schema: E, schemaId: S, root: g, baseId: _ });
      }
      return m.call(this, v, x);
    }
  }
  ai.resolveSchema = h;
  const p = /* @__PURE__ */ new Set([
    "properties",
    "patternProperties",
    "enum",
    "dependencies",
    "definitions"
  ]);
  function m(g, { baseId: y, schema: v, root: b }) {
    var _;
    if (((_ = g.fragment) === null || _ === void 0 ? void 0 : _[0]) !== "/")
      return;
    for (const E of g.fragment.slice(1).split("/")) {
      if (typeof v == "boolean")
        return;
      const S = v[(0, o.unescapeFragment)(E)];
      if (S === void 0)
        return;
      v = S;
      const C = typeof v == "object" && v[this.opts.schemaId];
      !p.has(E) && C && (y = (0, r.resolveUrl)(this.opts.uriResolver, y, C));
    }
    let w;
    if (typeof v != "boolean" && v.$ref && !(0, o.schemaHasRulesButRef)(v, this.RULES)) {
      const E = (0, r.resolveUrl)(this.opts.uriResolver, y, v.$ref);
      w = h.call(this, b, E);
    }
    const { schemaId: x } = this.opts;
    if (w = w || new s({ schema: v, schemaId: x, root: b, baseId: y }), w.schema !== w.root.schema)
      return w;
  }
  return ai;
}
const n_t = "https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#", r_t = "Meta-schema for $data reference (JSON AnySchema extension proposal)", o_t = "object", i_t = ["$data"], s_t = { $data: { type: "string", anyOf: [{ format: "relative-json-pointer" }, { format: "json-pointer" }] } }, a_t = !1, l_t = {
  $id: n_t,
  description: r_t,
  type: o_t,
  required: i_t,
  properties: s_t,
  additionalProperties: a_t
};
var W1 = {}, Dm = { exports: {} }, rD, zre;
function c_t() {
  return zre || (zre = 1, rD = {
    HEX: {
      0: 0,
      1: 1,
      2: 2,
      3: 3,
      4: 4,
      5: 5,
      6: 6,
      7: 7,
      8: 8,
      9: 9,
      a: 10,
      A: 10,
      b: 11,
      B: 11,
      c: 12,
      C: 12,
      d: 13,
      D: 13,
      e: 14,
      E: 14,
      f: 15,
      F: 15
    }
  }), rD;
}
var oD, qre;
function u_t() {
  if (qre) return oD;
  qre = 1;
  const { HEX: t } = c_t();
  function e(p) {
    if (s(p, ".") < 3)
      return { host: p, isIPV4: !1 };
    const m = p.match(/^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/u) || [], [g] = m;
    return g ? { host: i(g, "."), isIPV4: !0 } : { host: p, isIPV4: !1 };
  }
  function n(p, m = !1) {
    let g = "", y = !0;
    for (const v of p) {
      if (t[v] === void 0) return;
      v !== "0" && y === !0 && (y = !1), y || (g += v);
    }
    return m && g.length === 0 && (g = "0"), g;
  }
  function r(p) {
    let m = 0;
    const g = { error: !1, address: "", zone: "" }, y = [], v = [];
    let b = !1, _ = !1, w = !1;
    function x() {
      if (v.length) {
        if (b === !1) {
          const E = n(v);
          if (E !== void 0)
            y.push(E);
          else
            return g.error = !0, !1;
        }
        v.length = 0;
      }
      return !0;
    }
    for (let E = 0; E < p.length; E++) {
      const S = p[E];
      if (!(S === "[" || S === "]"))
        if (S === ":") {
          if (_ === !0 && (w = !0), !x())
            break;
          if (m++, y.push(":"), m > 7) {
            g.error = !0;
            break;
          }
          E - 1 >= 0 && p[E - 1] === ":" && (_ = !0);
          continue;
        } else if (S === "%") {
          if (!x())
            break;
          b = !0;
        } else {
          v.push(S);
          continue;
        }
    }
    return v.length && (b ? g.zone = v.join("") : w ? y.push(v.join("")) : y.push(n(v))), g.address = y.join(""), g;
  }
  function o(p, m = {}) {
    if (s(p, ":") < 2)
      return { host: p, isIPV6: !1 };
    const g = r(p);
    if (g.error)
      return { host: p, isIPV6: !1 };
    {
      let y = g.address, v = g.address;
      return g.zone && (y += "%" + g.zone, v += "%25" + g.zone), { host: y, escapedHost: v, isIPV6: !0 };
    }
  }
  function i(p, m) {
    let g = "", y = !0;
    const v = p.length;
    for (let b = 0; b < v; b++) {
      const _ = p[b];
      _ === "0" && y ? (b + 1 <= v && p[b + 1] === m || b + 1 === v) && (g += _, y = !1) : (_ === m ? y = !0 : y = !1, g += _);
    }
    return g;
  }
  function s(p, m) {
    let g = 0;
    for (let y = 0; y < p.length; y++)
      p[y] === m && g++;
    return g;
  }
  const a = /^\.\.?\//u, l = /^\/\.(?:\/|$)/u, c = /^\/\.\.(?:\/|$)/u, u = /^\/?(?:.|\n)*?(?=\/|$)/u;
  function d(p) {
    const m = [];
    for (; p.length; )
      if (p.match(a))
        p = p.replace(a, "");
      else if (p.match(l))
        p = p.replace(l, "/");
      else if (p.match(c))
        p = p.replace(c, "/"), m.pop();
      else if (p === "." || p === "..")
        p = "";
      else {
        const g = p.match(u);
        if (g) {
          const y = g[0];
          p = p.slice(y.length), m.push(y);
        } else
          throw new Error("Unexpected dot segment condition");
      }
    return m.join("");
  }
  function f(p, m) {
    const g = m !== !0 ? escape : unescape;
    return p.scheme !== void 0 && (p.scheme = g(p.scheme)), p.userinfo !== void 0 && (p.userinfo = g(p.userinfo)), p.host !== void 0 && (p.host = g(p.host)), p.path !== void 0 && (p.path = g(p.path)), p.query !== void 0 && (p.query = g(p.query)), p.fragment !== void 0 && (p.fragment = g(p.fragment)), p;
  }
  function h(p, m) {
    const g = [];
    if (p.userinfo !== void 0 && (g.push(p.userinfo), g.push("@")), p.host !== void 0) {
      let y = unescape(p.host);
      const v = e(y);
      if (v.isIPV4)
        y = v.host;
      else {
        const b = o(v.host, { isIPV4: !1 });
        b.isIPV6 === !0 ? y = `[${b.escapedHost}]` : y = p.host;
      }
      g.push(y);
    }
    return (typeof p.port == "number" || typeof p.port == "string") && (g.push(":"), g.push(String(p.port))), g.length ? g.join("") : void 0;
  }
  return oD = {
    recomposeAuthority: h,
    normalizeComponentEncoding: f,
    removeDotSegments: d,
    normalizeIPv4: e,
    normalizeIPv6: o,
    stringArrayToHexStripped: n
  }, oD;
}
var iD, Ure;
function d_t() {
  if (Ure) return iD;
  Ure = 1;
  const t = /^[\da-f]{8}\b-[\da-f]{4}\b-[\da-f]{4}\b-[\da-f]{4}\b-[\da-f]{12}$/iu, e = /([\da-z][\d\-a-z]{0,31}):((?:[\w!$'()*+,\-.:;=@]|%[\da-f]{2})+)/iu;
  function n(v) {
    return typeof v.secure == "boolean" ? v.secure : String(v.scheme).toLowerCase() === "wss";
  }
  function r(v) {
    return v.host || (v.error = v.error || "HTTP URIs must have a host."), v;
  }
  function o(v) {
    const b = String(v.scheme).toLowerCase() === "https";
    return (v.port === (b ? 443 : 80) || v.port === "") && (v.port = void 0), v.path || (v.path = "/"), v;
  }
  function i(v) {
    return v.secure = n(v), v.resourceName = (v.path || "/") + (v.query ? "?" + v.query : ""), v.path = void 0, v.query = void 0, v;
  }
  function s(v) {
    if ((v.port === (n(v) ? 443 : 80) || v.port === "") && (v.port = void 0), typeof v.secure == "boolean" && (v.scheme = v.secure ? "wss" : "ws", v.secure = void 0), v.resourceName) {
      const [b, _] = v.resourceName.split("?");
      v.path = b && b !== "/" ? b : void 0, v.query = _, v.resourceName = void 0;
    }
    return v.fragment = void 0, v;
  }
  function a(v, b) {
    if (!v.path)
      return v.error = "URN can not be parsed", v;
    const _ = v.path.match(e);
    if (_) {
      const w = b.scheme || v.scheme || "urn";
      v.nid = _[1].toLowerCase(), v.nss = _[2];
      const x = `${w}:${b.nid || v.nid}`, E = y[x];
      v.path = void 0, E && (v = E.parse(v, b));
    } else
      v.error = v.error || "URN can not be parsed.";
    return v;
  }
  function l(v, b) {
    const _ = b.scheme || v.scheme || "urn", w = v.nid.toLowerCase(), x = `${_}:${b.nid || w}`, E = y[x];
    E && (v = E.serialize(v, b));
    const S = v, C = v.nss;
    return S.path = `${w || b.nid}:${C}`, b.skipEscape = !0, S;
  }
  function c(v, b) {
    const _ = v;
    return _.uuid = _.nss, _.nss = void 0, !b.tolerant && (!_.uuid || !t.test(_.uuid)) && (_.error = _.error || "UUID is not valid."), _;
  }
  function u(v) {
    const b = v;
    return b.nss = (v.uuid || "").toLowerCase(), b;
  }
  const d = {
    scheme: "http",
    domainHost: !0,
    parse: r,
    serialize: o
  }, f = {
    scheme: "https",
    domainHost: d.domainHost,
    parse: r,
    serialize: o
  }, h = {
    scheme: "ws",
    domainHost: !0,
    parse: i,
    serialize: s
  }, p = {
    scheme: "wss",
    domainHost: h.domainHost,
    parse: h.parse,
    serialize: h.serialize
  }, y = {
    http: d,
    https: f,
    ws: h,
    wss: p,
    urn: {
      scheme: "urn",
      parse: a,
      serialize: l,
      skipNormalize: !0
    },
    "urn:uuid": {
      scheme: "urn:uuid",
      parse: c,
      serialize: u,
      skipNormalize: !0
    }
  };
  return iD = y, iD;
}
var Hre;
function f_t() {
  if (Hre) return Dm.exports;
  Hre = 1;
  const { normalizeIPv6: t, normalizeIPv4: e, removeDotSegments: n, recomposeAuthority: r, normalizeComponentEncoding: o } = u_t(), i = d_t();
  function s(g, y) {
    return typeof g == "string" ? g = u(p(g, y), y) : typeof g == "object" && (g = p(u(g, y), y)), g;
  }
  function a(g, y, v) {
    const b = Object.assign({ scheme: "null" }, v), _ = l(p(g, b), p(y, b), b, !0);
    return u(_, { ...b, skipEscape: !0 });
  }
  function l(g, y, v, b) {
    const _ = {};
    return b || (g = p(u(g, v), v), y = p(u(y, v), v)), v = v || {}, !v.tolerant && y.scheme ? (_.scheme = y.scheme, _.userinfo = y.userinfo, _.host = y.host, _.port = y.port, _.path = n(y.path || ""), _.query = y.query) : (y.userinfo !== void 0 || y.host !== void 0 || y.port !== void 0 ? (_.userinfo = y.userinfo, _.host = y.host, _.port = y.port, _.path = n(y.path || ""), _.query = y.query) : (y.path ? (y.path.charAt(0) === "/" ? _.path = n(y.path) : ((g.userinfo !== void 0 || g.host !== void 0 || g.port !== void 0) && !g.path ? _.path = "/" + y.path : g.path ? _.path = g.path.slice(0, g.path.lastIndexOf("/") + 1) + y.path : _.path = y.path, _.path = n(_.path)), _.query = y.query) : (_.path = g.path, y.query !== void 0 ? _.query = y.query : _.query = g.query), _.userinfo = g.userinfo, _.host = g.host, _.port = g.port), _.scheme = g.scheme), _.fragment = y.fragment, _;
  }
  function c(g, y, v) {
    return typeof g == "string" ? (g = unescape(g), g = u(o(p(g, v), !0), { ...v, skipEscape: !0 })) : typeof g == "object" && (g = u(o(g, !0), { ...v, skipEscape: !0 })), typeof y == "string" ? (y = unescape(y), y = u(o(p(y, v), !0), { ...v, skipEscape: !0 })) : typeof y == "object" && (y = u(o(y, !0), { ...v, skipEscape: !0 })), g.toLowerCase() === y.toLowerCase();
  }
  function u(g, y) {
    const v = {
      host: g.host,
      scheme: g.scheme,
      userinfo: g.userinfo,
      port: g.port,
      path: g.path,
      query: g.query,
      nid: g.nid,
      nss: g.nss,
      uuid: g.uuid,
      fragment: g.fragment,
      reference: g.reference,
      resourceName: g.resourceName,
      secure: g.secure,
      error: ""
    }, b = Object.assign({}, y), _ = [], w = i[(b.scheme || v.scheme || "").toLowerCase()];
    w && w.serialize && w.serialize(v, b), v.path !== void 0 && (b.skipEscape ? v.path = unescape(v.path) : (v.path = escape(v.path), v.scheme !== void 0 && (v.path = v.path.split("%3A").join(":")))), b.reference !== "suffix" && v.scheme && _.push(v.scheme, ":");
    const x = r(v, b);
    if (x !== void 0 && (b.reference !== "suffix" && _.push("//"), _.push(x), v.path && v.path.charAt(0) !== "/" && _.push("/")), v.path !== void 0) {
      let E = v.path;
      !b.absolutePath && (!w || !w.absolutePath) && (E = n(E)), x === void 0 && (E = E.replace(/^\/\//u, "/%2F")), _.push(E);
    }
    return v.query !== void 0 && _.push("?", v.query), v.fragment !== void 0 && _.push("#", v.fragment), _.join("");
  }
  const d = Array.from({ length: 127 }, (g, y) => /[^!"$&'()*+,\-.;=_`a-z{}~]/u.test(String.fromCharCode(y)));
  function f(g) {
    let y = 0;
    for (let v = 0, b = g.length; v < b; ++v)
      if (y = g.charCodeAt(v), y > 126 || d[y])
        return !0;
    return !1;
  }
  const h = /^(?:([^#/:?]+):)?(?:\/\/((?:([^#/?@]*)@)?(\[[^#/?\]]+\]|[^#/:?]*)(?::(\d*))?))?([^#?]*)(?:\?([^#]*))?(?:#((?:.|[\n\r])*))?/u;
  function p(g, y) {
    const v = Object.assign({}, y), b = {
      scheme: void 0,
      userinfo: void 0,
      host: "",
      port: void 0,
      path: "",
      query: void 0,
      fragment: void 0
    }, _ = g.indexOf("%") !== -1;
    let w = !1;
    v.reference === "suffix" && (g = (v.scheme ? v.scheme + ":" : "") + "//" + g);
    const x = g.match(h);
    if (x) {
      if (b.scheme = x[1], b.userinfo = x[3], b.host = x[4], b.port = parseInt(x[5], 10), b.path = x[6] || "", b.query = x[7], b.fragment = x[8], isNaN(b.port) && (b.port = x[5]), b.host) {
        const S = e(b.host);
        if (S.isIPV4 === !1) {
          const C = t(S.host, { isIPV4: !1 });
          b.host = C.host.toLowerCase(), w = C.isIPV6;
        } else
          b.host = S.host, w = !0;
      }
      b.scheme === void 0 && b.userinfo === void 0 && b.host === void 0 && b.port === void 0 && !b.path && b.query === void 0 ? b.reference = "same-document" : b.scheme === void 0 ? b.reference = "relative" : b.fragment === void 0 ? b.reference = "absolute" : b.reference = "uri", v.reference && v.reference !== "suffix" && v.reference !== b.reference && (b.error = b.error || "URI is not a " + v.reference + " reference.");
      const E = i[(v.scheme || b.scheme || "").toLowerCase()];
      if (!v.unicodeSupport && (!E || !E.unicodeSupport) && b.host && (v.domainHost || E && E.domainHost) && w === !1 && f(b.host))
        try {
          b.host = URL.domainToASCII(b.host.toLowerCase());
        } catch (S) {
          b.error = b.error || "Host's domain name can not be converted to ASCII: " + S;
        }
      (!E || E && !E.skipNormalize) && (_ && b.scheme !== void 0 && (b.scheme = unescape(b.scheme)), _ && b.host !== void 0 && (b.host = unescape(b.host)), b.path !== void 0 && b.path.length && (b.path = escape(unescape(b.path))), b.fragment !== void 0 && b.fragment.length && (b.fragment = encodeURI(decodeURIComponent(b.fragment)))), E && E.parse && E.parse(b, v);
    } else
      b.error = b.error || "URI can not be parsed.";
    return b;
  }
  const m = {
    SCHEMES: i,
    normalize: s,
    resolve: a,
    resolveComponents: l,
    equal: c,
    serialize: u,
    parse: p
  };
  return Dm.exports = m, Dm.exports.default = m, Dm.exports.fastUri = m, Dm.exports;
}
var Vre;
function h_t() {
  if (Vre) return W1;
  Vre = 1, Object.defineProperty(W1, "__esModule", { value: !0 });
  const t = f_t();
  return t.code = 'require("ajv/dist/runtime/uri").default', W1.default = t, W1;
}
var Wre;
function p_t() {
  return Wre || (Wre = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.CodeGen = t.Name = t.nil = t.stringify = t.str = t._ = t.KeywordCxt = void 0;
    var e = qO();
    Object.defineProperty(t, "KeywordCxt", { enumerable: !0, get: function() {
      return e.KeywordCxt;
    } });
    var n = Mt();
    Object.defineProperty(t, "_", { enumerable: !0, get: function() {
      return n._;
    } }), Object.defineProperty(t, "str", { enumerable: !0, get: function() {
      return n.str;
    } }), Object.defineProperty(t, "stringify", { enumerable: !0, get: function() {
      return n.stringify;
    } }), Object.defineProperty(t, "nil", { enumerable: !0, get: function() {
      return n.nil;
    } }), Object.defineProperty(t, "Name", { enumerable: !0, get: function() {
      return n.Name;
    } }), Object.defineProperty(t, "CodeGen", { enumerable: !0, get: function() {
      return n.CodeGen;
    } });
    const r = Z6(), o = UO(), i = a_e(), s = J6(), a = Mt(), l = zO(), c = BE(), u = Jt(), d = l_t, f = h_t(), h = ($, D) => new RegExp($, D);
    h.code = "new RegExp";
    const p = ["removeAdditional", "useDefaults", "coerceTypes"], m = /* @__PURE__ */ new Set([
      "validate",
      "serialize",
      "parse",
      "wrapper",
      "root",
      "schema",
      "keyword",
      "pattern",
      "formats",
      "validate$data",
      "func",
      "obj",
      "Error"
    ]), g = {
      errorDataPath: "",
      format: "`validateFormats: false` can be used instead.",
      nullable: '"nullable" keyword is supported by default.',
      jsonPointers: "Deprecated jsPropertySyntax can be used instead.",
      extendRefs: "Deprecated ignoreKeywordsWithRef can be used instead.",
      missingRefs: "Pass empty schema with $id that should be ignored to ajv.addSchema.",
      processCode: "Use option `code: {process: (code, schemaEnv: object) => string}`",
      sourceCode: "Use option `code: {source: true}`",
      strictDefaults: "It is default now, see option `strict`.",
      strictKeywords: "It is default now, see option `strict`.",
      uniqueItems: '"uniqueItems" keyword is always validated.',
      unknownFormats: "Disable strict mode or pass `true` to `ajv.addFormat` (or `formats` option).",
      cache: "Map is used as cache, schema object as key.",
      serialize: "Map is used as cache, schema object as key.",
      ajvErrors: "It is default now."
    }, y = {
      ignoreKeywordsWithRef: "",
      jsPropertySyntax: "",
      unicode: '"minLength"/"maxLength" account for unicode characters by default.'
    }, v = 200;
    function b($) {
      var D, U, q, F, B, H, Z, W, G, ee, Y, L, V, K, ne, ce, fe, ve, _e, Ee, Me, Le, Ce, Je, Ie;
      const nt = $.strict, ct = (D = $.code) === null || D === void 0 ? void 0 : D.optimize, mt = ct === !0 || ct === void 0 ? 1 : ct || 0, gt = (q = (U = $.code) === null || U === void 0 ? void 0 : U.regExp) !== null && q !== void 0 ? q : h, Et = (F = $.uriResolver) !== null && F !== void 0 ? F : f.default;
      return {
        strictSchema: (H = (B = $.strictSchema) !== null && B !== void 0 ? B : nt) !== null && H !== void 0 ? H : !0,
        strictNumbers: (W = (Z = $.strictNumbers) !== null && Z !== void 0 ? Z : nt) !== null && W !== void 0 ? W : !0,
        strictTypes: (ee = (G = $.strictTypes) !== null && G !== void 0 ? G : nt) !== null && ee !== void 0 ? ee : "log",
        strictTuples: (L = (Y = $.strictTuples) !== null && Y !== void 0 ? Y : nt) !== null && L !== void 0 ? L : "log",
        strictRequired: (K = (V = $.strictRequired) !== null && V !== void 0 ? V : nt) !== null && K !== void 0 ? K : !1,
        code: $.code ? { ...$.code, optimize: mt, regExp: gt } : { optimize: mt, regExp: gt },
        loopRequired: (ne = $.loopRequired) !== null && ne !== void 0 ? ne : v,
        loopEnum: (ce = $.loopEnum) !== null && ce !== void 0 ? ce : v,
        meta: (fe = $.meta) !== null && fe !== void 0 ? fe : !0,
        messages: (ve = $.messages) !== null && ve !== void 0 ? ve : !0,
        inlineRefs: (_e = $.inlineRefs) !== null && _e !== void 0 ? _e : !0,
        schemaId: (Ee = $.schemaId) !== null && Ee !== void 0 ? Ee : "$id",
        addUsedSchema: (Me = $.addUsedSchema) !== null && Me !== void 0 ? Me : !0,
        validateSchema: (Le = $.validateSchema) !== null && Le !== void 0 ? Le : !0,
        validateFormats: (Ce = $.validateFormats) !== null && Ce !== void 0 ? Ce : !0,
        unicodeRegExp: (Je = $.unicodeRegExp) !== null && Je !== void 0 ? Je : !0,
        int32range: (Ie = $.int32range) !== null && Ie !== void 0 ? Ie : !0,
        uriResolver: Et
      };
    }
    class _ {
      constructor(D = {}) {
        this.schemas = {}, this.refs = {}, this.formats = {}, this._compilations = /* @__PURE__ */ new Set(), this._loading = {}, this._cache = /* @__PURE__ */ new Map(), D = this.opts = { ...D, ...b(D) };
        const { es5: U, lines: q } = this.opts.code;
        this.scope = new a.ValueScope({ scope: {}, prefixes: m, es5: U, lines: q }), this.logger = N(D.logger);
        const F = D.validateFormats;
        D.validateFormats = !1, this.RULES = (0, i.getRules)(), w.call(this, g, D, "NOT SUPPORTED"), w.call(this, y, D, "DEPRECATED", "warn"), this._metaOpts = R.call(this), D.formats && S.call(this), this._addVocabularies(), this._addDefaultMetaSchema(), D.keywords && C.call(this, D.keywords), typeof D.meta == "object" && this.addMetaSchema(D.meta), E.call(this), D.validateFormats = F;
      }
      _addVocabularies() {
        this.addKeyword("$async");
      }
      _addDefaultMetaSchema() {
        const { $data: D, meta: U, schemaId: q } = this.opts;
        let F = d;
        q === "id" && (F = { ...d }, F.id = F.$id, delete F.$id), U && D && this.addMetaSchema(F, F[q], !1);
      }
      defaultMeta() {
        const { meta: D, schemaId: U } = this.opts;
        return this.opts.defaultMeta = typeof D == "object" ? D[U] || D : void 0;
      }
      validate(D, U) {
        let q;
        if (typeof D == "string") {
          if (q = this.getSchema(D), !q)
            throw new Error(`no schema with key or ref "${D}"`);
        } else
          q = this.compile(D);
        const F = q(U);
        return "$async" in q || (this.errors = q.errors), F;
      }
      compile(D, U) {
        const q = this._addSchema(D, U);
        return q.validate || this._compileSchemaEnv(q);
      }
      compileAsync(D, U) {
        if (typeof this.opts.loadSchema != "function")
          throw new Error("options.loadSchema should be a function");
        const { loadSchema: q } = this.opts;
        return F.call(this, D, U);
        async function F(ee, Y) {
          await B.call(this, ee.$schema);
          const L = this._addSchema(ee, Y);
          return L.validate || H.call(this, L);
        }
        async function B(ee) {
          ee && !this.getSchema(ee) && await F.call(this, { $ref: ee }, !0);
        }
        async function H(ee) {
          try {
            return this._compileSchemaEnv(ee);
          } catch (Y) {
            if (!(Y instanceof o.default))
              throw Y;
            return Z.call(this, Y), await W.call(this, Y.missingSchema), H.call(this, ee);
          }
        }
        function Z({ missingSchema: ee, missingRef: Y }) {
          if (this.refs[ee])
            throw new Error(`AnySchema ${ee} is loaded but ${Y} cannot be resolved`);
        }
        async function W(ee) {
          const Y = await G.call(this, ee);
          this.refs[ee] || await B.call(this, Y.$schema), this.refs[ee] || this.addSchema(Y, ee, U);
        }
        async function G(ee) {
          const Y = this._loading[ee];
          if (Y)
            return Y;
          try {
            return await (this._loading[ee] = q(ee));
          } finally {
            delete this._loading[ee];
          }
        }
      }
      // Adds schema to the instance
      addSchema(D, U, q, F = this.opts.validateSchema) {
        if (Array.isArray(D)) {
          for (const H of D)
            this.addSchema(H, void 0, q, F);
          return this;
        }
        let B;
        if (typeof D == "object") {
          const { schemaId: H } = this.opts;
          if (B = D[H], B !== void 0 && typeof B != "string")
            throw new Error(`schema ${H} must be string`);
        }
        return U = (0, l.normalizeId)(U || B), this._checkUnique(U), this.schemas[U] = this._addSchema(D, q, U, F, !0), this;
      }
      // Add schema that will be used to validate other schemas
      // options in META_IGNORE_OPTIONS are alway set to false
      addMetaSchema(D, U, q = this.opts.validateSchema) {
        return this.addSchema(D, U, !0, q), this;
      }
      //  Validate schema against its meta-schema
      validateSchema(D, U) {
        if (typeof D == "boolean")
          return !0;
        let q;
        if (q = D.$schema, q !== void 0 && typeof q != "string")
          throw new Error("$schema must be a string");
        if (q = q || this.opts.defaultMeta || this.defaultMeta(), !q)
          return this.logger.warn("meta-schema not available"), this.errors = null, !0;
        const F = this.validate(q, D);
        if (!F && U) {
          const B = "schema is invalid: " + this.errorsText();
          if (this.opts.validateSchema === "log")
            this.logger.error(B);
          else
            throw new Error(B);
        }
        return F;
      }
      // Get compiled schema by `key` or `ref`.
      // (`key` that was passed to `addSchema` or full schema reference - `schema.$id` or resolved id)
      getSchema(D) {
        let U;
        for (; typeof (U = x.call(this, D)) == "string"; )
          D = U;
        if (U === void 0) {
          const { schemaId: q } = this.opts, F = new s.SchemaEnv({ schema: {}, schemaId: q });
          if (U = s.resolveSchema.call(this, F, D), !U)
            return;
          this.refs[D] = U;
        }
        return U.validate || this._compileSchemaEnv(U);
      }
      // Remove cached schema(s).
      // If no parameter is passed all schemas but meta-schemas are removed.
      // If RegExp is passed all schemas with key/id matching pattern but meta-schemas are removed.
      // Even if schema is referenced by other schemas it still can be removed as other schemas have local references.
      removeSchema(D) {
        if (D instanceof RegExp)
          return this._removeAllSchemas(this.schemas, D), this._removeAllSchemas(this.refs, D), this;
        switch (typeof D) {
          case "undefined":
            return this._removeAllSchemas(this.schemas), this._removeAllSchemas(this.refs), this._cache.clear(), this;
          case "string": {
            const U = x.call(this, D);
            return typeof U == "object" && this._cache.delete(U.schema), delete this.schemas[D], delete this.refs[D], this;
          }
          case "object": {
            const U = D;
            this._cache.delete(U);
            let q = D[this.opts.schemaId];
            return q && (q = (0, l.normalizeId)(q), delete this.schemas[q], delete this.refs[q]), this;
          }
          default:
            throw new Error("ajv.removeSchema: invalid parameter");
        }
      }
      // add "vocabulary" - a collection of keywords
      addVocabulary(D) {
        for (const U of D)
          this.addKeyword(U);
        return this;
      }
      addKeyword(D, U) {
        let q;
        if (typeof D == "string")
          q = D, typeof U == "object" && (this.logger.warn("these parameters are deprecated, see docs for addKeyword"), U.keyword = q);
        else if (typeof D == "object" && U === void 0) {
          if (U = D, q = U.keyword, Array.isArray(q) && !q.length)
            throw new Error("addKeywords: keyword must be string or non-empty array");
        } else
          throw new Error("invalid addKeywords parameters");
        if (O.call(this, q, U), !U)
          return (0, u.eachItem)(q, (B) => k.call(this, B)), this;
        I.call(this, U);
        const F = {
          ...U,
          type: (0, c.getJSONTypes)(U.type),
          schemaType: (0, c.getJSONTypes)(U.schemaType)
        };
        return (0, u.eachItem)(q, F.type.length === 0 ? (B) => k.call(this, B, F) : (B) => F.type.forEach((H) => k.call(this, B, F, H))), this;
      }
      getKeyword(D) {
        const U = this.RULES.all[D];
        return typeof U == "object" ? U.definition : !!U;
      }
      // Remove keyword
      removeKeyword(D) {
        const { RULES: U } = this;
        delete U.keywords[D], delete U.all[D];
        for (const q of U.rules) {
          const F = q.rules.findIndex((B) => B.keyword === D);
          F >= 0 && q.rules.splice(F, 1);
        }
        return this;
      }
      // Add format
      addFormat(D, U) {
        return typeof U == "string" && (U = new RegExp(U)), this.formats[D] = U, this;
      }
      errorsText(D = this.errors, { separator: U = ", ", dataVar: q = "data" } = {}) {
        return !D || D.length === 0 ? "No errors" : D.map((F) => `${q}${F.instancePath} ${F.message}`).reduce((F, B) => F + U + B);
      }
      $dataMetaSchema(D, U) {
        const q = this.RULES.all;
        D = JSON.parse(JSON.stringify(D));
        for (const F of U) {
          const B = F.split("/").slice(1);
          let H = D;
          for (const Z of B)
            H = H[Z];
          for (const Z in q) {
            const W = q[Z];
            if (typeof W != "object")
              continue;
            const { $data: G } = W.definition, ee = H[Z];
            G && ee && (H[Z] = z(ee));
          }
        }
        return D;
      }
      _removeAllSchemas(D, U) {
        for (const q in D) {
          const F = D[q];
          (!U || U.test(q)) && (typeof F == "string" ? delete D[q] : F && !F.meta && (this._cache.delete(F.schema), delete D[q]));
        }
      }
      _addSchema(D, U, q, F = this.opts.validateSchema, B = this.opts.addUsedSchema) {
        let H;
        const { schemaId: Z } = this.opts;
        if (typeof D == "object")
          H = D[Z];
        else {
          if (this.opts.jtd)
            throw new Error("schema must be object");
          if (typeof D != "boolean")
            throw new Error("schema must be object or boolean");
        }
        let W = this._cache.get(D);
        if (W !== void 0)
          return W;
        q = (0, l.normalizeId)(H || q);
        const G = l.getSchemaRefs.call(this, D, q);
        return W = new s.SchemaEnv({ schema: D, schemaId: Z, meta: U, baseId: q, localRefs: G }), this._cache.set(W.schema, W), B && !q.startsWith("#") && (q && this._checkUnique(q), this.refs[q] = W), F && this.validateSchema(D, !0), W;
      }
      _checkUnique(D) {
        if (this.schemas[D] || this.refs[D])
          throw new Error(`schema with key or id "${D}" already exists`);
      }
      _compileSchemaEnv(D) {
        if (D.meta ? this._compileMetaSchema(D) : s.compileSchema.call(this, D), !D.validate)
          throw new Error("ajv implementation error");
        return D.validate;
      }
      _compileMetaSchema(D) {
        const U = this.opts;
        this.opts = this._metaOpts;
        try {
          s.compileSchema.call(this, D);
        } finally {
          this.opts = U;
        }
      }
    }
    _.ValidationError = r.default, _.MissingRefError = o.default, t.default = _;
    function w($, D, U, q = "error") {
      for (const F in $) {
        const B = F;
        B in D && this.logger[q](`${U}: option ${F}. ${$[B]}`);
      }
    }
    function x($) {
      return $ = (0, l.normalizeId)($), this.schemas[$] || this.refs[$];
    }
    function E() {
      const $ = this.opts.schemas;
      if ($)
        if (Array.isArray($))
          this.addSchema($);
        else
          for (const D in $)
            this.addSchema($[D], D);
    }
    function S() {
      for (const $ in this.opts.formats) {
        const D = this.opts.formats[$];
        D && this.addFormat($, D);
      }
    }
    function C($) {
      if (Array.isArray($)) {
        this.addVocabulary($);
        return;
      }
      this.logger.warn("keywords option as map is deprecated, pass array");
      for (const D in $) {
        const U = $[D];
        U.keyword || (U.keyword = D), this.addKeyword(U);
      }
    }
    function R() {
      const $ = { ...this.opts };
      for (const D of p)
        delete $[D];
      return $;
    }
    const P = { log() {
    }, warn() {
    }, error() {
    } };
    function N($) {
      if ($ === !1)
        return P;
      if ($ === void 0)
        return console;
      if ($.log && $.warn && $.error)
        return $;
      throw new Error("logger must implement log, warn and error methods");
    }
    const A = /^[a-z_$][a-z0-9_$:-]*$/i;
    function O($, D) {
      const { RULES: U } = this;
      if ((0, u.eachItem)($, (q) => {
        if (U.keywords[q])
          throw new Error(`Keyword ${q} is already defined`);
        if (!A.test(q))
          throw new Error(`Keyword ${q} has invalid name`);
      }), !!D && D.$data && !("code" in D || "validate" in D))
        throw new Error('$data keyword must have "code" or "validate" function');
    }
    function k($, D, U) {
      var q;
      const F = D?.post;
      if (U && F)
        throw new Error('keyword with "post" flag cannot have "type"');
      const { RULES: B } = this;
      let H = F ? B.post : B.rules.find(({ type: W }) => W === U);
      if (H || (H = { type: U, rules: [] }, B.rules.push(H)), B.keywords[$] = !0, !D)
        return;
      const Z = {
        keyword: $,
        definition: {
          ...D,
          type: (0, c.getJSONTypes)(D.type),
          schemaType: (0, c.getJSONTypes)(D.schemaType)
        }
      };
      D.before ? T.call(this, H, Z, D.before) : H.rules.push(Z), B.all[$] = Z, (q = D.implements) === null || q === void 0 || q.forEach((W) => this.addKeyword(W));
    }
    function T($, D, U) {
      const q = $.rules.findIndex((F) => F.keyword === U);
      q >= 0 ? $.rules.splice(q, 0, D) : ($.rules.push(D), this.logger.warn(`rule ${U} is not defined`));
    }
    function I($) {
      let { metaSchema: D } = $;
      D !== void 0 && ($.$data && this.opts.$data && (D = z(D)), $.validateSchema = this.compile(D, !0));
    }
    const j = {
      $ref: "https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#"
    };
    function z($) {
      return { anyOf: [$, j] };
    }
  }(XM)), XM;
}
var G1 = {}, Y1 = {}, K1 = {}, Gre;
function m_t() {
  if (Gre) return K1;
  Gre = 1, Object.defineProperty(K1, "__esModule", { value: !0 });
  const t = {
    keyword: "id",
    code() {
      throw new Error('NOT SUPPORTED: keyword "id", use "$id" for schema ID');
    }
  };
  return K1.default = t, K1;
}
var sc = {}, Yre;
function g_t() {
  if (Yre) return sc;
  Yre = 1, Object.defineProperty(sc, "__esModule", { value: !0 }), sc.callRef = sc.getValidate = void 0;
  const t = UO(), e = js(), n = Mt(), r = fu(), o = J6(), i = Jt(), s = {
    keyword: "$ref",
    schemaType: "string",
    code(c) {
      const { gen: u, schema: d, it: f } = c, { baseId: h, schemaEnv: p, validateName: m, opts: g, self: y } = f, { root: v } = p;
      if ((d === "#" || d === "#/") && h === v.baseId)
        return _();
      const b = o.resolveRef.call(y, v, h, d);
      if (b === void 0)
        throw new t.default(f.opts.uriResolver, h, d);
      if (b instanceof o.SchemaEnv)
        return w(b);
      return x(b);
      function _() {
        if (p === v)
          return l(c, m, p, p.$async);
        const E = u.scopeValue("root", { ref: v });
        return l(c, (0, n._)`${E}.validate`, v, v.$async);
      }
      function w(E) {
        const S = a(c, E);
        l(c, S, E, E.$async);
      }
      function x(E) {
        const S = u.scopeValue("schema", g.code.source === !0 ? { ref: E, code: (0, n.stringify)(E) } : { ref: E }), C = u.name("valid"), R = c.subschema({
          schema: E,
          dataTypes: [],
          schemaPath: n.nil,
          topSchemaRef: S,
          errSchemaPath: d
        }, C);
        c.mergeEvaluated(R), c.ok(C);
      }
    }
  };
  function a(c, u) {
    const { gen: d } = c;
    return u.validate ? d.scopeValue("validate", { ref: u.validate }) : (0, n._)`${d.scopeValue("wrapper", { ref: u })}.validate`;
  }
  sc.getValidate = a;
  function l(c, u, d, f) {
    const { gen: h, it: p } = c, { allErrors: m, schemaEnv: g, opts: y } = p, v = y.passContext ? r.default.this : n.nil;
    f ? b() : _();
    function b() {
      if (!g.$async)
        throw new Error("async schema referenced by sync schema");
      const E = h.let("valid");
      h.try(() => {
        h.code((0, n._)`await ${(0, e.callValidateCode)(c, u, v)}`), x(u), m || h.assign(E, !0);
      }, (S) => {
        h.if((0, n._)`!(${S} instanceof ${p.ValidationError})`, () => h.throw(S)), w(S), m || h.assign(E, !1);
      }), c.ok(E);
    }
    function _() {
      c.result((0, e.callValidateCode)(c, u, v), () => x(u), () => w(u));
    }
    function w(E) {
      const S = (0, n._)`${E}.errors`;
      h.assign(r.default.vErrors, (0, n._)`${r.default.vErrors} === null ? ${S} : ${r.default.vErrors}.concat(${S})`), h.assign(r.default.errors, (0, n._)`${r.default.vErrors}.length`);
    }
    function x(E) {
      var S;
      if (!p.opts.unevaluated)
        return;
      const C = (S = d?.validate) === null || S === void 0 ? void 0 : S.evaluated;
      if (p.props !== !0)
        if (C && !C.dynamicProps)
          C.props !== void 0 && (p.props = i.mergeEvaluated.props(h, C.props, p.props));
        else {
          const R = h.var("props", (0, n._)`${E}.evaluated.props`);
          p.props = i.mergeEvaluated.props(h, R, p.props, n.Name);
        }
      if (p.items !== !0)
        if (C && !C.dynamicItems)
          C.items !== void 0 && (p.items = i.mergeEvaluated.items(h, C.items, p.items));
        else {
          const R = h.var("items", (0, n._)`${E}.evaluated.items`);
          p.items = i.mergeEvaluated.items(h, R, p.items, n.Name);
        }
    }
  }
  return sc.callRef = l, sc.default = s, sc;
}
var Kre;
function y_t() {
  if (Kre) return Y1;
  Kre = 1, Object.defineProperty(Y1, "__esModule", { value: !0 });
  const t = m_t(), e = g_t(), n = [
    "$schema",
    "$id",
    "$defs",
    "$vocabulary",
    { keyword: "$comment" },
    "definitions",
    t.default,
    e.default
  ];
  return Y1.default = n, Y1;
}
var X1 = {}, Q1 = {}, Xre;
function v_t() {
  if (Xre) return Q1;
  Xre = 1, Object.defineProperty(Q1, "__esModule", { value: !0 });
  const t = Mt(), e = t.operators, n = {
    maximum: { okStr: "<=", ok: e.LTE, fail: e.GT },
    minimum: { okStr: ">=", ok: e.GTE, fail: e.LT },
    exclusiveMaximum: { okStr: "<", ok: e.LT, fail: e.GTE },
    exclusiveMinimum: { okStr: ">", ok: e.GT, fail: e.LTE }
  }, r = {
    message: ({ keyword: i, schemaCode: s }) => (0, t.str)`must be ${n[i].okStr} ${s}`,
    params: ({ keyword: i, schemaCode: s }) => (0, t._)`{comparison: ${n[i].okStr}, limit: ${s}}`
  }, o = {
    keyword: Object.keys(n),
    type: "number",
    schemaType: "number",
    $data: !0,
    error: r,
    code(i) {
      const { keyword: s, data: a, schemaCode: l } = i;
      i.fail$data((0, t._)`${a} ${n[s].fail} ${l} || isNaN(${a})`);
    }
  };
  return Q1.default = o, Q1;
}
var Z1 = {}, Qre;
function b_t() {
  if (Qre) return Z1;
  Qre = 1, Object.defineProperty(Z1, "__esModule", { value: !0 });
  const t = Mt(), n = {
    keyword: "multipleOf",
    type: "number",
    schemaType: "number",
    $data: !0,
    error: {
      message: ({ schemaCode: r }) => (0, t.str)`must be multiple of ${r}`,
      params: ({ schemaCode: r }) => (0, t._)`{multipleOf: ${r}}`
    },
    code(r) {
      const { gen: o, data: i, schemaCode: s, it: a } = r, l = a.opts.multipleOfPrecision, c = o.let("res"), u = l ? (0, t._)`Math.abs(Math.round(${c}) - ${c}) > 1e-${l}` : (0, t._)`${c} !== parseInt(${c})`;
      r.fail$data((0, t._)`(${s} === 0 || (${c} = ${i}/${s}, ${u}))`);
    }
  };
  return Z1.default = n, Z1;
}
var J1 = {}, e_ = {}, Zre;
function __t() {
  if (Zre) return e_;
  Zre = 1, Object.defineProperty(e_, "__esModule", { value: !0 });
  function t(e) {
    const n = e.length;
    let r = 0, o = 0, i;
    for (; o < n; )
      r++, i = e.charCodeAt(o++), i >= 55296 && i <= 56319 && o < n && (i = e.charCodeAt(o), (i & 64512) === 56320 && o++);
    return r;
  }
  return e_.default = t, t.code = 'require("ajv/dist/runtime/ucs2length").default', e_;
}
var Jre;
function w_t() {
  if (Jre) return J1;
  Jre = 1, Object.defineProperty(J1, "__esModule", { value: !0 });
  const t = Mt(), e = Jt(), n = __t(), o = {
    keyword: ["maxLength", "minLength"],
    type: "string",
    schemaType: "number",
    $data: !0,
    error: {
      message({ keyword: i, schemaCode: s }) {
        const a = i === "maxLength" ? "more" : "fewer";
        return (0, t.str)`must NOT have ${a} than ${s} characters`;
      },
      params: ({ schemaCode: i }) => (0, t._)`{limit: ${i}}`
    },
    code(i) {
      const { keyword: s, data: a, schemaCode: l, it: c } = i, u = s === "maxLength" ? t.operators.GT : t.operators.LT, d = c.opts.unicode === !1 ? (0, t._)`${a}.length` : (0, t._)`${(0, e.useFunc)(i.gen, n.default)}(${a})`;
      i.fail$data((0, t._)`${d} ${u} ${l}`);
    }
  };
  return J1.default = o, J1;
}
var t_ = {}, eoe;
function x_t() {
  if (eoe) return t_;
  eoe = 1, Object.defineProperty(t_, "__esModule", { value: !0 });
  const t = js(), e = Mt(), r = {
    keyword: "pattern",
    type: "string",
    schemaType: "string",
    $data: !0,
    error: {
      message: ({ schemaCode: o }) => (0, e.str)`must match pattern "${o}"`,
      params: ({ schemaCode: o }) => (0, e._)`{pattern: ${o}}`
    },
    code(o) {
      const { data: i, $data: s, schema: a, schemaCode: l, it: c } = o, u = c.opts.unicodeRegExp ? "u" : "", d = s ? (0, e._)`(new RegExp(${l}, ${u}))` : (0, t.usePattern)(o, a);
      o.fail$data((0, e._)`!${d}.test(${i})`);
    }
  };
  return t_.default = r, t_;
}
var n_ = {}, toe;
function E_t() {
  if (toe) return n_;
  toe = 1, Object.defineProperty(n_, "__esModule", { value: !0 });
  const t = Mt(), n = {
    keyword: ["maxProperties", "minProperties"],
    type: "object",
    schemaType: "number",
    $data: !0,
    error: {
      message({ keyword: r, schemaCode: o }) {
        const i = r === "maxProperties" ? "more" : "fewer";
        return (0, t.str)`must NOT have ${i} than ${o} properties`;
      },
      params: ({ schemaCode: r }) => (0, t._)`{limit: ${r}}`
    },
    code(r) {
      const { keyword: o, data: i, schemaCode: s } = r, a = o === "maxProperties" ? t.operators.GT : t.operators.LT;
      r.fail$data((0, t._)`Object.keys(${i}).length ${a} ${s}`);
    }
  };
  return n_.default = n, n_;
}
var r_ = {}, noe;
function S_t() {
  if (noe) return r_;
  noe = 1, Object.defineProperty(r_, "__esModule", { value: !0 });
  const t = js(), e = Mt(), n = Jt(), o = {
    keyword: "required",
    type: "object",
    schemaType: "array",
    $data: !0,
    error: {
      message: ({ params: { missingProperty: i } }) => (0, e.str)`must have required property '${i}'`,
      params: ({ params: { missingProperty: i } }) => (0, e._)`{missingProperty: ${i}}`
    },
    code(i) {
      const { gen: s, schema: a, schemaCode: l, data: c, $data: u, it: d } = i, { opts: f } = d;
      if (!u && a.length === 0)
        return;
      const h = a.length >= f.loopRequired;
      if (d.allErrors ? p() : m(), f.strictRequired) {
        const v = i.parentSchema.properties, { definedProperties: b } = i.it;
        for (const _ of a)
          if (v?.[_] === void 0 && !b.has(_)) {
            const w = d.schemaEnv.baseId + d.errSchemaPath, x = `required property "${_}" is not defined at "${w}" (strictRequired)`;
            (0, n.checkStrictMode)(d, x, d.opts.strictRequired);
          }
      }
      function p() {
        if (h || u)
          i.block$data(e.nil, g);
        else
          for (const v of a)
            (0, t.checkReportMissingProp)(i, v);
      }
      function m() {
        const v = s.let("missing");
        if (h || u) {
          const b = s.let("valid", !0);
          i.block$data(b, () => y(v, b)), i.ok(b);
        } else
          s.if((0, t.checkMissingProp)(i, a, v)), (0, t.reportMissingProp)(i, v), s.else();
      }
      function g() {
        s.forOf("prop", l, (v) => {
          i.setParams({ missingProperty: v }), s.if((0, t.noPropertyInData)(s, c, v, f.ownProperties), () => i.error());
        });
      }
      function y(v, b) {
        i.setParams({ missingProperty: v }), s.forOf(v, l, () => {
          s.assign(b, (0, t.propertyInData)(s, c, v, f.ownProperties)), s.if((0, e.not)(b), () => {
            i.error(), s.break();
          });
        }, e.nil);
      }
    }
  };
  return r_.default = o, r_;
}
var o_ = {}, roe;
function O_t() {
  if (roe) return o_;
  roe = 1, Object.defineProperty(o_, "__esModule", { value: !0 });
  const t = Mt(), n = {
    keyword: ["maxItems", "minItems"],
    type: "array",
    schemaType: "number",
    $data: !0,
    error: {
      message({ keyword: r, schemaCode: o }) {
        const i = r === "maxItems" ? "more" : "fewer";
        return (0, t.str)`must NOT have ${i} than ${o} items`;
      },
      params: ({ schemaCode: r }) => (0, t._)`{limit: ${r}}`
    },
    code(r) {
      const { keyword: o, data: i, schemaCode: s } = r, a = o === "maxItems" ? t.operators.GT : t.operators.LT;
      r.fail$data((0, t._)`${i}.length ${a} ${s}`);
    }
  };
  return o_.default = n, o_;
}
var i_ = {}, s_ = {}, ooe;
function e9() {
  if (ooe) return s_;
  ooe = 1, Object.defineProperty(s_, "__esModule", { value: !0 });
  const t = c_e();
  return t.code = 'require("ajv/dist/runtime/equal").default', s_.default = t, s_;
}
var ioe;
function C_t() {
  if (ioe) return i_;
  ioe = 1, Object.defineProperty(i_, "__esModule", { value: !0 });
  const t = BE(), e = Mt(), n = Jt(), r = e9(), i = {
    keyword: "uniqueItems",
    type: "array",
    schemaType: "boolean",
    $data: !0,
    error: {
      message: ({ params: { i: s, j: a } }) => (0, e.str)`must NOT have duplicate items (items ## ${a} and ${s} are identical)`,
      params: ({ params: { i: s, j: a } }) => (0, e._)`{i: ${s}, j: ${a}}`
    },
    code(s) {
      const { gen: a, data: l, $data: c, schema: u, parentSchema: d, schemaCode: f, it: h } = s;
      if (!c && !u)
        return;
      const p = a.let("valid"), m = d.items ? (0, t.getSchemaTypes)(d.items) : [];
      s.block$data(p, g, (0, e._)`${f} === false`), s.ok(p);
      function g() {
        const _ = a.let("i", (0, e._)`${l}.length`), w = a.let("j");
        s.setParams({ i: _, j: w }), a.assign(p, !0), a.if((0, e._)`${_} > 1`, () => (y() ? v : b)(_, w));
      }
      function y() {
        return m.length > 0 && !m.some((_) => _ === "object" || _ === "array");
      }
      function v(_, w) {
        const x = a.name("item"), E = (0, t.checkDataTypes)(m, x, h.opts.strictNumbers, t.DataType.Wrong), S = a.const("indices", (0, e._)`{}`);
        a.for((0, e._)`;${_}--;`, () => {
          a.let(x, (0, e._)`${l}[${_}]`), a.if(E, (0, e._)`continue`), m.length > 1 && a.if((0, e._)`typeof ${x} == "string"`, (0, e._)`${x} += "_"`), a.if((0, e._)`typeof ${S}[${x}] == "number"`, () => {
            a.assign(w, (0, e._)`${S}[${x}]`), s.error(), a.assign(p, !1).break();
          }).code((0, e._)`${S}[${x}] = ${_}`);
        });
      }
      function b(_, w) {
        const x = (0, n.useFunc)(a, r.default), E = a.name("outer");
        a.label(E).for((0, e._)`;${_}--;`, () => a.for((0, e._)`${w} = ${_}; ${w}--;`, () => a.if((0, e._)`${x}(${l}[${_}], ${l}[${w}])`, () => {
          s.error(), a.assign(p, !1).break(E);
        })));
      }
    }
  };
  return i_.default = i, i_;
}
var a_ = {}, soe;
function k_t() {
  if (soe) return a_;
  soe = 1, Object.defineProperty(a_, "__esModule", { value: !0 });
  const t = Mt(), e = Jt(), n = e9(), o = {
    keyword: "const",
    $data: !0,
    error: {
      message: "must be equal to constant",
      params: ({ schemaCode: i }) => (0, t._)`{allowedValue: ${i}}`
    },
    code(i) {
      const { gen: s, data: a, $data: l, schemaCode: c, schema: u } = i;
      l || u && typeof u == "object" ? i.fail$data((0, t._)`!${(0, e.useFunc)(s, n.default)}(${a}, ${c})`) : i.fail((0, t._)`${u} !== ${a}`);
    }
  };
  return a_.default = o, a_;
}
var l_ = {}, aoe;
function A_t() {
  if (aoe) return l_;
  aoe = 1, Object.defineProperty(l_, "__esModule", { value: !0 });
  const t = Mt(), e = Jt(), n = e9(), o = {
    keyword: "enum",
    schemaType: "array",
    $data: !0,
    error: {
      message: "must be equal to one of the allowed values",
      params: ({ schemaCode: i }) => (0, t._)`{allowedValues: ${i}}`
    },
    code(i) {
      const { gen: s, data: a, $data: l, schema: c, schemaCode: u, it: d } = i;
      if (!l && c.length === 0)
        throw new Error("enum must have non-empty array");
      const f = c.length >= d.opts.loopEnum;
      let h;
      const p = () => h ?? (h = (0, e.useFunc)(s, n.default));
      let m;
      if (f || l)
        m = s.let("valid"), i.block$data(m, g);
      else {
        if (!Array.isArray(c))
          throw new Error("ajv implementation error");
        const v = s.const("vSchema", u);
        m = (0, t.or)(...c.map((b, _) => y(v, _)));
      }
      i.pass(m);
      function g() {
        s.assign(m, !1), s.forOf("v", u, (v) => s.if((0, t._)`${p()}(${a}, ${v})`, () => s.assign(m, !0).break()));
      }
      function y(v, b) {
        const _ = c[b];
        return typeof _ == "object" && _ !== null ? (0, t._)`${p()}(${a}, ${v}[${b}])` : (0, t._)`${a} === ${_}`;
      }
    }
  };
  return l_.default = o, l_;
}
var loe;
function T_t() {
  if (loe) return X1;
  loe = 1, Object.defineProperty(X1, "__esModule", { value: !0 });
  const t = v_t(), e = b_t(), n = w_t(), r = x_t(), o = E_t(), i = S_t(), s = O_t(), a = C_t(), l = k_t(), c = A_t(), u = [
    // number
    t.default,
    e.default,
    // string
    n.default,
    r.default,
    // object
    o.default,
    i.default,
    // array
    s.default,
    a.default,
    // any
    { keyword: "type", schemaType: ["string", "array"] },
    { keyword: "nullable", schemaType: "boolean" },
    l.default,
    c.default
  ];
  return X1.default = u, X1;
}
var c_ = {}, Of = {}, coe;
function u_e() {
  if (coe) return Of;
  coe = 1, Object.defineProperty(Of, "__esModule", { value: !0 }), Of.validateAdditionalItems = void 0;
  const t = Mt(), e = Jt(), r = {
    keyword: "additionalItems",
    type: "array",
    schemaType: ["boolean", "object"],
    before: "uniqueItems",
    error: {
      message: ({ params: { len: i } }) => (0, t.str)`must NOT have more than ${i} items`,
      params: ({ params: { len: i } }) => (0, t._)`{limit: ${i}}`
    },
    code(i) {
      const { parentSchema: s, it: a } = i, { items: l } = s;
      if (!Array.isArray(l)) {
        (0, e.checkStrictMode)(a, '"additionalItems" is ignored when "items" is not an array of schemas');
        return;
      }
      o(i, l);
    }
  };
  function o(i, s) {
    const { gen: a, schema: l, data: c, keyword: u, it: d } = i;
    d.items = !0;
    const f = a.const("len", (0, t._)`${c}.length`);
    if (l === !1)
      i.setParams({ len: s.length }), i.pass((0, t._)`${f} <= ${s.length}`);
    else if (typeof l == "object" && !(0, e.alwaysValidSchema)(d, l)) {
      const p = a.var("valid", (0, t._)`${f} <= ${s.length}`);
      a.if((0, t.not)(p), () => h(p)), i.ok(p);
    }
    function h(p) {
      a.forRange("i", s.length, f, (m) => {
        i.subschema({ keyword: u, dataProp: m, dataPropType: e.Type.Num }, p), d.allErrors || a.if((0, t.not)(p), () => a.break());
      });
    }
  }
  return Of.validateAdditionalItems = o, Of.default = r, Of;
}
var u_ = {}, Cf = {}, uoe;
function d_e() {
  if (uoe) return Cf;
  uoe = 1, Object.defineProperty(Cf, "__esModule", { value: !0 }), Cf.validateTuple = void 0;
  const t = Mt(), e = Jt(), n = js(), r = {
    keyword: "items",
    type: "array",
    schemaType: ["object", "array", "boolean"],
    before: "uniqueItems",
    code(i) {
      const { schema: s, it: a } = i;
      if (Array.isArray(s))
        return o(i, "additionalItems", s);
      a.items = !0, !(0, e.alwaysValidSchema)(a, s) && i.ok((0, n.validateArray)(i));
    }
  };
  function o(i, s, a = i.schema) {
    const { gen: l, parentSchema: c, data: u, keyword: d, it: f } = i;
    m(c), f.opts.unevaluated && a.length && f.items !== !0 && (f.items = e.mergeEvaluated.items(l, a.length, f.items));
    const h = l.name("valid"), p = l.const("len", (0, t._)`${u}.length`);
    a.forEach((g, y) => {
      (0, e.alwaysValidSchema)(f, g) || (l.if((0, t._)`${p} > ${y}`, () => i.subschema({
        keyword: d,
        schemaProp: y,
        dataProp: y
      }, h)), i.ok(h));
    });
    function m(g) {
      const { opts: y, errSchemaPath: v } = f, b = a.length, _ = b === g.minItems && (b === g.maxItems || g[s] === !1);
      if (y.strictTuples && !_) {
        const w = `"${d}" is ${b}-tuple, but minItems or maxItems/${s} are not specified or different at path "${v}"`;
        (0, e.checkStrictMode)(f, w, y.strictTuples);
      }
    }
  }
  return Cf.validateTuple = o, Cf.default = r, Cf;
}
var doe;
function R_t() {
  if (doe) return u_;
  doe = 1, Object.defineProperty(u_, "__esModule", { value: !0 });
  const t = d_e(), e = {
    keyword: "prefixItems",
    type: "array",
    schemaType: ["array"],
    before: "uniqueItems",
    code: (n) => (0, t.validateTuple)(n, "items")
  };
  return u_.default = e, u_;
}
var d_ = {}, foe;
function P_t() {
  if (foe) return d_;
  foe = 1, Object.defineProperty(d_, "__esModule", { value: !0 });
  const t = Mt(), e = Jt(), n = js(), r = u_e(), i = {
    keyword: "items",
    type: "array",
    schemaType: ["object", "boolean"],
    before: "uniqueItems",
    error: {
      message: ({ params: { len: s } }) => (0, t.str)`must NOT have more than ${s} items`,
      params: ({ params: { len: s } }) => (0, t._)`{limit: ${s}}`
    },
    code(s) {
      const { schema: a, parentSchema: l, it: c } = s, { prefixItems: u } = l;
      c.items = !0, !(0, e.alwaysValidSchema)(c, a) && (u ? (0, r.validateAdditionalItems)(s, u) : s.ok((0, n.validateArray)(s)));
    }
  };
  return d_.default = i, d_;
}
var f_ = {}, hoe;
function $_t() {
  if (hoe) return f_;
  hoe = 1, Object.defineProperty(f_, "__esModule", { value: !0 });
  const t = Mt(), e = Jt(), r = {
    keyword: "contains",
    type: "array",
    schemaType: ["object", "boolean"],
    before: "uniqueItems",
    trackErrors: !0,
    error: {
      message: ({ params: { min: o, max: i } }) => i === void 0 ? (0, t.str)`must contain at least ${o} valid item(s)` : (0, t.str)`must contain at least ${o} and no more than ${i} valid item(s)`,
      params: ({ params: { min: o, max: i } }) => i === void 0 ? (0, t._)`{minContains: ${o}}` : (0, t._)`{minContains: ${o}, maxContains: ${i}}`
    },
    code(o) {
      const { gen: i, schema: s, parentSchema: a, data: l, it: c } = o;
      let u, d;
      const { minContains: f, maxContains: h } = a;
      c.opts.next ? (u = f === void 0 ? 1 : f, d = h) : u = 1;
      const p = i.const("len", (0, t._)`${l}.length`);
      if (o.setParams({ min: u, max: d }), d === void 0 && u === 0) {
        (0, e.checkStrictMode)(c, '"minContains" == 0 without "maxContains": "contains" keyword ignored');
        return;
      }
      if (d !== void 0 && u > d) {
        (0, e.checkStrictMode)(c, '"minContains" > "maxContains" is always invalid'), o.fail();
        return;
      }
      if ((0, e.alwaysValidSchema)(c, s)) {
        let b = (0, t._)`${p} >= ${u}`;
        d !== void 0 && (b = (0, t._)`${b} && ${p} <= ${d}`), o.pass(b);
        return;
      }
      c.items = !0;
      const m = i.name("valid");
      d === void 0 && u === 1 ? y(m, () => i.if(m, () => i.break())) : u === 0 ? (i.let(m, !0), d !== void 0 && i.if((0, t._)`${l}.length > 0`, g)) : (i.let(m, !1), g()), o.result(m, () => o.reset());
      function g() {
        const b = i.name("_valid"), _ = i.let("count", 0);
        y(b, () => i.if(b, () => v(_)));
      }
      function y(b, _) {
        i.forRange("i", 0, p, (w) => {
          o.subschema({
            keyword: "contains",
            dataProp: w,
            dataPropType: e.Type.Num,
            compositeRule: !0
          }, b), _();
        });
      }
      function v(b) {
        i.code((0, t._)`${b}++`), d === void 0 ? i.if((0, t._)`${b} >= ${u}`, () => i.assign(m, !0).break()) : (i.if((0, t._)`${b} > ${d}`, () => i.assign(m, !1).break()), u === 1 ? i.assign(m, !0) : i.if((0, t._)`${b} >= ${u}`, () => i.assign(m, !0)));
      }
    }
  };
  return f_.default = r, f_;
}
var sD = {}, poe;
function M_t() {
  return poe || (poe = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.validateSchemaDeps = t.validatePropertyDeps = t.error = void 0;
    const e = Mt(), n = Jt(), r = js();
    t.error = {
      message: ({ params: { property: l, depsCount: c, deps: u } }) => {
        const d = c === 1 ? "property" : "properties";
        return (0, e.str)`must have ${d} ${u} when property ${l} is present`;
      },
      params: ({ params: { property: l, depsCount: c, deps: u, missingProperty: d } }) => (0, e._)`{property: ${l},
    missingProperty: ${d},
    depsCount: ${c},
    deps: ${u}}`
      // TODO change to reference
    };
    const o = {
      keyword: "dependencies",
      type: "object",
      schemaType: "object",
      error: t.error,
      code(l) {
        const [c, u] = i(l);
        s(l, c), a(l, u);
      }
    };
    function i({ schema: l }) {
      const c = {}, u = {};
      for (const d in l) {
        if (d === "__proto__")
          continue;
        const f = Array.isArray(l[d]) ? c : u;
        f[d] = l[d];
      }
      return [c, u];
    }
    function s(l, c = l.schema) {
      const { gen: u, data: d, it: f } = l;
      if (Object.keys(c).length === 0)
        return;
      const h = u.let("missing");
      for (const p in c) {
        const m = c[p];
        if (m.length === 0)
          continue;
        const g = (0, r.propertyInData)(u, d, p, f.opts.ownProperties);
        l.setParams({
          property: p,
          depsCount: m.length,
          deps: m.join(", ")
        }), f.allErrors ? u.if(g, () => {
          for (const y of m)
            (0, r.checkReportMissingProp)(l, y);
        }) : (u.if((0, e._)`${g} && (${(0, r.checkMissingProp)(l, m, h)})`), (0, r.reportMissingProp)(l, h), u.else());
      }
    }
    t.validatePropertyDeps = s;
    function a(l, c = l.schema) {
      const { gen: u, data: d, keyword: f, it: h } = l, p = u.name("valid");
      for (const m in c)
        (0, n.alwaysValidSchema)(h, c[m]) || (u.if(
          (0, r.propertyInData)(u, d, m, h.opts.ownProperties),
          () => {
            const g = l.subschema({ keyword: f, schemaProp: m }, p);
            l.mergeValidEvaluated(g, p);
          },
          () => u.var(p, !0)
          // TODO var
        ), l.ok(p));
    }
    t.validateSchemaDeps = a, t.default = o;
  }(sD)), sD;
}
var h_ = {}, moe;
function D_t() {
  if (moe) return h_;
  moe = 1, Object.defineProperty(h_, "__esModule", { value: !0 });
  const t = Mt(), e = Jt(), r = {
    keyword: "propertyNames",
    type: "object",
    schemaType: ["object", "boolean"],
    error: {
      message: "property name must be valid",
      params: ({ params: o }) => (0, t._)`{propertyName: ${o.propertyName}}`
    },
    code(o) {
      const { gen: i, schema: s, data: a, it: l } = o;
      if ((0, e.alwaysValidSchema)(l, s))
        return;
      const c = i.name("valid");
      i.forIn("key", a, (u) => {
        o.setParams({ propertyName: u }), o.subschema({
          keyword: "propertyNames",
          data: u,
          dataTypes: ["string"],
          propertyName: u,
          compositeRule: !0
        }, c), i.if((0, t.not)(c), () => {
          o.error(!0), l.allErrors || i.break();
        });
      }), o.ok(c);
    }
  };
  return h_.default = r, h_;
}
var p_ = {}, goe;
function f_e() {
  if (goe) return p_;
  goe = 1, Object.defineProperty(p_, "__esModule", { value: !0 });
  const t = js(), e = Mt(), n = fu(), r = Jt(), i = {
    keyword: "additionalProperties",
    type: ["object"],
    schemaType: ["boolean", "object"],
    allowUndefined: !0,
    trackErrors: !0,
    error: {
      message: "must NOT have additional properties",
      params: ({ params: s }) => (0, e._)`{additionalProperty: ${s.additionalProperty}}`
    },
    code(s) {
      const { gen: a, schema: l, parentSchema: c, data: u, errsCount: d, it: f } = s;
      if (!d)
        throw new Error("ajv implementation error");
      const { allErrors: h, opts: p } = f;
      if (f.props = !0, p.removeAdditional !== "all" && (0, r.alwaysValidSchema)(f, l))
        return;
      const m = (0, t.allSchemaProperties)(c.properties), g = (0, t.allSchemaProperties)(c.patternProperties);
      y(), s.ok((0, e._)`${d} === ${n.default.errors}`);
      function y() {
        a.forIn("key", u, (x) => {
          !m.length && !g.length ? _(x) : a.if(v(x), () => _(x));
        });
      }
      function v(x) {
        let E;
        if (m.length > 8) {
          const S = (0, r.schemaRefOrVal)(f, c.properties, "properties");
          E = (0, t.isOwnProperty)(a, S, x);
        } else m.length ? E = (0, e.or)(...m.map((S) => (0, e._)`${x} === ${S}`)) : E = e.nil;
        return g.length && (E = (0, e.or)(E, ...g.map((S) => (0, e._)`${(0, t.usePattern)(s, S)}.test(${x})`))), (0, e.not)(E);
      }
      function b(x) {
        a.code((0, e._)`delete ${u}[${x}]`);
      }
      function _(x) {
        if (p.removeAdditional === "all" || p.removeAdditional && l === !1) {
          b(x);
          return;
        }
        if (l === !1) {
          s.setParams({ additionalProperty: x }), s.error(), h || a.break();
          return;
        }
        if (typeof l == "object" && !(0, r.alwaysValidSchema)(f, l)) {
          const E = a.name("valid");
          p.removeAdditional === "failing" ? (w(x, E, !1), a.if((0, e.not)(E), () => {
            s.reset(), b(x);
          })) : (w(x, E), h || a.if((0, e.not)(E), () => a.break()));
        }
      }
      function w(x, E, S) {
        const C = {
          keyword: "additionalProperties",
          dataProp: x,
          dataPropType: r.Type.Str
        };
        S === !1 && Object.assign(C, {
          compositeRule: !0,
          createErrors: !1,
          allErrors: !1
        }), s.subschema(C, E);
      }
    }
  };
  return p_.default = i, p_;
}
var m_ = {}, yoe;
function I_t() {
  if (yoe) return m_;
  yoe = 1, Object.defineProperty(m_, "__esModule", { value: !0 });
  const t = qO(), e = js(), n = Jt(), r = f_e(), o = {
    keyword: "properties",
    type: "object",
    schemaType: "object",
    code(i) {
      const { gen: s, schema: a, parentSchema: l, data: c, it: u } = i;
      u.opts.removeAdditional === "all" && l.additionalProperties === void 0 && r.default.code(new t.KeywordCxt(u, r.default, "additionalProperties"));
      const d = (0, e.allSchemaProperties)(a);
      for (const g of d)
        u.definedProperties.add(g);
      u.opts.unevaluated && d.length && u.props !== !0 && (u.props = n.mergeEvaluated.props(s, (0, n.toHash)(d), u.props));
      const f = d.filter((g) => !(0, n.alwaysValidSchema)(u, a[g]));
      if (f.length === 0)
        return;
      const h = s.name("valid");
      for (const g of f)
        p(g) ? m(g) : (s.if((0, e.propertyInData)(s, c, g, u.opts.ownProperties)), m(g), u.allErrors || s.else().var(h, !0), s.endIf()), i.it.definedProperties.add(g), i.ok(h);
      function p(g) {
        return u.opts.useDefaults && !u.compositeRule && a[g].default !== void 0;
      }
      function m(g) {
        i.subschema({
          keyword: "properties",
          schemaProp: g,
          dataProp: g
        }, h);
      }
    }
  };
  return m_.default = o, m_;
}
var g_ = {}, voe;
function N_t() {
  if (voe) return g_;
  voe = 1, Object.defineProperty(g_, "__esModule", { value: !0 });
  const t = js(), e = Mt(), n = Jt(), r = Jt(), o = {
    keyword: "patternProperties",
    type: "object",
    schemaType: "object",
    code(i) {
      const { gen: s, schema: a, data: l, parentSchema: c, it: u } = i, { opts: d } = u, f = (0, t.allSchemaProperties)(a), h = f.filter((_) => (0, n.alwaysValidSchema)(u, a[_]));
      if (f.length === 0 || h.length === f.length && (!u.opts.unevaluated || u.props === !0))
        return;
      const p = d.strictSchema && !d.allowMatchingProperties && c.properties, m = s.name("valid");
      u.props !== !0 && !(u.props instanceof e.Name) && (u.props = (0, r.evaluatedPropsToName)(s, u.props));
      const { props: g } = u;
      y();
      function y() {
        for (const _ of f)
          p && v(_), u.allErrors ? b(_) : (s.var(m, !0), b(_), s.if(m));
      }
      function v(_) {
        for (const w in p)
          new RegExp(_).test(w) && (0, n.checkStrictMode)(u, `property ${w} matches pattern ${_} (use allowMatchingProperties)`);
      }
      function b(_) {
        s.forIn("key", l, (w) => {
          s.if((0, e._)`${(0, t.usePattern)(i, _)}.test(${w})`, () => {
            const x = h.includes(_);
            x || i.subschema({
              keyword: "patternProperties",
              schemaProp: _,
              dataProp: w,
              dataPropType: r.Type.Str
            }, m), u.opts.unevaluated && g !== !0 ? s.assign((0, e._)`${g}[${w}]`, !0) : !x && !u.allErrors && s.if((0, e.not)(m), () => s.break());
          });
        });
      }
    }
  };
  return g_.default = o, g_;
}
var y_ = {}, boe;
function j_t() {
  if (boe) return y_;
  boe = 1, Object.defineProperty(y_, "__esModule", { value: !0 });
  const t = Jt(), e = {
    keyword: "not",
    schemaType: ["object", "boolean"],
    trackErrors: !0,
    code(n) {
      const { gen: r, schema: o, it: i } = n;
      if ((0, t.alwaysValidSchema)(i, o)) {
        n.fail();
        return;
      }
      const s = r.name("valid");
      n.subschema({
        keyword: "not",
        compositeRule: !0,
        createErrors: !1,
        allErrors: !1
      }, s), n.failResult(s, () => n.reset(), () => n.error());
    },
    error: { message: "must NOT be valid" }
  };
  return y_.default = e, y_;
}
var v_ = {}, _oe;
function L_t() {
  if (_oe) return v_;
  _oe = 1, Object.defineProperty(v_, "__esModule", { value: !0 });
  const e = {
    keyword: "anyOf",
    schemaType: "array",
    trackErrors: !0,
    code: js().validateUnion,
    error: { message: "must match a schema in anyOf" }
  };
  return v_.default = e, v_;
}
var b_ = {}, woe;
function F_t() {
  if (woe) return b_;
  woe = 1, Object.defineProperty(b_, "__esModule", { value: !0 });
  const t = Mt(), e = Jt(), r = {
    keyword: "oneOf",
    schemaType: "array",
    trackErrors: !0,
    error: {
      message: "must match exactly one schema in oneOf",
      params: ({ params: o }) => (0, t._)`{passingSchemas: ${o.passing}}`
    },
    code(o) {
      const { gen: i, schema: s, parentSchema: a, it: l } = o;
      if (!Array.isArray(s))
        throw new Error("ajv implementation error");
      if (l.opts.discriminator && a.discriminator)
        return;
      const c = s, u = i.let("valid", !1), d = i.let("passing", null), f = i.name("_valid");
      o.setParams({ passing: d }), i.block(h), o.result(u, () => o.reset(), () => o.error(!0));
      function h() {
        c.forEach((p, m) => {
          let g;
          (0, e.alwaysValidSchema)(l, p) ? i.var(f, !0) : g = o.subschema({
            keyword: "oneOf",
            schemaProp: m,
            compositeRule: !0
          }, f), m > 0 && i.if((0, t._)`${f} && ${u}`).assign(u, !1).assign(d, (0, t._)`[${d}, ${m}]`).else(), i.if(f, () => {
            i.assign(u, !0), i.assign(d, m), g && o.mergeEvaluated(g, t.Name);
          });
        });
      }
    }
  };
  return b_.default = r, b_;
}
var __ = {}, xoe;
function B_t() {
  if (xoe) return __;
  xoe = 1, Object.defineProperty(__, "__esModule", { value: !0 });
  const t = Jt(), e = {
    keyword: "allOf",
    schemaType: "array",
    code(n) {
      const { gen: r, schema: o, it: i } = n;
      if (!Array.isArray(o))
        throw new Error("ajv implementation error");
      const s = r.name("valid");
      o.forEach((a, l) => {
        if ((0, t.alwaysValidSchema)(i, a))
          return;
        const c = n.subschema({ keyword: "allOf", schemaProp: l }, s);
        n.ok(s), n.mergeEvaluated(c);
      });
    }
  };
  return __.default = e, __;
}
var w_ = {}, Eoe;
function z_t() {
  if (Eoe) return w_;
  Eoe = 1, Object.defineProperty(w_, "__esModule", { value: !0 });
  const t = Mt(), e = Jt(), r = {
    keyword: "if",
    schemaType: ["object", "boolean"],
    trackErrors: !0,
    error: {
      message: ({ params: i }) => (0, t.str)`must match "${i.ifClause}" schema`,
      params: ({ params: i }) => (0, t._)`{failingKeyword: ${i.ifClause}}`
    },
    code(i) {
      const { gen: s, parentSchema: a, it: l } = i;
      a.then === void 0 && a.else === void 0 && (0, e.checkStrictMode)(l, '"if" without "then" and "else" is ignored');
      const c = o(l, "then"), u = o(l, "else");
      if (!c && !u)
        return;
      const d = s.let("valid", !0), f = s.name("_valid");
      if (h(), i.reset(), c && u) {
        const m = s.let("ifClause");
        i.setParams({ ifClause: m }), s.if(f, p("then", m), p("else", m));
      } else c ? s.if(f, p("then")) : s.if((0, t.not)(f), p("else"));
      i.pass(d, () => i.error(!0));
      function h() {
        const m = i.subschema({
          keyword: "if",
          compositeRule: !0,
          createErrors: !1,
          allErrors: !1
        }, f);
        i.mergeEvaluated(m);
      }
      function p(m, g) {
        return () => {
          const y = i.subschema({ keyword: m }, f);
          s.assign(d, f), i.mergeValidEvaluated(y, d), g ? s.assign(g, (0, t._)`${m}`) : i.setParams({ ifClause: m });
        };
      }
    }
  };
  function o(i, s) {
    const a = i.schema[s];
    return a !== void 0 && !(0, e.alwaysValidSchema)(i, a);
  }
  return w_.default = r, w_;
}
var x_ = {}, Soe;
function q_t() {
  if (Soe) return x_;
  Soe = 1, Object.defineProperty(x_, "__esModule", { value: !0 });
  const t = Jt(), e = {
    keyword: ["then", "else"],
    schemaType: ["object", "boolean"],
    code({ keyword: n, parentSchema: r, it: o }) {
      r.if === void 0 && (0, t.checkStrictMode)(o, `"${n}" without "if" is ignored`);
    }
  };
  return x_.default = e, x_;
}
var Ooe;
function U_t() {
  if (Ooe) return c_;
  Ooe = 1, Object.defineProperty(c_, "__esModule", { value: !0 });
  const t = u_e(), e = R_t(), n = d_e(), r = P_t(), o = $_t(), i = M_t(), s = D_t(), a = f_e(), l = I_t(), c = N_t(), u = j_t(), d = L_t(), f = F_t(), h = B_t(), p = z_t(), m = q_t();
  function g(y = !1) {
    const v = [
      // any
      u.default,
      d.default,
      f.default,
      h.default,
      p.default,
      m.default,
      // object
      s.default,
      a.default,
      i.default,
      l.default,
      c.default
    ];
    return y ? v.push(e.default, r.default) : v.push(t.default, n.default), v.push(o.default), v;
  }
  return c_.default = g, c_;
}
var E_ = {}, S_ = {}, Coe;
function H_t() {
  if (Coe) return S_;
  Coe = 1, Object.defineProperty(S_, "__esModule", { value: !0 });
  const t = Mt(), n = {
    keyword: "format",
    type: ["number", "string"],
    schemaType: "string",
    $data: !0,
    error: {
      message: ({ schemaCode: r }) => (0, t.str)`must match format "${r}"`,
      params: ({ schemaCode: r }) => (0, t._)`{format: ${r}}`
    },
    code(r, o) {
      const { gen: i, data: s, $data: a, schema: l, schemaCode: c, it: u } = r, { opts: d, errSchemaPath: f, schemaEnv: h, self: p } = u;
      if (!d.validateFormats)
        return;
      a ? m() : g();
      function m() {
        const y = i.scopeValue("formats", {
          ref: p.formats,
          code: d.code.formats
        }), v = i.const("fDef", (0, t._)`${y}[${c}]`), b = i.let("fType"), _ = i.let("format");
        i.if((0, t._)`typeof ${v} == "object" && !(${v} instanceof RegExp)`, () => i.assign(b, (0, t._)`${v}.type || "string"`).assign(_, (0, t._)`${v}.validate`), () => i.assign(b, (0, t._)`"string"`).assign(_, v)), r.fail$data((0, t.or)(w(), x()));
        function w() {
          return d.strictSchema === !1 ? t.nil : (0, t._)`${c} && !${_}`;
        }
        function x() {
          const E = h.$async ? (0, t._)`(${v}.async ? await ${_}(${s}) : ${_}(${s}))` : (0, t._)`${_}(${s})`, S = (0, t._)`(typeof ${_} == "function" ? ${E} : ${_}.test(${s}))`;
          return (0, t._)`${_} && ${_} !== true && ${b} === ${o} && !${S}`;
        }
      }
      function g() {
        const y = p.formats[l];
        if (!y) {
          w();
          return;
        }
        if (y === !0)
          return;
        const [v, b, _] = x(y);
        v === o && r.pass(E());
        function w() {
          if (d.strictSchema === !1) {
            p.logger.warn(S());
            return;
          }
          throw new Error(S());
          function S() {
            return `unknown format "${l}" ignored in schema at path "${f}"`;
          }
        }
        function x(S) {
          const C = S instanceof RegExp ? (0, t.regexpCode)(S) : d.code.formats ? (0, t._)`${d.code.formats}${(0, t.getProperty)(l)}` : void 0, R = i.scopeValue("formats", { key: l, ref: S, code: C });
          return typeof S == "object" && !(S instanceof RegExp) ? [S.type || "string", S.validate, (0, t._)`${R}.validate`] : ["string", S, R];
        }
        function E() {
          if (typeof y == "object" && !(y instanceof RegExp) && y.async) {
            if (!h.$async)
              throw new Error("async format in sync schema");
            return (0, t._)`await ${_}(${s})`;
          }
          return typeof b == "function" ? (0, t._)`${_}(${s})` : (0, t._)`${_}.test(${s})`;
        }
      }
    }
  };
  return S_.default = n, S_;
}
var koe;
function V_t() {
  if (koe) return E_;
  koe = 1, Object.defineProperty(E_, "__esModule", { value: !0 });
  const e = [H_t().default];
  return E_.default = e, E_;
}
var Cu = {}, Aoe;
function W_t() {
  return Aoe || (Aoe = 1, Object.defineProperty(Cu, "__esModule", { value: !0 }), Cu.contentVocabulary = Cu.metadataVocabulary = void 0, Cu.metadataVocabulary = [
    "title",
    "description",
    "default",
    "deprecated",
    "readOnly",
    "writeOnly",
    "examples"
  ], Cu.contentVocabulary = [
    "contentMediaType",
    "contentEncoding",
    "contentSchema"
  ]), Cu;
}
var Toe;
function G_t() {
  if (Toe) return G1;
  Toe = 1, Object.defineProperty(G1, "__esModule", { value: !0 });
  const t = y_t(), e = T_t(), n = U_t(), r = V_t(), o = W_t(), i = [
    t.default,
    e.default,
    (0, n.default)(),
    r.default,
    o.metadataVocabulary,
    o.contentVocabulary
  ];
  return G1.default = i, G1;
}
var O_ = {}, Im = {}, Roe;
function Y_t() {
  if (Roe) return Im;
  Roe = 1, Object.defineProperty(Im, "__esModule", { value: !0 }), Im.DiscrError = void 0;
  var t;
  return function(e) {
    e.Tag = "tag", e.Mapping = "mapping";
  }(t || (Im.DiscrError = t = {})), Im;
}
var Poe;
function K_t() {
  if (Poe) return O_;
  Poe = 1, Object.defineProperty(O_, "__esModule", { value: !0 });
  const t = Mt(), e = Y_t(), n = J6(), r = UO(), o = Jt(), s = {
    keyword: "discriminator",
    type: "object",
    schemaType: "object",
    error: {
      message: ({ params: { discrError: a, tagName: l } }) => a === e.DiscrError.Tag ? `tag "${l}" must be string` : `value of tag "${l}" must be in oneOf`,
      params: ({ params: { discrError: a, tag: l, tagName: c } }) => (0, t._)`{error: ${a}, tag: ${c}, tagValue: ${l}}`
    },
    code(a) {
      const { gen: l, data: c, schema: u, parentSchema: d, it: f } = a, { oneOf: h } = d;
      if (!f.opts.discriminator)
        throw new Error("discriminator: requires discriminator option");
      const p = u.propertyName;
      if (typeof p != "string")
        throw new Error("discriminator: requires propertyName");
      if (u.mapping)
        throw new Error("discriminator: mapping is not supported");
      if (!h)
        throw new Error("discriminator: requires oneOf keyword");
      const m = l.let("valid", !1), g = l.const("tag", (0, t._)`${c}${(0, t.getProperty)(p)}`);
      l.if((0, t._)`typeof ${g} == "string"`, () => y(), () => a.error(!1, { discrError: e.DiscrError.Tag, tag: g, tagName: p })), a.ok(m);
      function y() {
        const _ = b();
        l.if(!1);
        for (const w in _)
          l.elseIf((0, t._)`${g} === ${w}`), l.assign(m, v(_[w]));
        l.else(), a.error(!1, { discrError: e.DiscrError.Mapping, tag: g, tagName: p }), l.endIf();
      }
      function v(_) {
        const w = l.name("valid"), x = a.subschema({ keyword: "oneOf", schemaProp: _ }, w);
        return a.mergeEvaluated(x, t.Name), w;
      }
      function b() {
        var _;
        const w = {}, x = S(d);
        let E = !0;
        for (let P = 0; P < h.length; P++) {
          let N = h[P];
          if (N?.$ref && !(0, o.schemaHasRulesButRef)(N, f.self.RULES)) {
            const O = N.$ref;
            if (N = n.resolveRef.call(f.self, f.schemaEnv.root, f.baseId, O), N instanceof n.SchemaEnv && (N = N.schema), N === void 0)
              throw new r.default(f.opts.uriResolver, f.baseId, O);
          }
          const A = (_ = N?.properties) === null || _ === void 0 ? void 0 : _[p];
          if (typeof A != "object")
            throw new Error(`discriminator: oneOf subschemas (or referenced schemas) must have "properties/${p}"`);
          E = E && (x || S(N)), C(A, P);
        }
        if (!E)
          throw new Error(`discriminator: "${p}" must be required`);
        return w;
        function S({ required: P }) {
          return Array.isArray(P) && P.includes(p);
        }
        function C(P, N) {
          if (P.const)
            R(P.const, N);
          else if (P.enum)
            for (const A of P.enum)
              R(A, N);
          else
            throw new Error(`discriminator: "properties/${p}" must have "const" or "enum"`);
        }
        function R(P, N) {
          if (typeof P != "string" || P in w)
            throw new Error(`discriminator: "${p}" values must be unique strings`);
          w[P] = N;
        }
      }
    }
  };
  return O_.default = s, O_;
}
const X_t = "http://json-schema.org/draft-07/schema#", Q_t = "http://json-schema.org/draft-07/schema#", Z_t = "Core schema meta-schema", J_t = { schemaArray: { type: "array", minItems: 1, items: { $ref: "#" } }, nonNegativeInteger: { type: "integer", minimum: 0 }, nonNegativeIntegerDefault0: { allOf: [{ $ref: "#/definitions/nonNegativeInteger" }, { default: 0 }] }, simpleTypes: { enum: ["array", "boolean", "integer", "null", "number", "object", "string"] }, stringArray: { type: "array", items: { type: "string" }, uniqueItems: !0, default: [] } }, ewt = ["object", "boolean"], twt = { $id: { type: "string", format: "uri-reference" }, $schema: { type: "string", format: "uri" }, $ref: { type: "string", format: "uri-reference" }, $comment: { type: "string" }, title: { type: "string" }, description: { type: "string" }, default: !0, readOnly: { type: "boolean", default: !1 }, examples: { type: "array", items: !0 }, multipleOf: { type: "number", exclusiveMinimum: 0 }, maximum: { type: "number" }, exclusiveMaximum: { type: "number" }, minimum: { type: "number" }, exclusiveMinimum: { type: "number" }, maxLength: { $ref: "#/definitions/nonNegativeInteger" }, minLength: { $ref: "#/definitions/nonNegativeIntegerDefault0" }, pattern: { type: "string", format: "regex" }, additionalItems: { $ref: "#" }, items: { anyOf: [{ $ref: "#" }, { $ref: "#/definitions/schemaArray" }], default: !0 }, maxItems: { $ref: "#/definitions/nonNegativeInteger" }, minItems: { $ref: "#/definitions/nonNegativeIntegerDefault0" }, uniqueItems: { type: "boolean", default: !1 }, contains: { $ref: "#" }, maxProperties: { $ref: "#/definitions/nonNegativeInteger" }, minProperties: { $ref: "#/definitions/nonNegativeIntegerDefault0" }, required: { $ref: "#/definitions/stringArray" }, additionalProperties: { $ref: "#" }, definitions: { type: "object", additionalProperties: { $ref: "#" }, default: {} }, properties: { type: "object", additionalProperties: { $ref: "#" }, default: {} }, patternProperties: { type: "object", additionalProperties: { $ref: "#" }, propertyNames: { format: "regex" }, default: {} }, dependencies: { type: "object", additionalProperties: { anyOf: [{ $ref: "#" }, { $ref: "#/definitions/stringArray" }] } }, propertyNames: { $ref: "#" }, const: !0, enum: { type: "array", items: !0, minItems: 1, uniqueItems: !0 }, type: { anyOf: [{ $ref: "#/definitions/simpleTypes" }, { type: "array", items: { $ref: "#/definitions/simpleTypes" }, minItems: 1, uniqueItems: !0 }] }, format: { type: "string" }, contentMediaType: { type: "string" }, contentEncoding: { type: "string" }, if: { $ref: "#" }, then: { $ref: "#" }, else: { $ref: "#" }, allOf: { $ref: "#/definitions/schemaArray" }, anyOf: { $ref: "#/definitions/schemaArray" }, oneOf: { $ref: "#/definitions/schemaArray" }, not: { $ref: "#" } }, nwt = {
  $schema: X_t,
  $id: Q_t,
  title: Z_t,
  definitions: J_t,
  type: ewt,
  properties: twt,
  default: !0
};
var $oe;
function h_e() {
  return $oe || ($oe = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", { value: !0 }), e.MissingRefError = e.ValidationError = e.CodeGen = e.Name = e.nil = e.stringify = e.str = e._ = e.KeywordCxt = e.Ajv = void 0;
    const n = p_t(), r = G_t(), o = K_t(), i = nwt, s = ["/properties"], a = "http://json-schema.org/draft-07/schema";
    class l extends n.default {
      _addVocabularies() {
        super._addVocabularies(), r.default.forEach((p) => this.addVocabulary(p)), this.opts.discriminator && this.addKeyword(o.default);
      }
      _addDefaultMetaSchema() {
        if (super._addDefaultMetaSchema(), !this.opts.meta)
          return;
        const p = this.opts.$data ? this.$dataMetaSchema(i, s) : i;
        this.addMetaSchema(p, a, !1), this.refs["http://json-schema.org/schema"] = a;
      }
      defaultMeta() {
        return this.opts.defaultMeta = super.defaultMeta() || (this.getSchema(a) ? a : void 0);
      }
    }
    e.Ajv = l, t.exports = e = l, t.exports.Ajv = l, Object.defineProperty(e, "__esModule", { value: !0 }), e.default = l;
    var c = qO();
    Object.defineProperty(e, "KeywordCxt", { enumerable: !0, get: function() {
      return c.KeywordCxt;
    } });
    var u = Mt();
    Object.defineProperty(e, "_", { enumerable: !0, get: function() {
      return u._;
    } }), Object.defineProperty(e, "str", { enumerable: !0, get: function() {
      return u.str;
    } }), Object.defineProperty(e, "stringify", { enumerable: !0, get: function() {
      return u.stringify;
    } }), Object.defineProperty(e, "nil", { enumerable: !0, get: function() {
      return u.nil;
    } }), Object.defineProperty(e, "Name", { enumerable: !0, get: function() {
      return u.Name;
    } }), Object.defineProperty(e, "CodeGen", { enumerable: !0, get: function() {
      return u.CodeGen;
    } });
    var d = Z6();
    Object.defineProperty(e, "ValidationError", { enumerable: !0, get: function() {
      return d.default;
    } });
    var f = UO();
    Object.defineProperty(e, "MissingRefError", { enumerable: !0, get: function() {
      return f.default;
    } });
  }(q1, q1.exports)), q1.exports;
}
var rwt = h_e();
const owt = /* @__PURE__ */ Kt(rwt);
var C_ = { exports: {} }, aD = {}, Moe;
function iwt() {
  return Moe || (Moe = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.formatNames = t.fastFormats = t.fullFormats = void 0;
    function e(C, R) {
      return { validate: C, compare: R };
    }
    t.fullFormats = {
      // date: http://tools.ietf.org/html/rfc3339#section-5.6
      date: e(i, s),
      // date-time: http://tools.ietf.org/html/rfc3339#section-5.6
      time: e(l, c),
      "date-time": e(d, f),
      // duration: https://tools.ietf.org/html/rfc3339#appendix-A
      duration: /^P(?!$)((\d+Y)?(\d+M)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+S)?)?|(\d+W)?)$/,
      uri: m,
      "uri-reference": /^(?:[a-z][a-z0-9+\-.]*:)?(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'"()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?(?:\?(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i,
      // uri-template: https://tools.ietf.org/html/rfc6570
      "uri-template": /^(?:(?:[^\x00-\x20"'<>%\\^`{|}]|%[0-9a-f]{2})|\{[+#./;?&=,!@|]?(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?(?:,(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?)*\})*$/i,
      // For the source: https://gist.github.com/dperini/729294
      // For test cases: https://mathiasbynens.be/demo/url-regex
      url: /^(?:https?|ftp):\/\/(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z0-9\u{00a1}-\u{ffff}]+-)*[a-z0-9\u{00a1}-\u{ffff}]+)(?:\.(?:[a-z0-9\u{00a1}-\u{ffff}]+-)*[a-z0-9\u{00a1}-\u{ffff}]+)*(?:\.(?:[a-z\u{00a1}-\u{ffff}]{2,})))(?::\d{2,5})?(?:\/[^\s]*)?$/iu,
      email: /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i,
      hostname: /^(?=.{1,253}\.?$)[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[-0-9a-z]{0,61}[0-9a-z])?)*\.?$/i,
      // optimized https://www.safaribooksonline.com/library/view/regular-expressions-cookbook/9780596802837/ch07s16.html
      ipv4: /^(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)$/,
      ipv6: /^((([0-9a-f]{1,4}:){7}([0-9a-f]{1,4}|:))|(([0-9a-f]{1,4}:){6}(:[0-9a-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9a-f]{1,4}:){5}(((:[0-9a-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9a-f]{1,4}:){4}(((:[0-9a-f]{1,4}){1,3})|((:[0-9a-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9a-f]{1,4}:){3}(((:[0-9a-f]{1,4}){1,4})|((:[0-9a-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9a-f]{1,4}:){2}(((:[0-9a-f]{1,4}){1,5})|((:[0-9a-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9a-f]{1,4}:){1}(((:[0-9a-f]{1,4}){1,6})|((:[0-9a-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9a-f]{1,4}){1,7})|((:[0-9a-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))$/i,
      regex: S,
      // uuid: http://tools.ietf.org/html/rfc4122
      uuid: /^(?:urn:uuid:)?[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$/i,
      // JSON-pointer: https://tools.ietf.org/html/rfc6901
      // uri fragment: https://tools.ietf.org/html/rfc3986#appendix-A
      "json-pointer": /^(?:\/(?:[^~/]|~0|~1)*)*$/,
      "json-pointer-uri-fragment": /^#(?:\/(?:[a-z0-9_\-.!$&'()*+,;:=@]|%[0-9a-f]{2}|~0|~1)*)*$/i,
      // relative JSON-pointer: http://tools.ietf.org/html/draft-luff-relative-json-pointer-00
      "relative-json-pointer": /^(?:0|[1-9][0-9]*)(?:#|(?:\/(?:[^~/]|~0|~1)*)*)$/,
      // the following formats are used by the openapi specification: https://spec.openapis.org/oas/v3.0.0#data-types
      // byte: https://github.com/miguelmota/is-base64
      byte: y,
      // signed 32 bit integer
      int32: { type: "number", validate: _ },
      // signed 64 bit integer
      int64: { type: "number", validate: w },
      // C-type float
      float: { type: "number", validate: x },
      // C-type double
      double: { type: "number", validate: x },
      // hint to the UI to hide input strings
      password: !0,
      // unchecked string payload
      binary: !0
    }, t.fastFormats = {
      ...t.fullFormats,
      date: e(/^\d\d\d\d-[0-1]\d-[0-3]\d$/, s),
      time: e(/^(?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d(?::?\d\d)?)?$/i, c),
      "date-time": e(/^\d\d\d\d-[0-1]\d-[0-3]\d[t\s](?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d(?::?\d\d)?)$/i, f),
      // uri: https://github.com/mafintosh/is-my-json-valid/blob/master/formats.js
      uri: /^(?:[a-z][a-z0-9+\-.]*:)(?:\/?\/)?[^\s]*$/i,
      "uri-reference": /^(?:(?:[a-z][a-z0-9+\-.]*:)?\/?\/)?(?:[^\\\s#][^\s#]*)?(?:#[^\\\s]*)?$/i,
      // email (sources from jsen validator):
      // http://stackoverflow.com/questions/201323/using-a-regular-expression-to-validate-an-email-address#answer-8829363
      // http://www.w3.org/TR/html5/forms.html#valid-e-mail-address (search for 'wilful violation')
      email: /^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)*$/i
    }, t.formatNames = Object.keys(t.fullFormats);
    function n(C) {
      return C % 4 === 0 && (C % 100 !== 0 || C % 400 === 0);
    }
    const r = /^(\d\d\d\d)-(\d\d)-(\d\d)$/, o = [0, 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    function i(C) {
      const R = r.exec(C);
      if (!R)
        return !1;
      const P = +R[1], N = +R[2], A = +R[3];
      return N >= 1 && N <= 12 && A >= 1 && A <= (N === 2 && n(P) ? 29 : o[N]);
    }
    function s(C, R) {
      if (C && R)
        return C > R ? 1 : C < R ? -1 : 0;
    }
    const a = /^(\d\d):(\d\d):(\d\d)(\.\d+)?(z|[+-]\d\d(?::?\d\d)?)?$/i;
    function l(C, R) {
      const P = a.exec(C);
      if (!P)
        return !1;
      const N = +P[1], A = +P[2], O = +P[3], k = P[5];
      return (N <= 23 && A <= 59 && O <= 59 || N === 23 && A === 59 && O === 60) && (!R || k !== "");
    }
    function c(C, R) {
      if (!(C && R))
        return;
      const P = a.exec(C), N = a.exec(R);
      if (P && N)
        return C = P[1] + P[2] + P[3] + (P[4] || ""), R = N[1] + N[2] + N[3] + (N[4] || ""), C > R ? 1 : C < R ? -1 : 0;
    }
    const u = /t|\s/i;
    function d(C) {
      const R = C.split(u);
      return R.length === 2 && i(R[0]) && l(R[1], !0);
    }
    function f(C, R) {
      if (!(C && R))
        return;
      const [P, N] = C.split(u), [A, O] = R.split(u), k = s(P, A);
      if (k !== void 0)
        return k || c(N, O);
    }
    const h = /\/|:/, p = /^(?:[a-z][a-z0-9+\-.]*:)(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)(?:\?(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i;
    function m(C) {
      return h.test(C) && p.test(C);
    }
    const g = /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/gm;
    function y(C) {
      return g.lastIndex = 0, g.test(C);
    }
    const v = -(2 ** 31), b = 2 ** 31 - 1;
    function _(C) {
      return Number.isInteger(C) && C <= b && C >= v;
    }
    function w(C) {
      return Number.isInteger(C);
    }
    function x() {
      return !0;
    }
    const E = /[^\\]\\Z/;
    function S(C) {
      if (E.test(C))
        return !1;
      try {
        return new RegExp(C), !0;
      } catch {
        return !1;
      }
    }
  }(aD)), aD;
}
var lD = {}, Doe;
function swt() {
  return Doe || (Doe = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.formatLimitDefinition = void 0;
    const e = h_e(), n = Mt(), r = n.operators, o = {
      formatMaximum: { okStr: "<=", ok: r.LTE, fail: r.GT },
      formatMinimum: { okStr: ">=", ok: r.GTE, fail: r.LT },
      formatExclusiveMaximum: { okStr: "<", ok: r.LT, fail: r.GTE },
      formatExclusiveMinimum: { okStr: ">", ok: r.GT, fail: r.LTE }
    }, i = {
      message: ({ keyword: a, schemaCode: l }) => n.str`should be ${o[a].okStr} ${l}`,
      params: ({ keyword: a, schemaCode: l }) => n._`{comparison: ${o[a].okStr}, limit: ${l}}`
    };
    t.formatLimitDefinition = {
      keyword: Object.keys(o),
      type: "string",
      schemaType: "string",
      $data: !0,
      error: i,
      code(a) {
        const { gen: l, data: c, schemaCode: u, keyword: d, it: f } = a, { opts: h, self: p } = f;
        if (!h.validateFormats)
          return;
        const m = new e.KeywordCxt(f, p.RULES.all.format.definition, "format");
        m.$data ? g() : y();
        function g() {
          const b = l.scopeValue("formats", {
            ref: p.formats,
            code: h.code.formats
          }), _ = l.const("fmt", n._`${b}[${m.schemaCode}]`);
          a.fail$data(n.or(n._`typeof ${_} != "object"`, n._`${_} instanceof RegExp`, n._`typeof ${_}.compare != "function"`, v(_)));
        }
        function y() {
          const b = m.schema, _ = p.formats[b];
          if (!_ || _ === !0)
            return;
          if (typeof _ != "object" || _ instanceof RegExp || typeof _.compare != "function")
            throw new Error(`"${d}": format "${b}" does not define "compare" function`);
          const w = l.scopeValue("formats", {
            key: b,
            ref: _,
            code: h.code.formats ? n._`${h.code.formats}${n.getProperty(b)}` : void 0
          });
          a.fail$data(v(w));
        }
        function v(b) {
          return n._`${b}.compare(${c}, ${u}) ${o[d].fail} 0`;
        }
      },
      dependencies: ["format"]
    };
    const s = (a) => (a.addKeyword(t.formatLimitDefinition), a);
    t.default = s;
  }(lD)), lD;
}
var Ioe;
function awt() {
  return Ioe || (Ioe = 1, function(t, e) {
    Object.defineProperty(e, "__esModule", { value: !0 });
    const n = iwt(), r = swt(), o = Mt(), i = new o.Name("fullFormats"), s = new o.Name("fastFormats"), a = (c, u = { keywords: !0 }) => {
      if (Array.isArray(u))
        return l(c, u, n.fullFormats, i), c;
      const [d, f] = u.mode === "fast" ? [n.fastFormats, s] : [n.fullFormats, i], h = u.formats || n.formatNames;
      return l(c, h, d, f), u.keywords && r.default(c), c;
    };
    a.get = (c, u = "full") => {
      const f = (u === "fast" ? n.fastFormats : n.fullFormats)[c];
      if (!f)
        throw new Error(`Unknown format "${c}"`);
      return f;
    };
    function l(c, u, d, f) {
      var h, p;
      (h = (p = c.opts.code).formats) !== null && h !== void 0 || (p.formats = o._`require("ajv-formats/dist/formats").${f}`);
      for (const m of u)
        c.addFormat(m, d[m]);
    }
    t.exports = e = a, Object.defineProperty(e, "__esModule", { value: !0 }), e.default = a;
  }(C_, C_.exports)), C_.exports;
}
var lwt = awt();
const Noe = /* @__PURE__ */ Kt(lwt), cwt = {
  allErrors: !0,
  multipleOfPrecision: 8,
  strict: !1,
  verbose: !0,
  discriminator: !1
  // TODO enable this in V6
}, uwt = /^(#?([0-9A-Fa-f]{3}){1,2}\b|aqua|black|blue|fuchsia|gray|green|lime|maroon|navy|olive|orange|purple|red|silver|teal|white|yellow|(rgb\(\s*\b([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\b\s*,\s*\b([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\b\s*,\s*\b([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\b\s*\))|(rgb\(\s*(\d?\d%|100%)+\s*,\s*(\d?\d%|100%)+\s*,\s*(\d?\d%|100%)+\s*\)))$/, dwt = /^data:([a-z]+\/[a-z0-9-+.]+)?;(?:name=(.*);)?base64,(.*)$/;
function fwt(t, e, n = {}, r, o = owt) {
  const i = new o({ ...cwt, ...n });
  return r ? Noe(i, r) : r !== !1 && Noe(i), i.addFormat("data-url", dwt), i.addFormat("color", uwt), i.addKeyword(Jbe), i.addKeyword(hyt), Array.isArray(t) && i.addMetaSchema(t), I6(e) && Object.keys(e).forEach((s) => {
    i.addFormat(s, e[s]);
  }), i;
}
function hwt(t = [], e) {
  return t.map((n) => {
    const { instancePath: r, keyword: o, params: i, schemaPath: s, parentSchema: a, ...l } = n;
    let { message: c = "" } = l, u = r.replace(/\//g, "."), d = `${u} ${c}`.trim();
    if ("missingProperty" in i) {
      u = u ? `${u}.${i.missingProperty}` : i.missingProperty;
      const f = i.missingProperty, h = IZ(nr(e, `${u.replace(/^\./, "")}`)).title;
      if (h)
        c = c.replace(f, h);
      else {
        const p = nr(a, [ha, f, "title"]);
        p && (c = c.replace(f, p));
      }
      d = c;
    } else {
      const f = IZ(nr(e, `${u.replace(/^\./, "")}`)).title;
      if (f)
        d = `'${f}' ${c}`.trim();
      else {
        const h = a?.title;
        h && (d = `'${h}' ${c}`.trim());
      }
    }
    return {
      name: o,
      property: u,
      message: c,
      params: i,
      stack: d,
      schemaPath: s
    };
  });
}
function pwt(t, e, n, r, o, i, s) {
  const { validationError: a } = e;
  let l = hwt(e.errors, s);
  a && (l = [...l, { stack: a.message }]), typeof i == "function" && (l = i(l, s));
  let c = G1t(l);
  if (a && (c = {
    ...c,
    $schema: {
      __errors: [a.message]
    }
  }), typeof o != "function")
    return { errors: l, errorSchema: c };
  const u = $1t(t, r, n, r, !0), d = o(u, g3(u), s), f = s_e(d);
  return Y1t({ errors: l, errorSchema: c }, f);
}
class mwt {
  /** Constructs an `AJV8Validator` instance using the `options`
   *
   * @param options - The `CustomValidatorOptionsType` options that are used to create the AJV instance
   * @param [localizer] - If provided, is used to localize a list of Ajv `ErrorObject`s
   */
  constructor(e, n) {
    const { additionalMetaSchemas: r, customFormats: o, ajvOptionsOverrides: i, ajvFormatOptions: s, AjvClass: a } = e;
    this.ajv = fwt(r, o, i, s, a), this.localizer = n;
  }
  /** Resets the internal AJV validator to clear schemas from it. Can be helpful for resetting the validator for tests.
   */
  reset() {
    this.ajv.removeSchema();
  }
  /** Converts an `errorSchema` into a list of `RJSFValidationErrors`
   *
   * @param errorSchema - The `ErrorSchema` instance to convert
   * @param [fieldPath=[]] - The current field path, defaults to [] if not specified
   * @deprecated - Use the `toErrorList()` function provided by `@rjsf/utils` instead. This function will be removed in
   *        the next major release.
   */
  toErrorList(e, n = []) {
    return X6(e, n);
  }
  /** Runs the pure validation of the `schema` and `formData` without any of the RJSF functionality. Provided for use
   * by the playground. Returns the `errors` from the validation
   *
   * @param schema - The schema against which to validate the form data   * @param schema
   * @param formData - The form data to validate
   */
  rawValidation(e, n) {
    let r, o;
    e[B1] && (o = this.ajv.getSchema(e[B1]));
    try {
      o === void 0 && (o = this.ajv.compile(e)), o(n);
    } catch (s) {
      r = s;
    }
    let i;
    return o && (typeof this.localizer == "function" && this.localizer(o.errors), i = o.errors || void 0, o.errors = null), {
      errors: i,
      validationError: r
    };
  }
  /** This function processes the `formData` with an optional user contributed `customValidate` function, which receives
   * the form data and a `errorHandler` function that will be used to add custom validation errors for each field. Also
   * supports a `transformErrors` function that will take the raw AJV validation errors, prior to custom validation and
   * transform them in what ever way it chooses.
   *
   * @param formData - The form data to validate
   * @param schema - The schema against which to validate the form data
   * @param [customValidate] - An optional function that is used to perform custom validation
   * @param [transformErrors] - An optional function that is used to transform errors after AJV validation
   * @param [uiSchema] - An optional uiSchema that is passed to `transformErrors` and `customValidate`
   */
  validateFormData(e, n, r, o, i) {
    const s = this.rawValidation(n, e);
    return pwt(this, s, e, n, r, o, i);
  }
  /**
   * This function checks if a schema needs to be added and if the root schemas don't match it removes the old root schema from the ajv instance and adds the new one.
   * @param rootSchema - The root schema used to provide $ref resolutions
   */
  handleSchemaUpdate(e) {
    var n, r;
    const o = (n = e[B1]) !== null && n !== void 0 ? n : t1e;
    this.ajv.getSchema(o) === void 0 ? this.ajv.addSchema(e, o) : p1e(e, (r = this.ajv.getSchema(o)) === null || r === void 0 ? void 0 : r.schema) || (this.ajv.removeSchema(o), this.ajv.addSchema(e, o));
  }
  /** Validates data against a schema, returning true if the data is valid, or
   * false otherwise. If the schema is invalid, then this function will return
   * false.
   *
   * @param schema - The schema against which to validate the form data
   * @param formData - The form data to validate
   * @param rootSchema - The root schema used to provide $ref resolutions
   */
  isValid(e, n, r) {
    var o;
    try {
      this.handleSchemaUpdate(r);
      const i = Q6(e), s = (o = i[B1]) !== null && o !== void 0 ? o : U1t(i);
      let a;
      return a = this.ajv.getSchema(s), a === void 0 && (a = this.ajv.addSchema(i, s).getSchema(s) || this.ajv.compile(i)), a(n);
    } catch (i) {
      return console.warn("Error encountered compiling schema:", i), !1;
    }
  }
}
function t9(t = {}, e) {
  return new mwt(t, e);
}
t9();
var Bw = { exports: {} }, gwt = Bw.exports, joe;
function ywt() {
  return joe || (joe = 1, function(t, e) {
    (function(n, r) {
      t.exports = r(xe);
    })(gwt, function(n) {
      return function() {
        var r = { 378: function(a) {
          a.exports = function l(c, u) {
            if (c === u) return !0;
            if (c && u && typeof c == "object" && typeof u == "object") {
              if (c.constructor !== u.constructor) return !1;
              var d, f, h;
              if (Array.isArray(c)) {
                if ((d = c.length) != u.length) return !1;
                for (f = d; f-- != 0; ) if (!l(c[f], u[f])) return !1;
                return !0;
              }
              if (c.constructor === RegExp) return c.source === u.source && c.flags === u.flags;
              if (c.valueOf !== Object.prototype.valueOf) return c.valueOf() === u.valueOf();
              if (c.toString !== Object.prototype.toString) return c.toString() === u.toString();
              if ((d = (h = Object.keys(c)).length) !== Object.keys(u).length) return !1;
              for (f = d; f-- != 0; ) if (!Object.prototype.hasOwnProperty.call(u, h[f])) return !1;
              for (f = d; f-- != 0; ) {
                var p = h[f];
                if (!l(c[p], u[p])) return !1;
              }
              return !0;
            }
            return c != c && u != u;
          };
        }, 145: function(a, l, c) {
          c.r(l), l.default = '@keyframes spin{to{transform:rotate(360deg)}}.tf-v1-popover{bottom:96px;position:fixed;right:16px;z-index:10001}.tf-v1-popover.open{max-width:100%;min-height:360px;min-width:360px}.tf-v1-popover-wrapper{position:absolute;top:50%;left:50%;transform:translate(-50%, -50%);height:100%;width:100%;opacity:0;transition:opacity .25s ease-in-out;border-radius:4px;box-shadow:rgba(0,0,0,.08) 0 2px 4px,rgba(0,0,0,.06) 0 2px 12px}.tf-v1-popover-wrapper iframe{width:100%;height:100%;border:none;overflow:hidden;border-radius:8px}.tf-v1-popover-close{display:none}.tf-v1-popover-button{width:54px;height:54px;position:fixed;box-shadow:0 2px 12px rgba(0,0,0,.06),0 2px 4px rgba(0,0,0,.08);color:#fff;right:26px;bottom:26px;border-radius:50%;display:flex;align-items:center;justify-content:center;cursor:pointer;background:#3a7685;line-height:0;border:none;padding:0}.tf-v1-popover-button-icon{width:54px;height:54px;font-size:24px;border-radius:50%;overflow:hidden;display:flex;justify-content:center;align-items:center}.tf-v1-popover-button-icon svg.default{margin-top:6px}.tf-v1-popover-button-icon svg,.tf-v1-popover-button-icon img{max-width:54px;max-height:54px}.tf-v1-popover-button-icon img{width:100%;height:100%;object-fit:cover;border-radius:50%}.tf-v1-popover-tooltip{position:fixed;right:94px;bottom:33px;max-width:240px;padding:10px 25px 10px 10px;border-radius:8px;background:#fff;box-shadow:0 2px 4px rgba(0,0,0,.08),0 2px 12px rgba(0,0,0,.06);font-size:14px;font-family:Helvetica,Arial,sans-serif;line-height:22px}.tf-v1-popover-tooltip::before{background-color:#fff;content:"";display:block;width:12px;height:12px;position:absolute;right:-4px;bottom:15px;transform:rotate(45deg);box-shadow:2px -2px 2px 0 rgba(0,0,0,.06)}.tf-v1-popover-tooltip-text{overflow:hidden}.tf-v1-popover-tooltip-close{color:rgba(0,0,0,.2);cursor:pointer;margin-left:4px;display:inline-block;width:20px;height:20px;font-size:18px;text-align:center;position:absolute;top:8px;right:6px}.tf-v1-popover-tooltip-close:hover{color:rgba(0,0,0,.3)}.tf-v1-popover-tooltip.closing{transition:opacity .25s ease-in-out;opacity:0}.tf-v1-popover-unread-dot{width:8px;height:8px;border-radius:50%;background-color:#fa6b05;border:2px solid #fff;position:absolute;top:2px;right:2px}.tf-v1-popover-unread-dot.closing{transition:opacity .25s ease-in-out;opacity:0}.tf-v1-spinner{border:3px solid #aaa;font-size:40px;width:1em;height:1em;border-radius:.5em;box-sizing:border-box;animation:spin 1s linear infinite;border-top-color:#fff;position:absolute;top:50%;left:50%;margin:-20px 0 0 -20px}@media(max-width: 480px){.tf-v1-popover.open{top:0;left:0;bottom:0;right:0;width:100% !important;height:100% !important;width:100vw !important;height:100vh !important;max-height:stretch}.tf-v1-popover.open .tf-v1-popover-close{display:block}.tf-v1-popover-wrapper{border-radius:0;box-shadow:none}.tf-v1-popover-wrapper iframe{border-radius:0}.tf-v1-popover-close{position:absolute;font-size:32px;line-height:24px;width:24px;height:24px;text-align:center;cursor:pointer;opacity:.75;transition:opacity .25s ease-in-out;text-decoration:none;color:#000;top:6px;right:8px;z-index:1;opacity:0}.tf-v1-popover-close:hover{opacity:1}}@media(max-width: 480px)and (min-width: 481px){.tf-v1-popover-close{color:#fff !important}}@media(max-width: 480px){.tf-v1-popover-button{width:44px;height:44px;right:8px;bottom:8px}.tf-v1-popover-button-icon{font-size:20px}.tf-v1-popover-button-icon svg{margin-top:4px;max-height:24px;max-width:24px}.tf-v1-popover-button-icon img{max-width:44px;max-height:44px}}@media(max-width: 480px){.tf-v1-popover-tooltip{position:fixed;right:66px;bottom:8px;left:auto;font-size:12px}.tf-v1-popover-tooltip::before{bottom:14px}}@media(max-width: 480px){.tf-v1-popover-unread-dot{top:0;right:0}}@media(max-width: 480px){.tf-v1-spinner{border:3px solid #aaa;font-size:32px;width:1em;height:1em;border-radius:.5em;box-sizing:border-box;animation:spin 1s linear infinite;border-top-color:#fff;position:absolute;top:50%;left:50%;margin:-16px 0 0 -16px}}';
        }, 792: function(a, l, c) {
          c.r(l), l.default = "@keyframes spin{to{transform:rotate(360deg)}}.tf-v1-popup{position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,.75);transition:opacity .25s ease-in-out;z-index:10001;display:flex;align-items:center;justify-content:center}.tf-v1-popup .tf-v1-iframe-wrapper{position:relative;transition:opacity .25s ease-in-out;min-width:360px;min-height:360px}.tf-v1-popup .tf-v1-iframe-wrapper iframe{width:100%;height:100%;border:none;overflow:hidden;border-radius:8px}.tf-v1-popup .tf-v1-close{position:absolute;font-size:32px;line-height:24px;width:24px;height:24px;text-align:center;cursor:pointer;opacity:.75;transition:opacity .25s ease-in-out;text-decoration:none;color:#000;top:-34px;right:0}.tf-v1-popup .tf-v1-close:hover{opacity:1}@media(min-width: 481px){.tf-v1-popup .tf-v1-close{color:#fff !important}}.tf-v1-popup .tf-v1-spinner{border:3px solid #aaa;font-size:40px;width:1em;height:1em;border-radius:.5em;box-sizing:border-box;animation:spin 1s linear infinite;border-top-color:#fff;position:absolute;top:50%;left:50%;margin:-20px 0 0 -20px}@media(max-width: 480px){.tf-v1-popup{width:100% !important;height:100% !important;width:100vw !important;height:100vh !important;max-height:stretch}.tf-v1-popup .tf-v1-iframe-wrapper{position:relative;transition:opacity .25s ease-in-out;min-width:100%;min-height:100%}.tf-v1-popup .tf-v1-iframe-wrapper iframe{border-radius:0}.tf-v1-popup .tf-v1-close{position:absolute;font-size:32px;line-height:24px;width:24px;height:24px;text-align:center;cursor:pointer;opacity:.75;transition:opacity .25s ease-in-out;text-decoration:none;color:#000;top:6px;right:8px}.tf-v1-popup .tf-v1-close:hover{opacity:1}}@media(max-width: 480px)and (min-width: 481px){.tf-v1-popup .tf-v1-close{color:#fff !important}}";
        }, 838: function(a, l, c) {
          c.r(l), l.default = "@keyframes spin{to{transform:rotate(360deg)}}.tf-v1-sidetab{position:fixed;top:50%;right:0;width:400px;height:580px;transform:translate(100%, -50%);box-shadow:0 2px 4px rgba(0,0,0,.08),0 2px 12px rgba(0,0,0,.06);z-index:10001;will-change:transform}.tf-v1-sidetab.ready{transition:transform 400ms cubic-bezier(0.5, 0, 0.75, 0)}.tf-v1-sidetab iframe{width:100%;height:100%;border:none;overflow:hidden;border-radius:8px 0 0 8px}.tf-v1-sidetab.open{transform:translate(0, -50%)}.tf-v1-sidetab-wrapper{position:relative;height:100%}.tf-v1-sidetab-button{position:absolute;top:50%;left:-48px;transform:rotate(-90deg) translateX(-50%);transform-origin:left top;min-width:100px;max-width:540px;height:48px;display:flex;align-items:center;padding:12px 16px;border-radius:8px 8px 0 0;color:#fff;box-shadow:0 2px 4px rgba(0,0,0,.08),0 2px 12px rgba(0,0,0,.06);background-color:#3a7685;cursor:pointer;border:0;text-decoration:none;outline:none}.tf-v1-sidetab-button-text{flex:1;font-size:18px;font-family:Helvetica,Arial,sans-serif;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.tf-v1-sidetab-button-icon{width:24px;height:24px;font-size:24px;transform:rotate(90deg);margin-right:12px;position:relative;order:-1}.tf-v1-sidetab-button-icon>img{width:100%;height:100%;object-fit:contain}.tf-v1-sidetab-close{display:none}.tf-v1-sidetab .tf-v1-spinner{border:3px solid #aaa;font-size:24px;width:1em;height:1em;border-radius:.5em;box-sizing:border-box;animation:spin 1s linear infinite;border-top-color:#fff;position:absolute;top:50%;left:50%;margin:-12px 0 0 -12px;top:0;left:0;margin:0}@media(max-width: 480px){.tf-v1-sidetab{transition:unset}.tf-v1-sidetab.ready{transition:unset}.tf-v1-sidetab.open{top:0;left:0;right:0;bottom:0;transform:translate(0, 0);width:100% !important;height:100% !important;width:100vw !important;height:100vh !important;max-height:stretch}.tf-v1-sidetab-close{position:absolute;font-size:32px;line-height:24px;width:24px;height:24px;text-align:center;cursor:pointer;opacity:.75;transition:opacity .25s ease-in-out;text-decoration:none;color:#000;top:6px;right:8px;display:block;z-index:1}.tf-v1-sidetab-close:hover{opacity:1}}@media(max-width: 480px)and (min-width: 481px){.tf-v1-sidetab-close{color:#fff !important}}";
        }, 630: function(a, l, c) {
          c.r(l), l.default = "@keyframes spin{to{transform:rotate(360deg)}}.tf-v1-slider{position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,.75);transition:opacity .25s ease-in-out;z-index:10001}.tf-v1-slider .tf-v1-iframe-wrapper{max-width:calc(100vw - 26px);height:100%;position:absolute;top:0;transition:right .5s ease-in-out,left .5s ease-in-out}.tf-v1-slider .tf-v1-iframe-wrapper iframe{width:100%;height:100%;border:none;overflow:hidden;border-radius:0}@media(min-width: 481px){.tf-v1-slider .tf-v1-iframe-wrapper iframe{border-radius:8px 0 0 8px}}.tf-v1-slider .tf-v1-close{position:absolute;font-size:32px;line-height:24px;width:24px;height:24px;text-align:center;cursor:pointer;opacity:.75;transition:opacity .25s ease-in-out;text-decoration:none;color:#000;top:6px;right:8px}.tf-v1-slider .tf-v1-close:hover{opacity:1}@media(min-width: 481px){.tf-v1-slider .tf-v1-close{color:#fff !important}}@media(min-width: 481px){.tf-v1-slider .tf-v1-close{top:4px;left:-26px}}.tf-v1-slider .tf-v1-close:hover{opacity:1}.tf-v1-slider .tf-v1-spinner{border:3px solid #aaa;font-size:40px;width:1em;height:1em;border-radius:.5em;box-sizing:border-box;animation:spin 1s linear infinite;border-top-color:#fff;position:absolute;top:50%;left:50%;margin:-20px 0 0 -20px}@media(min-width: 481px){.tf-v1-slider.left .tf-v1-iframe-wrapper iframe{border-radius:0 8px 8px 0}.tf-v1-slider.left .tf-v1-close{left:auto;right:-24px}}@media(max-width: 480px){.tf-v1-slider{width:100% !important;height:100% !important;width:100vw !important;height:100vh !important;max-height:stretch}.tf-v1-slider .tf-v1-iframe-wrapper{width:100% !important;max-width:100vw;height:100%;transition:unset}.tf-v1-slider .tf-v1-iframe-wrapper iframe{border-radius:none}.tf-v1-slider .tf-v1-close{position:absolute;font-size:32px;line-height:24px;width:24px;height:24px;text-align:center;cursor:pointer;opacity:.75;transition:opacity .25s ease-in-out;text-decoration:none;color:#000;top:6px;right:8px;left:auto}.tf-v1-slider .tf-v1-close:hover{opacity:1}}@media(max-width: 480px)and (min-width: 481px){.tf-v1-slider .tf-v1-close{color:#fff !important}}";
        }, 684: function(a, l, c) {
          c.r(l), l.default = ".tf-v1-widget{width:100%;height:100%;position:relative}.tf-v1-widget iframe{width:100%;height:100%;border:none;overflow:hidden;border-radius:8px}.tf-v1-widget-close{display:none}.tf-v1-widget-iframe-overlay{width:100%;height:100%;border:none;overflow:hidden;border-radius:8px;position:absolute;top:0;left:0}.tf-v1-widget-fullscreen{position:fixed;top:0;left:0;right:0;bottom:0;z-index:10001;width:100% !important;height:100% !important;width:100vw !important;height:100vh !important;max-height:stretch}.tf-v1-widget-fullscreen .tf-v1-widget-close{display:block;position:absolute;font-size:32px;line-height:24px;width:24px;height:24px;text-align:center;cursor:pointer;opacity:.75;transition:opacity .25s ease-in-out;text-decoration:none;color:#000;top:6px;right:8px;z-index:1}.tf-v1-widget-fullscreen .tf-v1-widget-close:hover{opacity:1}@media(min-width: 481px){.tf-v1-widget-fullscreen .tf-v1-widget-close{color:#fff !important}}.tf-v1-widget-fullscreen iframe{border-radius:0}";
        }, 281: function(a, l, c) {
          var u = this && this.__createBinding || (Object.create ? function(f, h, p, m) {
            m === void 0 && (m = p), Object.defineProperty(f, m, { enumerable: !0, get: function() {
              return h[p];
            } });
          } : function(f, h, p, m) {
            m === void 0 && (m = p), f[m] = h[p];
          }), d = this && this.__exportStar || function(f, h) {
            for (var p in f) p === "default" || Object.prototype.hasOwnProperty.call(h, p) || u(h, f, p);
          };
          Object.defineProperty(l, "__esModule", { value: !0 }), d(c(11), l), d(c(739), l), d(c(860), l);
        }, 794: function(a, l, c) {
          var u = this && this.__assign || function() {
            return u = Object.assign || function(p) {
              for (var m, g = 1, y = arguments.length; g < y; g++) for (var v in m = arguments[g]) Object.prototype.hasOwnProperty.call(m, v) && (p[v] = m[v]);
              return p;
            }, u.apply(this, arguments);
          }, d = this && this.__importDefault || function(p) {
            return p && p.__esModule ? p : { default: p };
          };
          Object.defineProperty(l, "__esModule", { value: !0 }), l.InlineStyle = void 0;
          var f = d(c(156)), h = d(c(52));
          l.InlineStyle = function(p) {
            var m = p.filename, g = c(367)("./" + m + ".css"), y = h.default();
            return f.default.createElement("style", u({}, y ? { nonce: y } : {}), g.default);
          };
        }, 11: function(a, l, c) {
          var u = this && this.__assign || function() {
            return u = Object.assign || function(y) {
              for (var v, b = 1, _ = arguments.length; b < _; b++) for (var w in v = arguments[b]) Object.prototype.hasOwnProperty.call(v, w) && (y[w] = v[w]);
              return y;
            }, u.apply(this, arguments);
          }, d = this && this.__createBinding || (Object.create ? function(y, v, b, _) {
            _ === void 0 && (_ = b), Object.defineProperty(y, _, { enumerable: !0, get: function() {
              return v[b];
            } });
          } : function(y, v, b, _) {
            _ === void 0 && (_ = b), y[_] = v[b];
          }), f = this && this.__setModuleDefault || (Object.create ? function(y, v) {
            Object.defineProperty(y, "default", { enumerable: !0, value: v });
          } : function(y, v) {
            y.default = v;
          }), h = this && this.__importStar || function(y) {
            if (y && y.__esModule) return y;
            var v = {};
            if (y != null) for (var b in y) b !== "default" && Object.prototype.hasOwnProperty.call(y, b) && d(v, y, b);
            return f(v, y), v;
          }, p = this && this.__rest || function(y, v) {
            var b = {};
            for (var _ in y) Object.prototype.hasOwnProperty.call(y, _) && v.indexOf(_) < 0 && (b[_] = y[_]);
            if (y != null && typeof Object.getOwnPropertySymbols == "function") {
              var w = 0;
              for (_ = Object.getOwnPropertySymbols(y); w < _.length; w++) v.indexOf(_[w]) < 0 && Object.prototype.propertyIsEnumerable.call(y, _[w]) && (b[_[w]] = y[_[w]]);
            }
            return b;
          };
          Object.defineProperty(l, "__esModule", { value: !0 }), l.makeButtonComponent = l.emptyEmbed = void 0;
          var m = h(c(156)), g = c(794);
          l.emptyEmbed = { unmount: function() {
          }, open: function() {
          } }, l.makeButtonComponent = function(y, v) {
            return m.default.forwardRef(function(b, _) {
              var w = b.id, x = b.children, E = b.as, S = E === void 0 ? "button" : E, C = b.style, R = C === void 0 ? {} : C, P = b.className, N = P === void 0 ? "" : P, A = b.buttonProps, O = p(b, ["id", "children", "as", "style", "className", "buttonProps"]), k = m.useRef(l.emptyEmbed), T = _ || k;
              m.useEffect(function() {
                return T.current = y(w, O), function() {
                  return T.current.unmount();
                };
              }, [w, O, T]);
              var I = m.useMemo(function() {
                return function() {
                  return T.current.open();
                };
              }, [T]), j = m.default.createElement(S, u({ style: R, className: N, onClick: I, "data-testid": "tf-v1-" + v, children: x }, A));
              return m.default.createElement(m.default.Fragment, null, m.default.createElement(g.InlineStyle, { filename: v }), j);
            });
          };
        }, 739: function(a, l, c) {
          var u = this && this.__createBinding || (Object.create ? function(y, v, b, _) {
            _ === void 0 && (_ = b), Object.defineProperty(y, _, { enumerable: !0, get: function() {
              return v[b];
            } });
          } : function(y, v, b, _) {
            _ === void 0 && (_ = b), y[_] = v[b];
          }), d = this && this.__setModuleDefault || (Object.create ? function(y, v) {
            Object.defineProperty(y, "default", { enumerable: !0, value: v });
          } : function(y, v) {
            y.default = v;
          }), f = this && this.__importStar || function(y) {
            if (y && y.__esModule) return y;
            var v = {};
            if (y != null) for (var b in y) b !== "default" && Object.prototype.hasOwnProperty.call(y, b) && u(v, y, b);
            return d(v, y), v;
          }, h = this && this.__rest || function(y, v) {
            var b = {};
            for (var _ in y) Object.prototype.hasOwnProperty.call(y, _) && v.indexOf(_) < 0 && (b[_] = y[_]);
            if (y != null && typeof Object.getOwnPropertySymbols == "function") {
              var w = 0;
              for (_ = Object.getOwnPropertySymbols(y); w < _.length; w++) v.indexOf(_[w]) < 0 && Object.prototype.propertyIsEnumerable.call(y, _[w]) && (b[_[w]] = y[_[w]]);
            }
            return b;
          };
          Object.defineProperty(l, "__esModule", { value: !0 }), l.makeInitializerComponent = void 0;
          var p = f(c(156)), m = c(794), g = { unmount: function() {
          } };
          l.makeInitializerComponent = function(y, v) {
            return p.default.forwardRef(function(b, _) {
              var w = b.id, x = h(b, ["id"]), E = p.useRef(g), S = _ || E;
              return p.useEffect(function() {
                return S.current = y(w, x), function() {
                  S.current.unmount();
                };
              }, [w, x, S]), p.default.createElement(m.InlineStyle, { filename: v });
            });
          };
        }, 860: function(a, l, c) {
          var u = this && this.__assign || function() {
            return u = Object.assign || function(v) {
              for (var b, _ = 1, w = arguments.length; _ < w; _++) for (var x in b = arguments[_]) Object.prototype.hasOwnProperty.call(b, x) && (v[x] = b[x]);
              return v;
            }, u.apply(this, arguments);
          }, d = this && this.__createBinding || (Object.create ? function(v, b, _, w) {
            w === void 0 && (w = _), Object.defineProperty(v, w, { enumerable: !0, get: function() {
              return b[_];
            } });
          } : function(v, b, _, w) {
            w === void 0 && (w = _), v[w] = b[_];
          }), f = this && this.__setModuleDefault || (Object.create ? function(v, b) {
            Object.defineProperty(v, "default", { enumerable: !0, value: b });
          } : function(v, b) {
            v.default = b;
          }), h = this && this.__importStar || function(v) {
            if (v && v.__esModule) return v;
            var b = {};
            if (v != null) for (var _ in v) _ !== "default" && Object.prototype.hasOwnProperty.call(v, _) && d(b, v, _);
            return f(b, v), b;
          }, p = this && this.__rest || function(v, b) {
            var _ = {};
            for (var w in v) Object.prototype.hasOwnProperty.call(v, w) && b.indexOf(w) < 0 && (_[w] = v[w]);
            if (v != null && typeof Object.getOwnPropertySymbols == "function") {
              var x = 0;
              for (w = Object.getOwnPropertySymbols(v); x < w.length; x++) b.indexOf(w[x]) < 0 && Object.prototype.propertyIsEnumerable.call(v, w[x]) && (_[w[x]] = v[w[x]]);
            }
            return _;
          };
          Object.defineProperty(l, "__esModule", { value: !0 }), l.Widget = void 0;
          var m = h(c(156)), g = c(611), y = c(794);
          l.Widget = function(v) {
            var b = v.id, _ = v.style, w = _ === void 0 ? {} : _, x = v.className, E = x === void 0 ? "" : x, S = p(v, ["id", "style", "className"]), C = m.useRef(null);
            return m.useEffect(function() {
              if (C.current) {
                var R = g.createWidget(b, u(u({}, S), { container: C.current }));
                return function() {
                  R.unmount();
                };
              }
            }, [b, S]), m.default.createElement(m.default.Fragment, null, m.default.createElement(y.InlineStyle, { filename: "widget" }), m.default.createElement("div", { style: w, className: E, ref: C }));
          };
        }, 797: function(a, l, c) {
          var u = this && this.__createBinding || (Object.create ? function(f, h, p, m) {
            m === void 0 && (m = p), Object.defineProperty(f, m, { enumerable: !0, get: function() {
              return h[p];
            } });
          } : function(f, h, p, m) {
            m === void 0 && (m = p), f[m] = h[p];
          }), d = this && this.__exportStar || function(f, h) {
            for (var p in f) p === "default" || Object.prototype.hasOwnProperty.call(h, p) || u(h, f, p);
          };
          Object.defineProperty(l, "__esModule", { value: !0 }), d(c(553), l);
        }, 553: function(a, l, c) {
          var u = this && this.__importDefault || function(h) {
            return h && h.__esModule ? h : { default: h };
          };
          Object.defineProperty(l, "__esModule", { value: !0 }), l.memoComponent = l.propsAreEqual = void 0;
          var d = c(156), f = u(c(378));
          l.propsAreEqual = function(h, p) {
            return f.default(h, p);
          }, l.memoComponent = function(h) {
            return d.memo(h, l.propsAreEqual);
          };
        }, 52: function(a, l, c) {
          Object.defineProperty(l, "__esModule", { value: !0 }), l.default = function() {
            return c.g.__webpack_nonce__ !== void 0 ? c.g.__webpack_nonce__ : null;
          };
        }, 367: function(a, l, c) {
          var u = { "./popover.css": 145, "./popup.css": 792, "./sidetab.css": 838, "./slider.css": 630, "./widget.css": 684 };
          function d(h) {
            var p = f(h);
            return c(p);
          }
          function f(h) {
            if (!c.o(u, h)) {
              var p = new Error("Cannot find module '" + h + "'");
              throw p.code = "MODULE_NOT_FOUND", p;
            }
            return u[h];
          }
          d.keys = function() {
            return Object.keys(u);
          }, d.resolve = f, a.exports = d, d.id = 367;
        }, 611: function(a) {
          a.exports = function() {
            var l = { 27: function(u, d) {
              Object.defineProperty(d, "__esModule", { value: !0 }), d.DEFAULT_DOMAIN = d.POPUP_SIZE = d.SLIDER_WIDTH = d.SLIDER_POSITION = d.SIDETAB_ATTRIBUTE = d.WIDGET_ATTRIBUTE = d.SLIDER_ATTRIBUTE = d.POPUP_ATTRIBUTE = d.POPOVER_ATTRIBUTE = void 0, d.POPOVER_ATTRIBUTE = "data-tf-popover", d.POPUP_ATTRIBUTE = "data-tf-popup", d.SLIDER_ATTRIBUTE = "data-tf-slider", d.WIDGET_ATTRIBUTE = "data-tf-widget", d.SIDETAB_ATTRIBUTE = "data-tf-sidetab", d.SLIDER_POSITION = "right", d.SLIDER_WIDTH = 800, d.POPUP_SIZE = 100, d.DEFAULT_DOMAIN = "form.typeform.com";
            }, 528: function(u, d, f) {
              var h = this && this.__assign || function() {
                return h = Object.assign || function(_) {
                  for (var w, x = 1, E = arguments.length; x < E; x++) for (var S in w = arguments[x]) Object.prototype.hasOwnProperty.call(w, S) && (_[S] = w[S]);
                  return _;
                }, h.apply(this, arguments);
              }, p = this && this.__rest || function(_, w) {
                var x = {};
                for (var E in _) Object.prototype.hasOwnProperty.call(_, E) && w.indexOf(E) < 0 && (x[E] = _[E]);
                if (_ != null && typeof Object.getOwnPropertySymbols == "function") {
                  var S = 0;
                  for (E = Object.getOwnPropertySymbols(_); S < E.length; S++) w.indexOf(E[S]) < 0 && Object.prototype.propertyIsEnumerable.call(_, E[S]) && (x[E[S]] = _[E[S]]);
                }
                return x;
              };
              Object.defineProperty(d, "__esModule", { value: !0 }), d.createPopover = void 0;
              var m = f(747), g = f(320), y = function(_, w) {
                var x = _.parentNode;
                x && (x.removeChild(_), x.appendChild(w));
              }, v = function(_, w) {
                _ === void 0 && (_ = "div"), w === void 0 && (w = "tf-v1-popover-button-icon");
                var x = document.createElement(_);
                return x.className = w + " tf-v1-close-icon", x.innerHTML = "&times;", x.dataset.testid = w, x;
              }, b = { buttonColor: "#3a7685" };
              d.createPopover = function(_, w) {
                w === void 0 && (w = {});
                var x, E, S, C = h(h({}, b), w), R = C.domain, P = p(C, ["domain"]), N = m.createIframe("popover", { formId: _, domain: R, options: P }), A = N.iframe, O = N.embedId, k = N.refresh, T = N.focus, I = function(G, ee) {
                  var Y = document.createElement("div");
                  return Y.className = "tf-v1-popover", Y.dataset.testid = "tf-v1-popover", m.setElementSize(Y, { width: G, height: ee });
                }(P.width, P.height), j = function() {
                  var G = document.createElement("div");
                  return G.className = "tf-v1-popover-wrapper", G.dataset.testid = "tf-v1-popover-wrapper", G;
                }(), z = function(G, ee) {
                  var Y = m.getTextColor(ee), L = document.createElement("div");
                  L.className = "tf-v1-popover-button-icon";
                  var V = `<svg class="default" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M21 0H0V9L10.5743 24V16.5H21C22.6567 16.5 24 15.1567 24 13.5V3C24 1.34325 22.6567 0 21 0ZM7.5
    9.75C6.672 9.75 6 9.07875 6 8.25C6 7.42125 6.672 6.75 7.5 6.75C8.328 6.75 9 7.42125 9 8.25C9 9.07875 8.328 9.75
    7.5 9.75ZM12.75 9.75C11.922 9.75 11.25 9.07875 11.25 8.25C11.25 7.42125 11.922 6.75 12.75 6.75C13.578 6.75 14.25
    7.42125 14.25 8.25C14.25 9.07875 13.578 9.75 12.75 9.75ZM18 9.75C17.172 9.75 16.5 9.07875 16.5 8.25C16.5 7.42125
    17.172 6.75 18 6.75C18.828 6.75 19.5 7.42125 19.5 8.25C19.5 9.07875 18.828 9.75 18 9.75Z" fill="` + Y + `"></path>
  </svg>`, K = G?.startsWith("http");
                  return L.innerHTML = K ? "<img alt='popover trigger icon button' src='" + G + "'/>" : G ?? V, L.dataset.testid = "default-icon", L;
                }(P.customIcon, P.buttonColor || b.buttonColor), $ = function() {
                  var G = document.createElement("div");
                  G.className = "tf-v1-spinner";
                  var ee = document.createElement("div");
                  return ee.className = "tf-v1-popover-button-icon", ee.dataset.testid = "spinner-icon", ee.append(G), ee;
                }(), D = v(), U = v("a", "tf-v1-popover-close"), q = function(G) {
                  var ee = m.getTextColor(G), Y = document.createElement("button");
                  return Y.className = "tf-v1-popover-button", Y.dataset.testid = "tf-v1-popover-button", Y.style.backgroundColor = G, Y.style.color = ee, Y;
                }(P.buttonColor || b.buttonColor);
                (P.container || document.body).append(I), j.append(A), I.append(q), I.append(U), q.append(z);
                var F = function() {
                  E && E.parentNode && (E.classList.add("closing"), setTimeout(function() {
                    m.unmountElement(E);
                  }, 250));
                };
                P.tooltip && P.tooltip.length > 0 && (E = function(G, ee) {
                  var Y = document.createElement("span");
                  Y.className = "tf-v1-popover-tooltip-close", Y.dataset.testid = "tf-v1-popover-tooltip-close", Y.innerHTML = "&times;", Y.onclick = ee;
                  var L = document.createElement("div");
                  L.className = "tf-v1-popover-tooltip-text", L.innerHTML = G;
                  var V = document.createElement("div");
                  return V.className = "tf-v1-popover-tooltip", V.dataset.testid = "tf-v1-popover-tooltip", V.appendChild(L), V.appendChild(Y), V;
                }(P.tooltip, F), I.append(E)), P.notificationDays && (P.enableSandbox || g.canBuildNotificationDot(_)) && (S = g.buildNotificationDot(), q.append(S)), A.onload = function() {
                  I.classList.add("open"), j.style.opacity = "1", U.style.opacity = "1", y($, D), m.addCustomKeyboardListener(Z);
                };
                var B = m.makeAutoResize(I), H = function() {
                  m.isOpen(j) || (F(), S && (S.classList.add("closing"), P.notificationDays && !P.enableSandbox && g.saveNotificationDotHideUntilTime(_, P.notificationDays), setTimeout(function() {
                    m.unmountElement(S);
                  }, 250)), B(), window.addEventListener("resize", B), setTimeout(function() {
                    m.isInPage(j) ? (j.style.opacity = "0", U.style.opacity = "0", j.style.display = "flex", setTimeout(function() {
                      I.classList.add("open"), j.style.opacity = "1", U.style.opacity = "1";
                    }), y(z, D)) : (I.append(j), y(z, $), j.style.opacity = "0", U.style.opacity = "0");
                  }));
                }, Z = function() {
                  var G;
                  m.isOpen(I) && ((G = w.onClose) === null || G === void 0 || G.call(w), setTimeout(function() {
                    P.keepSession ? j.style.display = "none" : m.unmountElement(j), I.classList.remove("open"), y(D, z);
                  }, 250));
                };
                m.setAutoClose(O, P.autoClose, Z);
                var W = function() {
                  m.isOpen(j) ? Z() : H();
                };
                return q.onclick = W, U.onclick = Z, P.open && !m.isOpen(j) && (x = m.handleCustomOpen(H, P.open, P.openValue)), { open: H, close: Z, toggle: W, refresh: k, focus: T, unmount: function() {
                  m.unmountElement(I), window.removeEventListener("resize", B), P.open && x?.remove && x.remove();
                } };
              };
            }, 797: function(u, d, f) {
              var h = this && this.__createBinding || (Object.create ? function(m, g, y, v) {
                v === void 0 && (v = y), Object.defineProperty(m, v, { enumerable: !0, get: function() {
                  return g[y];
                } });
              } : function(m, g, y, v) {
                v === void 0 && (v = y), m[v] = g[y];
              }), p = this && this.__exportStar || function(m, g) {
                for (var y in m) y === "default" || Object.prototype.hasOwnProperty.call(g, y) || h(g, m, y);
              };
              Object.defineProperty(d, "__esModule", { value: !0 }), p(f(528), d), p(f(100), d);
            }, 320: function(u, d) {
              var f = this && this.__assign || function() {
                return f = Object.assign || function(g) {
                  for (var y, v = 1, b = arguments.length; v < b; v++) for (var _ in y = arguments[v]) Object.prototype.hasOwnProperty.call(y, _) && (g[_] = y[_]);
                  return g;
                }, f.apply(this, arguments);
              };
              Object.defineProperty(d, "__esModule", { value: !0 }), d.buildNotificationDot = d.canBuildNotificationDot = d.saveNotificationDotHideUntilTime = void 0;
              var h = "tfNotificationData", p = function() {
                var g = localStorage.getItem(h);
                return g ? JSON.parse(g) : {};
              }, m = function(g) {
                g && localStorage.setItem(h, JSON.stringify(g));
              };
              d.saveNotificationDotHideUntilTime = function(g, y) {
                var v, b = /* @__PURE__ */ new Date();
                b.setDate(b.getDate() + y), m(f(f({}, p()), ((v = {})[g] = { hideUntilTime: b.getTime() }, v)));
              }, d.canBuildNotificationDot = function(g) {
                var y = function(v) {
                  var b;
                  return ((b = p()[v]) === null || b === void 0 ? void 0 : b.hideUntilTime) || 0;
                }(g);
                return (/* @__PURE__ */ new Date()).getTime() > y && (y && function(v) {
                  var b = p();
                  delete b[v], m(b);
                }(g), !0);
              }, d.buildNotificationDot = function() {
                var g = document.createElement("span");
                return g.className = "tf-v1-popover-unread-dot", g.dataset.testid = "tf-v1-popover-unread-dot", g;
              };
            }, 100: function(u, d) {
              Object.defineProperty(d, "__esModule", { value: !0 });
            }, 630: function(u, d, f) {
              var h = this && this.__rest || function(y, v) {
                var b = {};
                for (var _ in y) Object.prototype.hasOwnProperty.call(y, _) && v.indexOf(_) < 0 && (b[_] = y[_]);
                if (y != null && typeof Object.getOwnPropertySymbols == "function") {
                  var w = 0;
                  for (_ = Object.getOwnPropertySymbols(y); w < _.length; w++) v.indexOf(_[w]) < 0 && Object.prototype.propertyIsEnumerable.call(y, _[w]) && (b[_[w]] = y[_[w]]);
                }
                return b;
              };
              Object.defineProperty(d, "__esModule", { value: !0 }), d.createPopup = void 0;
              var p = f(747), m = f(27), g = f(747);
              d.createPopup = function(y, v) {
                if (v === void 0 && (v = {}), !p.hasDom()) return { open: function() {
                }, close: function() {
                }, toggle: function() {
                }, refresh: function() {
                }, focus: function() {
                }, unmount: function() {
                } };
                var b, _ = v.width, w = v.height, x = v.size, E = x === void 0 ? m.POPUP_SIZE : x, S = v.onClose, C = v.domain, R = h(v, ["width", "height", "size", "onClose", "domain"]), P = p.createIframe("popup", { formId: y, domain: C, options: R }), N = P.iframe, A = P.embedId, O = P.refresh, k = P.focus, T = document.body.style.overflow, I = function() {
                  var B = document.createElement("div");
                  return B.className = "tf-v1-popup", B.dataset.testid = "tf-v1-popup", B.style.opacity = "0", B;
                }(), j = function() {
                  var B = document.createElement("div");
                  return B.className = "tf-v1-spinner", B;
                }(), z = function(B, H, Z) {
                  var W = document.createElement("div");
                  return W.className = "tf-v1-iframe-wrapper", W.style.opacity = "0", p.isDefined(B) && p.isDefined(H) ? p.setElementSize(W, { width: B, height: H }) : (W.style.width = "calc(" + Z + "% - 80px)", W.style.height = "calc(" + Z + "% - 80px)", W);
                }(_, w, E);
                z.append(N), I.append(j), I.append(z);
                var $ = R.container || document.body;
                N.onload = function() {
                  z.style.opacity = "1", setTimeout(function() {
                    j.style.display = "none";
                  }, 250), p.addCustomKeyboardListener(q);
                };
                var D = g.makeAutoResize(I), U = function() {
                  g.isOpen(I) || (g.isInPage(I) ? I.style.display = "flex" : (j.style.display = "block", $.append(I)), document.body.style.overflow = "hidden", D(), window.addEventListener("resize", D), setTimeout(function() {
                    I.style.opacity = "1";
                  }));
                }, q = function() {
                  g.isOpen(I) && (S?.(), I.style.opacity = "0", document.body.style.overflow = T, setTimeout(function() {
                    R.keepSession ? I.style.display = "none" : F();
                  }, 250));
                };
                z.append(function(B) {
                  var H = document.createElement("a");
                  return H.className = "tf-v1-close tf-v1-close-icon", H.innerHTML = "&times;", H.onclick = B, H;
                }(q)), p.setAutoClose(A, R.autoClose, q), R.open && !g.isOpen(I) && (b = p.handleCustomOpen(U, R.open, R.openValue));
                var F = function() {
                  p.unmountElement(I), window.removeEventListener("resize", D), R.open && b?.remove && b.remove();
                };
                return { open: U, close: q, toggle: function() {
                  g.isOpen(I) ? q() : U();
                }, refresh: O, focus: k, unmount: F };
              };
            }, 970: function(u, d, f) {
              var h = this && this.__createBinding || (Object.create ? function(m, g, y, v) {
                v === void 0 && (v = y), Object.defineProperty(m, v, { enumerable: !0, get: function() {
                  return g[y];
                } });
              } : function(m, g, y, v) {
                v === void 0 && (v = y), m[v] = g[y];
              }), p = this && this.__exportStar || function(m, g) {
                for (var y in m) y === "default" || Object.prototype.hasOwnProperty.call(g, y) || h(g, m, y);
              };
              Object.defineProperty(d, "__esModule", { value: !0 }), p(f(630), d), p(f(394), d);
            }, 394: function(u, d) {
              Object.defineProperty(d, "__esModule", { value: !0 });
            }, 382: function(u, d, f) {
              var h = this && this.__assign || function() {
                return h = Object.assign || function(b) {
                  for (var _, w = 1, x = arguments.length; w < x; w++) for (var E in _ = arguments[w]) Object.prototype.hasOwnProperty.call(_, E) && (b[E] = _[E]);
                  return b;
                }, h.apply(this, arguments);
              }, p = this && this.__rest || function(b, _) {
                var w = {};
                for (var x in b) Object.prototype.hasOwnProperty.call(b, x) && _.indexOf(x) < 0 && (w[x] = b[x]);
                if (b != null && typeof Object.getOwnPropertySymbols == "function") {
                  var E = 0;
                  for (x = Object.getOwnPropertySymbols(b); E < x.length; E++) _.indexOf(x[E]) < 0 && Object.prototype.propertyIsEnumerable.call(b, x[E]) && (w[x[E]] = b[x[E]]);
                }
                return w;
              };
              Object.defineProperty(d, "__esModule", { value: !0 }), d.createSidetab = void 0;
              var m = f(747), g = { buttonColor: "#3a7685", buttonText: "Launch me" }, y = function(b, _) {
                b === void 0 && (b = "div"), _ === void 0 && (_ = "tf-v1-sidetab-button-icon");
                var w = document.createElement(b);
                return w.className = _ + " tf-v1-close-icon", w.innerHTML = "&times;", w.dataset.testid = _, w;
              }, v = function(b, _) {
                var w = b.parentNode;
                w && (w.removeChild(b), w.appendChild(_));
              };
              d.createSidetab = function(b, _) {
                _ === void 0 && (_ = {});
                var w, x = h(h({}, g), _), E = x.domain, S = p(x, ["domain"]), C = m.createIframe("side-tab", { formId: b, domain: E, options: S }), R = C.iframe, P = C.embedId, N = C.refresh, A = C.focus, O = function(H, Z) {
                  var W = document.createElement("div");
                  return W.className = "tf-v1-sidetab", W.dataset.testid = "tf-v1-sidetab", m.setElementSize(W, { width: H, height: Z });
                }(S.width, S.height), k = function() {
                  var H = document.createElement("div");
                  return H.className = "tf-v1-sidetab-wrapper", H.dataset.testid = "tf-v1-sidetab-wrapper", H;
                }(), T = function() {
                  var H = document.createElement("div");
                  H.className = "tf-v1-spinner";
                  var Z = document.createElement("div");
                  return Z.className = "tf-v1-sidetab-button-icon", Z.dataset.testid = "spinner-icon", Z.append(H), Z;
                }(), I = function(H) {
                  var Z = m.getTextColor(H), W = document.createElement("button");
                  return W.className = "tf-v1-sidetab-button", W.style.backgroundColor = H, W.style.color = Z, W;
                }(S.buttonColor || g.buttonColor), j = function(H) {
                  var Z = document.createElement("span");
                  return Z.className = "tf-v1-sidetab-button-text", Z.innerHTML = H, Z;
                }(S.buttonText || g.buttonText), z = function(H, Z) {
                  var W = m.getTextColor(Z), G = document.createElement("div");
                  G.className = "tf-v1-sidetab-button-icon";
                  var ee = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M21 0H0V9L10.5743 24V16.5H21C22.6567 16.5 24 15.1567 24 13.5V3C24 1.34325 22.6567 0 21 0ZM7.5 9.75C6.672 9.75 6 9.07875 6 8.25C6 7.42125 6.672 6.75 7.5 6.75C8.328 6.75 9 7.42125 9 8.25C9 9.07875 8.328 9.75 7.5 9.75ZM12.75 9.75C11.922 9.75 11.25 9.07875 11.25 8.25C11.25 7.42125 11.922 6.75 12.75 6.75C13.578 6.75 14.25 7.42125 14.25 8.25C14.25 9.07875 13.578 9.75 12.75 9.75ZM18 9.75C17.172 9.75 16.5 9.07875 16.5 8.25C16.5 7.42125 17.172 6.75 18 6.75C18.828 6.75 19.5 7.42125 19.5 8.25C19.5 9.07875 18.828 9.75 18 9.75Z" fill="` + W + `"></path>
  </svg>`, Y = H?.startsWith("http");
                  return G.innerHTML = Y ? "<img alt='popover trigger icon button' src='" + H + "'/>" : H ?? ee, G.dataset.testid = "default-icon", G;
                }(S.customIcon, S.buttonColor || g.buttonColor), $ = y(), D = y("a", "tf-v1-sidetab-close");
                (S.container || document.body).append(O), k.append(R), O.append(I), O.append(D), I.append(z), I.append(j), setTimeout(function() {
                  O.classList.add("ready");
                }, 250), R.onload = function() {
                  O.classList.add("open"), v(T, $), m.addCustomKeyboardListener(F);
                };
                var U = m.makeAutoResize(O), q = function() {
                  m.isOpen(k) || (U(), window.addEventListener("resize", U), m.isInPage(k) ? (k.style.display = "flex", O.classList.add("open"), v(z, $)) : (O.append(k), v(z, T)));
                }, F = function() {
                  var H;
                  m.isOpen(k) && ((H = S.onClose) === null || H === void 0 || H.call(S), O.classList.remove("open"), setTimeout(function() {
                    S.keepSession ? k.style.display = "none" : m.unmountElement(k), v($, z);
                  }, 250));
                };
                m.setAutoClose(P, S.autoClose, F);
                var B = function() {
                  m.isOpen(k) ? F() : q();
                };
                return I.onclick = B, D.onclick = F, S.open && !m.isOpen(k) && (w = m.handleCustomOpen(q, S.open, S.openValue)), { open: q, close: F, toggle: B, refresh: N, focus: A, unmount: function() {
                  m.unmountElement(O), window.removeEventListener("resize", U), S.open && w?.remove && w.remove();
                } };
              };
            }, 434: function(u, d, f) {
              var h = this && this.__createBinding || (Object.create ? function(m, g, y, v) {
                v === void 0 && (v = y), Object.defineProperty(m, v, { enumerable: !0, get: function() {
                  return g[y];
                } });
              } : function(m, g, y, v) {
                v === void 0 && (v = y), m[v] = g[y];
              }), p = this && this.__exportStar || function(m, g) {
                for (var y in m) y === "default" || Object.prototype.hasOwnProperty.call(g, y) || h(g, m, y);
              };
              Object.defineProperty(d, "__esModule", { value: !0 }), p(f(382), d), p(f(668), d);
            }, 668: function(u, d) {
              Object.defineProperty(d, "__esModule", { value: !0 });
            }, 603: function(u, d, f) {
              var h = this && this.__rest || function(g, y) {
                var v = {};
                for (var b in g) Object.prototype.hasOwnProperty.call(g, b) && y.indexOf(b) < 0 && (v[b] = g[b]);
                if (g != null && typeof Object.getOwnPropertySymbols == "function") {
                  var _ = 0;
                  for (b = Object.getOwnPropertySymbols(g); _ < b.length; _++) y.indexOf(b[_]) < 0 && Object.prototype.propertyIsEnumerable.call(g, b[_]) && (v[b[_]] = g[b[_]]);
                }
                return v;
              };
              Object.defineProperty(d, "__esModule", { value: !0 }), d.createSlider = void 0;
              var p = f(747), m = f(27);
              d.createSlider = function(g, y) {
                if (y === void 0 && (y = {}), !p.hasDom()) return { open: function() {
                }, close: function() {
                }, toggle: function() {
                }, refresh: function() {
                }, focus: function() {
                }, unmount: function() {
                } };
                var v, b = y.position, _ = b === void 0 ? m.SLIDER_POSITION : b, w = y.width, x = w === void 0 ? m.SLIDER_WIDTH : w, E = y.onClose, S = y.domain, C = h(y, ["position", "width", "onClose", "domain"]), R = p.createIframe("slider", { formId: g, domain: S, options: C }), P = R.iframe, N = R.embedId, A = R.refresh, O = R.focus, k = document.body.style.overflow, T = function(F) {
                  var B = document.createElement("div");
                  return B.className = "tf-v1-slider " + F, B.dataset.testid = "tf-v1-slider", B.style.opacity = "0", B;
                }(_), I = function() {
                  var F = document.createElement("div");
                  return F.className = "tf-v1-spinner", F;
                }(), j = function(F, B) {
                  var H = document.createElement("div");
                  return H.className = "tf-v1-iframe-wrapper", H.style[F] = "-100%", p.setElementSize(H, { width: B });
                }(_, x);
                j.append(P), T.append(I), T.append(j);
                var z = C.container || document.body;
                P.onload = function() {
                  j.style[_] = "0", setTimeout(function() {
                    I.style.display = "none";
                  }, 500), p.addCustomKeyboardListener(U);
                };
                var $ = p.makeAutoResize(T), D = function() {
                  p.isOpen(T) || ($(), window.addEventListener("resize", $), p.isInPage(T) ? (T.style.display = "flex", setTimeout(function() {
                    j.style[_] = "0";
                  })) : (z.append(T), I.style.display = "block"), document.body.style.overflow = "hidden", setTimeout(function() {
                    T.style.opacity = "1";
                  }));
                }, U = function() {
                  p.isOpen(T) && (E?.(), T.style.opacity = "0", j.style[_] = "-100%", document.body.style.overflow = k, setTimeout(function() {
                    C.keepSession ? T.style.display = "none" : q();
                  }, 500));
                };
                p.setAutoClose(N, C.autoClose, U), j.append(function(F) {
                  var B = document.createElement("a");
                  return B.className = "tf-v1-close tf-v1-close-icon", B.innerHTML = "&times;", B.onclick = F, B;
                }(U)), C.open && !p.isOpen(T) && (v = p.handleCustomOpen(D, C.open, C.openValue));
                var q = function() {
                  p.unmountElement(T), window.removeEventListener("resize", $), C.open && v?.remove && v.remove();
                };
                return { open: D, close: U, toggle: function() {
                  p.isOpen(T) ? U() : D();
                }, refresh: A, focus: O, unmount: q };
              };
            }, 331: function(u, d, f) {
              var h = this && this.__createBinding || (Object.create ? function(m, g, y, v) {
                v === void 0 && (v = y), Object.defineProperty(m, v, { enumerable: !0, get: function() {
                  return g[y];
                } });
              } : function(m, g, y, v) {
                v === void 0 && (v = y), m[v] = g[y];
              }), p = this && this.__exportStar || function(m, g) {
                for (var y in m) y === "default" || Object.prototype.hasOwnProperty.call(g, y) || h(g, m, y);
              };
              Object.defineProperty(d, "__esModule", { value: !0 }), p(f(603), d), p(f(162), d);
            }, 162: function(u, d) {
              Object.defineProperty(d, "__esModule", { value: !0 });
            }, 718: function(u, d, f) {
              var h = this && this.__rest || function(b, _) {
                var w = {};
                for (var x in b) Object.prototype.hasOwnProperty.call(b, x) && _.indexOf(x) < 0 && (w[x] = b[x]);
                if (b != null && typeof Object.getOwnPropertySymbols == "function") {
                  var E = 0;
                  for (x = Object.getOwnPropertySymbols(b); E < x.length; E++) _.indexOf(x[E]) < 0 && Object.prototype.propertyIsEnumerable.call(b, x[E]) && (w[x[E]] = b[x[E]]);
                }
                return w;
              }, p = this && this.__read || function(b, _) {
                var w = typeof Symbol == "function" && b[Symbol.iterator];
                if (!w) return b;
                var x, E, S = w.call(b), C = [];
                try {
                  for (; (_ === void 0 || _-- > 0) && !(x = S.next()).done; ) C.push(x.value);
                } catch (R) {
                  E = { error: R };
                } finally {
                  try {
                    x && !x.done && (w = S.return) && w.call(S);
                  } finally {
                    if (E) throw E.error;
                  }
                }
                return C;
              };
              Object.defineProperty(d, "__esModule", { value: !0 }), d.createWidget = void 0;
              var m = f(747), g = f(554), y = f(313), v = f(126);
              d.createWidget = function(b, _) {
                if (!m.hasDom()) return { refresh: function() {
                }, focus: function() {
                }, unmount: function() {
                } };
                var w = _.domain, x = h(_, ["domain"]);
                x.inlineOnMobile = _.inlineOnMobile || _.fullScreen, x.inlineOnMobile || !x.forceTouch && !m.isFullscreen() || (x.displayAsFullScreenModal = !0, x.forceTouch = !0);
                var E, S = m.createIframe("widget", { formId: b, domain: w, options: x }), C = S.embedId, R = S.iframe, P = S.refresh, N = S.focus, A = y.buildWidget(R, x.width, x.height);
                if (x.fullScreen && (v.overrideFullScreenStyles(_.container, R), E = m.makeAutoResize(_.container, !0), window.addEventListener("resize", E), E()), x.autoResize) {
                  var O = p(typeof x.autoResize == "string" ? x.autoResize.split(",").map(function(q) {
                    return parseInt(q);
                  }) : [], 2), k = O[0], T = O[1];
                  window.addEventListener("message", g.getFormHeightChangedHandler(C, function(q) {
                    var F = Math.max(q.height, k || 0);
                    T && (F = Math.min(F, T)), _.container.style.height = F + "px";
                  }));
                }
                x.autoFocus && window.addEventListener("message", g.getFormReadyHandler(C, function() {
                  setTimeout(function() {
                    N();
                  }, 1e3);
                }));
                var I, j = function() {
                  return _.container.append(A);
                };
                if (_.container.innerHTML = "", _.lazy ? m.lazyInitialize(_.container, j) : j(), x.displayAsFullScreenModal) {
                  var z = "", $ = _.container;
                  E = m.makeAutoResize($);
                  var D = $.style.height;
                  window.addEventListener("message", g.getWelcomeScreenHiddenHandler(C, function() {
                    $.classList.add("tf-v1-widget-fullscreen"), _.opacity !== void 0 && ($.style.backgroundColor = z), E(), window.addEventListener("resize", E);
                  })), window.addEventListener("message", g.getFormThemeHandler(C, function(q) {
                    var F;
                    z = m.changeColorOpacity((F = q?.theme) === null || F === void 0 ? void 0 : F.backgroundColor);
                  }));
                  var U = ((I = document.createElement("a")).className = "tf-v1-widget-close tf-v1-close-icon", I.innerHTML = "&times;", I);
                  U.onclick = function() {
                    var q;
                    if (window.removeEventListener("resize", E), $.style.height = D, (q = _.onClose) === null || q === void 0 || q.call(_), $.classList.remove("tf-v1-widget-fullscreen"), $.style.backgroundColor = "", _.keepSession) {
                      var F = document.createElement("div");
                      F.className = "tf-v1-widget-iframe-overlay", F.onclick = function() {
                        $.classList.add("tf-v1-widget-fullscreen"), m.unmountElement(F);
                      }, A.append(F);
                    } else _.container.innerHTML = "", j(), $.append(U);
                  }, $.append(U);
                }
                return { refresh: P, focus: N, unmount: function() {
                  E && window.removeEventListener("resize", E), m.unmountElement(A);
                } };
              };
            }, 419: function(u, d, f) {
              Object.defineProperty(d, "__esModule", { value: !0 }), d.buildWidget = void 0;
              var h = f(747);
              d.buildWidget = function(p, m, g) {
                var y = document.createElement("div");
                return y.className = "tf-v1-widget", y.dataset.testid = "tf-v1-widget", y.append(p), h.setElementSize(y, { width: m, height: g });
              };
            }, 313: function(u, d, f) {
              var h = this && this.__createBinding || (Object.create ? function(m, g, y, v) {
                v === void 0 && (v = y), Object.defineProperty(m, v, { enumerable: !0, get: function() {
                  return g[y];
                } });
              } : function(m, g, y, v) {
                v === void 0 && (v = y), m[v] = g[y];
              }), p = this && this.__exportStar || function(m, g) {
                for (var y in m) y === "default" || Object.prototype.hasOwnProperty.call(g, y) || h(g, m, y);
              };
              Object.defineProperty(d, "__esModule", { value: !0 }), p(f(419), d);
            }, 126: function(u, d) {
              Object.defineProperty(d, "__esModule", { value: !0 }), d.overrideFullScreenStyles = void 0, d.overrideFullScreenStyles = function(f, h) {
                Object.assign(f.style, { zIndex: "10001", position: "absolute", top: "0", left: "0", width: "100%", height: "100%" }), h.style.borderRadius = "0", Object.assign(document.body.style, { overflow: "hidden" });
              };
            }, 321: function(u, d, f) {
              var h = this && this.__createBinding || (Object.create ? function(m, g, y, v) {
                v === void 0 && (v = y), Object.defineProperty(m, v, { enumerable: !0, get: function() {
                  return g[y];
                } });
              } : function(m, g, y, v) {
                v === void 0 && (v = y), m[v] = g[y];
              }), p = this && this.__exportStar || function(m, g) {
                for (var y in m) y === "default" || Object.prototype.hasOwnProperty.call(g, y) || h(g, m, y);
              };
              Object.defineProperty(d, "__esModule", { value: !0 }), p(f(718), d), p(f(58), d);
            }, 58: function(u, d) {
              Object.defineProperty(d, "__esModule", { value: !0 });
            }, 920: function(u, d, f) {
              var h = this && this.__createBinding || (Object.create ? function(m, g, y, v) {
                v === void 0 && (v = y), Object.defineProperty(m, v, { enumerable: !0, get: function() {
                  return g[y];
                } });
              } : function(m, g, y, v) {
                v === void 0 && (v = y), m[v] = g[y];
              }), p = this && this.__exportStar || function(m, g) {
                for (var y in m) y === "default" || Object.prototype.hasOwnProperty.call(g, y) || h(g, m, y);
              };
              Object.defineProperty(d, "__esModule", { value: !0 }), p(f(797), d), p(f(970), d), p(f(331), d), p(f(321), d), p(f(434), d);
            }, 626: function(u, d, f) {
              var h = this && this.__assign || function() {
                return h = Object.assign || function(w) {
                  for (var x, E = 1, S = arguments.length; E < S; E++) for (var C in x = arguments[E]) Object.prototype.hasOwnProperty.call(x, C) && (w[C] = x[C]);
                  return w;
                }, h.apply(this, arguments);
              }, p = this && this.__read || function(w, x) {
                var E = typeof Symbol == "function" && w[Symbol.iterator];
                if (!E) return w;
                var S, C, R = E.call(w), P = [];
                try {
                  for (; (x === void 0 || x-- > 0) && !(S = R.next()).done; ) P.push(S.value);
                } catch (N) {
                  C = { error: N };
                } finally {
                  try {
                    S && !S.done && (E = R.return) && E.call(R);
                  } finally {
                    if (C) throw C.error;
                  }
                }
                return P;
              };
              Object.defineProperty(d, "__esModule", { value: !0 }), d.buildIframeSrc = void 0;
              var m = f(27), g = f(527), y = f(346), v = f(698), b = f(863), _ = { widget: "embed-widget", popup: "popup-blank", slider: "popup-drawer", popover: "popup-popover", "side-tab": "popup-side-panel" };
              d.buildIframeSrc = function(w) {
                var x = w.domain, E = w.formId, S = w.type, C = w.embedId, R = w.options, P = function(T, I, j) {
                  var z = j.transitiveSearchParams, $ = j.source, D = j.medium, U = j.mediumVersion, q = j.hideFooter, F = j.hideHeaders, B = j.opacity, H = j.disableTracking, Z = j.enableSandbox, W = j.shareGaInstance, G = j.forceTouch, ee = j.displayAsFullScreenModal, Y = j.tracking, L = j.redirectTarget, V = j.autoResize, K = j.disableScroll, ne = j.onEndingButtonClick, ce = j.noHeading, fe = v.getTransitiveSearchParams(z);
                  return h(h(h({}, { "typeform-embed-id": I, "typeform-embed": _[T], "typeform-source": $, "typeform-medium": D, "typeform-medium-version": U, "embed-hide-footer": q ? "true" : void 0, "embed-hide-headers": F ? "true" : void 0, "embed-opacity": B, "disable-tracking": H || Z ? "true" : void 0, "__dangerous-disable-submissions": Z ? "true" : void 0, "share-ga-instance": W ? "true" : void 0, "force-touch": G ? "true" : void 0, "add-placeholder-ws": T === "widget" && ee ? "true" : void 0, "typeform-embed-redirect-target": L, "typeform-embed-auto-resize": V ? "true" : void 0, "typeform-embed-disable-scroll": K ? "true" : void 0, "typeform-embed-handle-ending-button-click": ne ? "true" : void 0, "typeform-embed-no-heading": ce ? "true" : void 0 }), fe), Y);
                }(S, C, function(T) {
                  return T.noHeading || (T.noHeading = document.querySelectorAll("h1").length > 0), h(h({}, { source: (I = window?.location) === null || I === void 0 ? void 0 : I.hostname.replace(/^www\./, ""), medium: "embed-sdk", mediumVersion: "next" }), g.removeUndefinedKeys(T));
                  var I;
                }(R)), N = function(T, I, j) {
                  return I === void 0 && (I = m.DEFAULT_DOMAIN), j === void 0 && (j = !1), T.startsWith("http://") || T.startsWith("https://") ? new URL(T) : new URL("https://" + I + "/" + (j ? "c" : "to") + "/" + T);
                }(E, x, R.chat);
                if (Object.entries(P).filter(function(T) {
                  var I = p(T, 2)[1];
                  return y.isDefined(I);
                }).forEach(function(T) {
                  var I = p(T, 2), j = I[0], z = I[1];
                  N.searchParams.set(j, z);
                }), R.hubspot) {
                  var A = b.getHubspotHiddenFields();
                  R.hidden = h(h({}, R.hidden), A);
                }
                if (R.hidden) {
                  var O = new URLSearchParams();
                  Object.entries(R.hidden).filter(function(T) {
                    var I = p(T, 2)[1];
                    return y.isDefined(I) && I !== "";
                  }).forEach(function(T) {
                    var I = p(T, 2), j = I[0], z = I[1];
                    typeof R.transitiveSearchParams == "boolean" && N.searchParams.delete(j), O.set(j, z);
                  });
                  var k = O.toString();
                  k && (N.hash = k);
                }
                return N.href;
              };
            }, 391: function(u, d) {
              Object.defineProperty(d, "__esModule", { value: !0 }), d.changeColorOpacity = void 0, d.changeColorOpacity = function(f, h) {
                return f === void 0 && (f = ""), h === void 0 && (h = 255), f.startsWith("rgba(") ? f?.replace(/, [\d.]+\)$/, ", " + h + ")") : f;
              };
            }, 972: function(u, d) {
              Object.defineProperty(d, "__esModule", { value: !0 }), d.handleCustomOpen = void 0;
              var f = { remove: function() {
              } };
              d.handleCustomOpen = function(h, p, m) {
                switch (p) {
                  case "load":
                    return h(), f;
                  case "exit":
                    return m ? function(g, y) {
                      var v = 0, b = function(_) {
                        _.clientY < g && _.clientY < v ? (document.removeEventListener("mousemove", b, !0), y()) : v = _.clientY;
                      };
                      return document.addEventListener("mousemove", b, !0), { remove: function() {
                        return document.removeEventListener("mousemove", b, !0);
                      } };
                    }(m, h) : f;
                  case "time":
                    return setTimeout(function() {
                      h();
                    }, m), f;
                  case "scroll":
                    return m ? function(g, y) {
                      function v() {
                        var b = window.pageYOffset || document.documentElement.scrollTop, _ = document.documentElement.clientTop || 0, w = document.documentElement.scrollHeight, x = b - _, E = x / w * 100, S = x + window.innerHeight >= w;
                        (E >= g || S) && (y(), document.removeEventListener("scroll", v));
                      }
                      return document.addEventListener("scroll", v), { remove: function() {
                        return document.removeEventListener("scroll", v);
                      } };
                    }(m, h) : f;
                  default:
                    return f;
                }
              };
            }, 553: function(u, d, f) {
              Object.defineProperty(d, "__esModule", { value: !0 }), d.createIframe = void 0;
              var h = f(626), p = f(747), m = f(866), g = f(554), y = f(256), v = f(144), b = f(511);
              d.createIframe = function(_, w) {
                var x = w.formId, E = w.domain, S = w.options, C = m.generateEmbedId(), R = S.iframeProps, P = R === void 0 ? {} : R, N = S.onReady, A = S.onQuestionChanged, O = S.onHeightChanged, k = S.onSubmit, T = S.onEndingButtonClick, I = S.shareGaInstance, j = h.buildIframeSrc({ formId: x, domain: E, embedId: C, type: _, options: S }), z = document.createElement("iframe");
                return z.src = j, z.dataset.testid = "iframe", z.style.border = "0px", z.allow = "microphone; camera", Object.keys(P).forEach(function($) {
                  z.setAttribute($, P[$]);
                }), z.addEventListener("load", y.triggerIframeRedraw, { once: !0 }), window.addEventListener("message", g.getFormReadyHandler(C, N)), window.addEventListener("message", g.getFormQuestionChangedHandler(C, A)), window.addEventListener("message", g.getFormHeightChangedHandler(C, O)), window.addEventListener("message", g.getFormSubmitHandler(C, k)), window.addEventListener("message", g.getFormThemeHandler(C, function($) {
                  var D;
                  if ($?.theme) {
                    var U = document.querySelector(".tf-v1-close-icon");
                    U && (U.style.color = (D = $.theme) === null || D === void 0 ? void 0 : D.color);
                  }
                })), window.addEventListener("message", g.getThankYouScreenButtonClickHandler(C, T)), _ !== "widget" && window.addEventListener("message", v.dispatchCustomKeyEventFromIframe), I && window.addEventListener("message", g.getFormReadyHandler(C, function() {
                  p.setupGaInstance(z, C, I);
                })), { iframe: z, embedId: C, refresh: function() {
                  return b.refreshIframe(z);
                }, focus: function() {
                  var $;
                  ($ = z.contentWindow) === null || $ === void 0 || $.postMessage("embed-focus", "*");
                } };
              };
            }, 866: function(u, d) {
              var f = this && this.__read || function(h, p) {
                var m = typeof Symbol == "function" && h[Symbol.iterator];
                if (!m) return h;
                var g, y, v = m.call(h), b = [];
                try {
                  for (; (p === void 0 || p-- > 0) && !(g = v.next()).done; ) b.push(g.value);
                } catch (_) {
                  y = { error: _ };
                } finally {
                  try {
                    g && !g.done && (m = v.return) && m.call(v);
                  } finally {
                    if (y) throw y.error;
                  }
                }
                return b;
              };
              Object.defineProperty(d, "__esModule", { value: !0 }), d.generateEmbedId = void 0, d.generateEmbedId = function() {
                var h = Math.random();
                return f(String(h).split("."), 2)[1];
              };
            }, 554: function(u, d) {
              var f = this && this.__rest || function(p, m) {
                var g = {};
                for (var y in p) Object.prototype.hasOwnProperty.call(p, y) && m.indexOf(y) < 0 && (g[y] = p[y]);
                if (p != null && typeof Object.getOwnPropertySymbols == "function") {
                  var v = 0;
                  for (y = Object.getOwnPropertySymbols(p); v < y.length; v++) m.indexOf(y[v]) < 0 && Object.prototype.propertyIsEnumerable.call(p, y[v]) && (g[y[v]] = p[y[v]]);
                }
                return g;
              };
              function h(p, m, g) {
                return function(y) {
                  var v = y.data, b = v.type, _ = v.embedId, w = f(v, ["type", "embedId"]);
                  b === p && _ === m && g?.(w);
                };
              }
              Object.defineProperty(d, "__esModule", { value: !0 }), d.getThankYouScreenButtonClickHandler = d.getFormThemeHandler = d.getWelcomeScreenHiddenHandler = d.getFormSubmitHandler = d.getFormHeightChangedHandler = d.getFormQuestionChangedHandler = d.getFormReadyHandler = void 0, d.getFormReadyHandler = function(p, m) {
                return h("form-ready", p, m);
              }, d.getFormQuestionChangedHandler = function(p, m) {
                return h("form-screen-changed", p, m);
              }, d.getFormHeightChangedHandler = function(p, m) {
                return h("form-height-changed", p, m);
              }, d.getFormSubmitHandler = function(p, m) {
                return h("form-submit", p, m);
              }, d.getWelcomeScreenHiddenHandler = function(p, m) {
                return h("welcome-screen-hidden", p, m);
              }, d.getFormThemeHandler = function(p, m) {
                return h("form-theme", p, m);
              }, d.getThankYouScreenButtonClickHandler = function(p, m) {
                return h("thank-you-screen-button-click", p, m);
              };
            }, 339: function(u, d, f) {
              var h = this && this.__createBinding || (Object.create ? function(m, g, y, v) {
                v === void 0 && (v = y), Object.defineProperty(m, v, { enumerable: !0, get: function() {
                  return g[y];
                } });
              } : function(m, g, y, v) {
                v === void 0 && (v = y), m[v] = g[y];
              }), p = this && this.__exportStar || function(m, g) {
                for (var y in m) y === "default" || Object.prototype.hasOwnProperty.call(g, y) || h(g, m, y);
              };
              Object.defineProperty(d, "__esModule", { value: !0 }), p(f(553), d), p(f(144), d);
            }, 511: function(u, d) {
              Object.defineProperty(d, "__esModule", { value: !0 }), d.refreshIframe = void 0, d.refreshIframe = function(f) {
                if (f) {
                  var h = f.src;
                  if (h.includes("&refresh")) {
                    var p = h.split("&refresh#");
                    f.src = p.join("#");
                  } else (p = h.split("#"))[0] = p[0] + "&refresh", f.src = p.join("#");
                }
              };
            }, 144: function(u, d) {
              var f = this && this.__awaiter || function(g, y, v, b) {
                return new (v || (v = Promise))(function(_, w) {
                  function x(C) {
                    try {
                      S(b.next(C));
                    } catch (R) {
                      w(R);
                    }
                  }
                  function E(C) {
                    try {
                      S(b.throw(C));
                    } catch (R) {
                      w(R);
                    }
                  }
                  function S(C) {
                    var R;
                    C.done ? _(C.value) : (R = C.value, R instanceof v ? R : new v(function(P) {
                      P(R);
                    })).then(x, E);
                  }
                  S((b = b.apply(g, y || [])).next());
                });
              }, h = this && this.__generator || function(g, y) {
                var v, b, _, w, x = { label: 0, sent: function() {
                  if (1 & _[0]) throw _[1];
                  return _[1];
                }, trys: [], ops: [] };
                return w = { next: E(0), throw: E(1), return: E(2) }, typeof Symbol == "function" && (w[Symbol.iterator] = function() {
                  return this;
                }), w;
                function E(S) {
                  return function(C) {
                    return function(R) {
                      if (v) throw new TypeError("Generator is already executing.");
                      for (; x; ) try {
                        if (v = 1, b && (_ = 2 & R[0] ? b.return : R[0] ? b.throw || ((_ = b.return) && _.call(b), 0) : b.next) && !(_ = _.call(b, R[1])).done) return _;
                        switch (b = 0, _ && (R = [2 & R[0], _.value]), R[0]) {
                          case 0:
                          case 1:
                            _ = R;
                            break;
                          case 4:
                            return x.label++, { value: R[1], done: !1 };
                          case 5:
                            x.label++, b = R[1], R = [0];
                            continue;
                          case 7:
                            R = x.ops.pop(), x.trys.pop();
                            continue;
                          default:
                            if (!((_ = (_ = x.trys).length > 0 && _[_.length - 1]) || R[0] !== 6 && R[0] !== 2)) {
                              x = 0;
                              continue;
                            }
                            if (R[0] === 3 && (!_ || R[1] > _[0] && R[1] < _[3])) {
                              x.label = R[1];
                              break;
                            }
                            if (R[0] === 6 && x.label < _[1]) {
                              x.label = _[1], _ = R;
                              break;
                            }
                            if (_ && x.label < _[2]) {
                              x.label = _[2], x.ops.push(R);
                              break;
                            }
                            _[2] && x.ops.pop(), x.trys.pop();
                            continue;
                        }
                        R = y.call(g, x);
                      } catch (P) {
                        R = [6, P], b = 0;
                      } finally {
                        v = _ = 0;
                      }
                      if (5 & R[0]) throw R[1];
                      return { value: R[0] ? R[1] : void 0, done: !0 };
                    }([S, C]);
                  };
                }
              };
              Object.defineProperty(d, "__esModule", { value: !0 }), d.dispatchCustomKeyEventFromIframe = d.removeCustomKeyboardListener = d.addCustomKeyboardListener = void 0;
              var p = "Escape", m = function(g, y) {
                return f(void 0, void 0, void 0, function() {
                  return h(this, function(v) {
                    return g.code === p && typeof y == "function" && (y(), d.removeCustomKeyboardListener()), [2];
                  });
                });
              };
              d.addCustomKeyboardListener = function(g) {
                return window.document.addEventListener("keydown", function(y) {
                  return m(y, g);
                });
              }, d.removeCustomKeyboardListener = function() {
                return window.document.removeEventListener("keydown", m);
              }, d.dispatchCustomKeyEventFromIframe = function(g) {
                g.data.type === "form-close" && window.document.dispatchEvent(new KeyboardEvent("keydown", { code: p }));
              };
            }, 256: function(u, d) {
              Object.defineProperty(d, "__esModule", { value: !0 }), d.triggerIframeRedraw = void 0, d.triggerIframeRedraw = function() {
                this.style.transform = "translateZ(0)";
              };
            }, 939: function(u, d, f) {
              Object.defineProperty(d, "__esModule", { value: !0 }), d.getTextColor = void 0;
              var h = f(938);
              d.getTextColor = function(p) {
                if (!p) return "#FFFFFF";
                var m = p.startsWith("#") ? h.hexRgb(p) : function(b) {
                  var _ = { red: 0, green: 0, blue: 0 }, w = b.match(/\d+/g);
                  return w && (_.red = parseInt(w[0], 10), _.green = parseInt(w[0], 10), _.blue = parseInt(w[0], 10)), _;
                }(p), g = m.red, y = m.green, v = m.blue;
                return Math.round((299 * g + 587 * y + 114 * v) / 1e3) > 150 ? "#000000" : "#FFFFFF";
              };
            }, 698: function(u, d) {
              var f = this && this.__assign || function() {
                return f = Object.assign || function(h) {
                  for (var p, m = 1, g = arguments.length; m < g; m++) for (var y in p = arguments[m]) Object.prototype.hasOwnProperty.call(p, y) && (h[y] = p[y]);
                  return h;
                }, f.apply(this, arguments);
              };
              Object.defineProperty(d, "__esModule", { value: !0 }), d.getTransitiveSearchParams = void 0, d.getTransitiveSearchParams = function(h) {
                var p = new URL(window.location.href);
                return typeof h == "boolean" && h ? Object.fromEntries(p.searchParams.entries()) : Array.isArray(h) && h.length > 0 ? h.reduce(function(m, g) {
                  var y, v = p.searchParams.get(g);
                  return v ? f(f({}, m), ((y = {})[g] = v, y)) : m;
                }, {}) : {};
              };
            }, 252: function(u, d) {
              Object.defineProperty(d, "__esModule", { value: !0 }), d.hasDom = void 0, d.hasDom = function() {
                return typeof document < "u" && typeof window < "u";
              };
            }, 938: function(u, d) {
              Object.defineProperty(d, "__esModule", { value: !0 }), d.hexRgb = void 0;
              var f = new RegExp("[^#a-f\\d]", "gi"), h = new RegExp("^#?[a-f\\d]{3}[a-f\\d]?$|^#?[a-f\\d]{6}([a-f\\d]{2})?$", "i");
              d.hexRgb = function(p) {
                if (typeof p != "string" || f.test(p) || !h.test(p)) throw new TypeError("Expected a valid hex string");
                (p = p.replace(/^#/, "")).length === 8 && (p = p.slice(0, 6)), p.length === 4 && (p = p.slice(0, 3)), p.length === 3 && (p = p[0] + p[0] + p[1] + p[1] + p[2] + p[2]);
                var m = Number.parseInt(p, 16);
                return { red: m >> 16, green: m >> 8 & 255, blue: 255 & m };
              };
            }, 863: function(u, d, f) {
              var h = this && this.__awaiter || function(g, y, v, b) {
                return new (v || (v = Promise))(function(_, w) {
                  function x(C) {
                    try {
                      S(b.next(C));
                    } catch (R) {
                      w(R);
                    }
                  }
                  function E(C) {
                    try {
                      S(b.throw(C));
                    } catch (R) {
                      w(R);
                    }
                  }
                  function S(C) {
                    var R;
                    C.done ? _(C.value) : (R = C.value, R instanceof v ? R : new v(function(P) {
                      P(R);
                    })).then(x, E);
                  }
                  S((b = b.apply(g, y || [])).next());
                });
              }, p = this && this.__generator || function(g, y) {
                var v, b, _, w, x = { label: 0, sent: function() {
                  if (1 & _[0]) throw _[1];
                  return _[1];
                }, trys: [], ops: [] };
                return w = { next: E(0), throw: E(1), return: E(2) }, typeof Symbol == "function" && (w[Symbol.iterator] = function() {
                  return this;
                }), w;
                function E(S) {
                  return function(C) {
                    return function(R) {
                      if (v) throw new TypeError("Generator is already executing.");
                      for (; x; ) try {
                        if (v = 1, b && (_ = 2 & R[0] ? b.return : R[0] ? b.throw || ((_ = b.return) && _.call(b), 0) : b.next) && !(_ = _.call(b, R[1])).done) return _;
                        switch (b = 0, _ && (R = [2 & R[0], _.value]), R[0]) {
                          case 0:
                          case 1:
                            _ = R;
                            break;
                          case 4:
                            return x.label++, { value: R[1], done: !1 };
                          case 5:
                            x.label++, b = R[1], R = [0];
                            continue;
                          case 7:
                            R = x.ops.pop(), x.trys.pop();
                            continue;
                          default:
                            if (!((_ = (_ = x.trys).length > 0 && _[_.length - 1]) || R[0] !== 6 && R[0] !== 2)) {
                              x = 0;
                              continue;
                            }
                            if (R[0] === 3 && (!_ || R[1] > _[0] && R[1] < _[3])) {
                              x.label = R[1];
                              break;
                            }
                            if (R[0] === 6 && x.label < _[1]) {
                              x.label = _[1], _ = R;
                              break;
                            }
                            if (_ && x.label < _[2]) {
                              x.label = _[2], x.ops.push(R);
                              break;
                            }
                            _[2] && x.ops.pop(), x.trys.pop();
                            continue;
                        }
                        R = y.call(g, x);
                      } catch (P) {
                        R = [6, P], b = 0;
                      } finally {
                        v = _ = 0;
                      }
                      if (5 & R[0]) throw R[1];
                      return { value: R[0] ? R[1] : void 0, done: !0 };
                    }([S, C]);
                  };
                }
              };
              Object.defineProperty(d, "__esModule", { value: !0 }), d.waitForHubspotCookie = d.getHubspotHiddenFields = d.getHubspotCookieValue = void 0;
              var m = f(623);
              d.getHubspotCookieValue = function() {
                var g = document.cookie.match(new RegExp("(^| )hubspotutk=([^;]+)"));
                return g && g[2] || void 0;
              }, d.getHubspotHiddenFields = function() {
                return { hubspot_page_name: document.title, hubspot_page_url: window.location.href, hubspot_utk: d.getHubspotCookieValue() };
              }, d.waitForHubspotCookie = function() {
                return h(void 0, void 0, void 0, function() {
                  var g, y;
                  return p(this, function(v) {
                    switch (v.label) {
                      case 0:
                        g = 10, y = 0, v.label = 1;
                      case 1:
                        return !d.getHubspotCookieValue() && y < g ? [4, m.sleep(250)] : [3, 4];
                      case 2:
                        v.sent(), v.label = 3;
                      case 3:
                        return y++, [3, 1];
                      case 4:
                        return [2];
                    }
                  });
                });
              };
            }, 71: function(u, d) {
              Object.defineProperty(d, "__esModule", { value: !0 }), d.includeCss = void 0, d.includeCss = function(f) {
                var h = function(m) {
                  return "https://embed.typeform.com/next/css/" + m;
                }(f);
                if (!document.querySelector('link[href="' + h + '"]')) {
                  var p = document.createElement("link");
                  p.rel = "stylesheet", p.href = h, document.head.append(p);
                }
              };
            }, 747: function(u, d, f) {
              var h = this && this.__createBinding || (Object.create ? function(m, g, y, v) {
                v === void 0 && (v = y), Object.defineProperty(m, v, { enumerable: !0, get: function() {
                  return g[y];
                } });
              } : function(m, g, y, v) {
                v === void 0 && (v = y), m[v] = g[y];
              }), p = this && this.__exportStar || function(m, g) {
                for (var y in m) y === "default" || Object.prototype.hasOwnProperty.call(g, y) || h(g, m, y);
              };
              Object.defineProperty(d, "__esModule", { value: !0 }), p(f(626), d), p(f(339), d), p(f(252), d), p(f(71), d), p(f(346), d), p(f(377), d), p(f(563), d), p(f(527), d), p(f(533), d), p(f(451), d), p(f(972), d), p(f(748), d), p(f(392), d), p(f(939), d), p(f(917), d), p(f(987), d), p(f(318), d), p(f(391), d), p(f(863), d);
            }, 346: function(u, d) {
              Object.defineProperty(d, "__esModule", { value: !0 }), d.isDefined = void 0, d.isDefined = function(f) {
                return f != null;
              };
            }, 987: function(u, d) {
              Object.defineProperty(d, "__esModule", { value: !0 }), d.isVisible = d.isInPage = d.isOpen = void 0, d.isOpen = function(f) {
                return d.isInPage(f) && d.isVisible(f);
              }, d.isInPage = function(f) {
                return !!f.parentNode;
              }, d.isVisible = function(f) {
                return f.style.display !== "none";
              };
            }, 917: function(u, d) {
              Object.defineProperty(d, "__esModule", { value: !0 }), d.lazyInitialize = void 0, d.lazyInitialize = function(f, h) {
                var p = new IntersectionObserver(function(m) {
                  m.forEach(function(g) {
                    g.isIntersecting && (h(), p.unobserve(g.target));
                  });
                });
                p.observe(f);
              };
            }, 377: function(u, d) {
              var f = this && this.__assign || function() {
                return f = Object.assign || function(b) {
                  for (var _, w = 1, x = arguments.length; w < x; w++) for (var E in _ = arguments[w]) Object.prototype.hasOwnProperty.call(_, E) && (b[E] = _[E]);
                  return b;
                }, f.apply(this, arguments);
              }, h = this && this.__read || function(b, _) {
                var w = typeof Symbol == "function" && b[Symbol.iterator];
                if (!w) return b;
                var x, E, S = w.call(b), C = [];
                try {
                  for (; (_ === void 0 || _-- > 0) && !(x = S.next()).done; ) C.push(x.value);
                } catch (R) {
                  E = { error: R };
                } finally {
                  try {
                    x && !x.done && (w = S.return) && w.call(S);
                  } finally {
                    if (E) throw E.error;
                  }
                }
                return C;
              };
              Object.defineProperty(d, "__esModule", { value: !0 }), d.loadOptionsFromAttributes = d.transformAttributeValue = d.camelCaseToKebabCase = void 0, d.camelCaseToKebabCase = function(b) {
                return b.split("").map(function(_, w) {
                  return _.toUpperCase() === _ ? (w !== 0 ? "-" : "") + _.toLowerCase() : _;
                }).join("");
              };
              var p = function(b) {
                return b || void 0;
              }, m = function(b) {
                return b === "" || b === "yes" || b === "true";
              }, g = function(b) {
                var _ = b ? parseInt(b, 10) : NaN;
                return isNaN(_) ? void 0 : _;
              }, y = "%ESCAPED_COMMA%", v = function(b) {
                if (b) return b.replace(/\s/g, "").replace(/\\,/g, y).split(",").filter(function(_) {
                  return !!_;
                }).map(function(_) {
                  return _.replace(y, ",");
                });
              };
              d.transformAttributeValue = function(b, _) {
                var w, x, E;
                switch (_) {
                  case "string":
                    return p(b);
                  case "boolean":
                    return m(b);
                  case "integer":
                    return g(b);
                  case "function":
                    return function(S) {
                      var C = S && S in window ? window[S] : void 0;
                      return typeof C == "function" ? C : void 0;
                    }(b);
                  case "array":
                    return v(b);
                  case "record":
                    return function(S) {
                      if (S) return S.replace(/\\,/g, y).split(",").filter(function(C) {
                        return !!C;
                      }).map(function(C) {
                        return C.replace(y, ",");
                      }).reduce(function(C, R) {
                        var P, N = R.match(/^([^=]+)=(.*)$/);
                        if (N) {
                          var A = h(N, 3), O = A[1], k = A[2];
                          return f(f({}, C), ((P = {})[O.trim()] = k, P));
                        }
                        return C;
                      }, {});
                    }(b);
                  case "integerOrBoolean":
                    return (w = g(b)) !== null && w !== void 0 ? w : m(b);
                  case "stringOrBoolean":
                    return (x = p(b)) !== null && x !== void 0 ? x : m(b);
                  case "arrayOrBoolean":
                    return (E = v(b)) !== null && E !== void 0 ? E : m(b);
                  default:
                    throw new Error("Invalid attribute transformation " + _);
                }
              }, d.loadOptionsFromAttributes = function(b, _) {
                return Object.keys(_).reduce(function(w, x) {
                  var E;
                  return f(f({}, w), ((E = {})[x] = d.transformAttributeValue(b.getAttribute("data-tf-" + d.camelCaseToKebabCase(x)), _[x]), E));
                }, {});
              };
            }, 318: function(u, d, f) {
              Object.defineProperty(d, "__esModule", { value: !0 }), d.makeAutoResize = void 0;
              var h = f(563);
              d.makeAutoResize = function(p, m) {
                return m === void 0 && (m = !1), function() {
                  var g = m || h.isMobile();
                  p && g && p.style.setProperty("height", window.innerHeight + "px", "important");
                };
              };
            }, 563: function(u, d) {
              Object.defineProperty(d, "__esModule", { value: !0 }), d.isFullscreen = d.isMobile = d.isBigScreen = void 0, d.isBigScreen = function() {
                return window.screen.width >= 1024 && window.screen.height >= 768;
              }, d.isMobile = function() {
                return /mobile|tablet|android/i.test(navigator.userAgent.toLowerCase());
              }, d.isFullscreen = function() {
                return d.isMobile() && !d.isBigScreen();
              };
            }, 527: function(u, d, f) {
              var h = this && this.__assign || function() {
                return h = Object.assign || function(g) {
                  for (var y, v = 1, b = arguments.length; v < b; v++) for (var _ in y = arguments[v]) Object.prototype.hasOwnProperty.call(y, _) && (g[_] = y[_]);
                  return g;
                }, h.apply(this, arguments);
              }, p = this && this.__read || function(g, y) {
                var v = typeof Symbol == "function" && g[Symbol.iterator];
                if (!v) return g;
                var b, _, w = v.call(g), x = [];
                try {
                  for (; (y === void 0 || y-- > 0) && !(b = w.next()).done; ) x.push(b.value);
                } catch (E) {
                  _ = { error: E };
                } finally {
                  try {
                    b && !b.done && (v = w.return) && v.call(w);
                  } finally {
                    if (_) throw _.error;
                  }
                }
                return x;
              };
              Object.defineProperty(d, "__esModule", { value: !0 }), d.removeUndefinedKeys = void 0;
              var m = f(346);
              d.removeUndefinedKeys = function(g) {
                return Object.entries(g).filter(function(y) {
                  var v = p(y, 2)[1];
                  return m.isDefined(v);
                }).reduce(function(y, v) {
                  var b, _ = p(v, 2), w = _[0], x = _[1];
                  return h(h({}, y), ((b = {})[w] = x, b));
                }, {});
              };
            }, 748: function(u, d, f) {
              Object.defineProperty(d, "__esModule", { value: !0 }), d.setAutoClose = void 0;
              var h = f(554);
              d.setAutoClose = function(p, m, g) {
                if (m && g) {
                  var y = typeof m == "number" ? m : 0;
                  window.addEventListener("message", h.getFormSubmitHandler(p, function() {
                    return setTimeout(g, y);
                  }));
                }
              };
            }, 533: function(u, d) {
              Object.defineProperty(d, "__esModule", { value: !0 }), d.setElementSize = void 0, d.setElementSize = function(f, h) {
                var p = h.width, m = h.height;
                return p && (f.style.width = p + "px"), m && (f.style.height = m + "px"), f;
              };
            }, 392: function(u, d) {
              Object.defineProperty(d, "__esModule", { value: !0 }), d.setupGaInstance = d.sendGaIdMessage = void 0, d.sendGaIdMessage = function(h, p, m) {
                var g = { embedId: h, gaClientId: p };
                setTimeout(function() {
                  m && m.contentWindow && m.contentWindow.postMessage({ type: "ga-client-id", data: g }, "*");
                }, 0);
              };
              var f = function(h) {
                console.error(h);
              };
              d.setupGaInstance = function(h, p, m) {
                var g = typeof m == "string" ? m : void 0;
                if (window.gtag) {
                  if (g || (g = function() {
                    if (window.dataLayer) {
                      var b = window.dataLayer.find(function(_) {
                        return _.length > 1 && _[0] === "config";
                      });
                      return b && b[1];
                    }
                  }()), !g) return void f("Whoops! You enabled the shareGaInstance feature in yourtypeform embed but the tracker ID could not be retrieved. Make sure to include Google Analytics Javascript code before the Typeform Embed Javascriptcode in your page and use correct tracker ID. ");
                  var y = !1;
                  window.gtag("get", g, "client_id", function(b) {
                    y = !0, d.sendGaIdMessage(p, b, h);
                  }), setTimeout(function() {
                    y || f("Whoops! You enabled the shareGaInstance feature in yourtypeform embed but the tracker with ID " + g + " was not found. Make sure to include Google Analytics Javascript code before the Typeform Embed Javascriptcode in your page and use correct tracker ID. ");
                  }, 3e3);
                } else try {
                  var v = function(b, _) {
                    return _ ? b.find(function(w) {
                      return w.get("trackingId") === _;
                    }) : b[0];
                  }(window.ga.getAll(), g);
                  v ? d.sendGaIdMessage(p, v.get("clientId"), h) : f("Whoops! You enabled the shareGaInstance feature in yourtypeform embed but the tracker with ID " + g + " was not found. Make sure to include Google Analytics Javascript code before the Typeform Embed Javascriptcode in your page and use correct tracker ID. ");
                } catch (b) {
                  f("Whoops! You enabled the shareGaInstance feature in your typeform embed but the Google Analytics object has not been found. Make sure to include Google Analytics Javascript code before the Typeform Embed Javascript code in your page. "), f(b);
                }
              };
            }, 623: function(u, d) {
              Object.defineProperty(d, "__esModule", { value: !0 }), d.sleep = void 0, d.sleep = function(f) {
                return new Promise(function(h) {
                  return setTimeout(h, f);
                });
              };
            }, 451: function(u, d) {
              Object.defineProperty(d, "__esModule", { value: !0 }), d.unmountElement = void 0, d.unmountElement = function(f) {
                var h;
                (h = f.parentNode) === null || h === void 0 || h.removeChild(f);
              };
            } }, c = {};
            return function u(d) {
              var f = c[d];
              if (f !== void 0) return f.exports;
              var h = c[d] = { exports: {} };
              return l[d].call(h.exports, h, h.exports, u), h.exports;
            }(920);
          }();
        }, 156: function(a) {
          a.exports = n;
        } }, o = {};
        function i(a) {
          var l = o[a];
          if (l !== void 0) return l.exports;
          var c = o[a] = { exports: {} };
          return r[a].call(c.exports, c, c.exports, i), c.exports;
        }
        i.g = function() {
          if (typeof globalThis == "object") return globalThis;
          try {
            return this || new Function("return this")();
          } catch {
            if (typeof window == "object") return window;
          }
        }(), i.o = function(a, l) {
          return Object.prototype.hasOwnProperty.call(a, l);
        }, i.r = function(a) {
          typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(a, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(a, "__esModule", { value: !0 });
        };
        var s = {};
        return function() {
          var a = s;
          Object.defineProperty(a, "__esModule", { value: !0 }), a.Sidetab = a.Popover = a.SliderButton = a.PopupButton = a.Widget = void 0;
          var l = i(611), c = i(281), u = i(797), d = u.memoComponent(c.Widget);
          a.Widget = d;
          var f = u.memoComponent(c.makeButtonComponent(l.createPopup, "popup"));
          a.PopupButton = f;
          var h = u.memoComponent(c.makeButtonComponent(l.createSlider, "slider"));
          a.SliderButton = h;
          var p = u.memoComponent(c.makeInitializerComponent(l.createPopover, "popover"));
          a.Popover = p;
          var m = u.memoComponent(c.makeInitializerComponent(l.createSidetab, "sidetab"));
          a.Sidetab = m;
        }(), s;
      }();
    });
  }(Bw)), Bw.exports;
}
ywt();
var cD = {}, ms = {}, Loe;
function Ls() {
  if (Loe) return ms;
  Loe = 1, Object.defineProperty(ms, "__esModule", { value: !0 }), ms.getBreaksNeededForEmptyLineAfter = ms.getBreaksNeededForEmptyLineBefore = ms.selectWord = ms.getSurroundingWord = void 0;
  function t(o, i) {
    if (!o)
      throw Error("Argument 'text' should be truthy");
    for (var s = function(u) {
      return u === " " || u.charCodeAt(0) === 10;
    }, a = 0, l = o.length, c = i; c - 1 > -1; c--)
      if (s(o[c - 1])) {
        a = c;
        break;
      }
    for (var c = i; c < o.length; c++)
      if (s(o[c])) {
        l = c;
        break;
      }
    return { start: a, end: l };
  }
  ms.getSurroundingWord = t;
  function e(o) {
    var i = o.text, s = o.selection;
    return i && i.length && s.start === s.end ? t(i, s.start) : s;
  }
  ms.selectWord = e;
  function n(o, i) {
    if (o === void 0 && (o = ""), i === 0)
      return 0;
    for (var s = 2, a = !0, l = i - 1; l >= 0 && s >= 0; l--)
      switch (o.charCodeAt(l)) {
        case 32:
          continue;
        case 10:
          s--, a = !1;
          break;
        default:
          return s;
      }
    return a ? 0 : s;
  }
  ms.getBreaksNeededForEmptyLineBefore = n;
  function r(o, i) {
    if (o === void 0 && (o = ""), i === o.length - 1)
      return 0;
    for (var s = 2, a = !0, l = i; l < o.length && s >= 0; l++)
      switch (o.charCodeAt(l)) {
        case 32:
          continue;
        case 10: {
          s--, a = !1;
          break;
        }
        default:
          return s;
      }
    return a ? 0 : s;
  }
  return ms.getBreaksNeededForEmptyLineAfter = r, ms;
}
var ku = {}, Nm = {}, jm = {}, Foe;
function qp() {
  if (Foe) return jm;
  Foe = 1;
  /*!
    Copyright (c) 2018 Jed Watson.
    Licensed under the MIT License (MIT), see
    http://jedwatson.github.io/classnames
  */
  Object.defineProperty(jm, "__esModule", { value: !0 }), jm.classNames = void 0;
  function t(o) {
    return typeof o == "string";
  }
  function e(o) {
    return Array.isArray(o) && o.length > 0;
  }
  function n(o) {
    return typeof o == "object";
  }
  function r() {
    for (var o = [], i = 0; i < arguments.length; i++)
      o[i] = arguments[i];
    for (var s = [], a = 0; a < o.length; a++) {
      var l = o[a];
      if (l) {
        if (t(l))
          s.push(l);
        else if (e(l)) {
          var c = r.apply(null, l);
          c && s.push(c);
        } else if (n(l))
          for (var u in l)
            l.hasOwnProperty(u) && l[u] && s.push(u);
      }
    }
    return s.join(" ");
  }
  return jm.classNames = r, jm;
}
var Boe;
function p_e() {
  if (Boe) return Nm;
  Boe = 1, Object.defineProperty(Nm, "__esModule", { value: !0 }), Nm.ToolbarButtonGroup = void 0;
  var t = xe, e = qp(), n = function(r) {
    return t.createElement("ul", { className: e.classNames("mde-header-group", { hidden: r.hidden }) }, r.children);
  };
  return Nm.ToolbarButtonGroup = n, Nm;
}
var Au = {}, zoe;
function m_e() {
  if (zoe) return Au;
  zoe = 1;
  var t = Au && Au.__assign || function() {
    return t = Object.assign || function(o) {
      for (var i, s = 1, a = arguments.length; s < a; s++) {
        i = arguments[s];
        for (var l in i) Object.prototype.hasOwnProperty.call(i, l) && (o[l] = i[l]);
      }
      return o;
    }, t.apply(this, arguments);
  };
  Object.defineProperty(Au, "__esModule", { value: !0 }), Au.ToolbarButton = void 0;
  var e = xe, n = {
    tabIndex: -1
  }, r = function(o) {
    var i = o.buttonComponentClass, s = o.buttonContent, a = o.buttonProps, l = o.onClick, c = o.readOnly, u = o.name, d = t(t({}, n), a || {}), f = i || "button";
    return e.createElement("li", { className: "mde-header-item" }, e.createElement(f, t(t({ "data-name": u }, d), {
      onClick: l,
      disabled: c,
      type: "button"
    }), s));
  };
  return Au.ToolbarButton = r, Au;
}
var Lm = {}, qoe;
function g_e() {
  if (qoe) return Lm;
  qoe = 1, Object.defineProperty(Lm, "__esModule", { value: !0 }), Lm.MdeFontAwesomeIcon = void 0;
  var t = xe, e = function(n) {
    var r = n.icon, o = r;
    switch (r) {
      case "header":
        o = "heading";
        break;
      case "quote":
        o = "quote-right";
        break;
      case "unordered-list":
        o = "tasks";
        break;
      case "ordered-list":
        o = "list-ol";
        break;
      case "checked-list":
        o = "tasks";
        break;
      default:
        o = r;
    }
    return t.createElement("i", { className: "fas fa-" + o, "aria-hidden": "true" });
  };
  return Lm.MdeFontAwesomeIcon = e, Lm;
}
var Tu = {}, Uoe;
function vwt() {
  if (Uoe) return Tu;
  Uoe = 1;
  var t = Tu && Tu.__extends || /* @__PURE__ */ function() {
    var o = function(i, s) {
      return o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(a, l) {
        a.__proto__ = l;
      } || function(a, l) {
        for (var c in l) Object.prototype.hasOwnProperty.call(l, c) && (a[c] = l[c]);
      }, o(i, s);
    };
    return function(i, s) {
      if (typeof s != "function" && s !== null)
        throw new TypeError("Class extends value " + String(s) + " is not a constructor or null");
      o(i, s);
      function a() {
        this.constructor = i;
      }
      i.prototype = s === null ? Object.create(s) : (a.prototype = s.prototype, new a());
    };
  }();
  Object.defineProperty(Tu, "__esModule", { value: !0 }), Tu.Preview = void 0;
  var e = xe, n = qp(), r = (
    /** @class */
    function(o) {
      t(i, o);
      function i(s) {
        var a = o.call(this, s) || this;
        return a.state = {
          loading: !0
        }, a;
      }
      return i.prototype.componentDidMount = function() {
        this.generatePreview();
      }, i.prototype.componentDidUpdate = function(s, a) {
        this.props.markdown !== s.markdown && this.generatePreview();
      }, i.prototype.generatePreview = function() {
        var s = this, a = this.props, l = a.markdown, c = a.generateMarkdownPreview;
        c(l).then(function(u) {
          s.setState({
            preview: u,
            loading: !1
          });
        });
      }, i.prototype.render = function() {
        var s = this.props, a = s.classes, l = s.minHeight, c = s.loadingPreview, u = s.refObject, d = s.heightUnits, f = this.state, h = f.preview, p = f.loading, m = p ? c : h, g;
        typeof m == "string" ? g = e.createElement("div", { className: "mde-preview-content", dangerouslySetInnerHTML: { __html: m || "<p>&nbsp;</p>" }, ref: u }) : g = e.createElement("div", { className: "mde-preview-content" }, m);
        var y = l && d ? l + 10 + d : l + 10;
        return e.createElement("div", { className: n.classNames("mde-preview", a, { loading: p }), style: { minHeight: y }, "data-testid": "mde-preview" }, g);
      }, i;
    }(e.Component)
  );
  return Tu.Preview = r, Tu;
}
var Wa = {}, Fm = {}, Hoe;
function bwt() {
  if (Hoe) return Fm;
  Hoe = 1, Object.defineProperty(Fm, "__esModule", { value: !0 }), Fm.getCaretCoordinates = void 0;
  var t = [
    "direction",
    "boxSizing",
    "width",
    "height",
    "overflowX",
    "overflowY",
    "borderTopWidth",
    "borderRightWidth",
    "borderBottomWidth",
    "borderLeftWidth",
    "borderStyle",
    "paddingTop",
    "paddingRight",
    "paddingBottom",
    "paddingLeft",
    // https://developer.mozilla.org/en-US/docs/Web/CSS/font
    "fontStyle",
    "fontVariant",
    "fontWeight",
    "fontStretch",
    "fontSize",
    "fontSizeAdjust",
    "lineHeight",
    "fontFamily",
    "textAlign",
    "textTransform",
    "textIndent",
    "textDecoration",
    "letterSpacing",
    "wordSpacing",
    "tabSize",
    "MozTabSize"
  ], e = typeof window < "u", n = e && window.mozInnerScreenX != null;
  function r(o, i) {
    if (!e)
      throw new Error("getCaretCoordinates should only be called in a browser");
    var s = document.createElement("div");
    s.id = "input-textarea-caret-position-mirror-div", document.body.appendChild(s);
    var a = s.style, l = window.getComputedStyle ? window.getComputedStyle(o) : o.currentStyle;
    a.whiteSpace = "pre-wrap", a.wordWrap = "break-word", a.position = "absolute", a.visibility = "hidden", t.forEach(function(d) {
      a[d] = l[d];
    }), n ? o.scrollHeight > parseInt(l.height) && (a.overflowY = "scroll") : a.overflow = "hidden", s.textContent = o.value.substring(0, o.selectionStart), i && (s.textContent += i);
    var c = document.createElement("span");
    c.textContent = o.value.substring(o.selectionEnd) || ".", s.appendChild(c);
    var u = {
      top: c.offsetTop + parseInt(l.borderTopWidth),
      left: c.offsetLeft + parseInt(l.borderLeftWidth),
      lineHeight: parseInt(l.lineHeight)
    };
    return document.body.removeChild(s), u;
  }
  return Fm.getCaretCoordinates = r, Fm;
}
var Bm = {}, Voe;
function y_e() {
  if (Voe) return Bm;
  Voe = 1;
  /*!
   * The MIT License
     Copyright (c) 2018 Dmitriy Kubyshkin
     Copied from https://github.com/grassator/insert-text-at-cursor
   */
  Object.defineProperty(Bm, "__esModule", { value: !0 }), Bm.insertText = void 0;
  function t(n, r) {
    if (n.focus(), document.selection) {
      var o = document.selection.createRange();
      o.text = r, o.collapse(
        !1
        /* to the end */
      ), o.select();
      return;
    }
    var i = document.execCommand("insertText", !1, r);
    if (!i) {
      var s = n.selectionStart, a = n.selectionEnd;
      if (typeof n.setRangeText == "function")
        n.setRangeText(r);
      else if (e(n)) {
        var l = document.createTextNode(r), c = n.firstChild;
        if (!c)
          n.appendChild(l);
        else {
          for (var u = 0, d = null, f = null, h = document.createRange(); c && (d === null || f === null); ) {
            var p = c.nodeValue.length;
            s >= u && s <= u + p && h.setStart(d = c, s - u), a >= u && a <= u + p && h.setEnd(f = c, a - u), u += p, c = c.nextSibling;
          }
          s !== a && h.deleteContents(), h.insertNode(l);
        }
      } else {
        var m = n.value;
        n.value = m.slice(0, s) + r + m.slice(a);
      }
      n.setSelectionRange(s + r.length, s + r.length);
      var g = document.createEvent("UIEvent");
      g.initEvent("input", !0, !1), n.dispatchEvent(g);
    }
  }
  Bm.insertText = t;
  function e(n) {
    if (n.nodeName !== "TEXTAREA")
      return !1;
    var r;
    if (typeof r > "u") {
      var o = document.createElement("textarea");
      o.value = "1", r = !!o.firstChild;
    }
    return r;
  }
  return Bm;
}
var zm = {}, Woe;
function _wt() {
  if (Woe) return zm;
  Woe = 1, Object.defineProperty(zm, "__esModule", { value: !0 }), zm.mod = void 0;
  function t(e, n) {
    return (e % n + n) % n;
  }
  return zm.mod = t, zm;
}
var qm = {}, Goe;
function v_e() {
  if (Goe) return qm;
  Goe = 1, Object.defineProperty(qm, "__esModule", { value: !0 }), qm.SuggestionsDropdown = void 0;
  var t = xe, e = qp(), n = function(r) {
    var o = r.classes, i = r.suggestions, s = r.caret, a = r.onSuggestionSelected, l = r.suggestionsAutoplace, c = r.focusIndex, u = r.textAreaRef, d = function(v) {
      v.preventDefault();
      var b = parseInt(v.currentTarget.attributes["data-index"].value);
      a(b);
    }, f = function(v) {
      return v.preventDefault();
    }, h = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0), p = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0), m = s.left - u.current.scrollLeft, g = s.top - u.current.scrollTop, y = {};
    return l && g + u.current.getBoundingClientRect().top > p / 2 ? y.bottom = u.current.offsetHeight - g : y.top = g, l && m + u.current.getBoundingClientRect().left > h / 2 ? y.right = u.current.offsetWidth - m : y.left = m, t.createElement("ul", { className: e.classNames("mde-suggestions", o), style: y }, i.map(function(v, b) {
      return t.createElement("li", { onClick: d, onMouseDown: f, key: b, "aria-selected": c === b ? "true" : "false", "data-index": "" + b }, v.preview);
    }));
  };
  return qm.SuggestionsDropdown = n, qm;
}
var Yoe;
function wwt() {
  if (Yoe) return Wa;
  Yoe = 1;
  var t = Wa && Wa.__extends || /* @__PURE__ */ function() {
    var c = function(u, d) {
      return c = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(f, h) {
        f.__proto__ = h;
      } || function(f, h) {
        for (var p in h) Object.prototype.hasOwnProperty.call(h, p) && (f[p] = h[p]);
      }, c(u, d);
    };
    return function(u, d) {
      if (typeof d != "function" && d !== null)
        throw new TypeError("Class extends value " + String(d) + " is not a constructor or null");
      c(u, d);
      function f() {
        this.constructor = u;
      }
      u.prototype = d === null ? Object.create(d) : (f.prototype = d.prototype, new f());
    };
  }(), e = Wa && Wa.__assign || function() {
    return e = Object.assign || function(c) {
      for (var u, d = 1, f = arguments.length; d < f; d++) {
        u = arguments[d];
        for (var h in u) Object.prototype.hasOwnProperty.call(u, h) && (c[h] = u[h]);
      }
      return c;
    }, e.apply(this, arguments);
  };
  Object.defineProperty(Wa, "__esModule", { value: !0 }), Wa.TextArea = void 0;
  var n = xe, r = qp(), o = bwt(), i = y_e(), s = _wt(), a = v_e(), l = (
    /** @class */
    function(c) {
      t(u, c);
      function u(d) {
        var f = c.call(this, d) || this;
        return f.currentLoadSuggestionsPromise = Promise.resolve(void 0), f.suggestionsPromiseIndex = 0, f.getTextArea = function() {
          return f.props.refObject.current;
        }, f.handleOnChange = function(h) {
          var p = f.props.onChange;
          p(h.target.value);
        }, f.handleBlur = function() {
          var h = f.state.mention;
          h && f.setState({ mention: { status: "inactive", suggestions: [] } });
        }, f.startLoadingSuggestions = function(h) {
          var p = ++f.suggestionsPromiseIndex, m = f.props.loadSuggestions;
          f.currentLoadSuggestionsPromise = f.currentLoadSuggestionsPromise.then(function() {
            return m(h, f.state.mention.triggeredBy);
          }).then(function(g) {
            if (f.state.mention.status !== "inactive")
              return f.suggestionsPromiseIndex === p && (!g || !g.length ? f.setState({
                mention: {
                  status: "inactive",
                  suggestions: []
                }
              }) : f.setState({
                mention: e(e({}, f.state.mention), { status: "active", suggestions: g, focusIndex: 0 })
              }), f.suggestionsPromiseIndex = 0), Promise.resolve();
          });
        }, f.loadEmptySuggestion = function(h, p) {
          var m = o.getCaretCoordinates(h, p);
          f.startLoadingSuggestions(""), f.setState({
            mention: {
              status: "loading",
              startPosition: h.selectionStart + 1,
              caret: m,
              suggestions: [],
              triggeredBy: p
            }
          });
        }, f.handleSuggestionSelected = function(h) {
          var p = f.state.mention;
          f.getTextArea().selectionStart = p.startPosition - 1, f.props.value.substr(f.getTextArea().selectionStart, f.getTextArea().selectionEnd - f.getTextArea().selectionStart), i.insertText(f.getTextArea(), p.suggestions[h].value + " "), f.setState({
            mention: {
              status: "inactive",
              suggestions: []
            }
          });
        }, f.handleKeyDown = function(h) {
          if (f.props.onPossibleKeyCommand) {
            var p = f.props.onPossibleKeyCommand(h);
            if (p) {
              h.preventDefault(), f.suggestionsPromiseIndex = 0, f.setState({
                mention: {
                  status: "inactive",
                  suggestions: []
                }
              });
              return;
            }
          }
          if (f.suggestionsEnabled()) {
            var m = h.key, g = h.shiftKey, y = h.currentTarget, v = y.selectionStart, b = f.state.mention;
            switch (b.status) {
              case "loading":
              case "active":
                if (m === "Escape" || m === "Backspace" && v <= f.state.mention.startPosition)
                  f.suggestionsPromiseIndex = 0, f.setState({
                    mention: {
                      status: "inactive",
                      suggestions: []
                    }
                  });
                else if (b.status === "active" && (m === "ArrowUp" || m === "ArrowDown") && !g) {
                  h.preventDefault();
                  var _ = m === "ArrowUp" ? -1 : 1;
                  f.setState({
                    mention: e(e({}, b), { focusIndex: s.mod(b.focusIndex + _, b.suggestions.length) })
                  });
                } else m === "Enter" && b.status === "active" && b.suggestions.length && (h.preventDefault(), f.handleSuggestionSelected(b.focusIndex));
                break;
            }
          }
        }, f.handleKeyUp = function(h) {
          var p = h.key, m = f.state.mention, g = f.props, y = g.suggestionTriggerCharacters, v = g.value;
          switch (m.status) {
            case "loading":
            case "active":
              if (p === "Backspace") {
                var b = v.substr(m.startPosition, f.getTextArea().selectionStart - m.startPosition);
                f.startLoadingSuggestions(b), m.status !== "loading" && f.setState({
                  mention: e(e({}, f.state.mention), { status: "loading" })
                });
              }
              break;
            case "inactive":
              if (p === "Backspace") {
                var _ = v.charAt(f.getTextArea().selectionStart - 1), w = y.includes(v.charAt(f.getTextArea().selectionStart - 1));
                w && f.loadEmptySuggestion(h.currentTarget, _);
              }
              break;
          }
        }, f.handleKeyPress = function(h) {
          var p = f.props, m = p.suggestionTriggerCharacters, g = p.value, y = f.state.mention, v = h.key;
          switch (y.status) {
            case "loading":
            case "active":
              if (v === " ") {
                f.setState({
                  mention: e(e({}, f.state.mention), { status: "inactive" })
                });
                return;
              }
              var b = g.substr(y.startPosition, f.getTextArea().selectionStart - y.startPosition) + v;
              f.startLoadingSuggestions(b), y.status !== "loading" && f.setState({
                mention: e(e({}, f.state.mention), { status: "loading" })
              });
              break;
            case "inactive":
              if (m.indexOf(h.key) === -1 || !/\s|\(|\[|^.{0}$/.test(g.charAt(f.getTextArea().selectionStart - 1)))
                return;
              f.loadEmptySuggestion(h.currentTarget, h.key);
              break;
          }
        }, f.state = { mention: { status: "inactive", suggestions: [] } }, f;
      }
      return u.prototype.suggestionsEnabled = function() {
        return this.props.suggestionTriggerCharacters && this.props.suggestionTriggerCharacters.length && this.props.loadSuggestions;
      }, u.prototype.render = function() {
        var d = this, f = this.props, h = f.classes, p = f.readOnly, m = f.textAreaProps, g = f.height, y = f.heightUnits, v = f.value, b = f.suggestionTriggerCharacters, _ = f.loadSuggestions, w = f.suggestionsDropdownClasses, x = f.textAreaComponent, E = f.onPaste, S = f.onDrop, C = b && b.length && _, R = this.state.mention, P = x || "textarea", N = g && y ? g + y : g;
        return n.createElement(
          "div",
          { className: "mde-textarea-wrapper" },
          n.createElement(P, e({ className: r.classNames("mde-text", h), style: { height: N }, ref: this.props.refObject, readOnly: p, value: v, "data-testid": "text-area" }, m, { onChange: function(A) {
            var O;
            (O = m?.onChange) === null || O === void 0 || O.call(m, A), d.handleOnChange(A);
          }, onBlur: function(A) {
            var O;
            (O = m?.onBlur) === null || O === void 0 || O.call(m, A), C && d.handleBlur();
          }, onKeyDown: function(A) {
            var O;
            (O = m?.onKeyDown) === null || O === void 0 || O.call(m, A), d.handleKeyDown(A);
          }, onKeyUp: function(A) {
            var O;
            (O = m?.onKeyUp) === null || O === void 0 || O.call(m, A), C && d.handleKeyUp(A);
          }, onKeyPress: function(A) {
            var O;
            (O = m?.onKeyPress) === null || O === void 0 || O.call(m, A), C && d.handleKeyPress(A);
          }, onPaste: function(A) {
            var O;
            (O = m?.onPaste) === null || O === void 0 || O.call(m, A), E(A);
          }, onDragOver: function(A) {
            A.preventDefault(), A.stopPropagation();
          }, onDrop: function(A) {
            var O;
            (O = m?.onDrop) === null || O === void 0 || O.call(m, A), S(A), A.preventDefault();
          } })),
          R.status === "active" && R.suggestions.length && n.createElement(a.SuggestionsDropdown, { classes: w, caret: R.caret, suggestions: R.suggestions, onSuggestionSelected: this.handleSuggestionSelected, suggestionsAutoplace: this.props.suggestionsAutoplace, focusIndex: R.focusIndex, textAreaRef: this.props.refObject })
        );
      }, u;
    }(n.Component)
  );
  return Wa.TextArea = l, Wa;
}
var Ga = {}, Koe;
function xwt() {
  if (Koe) return Ga;
  Koe = 1;
  var t = Ga && Ga.__extends || /* @__PURE__ */ function() {
    var a = function(l, c) {
      return a = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(u, d) {
        u.__proto__ = d;
      } || function(u, d) {
        for (var f in d) Object.prototype.hasOwnProperty.call(d, f) && (u[f] = d[f]);
      }, a(l, c);
    };
    return function(l, c) {
      if (typeof c != "function" && c !== null)
        throw new TypeError("Class extends value " + String(c) + " is not a constructor or null");
      a(l, c);
      function u() {
        this.constructor = l;
      }
      l.prototype = c === null ? Object.create(c) : (u.prototype = c.prototype, new u());
    };
  }(), e = Ga && Ga.__assign || function() {
    return e = Object.assign || function(a) {
      for (var l, c = 1, u = arguments.length; c < u; c++) {
        l = arguments[c];
        for (var d in l) Object.prototype.hasOwnProperty.call(l, d) && (a[d] = l[d]);
      }
      return a;
    }, e.apply(this, arguments);
  };
  Object.defineProperty(Ga, "__esModule", { value: !0 }), Ga.Toolbar = void 0;
  var n = xe, r = qp(), o = p_e(), i = m_e(), s = (
    /** @class */
    function(a) {
      t(l, a);
      function l() {
        var c = a !== null && a.apply(this, arguments) || this;
        return c.handleTabChange = function(u) {
          var d = c.props.onTabChange;
          d(u);
        }, c;
      }
      return l.prototype.render = function() {
        var c = this, u = this.props.l18n, d = this.props, f = d.classes, h = d.children, p = d.buttons, m = d.onCommand, g = d.readOnly, y = d.disablePreview, v = d.writeButtonProps, b = d.previewButtonProps, _ = d.buttonProps;
        if ((!p || p.length === 0) && !h)
          return null;
        var w = n.createElement(
          "div",
          { className: "mde-tabs" },
          n.createElement("button", e({ type: "button", className: r.classNames({ selected: this.props.tab === "write" }), onClick: function() {
            return c.handleTabChange("write");
          } }, v), u.write),
          n.createElement("button", e({ type: "button", className: r.classNames({ selected: this.props.tab === "preview" }), onClick: function() {
            return c.handleTabChange("preview");
          } }, b), u.preview)
        );
        return n.createElement(
          "div",
          { className: r.classNames("mde-header", f) },
          !y && w,
          p.map(function(x, E) {
            return n.createElement(o.ToolbarButtonGroup, { key: E, hidden: c.props.tab === "preview" }, x.map(function(S, C) {
              return n.createElement(i.ToolbarButton, { key: C, name: S.commandName, buttonContent: S.buttonContent, buttonProps: e(e({}, _ || {}), S.buttonProps), onClick: function() {
                return m(S.commandName);
              }, readOnly: g, buttonComponentClass: S.buttonComponentClass });
            }));
          })
        );
      }, l;
    }(n.Component)
  );
  return Ga.Toolbar = s, Ga;
}
var li = {}, Ya = {}, Um = {}, Xoe;
function Ewt() {
  if (Xoe) return Um;
  Xoe = 1, Object.defineProperty(Um, "__esModule", { value: !0 }), Um.headerCommand = void 0;
  var t = Ls();
  function e(n, r, o) {
    var i = t.selectWord({
      text: n.text,
      selection: n.selection
    }), s = r.setSelectionRange(i), a = r.replaceSelection("" + o + s.selectedText);
    r.setSelectionRange({
      start: a.selection.end - s.selectedText.length,
      end: a.selection.end
    });
  }
  return Um.headerCommand = {
    buttonProps: { "aria-label": "Add header" },
    execute: function(n) {
      var r = n.initialState, o = n.textApi;
      e(r, o, "### ");
    }
  }, Um;
}
var Hm = {}, Qoe;
function Swt() {
  if (Qoe) return Hm;
  Qoe = 1, Object.defineProperty(Hm, "__esModule", { value: !0 }), Hm.boldCommand = void 0;
  var t = Ls();
  return Hm.boldCommand = {
    buttonProps: { "aria-label": "Add bold text" },
    execute: function(e) {
      var n = e.initialState, r = e.textApi, o = t.selectWord({
        text: n.text,
        selection: n.selection
      }), i = r.setSelectionRange(o), s = r.replaceSelection("**" + i.selectedText + "**");
      r.setSelectionRange({
        start: s.selection.end - 2 - i.selectedText.length,
        end: s.selection.end - 2
      });
    },
    handleKeyCommand: function(e) {
      return (e.ctrlKey || e.metaKey) && e.key == "b";
    }
  }, Hm;
}
var Vm = {}, Zoe;
function Owt() {
  if (Zoe) return Vm;
  Zoe = 1, Object.defineProperty(Vm, "__esModule", { value: !0 }), Vm.italicCommand = void 0;
  var t = Ls();
  return Vm.italicCommand = {
    buttonProps: { "aria-label": "Add italic text" },
    execute: function(e) {
      var n = e.initialState, r = e.textApi, o = t.selectWord({
        text: n.text,
        selection: n.selection
      }), i = r.setSelectionRange(o), s = r.replaceSelection("*" + i.selectedText + "*");
      r.setSelectionRange({
        start: s.selection.end - 1 - i.selectedText.length,
        end: s.selection.end - 1
      });
    },
    handleKeyCommand: function(e) {
      return (e.ctrlKey || e.metaKey) && e.key == "i";
    }
  }, Vm;
}
var Wm = {}, Joe;
function Cwt() {
  if (Joe) return Wm;
  Joe = 1, Object.defineProperty(Wm, "__esModule", { value: !0 }), Wm.strikeThroughCommand = void 0;
  var t = Ls();
  return Wm.strikeThroughCommand = {
    buttonProps: { "aria-label": "Add strikethrough text" },
    execute: function(e) {
      var n = e.initialState, r = e.textApi, o = t.selectWord({
        text: n.text,
        selection: n.selection
      }), i = r.setSelectionRange(o), s = r.replaceSelection("~~" + i.selectedText + "~~");
      r.setSelectionRange({
        start: s.selection.end - 2 - i.selectedText.length,
        end: s.selection.end - 2
      });
    }
  }, Wm;
}
var Gm = {}, eie;
function kwt() {
  if (eie) return Gm;
  eie = 1, Object.defineProperty(Gm, "__esModule", { value: !0 }), Gm.linkCommand = void 0;
  var t = Ls();
  return Gm.linkCommand = {
    buttonProps: { "aria-label": "Add a link" },
    execute: function(e) {
      var n = e.initialState, r = e.textApi, o = t.selectWord({
        text: n.text,
        selection: n.selection
      }), i = r.setSelectionRange(o), s = r.replaceSelection("[" + i.selectedText + "](url)");
      r.setSelectionRange({
        start: s.selection.end - 6 - i.selectedText.length,
        end: s.selection.end - 6
      });
    },
    handleKeyCommand: function(e) {
      return (e.ctrlKey || e.metaKey) && e.key == "k";
    }
  }, Gm;
}
var Ym = {}, tie;
function Awt() {
  if (tie) return Ym;
  tie = 1, Object.defineProperty(Ym, "__esModule", { value: !0 }), Ym.quoteCommand = void 0;
  var t = Ls();
  return Ym.quoteCommand = {
    buttonProps: { "aria-label": "Insert a quote" },
    execute: function(e) {
      var n = e.initialState, r = e.textApi, o = t.selectWord({
        text: n.text,
        selection: n.selection
      }), i = r.setSelectionRange(o), s = t.getBreaksNeededForEmptyLineBefore(i.text, i.selection.start), a = Array(s + 1).join(`
`), l = t.getBreaksNeededForEmptyLineAfter(i.text, i.selection.end), c = Array(l + 1).join(`
`);
      r.replaceSelection(a + "> " + i.selectedText + c);
      var u = i.selection.start + s + 2, d = u + i.selectedText.length;
      r.setSelectionRange({
        start: u,
        end: d
      });
    }
  }, Ym;
}
var Km = {}, nie;
function Twt() {
  if (nie) return Km;
  nie = 1, Object.defineProperty(Km, "__esModule", { value: !0 }), Km.codeCommand = void 0;
  var t = Ls();
  return Km.codeCommand = {
    buttonProps: { "aria-label": "Insert code" },
    execute: function(e) {
      var n = e.initialState, r = e.textApi, o = t.selectWord({
        text: n.text,
        selection: n.selection
      }), i = r.setSelectionRange(o);
      if (i.selectedText.indexOf(`
`) === -1) {
        r.replaceSelection("`" + i.selectedText + "`");
        var s = i.selection.start + 1, a = s + i.selectedText.length;
        r.setSelectionRange({
          start: s,
          end: a
        });
        return;
      }
      var l = t.getBreaksNeededForEmptyLineBefore(i.text, i.selection.start), c = Array(l + 1).join(`
`), u = t.getBreaksNeededForEmptyLineAfter(i.text, i.selection.end), d = Array(u + 1).join(`
`);
      r.replaceSelection(c + "```\n" + i.selectedText + "\n```" + d);
      var f = i.selection.start + l + 4, h = f + i.selectedText.length;
      r.setSelectionRange({
        start: f,
        end: h
      });
    }
  }, Km;
}
var uD = {}, rie;
function Rwt() {
  return rie || (rie = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.checkedListCommand = t.orderedListCommand = t.unorderedListCommand = t.makeList = t.insertBeforeEachLine = void 0;
    var e = Ls();
    function n(o, i) {
      var s = o.split(/\n/), a = 0, l = s.map(function(c, u) {
        if (typeof i == "string")
          return a += i.length, i + c;
        if (typeof i == "function") {
          var d = i(c, u);
          return a += d.length, i(c, u) + c;
        }
        throw Error("insertion is expected to be either a string or a function");
      }).join(`
`);
      return { modifiedText: l, insertionLength: a };
    }
    t.insertBeforeEachLine = n;
    var r = function(o, i, s) {
      var a = e.selectWord({
        text: o.text,
        selection: o.selection
      }), l = i.setSelectionRange(a), c = e.getBreaksNeededForEmptyLineBefore(l.text, l.selection.start), u = Array(c + 1).join(`
`), d = e.getBreaksNeededForEmptyLineAfter(l.text, l.selection.end), f = Array(d + 1).join(`
`), h = n(l.selectedText, s);
      i.replaceSelection("" + u + h.modifiedText + f);
      var p = l.selectedText.indexOf(`
`) === -1 ? h.insertionLength : 0, m = l.selection.start + c + p, g = m + h.modifiedText.length - p;
      i.setSelectionRange({
        start: m,
        end: g
      });
    };
    t.makeList = r, t.unorderedListCommand = {
      buttonProps: { "aria-label": "Add unordered list" },
      execute: function(o) {
        var i = o.initialState, s = o.textApi;
        t.makeList(i, s, "- ");
      }
    }, t.orderedListCommand = {
      buttonProps: { "aria-label": "Add ordered list" },
      execute: function(o) {
        var i = o.initialState, s = o.textApi;
        t.makeList(i, s, function(a, l) {
          return l + 1 + ". ";
        });
      }
    }, t.checkedListCommand = {
      buttonProps: { "aria-label": "Add checked list" },
      execute: function(o) {
        var i = o.initialState, s = o.textApi;
        t.makeList(i, s, function(a, l) {
          return "- [ ] ";
        });
      }
    };
  }(uD)), uD;
}
var Xm = {}, oie;
function Pwt() {
  if (oie) return Xm;
  oie = 1, Object.defineProperty(Xm, "__esModule", { value: !0 }), Xm.imageCommand = void 0;
  var t = Ls();
  return Xm.imageCommand = {
    buttonProps: { "aria-label": "Add image" },
    execute: function(e) {
      var n = e.initialState, r = e.textApi, o = r.setSelectionRange(t.selectWord({
        text: n.text,
        selection: n.selection
      })), i = o.selectedText || "https://example.com/your-image.png";
      r.replaceSelection("![](" + i + ")"), r.setSelectionRange({
        start: o.selection.start + 4,
        end: o.selection.start + 4 + i.length
      });
    }
  }, Xm;
}
var Ka = {}, Xa = {}, iie;
function $wt() {
  if (iie) return Xa;
  iie = 1;
  var t = Xa && Xa.__awaiter || function(r, o, i, s) {
    function a(l) {
      return l instanceof i ? l : new i(function(c) {
        c(l);
      });
    }
    return new (i || (i = Promise))(function(l, c) {
      function u(h) {
        try {
          f(s.next(h));
        } catch (p) {
          c(p);
        }
      }
      function d(h) {
        try {
          f(s.throw(h));
        } catch (p) {
          c(p);
        }
      }
      function f(h) {
        h.done ? l(h.value) : a(h.value).then(u, d);
      }
      f((s = s.apply(r, o || [])).next());
    });
  }, e = Xa && Xa.__generator || function(r, o) {
    var i = { label: 0, sent: function() {
      if (l[0] & 1) throw l[1];
      return l[1];
    }, trys: [], ops: [] }, s, a, l, c;
    return c = { next: u(0), throw: u(1), return: u(2) }, typeof Symbol == "function" && (c[Symbol.iterator] = function() {
      return this;
    }), c;
    function u(f) {
      return function(h) {
        return d([f, h]);
      };
    }
    function d(f) {
      if (s) throw new TypeError("Generator is already executing.");
      for (; i; ) try {
        if (s = 1, a && (l = f[0] & 2 ? a.return : f[0] ? a.throw || ((l = a.return) && l.call(a), 0) : a.next) && !(l = l.call(a, f[1])).done) return l;
        switch (a = 0, l && (f = [f[0] & 2, l.value]), f[0]) {
          case 0:
          case 1:
            l = f;
            break;
          case 4:
            return i.label++, { value: f[1], done: !1 };
          case 5:
            i.label++, a = f[1], f = [0];
            continue;
          case 7:
            f = i.ops.pop(), i.trys.pop();
            continue;
          default:
            if (l = i.trys, !(l = l.length > 0 && l[l.length - 1]) && (f[0] === 6 || f[0] === 2)) {
              i = 0;
              continue;
            }
            if (f[0] === 3 && (!l || f[1] > l[0] && f[1] < l[3])) {
              i.label = f[1];
              break;
            }
            if (f[0] === 6 && i.label < l[1]) {
              i.label = l[1], l = f;
              break;
            }
            if (l && i.label < l[2]) {
              i.label = l[2], i.ops.push(f);
              break;
            }
            l[2] && i.ops.pop(), i.trys.pop();
            continue;
        }
        f = o.call(r, i);
      } catch (h) {
        f = [6, h], a = 0;
      } finally {
        s = l = 0;
      }
      if (f[0] & 5) throw f[1];
      return { value: f[0] ? f[1] : void 0, done: !0 };
    }
  };
  Object.defineProperty(Xa, "__esModule", { value: !0 }), Xa.readFileAsync = void 0;
  function n(r) {
    return t(this, void 0, void 0, function() {
      return e(this, function(o) {
        return [2, new Promise(function(i, s) {
          var a = new FileReader();
          a.onload = function() {
            if (typeof a.result == "string")
              throw new Error("reader.result is expected to be an ArrayBuffer");
            i(a.result);
          }, a.onerror = s, a.readAsArrayBuffer(r);
        })];
      });
    });
  }
  return Xa.readFileAsync = n, Xa;
}
var sie;
function Mwt() {
  if (sie) return Ka;
  sie = 1;
  var t = Ka && Ka.__awaiter || function(c, u, d, f) {
    function h(p) {
      return p instanceof d ? p : new d(function(m) {
        m(p);
      });
    }
    return new (d || (d = Promise))(function(p, m) {
      function g(b) {
        try {
          v(f.next(b));
        } catch (_) {
          m(_);
        }
      }
      function y(b) {
        try {
          v(f.throw(b));
        } catch (_) {
          m(_);
        }
      }
      function v(b) {
        b.done ? p(b.value) : h(b.value).then(g, y);
      }
      v((f = f.apply(c, u || [])).next());
    });
  }, e = Ka && Ka.__generator || function(c, u) {
    var d = { label: 0, sent: function() {
      if (p[0] & 1) throw p[1];
      return p[1];
    }, trys: [], ops: [] }, f, h, p, m;
    return m = { next: g(0), throw: g(1), return: g(2) }, typeof Symbol == "function" && (m[Symbol.iterator] = function() {
      return this;
    }), m;
    function g(v) {
      return function(b) {
        return y([v, b]);
      };
    }
    function y(v) {
      if (f) throw new TypeError("Generator is already executing.");
      for (; d; ) try {
        if (f = 1, h && (p = v[0] & 2 ? h.return : v[0] ? h.throw || ((p = h.return) && p.call(h), 0) : h.next) && !(p = p.call(h, v[1])).done) return p;
        switch (h = 0, p && (v = [v[0] & 2, p.value]), v[0]) {
          case 0:
          case 1:
            p = v;
            break;
          case 4:
            return d.label++, { value: v[1], done: !1 };
          case 5:
            d.label++, h = v[1], v = [0];
            continue;
          case 7:
            v = d.ops.pop(), d.trys.pop();
            continue;
          default:
            if (p = d.trys, !(p = p.length > 0 && p[p.length - 1]) && (v[0] === 6 || v[0] === 2)) {
              d = 0;
              continue;
            }
            if (v[0] === 3 && (!p || v[1] > p[0] && v[1] < p[3])) {
              d.label = v[1];
              break;
            }
            if (v[0] === 6 && d.label < p[1]) {
              d.label = p[1], p = v;
              break;
            }
            if (p && d.label < p[2]) {
              d.label = p[2], d.ops.push(v);
              break;
            }
            p[2] && d.ops.pop(), d.trys.pop();
            continue;
        }
        v = u.call(c, d);
      } catch (b) {
        v = [6, b], h = 0;
      } finally {
        f = p = 0;
      }
      if (v[0] & 5) throw v[1];
      return { value: v[0] ? v[1] : void 0, done: !0 };
    }
  };
  Object.defineProperty(Ka, "__esModule", { value: !0 }), Ka.saveImageCommand = void 0;
  var n = $wt(), r = Ls();
  function o(c) {
    var u = [];
    for (var d in c) {
      var f = c[d];
      f.kind === "file" && u.push(f.getAsFile());
    }
    return u;
  }
  function i(c) {
    for (var u = [], d = 0; d < c.length; d++)
      u.push(c[0]);
    return u;
  }
  function s(c, u) {
    var d = u.multiple, f = u.accept, h = c;
    if (d || (h = h.slice(0, 1)), f) {
      var p = f.split(","), m = new Set(p.filter(function(v) {
        return /^\.\w+/.test(v);
      }).map(function(v) {
        return v.split(".")[1];
      })), g = new Set(p.filter(function(v) {
        return /^[-\w.]+\/[-\w.]+$/.test(v);
      })), y = new Set(p.filter(function(v) {
        return /(audio|video|image)\/\*/.test(v);
      }).map(function(v) {
        return v.split("/")[0];
      }));
      h = h.filter(function(v) {
        return m.has(v.name.split(".")[1]) || g.has(v.type) || y.has(v.type.split("/")[0]);
      });
    }
    return h;
  }
  Ka.saveImageCommand = {
    execute: function(c) {
      c.initialState;
      var u = c.textApi, d = c.context, f = c.l18n;
      return t(this, void 0, void 0, function() {
        var h, p, m, g, y, v, b, _, w, x, E, S, C, R, P, N, A, O, k, T, I, j, z, $;
        return e(this, function(D) {
          switch (D.label) {
            case 0:
              if (!d)
                throw new Error("wrong context");
              h = d, p = h.event, m = h.pasteOptions, g = m.saveImage, y = m.multiple, v = m.accept, b = a(d) ? o(p.clipboardData.items) : l(d) ? o(p.dataTransfer.items) : i(p.target.files), _ = s(b, { multiple: y, accept: v }), w = [];
              for (x in _)
                w.push(x);
              E = 0, D.label = 1;
            case 1:
              return E < w.length ? (S = w[E], C = u.getState(), R = r.getBreaksNeededForEmptyLineBefore(C.text, C.selection.start), P = Array(R + 1).join(`
`), N = P + "![" + f.uploadingImage + "]()", u.replaceSelection(N), A = b[S], [4, n.readFileAsync(A)]) : [3, 5];
            case 2:
              return O = D.sent(), k = g(O, A), [4, k.next()];
            case 3:
              T = D.sent().value, I = u.getState(), j = I.text.substr(C.selection.start, N.length), j === N && (u.setSelectionRange({
                start: C.selection.start,
                end: C.selection.start + N.length
              }), z = T ? P + "![image](" + T + ")" : "", $ = z.length - N.length, u.replaceSelection(z), u.setSelectionRange({
                start: I.selection.start + $,
                end: I.selection.end + $
              })), D.label = 4;
            case 4:
              return E++, [3, 1];
            case 5:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }
  };
  function a(c) {
    return c.event.clipboardData !== void 0;
  }
  function l(c) {
    return c.event.dataTransfer !== void 0;
  }
  return Ka;
}
var aie;
function n9() {
  if (aie) return Ya;
  aie = 1, Object.defineProperty(Ya, "__esModule", { value: !0 }), Ya.getDefaultSaveImageCommandName = Ya.getDefaultCommandMap = Ya.getDefaultToolbarCommands = void 0;
  var t = Ewt(), e = Swt(), n = Owt(), r = Cwt(), o = kwt(), i = Awt(), s = Twt(), a = Rwt(), l = Pwt(), c = Mwt();
  function u() {
    return [
      ["header", "bold", "italic", "strikethrough"],
      ["link", "quote", "code", "image"],
      ["unordered-list", "ordered-list", "checked-list"]
    ];
  }
  Ya.getDefaultToolbarCommands = u;
  function d() {
    return {
      header: t.headerCommand,
      bold: e.boldCommand,
      italic: n.italicCommand,
      strikethrough: r.strikeThroughCommand,
      link: o.linkCommand,
      quote: i.quoteCommand,
      code: s.codeCommand,
      image: l.imageCommand,
      "unordered-list": a.unorderedListCommand,
      "ordered-list": a.orderedListCommand,
      "checked-list": a.checkedListCommand,
      "save-image": c.saveImageCommand
    };
  }
  Ya.getDefaultCommandMap = d;
  function f() {
    return "save-image";
  }
  return Ya.getDefaultSaveImageCommandName = f, Ya;
}
var Qm = {}, lie;
function Dwt() {
  return lie || (lie = 1, Object.defineProperty(Qm, "__esModule", { value: !0 }), Qm.enL18n = void 0, Qm.enL18n = {
    write: "Write",
    preview: "Preview",
    uploadingImage: "Uploading image...",
    pasteDropSelect: "Attach files by dragging & dropping, selecting or pasting them."
  }), Qm;
}
var Ru = {}, Zm = {}, cie;
function Iwt() {
  if (cie) return Zm;
  cie = 1, Object.defineProperty(Zm, "__esModule", { value: !0 }), Zm.SvgIcon = void 0;
  var t = xe, e = t.createElement(
    "svg",
    { className: "svg-icon", "aria-hidden": "true", "data-prefix": "fas", "data-icon": "tasks", role: "img", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 512 512", "data-fa-i2svg": "" },
    t.createElement("path", { fill: "currentColor", d: "M208 132h288c8.8 0 16-7.2 16-16V76c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16v40c0 8.8 7.2 16 16 16zm0 160h288c8.8 0 16-7.2 16-16v-40c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16v40c0 8.8 7.2 16 16 16zm0 160h288c8.8 0 16-7.2 16-16v-40c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16v40c0 8.8 7.2 16 16 16zM64 368c-26.5 0-48.6 21.5-48.6 48s22.1 48 48.6 48 48-21.5 48-48-21.5-48-48-48zm92.5-299l-72.2 72.2-15.6 15.6c-4.7 4.7-12.9 4.7-17.6 0L3.5 109.4c-4.7-4.7-4.7-12.3 0-17l15.7-15.7c4.7-4.7 12.3-4.7 17 0l22.7 22.1 63.7-63.3c4.7-4.7 12.3-4.7 17 0l17 16.5c4.6 4.7 4.6 12.3-.1 17zm0 159.6l-72.2 72.2-15.7 15.7c-4.7 4.7-12.9 4.7-17.6 0L3.5 269c-4.7-4.7-4.7-12.3 0-17l15.7-15.7c4.7-4.7 12.3-4.7 17 0l22.7 22.1 63.7-63.7c4.7-4.7 12.3-4.7 17 0l17 17c4.6 4.6 4.6 12.2-.1 16.9z" })
  ), n = t.createElement(
    "svg",
    { className: "svg-icon", "aria-hidden": "true", "data-prefix": "fas", "data-icon": "list-ol", role: "img", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 512 512", "data-fa-i2svg": "" },
    t.createElement("path", { fill: "currentColor", d: "M3.263 139.527c0-7.477 3.917-11.572 11.573-11.572h15.131V88.078c0-5.163.534-10.503.534-10.503h-.356s-1.779 2.67-2.848 3.738c-4.451 4.273-10.504 4.451-15.666-1.068l-5.518-6.231c-5.342-5.341-4.984-11.216.534-16.379l21.72-19.938C32.815 33.602 36.732 32 42.785 32H54.89c7.656 0 11.749 3.916 11.749 11.572v84.384h15.488c7.655 0 11.572 4.094 11.572 11.572v8.901c0 7.477-3.917 11.572-11.572 11.572H14.836c-7.656 0-11.573-4.095-11.573-11.572v-8.902zM2.211 304.591c0-47.278 50.955-56.383 50.955-69.165 0-7.18-5.954-8.755-9.28-8.755-3.153 0-6.479 1.051-9.455 3.852-5.079 4.903-10.507 7.004-16.111 2.451l-8.579-6.829c-5.779-4.553-7.18-9.805-2.803-15.409C13.592 201.981 26.025 192 47.387 192c19.437 0 44.476 10.506 44.476 39.573 0 38.347-46.753 46.402-48.679 56.909h39.049c7.529 0 11.557 4.027 11.557 11.382v8.755c0 7.354-4.028 11.382-11.557 11.382h-67.94c-7.005 0-12.083-4.028-12.083-11.382v-4.028zM5.654 454.61l5.603-9.28c3.853-6.654 9.105-7.004 15.584-3.152 4.903 2.101 9.63 3.152 14.359 3.152 10.155 0 14.358-3.502 14.358-8.23 0-6.654-5.604-9.106-15.934-9.106h-4.728c-5.954 0-9.28-2.101-12.258-7.88l-1.05-1.926c-2.451-4.728-1.226-9.806 2.801-14.884l5.604-7.004c6.829-8.405 12.257-13.483 12.257-13.483v-.35s-4.203 1.051-12.608 1.051H16.685c-7.53 0-11.383-4.028-11.383-11.382v-8.755c0-7.53 3.853-11.382 11.383-11.382h58.484c7.529 0 11.382 4.027 11.382 11.382v3.327c0 5.778-1.401 9.806-5.079 14.183l-17.509 20.137c19.611 5.078 28.716 20.487 28.716 34.845 0 21.363-14.358 44.126-48.503 44.126-16.636 0-28.192-4.728-35.896-9.455-5.779-4.202-6.304-9.805-2.626-15.934zM144 132h352c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H144c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h352c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H144c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h352c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H144c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z" })
  ), r = t.createElement(
    "svg",
    { className: "svg-icon", "aria-hidden": "true", "data-prefix": "fas", "data-icon": "list-ul", role: "img", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 512 512", "data-fa-i2svg": "" },
    t.createElement("path", { fill: "currentColor", d: "M96 96c0 26.51-21.49 48-48 48S0 122.51 0 96s21.49-48 48-48 48 21.49 48 48zM48 208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm0 160c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm96-236h352c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H144c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h352c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H144c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h352c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H144c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z" })
  ), o = t.createElement(
    "svg",
    { className: "svg-icon", "aria-hidden": "true", "data-prefix": "fas", "data-icon": "image", role: "img", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 512 512", "data-fa-i2svg": "" },
    t.createElement("path", { fill: "currentColor", d: "M464 448H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h416c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48zM112 120c-30.928 0-56 25.072-56 56s25.072 56 56 56 56-25.072 56-56-25.072-56-56-56zM64 384h384V272l-87.515-87.515c-4.686-4.686-12.284-4.686-16.971 0L208 320l-55.515-55.515c-4.686-4.686-12.284-4.686-16.971 0L64 336v48z" })
  ), i = t.createElement(
    "svg",
    { className: "svg-icon", "aria-hidden": "true", "data-prefix": "fas", "data-icon": "code", role: "img", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 640 512", "data-fa-i2svg": "" },
    t.createElement("path", { fill: "currentColor", d: "M278.9 511.5l-61-17.7c-6.4-1.8-10-8.5-8.2-14.9L346.2 8.7c1.8-6.4 8.5-10 14.9-8.2l61 17.7c6.4 1.8 10 8.5 8.2 14.9L293.8 503.3c-1.9 6.4-8.5 10.1-14.9 8.2zm-114-112.2l43.5-46.4c4.6-4.9 4.3-12.7-.8-17.2L117 256l90.6-79.7c5.1-4.5 5.5-12.3.8-17.2l-43.5-46.4c-4.5-4.8-12.1-5.1-17-.5L3.8 247.2c-5.1 4.7-5.1 12.8 0 17.5l144.1 135.1c4.9 4.6 12.5 4.4 17-.5zm327.2.6l144.1-135.1c5.1-4.7 5.1-12.8 0-17.5L492.1 112.1c-4.8-4.5-12.4-4.3-17 .5L431.6 159c-4.6 4.9-4.3 12.7.8 17.2L523 256l-90.6 79.7c-5.1 4.5-5.5 12.3-.8 17.2l43.5 46.4c4.5 4.9 12.1 5.1 17 .6z" })
  ), s = t.createElement(
    "svg",
    { className: "svg-icon", "aria-hidden": "true", "data-prefix": "fas", "data-icon": "quote-right", role: "img", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 512 512", "data-fa-i2svg": "" },
    t.createElement("path", { fill: "currentColor", d: "M512 80v128c0 137.018-63.772 236.324-193.827 271.172-15.225 4.08-30.173-7.437-30.173-23.199v-33.895c0-10.057 6.228-19.133 15.687-22.55C369.684 375.688 408 330.054 408 256h-72c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h128c26.51 0 48 21.49 48 48zM176 32H48C21.49 32 0 53.49 0 80v128c0 26.51 21.49 48 48 48h72c0 74.054-38.316 119.688-104.313 143.528C6.228 402.945 0 412.021 0 422.078v33.895c0 15.762 14.948 27.279 30.173 23.199C160.228 444.324 224 345.018 224 208V80c0-26.51-21.49-48-48-48z" })
  ), a = t.createElement(
    "svg",
    { className: "svg-icon", "aria-hidden": "true", "data-prefix": "fas", "data-icon": "link", role: "img", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 512 512", "data-fa-i2svg": "" },
    t.createElement("path", { fill: "currentColor", d: "M326.612 185.391c59.747 59.809 58.927 155.698.36 214.59-.11.12-.24.25-.36.37l-67.2 67.2c-59.27 59.27-155.699 59.262-214.96 0-59.27-59.26-59.27-155.7 0-214.96l37.106-37.106c9.84-9.84 26.786-3.3 27.294 10.606.648 17.722 3.826 35.527 9.69 52.721 1.986 5.822.567 12.262-3.783 16.612l-13.087 13.087c-28.026 28.026-28.905 73.66-1.155 101.96 28.024 28.579 74.086 28.749 102.325.51l67.2-67.19c28.191-28.191 28.073-73.757 0-101.83-3.701-3.694-7.429-6.564-10.341-8.569a16.037 16.037 0 0 1-6.947-12.606c-.396-10.567 3.348-21.456 11.698-29.806l21.054-21.055c5.521-5.521 14.182-6.199 20.584-1.731a152.482 152.482 0 0 1 20.522 17.197zM467.547 44.449c-59.261-59.262-155.69-59.27-214.96 0l-67.2 67.2c-.12.12-.25.25-.36.37-58.566 58.892-59.387 154.781.36 214.59a152.454 152.454 0 0 0 20.521 17.196c6.402 4.468 15.064 3.789 20.584-1.731l21.054-21.055c8.35-8.35 12.094-19.239 11.698-29.806a16.037 16.037 0 0 0-6.947-12.606c-2.912-2.005-6.64-4.875-10.341-8.569-28.073-28.073-28.191-73.639 0-101.83l67.2-67.19c28.239-28.239 74.3-28.069 102.325.51 27.75 28.3 26.872 73.934-1.155 101.96l-13.087 13.087c-4.35 4.35-5.769 10.79-3.783 16.612 5.864 17.194 9.042 34.999 9.69 52.721.509 13.906 17.454 20.446 27.294 10.606l37.106-37.106c59.271-59.259 59.271-155.699.001-214.959z" })
  ), l = t.createElement(
    "svg",
    { className: "svg-icon", "aria-hidden": "true", "data-prefix": "fas", "data-icon": "strikethrough", role: "img", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 512 512", "data-fa-i2svg": "" },
    t.createElement("path", { fill: "currentColor", d: "M496 288H16c-8.837 0-16-7.163-16-16v-32c0-8.837 7.163-16 16-16h480c8.837 0 16 7.163 16 16v32c0 8.837-7.163 16-16 16zm-214.666 16c27.258 12.937 46.524 28.683 46.524 56.243 0 33.108-28.977 53.676-75.621 53.676-32.325 0-76.874-12.08-76.874-44.271V368c0-8.837-7.164-16-16-16H113.75c-8.836 0-16 7.163-16 16v19.204c0 66.845 77.717 101.82 154.487 101.82 88.578 0 162.013-45.438 162.013-134.424 0-19.815-3.618-36.417-10.143-50.6H281.334zm-30.952-96c-32.422-13.505-56.836-28.946-56.836-59.683 0-33.92 30.901-47.406 64.962-47.406 42.647 0 64.962 16.593 64.962 32.985V136c0 8.837 7.164 16 16 16h45.613c8.836 0 16-7.163 16-16v-30.318c0-52.438-71.725-79.875-142.575-79.875-85.203 0-150.726 40.972-150.726 125.646 0 22.71 4.665 41.176 12.777 56.547h129.823z" })
  ), c = t.createElement(
    "svg",
    { className: "svg-icon", "aria-hidden": "true", "data-prefix": "fas", "data-icon": "italic", role: "img", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 320 512", "data-fa-i2svg": "" },
    t.createElement("path", { fill: "currentColor", d: "M204.758 416h-33.849l62.092-320h40.725a16 16 0 0 0 15.704-12.937l6.242-32C297.599 41.184 290.034 32 279.968 32H120.235a16 16 0 0 0-15.704 12.937l-6.242 32C96.362 86.816 103.927 96 113.993 96h33.846l-62.09 320H46.278a16 16 0 0 0-15.704 12.935l-6.245 32C22.402 470.815 29.967 480 40.034 480h158.479a16 16 0 0 0 15.704-12.935l6.245-32c1.927-9.88-5.638-19.065-15.704-19.065z" })
  ), u = t.createElement(
    "svg",
    { className: "svg-icon", "aria-hidden": "true", "data-prefix": "fas", "data-icon": "heading", role: "img", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 512 512", "data-fa-i2svg": "" },
    t.createElement("path", { fill: "currentColor", d: "M496 80V48c0-8.837-7.163-16-16-16H320c-8.837 0-16 7.163-16 16v32c0 8.837 7.163 16 16 16h37.621v128H154.379V96H192c8.837 0 16-7.163 16-16V48c0-8.837-7.163-16-16-16H32c-8.837 0-16 7.163-16 16v32c0 8.837 7.163 16 16 16h37.275v320H32c-8.837 0-16 7.163-16 16v32c0 8.837 7.163 16 16 16h160c8.837 0 16-7.163 16-16v-32c0-8.837-7.163-16-16-16h-37.621V288H357.62v128H320c-8.837 0-16 7.163-16 16v32c0 8.837 7.163 16 16 16h160c8.837 0 16-7.163 16-16v-32c0-8.837-7.163-16-16-16h-37.275V96H480c8.837 0 16-7.163 16-16z" })
  ), d = t.createElement(
    "svg",
    { className: "svg-icon", "aria-hidden": "true", "data-prefix": "fas", "data-icon": "bold", role: "img", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 384 512", "data-fa-i2svg": "" },
    t.createElement("path", { fill: "currentColor", d: "M304.793 243.891c33.639-18.537 53.657-54.16 53.657-95.693 0-48.236-26.25-87.626-68.626-104.179C265.138 34.01 240.849 32 209.661 32H24c-8.837 0-16 7.163-16 16v33.049c0 8.837 7.163 16 16 16h33.113v318.53H24c-8.837 0-16 7.163-16 16V464c0 8.837 7.163 16 16 16h195.69c24.203 0 44.834-1.289 66.866-7.584C337.52 457.193 376 410.647 376 350.014c0-52.168-26.573-91.684-71.207-106.123zM142.217 100.809h67.444c16.294 0 27.536 2.019 37.525 6.717 15.828 8.479 24.906 26.502 24.906 49.446 0 35.029-20.32 56.79-53.029 56.79h-76.846V100.809zm112.642 305.475c-10.14 4.056-22.677 4.907-31.409 4.907h-81.233V281.943h84.367c39.645 0 63.057 25.38 63.057 63.057.001 28.425-13.66 52.483-34.782 61.284z" })
  ), f = function(h) {
    var p = h.icon;
    switch (p) {
      case "header":
        return u;
      case "bold":
        return d;
      case "italic":
        return c;
      case "strikethrough":
        return l;
      case "link":
        return a;
      case "quote":
        return s;
      case "code":
        return i;
      case "image":
        return o;
      case "unordered-list":
        return r;
      case "ordered-list":
        return n;
      case "checked-list":
        return e;
      default:
        return null;
    }
  };
  return Zm.SvgIcon = f, Zm;
}
var uie;
function b_e() {
  return uie || (uie = 1, function(t) {
    var e = Ru && Ru.__createBinding || (Object.create ? function(r, o, i, s) {
      s === void 0 && (s = i), Object.defineProperty(r, s, { enumerable: !0, get: function() {
        return o[i];
      } });
    } : function(r, o, i, s) {
      s === void 0 && (s = i), r[s] = o[i];
    }), n = Ru && Ru.__exportStar || function(r, o) {
      for (var i in r) i !== "default" && !Object.prototype.hasOwnProperty.call(o, i) && e(o, r, i);
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), n(g_e(), t), n(Iwt(), t);
  }(Ru)), Ru;
}
var wo = {}, Jm = {}, die;
function Nwt() {
  if (die) return Jm;
  die = 1, Object.defineProperty(Jm, "__esModule", { value: !0 }), Jm.extractKeyActivatedCommands = void 0;
  function t(e) {
    var n = [];
    for (var r in e)
      e.hasOwnProperty(r) && e[r].handleKeyCommand && n.push(r);
    return n;
  }
  return Jm.extractKeyActivatedCommands = t, Jm;
}
var fie;
function jwt() {
  if (fie) return wo;
  fie = 1;
  var t = wo && wo.__assign || function() {
    return t = Object.assign || function(u) {
      for (var d, f = 1, h = arguments.length; f < h; f++) {
        d = arguments[f];
        for (var p in d) Object.prototype.hasOwnProperty.call(d, p) && (u[p] = d[p]);
      }
      return u;
    }, t.apply(this, arguments);
  }, e = wo && wo.__awaiter || function(u, d, f, h) {
    function p(m) {
      return m instanceof f ? m : new f(function(g) {
        g(m);
      });
    }
    return new (f || (f = Promise))(function(m, g) {
      function y(_) {
        try {
          b(h.next(_));
        } catch (w) {
          g(w);
        }
      }
      function v(_) {
        try {
          b(h.throw(_));
        } catch (w) {
          g(w);
        }
      }
      function b(_) {
        _.done ? m(_.value) : p(_.value).then(y, v);
      }
      b((h = h.apply(u, d || [])).next());
    });
  }, n = wo && wo.__generator || function(u, d) {
    var f = { label: 0, sent: function() {
      if (m[0] & 1) throw m[1];
      return m[1];
    }, trys: [], ops: [] }, h, p, m, g;
    return g = { next: y(0), throw: y(1), return: y(2) }, typeof Symbol == "function" && (g[Symbol.iterator] = function() {
      return this;
    }), g;
    function y(b) {
      return function(_) {
        return v([b, _]);
      };
    }
    function v(b) {
      if (h) throw new TypeError("Generator is already executing.");
      for (; f; ) try {
        if (h = 1, p && (m = b[0] & 2 ? p.return : b[0] ? p.throw || ((m = p.return) && m.call(p), 0) : p.next) && !(m = m.call(p, b[1])).done) return m;
        switch (p = 0, m && (b = [b[0] & 2, m.value]), b[0]) {
          case 0:
          case 1:
            m = b;
            break;
          case 4:
            return f.label++, { value: b[1], done: !1 };
          case 5:
            f.label++, p = b[1], b = [0];
            continue;
          case 7:
            b = f.ops.pop(), f.trys.pop();
            continue;
          default:
            if (m = f.trys, !(m = m.length > 0 && m[m.length - 1]) && (b[0] === 6 || b[0] === 2)) {
              f = 0;
              continue;
            }
            if (b[0] === 3 && (!m || b[1] > m[0] && b[1] < m[3])) {
              f.label = b[1];
              break;
            }
            if (b[0] === 6 && f.label < m[1]) {
              f.label = m[1], m = b;
              break;
            }
            if (m && f.label < m[2]) {
              f.label = m[2], f.ops.push(b);
              break;
            }
            m[2] && f.ops.pop(), f.trys.pop();
            continue;
        }
        b = d.call(u, f);
      } catch (_) {
        b = [6, _], p = 0;
      } finally {
        h = m = 0;
      }
      if (b[0] & 5) throw b[1];
      return { value: b[0] ? b[1] : void 0, done: !0 };
    }
  };
  Object.defineProperty(wo, "__esModule", { value: !0 }), wo.CommandOrchestrator = wo.getStateFromTextArea = wo.TextAreaTextApi = void 0;
  var r = w_e(), o = y_e(), i = Nwt(), s = n9(), a = (
    /** @class */
    function() {
      function u(d) {
        this.textAreaRef = d;
      }
      return u.prototype.replaceSelection = function(d) {
        var f = this.textAreaRef.current;
        return o.insertText(f, d), l(f);
      }, u.prototype.setSelectionRange = function(d) {
        var f = this.textAreaRef.current;
        return f.focus(), f.selectionStart = d.start, f.selectionEnd = d.end, l(f);
      }, u.prototype.getState = function() {
        var d = this.textAreaRef.current;
        return l(d);
      }, u;
    }()
  );
  wo.TextAreaTextApi = a;
  function l(u) {
    return {
      selection: {
        start: u.selectionStart,
        end: u.selectionEnd
      },
      text: u.value,
      selectedText: u.value.slice(u.selectionStart, u.selectionEnd)
    };
  }
  wo.getStateFromTextArea = l;
  var c = (
    /** @class */
    function() {
      function u(d, f, h, p) {
        var m = this;
        if (this.getCommand = function(g) {
          var y = m.commandMap[g];
          if (!y)
            throw new Error("Cannot execute command. Command not found: " + g);
          return y;
        }, this.handlePossibleKeyCommand = function(g) {
          for (var y = 0, v = m.keyActivatedCommands; y < v.length; y++) {
            var b = v[y];
            if (m.getCommand(b).handleKeyCommand(g))
              return m.executeCommand(b).then(function(_) {
              }), !0;
          }
          return !1;
        }, p && !p.saveImage)
          throw new Error("paste options are incomplete. saveImage are required ");
        this.commandMap = t(t({}, r.getDefaultCommandMap()), d || {}), this.pasteOptions = p, this.keyActivatedCommands = i.extractKeyActivatedCommands(d), this.textAreaRef = f, this.textApi = new a(f), this.l18n = h;
      }
      return u.prototype.executeCommand = function(d, f) {
        return e(this, void 0, void 0, function() {
          var h, p;
          return n(this, function(m) {
            switch (m.label) {
              case 0:
                return this.isExecuting ? [
                  2
                  /*return*/
                ] : (this.isExecuting = !0, h = this.commandMap[d], p = h.execute({
                  initialState: l(this.textAreaRef.current),
                  textApi: this.textApi,
                  l18n: this.l18n,
                  context: f
                }), [4, p]);
              case 1:
                return m.sent(), this.isExecuting = !1, [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, u.prototype.executePasteCommand = function(d) {
        return e(this, void 0, void 0, function() {
          return n(this, function(f) {
            return this.pasteOptions ? [2, this.executeCommand(this.pasteOptions.command || s.getDefaultSaveImageCommandName(), {
              pasteOptions: this.pasteOptions,
              event: d
            })] : [
              2
              /*return*/
            ];
          });
        });
      }, u.prototype.executeDropCommand = function(d) {
        return e(this, void 0, void 0, function() {
          return n(this, function(f) {
            return this.pasteOptions ? [2, this.executeCommand(this.pasteOptions.command || s.getDefaultSaveImageCommandName(), {
              pasteOptions: this.pasteOptions,
              event: d
            })] : [
              2
              /*return*/
            ];
          });
        });
      }, u.prototype.executeSelectImageCommand = function(d) {
        return e(this, void 0, void 0, function() {
          return n(this, function(f) {
            return this.pasteOptions ? [2, this.executeCommand(this.pasteOptions.command || s.getDefaultSaveImageCommandName(), {
              pasteOptions: this.pasteOptions,
              event: d
            })] : [
              2
              /*return*/
            ];
          });
        });
      }, u.prototype.getCommandByName = function(d) {
        return this.commandMap[d];
      }, u;
    }()
  );
  return wo.CommandOrchestrator = c, wo;
}
var hie;
function Lwt() {
  if (hie) return li;
  hie = 1;
  var t = li && li.__extends || /* @__PURE__ */ function() {
    var h = function(p, m) {
      return h = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(g, y) {
        g.__proto__ = y;
      } || function(g, y) {
        for (var v in y) Object.prototype.hasOwnProperty.call(y, v) && (g[v] = y[v]);
      }, h(p, m);
    };
    return function(p, m) {
      if (typeof m != "function" && m !== null)
        throw new TypeError("Class extends value " + String(m) + " is not a constructor or null");
      h(p, m);
      function g() {
        this.constructor = p;
      }
      p.prototype = m === null ? Object.create(m) : (g.prototype = m.prototype, new g());
    };
  }(), e = li && li.__assign || function() {
    return e = Object.assign || function(h) {
      for (var p, m = 1, g = arguments.length; m < g; m++) {
        p = arguments[m];
        for (var y in p) Object.prototype.hasOwnProperty.call(p, y) && (h[y] = p[y]);
      }
      return h;
    }, e.apply(this, arguments);
  }, n = li && li.__awaiter || function(h, p, m, g) {
    function y(v) {
      return v instanceof m ? v : new m(function(b) {
        b(v);
      });
    }
    return new (m || (m = Promise))(function(v, b) {
      function _(E) {
        try {
          x(g.next(E));
        } catch (S) {
          b(S);
        }
      }
      function w(E) {
        try {
          x(g.throw(E));
        } catch (S) {
          b(S);
        }
      }
      function x(E) {
        E.done ? v(E.value) : y(E.value).then(_, w);
      }
      x((g = g.apply(h, p || [])).next());
    });
  }, r = li && li.__generator || function(h, p) {
    var m = { label: 0, sent: function() {
      if (v[0] & 1) throw v[1];
      return v[1];
    }, trys: [], ops: [] }, g, y, v, b;
    return b = { next: _(0), throw: _(1), return: _(2) }, typeof Symbol == "function" && (b[Symbol.iterator] = function() {
      return this;
    }), b;
    function _(x) {
      return function(E) {
        return w([x, E]);
      };
    }
    function w(x) {
      if (g) throw new TypeError("Generator is already executing.");
      for (; m; ) try {
        if (g = 1, y && (v = x[0] & 2 ? y.return : x[0] ? y.throw || ((v = y.return) && v.call(y), 0) : y.next) && !(v = v.call(y, x[1])).done) return v;
        switch (y = 0, v && (x = [x[0] & 2, v.value]), x[0]) {
          case 0:
          case 1:
            v = x;
            break;
          case 4:
            return m.label++, { value: x[1], done: !1 };
          case 5:
            m.label++, y = x[1], x = [0];
            continue;
          case 7:
            x = m.ops.pop(), m.trys.pop();
            continue;
          default:
            if (v = m.trys, !(v = v.length > 0 && v[v.length - 1]) && (x[0] === 6 || x[0] === 2)) {
              m = 0;
              continue;
            }
            if (x[0] === 3 && (!v || x[1] > v[0] && x[1] < v[3])) {
              m.label = x[1];
              break;
            }
            if (x[0] === 6 && m.label < v[1]) {
              m.label = v[1], v = x;
              break;
            }
            if (v && m.label < v[2]) {
              m.label = v[2], m.ops.push(x);
              break;
            }
            v[2] && m.ops.pop(), m.trys.pop();
            continue;
        }
        x = p.call(h, m);
      } catch (E) {
        x = [6, E], y = 0;
      } finally {
        g = v = 0;
      }
      if (x[0] & 5) throw x[1];
      return { value: x[0] ? x[1] : void 0, done: !0 };
    }
  };
  Object.defineProperty(li, "__esModule", { value: !0 }), li.ReactMde = void 0;
  var o = xe, i = __e(), s = n9(), a = Dwt(), l = b_e(), c = qp(), u = jwt(), d = {
    accept: "image/*",
    multiple: !1
  }, f = (
    /** @class */
    function(h) {
      t(p, h);
      function p(m) {
        var g, y = h.call(this, m) || this;
        y.handleTextChange = function(b) {
          var _ = y.props.onChange;
          _(b);
        }, y.handlePaste = function(b) {
          return n(y, void 0, void 0, function() {
            var _;
            return r(this, function(w) {
              switch (w.label) {
                case 0:
                  return _ = this.props.paste, !_ || !_.saveImage ? [
                    2
                    /*return*/
                  ] : [4, this.commandOrchestrator.executePasteCommand(b)];
                case 1:
                  return w.sent(), [
                    2
                    /*return*/
                  ];
              }
            });
          });
        }, y.handleDrop = function(b) {
          return n(y, void 0, void 0, function() {
            var _;
            return r(this, function(w) {
              switch (w.label) {
                case 0:
                  return _ = this.props.paste, !_ || !_.saveImage ? [
                    2
                    /*return*/
                  ] : [4, this.commandOrchestrator.executeDropCommand(b)];
                case 1:
                  return w.sent(), [
                    2
                    /*return*/
                  ];
              }
            });
          });
        }, y.handleImageSelection = function(b) {
          return n(y, void 0, void 0, function() {
            var _;
            return r(this, function(w) {
              switch (w.label) {
                case 0:
                  return _ = this.props.paste, !_ || !_.saveImage ? [
                    2
                    /*return*/
                  ] : [4, this.commandOrchestrator.executeSelectImageCommand(b)];
                case 1:
                  return w.sent(), [
                    2
                    /*return*/
                  ];
              }
            });
          });
        }, y.handleTabChange = function(b) {
          var _ = y.props.onTabChange;
          _(b);
        }, y.handleCommand = function(b) {
          return n(y, void 0, void 0, function() {
            return r(this, function(_) {
              switch (_.label) {
                case 0:
                  return [4, this.commandOrchestrator.executeCommand(b)];
                case 1:
                  return _.sent(), [
                    2
                    /*return*/
                  ];
              }
            });
          });
        }, y.finalRefs = e({}, m.refs || {}), y.finalRefs.textarea || (y.finalRefs.textarea = o.createRef()), y.finalRefs.preview || (y.finalRefs.preview = o.createRef()), y.commandOrchestrator = new u.CommandOrchestrator(y.props.commands, y.finalRefs.textarea, y.props.l18n, y.props.paste ? e(e({}, d), y.props.paste) : void 0);
        var v = Math.min(m.maxEditorHeight, m.minEditorHeight);
        return y.state = {
          editorHeight: (g = m.initialEditorHeight) !== null && g !== void 0 ? g : v
        }, y;
      }
      return p.prototype.render = function() {
        var m = this, g, y, v = this.props, b = v.getIcon, _ = v.toolbarCommands, w = v.classes, x = v.loadingPreview, E = v.readOnly, S = v.disablePreview, C = v.value, R = v.l18n, P = v.minPreviewHeight, N = v.heightUnits, A = v.childProps, O = v.selectedTab, k = v.generateMarkdownPreview, T = v.loadSuggestions, I = v.suggestionTriggerCharacters, j = v.textAreaComponent, z = A || {}, $ = _.map(function(D) {
          return D.map(function(U) {
            var q = m.commandOrchestrator.getCommand(U);
            return {
              commandName: U,
              buttonContent: q.icon ? q.icon(b) : b(U),
              buttonProps: q.buttonProps,
              buttonComponentClass: q.buttonComponentClass
            };
          });
        });
        return o.createElement(
          "div",
          { className: c.classNames("react-mde", "react-mde-tabbed-layout", w?.reactMde) },
          o.createElement(i.Toolbar, { classes: w?.toolbar, buttons: $, onCommand: this.handleCommand, onTabChange: this.handleTabChange, tab: O, readOnly: E, disablePreview: S, l18n: R, buttonProps: z.commandButtons, writeButtonProps: z.writeButton, previewButtonProps: z.previewButton }),
          o.createElement(
            "div",
            { className: c.classNames({ invisible: O !== "write" }) },
            o.createElement(i.TextArea, { classes: w?.textArea, suggestionsDropdownClasses: w?.suggestionsDropdown, suggestionsAutoplace: this.props.suggestionsAutoplace, refObject: this.finalRefs.textarea, onChange: this.handleTextChange, onPaste: this.handlePaste, onDrop: this.handleDrop, readOnly: E, textAreaComponent: j, textAreaProps: A && A.textArea, height: this.state.editorHeight, heightUnits: this.props.heightUnits, value: C, suggestionTriggerCharacters: I, loadSuggestions: T, onPossibleKeyCommand: this.commandOrchestrator.handlePossibleKeyCommand }),
            this.props.paste && o.createElement(
              "label",
              { className: c.classNames("image-tip") },
              o.createElement("input", { className: c.classNames("image-input"), type: "file", accept: (g = this.props.paste.accept) !== null && g !== void 0 ? g : d.accept, multiple: (y = this.props.paste.multiple) !== null && y !== void 0 ? y : d.multiple, onChange: this.handleImageSelection }),
              o.createElement("span", null, R.pasteDropSelect)
            )
          ),
          O !== "write" && o.createElement(i.Preview, { classes: w?.preview, refObject: this.finalRefs.preview, loadingPreview: x, minHeight: P, heightUnits: N, generateMarkdownPreview: k, markdown: C })
        );
      }, p.defaultProps = {
        commands: s.getDefaultCommandMap(),
        toolbarCommands: s.getDefaultToolbarCommands(),
        getIcon: function(m) {
          return o.createElement(l.SvgIcon, { icon: m });
        },
        readOnly: !1,
        l18n: a.enL18n,
        minEditorHeight: 200,
        maxEditorHeight: 500,
        minPreviewHeight: 200,
        heightUnits: "px",
        selectedTab: "write",
        disablePreview: !1,
        suggestionTriggerCharacters: ["@"],
        suggestionsAutoplace: !1
      }, p;
    }(o.Component)
  );
  return li.ReactMde = f, li;
}
var pie;
function __e() {
  return pie || (pie = 1, function(t) {
    var e = ku && ku.__createBinding || (Object.create ? function(r, o, i, s) {
      s === void 0 && (s = i), Object.defineProperty(r, s, { enumerable: !0, get: function() {
        return o[i];
      } });
    } : function(r, o, i, s) {
      s === void 0 && (s = i), r[s] = o[i];
    }), n = ku && ku.__exportStar || function(r, o) {
      for (var i in r) i !== "default" && !Object.prototype.hasOwnProperty.call(o, i) && e(o, r, i);
    };
    Object.defineProperty(t, "__esModule", { value: !0 }), n(p_e(), t), n(m_e(), t), n(g_e(), t), n(vwt(), t), n(wwt(), t), n(xwt(), t), n(Lwt(), t), n(v_e(), t);
  }(ku)), ku;
}
var mie;
function w_e() {
  return mie || (mie = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.getDefaultToolbarCommands = t.getDefaultCommandMap = t.MdeFontAwesomeIcon = t.SvgIcon = t.MarkdownUtil = t.ToolbarButtonGroup = t.Toolbar = t.Preview = t.SuggestionsDropdown = t.TextArea = void 0;
    var e = Ls();
    t.MarkdownUtil = e;
    var n = __e();
    Object.defineProperty(t, "TextArea", { enumerable: !0, get: function() {
      return n.TextArea;
    } }), Object.defineProperty(t, "SuggestionsDropdown", { enumerable: !0, get: function() {
      return n.SuggestionsDropdown;
    } }), Object.defineProperty(t, "Preview", { enumerable: !0, get: function() {
      return n.Preview;
    } }), Object.defineProperty(t, "Toolbar", { enumerable: !0, get: function() {
      return n.Toolbar;
    } }), Object.defineProperty(t, "ToolbarButtonGroup", { enumerable: !0, get: function() {
      return n.ToolbarButtonGroup;
    } });
    var r = b_e();
    Object.defineProperty(t, "SvgIcon", { enumerable: !0, get: function() {
      return r.SvgIcon;
    } }), Object.defineProperty(t, "MdeFontAwesomeIcon", { enumerable: !0, get: function() {
      return r.MdeFontAwesomeIcon;
    } });
    var o = n9();
    Object.defineProperty(t, "getDefaultCommandMap", { enumerable: !0, get: function() {
      return o.getDefaultCommandMap;
    } }), Object.defineProperty(t, "getDefaultToolbarCommands", { enumerable: !0, get: function() {
      return o.getDefaultToolbarCommands;
    } }), t.default = n.ReactMde;
  }(cD)), cD;
}
w_e();
var Fwt = Object.defineProperty, x_e = (t) => {
  throw TypeError(t);
}, Bwt = (t, e, n) => e in t ? Fwt(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n, Gn = (t, e, n) => Bwt(t, typeof e != "symbol" ? e + "" : e, n), E_e = (t, e, n) => e.has(t) || x_e("Cannot " + n), gie = (t, e, n) => (E_e(t, e, "read from private field"), n ? n.call(t) : e.get(t)), zwt = (t, e, n) => e.has(t) ? x_e("Cannot add the same private member more than once") : e instanceof WeakSet ? e.add(t) : e.set(t, n), qwt = (t, e, n, r) => (E_e(t, e, "write to private field"), e.set(t, n), n), r9 = /* @__PURE__ */ ((t) => (t.black = "black", t.white = "white", t))(r9 || {}), fd = /* @__PURE__ */ ((t) => (t.CHECKED = "CHECKED", t.INTERMEDIATE = "INTERMEDIATE", t.BULK_CHECKED = "BULK_CHECKED", t))(fd || {}), o9 = /* @__PURE__ */ ((t) => (t.Large = "large", t.Medium = "medium", t.SMALL = "small", t))(o9 || {}), qc = /* @__PURE__ */ ((t) => (t.PRECD = "PRECD", t.CD = "CD", t.POSTCD = "POSTCD", t.APPROVAL = "APPROVAL", t))(qc || {}), S_e = /* @__PURE__ */ ((t) => (t.GIT = "GIT", t.CI = "CI", t.WEBHOOK = "WEBHOOK", t.PRE_CD = "PRECD", t.CD = "CD", t.POST_CD = "POSTCD", t))(S_e || {}), O_e = /* @__PURE__ */ ((t) => (t.HELM = "helm", t.ARGO_CD = "argocd", t.FLUX_CD = "fluxcd", t))(O_e || {}), Ng = /* @__PURE__ */ ((t) => (t.CLUSTERS = "clusters", t.ENVIRONMENTS = "environments", t.PROJECTS = "projects", t.APPLICATIONS = "applications", t))(Ng || {}), zw = /* @__PURE__ */ ((t) => (t.ITEM_NAME = "itemName", t.VIEW = "view", t.DETAIL = "detail", t))(zw || {}), C_e = /* @__PURE__ */ ((t) => (t.VOLUME_SNAPSHOT = "volume-snapshot", t.STORAGE = "storage", t))(C_e || {}), k_e = /* @__PURE__ */ ((t) => (t.Backups = "backups", t.Schedules = "schedules", t))(k_e || {});
const yie = 6e4, Uwt = window?.__ORCHESTRATOR_ROOT__ ?? "/orchestrator", i9 = "https://docs.devtron.ai", Hwt = "/devtron/v2.0", A_e = "https://discord.devtron.ai/", ul = "/application-management", dD = `${ul}/templates/devtron-app`, kf = `${ul}/configurations`, ac = "/infrastructure-management", Vwt = "/software-release-management", lc = "/cost-visibility", Pu = "/security-center", vie = "/automation-and-enablement", qf = "/data-protection-management", bie = `${qf}/backup-and-schedule/:view(${Object.values(k_e).join("|")})`, k_ = "/global-configuration", Up = {
  LOGIN: "/login",
  LOGIN_SSO: "/login/sso",
  APP_LIST: "list",
  CREATE_JOB: "create-job",
  GETTING_STARTED: "getting-started",
  STACK_MANAGER_ABOUT: "/stack-manager/about",
  APP_CI_DETAILS: "ci-details",
  LOGS: "Logs",
  CREATE: "/create",
  RELEASES: "/releases",
  DEVTRON_CHARTS: "dc",
  APP_DEPLOYMNENT_HISTORY: "deployments",
  APP_DETAILS: "details",
  APP_DETAILS_K8: "k8s-resources",
  // for V2
  DETAILS: "/details",
  CD_DETAILS: "cd-details",
  APP_TRIGGER: "trigger",
  DEPLOYMENT_HISTORY_CONFIGURATIONS: "/configuration",
  NETWORK_STATUS_INTERFACE: "/network-status-interface",
  COMPARE_CLUSTERS: "/compare-clusters",
  APP_CONFIG: "edit",
  LICENSE_AUTH: "/license-auth",
  // APPLICATION MANAGEMENT
  APPLICATION_MANAGEMENT: ul,
  APPLICATION_MANAGEMENT_OVERVIEW: `${ul}/overview`,
  APPLICATION_MANAGEMENT_APP: `${ul}/devtron-app`,
  APPLICATION_MANAGEMENT_APP_LIST: `${ul}/devtron-app/list`,
  APPLICATION_MANAGEMENT_CREATE_DEVTRON_APP: `${ul}/devtron-app/list/create-app`,
  APPLICATION_MANAGEMENT_APPLICATION_GROUP: `${ul}/application-group`,
  APPLICATION_MANAGEMENT_TEMPLATES_DEVTRON_APP: dD,
  APPLICATION_MANAGEMENT_TEMPLATES_DEVTRON_APP_CREATE: `${dD}/create`,
  // NOTE: using appId since we are re-using AppConfig component
  APPLICATION_MANAGEMENT_TEMPLATES_DEVTRON_APP_DETAIL: `${dD}/detail/:appId`,
  APPLICATION_MANAGEMENT_PROJECTS: `${ul}/projects`,
  APPLICATION_MANAGEMENT_CONFIGURATIONS: kf,
  APPLICATION_MANAGEMENT_CONFIGURATIONS_DEPLOYMENT_CHARTS: `${kf}/deployment-charts`,
  APPLICATION_MANAGEMENT_CONFIGURATIONS_SCOPED_VARIABLES: `${kf}/scoped-variables`,
  APPLICATION_MANAGEMENT_CONFIGURATIONS_BUILD_INFRA: `${kf}/build-infra`,
  APPLICATION_MANAGEMENT_CONFIGURATIONS_BUILD_INFRA_PROFILES: `${kf}/build-infra/profiles`,
  APPLICATION_MANAGEMENT_CONFIGURATIONS_NOTIFICATIONS: `${kf}/notifications`,
  // INFRASTRUCTURE MANAGEMENT
  INFRASTRUCTURE_MANAGEMENT: ac,
  INFRASTRUCTURE_MANAGEMENT_OVERVIEW: `${ac}/overview`,
  INFRASTRUCTURE_MANAGEMENT_APP_LIST: `${ac}/apps/:appType(${Object.values(O_e).join("|")})`,
  INFRASTRUCTURE_MANAGEMENT_APP: `${ac}/apps`,
  INFRASTRUCTURE_MANAGEMENT_CHART_STORE: `${ac}/chart-store`,
  INFRASTRUCTURE_MANAGEMENT_CHART_STORE_DISCOVER: `${ac}/chart-store/discover`,
  INFRASTRUCTURE_MANAGEMENT_RESOURCE_BROWSER: `${ac}/resource-browser`,
  INFRASTRUCTURE_MANAGEMENT_RESOURCE_WATCHER: `${ac}/resource-watcher`,
  // SOFTWARE RELEASE MANAGEMENT
  SOFTWARE_RELEASE_MANAGEMENT: Vwt,
  // COST VISIBILITY
  COST_VISIBILITY: lc,
  COST_VISIBILITY_OVERVIEW: `${lc}/overview`,
  COST_BREAKDOWN_ROUTE: `${lc}/breakdown/:breakdownViewType`,
  COST_BREAKDOWN_CLUSTERS: `${lc}/breakdown/${Ng.CLUSTERS}`,
  COST_BREAKDOWN_ENVIRONMENTS: `${lc}/breakdown/${Ng.ENVIRONMENTS}`,
  COST_BREAKDOWN_PROJECTS: `${lc}/breakdown/${Ng.PROJECTS}`,
  COST_BREAKDOWN_APPLICATIONS: `${lc}/breakdown/${Ng.APPLICATIONS}`,
  COST_BREAKDOWN_DETAIL: `:${zw.ITEM_NAME}/:${zw.VIEW}/:${zw.DETAIL}?`,
  COST_CONFIGURATIONS: `${lc}/configurations`,
  // SECURITY CENTER
  SECURITY_CENTER: Pu,
  SECURITY_CENTER_OVERVIEW: `${Pu}/overview`,
  SECURITY_CENTER_VULNERABILITIES: `${Pu}/vulnerabilities`,
  SECURITY_CENTER_VULNERABILITY_DEPLOYMENTS: `${Pu}/vulnerabilities/deployments`,
  SECURITY_CENTER_VULNERABILITY_CVES: `${Pu}/vulnerabilities/cves`,
  SECURITY_CENTER_SECURITY_ENABLEMENT: `${Pu}/security-enablement`,
  SECURITY_CENTER_POLICIES: `${Pu}/policies`,
  // AUTOMATION AND ENABLEMENT
  AUTOMATION_AND_ENABLEMENT: vie,
  AUTOMATION_AND_ENABLEMENT_JOB: `${vie}/job`,
  // DATA PROTECTION
  DATA_PROTECTION: qf,
  DATA_PROTECTION_OVERVIEW: `${qf}/overview`,
  DATA_PROTECTION_BACKUP_AND_SCHEDULE: bie,
  DATA_PROTECTION_BACKUP_AND_SCHEDULE_DETAIL: `${bie}/detail/:id`,
  DATA_PROTECTION_RESTORES: `${qf}/restores`,
  DATA_PROTECTION_RESTORES_DETAIL: `${qf}/restores/:restoreId`,
  DATA_PROTECTION_BACKUP_LOCATIONS: `${qf}/backup-locations/:type(${Object.values(C_e).join("|")})`,
  BACKUP_LOCATION_DETAILS: "/:locationId",
  // GLOBAL CONFIGURATION
  GLOBAL_CONFIG: k_,
  GLOBAL_CONFIG_DOCKER: `${k_}/docker`,
  GLOBAL_CONFIG_EDIT_CLUSTER: `${k_}/cluster-env/edit/:clusterId`,
  PERMISSION_GROUPS: `${k_}/auth/groups`,
  EXTERNAL_APPS: "ea"
}, rf = {
  APP: "app",
  APP_ARTIFACT_PROMOTE_MATERIAL: "app/artifact/promotion-request/material",
  APP_TEMPLATE_DATA: "app/template/data",
  ENVIRONMENT_CATEGORIES: "env/categories",
  PROJECT_LIST_MIN: "team/autocomplete",
  USER_CHECK_ROLE: "user/check/roles",
  IMAGE_TAGGING: "app/image-tagging",
  CREATE_RESOURCE: "k8s/resource/create",
  K8S_RESOURCE_CREATE: "k8s/resources/apply",
  CI_CONFIG_GET: "app/ci-pipeline",
  CD_MATERIAL_GET: "app/cd-pipeline",
  DEPLOYMENT_TEMPLATE_LIST: "app/template/list",
  INFRA_CONFIG_PROFILE: "infra-config/profile",
  SCAN_RESULT: "scan-result",
  NOTIFIER: "notification",
  APP_LIST: "app/list",
  TELEMETRY_EVENT: "telemetry/event",
  SERVER_INFO_API: "server",
  ATTRIBUTES_USER: "attributes/user",
  GET: "get",
  UPDATE: "update",
  PATCH: "patch",
  ENVIRONMENT_LIST_MIN: "env/autocomplete",
  CLUSTER: "cluster",
  CLUSTER_MIN: "cluster/min",
  API_RESOURCE: "k8s/api-resources",
  GVK: "gvk",
  NAMESPACE: "env/namespace",
  CLUSTER_NOTE: "cluster/note",
  APPLICATION_NOTE: "app/note",
  GIT_HOST_EVENT: "git/host/event",
  HELM_DEPLOYMENT_STATUS_TIMELINE_INSTALLED_APP: "app-store/deployment-status/timeline",
  DEPLOYMENT_STATUS: "app/deployment-status/timeline",
  MANUAL_SYNC: "app/deployment-status/manual-sync",
  CD_CONFIG: "app/cd-pipeline",
  CONFIG_CD_PIPELINE: "config/cd-pipeline",
  MODULE_CONFIGURED: "module/config",
  RESOURCE_HISTORY_DEPLOYMENT: "resource/history/deployment",
  ATTRIBUTES: "attributes",
  ATTRIBUTES_CREATE: "attributes/create",
  ATTRIBUTES_UPDATE: "attributes/update",
  APP_LIST_MIN: "app/min",
  APP_DETAIL: "app/detail",
  CLUSTER_LIST_MIN: "cluster/autocomplete",
  CLUSTER_LIST_RAW: "k8s/capacity/cluster/list/raw",
  PLUGIN_GLOBAL_LIST_DETAIL_V2: "plugin/global/list/detail/v2",
  PLUGIN_GLOBAL_LIST_V2: "plugin/global/list/v2",
  PLUGIN_GLOBAL_LIST_TAGS: "plugin/global/list/tags",
  PLUGIN_LIST_MIN: "plugin/global/list/v2/min",
  DEPLOYMENT_CHARTS_LIST: "deployment/template/fetch",
  USER_LIST_MIN: "user/list/min",
  CONFIG_DATA: "config/data",
  K8S_RESOURCE: "k8s/resource",
  K8S_RESOURCE_LIST: "k8s/resource/list",
  FILE_UPLOAD: "file/upload",
  PLUGIN_GLOBAL_VARIABLES: "plugin/global/list/global-variable",
  CONFIG_COMPARE_SECRET: "config/compare/secret",
  SCOPED_GLOBAL_VARIABLES: "global/variables",
  CD_TRIGGER_POST: "app/cd-pipeline/trigger",
  DELETE_RESOURCE: "k8s/resource/delete",
  NODE_CAPACITY: "k8s/capacity/node",
  RESOURCE_TEMPLATE: "resource/template",
  ENVIRONMENT_DATA: "global/environment-variables",
  DASHBOARD_EVENT: "dashboard-event",
  LICENSE_DATA: "license/data",
  ENV: "env",
  APP_METADATA: "app-metadata",
  RESOURCE_CONFLICTS_LIST: "app/:appId/cd-pipeline/:pipelineId/history/:wfrId/helm-ownership-conflicts"
};
var Sr = /* @__PURE__ */ ((t) => (t[t.BAD_REQUEST = 400] = "BAD_REQUEST", t[t.UNAUTHORIZED = 401] = "UNAUTHORIZED", t[t.PERMISSION_DENIED = 403] = "PERMISSION_DENIED", t[t.NOT_FOUND = 404] = "NOT_FOUND", t[t.EXPECTATION_FAILED = 417] = "EXPECTATION_FAILED", t[t.INTERNAL_SERVER_ERROR = 500] = "INTERNAL_SERVER_ERROR", t[t.BAD_GATEWAY = 502] = "BAD_GATEWAY", t[t.SERVICE_TEMPORARY_UNAVAILABLE = 503] = "SERVICE_TEMPORARY_UNAVAILABLE", t))(Sr || {});
const Wwt = {
  TITLE: "Access denied",
  SUBTITLE: "You do not have required access to perform this action"
}, yr = {
  PAGE_NOT_FOUND: "Not found",
  PAGE_NOT_EXIST: "Error 404: The requested resource could not be found. Please check the URL and try again.",
  TAKE_BACK_HOME: "Go back home",
  REPORT_ISSUE: "Report issue",
  ONLY_FOR_SUPERADMIN: "Information on this page is available only to superadmin users.",
  NOT_AUTHORIZED: "Not authorized",
  REQUIRED_MANAGER_ACCESS: "Looks like you don’t have access to information on this page. Please contact your manager to request access.",
  BAD_REQUEST: "Bad request",
  BAD_REQUEST_MESSAGE: "Error 400: The request could not be understood by the server due to malformed syntax. Please check your request and try again.",
  TRY_AGAIN: "Try again",
  UNAUTHORIZED: "Unauthorized",
  UNAUTHORIZED_MESSAGE: "Error 401: You are not authorized to access this resource. Please contact your administrator for assistance.",
  FORBIDDEN: "Forbidden",
  FORBIDDEN_MESSAGE: "Error 403: You are not authorized to access this resource. Please contact your administrator for assistance.",
  INTERNAL_SERVER_ERROR: "Internal server error",
  INTERNAL_SERVER_ERROR_MESSAGE: "Error 500: The server encountered an unexpected condition that prevented it from fulfilling the request. Please try again later.",
  BAD_GATEWAY: "Bad gateway",
  BAD_GATEWAY_MESSAGE: "Error 500: The server received an invalid response from an upstream server. Please try again later.",
  SERVICE_TEMPORARY_UNAVAILABLE: "Service temporary unavailable",
  SERVICE_TEMPORARY_UNAVAILABLE_MESSAGE: "Error 503: The server is currently unable to handle the request due to a temporary overload or maintenance. Please try again later."
}, Gwt = 2147483647;
var lo = /* @__PURE__ */ ((t) => (t.ASC = "ASC", t.DESC = "DESC", t))(lo || {});
const s9 = 20, T_e = "0001-01-01T00:00:00Z", R_e = [void 0, null, "", NaN], Qa = {
  OK: 200,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  PERMISSION_DENIED: 403,
  NOT_FOUND: 404,
  REQUEST_TIMEOUT: 408,
  CONFLICT: 409,
  PRE_CONDITION_FAILED: 412,
  EXPECTATION_FAILED: 417,
  UNPROCESSABLE_ENTITY: 422,
  LOCKED: 423,
  FAILED_DEPENDENCY: 424
}, a9 = {
  TWELVE_HOURS_FORMAT: "ddd, DD MMM YYYY, hh:mm A",
  TWELVE_HOURS_FORMAT_WITHOUT_WEEKDAY: "DD MMM YYYY, hh:mm A",
  TWELVE_HOURS_EXPORT_FORMAT: "DD-MMM-YYYY hh.mm A",
  DD_MMM_YYYY_HH_MM: "DD MMM YYYY, hh:mm",
  DD_MMM_YYYY: "DD MMM YYYY",
  "DD/MM/YYYY": "DD/MM/YYYY",
  DD_MMM: "DD MMM",
  TWENTY_FOUR_HOUR_FORMAT_HOUR: "HH",
  ABBREVIATED_MONTH: "MMM",
  DATE_WITH_ABBREVIATED_MONTH: "DD MMM",
  WEEKDAY_WITH_DATE_MONTH_AND_YEAR: "ddd, DD MMM YYYY",
  WEEKDAY_DATE_MONTH_YEAR_AND_HOUR: "ddd, DD MMM YYYY, HH:00",
  DAY_OF_MONTH_WITH_ORDINAL: "Do",
  ABBREVIATED_WEEKDAY: "ddd",
  DAY_OF_MONTH: "DD"
}, _ie = window.navigator.userAgent.toUpperCase().includes("MAC");
var Vu = /* @__PURE__ */ ((t) => (t.GITHUB = "github", t.GITLAB = "gitlab", t.BITBUCKET = "bitbucket", t.AZURE = "azure", t.GITEA = "gitea", t.GIT = "git", t))(Vu || {}), gc = /* @__PURE__ */ ((t) => (t.google = "google", t.github = "github", t.gitlab = "gitlab", t.microsoft = "microsoft", t.ldap = "ldap", t.oidc = "oidc", t.openshift = "openshift", t))(gc || {});
class Ywt {
  constructor(e) {
    Gn(this, "code"), Gn(this, "internalMessage"), Gn(this, "userMessage"), Gn(this, "moreInfo"), this.code = e.code || 0, this.userMessage = e.userMessage || "", this.internalMessage = e.internalMessage || "", this.moreInfo = e.moreInfo || "";
  }
}
class yl extends Error {
  constructor(e) {
    super(), Gn(this, "code"), Gn(this, "errors"), this.code = e.code;
    const n = e.errors.reduce((r, o) => (r += `${o.internalMessage || o.userMessage}`, r), "");
    this.name = `[${e.code.toString()}]`, this.message = n, this.errors = e.errors.map((r) => new Ywt(r)), Object.setPrototypeOf(this, yl.prototype);
  }
}
var zn = /* @__PURE__ */ ((t) => (t.GIT = "git", t.GITHUB = "github", t.GITLAB = "gitlab", t.BITBUCKET = "bitbucket", t.DOCKER = "docker", t.DOCKER_HUB = "docker-hub", t.ACR = "acr", t.QUAY = "quay", t.ECR = "ecr", t.ARTIFACT_REGISTRY = "artifact-registry", t.GCR = "gcr", t.OTHER = "other", t))(zn || {}), Uf = /* @__PURE__ */ ((t) => (t.CRITICAL = "critical", t.HIGH = "high", t.MEDIUM = "medium", t.LOW = "low", t.UNKNOWN = "unknown", t))(Uf || {}), P_e = /* @__PURE__ */ ((t) => (t.IMAGE = "Image", t.PARAMETERS = "Parameters", t))(P_e || {}), qw = /* @__PURE__ */ ((t) => (t.devtronApplication = "application/devtron-application", t.helmChart = "application/helm-application", t.job = "job", t.cluster = "cluster", t.release = "release", t.releaseTrack = "release-track", t.releaseChannel = "release-channel", t.tenant = "tenant", t.installation = "installation", t.infrastructureInstallation = "installations", t.environment = "environment", t.cdPipeline = "cd-pipeline", t.ciPipeline = "ci-pipeline", t.project = "project", t))(qw || {}), w3 = /* @__PURE__ */ ((t) => (t.PULL_REQUEST = "Pull Request", t.TAG_CREATION = "Tag Creation", t))(w3 || {}), $_e = /* @__PURE__ */ ((t) => (t.GUI = "GUI", t.YAML = "YAML", t))($_e || {}), Ud = /* @__PURE__ */ ((t) => (t.STARTING = "Starting", t.RUNNING = "Running", t.PROGRESSING = "Progressing", t.WAITING_TO_START = "WaitingToStart", t.TIMED_OUT = "TimedOut", t.CANCELLED = "CANCELLED", t))(Ud || {}), Hf = /* @__PURE__ */ ((t) => (t.EXTERNAL_CI = "EXTERNAL-CI", t.CI = "CI", t.LINKED_CI = "LINKED-CI", t.JOB_CI = "JOB-CI", t.LINKED_CD = "LINKED_CD", t.CI_CD = "CI_CD", t))(Hf || {}), M_e = /* @__PURE__ */ ((t) => (t.LICENSE_STATUS = "X-License-Status", t))(M_e || {}), bi = /* @__PURE__ */ ((t) => (t.DEPLOYMENT_INITIATED = "DEPLOYMENT_INITIATED", t.GIT_COMMIT = "GIT_COMMIT", t.GIT_COMMIT_FAILED = "GIT_COMMIT_FAILED", t.ARGOCD_SYNC = "ARGOCD_SYNC", t.ARGOCD_SYNC_FAILED = "ARGOCD_SYNC_FAILED", t.KUBECTL_APPLY = "KUBECTL_APPLY", t.KUBECTL_APPLY_STARTED = "KUBECTL_APPLY_STARTED", t.KUBECTL_APPLY_SYNCED = "KUBECTL_APPLY_SYNCED", t.HEALTHY = "HEALTHY", t.APP_HEALTH = "APP_HEALTH", t.DEPLOYMENT_FAILED = "FAILED", t.FETCH_TIMED_OUT = "TIMED_OUT", t.UNABLE_TO_FETCH_STATUS = "UNABLE_TO_FETCH_STATUS", t.DEGRADED = "DEGRADED", t.DEPLOYMENT_SUPERSEDED = "DEPLOYMENT_SUPERSEDED", t.ABORTED = "ABORTED", t.INPROGRESS = "INPROGRESS", t.HELM_PACKAGE_GENERATED = "HELM_PACKAGE_GENERATED", t.HELM_PACKAGE_GENERATION_FAILED = "HELM_PACKAGE_GENERATION_FAILED", t.HELM_MANIFEST_PUSHED_TO_HELM_REPO = "HELM_MANIFEST_PUSHED_TO_HELM_REPO", t.HELM_MANIFEST_PUSHED_TO_HELM_REPO_FAILED = "HELM_MANIFEST_PUSHED_TO_HELM_REPO_FAILED", t))(bi || {}), Vf = /* @__PURE__ */ ((t) => (t.PRE_SYNC = "PreSync", t.SYNC = "Sync", t.POST_SYNC = "PostSync", t.SKIP = "Skip", t.SYNC_FAIL = "SyncFail", t))(Vf || {}), Uw = /* @__PURE__ */ ((t) => (t.Direct = "DIRECT", t.Proxy = "PROXY", t.SSHTunnel = "SSH", t))(Uw || {}), Pl = /* @__PURE__ */ ((t) => (t.PRE = "PRE", t.DEPLOY = "DEPLOY", t.POST = "POST", t))(Pl || {});
const Lo = {
  SUCCEEDED: "succeeded",
  HEALTHY: "healthy",
  FAILED: "failed",
  TIMED_OUT: "timed_out",
  UNABLE_TO_FETCH: "unable_to_fetch",
  INPROGRESS: "inprogress",
  PROGRESSING: "progressing",
  STARTING: "starting",
  INITIATING: "initiating",
  SUPERSEDED: "superseded",
  QUEUED: "queued",
  UNKNOWN: "unknown",
  CHECKING: "checking"
};
var Oe = /* @__PURE__ */ ((t) => (t.xxs_small_icon = "xxs-small-icon", t.xxxs = "xxxs", t.xxs = "xxs", t.xs = "xs", t.small = "small", t.medium = "medium", t.large = "large", t.xl = "xl", t))(Oe || {});
const rl = {
  xxxs: "py-1 fs-12 lh-20",
  "xxs-small-icon": "py-1 fs-12 lh-20",
  xxs: "py-1 fs-12 lh-20",
  xs: "py-1 fs-12 lh-20",
  small: "py-3 fs-12 lh-20",
  medium: "py-5 fs-13 lh-20",
  large: "py-7 fs-13 lh-20",
  xl: "py-9 fs-14 lh-20"
}, Kwt = {
  xxxs: "px-5",
  "xxs-small-icon": "px-4",
  xxs: "px-5",
  xs: "px-5",
  small: "px-5",
  medium: "px-7",
  large: "px-7",
  xl: "px-9"
}, D_e = {
  xxxs: 14,
  "xxs-small-icon": 12,
  xxs: 14,
  xs: 14,
  small: 16,
  medium: 16,
  large: 16,
  xl: 20
}, Xwt = "popup";
Object.values(
  P_e
).map((t) => ({
  value: t,
  label: t
}));
Object.values($_e);
const Qwt = "https://enterprise.devtron.ai/portal/en/newticket", Zwt = "https://enterprise.devtron.ai/portal/en/myarea", Jwt = "https://github.com/devtron-labs/devtron/issues/new/choose", ext = "devtron-base-main-identifier", txt = "https://devtron.ai/enterprise-support", nxt = "inValid";
var Wu = /* @__PURE__ */ ((t) => (t.ERROR = "error", t.HELP = "help", t.INFORMATION = "information", t.SUCCESS = "success", t.WARNING = "warning", t.NEUTRAL = "neutral", t))(Wu || {});
const rxt = {
  error: "bcr-1",
  help: "bcv-1",
  information: "bcb-1",
  success: "bcg-1",
  warning: "bcy-1",
  neutral: "bcn-1"
}, oxt = {
  error: "er-2",
  help: "ev-2",
  information: "eb-2",
  success: "eg-2",
  warning: "ey-2",
  neutral: "en-2"
};
qc.CD, qc.POSTCD, qc.PRECD;
const zE = "allow-action-outside-focus-trap";
Uw.Direct + "", Uw.Proxy + "", Uw.SSHTunnel + "";
lr(null);
const ixt = lr(null), l9 = () => {
  const t = Hn(ixt);
  if (!t)
    throw new Error("Please wrap with MainContextProvider");
  return t;
};
var I_e = /* @__PURE__ */ ((t) => (t.DOCUMENTATION = "documentation", t.ASK_DEVTRON = "ask-devtron", t))(I_e || {}), ti = /* @__PURE__ */ ((t) => (t.light = "light", t.dark = "dark", t))(ti || {});
({
  ...ti
});
lr(null);
lr(null);
const c9 = ({ pageLoader: t, size: e, theme: n, styles: r, fillColor: o }) => {
  const i = e ? `${e}px` : t ? "48px" : "20px";
  return /* @__PURE__ */ M.jsx("div", { className: `loader ${n || "default"}-background`, style: r, "data-testid": "progressing", children: /* @__PURE__ */ M.jsx("div", { style: { width: i, height: i }, children: /* @__PURE__ */ M.jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", className: "loader__svg", children: /* @__PURE__ */ M.jsxs("g", { fill: "none", fillRule: "evenodd", strokeLinecap: "round", children: [
    /* @__PURE__ */ M.jsx(
      "animateTransform",
      {
        attributeName: "transform",
        attributeType: "XML",
        dur: "0.5s",
        from: "0 12 12",
        repeatCount: "indefinite",
        to: "360 12 12",
        type: "rotate"
      }
    ),
    /* @__PURE__ */ M.jsx(
      "path",
      {
        fill: o || "var(--B500)",
        fillRule: "nonzero",
        d: "M12 2.5A9.5 9.5 0 1 1 2.5 12a1.5 1.5 0 0 1 3 0A6.5 6.5 0 1 0 12 5.5a1.5 1.5 0 0 1 0-3z"
      }
    )
  ] }) }) }) });
}, sxt = (t, e) => {
  Ne(() => {
    const n = (r) => {
      t?.current && !t.current.contains(r.target) && e();
    };
    return document.addEventListener("click", n), () => {
      document.removeEventListener("click", n);
    };
  }, [t, e]);
};
var N_e = /* @__PURE__ */ ((t) => (t.Internal = "", t.KubernetesConfigMap = "KubernetesConfigMap", t.KubernetesSecret = "KubernetesSecret", t.AWSSecretsManager = "AWSSecretsManager", t.AWSSystemManager = "AWSSystemManager", t.HashiCorpVault = "HashiCorpVault", t.ESO_GoogleSecretsManager = "ESO_GoogleSecretsManager", t.ESO_AWSSecretsManager = "ESO_AWSSecretsManager", t.ESO_AzureSecretsManager = "ESO_AzureSecretsManager", t.ESO_HashiCorpVault = "ESO_HashiCorpVault", t))(N_e || {}), Hd = /* @__PURE__ */ ((t) => (t[t.ConfigMap = 1] = "ConfigMap", t[t.Secret = 2] = "Secret", t))(Hd || {}), Qr = /* @__PURE__ */ ((t) => (t.info = "info", t.success = "success", t.error = "error", t.warn = "warn", t.notAuthorized = "notAuthorized", t.shortcut = "shortcut", t))(Qr || {});
const axt = {
  [Qr.info]: {
    icon: /* @__PURE__ */ M.jsx(fEe, {}),
    type: "info",
    title: "Information",
    progressBarBg: "var(--B500)"
  },
  [Qr.success]: {
    icon: /* @__PURE__ */ M.jsx(REe, {}),
    type: "success",
    title: "Success",
    progressBarBg: "var(--G500)"
  },
  [Qr.error]: {
    icon: /* @__PURE__ */ M.jsx(wEe, {}),
    type: "error",
    title: "Error",
    progressBarBg: "var(--R500)"
  },
  [Qr.warn]: {
    icon: /* @__PURE__ */ M.jsx(oEe, { className: "warning-icon-y5-imp" }),
    type: "warning",
    title: "Warning",
    progressBarBg: "var(--Y500)"
  },
  [Qr.notAuthorized]: {
    icon: /* @__PURE__ */ M.jsx(NAe, {}),
    type: "warning",
    title: "Not authorized",
    progressBarBg: "var(--Y500)"
  }
}, lxt = ({
  title: t,
  description: e,
  buttonProps: n
}) => /* @__PURE__ */ M.jsxs("div", { className: "flexbox-col dc__gap-8 custom-toast__content", children: [
  /* @__PURE__ */ M.jsxs("div", { className: "flexbox-col dc__gap-4", children: [
    /* @__PURE__ */ M.jsx("h3", { className: "m-0 fs-13 fw-6 lh-20 text__white dc__ellipsis-right__2nd-line", children: t }),
    /* @__PURE__ */ M.jsx("p", { className: "fs-12 fw-4 lh-18 m-0 dc__truncate--clamp-6", children: e })
  ] }),
  n && /* @__PURE__ */ M.jsx(
    Ar,
    {
      ...n,
      variant: Nr.text,
      size: Oe.small,
      style: Ti.neutral
    }
  )
] }), cxt = ({ shortcuts: t, text: e }) => /* @__PURE__ */ M.jsxs("div", { className: "p-12 br-12 dc__border ev-5 bcv-1 flex dc__gap-6 dc__w-fit-content", children: [
  t.map((n) => /* @__PURE__ */ M.jsx(
    "kbd",
    {
      className: "flex bg__primary border__primary br-2 shadow__key fs-13 lh-14 fw-5 cn-8 icon-dim-20 dc__no-shrink",
      children: n
    },
    n
  )),
  /* @__PURE__ */ M.jsx("span", { className: "cn-9 fw-5 lh-20 fs-13 font-ibm-plex-sans", children: e })
] });
var E0;
const j_e = class jg {
  constructor() {
    Gn(this, "showToast", ({
      variant: e = Qr.info,
      icon: n,
      title: r,
      description: o,
      buttonProps: i,
      progressBarBg: s,
      text: a,
      shortcuts: l
    }, c = {}) => {
      if (e === Qr.shortcut)
        return In(/* @__PURE__ */ M.jsx(cxt, { text: a, shortcuts: l }), {
          position: "top-center",
          containerId: "devtron-shortcut-toast",
          className: "shortcut-toast",
          hideProgressBar: !0,
          closeButton: !1,
          autoClose: 3e3,
          closeOnClick: !0
        });
      const { icon: u, type: d, title: f, progressBarBg: h } = axt[e];
      return In(
        /* @__PURE__ */ M.jsx(lxt, { title: r || f, description: o, buttonProps: i }),
        {
          ...c,
          icon: () => /* @__PURE__ */ M.jsx("div", { className: "dc__no-shrink flex dc__fill-available-space icon-dim-20", children: n ?? u }),
          type: d,
          progressStyle: {
            background: s || h
          },
          // Show the progress bar if the auto close is disabled
          ...c.autoClose === !1 ? {
            progress: 1
          } : {}
        }
      );
    }), Gn(this, "dismissToast", In.dismiss), Gn(this, "isToastActive", In.isActive);
  }
  static get instance() {
    return gie(jg, E0) || qwt(jg, E0, new jg()), gie(jg, E0);
  }
};
E0 = /* @__PURE__ */ new WeakMap(), // eslint-disable-next-line no-use-before-define
zwt(j_e, E0);
let uxt = j_e;
const Cl = uxt.instance;
var Wf = /* @__PURE__ */ ((t) => (t.VALUES = "values", t.INHERITED = "inherited", t.DRY_RUN = "dryRun", t))(Wf || {});
Wf.VALUES, Wf.DRY_RUN, Wf.INHERITED, Wf.VALUES, Wf.DRY_RUN;
const L_e = Ri(
  ({ rootClassName: t, onClick: e, name: n, disabled: r, value: o, onChange: i, tabIndex: s, isChecked: a, id: l, dataTestId: c, children: u }, d) => {
    const f = `${t || ""}`;
    return (
      // eslint-disable-next-line jsx-a11y/label-has-associated-control
      /* @__PURE__ */ M.jsxs("label", { ref: d, className: `dc__position-rel flex left cursor ${f}`, onClick: e, children: [
        /* @__PURE__ */ M.jsx(
          "input",
          {
            ...n ? { name: n } : {},
            type: "checkbox",
            className: "form__checkbox",
            disabled: r,
            value: o,
            onChange: i,
            tabIndex: s,
            checked: a,
            id: l,
            "data-testid": c,
            onClick: Xv
          }
        ),
        /* @__PURE__ */ M.jsx("span", { className: "form__checkbox-container", "data-testid": `${c}-chk-span` }),
        /* @__PURE__ */ M.jsx("span", { className: "form__checkbox-label", children: u })
      ] })
    );
  }
), dxt = (t) => {
  switch (t) {
    case Pl.PRE:
      return "pre-deployment";
    case Pl.POST:
      return "post-deployment";
    case Pl.DEPLOY:
      return "deployment";
    default:
      return "-";
  }
};
qc.PRECD + "", qc.CD + "", qc.POSTCD + "", qc.APPROVAL + "";
var Ot = /* @__PURE__ */ ((t) => (t.CPU_LIMIT = "cpu_limit", t.CPU_REQUEST = "cpu_request", t.MEMORY_LIMIT = "memory_limit", t.MEMORY_REQUEST = "memory_request", t.BUILD_TIMEOUT = "timeout", t.NODE_SELECTOR = "node_selector", t.TOLERANCE = "tolerations", t.CONFIG_MAP = "cm", t.SECRET = "cs", t))(Ot || {}), u9 = /* @__PURE__ */ ((t) => (t.NAME = "name", t.DESCRIPTION = "description", t))(u9 || {}), an = /* @__PURE__ */ ((t) => (t.CPU = "cpu", t.MEMORY = "memory", t.BUILD_TIMEOUT = "timeout", t.NODE_SELECTOR = "node selector", t.TOLERANCE = "tolerance", t.CONFIG_MAP = "cm", t.SECRET = "cs", t))(an || {}), F_e = /* @__PURE__ */ ((t) => (t.EXISTS = "Exists", t.EQUALS = "Equal", t))(F_e || {}), B_e = /* @__PURE__ */ ((t) => (t.NO_EXECUTE = "NoExecute", t.NO_SCHEDULE = "NoSchedule", t.PREFER_NO_SCHEDULE = "PreferNoSchedule", t))(B_e || {}), d9 = /* @__PURE__ */ ((t) => (t.TARGET_PLATFORM = "target_platform", t))(d9 || {}), z_e = /* @__PURE__ */ ((t) => (t.ALPHA1 = "alpha1", t))(z_e || {});
const fD = {
  [an.CPU]: Nse,
  [an.MEMORY]: jse,
  [an.BUILD_TIMEOUT]: sEe,
  [an.NODE_SELECTOR]: iEe,
  [an.TOLERANCE]: Ise,
  [an.CONFIG_MAP]: null,
  [an.SECRET]: null
};
an.CPU + "", an.MEMORY + "", an.BUILD_TIMEOUT + "", an.NODE_SELECTOR + "", an.TOLERANCE + "", an.CONFIG_MAP + "", an.SECRET + "";
const fxt = [
  {
    heading: /* @__PURE__ */ M.jsx("h3", { className: "m-0 cn-9 fs-13 fw-6 lh-20 w-240 dc__no-shrink", children: "CPU (Request - Limit)" }),
    marker: fD[an.CPU],
    actions: [
      {
        actionType: Ot.CPU_REQUEST,
        label: "Request",
        placeholder: "Type CPU request"
      },
      {
        actionType: Ot.CPU_LIMIT,
        label: "Limit",
        placeholder: "Type CPU limit"
      }
    ],
    locator: an.CPU
  },
  {
    heading: /* @__PURE__ */ M.jsx("h3", { className: "m-0 cn-9 fs-13 fw-6 lh-20 w-240 dc__no-shrink", children: "Memory (Request - Limit)" }),
    marker: fD[an.MEMORY],
    actions: [
      {
        actionType: Ot.MEMORY_REQUEST,
        label: "Request",
        placeholder: "Type memory request"
      },
      {
        actionType: Ot.MEMORY_LIMIT,
        label: "Limit",
        placeholder: "Type memory limit"
      }
    ],
    locator: an.MEMORY
  },
  {
    heading: /* @__PURE__ */ M.jsx("h3", { className: "m-0 cn-9 fs-13 fw-6 lh-20 w-240 dc__no-shrink", children: "Build timeout" }),
    marker: fD[an.BUILD_TIMEOUT],
    actions: [
      {
        actionType: Ot.BUILD_TIMEOUT,
        label: "Timeout",
        placeholder: "Type build timeout"
      }
    ],
    locator: an.BUILD_TIMEOUT
  }
];
fxt.reduce(
  (t, e) => (t[e.locator] = e, t),
  {}
);
Object.fromEntries(
  Object.values({
    ...Ot,
    ...u9,
    ...d9
  }).map((t) => [t, null])
);
u9.NAME;
z_e.ALPHA1;
Ot.BUILD_TIMEOUT + "", Ot.CPU_LIMIT + "", Ot.CPU_REQUEST + "", Ot.MEMORY_LIMIT + "", Ot.MEMORY_REQUEST + "", Ot.NODE_SELECTOR + "", Ot.TOLERANCE + "", Ot.CONFIG_MAP + "", Ot.SECRET + "", d9.TARGET_PLATFORM + "";
Object.values(an).reduce(
  (t, e) => (t[`activate_${e}`] = e, t[`de_activate_${e}`] = e, t),
  {}
);
an.CPU + "", Ot.CPU_REQUEST, Ot.CPU_LIMIT, an.MEMORY + "", Ot.MEMORY_REQUEST, Ot.MEMORY_LIMIT, an.BUILD_TIMEOUT + "", Ot.BUILD_TIMEOUT, an.NODE_SELECTOR + "", Ot.NODE_SELECTOR, an.TOLERANCE + "", Ot.TOLERANCE, an.CONFIG_MAP + "", Ot.CONFIG_MAP, an.SECRET + "", Ot.SECRET;
Ot.CPU_LIMIT + "", Ot.CPU_REQUEST, Ot.CPU_REQUEST + "", Ot.CPU_LIMIT, Ot.MEMORY_LIMIT + "", Ot.MEMORY_REQUEST, Ot.MEMORY_REQUEST + "", Ot.MEMORY_LIMIT;
B_e.NO_SCHEDULE;
F_e.EQUALS;
Ot.BUILD_TIMEOUT + "", Ot.CONFIG_MAP + "", Ot.SECRET + "";
Ot.CONFIG_MAP + "", Ot.SECRET + "";
Ot.CONFIG_MAP + "", Hd.ConfigMap, Ot.SECRET + "", Hd.Secret;
Hd.ConfigMap + "", Ot.CONFIG_MAP, Hd.Secret + "", Ot.SECRET;
Hd.ConfigMap + "", an.CONFIG_MAP, Hd.Secret + "", an.SECRET;
const hD = {
  10: 1,
  12: 1
}, hxt = (t) => (e) => /* @__PURE__ */ M.jsx(Ai, { ...t, children: /* @__PURE__ */ M.jsx("div", { className: "flex", children: e }) }), pxt = ({
  name: t,
  iconMap: e,
  size: n = 16,
  tooltipProps: r,
  color: o,
  dataTestId: i,
  rotateBy: s,
  fillSpace: a = !1,
  flip: l
}) => {
  const c = e[t];
  if (!c)
    throw new Error(`Icon with name "${t}" does not exist.`);
  const u = () => qE(l) ? {
    "--flip-x": 1,
    "--flip-y": 1
  } : l === "horizontal" ? { "--flip-x": -1, "--flip-y": 1 } : { "--flip-x": 1, "--flip-y": -1 };
  return /* @__PURE__ */ M.jsx(Hp, { condition: !!r?.content, wrap: hxt(r), children: /* @__PURE__ */ M.jsx(
    c,
    {
      "data-testid": i,
      className: `icon-component-transform ${n ? `icon-dim-${n}` : ""} ${o ? "icon-component-color" : ""} ${hD[n] ? "icon-component-stroke-width" : ""} ${a ? "dc__fill-available-space" : ""} dc__no-shrink`,
      style: {
        ...o ? { "--iconColor": `var(--${o})` } : {},
        ...hD[n] ? { "--strokeWidth": hD[n] } : {},
        ...qE(s) ? {} : { "--rotateBy": `${s}deg` },
        ...u()
      }
    }
  ) });
}, mxt = {
  "ic-73strings": eSe,
  "ic-aborted": tSe,
  "ic-activity": nSe,
  "ic-add": rSe,
  "ic-ai": oSe,
  "ic-alibaba": iSe,
  "ic-amazon-eks": sSe,
  "ic-app-group": aSe,
  "ic-app-template": lSe,
  "ic-application-group": uSe,
  "ic-application-management": dSe,
  "ic-application-template": fSe,
  "ic-application": cSe,
  "ic-argocd-app": hSe,
  "ic-arrow-clockwise": pSe,
  "ic-arrow-line-down": mSe,
  "ic-arrow-right": gSe,
  "ic-arrow-square-out": ySe,
  "ic-arrows-clockwise": vSe,
  "ic-arrows-left-right": bSe,
  "ic-asterisk": _Se,
  "ic-ather": wSe,
  "ic-aws-codecommit": ESe,
  "ic-aws": xSe,
  "ic-azure-aks": OSe,
  "ic-azure": SSe,
  "ic-backup-and-schedule": CSe,
  "ic-backup-color": kSe,
  "ic-backup-location": ASe,
  "ic-backup-schedule-color": TSe,
  "ic-bg-backup-schedule": RSe,
  "ic-bg-backups": PSe,
  "ic-bg-build": $Se,
  "ic-bg-cluster": MSe,
  "ic-bg-cpu": DSe,
  "ic-bg-deploy": ISe,
  "ic-bg-environment": NSe,
  "ic-bg-memory": jSe,
  "ic-bg-pause-schedule": LSe,
  "ic-bg-production-pipelines": FSe,
  "ic-bg-project": BSe,
  "ic-bg-ransomware-vulnerable-cluster": zSe,
  "ic-bg-restore": qSe,
  "ic-bg-scan": USe,
  "ic-bg-storage-locations": HSe,
  "ic-bg-webhook": VSe,
  "ic-bharatpe": WSe,
  "ic-binoculars": GSe,
  "ic-bitbucket": Wse,
  "ic-book-open": YSe,
  "ic-bot": KSe,
  "ic-brain": XSe,
  "ic-browser": QSe,
  "ic-bug": ZSe,
  "ic-build-color": JSe,
  "ic-building": eOe,
  "ic-calendar": Fse,
  "ic-cancelled": tOe,
  "ic-card-stack": nOe,
  "ic-caret-down-small": rOe,
  "ic-caret-left": oOe,
  "ic-caret-right": iOe,
  "ic-cd": sOe,
  "ic-chart-line-up": aOe,
  "ic-chart-repo": lOe,
  "ic-chat-circle-dots": $Ee,
  "ic-chat-circle-online": cOe,
  "ic-check-all": dOe,
  "ic-check-circle": fOe,
  "ic-check-square": hOe,
  "ic-check": uOe,
  "ic-checks": pOe,
  "ic-ci-linked": mOe,
  "ic-circle-loader": gOe,
  "ic-circle-small": yOe,
  "ic-clean-brush": vOe,
  "ic-clipboard": bOe,
  "ic-clock-counterclockwise": wOe,
  "ic-clock": _Oe,
  "ic-close-large": xOe,
  "ic-close-small": EOe,
  "ic-cloud-upload": SOe,
  "ic-cloud-vms": OOe,
  "ic-cluster-isolated": kOe,
  "ic-cluster": COe,
  "ic-code": AOe,
  "ic-coins-color-animated": ROe,
  "ic-coins": TOe,
  "ic-container-registry": $Oe,
  "ic-container": POe,
  "ic-cookr": MOe,
  "ic-copy": DOe,
  "ic-cost-visibility": IOe,
  "ic-cpu": Nse,
  "ic-crown": NOe,
  "ic-cube": jOe,
  "ic-database-backup": LOe,
  "ic-delete-dots": BOe,
  "ic-delete-lightning": zOe,
  "ic-delete": FOe,
  "ic-delhivery": qOe,
  "ic-deploy-color": UOe,
  "ic-deploy-sync": HOe,
  "ic-devtron-ai": WOe,
  "ic-devtron-app": GOe,
  "ic-devtron-header-logo": YOe,
  "ic-devtron-job": KOe,
  "ic-devtron-text": XOe,
  "ic-devtron": VOe,
  "ic-diff-added": QOe,
  "ic-diff-deleted": ZOe,
  "ic-diff-updated": JOe,
  "ic-disconnect": eCe,
  "ic-discord-fill": tCe,
  "ic-dockerhub": nCe,
  "ic-download": rCe,
  "ic-ecr": oCe,
  "ic-edit-lines": sCe,
  "ic-edit": iCe,
  "ic-email": aCe,
  "ic-enter-fullscreen": lCe,
  "ic-enterprise-feat": cCe,
  "ic-enterprise-tag": uCe,
  "ic-env": dCe,
  "ic-environment-isolated": fCe,
  "ic-environment": qse,
  "ic-error": hCe,
  "ic-exit-fullscreen": pCe,
  "ic-expand-right-sm": mCe,
  "ic-expand-sm": gCe,
  "ic-external-link": yCe,
  "ic-failure": vCe,
  "ic-fast-forward": bCe,
  "ic-file-code": wCe,
  "ic-file-download": xCe,
  "ic-file-edit": ECe,
  "ic-file-key": SCe,
  "ic-file": _Ce,
  "ic-files-changed": CCe,
  "ic-files": OCe,
  "ic-filter-applied": ACe,
  "ic-filter": kCe,
  "ic-flask": TCe,
  "ic-floppy-disk": RCe,
  "ic-fluxcd-app": PCe,
  "ic-folder-color": MCe,
  "ic-folder-user": DCe,
  "ic-folder": $Ce,
  "ic-gavel": ICe,
  "ic-gear": NCe,
  "ic-gift-animated": LCe,
  "ic-gift-gradient": FCe,
  "ic-gift": jCe,
  "ic-git-branch": zCe,
  "ic-git": BCe,
  "ic-github": qCe,
  "ic-gitlab": UCe,
  "ic-global-overview": HCe,
  "ic-google-artifact-registry": WCe,
  "ic-google-cloud": GCe,
  "ic-google-container-registry": YCe,
  "ic-google-gke": KCe,
  "ic-google": VCe,
  "ic-grid-view": XCe,
  "ic-group-filter-applied": ZCe,
  "ic-group-filter": QCe,
  "ic-hand-pointing": JCe,
  "ic-heart-green": eke,
  "ic-heart-red-animated": nke,
  "ic-heart-red": tke,
  "ic-helm-app": oke,
  "ic-helm": rke,
  "ic-help-filled": ike,
  "ic-help-outline": ske,
  "ic-hibernate-circle": lke,
  "ic-hibernate": ake,
  "ic-in-progress": cke,
  "ic-info-filled-color": dke,
  "ic-info-filled": uke,
  "ic-info-outline": fke,
  "ic-infrastructure-management": hke,
  "ic-input": pke,
  "ic-install": mke,
  "ic-job-color": gke,
  "ic-k3s": yke,
  "ic-k8s-job": vke,
  "ic-key-enter": _ke,
  "ic-key": bke,
  "ic-kind": wke,
  "ic-kubernetes": xke,
  "ic-laptop": Eke,
  "ic-ldap": Ske,
  "ic-lego": Oke,
  "ic-lightning-fill": kke,
  "ic-lightning": Cke,
  "ic-link": Ake,
  "ic-linked-build-color": Tke,
  "ic-list-bullets": Rke,
  "ic-livspace": Pke,
  "ic-locked": $ke,
  "ic-logout": Mke,
  "ic-logs": Dke,
  "ic-magic-wand": Ike,
  "ic-magnifying-glass": Nke,
  "ic-medium-delete": jke,
  "ic-medium-paintbucket": jEe,
  "ic-megaphone-left": Lke,
  "ic-megaphone-right": Fke,
  "ic-memory": jse,
  "ic-microsoft": Bke,
  "ic-minikube": zke,
  "ic-minus": qke,
  "ic-missing": Uke,
  "ic-mobile": Hke,
  "ic-monitoring": Vke,
  "ic-more-vertical": Wke,
  "ic-namespace": Gke,
  "ic-new": Yke,
  "ic-node-script": Kke,
  "ic-oidc": Xke,
  "ic-open-box": Qke,
  "ic-open-in-new": Zke,
  "ic-openai": Jke,
  "ic-openshift": e2e,
  "ic-oracle-cloud": t2e,
  "ic-otc-cloud": n2e,
  "ic-out-of-sync": r2e,
  "ic-paper-plane-color": i2e,
  "ic-paper-plane": o2e,
  "ic-party": s2e,
  "ic-path": a2e,
  "ic-pause-circle": c2e,
  "ic-pause": l2e,
  "ic-pencil": u2e,
  "ic-play-outline": d2e,
  "ic-priority-medium-fill": f2e,
  "ic-quay": h2e,
  "ic-quote": p2e,
  "ic-ratings": m2e,
  "ic-release-hub": g2e,
  "ic-resize-handle": y2e,
  "ic-resource-browser": v2e,
  "ic-resource-watcher": b2e,
  "ic-right-panel-collapse": _2e,
  "ic-rocket-gear": w2e,
  "ic-rocket-launch": x2e,
  "ic-security-fixable": E2e,
  "ic-security-not-fixable": S2e,
  "ic-security-policy": O2e,
  "ic-security-scan": C2e,
  "ic-security-vulnerability": k2e,
  "ic-selected": A2e,
  "ic-shapes": T2e,
  "ic-shield-check": R2e,
  "ic-sliders-vertical": P2e,
  "ic-software-release-management": $2e,
  "ic-sort-ascending": M2e,
  "ic-sort-descending": D2e,
  "ic-sortable": I2e,
  "ic-sparkle-ai-color": N2e,
  "ic-sparkle-color": j2e,
  "ic-speedometer": L2e,
  "ic-spinny": F2e,
  "ic-spray-can": B2e,
  "ic-stack": z2e,
  "ic-stamp": q2e,
  "ic-stop-fill": U2e,
  "ic-storage": H2e,
  "ic-strategy-blue-green-color": W2e,
  "ic-strategy-blue-green": V2e,
  "ic-strategy-canary-color": Y2e,
  "ic-strategy-canary": G2e,
  "ic-strategy-recreate-color": X2e,
  "ic-strategy-recreate": K2e,
  "ic-strategy-rolling-color": Z2e,
  "ic-strategy-rolling": Q2e,
  "ic-success-blue": eAe,
  "ic-success": J2e,
  "ic-sun": tAe,
  "ic-suspended": nAe,
  "ic-symbol-greater-than": rAe,
  "ic-tag": oAe,
  "ic-tata1mg": iAe,
  "ic-tenants": sAe,
  "ic-terminal-fill": lAe,
  "ic-terminal": aAe,
  "ic-thermometer": cAe,
  "ic-thumb-down": uAe,
  "ic-thumb-up": dAe,
  "ic-timeout-dash": fAe,
  "ic-timer": hAe,
  "ic-traffic-signal": pAe,
  "ic-travclan": mAe,
  "ic-trend-up": gAe,
  "ic-two-cubes": yAe,
  "ic-ubuntu": vAe,
  "ic-unknown": bAe,
  "ic-upgrade-enterprise": _Ae,
  "ic-user-circle": wAe,
  "ic-user-key": xAe,
  "ic-users": EAe,
  "ic-view-variable-toggle": SAe,
  "ic-visibility-off": IEe,
  "ic-visibility-on": NEe,
  "ic-warning-fill": CAe,
  "ic-warning-stroke": kAe,
  "ic-warning": OAe,
  "ic-webhook": AAe,
  "ic-wifi-slash": TAe,
  "ic-world-globe": RAe
}, Ut = (t) => /* @__PURE__ */ M.jsx(pxt, { ...t, iconMap: mxt });
Oe.small + "", Oe.medium + "", Oe.large + "", Oe.xl + "";
Oe.small + "", Oe.medium + "", Oe.large + "", Oe.xl + "";
Oe.small + "", Oe.medium + "", Oe.large + "", Oe.xl + "";
Oe.small + "", Oe.medium + "", Oe.large + "", Oe.xl + "";
const gxt = (t = {}) => t ? Object.hasOwn(t, "shortcutKeyCombo") && "shortcutKeyCombo" in t ? t : {
  // TODO: using some typing somersaults here, clean it up later
  alwaysShowTippyOnHover: !!t?.content,
  ...t,
  placement: "right"
} : {
  alwaysShowTippyOnHover: !1,
  content: null
}, yxt = ({
  menuListFooterConfig: t
}) => {
  if (!t)
    return null;
  const { type: e } = t;
  if (e === "text") {
    const { value: n } = t;
    return /* @__PURE__ */ M.jsxs("div", { className: "flexbox dc__gap-6 p-8", children: [
      /* @__PURE__ */ M.jsx(Ut, { name: "ic-info-outline", color: "N700", size: 16 }),
      /* @__PURE__ */ M.jsx("p", { className: "fs-12 fw-4 lh-16 cn-8 dc__word-break m-0", children: n })
    ] });
  }
  if (e === "button") {
    const { buttonProps: n } = t, { variant: r } = n;
    return (
      // We are adding justify-content: flex-start for borderLess variant using this class
      /* @__PURE__ */ M.jsx(
        "div",
        {
          className: `select-picker__menu-list-footer-button--${r} ${r === Nr.borderLess ? "py-4" : "p-8"}`,
          children: /* @__PURE__ */ M.jsx(Ar, { ...n, size: Oe.medium, fullWidth: !0 })
        }
      )
    );
  }
  if (e === "customNode") {
    const { value: n } = t;
    return n;
  }
  return null;
}, q_e = (t) => `${t}-error-msg`, U_e = (t) => `${t}-label`, vxt = (t) => `${t}-helper-text`, bxt = ({
  inputId: t,
  label: e,
  ariaLabel: n,
  required: r,
  error: o,
  helperText: i
}) => ({
  "aria-required": r,
  ...i ? {
    "aria-describedby": vxt(t)
  } : {},
  ...o ? {
    "aria-errormessage": q_e(t),
    "aria-invalid": !!o
  } : {},
  ...e ? {
    "aria-labelledby": U_e(t)
  } : {
    "aria-label": n
  }
}), pD = ({ id: t, text: e, icon: n, textClass: r }) => /* @__PURE__ */ M.jsxs("div", { className: "flexbox dc__gap-4 fs-11 lh-16 fw-4", id: t, children: [
  /* @__PURE__ */ M.jsx(Ut, { name: n, size: 16, color: null }),
  /* @__PURE__ */ M.jsx("span", { className: `dc__ellipsis-right__2nd-line ${r}`, children: e })
] }), _xt = ({ error: t, helperText: e, warningText: n, inputId: r }) => /* @__PURE__ */ M.jsxs("div", { className: "flex left column dc__gap-4", children: [
  !!t && /* @__PURE__ */ M.jsx(pD, { text: t, icon: "ic-error", textClass: "cr-5", id: q_e(r) }),
  !!e && /* @__PURE__ */ M.jsx(pD, { text: e, icon: "ic-info-filled", textClass: "cn-7", id: `${r}-helper-text` }),
  !!n && /* @__PURE__ */ M.jsx(pD, { text: n, icon: "ic-warning", textClass: "cy-7", id: `${r}-warning-msg` })
] }), wxt = ({
  label: t,
  inputId: e,
  required: n,
  layout: r,
  labelTooltipConfig: o,
  labelTippyCustomizedConfig: i
}) => {
  if (!t)
    return null;
  const s = U_e(e), a = r === "row", l = a && !!o?.content, c = (u) => /* @__PURE__ */ M.jsx(
    Ai,
    {
      placement: "bottom",
      alwaysShowTippyOnHover: !0,
      ...o,
      children: u
    }
  );
  return /* @__PURE__ */ M.jsxs("div", { className: "flex left dc__gap-4", children: [
    /* @__PURE__ */ M.jsxs("div", { className: `flex left ${n ? "dc__required-field" : ""}`, children: [
      /* @__PURE__ */ M.jsx(Hp, { condition: l, wrap: c, children: /* @__PURE__ */ M.jsx(
        "label",
        {
          className: `fs-13 lh-20 fw-4 dc__block mb-0 cursor ${a ? `cn-9 ${l ? "dc__underline-dotted" : ""}` : "cn-7"}`,
          htmlFor: e,
          id: s,
          "data-testid": s,
          children: typeof t == "string" ? /* @__PURE__ */ M.jsx("span", { className: "flex left", children: /* @__PURE__ */ M.jsx("span", { className: "dc__truncate", children: t }) }) : t
        }
      ) }),
      n && /* @__PURE__ */ M.jsx("span", { children: " " })
    ] }),
    !a && i && /* @__PURE__ */ M.jsx(uEt, { placement: "bottom-start", iconClass: "fcv-5", ...i })
  ] });
}, xxt = ({
  layout: t,
  fullWidth: e,
  label: n,
  inputId: r,
  error: o,
  helperText: i,
  warningText: s,
  required: a,
  children: l,
  labelTippyCustomizedConfig: c,
  labelTooltipConfig: u,
  hideFormFieldInfo: d = !1
}) => {
  const f = t === "row", h = f ? "dc__mxw-250 w-100 mxh-36 dc__align-self-stretch" : "", p = Array.isArray(o) ? o[0] : o;
  return /* @__PURE__ */ M.jsxs("div", { className: `flex left column top dc__gap-4 ${e ? "w-100" : ""}`, children: [
    /* @__PURE__ */ M.jsxs("div", { className: `flex left top dc__gap-6 ${f ? "" : "column"} w-100`, children: [
      n && /* @__PURE__ */ M.jsx("div", { className: `${h} flex left`, children: /* @__PURE__ */ M.jsx(
        wxt,
        {
          inputId: r,
          label: n,
          required: a,
          layout: t,
          ...f ? {
            labelTooltipConfig: u
          } : {
            labelTippyCustomizedConfig: c
          }
        }
      ) }),
      /* @__PURE__ */ M.jsx("div", { className: "w-100 dc__position-rel", children: l })
    ] }),
    !d && (!!p || !!i || !!s) && /* @__PURE__ */ M.jsxs("div", { className: "flex left dc__gap-6 w-100", children: [
      f && /* @__PURE__ */ M.jsx("div", { className: `${h} dc__visibility-hidden` }),
      /* @__PURE__ */ M.jsx(
        _xt,
        {
          inputId: r,
          error: p,
          helperText: i,
          warningText: s
        }
      )
    ] })
  ] });
}, H_e = ({
  reload: t,
  buttonProps: e,
  customIcon: n,
  withBorder: r = !1,
  title: o = "Failed to load",
  subTitle: i = "We could not load the information on this page.",
  description: s = "Please reload or try again later",
  buttonText: a = "Reload",
  rootClassName: l,
  useInfoIcon: c = !1,
  progressingProps: u
}) => {
  const d = () => n || (u ? /* @__PURE__ */ M.jsx(Ut, { name: "ic-circle-loader", ...u }) : c ? /* @__PURE__ */ M.jsx(rEe, { className: "icon-dim-24" }) : /* @__PURE__ */ M.jsx(CEe, { className: "icon-dim-24 alert-icon-r5-imp" })), f = (h) => h ? typeof h == "string" ? /* @__PURE__ */ M.jsx("p", { className: "m-0 dc__truncate--clamp-6", children: h }) : h : null;
  return /* @__PURE__ */ M.jsxs("div", { className: `flex column dc__gap-8 p-16 ${r ? "dc__border br-4" : ""} ${l || ""}`, children: [
    d(),
    /* @__PURE__ */ M.jsxs("div", { className: "flex column dc__gap-4 dc__align-center", children: [
      /* @__PURE__ */ M.jsx("h3", { className: "fs-13 lh-20 fw-6 cn-9 m-0", children: o }),
      (i || s) && /* @__PURE__ */ M.jsxs("div", { className: "flex column fs-13 lh-20 fw-4 cn-7", children: [
        f(i),
        f(s)
      ] })
    ] }),
    t && /* @__PURE__ */ M.jsx(
      Ar,
      {
        text: a,
        onClick: t,
        variant: Nr.text,
        size: Oe.small,
        dataTestId: "generic-section-reload-button"
      }
    ),
    e && /* @__PURE__ */ M.jsx(Ar, { ...e })
  ] });
}, Ext = {
  [Oe.medium]: Oe.xxs,
  [Oe.large]: Oe.xs
}, Sxt = ({
  name: t,
  label: e,
  fullWidth: n,
  error: r,
  helperText: o,
  warningText: i,
  layout: s,
  required: a,
  onBlur: l,
  shouldTrim: c = !0,
  size: u = Oe.large,
  ariaLabel: d,
  borderConfig: f,
  borderRadiusConfig: h,
  type: p = "text",
  autoFocus: m = !1,
  endIconButtonConfig: g,
  labelTippyCustomizedConfig: y,
  labelTooltipConfig: v,
  inputRef: b,
  hideFormFieldInfo: _,
  ...w
}) => {
  const x = Ue(null), E = b || x;
  Ne(() => {
    setTimeout(() => {
      E.current && m && E.current.focus();
    }, 100);
  }, [m]);
  const S = (P) => {
    if (c) {
      const N = P.target.value?.trim();
      P.target.value !== N && (P.stopPropagation(), P.target.value = N, w.onChange(P));
    }
    l?.(P);
  }, C = (P) => {
    P.stopPropagation(), E.current.focus(), g?.onClick(P);
  }, R = (P) => {
    P.key === "Escape" && E.current.blur(), w.onKeyDown?.(P);
  };
  return /* @__PURE__ */ M.jsx(
    xxt,
    {
      inputId: t,
      layout: s,
      label: e,
      error: r,
      helperText: o,
      warningText: i,
      required: a,
      fullWidth: n,
      ariaLabel: d,
      borderConfig: f,
      borderRadiusConfig: h,
      labelTippyCustomizedConfig: y,
      labelTooltipConfig: v,
      hideFormFieldInfo: _,
      children: /* @__PURE__ */ M.jsxs(M.Fragment, { children: [
        /* @__PURE__ */ M.jsx(
          "input",
          {
            ...w,
            ...bxt({
              inputId: t,
              required: a,
              label: e,
              ariaLabel: d,
              error: r,
              helperText: o
            }),
            autoComplete: "off",
            name: t,
            id: t,
            spellCheck: !1,
            "data-testid": t,
            required: a,
            onBlur: S,
            onKeyDown: R,
            type: p,
            ref: E,
            className: `${rl[u]} ${Kwt[u]} ${X_e({ borderConfig: f, borderRadiusConfig: h })} ${g ? `custom-input__with-icon-button--${u}` : ""} w-100 dc__overflow-auto`
          }
        ),
        g && /* @__PURE__ */ M.jsx("div", { className: `dc__no-shrink dc__position-abs custom-input__icon-button--${u}`, children: /* @__PURE__ */ M.jsx(
          Ar,
          {
            style: Ti.neutral,
            ...g,
            dataTestId: `${t}-end-icon`,
            variant: Nr.borderLess,
            size: Ext[u],
            onClick: C
          }
        ) })
      ] })
    }
  );
}, Oxt = lr(null), Cxt = ({
  onEscape: t,
  deactivateFocusOnEscape: e = !0,
  children: n,
  initialFocus: r = void 0,
  returnFocusOnDeactivate: o = !0
}) => {
  const [i, s] = Ye(!0), a = Cn(
    (c) => (t(c), e),
    [t, e]
  );
  Ne(() => (xie(!0), () => {
    xie(!1);
  }), []);
  const l = cn(
    () => ({
      disableFocusTrap: () => s(!1),
      resumeFocusTrap: () => s(!0)
    }),
    []
  );
  return /* @__PURE__ */ M.jsx(Oxt.Provider, { value: l, children: /* @__PURE__ */ M.jsx(
    w4e,
    {
      active: i,
      focusTrapOptions: {
        escapeDeactivates: a,
        initialFocus: r,
        allowOutsideClick: (c) => {
          let u = c.target, d = 0;
          for (; u && d < 4; ) {
            if (u.classList && u.classList.contains(zE))
              return !0;
            u = u.parentElement, d += 1;
          }
          return !1;
        },
        returnFocusOnDeactivate: o
      },
      children: n
    }
  ) });
}, kxt = (t) => {
  const e = document.getElementById(ext);
  if (!e)
    return null;
  const n = document.createElement("div");
  return n.setAttribute("id", t), e.parentElement.appendChild(n), n;
}, f9 = ({
  children: t,
  onEscape: e,
  onClick: n,
  hasClearBackground: r = !1,
  onBackdropMount: o,
  deactivateFocusOnEscape: i = !0,
  initialFocus: s,
  returnFocusOnDeactivate: a
}) => {
  const [l, c] = Ye(null), u = Ue(`backdrop-${HO()}`);
  return Ne(() => {
    o?.(!!l);
  }, [l]), iu(() => {
    let d = document.getElementById(u.current), f = !1;
    return d || (f = !0, d = kxt(u.current)), c(d), () => {
      f && d?.parentNode && d.parentNode.removeChild(d);
    };
  }, []), l === null ? null : XE(
    /* @__PURE__ */ M.jsx(
      Cxt,
      {
        onEscape: e,
        deactivateFocusOnEscape: i,
        initialFocus: s ?? void 0,
        returnFocusOnDeactivate: a,
        children: /* @__PURE__ */ M.jsx(
          IE.div,
          {
            initial: { opacity: 0 },
            animate: { opacity: 1 },
            exit: { opacity: 0, transition: { duration: 0.35 } },
            className: `backdrop ${r ? "backdrop--transparent" : ""} dc__position-fixed dc__top-0 dc__left-0 full-height-width flexbox dc__content-center dc__align-items-center dc__overflow-hidden`,
            onClick: n,
            children: t
          }
        )
      }
    ),
    l
  );
}, Axt = ({
  open: t,
  popoverProps: e,
  overlayProps: n,
  triggerProps: { bounds: r, ...o },
  buttonProps: i,
  triggerElement: s,
  children: a
}) => /* @__PURE__ */ M.jsxs(M.Fragment, { children: [
  /* @__PURE__ */ M.jsx("div", { ...o, children: s || /* @__PURE__ */ M.jsx(Ar, { ...i }) }),
  /* @__PURE__ */ M.jsx(C0t, { children: t && /* @__PURE__ */ M.jsx(f9, { ...n, children: /* @__PURE__ */ M.jsxs(
    "div",
    {
      className: "dc__position-abs",
      style: { left: r.left, top: r.top },
      onClick: o.onClick,
      children: [
        /* @__PURE__ */ M.jsx("div", { className: "dc__visibility-hidden", style: { width: r.width, height: r.height } }),
        /* @__PURE__ */ M.jsx(IE.div, { ...e, "data-testid": e.id, children: a })
      ]
    }
  ) }) })
] }), Txt = ({ position: t, alignment: e }) => {
  if (t === "top" || t === "bottom")
    switch (e) {
      case "end":
        return { right: 0 };
      case "middle":
        return { left: "50%" };
      case "start":
      default:
        return { left: 0 };
    }
  switch (e) {
    case "end":
      return { bottom: 0 };
    case "middle":
      return { top: "50%" };
    case "start":
    default:
      return { top: 0 };
  }
}, Rxt = ({ position: t }) => {
  switch (t) {
    case "top":
      return { bottom: "100%", marginBottom: 6 };
    case "left":
      return { right: "100%", marginRight: 6 };
    case "right":
      return { left: "100%", marginLeft: 6 };
    case "bottom":
    default:
      return { top: "100%", marginTop: 6 };
  }
}, wie = (t, e, n) => ({
  initial: { opacity: 0, [t]: e },
  animate: { opacity: 1, [t]: 0 },
  exit: { opacity: 0, [t]: e },
  transformTemplate: n ? (r) => t === "y" ? `translate(-50%, ${r[t]})` : `translate(${r[t]}, -50%)` : void 0
}), Pxt = ({ position: t, alignment: e }) => {
  const n = e === "middle";
  return t === "top" || t === "bottom" ? wie("y", t === "bottom" ? -12 : 12, n) : wie("x", t === "right" ? -12 : 12, n);
}, $xt = ({
  position: t,
  alignment: e,
  triggerRect: n,
  popoverRect: r
}) => {
  const o = {
    top: n.top,
    bottom: window.innerHeight - n.bottom,
    left: n.left,
    right: window.innerWidth - n.right
  }, i = {
    top: r.height <= o.top,
    bottom: r.height <= o.bottom,
    left: r.width <= o.left,
    right: r.width <= o.right
  }, s = i[t] && t || i.bottom && "bottom" || i.top && "top" || i.right && "right" || i.left && "left" || t, a = s === "top" || s === "bottom" ? {
    start: n.left + r.width <= window.innerWidth,
    middle: n.left + n.width / 2 - r.width / 2 >= 0 && n.left + n.width / 2 + r.width / 2 <= window.innerWidth,
    end: n.right - r.width >= 0
  } : {
    start: n.top + r.height <= window.innerHeight,
    middle: n.top + n.height / 2 - r.height / 2 >= 0 && n.top + n.height / 2 + r.height / 2 <= window.innerHeight,
    end: n.bottom - r.height >= 0
  }, l = a[e] && e || a.start && "start" || a.middle && "middle" || a.end && "end" || e;
  return { fallbackPosition: s, fallbackAlignment: l };
}, Mxt = ({
  id: t,
  position: e = "bottom",
  alignment: n = "start",
  width: r = "auto",
  variant: o = "menu",
  onOpen: i,
  onPopoverKeyDown: s,
  onTriggerKeyDown: a,
  disableClose: l = !1
}) => {
  const [c, u] = Ye(!1), [d, f] = Ye(e), [h, p] = Ye(n), [m, g] = Ye(null), [y, v] = Ye(!1), b = r === "auto", _ = Ue(null), w = Ue(null), x = Ue(null), E = (A) => {
    u(A), i?.(A);
  }, S = () => {
    l && c || E(!c);
  }, C = () => {
    l || (E(!1), _.current?.querySelector("button")?.blur(), _.current?.blur());
  }, R = (A) => {
    !c && (A.key === "Enter" || A.key === " ") && (A.preventDefault(), E(!0)), a?.(A, c, C);
  }, P = (A) => s?.(A, c, C), N = () => {
    C();
  };
  return iu(() => {
    if (!c || !y || !_.current || !w.current || !x.current)
      return;
    const A = () => {
      const k = _.current.getBoundingClientRect(), T = w.current.getBoundingClientRect(), { fallbackPosition: I, fallbackAlignment: j } = $xt({
        position: e,
        alignment: n,
        triggerRect: k,
        popoverRect: T
      });
      f(I), p(j), g({
        left: k.left,
        top: k.top,
        height: k.height,
        width: k.width
      });
    };
    A(), w.current.focus();
    const O = (k) => {
      k.stopPropagation();
      const T = x.current.scrollTop === 0 && k.deltaY < 0, I = x.current.scrollHeight - x.current.clientHeight === x.current.scrollTop && k.deltaY > 0;
      (T || I) && k.preventDefault();
    };
    return x.current.addEventListener("wheel", O, { passive: !1 }), window.addEventListener("resize", A), () => {
      x.current.removeEventListener("wheel", O), window.removeEventListener("resize", A);
    };
  }, [c, e, n, y]), {
    open: c,
    triggerProps: {
      ref: _,
      onClick: S,
      onKeyDown: R,
      "aria-haspopup": "listbox",
      "aria-expanded": c,
      className: "flex",
      tabIndex: 0,
      bounds: m ?? { left: 0, top: 0, height: 0, width: 0 }
    },
    overlayProps: {
      hasClearBackground: !0,
      onClick: N,
      onEscape: C,
      onBackdropMount: v
    },
    popoverProps: {
      id: t,
      ref: w,
      role: "listbox",
      className: `dc__position-abs dc__outline-none-imp ${o === "menu" ? "bg__menu--primary shadow__menu" : "bg__overlay--primary shadow__overlay"} border__primary br-6 dc__overflow-hidden ${b ? "dc_width-max-content dc__mxw-250" : ""}`,
      onClick: Xv,
      onKeyDown: P,
      style: {
        width: b ? void 0 : `${r}px`,
        ...Rxt({ position: d }),
        ...Txt({ position: d, alignment: h })
      },
      ...Pxt({ position: d, alignment: h }),
      transition: { duration: 0.2 }
    },
    scrollableRef: x,
    closePopover: C
  };
}, Dxt = {
  ADMIN_PASSWORD: "install/install-devtron#devtron-admin-credentials",
  APP_CI_CONFIG_BUILD_WITHOUT_DOCKER: "usage/applications/creating-application/docker-build-configuration#build-docker-image-without-dockerfile",
  APP_CREATE: "usage/applications/create-application",
  APP_CREATE_CI_CONFIG: "usage/applications/creating-application/docker-build-configuration",
  APP_CREATE_CONFIG_MAP: "usage/applications/creating-application/config-maps",
  APP_CREATE_ENVIRONMENT_OVERRIDE: "usage/applications/creating-application/environment-overrides",
  APP_CREATE_MATERIAL: "usage/applications/creating-application/git-material",
  APP_CREATE_SECRET: "usage/applications/creating-application/secrets",
  APP_CREATE_WORKFLOW: "usage/applications/creating-application/workflow",
  APP_DEPLOYMENT_TEMPLATE: "usage/applications/creating-application/deployment-template",
  APP_EPHEMERAL_CONTAINER: "usage/applications/app-details/ephemeral-containers",
  APP_GROUP: "usage/application-groups",
  APP_METRICS: "usage/applications/app-details/app-metrics",
  APP_OVERVIEW_TAGS: "usage/applications/overview#manage-tags",
  APP_ROLLOUT_DEPLOYMENT_TEMPLATE: "usage/applications/creating-application/deployment-template/rollout-deployment",
  BUILD_STAGE: "usage/applications/creating-application/workflow/ci-pipeline#build-stage",
  APP_TAGS: "usage/applications/create-application#tags",
  BLOB_STORAGE: "configurations-overview/installation-configuration#configuration-of-blob-storage",
  BULK_UPDATE: "usage/bulk-update",
  CHART_GROUP: "usage/deploy-chart/chart-group",
  CHART_LIST: "usage/deploy-chart/overview-of-charts",
  CHART_STORE: "usage/deploy-chart",
  CHART_STORE_METRICS_SERVER: "dashboard//chart-store/discover?appStoreName=metrics-server",
  CUSTOM_VALUES: "usage/deploy-chart/overview-of-charts#custom-values",
  CONFIGURING_WEBHOOK: "usage/applications/creating-application/workflow/ci-pipeline#configuring-webhook",
  DEPLOYMENT: "usage/applications/creating-application/deployment-template/deployment",
  DEPLOYMENT_TEMPLATE: "usage/applications/creating-application/deployment-template",
  DEVTRON_UPGRADE: "getting-started/upgrade",
  DOC_HOME_PAGE: i9,
  ENTERPRISE_LICENSE: "enterprise-license",
  EXECUTE_CUSTOM_SCRIPT: "usage/applications/creating-application/workflow/ci-pipeline/ci-build-pre-post-plugins#execute-custom-script",
  EXTERNAL_LINKS: "getting-started/global-configurations/external-links",
  EXTERNAL_SECRET: "usage/applications/creating-application/secrets#external-secrets",
  HOME_PAGE: "https://devtron.ai",
  JOBS: "usage/jobs",
  KUBE_CONFIG: "usage/resource-browser#running-kubectl-commands-locally",
  RESOURCE_BROWSER: "usage/resource-browser",
  TAINT: "usage/resource-browser#taint-a-node",
  // Global Configurations
  GLOBAL_CONFIGUDATIONS: "getting-started/global-configurations",
  GLOBAL_CONFIG_API_TOKEN: "getting-started/global-configurations/authorization/api-tokens",
  GLOBAL_CONFIG_BUILD_INFRA: "global-configurations/build-infra",
  GLOBAL_CONFIG_CHART: "getting-started/global-configurations/chart-repo",
  GLOBAL_CONFIG_CLUSTER: "getting-started/global-configurations/cluster-and-environments",
  GLOBAL_CONFIG_CUSTOM_CHART: "getting-started/global-configurations/custom-charts",
  GLOBAL_CONFIG_CUSTOM_CHART_PRE_REQUISITES: "global-configurations/deployment-charts#preparing-a-deployment-chart",
  GLOBAL_CONFIG_DOCKER: "getting-started/global-configurations/container-registries",
  GLOBAL_CONFIG_GIT: "getting-started/global-configurations/git-accounts",
  GLOBAL_CONFIG_GITOPS: "global-configurations/gitops",
  GLOBAL_CONFIG_GITOPS_GITHUB: "global-configurations/gitops#github",
  GLOBAL_CONFIG_GITOPS_GITLAB: "global-configurations/gitops#gitlab",
  GLOBAL_CONFIG_GITOPS_AZURE: "global-configurations/gitops#azure",
  GLOBAL_CONFIG_GITOPS_BITBUCKET: "global-configurations/gitops#bitbucket",
  GLOBAL_CONFIG_GROUPS: "getting-started/global-configurations/authorization/permission-groups",
  GLOBAL_CONFIG_HOST_URL: "global-configurations/host-url",
  GLOBAL_CONFIG_NOTIFICATION: "getting-started/global-configurations/manage-notification",
  GLOBAL_CONFIG_PERMISSION: "global-configurations/authorization/user-access#devtron-apps-permissions",
  GLOBAL_CONFIG_PROJECT: "global-configurations/projects",
  GLOBAL_CONFIG_SSO: "getting-started/global-configurations/sso-login",
  GLOBAL_CONFIG_SCOPED_VARIABLES: "getting-started/global-configurations/scoped-variables",
  GLOBAL_CONFIG_USER: "getting-started/global-configurations/authorization/user-access",
  HYPERION: "usage/applications#view-external-helm-app-listing",
  JOB_CRONJOB: "usage/applications/creating-application/deployment-template/job-and-cronjob",
  JOB_SOURCE_CODE: "usage/jobs/configuration-job",
  JOB_WORKFLOW_EDITOR: "usage/jobs/workflow-editor-job",
  K8S_RESOURCES_PERMISSIONS: "global-configurations/authorization/user-access#kubernetes-resources-permissions",
  PRE_POST_BUILD_STAGE: "usage/applications/creating-application/ci-pipeline/ci-build-pre-post-plugins",
  ROLLOUT: "usage/applications/creating-application/deployment-template/rollout-deployment",
  SECURITY: "usage/security-features",
  SPECIFY_IMAGE_PULL_SECRET: "getting-started/global-configurations/container-registries#specify-image-pull-secret",
  TENANT_INSTALLATION: "usage/software-distribution-hub/tenants",
  // ENTERPRISE
  CEL: "https://github.com/google/cel-spec/blob/master/doc/langdef.md",
  KUBERNETES_LABELS: "https://kubernetes.io/docs/concepts/overview/working-with-objects/labels",
  IMAGE_PROMOTION: "global-configurations/image-promotion-policy",
  IMAGE_PROMOTION_ASSIGN_TO: "global-configurations/image-promotion-policy#applying-an-image-promotion-policy",
  TAGS: "usage/applications/create-application#tags",
  TAGS_POLICY: "global-configurations/tags-policy",
  RESOURCE_WATCHER: "usage/resource-watcher",
  GITOPS_BITBUCKET: "global-configurations/gitops#bitbucket",
  DEPLOYMENT_CONFIGS: "resources/glossary#base-deployment-template",
  RJSF_PLAYGROUND: "https://rjsf-team.github.io/react-jsonschema-form/",
  // GLOBAL CONFIGURATION
  GLOBAL_CONFIG_DEPLOYMENT_WINDOW: "global-configurations/deployment-window",
  GLOBAL_CONFIG_CATALOG_FRAMEWORK: "global-configurations/catalog-framework",
  GLOBAL_CONFIG_DEVTRON_APP_TEMPLATES: "global-configurations",
  GLOBAL_CONFIG_FILTER_CONDITION: "global-configurations/filter-condition",
  GLOBAL_CONFIG_LOCK_DEPLOYMENT_CONFIG: "global-configurations/lock-deployment-config",
  GLOBAL_CONFIG_PLUGINS_POLICY: "global-configurations/plugins-policy",
  GLOBAL_CONFIG_APPROVAL_POLICY: "global-configurations/approval-policy",
  GLOBAL_CONFIG_SSO_LOGIN_LDAP: "global-configurations/authorization/sso-login/ldap",
  GLOBAL_CONFIG_SSO_LOGIN_OIDC: "global-configurations/authorization/sso-login/oidc",
  GLOBAL_CONFIG_SSO_LOGIN_MICROSOFT: "global-configurations/authorization/sso-login/microsoft",
  GLOBAL_CONFIG_PULL_IMAGE_DIGEST: "global-configurations/pull-image-digest",
  GLOBAL_CONFIG_TAGS: "getting-started/global-configurations/tags-policy",
  // Application Management
  APP_MANAGEMENT: "docs/user-guide/app-management",
  // Software Release Management
  SOFTWARE_DISTRIBUTION_HUB: "usage/software-distribution-hub",
  RELEASE_TRACKS: "usage/software-distribution-hub/release-hub#creating-release-tracks-and-versions",
  RELEASES: "usage/software-distribution-hub/release-hub#creating-release-tracks-and-versions",
  RELEASE_HUB: "usage/software-distribution-hub/release-hub",
  TENANTS: "usage/software-distribution-hub/tenants#adding-installation",
  TENANTS_INSTALLATION: "usage/software-distribution-hub/tenants",
  // Infrastructure Management
  AUTOSCALER_DETECTION: "docs/user-guide/infra-management/infrastructure-overview#troubleshooting-autoscaler-detection",
  INFRA_MANAGEMENT: "docs/user-guide/infra-management",
  // Cost Visibility
  COST_BREAKDOWN: "docs/user-guide/finops",
  COST_CALCULATION: "docs/user-guide/finops/overview-cost-visibility#how-is-the-cost-calculated",
  COST_VISIBILITY_OVERVIEW: "docs/user-guide/finops/overview-cost-visibility",
  // Security Center
  SECURITY_CENTER: "docs/user-guide/security-features",
  // AI Recommendations
  AI_RECOMMENDATIONS: "docs/user-guide/ai-recommendations",
  // Automation & Enablement
  AUTOMATION_AND_ENABLEMENT: "docs/user-guide/automation"
}, V_e = ({ isEnterprise: t, link: e = "" }) => `${e}?utm_source=product_${t ? "ent" : "oss"}&utm_medium=product_app&utm_campaign=docs_navigation`, Ixt = ({
  docLinkKey: t,
  isEnterprise: e = !1,
  isExternalLink: n,
  isLicenseDashboard: r = !1
}) => {
  if (n)
    return t;
  const o = Dxt[t];
  if (o?.startsWith("http"))
    return o;
  const i = r ? "" : V_e({ isEnterprise: e });
  return `${i9}${Hwt}/${o || ""}${i}`;
}, Nxt = ({ count: t, isApprox: e, isSelected: n }) => /* @__PURE__ */ M.jsxs(
  "div",
  {
    className: `flex dc__no-shrink br-12 dc__gap-2 px-6 ${n ? "bcb-5 cn-0" : "bcn-1 cn-7"} fs-13 fw-6 lh-20`,
    children: [
      e && /* @__PURE__ */ M.jsx(LEe, { className: "dc__no-shrink icon-dim-12 scn-0" }),
      /* @__PURE__ */ M.jsx("span", { children: t })
    ]
  }
), jxt = {
  [Oe.medium]: "w-32",
  [Oe.small]: "w-24"
}, Lxt = {
  [Oe.medium]: "w-28",
  [Oe.small]: "w-24"
}, Fxt = {
  [Oe.medium]: "h-24",
  [Oe.small]: "h-20"
}, Bxt = {
  theme: "B500",
  positive: "G500"
}, zxt = {
  theme: "bcb-5",
  positive: "bcg-5"
}, qxt = {
  theme: "var(--B600)",
  positive: "var(--G600)"
}, Uxt = {
  theme: "bcb-3",
  positive: "bcg-3"
}, Hxt = {
  theme: "var(--B400)",
  positive: "var(--G400)"
}, Vxt = {
  [Oe.medium]: "icon-dim-16",
  [Oe.small]: "icon-dim-12"
}, Wxt = {
  [Oe.medium]: "w-12",
  [Oe.small]: "w-10"
}, Gxt = {
  [Oe.medium]: "p-3",
  [Oe.small]: "p-1"
}, Yxt = {
  rounded: "p-2",
  square: "p-1"
}, Kxt = ({ shape: t, size: e }) => `${Fxt[e]} ${t === "rounded" ? jxt[e] : Lxt[e]}`, Xxt = ({
  shape: t,
  variant: e,
  isChecked: n,
  isLoading: r
}) => r ? "dc__transparent--unstyled" : n ? t === "rounded" ? zxt[e] : Uxt[e] : "bcn-2", Qxt = ({
  shape: t,
  variant: e,
  isChecked: n,
  isLoading: r
}) => r ? "transparent" : n ? t === "rounded" ? qxt[e] : Hxt[e] : "var(--N300)", Zxt = ({
  shape: t,
  size: e,
  showIndeterminateIcon: n
}) => n ? `${Wxt[e]} h-2 br-4 dc__no-shrink bg__white` : `flex ${Gxt[e]} ${t === "rounded" ? `dc__border-radius-50-per ${Vxt[e]}` : "br-3"} bg__white`, Jxt = ({
  iconColor: t,
  isChecked: e,
  variant: n
}) => e ? t || (n === "theme" ? "B500" : "G500") : "N500", eEt = ({
  isChecked: t,
  size: e,
  shape: n,
  indeterminate: r,
  isLoading: o
}) => o ? e === Oe.medium && n === "rounded" ? 6 : 4 : t ? r ? e === Oe.medium ? 8 : 5 : e === Oe.medium && n === "rounded" ? 12 : 8 : 0, tEt = ({ shape: t, isLoading: e }) => e ? "" : Yxt[t], nEt = ({
  ariaLabel: t,
  isDisabled: e,
  isLoading: n,
  isChecked: r,
  tooltipContent: o,
  shape: i = "rounded",
  variant: s = "positive",
  iconColor: a,
  iconName: l,
  indeterminate: c = !1,
  size: u = Oe.medium,
  name: d,
  dataTestId: f = d,
  onChange: h,
  autoFocus: p = !1
}) => {
  const m = Ue(HO()), g = r ? c ? "mixed" : !0 : !1, y = g === "mixed", v = eEt({ isChecked: r, shape: i, size: u, indeterminate: c, isLoading: n }), b = () => /* @__PURE__ */ M.jsx(
    "span",
    {
      className: `flexbox flex-grow-1 ${!n && y ? "dc__align-items-center" : ""} ${tEt({ shape: i, isLoading: n })}`,
      children: n ? /* @__PURE__ */ M.jsx(
        IE.span,
        {
          transition: { ease: "easeInOut", duration: 0.2 },
          animate: {
            x: v
          },
          className: "flexbox dc__fill-available-space",
          children: /* @__PURE__ */ M.jsx(Ut, { name: "ic-circle-loader", color: Bxt[s], size: null })
        }
      ) : /* @__PURE__ */ M.jsx(
        IE.span,
        {
          transition: { ease: "easeInOut", duration: 0.2 },
          animate: {
            x: v
          },
          className: Zxt({ shape: i, size: u, showIndeterminateIcon: y }),
          children: l && !y && /* @__PURE__ */ M.jsx("span", { className: "icon-dim-12 flex dc__fill-available-space dc__no-shrink", children: /* @__PURE__ */ M.jsx(
            Ut,
            {
              name: l,
              color: Jxt({
                isChecked: r,
                iconColor: a,
                variant: s
              }),
              size: null
            }
          ) })
        }
      )
    }
  );
  return /* @__PURE__ */ M.jsx(Ai, { alwaysShowTippyOnHover: !!o, content: o, children: /* @__PURE__ */ M.jsxs(
    "label",
    {
      htmlFor: m.current,
      className: `${Kxt({ shape: i, size: u })} flex dc__no-shrink py-2 m-0`,
      children: [
        /* @__PURE__ */ M.jsx(
          "input",
          {
            type: "checkbox",
            id: m.current,
            name: d,
            checked: r,
            disabled: e,
            readOnly: !0,
            hidden: !0
          }
        ),
        /* @__PURE__ */ M.jsx(
          "button",
          {
            type: "button",
            role: "checkbox",
            autoFocus: p,
            "aria-checked": g,
            "aria-labelledby": m.current,
            "aria-label": n ? "Loading..." : t,
            "data-testid": f,
            disabled: e || n,
            "aria-disabled": e,
            className: `p-0-imp h-100 flex flex-grow-1 dc__no-border dt-switch__track ${i === "rounded" ? "br-12" : "br-4"} ${Xxt({ shape: i, variant: s, isChecked: r, isLoading: n })} ${e ? "dc__disabled" : ""} dc__fill-available-space`,
            onClick: h,
            style: {
              // Adding hover styles directly to the button
              "--switch-track-hover-color": Qxt({
                shape: i,
                variant: s,
                isChecked: r,
                isLoading: n
              })
            },
            children: b()
          }
        )
      ]
    }
  ) });
}, rEt = ({ type: t, config: e, variant: n = "neutral" }) => {
  const r = n === "negative", o = (s) => {
    if (t === "switch") {
      const { onChange: a } = e;
      s.stopPropagation(), a(s);
    }
  }, i = (s) => {
    s.stopPropagation(), t === "button" && e.onClick && e.onClick(s);
  };
  switch (t) {
    case "icon":
      return /* @__PURE__ */ M.jsx("span", { className: "mt-2 flex dc__no-shrink", children: /* @__PURE__ */ M.jsx(Ut, { ...e, color: e.color || (r ? "R500" : "N800") }) });
    case "text": {
      const { value: s, icon: a } = e;
      return /* @__PURE__ */ M.jsxs("span", { className: "flex dc__gap-2 mt-2", children: [
        /* @__PURE__ */ M.jsx("span", { className: "fs-12 lh-1-5 fw-4 cn-7", children: s }),
        a && /* @__PURE__ */ M.jsx(Ut, { name: a.name, color: a.color || (r ? "R500" : "N700") })
      ] });
    }
    case "counter":
      return /* @__PURE__ */ M.jsx(Nxt, { count: e.value, isSelected: e.isSelected });
    case "switch":
      return /* @__PURE__ */ M.jsx(nEt, { ...e, onChange: o, size: Oe.small });
    case "button":
      return /* @__PURE__ */ M.jsx(
        Ar,
        {
          ...e,
          onClick: i,
          variant: Nr.borderLess,
          size: Oe.xxs
        }
      );
    case "action-menu":
      return /* @__PURE__ */ M.jsx(G_e, { ...e });
    default:
      return null;
  }
}, oEt = ({
  item: t,
  itemRef: e,
  isFocused: n,
  onClick: r,
  onMouseEnter: o,
  disableDescriptionEllipsis: i = !1
}) => {
  const {
    id: s,
    description: a,
    label: l,
    startIcon: c,
    trailingItem: u,
    tooltipProps: d,
    type: f = "neutral",
    isDisabled: h,
    componentType: p = "button"
  } = t, { isEnterprise: m } = l9(), g = (S) => {
    n && S && S.scrollIntoView({ block: "nearest", behavior: "smooth" });
  }, y = f === "negative", v = `w-100 flex left top dc__gap-8 py-6 px-8 ${h ? "dc__disabled" : "cursor"}`, b = (S) => {
    h || r(t, S);
  }, _ = (S) => S && /* @__PURE__ */ M.jsx("span", { className: "mt-2 flex dc__no-shrink", children: /* @__PURE__ */ M.jsx(Ut, { ...S, color: S.color || (y ? "R500" : "N800") }) }), w = () => u ? /* @__PURE__ */ M.jsx(rEt, { ...u, variant: f }) : null, x = () => /* @__PURE__ */ M.jsxs(M.Fragment, { children: [
    _(c),
    /* @__PURE__ */ M.jsxs("span", { className: "flex-grow-1", children: [
      /* @__PURE__ */ M.jsx(Ai, { content: l, placement: "right", children: /* @__PURE__ */ M.jsx("span", { className: `m-0 fs-13 fw-4 lh-20 dc__truncate ${y ? "cr-5" : "cn-9"}`, children: l }) }),
      a && (typeof a == "string" ? /* @__PURE__ */ M.jsx(
        "span",
        {
          className: `m-0 fs-12 fw-4 lh-18 cn-7 ${i ? "dc__word-break" : "dc__ellipsis-right__2nd-line"}`,
          children: a
        }
      ) : a)
    ] }),
    w()
  ] }), E = () => {
    switch (p) {
      case "anchor":
        return /* @__PURE__ */ M.jsx(
          "a",
          {
            ref: e,
            className: v,
            href: V_e({ isEnterprise: m, link: t.href }),
            target: "_blank",
            rel: "noreferrer",
            onClick: b,
            "aria-disabled": h,
            children: x()
          }
        );
      case "link":
        return /* @__PURE__ */ M.jsx(
          QE,
          {
            ref: e,
            className: v,
            to: t.to,
            onClick: b,
            "aria-disabled": h,
            children: x()
          }
        );
      case "button":
      default:
        return /* @__PURE__ */ M.jsx(
          "button",
          {
            ref: e,
            type: "button",
            className: `dc__transparent ${v}`,
            onClick: b,
            disabled: h,
            children: x()
          }
        );
    }
  };
  return /* @__PURE__ */ M.jsx(Ai, { ...gxt(d), children: /* @__PURE__ */ M.jsx(
    "li",
    {
      ref: g,
      role: "menuitem",
      "data-testid": `action-menu-item-${s}`,
      onMouseEnter: o,
      tabIndex: -1,
      className: `action-menu__option br-4 mr-4 ml-4 ${!h && (y ? "dc__hover-r50" : "dc__hover-n50") || ""} ${n ? `action-menu__option--focused${y ? "-negative" : ""}` : ""}`,
      "aria-disabled": h,
      children: E()
    }
  ) });
}, iEt = (t) => t.flatMap(
  (e, n) => e.items.map((r, o) => ({
    option: r,
    itemIndex: o,
    sectionIndex: n
  })),
  []
), W_e = (t) => t.toLowerCase(), sEt = (t, e) => W_e(t).includes(e), aEt = (t, e) => {
  if (!e)
    return t;
  const n = W_e(e);
  return t.map((r) => {
    const o = r.items.filter((i) => sEt(i.label, n));
    return o.length > 0 ? { ...r, items: o } : null;
  }).filter(Boolean);
}, lEt = ({
  id: t,
  position: e = "bottom",
  alignment: n = "start",
  width: r = "auto",
  options: o,
  isSearchable: i,
  onOpen: s
}) => {
  const [a, l] = Ye(-1), [c, u] = Ye(""), d = i ? aEt(o, c) : o, f = iEt(d), h = Ue(
    f.map(() => g8())
  );
  Ne(() => {
    h.current = f.map(() => g8());
  }, [f.length]);
  const p = (S) => {
    u(S.target.value);
  }, m = (S, C) => {
    let R = S;
    const P = f.length;
    for (let N = 0; N < P; N++)
      if (R = (R + C + P) % P, !f[R]?.option?.isDisabled)
        return R;
    return S;
  }, g = (S, C, R) => {
    if (S.stopPropagation(), C)
      switch (S.key) {
        case "Escape":
          S.preventDefault(), R();
          break;
        case "ArrowDown":
        case "Tab":
          if (S.preventDefault(), S.shiftKey && S.key === "Tab") {
            l((P) => m(P, -1));
            break;
          }
          l((P) => m(P, 1));
          break;
        case "ArrowUp":
          S.preventDefault(), l((P) => m(P, -1));
          break;
        case "Enter":
        case " ": {
          S.preventDefault();
          const P = f[a].option, N = h.current[a].current;
          !P.isDisabled && N && N.click();
          break;
        }
      }
  }, y = (S, C) => {
    !C && (S.key === "Enter" || S.key === " ") && l(0);
  }, { open: v, closePopover: b, overlayProps: _, popoverProps: w, triggerProps: x, scrollableRef: E } = Mxt({
    id: t,
    position: e,
    alignment: n,
    width: r,
    onOpen: s,
    onPopoverKeyDown: g,
    onTriggerKeyDown: y
  });
  return Ne(() => {
    v || (l(-1), u(""));
  }, [v]), {
    open: v,
    flatOptions: f,
    filteredOptions: d,
    focusedIndex: a,
    itemsRef: h,
    triggerProps: x,
    overlayProps: _,
    popoverProps: w,
    setFocusedIndex: l,
    closePopover: b,
    searchTerm: c,
    handleSearch: p,
    scrollableRef: E
  };
}, G_e = ({
  id: t,
  options: e,
  onClick: n,
  position: r,
  alignment: o,
  width: i,
  isSearchable: s,
  disableDescriptionEllipsis: a,
  buttonProps: l,
  children: c,
  onOpen: u,
  footerConfig: d
}) => {
  const {
    open: f,
    filteredOptions: h,
    flatOptions: p,
    triggerProps: m,
    overlayProps: g,
    popoverProps: y,
    focusedIndex: v,
    searchTerm: b,
    handleSearch: _,
    itemsRef: w,
    setFocusedIndex: x,
    closePopover: E,
    scrollableRef: S
  } = lEt({
    id: t,
    options: e,
    position: r,
    alignment: o,
    width: i,
    isSearchable: s,
    onOpen: u
  }), C = (P) => () => x(P), R = (P, N) => {
    n(P, N), P.doNotCloseMenuOnClick || E();
  };
  return /* @__PURE__ */ M.jsx(
    Axt,
    {
      open: f,
      overlayProps: g,
      popoverProps: y,
      triggerProps: m,
      buttonProps: l,
      triggerElement: c,
      children: /* @__PURE__ */ M.jsxs("div", { className: "flexbox-col mxh-300", children: [
        s && /* @__PURE__ */ M.jsx(
          "div",
          {
            role: "search",
            className: "action-menu__searchbox bg__primary border__secondary-translucent--bottom",
            children: /* @__PURE__ */ M.jsx(
              Sxt,
              {
                name: "action-menu-search-box",
                value: b,
                placeholder: "Search",
                onChange: _,
                fullWidth: !0,
                autoFocus: !0
              }
            )
          }
        ),
        /* @__PURE__ */ M.jsx(
          "ul",
          {
            ref: S,
            role: "menu",
            className: "action-menu m-0 p-0 flex-grow-1 dc__overflow-auto dc__overscroll-none",
            children: h.length > 0 ? h.map((P, N) => /* @__PURE__ */ M.jsxs(
              "li",
              {
                role: "menuitem",
                className: "action-menu__group flexbox-col dc__gap-4 py-4",
                children: [
                  P.groupLabel && /* @__PURE__ */ M.jsx("h4", { className: "bg__menu--secondary dc__truncate m-0 fs-12 lh-18 cn-9 fw-6 py-4 px-12 dc__position-sticky dc__top-0 dc__zi-1", children: P.groupLabel }),
                  P.items.length > 0 ? /* @__PURE__ */ M.jsx("ul", { className: "action-menu__group-list p-0", children: P.items.map((A, O) => {
                    const k = p.findIndex(
                      (T) => T.sectionIndex === N && T.itemIndex === O
                    );
                    return /* @__PURE__ */ M.jsx(
                      oEt,
                      {
                        item: A,
                        itemRef: w.current[k],
                        isFocused: k === v,
                        onMouseEnter: C(k),
                        onClick: R,
                        disableDescriptionEllipsis: a
                      },
                      `${A.label}-${A.id}`
                    );
                  }) }) : /* @__PURE__ */ M.jsx("p", { className: "m-0 fs-13 lh-18 fw-4 cn-7 py-6 px-12", children: "No options in this group" })
                ]
              },
              P.groupLabel || `no-group-label-${N}`
            )) : /* @__PURE__ */ M.jsx("li", { role: "menuitem", className: "py-8 px-12", children: /* @__PURE__ */ M.jsx("p", { className: "m-0 fs-13 lh-20 fw-4 cn-7", children: "No options" }) })
          }
        ),
        d && /* @__PURE__ */ M.jsx("div", { className: "border__secondary-translucent--top", children: /* @__PURE__ */ M.jsx(yxt, { menuListFooterConfig: d }) })
      ] })
    }
  );
};
lr(null);
const cEt = (t) => {
  const e = Ue(null), [n, r] = Ye(!1), o = t.theme === r9.white, i = (b) => {
    b.keyCode === 27 && a(b);
  }, s = (b) => {
    e.current = b, document.addEventListener("keydown", i);
  }, a = (b) => {
    t.disableClose || (Xv(b), e.current?.hide && (e.current.hide(), e.current = null, t.onClose && t.onClose()), r(!1), document.removeEventListener("keydown", i));
  }, l = (b) => {
    r(WOt);
  }, c = () => {
    const {
      Icon: b,
      iconPath: _,
      iconClass: w,
      iconSize: x,
      onImageLoadError: E,
      heading: S,
      headingInfo: C,
      infoTextHeading: R,
      hideHeading: P,
      infoText: N,
      showCloseButton: A,
      additionalContent: O,
      documentationLink: k,
      documentationLinkText: T,
      isExternalLink: I,
      openInNewTab: j
    } = t;
    return /* @__PURE__ */ M.jsxs(M.Fragment, { children: [
      !P && /* @__PURE__ */ M.jsxs(
        "div",
        {
          className: `dc__word-break dc__hyphens-auto flex dc__align-start left ${o ? `p-12 cn-9 ${t.noHeadingBorder ? "" : "border__secondary-translucent--bottom"}` : "pt-20 pb-12 pr-20 pl-20 cn-0 top"}`,
          children: [
            _ ? /* @__PURE__ */ M.jsx(
              "img",
              {
                className: `icon-dim-${x || 20} mr-6 ${w || ""}`,
                src: _,
                alt: "Heading",
                onError: E
              }
            ) : b && /* @__PURE__ */ M.jsx("div", { className: `icon-dim-${x || 20} mr-6`, children: /* @__PURE__ */ M.jsx(b, { className: `icon-dim-${x || 20} ${w || ""}` }) }),
            S && /* @__PURE__ */ M.jsx("span", { className: `fs-14 fw-6 lh-20 ${A ? "mr-12" : ""}`, children: S }),
            C && /* @__PURE__ */ M.jsx("div", { className: "icon-dim-20 cursor", onClick: l, children: /* @__PURE__ */ M.jsx(Vse, { className: "icon-dim-20" }) }),
            A && /* @__PURE__ */ M.jsx("div", { className: "icon-dim-16 ml-auto", children: /* @__PURE__ */ M.jsx(
              Hse,
              {
                className: `icon-dim-16 cursor ${o ? "fcn-9" : "icon-fill__white"}`,
                onClick: a
              }
            ) })
          ]
        }
      ),
      n && /* @__PURE__ */ M.jsxs(
        "div",
        {
          className: `flex left top bcv-1 fs-13 fw-4 lh-20 pt-8 pb-8 ${o ? "pl-12 pr-12" : "pl-20 pr-20"}`,
          children: [
            /* @__PURE__ */ M.jsx("div", { className: "icon-dim-20 mr-8", children: /* @__PURE__ */ M.jsx(L3, { className: "icon-dim-20 fcv-5" }) }),
            /* @__PURE__ */ M.jsx("div", { className: "dc__word-break dc__hyphens-auto", children: C })
          ]
        }
      ),
      R && /* @__PURE__ */ M.jsx(
        "div",
        {
          className: `dc__word-break dc__hyphens-auto fs-14 fw-6 lh-20 ${o ? "pl-12 pr-12" : "pl-20 pr-20"}`,
          children: R
        }
      ),
      N && /* @__PURE__ */ M.jsx(
        "div",
        {
          className: `dc__word-break dc__hyphens-auto fs-13 fw-4 lh-20 ${o ? "p-12" : `pl-20 pr-20 pt-4 ${O && k ? "pb-12" : "pb-20"}`}`,
          children: N
        }
      ),
      O,
      k && /* @__PURE__ */ M.jsx("div", { className: "px-12 pb-12 flexbox", children: /* @__PURE__ */ M.jsx(
        zEt,
        {
          text: T,
          dataTestId: "learn-more-about-tippy-link",
          showExternalIcon: !0,
          onClick: a,
          isExternalLink: I,
          docLinkKey: k,
          openInNewTab: j
        }
      ) })
    ] });
  }, { className: u, placement: d, arrow: f, interactive: h, showOnCreate: p, trigger: m, animation: g, duration: y, children: v } = t;
  return /* @__PURE__ */ M.jsx(
    hS,
    {
      className: `${o ? "tippy-white-container default-white" : "tippy-black-container default-black"} no-content-padding tippy-shadow ${u}`,
      arrow: f || !1,
      interactive: h || !1,
      placement: d || "top",
      content: c(),
      trigger: m || "mouseenter",
      onMount: s,
      onClickOutside: (b, _) => a(_),
      showOnCreate: p || !1,
      animation: g || "fade",
      duration: y || 300,
      visible: t.visible,
      appendTo: t.appendTo,
      children: v
    }
  );
}, uEt = ({
  heading: t,
  infoText: e,
  iconClass: n = "fcv-5",
  documentationLink: r,
  documentationLinkText: o,
  additionalContent: i,
  iconClassName: s = "icon-dim-16 dc__no-shrink",
  placement: a = "bottom",
  dataTestid: l = "info-tippy-button",
  children: c,
  headingInfo: u,
  buttonPadding: d = "p-0",
  isExternalLink: f,
  openInNewTab: h
}) => /* @__PURE__ */ M.jsx(
  cEt,
  {
    theme: r9.white,
    headingInfo: u,
    className: "w-300 h-100 dc__no-text-transform",
    placement: a,
    Icon: L3,
    heading: t,
    infoText: e,
    iconClass: n,
    showCloseButton: !0,
    trigger: "click",
    interactive: !0,
    documentationLink: r,
    documentationLinkText: o,
    additionalContent: i,
    animation: "shift-toward",
    duration: 400,
    isExternalLink: f,
    openInNewTab: h,
    children: c || /* @__PURE__ */ M.jsx(
      "button",
      {
        type: "button",
        className: `${d} dc__no-background dc__no-border dc__outline-none-imp flex dc__tab-focus dc__no-shrink`,
        "aria-label": "Info Icon",
        "data-testid": l,
        children: /* @__PURE__ */ M.jsx(Vse, { className: s })
      }
    )
  }
), Yv = t9({
  ajvOptionsOverrides: {
    strict: !0,
    allowUnionTypes: !0
  }
});
Yv.ajv.addKeyword("hidden");
Yv.ajv.addKeyword({
  keyword: "placeholder",
  type: ["string", "number"],
  schemaType: "string",
  // placeholder itself should be a string
  errors: !1
});
Yv.ajv.addKeyword("updatePath");
Yv.ajv.addFormat("memory", /^\d+(\.\d+)?(Ki|Mi|Gi|Ti|Pi|Ei|KiB|MiB|GiB|TiB|PiB|EiB)?$/);
Yv.ajv.addFormat("cpu", /^(?:\d+(\.\d+)?|(\d+)(m))$/);
const Kv = t9({ ajvOptionsOverrides: { strict: !1 } });
Kv.ajv.addKeyword("hidden");
Kv.ajv.addKeyword({
  keyword: "placeholder",
  type: ["string", "number"],
  schemaType: "string",
  // placeholder itself should be a string
  errors: !1
});
Kv.ajv.addKeyword("updatePath");
Kv.ajv.addFormat("memory", /^\d+(\.\d+)?(Ki|Mi|Gi|Ti|Pi|Ei|KiB|MiB|GiB|TiB|PiB|EiB)?$/);
Kv.ajv.addFormat("cpu", /^(?:\d+(\.\d+)?|(\d+)(m))$/);
const Y_e = "k8sEmptyGroup", xie = (t) => {
  t ? (document.body.style.overflowY = "hidden", document.body.style.height = "100vh", document.documentElement.style.overflow = "initial") : (document.body.style.overflowY = null, document.body.style.height = null, document.documentElement.style.overflow = null);
}, mD = (t, e, n = lo.ASC, r = !0) => r ? n === lo.ASC ? t.localeCompare(e) : e.localeCompare(t) : n === lo.ASC ? t.toLowerCase().localeCompare(e.toLowerCase()) : e.toLowerCase().localeCompare(t.toLowerCase()), dEt = (t, e = {}, n) => {
  const { defaultIntersecting: r, once: o, ...i } = e, s = Ue(i), [a, l] = Ye(r === !0), c = Ue(!1);
  return Ne(() => {
    XOt(s.current, i) || (s.current = i);
  }), Ne(() => {
    if (t == null)
      return;
    const u = t instanceof Element ? t : t.current;
    if (u == null || o && c.current)
      return;
    const d = new IntersectionObserver(
      ([f]) => {
        l(f.isIntersecting), f.isIntersecting && (c.current = !0), o && f.isIntersecting && u != null && d.unobserve(u);
      },
      {
        ...s.current,
        root: s.current.root != null ? s.current.root.current : null
      }
    );
    return d.observe(u), () => {
      o && c.current || u != null && d.unobserve(u);
    };
  }, [s.current, t]), a;
}, qE = (t) => t == null, Th = (t) => !!t && t !== T_e, K_e = (t) => () => {
  window.open(t, "_blank", "noreferrer");
}, HO = (t) => W5e(t), fEt = (t = "") => t.includes("git-codecommit.") && t.includes(".amazonaws.com"), hEt = (t = "") => {
  const e = "dc__vertical-align-middle icon-dim-20 dc__no-shrink";
  return t.includes("gitlab") ? /* @__PURE__ */ M.jsx(IAe, { className: e }) : t.includes("github") ? /* @__PURE__ */ M.jsx(DAe, { className: `${e} fcn-8` }) : t.includes("bitbucket") ? /* @__PURE__ */ M.jsx(Wse, { className: e }) : fEt(t) ? /* @__PURE__ */ M.jsx($Ae, { className: "dc__vertical-align-middle icon-dim-18" }) : /* @__PURE__ */ M.jsx(MAe, { className: e });
}, h9 = (t = {}) => {
  const { top: e = !0, right: n = !0, bottom: r = !0, left: o = !0 } = t;
  return { top: e, right: n, bottom: r, left: o };
}, pEt = (t = {}) => {
  const { top: e, right: n, bottom: r, left: o } = h9(t);
  return `${e ? "" : "dc__no-top-radius"} ${n ? "" : "dc__no-right-radius"} ${r ? "" : "dc__no-bottom-radius"} ${o ? "" : "dc__no-left-radius"}`;
}, mEt = (t = {}) => {
  const { top: e, right: n, bottom: r, left: o } = h9(t);
  return `${e ? "" : "dc__no-border-top-imp"} ${n ? "" : "dc__no-border-right-imp"} ${r ? "" : "dc__no-border-bottom-imp"} ${o ? "" : "dc__no-border-left-imp"}`;
}, X_e = ({
  borderConfig: t,
  borderRadiusConfig: e
}) => {
  const { top: n, right: r, bottom: o, left: i } = h9(e);
  return `${mEt(t)} ${pEt({ top: n, right: r, bottom: o, left: i })}`;
}, gEt = (t) => {
  if (!t)
    return "";
  let e = "";
  return t.Group && (e += t.Group), t.Version && (e += e ? ` / ${t.Version}` : t.Version), t.Kind && (e += e ? ` / ${t.Kind}` : t.Kind), e;
}, yp = {
  BranchFixed: "SOURCE_TYPE_BRANCH_FIXED",
  WEBHOOK: "WEBHOOK",
  BranchRegex: "SOURCE_TYPE_BRANCH_REGEX"
};
function Q_e(t, e) {
  if (!t || !e)
    return "NA";
  if (t.indexOf("gitlab") > 0 || t.indexOf("github") > 0 || t.indexOf("azure") > 0) {
    const n = t.split("@");
    if (n.length > 1)
      return `https://${n[1].split(".git")[0]}/commit/${e}`;
    if (n.length == 1)
      return `${n[0].split(".git")[0]}/commit/${e}`;
  }
  if (t.indexOf("bitbucket") > 0) {
    const n = t.split("@");
    if (n.length > 1)
      return `https://${n[1].split(".git")[0]}/commits/${e}`;
    if (n.length == 1)
      return `${n[0].split(".git")[0]}/commits/${e}`;
  }
  return "NA";
}
function Eie(t) {
  const e = `${rf.GIT_HOST_EVENT}/${t}`;
  return w9(e);
}
const Sie = 1, yEt = () => {
  const [t, e] = Ye(!1);
  return {
    isTextTruncated: t,
    handleMouseEnterEvent: (n) => {
      const { currentTarget: r } = n, o = r.scrollWidth > r.clientWidth + Sie || r.scrollHeight > r.clientHeight + Sie;
      o && !t ? e(!0) : !o && t && e(!1);
    }
  };
}, Z_e = lr(null), vEt = () => Hn(Z_e), A_ = (t) => {
  if (!t)
    throw new Error("keys undefined");
  const e = t.map((n) => `${n}`.toUpperCase()).sort();
  return {
    keys: e,
    id: e.join()
  };
}, T_ = (t) => {
  if (!t || !Array.isArray(t) || !t.every((e) => typeof e == "function"))
    throw new Error("callback stack is undefined");
}, bEt = ["input", "textarea", "select"], _Et = 300, wEt = ({
  shouldHookOntoWindow: t = !0,
  ignoreTags: e,
  preventDefault: n = !1,
  shortcutTimeout: r,
  children: o
}) => {
  const i = Ue(!1), s = Ue({}), a = Ue(/* @__PURE__ */ new Set()), l = Ue(-1), c = e ?? bEt, u = Cn(
    ({ keys: v, callback: b, description: _ = "" }) => {
      const { keys: w, id: x } = A_(v);
      if (typeof b != "function")
        throw new Error("callback provided is not a function");
      const E = s.current[x] && p1e(s.current[x].keys, v) ? s.current[x] : null;
      if (E) {
        T_(E.callbackStack), E.callbackStack.push(b);
        return;
      }
      s.current[x] = { keys: w, callbackStack: [b], description: _ };
    },
    []
  ), d = Cn((v) => {
    const { id: b } = A_(v);
    if (!s.current[b])
      return;
    const { callbackStack: _ } = s.current[b];
    T_(_), _.pop(), _.length || delete s.current[b];
  }, []), f = Cn((v) => {
    i.current = v;
  }, []), h = Cn((v) => {
    const { id: b } = A_(v);
    if (!s.current[b])
      return;
    const { callbackStack: _ } = s.current[b];
    T_(_), _[_.length - 1]();
  }, []), p = Cn(() => {
    if (!a.current.size)
      return;
    const { id: v } = A_(Array.from(a.current.values()));
    if (s.current[v]) {
      const { callbackStack: b } = s.current[v];
      T_(b), b[b.length - 1]();
    }
    a.current.clear(), l.current > -1 && (clearTimeout(l.current), l.current = -1);
  }, []), m = Cn((v) => {
    !v.key || c.map((b) => b.toUpperCase()).indexOf(v.target.tagName?.toUpperCase()) > -1 || v.target?.role === "textbox" || i.current || (n && v.preventDefault(), a.current.add(v.key.toUpperCase()), v.ctrlKey && a.current.add("CONTROL"), v.metaKey && a.current.add("META"), v.altKey && a.current.add("ALT"), v.shiftKey && a.current.add("SHIFT"), l.current === -1 && (l.current = setTimeout(() => {
      p();
    }, r ?? _Et)));
  }, []), g = Cn(() => {
    a.current.clear();
  }, []);
  Ne(() => t ? (window.addEventListener("keydown", m), window.addEventListener("keyup", p), window.addEventListener("blur", g), () => {
    window.removeEventListener(
      "keydown",
      m
    ), window.removeEventListener("keyup", p), window.removeEventListener("blur", g), l.current > -1 && clearTimeout(l.current);
  }) : eo, [p, m, g, t]);
  const y = cn(
    () => ({
      registerShortcut: u,
      unregisterShortcut: d,
      setDisableShortcuts: f,
      triggerShortcut: h,
      ...t ? {} : { targetProps: { onKeyDown: m, onKeyUp: p, onBlur: g } }
    }),
    [
      u,
      d,
      f,
      h,
      t,
      m,
      p,
      g
    ]
  );
  return /* @__PURE__ */ M.jsx(Z_e.Provider, { value: y, children: o });
}, Rh = 1, xEt = {
  PAGE_SIZE: "pageSize",
  PAGE_NUMBER: "pageNumber",
  SEARCH_KEY: "searchKey",
  SORT_BY: "sortBy",
  SORT_ORDER: "sortOrder"
}, EEt = ({
  initialSortKey: t,
  defaultPageSize: e = s9
} = {}) => {
  const [n, r] = Ye({
    sortOrder: lo.ASC,
    sortBy: t
  }), [o, i] = Ye(""), { sortBy: s, sortOrder: a } = n, [l, c] = Ye({
    pageSize: e,
    pageNumber: Rh
  }), u = l.pageSize * (l.pageNumber - 1), d = () => {
    c((f) => ({
      ...f,
      pageNumber: Rh
    }));
  };
  return {
    ...n,
    handleSorting: (f) => {
      let h;
      f === s && a === lo.ASC ? h = lo.DESC : h = lo.ASC, r(() => ({
        ...n,
        sortBy: f,
        sortOrder: h
      })), d();
    },
    searchKey: o,
    handleSearch: (f) => {
      i(f?.trim() ?? ""), d();
    },
    clearFilters: () => {
      i(""), r({
        sortOrder: lo.ASC,
        sortBy: t
      }), c({
        pageSize: e,
        pageNumber: Rh
      });
    },
    ...l,
    changePage: (f) => {
      c({
        ...l,
        pageNumber: f
      });
    },
    changePageSize: (f) => {
      c({
        ...l,
        pageSize: f
      }), d();
    },
    offset: u,
    areFiltersApplied: !!o
  };
}, Oie = (t, e) => {
  t && localStorage.setItem(t, e);
}, SEt = (t) => !t || !Object.keys(t).length ? !1 : Object.keys(t).some((e) => qE(t[e]) ? !1 : Array.isArray(t[e]) || typeof t[e] == "string" ? t[e].length > 0 : !0), { PAGE_SIZE: Cie, PAGE_NUMBER: gD, SEARCH_KEY: kie, SORT_BY: Aie, SORT_ORDER: Tie } = xEt, OEt = ({
  initialSortKey: t,
  parseSearchParams: e,
  localStorageKey: n,
  redirectionMethod: r = "replace",
  defaultPageSize: o = s9
} = {}) => {
  const i = N3(), s = Yy(), a = Ue(!1), l = (() => {
    const _ = new URLSearchParams(i.search);
    if (!a.current && n)
      if (i.search)
        Oie(
          n,
          JSON.stringify(e(_))
        );
      else {
        a.current = !0;
        const w = localStorage.getItem(n);
        if (w)
          try {
            const x = b9("", JSON.parse(w)), E = new URLSearchParams(x.split("?")[1] ?? "");
            return s.replace({ search: E.toString() }), E;
          } catch {
            localStorage.removeItem(n);
          }
      }
    return _;
  })(), c = (_) => e ? e(_) : {}, { pageSize: u, pageNumber: d, searchKey: f, sortBy: h, sortOrder: p, parsedParams: m } = cn(() => {
    const _ = l.get(Cie), w = l.get(gD), x = l.get(kie), E = l.get(Tie), S = l.get(Aie) || t || "", C = Object.values(lo).includes(E) ? E : lo.ASC, R = c(l);
    return {
      pageSize: Number(_) || o,
      pageNumber: Number(w) || Rh,
      searchKey: x || "",
      sortBy: S,
      // sort order should only be applied if the key is available
      sortOrder: S ? C : "",
      parsedParams: R
    };
  }, [l]), g = u * (d - 1), y = (_, w) => {
    const x = { search: _ };
    (w.redirectionMethod ?? r) === "push" ? s.push(x) : s.replace(x);
  }, v = (_, w, x = {}) => {
    l.set(_, String(w)), y(l.toString(), x);
  }, b = (_ = {}) => {
    if (d !== Rh) {
      v(gD, Rh, _);
      return;
    }
    y(l.toString(), _);
  };
  return {
    pageSize: u,
    changePage: (_) => {
      v(gD, _);
    },
    changePageSize: (_) => {
      v(Cie, _), b();
    },
    searchKey: f,
    handleSearch: (_) => {
      v(kie, _), b();
    },
    offset: g,
    sortBy: h,
    sortOrder: p,
    handleSorting: (_) => {
      let w;
      _ === h && p === lo.ASC ? w = lo.DESC : w = lo.ASC, v(Aie, _), v(Tie, w), b();
    },
    clearFilters: () => {
      y("", {}), n && localStorage.removeItem(n);
    },
    ...m,
    updateSearchParams: (_, w = {}) => {
      Object.keys(_).forEach((x) => {
        R_e.includes(_[x]) ? l.delete(x) : Array.isArray(_[x]) ? (l.delete(x), _[x].forEach((E) => {
          l.append(x, E);
        })) : l.set(x, _[x]);
      }), Oie(n, JSON.stringify(c(l))), b(w);
    },
    areFiltersApplied: !!f || SEt(m)
  };
};
let yD;
const Rie = () => ({
  width: window.innerWidth,
  height: window.innerHeight
}), J_e = () => {
  const [t, e] = Ye(Rie);
  function n(r) {
    yD && window.cancelAnimationFrame(yD), yD = window.requestAnimationFrame(() => {
      e(Rie());
    });
  }
  return Ne(() => (window.addEventListener("resize", n, !1), () => window.removeEventListener("resize", n, !1)), []), t;
}, CEt = {
  Control: "Ctrl",
  Shift: "⇧",
  Meta: _ie ? "⌘" : "Win",
  Alt: _ie ? "⌥" : "Alt",
  F: "F",
  E: "E",
  R: "R",
  K: "K",
  X: "X",
  A: "A",
  N: "N",
  S: "S",
  "/": "/",
  Escape: "Esc",
  Enter: "↩",
  ArrowLeft: "←",
  ArrowRight: "→",
  ArrowUp: "↑",
  ArrowDown: "↓",
  PageUp: "PgUp",
  PageDown: "PgDn",
  Home: "Home",
  End: "End",
  Backspace: "⌫",
  Delete: "⌦",
  ".": ".",
  Space: "Space",
  ">": ">"
}, kEt = ({ text: t, combo: e }) => /* @__PURE__ */ M.jsxs("div", { className: "flexbox dc__gap-8 px-8 py-4 flex-wrap", children: [
  /* @__PURE__ */ M.jsx("span", { className: "lh-18 fs-12 fw-4 text__white", children: t }),
  !!e?.length && /* @__PURE__ */ M.jsx("div", { className: "flexbox dc__gap-4 dc__align-items-center flex-wrap", children: e.map((n) => /* @__PURE__ */ M.jsx("kbd", { className: "shortcut-keys__chip dc__capitalize lh-16 fs-11 fw-5 flex text__white", children: CEt[n] }, n)) })
] }), Ai = ({
  shortcutKeyCombo: t,
  alwaysShowTippyOnHover: e,
  // NOTE: if alwaysShowTippyOnHover or shortcutKeyCombo are being passed by user don't apply truncation logic at all
  showOnTruncate: n = e === void 0 && t === void 0,
  wordBreak: r = !0,
  children: o,
  plugins: i = [],
  ...s
}) => {
  const { isTextTruncated: a, handleMouseEnterEvent: l } = yEt();
  return n && a || t && (e === void 0 || e) || e ? /* @__PURE__ */ M.jsx(
    hS,
    {
      arrow: !1,
      placement: "top",
      maxWidth: "",
      ...s,
      ...t ? { content: /* @__PURE__ */ M.jsx(kEt, { ...t }) } : {},
      className: `${t ? "shortcut-keys__tippy" : "default-tt"} ${r ? "dc__word-break" : ""} dc__mxw-200 ${s.className ?? ""}`,
      plugins: [...i, yje],
      children: Gi(o, { ...o.props, onMouseEnter: l })
    }
  ) : Gi(o, { ...o.props, onMouseEnter: l });
};
var Nr = /* @__PURE__ */ ((t) => (t.primary = "primary", t.secondary = "secondary", t.borderLess = "border-less", t.text = "text", t))(Nr || {}), Ti = /* @__PURE__ */ ((t) => (t.default = "default", t.negative = "negative", t.negativeGrey = "negative-grey", t.positive = "positive", t.warning = "warning", t.neutral = "neutral", t.neutralN0 = "neutral-n0", t.neutralWhite = "neutral-white", t))(Ti || {}), Ph = /* @__PURE__ */ ((t) => (t.button = "button", t.link = "link", t.anchor = "anchor", t))(Ph || {});
const AEt = {
  [Oe.xxs_small_icon]: `${rl[Oe.xxs]} px-9 dc__gap-6 mw-48`,
  [Oe.xxxs]: `${rl[Oe.xxs]} px-9 dc__gap-6 mw-48`,
  [Oe.xxs]: `${rl[Oe.xxs]} px-9 dc__gap-6 mw-48`,
  [Oe.xs]: `${rl[Oe.xs]} px-9 dc__gap-6 mw-48`,
  [Oe.small]: `${rl[Oe.small]} px-9 dc__gap-8 mw-48`,
  [Oe.medium]: `${rl[Oe.medium]} px-11 dc__gap-8 mw-48`,
  [Oe.large]: `${rl[Oe.large]} px-13 dc__gap-8 mw-64`,
  [Oe.xl]: `${rl[Oe.xl]} px-15 dc__gap-12 mw-64`
}, TEt = {
  bold: "fw-6",
  normal: "fw-4"
}, REt = {
  [Oe.xxs_small_icon]: "p-4",
  [Oe.xxxs]: "p-1",
  [Oe.xxs]: "p-1",
  [Oe.xs]: "p-3",
  [Oe.small]: "p-5",
  [Oe.medium]: "p-7",
  [Oe.large]: "p-7",
  [Oe.xl]: "p-7"
};
Oe.xxs_small_icon + "", Oe.xxxs + "", Oe.xxs + "", Oe.xs + "", Oe.small + "", Oe.medium + "", Oe.large + "", Oe.xl + "";
const ewe = {
  [Oe.xxs_small_icon]: 12,
  [Oe.xxxs]: 16,
  [Oe.xxs]: 16,
  [Oe.xs]: 16,
  [Oe.small]: 16,
  [Oe.medium]: 16,
  [Oe.large]: 20,
  [Oe.xl]: 24
}, PEt = ({ size: t, icon: e }) => `icon-dim-${e ? ewe[t] : D_e[t]}`, $Et = ({ size: t, icon: e }) => e ? ewe[t] : D_e[t], MEt = ({
  size: t,
  variant: e,
  style: n,
  isLoading: r,
  icon: o,
  isAutoTriggerActive: i,
  fontWeight: s
}) => `button button__${e}--${n} ${o ? REt[t] : AEt[t]} ${TEt[s]} ${i ? "button--auto-click" : ""} ${r ? "button--loading" : ""}`, DEt = Ri(
  ({ component: t = Ph.button, anchorProps: e, linkProps: n, buttonProps: r, onClick: o, elementRef: i, ...s }, a) => {
    const l = `${s.className} button__link ${s.disabled ? "dc__disable-click" : ""}`, c = Cn((u) => {
      u && (i.current = u, a && typeof a == "object" && Object.hasOwn(a, "current") ? a.current = u : typeof a == "function" && a(u));
    }, []);
    return t === Ph.link ? /* @__PURE__ */ M.jsx(
      QE,
      {
        ...n,
        ...s,
        className: l,
        onClick: o,
        ref: c
      }
    ) : t === Ph.anchor ? /* @__PURE__ */ M.jsx(
      "a",
      {
        target: "_blank",
        rel: "noopener noreferrer",
        ...e,
        ...s,
        className: l,
        onClick: o,
        ref: c,
        children: s.children
      }
    ) : /* @__PURE__ */ M.jsx(
      "button",
      {
        ...r,
        ...s,
        type: r?.type || "button",
        onClick: o,
        ref: c
      }
    );
  }
), Ar = Ri(
  ({
    dataTestId: t,
    text: e,
    variant: n = Nr.primary,
    size: r = Oe.large,
    style: o = Ti.default,
    fontWeight: i = "bold",
    startIcon: s = null,
    endIcon: a = null,
    disabled: l = !1,
    isLoading: c = !1,
    showTooltip: u = !1,
    tooltipProps: d = {},
    icon: f = null,
    ariaLabel: h = null,
    showAriaLabelInTippy: p = !0,
    fullWidth: m = !1,
    isOpacityHoverChild: g = !1,
    triggerAutoClickTimestamp: y,
    ...v
  }, b) => {
    const [_, w] = Ye(!1), x = Ue(), E = Ue(null), S = l || c, C = `dc__no-shrink flex dc__fill-available-space ${PEt({
      size: r,
      icon: f
    })}`;
    Ne(() => (y && setTimeout(() => {
      w(!0), x.current = setTimeout(() => {
        E.current.click();
      }, 1495);
    }, 100), () => {
      w(!1), clearTimeout(x.current);
    }), [y]);
    const R = (N) => {
      w(!1), clearTimeout(x.current), v.onClick?.(N);
    }, P = () => !u && p && f && h ? {
      alwaysShowTippyOnHover: !0,
      content: h
    } : Object.hasOwn(d, "shortcutKeyCombo") && "shortcutKeyCombo" in d ? d : {
      alwaysShowTippyOnHover: u && !!d?.content,
      ...d
    };
    return /* @__PURE__ */ M.jsx(Ai, { ...P(), children: /* @__PURE__ */ M.jsx("div", { className: `dc__inline-block flex ${m ? "w-100" : "dc__w-fit-content"}`, children: /* @__PURE__ */ M.jsxs(
      DEt,
      {
        ref: b,
        ...v,
        disabled: S,
        className: `br-4 flex cursor dc__tab-focus dc__position-rel dc__capitalize ${g ? "dc__opacity-hover--child" : ""} ${MEt({ size: r, variant: n, style: o, isLoading: c, icon: f, isAutoTriggerActive: _, fontWeight: i })} ${S ? "dc__disabled" : ""} ${m ? "w-100" : ""}`,
        "data-testid": t,
        "aria-label": h || (c ? e : void 0),
        elementRef: E,
        onClick: R,
        children: [
          f ? /* @__PURE__ */ M.jsx("span", { className: C, children: f }) : /* @__PURE__ */ M.jsxs(M.Fragment, { children: [
            s && /* @__PURE__ */ M.jsx("span", { className: C, children: s }),
            /* @__PURE__ */ M.jsx("span", { className: "dc__align-left", children: e }),
            a && /* @__PURE__ */ M.jsx("span", { className: C, children: a })
          ] }),
          c && /* @__PURE__ */ M.jsx(
            c9,
            {
              size: $Et({
                size: r,
                icon: f
              })
            }
          )
        ]
      }
    ) }) });
  }
), Pie = {
  title: "Resource not found",
  subTitle: "The resource you are looking for does not exist"
}, IEt = ({
  isLoading: t,
  progressingProps: e,
  customLoader: n,
  error: r,
  notAuthorized: o,
  notFoundText: i,
  reloadProps: s,
  genericSectionErrorProps: a,
  errorScreenManagerProps: l,
  children: c
}) => o ? /* @__PURE__ */ M.jsx(sCt, {}) : t ? n ? /* @__PURE__ */ M.jsx(M.Fragment, { children: n }) : /* @__PURE__ */ M.jsx(c9, { ...e }) : r ? a ? /* @__PURE__ */ M.jsx(H_e, { ...a }) : l ? /* @__PURE__ */ M.jsx(iwe, { ...l }) : r?.code === 404 ? /* @__PURE__ */ M.jsx(
  Vd,
  {
    title: i?.title ?? Pie.title,
    subTitle: i?.subTitle ?? Pie.subTitle
  }
) : /* @__PURE__ */ M.jsx(g9, { ...s }) : /* @__PURE__ */ M.jsx(M.Fragment, { children: c }), NEt = ({
  isSorted: t,
  triggerSorting: e,
  sortOrder: n,
  title: r,
  disabled: o,
  isSortable: i = !0,
  showTippyOnTruncate: s = !1,
  id: a,
  handleResize: l,
  isResizable: c
}) => {
  const u = !!(c && a && l), d = () => i ? t ? /* @__PURE__ */ M.jsx(
    _Ee,
    {
      className: `icon-dim-12 mw-12 scn-7 dc__no-shrink dc__transition--transform ${n !== lo.DESC ? "dc__flip-180" : ""}`
    }
  ) : /* @__PURE__ */ M.jsx(bEe, { className: "icon-dim-12 mw-12 scn-7 dc__no-shrink" }) : null, f = (h, p) => {
    u && l(a, p.deltaX);
  };
  return (
    // Added w-100, h-100 when isResizable is true to ensure the cell takes full dimensions in wrapper flex layout (if any)
    /* @__PURE__ */ M.jsxs(
      "div",
      {
        className: `flex dc__content-space dc__gap-6 dc__position-rel ${c ? "w-100 h-100 sortable-table-header__container" : ""}`,
        children: [
          /* @__PURE__ */ M.jsxs(
            "button",
            {
              type: "button",
              className: `dc__transparent p-0 cn-7 flex dc__content-start dc__gap-4 dc__select-text fw-6 ${i ? "" : "cursor-default"} dc__position-rel`,
              onClick: i ? e : eo,
              disabled: o,
              tabIndex: o || !i ? -1 : 0,
              "data-testid": r,
              children: [
                /* @__PURE__ */ M.jsx(Ai, { showOnTruncate: s, content: r, children: /* @__PURE__ */ M.jsx("span", { className: "dc__uppercase dc__truncate", children: r }) }),
                d()
              ]
            }
          ),
          u && /* @__PURE__ */ M.jsx(
            yx,
            {
              handle: ".sortable-table-header__resize-btn",
              defaultClassNameDragging: "sortable-table-header__resize-btn--dragging",
              position: {
                x: 0,
                y: 0
              },
              axis: "none",
              onDrag: f,
              bounds: {
                top: 0,
                bottom: 0
              },
              children: /* @__PURE__ */ M.jsx("div", { className: "sortable-table-header__resize-btn flex h-100 dc__no-shrink px-2 dc__position-abs dc__cursor-col-resize dc__right-3--neg", children: /* @__PURE__ */ M.jsx("div", { className: "dc__divider h-16" }) })
            }
          )
        ]
      }
    )
  );
}, jEt = 70, LEt = 600, FEt = ({ headersConfig: t }) => {
  const [e, n] = Ye([]);
  Ne(() => {
    n(t.map((o) => o.width));
  }, [JSON.stringify(t)]);
  const r = (o, i) => {
    const s = t.findIndex((a) => a.id === o);
    s < 0 || n((a) => {
      const l = structuredClone(a);
      if (typeof l[s] != "number")
        return a;
      const c = l[s] + i, u = t[s];
      return c < (u.minWidth ?? jEt) || c > (u.maxWidth ?? LEt) ? a : (l[s] = c, l);
    });
  };
  return {
    gridTemplateColumns: e.map((o) => typeof o == "number" ? `${o}px` : o).join(" "),
    handleResize: r
  };
}, BEt = () => {
  const [t, e] = Ye(!1);
  return Ne(() => {
    e(window.location.protocol === "https:");
  }, []), t;
};
qw.devtronApplication + "", qw.job + "", qw.cluster + "";
const zEt = ({
  docLinkKey: t,
  text: e = "Learn more",
  dataTestId: n,
  startIcon: r,
  showExternalIcon: o,
  onClick: i,
  fontWeight: s,
  size: a = Oe.medium,
  variant: l = Nr.text,
  isExternalLink: c,
  openInNewTab: u = !1,
  fullWidth: d = !1
}) => {
  const { isEnterprise: f, setSidePanelConfig: h, isLicenseDashboard: p } = l9(), m = BEt(), g = Ixt({
    docLinkKey: t,
    isEnterprise: f,
    isExternalLink: c,
    isLicenseDashboard: p
  }), y = (v) => {
    m && !c && !u && !v.metaKey && !p && g.startsWith(i9) && (v.preventDefault(), h((b) => ({
      ...b,
      state: I_e.DOCUMENTATION,
      docLink: g,
      reinitialize: !0
    }))), i?.(v);
  };
  return /* @__PURE__ */ M.jsx(
    Ar,
    {
      component: Ph.anchor,
      anchorProps: {
        href: g
      },
      onClick: y,
      dataTestId: n,
      text: e,
      variant: l,
      size: a,
      startIcon: r,
      endIcon: o && /* @__PURE__ */ M.jsx(Ut, { name: "ic-open-in-new", color: null }),
      fullWidth: d,
      fontWeight: s
    }
  );
}, Hw = {
  [zn.GIT]: "ic-git",
  [zn.GITHUB]: "ic-github",
  [zn.GITLAB]: "ic-gitlab",
  [zn.BITBUCKET]: "ic-bitbucket",
  [zn.DOCKER]: "ic-dockerhub",
  [zn.DOCKER_HUB]: "ic-dockerhub",
  [zn.ACR]: "ic-azure",
  [zn.QUAY]: "ic-quay",
  [zn.ECR]: "ic-ecr",
  [zn.ARTIFACT_REGISTRY]: "ic-google-artifact-registry",
  [zn.GCR]: "ic-google-container-registry",
  [zn.OTHER]: "ic-container-registry"
}, qEt = (t) => {
  if (!t) return Hw[zn.OTHER];
  const e = Object.values(zn).find(
    (n) => n !== zn.OTHER && t.includes(n)
  );
  return e ? Hw[e] : Hw[zn.OTHER];
}, ol = ({ registryType: t, size: e = 20, registryUrl: n }) => /* @__PURE__ */ M.jsx(
  Ut,
  {
    name: t ? Hw[t] : qEt(n),
    size: e,
    color: null
  }
);
zn.ECR, zn.DOCKER_HUB, zn.GITLAB, zn.ACR, zn.ARTIFACT_REGISTRY, zn.GCR, zn.QUAY, zn.OTHER;
const UEt = {
  control: (t, e) => ({
    ...t,
    backgroundColor: "var(--bg-primary)",
    cursor: e.isDisabled ? "not-allowed" : "normal",
    border: e.isFocused ? "1px solid var(--B500)" : "1px solid var(--N200)",
    boxShadow: "none"
  }),
  menu: (t, e) => ({
    ...t,
    backgroundColor: "var(--bg-primary)"
  }),
  option: (t, e) => ({
    ...t,
    backgroundColor: e.isFocused ? "var(--N100)" : "var(--bg-primary)",
    color: "var(--N900)",
    padding: "8px 12px"
  }),
  container: (t, e) => ({
    ...t,
    cursor: e.isDisabled ? "not-allowed" : "pointer"
  }),
  valueContainer: (t, e) => ({
    ...t,
    color: e.selectProps.menuIsOpen ? "var(--N500)" : t.color
  }),
  singleValue: (t) => ({
    ...t,
    color: "var(--N900)"
  }),
  input: (t) => ({
    ...t,
    color: "var(--N900)"
  })
};
var er = /* @__PURE__ */ ((t) => (t.CI = "CI", t.CD = "CD", t.GROUP_CI = "GROUP_CI", t.GROUP_CD = "GROUP_CD", t))(er || {}), x3 = /* @__PURE__ */ ((t) => (t.SUCCESS = "SUCCESS", t.FETCHING = "FETCHING", t.SUSPEND = "SUSPEND", t))(x3 || {}), p9 = /* @__PURE__ */ ((t) => (t.WORKFLOW = "workflow", t.POD = "pod", t))(p9 || {}), kn = /* @__PURE__ */ ((t) => (t.NOT_STARTED = "NOT_STARTED", t.RUNNING = "RUNNING", t.SUCCEEDED = "SUCCEEDED", t.FAILED = "FAILED", t.ABORTED = "ABORTED", t.TIMEOUT = "TIMEOUT", t.UNKNOWN = "UNKNOWN", t))(kn || {}), E3 = /* @__PURE__ */ ((t) => (t.PREPARATION = "Preparation", t.EXECUTION = "Execution", t))(E3 || {}), Lg = /* @__PURE__ */ ((t) => (t.DEPLOY_DIALOG = "DEPLOY_DIALOG", t.RESOURCE_DETAIL_MODAL = "RESOURCE_DETAIL_MODAL", t))(Lg || {});
const vD = {
  APPLICATION: "Application",
  ENVIRONMENT: "Environment",
  PIPELINE: "Pipeline"
}, HEt = {
  ...UEt,
  control: (t) => ({
    ...t,
    minHeight: "36px",
    fontWeight: "400",
    backgroundColor: "var(--bg-secondary)",
    cursor: "pointer"
  }),
  dropdownIndicator: (t) => ({
    ...t,
    padding: "0 8px"
  }),
  menuPortal: (t) => ({ ...t, zIndex: 9999 })
}, VEt = "Not Configured", WEt = "--", Mr = {
  SUCCEEDED: "succeeded",
  HEALTHY: "healthy",
  RUNNING: "running",
  PROGRESSING: "progressing",
  STARTING: "starting",
  INITIATING: "initiating",
  QUEUED: "queued",
  FAILED: "failed",
  ERROR: "error",
  CANCELLED: "cancelled",
  TIMED_OUT: Ud.TIMED_OUT.toLowerCase(),
  WAITING_TO_START: Ud.WAITING_TO_START.toLowerCase()
}, GEt = "1", VO = 1, YEt = "devtron-ci", KEt = "devtron-ci", S3 = {
  suspended: "var(--Y500)",
  unknown: "var(--N700)",
  queued: "var(--N700)",
  degraded: "var(--R500)",
  healthy: "var(--G500)",
  notdeployed: "var(--N500)",
  [kn.NOT_STARTED.toLowerCase()]: "var(--N500)",
  missing: "var(--N700)",
  progressing: "var(--O500)",
  initiating: "var(--O500)",
  starting: "var(--O500)",
  [Ud.WAITING_TO_START.toLowerCase()]: "var(--O500)",
  [Ud.TIMED_OUT.toLowerCase()]: "var(--R500)",
  succeeded: "var(--G500)",
  running: "var(--O500)",
  failed: "var(--R500)",
  error: "var(--R500)",
  cancelled: "var(--R500)",
  aborted: "var(--R500)",
  timedout: "var(--R500)",
  [kn.TIMEOUT.toLowerCase()]: "var(--R500)",
  unabletofetch: "var(--R500)",
  hibernating: "var(--N700)"
}, XEt = {
  progressing: !0,
  initiating: !0,
  starting: !0,
  running: !0
}, QEt = {
  [kn.NOT_STARTED]: "Waiting to start",
  [kn.RUNNING]: "Running",
  [kn.SUCCEEDED]: "Succeeded",
  [kn.FAILED]: "Failed",
  [kn.ABORTED]: "Aborted",
  [kn.TIMEOUT]: "Timed out",
  [kn.UNKNOWN]: "Unknown"
}, ZEt = {
  [kn.SUCCEEDED]: "succeeded",
  [kn.FAILED]: "failed",
  [kn.ABORTED]: "aborted",
  [kn.TIMEOUT]: "timed out"
}, JEt = {
  [Mr.SUCCEEDED]: "cg-5",
  [Mr.HEALTHY]: "cg-5",
  [Mr.FAILED]: "cr-5",
  [Mr.CANCELLED]: "cr-5",
  [Mr.ERROR]: "cr-5",
  [Mr.TIMED_OUT]: "cr-5",
  [Mr.WAITING_TO_START]: "co-5"
}, eSt = {
  [Mr.WAITING_TO_START]: "running",
  [Mr.RUNNING]: "running",
  [Mr.PROGRESSING]: "progressing",
  [Mr.STARTING]: "starting",
  [Mr.INITIATING]: "initiating",
  [Mr.QUEUED]: "queued"
}, UE = {
  [kn.ABORTED]: !0,
  [kn.FAILED]: !0,
  [kn.TIMEOUT]: !0
}, tSt = "cannot be imported into the current release: invalid ownership metadata;", nSt = [
  {
    field: "name",
    label: "Name",
    size: {
      range: {
        startWidth: 250,
        maxWidth: 400,
        minWidth: 120
      }
    },
    isSortable: !0,
    comparator: mD,
    horizontallySticky: !0
  },
  {
    field: "namespace",
    label: "Namespace",
    size: {
      range: {
        startWidth: 150,
        maxWidth: 400,
        minWidth: 100
      }
    },
    comparator: mD,
    isSortable: !0
  },
  {
    field: "gvkTitle",
    label: "GVK",
    size: {
      range: {
        startWidth: 250,
        maxWidth: 400,
        minWidth: 100
      }
    },
    isSortable: !0,
    comparator: mD
  }
], eg = {
  NOT_AVAILABLE: "Not available",
  NOT_DEPLOYED: "not-deployed",
  NOT_DEPLOYED_NO_SPACE: "notdeployed",
  JOB_VIEW_NOT_DEPLOYED_MESSAGE: "Yet to run",
  NOT_DEPLOYED_MESSAGE: "Not deployed"
};
var hi = /* @__PURE__ */ ((t) => (t.QUEUED = "QUEUED", t.FAILED = "FAILED", t.ERROR = "ERROR", t.CANCELLED = "CANCELLED", t.ABORTED = "ABORTED", t.HEALTHY = "HEALTHY", t.SUCCEEDED = "SUCCEEDED", t.DRIFTED = "DRIFTED", t.MISSING = "MISSING", t.UNKNOWN = "UNKNOWN", t.NOT_DEPLOYED = "NOT-DEPLOYED", t.SUSPENDED = "SUSPENDED", t.DEGRADED = "DEGRADED", t.PROGRESSING = "PROGRESSING", t.INPROGRESS = "INPROGRESS", t.HIBERNATING = "HIBERNATING", t.TIMED_OUT = "TIMED_OUT", t.DELETING = "DELETING", t))(hi || {});
const rSt = (t, e) => {
  switch (t) {
    case "queued":
    case "pending":
      return "ic-clock";
    case "failed":
      return "ic-failure";
    case "error":
    case "not-ready":
      return "ic-error";
    case "cancelled":
      return "ic-cancelled";
    case "aborted":
      return "ic-aborted";
    case "healthy":
      return "ic-heart-green";
    case "ready":
    case "synced":
    case "sync.ok":
    case "succeeded":
      return "ic-success";
    case "drifted":
      return "ic-out-of-sync";
    case "missing":
      return "ic-missing";
    case "unknown":
      return "ic-unknown";
    case "not-triggered":
    case "not-deployed":
    case "notdeployed":
    case "not-available":
      return "ic-close-small";
    case "suspended":
      return "ic-suspended";
    case "degraded":
      return e ? "ic-heart-red-animated" : "ic-heart-red";
    case "initiating":
    case "progressing":
    case "running":
    case "request_accepted":
    case "starting":
    case "waiting-to-start":
      return "ic-circle-loader";
    case "inprogress":
      return "ic-in-progress";
    case "hibernating":
    case "hibernated":
      return "ic-hibernate-circle";
    case "timedout":
    case "timed_out":
      return "ic-timeout-dash";
    case "unable_to_fetch":
      return "ic-disconnect";
    case "deleting":
      return "ic-delete-dots";
    case "deleted":
      return "ic-delete";
    case "warning":
      return "ic-warning-fill";
    default:
      return null;
  }
}, oSt = (t) => {
  switch (t) {
    case "not-triggered":
    case "not-deployed":
    case "notdeployed":
    case "not-available":
    case "queued":
    case "pending":
      return "N600";
    case "initiating":
    case "progressing":
    case "running":
    case "request_accepted":
    case "starting":
      return "O500";
    case "unable_to_fetch":
    case "timedout":
    case "timed_out":
    case "deleting":
    case "deleted":
      return "R500";
    case "warning":
      return "Y500";
    default:
      return null;
  }
}, iSt = (t) => {
  switch (t?.toUpperCase()) {
    case bi.ABORTED:
      return hi.ABORTED;
    case bi.DEGRADED:
      return hi.FAILED;
    case bi.HEALTHY:
      return hi.SUCCEEDED;
    case bi.INPROGRESS:
      return hi.INPROGRESS;
    default:
      return t;
  }
}, sSt = (t) => t === Ud.WAITING_TO_START ? "Waiting to start" : t, aSt = (t) => /* @__PURE__ */ M.jsx("div", { className: "flexbox dc__align-items-center dc__gap-6", children: t }), lSt = ({
  status: t,
  hideIcon: e = !1,
  hideMessage: n = !1,
  iconSize: r = 16,
  showAnimatedIcon: o = !1,
  hideIconTooltip: i = !1,
  message: s
}) => {
  const a = (t || "").toLowerCase().replace(/ /g, "-"), l = s || t || "", c = () => {
    const d = rSt(a, o), f = oSt(a);
    return d ? /* @__PURE__ */ M.jsx(
      Ut,
      {
        name: d,
        size: r,
        color: f,
        tooltipProps: {
          alwaysShowTippyOnHover: !0,
          placement: "top",
          content: n && !i ? l : null
        }
      }
    ) : null;
  }, u = () => l ? /* @__PURE__ */ M.jsx(Ai, { content: l, children: /* @__PURE__ */ M.jsx(
    "p",
    {
      "data-testid": `${t || "status-is-null"}-status`,
      className: "m-0 dc__ellipsis-right dc__first-letter-capitalize fs-13 lh-20 cn-9",
      children: l
    }
  ) }) : null;
  return /* @__PURE__ */ M.jsxs(Hp, { condition: !e && !n, wrap: aSt, children: [
    !e && c(),
    !n && u()
  ] });
}, cSt = ({
  status: t,
  isJobView: e = !1,
  isVirtualEnv: n = !1,
  hideMessage: r,
  ...o
}) => {
  const i = e ? sSt(t) : t, s = n ? eg.NOT_AVAILABLE : i ?? "", a = s.toLowerCase().replace(/ /g, "-") === eg.NOT_DEPLOYED || s.toLowerCase() === eg.NOT_DEPLOYED_NO_SPACE, l = e ? eg.JOB_VIEW_NOT_DEPLOYED_MESSAGE : eg.NOT_DEPLOYED_MESSAGE, c = a ? l : s;
  return s ? /* @__PURE__ */ M.jsx(lSt, { status: s, message: c, hideMessage: r, ...o }) : /* @__PURE__ */ M.jsxs("div", { className: "flexbox dc__align-items-center dc__gap-6", children: [
    /* @__PURE__ */ M.jsx(
      Ut,
      {
        name: "ic-info-outline",
        size: o.iconSize,
        tooltipProps: {
          alwaysShowTippyOnHover: !0,
          placement: "top",
          content: "To view app status open the app detail page"
        },
        color: "N600"
      }
    ),
    !r && /* @__PURE__ */ M.jsx("span", { className: "fs-13 lh-20 cn-6", children: "-" })
  ] });
}, twe = ({ status: t, ...e }) => /* @__PURE__ */ M.jsx(cSt, { status: iSt(t), ...e }), $ie = (t, e, n) => {
  const r = [];
  return Object.keys(e).forEach((o) => {
    const i = n.find((s) => s.id == o);
    r.push({ name: i ? i.name : "", value: e[o] });
  }), /* @__PURE__ */ M.jsxs(M.Fragment, { children: [
    /* @__PURE__ */ M.jsxs("span", { children: [
      " ",
      t,
      " Filters "
    ] }),
    /* @__PURE__ */ M.jsx("br", {}),
    /* @__PURE__ */ M.jsx("ul", { className: "m-0", children: r.map((o, i) => (
      // eslint-disable-next-line react/no-array-index-key
      /* @__PURE__ */ M.jsxs("li", { children: [
        o.name,
        " : ",
        o.value
      ] }, i)
    )) })
  ] });
}, uSt = (t) => {
  const e = t?.[p9.POD]?.[0], { status: n, message: r, endTime: o, metadata: i } = e || {};
  return {
    status: n || kn.UNKNOWN,
    message: r || "",
    clusterId: i?.clusterId || VO,
    endTime: Th(o) ? o : ""
  };
}, m9 = (t) => {
  if (!Object.keys(t || {}).length)
    return null;
  const e = t[p9.WORKFLOW] || [], n = e.find(
    (a) => a?.stageName === E3.PREPARATION
  ), r = e.find(
    (a) => a?.stageName === E3.EXECUTION
  ), o = n?.startTime;
  let i = kn.UNKNOWN;
  e.forEach(({ status: a }) => {
    a !== kn.NOT_STARTED && (i = a);
  });
  let s = "";
  return e.forEach(({ status: a, endTime: l }, c) => {
    (UE[a] || c === e.length - 1 && a === kn.SUCCEEDED) && (s = l);
  }), {
    triggeredOn: Th(o) ? o : "",
    executionStartedOn: Th(r?.startTime) ? r?.startTime : "",
    finishedOn: Th(s) ? s : "",
    currentStatus: i,
    workerDetails: uSt(t)
  };
}, nwe = (t) => {
  const e = {
    [kn.TIMEOUT]: hi.TIMED_OUT,
    [kn.ABORTED]: hi.ABORTED,
    [kn.FAILED]: hi.FAILED,
    [kn.SUCCEEDED]: hi.SUCCEEDED,
    [kn.NOT_STARTED]: hi.INPROGRESS,
    [kn.RUNNING]: hi.INPROGRESS
  };
  return e[t] ? /* @__PURE__ */ M.jsx(twe, { status: e[t], iconSize: 20, hideMessage: !0, hideIconTooltip: !0 }) : /* @__PURE__ */ M.jsx(Ut, { name: "ic-help-outline", size: 20, color: "N500" });
}, dSt = (t) => {
  const e = m9(t);
  return e ? e.finishedOn ? !UE[e.currentStatus] && UE[e.workerDetails.status] ? /* @__PURE__ */ M.jsx(Ut, { name: "ic-warning", size: 20, color: null }) : nwe(e.workerDetails.status) : /* @__PURE__ */ M.jsx(Ut, { name: "ic-in-progress", size: 20, color: null }) : /* @__PURE__ */ M.jsx(Ut, { name: "ic-help-outline", size: 20, color: "N500" });
}, fSt = (t = VO, e = YEt) => `${Up.INFRASTRUCTURE_MANAGEMENT_RESOURCE_BROWSER}/${t}/${e}/pod/${Y_e}`, rwe = (t) => t ? t.toLowerCase() === "cancelled" ? "Aborted" : t === Ud.WAITING_TO_START ? "Waiting to start" : t : null, WO = (t) => Th(t) ? qe(t, "YYYY-MM-DDTHH:mm:ssZ").format(a9.TWELVE_HOURS_FORMAT) : "", hSt = (t) => {
  switch (t?.toLowerCase()) {
    case Mr.RUNNING:
    case Mr.PROGRESSING:
    case Mr.STARTING:
    case Mr.INITIATING:
    case Mr.WAITING_TO_START:
      return hi.INPROGRESS;
    case Mr.CANCELLED:
      return hi.ABORTED;
    default:
      return t;
  }
}, pSt = (t) => Array.from(t).sort(([e], [n]) => n - e), mSt = ({
  sourceType: t,
  sourceValue: e,
  showTooltip: n,
  showIcons: r = !0,
  baseText: o = void 0,
  regex: i,
  isRegex: s,
  primaryBranchAfterRegex: a,
  rootClassName: l = ""
}) => {
  const c = t === yp.WEBHOOK, u = t === yp.BranchRegex || !!i || s, [d, f] = Ye(""), [h, p] = Ye(""), [m, g] = Ye(!!c), [y, v] = Ye(!1), b = () => {
    if (c) {
      g(!0), v(!1);
      const E = JSON.parse(e);
      Eie(E.eventId).then((S) => {
        const C = S.result;
        f(C.name), p(
          $ie(
            C.name,
            E.condition,
            C.selectors
          )
        ), g(!1);
      }).catch(() => {
        g(!1), v(!0);
      });
    } else
      f(e), p(e);
  };
  Ne(() => {
    b();
  }, [e]);
  const _ = () => /* @__PURE__ */ M.jsxs(M.Fragment, { children: [
    /* @__PURE__ */ M.jsxs(M.Fragment, { children: [
      /* @__PURE__ */ M.jsx("div", { className: "fw-6", children: "Regex" }),
      /* @__PURE__ */ M.jsx("p", { children: i })
    ] }),
    window.location.href.includes("trigger") && /* @__PURE__ */ M.jsxs(M.Fragment, { children: [
      /* @__PURE__ */ M.jsx("div", { className: "fw-6", children: "Primary Branch" }),
      /* @__PURE__ */ M.jsx("p", { children: a || "Not set" })
    ] })
  ] });
  function w() {
    if (!c)
      return;
    g(!0), v(!1);
    const E = JSON.parse(e), S = E.eventId, C = E.condition;
    Eie(S).then((R) => {
      const P = R.result;
      f(P.name), p($ie(P.name, C, P.selectors)), g(!1);
    }).catch(() => {
      g(!1), v(!0);
    });
  }
  function x() {
    u && p(_());
  }
  return Ne(() => {
    w(), x();
  }, []), !m && y ? /* @__PURE__ */ M.jsxs("div", { className: "flex left dc__gap-4", children: [
    /* @__PURE__ */ M.jsx(Ut, { name: "ic-error", size: 16, color: null }),
    /* @__PURE__ */ M.jsx("span", { className: "dc__truncate fw-5 cr-5", children: "Failed to fetch" })
  ] }) : /* @__PURE__ */ M.jsxs("div", { className: `flex left ${n ? "fw-5" : ""}  ${l}`, children: [
    m && r && /* @__PURE__ */ M.jsx("span", { className: "dc__loading-dots", children: "loading" }),
    !m && /* @__PURE__ */ M.jsxs("div", { className: "flexbox dc__gap-4 dc__align-start", children: [
      r && /* @__PURE__ */ M.jsx("span", { className: "icon-dim-12 flex dc__no-shrink dc__fill-available-space mt-4", children: ZOt(t, u, d) }),
      n ? /* @__PURE__ */ M.jsx(
        Ai,
        {
          wordBreak: !0,
          alwaysShowTippyOnHover: !0,
          arrow: !1,
          placement: "bottom",
          content: h,
          children: /* @__PURE__ */ M.jsxs(
            "div",
            {
              className: "flex left dc__gap-4",
              style: { maxWidth: o ? "auto" : "calc(100% - 15px)" },
              children: [
                !o && /* @__PURE__ */ M.jsxs(M.Fragment, { children: [
                  /* @__PURE__ */ M.jsx(
                    "div",
                    {
                      className: `dc__truncate ${e === VEt ? "cr-5" : ""}`,
                      children: d
                    }
                  ),
                  e !== WEt && /* @__PURE__ */ M.jsx(xEe, { className: "icon-dim-12 fcn-5" })
                ] }),
                o && /* @__PURE__ */ M.jsx("span", { className: "dc__border-dashed--n3-bottom fw-6 fs-13 lh-19-imp", children: o })
              ]
            }
          )
        }
      ) : /* @__PURE__ */ M.jsx("span", { className: "dc__truncate", children: h })
    ] })
  ] });
};
new xO({});
new xO([]);
new xO([]);
new xO({});
var xo = /* @__PURE__ */ ((t) => (t.PROGRESSING = "Progressing", t.ABORTED = "Aborted", t.FAILED = "Failed", t.SUCCEEDED = "Succeeded", t.TIMED_OUT = "TimedOut", t.UNABLE_TO_FETCH = "UnableToFetch", t.STARTING = "Starting", t.QUEUED = "Queued", t.INITIATING = "Initiating", t.HEALTHY = "Healthy", t.DEGRADED = "Degraded", t.MISSING = "Missing", t.UNKNOWN = "Unknown", t.SUSPENDED = "Suspended", t))(xo || {});
xo.ABORTED + "", Lo.FAILED, xo.FAILED + "", Lo.FAILED, xo.TIMED_OUT + "", Lo.TIMED_OUT, xo.UNABLE_TO_FETCH + "", Lo.UNABLE_TO_FETCH, xo.DEGRADED + "", Lo.SUCCEEDED, xo.HEALTHY + "", Lo.SUCCEEDED, xo.SUCCEEDED + "", Lo.SUCCEEDED, xo.INITIATING + "", Lo.INITIATING, xo.STARTING + "", Lo.STARTING, xo.PROGRESSING + "", Lo.INPROGRESS, xo.SUSPENDED + "", Lo.INPROGRESS, xo.QUEUED + "", Lo.QUEUED, xo.UNKNOWN + "", Lo.UNABLE_TO_FETCH, xo.MISSING + "", Lo.UNABLE_TO_FETCH;
bi.DEPLOYMENT_INITIATED, bi.GIT_COMMIT, bi.ARGOCD_SYNC, bi.KUBECTL_APPLY, bi.APP_HEALTH;
bi.DEPLOYMENT_INITIATED, bi.GIT_COMMIT, bi.APP_HEALTH;
Vf.PRE_SYNC, Vf.SYNC, Vf.POST_SYNC, Vf.SKIP, Vf.SYNC_FAIL;
const gSt = {
  [Wu.ERROR]: /* @__PURE__ */ M.jsx(Ut, { name: "ic-error", color: "R500" }),
  [Wu.HELP]: /* @__PURE__ */ M.jsx(Ut, { name: "ic-help-outline", color: "V500" }),
  [Wu.INFORMATION]: /* @__PURE__ */ M.jsx(Ut, { name: "ic-info-filled", color: "B500" }),
  [Wu.SUCCESS]: /* @__PURE__ */ M.jsx(Ut, { name: "ic-success", color: "G500" }),
  [Wu.WARNING]: /* @__PURE__ */ M.jsx(Ut, { name: "ic-warning", color: "Y500" }),
  [Wu.NEUTRAL]: /* @__PURE__ */ M.jsx(Ut, { name: "ic-info-filled", color: null })
}, ySt = {
  [Oe.large]: "px-12",
  [Oe.medium]: "px-8"
}, vSt = {
  [Oe.large]: "icon-dim-20",
  [Oe.medium]: "icon-dim-18"
}, bSt = {
  [Oe.large]: Oe.medium,
  [Oe.medium]: Oe.xs
}, _St = {
  [Oe.large]: Oe.xxs,
  [Oe.medium]: Oe.xxs
}, wSt = ({
  layout: t = "row",
  variant: e = "information",
  size: n = Oe.large,
  customIcon: r,
  buttonProps: o,
  heading: i,
  description: s,
  borderRadiusConfig: a,
  borderConfig: l
}) => {
  const c = `${ySt[n]} ${rxt[e]} ${oxt[e]} ${X_e({ borderConfig: l, borderRadiusConfig: a })} w-100 py-8 br-4 bw-1`, u = `dc__no-shrink flex dc__fill-available-space ${vSt[n]}`, d = r ?? gSt[e], f = o?.icon ? _St[n] : bSt[n], h = () => /* @__PURE__ */ M.jsx("span", { className: u, children: d }), p = () => i ? typeof i == "string" ? /* @__PURE__ */ M.jsx(
    "h6",
    {
      className: `cn-9 ${n === Oe.large ? "fs-13 lh-20" : "fs-12 lh-18"} fw-6 m-0 dc__truncate--clamp-3 dc__word-break`,
      children: i
    }
  ) : i : null, m = () => s ? typeof s == "string" ? /* @__PURE__ */ M.jsx(
    "p",
    {
      className: `m-0 cn-9 fw-4 ${n === Oe.large ? "fs-13 lh-20" : "fs-12 lh-18"} dc__truncate--clamp-6 dc__word-break`,
      children: s
    }
  ) : s : null, g = () => {
    const y = t === "column", v = n === Oe.medium ? "dc__gap-2" : "dc__gap-4";
    return /* @__PURE__ */ M.jsxs("div", { className: `flexbox-col flex-grow-1 ${y ? v : ""}`, children: [
      p(),
      m()
    ] });
  };
  return t === "row" ? /* @__PURE__ */ M.jsxs("div", { className: `${c} flexbox dc__gap-16`, children: [
    /* @__PURE__ */ M.jsxs("div", { className: "flexbox dc__gap-8 flex-grow-1", children: [
      h(),
      g()
    ] }),
    o && /* @__PURE__ */ M.jsx(Ar, { ...o, size: f })
  ] }) : t === "column" ? /* @__PURE__ */ M.jsxs("div", { className: `${c} flexbox-col dc__gap-8`, children: [
    /* @__PURE__ */ M.jsxs("div", { className: "flexbox dc__gap-8", children: [
      g(),
      h()
    ] }),
    o && /* @__PURE__ */ M.jsx(Ar, { ...o, size: f })
  ] }) : null;
}, xSt = ({ text: t, textClass: e, containerClass: n = "min-w-385 pr-20", hideShowMore: r }) => {
  const o = Ue(null), [i, s] = Ye(!1), [a, l] = Ye(!1);
  Ne(() => {
    !r && o.current?.offsetHeight && o.current?.scrollHeight && (o.current.offsetHeight === o.current?.scrollHeight ? s(!1) : s(!0));
  }, [o.current?.scrollHeight]);
  const c = () => {
    l(!a);
  };
  return /* @__PURE__ */ M.jsxs("div", { className: n, children: [
    /* @__PURE__ */ M.jsx(
      "span",
      {
        ref: o,
        className: `${e || ""} ${r ? "dc__truncate--clamp-3" : ""} ${a ? "" : "dc__truncate"} dc__word-break`,
        children: t
      }
    ),
    i && /* @__PURE__ */ M.jsxs(
      "button",
      {
        type: "button",
        className: "dc__transparent p-0 flexbox dc__align-items-center dc__gap-4",
        onClick: c,
        children: [
          /* @__PURE__ */ M.jsx("span", { className: "cb-5 fs-12 fw-6 lh-20", children: a ? "Show less" : "Show more" }),
          /* @__PURE__ */ M.jsx(
            zse,
            {
              className: `dc__no-shrink icon-dim-16 flex scb-5 dc__transition--transform ${a ? "dc__flip-180" : ""}`
            }
          )
        ]
      }
    )
  ] });
}, ESt = (t, e) => {
  const n = `${rf.CI_CONFIG_GET}/${t.pipelineId}/workflow/${t.workflowId}?forceAbort=${e}`;
  return Ewe(n);
}, SSt = (t, e, n) => {
  const r = b9(`${rf.CD_MATERIAL_GET}/${t}/workflowRunner/${e}`, {
    forceAbort: n
  });
  return Ewe(r);
}, owe = async ({
  pipelineId: t,
  triggerId: e,
  appId: n
}) => {
  await rCt(rf.CD_TRIGGER_POST, {
    pipelineId: +t,
    wfrIdForDeploymentWithSpecificTrigger: +e,
    appId: +n,
    helmRedeploymentRequest: !0
  }), Cl.showToast({
    variant: Qr.success,
    title: "Redeployment initiated",
    description: "Redeployment for application has been successfully initiated."
  });
}, OSt = async ({
  appId: t,
  pipelineId: e,
  triggerId: n,
  signal: r
}) => {
  const { result: o } = await w9(
    Yf(rf.RESOURCE_CONFLICTS_LIST, {
      appId: t,
      pipelineId: e,
      wfrId: n
    }),
    { signal: r }
  );
  return (o?.conflictingResources || []).map((i) => ({
    name: i.name || "",
    namespace: i.namespace || "",
    gvk: {
      Group: i.groupVersionKind.Group || Y_e,
      Version: i.groupVersionKind.Version || "",
      Kind: i.groupVersionKind.Kind || ""
    },
    gvkTitle: gEt(i.groupVersionKind),
    clusterId: o.clusterId,
    id: HO()
  }));
}, Vd = ({
  title: t,
  image: e,
  subTitle: n,
  isButtonAvailable: r,
  classname: o,
  styles: i,
  imageType: s,
  renderButton: a,
  imageClassName: l,
  children: c,
  SvgImage: u,
  noImage: d,
  layout: f = "column",
  contentClassName: h = "",
  imageStyles: p = {},
  imgName: m
}) => {
  const g = f === "row", y = () => {
    switch (s) {
      case o9.Large:
        return { width: "250px", height: "200px" };
      default:
        return { width: "200px", height: "160px" };
    }
  };
  return /* @__PURE__ */ M.jsxs(
    "div",
    {
      className: `flex ${g ? "dc__gap-32" : "column dc__gap-20"} empty-state ${o || ""}`,
      style: i,
      "data-testid": "generic-empty-state",
      children: [
        u ? /* @__PURE__ */ M.jsx(
          u,
          {
            style: {
              width: `${y().width}`,
              height: `${y().height}`,
              ...p
            }
          }
        ) : !d && (m ? /* @__PURE__ */ M.jsx(
          VOt,
          {
            name: m,
            imageProps: {
              alt: "empty-state",
              style: {
                width: `${y().width}`,
                height: `${y().height}`,
                ...p
              }
            }
          }
        ) : /* @__PURE__ */ M.jsx(
          "img",
          {
            className: l || "",
            src: e || dEe,
            style: {
              width: `${y().width}`,
              height: `${y().height}`,
              ...p
            },
            alt: "empty-state"
          }
        )),
        /* @__PURE__ */ M.jsxs(
          "div",
          {
            className: `flex column dc__gap-20 dc__mxw-300 ${g ? "dc__align-start" : ""} ${h}`,
            children: [
              /* @__PURE__ */ M.jsxs("div", { className: "flex column dc__gap-8", children: [
                /* @__PURE__ */ M.jsx("h4", { className: "title fw-6 cn-9 mt-0 mb-0 lh-24 dc__align-center", children: t }),
                n && /* @__PURE__ */ M.jsx("p", { className: `subtitle ${g ? "subtitle--text-start" : ""}`, children: n })
              ] }),
              r && a(),
              c
            ]
          }
        )
      ]
    }
  );
}, $u = ({ code: t, image: e, title: n, subTitle: r, imageType: o, redirectURL: i, reload: s, on404Redirect: a }) => {
  const { push: l } = Yy(), c = () => {
    if (a) {
      a();
      return;
    }
    l(i || `/${rf.APP_LIST}`);
  }, u = (m) => {
    switch (m) {
      case Sr.NOT_FOUND:
        return {
          onClick: c,
          renderButtonText: yr.TAKE_BACK_HOME,
          isButtonAvailable: !0
        };
      case Sr.INTERNAL_SERVER_ERROR:
        return {
          onClick: GOt,
          renderButtonText: yr.REPORT_ISSUE,
          isButtonAvailable: !0
        };
      case Sr.BAD_REQUEST:
      case Sr.BAD_GATEWAY:
      case Sr.SERVICE_TEMPORARY_UNAVAILABLE:
        return {
          onClick: s ?? vwe,
          renderButtonText: yr.TRY_AGAIN,
          isButtonAvailable: !0
        };
      default:
        return { onClick: eo, renderButtonText: "", isButtonAvailable: !1 };
    }
  }, {
    onClick: d,
    renderButtonText: f,
    isButtonAvailable: h
  } = u(t), p = () => /* @__PURE__ */ M.jsx("button", { type: "button", className: "flex cta h-36", onClick: d, "data-testid": "empty-screen-take-me-home", children: f });
  return /* @__PURE__ */ M.jsx(
    Vd,
    {
      image: e,
      title: n,
      subTitle: r,
      isButtonAvailable: h,
      renderButton: p,
      imageType: o
    }
  );
};
function g9({ reload: t, className: e = "" }) {
  return /* @__PURE__ */ M.jsx(
    "article",
    {
      className: `flex w-100 h-100 ${e}`,
      children: /* @__PURE__ */ M.jsxs("div", { className: "flex column w-250 dc__align-center", "data-testid": "reload", children: [
        /* @__PURE__ */ M.jsx("img", { src: DEe, style: { height: "auto" }, className: "w-100 mb-12", alt: "load-error" }),
        /* @__PURE__ */ M.jsx("h3", { className: "title dc__bold", children: "Failed to load" }),
        /* @__PURE__ */ M.jsx("div", { className: "dc__empty__subtitle mb-20", children: "We could not load this page. Please give us another try." }),
        /* @__PURE__ */ M.jsx("button", { type: "button", className: "cta ghosted", onClick: typeof t == "function" ? t : vwe, children: "Retry" })
      ] })
    }
  );
}
const iwe = ({
  code: t,
  reload: e,
  subtitle: n,
  reloadClass: r,
  redirectURL: o,
  on404Redirect: i,
  imageType: s = o9.Large
}) => (() => {
  switch (t) {
    case Sr.BAD_REQUEST:
      return /* @__PURE__ */ M.jsx(
        $u,
        {
          code: Sr.BAD_REQUEST,
          title: yr.BAD_REQUEST,
          subTitle: n || yr.BAD_REQUEST_MESSAGE,
          image: ib,
          imageType: s,
          reload: e
        }
      );
    case Sr.UNAUTHORIZED:
      return /* @__PURE__ */ M.jsx(
        $u,
        {
          code: Sr.UNAUTHORIZED,
          title: yr.UNAUTHORIZED,
          subTitle: n || yr.UNAUTHORIZED_MESSAGE,
          image: PD,
          imageType: s
        }
      );
    case Sr.PERMISSION_DENIED:
      return /* @__PURE__ */ M.jsx(
        $u,
        {
          code: Sr.PERMISSION_DENIED,
          title: yr.FORBIDDEN,
          subTitle: n || yr.FORBIDDEN_MESSAGE,
          image: PD,
          imageType: s
        }
      );
    case Sr.NOT_FOUND:
      return /* @__PURE__ */ M.jsx(
        $u,
        {
          code: Sr.NOT_FOUND,
          title: yr.PAGE_NOT_FOUND,
          subTitle: n || yr.PAGE_NOT_EXIST,
          image: MEe,
          imageType: s,
          redirectURL: o,
          on404Redirect: i
        }
      );
    case Sr.INTERNAL_SERVER_ERROR:
      return /* @__PURE__ */ M.jsx(
        $u,
        {
          code: Sr.INTERNAL_SERVER_ERROR,
          title: yr.INTERNAL_SERVER_ERROR,
          subTitle: n || yr.INTERNAL_SERVER_ERROR_MESSAGE,
          image: ib,
          imageType: s,
          reload: e
        }
      );
    case Sr.BAD_GATEWAY:
      return /* @__PURE__ */ M.jsx(
        $u,
        {
          code: Sr.BAD_GATEWAY,
          title: yr.BAD_GATEWAY,
          subTitle: n || yr.BAD_GATEWAY_MESSAGE,
          image: ib,
          imageType: s,
          reload: e
        }
      );
    case Sr.SERVICE_TEMPORARY_UNAVAILABLE:
      return /* @__PURE__ */ M.jsx(
        $u,
        {
          code: Sr.SERVICE_TEMPORARY_UNAVAILABLE,
          title: yr.SERVICE_TEMPORARY_UNAVAILABLE,
          subTitle: n || yr.SERVICE_TEMPORARY_UNAVAILABLE_MESSAGE,
          image: ib,
          imageType: s,
          reload: e
        }
      );
    default:
      return /* @__PURE__ */ M.jsx(g9, { reload: e, className: r });
  }
})(), CSt = ({
  content: t,
  initialTippyText: e = "Copy",
  copiedTippyText: n = "Copied!",
  duration: r = 1e3,
  copyToClipboardPromise: o,
  rootClassName: i = "",
  iconSize: s = 16,
  handleSuccess: a,
  variant: l = "default",
  size: c
}) => {
  const [u, d] = Ye(!1), f = Ue(-1), h = () => {
    d(!0), f.current = setTimeout(() => {
      d(!1), f.current = -1;
    }, r);
  }, p = async (_) => {
    try {
      _ ? await _we(t) : await o, a?.(), h();
    } catch {
    }
  }, m = async (_) => {
    _ && Xv(_), await p(!0);
  };
  Ne(() => {
    o && p().catch(eo);
  }, [o]), Ne(
    () => () => {
      f.current > -1 && clearTimeout(f.current);
    },
    []
  );
  const g = `icon-dim-${s} dc__no-shrink`, y = `Copy ${t}`, v = () => /* @__PURE__ */ M.jsx("div", { className: "flex", children: u ? /* @__PURE__ */ M.jsx(EEe, { className: g }) : /* @__PURE__ */ M.jsx(PEe, { className: g }) }), b = u ? n : e;
  return l === "button--secondary" ? /* @__PURE__ */ M.jsx(
    Ar,
    {
      variant: Nr.secondary,
      dataTestId: "clippy-button",
      icon: v(),
      size: c,
      onClick: m,
      tooltipProps: {
        content: b
      },
      showTooltip: !0,
      ariaLabel: y,
      style: Ti.neutral
    }
  ) : /* @__PURE__ */ M.jsx(Ai, { content: b, alwaysShowTippyOnHover: !0, children: /* @__PURE__ */ M.jsx(
    "button",
    {
      type: "button",
      className: `dc__outline-none-imp p-0 flex dc__transparent--unstyled dc__no-border ${i}`,
      "aria-label": y,
      onClick: m,
      children: v()
    }
  ) });
};
lr(null);
const kSt = 2e3, ASt = xt.define();
jr.define({
  create() {
    return !1;
  },
  update(t, e) {
    const n = e.effects.find((r) => r.is(ASt));
    return n ? n.value : t;
  }
});
const TSt = (t) => {
  const e = document.createElement("span");
  e.className = `flex h-100 ${t ? "" : "is-closed"}`;
  const n = /* @__PURE__ */ M.jsx(
    zse,
    {
      className: "icon-dim-12 scn-6 rotate",
      style: { "--rotateBy": t ? "0deg" : "-90deg" }
    }
  );
  return e.innerHTML = vhe.renderToString(n), e;
}, RSt = () => {
  const t = document.createElement("div"), e = /* @__PURE__ */ M.jsx("div", { className: "code-editor__read-only-tooltip py-6 px-10 br-4 text__white", children: /* @__PURE__ */ M.jsx("p", { className: "m-0 fs-12 lh-18", children: "Cannot edit in read-only editor" }) });
  return t.innerHTML = vhe.renderToString(e), t;
}, PSt = ["ArrowUp", "ArrowRight", "ArrowDown", "ArrowLeft", "Enter", "Escape"], O3 = xt.define();
jr.define({
  // Initializes the tooltip state as null
  create: () => null,
  // Updates the tooltip state based on the dispatched effects
  update: (t, e) => {
    const n = e.effects.find((r) => r.is(O3));
    return n ? n.value : t;
  },
  // Provides the tooltip to the editor's UI
  provide: (t) => TS.from(t)
});
const $St = (t) => {
  const e = t.state.selection.main.head;
  if (e === null)
    return null;
  const n = RSt();
  n.classList.add("dc__w-fit-content"), document.body.appendChild(n);
  const r = -(n.getBoundingClientRect().width / 2);
  return document.body.removeChild(n), {
    pos: e,
    // Display the tooltip above the cursor
    above: !0,
    // Provide tooltip dom element and offset it's position to be in center.
    create: () => ({ dom: n, offset: { x: r, y: 4 }, overlap: !0 })
  };
};
kr.fromClass(
  class {
    constructor(t) {
      Gn(this, "timeoutId", null), Gn(this, "handleKeyPress", (e) => {
        if (!this.view.state.readOnly || PSt.includes(e.key) || e.metaKey || e.shiftKey || e.altKey || e.ctrlKey)
          return;
        const n = $St(this.view);
        this.view.dispatch({ effects: O3.of(n) }), this.timeoutId && clearTimeout(this.timeoutId), this.timeoutId = setTimeout(() => {
          this.view.dispatch({ effects: O3.of(null) });
        }, kSt);
      }), this.view = t, this.view.dom.addEventListener("keydown", this.handleKeyPress);
    }
    destroy() {
      this.view.dom.removeEventListener("keydown", this.handleKeyPress), this.timeoutId && clearTimeout(this.timeoutId);
    }
  }
);
const swe = (t) => /^(true|false)$/i.test(t), MSt = (t) => swe(t) || /^[-+]?\d*\.\d+$/.test(t) || /^[-+]?\d+$/.test(t), Mie = (t) => {
  const e = [], n = U8e(t, t.doc.length);
  return n && n.iterate({
    from: 0,
    to: t.doc.length,
    enter: (r) => {
      if (r.name === "Pair") {
        const o = r.node.getChild("Literal");
        if (o) {
          const i = t.sliceDoc(o.from, o.to).trim();
          MSt(i) && e.push(
            ut.mark({
              class: swe(i) ? "cm-highlight-bool" : "cm-highlight-number"
            }).range(o.from, o.to)
          );
        }
      }
    }
  }), ut.set(e);
};
jr.define({
  create(t) {
    return Mie(t);
  },
  update(t, e) {
    let n = t.map(e.changes);
    return e.docChanged && (n = Mie(e.state)), n;
  },
  provide: (t) => et.decorations.from(t)
});
lfe({
  markerDOM: TSt
});
lr({
  name: "",
  value: "",
  disabled: !1,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  onChange: (t) => {
  }
});
Vu.GIT + "", Vu.GITHUB + "", Vu.GITLAB + "", Vu.BITBUCKET + "", Vu.GITEA + "", Vu.AZURE + "";
const DSt = ({ callback: t, hasError: e }) => {
  const n = Ue(null), r = dEt(n, {
    rootMargin: "0px",
    once: !1
  });
  return Ne(() => {
    r && t();
  }, [r]), e ? /* @__PURE__ */ M.jsx("div", { className: "p-24 flex", children: /* @__PURE__ */ M.jsx(H_e, { reload: t }) }) : /* @__PURE__ */ M.jsx("span", { className: "pb-5", ref: n });
}, ISt = (t = {}) => ({
  container: (e, n) => ({
    ...e,
    ...n.isDisabled && {
      cursor: "not-allowed",
      pointerEvents: "auto"
    }
  }),
  menuList: (e) => ({
    ...e,
    padding: 0,
    paddingBlock: "4px",
    cursor: "pointer"
  }),
  control: (e, n) => ({
    ...e,
    minHeight: "32px",
    boxShadow: "none",
    backgroundColor: "var(--bg-secondary)",
    border: "1px solid var(--N200)",
    cursor: n.isDisabled ? "not-allowed" : "pointer",
    opacity: n.isDisabled ? 0.5 : 1,
    "&:hover": {
      borderColor: "var(--N300)"
    },
    "&:focus, &:focus-within": {
      borderColor: "var(--B500)",
      outline: "none"
    }
  }),
  option: (e, n) => ({
    ...e,
    color: "var(--N900)",
    // eslint-disable-next-line no-nested-ternary
    backgroundColor: n.isSelected ? "var(--B100)" : n.isFocused ? "var(--N100)" : "var(--bg-primary)",
    padding: "10px 12px",
    cursor: "pointer",
    fontSize: "13px",
    lineHeight: "20px",
    fontWeight: 400,
    ":active": {
      backgroundColor: "var(--N100)"
    }
  }),
  dropdownIndicator: (e, n) => ({
    ...e,
    color: "var(--N600)",
    padding: "0 8px",
    transition: "all .2s ease",
    transform: n.selectProps.menuIsOpen ? "rotate(180deg)" : "rotate(0deg)"
  }),
  valueContainer: (e) => ({
    ...e,
    padding: "0 8px",
    fontWeight: "400"
  }),
  loadingMessage: (e) => ({
    ...e,
    color: "var(--N600)"
  }),
  noOptionsMessage: (e) => ({
    ...e,
    color: "var(--N600)"
  }),
  placeholder: (e) => ({
    ...e,
    color: "var(--N500)",
    fontSize: "13px",
    lineHeight: "20px",
    fontWeight: 400,
    margin: 0,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  }),
  group: (e) => ({
    ...e,
    paddingTop: "4px",
    paddingBottom: 0
  }),
  groupHeading: (e) => ({
    ...e,
    fontWeight: 600,
    fontSize: "12px",
    color: "var(--N900)",
    backgroundColor: "var(--N100)",
    marginBottom: 0,
    padding: "4px 8px",
    textTransform: "none",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  }),
  singleValue: (e) => ({
    ...e,
    color: "var(--N900)"
  }),
  input: (e) => ({
    ...e,
    color: "var(--N900)"
  }),
  menu: (e) => ({
    ...e,
    backgroundColor: "var(--bg-menu-primary)",
    border: "1px solid var(--border-primary-translucent)"
  }),
  multiValue: (e) => ({
    ...e,
    background: "var(--bg-primary)",
    border: "1px solid var(--N200)",
    borderRadius: "4px",
    padding: "1px 5px",
    maxWidth: "250px",
    margin: 0,
    display: "flex",
    alignItems: "center",
    gap: "4px"
  }),
  multiValueLabel: (e) => ({
    ...e,
    borderRadius: 0,
    color: "var(--N900)",
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: "20px",
    padding: 0,
    paddingLeft: 0
  }),
  ...t
}), NSt = (t, e) => t ? "var(--B100)" : e ? "var(--bg-secondary)" : "var(--bg-primary)", jSt = (t = {}) => (e, n) => ({
  ...e,
  backgroundColor: NSt(n.isSelected, n.isFocused),
  color: n.isSelected ? "var(--B500)" : "var(--N900)",
  textOverflow: "ellipsis",
  fontWeight: "500",
  overflow: "hidden",
  textAlign: "left",
  whiteSpace: "nowrap",
  cursor: "pointer",
  fontSize: "13px",
  ...t
});
ISt();
const C3 = ({ handleClick: t = eo, commits: e }) => e?.length > 0 ? /* @__PURE__ */ M.jsx("div", { className: "flexbox", children: /* @__PURE__ */ M.jsxs(
  "button",
  {
    type: "button",
    className: "dc__transparent p-0 flexbox dc__gap-4 fs-14 lh-20 cb-5 dc__truncate mono cursor",
    onClick: t,
    children: [
      /* @__PURE__ */ M.jsxs("span", { className: "flex dc__gap-4 br-4 pl-6 pr-6 bcb-1", children: [
        /* @__PURE__ */ M.jsx(vEe, { className: "icon-dim-14 dc__no-shrink fcb-5" }),
        /* @__PURE__ */ M.jsx("span", { children: e[0].substring(0, 7) })
      ] }),
      e.length > 1 && /* @__PURE__ */ M.jsx("span", { className: "flex br-4 pl-6 pr-6 bcb-1", children: "…" })
    ]
  }
) }) : /* @__PURE__ */ M.jsx("span", {}), awe = Wt(
  ({
    ciMaterials: t,
    gitTriggers: e,
    addMarginTop: n
  }) => (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    /* @__PURE__ */ M.jsx(M.Fragment, { children: Object.keys(e ?? {}).length > 0 && t?.map((r) => {
      const o = e[r.id], i = o?.CiConfigureSourceType || r?.type, s = o?.CiConfigureSourceValue || r?.value, a = o?.GitRepoUrl || r?.url;
      return i !== yp.WEBHOOK && !o ? null : /* @__PURE__ */ M.jsx("div", { className: `${n ? "mt-16" : ""}`, children: i === yp.WEBHOOK ? /* @__PURE__ */ M.jsx("div", { className: "flex left column", children: /* @__PURE__ */ M.jsx(
        mSt,
        {
          sourceType: i,
          sourceValue: s,
          showTooltip: !1
        }
      ) }) : /* @__PURE__ */ M.jsxs("div", { className: "flexbox-col dc__gap-4", children: [
        /* @__PURE__ */ M.jsxs("div", { className: "flexbox dc__gap-6 dc__align-start", children: [
          hEt(a),
          o?.GitRepoName && /* @__PURE__ */ M.jsx("span", { className: "cn-9 fs-13 fw-6 lh-20 dc__word-break", children: o.GitRepoName })
        ] }),
        /* @__PURE__ */ M.jsxs("div", { className: "flexbox dc__gap-6 dc__align-start", children: [
          /* @__PURE__ */ M.jsx(Bse, { className: "icon-dim-20 p-2 dc__no-shrink fcn-7" }),
          /* @__PURE__ */ M.jsx("span", { className: "cn-7 dc__word-break fs-13 fw-4 lh-16", children: s })
        ] }),
        o?.Commit && /* @__PURE__ */ M.jsx(
          C3,
          {
            commits: [o.Commit],
            handleClick: K_e(
              Q_e(r.url, o.Commit)
            )
          }
        ),
        o?.Message && /* @__PURE__ */ M.jsx("p", { className: "m-0 cn-9 fs-13 fw-4 lh-20 dc__truncate--clamp-3", children: o.Message })
      ] }) }, r.id);
    }) })
  )
), lwe = Wt(
  ({
    message: t,
    podStatus: e,
    stage: n,
    workerPodName: r,
    finishedOn: o,
    clusterId: i,
    namespace: s,
    workerMessageContainerClassName: a,
    titleClassName: l = "cn-9 fs-13 fw-4 lh-20",
    viewWorkerPodClassName: c = "fs-13",
    hideShowMoreMessageButton: u = !1,
    children: d
  }) => {
    if (!t && !e)
      return null;
    const f = r && (!Th(o) || !qe(o).isBefore(qe().subtract(GEt, "hours"))), h = () => f ? /* @__PURE__ */ M.jsx(
      Dse,
      {
        to: `${fSt(i, s)}/${r}/logs`,
        target: "_blank",
        className: "anchor",
        children: /* @__PURE__ */ M.jsx("span", { className: `mr-10 ${c}`, children: "View worker pod" })
      }
    ) : null;
    return /* @__PURE__ */ M.jsxs(M.Fragment, { children: [
      /* @__PURE__ */ M.jsx("div", { className: "flexbox dc__content-center", children: UE[e] ? /* @__PURE__ */ M.jsx(Ut, { size: 20, name: "ic-warning", color: null }) : /* @__PURE__ */ M.jsx(yEe, { className: "icon-dim-20 dc__no-shrink scn-7" }) }),
      /* @__PURE__ */ M.jsxs("div", { className: "flexbox-col", children: [
        /* @__PURE__ */ M.jsxs("div", { className: "flexbox dc__gap-8", children: [
          /* @__PURE__ */ M.jsxs("div", { className: `flexbox cn-9 ${l}`, children: [
            /* @__PURE__ */ M.jsx("span", { children: n === Pl.DEPLOY && !e ? "Message" : "Worker" }),
            e && /* @__PURE__ */ M.jsxs("span", { children: [
              ": ",
              QEt[e] || e.toLowerCase(),
              " "
            ] })
          ] }),
          n !== Pl.DEPLOY && h()
        ] }),
        t && /* @__PURE__ */ M.jsx(
          xSt,
          {
            text: t,
            textClass: "cn-7",
            containerClass: a,
            hideShowMore: u
          },
          t
        ),
        d
      ] })
    ] });
  }
), Die = "icon-dim-20 dc__no-shrink", LSt = Wt(
  ({
    workflowExecutionStages: t,
    triggeredByEmail: e,
    namespace: n,
    podName: r,
    stage: o,
    gitTriggers: i,
    ciMaterials: s
  }) => {
    const a = m9(t);
    return /* @__PURE__ */ M.jsxs("div", { className: "shadow__overlay p-16 br-4 w-350 bg__overlay--primary border__primary mxh-300 dc__overflow-auto flexbox-col dc__gap-16", children: [
      /* @__PURE__ */ M.jsxs("div", { className: "dc__icon-text-layout", children: [
        /* @__PURE__ */ M.jsx(Fse, { className: `scn-7 ${Die}` }),
        /* @__PURE__ */ M.jsx("time", { className: "cn-9 fs-12 cn-9 fw-4 lh-20", children: a?.triggeredOn ? WO(a.triggeredOn) : "--" }),
        /* @__PURE__ */ M.jsx(uEe, { className: `fcn-7 ${Die}` }),
        /* @__PURE__ */ M.jsx(Ai, { content: e, children: /* @__PURE__ */ M.jsx("span", { className: "cn-9 fs-12 fw-4 lh-20 dc__truncate", children: e }) }),
        /* @__PURE__ */ M.jsx(
          lwe,
          {
            message: a?.workerDetails.message,
            podStatus: a?.workerDetails.status,
            stage: o,
            finishedOn: a?.workerDetails.endTime,
            clusterId: a?.workerDetails.clusterId || VO,
            workerPodName: r,
            namespace: n,
            workerMessageContainerClassName: "cn-7 fs-12 fw-4 lh-18",
            titleClassName: "cn-9 fs-12 fw-4 lh-20",
            viewWorkerPodClassName: "fs-12",
            hideShowMoreMessageButton: !0
          }
        )
      ] }),
      Object.keys(i ?? {}).length > 0 && s?.length > 0 && /* @__PURE__ */ M.jsx("div", { className: "dc__border-bottom-n1" }),
      /* @__PURE__ */ M.jsx(awe, { gitTriggers: i, ciMaterials: s })
    ] });
  }
), FSt = Wt(
  ({
    status: t,
    startedOn: e,
    triggeredBy: n,
    triggeredByEmail: r,
    ciMaterials: o,
    gitTriggers: i
  }) => {
    const s = n === 1 ? "auto trigger" : r;
    return /* @__PURE__ */ M.jsxs("div", { className: "shadow__overlay p-16 br-4 w-400 bg__overlay--primary border__primary mxh-300 dc__overflow-auto", children: [
      /* @__PURE__ */ M.jsx("span", { className: "fw-6 fs-16 mb-4", style: { color: S3[t.toLowerCase()] }, children: rwe(t) }),
      /* @__PURE__ */ M.jsxs("div", { className: "flex column left", children: [
        /* @__PURE__ */ M.jsxs("div", { className: "flex left fs-12 cn-7", children: [
          /* @__PURE__ */ M.jsx("div", { className: "dc__no-shrink", children: qe(e).format(a9.TWELVE_HOURS_FORMAT) }),
          /* @__PURE__ */ M.jsx("div", { className: "dc__bullet ml-6 mr-6 dc__no-shrink" }),
          /* @__PURE__ */ M.jsx(Ai, { content: s, children: /* @__PURE__ */ M.jsx("span", { className: "dc__truncate", children: s }) })
        ] }),
        /* @__PURE__ */ M.jsx(awe, { addMarginTop: !0, ciMaterials: o, gitTriggers: i })
      ] })
    ] });
  }
), BSt = Wt(
  ({ handleViewAllHistory: t }) => /* @__PURE__ */ M.jsxs("div", { className: "flex pt-12 pb-12 pl-16 pr-16 dc__gap-16 dc__align-self-stretch", children: [
    /* @__PURE__ */ M.jsx(
      "button",
      {
        type: "button",
        "aria-label": "all-history",
        className: "p-0 dc__no-background dc__no-border h-16",
        onClick: t,
        children: /* @__PURE__ */ M.jsx(lEe, { width: 16, height: 16 })
      }
    ),
    /* @__PURE__ */ M.jsx("div", { style: { flex: "1 0 0" }, children: /* @__PURE__ */ M.jsx("p", { className: "ci-cd-details__sidebar-typography", children: "View all items in history" }) })
  ] })
), zSt = Wt(
  ({
    id: t,
    status: e,
    startedOn: n,
    triggeredBy: r,
    triggeredByEmail: o,
    ciMaterials: i,
    gitTriggers: s,
    artifact: a,
    type: l,
    stage: c,
    dataTestId: u,
    renderRunSource: d,
    runSource: f,
    resourceId: h,
    podName: p,
    namespace: m,
    workflowExecutionStages: g
  }) => {
    const { path: y, params: v } = I3(), { pathname: b } = N3(), _ = b.split("/").pop(), { envId: w, ...x } = Gy(), E = l === er.CD || l === er.GROUP_CD, S = E ? "triggerId" : "buildId", C = h === f?.id, R = Ue(null), P = () => {
      const T = {
        ...x,
        envId: w,
        [S]: t
      };
      return `${Yf(y, T)}/${_}`;
    }, N = () => {
      R?.current && R.current.scrollIntoView({ behavior: "smooth" });
    };
    Ne(() => {
      N();
    }, [R]);
    const A = v[S], O = (T) => {
      +A == +t && (R.current = T);
    }, k = c !== Pl.DEPLOY && Object.keys(g || {}).length > 0;
    return /* @__PURE__ */ M.jsx(
      Hp,
      {
        condition: Array.isArray(i),
        wrap: (T) => /* @__PURE__ */ M.jsx(
          FXe,
          {
            placement: "right",
            interactive: !0,
            render: () => (
              // Adding check for workflowExecutionStages to cater backward compatibility
              k ? /* @__PURE__ */ M.jsx(
                LSt,
                {
                  workflowExecutionStages: g,
                  triggeredByEmail: o,
                  namespace: m,
                  podName: p,
                  stage: c,
                  gitTriggers: s,
                  ciMaterials: i
                }
              ) : /* @__PURE__ */ M.jsx(
                FSt,
                {
                  status: e,
                  startedOn: n,
                  triggeredBy: r,
                  triggeredByEmail: o,
                  ciMaterials: i,
                  gitTriggers: s
                }
              )
            ),
            children: T
          }
        ),
        children: /* @__PURE__ */ M.jsx(
          Dse,
          {
            to: P,
            className: "w-100 deployment-history-card-container p-8 br-4",
            "data-testid": u,
            activeClassName: "active",
            ref: O,
            children: /* @__PURE__ */ M.jsxs("div", { className: "w-100 deployment-history-card", children: [
              k ? dSt(g) : /* @__PURE__ */ M.jsx(
                twe,
                {
                  status: hSt(e),
                  hideMessage: !0,
                  hideIconTooltip: !0,
                  iconSize: 20
                }
              ),
              /* @__PURE__ */ M.jsxs("div", { className: "flexbox-col dc__gap-8", children: [
                /* @__PURE__ */ M.jsxs("div", { className: "flex column left", children: [
                  /* @__PURE__ */ M.jsx("div", { className: "cn-9 fs-13 lh-20", children: qe(n).format(a9.TWELVE_HOURS_FORMAT) }),
                  /* @__PURE__ */ M.jsxs("div", { className: "flex left cn-7 fs-12", children: [
                    E && /* @__PURE__ */ M.jsxs(M.Fragment, { children: [
                      /* @__PURE__ */ M.jsx("div", { className: "dc__first-letter-capitalize dc__no-shrink", children: ["pre", "post"].includes(c?.toLowerCase()) ? `${c}-deploy` : c }),
                      /* @__PURE__ */ M.jsx("span", { className: "dc__bullet dc__bullet--d2 ml-4 mr-4" }),
                      a && /* @__PURE__ */ M.jsxs("div", { className: "dc__app-commit__hash dc__app-commit__hash--no-bg dc__no-shrink", children: [
                        /* @__PURE__ */ M.jsx(cEe, { className: "commit-hash__icon grayscale" }),
                        a.split(":")[1].slice(-12)
                      ] }),
                      /* @__PURE__ */ M.jsx("span", { className: "dc__bullet dc__bullet--d2 ml-4 mr-4" })
                    ] }),
                    /* @__PURE__ */ M.jsx("div", { className: "cn-7 fs-12 dc__truncate", children: r === 1 ? "auto trigger" : o })
                  ] })
                ] }),
                f && d && d(f, C)
              ] })
            ] })
          }
        )
      }
    );
  }
);
xe.memo(
  ({
    type: t,
    filterOptions: e,
    triggerHistory: n,
    hasMore: r,
    setPagination: o,
    fetchIdData: i,
    handleViewAllHistory: s,
    children: a,
    renderRunSource: l,
    resourceId: c
  }) => {
    const { pipelineId: u, appId: d, envId: f } = Gy(), { push: h } = Yy(), { path: p } = I3(), m = (x) => {
      t === er.CI ? (o({ offset: 0, size: 20 }), h(Yf(p, { appId: d, pipelineId: x.value }))) : t === er.GROUP_CI ? (o({ offset: 0, size: 20 }), h(Yf(p, { envId: f, pipelineId: x.pipelineId }))) : t === er.GROUP_CD ? (o({ offset: 0, size: 20 }), h(Yf(p, { envId: f, appId: x.value, pipelineId: x.pipelineId }))) : (o({ offset: 0, size: 20 }), h(Yf(p, { appId: d, envId: x.value, pipelineId: x.pipelineId })));
    }, g = () => {
      KRe.event({
        category: "pagination",
        action: "auto",
        label: `${t.toLowerCase()}-history`,
        value: n.size
      }), o({ offset: n.size, size: 20 });
    }, y = () => t === er.CI || t === er.GROUP_CI ? u : t === er.GROUP_CD ? d : f, v = e?.find((x) => x.value === y()) ?? null;
    e?.sort((x, E) => x.label > E.label ? 1 : -1);
    const b = e?.filter((x) => !x.deploymentAppDeleteRequest), _ = () => t === er.GROUP_CI || t === er.GROUP_CD ? vD.APPLICATION : t === er.CI ? vD.PIPELINE : vD.ENVIRONMENT, w = (x) => (x.selectProps.styles.option = jSt(), /* @__PURE__ */ M.jsx(Lse.Option, { ...x, children: /* @__PURE__ */ M.jsxs("div", { className: "flexbox dc dc__gap-4", children: [
      (t === er.CI || t === er.GROUP_CI) && /* @__PURE__ */ M.jsx(
        Ut,
        {
          name: x.data.pipelineType?.toLowerCase() === "ci_job" ? "ic-job-color" : "ic-build-color",
          size: 20,
          color: null
        }
      ),
      /* @__PURE__ */ M.jsx("span", { children: x.label })
    ] }) }));
    return /* @__PURE__ */ M.jsxs(M.Fragment, { children: [
      a || /* @__PURE__ */ M.jsxs("div", { className: "select-pipeline-wrapper w-100 pl-16 pr-16 dc__overflow-hidden dc__border-bottom-n1", children: [
        /* @__PURE__ */ M.jsxs(
          "label",
          {
            htmlFor: "history-pipeline-selector",
            className: "form__label",
            "data-testid": "select-history-heading",
            children: [
              "Select ",
              _()
            ]
          }
        ),
        /* @__PURE__ */ M.jsx(
          aEe,
          {
            classNamePrefix: "history-pipeline-dropdown",
            value: v,
            options: t === er.CI || t === er.GROUP_CI ? e : b,
            onChange: m,
            components: {
              IndicatorSeparator: null,
              Option: w,
              DropdownIndicator: QOt
            },
            styles: HEt,
            menuPosition: "fixed",
            inputId: "history-pipeline-selector"
          }
        )
      ] }),
      /* @__PURE__ */ M.jsxs("div", { className: "flex column top left flex-grow-1 dc__overflow-auto p-8", children: [
        i === x3.SUCCESS && /* @__PURE__ */ M.jsx(BSt, { handleViewAllHistory: s }),
        pSt(n).map(([x, E], S) => /* @__PURE__ */ M.jsx(
          zSt,
          {
            dataTestId: `deployment-history-${S}`,
            id: x,
            status: E.status,
            startedOn: E.startedOn,
            triggeredBy: E.triggeredBy,
            triggeredByEmail: E.triggeredByEmail,
            ciMaterials: E.ciMaterials,
            gitTriggers: E.gitTriggers,
            artifact: E.artifact,
            stage: E.stage,
            type: t,
            runSource: E.runSource,
            renderRunSource: l,
            resourceId: c,
            workflowExecutionStages: E.workflowExecutionStages,
            podName: E.podName,
            namespace: E.namespace
          },
          x
        )),
        r && (i === x3.SUSPEND || !i) && /* @__PURE__ */ M.jsx(DSt, { callback: g })
      ] })
    ] });
  }
);
const y9 = ({
  imagePath: t,
  registryType: e,
  handleClick: n,
  isExpanded: r,
  placement: o = "auto"
}) => {
  const [i, s] = Ye(!1), a = () => {
    s((c) => !c);
  }, l = r ?? i;
  return /* @__PURE__ */ M.jsx("div", { className: "cn-7 fs-14 lh-20 flexbox", children: /* @__PURE__ */ M.jsx(hS, { content: t, className: "default-tt", placement: o, arrow: !1, children: /* @__PURE__ */ M.jsxs(
    "button",
    {
      type: "button",
      className: `display-grid dc__align-items-center dc__select-text image-chip-cell__container ${l ? "image-chip-cell__container--expanded" : ""} bcn-1 br-6 dc__transparent py-0 px-6 cursor max-w-100`,
      onClick: n || a,
      children: [
        /* @__PURE__ */ M.jsx(ol, { registryType: e || zn.DOCKER, size: 14 }),
        l ? /* @__PURE__ */ M.jsx("div", { className: "mono dc__ellipsis-left direction-left", children: t }) : /* @__PURE__ */ M.jsxs(M.Fragment, { children: [
          /* @__PURE__ */ M.jsx("div", { children: "…" }),
          /* @__PURE__ */ M.jsx("div", { className: "mono dc__ellipsis-left direction-left text-overflow-clip", children: t.split(":").slice(-1)[0] ?? "" })
        ] })
      ]
    }
  ) }) });
}, qSt = lr(null), USt = () => Hn(qSt);
var HE = /* @__PURE__ */ ((t) => (t.info = "info", t.delete = "delete", t.warning = "warning", t.custom = "custom", t))(HE || {});
const k3 = (t) => {
  const { setModalKey: e, settersRef: n } = USt();
  return Ne(() => {
    const r = HO();
    return e(r), () => {
      e((o) => o === r ? "" : o);
    };
  }, []), Ne(() => {
    n.current.setProps(t);
  }, [t]), null;
}, HSt = ({ appName: t, environmentName: e, handleClose: n }) => {
  const r = Yy(), { appId: o, envId: i, pipelineId: s, triggerId: a } = Gy(), [l, c] = Ye(!1), u = async () => {
    c(!0);
    try {
      await owe({
        pipelineId: s,
        triggerId: a,
        appId: o
      }), c(!1), r.push(`${Up.APPLICATION_MANAGEMENT_APP}/${o}/details/${i}`);
    } catch (d) {
      Vy(d), c(!1);
    }
  };
  return /* @__PURE__ */ M.jsx(
    k3,
    {
      variant: HE.custom,
      Icon: /* @__PURE__ */ M.jsx(Ut, { name: "ic-warning", color: null, size: 48 }),
      title: "Take resource ownership and redeploy",
      subtitle: `Ensure the resources belong to the '${t}' application and the '${e}' environment to avoid destructive changes.`,
      handleClose: n,
      buttonConfig: {
        secondaryButtonConfig: {
          text: "Cancel",
          onClick: n
        },
        primaryButtonConfig: {
          isLoading: l,
          text: "Re-deploy",
          onClick: u,
          style: Ti.warning
        }
      }
    }
  );
};
class VSt extends xe.Component {
  constructor(e) {
    super(e), Gn(this, "handleBodyClick", (n) => {
      document.getElementById(Xwt) || (n.stopPropagation(), this.props.close?.(n));
    }), this.escFunction = this.escFunction.bind(this);
  }
  escFunction() {
    this.props.onEscape ? this.props.onEscape() : this.props.close && this.props.close();
  }
  render() {
    return /* @__PURE__ */ M.jsx(
      f9,
      {
        onEscape: this.escFunction,
        onClick: this.handleBodyClick,
        initialFocus: this.props.initialFocus ?? void 0,
        children: /* @__PURE__ */ M.jsx("div", { className: this.props.parentClassName, children: /* @__PURE__ */ M.jsx("div", { className: `visible-modal__body ${this.props.className || ""}`, children: this.props.children }) })
      }
    );
  }
}
const WSt = ({
  children: t,
  position: e,
  height: n,
  width: r,
  minWidth: o,
  maxWidth: i,
  parentClassName: s,
  onEscape: a,
  onClose: l,
  disableTransition: c,
  initialFocus: u = void 0
}) => {
  const d = Ue(null);
  Ne(() => (setTimeout(() => d.current?.classList?.add("show"), 1), () => {
    d.current?.classList?.remove("show");
  }), []);
  const f = {};
  return (e === "left" || e === "right") && (f["--width"] = r, f["--minWidth"] = o, f["--maxWidth"] = i), (e === "top" || e === "bottom") && (f["--height"] = n), /* @__PURE__ */ M.jsx(
    VSt,
    {
      className: "drawer--container",
      parentClassName: s || "",
      onEscape: a,
      close: l,
      initialFocus: u,
      children: /* @__PURE__ */ M.jsx(
        "aside",
        {
          style: f,
          ref: d,
          className: `drawer ${c ? "disable-transition" : ""} ${e}`,
          children: t
        }
      )
    }
  );
};
var jn = /* @__PURE__ */ ((t) => (t.CLEAR_ALL_SELECTIONS = "CLEAR_ALL_SELECTIONS", t.CLEAR_IDENTIFIERS = "CLEAR_IDENTIFIERS", t.SELECT_ALL_ACROSS_PAGES = "SELECT_ALL_ACROSS_PAGES", t.SELECT_ALL_ON_PAGE = "SELECT_ALL_ON_PAGE", t.SELECT_IDENTIFIER = "SELECT_IDENTIFIER", t.CLEAR_IDENTIFIERS_AFTER_ACROSS_SELECTION = "CLEAR_IDENTIFIERS_AFTER_ACROSS_SELECTION", t.CLEAR_SELECTIONS_AND_SELECT_ALL_ACROSS_PAGES = "CLEAR_SELECTIONS_AND_SELECT_ALL_ACROSS_PAGES", t))(jn || {}), cwe = /* @__PURE__ */ ((t) => (t.OPEN = "OPEN", t.CLOSED = "CLOSED", t))(cwe || {});
const GSt = "bulk-selection-pop-up-menu", bD = {
  [jn.SELECT_ALL_ON_PAGE]: "All on this page",
  [jn.SELECT_ALL_ACROSS_PAGES]: "All across pages",
  [jn.CLEAR_ALL_SELECTIONS]: "Clear selection(s)"
}, tg = "*", YSt = (t) => `Invalid action ${t} passed to useBulkSelection`, KSt = "useBulkSelection must be used within BulkSelectionContext", Iie = "Selections on other pages are cleared", uwe = lr({
  selectedIdentifiers: {},
  handleBulkSelection: eo,
  isChecked: !1,
  checkboxValue: fd.CHECKED,
  isBulkSelectionApplied: !1,
  setIdentifiers: eo,
  getSelectedIdentifiersCount: eo
}), dwe = () => {
  const t = Hn(uwe);
  if (!t)
    throw new Error(KSt);
  return t;
}, XSt = ({
  children: t,
  identifiers: e = null,
  getSelectAllDialogStatus: n
}) => {
  const [r, o] = Ye({}), [i, s] = Ye(e ?? {});
  bwe(() => {
    e && s(e);
  }, [e]);
  const a = r[tg], l = () => Object.keys(r).length, c = (g, y) => {
    const v = JSON.parse(JSON.stringify(g));
    y.forEach((b) => {
      delete v[b];
    }), o(v);
  }, u = (g) => {
    const y = JSON.parse(JSON.stringify(r));
    a && delete y[tg], o({
      ...y,
      ...g
    });
  }, d = ({ action: g, data: y }) => {
    const v = y?.identifierIds ?? [], b = y?.identifierObject ?? {};
    switch (g) {
      case jn.CLEAR_ALL_SELECTIONS:
        o({});
        break;
      case jn.CLEAR_IDENTIFIERS_AFTER_ACROSS_SELECTION: {
        Cl.showToast({
          variant: Qr.info,
          description: Iie
        }), c(i, v);
        break;
      }
      case jn.CLEAR_IDENTIFIERS: {
        c(r, v);
        break;
      }
      case jn.SELECT_ALL_ACROSS_PAGES: {
        if (a || l() > 0 && n() === cwe.OPEN)
          return;
        o({
          [tg]: !0
        });
        break;
      }
      case jn.CLEAR_SELECTIONS_AND_SELECT_ALL_ACROSS_PAGES:
        o({
          [tg]: !0
        });
        break;
      case jn.SELECT_ALL_ON_PAGE: {
        r[tg] && Cl.showToast({
          variant: Qr.info,
          description: Iie
        }), u(i);
        break;
      }
      case jn.SELECT_IDENTIFIER: {
        u(b);
        break;
      }
      default:
        throw new Error(YSt(g));
    }
  }, f = () => Object.keys(r).length === 0 ? {
    isChecked: !1,
    checkboxValue: fd.CHECKED
  } : a ? {
    isChecked: !0,
    checkboxValue: fd.BULK_CHECKED
  } : Object.keys(i).every(
    (g) => r[g]
  ) ? {
    isChecked: !0,
    checkboxValue: fd.CHECKED
  } : {
    isChecked: !0,
    checkboxValue: fd.INTERMEDIATE
  }, { isChecked: h, checkboxValue: p } = f(), m = cn(
    () => ({
      selectedIdentifiers: r,
      handleBulkSelection: d,
      isChecked: h,
      checkboxValue: p,
      isBulkSelectionApplied: a,
      getSelectedIdentifiersCount: l,
      setIdentifiers: s
    }),
    [
      r,
      d,
      h,
      p,
      l,
      i,
      a
    ]
  );
  return /* @__PURE__ */ M.jsx(uwe.Provider, { value: m, children: t });
}, QSt = Ri(
  ({ showPagination: t, disabled: e = !1, showChevronDownIcon: n = !0, selectAllIfNotPaginated: r = !1 }, o) => {
    const { handleBulkSelection: i, isChecked: s, checkboxValue: a, getSelectedIdentifiersCount: l } = dwe(), c = l() > 0, u = [
      {
        id: jn.SELECT_ALL_ON_PAGE,
        label: bD[jn.SELECT_ALL_ON_PAGE],
        startIcon: { name: "ic-check-square" }
      },
      ...t ? [
        {
          id: jn.SELECT_ALL_ACROSS_PAGES,
          label: bD[jn.SELECT_ALL_ACROSS_PAGES],
          startIcon: { name: "ic-check-all" }
        }
      ] : [],
      ...c ? [
        {
          id: jn.CLEAR_ALL_SELECTIONS,
          label: bD[jn.CLEAR_ALL_SELECTIONS],
          startIcon: { name: "ic-close-small" },
          type: "negative"
        }
      ] : []
    ], d = (m) => {
      i({
        action: m.id
      });
    }, f = (m) => {
      m.stopPropagation(), i({
        action: c ? jn.CLEAR_ALL_SELECTIONS : jn.SELECT_ALL_ON_PAGE
      });
    }, h = !r || t, p = (m) => /* @__PURE__ */ M.jsx(
      G_e,
      {
        id: GSt,
        onClick: d,
        position: "bottom",
        options: [
          {
            items: u
          }
        ],
        children: m
      }
    );
    return /* @__PURE__ */ M.jsx(Hp, { wrap: p, condition: h, children: /* @__PURE__ */ M.jsxs("div", { className: "flexbox dc__gap-4 dc__align-items-center", children: [
      /* @__PURE__ */ M.jsx(
        L_e,
        {
          ref: o,
          isChecked: s,
          onChange: h ? eo : f,
          rootClassName: "icon-dim-20 m-0",
          value: a,
          disabled: e,
          onClick: eo
        }
      ),
      n && /* @__PURE__ */ M.jsx(j3, { className: "icon-dim-20 fcn-6 dc__no-shrink" })
    ] }) });
  }
), ZSt = 350, fwe = !!(Storage && localStorage), Vw = "generic-table-configurable-columns", Ww = "bulk-action-gutter", hwe = new EventTarget(), Nie = "table-drag-selector", R_ = [1, 2, 3], JSt = new Error("Neither rows nor getRows function provided"), eOt = ({
  handleClearFilters: t,
  isButtonAvailable: e,
  renderButton: n,
  ...r
}) => {
  const o = !!t, i = () => /* @__PURE__ */ M.jsx(
    Ar,
    {
      dataTestId: "clear-filters",
      onClick: t,
      variant: Nr.secondary,
      size: Oe.medium,
      text: "Clear Filters"
    }
  );
  return /* @__PURE__ */ M.jsx(
    Vd,
    {
      imgName: "img-no-result",
      title: "No results",
      subTitle: "We couldn’t find any matching results",
      ...r,
      isButtonAvailable: o || e,
      renderButton: o ? i : n
    }
  );
}, jie = 5, tOt = [
  { value: 20, selected: !0 },
  { value: 40, selected: !1 },
  { value: 50, selected: !1 }
], _D = ({ size: t, pageSize: e, selectedPageNo: n }) => {
  const r = [], o = Math.ceil(t / e), i = n - 2 < 1 ? 1 : n - 2, s = n + 2 > o ? o : n + 2;
  for (let a = 1; a <= o; a++)
    r.push({
      value: a,
      selected: a === n,
      isVisible: s - jie < a && a < i + jie
    });
  return r;
}, nOt = (t) => t?.length ? t : tOt, rOt = ({
  optionValue: t,
  options: e,
  setOptions: n,
  handleCloseDropdown: r,
  changePageSize: o
}) => {
  const i = () => {
    const s = e.map((a) => ({
      value: a.value,
      selected: a.value === t
    }));
    n([...s]), r(), o(t);
  };
  return /* @__PURE__ */ M.jsx("div", { className: "select__item", onClick: i, children: t }, t);
}, oOt = ({ pageSizeOptions: t, pageSize: e, changePageSize: n }) => {
  const r = nOt(t).map((h) => ({
    value: h.value,
    selected: h.value === e
  })), [o, i] = Ye(!1), [s, a] = Ye(r), l = () => {
    i(!1);
  }, c = () => {
    i(!o);
  }, u = Ue(null);
  sxt(u, l);
  const d = s.find((h) => h.selected), f = o ? "fa fa-caret-up" : "fa fa-caret-down";
  return /* @__PURE__ */ M.jsxs("div", { ref: u, children: [
    o && /* @__PURE__ */ M.jsx("div", { className: "pagination__select-menu", children: s.map((h) => /* @__PURE__ */ M.jsx(
      rOt,
      {
        optionValue: h.value,
        options: s,
        setOptions: a,
        handleCloseDropdown: l,
        changePageSize: n
      }
    )) }),
    /* @__PURE__ */ M.jsxs("button", { type: "button", className: "select__button flexbox", onClick: c, children: [
      /* @__PURE__ */ M.jsx("span", { children: d ? d.value : "" }),
      /* @__PURE__ */ M.jsx("span", { className: "select__icon", children: /* @__PURE__ */ M.jsx("i", { className: f }) })
    ] })
  ] });
}, iOt = ({ value: t, isSelected: e, selectPage: n }) => {
  const r = e ? "page__button page__button--selected" : "page__button", o = () => {
    n(t);
  };
  return /* @__PURE__ */ M.jsx("li", { className: "page", children: /* @__PURE__ */ M.jsx("button", { className: r, onClick: o, type: "button", children: t }) });
}, sOt = ({
  size: t,
  pageSize: e,
  offset: n,
  changePage: r,
  changePageSize: o,
  isPageSizeFix: i,
  pageSizeOptions: s,
  rootClassName: a
}) => {
  const [l, c] = Ye([]);
  Ne(() => {
    const g = _D({ size: t, pageSize: e, selectedPageNo: 1 });
    c(g);
  }, [t, e]), Ne(() => {
    const g = 1 + Math.floor(n / e), y = _D({ size: t, pageSize: e, selectedPageNo: g });
    c(y);
  }, [n]);
  const u = (g) => {
    const y = _D({ size: t, pageSize: e, selectedPageNo: g });
    c(y), r(g);
  }, d = () => {
    const g = l.find((y) => y.selected).value - 1;
    u(g);
  }, f = () => {
    const g = l.find((y) => y.selected).value + 1;
    u(g);
  }, h = n + e < t ? n + e : t, p = l.findIndex((g) => g.selected), m = l.filter((g) => g.isVisible);
  return /* @__PURE__ */ M.jsxs("div", { className: a || "", children: [
    /* @__PURE__ */ M.jsxs("div", { className: "page-number", children: [
      n + 1,
      " - ",
      h,
      " of ",
      t
    ] }),
    /* @__PURE__ */ M.jsxs("ul", { className: "pagination flex", children: [
      /* @__PURE__ */ M.jsx(
        Ar,
        {
          disabled: !p,
          onClick: d,
          ariaLabel: "Previous page",
          variant: Nr.borderLess,
          icon: /* @__PURE__ */ M.jsx(Ut, { name: "ic-caret-down-small", color: null, rotateBy: 90 }),
          dataTestId: "pagination-prev-button-clicked",
          showAriaLabelInTippy: !1,
          size: Oe.xs
        }
      ),
      m.map((g) => /* @__PURE__ */ M.jsx(
        iOt,
        {
          value: g.value,
          isSelected: g.selected,
          selectPage: u
        },
        g.value
      )),
      /* @__PURE__ */ M.jsx(
        Ar,
        {
          disabled: p === l.length - 1,
          onClick: f,
          ariaLabel: "Next page",
          variant: Nr.borderLess,
          icon: /* @__PURE__ */ M.jsx(Ut, { name: "ic-caret-down-small", color: null, rotateBy: 270 }),
          dataTestId: "pagination-prev-button-clicked",
          showAriaLabelInTippy: !1,
          size: Oe.xs
        }
      )
    ] }),
    !i && /* @__PURE__ */ M.jsxs("div", { className: "select", children: [
      /* @__PURE__ */ M.jsx("span", { className: "select__placeholder", children: "Rows per page" }),
      /* @__PURE__ */ M.jsx(
        oOt,
        {
          pageSizeOptions: s,
          pageSize: e,
          changePageSize: o
        }
      )
    ] })
  ] });
};
function aOt({ dragClassName: t }) {
  return /* @__PURE__ */ M.jsx(
    "button",
    {
      type: "button",
      className: `${t} dc__outline-none-imp dc__no-border p-0 dc__transparent h-20`,
      children: /* @__PURE__ */ M.jsx(Use, { className: "dc__grabbable icon-dim-20 fcn-6" })
    }
  );
}
var VE = /* @__PURE__ */ ((t) => (t.PARENT_BOTTOM_CENTER = "PARENT_BOTTOM_CENTER", t.SCREEN_BOTTOM_CENTER = "SCREEN_BOTTOM_CENTER", t.SCREEN_BOTTOM_RIGHT = "SCREEN_BOTTOM_RIGHT", t))(VE || {});
function lOt({
  children: t,
  zIndex: e = Gwt,
  positionVariant: n,
  dragSelector: r,
  parentRef: o,
  boundaryGap: i = 16,
  childDivProps: s = {},
  layoutFixDelta: a = 0
}) {
  const l = J_e(), c = Ue(null), [u, d] = Ye({
    x: 0,
    y: 0
  }), f = (p) => {
    const m = o?.current?.getBoundingClientRect() ?? {
      width: 0,
      height: 0,
      top: 0,
      left: 0
    }, g = c.current?.getBoundingClientRect().height ?? 0, y = c.current?.getBoundingClientRect().width ?? 0;
    switch (p) {
      case VE.PARENT_BOTTOM_CENTER: {
        const v = (m.width - y) / 2, b = m.top > 0 ? m.top : a, _ = (m.height > l.height ? l.height - b : m.height) - g - i;
        return { x: v, y: _ };
      }
      case VE.SCREEN_BOTTOM_RIGHT: {
        const v = l.width - m.left - y - i, b = l.height - m.top - g - i;
        return { x: v, y: b };
      }
      // Add more cases for other variants if needed
      default: {
        const v = l.width / 2 - m.left - y / 2, b = l.height - m.top - g - i;
        return { x: v, y: b };
      }
    }
  };
  Ne(() => {
    const p = f(n);
    d(p);
  }, [c, n, l]);
  function h(p, m) {
    const g = o?.current?.getBoundingClientRect().left ?? 0, y = o?.current?.getBoundingClientRect().top ?? 0, v = c.current?.getBoundingClientRect().height ?? 0, b = c.current?.getBoundingClientRect().width ?? 0;
    g + m.x + b + i > l.width || y + m.y + v + i > l.height || g + m.x < 0 || y + m.y < 0 || d({
      x: m.x,
      y: m.y
    });
  }
  return (
    // Since we are using position fixed so we need to disable click on the div so that it does not interfere with the click of other elements
    /* @__PURE__ */ M.jsx(
      "div",
      {
        className: "dc__position-fixed dc__disable-click",
        style: {
          zIndex: e
        },
        children: /* @__PURE__ */ M.jsx(yx, { handle: r, nodeRef: c, position: u, onDrag: h, children: /* @__PURE__ */ M.jsx(
          "div",
          {
            ref: c,
            ...s,
            style: {
              zIndex: e,
              pointerEvents: "auto"
            },
            children: t
          }
        ) })
      }
    )
  );
}
const cOt = ({
  count: t,
  handleClearBulkSelection: e,
  parentRef: n,
  BulkActionsComponent: r,
  bulkActionsData: o,
  setBulkActionState: i
}) => {
  const s = (a) => {
    const {
      dataset: { key: l }
    } = a.currentTarget;
    i(l);
  };
  return /* @__PURE__ */ M.jsx(
    lOt,
    {
      dragSelector: `.${Nie}`,
      positionVariant: VE.PARENT_BOTTOM_CENTER,
      zIndex: "calc(var(--modal-index) - 1)",
      parentRef: n,
      children: /* @__PURE__ */ M.jsxs("div", { className: "dc__separated-flexbox dc__separated-flexbox--gap-8 p-12 bulk-selection-widget br-8", children: [
        /* @__PURE__ */ M.jsxs("div", { className: "flexbox dc__gap-8", children: [
          /* @__PURE__ */ M.jsx(aOt, { dragClassName: Nie }),
          /* @__PURE__ */ M.jsxs("div", { className: "fs-13 lh-20 fw-6 flex dc__gap-12", children: [
            /* @__PURE__ */ M.jsx("span", { className: "flex dc__gap-2 bcb-5 text__white br-4 px-6", children: t }),
            /* @__PURE__ */ M.jsx("span", { className: "cn-9", children: "Selected" })
          ] })
        ] }),
        /* @__PURE__ */ M.jsx(r, { onActionClick: s, bulkActionsData: o }),
        /* @__PURE__ */ M.jsx(
          Ar,
          {
            icon: /* @__PURE__ */ M.jsx(gEe, {}),
            dataTestId: "table__action-widget--close",
            component: Ph.button,
            style: Ti.negativeGrey,
            variant: Nr.borderLess,
            ariaLabel: "Clear selection(s)",
            size: Oe.small,
            onClick: e,
            showAriaLabelInTippy: !1
          }
        )
      ] })
    }
  );
};
var Gw = /* @__PURE__ */ ((t) => (t.ENTER_PRESSED = "enter-pressed", t.DELETE_PRESSED = "delete-pressed", t.ESCAPE_PRESSED = "escape-pressed", t.OPEN_CONTEXT_MENU = "open-context-menu", t.ROW_CLICKED = "row-clicked", t))(Gw || {}), Hy = /* @__PURE__ */ ((t) => (t.STATE = "state", t.URL = "url", t.NONE = "none", t))(Hy || {}), S0 = /* @__PURE__ */ ((t) => (t.PAGINATED = "paginated", t.INFINITE = "infinite", t.NOT_PAGINATED = "not-paginated", t))(S0 || {});
const uOt = ({
  bulkSelectionConfig: t,
  handleToggleBulkSelectionOnRow: e,
  bulkSelectionReturnValue: n
}, r, o, i) => {
  const s = !!t, { registerShortcut: a, unregisterShortcut: l, targetProps: c } = vEt(), { handleBulkSelection: u } = n ?? {}, [d, f] = Ye(0), h = Ue({ count: 0, type: "" }), p = Cn(
    (y) => {
      hwe.dispatchEvent(
        new CustomEvent(y, { detail: { activeRowData: r[d] } })
      );
    },
    [d, r]
  ), m = Cn(
    (y) => {
      h.current = y === h.current.type ? { count: h.current.count + 1, type: y } : { count: 1, type: y };
      const v = Math.min(d + 1, r.length - 1);
      return f(v), {
        consecutiveSequencesForBulkSelection: h.current.count,
        activeRowIndex: v
      };
    },
    [d, r]
  ), g = Cn(
    (y) => {
      h.current = y === h.current.type ? { count: h.current.count + 1, type: y } : { count: 1, type: y };
      const v = Math.max(d - 1, 0);
      return f(v), {
        consecutiveSequencesForBulkSelection: h.current.count,
        activeRowIndex: v
      };
    },
    [d]
  );
  return Ne(() => (a({
    keys: ["ArrowDown"],
    callback: () => {
      m("arrow-down");
    }
  }), a({
    keys: ["ArrowUp"],
    callback: () => {
      g("arrow-up");
    }
  }), a({
    keys: ["Enter"],
    callback: () => {
      p(Gw.ENTER_PRESSED);
    }
  }), a({
    keys: ["Backspace"],
    callback: () => {
      p(Gw.DELETE_PRESSED);
    }
  }), a({
    keys: ["."],
    callback: () => {
      p(Gw.OPEN_CONTEXT_MENU);
    }
  }), () => {
    l(["ArrowDown"]), l(["ArrowUp"]), l(["Enter"]), l(["Backspace"]), l(["."]);
  }), [m, g, p]), Ne(() => s ? (a({
    keys: ["Escape"],
    callback: () => {
      u({ action: jn.CLEAR_ALL_SELECTIONS });
    }
  }), a({
    keys: ["Shift", "ArrowDown"],
    callback: () => {
      const { consecutiveSequencesForBulkSelection: y, activeRowIndex: v } = m("shift-arrow-down");
      if (d === v)
        return;
      const b = r[d], _ = r[v];
      u({
        action: jn.SELECT_IDENTIFIER,
        data: {
          identifierObject: {
            ...y === 1 ? { [b.id]: b } : {},
            [_.id]: _
          }
        }
      });
    }
  }), a({
    keys: ["Control", "A"],
    callback: () => {
      if (o) {
        i.current?.click(), i.current?.focus({ preventScroll: !0 });
        return;
      }
      u({
        action: jn.SELECT_ALL_ON_PAGE
      });
    }
  }), a({
    keys: ["Shift", "ArrowUp"],
    callback: () => {
      const { consecutiveSequencesForBulkSelection: y, activeRowIndex: v } = g("shift-arrow-up");
      if (d === v)
        return;
      const b = r[d], _ = r[v];
      u({
        action: jn.SELECT_IDENTIFIER,
        data: {
          identifierObject: {
            ...y === 1 ? { [b.id]: b } : {},
            [_.id]: _
          }
        }
      });
    }
  }), a({
    keys: ["X"],
    callback: () => {
      e(r[d]);
    }
  }), () => {
    l(["Shift", "ArrowUp"]), l(["Shift", "ArrowDown"]), l(["X"]), l(["Control", "A"]), l(["Escape"]);
  }) : eo, [
    m,
    g,
    d,
    r,
    e,
    u,
    o
  ]), {
    activeRowIndex: d,
    setActiveRowIndex: f,
    shortcutContainerProps: c
  };
}, dOt = (t, e, n, r) => {
  const { sortBy: o, sortOrder: i } = n ?? {}, s = e ? t.filter((a) => e(a, n)) : t;
  return {
    rows: r && o ? s.sort(
      (a, l) => (i === lo.ASC ? 1 : -1) * r(a.data[o], l.data[o])
    ) : s,
    totalRows: s.length
  };
}, fOt = ({
  allColumns: t,
  id: e
}) => {
  if (!fwe)
    return t;
  try {
    const n = JSON.parse(localStorage.getItem(Vw));
    if (!n?.[e])
      throw new Error();
    const r = n[e];
    if (!Array.isArray(r) || r.some((i) => !i || qE(i.field)))
      throw new Error();
    const o = new Set(r.map((i) => i.field));
    return t.filter((i) => o.has(i.field));
  } catch {
    return t;
  }
}, hOt = ({
  id: t,
  visibleColumns: e
}) => {
  if (!(!fwe || !Array.isArray(e)))
    try {
      const n = JSON.parse(localStorage.getItem(Vw)) ?? {};
      localStorage.setItem(
        Vw,
        JSON.stringify({ ...n, [t]: e })
      );
    } catch {
      localStorage.removeItem(Vw);
    }
}, Lie = ({
  areColumnsConfigurable: t,
  columns: e,
  id: n
}) => t ? fOt({ allColumns: e, id: n }) : e, pOt = ({
  searchSortTimeoutRef: t,
  callback: e
}) => new Promise((n, r) => {
  t.current !== -1 && clearTimeout(t.current), t.current = setTimeout(async () => {
    try {
      n(await e());
    } catch (o) {
      Vy(o), r(o);
    }
    t.current = -1;
  }, ZSt);
}), Fie = (t, e) => ({
  className: "dc__position-sticky dc__zi-1 generic-table__cell--sticky",
  // NOTE: container has a padding left of 20px and the gap between columns is 16px
  // so we want each sticky column to stick to the left of the previous column
  left: `${Number(
    t.split(" ").slice(0, e).reduce((n, r) => n + Number(r.split("px")[0]), 0) ?? 1
  ) + 20 + 16 * e}px`
}), mOt = (t, e, n) => {
  if (!t || !e)
    return;
  const { bottom: r, top: o } = t.getBoundingClientRect(), { bottom: i, top: s } = e.getBoundingClientRect();
  let { scrollTop: a } = e;
  o < s && (a += o - s - n), r > i && (a += r - i), e.scrollTo({ top: a, behavior: "auto" });
}, gOt = ({
  filterData: t,
  rows: e,
  resizableConfig: n,
  additionalProps: r,
  visibleColumns: o,
  stylesConfig: i,
  loading: s,
  bulkSelectionConfig: a,
  bulkSelectionReturnValue: l,
  handleClearBulkSelection: c,
  handleToggleBulkSelectionOnRow: u,
  paginationVariant: d,
  rowActionOnHoverConfig: f,
  pageSizeOptions: h,
  filteredRows: p,
  areFilteredRowsLoading: m,
  getRows: g,
  totalRows: y
}) => {
  const v = Ue(null), b = Ue(null), _ = Ue(null), w = Ue(null), [x, E] = Ye(null), [S, C] = Ye(!1), { width: R, Component: P } = f || {}, {
    BulkActionsComponent: N,
    bulkActionsData: A = null,
    BulkOperationModal: O,
    bulkOperationModalData: k = null,
    disableSelectAllAcrossEvenIfPaginated: T = !1
  } = a ?? {}, { showSeparatorBetweenRows: I = !0 } = i ?? {}, { sortBy: j, sortOrder: z, handleSorting: $, pageSize: D, offset: U, changePage: q, changePageSize: F } = t ?? {}, B = !!a, {
    selectedIdentifiers: H = {},
    isBulkSelectionApplied: Z = !1,
    setIdentifiers: W,
    getSelectedIdentifiersCount: G
  } = l ?? {}, {
    handleResize: ee,
    gridTemplateColumns: Y = o.map((Ie) => typeof Ie.size?.fixed == "number" ? `${Ie.size.fixed}px` : "minmax(200px, 1fr)").join(" ")
  } = n ?? {}, L = R ? `${Y} ${typeof R == "number" ? `minmax(${R}px, 1fr)` : R}` : Y;
  Ne(() => {
    const Ie = () => {
      C(v.current?.scrollLeft > 0);
    }, nt = (ct) => {
      ["ArrowUp", "ArrowDown"].includes(ct.key) && ct.preventDefault();
    };
    v.current.addEventListener("scroll", Ie), v.current.addEventListener("keydown", nt);
  }, []);
  const V = Z ? y : G?.() ?? 0, K = cn(() => {
    const Ie = p ?? [];
    return d !== S0.PAGINATED || d === S0.PAGINATED && g ? Ie : Ie.slice(U, U + D);
  }, [d, U, D, p]), ne = !!g, ce = d === S0.PAGINATED && (ne || p?.length > (h?.[0]?.value ?? s9)), { activeRowIndex: fe, setActiveRowIndex: ve, shortcutContainerProps: _e } = uOt(
    { bulkSelectionConfig: a, bulkSelectionReturnValue: l, handleToggleBulkSelectionOnRow: u },
    K,
    ce,
    _
  );
  bwe(() => {
    ve(0);
  }, [U, K]), Ne(() => {
    W?.(
      K.reduce((Ie, nt) => (Ie[nt.id] = nt, Ie), {})
    );
  }, [K]);
  const Ee = (Ie) => () => {
    $(Ie);
  }, Me = (Ie) => {
    Ie && !["INPUT", "TEXTAREA"].includes(document.activeElement.tagName.toUpperCase()) && Ie.dataset.active === "true" && (Ie.focus({ preventScroll: !0 }), mOt(Ie, v.current, w.current?.offsetHeight), Ie.dataset.active = "false");
  }, Le = () => {
    E(null);
  }, Ce = () => Z && e ? p : Object.values(H), Je = () => s ? R_.map((Ie) => /* @__PURE__ */ M.jsxs(
    "div",
    {
      className: `px-20 flexbox py-12 dc__gap-16 ${I ? "border__secondary--bottom" : ""}`,
      children: [
        B ? /* @__PURE__ */ M.jsx("div", { className: "shimmer w-20" }) : null,
        R_.map((nt) => /* @__PURE__ */ M.jsx("div", { className: "shimmer w-200" }, nt))
      ]
    },
    Ie
  )) : m ? R_.map((Ie) => /* @__PURE__ */ M.jsx(
    "div",
    {
      className: "dc__grid px-20 border__secondary--bottom dc__gap-16",
      style: {
        gridTemplateColumns: L
      },
      children: o.map(({ label: nt }) => /* @__PURE__ */ M.jsx("div", { className: "py-12 flex", "aria-label": "Loading...", children: /* @__PURE__ */ M.jsx("div", { className: "shimmer h-16 w-100" }) }, nt))
    },
    Ie
  )) : K.map((Ie, nt) => {
    const ct = fe === nt, mt = !!H[Ie.id] || Z, gt = () => {
      ve(nt);
    }, Et = () => {
      u(Ie);
    };
    return /* @__PURE__ */ M.jsxs(
      "div",
      {
        ref: ct ? Me : null,
        onClick: gt,
        className: `dc__grid px-20 dc__min-width-fit-content checkbox__parent-container dc__opacity-hover dc__opacity-hover--parent ${I ? "border__secondary--bottom" : ""} fs-13 fw-4 lh-20 cn-9 generic-table__row dc__gap-16 ${ct ? "generic-table__row--active checkbox__parent-container--active" : ""} ${f ? "dc__opacity-hover dc__opacity-hover--parent" : ""} ${mt ? "generic-table__row--bulk-selected" : ""}`,
        style: {
          gridTemplateColumns: L
        },
        "data-active": ct,
        tabIndex: -1,
        children: [
          o.map(({ field: Rt, horizontallySticky: zt, CellComponent: At }, X) => {
            const ae = Rt === Ww, ye = zt || ae, { className: De = "", left: Te = "" } = ye ? Fie(L, X) : {};
            return ae ? /* @__PURE__ */ M.jsx(
              "div",
              {
                className: `flexbox dc__align-items-center ${De}`,
                style: { left: Te },
                children: /* @__PURE__ */ M.jsx(
                  L_e,
                  {
                    isChecked: mt,
                    onChange: Et,
                    rootClassName: "mb-0",
                    value: fd.CHECKED
                  }
                )
              },
              Rt
            ) : /* @__PURE__ */ M.jsx(
              "div",
              {
                className: `${De} generic-table__cell`,
                style: { left: Te },
                children: At ? /* @__PURE__ */ M.jsx(
                  At,
                  {
                    field: Rt,
                    value: Ie.data[Rt],
                    signals: hwe,
                    row: Ie,
                    filterData: t,
                    isRowActive: ct,
                    ...r
                  }
                ) : /* @__PURE__ */ M.jsx("div", { className: "flex left", children: /* @__PURE__ */ M.jsx("span", { className: "fs-13 fw-4 cn-9 lh-20 dc__truncate", children: Ie.data[Rt] }, Rt) })
              },
              Rt
            );
          }),
          P && /* @__PURE__ */ M.jsx(
            "div",
            {
              className: `dc__position-sticky dc__right-0 dc__zi-1 ${ct ? "" : "dc__opacity-hover--child"}`,
              children: /* @__PURE__ */ M.jsx(P, { row: Ie, ...r })
            }
          )
        ]
      },
      Ie.id
    );
  });
  return /* @__PURE__ */ M.jsxs(
    "div",
    {
      ..._e,
      tabIndex: -1,
      role: "grid",
      className: "generic-table flexbox-col dc__overflow-hidden flex-grow-1 dc__outline-none-imp",
      children: [
        /* @__PURE__ */ M.jsxs("div", { className: "flexbox-col flex-grow-1 w-100 dc__overflow-hidden", ref: b, children: [
          /* @__PURE__ */ M.jsxs(
            "div",
            {
              ref: v,
              className: `flex-grow-1 flexbox-col dc__overflow-auto ${S ? "generic-table--scrolled" : ""}`,
              children: [
                /* @__PURE__ */ M.jsx(
                  "div",
                  {
                    ref: w,
                    className: "bg__primary dc__min-width-fit-content px-20 border__secondary--bottom dc__position-sticky dc__zi-2 dc__top-0 generic-table__header",
                    children: s ? /* @__PURE__ */ M.jsxs("div", { className: "flexbox py-12 dc__gap-16", children: [
                      B ? /* @__PURE__ */ M.jsx("div", { className: "shimmer w-20" }) : null,
                      R_.map((Ie) => /* @__PURE__ */ M.jsx("div", { className: "shimmer w-200" }, Ie))
                    ] }) : /* @__PURE__ */ M.jsx(
                      "div",
                      {
                        className: "dc__grid fw-6 cn-7 fs-12 lh-20 py-8 dc__gap-16",
                        style: {
                          gridTemplateColumns: L
                        },
                        children: o.map(
                          ({
                            label: Ie,
                            field: nt,
                            isSortable: ct,
                            size: mt,
                            showTippyOnTruncate: gt,
                            horizontallySticky: Et
                          }, Rt) => {
                            const zt = !!mt?.range, At = Et || nt === Ww, { className: X = "", left: ae = "" } = At ? Fie(L, Rt) : {};
                            return nt === Ww ? /* @__PURE__ */ M.jsx(
                              "div",
                              {
                                className: `flex ${X}`,
                                style: { left: ae },
                                children: /* @__PURE__ */ M.jsx(
                                  QSt,
                                  {
                                    ref: _,
                                    showPagination: T ? !1 : ce,
                                    showChevronDownIcon: !1,
                                    selectAllIfNotPaginated: !0
                                  },
                                  nt
                                )
                              },
                              nt
                            ) : /* @__PURE__ */ M.jsx(
                              "div",
                              {
                                className: `${X}`,
                                style: { left: ae },
                                children: /* @__PURE__ */ M.jsx(
                                  NEt,
                                  {
                                    title: Ie,
                                    isSortable: !!ct,
                                    sortOrder: z,
                                    isSorted: j === nt,
                                    triggerSorting: Ee(nt),
                                    showTippyOnTruncate: gt,
                                    disabled: m,
                                    ...zt ? { isResizable: zt, handleResize: ee, id: Ie } : { isResizable: !1 }
                                  },
                                  nt
                                )
                              },
                              nt
                            );
                          }
                        )
                      }
                    )
                  }
                ),
                Je()
              ]
            }
          ),
          !!a && !!V && /* @__PURE__ */ M.jsx(
            cOt,
            {
              count: V,
              handleClearBulkSelection: c,
              parentRef: b,
              BulkActionsComponent: N,
              setBulkActionState: E,
              bulkActionsData: A
            }
          )
        ] }),
        ce && !m && /* @__PURE__ */ M.jsx(
          sOt,
          {
            pageSize: D,
            changePage: q,
            changePageSize: F,
            offset: U,
            rootClassName: "border__secondary--top flex dc__content-space px-20",
            size: y,
            pageSizeOptions: h
          }
        ),
        x && /* @__PURE__ */ M.jsx(
          O,
          {
            action: x,
            onClose: Le,
            bulkOperationModalData: k,
            isBulkSelectionApplied: Z,
            selections: Ce()
          }
        )
      ]
    }
  );
}, pwe = ({
  filtersVariant: t,
  filterData: e,
  rows: n,
  getRows: r,
  columns: o,
  ViewWrapper: i,
  resizableConfig: s,
  emptyStateConfig: a,
  additionalProps: l,
  areColumnsConfigurable: c,
  filter: u,
  setVisibleColumns: d,
  visibleColumns: f,
  stylesConfig: h,
  loading: p,
  bulkSelectionConfig: m,
  bulkSelectionReturnValue: g,
  id: y,
  handleClearBulkSelection: v,
  handleToggleBulkSelectionOnRow: b,
  paginationVariant: _,
  rowActionOnHoverConfig: w,
  pageSizeOptions: x,
  clearFilters: E
}) => {
  const {
    sortBy: S,
    sortOrder: C,
    searchKey: R = "",
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    handleSorting: P,
    pageSize: N,
    offset: A,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    changePage: O,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    changePageSize: k,
    clearFilters: T,
    areFiltersApplied: I,
    // Destructuring specific filters, grouping the rest with the rest operator
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    handleSearch: j,
    ...z
  } = e ?? {}, $ = Ue(null), D = Ue(-1);
  Ne(() => {
    const Ee = (Me) => {
      setTimeout(() => {
        const Le = Me.currentTarget, Ce = Me.relatedTarget;
        !Le?.contains(document.activeElement) && (!Ce || Ce.tagName === "BODY" || document.activeElement === document.body) && $.current?.getElementsByClassName(
          "generic-table"
        )?.[0]?.focus({ preventScroll: !0 });
      }, 0);
    };
    return $.current?.addEventListener("focusout", Ee), () => {
      clearTimeout(D.current), $.current?.removeEventListener("focusout", Ee);
    };
  }, []), Ne(() => {
    v();
  }, [n]);
  const U = async () => {
    let Ee = n.length;
    return { filteredRows: await pOt({
      searchSortTimeoutRef: D,
      callback: () => {
        const { rows: Me, totalRows: Le } = dOt(
          n,
          u,
          e,
          f.find(({ field: Ce }) => Ce === S)?.comparator
        );
        return Ee = Le, Me;
      }
    }), totalRows: Ee };
  }, [q, F, B, H] = wwe(
    U,
    [R, S, C, n, JSON.stringify(z), f],
    !!n
  ), {
    isFetching: Z,
    data: W,
    error: G,
    refetch: ee
  } = xwe({
    queryFn: async ({ signal: Ee }) => {
      const { rows: Me, totalRows: Le } = await r(e, Ee);
      return { filteredRows: Me, totalRows: Le };
    },
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: [
      R,
      S,
      C,
      r,
      A,
      N,
      JSON.stringify(z),
      f
    ],
    enabled: !!r
  }), Y = r ? Z : q, L = r ? W : F, V = r ? G : B, K = r ? ee : H, { filteredRows: ne, totalRows: ce } = cn(
    () => L ?? { filteredRows: [], totalRows: 0 },
    [L]
  ), fe = Y || V === JSt, ve = i ?? $se, _e = () => V && !fe && !p ? /* @__PURE__ */ M.jsx(iwe, { code: V.code, reload: K }) : !fe && !ne?.length && !p ? t !== Hy.NONE && I ? /* @__PURE__ */ M.jsx(
    eOt,
    {
      ...a.noRowsForFilterConfig,
      handleClearFilters: E ?? T
    }
  ) : /* @__PURE__ */ M.jsx(Vd, { ...a.noRowsConfig }) : /* @__PURE__ */ M.jsx(wEt, { shouldHookOntoWindow: !1, shortcutTimeout: 50, children: /* @__PURE__ */ M.jsx(
    gOt,
    {
      filteredRows: ne,
      areFilteredRowsLoading: fe,
      visibleColumns: f,
      bulkSelectionReturnValue: g,
      paginationVariant: _,
      resizableConfig: s,
      filterData: e,
      handleClearBulkSelection: v,
      handleToggleBulkSelectionOnRow: b,
      rowActionOnHoverConfig: w,
      additionalProps: l,
      bulkSelectionConfig: m,
      loading: p,
      pageSizeOptions: x,
      rows: n,
      stylesConfig: h,
      getRows: r,
      totalRows: ce
    }
  ) });
  return /* @__PURE__ */ M.jsx("div", { ref: $, className: "flexbox-col flex-grow-1 dc__overflow-hidden", id: `table-wrapper-${y}`, children: /* @__PURE__ */ M.jsx(
    ve,
    {
      areRowsLoading: fe,
      clearFilters: T,
      rows: n,
      filteredRows: ne,
      handleSearch: j,
      updateSearchParams: eo,
      offset: A,
      searchKey: R,
      sortBy: S,
      sortOrder: C,
      ...e,
      ...c ? {
        allColumns: o,
        setVisibleColumns: d,
        visibleColumns: f
      } : {},
      ...l,
      children: _e()
    }
  ) });
}, yOt = (t) => {
  const { visibleColumns: e } = t, n = FEt({
    headersConfig: e.map(({ label: r, size: o }) => {
      if (o.range) {
        const {
          range: { minWidth: i, maxWidth: s, startWidth: a }
        } = o;
        return {
          id: r,
          minWidth: i,
          width: a,
          maxWidth: s === "infinite" ? Number.MAX_SAFE_INTEGER : s
        };
      }
      return {
        id: r,
        minWidth: o.fixed,
        width: o.fixed,
        maxWidth: o.fixed
      };
    })
  });
  return /* @__PURE__ */ M.jsx(pwe, { ...t, resizableConfig: n });
}, mwe = (t) => {
  const { visibleColumns: e, bulkSelectionConfig: n } = t, r = cn(
    () => n ? [{ size: { fixed: 20 }, field: Ww }, ...e] : e,
    [!!n, e]
  ), o = r.some(({ size: s }) => s && "range" in s && s.range);
  if (o && r.some(({ size: s }) => s === null))
    throw new Error("If any column is resizable, all columns must have a fixed size");
  const i = { ...t, visibleColumns: r, resizableConfig: null };
  return o ? /* @__PURE__ */ M.jsx(yOt, { ...i }) : /* @__PURE__ */ M.jsx(pwe, { ...i });
}, vOt = (t) => {
  const e = dwe(), { selectedIdentifiers: n, handleBulkSelection: r, isBulkSelectionApplied: o } = e, i = () => {
    r({
      action: jn.CLEAR_ALL_SELECTIONS
    });
  }, s = Cn(
    (a) => {
      if (!n[a.id] && !o) {
        r({
          action: jn.SELECT_IDENTIFIER,
          data: {
            // TODO: maybe add a few comments explaining the difference between identifierIds and identifierObject
            identifierObject: {
              [a.id]: a
            }
          }
        });
        return;
      }
      r({
        action: o ? jn.CLEAR_IDENTIFIERS_AFTER_ACROSS_SELECTION : jn.CLEAR_IDENTIFIERS,
        data: {
          identifierIds: [a.id]
        }
      });
    },
    [o, n]
  );
  return /* @__PURE__ */ M.jsx(
    mwe,
    {
      ...t,
      bulkSelectionReturnValue: e,
      handleClearBulkSelection: i,
      handleToggleBulkSelectionOnRow: s
    }
  );
}, bOt = (t) => {
  const { bulkSelectionConfig: e } = t;
  return e ? /* @__PURE__ */ M.jsx(XSt, { getSelectAllDialogStatus: e.getSelectAllDialogStatus, children: /* @__PURE__ */ M.jsx(vOt, { ...t }) }) : /* @__PURE__ */ M.jsx(
    mwe,
    {
      ...t,
      bulkSelectionReturnValue: null,
      handleClearBulkSelection: eo,
      handleToggleBulkSelectionOnRow: eo
    }
  );
}, v9 = (t) => {
  const { columns: e, id: n, areColumnsConfigurable: r } = t, [o, i] = Ye(Lie({ columns: e, id: n, areColumnsConfigurable: r })), s = (a) => {
    i(a), hOt({ id: n, visibleColumns: a });
  };
  return Ne(() => {
    i(Lie({ columns: e, id: n, areColumnsConfigurable: r }));
  }, [e, n, r]), /* @__PURE__ */ M.jsx(
    bOt,
    {
      ...t,
      visibleColumns: o,
      setVisibleColumns: s
    }
  );
}, _Ot = (t) => {
  const { additionalFilterProps: e } = t, n = EEt(e);
  return /* @__PURE__ */ M.jsx(v9, { ...t, filterData: n });
}, wOt = (t) => {
  const { additionalFilterProps: e } = t, n = OEt(e);
  return /* @__PURE__ */ M.jsx(v9, { ...t, filterData: n });
}, xOt = (t) => {
  const { filtersVariant: e } = t;
  return e === Hy.STATE ? /* @__PURE__ */ M.jsx(_Ot, { ...t }) : e === Hy.URL ? /* @__PURE__ */ M.jsx(wOt, { ...t }) : /* @__PURE__ */ M.jsx(
    v9,
    {
      ...t,
      filterData: null
    }
  );
}, EOt = ({ children: t }) => /* @__PURE__ */ M.jsx("div", { className: "dc__overflow-hidden flexbox-col flex-grow-1", children: t }), SOt = () => !0, OOt = ({ resourceConflictDetails: t }) => {
  const e = cn(
    () => (t || []).map((n) => ({
      data: n,
      id: n.id
    })),
    [t]
  );
  return /* @__PURE__ */ M.jsx(
    xOt,
    {
      id: "table__resource-conflict-details",
      columns: nSt,
      rows: e,
      emptyStateConfig: {
        noRowsConfig: {
          title: "No resource found"
        },
        noRowsForFilterConfig: {
          title: "No results",
          subTitle: "We couldn't find any matching results"
        }
      },
      paginationVariant: S0.NOT_PAGINATED,
      additionalFilterProps: {
        initialSortKey: "name"
      },
      filtersVariant: Hy.STATE,
      ViewWrapper: EOt,
      filter: SOt
    }
  );
}, COt = ({ appName: t, environmentName: e, handleClose: n }) => {
  const { appId: r, envId: o, pipelineId: i, triggerId: s } = Gy(), a = Yy(), {
    isFetching: l,
    data: c,
    refetch: u,
    error: d
  } = xwe({
    queryKey: ["getResourceConflictDetails", i, s, r],
    queryFn: ({ signal: m }) => OSt({ pipelineId: i, triggerId: s, appId: r, signal: m })
  }), [f, h] = Ye(!1), p = async () => {
    h(!0);
    try {
      await owe({
        pipelineId: i,
        triggerId: s,
        appId: r
      }), h(!1), a.push(`${Up.APPLICATION_MANAGEMENT_APP}/${r}/details/${o}`);
    } catch (m) {
      Vy(m), h(!1);
    }
  };
  return /* @__PURE__ */ M.jsx(WSt, { width: "800px", onClose: n, onEscape: n, position: "right", children: /* @__PURE__ */ M.jsxs(
    "div",
    {
      className: "flexbox-col dc__content-space h-100 bg__modal--primary shadow__modal dc__overflow-auto",
      onClick: Xv,
      children: [
        /* @__PURE__ */ M.jsxs("div", { className: "flexbox-col dc__overflow-auto flex-grow-1", children: [
          /* @__PURE__ */ M.jsxs("div", { className: "px-20 py-12 flexbox dc__content-space dc__align-items-center border__primary--bottom", children: [
            /* @__PURE__ */ M.jsx("h2", { className: "m-0 fs-16 fw-6 lh-24 cn-9", children: "Resources with conflict" }),
            /* @__PURE__ */ M.jsx(
              Ar,
              {
                dataTestId: "header-close-button",
                ariaLabel: "Close",
                showAriaLabelInTippy: !1,
                onClick: n,
                variant: Nr.borderLess,
                style: Ti.negativeGrey,
                icon: /* @__PURE__ */ M.jsx(Ut, { name: "ic-close-large", color: null }),
                size: Oe.xs
              }
            )
          ] }),
          /* @__PURE__ */ M.jsx("div", { className: "flexbox-col flex-grow-1 dc__overflow-auto w-100", children: /* @__PURE__ */ M.jsx(
            IEt,
            {
              isLoading: l,
              progressingProps: {
                pageLoader: !0
              },
              error: d,
              errorScreenManagerProps: {
                code: d?.code,
                reload: u,
                on404Redirect: n
              },
              children: /* @__PURE__ */ M.jsx(OOt, { resourceConflictDetails: c })
            }
          ) })
        ] }),
        /* @__PURE__ */ M.jsxs("div", { className: "flexbox dc__align-items-center dc__content-space dc__gap-20 py-16 px-20 border__primary--top dc__no-shrink", children: [
          /* @__PURE__ */ M.jsxs("div", { className: "flexbox dc__gap-8", children: [
            /* @__PURE__ */ M.jsx(Ut, { name: "ic-warning", size: 20, color: null }),
            /* @__PURE__ */ M.jsxs("div", { className: "flexbox-col", children: [
              /* @__PURE__ */ M.jsx("span", { className: "cn-9 fs-13 fw-6 lh-1-5", children: "Take resource ownership and redeploy" }),
              /* @__PURE__ */ M.jsxs("span", { children: [
                "Ensure all resources strictly belong to the ",
                t,
                " application and the ",
                e,
                "environment. Any resource outside this Helm release may cause incorrect associations and potentially destructive changes."
              ] })
            ] })
          ] }),
          /* @__PURE__ */ M.jsx("div", { className: "dc__no-shrink", children: /* @__PURE__ */ M.jsx(
            Ar,
            {
              dataTestId: "footer-redeploy-button",
              variant: Nr.primary,
              style: Ti.warning,
              size: Oe.large,
              text: "Re-deploy",
              startIcon: /* @__PURE__ */ M.jsx(Ut, { name: "ic-rocket-launch", color: null }),
              isLoading: f,
              disabled: !c?.length,
              onClick: p
            }
          ) })
        ] })
      ]
    }
  ) });
}, Bie = Wt(({ status: t, finishedOn: e, artifact: n, type: r, executionInfo: o }) => {
  const i = o?.finishedOn || e, s = () => o ? /* @__PURE__ */ M.jsxs("span", { className: "cn-9 fs-13 fw-6 lh-20", children: [
    "Execution ",
    ZEt[o.currentStatus] || "finished"
  ] }) : /* @__PURE__ */ M.jsx(
    "div",
    {
      className: `${t} fs-13 fw-6 ${JEt[t.toLowerCase()] || "cn-5"}`,
      "data-testid": "deployment-status-text",
      children: rwe(t)
    }
  );
  return /* @__PURE__ */ M.jsxs("div", { className: "flexbox py-8 dc__gap-8 left dc__min-width-fit-content dc__align-items-center", children: [
    s(),
    i && i !== T_e && /* @__PURE__ */ M.jsx("time", { className: "dc__vertical-align-middle fs-13", children: WO(i) }),
    r === er.CI && n && /* @__PURE__ */ M.jsxs(M.Fragment, { children: [
      /* @__PURE__ */ M.jsx("div", { className: "dc__bullet" }),
      /* @__PURE__ */ M.jsx(y9, { imagePath: n, placement: "top" })
    ] })
  ] });
}), zie = Wt(({ stage: t, type: e, label: n = "In progress" }) => {
  const [r, o] = Ye(!1), [i, s] = Ye(!1), [a, l] = Ye({
    status: !1,
    message: ""
  }), { buildId: c, triggerId: u, pipelineId: d } = Gy();
  let f = null;
  e === er.CI ? f = (g) => ESt({ pipelineId: d, workflowId: c }, g) : t !== Pl.DEPLOY && (f = (g) => SSt(d, u, g));
  async function h() {
    o(!0);
    try {
      await f(a.status), Cl.showToast({
        variant: Qr.success,
        description: "Build Aborted"
      }), l({
        status: !1,
        message: ""
      });
    } catch (g) {
      if (g.code === 400) {
        const { errors: y } = g;
        l({
          status: !0,
          message: y[0].userMessage
        });
      }
    } finally {
      o(!1), s(!1);
    }
  }
  const p = () => {
    s(!i);
  }, m = () => {
    l({
      status: !1,
      message: ""
    });
  };
  return /* @__PURE__ */ M.jsxs(M.Fragment, { children: [
    /* @__PURE__ */ M.jsxs("div", { className: "flex dc__gap-8 left py-8", children: [
      /* @__PURE__ */ M.jsx("div", { className: "dc__min-width-fit-content", children: /* @__PURE__ */ M.jsx("div", { className: "fs-13 fw-6 flex left inprogress-status-color", children: n }) }),
      f && /* @__PURE__ */ M.jsxs(M.Fragment, { children: [
        /* @__PURE__ */ M.jsx("span", { className: "cn-5 fs-13 fw-4 lh-20", children: "/" }),
        /* @__PURE__ */ M.jsx(
          Ar,
          {
            dataTestId: "abort-execution-button",
            onClick: p,
            startIcon: /* @__PURE__ */ M.jsx(hEe, {}),
            text: "Abort",
            variant: Nr.text,
            style: Ti.negative,
            size: Oe.small
          }
        )
      ] })
    ] }),
    i && /* @__PURE__ */ M.jsx(
      k3,
      {
        variant: HE.warning,
        title: e === er.CD ? `Abort ${t.toLowerCase()}-deployment?` : "Abort build?",
        subtitle: e === er.CD ? "Are you sure you want to abort this stage?" : "Are you sure you want to abort this build?",
        buttonConfig: {
          secondaryButtonConfig: {
            disabled: r,
            onClick: p,
            text: "Cancel"
          },
          primaryButtonConfig: {
            isLoading: r,
            onClick: h,
            text: "Yes, Abort"
          }
        },
        handleClose: p
      }
    ),
    a.status && /* @__PURE__ */ M.jsxs(
      k3,
      {
        variant: HE.warning,
        title: "Could not abort build!",
        subtitle: `Error: ${a.message}`,
        buttonConfig: {
          secondaryButtonConfig: {
            disabled: r,
            onClick: m,
            text: "Cancel"
          },
          primaryButtonConfig: {
            isLoading: r,
            onClick: h,
            text: "Force Abort"
          }
        },
        handleClose: m,
        children: [
          /* @__PURE__ */ M.jsx("div", { className: "fs-13 fw-6 pt-12 cn-7 lh-1-54", children: /* @__PURE__ */ M.jsx("span", { children: "Please try to force abort" }) }),
          /* @__PURE__ */ M.jsx("div", { className: "pt-4 fw-4 cn-7 lh-1-54", children: /* @__PURE__ */ M.jsx("span", { children: "Some resource might get orphaned which will be cleaned up with Job-lifecycle" }) })
        ]
      }
    )
  ] });
}), kOt = Wt(
  ({ status: t, finishedOn: e, artifact: n, stage: r, type: o, executionInfo: i }) => i ? i.finishedOn ? /* @__PURE__ */ M.jsx(Bie, { executionInfo: i, artifact: n, type: o }) : i.currentStatus === kn.RUNNING ? /* @__PURE__ */ M.jsx(
    zie,
    {
      stage: r,
      type: o,
      ...i.executionStartedOn ? {} : {
        label: "Waiting to start"
      }
    }
  ) : i.currentStatus === kn.UNKNOWN ? /* @__PURE__ */ M.jsxs("div", { className: "flex dc__gap-8 left py-8", children: [
    /* @__PURE__ */ M.jsx("span", { className: "cn-9 fs-13 fw-6 lh-20", children: "Unknown status" }),
    o === er.CI && n && /* @__PURE__ */ M.jsxs(M.Fragment, { children: [
      /* @__PURE__ */ M.jsx("div", { className: "dc__bullet" }),
      /* @__PURE__ */ M.jsx(y9, { imagePath: n, placement: "top" })
    ] })
  ] }) : null : eSt[t.toLowerCase()] ? /* @__PURE__ */ M.jsx(zie, { stage: r, type: o }) : /* @__PURE__ */ M.jsx(Bie, { status: t, finishedOn: e, artifact: n, type: o })
), AOt = ({
  startedOn: t,
  triggeredBy: e,
  triggeredByEmail: n,
  ciMaterials: r,
  gitTriggers: o,
  artifact: i,
  type: s,
  environmentName: a,
  renderTargetConfigInfo: l,
  stage: c
}) => {
  const { url: u } = I3(), { pathname: d } = N3();
  return /* @__PURE__ */ M.jsx("div", { className: "w-100 pr-20 flex column left", children: /* @__PURE__ */ M.jsxs("div", { className: "flexbox dc__gap-8 dc__align-items-center py-8 flex-wrap", children: [
    /* @__PURE__ */ M.jsxs("div", { className: "flex left dc__gap-4 cn-9 fs-13 fw-6 lh-20", children: [
      /* @__PURE__ */ M.jsxs("div", { className: "flex left dc__no-shrink dc__gap-4", "data-testid": "deployment-history-start-heading", children: [
        /* @__PURE__ */ M.jsx("h3", { className: "m-0 cn-9 fs-13 fw-6 lh-20", children: "Triggered" }),
        c && /* @__PURE__ */ M.jsxs(M.Fragment, { children: [
          /* @__PURE__ */ M.jsx("div", { className: "dc__bullet" }),
          /* @__PURE__ */ M.jsx("div", { className: "dc__first-letter-capitalize", children: dxt(c) })
        ] })
      ] }),
      a && /* @__PURE__ */ M.jsxs(M.Fragment, { children: [
        /* @__PURE__ */ M.jsx(pEe, { className: "icon-dim-14 scn-9 dc__no-shrink" }),
        /* @__PURE__ */ M.jsx("span", { className: "dc__truncate", children: a })
      ] }),
      l?.()
    ] }),
    /* @__PURE__ */ M.jsx("time", { className: "cn-7 fs-13", children: WO(t) }),
    /* @__PURE__ */ M.jsx("div", { className: "dc__bullet" }),
    /* @__PURE__ */ M.jsx("div", { className: "trigger-details__trigger-by cn-7 fs-13 dc__word-break", children: e === 1 ? "auto trigger" : n }),
    /* @__PURE__ */ M.jsx("div", {}),
    s === er.CD ? (
      // eslint-disable-next-line react/jsx-no-useless-fragment
      /* @__PURE__ */ M.jsx(M.Fragment, { children: i && /* @__PURE__ */ M.jsx(y9, { imagePath: i, placement: "top" }) })
    ) : Object.keys(o ?? {}).length > 0 && r?.map((f) => {
      const h = o[f.id];
      return h ? /* @__PURE__ */ M.jsxs($se, { children: [
        f.type !== "WEBHOOK" && h.Commit && /* @__PURE__ */ M.jsx(
          C3,
          {
            commits: [h.Commit],
            handleClick: K_e(
              Q_e(f.url, h.Commit)
            )
          }
        ),
        f.type === "WEBHOOK" && h.WebhookData && h.WebhookData.Data && h.WebhookData.Data["target checkout"] && /* @__PURE__ */ M.jsx(
          C3,
          {
            commits: h.WebhookData.EventActionType === "merged" ? h.WebhookData.Data["target checkout"].substr(0, 7) : h.WebhookData.Data["target checkout"]
          }
        )
      ] }, f.id) : null;
    }),
    !d.includes("source-code") && /* @__PURE__ */ M.jsx(QE, { to: `${u}/source-code`, className: "anchor fs-13", "data-testid": "commit-details-link", children: "Commit details" })
  ] }) });
}, Gu = () => /* @__PURE__ */ M.jsx("div", { className: "flex flex-grow-1", children: /* @__PURE__ */ M.jsx("div", { className: "dc__border-left--n3 h-100" }) }), qie = () => /* @__PURE__ */ M.jsxs(M.Fragment, { children: [
  /* @__PURE__ */ M.jsx("div", { className: "flex", children: /* @__PURE__ */ M.jsx(Ut, { size: 20, name: "ic-success", color: null }) }),
  Gu()
] }), TOt = Wt(
  ({ status: t }) => /* @__PURE__ */ M.jsx("svg", { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ M.jsx(
    "circle",
    {
      cx: "10",
      cy: "10",
      r: "5",
      fill: S3[t] || "var(--N500",
      stroke: S3[t] || "var(--N500",
      strokeOpacity: "0.3",
      strokeWidth: "10"
    }
  ) })
), ROt = Wt(({ status: t, executionInfoCurrentStatus: e }) => e ? nwe(e) : XEt[t] ? /* @__PURE__ */ M.jsx(mEe, {}) : /* @__PURE__ */ M.jsx(TOt, { status: t.toLowerCase() }));
Wt(
  ({
    status: t,
    startedOn: e,
    finishedOn: n,
    triggeredBy: r,
    triggeredByEmail: o,
    ciMaterials: i,
    gitTriggers: s,
    message: a,
    podStatus: l,
    type: c,
    stage: u,
    artifact: d,
    environmentName: f,
    isJobView: h,
    workerPodName: p,
    triggerMetadata: m,
    renderDeploymentHistoryTriggerMetaText: g,
    renderTargetConfigInfo: y,
    workflowExecutionStages: v,
    namespace: b,
    isLatest: _,
    appName: w
  }) => {
    const { isFELibAvailable: x } = l9(), [E, S] = Ye(null), C = cn(
      () => m9(v),
      [v]
    ), R = C?.workerDetails.message || a, P = x && _ && (c === er.CD || c === er.GROUP_CD) && u === Pl.DEPLOY && R?.includes(tSt), N = () => {
      S(Lg.DEPLOY_DIALOG);
    }, A = () => {
      S(Lg.RESOURCE_DETAIL_MODAL);
    }, O = () => {
      S(null);
    }, k = () => /* @__PURE__ */ M.jsxs("div", { className: "flexbox", children: [
      /* @__PURE__ */ M.jsx(
        Ar,
        {
          dataTestId: "resource-conflicts-resource-info",
          text: "Some Resources",
          variant: Nr.text,
          size: Oe.medium,
          style: Ti.warning,
          onClick: A
        }
      ),
      " ",
      /* @__PURE__ */ M.jsx("span", { className: "cn-9 fw-4 fs-13 lh-20 dc__word-break", children: "have ownership conflicts. Resolve by taking ownership and redeploying." })
    ] }), T = () => E === Lg.DEPLOY_DIALOG ? /* @__PURE__ */ M.jsx(
      HSt,
      {
        appName: w,
        environmentName: f,
        handleClose: O
      }
    ) : E === Lg.RESOURCE_DETAIL_MODAL ? /* @__PURE__ */ M.jsx(
      COt,
      {
        appName: w,
        environmentName: f,
        handleClose: O
      }
    ) : null;
    return /* @__PURE__ */ M.jsxs(M.Fragment, { children: [
      /* @__PURE__ */ M.jsx("div", { className: "trigger-details flexbox-col", children: /* @__PURE__ */ M.jsxs("div", { className: "flexbox-col py-8 trigger-details__summary lh-20", children: [
        /* @__PURE__ */ M.jsxs("div", { className: "display-grid trigger-details__grid", children: [
          /* @__PURE__ */ M.jsx("div", { className: "flexbox dc__content-center", children: /* @__PURE__ */ M.jsxs("div", { className: "flexbox-col dc__gap-4", children: [
            /* @__PURE__ */ M.jsx("div", { className: "flex flex-grow-1" }),
            qie()
          ] }) }),
          /* @__PURE__ */ M.jsx("div", { className: "flexbox-col flex-grow-1", children: /* @__PURE__ */ M.jsx(
            AOt,
            {
              startedOn: C?.triggeredOn || e,
              triggeredBy: r,
              triggeredByEmail: o,
              ciMaterials: i,
              gitTriggers: s,
              artifact: d,
              type: c,
              environmentName: f,
              renderTargetConfigInfo: y,
              stage: u
            }
          ) })
        ] }),
        !!m && !!g && /* @__PURE__ */ M.jsxs("div", { className: "display-grid trigger-details__grid", children: [
          /* @__PURE__ */ M.jsx("div", { className: "flexbox dc__content-center", children: /* @__PURE__ */ M.jsxs("div", { className: "flexbox-col dc__gap-4", children: [
            Gu(),
            g(m, !0),
            Gu()
          ] }) }),
          g(m)
        ] }),
        h && /* @__PURE__ */ M.jsxs("div", { className: "display-grid trigger-details__grid", children: [
          /* @__PURE__ */ M.jsx("div", { className: "flexbox dc__content-center", children: /* @__PURE__ */ M.jsxs("div", { className: "flexbox-col dc__gap-4", children: [
            Gu(),
            /* @__PURE__ */ M.jsx(qse, { className: "icon-dim-20 dc__no-shrink scn-9" }),
            Gu()
          ] }) }),
          /* @__PURE__ */ M.jsxs("div", { className: "flexbox dc__align-items-center dc__gap-8 py-8", children: [
            /* @__PURE__ */ M.jsx("span", { className: "cn-9 fs-13 fw-6 lh-20", children: "Env" }),
            /* @__PURE__ */ M.jsx("span", { className: "fs-12 lh-20", children: f !== "" ? f : KEt }),
            f === "" && /* @__PURE__ */ M.jsx("i", { className: "fw-4 fs-12 lh-20", children: "(Default)" })
          ] })
        ] }),
        !!C?.executionStartedOn && /* @__PURE__ */ M.jsxs("div", { className: "display-grid trigger-details__grid", children: [
          /* @__PURE__ */ M.jsx("div", { className: "flexbox dc__content-center", children: /* @__PURE__ */ M.jsxs("div", { className: "flexbox-col dc__gap-4", children: [
            Gu(),
            qie()
          ] }) }),
          /* @__PURE__ */ M.jsxs("div", { className: "w-100 pr-20 flexbox dc__gap-8 py-8", children: [
            /* @__PURE__ */ M.jsx("h3", { className: "m-0 cn-9 fs-13 fw-6 lh-20", children: "Execution started" }),
            /* @__PURE__ */ M.jsx("time", { className: "cn-7 fs-13", children: WO(C.executionStartedOn) })
          ] })
        ] }),
        /* @__PURE__ */ M.jsxs("div", { className: "display-grid trigger-details__grid", children: [
          /* @__PURE__ */ M.jsx("div", { className: "flexbox dc__content-center", children: /* @__PURE__ */ M.jsxs("div", { className: "flexbox-col dc__gap-4", children: [
            Gu(),
            /* @__PURE__ */ M.jsx(
              ROt,
              {
                status: t,
                executionInfoCurrentStatus: C?.currentStatus
              }
            ),
            /* @__PURE__ */ M.jsx("div", { className: "flex flex-grow-1" })
          ] }) }),
          /* @__PURE__ */ M.jsx(
            kOt,
            {
              executionInfo: C,
              status: t,
              finishedOn: n,
              artifact: d,
              stage: u,
              type: c
            }
          )
        ] }),
        /* @__PURE__ */ M.jsx("div", { className: "display-grid trigger-details__grid py-4", children: /* @__PURE__ */ M.jsx(
          lwe,
          {
            message: C?.workerDetails.message || a,
            podStatus: C?.workerDetails.status || l,
            stage: u,
            finishedOn: C?.workerDetails.endTime || n,
            clusterId: C?.workerDetails.clusterId || VO,
            workerPodName: p,
            namespace: b,
            children: P && /* @__PURE__ */ M.jsx("div", { className: "pt-12 pr-12", children: /* @__PURE__ */ M.jsx(
              wSt,
              {
                variant: "warning",
                description: k(),
                buttonProps: {
                  dataTestId: "resource-conflict-re-deploy",
                  text: "Re-deploy",
                  startIcon: /* @__PURE__ */ M.jsx(Ut, { name: "ic-rocket-launch", color: null }),
                  onClick: N,
                  variant: Nr.text,
                  style: Ti.warning,
                  size: Oe.medium
                }
              }
            ) })
          }
        ) })
      ] }) }),
      T()
    ] });
  }
);
Oe.medium + "", Oe.large + "", Oe.xl + "";
Oe.medium + "", Oe.large + "", Oe.xl + "";
Oe.xxxs + "", Oe.xxs + "", Oe.xs + "";
var gwe = /* @__PURE__ */ ((t) => (t[t.ASC = 1] = "ASC", t[t.DESC = -1] = "DESC", t))(gwe || {}), Yr = /* @__PURE__ */ ((t) => (t.CRITICAL = "critical", t.HIGH = "high", t.MEDIUM = "medium", t.LOW = "low", t.UNKNOWN = "unknown", t.FAILURES = "fail", t.SUCCESSES = "success", t.EXCEPTIONS = "exceptions", t))(Yr || {});
Yr.CRITICAL + "", Yr.HIGH + "", Yr.MEDIUM + "", Yr.LOW + "", Yr.UNKNOWN + "", Yr.FAILURES + "", Yr.SUCCESSES + "", Yr.EXCEPTIONS + "";
Yr.CRITICAL, Yr.HIGH, Yr.MEDIUM, Yr.LOW, Yr.UNKNOWN, Yr.FAILURES, Yr.EXCEPTIONS, Yr.SUCCESSES;
gwe.DESC;
Uf.CRITICAL + "", Uf.HIGH + "", Uf.MEDIUM + "", Uf.LOW + "", Uf.UNKNOWN + "";
ti.light + "", ti.dark + "";
ti.light + "", ti.dark + "";
ti.light + "", ti.dark + "";
ti.dark + "", ti.light + "";
ti.light + "", ti.dark + "";
const POt = (t, e) => Math.sqrt((e.x - t.x) ** 2 + (e.y - t.y) ** 2);
wc.register(
  mj,
  gj,
  Cw,
  Rw,
  kw,
  jc,
  Tw,
  kg,
  Tg,
  Ey,
  ytt,
  Zme,
  mtt,
  ctt
);
Zme.positioners.barElementCenterPositioner = (t, e) => {
  if (!t.length)
    return !1;
  let { x: n } = e, { y: r } = e, o = Number.POSITIVE_INFINITY, i, s, a;
  for (i = 0, s = t.length; i < s; ++i) {
    const l = t[i].element;
    if (l && l.hasValue()) {
      const c = l.getCenterPoint(), u = POt(e, c);
      u < o && (o = u, a = l);
    }
  }
  if (a) {
    const l = a.getCenterPoint();
    n = l.x, r = l.y;
  }
  return {
    x: n,
    y: r
  };
};
N_e.KubernetesConfigMap;
const $Ot = {
  "Day 1": "1",
  "Day 2": "2",
  "Day 3": "3",
  "Day 4": "4",
  "Day 5": "5",
  "Day 6": "6",
  "Day 7": "7",
  "Day 8": "8",
  "Day 9": "9",
  "Day 10": "10",
  "Day 11": "11",
  "Day 12": "12",
  "Day 13": "13",
  "Day 14": "14",
  "Day 15": "15",
  "Day 16": "16",
  "Day 17": "17",
  "Day 18": "18",
  "Day 19": "19",
  "Day 20": "20",
  "Day 21": "21",
  "Day 22": "22",
  "Day 23": "23",
  "Day 24": "24",
  "Day 25": "25",
  "Day 26": "26",
  "Day 27": "27",
  "Day 28": "28",
  "Third Last Day": "-3",
  "Second Last Day": "-2",
  "Last Day": "-1"
}, MOt = {
  "12:00 AM": "00:00:00",
  "12:30 AM": "00:30:00",
  "01:00 AM": "01:00:00",
  "01:30 AM": "01:30:00",
  "02:00 AM": "02:00:00",
  "02:30 AM": "02:30:00",
  "03:00 AM": "03:00:00",
  "03:30 AM": "03:30:00",
  "04:00 AM": "04:00:00",
  "04:30 AM": "04:30:00",
  "05:00 AM": "05:00:00",
  "05:30 AM": "05:30:00",
  "06:00 AM": "06:00:00",
  "06:30 AM": "06:30:00",
  "07:00 AM": "07:00:00",
  "07:30 AM": "07:30:00",
  "08:00 AM": "08:00:00",
  "08:30 AM": "08:30:00",
  "09:00 AM": "09:00:00",
  "09:30 AM": "09:30:00",
  "10:00 AM": "10:00:00",
  "10:30 AM": "10:30:00",
  "11:00 AM": "11:00:00",
  "11:30 AM": "11:30:00",
  "12:00 PM": "12:00:00",
  "12:30 PM": "12:30:00",
  "01:00 PM": "13:00:00",
  "01:30 PM": "13:30:00",
  "02:00 PM": "14:00:00",
  "02:30 PM": "14:30:00",
  "03:00 PM": "15:00:00",
  "03:30 PM": "15:30:00",
  "04:00 PM": "16:00:00",
  "04:30 PM": "16:30:00",
  "05:00 PM": "17:00:00",
  "05:30 PM": "17:30:00",
  "06:00 PM": "18:00:00",
  "06:30 PM": "18:30:00",
  "07:00 PM": "19:00:00",
  "07:30 PM": "19:30:00",
  "08:00 PM": "20:00:00",
  "08:30 PM": "20:30:00",
  "09:00 PM": "21:00:00",
  "09:30 PM": "21:30:00",
  "10:00 PM": "22:00:00",
  "10:30 PM": "22:30:00",
  "11:00 PM": "23:00:00",
  "11:30 PM": "23:30:00"
};
qe(), qe().subtract(5, "minutes"), qe(), qe().subtract(30, "minutes"), qe(), qe().subtract(1, "hours"), qe(), qe().subtract(24, "hours"), qe(), qe().subtract(7, "days"), qe(), qe().subtract(1, "months"), qe(), qe().subtract(6, "months");
Object.entries($Ot).map(([t, e]) => ({
  label: t,
  value: e
}));
Object.entries(MOt).map(
  ([t, e]) => ({
    label: t,
    value: e
  })
);
xe.createContext(null);
const cc = {
  width: 356,
  height: 504
}, ywe = "No Defined Description", DOt = "No Defined Value", IOt = "What is scoped variable?", wD = (t, e) => t && e ? `"${t}":${e},` : "", NOt = ({
  appId: t,
  envId: e,
  clusterId: n,
  isTemplateView: r
}) => {
  if (!t)
    return "";
  let o = `?${r ? "" : `appId=${t}&`}scope={`;
  return r || (o += wD("appId", t)), o += wD("envId", e), o += wD("clusterId", n), o.endsWith(",") && (o = o.slice(0, -1)), o += "}", o;
}, jOt = async (t, e, n, {
  hideObjectVariables: r,
  isTemplateView: o
}) => {
  const { result: i } = await w9(
    `${rf.SCOPED_GLOBAL_VARIABLES}${NOt({
      appId: t,
      envId: e,
      clusterId: n,
      isTemplateView: o
    })}`
  );
  return i ? r ? i.filter((s) => !s.variableValue || typeof s.variableValue.value != "object") : i : [];
}, LOt = ({
  variableName: t,
  description: e,
  variableValue: n,
  isRedacted: r,
  highlightText: o,
  showValueOnHover: i
}) => {
  const [s, a] = Ye(null), l = `@{{${t}}}`, c = () => {
    a(_we(l));
  }, u = (m) => {
    if (r)
      return /* @__PURE__ */ M.jsx("i", { className: "text__white fs-12 fw-6 lh-18 m-0", children: "is sensitive & hidden" });
    const g = "text__white fs-12 fw-6 lh-18 m-0";
    return m === "" ? /* @__PURE__ */ M.jsx("p", { className: g, children: `'""'` }) : typeof m == "boolean" ? /* @__PURE__ */ M.jsx("p", { className: g, children: m ? "true" : "false" }) : typeof m == "object" ? /* @__PURE__ */ M.jsx("pre", { className: `${g} dc__transparent--unstyled border__primary`, children: KOt(m) }) : /* @__PURE__ */ M.jsx("p", { className: g, children: m });
  }, d = (m) => {
    if (o === "")
      return m;
    try {
      const g = new RegExp(o, "gi");
      return m.replace(g, (y) => `<span class="bcy-2">${y}</span>`);
    } catch {
      return m;
    }
  }, f = () => e === ywe ? /* @__PURE__ */ M.jsx("p", { className: "m-0 fs-12 fw-4 lh-18", children: e }) : /* @__PURE__ */ M.jsx(
    "p",
    {
      className: "m-0 fs-12 fw-4 lh-18 dc__word-break-all",
      dangerouslySetInnerHTML: { __html: DZ.sanitize(d(e)) }
    }
  ), h = () => /* @__PURE__ */ M.jsx(
    "p",
    {
      className: "m-0 fs-13 fw-6 lh-20 cn-9 dc__ellipsis-right",
      dangerouslySetInnerHTML: { __html: DZ.sanitize(d(t)) }
    }
  ), p = (m) => /* @__PURE__ */ M.jsx(
    Ai,
    {
      className: "default-tt dc__word-break-all",
      content: /* @__PURE__ */ M.jsxs("div", { className: "mw-200 flex column dc__content-start dc__align-start mxh-140 dc__overflow-auto", children: [
        /* @__PURE__ */ M.jsx("div", { className: "flex column dc__content-start dc__align-start", children: "Value" }),
        /* @__PURE__ */ M.jsx("div", { className: "flex column dc__content-start dc__align-start", children: u(n) })
      ] }),
      placement: "left",
      interactive: !0,
      alwaysShowTippyOnHover: !0,
      appendTo: document.body,
      children: m
    }
  );
  return (
    // TODO: conditional wrap is not required since handled through alwaysShowTippyOnHover in tooltip
    /* @__PURE__ */ M.jsx(Hp, { condition: i, wrap: p, children: /* @__PURE__ */ M.jsxs(
      "div",
      {
        className: "flexbox-col pt-8 pb-8 pl-12 pr-12 dc__align-self-stretch bg__primary dc__border-bottom-n1 dc__hover-n50",
        onClick: c,
        "data-testid": "suggestion-item",
        children: [
          /* @__PURE__ */ M.jsxs("div", { className: "flexbox dc__align-items-center dc__gap-8 dc__ellipsis-right", children: [
            h(),
            /* @__PURE__ */ M.jsx(
              CSt,
              {
                content: l,
                copiedTippyText: `Copied: ${l}`,
                copyToClipboardPromise: s
              }
            )
          ] }),
          /* @__PURE__ */ M.jsx("div", { className: "flexbox dc__align-items-center", children: f() })
        ]
      }
    ) })
  );
}, FOt = () => {
  const [t, e] = Ye(!1), n = () => {
    e(!t);
  };
  return /* @__PURE__ */ M.jsxs("div", { className: "flexbox-col dc__align-self-stretch p-12 dc__gap-8 bcv-1 dc__border-top-v1", children: [
    /* @__PURE__ */ M.jsxs(
      "button",
      {
        className: "flexbox dc__align-self-stretch dc__align-items-center dc__content-space dc__outline-none-imp dc__no-border p-0 bcv-1",
        onClick: n,
        type: "button",
        children: [
          /* @__PURE__ */ M.jsxs("div", { className: "flexbox dc__gap-8", children: [
            /* @__PURE__ */ M.jsx("div", { className: "flex center", children: /* @__PURE__ */ M.jsx(L3, { className: "icon-dim-16 fcv-5" }) }),
            /* @__PURE__ */ M.jsx("p", { className: "m-0 fs-13 cn-9 fw-6 lh-20", children: IOt })
          ] }),
          /* @__PURE__ */ M.jsx(j3, { className: `icon-dim-16 fcn-6 ${t ? "" : "dc__flip-270"}` })
        ]
      }
    ),
    t && /* @__PURE__ */ M.jsx("div", { className: "flex pl-24 dc__gap-4 flex-wrap dc__content-center", children: /* @__PURE__ */ M.jsxs("p", { className: "m-0 fs-13 fw-4 lh-20 cn-9", children: [
      "Use a scoped variable for dynamic values, which are defined in the ",
      /* @__PURE__ */ M.jsx(
        QE,
        {
          className: "cb-5 m-0",
          to: Up.APPLICATION_MANAGEMENT_CONFIGURATIONS_SCOPED_VARIABLES,
          target: "_blank",
          rel: "noopener noreferrer",
          children: "Global Configuration"
        }
      ),
      ". To use a variable, type ",
      /* @__PURE__ */ M.jsx("i", { className: "m-0", children: "@{{variablename}}" }),
      "."
    ] }) })
  ] });
}, Uie = Wt(FOt), BOt = ({
  handleDeActivation: t,
  loading: e,
  variables: n,
  reloadVariables: r,
  error: o,
  showValueOnHover: i
}) => {
  const [s, a] = Ye(n), [l, c] = Ye(!1), [u, d] = Ye(""), f = !e && !o && !!n?.length;
  Ne(() => {
    a(n);
  }, [n]);
  const h = (b) => {
    const _ = b.trim().toLowerCase(), w = n.filter(
      (x) => x.variableName.toLowerCase().includes(_) || x.shortDescription?.toLowerCase().includes(_)
    );
    a(w), d(_);
  }, p = () => {
    c(!l);
  }, m = () => /* @__PURE__ */ M.jsx(
    "button",
    {
      className: "dc__outline-none-imp flexbox mw-56 pt-5 pb-5 pl-12 pr-12 dc__gap-8 dc__align-items-center dc__border-radius-4-imp dc__border bg__primary cb-5 fs-12 fw-6 lh-18 dc__align-center dc__hover-cn1 dc__hover-b500",
      onClick: p,
      type: "button",
      children: "Clear Search"
    }
  ), g = () => /* @__PURE__ */ M.jsxs("div", { className: "flexbox-col dc__align-self-stretch", children: [
    /* @__PURE__ */ M.jsxs("div", { className: "handle-drag flexbox pt-8 pl-12 pr-12 dc__gap-16 dc__align-start dc__align-self-stretch dc__grabbable dc__border-bottom", children: [
      /* @__PURE__ */ M.jsxs("div", { className: "flexbox-col dc__content-center dc__align-start flex-grow-1 dc__no-shrink", children: [
        /* @__PURE__ */ M.jsxs("div", { className: "flex center dc__gap-4", children: [
          /* @__PURE__ */ M.jsx("p", { className: "m-0 cn-7 fs-13 fw-6 lh-20 dc__align-self-stretch", children: "Scoped variables" }),
          /* @__PURE__ */ M.jsx(Ut, { name: "ic-view-variable-toggle", color: "N700", size: 16 })
        ] }),
        /* @__PURE__ */ M.jsx("p", { className: "dc__align-self-stretch cn-7 fs-12 fw-1 lh-20", children: "Use variable to set dynamic value" })
      ] }),
      /* @__PURE__ */ M.jsx("div", { className: "h-100", children: /* @__PURE__ */ M.jsx(
        Ar,
        {
          icon: /* @__PURE__ */ M.jsx(Hse, { className: zE }),
          ariaLabel: "Close suggestions",
          showAriaLabelInTippy: !1,
          dataTestId: "deactivate-suggestions",
          onClick: t,
          size: Oe.xs,
          variant: Nr.borderLess,
          style: Ti.negativeGrey
        }
      ) })
    ] }),
    f && /* @__PURE__ */ M.jsx(
      "div",
      {
        onKeyDown: (b) => {
          b.key === "Enter" && b.preventDefault();
        },
        className: "flexbox dc__align-self-stretch pt-8 pb-8 pl-12 pr-12 bg__primary",
        children: /* @__PURE__ */ M.jsx(
          iCt,
          {
            onSearch: h,
            placeholder: "Search variables",
            containerClass: "flexbox flex-grow-1 pt-8 pb-8 pl-10 pr-10 dc__gap-8 dc__align-self-stretch dc__align-items-center bg__secondary dc__border dc__border-radius-4-imp focus-within-border-b5 dc__hover-border-n300",
            inputClass: "flex-grow-1 dc__no-border dc__outline-none-imp bg__secondary lh-20 fs-13 cn-9 fw-4 p-0 placeholder-cn5",
            Icon: AEe,
            iconClass: "icon-dim-16",
            clearSearch: l
          }
        )
      }
    )
  ] }), y = () => /* @__PURE__ */ M.jsxs(M.Fragment, { children: [
    /* @__PURE__ */ M.jsx("div", { className: "flexbox-col dc__align-self-stretch dc__overflow-auto bg__primary flex-grow-1", children: s.length ? s.map((b) => /* @__PURE__ */ M.jsx(
      LOt,
      {
        variableName: b.variableName,
        description: b.shortDescription?.length ? b.shortDescription : ywe,
        variableValue: b.variableValue?.value ?? DOt,
        isRedacted: b.isRedacted,
        highlightText: u,
        showValueOnHover: i
      },
      b.variableName
    )) : /* @__PURE__ */ M.jsx(
      Vd,
      {
        title: "No matching variable found",
        isButtonAvailable: !0,
        noImage: !0,
        renderButton: m,
        classname: "h-200"
      }
    ) }),
    /* @__PURE__ */ M.jsx(Uie, {})
  ] }), v = () => e ? /* @__PURE__ */ M.jsx("div", { className: "flexbox-col dc__align-self-stretch dc__overflow-auto bg__primary flex-grow-1 h-250", children: /* @__PURE__ */ M.jsx(c9, { pageLoader: !0, size: 32 }) }) : n?.length === 0 ? /* @__PURE__ */ M.jsxs(M.Fragment, { children: [
    /* @__PURE__ */ M.jsx("div", { className: "flexbox-col dc__align-self-stretch dc__overflow-auto flex-grow-1 h-250", children: /* @__PURE__ */ M.jsx(Vd, { title: "No variables found", image: SEe }) }),
    /* @__PURE__ */ M.jsx(Uie, {})
  ] }) : f ? y() : /* @__PURE__ */ M.jsx(g9, { reload: r, className: "bg__primary pb-16" });
  return /* @__PURE__ */ M.jsxs(M.Fragment, { children: [
    g(),
    v()
  ] });
}, zOt = Wt(BOt), qOt = ({
  zIndex: t,
  appId: e,
  envId: n,
  clusterId: r,
  bounds: o,
  hideObjectVariables: i = !0,
  showValueOnHover: s = !0,
  isTemplateView: a
}) => {
  const [l, c] = Ye(!1), [u, d] = Ye({ x: 0, y: 0 }), [f, h] = Ye({ x: 0, y: 0 }), [p, m, g, y] = wwe(
    () => jOt(e, n, r, { hideObjectVariables: i, isTemplateView: a }),
    [e, n, r]
  ), v = J_e(), b = Ue(null), _ = cn(() => {
    const C = b.current?.getBoundingClientRect() || {
      x: 0,
      y: 0
    };
    return { x: C.x, y: C.y };
  }, [b.current]);
  Ne(() => {
    const C = new ResizeObserver((R) => {
      if (R?.length > 0 && l) {
        const { height: P } = R[0].contentRect;
        _.y + f.y + P > v.height && h({
          x: f.x,
          y: v.height - P - _.y
        });
      }
    });
    return C.observe(b.current), () => {
      C.disconnect();
    };
  }, [l, f, v, _]);
  const w = () => {
    const C = {
      x: _.x + u.x,
      y: _.y + u.y
    };
    h({
      x: u.x,
      y: u.y
    }), C.y > v.height - cc.height && h({
      x: u.x,
      y: v.height - cc.height - _.y
    }), C.x > v.width - cc.width && h({
      x: v.width - cc.width - _.x,
      y: u.y
    }), C.x > v.width - cc.width && C.y > v.height - cc.height && h({
      x: v.width - cc.width - _.x,
      y: v.height - cc.height - _.y
    }), c(!0);
  }, x = Cn((C) => {
    C.stopPropagation(), c(!1);
  }, []), E = (C, R) => {
    const P = {
      x: _.x + R.x,
      y: _.y + R.y
    };
    P.y < 0 || P.x < 0 || P.x + (b.current?.getBoundingClientRect().width || 0) > v.width || P.y + (b.current?.getBoundingClientRect().height || 0) > v.height || d(R);
  }, S = (C, R) => {
    const P = {
      x: _.x + R.x,
      y: _.y + R.y
    };
    P.y < 0 || P.x < 0 || P.x + (b.current?.getBoundingClientRect().width || 0) > v.width || P.y + (b.current?.getBoundingClientRect().height || 0) > v.height || (h(R), d(R));
  };
  return l ? /* @__PURE__ */ M.jsx(
    yx,
    {
      bounds: o,
      handle: ".handle-drag",
      nodeRef: b,
      position: f,
      onDrag: S,
      children: /* @__PURE__ */ M.jsx(
        "div",
        {
          className: `flex column dc__no-shrink w-356 dc__content-space dc__border-radius-8-imp dc__border dc__overflow-hidden dc__position-abs mxh-504 bg__overlay--primary ${zE}`,
          style: {
            zIndex: t,
            boxShadow: "0px 4px 8px 0px rgba(0, 0, 0, 0.25)"
          },
          ref: b,
          children: /* @__PURE__ */ M.jsx(
            zOt,
            {
              handleDeActivation: x,
              loading: p,
              variables: m ?? [],
              reloadVariables: y,
              error: g,
              showValueOnHover: s
            }
          )
        }
      )
    }
  ) : /* @__PURE__ */ M.jsx(
    yx,
    {
      bounds: o,
      handle: ".handle-drag",
      nodeRef: b,
      position: u,
      onDrag: E,
      children: /* @__PURE__ */ M.jsxs(
        "div",
        {
          className: "bcn-7 dc__outline-none-imp dc__border-n0 br-48 flex h-40 pt-8 pb-8 pl-12 pr-12 dc__gap-8 dc__no-shrink dc__position-abs",
          style: { zIndex: t, boxShadow: "0px 4px 8px 0px rgba(0, 0, 0, 0.20)" },
          ref: b,
          "data-testid": "collapsed-state",
          children: [
            /* @__PURE__ */ M.jsx("button", { type: "button", className: "dc__outline-none-imp dc__no-border p-0 bcn-7 h-24", children: /* @__PURE__ */ M.jsx(Use, { className: "handle-drag dc__grabbable icon-dim-24 fcn-2" }) }),
            /* @__PURE__ */ M.jsx(hS, { content: "Scoped variables", placement: "top", className: "default-tt", arrow: !1, children: /* @__PURE__ */ M.jsx(
              "button",
              {
                className: `dc__outline-none-imp dc__no-border p-0 bcn-7 h-20 ${zE}`,
                type: "button",
                onClick: w,
                "data-testid": "activate-suggestions",
                "aria-label": "Activate suggestions",
                children: /* @__PURE__ */ M.jsx(Ut, { name: "ic-view-variable-toggle", color: "N0", size: 20 })
              }
            ) })
          ]
        }
      )
    }
  );
};
Wt(qOt);
lr({
  name: "dummy-generic-modal-name",
  onClose: eo
});
var Sd = /* @__PURE__ */ ((t) => (t.GETTING_STARTED = "getting-started", t.VIEW_DOCUMENTATION = "view-documentation", t.JOIN_DISCORD_COMMUNITY = "join-discord-community", t.ABOUT_DEVTRON = "about-devtron", t.REQUEST_SUPPORT = "request-support", t.OPEN_NEW_TICKET = "open-new-ticket", t.VIEW_ALL_TICKETS = "view-all-tickets", t.GIVE_FEEDBACK = "give-feedback", t.CHAT_WITH_SUPPORT = "chat-with-support", t.RAISE_ISSUE_REQUEST = "raise-issue-request", t.DEVTRON_GPT = "devtron-gpt", t))(Sd || {});
Sd.CHAT_WITH_SUPPORT, Sd.RAISE_ISSUE_REQUEST;
Sd.REQUEST_SUPPORT;
Sd.OPEN_NEW_TICKET, Sd.VIEW_ALL_TICKETS, Sd.GIVE_FEEDBACK;
const UOt = ({
  name: t,
  illustrationMap: e,
  dataTestId: n,
  imageProps: r,
  svgProps: o
}) => {
  const i = e[t];
  if (!i)
    throw new Error(`Illustration with name "${t}" does not exist.`);
  return typeof i == "string" ? /* @__PURE__ */ M.jsx("img", { src: i, alt: t, ...r, "data-testid": n }) : /* @__PURE__ */ M.jsx(i, { ...o, role: "img", "aria-label": t, "data-testid": n });
}, HOt = {
  "img-celebration": zEe,
  "img-folder-empty": HEe,
  "img-install-freemium-saas": VEe,
  "img-install-via-aws-marketplace": WEe,
  "img-mechanical-operation": YEe,
  "img-no-backup-location": KEe,
  "img-no-restores": XEe,
  "img-page-not-found": ZEe,
  "create-backup-schedule": FEe,
  "create-backup-snapshot": BEe,
  "img-code": qEe,
  "img-devtron-freemium": UEe,
  "img-man-on-rocket": GEe,
  "img-no-result": QEe,
  "no-cluster-cost-enabled": JEe
}, VOt = (t) => /* @__PURE__ */ M.jsx(UOt, { ...t, illustrationMap: HOt });
gc.google + "", gc.github + "", gc.gitlab + "", gc.ldap + "", gc.microsoft + "", gc.oidc + "", gc.openshift + "";
ti.light + "", ti.dark + "";
Hf.CI_CD, Hf.CI, Hf.JOB_CI, S_e.WEBHOOK, Hf.LINKED_CI, Hf.JOB_CI;
function Vy(t, e = !0, n = !1) {
  t instanceof yl && Array.isArray(t.errors) ? t.errors.map(({ userMessage: r, internalMessage: o }) => {
    const i = r?.toLowerCase();
    t.code === 403 && (i === yr.UNAUTHORIZED.toLowerCase() || i === yr.FORBIDDEN.toLowerCase()) ? n || Cl.showToast({
      variant: Qr.notAuthorized,
      description: Wwt.SUBTITLE
    }) : Cl.showToast({
      variant: Qr.error,
      description: r || o
    });
  }) : (t.code !== 403 && t.code !== 408 && !JOt(t) && oce(t), e && (t.message ? Cl.showToast({
    variant: Qr.error,
    description: t.message
  }) : Cl.showToast({
    variant: Qr.error,
    description: "Some Error Occurred"
  })));
}
const Hp = ({ condition: t, wrap: e, children: n }) => t ? e(n) : /* @__PURE__ */ M.jsx(M.Fragment, { children: n }), Xv = (t) => {
  t?.stopPropagation();
};
function eo(...t) {
}
function WOt(t) {
  return !t;
}
const vwe = () => {
  window.location.reload();
}, GOt = () => {
  window.open(A_e);
};
function bwe(t, e) {
  const n = xe.useRef(!0);
  xe.useEffect(() => {
    if (!n.current)
      return t();
    n.current = !1;
  }, e);
}
const YOt = (t) => {
  const e = function(n) {
    n.preventDefault(), n.clipboardData.setData("text/plain", t);
  };
  document.addEventListener("copy", e), document.execCommand("copy"), document.removeEventListener("copy", e);
};
function _we(t) {
  return new Promise((e, n) => {
    if (!t) {
      e();
      return;
    }
    window.isSecureContext && navigator.clipboard ? navigator.clipboard.writeText(t).then(() => {
      e();
    }).catch(() => {
      Cl.showToast({
        variant: Qr.error,
        description: "Failed to copy to clipboard"
      }), n();
    }) : (YOt(t), e());
  });
}
function wwe(t, e = [], n = !0, r = { resetOnChange: !0 }) {
  const [o, i] = Ye({
    loading: !0,
    result: null,
    error: null,
    dependencies: e
  }), s = Ue(!0), a = cn(() => [...e, n], [...e, n]), l = () => {
    async function u() {
      try {
        i((f) => ({
          ...f,
          loading: !0
        }));
        const d = await t();
        s.current && i((f) => ({
          ...f,
          result: d,
          error: null,
          loading: !1
        }));
      } catch (d) {
        s.current && i((f) => ({
          ...f,
          error: d,
          loading: !1
        }));
      }
    }
    return u();
  };
  Ne(() => {
    if (!n) {
      i((u) => ({ ...u, loading: !1 }));
      return;
    }
    return i((u) => ({ ...u, dependencies: e })), l(), () => i((u) => ({
      ...u,
      loading: !1,
      error: null,
      ...r.resetOnChange ? { result: null } : {}
    }));
  }, a), Ne(() => (s.current = !0, () => {
    s.current = !1;
  }), []);
  const c = (u) => {
    i(typeof u == "function" ? (d) => ({ ...d, result: u(d.result) }) : (d) => ({ ...d, result: u }));
  };
  return [o.loading, o.result, o.error, l, c, o.dependencies];
}
const b9 = (t, e = {}) => {
  const n = new URLSearchParams();
  Object.keys(e).forEach((o) => {
    R_e.includes(e[o]) || (Array.isArray(e[o]) ? e[o].forEach((i) => {
      n.append(o, i);
    }) : n.set(o, e[o]));
  });
  const r = n.toString();
  return t + (r ? `?${r}` : "");
};
oce.bind(window);
const KOt = (t, e) => nEe.stringify(t, { indent: 2, lineWidth: 0, ...e });
function XOt(t, e) {
  if (t === e)
    return !0;
  if (typeof t != "object" || t === null || typeof e != "object" || e === null)
    return !1;
  const n = Object.keys(t), r = Object.keys(e);
  if (n.length !== r.length)
    return !1;
  const o = Object.prototype.hasOwnProperty.bind(e);
  for (let i = 0; i < n.length; i++)
    if (!o(n[i]) || t[n[i]] !== e[n[i]])
      return !1;
  return !0;
}
const QOt = (t) => /* @__PURE__ */ M.jsx(Lse.DropdownIndicator, { ...t, children: /* @__PURE__ */ M.jsx(j3, { className: "icon-dim-20 icon-n6" }) }), ZOt = (t, e, n) => t === yp.WEBHOOK ? n === w3.PULL_REQUEST ? /* @__PURE__ */ M.jsx(OEe, { className: "scn-6" }) : n === w3.TAG_CREATION ? /* @__PURE__ */ M.jsx(Ise, { className: "scn-6" }) : /* @__PURE__ */ M.jsx(PAe, {}) : t === yp.BranchRegex || e ? /* @__PURE__ */ M.jsx(kEe, { className: "fcn-6" }) : /* @__PURE__ */ M.jsx(Bse, { className: "fcn-6" }), Hie = {
  100: "Continue",
  101: "Switching Protocols",
  102: "Processing(WebDAV)",
  200: "OK",
  201: "Created",
  202: "Accepted",
  203: "Non - Authoritative Information",
  204: "No Content",
  205: "Reset Content",
  206: "Partial Content",
  207: "Multi - Status(WebDAV)",
  208: "Already Reported(WebDAV)",
  226: "IM Used",
  300: "Multiple Choices",
  301: "Moved Permanently",
  302: "Found",
  303: "See Other",
  304: "Not Modified",
  305: "Use Proxy",
  307: "Temporary Redirect",
  308: "Permanent Redirect(experimental)",
  400: "Bad Request",
  401: "Unauthorized",
  402: "Payment Required",
  403: "Forbidden",
  404: "Not Found",
  405: "Method Not Allowed",
  406: "Not Acceptable",
  407: "Proxy Authentication Required",
  408: "Request Timeout",
  409: "Conflict",
  410: "Gone",
  411: "Length Required",
  412: "Precondition Failed",
  413: "Request Entity Too Large",
  414: "Request - URI Too Long",
  415: "Unsupported Media Type",
  416: "Requested Range Not Satisfiable",
  417: "Expectation Failed",
  418: "I'm a teapot",
  420: "Enhance Your Calm(Twitter)",
  422: "Unprocessable Entity(WebDAV)",
  423: "Locked(WebDAV)",
  424: "Failed Dependency(WebDAV)",
  425: "Reserved for WebDAV",
  426: "Upgrade Required",
  428: "Precondition Required",
  429: "Too Many Requests",
  431: "Request Header Fields Too Large",
  444: "No Response(Nginx)",
  449: "Retry With(Microsoft)",
  450: "Blocked by Windows Parental Controls(Microsoft)",
  451: "Unavailable For Legal Reasons",
  499: "Client Closed Request(Nginx)",
  500: "Internal Server Error",
  501: "Not Implemented",
  502: "Bad Gateway",
  503: "Service Unavailable",
  504: "Gateway Timeout",
  505: "HTTP Version Not Supported",
  506: "Variant Also Negotiates(Experimental)",
  507: "Insufficient Storage(WebDAV)",
  508: "Loop Detected(WebDAV)",
  509: "Bandwidth Limit Exceeded(Apache)",
  510: "Not Extended",
  511: "Network Authentication Required",
  598: "Network read timeout error",
  599: "Network connect timeout error"
}, Vie = async (t, e) => {
  const n = e.status;
  let r = e.statusText || Hie[n];
  const o = new yl({ code: n, errors: [] });
  if (t !== "application/json")
    r = `${Hie[n]}. Please try again.`;
  else {
    const i = await e.json();
    i.errors && (o.errors = i.errors);
  }
  throw o.errors = o.errors.length > 0 ? o.errors : [{ code: n, internalMessage: r, userMessage: r }], o;
}, JOt = (t) => (
  // The 0 code is common for aborted and blocked requests
  t && t.code === 0 && t.message.search("abort|aborted") > -1
), eCt = () => {
  const t = `${window.location.pathname.replace(window.__BASE_URL__, "")}${window.location.search}`;
  window.location.href = b9(`${window.location.origin}${window.__BASE_URL__}${Up.LOGIN_SSO}`, {
    continue: t
  });
}, tCt = () => {
  window.location.href = `${window.location.origin}${window.__BASE_URL__}${Up.LICENSE_AUTH}`;
};
class _9 {
  constructor({ handleLogout: e, host: n, timeout: r, handleRedirectToLicenseActivation: o }) {
    Gn(this, "handleLogout"), Gn(this, "handleRedirectToLicenseActivation"), Gn(this, "host"), Gn(this, "timeout"), Gn(this, "fetchAPI", async ({
      url: i,
      type: s,
      data: a,
      signal: l,
      preventAutoLogout: c = !1,
      preventLicenseRedirect: u = !1,
      shouldParseServerErrorForUnauthorizedUser: d = !1,
      isMultipartRequest: f,
      isProxyHost: h = !1
    }) => {
      const p = {
        method: s,
        signal: l,
        body: a ? JSON.stringify(a) : void 0
      };
      return p.credentials = "include", fetch(
        `${h ? "/proxy" : this.host}/${i}`,
        f ? {
          method: s,
          body: a
        } : p
      ).then(
        // eslint-disable-next-line consistent-return
        async (m) => {
          if (m.headers.get(M_e.LICENSE_STATUS) === nxt && !u)
            return this.handleRedirectToLicenseActivation(), new Promise((y) => {
              setTimeout(() => {
                y({ code: Qa.UNAUTHORIZED, status: "Unauthorized", result: [] });
              }, 1e3);
            });
          const g = m.headers.get("Content-Type");
          if (m.status === Qa.UNAUTHORIZED)
            if (c) {
              if (d)
                return await Vie(g, m), null;
              throw new yl({
                code: Qa.UNAUTHORIZED,
                errors: [
                  {
                    code: Qa.UNAUTHORIZED,
                    internalMessage: "Please login again",
                    userMessage: "Please login again"
                  }
                ]
              });
            } else
              return this.handleLogout(), await new Promise((y) => {
                setTimeout(() => {
                  y({ code: Qa.UNAUTHORIZED, status: "Unauthorized", result: [] });
                }, 1e3);
              });
          else {
            if (m.status >= 300 && m.status <= 599)
              return await Vie(g, m);
            if (g === "application/json")
              return m.json().then((y) => {
                if (y.code >= 300 && y.code <= 599)
                  throw new yl({ code: y.code, errors: y.errors });
                return y;
              });
            if (g === "octet-stream" || g === "application/octet-stream")
              return m;
          }
        },
        (m) => {
          const g = {
            code: 0,
            userMessage: m.message,
            internalMessage: m.message,
            moreInfo: m.message
          };
          throw new yl({ code: 0, errors: [g] });
        }
      );
    }), Gn(this, "fetchInTime", ({
      url: i,
      type: s,
      data: a,
      options: l,
      isMultipartRequest: c
    }) => {
      const u = l?.abortControllerRef?.current ?? new AbortController(), d = u.signal, f = _9.mergeAbortSignals(l?.signal, d), h = l?.timeout || this.timeout, p = new Promise((m, g) => {
        setTimeout(() => {
          u.abort(), l?.abortControllerRef?.current && (l.abortControllerRef.current = new AbortController()), g({
            code: Qa.REQUEST_TIMEOUT,
            errors: [
              {
                code: Qa.REQUEST_TIMEOUT,
                internalMessage: "Request cancelled",
                userMessage: "Request Cancelled"
              }
            ]
          });
        }, h);
      });
      return Promise.race([
        this.fetchAPI({
          url: i,
          type: s,
          data: a,
          signal: f,
          preventAutoLogout: l?.preventAutoLogout || !1,
          preventLicenseRedirect: l?.preventLicenseRedirect || !1,
          shouldParseServerErrorForUnauthorizedUser: l?.shouldParseServerErrorForUnauthorizedUser,
          isMultipartRequest: c,
          isProxyHost: l?.isProxyHost || !1
        }),
        p
      ]).catch((m) => {
        throw m instanceof yl ? m : new yl({
          code: Qa.REQUEST_TIMEOUT,
          errors: [
            {
              code: Qa.REQUEST_TIMEOUT,
              internalMessage: "That took longer than expected.",
              userMessage: "That took longer than expected."
            }
          ]
        });
      });
    }), Gn(this, "post", (i, s, a, l) => this.fetchInTime({ url: i, type: "POST", data: s, options: a, isMultipartRequest: l })), Gn(this, "put", (i, s, a) => this.fetchInTime({ url: i, type: "PUT", data: s, options: a })), Gn(this, "patch", (i, s, a) => this.fetchInTime({ url: i, type: "PATCH", data: s, options: a })), Gn(this, "get", (i, s) => this.fetchInTime({ url: i, type: "GET", data: null, options: s })), Gn(this, "trash", (i, s, a) => this.fetchInTime({ url: i, type: "DELETE", data: s, options: a })), Gn(this, "setGlobalAPITimeout", (i) => {
      this.timeout = i || yie;
    }), this.handleLogout = e, this.host = n || Uwt, this.timeout = r || yie, this.handleRedirectToLicenseActivation = o || eo;
  }
  /**
   * Merges multiple AbortSignals into a single AbortSignal that aborts
   * as soon as any of the input signals abort.
   *
   * This is useful when you want to race multiple async cancellation signals,
   * for example, to support both a global timeout and a user-triggered abort.
   *
   * @param signals - AbortSignals to merge.
   * @returns An AbortSignal that aborts if any input signal aborts.
   */
  static mergeAbortSignals(...e) {
    const n = new AbortController();
    if (e.some((i) => i?.aborted))
      return n.abort(), n.signal;
    const r = () => n.abort(), o = [];
    return e.forEach((i) => {
      i && !i.aborted && (i.addEventListener("abort", r), o.push(() => i.removeEventListener("abort", r)));
    }), n.signal.addEventListener(
      "abort",
      () => {
        o.forEach((i) => i());
      },
      // This ensures the listener is only run once
      { once: !0 }
    ), n.signal;
  }
}
new hIe({
  defaultOptions: {
    queries: {
      cacheTime: 0,
      refetchOnWindowFocus: !1,
      refetchOnReconnect: !1,
      retry: !1,
      meta: { showToastError: !0 }
    },
    mutations: {
      cacheTime: 0,
      retry: !1,
      meta: { showToastError: !0 }
    }
  },
  queryCache: new yle({
    onError: (t, e) => {
      e.meta.showToastError && Vy(t);
    }
  }),
  mutationCache: new vle({
    onError: (t, e, n, r) => {
      r.meta.showToastError && Vy(t);
    }
  })
});
const xwe = (t) => IIe(t), nCt = new _9({
  handleLogout: eCt,
  timeout: window?._env_?.GLOBAL_API_TIMEOUT,
  handleRedirectToLicenseActivation: tCt
}), { post: rCt, put: kIt, patch: AIt, get: w9, trash: Ewe, setGlobalAPITimeout: TIt } = nCt;
lr({
  state: { alias: {} },
  setState: null
});
xe.createContext(null);
function oCt(t, e, n = []) {
  const r = Ue(!0);
  Ne(() => {
    if (r.current) {
      r.current = !1;
      return;
    }
    const o = setTimeout(() => {
      t();
    }, e);
    return () => {
      clearTimeout(o);
    };
  }, [e, ...n]);
}
function iCt({
  onSearch: t,
  Icon: e,
  children: n,
  placeholder: r,
  containerClass: o = "",
  iconClass: i = "",
  inputClass: s = "",
  debounceTimeout: a = 500,
  clearSearch: l,
  showClearIcon: c = !0,
  autoFocus: u = !0
}) {
  const [d, f] = Ye("");
  Ne(() => {
    f("");
  }, [l]);
  const h = (m) => {
    f(m.target.value);
  }, p = () => {
    f("");
  };
  return oCt(() => t(d), a, [d]), /* @__PURE__ */ M.jsxs("div", { className: o, children: [
    e && /* @__PURE__ */ M.jsx(e, { className: i }),
    /* @__PURE__ */ M.jsx(
      "input",
      {
        type: "text",
        className: s,
        placeholder: r ?? "Search",
        value: d,
        onChange: h,
        autoFocus: u,
        "data-testid": "debounced-search"
      }
    ),
    c && !!d && /* @__PURE__ */ M.jsx(
      "button",
      {
        type: "button",
        className: "dc__outline-none-imp dc__no-border p-0 bg__secondary flex",
        onClick: p,
        "data-testid": "clear-search",
        children: /* @__PURE__ */ M.jsx(TEe, { className: "icon-dim-20 icon-n6" })
      }
    ),
    n
  ] });
}
lr({ title: "", isLoading: !1, close: (t) => {
}, onSave: (t) => {
} });
const sCt = ({ subtitle: t, title: e }) => /* @__PURE__ */ M.jsx(
  Vd,
  {
    image: PD,
    title: e ?? yr.NOT_AUTHORIZED,
    subTitle: t ?? yr.ONLY_FOR_SUPERADMIN
  }
);
new Tn.Renderer();
class RIt extends xe.Component {
  constructor(e) {
    super(e), Gn(this, "handleBodyClick", (n) => {
      n.stopPropagation(), this.props.close?.(n);
    });
  }
  render() {
    return /* @__PURE__ */ M.jsx(
      f9,
      {
        onEscape: this.props.close ?? eo,
        onClick: this.handleBodyClick,
        initialFocus: this.props.initialFocus ?? void 0,
        children: /* @__PURE__ */ M.jsx("div", { className: `visible-modal__body ${this.props.className || ""}`, children: this.props.children })
      }
    );
  }
}
Oe.xs + "", Oe.small + "", Oe.medium + "", Oe.large + "";
Oe.xs + "", Oe.small + "", Oe.medium + "", Oe.large + "";
xe.createContext(null);
class aCt {
  /**
   * @callback HookCallback
   * @this {*|Jsep} this
   * @param {Jsep} env
   * @returns: void
   */
  /**
   * Adds the given callback to the list of callbacks for the given hook.
   *
   * The callback will be invoked when the hook it is registered for is run.
   *
   * One callback function can be registered to multiple hooks and the same hook multiple times.
   *
   * @param {string|object} name The name of the hook, or an object of callbacks keyed by name
   * @param {HookCallback|boolean} callback The callback function which is given environment variables.
   * @param {?boolean} [first=false] Will add the hook to the top of the list (defaults to the bottom)
   * @public
   */
  add(e, n, r) {
    if (typeof arguments[0] != "string")
      for (let o in arguments[0])
        this.add(o, arguments[0][o], arguments[1]);
    else
      (Array.isArray(e) ? e : [e]).forEach(function(o) {
        this[o] = this[o] || [], n && this[o][r ? "unshift" : "push"](n);
      }, this);
  }
  /**
   * Runs a hook invoking all registered callbacks with the given environment variables.
   *
   * Callbacks will be invoked synchronously and in the order in which they were registered.
   *
   * @param {string} name The name of the hook.
   * @param {Object<string, any>} env The environment variables of the hook passed to all callbacks registered.
   * @public
   */
  run(e, n) {
    this[e] = this[e] || [], this[e].forEach(function(r) {
      r.call(n && n.context ? n.context : n, n);
    });
  }
}
class lCt {
  constructor(e) {
    this.jsep = e, this.registered = {};
  }
  /**
   * @callback PluginSetup
   * @this {Jsep} jsep
   * @returns: void
   */
  /**
   * Adds the given plugin(s) to the registry
   *
   * @param {object} plugins
   * @param {string} plugins.name The name of the plugin
   * @param {PluginSetup} plugins.init The init function
   * @public
   */
  register() {
    for (var e = arguments.length, n = new Array(e), r = 0; r < e; r++)
      n[r] = arguments[r];
    n.forEach((o) => {
      if (typeof o != "object" || !o.name || !o.init)
        throw new Error("Invalid JSEP plugin format");
      this.registered[o.name] || (o.init(this.jsep), this.registered[o.name] = o);
    });
  }
}
class Se {
  /**
   * @returns {string}
   */
  static get version() {
    return "1.4.0";
  }
  /**
   * @returns {string}
   */
  static toString() {
    return "JavaScript Expression Parser (JSEP) v" + Se.version;
  }
  // ==================== CONFIG ================================
  /**
   * @method addUnaryOp
   * @param {string} op_name The name of the unary op to add
   * @returns {Jsep}
   */
  static addUnaryOp(e) {
    return Se.max_unop_len = Math.max(e.length, Se.max_unop_len), Se.unary_ops[e] = 1, Se;
  }
  /**
   * @method jsep.addBinaryOp
   * @param {string} op_name The name of the binary op to add
   * @param {number} precedence The precedence of the binary op (can be a float). Higher number = higher precedence
   * @param {boolean} [isRightAssociative=false] whether operator is right-associative
   * @returns {Jsep}
   */
  static addBinaryOp(e, n, r) {
    return Se.max_binop_len = Math.max(e.length, Se.max_binop_len), Se.binary_ops[e] = n, r ? Se.right_associative.add(e) : Se.right_associative.delete(e), Se;
  }
  /**
   * @method addIdentifierChar
   * @param {string} char The additional character to treat as a valid part of an identifier
   * @returns {Jsep}
   */
  static addIdentifierChar(e) {
    return Se.additional_identifier_chars.add(e), Se;
  }
  /**
   * @method addLiteral
   * @param {string} literal_name The name of the literal to add
   * @param {*} literal_value The value of the literal
   * @returns {Jsep}
   */
  static addLiteral(e, n) {
    return Se.literals[e] = n, Se;
  }
  /**
   * @method removeUnaryOp
   * @param {string} op_name The name of the unary op to remove
   * @returns {Jsep}
   */
  static removeUnaryOp(e) {
    return delete Se.unary_ops[e], e.length === Se.max_unop_len && (Se.max_unop_len = Se.getMaxKeyLen(Se.unary_ops)), Se;
  }
  /**
   * @method removeAllUnaryOps
   * @returns {Jsep}
   */
  static removeAllUnaryOps() {
    return Se.unary_ops = {}, Se.max_unop_len = 0, Se;
  }
  /**
   * @method removeIdentifierChar
   * @param {string} char The additional character to stop treating as a valid part of an identifier
   * @returns {Jsep}
   */
  static removeIdentifierChar(e) {
    return Se.additional_identifier_chars.delete(e), Se;
  }
  /**
   * @method removeBinaryOp
   * @param {string} op_name The name of the binary op to remove
   * @returns {Jsep}
   */
  static removeBinaryOp(e) {
    return delete Se.binary_ops[e], e.length === Se.max_binop_len && (Se.max_binop_len = Se.getMaxKeyLen(Se.binary_ops)), Se.right_associative.delete(e), Se;
  }
  /**
   * @method removeAllBinaryOps
   * @returns {Jsep}
   */
  static removeAllBinaryOps() {
    return Se.binary_ops = {}, Se.max_binop_len = 0, Se;
  }
  /**
   * @method removeLiteral
   * @param {string} literal_name The name of the literal to remove
   * @returns {Jsep}
   */
  static removeLiteral(e) {
    return delete Se.literals[e], Se;
  }
  /**
   * @method removeAllLiterals
   * @returns {Jsep}
   */
  static removeAllLiterals() {
    return Se.literals = {}, Se;
  }
  // ==================== END CONFIG ============================
  /**
   * @returns {string}
   */
  get char() {
    return this.expr.charAt(this.index);
  }
  /**
   * @returns {number}
   */
  get code() {
    return this.expr.charCodeAt(this.index);
  }
  /**
   * @param {string} expr a string with the passed in express
   * @returns Jsep
   */
  constructor(e) {
    this.expr = e, this.index = 0;
  }
  /**
   * static top-level parser
   * @returns {jsep.Expression}
   */
  static parse(e) {
    return new Se(e).parse();
  }
  /**
   * Get the longest key length of any object
   * @param {object} obj
   * @returns {number}
   */
  static getMaxKeyLen(e) {
    return Math.max(0, ...Object.keys(e).map((n) => n.length));
  }
  /**
   * `ch` is a character code in the next three functions
   * @param {number} ch
   * @returns {boolean}
   */
  static isDecimalDigit(e) {
    return e >= 48 && e <= 57;
  }
  /**
   * Returns the precedence of a binary operator or `0` if it isn't a binary operator. Can be float.
   * @param {string} op_val
   * @returns {number}
   */
  static binaryPrecedence(e) {
    return Se.binary_ops[e] || 0;
  }
  /**
   * Looks for start of identifier
   * @param {number} ch
   * @returns {boolean}
   */
  static isIdentifierStart(e) {
    return e >= 65 && e <= 90 || // A...Z
    e >= 97 && e <= 122 || // a...z
    e >= 128 && !Se.binary_ops[String.fromCharCode(e)] || // any non-ASCII that is not an operator
    Se.additional_identifier_chars.has(String.fromCharCode(e));
  }
  /**
   * @param {number} ch
   * @returns {boolean}
   */
  static isIdentifierPart(e) {
    return Se.isIdentifierStart(e) || Se.isDecimalDigit(e);
  }
  /**
   * throw error at index of the expression
   * @param {string} message
   * @throws
   */
  throwError(e) {
    const n = new Error(e + " at character " + this.index);
    throw n.index = this.index, n.description = e, n;
  }
  /**
   * Run a given hook
   * @param {string} name
   * @param {jsep.Expression|false} [node]
   * @returns {?jsep.Expression}
   */
  runHook(e, n) {
    if (Se.hooks[e]) {
      const r = {
        context: this,
        node: n
      };
      return Se.hooks.run(e, r), r.node;
    }
    return n;
  }
  /**
   * Runs a given hook until one returns a node
   * @param {string} name
   * @returns {?jsep.Expression}
   */
  searchHook(e) {
    if (Se.hooks[e]) {
      const n = {
        context: this
      };
      return Se.hooks[e].find(function(r) {
        return r.call(n.context, n), n.node;
      }), n.node;
    }
  }
  /**
   * Push `index` up to the next non-space character
   */
  gobbleSpaces() {
    let e = this.code;
    for (; e === Se.SPACE_CODE || e === Se.TAB_CODE || e === Se.LF_CODE || e === Se.CR_CODE; )
      e = this.expr.charCodeAt(++this.index);
    this.runHook("gobble-spaces");
  }
  /**
   * Top-level method to parse all expressions and returns compound or single node
   * @returns {jsep.Expression}
   */
  parse() {
    this.runHook("before-all");
    const e = this.gobbleExpressions(), n = e.length === 1 ? e[0] : {
      type: Se.COMPOUND,
      body: e
    };
    return this.runHook("after-all", n);
  }
  /**
   * top-level parser (but can be reused within as well)
   * @param {number} [untilICode]
   * @returns {jsep.Expression[]}
   */
  gobbleExpressions(e) {
    let n = [], r, o;
    for (; this.index < this.expr.length; )
      if (r = this.code, r === Se.SEMCOL_CODE || r === Se.COMMA_CODE)
        this.index++;
      else if (o = this.gobbleExpression())
        n.push(o);
      else if (this.index < this.expr.length) {
        if (r === e)
          break;
        this.throwError('Unexpected "' + this.char + '"');
      }
    return n;
  }
  /**
   * The main parsing function.
   * @returns {?jsep.Expression}
   */
  gobbleExpression() {
    const e = this.searchHook("gobble-expression") || this.gobbleBinaryExpression();
    return this.gobbleSpaces(), this.runHook("after-expression", e);
  }
  /**
   * Search for the operation portion of the string (e.g. `+`, `===`)
   * Start by taking the longest possible binary operations (3 characters: `===`, `!==`, `>>>`)
   * and move down from 3 to 2 to 1 character until a matching binary operation is found
   * then, return that binary operation
   * @returns {string|boolean}
   */
  gobbleBinaryOp() {
    this.gobbleSpaces();
    let e = this.expr.substr(this.index, Se.max_binop_len), n = e.length;
    for (; n > 0; ) {
      if (Se.binary_ops.hasOwnProperty(e) && (!Se.isIdentifierStart(this.code) || this.index + e.length < this.expr.length && !Se.isIdentifierPart(this.expr.charCodeAt(this.index + e.length))))
        return this.index += n, e;
      e = e.substr(0, --n);
    }
    return !1;
  }
  /**
   * This function is responsible for gobbling an individual expression,
   * e.g. `1`, `1+2`, `a+(b*2)-Math.sqrt(2)`
   * @returns {?jsep.BinaryExpression}
   */
  gobbleBinaryExpression() {
    let e, n, r, o, i, s, a, l, c;
    if (s = this.gobbleToken(), !s || (n = this.gobbleBinaryOp(), !n))
      return s;
    for (i = {
      value: n,
      prec: Se.binaryPrecedence(n),
      right_a: Se.right_associative.has(n)
    }, a = this.gobbleToken(), a || this.throwError("Expected expression after " + n), o = [s, i, a]; n = this.gobbleBinaryOp(); ) {
      if (r = Se.binaryPrecedence(n), r === 0) {
        this.index -= n.length;
        break;
      }
      i = {
        value: n,
        prec: r,
        right_a: Se.right_associative.has(n)
      }, c = n;
      const u = (d) => i.right_a && d.right_a ? r > d.prec : r <= d.prec;
      for (; o.length > 2 && u(o[o.length - 2]); )
        a = o.pop(), n = o.pop().value, s = o.pop(), e = {
          type: Se.BINARY_EXP,
          operator: n,
          left: s,
          right: a
        }, o.push(e);
      e = this.gobbleToken(), e || this.throwError("Expected expression after " + c), o.push(i, e);
    }
    for (l = o.length - 1, e = o[l]; l > 1; )
      e = {
        type: Se.BINARY_EXP,
        operator: o[l - 1].value,
        left: o[l - 2],
        right: e
      }, l -= 2;
    return e;
  }
  /**
   * An individual part of a binary expression:
   * e.g. `foo.bar(baz)`, `1`, `"abc"`, `(a % 2)` (because it's in parenthesis)
   * @returns {boolean|jsep.Expression}
   */
  gobbleToken() {
    let e, n, r, o;
    if (this.gobbleSpaces(), o = this.searchHook("gobble-token"), o)
      return this.runHook("after-token", o);
    if (e = this.code, Se.isDecimalDigit(e) || e === Se.PERIOD_CODE)
      return this.gobbleNumericLiteral();
    if (e === Se.SQUOTE_CODE || e === Se.DQUOTE_CODE)
      o = this.gobbleStringLiteral();
    else if (e === Se.OBRACK_CODE)
      o = this.gobbleArray();
    else {
      for (n = this.expr.substr(this.index, Se.max_unop_len), r = n.length; r > 0; ) {
        if (Se.unary_ops.hasOwnProperty(n) && (!Se.isIdentifierStart(this.code) || this.index + n.length < this.expr.length && !Se.isIdentifierPart(this.expr.charCodeAt(this.index + n.length)))) {
          this.index += r;
          const i = this.gobbleToken();
          return i || this.throwError("missing unaryOp argument"), this.runHook("after-token", {
            type: Se.UNARY_EXP,
            operator: n,
            argument: i,
            prefix: !0
          });
        }
        n = n.substr(0, --r);
      }
      Se.isIdentifierStart(e) ? (o = this.gobbleIdentifier(), Se.literals.hasOwnProperty(o.name) ? o = {
        type: Se.LITERAL,
        value: Se.literals[o.name],
        raw: o.name
      } : o.name === Se.this_str && (o = {
        type: Se.THIS_EXP
      })) : e === Se.OPAREN_CODE && (o = this.gobbleGroup());
    }
    return o ? (o = this.gobbleTokenProperty(o), this.runHook("after-token", o)) : this.runHook("after-token", !1);
  }
  /**
   * Gobble properties of of identifiers/strings/arrays/groups.
   * e.g. `foo`, `bar.baz`, `foo['bar'].baz`
   * It also gobbles function calls:
   * e.g. `Math.acos(obj.angle)`
   * @param {jsep.Expression} node
   * @returns {jsep.Expression}
   */
  gobbleTokenProperty(e) {
    this.gobbleSpaces();
    let n = this.code;
    for (; n === Se.PERIOD_CODE || n === Se.OBRACK_CODE || n === Se.OPAREN_CODE || n === Se.QUMARK_CODE; ) {
      let r;
      if (n === Se.QUMARK_CODE) {
        if (this.expr.charCodeAt(this.index + 1) !== Se.PERIOD_CODE)
          break;
        r = !0, this.index += 2, this.gobbleSpaces(), n = this.code;
      }
      this.index++, n === Se.OBRACK_CODE ? (e = {
        type: Se.MEMBER_EXP,
        computed: !0,
        object: e,
        property: this.gobbleExpression()
      }, e.property || this.throwError('Unexpected "' + this.char + '"'), this.gobbleSpaces(), n = this.code, n !== Se.CBRACK_CODE && this.throwError("Unclosed ["), this.index++) : n === Se.OPAREN_CODE ? e = {
        type: Se.CALL_EXP,
        arguments: this.gobbleArguments(Se.CPAREN_CODE),
        callee: e
      } : (n === Se.PERIOD_CODE || r) && (r && this.index--, this.gobbleSpaces(), e = {
        type: Se.MEMBER_EXP,
        computed: !1,
        object: e,
        property: this.gobbleIdentifier()
      }), r && (e.optional = !0), this.gobbleSpaces(), n = this.code;
    }
    return e;
  }
  /**
   * Parse simple numeric literals: `12`, `3.4`, `.5`. Do this by using a string to
   * keep track of everything in the numeric literal and then calling `parseFloat` on that string
   * @returns {jsep.Literal}
   */
  gobbleNumericLiteral() {
    let e = "", n, r;
    for (; Se.isDecimalDigit(this.code); )
      e += this.expr.charAt(this.index++);
    if (this.code === Se.PERIOD_CODE)
      for (e += this.expr.charAt(this.index++); Se.isDecimalDigit(this.code); )
        e += this.expr.charAt(this.index++);
    if (n = this.char, n === "e" || n === "E") {
      for (e += this.expr.charAt(this.index++), n = this.char, (n === "+" || n === "-") && (e += this.expr.charAt(this.index++)); Se.isDecimalDigit(this.code); )
        e += this.expr.charAt(this.index++);
      Se.isDecimalDigit(this.expr.charCodeAt(this.index - 1)) || this.throwError("Expected exponent (" + e + this.char + ")");
    }
    return r = this.code, Se.isIdentifierStart(r) ? this.throwError("Variable names cannot start with a number (" + e + this.char + ")") : (r === Se.PERIOD_CODE || e.length === 1 && e.charCodeAt(0) === Se.PERIOD_CODE) && this.throwError("Unexpected period"), {
      type: Se.LITERAL,
      value: parseFloat(e),
      raw: e
    };
  }
  /**
   * Parses a string literal, staring with single or double quotes with basic support for escape codes
   * e.g. `"hello world"`, `'this is\nJSEP'`
   * @returns {jsep.Literal}
   */
  gobbleStringLiteral() {
    let e = "";
    const n = this.index, r = this.expr.charAt(this.index++);
    let o = !1;
    for (; this.index < this.expr.length; ) {
      let i = this.expr.charAt(this.index++);
      if (i === r) {
        o = !0;
        break;
      } else if (i === "\\")
        switch (i = this.expr.charAt(this.index++), i) {
          case "n":
            e += `
`;
            break;
          case "r":
            e += "\r";
            break;
          case "t":
            e += "	";
            break;
          case "b":
            e += "\b";
            break;
          case "f":
            e += "\f";
            break;
          case "v":
            e += "\v";
            break;
          default:
            e += i;
        }
      else
        e += i;
    }
    return o || this.throwError('Unclosed quote after "' + e + '"'), {
      type: Se.LITERAL,
      value: e,
      raw: this.expr.substring(n, this.index)
    };
  }
  /**
   * Gobbles only identifiers
   * e.g.: `foo`, `_value`, `$x1`
   * Also, this function checks if that identifier is a literal:
   * (e.g. `true`, `false`, `null`) or `this`
   * @returns {jsep.Identifier}
   */
  gobbleIdentifier() {
    let e = this.code, n = this.index;
    for (Se.isIdentifierStart(e) ? this.index++ : this.throwError("Unexpected " + this.char); this.index < this.expr.length && (e = this.code, Se.isIdentifierPart(e)); )
      this.index++;
    return {
      type: Se.IDENTIFIER,
      name: this.expr.slice(n, this.index)
    };
  }
  /**
   * Gobbles a list of arguments within the context of a function call
   * or array literal. This function also assumes that the opening character
   * `(` or `[` has already been gobbled, and gobbles expressions and commas
   * until the terminator character `)` or `]` is encountered.
   * e.g. `foo(bar, baz)`, `my_func()`, or `[bar, baz]`
   * @param {number} termination
   * @returns {jsep.Expression[]}
   */
  gobbleArguments(e) {
    const n = [];
    let r = !1, o = 0;
    for (; this.index < this.expr.length; ) {
      this.gobbleSpaces();
      let i = this.code;
      if (i === e) {
        r = !0, this.index++, e === Se.CPAREN_CODE && o && o >= n.length && this.throwError("Unexpected token " + String.fromCharCode(e));
        break;
      } else if (i === Se.COMMA_CODE) {
        if (this.index++, o++, o !== n.length) {
          if (e === Se.CPAREN_CODE)
            this.throwError("Unexpected token ,");
          else if (e === Se.CBRACK_CODE)
            for (let s = n.length; s < o; s++)
              n.push(null);
        }
      } else if (n.length !== o && o !== 0)
        this.throwError("Expected comma");
      else {
        const s = this.gobbleExpression();
        (!s || s.type === Se.COMPOUND) && this.throwError("Expected comma"), n.push(s);
      }
    }
    return r || this.throwError("Expected " + String.fromCharCode(e)), n;
  }
  /**
   * Responsible for parsing a group of things within parentheses `()`
   * that have no identifier in front (so not a function call)
   * This function assumes that it needs to gobble the opening parenthesis
   * and then tries to gobble everything within that parenthesis, assuming
   * that the next thing it should see is the close parenthesis. If not,
   * then the expression probably doesn't have a `)`
   * @returns {boolean|jsep.Expression}
   */
  gobbleGroup() {
    this.index++;
    let e = this.gobbleExpressions(Se.CPAREN_CODE);
    if (this.code === Se.CPAREN_CODE)
      return this.index++, e.length === 1 ? e[0] : e.length ? {
        type: Se.SEQUENCE_EXP,
        expressions: e
      } : !1;
    this.throwError("Unclosed (");
  }
  /**
   * Responsible for parsing Array literals `[1, 2, 3]`
   * This function assumes that it needs to gobble the opening bracket
   * and then tries to gobble the expressions as arguments.
   * @returns {jsep.ArrayExpression}
   */
  gobbleArray() {
    return this.index++, {
      type: Se.ARRAY_EXP,
      elements: this.gobbleArguments(Se.CBRACK_CODE)
    };
  }
}
const cCt = new aCt();
Object.assign(Se, {
  hooks: cCt,
  plugins: new lCt(Se),
  // Node Types
  // ----------
  // This is the full set of types that any JSEP node can be.
  // Store them here to save space when minified
  COMPOUND: "Compound",
  SEQUENCE_EXP: "SequenceExpression",
  IDENTIFIER: "Identifier",
  MEMBER_EXP: "MemberExpression",
  LITERAL: "Literal",
  THIS_EXP: "ThisExpression",
  CALL_EXP: "CallExpression",
  UNARY_EXP: "UnaryExpression",
  BINARY_EXP: "BinaryExpression",
  ARRAY_EXP: "ArrayExpression",
  TAB_CODE: 9,
  LF_CODE: 10,
  CR_CODE: 13,
  SPACE_CODE: 32,
  PERIOD_CODE: 46,
  // '.'
  COMMA_CODE: 44,
  // ','
  SQUOTE_CODE: 39,
  // single quote
  DQUOTE_CODE: 34,
  // double quotes
  OPAREN_CODE: 40,
  // (
  CPAREN_CODE: 41,
  // )
  OBRACK_CODE: 91,
  // [
  CBRACK_CODE: 93,
  // ]
  QUMARK_CODE: 63,
  // ?
  SEMCOL_CODE: 59,
  // ;
  COLON_CODE: 58,
  // :
  // Operations
  // ----------
  // Use a quickly-accessible map to store all of the unary operators
  // Values are set to `1` (it really doesn't matter)
  unary_ops: {
    "-": 1,
    "!": 1,
    "~": 1,
    "+": 1
  },
  // Also use a map for the binary operations but set their values to their
  // binary precedence for quick reference (higher number = higher precedence)
  // see [Order of operations](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Operator_Precedence)
  binary_ops: {
    "||": 1,
    "??": 1,
    "&&": 2,
    "|": 3,
    "^": 4,
    "&": 5,
    "==": 6,
    "!=": 6,
    "===": 6,
    "!==": 6,
    "<": 7,
    ">": 7,
    "<=": 7,
    ">=": 7,
    "<<": 8,
    ">>": 8,
    ">>>": 8,
    "+": 9,
    "-": 9,
    "*": 10,
    "/": 10,
    "%": 10,
    "**": 11
  },
  // sets specific binary_ops as right-associative
  right_associative: /* @__PURE__ */ new Set(["**"]),
  // Additional valid identifier chars, apart from a-z, A-Z and 0-9 (except on the starting char)
  additional_identifier_chars: /* @__PURE__ */ new Set(["$", "_"]),
  // Literals
  // ----------
  // Store the values to return for the various literals we may encounter
  literals: {
    true: !0,
    false: !1,
    null: null
  },
  // Except for `this`, which is special. This could be changed to something like `'self'` as well
  this_str: "this"
});
Se.max_unop_len = Se.getMaxKeyLen(Se.unary_ops);
Se.max_binop_len = Se.getMaxKeyLen(Se.binary_ops);
const ql = (t) => new Se(t).parse(), uCt = Object.getOwnPropertyNames(class {
});
Object.getOwnPropertyNames(Se).filter((t) => !uCt.includes(t) && ql[t] === void 0).forEach((t) => {
  ql[t] = Se[t];
});
ql.Jsep = Se;
const dCt = "ConditionalExpression";
var fCt = {
  name: "ternary",
  init(t) {
    t.hooks.add("after-expression", function(n) {
      if (n.node && this.code === t.QUMARK_CODE) {
        this.index++;
        const r = n.node, o = this.gobbleExpression();
        if (o || this.throwError("Expected expression"), this.gobbleSpaces(), this.code === t.COLON_CODE) {
          this.index++;
          const i = this.gobbleExpression();
          if (i || this.throwError("Expected expression"), n.node = {
            type: dCt,
            test: r,
            consequent: o,
            alternate: i
          }, r.operator && t.binary_ops[r.operator] <= 0.9) {
            let s = r;
            for (; s.right.operator && t.binary_ops[s.right.operator] <= 0.9; )
              s = s.right;
            n.node.test = s.right, s.right = n.node, n.node = r;
          }
        } else
          this.throwError("Expected :");
      }
    });
  }
};
ql.plugins.register(fCt);
const Wie = 47, hCt = 92;
var pCt = {
  name: "regex",
  init(t) {
    t.hooks.add("gobble-token", function(n) {
      if (this.code === Wie) {
        const r = ++this.index;
        let o = !1;
        for (; this.index < this.expr.length; ) {
          if (this.code === Wie && !o) {
            const i = this.expr.slice(r, this.index);
            let s = "";
            for (; ++this.index < this.expr.length; ) {
              const l = this.code;
              if (l >= 97 && l <= 122 || l >= 65 && l <= 90 || l >= 48 && l <= 57)
                s += this.char;
              else
                break;
            }
            let a;
            try {
              a = new RegExp(i, s);
            } catch (l) {
              this.throwError(l.message);
            }
            return n.node = {
              type: t.LITERAL,
              value: a,
              raw: this.expr.slice(r - 1, this.index)
            }, n.node = this.gobbleTokenProperty(n.node), n.node;
          }
          this.code === t.OBRACK_CODE ? o = !0 : o && this.code === t.CBRACK_CODE && (o = !1), this.index += this.code === hCt ? 2 : 1;
        }
        this.throwError("Unclosed Regex");
      }
    });
  }
};
const xD = 43, mCt = 45, Gf = {
  name: "assignment",
  assignmentOperators: /* @__PURE__ */ new Set(["=", "*=", "**=", "/=", "%=", "+=", "-=", "<<=", ">>=", ">>>=", "&=", "^=", "|=", "||=", "&&=", "??="]),
  updateOperators: [xD, mCt],
  assignmentPrecedence: 0.9,
  init(t) {
    const e = [t.IDENTIFIER, t.MEMBER_EXP];
    Gf.assignmentOperators.forEach((r) => t.addBinaryOp(r, Gf.assignmentPrecedence, !0)), t.hooks.add("gobble-token", function(o) {
      const i = this.code;
      Gf.updateOperators.some((s) => s === i && s === this.expr.charCodeAt(this.index + 1)) && (this.index += 2, o.node = {
        type: "UpdateExpression",
        operator: i === xD ? "++" : "--",
        argument: this.gobbleTokenProperty(this.gobbleIdentifier()),
        prefix: !0
      }, (!o.node.argument || !e.includes(o.node.argument.type)) && this.throwError(`Unexpected ${o.node.operator}`));
    }), t.hooks.add("after-token", function(o) {
      if (o.node) {
        const i = this.code;
        Gf.updateOperators.some((s) => s === i && s === this.expr.charCodeAt(this.index + 1)) && (e.includes(o.node.type) || this.throwError(`Unexpected ${o.node.operator}`), this.index += 2, o.node = {
          type: "UpdateExpression",
          operator: i === xD ? "++" : "--",
          argument: o.node,
          prefix: !1
        });
      }
    }), t.hooks.add("after-expression", function(o) {
      o.node && n(o.node);
    });
    function n(r) {
      Gf.assignmentOperators.has(r.operator) ? (r.type = "AssignmentExpression", n(r.left), n(r.right)) : r.operator || Object.values(r).forEach((o) => {
        o && typeof o == "object" && n(o);
      });
    }
  }
};
ql.plugins.register(pCt, Gf);
ql.addUnaryOp("typeof");
ql.addLiteral("null", null);
ql.addLiteral("undefined", void 0);
const gCt = /* @__PURE__ */ new Set(["constructor", "__proto__", "__defineGetter__", "__defineSetter__"]), Pn = {
  /**
   * @param {jsep.Expression} ast
   * @param {Record<string, any>} subs
   */
  evalAst(t, e) {
    switch (t.type) {
      case "BinaryExpression":
      case "LogicalExpression":
        return Pn.evalBinaryExpression(t, e);
      case "Compound":
        return Pn.evalCompound(t, e);
      case "ConditionalExpression":
        return Pn.evalConditionalExpression(t, e);
      case "Identifier":
        return Pn.evalIdentifier(t, e);
      case "Literal":
        return Pn.evalLiteral(t, e);
      case "MemberExpression":
        return Pn.evalMemberExpression(t, e);
      case "UnaryExpression":
        return Pn.evalUnaryExpression(t, e);
      case "ArrayExpression":
        return Pn.evalArrayExpression(t, e);
      case "CallExpression":
        return Pn.evalCallExpression(t, e);
      case "AssignmentExpression":
        return Pn.evalAssignmentExpression(t, e);
      default:
        throw SyntaxError("Unexpected expression", t);
    }
  },
  evalBinaryExpression(t, e) {
    return {
      "||": (r, o) => r || o(),
      "&&": (r, o) => r && o(),
      "|": (r, o) => r | o(),
      "^": (r, o) => r ^ o(),
      "&": (r, o) => r & o(),
      // eslint-disable-next-line eqeqeq -- API
      "==": (r, o) => r == o(),
      // eslint-disable-next-line eqeqeq -- API
      "!=": (r, o) => r != o(),
      "===": (r, o) => r === o(),
      "!==": (r, o) => r !== o(),
      "<": (r, o) => r < o(),
      ">": (r, o) => r > o(),
      "<=": (r, o) => r <= o(),
      ">=": (r, o) => r >= o(),
      "<<": (r, o) => r << o(),
      ">>": (r, o) => r >> o(),
      ">>>": (r, o) => r >>> o(),
      "+": (r, o) => r + o(),
      "-": (r, o) => r - o(),
      "*": (r, o) => r * o(),
      "/": (r, o) => r / o(),
      "%": (r, o) => r % o()
    }[t.operator](Pn.evalAst(t.left, e), () => Pn.evalAst(t.right, e));
  },
  evalCompound(t, e) {
    let n;
    for (let r = 0; r < t.body.length; r++) {
      t.body[r].type === "Identifier" && ["var", "let", "const"].includes(t.body[r].name) && t.body[r + 1] && t.body[r + 1].type === "AssignmentExpression" && (r += 1);
      const o = t.body[r];
      n = Pn.evalAst(o, e);
    }
    return n;
  },
  evalConditionalExpression(t, e) {
    return Pn.evalAst(t.test, e) ? Pn.evalAst(t.consequent, e) : Pn.evalAst(t.alternate, e);
  },
  evalIdentifier(t, e) {
    if (Object.hasOwn(e, t.name))
      return e[t.name];
    throw ReferenceError(`${t.name} is not defined`);
  },
  evalLiteral(t) {
    return t.value;
  },
  evalMemberExpression(t, e) {
    const n = String(
      // NOTE: `String(value)` throws error when
      // value has overwritten the toString method to return non-string
      // i.e. `value = {toString: () => []}`
      t.computed ? Pn.evalAst(t.property) : t.property.name
      // `object.property` property is Identifier
    ), r = Pn.evalAst(t.object, e);
    if (r == null)
      throw TypeError(`Cannot read properties of ${r} (reading '${n}')`);
    if (!Object.hasOwn(r, n) && gCt.has(n))
      throw TypeError(`Cannot read properties of ${r} (reading '${n}')`);
    const o = r[n];
    return typeof o == "function" ? o.bind(r) : o;
  },
  evalUnaryExpression(t, e) {
    return {
      "-": (r) => -Pn.evalAst(r, e),
      "!": (r) => !Pn.evalAst(r, e),
      "~": (r) => ~Pn.evalAst(r, e),
      // eslint-disable-next-line no-implicit-coercion -- API
      "+": (r) => +Pn.evalAst(r, e),
      typeof: (r) => typeof Pn.evalAst(r, e)
    }[t.operator](t.argument);
  },
  evalArrayExpression(t, e) {
    return t.elements.map((n) => Pn.evalAst(n, e));
  },
  evalCallExpression(t, e) {
    const n = t.arguments.map((o) => Pn.evalAst(o, e));
    return Pn.evalAst(t.callee, e)(...n);
  },
  evalAssignmentExpression(t, e) {
    if (t.left.type !== "Identifier")
      throw SyntaxError("Invalid left-hand side in assignment");
    const n = t.left.name, r = Pn.evalAst(t.right, e);
    return e[n] = r, e[n];
  }
};
class yCt {
  /**
   * @param {string} expr Expression to evaluate
   */
  constructor(e) {
    this.code = e, this.ast = ql(this.code);
  }
  /**
   * @param {object} context Object whose items will be added
   *   to evaluation
   * @returns {EvaluatedResult} Result of evaluated code
   */
  runInNewContext(e) {
    const n = Object.assign(/* @__PURE__ */ Object.create(null), e);
    return Pn.evalAst(this.ast, n);
  }
}
function uc(t, e) {
  return t = t.slice(), t.push(e), t;
}
function A3(t, e) {
  return e = e.slice(), e.unshift(t), e;
}
class vCt extends Error {
  /**
   * @param {AnyResult} value The evaluated scalar value
   */
  constructor(e) {
    super('JSONPath should not be called with "new" (it prevents return of (unwrapped) scalar values)'), this.avoidNew = !0, this.value = e, this.name = "NewError";
  }
}
function sn(t, e, n, r, o) {
  if (!(this instanceof sn))
    try {
      return new sn(t, e, n, r, o);
    } catch (s) {
      if (!s.avoidNew)
        throw s;
      return s.value;
    }
  typeof t == "string" && (o = r, r = n, n = e, e = t, t = null);
  const i = t && typeof t == "object";
  if (t = t || {}, this.json = t.json || n, this.path = t.path || e, this.resultType = t.resultType || "value", this.flatten = t.flatten || !1, this.wrap = Object.hasOwn(t, "wrap") ? t.wrap : !0, this.sandbox = t.sandbox || {}, this.eval = t.eval === void 0 ? "safe" : t.eval, this.ignoreEvalErrors = typeof t.ignoreEvalErrors > "u" ? !1 : t.ignoreEvalErrors, this.parent = t.parent || null, this.parentProperty = t.parentProperty || null, this.callback = t.callback || r || null, this.otherTypeCallback = t.otherTypeCallback || o || function() {
    throw new TypeError("You must supply an otherTypeCallback callback option with the @other() operator.");
  }, t.autostart !== !1) {
    const s = {
      path: i ? t.path : e
    };
    i ? "json" in t && (s.json = t.json) : s.json = n;
    const a = this.evaluate(s);
    if (!a || typeof a != "object")
      throw new vCt(a);
    return a;
  }
}
sn.prototype.evaluate = function(t, e, n, r) {
  let o = this.parent, i = this.parentProperty, {
    flatten: s,
    wrap: a
  } = this;
  if (this.currResultType = this.resultType, this.currEval = this.eval, this.currSandbox = this.sandbox, n = n || this.callback, this.currOtherTypeCallback = r || this.otherTypeCallback, e = e || this.json, t = t || this.path, t && typeof t == "object" && !Array.isArray(t)) {
    if (!t.path && t.path !== "")
      throw new TypeError('You must supply a "path" property when providing an object argument to JSONPath.evaluate().');
    if (!Object.hasOwn(t, "json"))
      throw new TypeError('You must supply a "json" property when providing an object argument to JSONPath.evaluate().');
    ({
      json: e
    } = t), s = Object.hasOwn(t, "flatten") ? t.flatten : s, this.currResultType = Object.hasOwn(t, "resultType") ? t.resultType : this.currResultType, this.currSandbox = Object.hasOwn(t, "sandbox") ? t.sandbox : this.currSandbox, a = Object.hasOwn(t, "wrap") ? t.wrap : a, this.currEval = Object.hasOwn(t, "eval") ? t.eval : this.currEval, n = Object.hasOwn(t, "callback") ? t.callback : n, this.currOtherTypeCallback = Object.hasOwn(t, "otherTypeCallback") ? t.otherTypeCallback : this.currOtherTypeCallback, o = Object.hasOwn(t, "parent") ? t.parent : o, i = Object.hasOwn(t, "parentProperty") ? t.parentProperty : i, t = t.path;
  }
  if (o = o || null, i = i || null, Array.isArray(t) && (t = sn.toPathString(t)), !t && t !== "" || !e)
    return;
  const l = sn.toPathArray(t);
  l[0] === "$" && l.length > 1 && l.shift(), this._hasParentSelector = null;
  const c = this._trace(l, e, ["$"], o, i, n).filter(function(u) {
    return u && !u.isParentSelector;
  });
  return c.length ? !a && c.length === 1 && !c[0].hasArrExpr ? this._getPreferredOutput(c[0]) : c.reduce((u, d) => {
    const f = this._getPreferredOutput(d);
    return s && Array.isArray(f) ? u = u.concat(f) : u.push(f), u;
  }, []) : a ? [] : void 0;
};
sn.prototype._getPreferredOutput = function(t) {
  const e = this.currResultType;
  switch (e) {
    case "all": {
      const n = Array.isArray(t.path) ? t.path : sn.toPathArray(t.path);
      return t.pointer = sn.toPointer(n), t.path = typeof t.path == "string" ? t.path : sn.toPathString(t.path), t;
    }
    case "value":
    case "parent":
    case "parentProperty":
      return t[e];
    case "path":
      return sn.toPathString(t[e]);
    case "pointer":
      return sn.toPointer(t.path);
    default:
      throw new TypeError("Unknown result type");
  }
};
sn.prototype._handleCallback = function(t, e, n) {
  if (e) {
    const r = this._getPreferredOutput(t);
    t.path = typeof t.path == "string" ? t.path : sn.toPathString(t.path), e(r, n, t);
  }
};
sn.prototype._trace = function(t, e, n, r, o, i, s, a) {
  let l;
  if (!t.length)
    return l = {
      path: n,
      value: e,
      parent: r,
      parentProperty: o,
      hasArrExpr: s
    }, this._handleCallback(l, i, "value"), l;
  const c = t[0], u = t.slice(1), d = [];
  function f(h) {
    Array.isArray(h) ? h.forEach((p) => {
      d.push(p);
    }) : d.push(h);
  }
  if ((typeof c != "string" || a) && e && Object.hasOwn(e, c))
    f(this._trace(u, e[c], uc(n, c), e, c, i, s));
  else if (c === "*")
    this._walk(e, (h) => {
      f(this._trace(u, e[h], uc(n, h), e, h, i, !0, !0));
    });
  else if (c === "..")
    f(this._trace(u, e, n, r, o, i, s)), this._walk(e, (h) => {
      typeof e[h] == "object" && f(this._trace(t.slice(), e[h], uc(n, h), e, h, i, !0));
    });
  else {
    if (c === "^")
      return this._hasParentSelector = !0, {
        path: n.slice(0, -1),
        expr: u,
        isParentSelector: !0
      };
    if (c === "~")
      return l = {
        path: uc(n, c),
        value: o,
        parent: r,
        parentProperty: null
      }, this._handleCallback(l, i, "property"), l;
    if (c === "$")
      f(this._trace(u, e, n, null, null, i, s));
    else if (/^(-?\d*):(-?\d*):?(\d*)$/u.test(c))
      f(this._slice(c, u, e, n, r, o, i));
    else if (c.indexOf("?(") === 0) {
      if (this.currEval === !1)
        throw new Error("Eval [?(expr)] prevented in JSONPath expression.");
      const h = c.replace(/^\?\((.*?)\)$/u, "$1"), p = /@.?([^?]*)[['](\??\(.*?\))(?!.\)\])[\]']/gu.exec(h);
      p ? this._walk(e, (m) => {
        const g = [p[2]], y = p[1] ? e[m][p[1]] : e[m];
        this._trace(g, y, n, r, o, i, !0).length > 0 && f(this._trace(u, e[m], uc(n, m), e, m, i, !0));
      }) : this._walk(e, (m) => {
        this._eval(h, e[m], m, n, r, o) && f(this._trace(u, e[m], uc(n, m), e, m, i, !0));
      });
    } else if (c[0] === "(") {
      if (this.currEval === !1)
        throw new Error("Eval [(expr)] prevented in JSONPath expression.");
      f(this._trace(A3(this._eval(c, e, n.at(-1), n.slice(0, -1), r, o), u), e, n, r, o, i, s));
    } else if (c[0] === "@") {
      let h = !1;
      const p = c.slice(1, -2);
      switch (p) {
        case "scalar":
          (!e || !["object", "function"].includes(typeof e)) && (h = !0);
          break;
        case "boolean":
        case "string":
        case "undefined":
        case "function":
          typeof e === p && (h = !0);
          break;
        case "integer":
          Number.isFinite(e) && !(e % 1) && (h = !0);
          break;
        case "number":
          Number.isFinite(e) && (h = !0);
          break;
        case "nonFinite":
          typeof e == "number" && !Number.isFinite(e) && (h = !0);
          break;
        case "object":
          e && typeof e === p && (h = !0);
          break;
        case "array":
          Array.isArray(e) && (h = !0);
          break;
        case "other":
          h = this.currOtherTypeCallback(e, n, r, o);
          break;
        case "null":
          e === null && (h = !0);
          break;
        /* c8 ignore next 2 */
        default:
          throw new TypeError("Unknown value type " + p);
      }
      if (h)
        return l = {
          path: n,
          value: e,
          parent: r,
          parentProperty: o
        }, this._handleCallback(l, i, "value"), l;
    } else if (c[0] === "`" && e && Object.hasOwn(e, c.slice(1))) {
      const h = c.slice(1);
      f(this._trace(u, e[h], uc(n, h), e, h, i, s, !0));
    } else if (c.includes(",")) {
      const h = c.split(",");
      for (const p of h)
        f(this._trace(A3(p, u), e, n, r, o, i, !0));
    } else !a && e && Object.hasOwn(e, c) && f(this._trace(u, e[c], uc(n, c), e, c, i, s, !0));
  }
  if (this._hasParentSelector)
    for (let h = 0; h < d.length; h++) {
      const p = d[h];
      if (p && p.isParentSelector) {
        const m = this._trace(p.expr, e, p.path, r, o, i, s);
        if (Array.isArray(m)) {
          d[h] = m[0];
          const g = m.length;
          for (let y = 1; y < g; y++)
            h++, d.splice(h, 0, m[y]);
        } else
          d[h] = m;
      }
    }
  return d;
};
sn.prototype._walk = function(t, e) {
  if (Array.isArray(t)) {
    const n = t.length;
    for (let r = 0; r < n; r++)
      e(r);
  } else t && typeof t == "object" && Object.keys(t).forEach((n) => {
    e(n);
  });
};
sn.prototype._slice = function(t, e, n, r, o, i, s) {
  if (!Array.isArray(n))
    return;
  const a = n.length, l = t.split(":"), c = l[2] && Number.parseInt(l[2]) || 1;
  let u = l[0] && Number.parseInt(l[0]) || 0, d = l[1] && Number.parseInt(l[1]) || a;
  u = u < 0 ? Math.max(0, u + a) : Math.min(a, u), d = d < 0 ? Math.max(0, d + a) : Math.min(a, d);
  const f = [];
  for (let h = u; h < d; h += c)
    this._trace(A3(h, e), n, r, o, i, s, !0).forEach((m) => {
      f.push(m);
    });
  return f;
};
sn.prototype._eval = function(t, e, n, r, o, i) {
  this.currSandbox._$_parentProperty = i, this.currSandbox._$_parent = o, this.currSandbox._$_property = n, this.currSandbox._$_root = this.json, this.currSandbox._$_v = e;
  const s = t.includes("@path");
  s && (this.currSandbox._$_path = sn.toPathString(r.concat([n])));
  const a = this.currEval + "Script:" + t;
  if (!sn.cache[a]) {
    let l = t.replaceAll("@parentProperty", "_$_parentProperty").replaceAll("@parent", "_$_parent").replaceAll("@property", "_$_property").replaceAll("@root", "_$_root").replaceAll(/@([.\s)[])/gu, "_$_v$1");
    if (s && (l = l.replaceAll("@path", "_$_path")), this.currEval === "safe" || this.currEval === !0 || this.currEval === void 0)
      sn.cache[a] = new this.safeVm.Script(l);
    else if (this.currEval === "native")
      sn.cache[a] = new this.vm.Script(l);
    else if (typeof this.currEval == "function" && this.currEval.prototype && Object.hasOwn(this.currEval.prototype, "runInNewContext")) {
      const c = this.currEval;
      sn.cache[a] = new c(l);
    } else if (typeof this.currEval == "function")
      sn.cache[a] = {
        runInNewContext: (c) => this.currEval(l, c)
      };
    else
      throw new TypeError(`Unknown "eval" property "${this.currEval}"`);
  }
  try {
    return sn.cache[a].runInNewContext(this.currSandbox);
  } catch (l) {
    if (this.ignoreEvalErrors)
      return !1;
    throw new Error("jsonPath: " + l.message + ": " + t);
  }
};
sn.cache = {};
sn.toPathString = function(t) {
  const e = t, n = e.length;
  let r = "$";
  for (let o = 1; o < n; o++)
    /^(~|\^|@.*?\(\))$/u.test(e[o]) || (r += /^[0-9*]+$/u.test(e[o]) ? "[" + e[o] + "]" : "['" + e[o] + "']");
  return r;
};
sn.toPointer = function(t) {
  const e = t, n = e.length;
  let r = "";
  for (let o = 1; o < n; o++)
    /^(~|\^|@.*?\(\))$/u.test(e[o]) || (r += "/" + e[o].toString().replaceAll("~", "~0").replaceAll("/", "~1"));
  return r;
};
sn.toPathArray = function(t) {
  const {
    cache: e
  } = sn;
  if (e[t])
    return e[t].concat();
  const n = [], o = t.replaceAll(/@(?:null|boolean|number|string|integer|undefined|nonFinite|scalar|array|object|function|other)\(\)/gu, ";$&;").replaceAll(/[['](\??\(.*?\))[\]'](?!.\])/gu, function(i, s) {
    return "[#" + (n.push(s) - 1) + "]";
  }).replaceAll(/\[['"]([^'\]]*)['"]\]/gu, function(i, s) {
    return "['" + s.replaceAll(".", "%@%").replaceAll("~", "%%@@%%") + "']";
  }).replaceAll("~", ";~;").replaceAll(/['"]?\.['"]?(?![^[]*\])|\[['"]?/gu, ";").replaceAll("%@%", ".").replaceAll("%%@@%%", "~").replaceAll(/(?:;)?(\^+)(?:;)?/gu, function(i, s) {
    return ";" + s.split("").join(";") + ";";
  }).replaceAll(/;;;|;;/gu, ";..;").replaceAll(/;$|'?\]|'$/gu, "").split(";").map(function(i) {
    const s = i.match(/#(\d+)/u);
    return !s || !s[1] ? i : n[s[1]];
  });
  return e[t] = o, e[t].concat();
};
sn.prototype.safeVm = {
  Script: yCt
};
const bCt = function(t, e, n) {
  const r = t.length;
  for (let o = 0; o < r; o++) {
    const i = t[o];
    n(i) && e.push(t.splice(o--, 1)[0]);
  }
};
class _Ct {
  /**
   * @param {string} expr Expression to evaluate
   */
  constructor(e) {
    this.code = e;
  }
  /**
   * @param {object} context Object whose items will be added
   *   to evaluation
   * @returns {EvaluatedResult} Result of evaluated code
   */
  runInNewContext(e) {
    let n = this.code;
    const r = Object.keys(e), o = [];
    bCt(r, o, (c) => typeof e[c] == "function");
    const i = r.map((c) => e[c]);
    n = o.reduce((c, u) => {
      let d = e[u].toString();
      return /function/u.test(d) || (d = "function " + d), "var " + u + "=" + d + ";" + c;
    }, "") + n, !/(['"])use strict\1/u.test(n) && !r.includes("arguments") && (n = "var arguments = undefined;" + n), n = n.replace(/;\s*$/u, "");
    const a = n.lastIndexOf(";"), l = a !== -1 ? n.slice(0, a + 1) + " return " + n.slice(a + 1) : " return " + n;
    return new Function(...r, l)(...i);
  }
}
sn.prototype.vm = {
  Script: _Ct
};
/*!
 * https://github.com/Starcounter-Jack/JSON-Patch
 * (c) 2017-2022 Joachim Wester
 * MIT licensed
 */
var wCt = /* @__PURE__ */ function() {
  var t = function(e, n) {
    return t = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, o) {
      r.__proto__ = o;
    } || function(r, o) {
      for (var i in o) o.hasOwnProperty(i) && (r[i] = o[i]);
    }, t(e, n);
  };
  return function(e, n) {
    t(e, n);
    function r() {
      this.constructor = e;
    }
    e.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), xCt = Object.prototype.hasOwnProperty;
function T3(t, e) {
  return xCt.call(t, e);
}
function R3(t) {
  if (Array.isArray(t)) {
    for (var e = new Array(t.length), n = 0; n < e.length; n++)
      e[n] = "" + n;
    return e;
  }
  if (Object.keys)
    return Object.keys(t);
  var r = [];
  for (var o in t)
    T3(t, o) && r.push(o);
  return r;
}
function xi(t) {
  switch (typeof t) {
    case "object":
      return JSON.parse(JSON.stringify(t));
    //Faster than ES5 clone - http://jsperf.com/deep-cloning-of-objects/5
    case "undefined":
      return null;
    //this is how JSON.stringify behaves for array items
    default:
      return t;
  }
}
function P3(t) {
  for (var e = 0, n = t.length, r; e < n; ) {
    if (r = t.charCodeAt(e), r >= 48 && r <= 57) {
      e++;
      continue;
    }
    return !1;
  }
  return !0;
}
function Yu(t) {
  return t.indexOf("/") === -1 && t.indexOf("~") === -1 ? t : t.replace(/~/g, "~0").replace(/\//g, "~1");
}
function Swe(t) {
  return t.replace(/~1/g, "/").replace(/~0/g, "~");
}
function $3(t) {
  if (t === void 0)
    return !0;
  if (t) {
    if (Array.isArray(t)) {
      for (var e = 0, n = t.length; e < n; e++)
        if ($3(t[e]))
          return !0;
    } else if (typeof t == "object") {
      for (var r = R3(t), o = r.length, i = 0; i < o; i++)
        if ($3(t[r[i]]))
          return !0;
    }
  }
  return !1;
}
function Gie(t, e) {
  var n = [t];
  for (var r in e) {
    var o = typeof e[r] == "object" ? JSON.stringify(e[r], null, 2) : e[r];
    typeof o < "u" && n.push(r + ": " + o);
  }
  return n.join(`
`);
}
var Owe = (
  /** @class */
  function(t) {
    wCt(e, t);
    function e(n, r, o, i, s) {
      var a = this.constructor, l = t.call(this, Gie(n, { name: r, index: o, operation: i, tree: s })) || this;
      return l.name = r, l.index = o, l.operation = i, l.tree = s, Object.setPrototypeOf(l, a.prototype), l.message = Gie(n, { name: r, index: o, operation: i, tree: s }), l;
    }
    return e;
  }(Error)
), dr = Owe, ECt = xi, lh = {
  add: function(t, e, n) {
    return t[e] = this.value, { newDocument: n };
  },
  remove: function(t, e, n) {
    var r = t[e];
    return delete t[e], { newDocument: n, removed: r };
  },
  replace: function(t, e, n) {
    var r = t[e];
    return t[e] = this.value, { newDocument: n, removed: r };
  },
  move: function(t, e, n) {
    var r = WE(n, this.path);
    r && (r = xi(r));
    var o = Od(n, { op: "remove", path: this.from }).removed;
    return Od(n, { op: "add", path: this.path, value: o }), { newDocument: n, removed: r };
  },
  copy: function(t, e, n) {
    var r = WE(n, this.from);
    return Od(n, { op: "add", path: this.path, value: xi(r) }), { newDocument: n };
  },
  test: function(t, e, n) {
    return { newDocument: n, test: Wy(t[e], this.value) };
  },
  _get: function(t, e, n) {
    return this.value = t[e], { newDocument: n };
  }
}, SCt = {
  add: function(t, e, n) {
    return P3(e) ? t.splice(e, 0, this.value) : t[e] = this.value, { newDocument: n, index: e };
  },
  remove: function(t, e, n) {
    var r = t.splice(e, 1);
    return { newDocument: n, removed: r[0] };
  },
  replace: function(t, e, n) {
    var r = t[e];
    return t[e] = this.value, { newDocument: n, removed: r };
  },
  move: lh.move,
  copy: lh.copy,
  test: lh.test,
  _get: lh._get
};
function WE(t, e) {
  if (e == "")
    return t;
  var n = { op: "_get", path: e };
  return Od(t, n), n.value;
}
function Od(t, e, n, r, o, i) {
  if (n === void 0 && (n = !1), r === void 0 && (r = !0), o === void 0 && (o = !0), i === void 0 && (i = 0), n && (typeof n == "function" ? n(e, 0, t, e.path) : GE(e, 0)), e.path === "") {
    var s = { newDocument: t };
    if (e.op === "add")
      return s.newDocument = e.value, s;
    if (e.op === "replace")
      return s.newDocument = e.value, s.removed = t, s;
    if (e.op === "move" || e.op === "copy")
      return s.newDocument = WE(t, e.from), e.op === "move" && (s.removed = t), s;
    if (e.op === "test") {
      if (s.test = Wy(t, e.value), s.test === !1)
        throw new dr("Test operation failed", "TEST_OPERATION_FAILED", i, e, t);
      return s.newDocument = t, s;
    } else {
      if (e.op === "remove")
        return s.removed = t, s.newDocument = null, s;
      if (e.op === "_get")
        return e.value = t, s;
      if (n)
        throw new dr("Operation `op` property is not one of operations defined in RFC-6902", "OPERATION_OP_INVALID", i, e, t);
      return s;
    }
  } else {
    r || (t = xi(t));
    var a = e.path || "", l = a.split("/"), c = t, u = 1, d = l.length, f = void 0, h = void 0, p = void 0;
    for (typeof n == "function" ? p = n : p = GE; ; ) {
      if (h = l[u], h && h.indexOf("~") != -1 && (h = Swe(h)), o && (h == "__proto__" || h == "prototype" && u > 0 && l[u - 1] == "constructor"))
        throw new TypeError("JSON-Patch: modifying `__proto__` or `constructor/prototype` prop is banned for security reasons, if this was on purpose, please set `banPrototypeModifications` flag false and pass it to this function. More info in fast-json-patch README");
      if (n && f === void 0 && (c[h] === void 0 ? f = l.slice(0, u).join("/") : u == d - 1 && (f = e.path), f !== void 0 && p(e, 0, t, f)), u++, Array.isArray(c)) {
        if (h === "-")
          h = c.length;
        else {
          if (n && !P3(h))
            throw new dr("Expected an unsigned base-10 integer value, making the new referenced value the array element with the zero-based index", "OPERATION_PATH_ILLEGAL_ARRAY_INDEX", i, e, t);
          P3(h) && (h = ~~h);
        }
        if (u >= d) {
          if (n && e.op === "add" && h > c.length)
            throw new dr("The specified index MUST NOT be greater than the number of elements in the array", "OPERATION_VALUE_OUT_OF_BOUNDS", i, e, t);
          var s = SCt[e.op].call(e, c, h, t);
          if (s.test === !1)
            throw new dr("Test operation failed", "TEST_OPERATION_FAILED", i, e, t);
          return s;
        }
      } else if (u >= d) {
        var s = lh[e.op].call(e, c, h, t);
        if (s.test === !1)
          throw new dr("Test operation failed", "TEST_OPERATION_FAILED", i, e, t);
        return s;
      }
      if (c = c[h], n && u < d && (!c || typeof c != "object"))
        throw new dr("Cannot perform operation at the desired path", "OPERATION_PATH_UNRESOLVABLE", i, e, t);
    }
  }
}
function x9(t, e, n, r, o) {
  if (r === void 0 && (r = !0), o === void 0 && (o = !0), n && !Array.isArray(e))
    throw new dr("Patch sequence must be an array", "SEQUENCE_NOT_AN_ARRAY");
  r || (t = xi(t));
  for (var i = new Array(e.length), s = 0, a = e.length; s < a; s++)
    i[s] = Od(t, e[s], n, !0, o, s), t = i[s].newDocument;
  return i.newDocument = t, i;
}
function OCt(t, e, n) {
  var r = Od(t, e);
  if (r.test === !1)
    throw new dr("Test operation failed", "TEST_OPERATION_FAILED", n, e, t);
  return r.newDocument;
}
function GE(t, e, n, r) {
  if (typeof t != "object" || t === null || Array.isArray(t))
    throw new dr("Operation is not an object", "OPERATION_NOT_AN_OBJECT", e, t, n);
  if (lh[t.op]) {
    if (typeof t.path != "string")
      throw new dr("Operation `path` property is not a string", "OPERATION_PATH_INVALID", e, t, n);
    if (t.path.indexOf("/") !== 0 && t.path.length > 0)
      throw new dr('Operation `path` property must start with "/"', "OPERATION_PATH_INVALID", e, t, n);
    if ((t.op === "move" || t.op === "copy") && typeof t.from != "string")
      throw new dr("Operation `from` property is not present (applicable in `move` and `copy` operations)", "OPERATION_FROM_REQUIRED", e, t, n);
    if ((t.op === "add" || t.op === "replace" || t.op === "test") && t.value === void 0)
      throw new dr("Operation `value` property is not present (applicable in `add`, `replace` and `test` operations)", "OPERATION_VALUE_REQUIRED", e, t, n);
    if ((t.op === "add" || t.op === "replace" || t.op === "test") && $3(t.value))
      throw new dr("Operation `value` property is not present (applicable in `add`, `replace` and `test` operations)", "OPERATION_VALUE_CANNOT_CONTAIN_UNDEFINED", e, t, n);
    if (n) {
      if (t.op == "add") {
        var o = t.path.split("/").length, i = r.split("/").length;
        if (o !== i + 1 && o !== i)
          throw new dr("Cannot perform an `add` operation at the desired path", "OPERATION_PATH_CANNOT_ADD", e, t, n);
      } else if (t.op === "replace" || t.op === "remove" || t.op === "_get") {
        if (t.path !== r)
          throw new dr("Cannot perform the operation at a path that does not exist", "OPERATION_PATH_UNRESOLVABLE", e, t, n);
      } else if (t.op === "move" || t.op === "copy") {
        var s = { op: "_get", path: t.from, value: void 0 }, a = Cwe([s], n);
        if (a && a.name === "OPERATION_PATH_UNRESOLVABLE")
          throw new dr("Cannot perform the operation from a path that does not exist", "OPERATION_FROM_UNRESOLVABLE", e, t, n);
      }
    }
  } else throw new dr("Operation `op` property is not one of operations defined in RFC-6902", "OPERATION_OP_INVALID", e, t, n);
}
function Cwe(t, e, n) {
  try {
    if (!Array.isArray(t))
      throw new dr("Patch sequence must be an array", "SEQUENCE_NOT_AN_ARRAY");
    if (e)
      x9(xi(e), xi(t), n || !0);
    else {
      n = n || GE;
      for (var r = 0; r < t.length; r++)
        n(t[r], r, e, void 0);
    }
  } catch (o) {
    if (o instanceof dr)
      return o;
    throw o;
  }
}
function Wy(t, e) {
  if (t === e)
    return !0;
  if (t && e && typeof t == "object" && typeof e == "object") {
    var n = Array.isArray(t), r = Array.isArray(e), o, i, s;
    if (n && r) {
      if (i = t.length, i != e.length)
        return !1;
      for (o = i; o-- !== 0; )
        if (!Wy(t[o], e[o]))
          return !1;
      return !0;
    }
    if (n != r)
      return !1;
    var a = Object.keys(t);
    if (i = a.length, i !== Object.keys(e).length)
      return !1;
    for (o = i; o-- !== 0; )
      if (!e.hasOwnProperty(a[o]))
        return !1;
    for (o = i; o-- !== 0; )
      if (s = a[o], !Wy(t[s], e[s]))
        return !1;
    return !0;
  }
  return t !== t && e !== e;
}
const CCt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  JsonPatchError: dr,
  _areEquals: Wy,
  applyOperation: Od,
  applyPatch: x9,
  applyReducer: OCt,
  deepClone: ECt,
  getValueByPointer: WE,
  validate: Cwe,
  validator: GE
}, Symbol.toStringTag, { value: "Module" }));
/*!
 * https://github.com/Starcounter-Jack/JSON-Patch
 * (c) 2017-2021 Joachim Wester
 * MIT license
 */
var E9 = /* @__PURE__ */ new WeakMap(), kCt = (
  /** @class */
  /* @__PURE__ */ function() {
    function t(e) {
      this.observers = /* @__PURE__ */ new Map(), this.obj = e;
    }
    return t;
  }()
), ACt = (
  /** @class */
  /* @__PURE__ */ function() {
    function t(e, n) {
      this.callback = e, this.observer = n;
    }
    return t;
  }()
);
function TCt(t) {
  return E9.get(t);
}
function RCt(t, e) {
  return t.observers.get(e);
}
function PCt(t, e) {
  t.observers.delete(e.callback);
}
function $Ct(t, e) {
  e.unobserve();
}
function MCt(t, e) {
  var n = [], r, o = TCt(t);
  if (!o)
    o = new kCt(t), E9.set(t, o);
  else {
    var i = RCt(o, e);
    r = i && i.observer;
  }
  if (r)
    return r;
  if (r = {}, o.value = xi(t), e) {
    r.callback = e, r.next = null;
    var s = function() {
      M3(r);
    }, a = function() {
      clearTimeout(r.next), r.next = setTimeout(s);
    };
    typeof window < "u" && (window.addEventListener("mouseup", a), window.addEventListener("keyup", a), window.addEventListener("mousedown", a), window.addEventListener("keydown", a), window.addEventListener("change", a));
  }
  return r.patches = n, r.object = t, r.unobserve = function() {
    M3(r), clearTimeout(r.next), PCt(o, r), typeof window < "u" && (window.removeEventListener("mouseup", a), window.removeEventListener("keyup", a), window.removeEventListener("mousedown", a), window.removeEventListener("keydown", a), window.removeEventListener("change", a));
  }, o.observers.set(e, new ACt(e, r)), r;
}
function M3(t, e) {
  e === void 0 && (e = !1);
  var n = E9.get(t.object);
  S9(n.value, t.object, t.patches, "", e), t.patches.length && x9(n.value, t.patches);
  var r = t.patches;
  return r.length > 0 && (t.patches = [], t.callback && t.callback(r)), r;
}
function S9(t, e, n, r, o) {
  if (e !== t) {
    typeof e.toJSON == "function" && (e = e.toJSON());
    for (var i = R3(e), s = R3(t), a = !1, l = s.length - 1; l >= 0; l--) {
      var c = s[l], u = t[c];
      if (T3(e, c) && !(e[c] === void 0 && u !== void 0 && Array.isArray(e) === !1)) {
        var d = e[c];
        typeof u == "object" && u != null && typeof d == "object" && d != null && Array.isArray(u) === Array.isArray(d) ? S9(u, d, n, r + "/" + Yu(c), o) : u !== d && (o && n.push({ op: "test", path: r + "/" + Yu(c), value: xi(u) }), n.push({ op: "replace", path: r + "/" + Yu(c), value: xi(d) }));
      } else Array.isArray(t) === Array.isArray(e) ? (o && n.push({ op: "test", path: r + "/" + Yu(c), value: xi(u) }), n.push({ op: "remove", path: r + "/" + Yu(c) }), a = !0) : (o && n.push({ op: "test", path: r, value: t }), n.push({ op: "replace", path: r, value: e }));
    }
    if (!(!a && i.length == s.length))
      for (var l = 0; l < i.length; l++) {
        var c = i[l];
        !T3(t, c) && e[c] !== void 0 && n.push({ op: "add", path: r + "/" + Yu(c), value: xi(e[c]) });
      }
  }
}
function DCt(t, e, n) {
  n === void 0 && (n = !1);
  var r = [];
  return S9(t, e, r, "", n), r;
}
const ICt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  compare: DCt,
  generate: M3,
  observe: MCt,
  unobserve: $Ct
}, Symbol.toStringTag, { value: "Module" }));
Object.assign({}, CCt, ICt, {
  JsonPatchError: Owe,
  deepClone: xi,
  escapePathComponent: Yu,
  unescapePathComponent: Swe
});
var ED = { exports: {} }, ng = {}, Fg = { exports: {} }, NCt = Fg.exports, Yie;
function O9() {
  return Yie || (Yie = 1, function(t, e) {
    (function(n, r) {
      r(e);
    })(NCt, function(n) {
      function r(W) {
        return function(ee, Y, L, V, K, ne, ce) {
          return W(ee, Y, ce);
        };
      }
      function o(W) {
        return function(ee, Y, L, V) {
          if (!ee || !Y || typeof ee != "object" || typeof Y != "object")
            return W(ee, Y, L, V);
          var K = V.get(ee), ne = V.get(Y);
          if (K && ne)
            return K === Y && ne === ee;
          V.set(ee, Y), V.set(Y, ee);
          var ce = W(ee, Y, L, V);
          return V.delete(ee), V.delete(Y), ce;
        };
      }
      function i(W, G) {
        var ee = {};
        for (var Y in W)
          ee[Y] = W[Y];
        for (var Y in G)
          ee[Y] = G[Y];
        return ee;
      }
      function s(W) {
        return W.constructor === Object || W.constructor == null;
      }
      function a(W) {
        return typeof W.then == "function";
      }
      function l(W, G) {
        return W === G || W !== W && G !== G;
      }
      var c = "[object Arguments]", u = "[object Boolean]", d = "[object Date]", f = "[object RegExp]", h = "[object Map]", p = "[object Number]", m = "[object Object]", g = "[object Set]", y = "[object String]", v = Object.prototype.toString;
      function b(W) {
        var G = W.areArraysEqual, ee = W.areDatesEqual, Y = W.areMapsEqual, L = W.areObjectsEqual, V = W.areRegExpsEqual, K = W.areSetsEqual, ne = W.createIsNestedEqual, ce = ne(fe);
        function fe(ve, _e, Ee) {
          if (ve === _e)
            return !0;
          if (!ve || !_e || typeof ve != "object" || typeof _e != "object")
            return ve !== ve && _e !== _e;
          if (s(ve) && s(_e))
            return L(ve, _e, ce, Ee);
          var Me = Array.isArray(ve), Le = Array.isArray(_e);
          if (Me || Le)
            return Me === Le && G(ve, _e, ce, Ee);
          var Ce = v.call(ve);
          return Ce !== v.call(_e) ? !1 : Ce === d ? ee(ve, _e, ce, Ee) : Ce === f ? V(ve, _e, ce, Ee) : Ce === h ? Y(ve, _e, ce, Ee) : Ce === g ? K(ve, _e, ce, Ee) : Ce === m || Ce === c ? a(ve) || a(_e) ? !1 : L(ve, _e, ce, Ee) : Ce === u || Ce === p || Ce === y ? l(ve.valueOf(), _e.valueOf()) : !1;
        }
        return fe;
      }
      function _(W, G, ee, Y) {
        var L = W.length;
        if (G.length !== L)
          return !1;
        for (; L-- > 0; )
          if (!ee(W[L], G[L], L, L, W, G, Y))
            return !1;
        return !0;
      }
      var w = o(_);
      function x(W, G) {
        return l(W.valueOf(), G.valueOf());
      }
      function E(W, G, ee, Y) {
        var L = W.size === G.size;
        if (!L)
          return !1;
        if (!W.size)
          return !0;
        var V = {}, K = 0;
        return W.forEach(function(ne, ce) {
          if (L) {
            var fe = !1, ve = 0;
            G.forEach(function(_e, Ee) {
              !fe && !V[ve] && (fe = ee(ce, Ee, K, ve, W, G, Y) && ee(ne, _e, ce, Ee, W, G, Y)) && (V[ve] = !0), ve++;
            }), K++, L = fe;
          }
        }), L;
      }
      var S = o(E), C = "_owner", R = Object.prototype.hasOwnProperty;
      function P(W, G, ee, Y) {
        var L = Object.keys(W), V = L.length;
        if (Object.keys(G).length !== V)
          return !1;
        for (var K; V-- > 0; ) {
          if (K = L[V], K === C) {
            var ne = !!W.$$typeof, ce = !!G.$$typeof;
            if ((ne || ce) && ne !== ce)
              return !1;
          }
          if (!R.call(G, K) || !ee(W[K], G[K], K, K, W, G, Y))
            return !1;
        }
        return !0;
      }
      var N = o(P);
      function A(W, G) {
        return W.source === G.source && W.flags === G.flags;
      }
      function O(W, G, ee, Y) {
        var L = W.size === G.size;
        if (!L)
          return !1;
        if (!W.size)
          return !0;
        var V = {};
        return W.forEach(function(K, ne) {
          if (L) {
            var ce = !1, fe = 0;
            G.forEach(function(ve, _e) {
              !ce && !V[fe] && (ce = ee(K, ve, ne, _e, W, G, Y)) && (V[fe] = !0), fe++;
            }), L = ce;
          }
        }), L;
      }
      var k = o(O), T = Object.freeze({
        areArraysEqual: _,
        areDatesEqual: x,
        areMapsEqual: E,
        areObjectsEqual: P,
        areRegExpsEqual: A,
        areSetsEqual: O,
        createIsNestedEqual: r
      }), I = Object.freeze({
        areArraysEqual: w,
        areDatesEqual: x,
        areMapsEqual: S,
        areObjectsEqual: N,
        areRegExpsEqual: A,
        areSetsEqual: k,
        createIsNestedEqual: r
      }), j = b(T);
      function z(W, G) {
        return j(W, G, void 0);
      }
      var $ = b(i(T, { createIsNestedEqual: function() {
        return l;
      } }));
      function D(W, G) {
        return $(W, G, void 0);
      }
      var U = b(I);
      function q(W, G) {
        return U(W, G, /* @__PURE__ */ new WeakMap());
      }
      var F = b(i(I, {
        createIsNestedEqual: function() {
          return l;
        }
      }));
      function B(W, G) {
        return F(W, G, /* @__PURE__ */ new WeakMap());
      }
      function H(W) {
        return b(i(T, W(T)));
      }
      function Z(W) {
        var G = b(i(I, W(I)));
        return function(ee, Y, L) {
          return L === void 0 && (L = /* @__PURE__ */ new WeakMap()), G(ee, Y, L);
        };
      }
      n.circularDeepEqual = q, n.circularShallowEqual = B, n.createCustomCircularEqual = Z, n.createCustomEqual = H, n.deepEqual = z, n.sameValueZeroEqual = l, n.shallowEqual = D, Object.defineProperty(n, "__esModule", { value: !0 });
    });
  }(Fg, Fg.exports)), Fg.exports;
}
var P_ = { exports: {} }, Kie;
function C9() {
  if (Kie) return P_.exports;
  Kie = 1;
  function t(n) {
    var r, o, i = "";
    if (typeof n == "string" || typeof n == "number") i += n;
    else if (typeof n == "object") if (Array.isArray(n)) {
      var s = n.length;
      for (r = 0; r < s; r++) n[r] && (o = t(n[r])) && (i && (i += " "), i += o);
    } else for (o in n) n[o] && (i && (i += " "), i += o);
    return i;
  }
  function e() {
    for (var n, r, o = 0, i = "", s = arguments.length; o < s; o++) (n = arguments[o]) && (r = t(n)) && (i && (i += " "), i += r);
    return i;
  }
  return P_.exports = e, P_.exports.clsx = e, P_.exports;
}
var Vt = {}, SD, Xie;
function jCt() {
  return Xie || (Xie = 1, SD = function(e, n, r) {
    return e === n ? !0 : e.className === n.className && r(e.style, n.style) && e.width === n.width && e.autoSize === n.autoSize && e.cols === n.cols && e.draggableCancel === n.draggableCancel && e.draggableHandle === n.draggableHandle && r(e.verticalCompact, n.verticalCompact) && r(e.compactType, n.compactType) && r(e.layout, n.layout) && r(e.margin, n.margin) && r(e.containerPadding, n.containerPadding) && e.rowHeight === n.rowHeight && e.maxRows === n.maxRows && e.isBounded === n.isBounded && e.isDraggable === n.isDraggable && e.isResizable === n.isResizable && e.allowOverlap === n.allowOverlap && e.preventCollision === n.preventCollision && e.useCSSTransforms === n.useCSSTransforms && e.transformScale === n.transformScale && e.isDroppable === n.isDroppable && r(e.resizeHandles, n.resizeHandles) && r(e.resizeHandle, n.resizeHandle) && e.onLayoutChange === n.onLayoutChange && e.onDragStart === n.onDragStart && e.onDrag === n.onDrag && e.onDragStop === n.onDragStop && e.onResizeStart === n.onResizeStart && e.onResize === n.onResize && e.onResizeStop === n.onResizeStop && e.onDrop === n.onDrop && r(e.droppingItem, n.droppingItem) && r(e.innerRef, n.innerRef);
  }), SD;
}
var Qie;
function Vp() {
  if (Qie) return Vt;
  Qie = 1, Object.defineProperty(Vt, "__esModule", {
    value: !0
  }), Vt.bottom = o, Vt.childrenEqual = c, Vt.cloneLayout = i, Vt.cloneLayoutItem = l, Vt.collides = d, Vt.compact = f, Vt.compactItem = m, Vt.compactType = G, Vt.correctBounds = g, Vt.fastPositionEqual = u, Vt.fastRGLPropsEqual = void 0, Vt.getAllCollisions = b, Vt.getFirstCollision = v, Vt.getLayoutItem = y, Vt.getStatics = _, Vt.modifyLayout = s, Vt.moveElement = w, Vt.moveElementAwayFromCollision = x, Vt.noop = void 0, Vt.perc = E, Vt.resizeItemInDirection = D, Vt.setTopLeft = q, Vt.setTransform = U, Vt.sortLayoutItems = F, Vt.sortLayoutItemsByColRow = H, Vt.sortLayoutItemsByRowCol = B, Vt.synchronizeLayoutWithChildren = Z, Vt.validateLayout = W, Vt.withLayoutItem = a;
  var t = /* @__PURE__ */ O9(), e = n(xe);
  function n(L) {
    return L && L.__esModule ? L : { default: L };
  }
  const r = process.env.NODE_ENV === "production";
  function o(L) {
    let V = 0, K;
    for (let ne = 0, ce = L.length; ne < ce; ne++)
      K = L[ne].y + L[ne].h, K > V && (V = K);
    return V;
  }
  function i(L) {
    const V = Array(L.length);
    for (let K = 0, ne = L.length; K < ne; K++)
      V[K] = l(L[K]);
    return V;
  }
  function s(L, V) {
    const K = Array(L.length);
    for (let ne = 0, ce = L.length; ne < ce; ne++)
      V.i === L[ne].i ? K[ne] = V : K[ne] = L[ne];
    return K;
  }
  function a(L, V, K) {
    let ne = y(L, V);
    return ne ? (ne = K(l(ne)), L = s(L, ne), [L, ne]) : [L, null];
  }
  function l(L) {
    return {
      w: L.w,
      h: L.h,
      x: L.x,
      y: L.y,
      i: L.i,
      minW: L.minW,
      maxW: L.maxW,
      minH: L.minH,
      maxH: L.maxH,
      moved: !!L.moved,
      static: !!L.static,
      // These can be null/undefined
      isDraggable: L.isDraggable,
      isResizable: L.isResizable,
      resizeHandles: L.resizeHandles,
      isBounded: L.isBounded
    };
  }
  function c(L, V) {
    return (0, t.deepEqual)(e.default.Children.map(L, (K) => K?.key), e.default.Children.map(V, (K) => K?.key)) && (0, t.deepEqual)(e.default.Children.map(L, (K) => K?.props["data-grid"]), e.default.Children.map(V, (K) => K?.props["data-grid"]));
  }
  Vt.fastRGLPropsEqual = jCt();
  function u(L, V) {
    return L.left === V.left && L.top === V.top && L.width === V.width && L.height === V.height;
  }
  function d(L, V) {
    return !(L.i === V.i || L.x + L.w <= V.x || L.x >= V.x + V.w || L.y + L.h <= V.y || L.y >= V.y + V.h);
  }
  function f(L, V, K, ne) {
    const ce = _(L), fe = F(L, V), ve = Array(L.length);
    for (let _e = 0, Ee = fe.length; _e < Ee; _e++) {
      let Me = l(fe[_e]);
      Me.static || (Me = m(ce, Me, V, K, fe, ne), ce.push(Me)), ve[L.indexOf(fe[_e])] = Me, Me.moved = !1;
    }
    return ve;
  }
  const h = {
    x: "w",
    y: "h"
  };
  function p(L, V, K, ne) {
    const ce = h[ne];
    V[ne] += 1;
    const fe = L.map((ve) => ve.i).indexOf(V.i);
    for (let ve = fe + 1; ve < L.length; ve++) {
      const _e = L[ve];
      if (!_e.static) {
        if (_e.y > V.y + V.h) break;
        d(V, _e) && p(L, _e, K + V[ce], ne);
      }
    }
    V[ne] = K;
  }
  function m(L, V, K, ne, ce, fe) {
    const ve = K === "vertical", _e = K === "horizontal";
    if (ve)
      for (V.y = Math.min(o(L), V.y); V.y > 0 && !v(L, V); )
        V.y--;
    else if (_e)
      for (; V.x > 0 && !v(L, V); )
        V.x--;
    let Ee;
    for (; (Ee = v(L, V)) && !(K === null && fe); )
      if (_e ? p(ce, V, Ee.x + Ee.w, "x") : p(ce, V, Ee.y + Ee.h, "y"), _e && V.x + V.w > ne)
        for (V.x = ne - V.w, V.y++; V.x > 0 && !v(L, V); )
          V.x--;
    return V.y = Math.max(V.y, 0), V.x = Math.max(V.x, 0), V;
  }
  function g(L, V) {
    const K = _(L);
    for (let ne = 0, ce = L.length; ne < ce; ne++) {
      const fe = L[ne];
      if (fe.x + fe.w > V.cols && (fe.x = V.cols - fe.w), fe.x < 0 && (fe.x = 0, fe.w = V.cols), !fe.static) K.push(fe);
      else
        for (; v(K, fe); )
          fe.y++;
    }
    return L;
  }
  function y(L, V) {
    for (let K = 0, ne = L.length; K < ne; K++)
      if (L[K].i === V) return L[K];
  }
  function v(L, V) {
    for (let K = 0, ne = L.length; K < ne; K++)
      if (d(L[K], V)) return L[K];
  }
  function b(L, V) {
    return L.filter((K) => d(K, V));
  }
  function _(L) {
    return L.filter((V) => V.static);
  }
  function w(L, V, K, ne, ce, fe, ve, _e, Ee) {
    if (V.static && V.isDraggable !== !0 || V.y === ne && V.x === K) return L;
    `${V.i}${String(K)}${String(ne)}${V.x}${V.y}`;
    const Me = V.x, Le = V.y;
    typeof K == "number" && (V.x = K), typeof ne == "number" && (V.y = ne), V.moved = !0;
    let Ce = F(L, ve);
    (ve === "vertical" && typeof ne == "number" ? Le >= ne : ve === "horizontal" && typeof K == "number" ? Me >= K : !1) && (Ce = Ce.reverse());
    const Ie = b(Ce, V), nt = Ie.length > 0;
    if (nt && Ee)
      return i(L);
    if (nt && fe)
      return `${V.i}`, V.x = Me, V.y = Le, V.moved = !1, L;
    for (let ct = 0, mt = Ie.length; ct < mt; ct++) {
      const gt = Ie[ct];
      `${V.i}${V.x}${V.y}${gt.i}${gt.x}${gt.y}`, !gt.moved && (gt.static ? L = x(L, gt, V, ce, ve) : L = x(L, V, gt, ce, ve));
    }
    return L;
  }
  function x(L, V, K, ne, ce, fe) {
    const ve = ce === "horizontal", _e = ce === "vertical", Ee = V.static;
    if (ne) {
      ne = !1;
      const Ce = {
        x: ve ? Math.max(V.x - K.w, 0) : K.x,
        y: _e ? Math.max(V.y - K.h, 0) : K.y,
        w: K.w,
        h: K.h,
        i: "-1"
      }, Je = v(L, Ce), Ie = Je && Je.y + Je.h > V.y, nt = Je && V.x + V.w > Je.x;
      if (Je) {
        if (Ie && _e)
          return w(L, K, void 0, V.y + 1, ne, Ee, ce);
        if (Ie && ce == null)
          return V.y = K.y, K.y = K.y + K.h, L;
        if (nt && ve)
          return w(L, V, K.x, void 0, ne, Ee, ce);
      } else return `${K.i}${Ce.x}${Ce.y}`, w(L, K, ve ? Ce.x : void 0, _e ? Ce.y : void 0, ne, Ee, ce);
    }
    const Me = ve ? K.x + 1 : void 0, Le = _e ? K.y + 1 : void 0;
    return Me == null && Le == null ? L : w(L, K, ve ? K.x + 1 : void 0, _e ? K.y + 1 : void 0, ne, Ee, ce);
  }
  function E(L) {
    return L * 100 + "%";
  }
  const S = (L, V, K, ne) => L + K > ne ? V : K, C = (L, V, K) => L < 0 ? V : K, R = (L) => Math.max(0, L), P = (L) => Math.max(0, L), N = (L, V, K) => {
    let {
      left: ne,
      height: ce,
      width: fe
    } = V;
    const ve = L.top - (ce - L.height);
    return {
      left: ne,
      width: fe,
      height: C(ve, L.height, ce),
      top: P(ve)
    };
  }, A = (L, V, K) => {
    let {
      top: ne,
      left: ce,
      height: fe,
      width: ve
    } = V;
    return {
      top: ne,
      height: fe,
      width: S(L.left, L.width, ve, K),
      left: R(ce)
    };
  }, O = (L, V, K) => {
    let {
      top: ne,
      height: ce,
      width: fe
    } = V;
    const ve = L.left - (fe - L.width);
    return {
      height: ce,
      width: ve < 0 ? L.width : S(L.left, L.width, fe, K),
      top: P(ne),
      left: R(ve)
    };
  }, k = (L, V, K) => {
    let {
      top: ne,
      left: ce,
      height: fe,
      width: ve
    } = V;
    return {
      width: ve,
      left: ce,
      height: C(ne, L.height, fe),
      top: P(ne)
    };
  }, $ = {
    n: N,
    ne: function() {
      return N(arguments.length <= 0 ? void 0 : arguments[0], A(...arguments));
    },
    e: A,
    se: function() {
      return k(arguments.length <= 0 ? void 0 : arguments[0], A(...arguments));
    },
    s: k,
    sw: function() {
      return k(arguments.length <= 0 ? void 0 : arguments[0], O(...arguments));
    },
    w: O,
    nw: function() {
      return N(arguments.length <= 0 ? void 0 : arguments[0], O(...arguments));
    }
  };
  function D(L, V, K, ne) {
    const ce = $[L];
    return ce ? ce(V, {
      ...V,
      ...K
    }, ne) : K;
  }
  function U(L) {
    let {
      top: V,
      left: K,
      width: ne,
      height: ce
    } = L;
    const fe = `translate(${K}px,${V}px)`;
    return {
      transform: fe,
      WebkitTransform: fe,
      MozTransform: fe,
      msTransform: fe,
      OTransform: fe,
      width: `${ne}px`,
      height: `${ce}px`,
      position: "absolute"
    };
  }
  function q(L) {
    let {
      top: V,
      left: K,
      width: ne,
      height: ce
    } = L;
    return {
      top: `${V}px`,
      left: `${K}px`,
      width: `${ne}px`,
      height: `${ce}px`,
      position: "absolute"
    };
  }
  function F(L, V) {
    return V === "horizontal" ? H(L) : V === "vertical" ? B(L) : L;
  }
  function B(L) {
    return L.slice(0).sort(function(V, K) {
      return V.y > K.y || V.y === K.y && V.x > K.x ? 1 : V.y === K.y && V.x === K.x ? 0 : -1;
    });
  }
  function H(L) {
    return L.slice(0).sort(function(V, K) {
      return V.x > K.x || V.x === K.x && V.y > K.y ? 1 : -1;
    });
  }
  function Z(L, V, K, ne, ce) {
    L = L || [];
    const fe = [];
    e.default.Children.forEach(V, (_e) => {
      if (_e?.key == null) return;
      const Ee = y(L, String(_e.key)), Me = _e.props["data-grid"];
      Ee && Me == null ? fe.push(l(Ee)) : Me ? (r || W([Me], "ReactGridLayout.children"), fe.push(l({
        ...Me,
        i: _e.key
      }))) : fe.push(l({
        w: 1,
        h: 1,
        x: 0,
        y: o(fe),
        i: String(_e.key)
      }));
    });
    const ve = g(fe, {
      cols: K
    });
    return ce ? ve : f(ve, ne, K);
  }
  function W(L) {
    let V = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "Layout";
    const K = ["x", "y", "w", "h"];
    if (!Array.isArray(L)) throw new Error(V + " must be an array!");
    for (let ne = 0, ce = L.length; ne < ce; ne++) {
      const fe = L[ne];
      for (let ve = 0; ve < K.length; ve++) {
        const _e = K[ve], Ee = fe[_e];
        if (typeof Ee != "number" || Number.isNaN(Ee))
          throw new Error(`ReactGridLayout: ${V}[${ne}].${_e} must be a number! Received: ${Ee} (${typeof Ee})`);
      }
      if (typeof fe.i < "u" && typeof fe.i != "string")
        throw new Error(`ReactGridLayout: ${V}[${ne}].i must be a string! Received: ${fe.i} (${typeof fe.i})`);
    }
  }
  function G(L) {
    const {
      verticalCompact: V,
      compactType: K
    } = L || {};
    return V === !1 ? null : K;
  }
  function ee() {
  }
  const Y = () => {
  };
  return Vt.noop = Y, Vt;
}
var Za = {}, Zie;
function k9() {
  if (Zie) return Za;
  Zie = 1, Object.defineProperty(Za, "__esModule", {
    value: !0
  }), Za.calcGridColWidth = t, Za.calcGridItemPosition = n, Za.calcGridItemWHPx = e, Za.calcWH = o, Za.calcXY = r, Za.clamp = i;
  function t(s) {
    const {
      margin: a,
      containerPadding: l,
      containerWidth: c,
      cols: u
    } = s;
    return (c - a[0] * (u - 1) - l[0] * 2) / u;
  }
  function e(s, a, l) {
    return Number.isFinite(s) ? Math.round(a * s + Math.max(0, s - 1) * l) : s;
  }
  function n(s, a, l, c, u, d) {
    const {
      margin: f,
      containerPadding: h,
      rowHeight: p
    } = s, m = t(s), g = {};
    return d && d.resizing ? (g.width = Math.round(d.resizing.width), g.height = Math.round(d.resizing.height)) : (g.width = e(c, m, f[0]), g.height = e(u, p, f[1])), d && d.dragging ? (g.top = Math.round(d.dragging.top), g.left = Math.round(d.dragging.left)) : d && d.resizing && typeof d.resizing.top == "number" && typeof d.resizing.left == "number" ? (g.top = Math.round(d.resizing.top), g.left = Math.round(d.resizing.left)) : (g.top = Math.round((p + f[1]) * l + h[1]), g.left = Math.round((m + f[0]) * a + h[0])), g;
  }
  function r(s, a, l, c, u) {
    const {
      margin: d,
      containerPadding: f,
      cols: h,
      rowHeight: p,
      maxRows: m
    } = s, g = t(s);
    let y = Math.round((l - f[0]) / (g + d[0])), v = Math.round((a - f[1]) / (p + d[1]));
    return y = i(y, 0, h - c), v = i(v, 0, m - u), {
      x: y,
      y: v
    };
  }
  function o(s, a, l, c, u, d) {
    const {
      margin: f,
      maxRows: h,
      cols: p,
      rowHeight: m
    } = s, g = t(s);
    let y = Math.round((a + f[0]) / (g + f[0])), v = Math.round((l + f[1]) / (m + f[1])), b = i(y, 0, p - c), _ = i(v, 0, h - u);
    return ["sw", "w", "nw"].indexOf(d) !== -1 && (b = i(y, 0, p)), ["nw", "n", "ne"].indexOf(d) !== -1 && (_ = i(v, 0, h)), {
      w: b,
      h: _
    };
  }
  function i(s, a, l) {
    return Math.max(Math.min(s, l), a);
  }
  return Za;
}
var rg = {}, $_ = { exports: {} }, M_ = { exports: {} }, gn = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Jie;
function LCt() {
  if (Jie) return gn;
  Jie = 1;
  var t = typeof Symbol == "function" && Symbol.for, e = t ? Symbol.for("react.element") : 60103, n = t ? Symbol.for("react.portal") : 60106, r = t ? Symbol.for("react.fragment") : 60107, o = t ? Symbol.for("react.strict_mode") : 60108, i = t ? Symbol.for("react.profiler") : 60114, s = t ? Symbol.for("react.provider") : 60109, a = t ? Symbol.for("react.context") : 60110, l = t ? Symbol.for("react.async_mode") : 60111, c = t ? Symbol.for("react.concurrent_mode") : 60111, u = t ? Symbol.for("react.forward_ref") : 60112, d = t ? Symbol.for("react.suspense") : 60113, f = t ? Symbol.for("react.suspense_list") : 60120, h = t ? Symbol.for("react.memo") : 60115, p = t ? Symbol.for("react.lazy") : 60116, m = t ? Symbol.for("react.block") : 60121, g = t ? Symbol.for("react.fundamental") : 60117, y = t ? Symbol.for("react.responder") : 60118, v = t ? Symbol.for("react.scope") : 60119;
  function b(w) {
    if (typeof w == "object" && w !== null) {
      var x = w.$$typeof;
      switch (x) {
        case e:
          switch (w = w.type, w) {
            case l:
            case c:
            case r:
            case i:
            case o:
            case d:
              return w;
            default:
              switch (w = w && w.$$typeof, w) {
                case a:
                case u:
                case p:
                case h:
                case s:
                  return w;
                default:
                  return x;
              }
          }
        case n:
          return x;
      }
    }
  }
  function _(w) {
    return b(w) === c;
  }
  return gn.AsyncMode = l, gn.ConcurrentMode = c, gn.ContextConsumer = a, gn.ContextProvider = s, gn.Element = e, gn.ForwardRef = u, gn.Fragment = r, gn.Lazy = p, gn.Memo = h, gn.Portal = n, gn.Profiler = i, gn.StrictMode = o, gn.Suspense = d, gn.isAsyncMode = function(w) {
    return _(w) || b(w) === l;
  }, gn.isConcurrentMode = _, gn.isContextConsumer = function(w) {
    return b(w) === a;
  }, gn.isContextProvider = function(w) {
    return b(w) === s;
  }, gn.isElement = function(w) {
    return typeof w == "object" && w !== null && w.$$typeof === e;
  }, gn.isForwardRef = function(w) {
    return b(w) === u;
  }, gn.isFragment = function(w) {
    return b(w) === r;
  }, gn.isLazy = function(w) {
    return b(w) === p;
  }, gn.isMemo = function(w) {
    return b(w) === h;
  }, gn.isPortal = function(w) {
    return b(w) === n;
  }, gn.isProfiler = function(w) {
    return b(w) === i;
  }, gn.isStrictMode = function(w) {
    return b(w) === o;
  }, gn.isSuspense = function(w) {
    return b(w) === d;
  }, gn.isValidElementType = function(w) {
    return typeof w == "string" || typeof w == "function" || w === r || w === c || w === i || w === o || w === d || w === f || typeof w == "object" && w !== null && (w.$$typeof === p || w.$$typeof === h || w.$$typeof === s || w.$$typeof === a || w.$$typeof === u || w.$$typeof === g || w.$$typeof === y || w.$$typeof === v || w.$$typeof === m);
  }, gn.typeOf = b, gn;
}
var yn = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ese;
function FCt() {
  return ese || (ese = 1, process.env.NODE_ENV !== "production" && function() {
    var t = typeof Symbol == "function" && Symbol.for, e = t ? Symbol.for("react.element") : 60103, n = t ? Symbol.for("react.portal") : 60106, r = t ? Symbol.for("react.fragment") : 60107, o = t ? Symbol.for("react.strict_mode") : 60108, i = t ? Symbol.for("react.profiler") : 60114, s = t ? Symbol.for("react.provider") : 60109, a = t ? Symbol.for("react.context") : 60110, l = t ? Symbol.for("react.async_mode") : 60111, c = t ? Symbol.for("react.concurrent_mode") : 60111, u = t ? Symbol.for("react.forward_ref") : 60112, d = t ? Symbol.for("react.suspense") : 60113, f = t ? Symbol.for("react.suspense_list") : 60120, h = t ? Symbol.for("react.memo") : 60115, p = t ? Symbol.for("react.lazy") : 60116, m = t ? Symbol.for("react.block") : 60121, g = t ? Symbol.for("react.fundamental") : 60117, y = t ? Symbol.for("react.responder") : 60118, v = t ? Symbol.for("react.scope") : 60119;
    function b(L) {
      return typeof L == "string" || typeof L == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      L === r || L === c || L === i || L === o || L === d || L === f || typeof L == "object" && L !== null && (L.$$typeof === p || L.$$typeof === h || L.$$typeof === s || L.$$typeof === a || L.$$typeof === u || L.$$typeof === g || L.$$typeof === y || L.$$typeof === v || L.$$typeof === m);
    }
    function _(L) {
      if (typeof L == "object" && L !== null) {
        var V = L.$$typeof;
        switch (V) {
          case e:
            var K = L.type;
            switch (K) {
              case l:
              case c:
              case r:
              case i:
              case o:
              case d:
                return K;
              default:
                var ne = K && K.$$typeof;
                switch (ne) {
                  case a:
                  case u:
                  case p:
                  case h:
                  case s:
                    return ne;
                  default:
                    return V;
                }
            }
          case n:
            return V;
        }
      }
    }
    var w = l, x = c, E = a, S = s, C = e, R = u, P = r, N = p, A = h, O = n, k = i, T = o, I = d, j = !1;
    function z(L) {
      return j || (j = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), $(L) || _(L) === l;
    }
    function $(L) {
      return _(L) === c;
    }
    function D(L) {
      return _(L) === a;
    }
    function U(L) {
      return _(L) === s;
    }
    function q(L) {
      return typeof L == "object" && L !== null && L.$$typeof === e;
    }
    function F(L) {
      return _(L) === u;
    }
    function B(L) {
      return _(L) === r;
    }
    function H(L) {
      return _(L) === p;
    }
    function Z(L) {
      return _(L) === h;
    }
    function W(L) {
      return _(L) === n;
    }
    function G(L) {
      return _(L) === i;
    }
    function ee(L) {
      return _(L) === o;
    }
    function Y(L) {
      return _(L) === d;
    }
    yn.AsyncMode = w, yn.ConcurrentMode = x, yn.ContextConsumer = E, yn.ContextProvider = S, yn.Element = C, yn.ForwardRef = R, yn.Fragment = P, yn.Lazy = N, yn.Memo = A, yn.Portal = O, yn.Profiler = k, yn.StrictMode = T, yn.Suspense = I, yn.isAsyncMode = z, yn.isConcurrentMode = $, yn.isContextConsumer = D, yn.isContextProvider = U, yn.isElement = q, yn.isForwardRef = F, yn.isFragment = B, yn.isLazy = H, yn.isMemo = Z, yn.isPortal = W, yn.isProfiler = G, yn.isStrictMode = ee, yn.isSuspense = Y, yn.isValidElementType = b, yn.typeOf = _;
  }()), yn;
}
var tse;
function kwe() {
  return tse || (tse = 1, process.env.NODE_ENV === "production" ? M_.exports = LCt() : M_.exports = FCt()), M_.exports;
}
var OD, nse;
function A9() {
  if (nse) return OD;
  nse = 1;
  var t = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return OD = t, OD;
}
var CD, rse;
function Awe() {
  return rse || (rse = 1, CD = Function.call.bind(Object.prototype.hasOwnProperty)), CD;
}
var kD, ose;
function BCt() {
  if (ose) return kD;
  ose = 1;
  var t = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var e = /* @__PURE__ */ A9(), n = {}, r = /* @__PURE__ */ Awe();
    t = function(i) {
      var s = "Warning: " + i;
      typeof console < "u" && console.error(s);
      try {
        throw new Error(s);
      } catch {
      }
    };
  }
  function o(i, s, a, l, c) {
    if (process.env.NODE_ENV !== "production") {
      for (var u in i)
        if (r(i, u)) {
          var d;
          try {
            if (typeof i[u] != "function") {
              var f = Error(
                (l || "React class") + ": " + a + " type `" + u + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[u] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw f.name = "Invariant Violation", f;
            }
            d = i[u](s, u, l, a, null, e);
          } catch (p) {
            d = p;
          }
          if (d && !(d instanceof Error) && t(
            (l || "React class") + ": type specification of " + a + " `" + u + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof d + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), d instanceof Error && !(d.message in n)) {
            n[d.message] = !0;
            var h = c ? c() : "";
            t(
              "Failed " + a + " type: " + d.message + (h ?? "")
            );
          }
        }
    }
  }
  return o.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, kD = o, kD;
}
var AD, ise;
function zCt() {
  if (ise) return AD;
  ise = 1;
  var t = kwe(), e = F3(), n = /* @__PURE__ */ A9(), r = /* @__PURE__ */ Awe(), o = /* @__PURE__ */ BCt(), i = function() {
  };
  process.env.NODE_ENV !== "production" && (i = function(a) {
    var l = "Warning: " + a;
    typeof console < "u" && console.error(l);
    try {
      throw new Error(l);
    } catch {
    }
  });
  function s() {
    return null;
  }
  return AD = function(a, l) {
    var c = typeof Symbol == "function" && Symbol.iterator, u = "@@iterator";
    function d($) {
      var D = $ && (c && $[c] || $[u]);
      if (typeof D == "function")
        return D;
    }
    var f = "<<anonymous>>", h = {
      array: y("array"),
      bigint: y("bigint"),
      bool: y("boolean"),
      func: y("function"),
      number: y("number"),
      object: y("object"),
      string: y("string"),
      symbol: y("symbol"),
      any: v(),
      arrayOf: b,
      element: _(),
      elementType: w(),
      instanceOf: x,
      node: R(),
      objectOf: S,
      oneOf: E,
      oneOfType: C,
      shape: N,
      exact: A
    };
    function p($, D) {
      return $ === D ? $ !== 0 || 1 / $ === 1 / D : $ !== $ && D !== D;
    }
    function m($, D) {
      this.message = $, this.data = D && typeof D == "object" ? D : {}, this.stack = "";
    }
    m.prototype = Error.prototype;
    function g($) {
      if (process.env.NODE_ENV !== "production")
        var D = {}, U = 0;
      function q(B, H, Z, W, G, ee, Y) {
        if (W = W || f, ee = ee || Z, Y !== n) {
          if (l) {
            var L = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw L.name = "Invariant Violation", L;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var V = W + ":" + Z;
            !D[V] && // Avoid spamming the console because they are often not actionable except for lib authors
            U < 3 && (i(
              "You are manually calling a React.PropTypes validation function for the `" + ee + "` prop on `" + W + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), D[V] = !0, U++);
          }
        }
        return H[Z] == null ? B ? H[Z] === null ? new m("The " + G + " `" + ee + "` is marked as required " + ("in `" + W + "`, but its value is `null`.")) : new m("The " + G + " `" + ee + "` is marked as required in " + ("`" + W + "`, but its value is `undefined`.")) : null : $(H, Z, W, G, ee);
      }
      var F = q.bind(null, !1);
      return F.isRequired = q.bind(null, !0), F;
    }
    function y($) {
      function D(U, q, F, B, H, Z) {
        var W = U[q], G = T(W);
        if (G !== $) {
          var ee = I(W);
          return new m(
            "Invalid " + B + " `" + H + "` of type " + ("`" + ee + "` supplied to `" + F + "`, expected ") + ("`" + $ + "`."),
            { expectedType: $ }
          );
        }
        return null;
      }
      return g(D);
    }
    function v() {
      return g(s);
    }
    function b($) {
      function D(U, q, F, B, H) {
        if (typeof $ != "function")
          return new m("Property `" + H + "` of component `" + F + "` has invalid PropType notation inside arrayOf.");
        var Z = U[q];
        if (!Array.isArray(Z)) {
          var W = T(Z);
          return new m("Invalid " + B + " `" + H + "` of type " + ("`" + W + "` supplied to `" + F + "`, expected an array."));
        }
        for (var G = 0; G < Z.length; G++) {
          var ee = $(Z, G, F, B, H + "[" + G + "]", n);
          if (ee instanceof Error)
            return ee;
        }
        return null;
      }
      return g(D);
    }
    function _() {
      function $(D, U, q, F, B) {
        var H = D[U];
        if (!a(H)) {
          var Z = T(H);
          return new m("Invalid " + F + " `" + B + "` of type " + ("`" + Z + "` supplied to `" + q + "`, expected a single ReactElement."));
        }
        return null;
      }
      return g($);
    }
    function w() {
      function $(D, U, q, F, B) {
        var H = D[U];
        if (!t.isValidElementType(H)) {
          var Z = T(H);
          return new m("Invalid " + F + " `" + B + "` of type " + ("`" + Z + "` supplied to `" + q + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return g($);
    }
    function x($) {
      function D(U, q, F, B, H) {
        if (!(U[q] instanceof $)) {
          var Z = $.name || f, W = z(U[q]);
          return new m("Invalid " + B + " `" + H + "` of type " + ("`" + W + "` supplied to `" + F + "`, expected ") + ("instance of `" + Z + "`."));
        }
        return null;
      }
      return g(D);
    }
    function E($) {
      if (!Array.isArray($))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? i(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : i("Invalid argument supplied to oneOf, expected an array.")), s;
      function D(U, q, F, B, H) {
        for (var Z = U[q], W = 0; W < $.length; W++)
          if (p(Z, $[W]))
            return null;
        var G = JSON.stringify($, function(Y, L) {
          var V = I(L);
          return V === "symbol" ? String(L) : L;
        });
        return new m("Invalid " + B + " `" + H + "` of value `" + String(Z) + "` " + ("supplied to `" + F + "`, expected one of " + G + "."));
      }
      return g(D);
    }
    function S($) {
      function D(U, q, F, B, H) {
        if (typeof $ != "function")
          return new m("Property `" + H + "` of component `" + F + "` has invalid PropType notation inside objectOf.");
        var Z = U[q], W = T(Z);
        if (W !== "object")
          return new m("Invalid " + B + " `" + H + "` of type " + ("`" + W + "` supplied to `" + F + "`, expected an object."));
        for (var G in Z)
          if (r(Z, G)) {
            var ee = $(Z, G, F, B, H + "." + G, n);
            if (ee instanceof Error)
              return ee;
          }
        return null;
      }
      return g(D);
    }
    function C($) {
      if (!Array.isArray($))
        return process.env.NODE_ENV !== "production" && i("Invalid argument supplied to oneOfType, expected an instance of array."), s;
      for (var D = 0; D < $.length; D++) {
        var U = $[D];
        if (typeof U != "function")
          return i(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + j(U) + " at index " + D + "."
          ), s;
      }
      function q(F, B, H, Z, W) {
        for (var G = [], ee = 0; ee < $.length; ee++) {
          var Y = $[ee], L = Y(F, B, H, Z, W, n);
          if (L == null)
            return null;
          L.data && r(L.data, "expectedType") && G.push(L.data.expectedType);
        }
        var V = G.length > 0 ? ", expected one of type [" + G.join(", ") + "]" : "";
        return new m("Invalid " + Z + " `" + W + "` supplied to " + ("`" + H + "`" + V + "."));
      }
      return g(q);
    }
    function R() {
      function $(D, U, q, F, B) {
        return O(D[U]) ? null : new m("Invalid " + F + " `" + B + "` supplied to " + ("`" + q + "`, expected a ReactNode."));
      }
      return g($);
    }
    function P($, D, U, q, F) {
      return new m(
        ($ || "React class") + ": " + D + " type `" + U + "." + q + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + F + "`."
      );
    }
    function N($) {
      function D(U, q, F, B, H) {
        var Z = U[q], W = T(Z);
        if (W !== "object")
          return new m("Invalid " + B + " `" + H + "` of type `" + W + "` " + ("supplied to `" + F + "`, expected `object`."));
        for (var G in $) {
          var ee = $[G];
          if (typeof ee != "function")
            return P(F, B, H, G, I(ee));
          var Y = ee(Z, G, F, B, H + "." + G, n);
          if (Y)
            return Y;
        }
        return null;
      }
      return g(D);
    }
    function A($) {
      function D(U, q, F, B, H) {
        var Z = U[q], W = T(Z);
        if (W !== "object")
          return new m("Invalid " + B + " `" + H + "` of type `" + W + "` " + ("supplied to `" + F + "`, expected `object`."));
        var G = e({}, U[q], $);
        for (var ee in G) {
          var Y = $[ee];
          if (r($, ee) && typeof Y != "function")
            return P(F, B, H, ee, I(Y));
          if (!Y)
            return new m(
              "Invalid " + B + " `" + H + "` key `" + ee + "` supplied to `" + F + "`.\nBad object: " + JSON.stringify(U[q], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys($), null, "  ")
            );
          var L = Y(Z, ee, F, B, H + "." + ee, n);
          if (L)
            return L;
        }
        return null;
      }
      return g(D);
    }
    function O($) {
      switch (typeof $) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !$;
        case "object":
          if (Array.isArray($))
            return $.every(O);
          if ($ === null || a($))
            return !0;
          var D = d($);
          if (D) {
            var U = D.call($), q;
            if (D !== $.entries) {
              for (; !(q = U.next()).done; )
                if (!O(q.value))
                  return !1;
            } else
              for (; !(q = U.next()).done; ) {
                var F = q.value;
                if (F && !O(F[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function k($, D) {
      return $ === "symbol" ? !0 : D ? D["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && D instanceof Symbol : !1;
    }
    function T($) {
      var D = typeof $;
      return Array.isArray($) ? "array" : $ instanceof RegExp ? "object" : k(D, $) ? "symbol" : D;
    }
    function I($) {
      if (typeof $ > "u" || $ === null)
        return "" + $;
      var D = T($);
      if (D === "object") {
        if ($ instanceof Date)
          return "date";
        if ($ instanceof RegExp)
          return "regexp";
      }
      return D;
    }
    function j($) {
      var D = I($);
      switch (D) {
        case "array":
        case "object":
          return "an " + D;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + D;
        default:
          return D;
      }
    }
    function z($) {
      return !$.constructor || !$.constructor.name ? f : $.constructor.name;
    }
    return h.checkPropTypes = o, h.resetWarningCache = o.resetWarningCache, h.PropTypes = h, h;
  }, AD;
}
var TD, sse;
function qCt() {
  if (sse) return TD;
  sse = 1;
  var t = /* @__PURE__ */ A9();
  function e() {
  }
  function n() {
  }
  return n.resetWarningCache = e, TD = function() {
    function r(s, a, l, c, u, d) {
      if (d !== t) {
        var f = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw f.name = "Invariant Violation", f;
      }
    }
    r.isRequired = r;
    function o() {
      return r;
    }
    var i = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: o,
      element: r,
      elementType: r,
      instanceOf: o,
      node: r,
      objectOf: o,
      oneOf: o,
      oneOfType: o,
      shape: o,
      exact: o,
      checkPropTypes: n,
      resetWarningCache: e
    };
    return i.PropTypes = i, i;
  }, TD;
}
var ase;
function hu() {
  if (ase) return $_.exports;
  if (ase = 1, process.env.NODE_ENV !== "production") {
    var t = kwe(), e = !0;
    $_.exports = /* @__PURE__ */ zCt()(t.isElement, e);
  } else
    $_.exports = /* @__PURE__ */ qCt()();
  return $_.exports;
}
var og = { exports: {} }, RD = {};
function Twe(t) {
  var e, n, r = "";
  if (typeof t == "string" || typeof t == "number") r += t;
  else if (typeof t == "object") if (Array.isArray(t)) for (e = 0; e < t.length; e++) t[e] && (n = Twe(t[e])) && (r && (r += " "), r += n);
  else for (e in t) t[e] && (r && (r += " "), r += e);
  return r;
}
function lse() {
  for (var t, e, n = 0, r = ""; n < arguments.length; ) (t = arguments[n++]) && (e = Twe(t)) && (r && (r += " "), r += e);
  return r;
}
const UCt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  clsx: lse,
  default: lse
}, Symbol.toStringTag, { value: "Module" })), HCt = /* @__PURE__ */ Mse(UCt);
var gr = {}, dc = {}, cse;
function GO() {
  if (cse) return dc;
  cse = 1, Object.defineProperty(dc, "__esModule", {
    value: !0
  }), dc.dontSetMe = o, dc.findInArray = t, dc.int = r, dc.isFunction = e, dc.isNum = n;
  function t(i, s) {
    for (let a = 0, l = i.length; a < l; a++)
      if (s.apply(s, [i[a], a, i])) return i[a];
  }
  function e(i) {
    return typeof i == "function" || Object.prototype.toString.call(i) === "[object Function]";
  }
  function n(i) {
    return typeof i == "number" && !isNaN(i);
  }
  function r(i) {
    return parseInt(i, 10);
  }
  function o(i, s, a) {
    if (i[s])
      return new Error("Invalid prop ".concat(s, " passed to ").concat(a, " - do not set this, set it on the child."));
  }
  return dc;
}
var fc = {}, use;
function VCt() {
  if (use) return fc;
  use = 1, Object.defineProperty(fc, "__esModule", {
    value: !0
  }), fc.browserPrefixToKey = n, fc.browserPrefixToStyle = r, fc.default = void 0, fc.getPrefix = e;
  const t = ["Moz", "Webkit", "O", "ms"];
  function e() {
    var i;
    let s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "transform";
    if (typeof window > "u") return "";
    const a = (i = window.document) === null || i === void 0 || (i = i.documentElement) === null || i === void 0 ? void 0 : i.style;
    if (!a || s in a) return "";
    for (let l = 0; l < t.length; l++)
      if (n(s, t[l]) in a) return t[l];
    return "";
  }
  function n(i, s) {
    return s ? "".concat(s).concat(o(i)) : i;
  }
  function r(i, s) {
    return s ? "-".concat(s.toLowerCase(), "-").concat(i) : i;
  }
  function o(i) {
    let s = "", a = !0;
    for (let l = 0; l < i.length; l++)
      a ? (s += i[l].toUpperCase(), a = !1) : i[l] === "-" ? a = !0 : s += i[l];
    return s;
  }
  return fc.default = e(), fc;
}
var dse;
function T9() {
  if (dse) return gr;
  dse = 1, Object.defineProperty(gr, "__esModule", {
    value: !0
  }), gr.addClassName = w, gr.addEvent = a, gr.addUserSelectStyles = b, gr.createCSSTransform = p, gr.createSVGTransform = m, gr.getTouch = y, gr.getTouchIdentifier = v, gr.getTranslation = g, gr.innerHeight = d, gr.innerWidth = f, gr.matchesSelector = i, gr.matchesSelectorAndParentsTo = s, gr.offsetXYFromParent = h, gr.outerHeight = c, gr.outerWidth = u, gr.removeClassName = x, gr.removeEvent = l, gr.removeUserSelectStyles = _;
  var t = GO(), e = r(VCt());
  function n(E) {
    if (typeof WeakMap != "function") return null;
    var S = /* @__PURE__ */ new WeakMap(), C = /* @__PURE__ */ new WeakMap();
    return (n = function(R) {
      return R ? C : S;
    })(E);
  }
  function r(E, S) {
    if (E && E.__esModule)
      return E;
    if (E === null || typeof E != "object" && typeof E != "function")
      return { default: E };
    var C = n(S);
    if (C && C.has(E))
      return C.get(E);
    var R = {}, P = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var N in E)
      if (N !== "default" && Object.prototype.hasOwnProperty.call(E, N)) {
        var A = P ? Object.getOwnPropertyDescriptor(E, N) : null;
        A && (A.get || A.set) ? Object.defineProperty(R, N, A) : R[N] = E[N];
      }
    return R.default = E, C && C.set(E, R), R;
  }
  let o = "";
  function i(E, S) {
    return o || (o = (0, t.findInArray)(["matches", "webkitMatchesSelector", "mozMatchesSelector", "msMatchesSelector", "oMatchesSelector"], function(C) {
      return (0, t.isFunction)(E[C]);
    })), (0, t.isFunction)(E[o]) ? E[o](S) : !1;
  }
  function s(E, S, C) {
    let R = E;
    do {
      if (i(R, S)) return !0;
      if (R === C) return !1;
      R = R.parentNode;
    } while (R);
    return !1;
  }
  function a(E, S, C, R) {
    if (!E) return;
    const P = {
      capture: !0,
      ...R
    };
    E.addEventListener ? E.addEventListener(S, C, P) : E.attachEvent ? E.attachEvent("on" + S, C) : E["on" + S] = C;
  }
  function l(E, S, C, R) {
    if (!E) return;
    const P = {
      capture: !0,
      ...R
    };
    E.removeEventListener ? E.removeEventListener(S, C, P) : E.detachEvent ? E.detachEvent("on" + S, C) : E["on" + S] = null;
  }
  function c(E) {
    let S = E.clientHeight;
    const C = E.ownerDocument.defaultView.getComputedStyle(E);
    return S += (0, t.int)(C.borderTopWidth), S += (0, t.int)(C.borderBottomWidth), S;
  }
  function u(E) {
    let S = E.clientWidth;
    const C = E.ownerDocument.defaultView.getComputedStyle(E);
    return S += (0, t.int)(C.borderLeftWidth), S += (0, t.int)(C.borderRightWidth), S;
  }
  function d(E) {
    let S = E.clientHeight;
    const C = E.ownerDocument.defaultView.getComputedStyle(E);
    return S -= (0, t.int)(C.paddingTop), S -= (0, t.int)(C.paddingBottom), S;
  }
  function f(E) {
    let S = E.clientWidth;
    const C = E.ownerDocument.defaultView.getComputedStyle(E);
    return S -= (0, t.int)(C.paddingLeft), S -= (0, t.int)(C.paddingRight), S;
  }
  function h(E, S, C) {
    const P = S === S.ownerDocument.body ? {
      left: 0,
      top: 0
    } : S.getBoundingClientRect(), N = (E.clientX + S.scrollLeft - P.left) / C, A = (E.clientY + S.scrollTop - P.top) / C;
    return {
      x: N,
      y: A
    };
  }
  function p(E, S) {
    const C = g(E, S, "px");
    return {
      [(0, e.browserPrefixToKey)("transform", e.default)]: C
    };
  }
  function m(E, S) {
    return g(E, S, "");
  }
  function g(E, S, C) {
    let {
      x: R,
      y: P
    } = E, N = "translate(".concat(R).concat(C, ",").concat(P).concat(C, ")");
    if (S) {
      const A = "".concat(typeof S.x == "string" ? S.x : S.x + C), O = "".concat(typeof S.y == "string" ? S.y : S.y + C);
      N = "translate(".concat(A, ", ").concat(O, ")") + N;
    }
    return N;
  }
  function y(E, S) {
    return E.targetTouches && (0, t.findInArray)(E.targetTouches, (C) => S === C.identifier) || E.changedTouches && (0, t.findInArray)(E.changedTouches, (C) => S === C.identifier);
  }
  function v(E) {
    if (E.targetTouches && E.targetTouches[0]) return E.targetTouches[0].identifier;
    if (E.changedTouches && E.changedTouches[0]) return E.changedTouches[0].identifier;
  }
  function b(E) {
    if (!E) return;
    let S = E.getElementById("react-draggable-style-el");
    S || (S = E.createElement("style"), S.type = "text/css", S.id = "react-draggable-style-el", S.innerHTML = `.react-draggable-transparent-selection *::-moz-selection {all: inherit;}
`, S.innerHTML += `.react-draggable-transparent-selection *::selection {all: inherit;}
`, E.getElementsByTagName("head")[0].appendChild(S)), E.body && w(E.body, "react-draggable-transparent-selection");
  }
  function _(E) {
    if (E)
      try {
        if (E.body && x(E.body, "react-draggable-transparent-selection"), E.selection)
          E.selection.empty();
        else {
          const S = (E.defaultView || window).getSelection();
          S && S.type !== "Caret" && S.removeAllRanges();
        }
      } catch {
      }
  }
  function w(E, S) {
    E.classList ? E.classList.add(S) : E.className.match(new RegExp("(?:^|\\s)".concat(S, "(?!\\S)"))) || (E.className += " ".concat(S));
  }
  function x(E, S) {
    E.classList ? E.classList.remove(S) : E.className = E.className.replace(new RegExp("(?:^|\\s)".concat(S, "(?!\\S)"), "g"), "");
  }
  return gr;
}
var Ws = {}, fse;
function Rwe() {
  if (fse) return Ws;
  fse = 1, Object.defineProperty(Ws, "__esModule", {
    value: !0
  }), Ws.canDragX = o, Ws.canDragY = i, Ws.createCoreData = a, Ws.createDraggableData = l, Ws.getBoundPosition = n, Ws.getControlPosition = s, Ws.snapToGrid = r;
  var t = GO(), e = T9();
  function n(d, f, h) {
    if (!d.props.bounds) return [f, h];
    let {
      bounds: p
    } = d.props;
    p = typeof p == "string" ? p : c(p);
    const m = u(d);
    if (typeof p == "string") {
      const {
        ownerDocument: g
      } = m, y = g.defaultView;
      let v;
      if (p === "parent" ? v = m.parentNode : v = g.querySelector(p), !(v instanceof y.HTMLElement))
        throw new Error('Bounds selector "' + p + '" could not find an element.');
      const b = v, _ = y.getComputedStyle(m), w = y.getComputedStyle(b);
      p = {
        left: -m.offsetLeft + (0, t.int)(w.paddingLeft) + (0, t.int)(_.marginLeft),
        top: -m.offsetTop + (0, t.int)(w.paddingTop) + (0, t.int)(_.marginTop),
        right: (0, e.innerWidth)(b) - (0, e.outerWidth)(m) - m.offsetLeft + (0, t.int)(w.paddingRight) - (0, t.int)(_.marginRight),
        bottom: (0, e.innerHeight)(b) - (0, e.outerHeight)(m) - m.offsetTop + (0, t.int)(w.paddingBottom) - (0, t.int)(_.marginBottom)
      };
    }
    return (0, t.isNum)(p.right) && (f = Math.min(f, p.right)), (0, t.isNum)(p.bottom) && (h = Math.min(h, p.bottom)), (0, t.isNum)(p.left) && (f = Math.max(f, p.left)), (0, t.isNum)(p.top) && (h = Math.max(h, p.top)), [f, h];
  }
  function r(d, f, h) {
    const p = Math.round(f / d[0]) * d[0], m = Math.round(h / d[1]) * d[1];
    return [p, m];
  }
  function o(d) {
    return d.props.axis === "both" || d.props.axis === "x";
  }
  function i(d) {
    return d.props.axis === "both" || d.props.axis === "y";
  }
  function s(d, f, h) {
    const p = typeof f == "number" ? (0, e.getTouch)(d, f) : null;
    if (typeof f == "number" && !p) return null;
    const m = u(h), g = h.props.offsetParent || m.offsetParent || m.ownerDocument.body;
    return (0, e.offsetXYFromParent)(p || d, g, h.props.scale);
  }
  function a(d, f, h) {
    const p = !(0, t.isNum)(d.lastX), m = u(d);
    return p ? {
      node: m,
      deltaX: 0,
      deltaY: 0,
      lastX: f,
      lastY: h,
      x: f,
      y: h
    } : {
      node: m,
      deltaX: f - d.lastX,
      deltaY: h - d.lastY,
      lastX: d.lastX,
      lastY: d.lastY,
      x: f,
      y: h
    };
  }
  function l(d, f) {
    const h = d.props.scale;
    return {
      node: f.node,
      x: d.state.x + f.deltaX / h,
      y: d.state.y + f.deltaY / h,
      deltaX: f.deltaX / h,
      deltaY: f.deltaY / h,
      lastX: d.state.x,
      lastY: d.state.y
    };
  }
  function c(d) {
    return {
      left: d.left,
      top: d.top,
      right: d.right,
      bottom: d.bottom
    };
  }
  function u(d) {
    const f = d.findDOMNode();
    if (!f)
      throw new Error("<DraggableCore>: Unmounted during event!");
    return f;
  }
  return Ws;
}
var ig = {}, D_ = {}, hse;
function Pwe() {
  if (hse) return D_;
  hse = 1, Object.defineProperty(D_, "__esModule", {
    value: !0
  }), D_.default = t;
  function t() {
  }
  return D_;
}
var pse;
function WCt() {
  if (pse) return ig;
  pse = 1, Object.defineProperty(ig, "__esModule", {
    value: !0
  }), ig.default = void 0;
  var t = c(xe), e = a(/* @__PURE__ */ hu()), n = a(Kc), r = T9(), o = Rwe(), i = GO(), s = a(Pwe());
  function a(g) {
    return g && g.__esModule ? g : { default: g };
  }
  function l(g) {
    if (typeof WeakMap != "function") return null;
    var y = /* @__PURE__ */ new WeakMap(), v = /* @__PURE__ */ new WeakMap();
    return (l = function(b) {
      return b ? v : y;
    })(g);
  }
  function c(g, y) {
    if (g && g.__esModule)
      return g;
    if (g === null || typeof g != "object" && typeof g != "function")
      return { default: g };
    var v = l(y);
    if (v && v.has(g))
      return v.get(g);
    var b = {}, _ = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var w in g)
      if (w !== "default" && Object.prototype.hasOwnProperty.call(g, w)) {
        var x = _ ? Object.getOwnPropertyDescriptor(g, w) : null;
        x && (x.get || x.set) ? Object.defineProperty(b, w, x) : b[w] = g[w];
      }
    return b.default = g, v && v.set(g, b), b;
  }
  function u(g, y, v) {
    return y = d(y), y in g ? Object.defineProperty(g, y, { value: v, enumerable: !0, configurable: !0, writable: !0 }) : g[y] = v, g;
  }
  function d(g) {
    var y = f(g, "string");
    return typeof y == "symbol" ? y : String(y);
  }
  function f(g, y) {
    if (typeof g != "object" || g === null) return g;
    var v = g[Symbol.toPrimitive];
    if (v !== void 0) {
      var b = v.call(g, y || "default");
      if (typeof b != "object") return b;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (y === "string" ? String : Number)(g);
  }
  const h = {
    touch: {
      start: "touchstart",
      move: "touchmove",
      stop: "touchend"
    },
    mouse: {
      start: "mousedown",
      move: "mousemove",
      stop: "mouseup"
    }
  };
  let p = h.mouse, m = class extends t.Component {
    constructor() {
      super(...arguments), u(this, "dragging", !1), u(this, "lastX", NaN), u(this, "lastY", NaN), u(this, "touchIdentifier", null), u(this, "mounted", !1), u(this, "handleDragStart", (y) => {
        if (this.props.onMouseDown(y), !this.props.allowAnyClick && typeof y.button == "number" && y.button !== 0) return !1;
        const v = this.findDOMNode();
        if (!v || !v.ownerDocument || !v.ownerDocument.body)
          throw new Error("<DraggableCore> not mounted on DragStart!");
        const {
          ownerDocument: b
        } = v;
        if (this.props.disabled || !(y.target instanceof b.defaultView.Node) || this.props.handle && !(0, r.matchesSelectorAndParentsTo)(y.target, this.props.handle, v) || this.props.cancel && (0, r.matchesSelectorAndParentsTo)(y.target, this.props.cancel, v))
          return;
        y.type === "touchstart" && y.preventDefault();
        const _ = (0, r.getTouchIdentifier)(y);
        this.touchIdentifier = _;
        const w = (0, o.getControlPosition)(y, _, this);
        if (w == null) return;
        const {
          x,
          y: E
        } = w, S = (0, o.createCoreData)(this, x, E);
        (0, s.default)("DraggableCore: handleDragStart: %j", S), (0, s.default)("calling", this.props.onStart), !(this.props.onStart(y, S) === !1 || this.mounted === !1) && (this.props.enableUserSelectHack && (0, r.addUserSelectStyles)(b), this.dragging = !0, this.lastX = x, this.lastY = E, (0, r.addEvent)(b, p.move, this.handleDrag), (0, r.addEvent)(b, p.stop, this.handleDragStop));
      }), u(this, "handleDrag", (y) => {
        const v = (0, o.getControlPosition)(y, this.touchIdentifier, this);
        if (v == null) return;
        let {
          x: b,
          y: _
        } = v;
        if (Array.isArray(this.props.grid)) {
          let E = b - this.lastX, S = _ - this.lastY;
          if ([E, S] = (0, o.snapToGrid)(this.props.grid, E, S), !E && !S) return;
          b = this.lastX + E, _ = this.lastY + S;
        }
        const w = (0, o.createCoreData)(this, b, _);
        if ((0, s.default)("DraggableCore: handleDrag: %j", w), this.props.onDrag(y, w) === !1 || this.mounted === !1) {
          try {
            this.handleDragStop(new MouseEvent("mouseup"));
          } catch {
            const S = document.createEvent("MouseEvents");
            S.initMouseEvent("mouseup", !0, !0, window, 0, 0, 0, 0, 0, !1, !1, !1, !1, 0, null), this.handleDragStop(S);
          }
          return;
        }
        this.lastX = b, this.lastY = _;
      }), u(this, "handleDragStop", (y) => {
        if (!this.dragging) return;
        const v = (0, o.getControlPosition)(y, this.touchIdentifier, this);
        if (v == null) return;
        let {
          x: b,
          y: _
        } = v;
        if (Array.isArray(this.props.grid)) {
          let S = b - this.lastX || 0, C = _ - this.lastY || 0;
          [S, C] = (0, o.snapToGrid)(this.props.grid, S, C), b = this.lastX + S, _ = this.lastY + C;
        }
        const w = (0, o.createCoreData)(this, b, _);
        if (this.props.onStop(y, w) === !1 || this.mounted === !1) return !1;
        const E = this.findDOMNode();
        E && this.props.enableUserSelectHack && (0, r.removeUserSelectStyles)(E.ownerDocument), (0, s.default)("DraggableCore: handleDragStop: %j", w), this.dragging = !1, this.lastX = NaN, this.lastY = NaN, E && ((0, s.default)("DraggableCore: Removing handlers"), (0, r.removeEvent)(E.ownerDocument, p.move, this.handleDrag), (0, r.removeEvent)(E.ownerDocument, p.stop, this.handleDragStop));
      }), u(this, "onMouseDown", (y) => (p = h.mouse, this.handleDragStart(y))), u(this, "onMouseUp", (y) => (p = h.mouse, this.handleDragStop(y))), u(this, "onTouchStart", (y) => (p = h.touch, this.handleDragStart(y))), u(this, "onTouchEnd", (y) => (p = h.touch, this.handleDragStop(y)));
    }
    componentDidMount() {
      this.mounted = !0;
      const y = this.findDOMNode();
      y && (0, r.addEvent)(y, h.touch.start, this.onTouchStart, {
        passive: !1
      });
    }
    componentWillUnmount() {
      this.mounted = !1;
      const y = this.findDOMNode();
      if (y) {
        const {
          ownerDocument: v
        } = y;
        (0, r.removeEvent)(v, h.mouse.move, this.handleDrag), (0, r.removeEvent)(v, h.touch.move, this.handleDrag), (0, r.removeEvent)(v, h.mouse.stop, this.handleDragStop), (0, r.removeEvent)(v, h.touch.stop, this.handleDragStop), (0, r.removeEvent)(y, h.touch.start, this.onTouchStart, {
          passive: !1
        }), this.props.enableUserSelectHack && (0, r.removeUserSelectStyles)(v);
      }
    }
    // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
    // the underlying DOM node ourselves. See the README for more information.
    findDOMNode() {
      var y, v;
      return (y = this.props) !== null && y !== void 0 && y.nodeRef ? (v = this.props) === null || v === void 0 || (v = v.nodeRef) === null || v === void 0 ? void 0 : v.current : n.default.findDOMNode(this);
    }
    render() {
      return /* @__PURE__ */ t.cloneElement(t.Children.only(this.props.children), {
        // Note: mouseMove handler is attached to document so it will still function
        // when the user drags quickly and leaves the bounds of the element.
        onMouseDown: this.onMouseDown,
        onMouseUp: this.onMouseUp,
        // onTouchStart is added on `componentDidMount` so they can be added with
        // {passive: false}, which allows it to cancel. See
        // https://developers.google.com/web/updates/2017/01/scrolling-intervention
        onTouchEnd: this.onTouchEnd
      });
    }
  };
  return ig.default = m, u(m, "displayName", "DraggableCore"), u(m, "propTypes", {
    /**
     * `allowAnyClick` allows dragging using any mouse button.
     * By default, we only accept the left button.
     *
     * Defaults to `false`.
     */
    allowAnyClick: e.default.bool,
    children: e.default.node.isRequired,
    /**
     * `disabled`, if true, stops the <Draggable> from dragging. All handlers,
     * with the exception of `onMouseDown`, will not fire.
     */
    disabled: e.default.bool,
    /**
     * By default, we add 'user-select:none' attributes to the document body
     * to prevent ugly text selection during drag. If this is causing problems
     * for your app, set this to `false`.
     */
    enableUserSelectHack: e.default.bool,
    /**
     * `offsetParent`, if set, uses the passed DOM node to compute drag offsets
     * instead of using the parent node.
     */
    offsetParent: function(g, y) {
      if (g[y] && g[y].nodeType !== 1)
        throw new Error("Draggable's offsetParent must be a DOM Node.");
    },
    /**
     * `grid` specifies the x and y that dragging should snap to.
     */
    grid: e.default.arrayOf(e.default.number),
    /**
     * `handle` specifies a selector to be used as the handle that initiates drag.
     *
     * Example:
     *
     * ```jsx
     *   let App = React.createClass({
     *       render: function () {
     *         return (
     *            <Draggable handle=".handle">
     *              <div>
     *                  <div className="handle">Click me to drag</div>
     *                  <div>This is some other content</div>
     *              </div>
     *           </Draggable>
     *         );
     *       }
     *   });
     * ```
     */
    handle: e.default.string,
    /**
     * `cancel` specifies a selector to be used to prevent drag initialization.
     *
     * Example:
     *
     * ```jsx
     *   let App = React.createClass({
     *       render: function () {
     *           return(
     *               <Draggable cancel=".cancel">
     *                   <div>
     *                     <div className="cancel">You can't drag from here</div>
     *                     <div>Dragging here works fine</div>
     *                   </div>
     *               </Draggable>
     *           );
     *       }
     *   });
     * ```
     */
    cancel: e.default.string,
    /* If running in React Strict mode, ReactDOM.findDOMNode() is deprecated.
     * Unfortunately, in order for <Draggable> to work properly, we need raw access
     * to the underlying DOM node. If you want to avoid the warning, pass a `nodeRef`
     * as in this example:
     *
     * function MyComponent() {
     *   const nodeRef = React.useRef(null);
     *   return (
     *     <Draggable nodeRef={nodeRef}>
     *       <div ref={nodeRef}>Example Target</div>
     *     </Draggable>
     *   );
     * }
     *
     * This can be used for arbitrarily nested components, so long as the ref ends up
     * pointing to the actual child DOM node and not a custom component.
     */
    nodeRef: e.default.object,
    /**
     * Called when dragging starts.
     * If this function returns the boolean false, dragging will be canceled.
     */
    onStart: e.default.func,
    /**
     * Called while dragging.
     * If this function returns the boolean false, dragging will be canceled.
     */
    onDrag: e.default.func,
    /**
     * Called when dragging stops.
     * If this function returns the boolean false, the drag will remain active.
     */
    onStop: e.default.func,
    /**
     * A workaround option which can be passed if onMouseDown needs to be accessed,
     * since it'll always be blocked (as there is internal use of onMouseDown)
     */
    onMouseDown: e.default.func,
    /**
     * `scale`, if set, applies scaling while dragging an element
     */
    scale: e.default.number,
    /**
     * These properties should be defined on the child, not here.
     */
    className: i.dontSetMe,
    style: i.dontSetMe,
    transform: i.dontSetMe
  }), u(m, "defaultProps", {
    allowAnyClick: !1,
    // by default only accept left click
    disabled: !1,
    enableUserSelectHack: !0,
    onStart: function() {
    },
    onDrag: function() {
    },
    onStop: function() {
    },
    onMouseDown: function() {
    },
    scale: 1
  }), ig;
}
var mse;
function GCt() {
  return mse || (mse = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "DraggableCore", {
      enumerable: !0,
      get: function() {
        return l.default;
      }
    }), t.default = void 0;
    var e = f(xe), n = u(/* @__PURE__ */ hu()), r = u(Kc), o = u(HCt), i = T9(), s = Rwe(), a = GO(), l = u(WCt()), c = u(Pwe());
    function u(v) {
      return v && v.__esModule ? v : { default: v };
    }
    function d(v) {
      if (typeof WeakMap != "function") return null;
      var b = /* @__PURE__ */ new WeakMap(), _ = /* @__PURE__ */ new WeakMap();
      return (d = function(w) {
        return w ? _ : b;
      })(v);
    }
    function f(v, b) {
      if (v && v.__esModule)
        return v;
      if (v === null || typeof v != "object" && typeof v != "function")
        return { default: v };
      var _ = d(b);
      if (_ && _.has(v))
        return _.get(v);
      var w = {}, x = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var E in v)
        if (E !== "default" && Object.prototype.hasOwnProperty.call(v, E)) {
          var S = x ? Object.getOwnPropertyDescriptor(v, E) : null;
          S && (S.get || S.set) ? Object.defineProperty(w, E, S) : w[E] = v[E];
        }
      return w.default = v, _ && _.set(v, w), w;
    }
    function h() {
      return h = Object.assign ? Object.assign.bind() : function(v) {
        for (var b = 1; b < arguments.length; b++) {
          var _ = arguments[b];
          for (var w in _)
            Object.prototype.hasOwnProperty.call(_, w) && (v[w] = _[w]);
        }
        return v;
      }, h.apply(this, arguments);
    }
    function p(v, b, _) {
      return b = m(b), b in v ? Object.defineProperty(v, b, { value: _, enumerable: !0, configurable: !0, writable: !0 }) : v[b] = _, v;
    }
    function m(v) {
      var b = g(v, "string");
      return typeof b == "symbol" ? b : String(b);
    }
    function g(v, b) {
      if (typeof v != "object" || v === null) return v;
      var _ = v[Symbol.toPrimitive];
      if (_ !== void 0) {
        var w = _.call(v, b || "default");
        if (typeof w != "object") return w;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (b === "string" ? String : Number)(v);
    }
    class y extends e.Component {
      // React 16.3+
      // Arity (props, state)
      static getDerivedStateFromProps(b, _) {
        let {
          position: w
        } = b, {
          prevPropsPosition: x
        } = _;
        return w && (!x || w.x !== x.x || w.y !== x.y) ? ((0, c.default)("Draggable: getDerivedStateFromProps %j", {
          position: w,
          prevPropsPosition: x
        }), {
          x: w.x,
          y: w.y,
          prevPropsPosition: {
            ...w
          }
        }) : null;
      }
      constructor(b) {
        super(b), p(this, "onDragStart", (_, w) => {
          if ((0, c.default)("Draggable: onDragStart: %j", w), this.props.onStart(_, (0, s.createDraggableData)(this, w)) === !1) return !1;
          this.setState({
            dragging: !0,
            dragged: !0
          });
        }), p(this, "onDrag", (_, w) => {
          if (!this.state.dragging) return !1;
          (0, c.default)("Draggable: onDrag: %j", w);
          const x = (0, s.createDraggableData)(this, w), E = {
            x: x.x,
            y: x.y,
            slackX: 0,
            slackY: 0
          };
          if (this.props.bounds) {
            const {
              x: C,
              y: R
            } = E;
            E.x += this.state.slackX, E.y += this.state.slackY;
            const [P, N] = (0, s.getBoundPosition)(this, E.x, E.y);
            E.x = P, E.y = N, E.slackX = this.state.slackX + (C - E.x), E.slackY = this.state.slackY + (R - E.y), x.x = E.x, x.y = E.y, x.deltaX = E.x - this.state.x, x.deltaY = E.y - this.state.y;
          }
          if (this.props.onDrag(_, x) === !1) return !1;
          this.setState(E);
        }), p(this, "onDragStop", (_, w) => {
          if (!this.state.dragging || this.props.onStop(_, (0, s.createDraggableData)(this, w)) === !1) return !1;
          (0, c.default)("Draggable: onDragStop: %j", w);
          const E = {
            dragging: !1,
            slackX: 0,
            slackY: 0
          };
          if (!!this.props.position) {
            const {
              x: C,
              y: R
            } = this.props.position;
            E.x = C, E.y = R;
          }
          this.setState(E);
        }), this.state = {
          // Whether or not we are currently dragging.
          dragging: !1,
          // Whether or not we have been dragged before.
          dragged: !1,
          // Current transform x and y.
          x: b.position ? b.position.x : b.defaultPosition.x,
          y: b.position ? b.position.y : b.defaultPosition.y,
          prevPropsPosition: {
            ...b.position
          },
          // Used for compensating for out-of-bounds drags
          slackX: 0,
          slackY: 0,
          // Can only determine if SVG after mounting
          isElementSVG: !1
        }, b.position && !(b.onDrag || b.onStop) && console.warn("A `position` was applied to this <Draggable>, without drag handlers. This will make this component effectively undraggable. Please attach `onDrag` or `onStop` handlers so you can adjust the `position` of this element.");
      }
      componentDidMount() {
        typeof window.SVGElement < "u" && this.findDOMNode() instanceof window.SVGElement && this.setState({
          isElementSVG: !0
        });
      }
      componentWillUnmount() {
        this.setState({
          dragging: !1
        });
      }
      // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
      // the underlying DOM node ourselves. See the README for more information.
      findDOMNode() {
        var b, _;
        return (b = (_ = this.props) === null || _ === void 0 || (_ = _.nodeRef) === null || _ === void 0 ? void 0 : _.current) !== null && b !== void 0 ? b : r.default.findDOMNode(this);
      }
      render() {
        const {
          axis: b,
          bounds: _,
          children: w,
          defaultPosition: x,
          defaultClassName: E,
          defaultClassNameDragging: S,
          defaultClassNameDragged: C,
          position: R,
          positionOffset: P,
          scale: N,
          ...A
        } = this.props;
        let O = {}, k = null;
        const I = !!!R || this.state.dragging, j = R || x, z = {
          // Set left if horizontal drag is enabled
          x: (0, s.canDragX)(this) && I ? this.state.x : j.x,
          // Set top if vertical drag is enabled
          y: (0, s.canDragY)(this) && I ? this.state.y : j.y
        };
        this.state.isElementSVG ? k = (0, i.createSVGTransform)(z, P) : O = (0, i.createCSSTransform)(z, P);
        const $ = (0, o.default)(w.props.className || "", E, {
          [S]: this.state.dragging,
          [C]: this.state.dragged
        });
        return /* @__PURE__ */ e.createElement(l.default, h({}, A, {
          onStart: this.onDragStart,
          onDrag: this.onDrag,
          onStop: this.onDragStop
        }), /* @__PURE__ */ e.cloneElement(e.Children.only(w), {
          className: $,
          style: {
            ...w.props.style,
            ...O
          },
          transform: k
        }));
      }
    }
    t.default = y, p(y, "displayName", "Draggable"), p(y, "propTypes", {
      // Accepts all props <DraggableCore> accepts.
      ...l.default.propTypes,
      /**
       * `axis` determines which axis the draggable can move.
       *
       *  Note that all callbacks will still return data as normal. This only
       *  controls flushing to the DOM.
       *
       * 'both' allows movement horizontally and vertically.
       * 'x' limits movement to horizontal axis.
       * 'y' limits movement to vertical axis.
       * 'none' limits all movement.
       *
       * Defaults to 'both'.
       */
      axis: n.default.oneOf(["both", "x", "y", "none"]),
      /**
       * `bounds` determines the range of movement available to the element.
       * Available values are:
       *
       * 'parent' restricts movement within the Draggable's parent node.
       *
       * Alternatively, pass an object with the following properties, all of which are optional:
       *
       * {left: LEFT_BOUND, right: RIGHT_BOUND, bottom: BOTTOM_BOUND, top: TOP_BOUND}
       *
       * All values are in px.
       *
       * Example:
       *
       * ```jsx
       *   let App = React.createClass({
       *       render: function () {
       *         return (
       *            <Draggable bounds={{right: 300, bottom: 300}}>
       *              <div>Content</div>
       *           </Draggable>
       *         );
       *       }
       *   });
       * ```
       */
      bounds: n.default.oneOfType([n.default.shape({
        left: n.default.number,
        right: n.default.number,
        top: n.default.number,
        bottom: n.default.number
      }), n.default.string, n.default.oneOf([!1])]),
      defaultClassName: n.default.string,
      defaultClassNameDragging: n.default.string,
      defaultClassNameDragged: n.default.string,
      /**
       * `defaultPosition` specifies the x and y that the dragged item should start at
       *
       * Example:
       *
       * ```jsx
       *      let App = React.createClass({
       *          render: function () {
       *              return (
       *                  <Draggable defaultPosition={{x: 25, y: 25}}>
       *                      <div>I start with transformX: 25px and transformY: 25px;</div>
       *                  </Draggable>
       *              );
       *          }
       *      });
       * ```
       */
      defaultPosition: n.default.shape({
        x: n.default.number,
        y: n.default.number
      }),
      positionOffset: n.default.shape({
        x: n.default.oneOfType([n.default.number, n.default.string]),
        y: n.default.oneOfType([n.default.number, n.default.string])
      }),
      /**
       * `position`, if present, defines the current position of the element.
       *
       *  This is similar to how form elements in React work - if no `position` is supplied, the component
       *  is uncontrolled.
       *
       * Example:
       *
       * ```jsx
       *      let App = React.createClass({
       *          render: function () {
       *              return (
       *                  <Draggable position={{x: 25, y: 25}}>
       *                      <div>I start with transformX: 25px and transformY: 25px;</div>
       *                  </Draggable>
       *              );
       *          }
       *      });
       * ```
       */
      position: n.default.shape({
        x: n.default.number,
        y: n.default.number
      }),
      /**
       * These properties should be defined on the child, not here.
       */
      className: a.dontSetMe,
      style: a.dontSetMe,
      transform: a.dontSetMe
    }), p(y, "defaultProps", {
      ...l.default.defaultProps,
      axis: "both",
      bounds: !1,
      defaultClassName: "react-draggable",
      defaultClassNameDragging: "react-draggable-dragging",
      defaultClassNameDragged: "react-draggable-dragged",
      defaultPosition: {
        x: 0,
        y: 0
      },
      scale: 1
    });
  }(RD)), RD;
}
var gse;
function R9() {
  if (gse) return og.exports;
  gse = 1;
  const {
    default: t,
    DraggableCore: e
  } = GCt();
  return og.exports = t, og.exports.default = t, og.exports.DraggableCore = e, og.exports;
}
var sg = { exports: {} }, ag = {}, I_ = {}, yse;
function YCt() {
  if (yse) return I_;
  yse = 1, I_.__esModule = !0, I_.cloneElement = a;
  var t = e(xe);
  function e(l) {
    return l && l.__esModule ? l : { default: l };
  }
  function n(l, c) {
    var u = Object.keys(l);
    if (Object.getOwnPropertySymbols) {
      var d = Object.getOwnPropertySymbols(l);
      c && (d = d.filter(function(f) {
        return Object.getOwnPropertyDescriptor(l, f).enumerable;
      })), u.push.apply(u, d);
    }
    return u;
  }
  function r(l) {
    for (var c = 1; c < arguments.length; c++) {
      var u = arguments[c] != null ? arguments[c] : {};
      c % 2 ? n(Object(u), !0).forEach(function(d) {
        o(l, d, u[d]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(l, Object.getOwnPropertyDescriptors(u)) : n(Object(u)).forEach(function(d) {
        Object.defineProperty(l, d, Object.getOwnPropertyDescriptor(u, d));
      });
    }
    return l;
  }
  function o(l, c, u) {
    return c = i(c), c in l ? Object.defineProperty(l, c, { value: u, enumerable: !0, configurable: !0, writable: !0 }) : l[c] = u, l;
  }
  function i(l) {
    var c = s(l, "string");
    return typeof c == "symbol" ? c : String(c);
  }
  function s(l, c) {
    if (typeof l != "object" || l === null) return l;
    var u = l[Symbol.toPrimitive];
    if (u !== void 0) {
      var d = u.call(l, c || "default");
      if (typeof d != "object") return d;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (c === "string" ? String : Number)(l);
  }
  function a(l, c) {
    return c.style && l.props.style && (c.style = r(r({}, l.props.style), c.style)), c.className && l.props.className && (c.className = l.props.className + " " + c.className), /* @__PURE__ */ t.default.cloneElement(l, c);
  }
  return I_;
}
var lg = {}, vse;
function $we() {
  if (vse) return lg;
  vse = 1, lg.__esModule = !0, lg.resizableProps = void 0;
  var t = e(/* @__PURE__ */ hu());
  R9();
  function e(r) {
    return r && r.__esModule ? r : { default: r };
  }
  var n = {
    /*
    * Restricts resizing to a particular axis (default: 'both')
    * 'both' - allows resizing by width or height
    * 'x' - only allows the width to be changed
    * 'y' - only allows the height to be changed
    * 'none' - disables resizing altogether
    * */
    axis: t.default.oneOf(["both", "x", "y", "none"]),
    className: t.default.string,
    /*
    * Require that one and only one child be present.
    * */
    children: t.default.element.isRequired,
    /*
    * These will be passed wholesale to react-draggable's DraggableCore
    * */
    draggableOpts: t.default.shape({
      allowAnyClick: t.default.bool,
      cancel: t.default.string,
      children: t.default.node,
      disabled: t.default.bool,
      enableUserSelectHack: t.default.bool,
      offsetParent: t.default.node,
      grid: t.default.arrayOf(t.default.number),
      handle: t.default.string,
      nodeRef: t.default.object,
      onStart: t.default.func,
      onDrag: t.default.func,
      onStop: t.default.func,
      onMouseDown: t.default.func,
      scale: t.default.number
    }),
    /*
    * Initial height
    * */
    height: function() {
      for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
        i[s] = arguments[s];
      var a = i[0];
      if (a.axis === "both" || a.axis === "y") {
        var l;
        return (l = t.default.number).isRequired.apply(l, i);
      }
      return t.default.number.apply(t.default, i);
    },
    /*
    * Customize cursor resize handle
    * */
    handle: t.default.oneOfType([t.default.node, t.default.func]),
    /*
    * If you change this, be sure to update your css
    * */
    handleSize: t.default.arrayOf(t.default.number),
    lockAspectRatio: t.default.bool,
    /*
    * Max X & Y measure
    * */
    maxConstraints: t.default.arrayOf(t.default.number),
    /*
    * Min X & Y measure
    * */
    minConstraints: t.default.arrayOf(t.default.number),
    /*
    * Called on stop resize event
    * */
    onResizeStop: t.default.func,
    /*
    * Called on start resize event
    * */
    onResizeStart: t.default.func,
    /*
    * Called on resize event
    * */
    onResize: t.default.func,
    /*
    * Defines which resize handles should be rendered (default: 'se')
    * 's' - South handle (bottom-center)
    * 'w' - West handle (left-center)
    * 'e' - East handle (right-center)
    * 'n' - North handle (top-center)
    * 'sw' - Southwest handle (bottom-left)
    * 'nw' - Northwest handle (top-left)
    * 'se' - Southeast handle (bottom-right)
    * 'ne' - Northeast handle (top-center)
    * */
    resizeHandles: t.default.arrayOf(t.default.oneOf(["s", "w", "e", "n", "sw", "nw", "se", "ne"])),
    /*
    * If `transform: scale(n)` is set on the parent, this should be set to `n`.
    * */
    transformScale: t.default.number,
    /*
     * Initial width
     */
    width: function() {
      for (var o = arguments.length, i = new Array(o), s = 0; s < o; s++)
        i[s] = arguments[s];
      var a = i[0];
      if (a.axis === "both" || a.axis === "x") {
        var l;
        return (l = t.default.number).isRequired.apply(l, i);
      }
      return t.default.number.apply(t.default, i);
    }
  };
  return lg.resizableProps = n, lg;
}
var bse;
function Mwe() {
  if (bse) return ag;
  bse = 1, ag.__esModule = !0, ag.default = void 0;
  var t = s(xe), e = R9(), n = YCt(), r = $we(), o = ["children", "className", "draggableOpts", "width", "height", "handle", "handleSize", "lockAspectRatio", "axis", "minConstraints", "maxConstraints", "onResize", "onResizeStop", "onResizeStart", "resizeHandles", "transformScale"];
  function i(y) {
    if (typeof WeakMap != "function") return null;
    var v = /* @__PURE__ */ new WeakMap(), b = /* @__PURE__ */ new WeakMap();
    return (i = function(w) {
      return w ? b : v;
    })(y);
  }
  function s(y, v) {
    if (y && y.__esModule)
      return y;
    if (y === null || typeof y != "object" && typeof y != "function")
      return { default: y };
    var b = i(v);
    if (b && b.has(y))
      return b.get(y);
    var _ = {}, w = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var x in y)
      if (x !== "default" && Object.prototype.hasOwnProperty.call(y, x)) {
        var E = w ? Object.getOwnPropertyDescriptor(y, x) : null;
        E && (E.get || E.set) ? Object.defineProperty(_, x, E) : _[x] = y[x];
      }
    return _.default = y, b && b.set(y, _), _;
  }
  function a() {
    return a = Object.assign ? Object.assign.bind() : function(y) {
      for (var v = 1; v < arguments.length; v++) {
        var b = arguments[v];
        for (var _ in b)
          Object.prototype.hasOwnProperty.call(b, _) && (y[_] = b[_]);
      }
      return y;
    }, a.apply(this, arguments);
  }
  function l(y, v) {
    if (y == null) return {};
    var b = {}, _ = Object.keys(y), w, x;
    for (x = 0; x < _.length; x++)
      w = _[x], !(v.indexOf(w) >= 0) && (b[w] = y[w]);
    return b;
  }
  function c(y, v) {
    var b = Object.keys(y);
    if (Object.getOwnPropertySymbols) {
      var _ = Object.getOwnPropertySymbols(y);
      v && (_ = _.filter(function(w) {
        return Object.getOwnPropertyDescriptor(y, w).enumerable;
      })), b.push.apply(b, _);
    }
    return b;
  }
  function u(y) {
    for (var v = 1; v < arguments.length; v++) {
      var b = arguments[v] != null ? arguments[v] : {};
      v % 2 ? c(Object(b), !0).forEach(function(_) {
        d(y, _, b[_]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(y, Object.getOwnPropertyDescriptors(b)) : c(Object(b)).forEach(function(_) {
        Object.defineProperty(y, _, Object.getOwnPropertyDescriptor(b, _));
      });
    }
    return y;
  }
  function d(y, v, b) {
    return v = f(v), v in y ? Object.defineProperty(y, v, { value: b, enumerable: !0, configurable: !0, writable: !0 }) : y[v] = b, y;
  }
  function f(y) {
    var v = h(y, "string");
    return typeof v == "symbol" ? v : String(v);
  }
  function h(y, v) {
    if (typeof y != "object" || y === null) return y;
    var b = y[Symbol.toPrimitive];
    if (b !== void 0) {
      var _ = b.call(y, v || "default");
      if (typeof _ != "object") return _;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (v === "string" ? String : Number)(y);
  }
  function p(y, v) {
    y.prototype = Object.create(v.prototype), y.prototype.constructor = y, m(y, v);
  }
  function m(y, v) {
    return m = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(_, w) {
      return _.__proto__ = w, _;
    }, m(y, v);
  }
  var g = /* @__PURE__ */ function(y) {
    p(v, y);
    function v() {
      for (var _, w = arguments.length, x = new Array(w), E = 0; E < w; E++)
        x[E] = arguments[E];
      return _ = y.call.apply(y, [this].concat(x)) || this, _.handleRefs = {}, _.lastHandleRect = null, _.slack = null, _;
    }
    var b = v.prototype;
    return b.componentWillUnmount = function() {
      this.resetData();
    }, b.resetData = function() {
      this.lastHandleRect = this.slack = null;
    }, b.runConstraints = function(w, x) {
      var E = this.props, S = E.minConstraints, C = E.maxConstraints, R = E.lockAspectRatio;
      if (!S && !C && !R) return [w, x];
      if (R) {
        var P = this.props.width / this.props.height, N = w - this.props.width, A = x - this.props.height;
        Math.abs(N) > Math.abs(A * P) ? x = w / P : w = x * P;
      }
      var O = w, k = x, T = this.slack || [0, 0], I = T[0], j = T[1];
      return w += I, x += j, S && (w = Math.max(S[0], w), x = Math.max(S[1], x)), C && (w = Math.min(C[0], w), x = Math.min(C[1], x)), this.slack = [I + (O - w), j + (k - x)], [w, x];
    }, b.resizeHandler = function(w, x) {
      var E = this;
      return function(S, C) {
        var R = C.node, P = C.deltaX, N = C.deltaY;
        w === "onResizeStart" && E.resetData();
        var A = (E.props.axis === "both" || E.props.axis === "x") && x !== "n" && x !== "s", O = (E.props.axis === "both" || E.props.axis === "y") && x !== "e" && x !== "w";
        if (!(!A && !O)) {
          var k = x[0], T = x[x.length - 1], I = R.getBoundingClientRect();
          if (E.lastHandleRect != null) {
            if (T === "w") {
              var j = I.left - E.lastHandleRect.left;
              P += j;
            }
            if (k === "n") {
              var z = I.top - E.lastHandleRect.top;
              N += z;
            }
          }
          E.lastHandleRect = I, T === "w" && (P = -P), k === "n" && (N = -N);
          var $ = E.props.width + (A ? P / E.props.transformScale : 0), D = E.props.height + (O ? N / E.props.transformScale : 0), U = E.runConstraints($, D);
          $ = U[0], D = U[1];
          var q = $ !== E.props.width || D !== E.props.height, F = typeof E.props[w] == "function" ? E.props[w] : null, B = w === "onResize" && !q;
          F && !B && (S.persist == null || S.persist(), F(S, {
            node: R,
            size: {
              width: $,
              height: D
            },
            handle: x
          })), w === "onResizeStop" && E.resetData();
        }
      };
    }, b.renderResizeHandle = function(w, x) {
      var E = this.props.handle;
      if (!E)
        return /* @__PURE__ */ t.createElement("span", {
          className: "react-resizable-handle react-resizable-handle-" + w,
          ref: x
        });
      if (typeof E == "function")
        return E(w, x);
      var S = typeof E.type == "string", C = u({
        ref: x
      }, S ? {} : {
        handleAxis: w
      });
      return /* @__PURE__ */ t.cloneElement(E, C);
    }, b.render = function() {
      var w = this, x = this.props, E = x.children, S = x.className, C = x.draggableOpts;
      x.width, x.height, x.handle, x.handleSize, x.lockAspectRatio, x.axis, x.minConstraints, x.maxConstraints, x.onResize, x.onResizeStop, x.onResizeStart;
      var R = x.resizeHandles;
      x.transformScale;
      var P = l(x, o);
      return (0, n.cloneElement)(E, u(u({}, P), {}, {
        className: (S ? S + " " : "") + "react-resizable",
        children: [].concat(E.props.children, R.map(function(N) {
          var A, O = (A = w.handleRefs[N]) != null ? A : w.handleRefs[N] = /* @__PURE__ */ t.createRef();
          return /* @__PURE__ */ t.createElement(e.DraggableCore, a({}, C, {
            nodeRef: O,
            key: "resizableHandle-" + N,
            onStop: w.resizeHandler("onResizeStop", N),
            onStart: w.resizeHandler("onResizeStart", N),
            onDrag: w.resizeHandler("onResize", N)
          }), w.renderResizeHandle(N, O));
        }))
      }));
    }, v;
  }(t.Component);
  return ag.default = g, g.propTypes = r.resizableProps, g.defaultProps = {
    axis: "both",
    handleSize: [20, 20],
    lockAspectRatio: !1,
    minConstraints: [20, 20],
    maxConstraints: [1 / 0, 1 / 0],
    resizeHandles: ["se"],
    transformScale: 1
  }, ag;
}
var cg = {}, _se;
function KCt() {
  if (_se) return cg;
  _se = 1, cg.__esModule = !0, cg.default = void 0;
  var t = a(xe), e = i(/* @__PURE__ */ hu()), n = i(Mwe()), r = $we(), o = ["handle", "handleSize", "onResize", "onResizeStart", "onResizeStop", "draggableOpts", "minConstraints", "maxConstraints", "lockAspectRatio", "axis", "width", "height", "resizeHandles", "style", "transformScale"];
  function i(v) {
    return v && v.__esModule ? v : { default: v };
  }
  function s(v) {
    if (typeof WeakMap != "function") return null;
    var b = /* @__PURE__ */ new WeakMap(), _ = /* @__PURE__ */ new WeakMap();
    return (s = function(x) {
      return x ? _ : b;
    })(v);
  }
  function a(v, b) {
    if (v && v.__esModule)
      return v;
    if (v === null || typeof v != "object" && typeof v != "function")
      return { default: v };
    var _ = s(b);
    if (_ && _.has(v))
      return _.get(v);
    var w = {}, x = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var E in v)
      if (E !== "default" && Object.prototype.hasOwnProperty.call(v, E)) {
        var S = x ? Object.getOwnPropertyDescriptor(v, E) : null;
        S && (S.get || S.set) ? Object.defineProperty(w, E, S) : w[E] = v[E];
      }
    return w.default = v, _ && _.set(v, w), w;
  }
  function l() {
    return l = Object.assign ? Object.assign.bind() : function(v) {
      for (var b = 1; b < arguments.length; b++) {
        var _ = arguments[b];
        for (var w in _)
          Object.prototype.hasOwnProperty.call(_, w) && (v[w] = _[w]);
      }
      return v;
    }, l.apply(this, arguments);
  }
  function c(v, b) {
    var _ = Object.keys(v);
    if (Object.getOwnPropertySymbols) {
      var w = Object.getOwnPropertySymbols(v);
      b && (w = w.filter(function(x) {
        return Object.getOwnPropertyDescriptor(v, x).enumerable;
      })), _.push.apply(_, w);
    }
    return _;
  }
  function u(v) {
    for (var b = 1; b < arguments.length; b++) {
      var _ = arguments[b] != null ? arguments[b] : {};
      b % 2 ? c(Object(_), !0).forEach(function(w) {
        d(v, w, _[w]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(v, Object.getOwnPropertyDescriptors(_)) : c(Object(_)).forEach(function(w) {
        Object.defineProperty(v, w, Object.getOwnPropertyDescriptor(_, w));
      });
    }
    return v;
  }
  function d(v, b, _) {
    return b = f(b), b in v ? Object.defineProperty(v, b, { value: _, enumerable: !0, configurable: !0, writable: !0 }) : v[b] = _, v;
  }
  function f(v) {
    var b = h(v, "string");
    return typeof b == "symbol" ? b : String(b);
  }
  function h(v, b) {
    if (typeof v != "object" || v === null) return v;
    var _ = v[Symbol.toPrimitive];
    if (_ !== void 0) {
      var w = _.call(v, b || "default");
      if (typeof w != "object") return w;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (b === "string" ? String : Number)(v);
  }
  function p(v, b) {
    if (v == null) return {};
    var _ = {}, w = Object.keys(v), x, E;
    for (E = 0; E < w.length; E++)
      x = w[E], !(b.indexOf(x) >= 0) && (_[x] = v[x]);
    return _;
  }
  function m(v, b) {
    v.prototype = Object.create(b.prototype), v.prototype.constructor = v, g(v, b);
  }
  function g(v, b) {
    return g = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(w, x) {
      return w.__proto__ = x, w;
    }, g(v, b);
  }
  var y = /* @__PURE__ */ function(v) {
    m(b, v);
    function b() {
      for (var w, x = arguments.length, E = new Array(x), S = 0; S < x; S++)
        E[S] = arguments[S];
      return w = v.call.apply(v, [this].concat(E)) || this, w.state = {
        width: w.props.width,
        height: w.props.height,
        propsWidth: w.props.width,
        propsHeight: w.props.height
      }, w.onResize = function(C, R) {
        var P = R.size;
        w.props.onResize ? (C.persist == null || C.persist(), w.setState(P, function() {
          return w.props.onResize && w.props.onResize(C, R);
        })) : w.setState(P);
      }, w;
    }
    b.getDerivedStateFromProps = function(x, E) {
      return E.propsWidth !== x.width || E.propsHeight !== x.height ? {
        width: x.width,
        height: x.height,
        propsWidth: x.width,
        propsHeight: x.height
      } : null;
    };
    var _ = b.prototype;
    return _.render = function() {
      var x = this.props, E = x.handle, S = x.handleSize;
      x.onResize;
      var C = x.onResizeStart, R = x.onResizeStop, P = x.draggableOpts, N = x.minConstraints, A = x.maxConstraints, O = x.lockAspectRatio, k = x.axis;
      x.width, x.height;
      var T = x.resizeHandles, I = x.style, j = x.transformScale, z = p(x, o);
      return /* @__PURE__ */ t.createElement(n.default, {
        axis: k,
        draggableOpts: P,
        handle: E,
        handleSize: S,
        height: this.state.height,
        lockAspectRatio: O,
        maxConstraints: A,
        minConstraints: N,
        onResizeStart: C,
        onResize: this.onResize,
        onResizeStop: R,
        resizeHandles: T,
        transformScale: j,
        width: this.state.width
      }, /* @__PURE__ */ t.createElement("div", l({}, z, {
        style: u(u({}, I), {}, {
          width: this.state.width + "px",
          height: this.state.height + "px"
        })
      })));
    }, b;
  }(t.Component);
  return cg.default = y, y.propTypes = u(u({}, r.resizableProps), {}, {
    children: e.default.element
  }), cg;
}
var wse;
function XCt() {
  return wse || (wse = 1, sg.exports = function() {
    throw new Error("Don't instantiate Resizable directly! Use require('react-resizable').Resizable");
  }, sg.exports.Resizable = Mwe().default, sg.exports.ResizableBox = KCt().default), sg.exports;
}
var Ja = {}, xse;
function Dwe() {
  if (xse) return Ja;
  xse = 1, Object.defineProperty(Ja, "__esModule", {
    value: !0
  }), Ja.resizeHandleType = Ja.resizeHandleAxesType = Ja.default = void 0;
  var t = n(/* @__PURE__ */ hu()), e = n(xe);
  function n(i) {
    return i && i.__esModule ? i : { default: i };
  }
  const r = Ja.resizeHandleAxesType = t.default.arrayOf(t.default.oneOf(["s", "w", "e", "n", "sw", "nw", "se", "ne"])), o = Ja.resizeHandleType = t.default.oneOfType([t.default.node, t.default.func]);
  return Ja.default = {
    //
    // Basic props
    //
    className: t.default.string,
    style: t.default.object,
    // This can be set explicitly. If it is not set, it will automatically
    // be set to the container width. Note that resizes will *not* cause this to adjust.
    // If you need that behavior, use WidthProvider.
    width: t.default.number,
    // If true, the container height swells and contracts to fit contents
    autoSize: t.default.bool,
    // # of cols.
    cols: t.default.number,
    // A selector that will not be draggable.
    draggableCancel: t.default.string,
    // A selector for the draggable handler
    draggableHandle: t.default.string,
    // Deprecated
    verticalCompact: function(i) {
      i.verticalCompact === !1 && process.env.NODE_ENV !== "production" && console.warn(
        // eslint-disable-line no-console
        '`verticalCompact` on <ReactGridLayout> is deprecated and will be removed soon. Use `compactType`: "horizontal" | "vertical" | null.'
      );
    },
    // Choose vertical or hotizontal compaction
    compactType: t.default.oneOf(["vertical", "horizontal"]),
    // layout is an array of object with the format:
    // {x: Number, y: Number, w: Number, h: Number, i: String}
    layout: function(i) {
      var s = i.layout;
      s !== void 0 && Vp().validateLayout(s, "layout");
    },
    //
    // Grid Dimensions
    //
    // Margin between items [x, y] in px
    margin: t.default.arrayOf(t.default.number),
    // Padding inside the container [x, y] in px
    containerPadding: t.default.arrayOf(t.default.number),
    // Rows have a static height, but you can change this based on breakpoints if you like
    rowHeight: t.default.number,
    // Default Infinity, but you can specify a max here if you like.
    // Note that this isn't fully fleshed out and won't error if you specify a layout that
    // extends beyond the row capacity. It will, however, not allow users to drag/resize
    // an item past the barrier. They can push items beyond the barrier, though.
    // Intentionally not documented for this reason.
    maxRows: t.default.number,
    //
    // Flags
    //
    isBounded: t.default.bool,
    isDraggable: t.default.bool,
    isResizable: t.default.bool,
    // If true, grid can be placed one over the other.
    allowOverlap: t.default.bool,
    // If true, grid items won't change position when being dragged over.
    preventCollision: t.default.bool,
    // Use CSS transforms instead of top/left
    useCSSTransforms: t.default.bool,
    // parent layout transform scale
    transformScale: t.default.number,
    // If true, an external element can trigger onDrop callback with a specific grid position as a parameter
    isDroppable: t.default.bool,
    // Resize handle options
    resizeHandles: r,
    resizeHandle: o,
    //
    // Callbacks
    //
    // Callback so you can save the layout. Calls after each drag & resize stops.
    onLayoutChange: t.default.func,
    // Calls when drag starts. Callback is of the signature (layout, oldItem, newItem, placeholder, e, ?node).
    // All callbacks below have the same signature. 'start' and 'stop' callbacks omit the 'placeholder'.
    onDragStart: t.default.func,
    // Calls on each drag movement.
    onDrag: t.default.func,
    // Calls when drag is complete.
    onDragStop: t.default.func,
    //Calls when resize starts.
    onResizeStart: t.default.func,
    // Calls when resize movement happens.
    onResize: t.default.func,
    // Calls when resize is complete.
    onResizeStop: t.default.func,
    // Calls when some element is dropped.
    onDrop: t.default.func,
    //
    // Other validations
    //
    droppingItem: t.default.shape({
      i: t.default.string.isRequired,
      w: t.default.number.isRequired,
      h: t.default.number.isRequired
    }),
    // Children must not have duplicate keys.
    children: function(i, s) {
      const a = i[s], l = {};
      e.default.Children.forEach(a, function(c) {
        if (c?.key != null) {
          if (l[c.key])
            throw new Error('Duplicate child key "' + c.key + '" found! This will cause problems in ReactGridLayout.');
          l[c.key] = !0;
        }
      });
    },
    // Optional ref for getting a reference for the wrapping div.
    innerRef: t.default.any
  }, Ja;
}
var Ese;
function QCt() {
  if (Ese) return rg;
  Ese = 1, Object.defineProperty(rg, "__esModule", {
    value: !0
  }), rg.default = void 0;
  var t = l(xe), e = l(/* @__PURE__ */ hu()), n = R9(), r = XCt(), o = Vp(), i = k9(), s = Dwe(), a = l(C9());
  function l(h) {
    return h && h.__esModule ? h : { default: h };
  }
  function c(h, p, m) {
    return p = u(p), p in h ? Object.defineProperty(h, p, { value: m, enumerable: !0, configurable: !0, writable: !0 }) : h[p] = m, h;
  }
  function u(h) {
    var p = d(h, "string");
    return typeof p == "symbol" ? p : String(p);
  }
  function d(h, p) {
    if (typeof h != "object" || h === null) return h;
    var m = h[Symbol.toPrimitive];
    if (m !== void 0) {
      var g = m.call(h, p || "default");
      if (typeof g != "object") return g;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (p === "string" ? String : Number)(h);
  }
  let f = class extends t.default.Component {
    constructor() {
      super(...arguments), c(this, "state", {
        resizing: null,
        dragging: null,
        className: ""
      }), c(this, "elementRef", /* @__PURE__ */ t.default.createRef()), c(this, "onDragStart", (p, m) => {
        let {
          node: g
        } = m;
        const {
          onDragStart: y,
          transformScale: v
        } = this.props;
        if (!y) return;
        const b = {
          top: 0,
          left: 0
        }, {
          offsetParent: _
        } = g;
        if (!_) return;
        const w = _.getBoundingClientRect(), x = g.getBoundingClientRect(), E = x.left / v, S = w.left / v, C = x.top / v, R = w.top / v;
        b.left = E - S + _.scrollLeft, b.top = C - R + _.scrollTop, this.setState({
          dragging: b
        });
        const {
          x: P,
          y: N
        } = (0, i.calcXY)(this.getPositionParams(), b.top, b.left, this.props.w, this.props.h);
        return y.call(this, this.props.i, P, N, {
          e: p,
          node: g,
          newPosition: b
        });
      }), c(this, "onDrag", (p, m) => {
        let {
          node: g,
          deltaX: y,
          deltaY: v
        } = m;
        const {
          onDrag: b
        } = this.props;
        if (!b) return;
        if (!this.state.dragging)
          throw new Error("onDrag called before onDragStart.");
        let _ = this.state.dragging.top + v, w = this.state.dragging.left + y;
        const {
          isBounded: x,
          i: E,
          w: S,
          h: C,
          containerWidth: R
        } = this.props, P = this.getPositionParams();
        if (x) {
          const {
            offsetParent: k
          } = g;
          if (k) {
            const {
              margin: T,
              rowHeight: I,
              containerPadding: j
            } = this.props, z = k.clientHeight - (0, i.calcGridItemWHPx)(C, I, T[1]);
            _ = (0, i.clamp)(_ - j[1], 0, z);
            const $ = (0, i.calcGridColWidth)(P), D = R - (0, i.calcGridItemWHPx)(S, $, T[0]);
            w = (0, i.clamp)(w - j[0], 0, D);
          }
        }
        const N = {
          top: _,
          left: w
        };
        this.setState({
          dragging: N
        });
        const {
          x: A,
          y: O
        } = (0, i.calcXY)(P, _, w, S, C);
        return b.call(this, E, A, O, {
          e: p,
          node: g,
          newPosition: N
        });
      }), c(this, "onDragStop", (p, m) => {
        let {
          node: g
        } = m;
        const {
          onDragStop: y
        } = this.props;
        if (!y) return;
        if (!this.state.dragging)
          throw new Error("onDragEnd called before onDragStart.");
        const {
          w: v,
          h: b,
          i: _
        } = this.props, {
          left: w,
          top: x
        } = this.state.dragging, E = {
          top: x,
          left: w
        };
        this.setState({
          dragging: null
        });
        const {
          x: S,
          y: C
        } = (0, i.calcXY)(this.getPositionParams(), x, w, v, b);
        return y.call(this, _, S, C, {
          e: p,
          node: g,
          newPosition: E
        });
      }), c(this, "onResizeStop", (p, m, g) => this.onResizeHandler(p, m, g, "onResizeStop")), c(this, "onResizeStart", (p, m, g) => this.onResizeHandler(p, m, g, "onResizeStart")), c(this, "onResize", (p, m, g) => this.onResizeHandler(p, m, g, "onResize"));
    }
    shouldComponentUpdate(p, m) {
      if (this.props.children !== p.children || this.props.droppingPosition !== p.droppingPosition) return !0;
      const g = (0, i.calcGridItemPosition)(this.getPositionParams(this.props), this.props.x, this.props.y, this.props.w, this.props.h, this.state), y = (0, i.calcGridItemPosition)(this.getPositionParams(p), p.x, p.y, p.w, p.h, m);
      return !(0, o.fastPositionEqual)(g, y) || this.props.useCSSTransforms !== p.useCSSTransforms;
    }
    componentDidMount() {
      this.moveDroppingItem({});
    }
    componentDidUpdate(p) {
      this.moveDroppingItem(p);
    }
    // When a droppingPosition is present, this means we should fire a move event, as if we had moved
    // this element by `x, y` pixels.
    moveDroppingItem(p) {
      const {
        droppingPosition: m
      } = this.props;
      if (!m) return;
      const g = this.elementRef.current;
      if (!g) return;
      const y = p.droppingPosition || {
        left: 0,
        top: 0
      }, {
        dragging: v
      } = this.state, b = v && m.left !== y.left || m.top !== y.top;
      if (!v)
        this.onDragStart(m.e, {
          node: g,
          deltaX: m.left,
          deltaY: m.top
        });
      else if (b) {
        const _ = m.left - v.left, w = m.top - v.top;
        this.onDrag(m.e, {
          node: g,
          deltaX: _,
          deltaY: w
        });
      }
    }
    getPositionParams() {
      let p = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.props;
      return {
        cols: p.cols,
        containerPadding: p.containerPadding,
        containerWidth: p.containerWidth,
        margin: p.margin,
        maxRows: p.maxRows,
        rowHeight: p.rowHeight
      };
    }
    /**
     * This is where we set the grid item's absolute placement. It gets a little tricky because we want to do it
     * well when server rendering, and the only way to do that properly is to use percentage width/left because
     * we don't know exactly what the browser viewport is.
     * Unfortunately, CSS Transforms, which are great for performance, break in this instance because a percentage
     * left is relative to the item itself, not its container! So we cannot use them on the server rendering pass.
     *
     * @param  {Object} pos Position object with width, height, left, top.
     * @return {Object}     Style object.
     */
    createStyle(p) {
      const {
        usePercentages: m,
        containerWidth: g,
        useCSSTransforms: y
      } = this.props;
      let v;
      return y ? v = (0, o.setTransform)(p) : (v = (0, o.setTopLeft)(p), m && (v.left = (0, o.perc)(p.left / g), v.width = (0, o.perc)(p.width / g))), v;
    }
    /**
     * Mix a Draggable instance into a child.
     * @param  {Element} child    Child element.
     * @return {Element}          Child wrapped in Draggable.
     */
    mixinDraggable(p, m) {
      return /* @__PURE__ */ t.default.createElement(n.DraggableCore, {
        disabled: !m,
        onStart: this.onDragStart,
        onDrag: this.onDrag,
        onStop: this.onDragStop,
        handle: this.props.handle,
        cancel: ".react-resizable-handle" + (this.props.cancel ? "," + this.props.cancel : ""),
        scale: this.props.transformScale,
        nodeRef: this.elementRef
      }, p);
    }
    /**
     * Utility function to setup callback handler definitions for
     * similarily structured resize events.
     */
    curryResizeHandler(p, m) {
      return (g, y) => (
        /*: Function*/
        m(g, y, p)
      );
    }
    /**
     * Mix a Resizable instance into a child.
     * @param  {Element} child    Child element.
     * @param  {Object} position  Position object (pixel values)
     * @return {Element}          Child wrapped in Resizable.
     */
    mixinResizable(p, m, g) {
      const {
        cols: y,
        minW: v,
        minH: b,
        maxW: _,
        maxH: w,
        transformScale: x,
        resizeHandles: E,
        resizeHandle: S
      } = this.props, C = this.getPositionParams(), R = (0, i.calcGridItemPosition)(C, 0, 0, y, 0).width, P = (0, i.calcGridItemPosition)(C, 0, 0, v, b), N = (0, i.calcGridItemPosition)(C, 0, 0, _, w), A = [P.width, P.height], O = [Math.min(N.width, R), Math.min(N.height, 1 / 0)];
      return /* @__PURE__ */ t.default.createElement(
        r.Resizable,
        {
          draggableOpts: {
            disabled: !g
          },
          className: g ? void 0 : "react-resizable-hide",
          width: m.width,
          height: m.height,
          minConstraints: A,
          maxConstraints: O,
          onResizeStop: this.curryResizeHandler(m, this.onResizeStop),
          onResizeStart: this.curryResizeHandler(m, this.onResizeStart),
          onResize: this.curryResizeHandler(m, this.onResize),
          transformScale: x,
          resizeHandles: E,
          handle: S
        },
        p
      );
    }
    /**
     * Wrapper around resize events to provide more useful data.
     */
    onResizeHandler(p, m, g, y) {
      let {
        node: v,
        size: b,
        handle: _
      } = m;
      const w = this.props[y];
      if (!w) return;
      const {
        x,
        y: E,
        i: S,
        maxH: C,
        minH: R,
        containerWidth: P
      } = this.props, {
        minW: N,
        maxW: A
      } = this.props;
      let O = b;
      v && (O = (0, o.resizeItemInDirection)(_, g, b, P), this.setState({
        resizing: y === "onResizeStop" ? null : O
      }));
      let {
        w: k,
        h: T
      } = (0, i.calcWH)(this.getPositionParams(), O.width, O.height, x, E, _);
      k = (0, i.clamp)(k, Math.max(N, 1), A), T = (0, i.clamp)(T, R, C), w.call(this, S, k, T, {
        e: p,
        node: v,
        size: O,
        handle: _
      });
    }
    render() {
      const {
        x: p,
        y: m,
        w: g,
        h: y,
        isDraggable: v,
        isResizable: b,
        droppingPosition: _,
        useCSSTransforms: w
      } = this.props, x = (0, i.calcGridItemPosition)(this.getPositionParams(), p, m, g, y, this.state), E = t.default.Children.only(this.props.children);
      let S = /* @__PURE__ */ t.default.cloneElement(E, {
        ref: this.elementRef,
        className: (0, a.default)("react-grid-item", E.props.className, this.props.className, {
          static: this.props.static,
          resizing: !!this.state.resizing,
          "react-draggable": v,
          "react-draggable-dragging": !!this.state.dragging,
          dropping: !!_,
          cssTransforms: w
        }),
        // We can set the width and height on the child, but unfortunately we can't set the position.
        style: {
          ...this.props.style,
          ...E.props.style,
          ...this.createStyle(x)
        }
      });
      return S = this.mixinResizable(S, x, b), S = this.mixinDraggable(S, v), S;
    }
  };
  return rg.default = f, c(f, "propTypes", {
    // Children must be only a single element
    children: e.default.element,
    // General grid attributes
    cols: e.default.number.isRequired,
    containerWidth: e.default.number.isRequired,
    rowHeight: e.default.number.isRequired,
    margin: e.default.array.isRequired,
    maxRows: e.default.number.isRequired,
    containerPadding: e.default.array.isRequired,
    // These are all in grid units
    x: e.default.number.isRequired,
    y: e.default.number.isRequired,
    w: e.default.number.isRequired,
    h: e.default.number.isRequired,
    // All optional
    minW: function(h, p) {
      const m = h[p];
      if (typeof m != "number") return new Error("minWidth not Number");
      if (m > h.w || m > h.maxW) return new Error("minWidth larger than item width/maxWidth");
    },
    maxW: function(h, p) {
      const m = h[p];
      if (typeof m != "number") return new Error("maxWidth not Number");
      if (m < h.w || m < h.minW) return new Error("maxWidth smaller than item width/minWidth");
    },
    minH: function(h, p) {
      const m = h[p];
      if (typeof m != "number") return new Error("minHeight not Number");
      if (m > h.h || m > h.maxH) return new Error("minHeight larger than item height/maxHeight");
    },
    maxH: function(h, p) {
      const m = h[p];
      if (typeof m != "number") return new Error("maxHeight not Number");
      if (m < h.h || m < h.minH) return new Error("maxHeight smaller than item height/minHeight");
    },
    // ID is nice to have for callbacks
    i: e.default.string.isRequired,
    // Resize handle options
    resizeHandles: s.resizeHandleAxesType,
    resizeHandle: s.resizeHandleType,
    // Functions
    onDragStop: e.default.func,
    onDragStart: e.default.func,
    onDrag: e.default.func,
    onResizeStop: e.default.func,
    onResizeStart: e.default.func,
    onResize: e.default.func,
    // Flags
    isDraggable: e.default.bool.isRequired,
    isResizable: e.default.bool.isRequired,
    isBounded: e.default.bool.isRequired,
    static: e.default.bool,
    // Use CSS transforms instead of top/left
    useCSSTransforms: e.default.bool.isRequired,
    transformScale: e.default.number,
    // Others
    className: e.default.string,
    // Selector for draggable handle
    handle: e.default.string,
    // Selector for draggable cancel (see react-draggable)
    cancel: e.default.string,
    // Current position of a dropping element
    droppingPosition: e.default.shape({
      e: e.default.object.isRequired,
      left: e.default.number.isRequired,
      top: e.default.number.isRequired
    })
  }), c(f, "defaultProps", {
    className: "",
    cancel: "",
    handle: "",
    minH: 1,
    minW: 1,
    maxH: 1 / 0,
    maxW: 1 / 0,
    transformScale: 1
  }), rg;
}
var Sse;
function Iwe() {
  if (Sse) return ng;
  Sse = 1, Object.defineProperty(ng, "__esModule", {
    value: !0
  }), ng.default = void 0;
  var t = c(xe), e = /* @__PURE__ */ O9(), n = a(C9()), r = Vp(), o = k9(), i = a(QCt()), s = a(Dwe());
  function a(g) {
    return g && g.__esModule ? g : { default: g };
  }
  function l(g) {
    if (typeof WeakMap != "function") return null;
    var y = /* @__PURE__ */ new WeakMap(), v = /* @__PURE__ */ new WeakMap();
    return (l = function(b) {
      return b ? v : y;
    })(g);
  }
  function c(g, y) {
    if (g && g.__esModule) return g;
    if (g === null || typeof g != "object" && typeof g != "function") return { default: g };
    var v = l(y);
    if (v && v.has(g)) return v.get(g);
    var b = { __proto__: null }, _ = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var w in g) if (w !== "default" && Object.prototype.hasOwnProperty.call(g, w)) {
      var x = _ ? Object.getOwnPropertyDescriptor(g, w) : null;
      x && (x.get || x.set) ? Object.defineProperty(b, w, x) : b[w] = g[w];
    }
    return b.default = g, v && v.set(g, b), b;
  }
  function u(g, y, v) {
    return y = d(y), y in g ? Object.defineProperty(g, y, { value: v, enumerable: !0, configurable: !0, writable: !0 }) : g[y] = v, g;
  }
  function d(g) {
    var y = f(g, "string");
    return typeof y == "symbol" ? y : String(y);
  }
  function f(g, y) {
    if (typeof g != "object" || g === null) return g;
    var v = g[Symbol.toPrimitive];
    if (v !== void 0) {
      var b = v.call(g, y || "default");
      if (typeof b != "object") return b;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (y === "string" ? String : Number)(g);
  }
  const h = "react-grid-layout";
  let p = !1;
  try {
    p = /firefox/i.test(navigator.userAgent);
  } catch {
  }
  let m = class extends t.Component {
    constructor() {
      super(...arguments), u(this, "state", {
        activeDrag: null,
        layout: (0, r.synchronizeLayoutWithChildren)(
          this.props.layout,
          this.props.children,
          this.props.cols,
          // Legacy support for verticalCompact: false
          (0, r.compactType)(this.props),
          this.props.allowOverlap
        ),
        mounted: !1,
        oldDragItem: null,
        oldLayout: null,
        oldResizeItem: null,
        resizing: !1,
        droppingDOMNode: null,
        children: []
      }), u(this, "dragEnterCounter", 0), u(this, "onDragStart", (y, v, b, _) => {
        let {
          e: w,
          node: x
        } = _;
        const {
          layout: E
        } = this.state, S = (0, r.getLayoutItem)(E, y);
        if (!S) return;
        const C = {
          w: S.w,
          h: S.h,
          x: S.x,
          y: S.y,
          placeholder: !0,
          i: y
        };
        return this.setState({
          oldDragItem: (0, r.cloneLayoutItem)(S),
          oldLayout: E,
          activeDrag: C
        }), this.props.onDragStart(E, S, S, null, w, x);
      }), u(this, "onDrag", (y, v, b, _) => {
        let {
          e: w,
          node: x
        } = _;
        const {
          oldDragItem: E
        } = this.state;
        let {
          layout: S
        } = this.state;
        const {
          cols: C,
          allowOverlap: R,
          preventCollision: P
        } = this.props, N = (0, r.getLayoutItem)(S, y);
        if (!N) return;
        const A = {
          w: N.w,
          h: N.h,
          x: N.x,
          y: N.y,
          placeholder: !0,
          i: y
        };
        S = (0, r.moveElement)(S, N, v, b, !0, P, (0, r.compactType)(this.props), C, R), this.props.onDrag(S, E, N, A, w, x), this.setState({
          layout: R ? S : (0, r.compact)(S, (0, r.compactType)(this.props), C),
          activeDrag: A
        });
      }), u(this, "onDragStop", (y, v, b, _) => {
        let {
          e: w,
          node: x
        } = _;
        if (!this.state.activeDrag) return;
        const {
          oldDragItem: E
        } = this.state;
        let {
          layout: S
        } = this.state;
        const {
          cols: C,
          preventCollision: R,
          allowOverlap: P
        } = this.props, N = (0, r.getLayoutItem)(S, y);
        if (!N) return;
        S = (0, r.moveElement)(S, N, v, b, !0, R, (0, r.compactType)(this.props), C, P);
        const O = P ? S : (0, r.compact)(S, (0, r.compactType)(this.props), C);
        this.props.onDragStop(O, E, N, null, w, x);
        const {
          oldLayout: k
        } = this.state;
        this.setState({
          activeDrag: null,
          layout: O,
          oldDragItem: null,
          oldLayout: null
        }), this.onLayoutMaybeChanged(O, k);
      }), u(this, "onResizeStart", (y, v, b, _) => {
        let {
          e: w,
          node: x
        } = _;
        const {
          layout: E
        } = this.state, S = (0, r.getLayoutItem)(E, y);
        S && (this.setState({
          oldResizeItem: (0, r.cloneLayoutItem)(S),
          oldLayout: this.state.layout,
          resizing: !0
        }), this.props.onResizeStart(E, S, S, null, w, x));
      }), u(this, "onResize", (y, v, b, _) => {
        let {
          e: w,
          node: x,
          size: E,
          handle: S
        } = _;
        const {
          oldResizeItem: C
        } = this.state, {
          layout: R
        } = this.state, {
          cols: P,
          preventCollision: N,
          allowOverlap: A
        } = this.props;
        let O = !1, k, T, I;
        const [j, z] = (0, r.withLayoutItem)(R, y, (D) => {
          let U;
          return T = D.x, I = D.y, ["sw", "w", "nw", "n", "ne"].indexOf(S) !== -1 && (["sw", "nw", "w"].indexOf(S) !== -1 && (T = D.x + (D.w - v), v = D.x !== T && T < 0 ? D.w : v, T = T < 0 ? 0 : T), ["ne", "n", "nw"].indexOf(S) !== -1 && (I = D.y + (D.h - b), b = D.y !== I && I < 0 ? D.h : b, I = I < 0 ? 0 : I), O = !0), N && !A && (U = (0, r.getAllCollisions)(R, {
            ...D,
            w: v,
            h: b,
            x: T,
            y: I
          }).filter((F) => F.i !== D.i).length > 0, U && (I = D.y, b = D.h, T = D.x, v = D.w, O = !1)), D.w = v, D.h = b, D;
        });
        if (!z) return;
        k = j, O && (k = (0, r.moveElement)(j, z, T, I, !0, this.props.preventCollision, (0, r.compactType)(this.props), P, A));
        const $ = {
          w: z.w,
          h: z.h,
          x: z.x,
          y: z.y,
          static: !0,
          i: y
        };
        this.props.onResize(k, C, z, $, w, x), this.setState({
          layout: A ? k : (0, r.compact)(k, (0, r.compactType)(this.props), P),
          activeDrag: $
        });
      }), u(this, "onResizeStop", (y, v, b, _) => {
        let {
          e: w,
          node: x
        } = _;
        const {
          layout: E,
          oldResizeItem: S
        } = this.state, {
          cols: C,
          allowOverlap: R
        } = this.props, P = (0, r.getLayoutItem)(E, y), N = R ? E : (0, r.compact)(E, (0, r.compactType)(this.props), C);
        this.props.onResizeStop(N, S, P, null, w, x);
        const {
          oldLayout: A
        } = this.state;
        this.setState({
          activeDrag: null,
          layout: N,
          oldResizeItem: null,
          oldLayout: null,
          resizing: !1
        }), this.onLayoutMaybeChanged(N, A);
      }), u(this, "onDragOver", (y) => {
        if (y.preventDefault(), y.stopPropagation(), p && // $FlowIgnore can't figure this out
        !y.nativeEvent.target?.classList.contains(h))
          return !1;
        const {
          droppingItem: v,
          onDropDragOver: b,
          margin: _,
          cols: w,
          rowHeight: x,
          maxRows: E,
          width: S,
          containerPadding: C,
          transformScale: R
        } = this.props, P = b?.(y);
        if (P === !1)
          return this.state.droppingDOMNode && this.removeDroppingPlaceholder(), !1;
        const N = {
          ...v,
          ...P
        }, {
          layout: A
        } = this.state, O = y.currentTarget.getBoundingClientRect(), k = y.clientX - O.left, T = y.clientY - O.top, I = {
          left: k / R,
          top: T / R,
          e: y
        };
        if (this.state.droppingDOMNode) {
          if (this.state.droppingPosition) {
            const {
              left: j,
              top: z
            } = this.state.droppingPosition;
            (j != k || z != T) && this.setState({
              droppingPosition: I
            });
          }
        } else {
          const j = {
            cols: w,
            margin: _,
            maxRows: E,
            rowHeight: x,
            containerWidth: S,
            containerPadding: C || _
          }, z = (0, o.calcXY)(j, T, k, N.w, N.h);
          this.setState({
            droppingDOMNode: /* @__PURE__ */ t.createElement("div", {
              key: N.i
            }),
            droppingPosition: I,
            layout: [...A, {
              ...N,
              x: z.x,
              y: z.y,
              static: !1,
              isDraggable: !0
            }]
          });
        }
      }), u(this, "removeDroppingPlaceholder", () => {
        const {
          droppingItem: y,
          cols: v
        } = this.props, {
          layout: b
        } = this.state, _ = (0, r.compact)(b.filter((w) => w.i !== y.i), (0, r.compactType)(this.props), v, this.props.allowOverlap);
        this.setState({
          layout: _,
          droppingDOMNode: null,
          activeDrag: null,
          droppingPosition: void 0
        });
      }), u(this, "onDragLeave", (y) => {
        y.preventDefault(), y.stopPropagation(), this.dragEnterCounter--, this.dragEnterCounter === 0 && this.removeDroppingPlaceholder();
      }), u(this, "onDragEnter", (y) => {
        y.preventDefault(), y.stopPropagation(), this.dragEnterCounter++;
      }), u(this, "onDrop", (y) => {
        y.preventDefault(), y.stopPropagation();
        const {
          droppingItem: v
        } = this.props, {
          layout: b
        } = this.state, _ = b.find((w) => w.i === v.i);
        this.dragEnterCounter = 0, this.removeDroppingPlaceholder(), this.props.onDrop(b, _, y);
      });
    }
    componentDidMount() {
      this.setState({
        mounted: !0
      }), this.onLayoutMaybeChanged(this.state.layout, this.props.layout);
    }
    static getDerivedStateFromProps(y, v) {
      let b;
      return v.activeDrag ? null : (!(0, e.deepEqual)(y.layout, v.propsLayout) || y.compactType !== v.compactType ? b = y.layout : (0, r.childrenEqual)(y.children, v.children) || (b = v.layout), b ? {
        layout: (0, r.synchronizeLayoutWithChildren)(b, y.children, y.cols, (0, r.compactType)(y), y.allowOverlap),
        // We need to save these props to state for using
        // getDerivedStateFromProps instead of componentDidMount (in which we would get extra rerender)
        compactType: y.compactType,
        children: y.children,
        propsLayout: y.layout
      } : null);
    }
    shouldComponentUpdate(y, v) {
      return (
        // NOTE: this is almost always unequal. Therefore the only way to get better performance
        // from SCU is if the user intentionally memoizes children. If they do, and they can
        // handle changes properly, performance will increase.
        this.props.children !== y.children || !(0, r.fastRGLPropsEqual)(this.props, y, e.deepEqual) || this.state.activeDrag !== v.activeDrag || this.state.mounted !== v.mounted || this.state.droppingPosition !== v.droppingPosition
      );
    }
    componentDidUpdate(y, v) {
      if (!this.state.activeDrag) {
        const b = this.state.layout, _ = v.layout;
        this.onLayoutMaybeChanged(b, _);
      }
    }
    /**
     * Calculates a pixel value for the container.
     * @return {String} Container height in pixels.
     */
    containerHeight() {
      if (!this.props.autoSize) return;
      const y = (0, r.bottom)(this.state.layout), v = this.props.containerPadding ? this.props.containerPadding[1] : this.props.margin[1];
      return y * this.props.rowHeight + (y - 1) * this.props.margin[1] + v * 2 + "px";
    }
    onLayoutMaybeChanged(y, v) {
      v || (v = this.state.layout), (0, e.deepEqual)(v, y) || this.props.onLayoutChange(y);
    }
    /**
     * Create a placeholder object.
     * @return {Element} Placeholder div.
     */
    placeholder() {
      const {
        activeDrag: y
      } = this.state;
      if (!y) return null;
      const {
        width: v,
        cols: b,
        margin: _,
        containerPadding: w,
        rowHeight: x,
        maxRows: E,
        useCSSTransforms: S,
        transformScale: C
      } = this.props;
      return /* @__PURE__ */ t.createElement(i.default, {
        w: y.w,
        h: y.h,
        x: y.x,
        y: y.y,
        i: y.i,
        className: `react-grid-placeholder ${this.state.resizing ? "placeholder-resizing" : ""}`,
        containerWidth: v,
        cols: b,
        margin: _,
        containerPadding: w || _,
        maxRows: E,
        rowHeight: x,
        isDraggable: !1,
        isResizable: !1,
        isBounded: !1,
        useCSSTransforms: S,
        transformScale: C
      }, /* @__PURE__ */ t.createElement("div", null));
    }
    /**
     * Given a grid item, set its style attributes & surround in a <Draggable>.
     * @param  {Element} child React element.
     * @return {Element}       Element wrapped in draggable and properly placed.
     */
    processGridItem(y, v) {
      if (!y || !y.key) return;
      const b = (0, r.getLayoutItem)(this.state.layout, String(y.key));
      if (!b) return null;
      const {
        width: _,
        cols: w,
        margin: x,
        containerPadding: E,
        rowHeight: S,
        maxRows: C,
        isDraggable: R,
        isResizable: P,
        isBounded: N,
        useCSSTransforms: A,
        transformScale: O,
        draggableCancel: k,
        draggableHandle: T,
        resizeHandles: I,
        resizeHandle: j
      } = this.props, {
        mounted: z,
        droppingPosition: $
      } = this.state, D = typeof b.isDraggable == "boolean" ? b.isDraggable : !b.static && R, U = typeof b.isResizable == "boolean" ? b.isResizable : !b.static && P, q = b.resizeHandles || I, F = D && N && b.isBounded !== !1;
      return /* @__PURE__ */ t.createElement(i.default, {
        containerWidth: _,
        cols: w,
        margin: x,
        containerPadding: E || x,
        maxRows: C,
        rowHeight: S,
        cancel: k,
        handle: T,
        onDragStop: this.onDragStop,
        onDragStart: this.onDragStart,
        onDrag: this.onDrag,
        onResizeStart: this.onResizeStart,
        onResize: this.onResize,
        onResizeStop: this.onResizeStop,
        isDraggable: D,
        isResizable: U,
        isBounded: F,
        useCSSTransforms: A && z,
        usePercentages: !z,
        transformScale: O,
        w: b.w,
        h: b.h,
        x: b.x,
        y: b.y,
        i: b.i,
        minH: b.minH,
        minW: b.minW,
        maxH: b.maxH,
        maxW: b.maxW,
        static: b.static,
        droppingPosition: v ? $ : void 0,
        resizeHandles: q,
        resizeHandle: j
      }, y);
    }
    render() {
      const {
        className: y,
        style: v,
        isDroppable: b,
        innerRef: _
      } = this.props, w = (0, n.default)(h, y), x = {
        height: this.containerHeight(),
        ...v
      };
      return /* @__PURE__ */ t.createElement("div", {
        ref: _,
        className: w,
        style: x,
        onDrop: b ? this.onDrop : r.noop,
        onDragLeave: b ? this.onDragLeave : r.noop,
        onDragEnter: b ? this.onDragEnter : r.noop,
        onDragOver: b ? this.onDragOver : r.noop
      }, t.Children.map(this.props.children, (E) => this.processGridItem(E)), b && this.state.droppingDOMNode && this.processGridItem(this.state.droppingDOMNode, !0), this.placeholder());
    }
  };
  return ng.default = m, u(m, "displayName", "ReactGridLayout"), u(m, "propTypes", s.default), u(m, "defaultProps", {
    autoSize: !0,
    cols: 12,
    className: "",
    style: {},
    draggableHandle: "",
    draggableCancel: "",
    containerPadding: null,
    rowHeight: 150,
    maxRows: 1 / 0,
    // infinite vertical growth
    layout: [],
    margin: [10, 10],
    isBounded: !1,
    isDraggable: !0,
    isResizable: !0,
    allowOverlap: !1,
    isDroppable: !1,
    useCSSTransforms: !0,
    transformScale: 1,
    verticalCompact: !0,
    compactType: "vertical",
    preventCollision: !1,
    droppingItem: {
      i: "__dropping-elem__",
      h: 1,
      w: 1
    },
    resizeHandles: ["se"],
    onLayoutChange: r.noop,
    onDragStart: r.noop,
    onDrag: r.noop,
    onDragStop: r.noop,
    onResizeStart: r.noop,
    onResize: r.noop,
    onResizeStop: r.noop,
    onDrop: r.noop,
    onDropDragOver: r.noop
  }), ng;
}
var ug = {}, Mu = {}, Ose;
function Nwe() {
  if (Ose) return Mu;
  Ose = 1, Object.defineProperty(Mu, "__esModule", {
    value: !0
  }), Mu.findOrGenerateResponsiveLayout = r, Mu.getBreakpointFromWidth = e, Mu.getColsFromBreakpoint = n, Mu.sortBreakpoints = o;
  var t = Vp();
  function e(i, s) {
    const a = o(i);
    let l = a[0];
    for (let c = 1, u = a.length; c < u; c++) {
      const d = a[c];
      s > i[d] && (l = d);
    }
    return l;
  }
  function n(i, s) {
    if (!s[i])
      throw new Error("ResponsiveReactGridLayout: `cols` entry for breakpoint " + i + " is missing!");
    return s[i];
  }
  function r(i, s, a, l, c, u) {
    if (i[a]) return (0, t.cloneLayout)(i[a]);
    let d = i[l];
    const f = o(s), h = f.slice(f.indexOf(a));
    for (let p = 0, m = h.length; p < m; p++) {
      const g = h[p];
      if (i[g]) {
        d = i[g];
        break;
      }
    }
    return d = (0, t.cloneLayout)(d || []), (0, t.compact)((0, t.correctBounds)(d, {
      cols: c
    }), u, c);
  }
  function o(i) {
    return Object.keys(i).sort(function(a, l) {
      return i[a] - i[l];
    });
  }
  return Mu;
}
var Cse;
function ZCt() {
  if (Cse) return ug;
  Cse = 1, Object.defineProperty(ug, "__esModule", {
    value: !0
  }), ug.default = void 0;
  var t = l(xe), e = s(/* @__PURE__ */ hu()), n = /* @__PURE__ */ O9(), r = Vp(), o = Nwe(), i = s(Iwe());
  function s(g) {
    return g && g.__esModule ? g : { default: g };
  }
  function a(g) {
    if (typeof WeakMap != "function") return null;
    var y = /* @__PURE__ */ new WeakMap(), v = /* @__PURE__ */ new WeakMap();
    return (a = function(b) {
      return b ? v : y;
    })(g);
  }
  function l(g, y) {
    if (g && g.__esModule) return g;
    if (g === null || typeof g != "object" && typeof g != "function") return { default: g };
    var v = a(y);
    if (v && v.has(g)) return v.get(g);
    var b = { __proto__: null }, _ = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var w in g) if (w !== "default" && Object.prototype.hasOwnProperty.call(g, w)) {
      var x = _ ? Object.getOwnPropertyDescriptor(g, w) : null;
      x && (x.get || x.set) ? Object.defineProperty(b, w, x) : b[w] = g[w];
    }
    return b.default = g, v && v.set(g, b), b;
  }
  function c() {
    return c = Object.assign ? Object.assign.bind() : function(g) {
      for (var y = 1; y < arguments.length; y++) {
        var v = arguments[y];
        for (var b in v)
          Object.prototype.hasOwnProperty.call(v, b) && (g[b] = v[b]);
      }
      return g;
    }, c.apply(this, arguments);
  }
  function u(g, y, v) {
    return y = d(y), y in g ? Object.defineProperty(g, y, { value: v, enumerable: !0, configurable: !0, writable: !0 }) : g[y] = v, g;
  }
  function d(g) {
    var y = f(g, "string");
    return typeof y == "symbol" ? y : String(y);
  }
  function f(g, y) {
    if (typeof g != "object" || g === null) return g;
    var v = g[Symbol.toPrimitive];
    if (v !== void 0) {
      var b = v.call(g, y || "default");
      if (typeof b != "object") return b;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (y === "string" ? String : Number)(g);
  }
  const h = (g) => Object.prototype.toString.call(g);
  function p(g, y) {
    return g == null ? null : Array.isArray(g) ? g : g[y];
  }
  let m = class extends t.Component {
    constructor() {
      super(...arguments), u(this, "state", this.generateInitialState()), u(this, "onLayoutChange", (y) => {
        this.props.onLayoutChange(y, {
          ...this.props.layouts,
          [this.state.breakpoint]: y
        });
      });
    }
    generateInitialState() {
      const {
        width: y,
        breakpoints: v,
        layouts: b,
        cols: _
      } = this.props, w = (0, o.getBreakpointFromWidth)(v, y), x = (0, o.getColsFromBreakpoint)(w, _), E = this.props.verticalCompact === !1 ? null : this.props.compactType;
      return {
        layout: (0, o.findOrGenerateResponsiveLayout)(b, v, w, w, x, E),
        breakpoint: w,
        cols: x
      };
    }
    static getDerivedStateFromProps(y, v) {
      if (!(0, n.deepEqual)(y.layouts, v.layouts)) {
        const {
          breakpoint: b,
          cols: _
        } = v;
        return {
          layout: (0, o.findOrGenerateResponsiveLayout)(y.layouts, y.breakpoints, b, b, _, y.compactType),
          layouts: y.layouts
        };
      }
      return null;
    }
    componentDidUpdate(y) {
      (this.props.width != y.width || this.props.breakpoint !== y.breakpoint || !(0, n.deepEqual)(this.props.breakpoints, y.breakpoints) || !(0, n.deepEqual)(this.props.cols, y.cols)) && this.onWidthChange(y);
    }
    /**
     * When the width changes work through breakpoints and reset state with the new width & breakpoint.
     * Width changes are necessary to figure out the widget widths.
     */
    onWidthChange(y) {
      const {
        breakpoints: v,
        cols: b,
        layouts: _,
        compactType: w
      } = this.props, x = this.props.breakpoint || (0, o.getBreakpointFromWidth)(this.props.breakpoints, this.props.width), E = this.state.breakpoint, S = (0, o.getColsFromBreakpoint)(x, b), C = {
        ..._
      };
      if (E !== x || y.breakpoints !== v || y.cols !== b) {
        E in C || (C[E] = (0, r.cloneLayout)(this.state.layout));
        let N = (0, o.findOrGenerateResponsiveLayout)(C, v, x, E, S, w);
        N = (0, r.synchronizeLayoutWithChildren)(N, this.props.children, S, w, this.props.allowOverlap), C[x] = N, this.props.onBreakpointChange(x, S), this.props.onLayoutChange(N, C), this.setState({
          breakpoint: x,
          layout: N,
          cols: S
        });
      }
      const R = p(this.props.margin, x), P = p(this.props.containerPadding, x);
      this.props.onWidthChange(this.props.width, R, S, P);
    }
    render() {
      const {
        breakpoint: y,
        breakpoints: v,
        cols: b,
        layouts: _,
        margin: w,
        containerPadding: x,
        onBreakpointChange: E,
        onLayoutChange: S,
        onWidthChange: C,
        ...R
      } = this.props;
      return /* @__PURE__ */ t.createElement(i.default, c({}, R, {
        // $FlowIgnore should allow nullable here due to DefaultProps
        margin: p(w, this.state.breakpoint),
        containerPadding: p(x, this.state.breakpoint),
        onLayoutChange: this.onLayoutChange,
        layout: this.state.layout,
        cols: this.state.cols
      }));
    }
  };
  return ug.default = m, u(m, "propTypes", {
    //
    // Basic props
    //
    // Optional, but if you are managing width yourself you may want to set the breakpoint
    // yourself as well.
    breakpoint: e.default.string,
    // {name: pxVal}, e.g. {lg: 1200, md: 996, sm: 768, xs: 480}
    breakpoints: e.default.object,
    allowOverlap: e.default.bool,
    // # of cols. This is a breakpoint -> cols map
    cols: e.default.object,
    // # of margin. This is a breakpoint -> margin map
    // e.g. { lg: [5, 5], md: [10, 10], sm: [15, 15] }
    // Margin between items [x, y] in px
    // e.g. [10, 10]
    margin: e.default.oneOfType([e.default.array, e.default.object]),
    // # of containerPadding. This is a breakpoint -> containerPadding map
    // e.g. { lg: [5, 5], md: [10, 10], sm: [15, 15] }
    // Padding inside the container [x, y] in px
    // e.g. [10, 10]
    containerPadding: e.default.oneOfType([e.default.array, e.default.object]),
    // layouts is an object mapping breakpoints to layouts.
    // e.g. {lg: Layout, md: Layout, ...}
    layouts(g, y) {
      if (h(g[y]) !== "[object Object]")
        throw new Error("Layout property must be an object. Received: " + h(g[y]));
      Object.keys(g[y]).forEach((v) => {
        if (!(v in g.breakpoints))
          throw new Error("Each key in layouts must align with a key in breakpoints.");
        (0, r.validateLayout)(g.layouts[v], "layouts." + v);
      });
    },
    // The width of this component.
    // Required in this propTypes stanza because generateInitialState() will fail without it.
    width: e.default.number.isRequired,
    //
    // Callbacks
    //
    // Calls back with breakpoint and new # cols
    onBreakpointChange: e.default.func,
    // Callback so you can save the layout.
    // Calls back with (currentLayout, allLayouts). allLayouts are keyed by breakpoint.
    onLayoutChange: e.default.func,
    // Calls back with (containerWidth, margin, cols, containerPadding)
    onWidthChange: e.default.func
  }), u(m, "defaultProps", {
    breakpoints: {
      lg: 1200,
      md: 996,
      sm: 768,
      xs: 480,
      xxs: 0
    },
    cols: {
      lg: 12,
      md: 10,
      sm: 6,
      xs: 4,
      xxs: 2
    },
    containerPadding: {
      lg: null,
      md: null,
      sm: null,
      xs: null,
      xxs: null
    },
    layouts: {},
    margin: [10, 10],
    allowOverlap: !1,
    onBreakpointChange: r.noop,
    onLayoutChange: r.noop,
    onWidthChange: r.noop
  }), ug;
}
var N_ = {}, jwe = function() {
  if (typeof Map < "u")
    return Map;
  function t(e, n) {
    var r = -1;
    return e.some(function(o, i) {
      return o[0] === n ? (r = i, !0) : !1;
    }), r;
  }
  return (
    /** @class */
    function() {
      function e() {
        this.__entries__ = [];
      }
      return Object.defineProperty(e.prototype, "size", {
        /**
         * @returns {boolean}
         */
        get: function() {
          return this.__entries__.length;
        },
        enumerable: !0,
        configurable: !0
      }), e.prototype.get = function(n) {
        var r = t(this.__entries__, n), o = this.__entries__[r];
        return o && o[1];
      }, e.prototype.set = function(n, r) {
        var o = t(this.__entries__, n);
        ~o ? this.__entries__[o][1] = r : this.__entries__.push([n, r]);
      }, e.prototype.delete = function(n) {
        var r = this.__entries__, o = t(r, n);
        ~o && r.splice(o, 1);
      }, e.prototype.has = function(n) {
        return !!~t(this.__entries__, n);
      }, e.prototype.clear = function() {
        this.__entries__.splice(0);
      }, e.prototype.forEach = function(n, r) {
        r === void 0 && (r = null);
        for (var o = 0, i = this.__entries__; o < i.length; o++) {
          var s = i[o];
          n.call(r, s[1], s[0]);
        }
      }, e;
    }()
  );
}(), D3 = typeof window < "u" && typeof document < "u" && window.document === document, YE = function() {
  return typeof global < "u" && global.Math === Math ? global : typeof self < "u" && self.Math === Math ? self : typeof window < "u" && window.Math === Math ? window : Function("return this")();
}(), JCt = function() {
  return typeof requestAnimationFrame == "function" ? requestAnimationFrame.bind(YE) : function(t) {
    return setTimeout(function() {
      return t(Date.now());
    }, 1e3 / 60);
  };
}(), ekt = 2;
function tkt(t, e) {
  var n = !1, r = !1, o = 0;
  function i() {
    n && (n = !1, t()), r && a();
  }
  function s() {
    JCt(i);
  }
  function a() {
    var l = Date.now();
    if (n) {
      if (l - o < ekt)
        return;
      r = !0;
    } else
      n = !0, r = !1, setTimeout(s, e);
    o = l;
  }
  return a;
}
var nkt = 20, rkt = ["top", "right", "bottom", "left", "width", "height", "size", "weight"], okt = typeof MutationObserver < "u", ikt = (
  /** @class */
  function() {
    function t() {
      this.connected_ = !1, this.mutationEventsAdded_ = !1, this.mutationsObserver_ = null, this.observers_ = [], this.onTransitionEnd_ = this.onTransitionEnd_.bind(this), this.refresh = tkt(this.refresh.bind(this), nkt);
    }
    return t.prototype.addObserver = function(e) {
      ~this.observers_.indexOf(e) || this.observers_.push(e), this.connected_ || this.connect_();
    }, t.prototype.removeObserver = function(e) {
      var n = this.observers_, r = n.indexOf(e);
      ~r && n.splice(r, 1), !n.length && this.connected_ && this.disconnect_();
    }, t.prototype.refresh = function() {
      var e = this.updateObservers_();
      e && this.refresh();
    }, t.prototype.updateObservers_ = function() {
      var e = this.observers_.filter(function(n) {
        return n.gatherActive(), n.hasActive();
      });
      return e.forEach(function(n) {
        return n.broadcastActive();
      }), e.length > 0;
    }, t.prototype.connect_ = function() {
      !D3 || this.connected_ || (document.addEventListener("transitionend", this.onTransitionEnd_), window.addEventListener("resize", this.refresh), okt ? (this.mutationsObserver_ = new MutationObserver(this.refresh), this.mutationsObserver_.observe(document, {
        attributes: !0,
        childList: !0,
        characterData: !0,
        subtree: !0
      })) : (document.addEventListener("DOMSubtreeModified", this.refresh), this.mutationEventsAdded_ = !0), this.connected_ = !0);
    }, t.prototype.disconnect_ = function() {
      !D3 || !this.connected_ || (document.removeEventListener("transitionend", this.onTransitionEnd_), window.removeEventListener("resize", this.refresh), this.mutationsObserver_ && this.mutationsObserver_.disconnect(), this.mutationEventsAdded_ && document.removeEventListener("DOMSubtreeModified", this.refresh), this.mutationsObserver_ = null, this.mutationEventsAdded_ = !1, this.connected_ = !1);
    }, t.prototype.onTransitionEnd_ = function(e) {
      var n = e.propertyName, r = n === void 0 ? "" : n, o = rkt.some(function(i) {
        return !!~r.indexOf(i);
      });
      o && this.refresh();
    }, t.getInstance = function() {
      return this.instance_ || (this.instance_ = new t()), this.instance_;
    }, t.instance_ = null, t;
  }()
), Lwe = function(t, e) {
  for (var n = 0, r = Object.keys(e); n < r.length; n++) {
    var o = r[n];
    Object.defineProperty(t, o, {
      value: e[o],
      enumerable: !1,
      writable: !1,
      configurable: !0
    });
  }
  return t;
}, vp = function(t) {
  var e = t && t.ownerDocument && t.ownerDocument.defaultView;
  return e || YE;
}, Fwe = YO(0, 0, 0, 0);
function KE(t) {
  return parseFloat(t) || 0;
}
function kse(t) {
  for (var e = [], n = 1; n < arguments.length; n++)
    e[n - 1] = arguments[n];
  return e.reduce(function(r, o) {
    var i = t["border-" + o + "-width"];
    return r + KE(i);
  }, 0);
}
function skt(t) {
  for (var e = ["top", "right", "bottom", "left"], n = {}, r = 0, o = e; r < o.length; r++) {
    var i = o[r], s = t["padding-" + i];
    n[i] = KE(s);
  }
  return n;
}
function akt(t) {
  var e = t.getBBox();
  return YO(0, 0, e.width, e.height);
}
function lkt(t) {
  var e = t.clientWidth, n = t.clientHeight;
  if (!e && !n)
    return Fwe;
  var r = vp(t).getComputedStyle(t), o = skt(r), i = o.left + o.right, s = o.top + o.bottom, a = KE(r.width), l = KE(r.height);
  if (r.boxSizing === "border-box" && (Math.round(a + i) !== e && (a -= kse(r, "left", "right") + i), Math.round(l + s) !== n && (l -= kse(r, "top", "bottom") + s)), !ukt(t)) {
    var c = Math.round(a + i) - e, u = Math.round(l + s) - n;
    Math.abs(c) !== 1 && (a -= c), Math.abs(u) !== 1 && (l -= u);
  }
  return YO(o.left, o.top, a, l);
}
var ckt = /* @__PURE__ */ function() {
  return typeof SVGGraphicsElement < "u" ? function(t) {
    return t instanceof vp(t).SVGGraphicsElement;
  } : function(t) {
    return t instanceof vp(t).SVGElement && typeof t.getBBox == "function";
  };
}();
function ukt(t) {
  return t === vp(t).document.documentElement;
}
function dkt(t) {
  return D3 ? ckt(t) ? akt(t) : lkt(t) : Fwe;
}
function fkt(t) {
  var e = t.x, n = t.y, r = t.width, o = t.height, i = typeof DOMRectReadOnly < "u" ? DOMRectReadOnly : Object, s = Object.create(i.prototype);
  return Lwe(s, {
    x: e,
    y: n,
    width: r,
    height: o,
    top: n,
    right: e + r,
    bottom: o + n,
    left: e
  }), s;
}
function YO(t, e, n, r) {
  return { x: t, y: e, width: n, height: r };
}
var hkt = (
  /** @class */
  function() {
    function t(e) {
      this.broadcastWidth = 0, this.broadcastHeight = 0, this.contentRect_ = YO(0, 0, 0, 0), this.target = e;
    }
    return t.prototype.isActive = function() {
      var e = dkt(this.target);
      return this.contentRect_ = e, e.width !== this.broadcastWidth || e.height !== this.broadcastHeight;
    }, t.prototype.broadcastRect = function() {
      var e = this.contentRect_;
      return this.broadcastWidth = e.width, this.broadcastHeight = e.height, e;
    }, t;
  }()
), pkt = (
  /** @class */
  /* @__PURE__ */ function() {
    function t(e, n) {
      var r = fkt(n);
      Lwe(this, { target: e, contentRect: r });
    }
    return t;
  }()
), mkt = (
  /** @class */
  function() {
    function t(e, n, r) {
      if (this.activeObservations_ = [], this.observations_ = new jwe(), typeof e != "function")
        throw new TypeError("The callback provided as parameter 1 is not a function.");
      this.callback_ = e, this.controller_ = n, this.callbackCtx_ = r;
    }
    return t.prototype.observe = function(e) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element > "u" || !(Element instanceof Object))) {
        if (!(e instanceof vp(e).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var n = this.observations_;
        n.has(e) || (n.set(e, new hkt(e)), this.controller_.addObserver(this), this.controller_.refresh());
      }
    }, t.prototype.unobserve = function(e) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element > "u" || !(Element instanceof Object))) {
        if (!(e instanceof vp(e).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var n = this.observations_;
        n.has(e) && (n.delete(e), n.size || this.controller_.removeObserver(this));
      }
    }, t.prototype.disconnect = function() {
      this.clearActive(), this.observations_.clear(), this.controller_.removeObserver(this);
    }, t.prototype.gatherActive = function() {
      var e = this;
      this.clearActive(), this.observations_.forEach(function(n) {
        n.isActive() && e.activeObservations_.push(n);
      });
    }, t.prototype.broadcastActive = function() {
      if (this.hasActive()) {
        var e = this.callbackCtx_, n = this.activeObservations_.map(function(r) {
          return new pkt(r.target, r.broadcastRect());
        });
        this.callback_.call(e, n, e), this.clearActive();
      }
    }, t.prototype.clearActive = function() {
      this.activeObservations_.splice(0);
    }, t.prototype.hasActive = function() {
      return this.activeObservations_.length > 0;
    }, t;
  }()
), Bwe = typeof WeakMap < "u" ? /* @__PURE__ */ new WeakMap() : new jwe(), zwe = (
  /** @class */
  /* @__PURE__ */ function() {
    function t(e) {
      if (!(this instanceof t))
        throw new TypeError("Cannot call a class as a function.");
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      var n = ikt.getInstance(), r = new mkt(e, n, this);
      Bwe.set(this, r);
    }
    return t;
  }()
);
[
  "observe",
  "unobserve",
  "disconnect"
].forEach(function(t) {
  zwe.prototype[t] = function() {
    var e;
    return (e = Bwe.get(this))[t].apply(e, arguments);
  };
});
var gkt = function() {
  return typeof YE.ResizeObserver < "u" ? YE.ResizeObserver : zwe;
}();
const ykt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: gkt
}, Symbol.toStringTag, { value: "Module" })), vkt = /* @__PURE__ */ Mse(ykt);
var Ase;
function bkt() {
  if (Ase) return N_;
  Ase = 1, Object.defineProperty(N_, "__esModule", {
    value: !0
  }), N_.default = f;
  var t = s(xe), e = o(/* @__PURE__ */ hu()), n = o(vkt), r = o(C9());
  function o(h) {
    return h && h.__esModule ? h : { default: h };
  }
  function i(h) {
    if (typeof WeakMap != "function") return null;
    var p = /* @__PURE__ */ new WeakMap(), m = /* @__PURE__ */ new WeakMap();
    return (i = function(g) {
      return g ? m : p;
    })(h);
  }
  function s(h, p) {
    if (h && h.__esModule) return h;
    if (h === null || typeof h != "object" && typeof h != "function") return { default: h };
    var m = i(p);
    if (m && m.has(h)) return m.get(h);
    var g = { __proto__: null }, y = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var v in h) if (v !== "default" && Object.prototype.hasOwnProperty.call(h, v)) {
      var b = y ? Object.getOwnPropertyDescriptor(h, v) : null;
      b && (b.get || b.set) ? Object.defineProperty(g, v, b) : g[v] = h[v];
    }
    return g.default = h, m && m.set(h, g), g;
  }
  function a() {
    return a = Object.assign ? Object.assign.bind() : function(h) {
      for (var p = 1; p < arguments.length; p++) {
        var m = arguments[p];
        for (var g in m)
          Object.prototype.hasOwnProperty.call(m, g) && (h[g] = m[g]);
      }
      return h;
    }, a.apply(this, arguments);
  }
  function l(h, p, m) {
    return p = c(p), p in h ? Object.defineProperty(h, p, { value: m, enumerable: !0, configurable: !0, writable: !0 }) : h[p] = m, h;
  }
  function c(h) {
    var p = u(h, "string");
    return typeof p == "symbol" ? p : String(p);
  }
  function u(h, p) {
    if (typeof h != "object" || h === null) return h;
    var m = h[Symbol.toPrimitive];
    if (m !== void 0) {
      var g = m.call(h, p || "default");
      if (typeof g != "object") return g;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (p === "string" ? String : Number)(h);
  }
  const d = "react-grid-layout";
  function f(h) {
    var p;
    return p = class extends t.Component {
      constructor() {
        super(...arguments), l(this, "state", {
          width: 1280
        }), l(this, "elementRef", /* @__PURE__ */ t.createRef()), l(this, "mounted", !1), l(this, "resizeObserver", void 0);
      }
      componentDidMount() {
        this.mounted = !0, this.resizeObserver = new n.default((y) => {
          if (this.elementRef.current instanceof HTMLElement) {
            const b = y[0].contentRect.width;
            this.setState({
              width: b
            });
          }
        });
        const g = this.elementRef.current;
        g instanceof HTMLElement && this.resizeObserver.observe(g);
      }
      componentWillUnmount() {
        this.mounted = !1;
        const g = this.elementRef.current;
        g instanceof HTMLElement && this.resizeObserver.unobserve(g), this.resizeObserver.disconnect();
      }
      render() {
        const {
          measureBeforeMount: g,
          ...y
        } = this.props;
        return g && !this.mounted ? /* @__PURE__ */ t.createElement("div", {
          className: (0, r.default)(this.props.className, d),
          style: this.props.style,
          ref: this.elementRef
        }) : /* @__PURE__ */ t.createElement(h, a({
          innerRef: this.elementRef
        }, y, this.state));
      }
    }, l(p, "defaultProps", {
      measureBeforeMount: !1
    }), l(p, "propTypes", {
      // If true, will not render children until mounted. Useful for getting the exact width before
      // rendering, to prevent any unsightly resizing.
      measureBeforeMount: e.default.bool
    }), p;
  }
  return N_;
}
var Tse;
function _kt() {
  return Tse || (Tse = 1, function(t) {
    t.exports = Iwe().default, t.exports.utils = Vp(), t.exports.calculateUtils = k9(), t.exports.Responsive = ZCt().default, t.exports.Responsive.utils = Nwe(), t.exports.WidthProvider = bkt().default;
  }(ED)), ED.exports;
}
var wkt = _kt();
const jIt = /* @__PURE__ */ Kt(wkt);
export {
  sn as J,
  KRe as R,
  w9 as _,
  sIt as a,
  rIt as b,
  nIt as c,
  tIt as d,
  Od as e,
  rCt as f,
  Yu as g,
  wkt as h,
  eIt as i,
  JDt as j,
  jIt as k,
  DCt as l,
  x9 as m,
  DZ as p,
  oIt as r,
  iIt as t
};
